webpackJsonp([8],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchTchScoreMap;
/* harmony export (immutable) */ __webpack_exports__["c"] = applyTchScoresToRows;
/* harmony export (immutable) */ __webpack_exports__["a"] = renderTchNameWithScore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



function fetchTchScoreMap(http, tchIds) {
  var ids = [];
  var seen = {};(tchIds || []).forEach(function (id) {
    if (id == null || id === '') {
      return;
    }
    var n = Number(id);
    if (!n || seen[n]) {
      return;
    }
    seen[n] = true;
    ids.push(n);
  });
  if (!ids.length) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
  }
  return http.post('/tch/score/batch', { tchIds: ids.join(',') }).then(function (res) {
    var map = {};
    if (!res || res.status !== 'ok' || !res.data) {
      return map;
    }
    ;(res.data || []).forEach(function (row) {
      if (!row || row.tchId == null || row.totalScore == null || row.totalScore === '') {
        return;
      }
      var num = Number(row.totalScore);
      if (isNaN(num)) {
        return;
      }
      map[row.tchId] = num;
      map[String(row.tchId)] = num;
    });
    return map;
  }).catch(function () {
    return {};
  });
}

function applyTchScoresToRows(vm, rows, idKey, scoreKey, map) {
  idKey = idKey || 'id';
  scoreKey = scoreKey || 'monthRankScore';
  map = map || {};
  if (!rows || !rows.length) {
    return;
  }
  rows.forEach(function (row) {
    var id = row[idKey];
    var score = map[id];
    if (score == null) {
      score = map[String(id)];
    }
    vm.$set(row, scoreKey, score == null ? null : score);
  });
}

function renderTchNameWithScore(h, options) {
  options = options || {};
  var text = options.text == null ? '' : options.text;
  var nameNode = options.onClick ? h('a', { on: { click: options.onClick } }, text) : h('span', text);
  var badgeText = null;
  if (options.score != null && options.score !== '') {
    var num = Number(options.score);
    if (!isNaN(num)) {
      badgeText = num.toFixed(2);
    }
  }
  if (badgeText == null) {
    return nameNode;
  }
  return h('span', {
    style: {
      display: 'inline-flex',
      alignItems: 'flex-start',
      whiteSpace: 'nowrap'
    }
  }, [nameNode, h('span', {
    style: {
      marginLeft: '4px',
      padding: '0 4px',
      borderRadius: '7px',
      background: '#ff9900',
      color: '#fff',
      fontSize: '10px',
      lineHeight: '14px'
    }
  }, badgeText)]);
}

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1153)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1813),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5961c210",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var _format = __webpack_require__(71);
var weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
var dates = {
  today: function today() {
    return _format(Date.now(), 'YYYY-MM-DD');
  },
  toWeek: function toWeek(week) {
    if (!week || week < 1 || week > 7) {
      return '';
    }
    return weeks[week - 1];
  },
  format: function format(date) {
    var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

    return _format(date, fmt);
  },
  formatUnix: function formatUnix(time) {
    var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

    if (!time) {
      return '';
    }
    return _format(time * 1000, fmt);
  },
  durationUnix: function durationUnix(duration) {
    if (!duration || duration < 0) {
      return '';
    }
    var day = Math.floor(duration / 60 / 60 / 24);
    var hour = Math.floor(duration / 60 / 60);
    var minute = Math.floor(duration / 60 % 60);
    var second = Math.floor(duration % 60);

    var human = '';
    if (day) {
      human += day + ' 天 ';
    }
    if (hour) {
      human += hour + ' 时 ';
    }
    if (minute) {
      human += minute + ' 分 ';
    }
    if (second) {
      human += second + ' 秒 ';
    }
    return human;
  }
};

module.exports = dates;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c474bea0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PROBATION_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PROBATION_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REVIEW_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REVIEW_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REVIEW_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONTRACT_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FOLLOWUP_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FOLLOWUP_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FOLLOWUP_RESULT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BIZ_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TODO_KIND; });
/* unused harmony export SEVERITY */
/* harmony export (immutable) */ __webpack_exports__["e"] = codeText;
/* harmony export (immutable) */ __webpack_exports__["f"] = codeColor;
/* harmony export (immutable) */ __webpack_exports__["d"] = tchLabel;
/* unused harmony export toDayString */
/* unused harmony export ADVISER_STORAGE_KEY */
/* unused harmony export readStoredAdviserId */
/* harmony export (immutable) */ __webpack_exports__["c"] = writeStoredAdviserId;
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveAdviserId;
/* harmony export (immutable) */ __webpack_exports__["u"] = badgesAdviserParam;
/* harmony export (immutable) */ __webpack_exports__["h"] = adviserParam;
/* harmony export (immutable) */ __webpack_exports__["j"] = downloadCsv;
/* harmony export (immutable) */ __webpack_exports__["r"] = daysText;
var API_PREFIX = '/tch/hr-workbench';

var PROBATION_LEVEL = {
  expired: { text: '已逾期', color: 'red' },
  urgent: { text: '即将到期', color: 'yellow' },
  near: { text: '临近到期', color: 'blue' },
  normal: { text: '试用期中', color: 'default' },
  done: { text: '已归档', color: 'green' },
  missing: { text: '入职日缺失', color: 'default' }
};

var PROBATION_RESULT = {
  CONVERTED: { text: '转正', color: 'green' },
  EXTENDED: { text: '延长试用', color: 'yellow' },
  TERMINATED: { text: '未通过', color: 'red' }
};

var REVIEW_LEVEL = {
  overdue: { text: '已逾期', color: 'red' },
  soon: { text: '即将到节点', color: 'yellow' },
  upcoming: { text: '未到节点', color: 'default' },
  done: { text: '已回访', color: 'green' }
};

var REVIEW_RESULT = {
  GOOD: { text: '良好稳定', color: 'green' },
  NORMAL: { text: '一般观察', color: 'blue' },
  CONCERN: { text: '有问题需支持', color: 'yellow' },
  RISK: { text: '高风险需干预', color: 'red' }
};

var REVIEW_CHANNELS = ['微信', '电话', '视频会议', '邮件'];

var CONTRACT_LEVEL = {
  expired: { text: '已超期', color: 'red' },
  expiring: { text: '即将到期', color: 'yellow' },
  normal: { text: '有效期内', color: 'green' },
  missing: { text: '未登记合同', color: 'default' }
};

var FOLLOWUP_TYPE = {
  ABSENT: { text: '旷课', color: 'red' },
  LOST: { text: '旷课·失联', color: 'red' },
  LEAVE: { text: '请假', color: 'yellow' },
  LATE: { text: '迟到', color: 'blue' }
};

var FOLLOWUP_RESULT = {
  NORMAL_CLASS: { text: '已正常上课', color: 'green' },
  CONTINUE: { text: '待继续跟进', color: 'yellow' },

  CONTACTED: { text: '已联系本人', color: 'blue' },
  CONFIRMED: { text: '已确认原因', color: 'blue' },
  MAKEUP: { text: '已安排补课', color: 'green' },
  WARNED: { text: '已警告提醒', color: 'yellow' },
  ESCALATED: { text: '已升级处理', color: 'red' },
  EXCUSED: { text: '免责（不可抗力）', color: 'green' }
};

var FOLLOWUP_RESULT_OPTIONS = {
  NORMAL_CLASS: FOLLOWUP_RESULT.NORMAL_CLASS,
  CONTINUE: FOLLOWUP_RESULT.CONTINUE
};

var BIZ_TYPE = {
  PROBATION: '试用期',
  REVIEW: '新外教回访',
  CONTRACT: '合同续签',
  FOLLOWUP: '出勤跟进'
};

var TODO_KIND = {
  PROBATION: { text: '试用期', button: '处理' },
  CONTRACT: { text: '合同', button: '续签' },
  FOLLOWUP: { text: '出勤跟进', button: '跟进' },
  REVIEW: { text: '新外教回访', button: '回访' },
  RISK: { text: '出勤风险', button: '监测' }
};

var SEVERITY = {
  danger: { text: '紧急', color: '#E6464E' },
  warning: { text: '关注', color: '#E89F2D' },
  info: { text: '预告', color: '#2d8cf0' }
};

function codeText(dict, code) {
  if (!code) {
    return '';
  }
  return dict[code] && dict[code].text || code;
}

function codeColor(dict, code) {
  return dict[code] && dict[code].color || 'default';
}

function tchLabel(row) {
  if (!row) {
    return '';
  }
  return row.tchName || (row.tchId == null ? '' : String(row.tchId));
}

function pad2(n) {
  return n < 10 ? '0' + n : '' + n;
}

function toDayString(v) {
  if (!v) {
    return '';
  }
  if (typeof v === 'string') {
    return v.length >= 10 ? v.slice(0, 10) : '';
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1) + '-' + pad2(v.getDate());
  }
  return '';
}

var ADVISER_STORAGE_KEY = 'hrWorkbench.studyAdviserId';

function readStoredAdviserId() {
  try {
    var v = window.localStorage.getItem(ADVISER_STORAGE_KEY);
    if (v == null || v === '' || v === 'all') {
      return 'all';
    }
    return String(v);
  } catch (e) {
    return 'all';
  }
}

function writeStoredAdviserId(adviserId) {
  try {
    if (adviserId === 'all' || adviserId === '' || adviserId == null) {
      window.localStorage.removeItem(ADVISER_STORAGE_KEY);
    } else {
      window.localStorage.setItem(ADVISER_STORAGE_KEY, String(adviserId));
    }
  } catch (e) {}
}

function resolveAdviserId(routeQuery) {
  var q = routeQuery || {};
  if (q.studyAdviserId != null && q.studyAdviserId !== '') {
    return String(q.studyAdviserId);
  }
  return readStoredAdviserId();
}

function badgesAdviserParam() {
  return adviserParam(readStoredAdviserId());
}

function adviserParam(adviserId) {
  if (adviserId === 'all' || adviserId === '' || adviserId == null) {
    return {};
  }
  return { studyAdviserId: Number(adviserId) };
}

function csvCell(v) {
  if (v == null) {
    return '';
  }
  var s = String(v);
  if (/[",\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

function downloadCsv(filename, headers, rows) {
  var lines = [headers].concat(rows || []).map(function (cols) {
    return (cols || []).map(csvCell).join(',');
  });
  var blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
  var link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

function daysText(daysLeft) {
  if (daysLeft == null) {
    return '—';
  }
  if (daysLeft < 0) {
    return '逾期 ' + Math.abs(daysLeft) + ' 天';
  }
  if (daysLeft === 0) {
    return '今天到期';
  }
  return '剩 ' + daysLeft + ' 天';
}

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37839aaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

var commonUtils = {
  getTraceTypeListByShortNum: function getTraceTypeListByShortNum(name) {
    var traceTypeList = [];
    if (name === 0) {
      traceTypeList.push(1);
    } else if (name === 1) {
      traceTypeList.push(11);
    } else if (name === 2) {
      traceTypeList.push(21);
      traceTypeList.push(22);
      traceTypeList.push(23);
      traceTypeList.push(24);
      traceTypeList.push(25);
    } else if (name === 3) {
      traceTypeList.push(31);
      traceTypeList.push(32);
    } else if (name === 4) {
      traceTypeList.push(41);
      traceTypeList.push(42);
      traceTypeList.push(43);
    } else if (name === 5) {
      traceTypeList.push(51);
      traceTypeList.push(52);
    } else if (name === 6) {
      traceTypeList.push(61);
      traceTypeList.push(62);
      traceTypeList.push(63);
      traceTypeList.push(64);
      traceTypeList.push(65);
      traceTypeList.push(66);
      traceTypeList.push(67);
      traceTypeList.push(68);
    } else if (name === 7) {
      traceTypeList.push(8);
      traceTypeList.push(71);
      traceTypeList.push(99);
    } else {
      traceTypeList.push(1);
    }

    return traceTypeList;
  },
  getShortNumByTraceType: function getShortNumByTraceType(traceType) {
    var shortNum;
    if (traceType === 8 || traceType === 99) {
      return 7;
    }
    if (traceType > 0 && traceType < 10) {
      shortNum = 0;
    } else if (traceType > 10 && traceType < 20) {
      shortNum = 1;
    } else if (traceType > 20 && traceType < 30) {
      shortNum = 2;
    } else if (traceType > 30 && traceType < 40) {
      shortNum = 3;
    } else if (traceType > 40 && traceType < 50) {
      shortNum = 4;
    } else if (traceType > 50 && traceType < 60) {
      shortNum = 5;
    } else if (traceType > 60 && traceType < 70) {
      shortNum = 6;
    } else if (traceType > 70) {
      shortNum = 7;
    } else {
      shortNum = 0;
    }

    return shortNum;
  },
  getUrlByTraceType: function getUrlByTraceType(data, traceType) {
    var obj = void 0;
    data.forEach(function (e) {
      if (e.code === traceType) {
        obj = e.url;
        return;
      }
    });
    return obj;
  },
  getTotalUrl: function getTotalUrl(url) {
    if (!url) {
      return '';
    }
    var totalImageUrl = url;
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      return url;
    } else {
      if (url.substr(0, 1) === '/') {
        totalImageUrl = 'http://medias.kouyujie.cn' + url;
      } else {
        totalImageUrl = 'http://medias.kouyujie.cn/' + url;
      }
      return totalImageUrl;
    }
  }
};

module.exports = commonUtils;

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1627),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAiAllowed;
/* harmony export (immutable) */ __webpack_exports__["a"] = bindAiAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aiApi__ = __webpack_require__(72);




var cached = null;
var inflight = null;

function fetchAiAllowed(http) {
  if (cached !== null) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cached);
  }
  if (inflight) {
    return inflight;
  }
  if (!http || typeof http.post !== 'function') {
    cached = false;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
  }
  inflight = http.post(__WEBPACK_IMPORTED_MODULE_1__aiApi__["a" /* AI_URI */].allowed, {}).then(function (res) {
    inflight = null;
    var allowed = false;
    if (res && res.status === 'ok' && res.data && res.data.allowed === true) {
      allowed = true;
    }
    cached = allowed;
    return cached;
  }).catch(function () {
    inflight = null;
    cached = false;
    return false;
  });
  return inflight;
}

function bindAiAllowed(vm) {
  fetchAiAllowed(vm.$http).then(function (allowed) {
    vm.aiAllowed = allowed;
    if (allowed) {
      vm.reload = new Date().getTime();
    }
  });
}

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1879),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1169)
  __webpack_require__(1170)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62fc72cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = questionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["a"] = skillLabel;
/* harmony export (immutable) */ __webpack_exports__["c"] = catReasonLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var BY_SKILL = {
  Listening: {
    'Multiple Choice': '听力选择题',
    'Fill in the Blanks': '听力填空'
  },
  Reading: {
    'Multiple Choice': '阅读选择',
    'Letter Match': '字母匹配',
    'Word-Picture Match': '图词匹配',
    'Sentence-Picture Match': '图句匹配',
    'True/False Judgment': '判断题',
    'Cloze': '完形填空',
    'Gap Fill': '选词填空',
    'Reading Comprehension': '阅读理解',
    'Multiple Choice - Reading Comprehension': '阅读理解选择',
    'Advanced Reading': '进阶阅读',
    'Information Matching': '信息匹配'
  },
  Writing: {
    'Drag Letters - Picture Spelling': '拖字母-看图拼写',
    'Drag Letters - Audio Spelling': '拖字母-听音拼写',
    'Drag Letters - Sentence Completion': '拖字母-补全句子',
    'Typing - Picture Spelling': '打字-看图拼写',
    'Typing - Audio Spelling': '打字-听音拼写',
    'Typing - Sentence Completion': '打字-补全句子',
    'Typing - Dialogue Completion': '打字-补全对话',
    'Sequence - Sentence Ordering': '句子排序',
    'Fill Passage - Word Form': '语篇填空-词形',
    'Fill in Blank - Word Form': '单空填空-词形',
    'Picture Writing - 3 to 4 Sentences': '看图写 3-4 句',
    'Picture Writing - Four Panel Story': '四格故事写作',
    'Practical Writing - Reply Letter': '应用文-回信',
    'Guided Writing - Email': '引导写作-邮件'
  },
  Speaking: {
    'Oral Letter Reading': '字母认读',
    'Letter Sound': '字母发音',
    'Picture Naming': '看图说词',
    'Word Blending': '单词拼读',
    'Simple Q&A': '简单问答',
    'Picture Q&A': '看图问答',
    'Picture Description': '看图描述',
    'Self Introduction': '自我介绍',
    '1-min Presentation': '一分钟陈述',
    'Discussion': '观点讨论',
    'Story Telling With Picture': '看图讲故事',
    'Topic Talk': '话题表达'
  }
};

var SHARED = {};
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(BY_SKILL).forEach(function (skill) {
  var map = BY_SKILL[skill];
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).forEach(function (code) {
    if (!SHARED[code]) SHARED[code] = map[code];
  });
});

function hasCjk(s) {
  return (/[\u4e00-\u9fff]/.test(s || '')
  );
}

function questionTypeLabel(code, skill) {
  var value = String(code || '').trim();
  if (!value) return '';
  if (hasCjk(value)) return value;
  var cn = BY_SKILL[skill] && BY_SKILL[skill][value] || SHARED[value];
  if (!cn) return value;
  return cn + ' ' + value;
}

function skillLabel(code) {
  if (code === 'Listening') return '听力 Listening';
  if (code === 'Speaking') return '口语 Speaking';
  if (code === 'Reading') return '阅读 Reading';
  if (code === 'Writing') return '写作 Writing';
  return code || '';
}

function catReasonLabel(code) {
  var v = String(code || '').trim();
  if (!v) return '';
  if (v === 'ANCHOR' || v.indexOf('ANCHOR') >= 0) return '锚题';
  if (v === 'SLOT') return '槽位';
  if (v === 'PRACTICE') return '练习';
  if (v === 'FIXED_FORM') return '固定卷';
  return v;
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RULE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DAY_OPTIONS; });
/* unused harmony export TYPE_META */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LEVEL_BADGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STATUS_BADGE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = typeLabel;
/* harmony export (immutable) */ __webpack_exports__["m"] = typeColor;
/* harmony export (immutable) */ __webpack_exports__["s"] = typeBadge;
/* harmony export (immutable) */ __webpack_exports__["n"] = isNum;
/* harmony export (immutable) */ __webpack_exports__["e"] = num;
/* harmony export (immutable) */ __webpack_exports__["d"] = fmtNum;
/* harmony export (immutable) */ __webpack_exports__["f"] = fmtRate;
/* harmony export (immutable) */ __webpack_exports__["p"] = fmtRateNum;
/* harmony export (immutable) */ __webpack_exports__["r"] = shortDate;
/* harmony export (immutable) */ __webpack_exports__["q"] = levelHigh;
/* harmony export (immutable) */ __webpack_exports__["g"] = levelLow;
/* harmony export (immutable) */ __webpack_exports__["u"] = levelVsPrev;
/* harmony export (immutable) */ __webpack_exports__["t"] = changeVsPrev;
/* harmony export (immutable) */ __webpack_exports__["k"] = sumCount;
/* unused harmony export cleanParams */
/* harmony export (immutable) */ __webpack_exports__["i"] = postImpact;
/* harmony export (immutable) */ __webpack_exports__["j"] = exportImpact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var API_PREFIX = '/tch/impact';

var RULE_VERSION = 'v1 · 2026-10-22';

var DATA_SOURCE = '欧美外教 · 常规外教课 · 实时计算';

var DAY_OPTIONS = [{ value: 7, label: '近 7 天' }, { value: 30, label: '近 30 天' }, { value: 90, label: '近 90 天' }];

var TYPE_META = {
  resign: { label: '离职', color: '#7C5CFF', badge: 'is-purple' },
  elim: { label: '淘汰', color: '#E6464E', badge: 'is-danger' },
  close: { label: '关闭时间', color: '#E89F2D', badge: 'is-warning' },
  tleave: { label: '3h内请假', color: '#FF8F3D', badge: 'is-warning' },
  leave: { label: '请假', color: '#5B8FF9', badge: 'is-info' },
  absent: { label: '旷课', color: '#B3312F', badge: 'is-danger' }
};

var LEVEL_BADGE = {
  '极高': 'is-deep',
  '高': 'is-danger',
  '中': 'is-warning',
  '低': 'is-gray'
};

var STATUS_BADGE = {
  '流失预警': 'is-danger',
  '待换老师': 'is-warning',
  '已换老师': 'is-healthy',
  '正常上课': 'is-info'
};

function typeLabel(type) {
  return TYPE_META[type] && TYPE_META[type].label || type || '—';
}

function typeColor(type) {
  return TYPE_META[type] && TYPE_META[type].color || '#A7AEBC';
}

function typeBadge(type) {
  return TYPE_META[type] && TYPE_META[type].badge || 'is-gray';
}

function isNum(v) {
  return v !== null && v !== undefined && v !== '' && !isNaN(Number(v));
}

function num(v) {
  return isNum(v) ? Number(v) : 0;
}

function fmtNum(v, digits) {
  if (!isNum(v)) {
    return '—';
  }
  var d = digits == null ? 1 : digits;
  return Number(v).toLocaleString('en-US', { maximumFractionDigits: d });
}

function fmtRate(v) {
  return isNum(v) ? Number(v).toFixed(1) + '%' : '—';
}

function fmtRateNum(v) {
  return isNum(v) ? Number(v).toFixed(1) : '—';
}

function shortDate(s) {
  return s && s.length >= 10 ? s.slice(5, 10) : s || '—';
}

function levelHigh(v, good, warn) {
  if (!isNum(v)) {
    return 'healthy';
  }
  var n = Number(v);
  if (n >= good) {
    return 'healthy';
  }
  return n >= warn ? 'warning' : 'danger';
}

function levelLow(v, warn, danger) {
  if (!isNum(v)) {
    return 'healthy';
  }
  var n = Number(v);
  if (n >= danger) {
    return 'danger';
  }
  return n >= warn ? 'warning' : 'healthy';
}

function levelVsPrev(cur, prev) {
  var c = num(cur);
  if (c <= 0) {
    return 'healthy';
  }
  if (!isNum(prev)) {
    return 'warning';
  }
  var p = Number(prev);
  if (c > p) {
    return 'danger';
  }
  return c === p ? 'warning' : 'healthy';
}

function changeVsPrev(cur, prev, unit) {
  if (!isNum(cur) || !isNum(prev)) {
    return { text: '', tone: 'neutral' };
  }
  var c = Number(cur);
  var p = Number(prev);
  var tail = ' 上期 ' + fmtNum(p) + (unit || '');
  if (p === 0) {
    return c > 0 ? { text: '新增' + tail, tone: 'danger' } : { text: '持平' + tail, tone: 'neutral' };
  }
  var pct = (c - p) / p * 100;
  if (pct === 0) {
    return { text: '持平' + tail, tone: 'neutral' };
  }
  return {
    text: (pct > 0 ? '↑ ' : '↓ ') + Math.abs(pct).toFixed(1) + '%' + tail,
    tone: pct > 0 ? 'danger' : 'healthy'
  };
}

function sumCount(list, key) {
  return (list || []).reduce(function (n, item) {
    return n + num(item[key || 'count']);
  }, 0);
}

function cleanParams(params) {
  var out = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params || {}).forEach(function (k) {
    var v = params[k];
    if (v !== null && v !== undefined && v !== '') {
      out[k] = v;
    }
  });
  return out;
}

function postImpact(vm, path, params) {
  var seqs = vm._impactSeq || (vm._impactSeq = {});
  var seq = (seqs[path] || 0) + 1;
  seqs[path] = seq;
  return vm.$http.post(API_PREFIX + path, cleanParams(params), { silent: true }).then(function (res) {
    if (res && res.status === 'ok') {
      return res.data || {};
    }
    if (seqs[path] === seq) {
      vm.$Message.error(res && res.msg || '加载失败');
    }
    return null;
  }).catch(function () {
    return null;
  }).then(function (data) {
    return seqs[path] === seq ? data : new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {});
  });
}

function decodeErrorMsg(buf) {
  try {
    var text = new TextDecoder('utf-8').decode(new Uint8Array(buf));
    var json = JSON.parse(text);
    return json.msg || '导出失败';
  } catch (e) {
    return '导出失败';
  }
}

function exportImpact(vm, params, fileName) {
  return vm.$http.post(API_PREFIX + '/export', cleanParams(params), {
    responseType: 'arraybuffer',
    silent: true
  }).then(function (res) {
    if (res && res.headers && res.data) {
      var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () {
        window.URL.revokeObjectURL(link.href);
      }, 1000);
      return true;
    }
    var msg = res instanceof ArrayBuffer ? decodeErrorMsg(res) : res && res.msg || '导出失败';
    vm.$Message.error(msg);
    return false;
  }).catch(function () {
    return false;
  });
}

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1956),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1773),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1961),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1872),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1678),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1711),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1727),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REVIEW_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OFFER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEMO_SCORE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEMO_SCORE_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NO_REFERRER; });
/* harmony export (immutable) */ __webpack_exports__["e"] = findStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = tchName;
/* harmony export (immutable) */ __webpack_exports__["l"] = parseJson;
/* harmony export (immutable) */ __webpack_exports__["i"] = emptyScores;
/* harmony export (immutable) */ __webpack_exports__["f"] = shortTime;
var STAGE_STATUS = [{ code: 'pending', text: '待安排', color: 'gray' }, { code: 'scheduled', text: '待确认', color: 'yellow' }, { code: 'confirmed', text: '已确认', color: 'blue' }, { code: 'completed', text: '已完成', color: 'primary' }, { code: 'passed', text: '已通过', color: 'green' }, { code: 'failed', text: '未通过', color: 'red' }];

var REVIEW_STATUS = [{ code: 'submit', text: '未提交', color: 'gray' }, { code: 'pending_review', text: '待复审', color: 'yellow' }, { code: 'approved', text: '审核通过', color: 'green' }, { code: 'rejected', text: '审核不通过', color: 'red' }];

var OFFER_STATUS = [{ code: 'pending', text: '待发Offer', color: 'gray' }, { code: 'sent', text: '已发Offer', color: 'blue' }, { code: 'accepted', text: '接受Offer', color: 'green' }, { code: 'rejected', text: '拒绝Offer', color: 'rose' }];

var GRADES = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C'];

var DEMO_SCORE_OPTIONS = [0, 1, 2, 3, 3.5, 4, 4.5, 5];

var DEMO_SCORE_CRITERIA = [{ key: 'appearance', label: '形象' }, { key: 'studentReaction', label: '对学生表现反应' }, { key: 'facialExpression', label: '面部表情' }, { key: 'voiceEnergy', label: '声音活力' }, { key: 'propsTpr', label: '教具/TPR' }, { key: 'classroomMgmt', label: '课堂管理' }, { key: 'interaction', label: '互动引导' }, { key: 'contentClarity', label: '教学内容清晰度' }, { key: 'timeControl', label: '时间把控' }];

var NO_REFERRER = '__none__';

function findStatus(list, code, defaultCode) {
  var key = code || defaultCode;
  for (var i = 0; i < list.length; i++) {
    if (list[i].code === key) {
      return list[i];
    }
  }
  return { code: key, text: key || '', color: 'gray' };
}

function tchName(row) {
  if (!row) {
    return '';
  }
  if (row.fullName) {
    return row.fullName;
  }
  return ((row.firstName || '') + ' ' + (row.lastName || '')).trim();
}

function parseJson(val, fallback) {
  if (val === null || val === undefined || val === '') {
    return fallback;
  }
  if (typeof val !== 'string') {
    return val;
  }
  try {
    var parsed = JSON.parse(val);
    return parsed === null ? fallback : parsed;
  } catch (e) {
    return fallback;
  }
}

function emptyScores() {
  var scores = {};
  DEMO_SCORE_CRITERIA.forEach(function (c) {
    scores[c.key] = 0;
  });
  return scores;
}

function shortTime(val) {
  if (!val) {
    return '';
  }
  return String(val).substring(0, 16);
}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderSimpleMarkdown;


function escapeHtml(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function inlineFormat(escapedLine) {
  var s = escapedLine;
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/\[ \]/g, '☐ ');
  s = s.replace(/\[x\]/gi, '☑ ');
  return s;
}

function isTableSep(line) {
  return (/^\|?[\s:-]+\|[\s|:-]*$/.test(line)
  );
}

function parseTableRow(line) {
  var raw = line.trim();
  if (raw.charAt(0) === '|') raw = raw.slice(1);
  if (raw.charAt(raw.length - 1) === '|') raw = raw.slice(0, -1);
  return raw.split('|').map(function (c) {
    return inlineFormat(escapeHtml(c.trim()));
  });
}

function renderSimpleMarkdown(md) {
  if (md == null || md === '') {
    return '';
  }
  var lines = String(md).replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
  var html = [];
  var i = 0;
  var inUl = false;
  var inOl = false;

  function closeLists() {
    if (inUl) {
      html.push('</ul>');
      inUl = false;
    }
    if (inOl) {
      html.push('</ol>');
      inOl = false;
    }
  }

  while (i < lines.length) {
    var line = lines[i];
    var trimmed = line.trim();

    if (trimmed.indexOf('|') >= 0 && i + 1 < lines.length && isTableSep(lines[i + 1].trim())) {
      closeLists();
      var header = parseTableRow(trimmed);
      html.push('<table class="md-table"><thead><tr>');
      header.forEach(function (c) {
        html.push('<th>' + c + '</th>');
      });
      html.push('</tr></thead><tbody>');
      i += 2;
      while (i < lines.length && lines[i].trim().indexOf('|') >= 0 && !isTableSep(lines[i].trim())) {
        var cells = parseTableRow(lines[i].trim());
        html.push('<tr>');
        cells.forEach(function (c) {
          html.push('<td>' + c + '</td>');
        });
        html.push('</tr>');
        i++;
      }
      html.push('</tbody></table>');
      continue;
    }

    if (/^###\s+/.test(trimmed)) {
      closeLists();
      html.push('<h4>' + inlineFormat(escapeHtml(trimmed.replace(/^###\s+/, ''))) + '</h4>');
      i++;
      continue;
    }
    if (/^##\s+/.test(trimmed)) {
      closeLists();
      html.push('<h3>' + inlineFormat(escapeHtml(trimmed.replace(/^##\s+/, ''))) + '</h3>');
      i++;
      continue;
    }
    if (/^#\s+/.test(trimmed)) {
      closeLists();
      html.push('<h2>' + inlineFormat(escapeHtml(trimmed.replace(/^#\s+/, ''))) + '</h2>');
      i++;
      continue;
    }
    if (/^>\s?/.test(trimmed)) {
      closeLists();
      html.push('<blockquote>' + inlineFormat(escapeHtml(trimmed.replace(/^>\s?/, ''))) + '</blockquote>');
      i++;
      continue;
    }
    if (/^[-*]\s+/.test(trimmed)) {
      if (inOl) {
        html.push('</ol>');
        inOl = false;
      }
      if (!inUl) {
        html.push('<ul>');
        inUl = true;
      }
      html.push('<li>' + inlineFormat(escapeHtml(trimmed.replace(/^[-*]\s+/, ''))) + '</li>');
      i++;
      continue;
    }
    if (/^\d+\.\s+/.test(trimmed)) {
      if (inUl) {
        html.push('</ul>');
        inUl = false;
      }
      if (!inOl) {
        html.push('<ol>');
        inOl = true;
      }
      html.push('<li>' + inlineFormat(escapeHtml(trimmed.replace(/^\d+\.\s+/, ''))) + '</li>');
      i++;
      continue;
    }
    if (trimmed === '') {
      closeLists();
      html.push('<br/>');
      i++;
      continue;
    }
    closeLists();
    html.push('<p>' + inlineFormat(escapeHtml(trimmed)) + '</p>');
    i++;
  }
  closeLists();
  return html.join('');
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  renderSimpleMarkdown: renderSimpleMarkdown
});

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea629156",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1889),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1907),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1644),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'));
  }
  if (typeof date === 'number') {
    date = new Date(date);
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  var week = {
    '0': '\u65E5',
    '1': '\u4E00',
    '2': '\u4E8C',
    '3': '\u4E09',
    '4': '\u56DB',
    '5': '\u4E94',
    '6': '\u516D'
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '\u661F\u671F' : '\u5468' : '') + week[date.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AI_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RISK_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TCH_RISK_URI; });
/* unused harmony export FORBIDDEN_AI_BODY_KEYS */
/* unused harmony export SENSITIVE_FACT_KEYS */
/* harmony export (immutable) */ __webpack_exports__["e"] = newClientRequestId;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildPrepareBody;
/* harmony export (immutable) */ __webpack_exports__["g"] = tchRiskLevelText;
/* harmony export (immutable) */ __webpack_exports__["h"] = tchRiskLevelColor;
/* harmony export (immutable) */ __webpack_exports__["j"] = normalizeTchRiskList;
/* harmony export (immutable) */ __webpack_exports__["f"] = buildGenerateBody;
/* harmony export (immutable) */ __webpack_exports__["d"] = stripForbiddenAiBody;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSensitiveFactKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);




var AI_URI = {
  allowed: '/ai/allowed',
  prepare: '/ai/prepare',
  generate: '/ai/generate',
  runDetail: '/ai/runDetail',
  approve: '/ai/approve',
  execute: '/ai/execute',
  feedback: '/ai/feedback',
  runList: '/ai/runList'
};

var RISK_URI = {
  list: '/studentRisk/list',
  followup: '/studentRisk/followup'
};

var TCH_RISK_URI = {
  latestBatch: '/tchRisk/latestBatch'
};

var FORBIDDEN_AI_BODY_KEYS = ['adminId', 'ownerId', 'recordUrl', 'calleeId', 'callerId', 'mobile', 'wechatAccount', 'payAmount'];

var SENSITIVE_FACT_KEYS = ['mobile', 'remarkMobile', 'wechatAccount', 'wechatId', 'wechatUnionId', 'wechatOpenId', 'wechat', 'idcard', 'idCard', 'payAmount', 'hasPayAmount', 'recordUrl', 'calleeId', 'callerId', 'password', 'salt', 'birthday'];

function newClientRequestId() {
  return 'c' + Date.now() + '-' + Math.random().toString(16).slice(2);
}

function buildPrepareBody(_ref) {
  var taskType = _ref.taskType,
      uid = _ref.uid,
      pageRoute = _ref.pageRoute,
      excludeFactKeys = _ref.excludeFactKeys,
      subjectType = _ref.subjectType;

  return {
    taskType: taskType,
    subjectType: subjectType || 'STUDENT',
    subjectId: uid,
    pageRoute: pageRoute,
    excludeFactKeys: excludeFactKeys || []
  };
}

function tchRiskLevelText(level) {
  if (level === null || level === undefined || level === '') {
    return '';
  }
  var n = Number(level);
  if (n === 2) {
    return '高';
  }
  if (n === 1) {
    return '中';
  }
  if (n === 0) {
    return '低';
  }
  return '';
}

function tchRiskLevelColor(level) {
  if (level === null || level === undefined || level === '') {
    return '';
  }
  var n = Number(level);
  if (n === 2) {
    return '#ed4014';
  }
  if (n === 1) {
    return '#ff9900';
  }
  if (n === 0) {
    return '#80848f';
  }
  return '';
}

function normalizeTchRiskList(data) {
  if (!data) {
    return [];
  }
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data.data)) {
    return data.data;
  }
  if (Array.isArray(data.list)) {
    return data.list;
  }
  return [];
}

function buildGenerateBody(prepareLike, clientRequestId) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, prepareLike, { clientRequestId: clientRequestId });
}

function stripForbiddenAiBody(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') {
    return body;
  }
  var out = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body).forEach(function (key) {
    if (FORBIDDEN_AI_BODY_KEYS.indexOf(key) === -1) {
      out[key] = body[key];
    }
  });
  return out;
}

function isSensitiveFactKey(key) {
  if (!key) {
    return false;
  }
  var lower = String(key).toLowerCase();
  return SENSITIVE_FACT_KEYS.some(function (item) {
    return item.toLowerCase() === lower;
  });
}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1950),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1891),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ff961f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1656),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1094)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1724),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1188)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1864),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1783),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b230615",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1172)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1839),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63cc1742",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1812),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59518f3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1761),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41277a4b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08b1d9b9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1815),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1802),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assetFolder */
/* harmony export (immutable) */ __webpack_exports__["a"] = assetUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = assetKind;
function assetFolder(skill) {
  var s = String(skill || '').trim().toLowerCase();
  if (s === 'speaking' || s === 'speak' || s === '口语') return 'speaking';
  if (s === 'reading' || s === '阅读') return 'reading';
  if (s === 'writing' || s === '写作') return 'writing';
  if (s === 'listening' || s === '听力' || s === 'comp') return 'listening';
  return s || 'listening';
}

function assetUrl(path, skill) {
  var raw = String(path || '').trim();
  if (!raw || raw.toLowerCase() === 'none') return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  var file = raw.replace(/\\/g, '/').split('/').pop();
  if (!file) return '';
  return 'https://file.kouyujie.cn/' + assetFolder(skill) + '/' + file;
}

function assetKind(url) {
  var file = String(url || '').split('?')[0].toLowerCase();
  if (/\.(png|jpe?g|gif|webp|bmp|svg)$/.test(file)) return 'image';
  if (/\.(mp3|wav|m4a|aac|ogg|flac)$/.test(file)) return 'audio';
  if (/\.(mp4|mov|webm|m4v)$/.test(file)) return 'video';
  return '';
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sourceText;
/* harmony export (immutable) */ __webpack_exports__["f"] = onboardingStatusText;
/* harmony export (immutable) */ __webpack_exports__["e"] = regularizationStatusText;
/* harmony export (immutable) */ __webpack_exports__["d"] = transferStatusText;
/* harmony export (immutable) */ __webpack_exports__["a"] = resignationStatusText;
/* harmony export (immutable) */ __webpack_exports__["c"] = processTypeText;

function sourceText(code) {
  if (code === 'LOCAL') return '本地';
  if (code === 'DING') return '钉钉';
  return code || '—';
}

function onboardingStatusText(code) {
  if (code === 'PENDING' || code === 'WAIT') return '待入职';
  if (code === 'DONE') return '已入职';
  if (code === 'CANCEL') return '已取消';
  return code || '—';
}

function regularizationStatusText(code) {
  if (code === 'DRAFT') return '草稿';
  if (code === 'OPEN') return '待转正';
  if (code === 'DONE') return '已办';
  if (code === 'CANCEL') return '已取消';
  return code || '—';
}

function transferStatusText(code) {
  if (code === 'DRAFT') return '草稿';
  if (code === 'OPEN') return '办理中';
  if (code === 'DONE') return '已办结';
  if (code === 'CANCEL') return '已取消';
  return code || '—';
}

function resignationStatusText(code) {
  if (code === 'DRAFT') return '草稿';
  if (code === 'OPEN') return '办理中';
  if (code === 'DONE') return '已离职';
  if (code === 'CANCEL') return '已取消';
  return code || '—';
}

function processTypeText(code) {
  if (code === 'REGULAR') return '转正';
  if (code === 'TRANSFER') return '调岗';
  if (code === 'RESIGN') return '离职';
  return code || '—';
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSlots;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



var weekZh = ['周日', '周一', '周二', '周三', '周四', '周五', '周六', '周日'];

function hasTimeOverlap(s1, e1, s2, e2) {
  return s1 < e2 && e1 > s2;
}

function getWeekFromTimestamp(ts) {
  var date = new Date(ts * 1000);
  var day = date.getDay();
  return day === 0 ? 7 : day;
}

function isSameDay(slot1, slot2) {
  if (slot1.week != null && slot2.week != null) {
    return slot1.week === slot2.week;
  }
  if (slot1.day != null && slot2.day != null) {
    return slot1.day === slot2.day;
  }
  if (slot1.week != null && slot2.day != null) {
    return slot1.week === getWeekFromTimestamp(slot2.day);
  }
  if (slot1.day != null && slot2.week != null) {
    return getWeekFromTimestamp(slot1.day) === slot2.week;
  }
  return false;
}

function formatSlot(slot) {
  var dayLabel = slot.weekStr || slot.dayStr || (slot.week != null ? weekZh[slot.week] : '');
  var start = slot.startTimeStr || '';
  var end = slot.endTimeStr || '';
  return dayLabel + ' ' + start + '-' + end;
}

function validateSlots(newSlots, existingOpened, existingShortTerm, existingRandom) {
  var errors = [];

  if (!newSlots || newSlots.length === 0) {
    return { valid: true, errors: [] };
  }

  for (var i = 0; i < newSlots.length; i++) {
    for (var j = i + 1; j < newSlots.length; j++) {
      if (isSameDay(newSlots[i], newSlots[j]) && hasTimeOverlap(newSlots[i].startTime, newSlots[i].endTime, newSlots[j].startTime, newSlots[j].endTime)) {
        errors.push('新增时间内部重叠: ' + formatSlot(newSlots[i]) + ' 与 ' + formatSlot(newSlots[j]));
      }
    }
  }

  checkAgainstExisting(newSlots, existingOpened, '买断时间', errors);

  checkAgainstExisting(newSlots, existingShortTerm, '短期固定时间', errors);

  checkAgainstExisting(newSlots, existingRandom, '上课时间', errors);

  return {
    valid: errors.length === 0,
    errors: errors
  };
}

function checkAgainstExisting(newSlots, existingSlots, typeName, errors) {
  if (!existingSlots || existingSlots.length === 0) return;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(newSlots), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var newSlot = _step.value;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(existingSlots), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var existing = _step2.value;

          if (isSameDay(newSlot, existing) && hasTimeOverlap(newSlot.startTime, newSlot.endTime, existing.startTime, existing.endTime)) {
            errors.push('\u4E0E' + typeName + '\u51B2\u7A81: ' + formatSlot(existing));
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1133)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1788),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ebd3bbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1817),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1111)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1749),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bbb700b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1645),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1792),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5031df50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1167)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1834),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61d51cf2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1880),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1799),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1095)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1725),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1173)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1841),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1632),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1892),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchLoading: false,
      tableLoading: false,
      saveLoading: false,
      showModal: false,
      showChannelModal: false,
      showChannelEdit: false,
      channelLoading: false,
      channelSaving: false,
      totalCount: 0,
      enabledChannels: [],
      allChannels: [],
      queryParam: {
        period: '',
        personName: '',
        pageIndex: 1,
        pageSize: 200
      },
      formData: {
        id: null,
        period: '',
        personName: '',
        channelValues: {}
      },
      channelForm: {
        id: null,
        displayName: '',
        channelKey: '',
        sort: null
      },
      dataList: [],
      baseColumns: []
    };
  },

  computed: {
    columns: function columns() {
      var self = this;
      var cols = [{ title: '周期', key: 'period', minWidth: 120 }, { title: '姓名', key: 'personName', minWidth: 100 }];
      var channels = this.enabledChannels || [];
      if (!channels.length) {
        cols.push({
          title: '渠道',
          minWidth: 160,
          render: function render(h) {
            return h('span', { style: { color: '#999' } }, '请先在渠道管理中添加渠道');
          }
        });
      } else {
        channels.forEach(function (ch) {
          var key = ch.channelKey;
          cols.push({
            title: ch.displayName,
            key: key,
            width: 90,
            render: function render(h, params) {
              var map = self.parseValues(params.row);
              var v = map[key];
              return h('span', v == null || v === '' ? '' : v);
            }
          });
        });
      }
      cols.push({ title: '总计', key: 'total', width: 80 });
      cols.push({
        title: '操作人',
        minWidth: 100,
        render: function render(h, params) {
          if (params.row._isSum) return h('span', '');
          return h('span', params.row.modifierName || params.row.creatorName || '');
        }
      });
      cols.push({
        title: '操作时间',
        minWidth: 160,
        render: function render(h, params) {
          if (params.row._isSum) return h('span', '');
          return h('span', params.row.gmtModified || params.row.gmtCreate || '');
        }
      });
      cols.push({
        title: '操作',
        width: 140,
        fixed: 'right',
        render: function render(h, params) {
          if (params.row._isSum) return h('span', '');
          return h('div', [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                self.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { type: 'error', size: 'small' },
            on: { click: function click() {
                self.remove(params.row);
              } }
          }, '删除')]);
        }
      });
      return cols;
    },
    channelColumns: function channelColumns() {
      var self = this;
      return [{ title: '展示名', key: 'displayName', minWidth: 120 }, {
        title: '标识',
        key: 'channelKey',
        minWidth: 120,
        render: function render(h, params) {
          return h('span', { style: { color: '#888', fontSize: '12px' } }, params.row.channelKey);
        }
      }, { title: '排序', key: 'sort', width: 80 }, {
        title: '状态',
        width: 90,
        render: function render(h, params) {
          var on = params.row.status === 1;
          return h('Tag', { props: { color: on ? 'green' : 'default' } }, on ? '启用' : '禁用');
        }
      }, {
        title: '操作',
        width: 200,
        render: function render(h, params) {
          var on = params.row.status === 1;
          var btns = [h('Button', {
            props: { type: 'text', size: 'small' },
            on: { click: function click() {
                self.openRename(params.row);
              } }
          }, '改名')];
          btns.push(h('Button', {
            props: { type: 'text', size: 'small' },
            on: {
              click: function click() {
                self.toggleStatus(params.row, on ? 0 : 1);
              }
            }
          }, on ? '禁用' : '启用'));
          btns.push(h('Button', {
            props: { type: 'text', size: 'small' },
            style: { color: '#ed4014' },
            on: { click: function click() {
                self.deleteChannel(params.row);
              } }
          }, '删除'));
          return h('div', btns);
        }
      }];
    },
    tableDataWithSum: function tableDataWithSum() {
      var _this = this;

      var list = this.dataList || [];
      if (!list.length) return list;
      var sumRow = { _isSum: true, period: '总计', personName: '', _values: {} };
      var totalSum = 0;
      var totalHas = false;(this.enabledChannels || []).forEach(function (ch) {
        var s = 0;
        var has = false;
        list.forEach(function (r) {
          var map = _this.parseValues(r);
          var v = map[ch.channelKey];
          if (v != null && v !== '') {
            s += Number(v) || 0;
            has = true;
          }
        });
        sumRow[ch.channelKey] = has ? s : '';
        sumRow._values[ch.channelKey] = has ? s : null;
      });
      list.forEach(function (r) {
        if (r.total != null && r.total !== '') {
          totalSum += Number(r.total) || 0;
          totalHas = true;
        }
      });
      sumRow.total = totalHas ? totalSum : '';
      return list.concat([sumRow]);
    }
  },
  created: function created() {
    this.reloadChannelsAndList();
  },

  methods: {
    parseValues: function parseValues(row) {
      if (!row) return {};
      if (row._values) return row._values;
      if (row.channelValues && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(row.channelValues) === 'object') {
        return row.channelValues;
      }
      if (typeof row.channelValues === 'string' && row.channelValues) {
        try {
          return JSON.parse(row.channelValues) || {};
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    reloadChannelsAndList: function reloadChannelsAndList() {
      var self = this;
      this.loadEnabledChannels().then(function () {
        self.search();
      });
    },
    loadEnabledChannels: function loadEnabledChannels() {
      var self = this;
      return this.$http.post('/marketMetricChannel/listEnabled', { bizType: this.bizType }).then(function (res) {
        if (res && res.status === 'ok') {
          self.enabledChannels = res.data || [];
        } else {
          self.enabledChannels = [];
        }
      }).catch(function () {
        self.enabledChannels = [];
      });
    },
    loadAllChannels: function loadAllChannels() {
      var self = this;
      this.channelLoading = true;
      return this.$http.post('/marketMetricChannel/list', { bizType: this.bizType }).then(function (res) {
        self.channelLoading = false;
        if (res && res.status === 'ok') {
          self.allChannels = res.data || [];
        }
      }).catch(function () {
        self.channelLoading = false;
      });
    },
    search: function search() {
      this.searchLoading = true;
      this.tableLoading = true;
      this.queryParam.pageIndex = 1;
      this.loadList();
    },
    loadList: function loadList() {
      var self = this;
      this.$http.post(this.listUrl, self.queryParam).then(function (res) {
        self.searchLoading = false;
        self.tableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
        }
      }).catch(function () {
        self.searchLoading = false;
        self.tableLoading = false;
      });
    },
    onPageChange: function onPageChange(page) {
      this.queryParam.pageIndex = page;
      this.tableLoading = true;
      this.loadList();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.queryParam.pageSize = size;
      this.queryParam.pageIndex = 1;
      this.tableLoading = true;
      this.loadList();
    },
    emptyChannelValues: function emptyChannelValues() {
      var map = {};(this.enabledChannels || []).forEach(function (ch) {
        map[ch.channelKey] = null;
      });
      return map;
    },
    openAdd: function openAdd() {
      if (!(this.enabledChannels || []).length) {
        this.$Message.warning('请先在渠道管理中添加渠道');
        return;
      }
      this.formData = {
        id: null,
        period: '',
        personName: '',
        channelValues: this.emptyChannelValues()
      };
      this.showModal = true;
    },
    openEdit: function openEdit(row) {
      var values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.emptyChannelValues(), this.parseValues(row));
      this.formData = {
        id: row.id,
        period: row.period,
        personName: row.personName,
        channelValues: values
      };
      this.showModal = true;
    },
    save: function save() {
      var self = this;
      if (!self.formData.period || !self.formData.personName) {
        self.$Message.warning('周期和姓名不能为空');
        return;
      }
      var payload = {
        id: self.formData.id,
        period: self.formData.period,
        personName: self.formData.personName,
        channelValues: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData.channelValues || {})
      };
      self.saveLoading = true;
      var url = self.formData.id ? self.updateUrl : self.insertUrl;
      this.$http.post(url, payload).then(function (res) {
        self.saveLoading = false;
        if (res && res.status === 'ok') {
          self.showModal = false;
          self.$Message.success('保存成功');
          self.loadList();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    remove: function remove(row) {
      var self = this;
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除「' + row.personName + '」在「' + row.period + '」的记录？',
        onOk: function onOk() {
          return self.$http.post(self.deleteUrl, { id: row.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已删除');
              self.loadList();
            }
          });
        }
      });
    },
    openChannelManage: function openChannelManage() {
      this.showChannelModal = true;
      this.loadAllChannels();
    },
    onChannelModalClose: function onChannelModalClose() {
      var self = this;
      this.loadEnabledChannels().then(function () {
        self.loadList();
      });
    },
    openAddChannel: function openAddChannel() {
      this.channelForm = { id: null, displayName: '', channelKey: '', sort: null };
      this.showChannelEdit = true;
    },
    openRename: function openRename(row) {
      this.channelForm = {
        id: row.id,
        displayName: row.displayName,
        channelKey: row.channelKey,
        sort: row.sort
      };
      this.showChannelEdit = true;
    },
    saveChannel: function saveChannel() {
      var self = this;
      if (!self.channelForm.displayName) {
        self.$Message.warning('展示名不能为空');
        return;
      }
      self.channelSaving = true;
      var isEdit = !!self.channelForm.id;
      var url = isEdit ? '/marketMetricChannel/update' : '/marketMetricChannel/insert';
      var payload = isEdit ? { id: self.channelForm.id, displayName: self.channelForm.displayName, sort: self.channelForm.sort } : {
        bizType: self.bizType,
        displayName: self.channelForm.displayName,
        channelKey: self.channelForm.channelKey || '',
        sort: self.channelForm.sort
      };
      this.$http.post(url, payload).then(function (res) {
        self.channelSaving = false;
        if (res && res.status === 'ok') {
          self.showChannelEdit = false;
          self.$Message.success('保存成功');
          self.loadAllChannels();
        }
      }).catch(function () {
        self.channelSaving = false;
      });
    },
    toggleStatus: function toggleStatus(row, status) {
      var self = this;
      var tip = status === 0 ? '禁用后，新录入不再显示该渠道列；历史数据保留。确定禁用？' : '确定启用该渠道？';
      this.$Modal.confirm({
        title: status === 0 ? '确认禁用' : '确认启用',
        content: tip,
        onOk: function onOk() {
          return self.$http.post('/marketMetricChannel/setStatus', { id: row.id, status: status }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success(status === 0 ? '已禁用' : '已启用');
              self.loadAllChannels();
            }
          });
        }
      });
    },
    deleteChannel: function deleteChannel(row) {
      var self = this;
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除该渠道？仅在无任何录入数据时可删。',
        onOk: function onOk() {
          return self.$http.post('/marketMetricChannel/delete', { id: row.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已删除');
              self.loadAllChannels();
            } else if (res && res.msg) {
              self.$Message.warning(res.msg);
            }
          }).catch(function (err) {
            var msg = err && err.msg || err && err.message || '该渠道已有录入数据，请改用禁用';
            self.$Message.warning(msg);
          });
        }
      });
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KB_ASK_PERMISSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KB_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KB_FAB_POS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KB_WIN_GEOM_KEY; });

var KB_ASK_PERMISSION = '/kb/ask';

var KB_URI = {
  askAllowed: '/kb/askAllowed',
  ask: '/kb/ask',
  baseList: '/kb/base/list',
  baseSave: '/kb/base/save',
  baseSync: '/kb/base/sync',
  browse: '/kb/browse',
  upload: '/kb/upload',
  groupBinds: '/kb/group/binds',
  groupBind: '/kb/group/bind',
  providerStatus: '/kb/provider/status',
  providerBases: '/kb/provider/bases'
};

var KB_FAB_POS_KEY = 'kb_assistant_fab_pos';

var KB_WIN_GEOM_KEY = 'kb_assistant_win_geom';

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3503d28e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1127)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1778),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39031e1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-179333b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0116a3ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1634),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1852),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a03f8c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1955),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1743),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1626),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1755),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1919),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1119)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1124)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1821),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1897),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1888),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1736),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1639),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1855),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1914),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1954),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('drag-modal', function (el, bindings, vnode) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick().then(function () {
    var componentInstance = vnode.componentInstance;

    var _ref = componentInstance || {},
        visible = _ref.visible,
        destroyOnClose = _ref.destroyOnClose;

    if (!visible) return;

    var modal = el.getElementsByClassName('ivu-modal-content')[0];
    var header = el.getElementsByClassName('ivu-modal-header')[0];

    if (!header || !modal) return;

    header.style.cursor = 'move';
    var left = 0;
    var top = 0;

    if (!destroyOnClose) {
      left = modal.left || 0;
      top = modal.top || 0;
    }

    if (typeof modal.left !== 'number') {
      top = top || modal.offsetTop;
    }

    header.onmousedown = function (e) {
      var startX = e.clientX;
      var startY = e.clientY;

      el.onmousemove = function (event) {
        var endX = event.clientX;
        var endY = event.clientY;

        modal.left = endX - startX + left;
        modal.top = endY - startY + top;

        modal.style.left = modal.left + 'px';
        modal.style.top = modal.top + 'px';
      };

      el.onmouseup = function () {
        left = modal.left;
        top = modal.top;

        el.onmousemove = null;
        el.onmouseup = null;

        if (header.releaseCapture) {
          header.releaseCapture();
        }
      };

      if (header.setCapture) {
        header.setCapture();
      }
    };
  });
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  name: 'eventBus'
}));

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isImageUrl */
/* unused harmony export isOfficeUrl */
/* unused harmony export parseTrackContentAttach */
/* harmony export (immutable) */ __webpack_exports__["a"] = renderTrackContentAttach;


var IMG_RE = /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i;
var OFFICE_RE = /\.(doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)(\?|$)/i;
var URL_RE = /https?:\/\/\S+/g;

var THUMB_STYLE = {
  width: '48px',
  height: '48px',
  objectFit: 'cover',
  marginRight: '4px',
  marginBottom: '4px',
  borderRadius: '3px',
  cursor: 'pointer',
  verticalAlign: 'middle'
};

function isImageUrl(url) {
  return IMG_RE.test(url || '');
}

function isOfficeUrl(url) {
  return OFFICE_RE.test(url || '');
}

function parseTrackContentAttach(content) {
  var text = content == null ? '' : String(content);
  if (!text) {
    return { prefix: '', items: [], plain: '' };
  }
  var urls = text.match(URL_RE);
  if (!urls || !urls.length) {
    return { prefix: '', items: [], plain: text };
  }

  if (text.indexOf('【附件】') === 0) {
    var body = text.slice('【附件】'.length);
    var parts = body.split(/[；;]/).map(function (s) {
      return s.trim();
    }).filter(Boolean);
    var items = [];
    parts.forEach(function (part) {
      var m = part.match(/^(.*?)\s+(https?:\/\/\S+)\s*$/);
      if (m) {
        items.push({ name: (m[1] || '').trim() || '未命名', url: m[2] });
      } else {
        var u = part.match(URL_RE);
        if (u && u[0]) {
          items.push({ name: part.replace(u[0], '').trim() || '未命名', url: u[0] });
        }
      }
    });
    if (items.length) {
      return { prefix: '【附件】', items: items, plain: null };
    }
  }

  var items2 = [];
  var last = 0;
  var re = /https?:\/\/\S+/g;
  var match;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      items2.push({ type: 'text', text: text.slice(last, match.index) });
    }
    items2.push({ type: 'url', name: '', url: match[0] });
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    items2.push({ type: 'text', text: text.slice(last) });
  }
  return { prefix: '', items: items2, plain: null, mixed: true };
}

function renderTrackContentAttach(h, content, onViewImages) {
  var parsed = parseTrackContentAttach(content);
  if (parsed.plain != null) {
    return h('span', parsed.plain);
  }

  var nodes = [];
  var imageUrls = [];

  function collectImages(list) {
    list.forEach(function (it) {
      var url = it.url;
      if (url && isImageUrl(url)) {
        imageUrls.push(url);
      }
    });
  }

  if (parsed.mixed) {
    collectImages(parsed.items.filter(function (it) {
      return it.type === 'url';
    }));
  } else {
    collectImages(parsed.items);
  }

  if (parsed.prefix) {
    nodes.push(h('span', { style: { marginRight: '6px', verticalAlign: 'middle' } }, parsed.prefix));
  }

  function pushUrlNode(name, url) {
    if (isImageUrl(url)) {
      var imgIndex = imageUrls.indexOf(url);
      nodes.push(h('img', {
        attrs: { src: url, alt: name || '' },
        style: THUMB_STYLE,
        on: {
          click: function click() {
            if (typeof onViewImages === 'function') {
              onViewImages(imageUrls, imgIndex < 0 ? 0 : imgIndex);
            }
          }
        }
      }));
    } else if (isOfficeUrl(url)) {
      nodes.push(h('a', {
        style: { display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' },
        attrs: {
          href: 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url),
          target: '_blank'
        }
      }, name || '预览'));
    } else {
      nodes.push(h('a', {
        style: { display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' },
        attrs: { href: url, target: '_blank' }
      }, name || '打开'));
    }
  }

  if (parsed.mixed) {
    parsed.items.forEach(function (it) {
      if (it.type === 'text') {
        if (it.text) {
          nodes.push(h('span', it.text));
        }
      } else {
        pushUrlNode(it.name, it.url);
      }
    });
  } else {
    parsed.items.forEach(function (it) {
      pushUrlNode(it.name, it.url);
    });
  }

  return h('div', { style: { lineHeight: '1.4' } }, nodes);
}

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1824),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1751),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cb472ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1806),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-568d4f1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1948),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1861),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1882),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79f8d22a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1764),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1808),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1893),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1913),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1620),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1801),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1025)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00612eb7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1846),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1868),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db761d34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1904),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1887),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e428086",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1842),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1903),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1692),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1117)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1758),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40d4e45a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1965),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var AppConfig = {
  install: function install(Vue, options) {
    Vue.prototype.$appConfig = AppConfig;
  },

  noneImg: '/assets/img/none.jpg',
  baseUrl: "https://backend-bops.kouyujie.cn" || 'http://localhost:7070',
  active: "prod" || 'test',
  isQuqukid: function () {
    try {
      return window.location.hostname.indexOf('ququkid.com') !== -1;
    } catch (e) {
      return false;
    }
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (AppConfig);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var vuePermission = {};
vuePermission.install = function (Vue) {
  Vue.directive('perm', {
    inserted: function inserted(el, binding, vnode) {

      var permissions = Vue.prototype.$store.get('permissions');
      var params = binding.value;
      if (permissions.indexOf('all') >= 0) {} else if (permissions.indexOf(params) < 0) {
        el.style.display = "none";
      }
    }
  });
};
/* harmony default export */ __webpack_exports__["a"] = (vuePermission);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_quill__);







var Link = __WEBPACK_IMPORTED_MODULE_6_quill__["import"]('formats/link');
var BlockEmbed = __WEBPACK_IMPORTED_MODULE_6_quill__["import"]('blots/block/embed');

var ATTRIBUTES = ['src'];

var Audio = function (_BlockEmbed) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Audio, _BlockEmbed);

  function Audio() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Audio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Audio.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Audio)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Audio, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Audio.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Audio.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Audio.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Audio), 'create', this).call(this, value);
      node.setAttribute('style', 'width: 40%;');
      node.setAttribute('controls', 'controls');
      if (value.src) {
        node.setAttribute('src', value.src);
      } else {
        node.setAttribute('src', value);
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return Link.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Audio;
}(BlockEmbed);

Audio.blotName = 'audio';
Audio.className = 'ql-audio';
Audio.tagName = 'audio';

/* harmony default export */ __webpack_exports__["a"] = (Audio);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Constant = {
  install: function install(Vue) {
    Vue.prototype.$constant = Constant;
  },

  contractStatus: [{ code: 0, text: '使用中' }, { code: 1, text: '未开启' }, { code: 2, text: '已过期' }],
  yn: [{ code: 'y', text: '是' }, { code: 'n', text: '否' }],
  yesNoNum: [{ code: 1, text: '是' }, { code: 0, text: '否' }],
  loginBy: [{ code: 2, text: '邮箱' }, { code: 1, text: '手机号' }],
  tchTags: [{ code: '不活跃', text: '不活跃' }, { code: '活跃', text: '活跃' }],
  serviceType: [{ code: 0, text: '否' }, { code: 1, text: '销售专属' }, { code: 2, text: '学导专属' }],
  enabledStatus: [{ code: 1, text: '启用' }, { code: 0, text: '禁用' }],
  userListStatus: [{ code: 1, text: '正常' }, { code: 0, text: '禁用' }],
  userLeaveStatus: [{ code: 1, text: '正常' }, { code: -1, text: '已取消' }],
  adminRuleType: [{ code: 1, text: 'URL' }, { code: 2, text: '菜单' }],
  sex: [{ code: 1, text: '男' }, { code: 2, text: '女' }],
  grade: [{ code: '学龄前', text: '学龄前' }, { code: '幼儿园', text: '幼儿园' }, { code: '一年级', text: '一年级' }, { code: '二年级', text: '二年级' }, { code: '三年级', text: '三年级' }, { code: '四年级', text: '四年级' }, { code: '五年级', text: '五年级' }, { code: '六年级', text: '六年级' }, { code: '七年级', text: '七年级' }, { code: '八年级', text: '八年级' }, { code: '九年级', text: '九年级' }, { code: '高一', text: '高一' }, { code: '高二', text: '高二' }, { code: '高三', text: '高三' }],
  userLessonStatus: [{ code: 0, text: '未测网' }, { code: 1, text: '己测网' }, { code: 2, text: '己试听' }],
  userTrackStatus: [{ code: '0', text: '未处理' }, { code: '1', text: '已处理' }],
  bookCourseChangeStatus: [{ code: 0, text: '未审核' }, { code: 1, text: '通过' }, { code: 2, text: '拒绝' }, { code: 3, text: '复审' }],
  courseType: [{ code: 1, text: '外教课' }, { code: 2, text: '中教课' }, { code: 3, text: '直播课' }, { code: 4, text: '外教辅修课' }, { code: 5, text: '外教补课' }, { code: 6, text: '中教补课' }, { code: 7, text: '试听课' }, { code: 8, text: '陪练课' }],
  newCourseType: [{ code: 1, text: '外教课' }, { code: 2, text: '中教课' }, { code: 3, text: '直播课' }, { code: 4, text: '外教辅修课' }, { code: 7, text: '试听课' }, { code: 8, text: '陪练课' }],
  givingType_fq: [{ code: 1, text: '朋友圈活动' }, { code: 2, text: '邀请好友' }, { code: 3, text: '其他' }, { code: 4, text: '平台问题(classin)' }, { code: 5, text: '教材问题' }],
  givingType: [{ code: 1, text: '朋友圈赠课' }, { code: 2, text: '邀请好友' }, { code: 3, text: '特殊补贴课时' }, { code: 4, text: '平台原因(classin)' }, { code: 5, text: '教材原因' }, { code: 7, text: '技术(bug)原因' }, { code: 8, text: '学导原因导致返课' }, { code: 9, text: '购课赠送课时' }, { code: 10, text: '退款' }],
  applyDepartment: [{ code: 4, text: '学导部' }, { code: 10, text: '销售部' }],
  addSubType: [{ code: 1, text: '加课时' }, { code: 2, text: '减课时' }, { code: 3, text: '加请假次数' }, { code: 4, text: '减请假次数' }, { code: 5, text: '加补课数' }, { code: 6, text: '减补课数' }],
  teacherType: [{ code: 1, text: '共用' }, { code: 2, text: '常规' }, { code: 3, text: '测评' }],
  teacherStatus: [{ code: -1, text: '禁用' }, { code: 0, text: '未激活' }, { code: 1, text: '激活' }, { code: 2, text: '被拒绝' }, { code: 3, text: '离职' }],
  hrList: [{ code: 'Murphy', text: 'Murphy' }, { code: 'Louis', text: 'Louis' }, { code: 'Coco', text: 'Coco' }, { code: 'Amanda', text: 'Amanda' }],
  isStudyAdviser: [{ code: 1, text: '已分配' }, { code: 0, text: '未分配' }],

  teacherCategory: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }, { code: 4, text: '培训中老师' }, { code: 5, text: '面试中老师' }, { code: 6, text: '中介老师' }],

  tchChangeStatusType: [{ code: 1, text: '状态' }, { code: 2, text: '类型' }, { code: 3, text: '职务' }, { code: 4, text: '绑定外教运营' }, { code: 5, text: '绑定学顾' }],
  tchLeaveStatus: [{ code: 1, text: '正常' }, { code: -1, text: '已取消' }],
  tchSignLogStatus: [{ code: 1, text: '签到' }, { code: 2, text: '未签到' }],
  appraise: [{ code: 1, text: '听力' }, { code: 2, text: '口语' }, { code: 3, text: '读' }, { code: 4, text: '读写' }],
  questionType: [{ code: 1, text: '录音题' }, { code: 2, text: '选择题' }, { code: 3, text: '填空题' }],
  questionAnswer: [{ code: '1', text: '选项1' }, { code: '2', text: '选项2' }, { code: '3', text: '选项3' }, { code: '4', text: '选项4' }],
  activityType: [{ code: 'SHARE_POSTER', text: '分享海报' }, { code: 'GROUP_ACTIVITY', text: '拼团活动' }, { code: 'BOOST_ACTIVITY', text: '助力活动' }, { code: 'LOTTERY_ACTIVITY', text: '抽奖活动' }, { code: 'LARGE_POSTER', text: '大型活动' }],
  sharePosterType: [{ code: 'ORDINARY_POSTER', text: '普通海报' }, { code: 'CUSTOMIZE_POSTER', text: '自定义海报' }],
  giveType: [{ code: 1, text: '课时赠送' }, { code: 2, text: '物品赠送' }],
  studentStatus: [{ code: 1, text: '体验名单' }, { code: 2, text: '体验学生' }, { code: 3, text: '付费学生' }],
  studentServerBy: [{ code: 1, text: '等待确认归属' }, { code: 2, text: '销售独立服务' }, { code: 3, text: '学导服务' }],
  distributionReason: [{ code: 1, text: '新生分配' }, { code: 2, text: '服务原因更换班主任' }, { code: 3, text: '离职交接' }, { code: 4, text: '投诉属实更换班主任' }, { code: 5, text: '无效投诉更换班主任 ' }],
  studentStatusAudit: [{ code: 1, text: '停课' }, { code: 2, text: '主修课结课' }, { code: 3, text: '中教课结课' }, { code: 4, text: '陪练课结课' }, { code: 5, text: '常规学生' }, { code: 6, text: '退费学生' }, { code: 7, text: '待开班学生' }, { code: 8, text: '结课学生' }, { code: 9, text: '待分配' }],
  bookLessonOpenedLsnType: [{ code: 0, text: '测网课' }, { code: 1, text: '试听课' }, { code: 2, text: '常规课' }],
  bookLessonOpenedCheckStatus: [{ code: 0, text: '未审核' }, { code: 1, text: '通过' }, { code: 2, text: '未通过' }],
  classType: [{ code: 1, text: 'classIn' }, { code: 2, text: 'hellokid' }],
  tchType: [{ code: 0, text: '未分配' }, { code: 1, text: '外教' }, { code: 2, text: '中教' }, { code: 3, text: '陪练' }],
  lessonType: [{ code: 0, text: '未分配' }, { code: 1, text: '外教课' }, { code: 2, text: '中教课' }, { code: 3, text: '辅修课' }, { code: 4, text: '陪练课' }],
  itemType: [{ code: 1, text: '学生画像' }, { code: 2, text: '试听课预约失败' }, { code: 3, text: '试听课缺席原因' }, { code: 4, text: '试听课课后反馈' }],
  handlerType: [{ code: '1', text: '已处理' }, { code: 0, text: '未处理' }],
  tchOpenedTimeType: [{ code: 0, text: '无开课' }, { code: 1, text: '有开课' }],
  userTraceType: [{ code: 0, text: '新注册学生' }, { code: 1, text: '分配记录' }, { code: 2, text: '试听课记录' }, { code: 3, text: '成交记录' }, { code: 4, text: '交接记录' }, { code: 5, text: '绑定记录' }, { code: 6, text: '上课跟进记录' }, { code: 7, text: '转介绍跟进记录' }, { code: 99, text: '其他' }],
  recordsSource: [{ code: 1, text: '手动分配' }, { code: 2, text: '公共资源' }, { code: 3, text: '自动分配' }, { code: 4, text: '扫码推荐关联' }],
  personMessageRouter: [{ code: 1, text: '注册消息', url: '/user/userTrackList' }, { code: 11, text: '分配消息', url: '/user/userTrackList' }, { code: 21, text: '试听课消息', url: '/user/editStudentInfo' }, { code: 22, text: '试听课失败消息', url: '/message/trailLessonFailedReason' }, { code: 23, text: '试听课缺席消息', url: '/message/trailLessonAbsentReason' }, { code: 24, text: '试听课完结后消息', url: '/message/trailLessonFeedBack' }, { code: 25, text: '试听课完结后提醒是否成功报名', url: '/user/userTrackList' }, { code: 31, text: '报名成功', url: '/user/parentCommunicationAdviserRecords' }, { code: 32, text: '报名失败', url: '/user/addOrderFailRecords' }, { code: 41, text: '寄送教材', url: '/user/userTrackList' }, { code: 42, text: '和家长沟通确认', url: '/user/userTrackList' }, { code: 43, text: '分配学导后提醒和家长沟通', url: '/user/parentCommunicationRecords' }, { code: 51, text: '绑定消息', url: '/user/userTrackList' }, { code: 52, text: '解绑消息', url: '/user/userTrackList' }, { code: 61, text: '上课跟进消息', url: '/user/userTrackList' }, { code: 62, text: '转移学导记录', url: '/user/userTrackList' }, { code: 63, text: '完成一个等级课程', url: '/user/userTrackList' }, { code: 64, text: '完结相应课节数量提醒', url: '/user/userTrackList' }, { code: 65, text: '超过一个月未联系提醒', url: '/user/userTrackList' }, { code: 66, text: '开课时间提醒', url: '/user/userTrackList' }, { code: 67, text: '绑定有效时间失效记录', url: '/user/userTrackList' }, { code: 68, text: '提示配送教材', url: '/user/addSendMaterialRecords' }, { code: 99, text: '其他' }],
  lsnSelStatus: [{ code: 1, text: '已选' }, { code: 2, text: '上课中' }, { code: 3, text: '已上课' }, { code: 4, text: '学生请假' }, { code: 5, text: '学生旷课' }, { code: 6, text: '老师请假' }, { code: 7, text: '老师旷课' }, { code: 8, text: '老师迟到' }, { code: 9, text: '学生老师旷课' }, { code: 10, text: '学生旷课老师迟到' }, { code: 11, text: '管理员取消' }, { code: 12, text: '学生取消' }, { code: 13, text: '老师离职' }],
  complaintReason: [{ code: 1, text: '上课吃东西' }, { code: 2, text: '上课打电话' }, { code: 3, text: '没上课技巧' }, { code: 4, text: '上课不认真' }, { code: 5, text: '中途离开' }, { code: 6, text: '网太差' }, { code: 7, text: '不纠正孩子发音' }],

  fundPackageState: [{ code: 0, text: '待支付' }, { code: 1, text: '支付成功' }, { code: 2, text: '订单已添加' }, { code: 3, text: '合同关闭' }, { code: 4, text: '部分支付' }, { code: 5, text: '全部支付' }, { code: 6, text: '财务已审核' }, { code: 9, text: '已退费' }],
  fundUserBillType: [{ code: 1, text: '支付宝' }, { code: 2, text: '微信' }],
  payWay: [{ code: 1, text: '支付宝' }, { code: 2, text: '微信' }, { code: 9, text: '其他' }],
  payWayNew: [{ code: 2, text: '微信' }, { code: 1, text: '支付宝' }, { code: 9, text: '其他' }],
  payWay2: [{ code: 1, text: '微信' }, { code: 2, text: '支付宝' }, { code: 9, text: '其他' }],
  isReceive: [{ code: 1, text: '是' }, { code: 0, text: '否' }, { code: 2, text: '未审核' }],
  week: [{ code: 1, text: '周一' }, { code: 2, text: '周二' }, { code: 3, text: '周三' }, { code: 4, text: '周四' }, { code: 5, text: '周五' }, { code: 6, text: '周六' }, { code: 7, text: '周日' }],
  telState: [{ code: 'dealing', text: '已接' }, { code: 'notDeal', text: '振铃未接听' }, { code: 'leak', text: 'ivr放弃' }, { code: 'queueLeak', text: '排队放弃' }, { code: 'blackList', text: '黑名单' }, { code: 'voicemail', text: '留言' }],
  traceStatus: [{ code: 1, text: '跟进高' }, { code: 2, text: '跟进中' }, { code: 3, text: '跟进低' }, { code: 4, text: '无意向' }, { code: 5, text: '多次联系不到' }, { code: 100, text: '注册备注' }],
  traceItem: [{ code: 1, text: '课后-同意购买' }, { code: 2, text: '课后-付款成功，持续跟进' }, { code: 3, text: '课后-讲解产品，学习方案' }, { code: 4, text: '课后-开场' }, { code: 5, text: '课前跟进，确认出席' }, { code: 6, text: '课前跟进，改期' }, { code: 7, text: '课前约课' }, { code: 8, text: '价格问题' }, { code: 9, text: '行业对比' }, { code: 10, text: '不信任' }, { code: 11, text: '级别年龄不符' }, { code: 12, text: '无人接听' }, { code: 13, text: '挂断' }, { code: 14, text: '关机/停机' }, { code: 15, text: '空号' }],
  telCallState: [{ code: 1, text: '去电' }, { code: 2, text: '来电' }],
  weekZh: ['周日', '周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  weekSelect: [{ code: 1, text: '周一' }, { code: 2, text: '周二' }, { code: 3, text: '周三' }, { code: 4, text: '周四' }, { code: 5, text: '周五' }, { code: 6, text: '周六' }, { code: 7, text: '周日' }],
  connectionStatus: [{ code: 1, text: '未拨打' }, { code: 2, text: '拨打未接' }, { code: 3, text: '拨打接通' }, { code: 4, text: '无效资源' }],
  adviserGroup: [{ code: 0, text: '全部' }, { code: 1, text: '销售一部' }, { code: 2, text: '销售二部' }],
  studentTags: [{ code: 1, text: '自主下单电脑端' }, { code: 2, text: '自主下单移动端' }, { code: 3, text: '转介绍' }, { code: 4, text: '新春福袋活动' }, { code: 5, text: '新学期读书计划活动' }, { code: 6, text: '砍价活动' }, { code: 7, text: '金币商城活动' }, { code: 8, text: '年终奖学金活动' }, { code: 9, text: 'VIP学生' }, { code: 10, text: '抓气球活动' }],
  channel: [{ code: 0, text: '其他' }, { code: 1, text: '在线咨询' }, { code: 2, text: '来电咨询' }],
  tchLeaveType: [{ code: 1, text: '常规请假 Standard leave' }, { code: 2, text: '临时请假 Emergency leave' }, { code: 4, text: '老师失联NCNS' }, { code: 5, text: '取消课Cancellation' }, { code: 6, text: '无责任请假Exempted from leave rate' }, { code: 7, text: '无责病假Exempted from sick leave rate' }, { code: 8, text: '无责年假Irresponsible annual leave' }, { code: 9, text: '离职' }, { code: 99, text: '其他原因' }],
  tchResignType: [{ code: 9, text: '离职LeaveOffice' }, { code: 99, text: '其他原因Other' }],
  resourceStatus: [{ code: 1, text: '分配资源' }, { code: 2, text: '公共资源' }],
  intentLevel: [{ code: 1, text: '高意向' }, { code: 2, text: '意向一般' }, { code: 3, text: '待跟进' }, { code: 4, text: '无效资源' }],
  auditionStatus: [{ code: 1, text: '未预约' }, { code: 2, text: '已预约' }, { code: 3, text: '已试听' }],
  evaluationProgress: [{ code: 1, text: '未测评' }, { code: 2, text: '已测评' }],
  stdStatus: [{ code: -1, text: '全部' }, { code: 1, text: '新注册学生' }, { code: 3, text: '已预约' }, { code: 4, text: '已试听' }, { code: 5, text: '付款未绑定' }, { code: 6, text: '已绑定' }, { code: 7, text: '已开课' }, { code: 8, text: '已完课' }, { code: 9, text: '退费' }, { code: 10, text: '停课' }, { code: 11, text: '已付款' }, { code: 12, text: '重新待绑定' }, { code: 13, text: '绑定未开课' }, { code: 14, text: '上课中' }, { code: 15, text: '请假中' }],
  studentCanal: [{ code: 'gw', text: '官网' }, { code: 'yd', text: '移动' }, { code: 'zxzx', text: '在线咨询' }, { code: 'ldzx', text: '来电咨询' }, { code: 'tj', text: '二维码推荐' }, { code: 'gzh', text: '公众号' }, { code: 'tmk', text: 'TMK' }, { code: 'qt', text: '其他' }, { code: 'zj', text: '直接' }, { code: 'seo', text: 'SEO' }, { code: 'wb', text: '外部链接' }, { code: 'bd', text: '百度推广' }, { code: 'sg', text: '搜狗推广' }, { code: 'sm', text: '神马推广' }, { code: '360', text: '360推广' }, { code: 'qcx', text: '推广合作B' }, { code: 'jjppc', text: '竞价品牌词' }, { code: 'pyq', text: '朋友圈' }, { code: 'pt', text: '拼团' }, { code: 'ma', text: '拼团小程序' }, { code: 'hfwj', text: '哈佛外教课' }, { code: 'seoxzd', text: '一部小站点' }, { code: 'seoask', text: '一部问答' }, { code: 'seowx', text: '一部公众号' }, { code: 'xcx', text: '小程序' }, { code: 'invite', text: '分享有礼' }, { code: 'tjyj', text: '推荐有奖' }, { code: 'monthly_report', text: '月度报告' }, { code: 'qdhz1', text: '渠道合作一' }, { code: 'yyw', text: '鹰羽网' }, { code: '一部趣趣问答', text: '一部趣趣问答' }, { code: 'stqd1', text: '试听渠道一' }, { code: 'spoken_word_star', text: '口语之星' }, { code: 'dljm', text: '代理价加盟' }, { code: 'qrcode_tj', text: '四月推荐活动(4.13-4.28)' }],
  stdTab: [{ code: 11, text: '五月推荐活动' }, { code: 12, text: '618陪练课活动' }],
  leaveType: [{ code: 1, text: '请单节课' }, { code: 2, text: '请长假' }, { code: 3, text: '申请停课' }],
  regTypes: [{ code: 'gw', text: '官网' }, { code: 'yd', text: '移动' }, { code: 'zxzx', text: '在线咨询' }, { code: 'ldzx', text: '来电咨询' }, { code: 'tj', text: '二维码推荐' }, { code: 'gzh', text: '公众号' }, { code: 'pyq', text: '朋友圈' }, { code: 'tmk', text: 'TMK' }, { code: 'qcx', text: '推广合作B' }, { code: 'jjppc', text: '竞价品牌词' }, { code: 'xcx', text: '小程序' }, { code: 'seoxzd', text: '一部小站点' }, { code: 'seoask', text: '一部问答' }, { code: 'seowx', text: '一部公众号' }, { code: 'qt', text: '其他' }],
  accent: [{ code: 1, text: '英音' }, { code: 2, text: '美音' }, { code: 9, text: '其他' }],
  tchChannel: [{ code: 1, text: '欧美' }, { code: 2, text: '菲教' }],
  materialVersions: [{ code: 1, text: '教材1.0' }, { code: 2, text: 'Wonders' }, { code: 3, text: '教材3.0' }, { code: 4, text: '教材4.0' }, { code: 5, text: '教材5.0' }, { code: 6, text: '陪练' }, { code: 10, text: 'Power Up' }, { code: 9, text: '其他' }],
  invoiceState: [{ code: 1, text: '未开' }, { code: 2, text: '部分已开' }, { code: 3, text: '已开' }],
  invoiceStatus: [{ code: 1, text: '收据' }, { code: 2, text: '普通发票' }, { code: 3, text: '增值税发票' }, { code: 4, text: '服务发票' }],
  assignList: [{ code: 0, text: '全部' }, { code: 1, text: '分配名单' }, { code: 2, text: '推荐名单' }],
  refundInvoice: [{ code: 0, text: '未开票' }, { code: 1, text: '需回收' }, { code: 2, text: '已经回收' }],
  refundState: [{ code: -1, text: '删除' }, { code: 0, text: '待审核' }, { code: 1, text: '审核通过' }, { code: 2, text: '财务退款成功' }, { code: 3, text: '驳回' }, { code: 9, text: '劝退成功' }],
  refundReasonCategory: [{ code: 1, text: '外教原因' }, { code: 2, text: '学导原因' }, { code: 3, text: '销售原因' }, { code: 4, text: '技术原因' }, { code: 5, text: '产品原因' }, { code: 6, text: '学生客观原因' }],
  mobileRule: /^(\d{3,5}-)?\d{7,12}$/,
  lessonReviewAppraise: [{ code: 1, text: '听力' }, { code: 2, text: '口语' }, { code: 3, text: '读' }, { code: 4, text: '写作' }],
  lessonReviewQuestionType: [{ code: 1, text: '录音题' }, { code: 2, text: '选择题' }, { code: 3, text: '填空题' }],
  orderChannel: [{ code: 0, text: '新签' }, { code: 1, text: '转介绍' }, { code: 3, text: '续费' }, { code: 4, text: '销售续费' }, { code: 5, text: '结课新签' }, { code: 6, text: '新签补升' }, { code: 7, text: '转介绍补升' }, { code: 8, text: '续费补升' }, { code: 9, text: '销售续费补升' }, { code: 10, text: '结课新签补升' }, { code: 11, text: '订金订单' }],
  orderChannelNew: [{ code: 0, text: '新签' }, { code: 1, text: '转介绍' }, { code: 3, text: '续费' }, { code: 4, text: '销售续费' }, { code: 5, text: '结课新签' }, { code: 11, text: '订金订单' }],
  orderChannelRenew: [{ code: 6, text: '新签补升' }, { code: 7, text: '转介绍补升' }, { code: 8, text: '续费补升' }, { code: 9, text: '销售续费补升' }, { code: 10, text: '结课新签补升' }],
  department: [{ code: 1, text: '顶级管理组' }, { code: 2, text: '管理员' }, { code: 3, text: '产品组' }, { code: 4, text: '学习导师SC' }, { code: 6, text: '市场运营' }, { code: 7, text: '外教运营' }, { code: 8, text: '教研' }, { code: 9, text: '已离职' }, { code: 10, text: '课程顾问CC' }, { code: 12, text: '临时' }],
  receiveType: [{ code: 0, text: '有赞' }, { code: 1, text: '微信' }, { code: 2, text: '支付宝' }, { code: 3, text: '转账' }, { code: 4, text: '库分期' }],
  tchTrackRecordType: [{ code: 0, text: '加薪记录' }, { code: 1, text: '请假记录' }, { code: 2, text: '时间变动' }, { code: 3, text: '销售评价' }, { code: 4, text: '学导评价' }, { code: 5, text: '外管评价' }, { code: 6, text: '其他' }, { code: 7, text: '回访' }, { code: 8, text: '面试记录' }, { code: 9, text: '培训记录' }, { code: 10, text: '老师离职' }, { code: 11, text: '培训淘汰' }, { code: 12, text: '培训流失' }, { code: 13, text: '面试笔记' }],
  stuDesc: [{ code: 1, text: '不自信' }, { code: 2, text: '坐不住调皮' }, { code: 3, text: '孩子有基础' }, { code: 4, text: '孩子基础很好' }, { code: 5, text: '注意力不集中的' }, { code: 6, text: '害羞' }, { code: 7, text: '安静' }, { code: 8, text: '零基础' }, { code: 9, text: '基础差' }, { code: 10, text: '父母是英语老师' }, { code: 11, text: '去过国外' }, { code: 12, text: '不喜欢学英语' }, { code: 13, text: '学生不会用画笔' }],
  askForTch: [{ code: 114, text: '多拓展' }, { code: 115, text: '多用道具' }, { code: 116, text: '给权限' }, { code: 117, text: '给多点奖杯' }, { code: 118, text: '做一些口语交流' }, { code: 119, text: '幽默点' }, { code: 120, text: '耐心点' }, { code: 121, text: '活泼点' }, { code: 122, text: '讲慢点' }, { code: 123, text: '要纠音' }, { code: 124, text: '要纠正语法错误' }, { code: 125, text: '多微笑' }, { code: 126, text: '多鼓励' }, { code: 127, text: '多互动' }, { code: 128, text: '引导/带动孩子' }, { code: 129, text: '展示下宠物' }, { code: 130, text: '调动学生的兴趣' }, { code: 131, text: '不要让学生用画笔' }, { code: 132, text: '不要打字，说为主' }, { code: 133, text: '多用肢体语言' }, { code: 134, text: '引导孩子念句子' }, { code: 135, text: '不要照本宣科' }, { code: 136, text: '把课件放大' }, { code: 137, text: '引导孩子输出' }],
  lessonErrStatus: [{ code: 0, text: '待处理' }, { code: 1, text: '已修改' }, { code: 2, text: '无需处理' }],
  confirm: [{ code: 0, text: '未确认' }, { code: 1, text: '确认' }],

  woStatus: [{ code: 'UNAUDITED', text: '未审核' }, { code: 'APPROVED', text: '已审核' }, { code: 'REJECTED', text: '已驳回' }, { code: 'UN_SUBMITTED', text: '未提交' }, { code: 'ASSIGNED', text: '分配学导' }, { code: 'IN_PROGRESS', text: '处理中' }],
  woVersion: [{ code: 0, text: '旧' }, { code: 1, text: '新' }],
  paymentType: [{ code: 'PAYPAL', text: 'PAYPAL' }, { code: 'PAYONEER_1', text: 'PAYONEER 1%' }, { code: 'PAYONEER_2', text: 'PAYONEER 2%' }, { code: 'PAYONEER_6_0', text: 'PAYONEER 6.0' }, { code: 'DOMESTIC_PAYPAL', text: '国内PAYPAL' }, { code: 'DOMESTIC_PAYONEER', text: '国内PAYONEER' }, { code: 'WECHAT', text: '微信' }, { code: 'ALIPAY', text: '支付宝' }, { code: 'LOCAL_BANK_ACCOUNT', text: '当地银行卡付款' }],
  userVideoType: [{ code: 1, text: '萌宝幼儿组' }, { code: 2, text: '活力少儿组' }, { code: 3, text: '青春少年组' }],
  auditStatus: [{ code: 0, text: '待审核' }, { code: 1, text: '审核通过' }, { code: 2, text: '审核不通过' }],
  userVideoPhase: [{ code: 0, text: '未知' }, { code: 1, text: '初赛' }, { code: 2, text: '复赛' }],
  userVideoPeriod: [{ code: 4, text: '第四期' }, { code: 5, text: '第五期' }, { code: 6, text: '第六期' }, { code: 7, text: '第七期' }],
  groupStatus: [{ code: 0, text: '未付款' }, { code: 1, text: '拼团中' }, { code: 2, text: '拼团成功' }, { code: 3, text: '拼团失败' }],
  courseTypeEnum: [{ code: 'ONE_TO_ONE', text: '外教一对一' }],
  renewalType: [{ code: 'RENEWED', text: '已续费' }, { code: 'NOT_RENEWED', text: '未续费' }],
  tchFeedbackStatus: [{ code: 1, text: '显示' }, { code: 2, text: '隐藏' }],
  reviewClockRecordStatus: [{ code: 0, text: '未完成' }, { code: 1, text: '已完成' }],
  reviewClockRecordType: [{ code: 0, text: '闯关' }, { code: 1, text: '打卡' }],
  woReason: [{ code: '开课日期有误', text: '开课日期有误' }, { code: '备注有误', text: '备注有误' }],
  callType: [{ code: 'CALL_IN', text: '去电' }, { code: 'ON_CALL', text: '来电' }],
  callState: [{ code: 'ANSWERED', text: '已接' }, { code: 'NOT_ANSWERED', text: '振铃未接听' }, { code: 'CALLED', text: '被叫' }],
  assignNumEnum: [{ code: 0, text: '未流转' }, { code: 1, text: '一次流转' }, { code: 2, text: '二次流转' }],
  givingTypeEnum: [{ code: 0, text: '无' }, { code: 1, text: '朋友圈赠课' }, { code: 2, text: '邀请好友' }, { code: 3, text: '特殊补贴课时' }, { code: 4, text: '平台原因' }, { code: 5, text: '教材原因' }, { code: 6, text: '老师原因' }, { code: 7, text: '技术(bug)原因' }, { code: 8, text: '学导原因导致返课' }, { code: 9, text: '购课赠送课时' }, { code: 10, text: '退款' }, { code: 11, text: '老师原因' }],
  givingTypeChildEnum: [{ code: 0, text: '无' }, { code: 1, text: '课件编辑错' }, { code: 2, text: '老师离职' }, { code: 3, text: '老师旷课' }, { code: 4, text: '老师迟到10分钟以及以上' }, { code: 5, text: '老师网络原因不能上课' }, { code: 6, text: '教材不顺延' }, { code: 7, text: '课件排错' }, { code: 8, text: '特殊请假' }, { code: 9, text: '家长态度强硬非要返还课时' }, { code: 10, text: '转介绍成功购课' }, { code: 11, text: '邀请好友试听成功' }],
  competitionAreaEnum: [{ code: 1, text: '杭州赛区' }, { code: 2, text: '嘉兴赛区' }, { code: 3, text: '绍兴赛区' }, { code: 4, text: '金华赛区' }, { code: 5, text: '温州赛区' }, { code: 6, text: '台州赛区' }, { code: 7, text: '台州赛区' }, { code: 8, text: '舟山赛区' }, { code: 9, text: '衢州赛区' }],
  ageGroupEnum: [{ code: 1, text: '6-9岁' }, { code: 2, text: '10-12岁' }, { code: 3, text: '13-16岁' }],
  phaseEnum: [{ code: 0, text: '未知' }, { code: 1, text: '初赛' }, { code: 2, text: '复赛' }, { code: 3, text: '终赛' }],
  schoolEnums: [{ code: 0, text: '邦德尔英语' }],
  tchComplaintRemark: [{ text: '上课知识点讲解错误，发音错误', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教不备课', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教上课态度不好', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教上课看手机、回复消息、浏览其他不相关网站', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教上课吃东西、喝酒、抽烟、喝水不算', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教教学环境嘈杂', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教上课言论不当（与我们的政治立场相反）', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教衣着不得体、鼻环、舌钉', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教上课混时间，播放非教材视频超过2分钟', stdNum: 2, tchNum: 6, subSalary: 1 }, { text: '外教迟到', stdNum: 0, tchNum: 0, subSalary: 0 }, { text: '外教早退', stdNum: 0, tchNum: 0, subSalary: 0 }, { text: '外教缺席', stdNum: 0, tchNum: 0, subSalary: 0 }, { text: '外教临时请假', stdNum: 0, tchNum: 0, subSalary: 0 }, { text: '外教离职', stdNum: 0, tchNum: 0, subSalary: 0 }, { text: '网络原因', stdNum: 0, tchNum: 0, subSalary: 0 }],
  stdOverRemark: [{ text: '价格贵' }, { text: '转线下' }, { text: '服务不满意' }, { text: '课程不满意' }, { text: '老师不满意' }, { text: '没时间 ' }, { text: '效果不好 ' }, { text: 'app 不满意 ' }, { text: '无配套预复习 ' }, { text: '规划不定 ' }, { text: '退费 ' }],
  checkStatus: [{ code: 0, text: '未确认' }, { code: 1, text: '已确认' }, { code: 2, text: '已拒绝' }],
  yesOrNo: [{ code: false, text: '否' }, { code: true, text: '是' }],
  channelTypeEnum: [{ id: 'A', text: 'A' }, { id: 'B', text: 'B' }, { id: 'C', text: 'C' }, { id: 'N', text: 'N' }, { id: 'P', text: 'P' }, { id: 'R', text: 'R' }, { id: '代理', text: '代理' }, { id: '新渠道', text: '新渠道' }],
  getEnum: function getEnum(data, key) {
    var obj = void 0;
    data.forEach(function (e) {
      if (e.code === key) {
        obj = e;
        return;
      }
    });
    return obj;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Constant);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var DateUtil = {
  install: function install(Vue) {
    Vue.prototype.$dateUtil = DateUtil;
  },
  getSecondByHm: function getSecondByHm(time) {
    var hour = time.split(':')[0];
    var minute = time.split(':')[1];
    return hour * 3600 + minute * 60;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DateUtil);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);




var Helper = {
  install: function install(Vue) {
    Vue.prototype.$helper = Helper;
  },
  isDetail: function isDetail(path) {
    if (!path) {
      return;
    }
    return path.endsWith(path, 'detail');
  },
  reset: function reset(val) {
    if (!val) {
      return;
    }

    if (typeof val === 'string') {
      val = '';
      return val;
    }
    if (typeof val === 'number') {
      val = null;
      return val;
    }
    if (val instanceof Array) {
      for (var i in val) {
        val[i] = this.reset(val[i]);
      }
    }
    if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object') {
      for (var k in val) {
        val[k] = this.reset(val[k]);
      }
    }
  },
  copyProperties: function copyProperties(src, dest) {
    if (!src || !dest) {
      return;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dest)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var v = src[key];
        dest[key] = v;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  mergeProperties: function mergeProperties(src, dest) {
    if (!src || !dest) {
      return;
    }
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(src)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        var v = src[key];
        if (v !== undefined && v !== '' && v !== null) {
          dest[key] = v;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);





var Http = {
  install: function install(Vue, options) {
    var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
      baseURL: Vue.prototype.$appConfig.baseUrl,
      timeout: 600000,

      responseType: 'json',
      transformRequest: [function (data, headers) {
        if (typeof FormData !== 'undefined' && data instanceof FormData) {
          if (headers) {
            if (typeof headers.delete === 'function') {
              headers.delete('Content-Type');
            } else {
              delete headers['Content-Type'];
              delete headers['content-type'];
            }
          }
          return data;
        }

        if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
          if (data.sorts && Array.isArray(data.sorts) && data.sorts.length > 0) {
            data.sortProperty = data.sorts[0].property;
            data.sortDirection = data.sorts[0].direction;
          }
          delete data.sorts;
        }

        return __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data, {
          arrayFormat: 'repeat',
          skipNulls: true,
          allowDots: true
        });
      }],
      transformResponse: [function (data) {
        return data;
      }],
      paramsSerializer: function paramsSerializer(params) {
        var paramKeyValue = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(params, { arrayFormat: 'repeat', skipNulls: true, allowDots: true });
        return paramKeyValue;
      },
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': '*'
      }
    });

    var logger = Vue.prototype.$logger;
    var store = Vue.prototype.$store;

    http.interceptors.request.use(function (config) {
      if (config) {
        if (store.get('token')) {
          config.headers.token = store.get('token');
        }
        if (store.get('account') && store.get('password')) {
          config.headers.account = store.get('account');
          config.headers.password = store.get('password');
        }
      }
      return config;
    }, function (error) {
      logger.debug(error);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    var router = options.router;
    var message = Vue.prototype.$Message;
    var isMessageShow = false;
    http.interceptors.response.use(function (response) {
      var headers = response.headers;
      if (headers['content-type'].indexOf('application/octet-stream') >= 0) {
        return response;
      }
      if (headers['content-type'].indexOf('text/event-stream') >= 0) {
        return response;
      }

      if (headers['content-type'].indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') >= 0) {
        return response;
      }
      if (headers['content-type'].indexOf('application/vnd.ms-excel') >= 0) {
        return response;
      }
      if (typeof response.data === 'string') {
        try {
          response.data = JSON.parse(response.data);
        } catch (e) {
          console.warn('Response data is not JSON:', e.message);
        }
      }
      var data = response.data;
      if (data.status === 'ok') {
        return data;
      } else if (data.status === '601') {
        if (!isMessageShow) {
          isMessageShow = true;
          message.error({
            content: data.msg,
            onClose: function onClose() {
              isMessageShow = false;
            }
          });
        }
        var backUrl = '';
        if (router.currentRoute) {
          backUrl = router.currentRoute.path;
        }
        router.push({ path: '/login', query: { backUrl: backUrl } });
      } else {
        if (!response.config.silent && !isMessageShow) {
          isMessageShow = true;
          message.error({
            content: data.msg,
            onClose: function onClose() {
              isMessageShow = false;
            }
          });
        }
        return data;
      }
    }, function (error) {
      logger.info('ajax错误过滤器', error);
      message.error('系统繁忙');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    Vue.prototype.$http = http;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var Logger = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  logLevel: this.DEBUG,
  install: function install(Vue) {
    Vue.prototype.$logger = Logger;

    if (Vue.prototype.$appConfig.logLevel) {
      this.logLevel = Vue.prototype.$appConfig.logLevel;
    }
  },
  debug: function debug(msg) {
    if (this.logLevel > 0) {
      return;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    console.debug('DEBUG: ', msg, args);
  },
  info: function info(msg) {
    if (this.logLevel > 1) {
      return;
    }

    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    console.info('INFO: ', msg, args);
  },
  warn: function warn(msg) {
    if (this.logLevel > 2) {
      return;
    }

    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    console.info('WARN: ', msg, args);
  },
  error: function error(msg) {
    if (this.logLevel > 3) {
      return;
    }

    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    console.info('ERROR: ', msg, args);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PhoneArea = {
  install: function install(Vue) {
    Vue.prototype.$phoneArea = PhoneArea;
  },

  areaNum: [{
    'num': 86,
    'name': {
      'cn': '中国',
      'pinyin': 'zhongguo',
      'en': 'china'
    }
  }, {
    'num': 93,
    'name': {
      'cn': '阿富汗',
      'pinyin': 'afuhan',
      'en': 'Afghanistan'
    }
  }, {
    'num': 355,
    'name': {
      'cn': '阿尔巴尼亚',
      'pinyin': 'aerbaniya',
      'en': 'Albania'
    }
  }, {
    'num': 213,
    'name': {
      'cn': '阿尔及利亚',
      'pinyin': 'aerjiliya',
      'en': 'Algeria'
    }
  }, {
    'num': 1684,
    'name': {
      'cn': '美属萨摩亚群岛',
      'pinyin': 'meishusamoyaqundao',
      'en': 'American Samoa'
    }
  }, {
    'num': 376,
    'name': {
      'cn': '安道尔',
      'pinyin': 'andaoer',
      'en': 'Andorra'
    }
  }, {
    'num': 244,
    'name': {
      'cn': '安哥拉',
      'pinyin': 'angela',
      'en': 'Angola'
    }
  }, {
    'num': 1264,
    'name': {
      'cn': '安圭拉岛',
      'pinyin': 'anguiladao',
      'en': 'Anguilla'
    }
  }, {
    'num': 1268,
    'name': {
      'cn': '安提瓜和巴布达',
      'pinyin': 'antiguahebabuda',
      'en': 'Antigua and Barbuda'
    }
  }, {
    'num': 54,
    'name': {
      'cn': '阿根廷',
      'pinyin': 'agenting',
      'en': 'Argentina'
    }
  }, {
    'num': 374,
    'name': {
      'cn': '亚美尼亚',
      'pinyin': 'yameiniya',
      'en': 'Armenia'
    }
  }, {
    'num': 297,
    'name': {
      'cn': '阿鲁巴岛',
      'pinyin': 'alubadao',
      'en': 'Aruba'
    }
  }, {
    'num': 61,
    'name': {
      'cn': '澳大利亚',
      'pinyin': 'aodaliya',
      'en': 'Australia'
    }
  }, {
    'num': 43,
    'name': {
      'cn': '奥地利',
      'pinyin': 'aodili',
      'en': 'Austria'
    }
  }, {
    'num': 994,
    'name': {
      'cn': '阿塞拜疆',
      'pinyin': 'asaibaijiang',
      'en': 'Azerbaijan'
    }
  }, {
    'num': 1242,
    'name': {
      'cn': '巴哈马',
      'pinyin': 'bahama',
      'en': 'Bahamas'
    }
  }, {
    'num': 973,
    'name': {
      'cn': '巴林',
      'pinyin': 'balin',
      'en': 'Bahrain'
    }
  }, {
    'num': 880,
    'name': {
      'cn': '孟加拉国',
      'pinyin': 'mengjialaguo',
      'en': 'Bangladesh'
    }
  }, {
    'num': 1246,
    'name': {
      'cn': '巴巴多斯',
      'pinyin': 'babaduosi',
      'en': 'Barbados'
    }
  }, {
    'num': 375,
    'name': {
      'cn': '白俄罗斯',
      'pinyin': 'baieluosi',
      'en': 'Belarus'
    }
  }, {
    'num': 32,
    'name': {
      'cn': '比利时',
      'pinyin': 'bilishi',
      'en': 'Belgium'
    }
  }, {
    'num': 501,
    'name': {
      'cn': '伯利兹',
      'pinyin': 'bolizi',
      'en': 'Belize'
    }
  }, {
    'num': 229,
    'name': {
      'cn': '贝宁',
      'pinyin': 'beining',
      'en': 'Benin'
    }
  }, {
    'num': 1441,
    'name': {
      'cn': '百慕大群岛',
      'pinyin': 'baimudaqundao',
      'en': 'Bermuda'
    }
  }, {
    'num': 975,
    'name': {
      'cn': '不丹',
      'pinyin': 'budao',
      'en': 'Bhutan'
    }
  }, {
    'num': 591,
    'name': {
      'cn': '玻利维亚',
      'pinyin': 'boliweiya',
      'en': 'Bolivia'
    }
  }, {
    'num': 387,
    'name': {
      'cn': '波斯尼亚和黑塞哥维那',
      'pinyin': 'bosiniyaheheisaigeweina',
      'en': 'Bosnia and Herzegovina'
    }
  }, {
    'num': 267,
    'name': {
      'cn': '博茨瓦纳',
      'pinyin': 'bociwana',
      'en': 'Botswana'
    }
  }, {
    'num': 55,
    'name': {
      'cn': '巴西',
      'pinyin': 'baxi',
      'en': 'Brazil'
    }
  }, {
    'num': 673,
    'name': {
      'cn': '文莱',
      'pinyin': 'wenlai',
      'en': 'Brunei Darussalam'
    }
  }, {
    'num': 359,
    'name': {
      'cn': '保加利亚',
      'pinyin': 'baojialiya',
      'en': 'Bulgaria'
    }
  }, {
    'num': 226,
    'name': {
      'cn': '布基纳法索',
      'pinyin': 'bujinafasuo',
      'en': 'Burkina Faso'
    }
  }, {
    'num': 257,
    'name': {
      'cn': '布隆迪',
      'pinyin': 'bulongdi',
      'en': 'Burundi'
    }
  }, {
    'num': 855,
    'name': {
      'cn': '柬埔寨',
      'pinyin': 'jianpuzhai',
      'en': 'Cambodia'
    }
  }, {
    'num': 237,
    'name': {
      'cn': '喀麦隆',
      'pinyin': 'kemailong',
      'en': 'Cameroon'
    }
  }, {
    'num': 1,
    'name': {
      'cn': '加拿大',
      'pinyin': 'jianada',
      'en': 'Canada'
    }
  }, {
    'num': 238,
    'name': {
      'cn': '佛得角',
      'pinyin': 'fodejiao',
      'en': 'Cape Verde'
    }
  }, {
    'num': 1345,
    'name': {
      'cn': '开曼群岛',
      'pinyin': 'kaimangqundao',
      'en': 'Cayman Islands'
    }
  }, {
    'num': 236,
    'name': {
      'cn': '中非',
      'pinyin': 'zhongfei',
      'en': 'Central African Republic'
    }
  }, {
    'num': 235,
    'name': {
      'cn': '乍得',
      'pinyin': 'zade',
      'en': 'Chad'
    }
  }, {
    'num': 56,
    'name': {
      'cn': '智利',
      'pinyin': 'zhili',
      'en': 'Chile'
    }
  }, {
    'num': 57,
    'name': {
      'cn': '哥伦比亚',
      'pinyin': 'gelunbiya',
      'en': 'Colombia'
    }
  }, {
    'num': 242,
    'name': {
      'cn': '刚果',
      'pinyin': 'gangguo',
      'en': 'Congo'
    }
  }, {
    'num': 682,
    'name': {
      'cn': '库克群岛',
      'pinyin': 'kukequndao',
      'en': 'Cook Islands'
    }
  }, {
    'num': 506,
    'name': {
      'cn': '哥斯达黎加',
      'pinyin': 'gesidalijia',
      'en': 'Costa Rica'
    }
  }, {
    'num': 385,
    'name': {
      'cn': '克罗地亚',
      'pinyin': 'keluodiya',
      'en': 'Croatia'
    }
  }, {
    'num': 53,
    'name': {
      'cn': '古巴',
      'pinyin': 'guba',
      'en': 'Cuba'
    }
  }, {
    'num': 357,
    'name': {
      'cn': '塞浦路斯',
      'pinyin': 'saipulusi',
      'en': 'Cyprus'
    }
  }, {
    'num': 420,
    'name': {
      'cn': '捷克共和国',
      'pinyin': 'jiekegongheguo',
      'en': 'Czech Republic'
    }
  }, {
    'num': 45,
    'name': {
      'cn': '丹麦',
      'pinyin': 'danmai',
      'en': 'Denmark'
    }
  }, {
    'num': 1809,
    'name': {
      'cn': '多米尼加共和国',
      'pinyin': 'duominijiagongheguo',
      'en': 'Dominican Republic'
    }
  }, {
    'num': 593,
    'name': {
      'cn': '厄瓜多尔',
      'pinyin': 'geguaduoer',
      'en': 'Ecuador'
    }
  }, {
    'num': 20,
    'name': {
      'cn': '埃及',
      'pinyin': 'aiji',
      'en': 'Egypt'
    }
  }, {
    'num': 503,
    'name': {
      'cn': '萨尔瓦多',
      'pinyin': 'saerwaduo',
      'en': 'El Salvador'
    }
  }, {
    'num': 240,
    'name': {
      'cn': '赤道几内亚',
      'pinyin': 'chidaojineiya',
      'en': 'Equatorial Guinea'
    }
  }, {
    'num': 372,
    'name': {
      'cn': '爱沙尼亚',
      'pinyin': 'aishaniya',
      'en': 'Estonia'
    }
  }, {
    'num': 251,
    'name': {
      'cn': '埃塞俄比亚',
      'pinyin': 'aisaiebiya',
      'en': 'Ethiopia'
    }
  }, {
    'num': 500,
    'name': {
      'cn': '福克兰群岛',
      'pinyin': 'fukelanqundao',
      'en': 'Falkland Islands'
    }
  }, {
    'num': 298,
    'name': {
      'cn': '法罗群岛',
      'pinyin': 'faluoqundao',
      'en': 'Faroe Islands'
    }
  }, {
    'num': 679,
    'name': {
      'cn': '斐济',
      'pinyin': 'feiji',
      'en': 'Fiji'
    }
  }, {
    'num': 358,
    'name': {
      'cn': '芬兰',
      'pinyin': 'fenlan',
      'en': 'Finland'
    }
  }, {
    'num': 33,
    'name': {
      'cn': '法国',
      'pinyin': 'faguo',
      'en': 'France'
    }
  }, {
    'num': 594,
    'name': {
      'cn': '法属圭亚那',
      'pinyin': 'fashuguiyana',
      'en': 'French Guiana'
    }
  }, {
    'num': 689,
    'name': {
      'cn': '法属波里尼西亚',
      'pinyin': 'fashubolinixiya',
      'en': 'French Polynesia'
    }
  }, {
    'num': 241,
    'name': {
      'cn': '加蓬',
      'pinyin': 'jiapeng',
      'en': 'Gabon'
    }
  }, {
    'num': 220,
    'name': {
      'cn': '冈比亚',
      'pinyin': 'gangbiya',
      'en': 'Gambia'
    }
  }, {
    'num': 995,
    'name': {
      'cn': '格鲁吉亚',
      'pinyin': 'gelujiya',
      'en': 'Georgia'
    }
  }, {
    'num': 49,
    'name': {
      'cn': '德国',
      'pinyin': 'deguo',
      'en': 'Germany'
    }
  }, {
    'num': 233,
    'name': {
      'cn': '加纳',
      'pinyin': 'jiana',
      'en': 'Ghana'
    }
  }, {
    'num': 350,
    'name': {
      'cn': '直布罗陀(英)',
      'pinyin': 'zhibuluotuo',
      'en': 'Gibraltar'
    }
  }, {
    'num': 30,
    'name': {
      'cn': '希腊',
      'pinyin': 'xila',
      'en': 'Greece'
    }
  }, {
    'num': 299,
    'name': {
      'cn': '格陵兰岛',
      'pinyin': 'gelinglandao',
      'en': 'Greenland'
    }
  }, {
    'num': 1809,
    'name': {
      'cn': '格林纳达',
      'pinyin': 'gelinnada',
      'en': 'Grenada'
    }
  }, {
    'num': 590,
    'name': {
      'cn': '瓜德罗普岛',
      'pinyin': 'guadeluopudao',
      'en': 'Guadeloupe'
    }
  }, {
    'num': 502,
    'name': {
      'cn': '危地马拉',
      'pinyin': 'weidimala',
      'en': 'Guatemala'
    }
  }, {
    'num': 224,
    'name': {
      'cn': '几内亚',
      'pinyin': 'jinaya',
      'en': 'Guinea'
    }
  }, {
    'num': 245,
    'name': {
      'cn': '几内亚比绍',
      'pinyin': 'jinayabisao',
      'en': 'Guinea-Bissau'
    }
  }, {
    'num': 592,
    'name': {
      'cn': '圭亚那',
      'pinyin': 'guiyana',
      'en': 'Guyana'
    }
  }, {
    'num': 509,
    'name': {
      'cn': '海地',
      'pinyin': 'haidi',
      'en': 'Haiti'
    }
  }, {
    'num': 504,
    'name': {
      'cn': '洪都拉斯',
      'pinyin': 'hongdulasi',
      'en': 'Honduras'
    }
  }, {
    'num': 852,
    'name': {
      'cn': '香港',
      'pinyin': 'xianggang',
      'en': 'Hong Kong'
    }
  }, {
    'num': 36,
    'name': {
      'cn': '匈牙利',
      'pinyin': 'xiongyali',
      'en': 'Hungary'
    }
  }, {
    'num': 354,
    'name': {
      'cn': '冰岛',
      'pinyin': 'bindao',
      'en': 'Iceland'
    }
  }, {
    'num': 91,
    'name': {
      'cn': '印度',
      'pinyin': 'yindu',
      'en': 'India'
    }
  }, {
    'num': 62,
    'name': {
      'cn': '印度尼西亚',
      'pinyin': 'yindunixiya',
      'en': 'Indonesia'
    }
  }, {
    'num': 98,
    'name': {
      'cn': '伊郎',
      'pinyin': 'yilang',
      'en': 'Iran'
    }
  }, {
    'num': 964,
    'name': {
      'cn': '伊拉克',
      'pinyin': 'yilake',
      'en': 'Iraq'
    }
  }, {
    'num': 353,
    'name': {
      'cn': '爱尔兰',
      'pinyin': 'aierlan',
      'en': 'Ireland'
    }
  }, {
    'num': 972,
    'name': {
      'cn': '以色列',
      'pinyin': 'yiselie',
      'en': 'Israel'
    }
  }, {
    'num': 39,
    'name': {
      'cn': '意大利',
      'pinyin': 'yidali',
      'en': 'Italy'
    }
  }, {
    'num': 1876,
    'name': {
      'cn': '牙买加',
      'pinyin': 'yamaijia',
      'en': 'Jamaica'
    }
  }, {
    'num': 81,
    'name': {
      'cn': '日本',
      'pinyin': 'riben',
      'en': 'Japan'
    }
  }, {
    'num': 962,
    'name': {
      'cn': '约旦',
      'pinyin': 'yuedao',
      'en': 'Jordan'
    }
  }, {
    'num': 7,
    'name': {
      'cn': '哈萨克斯坦',
      'pinyin': 'hasakesitan',
      'en': 'Kazakhstan'
    }
  }, {
    'num': 254,
    'name': {
      'cn': '肯尼亚',
      'pinyin': 'kenniya',
      'en': 'Kenya'
    }
  }, {
    'num': 965,
    'name': {
      'cn': '科威特',
      'pinyin': 'keweite',
      'en': 'Kuwait'
    }
  }, {
    'num': 7,
    'name': {
      'cn': '吉尔吉斯斯坦',
      'pinyin': 'jierjisita',
      'en': 'Kyrgyzstan'
    }
  }, {
    'num': 856,
    'name': {
      'cn': '老挝',
      'pinyin': 'laoguo',
      'en': 'Laos'
    }
  }, {
    'num': 371,
    'name': {
      'cn': '拉脱维亚',
      'pinyin': 'latuoweiya',
      'en': 'Latvia'
    }
  }, {
    'num': 961,
    'name': {
      'cn': '黎巴嫩',
      'pinyin': 'libanen',
      'en': 'Lebanon'
    }
  }, {
    'num': 266,
    'name': {
      'cn': '莱索托',
      'pinyin': 'laisuotuo',
      'en': 'Lesotho'
    }
  }, {
    'num': 231,
    'name': {
      'cn': '利比里亚',
      'pinyin': 'libiya',
      'en': 'Liberia'
    }
  }, {
    'num': 218,
    'name': {
      'cn': '利比亚',
      'pinyin': 'libiya',
      'en': 'Libya'
    }
  }, {
    'num': 423,
    'name': {
      'cn': '列支敦士登',
      'pinyin': 'liezhidunshideng',
      'en': 'Liechtenstein'
    }
  }, {
    'num': 370,
    'name': {
      'cn': '立陶宛',
      'pinyin': 'liwanyuan',
      'en': 'Lithuania'
    }
  }, {
    'num': 352,
    'name': {
      'cn': '卢森堡',
      'pinyin': 'lusenbao',
      'en': 'Luxembourg'
    }
  }, {
    'num': 853,
    'name': {
      'cn': '澳门',
      'pinyin': 'aomen',
      'en': 'Macau'
    }
  }, {
    'num': 389,
    'name': {
      'cn': '马其顿',
      'pinyin': 'maqidun',
      'en': 'Macedonia'
    }
  }, {
    'num': 261,
    'name': {
      'cn': '马达加斯加',
      'pinyin': 'madajiasida',
      'en': 'Madagascar'
    }
  }, {
    'num': 265,
    'name': {
      'cn': '马拉维',
      'pinyin': 'malawei',
      'en': 'Malawi'
    }
  }, {
    'num': 60,
    'name': {
      'cn': '马来西亚',
      'pinyin': 'malaixiya',
      'en': 'Malaysia'
    }
  }, {
    'num': 960,
    'name': {
      'cn': '马尔代夫',
      'pinyin': 'maerdaifu',
      'en': 'Maldives'
    }
  }, {
    'num': 223,
    'name': {
      'cn': '马里',
      'pinyin': 'mali',
      'en': 'Mali'
    }
  }, {
    'num': 356,
    'name': {
      'cn': '马耳他',
      'pinyin': 'maerta',
      'en': 'Malta'
    }
  }, {
    'num': 692,
    'name': {
      'cn': '马绍尔群岛',
      'pinyin': 'masaierqundao',
      'en': 'Marshall Islands'
    }
  }, {
    'num': 596,
    'name': {
      'cn': '马提尼克(法)',
      'pinyin': 'matinike',
      'en': 'Martinique'
    }
  }, {
    'num': 222,
    'name': {
      'cn': '毛里塔尼亚',
      'pinyin': 'maolitaniya',
      'en': 'Mauritania'
    }
  }, {
    'num': 230,
    'name': {
      'cn': '毛里求斯',
      'pinyin': 'laoliqiusi',
      'en': 'Mauritius'
    }
  }, {
    'num': 52,
    'name': {
      'cn': '墨西哥',
      'pinyin': 'moxige',
      'en': 'Mexico'
    }
  }, {
    'num': 373,
    'name': {
      'cn': '摩尔多瓦',
      'pinyin': 'moerduowa',
      'en': 'Moldova'
    }
  }, {
    'num': 377,
    'name': {
      'cn': '摩纳哥',
      'pinyin': 'monage',
      'en': 'Monaco'
    }
  }, {
    'num': 976,
    'name': {
      'cn': '蒙古',
      'pinyin': 'menggu',
      'en': 'Mongolia'
    }
  }, {
    'num': 382,
    'name': {
      'cn': '黑山共和国',
      'pinyin': 'heishangongheguo',
      'en': 'Montenegro'
    }
  }, {
    'num': 212,
    'name': {
      'cn': '摩洛哥',
      'pinyin': 'moluoge',
      'en': 'Morocco'
    }
  }, {
    'num': 258,
    'name': {
      'cn': '莫桑比克',
      'pinyin': 'mosanbike',
      'en': 'Mozambique'
    }
  }, {
    'num': 95,
    'name': {
      'cn': '缅甸',
      'pinyin': 'miandian',
      'en': 'Myanmar'
    }
  }, {
    'num': 264,
    'name': {
      'cn': '纳米比亚',
      'pinyin': 'namibiya',
      'en': 'Namibia'
    }
  }, {
    'num': 674,
    'name': {
      'cn': '瑙鲁',
      'pinyin': 'naolu',
      'en': 'Nauru'
    }
  }, {
    'num': 977,
    'name': {
      'cn': '尼泊尔',
      'pinyin': 'niboer',
      'en': 'Nepal'
    }
  }, {
    'num': 31,
    'name': {
      'cn': '荷兰',
      'pinyin': 'helan',
      'en': 'Netherlands'
    }
  }, {
    'num': 687,
    'name': {
      'cn': '新喀里多尼亚',
      'pinyin': 'xinkeliduoniya',
      'en': 'New Caledonia'
    }
  }, {
    'num': 64,
    'name': {
      'cn': '新西兰',
      'pinyin': 'xinxilan',
      'en': 'New Zealand'
    }
  }, {
    'num': 505,
    'name': {
      'cn': '尼加拉瓜',
      'pinyin': 'nijialagua',
      'en': 'Nicaragua'
    }
  }, {
    'num': 227,
    'name': {
      'cn': '尼日尔',
      'pinyin': 'nirier',
      'en': 'Niger'
    }
  }, {
    'num': 234,
    'name': {
      'cn': '尼日利亚',
      'pinyin': 'niriliya',
      'en': 'Nigeria'
    }
  }, {
    'num': 47,
    'name': {
      'cn': '挪威',
      'pinyin': 'nuowei',
      'en': 'Norway'
    }
  }, {
    'num': 968,
    'name': {
      'cn': '阿曼',
      'pinyin': 'aman',
      'en': 'Oman'
    }
  }, {
    'num': 92,
    'name': {
      'cn': '巴基斯坦',
      'pinyin': 'bajisitan',
      'en': 'Pakistan'
    }
  }, {
    'num': 680,
    'name': {
      'cn': '帕劳(美)',
      'pinyin': 'palao',
      'en': 'Palau'
    }
  }, {
    'num': 507,
    'name': {
      'cn': '巴拿马',
      'pinyin': 'banama',
      'en': 'Panama'
    }
  }, {
    'num': 675,
    'name': {
      'cn': '巴布亚新几内亚',
      'pinyin': 'babuyaxinjineiya',
      'en': 'Papua New Guinea'
    }
  }, {
    'num': 595,
    'name': {
      'cn': '巴拉圭',
      'pinyin': 'balagui',
      'en': 'Paraguay'
    }
  }, {
    'num': 51,
    'name': {
      'cn': '秘鲁',
      'pinyin': 'milu',
      'en': 'Peru'
    }
  }, {
    'num': 63,
    'name': {
      'cn': '菲律宾',
      'pinyin': 'feilvbin',
      'en': 'Philippines'
    }
  }, {
    'num': 48,
    'name': {
      'cn': '波兰',
      'pinyin': 'bolan',
      'en': 'Poland'
    }
  }, {
    'num': 351,
    'name': {
      'cn': '葡萄牙',
      'pinyin': 'putapya',
      'en': 'Portugal'
    }
  }, {
    'num': 974,
    'name': {
      'cn': '卡塔尔',
      'pinyin': 'kataer',
      'en': 'Qatar'
    }
  }, {
    'num': 262,
    'name': {
      'cn': '留尼汪岛',
      'pinyin': 'liuniwangdao',
      'en': 'Reunion'
    }
  }, {
    'num': 40,
    'name': {
      'cn': '罗马尼亚',
      'pinyin': 'luomaniya',
      'en': 'Romania'
    }
  }, {
    'num': 7,
    'name': {
      'cn': '俄罗斯',
      'pinyin': 'eluosi',
      'en': 'Russian Federation'
    }
  }, {
    'num': 966,
    'name': {
      'cn': '沙特阿拉伯',
      'pinyin': 'shatealabo',
      'en': 'Saudi Arabia'
    }
  }, {
    'num': 221,
    'name': {
      'cn': '塞内加尔',
      'pinyin': 'saineijiaer',
      'en': 'Senegal'
    }
  }, {
    'num': 381,
    'name': {
      'cn': '塞尔维亚',
      'pinyin': 'saierweiya',
      'en': 'Serbia'
    }
  }, {
    'num': 248,
    'name': {
      'cn': '塞舌尔',
      'pinyin': 'saisheer',
      'en': 'Seychelles'
    }
  }, {
    'num': 232,
    'name': {
      'cn': '塞拉利昂',
      'pinyin': 'sailalian',
      'en': 'Sierra Leone'
    }
  }, {
    'num': 65,
    'name': {
      'cn': '新加坡',
      'pinyin': 'xinjiabo',
      'en': 'Singapore'
    }
  }, {
    'num': 421,
    'name': {
      'cn': '斯洛伐克',
      'pinyin': 'siluofake',
      'en': 'Slovakia'
    }
  }, {
    'num': 386,
    'name': {
      'cn': '斯洛文尼亚',
      'pinyin': 'siluowenniya',
      'en': 'Slovenia'
    }
  }, {
    'num': 677,
    'name': {
      'cn': '阿罗门',
      'pinyin': 'aluomen',
      'en': 'Solomon Islands'
    }
  }, {
    'num': 252,
    'name': {
      'cn': '索马里',
      'pinyin': 'suomali',
      'en': 'Somalia'
    }
  }, {
    'num': 27,
    'name': {
      'cn': '南非',
      'pinyin': 'nanfei',
      'en': 'South Africa'
    }
  }, {
    'num': 34,
    'name': {
      'cn': '西班牙',
      'pinyin': 'xibanya',
      'en': 'Spain'
    }
  }, {
    'num': 94,
    'name': {
      'cn': '斯里兰卡',
      'pinyin': 'sililanka',
      'en': 'Sri Lanka'
    }
  }, {
    'num': 249,
    'name': {
      'cn': '苏丹',
      'pinyin': 'sudan',
      'en': 'Sudan'
    }
  }, {
    'num': 597,
    'name': {
      'cn': '苏里南',
      'pinyin': 'sulinan',
      'en': 'Suriname'
    }
  }, {
    'num': 268,
    'name': {
      'cn': '斯威士兰',
      'pinyin': 'siweishilan',
      'en': 'Swaziland'
    }
  }, {
    'num': 46,
    'name': {
      'cn': '瑞典',
      'pinyin': 'ruidian',
      'en': 'Sweden'
    }
  }, {
    'num': 41,
    'name': {
      'cn': '瑞士',
      'pinyin': 'ruishi',
      'en': 'Switzerland'
    }
  }, {
    'num': 963,
    'name': {
      'cn': '叙利亚',
      'pinyin': 'xuliya',
      'en': 'Syria'
    }
  }, {
    'num': 886,
    'name': {
      'cn': '台湾',
      'pinyin': 'taiwan',
      'en': 'Taiwan'
    }
  }, {
    'num': 7,
    'name': {
      'cn': '塔吉克斯坦',
      'pinyin': 'tajikesitan',
      'en': 'Tajikistan'
    }
  }, {
    'num': 255,
    'name': {
      'cn': '坦桑尼亚',
      'pinyin': 'tansanniya',
      'en': 'Tanzania'
    }
  }, {
    'num': 66,
    'name': {
      'cn': '泰国',
      'pinyin': 'taiguo',
      'en': 'Thailand'
    }
  }, {
    'num': 228,
    'name': {
      'cn': '多哥',
      'pinyin': 'duoge',
      'en': 'Togo'
    }
  }, {
    'num': 676,
    'name': {
      'cn': '汤加',
      'pinyin': 'tangjia',
      'en': 'Tonga'
    }
  }, {
    'num': 1868,
    'name': {
      'cn': '特立尼达和多巴哥',
      'pinyin': 'telinidaheduobage',
      'en': 'Trinidad and Tobago'
    }
  }, {
    'num': 216,
    'name': {
      'cn': '突尼斯',
      'pinyin': 'tunisi',
      'en': 'Tunisia'
    }
  }, {
    'num': 90,
    'name': {
      'cn': '土耳其',
      'pinyin': 'tuerqi',
      'en': 'Turkey'
    }
  }, {
    'num': 993,
    'name': {
      'cn': '土库曼斯坦',
      'pinyin': 'tukumansitan',
      'en': 'Turkmenistan'
    }
  }, {
    'num': 1649,
    'name': {
      'cn': '特克斯和凯科斯群岛',
      'pinyin': 'tekesihekaikesiqundao',
      'en': 'Turks and Caicos Islands'
    }
  }, {
    'num': 256,
    'name': {
      'cn': '乌干达',
      'pinyin': 'wuganda',
      'en': 'Uganda'
    }
  }, {
    'num': 380,
    'name': {
      'cn': '乌克兰',
      'pinyin': 'wukelan',
      'en': 'Ukraine'
    }
  }, {
    'num': 44,
    'name': {
      'cn': '英国',
      'pinyin': 'yingguo',
      'en': 'United Kingdom'
    }
  }, {
    'num': 1,
    'name': {
      'cn': '美国',
      'pinyin': 'meiguo',
      'en': 'United States'
    }
  }, {
    'num': 598,
    'name': {
      'cn': '乌拉圭',
      'pinyin': 'wulagui',
      'en': 'Uruguay'
    }
  }, {
    'num': 998,
    'name': {
      'cn': '乌兹别克斯坦',
      'pinyin': 'wuzibiekesitan',
      'en': 'Uzbekistan'
    }
  }, {
    'num': 678,
    'name': {
      'cn': '瓦努阿图',
      'pinyin': 'wanuatu',
      'en': 'Vanuatu'
    }
  }, {
    'num': 58,
    'name': {
      'cn': '委内瑞拉',
      'pinyin': 'weineiruila',
      'en': 'Venezuela'
    }
  }, {
    'num': 84,
    'name': {
      'cn': '越南',
      'pinyin': 'yuenan',
      'en': 'Vietnam'
    }
  }, {
    'num': 967,
    'name': {
      'cn': '也门',
      'pinyin': 'yemen',
      'en': 'Yemen'
    }
  }, {
    'num': 260,
    'name': {
      'cn': '赞比亚',
      'pinyin': 'zanbiya',
      'en': 'Zambia'
    }
  }, {
    'num': 263,
    'name': {
      'cn': '津巴布韦',
      'pinyin': 'jinbabuwei',
      'en': 'Zimbabwe'
    }
  }, {
    'num': 82,
    'name': {
      'cn': '韩国',
      'pinyin': 'hanguo',
      'en': 'Korea'
    }
  }, {
    'num': 971,
    'name': {
      'cn': '阿联酋',
      'pinyin': 'alianqiu',
      'en': 'United Arab Emirates'
    }
  }, {
    'num': 383,
    'name': {
      'cn': '科索沃',
      'pinyin': 'kesuowo',
      'en': 'The Republic of Kosovo'
    }
  }],
  getEnum: function getEnum(data, key) {
    var obj = void 0;
    data.forEach(function (e) {
      if (e.name.cn === key) {
        obj = e;
        return;
      }
    });
    return obj;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (PhoneArea);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store__);


var Store = {
  install: function install(Vue) {
    Vue.prototype.$store = __WEBPACK_IMPORTED_MODULE_0_store___default.a;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Store);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var TableStyle = {
  install: function install(Vue) {
    Vue.prototype.$tableStyle = TableStyle;
  },

  dateTimeWidth: 120,
  dateWidth: 100,
  dateMinuteWidth: 130
};

/* harmony default export */ __webpack_exports__["a"] = (TableStyle);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TimeZone = {
  install: function install(Vue) {
    Vue.prototype.$timeZone = TimeZone;
  },

  timeZone: [{
    'num': -20,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-12(IDL-国际换日线)'
    }
  }, {
    'num': -19,
    'name': {
      'code': 'UTC-11',
      'word': 'UTC-11(MIT-中途岛标准时间)'
    }
  }, {
    'num': -18,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-10(HST-夏威夷-阿留申标准时间)'
    }
  }, {
    'num': -17.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-9:30(MSIT-马克萨斯群岛标准时间)'
    }
  }, {
    'num': -17,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-9(AKST-阿拉斯加标准时间)'
    }
  }, {
    'num': -16,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-8(PSTA-太平洋标准时间A)'
    }
  }, {
    'num': -15,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-7(MST-北美山区标准时间)'
    }
  }, {
    'num': -14,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-6(CST-北美中部标准时间)'
    }
  }, {
    'num': -13,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-5(EST-北美东部标准时间)'
    }
  }, {
    'num': -12,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-4(AST-大西洋标准时间)'
    }
  }, {
    'num': -11.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-3:30(NST-纽芬兰岛标准时间)'
    }
  }, {
    'num': -11,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-3(SAT-南美标准时间)'
    }
  }, {
    'num': -10,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-2(BRT-巴西时间)'
    }
  }, {
    'num': -9,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC-1(CVT-佛得角标准时间)'
    }
  }, {
    'num': -8,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC(WET-欧洲西部时区，GMT-格林威治标准时间)'
    }
  }, {
    'num': -7,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+1(CET-欧洲中部时区)'
    }
  }, {
    'num': -6,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+2(EET-欧洲东部时区)'
    }
  }, {
    'num': -5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+3(MSK-莫斯科时区)'
    }
  }, {
    'num': -4.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+3:30(IRT-伊朗标准时间)'
    }
  }, {
    'num': -4,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+4(META-中东时区A)'
    }
  }, {
    'num': -3.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+4:30(AFT-阿富汗标准时间)'
    }
  }, {
    'num': -3,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+5(METB-中东时区B)'
    }
  }, {
    'num': -2.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+5:30(IDT-印度标准时间)'
    }
  }, {
    'num': -2.25,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+5:45(NPT-尼泊尔标准时间)'
    }
  }, {
    'num': -2,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+6(BHT-孟加拉标准时间)'
    }
  }, {
    'num': -1.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+6:30(MRT-缅甸标准时间)'
    }
  }, {
    'num': -1,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+7(MST-中南半岛标准时间)'
    }
  }, {
    'num': 0,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+8(EAT-东亚标准时间/中国标准时间(BJT))'
    }
  }, {
    'num': 0.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+8:30(KRT-朝鲜标准时间)'
    }
  }, {
    'num': 1,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+9(FET-远东标准时间)'
    }
  }, {
    'num': 1.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+9:30(ACST-澳大利亚中部标准时间)'
    }
  }, {
    'num': 2,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+10(AEST-澳大利亚东部标准时间)'
    }
  }, {
    'num': 2.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+10:3(FAST-澳大利亚远东标准时间)'
    }
  }, {
    'num': 3,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+11(VTT-瓦努按图标准时间)'
    }
  }, {
    'num': 3.5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+11:30(NFT-诺福克岛标准时间)'
    }
  }, {
    'num': 4,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+12(PSTB-太平洋标准时间B)'
    }
  }, {
    'num': 4.75,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+12:45(CIT-查塔姆群岛标准时间)'
    }
  }, {
    'num': 5,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+13(PSTC-太平洋标准时间C)'
    }
  }, {
    'num': 6,
    'name': {
      'code': 'UTC-12',
      'word': 'UTC+14(PSTD-太平洋标准时间D)'
    }
  }],
  getEnum: function getEnum(data, key) {
    var obj = void 0;
    data.forEach(function (e) {
      if (e.name.cn === key) {
        obj = e;
        return;
      }
    });
    return obj;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (TimeZone);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginSms__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginSms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoginSms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mex_MexCompQuestionList__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mex_MexCompQuestionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mex_MexCompQuestionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mex_MexSpeakQuestionList__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mex_MexSpeakQuestionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_mex_MexSpeakQuestionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mex_MexBlueprintList__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mex_MexBlueprintList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mex_MexBlueprintList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mex_MexSessionList__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mex_MexSessionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_mex_MexSessionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mex_MexPromotionList__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mex_MexPromotionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_mex_MexPromotionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mex_MexAdviceList__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mex_MexAdviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_mex_MexAdviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mex_MexFeedbackList__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mex_MexFeedbackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_mex_MexFeedbackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mex_MexItemStatsList__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mex_MexItemStatsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_mex_MexItemStatsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mex_MexScoreCohortList__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mex_MexScoreCohortList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mex_MexScoreCohortList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mex_MexGraySetting__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mex_MexGraySetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_mex_MexGraySetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mex_MexTrialPaper__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mex_MexTrialPaper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_mex_MexTrialPaper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_ActivityList__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_ActivityList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_market_ActivityList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_ChannelManagement__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_ChannelManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_market_ChannelManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_ChannelDealRate__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_ChannelDealRate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_market_ChannelDealRate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_market_ShareManagement__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_market_ShareManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_market_ShareManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_market_ExChangeRecordListB__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_market_ExChangeRecordListB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_market_ExChangeRecordListB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_market_ArticlePublishList__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_market_ArticlePublishList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_market_ArticlePublishList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_ChannelIncludeList__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_ChannelIncludeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_market_ChannelIncludeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_market_AiChannelIncludeList__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_market_AiChannelIncludeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_market_AiChannelIncludeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_agent_AgentUserList__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_agent_AgentUserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_agent_AgentUserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_agent_AgentInviteList__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_agent_AgentInviteList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_agent_AgentInviteList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_crm_AdviserPunchList__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_crm_AdviserPunchList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_crm_AdviserPunchList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_crm_MyResource__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_crm_MyResource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_crm_MyResource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_crm_DailyTransferList__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_crm_DailyTransferList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_crm_DailyTransferList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_crm_TreasuryResource__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_crm_TreasuryResource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_crm_TreasuryResource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_crm_DistributionList__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_crm_DistributionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_crm_DistributionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_crm_SalesDealRate__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_crm_SalesDealRate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_crm_SalesDealRate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_crm_FirstFollowList__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_crm_FirstFollowList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_crm_FirstFollowList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_crm_SpellGroupList__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_crm_SpellGroupList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_crm_SpellGroupList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_crm_PhoneRecordList__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_crm_PhoneRecordList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_crm_PhoneRecordList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_crm_DviAudioList__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_crm_DviAudioList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_crm_DviAudioList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_crm_CallAsrWord__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_crm_CallAsrWord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_crm_CallAsrWord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_crm_CallScript__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_crm_CallScript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_crm_CallScript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_user_BookTestList__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_user_BookTestList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_user_BookTestList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_user_UserPayList__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_user_UserPayList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_user_UserPayList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_user_NewStudentService__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_user_NewStudentService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_user_NewStudentService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_user_UserPayDetail__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_user_UserPayDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_user_UserPayDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_user_UserProvisionalList__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_user_UserProvisionalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_user_UserProvisionalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_user_UserExperienceList__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_user_UserExperienceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_user_UserExperienceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_user_UserTrackList__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_user_UserTrackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_user_UserTrackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_user_StudentRiskList__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_user_StudentRiskList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_user_StudentRiskList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_user_UserTrackEdit__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_user_UserTrackEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_user_UserTrackEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_user_ParentCommunicationRecords__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_user_ParentCommunicationRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_user_ParentCommunicationRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_user_ParentCommunicationAdviserRecords__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_user_ParentCommunicationAdviserRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_user_ParentCommunicationAdviserRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_user_AddOrderFailRecords__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_user_AddOrderFailRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_user_AddOrderFailRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_user_AddSendMaterialRecords__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_user_AddSendMaterialRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_user_AddSendMaterialRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_user_BindingValidTimeFailRecords__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_user_BindingValidTimeFailRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_user_BindingValidTimeFailRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_user_BookUserLeaveTimeList__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_user_BookUserLeaveTimeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_user_BookUserLeaveTimeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_user_BookCourseChangeList__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_user_BookCourseChangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_user_BookCourseChangeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_user_EditStudentInfo__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_user_EditStudentInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_user_EditStudentInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_user_PersonUserTrackList__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_user_PersonUserTrackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_user_PersonUserTrackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_user_ActivityExamineList__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_user_ActivityExamineList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_user_ActivityExamineList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_user_ExchangeRecordList__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_user_ExchangeRecordList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_user_ExchangeRecordList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_user_UserRefundList__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_user_UserRefundList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_user_UserRefundList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_user_FollowUpList__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_user_FollowUpList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_user_FollowUpList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_user_UserOverClassList__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_user_UserOverClassList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_user_UserOverClassList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_user_UserLessonsStopList__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_user_UserLessonsStopList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_user_UserLessonsStopList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_user_UserNotAllowedList__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_user_UserNotAllowedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_user_UserNotAllowedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_user_ReviewClockRecordList__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_user_ReviewClockRecordList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_user_ReviewClockRecordList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_user_DailyStudy__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_user_DailyStudy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_user_DailyStudy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_user_CancelLessonRecord__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_user_CancelLessonRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_user_CancelLessonRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_user_UserStatusAuditList__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_user_UserStatusAuditList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_user_UserStatusAuditList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_user_ClassHourFlow__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_user_ClassHourFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_user_ClassHourFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_user_DistributionStudyRecord__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_user_DistributionStudyRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_user_DistributionStudyRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_user_StudentWeekStatList__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_user_StudentWeekStatList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_user_StudentWeekStatList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_user_StudentMonthStatList__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_user_StudentMonthStatList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_user_StudentMonthStatList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_user_WordCardList__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_user_WordCardList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_user_WordCardList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_user_SentenceCardList__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_user_SentenceCardList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_user_SentenceCardList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_user_StudentWordbookList__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_user_StudentWordbookList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_user_StudentWordbookList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_user_StudentWordcardEvalList__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_user_StudentWordcardEvalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_user_StudentWordcardEvalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_user_TchRebindBoard__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_user_TchRebindBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_user_TchRebindBoard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_disk_DiskIndex__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_disk_DiskIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_disk_DiskIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_kb_KbIndex__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_kb_KbIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_kb_KbIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_disk_DiskShareRecords__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_disk_DiskShareRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_disk_DiskShareRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_disk_DiskShare__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_disk_DiskShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_disk_DiskShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_teacher_TchTrainingList__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_teacher_TchTrainingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_teacher_TchTrainingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_teacher_TchRecruitTrainStat__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_teacher_TchRecruitTrainStat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_teacher_TchRecruitTrainStat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_teacher_recruit_TchRecruitDashboard__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_teacher_recruit_TchRecruitDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_teacher_recruit_TchRecruitDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_teacher_recruit_TchRecruitLeaderboard__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_teacher_recruit_TchRecruitLeaderboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_teacher_recruit_TchRecruitLeaderboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_teacher_recruit_TchPendingInterview__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_teacher_recruit_TchPendingInterview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_teacher_recruit_TchPendingInterview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_teacher_recruit_TchReservedList__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_teacher_recruit_TchReservedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_teacher_recruit_TchReservedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_teacher_TchRegChannelList__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_teacher_TchRegChannelList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_teacher_TchRegChannelList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_teacher_TchNormalList__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_teacher_TchNormalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_teacher_TchNormalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_teacher_TchUnauditedList__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_teacher_TchUnauditedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_teacher_TchUnauditedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_teacher_TchAuditList__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_teacher_TchAuditList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_teacher_TchAuditList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_teacher_TchFormalList__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_teacher_TchFormalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_teacher_TchFormalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_teacher_ForeignTchMatchCenter__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_teacher_ForeignTchMatchCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_teacher_ForeignTchMatchCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_teacher_TchResignFormalList__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_teacher_TchResignFormalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_teacher_TchResignFormalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_teacher_TchAnomalyList__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_teacher_TchAnomalyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_teacher_TchAnomalyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_teacher_TchFilipinoFormalList__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_teacher_TchFilipinoFormalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_teacher_TchFilipinoFormalList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_teacher_TchLeaveList__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_teacher_TchLeaveList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_teacher_TchLeaveList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_teacher_TchLeaveRateList__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_teacher_TchLeaveRateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_teacher_TchLeaveRateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_teacher_TchRiskWarningList__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_teacher_TchRiskWarningList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_teacher_TchRiskWarningList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_hrWorkbench_HrWorkbenchDashboard__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_hrWorkbench_HrWorkbenchDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_hrWorkbench_HrWorkbenchDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_hrWorkbench_HrWorkbenchProbation__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_hrWorkbench_HrWorkbenchProbation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_hrWorkbench_HrWorkbenchProbation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_hrWorkbench_HrWorkbenchReview__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_hrWorkbench_HrWorkbenchReview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_hrWorkbench_HrWorkbenchReview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_hrWorkbench_HrWorkbenchContract__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_hrWorkbench_HrWorkbenchContract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_hrWorkbench_HrWorkbenchContract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_hrWorkbench_HrWorkbenchFollowup__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_hrWorkbench_HrWorkbenchFollowup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_hrWorkbench_HrWorkbenchFollowup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_hrWorkbench_HrWorkbenchSupervise__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_hrWorkbench_HrWorkbenchSupervise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_hrWorkbench_HrWorkbenchSupervise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_smartHr_SmartHrRoster__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_smartHr_SmartHrRoster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_smartHr_SmartHrRoster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_smartHr_SmartHrOnboarding__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_smartHr_SmartHrOnboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_smartHr_SmartHrOnboarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_smartHr_SmartHrRegularization__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_smartHr_SmartHrRegularization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_smartHr_SmartHrRegularization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_smartHr_SmartHrTransfer__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_smartHr_SmartHrTransfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_smartHr_SmartHrTransfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_smartHr_SmartHrResignation__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_smartHr_SmartHrResignation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_smartHr_SmartHrResignation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_smartHr_SmartHrSafety__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_smartHr_SmartHrSafety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_smartHr_SmartHrSafety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_smartHr_SmartHrGrowth__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_smartHr_SmartHrGrowth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_smartHr_SmartHrGrowth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_smartHr_SmartHrContract__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_smartHr_SmartHrContract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_smartHr_SmartHrContract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_smartHr_SmartHrRetire__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_smartHr_SmartHrRetire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_smartHr_SmartHrRetire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_smartHr_SmartHrCare__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_smartHr_SmartHrCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_smartHr_SmartHrCare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_tchImpact_TchImpactOverview__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_tchImpact_TchImpactOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_tchImpact_TchImpactOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_tchImpact_TchImpactChange__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_tchImpact_TchImpactChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_tchImpact_TchImpactChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_tchImpact_TchImpactLeave__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_tchImpact_TchImpactLeave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_tchImpact_TchImpactLeave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_tchImpact_TchImpactStudent__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_tchImpact_TchImpactStudent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_tchImpact_TchImpactStudent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_tchImpact_TchImpactRisk__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_tchImpact_TchImpactRisk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_tchImpact_TchImpactRisk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_tchImpact_TchImpactModel__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_tchImpact_TchImpactModel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_tchImpact_TchImpactModel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_teacher_TchSignLogList__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_teacher_TchSignLogList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_teacher_TchSignLogList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_teacher_TchSignTimeList__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_teacher_TchSignTimeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_teacher_TchSignTimeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_lesson_BookLessonOpenedList__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_lesson_BookLessonOpenedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_lesson_BookLessonOpenedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_lesson_LiveMonitor__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_lesson_LiveMonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_lesson_LiveMonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_lesson_BookLessonTempList__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_lesson_BookLessonTempList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_lesson_BookLessonTempList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_lesson_BookLessonFinishedList__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_lesson_BookLessonFinishedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_lesson_BookLessonFinishedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_lesson_BookClassinList__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_lesson_BookClassinList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_lesson_BookClassinList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_lesson_ClassFeedback__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_lesson_ClassFeedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_lesson_ClassFeedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_teacher_TeacherManagerMessage__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_teacher_TeacherManagerMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_teacher_TeacherManagerMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_teacher_TchLearningMaterialList__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_teacher_TchLearningMaterialList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_teacher_TchLearningMaterialList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_teacher_TchOnboardingList__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_teacher_TchOnboardingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_teacher_TchOnboardingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_teacher_TchOnboardingManage__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_teacher_TchOnboardingManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_teacher_TchOnboardingManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_order_UserCredential__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_order_UserCredential___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_order_UserCredential__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_order_UserCredential2__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_order_UserCredential2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_order_UserCredential2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_teacher_BonusAndDeduction__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_teacher_BonusAndDeduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_teacher_BonusAndDeduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_teacher_TchRecommendList__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_teacher_TchRecommendList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_teacher_TchRecommendList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_teacher_ReferrerList__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_teacher_ReferrerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_teacher_ReferrerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_teacher_ReferrerFeeList__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_teacher_ReferrerFeeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_teacher_ReferrerFeeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_teacher_TchTrackList__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_teacher_TchTrackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_teacher_TchTrackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_teacher_TchWagesList__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_teacher_TchWagesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_teacher_TchWagesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_teacher_TchFeedbackList__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_teacher_TchFeedbackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_teacher_TchFeedbackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_teacher_TchPerformanceList__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_teacher_TchPerformanceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_teacher_TchPerformanceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_teacher_TchForeignManageData__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_teacher_TchForeignManageData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_teacher_TchForeignManageData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_teacher_TchTeacherRanking__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_teacher_TchTeacherRanking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_teacher_TchTeacherRanking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_teacher_TchHrMetricsDashboard__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_teacher_TchHrMetricsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_teacher_TchHrMetricsDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_teacher_TchFirstCheckList__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_teacher_TchFirstCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_teacher_TchFirstCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_teacher_TrialLessonRequirements__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_teacher_TrialLessonRequirements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_teacher_TrialLessonRequirements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_order_FundPackageList__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_order_FundPackageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_order_FundPackageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_order_PerformanceList__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_order_PerformanceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__components_order_PerformanceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_order_DragonTigerList__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_order_DragonTigerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__components_order_DragonTigerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_order_DragonTigerListV2__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_order_DragonTigerListV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__components_order_DragonTigerListV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_order_PerformanceDetail__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_order_PerformanceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__components_order_PerformanceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_order_StudyAdviserDragonTigerList__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_order_StudyAdviserDragonTigerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__components_order_StudyAdviserDragonTigerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_order_StudyAdviserPerformanceDetail__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_order_StudyAdviserPerformanceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__components_order_StudyAdviserPerformanceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_fund_FundUserBillList__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_fund_FundUserBillList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__components_fund_FundUserBillList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_financial_InvoiceList__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_financial_InvoiceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__components_financial_InvoiceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_financial_RefundList__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_financial_RefundList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__components_financial_RefundList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_financial_IncomeStatistics__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_financial_IncomeStatistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__components_financial_IncomeStatistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_financial_StudyAdviserRefundDashboard__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_financial_StudyAdviserRefundDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__components_financial_StudyAdviserRefundDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_admin_AdminUserList__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_admin_AdminUserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__components_admin_AdminUserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_admin_StudyDutyList__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_admin_StudyDutyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__components_admin_StudyDutyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_admin_LogList__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_admin_LogList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__components_admin_LogList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_admin_MessageTemplate__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_admin_MessageTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__components_admin_MessageTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_admin_MessageLog__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_admin_MessageLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__components_admin_MessageLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_admin_AdminGroupList__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_admin_AdminGroupList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__components_admin_AdminGroupList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_admin_AdminRuleList__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_admin_AdminRuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__components_admin_AdminRuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_admin_AdminConfigList__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_admin_AdminConfigList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__components_admin_AdminConfigList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_admin_AdminTConfigList__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_admin_AdminTConfigList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__components_admin_AdminTConfigList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_admin_SendSms__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_admin_SendSms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__components_admin_SendSms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_message_TrailLessonFailedReason__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_message_TrailLessonFailedReason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__components_message_TrailLessonFailedReason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_message_TrailLessonFeedBack__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_message_TrailLessonFeedBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__components_message_TrailLessonFeedBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_message_TrailLessonAbsentReason__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_message_TrailLessonAbsentReason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__components_message_TrailLessonAbsentReason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_data_StudyAdviserTrack__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_data_StudyAdviserTrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__components_data_StudyAdviserTrack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_data_ShowLessonCount__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_data_ShowLessonCount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__components_data_ShowLessonCount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_data_ShowAddLeaveNumDetail__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_data_ShowAddLeaveNumDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__components_data_ShowAddLeaveNumDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_data_ShowAddCourseDetail__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_data_ShowAddCourseDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__components_data_ShowAddCourseDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_data_ShowTotalLeaveDetail__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_data_ShowTotalLeaveDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__components_data_ShowTotalLeaveDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_data_TelDetails__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_data_TelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__components_data_TelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_data_AdviserData__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_data_AdviserData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__components_data_AdviserData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_data_ShowAssignDetail__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_data_ShowAssignDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__components_data_ShowAssignDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_data_ShowAdviserDataDetail__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_data_ShowAdviserDataDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__components_data_ShowAdviserDataDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_message_PersonMessage__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_message_PersonMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__components_message_PersonMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_data_detail_NegativeComment__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_data_detail_NegativeComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__components_data_detail_NegativeComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_data_detail_TchReviewDetail__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_data_detail_TchReviewDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__components_data_detail_TchReviewDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_data_detail_NewAssignDetail__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_data_detail_NewAssignDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__components_data_detail_NewAssignDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_data_detail_StudentAbsentDetail__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_data_detail_StudentAbsentDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__components_data_detail_StudentAbsentDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_data_detail_TchNoReviewDetail__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_data_detail_TchNoReviewDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__components_data_detail_TchNoReviewDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_data_detail_StudentEarlyDetail__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_data_detail_StudentEarlyDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__components_data_detail_StudentEarlyDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_data_detail_UserLeaveDetail__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_data_detail_UserLeaveDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__components_data_detail_UserLeaveDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_data_RenewDataList__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_data_RenewDataList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__components_data_RenewDataList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_data_FinishRenewalRateList__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_data_FinishRenewalRateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__components_data_FinishRenewalRateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_data_LessonExpendDailyList__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_data_LessonExpendDailyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__components_data_LessonExpendDailyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_data_StudentDailyList__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_data_StudentDailyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__components_data_StudentDailyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_data_StatisticsGatherList__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_data_StatisticsGatherList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__components_data_StatisticsGatherList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_data_SalesUtilizationList__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_data_SalesUtilizationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__components_data_SalesUtilizationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_data_StudentLifeCycle__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_data_StudentLifeCycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__components_data_StudentLifeCycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_data_StudyAdviserList__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_data_StudyAdviserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__components_data_StudyAdviserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_data_StudyAdviserConsumeList__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_data_StudyAdviserConsumeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__components_data_StudyAdviserConsumeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_data_FinanceDailyList__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_data_FinanceDailyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__components_data_FinanceDailyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_data_StudentContract__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_data_StudentContract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__components_data_StudentContract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_data_TchContract__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_data_TchContract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__components_data_TchContract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_emergency_TeacherPoolOriginal__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_emergency_TeacherPoolOriginal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__components_emergency_TeacherPoolOriginal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_activity_UserVideoList__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_activity_UserVideoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__components_activity_UserVideoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_safenessVote_UserVideoList__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_safenessVote_UserVideoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__components_safenessVote_UserVideoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_course_ClassinFolder__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_course_ClassinFolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__components_course_ClassinFolder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_course_ClassReview__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_course_ClassReview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__components_course_ClassReview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_course_LessonPreviewList__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_course_LessonPreviewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__components_course_LessonPreviewList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_course_LessonPreview__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_course_LessonPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__components_course_LessonPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_course_CoursePriceList__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_course_CoursePriceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__components_course_CoursePriceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_lesson_ReplaceRecord__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_lesson_ReplaceRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__components_lesson_ReplaceRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_user_BindTeacherOperationRecord__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_user_BindTeacherOperationRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__components_user_BindTeacherOperationRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_user_BindGroupLessonScan__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_user_BindGroupLessonScan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__components_user_BindGroupLessonScan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_user_BindGroupLevel__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_user_BindGroupLevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__components_user_BindGroupLevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_course_BookMaterialLessonsErr__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_course_BookMaterialLessonsErr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__components_course_BookMaterialLessonsErr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__components_course_LessonVideoList__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__components_course_LessonVideoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__components_course_LessonVideoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__components_course_LessonAudioList__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__components_course_LessonAudioList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__components_course_LessonAudioList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__components_question_AbilityList__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__components_question_AbilityList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__components_question_AbilityList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__components_question_TestLevelQuestionList__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__components_question_TestLevelQuestionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__components_question_TestLevelQuestionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__components_question_TemplateList__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__components_question_TemplateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__components_question_TemplateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__components_data_ContractVersion__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__components_data_ContractVersion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__components_data_ContractVersion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__components_teacher_TchComplaintList__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__components_teacher_TchComplaintList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__components_teacher_TchComplaintList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__components_teacher_TchAttendanceList__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__components_teacher_TchAttendanceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__components_teacher_TchAttendanceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__components_teacher_TchAttendanceDetailList__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__components_teacher_TchAttendanceDetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__components_teacher_TchAttendanceDetailList__);

























































































































































var TchOpenedExceptionList = function TchOpenedExceptionList(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(2027));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TchExceptionLogList = function TchExceptionLogList(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(2026));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};






















































































var TimetableList = function TimetableList(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(2009));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TimetableDetailList = function TimetableDetailList(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(2008));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var LevelGradeList = function LevelGradeList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2012));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AuditList = function AuditList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2010));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var BindUnfreezeAuditList = function BindUnfreezeAuditList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2011));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LevelQuestionList = function LevelQuestionList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2013));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LevelRecordList = function LevelRecordList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2014));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ReviewRecord = function ReviewRecord(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(2015));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var OpenClassList = function OpenClassList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(1998));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var BookLessonList = function BookLessonList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(1995));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LessonSubjectList = function LessonSubjectList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(1996));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MaterialLevelList = function MaterialLevelList(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(1997));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ClassInfoList = function ClassInfoList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2019));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SmsRecordList = function SmsRecordList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2023));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InternalMobileList = function InternalMobileList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2021));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var IpBlacklistList = function IpBlacklistList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2022));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var StudentTempLoginPassword = function StudentTempLoginPassword(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2024));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DiplomaticRiskList = function DiplomaticRiskList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2020));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TotalClassInfoList = function TotalClassInfoList(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(2025));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Index = function Index(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__(1994));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var TeacherPerformanceList = function TeacherPerformanceList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2006));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TeacherSalaryList = function TeacherSalaryList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2007));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ForeignTeacherDeductionSummary = function ForeignTeacherDeductionSummary(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(1999));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TeacherMonthlyCoreData = function TeacherMonthlyCoreData(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2005));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TeacherFilipinoSalaryList = function TeacherFilipinoSalaryList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2004));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TchClassList = function TchClassList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2000));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TchClassUsageList = function TchClassUsageList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2001));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TchNegativeList = function TchNegativeList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2002));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TchUsageList = function TchUsageList(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(2003));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SpeechVoiceList = function SpeechVoiceList(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(2018));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SpeechCompose = function SpeechCompose(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(2017));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SpeechClipList = function SpeechClipList(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(2016));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  redirect: { path: '/user/userPayList' }
}, {
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home___default.a,
  children: [{
    path: '/index',
    name: 'Index',
    component: Index
  }, {
    path: '/market/exChangeRecordListB',
    name: 'exChangeRecordListB',
    component: __WEBPACK_IMPORTED_MODULE_18__components_market_ExChangeRecordListB___default.a,
    meta: { title: '兑换课程审核列表' }
  }, {
    path: 'question/AbilityList',
    name: 'abilityList',
    component: __WEBPACK_IMPORTED_MODULE_214__components_question_AbilityList___default.a,
    meta: { title: '英语能力信息列表' }
  }, {
    path: 'question/TemplateList',
    name: 'templateList',
    meta: { title: '题目模板管理' },
    component: __WEBPACK_IMPORTED_MODULE_216__components_question_TemplateList___default.a
  }, {
    path: 'question/TestLevelQuestionList',
    name: 'testLevelQuestionList',
    meta: { title: '题目模板管理' },
    component: __WEBPACK_IMPORTED_MODULE_215__components_question_TestLevelQuestionList___default.a
  }, {
    path: 'data/salesUtilizationList',
    name: 'salesUtilizationList',
    meta: { title: '销售名单利用统计' },
    component: __WEBPACK_IMPORTED_MODULE_192__components_data_SalesUtilizationList___default.a
  }, {
    path: 'data/studentLifeCycle',
    name: 'studentLifeCycle',
    meta: { title: '学员生命周期' },
    component: __WEBPACK_IMPORTED_MODULE_193__components_data_StudentLifeCycle___default.a
  }, {
    path: 'data/studyAdviserList',
    name: 'studyAdviserList',
    meta: { title: '后端学导数据' },
    component: __WEBPACK_IMPORTED_MODULE_194__components_data_StudyAdviserList___default.a
  }, {
    path: 'data/studyAdviserConsumeList',
    name: 'studyAdviserConsumeList',
    meta: { title: '班主任课耗绩效' },
    component: __WEBPACK_IMPORTED_MODULE_195__components_data_StudyAdviserConsumeList___default.a
  }, {
    path: '/market/activityList',
    name: 'activityList',
    meta: { title: '活动列表' },
    component: __WEBPACK_IMPORTED_MODULE_14__components_market_ActivityList___default.a
  }, {
    path: '/market/channelManagement',
    name: 'channelManagement',
    meta: { title: '渠道管理' },
    component: __WEBPACK_IMPORTED_MODULE_15__components_market_ChannelManagement___default.a
  }, {
    path: '/market/ChannelDealRate',
    name: 'channelDealRate',
    meta: { title: '渠道成交率' },
    component: __WEBPACK_IMPORTED_MODULE_16__components_market_ChannelDealRate___default.a
  }, {
    path: '/market/ArticlePublishList',
    name: 'articlePublishList',
    meta: { title: '文章发布表' },
    component: __WEBPACK_IMPORTED_MODULE_19__components_market_ArticlePublishList___default.a
  }, {
    path: '/market/ChannelIncludeList',
    name: 'channelIncludeList',
    meta: { title: '发布渠道收录表' },
    component: __WEBPACK_IMPORTED_MODULE_20__components_market_ChannelIncludeList___default.a
  }, {
    path: '/market/AiChannelIncludeList',
    name: 'aiChannelIncludeList',
    meta: { title: 'AI渠道收录表' },
    component: __WEBPACK_IMPORTED_MODULE_21__components_market_AiChannelIncludeList___default.a
  }, {
    path: '/market/shareManagement',
    name: 'shareManagement',
    meta: { title: '分享有礼海报管理' },
    component: __WEBPACK_IMPORTED_MODULE_17__components_market_ShareManagement___default.a
  }, {
    path: '/agent/agentUserList',
    name: 'agentUserList',
    meta: { title: '代理用户' },
    component: __WEBPACK_IMPORTED_MODULE_22__components_agent_AgentUserList___default.a
  }, {
    path: '/agent/agentInviteList',
    name: 'agentInviteList',
    meta: { title: '推荐记录' },
    component: __WEBPACK_IMPORTED_MODULE_23__components_agent_AgentInviteList___default.a
  }, {
    path: '/crm/adviserPunchList',
    name: 'adviserPunchList',
    meta: { title: '打卡分单' },
    component: __WEBPACK_IMPORTED_MODULE_24__components_crm_AdviserPunchList___default.a
  }, {
    path: '/crm/dailyTransferList',
    name: 'dailyTransferList',
    meta: { title: '今日将转出名单' },
    component: __WEBPACK_IMPORTED_MODULE_26__components_crm_DailyTransferList___default.a
  }, {
    path: '/user/bookTestList',
    name: 'bookTestList',
    meta: { title: '体验名单' },
    component: __WEBPACK_IMPORTED_MODULE_36__components_user_BookTestList___default.a
  }, {
    path: '/user/userExperienceList',
    name: 'userExperienceList',
    meta: { title: '体验学生' },
    component: __WEBPACK_IMPORTED_MODULE_41__components_user_UserExperienceList___default.a
  }, {
    path: '/user/userPayList',
    name: 'userPayList',
    meta: { title: '常规学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_37__components_user_UserPayList___default.a
  }, {
    path: '/user/userTodayNewList',
    name: 'userTodayNewList',
    meta: { title: '新生分配' },
    component: __WEBPACK_IMPORTED_MODULE_37__components_user_UserPayList___default.a
  }, {
    path: '/user/newStudentService',
    name: 'newStudentService',
    meta: { title: '学情反馈' },
    component: __WEBPACK_IMPORTED_MODULE_38__components_user_NewStudentService___default.a
  }, {
    path: '/user/userPayDetail',
    name: 'userPayDetail',
    meta: { title: '学生信息详情' },
    component: __WEBPACK_IMPORTED_MODULE_39__components_user_UserPayDetail___default.a
  }, {
    path: '/user/userProvisionalList',
    name: 'userProvisionalList',
    meta: { title: '待分配学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_40__components_user_UserProvisionalList___default.a
  }, {
    path: '/user/userTrackList',
    name: 'userTrackList',
    meta: { title: '学员跟踪记录' },
    component: __WEBPACK_IMPORTED_MODULE_42__components_user_UserTrackList___default.a
  }, {
    path: '/user/studentRiskList',
    name: 'studentRiskList',
    meta: { title: '学员风险' },
    component: __WEBPACK_IMPORTED_MODULE_43__components_user_StudentRiskList___default.a
  }, {
    path: '/user/tchRebindBoard',
    name: 'tchRebindBoard',
    meta: { title: '异动老师看板' },
    component: __WEBPACK_IMPORTED_MODULE_73__components_user_TchRebindBoard___default.a
  }, {
    path: '/user/userTrackEdit',
    name: 'userTrackEdit',
    meta: { title: '添加学员跟踪记录' },
    component: __WEBPACK_IMPORTED_MODULE_44__components_user_UserTrackEdit___default.a
  }, {
    path: '/user/personUserTrackList',
    name: 'personUserTrackList',
    meta: { title: '学员服务记录' },
    component: __WEBPACK_IMPORTED_MODULE_53__components_user_PersonUserTrackList___default.a
  }, {
    path: '/user/parentCommunicationRecords',
    name: 'parentCommunicationRecords',
    meta: { title: '添加跟踪记录-家长沟通确认记录-学导' },
    component: __WEBPACK_IMPORTED_MODULE_45__components_user_ParentCommunicationRecords___default.a
  }, {
    path: '/user/parentCommunicationAdviserRecords',
    name: 'parentCommunicationAdviserRecords',
    meta: { title: '添加跟踪记录-家长沟通确认记录-课顾' },
    component: __WEBPACK_IMPORTED_MODULE_46__components_user_ParentCommunicationAdviserRecords___default.a
  }, {
    path: '/user/addOrderFailRecords',
    name: 'addOrderFailRecords',
    meta: { title: '添加跟踪记录-报名失败记录' },
    component: __WEBPACK_IMPORTED_MODULE_47__components_user_AddOrderFailRecords___default.a
  }, {
    path: '/user/addSendMaterialRecords',
    name: 'addSendMaterialRecords',
    meta: { title: '添加跟踪记录-教材配送记录' },
    component: __WEBPACK_IMPORTED_MODULE_48__components_user_AddSendMaterialRecords___default.a
  }, {
    path: '/user/bindingValidTimeFailRecords',
    name: 'bindingValidTimeFailRecords',
    meta: { title: '添加跟踪记录-绑定有效时间生效失败记录' },
    component: __WEBPACK_IMPORTED_MODULE_49__components_user_BindingValidTimeFailRecords___default.a
  }, {
    path: '/user/bookUserLeaveTimeList',
    name: 'bookUserLeaveTimeList',
    meta: { title: '学生请假列表' },
    component: __WEBPACK_IMPORTED_MODULE_50__components_user_BookUserLeaveTimeList___default.a
  }, {
    path: '/user/bookCourseChangeList',
    name: 'bookCourseChangeList',
    meta: { title: '补课时记录' },
    component: __WEBPACK_IMPORTED_MODULE_51__components_user_BookCourseChangeList___default.a
  }, {
    path: '/user/editStudentInfo',
    name: 'editStudentInfo',
    meta: { title: '添加跟踪记录-试听课成功预约提醒记录' },
    component: __WEBPACK_IMPORTED_MODULE_52__components_user_EditStudentInfo___default.a
  }, {
    path: '/user/activityExamineList',
    name: 'activityExamineList',
    meta: { title: '朋友圈分享审核列表' },
    component: __WEBPACK_IMPORTED_MODULE_54__components_user_ActivityExamineList___default.a
  }, {
    path: '/user/exchangeRecordList',
    name: 'exchangeRecordList',
    meta: { title: '兑换记录' },
    component: __WEBPACK_IMPORTED_MODULE_55__components_user_ExchangeRecordList___default.a
  }, {
    path: '/user/userRefundList',
    name: 'userRefundList',
    meta: { title: '退费学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_56__components_user_UserRefundList___default.a
  }, {
    path: '/user/userOverClassList',
    name: 'userOverClassList',
    meta: { title: '结课学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_58__components_user_UserOverClassList___default.a
  }, {
    path: '/user/userLessonsStopList',
    name: 'userLessonsStopList',
    meta: { title: '停课学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_59__components_user_UserLessonsStopList___default.a
  }, {
    path: '/user/userNotAllowedList',
    name: 'userNotAllowedList',
    meta: { title: '禁用学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_60__components_user_UserNotAllowedList___default.a
  }, {
    path: '/user/reviewClockRecordList',
    name: 'reviewClockRecordList',
    meta: { title: '打卡闯关记录' },
    component: __WEBPACK_IMPORTED_MODULE_61__components_user_ReviewClockRecordList___default.a
  }, {
    path: '/bookMaterialLessons/DailyStudy',
    name: 'DailyStudy',
    meta: { title: '每日作业' },
    component: __WEBPACK_IMPORTED_MODULE_62__components_user_DailyStudy___default.a
  }, {
    path: '/user/cancelLessonRecord',
    name: 'CancelLessonRecord',
    meta: { title: '取消课程记录' },
    component: __WEBPACK_IMPORTED_MODULE_63__components_user_CancelLessonRecord___default.a
  }, {
    path: '/user/userStatusAuditList',
    name: 'userStatusAuditList',
    meta: { title: '学生状态审核' },
    component: __WEBPACK_IMPORTED_MODULE_64__components_user_UserStatusAuditList___default.a
  }, {
    path: '/user/classHourFlow',
    name: 'classHourFlow',
    meta: { title: '课时流水' },
    component: __WEBPACK_IMPORTED_MODULE_65__components_user_ClassHourFlow___default.a
  }, {
    path: '/user/distributionStudyRecord',
    name: 'distributionStudyRecord',
    meta: { title: '分配学导记录' },
    component: __WEBPACK_IMPORTED_MODULE_66__components_user_DistributionStudyRecord___default.a
  }, {
    path: '/user/StudentWeekStatList',
    name: 'StudentWeekStatList',
    meta: { title: '周数据' },
    component: __WEBPACK_IMPORTED_MODULE_67__components_user_StudentWeekStatList___default.a
  }, {
    path: '/user/StudentMonthStatList',
    name: 'StudentMonthStatList',
    meta: { title: '月数据' },
    component: __WEBPACK_IMPORTED_MODULE_68__components_user_StudentMonthStatList___default.a
  }, {
    path: '/user/followUpList',
    name: 'followUpList',
    meta: { title: 'followUp记录' },
    component: __WEBPACK_IMPORTED_MODULE_57__components_user_FollowUpList___default.a
  }, {
    path: '/user/wordCardList',
    name: 'wordCardList',
    meta: { title: '单词卡' },
    component: __WEBPACK_IMPORTED_MODULE_69__components_user_WordCardList___default.a
  }, {
    path: '/speech/voice',
    name: 'speechVoice',
    meta: { title: '音色' },
    component: SpeechVoiceList
  }, {
    path: '/speech/compose',
    name: 'speechCompose',
    meta: { title: '合成' },
    component: SpeechCompose
  }, {
    path: '/speech/clip',
    name: 'speechClip',
    meta: { title: '成片' },
    component: SpeechClipList
  }, {
    path: '/user/sentenceCardList',
    name: 'sentenceCardList',
    meta: { title: '句子翻译' },
    component: __WEBPACK_IMPORTED_MODULE_70__components_user_SentenceCardList___default.a
  }, {
    path: '/user/studentWordbookList',
    name: 'studentWordbookList',
    meta: { title: '学生单词本' },
    component: __WEBPACK_IMPORTED_MODULE_71__components_user_StudentWordbookList___default.a
  }, {
    path: '/user/studentWordcardEvalList',
    name: 'studentWordcardEvalList',
    meta: { title: '跟读记录' },
    component: __WEBPACK_IMPORTED_MODULE_72__components_user_StudentWordcardEvalList___default.a
  }, {
    path: '/tch/trainingList',
    name: 'tchTrainingList',
    meta: { title: '培训中老师' },
    component: __WEBPACK_IMPORTED_MODULE_78__components_teacher_TchTrainingList___default.a
  }, {
    path: '/tch/recruitTrainStat',
    name: 'tchRecruitTrainStat',
    meta: { title: '招聘培训统计' },
    component: __WEBPACK_IMPORTED_MODULE_79__components_teacher_TchRecruitTrainStat___default.a
  }, {
    path: '/tch/recruit/dashboard',
    name: 'tchRecruitDashboard',
    meta: { title: '数据看板' },
    component: __WEBPACK_IMPORTED_MODULE_80__components_teacher_recruit_TchRecruitDashboard___default.a
  }, {
    path: '/tch/recruit/leaderboard',
    name: 'tchRecruitLeaderboard',
    meta: { title: '招聘龙虎榜' },
    component: __WEBPACK_IMPORTED_MODULE_81__components_teacher_recruit_TchRecruitLeaderboard___default.a
  }, {
    path: '/tch/recruit/pendingInterview',
    name: 'tchPendingInterview',
    meta: { title: '待面试老师' },
    component: __WEBPACK_IMPORTED_MODULE_82__components_teacher_recruit_TchPendingInterview___default.a
  }, {
    path: '/tch/recruit/reserved',
    name: 'tchReservedList',
    meta: { title: '储备老师' },
    component: __WEBPACK_IMPORTED_MODULE_83__components_teacher_recruit_TchReservedList___default.a
  }, {
    path: '/tch/regChannelList',
    name: 'tchRegChannelList',
    meta: { title: '注册渠道管理' },
    component: __WEBPACK_IMPORTED_MODULE_84__components_teacher_TchRegChannelList___default.a
  }, {
    path: '/tch/tchNormalList',
    name: 'tchNormalList',
    meta: { title: '在职老师' },
    component: __WEBPACK_IMPORTED_MODULE_85__components_teacher_TchNormalList___default.a
  }, {
    path: '/tch/tchUnauditedList',
    name: 'tchUnauditedList',
    meta: { title: '待审核老师' },
    component: __WEBPACK_IMPORTED_MODULE_86__components_teacher_TchUnauditedList___default.a
  }, {
    path: '/tch/tchAuditList',
    name: 'tchAuditList',
    meta: { title: '已审核老师' },
    component: __WEBPACK_IMPORTED_MODULE_87__components_teacher_TchAuditList___default.a
  }, {
    path: '/tch/tchFormalList',
    name: 'tchFormalList',
    meta: { title: '正式老师' },
    component: __WEBPACK_IMPORTED_MODULE_88__components_teacher_TchFormalList___default.a
  }, {
    path: '/tch/foreignTchMatchCenter',
    name: 'foreignTchMatchCenter',
    meta: { title: '外教对接中心' },
    component: __WEBPACK_IMPORTED_MODULE_89__components_teacher_ForeignTchMatchCenter___default.a
  }, {
    path: '/tch/filipino/tchFormalList',
    name: 'tchFilipinoFormalList',
    meta: { title: '正式老师(菲)' },
    component: __WEBPACK_IMPORTED_MODULE_92__components_teacher_TchFilipinoFormalList___default.a
  }, {
    path: '/tch/tchResignFormalList',
    name: 'tchResignFormalList',
    meta: { title: '离职外教' },
    component: __WEBPACK_IMPORTED_MODULE_90__components_teacher_TchResignFormalList___default.a
  }, {
    path: '/tch/tchAnomalyList',
    name: 'tchAnomalyList',
    meta: { title: '异动老师' },
    component: __WEBPACK_IMPORTED_MODULE_91__components_teacher_TchAnomalyList___default.a
  }, {
    path: '/tch/tchLeaveList',
    name: 'tchLeaveList',
    meta: { title: '老师请假列表' },
    component: __WEBPACK_IMPORTED_MODULE_93__components_teacher_TchLeaveList___default.a
  }, {
    path: '/tch/tchLeaveRateList',
    name: 'tchLeaveRateList',
    meta: { title: '在职老师请假率' },
    component: __WEBPACK_IMPORTED_MODULE_94__components_teacher_TchLeaveRateList___default.a
  }, {
    path: '/tch/tchRiskWarningList',
    name: 'tchRiskWarningList',
    meta: { title: '外教异动风险监测' },
    component: __WEBPACK_IMPORTED_MODULE_95__components_teacher_TchRiskWarningList___default.a
  }, {
    path: '/hrWorkbench/supervise',
    name: 'hrWorkbenchSupervise',
    meta: { title: '主管管理' },
    component: __WEBPACK_IMPORTED_MODULE_101__components_hrWorkbench_HrWorkbenchSupervise___default.a
  }, {
    path: '/hrWorkbench/dashboard',
    name: 'hrWorkbenchDashboard',
    meta: { title: '工作台' },
    component: __WEBPACK_IMPORTED_MODULE_96__components_hrWorkbench_HrWorkbenchDashboard___default.a
  }, {
    path: '/hrWorkbench/probation',
    name: 'hrWorkbenchProbation',
    meta: { title: '试用期到期提醒' },
    component: __WEBPACK_IMPORTED_MODULE_97__components_hrWorkbench_HrWorkbenchProbation___default.a
  }, {
    path: '/hrWorkbench/review',
    name: 'hrWorkbenchReview',
    meta: { title: '新外教跟进' },
    component: __WEBPACK_IMPORTED_MODULE_98__components_hrWorkbench_HrWorkbenchReview___default.a
  }, {
    path: '/hrWorkbench/contract',
    name: 'hrWorkbenchContract',
    meta: { title: '合同到期提醒' },
    component: __WEBPACK_IMPORTED_MODULE_99__components_hrWorkbench_HrWorkbenchContract___default.a
  }, {
    path: '/hrWorkbench/followup',
    name: 'hrWorkbenchFollowup',
    meta: { title: '出勤风险跟进' },
    component: __WEBPACK_IMPORTED_MODULE_100__components_hrWorkbench_HrWorkbenchFollowup___default.a
  }, {
    path: '/hrWorkbench/settings',
    name: 'hrWorkbenchSettings',
    meta: { title: '主管管理' },
    redirect: '/hrWorkbench/supervise'
  }, {
    path: '/smartHr/roster',
    name: 'smartHrRoster',
    meta: { title: '花名册' },
    component: __WEBPACK_IMPORTED_MODULE_102__components_smartHr_SmartHrRoster___default.a
  }, {
    path: '/smartHr/onboarding',
    name: 'smartHrOnboarding',
    meta: { title: '入职管理' },
    component: __WEBPACK_IMPORTED_MODULE_103__components_smartHr_SmartHrOnboarding___default.a
  }, {
    path: '/smartHr/regularization',
    name: 'smartHrRegularization',
    meta: { title: '转正管理' },
    component: __WEBPACK_IMPORTED_MODULE_104__components_smartHr_SmartHrRegularization___default.a
  }, {
    path: '/smartHr/transfer',
    name: 'smartHrTransfer',
    meta: { title: '异动管理' },
    component: __WEBPACK_IMPORTED_MODULE_105__components_smartHr_SmartHrTransfer___default.a
  }, {
    path: '/smartHr/resignation',
    name: 'smartHrResignation',
    meta: { title: '离职管理' },
    component: __WEBPACK_IMPORTED_MODULE_106__components_smartHr_SmartHrResignation___default.a
  }, {
    path: '/smartHr/safety',
    name: 'smartHrSafety',
    meta: { title: '用工安全' },
    component: __WEBPACK_IMPORTED_MODULE_107__components_smartHr_SmartHrSafety___default.a
  }, {
    path: '/smartHr/growth',
    name: 'smartHrGrowth',
    meta: { title: '新人成长' },
    component: __WEBPACK_IMPORTED_MODULE_108__components_smartHr_SmartHrGrowth___default.a
  }, {
    path: '/smartHr/contract',
    name: 'smartHrContract',
    meta: { title: '合同管理' },
    component: __WEBPACK_IMPORTED_MODULE_109__components_smartHr_SmartHrContract___default.a
  }, {
    path: '/smartHr/retire',
    name: 'smartHrRetire',
    meta: { title: '退休管理' },
    component: __WEBPACK_IMPORTED_MODULE_110__components_smartHr_SmartHrRetire___default.a
  }, {
    path: '/smartHr/care',
    name: 'smartHrCare',
    meta: { title: '员工关怀' },
    component: __WEBPACK_IMPORTED_MODULE_111__components_smartHr_SmartHrCare___default.a
  }, {
    path: '/tchImpact/overview',
    name: 'tchImpactOverview',
    meta: { title: '影响总览' },
    component: __WEBPACK_IMPORTED_MODULE_112__components_tchImpact_TchImpactOverview___default.a
  }, {
    path: '/tchImpact/change',
    name: 'tchImpactChange',
    meta: { title: '学生异动影响' },
    component: __WEBPACK_IMPORTED_MODULE_113__components_tchImpact_TchImpactChange___default.a
  }, {
    path: '/tchImpact/leave',
    name: 'tchImpactLeave',
    meta: { title: '请假/旷课影响' },
    component: __WEBPACK_IMPORTED_MODULE_114__components_tchImpact_TchImpactLeave___default.a
  }, {
    path: '/tchImpact/student',
    name: 'tchImpactStudent',
    meta: { title: '学生影响明细' },
    component: __WEBPACK_IMPORTED_MODULE_115__components_tchImpact_TchImpactStudent___default.a
  }, {
    path: '/tchImpact/risk',
    name: 'tchImpactRisk',
    meta: { title: '综合风险视图' },
    component: __WEBPACK_IMPORTED_MODULE_116__components_tchImpact_TchImpactRisk___default.a
  }, {
    path: '/tchImpact/model',
    name: 'tchImpactModel',
    meta: { title: '指标口径' },
    component: __WEBPACK_IMPORTED_MODULE_117__components_tchImpact_TchImpactModel___default.a
  }, {
    path: '/tch/tchSignLogList',
    name: 'tchSignLogList',
    meta: { title: '老师签到日志' },
    component: __WEBPACK_IMPORTED_MODULE_118__components_teacher_TchSignLogList___default.a
  }, {
    path: '/tch/tchSignTimeList',
    name: 'tchSignTimeList',
    meta: { title: '签到记录' },
    component: __WEBPACK_IMPORTED_MODULE_119__components_teacher_TchSignTimeList___default.a
  }, {
    path: '/tch/tchOpenedExceptionList',
    name: 'TchOpenedExceptionList',
    meta: { title: '上课异常列表' },
    component: TchOpenedExceptionList
  }, {
    path: '/tch/tchExceptionLogList',
    name: 'tchExceptionLogList',
    meta: { title: '异常操作日志' },
    component: TchExceptionLogList
  }, {
    path: '/tch/messageCenter',
    name: 'teacherManagerMessage',
    meta: { title: '外管消息' },
    component: __WEBPACK_IMPORTED_MODULE_126__components_teacher_TeacherManagerMessage___default.a
  }, {
    path: '/tch/learningMaterialList',
    name: 'tchLearningMaterialList',
    meta: { title: '外教中心展示资料' },
    component: __WEBPACK_IMPORTED_MODULE_127__components_teacher_TchLearningMaterialList___default.a
  }, {
    path: '/tch/onboardingChecklist',
    name: 'tchOnboardingChecklist',
    meta: { title: '外教开课Checklist' },
    component: __WEBPACK_IMPORTED_MODULE_128__components_teacher_TchOnboardingList___default.a
  }, {
    path: '/tch/onboardingManage',
    name: 'tchOnboardingManage',
    meta: { title: '开课Checklist管理' },
    component: __WEBPACK_IMPORTED_MODULE_129__components_teacher_TchOnboardingManage___default.a
  }, {
    path: '/tch/tchRecommendList',
    name: 'tchRecommendList',
    meta: { title: '老师推荐记录' },
    component: __WEBPACK_IMPORTED_MODULE_133__components_teacher_TchRecommendList___default.a
  }, {
    path: '/tch/referrerList',
    name: 'referrerList',
    meta: { title: '推荐官管理' },
    component: __WEBPACK_IMPORTED_MODULE_134__components_teacher_ReferrerList___default.a
  }, {
    path: '/tch/referrerFeeList',
    name: 'referrerFeeList',
    meta: { title: '被推荐人管理' },
    component: __WEBPACK_IMPORTED_MODULE_135__components_teacher_ReferrerFeeList___default.a
  }, {
    path: '/tch/tchComplaintList',
    name: 'tchComplaintList',
    meta: { title: '课堂投诉' },
    component: __WEBPACK_IMPORTED_MODULE_218__components_teacher_TchComplaintList___default.a
  }, {
    path: '/tch/tchAttendanceList',
    name: 'tchAttendanceList',
    meta: { title: '老师考勤' },
    component: __WEBPACK_IMPORTED_MODULE_219__components_teacher_TchAttendanceList___default.a
  }, {
    path: '/tch/tchAttendanceDetailList',
    name: 'tchAttendanceDetailList',
    meta: { title: '老师考勤明细' },
    component: __WEBPACK_IMPORTED_MODULE_220__components_teacher_TchAttendanceDetailList___default.a
  }, {
    path: '/tch/tchTrackList',
    name: 'tchTrackList',
    meta: { title: '老师跟踪记录' },
    component: __WEBPACK_IMPORTED_MODULE_136__components_teacher_TchTrackList___default.a
  }, {
    path: '/tch/tchWagesList',
    name: 'tchWagesList',
    meta: { title: '工资条管理' },
    component: __WEBPACK_IMPORTED_MODULE_137__components_teacher_TchWagesList___default.a
  }, {
    path: '/tch/tchFeedbackList',
    name: 'tchFeedbackList',
    meta: { title: '老师反馈列表' },
    component: __WEBPACK_IMPORTED_MODULE_138__components_teacher_TchFeedbackList___default.a
  }, {
    path: '/tch/tchPerformanceList',
    name: 'tchPerformanceList',
    meta: { title: '外管绩效' },
    component: __WEBPACK_IMPORTED_MODULE_139__components_teacher_TchPerformanceList___default.a
  }, {
    path: '/tch/tchForeignManageData',
    name: 'tchForeignManageData',
    meta: { title: '外管数据' },
    component: __WEBPACK_IMPORTED_MODULE_140__components_teacher_TchForeignManageData___default.a
  }, {
    path: '/tch/tchTeacherRanking',
    name: 'tchTeacherRanking',
    meta: { title: '优秀外教排行榜' },
    component: __WEBPACK_IMPORTED_MODULE_141__components_teacher_TchTeacherRanking___default.a
  }, {
    path: '/tch/tchHrMetricsDashboard',
    name: 'tchHrMetricsDashboard',
    meta: { title: '外教核心数据看板' },
    component: __WEBPACK_IMPORTED_MODULE_142__components_teacher_TchHrMetricsDashboard___default.a
  }, {
    path: '/tch/tchFirstCheckList',
    name: 'tchFirstCheckList',
    meta: { title: '外教首课签到' },
    component: __WEBPACK_IMPORTED_MODULE_143__components_teacher_TchFirstCheckList___default.a
  }, {
    path: '/tch/trialLessonRequirements',
    name: 'trialLessonRequirements',
    meta: { title: '体验课上课要求' },
    component: __WEBPACK_IMPORTED_MODULE_144__components_teacher_TrialLessonRequirements___default.a
  }, {
    path: '/lesson/timetableList',
    name: 'TimetableList',
    meta: { title: '色块排课表' },
    component: TimetableList
  }, {
    path: '/lesson/timetableDetailList',
    name: 'TimetableDetailList',
    meta: { title: '色块排课表-老师' },
    component: TimetableDetailList
  }, {
    path: '/lesson/bookLessonOpenedList',
    name: 'bookLessonOpenedList',
    meta: { title: '常规课程列表' },
    component: __WEBPACK_IMPORTED_MODULE_120__components_lesson_BookLessonOpenedList___default.a
  }, {
    path: '/lesson/classFeedback',
    name: 'classFeedback',
    meta: { title: '课堂反馈' },
    component: __WEBPACK_IMPORTED_MODULE_125__components_lesson_ClassFeedback___default.a
  }, {
    path: '/lesson/liveMonitor',
    name: 'liveMonitor',
    meta: { title: '实时监课' },
    component: __WEBPACK_IMPORTED_MODULE_121__components_lesson_LiveMonitor___default.a
  }, {
    path: '/lesson/bookLessonTempList',
    name: 'bookLessonTempList',
    meta: { title: '当天订课信息' },
    component: __WEBPACK_IMPORTED_MODULE_122__components_lesson_BookLessonTempList___default.a
  }, {
    path: '/lesson/bookLessonFinishedList',
    name: 'bookLessonFinishedList',
    meta: { title: '已结束课表' },
    component: __WEBPACK_IMPORTED_MODULE_123__components_lesson_BookLessonFinishedList___default.a
  }, {
    path: '/lesson/bookClassinList',
    name: 'bookClassinList',
    meta: { title: 'ClassIn临时账号' },
    component: __WEBPACK_IMPORTED_MODULE_124__components_lesson_BookClassinList___default.a
  }, {
    path: '/order/fundPackageList',
    name: 'fundPackageList',
    component: __WEBPACK_IMPORTED_MODULE_145__components_order_FundPackageList___default.a,
    meta: { title: '订单管理-订单列表' }
  }, {
    path: '/order/performanceList',
    name: 'performanceList',
    meta: { title: '业绩统计' },
    component: __WEBPACK_IMPORTED_MODULE_146__components_order_PerformanceList___default.a
  }, {
    path: '/order/dragonTigerList',
    name: 'dragonTigerList',
    meta: { title: '龙虎榜' },
    component: __WEBPACK_IMPORTED_MODULE_147__components_order_DragonTigerList___default.a
  }, {
    path: '/order/dragonTigerListV2',
    name: 'dragonTigerListV2',
    meta: { title: '龙虎榜' },
    component: __WEBPACK_IMPORTED_MODULE_148__components_order_DragonTigerListV2___default.a
  }, {
    path: '/order/performanceDetail',
    name: 'performanceDetail',
    meta: { title: '业绩详情' },
    component: __WEBPACK_IMPORTED_MODULE_149__components_order_PerformanceDetail___default.a
  }, {
    path: '/order/studyAdviserDragonTiger',
    name: 'studyAdviserDragonTiger',
    meta: { title: '班主任龙虎榜' },
    component: __WEBPACK_IMPORTED_MODULE_150__components_order_StudyAdviserDragonTigerList___default.a
  }, {
    path: '/order/studyAdviserPerformanceDetail',
    name: 'studyAdviserPerformanceDetail',
    meta: { title: '班主任业绩详情' },
    component: __WEBPACK_IMPORTED_MODULE_151__components_order_StudyAdviserPerformanceDetail___default.a
  }, {
    path: '/fund/fundUserBillList',
    name: 'fundUserBillList',
    meta: { title: '用户账单' },
    component: __WEBPACK_IMPORTED_MODULE_152__components_fund_FundUserBillList___default.a
  }, {
    path: '/mex/comp/questions',
    name: 'mexCompQuestionList',
    meta: { title: '综合题库' },
    component: __WEBPACK_IMPORTED_MODULE_3__components_mex_MexCompQuestionList___default.a
  }, {
    path: '/mex/speak/questions',
    name: 'mexSpeakQuestionList',
    meta: { title: '口语题库' },
    component: __WEBPACK_IMPORTED_MODULE_4__components_mex_MexSpeakQuestionList___default.a
  }, {
    path: '/mex/blueprints',
    name: 'mexBlueprintList',
    meta: { title: '蓝图' },
    component: __WEBPACK_IMPORTED_MODULE_5__components_mex_MexBlueprintList___default.a
  }, {
    path: '/mex/trial',
    name: 'mexTrialPaper',
    meta: { title: '试做试卷' },
    component: __WEBPACK_IMPORTED_MODULE_13__components_mex_MexTrialPaper___default.a
  }, {
    path: '/mex/sessions',
    name: 'mexSessionList',
    meta: { title: '场次记录' },
    component: __WEBPACK_IMPORTED_MODULE_6__components_mex_MexSessionList___default.a
  }, {
    path: '/mex/feedback',
    name: 'mexFeedbackList',
    meta: { title: '题目反馈' },
    component: __WEBPACK_IMPORTED_MODULE_9__components_mex_MexFeedbackList___default.a
  }, {
    path: '/mex/promotions',
    name: 'mexPromotionList',
    meta: { title: '升班建议' },
    component: __WEBPACK_IMPORTED_MODULE_7__components_mex_MexPromotionList___default.a
  }, {
    path: '/mex/advice',
    name: 'mexAdviceList',
    meta: { title: '学习建议' },
    component: __WEBPACK_IMPORTED_MODULE_8__components_mex_MexAdviceList___default.a
  }, {
    path: '/mex/stats',
    name: 'mexItemStatsList',
    meta: { title: '实测统计' },
    component: __WEBPACK_IMPORTED_MODULE_10__components_mex_MexItemStatsList___default.a
  }, {
    path: '/mex/cohorts',
    name: 'mexScoreCohortList',
    meta: { title: '同龄分群' },
    component: __WEBPACK_IMPORTED_MODULE_11__components_mex_MexScoreCohortList___default.a
  }, {
    path: '/mex/gray',
    name: 'mexGraySetting',
    meta: { title: '灰度设置' },
    component: __WEBPACK_IMPORTED_MODULE_12__components_mex_MexGraySetting___default.a
  }, {
    path: '/adminUser/adminUserList',
    name: 'adminUserList',
    meta: { title: '管理员列表' },
    component: __WEBPACK_IMPORTED_MODULE_157__components_admin_AdminUserList___default.a
  }, {
    path: '/adminUser/StudyDutyList',
    name: 'studyDutyList',
    meta: { title: '班主任值班表' },
    component: __WEBPACK_IMPORTED_MODULE_158__components_admin_StudyDutyList___default.a
  }, {
    path: '/adminUser/LogList',
    name: 'logList',
    meta: { title: '操作日志' },
    component: __WEBPACK_IMPORTED_MODULE_159__components_admin_LogList___default.a
  }, {
    path: '/adminUser/MessageTemplate',
    name: 'messageTemplate',
    meta: { title: '消息模板' },
    component: __WEBPACK_IMPORTED_MODULE_160__components_admin_MessageTemplate___default.a
  }, {
    path: '/adminUser/MessageLog',
    name: 'messageLog',
    meta: { title: '消息日志' },
    component: __WEBPACK_IMPORTED_MODULE_161__components_admin_MessageLog___default.a
  }, {
    path: '/adminGroup/adminGroupList',
    name: 'adminGroupList',
    meta: { title: '权限组管理' },
    component: __WEBPACK_IMPORTED_MODULE_162__components_admin_AdminGroupList___default.a
  }, {
    path: '/adminGroup/adminRuleList',
    name: 'adminRuleList',
    meta: { title: '权限菜单列表' },
    component: __WEBPACK_IMPORTED_MODULE_163__components_admin_AdminRuleList___default.a
  }, {
    path: '/admin/adminConfigList',
    name: 'adminConfigList',
    meta: { title: '新增父级类目' },
    component: __WEBPACK_IMPORTED_MODULE_164__components_admin_AdminConfigList___default.a
  }, {
    path: '/admin/adminTConfigList',
    name: 'adminTConfigList',
    meta: { title: '自动排课配置管理' },
    component: __WEBPACK_IMPORTED_MODULE_165__components_admin_AdminTConfigList___default.a
  }, {
    path: '/admin/sendSms',
    name: 'sendSms',
    meta: { title: '短信发送' },
    component: __WEBPACK_IMPORTED_MODULE_166__components_admin_SendSms___default.a
  }, {
    path: '/auditList',
    name: 'AuditList',
    meta: { title: '修改绑定审批' },
    component: AuditList
  }, {
    path: '/bindUnfreezeAuditList',
    name: 'BindUnfreezeAuditList',
    meta: { title: '修改绑定解冻' },
    component: BindUnfreezeAuditList
  }, {
    path: '/level/levelGradeList',
    name: 'LevelGradeList',
    meta: { title: '等级列表' },
    component: LevelGradeList
  }, {
    path: '/level/levelQuestionList',
    name: 'LevelQuestionList',
    meta: { title: '测试题列表' },
    component: LevelQuestionList
  }, {
    path: '/level/levelRecordList',
    name: 'LevelRecordList',
    meta: { title: '测试结果' },
    component: LevelRecordList
  }, {
    path: '/level/reviewRecore',
    name: 'ReviewRecord',
    meta: { title: '测试记录' },
    component: ReviewRecord
  }, {
    path: '/course/openClassList',
    name: 'OpenClassList',
    meta: { title: '公开课列表' },
    component: OpenClassList
  }, {
    path: '/course/bookLessonList',
    name: 'BookLessonList',
    meta: { title: '单节课列表' },
    component: BookLessonList
  }, {
    path: '/course/materialLevelList',
    name: 'MaterialLevelList',
    meta: { title: '等级列表' },
    component: MaterialLevelList
  }, {
    path: '/course/classinFolder',
    name: 'ClassinFolder',
    meta: { title: 'Classin文件目录' },
    component: __WEBPACK_IMPORTED_MODULE_202__components_course_ClassinFolder___default.a
  }, {
    path: '/course/coursePriceList',
    name: 'coursePriceList',
    meta: { title: '教材价格列表' },
    component: __WEBPACK_IMPORTED_MODULE_206__components_course_CoursePriceList___default.a
  }, {
    path: '/course/lessonPreviewList',
    name: 'lessonPreviewList',
    meta: { title: '课前预习' },
    component: __WEBPACK_IMPORTED_MODULE_204__components_course_LessonPreviewList___default.a
  }, {
    path: '/course/LessonVideoList',
    name: 'lessonVideoList',
    meta: { title: '课后视频' },
    component: __WEBPACK_IMPORTED_MODULE_212__components_course_LessonVideoList___default.a
  }, {
    path: '/course/LessonAudioList',
    name: 'lessonAudioList',
    meta: { title: '课程音频' },
    component: __WEBPACK_IMPORTED_MODULE_213__components_course_LessonAudioList___default.a
  }, {
    path: '/course/classReview',
    name: 'classReview',
    meta: { title: '课后习题' },
    component: __WEBPACK_IMPORTED_MODULE_203__components_course_ClassReview___default.a
  }, {
    path: '/course/lessonSubject',
    name: 'lessonSubject',
    meta: { title: '课前课后题目' },
    component: LessonSubjectList
  }, {
    path: '/course/BookMaterialLessonsErr',
    name: 'BookMaterialLessonsErr',
    meta: { title: '教材报错' },
    component: __WEBPACK_IMPORTED_MODULE_211__components_course_BookMaterialLessonsErr___default.a
  }, {
    path: '/support/totalClassInfoList',
    name: 'totalClassInfoList',
    meta: { title: '总课时充值对照' },
    component: TotalClassInfoList
  }, {
    path: '/support/classInfoList',
    name: 'classInfoList',
    meta: { title: '课程对照' },
    component: ClassInfoList
  }, {
    path: '/support/internalMobile',
    name: 'internalMobile',
    meta: { title: '内部手机号' },
    component: InternalMobileList
  }, {
    path: '/support/ipBlacklist',
    name: 'ipBlacklist',
    meta: { title: 'IP黑名单' },
    component: IpBlacklistList
  }, {
    path: '/support/studentTempLoginPassword',
    name: 'studentTempLoginPassword',
    meta: { title: '学生临时登录密码' },
    component: StudentTempLoginPassword
  }, {
    path: '/support/diplomaticRisk',
    name: 'diplomaticRisk',
    meta: { title: '外教风险地区' },
    component: DiplomaticRiskList
  }, {
    path: '/sms/recordList',
    name: 'smsRecordList',
    meta: { title: '短信电话记录' },
    component: SmsRecordList
  }, {
    path: '/data/tchClassList',
    name: 'tchClassList',
    meta: { title: '老师薪酬统计' },
    component: TchClassList
  }, {
    path: '/data/teacherPerformanceList',
    name: 'teacherPerformanceList',
    meta: { title: '老师绩效统计' },
    component: TeacherPerformanceList
  }, {
    path: '/data/teacherSalaryList',
    name: 'teacherSalaryList',
    meta: { title: '老师薪酬统计' },
    component: TeacherSalaryList
  }, {
    path: '/data/foreignTeacherDeductionSummary',
    name: 'foreignTeacherDeductionSummary',
    meta: { title: '外教课上课统计' },
    component: ForeignTeacherDeductionSummary
  }, {
    path: '/data/teacherMonthlyCoreData',
    name: 'teacherMonthlyCoreData',
    meta: { title: '外教月度核心数据' },
    component: TeacherMonthlyCoreData
  }, {
    path: '/data/filipino/teacherSalaryList',
    name: 'teacherFilipinoSalaryList',
    meta: { title: '老师薪酬统计(菲)' },
    component: TeacherFilipinoSalaryList
  }, {
    path: '/data/tchNegativeList',
    name: 'tchNegativeList',
    meta: { title: '老师投诉列表' },
    component: TchNegativeList
  }, {
    path: '/data/showAdviserDataDetail',
    name: 'showAdviserDataDetail',
    meta: { title: '课顾汇总数据详情' },
    component: __WEBPACK_IMPORTED_MODULE_178__components_data_ShowAdviserDataDetail___default.a
  }, {
    path: '/data/tchClassUsageList',
    name: 'tchClassUsageList',
    meta: { title: '老师数据统计' },
    component: TchClassUsageList
  }, {
    path: '/data/tchUsageList',
    name: 'tchUsageList',
    meta: { title: '老师使用率' },
    component: TchUsageList
  }, {
    path: '/data/studyAdviserTrack',
    name: 'studyAdviserTrack',
    meta: { title: '学导跟进数据' },
    component: __WEBPACK_IMPORTED_MODULE_170__components_data_StudyAdviserTrack___default.a
  }, {
    path: '/data/showLessonCount',
    name: 'showLessonCount',
    meta: { title: '课程消耗数据' },
    component: __WEBPACK_IMPORTED_MODULE_171__components_data_ShowLessonCount___default.a
  }, {
    path: '/data/showAddLeaveNumDetail',
    name: 'showAddLeaveNumDetail',
    meta: { title: '学导申请请假记录' },
    component: __WEBPACK_IMPORTED_MODULE_172__components_data_ShowAddLeaveNumDetail___default.a
  }, {
    path: '/data/showAddCourseDetail',
    name: 'showAddCourseDetail',
    meta: { title: '学导申请加课时记录' },
    component: __WEBPACK_IMPORTED_MODULE_173__components_data_ShowAddCourseDetail___default.a
  }, {
    path: '/data/showAssignDetail',
    name: 'showAssignDetail',
    meta: { title: '分配名单详情' },
    component: __WEBPACK_IMPORTED_MODULE_177__components_data_ShowAssignDetail___default.a
  }, {
    path: '/data/showTotalLeaveDetail',
    name: 'showTotalLeaveDetail',
    meta: { title: '学生请假详情' },
    component: __WEBPACK_IMPORTED_MODULE_174__components_data_ShowTotalLeaveDetail___default.a
  }, {
    path: '/data/telDetails',
    name: 'telDetails',
    meta: { title: '电话沟通详情' },
    component: __WEBPACK_IMPORTED_MODULE_175__components_data_TelDetails___default.a
  }, {
    path: '/data/adviserData',
    name: 'adviserData',
    meta: { title: '课程顾问跟进数据' },
    component: __WEBPACK_IMPORTED_MODULE_176__components_data_AdviserData___default.a
  }, {
    path: '/data/negativeComment',
    name: 'negativeComment',
    meta: { title: '差评投诉列表' },
    component: __WEBPACK_IMPORTED_MODULE_180__components_data_detail_NegativeComment___default.a
  }, {
    path: '/data/tchReviewDetail',
    name: 'tchReviewDetail',
    meta: { title: '评价超时列表' },
    component: __WEBPACK_IMPORTED_MODULE_181__components_data_detail_TchReviewDetail___default.a
  }, {
    path: '/data/newAssignDetail',
    name: 'newAssignDetail',
    meta: { title: '新签学生列表' },
    component: __WEBPACK_IMPORTED_MODULE_182__components_data_detail_NewAssignDetail___default.a
  }, {
    path: '/data/studentEarlyDetail',
    name: 'studentEarlyDetail',
    meta: { title: '学生早退详情' },
    component: __WEBPACK_IMPORTED_MODULE_185__components_data_detail_StudentEarlyDetail___default.a
  }, {
    path: '/data/userLeaveDetail',
    name: 'userLeaveDetail',
    meta: { title: '学生常规请假详情' },
    component: __WEBPACK_IMPORTED_MODULE_186__components_data_detail_UserLeaveDetail___default.a
  }, {
    path: '/data/subsidyLeaveDetail',
    name: 'subsidyLeaveDetail',
    meta: { title: '两小时内常规课学生请假详情' },
    component: __WEBPACK_IMPORTED_MODULE_186__components_data_detail_UserLeaveDetail___default.a,
    props: { listUrl: '/bc/listSubsidyLeaveDetail' }
  }, {
    path: '/data/studentAbsentDetail',
    name: 'studentAbsentDetail',
    meta: { title: '上课异常列表' },
    component: __WEBPACK_IMPORTED_MODULE_183__components_data_detail_StudentAbsentDetail___default.a
  }, {
    path: '/data/tchNoReviewDetail',
    name: 'tchNoReviewDetail',
    meta: { title: '老师未评论列表' },
    component: __WEBPACK_IMPORTED_MODULE_184__components_data_detail_TchNoReviewDetail___default.a
  }, {
    path: '/data/RenewDataList',
    name: 'RenewDataList',
    meta: { title: '续费数据列表' },
    component: __WEBPACK_IMPORTED_MODULE_187__components_data_RenewDataList___default.a
  }, {
    path: '/activity/UserVideoList',
    name: 'UserVideoList',
    meta: { title: '学生作品管理' },
    component: __WEBPACK_IMPORTED_MODULE_200__components_activity_UserVideoList___default.a
  }, {
    path: '/safenessVote/UserVideoList',
    name: 'SafenessUserVideoList',
    meta: { title: '学生作品管理' },
    component: __WEBPACK_IMPORTED_MODULE_201__components_safenessVote_UserVideoList___default.a
  }, {
    path: '/emergency/teacherPool',
    name: 'TeacherPool',
    meta: { title: '应急外教池管理' },
    component: __WEBPACK_IMPORTED_MODULE_199__components_emergency_TeacherPoolOriginal___default.a
  }, {
    path: '/emergency/trialTeacherPool',
    name: 'TrialTeacherPool',
    meta: { title: '试听外教池' },
    component: __WEBPACK_IMPORTED_MODULE_199__components_emergency_TeacherPoolOriginal___default.a
  }, {
    path: '/message/personMessage',
    name: 'personMessage',
    meta: { title: '个人邮箱' },
    component: __WEBPACK_IMPORTED_MODULE_179__components_message_PersonMessage___default.a
  }, {
    path: '/message/trailLessonFailedReason',
    name: 'trailLessonFailedReason',
    meta: { title: '试听课预约失败记录' },
    component: __WEBPACK_IMPORTED_MODULE_167__components_message_TrailLessonFailedReason___default.a
  }, {
    path: '/message/trailLessonFeedBack',
    name: 'trailLessonFeedBack',
    meta: { title: '试听课后反馈记录' },
    component: __WEBPACK_IMPORTED_MODULE_168__components_message_TrailLessonFeedBack___default.a
  }, {
    path: '/message/trailLessonAbsentReason',
    name: 'trailLessonAbsentReason',
    meta: { title: '试听课预缺席记录' },
    component: __WEBPACK_IMPORTED_MODULE_169__components_message_TrailLessonAbsentReason___default.a
  }, {
    path: '/crm/MyResource',
    name: 'myResource',
    meta: { title: '个人资源' },
    component: __WEBPACK_IMPORTED_MODULE_25__components_crm_MyResource___default.a
  }, {
    path: '/crm/TreasuryResource',
    name: 'treasuryResource',
    meta: { title: '公共资源' },
    component: __WEBPACK_IMPORTED_MODULE_27__components_crm_TreasuryResource___default.a
  }, {
    path: '/crm/SpellGroupList',
    name: 'spellGroupList',
    meta: { title: '拼团记录' },
    component: __WEBPACK_IMPORTED_MODULE_31__components_crm_SpellGroupList___default.a
  }, {
    path: '/crm/DistributionList',
    name: 'distributionList',
    meta: { title: '分配记录' },
    component: __WEBPACK_IMPORTED_MODULE_28__components_crm_DistributionList___default.a
  }, {
    path: '/crm/SalesDealRate',
    name: 'salesDealRate',
    meta: { title: '销售成交率' },
    component: __WEBPACK_IMPORTED_MODULE_29__components_crm_SalesDealRate___default.a
  }, {
    path: '/crm/FirstFollowList',
    name: 'firstFollowList',
    meta: { title: '首次跟踪记录' },
    component: __WEBPACK_IMPORTED_MODULE_30__components_crm_FirstFollowList___default.a
  }, {
    path: '/crm/PhoneRecordList',
    name: 'phoneRecordList',
    meta: { title: '销售通话记录' },
    component: __WEBPACK_IMPORTED_MODULE_32__components_crm_PhoneRecordList___default.a
  }, {
    path: '/crm/DviAudioList',
    name: 'dviAudioList',
    meta: { title: '销售通话记录AI' },
    component: __WEBPACK_IMPORTED_MODULE_33__components_crm_DviAudioList___default.a
  }, {
    path: '/crm/CallAsrWord',
    name: 'callAsrWord',
    meta: { title: '通话转写词表' },
    component: __WEBPACK_IMPORTED_MODULE_34__components_crm_CallAsrWord___default.a
  }, {
    path: '/crm/CallScript',
    name: 'callScript',
    meta: { title: '销售话术库' },
    component: __WEBPACK_IMPORTED_MODULE_35__components_crm_CallScript___default.a
  }, {
    path: '/financial/InvoiceList',
    name: 'invoiceList',
    meta: { title: '应开发票' },
    component: __WEBPACK_IMPORTED_MODULE_153__components_financial_InvoiceList___default.a
  }, {
    path: '/financial/refundList',
    name: 'refundList',
    meta: { title: '退费列表' },
    component: __WEBPACK_IMPORTED_MODULE_154__components_financial_RefundList___default.a
  }, {
    path: '/financial/studyAdviserRefundDashboard',
    name: 'studyAdviserRefundDashboard',
    meta: { title: '班主任退费看板' },
    component: __WEBPACK_IMPORTED_MODULE_156__components_financial_StudyAdviserRefundDashboard___default.a
  }, {
    path: '/financial/IncomeStatistics',
    name: 'incomeStatistics',
    meta: { title: '收入统计' },
    component: __WEBPACK_IMPORTED_MODULE_155__components_financial_IncomeStatistics___default.a
  }, {
    path: '/tch/bonusAndDeductionList',
    name: 'BonusAndDeduction',
    meta: { title: '奖惩机制' },
    component: __WEBPACK_IMPORTED_MODULE_132__components_teacher_BonusAndDeduction___default.a
  }, {
    path: '/lesson/ReplaceRecord',
    name: 'replaceRecord',
    meta: { title: '老师替换课记录' },
    component: __WEBPACK_IMPORTED_MODULE_207__components_lesson_ReplaceRecord___default.a
  }, {
    path: '/user/BindTeacherOperationRecord',
    name: 'bindTeacherOperationRecord',
    meta: { title: '绑定老师记录' },
    component: __WEBPACK_IMPORTED_MODULE_208__components_user_BindTeacherOperationRecord___default.a
  }, {
    path: '/user/bindGroupLessonScan',
    name: 'bindGroupLessonScan',
    meta: { title: '绑定分组课件修复' },
    component: __WEBPACK_IMPORTED_MODULE_209__components_user_BindGroupLessonScan___default.a
  }, {
    path: '/user/bindGroupLevel',
    name: 'bindGroupLevel',
    meta: { title: '多级别绑定等级' },
    component: __WEBPACK_IMPORTED_MODULE_210__components_user_BindGroupLevel___default.a
  }, {
    path: '/data/lessonExpendDailyList',
    name: 'lessonExpendDailyList',
    meta: { title: '课程消耗日报列表' },
    component: __WEBPACK_IMPORTED_MODULE_189__components_data_LessonExpendDailyList___default.a
  }, {
    path: '/data/studentDailyList',
    name: 'studentDailyList',
    meta: { title: '学生量统计列表' },
    component: __WEBPACK_IMPORTED_MODULE_190__components_data_StudentDailyList___default.a
  }, {
    path: '/data/finishRenewalRateList',
    name: 'finishRenewalRateList',
    meta: { title: '常规生转化率列表' },
    component: __WEBPACK_IMPORTED_MODULE_188__components_data_FinishRenewalRateList___default.a
  }, {
    path: '/data/statisticsGatherList',
    name: 'statisticsGatherList',
    meta: { title: '数据汇总列表' },
    component: __WEBPACK_IMPORTED_MODULE_191__components_data_StatisticsGatherList___default.a
  }, {
    path: '/data/financeDaily',
    name: 'financeDailyList',
    meta: { title: '财务每日数据' },
    component: __WEBPACK_IMPORTED_MODULE_196__components_data_FinanceDailyList___default.a
  }, {
    path: '/student-contract',
    name: 'studentContract',
    meta: { title: '学生合同' },
    component: __WEBPACK_IMPORTED_MODULE_197__components_data_StudentContract___default.a
  }, {
    path: '/tch-contract',
    name: 'tchContract',
    meta: { title: '老师合同' },
    component: __WEBPACK_IMPORTED_MODULE_198__components_data_TchContract___default.a
  }, {
    path: '/data/contract-version',
    name: 'contractVersion',
    meta: { title: '合同模板' },
    component: __WEBPACK_IMPORTED_MODULE_217__components_data_ContractVersion___default.a
  }, {
    path: '/disk/index',
    name: 'diskIndex',
    meta: { title: '网盘' },
    component: __WEBPACK_IMPORTED_MODULE_74__components_disk_DiskIndex___default.a
  }, {
    path: '/disk/recycle',
    name: 'diskRecycle',
    meta: { title: '回收站' },
    component: __WEBPACK_IMPORTED_MODULE_74__components_disk_DiskIndex___default.a
  }, {
    path: '/disk/shares',
    name: 'diskShares',
    meta: { title: '分享记录' },
    component: __WEBPACK_IMPORTED_MODULE_76__components_disk_DiskShareRecords___default.a
  }, {
    path: '/kb/index',
    name: 'kbIndex',
    meta: { title: '库管理' },
    component: __WEBPACK_IMPORTED_MODULE_75__components_kb_KbIndex___default.a
  }]
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login___default.a
}, {
  path: '/loginSms',
  name: 'LoginSms',
  component: __WEBPACK_IMPORTED_MODULE_2__components_LoginSms___default.a
}, {
  path: '/disk/share',
  name: 'diskShare',
  meta: { title: '网盘分享' },
  component: __WEBPACK_IMPORTED_MODULE_77__components_disk_DiskShare___default.a
}, {
  path: '/order/userCredential2',
  name: 'userCredential2',
  meta: { title: '课程购买凭据' },
  component: __WEBPACK_IMPORTED_MODULE_131__components_order_UserCredential2___default.a
}, {
  path: '/order/userCredential',
  name: 'userCredential',
  meta: { title: '課程購買憑據' },
  component: __WEBPACK_IMPORTED_MODULE_130__components_order_UserCredential___default.a
}, {
  path: '/course/lessonPreview',
  name: 'lessonPreview',
  component: __WEBPACK_IMPORTED_MODULE_205__components_course_LessonPreview___default.a
}]);

/***/ }),
/* 443 */
/***/ (function(module, exports) {


(function () {
  var REPLACEABLE_SUFFIXES = ['kouyujie.cn', 'speakstreet.cn'];

  var TARGET_DOMAIN = 'ququkid.com';

  var SPECIAL_DOMAIN_MAP = {
    'hellokid.speakstreet.cn': 'student.ququkid.com'
  };

  var STATIC_MEDIA_DOMAINS = ['medias.kouyujie.cn', 'oss.kouyujie.cn', 'imgs.kouyujie.cn', 'imgs.speakstreet.cn'];

  function isQuqukidDomain() {
    try {
      return window.location.hostname.indexOf(TARGET_DOMAIN) !== -1;
    } catch (e) {
      return false;
    }
  }

  function extractHostname(url) {
    var match = url.match(/^https?:\/\/([^/:?#]+)/i);
    return match ? match[1] : null;
  }

  function getReplaceableSuffix(hostname) {
    if (hostname.indexOf(TARGET_DOMAIN) !== -1) {
      return null;
    }
    for (var i = 0; i < REPLACEABLE_SUFFIXES.length; i++) {
      if (hostname.indexOf(REPLACEABLE_SUFFIXES[i]) !== -1) {
        return REPLACEABLE_SUFFIXES[i];
      }
    }
    return null;
  }

  function replaceDomain(url) {
    if (!url || typeof url !== 'string') {
      return url;
    }

    if (!isQuqukidDomain()) {
      return url;
    }

    if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
      return url;
    }

    var hostname = extractHostname(url);
    if (!hostname) {
      return url;
    }

    for (var m = 0; m < STATIC_MEDIA_DOMAINS.length; m++) {
      if (hostname.indexOf(STATIC_MEDIA_DOMAINS[m]) !== -1) {
        return url;
      }
    }

    if (SPECIAL_DOMAIN_MAP[hostname]) {
      return url.replace(hostname, SPECIAL_DOMAIN_MAP[hostname]);
    }

    var suffix = getReplaceableSuffix(hostname);
    if (!suffix) {
      return url;
    }

    var suffixParts = suffix.split('.');
    var suffixLength = suffixParts.length;

    var parts = hostname.split('.');

    var targetParts = TARGET_DOMAIN.split('.');
    var newParts = parts.slice(0, parts.length - suffixLength).concat(targetParts);
    var newHostname = newParts.join('.');

    return url.replace(hostname, newHostname);
  }

  function addReplaceableSuffix(suffix) {
    if (suffix && REPLACEABLE_SUFFIXES.indexOf(suffix) === -1) {
      REPLACEABLE_SUFFIXES.push(suffix);
    }
  }

  var domainHelper = {
    isQuqukidDomain: isQuqukidDomain,
    replaceDomain: replaceDomain,
    addReplaceableSuffix: addReplaceableSuffix
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = domainHelper;
  }

  window.$domainHelper = domainHelper;
})();

/***/ }),
/* 444 */,
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1782),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1909),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1885),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1659),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1933),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b3dad696",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ccc6262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1876),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1925),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */,
/* 463 */,
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3f1558c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da949e06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.1","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.1","name":"axios","escapedName":"axios","rawSpec":"^0.21.1","saveSpec":null,"fetchSpec":"^0.21.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmmirror.com/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.1","_where":"/root/workspace/bops-vue_7hNi","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assist__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_emitter__ = __webpack_require__(210);





var prefixCls = 'ivu-checkbox-group';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CheckboxGroup',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_emitter__["a" /* default */]],
    props: {
        value: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        size: {
            validator: function validator(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["a" /* oneOf */])(value, ['small', 'large', 'default']);
            }
        }
    },
    data: function data() {
        return {
            currentValue: this.value,
            childrens: []
        };
    },

    computed: {
        classes: function classes() {
            return ['' + prefixCls, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'ivu-checkbox-' + this.size, !!this.size)];
        }
    },
    mounted: function mounted() {
        this.updateModel(true);
    },

    methods: {
        updateModel: function updateModel(update) {
            var value = this.value;
            this.childrens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["c" /* findComponentsDownward */])(this, 'Checkbox');

            if (this.childrens) {
                this.childrens.forEach(function (child) {
                    child.model = value;

                    if (update) {
                        child.currentValue = value.indexOf(child.label) >= 0;
                        child.group = true;
                    }
                });
            }
        },
        change: function change(data) {
            this.currentValue = data;
            this.$emit('input', data);
            this.$emit('on-change', data);
            this.dispatch('FormItem', 'on-form-change', data);
        }
    },
    watch: {
        value: function value() {
            this.updateModel(true);
        }
    }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assist__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_emitter__ = __webpack_require__(210);






var prefixCls = 'ivu-checkbox';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Checkbox',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_emitter__["a" /* default */]],
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number, Boolean],
            default: false
        },
        trueValue: {
            type: [String, Number, Boolean],
            default: true
        },
        falseValue: {
            type: [String, Number, Boolean],
            default: false
        },
        label: {
            type: [String, Number, Boolean]
        },
        indeterminate: {
            type: Boolean,
            default: false
        },
        size: {
            validator: function validator(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["a" /* oneOf */])(value, ['small', 'large', 'default']);
            }
        },
        name: {
            type: String
        }
    },
    data: function data() {
        return {
            model: [],
            currentValue: this.value,
            group: false,
            showSlot: true,
            parent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["b" /* findComponentUpward */])(this, 'CheckboxGroup')
        };
    },

    computed: {
        wrapClasses: function wrapClasses() {
            var _ref;

            return [prefixCls + '-wrapper', (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-group-item', this.group), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-wrapper-checked', this.currentValue), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-wrapper-disabled', this.disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.size, !!this.size), _ref)];
        },
        checkboxClasses: function checkboxClasses() {
            var _ref2;

            return ['' + prefixCls, (_ref2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, prefixCls + '-checked', this.currentValue), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, prefixCls + '-disabled', this.disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, prefixCls + '-indeterminate', this.indeterminate), _ref2)];
        },
        innerClasses: function innerClasses() {
            return prefixCls + '-inner';
        },
        inputClasses: function inputClasses() {
            return prefixCls + '-input';
        }
    },
    mounted: function mounted() {
        this.parent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["b" /* findComponentUpward */])(this, 'CheckboxGroup');
        if (this.parent) this.group = true;
        if (!this.group) {
            this.updateModel();
            this.showSlot = this.$slots.default !== undefined;
        } else {
            this.parent.updateModel(true);
        }
    },

    methods: {
        change: function change(event) {
            if (this.disabled) {
                return false;
            }

            var checked = event.target.checked;
            this.currentValue = checked;

            var value = checked ? this.trueValue : this.falseValue;
            this.$emit('input', value);

            if (this.group) {
                this.parent.change(this.model);
            } else {
                this.$emit('on-change', value);
                this.dispatch('FormItem', 'on-form-change', value);
            }
        },
        updateModel: function updateModel() {
            this.currentValue = this.value === this.trueValue;
        }
    },
    watch: {
        value: function value(val) {
            if (val !== this.trueValue && val !== this.falseValue) {
                throw 'Value should be trueValue or falseValue.';
            }
            this.updateModel();
        }
    }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assist__ = __webpack_require__(126);





var prefixCls = 'ivu-row';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Row',
    props: {
        type: {
            validator: function validator(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["a" /* oneOf */])(value, ['flex']);
            }
        },
        align: {
            validator: function validator(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["a" /* oneOf */])(value, ['top', 'middle', 'bottom']);
            }
        },
        justify: {
            validator: function validator(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["a" /* oneOf */])(value, ['start', 'end', 'center', 'space-around', 'space-between']);
            }
        },
        gutter: {
            type: Number,
            default: 0
        },
        className: String
    },
    computed: {
        classes: function classes() {
            var _ref;

            return [(_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, '' + prefixCls, !this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.type, !!this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.type + '-' + this.align, !!this.align), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.type + '-' + this.justify, !!this.justify), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, '' + this.className, !!this.className), _ref)];
        },
        styles: function styles() {
            var style = {};
            if (this.gutter !== 0) {
                style = {
                    marginLeft: this.gutter / -2 + 'px',
                    marginRight: this.gutter / -2 + 'px'
                };
            }

            return style;
        }
    },
    methods: {
        updateGutter: function updateGutter(val) {
            var Cols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assist__["c" /* findComponentsDownward */])(this, 'iCol');
            if (Cols.length) {
                Cols.forEach(function (child) {
                    if (val !== 0) {
                        child.gutter = val;
                    }
                });
            }
        }
    },
    watch: {
        gutter: function gutter(val) {
            this.updateGutter(val);
        }
    }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {},

  watch: {
    '$route': function $route(to, from) {
      to.meta.refer = from;
      this.$logger.debug('\u8DEF\u7531\u8DF3\u8F6Cfrom: ' + from.path + ' to: ' + to.path);
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CommonHeader_vue__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CommonHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layout_CommonHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CommonMain_vue__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CommonMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_CommonMain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_CommonFooter_vue__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_CommonFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_CommonFooter_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CommonHeader: __WEBPACK_IMPORTED_MODULE_0__layout_CommonHeader_vue___default.a,
    CommonMain: __WEBPACK_IMPORTED_MODULE_1__layout_CommonMain_vue___default.a,
    CommonFooter: __WEBPACK_IMPORTED_MODULE_2__layout_CommonFooter_vue___default.a
  },
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {}
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.height = window.innerHeight + 'px';
    this.resizeHandler = function () {
      _this.height = window.innerHeight + 'px';
    };
    window.addEventListener('resize', this.resizeHandler);
    this.ensureMobileViewport();

    if (this.$route.query.backUrl) {
      this.backUrl = this.$route.query.backUrl;
    }
    var search = new URLSearchParams(window.location.search);
    var authCode = this.$route.query.authCode || this.$route.query.code || search.get('authCode') || search.get('code');
    var state = this.$route.query.state || search.get('state') || '';
    if (authCode && this.inDingTalk()) {
      this.dingtalkHanded = true;
      this.dingtalkHandedText = '正在确认授权…';
      this.dingtalkLogin(authCode, state);
      return;
    }
    if (authCode) {
      this.view = 'admin';
      this.dingtalkLogin(authCode, state);
      return;
    }
    var pending = window.sessionStorage.getItem('ding_login_state');
    if (pending && this.isMobile() && !this.inDingTalk()) {
      this.view = 'admin';
      this.dingtalkWaiting = true;
      this.dingtalkLoginLoading = true;
      this.startDingPoll(pending);
    }
  },
  data: function data() {
    return {
      view: 'select',
      backUrl: '/',
      height: '1200px',
      loginForm: {
        mobile: '',
        password: '',
        remember: false
      },
      ruleValidate: {
        mobile: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      dingtalkLoginUrl: '',
      dingtalkLoginLoading: false,
      dingtalkWaiting: false,
      dingtalkHanded: false,
      dingtalkHandedText: '授权成功，请返回浏览器。登录会在原来的页面完成。',
      chooseAccounts: [],
      choosePickToken: '',
      chooseLoading: false,
      dingPollTimer: null,
      resizeHandler: null,
      loginViewportAdded: false,
      prevViewport: ''
    };
  },

  computed: {
    welcomeText: function welcomeText() {
      if (window.location.hostname.indexOf('ququkid.com') > -1) {
        return '欢迎使用趣趣ABC管理系统';
      }
      return '欢迎使用HelloKid学员管理系统';
    }
  },
  methods: {
    enterAdmin: function enterAdmin() {
      var self = this;
      self.view = 'admin';
      self.$nextTick(function () {
        self.loadQrCode();
      });
    },
    enterAgent: function enterAgent() {
      this.view = 'agent';
    },
    backToSelect: function backToSelect() {
      this.view = 'select';
    },
    submit: function submit() {
      var self = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          self.$http.post('/adminUser/doLogin', self.loginForm).then(function (res) {
            if (res && res.data) {
              self.$store.set('mobile', res.data.mobile);
              self.$store.set('_account', res.data.account);
              self.$router.push('/LoginSms');
            }
          });
        }
      });
    },
    redirectUri: function redirectUri() {
      return window.location.origin;
    },
    qrSize: function qrSize() {
      var width = window.innerWidth || 360;
      if (width < 480) {
        return Math.max(200, Math.min(260, width - 72));
      }
      return 280;
    },
    ensureMobileViewport: function ensureMobileViewport() {
      var meta = document.querySelector('meta[name="viewport"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        meta.setAttribute('data-login-viewport', '1');
        document.head.appendChild(meta);
        this.loginViewportAdded = true;
      }
      this.prevViewport = meta.getAttribute('content');
      meta.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');
    },
    restoreViewport: function restoreViewport() {
      var meta = document.querySelector('meta[name="viewport"]');
      if (!meta) {
        return;
      }
      if (this.loginViewportAdded) {
        meta.parentNode.removeChild(meta);
        return;
      }
      if (this.prevViewport) {
        meta.setAttribute('content', this.prevViewport);
      }
    },
    loadLoginUrl: function loadLoginUrl(callback) {
      var self = this;
      if (self.dingtalkLoginUrl) {
        callback(self.dingtalkLoginUrl);
        return;
      }
      self.$http.get('/adminUser/dingtalk-login-link', { params: { redirectUri: self.redirectUri() } }).then(function (res) {
        if (res && res.data) {
          self.dingtalkLoginUrl = res.data;
          callback(res.data);
        } else {
          callback('');
        }
      });
    },
    loadQrCode: function loadQrCode() {
      var self = this;
      self.loadLoginUrl(function (url) {
        if (!url || self.view !== 'admin') {
          return;
        }
        var clientId = '';
        try {
          clientId = new URL(url).searchParams.get('client_id');
        } catch (e) {
          clientId = '';
        }
        if (!clientId) {
          self.$Message.error('钉钉登录配置缺失');
          return;
        }
        self.ensureDingLoginScript(function () {
          if (self.view !== 'admin' || !document.getElementById('dingtalk-qr')) {
            return;
          }
          if (!window.DTFrameLogin) {
            self.$Message.error('钉钉扫码组件加载失败');
            return;
          }
          var qrSize = self.qrSize();
          window.DTFrameLogin({ id: 'dingtalk-qr', width: qrSize, height: qrSize }, {
            redirect_uri: encodeURIComponent(self.redirectUri()),
            client_id: clientId,
            scope: 'openid',
            response_type: 'code',
            state: 'bops',
            prompt: 'consent'
          }, function (loginResult) {
            var authCode = loginResult && (loginResult.authCode || loginResult.code);
            if (authCode) {
              self.dingtalkLogin(authCode);
            }
          }, function (errorMsg) {
            self.$Message.error(errorMsg || '钉钉扫码失败');
          });
        });
      });
    },
    ensureDingLoginScript: function ensureDingLoginScript(callback) {
      if (window.DTFrameLogin) {
        callback();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://g.alicdn.com/dingding/h5-dingtalk-login/0.21.0/ddlogin.js';
      script.onload = function () {
        callback();
      };
      script.onerror = function () {
        callback();
      };
      document.body.appendChild(script);
    },
    isMobile: function isMobile() {
      return (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
      );
    },
    inDingTalk: function inDingTalk() {
      return (/DingTalk/i.test(navigator.userAgent)
      );
    },
    randomState: function randomState() {
      var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      var out = '';
      for (var i = 0; i < 32; i++) {
        out += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return out;
    },
    dingtalkAuthLogin: function dingtalkAuthLogin() {
      var self = this;
      var popup = null;
      if (self.isMobile() && !self.inDingTalk()) {
        popup = window.open('about:blank', '_blank');
      }
      self.dingtalkLoginLoading = true;
      self.loadLoginUrl(function (url) {
        if (!url) {
          self.dingtalkLoginLoading = false;
          if (popup) {
            popup.close();
          }
          return;
        }
        if (!self.isMobile() || self.inDingTalk()) {
          if (popup) {
            popup.close();
          }
          window.location.href = url;
          return;
        }
        var state = self.randomState();
        window.sessionStorage.setItem('ding_login_state', state);
        var oauth = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'state=' + encodeURIComponent(state);
        self.dingtalkWaiting = true;
        self.startDingPoll(state);
        if (popup) {
          popup.location.href = oauth;
        } else {
          window.location.href = oauth;
        }
      });
    },
    startDingPoll: function startDingPoll(state) {
      var self = this;
      self.stopDingPoll();
      var n = 0;
      self.dingPollTimer = setInterval(function () {
        n++;
        if (n > 60) {
          self.stopDingPoll();
          self.dingtalkWaiting = false;
          self.dingtalkLoginLoading = false;
          window.sessionStorage.removeItem('ding_login_state');
          self.$Message.error('等待钉钉授权超时，请重试');
          return;
        }
        self.$http.get('/adminUser/dingtalk-login-poll', { params: { state: state } }).then(function (res) {
          if (!(res && res.status === 'ok' && res.data)) {
            return;
          }
          var data = res.data;
          if (data.error) {
            self.stopDingPoll();
            self.dingtalkWaiting = false;
            self.dingtalkLoginLoading = false;
            window.sessionStorage.removeItem('ding_login_state');
            self.$Message.error(data.error);
            return;
          }
          if (data.choose === true) {
            self.stopDingPoll();
            self.dingtalkWaiting = false;
            self.dingtalkLoginLoading = false;
            window.sessionStorage.removeItem('ding_login_state');
            self.showChoose(data);
            return;
          }
          if (data.token) {
            self.stopDingPoll();
            self.dingtalkWaiting = false;
            self.dingtalkLoginLoading = false;
            window.sessionStorage.removeItem('ding_login_state');
            self.finishLogin(data);
          }
        });
      }, 2000);
    },
    stopDingPoll: function stopDingPoll() {
      if (this.dingPollTimer) {
        clearInterval(this.dingPollTimer);
        this.dingPollTimer = null;
      }
    },
    dingtalkLogin: function dingtalkLogin(authCode, state) {
      var self = this;
      var insideDing = self.inDingTalk();
      self.$http.post('/adminUser/dingtalkScanLogin', {
        authCode: authCode,
        redirectUri: self.redirectUri(),
        state: insideDing ? state || '' : ''
      }).then(function (res) {
        if (!(res && res.data)) {
          if (insideDing) {
            self.dingtalkHandedText = '授权失败，请回到浏览器重试';
          }
          return;
        }
        if (insideDing && state) {
          self.dingtalkHanded = true;
          self.dingtalkHandedText = '授权成功，请返回浏览器。登录会在原来的页面完成。';
          if (window.location.search) {
            window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash);
          }
          return;
        }
        if (res.data.choose === true) {
          self.showChoose(res.data);
          return;
        }
        self.finishLogin(res.data);
      }, function () {
        if (insideDing) {
          self.dingtalkHandedText = '授权失败，请回到浏览器重试';
        }
      });
    },
    showChoose: function showChoose(data) {
      this.choosePickToken = data.pickToken || '';
      this.chooseAccounts = data.accounts || [];
    },
    chooseLogin: function chooseLogin(item) {
      var self = this;
      if (self.chooseLoading) {
        return;
      }
      if (!self.choosePickToken) {
        self.$Message.error('登录信息已失效，请重新钉钉登录');
        return;
      }
      self.chooseLoading = true;
      self.$http.post('/adminUser/dingtalkChooseLogin', {
        pickToken: self.choosePickToken,
        adminUserId: item.id
      }).then(function (res) {
        self.chooseLoading = false;
        if (res && res.status === 'ok' && res.data && res.data.token) {
          self.chooseAccounts = [];
          self.choosePickToken = '';
          self.finishLogin(res.data);
        }
      }, function () {
        self.chooseLoading = false;
      });
    },
    finishLogin: function finishLogin(data) {
      var self = this;
      self.$store.set('token', data.token);
      self.$store.set('mobile', data.account);
      self.$store.set('id', data.id);
      self.$store.set('permissions', data.permissions);
      self.$store.set('adminRule', data.adminRule);
      if (data.adviserInfo) {
        self.$store.set('adviserInfo', data.adviserInfo);
      }
      self.$Message.success('登录成功!');
      if (window.location.search) {
        window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash);
      }
      if (self.backUrl.indexOf('login') > -1) {
        self.$router.push('/');
      } else {
        self.$router.push(self.backUrl);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopDingPoll();
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    this.restoreViewport();
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.height = window.innerHeight + 'px';
    window.onresize = function () {
      _this.height = window.innerHeight + 'px';
    };

    if (this.$route.query.backUrl) {
      this.backUrl = this.$route.query.backUrl;
    }
  },
  data: function data() {
    return {
      backUrl: '/',
      height: '1200px',
      loginForm: {
        mobile: this.$store.get('mobile'),
        password: '',
        remember: false,
        code: ''
      },
      ruleValidate: {
        mobile: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
      },
      show: true,
      count: '',
      timer: null
    };
  },

  computed: {
    welcomeText: function welcomeText() {
      if (window.location.hostname.indexOf('ququkid.com') > -1) {
        return '欢迎使用趣趣ABC管理系统';
      }
      return '欢迎使用HelloKid学员管理系统';
    }
  },
  methods: {
    submit: function submit() {
      var self = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          var f = self.loginForm;
          f.phone = f.mobile;
          f.mobile = self.$store.get('_account');
          f.code = self.$store.get('_wechatCode');
          self.$http.post('/adminUser/doSmsLogin', f).then(function (res) {
            if (res && res.data) {
              self.$store.set('token', res.data.token);
              self.$store.set('mobile', res.data.account);
              self.$store.set('id', res.data.id);
              self.$store.set('depLeader', res.data.depLeader);
              self.$store.set('adminRule', res.data.adminRule);
              self.$store.set('permissions', res.data.permissions);
              if (res.data.adviserInfo) {
                self.$store.set('adviserInfo', res.data.adviserInfo);
              } else {
                self.$store.remove('adviserInfo');
              }
              if (self.loginForm.remember) {
                self.$store.set('password', res.data.password);
              }
              self.$Message.success('登录成功!');
              if (self.backUrl.indexOf('login') > -1) {
                self.$router.push('/');
              } else {
                self.$router.push(self.backUrl);
              }
            }
          });
        }
      });
    },
    getCode: function getCode() {
      var self = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          self.$http.post('/adminUser/getSmsCode', self.loginForm).then(function (res) {
            if (res && res.status === 'ok') {
              if (!self.timer) {
                self.count = 60;
                self.show = false;
                self.timer = setInterval(function () {
                  if (self.count > 0 && self.count <= 60) {
                    self.count--;
                  } else {
                    self.show = true;
                    clearInterval(self.timer);
                    self.timer = null;
                  }
                }, 1000);
              }
            } else {
              self.$Message.error(res.msg);
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AddUserVideoModal__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AddUserVideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_AddUserVideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_EditUserVideoModal__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_EditUserVideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_EditUserVideoModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserVideoList',
  components: { EditUserVideoModal: __WEBPACK_IMPORTED_MODULE_2__modal_EditUserVideoModal___default.a, AddUserVideoModal: __WEBPACK_IMPORTED_MODULE_1__modal_AddUserVideoModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      selectionOpenedIds: [],
      queryParam: {
        uid: null,
        title: '',
        userName: '',
        mobile: '',
        studyAdviserId: null,
        ageGroup: null,
        isUploadVideo: null,
        phase: null,
        period: null,
        auditStatus: null,
        hasPublicScore: null
      },
      itemId: null,
      showAddUserVideoModal: false,
      showEditUserVideoModal: false,
      title: [{
        type: 'selection',
        width: 40,
        align: 'center'
      }, {
        title: '排名',
        width: 70,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row._index + 1);
        }
      }, {
        title: '作品ID',
        width: 80,
        align: 'center',
        key: 'id'
      }, {
        title: '学生id/姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 125,
        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '作品名称',
        width: 230,
        align: 'center',
        key: 'title'
      }, {
        title: '作品封面',
        width: 100,
        align: 'center',
        key: 'videoPicUrl',
        render: function render(h, params) {
          var row = params.row;
          if (!row.videoPicUrl) {
            return h('span', '-');
          }
          return h('viewer', {
            style: { display: 'inline-block', verticalAlign: 'middle', height: '40px' }
          }, [h('img', {
            style: { width: '40px', height: '40px', objectFit: 'cover', cursor: 'pointer', verticalAlign: 'middle' },
            attrs: { src: _this.mediaUrl(row.videoPicUrl), alt: '作品封面', title: row.videoPicUrl }
          })]);
        }
      }, {
        title: '作品',
        width: 200,
        align: 'center',
        key: 'videoUrl',
        render: function render(h, params) {
          var row = params.row;
          if (row.videoUrl) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showVideo(row);
                } } }, row.videoUrl);
          } else {
            return h('span');
          }
        }
      }, {
        title: '分组',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var ageGroup = row.ageGroup;
          var typeEnum = $constant.getEnum($constant.userVideoType, ageGroup);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '周期',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var period = row.period;
          var periodEnum = $constant.getEnum($constant.userVideoPeriod, period);
          return h('span', periodEnum && periodEnum.text);
        }
      }, {
        title: '外教1打分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreTch != null ? row.scoreTch : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreTch != null ? String(row.scoreTch) : '')) {
                  row.scoreTch = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreTch', newValue ? Number(newValue) : null);
                  _this.updateAvgScoreTch(row);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreTch != null ? String(row.scoreTch) : '')) {
                  row.scoreTch = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreTch', value ? Number(value) : null);
                  _this.updateAvgScoreTch(row);
                }
              }
            }
          });
        }
      }, {
        title: '外教2打分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreTch2 != null ? row.scoreTch2 : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreTch2 != null ? String(row.scoreTch2) : '')) {
                  row.scoreTch2 = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreTch2', newValue ? Number(newValue) : null);
                  _this.updateAvgScoreTch(row);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreTch2 != null ? String(row.scoreTch2) : '')) {
                  row.scoreTch2 = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreTch2', value ? Number(value) : null);
                  _this.updateAvgScoreTch(row);
                }
              }
            }
          });
        }
      }, {
        title: '外教平均分',
        width: 120,
        align: 'center',
        key: 'avgScoreTch'
      }, {
        title: '热度数据分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreHot != null ? row.scoreHot : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreHot != null ? String(row.scoreHot) : '')) {
                  row.scoreHot = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreHot', newValue ? Number(newValue) : null);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreHot != null ? String(row.scoreHot) : '')) {
                  row.scoreHot = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreHot', value ? Number(value) : null);
                }
              }
            }
          });
        }
      }, {
        title: '共鸣收藏分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreCollect != null ? row.scoreCollect : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreCollect != null ? String(row.scoreCollect) : '')) {
                  row.scoreCollect = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreCollect', newValue ? Number(newValue) : null);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreCollect != null ? String(row.scoreCollect) : '')) {
                  row.scoreCollect = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreCollect', value ? Number(value) : null);
                }
              }
            }
          });
        }
      }, {
        title: '优质评论分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreComment != null ? row.scoreComment : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreComment != null ? String(row.scoreComment) : '')) {
                  row.scoreComment = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreComment', newValue ? Number(newValue) : null);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreComment != null ? String(row.scoreComment) : '')) {
                  row.scoreComment = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreComment', value ? Number(value) : null);
                }
              }
            }
          });
        }
      }, {
        title: '大众口碑分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scorePublic != null ? row.scorePublic : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scorePublic != null ? String(row.scorePublic) : '')) {
                  row.scorePublic = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scorePublic', newValue ? Number(newValue) : null);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scorePublic != null ? String(row.scorePublic) : '')) {
                  row.scorePublic = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scorePublic', value ? Number(value) : null);
                }
              }
            }
          });
        }
      }, {
        title: '综合得分',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.scoreAll != null ? row.scoreAll : '',
              placeholder: '-'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.scoreAll != null ? String(row.scoreAll) : '')) {
                  row.scoreAll = newValue ? Number(newValue) : null;
                  _this.updateUserVideo(row.id, 'scoreAll', newValue ? Number(newValue) : null);
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== (row.scoreAll != null ? String(row.scoreAll) : '')) {
                  row.scoreAll = value ? Number(value) : null;
                  _this.updateUserVideo(row.id, 'scoreAll', value ? Number(value) : null);
                }
              }
            }
          });
        }
      }, {
        title: '学导id/姓名',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserId === 0 ? '未分配' : row.studyAdviserId + '-' + row.studyAdviserName);
        }
      }, {
        title: '短视频链接',
        className: 'sv-plat-column',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var lines = _this.platformRows(params.row);
          if (!lines.length) return h('span', '-');
          return h('div', lines.map(function (item) {
            return _this.svLine(h, [h('Poptip', {
              props: {
                trigger: 'hover',
                transfer: true,
                placement: 'top',
                width: 360
              }
            }, [h('span', {
              style: { display: 'inline-block', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' }
            }, item.label + '：' + item.url), h('div', {
              slot: 'content',
              style: { maxWidth: '360px', whiteSpace: 'normal', wordBreak: 'break-all', textAlign: 'left' }
            }, item.label + '：' + item.url)])]);
          }));
        }
      }, {
        title: '原视频',
        className: 'sv-plat-column',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var lines = _this.platformRows(params.row);
          if (!lines.length) return h('span', '-');
          return h('div', lines.map(function (item) {
            var url = item.task && item.task.videoFileUrl;
            if (!url) return _this.svLine(h, item.label + '：-');
            return _this.svLine(h, [h('span', item.label + '：'), h('a', {
              attrs: { title: url },
              style: { display: 'inline-block', maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' },
              on: { click: function click() {
                  return _this.showSvFile(url);
                } }
            }, url)]);
          }));
        }
      }, {
        title: '短视频封面',
        className: 'sv-plat-column',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var lines = _this.platformRows(params.row);
          if (!lines.length) return h('span', '-');
          return h('div', lines.map(function (item) {
            var url = item.task && item.task.coverUrl;
            if (!url) return _this.svLine(h, item.label + '：-');
            return _this.svLine(h, [h('span', { style: { verticalAlign: 'top' } }, item.label + '：'), h('viewer', { style: { display: 'inline-block', verticalAlign: 'top', height: '32px' } }, [h('img', {
              style: { width: '28px', height: '28px', marginTop: '2px', objectFit: 'cover', cursor: 'pointer', verticalAlign: 'top' },
              attrs: { src: _this.mediaUrl(url), alt: '封面' }
            })])]);
          }));
        }
      }, {
        title: '短视频同步',
        className: 'sv-plat-column',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          var lines = _this.platformRows(params.row);
          if (!lines.length) return h('span', '-');
          var map = { pending: '待抓取', running: '抓取中', success: '成功', fail: '失败' };
          return h('div', lines.map(function (item) {
            if (!item.task) return _this.svLine(h, item.label + '：未抓取');
            var text = item.label + '：' + (map[item.task.status] || '-');
            if (item.task.status !== 'fail') return _this.svLine(h, text);
            return _this.svLine(h, [h('Tooltip', {
              props: {
                content: item.task.errorMsg || '',
                placement: 'top',
                transfer: true,
                maxWidth: 300,
                disabled: !item.task.errorMsg
              }
            }, [h('span', { style: { color: '#ed4014', cursor: item.task.errorMsg ? 'help' : 'default' } }, text)])]);
          }));
        }
      }, {
        title: '短视频作者',
        className: 'sv-plat-column',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var lines = _this.platformRows(params.row);
          if (!lines.length) return h('span', '-');
          return h('div', lines.map(function (item) {
            var text = item.label + '：' + (item.task && item.task.author || '-');
            return _this.svLine(h, [h('span', {
              attrs: { title: text },
              style: { display: 'inline-block', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' }
            }, text)]);
          }));
        }
      }, {
        title: '赞/藏/评',
        className: 'sv-plat-column',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var r = params.row;
          var lines = _this.platformRows(r);
          if (!lines.length) return h('span', '-');
          var rows = lines.map(function (item) {
            var t = item.task;
            if (!t) return _this.svLine(h, item.label + '：-');
            return _this.svLine(h, item.label + '：' + (t.likeCount || 0) + '/' + (t.collectCount || 0) + '/' + (t.commentCount || 0));
          });
          rows.push(_this.svLine(h, '合计：' + (r.svLikeCount || 0) + '/' + (r.svCollectCount || 0) + '/' + (r.svCommentCount || 0)));
          return h('div', rows);
        }
      }, {
        title: '修复标记',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          if (row.repairStatus === 1) {
            return h('Tag', { props: { color: 'green' } }, '已修复');
          }
          return h('span', '-');
        }
      }, {
        title: '审核状态',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var auditStatus = row.auditStatus;
          var auditStatusEnum = $constant.getEnum($constant.auditStatus, auditStatus);
          return h('span', auditStatusEnum && auditStatusEnum.text);
        }
      }, {
        title: '操作',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          var links = [];
          links.push(h('a', { on: { click: function click() {
                return self.onEdit(row);
              } } }, '编辑'));
          if (self.hasShortVideoUrl(row)) {
            links.push(h('span', ' | '));
            links.push(h('a', { on: { click: function click() {
                  return self.fetchShortVideo(row);
                } } }, '抓取'));
          }
          if (row.auditStatus === 1) {
            links.push(h('span', ' | '));
            links.push(h('a', { on: { click: function click() {
                  return self.auditVideo(row.id, 2);
                } } }, '不通过'));
          } else if (row.auditStatus === 2) {
            links.push(h('span', ' | '));
            links.push(h('a', { on: { click: function click() {
                  return self.auditVideo(row.id, 1);
                } } }, '通过'));
          } else {
            links.push(h('span', ' | '));
            links.push(h('a', { on: { click: function click() {
                  return self.auditVideo(row.id, 1);
                } } }, '通过'));
            links.push(h('span', ' | '));
            links.push(h('a', { on: { click: function click() {
                  return self.auditVideo(row.id, 2);
                } } }, '不通过'));
          }
          return h('span', links);
        }
      }]
    };
  },

  methods: {
    showIndex: function showIndex(videoPicUrl) {
      if (videoPicUrl) {
        window.open('http://medias.kouyujie.cn/' + videoPicUrl + '?' + Date.parse(new Date()));
      }
    },
    search: function search() {
      this.selectionOpenedIds = [];
      this.reload = new Date().getTime();
    },
    onAdd: function onAdd() {
      this.showAddUserVideoModal = true;
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    clearid: function clearid() {
      this.itemId = null;
    },
    onEdit: function onEdit(row) {
      this.showEditUserVideoModal = true;
      this.itemId = row.id;
    },
    hasShortVideoUrl: function hasShortVideoUrl(row) {
      return !!(row && (row.douyinUrl || row.xhsUrl || row.channelsUrl));
    },
    fetchShortVideo: function fetchShortVideo(row) {
      if (!row || !row.id) {
        this.$Message.warning('作品ID无效');
        return;
      }
      if (!this.hasShortVideoUrl(row)) {
        this.$Message.warning('请先编辑填写短视频链接');
        return;
      }
      var self = this;
      self.$http.post('/userVideo/shortVideo/fetch', { id: row.id }).then(function (res) {
        self.$Message.success(res.data && res.data.message ? res.data.message : '已提交');
        self.search();
      });
    },
    selectedChange: function selectedChange(selection) {
      this.selectionOpenedIds = selection;
    },
    showVideo: function showVideo(row) {
      var videoUrl = row.videoUrl;
      if (videoUrl) {
        window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()));
      }
    },
    showSvFile: function showSvFile(url) {
      if (!url) {
        return;
      }
      var playUrl = this.mediaUrl(url);
      var joiner = playUrl.indexOf('?') >= 0 ? '&' : '?';
      window.open(playUrl + joiner + Date.parse(new Date()));
    },
    platformRows: function platformRows(row) {
      var tasks = Array.isArray(row.svTasks) ? row.svTasks : [];
      return [{ platform: 'douyin', label: '抖音', url: row.douyinUrl }, { platform: 'xhs', label: '小红书', url: row.xhsUrl }, { platform: 'channels', label: '视频号', url: row.channelsUrl }].filter(function (item) {
        return item.url;
      }).map(function (item) {
        item.task = tasks.find(function (t) {
          return t.platform === item.platform;
        }) || null;
        return item;
      });
    },
    svLine: function svLine(h, children) {
      return h('div', {
        style: { height: '32px', lineHeight: '32px', overflow: 'hidden', whiteSpace: 'nowrap' }
      }, children);
    },
    mediaUrl: function mediaUrl(url) {
      if (!url) {
        return '';
      }
      if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
        return url;
      }
      return 'http://medias.kouyujie.cn/' + url;
    },
    auditVideo: function auditVideo(id, auditStatus) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: auditStatus === 1 ? '是否 <b>通过</b> 此作品？' : '是否 <b>不通过</b> 此作品？',
        width: 300,
        okText: auditStatus === 1 ? '确定通过' : '确定不通过',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/userVideo/check', { id: id, auditStatus: auditStatus }).then(function (resp) {
            self.search();
            self.$Message.success('操作成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    batchToNextRound: function batchToNextRound() {
      if (this.selectionOpenedIds.length <= 0) {
        this.$Message.warning('请选择需要取消的课程！');
        return;
      }
      var self = this;
      var ids = [];
      if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
        for (var i in this.selectionOpenedIds) {
          var dto = this.selectionOpenedIds[i];
          ids[i] = dto.id;
        }
      }
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认进入下一轮？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/userVideo/batchToNextRound', { videoIds: ids.join(',') }).then(function (res) {
            self.search();
            self.$Message.success('操作成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    updateUserVideo: function updateUserVideo(id, field, value) {
      this.$http.post('/userVideo/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ id: id }, field, value)).then(function (res) {
        if (res && res.data > 0) {
          this.$Message.success('更新成功');
        } else {
          this.$Message.error(res.msg);
        }
      }.bind(this));
    },
    updateAvgScoreTch: function updateAvgScoreTch(row) {
      var s1 = row.scoreTch;
      var s2 = row.scoreTch2;
      var avg = null;
      if (s1 != null && s2 != null) {
        avg = (Number(s1) + Number(s2)) / 2;
      } else if (s1 != null) {
        avg = Number(s1);
      } else if (s2 != null) {
        avg = Number(s2);
      }
      row.avgScoreTch = avg;
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/userVideo/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '学生作品列表.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddUserVideoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      userVideoParams: {
        uid: null,
        title: '',
        videoUrl: '',
        videoPicUrl: '',
        douyinUrl: '',
        xhsUrl: '',
        channelsUrl: '',
        ageGroup: null
      },
      userVideoRules: {
        title: [{ type: 'string', required: true, message: '请填写作品名称', trigger: 'blur' }],
        uid: [{ type: 'integer', required: true, message: '请填写学生ID', trigger: 'blur' }],
        ageGroup: [{ type: 'integer', required: true, message: '请选择类型', trigger: 'blur' }]
      },
      headers: {},
      videoFileList: [],
      videoPicFileList: [],
      videoUrl: '',
      videoPicUrl: '',
      loadingAddModal: false
    };
  },

  methods: {
    videoChange: function videoChange(file, fileList) {
      this.videoFileList = fileList.slice(-1);
    },
    videoSuccess: function videoSuccess(res, file, fileList) {
      this.userVideoParams.videoUrl = res.data.name;
      this.videoUrl = res.data.url;
    },
    videoPicChange: function videoPicChange(file, fileList) {
      this.videoPicFileList = fileList.slice(-1);
    },
    videoPicSuccess: function videoPicSuccess(res, file, fileList) {
      this.userVideoParams.videoPicUrl = res.data.name;
      this.videoPicUrl = res.data.url;
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    svUrlError: function svUrlError() {
      var p = this.userVideoParams;
      var hostIn = function hostIn(host, domain) {
        return host === domain || host.slice(-domain.length - 1) === '.' + domain;
      };
      var rules = [{ key: 'douyinUrl', name: '抖音', ok: function ok(host) {
          return ['douyin.com', 'v.douyin.com', 'iesdouyin.com'].some(function (d) {
            return hostIn(host, d);
          });
        } }, { key: 'xhsUrl', name: '小红书', ok: function ok(host) {
          return ['xiaohongshu.com', 'xhslink.com', 'xhslink.cn'].some(function (d) {
            return hostIn(host, d);
          });
        } }, { key: 'channelsUrl', name: '视频号', ok: function ok(host, path) {
          return hostIn(host, 'channels.weixin.qq.com') || hostIn(host, 'weixin.qq.com') && path.indexOf('sph') >= 0;
        } }];
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        var text = (p[r.key] || '').trim();
        if (!text) continue;
        if (text.length > 1024) return r.name + '链接过长';
        var m = /https?:\/\/([^/?#\s:]+)(?::\d+)?([^?#\s]*)/i.exec(text);
        if (!m || !r.ok(m[1].toLowerCase(), m[2] || '')) return r.name + '链接不是' + r.name + '地址';
      }
      return '';
    },
    addUserVideo: function addUserVideo() {
      var self = this;
      self.loadingAddModal = true;
      self.$refs.userVideoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddModal = false;
          return;
        }
        var video = (self.userVideoParams.videoUrl || '').trim();
        var p = self.userVideoParams;
        var link = ((p.douyinUrl || '') + (p.xhsUrl || '') + (p.channelsUrl || '')).trim();
        if (!video && !link) {
          self.$Message.warning('请上传学生作品或填写短视频链接');
          self.loadingAddModal = false;
          return;
        }
        var urlError = self.svUrlError();
        if (urlError) {
          self.$Message.warning(urlError);
          self.loadingAddModal = false;
          return;
        }
        self.$http.post('/userVideo/insert', self.userVideoParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
            self.loadingAddModal = false;
          } else {
            self.$Message.error(res.msg);
          }
        }).catch(function (e) {
          self.visible = false;
          self.loadingAddModal = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.userVideoParams = {};
        this.viceoFileList = [];
        this.videoPicFileList = [];
        this.$emit('on-close', false);
      }
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditUserVideoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    itemId: Number
  },
  data: function data() {
    return {
      visible: this.value,
      userVideoParams: {
        uid: null,
        title: '',
        videoUrl: '',
        videoPicUrl: '',
        douyinUrl: '',
        xhsUrl: '',
        channelsUrl: '',
        svSyncStatus: null,
        svAuthor: '',
        svLikeCount: 0,
        svCollectCount: 0,
        svCommentCount: 0,
        ageGroup: null,
        nickname: ''
      },
      svTasks: [],
      loadingFetch: false,
      userVideoRules: {
        title: [{ type: 'string', required: true, message: '请填写作品名称', trigger: 'blur' }],
        uid: [{ type: 'integer', required: true, message: '请填写学生ID', trigger: 'blur' }],
        ageGroup: [{ type: 'integer', required: true, message: '请选择类型', trigger: 'blur' }]
      },
      headers: {},
      videoFileList: [],
      videoPicFileList: [],
      videoUrl: '',
      videoPicUrl: '',
      loadingEditModal: false,
      formReady: false,
      localVideoDirty: false,
      localPicDirty: false
    };
  },

  computed: {
    syncStatusText: function syncStatusText() {
      var s = this.userVideoParams.svSyncStatus;
      var map = { 0: '无', 1: '抓取中', 2: '成功', 3: '失败' };
      return map[s] != null ? map[s] : '-';
    }
  },
  methods: {
    blankParams: function blankParams() {
      return {
        uid: null,
        title: '',
        videoUrl: '',
        videoPicUrl: '',
        douyinUrl: '',
        xhsUrl: '',
        channelsUrl: '',
        svSyncStatus: null,
        svAuthor: '',
        svLikeCount: 0,
        svCollectCount: 0,
        svCommentCount: 0,
        ageGroup: null,
        nickname: ''
      };
    },
    platformText: function platformText(platform) {
      var map = { douyin: '抖音', xhs: '小红书', channels: '视频号' };
      return map[platform] || platform;
    },
    mediaUrl: function mediaUrl(url) {
      if (!url) {
        return '';
      }
      if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
        return url;
      }
      return 'http://medias.kouyujie.cn/' + url;
    },
    taskStatusText: function taskStatusText(status) {
      var map = { pending: '待抓取', running: '抓取中', success: '成功', fail: '失败' };
      return map[status] || '-';
    },
    loadTasks: function loadTasks(id) {
      var self = this;
      self.$http.get('/userVideo/shortVideo/tasks?id=' + id).then(function (res) {
        if (self.userVideoParams.id !== id) {
          return;
        }
        self.svTasks = Array.isArray(res.data) ? res.data : [];
      });
    },
    svUrlError: function svUrlError() {
      var p = this.userVideoParams;
      var hostIn = function hostIn(host, domain) {
        return host === domain || host.slice(-domain.length - 1) === '.' + domain;
      };
      var rules = [{ key: 'douyinUrl', name: '抖音', ok: function ok(host) {
          return ['douyin.com', 'v.douyin.com', 'iesdouyin.com'].some(function (d) {
            return hostIn(host, d);
          });
        } }, { key: 'xhsUrl', name: '小红书', ok: function ok(host) {
          return ['xiaohongshu.com', 'xhslink.com', 'xhslink.cn'].some(function (d) {
            return hostIn(host, d);
          });
        } }, { key: 'channelsUrl', name: '视频号', ok: function ok(host, path) {
          return hostIn(host, 'channels.weixin.qq.com') || hostIn(host, 'weixin.qq.com') && path.indexOf('sph') >= 0;
        } }];
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        var text = (p[r.key] || '').trim();
        if (!text) continue;
        if (text.length > 1024) return r.name + '链接过长';
        var m = /https?:\/\/([^/?#\s:]+)(?::\d+)?([^?#\s]*)/i.exec(text);
        if (!m || !r.ok(m[1].toLowerCase(), m[2] || '')) return r.name + '链接不是' + r.name + '地址';
      }
      return '';
    },
    fileItem: function fileItem(key) {
      if (!key) {
        return [];
      }
      var name = String(key).split('/').pop();
      return [{ name: name, url: 'http://medias.kouyujie.cn/' + key, status: 'success', uid: name }];
    },
    videoChange: function videoChange(file, fileList) {
      if (file && file.raw) {
        this.videoFileList = fileList.slice(-1);
      }
    },
    videoSuccess: function videoSuccess(res, file, fileList) {
      this.$Message.destroy();
      if (!res || !res.data) {
        this.$Message.error(res && res.msg || '上传失败');
        return;
      }
      this.userVideoParams.videoUrl = res.data.name;
      this.videoUrl = res.data.url;
      this.localVideoDirty = true;
      this.videoFileList = this.fileItem(res.data.name);
    },
    videoExceed: function videoExceed(files) {
      var _this = this;

      if (!this.formReady || !files || !files[0]) {
        return;
      }
      this.videoFileList = [];
      this.$nextTick(function () {
        var up = _this.$refs.videoUpload;
        if (!up) return;
        up.handleStart(files[0]);
        up.submit();
      });
    },
    videoPicChange: function videoPicChange(file, fileList) {
      if (file && file.raw) {
        this.videoPicFileList = fileList.slice(-1);
      }
    },
    videoPicSuccess: function videoPicSuccess(res, file, fileList) {
      this.$Message.destroy();
      if (!res || !res.data) {
        this.$Message.error(res && res.msg || '上传失败');
        return;
      }
      this.userVideoParams.videoPicUrl = res.data.name;
      this.videoPicUrl = res.data.url;
      this.localPicDirty = true;
      this.videoPicFileList = this.fileItem(res.data.name);
    },
    videoPicExceed: function videoPicExceed(files) {
      var _this2 = this;

      if (!this.formReady || !files || !files[0]) {
        return;
      }
      this.videoPicFileList = [];
      this.$nextTick(function () {
        var up = _this2.$refs.videoPicUpload;
        if (!up) return;
        up.handleStart(files[0]);
        up.submit();
      });
    },
    beforeUpload: function beforeUpload(file) {
      if (!this.formReady) {
        return false;
      }
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleUploadError: function handleUploadError() {
      this.$Message.destroy();
      this.$Message.error('上传失败');
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    fetchShortVideo: function fetchShortVideo(platform) {
      var self = this;
      if (self.loadingFetch) {
        return;
      }
      if (!self.userVideoParams.id) {
        self.$Message.warning('作品ID无效');
        return;
      }
      var p = self.userVideoParams;
      if (platform) {
        if (!(p[platform + 'Url'] || '').trim()) {
          self.$Message.warning('请先填写' + self.platformText(platform) + '链接');
          return;
        }
      } else if (!((p.douyinUrl || '') + (p.xhsUrl || '') + (p.channelsUrl || '')).trim()) {
        self.$Message.warning('请先填写短视频链接');
        return;
      }
      var urlError = self.svUrlError();
      if (urlError) {
        self.$Message.warning(urlError);
        return;
      }
      var id = p.id;
      self.loadingFetch = true;

      self.$http.post('/userVideo/update', {
        id: id,
        douyinUrl: p.douyinUrl || '',
        xhsUrl: p.xhsUrl || '',
        channelsUrl: p.channelsUrl || ''
      }).then(function (res) {
        if (res.status !== 'ok') return res;
        var fetchParams = { id: id };
        if (platform) fetchParams.platform = platform;
        return self.$http.post('/userVideo/shortVideo/fetch', fetchParams);
      }).then(function (res) {
        self.loadingFetch = false;
        if (res.status !== 'ok') return;
        self.$Message.success(res.data && res.data.message ? res.data.message : '已提交');
        self.loadTasks(id);
        if (self.successCallback) self.successCallback();
      }).catch(function () {
        self.loadingFetch = false;
      });
    },
    editUserVideo: function editUserVideo() {
      var self = this;
      self.loadingEditModal = true;
      self.$refs.userVideoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEditModal = false;
          return;
        }
        var urlError = self.svUrlError();
        if (urlError) {
          self.$Message.warning(urlError);
          self.loadingEditModal = false;
          return;
        }
        var p = self.userVideoParams;
        self.$http.post('/userVideo/update', {
          id: p.id,
          uid: p.uid,
          title: p.title,
          ageGroup: p.ageGroup,
          videoUrl: p.videoUrl,
          videoPicUrl: p.videoPicUrl,
          douyinUrl: p.douyinUrl || '',
          xhsUrl: p.xhsUrl || '',
          channelsUrl: p.channelsUrl || ''
        }).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
            self.loadingEditModal = false;
          } else {
            self.$Message.error(res.msg);
            self.loadingEditModal = false;
          }
        }).catch(function (e) {
          self.visible = false;
          self.loadingEditModal = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this._editRequestId = null;
        this.userVideoParams = this.blankParams();
        this.svTasks = [];
        this.videoFileList = [];
        this.videoPicFileList = [];
        this.formReady = false;
        this.localVideoDirty = false;
        this.localPicDirty = false;
        this.$Message.destroy();
        this.$emit('on-close', false);
      }
    },
    itemId: function itemId(val) {
      if (val) {
        var self = this;
        var requestId = val;
        self._editRequestId = requestId;
        self.formReady = false;
        self.localVideoDirty = false;
        self.localPicDirty = false;
        self.$http.get('/userVideo/queryById?id=' + val).then(function (res) {
          if (self._editRequestId !== requestId) {
            return;
          }
          if (res.data) {
            var row = res.data;
            var keepVideo = self.localVideoDirty ? self.userVideoParams.videoUrl || '' : row.videoUrl || '';
            var keepPic = self.localPicDirty ? self.userVideoParams.videoPicUrl || '' : row.videoPicUrl || '';
            self.userVideoParams = {
              id: row.id,
              uid: row.uid,
              nickname: row.nickname || '',
              title: row.title || '',
              ageGroup: null,
              videoUrl: keepVideo,
              videoPicUrl: keepPic,
              douyinUrl: row.douyinUrl || '',
              xhsUrl: row.xhsUrl || '',
              channelsUrl: row.channelsUrl || '',
              svSyncStatus: row.svSyncStatus,
              svAuthor: row.svAuthor || '',
              svLikeCount: row.svLikeCount || 0,
              svCollectCount: row.svCollectCount || 0,
              svCommentCount: row.svCommentCount || 0
            };
            self.svTasks = [];
            self.loadTasks(row.id);
            if (!self.localVideoDirty) {
              self.videoFileList = self.fileItem(row.videoUrl);
            }
            if (!self.localPicDirty) {
              self.videoPicFileList = self.fileItem(row.videoPicUrl);
            }
            self.$nextTick(function () {
              if (self._editRequestId !== requestId) {
                return;
              }
              self.userVideoParams.ageGroup = row.ageGroup;
              self.formReady = true;
            });
          } else {
            self.formReady = true;
          }
          self.$emit('on-edit-clearid');
        }).catch(function () {
          if (self._editRequestId === requestId) {
            self.formReady = true;
          }
          self.$emit('on-edit-clearid');
        });
      }
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditItemModal_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditItemModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_EditItemModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EditItemModal: __WEBPACK_IMPORTED_MODULE_0__modal_EditItemModal_vue___default.a },
  props: {
    row: Object
  },
  data: function data() {
    return {
      itemId: null,
      itemList: [],
      editModal: false
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var self = this;
    var parent = localStorage.getItem('parentRow');
    self.$http.get('/adminConfig/getItemByParentId?parentId=' + parent).then(function (res) {
      if (res.data) {
        self.itemList = res.data;
      }
    });
  },
  methods: {
    editItem: function editItem(id) {
      var self = this;
      self.itemId = id;
      self.editModal = true;
    }
  },
  watch: {}
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminConfigExpand_vue__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminConfigExpand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AdminConfigExpand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_EditItemModal_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_EditItemModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_EditItemModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { expandRow: __WEBPACK_IMPORTED_MODULE_0__AdminConfigExpand_vue___default.a, EditItemModal: __WEBPACK_IMPORTED_MODULE_1__modal_EditItemModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      parentList: [],
      pid: null,
      formRule: {},
      loadingEdit: false,
      editModal: false,
      statusList: $constant.enabledStatus,
      itemList: [],
      itemId: null,
      formData: {
        id: null,
        pid: '',
        title: '',
        descr: '',
        state: '',
        itemType: ''
      },
      parentColumn: [{
        type: 'expand',
        width: 50,
        render: function render(h, params) {
          var row = params.row;
          localStorage.setItem('parentRow', row.id);
          return h(__WEBPACK_IMPORTED_MODULE_0__AdminConfigExpand_vue___default.a, {
            props: {
              row: row
            }
          });
        }
      }, {
        title: 'id',
        key: 'id',
        align: 'center'
      }, {
        title: '名称',
        key: 'title',
        align: 'center'
      }, {
        title: '展现类型',
        align: 'center',
        render: function render(h, params) {
          var itemType = params.row.itemType;
          var typeEnum = $constant.getEnum($constant.itemType, itemType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '状态',
        align: 'center',
        render: function render(h, params) {
          var status = params.row.state;
          var color = status === 0 ? 'red' : '';
          var statusEnum = $constant.getEnum($constant.enabledStatus, status);
          return h('span', { style: { color: color } }, statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('span', [h('a', { on: { click: function click() {
                return self.onEdit(row);
              } } }, '编辑'), h('span', ' | '), h('a', { on: { click: function click() {
                return self.addItem(row);
              } } }, '新增子类目')]);
        }
      }],
      parentData: []
    };
  },

  methods: {
    addParent: function addParent() {
      this.editModal = true;
    },
    getParent: function getParent() {
      var self = this;
      self.$http.get('/adminConfig/getParent').then(function (res) {
        self.parentData = res.data;
      });
    },
    editSuccess: function editSuccess() {
      this.searchLoading = true;
      this.pid = null;
      this.getParent();
      this.searchLoading = false;
    },
    clearid: function clearid() {
      this.itemId = null;
    },
    onEdit: function onEdit(row) {
      var self = this;
      self.editModal = false;
      self.itemId = row.id;
      self.editModal = true;
    },
    addItem: function addItem(row) {
      this.pid = row.id;
      this.editModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getParent();
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_kbApi__ = __webpack_require__(128);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var self = this;
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      statusList: $constant.enabledStatus,
      loadingEdit: false,
      editModal: false,
      checkKey: [],
      formData: {
        id: '',
        title: '',
        description: '',
        status: 1
      },
      formRule: {},
      editPermissionModal: false,
      kbBindModal: false,
      kbBindGroupId: null,
      kbBindIds: [],
      kbAllBases: [],
      kbBindSaving: false,
      kbBindPlaceholder: '请选择知识库',
      permissionData: [],
      departmentList: [],
      dingDeptReady: false,
      title: [{
        title: 'id',
        align: 'center',
        key: 'id'
      }, {
        title: '名称',
        align: 'center',
        key: 'title'
      }, {
        title: '描述',
        align: 'center',
        key: 'description'
      }, {
        title: '状态',
        key: 'status',
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var color = status === 0 ? 'red' : '';
          var statusEnum = $constant.getEnum($constant.enabledStatus, status);
          return h('div', { style: { color: color } }, statusEnum && statusEnum.text);
        }
      }, {
        title: '钉钉部门',
        align: 'center',
        width: 200,
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            style: { width: '160px' },
            props: {
              value: row.dingDeptId ? String(row.dingDeptId) : '',
              filterable: true,
              clearable: true,
              transfer: true,
              placeholder: '请选择'
            },
            on: {
              'on-change': function onChange(value) {
                if (!self.dingDeptReady) {
                  return;
                }
                var nextId = value === undefined || value === null ? '' : String(value);
                var current = row.dingDeptId ? String(row.dingDeptId) : '';
                if (nextId === current) {
                  return;
                }
                self.saveDingDept(row, nextId);
              }
            }
          }, (self.departmentList || []).map(function (item) {
            var deptId = item.departmentId == null ? '' : String(item.departmentId);
            return h('Option', { props: { value: deptId }, key: deptId }, item.departmentName);
          }));
        }
      }, {
        title: '钉钉部门 ID',
        align: 'center',
        width: 140,
        key: 'dingDeptId'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', {
            on: {
              click: function click() {
                self.onEdit(params.row);
              }
            }
          }, '编辑'), h('span', { class: 'divider' }), h('a', {
            on: {
              click: function click() {
                if (row.id === 1) {
                  self.$Message.warning('超级管理员，不允许编辑');
                  return;
                }
                self.onEditPermission(params.row);
              }
            }
          }, '权限'), h('span', { class: 'divider' }), h('a', {
            on: {
              click: function click() {
                self.onKbBind(params.row);
              }
            }
          }, '关联知识库')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    this.loadDingTalkGroup();
  },
  created: function created() {},
  methods: {
    onKbBind: function onKbBind(row) {
      var _this = this;

      this.kbBindGroupId = row.id;
      this.kbBindIds = [];
      this.kbAllBases = [];
      this.kbBindPlaceholder = '加载中…';
      this.kbBindModal = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].groupBinds, { groupId: row.id }).then(function (res) {
        _this.kbBindPlaceholder = '请选择知识库';
        if (res && res.status === 'ok' && res.data) {
          _this.kbAllBases = res.data.allBases || [];
          var binds = res.data.binds || [];
          _this.kbBindIds = binds.map(function (b) {
            return String(b.kbBaseId);
          });
          if (!_this.kbAllBases.length) {
            _this.kbBindPlaceholder = '请先在「知识库」菜单同步库';
          }
        }
      }).catch(function () {
        _this.kbBindPlaceholder = '加载失败';
      });
    },
    saveKbBind: function saveKbBind() {
      var _this2 = this;

      this.kbBindSaving = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].groupBind, {
        groupId: this.kbBindGroupId,
        kbBaseIds: (this.kbBindIds || []).join(',')
      }).then(function (res) {
        _this2.kbBindSaving = false;
        if (res && res.status === 'ok') {
          _this2.$Message.success('已保存关联');
          _this2.kbBindModal = false;
        }
      }).catch(function () {
        _this2.kbBindSaving = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    loadDingTalkGroup: function loadDingTalkGroup() {
      var self = this;
      self.$http.get('/dingTalk/departmentList').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.departmentList = res.data;
        setTimeout(function () {
          self.dingDeptReady = true;
          self.search();
        }, 0);
      });
    },
    saveDingDept: function saveDingDept(row, value) {
      var self = this;
      var dept = (self.departmentList || []).find(function (item) {
        return String(item.departmentId) === String(value);
      });
      var data = {
        id: row.id,
        dingDeptId: value ? String(value) : '',
        dingDeptName: value && dept ? dept.departmentName : ''
      };
      self.$http.post('/adminGroup/saveAdminGroup', data).then(function (res) {
        if (res && res.status === 'ok') {
          row.dingDeptId = data.dingDeptId;
          row.dingDeptName = data.dingDeptName;
          self.$Message.success('提交成功!');
          self.search();
        }
      });
    },
    delAll: function delAll() {
      this.$refs.dataList.delAll();
    },
    onEdit: function onEdit(row) {
      if (!row) {
        this.formData = {
          id: '',
          title: '',
          description: '',
          status: 1
        };
        this.editModal = true;
      }
      this.formData.id = row.id;
      this.formData.title = row.title;
      this.formData.status = row.status;
      this.formData.description = row.description;
      this.formData.superadmin = row.superadmin;
      this.editModal = true;
    },
    edit: function edit() {
      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/adminGroup/saveAdminGroup';
        self.$http.post(path, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.editModal = false;
            self.$Message.success('提交成功!');
            self.search();
          }
          self.loadingEdit = false;
        });
      });
    },
    editPermission: function editPermission() {
      var _this3 = this;

      var permissions = this.$refs.permissionTree.getCheckedNodes().map(function (item) {
        return item.id;
      }).join(',');

      this.loadingEdit = true;
      var path = '/adminGroup/saveAdminGroup';

      this.$http.post(path, { id: this.permissionGroupId, rules: permissions }).then(function (res) {
        if (res && res.data > 0) {
          _this3.editPermissionModal = false;
          _this3.$Message.success('提交成功!');
        }
        _this3.loadingEdit = false;
      });
    },
    onEditPermission: function onEditPermission(row) {
      var _this4 = this;

      this.checkKey = [];
      if (!row || !row.id) {
        return;
      }
      this.permissionGroupId = row.id;
      this.$http.get('/adminRule/queryAdminRuleDetailByParam', { params: { type: 'group', objectId: row.id } }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        _this4.permissionData = res.data.map(function (item) {
          return _this4.treeNode(item);
        });

        _this4.editPermissionModal = true;
      });
    },
    addCheckKeys: function addCheckKeys(permissionDto) {
      if (permissionDto) {
        if (permissionDto.havePermission) {
          this.checkKey.push(permissionDto.id);
        }
      }
    },
    treeNode: function treeNode(permissionDto) {
      var _this5 = this;

      if (!permissionDto) {
        return;
      }
      this.addCheckKeys(permissionDto);
      var treeNode = {
        id: permissionDto.id,
        label: permissionDto.title,
        expand: true,
        checked: permissionDto.havePermission,
        children: []
      };
      if (permissionDto.childAdminRuleDtoList) {
        treeNode.children = permissionDto.childAdminRuleDtoList.map(function (item) {
          return _this5.treeNode(item);
        });
      }

      return treeNode;
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var self = this;
    return {
      searchLoading: false,
      reload: 0,
      searchSubRules: [],
      queryParam: {
        pid: null,
        name: ''
      },
      pid: null,
      subPid: null,
      childId: null,
      parentRules: [],
      subRules: [],
      statusList: $constant.enabledStatus,
      adminRuleTypes: $constant.adminRuleType,
      loadingEdit: false,
      editModal: false,
      formData: {
        id: '',
        title: '',
        name: '',
        pid: '',
        type: '',
        status: 1,
        sort: 0
      },
      formRule: {},
      title: [{
        title: '名称',
        align: 'center',
        key: 'title'
      }, {
        title: 'URL',
        align: 'center',
        key: 'name'
      }, {
        title: '分类',
        align: 'center',
        key: 'pid'
      }, {
        title: '类型',
        key: 'type',
        align: 'center',
        render: function render(h, params) {
          var type = $constant.getEnum($constant.adminRuleType, params.row.type);
          return h('span', type && type.text);
        }
      }, {
        title: '状态',
        key: 'status',
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var color = status === 0 ? 'red' : '';
          var statusEnum = $constant.getEnum($constant.enabledStatus, status);
          return h('span', { style: { color: color } }, statusEnum && statusEnum.text);
        }
      }, {
        title: '排序',
        key: 'sort',
        align: 'center'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                self.onEdit(params.row);
              }
            }
          }, '编辑')]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.init();
  },
  computed: {},
  methods: {
    init: function init() {
      var _this = this;

      this.$http.get('/adminRule/list', { params: { pid: 0, pageIndex: 1, pageSize: 1000 } }).then(function (res) {
        if (res && res.data) {
          _this.parentRules = res.data.data;
        }
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    delAll: function delAll() {
      this.$refs.dataList.delAll();
    },
    onEdit: function onEdit(row) {
      var self = this;

      self.subPid = null;
      if (!row) {
        self.formData = {
          id: '',
          title: '',
          name: '',
          pid: '',
          type: '',
          status: 1,
          sort: 0
        };
        self.editModal = true;
        return;
      }
      self.formData.id = row.id;
      self.formData.title = row.title;
      self.formData.name = row.name;
      self.formData.pid = row.pid;
      self.formData.type = row.type;
      self.formData.status = row.status;
      self.formData.sort = row.sort;
      if (!row.pid || row.pid === 0) {
        self.editModal = true;
        return;
      }
      self.getParent(row.pid);
      self.editModal = true;
    },
    getParent: function getParent(pid) {
      var self = this;
      if (!pid || pid === 0) {
        self.pid = '';
        self.subPid = '';
        return;
      }

      self.$http.get('/adminRule/queryById', { params: { id: pid } }).then(function (res) {
        if (res && res.data) {
          if (res.data.pid === 0) {
            self.pid = pid;
            self.subPid = '';
          } else {
            self.pid = res.data.pid;
            self.subPid = pid;
          }
        }
      });
    },
    edit: function edit() {
      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/adminRule/saveAdminRule';
        self.$http.post(path, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.editModal = false;
            self.$Message.success('提交成功!');
          }
          self.loadingEdit = false;
          self.search();
        });
      });
    },
    onPidChange: function onPidChange(value) {
      var _this2 = this;

      this.formData.pid = value;
      this.$http.get('/adminRule/list', { params: { pid: value } }).then(function (res) {
        if (res && res.data) {
          _this2.subRules = res.data.data;
        } else {
          _this2.subRules = [];
        }
      });
    },
    onSubPidChange: function onSubPidChange(value) {
      this.formData.pid = value;
    },
    onSearchPidChange: function onSearchPidChange(value) {
      var _this3 = this;

      this.queryParam.pid = value;
      this.$http.get('/adminRule/list', { params: { pid: value } }).then(function (res) {
        if (res && res.data) {
          _this3.searchSubRules = res.data.data;
        } else {
          _this3.searchSubRules = [];
        }
      });
    },
    onSearchSubPidChange: function onSearchSubPidChange(value) {
      this.queryParam.pid = value;
    }
  },
  watch: {}
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var COL_STATUS = 88;
var COL_ACTION = 100;
var COL_KEY_MIN = 140;
var COL_TITLE_MIN = 160;
var COL_VALUE_MIN = 180;

function fitWidths(containerWidth) {
  var width = parseInt(containerWidth, 10) || 0;
  var fixed = COL_STATUS + COL_ACTION;
  var floors = COL_KEY_MIN + COL_TITLE_MIN + COL_VALUE_MIN;
  var usable = width - 2;
  if (usable <= fixed + floors) {
    return {
      key: COL_KEY_MIN,
      title: COL_TITLE_MIN,
      value: COL_VALUE_MIN
    };
  }
  var extra = usable - fixed - floors;
  var unit = Math.floor(extra / 5);
  var rest = extra - unit * 5;
  return {
    key: COL_KEY_MIN + unit * 2,
    title: COL_TITLE_MIN + unit * 2,
    value: COL_VALUE_MIN + unit + rest
  };
}

function ellipsisText(h, text) {
  var value = text || '';
  return h('span', {
    attrs: { title: value },
    style: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, value);
}

function buildColumns(widths, self, $constant) {
  return [{
    title: 'Key',
    key: 'configKey',
    align: 'center',
    width: widths.key,
    ellipsis: true,
    render: function render(h, params) {
      return ellipsisText(h, params.row.configKey);
    }
  }, {
    title: '配置标题',
    key: 'title',
    align: 'center',
    width: widths.title,
    ellipsis: true,
    render: function render(h, params) {
      return ellipsisText(h, params.row.title);
    }
  }, {
    title: '学导id',
    key: 'configValue',
    align: 'center',
    width: widths.value,
    ellipsis: true,
    render: function render(h, params) {
      var value = params.row.configValue || '';
      if (value.length <= 24) {
        return h('span', value);
      }
      return h('a', {
        style: { whiteSpace: 'nowrap' },
        on: { click: function click() {
            return self.showFullValue(value);
          } }
      }, value.slice(0, 24) + '...');
    }
  }, {
    title: '状态',
    align: 'center',
    width: COL_STATUS,
    render: function render(h, params) {
      var status = params.row.status;
      var color = status === 0 ? 'red' : '';
      var statusEnum = $constant.getEnum($constant.enabledStatus, status);
      return h('div', { style: { color: color } }, statusEnum && statusEnum.text);
    }
  }, {
    title: '操作',
    align: 'center',
    width: COL_ACTION,
    render: function render(h, params) {
      return h('el-button', {
        props: { type: 'primary', size: 'mini' },
        on: { click: function click() {
            return self.onEdit(params.row);
          } }
      }, '编辑');
    }
  }];
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var self = this;
    var screen = window.innerWidth || 1280;
    return {
      onLoading: false,
      queryParam: {},
      reload: 0,
      showEditTconfig: false,
      showValueModal: false,
      fullValue: '',
      modalWidth: Math.max(320, Math.min(600, screen - 48)),
      appliedKey: 0,
      appliedTitle: 0,
      appliedValue: 0,
      resizeTimer: null,
      formData: {
        id: null,
        configValue: '',
        status: null
      },
      title: buildColumns(fitWidths(screen - 306), self, $constant)
    };
  },
  mounted: function mounted() {
    this.applyLayout();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },

  methods: {
    onResize: function onResize() {
      var _this = this;

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(function () {
        _this.applyLayout();
      }, 80);
    },
    applyLayout: function applyLayout() {
      var screen = window.innerWidth || 1280;
      this.modalWidth = Math.max(320, Math.min(600, screen - 48));
      var container = screen - 306;
      if (this.$refs.listRoot && this.$refs.listRoot.clientWidth) {
        container = this.$refs.listRoot.clientWidth;
      }
      var widths = fitWidths(container);
      if (widths.key === this.appliedKey && widths.title === this.appliedTitle && widths.value === this.appliedValue) {
        return;
      }
      this.appliedKey = widths.key;
      this.appliedTitle = widths.title;
      this.appliedValue = widths.value;
      this.title = buildColumns(widths, this, this.$constant);
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    showFullValue: function showFullValue(value) {
      this.fullValue = value;
      this.showValueModal = true;
    },
    onEdit: function onEdit(row) {
      this.formData = {};
      this.formData.id = row.id;
      this.formData.configValue = row.configValue;
      this.formData.status = row.status;
      this.showEditTconfig = true;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    onSubmit: function onSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.$http.post('/adminConfig/editTConfig', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('保存成功!');
            self.showEditTconfig = false;
            self.formData = {};
            self.search();
          }
        });
      });
    },
    onClose: function onClose() {
      this.showEditTconfig = false;
      this.formData = {};
      this.search();
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tools_date_dates_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      syncLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        nickname: '',
        mobile: '',
        phone: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      loadingEdit: false,
      showAdminUserEditModal: false,
      editAdminUser: {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        dingMobile: '',
        status: '',
        groupId: '',
        agentMoor: '',
        teamType: '',
        positionType: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        dingtalkDepartmentId: '',
        adminConfig: {
          limitBindTchNum: '',
          limitBindTimeNum: '',
          limitBindTimesMonth: ''
        }
      },
      ruleAdminUser: {
        nickname: [{ type: 'string', required: true, message: '昵称不能为空', trigger: 'blur' }, { type: 'string', max: 20, message: '登录账号不能超过20个字', trigger: 'blur' }],
        mobile: [{ type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur' }, { type: 'string', max: 30, message: '登录账号不能超过30个字', trigger: 'blur' }],
        phone: [{ type: 'string', required: true, message: '联系号码不能为空', trigger: 'blur' }],
        groupId: [{ type: 'integer', required: true, message: '请选择分组', trigger: 'blur' }]
      },
      editPermissionModal: false,
      permissionData: [],
      title: [{
        title: 'id',

        align: 'center',
        key: 'id'
      }, {
        title: '昵称',
        align: 'center',
        key: 'nickname'
      }, {
        title: '登录账号',
        align: 'center',
        key: 'mobile'
      }, {
        title: '联系电话',

        align: 'center',
        key: 'phone'
      }, {
        title: '分组',

        align: 'center',
        key: 'groupTitle'
      }, {
        title: '钉钉名称',
        align: 'center',
        key: 'dingtalkName'
      }, {
        title: '绑定老师权限',

        align: 'center',
        key: 'limitMonthTimes'
      }, {
        title: '最近登录时间',

        align: 'center',
        key: 'lastLoginTime'
      }, {
        title: '登录IP',

        align: 'center',
        key: 'lastLoginIp'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onEdit(params.row.id);
              }
            }
          }, '编辑'), h('span', { class: 'divider' }), h('a', {
            on: {
              click: function click() {
                _this.onEditPermission(params.row);
              }
            }
          }, '权限管理')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    this.loadAdminGroup();
  },
  created: function created() {},
  methods: {
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/adminUser/list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '每月绑定老师次数统计.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    syncDingtalkName: function syncDingtalkName() {
      var self = this;
      self.syncLoading = true;
      self.$http.post('/adminUser/syncDingtalkName', {}).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('同步成功，已更新' + (res.data || 0) + '条');
          self.search();
        }
        self.syncLoading = false;
      }).catch(function () {
        self.syncLoading = false;
      });
    },
    onEdit: function onEdit(id) {
      var self = this;
      self.loadAdminGroup();
      self.loadDingTalkGroup();
      self.clearEditAdminUser();
      if (id) {
        self.$http.get('/adminUser/queryById?id=' + id).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.editAdminUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.data);
          if (res.data.positionType) {
            self.editAdminUser.positionType = res.data.positionType + '';
          }
          if (res.data.dingtalkUserid) {
            self.editAdminUser.dingtalkUserid = res.data.dingtalkUserid + '';
          }
          if (res.data.isReceiveMsg) {
            self.editAdminUser.isReceiveMsg = res.data.isReceiveMsg + '';
          }
          if (res.data.dingtalkDepartmentId) {
            self.editAdminUser.dingtalkDepartmentId = res.data.dingtalkDepartmentId + '';
            self.loadDingtalkUser(res.data.dingtalkDepartmentId);
          }
          self.editAdminUser.adminConfig = res.data.adminConfig;
          self.showAdminUserEditModal = true;
        });
      } else {
        self.showAdminUserEditModal = true;
      }
    },
    edit: function edit() {
      var _this3 = this;

      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/adminUser/update';
        if (!_this3.editAdminUser.id || _this3.editAdminUser.id === '') {
          path = '/adminUser/insert';
        }
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.editAdminUser);
        if (!data.dingtalkUserid) {
          data.dingtalkName = '';
        } else {
          var dingUser = (self.userList || []).find(function (item) {
            return String(item.userId) === String(data.dingtalkUserid);
          });
          if (dingUser) {
            data.dingtalkName = dingUser.userName;
          } else {
            delete data.dingtalkName;
          }
        }
        self.$http.post(path, data).then(function (res) {
          if (res && res.data > 0) {
            self.showAdminUserEditModal = false;
            self.$Message.success('提交成功!');
            self.search();
          }
          self.loadingEdit = false;
        });
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    loadAdminGroup: function loadAdminGroup() {
      var self = this;
      if (self.adminGroupList) {
        return;
      }
      self.$http.get('/adminGroup/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.adminGroupList = res.data;
      });
    },
    loadDingTalkGroup: function loadDingTalkGroup() {
      var self = this;
      self.$http.get('/dingTalk/departmentList').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.departmentList = res.data;
      });
    },
    loadDingtalkUser: function loadDingtalkUser(val) {
      var self = this;
      if (val) {
        self.$http.get('/dingTalk/getUserListByDepartmentId?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.userList = res.data;
        });
      }
    },
    clearEditAdminUser: function clearEditAdminUser() {
      this.editAdminUser = {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        dingMobile: '',
        status: '',
        groupId: '',
        dingtalkDepartmentId: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        adminConfig: {}
      };
    },
    editPermission: function editPermission() {
      var _this4 = this;

      var permissions = this.$refs.permissionTree.getCheckedNodes().map(function (item) {
        return item.id;
      }).join(',');

      this.loadingEdit = true;
      var path = '/adminRuleExtend/saveAdminGroupExtend';

      this.$http.post(path, { uid: this.permissionGroupId, extendId: permissions }).then(function (res) {
        if (res && res.data > 0) {
          _this4.editPermissionModal = false;
          _this4.$Message.success('提交成功!');
        }
        _this4.loadingEdit = false;
      });
    },
    onEditPermission: function onEditPermission(row) {
      var _this5 = this;

      this.checkKeys = [];
      if (!row || !row.id) {
        return;
      }
      this.permissionGroupId = row.id;
      this.$http.get('/adminRule/queryAdminRuleDetailByParam', {
        params: {
          type: 'adminUser',
          objectId: row.id
        }
      }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        _this5.permissionData = res.data.map(function (item) {
          return _this5.treeNode(item);
        });

        _this5.editPermissionModal = true;
        _this5.$nextTick(function () {
          _this5.$nextTick(function () {
            if (_this5.$refs.permissionTree) {
              _this5.$refs.permissionTree.setCheckedKeys(_this5.checkKeys);
            }
          });
        });
      });
    },
    addCheckKeys: function addCheckKeys(permissionDto) {
      if (permissionDto) {
        if (permissionDto.havePermission) {
          this.checkKeys.push(permissionDto.id);
        }
      }
    },
    treeNode: function treeNode(permissionDto) {
      var _this6 = this;

      if (!permissionDto) {
        return;
      }
      this.addCheckKeys(permissionDto);
      var treeNode = {
        id: permissionDto.id,
        label: permissionDto.title,
        expand: true,
        checked: permissionDto.havePermission,
        children: []
      };
      if (permissionDto.childAdminRuleDtoList) {
        treeNode.children = permissionDto.childAdminRuleDtoList.map(function (item) {
          return _this6.treeNode(item);
        });
      }

      return treeNode;
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        startTime: '',
        endTime: '',
        sysFrom: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [{
        title: '操作人',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.adminId === 0) {
            return h('div', '');
          }
          return h('div', [h('span', row.adminId), h('span', ' - '), h('span', row.adminName)]);
        }
      }, {
        title: '平台',
        align: 'center',
        render: function render(h, params) {
          var sysFrom = params.row.sysFrom;
          if (sysFrom === 1) {
            return h('span', '管理后台');
          }
          return h('span', '学生中心');
        }
      }, {
        title: '入口',
        align: 'center',
        key: 'action'
      }, {
        title: '路径',
        align: 'center',
        key: 'uri'
      }, {
        title: '参数',
        align: 'center',
        render: function render(h, params) {
          var p = params.row.params || '';
          var displayText = p.length > 50 ? p.substring(0, 50) + '...' : p;

          if (displayText.length > 50) {
            return h('Poptip', {
              props: {
                placement: 'top',
                transfer: true,
                wordWrap: true,
                maxWidth: 300
              }
            }, [h('div', {
              style: {
                'white-space': 'pre-line',
                'cursor': 'pointer'
              }
            }, displayText + '\n...'), h('div', {
              slot: 'content',
              style: {
                'white-space': 'pre-line',
                'max-height': '200px',
                'overflow-y': 'auto'
              }
            }, p)]);
          }

          return h('div', {
            style: {
              'white-space': 'pre-line'
            }
          }, displayText);
        }
      }, {
        title: '时间',
        align: 'center',
        width: 180,
        key: 'createTime'
      }, {
        title: 'IP',
        align: 'center',
        key: 'ip'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startTime = value[0];
      this.queryParam.endTime = value[1];
      this.search();
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        startTime: '',
        endTime: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [{
        title: '消息模板',
        align: 'center',
        key: 'templateName'
      }, {
        title: '主题',
        align: 'center',
        key: 'title'
      }, {
        title: '消息内容',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var p = params.row.sendContent || '';
          var displayText = p.length > 50 ? p.substring(0, 50) + '...' : p;
          if (displayText.length > 50) {
            return h('Poptip', {
              props: {
                placement: 'right',
                transfer: true,
                wordWrap: true,
                maxWidth: 500
              }
            }, [h('div', {
              style: {
                'white-space': 'pre-line',
                'cursor': 'pointer'
              }
            }, [h('span', displayText), h('br'), h('span', {
              style: {
                color: '#2d8cf0'
              }
            }, '完整内容')]), h('div', {
              slot: 'content',
              style: {
                'white-space': 'pre-line',
                'max-height': '500px',
                'overflow-y': 'auto'
              }
            }, p)]);
          }

          return h('div', {
            style: {
              'white-space': 'pre-line'
            }
          }, displayText);
        }
      }, {
        title: '消息类型',
        align: 'center',
        key: 'msgTypeName'
      }, {
        title: '接收人',
        align: 'center',
        key: 'sendToName'
      }, {
        title: '发送结果',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var result = row.sendResult;
          var color = 'green';
          var text = 'success';

          if (result !== 'ok' && result !== '200') {
            color = 'red';
            text = result;
          }

          return h('span', {
            style: {
              color: color
            }
          }, text);
        }
      }, {
        title: '时间',
        align: 'center',
        width: 180,
        key: 'createTime'
      }]
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startTime = value[0];
      this.queryParam.endTime = value[1];
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      addModalVisible: false,
      newTemplate: {
        templateName: '',
        title: '',
        sendContent: '',
        msgType: '',
        sendTo: '',
        dingAppId: '',
        dingSecret: '',
        hookUrl: '',
        enabled: true
      },
      queryParam: {
        startTime: '',
        endTime: '',
        sysFrom: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [{
        title: '模板名称',
        align: 'center',
        width: 300,
        key: 'templateName',
        fixed: 'left'
      }, {
        title: '标题',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.title
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.title) {
                  row.title = newValue;
                  _this.updateTchDirect({ templateName: row.templateName, title: newValue });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.templateName) {
                  row.templateName = value;
                  _this.updateTchDirect({ templateName: row.templateName, title: value });
                }
              }
            }
          });
        }
      }, {
        title: '模板内容',
        width: 400,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.sendContent || '',
              rows: 5 },
            props: {
              value: row.sendContent,
              placeholder: 'remark',
              type: 'textarea'
            },
            style: {
              resize: 'vertical' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.sendContent) {
                  row.sendContent = newValue;
                  _this.updateTchDirect({ templateName: row.templateName, sendContent: newValue });
                }
              }
            }
          });
        }
      }, {
        title: '消息类型',
        align: 'center',
        width: 150,
        key: 'msgTypeName'
      }, {
        title: '接收人',
        width: 150,
        align: 'center',
        key: 'sendToName'
      }, {
        title: 'AppId',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.dingAppId
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.dingAppId) {
                  row.dingAppId = newValue;
                  _this.updateTchDirect({ templateName: row.templateName, dingAppId: newValue });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.dingAppId) {
                  row.dingAppId = value;
                  _this.updateTchDirect({ templateName: row.templateName, dingAppId: value });
                }
              }
            }
          });
        }
      }, {
        title: 'Secret',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.dingSecret
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.dingSecret) {
                  row.dingSecret = newValue;
                  _this.updateTchDirect({ templateName: row.templateName, dingSecret: newValue });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.dingSecret) {
                  row.dingSecret = value;
                  _this.updateTchDirect({ templateName: row.templateName, dingSecret: value });
                }
              }
            }
          });
        }
      }, {
        title: 'WebHook',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.hookUrl
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.hookUrl) {
                  row.hookUrl = newValue;
                  _this.updateTchDirect({ templateName: row.templateName, hookUrl: newValue });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.hookUrl) {
                  row.hookUrl = value;
                  _this.updateTchDirect({ templateName: row.templateName, hookUrl: value });
                }
              }
            }
          });
        }
      }, {
        title: '最近更新时间',
        align: 'center',
        width: 180,
        key: 'updateTime'
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: function click() {
                _this.remove(params.row);
              }
            }
          }, '删除')]);
        }
      }, {
        title: '状态',
        width: 150,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          var statusValue = row.enabled === 1;

          return h('i-switch', {
            props: {
              value: statusValue,
              size: 'large'
            },
            on: {
              'input': function input(value) {
                row.enabled = value ? 1 : 0;
                _this.updateTchDirect({ templateName: row.templateName, enabled: value ? 1 : 0 });
              }
            }
          }, [h('span', { slot: 'open' }, '正常'), h('span', { slot: 'close' }, '禁用')]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startTime = value[0];
      this.queryParam.endTime = value[1];
      this.search();
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/activity/message-template-update', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    showAddModal: function showAddModal() {
      this.addModalVisible = true;

      this.newTemplate = {
        templateName: '',
        title: '',
        sendContent: '',
        msgType: '',
        sendTo: '',
        dingAppId: '',
        dingSecret: '',
        hookUrl: '',
        enabled: true
      };
    },
    handleAddConfirm: function handleAddConfirm() {
      var _this3 = this;

      if (!this.newTemplate.templateName) {
        this.$Message.error('请填写模板名称');
        return;
      }

      if (!this.newTemplate.title) {
        this.$Message.error('请填写标题');
        return;
      }

      var params = {
        templateName: this.newTemplate.templateName,
        title: this.newTemplate.title,
        sendContent: this.newTemplate.sendContent,
        msgType: this.newTemplate.msgType,
        sendTo: this.newTemplate.sendTo,
        dingAppId: this.newTemplate.dingAppId,
        dingSecret: this.newTemplate.dingSecret,
        hookUrl: this.newTemplate.hookUrl,
        enabled: this.newTemplate.enabled ? 1 : 0
      };

      this.$http.post('/activity/message-template-add', params).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success('新增成功');
          _this3.addModalVisible = false;
          _this3.search();
        } else {
          _this3.$Message.error(res.msg);
        }
      }).catch(function () {
        _this3.$Message.error('新增失败');
      });
    },
    remove: function remove(row) {
      var _this4 = this;

      this.$Modal.confirm({
        title: '确认删除',
        content: '\u786E\u5B9A\u8981\u5220\u9664\u6A21\u677F "' + row.templateName + '" \u5417\uFF1F',
        onOk: function onOk() {
          _this4.$http.post('/activity/message-template-remove', {
            templateName: row.templateName
          }).then(function (res) {
            if (res.status === 'ok') {
              _this4.$Message.success('删除成功');
              _this4.search();
            } else {
              _this4.$Message.error(res.msg);
            }
          }).catch(function () {
            _this4.$Message.error('删除失败');
          });
        }
      });
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      readonly: false,
      defaultIcon: [],
      iconFile: [],
      formData: {
        phones: '',
        content: ''
      },
      formRule: {
        phones: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },
  created: function created() {
    this.formData.id = this.$route.query.id;
    this.readonly = this.$helper.isDetail(this.$route.path);
    var self = this;

    if (!this.formData.id || this.formData.id === '') {
      return;
    }
    this.$http.get('/module/' + this.formData.id).then(function (response) {
      if (!response || !response.data) {
        return;
      }
      var data = response.data;
      self.$helper.copyProperties(data, self.formData);

      if (data.iconFile) {
        self.defaultIcon.push(data.iconFile);
      }
    });
  },
  mounted: function mounted() {},

  methods: {
    handleSubmit: function handleSubmit(name) {
      var _this = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var path = '/module/update';
          if (!_this.formData.id || _this.formData.id === '') {
            path = '/module/insert';
          }
          self.$http.post(path, self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!');
              self.$router.push('/module');
            }
          });
        } else {
          self.$Message.warning('表单验证失败!');
        }
      });
    },
    back: function back() {
      this.$router.push('/module');
    },
    handleReset: function handleReset(name) {
      this.$refs.form.resetFields();
    },
    handleIconChange: function handleIconChange(fileList) {
      this.formData.iconFileId = fileList.map(function (item) {
        return item.fileId;
      }).join(',');
    }
  },
  watch: {}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        nickname: '',
        mobile: '',
        phone: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      loadingEdit: false,
      showAdminUserEditModal: false,
      showAddTimeModal: false,
      addTimeReq: {
        dateRange: [],
        adminUserIds: []
      },
      editAdminUser: {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        status: '',
        groupId: '',
        agentMoor: '',
        teamType: '',
        positionType: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        dingtalkDepartmentId: '',
        adminConfig: {
          limitBindTchNum: '',
          limitBindTimeNum: '',
          limitBindTimesMonth: ''
        }
      },
      ruleAdminUser: {
        nickname: [{ type: 'string', required: true, message: '昵称不能为空', trigger: 'blur' }, { type: 'string', max: 20, message: '登录账号不能超过20个字', trigger: 'blur' }],
        mobile: [{ type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur' }, { type: 'string', max: 30, message: '登录账号不能超过30个字', trigger: 'blur' }],
        phone: [{ type: 'string', required: true, message: '联系号码不能为空', trigger: 'blur' }],
        groupId: [{ type: 'integer', required: true, message: '请选择分组', trigger: 'blur' }]
      },
      editPermissionModal: false,
      permissionData: [],
      title: [{
        title: '值班日期',
        align: 'center',
        key: 'date'
      }, {
        title: '值班人员',
        align: 'center',
        key: 'dutyUser'
      }, {
        title: '小组成员',
        align: 'center',
        render: function render(h, params) {
          var dutyUsers = params.row.dutyUsers;
          return h('div', dutyUsers.map(function (user) {
            return user.nickname;
          }).join('、'));
        }
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onDel(params.row.id);
              }
            }
          }, '删除')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    this.loadAdminGroup();
  },
  created: function created() {},
  methods: {
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/adminUser/list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '每月绑定老师次数统计.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    onAddTime: function onAddTime() {
      this.showAddTimeModal = true;
    },
    onDel: function onDel(id) {
      var self = this;
      self.$http.get('/todo/del-duty?id=' + id).then(function (res) {
        if (!res || !res.data) {
          self.search();
        }
      });
    },
    saveTime: function saveTime() {
      var self = this;
      self.loadingEdit = true;
      if (self.addTimeReq.dateRange.length === 2) {
        if (self.addTimeReq.dateRange[0]) {
          var startTimeDate = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.format(this.addTimeReq.dateRange[0]);
          self.addTimeReq.startTime = Date.parse(startTimeDate) / 1000;
        } else {
          self.$Message.warning('请选择时间!');
          self.loadingEdit = false;
          return;
        }
        if (this.addTimeReq.dateRange[1]) {
          self.addTimeReq.endTime = this.$moment(this.addTimeReq.dateRange[1], 'YYYY-M-D H:m').format('X');
        } else {
          self.$Message.warning('请选择时间!');
          self.loadingEdit = false;
          return;
        }
      } else {
        self.$Message.warning('请选择时间!');
        self.loadingEdit = false;
        return;
      }
      self.$http.post('/adminUser/add-time', self.addTimeReq).then(function (res) {
        if (res && res.status === 'ok') {
          self.addTimeReq = {};
          self.$Message.success('提交成功!');
          self.search();
        }
        self.loadingEdit = false;
      });
    },
    edit: function edit() {
      var _this3 = this;

      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/adminUser/update';
        if (!_this3.editAdminUser.id || _this3.editAdminUser.id === '') {
          path = '/adminUser/insert';
        }
        self.$http.post(path, self.editAdminUser).then(function (res) {
          if (res && res.data > 0) {
            self.showAdminUserEditModal = false;
            self.$Message.success('提交成功!');
            self.search();
          }
          self.loadingEdit = false;
        });
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    loadAdminGroup: function loadAdminGroup() {
      var self = this;
      if (self.adminGroupList) {
        return;
      }
      self.$http.get('/adminGroup/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.adminGroupList = res.data;
      });
    },
    loadDingTalkGroup: function loadDingTalkGroup() {
      var self = this;
      self.$http.get('/dingTalk/departmentList').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.departmentList = res.data;
      });
    },
    loadDingtalkUser: function loadDingtalkUser(val) {
      var self = this;
      if (val) {
        self.$http.get('/dingTalk/getUserListByDepartmentId?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.userList = res.data;
        });
      }
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startDate = value[0];
      this.queryParam.endDate = value[1];
      this.search();
    },
    editPermission: function editPermission() {
      var _this4 = this;

      var permissions = this.$refs.permissionTree.getCheckedNodes().map(function (item) {
        return item.id;
      }).join(',');

      this.loadingEdit = true;
      var path = '/adminRuleExtend/saveAdminGroupExtend';

      this.$http.post(path, { uid: this.permissionGroupId, extendId: permissions }).then(function (res) {
        if (res && res.data > 0) {
          _this4.editPermissionModal = false;
          _this4.$Message.success('提交成功!');
        }
        _this4.loadingEdit = false;
      });
    },
    onEditPermission: function onEditPermission(row) {
      var _this5 = this;

      this.checkKeys = [];
      if (!row || !row.id) {
        return;
      }
      this.permissionGroupId = row.id;
      this.$http.get('/adminRule/queryAdminRuleDetailByParam', {
        params: {
          type: 'adminUser',
          objectId: row.id
        }
      }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        _this5.permissionData = res.data.map(function (item) {
          return _this5.treeNode(item);
        });

        _this5.editPermissionModal = true;
      });
    },
    addCheckKeys: function addCheckKeys(permissionDto) {
      if (permissionDto) {
        if (permissionDto.havePermission) {
          this.checkKeys.push(permissionDto.id);
        }
      }
    },
    disabledDate: function disabledDate(date) {
      return date && date.valueOf() <= Date.now() - 24 * 60 * 60 * 1000;
    },
    treeNode: function treeNode(permissionDto) {
      var _this6 = this;

      if (!permissionDto) {
        return;
      }
      this.addCheckKeys(permissionDto);
      var treeNode = {
        id: permissionDto.id,
        label: permissionDto.title,
        expand: true,
        checked: permissionDto.havePermission,
        children: []
      };
      if (permissionDto.childAdminRuleDtoList) {
        treeNode.children = permissionDto.childAdminRuleDtoList.map(function (item) {
          return _this6.treeNode(item);
        });
      }

      return treeNode;
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditItemModal',
  props: {
    itemId: Number,
    value: {
      type: Boolean,
      default: false
    },
    pid: Number
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visible: this.value,
      formRule: {},
      parentList: [],
      searchLoading: false,
      loadingEdit: false,
      parentId: null,
      statusList: $constant.enabledStatus,
      formData: {
        title: '',
        desc: '',
        pid: '',
        itemType: '',
        state: ''
      }
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      var self = this;
      if (!val) {
        self.$emit('on-close');
      }
    },
    onPidChange: function onPidChange() {
      this.formData.pid = this.pid;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    edit: function edit() {
      var _this = this;

      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/adminConfig/update';
        if (!_this.formData.id || _this.formData.id === '') {
          path = '/adminConfig/insert';
        }
        self.$http.post(path, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.search();
            self.$emit('on-edit-success');
            self.clearItem();
          }
          self.loadingEdit = false;
        });
      });
    },
    clearItem: function clearItem() {
      var self = this;
      self.formData.title = '';
      self.formData.id = '';
      self.formData.descr = '';
      self.formData.pid = '';
      self.formData.itemType = '';
      self.formData.state = '';
      self.parentId = null;
    }
  },
  watch: {
    value: function value(val) {
      var self = this;
      if (val) {
        self.$http.get('/adminConfig/getParent').then(function (res) {
          self.parentList = res.data;
        });
        self.visible = true;
      } else {
        self.visible = false;
        this.clearItem();
      }
    },
    pid: function pid(val) {
      var self = this;
      if (val) {
        self.parentId = val;
        self.formData.pid = val;
      }
    },
    itemId: function itemId(val) {
      if (val) {
        var self = this;
        self.$http.get('/adminConfig/getItemById?id=' + val).then(function (res) {
          if (res.data) {
            self.formData.title = res.data.title;
            self.formData.id = res.data.id;
            self.formData.descr = res.data.descr;
            self.formData.pid = res.data.pid;
            self.formData.itemType = res.data.itemType;
            self.formData.state = res.data.state;
          }
          self.$emit('on-edit-clearid');
        });
      }
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      tutorAll: [],
      queryParam: {
        inviteKey: '',
        stdKey: '',
        studyAdviserId: '',
        startCreateTime: null,
        endCreateTime: null,
        adviserId: ''
      },
      statusList: [{ code: 1, text: '已领奖' }, { code: 0, text: '未领奖' }],
      title: [{
        title: '昵称',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.userNickname);
        }
      }, {
        title: '手机号',
        align: 'center',
        width: 150,
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '推荐人',
        width: 190,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.inviteId + ' - ' + (row.inviteNickname || ''));
        }
      }, {
        title: '推荐人课程顾问',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          if (row.inviteAdviserName != null) {
            return h('span', row.inviteAdviserName);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '推荐人学导',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          if (row.inviteStudyAdviserName != null) {
            return h('span', row.inviteStudyAdviserName);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '创建时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '已试听',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var isAudition = params.row.isAudition;
          var audition = $constant.getEnum($constant.yesNoNum, isAudition);
          if (audition) {
            return h('span', audition.text);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '成交时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var payTime = params.row.payTime;
          return h('span', payTime === 0 ? '' : $moment(payTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '奖励',
        width: 120,
        key: 'prize'
      }, {
        title: '状态',
        width: 150,
        align: 'center',
        key: 'status',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum(_this.statusList, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var self = this;
    var params = { status: 1, adminGroupId: 4 };
    self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
      if (res && res.data) {
        self.tutorAll = res.data;
      } else {
        self.tutorAll = [];
      }
    });
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/agentInvite/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '推荐记录列表.xls';
        link.click();
        _this2.exportLoading = false;
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        uid: '',
        userMobile: '',
        userNickname: ''
      },
      title: [{
        title: '用户ID、昵称',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', { style: { color: 'gray' } }, ' - '), h('a', { on: {
              click: function click() {
                _this.$router.push({ path: '/agent/agentInviteList', query: { inviteId: row.uid } });
              }
            } }, row.userNickname || '')]);
        }
      }, {
        title: '手机号',
        key: 'userMobile'
      }, {
        title: '创建时间',
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_aiApi__ = __webpack_require__(72);







var ERROR_TEXT = {
  AI_SCOPE_DENIED: '无权查看该学生',
  AI_KILL_SWITCH: 'AI 已关闭',
  AI_BUDGET_EXCEEDED: '今日额度已用完',
  AI_RATE_LIMITED: '操作过于频繁',
  AI_LLM_TIMEOUT: '生成超时，请重试',
  AI_LLM_UNSAFE: '内容未通过安全校验',
  AI_SCHEMA_INVALID: '结果结构不合法，未写回',
  AI_STATE_INVALID: '状态不允许此操作',
  AI_MARKET_NO_WRITEBACK: '市场角色不能写回',
  AI_IDEMPOTENT_HIT: '已写回，未重复插入'
};

var TASK_LABEL = {
  SALES_FOLLOWUP: '跟进建议',
  SALES_CALL_ANALYSIS: '通话分析',
  ADVISOR_AFTER_CLASS: '课后反馈',
  ADVISOR_WEEKLY: '周报',
  ADVISOR_RENEWAL: '续费提纲',
  RISK_EXPLAIN: '风险解释',
  TCH_RISK_EXPLAIN: '老师风险解释'
};

var STATUS_LABEL = {
  DRAFT: '草稿',
  GENERATING: '生成中',
  GENERATED: '已生成',
  APPROVED: '已确认',
  EXECUTED: '已写回',
  FAILED: '失败',
  CANCELLED: '已放弃'
};

var WRITEBACK_HINT = {
  SALES_FOLLOWUP: '将写入表 user_add_remark。无人行则 INSERT，有人行则 旧remark + "。" + 本文。files 不改。update_id = 当前登录用户（服务端取，前端不传）。',
  SALES_CALL_ANALYSIS: '将写入表 user_add_remark，前缀 [AI通话分析]。无人行则 INSERT，有人行则 旧remark + "。" + 本文。',
  ADVISOR_AFTER_CLASS: '将写入 user_trace_record。trackType=61（上课跟进消息）。isMessageSend=0（不推送）。content 前缀 [AI课后]。',
  ADVISOR_WEEKLY: '将写入 user_trace_record。trackType=61（上课跟进消息）。isMessageSend=0（不推送）。content 前缀 [AI周报]。',
  ADVISOR_RENEWAL: '将写入 user_trace_record。trackType=61（上课跟进消息）。isMessageSend=0（不推送）。content 前缀 [AI续费提纲]。仅内部。',
  RISK_EXPLAIN: '将写入 student_risk_followup。可选同时写一条 user_trace_record，trackType=61，isMessageSend=0，前缀 [AI风险]。',
  TCH_RISK_EXPLAIN: '将写入 tch_track_record，类型回访，前缀 [AI老师风险]。可选同时记 teacher_risk_followup。'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AiDrawer',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    uid: {
      type: [Number, String],
      default: null
    },
    pageRoute: {
      type: String,
      required: true
    },
    defaultTaskType: {
      type: String,
      required: true
    },
    snapshotId: {
      type: [Number, String],
      default: null
    },
    subjectType: {
      type: String,
      default: 'STUDENT'
    }
  },
  data: function data() {
    return {
      taskType: '',
      excludeFactKeys: [],
      facts: null,
      factSources: [],
      runId: null,
      runNo: null,
      runStatus: '',
      output: null,
      pending: null,
      editedText: '',
      originalEditedText: '',
      errorCode: '',
      errorMsg: '',
      clientRequestId: '',
      history: [],
      preparing: false,
      generating: false,
      approving: false,
      executing: false,
      historyLoading: false,
      prepareFailed: false,
      resultError: false,
      feedbackAdopted: null,
      feedbackIssueType: null,
      feedbackComment: '',
      suppressTaskChange: false
    };
  },
  computed: {
    isMarket: function isMarket() {
      return Number(this.$store.get('adminRule')) === 4;
    },
    missingIdText: function missingIdText() {
      return this.subjectType === 'TEACHER' ? '缺少老师 ID' : '缺少学生 ID';
    },
    taskOptions: function taskOptions() {
      var route = this.pageRoute;
      if (route === '/crm/PhoneRecordList') {
        return [{ label: '跟进建议', value: 'SALES_FOLLOWUP' }, { label: '通话分析', value: 'SALES_CALL_ANALYSIS' }];
      }
      if (route === '/user/bookTestList' || route === '/user/userExperienceList') {
        return [{ label: '跟进建议', value: 'SALES_FOLLOWUP' }];
      }
      if (route === '/user/userPayList' || route === '/user/userTodayNewList' || route === '/user/userTrackList') {
        return [{ label: '课后反馈', value: 'ADVISOR_AFTER_CLASS' }, { label: '周报', value: 'ADVISOR_WEEKLY' }, { label: '续费提纲', value: 'ADVISOR_RENEWAL' }];
      }
      if (route === '/user/studentRiskList') {
        return [{ label: '风险解释', value: 'RISK_EXPLAIN' }];
      }
      if (route === '/tch/tchFormalList' || route === '/tch/filipino/tchFormalList') {
        return [{ label: '风险解释', value: 'TCH_RISK_EXPLAIN' }];
      }
      return [];
    },
    writebackHint: function writebackHint() {
      return WRITEBACK_HINT[this.taskType] || '';
    },
    displayError: function displayError() {
      if (this.errorCode && ERROR_TEXT[this.errorCode]) {
        return ERROR_TEXT[this.errorCode] + (this.errorCode ? '（' + this.errorCode + '）' : '');
      }
      if (this.errorMsg) {
        return this.errorMsg + (this.errorCode ? '（' + this.errorCode + '）' : '');
      }
      if (this.errorCode) {
        return this.errorCode;
      }
      return '';
    },
    factRows: function factRows() {
      var self = this;
      var facts = this.facts;
      if (!facts || (typeof facts === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(facts)) !== 'object' || Array.isArray(facts)) {
        return [];
      }
      var sourceMap = {};(this.factSources || []).forEach(function (item) {
        if (item && item.key) {
          sourceMap[item.key] = item.table;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(facts).filter(function (key) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["b" /* isSensitiveFactKey */])(key)) {
          console.warn('[AiDrawer] skip sensitive fact key', key);
          return false;
        }
        return true;
      }).map(function (key) {
        return {
          key: key,
          display: self.formatValue(facts[key]),
          table: sourceMap[key] || ''
        };
      });
    },
    canGenerate: function canGenerate() {
      if (!this.uid) {
        return false;
      }
      if (this.generating || this.approving || this.executing) {
        return false;
      }
      if (this.runStatus === 'GENERATING' || this.runStatus === 'APPROVED') {
        return false;
      }
      return true;
    },
    canConfirm: function canConfirm() {
      if (this.isMarket) {
        return false;
      }
      if (this.runStatus !== 'GENERATED') {
        return false;
      }
      if (!this.editedText || !String(this.editedText).trim()) {
        return false;
      }
      if (this.executing || this.approving) {
        return false;
      }
      if (!this.uid) {
        return false;
      }
      return true;
    },
    canAbandon: function canAbandon() {
      return this.runStatus === 'GENERATED' && !this.isMarket;
    },
    canFeedback: function canFeedback() {
      if (!this.runId) {
        return false;
      }
      if (!this.runStatus || this.runStatus === 'GENERATING' || this.runStatus === 'DRAFT') {
        return false;
      }
      return true;
    },
    confirmReadOnly: function confirmReadOnly() {
      return this.runStatus === 'EXECUTED' || this.runStatus === 'CANCELLED';
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.resetAndOpen();
      }
    }
  },
  methods: {
    dealLabel: function dealLabel(code) {
      if (code === 'HIGH') return '高';
      if (code === 'MID') return '中';
      if (code === 'LOW') return '低';
      return code || '';
    },
    closeDrawer: function closeDrawer() {
      this.$emit('update:visible', false);
      this.$emit('on-close', false);
    },
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.$emit('update:visible', false);
        this.$emit('on-close', false);
      }
    },
    resetState: function resetState() {
      this.excludeFactKeys = [];
      this.facts = null;
      this.factSources = [];
      this.runId = null;
      this.runNo = null;
      this.runStatus = '';
      this.output = null;
      this.pending = null;
      this.editedText = '';
      this.originalEditedText = '';
      this.errorCode = '';
      this.errorMsg = '';
      this.clientRequestId = '';
      this.history = [];
      this.preparing = false;
      this.generating = false;
      this.approving = false;
      this.executing = false;
      this.historyLoading = false;
      this.prepareFailed = false;
      this.resultError = false;
      this.feedbackAdopted = null;
      this.feedbackIssueType = null;
      this.feedbackComment = '';
    },
    resetAndOpen: function resetAndOpen() {
      var self = this;
      this.suppressTaskChange = true;
      this.resetState();
      this.taskType = this.defaultTaskType || '';
      this.$nextTick(function () {
        self.suppressTaskChange = false;
        if (!self.uid) {
          self.errorMsg = self.missingIdText;
          self.resultError = true;
          return;
        }
        self.doPrepare();
        self.doLoadHistory();
      });
    },
    onTaskTypeChange: function onTaskTypeChange() {
      if (this.suppressTaskChange) {
        return;
      }
      this.output = null;
      this.pending = null;
      this.runId = null;
      this.runNo = null;
      this.runStatus = '';
      this.errorCode = '';
      this.errorMsg = '';
      this.editedText = '';
      this.originalEditedText = '';
      this.clientRequestId = '';
      this.resultError = false;
      this.prepareFailed = false;
      this.doPrepare();
    },
    buildBaseBody: function buildBaseBody() {
      var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["c" /* buildPrepareBody */])({
        taskType: this.taskType,
        uid: this.uid,
        pageRoute: this.pageRoute,
        excludeFactKeys: this.excludeFactKeys,
        subjectType: this.subjectType
      });
      if (this.snapshotId) {
        body.snapshotId = this.snapshotId;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["d" /* stripForbiddenAiBody */])(body);
    },
    pickErrorCode: function pickErrorCode(res) {
      if (!res) {
        return '';
      }
      var data = res.data || {};
      return data.errorCode || data.error_code || '';
    },
    applyError: function applyError(res, where) {
      var code = this.pickErrorCode(res);
      var msg = res && (res.msg || res.data && res.data.msg) || '';
      this.errorCode = code;
      this.errorMsg = msg;
      if (where === 'prepare') {
        this.prepareFailed = true;
      }
      if (where === 'generate') {
        this.resultError = true;
        this.runStatus = 'FAILED';
        if (res && res.data && res.data.runId) {
          this.runId = res.data.runId;
        }
      }
      if (where === 'result') {
        this.resultError = true;
      }
    },
    isIdempotentSuccess: function isIdempotentSuccess(res) {
      return this.pickErrorCode(res) === 'AI_IDEMPOTENT_HIT';
    },
    isFactIncluded: function isFactIncluded(key) {
      return this.excludeFactKeys.indexOf(key) === -1;
    },
    onFactCheck: function onFactCheck(key, checked) {
      this.toggleFact(key, checked);
    },
    toggleFact: function toggleFact(key, checked) {
      var idx = this.excludeFactKeys.indexOf(key);
      if (checked) {
        if (idx !== -1) {
          this.excludeFactKeys.splice(idx, 1);
        }
      } else if (idx === -1) {
        this.excludeFactKeys.push(key);
      }
    },
    doPrepare: function doPrepare() {
      var self = this;
      if (!self.uid) {
        self.errorMsg = self.missingIdText;
        self.prepareFailed = true;
        return;
      }
      self.preparing = true;
      self.prepareFailed = false;
      self.errorCode = '';
      self.errorMsg = '';
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].prepare, self.buildBaseBody()).then(function (res) {
        self.preparing = false;
        if (!res || res.status !== 'ok') {
          self.applyError(res, 'prepare');
          return;
        }
        var data = res.data || {};
        self.facts = data.facts || null;
        self.factSources = data.factSources || [];
        if (data.excludedKeys && data.excludedKeys.length) {
          self.excludeFactKeys = data.excludedKeys.slice();
        }
      }).catch(function () {
        self.preparing = false;
        self.prepareFailed = true;
        self.errorMsg = '系统繁忙';
      });
    },
    onGenerate: function onGenerate() {
      var self = this;
      if (!self.canGenerate) {
        return;
      }
      if (!self.clientRequestId || self.runStatus !== 'GENERATING') {
        self.clientRequestId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["e" /* newClientRequestId */])();
      }
      self.generating = true;
      self.runStatus = 'GENERATING';
      self.resultError = false;
      self.errorCode = '';
      self.errorMsg = '';
      var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["d" /* stripForbiddenAiBody */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["f" /* buildGenerateBody */])(self.buildBaseBody(), self.clientRequestId));
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].generate, body).then(function (res) {
        self.generating = false;
        if (!res || res.status !== 'ok') {
          self.applyError(res, 'generate');
          return;
        }
        var data = res.data || {};
        self.runId = data.runId;
        self.runNo = data.runNo;
        self.runStatus = data.status || 'GENERATED';
        self.output = data.output || null;
        self.pending = data.pending || null;
        self.editedText = self.defaultEditedText(self.output);
        self.originalEditedText = self.editedText;
        if (self.runStatus === 'FAILED') {
          self.applyError(res, 'generate');
        }
      }).catch(function () {
        self.generating = false;
        self.runStatus = 'FAILED';
        self.resultError = true;
        self.errorMsg = '系统繁忙';
      });
    },
    defaultEditedText: function defaultEditedText(output) {
      if (!output) {
        return '';
      }
      var t = this.taskType;
      if (t === 'SALES_FOLLOWUP') {
        return output.followUpText || '';
      }
      if (t === 'SALES_CALL_ANALYSIS') {
        return this.withPrefix('[AI通话分析]', output.followUpText);
      }
      if (t === 'ADVISOR_AFTER_CLASS') {
        return this.withPrefix('[AI课后]', output.parentFeedback);
      }
      if (t === 'ADVISOR_WEEKLY') {
        var parts = [];
        if (output.overview) {
          parts.push(output.overview);
        }
        if (output.highlights) {
          parts.push(this.formatList(output.highlights));
        }
        if (output.toReview) {
          parts.push(output.toReview);
        }
        if (output.homeAdvice) {
          parts.push(this.formatList(output.homeAdvice));
        }
        if (output.nextGoal) {
          parts.push(output.nextGoal);
        }
        return this.withPrefix('[AI周报]', parts.join('\n'));
      }
      if (t === 'ADVISOR_RENEWAL') {
        return this.withPrefix('[AI续费提纲]', output.internalOutline);
      }
      if (t === 'RISK_EXPLAIN') {
        return output.explanation || '';
      }
      if (t === 'TCH_RISK_EXPLAIN') {
        return output.explanation || '';
      }
      return '';
    },
    actionLabel: function actionLabel(code) {
      var map = {
        CALL: '电话',
        REMARK: '备注',
        TRANSFER: '转交',
        IGNORE: '忽略'
      };
      return map[code] || code || '';
    },
    withPrefix: function withPrefix(prefix, text) {
      var body = text || '';
      if (typeof body !== 'string') {
        body = this.formatValue(body);
      }
      if (!body) {
        return prefix;
      }
      if (body.indexOf(prefix) === 0) {
        return body;
      }
      return prefix + body;
    },
    onConfirmWriteback: function onConfirmWriteback() {
      var self = this;
      if (!self.canConfirm) {
        return;
      }
      self.approving = true;
      self.executing = true;
      self.errorCode = '';
      self.errorMsg = '';
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].approve, {
        runId: self.runId,
        editedText: self.editedText
      }).then(function (res) {
        if (self.isIdempotentSuccess(res)) {
          self.markExecuted(true);
          return;
        }
        if (!res || res.status !== 'ok') {
          self.applyError(res, 'result');
          return;
        }
        self.runStatus = 'APPROVED';
        return self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].execute, { runId: self.runId }).then(function (execRes) {
          if (self.isIdempotentSuccess(execRes) || execRes && execRes.status === 'ok') {
            self.markExecuted(self.isIdempotentSuccess(execRes));
          } else {
            self.applyError(execRes, 'result');
          }
        });
      }).catch(function () {
        self.errorMsg = '系统繁忙';
        self.resultError = true;
      }).then(function () {
        self.approving = false;
        self.executing = false;
      });
    },
    markExecuted: function markExecuted(idempotent) {
      this.runStatus = 'EXECUTED';
      this.resultError = false;
      if (idempotent) {
        this.errorCode = 'AI_IDEMPOTENT_HIT';
        this.errorMsg = ERROR_TEXT.AI_IDEMPOTENT_HIT;
      } else {
        this.errorCode = '';
        this.errorMsg = '';
      }
      this.$emit('on-executed', {
        runId: this.runId,
        taskType: this.taskType,
        uid: this.uid
      });
    },
    onAbandon: function onAbandon() {
      this.runStatus = 'CANCELLED';
    },
    onFeedback: function onFeedback(adopted) {
      var self = this;
      if (!self.canFeedback) {
        return;
      }
      var edited = self.editedText !== self.originalEditedText;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].feedback, {
        runId: self.runId,
        adopted: adopted ? 1 : 0,
        edited: edited ? 1 : 0,
        issueType: self.feedbackIssueType,
        comment: self.feedbackComment
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.feedbackAdopted = adopted;
          self.$Message.success('反馈已提交');
        }
      }).catch(function () {});
    },
    doLoadHistory: function doLoadHistory() {
      var self = this;
      if (!self.uid) {
        return;
      }
      self.historyLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].runList, {
        subjectType: self.subjectType || 'STUDENT',
        subjectId: self.uid,
        pageNo: 1,
        pageSize: 20
      }).then(function (res) {
        self.historyLoading = false;
        if (!res || res.status !== 'ok') {
          return;
        }
        self.history = self.normalizeList(res.data);
      }).catch(function () {
        self.historyLoading = false;
      });
    },
    normalizeList: function normalizeList(data) {
      if (!data) {
        return [];
      }
      if (Array.isArray(data)) {
        return data;
      }
      if (Array.isArray(data.data)) {
        return data.data;
      }
      if (Array.isArray(data.list)) {
        return data.list;
      }
      return [];
    },
    historyKey: function historyKey(item) {
      return item.runId || item.id || item.runNo;
    },
    historyTaskLabel: function historyTaskLabel(item) {
      var code = item && (item.taskType || item.task_type) || '';
      return TASK_LABEL[code] || code || '未知任务';
    },
    historyStatusLabel: function historyStatusLabel(item) {
      var code = item && item.status || '';
      return STATUS_LABEL[code] || code || '';
    },
    historyTime: function historyTime(item) {
      var raw = item && (item.gmtCreate || item.gmt_create || item.createTime || item.createdAt);
      return this.formatHistoryTime(raw);
    },
    formatHistoryTime: function formatHistoryTime(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      var d;
      if (typeof raw === 'number') {
        d = new Date(raw < 1e12 ? raw * 1000 : raw);
      } else if (raw instanceof Date) {
        d = raw;
      } else {
        var s = String(raw).replace('T', ' ').replace(/-/g, '/');
        d = new Date(s);
        if (isNaN(d.getTime())) {
          return String(raw);
        }
      }
      if (isNaN(d.getTime())) {
        return String(raw);
      }
      function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    parseJsonMaybe: function parseJsonMaybe(raw) {
      if (raw == null || raw === '') {
        return null;
      }
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(raw)) === 'object') {
        return raw;
      }
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    pickField: function pickField(obj, names) {
      if (!obj) {
        return undefined;
      }
      for (var i = 0; i < names.length; i++) {
        if (obj[names[i]] !== undefined && obj[names[i]] !== null) {
          return obj[names[i]];
        }
      }
      return undefined;
    },
    onHistoryClick: function onHistoryClick(item) {
      var self = this;
      var runId = item.runId || item.id;
      if (!runId) {
        return;
      }
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["a" /* AI_URI */].runDetail, { runId: runId }).then(function (res) {
        if (!res || res.status !== 'ok') {
          self.applyError(res, 'result');
          return;
        }
        var data = res.data || {};
        var run = data.run || data;
        var payload = data.payload || {};
        var pending = data.pending || null;
        var taskType = self.pickField(run, ['taskType', 'task_type']) || item.taskType || item.task_type;
        var output = self.parseJsonMaybe(self.pickField(payload, ['outputJson', 'output_json'])) || data.output || null;
        var editedObj = self.parseJsonMaybe(self.pickField(payload, ['editedJson', 'edited_json']));
        var facts = self.parseJsonMaybe(self.pickField(payload, ['inputRedacted', 'input_redacted'])) || data.facts;
        if (taskType) {
          self.suppressTaskChange = true;
          self.taskType = taskType;
          self.$nextTick(function () {
            self.suppressTaskChange = false;
          });
        }
        self.runId = self.pickField(run, ['id', 'runId']) || runId;
        self.runNo = self.pickField(run, ['runNo', 'run_no']);
        self.runStatus = self.pickField(run, ['status']) || item.status || '';
        self.output = output;
        self.pending = pending;
        if (facts && (typeof facts === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(facts)) === 'object' && !Array.isArray(facts)) {
          self.facts = facts;
        }
        var edited = '';
        if (data.editedText) {
          edited = data.editedText;
        } else if (pending && pending.previewText) {
          edited = pending.previewText;
        } else if (editedObj && (typeof editedObj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(editedObj)) === 'object') {
          edited = self.defaultEditedText(editedObj);
        } else if (typeof editedObj === 'string') {
          edited = editedObj;
        } else {
          edited = self.defaultEditedText(self.output);
        }
        self.editedText = edited;
        self.originalEditedText = edited;
        self.resultError = self.runStatus === 'FAILED';
        self.errorCode = '';
        self.errorMsg = '';
        if (self.runStatus === 'FAILED') {
          self.applyError(res, 'result');
          return;
        }
        if (!self.output) {
          self.resultError = true;
          self.errorMsg = '该次没有可展示的结果';
          return;
        }
        self.$Message.success('已加载该次结果');
      }).catch(function () {
        self.resultError = true;
        self.errorMsg = '系统繁忙';
      });
    },
    formatList: function formatList(val) {
      if (!val) {
        return '';
      }
      if (Array.isArray(val)) {
        return val.join('；');
      }
      return this.formatValue(val);
    },
    formatValue: function formatValue(val) {
      if (val === null || val === undefined || val === '') {
        return '';
      }
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object') {
        try {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
        } catch (e) {
          return String(val);
        }
      }
      return String(val);
    },
    formatJson: function formatJson(val) {
      try {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val, null, 2);
      } catch (e) {
        return String(val);
      }
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivitySelect',
  props: {
    value: {
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      activityList: [],
      model: ''
    };
  },

  methods: {
    onChange: function onChange(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('activity/quyeryall').then(function (res) {
      if (res && res.data) {
        self.activityList = res.data;
      } else {
        self.activityList = [];
      }
    });
  },
  watch: {
    value: function value(val) {
      if (val) {
        var idNumber = parseInt(val);
        this.model = idNumber;
      } else {
        this.model = '';
      }
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminUserMultSelect',
  props: {
    value: {
      type: Array },
    status: {
      type: [Number, String],
      default: 1
    },
    adminGroupCode: {
      type: String,
      default: ''
    },
    groupTitles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    needDefaultStudyAdviser: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      adminGroupList: [{ id: 4, code: 'userStudyAdviser' }, { id: 6, code: 'marketGroup' }, { id: 7, code: 'tchStudyAdviser' }, { id: 10, code: 'adviser' }],
      adminUserList: [],
      model: [] };
  },

  methods: {
    getAdminGroupId: function getAdminGroupId() {
      var adminGroupId = '';
      if (this.adminGroupCode === '') {
        return adminGroupId;
      }
      var code = this.adminGroupCode;
      this.adminGroupList.forEach(function (element) {
        if (element.code === code) {
          adminGroupId = element.id;
          return;
        }
      });
      return adminGroupId;
    },
    onChange: function onChange(value) {
      this.$emit('input', value);
    },
    loadByGroupTitles: function loadByGroupTitles() {
      var self = this;
      var wanted = {};
      self.groupTitles.forEach(function (title) {
        wanted[(title || '').trim()] = true;
      });
      self.$http.get('/adminGroup/listByCondition', { params: { status: 1 } }).then(function (res) {
        var groups = res && res.data ? res.data : [];
        if (!Array.isArray(groups)) {
          groups = groups.data || [];
        }
        var ids = [];
        groups.forEach(function (group) {
          var title = (group && group.title || '').trim();
          if (wanted[title]) {
            ids.push(group.id);
          }
        });
        if (!ids.length) {
          self.adminUserList = [];
          return;
        }
        self.$http.post('/adminUser/listByCondition', { status: self.status, groupIds: ids }).then(function (userRes) {
          var list = userRes && userRes.data ? userRes.data : [];
          if (!Array.isArray(list)) {
            list = [];
          }
          var seen = {};
          self.adminUserList = list.filter(function (user) {
            if (!user || seen[user.id]) {
              return false;
            }
            seen[user.id] = true;
            return true;
          });
        });
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    if (self.groupTitles && self.groupTitles.length) {
      self.loadByGroupTitles();
      return;
    }
    var params = { status: self.status, adminGroupId: self.getAdminGroupId(), needDefaultStudyAdviser: self.needDefaultStudyAdviser };
    self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
      if (res && res.data) {
        self.adminUserList = res.data;
      } else {
        self.adminUserList = [];
      }
    });
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.model = val;
      } else {
        this.model = [];
      }
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminUserSelect',
  props: {
    value: {
      type: [Number, String]
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    status: {
      type: [Number, String],
      default: 1
    },
    adminGroupCode: {
      type: String,
      default: ''
    },
    needDefaultStudyAdviser: {
      type: Number,
      default: 1
    },
    notInId: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    restrictToSelf: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      adminGroupList: [{ id: 4, code: 'userStudyAdviser' }, { id: 7, code: 'tchStudyAdviser' }, { id: 10, code: 'adviser' }, { id: 6, code: 'market' }],
      adminUserList: [],
      model: ''
    };
  },

  methods: {
    getAdminGroupId: function getAdminGroupId() {
      var adminGroupId = '';
      if (this.adminGroupCode === '') {
        return adminGroupId;
      }
      var code = this.adminGroupCode;
      this.adminGroupList.forEach(function (element) {
        if (element.code === code) {
          adminGroupId = element.id;
        }
      });
      return adminGroupId;
    },
    onChange: function onChange(value) {
      this.$emit('input', value);
      this.$emit('on-change', value);
    },
    onClear: function onClear() {
      this.$emit('input', null);
      this.$emit('on-clear');
    }
  },
  created: function created() {
    if (this.value) {
      this.model = parseInt(this.value);
    }
  },
  mounted: function mounted() {
    var self = this;
    var params = { status: self.status, adminGroupId: self.getAdminGroupId(), needDefaultStudyAdviser: self.needDefaultStudyAdviser };
    self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
      if (res && res.data) {
        var uniqueData = [];
        var idSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        res.data.forEach(function (item) {
          if (!idSet.has(item.id)) {
            idSet.add(item.id);
            uniqueData.push(item);
          }
        });

        if (self.notInId && self.notInId.length > 0) {
          self.adminUserList = uniqueData.filter(function (item) {
            return !self.notInId.includes(item.id);
          });
        } else {
          self.adminUserList = uniqueData;
        }

        if (self.restrictToSelf && self.$store.get('depLeader') !== true) {
          var currentUserId = self.$store.get('id');
          self.adminUserList = self.adminUserList.filter(function (item) {
            return item.id === currentUserId;
          });
        }
        if (self.disabled) {
          var _currentUserId = parseInt(self.$store.get('id'));
          self.adminUserList = self.adminUserList.filter(function (item) {
            return item.id === _currentUserId;
          });
          if (self.adminUserList.length === 0 && _currentUserId) {
            self.adminUserList = [{ id: _currentUserId, nickname: '本人', phone: '' }];
          }
          self.model = _currentUserId;
          self.$emit('input', _currentUserId);
        }
      } else {
        self.adminUserList = [];
      }
    });
  },
  watch: {
    value: function value(val) {
      if (val) {
        var idNumber = parseInt(val);
        this.model = idNumber;
      } else {
        this.model = null;
      }
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdviserFloatModal',
  props: {},
  data: function data() {
    var $constant = this.$constant;
    return {
      adviserId: null,
      teamType: 0,
      adviserSelectDisable: true,
      adviserGroupSelectDisable: true,
      adviserGroupList: $constant.adviserGroup,
      adviserList: [],
      adviserIdList: []
    };
  },

  methods: {
    getAdviserList: function getAdviserList(teamType, adviserId, positionType) {
      var self = this;
      self.adviserIdList = [];
      if (positionType === 1) {
        self.adviserIdList.push(adviserId);
        self.$emit('get_adviser', { adviserId: adviserId, teamType: teamType, adviserIds: self.adviserIdList });
      } else {
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.adviserList = res.data;
            if (adviserId > 0) {
              self.adviserIdList.push(adviserId);
            } else {
              for (var i in self.adviserList) {
                self.adviserIdList.push(self.adviserList[i].adviserId);
              }
            }
            self.$emit('get_adviser', { adviserId: adviserId, teamType: teamType, adviserIds: self.adviserIdList });
          }
        });
      }
    },
    onTeamTypeChange: function onTeamTypeChange(value) {
      var self = this;
      self.adviserId = null;
      self.adviserIdList = [];
      self.getAdviserList(value, 0, null);
    },
    onAdviserIdChange: function onAdviserIdChange(value) {
      if (value === null) {
        return;
      }
      var self = this;
      self.adviserIdList = [];
      if (value > 0) {
        self.adviserIdList[0] = value;
      } else if (value === '0') {
        for (var i in self.adviserList) {
          self.adviserIdList.push(self.adviserList[i].adviserId);
        }
      }
      self.$emit('get_adviser', { adviserId: value, teamType: self.teamType, adviserIds: self.adviserIdList });
    }
  },
  watch: {},
  created: function created() {
    var permissions = this.$store.get('permissions');
    if (permissions.indexOf('all') >= 0) {
      this.adviserGroupSelectDisable = false;
      this.adviserSelectDisable = false;
      this.teamType = 0;
      this.adviserId = 0;
      this.getAdviserList(this.teamType, this.adviserId, null);
    } else if (this.$store.get('adviserInfo')) {
      this.adviserGroupSelectDisable = this.$store.get('adviserInfo').positionType !== 9;
      this.adviserSelectDisable = this.$store.get('adviserInfo').positionType === 1;
      this.teamType = this.$store.get('adviserInfo').teamType;
      this.adviserList[0] = this.$store.get('adviserInfo');
      this.adviserId = this.$store.get('adviserInfo').adviserId;
      this.getAdviserList(this.teamType, this.adviserId, this.$store.get('adviserInfo').positionType);
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelSelect',
  props: {
    value: {
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      channelList: [],
      model: ''
    };
  },

  methods: {
    onChange: function onChange(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('channel/queryall?status=1').then(function (res) {
      if (res && res.data) {
        self.channelList = res.data;
      } else {
        self.channelList = [];
      }
    });
  },
  watch: {
    value: function value(val) {
      this.model = val;
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview_src_components_checkbox_checkbox__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview_src_components_checkbox_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_iview_src_components_checkbox_checkbox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Checkbox: __WEBPACK_IMPORTED_MODULE_0_iview_src_components_checkbox_checkbox___default.a },
  name: 'CheckBox',
  props: {
    boxList: {
      type: Array,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      box: [],
      itemArray: [],
      returnArray: []
    };
  },

  methods: {
    selectArray: function selectArray() {
      var self = this;
      self.returnArray = [];
      for (var index = 0; index < self.itemArray.length; index++) {
        if (self.itemArray[index]) {
          self.returnArray.push(self.itemArray[index]);
        }
      }
      self.$emit('on-select-change', self.returnArray);
    }
  },
  watch: {
    boxList: function boxList(val) {
      this.box = val;
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_provinces_js__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_provinces_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plugins_provinces_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    provinceName: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    cityName: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    blockName: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  name: 'app',
  created: function created() {
    var beijing = this.provinces.slice(0, 19);
    this.cities = beijing.filter(function (item) {
      if (item.level === 2) {
        return true;
      }
    });
    this.selectedCity = this.cities[0];
    this.blocks = beijing.filter(function (item) {
      if (item.level === 3) {
        return true;
      }
    });
    this.selectedBlock = this.blocks[0];
  },

  watch: {
    provinceName: function provinceName(val) {
      var self = this;
      if (val) {
        self.selectAreaByAreaName(val, this.cityName, this.blockName);
      }
    },
    selectedProvince: function selectedProvince(newVal, oldVal) {
      var _this = this;

      if (newVal.sheng === '71' || newVal.sheng === '81' || newVal.sheng === '82') {
        this.cities = [newVal];
        this.blocks = [newVal];
      } else {
        this.cities = this.provinces.filter(function (item) {
          if (item.level === 2 && item.sheng && newVal.sheng === item.sheng) {
            return true;
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
        if (_this.cityName) {
          return;
        }
        _this.selectedCity = _this.cities[0];
        _this.$emit('input', _this.info);
      });
    },
    selectedBlock: function selectedBlock() {
      var _this2 = this;

      if (this.blockName) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
        _this2.$emit('input', _this2.info);
      });
    },
    selectedCity: function selectedCity(newVal) {
      var _this3 = this;

      if (newVal.sheng === '71' || newVal.sheng === '81' || newVal.sheng === '82') {
        this.blocks = [newVal];
        this.cities = [newVal];
      } else {
        this.blocks = this.provinces.filter(function (item) {
          if (item.level === 3 && item.sheng && item.sheng === newVal.sheng && item.di === newVal.di && item.name !== '市辖区') {
            return true;
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
        if (_this3.blockName) {
          return;
        }
        _this3.selectedBlock = _this3.blocks[0];

        _this3.$emit('input', _this3.info);
      });
    }
  },
  computed: {
    info: function info() {
      return {
        province: this.selectedProvince,
        city: this.selectedCity,
        block: this.selectedBlock
      };
    }
  },
  data: function data() {
    return {
      selectedProvince: __WEBPACK_IMPORTED_MODULE_0__plugins_provinces_js___default.a[0],
      selectedCity: 0,
      selectedBlock: 0,
      cities: 0,
      provinces: __WEBPACK_IMPORTED_MODULE_0__plugins_provinces_js___default.a,
      blocks: 0
    };
  },

  methods: {
    selectAreaByAreaName: function selectAreaByAreaName(province, city, block) {
      for (var index = 0; index < this.provinces.length; index++) {
        if (this.provinces[index].name === province) {
          this.selectedProvince = this.provinces[index];
        }
        if (this.provinces[index].name === city) {
          this.selectedCity = this.provinces[index];
        }
        if (this.provinces[index].name === block) {
          this.selectedBlock = this.provinces[index];
        }
      }
      this.$emit('input', this.info);
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var PREVIEWABLE = ['image', 'video', 'audio', 'pdf', 'office', 'csv'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FilePreview',
  props: {
    fileUrl: { type: String, default: '' },
    type: { type: String, default: '' },
    fileName: { type: String, default: '' },
    previewApi: { type: String, default: '/tchLearningMaterial/previewTable' }
  },
  data: function data() {
    return {
      csvHeaders: [],
      csvRows: [],
      tableLoading: false,
      tableError: ''
    };
  },

  computed: {
    httpsUrl: function httpsUrl() {
      return this.toHttps(this.fileUrl);
    },
    resolvedType: function resolvedType() {
      var fromUrl = this.guessType(this.httpsUrl || this.fileUrl);
      if (PREVIEWABLE.indexOf(fromUrl) >= 0) return fromUrl;
      var fromName = this.guessType(this.fileName);
      if (PREVIEWABLE.indexOf(fromName) >= 0) return fromName;
      var t = (this.type || '').toLowerCase();
      if (t === 'text/csv' || t === 'xls' || t === 'xlsx') return 'csv';
      if (t === 'doc' || t === 'docx' || t === 'ppt' || t === 'pptx') return 'office';
      if (PREVIEWABLE.indexOf(t) >= 0) return t;
      return fromUrl || fromName || t;
    },
    officeViewerUrl: function officeViewerUrl() {
      return 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(this.httpsUrl || '');
    }
  },
  watch: {
    fileUrl: { immediate: true, handler: function handler() {
        this.loadCsvTable();
      }
    },
    resolvedType: function resolvedType() {
      this.loadCsvTable();
    }
  },
  methods: {
    toHttps: function toHttps(url) {
      if (!url) return url;
      var s = String(url).trim();
      if (!s) return url;

      if (/^https:\/\//i.test(s)) return s;
      if (/^http:\/\//i.test(s)) return 'https://' + s.substring(7);
      if (s.indexOf('//') === 0) return 'https:' + s;

      if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}(:\d+)?(\/|$)/i.test(s)) return 'https://' + s;

      if (s.charAt(0) === '/') return 'https://medias.kouyujie.cn' + s;
      return 'https://medias.kouyujie.cn/' + s;
    },
    guessType: function guessType(name) {
      if (!name) return '';
      var lower = String(name).toLowerCase();
      var path = lower.split('?')[0].split('#')[0];
      if (path === 'text/csv') return 'csv';
      var ext = path.split('.').pop();
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].indexOf(ext) >= 0) return 'image';
      if (['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v'].indexOf(ext) >= 0) return 'video';
      if (['mp3', 'wav', 'aac', 'ogg', 'm4a'].indexOf(ext) >= 0) return 'audio';
      if (ext === 'pdf') return 'pdf';
      if (['doc', 'docx', 'ppt', 'pptx'].indexOf(ext) >= 0) return 'office';
      if (['csv', 'xls', 'xlsx'].indexOf(ext) >= 0) return 'csv';
      return ext;
    },
    loadCsvTable: function loadCsvTable() {
      this.csvHeaders = [];
      this.csvRows = [];
      this.tableError = '';
      this.tableLoading = false;
      if (this.resolvedType !== 'csv' || !this.httpsUrl) return;
      var self = this;
      var url = this.httpsUrl;
      self.tableLoading = true;
      self.$http.get(self.previewApi, { params: { url: url } }).then(function (res) {
        if (self.httpsUrl !== url) return;
        self.tableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.csvHeaders = res.data.headers || [];
          self.csvRows = res.data.rows || [];
          if (!self.csvHeaders.length) self.tableError = 'Preview is empty.';
        } else {
          self.tableError = res && res.msg || 'Preview failed.';
        }
      }).catch(function () {
        if (self.httpsUrl !== url) return;
        self.tableLoading = false;
        self.tableError = 'Preview failed.';
      });
    },
    download: function download() {
      if (this.httpsUrl) window.open(this.httpsUrl, '_blank');
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileUpload',
  props: {
    defaultFileList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    params: {
      type: [Array, Object],
      default: function _default() {
        return { bucket: 'ting' };
      }
    },
    num: {
      type: [Number],
      default: function _default() {
        return 1;
      }
    },
    accept: {
      type: String,
      default: function _default() {
        return '*';
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '点击或将文件拖拽到这里上传';
      }
    }
  },
  data: function data() {
    return {
      action: '',
      data: this.params,
      headers: {},
      visible: false,
      fileList: [],
      fileIndex: 1
    };
  },

  methods: {
    handleRemove: function handleRemove(file) {
      var fileList = this.fileList;
      this.fileList.splice(fileList.map(function (item) {
        return item.uid;
      }).indexOf(file.uid), 1);
      this.emitInput(this.fileList);
    },
    onRemove: function onRemove(file, fileList) {
      this.emitInput(fileList);
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (this.fileList.length > this.num) {
        return;
      }

      this.$Message.destroy();
      this.$Message.info('上传成功');

      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;

      this.fileList.push(file);

      this.emitInput(this.fileList);
    },
    beforeUpload: function beforeUpload() {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }

      if (this.fileList.length >= this.num) {
        this.$Message.warning('上传文件不能超过 ' + this.num + ' 个');
        return false;
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    onProgress: function onProgress(event, file) {},
    emitInput: function emitInput(fileList) {
      var v = fileList.map(function (item) {
        return { name: item.name, url: item.url, fileId: item.fileId, size: item.size };
      });
      this.$emit('on-file-change', v);
      this.$emit('input', v.map(function (item) {
        return item.name;
      }).join(','));
    }
  },
  watch: {
    defaultFileList: function defaultFileList(fileList) {
      var _this = this;

      this.fileList = fileList.map(function (item) {
        item.status = 'finished';
        item.percentage = 100;
        item.uid = Date.now() + _this.fileIndex++;
        return item;
      });
    }
  },
  created: function created() {
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
    this.fileList = this.defaultFileList;
  },
  mounted: function mounted() {}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageUpload',
  props: {
    defaultFileList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return { bucket: 'hellokid' };
      }
    },
    num: {
      type: [Number],
      default: function _default() {
        return 1;
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '点击或将文件拖拽到这里上传';
      }
    },
    isView: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      action: '',
      visible: false,
      headers: {},
      data: this.params,
      largeImageUrl: '',
      fileList: [],
      fileIndex: 1,
      showIndex: 0,
      fileIndexList: [],
      fileUploadMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    handleView: function handleView(index) {
      this.showIndex = index;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.fileList;
      var defaultFileList = this.defaultFileList;
      this.fileList.splice(fileList.map(function (item) {
        return item.uid;
      }).indexOf(file.uid), 1);
      this.defaultFileList.splice(defaultFileList.map(function (item) {
        return item.name;
      }).indexOf(file.name), 1);
      this.emitInput(this.fileList);
    },
    onSuccess: function onSuccess(res, file, fileList) {
      if (this.fileList.length > this.num) {
        return;
      }

      this.$Message.destroy();
      this.$Message.info('上传成功');
      file.uid = Date.now() + this.fileIndex++;
      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;
      this.fileUploadMap.set(res.data.fileName, file);
      this.sortFileList(this.fileUploadMap);
      this.emitInput(this.fileList);
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }

      if (this.fileList.length >= this.num) {
        this.$Message.warning('上传文件不能超过 ' + this.num + ' 个');
        return false;
      }
      this.fileIndexList.push(file.name);
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    emitInput: function emitInput(fileList) {
      var list = [];
      for (var i in fileList) {
        if (fileList[i]) {
          list.push(fileList[i]);
        }
      }
      var v = list.map(function (item) {
        return { name: item.name, url: item.url, fileId: item.name, size: item.size };
      });
      this.$emit('on-file-change', v);
      this.$emit('input', v.map(function (item) {
        return item.fileId;
      }).join(','));
    },
    onCarouselClick: function onCarouselClick() {
      this.visible = false;
    },
    sortFileList: function sortFileList(map) {
      this.fileList = [];
      for (var i in this.defaultFileList) {
        if (this.defaultFileList[i]) {
          this.fileList.push(this.defaultFileList[i]);
        }
      }
      if (!map) {
        return;
      }
      if (this.fileIndexList == null || this.fileIndexList.length <= 0) {
        return;
      }
      for (var index = 0; index < this.fileIndexList.length; index++) {
        if (this.fileUploadMap.get(this.fileIndexList[index])) {
          this.fileList.push(this.fileUploadMap.get(this.fileIndexList[index]));
        }
      }
    }
  },
  watch: {
    defaultFileList: function defaultFileList(fileList) {
      var _this = this;

      this.fileUploadMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      this.fileIndexList = [];
      this.fileList = fileList.map(function (item) {
        item.status = 'finished';
        item.percentage = 100;
        item.uid = Date.now() + _this.fileIndex++;
        return item;
      });
    }
  },
  created: function created() {
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
    this.fileList = this.defaultFileList;
  },
  mounted: function mounted() {}
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageUploadNew',
  props: {
    defaultFileList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return { bucket: 'hellokid' };
      }
    },
    num: {
      type: [Number],
      default: function _default() {
        return 1;
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '点击或将文件拖拽到这里上传';
      }
    },
    isView: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      action: '',
      visible: false,
      headers: {},
      data: this.params,
      largeImageUrl: '',
      fileList: [],
      fileIndex: 1,
      showIndex: 0,
      fileIndexList: [],
      fileUploadMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    handleView: function handleView(index) {
      this.showIndex = index;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.fileList;
      var defaultFileList = this.defaultFileList;
      this.fileList.splice(fileList.map(function (item) {
        return item.uid;
      }).indexOf(file.uid), 1);
      this.defaultFileList.splice(defaultFileList.map(function (item) {
        return item.name;
      }).indexOf(file.name), 1);
      this.emitInput(this.fileList);
    },
    onSuccess: function onSuccess(res, file, fileList) {
      if (this.fileList.length > this.num) {
        return;
      }

      this.$Message.destroy();
      this.$Message.info('上传成功');
      file.uid = Date.now() + this.fileIndex++;
      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;
      this.fileUploadMap.set(res.data.fileName, file);
      this.sortFileList(this.fileUploadMap);
      this.emitInput(this.fileList);
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }

      if (this.fileList.length >= this.num) {
        this.$Message.warning('上传文件不能超过 ' + this.num + ' 个');
        return false;
      }
      this.fileIndexList.push(file.name);
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    emitInput: function emitInput(fileList) {
      var list = [];
      for (var i in fileList) {
        if (fileList[i]) {
          list.push(fileList[i]);
        }
      }
      var v = list.map(function (item) {
        return { name: item.name, url: item.url, fileId: item.name, size: item.size };
      });
      this.$emit('on-file-change', v);
      this.$emit('input', v.map(function (item) {
        return item.url;
      }).join(','));
    },
    onCarouselClick: function onCarouselClick() {
      this.visible = false;
    },
    sortFileList: function sortFileList(map) {
      this.fileList = [];
      for (var i in this.defaultFileList) {
        if (this.defaultFileList[i]) {
          this.fileList.push(this.defaultFileList[i]);
        }
      }
      if (!map) {
        return;
      }
      if (this.fileIndexList == null || this.fileIndexList.length <= 0) {
        return;
      }
      for (var index = 0; index < this.fileIndexList.length; index++) {
        if (this.fileUploadMap.get(this.fileIndexList[index])) {
          this.fileList.push(this.fileUploadMap.get(this.fileIndexList[index]));
        }
      }
    }
  },
  watch: {
    defaultFileList: function defaultFileList(fileList) {
      var _this = this;

      this.fileUploadMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      this.fileIndexList = [];
      this.fileList = fileList.map(function (item) {
        item.status = 'finished';
        item.percentage = 100;
        item.uid = Date.now() + _this.fileIndex++;
        return item;
      });
    }
  },
  created: function created() {
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
    this.fileList = this.defaultFileList;
  },
  mounted: function mounted() {}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  props: {
    listUrl: {
      type: [String],
      default: function _default() {
        return '';
      }
    },
    params: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    tableColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reload: {
      type: Number,
      default: function _default() {
        return new Date().getTime();
      }
    },
    reloadWithPage: {
      type: Number,
      default: function _default() {
        return new Date().getTime();
      }
    },
    onLoading: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    pageSize: {
      type: Number,
      default: function _default() {
        return 10;
      }
    },
    showSizer: {
      type: Boolean,
      default: false
    },
    pageSizeOpts: {
      type: Array,
      default: function _default() {
        return [10, 20, 50, 100];
      }
    },
    syncRoute: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    height: null,
    stripe: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      type: Function,
      default: function _default() {
        return function () {
          return '';
        };
      }
    }
  },
  data: function data() {
    return {
      innerColumns: this.tableColumns,
      tableData: [],
      queryParam: {},
      totalCount: 0,
      page: {
        pageIndex: 1,
        pageSize: this.pageSize
      },
      ignorePageChange: false,
      lastId: null };
  },

  mounted: function mounted() {},
  methods: {
    search: function search() {
      this.searchList('init');
    },
    searchList: function searchList(type) {
      var self = this;
      if (!this.listUrl) {
        return;
      }
      if (type === 'init') {
        this.page.pageIndex = 1;
        this.lastId = null;
      }

      this.queryParam = {};
      this.$helper.mergeProperties(this.params, this.queryParam);
      this.$helper.mergeProperties(this.page, this.queryParam);

      if (this.lastId !== null && this.lastId !== undefined && this.lastId !== '') {
        this.queryParam.minId = this.lastId;
      } else {
        delete this.queryParam.minId;
      }

      this.handleLoading(true);
      var loading = this.$Message.loading({
        content: '服务器疯狂处理中...',
        duration: 0
      });
      this.$http.post(this.listUrl, self.queryParam).then(function (res) {
        self.tableData = res.data.data || [];

        if (self.tableData && self.tableData.length > 0) {
          var lastItem = self.tableData[self.tableData.length - 1];
          if (lastItem && lastItem.id !== undefined && lastItem.id !== null) {
            self.lastId = lastItem.id;
          } else {
            self.lastId = null;
          }
        } else {
          self.lastId = null;
        }

        self.totalCount = res.data.totalCount;
        self.handleLoading(false);

        if (self.syncRoute) {
          self.$router.replace({
            query: self.queryParam
          });
        }
        loading();
      }).catch(function (e) {
        console.log(e);
        self.handleLoading(false);
        loading();
      });
    },
    changePageIndex: function changePageIndex(page) {
      if (this.ignorePageChange) {
        this.ignorePageChange = false;
        return;
      }
      this.page.pageIndex = page;
      this.searchList();
    },
    changePageSize: function changePageSize(size) {
      this.page.pageSize = size;
      this.ignorePageChange = true;
      this.searchList('init');
      var self = this;
      this.$nextTick(function () {
        self.ignorePageChange = false;
      });
    },
    handleLoading: function handleLoading(loading) {
      if (this.onLoading) {
        this.onLoading(loading);
      }
    },
    selectionChange: function selectionChange(selection) {
      this.$emit('on-selection-change', selection);
    },
    handleSortChange: function handleSortChange(column) {
      var order = column.order;
      if (order === 'normal') {
        order = '';
      }
      this.$emit('on-sort-change', column, column.key, order);
    }
  },
  watch: {
    params: function params(val) {
      this.queryParam = val;
    },
    reload: function reload(val) {
      if (val) {
        if (val === 119) {
          this.searchList();
          return;
        }
        this.searchList('init');
      }
    },
    tableColumns: function tableColumns(val) {
      this.innerColumns = val;
    },
    listUrl: function listUrl(val) {
      if (val) {
        this.searchList('init');
      }
    },
    reloadWithPage: function reloadWithPage(val) {
      if (val) {
        this.searchList();
      }
    },
    pageSize: function pageSize(val) {
      if (val) {
        this.page.pageSize = val;
      } else {
        this.page.pageSize = 10;
      }
    }
  },
  created: function created() {
    if (this.syncRoute === false) {
      this.searchList();
      return;
    }
    var routeQuery = this.$route.query;
    routeQuery.pageIndex && (this.page.pageIndex = parseInt(routeQuery.pageIndex));
    routeQuery.pageSize && (this.page.pageSize = parseInt(routeQuery.pageSize));
    delete routeQuery.pageIndex;
    delete routeQuery.pageSize;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.params, routeQuery);
    this.searchList();
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MultiUpload',
  props: {
    defaultFileList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return { bucket: 'hellokid' };
      }
    },
    num: {
      type: [Number],
      default: function _default() {
        return 1;
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '点击或将文件拖拽到这里上传';
      }
    }
  },
  data: function data() {
    return {
      action: '',
      visible: false,
      headers: {},
      data: this.params,
      largeImageUrl: '',
      fileList: [],
      fileIndex: 1,
      showIndex: 0,
      showImageUrl: ''
    };
  },

  methods: {
    handleView: function handleView(item) {
      this.showImageUrl = item.url;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.fileList;
      this.fileList.splice(fileList.map(function (item) {
        return item.uid;
      }).indexOf(file.uid), 1);
      this.emitInput(this.fileList);
    },
    onSuccess: function onSuccess(res, file, fileList) {
      if (this.fileList.length >= this.num) {
        return;
      }

      this.$Message.destroy();
      this.$Message.info('Upload success');

      file.uid = Date.now() + this.fileIndex++;
      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;

      this.fileList.push(file);

      this.emitInput(this.fileList);
    },
    beforeUpload: function beforeUpload() {
      console.log('this.fileList.length ', this.fileList.length >= this.num);
      if (this.fileList.length >= this.num) {
        this.$Message.warning('single file only');
        return;
      }
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('Processing...', 0);
      return true;
    },
    emitInput: function emitInput(fileList) {
      var v = fileList.map(function (item) {
        return { name: item.name, url: item.url, fileId: item.fileId, size: item.size };
      });
      this.$emit('on-file-change', v);
      this.$emit('input', v.map(function (item) {
        return item.fileId;
      }).join(','));
    },
    onCarouselClick: function onCarouselClick() {
      this.visible = false;
    }
  },
  watch: {
    defaultFileList: function defaultFileList(fileList) {
      var _this = this;

      this.fileList = fileList.map(function (item) {
        item.status = 'finished';
        item.percentage = 100;
        item.uid = Date.now() + _this.fileIndex++;
        return item;
      });
    }
  },
  created: function created() {
    this.fileList = [];
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PhoneAreaSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    },
    areaNumValue: {
      type: Number
    }
  },
  data: function data() {
    return {
      loading: false,
      model: this.value,
      items: null,
      arr: [],
      areaPhoneNum: '',
      placeNum: ''
    };
  },

  methods: {
    remoteMethod: function remoteMethod(query) {
      query = query === null ? '' : query.trim();
      if (query === null || query === '') {
        this.items = [];
        return;
      }
      var self = this;
      self.arr = [];
      self.loading = true;
      self.areaNums = self.$phoneArea.areaNum;
      for (var index = 0; index < self.areaNums.length; index++) {
        if (self.areaNums[index].name.cn.indexOf(query) >= 0 || self.areaNums[index].num === parseInt(query)) {
          self.arr.push(self.areaNums[index]);
        } else if (self.areaNums[index].name.en.indexOf(query) >= 0) {
          self.arr.push(self.areaNums[index]);
        } else if (self.areaNums[index].name.pinyin.indexOf(query) >= 0) {
          self.arr.push(self.areaNums[index]);
        }
      }
      self.items = self.arr;
      self.loading = false;
    },
    onChange: function onChange(value) {
      this.$emit('input', value);
      this.$emit('on-change', value);
    }
  },
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      this.model = val;
    },
    areaNumValue: function areaNumValue(val) {
      this.$refs.store.clearSingleSelect();
      if (!val) {
        this.placeNum = '';
      }
      if (val) {
        this.placeNum = '+' + val;
      }
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  props: {
    listUrl: {
      type: [String],
      default: function _default() {
        return '';
      }
    },
    params: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    tableColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reload: {
      type: Number,
      default: function _default() {
        return new Date().getTime();
      }
    },
    reloadWithPage: {
      type: Number,
      default: function _default() {
        return new Date().getTime();
      }
    },
    onLoading: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    reset: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    uid: {
      type: Number,
      default: function _default() {
        return null;
      }
    },
    height: null
  },
  data: function data() {
    return {
      innerColumns: this.tableColumns,
      tableData: [],
      queryParam: {},
      totalCount: 0,
      page: {
        pageIndex: 1,
        pageSize: 10
      }
    };
  },

  mounted: function mounted() {},
  methods: {
    search: function search() {
      this.searchList('init');
    },
    searchList: function searchList(type) {
      var self = this;
      if (!this.listUrl) {
        return;
      }
      if (type === 'init') {
        this.page.pageIndex = 1;
      }
      this.queryParam = {};
      this.queryParam.uid = this.uid;
      this.$helper.mergeProperties(this.params, this.queryParam);
      this.$helper.mergeProperties(this.page, this.queryParam);
      this.handleLoading(true);
      var loading = this.$Message.loading({
        content: '服务器疯狂处理中...',
        duration: 0
      });
      this.$http.post(this.listUrl, self.queryParam).then(function (res) {
        self.tableData = res.data.data;
        self.totalCount = res.data.totalCount;
        self.handleLoading(false);

        self.$router.replace({
          query: self.queryParam
        });
        loading();
      }).catch(function (e) {
        self.handleLoading(false);
        loading();
      });
    },
    changePageIndex: function changePageIndex(page) {
      this.page.pageIndex = page;
      this.searchList();
    },
    handleLoading: function handleLoading(loading) {
      if (this.onLoading) {
        this.onLoading(loading);
      }
    },
    selectionChange: function selectionChange(selection) {
      this.$emit('on-selection-change', selection);
    }
  },
  watch: {
    params: function params(val) {
      this.queryParam = val;
    },
    reload: function reload(val) {
      if (val) {
        this.search();
      }
    },
    tableColumns: function tableColumns(val) {
      this.innerColumns = val;
    },
    reset: function reset(val) {
      this.tableData = [];
    },
    data: function data(val) {
      if (val) {
        this.tableData = val.data.data;
        this.totalCount = val.data.totalCount;
        this.page.pageIndex = val.data.pageIndex;
      }
    },
    reloadWithPage: function reloadWithPage(val) {
      if (val) {
        this.searchList('init');
      }
    }
  },
  created: function created() {
    this.tableData = [];
    var routeQuery = this.$route.query;
    routeQuery.pageIndex && (this.page.pageIndex = parseInt(routeQuery.pageIndex));
    routeQuery.pageSize && (this.page.pageSize = parseInt(routeQuery.pageSize));
    delete routeQuery.pageIndex;
    delete routeQuery.pageSize;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.params, routeQuery);
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleButton',
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'primary';
      }
    },
    shape: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    icon: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    size: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    permissionName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    clickEvent: {
      type: Function
    }
  },
  data: function data() {
    return {
      buttonType: this.type,
      buttonShape: this.shape,
      buttonIcon: this.icon,
      buttonSize: this.size,
      buttonValue: this.value,
      isActive: true,
      permission: '',
      ruleButtons: null
    };
  },

  methods: {},
  mounted: function mounted() {
    var self = this;
    if (self.permissionName) {
      self.isActive = false;
      var buttons = self.ruleButtons;
      if (buttons) {
        if (buttons === 'all') {
          self.isActive = true;
        } else {
          for (var index = 0; index < buttons.length; index++) {
            if (buttons[index] === self.permissionName) {
              self.isActive = true;
            }
          }
        }
      }
    }
  },
  created: function created() {
    var self = this;
    self.$http.get('/adminRule/getUserRuleButton').then(function (res) {
      if (res.data) {
        self.ruleButtons = res.data;
      }
    });
  },
  watch: {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SalesAdviserSelect',
  props: {
    value: {
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      activityList: [],
      model: ''
    };
  },

  methods: {
    onChange: function onChange(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('userstatusreview/queryalladminuser').then(function (res) {
      if (res && res.data) {
        self.activityList = res.data;
      } else {
        self.activityList = [];
      }
    });
  },
  watch: {
    value: function value(val) {
      if (val) {
        var idNumber = parseInt(val);
        this.model = idNumber;
      } else {
        this.model = null;
      }
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SingleOnePicUpload',
  props: {
    text: {
      type: String,
      default: function _default() {
        return '点击上传';
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return { bucket: 'hellokid' };
      }
    },
    accept: {
      type: String,
      default: function _default() {
        return 'image/*';
      }
    }
  },
  data: function data() {
    return {
      action: '',
      headers: {},
      data: this.params,
      largeImageUrl: '',
      progress: false
    };
  },

  methods: {
    onSuccess: function onSuccess(res, file, fileList) {
      this.$Message.info('上传成功');

      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;

      this.emitInput(file);
    },
    beforeUpload: function beforeUpload() {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }

      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    emitInput: function emitInput(file) {
      this.$emit('on-file-change', file);
    }
  },
  watch: {},
  created: function created() {
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
  },
  mounted: function mounted() {}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentInfo',
  props: {
    name: {
      type: String
    },
    uid: {
      type: Number
    }
  },
  data: function data() {
    return {
      student: {},
      modal: false
    };
  },

  methods: {
    openStudentPage: function openStudentPage() {
      var self = this;
      this.$http.get('/adminUser/getStudentCenterToken').then(function (res) {
        if (res.data) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/adminUserLogin?mobile=' + self.student.mobile + '&token=' + res.data);
          } else {
            window.open('https://test-student.kouyujie.cn/adminUserLogin?mobile=' + self.student.mobile + '&token=' + res.data);
          }
        }
      });
    },
    show: function show() {
      var _this = this;

      if (!this.uid) {
        return;
      }
      this.$http.get('/userList/queryByUid', { params: { uid: this.uid } }).then(function (res) {
        _this.student = res.data || {};
        _this.modal = true;
      });
    }
  },
  mounted: function mounted() {},
  watch: {}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    }
  },
  data: function data() {
    return {
      studentList: [],
      loading: false,
      model: this.value
    };
  },

  methods: {
    remoteMethod: function remoteMethod(query) {
      query = query === null ? '' : query.trim();
      if (query === null || query === '') {
        this.studentList = [];
        return;
      }
      var self = this;
      self.loading = true;
      var params = { infoKeyword: query };
      self.$http.get('/user/listByCondition', { params: params }).then(function (res) {
        self.studentList = res.data;
        self.loading = false;
      });
    },
    onChange: function onChange(value) {
      this.$emit('input', value);

      var student = this.studentList.filter(function (item) {
        return item.id === value;
      })[0];
      this.$emit('change-select', student);

      if (student) {
        var name = student.id + ' ' + student.nickname;
        this.$emit('on-change', value, name);
      } else {
        this.$emit('on-change', value, '');
      }
    }
  },
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      this.model = val;
    }
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivitySelect',
  props: {
    value: {
      type: [Number, String]
    },
    openedId: {
      type: [Number],
      default: null
    },
    dataL: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      activityList: [],
      model: ''
    };
  },

  methods: {
    onChange: function onChange(value) {
      console.log('value', value);
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      if (val) {
        var idNumber = parseInt(val);
        this.model = idNumber;
      } else {
        this.model = '';
      }
    },
    dataL: function dataL(val) {
      this.activityList = val;
    }
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeacherSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    },
    status: {
      type: Number
    },
    isAudition: {
      type: Number
    },
    category: {
      type: [Array]
    },
    statusList: {
      type: [Array],
      default: []
    },
    isCanBound: {
      type: Number
    },
    uid: {
      type: Number
    }
  },
  data: function data() {
    return {
      teacherList: [],
      loading: false,
      model: this.value
    };
  },

  methods: {
    remoteMethod: function remoteMethod(query) {
      query = query === null ? '' : query.trim();
      if (query === null || query === '') {
        this.teacherList = [];
        return;
      }
      var self = this;
      self.loading = true;
      var params = { status: self.status, infoKeyword: query, isCanBound: self.isCanBound, isAudition: self.isAudition, uid: self.uid };
      var index = 0;
      self.category.forEach(function (element) {
        params['categories[' + index++ + ']'] = element;
      });
      self.statusList.forEach(function (element) {
        params['statusList[' + index++ + ']'] = element;
      });
      self.$http.get('/tch/listByCondition', { params: params }).then(function (res) {
        self.teacherList = res.data;
        self.loading = false;
      });
    },
    onChange: function onChange(value) {
      this.$emit('input', value);

      var tch = this.teacherList.filter(function (item) {
        return item.id === value;
      })[0];
      this.$emit('change-select', tch);

      if (tch) {
        var name = tch.firstName + ' ' + tch.lastName;
        this.$emit('on-change', value, name);
      } else {
        this.$emit('on-change', value, '');
      }
    }
  },
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      this.model = val;
    }
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeZoneSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    },
    timeZoneValue: {
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      loading: false,
      model: this.value,
      items: null,
      arr: [],
      placeNum: '',
      timeZones: this.$timeZone.timeZone
    };
  },

  methods: {
    remoteMethod: function remoteMethod(query) {
      query = query === null ? '' : query.trim();
      if (query === null || query === '') {
        this.items = [];
        return;
      }
      var self = this;
      self.arr = [];
      self.loading = true;
      for (var index = 0; index < self.timeZones.length; index++) {
        if (self.timeZones[index].name.word.indexOf(query) >= 0) {
          self.arr.push(self.timeZones[index]);
        }
      }
      self.items = self.arr;
      self.loading = false;
    },
    getByValue: function getByValue(query) {
      if (query === null || query === '') {
        return '';
      }
      var self = this;
      for (var index = 0; index < self.timeZones.length; index++) {
        if (self.timeZones[index].num === query) {
          return self.timeZones[index].name.word + '----------------时差：' + self.timeZones[index].num;
        }
      }
    },
    onChange: function onChange(obj) {
      this.$emit('input', obj);
      this.$emit('on-change', obj);
    }
  },
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      this.model = val;
    },
    timeZoneValue: function timeZoneValue(val) {
      this.$refs.timeZone.clearSingleSelect();
      if (!val) {
        this.placeNum = '';
      }
      if (val) {
        this.placeNum = this.getByValue(val);
      }
    }
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageUpload',
  props: {
    defaultFileList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return { bucket: 'hellokid' };
      }
    },
    num: {
      type: [Number],
      default: function _default() {
        return 1;
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '点击或将文件拖拽到这里上传';
      }
    }
  },
  data: function data() {
    return {
      action: '',
      visible: false,
      headers: {},
      data: this.params,
      largeImageUrl: '',
      fileList: [],
      fileIndex: 1,
      showIndex: 0,
      fileIndexList: [],
      fileUploadMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    handleView: function handleView(index) {
      this.showIndex = index;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.fileList;

      var index_ = fileList.map(function (item) {
        return item.uid;
      }).indexOf(file.uid);
      if (index_ > -1) {
        this.fileList.splice(index_, 1);
        this.defaultFileList.splice(index_, 1);
      }
      this.emitInput(this.fileList);
    },
    onSuccess: function onSuccess(res, file, fileList) {
      if (this.fileList.length > this.num) {
        return;
      }

      this.$Message.destroy();
      this.$Message.info('上传成功');
      file.uid = Date.now() + this.fileIndex++;
      file.url = res.data.url;
      file.name = res.data.name;
      file.fileId = res.data.fileId;
      file.size = res.data.size;
      this.fileUploadMap.set(res.data.fileName, file);
      this.sortFileList(this.fileUploadMap);
      this.emitInput(this.fileList);
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }

      if (this.fileList.length >= this.num) {
        this.$Message.warning('上传文件不能超过 ' + this.num + ' 个');
        return false;
      }
      this.fileIndexList.push(file.name);
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    emitInput: function emitInput(fileList) {
      var list = [];
      for (var i in fileList) {
        if (fileList[i]) {
          list.push(fileList[i]);
        }
      }
      var v = list.map(function (item) {
        return { name: item.name, url: item.url, fileId: item.name, size: item.size };
      });
      this.$emit('on-file-change', v);
      this.$emit('input', v.map(function (item) {
        return item.fileId;
      }).join(','));
    },
    onCarouselClick: function onCarouselClick() {
      this.visible = false;
    },
    sortFileList: function sortFileList(map) {
      this.fileList = [];
      for (var i in this.defaultFileList) {
        if (this.defaultFileList[i]) {
          this.fileList.push(this.defaultFileList[i]);
        }
      }
      if (!map) {
        return;
      }
      if (this.fileIndexList == null || this.fileIndexList.length <= 0) {
        return;
      }
      for (var index = 0; index < this.fileIndexList.length; index++) {
        if (this.fileUploadMap.get(this.fileIndexList[index])) {
          this.fileList.push(this.fileUploadMap.get(this.fileIndexList[index]));
        }
      }
    }
  },
  watch: {
    defaultFileList: function defaultFileList(fileList) {
      var _this = this;

      this.fileUploadMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      this.fileIndexList = [];
      this.fileList = fileList.map(function (item) {
        item.status = 'finished';
        item.percentage = 100;
        item.uid = Date.now() + _this.fileIndex++;
        return item;
      });
    }
  },
  created: function created() {
    this.action = this.$appConfig.baseUrl + '/upload/fileUpload';
    this.fileList = this.defaultFileList;
  },
  mounted: function mounted() {}
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookMaterialLessonsErr',
  data: function data() {
    var self = this;
    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      dateRange: ['', ''],
      queryParam: {
        materialVersionId: null,
        startTime: null,
        endTime: null,
        levelId: null,
        tchId: null,
        status: ''
      },
      levels: [],
      title: [{
        title: '老师ID/姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '课程标题',

        align: 'center',
        key: 'lesson'
      }, {
        title: '等级',

        align: 'center',
        key: 'level'
      }, {
        title: '版本',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var materialVersion = $constant.getEnum($constant.materialVersions, row.materialVersion);
          return h('span', materialVersion && materialVersion.text);
        }
      }, {
        title: '提交时间',
        width: 170,
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '内容',
        width: 200,
        align: 'center',
        key: 'remark'
      }, {
        title: '处理人',

        align: 'center',
        key: 'modifierName',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return h('span', '');
          }
          return h('span', row.modifierName);
        }
      }, {
        title: '处理时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return h('span', '');
          }
          return h('span', row.gmtModified);
        }
      }, {
        title: '处理方式',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var status = $constant.getEnum($constant.lessonErrStatus, row.status);
          return h('span', status && status.text);
        }
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return h('div', [h('a', { on: { click: function click() {
                  self.onEdit(row, 1);
                } } }, '已修改  '), h('a', { on: { click: function click() {
                  self.onEdit(row, 2);
                } } }, '错误提交  ')]);
          } else {
            return h('span', '');
          }
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query) {
      if (query.materialVersionId) {
        self.queryParam.materialVersionId = parseInt(query.materialVersionId);
      }
      if (query.startTime) {
        self.dateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
      if (query.endTime) {
        self.dateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
      if (query.levelId) {
        self.queryParam.levelId = parseInt(query.levelId);
      }
      if (query.tchId) {
        self.queryParam.tchId = parseInt(query.tchId);
      }
      if (query.status) {
        self.queryParam.status = parseInt(query.status);
      }
    }
  },
  created: function created() {
    var self = this;
    var query = self.$route.query;
    if (query) {
      if (query.startTime) {
        self.dateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
      if (query.endTime) {
        self.dateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
    }
    this.loadLevelIds();
  },
  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    loadLevelIds: function loadLevelIds(val) {
      var self = this;
      var url = '/bookMaterialLevel/listByCondition';
      if (val) {
        url = '/bookMaterialLevel/listByCondition?materialVersion=' + val;
      }
      self.$http.get(url).then(function (res) {
        if (res && res.data) {
          self.levels = res.data;
        }
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onEdit: function onEdit(row, status) {
      var self = this;
      var path = '/bookMaterialLessonsErr/update?id=' + row.id + '&status=' + status;
      self.$http.post(path, this.formData).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('审核成功!');
          self.search();
        }
      });
    },
    onDateChange: function onDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        var beginTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime();
        this.queryParam.startTime = parseInt(beginTime / 1000);
        this.dateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(beginTime, 'YYYY-MM-DD HH:mm:ss') + '';
        var endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        this.queryParam.endTime = parseInt(endTime / 1000);
        this.dateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(endTime, 'YYYY-MM-DD HH:mm:ss') + '';
      } else {
        this.dateRange = [];
        this.queryParam.startTime = null;
        this.queryParam.endTime = null;
      }
      this.search();
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this,
        _ref;

    var $constant = this.$constant;
    return {
      statusList: $constant.enabledStatus,
      classReviewId: null,
      isDisabled: false,
      reload: 0,
      text: '选项',
      answerText: '答案',
      SecondlyContext: '次内容',
      searchLoading: false,
      editModal: false,
      questionDevList: [{ id: 1, text: '题型1' }, { id: 2, text: '题型2' }],
      answerMore: {},
      levelAll: [],
      levelAlls: [],
      lessonAll: [],
      lessonAlls: [],
      levelGrades: [],
      defaultPicList: [],
      pinPicList: [],
      defaultAudioList: [],
      selectDefaultImages: [],
      selectDefaultVideo: [],
      answerOneList: [{
        id: '1',
        info: '',
        answer: ''
      }],
      answerList: [{
        id: '1',
        info: '',
        answer: ''
      }, {
        id: '2',
        info: '',
        answer: ''
      }, {
        id: '3',
        info: '',
        answer: ''
      }, {
        id: '4',
        info: '',
        answer: ''
      }],
      manyContext: {},
      queryParam: {
        materialVersion: '',
        title: '',
        levelItem: '',
        lessonItem: ''
      },
      formDate: {
        id: '',
        pinPic: '',
        appraise: '',
        questionType: 1,
        questionDev: 1,
        content: '',
        video: '',
        levelQuestionSelectOneList: [{
          id: '1',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '2',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '3',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '4',
          info: '',
          pic: '',
          video: ''
        }],
        materialVersion: '',
        title: '',
        levelItem: '',
        lessonItem: '',
        name: '',
        voice: '',
        pic: '',
        answer: '',
        sort: '',
        status: 1,
        levelQuestionSelectDtoList: [{
          id: '1',
          info: '',
          pic: ''
        }, {
          id: '2',
          info: '',
          pic: ''
        }, {
          id: '3',
          info: '',
          pic: ''
        }]
      },
      ruleLevelGrade: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        lessonItem: [{ type: 'integer', required: true, message: '课程不能为空', trigger: 'blur' }],
        sort: [{ type: 'integer', required: true, message: '排序不能为空', trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '题目不能为空', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '状态不能为空', trigger: 'blur' }]
      },
      title: [{
        title: 'ID',

        align: 'center',
        key: 'id'
      }, {
        title: '序号',

        align: 'center',
        key: 'sort'
      }, {
        title: '课后题标题',

        align: 'center',
        key: 'title'
      }, {
        title: '考核内容',

        align: 'center',
        key: 'appraise',
        render: function render(h, params) {
          var ap = params.row.appraise;
          return h('span', $constant.getEnum($constant.lessonReviewAppraise, ap).text);
        }
      }, {
        title: '题型',

        align: 'center',
        key: 'questionType',
        render: function render(h, params) {
          var qt = params.row.questionType;
          var qd = params.row.questionDev;
          return h('span', $constant.getEnum($constant.lessonReviewQuestionType, qt).text + '-题型' + qd);
        }
      }, {
        title: '教材版本',

        align: 'center',
        key: 'materialVersion',
        render: function render(h, params) {
          var status = params.row.materialVersion;
          if (status === 1) {
            return h('span', '教材1.0');
          } else if (status === 2) {
            return h('span', '教材2.0');
          } else if (status === 3) {
            return h('span', '教材3.0');
          } else if (status === 4) {
            return h('span', '教材4.0');
          } else {
            return h('span', '其他');
          }
        }
      }, {
        title: '课程等级',

        align: 'center',
        key: 'titleLevel'
      }, {
        title: '课程标题',

        align: 'center',
        key: 'lessonTitle'
      }, {
        title: '状态',

        align: 'center',
        key: 'status',
        render: function render(h, params) {
          var status = params.row.status;
          if (status === 0) {
            return h('span', '未启用');
          } else if (status === 1) {
            return h('span', '启用');
          } else if (status === -1) {
            return h('span', '禁用');
          } else {
            return h('span', '未知');
          }
        }
      }, {
        title: '创建时间',

        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '更新时间',

        align: 'center',
        key: 'gmtModified'
      }, (_ref = {
        title: '操作',

        align: 'center'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'align', 'center'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'render', function render(h, params) {
        return h('div', [h('a', {
          on: {
            click: function click() {
              _this.onEdit(params.row);
            }
          }
        }, '编辑'), h('span', { class: 'divider' }, ' | '), h('a', {
          on: {
            click: function click() {
              _this.showStudentQuestion(params.row);
            }
          }
        }, '预览')]);
      }), _ref)]
    };
  },

  methods: {
    changeQuestionType: function changeQuestionType(val) {
      var self = this;
      if (val === 1) {
        self.questionDevList = [{ id: 1, text: '题型1' }, { id: 2, text: '题型2' }];
      } else if (val === 2) {
        self.questionDevList = [{ id: 1, text: '题型1' }, { id: 2, text: '题型2' }, { id: 3, text: '题型3' }];
      } else if (val === 3) {
        self.questionDevList = [{ id: 1, text: '题型1' }, { id: 2, text: '题型2' }];
      }

      if (!self.classReviewId) {
        this.answerList = [{
          id: '1',
          info: '',
          answer: ''
        }, {
          id: '2',
          info: '',
          answer: ''
        }, {
          id: '3',
          info: '',
          answer: ''
        }, {
          id: '4',
          info: '',
          answer: ''
        }];

        this.answerOneList = [{
          id: '1',
          info: '',
          answer: ''
        }];
        this.defaultPicList = [];
        this.defaultAudioList = [];
        this.selectDefaultImages = [];
        this.selectDefaultVideo = [];
      }
    },
    changeQuestionDev: function changeQuestionDev(val) {
      if (!this.classReviewId) {
        this.answerList = [{
          id: '1',
          info: '',
          answer: ''
        }, {
          id: '2',
          info: '',
          answer: ''
        }, {
          id: '3',
          info: '',
          answer: ''
        }, {
          id: '4',
          info: '',
          answer: ''
        }];
        this.answerOneList = [{
          id: '1',
          info: '',
          answer: ''
        }];
        this.defaultPicList = [];
        this.defaultAudioList = [];
        this.selectDefaultImages = [];
        this.selectDefaultVideo = [];
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    changeLevel: function changeLevel(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAll = res.data;
          }
        });
      }
    },
    changeModelLevel: function changeModelLevel(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAlls = res.data;
          }
        });
      }
    },
    medition: function medition(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res && res.data) {
            self.levelAll = res.data;
          }
        });
      }
    },
    meditions: function meditions(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res && res.data) {
            self.levelAlls = res.data;
          }
        });
      }
    },
    onAdd: function onAdd() {
      this.classReviewId = null;
      this.isDisabled = false;
      this.$helper.reset(this.formDate);
      this.formDate.questionType = 1;

      if (!this.formDate.levelQuestionSelectOneList) {
        this.formDate.levelQuestionSelectOneList = [{
          id: '1',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '2',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '3',
          info: '',
          pic: '',
          video: ''
        }, {
          id: '4',
          info: '',
          pic: '',
          video: ''
        }];
      }

      if (!this.answerOneList) {
        this.answerOneList = [{
          id: '1',
          info: '',
          answer: ''
        }];
      }

      if (!this.answerList) {
        this.answerList = [{
          id: '1',
          info: '',
          answer: ''
        }, {
          id: '2',
          info: '',
          answer: ''
        }, {
          id: '3',
          info: '',
          answer: ''
        }, {
          id: '4',
          info: '',
          answer: ''
        }];
      }
      this.defaultPicList = [];
      this.defaultAudioList = [];
      this.selectDefaultImages = [];
      this.selectDefaultVideo = [];
      this.answerMore = {};
      this.manyContext = {};
      this.editModal = true;
    },
    onDelete: function onDelete(row) {
      var self = this;
      if (row.id) {
        self.$http.post('/bookLessonNewReview/delete', { classReviewId: row.id }).then(function (res) {
          console.log(row.id);
          if (res && res.data > 0) {
            self.$Message.success('删除成功!');
            self.search();
          }
        });
      }
    },
    onEdit: function onEdit(row) {
      var self = this;
      if (row.id) {
        self.classReviewId = row.id;
        this.isDisabled = true;
        this.$http.get('/bookLessonNewReview/queryClassReviewById?classReviewId=' + row.id).then(function (res) {
          if (res && res.data) {
            row = res.data;
            self.$helper.copyProperties(row, self.formDate);
            if (row.materialVersion) {
              self.formDate.materialVersion = row.materialVersion;
            }
            if (row.levelId) {
              self.formDate.levelItem = row.levelId;
            }
            if (row.levelId) {
              self.formDate.lessonItem = row.lessonId;
            }

            self.defaultPicList = row.pic ? [{ name: row.pic + '', url: row.picUrl }] : [];
            self.defaultAudioList = row.video ? [{ name: row.video, url: row.videoUrl }] : [];
            self.pinPicList = row.pinPic ? [{ name: row.pinPic, url: row.pinPicUrl }] : [];

            if (self.formDate.levelQuestionSelectOneList && self.formDate.levelQuestionSelectOneList.length > 0) {
              for (var i in self.formDate.levelQuestionSelectOneList) {
                var item = self.formDate.levelQuestionSelectOneList[i];
                self.selectDefaultImages[i] = item.pic ? [{ name: item.pic + '', url: item.picUrl }] : [];
                self.selectDefaultVideo[i] = item.video ? [{ name: item.video + '', url: item.videoUrl }] : [];
              }
            }

            if (row.answer) {
              self.answerMore = JSON.parse(row.answer);
            }

            if (row.content) {
              self.formDate.content = row.content;
            }
            if (row.questionType === 3 && row.questionDev === 1) {
              self.manyContext = JSON.parse(row.content);
              self.formDate.content = self.manyContext[0];
            }
          }
        });
      }
      this.editModal = true;
    },
    insert: function insert() {
      var self = this;
      self.$refs.form.validate(function (valid) {
        if (valid) {
          if (self.formDate.levelQuestionSelectOneList) {
            for (var i in self.formDate.levelQuestionSelectOneList) {
              var item = self.formDate.levelQuestionSelectOneList[i];
              var s = {
                id: item.id,
                info: item.info,
                pic: item.pic,
                video: item.video
              };
              self.formDate.levelQuestionSelectOneList[i] = s;
            }
            self.formDate.select = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formDate.levelQuestionSelectOneList);
          }
          if (self.formDate.questionType === 3) {
            self.formDate.answer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.answerMore);
            if (self.formDate.questionDev === 1) {
              self.manyContext[0] = self.formDate.content;
              self.formDate.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.manyContext);
            }
          } else {
            self.formDate.answer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.answerMore);
          }
          self.formDate.lessonId = self.formDate.lessonItem;
          self.$http.post('/bookLessonNewReview/insert', self.formDate).then(function (res) {
            if (res && res.data > 0) {
              self.search();
              self.$Message.success('提交成功!');
              self.editModal = false;
              self.$helper.reset(self.formDate);
            }
          });
        } else {
          self.$Message.warning('表单验证失败!');
        }
      });
    },
    showStudentQuestion: function showStudentQuestion(row) {
      var lessonId = row.lessonId;
      var self = this;
      this.$http.get('/adminUser/getAdminToken?type=student').then(function (res) {
        if (res.data) {
          if (self.$appConfig.active === 'prod') {
            window.open('http://hellokid.speakstreet.cn/newReview/test?lessonId=' + lessonId + '&token=' + res.data);
          } else {
            window.open('http://test-student.kouyujie.cn/newReview/test?lessonId=' + lessonId + '&token=' + res.data);
          }
        }
      });
      return;
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      state: true,
      fileList: [],
      folderList: [],
      Account: '',
      name: '',
      accountList: []
    };
  },
  created: function created() {
    this.getFolderTop();
  },

  methods: {
    search: function search(acc, name) {
      var list = this.accountList;
      if (list.length > 0 && list[list.length - 1].id === acc) {
        return;
      }
      if (acc) {
        var floder = {};
        floder.name = name;
        floder.id = acc;
        this.accountList.push(floder);
      }
    },
    queryAgentMember: function queryAgentMember(account) {
      var floderList = this.accountList;
      var newArr = [];
      for (var i in floderList) {
        if (floderList[i].id === account) {
          newArr.push(floderList[i]);
          break;
        }
        if (floderList[i].id !== account) {
          newArr.push(floderList[i]);
        }
      }
      this.accountList = newArr;
      this.folderId = account;
      this.onSearchTop();
    },
    getFolderTop: function getFolderTop() {
      var self = this;
      self.state = true;
      this.accountList = [];
      this.folderList = [];
      this.fileList = [];
      self.$http.get('/classinFile/getTopFile').then(function (res) {
        if (res && res.data) {
          self.folderId = res.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    getFolderId: function getFolderId(value, name) {
      var self = this;
      self.onSearch(value, name);
    },
    onSearch: function onSearch(value, name) {
      var _this = this;

      this.state = false;
      this.search(value, name);
      this.$http.get('/classinFile/getCloudFileList?folderId=' + value).then(function (res) {
        if (res.data) {
          _this.fileList = res.data.fileList;
          _this.folderList = res.data.folderList;
        }
      });
    },
    onSearchTop: function onSearchTop() {
      var _this2 = this;

      this.state = false;
      this.$http.get('/classinFile/getCloudFileList?folderId=' + this.folderId).then(function (res) {
        if (res.data) {
          _this2.fileList = res.data.fileList;
          _this2.folderList = res.data.folderList;
        }
      });
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var self = this;
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      formData: {
        id: '',
        title: '',
        price: ''
      },
      formRule: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        price: [{ type: 'integer', required: true, message: '价格不能为空', trigger: 'blur' }]
      },
      editModal: false,
      loadingInsert: false,
      title: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '标题',
        key: 'title',
        align: 'center'
      }, {
        title: '价格',
        key: 'price',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                self.onEdit(params.row);
              } } }, '编辑')]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onEdit: function onEdit(row) {
      if (!row) {
        this.$helper.reset(this.formData);
        return;
      }
      this.$helper.copyProperties(row, this.formData);
      this.editModal = true;
    },
    edit: function edit() {
      var _this = this;

      var self = this;
      self.$refs.form.validate(function (valid) {
        if (valid) {
          var path = '/materialPrice/insert';
          self.$http.post(path, _this.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!');
              self.editModal = false;
              self.search();
            }
          });
        } else {
          self.$Message.warning('表单验证失败!');
        }
      });
    }
  },
  watch: {
    editModal: function editModal(val) {}
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'LessonAudioInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      id: null,
      levels: [],
      lessons: [],
      headers: {},
      fileList: [],
      loadingInsert: false,
      formData: {
        lessonId: null,
        levelId: '',
        audioUrl: '',
        version: null,
        title: ''
      },
      visible: this.value,
      audioRule: {
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }],
        audioUrl: [{ type: 'string', required: true, message: '请上传音频', trigger: 'blur' }],
        title: [{ type: 'string', required: true, message: '请输入音频标题', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      this.formData.audioUrl = res.data.name;
      this.audioUrl = res.data.url;
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$refs.audioForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
        self.$http.post('/bookLessonAudio/insert', self.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('新增成功!');
            self.loadingInsert = false;
            self.visible = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingInsert = false;
          self.$Message.error(e.msg);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.levels = [];
        this.lessons = [];
        this.fileList = [];
        this.formData = {};
        this.$emit('on-close', val);
      }
    }
  },
  mounted: function mounted() {},

  created: function created() {}
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonAudioInsertModal__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonAudioInsertModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LessonAudioInsertModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonAudioUpdateModal__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonAudioUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LessonAudioUpdateModal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LessonAudioUpdateModal: __WEBPACK_IMPORTED_MODULE_1__LessonAudioUpdateModal___default.a,
    LessonAudioInsertModal: __WEBPACK_IMPORTED_MODULE_0__LessonAudioInsertModal___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      onLoading: false,
      queryParam: {
        materialVersion: '',
        levelId: '',
        lessonId: '',
        title: ''
      },
      levels: [],
      lessons: [],
      showInsertModal: false,
      showUpdateModal: false,
      title: [{
        title: 'ID',
        key: 'lessonId',

        align: 'center'
      }, {
        title: '教材版本',
        key: 'materialVersion',

        align: 'center',
        render: function render(h, params) {
          var version = params.row.materialVersion;
          var materialVersion = $constant.getEnum($constant.materialVersions, version);
          return h('span', materialVersion && materialVersion.text);
        }
      }, {
        title: '课程等级',
        key: 'levelTitle',

        align: 'center'
      }, {
        title: '课程标题',
        key: 'lessonTitle',

        align: 'center'
      }, {
        title: '音频标题',
        key: 'title',

        align: 'center'
      }, {
        title: '音频地址',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.audioUrl) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(row.audioUrl);
                } } }, row.audioUrl);
          } else {
            return h('span');
          }
        }
      }, {
        title: '创建时间',
        key: 'gmtCreate',
        width: 170,
        align: 'center'
      }, {
        title: '创建人',
        key: 'creatorName',

        align: 'center'
      }, {
        title: '更新时间',
        key: 'gmtModified',
        align: 'center',
        width: 170
      }, {
        title: '最新操作人',
        key: 'modifierName',

        align: 'center'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var spans = [h('a', { on: { click: function click() {
                return _this.editLesson(row.lessonId);
              } } }, '编辑')];
          if (row.id) {
            spans.push(h('span', ' | '));
            spans.push(h('a', { on: { click: function click() {
                  return _this.delete(row.id);
                } } }, '删除'));
          }
          return h('span', spans);
        }
      }],
      id: null
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query) {
      if (query.materialVersion) {
        self.queryParam.materialVersion = query.materialVersion;
      }
      if (query.levelId) {
        self.queryParam.levelId = parseInt(query.levelId);
      }
      if (query.lessonId) {
        self.queryParam.lessonId = parseInt(query.lessonId);
      }
      if (query.title) {
        self.queryParam.title = query.title;
      }
    }
  },
  created: function created() {},
  methods: {
    delete: function _delete(id) {
      var self = this;
      if (id) {
        self.$Modal.confirm({
          title: '提示',
          content: '确认删除该音频？',
          width: 300,
          okText: '确定',
          onOk: function onOk() {
            self.$http.post('/bookLessonAudio/delById', { id: id }).then(function (res) {
              if (res.data > 0) {
                self.$Message.success('删除成功!');
                self.search();
              }
            }).catch(function (e) {
              self.$Message.error(e.msg);
            });
          }
        });
      }
    },
    showIndex: function showIndex(audioUrl) {
      if (audioUrl) {
        window.open('http://medias.kouyujie.cn/' + audioUrl + '?' + Date.parse(new Date()));
      }
    },
    addLessonVideo: function addLessonVideo() {
      this.showInsertModal = true;
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
      this.search();
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLessonChange: function onLessonChange(val) {
      this.queryParam.lessonId = val;
      this.search();
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
      this.search();
    },
    editLesson: function editLesson(id) {
      this.showUpdateModal = true;
      this.id = id;
    },
    closeModal: function closeModal() {
      this.showUpdateModal = false;
      this.showInsertModal = false;
      this.id = null;
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'LessonAudioUpdateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    id: {
      type: Number
    }
  },
  data: function data() {
    return {
      levels: [],
      lessons: [],
      headers: {},
      fileList: [],
      loadingUpdate: false,
      formData: {
        lessonId: null,
        levelId: null,
        audioUrl: '',
        version: null,
        id: null,
        title: ''
      },
      visible: this.value,
      audioRule: {
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }],
        audioUrl: [{ type: 'string', required: true, message: '请上传音频', trigger: 'blur' }]
      }
    };
  },

  methods: {
    showIndex: function showIndex(audioUrl) {
      if (audioUrl) {
        window.open('http://medias.kouyujie.cn/' + audioUrl + '?' + Date.parse(new Date()));
      }
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      this.formData.audioUrl = res.data.name;
      var fileName = res.data.fileName;
      this.formData.title = fileName.substring(0, fileName.lastIndexOf('.'));
      this.audioUrl = res.data.url;
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.audioForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        self.$http.post('/bookLessonAudio/update', self.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('修改成功!');
            self.loadingUpdate = false;
            self.visible = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingUpdate = false;
          self.$Message.error(e.msg);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.levels = [];
        this.lessons = [];
        this.fileList = [];
        this.formData = {};
        this.$emit('on-close', val);
      }
    },
    id: function id(val) {
      if (val) {
        var self = this;
        self.$http.get('/bookLessonAudio/queryById?lessonId=' + val).then(function (res) {
          if (res.data) {
            if (res.data.id) {
              self.formData.id = res.data.id;
            }
            self.formData.title = res.data.title;
            self.formData.audioUrl = res.data.audioUrl;
            self.formData.version = res.data.materialVersion;
            self.formData.levelId = parseInt(res.data.levelId);
            self.formData.lessonId = parseInt(res.data.lessonId);
          }
        });
      }
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonPreviewModal',
  props: {
    previewData: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      data: ''
    };
  },

  methods: {
    saveData: function saveData() {}
  },
  created: function created() {
    var html = localStorage.getItem('preview');
    this.data = html;
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.$emit('on-close', val);
      }
    },
    previewData: function previewData(val) {
      this.data = val;
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonPreview__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LessonPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__);






var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_1_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_1_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LessonPreviewModal: __WEBPACK_IMPORTED_MODULE_0__LessonPreview___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__["quillEditor"]
  },
  name: 'LessonPreviewInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    lessonId: {
      type: Number,
      default: null
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      id: null,
      levels: [],
      lessons: [],
      headers: {},
      uploadType: '',
      loadingInsert: false,
      fullscreenLoading: false,
      action: this.$appConfig.baseUrl + '/upload/fileUpload',
      acceptType: '',
      formData: {
        content: '',
        title: '',
        lessonId: null,
        status: '',
        version: null,
        levelId: ''
      },
      options: {},
      visible: this.value,
      insertUserParam: {
        regType: ''
      },
      previewRule: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }]
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  methods: {
    textChange: function textChange(val) {
      localStorage.setItem('preview', this.formData.content);
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      if (file) {
        var names = file.name.split('.');
        if (names.length > 0 && names[names.length - 1] === 'mp3') {
          this.uploadType = 'audio';
        }
      }
      this.fullscreenLoading = true;
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
    },
    imgHandler: function imgHandler(state) {
      this.uploadType = 'image';
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('imgInput');
        fileInput.click();
      }
    },
    videoHandler: function videoHandler(state) {
      this.uploadType = 'video';
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('imgInput');
        fileInput.click();
      }
    },
    upScuccess: function upScuccess(e, file, fileList) {
      var self = this;
      var response = file.response.data;
      if (!response || !response.url) {
        this.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        this.fullscreenLoading = false;
        return;
      }
      var url = response.url;
      if (url != null && url.length > 0) {
        self.addRange = self.$refs.myQuillEditor.quill.getSelection();
        var index = self.addRange != null ? self.addRange.index : 0;
        self.$refs.myQuillEditor.quill.insertEmbed(index, self.uploadType, url, 'user');
        this.fullscreenLoading = false;
      } else {
        this.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        this.fullscreenLoading = false;
      }
      self.uploadType = '';
      this.$refs['upload'].clearFiles();
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    openPreview: function openPreview() {
      var url = '/#/course/lessonPreview';
      window.open(url);
    },
    saveData: function saveData() {
      var _this = this;

      var self = this;
      self.loadingInsert = true;
      self.$refs.previewForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
        self.$http.post('/lessonPreview/insert', _this.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('新增成功!');
            self.loadingInsert = false;
            self.visible = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingInsert = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.levels = [];
      this.lessons = [];
      this.formData = {
        content: '',
        title: '',
        lessonId: null,
        status: '',
        version: null,
        levelId: ''
      };
      if (!val) {
        localStorage.removeItem('preview');
        this.$emit('on-close', val);
      }
    },
    lessonId: function lessonId(val) {
      if (val) {
        this.id = val;
      }
    }
  },
  mounted: function mounted() {
    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler);
    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);
  },

  created: function created() {}
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonPreviewInsertModal__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonPreviewInsertModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LessonPreviewInsertModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonPreviewUpdateModal__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonPreviewUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LessonPreviewUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeLessonPreviewInsertModal__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeLessonPreviewInsertModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NativeLessonPreviewInsertModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeLessonPreviewUpdateModal__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeLessonPreviewUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NativeLessonPreviewUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    NativeLessonPreviewInsertModal: __WEBPACK_IMPORTED_MODULE_2__NativeLessonPreviewInsertModal___default.a,
    NativeLessonPreviewUpdateModal: __WEBPACK_IMPORTED_MODULE_3__NativeLessonPreviewUpdateModal___default.a,
    LessonPreviewInsertModal: __WEBPACK_IMPORTED_MODULE_0__LessonPreviewInsertModal___default.a,
    LessonPreviewUpdateModal: __WEBPACK_IMPORTED_MODULE_1__LessonPreviewUpdateModal___default.a
  },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      insertPreviewModal: false,
      updatePreviewModal: false,
      nativeInsertModal: false,
      nativeUpdateModal: false,
      previewId: null,
      onLoading: false,
      queryParam: {
        materialVersion: '',
        title: '',
        levelId: '',
        lessonId: ''
      },
      levels: [],
      lessons: [],
      defaultPicList: [],
      defaultPicsList: [],
      defaultFileList: [],
      formData: {},
      formRule: {},
      editModal: false,
      loadingInsert: false,
      title: [{
        title: 'ID',
        key: 'id',

        align: 'center'
      }, {
        title: '预习题标题',
        key: 'title',

        align: 'center'
      }, {
        title: '教材版本',
        key: 'version',

        align: 'center'
      }, {
        title: '课程等级',
        key: 'levelTitle',

        align: 'center'
      }, {
        title: '课程标题',
        key: 'lessonTitle',

        align: 'center'
      }, {
        title: '状态',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return h('span', '未启用');
          } else if (row.status === 1) {
            return h('span', '启用');
          } else if (row.status === -1) {
            return h('span', '禁用');
          } else if (row.status === 2) {
            return h('span', '预览');
          }
        }
      }, {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        width: 170
      }, {
        title: '更新时间',
        key: 'updateTime',
        align: 'center',
        width: 170
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;

          return h('span', [h('a', { on: { click: function click() {
                return _this.editLesson(row.id);
              } } }, '编辑'), h('span', ' | '), h('a', { on: { click: function click() {
                return _this.showIndex(row.id);
              } } }, '预览')]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    showIndex: function showIndex(id) {
      this.$http.get('/lessonPreview/queryById?id=' + id).then(function (res) {
        if (res.data.indexUrl) {
          window.open(res.data.indexUrl + '?' + Date.parse(new Date()));
        }
      });
    },
    addNativePreview: function addNativePreview() {
      this.nativeInsertModal = true;
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
      this.search();
    },
    editLesson: function editLesson(val) {
      this.previewId = val;
      this.nativeUpdateModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLessonChange: function onLessonChange(val) {
      this.queryParam.lessonId = val;
      this.search();
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
      this.search();
    },
    closeModal: function closeModal() {
      this.previewId = null;
      this.insertPreviewModal = false;
      this.updatePreviewModal = false;
      this.nativeInsertModal = false;
      this.nativeUpdateModal = false;
    },
    addPreview: function addPreview() {
      this.insertPreviewModal = true;
    }
  },
  watch: {}
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LessonPreview__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LessonPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LessonPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill__);









var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_5_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_5_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LessonPreviewModal: __WEBPACK_IMPORTED_MODULE_3__LessonPreview___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__["quillEditor"]
  },
  name: 'LessonPreviewUpdateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    previewId: {
      type: Number,
      default: null
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      headers: {},
      uploadType: '',
      loadingInsert: false,
      fullscreenLoading: false,
      action: this.$appConfig.baseUrl + '/upload/fileUpload',
      acceptType: '',
      levelTitle: '',
      lessonTitle: '',
      formData: {
        id: null,
        content: '',
        title: '',
        status: null,
        version: null
      },
      options: {},
      visible: this.value,
      previewRule: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }]
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  methods: {
    textChange: function textChange(val) {
      localStorage.setItem('preview', this.formData.content);
    },
    beforeUpload: function beforeUpload(file) {
      if (file) {
        var names = file.name.split('.');
        if (names.length > 0 && names[names.length - 1] === 'mp3') {
          this.uploadType = 'audio';
        }
      }
      this.fullscreenLoading = true;
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
    },
    imgHandler: function imgHandler(state) {
      this.uploadType = 'image';
      this.addRange = this.$refs.updateQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('updateInput');
        fileInput.click();
      }
    },
    videoHandler: function videoHandler(state) {
      this.uploadType = 'video';
      this.addRange = this.$refs.updateQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('updateInput');
        fileInput.click();
      }
    },
    upScuccess: function upScuccess(e, file, fileList) {
      var self = this;
      var response = file.response.data;
      if (!response || !response.url) {
        self.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        self.fullscreenLoading = false;
        return;
      }
      var url = response.url;
      if (url != null && url.length > 0) {
        self.addRange = self.$refs.updateQuillEditor.quill.getSelection();
        var index = self.addRange != null ? self.addRange.index : 0;
        self.$refs.updateQuillEditor.quill.insertEmbed(index, self.uploadType, url, 'user');
        self.fullscreenLoading = false;
      } else {
        self.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        self.fullscreenLoading = false;
      }
      this.$refs['upload'].clearFiles();
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    openPreview: function openPreview() {
      var url = '/#/course/lessonPreview';
      window.open(url);
    },
    saveData: function saveData() {
      var _this = this;

      var self = this;
      self.loadingInsert = true;
      self.$refs.previewForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
        self.$http.post('/lessonPreview/update', _this.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('编辑成功!');
            self.loadingInsert = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingInsert = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.formData = {};
        localStorage.removeItem('preview');
        this.$emit('on-close', val);
      } else {
        this.$refs.updateQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler);
        this.$refs.updateQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);
      }
    },
    previewId: function previewId(val) {
      if (val) {
        this.formData.id = val;
        var self = this;
        self.$http.get('/lessonPreview/queryById?id=' + val).then(function (res) {
          if (res.data) {
            self.formData.id = res.data.id;
            self.formData.content = res.data.content;
            self.formData.title = res.data.title;
            self.formData.status = res.data.status + '';
            self.formData.version = res.data.version + '';
            self.levelTitle = res.data.levelTitle;
            self.lessonTitle = res.data.lessonTitle;
          }
        });
      }
    }
  },
  mounted: function mounted() {},

  created: function created() {}
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'LessonVideoInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      id: null,
      levels: [],
      lessons: [],
      headers: {},
      fileList: [],
      fileMusicList: [],
      loadingInsert: false,
      formData: {
        lessonId: null,
        levelId: '',
        videoUrl: '',
        musicUrl: '',
        version: null
      },
      visible: this.value,
      videoRule: {
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleChangeMusic: function handleChangeMusic(file, fileList) {
      this.fileMusicList = fileList.slice(-1);
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      this.formData.videoUrl = res.data.name;
    },
    handleSuccessMusic: function handleSuccessMusic(res, file, fileList) {
      this.formData.musicUrl = res.data.name;
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$refs.videoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
        self.$http.post('/bookLessonVideo/insert', self.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('新增成功!');
            self.loadingInsert = false;
            self.visible = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingInsert = false;
          self.$Message.error(e.msg);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.levels = [];
        this.lessons = [];
        this.fileList = [];
        this.formData = {};
        this.$emit('on-close', val);
      }
    }
  },
  mounted: function mounted() {},

  created: function created() {}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonVideoInsertModal__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LessonVideoInsertModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LessonVideoInsertModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LessonVideoUpdateModal__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LessonVideoUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LessonVideoUpdateModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LessonVideoUpdateModal: __WEBPACK_IMPORTED_MODULE_2__LessonVideoUpdateModal___default.a,
    LessonVideoInsertModal: __WEBPACK_IMPORTED_MODULE_1__LessonVideoInsertModal___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      onLoading: false,
      queryParam: {
        materialVersion: '',
        levelId: '',
        lessonId: '',
        lessonTitle: ''
      },
      levels: [],
      lessons: [],
      showInsertModal: false,
      showUpdateModal: false,
      title: [{
        title: 'ID',
        key: 'lessonId',
        width: 80,
        align: 'center'
      }, {
        title: '教材版本',
        key: 'materialVersion',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var version = params.row.materialVersion;
          var materialVersion = $constant.getEnum($constant.materialVersions, version);
          return h('span', materialVersion && materialVersion.text);
        }
      }, {
        title: '课程等级',
        key: 'levelTitle',
        width: 150,
        align: 'center'
      }, {
        title: '课程标题',
        key: 'lessonTitle',
        width: 170,
        align: 'center'
      }, {
        title: '视频地址',

        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.videoUrl) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(row.videoUrl, 1);
                } } }, row.videoUrl);
          } else {
            return h('span');
          }
        }
      }, {
        title: '无声视频',

        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var noVoide = params.row.videoUrl;
          if (row.videoUrl) {
            noVoide = noVoide.replace(/\.mp4/g, '_no_voice.mp4');
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(noVoide, 0);
                } } }, noVoide);
          } else {
            return h('span');
          }
        }
      }, {
        title: '每课一曲',
        align: 'center',

        width: 200,
        render: function render(h, params) {
          var row = params.row;
          if (row.musicUrl) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(row.musicUrl);
                } } }, row.musicUrl);
          } else {
            return h('span');
          }
        }
      }, {
        title: '创建时间',
        key: 'gmtCreate',
        width: 175,
        align: 'center'
      }, {
        title: '创建人',
        key: 'creatorName',
        width: 150,
        align: 'center'
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        title: '更新时间',
        key: 'gmtModified',
        align: 'center',
        width: 175
      }, 'align', 'center'), {
        title: '最新操作人',
        key: 'modifierName',
        width: 150,
        align: 'center'
      }, {
        title: '操作',
        width: 120,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.editLesson(row.lessonId);
              } } }, '编辑'), h('a', { style: { marginLeft: '10px' }, on: { click: function click() {
                return _this.generateNoVoiceVideo(row.videoUrl);
              } } }, '生成无声视频')]);
        }
      }],
      id: null
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query) {
      if (query.materialVersion) {
        self.queryParam.materialVersion = query.materialVersion;
      }
      if (query.levelId) {
        self.queryParam.levelId = parseInt(query.levelId);
      }
      if (query.lessonId) {
        self.queryParam.lessonId = parseInt(query.lessonId);
      }
    }
  },
  created: function created() {},
  methods: {
    generateNoVoiceVideo: function generateNoVoiceVideo(videoUrl) {
      var _this2 = this;

      this.$http.get('/video/execute?old=y&path=' + videoUrl).then(function (res) {
        if (res.data) {
          _this2.$Message.success(res.data);
        } else {
          _this2.$Message.error('生成无声视频失败');
        }
      }).catch(function (error) {
        _this2.$Message.error('生成无声视频失败: ' + error.message);
      });
    },
    showIndex: function showIndex(videoUrl, type) {
      if (type === 0) {
        if (videoUrl) {
          window.open('http://oss.kouyujie.cn/' + videoUrl);
        }
      } else {
        if (videoUrl) {
          window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()));
        }
      }
    },
    addLessonVideo: function addLessonVideo() {
      this.showInsertModal = true;
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
      this.search();
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLessonChange: function onLessonChange(val) {
      this.queryParam.lessonId = val;
      this.search();
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
      this.search();
    },
    editLesson: function editLesson(id) {
      this.showUpdateModal = true;
      this.id = id;
    },
    closeModal: function closeModal() {
      this.showUpdateModal = false;
      this.showInsertModal = false;
      this.id = null;
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'LessonVideoUpdateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    id: {
      type: Number
    }
  },
  data: function data() {
    return {
      levels: [],
      lessons: [],
      headers: {},
      fileList: [],
      fileMusicList: [],
      loadingUpdate: false,
      formData: {
        lessonId: null,
        levelId: null,
        videoUrl: '',
        musicUrl: '',
        version: null,
        id: null
      },
      visible: this.value,
      videoRule: {
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }]
      }
    };
  },

  methods: {
    showIndex: function showIndex(videoUrl) {
      if (videoUrl) {
        window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()));
      }
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleChangeMusic: function handleChangeMusic(file, fileList) {
      this.fileMusicList = fileList.slice(-1);
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      this.formData.videoUrl = res.data.name;
    },
    handleSuccessMusic: function handleSuccessMusic(res, file, fileList) {
      this.formData.musicUrl = res.data.name;
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.videoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        self.$http.post('/bookLessonVideo/update', self.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('编辑成功!');
            self.loadingUpdate = false;
            self.visible = false;
            self.successCallback();
          }
        }).catch(function (e) {
          self.loadingUpdate = false;
          self.$Message.error(e.msg);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.levels = [];
        this.lessons = [];
        this.fileList = [];
        this.fileMusicList = [];
        this.formData = {};
        this.$emit('on-close', val);
      }
    },
    id: function id(val) {
      if (val) {
        var self = this;
        self.$http.get('/bookLessonVideo/queryById?lessonId=' + val).then(function (res) {
          if (res.data) {
            if (res.data.id) {
              self.formData.id = res.data.id;
            }
            self.formData.videoUrl = res.data.videoUrl;
            self.formData.musicUrl = res.data.musicUrl;
            self.formData.version = res.data.materialVersion;
            self.formData.levelId = parseInt(res.data.levelId);
            self.formData.lessonId = parseInt(res.data.lessonId);
          }
        });
      }
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'NativeLessonPreviewInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    lessonId: {
      type: Number,
      default: null
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      id: null,
      levels: [],
      lessons: [],
      headers: {},
      uploadType: '',
      loadingInsert: false,
      acceptType: '',
      formData: {
        indexUrl: '',
        title: '',
        lessonId: null,
        status: '',
        version: null,
        levelId: ''
      },
      options: {
        target: this.$appConfig.baseUrl + '/upload/folderUpload',
        testChunks: false,
        headers: {
          token: this.$store.get('token')
        }
      },
      visible: this.value,
      insertUserParam: {
        regType: ''
      },
      previewRule: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        version: [{ type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }],
        levelId: [{ type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    uploadSucess: function uploadSucess(rootFile, file, message, chunk) {
      if (file.file.name === 'index.html') {
        this.formData.indexUrl = file.relativePath;
      }
    },
    onVersionChange: function onVersionChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
          if (res.data) {
            self.levels = res.data;
          }
        });
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$refs.previewForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
      });
      if (!this.formData.indexUrl) {
        self.$Message.error('无法获取到index.html的路径');
        self.loadingInsert = false;
        return;
      }
      self.$http.post('/lessonPreview/insert', this.formData).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('新增成功!');
          self.loadingInsert = false;
          self.visible = false;
          self.successCallback();
        }
      }).catch(function (e) {
        self.loadingInsert = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.levels = [];
      this.lessons = [];
      this.formData = {
        content: '',
        title: '',
        lessonId: null,
        status: '',
        version: null,
        levelId: ''
      };
      if (!val) {
        this.$emit('on-close', val);
      }
    },
    lessonId: function lessonId(val) {
      if (val) {
        this.id = val;
      }
    }
  },
  mounted: function mounted() {},

  created: function created() {}
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'LessonPreviewUpdateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    previewId: {
      type: Number,
      default: null
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      headers: {},
      uploadType: '',
      loadingInsert: false,
      fullscreenLoading: false,
      acceptType: '',
      levelTitle: '',
      lessonTitle: '',
      formData: {
        id: null,
        indexUrl: '',
        content: '',
        title: '',
        status: null,
        version: null
      },
      options: {
        target: this.$appConfig.baseUrl + '/upload/folderUpload',
        testChunks: false,
        headers: {
          token: this.$store.get('token')
        }
      },
      visible: this.value,
      previewRule: {
        title: [{ type: 'string', required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    filesAdd: function filesAdd(files, fileList, event) {},
    uploadSucess: function uploadSucess(rootFile, file, message, chunk) {
      if (file.file.name === 'index.html') {
        console.log(rootFile);
        console.log(file);
        console.log(message);
        this.formData.indexUrl = file.relativePath;
      }
    },
    onLevelChange: function onLevelChange(val) {
      var self = this;
      if (val) {
        self.levelId = val;
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res.data) {
            self.lessons = res.data;
          }
        });
      }
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$refs.previewForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsert = false;
          return;
        }
      });
      if (!this.formData.indexUrl) {
        self.$Message.error('无法获取到index.html的路径');
        self.loadingInsert = false;
        return;
      }
      console.log('indexUrl: ' + this.formData.indexUrl);
      self.$http.post('/lessonPreview/update', this.formData).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('编辑成功!');
          self.loadingInsert = false;
          self.visible = false;
          self.successCallback();
        }
      }).catch(function (e) {
        self.loadingInsert = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.formData = {};
        this.$emit('on-close', val);
      }
    },
    previewId: function previewId(val) {
      if (val) {
        this.formData.id = val;
        var self = this;
        self.$http.get('/lessonPreview/queryById?id=' + val).then(function (res) {
          if (res.data) {
            self.formData.id = res.data.id;
            self.formData.content = res.data.content;
            self.formData.indexUrl = res.data.indexUrl;
            self.formData.title = res.data.title;
            self.formData.status = res.data.status + '';
            self.formData.version = res.data.version + '';
            self.levelTitle = res.data.levelTitle;
            self.lessonTitle = res.data.lessonTitle;
          }
        });
      }
    }
  },
  mounted: function mounted() {},

  created: function created() {}
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addMonthTargetModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      insertLoading: false,
      params: {
        adviserList: [],
        uids: [],
        type: 2
      },
      formData: {
        teamType: 0,
        adviserGroupList: this.$constant.adviserGroup,
        adviserList: []
      },
      formRule: {}
    };
  },

  mounted: function mounted() {},
  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    getAdviserList: function getAdviserList(teamType) {
      var self = this;
      self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
        if (res && res.data) {
          self.formData.adviserList = res.data;
          self.params.adviserList = res.data;
        }
      });
    },
    onTeamTypeChange: function onTeamTypeChange(value) {
      this.getAdviserList(value);
    },
    onOrderChange: function onOrderChange() {
      var self = this;
      var list = self.formData.adviserList;
      self.params.adviserList = [];
      var index = 0;
      for (; index < list.length; index++) {
        self.params.adviserList.push(list[index]);
      }
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    confirmAssign: function confirmAssign() {
      var self = this;
      self.$http.post('/adviser/updateAdviserInfos', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.params);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('操作成功!');
          self.editModal = false;
          self.successCallback();
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.getAdviserList(0);
      }
    },
    userList: function userList(array) {
      this.params.uids = [];
      for (var i = 0; i < array.length; i++) {
        this.params.uids.push(array[i].id);
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManualAssignModal_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManualAssignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ManualAssignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditAssignWeightModal_vue__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditAssignWeightModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EditAssignWeightModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddMonthTargetModal_vue__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddMonthTargetModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddMonthTargetModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview_src_components_grid_row__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_1__UserInfoModal_vue___default.a, AdviserFloatModal: __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue___default.a, ManualAssignModal: __WEBPACK_IMPORTED_MODULE_3__ManualAssignModal_vue___default.a, EditAssignWeightModal: __WEBPACK_IMPORTED_MODULE_4__EditAssignWeightModal_vue___default.a, AddMonthTargetModal: __WEBPACK_IMPORTED_MODULE_5__AddMonthTargetModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      modal1: false,
      showUserInfoModal: false,
      uid: null,
      showManualAssignModal: false,
      showEditAssingWeightModal: false,
      showAddMonthTargetModal: false,
      editData: null,
      searchLoading: false,
      reload: 0,
      connectionStatusList: $constant.connectionStatus,
      autoAssignTag: -1,
      havePermission: false,
      selectionUser: [],
      adviserList: [],
      adviserGroupList: $constant.adviserGroup,
      startTime: '',
      endTime: '',
      queryParam: {
        startGmtCreate: '',
        endGmtCreate: '',
        searchKeyword: '',
        isAdviser: ''
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: 'ID/姓名',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          var inviteId = row.inviteId;
          if (inviteId) {
            return h('span', [h('a', { on: { click: function click() {
                  return _this.openInfoModal(row.id);
                } } }, row.id + '-' + row.nickname), h('span', { style: { color: 'red' } }, '(推荐)')]);
          } else {
            return h('a', { on: { click: function click() {
                  return _this.openInfoModal(row.id);
                } } }, row.id + '-' + row.nickname);
          }
        }
      }, {
        title: '手机号码',
        align: 'center',
        key: 'mobile',

        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '城市',
        align: 'center',

        render: function render(h, params) {
          var province = params.row.province;
          var city = params.row.city;
          var address = '';
          if (province && province !== '未知') {
            address = address + province;
          }
          if (city && city !== '未知') {
            address = address + city;
          }
          return h('span', address);
        }
      }, {
        title: '注册渠道',
        align: 'center',

        key: 'regType',
        render: function render(h, params) {
          var name = params.row.regType || '';
          var type = params.row.channelType || '';
          if (type && name && type !== name) {
            return h('span', name + '（' + type + '）');
          }
          return h('span', name || type);
        }
      }, {
        title: '名单标签',
        align: 'center',

        render: function render(h, params) {
          var assignNum = params.row.assignNum;
          var assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum);
          return h('div', assignNumEnum && assignNumEnum.text);
        }
      }, {
        title: '推荐人',
        align: 'center',
        key: 'inviteName',
        render: function render(h, params) {
          var inviteId = params.row.inviteId;
          var inviteName = params.row.inviteName;
          if (inviteId) {
            return h('a', { on: { click: function click() {
                  return _this.openInfoModal(inviteId);
                } } }, inviteId + '-' + inviteName);
          }
        }
      }, {
        title: '创建人',

        align: 'center',
        key: 'createName'
      }, {
        title: '注册时间',
        align: 'center',
        key: 'regTime'
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    self.havePermission = false;
    var permissions = self.$store.get('permissions');
    if (permissions) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(permissions).indexOf('all') >= 0) {
        self.havePermission = true;
      } else {
        this.$http.post('/common/getPermissionByUrl', { url: '/adviser/updateAutoAssignTag' }).then(function (res) {
          if (res.data) {
            self.havePermission = true;
          }
        });
      }
    }
  },
  created: function created() {
    if (this.$store.get('permissions').indexOf('all') > 0) {
      this.queryParam.teamType = 0;
    } else if (this.$store.get('adviserInfo')) {
      this.queryParam.teamType = this.$store.get('adviserInfo').teamType;
    }
    this.getAdviserList();
    this.queryAutoAssignTag();
  },
  methods: {
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserExperienceList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    queryAutoAssignTag: function queryAutoAssignTag() {
      var self = this;
      self.$http.get('/userList/autoAssign').then(function (res) {
        if (res.data) {
          self.autoAssignTag = res.data;
        }
      });
    },
    search: function search() {
      this.startTime = this.queryParam.startGmtCreate;
      this.endTime = this.queryParam.endGmtCreate;
      this.reload = new Date().getTime();
    },
    getAdviserList: function getAdviserList() {
      var self = this;
      self.$http.get('/adviser/listNoPage?teamType=0').then(function (res) {
        if (res && res.data) {
          self.adviserList = res.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startGmtCreate = value;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endGmtCreate = value;
    },
    ok: function ok() {
      this.$Message.info('Clicked ok');
    },
    cancel: function cancel() {
      this.$Message.info('Clicked cancel');
    },
    editUserInfo: function editUserInfo(row) {
      this.uid = row.id;
      this.showUserInfoModal = true;
    },
    getAdviserInfo: function getAdviserInfo(obj) {
      if (obj) {
        console.log(obj);
        this.queryParam.adviserId = obj.adviserId;
        this.queryParam.teamType = obj.teamType;
      }
    },
    manualAssign: function manualAssign() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showManualAssignModal = true;
    },
    moveUser: function moveUser() {
      var self = this;
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择学生！');
        return;
      }
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移除</span>此资源?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          for (var i = 0; i < self.selectionUser.length; i++) {
            self.$http.post('/userList/crmResourceUpdate', { id: self.selectionUser[i].id }).then(function (res) {});
          }
          self.search();
        }
      });
    },
    autoAssignOpen: function autoAssignOpen(value) {
      var self = this;
      var content = '是否确认开启自动分配功能？开启后所有新注册学生将按权重分配给课顾！';
      if (value === -1) {
        content = '是否确认关闭自动分配功能？关闭后将停止自动分配课顾！';
      }
      self.$Modal.confirm({
        title: '提示',
        content: content,
        width: 300,
        loading: false,
        okText: '确认',
        cancelText: '取消',
        onOk: function onOk() {
          self.$http.post('/adviser/updateAutoAssignTag', { tag: value }).then(function (res) {
            if (res && res.data) {
              self.$Message.success('操作成功!');
              self.queryAutoAssignTag();
            } else {
              self.$Message.error('操作失败!');
            }
          });
        },
        onCancel: function onCancel() {}
      });
    },
    editAssignWeight: function editAssignWeight() {
      this.showEditAssingWeightModal = true;
    },
    addMonthTarget: function addMonthTarget() {
      this.showAddMonthTargetModal = true;
    }
  },
  watch: {
    startGmtCreate: function startGmtCreate(val) {
      this.startTime = val;
    },
    endGmtCreate: function endGmtCreate(val) {
      this.endTime = val;
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAdvierTreModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAssignAdviser: false,
      adviserParam: {
        adviserId: '',
        resourceStatus: 2
      },
      adviserRule: {
        adviserId: [{ type: 'integer', required: true, message: '请选择课程顾问', trigger: 'blur' }]
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      self.$refs.assignAdviserForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.userList.map(function (element) {
          return element.uid;
        });
        self.loadingAssignAdviser = true;
        var params = { ids: idList.join(','), adviserId: self.adviserParam.adviserId, resourceStatus: self.adviserParam.resourceStatus };
        self.$http.get('/user/updateAdviserTre', { params: params }).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
          }
          self.loadingAssignAdviser = false;
        }).catch(function (e) {
          self.visible = false;
          self.loadingAssignAdviser = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.adviserParam.adviserId = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CallAsrWord',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {
        srcWord: '',
        enabled: ''
      },
      form: {},
      tableColumns: [{ title: 'ID', key: 'id', width: 80 }, { title: '错词', key: 'srcWord', minWidth: 160 }, { title: '正确词', key: 'dstWord', minWidth: 160 }, {
        title: '状态',
        key: 'enabled',
        width: 90,
        render: function render(h, params) {
          return h('span', params.row.enabled === 1 ? '启用' : '停用');
        }
      }, { title: '修改时间', key: 'gmtModified', minWidth: 170 }, {
        title: '操作',
        key: 'action',
        width: 180,
        render: function render(h, params) {
          return h('div', { style: { whiteSpace: 'nowrap' } }, [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { size: 'small' },
            on: { click: function click() {
                return _this.changeStatus(params.row);
              } }
          }, params.row.enabled === 1 ? '停用' : '启用')]);
        }
      }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    emptyForm: function emptyForm() {
      return {
        srcWord: '',
        dstWord: '',
        enabled: 1
      };
    },
    search: function search() {
      var _this2 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.editVisible = true;
    },
    openEdit: function openEdit(row) {
      this.form = {
        id: row.id,
        srcWord: row.srcWord,
        dstWord: row.dstWord,
        enabled: row.enabled
      };
      this.editVisible = true;
    },
    save: function save() {
      var _this3 = this;

      this.$http.post('/callAsrWord/save', this.form).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success(_this3.form.id ? '已更新' : '已新建');
          _this3.editVisible = false;
          _this3.search();
        } else {
          _this3.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(row) {
      var _this4 = this;

      var enabled = row.enabled === 1 ? 0 : 1;
      this.$http.post('/callAsrWord/status', { id: row.id, enabled: enabled }).then(function (res) {
        if (res.status === 'ok') {
          _this4.$Message.success(enabled === 1 ? '已启用' : '已停用');
          _this4.search();
        } else {
          _this4.$Message.error(res.msg || '操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CallScript',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {
        scene: '',
        status: '',
        phrase: ''
      },
      form: {},
      sceneOptions: [{ value: 'OPENING', label: '开场' }, { value: 'OBJECTION', label: '异议' }, { value: 'INVITE_TRIAL', label: '邀约体验' }, { value: 'CLOSE', label: '促单' }, { value: 'FOLLOWUP', label: '回访' }],
      tableColumns: [{ title: 'ID', key: 'id', width: 80 }, {
        title: '场景',
        key: 'scene',
        width: 110,
        render: function render(h, params) {
          return h('span', _this.sceneLabel(params.row.scene));
        }
      }, { title: '话术', key: 'phrase', minWidth: 280 }, {
        title: '状态',
        key: 'status',
        width: 90,
        render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status));
        }
      }, { title: '来源通话', key: 'sourceCallId', width: 100 }, { title: '修改时间', key: 'gmtModified', minWidth: 170 }, {
        title: '操作',
        key: 'action',
        width: 240,
        render: function render(h, params) {
          var btns = [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.copyPhrase(params.row.phrase);
              } }
          }, '复制'), h('Button', {
            props: { size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑')];
          if (params.row.status !== 1) {
            btns.push(h('Button', {
              props: { size: 'small' },
              on: { click: function click() {
                  return _this.changeStatus(params.row.id, 1);
                } }
            }, '发布'));
          } else {
            btns.push(h('Button', {
              props: { size: 'small' },
              on: { click: function click() {
                  return _this.changeStatus(params.row.id, 2);
                } }
            }, '停用'));
          }
          return h('div', { style: { whiteSpace: 'nowrap' } }, btns);
        }
      }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    sceneLabel: function sceneLabel(code) {
      var hit = this.sceneOptions.find(function (item) {
        return item.value === code;
      });
      return hit ? hit.label : code || '';
    },
    statusLabel: function statusLabel(code) {
      if (code === 0) return '候选';
      if (code === 1) return '已发布';
      if (code === 2) return '停用';
      return '';
    },
    emptyForm: function emptyForm() {
      return {
        scene: 'OPENING',
        phrase: '',
        status: 1
      };
    },
    search: function search() {
      var _this2 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.editVisible = true;
    },
    openEdit: function openEdit(row) {
      this.form = {
        id: row.id,
        scene: row.scene,
        phrase: row.phrase,
        status: row.status
      };
      this.editVisible = true;
    },
    save: function save() {
      var _this3 = this;

      this.$http.post('/callScript/save', this.form).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success(_this3.form.id ? '已更新' : '已新建');
          _this3.editVisible = false;
          _this3.search();
        } else {
          _this3.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      this.$http.post('/callScript/status', { id: id, status: status }).then(function (res) {
        if (res.status === 'ok') {
          _this4.$Message.success(status === 1 ? '已发布' : '已停用');
          _this4.search();
        } else {
          _this4.$Message.error(res.msg || '操作失败');
        }
      });
    },
    copyPhrase: function copyPhrase(text) {
      var _this5 = this;

      if (!text) {
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this5.$Message.success('已复制');
        }).catch(function () {
          _this5.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy: function fallbackCopy(text) {
      var input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$Message.success('已复制');
      } catch (e) {
        this.$Message.error('复制失败');
      }
      document.body.removeChild(input);
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdviserFloatModal_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdviserFloatModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_AdviserFloatModal_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue___default.a,
    AdviserFloatModal: __WEBPACK_IMPORTED_MODULE_1__common_AdviserFloatModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      editUser: false,
      exportLoading: false,
      reload: 0,
      url: '/userinfo/dailyTransOut',
      uid: null,
      queryParam: {
        intentLevel: '',
        stdStatus: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        searchKeyword: '',
        studyAdviserId: '',
        adviserId: null,
        teamType: null,
        adviserIdList: null
      },
      studyAdvisers: [],
      title: [{
        title: '学生姓名/ID',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '手机号',
        key: 'mobile',
        align: 'center',

        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '城市',

        align: 'center',
        render: function render(h, params) {
          var province = params.row.province;
          var city = params.row.city;
          var address = '';
          if (province && province !== '未知') {
            address = address + province;
          }
          if (city && city !== '未知') {
            address = address + city;
          }
          return h('span', address);
        }
      }, {
        title: '渠道',

        align: 'center',
        key: 'regType'
      }, {
        title: '注册时间',
        align: 'center',

        key: 'regTime'
      }, {
        title: '课程顾问',
        align: 'center',
        key: 'adviserName'
      }, {
        title: '接通状态',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.connectionStatus;
          var typeEnum = $constant.getEnum($constant.connectionStatus, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '客户意向',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.intentLevel;
          var typeEnum = $constant.getEnum($constant.intentLevel, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '学员状态',
        align: 'center',

        render: function render(h, params) {
          var status = params.row.stdStatus;
          var typeEnum = $constant.getEnum($constant.stdStatus, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('a', { on: { click: function click() {
                return self.edit(row.uid);
              } } }, '编辑');
        }
      }]
    };
  },

  methods: {
    getAdviserInfo: function getAdviserInfo(obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId;
        if (obj.adviserIds.length > 1) {
          this.queryParam.adviserId = '0';
        }
        this.queryParam.teamType = obj.teamType;
        this.queryParam.adviserIdList = obj.adviserIds;
      }
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    edit: function edit(uid) {
      this.uid = uid;
      this.editUser = true;
    },
    closeModal: function closeModal(val) {
      this.editUser = val;
    },
    exportDaiyTransOut: function exportDaiyTransOut() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/userinfo/exportUserInfo', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '今日将转出名单.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    regTimeStartChange: function regTimeStartChange(val) {
      this.queryParam.regStartTimeDate = val;
    },
    regTimeEndChange: function regTimeEndChange(val) {
      this.queryParam.regEndTimeDate = val;
    },
    lessonStartTimeChange: function lessonStartTimeChange(val) {
      this.queryParam.lessonStartTimeDate = val;
    },
    lessonEndTimeChange: function lessonEndTimeChange(val) {
      this.queryParam.lessonEndTimeDate = val;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data;
    });
    this.search();
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdviserFloatModal: __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue___default.a
  },
  data: function data() {
    var $constant = this.$constant;

    var now = new Date();
    var momentDate = this.$moment([now.getFullYear(), now.getMonth(), now.getDate()]);
    var formattedDate = momentDate.format('YYYY-MM-DD');

    return {
      exportLoading: false,
      showAssignAdviserModal: false,
      selectionUser: [],
      searchLoading: false,
      editUser: false,
      reload: 0,
      uid: null,
      fromSalesDealRate: false,
      fromChannelDealRate: false,
      queryParam: {
        recordsSource: '',
        stdStatus: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        linkStartTimeDate: formattedDate,
        startTime: momentDate.format('X'),
        linkEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        searchKeyword: '',
        studyAdviserId: '',
        studentLessonState: '',
        adviserId: null,
        adviserIds: [],
        teamType: null,
        salesDealRate: '',
        weekStart: ''
      },
      studyAdvisers: [],
      assignTitle: [{
        title: '学生ID/姓名',

        render: function render(h, params) {
          var row = params.row;
          var remark = row.remark;
          if (remark && remark.indexOf('开始') !== -1) {
            return h('div', [h('span', row.uid + '-' + row.nickName), h('br'), h('span', { style: { fontSize: '12px', color: '#19be6b' } }, remark)]);
          }
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '手机号',
        key: 'mobile',

        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '城市',
        key: 'allCity'
      }, {
        title: '注册渠道',

        key: 'regType',
        render: function render(h, params) {
          var name = params.row.regType || '';
          var type = params.row.channelType || '';
          if (type && name && type !== name) {
            return h('span', name + '（' + type + '）');
          }
          return h('span', name || type);
        }
      }, {
        title: '推荐人',

        key: 'auName'
      }, {
        title: '创建人',

        key: 'creatorName'
      }, {
        title: '分配来源',

        render: function render(h, params) {
          var recordsSource = params.row.recordsSource;
          var recordsSourceEnum = $constant.getEnum($constant.recordsSource, recordsSource);
          return h('div', recordsSourceEnum && recordsSourceEnum.text);
        }
      }, {
        title: '课程顾问',

        key: 'adviserName',
        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '分配人',
        align: 'center',
        key: 'assignerName'
      }, {
        title: '分配时间',
        align: 'center',

        key: 'assignTime'
      }, {
        title: '学员状态',

        render: function render(h, params) {
          var status = params.row.stdStatus;
          var typeEnum = $constant.getEnum($constant.stdStatus, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }]
    };
  },

  methods: {
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    getAdviserInfo: function getAdviserInfo(obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId;
        this.queryParam.teamType = obj.teamType;
        this.queryParam.adviserIds = obj.adviserIds;
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    goBackSalesDealRate: function goBackSalesDealRate() {
      var startDate = this.queryParam.linkStartTimeDate;
      var endDate = this.queryParam.linkEndTimeDate;
      var query = void 0;
      if (startDate && endDate) {
        query = {
          startDate: startDate,
          endDate: endDate
        };
      } else {
        query = {
          weekStart: this.queryParam.weekStart || this.$route.query.weekStart,
          weeks: this.queryParam.weeks || this.$route.query.weeks
        };
      }
      this.$router.push({
        path: '/crm/SalesDealRate',
        query: query
      });
    },
    goBackChannelDealRate: function goBackChannelDealRate() {
      var startDate = this.queryParam.linkStartTimeDate;
      var endDate = this.queryParam.linkEndTimeDate;
      var query = void 0;
      if (startDate && endDate) {
        query = {
          startDate: startDate,
          endDate: endDate
        };
      } else {
        query = {
          weekStart: this.queryParam.weekStart || this.$route.query.weekStart
        };
      }
      if (this.$route.query.marketCategory) {
        query.marketCategory = this.$route.query.marketCategory;
      }
      this.$router.push({
        path: '/market/ChannelDealRate',
        query: query
      });
    },
    regTimeStartChange: function regTimeStartChange(val) {
      this.queryParam.regStartTimeDate = val;
    },
    regTimeEndChange: function regTimeEndChange(val) {
      this.queryParam.regEndTimeDate = val;
    },
    linkTimeStartChange: function linkTimeStartChange(val) {
      this.queryParam.linkStartTimeDate = val;
    },
    linkTimeEndChange: function linkTimeEndChange(val) {
      this.queryParam.linkEndTimeDate = val;
    }
  },
  created: function created() {
    var query = this.$route.query;
    if (query.salesDealRate == 1 || query.salesDealRate === '1') {
      this.fromSalesDealRate = true;
      this.queryParam.salesDealRate = 1;
      var weeks = String(query.weeks) === '8' ? 8 : 1;
      this.queryParam.weeks = weeks;
      if (String(query.weeks) !== String(weeks)) {
        query.weeks = weeks;
      }
      if (query.weekStart) {
        this.queryParam.weekStart = query.weekStart;
      }
      if (query.adviserId) {
        this.queryParam.adviserId = query.adviserId;
      }
      if (query.linkStartTimeDate) {
        this.queryParam.linkStartTimeDate = query.linkStartTimeDate;
      }
      if (query.linkEndTimeDate) {
        this.queryParam.linkEndTimeDate = query.linkEndTimeDate;
      }
    }
    if (query.channelDealRate === 1 || query.channelDealRate === '1') {
      this.fromChannelDealRate = true;
      this.queryParam.channelDealRate = 1;
      if (query.weekStart) {
        this.queryParam.weekStart = query.weekStart;
      }
      if (query.channelId !== undefined && query.channelId !== null && query.channelId !== '') {
        this.queryParam.channelId = query.channelId;
      }
      if (query.linkStartTimeDate) {
        this.queryParam.linkStartTimeDate = query.linkStartTimeDate;
      }
      if (query.linkEndTimeDate) {
        this.queryParam.linkEndTimeDate = query.linkEndTimeDate;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data;
    });
    this.cmd = 1;
    this.title = this.assignTitle;
    this.search();
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_AdminUserSelect_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_AdminUserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_AdminUserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__ = __webpack_require__(60);








function pad2(n) {
  return n < 10 ? '0' + n : '' + n;
}

function formatMs(ms) {
  if (ms == null || ms === '' || isNaN(ms)) return '';
  var total = Math.max(0, Math.floor(Number(ms) / 1000));
  var m = Math.floor(total / 60);
  var s = total % 60;
  return m + ':' + pad2(s);
}

function formatDuration(ms) {
  if (ms == null || ms === '' || isNaN(ms)) return '—';
  var total = Math.max(0, Math.floor(Number(ms) / 1000));
  var m = Math.floor(total / 60);
  var s = total % 60;
  if (m <= 0) return s + '秒';
  return m + '分' + s + '秒';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DviAudioList',
  components: { AdminUserSelect: __WEBPACK_IMPORTED_MODULE_3__common_AdminUserSelect_vue___default.a },
  data: function data() {
    var _this = this;

    var end = new Date();
    var begin = new Date(end);
    begin.setDate(end.getDate() - 6);
    var beginStr = begin.toISOString().split('T')[0];
    var endStr = end.toISOString().split('T')[0];
    return {
      reload: 0,
      searchLoading: false,
      defaultDate: [beginStr, endStr],
      queryParam: {
        beginTime: beginStr,
        endTime: endStr,
        fileName: '',
        adminUserId: null,
        uid: ''
      },
      bindVisible: false,
      bindResolving: false,
      bindSaving: false,
      bindTargetId: null,
      bindForm: {
        uidInput: '',
        resolvedUid: null,
        studentName: '',
        studentMobile: ''
      },
      detailVisible: false,
      detailLoading: false,
      detail: null,
      summaryHtml: '',
      cleanHtml: '',
      aiCleanLoading: false,
      backfillLoadingId: null,
      chatBubbles: [],
      fallbackTranscript: '',
      roleSwapped: false,
      transcriptList: [],
      speakerOrder: [],
      previewVisible: false,
      previewLoading: false,
      previewKind: '',
      previewCache: {},
      previewDetail: null,
      previewSummaryHtml: '',
      previewCleanHtml: '',
      previewChatBubbles: [],
      previewFallbackTranscript: '',
      previewRoleSwapped: false,
      previewTranscriptList: [],
      previewSpeakerOrder: [],
      tableColumns: [{
        title: '标题',
        minWidth: 200,
        align: 'left',
        render: function render(h, params) {
          var name = params.row.fileName || '未命名听记';
          return h('span', { attrs: { title: name } }, name);
        }
      }, {
        title: '录音时间',
        key: 'createTime',
        minWidth: 160,
        align: 'center'
      }, {
        title: '绑定人',
        minWidth: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.adminUserName || '—');
        }
      }, {
        title: '学生',
        minWidth: 150,
        align: 'left',
        render: function render(h, params) {
          return _this.renderStudentCell(h, params.row);
        }
      }, {
        title: '摘要',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var has = !!params.row.hasSummary;
          return h('Tag', {
            props: { color: has ? 'green' : 'default' },
            style: has ? { cursor: 'pointer' } : {},
            nativeOn: has ? { click: function click(e) {
                e && e.stopPropagation && e.stopPropagation();_this.openPreview(params.row.id, 'summary');
              } } : {}
          }, has ? '有' : '无');
        }
      }, {
        title: '清洗',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var has = !!params.row.hasAsrClean;
          return h('Tag', {
            props: { color: has ? 'green' : 'default' },
            style: has ? { cursor: 'pointer' } : {},
            nativeOn: has ? { click: function click(e) {
                e && e.stopPropagation && e.stopPropagation();_this.openPreview(params.row.id, 'clean');
              } } : {}
          }, has ? '有' : '无');
        }
      }, {
        title: '原文',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var has = !!params.row.hasTranscript;
          return h('Tag', {
            props: { color: has ? 'blue' : 'default' },
            style: has ? { cursor: 'pointer' } : {},
            nativeOn: has ? { click: function click(e) {
                e && e.stopPropagation && e.stopPropagation();_this.openPreview(params.row.id, 'transcript');
              } } : {}
          }, has ? '有' : '无');
        }
      }, {
        title: '音频',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          if (params.row.hasAudio && params.row.storageUrl) {
            return h('audio', {
              attrs: {
                src: params.row.storageUrl,
                controls: 'controls',
                preload: 'none'
              },
              style: { width: '160px', height: '32px', verticalAlign: 'middle' }
            });
          }
          return h('span', { style: { color: '#c5c8ce' } }, '—');
        }
      }, {
        title: '操作',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            style: { marginRight: '10px' },
            on: { click: function click() {
                return _this.openDetail(params.row.id);
              } }
          }, '查看'), h('a', {
            on: { click: function click() {
                return _this.handleBackfill(params.row);
              } }
          }, '补录')]);
        }
      }]
    };
  },

  computed: {
    detailTitle: function detailTitle() {
      if (!this.detail) return '通话详情';
      return '通话详情';
    },
    previewTitle: function previewTitle() {
      if (this.previewKind === 'summary') return '摘要预览';
      if (this.previewKind === 'clean') return 'AI清洗预览';
      if (this.previewKind === 'transcript') return '原始对话预览';
      return '预览';
    },
    hasTodos: function hasTodos() {
      return this.detail && Array.isArray(this.detail.todos) && this.detail.todos.length > 0;
    },
    canAiClean: function canAiClean() {
      if (!this.detail) return false;
      if (this.detail.hasTranscript) return true;
      if (this.detail.asrTranscript) return true;
      return false;
    },
    aiCleanBtnText: function aiCleanBtnText() {
      if (this.detail && this.detail.asrCleanContent) return '重新清洗';
      return 'AI 处理';
    }
  },
  methods: {
    displayTitle: function displayTitle(name) {
      return name || '未命名听记';
    },
    studentLabel: function studentLabel(row) {
      if (!row || row.uid == null || row.uid === '') return '';
      if (row.studentName) return row.uid + '-' + row.studentName;
      return String(row.uid);
    },
    renderStudentCell: function renderStudentCell(h, row) {
      var _this2 = this;

      if (!row || row.uid == null || row.uid === '') {
        return h('div', [h('span', { style: { color: '#c5c8ce' } }, '未绑定'), h('a', {
          style: { marginLeft: '8px' },
          on: { click: function click() {
              return _this2.openBind(row);
            } }
        }, '绑定')]);
      }
      var kids = [h('div', this.studentLabel(row))];
      if (!row.studentName) {
        kids.push(h('div', { style: { color: '#c5c8ce', fontSize: '12px' } }, '（学生信息缺失）'));
      } else if (row.studentMobile) {
        kids.push(h('div', { style: { color: '#808695', fontSize: '12px' } }, row.studentMobile));
      }
      kids.push(h('a', {
        style: { fontSize: '12px' },
        on: { click: function click() {
            return _this2.openBind(row);
          } }
      }, '改绑'));
      return h('div', kids);
    },
    openBind: function openBind(row) {
      var _this3 = this;

      if (!row || !row.id) return;
      this.bindTargetId = row.id;
      this.bindForm = {
        uidInput: row.uid != null ? String(row.uid) : '',
        resolvedUid: null,
        studentName: '',
        studentMobile: ''
      };
      this.bindVisible = true;
      if (row.uid != null) {
        this.$nextTick(function () {
          return _this3.resolveStudent();
        });
      }
    },
    closeBind: function closeBind() {
      this.bindVisible = false;
      this.bindResolving = false;
      this.bindSaving = false;
      this.bindTargetId = null;
      this.bindForm = { uidInput: '', resolvedUid: null, studentName: '', studentMobile: '' };
    },
    resolveStudent: function resolveStudent() {
      var _this4 = this;

      var raw = (this.bindForm.uidInput || '').trim();
      if (!raw) {
        this.bindForm.resolvedUid = null;
        this.bindForm.studentName = '';
        this.bindForm.studentMobile = '';
        return;
      }
      if (!/^\d+$/.test(raw)) {
        this.$Message.error('未找到学生');
        this.bindForm.resolvedUid = null;
        this.bindForm.studentName = '';
        this.bindForm.studentMobile = '';
        return;
      }
      this.bindResolving = true;
      this.$http.get('/crm/dviAudio/resolve-uid', { params: { uid: raw } }).then(function (res) {
        _this4.bindResolving = false;
        if (!res || res.status !== 'ok' || !res.data) {
          _this4.bindForm.resolvedUid = null;
          _this4.bindForm.studentName = '';
          _this4.bindForm.studentMobile = '';
          _this4.$Message.error(res && res.msg || '未找到学生');
          return;
        }
        _this4.bindForm.resolvedUid = res.data.uid;
        _this4.bindForm.studentName = res.data.studentName || '';
        _this4.bindForm.studentMobile = res.data.studentMobile || '';
      }).catch(function () {
        _this4.bindResolving = false;
        _this4.bindForm.resolvedUid = null;
        _this4.bindForm.studentName = '';
        _this4.bindForm.studentMobile = '';
        _this4.$Message.error('未找到学生');
      });
    },
    saveBind: function saveBind() {
      var _this5 = this;

      if (!this.bindTargetId) return;
      if (!this.bindForm.resolvedUid) {
        this.$Message.warning('请输入学生ID');
        return;
      }
      this.bindSaving = true;
      this.$http.get('/crm/dviAudio/bind-uid', {
        params: { id: this.bindTargetId, uid: this.bindForm.resolvedUid }
      }).then(function (res) {
        _this5.bindSaving = false;
        if (!res || res.status !== 'ok') {
          _this5.$Message.error(res && res.msg || '绑定失败');
          return;
        }
        _this5.$Message.success('绑定成功');
        var boundId = _this5.bindTargetId;
        var data = res.data || {};
        _this5.closeBind();
        _this5.reload = new Date().getTime();
        if (_this5.detail && _this5.detail.id === boundId) {
          _this5.detail.uid = data.uid;
          _this5.detail.studentName = data.studentName;
          _this5.detail.studentMobile = data.studentMobile;
        }
      }).catch(function () {
        _this5.bindSaving = false;
        _this5.$Message.error('绑定失败');
      });
    },
    handleBackfill: function handleBackfill(row) {
      var _this6 = this;

      if (!row || row.id == null) return;
      if (this.backfillLoadingId != null) return;
      this.backfillLoadingId = row.id;
      this.$http.post('/crm/dviAudio/backfill', { id: row.id }).then(function (res) {
        _this6.backfillLoadingId = null;
        if (!res || res.code !== 200) {
          _this6.$Message.error(res && res.msg || '补录失败');
          return;
        }
        var data = res.data || {};
        _this6.$Message.success(data.message || '补录完成');
        _this6.reload = new Date().getTime();
        if (_this6.previewCache && _this6.previewCache[row.id]) {
          _this6.$delete(_this6.previewCache, row.id);
        }
        if (_this6.detail && _this6.detail.id === row.id) {
          _this6.openDetail(row.id);
        }
      }).catch(function () {
        _this6.backfillLoadingId = null;
        _this6.$Message.error('补录失败');
      });
    },
    handleAiClean: function handleAiClean() {
      var _this7 = this;

      if (!this.detail || !this.detail.id) return;
      if (!this.canAiClean) {
        this.$Message.warning('暂无原始对话，无法 AI 处理');
        return;
      }
      var doRequest = function doRequest() {
        _this7.aiCleanLoading = true;
        _this7.$http.post('/crm/dviAudio/ai-clean', { id: _this7.detail.id }).then(function (res) {
          _this7.aiCleanLoading = false;
          if (!res || res.status !== 'ok') {
            _this7.$Message.error(res && res.msg || 'AI 处理失败');
            return;
          }
          var md = res.data && res.data.asrCleanContent || '';
          _this7.detail.asrCleanContent = md;
          _this7.detail.hasAsrClean = !!md;
          _this7.cleanHtml = md ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(md) : '';
          if (_this7.detail && _this7.detail.id != null) {
            _this7.$set(_this7.previewCache, _this7.detail.id, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this7.detail));
          }
          _this7.$Message.success('AI 处理完成');
          _this7.reload = new Date().getTime();
        }).catch(function () {
          _this7.aiCleanLoading = false;
          _this7.$Message.error('AI 处理失败');
        });
      };
      if (this.detail.asrCleanContent) {
        this.$Modal.confirm({
          title: '确认重新清洗',
          content: '将用 AI 结果覆盖当前清洗内容，是否继续？',
          onOk: function onOk() {
            doRequest();
          }
        });
      } else {
        doRequest();
      }
    },

    formatDuration: formatDuration,
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onDateChange: function onDateChange(value) {
      this.queryParam.beginTime = value && value[0] ? value[0] : '';
      this.queryParam.endTime = value && value[1] ? value[1] : '';
    },
    search: function search() {
      this.previewCache = {};
      this.reload = new Date().getTime();
    },
    openDetail: function openDetail(id) {
      var _this8 = this;

      if (!id) return;
      this.closePreview();
      this.detailVisible = true;
      this.detailLoading = true;
      this.detail = null;
      this.summaryHtml = '';
      this.cleanHtml = '';
      this.aiCleanLoading = false;
      this.chatBubbles = [];
      this.fallbackTranscript = '';
      this.roleSwapped = false;
      this.transcriptList = [];
      this.speakerOrder = [];
      var apply = function apply(data) {
        _this8.detailLoading = false;
        _this8.detail = data || {};
        _this8.summaryHtml = _this8.detail.summaryContent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(_this8.detail.summaryContent) : '';
        _this8.cleanHtml = _this8.detail.asrCleanContent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(_this8.detail.asrCleanContent) : '';
        _this8.parseTranscript(_this8.detail.asrTranscript);
      };
      var cached = this.previewCache[id];

      if (cached && cached.asrTranscript) {
        apply(cached);
        return;
      }
      this.$http.get('/crm/dviAudio/detail', { params: { id: id } }).then(function (res) {
        if (!res || res.status !== 'ok') {
          _this8.detailLoading = false;
          _this8.$Message.error(res && res.msg || '记录不存在');
          _this8.detailVisible = false;
          return;
        }
        var data = res.data || {};
        _this8.$set(_this8.previewCache, id, data);
        apply(data);
      }).catch(function () {
        _this8.detailLoading = false;
        _this8.detailVisible = false;
        _this8.$Message.error('请求失败');
      });
    },
    openPreview: function openPreview(id, kind) {
      var _this9 = this;

      if (!id || !kind) return;
      this.previewKind = kind;
      this.previewVisible = true;
      this.previewLoading = true;
      this.previewDetail = null;
      this.previewSummaryHtml = '';
      this.previewCleanHtml = '';
      this.previewChatBubbles = [];
      this.previewFallbackTranscript = '';
      this.previewRoleSwapped = false;
      this.previewTranscriptList = [];
      this.previewSpeakerOrder = [];
      var show = function show(data) {
        _this9.previewLoading = false;
        _this9.previewDetail = data || {};
        _this9.previewSummaryHtml = _this9.previewDetail.summaryContent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(_this9.previewDetail.summaryContent) : '';
        _this9.previewCleanHtml = _this9.previewDetail.asrCleanContent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(_this9.previewDetail.asrCleanContent) : '';
        if (kind === 'transcript') {
          _this9.parsePreviewTranscript(_this9.previewDetail.asrTranscript);
        }
      };
      var cached = this.previewCache[id];
      var needFresh = !cached || kind === 'transcript' && !cached.asrTranscript || kind === 'clean' && !cached.asrCleanContent || kind === 'summary' && !cached.summaryContent;
      if (cached && !needFresh) {
        show(cached);
        return;
      }
      this.$http.get('/crm/dviAudio/detail', { params: { id: id } }).then(function (res) {
        if (!res || res.status !== 'ok') {
          _this9.previewLoading = false;
          _this9.previewVisible = false;
          _this9.$Message.error(res && res.msg || '记录不存在');
          return;
        }
        var data = res.data || {};
        _this9.$set(_this9.previewCache, id, data);
        show(data);
      }).catch(function () {
        _this9.previewLoading = false;
        _this9.previewVisible = false;
        _this9.$Message.error('请求失败');
      });
    },
    closePreview: function closePreview() {
      this.previewVisible = false;
      this.previewLoading = false;
      this.previewKind = '';
      this.previewDetail = null;
      this.previewSummaryHtml = '';
      this.previewCleanHtml = '';
      this.previewChatBubbles = [];
      this.previewFallbackTranscript = '';
      this.previewRoleSwapped = false;
      this.previewTranscriptList = [];
      this.previewSpeakerOrder = [];
    },
    parsePreviewTranscript: function parsePreviewTranscript(raw) {
      this.previewChatBubbles = [];
      this.previewFallbackTranscript = '';
      this.previewRoleSwapped = false;
      this.previewTranscriptList = [];
      this.previewSpeakerOrder = [];
      if (raw == null || raw === '') return;
      var data = null;
      try {
        data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch (e) {
        this.previewFallbackTranscript = String(raw);
        return;
      }
      var list = null;
      if (Array.isArray(data)) {
        list = data;
      } else if (data && Array.isArray(data.paragraphList)) {
        list = data.paragraphList;
      }
      if (!list || !list.length) {
        if (typeof data === 'string') {
          this.previewFallbackTranscript = data;
        } else if (data && typeof data.text === 'string') {
          this.previewFallbackTranscript = data.text;
        } else {
          this.previewFallbackTranscript = typeof raw === 'string' ? raw : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data, null, 2);
        }
        return;
      }
      var resolveNick = function resolveNick(p) {
        if (!p) return '发言人';
        if (typeof p.speakerDisplay === 'string' && p.speakerDisplay) return p.speakerDisplay;
        if (p.speakerDisplay && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(p.speakerDisplay) === 'object') {
          if (p.speakerDisplay.nickName) return p.speakerDisplay.nickName;
          if (p.speakerDisplay.name) return p.speakerDisplay.name;
        }
        if (p.nickName) return p.nickName;
        return '发言人';
      };
      var speakerKey = function speakerKey(p) {
        var nick = resolveNick(p);
        if (nick && nick !== '发言人') return 'n:' + nick;
        if (p.unionId) return 'u:' + p.unionId;
        return 'unknown';
      };
      var speakerOrder = [];
      list.forEach(function (p) {
        var k = speakerKey(p);
        if (speakerOrder.indexOf(k) < 0) speakerOrder.push(k);
      });
      this.previewTranscriptList = list.map(function (p) {
        var text = p.paragraph;
        if (!text && Array.isArray(p.sentenceList)) {
          text = p.sentenceList.map(function (s) {
            return s && (s.sentence || s.text || s.content) || '';
          }).filter(Boolean).join('');
        }
        if (!text) text = '';
        return {
          key: speakerKey(p),
          text: text,
          timeLabel: formatMs(p.startTime)
        };
      }).filter(function (item) {
        return item.text;
      });
      this.previewSpeakerOrder = speakerOrder;
      this.buildPreviewBubbles();
    },
    previewRoleMetaForKey: function previewRoleMetaForKey(key) {
      var idx = this.previewSpeakerOrder.indexOf(key);
      var swapped = this.previewRoleSwapped;
      if (idx <= 0) {
        if (swapped) return { nick: '家长', side: 'left' };
        return { nick: '销售', side: 'right' };
      }
      if (idx === 1) {
        if (swapped) return { nick: '销售', side: 'right' };
        return { nick: '家长', side: 'left' };
      }
      return { nick: '其他', side: 'left' };
    },
    buildPreviewBubbles: function buildPreviewBubbles() {
      var _this10 = this;

      this.previewChatBubbles = this.previewTranscriptList.map(function (item) {
        var meta = _this10.previewRoleMetaForKey(item.key);
        return {
          nick: meta.nick,
          text: item.text,
          side: meta.side,
          timeLabel: item.timeLabel
        };
      });
    },
    togglePreviewRoleSwap: function togglePreviewRoleSwap() {
      this.previewRoleSwapped = !this.previewRoleSwapped;
      this.buildPreviewBubbles();
    },
    parseTranscript: function parseTranscript(raw) {
      this.chatBubbles = [];
      this.fallbackTranscript = '';
      this.roleSwapped = false;
      this.transcriptList = [];
      this.speakerOrder = [];
      if (raw == null || raw === '') return;
      var data = null;
      try {
        data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch (e) {
        this.fallbackTranscript = String(raw);
        return;
      }
      var list = null;
      if (Array.isArray(data)) {
        list = data;
      } else if (data && Array.isArray(data.paragraphList)) {
        list = data.paragraphList;
      }
      if (!list || !list.length) {
        if (typeof data === 'string') {
          this.fallbackTranscript = data;
        } else if (data && typeof data.text === 'string') {
          this.fallbackTranscript = data.text;
        } else {
          this.fallbackTranscript = typeof raw === 'string' ? raw : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data, null, 2);
        }
        return;
      }
      var resolveNick = function resolveNick(p) {
        if (!p) return '发言人';
        if (typeof p.speakerDisplay === 'string' && p.speakerDisplay) return p.speakerDisplay;
        if (p.speakerDisplay && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(p.speakerDisplay) === 'object') {
          if (p.speakerDisplay.nickName) return p.speakerDisplay.nickName;
          if (p.speakerDisplay.name) return p.speakerDisplay.name;
        }
        if (p.nickName) return p.nickName;
        return '发言人';
      };
      var speakerKey = function speakerKey(p) {
        var nick = resolveNick(p);
        if (nick && nick !== '发言人') return 'n:' + nick;
        if (p.unionId) return 'u:' + p.unionId;
        return 'unknown';
      };
      var speakerOrder = [];
      list.forEach(function (p) {
        var k = speakerKey(p);
        if (speakerOrder.indexOf(k) < 0) speakerOrder.push(k);
      });
      this.transcriptList = list.map(function (p) {
        var text = p.paragraph;
        if (!text && Array.isArray(p.sentenceList)) {
          text = p.sentenceList.map(function (s) {
            return s && (s.sentence || s.text || s.content) || '';
          }).filter(Boolean).join('');
        }
        if (!text) text = '';
        return {
          key: speakerKey(p),
          text: text,
          timeLabel: formatMs(p.startTime)
        };
      }).filter(function (item) {
        return item.text;
      });
      this.speakerOrder = speakerOrder;
      this.buildBubbles();
    },
    roleMetaForKey: function roleMetaForKey(key) {
      var idx = this.speakerOrder.indexOf(key);
      var swapped = this.roleSwapped;
      if (idx <= 0) {
        if (swapped) return { nick: '家长', side: 'left' };
        return { nick: '销售', side: 'right' };
      }
      if (idx === 1) {
        if (swapped) return { nick: '销售', side: 'right' };
        return { nick: '家长', side: 'left' };
      }
      return { nick: '其他', side: 'left' };
    },
    buildBubbles: function buildBubbles() {
      var _this11 = this;

      this.chatBubbles = this.transcriptList.map(function (item) {
        var meta = _this11.roleMetaForKey(item.key);
        return {
          nick: meta.nick,
          text: item.text,
          side: meta.side,
          timeLabel: item.timeLabel
        };
      });
    },
    toggleRoleSwap: function toggleRoleSwap() {
      this.roleSwapped = !this.roleSwapped;
      this.buildBubbles();
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editAssignWeightModal',
  components: { AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_1__common_AdminUserMultSelect_vue___default.a },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      insertLoading: false,
      params: {
        adviserList: [],
        uids: [],
        type: 1
      },
      formData: {
        totalNum: 0,
        remainder: 0,
        teamType: 0,
        adviserList: []
      },
      formRule: {}
    };
  },

  mounted: function mounted() {},
  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    getAdviserList: function getAdviserList(teamType) {
      var self = this;
      self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
        if (res && res.data) {
          self.formData.adviserList = res.data;
        }
      });
    },
    onTeamTypeChange: function onTeamTypeChange(value) {
      this.getAdviserList(value);
    },
    onTypeChange: function onTypeChange() {
      var self = this;
      var list = self.formData.adviserList;
      self.params.adviserList = [];
      var index = 0;
      for (; index < list.length; index++) {
        self.params.adviserList.push(list[index]);
      }
    },
    onWeightChange: function onWeightChange() {
      var self = this;
      var sumCount = 0;
      var list = self.formData.adviserList;
      self.params.adviserList = [];
      var index = 0;
      for (; index < list.length; index++) {
        var weight = parseInt(list[index].weight);
        sumCount += weight;
        self.params.adviserList.push(list[index]);
      }
      self.formData.remainder = self.formData.totalNum - sumCount;
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    confirmAssign: function confirmAssign() {
      var self = this;
      self.$http.post('/adviser/updateAdviserInfos', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.params);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('操作成功!');
          self.editModal = false;
          self.successCallback();
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.getAdviserList(0);
      }
    },
    userList: function userList(array) {
      this.params.uids = [];
      this.formData.totalNum = array.length;
      this.formData.remainder = array.length;
      for (var i = 0; i < array.length; i++) {
        this.params.uids.push(array[i].id);
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EvaluationSheetModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    uid: {
      type: Number,
      default: null
    },
    reprotId: {
      type: Number,
      default: null
    },
    studentid: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      reportRules: {
        lessonNum: [{ required: true, message: 'error', trigger: 'blur' }],
        partOneVocabulary: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partTwoSpeaking: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partTwoListening: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partTwoSentences: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partTwoAdaptability: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partTwoInteraction: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partThreeComments: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }],
        partFourFeedback: [{ type: 'string', required: true, message: 'error', trigger: 'blur' }]
      },
      name: '',
      formData: {
        id: '',
        lessonNum: '',
        uid: '',
        partOneVocabulary: '',
        partTwoSpeaking: '',
        partTwoListening: '',
        partTwoSentences: '',
        partTwoAdaptability: '',
        partTwoInteraction: '',
        partThreeComments: '',
        partFourFeedback: '',
        tutorId: ''
      },
      visible: false,
      submitShow: false
    };
  },

  methods: {
    addStageReport: function addStageReport() {
      var self = this;
      self.$refs.reportForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('ERROR!');
          return;
        }
        self.$http.post('/stageReport/updateReprot', self.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('保存成功');
            self.successCallback();
            self.visible = false;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        var self = this;
        this.$emit('on-close');
        self.formData.lessonNum = '';
        self.formData.partOneVocabulary = '';
        self.formData.partTwoSpeaking = '';
        self.formData.partTwoListening = '';
        self.formData.partTwoSentences = '';
        self.formData.partTwoAdaptability = '';
        self.formData.partTwoInteraction = '';
        self.formData.partThreeComments = '';
        self.formData.partFourFeedback = '';
      }
    },
    uid: function uid(val) {
      this.formData.uid = val;
      if (val) {
        var self = this;
        self.$http.get('/userList/selectByUserId', { params: { uid: val } }).then(function (res) {
          if (res.data) {
            self.name = res.data.nickname;
          }
        });
      }
    },
    reprotId: function reprotId(val) {
      if (val) {
        var self = this;
        self.$http.get('/stageReport/selectByid?id=' + val).then(function (res) {
          if (res.data) {
            self.formData.id = res.data.id;
            self.formData.uid = res.data.uid;
            self.formData.lessonNum = res.data.lessonNum;
            self.formData.partOneVocabulary = res.data.partOneVocabulary;
            self.formData.partTwoSpeaking = res.data.partTwoSpeaking;
            self.formData.partTwoListening = res.data.partTwoListening;
            self.formData.partTwoSentences = res.data.partTwoSentences;
            self.formData.partTwoAdaptability = res.data.partTwoAdaptability;
            self.formData.partTwoInteraction = res.data.partTwoInteraction;
            self.formData.partThreeComments = res.data.partThreeComments;
            self.formData.partFourFeedback = res.data.partFourFeedback;
          }
        });
      }
    },
    studentid: function studentid(val) {
      if (val) {
        var self = this;
        self.$http.get('/tch/selectAllId?uid=' + val).then(function (res) {
          if (res && res.data) {
            self.formData.tutorId = res.data.tutorId;
          } else {
            self.formData.tutorId = '';
          }
        });
      }
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdviserFloatModal: __WEBPACK_IMPORTED_MODULE_0__common_AdviserFloatModal_vue___default.a
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      exportLoading: false,
      cancelLoading: false,
      showAssignAdviserModal: false,
      selectionUser: [],
      searchLoading: false,
      editUser: false,
      reload: 0,
      uid: null,
      queryParam: {
        recordsSource: '',
        stdStatus: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        linkStartTimeDate: '',
        linkEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        stdSearchKey: '',
        nickName: '',
        studyAdviserId: '',
        studentLessonState: '',
        adviserId: null,
        adviserIds: [],
        teamType: null
      },
      studyAdvisers: [],
      assignTitle: [{
        type: 'selection',
        width: 60,
        align: 'center',
        fixed: 'left'
      }, {
        title: '学生ID/姓名',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '注册渠道',
        align: 'center',
        key: 'regType'
      }, {
        title: '分配来源',

        render: function render(h, params) {
          var recordsSource = params.row.recordsSource;
          var recordsSourceEnum = $constant.getEnum($constant.recordsSource, recordsSource);
          return h('div', recordsSourceEnum && recordsSourceEnum.text);
        }
      }, {
        title: '课程顾问',

        key: 'adviserName',
        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '分配人',
        align: 'center',
        key: 'assignerName'
      }, {
        title: '分配时间',
        align: 'center',

        key: 'assignTime'
      }, {
        title: '钉钉提醒时间',
        align: 'center',

        key: 'msgSendTime'
      }, {
        title: '销售处理时间',
        align: 'center',

        render: function render(h, params) {
          var updateTime = params.row.updateTime;
          if (updateTime) {
            return h('div', [h('span', { style: { color: '#19be6b' } }, updateTime), h('br'), h('span', { style: { color: '#19be6b' } }, '耗时:' + params.row.duration)]);
          } else {
            return h('div', [h('span', { style: { color: '#ff9900' } }, '待处理'), h('br'), h('span', { style: { color: '#ff9900' } }, params.row.duration)]);
          }
        }
      }, {
        title: '销售备注',
        align: 'center',

        key: 'optRemark'
      }, {
        title: '通话录音',
        render: function render(h, params) {
          var audioUrl = params.row.audioUrl;
          if (audioUrl) {
            if (audioUrl === '失败') {
              return h('span', '无录音');
            }
            return h('audio', {
              attrs: {
                src: audioUrl,
                controls: true },
              style: {
                width: '100%'
              }
            });
          } else {
            return h('span', '无录音');
          }
        }
      }]
    };
  },

  methods: {
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    getAdviserInfo: function getAdviserInfo(obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId;
        this.queryParam.teamType = obj.teamType;
        this.queryParam.adviserIds = obj.adviserIds;
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    regTimeStartChange: function regTimeStartChange(val) {
      this.queryParam.regStartTimeDate = val;
    },
    regTimeEndChange: function regTimeEndChange(val) {
      this.queryParam.regEndTimeDate = val;
    },
    linkTimeStartChange: function linkTimeStartChange(val) {
      this.queryParam.linkStartTimeDate = val;
    },
    linkTimeEndChange: function linkTimeEndChange(val) {
      this.queryParam.linkEndTimeDate = val;
    },
    batchCancel: function batchCancel() {
      var _this = this;

      var self = this;
      this.cancelLoading = true;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
        this.$http.post('/adviser/batch-notify', {
          ids: ids
        }).then(function (res) {
          self.$Message.success('提醒成功');
          self.cancelLoading = false;
        }).catch(function (e) {
          _this.cancelLoading = false;
        });
      } else {
        self.$Message.warning('请选择目标');
        this.cancelLoading = false;
      }
    }
  },
  created: function created() {
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    this.queryParam.linkStartTimeDate = year + '-' + month + '-' + day;
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data;
    });
    this.cmd = 1;
    this.title = this.assignTitle;
    this.search();
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'manualAssignModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      insertLoading: false,
      params: {
        adviserList: [],
        uids: []
      },
      formData: {
        totalNum: 0,
        remainder: 0,
        teamType: 0,
        adviserGroupList: this.$constant.adviserGroup,
        adviserList: []
      },
      formRule: {}
    };
  },

  mounted: function mounted() {},
  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    getAdviserList: function getAdviserList(teamType) {
      var self = this;
      self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
        if (res && res.data) {
          self.formData.adviserList = res.data;
        }
      });
    },
    onTeamTypeChange: function onTeamTypeChange(value) {
      this.getAdviserList(value);
    },
    onCountChange: function onCountChange() {
      var self = this;
      var sumCount = 0;
      var list = self.formData.adviserList;
      self.params.adviserList = [];
      var index = 0;
      for (; index < list.length; index++) {
        var count = parseInt(list[index].count);
        sumCount += count;
        if (count > 0) {
          self.params.adviserList.push(list[index]);
        }
      }
      self.formData.remainder = self.formData.totalNum - sumCount;
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    confirmAssign: function confirmAssign() {
      var self = this;
      self.insertLoading = true;
      self.$http.post('/adviser/manualAssignAdviser', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.params);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.insertLoading = false;
        if (res && res.data > 0) {
          self.$Message.success('操作成功!');
          self.editModal = false;
          self.successCallback();
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.getAdviserList(0);
      }
    },
    userList: function userList(array) {
      this.params.uids = [];
      this.formData.totalNum = array.length;
      this.formData.remainder = array.length;
      for (var i = 0; i < array.length; i++) {
        this.params.uids.push(array[i].id);
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_StudentInfo_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_StudentInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_StudentInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TodayPunchStatisticsModal_vue__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TodayPunchStatisticsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TodayPunchStatisticsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_UserLeaveModal_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_UserLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__user_UserLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_modal_UserTempLessonModal_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_modal_UserTempLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__user_modal_UserTempLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_UserPLLessonModal_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_UserPLLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__user_UserPLLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_UserChineseLessonModal_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_UserChineseLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__user_UserChineseLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_UserClassHourModal_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_UserClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__user_UserClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_UserLeaveNumModal_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_UserLeaveNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__user_UserLeaveNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_UserLessonNumModal_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_UserLessonNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__user_UserLessonNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_modal_CourseSchedulingModal_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_modal_CourseSchedulingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__user_modal_CourseSchedulingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_modal_BindTchModal_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_modal_BindTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__user_modal_BindTchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__order_AddOrderModal_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__order_AddOrderModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__order_AddOrderModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__user_UserTrialLessonModal_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__user_UserTrialLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__user_UserTrialLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tools_date_format_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__tools_date_format_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_modal_InsertUserModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_modal_InsertUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__user_modal_InsertUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_AssignAdviserModal_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_AssignAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__user_AssignAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__user_BatchMoveUserModal_vue__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__user_BatchMoveUserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__user_BatchMoveUserModal_vue__);
























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BatchMoveUserModal: __WEBPACK_IMPORTED_MODULE_20__user_BatchMoveUserModal_vue___default.a,
    AssignAdviserModal: __WEBPACK_IMPORTED_MODULE_19__user_AssignAdviserModal_vue___default.a,
    StudentInfo: __WEBPACK_IMPORTED_MODULE_1__common_StudentInfo_vue___default.a,
    AdviserFloatModal: __WEBPACK_IMPORTED_MODULE_2__common_AdviserFloatModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_3__UserInfoModal_vue___default.a,
    TodayPunchStatisticsModal: __WEBPACK_IMPORTED_MODULE_4__TodayPunchStatisticsModal_vue___default.a,
    UserLeaveModal: __WEBPACK_IMPORTED_MODULE_5__user_UserLeaveModal_vue___default.a,
    UserTempLessonModal: __WEBPACK_IMPORTED_MODULE_6__user_modal_UserTempLessonModal_vue___default.a,
    UserPLLessonModal: __WEBPACK_IMPORTED_MODULE_7__user_UserPLLessonModal_vue___default.a,
    UserChineseLessonModal: __WEBPACK_IMPORTED_MODULE_8__user_UserChineseLessonModal_vue___default.a,
    UserClassHourModal: __WEBPACK_IMPORTED_MODULE_9__user_UserClassHourModal_vue___default.a,
    UserLeaveNumModal: __WEBPACK_IMPORTED_MODULE_10__user_UserLeaveNumModal_vue___default.a,
    CourseSchedulingModal: __WEBPACK_IMPORTED_MODULE_12__user_modal_CourseSchedulingModal_vue___default.a,
    BindTchModal: __WEBPACK_IMPORTED_MODULE_13__user_modal_BindTchModal_vue___default.a,
    UserLessonNumModal: __WEBPACK_IMPORTED_MODULE_11__user_UserLessonNumModal_vue___default.a,
    AddOrderModal: __WEBPACK_IMPORTED_MODULE_14__order_AddOrderModal_vue___default.a,
    UserTrialLessonModal: __WEBPACK_IMPORTED_MODULE_15__user_UserTrialLessonModal_vue___default.a,
    InsertUserModal: __WEBPACK_IMPORTED_MODULE_18__user_modal_InsertUserModal___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      num: 10,
      dateRange: [],
      showTodayPunchStatisticsModal: false,
      payStudentType: 'error',
      myStudentType: 'error',
      godent: 'error',
      typeData: 'error',
      typeRanking: 'error',
      todayContactType: 'error',
      todayPublicType: 'error',
      todayAllotType: 'success',
      showPassModal: false,
      loadingPass: false,
      editUser: false,
      searchLoading: false,
      todayLoading: false,
      vaultLoading: false,
      exportLoading: false,
      tabValue: 0,
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModel: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showCourseSchedulingModal: false,
      showBindTchModal: false,
      isBinded: false,
      currentRow: null,
      showUserTrialLessonModal: false,
      trialaLessonUser: {},
      addOrderModal: false,
      orderQuantity: 0,
      finishOrderQuantity: 0,
      beginNextContact: '',
      endNextContact: '',
      dealMoney: 0.0,
      dealRate: '0%',
      reload: 0,
      listUrl: '/userList/todayAllot',
      uid: null,
      showInsertUserModal: false,
      showBatchMoveUser: false,
      showAssignAdviserModal: false,
      loadingInsertUser: false,
      queryParam: {
        tchChannel: '',
        channelType: '',
        intentLevel: '',
        stdStatus: '',
        connectionStatus: '',
        stdTab: -1,
        searchKeyword: '',
        beginRegTime: '',
        endRegTime: '',
        beginUseDate: '',
        endUseDate: '',
        beginlastPhoneTime: '',
        endlastPhoneTime: '',
        beginNextContactTime: '',
        endNextContactTime: '',
        adviserId: null,
        adviserIds: [],
        teamType: null,
        type: 1,
        regType: '',
        isPay: '-1',
        newPublic: '',
        isPrivate: '',
        startTime: '',
        endTime: ''
      },
      selectionUser: [],
      resourceTitle: [{
        type: 'selection',
        width: 60,
        fixed: 'left',
        align: 'center'
      }, {
        title: 'ID/姓名',
        width: 150,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '打电话',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('button', { attrs: { class: 'telephone2' }, on: { click: function click() {
                return _this.dialTel(row.uid, row.mobile);
              } } })]);
        }
      }, {
        title: '微信',
        width: 100,
        key: 'webChat'
      }, {
        title: '名单标签',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var assignNum = params.row.assignNum;
          var assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum);
          return h('div', assignNumEnum && assignNumEnum.text);
        }
      }, {
        title: '跟进内容',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('div', [h('span', row.followUpContent), h('br'), h('a', { on: { click: function click() {
                return self.edit(row.uid);
              } } }, '跟进内容')]);
        }
      }, {
        title: '下次联系',
        width: 120,
        align: 'center',
        key: 'nextContactTime',
        sortable: 'custom'
      }, {
        title: '渠道',
        width: 120,
        align: 'center',
        key: 'regType'
      }, {
        title: '推荐人',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var auName = params.row.auName;
          var auId = params.row.auId;
          if (auName && auId) {
            return h('span', auId + '-' + auName);
          }
          return h('span', '');
        }
      }, {
        title: '注册时间',
        width: 115,
        align: 'center',
        key: 'registerTime',
        sortable: 'custom'
      }, {
        title: '学员状态',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var stdStatus = params.row.stdStatus;
          var stdStatuslEnum = $constant.getEnum($constant.stdStatus, stdStatus);
          return h('div', { style: { 'font-size': '12px' } }, [h('p', stdStatuslEnum && stdStatuslEnum.text), h('p', params.row.lessonTitle), h('p', params.row.demoTchName)]);
        }
      }, {
        title: '最后编辑信息',
        width: 150,
        align: 'center',
        key: 'nameAndModified'
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: function render(h, params) {
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'trialLesson' } }, '约试听课'));
          btn.push(h('Dropdown-item', { props: { name: 'addOrder' } }, '添加订单'));
          btn.push(h('Dropdown-item', { props: { name: 'moveUser' } }, '移至公库'));
          btn.push(h('Dropdown-item', { props: { name: 'moveGodent' } }, '移至小金库'));
          return h('div', [h('span', { class: 'divider' }), h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                var row = params.row;
                if (name === 'trialLesson') {
                  _this.onTrialLesson(row);
                } else if (name === 'addOrder') {
                  _this.addOrderModal = true;
                } else if (name === 'moveUser') {
                  _this.onPass(params.row);
                } else if (name === 'moveGodent') {
                  _this.onMoveGent(params.row);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      rankingTtile: [{
        type: 'index',
        title: '排名',
        width: 100
      }, {
        title: '课顾',
        width: 150,
        key: 'adviserName',
        render: function render(h, params) {
          var row = params.row;
          if (row.state === 1) {
            return h('span', [h('span', row.adviserName)]);
          } else {
            return h('span', [h('span', row.adviserName), h('span', { style: { color: 'red' } }, '(离职)')]);
          }
        }
      }, {
        title: '目标(单)',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.orderQuantity);
        }
      }, {
        title: '完成量(单)',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishOrderQuantity);
        }
      }, {
        title: '成交金额',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.dealMoney);
        }
      }, {
        title: '完成率',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishRate.toFixed(2) + '%');
        }
      }],
      privateTitle: [{
        title: 'ID/姓名',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 150,
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          var row = params.row;
          return h('div', [h('span', row.mobile), h('br'), h('button', { attrs: { class: 'telephone2' }, on: { click: function click() {
                return _this.dialTel(row.id, row.mobile);
              } } })]);
        }
      }, {
        title: '城市',
        width: 100,
        key: 'city'
      }, {
        title: '微信',
        width: 100,
        key: 'webChat'
      }, {
        title: '接通状态',
        width: 120,
        render: function render(h, params) {
          var connectionStatus = params.row.connectionStatus;
          var connectionStatuslEnum = $constant.getEnum($constant.connectionStatus, connectionStatus);
          return h('div', connectionStatuslEnum && connectionStatuslEnum.text);
        }
      }, {
        title: '客户意向',
        width: 120,
        render: function render(h, params) {
          var intentLevel = params.row.intentLevel;
          var intentLevellEnum = $constant.getEnum($constant.intentLevel, intentLevel);
          return h('div', intentLevellEnum && intentLevellEnum.text);
        }
      }, {
        title: '名单标签',
        width: 120,
        render: function render(h, params) {
          var assignNum = params.row.assignNum;
          var assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum);
          return h('div', assignNumEnum && assignNumEnum.text);
        }
      }, {
        title: '跟进内容',
        width: 200,
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('div', [h('Poptip', {
            props: {
              trigger: 'hover',
              placement: 'top'
            }
          }, [h('span', {
            style: {
              display: 'inline-block',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, row.followUpContent), h('div', { slot: 'content' }, row.followUpContent)]), h('br'), h('a', { on: { click: function click() {
                return self.edit(row.uid);
              } } }, '跟进内容')]);
        }
      }, {
        title: '下次联系',
        width: 120,
        key: 'nextContactTime'
      }, {
        title: '渠道',
        width: 120,
        key: 'regType'
      }, {
        title: '推荐人',
        width: 120,
        render: function render(h, params) {
          var auName = params.row.auName;
          var auId = params.row.auId;
          if (auName && auId) {
            return h('span', auId + '-' + auName);
          }
          return h('span', '');
        }
      }, {
        title: '注册时间',
        width: 170,
        key: 'registerTime'
      }, {
        title: '学员状态',
        width: 120,
        render: function render(h, params) {
          var stdStatus = params.row.stdStatus;
          var stdStatuslEnum = $constant.getEnum($constant.stdStatus, stdStatus);
          return h('div', { style: { 'font-size': '12px' } }, [h('p', stdStatuslEnum && stdStatuslEnum.text), h('p', params.row.lessonTitle), h('p', params.row.demoTchName)]);
        }
      }, {
        title: '最后编辑信息',
        width: 150,
        key: 'nameAndModified'
      }, {
        title: '操作',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'trialLesson' } }, '约试听课'));
          btn.push(h('Dropdown-item', { props: { name: 'addOrder' } }, '添加订单'));
          btn.push(h('Dropdown-item', { props: { name: 'moveGodent' } }, '移出小金库'));
          return h('div', [h('span', { class: 'divider' }), h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                var row = params.row;
                if (name === 'trialLesson') {
                  _this.onTrialLesson(row);
                } else if (name === 'addOrder') {
                  _this.addOrderModal = true;
                } else if (name === 'moveUser') {
                  _this.onPass(params.row);
                } else if (name === 'moveGodent') {
                  _this.onRemoveGent(params.row);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      userPaytitle: [{
        title: '学生ID/姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          var row = params.row;
          return h('div', [h('span', row.mobile), h('br'), h('button', { attrs: { class: 'telephone2' }, on: { click: function click() {
                return _this.dialTel(row.id, row.mobile);
              } } })]);
        }
      }, {
        title: '课程顾问',
        width: 90,
        key: 'adviserName',
        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '学导',
        width: 100,
        key: 'studyAdviserName',
        render: function render(h, params) {
          return h('span', params.row.studyAdviserName || '未分配');
        }
      }, {
        title: '绑定老师',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          if (row.tchBoundNum === 0) {
            return h('span', '未绑定');
          }
          if (!row.tchIdAndNames) {
            console.log('row:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row));
            return h('span', '');
          }
          var tchIdAndNameArr = row.tchIdAndNames.split(',');
          var spans = [];
          for (var i = 0; i < tchIdAndNameArr.length; i++) {
            var obj = h('span', tchIdAndNameArr[i]);
            spans.push(obj);
            spans.push(h('br'));
          }
          return h('div', spans);
        }
      }, {
        title: '等级',
        width: 80,
        render: function render(h, params) {
          return h('span', params.row.levelTitle || '未分级');
        }
      }, {
        title: '上课时间',
        width: 160,
        render: function render(h, params) {
          var list = params.row.bookWorkLessonOpenedTimeList;
          if (!list) {
            return h('span', '未绑定');
          }
          var spanArr = [];
          list.forEach(function (element) {
            var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
            spanArr.push(h('span', $constant.weekZh[element.week] + startTime));
            spanArr.push(h('br'));
          });
          return h('div', spanArr);
        }
      }, {
        title: '总课时(外教/中教)',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.routineNum + ' / ' + row.chineseNum);
        }
      }, {
        title: '剩余(外教/中教)',
        width: 130,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.routineNum - row.routineEndNum + ' / ' + (row.chineseNum - row.chineseEndNum));
        }
      }, {
        title: '赠送课时',
        width: 80,
        align: 'center',
        key: 'discountNum'
      }, {
        title: '请假/补课次数',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.leaveNum + ' / ' + (row.makeupLessonNum - row.makeupLessonEndNum));
        }
      }, {
        title: '微信',
        width: 80,
        align: 'center',
        key: 'webChat'
      }, {
        title: '操作',
        align: 'center',

        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var id = row.id;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'userTemp' } }, '临时约课'));

          var bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList;
          if (!bookWorkLessonOpenedTimeList) {
            btn.push(h('Dropdown-item', { props: { name: 'bindTch' } }, '绑定老师'));
          } else {
            btn.push(h('Dropdown-item', { props: { name: 'editBindTch' } }, '修改绑定'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'changeDirector' } }, '学员转移'));
          btn.push(h('Dropdown-item', { props: { name: 'classHour' } }, '加减课时'));
          btn.push(h('Dropdown-item', { props: { name: 'leaveNum' } }, '加减请假次数'));
          btn.push(h('Dropdown-item', { props: { name: 'lessonNum' } }, '加减补课次数'));

          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'userTemp') {
                  _this.showUserTempLessonModal = true;
                  _this.tempLessonUser = row;
                } else if (name === 'bindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                  _this.isBinded = false;
                } else if (name === 'editBindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                  _this.isBinded = true;
                } else if (name === 'unbindTch') {
                  _this.onUnbingTch(row);
                } else if (name === 'classHour') {
                  _this.uid = id;
                  _this.showUserClassHourModal = true;
                } else if (name === 'changeDirector') {
                  _this.uid = id;
                  _this.onChangeDirector(row);
                } else if (name === 'leaveNum') {
                  _this.uid = id;
                  _this.showUserLeaveNumModal = true;
                } else if (name === 'lessonNum') {
                  _this.uid = id;
                  _this.showUserLessonNumModal = true;
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      dataTitle: [{
        title: '课顾',
        width: 150,
        key: 'adviserName',
        render: function render(h, params) {
          var row = params.row;
          if (row.state === 1) {
            return h('span', [h('span', row.adviserName)]);
          } else {
            return h('span', [h('span', row.adviserName), h('span', { style: { color: 'red' } }, '(离职)')]);
          }
        }
      }, {
        title: '外呼次数',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.outerCallNum);
        }
      }, {
        title: '接听量',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.answerTime.toFixed(2));
        }
      }, {
        title: '通时',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.callTime.toFixed(2));
        }
      }, {
        title: '名单数',
        width: 100,
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.totalListNum);
        }
      }, {
        title: '邀约数',
        width: 100,
        key: 'inviteListNum',
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.inviteListNum);
        }
      }, {
        title: '邀约率',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.inviteRate.toFixed(2) + '%');
        }
      }, {
        title: '出席数',
        key: 'attendNum',
        width: 100,
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.attendNum);
        }
      }, {
        title: '出席率',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.attendRate.toFixed(2) + '%');
        }
      }, {
        title: '成交数',
        key: 'dealNum',
        width: 100,
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.dealNum);
        }
      }, {
        title: '注册成交率',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.payUserRate.toFixed(2) + '%');
        }
      }, {
        title: '出席成交率',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.attendDealRate.toFixed(2) + '%');
        }
      }, {
        title: '目标(单)',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.orderQuantity);
        }
      }, {
        title: '完成量(单)',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishOrderQuantity);
        }
      }, {
        title: '成交金额',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.dealMoney);
        }
      }, {
        title: '完成率',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishRate.toFixed(2) + '%');
        }
      }],
      title: []
    };
  },

  methods: {
    onTrialLesson: function onTrialLesson(row) {
      this.showUserTrialLessonModal = true;
      this.trialaLessonUser = row;
    },
    publicUser: function publicUser() {
      this.typeRanking = 'error';
      this.typeData = 'error';
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayPublicType = 'success';
      this.todayContactType = 'error';
      this.myStudentType = 'error';
      this.godent = 'error';
      this.queryParam.type = 1;

      this.queryParam.newPublic = 2;
      this.title = this.resourceTitle;
      delete this.queryParam.sortProperty;
      delete this.queryParam.sortDirection;
      if (this.listUrl === '/userList/todayAllot') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/todayAllot';
      }
    },
    todayContact: function todayContact() {
      this.typeRanking = 'error';
      this.typeData = 'error';
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayPublicType = 'error';
      this.todayContactType = 'success';
      this.myStudentType = 'error';
      this.godent = 'error';
      this.queryParam.type = -1;

      this.queryParam.newPublic = '';
      this.title = this.resourceTitle;
      if (this.listUrl === '/userList/todayContact') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/todayContact';
      }
    },
    payStudent: function payStudent() {
      this.typeRanking = 'error';
      this.typeData = 'error';
      this.todayPublicType = 'error';
      this.payStudentType = 'success';
      this.todayAllotType = 'error';
      this.todayContactType = 'error';
      this.myStudentType = 'error';
      this.godent = 'error';
      this.title = this.userPaytitle;
      if (this.listUrl === '/userList/payList') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/payList';
      }
    },
    ranking: function ranking() {
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayContactType = 'error';
      this.todayPublicType = 'error';
      this.myStudentType = 'error';
      this.godent = 'error';
      this.typeData = 'error';
      this.typeRanking = 'success';
      this.queryParam.newPublic = '';
      this.title = this.rankingTtile;
      this.queryParam.type = '';
      this.queryParam.isPay = '';
      this.queryParam.isPrivate = 1;
      if (this.listUrl === '/adminUser/crmRanking') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/adminUser/crmRanking';
      }
    },
    onBatchMoveUser: function onBatchMoveUser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要批量添加到公库的学生！');
        return;
      }
      this.showBatchMoveUser = true;
    },
    onInsertUser: function onInsertUser() {
      this.showInsertUserModal = true;
    },
    vault: function vault() {
      this.typeRanking = 'error';
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayContactType = 'error';
      this.todayPublicType = 'error';
      this.myStudentType = 'error';
      this.typeData = 'error';
      this.godent = 'success';
      this.queryParam.newPublic = '';
      this.title = this.privateTitle;
      this.queryParam.type = '';
      this.queryParam.isPay = '';
      this.queryParam.isPrivate = 1;
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/crmList';
      }
    },
    myStudent: function myStudent() {
      this.typeRanking = 'error';
      this.typeData = 'error';
      this.queryParam.isPay = 0;
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayContactType = 'error';
      this.todayPublicType = 'error';
      this.godent = 'error';
      this.myStudentType = 'success';
      this.queryParam.newPublic = '';
      this.queryParam.type = -1;
      this.queryParam.isPay = 0;
      this.queryParam.isPrivate = 0;
      this.title = this.resourceTitle;
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/crmList';
      }
      delete this.queryParam.sortProperty;
      delete this.queryParam.sortDirection;
    },
    myStudentAll: function myStudentAll() {
      this.typeRanking = 'error';
      this.typeData = 'success';
      this.payStudentType = 'error';
      this.todayAllotType = 'error';
      this.todayContactType = 'error';
      this.todayPublicType = 'error';
      this.godent = 'error';
      this.myStudentType = 'error';
      this.queryParam.stdTab = '';
      this.queryParam.type = '';
      this.queryParam.isPay = '';
      this.title = this.resourceTitle;
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/crmList';
      }
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/crm/MyResource' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      var self = this;
      var startTimeDate = __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js___default.a.format(this.dateRange[0]);
      var endTimeDate = __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js___default.a.format(this.dateRange[1]);
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000;
      this.reload = new Date().getTime();
      delete this.queryParam.adviserAssignTime;
      delete this.queryParam.vaultTime;
      delete this.queryParam.sortProperty;
      delete this.queryParam.sortDirection;
      this.selectionUser = [];
    },
    searchCurr: function searchCurr() {
      var self = this;
      var startTimeDate = __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js___default.a.format(this.dateRange[0]);
      var endTimeDate = __WEBPACK_IMPORTED_MODULE_17__tools_date_dates_js___default.a.format(this.dateRange[1]);
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000;
      this.reload = 119;
      this.selectionUser = [];
    },
    todayAllot: function todayAllot() {
      this.typeRanking = 'error';
      this.typeData = 'error';
      this.todayContactType = 'error';
      this.todayAllotType = 'success';
      this.todayPublicType = 'error';
      this.myStudentType = 'error';
      this.godent = 'error';
      this.queryParam.type = 1;

      this.queryParam.newPublic = 1;
      this.title = this.resourceTitle;
      delete this.queryParam.sortProperty;
      delete this.queryParam.sortDirection;
      if (this.listUrl === '/userList/todayAllot') {
        this.reload = new Date().getTime();
      } else {
        this.listUrl = '/userList/todayAllot';
      }
    },
    edit: function edit(uid) {
      this.uid = uid;
      this.tabValue = 1;
      this.editUser = true;
    },
    closeModal: function closeModal(val) {
      this.tabValue = 0;
      this.uid = null;
      this.editUser = false;
    },
    todayOpenClass: function todayOpenClass() {
      var self = this;
      var query = {};
      query.startCreateTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000;
      query.startCreateDate = self.$moment(query.startCreateTime, 'X').format('YYYY-MM-DD HH:mm');
      query.endCreateTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000 + 24 * 3600;
      query.endCreateDate = self.$moment(query.endCreateTime, 'X').format('YYYY-MM-DD HH:mm');
      query.operatorIds = self.queryParam.adviserIds;
      query.tchChannel = self.queryParam.tchChannel;
      query.fromCrm = 1;

      query.adviserId = self.queryParam.adviserId;
      self.$router.push({ path: '/lesson/bookLessonOpenedList', query: query });
    },
    todayLisent: function todayLisent() {
      var self = this;
      var query = {};
      query.startTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000;
      query.startTimeDate = self.$moment(query.startTime, 'X').format('YYYY-MM-DD HH:mm');
      query.endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000 + 24 * 3600;
      query.endTimeDate = self.$moment(query.endTime, 'X').format('YYYY-MM-DD HH:mm');
      query.adviserIds = self.queryParam.adviserIds;
      query.tchChannel = self.queryParam.tchChannel;
      query.lsnType = 1;

      query.adviserId = self.queryParam.adviserId;
      self.$router.push({ path: '/lesson/bookLessonOpenedList', query: query });
    },
    onPass: function onPass(row) {
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移除</span>此资源?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/userList/crmResourceUpdate', { id: row.uid }).then(function (res) {
            if (res) {
              self.searchCurr();
            }
          });
        }
      });
    },
    onMoveGent: function onMoveGent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移至</span>小金库?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/userList/updatePrivate', { id: row.uid, type: 1 }).then(function (res) {
            if (res) {
              self.searchCurr();
            }
          });
        }
      });
    },
    onRemoveGent: function onRemoveGent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移出</span>小金库?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/userList/updatePrivate', { id: row.uid, type: 0 }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
      this.queryParam.a = 99;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    beginRegTimeChange: function beginRegTimeChange(value) {
      this.queryParam.beginRegTime = value;
    },
    endRegTimeChange: function endRegTimeChange(value) {
      this.queryParam.endRegTime = value;
    },
    beginlastPhoneTime: function beginlastPhoneTime(value) {
      this.queryParam.beginlastPhoneTime = value;
    },
    endlastPhoneTime: function endlastPhoneTime(value) {
      this.queryParam.endlastPhoneTime = value;
    },
    beginNextContactTime: function beginNextContactTime(value) {
      this.queryParam.beginNextContactTime = value;
    },
    endNextContactTime: function endNextContactTime(value) {
      this.queryParam.endNextContactTime = value;
    },
    getAdviserInfo: function getAdviserInfo(obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId;
        this.queryParam.teamType = obj.teamType;
        this.queryParam.adviserIds = obj.adviserIds;
        this.loadStatisticsData();
      }
    },
    onPunch: function onPunch() {
      var self = this;
      self.$http.post('/adviser/onPunch').then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('打卡成功!');
          if (res.data > 250) {
            self.$Message.warning('目前未付费个人资源数为：' + res.data + '，超过300将不再自动分配资源');
          }
        } else {
          self.$Message.error('打卡失败!');
        }
      });
    },
    showPunchStatistics: function showPunchStatistics() {
      this.showTodayPunchStatisticsModal = true;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showAssignAdviserModal = true;
    },
    reloadAfterAssign: function reloadAfterAssign() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    onAssignStudyAdviser: function onAssignStudyAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！');
        return;
      }
      this.showAssignUserStudyAdviserModal = true;
    },
    onUnbingTch: function onUnbingTch(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '解绑之后，其他学生可以占用该绑定时间，是否确认解绑该老师？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookWordLessonOpenedTime/unbindTch', { uid: row.id }).then(function (res) {
            self.search();
            self.$Message.success('解绑成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    onChangeDirector: function onChangeDirector(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search();
            self.$Message.success('转移成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    dialTel: function dialTel(uid, mobile) {
      if (!uid) {
        this.$Message.warning('学生ID不能为空');
        return;
      }

      if (!mobile) {
        this.$Message.warning('无效手机号码');
        return;
      }
      this.dialLoading = true;
      var self = this;
      this.$http.get('/moor/call?callNo=' + mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!');
          self.dialLoading = false;
        }
      });
    },
    handleSortChange: function handleSortChange(column, key, order) {
      delete this.queryParam.sortProperty;
      delete this.queryParam.sortDirection;
      if (order && order !== 'normal') {
        var sortKeyMap = {};
        if (this.listUrl.indexOf('/userList/todayContact') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 't.next_contact_time' };
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' };
          }
        } else if (this.listUrl.indexOf('/userList/crmList') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 'nct.max_next_contact_time' };
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' };
          }
        } else if (this.listUrl.indexOf('/userList/todayAllot') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 'nct.max_next_contact_time' };
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' };
          }
        }
        this.queryParam.sortProperty = sortKeyMap[key] || key;
        this.queryParam.sortDirection = order;
      }
      this.reload = new Date().getTime();
    },
    loadStatisticsData: function loadStatisticsData() {
      var self = this;
      self.$http.get('/userList/targetStatistics?adviserIds=' + self.queryParam.adviserIds).then(function (res) {
        if (res.data) {
          self.orderQuantity = res.data.orderQuantity;
          self.finishOrderQuantity = res.data.finishOrderQuantity;
          self.dealMoney = res.data.dealMoney;
          self.dealRate = res.data.dealRate;
        }
      });
    }
  },
  mounted: function mounted() {
    var query = this.$route.query;
    if (query) {
      if (query.beginNextContactTime) {
        this.beginNextContact = query.beginNextContactTime;
      }
      if (query.endNextContactTime) {
        this.endNextContact = query.endNextContactTime;
      }
    }
  },
  created: function created() {
    this.title = this.resourceTitle;
    this.queryParam.newPublic = '';
    var query = this.$route.query;
    if (query) {
      if (query.beginNextContactTime) {
        this.beginNextContact = query.beginNextContactTime;
      }
      if (query.endNextContactTime) {
        this.endNextContact = query.endNextContactTime;
      }
    }

    var week = new Date().getDay();
    var left = week;
    if (week === 0) {
      left = 7;
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SalesAdviserSelect_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SalesAdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SalesAdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_aiAccess__ = __webpack_require__(30);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SalesAdviserSelect: __WEBPACK_IMPORTED_MODULE_0__common_SalesAdviserSelect_vue___default.a, AiDrawer: __WEBPACK_IMPORTED_MODULE_1__components_ai_AiDrawer___default.a },
  data: function data() {
    var _this = this;

    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var yesterdayStr = yesterday.toISOString().split('T')[0];
    return {
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      selectionUser: [],
      timeDateChange: '',
      searchLoading: false,
      defaultDate: [yesterdayStr, yesterdayStr],
      queryParam: {
        ecUserName: '',
        beginTime: yesterdayStr,
        endTime: yesterdayStr,
        mobile: ''
      },
      tableColumns: [{
        title: '员工',
        key: 'callerId',
        align: 'center'
      }, {
        title: '通话时间',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', { style: { margin: '0' } }, params.row.beginTime), h('p', { style: { margin: '0' } }, '通话时长:' + _this.time(params.row.hold))]);
        }
      }, {
        title: '被呼叫号码',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', { style: { margin: '0' } }, params.row.calleeId), h('p', { style: { margin: '0' } }, '学生ID:' + params.row.uid)]);
        }
      }, {
        title: '备注',
        align: 'center',
        key: 'content'
      }, {
        title: '录音',
        align: 'center',
        key: 'recordUrl',
        render: function render(h, params) {
          var audioUrl = params.row.recordUrl;
          if (audioUrl) {
            if (audioUrl === '失败') {
              return h('span', '无录音');
            }
            return h('audio', {
              attrs: {
                src: audioUrl,
                controls: true },
              style: {
                width: '100%'
              }
            });
          } else {
            return h('span', '无录音');
          }
        }
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          var uid = params.row.uid;
          if (!uid) {
            return h('span', { style: { color: '#c5c8ce' } }, '无学生');
          }
          if (!_this.aiAllowed) {
            return h('span', '');
          }
          return h('a', { on: { click: function click() {
                return _this.openAiDrawer(uid);
              } } }, 'AI');
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools_aiAccess__["a" /* bindAiAllowed */])(this);
  },
  methods: {
    getYesterday: function getYesterday() {
      var today = new Date();
      var yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday.toISOString().split('T')[0];
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    time: function time(_time) {
      var sTime = _time;
      var mTime = 0;
      var hTime = 0;
      if (sTime > 60) {
        mTime = parseInt(sTime / 60);
        sTime = parseInt(sTime % 60);
        if (mTime > 60) {
          hTime = parseInt(mTime / 60);
          mTime = parseInt(mTime % 60);
        }
      }
      if (hTime === 0) {
        if (mTime === 0) {
          return sTime + '秒';
        }
        return mTime + '分' + sTime + '秒';
      }
      if (mTime === 0) {
        return sTime + '秒';
      }
      return hTime + '小时' + mTime + '分' + sTime + '秒';
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.beginTime = value[0];
      this.queryParam.endTime = value[1];
    },
    openAiDrawer: function openAiDrawer(uid) {
      this.aiUid = uid;
      this.aiVisible = true;
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
    },
    onAiExecuted: function onAiExecuted() {
      this.reload = new Date().getTime();
    },
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    syncSalesUser: function syncSalesUser() {
      var _this2 = this;

      this.$http.post('/moor/ec-transfer-user').then(function (response) {
        if (response.status === 'ok') {
          _this2.$Message.success('同步销售工号成功');
        } else {
          _this2.$Message.error(response.msg || '同步失败');
        }
      }).catch(function () {
        _this2.$Message.error('请求失败');
      });
    },
    SynchronousData: function SynchronousData() {
      var _this3 = this;

      this.$http.post('/call_record/initqimodata').then(function (response) {
        _this3.$Message.success('同步数据成功');
        _this3.search();
      });
    },
    exportData: function exportData() {
      var _this4 = this;

      this.exportLoading = true;
      this.$http.get('/call_record/exportPhone', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '销售通话记录.csv';
          link.click();
          _this4.exportLoading = false;
        } else {
          _this4.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this4.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecommendTeacherModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      visible: false,
      RecommendParam: {},
      ruleRecommend: {},
      loadingUpdate: false,
      endTimeDate: '',
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      reasonMap: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
      reset: false,
      formData: {
        selectList: []
      },
      teacherCategoryList: $constant.teacherCategory,
      queryParam: {
        name: '',
        sex: null,
        id: null,
        category: null,
        tchType: null,
        accent: null,
        useStartDate: '',
        useStartTime: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: ''
      },
      dataList: [],
      title: [{
        type: 'selection',
        align: 'center',
        width: 70
      }, {
        title: 'ID/姓名',
        width: 220,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '类型',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.teacherCategory, row.category);
          return h('span', cons && cons.text);
        }
      }, {
        title: '授课类型',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.tchType, row.tchType);
          return h('span', cons && cons.text);
        }
      }, {
        title: '性别',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.sex, row.sex);
          return h('span', cons && cons.text);
        }
      }, {
        title: '口音',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.accent, row.accent);
          return h('span', cons && cons.text);
        }
      }, {
        title: '年龄',
        key: 'age',
        width: 80
      }, {
        title: '推荐理由',
        key: '',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('Input', {
            domProps: {
              value: ''
            },
            on: {
              input: function input(event) {
                self.updateReson(row, event);
              }
            }
          });
        }
      }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeChange: function startTimeChange(val) {
      this.queryParam.startTime = val && parseInt(this.$dateUtil.getSecondByHm(val));
    },
    endTimeChange: function endTimeChange(val) {
      this.queryParam.endTime = val && parseInt(this.$dateUtil.getSecondByHm(val));
    },
    updateReson: function updateReson(row, event) {
      var map = this.reasonMap;
      map.set(row.tchId, event);
    },
    selectChange: function selectChange(val) {
      this.formData.selectList = val;
    },
    search: function search() {
      var self = this;
      self.reload = new Date().getTime();
    },
    searchTch: function searchTch() {
      if (this.visible === false) {
        return;
      }
      this.search();
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.useStartTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
    },
    addTch: function addTch() {
      var self = this;
      self.loadingUpdate = true;
      var list = this.formData.selectList;
      var map = this.reasonMap;
      if (!list || list.length <= 0) {
        this.$Message.warning('请选择要添加的老师!');
        self.loadingUpdate = false;
        return;
      }
      var tchIds = [];
      for (var i in list) {
        if (!map.get(list[i].tchId)) {
          this.$Message.warning('推荐理由不能为空!');
          self.loadingUpdate = false;
          return;
        }
        list[i].reason = map.get(list[i].tchId);
        tchIds.push(list[i].tchId);
        list[i].uid = this.uid;
      }

      var isPass = true;
      if (tchIds) {
        var searchParams = { uid: this.uid, tchIds: tchIds, status: 1, pageSize: 1000 };
        self.$http.get('/tchRecommend/list', { params: searchParams }).then(function (res) {
          if (res.data.data) {
            var tchList = res.data.data;
            if (tchList && tchList.length > 0) {
              isPass = false;
            }
            for (var _i in tchList) {
              self.$Message.warning('已经推荐' + tchList[_i].firstName + '-' + tchList[_i].lastName);
            }
            self.loadingUpdate = false;
          }
          if (isPass) {
            self.$http.post('/tchRecommend/insertRecommend', {}, {
              transformRequest: [function (data, headers) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData.selectList);
              }],
              headers: { 'Content-Type': 'application/json;charset=utf-8' }
            }).then(function (res) {
              if (res) {
                self.$Message.success('新增成功!');
                self.loadingUpdate = false;
                self.visible = false;
                return;
              }
            }).catch(function (e) {
              self.loadingUpdate = false;
            });
          }
        });
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.queryParam = {};
        this.reset = true;
        this.formData.selectList = [];
        this.reasonMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
        this.$emit('on-close', false);
      } else {
        this.reset = false;
      }
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      startDate: '',
      endDate: '',
      dateRange: [],
      department: '',
      list: [],
      totalAssignCount: 0,
      totalDealCount: 0,
      totalDealRate: null,
      columns: [{
        title: '课程顾问',
        key: 'adviserName'
      }, {
        title: '分配权重',
        key: 'assignWeight'
      }, {
        title: '部门',
        render: function render(h, params) {
          var group = _this.$constant.getEnum(_this.$constant.adviserGroup, params.row.department);
          return h('span', group && group.text);
        }
      }, {
        title: '分配数量',
        render: function render(h, params) {
          var count = params.row.assignCount == null ? 0 : params.row.assignCount;
          var href = _this.$router.resolve({
            path: '/crm/DistributionList',
            query: _this.assignQuery(params.row)
          }).href;
          return h('a', {
            attrs: { href: href },
            style: { color: '#2d8cf0' },
            on: {
              click: function click(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                  return;
                }
                e.preventDefault();
                _this.$router.push({
                  path: '/crm/DistributionList',
                  query: _this.assignQuery(params.row)
                });
              }
            }
          }, String(count));
        }
      }, {
        title: '成交数量',
        render: function render(h, params) {
          var count = params.row.dealCount == null ? 0 : params.row.dealCount;
          var href = _this.$router.resolve({
            path: '/order/performanceDetail',
            query: _this.dealQuery(params.row)
          }).href;
          return h('a', {
            attrs: { href: href },
            style: { color: '#2d8cf0' },
            on: {
              click: function click(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                  return;
                }
                e.preventDefault();
                _this.$router.push({
                  path: '/order/performanceDetail',
                  query: _this.dealQuery(params.row)
                });
              }
            }
          }, String(count));
        }
      }, {
        title: '成交率',
        render: function render(h, params) {
          return h('span', _this.formatRate(params.row.dealRate));
        }
      }]
    };
  },
  created: function created() {
    var startDate = this.$route.query.startDate;
    var endDate = this.$route.query.endDate;
    var weekStart = this.$route.query.weekStart;
    var weeks = this.$route.query.weeks;
    if (startDate && endDate) {
      this.setRange(startDate, endDate);
      this.search();
    } else if (weekStart && String(weeks) === '8') {
      var start = this.$moment(weekStart, 'YYYY-MM-DD').startOf('isoWeek');
      this.setRange(start.format('YYYY-MM-DD'), start.clone().add(55, 'days').format('YYYY-MM-DD'));
      this.search();
    } else if (weekStart) {
      var _start = this.$moment(weekStart, 'YYYY-MM-DD').startOf('isoWeek');
      this.setRange(_start.format('YYYY-MM-DD'), _start.clone().add(6, 'days').format('YYYY-MM-DD'));
      this.search();
    } else {
      this.applyRecentEightWeeks();
      this.search();
    }
  },

  methods: {
    setRange: function setRange(start, end) {
      this.startDate = start;
      this.endDate = end;
      this.dateRange = [start, end];
    },
    onRangeChange: function onRangeChange(value) {
      if (!value || !value[0] || !value[1]) {
        this.dateRange = [this.startDate, this.endDate];
        return;
      }
      this.setRange(value[0], value[1]);
    },
    applyRecentEightWeeks: function applyRecentEightWeeks() {
      var start = this.$moment().startOf('isoWeek').subtract(7, 'weeks');
      this.setRange(start.format('YYYY-MM-DD'), start.clone().add(55, 'days').format('YYYY-MM-DD'));
    },
    inclusiveDays: function inclusiveDays() {
      if (!this.startDate || !this.endDate) {
        return 0;
      }
      var start = this.$moment(this.startDate, 'YYYY-MM-DD');
      var end = this.$moment(this.endDate, 'YYYY-MM-DD');
      return end.diff(start, 'days') + 1;
    },
    assignQuery: function assignQuery(row) {
      return {
        salesDealRate: 1,
        weekStart: this.startDate,
        startDate: this.startDate,
        endDate: this.endDate,
        adviserId: row.adviserId,
        linkStartTimeDate: this.startDate,
        linkEndTimeDate: this.endDate
      };
    },
    dealQuery: function dealQuery(row) {
      return {
        salesDealRate: 1,
        weekStart: this.startDate,
        startDate: this.startDate,
        endDate: this.endDate,
        adviserId: row.adviserId
      };
    },
    formatRate: function formatRate(rate) {
      if (rate === null || rate === undefined || rate === '') {
        return '-';
      }
      return this.$numeral(Number(rate) * 100).format('0.00') + '%';
    },
    rowClassName: function rowClassName(row) {
      if (row.dealRate === null || row.dealRate === undefined || row.dealRate === '') {
        return '';
      }
      var limit = this.inclusiveDays() === 56 ? 0.1 : 0.07;
      return Number(row.dealRate) < limit ? 'low-deal-rate' : '';
    },
    search: function search() {
      var _this2 = this;

      this.searchLoading = true;
      var params = {
        startDate: this.startDate,
        endDate: this.endDate
      };
      if (this.department) {
        params.department = this.department;
      }
      this.$http.get('/userinfo/salesDealRate', {
        params: params
      }).then(function (res) {
        var data = res.data || {};
        _this2.list = data.list || [];
        _this2.totalAssignCount = data.totalAssignCount || 0;
        _this2.totalDealCount = data.totalDealCount || 0;
        _this2.totalDealRate = data.totalDealRate;
        _this2.searchLoading = false;
      }).catch(function () {
        _this2.searchLoading = false;
      });
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      reload: 0,
      uid: null,
      queryParam: {
        status: null,
        mobile: ''
      },
      title: [{
        title: '拼团ID',

        align: 'center',
        key: 'id'
      }, {
        title: '团长ID',

        align: 'center',
        key: 'uid'
      }, {
        title: '团长手机号',
        align: 'center',

        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '团长课程顾问',
        align: 'center',

        key: 'adviser'
      }, {
        title: '团员ID',
        align: 'center',

        key: 'memberIds'
      }, {
        title: '团员手机号',
        align: 'center',

        key: 'memberMobiles'
      }, {
        title: '团员课程顾问',
        align: 'center',

        key: 'memberAdviser'
      }, {
        title: '状态',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.groupStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookCourseChangeList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    exportData: function exportData(type) {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/bookCourseChange/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '补课时记录.csv';
        link.click();
        _this.exportLoading = false;
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SingleOnePicUpload_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SingleOnePicUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SingleOnePicUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FileUpload_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FileUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_FileUpload_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SingleOnePicUpload: __WEBPACK_IMPORTED_MODULE_0__common_SingleOnePicUpload_vue___default.a, FileUpload: __WEBPACK_IMPORTED_MODULE_1__common_FileUpload_vue___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      tchAll: [],
      studyAll: [],
      tutorAll: [],
      defaultAudioList: [],
      reportDocUrl: '',
      uploadText: '点击上传测评报告(PDF格式)',
      reportParam: {
        tchId: '',
        tutorId: '',
        studyAdviserId: '',
        lessonNum: '',
        reportDoc: '',
        uid: '',
        tchName: '',
        studyName: '',
        tutorName: ''
      },
      ruleUser: {
        lessonNum: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleReportDoc: function handleReportDoc(file) {
      var _this = this;

      file.forEach(function (f) {
        _this.reportParam.reportDoc = f.name;
        _this.reportDocUrl = f.url;
      });
    },
    insert: function insert() {
      var self = this;

      self.tchAll.forEach(function (element) {
        if (element.id === self.reportParam.tchId) {
          self.reportParam.tchName = element.tchName;
        }
      });

      self.studyAll.forEach(function (element) {
        if (element.id === self.reportParam.studyAdviserId) {
          self.reportParam.studyName = element.nickname;
        }
      });

      self.tutorAll.forEach(function (element) {
        if (element.id === self.reportParam.tutorId) {
          self.reportParam.tutorName = element.nickname;
        }
      });

      self.$refs.insertUserForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.reportParam.uid) {
          self.$http.post('/stageReport/insert', {
            uid: self.reportParam.uid,
            tchId: self.reportParam.tchId,
            tchName: self.reportParam.tchName,
            studyAdviserId: self.reportParam.studyAdviserId,
            studyName: self.reportParam.studyName,
            tutorId: self.reportParam.tutorId,
            tutorName: self.reportParam.tutorName,
            lessonNum: self.reportParam.lessonNum,
            reportDoc: self.reportParam.reportDoc
          }).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false;
              self.successCallback();
            }
          });
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        var self = this;
        self.reportParam.lessonNum = '';
        self.reportParam.reportDoc = '';
        self.reportParam.studyAdviserId = '';
        self.reportParam.tutorId = '';
        self.reportParam.tchId = '';
        self.reportParam.tchName = '';
        self.reportParam.studyName = '';
        self.reportParam.tutorName = '';
        self.defaultAudioList = [];
        if (self.reportParam.uid) {
          self.$http.get('/tchList/selectAllId?id=' + self.reportParam.uid).then(function (res) {
            if (res && res.data) {
              if (res.data.tchId === 0) {
                self.reportParam.tchId = '';
              } else {
                self.reportParam.tchId = res.data.tchId;
              }
              self.reportParam.tutorId = res.data.tutorId;
              self.reportParam.studyAdviserId = res.data.studyAdviserId;
            } else {
              self.reportParam.tchId = '';
              self.reportParam.tutorId = '';
              self.reportParam.studyAdviserId = '';
            }
          });
        }
        var params = { status: 1, adminGroupId: 4 };
        var para = { status: 1, adminGroupId: 7 };
        self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
          if (res && res.data) {
            self.tutorAll = res.data;
          } else {
            self.tutorAll = [];
          }
        });
        self.$http.get('/adminUser/listByCondition', { params: para }).then(function (res) {
          if (res && res.data) {
            self.studyAll = res.data;
          } else {
            self.studyAll = [];
          }
        });
        self.$http.get('/tchList/selectAllTch').then(function (res) {
          if (res && res.data) {
            self.tchAll = res.data;
          } else {
            self.tchAll = [];
          }
        });
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.$emit('input', val);
    },
    uid: function uid(val) {
      var self = this;
      self.reportParam.uid = val;
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TodayPunchStatisticsModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      tableData: [],
      title: [{
        title: '课程顾问 ',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.adviserId + '-' + row.adviserName);
        }
      }, {
        title: '今日分配数 ',
        width: 150,
        align: 'center',
        key: 'countNum'
      }]
    };
  },

  mounted: function mounted() {},
  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    searchList: function searchList() {
      var self = this;
      this.$http.get('/adviser/getTodayPunchAssignCount').then(function (res) {
        self.tableData = res.data;
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.searchList();
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignAdviserTreModal_vue__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignAdviserTreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AssignAdviserTreModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__UserInfoModal_vue___default.a, AssignAdviserTreModal: __WEBPACK_IMPORTED_MODULE_1__AssignAdviserTreModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      exportLoading: false,
      showAssignAdviserModal: false,
      selectionUser: [],
      searchLoading: false,
      editUser: false,
      reload: 0,
      url: '/userinfo/treasuryResource',
      uid: null,
      queryParam: {
        resourceStatus: 2,
        intentLevel: '',
        stdStatus: '',
        adviserId: '',
        connectionStatus: '',
        regStartTimeDate: '',
        regEndTimeDate: '',
        linkStartTimeDate: '',
        startTime: '',
        lastLoginTimeStart: '',
        lastLoginTimeEnd: '',
        linkEndTimeDate: '',
        studentTag: null,
        bookTestId: '',
        searchKeyword: '',
        studyAdviserId: '',

        studentLessonState: ''
      },
      studyAdvisers: [],
      assignTitle: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '手机号',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '打电话',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('button', { attrs: { class: 'telephone2' }, on: { click: function click() {
                return _this.dialTel(row.id, row.mobile);
              } } })]);
        }
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regType'
      }, {
        title: '推荐人',
        align: 'center',
        width: 110,
        key: 'auName'
      }, {
        title: '最近登录',
        align: 'center',
        width: 100,
        key: 'lastLoginTime'
      }, {
        title: '注册时间',
        align: 'center',
        width: 170,
        key: 'gmtCreate'
      }, {
        title: '接通状态',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var status = params.row.connectionStatus;
          var typeEnum = $constant.getEnum($constant.connectionStatus, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '客户意向',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var status = params.row.intentLevel;
          var typeEnum = $constant.getEnum($constant.intentLevel, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '名单标签',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          var assignNum = params.row.assignNum;
          var assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum);
          return h('div', assignNumEnum && assignNumEnum.text);
        }
      }, {
        title: '试听课',
        align: 'center',
        key: 'openTime',
        width: 100
      }, {
        title: '最后联系时间',
        align: 'center',
        width: 150,
        key: 'lastPhoneTime'
      }, {
        title: '学员状态',
        align: 'center',
        width: 110,
        render: function render(h, params) {
          var status = params.row.stdStatus;
          var typeEnum = $constant.getEnum($constant.stdStatus, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: 'Follow Up',
        width: 250,
        align: 'center',
        key: 'followUpContent'
      }, {
        title: '操作',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onPass(params.row);
              }
            }
          }, '移至私库')]);
        }
      }]
    };
  },

  methods: {
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showAssignAdviserModal = true;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    onPass: function onPass(row) {
      var _this2 = this;

      if (this.$store.get('adviserInfo')) {
        this.adviserGroupSelectDisable = this.$store.get('adviserInfo').teamType !== 0;
        this.adviserId = this.$store.get('adviserInfo').adviserId;
      }
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移至</span>此资源?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/userList/crmTreasuryUpdate', { stuId: row.uid, thcId: _this2.adviserId }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    dial: function dial(mobile) {
      if (!mobile) {
        this.$Message.warning('无效手机号码');
        return;
      }
      this.$http.get('/moor/call?callno=' + mobile);
    },
    edit: function edit(uid) {
      this.uid = uid;
      this.editUser = true;
    },
    closeModal: function closeModal(val) {
      this.editUser = val;
      this.uid = null;
    },
    exportDaiyTransOut: function exportDaiyTransOut() {
      var _this3 = this;

      this.exportLoading = true;
      this.$http.get('/userinfo/exportUserInfo', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '公共资源名单.csv';
          link.click();
          _this3.exportLoading = false;
        } else {
          _this3.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this3.exportLoading = false;
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    regTimeStartChange: function regTimeStartChange(val) {
      this.queryParam.regStartTimeDate = val;
    },
    regTimeEndChange: function regTimeEndChange(val) {
      this.queryParam.regEndTimeDate = val;
    },
    lessonStartTimeChange: function lessonStartTimeChange(val) {
      this.queryParam.lessonStartTimeDate = val;
    },
    lessonEndTimeChange: function lessonEndTimeChange(val) {
      this.queryParam.lessonEndTimeDate = val;
    },
    linkTimeStartChange: function linkTimeStartChange(val) {
      this.queryParam.linkStartTimeDate = val;
    },
    linkTimeEndChange: function linkTimeEndChange(val) {
      this.queryParam.linkEndTimeDate = val;
    },
    loginTimeStartChange: function loginTimeStartChange(val) {
      this.queryParam.lastLoginTimeStart = val;
    },
    loginTimeEndChange: function loginTimeEndChange(val) {
      this.queryParam.lastLoginTimeEnd = val;
    }
  },
  created: function created() {
    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.regStartTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-24, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.regStartTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
      self.studyAdvisers = res.data;
    });
    this.cmd = 1;
    this.title = this.assignTitle;
    this.search();
  },
  dialTel: function dialTel(uid, mobile) {
    if (!uid) {
      this.$Message.warning('学生ID不能为空');
      return;
    }
    if (!mobile) {
      this.$Message.warning('无效手机号码');
      return;
    }
    this.dialLoading = true;
    var self = this;
    this.$http.get('/moor/call?callNo=' + mobile).then(function (res) {
      if (res.data > 0) {
        self.$Message.success('呼出成功!');
        self.dialLoading = false;
      }
    });
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecommendTeacherModal_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecommendTeacherModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RecommendTeacherModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_distpicker__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_distpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_distpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StageReportModal_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StageReportModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__StageReportModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EvaluationSheetModal_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EvaluationSheetModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EvaluationSheetModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_UserTrackContentModal_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_UserTrackContentModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__user_UserTrackContentModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_TrackContentPreview_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_TrackContentPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__user_TrackContentPreview_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TrackContentPreview: __WEBPACK_IMPORTED_MODULE_12__user_TrackContentPreview_vue___default.a,
    ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_10__order_ShowImageCarousel___default.a,
    SingleOnePicUpload: __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue___default.a,
    RecommendTeacher: __WEBPACK_IMPORTED_MODULE_4__RecommendTeacherModal_vue___default.a,
    RecommendList: __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue___default.a,
    VDistpicker: __WEBPACK_IMPORTED_MODULE_6_v_distpicker___default.a,
    StageReportModal: __WEBPACK_IMPORTED_MODULE_7__StageReportModal_vue___default.a,
    EvaluationSheetModal: __WEBPACK_IMPORTED_MODULE_8__EvaluationSheetModal_vue___default.a,
    UserTrackContentModal: __WEBPACK_IMPORTED_MODULE_11__user_UserTrackContentModal_vue___default.a
  },
  name: 'UserInfoModal',
  dialLoading: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    uid: {
      type: Number,
      default: null
    },
    tabValue: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      askForTch: false,
      nextDate: '',
      reprotId: null,
      cityInfo: '',
      insertLoading: false,
      showImgModal: false,
      StageReportModal: false,
      showEvaluationSheetModal: false,
      showImgList: [],
      defaultPicList: [],
      followList: [],
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      reload: 0,
      text: '编辑头像',
      totalImageUrl: '',
      recommendData: null,
      paramsErrors: [],
      recommendEdit: false,
      reset: false,
      tabName: 0,
      placeholders: {
        province: '------- 省 --------',
        city: '--- 市 ---',
        area: '--- 区 ---'
      },
      formData: {
        uid: null,
        reprotId: null,
        itemUrl: '',
        enName: '',
        cnName: '',
        canal: '',
        payCanal: '',
        mobile: '',
        phoneRole: '',
        weChat: '',
        infoRemark: '',
        address: '',
        learnEnglishTime: '',
        haveContactForeignTeacher: '',
        familyEconomicSituation: '',
        attentionEnglish: '',
        province: '',
        city: '',
        block: '',
        sex: '',
        password: '',
        imageUrl: '',
        intentLevel: '',
        age: '',
        connectionStatus: '',
        userContacts: [],
        grade: '',
        birthday: null
      },
      followFormData: {
        id: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        tchNames: [],
        traceStatus: '',
        traceItem: '',
        content: '',
        nextDate: '',
        files: '',
        stuDescCheckGroup: [],
        askForTchCheckGroup: []
      },
      nextHandler: [],
      uidReadonly: false,
      disable: false,
      aiLoading: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        contentRaw: '',
        nextHandlerId: null,
        status: '0',
        traceType: '',
        nextHandlerTime: '',
        nextTimeDate: '',
        files: ''
      },
      traceParam: {
        totalCount: 0,
        pageSize: 10,
        pageIndex: 1,
        uid: ''
      },
      tableData: [],
      ruleValidate: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur' }],
        traceType: [{ required: true, message: '属性不能为空', trigger: 'blur' }],
        nextHandlerId: [{ type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur' }]
      },
      telDetails: [],
      userModal: null,
      studentNature: [],
      studyExperience: [],
      hobby: [],
      englishLevel: [],
      tchRequirement: [],
      queryParam: {
        intentLevel: '',
        uid: ''
      },
      title: [{
        title: '拨打时间',
        render: function render(h, params) {
          var time = params.row.begin / 1000;
          return h('span', time && $moment(time, 'X').format('YYYY-MM-DD'));
        }
      }, {
        title: '通话类型',
        render: function render(h, params) {
          var status = params.row.callState;
          var typeEnum = $constant.getEnum($constant.telCallState, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '通话状态',
        render: function render(h, params) {
          var status = params.row.state;
          var typeEnum = $constant.getEnum($constant.telState, status);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '通话时长(秒)',
        render: function render(h, params) {
          var row = params.row;
          return h('span', (row.end - row.begin) / 1000);
        }
      }, {
        title: '通话人',
        key: 'agentName'
      }, {
        title: '通话录音',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.downLoadTel(row);
              } } }, '下载');
        }
      }, {
        title: '备注'
      }],
      visible: this.value,
      userRule: {
        mobile: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { pattern: $constant.mobileRule, message: '只能限数字或-,请输入正确的手机号码', trigger: 'blur' }],
        age: [{ pattern: /^[0-9]+$/, message: '只能输入数字', trigger: 'blur' }]
      },
      followRule: {
        traceStatus: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        traceItem: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      },
      followData: [],
      stageReportData: [],
      followtitle: [{
        title: '时间',
        width: 100,
        key: 'gmtCreate'
      }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          if (params.row.traceStatus == 100 || params.row.creatorName === '注册备注') return h('span', '注册备注');
          var traceStatus = params.row.traceStatus;
          var traceStatusEnum = $constant.getEnum($constant.traceStatus, traceStatus);
          return h('span', traceStatusEnum && traceStatusEnum.text);
        }
      }, {
        title: 'follow up选项',
        key: 'traceItem',
        width: 90,
        render: function render(h, params) {
          var traceItem = params.row.traceItem;
          var traceItemEnum = $constant.getEnum($constant.traceItem, traceItem);
          return h('span', traceItemEnum && traceItemEnum.text);
        }
      }, {
        title: '内容',
        key: 'content'
      }, {
        title: '下次联系时间',
        width: 100,
        key: 'nextContactTime'
      }, {
        title: '处理人',
        width: 100,
        key: 'creatorName'
      }],
      stageReportTitle: [{
        title: '老师ID/姓名',
        key: 'tchNameId',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchNameId,
            score: row.monthRankScore
          });
        }
      }, {
        title: '报告对应课节',
        key: 'lessonNum'
      }, {
        title: '外管',
        key: 'studyName'
      }, {
        title: '学导',
        key: 'tutorName'
      }, {
        title: '阶段测评报告',
        render: function render(h, params) {
          var row = params.row;
          if (row.reportDoc !== '') {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.lookRerot(row.id);
                } } }, '查看与编辑')]);
          }
        }
      }, {
        title: '添加时间',
        key: 'gmtCreate'
      }, {
        title: '添加人',
        key: 'creatorName'
      }, {
        title: '状态',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 1) {
            return h('span', '待审核');
          } else {
            return h('span', '已通过');
          }
        }
      }, {
        title: '操作',
        render: function render(h, params) {
          var row = params.row;
          console.log(row.status);
          if (row.status === 2) {
            return h('span', '');
          } else {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.editReport(row.id, 2);
                }
              }
            }, '通过')]);
          }
        }
      }],
      recommendTitle: [{
        title: '老师ID/姓名',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '类型',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.teacherCategory, row.category);
          return h('span', cons && cons.text);
        }
      }, {
        title: '授课类型',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.tchType, row.tchType);
          return h('span', cons && cons.text);
        }
      }, {
        title: '性别',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.sex, row.sex);
          return h('span', cons && cons.text);
        }
      }, {
        title: '口音',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.accent, row.accent);
          return h('span', cons && cons.text);
        }
      }, {
        title: '年龄',
        key: 'age'
      }, {
        title: '推荐理由',
        key: 'reason'
      }, {
        title: '推荐人',
        key: 'recommendName'
      }, {
        title: '取消人',
        key: 'cancelName'
      }, {
        title: '操作',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 1) {
            return h('a', { on: { click: function click() {
                  return _this.cancelRecommend(row.id);
                } } }, '取消推荐');
          } else {
            return h('span', '已取消');
          }
        }
      }]
    };
  },

  methods: {
    loadMonthRankScoresFor: function loadMonthRankScoresFor(rows, idKey) {
      idKey = idKey || 'tchId';
      if (!rows || !rows.length) {
        return;
      }
      var ids = [];
      rows.forEach(function (row) {
        var id = row[idKey];
        if ((id == null || id === '') && row.tchNameId) {
          var matched = String(row.tchNameId).match(/^(\d+)/);
          if (matched) {
            id = Number(matched[1]);
            row._scoreTchId = id;
          }
        }
        if (id != null && id !== '') {
          ids.push(id);
        }
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, idKey, 'monthRankScore', map);
        rows.forEach(function (row) {
          if (row.monthRankScore == null && row._scoreTchId != null) {
            var score = map[row._scoreTchId];
            if (score == null) {
              score = map[String(row._scoreTchId)];
            }
            if (score != null) {
              self.$set(row, 'monthRankScore', score);
            }
          }
        });
      });
    },
    formatNextHandlerTime: function formatNextHandlerTime(item) {
      var time = item && item.nextHandlerTime;
      if (!time || time === '0000-00-00 00:00:00') {
        return '0';
      }
      return time;
    },
    onEvaluationSheetModalClose: function onEvaluationSheetModalClose() {
      this.showEvaluationSheetModal = false;
      this.reprotId = null;
    },
    changeDate: function changeDate(value) {
      this.followFormData.nextDate = value;
    },
    onSelectedProvince: function onSelectedProvince(data) {
      if (data.value) {
        this.formData.province = data.value;
      }
    },
    onSelectedCity: function onSelectedCity(data) {
      if (data.value) {
        this.formData.city = data.value;
      }
    },
    onSelectedArea: function onSelectedArea(data) {
      if (data.value) {
        this.formData.block = data.value;
      }
    },
    cancelRecommend: function cancelRecommend(id) {
      var self = this;
      this.$http.post('/tchRecommend/cancelRecommend', { id: id }).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('取消成功!');
          self.searTchRecommend();
        }
      });
    },
    onTabClick: function onTabClick(name) {
      if (name === 2) {
        this.searTchRecommend();
      }
    },
    searTchRecommend: function searTchRecommend() {
      var self = this;
      this.$http.get('/tchRecommend/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.recommendData = res;
          self.loadMonthRankScoresFor(self.recommendData && self.recommendData.data ? self.recommendData.data : self.recommendData, 'tchId');
        }
      });
    },
    closeRecommendEdit: function closeRecommendEdit() {
      this.searTchRecommend();
      this.recommendEdit = false;
    },
    openRecommendEdit: function openRecommendEdit() {
      this.recommendEdit = true;
    },
    deleteContact: function deleteContact(val) {
      var contact = this.formData.userContacts;
      var newContact = [];
      for (var i in contact) {
        if (i !== val + '') {
          newContact.push(contact[i]);
        }
      }
      this.formData.userContacts = newContact;
    },
    addContact: function addContact() {
      if (this.formData.userContacts.length >= 3) {
        this.$Message.warning('已到添加号码上限!');
        return;
      }
      var contact = {};
      this.formData.userContacts.push(contact);
    },
    openStudentPage: function openStudentPage() {
      var self = this;
      this.$http.get('/adminUser/getAdminToken?type=student').then(function (res) {
        if (res.data) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/adminUserLogin?mobile=' + self.formData.mobile + '&token=' + res.data);
          } else {
            window.open('https://test-student.kouyujie.cn/adminUserLogin?mobile=' + self.formData.mobile + '&token=' + res.data);
          }
        }
      });
      return;
    },
    lookRerot: function lookRerot(id) {
      if (id) {
        this.reprotId = id;
        this.showEvaluationSheetModal = true;
      }
    },
    editReport: function editReport(id, status) {
      var self = this;
      if (id) {
        var path = '/stageReport/update?id=' + id + '&status=' + status;
        self.$http.post(path, this.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!');
            self.reportList();
          }
        });
      }
    },
    reportList: function reportList() {
      var self = this;
      self.$http.get('/stageReport/list?uid=' + self.followFormData.id).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data;
          self.loadMonthRankScoresFor(self.stageReportData, 'tchId');
        }
      });
    },
    insertReport: function insertReport() {
      this.StageReportModal = true;
    },
    downLoadTel: function downLoadTel(row) {},
    search: function search() {
      var self = this;
      self.$http.get('/tel/listPersonDetails', self.queryParam).then(function (res) {
        if (res.data.data) {
          self.telDetails = res.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.insertLoading = loading;
    },
    changeFollow: function changeFollow(val) {
      var self = this;
      if (!val) {
        return;
      }
      self.followFormData.traceItem = '';
      if (val === '100') {
        self.followList = [{ id: 100, text: '注册备注' }];
        self.followFormData.traceItem = 100;
      }
      if (val === '1') {
        self.followList = [{ id: 1, text: '课后-同意购买' }, { id: 2, text: '课后-付款成功，持续跟进' }];
      }
      if (val === '2') {
        self.followList = [{ id: 3, text: '课后-讲解产品，学习方案' }];
      }
      if (val === '3') {
        self.followList = [{ id: 4, text: '课后-开场' }, { id: 5, text: '课前跟进，确认出席' }, {
          id: 6,
          text: '课前跟进，改期'
        }, { id: 7, text: '课前约课' }];
      }
      if (val === '4') {
        self.followList = [{ id: 8, text: '价格问题' }, { id: 9, text: '行业对比' }, { id: 10, text: '不信任' }, {
          id: 11,
          text: '级别年龄不符'
        }];
      }
      if (val === '5') {
        self.followList = [{ id: 12, text: '无人接听' }, { id: 13, text: '挂断' }, { id: 14, text: '关机/停机' }, {
          id: 15,
          text: '空号'
        }];
      }
    },
    addFollow: function addFollow() {
      var self = this;
      self.$refs.followForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.followFormData.id) {
          if (self.followFormData.traceStatus == 100 || self.followFormData.traceStatus == '100') {
            self.$http.post('/userTrack/insert', {
              uid: self.followFormData.id,
              content: self.followFormData.content,
              files: self.followFormData.files || '',
              traceType: 100
            }).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('保存成功!');
                self.followFormData.traceStatus = '';
                self.followFormData.traceItem = '';
                self.followFormData.content = '';
                self.followFormData.nextDate = '';
                self.followFormData.files = '';
                self.nextDate = '';
                self.askForTch = false;
                self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                  if (res && res.data) {
                    self.followData = res.data.list;
                  }
                });
              }
            });
            return;
          }
          var requireNum = [];
          requireNum.push.apply(requireNum, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(self.followFormData.stuDescCheckGroup));
          requireNum.push.apply(requireNum, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(self.followFormData.askForTchCheckGroup));
          self.$http.post('/saleTrace/insert', {
            uid: self.followFormData.id,
            traceStatus: self.followFormData.traceStatus,
            traceItem: self.followFormData.traceItem,
            content: self.followFormData.content,
            nextDate: self.followFormData.nextDate,
            requireNum: requireNum.toString()
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('保存成功!');
              self.followFormData.traceStatus = '';
              self.followFormData.traceItem = '';
              self.followFormData.content = '';
              self.followFormData.nextDate = '';
              self.nextDate = '';
              self.askForTch = false;
              self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                if (res && res.data) {
                  self.followData = res.data.list;
                }
              });
            }
          });
        }
      });
    },
    resetRequireNum: function resetRequireNum() {
      this.nextDate = '';
      this.followFormData.askForTchCheckGroup = [];
      this.followFormData.stuDescCheckGroup = [];
      this.askForTch = false;
    },
    addStudent: function addStudent() {
      var self = this;
      self.insertLoading = true;
      var res = self.valiDateParam();
      if (!res) {
        this.$Message.warning('参数输入错误!');
        if (self.paramsErrors.length > 0) {
          for (var i in self.paramsErrors) {
            this.$Message.warning(self.paramsErrors[i]);
          }
          self.paramsErrors = [];
        }
        self.insertLoading = false;
        return;
      }
      if (self.formData.birthday) {
        self.formData.birthday = self.formData.birthday / 1000;
      }
      if (!self.formData.uid) {
        self.$http.get('/user/queryByMobile?mobile=' + self.formData.mobile).then(function (res) {
          if (res.data) {
            this.$Message.warning('学员手机号已经存在!');
          }
        });
        self.$http.post('/userinfo/insertUserInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData)).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('新增成功!');
            self.successCallback();
          }
          self.insertLoading = false;
        }).catch(function (e) {
          self.visible = false;
          self.insertLoading = false;
        });
      } else {
        self.$http.post('/userinfo/updateUserInfo', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          self.insertLoading = false;
          if (res) {
            self.$Message.success('修改成功!');
            self.visible = false;
            return;
          }
        }).catch(function (e) {
          self.insertLoading = false;
        });
      }
    },
    valiDateParam: function valiDateParam() {
      var self = this;
      var isPass = false;
      self.$refs.userInfoForm.validate(function (valid) {
        var res = self.valiDateMobile();
        if (valid && res) {
          isPass = true;
        }
      });
      return isPass;
    },
    valiDateMobile: function valiDateMobile() {
      var isPass = false;
      var self = this;
      var pattern = /^[0-9]+$/;
      if (self.formData.userContacts && self.formData.userContacts.length > 0) {
        for (var i in self.formData.userContacts) {
          var param = self.formData.userContacts[i];
          if (!param.name) {
            self.paramsErrors.push('联系人名字不能为空!');
          } else if (!param.mobile) {
            self.paramsErrors.push('联系人号码不能为空!');
          } else if (!pattern.test(param.mobile)) {
            self.paramsErrors.push('手机号只能输入数字!');
          } else {
            isPass = true;
          }
        }
      }
      if (self.paramsErrors && self.paramsErrors.length > 0) {
        isPass = false;
      } else {
        isPass = true;
      }
      return isPass;
    },
    dialTel: function dialTel() {
      if (!this.formData.mobile) {
        this.$Message.warning('无效手机号码');
        return;
      }
      this.dialLoading = true;
      var self = this;
      this.$http.get('/moor/call?callNo=' + this.formData.mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!');
          self.dialLoading = false;
        }
      });
    },
    handleResult: function handleResult(file) {
      this.formData.imageUrl = file.name;
      this.totalImageUrl = file.url;
    },
    openTrackContent: function openTrackContent(item) {
      this.$refs.trackContentModal && this.$refs.trackContentModal.open(item);
    },
    handleAiMarkdown: function handleAiMarkdown() {
      var self = this;
      var content = (self.formValidate.content || '').trim();
      if (!content) {
        self.$Message.warning('请先填写内容');
        return;
      }
      self.aiLoading = true;
      self.$http.post('/userTrack/aiMarkdown', { content: content }).then(function (res) {
        self.aiLoading = false;
        if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
          return;
        }
        var markdown = res.data.markdown;
        self.$Modal.confirm({
          title: '确认覆盖',
          content: '将用 AI 结果覆盖当前内容，是否继续？',
          onOk: function onOk() {
            if (!(self.formValidate.contentRaw || '').trim()) {
              self.formValidate.contentRaw = content;
            }
            self.formValidate.content = markdown;
            self.$Message.success('已用 AI 结果更新内容');
          }
        });
      }).catch(function () {
        self.aiLoading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
          if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
            self.$Message.warning('请填写下次联系人和下次联系日期!');
            return;
          }
        }
        self.$http.post('/userTrack/insert', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.formValidate.content = '';
            self.formValidate.contentRaw = '';
            self.formValidate.nextHandlerId = null;
            self.formValidate.nextHandlerTime = '';
            self.formValidate.traceType = '';
            self.formValidate.nextTimeDate = '';
            self.getPersonTrace(self.formValidate.uid);
          }
        });
      });
    },
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
    },
    getPersonTrace: function getPersonTrace(uid) {
      var self = this;
      var params = self.traceParam;
      if (uid) {
        self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize).then(function (res) {
          if (!res.data || !res.data.data) {
            self.traceParam.totalCount = 0;
            self.tableData = [];
            return;
          }
          self.traceParam.uid = res.data.data[0].uid;
          self.traceParam.nickName = res.data.data[0].nickname;
          self.traceParam.totalCount = res.data.totalCount;
          self.tableData = res.data.data;
        });
      }
    },
    changePageIndex: function changePageIndex(page) {
      this.traceParam.pageIndex = page;
      this.getPersonTrace(this.traceParam.uid);
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.nickname ? row.nickname.split(',').map(function (item) {
        if (!item.startsWith('http')) {
          return 'https://imgs.speakstreet.cn/' + item;
        }
        return item;
      }) : [];
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.tabName = 0;
      this.reset = true;
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(this.formData, 'userContacts', {});
      if (val === false) {
        this.followFormData.traceStatus = '';
        this.followFormData.traceItem = '';
        this.followFormData.content = '';
        this.followFormData.nextDate = '';
        this.followFormData.files = '';
        this.resetRequireNum();
        this.$emit('on-close', val);
      } else {
        this.reset = false;
      }
    },
    uid: function uid(val) {
      var self = this;
      if (val) {
        self.formData.uid = val;
        self.$http.get('/saleTrace/followUp?id=' + val).then(function (res) {
          if (res.data) {
            self.followFormData.id = res.data.id;
            self.followFormData.adviserName = res.data.adviserName;
            self.followFormData.nickname = res.data.nickname;
            self.followFormData.studyAdviserName = res.data.studyAdviserName;
            var requireNum = res.data.requireNum;
            if (requireNum) {
              var require = requireNum.split(',');
              for (var i in require) {
                var j = parseInt(require[i]);
                var len = self.$constant.stuDesc.length + 1;
                if (j < len) {
                  self.followFormData.stuDescCheckGroup.push(j);
                } else {
                  self.followFormData.askForTchCheckGroup.push(j);
                }
              }
            }
            self.formValidate.uid = val;
            self.formValidate.nickname = res.data.nickname;
            self.formValidate.adviserName = res.data.adviserName;
            self.formValidate.studyAdviserName = res.data.studyAdviserName;
            self.followFormData.tchNames = res.data.tchNames;
            self.followData = res.data.list;
          }
        });
        this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
          self.nextHandler = res.data;
        });
        self.getPersonTrace(val);
        self.$http.get('/stageReport/list?uid=' + val).then(function (res) {
          if (res.data) {
            self.stageReportData = res.data;
          }
        });
        self.$http.get('/userinfo/getUserInfo?uid=' + val).then(function (res) {
          if (res.data) {
            var data = res.data;
            self.formData.enName = data.enName;
            self.formData.cnName = data.cnName;
            self.formData.sex = data.sex;
            self.formData.regType = data.regType;
            self.formData.payCanal = data.payCanal;
            self.formData.mobile = data.mobile;
            self.formData.phoneName = data.phoneName;
            self.formData.weChat = data.weChat;
            self.formData.phoneRole = data.phoneRole;
            self.formData.infoRemark = data.infoRemark;
            self.formData.address = data.address;
            self.formData.learnEnglishTime = data.learnEnglishTime + '';
            self.formData.haveContactForeignTeacher = data.haveContactForeignTeacher;
            self.formData.familyEconomicSituation = data.familyEconomicSituation;
            self.formData.attentionEnglish = data.attentionEnglish;
            self.formData.province = data.province;
            self.formData.city = data.city;
            self.formData.block = data.block;
            self.formData.imageUrl = data.imageUrl;
            self.formData.age = data.age;
            self.formData.intentLevel = data.intentLevel;
            self.formData.connectionStatus = data.connectionStatus;
            self.formData.userContacts = data.userContacts;
            self.formData.grade = data.grade;
            self.formData.birthday = data.birthday * 1000;
            if (data.imageUrl) {
              if (data.imageUrl.indexOf('http://') !== -1) {
                self.totalImageUrl = data.imageUrl;
              } else {
                if (data.imageUrl.substr(0, 1) === '/') {
                  self.totalImageUrl = 'http://medias.kouyujie.cn' + data.imageUrl;
                } else {
                  self.totalImageUrl = 'http://medias.kouyujie.cn/' + data.imageUrl;
                }
              }
              self.text = '编辑头像';
            } else {
              self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
              self.text = '上传头像';
            }

            self.userModal = data.userModal;
          }
        });
        self.queryParam.uid = val;
        self.search();
      } else {
        self.formData.password = '';
      }
    },
    tabValue: function tabValue(val) {
      if (val) {
        this.tabName = val;
      } else {
        this.tabName = 0;
      }
    },
    cityInfo: function cityInfo(val) {
      if (val) {
        this.formData.province = val.province.name;
        this.formData.city = val.city.name;
        this.formData.block = val.block.name;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_format_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_format_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dateRange: [],
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParams: {
        studyAdviserId: null
      },
      queryParam: {
        startTime: '',
        endTime: '',
        pageSize: 100
      },
      formData: {
        totalNum: 0,
        remainder: 0,
        teamType: 0,
        adviserGroupList: this.$constant.adviserGroup,
        adviserList: []
      },
      formRule: {},
      details: '',
      title: [{
        title: '课顾',
        width: 150,
        align: 'center',
        key: 'adviserName',
        render: function render(h, params) {
          var row = params.row;
          if (row.state === 1) {
            return h('span', [h('span', row.adviserName)]);
          } else {
            return h('span', [h('span', row.adviserName), h('span', { style: { color: 'red' } }, '(离职)')]);
          }
        }
      }, {
        title: '外呼次数',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.outerCallNum);
        }
      }, {
        title: '接听量',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.answerTime.toFixed(2));
        }
      }, {
        title: '通时',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.callTime.toFixed(2));
        }
      }, {
        title: '名单数',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.totalListNum);
        }
      }, {
        title: '邀约数',
        width: 100,
        align: 'center',
        key: 'inviteListNum',
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.inviteListNum);
        }
      }, {
        title: '邀约率',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.inviteRate.toFixed(2) + '%');
        }
      }, {
        title: '出席数',
        key: 'attendNum',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.attendNum);
        }
      }, {
        title: '出席率',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.attendRate.toFixed(2) + '%');
        }
      }, {
        title: '成交数',
        key: 'dealNum',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;

          return h('span', row.dealNum);
        }
      }, {
        title: '注册成交率',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.payUserRate.toFixed(2) + '%');
        }
      }, {
        title: '出席成交率',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.attendDealRate.toFixed(2) + '%');
        }
      }, {
        title: '目标(单)',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.orderQuantity);
        }
      }, {
        title: '完成量(单)',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishOrderQuantity);
        }
      }, {
        title: '成交金额',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.dealMoney);
        }
      }, {
        title: '完成率',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.finishRate.toFixed(2) + '%');
        }
      }]
    };
  },

  methods: {
    getAdviserList: function getAdviserList(teamType) {
      var self = this;
      self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
        if (res && res.data) {
          self.formData.adviserList = res.data;
        }
      });
    },
    onTeamTypeChange: function onTeamTypeChange(value) {
      this.getAdviserList(value);
    },
    onDateChange: function onDateChange(dateRange) {},
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = Date.parse(new Date(value)) / 1000;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = Date.parse(new Date(value)) / 1000;
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      var self = this;
      var startTimeDate = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.format(this.dateRange[0]);
      var endTimeDate = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.format(this.dateRange[1]);
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000;
      this.$http.post('/adminUser/getTotalAdviserData', self.queryParam).then(function (res) {
        self.details = res.data;
      });
      self.reload = new Date().getMilliseconds();
    },
    showAssignDetail: function showAssignDetail(id) {
      localStorage.setItem('adviserId', id);
      localStorage.setItem('startTime', this.queryParam.startTime);
      localStorage.setItem('endTime', this.queryParam.endTime);
      this.$router.push({ path: '/data/showAssignDetail' });
    },
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/adminUser/exportAdviserData', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '课程顾问汇总数据.csv';
        link.click();
        _this.exportLoading = false;
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    showDetails: function showDetails(id, cmd) {
      localStorage.setItem('adviserId', id);
      localStorage.setItem('startTime', this.queryParam.startTime);
      localStorage.setItem('endTime', this.queryParam.endTime);
      localStorage.setItem('cmd', cmd);
      this.$router.push({ path: '/data/showAdviserDataDetail' });
    }
  },
  mounted: function mounted() {
    var self = this;
    this.$http.post('/adminUser/getTotalAdviserData', self.queryParam).then(function (res) {
      self.details = res.data;
    });
  },
  created: function created() {
    var week = new Date().getDay();
    var left = week;
    if (week === 0) {
      left = 7;
    }

    var self = this;
    var now = Date.now();
    this.dateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_format_js___default()(new Date(now - (left + 6) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD');
    this.dateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_format_js___default()(new Date(now - left * 24 * 60 * 60 * 1000), 'YYYY-MM-DD');
    var startTimeDate = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.format(this.dateRange[0]);
    var endTimeDate = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.format(this.dateRange[1]);
    self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
    self.queryParam.endTime = Date.parse(endTimeDate) / 1000;
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);





var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_0_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_0_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  name: 'ContractVersion',
  data: function data() {
    return {
      loadingInsert: false,
      reload: 0,
      editModal: false,
      loadingEdit: false,
      versionList: [],
      formData: {
        id: '',
        title: '',
        contract: '',
        status: 1
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  mounted: function mounted() {
    this.queryContract();
  },
  created: function created() {},
  methods: {
    queryContract: function queryContract() {
      var self = this;
      self.$http.post('/common/contractSelect', {
        pageSize: 1000,
        pageIndex: 1
      }).then(function (res) {
        if (res && res.data) {
          self.versionList = res.data.data;
        }
      });
    },
    onChange: function onChange(val) {
      var _this = this;

      this.versionList.forEach(function (v) {
        if (v.id === val) {
          _this.formData.contract = v.contract;
          _this.formData.title = v.title;
        }
      });
    },
    openPreview: function openPreview() {
      var contract = this.$refs.myQuillEditor.quill.root.innerHTML;
      var url = 'https://test-h5.kouyujie.cn/contract/contract.html';
      if (this.$appConfig.active === 'prod') {
        url = 'https://h5.speakstreet.cn/contract/contract.html';
      }
      var newWindow = window.open(url, '_blank');
      setTimeout(function () {
        newWindow.postMessage({ type: 'SET_CONTENT', contract: contract }, '*');
      }, 1000);
    },
    textChange: function textChange(val) {
      this.formData.contract = val.html;
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$http.post('/common/editContract', self.formData).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('保存成功!');
        }
        self.loadingInsert = false;
        self.editModal = false;
        self.queryContract();
      }).catch(function (e) {
        console.log(e);
        self.loadingInsert = false;
      });
    },
    onAdd: function onAdd(row, isAdd) {
      if (isAdd) {
        this.formData = {
          id: '',
          title: '',
          status: ''
        };
        this.editModal = true;
        return;
      }
      if (row.id === '') {
        this.$Message.warning('请选择合同模版!');
        return;
      }
      this.formData.id = row.id;
      this.formData.title = row.title;
      this.formData.status = row.status;
      this.editModal = true;
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'financeDailyList',
  data: function data() {
    var _this = this;

    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        date: null,
        studyConsultantId: null
      },
      title: [{
        title: '统计日期',

        align: 'center',
        key: 'date'
      }, {
        title: '数据类型',

        align: 'center',
        key: 'dataType'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.url !== '') {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.download(row.date, row.url);
                } } }, '下载')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {},
    dateChange: function dateChange(val) {
      this.queryParam.date = val;
    },
    download: function download(time, url) {
      this.exportLoading = true;
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', time + '付费学生剩余课时数据.xls');
      link.click();
      link.remove();
      this.exportLoading = false;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_UnBinStudyModal_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_UnBinStudyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__user_UnBinStudyModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UnBinStudyModal: __WEBPACK_IMPORTED_MODULE_0__user_UnBinStudyModal_vue___default.a
  },
  name: 'finishRenewalRateList',
  data: function data() {
    var $constant = this.$constant;
    return {
      exportLoading: false,
      cancelLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        studyConsultantId: null,
        estimateEndYearMonth: null
      },
      title: [{
        title: '预计结课月',
        width: 110,
        align: 'center',
        key: 'estimateEndYearMonth'
      }, {
        title: '实际结课时间',
        width: 125,
        align: 'center',
        key: 'actualEndYearMonth'
      }, {
        title: '学生ID',
        width: 100,
        align: 'center',
        key: 'studentId'
      }, {
        title: '学生姓名',
        align: 'center',
        width: 150,
        key: 'studentName'
      }, {
        title: '等级',
        width: 150,
        align: 'center',
        key: 'levelName'
      }, {
        title: '课程类型',
        width: 150,
        align: 'center',
        key: 'courseType',
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var courseTypeEnum = $constant.getEnum($constant.courseTypeEnum, courseType);
          return h('span', courseTypeEnum && courseTypeEnum.text);
        }
      }, {
        title: '常规课总课时',
        width: 125,
        align: 'center',
        key: 'studentRoutineNum'
      }, {
        title: '常规课剩余课时',
        width: 135,
        align: 'center',
        key: 'studentRoutineEndNum',
        render: function render(h, params) {
          var studentRoutineNum = params.row.studentRoutineNum;
          var studentRoutineEndNum = params.row.studentRoutineEndNum;
          return h('span', studentRoutineNum - studentRoutineEndNum);
        }
      }, {
        title: '常规课课耗',
        width: 110,
        align: 'center',
        key: 'studentRoutineEndNum'
      }, {
        title: '续费状态',
        width: 100,
        align: 'center',
        key: 'renewalType',
        render: function render(h, params) {
          var renewalType = params.row.renewalType;
          var renewalTypeEnum = $constant.getEnum($constant.renewalType, renewalType);
          return h('span', renewalTypeEnum && renewalTypeEnum.text);
        }
      }, {
        title: '续费订单数量',
        width: 125,
        align: 'center',
        key: 'fundCount'
      }, {
        title: '学导姓名',
        width: 150,
        align: 'center',
        key: 'studyConsultantName'
      }, {
        title: '课程顾问',
        width: 150,
        align: 'center',
        key: 'adviserName'
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {},
    exportData: function exportData(type) {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/dataCenter/finishRenewalRate/exportExcel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '结课续费率统计.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'lessonExpendDailyList',
  data: function data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        startDate: null,
        endDate: null,
        studyConsultantId: null
      },
      title: [{
        title: '日期',

        align: 'center',
        key: 'statisticalDate'
      }, {
        title: '一对一外教课时',
        align: 'center',

        key: 'enCountSum'
      }, {
        title: '中教',

        align: 'center',
        key: 'cnCountSum'
      }, {
        title: '陪练',

        align: 'center',
        key: 'partnerSum'
      }, {
        title: '学生提前请假',

        align: 'center',
        key: 'studentAskLeaveCountSum'
      }, {
        title: '学生临时请假',

        align: 'center',
        key: 'studentOnLeaveCountSum'
      }, {
        title: '补课',

        align: 'center',
        key: 'makeUpCountSum'
      }, {
        title: '学生缺席',

        align: 'center',
        key: 'studentAbsentCountSum'
      }, {
        title: '老师缺席',

        align: 'center',
        key: 'teacherAbsentCountSum'
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {},
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/dataCenter/lessonDaily/exportExcel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '课耗统计.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RenewDataList',
  data: function data() {
    return {
      searchLoading: false,
      queryParam: {
        startTime: '',
        endTime: '',
        status: 1
      },
      startTimeStr: '',
      endTimeStr: '',
      title: [{
        title: '学导ID/姓名',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserId + '-' + row.nickname);
        }
      }, {
        title: '结课学生数',
        align: 'center',
        key: 'overClassUserNum'
      }, {
        title: '结课续费学生数',
        align: 'center',
        key: 'overRenewUserNum'
      }, {
        title: '续费数',
        align: 'center',
        key: 'renewUserNum'
      }]
    };
  },

  created: function created() {
    this.startTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '1';
    this.endTimeStr = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(Date.now(), 'YYYY-MM-DD');
    this.queryParam.startTime = Date.parse(this.startTimeStr) / 1000;
    this.queryParam.endTime = Date.parse(this.endTimeStr) / 1000;
  },
  methods: {
    startTimeDateChange: function startTimeDateChange(value) {
      if (value) {
        this.queryParam.startTime = Date.parse(new Date(value)) / 1000 - 28800;
      } else {
        this.queryParam.startTime = null;
      }
    },
    endTimeDateChange: function endTimeDateChange(value) {
      if (value) {
        this.queryParam.endTime = Date.parse(new Date(value)) / 1000 + 57599;
      } else {
        this.queryParam.endTime = null;
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      this.$refs.dataList.search();
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var $constant = this.$constant;
        var $moment = this.$moment;
        return {
            reload: 0,
            searchLoading: false,
            start: {
                disabledDate: function disabledDate(date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') <= $moment($moment().year($moment().year() - 1).startOf('day'), 'YYYY-MM-DD').format('X');
                }
            },
            end: {
                disabledDate: function disabledDate(date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') >= $moment($moment().year($moment().year()).startOf('day'), 'YYYY-MM-DD').format('X');
                }
            },
            option: {
                disabledDate: function disabledDate(date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') >= $moment($moment().year($moment().year()).startOf('day'), 'YYYY-MM-DD').format('X');
                }
            },
            onLoading: false,
            tableRulePrompt: false,
            showSummaryDataModal: false,
            summaryData: {},
            defaultData: [],
            expiration: '',
            tableRulePromptContent: '',
            queryParam: {
                createStartTime: '',
                createEndTime: '',
                startTime: '',
                endTime: '',
                personage: '0',
                adviserId: '',
                expirationDate: ''
            },
            table: [{
                title: '销售姓名',
                align: 'center',
                key: 'nickName',
                fixed: 'left',
                width: 100
            }, {
                title: '销售分组',
                align: 'center',
                key: 'groupName',
                fixed: 'left',
                width: 100,
                render: function render(h, params) {
                    var row = params.row;
                    var group = row.groupName ? $constant.getEnum($constant.adviserGroup, Number(row.groupName)).text : '未分组';
                    return h('div', group);
                }
            }, {
                title: '市场名单量',
                align: 'center',
                key: 'bazaarNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：学员首次分配时间在筛选时间内【渠道条件】：非二维码推荐【归属条件】：首次分配课程顾问为对应销售';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单量');
                }
            }, {
                title: '市场名单外呼量',
                align: 'center',
                key: 'bazaarCallNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【拨号条件】：被叫号码为市场名单量中学员的手机号且接通的量【名单流转条件】：呼叫时间在该名单二次分配/流入公库时间之前【归属条件】：呼叫人工号 = 首次分配课程顾问工号 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单外呼量');
                }
            }, {
                title: '市场名单邀约数',
                align: 'center',
                key: 'bazaarInviteNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】：至少有一节试听课且为外教课状态为：非管理员取消【学生条件】：市场名单内的学生【归属条件】：约课人ID=首次分配课程顾问ID ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单邀约数');
                }
            }, {
                title: '市场名单邀约率',
                align: 'center',
                key: 'bazaarInviteRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '市场名单邀约数/市场名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单邀约率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.bazaarInviteRatio + '%');
                }
            }, {
                title: '市场名单出席数',
                align: 'center',
                key: 'bazaarAttendNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】：为市场名单至少有一节课程                 状态为：已上课  的课程数 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单出席数');
                }
            }, {
                title: '市场名单出席率',
                align: 'center',
                key: 'bazaarAttendRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '市场名单出席数/市场名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单出席率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.bazaarAttendRatio + '%');
                }
            }, {
                title: '市场名单成交数',
                align: 'center',
                key: 'bazaarTransactionsNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功【签单人条件】：签单人ID = 首次分配课程顾问为对应销售 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单成交数');
                }
            }, {
                title: '市场名单成交率',
                align: 'center',
                key: 'bazaarTransactionsRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '市场名单成交数/市场名单数';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场名单成交率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.bazaarTransactionsRatio + '%');
                }
            }, {
                title: '平均成交周期',
                align: 'center',
                key: 'bazaarAverageTransactionsTime',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功 【计算公式】：∑((学生1付款时间 - 学生1首次分配时间)+…+(学生n付款时间-学生n首次分配时间))/(市场名单成交数)   （每个市场名单成交的学生的（付款时间-首次分配时间）的和的平均数）';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '平均成交周期');
                }
            }, {
                title: '转介绍名单量',
                align: 'center',
                key: 'introductionNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：学员首次分配时间在筛选时间内【渠道条件】：二维码推荐【归属条件】：首次分配课程顾问为对应销售';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单量');
                }
            }, {
                title: '转介绍名单外呼量',
                align: 'center',
                key: 'introductionCallNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【被叫号码条件】：被叫号码为市场名单量中学员的手机号且接通的量 【归属条件】：  呼叫人工号 = 首次分配课程顾问工号 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单外呼量');
                }
            }, {
                title: '转介绍名单邀约数',
                align: 'center',
                key: 'introductionInviteNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】：至少有一节试听课且为外教课                  状态为：非管理员取消             【学生条件】：转介绍名单量内的学生【归属条件】：约课人ID=首次分配课程顾问ID';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单邀约数');
                }
            }, {
                title: '转介绍名单邀约率',
                align: 'center',
                key: 'introductionInviteRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '转介绍名单要约束/转介绍名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单邀约率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.introductionInviteRatio + '%');
                }
            }, {
                title: '转介绍名单出席数',
                align: 'center',
                key: 'introductionAttendNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】：为转介绍名单至少有一节课程                 状态为：已上课  的课程数 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单出席数');
                }
            }, {
                title: '转介绍名单出席率',
                align: 'center',
                key: 'introductionAttendRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '转介绍名单出席数/转介绍名单数 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单出席率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.introductionAttendRatio + '%');
                }
            }, {
                title: '转介绍名单成交数',
                align: 'center',
                key: 'introductionTransactionsNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生条件】：转介绍名单内的学生【订单条件】：全额付清 or 支付成功【签单人条件】：签单人ID = 首次分配课程顾问为对应销售';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单成交数');
                }
            }, {
                title: '转介绍名单成交率',
                align: 'center',
                key: 'introductionTransactionsRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '市场名单成交数/市场名单数';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍名单成交率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.introductionTransactionsRatio + '%');
                }
            }, {
                title: '平均成交周期',
                align: 'center',
                key: 'introductionAverageTransactionsTime',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功【计算公式】：     ∑((学生1付款时间 - 学生1首次分配时间)+…+(学生n付款时间-学生n首次分配时间))/(市场名单成交数)   （每个转介绍名单的学生的（付款时间-首次分配时间）的和的平均数）';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '平均成交周期');
                }
            }, {
                title: '老旧名单量',
                align: 'center',
                key: 'oldNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：二次分配时间 or 公库捞回的时间在时间筛选的范围内【渠道条件】：任意渠道【归属条件】：对应销售至少获得过名单一次即算一个名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单量');
                }
            }, {
                title: '老旧名单外呼量',
                align: 'center',
                key: 'oldCallNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【拨号条件】：被叫号码为老旧名单量中学员的手机号且接通的量【渠道条件】：任意渠道名单';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单外呼量');
                }
            }, {
                title: '老旧名单邀约量',
                align: 'center',
                key: 'oldInviteNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】：至少有一节试听课且为外教课 状态为：非管理员取消【学生条件】：老旧名单量中的学生【归属条件】：约课人ID为对应的销售';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单邀约量');
                }
            }, {
                title: '老旧名单邀约率',
                align: 'center',
                key: 'oldInviteRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '老旧名单邀约量/老旧名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单邀约率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.oldInviteRatio + '%');
                }
            }, {
                title: '老旧名单出席量',
                align: 'center',
                key: 'oldAttendNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课程条件】： 为老旧名单邀约量对应的课程 状态为：已上课【渠道条件】：任意渠道【归属条件】：对应销售至少获得过名单一次即算一个名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单出席量');
                }
            }, {
                title: '老旧名单出席率',
                align: 'center',
                key: 'oldAttendRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '老旧名单出席量/老旧名单量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单出席率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.oldAttendRatio + '%');
                }
            }, {
                title: '老旧名单成交量',
                align: 'center',
                key: 'oldTransactionsNum',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生条件】：老旧名单内的学生【渠道条件】：任意渠道【订单条件】：全额付清 或 支付成功';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单成交量');
                }
            }, {
                title: '老旧名单成交率',
                align: 'center',
                key: 'oldTransactionsRatio',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '老旧名单成交量/老旧名单量 ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧名单成交率');
                },
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.oldTransactionsRatio + '%');
                }
            }, {
                title: '市场业绩',
                align: 'center',
                key: 'marketPerformance',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 市场名单成交数的学生 【学生条件】：';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '市场业绩');
                }
            }, {
                title: '转介绍业绩',
                align: 'center',
                key: 'introductionPerformance',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 转介绍名单成交数的学生 【学生条件】：';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '转介绍业绩');
                }
            }, {
                title: '老旧资源业绩',
                align: 'center',
                key: 'oldPerformance',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '              【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 老旧资源名单成交数的学生 【学生条件】：';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '老旧资源业绩');
                }
            }, {
                title: '总业绩',
                align: 'center',
                key: 'totalPerformance',
                width: 120,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '市场业绩+转介绍业绩+老旧资源业绩';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '总业绩');
                }
            }]
        };
    },

    mounted: function mounted() {},
    created: function created() {
        var day = this.$moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
        this.defaultData = [day, day];
        this.expiration = day;
        this.queryParam.createStartTime = day;
        this.queryParam.createEndTime = day;
        this.queryParam.expirationDate = day;
    },

    methods: {
        search: function search() {
            this.reload = new Date().getTime();
        },
        onLoading: function onLoading(loading) {
            this.searchLoading = loading;
        },
        showPrompt: function showPrompt(value) {
            var self = this;
            self.tableRulePrompt = true;
            self.tableRulePromptContent = value;
        },
        cancel: function cancel() {
            var self = this;
            self.tableRulePrompt = false;
            self.showSummaryDataModal = false;
        },
        getTimeDateChange: function getTimeDateChange(val) {
            var self = this;
            console.log('val', val);
            self.queryParam.createStartTime = val[0];
            self.queryParam.createEndTime = val[1];
        },
        startMonth: function startMonth(val) {
            console.log('val', val);
            this.queryParam.createStartTime = val;
        },
        endMonth: function endMonth(val) {
            console.log('val', val);
            this.queryParam.createEndTime = val;
        },
        stopTimeDateChange: function stopTimeDateChange(val) {
            var self = this;
            self.queryParam.expirationDate = val;
        },
        showSummaryData: function showSummaryData() {
            var self = this;
            self.$http.post('/data/report/queryadviserdatatotalresult', self.queryParam).then(function (res) {
                if (res.data) {
                    self.summaryData = res.data;
                    self.showSummaryDataModal = true;
                }
            });
        },
        copy: function copy() {
            var self = this;
            var clipboard = new Clipboard('.copyBtn');
            console.log('clipboard', clipboard);
            clipboard.on('success', function (e) {
                self.$message.success('复制成功');
                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                clipboard.destroy();
            });
        },
        exportData: function exportData() {
            var _this2 = this;

            this.exportLoading = true;
            this.$http.get('/data/report/exportadviserdata', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
                if (response.data) {
                    var blob = new Blob([response.data], { type: 'text/csv' });
                    var link = document.createElement('a');
                    link.target = '_blank';
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '销售名单利用数据统计.csv';
                    link.click();
                    _this2.exportLoading = false;
                } else {
                    _this2.$Message.error(response.msg);
                }
            }).catch(function (e) {
                _this2.exportLoading = false;
            });
        }
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        studyAdviserId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        startTimeSec: '',
        endTimeSec: ''
      },
      title: [{
        title: '学生姓名',
        render: function render(h, params) {
          var row = params.row;
          return h(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default.a, {
            props: {
              name: '' + (row.userNickname || ''),
              uid: row.uid
            }
          });
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 85,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '加课时数量',
        align: 'right',
        key: 'num'
      }, {
        title: '申请人',
        key: 'adminNickname'
      }, {
        title: '申请时间',
        align: 'center',
        width: 135,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '备注',

        key: 'reason'
      }, {
        title: '状态',
        width: 72,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核人',
        key: 'checkAdmin'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.studyAdviserId = localStorage.studyAdviserId;
    this.queryParam.startTimeSec = localStorage.startTime;
    this.queryParam.endTimeSec = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        studyAdviserId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        startTimeSec: '',
        endTimeSec: ''
      },
      title: [{
        title: '学生姓名',
        render: function render(h, params) {
          var row = params.row;
          return h(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default.a, {
            props: {
              name: '' + (row.userNickname || ''),
              uid: row.uid
            }
          });
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 85,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '加请假数量',
        align: 'right',
        width: 85,
        render: function render(h, params) {
          var type = params.row.type;
          var num = 0;
          if (type === 3 || type === 4) {
            num = type === 4 ? -params.row.num : params.row.num;
          }
          return h('span', num);
        }
      }, {
        title: '申请人',
        key: 'adminNickname'
      }, {
        title: '申请时间',
        align: 'center',
        width: 135,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '备注',

        key: 'reason'
      }, {
        title: '状态',
        width: 72,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核人',
        key: 'checkAdmin'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.studyAdviserId = localStorage.studyAdviserId;
    this.queryParam.startTimeSec = localStorage.startTime;
    this.queryParam.endTimeSec = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        adviserId: '',
        uid: '',
        nickName: '',
        startTime: '',
        endTime: '',
        cmd: '',
        regType: ''
      },
      assignNum: '',
      title: [{
        title: '学生ID',
        key: 'uid'
      }, {
        title: '学生名字',
        key: 'nickName'
      }, {
        title: '手机号',
        key: 'phoneNumber'
      }, {
        title: '渠道',
        key: 'regType'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.adviserId = localStorage.adviserId;
    this.queryParam.startTime = localStorage.startTime;
    this.queryParam.endTime = localStorage.endTime;
    this.queryParam.cmd = localStorage.cmd;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        adviserId: '',
        uid: '',
        nickName: '',
        startTime: '',
        endTime: '',
        canal: ''
      },
      assignNum: '',
      title: [{
        title: '学生ID/姓名',
        key: 'uid',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '电话',
        key: 'phoneNumber'
      }, {
        title: '渠道',
        render: function render(h, params) {
          var regType = params.regType;
          var regTypesEnum = $constant.getEnum($constant.studentCanal, regType);
          console.log('regTypesEnum.text:' + regTypesEnum.text);
          return h('span', regTypesEnum && regTypesEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    this.$http.post('/userList/getAssignCanalDetails', self.queryParam).then(function (res) {
      self.assignNum = res.data;
    });
  },
  created: function created() {
    this.queryParam.adviserId = localStorage.adviserId;
    this.queryParam.startTime = localStorage.startTime;
    this.queryParam.endTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/userList/exportAdviserAssignDetail', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '课顾分配名单详情.csv';
        link.click();
        _this.exportLoading = false;
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lesson_BookUserFeedbackModal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lesson_BookUserFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lesson_BookUserFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson_BookTchFeedbackModal_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson_BookTchFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lesson_BookTchFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_ClassMemberTimeModal_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_ClassMemberTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_ClassMemberTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_modal_MonitorLessonRecordListModal_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_modal_MonitorLessonRecordListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lesson_modal_MonitorLessonRecordListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lesson_BookTchScoreFeedbackModal_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lesson_BookTchScoreFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lesson_BookTchScoreFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tchScore__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BookUserFeedbackModal: __WEBPACK_IMPORTED_MODULE_0__lesson_BookUserFeedbackModal_vue___default.a,
    BookTchFeedbackModal: __WEBPACK_IMPORTED_MODULE_1__lesson_BookTchFeedbackModal_vue___default.a,
    ClassMemberTimeModal: __WEBPACK_IMPORTED_MODULE_2__lesson_ClassMemberTimeModal_vue___default.a,
    MonitorLessonRecordListModal: __WEBPACK_IMPORTED_MODULE_3__lesson_modal_MonitorLessonRecordListModal_vue___default.a,
    BookTchScoreFeedbackModal: __WEBPACK_IMPORTED_MODULE_4__lesson_BookTchScoreFeedbackModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnType: '',
        courseType: '',
        checkStatus: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        studyAdviserId: ''
      },
      openedId: null,
      showBalanceModal: false,
      showRejectBalanceModal: false,
      showBookUserFeedbackModal: false,
      showClassMemberTimeModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      showMonitorLessonRecordListModal: false,
      monitorLessonRecordId: null,
      tchStudyAdviserList: [],
      title: [{
        title: '学生ID、姓名',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid + '-'), h('span', row.userNickname)]);
        }
      }, {
        title: '老师姓名',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.tchFirstName || '') + (row.tchLastName || ''),
            score: row.monthRankScore
          });
        }
      }, {
        title: '学顾',
        width: 70,
        key: 'studyAdviserNickname'
      }, {
        title: '课程名称',
        width: 70,
        key: 'lessonTitle'
      }, {
        title: '上课类型',
        align: 'center',
        width: 70,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程顾问',
        width: 70,
        key: 'adviserNickname'
      }, {
        title: '外教运营',
        width: 70,
        key: 'tchAdviserNickname'
      }, {
        title: '上课时间',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 60,
        key: 'courseTime'
      }, {
        title: '学生对老师评价',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookUserFeedbackId = row.bookUserFeedbackId;
          var bookUserFeedbackStar = row.bookUserFeedbackStar;
          if (bookUserFeedbackId) {
            return h('div', [h('Rate', {
              props: {
                disabled: true,
                count: bookUserFeedbackStar,
                value: bookUserFeedbackStar
              }
            }), h('br'), h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showBookUserFeedbackModal = true;
                }
              } }, '查看')]);
          }
          return h('span', { style: { color: 'red' } }, '未评论');
        }
      }, {
        title: '老师对学生评价',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookTchFeedbackUid = row.bookTchFeedbackUid;
          if (bookTchFeedbackUid) {
            return h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  if (row.lsnType === 1) {
                    _this.showBookTchScoreFeedbackModal = true;
                  } else {
                    _this.showBookTchFeedbackModal = true;
                  }
                }
              } }, '查看');
          }
          return h('span', { style: { color: 'red' } }, '未评论');
        }
      }, {
        title: '上课情况',
        width: 70,
        align: 'center',
        render: function render(h, params) {
          return h('a', { on: {
              click: function click() {
                _this.openedId = params.row.id;
                _this.showClassMemberTimeModal = true;
              }
            } }, '查看');
        }
      }, {
        title: '教室',
        width: 70,
        render: function render(h, params) {
          var row = params.row;
          var classType = row.classType;
          var typeEnum = $constant.getEnum($constant.classType, classType);
          return h('div', [h('span', typeEnum && typeEnum.text), h('span', ' - '), h('span', row.courseId)]);
        }
      }, {
        title: '监课记录',
        width: 70,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isMonitorLessonRecord = row.isMonitorLessonRecord;
          if (isMonitorLessonRecord) {
            return h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showMonitorLessonRecordListModal = true;
                }
              } }, '查看');
          }
          return h('span', { style: { color: 'red' } }, '未记录');
        }
      }, {
        title: '审核状态',
        width: 85,
        align: 'center',
        render: function render(h, params) {
          var checkStatus = params.row.checkStatus;
          var statusEnum = $constant.getEnum($constant.bookLessonOpenedCheckStatus, checkStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核备注',
        width: 120,
        key: 'checkReason'
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      self.tchStudyAdviserList = res.data;
    });
  },
  created: function created() {
    this.queryParam.studyAdviserId = localStorage.studyAdviserId;
    this.queryParam.startTime = localStorage.startTime;
    this.queryParam.endTime = localStorage.endTime;
    this.queryParam.courseType = localStorage.courseType;
    this.queryParam.lsnType = localStorage.lsnType;
    console.log(this.queryParam);
  },
  methods: {
    onDateChange: function onDateChange() {},
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = Date.parse(new Date(value)) / 1000;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = Date.parse(new Date(value)) / 1000;
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      queryParam: {
        uid: '',
        studyAdviserId: '',
        userMobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: ''
      },
      title: [{
        title: '学生ID、姓名',
        render: function render(h, params) {
          var row = params.row;

          return h(__WEBPACK_IMPORTED_MODULE_0__common_StudentInfo_vue___default.a, {
            props: {
              name: '' + (row.userNickname || ''),
              uid: row.uid
            }
          });
        }
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '涉及课节',
        align: 'center',
        width: 84,
        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                _this.onBookLessonOpened(params.row);
              } } }, '查看')]);
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var updateTime = params.row.updateTime;
          return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '备注',
        key: 'remark'
      }],
      showBookLessonOpenedModal: false,
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '手机号码',
        align: 'center',
        width: 100,
        key: 'userMobile'
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '学顾',
        width: 90,
        key: 'studyAdviserNickname'
      }, {
        title: '外教运营',
        width: 90,
        key: 'adviserNickname'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        key: 'lessonTitle'
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }],
      bookLessonOpenedList: []
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.studyAdviserId = localStorage.studyAdviserId;
    this.queryParam.startTimeSec = localStorage.startTime;
    this.queryParam.endTimeSec = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookLessonOpened: function onBookLessonOpened(row) {
      var self = this;
      var params = {};
      params.uid = row.uid;
      params.startTime = row.startTime;
      params.endTime = row.endTime;

      self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
        self.showBookLessonOpenedModal = true;
        self.bookLessonOpenedList = res.data;
      });
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'statisticsGatherList',
  data: function data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        paramYear: null,
        paramMonth: null
      },
      title: [{
        title: '日期',
        width: 90,
        align: 'center',
        key: 'statisticalDate'
      }, {
        title: '学生总数(常规+冻结)',
        align: 'center',
        width: 120,
        key: 'studentTotalCount'
      }, {
        title: '冻结数',
        width: 80,
        align: 'center',
        key: 'studentClosedCount'
      }, {
        title: '新增量',
        width: 80,
        align: 'center',
        key: 'studentNewMonthCount'
      }, {
        title: '预估结课量',
        width: 110,
        align: 'center',
        key: 'estimateEndStudentCount'
      }, {
        title: '实际结课量',
        width: 110,
        align: 'center',
        key: 'actualEndStudentCount'
      }, {
        title: '退费新生数',
        width: 110,
        align: 'center',
        key: 'newRefundCount'
      }, {
        title: '退费常规生数',
        width: 125,
        align: 'center',
        key: 'routineRefundCount'
      }, {
        title: '一对一课时',
        width: 110,
        align: 'center',
        key: 'enCount'
      }, {
        title: '提前请假(六小时前)',
        width: 120,
        align: 'center',
        key: 'studentAskLeaveCount'
      }, {
        title: '临时请假(六小时后)',
        width: 120,
        align: 'center',
        key: 'studentOnLeaveCount'
      }, {
        title: '缺席数',
        width: 80,
        align: 'center',
        key: 'studentAbsentCount'
      }, {
        title: '补课数(不计课时)',
        width: 100,
        align: 'center',
        key: 'makeUpCount'
      }, {
        title: '朋友圈赠课数',
        width: 100,
        align: 'center',
        key: 'circleGiveCourseCount'
      }, {
        title: '补贴课时',
        width: 95,
        align: 'center',
        key: 'otherGiveCourseCount'
      }, {
        title: '续费业绩(元)',
        width: 120,
        align: 'center',
        key: 'renewalPerformance'
      }, {
        title: '学导人数',
        width: 95,
        align: 'center',
        key: 'studyConsultantCount'
      }, {
        title: '人效(元)',
        width: 120,
        align: 'center',
        key: 'peopleEfficiency'
      }, {
        title: '转化率',
        width: 100,
        align: 'center',
        key: 'percentConversion'
      }, {
        title: '新生退费总金额(元)',
        width: 120,
        align: 'center',
        key: 'newRefundSum'
      }, {
        title: '常规生退费总金额(元)',
        width: 120,
        align: 'center',
        key: 'routineRefundSum'
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {},
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/dataCenter/statisticsGather/exportExcel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '课耗统计.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);





var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_0_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_0_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  name: 'StudentContract',
  data: function data() {
    return {
      loadingInsert: false,
      reload: 0,
      currentVersionId: '',
      currentContract: '',
      formData: {
        fundPackageId: '',
        contract: '',
        uid: '',
        contractVersionId: '',
        versionList: []
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var self = this;
    self.formData.fundPackageId = this.$route.query.row.id;
    if (self.formData.fundPackageId === undefined) {
      this.$router.go(-1);
      return;
    }
    self.formData.uid = this.$route.query.row.uid;
    self.$http.get('/fundPackage/getContract?fundPackageId=' + self.formData.fundPackageId).then(function (res) {
      if (res.data.fundPackageId) {
        self.currentVersionId = res.data.contractVersionId;
        self.currentContract = res.data.contract;
        self.formData = res.data;
      } else {
        self.formData.versionList = res.data.versionList;
      }
    });
  },
  created: function created() {},
  methods: {
    onChange: function onChange(val) {
      var _this = this;

      this.formData.versionList.forEach(function (v) {
        if (v.id === val && _this.currentVersionId !== v.id) {
          _this.formData.contract = v.contract;
        } else if (v.id === val && _this.currentVersionId === v.id) {
          _this.formData.contract = _this.currentContract;
        }
      });
    },
    onBack: function onBack() {
      this.$router.go(-1);
    },
    openPreview: function openPreview() {
      var contract = this.$refs.myQuillEditor.quill.root.innerHTML;
      var url = 'https://test-h5.kouyujie.cn/contract/contract.html';
      if (this.$appConfig.active === 'prod') {
        url = 'https://h5.speakstreet.cn/contract/contract.html';
      }
      var newWindow = window.open(url, '_blank');
      setTimeout(function () {
        newWindow.postMessage({ type: 'SET_CONTENT', contract: contract }, '*');
      }, 1000);
    },
    textChange: function textChange(val) {},
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$http.post('/fundPackage/editContract', {
        fundPackageId: self.formData.fundPackageId,
        contract: self.formData.contract,
        uid: self.formData.uid,
        contractVersionId: self.formData.contractVersionId
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('保存成功!');
          self.$router.go(-1);
        }
        self.loadingInsert = false;
      }).catch(function (e) {
        console.log(e);
        self.loadingInsert = false;
      });
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'studentDailyList',
  data: function data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        statisticalDate: null,
        studyConsultantId: null
      },
      title: [{
        title: '级别',
        align: 'center',

        key: 'levelName'
      }, {
        title: '总学生量',

        align: 'center',
        key: 'studentTotalCountSum'
      }, {
        title: '总在读学生',

        align: 'center',
        key: 'studentInCountSum'
      }, {
        title: '总停课学生数',

        align: 'center',
        key: 'studentClosedCountSum'
      }, {
        title: '本月退费学生数',

        align: 'center',
        key: 'studentRefundMonthCountSum'
      }, {
        title: '本月完结学生数',

        align: 'center',
        key: 'studentEndMonthCountSum'
      }, {
        title: '本月新生',

        align: 'center',
        key: 'studentNewMonthCountSum'
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {},
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/dataCenter/studentDaily/exportExcel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '学生数量统计.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            searchLoading: false,
            reload: 0,
            defaultDate: [],
            queryParam: {
                startTime: '',
                endTime: '',
                dayOfMonth: 0
            },
            tableRulePrompt: false,
            tableRulePromptContent: '',
            type: '',
            table: [{
                title: '时间',
                align: 'center',
                key: 'day',
                render: function render(h, params) {
                    var row = params.row;
                    if (_this.queryParam.dayOfMonth == 0) return h('div', row.gmtCreate);
                    return h('div', row.day);
                }
            }, {
                align: 'center',
                key: 'endCourseNum',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生状态变更记录】：最近一条变更记录状态为“结课学生” 且时间为对应日期的学生数量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '结课学生流失量');
                }
            }, {
                align: 'center',
                key: 'returnPremiumNum',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生状态变更记录】：最近一条变更记录状态为“退费学生” 且时间为对应日期的学生数量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '退费学生流失量');
                }
            }, {
                align: 'center',
                key: 'endCourseLifeCycle',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '∑（结课学生状态变更记录创建时间 - 学生注册时间）/ 结课学生流失量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '平均结课生命周期');
                }
            }, {
                align: 'center',
                key: 'returnLifeCycle',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '∑（退费学生状态变更记录创建时间 - 学生注册时间）/ 结课学生流失量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '平均退费生命周期');
                }
            }, {
                align: 'center',
                key: 'totalLifeCycle',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '∑（结课学生状态 +退费学生状态 变更记录创建时间 - 学生注册时间）/ 结课学生流失量';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '平均生命周期');
                }
            }]
        };
    },

    mounted: function mounted() {},
    created: function created() {
        var date = new Date();
        var today = this.$moment(new Date()).format('YYYY-MM-DD');
        var sevenDayAgo = this.$moment(new Date(date.getTime() - 168 * 60 * 60 * 1000)).format('YYYY-MM-DD');
        this.defaultDate = [sevenDayAgo, today];
        this.queryParam.startTime = sevenDayAgo;
        this.queryParam.endTime = today;
        console.log('this.queryParam.dayOfMonth', this.queryParam.dayOfMonth);
        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month';
    },
    updated: function updated() {
        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month';
    },

    methods: {
        search: function search() {
            this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month';
            this.reload = new Date().getTime();
        },
        showPrompt: function showPrompt(value) {
            var self = this;
            self.tableRulePrompt = true;
            self.tableRulePromptContent = value;
        },
        cancel: function cancel() {
            var self = this;
            self.tableRulePrompt = false;
        },
        getTimeDateChange: function getTimeDateChange(val) {
            console.log('\u65E5', val);
            this.queryParam.startTime = val[0];
            this.queryParam.endTime = val[1];
        },
        getTimeMonthChange: function getTimeMonthChange(val) {
            console.log('\u6708', val);
            this.queryParam.startTime = val;
            this.queryParam.endTime = val;
        },
        exportData: function exportData() {
            var _this2 = this;

            this.exportLoading = true;
            this.$http.get('/data/report/exporUserLifeCycleData', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
                if (response.data) {
                    var blob = new Blob([response.data], { type: 'text/csv' });
                    var link = document.createElement('a');
                    link.target = '_blank';
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '学生生命周期.csv';
                    link.click();
                    _this2.exportLoading = false;
                } else {
                    _this2.$Message.error(response.msg);
                }
            }).catch(function (e) {
                _this2.exportLoading = false;
            });
        }
    }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      type: 'month',
      queryParam: {
        queryStartTime: '',
        queryEndTime: '',
        studyAdviserId: null
      },
      table: [{
        title: '月份',
        align: 'center',
        key: 'monthStr',
        width: 150
      }, {
        title: '班主任',
        align: 'center',
        key: 'studyAdviserName',
        width: 150
      }, {
        title: '所有学生课耗',
        align: 'center',
        key: 'allConsume',
        width: 150
      }, {
        title: '当月新生课耗',
        align: 'center',
        key: 'newStdConsume',
        width: 150
      }, {
        title: '当月结课学生课耗',
        align: 'center',
        key: 'overStdConsume',
        width: 150
      }, {
        title: '当月1号班主任名下常规生数量',
        align: 'center',
        key: 'stdNumFirstDayOfMonth',
        width: 170
      }, {
        title: '未绑定的学生',
        align: 'center',
        key: 'noBindTchNum',
        width: 170
      }, {
        title: '当月接收新生数量',
        align: 'center',
        key: 'stdNumNew',
        width: 150
      }, {
        title: '当月结课学生数量',
        align: 'center',
        key: 'stdNumOver',
        width: 150
      }, {
        title: '课耗绩效',
        align: 'center',
        key: 'performance'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/userStudyAdviserLog/class-consumption-statistics-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '班主任课耗绩效.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            searchLoading: false,
            onLoading: false,
            reload: 0,
            defaultDate: [],
            type: '',
            queryParam: {
                startTime: '',
                endTime: '',
                dayOfMonth: 0
            },
            tableRulePrompt: false,
            tableRulePromptContent: '',
            table: [{
                title: '时间',
                align: 'center',
                key: 'day',
                width: 80,
                fixed: 'left',
                render: function render(h, params) {
                    var row = params.row;
                    if (_this.queryParam.dayOfMonth == 0) return h('div', row.gmtCreate);
                    return h('div', row.day);
                }
            }, {
                title: '包含所有课时学生数',
                align: 'center',
                key: 'totalAllCourse',
                width: 170,
                fixed: 'left',
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '外教课>0且中教课>0且陪练课>0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '包含所有课时学生数');
                }
            }, {
                align: 'center',
                key: 'totalPaySuccessNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【学生状态】:常规学生、停课学生、待分配学生';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '总在校付费学生数');
                }
            }, {
                align: 'center',
                key: 'routineNum',
                width: 170,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课>0且中教课=0且陪练课=0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '只含外教课学员数');
                }
            }, {
                align: 'center',
                key: 'chineseNum',
                width: 170,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课=0且中教课>0且陪练课=0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '只包含中教课学生数');
                }
            }, {
                align: 'center',
                key: 'partnerNum',
                width: 170,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课=0且中教课=0且陪练课>0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '只包含陪练课学生数');
                }
            }, {
                align: 'center',
                key: 'noRoutineNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课=0且中教课>0且陪练课>0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '无外教课时学员数');
                }
            }, {
                align: 'center',
                key: 'noChineseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课>0且中教课=0且陪练课>0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '无中教课时学员数');
                }
            }, {
                align: 'center',
                key: 'noPartnerNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【课时条件】：外教课>0且中教课>0且陪练课=0';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '无陪练课时学员数');
                }
            }, {
                align: 'center',
                key: 'serviceAttributionStudyNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【归属条件】：学导服务';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '学导服务常规生量');
                }
            }, {
                align: 'center',
                key: 'serviceAttributionAdviserNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【归属条件】：销售独立服务';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '销售服务学生量');
                }
            }, {
                align: 'center',
                key: 'noServiceAttributionNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【归属条件】：   等待确认归属';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '等待分配学生量');
                }
            }, {
                align: 'center',
                key: 'stopCourseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '查询当日总的停课学生量【学生状态】:        停课学生  ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '停课学生量');
                }
            }, {
                align: 'center',
                key: 'adviserOnlyNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：订单支付时间为对应日期【支付条件】：支付状态为全额付清【订单类型】：新签【学生量】：一个学生多笔订单只算一次';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '销售净签');
                }
            }, {
                align: 'center',
                key: 'studyReceiveNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：工单审核通过时间为对应日期【工单审核状态】：已通过';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '学导接收学生数');
                }
            }, {
                align: 'center',
                key: 'routineStopCourseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：外教课结课状态变更记录创建时间在对应日期内           【变更后状态】：主修课课结课   ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '外教课结课学员数');
                }
            }, {
                align: 'center',
                key: 'chineseStopCourseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：中教课结课状态变更记录创建时间在对应日期内   【变更后状态】：中教课结课   ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '中教课结课学员量');
                }
            }, {
                align: 'center',
                key: 'partnerStopCourseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：陪练课结课状态变更记录创建时间在对应日期内   【变更后状态】：   陪练课结课  ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '陪练课结课学员量');
                }
            }, {
                align: 'center',
                key: 'endCourseNum',
                width: 150,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：结课状态变更记录创建时间在对应日期内【变更后状态】：  结课学生   ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '学员结课流失量');
                }
            }, {
                align: 'center',
                key: 'returnPremiumNum',
                width: 170,
                renderHeader: function renderHeader(h, params) {
                    var tableHeader = '【时间条件】：退费状态变更记录创建时间在对应日期内 【变更后状态】：退费学生  ';
                    return h('div', {
                        style: { color: '#3399ff' },
                        on: { click: function click() {
                                return _this.showPrompt(tableHeader);
                            } }
                    }, '后端退费流失学生量');
                }
            }]
        };
    },

    mounted: function mounted() {},
    created: function created() {
        var date = new Date();
        var today = this.$moment(new Date()).format('YYYY-MM-DD');
        var sevenDayAgo = this.$moment(new Date(date.getTime() - 168 * 60 * 60 * 1000)).format('YYYY-MM-DD');
        this.defaultDate = [sevenDayAgo, today];
        this.queryParam.startTime = sevenDayAgo;
        this.queryParam.endTime = today;

        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month';
    },
    methods: {
        search: function search() {
            console.log('this.queryParam', this.queryParam);
            this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month';
            this.reload = new Date().getTime();
        },
        onLoading: function onLoading(loading) {
            this.searchLoading = loading;
        },
        showPrompt: function showPrompt(value) {
            var self = this;
            self.tableRulePrompt = true;
            self.tableRulePromptContent = value;
        },
        cancel: function cancel() {
            var self = this;
            self.tableRulePrompt = false;
        },
        getTimeDateChange: function getTimeDateChange(val) {
            this.queryParam.startTime = val[0];
            this.queryParam.endTime = val[1];
        },
        getTimeMonthChange: function getTimeMonthChange(val) {
            this.queryParam.startTime = val;
            this.queryParam.endTime = val;
        },
        exportData: function exportData() {
            var _this2 = this;

            this.exportLoading = true;
            this.$http.get('/data/report/exporstudytadviserdata', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
                if (response.data) {
                    var blob = new Blob([response.data], { type: 'text/csv' });
                    var link = document.createElement('a');
                    link.target = '_blank';
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '后端学导数据.csv';
                    link.click();
                    _this2.exportLoading = false;
                } else {
                    _this2.$Message.error(response.msg);
                }
            }).catch(function (e) {
                _this2.exportLoading = false;
            });
        }
    }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      showLessonCountModal: false,
      url: null,
      courseType: '',
      startTimeStr: '',
      endTimeStr: '',
      details: '',
      queryParams: {
        studyAdviserId: null
      },
      queryParam: {
        startTimeSec: '',
        endTimeSec: '',
        status: 1,
        adminUserId: ''
      },
      title: [{
        title: 'ID',

        align: 'center',
        key: 'studyAdviserId'
      }, {
        title: '名字',

        align: 'center',
        key: 'studyAdviserName'
      }, {
        title: '课耗 外教/中教/陪练/辅修',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.showDetail(params, 'routine');
              } } }, row.routineNum + ' / '), h('a', { on: { click: function click() {
                return _this.showDetail(params, 'chinese');
              } } }, row.chineseNum + ' / '), h('a', { on: { click: function click() {
                return _this.showDetail(params, 'partner');
              } } }, row.partnerNum + ' / '), h('a', { on: { click: function click() {
                return _this.showDetail(params, 'minor');
              } } }, row.minorNum)]);
        }
      }, {
        title: '试听课数',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.showDetail(params, 'audition');
              } } }, row.auditionNum);
        }
      }, {
        title: '工单 完成/未完成',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.processed + ' / ' + row.unprocessed);
        }
      }, {
        title: '学生请假总数量',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.showTotalLeaveDetail(row.studyAdviserId);
              } } }, row.totalLeaveNum);
        }
      }, {
        title: '补偿请假数',
        key: 'leaveNum',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.showLeaveDetail(row.studyAdviserId);
              } } }, row.leaveNum);
        }
      }, {
        title: '补偿课时',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.showAddCourseDetail(row.studyAdviserId);
              } } }, row.addLessonNum);
        }
      }, {
        title: '电话回访次数',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.showTelDetails(row.studyAdviserId);
              } } }, row.callNum);
        }
      }, {
        title: '回访时间(分钟)',
        key: 'totalCallTime',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.totalCallTime.toFixed(2));
        }
      }, {
        title: '学员数',

        align: 'center',
        key: 'bindStuNum'
      }]
    };
  },

  methods: {
    showTelDetails: function showTelDetails(studyAdviserId) {
      localStorage.setItem('studyAdviserId', studyAdviserId);
      localStorage.setItem('startTime', this.queryParam.startTimeSec);
      localStorage.setItem('endTime', this.queryParam.endTimeSec);
      this.$router.push({ path: '/data/telDetails' });
    },
    showTotalLeaveDetail: function showTotalLeaveDetail(studyAdviserId) {
      localStorage.setItem('studyAdviserId', studyAdviserId);
      localStorage.setItem('startTime', this.queryParam.startTimeSec);
      localStorage.setItem('endTime', this.queryParam.endTimeSec);
      this.$router.push({ path: '/data/showTotalLeaveDetail' });
    },
    showAddCourseDetail: function showAddCourseDetail(studyAdviserId) {
      localStorage.setItem('studyAdviserId', studyAdviserId);
      localStorage.setItem('startTime', this.queryParam.startTimeSec);
      localStorage.setItem('endTime', this.queryParam.endTimeSec);
      this.$router.push({ path: '/data/showAddCourseDetail' });
    },
    showLeaveDetail: function showLeaveDetail(studyAdviserId) {
      localStorage.setItem('studyAdviserId', studyAdviserId);
      localStorage.setItem('startTime', this.queryParam.startTimeSec);
      localStorage.setItem('endTime', this.queryParam.endTimeSec);
      this.$router.push({ path: '/data/showAddLeaveNumDetail' });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      if (value) {
        this.queryParam.startTimeSec = Date.parse(new Date(value)) / 1000 - 28800;
      } else {
        this.queryParam.startTimeSec = null;
      }
    },
    endTimeDateChange: function endTimeDateChange(value) {
      if (value) {
        this.queryParam.endTimeSec = Date.parse(new Date(value)) / 1000 + 57599;
      } else {
        this.queryParam.endTimeSec = null;
      }
    },
    showDetail: function showDetail(params, cmd) {
      localStorage.setItem('startTime', this.queryParam.startTimeSec);
      localStorage.setItem('endTime', this.queryParam.endTimeSec);
      localStorage.setItem('studyAdviserId', params.row.studyAdviserId);
      if (cmd === 'routine') {
        localStorage.setItem('courseType', 1);
      }
      if (cmd === 'chinese') {
        localStorage.setItem('courseType', 2);
      }
      if (cmd === 'living') {
        localStorage.setItem('courseType', 3);
      }
      if (cmd === 'minor') {
        localStorage.setItem('courseType', 4);
      }
      if (cmd === 'chineseMakeup') {
        localStorage.setItem('courseType', 6);
      }
      if (cmd === 'makeup') {
        localStorage.setItem('courseType', 5);
      }
      if (cmd === 'partner') {
        localStorage.setItem('courseType', 8);
      }
      if (cmd === 'audition') {
        localStorage.setItem('lsnType', 1);
      }
      this.$router.push({ path: '/data/showLessonCount' });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      this.$refs.dataList.search();
      var self = this;

      self.$http.post('/adminUser/getTotalStudyAdviserData', self.queryParam).then(function (res) {
        self.details = res.data;
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    this.$http.post('/adminUser/getTotalStudyAdviserData', self.queryParam).then(function (res) {
      self.details = res.data;
    });
  },
  created: function created() {
    this.startTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '1';
    this.endTimeStr = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(Date.now(), 'YYYY-MM-DD');
    this.queryParam.startTimeSec = Date.parse(this.startTimeStr) / 1000;
    this.queryParam.endTimeSec = Date.parse(this.endTimeStr) / 1000;
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);





var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_0_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_0_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  name: 'TchContract',
  data: function data() {
    return {
      loadingInsert: false,
      reload: 0,
      currentVersionId: '',
      currentContract: '',
      formData: {
        id: '',
        tchId: '',
        contract: '',
        contractVersionId: '',
        enabled: '',
        confirmed: '',
        confirmTime: '',
        versionList: []
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var self = this;
    self.formData.tchId = this.$route.query.tchId;
    if (self.formData.tchId === undefined) {
      this.$router.go(-1);
      return;
    }
    self.$http.get('/tch/lesson/contract?tchId=' + self.formData.tchId).then(function (res) {
      if (res.data.tchId) {
        self.currentVersionId = res.data.contractVersionId;
        self.currentContract = res.data.contract;
        self.formData = res.data;
      } else {
        self.formData.versionList = res.data.versionList;
      }
    });
  },
  created: function created() {},
  methods: {
    onChange: function onChange(val) {
      var _this = this;

      this.formData.versionList.forEach(function (v) {
        if (v.id === val && _this.currentVersionId !== v.id) {
          _this.formData.contract = v.contract;
        } else if (v.id === val && _this.currentVersionId === v.id) {
          _this.formData.contract = _this.currentContract;
        }
      });
    },
    onBack: function onBack() {
      this.backToPreviousPage();
    },
    openPreview: function openPreview() {
      var contract = this.$refs.myQuillEditor.quill.root.innerHTML;

      var styleTag = '<style>\n        /* \u79FB\u9664\u6253\u5370\u9884\u89C8\u65F6\u7684\u6587\u5B57\u680F\u5E76\u8C03\u6574\u9875\u9762\u8FB9\u8DDD */\n        @media print {\n          @page { margin: 0 1.6cm 0 1.6cm; } /* \u4E3A\u6BCF\u4E00\u9875\u8BBE\u7F6E\u9876\u90E8\u8FB9\u8DDD3\u5398\u7C73 */\n          body { margin: 0; } /* \u91CD\u7F6Ebody\u8FB9\u8DDD\uFF0C\u4F7F\u7528@page\u7684\u8FB9\u8DDD\u63A7\u5236 */\n          .button { display: none !important; border: none; }\n        }\n      </style>';

      contract = styleTag + contract;

      var url = 'https://test-h5.kouyujie.cn/contract/preview.html';
      if (this.$appConfig.active === 'prod') {
        url = 'https://h5.speakstreet.cn/contract/preview.html';
      }
      var newWindow = window.open(url, '_blank');
      setTimeout(function () {
        newWindow.postMessage({ type: 'SET_CONTENT', contract: contract }, '*');
      }, 1000);
    },
    textChange: function textChange(val) {},
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$http.post('/tch/lesson/edit-contract', self.formData).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('保存成功!');
          self.backToPreviousPage();
        }
        self.loadingInsert = false;
      }).catch(function (e) {
        self.loadingInsert = false;
      });
    },
    backToPreviousPage: function backToPreviousPage() {
      var from = decodeURIComponent(this.$route.query.from || '/');
      this.$router.push(from);
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      queryParam: {
        studyAdviserId: '',
        startTimeSec: '',
        endTimeSec: '',
        callTel: '',
        calledTel: ''
      },
      title: [{
        title: '主叫号码',
        key: 'callNo'
      }, {
        title: '被叫号码',
        key: 'calledNo'
      }, {
        title: '响铃时间',
        key: 'ringStr'
      }, {
        title: '电话接通时间',
        key: 'beginStr'
      }, {
        title: '电话结束时间',
        key: 'endStr'
      }, {
        title: '通话时长',
        key: 'endStr',
        render: function render(h, params) {
          var row = params.row;
          if (((row.end - row.begin) / (1000 * 60)).toFixed(2) > 1) {
            return h('span', ((row.end - row.begin) / (1000 * 60)).toFixed(2) + ' 分钟');
          } else {
            return h('span', ((row.end - row.begin) / 1000).toFixed(0) + ' 秒');
          }
        }
      }, {
        title: '处理工号',
        key: 'agent'
      }, {
        title: '处理人',
        key: 'agentName'
      }, {
        title: '处理结果',
        key: 'attendLessonRate',
        render: function render(h, params) {
          var telState = params.row.state;
          var typeEnum = $constant.getEnum($constant.telState, telState);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '语音文件',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.downLoadFile(row);
              } } }, '查看');
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.studyAdviserId = localStorage.studyAdviserId;
    this.queryParam.startTimeSec = localStorage.startTime;
    this.queryParam.endTimeSec = localStorage.endTime;
  },
  methods: {
    downLoadFile: function downLoadFile(row) {
      window.open(row.fileServer + '/' + row.recordFile);
    },
    search: function search() {
      this.$refs.dataList.search();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EarlyLessonMemeberTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      dataList: [],
      column: [{
        title: '老师进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchStartTime === '0') {
            return h('span', '');
          }
          return h('span', $moment(params.tchStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师最后出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchEndTime === '0') {
            return h('span', '');
          }
          return h('span', $moment(params.row.tchEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdStartTime === '0') {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdEndTime === '0') {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师授课时间(秒)',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.tchTime);
        }
      }, {
        title: '学生学习时间(秒)',
        width: 121,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.sdTime);
        }
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/bookLesson/getClassMemberTime', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          return;
        }
        self.dataList = [res.data];
        self.visible = true;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonMemberTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      dataList: [],
      column: [{
        title: '老师进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchStartTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.tchStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师最后出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchEndTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.tchEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdStartTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdEndTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师授课时间(秒)',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.tchTime);
        }
      }, {
        title: '学生学习时间(秒)',
        width: 121,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.sdTime);
        }
      }]
    };
  },

  methods: {
    cancelAbsent: function cancelAbsent() {
      var _this = this;

      var self = this;
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">取消</span>该旷课?',
        width: 300,
        okText: '确认关闭',
        loading: true,
        onOk: function onOk() {
          _this.$http.post('/bc/cancelStudentAbsent', { lsnOpenId: self.openedId }).then(function (res) {
            if (res) {
              self.$Message.success('更改成功');
              self.$Modal.remove();
              self.visible = false;
              self.$emit('on-close');
            }
          });
        }
      });
    },
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/bookLesson/getClassMemberTime', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          return;
        }
        self.dataList = [res.data];
        self.visible = true;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OtherReasonModal_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OtherReasonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OtherReasonModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { OtherReasonModal: __WEBPACK_IMPORTED_MODULE_0__OtherReasonModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      reason: '',
      ohterReasonModal: false,
      otherReason: '',
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '课程名称',
        key: 'lessonName'
      }, {
        title: '课程类型',
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程开始时间时间',
        key: 'lessonStartTime'
      }, {
        title: '投诉理由',
        align: 'center',
        render: function render(h, params) {
          var reason = params.row.complaintReason;
          var typeEnum = $constant.getEnum($constant.complaintReason, reason);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '投诉补充',
        render: function render(h, params) {
          var row = params.row;
          if (row.otherComplaintReason) {
            return h('a', { on: { click: function click() {
                  return _this.showReason(row.otherComplaintReason);
                } } }, '查看');
          } else {
            return h('span', '无');
          }
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    showReason: function showReason(reason) {
      this.otherReason = reason;
      this.ohterReasonModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '试听课名称',
        key: 'trailLessonName'
      }, {
        title: '试听课时间',
        key: 'trailTimeStr'
      }, {
        title: '初节常规课',
        key: 'routineName'
      }, {
        title: '初节常规课时间',
        key: 'routineTimeStr'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OtherReasonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    otherReason: {
      type: String
    }
  },
  data: function data() {
    return {
      visible: this.value,
      reason: ''
    };
  },

  methods: {},
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.$emit('input', val);
    },
    otherReason: function otherReason(val) {
      this.reason = val;
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonMemberTimeModal_vue__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonMemberTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LessonMemberTimeModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LessonMemberTimeModal: __WEBPACK_IMPORTED_MODULE_0__LessonMemberTimeModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      showClassMemberTimeModal: false,
      openId: null,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '课程名称',
        key: 'lessonName'
      }, {
        title: '课程类型',
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程开始时间时间',
        key: 'lessonStartTime'
      }, {
        title: '课程时长(分钟)',
        key: 'lessonLength',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.lessonLength / 60);
        }
      }, {
        title: '进出教室记录',
        align: 'center',
        render: function render(h, params) {
          return h('a', { on: { click: function click() {
                _this.openId = params.row.openId;
                _this.showClassMemberTimeModal = true;
              } } }, '查看');
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    closeModal: function closeModal() {
      this.showClassMemberTimeModal = false;
      this.search();
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EarlyLessonMemberTimeModal_vue__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EarlyLessonMemberTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EarlyLessonMemberTimeModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EarlyLessonMemeberTimeModal: __WEBPACK_IMPORTED_MODULE_0__EarlyLessonMemberTimeModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      showClassMemberTimeModal: false,
      openId: null,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '课程名称',
        key: 'lessonName'
      }, {
        title: '课程类型',
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程开始时间时间',
        key: 'lessonStartTime'
      }, {
        title: '课程时长(分钟)',
        key: 'lessonLength',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.lessonLength / 60);
        }
      }, {
        title: '进出教室记录',
        align: 'center',
        render: function render(h, params) {
          return h('a', { on: { click: function click() {
                _this.openId = params.row.openId;
                _this.showClassMemberTimeModal = true;
              } } }, '查看');
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '课程名称',
        key: 'lessonName'
      }, {
        title: '课程类型',
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程结束时间',
        key: 'lessonEndTime'
      }, {
        title: '评价提交时间',
        align: 'center',
        key: 'reviewTimeStr'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        userNickname: '',
        adminNickname: '',
        lessonStartTime: '',
        lessonEndTime: '',
        lsnType: ''
      },
      title: [{
        title: '学生姓名/ID',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nickName + '-' + row.uid);
        }
      }, {
        title: '课程名称',
        key: 'lessonName'
      }, {
        title: '课程类型',
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程结束时间',
        key: 'lessonEndTime'
      }, {
        title: '评价提交时间',
        align: 'center',
        key: 'reviewTimeStr'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    listUrl: {
      type: String,
      default: '/bc/listUserLeaveDetail'
    }
  },
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        tchId: '',
        uid: '',
        lessonStartTime: '',
        lessonEndTime: ''
      },
      title: [{
        title: '学生ID、姓名',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('span', (row.uid || '') + '-' + (row.userNickname || ''));
        }
      }, {
        title: '上课时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.lsnBeginTime ? $moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') : '');
        }
      }, {
        title: '课程状态',
        align: 'center',
        width: 110,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '请假时间',
        align: 'center',
        width: 240,
        render: function render(h, params) {
          var row = params.row;
          var start = row.leaveStartTime ? $moment(row.leaveStartTime, 'X').format('YYYY-MM-DD HH:mm') : '';
          var end = row.leaveEndTime ? $moment(row.leaveEndTime, 'X').format('YYYY-MM-DD HH:mm') : '';
          if (!start && !end) {
            return h('span', '');
          }
          if (!end) {
            return h('span', start);
          }
          return h('span', start + ' ~ ' + end);
        }
      }]
    };
  },

  created: function created() {
    this.queryParam.tchId = localStorage.tchId;
    this.queryParam.lessonStartTime = localStorage.startTime;
    this.queryParam.lessonEndTime = localStorage.endTime;
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiskGroupNav',
  props: {
    groupId: {
      type: [Number, String],
      default: null
    },
    rootNodeId: {
      type: [Number, String],
      default: null
    },
    currentFolderId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      loadError: false,
      categories: [],
      entries: [],
      categoryKey: '',
      keyword: '',
      expanded: true,
      userCollapsed: false,
      openingId: null,
      openSeq: 0,
      loadedGroupId: null
    };
  },

  computed: {
    visible: function visible() {
      return Number(this.groupId) === 1;
    },
    atRoot: function atRoot() {
      if (this.rootNodeId == null || this.currentFolderId == null) {
        return false;
      }
      return Number(this.rootNodeId) === Number(this.currentFolderId);
    },
    hasFilter: function hasFilter() {
      return !!(this.categoryKey || (this.keyword || '').trim());
    },
    filteredEntries: function filteredEntries() {
      var _this = this;

      var list = this.entries || [];
      if (this.categoryKey) {
        list = list.filter(function (e) {
          return e.categoryKey === _this.categoryKey;
        });
      }
      var kw = (this.keyword || '').trim().toLowerCase();
      if (!kw) {
        return list;
      }
      return list.filter(function (e) {
        var blob = [e.title, e.summary].concat(e.keywords || []).join(' ').toLowerCase();
        return blob.indexOf(kw) !== -1;
      });
    }
  },
  watch: {
    groupId: {
      immediate: true,
      handler: function handler(val) {
        if (Number(val) === 1) {
          this.ensureLoaded();
          this.syncExpandByFolder();
        } else {
          this.categories = [];
          this.entries = [];
          this.loadedGroupId = null;
        }
      }
    },
    currentFolderId: function currentFolderId() {
      this.syncExpandByFolder();
    },
    rootNodeId: function rootNodeId() {
      this.syncExpandByFolder();
    }
  },
  methods: {
    syncExpandByFolder: function syncExpandByFolder() {
      if (!this.visible) {
        return;
      }
      if (this.atRoot) {
        if (!this.userCollapsed) {
          this.expanded = true;
        }
      } else {
        this.expanded = false;
        this.userCollapsed = false;
      }
    },
    expand: function expand() {
      this.expanded = true;
      this.userCollapsed = false;
      this.ensureLoaded();
    },
    collapse: function collapse() {
      this.expanded = false;
      if (this.atRoot) {
        this.userCollapsed = true;
      }
    },
    toggleCategory: function toggleCategory(key) {
      this.categoryKey = this.categoryKey === key ? '' : key;
    },
    clearFilter: function clearFilter() {
      this.categoryKey = '';
      this.keyword = '';
    },
    onKeywordChange: function onKeywordChange() {},
    ensureLoaded: function ensureLoaded() {
      if (!this.visible) {
        return;
      }
      if (this.loadedGroupId === Number(this.groupId) && (this.entries.length || this.categories.length) && !this.loadError) {
        return;
      }
      this.reload();
    },
    reload: function reload() {
      var self = this;
      if (!self.visible) {
        return;
      }
      self.loading = true;
      self.loadError = false;
      self.$http.get('/disk/nav/config', { params: { groupId: 1 } }).then(function (res) {
        self.loading = false;
        if (res && res.status === 'ok' && res.data) {
          self.categories = res.data.categories || [];
          self.entries = res.data.entries || [];
          self.loadedGroupId = 1;
          self.loadError = false;
        } else {
          self.loadError = true;
        }
      }).catch(function () {
        self.loading = false;
        self.loadError = true;
      });
    },
    openNode: function openNode(nodeId) {
      var self = this;
      if (!nodeId) {
        self.$Message.error('该入口已不可用，请联系维护人更新导航');
        return;
      }
      var seq = ++self.openSeq;
      self.openingId = nodeId;
      self.$http.get('/disk/nav/open', { params: { groupId: 1, nodeId: nodeId } }).then(function (res) {
        if (seq !== self.openSeq) {
          return;
        }
        self.openingId = null;
        if (res && res.status === 'ok' && res.data) {
          self.$emit('open-target', res.data);
        }
      }).catch(function () {
        if (seq !== self.openSeq) {
          return;
        }
        self.openingId = null;
      });
    }
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiskGroupNav_vue__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiskGroupNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DiskGroupNav_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiskIndex',
  components: { DiskGroupNav: __WEBPACK_IMPORTED_MODULE_4__DiskGroupNav_vue___default.a },
  data: function data() {
    var _this = this;

    return {
      spaces: [],
      groupList: [],
      activeSpace: null,
      activeGroup: null,
      groupKeyword: '',
      showCreateGroupModal: false,
      createGroupName: '',
      createGroupLoading: false,
      showMemberModal: false,
      activityPanelOpen: false,
      activityLoading: false,
      activityList: [],
      activityPageIndex: 1,
      activityPageSize: 20,
      activityTotal: 0,
      activityNoMore: false,
      memberList: [],
      memberLoading: false,
      memberSaving: false,
      memberForm: { subjectType: 1, subjectIds: [] },
      showRenameGroupModal: false,
      renameGroupName: '',
      renameGroupLoading: false,
      showTransferModal: false,
      transferOwnerId: null,
      transferLoading: false,
      memberColumns: [{
        type: 'expand',
        width: 50,
        render: function render(h, params) {
          if (params.row.subjectType !== 2) {
            return h('span', '');
          }
          if (params.row._usersLoading) {
            return h('div', { class: 'disk-tip' }, '加载中...');
          }
          var users = params.row._users || [];
          if (!users.length) {
            return h('div', { class: 'disk-tip' }, '组内暂无有效成员');
          }
          return h('Table', {
            props: {
              columns: _this.accountUserColumns,
              data: users,
              size: 'small',
              showHeader: true
            }
          });
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.subjectType === 2 ? '账号组' : '员工');
        }
      }, {
        title: '名称',
        minWidth: 160,
        render: function render(h, params) {
          var name = params.row.subjectName || params.row.subjectId;
          if (params.row.subjectType === 2 && params.row.groupUserCount != null) {
            name = name + '（' + params.row.groupUserCount + '人）';
          }
          return h('span', name);
        }
      }, {
        title: '角色',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.roleText(params.row.role));
        }
      }, {
        title: '上传',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          if (params.row.role === 1) {
            return h('span', '开');
          }
          return h('i-switch', {
            props: { value: !!params.row.uploadEnabled, size: 'small' },
            on: { 'on-change': function onChange(v) {
                return _this.toggleMemberUpload(params.row, v);
              } }
          });
        }
      }, {
        title: '操作',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var ops = [];
          if (row.subjectType === 2) {
            ops.push(h('span', {
              style: { marginRight: '12px', color: '#808695', fontSize: '12px' }
            }, '左侧展开设组内上传'));
          }
          if (_this.isGroupOwner && row.subjectType === 1 && row.role !== 1) {
            ops.push(h('a', {
              style: { marginRight: '12px' },
              on: { click: function click() {
                  return _this.toggleMemberAdmin(row);
                } }
            }, row.role === 2 ? '取消管理员' : '设为管理员'));
          }
          if (row.role !== 1) {
            ops.push(h('a', {
              style: { color: '#ed4014' },
              on: { click: function click() {
                  return _this.removeGroupMember(row);
                } }
            }, '移除'));
          }
          return ops.length ? h('div', ops) : h('span', '-');
        }
      }],
      accountUserColumns: [{
        title: '成员',
        minWidth: 140,
        render: function render(h, params) {
          return h('span', params.row.nickname || params.row.adminUserId);
        }
      }, {
        title: '有效上传',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          if (params.row.owner) {
            return h('span', '开（群主）');
          }
          return h('i-switch', {
            props: { value: !!params.row.uploadEnabled, size: 'small' },
            on: { 'on-change': function onChange(v) {
                return _this.toggleAccountUserUpload(params.row, v);
              } }
          });
        }
      }, {
        title: '覆盖',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.hasOverride ? '个人覆盖' : '跟随组');
        }
      }, {
        title: '操作',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          if (!params.row.hasOverride || params.row.owner) {
            return h('span', '-');
          }
          return h('a', { on: { click: function click() {
                return _this.clearAccountUserOverride(params.row);
              } } }, '恢复默认');
        }
      }],
      breadcrumb: [],
      currentFolder: null,
      list: [],
      keyword: '',
      listKeyword: '',
      loading: false,
      selectedRow: null,
      selectedRows: [],
      showMkdirModal: false,
      mkdirName: '',
      mkdirLoading: false,
      showRenameModal: false,
      renameName: '',
      renameLoading: false,
      renameNode: null,
      showMoveModal: false,
      pickerMode: 'move',
      moveNode: null,
      moveNodes: [],
      moveCrumbs: [],
      moveFolders: [],
      moveFolderLoading: false,
      moveSaving: false,
      showPreviewModal: false,
      previewUrl: '',
      previewBlobUrl: '',
      previewEngine: '',
      previewWebofficeUrl: '',
      previewAccessToken: '',
      previewRefreshToken: '',
      previewType: '',
      previewName: '',
      previewExt: '',
      previewDownloadId: null,
      previewLoading: false,
      previewError: '',
      previewText: '',
      previewHtml: '',
      previewRows: [],
      previewEmpty: false,
      jsonError: false,
      mediaError: false,
      showAclModal: false,
      aclNode: null,
      aclNodes: [],
      aclList: [],
      aclLoading: false,
      aclForm: { subjectType: 1, subjectId: null, subjectIds: [], permBits: [1, 2] },
      aclSaving: false,
      adminUserLoading: false,
      adminUserSelectKey: 0,
      adminGroupLoading: false,
      adminGroupSelectKey: 0,
      permOptions: [{ value: 1, label: '查看' }, { value: 2, label: '下载' }, { value: 4, label: '上传' }, { value: 8, label: '编辑' }, { value: 16, label: '删除' }, { value: 32, label: '分享' }, { value: 64, label: '授权' }],
      adminUsers: [],
      adminGroups: [],
      showShareModal: false,
      showShareLogModal: false,
      shareLogList: [],
      shareLogLoading: false,
      shareNode: null,
      shareNodes: [],
      shareList: [],
      shareSaving: false,
      shareForm: { expireType: 'forever', customExpire: '', customExpireDate: '', extractCode: '' },
      uploadTasks: [],
      uploadTotal: 0,
      uploadWaiting: 0,
      uploadStamp: 0,
      uploadPage: 1,
      uploadPageSize: 100,
      scanning: false,
      overwriteSame: false,
      scanCount: 0,
      uploading: false,
      uploadConcurrency: 6,
      uploadAutoHint: '',
      pendingSessions: [],
      showUploadModal: false,
      taskPanelOpen: false,
      taskFilter: 'all',
      taskSpeedBps: 0,
      resumeSession: null,
      pendingParentId: 0,
      columns: [{ type: 'selection', width: 56, align: 'center' }, {
        title: '名称',
        minWidth: 280,
        render: function render(h, params) {
          var row = params.row;
          var children = [h('Icon', {
            props: { type: row.nodeType === 1 ? 'folder' : 'document-text' },
            style: { marginRight: '6px' }
          })];
          if (row.nodeType === 1) {
            children.push(h('a', { on: { click: function click() {
                  return _this.enterFolder(row);
                } } }, row.name));
          } else if (row.status === 1 && _this.hasPerm(row, 2)) {
            children.push(h('a', { on: { click: function click() {
                  return _this.previewRow(row);
                } } }, row.name));
          } else {
            children.push(h('span', row.name));
          }
          if (row.status === 0) {
            children.push(h('span', { style: { marginLeft: '8px', color: '#ff9900', fontSize: '12px' } }, '上传中'));
          } else if (row.status === 2) {
            children.push(h('span', { style: { marginLeft: '8px', color: '#ed4014', fontSize: '12px' } }, '失败'));
          }
          var menu = _this.renderRowMenu(h, row);
          if (menu) {
            children.push(menu);
          }
          return h('div', children);
        }
      }, {
        title: '大小',
        width: 120,
        align: 'right',
        render: function render(h, params) {
          return h('span', params.row.nodeType === 1 ? '-' : _this.formatSize(params.row.size));
        }
      }, {
        title: '修改时间',
        width: 170,
        render: function render(h, params) {
          return h('span', _this.formatTime(params.row.gmtCreate));
        }
      }, { title: '创建人', width: 120, key: 'creatorName' }, { title: '操作人', width: 120, key: 'modifierName' }, { title: '操作', width: 100, key: 'lastAction' }],
      recycleColumns: [{
        title: '名称',
        minWidth: 240,
        key: 'name'
      }, {
        title: '大小',
        width: 120,
        align: 'right',
        render: function render(h, params) {
          return h('span', params.row.nodeType === 1 ? '-' : _this.formatSize(params.row.size));
        }
      }, {
        title: '删除时间',
        width: 170,
        render: function render(h, params) {
          return h('span', _this.formatTime(params.row.gmtDeleted));
        }
      }, { title: '删除人', width: 120, key: 'deleterName' }, {
        title: '操作',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return _this.hasPerm(params.row, 16) ? h('a', { on: { click: function click() {
                return _this.restoreRecycle(params.row);
              } } }, '恢复') : h('span', '-');
        }
      }],
      aclColumns: [{
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.subjectType === 2 ? '权限组' : '员工');
        }
      }, {
        title: '对象',
        minWidth: 160,
        render: function render(h, params) {
          return h('span', params.row.subjectName || params.row.name || params.row.subjectId);
        }
      }, {
        title: '权限',
        minWidth: 220,
        render: function render(h, params) {
          return h('span', _this.permText(params.row.perm));
        }
      }, {
        title: '操作',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('a', { on: { click: function click() {
                return _this.removeAcl(params.row);
              } } }, '移除');
        }
      }],
      shareColumns: [{ title: '文件', width: 180, key: 'nodeName' }, {
        title: '链接',
        width: 420,
        render: function render(h, params) {
          var url = _this.buildShareUrl(params.row.token, params.row.extractCode);
          return h('a', {
            attrs: { href: url, target: '_blank', rel: 'noopener', title: url },
            style: { display: 'inline-block', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-all', lineHeight: '20px' }
          }, url);
        }
      }, {
        title: '提取码',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.extractCode || '无');
        }
      }, {
        title: '到期时间',
        width: 170,
        render: function render(h, params) {
          return h('span', params.row.expireTime ? _this.formatTime(params.row.expireTime) : '永久');
        }
      }, { title: '分享人', width: 100, key: 'creatorName' }, { title: '访问次数', width: 90, align: 'center', key: 'visitCount' }, { title: '预览次数', width: 90, align: 'center', key: 'previewCount' }, { title: '下载次数', width: 90, align: 'center', key: 'downloadCount' }, {
        title: '操作',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            style: { marginRight: '16px' },
            on: {
              click: function click() {
                return _this.copyText(_this.buildShareUrl(params.row.token, params.row.extractCode));
              }
            }
          }, '复制'), h('a', {
            style: { marginRight: '16px' },
            on: { click: function click() {
                return _this.openShareLog(params.row);
              } }
          }, '详细记录'), h('a', { on: { click: function click() {
                return _this.revokeShare(params.row);
              } } }, '撤销')]);
        }
      }],
      shareLogColumns: [{ title: '访问 IP', minWidth: 140, key: 'ip' }, {
        title: '访问时间',
        width: 170,
        render: function render(h, params) {
          return h('span', _this.formatTime(params.row.gmtCreate));
        }
      }, { title: '预览次数', width: 100, align: 'center', key: 'previewCount' }, { title: '下载次数', width: 100, align: 'center', key: 'downloadCount' }],
      uploadColumns: [{ title: '名称', minWidth: 180, key: 'name' }, { title: '文件目录', minWidth: 140, key: 'dir' }, { title: '类型', width: 140, key: 'typeName' }, {
        title: '文件大小',
        width: 110,
        align: 'right',
        render: function render(h, params) {
          return h('span', _this.formatSize(params.row.size));
        }
      }, {
        title: '状态',
        width: 160,
        render: function render(h, params) {
          return h('span', params.row.statusText);
        }
      }, {
        title: '操作',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          return params.row.statusText === '等待上传' ? h('a', { on: { click: function click() {
                return _this.removeQueued(params.row);
              } } }, '移除') : h('span', '-');
        }
      }]
    };
  },

  computed: {
    displayColumns: function displayColumns() {
      if (this.inRecycle) {
        return this.recycleColumns;
      }
      var cols = this.columns.slice();
      var insertAt = 2;
      var kw = (this.listKeyword || '').trim();
      if (kw) {
        cols.splice(insertAt, 0, {
          title: '所在目录',
          minWidth: 180,
          render: function render(h, params) {
            var path = params.row.parentPath;
            if (!path) {
              return h('span', { style: { color: '#808695' } }, '-');
            }
            return h('span', {
              style: { color: '#808695' },
              attrs: { title: path }
            }, path);
          }
        });
        insertAt += 1;
      }
      if (this.inGroupSpace) {
        cols.splice(insertAt, 0, {
          title: '上传人',
          width: 120,
          render: function render(h, params) {
            return h('span', params.row.ownerAdminName || params.row.creatorName || '-');
          }
        });
      }
      return cols;
    },
    mainSpaces: function mainSpaces() {
      return (this.spaces || []).filter(function (sp) {
        return !String(sp.key).startsWith('group-');
      });
    },
    groupSpaces: function groupSpaces() {
      return (this.spaces || []).filter(function (sp) {
        return String(sp.key).startsWith('group-');
      });
    },
    filteredGroupSpaces: function filteredGroupSpaces() {
      var kw = (this.groupKeyword || '').trim().toLowerCase();
      var list = this.groupSpaces;
      if (!kw) {
        return list;
      }
      return list.filter(function (sp) {
        var name = sp.node && sp.node.name || sp.group && sp.group.name || '';
        return String(name).toLowerCase().indexOf(kw) !== -1;
      });
    },
    activityGroups: function activityGroups() {
      var _this2 = this;

      var list = this.activityList || [];
      var map = {};
      var order = [];
      var now = new Date();
      var today = this.activityDayKey(now);
      var y = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      var yesterday = this.activityDayKey(y);
      list.forEach(function (item) {
        var day = _this2.activityDayKey(item.gmtCreate);
        if (!map[day]) {
          map[day] = [];
          order.push(day);
        }
        map[day].push(item);
      });
      return order.map(function (day) {
        var label = day;
        if (day === today) label = '今日';else if (day === yesterday) label = '昨日';
        return { day: day, label: label, items: map[day] };
      });
    },
    inGroupSpace: function inGroupSpace() {
      return this.activeSpace && String(this.activeSpace.key).startsWith('group-');
    },
    isGroupOwner: function isGroupOwner() {
      return this.activeGroup && this.activeGroup.myRole === 1;
    },
    isGroupManager: function isGroupManager() {
      return this.activeGroup && (this.activeGroup.myRole === 1 || this.activeGroup.myRole === 2);
    },
    personMembers: function personMembers() {
      return (this.memberList || []).filter(function (m) {
        return m.subjectType === 1 && m.role !== 1;
      });
    },
    canUpload: function canUpload() {
      if (!this.currentFolder) {
        return false;
      }
      if (this.currentFolder.perm == null) {
        return true;
      }
      return this.hasPerm(this.currentFolder, 4);
    },
    moveSpaces: function moveSpaces() {
      return (this.spaces || []).filter(function (sp) {
        return sp.key === 'personal' || sp.key === 'company' || String(sp.key).startsWith('group-');
      });
    },
    moveTitle: function moveTitle() {
      var rows = this.moveNodes || [];
      var verb = this.pickerMode === 'copy' ? '复制' : '移动';
      if (rows.length === 1) {
        return verb + '「' + rows[0].name + '」到：';
      }
      if (rows.length > 1) {
        return verb + ' ' + rows.length + ' 项到：';
      }
      return verb + '到：';
    },
    moveHereDisabled: function moveHereDisabled() {
      var target = this.moveCrumbs.length ? this.moveCrumbs[this.moveCrumbs.length - 1] : null;
      var rows = this.moveNodes || [];
      if (!rows.length || !target) {
        return true;
      }
      if (rows.some(function (row) {
        return row.id === target.id;
      })) {
        return true;
      }
      if (rows.every(function (row) {
        return row.parentId === target.id;
      })) {
        return true;
      }
      return !this.hasPerm(target, 4);
    },
    canMove: function canMove() {
      var _this3 = this;

      return this.pickedRows.some(function (row) {
        return _this3.hasPerm(row, 8);
      });
    },
    pickedRows: function pickedRows() {
      if (this.selectedRows && this.selectedRows.length) {
        return this.selectedRows;
      }
      return this.selectedRow ? [this.selectedRow] : [];
    },
    canDownload: function canDownload() {
      var _this4 = this;

      return this.pickedRows.some(function (row) {
        return row.nodeType === 2 && row.status === 1 && _this4.hasPerm(row, 2);
      });
    },
    canShare: function canShare() {
      var _this5 = this;

      return this.pickedRows.some(function (row) {
        return _this5.hasPerm(row, 32);
      });
    },
    canAcl: function canAcl() {
      var _this6 = this;

      return this.pickedRows.some(function (row) {
        return _this6.hasPerm(row, 64);
      });
    },
    shareTitle: function shareTitle() {
      return this.batchTitle(this.shareNodes, '分享');
    },
    aclTitle: function aclTitle() {
      return this.batchTitle(this.aclNodes, '授权');
    },
    aclAdminUsers: function aclAdminUsers() {
      var rows = this.adminUsers || [];
      var blocked = {};
      rows.forEach(function (user) {
        var title = user && user.groupTitle != null ? String(user.groupTitle).trim() : '';
        if (title === '代理') {
          blocked[user.id] = true;
        }
      });
      var seen = {};
      return rows.filter(function (user) {
        if (!user || seen[user.id] || blocked[user.id]) {
          return false;
        }
        if (user.status !== 1 && user.status !== '1') {
          return false;
        }
        seen[user.id] = true;
        return true;
      });
    },
    canDelete: function canDelete() {
      var _this7 = this;

      return this.pickedRows.some(function (row) {
        return _this7.hasPerm(row, 16);
      });
    },
    centerPreview: function centerPreview() {
      return ['image', 'pdf', 'video', 'audio'].indexOf(this.previewType) >= 0;
    },
    officeUrl: function officeUrl() {
      return 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(this.previewUrl || '');
    },
    inRecycle: function inRecycle() {
      return this.activeSpace && this.activeSpace.key === 'recycle';
    },
    canBeginUpload: function canBeginUpload() {
      return !this.scanning && this.uploadWaiting > 0;
    },
    uploadPageRows: function uploadPageRows() {
      var stamp = this.uploadStamp;
      var list = this._uploadQueue || [];
      if (!stamp && !list.length) {
        return [];
      }
      var size = this.uploadPageSize;
      var start = (this.uploadPage - 1) * size;
      if (start < 0 || start >= list.length) {
        start = 0;
      }
      return list.slice(start, start + size);
    },
    taskItems: function taskItems() {
      var _this8 = this;

      var stamp = this.uploadStamp;
      var items = [];
      var seen = {};
      var list = this._uploadQueue || [];
      if (!stamp && !list.length && !this.pendingSessions.length) {
        return items;
      }
      list.forEach(function (item) {
        if (item.statusText === '等待上传') {
          return;
        }
        if (item.sessionId) {
          seen[item.sessionId] = true;
        }
        var state = _this8.taskState(item.statusText);
        items.push({
          key: item.key,
          name: item.name,
          size: item.size,
          dest: item.dest,
          statusText: item.statusText,
          percent: item.percent || 0,
          state: state.key,
          stateLabel: state.label,
          failMsg: item.failMsg || '',
          session: null,
          queueKey: item.key
        });
      });
      this.pendingSessions.forEach(function (session) {
        if (seen[session.sessionId]) {
          return;
        }
        items.push({
          key: 'pending-' + session.sessionId,
          name: session.name,
          size: session.fileSize,
          dest: '/',
          statusText: '已停止',
          percent: 0,
          state: 'stopped',
          stateLabel: '已停止',
          session: session,
          queueKey: null
        });
      });
      return items;
    },
    taskTabs: function taskTabs() {
      var items = this.taskItems;
      var count = function count(state) {
        return items.filter(function (item) {
          return item.state === state;
        }).length;
      };
      return [{ key: 'all', label: '全部', count: items.length }, { key: 'uploading', label: '上传中', count: count('uploading') }, { key: 'stopped', label: '已停止', count: count('stopped') }, { key: 'success', label: '上传成功', count: count('success') }, { key: 'failed', label: '上传失败', count: count('failed') }];
    },
    taskView: function taskView() {
      var _this9 = this;

      if (this.taskFilter === 'all') {
        return this.taskItems;
      }
      return this.taskItems.filter(function (item) {
        return item.state === _this9.taskFilter;
      });
    },
    taskUploadingCount: function taskUploadingCount() {
      return this.taskItems.filter(function (item) {
        return item.state === 'uploading';
      }).length;
    },
    taskResumableCount: function taskResumableCount() {
      var self = this;
      var n = 0;
      this.taskItems.forEach(function (item) {
        if (item.state !== 'stopped' && item.state !== 'failed') {
          return;
        }
        if (!item.queueKey) {
          return;
        }
        var task = self.queueByKey(item.queueKey);
        if (task && self._uploadFiles && self._uploadFiles[task.key]) {
          n++;
        }
      });
      n += (this._uploadQueue || []).filter(function (item) {
        return item.statusText === '等待上传';
      }).length;
      return n;
    },
    taskRemovableCount: function taskRemovableCount() {
      if (this.taskFilter === 'uploading') {
        return 0;
      }
      return this.taskView.filter(function (item) {
        return item.state === 'stopped' || item.state === 'failed' || item.state === 'success';
      }).length;
    },
    taskBadge: function taskBadge() {
      return this.taskItems.filter(function (item) {
        return item.state !== 'success';
      }).length;
    },
    showTaskOverall: function showTaskOverall() {
      var stamp = this.uploadStamp;
      var list = this._uploadQueue || [];
      if (!stamp && !list.length && !this.uploadWaiting && !this.taskItems.length) {
        return false;
      }
      return !!(list.length || this.uploadWaiting || this.taskItems.length);
    },
    taskOverallTotal: function taskOverallTotal() {
      var stamp = this.uploadStamp;
      var list = this._uploadQueue || [];
      var total = 0;
      var seen = {};
      if (!stamp && !list.length && !this.pendingSessions.length) {
        return 0;
      }
      list.forEach(function (item) {
        total += Number(item.size) || 0;
        if (item.sessionId) {
          seen[item.sessionId] = true;
        }
      });
      this.pendingSessions.forEach(function (session) {
        if (seen[session.sessionId]) {
          return;
        }
        total += Number(session.fileSize) || 0;
      });
      return total;
    },
    taskOverallDone: function taskOverallDone() {
      var stamp = this.uploadStamp;
      var list = this._uploadQueue || [];
      var done = 0;
      if (!stamp && !list.length && !this.pendingSessions.length) {
        return 0;
      }
      list.forEach(function (item) {
        var size = Number(item.size) || 0;
        var p = Number(item.percent) || 0;
        if (item.statusText === '已完成') {
          p = 100;
        } else if (item.statusText === '等待上传') {
          p = 0;
        }
        if (p < 0) {
          p = 0;
        }
        if (p > 100) {
          p = 100;
        }
        done += size * p / 100;
      });

      return done;
    },
    taskOverallPercent: function taskOverallPercent() {
      var total = this.taskOverallTotal;
      if (!total) {
        return 0;
      }
      return Math.round(this.taskOverallDone * 100 / total);
    }
  },
  created: function created() {
    this._uploadFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
    this._uploadSeen = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
    this._uploadQueue = [];
    this._speedSamples = [];
    this._initWaiters = [];
    this._initFlushTimer = null;
    this._initFlushing = false;
    this._signedLive = 0;
    this._completeBuffer = [];
    this._completeFlushTimer = null;
    this._completeFlushing = false;
    this.clearPersistedUploadConcurrency();
    this.uploadConcurrency = 6;
    var self = this;
    this._speedTimer = setInterval(function () {
      self.sampleTaskSpeed();
    }, 500);
    this.loadSpace();
    this.loadPending();
    this.loadAdminUsers();
    this.loadAdminGroups();
  },

  watch: {
    '$route.path': function $routePath(path) {
      if (path === '/disk/recycle') {
        if (!this.inRecycle) {
          this.showSpace(this.recycleSpace());
        }
        return;
      }
      if (path === '/disk/index' && (this.inRecycle || this.pendingSpace)) {
        var space = this.pendingSpace || this.spaces && this.spaces[0];
        this.pendingSpace = null;
        if (space) {
          this.showSpace(space);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.$refs.folderInput) {
      this.$refs.folderInput.setAttribute('webkitdirectory', '');
      this.$refs.folderInput.setAttribute('directory', '');
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._speedTimer) {
      clearInterval(this._speedTimer);
      this._speedTimer = null;
    }
    if (this._uploadAutoHintTimer) {
      clearTimeout(this._uploadAutoHintTimer);
      this._uploadAutoHintTimer = null;
    }
    this.stopSmartConcurrencyAdapt();
  },

  methods: {
    loadSpace: function loadSpace() {
      var self = this;
      self.$http.get('/disk/space').then(function (res) {
        if (!res || res.status !== 'ok' || !res.data) {
          return;
        }
        var spaces = [];
        var personal = self.normalizeNode(res.data.personal, 'personal');
        var company = self.normalizeNode(res.data.company, 'company');
        if (personal) {
          spaces.push({ key: 'personal', node: personal });
        }
        if (company) {
          spaces.push({ key: 'company', node: company });
        }
        spaces.push({ key: 'granted', node: { id: 0, name: '授权给我', nodeType: 1, perm: 1 } });
        var groups = res.data.groups || [];
        self.groupList = groups;
        groups.forEach(function (g) {
          if (!g || !g.root) {
            return;
          }
          var node = self.normalizeNode(g.root, 'group');
          node.name = g.name || node.name;
          spaces.push({ key: 'group-' + g.id, node: node, group: g });
        });
        self.spaces = spaces;
        if (self.$route.path === '/disk/recycle') {
          self.showSpace(self.recycleSpace());
        } else if (self.activeSpace && self.activeSpace.key) {
          var keep = spaces.filter(function (sp) {
            return sp.key === self.activeSpace.key;
          })[0];
          if (keep) {
            self.showSpace(keep);
            return;
          }
          if (spaces.length) {
            self.showSpace(spaces[0]);
          }
        } else if (spaces.length) {
          self.showSpace(spaces[0]);
        }
      });
    },
    spaceLabel: function spaceLabel(sp) {
      if (!sp || !sp.node) {
        return '';
      }
      if (sp.node.name) {
        return sp.node.name;
      }
      if (sp.key === 'personal') {
        return '我的文件';
      }
      if (sp.key === 'company') {
        return '公司文件';
      }
      return sp.key;
    },
    roleText: function roleText(role) {
      if (role === 1) {
        return '群主';
      }
      if (role === 2) {
        return '管理员';
      }
      return '成员';
    },
    normalizeNode: function normalizeNode(node, key) {
      if (node == null) {
        return null;
      }
      if (typeof node === 'number' || typeof node === 'string') {
        return { id: Number(node), name: key === 'personal' ? '我的文件' : '公司文件' };
      }
      return node;
    },
    recycleSpace: function recycleSpace() {
      return { key: 'recycle', node: { id: 0, name: '回收站', nodeType: 1, perm: 1 } };
    },
    enterSpace: function enterSpace(space) {
      if (space.key !== 'recycle' && this.$route.path === '/disk/recycle') {
        this.pendingSpace = space;
        this.$router.push('/disk/index');
        return;
      }
      this.showSpace(space);
    },
    showSpace: function showSpace(space) {
      this.activeSpace = space;
      this.activeGroup = space && space.group ? space.group : null;
      this.breadcrumb = [space.node];
      this.currentFolder = space.node;
      this.keyword = '';
      this.listKeyword = '';
      this.selectedRow = null;
      this.selectedRows = [];
      if (space.key === 'granted') {
        this.loadGranted();
      } else if (space.key === 'recycle') {
        this.loadRecycle();
      } else {
        this.loadList();
      }
    },
    enterFolder: function enterFolder(row) {
      if (!row || row.nodeType !== 1) {
        return;
      }
      this.breadcrumb.push(row);
      this.currentFolder = row;
      this.keyword = '';
      this.listKeyword = '';
      this.selectedRow = null;
      this.selectedRows = [];
      this.loadList();
    },
    jumpTo: function jumpTo(index) {
      this.breadcrumb = this.breadcrumb.slice(0, index + 1);
      this.currentFolder = this.breadcrumb[this.breadcrumb.length - 1];
      this.keyword = '';
      this.listKeyword = '';
      this.selectedRow = null;
      this.selectedRows = [];
      if (this.activeSpace && this.activeSpace.key === 'recycle') {
        this.loadRecycle();
        return;
      }
      this.loadList();
    },
    onNavOpenTarget: function onNavOpenTarget(data) {
      if (!data || !data.node) {
        return;
      }
      var trail = data.trail && data.trail.length ? data.trail.slice() : [data.node];
      this.breadcrumb = trail;
      this.currentFolder = data.node;
      this.keyword = '';
      this.listKeyword = '';
      this.selectedRow = null;
      this.selectedRows = [];
      this.loadList();
    },
    loadList: function loadList() {
      var self = this;
      if (self.activeSpace && self.activeSpace.key === 'granted' && self.breadcrumb.length === 1) {
        self.loadGranted();
        return;
      }
      if (self.activeSpace && self.activeSpace.key === 'recycle') {
        self.loadRecycle();
        return;
      }
      var parentId = self.currentFolder ? self.currentFolder.id : 0;
      self.loading = true;
      self.$http.get('/disk/list', { params: { parentId: parentId, keyword: self.keyword } }).then(function (res) {
        self.loading = false;
        self.selectedRow = null;
        self.selectedRows = [];
        if (res && res.status === 'ok') {
          self.list = res.data || [];
          self.listKeyword = (self.keyword || '').trim();
        }
      });
    },
    loadRecycle: function loadRecycle() {
      var self = this;
      self.loading = true;
      self.$http.get('/disk/recycle/list').then(function (res) {
        self.loading = false;
        self.selectedRow = null;
        self.selectedRows = [];
        if (res && res.status === 'ok') {
          self.list = res.data || [];
          self.listKeyword = '';
        }
      }).catch(function () {
        self.loading = false;
      });
    },
    restoreRecycle: function restoreRecycle(row) {
      var self = this;
      if (!row) {
        return;
      }
      self.$http.post('/disk/recycle/restore', { id: row.id }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已恢复');
          self.loadRecycle();
        }
      });
    },
    loadGranted: function loadGranted() {
      var self = this;
      self.loading = true;
      self.$http.get('/disk/granted').then(function (res) {
        self.loading = false;
        self.selectedRow = null;
        self.selectedRows = [];
        if (res && res.status === 'ok') {
          self.list = res.data || [];
          self.listKeyword = '';
        }
      });
    },
    search: function search() {
      this.loadList();
    },
    onCurrentChange: function onCurrentChange(currentRow) {
      this.selectedRow = currentRow;
    },
    onSelectionChange: function onSelectionChange(rows) {
      this.selectedRows = rows || [];
      this.selectedRow = this.selectedRows.length === 1 ? this.selectedRows[0] : null;
    },
    renderRowMenu: function renderRowMenu(h, row) {
      var self = this;
      var actions = [];
      if (row.nodeType === 1) {
        actions.push({ name: 'open', label: '打开' });
      }
      if (row.nodeType === 2 && row.status === 1 && self.hasPerm(row, 2)) {
        actions.push({ name: 'download', label: '下载' });
        actions.push({ name: 'preview', label: '预览' });
      }
      if (self.hasPerm(row, 8)) {
        actions.push({ name: 'rename', label: '重命名' });
        actions.push({ name: 'move', label: '移动' });
        actions.push({ name: 'copy', label: '复制' });
      }
      if (self.hasPerm(row, 32)) {
        actions.push({ name: 'share', label: '分享' });
      }
      if (self.hasPerm(row, 64)) {
        actions.push({ name: 'acl', label: '授权' });
      }
      if (self.hasPerm(row, 16)) {
        actions.push({ name: 'delete', label: '删除' });
      }
      if (!actions.length) {
        return null;
      }
      return h('Dropdown', {
        props: { transfer: true, trigger: 'click', placement: 'bottom-start' },
        style: { marginLeft: '8px' },
        nativeOn: {
          click: function click(event) {
            event.stopPropagation();
          }
        },
        on: {
          'on-click': function onClick(name) {
            self.onRowAction(row, name);
          }
        }
      }, [h('a', [h('span', '操作'), h('Icon', { props: { type: 'ios-arrow-down' }, style: { marginLeft: '2px' } })]), h('Dropdown-menu', { slot: 'list' }, actions.map(function (item) {
        return h('Dropdown-item', { props: { name: item.name } }, item.label);
      }))]);
    },
    onRowAction: function onRowAction(row, name) {
      this.selectedRow = row;
      if (name === 'open') {
        this.enterFolder(row);
      } else if (name === 'download') {
        this.download(row.id);
      } else if (name === 'preview') {
        this.previewRow(row);
      } else if (name === 'rename') {
        this.openRename(row);
      } else if (name === 'move') {
        this.openMove(row);
      } else if (name === 'copy') {
        this.openCopy(row);
      } else if (name === 'share') {
        this.openShare(row);
      } else if (name === 'acl') {
        this.openAcl(row);
      } else if (name === 'delete') {
        this.confirmDelete([row]);
      }
    },
    openRename: function openRename(row) {
      this.renameNode = row;
      this.renameName = row && row.name ? row.name : '';
      this.showRenameModal = true;
    },
    openMoveSelected: function openMoveSelected() {
      var _this10 = this;

      var rows = this.pickedRows.filter(function (row) {
        return _this10.hasPerm(row, 8);
      });
      if (!rows.length) {
        return;
      }
      this.openMove(rows[0], rows);
    },
    openCopy: function openCopy(row) {
      this.openPicker('copy', row, row ? [row] : []);
    },
    openMove: function openMove(row, rows) {
      this.openPicker('move', row, rows);
    },
    openPicker: function openPicker(mode, row, rows) {
      this.pickerMode = mode === 'copy' ? 'copy' : 'move';
      this.moveNode = row;
      this.moveNodes = rows && rows.length ? rows : row ? [row] : [];
      this.moveFolders = [];
      if (!this.inRecycle && this.breadcrumb && this.breadcrumb.length) {
        this.moveCrumbs = this.breadcrumb.slice();
      } else if (this.moveSpaces.length) {
        this.moveCrumbs = [this.moveSpaces[0].node];
      } else {
        this.moveCrumbs = [];
      }
      this.showMoveModal = true;
      this.loadMoveFolders();
    },
    switchMoveSpace: function switchMoveSpace(space) {
      if (!space || !space.node) {
        return;
      }
      this.moveCrumbs = [space.node];
      this.loadMoveFolders();
    },
    jumpMove: function jumpMove(index) {
      this.moveCrumbs = this.moveCrumbs.slice(0, index + 1);
      this.loadMoveFolders();
    },
    enterMoveFolder: function enterMoveFolder(folder) {
      if (!folder) {
        return;
      }
      this.moveCrumbs.push(folder);
      this.loadMoveFolders();
    },
    loadMoveFolders: function loadMoveFolders() {
      var self = this;
      var folder = self.moveCrumbs.length ? self.moveCrumbs[self.moveCrumbs.length - 1] : null;
      if (!folder) {
        self.moveFolders = [];
        return;
      }
      self.moveFolderLoading = true;
      self.$http.get('/disk/list', { params: { parentId: folder.id } }).then(function (res) {
        self.moveFolderLoading = false;
        var rows = res && res.status === 'ok' ? res.data || [] : [];
        var movingIds = {};(self.moveNodes || []).forEach(function (item) {
          if (item && item.nodeType === 1) {
            movingIds[item.id] = true;
          }
        });
        self.moveFolders = rows.filter(function (item) {
          return item.nodeType === 1 && !movingIds[item.id];
        });
      }).catch(function () {
        self.moveFolderLoading = false;
      });
    },
    confirmMove: function confirmMove() {
      var self = this;
      var target = self.moveCrumbs.length ? self.moveCrumbs[self.moveCrumbs.length - 1] : null;
      var isCopy = self.pickerMode === 'copy';
      var rows = (self.moveNodes || []).filter(function (row) {
        return isCopy || row.parentId !== target.id;
      });
      if (!rows.length || !target || self.moveHereDisabled) {
        return;
      }
      self.moveSaving = true;
      var index = 0;
      var api = isCopy ? '/disk/copy' : '/disk/move';
      var okText = isCopy ? '已复制' : '已移动';
      var next = function next() {
        if (index >= rows.length) {
          self.moveSaving = false;
          self.$Message.success(okText);
          self.showMoveModal = false;
          self.loadList();
          return;
        }
        var row = rows[index];
        index += 1;
        self.$http.post(api, {
          id: row.id,
          targetParentId: target.id
        }).then(function (res) {
          if (res && res.status === 'ok') {
            next();
          } else {
            self.moveSaving = false;
          }
        }).catch(function () {
          self.moveSaving = false;
        });
      };
      next();
    },
    onRename: function onRename() {
      var self = this;
      if (!self.renameNode) {
        return;
      }
      if (!self.renameName || !self.renameName.trim()) {
        self.$Message.warning('请输入新名称');
        return;
      }
      self.renameLoading = true;
      self.$http.post('/disk/rename', {
        id: self.renameNode.id,
        name: self.renameName.trim()
      }).then(function (res) {
        self.renameLoading = false;
        if (res && res.status === 'ok') {
          self.$Message.success('已修改');
          self.showRenameModal = false;
          self.loadList();
        }
      }).catch(function () {
        self.renameLoading = false;
      });
    },
    hasPerm: function hasPerm(node, bit) {
      if (!node || node.perm == null) {
        return false;
      }
      return (node.perm & bit) === bit;
    },
    formatSize: function formatSize(size) {
      if (size == null || size === '') {
        return '-';
      }
      var n = Number(size);
      if (isNaN(n) || n <= 0) {
        return '0 B';
      }
      var units = ['B', 'KB', 'MB', 'GB', 'TB'];
      var i = 0;
      while (n >= 1024 && i < units.length - 1) {
        n = n / 1024;
        i++;
      }
      return (i === 0 ? n : n.toFixed(2)) + ' ' + units[i];
    },
    formatSpeed: function formatSpeed(bps) {
      var n = Number(bps);
      if (isNaN(n) || n <= 0) {
        return '0 B/s';
      }
      var units = ['B/s', 'KB/s', 'MB/s', 'GB/s', 'TB/s'];
      var i = 0;
      while (n >= 1024 && i < units.length - 1) {
        n = n / 1024;
        i++;
      }
      return (i === 0 ? Math.round(n) : n.toFixed(1)) + ' ' + units[i];
    },
    sampleTaskSpeed: function sampleTaskSpeed() {
      var now = new Date().getTime();
      var bytes = this.taskOverallDone;
      if (!this._speedSamples) {
        this._speedSamples = [];
      }
      var samples = this._speedSamples;
      samples.push({ t: now, bytes: bytes });
      while (samples.length > 1 && now - samples[0].t > 3000) {
        samples.shift();
      }
      if (this.taskUploadingCount === 0) {
        this.taskSpeedBps = 0;
        this._speedSamples = [{ t: now, bytes: bytes }];
        return;
      }
      if (samples.length < 2) {
        this.taskSpeedBps = 0;
        return;
      }
      var first = samples[0];
      var last = samples[samples.length - 1];
      var dt = (last.t - first.t) / 1000;
      if (dt <= 0) {
        this.taskSpeedBps = 0;
        return;
      }
      var rate = (last.bytes - first.bytes) / dt;
      this.taskSpeedBps = rate > 0 ? rate : 0;
    },
    formatTime: function formatTime(value) {
      if (value == null || value === '') {
        return '';
      }
      if (typeof value === 'number') {
        return this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
      }
      var text = String(value);
      if (/^\d{10,}$/.test(text)) {
        return this.$moment(Number(text)).format('YYYY-MM-DD HH:mm:ss');
      }
      return text;
    },
    openMkdir: function openMkdir() {
      this.mkdirName = '';
      this.showMkdirModal = true;
    },
    onMkdir: function onMkdir() {
      var self = this;
      if (!self.mkdirName || !self.mkdirName.trim()) {
        self.$Message.warning('请输入文件夹名称');
        return;
      }
      self.mkdirLoading = true;
      self.$http.post('/disk/mkdir', {
        parentId: self.currentFolder ? self.currentFolder.id : 0,
        name: self.mkdirName.trim()
      }).then(function (res) {
        self.mkdirLoading = false;
        if (res && res.status === 'ok') {
          self.$Message.success('创建成功');
          self.showMkdirModal = false;
          self.loadList();
        }
      }).catch(function () {
        self.mkdirLoading = false;
      });
    },
    downloadSelected: function downloadSelected() {
      var _this11 = this;

      var files = this.pickedRows.filter(function (row) {
        return row.nodeType === 2 && row.status === 1 && _this11.hasPerm(row, 2);
      });
      if (!files.length) {
        this.$Message.warning('请选择已上传完成的文件');
        return;
      }
      var self = this;
      var pending = files.length;
      var urls = [];
      files.forEach(function (row) {
        self.$http.get('/disk/downloadUrl', { params: { id: row.id } }).then(function (res) {
          if (res && res.status === 'ok' && res.data && res.data.url) {
            urls.push({ url: res.data.url, name: row.name });
          }
          pending -= 1;
          if (pending === 0) {
            if (!urls.length) {
              return;
            }
            urls.forEach(function (item) {
              self.saveDownload(item.url, item.name);
            });
            self.$Message.success('开始下载 ' + urls.length + ' 个文件');
          }
        }).catch(function () {
          pending -= 1;
          if (pending === 0 && urls.length) {
            urls.forEach(function (item) {
              self.saveDownload(item.url, item.name);
            });
          }
        });
      });
    },
    saveDownload: function saveDownload(url) {
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame.src = url;
      document.body.appendChild(frame);
      setTimeout(function () {
        if (frame.parentNode) {
          frame.parentNode.removeChild(frame);
        }
      }, 60000);
    },
    download: function download(id) {
      var self = this;
      self.$http.get('/disk/downloadUrl', { params: { id: id } }).then(function (res) {
        if (res && res.status === 'ok' && res.data && res.data.url) {
          self.openUrl(res.data.url);
        }
      });
    },
    previewRow: function previewRow(row) {
      this.selectedRow = row;
      this.previewSelected();
    },
    previewSelected: function previewSelected() {
      var row = this.selectedRow;
      if (!row || row.nodeType !== 2) {
        this.$Message.warning('请选择文件');
        return;
      }
      var self = this;
      self.$http.get('/disk/previewUrl', { params: { id: row.id } }).then(function (res) {
        if (res && res.status === 'ok' && res.data && (res.data.url || res.data.engine === 'aliyun')) {
          self.resetPreview();
          self.previewUrl = res.data.url || '';
          self.previewType = self.resolvePreviewType(row);
          self.previewExt = self.resolveExt(row);
          self.previewName = row.name;
          self.previewDownloadId = row.id;
          if (self.previewType === 'office' && res.data.engine === 'aliyun') {
            self.openAliyunOffice(res.data);
          } else {
            self.previewEngine = 'oss';
            self.showPreviewModal = true;
            if (self.previewType === 'pdf') {
              self.loadPreviewPdf();
            } else if (self.isTextPreview()) {
              self.loadPreviewText();
            }
          }
        }
      });
    },
    resetPreview: function resetPreview() {
      this.destroyAliyunOffice();
      this.revokePreviewBlob();
      this.previewUrl = '';
      this.previewType = '';
      this.previewExt = '';
      this.previewName = '';
      this.previewDownloadId = null;
      this.previewLoading = false;
      this.previewError = '';
      this.previewText = '';
      this.previewHtml = '';
      this.previewRows = [];
      this.previewEmpty = false;
      this.jsonError = false;
      this.mediaError = false;
    },
    resolveExt: function resolveExt(row) {
      var ext = (row.ext || '').toLowerCase().replace(/^\./, '');
      if (ext) {
        return ext;
      }
      var name = row.name || '';
      var index = name.lastIndexOf('.');
      if (index >= 0 && index < name.length - 1) {
        return name.substring(index + 1).toLowerCase();
      }
      return '';
    },
    resolvePreviewType: function resolvePreviewType(row) {
      var ext = this.resolveExt(row);
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'].indexOf(ext) >= 0) {
        return 'image';
      }
      if (ext === 'pdf') {
        return 'pdf';
      }
      if (['mp4', 'webm', 'ogv', 'mov', 'm4v'].indexOf(ext) >= 0) {
        return 'video';
      }
      if (['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'].indexOf(ext) >= 0) {
        return 'audio';
      }
      if (['md', 'markdown'].indexOf(ext) >= 0) {
        return 'markdown';
      }
      if (ext === 'json') {
        return 'json';
      }
      if (['csv', 'tsv'].indexOf(ext) >= 0) {
        return 'csv';
      }
      if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].indexOf(ext) >= 0) {
        return 'office';
      }
      if (['txt', 'text', 'log', 'xml', 'html', 'htm', 'css', 'js', 'yml', 'yaml', 'ini', 'properties', 'sql', 'conf', 'cfg'].indexOf(ext) >= 0) {
        return 'text';
      }
      return '';
    },
    stopPreviewMedia: function stopPreviewMedia() {
      var players = [this.$refs.previewVideo, this.$refs.previewAudio];
      for (var i = 0; i < players.length; i++) {
        var player = players[i];
        if (!player) {
          continue;
        }
        player.pause();
        player.removeAttribute('src');
        player.load();
      }
      this.previewUrl = '';
    },
    onPreviewVisible: function onPreviewVisible(visible) {
      if (!visible) {
        this.stopPreviewMedia();
        this.revokePreviewBlob();
        this.destroyAliyunOffice();
      }
    },
    openAliyunOffice: function openAliyunOffice(data) {
      var self = this;
      self.previewEngine = 'aliyun';
      self.previewWebofficeUrl = data.webofficeUrl;
      self.previewAccessToken = data.accessToken;
      self.previewRefreshToken = data.refreshToken;
      self.showPreviewModal = true;
      self.loadAliyunSdk().then(function () {
        self.$nextTick(function () {
          if (!self.$refs.aliyunOffice) {
            self.$nextTick(function () {
              self.mountAliyunOffice();
            });
            return;
          }
          self.mountAliyunOffice();
        });
      }).catch(function () {
        self.previewError = '阿里云预览组件加载失败';
      });
    },
    loadAliyunSdk: function loadAliyunSdk() {
      if (window.aliyun && window.aliyun.config) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (this._aliyunSdkPromise) {
        return this._aliyunSdkPromise;
      }
      this._aliyunSdkPromise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://g.alicdn.com/IMM/office-js/1.1.19/aliyun-web-office-sdk.min.js';
        script.onload = function () {
          resolve();
        };
        script.onerror = function () {
          reject();
        };
        document.head.appendChild(script);
      });
      return this._aliyunSdkPromise;
    },
    mountAliyunOffice: function mountAliyunOffice() {
      var self = this;
      var mount = self.$refs.aliyunOffice;
      if (!mount || !window.aliyun || !window.aliyun.config) {
        self.previewError = '阿里云预览组件加载失败';
        return;
      }
      var ins = window.aliyun.config({
        mount: mount,
        url: self.previewWebofficeUrl,
        refreshToken: function refreshToken() {
          return self.refreshAliyunOffice();
        }
      });
      ins.setToken({
        token: self.previewAccessToken,
        timeout: 25 * 60 * 1000
      });
      self._aliyunOffice = ins;
    },
    refreshAliyunOffice: function refreshAliyunOffice() {
      var self = this;
      return self.$http.post('/disk/previewRefresh', {
        accessToken: self.previewAccessToken,
        refreshToken: self.previewRefreshToken
      }).then(function (res) {
        if (!res || res.status !== 'ok' || !res.data || !res.data.accessToken) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject();
        }
        self.previewAccessToken = res.data.accessToken;
        if (res.data.refreshToken) {
          self.previewRefreshToken = res.data.refreshToken;
        }
        return {
          token: res.data.accessToken,
          timeout: 25 * 60 * 1000
        };
      });
    },
    destroyAliyunOffice: function destroyAliyunOffice() {
      var ins = this._aliyunOffice;
      this._aliyunOffice = null;
      if (ins && ins.destroy) {
        try {
          ins.destroy();
        } catch (e) {}
      }
      this.previewEngine = '';
      this.previewWebofficeUrl = '';
      this.previewAccessToken = '';
      this.previewRefreshToken = '';
    },
    revokePreviewBlob: function revokePreviewBlob() {
      if (this.previewBlobUrl) {
        URL.revokeObjectURL(this.previewBlobUrl);
        this.previewBlobUrl = '';
      }
    },
    loadPreviewPdf: function loadPreviewPdf() {
      var self = this;
      var maxSize = 40 * 1024 * 1024;
      var tooLarge = false;
      self.previewLoading = true;
      self.previewError = '';
      self.revokePreviewBlob();
      var xhr = new XMLHttpRequest();
      xhr.open('GET', self.previewUrl, true);
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 2) {
          return;
        }
        var headerLength = Number(xhr.getResponseHeader('Content-Length'));
        if (!isNaN(headerLength) && headerLength > maxSize) {
          tooLarge = true;
          xhr.abort();
        }
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          self.previewLoading = false;
          self.previewError = '预览加载失败，请下载';
          return;
        }
        var blob = new Blob([xhr.response], { type: 'application/pdf' });
        self.previewBlobUrl = URL.createObjectURL(blob);
        self.previewLoading = false;
      };
      xhr.onerror = function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      };
      xhr.onabort = function () {
        if (tooLarge) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
        }
      };
      xhr.send();
    },
    isTextPreview: function isTextPreview() {
      return ['markdown', 'json', 'csv', 'text'].indexOf(this.previewType) >= 0;
    },
    onMediaError: function onMediaError() {
      this.mediaError = true;
    },
    loadPreviewText: function loadPreviewText() {
      var self = this;
      var maxSize = 2 * 1024 * 1024;
      var tooLarge = false;
      self.previewLoading = true;
      self.previewError = '';
      self.previewText = '';
      self.previewHtml = '';
      self.previewRows = [];
      self.previewEmpty = false;
      self.jsonError = false;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', self.previewUrl, true);
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 2) {
          return;
        }
        var headerLength = Number(xhr.getResponseHeader('Content-Length'));
        if (!isNaN(headerLength) && headerLength > maxSize) {
          tooLarge = true;
          xhr.abort();
        }
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          self.previewLoading = false;
          self.previewError = '预览加载失败，请下载';
          return;
        }
        if (self.isSpreadsheetBytes(xhr.response)) {
          self.loadPreviewSheet();
          return;
        }
        var text = self.decodePreviewBytes(xhr.response);
        var bodyLength = Number(xhr.getResponseHeader('Content-Length'));
        if (isNaN(bodyLength) || bodyLength <= 0) {
          bodyLength = self.byteLength(text);
        }
        if (bodyLength > maxSize) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
          return;
        }
        self.previewText = text;
        self.renderPreviewText();
        self.previewLoading = false;
      };
      xhr.onerror = function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      };
      xhr.onabort = function () {
        if (tooLarge) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
        }
      };
      xhr.send();
    },
    isSpreadsheetBytes: function isSpreadsheetBytes(buffer) {
      var bytes = new Uint8Array(buffer || []);
      if (bytes.length >= 8 && bytes[0] === 208 && bytes[1] === 207 && bytes[2] === 17 && bytes[3] === 224) {
        return true;
      }
      return bytes.length >= 4 && bytes[0] === 80 && bytes[1] === 75;
    },
    loadPreviewSheet: function loadPreviewSheet() {
      var self = this;
      self.previewType = 'csv';
      self.$http.get('/disk/previewTable', { params: { id: self.previewDownloadId } }).then(function (res) {
        self.previewLoading = false;
        if (res && res.status === 'ok') {
          self.previewRows = res.data || [];
          self.previewEmpty = !self.previewRows.length;
          return;
        }
        self.previewError = res && res.msg || '请下载后查看';
      }).catch(function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      });
    },
    decodePreviewBytes: function decodePreviewBytes(buffer) {
      var bytes = new Uint8Array(buffer || []);
      if (bytes.length >= 3 && bytes[0] === 239 && bytes[1] === 187 && bytes[2] === 191) {
        bytes = bytes.subarray(3);
      }
      if (!window.TextDecoder) {
        return '';
      }
      try {
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      } catch (e) {
        try {
          return new TextDecoder('gbk').decode(bytes);
        } catch (e2) {
          return new TextDecoder('utf-8').decode(bytes);
        }
      }
    },
    byteLength: function byteLength(text) {
      var value = String(text == null ? '' : text);
      if (window.Blob) {
        return new Blob([value]).size;
      }
      return value.length;
    },
    renderPreviewText: function renderPreviewText() {
      if (this.previewType === 'markdown') {
        this.previewHtml = this.renderMarkdown(this.previewText);
        return;
      }
      if (this.previewType === 'json') {
        try {
          this.previewText = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(JSON.parse(this.previewText), null, 2);
        } catch (e) {
          this.jsonError = true;
        }
        return;
      }
      if (this.previewType === 'csv') {
        this.previewRows = this.parseTable(this.previewText);
        this.previewEmpty = !this.previewRows.length;
      }
    },
    parseTable: function parseTable(text) {
      var content = String(text == null ? '' : text).replace(/^\uFEFF/, '');
      if (!content.replace(/\s/g, '')) {
        return [];
      }
      var lines = content.replace(/\r\n?/g, '\n').split('\n');
      while (lines.length && !lines[lines.length - 1].trim()) {
        lines.pop();
      }
      if (this.previewExt === 'tsv') {
        return lines.map(function (line) {
          return line.split('\t');
        });
      }
      return this.parseCsv(lines.join('\n'));
    },
    parseCsv: function parseCsv(text) {
      var rows = [];
      var row = [];
      var field = '';
      var inQuotes = false;
      var index = 0;
      while (index < text.length) {
        var char = text.charAt(index);
        if (inQuotes) {
          if (char === '"') {
            if (text.charAt(index + 1) === '"') {
              field += '"';
              index += 2;
            } else {
              inQuotes = false;
              index++;
            }
          } else {
            field += char;
            index++;
          }
          continue;
        }
        if (char === '"' && field === '') {
          inQuotes = true;
          index++;
          continue;
        }
        if (char === ',') {
          row.push(field);
          field = '';
          index++;
          continue;
        }
        if (char === '\n') {
          row.push(field);
          rows.push(row);
          row = [];
          field = '';
          index++;
          continue;
        }
        field += char;
        index++;
      }
      if (field !== '' || row.length) {
        row.push(field);
        rows.push(row);
      }
      return rows;
    },
    escapeHtml: function escapeHtml(text) {
      return String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    safeUrl: function safeUrl(url) {
      var value = String(url == null ? '' : url).trim();
      if (/^(https?:|mailto:|\/|\.\/|\.\.\/|#)/i.test(value)) {
        return value;
      }
      return '#';
    },
    attrValue: function attrValue(text) {
      return String(text == null ? '' : text).replace(/&quot;|&#34;|&#x0*22;|&#39;|&#x0*27;|"|'/gi, '');
    },
    renderInline: function renderInline(text) {
      var self = this;
      var segments = String(text == null ? '' : text).split('`');
      var html = '';
      for (var i = 0; i < segments.length; i++) {
        if (i % 2 === 1) {
          html += '<code>' + segments[i] + '</code>';
        } else {
          html += self.renderInlineFormat(segments[i]);
        }
      }
      return html;
    },
    renderInlineFormat: function renderInlineFormat(text) {
      var self = this;
      var html = text;
      html = html.replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, function (match, alt, src) {
        return '<img src="' + self.attrValue(self.safeUrl(src)) + '" alt="' + self.attrValue(alt) + '">';
      });
      html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (match, label, href) {
        return '<a href="' + self.attrValue(self.safeUrl(href)) + '" target="_blank" rel="noopener">' + label + '</a>';
      });
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
      return html;
    },
    renderMarkdown: function renderMarkdown(text) {
      var self = this;
      var lines = self.escapeHtml(text).replace(/\r\n?/g, '\n').split('\n');
      var html = [];
      var paragraph = [];
      var quoteLines = [];
      var listType = '';
      var codeLines = [];
      var inCode = false;
      var index = 0;
      var flushParagraph = function flushParagraph() {
        if (paragraph.length) {
          html.push('<p>' + self.renderInline(paragraph.join(' ')) + '</p>');
          paragraph = [];
        }
      };
      var flushQuote = function flushQuote() {
        if (quoteLines.length) {
          html.push('<blockquote>' + self.renderInline(quoteLines.join(' ')) + '</blockquote>');
          quoteLines = [];
        }
      };
      var flushList = function flushList() {
        if (listType) {
          html.push('</' + listType + '>');
          listType = '';
        }
      };
      while (index < lines.length) {
        var line = lines[index];
        if (/^\s*```/.test(line)) {
          if (inCode) {
            html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>');
            codeLines = [];
            inCode = false;
          } else {
            flushParagraph();
            flushList();
            flushQuote();
            inCode = true;
          }
          index++;
          continue;
        }
        if (inCode) {
          codeLines.push(line);
          index++;
          continue;
        }
        if (line.indexOf('|') >= 0 && index + 1 < lines.length && self.isTableSeparator(lines[index + 1])) {
          flushParagraph();
          flushList();
          flushQuote();
          var rows = [line];
          index += 2;
          while (index < lines.length && lines[index].indexOf('|') >= 0 && lines[index].trim()) {
            rows.push(lines[index]);
            index++;
          }
          html.push(self.renderTable(rows));
          continue;
        }
        if (!line.trim()) {
          flushParagraph();
          flushList();
          flushQuote();
          index++;
          continue;
        }
        var heading = /^(#{1,6})\s+(.*)$/.exec(line);
        if (heading) {
          flushParagraph();
          flushList();
          flushQuote();
          html.push('<h' + heading[1].length + '>' + self.renderInline(heading[2].trim()) + '</h' + heading[1].length + '>');
          index++;
          continue;
        }
        if (/^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(line)) {
          flushParagraph();
          flushList();
          flushQuote();
          html.push('<hr>');
          index++;
          continue;
        }
        var quote = /^\s*&gt;\s?(.*)$/.exec(line);
        if (quote) {
          flushParagraph();
          flushList();
          quoteLines.push(quote[1]);
          index++;
          continue;
        }
        flushQuote();
        var unordered = /^\s*[-*+]\s+(.*)$/.exec(line);
        if (unordered) {
          flushParagraph();
          if (listType !== 'ul') {
            flushList();
            html.push('<ul>');
            listType = 'ul';
          }
          html.push('<li>' + self.renderInline(unordered[1]) + '</li>');
          index++;
          continue;
        }
        var ordered = /^\s*\d+\.\s+(.*)$/.exec(line);
        if (ordered) {
          flushParagraph();
          if (listType !== 'ol') {
            flushList();
            html.push('<ol>');
            listType = 'ol';
          }
          html.push('<li>' + self.renderInline(ordered[1]) + '</li>');
          index++;
          continue;
        }
        flushList();
        paragraph.push(line.trim());
        index++;
      }
      if (inCode) {
        html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>');
      }
      flushParagraph();
      flushList();
      flushQuote();
      return html.join('\n');
    },
    isTableSeparator: function isTableSeparator(line) {
      if (!line || line.indexOf('-') < 0) {
        return false;
      }
      var cells = this.splitTableRow(line);
      if (!cells.length) {
        return false;
      }
      for (var i = 0; i < cells.length; i++) {
        if (!/^:?-{2,}:?$/.test(cells[i].replace(/\s/g, ''))) {
          return false;
        }
      }
      return true;
    },
    splitTableRow: function splitTableRow(line) {
      var text = String(line == null ? '' : line).trim();
      if (text.charAt(0) === '|') {
        text = text.substring(1);
      }
      if (text.charAt(text.length - 1) === '|') {
        text = text.substring(0, text.length - 1);
      }
      return text.split('|').map(function (cell) {
        return cell.trim();
      });
    },
    renderTable: function renderTable(rows) {
      var self = this;
      var head = self.splitTableRow(rows[0]);
      var html = ['<table>', '<thead><tr>'];
      head.forEach(function (cell) {
        html.push('<th>' + self.renderInline(cell) + '</th>');
      });
      html.push('</tr></thead><tbody>');
      for (var i = 1; i < rows.length; i++) {
        var cells = self.splitTableRow(rows[i]);
        html.push('<tr>');
        for (var c = 0; c < head.length; c++) {
          html.push('<td>' + self.renderInline(cells[c] || '') + '</td>');
        }
        html.push('</tr>');
      }
      html.push('</tbody></table>');
      return html.join('');
    },
    openUrl: function openUrl(url) {
      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    deleteSelected: function deleteSelected() {
      this.confirmDelete(this.pickedRows);
    },
    confirmDelete: function confirmDelete(rows) {
      var self = this;
      var list = (rows || []).filter(function (row) {
        return self.hasPerm(row, 16);
      });
      if (!list.length) {
        return;
      }
      var names = list.map(function (row) {
        return row.name;
      }).join('、');
      self.$Modal.confirm({
        title: '移入回收站',
        content: '确定把「' + names + '」移入回收站吗？云上的文件会保留，可在回收站恢复。',
        onOk: function onOk() {
          var chain = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
          list.forEach(function (row) {
            chain = chain.then(function () {
              return self.$http.post('/disk/delete', { id: row.id });
            });
          });
          chain.then(function () {
            self.$Message.success('已移入回收站');
            self.selectedRow = null;
            self.selectedRows = [];
            self.loadList();
          });
        }
      });
    },
    batchTitle: function batchTitle(rows, action) {
      var list = rows || [];
      if (list.length === 1) {
        var kind = list[0].nodeType === 2 ? '文件' : '文件夹';
        return '当前' + kind + '：' + list[0].name;
      }
      if (list.length > 1) {
        return action + ' ' + list.length + ' 项：' + list.map(function (row) {
          return row.name;
        }).join('、');
      }
      return action;
    },
    openAcl: function openAcl(row) {
      var _this12 = this;

      var rows = row && row.id ? [row] : this.pickedRows.filter(function (item) {
        return _this12.hasPerm(item, 64);
      });
      if (!rows.length) {
        return;
      }
      this.aclNodes = rows;
      this.aclNode = rows[0];
      this.aclList = [];
      this.aclForm = { subjectType: 1, subjectId: null, subjectIds: [], permBits: [1, 2] };
      this.showAclModal = true;
      this.loadAdminUsers();
      this.loadAdminGroups();
      if (rows.length === 1) {
        this.loadAclList();
      }
    },
    loadAclList: function loadAclList() {
      var self = this;
      if (!self.aclNode) {
        return;
      }
      self.aclLoading = true;
      self.$http.get('/disk/acl/list', { params: { nodeId: self.aclNode.id } }).then(function (res) {
        self.aclLoading = false;
        if (res && res.status === 'ok') {
          self.aclList = res.data || [];
        }
      });
    },
    openCreateGroup: function openCreateGroup() {
      this.createGroupName = '';
      this.showCreateGroupModal = true;
    },
    onCreateGroup: function onCreateGroup() {
      var self = this;
      var name = (self.createGroupName || '').trim();
      if (!name) {
        self.$Message.warning('请输入群名称');
        return;
      }
      if (self.createGroupLoading) {
        return;
      }
      self.createGroupLoading = true;
      self.$http.post('/disk/group/create', { name: name }).then(function (res) {
        self.createGroupLoading = false;
        if (res && res.status === 'ok') {
          self.showCreateGroupModal = false;
          self.$Message.success('已创建');
          self.loadSpace();
        } else {
          self.$Message.error(res && res.msg || '创建失败');
        }
      }).catch(function () {
        self.createGroupLoading = false;
      });
    },
    openActivityPanel: function openActivityPanel() {
      if (!this.activeGroup || !this.activeGroup.id) {
        this.$Message.warning('请先进入群空间');
        return;
      }
      this.activityPanelOpen = true;
      this.activityPageIndex = 1;
      this.activityNoMore = false;
      this.activityList = [];
      this.loadActivity(true);
    },
    loadActivity: function loadActivity(reset) {
      var self = this;
      if (!self.activeGroup || !self.activeGroup.id) return;
      if (self.activityLoading) return;
      if (!reset && self.activityNoMore) return;
      self.activityLoading = true;
      var pageIndex = reset ? 1 : self.activityPageIndex;
      self.$http.post('/disk/group/activity/list', {
        groupId: self.activeGroup.id,
        pageIndex: pageIndex,
        pageSize: self.activityPageSize
      }).then(function (res) {
        self.activityLoading = false;
        if (!res || res.status !== 'ok') {
          self.$Message.error(res && res.msg || '加载群动态失败');
          return;
        }
        var page = res.data || {};
        var rows = page.data || [];
        self.activityTotal = page.totalCount || 0;
        if (reset) {
          self.activityList = rows;
        } else {
          self.activityList = self.activityList.concat(rows);
        }
        self.activityPageIndex = pageIndex + 1;
        if (!rows.length || self.activityList.length >= self.activityTotal) {
          self.activityNoMore = true;
        }
      }).catch(function () {
        self.activityLoading = false;
        self.$Message.error('加载群动态失败');
      });
    },
    onActivityScroll: function onActivityScroll(e) {
      var el = e && e.target;
      if (!el) return;
      if (el.scrollTop + el.clientHeight + 40 >= el.scrollHeight) {
        this.loadActivity(false);
      }
    },
    activityDayKey: function activityDayKey(v) {
      var d = this.parseActivityDate(v);
      if (!d) return '未知';
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    },
    parseActivityDate: function parseActivityDate(v) {
      if (!v) return null;
      if (v instanceof Date) return v;
      if (typeof v === 'number') return new Date(v);
      var s = String(v).replace('T', ' ').replace(/-/g, '/');
      var d = new Date(s);
      return isNaN(d.getTime()) ? null : d;
    },
    formatActivityTime: function formatActivityTime(v) {
      var d = this.parseActivityDate(v);
      if (!d) return '';
      var h = d.getHours();
      var m = d.getMinutes();
      return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    },
    openMemberManage: function openMemberManage() {
      this.memberForm = { subjectType: 1, subjectIds: [] };
      this.showMemberModal = true;
      this.loadAdminUsers();
      this.loadAdminGroups();
      this.loadGroupMembers();
    },
    loadGroupMembers: function loadGroupMembers() {
      var self = this;
      if (!self.activeGroup) {
        return;
      }
      self.memberLoading = true;
      self.$http.get('/disk/group/members', { params: { groupId: self.activeGroup.id } }).then(function (res) {
        self.memberLoading = false;
        if (res && res.status === 'ok') {
          self.memberList = res.data || [];
        }
      }).catch(function () {
        self.memberLoading = false;
      });
    },
    addGroupMembers: function addGroupMembers() {
      var self = this;
      var ids = self.memberForm.subjectIds || [];
      if (!ids.length) {
        self.$Message.warning(self.memberForm.subjectType === 2 ? '请选择账号组' : '请选择员工');
        return;
      }
      if (!self.activeGroup || self.memberSaving) {
        return;
      }
      self.memberSaving = true;
      self.$http.post('/disk/group/member/add', {
        groupId: self.activeGroup.id,
        subjectType: self.memberForm.subjectType,
        subjectIds: ids
      }).then(function (res) {
        self.memberSaving = false;
        if (res && res.status === 'ok') {
          self.memberForm.subjectIds = [];
          self.$Message.success('已添加');
          self.loadGroupMembers();
          self.loadSpace();
        } else {
          self.$Message.error(res && res.msg || '添加失败');
        }
      }).catch(function () {
        self.memberSaving = false;
      });
    },
    removeGroupMember: function removeGroupMember(row) {
      var self = this;
      if (!self.activeGroup || !row) {
        return;
      }
      self.$Modal.confirm({
        title: '移除成员',
        content: '确定移除「' + (row.subjectName || row.subjectId) + '」？',
        onOk: function onOk() {
          self.$http.post('/disk/group/member/remove', {
            groupId: self.activeGroup.id,
            memberId: row.id
          }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已移除');
              self.loadGroupMembers();
              self.loadSpace();
            } else {
              self.$Message.error(res && res.msg || '移除失败');
            }
          });
        }
      });
    },
    toggleMemberAdmin: function toggleMemberAdmin(row) {
      var self = this;
      if (!self.activeGroup || !row || row.subjectType !== 1) {
        return;
      }
      var admin = row.role === 2 ? 0 : 1;
      self.$http.post('/disk/group/member/setAdmin', {
        groupId: self.activeGroup.id,
        adminUserId: row.subjectId,
        admin: admin
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已更新');
          self.loadGroupMembers();
          self.loadSpace();
        } else {
          self.$Message.error(res && res.msg || '操作失败');
        }
      });
    },
    toggleMemberUpload: function toggleMemberUpload(row, enabled) {
      var self = this;
      if (!self.activeGroup || !row) {
        return;
      }
      self.$http.post('/disk/group/member/setUpload', {
        groupId: self.activeGroup.id,
        subjectType: row.subjectType,
        subjectId: row.subjectId,
        uploadEnabled: enabled ? 1 : 0
      }).then(function (res) {
        if (res && res.status === 'ok') {
          row.uploadEnabled = !!enabled;
          self.$Message.success('已更新');
          if (row.subjectType === 2 && row._users) {
            self.loadAccountGroupUsers(row);
          }
        } else {
          self.$Message.error(res && res.msg || '操作失败');
          self.loadGroupMembers();
        }
      }).catch(function () {
        self.loadGroupMembers();
      });
    },
    onMemberExpand: function onMemberExpand(row, status) {
      if (!status || !row || row.subjectType !== 2) {
        return;
      }
      this.loadAccountGroupUsers(row);
    },
    loadAccountGroupUsers: function loadAccountGroupUsers(row) {
      var self = this;
      if (!self.activeGroup || !row || row.subjectType !== 2) {
        return;
      }
      self.$set(row, '_usersLoading', true);
      self.$http.get('/disk/group/member/accountUsers', {
        params: { groupId: self.activeGroup.id, adminGroupId: row.subjectId }
      }).then(function (res) {
        self.$set(row, '_usersLoading', false);
        if (res && res.status === 'ok') {
          var list = res.data || [];
          list.forEach(function (u) {
            u._adminGroupId = row.subjectId;
          });
          self.$set(row, '_users', list);
        } else {
          self.$set(row, '_users', []);
          self.$Message.error(res && res.msg || '加载失败');
        }
      }).catch(function () {
        self.$set(row, '_usersLoading', false);
        self.$set(row, '_users', []);
      });
    },
    toggleAccountUserUpload: function toggleAccountUserUpload(user, enabled) {
      var self = this;
      if (!self.activeGroup || !user || user.owner) {
        return;
      }
      self.$http.post('/disk/group/member/setUploadOverride', {
        groupId: self.activeGroup.id,
        adminUserId: user.adminUserId,
        uploadEnabled: enabled ? 1 : 0
      }).then(function (res) {
        if (res && res.status === 'ok') {
          user.uploadEnabled = !!enabled;
          user.hasOverride = true;
          self.$Message.success('已覆盖个人上传权限');
        } else {
          self.$Message.error(res && res.msg || '操作失败');
          self.refreshAccountUsersFor(user._adminGroupId);
        }
      }).catch(function () {
        self.refreshAccountUsersFor(user._adminGroupId);
      });
    },
    clearAccountUserOverride: function clearAccountUserOverride(user) {
      var self = this;
      if (!self.activeGroup || !user) {
        return;
      }
      self.$http.post('/disk/group/member/clearUploadOverride', {
        groupId: self.activeGroup.id,
        adminUserId: user.adminUserId
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已恢复跟随账号组');
          self.refreshAccountUsersFor(user._adminGroupId);
        } else {
          self.$Message.error(res && res.msg || '操作失败');
        }
      });
    },
    refreshAccountUsersFor: function refreshAccountUsersFor(adminGroupId) {
      var row = (this.memberList || []).filter(function (m) {
        return m.subjectType === 2 && m.subjectId === adminGroupId;
      })[0];
      if (row) {
        this.loadAccountGroupUsers(row);
      }
    },
    openRenameGroup: function openRenameGroup() {
      this.renameGroupName = this.activeGroup ? this.activeGroup.name : '';
      this.showRenameGroupModal = true;
    },
    onRenameGroup: function onRenameGroup() {
      var self = this;
      var name = (self.renameGroupName || '').trim();
      if (!name || !self.activeGroup) {
        self.$Message.warning('请输入群名称');
        return;
      }
      self.renameGroupLoading = true;
      self.$http.post('/disk/group/rename', { groupId: self.activeGroup.id, name: name }).then(function (res) {
        self.renameGroupLoading = false;
        if (res && res.status === 'ok') {
          self.showRenameGroupModal = false;
          self.$Message.success('已改名');
          self.loadSpace();
        } else {
          self.$Message.error(res && res.msg || '改名失败');
        }
      }).catch(function () {
        self.renameGroupLoading = false;
      });
    },
    openTransferGroup: function openTransferGroup() {
      this.transferOwnerId = null;
      this.showTransferModal = true;
      this.loadGroupMembers();
    },
    onTransferGroup: function onTransferGroup() {
      var self = this;
      if (!self.activeGroup || !self.transferOwnerId) {
        self.$Message.warning('请选择新群主');
        return;
      }
      self.transferLoading = true;
      self.$http.post('/disk/group/transfer', {
        groupId: self.activeGroup.id,
        newOwnerAdminId: self.transferOwnerId
      }).then(function (res) {
        self.transferLoading = false;
        if (res && res.status === 'ok') {
          self.showTransferModal = false;
          self.showMemberModal = false;
          self.$Message.success('已转让');
          self.loadSpace();
        } else {
          self.$Message.error(res && res.msg || '转让失败');
        }
      }).catch(function () {
        self.transferLoading = false;
      });
    },
    dissolveGroup: function dissolveGroup() {
      var self = this;
      if (!self.activeGroup) {
        return;
      }
      self.$Modal.confirm({
        title: '解散群',
        content: '解散后群文件将整体迁入你的个人空间，其他成员失去访问。确定解散？',
        onOk: function onOk() {
          self.$http.post('/disk/group/dissolve', { groupId: self.activeGroup.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.showMemberModal = false;
              self.$Message.success('已解散');
              self.activeGroup = null;
              self.loadSpace();
            } else {
              self.$Message.error(res && res.msg || '解散失败');
            }
          });
        }
      });
    },
    leaveGroup: function leaveGroup() {
      var self = this;
      if (!self.activeGroup) {
        return;
      }
      self.$Modal.confirm({
        title: '退群',
        content: '确定退出「' + self.activeGroup.name + '」？',
        onOk: function onOk() {
          self.$http.post('/disk/group/leave', { groupId: self.activeGroup.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已退群');
              self.activeGroup = null;
              self.loadSpace();
            } else {
              self.$Message.error(res && res.msg || '退群失败');
            }
          });
        }
      });
    },
    loadAdminUsers: function loadAdminUsers() {
      var self = this;
      if (self.adminUsers.length || self.adminUserLoading) {
        return;
      }
      self.adminUserLoading = true;
      self.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
        self.adminUserLoading = false;
        var list = [];
        if (res && res.status === 'ok' && res.data) {
          list = Array.isArray(res.data) ? res.data : res.data.data || [];
        }
        self.adminUsers = list;
        self.adminUserSelectKey += 1;
      }).catch(function () {
        self.adminUserLoading = false;
      });
    },
    userLabel: function userLabel(user) {
      var name = user.nickname || user.mobile || user.phone || String(user.id);
      var dingName = user.dingtalkName == null ? '' : String(user.dingtalkName).trim();
      if (dingName && dingName !== name) {
        return name + '（' + dingName + '）';
      }
      return name;
    },
    selectAllUsers: function selectAllUsers() {
      this.aclForm.subjectIds = this.aclAdminUsers.map(function (user) {
        return user.id;
      });
    },
    selectAllGroups: function selectAllGroups() {
      this.aclForm.subjectIds = this.adminGroups.map(function (group) {
        return group.id;
      });
    },
    loadAdminGroups: function loadAdminGroups() {
      var self = this;
      if (self.adminGroups.length || self.adminGroupLoading) {
        return;
      }
      self.adminGroupLoading = true;
      self.$http.get('/adminGroup/listByCondition?status=1').then(function (res) {
        self.adminGroupLoading = false;
        var list = [];
        if (res && res.status === 'ok' && res.data) {
          list = Array.isArray(res.data) ? res.data : res.data.data || [];
        }
        self.adminGroups = list;
        self.adminGroupSelectKey += 1;
      }).catch(function () {
        self.adminGroupLoading = false;
      });
    },
    onSubjectTypeChange: function onSubjectTypeChange() {
      this.aclForm.subjectId = null;
      this.aclForm.subjectIds = [];
    },
    saveAcl: function saveAcl() {
      var self = this;
      var nodes = self.aclNodes && self.aclNodes.length ? self.aclNodes : self.aclNode ? [self.aclNode] : [];
      if (!nodes.length || self.aclSaving) {
        return;
      }
      var ids = self.aclForm.subjectIds || [];
      if (!ids.length) {
        self.$Message.warning(self.aclForm.subjectType === 2 ? '请选择权限组' : '请选择员工');
        return;
      }
      var bits = self.aclForm.permBits || [];
      if (!bits.length) {
        self.$Message.warning('请选择权限');
        return;
      }
      var perm = 0;
      bits.forEach(function (bit) {
        perm = perm | Number(bit);
      });
      self.aclSaving = true;
      var nodeIds = nodes.map(function (node) {
        return node.id;
      });
      self.$http.post('/disk/acl/saveBatch', {
        nodeIds: nodeIds,
        subjectType: self.aclForm.subjectType,
        subjectIds: ids,
        perm: perm
      }).then(function (res) {
        self.aclSaving = false;
        if (res && res.status === 'ok') {
          self.$Message.success('保存成功');
          self.aclForm.subjectIds = [];
          if (nodes.length === 1) {
            self.loadAclList();
          }
        }
      }).catch(function () {
        self.aclSaving = false;
      });
    },
    removeAcl: function removeAcl(row) {
      var self = this;
      if (!self.aclNode) {
        return;
      }
      self.$http.post('/disk/acl/save', {
        nodeId: self.aclNode.id,
        subjectType: row.subjectType,
        subjectId: row.subjectId,
        perm: 0
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已移除');
          self.loadAclList();
        }
      });
    },
    permText: function permText(perm) {
      if (perm == null || perm === 0) {
        return '';
      }
      var names = [];(this.permOptions || []).forEach(function (item) {
        if ((perm & item.value) === item.value) {
          names.push(item.label);
        }
      });
      return names.length ? names.join('、') : String(perm);
    },
    openShare: function openShare(row) {
      var _this13 = this;

      var rows = row && row.id ? [row] : this.pickedRows.filter(function (item) {
        return _this13.hasPerm(item, 32);
      });
      if (!rows.length) {
        return;
      }
      this.shareNodes = rows;
      this.shareNode = rows[0];
      this.shareList = [];
      this.shareForm = { expireType: 'forever', customExpire: '', customExpireDate: '', extractCode: '' };
      this.showShareModal = true;
      if (rows.length === 1) {
        this.loadShareList();
      }
    },
    loadShareList: function loadShareList() {
      var self = this;
      if (!self.shareNode) {
        return;
      }
      self.$http.get('/disk/share/list', { params: { nodeId: self.shareNode.id } }).then(function (res) {
        if (res && res.status === 'ok') {
          var name = self.shareNode.name;
          self.shareList = (res.data || []).map(function (item) {
            if (!item.nodeName) {
              item.nodeName = name;
            }
            return item;
          });
        }
      });
    },
    openShareLog: function openShareLog(row) {
      var self = this;
      if (!row) {
        return;
      }
      self.shareLogList = [];
      self.shareLogLoading = true;
      self.showShareLogModal = true;
      self.$http.get('/disk/share/access', { params: { id: row.id } }).then(function (res) {
        self.shareLogLoading = false;
        if (res && res.status === 'ok') {
          self.shareLogList = res.data || [];
        }
      }).catch(function () {
        self.shareLogLoading = false;
      });
    },
    onCustomExpire: function onCustomExpire(val) {
      this.shareForm.customExpire = val;
    },
    createShare: function createShare() {
      var self = this;
      var nodes = self.shareNodes && self.shareNodes.length ? self.shareNodes : self.shareNode ? [self.shareNode] : [];
      if (!nodes.length) {
        return;
      }
      var expireTime = '';
      if (self.shareForm.expireType === 'custom') {
        if (!self.shareForm.customExpire) {
          self.$Message.warning('请选择到期时间');
          return;
        }
        expireTime = self.shareForm.customExpire;
      } else if (self.shareForm.expireType !== 'forever') {
        expireTime = self.$moment().add(Number(self.shareForm.expireType), 'days').format('YYYY-MM-DD HH:mm:ss');
      }
      if (self.shareForm.extractCode && !/^\S{4}$/.test(self.shareForm.extractCode)) {
        self.$Message.warning('提取码为4位');
        return;
      }
      self.shareSaving = true;
      var index = 0;
      var created = [];
      var next = function next() {
        if (index >= nodes.length) {
          self.shareSaving = false;
          self.$Message.success('已生成 ' + created.length + ' 条链接');
          self.shareForm.customExpire = '';
          self.shareForm.customExpireDate = '';
          self.shareForm.extractCode = '';
          if (nodes.length === 1) {
            self.loadShareList();
          } else {
            self.shareList = created;
          }
          if (created.length === 1) {
            self.copyText(self.buildShareUrl(created[0].token, created[0].extractCode || ''));
          }
          return;
        }
        var node = nodes[index];
        index += 1;
        self.$http.post('/disk/share/create', {
          nodeId: node.id,
          expireTime: expireTime || null,
          extractCode: self.shareForm.extractCode || null
        }).then(function (res) {
          if (res && res.status === 'ok' && res.data) {
            res.data.nodeName = node.name;
            created.push(res.data);
            next();
          } else {
            self.shareSaving = false;
            if (created.length) {
              self.shareList = created;
            }
          }
        }).catch(function () {
          self.shareSaving = false;
          if (created.length) {
            self.shareList = created;
          }
        });
      };
      next();
    },
    revokeShare: function revokeShare(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定撤销该分享链接吗？',
        onOk: function onOk() {
          self.$http.post('/disk/share/revoke', { id: row.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已撤销');
              self.loadShareList();
            }
          });
        }
      });
    },
    buildShareUrl: function buildShareUrl(token, extractCode) {
      var url = window.location.origin + window.location.pathname + '#/disk/share?token=' + (token || '');
      if (extractCode) {
        url += '&extractCode=' + extractCode;
      }
      return url;
    },
    copyText: function copyText(text) {
      var input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$Message.success('已复制');
      } catch (e) {
        this.$Message.error('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },
    chooseUpload: function chooseUpload() {
      if (!this.canUpload) {
        return;
      }
      this.resumeSession = null;
      this.pendingParentId = this.currentFolder ? this.currentFolder.id : 0;
      if (!this.uploading && !this.scanning) {
        this._uploadQueue = [];
        this.uploadPage = 1;
        this.uploadWaiting = 0;
        this.scanCount = 0;
        this._uploadFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
        this._uploadSeen = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
        this.commitQueue();
      }
      this.showUploadModal = true;
    },
    pickFiles: function pickFiles() {
      if (this.scanning) {
        return;
      }
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    pickFolder: function pickFolder() {
      if (this.scanning) {
        return;
      }
      this.$refs.folderInput.value = '';
      this.$refs.folderInput.click();
    },
    resumeUpload: function resumeUpload(row) {
      this.resumeSession = row;
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    onDropFiles: function onDropFiles(event) {
      var items = event.dataTransfer && event.dataTransfer.items;
      if (items && items.length && items[0].webkitGetAsEntry) {
        var self = this;
        var pending = [];
        for (var i = 0; i < items.length; i++) {
          var entry = items[i].webkitGetAsEntry();
          if (entry) {
            pending.push(this.readDroppedEntry(entry, ''));
          }
        }
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(pending).then(function (groups) {
          var files = [];
          groups.forEach(function (group) {
            files = files.concat(group);
          });
          self.addQueuedFiles(files);
        });
        return;
      }
      this.addQueuedFiles(event.dataTransfer ? event.dataTransfer.files : []);
    },
    readDroppedEntry: function readDroppedEntry(entry, dir) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (entry.isFile) {
          entry.file(function (file) {
            file._diskDir = dir;
            resolve([file]);
          }, function () {
            resolve([]);
          });
          return;
        }
        if (!entry.isDirectory) {
          resolve([]);
          return;
        }
        var reader = entry.createReader();
        var nextDir = dir ? dir + '/' + entry.name : entry.name;
        var all = [];
        var readBatch = function readBatch() {
          reader.readEntries(function (entries) {
            if (!entries.length) {
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(all).then(function (groups) {
                var files = [];
                groups.forEach(function (group) {
                  files = files.concat(group);
                });
                resolve(files);
              });
              return;
            }
            for (var i = 0; i < entries.length; i++) {
              all.push(self.readDroppedEntry(entries[i], nextDir));
            }
            readBatch();
          }, function () {
            resolve([]);
          });
        };
        readBatch();
      });
    },
    onFilePicked: function onFilePicked(event) {
      var picked = event.target.files;
      var files = [];
      if (picked) {
        for (var i = 0; i < picked.length; i++) {
          files.push(picked[i]);
        }
      }
      var resume = this.resumeSession;
      this.resumeSession = null;
      event.target.value = '';
      if (!files.length) {
        return;
      }
      if (resume) {
        var file = files[0];
        if (file.size !== resume.fileSize) {
          this.$Message.warning('请选择与原任务相同的文件');
          return;
        }
        this.resumeTask(resume, file);
        return;
      }
      this.addQueuedFiles(files);
    },
    addQueuedFiles: function addQueuedFiles(files) {
      if (!files || !files.length) {
        return;
      }
      if (!this._scanWait) {
        this._scanWait = [];
      }
      this._scanWait.push(files);
      this.showUploadModal = true;
      if (!this.scanning) {
        this._rejectedNames = 0;
        this.scanNext();
      }
    },
    scanNext: function scanNext() {
      if (!this._scanWait || !this._scanWait.length) {
        this.scanning = false;
        if (this._rejectedNames) {
          this.$Message.warning('已跳过 ' + this._rejectedNames + ' 个不符合命名规范的文件');
          this._rejectedNames = 0;
        }
        return;
      }
      var files = this._scanWait.shift();
      this.scanning = true;
      this.scanChunk(files, 0, []);
    },
    scanChunk: function scanChunk(files, index, batch) {
      var self = this;
      if (!self._uploadFiles) {
        self._uploadFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
      }
      if (!self._uploadSeen) {
        self._uploadSeen = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
      }
      var limit = 10000;
      var end = Math.min(index + 400, files.length);
      var stop = false;
      for (var i = index; i < end; i++) {
        if ((self._uploadQueue ? self._uploadQueue.length : 0) + batch.length >= limit) {
          stop = true;
          break;
        }
        var file = files[i];
        if (!file || file.name === '.DS_Store') {
          continue;
        }
        var rel = file._diskDir != null ? file._diskDir : file.webkitRelativePath || '';
        var dir = '';
        if (file._diskDir != null) {
          dir = file._diskDir;
        } else if (rel && rel.indexOf('/') >= 0) {
          dir = rel.substring(0, rel.lastIndexOf('/'));
        }
        if (!self.validUploadName(file.name) || !self.validUploadDir(dir)) {
          self._rejectedNames = (self._rejectedNames || 0) + 1;
          continue;
        }
        var identity = (dir || '/') + '/' + file.name + ':' + file.size;
        if (self._uploadSeen[identity]) {
          continue;
        }
        self._uploadSeen[identity] = 1;
        var typeName = file.type || '';
        if (!typeName && file.name.indexOf('.') > 0) {
          typeName = file.name.split('.').pop();
        }
        var key = identity + ':' + i;
        self._uploadFiles[key] = file;
        batch.push({
          key: key,
          identity: identity,
          name: file.name,
          dir: dir || '/',
          typeName: typeName || '-',
          size: file.size,
          percent: 0,
          statusText: '等待上传'
        });
      }
      self.scanCount = (self._uploadQueue ? self._uploadQueue.length : 0) + batch.length;
      if (!stop && end < files.length) {
        setTimeout(function () {
          self.scanChunk(files, end, batch);
        }, 0);
        return;
      }
      if (batch.length) {
        if (!self._uploadQueue) {
          self._uploadQueue = [];
        }
        self._uploadQueue = self._uploadQueue.concat(batch);
        self.uploadWaiting += batch.length;
      }
      self.commitQueue();
      if (stop) {
        self._scanWait = [];
        self.$Message.warning('待上传列表最多允许添加 10000 个文件，超出部分被丢弃，如果要完整上传，请将文件打包成 Zip 包，上传后解压。');
      }
      self.scanNext();
    },
    validUploadName: function validUploadName(name) {
      if (!name || name === '.' || name === '..' || name.indexOf('/') >= 0 || name.indexOf('\\') >= 0) {
        return false;
      }
      var bytes = void 0;
      try {
        bytes = new TextEncoder().encode(name);
      } catch (e) {
        return false;
      }
      if (bytes.length < 1 || bytes.length > 1023) {
        return false;
      }
      try {
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes) === name;
      } catch (e) {
        return false;
      }
    },
    validUploadDir: function validUploadDir(dir) {
      if (!dir) {
        return true;
      }
      var parts = String(dir).split(/[/\\]/);
      for (var i = 0; i < parts.length; i++) {
        if (!parts[i]) {
          continue;
        }
        if (!this.validUploadName(parts[i])) {
          return false;
        }
      }
      return true;
    },
    commitQueue: function commitQueue() {
      var list = this._uploadQueue || [];
      this.uploadTotal = list.length;
      var maxPage = Math.max(1, Math.ceil(list.length / this.uploadPageSize) || 1);
      if (this.uploadPage > maxPage) {
        this.uploadPage = maxPage;
      }
      this.uploadStamp++;
    },
    removeQueued: function removeQueued(row) {
      if (this._uploadFiles) {
        delete this._uploadFiles[row.key];
      }
      if (this._uploadSeen && row.identity) {
        delete this._uploadSeen[row.identity];
      }
      if (row.statusText === '等待上传' && this.uploadWaiting > 0) {
        this.uploadWaiting--;
      }
      this._uploadQueue = (this._uploadQueue || []).filter(function (item) {
        return item.key !== row.key;
      });
      this.commitQueue();
    },
    onUploadPage: function onUploadPage(page) {
      this.uploadPage = page;
    },
    markQueueFailed: function markQueueFailed(item) {
      if (item.statusText === '等待上传' && this.uploadWaiting > 0) {
        this.uploadWaiting--;
      }
      item.statusText = this.uploadHalt ? '已停止' : '上传失败';
      this.touchQueue(item);
      if (item.statusText === '上传失败') {
        this.abortFailedSession(item);
      }
    },
    touchQueue: function touchQueue(task) {
      var now = new Date().getTime();
      var done = task && (task.statusText === '已完成' || task.statusText === '上传失败' || task.statusText === '合并失败' || task.statusText === '已停止');
      if (!done && this._touchAt && now - this._touchAt < 200) {
        return;
      }
      this._touchAt = now;
      this.uploadStamp++;
    },
    taskState: function taskState(statusText) {
      if (statusText === '上传中' || statusText === '续传中') {
        return { key: 'uploading', label: '上传中' };
      }
      if (statusText === '已停止') {
        return { key: 'stopped', label: '已停止' };
      }
      if (statusText === '已完成') {
        return { key: 'success', label: '上传成功' };
      }
      return { key: 'failed', label: '上传失败' };
    },
    stopUploads: function stopUploads() {
      var self = this;
      self.uploadHalt = true;
      self.stopSmartConcurrencyAdapt();
      self._uploadPoolNext = null;(self._uploadXhrs || []).forEach(function (xhr) {
        try {
          xhr.abort();
        } catch (e) {}
      });
      self._uploadXhrs = [];(self._uploadQueue || []).forEach(function (item) {
        if (item.statusText === '上传中' || item.statusText === '续传中' || item.statusText === '等待上传') {
          if (item.statusText === '等待上传' && self.uploadWaiting > 0) {
            self.uploadWaiting--;
          }
          item.statusText = '已停止';
        }
      });
      self.uploading = false;
      self.showUploadModal = false;
      self.commitQueue();
    },
    clearTask: function clearTask(item) {
      var task = item.queueKey ? this.queueByKey(item.queueKey) : null;
      if (task) {
        task.paused = true;
        task.runId = (task.runId || 0) + 1;
        this.abortTaskXhrs(task.key);
        if (this._uploadFiles) {
          delete this._uploadFiles[task.key];
        }
      }
      var sessionId = item.session && item.session.sessionId || (task && item.state !== 'success' ? task.sessionId : null);
      if (sessionId && item.state !== 'success') {
        this.pendingSessions = this.pendingSessions.filter(function (session) {
          return session.sessionId !== sessionId;
        });
        this.$http.post('/disk/upload/abort', { sessionId: sessionId });
      }
      if (item.queueKey) {
        this._uploadQueue = (this._uploadQueue || []).filter(function (row) {
          return row.key !== item.queueKey;
        });
        this.uploadTotal = this._uploadQueue.length;
      }
      this.commitQueue();
    },
    clearAllTasks: function clearAllTasks() {
      var self = this;
      if (self.taskFilter === 'uploading') {
        return;
      }
      var list = self.taskView.filter(function (item) {
        return item.state === 'stopped' || item.state === 'failed' || item.state === 'success';
      });
      if (!list.length) {
        return;
      }

      list.slice().forEach(function (item) {
        self.clearTask(item);
      });
    },
    queueByKey: function queueByKey(key) {
      var list = this._uploadQueue || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].key === key) {
          return list[i];
        }
      }
      return null;
    },
    abortTaskXhrs: function abortTaskXhrs(key) {
      ;(this._uploadXhrs || []).forEach(function (xhr) {
        if (key && xhr._diskKey !== key) {
          return;
        }
        try {
          xhr.abort();
        } catch (e) {}
      });
    },
    pauseUpload: function pauseUpload(item) {
      var task = this.queueByKey(item.queueKey);
      if (!task) {
        return;
      }
      task.paused = true;
      task.runId = (task.runId || 0) + 1;
      this.abortTaskXhrs(task.key);
      task.statusText = '已停止';
      this.touchQueue(task);
    },
    finishStoppedOrFailed: function finishStoppedOrFailed(task, runId) {
      if (!task || task.runId !== runId) {
        return;
      }
      this.releaseSignedSlot(task);
      task.statusText = task.paused || this.uploadHalt ? '已停止' : '上传失败';
      this.touchQueue(task);

      if (task.statusText === '上传失败') {
        this.abortFailedSession(task);
      }
    },
    abortFailedSession: function abortFailedSession(task) {
      if (!task || !task.sessionId) {
        return;
      }
      var sessionId = task.sessionId;
      task.sessionId = null;
      task.mode = null;
      this.$http.post('/disk/upload/abort', { sessionId: sessionId }, { silent: true }).catch(function () {});
    },
    continueUpload: function continueUpload(item) {
      var self = this;
      if (item.session && !item.queueKey) {
        self.resumeUpload(item.session);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      var task = self.queueByKey(item.queueKey);
      if (!task) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      var file = self._uploadFiles && self._uploadFiles[task.key];
      if (!file) {
        if (task.sessionId) {
          self.resumeUpload({
            sessionId: task.sessionId,
            nodeId: task.nodeId,
            name: task.name,
            fileSize: task.size,
            partSize: task.partSize || 0,
            donePartNumbers: task.donePartNumbers || []
          });
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        }
        self.$Message.warning('原文件已不在，请重新选择');
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      self.uploadHalt = false;
      task.paused = false;
      if (task.sessionId && task.mode === 'multipart') {
        return self.resumeQueueMultipart(task, file);
      }
      if (task.sessionId && task.mode === 'single') {
        return self.$http.post('/disk/upload/abort', { sessionId: task.sessionId }).then(function () {
          task.sessionId = null;
          task.mode = null;
          return self.startUpload(file, task.parentId, task);
        }).catch(function () {
          task.statusText = '上传失败';
          self.touchQueue(task);
        });
      }
      var root = task.parentId || self.pendingParentId;
      var dir = !task.parentId && task.dir && task.dir !== '/' ? task.dir : '';
      return self.ensureDir(root, dir, {}).then(function (parentId) {
        return self.startUpload(file, parentId, task);
      }).catch(function () {
        task.statusText = '上传失败';
        self.touchQueue(task);
      });
    },
    resumeQueueMultipart: function resumeQueueMultipart(task, file) {
      var self = this;
      task.paused = false;
      task.runId = (task.runId || 0) + 1;
      var runId = task.runId;
      task.statusText = '续传中';
      self.touchQueue(task);
      return self.uploadMultipart(task, file, task.partSize, task.partCount, task.donePartNumbers || []).catch(function () {
        self.finishStoppedOrFailed(task, runId);
      });
    },
    startAllUploads: function startAllUploads() {
      var self = this;
      if (self.uploading) {
        return;
      }
      var resumeItems = self.taskItems.filter(function (item) {
        if (item.state !== 'stopped' && item.state !== 'failed') {
          return false;
        }
        if (!item.queueKey) {
          return false;
        }
        var task = self.queueByKey(item.queueKey);
        return !!(task && self._uploadFiles && self._uploadFiles[task.key]);
      });
      var waiting = (self._uploadQueue || []).filter(function (item) {
        return item.statusText === '等待上传';
      });
      if (!resumeItems.length && !waiting.length) {
        return;
      }
      var autoItems = waiting.slice();
      resumeItems.forEach(function (item) {
        var task = self.queueByKey(item.queueKey);
        if (task) {
          autoItems.push(task);
        }
      });
      self.initSmartConcurrency(autoItems);
      self._signedLive = 0;
      self._initWaiters = [];
      self._completeBuffer = [];
      self.uploadHalt = false;
      self._uploadPoolNext = null;
      self.uploading = true;
      self.taskPanelOpen = true;
      self.startSmartConcurrencyAdapt();
      var destBase = self.currentFolder ? self.currentFolder.name : '';
      waiting.forEach(function (item) {
        var dir = item.dir && item.dir !== '/' ? item.dir : '';
        item.dest = dir ? destBase + '/' + dir : destBase || '/';
      });
      var work = [];
      resumeItems.forEach(function (item) {
        work.push({ kind: 'resume', item: item });
      });
      waiting.forEach(function (item) {
        work.push({ kind: 'waiting', item: item });
      });
      var cache = {};
      var index = 0;
      var active = 0;
      var settled = 0;
      var total = work.length;
      var finished = false;
      var markStoppedWaiting = function markStoppedWaiting(item) {
        if (item.statusText === '等待上传') {
          if (self.uploadWaiting > 0) {
            self.uploadWaiting--;
          }
          item.statusText = '已停止';
          self.touchQueue(item);
        }
      };
      var finishPool = function finishPool() {
        if (finished) {
          return;
        }
        if (settled >= total && active === 0) {
          finished = true;
          self._uploadPoolNext = null;
          self.stopSmartConcurrencyAdapt();
          self.uploading = false;
          self.showUploadModal = false;
          self.loadList();
        }
      };
      var runOne = function runOne(job) {
        if (self.uploadHalt) {
          if (job.kind === 'waiting') {
            markStoppedWaiting(job.item);
          }
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        }
        if (job.kind === 'resume') {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(self.continueUpload(job.item)).catch(function () {});
        }
        var item = job.item;
        var dir = item.dir === '/' ? '' : item.dir;
        return self.ensureDir(self.pendingParentId, dir, cache).then(function (parentId) {
          if (self.uploadHalt) {
            markStoppedWaiting(item);
            return;
          }
          var file = self._uploadFiles ? self._uploadFiles[item.key] : null;
          if (!file) {
            self.markQueueFailed(item);
            return;
          }
          return self.startUpload(file, parentId, item);
        }).catch(function () {
          self.markQueueFailed(item);
        });
      };
      var next = function next() {
        if (finished) {
          return;
        }
        if (self.uploadHalt) {
          while (index < total) {
            var left = work[index];
            index++;
            settled++;
            if (left.kind === 'waiting') {
              markStoppedWaiting(left.item);
            }
          }
          finishPool();
          return;
        }
        var limit = self.clampSmartConcurrency(self.uploadConcurrency);

        var _loop = function _loop() {
          var job = work[index];
          index++;
          active++;
          runOne(job).then(function () {
            active--;
            settled++;
            var tracked = job.kind === 'waiting' ? job.item : self.queueByKey(job.item && job.item.queueKey);
            self.noteSmartFileResult(tracked || job.item);
            if (settled >= total) {
              finishPool();
            } else {
              next();
            }
          });
        };

        while (active < limit && index < total && !self.uploadHalt) {
          _loop();
        }
        if (self.uploadHalt) {
          next();
        }
      };
      var waitingForWarm = [];
      work.forEach(function (job) {
        if (job && job.kind === 'waiting' && job.item) {
          waitingForWarm.push(job.item);
        }
      });
      self._warmItems = waitingForWarm;
      self._warmCache = cache;
      self._warmRootParentId = self.pendingParentId;
      self._uploadPoolNext = function () {
        self.warmUploadWindow(waitingForWarm, cache, self.pendingParentId);
        next();
      };
      self.warmUploadWindow(waitingForWarm, cache, self.pendingParentId);
      next();
    },
    clearPersistedUploadConcurrency: function clearPersistedUploadConcurrency() {
      try {
        window.localStorage.removeItem('disk_upload_concurrency');
      } catch (e) {}
    },
    clampSmartConcurrency: function clampSmartConcurrency(n) {
      n = parseInt(n, 10);
      if (isNaN(n)) {
        return 6;
      }
      if (n < 2) {
        return 2;
      }
      if (n > 20) {
        return 20;
      }
      return n;
    },
    pickFileConcurrency: function pickFileConcurrency(files) {
      var list = files || [];
      var n = list.length;
      if (!n) {
        return { fileConc: 6, tinyRatio: 0, smallRatio: 0, largeRatio: 0, largeByteShare: 0, avg: 0 };
      }
      var tinyLimit = 256 * 1024;
      var smallLimit = 8 * 1024 * 1024;
      var largeLimit = 100 * 1024 * 1024;
      var totalBytes = 0;
      var tinyCount = 0;
      var smallCount = 0;
      var largeCount = 0;
      var largeBytes = 0;
      for (var i = 0; i < n; i++) {
        var size = Number(list[i] && list[i].size) || 0;
        totalBytes += size;
        if (size < tinyLimit) {
          tinyCount++;
        }
        if (size < smallLimit) {
          smallCount++;
        }
        if (size >= largeLimit) {
          largeCount++;
          largeBytes += size;
        }
      }
      var avg = totalBytes / n;
      var tinyRatio = tinyCount / n;
      var smallRatio = smallCount / n;
      var largeRatio = largeCount / n;
      var largeByteShare = totalBytes > 0 ? largeBytes / totalBytes : 0;
      var fileConc = void 0;
      if (largeByteShare >= 0.7 || largeRatio >= 0.5) {
        fileConc = 3;
      } else if (n >= 2000 || n >= 200 && tinyRatio >= 0.7) {
        fileConc = 16;
      } else if (n >= 200 || tinyRatio >= 0.7 || avg < 512 * 1024) {
        fileConc = 12;
      } else if (smallRatio >= 0.7 || avg < 8 * 1024 * 1024) {
        fileConc = 8;
      } else {
        fileConc = 6;
      }
      return {
        fileConc: fileConc,
        tinyRatio: tinyRatio,
        smallRatio: smallRatio,
        largeRatio: largeRatio,
        largeByteShare: largeByteShare,
        avg: avg
      };
    },
    pickPartConcurrency: function pickPartConcurrency(fileSize, partSize) {
      var size = Number(fileSize) || 0;
      if (size < 8 * 1024 * 1024) {
        return 1;
      }
      if (size >= 100 * 1024 * 1024) {
        return 6;
      }
      return 5;
    },
    initSmartConcurrency: function initSmartConcurrency(items) {
      var self = this;
      this.clearPersistedUploadConcurrency();
      var picked = this.pickFileConcurrency(items);
      var n = this.clampSmartConcurrency(picked.fileConc);
      this.uploadConcurrency = n;
      this._smartConc = {
        target: n,
        tinyRatio: picked.tinyRatio || 0,
        windowStartAt: new Date().getTime(),
        windowBytesStart: this.taskOverallDone || 0,
        windowDone: 0,
        windowFail: 0,
        windowThrottle: false
      };
      this.uploadAutoHint = '智能调节';
      if (this._uploadAutoHintTimer) {
        clearTimeout(this._uploadAutoHintTimer);
      }
      this._uploadAutoHintTimer = setTimeout(function () {
        self.uploadAutoHint = '';
        self._uploadAutoHintTimer = null;
      }, 2500);
      return n;
    },
    startSmartConcurrencyAdapt: function startSmartConcurrencyAdapt() {
      var self = this;
      this.stopSmartConcurrencyAdapt();
      this._smartAdaptTimer = setInterval(function () {
        self.maybeAdaptFileConcurrency(true);
      }, 3000);
    },
    stopSmartConcurrencyAdapt: function stopSmartConcurrencyAdapt() {
      if (this._smartAdaptTimer) {
        clearInterval(this._smartAdaptTimer);
        this._smartAdaptTimer = null;
      }
    },
    noteSmartFileResult: function noteSmartFileResult(item) {
      var s = this._smartConc;
      if (!s || !item) {
        return;
      }
      var st = item.statusText || '';
      if (st === '已停止') {
        return;
      }
      s.windowDone++;
      if (st === '上传失败' || st === '合并失败') {
        s.windowFail++;
        var msg = String(item.failMsg || '');
        if (msg.indexOf('429') >= 0 || msg.indexOf('503') >= 0) {
          s.windowThrottle = true;
        }
      }
      if (s.windowDone >= 20) {
        this.maybeAdaptFileConcurrency(false);
      }
    },
    maybeAdaptFileConcurrency: function maybeAdaptFileConcurrency(byTimer) {
      var s = this._smartConc;
      if (!s || !this.uploading) {
        return;
      }
      var now = new Date().getTime();
      var enoughFiles = s.windowDone >= 20;
      var enoughTime = now - s.windowStartAt >= 3000;
      if (!enoughFiles && !enoughTime) {
        return;
      }
      if (s.windowDone < 3 && !s.windowThrottle) {
        return;
      }
      var failRate = s.windowDone > 0 ? s.windowFail / s.windowDone : 0;
      var bytesNow = this.taskOverallDone || 0;
      var dt = Math.max(0.001, (now - s.windowStartAt) / 1000);
      var speed = (bytesNow - s.windowBytesStart) / dt;
      var cur = this.clampSmartConcurrency(this.uploadConcurrency);
      var next = cur;
      if (failRate >= 0.15 || s.windowThrottle) {
        next = Math.max(2, Math.floor(cur / 2));
      } else if (speed < 200 * 1024 && s.tinyRatio >= 0.5 && failRate < 0.05) {
        next = Math.min(20, cur + 2);
      } else if (failRate < 0.05 && cur < s.target) {
        next = Math.min(s.target, cur + 1);
      }
      next = this.clampSmartConcurrency(next);
      s.windowStartAt = now;
      s.windowBytesStart = bytesNow;
      s.windowDone = 0;
      s.windowFail = 0;
      s.windowThrottle = false;
      if (next !== cur) {
        this.uploadConcurrency = next;
        if (typeof this._uploadPoolNext === 'function') {
          this._uploadPoolNext();
        }
      }
    },
    partUploadConcurrency: function partUploadConcurrency(file, partSize) {
      var size = file && file.size ? Number(file.size) : 0;
      return this.pickPartConcurrency(size, partSize);
    },
    beginUpload: function beginUpload() {
      var self = this;
      var waiting = (self._uploadQueue || []).filter(function (item) {
        return item.statusText === '等待上传';
      });
      if (!waiting.length || self.uploading) {
        return;
      }
      self.initSmartConcurrency(waiting);
      self._signedLive = 0;
      self._initWaiters = [];
      self._completeBuffer = [];
      self.uploading = true;
      self.uploadHalt = false;
      self.taskPanelOpen = true;
      self.startSmartConcurrencyAdapt();
      var destBase = self.currentFolder ? self.currentFolder.name : '';
      waiting.forEach(function (item) {
        var dir = item.dir && item.dir !== '/' ? item.dir : '';
        item.dest = dir ? destBase + '/' + dir : destBase || '/';
      });
      var cache = {};
      var index = 0;
      var active = 0;
      var settled = 0;
      var total = waiting.length;
      var finished = false;
      var markStoppedWaiting = function markStoppedWaiting(item) {
        if (item.statusText === '等待上传') {
          if (self.uploadWaiting > 0) {
            self.uploadWaiting--;
          }
          item.statusText = '已停止';
          self.touchQueue(item);
        }
      };
      var finishPool = function finishPool() {
        if (finished) {
          return;
        }
        if (settled >= total && active === 0) {
          finished = true;
          self._uploadPoolNext = null;
          self.stopSmartConcurrencyAdapt();
          self.uploading = false;
          self.showUploadModal = false;
          self.loadList();
        }
      };
      var runOne = function runOne(item) {
        if (self.uploadHalt) {
          markStoppedWaiting(item);
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        }
        var dir = item.dir === '/' ? '' : item.dir;
        return self.ensureDir(self.pendingParentId, dir, cache).then(function (parentId) {
          if (self.uploadHalt) {
            markStoppedWaiting(item);
            return;
          }
          var file = self._uploadFiles ? self._uploadFiles[item.key] : null;
          if (!file) {
            self.markQueueFailed(item);
            return;
          }
          return self.startUpload(file, parentId, item);
        }).catch(function () {
          self.markQueueFailed(item);
        });
      };
      var next = function next() {
        if (finished) {
          return;
        }
        if (self.uploadHalt) {
          while (index < total) {
            markStoppedWaiting(waiting[index]);
            index++;
            settled++;
          }
          finishPool();
          return;
        }
        var limit = self.clampSmartConcurrency(self.uploadConcurrency);

        var _loop2 = function _loop2() {
          var item = waiting[index];
          index++;
          active++;
          runOne(item).then(function () {
            active--;
            settled++;
            self.noteSmartFileResult(item);
            if (settled >= total) {
              finishPool();
            } else {
              next();
            }
          });
        };

        while (active < limit && index < total && !self.uploadHalt) {
          _loop2();
        }
        if (self.uploadHalt) {
          next();
        }
      };
      self._warmItems = waiting;
      self._warmCache = cache;
      self._warmRootParentId = self.pendingParentId;
      self._uploadPoolNext = function () {
        self.warmUploadWindow(waiting, cache, self.pendingParentId);
        next();
      };
      self.warmUploadWindow(waiting, cache, self.pendingParentId);
      next();
    },
    ensureDir: function ensureDir(rootId, dir, cache) {
      if (!dir) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(rootId);
      }
      var self = this;
      var parts = dir.split('/');
      var walk = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(rootId);
      var acc = '';
      parts.forEach(function (name) {
        walk = walk.then(function (parentId) {
          acc = acc ? acc + '/' + name : name;
          if (cache[acc]) {
            return cache[acc];
          }
          cache[acc] = self.findOrMkdir(parentId, name).then(function (id) {
            return id;
          }, function (err) {
            delete cache[acc];
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
          });
          return cache[acc];
        });
      });
      return walk;
    },
    findOrMkdir: function findOrMkdir(parentId, name) {
      var self = this;
      return self.$http.get('/disk/list', { params: { parentId: parentId } }).then(function (res) {
        var list = res && res.status === 'ok' && res.data ? res.data : [];
        for (var i = 0; i < list.length; i++) {
          if (list[i].nodeType === 1 && list[i].name === name) {
            return list[i].id;
          }
        }
        return self.$http.post('/disk/mkdir', { parentId: parentId, name: name }).then(function (created) {
          if (created && created.status === 'ok' && created.data != null) {
            return created.data;
          }
          return self.$http.get('/disk/list', { params: { parentId: parentId } }).then(function (again) {
            var rows = again && again.status === 'ok' && again.data ? again.data : [];
            for (var j = 0; j < rows.length; j++) {
              if (rows[j].nodeType === 1 && rows[j].name === name) {
                return rows[j].id;
              }
            }
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('mkdir'));
          });
        });
      });
    },
    startUpload: function startUpload(file, parentId, queued, preInit) {
      var self = this;
      var item = queued;
      var runId = 0;
      if (item) {
        if (item.statusText === '等待上传' && self.uploadWaiting > 0) {
          self.uploadWaiting--;
        }
        item.parentId = parentId;
        item.paused = false;
        item.runId = (item.runId || 0) + 1;
        runId = item.runId;
        item.statusText = '上传中';
        item.percent = 0;
        self.touchQueue(item);
      }
      var initPromise = void 0;
      var cached = preInit || item && item._preInit;
      if (cached && cached.ok !== false && cached.sessionId) {
        initPromise = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve({ status: 'ok', data: cached });
      } else if (item && item._preInitPromise) {
        initPromise = item._preInitPromise.then(function (data) {
          return { status: 'ok', data: data };
        });
      } else if (item) {
        initPromise = self.warmUploadInit(item, parentId, file).then(function (data) {
          return { status: 'ok', data: data };
        });
      } else {
        initPromise = self.$http.post('/disk/upload/init', {
          parentId: parentId,
          fileName: file.name,
          size: file.size,
          mime: file.type || 'application/octet-stream',
          overwrite: self.overwriteSame ? 1 : 0
        }, { silent: true });
      }
      return initPromise.then(function (res) {
        if (item && item.runId !== runId) {
          return;
        }
        if (!res || res.status !== 'ok' || !res.data || res.data.ok === false) {
          if (item) {
            item.failMsg = res && res.data && res.data.error || res && res.msg || '初始化失败';
          }
          self.finishStoppedOrFailed(item, runId);
          return;
        }
        self.showUploadModal = false;
        var data = res.data;
        var task = item || {
          key: data.sessionId + '-' + new Date().getTime(),
          name: file.name,
          dir: '/',
          typeName: file.type || '-',
          size: file.size,
          percent: 0,
          statusText: '上传中',
          parentId: parentId,
          paused: false,
          runId: 1
        };
        if (!item) {
          runId = task.runId;
        }
        task.nodeId = data.nodeId;
        task.sessionId = data.sessionId;
        task.mode = data.mode;
        task.partSize = data.partSize;
        task.partCount = data.partCount;
        task.parentId = parentId;
        task.donePartNumbers = [];
        task.putUrl = data.url || '';
        task.urlSignedAt = data.url ? Date.now() : 0;
        task.urlExpireSeconds = Number(data.expireSeconds) || 7200;
        if (data.fileName) {
          task.name = data.fileName;
          self.commitQueue();
        }
        task.statusText = '上传中';
        if (!item) {
          if (!self._uploadQueue) {
            self._uploadQueue = [];
          }
          self._uploadQueue.push(task);
          self.commitQueue();
          self.taskPanelOpen = true;
        }
        if (data.mode === 'single') {
          return self.ensureFreshPutUrl(task).then(function (url) {
            return self.putPartRetry(url, file, function (loaded) {
              var percent = file.size ? Math.floor(loaded * 100 / file.size) : 100;
              if (percent > task.percent) {
                task.percent = percent > 99 ? 99 : percent;
                self.touchQueue(task);
              }
            }, 1, task);
          }).then(function () {
            if (task.runId !== runId || task.paused) {
              return;
            }
            self.releaseSignedSlot(task);
            return self.completeUpload(task);
          }).catch(function (err) {
            self.releaseSignedSlot(task);
            if (task && err && err.message) {
              task.failMsg = err.message;
            }
            self.finishStoppedOrFailed(task, runId);
          });
        }
        return self.uploadMultipart(task, file, data.partSize, data.partCount, []).then(function () {
          self.releaseSignedSlot(task);
        }).catch(function (err) {
          self.releaseSignedSlot(task);
          if (task && err && err.message) {
            task.failMsg = err.message;
          }
          self.finishStoppedOrFailed(task, runId);
        });
      }).catch(function (err) {
        if (item && err && err.message && err.message !== 'stopped') {
          item.failMsg = err.message;
        }
        self.finishStoppedOrFailed(item, runId);
      });
    },
    loadPending: function loadPending() {
      var self = this;
      self.$http.get('/disk/upload/pending').then(function (res) {
        if (res && res.status === 'ok') {
          self.pendingSessions = res.data || [];
        }
      });
    },
    cancelPending: function cancelPending(session) {
      var self = this;
      self.$Modal.confirm({
        title: '取消上传',
        content: '取消后这个未完成任务会被清掉，云上不会留下半截文件。',
        onOk: function onOk() {
          self.$http.post('/disk/upload/abort', { sessionId: session.sessionId }).then(function () {
            self.loadPending();
          });
        }
      });
    },
    resumeTask: function resumeTask(session, file) {
      var self = this;
      self.uploadHalt = false;
      var partSize = Number(session.partSize) || 0;
      var partCount = partSize > 0 ? Math.ceil(session.fileSize / partSize) : 1;
      if (partSize > 0 && partCount > 1) {
        var task = {
          key: session.sessionId,
          nodeId: session.nodeId,
          sessionId: session.sessionId,
          name: session.name,
          dir: '/',
          typeName: '-',
          size: session.fileSize,
          mode: 'multipart',
          partSize: partSize,
          partCount: partCount,
          percent: 0,
          statusText: '续传中'
        };
        if (!self._uploadQueue) {
          self._uploadQueue = [];
        }
        self._uploadQueue.push(task);
        self.commitQueue();
        self.taskPanelOpen = true;
        self.uploadMultipart(task, file, partSize, partCount, session.donePartNumbers || []).catch(function () {
          task.statusText = self.uploadHalt ? '已停止' : '上传失败';
          self.touchQueue(task);
        });
        return;
      }
      self.$http.post('/disk/upload/abort', { sessionId: session.sessionId }).then(function () {
        self.startUpload(file, self.currentFolder ? self.currentFolder.id : 0);
      });
    },
    putPart: function putPart(url, blob, onProgress, taskKey) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr._diskKey = taskKey || '';
        self._uploadXhrs = self._uploadXhrs || [];
        self._uploadXhrs.push(xhr);
        var finish = function finish() {
          self._uploadXhrs = (self._uploadXhrs || []).filter(function (item) {
            return item !== xhr;
          });
        };
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.upload.onprogress = function (event) {
          if (event.lengthComputable && onProgress) {
            onProgress(event.loaded);
          }
        };
        xhr.onload = function () {
          finish();
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr);
          } else {
            reject(new Error('上传失败：' + xhr.status));
          }
        };
        xhr.onerror = function () {
          finish();

          reject(new Error('上传失败(网络或CORS)'));
        };
        xhr.onabort = function () {
          finish();
          reject(new Error('stopped'));
        };
        xhr.send(blob);
      });
    },
    putPartRetry: function putPartRetry(url, blob, onProgress, attempt, task) {
      var self = this;
      if (self.uploadHalt || task && task.paused) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
      }
      return self.putPart(url, blob, onProgress, task && task.key).catch(function (error) {
        if (self.uploadHalt || task && task.paused || !error || error.message === 'stopped' || attempt >= 3) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
        }
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(resolve, 800 * attempt);
        }).then(function () {
          return self.putPartRetry(url, blob, onProgress, attempt + 1, task);
        });
      });
    },
    sendPart: function sendPart(task, file, partSize, item, attempt, partLoaded, updatePercent) {
      var self = this;
      if (self.uploadHalt || task.paused) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
      }
      var partNumber = item.partNumber;
      var start = (partNumber - 1) * partSize;
      var end = Math.min(start + partSize, file.size);
      var blob = file.slice(start, end);
      return self.putPart(item.url, blob, function (loaded) {
        partLoaded[partNumber] = loaded;
        updatePercent();
      }, task.key).then(function (xhr) {
        delete partLoaded[partNumber];
        var etag = xhr.getResponseHeader('ETag') || '';
        return self.$http.post('/disk/upload/partDone', {
          sessionId: task.sessionId,
          partNumber: partNumber,
          etag: etag
        }).then(function (res) {
          if (!res || res.status !== 'ok') {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('分片记录失败'));
          }
          if (!task.donePartNumbers) {
            task.donePartNumbers = [];
          }
          if (task.donePartNumbers.indexOf(partNumber) < 0) {
            task.donePartNumbers.push(partNumber);
          }
          return blob.size;
        });
      }).catch(function (error) {
        delete partLoaded[partNumber];
        if (updatePercent) {
          updatePercent();
        }
        if (task.paused || self.uploadHalt || !error || error.message === 'stopped' || attempt >= 3) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
        }
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(resolve, 800 * attempt);
        }).then(function () {
          return self.signParts(task.sessionId, [partNumber]).then(function (signed) {
            var next = signed && signed[0] && signed[0].url ? signed[0] : item;
            return self.sendPart(task, file, partSize, next, attempt + 1, partLoaded, updatePercent);
          });
        });
      });
    },
    signParts: function signParts(sessionId, partNumbers) {
      var self = this;
      var batches = [];
      for (var i = 0; i < partNumbers.length; i += 20) {
        batches.push(partNumbers.slice(i, i + 20));
      }
      var requests = batches.map(function (batch) {
        return self.$http.post('/disk/upload/signParts', {
          sessionId: sessionId,
          partNumbers: batch.join(',')
        }, { silent: true });
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requests).then(function (results) {
        var signed = [];
        results.forEach(function (res) {
          if (res && res.status === 'ok' && res.data) {
            signed = signed.concat(res.data);
          }
        });
        return signed;
      });
    },
    uploadMultipart: function uploadMultipart(task, file, partSize, partCount, donePartNumbers) {
      var self = this;
      partSize = Number(partSize) || file.size;
      partCount = Number(partCount) || Math.ceil(file.size / partSize);
      var doneSet = {};
      var doneParts = donePartNumbers || [];
      doneParts.forEach(function (number) {
        doneSet[number] = true;
      });
      var missing = [];
      var completedBytes = 0;
      for (var number = 1; number <= partCount; number++) {
        if (doneSet[number]) {
          completedBytes += Math.min(partSize, Math.max(file.size - (number - 1) * partSize, 0));
        } else {
          missing.push(number);
        }
      }
      var partLoaded = {};
      var updatePercent = function updatePercent() {
        var sum = completedBytes;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(partLoaded).forEach(function (key) {
          sum += partLoaded[key];
        });
        var percent = Math.floor(sum * 100 / file.size);
        if (percent > 99) {
          percent = 99;
        }
        if (percent > task.percent) {
          task.percent = percent;
          self.touchQueue(task);
        }
      };
      task.percent = Math.floor(completedBytes * 100 / file.size);
      self.touchQueue(task);
      if (!missing.length) {
        if (task.paused || self.uploadHalt) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
        }
        return self.completeUpload(task);
      }
      var concurrency = self.partUploadConcurrency(file, partSize);

      var signBatch = Math.min(20, Math.max(concurrency * 2, 4));
      var batchIndex = 0;
      var uploadOne = function uploadOne(item) {
        return self.sendPart(task, file, partSize, item, 1, partLoaded, updatePercent).then(function (size) {
          completedBytes += size;
          updatePercent();
        });
      };
      var uploadNextBatch = function uploadNextBatch() {
        if (task.paused || self.uploadHalt) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
        }
        if (batchIndex >= missing.length) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        }
        var batch = missing.slice(batchIndex, batchIndex + signBatch);
        batchIndex += signBatch;
        return self.signParts(task.sessionId, batch).then(function (signed) {
          if (task.paused || self.uploadHalt) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
          }
          return self.runWithConcurrency(signed, concurrency, uploadOne);
        }).then(uploadNextBatch);
      };
      return uploadNextBatch().then(function () {
        if (task.paused || self.uploadHalt) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('stopped'));
        }
        task.percent = 100;
        return self.completeUpload(task);
      });
    },
    runWithConcurrency: function runWithConcurrency(items, limit, worker) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!items.length) {
          resolve([]);
          return;
        }
        var index = 0;
        var active = 0;
        var finished = 0;
        var failed = false;
        var next = function next() {
          if (failed) {
            return;
          }
          while (active < limit && index < items.length) {
            var current = index;
            index++;
            active++;
            worker(items[current], current).then(function () {
              active--;
              finished++;
              if (finished === items.length) {
                resolve([]);
              } else {
                next();
              }
            }).catch(function (error) {
              failed = true;
              reject(error);
            });
          }
        };
        next();
      });
    },
    uploadSignWindowSize: function uploadSignWindowSize() {
      return Math.min(this.clampSmartConcurrency(this.uploadConcurrency) * 2, 30);
    },
    postDiskJson: function postDiskJson(url, body) {
      return this.$http.post(url, body, {
        silent: true,
        transformRequest: [function (data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      });
    },
    releaseSignedSlot: function releaseSignedSlot(task) {
      if (task && task._signedCounted) {
        task._signedCounted = false;
        if (this._signedLive > 0) {
          this._signedLive--;
        }
        this.scheduleInitFlush();
        if (this._warmItems) {
          this.warmUploadWindow(this._warmItems, this._warmCache || {}, this._warmRootParentId || this.pendingParentId);
        }
      }
    },
    warmUploadInit: function warmUploadInit(item, parentId, file) {
      var self = this;
      if (!item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('参数错误'));
      }
      if (item._preInit && item._preInit.sessionId && item._preInit.ok !== false) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(item._preInit);
      }
      if (item._preInitPromise) {
        return item._preInitPromise;
      }
      item._preInitPromise = self.enqueueUploadInit(file, parentId, item).then(function (data) {
        item._preInit = data;
        return data;
      }, function (err) {
        item._preInitPromise = null;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
      });
      return item._preInitPromise;
    },
    enqueueUploadInit: function enqueueUploadInit(file, parentId, item) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!self._initWaiters) {
          self._initWaiters = [];
        }
        self._initWaiters.push({
          file: file,
          parentId: parentId,
          item: item,
          resolve: resolve,
          reject: reject
        });
        self.scheduleInitFlush();
      });
    },
    warmUploadWindow: function warmUploadWindow(items, cache, rootParentId) {
      var self = this;
      if (!items || !items.length) {
        return;
      }
      var windowSize = self.uploadSignWindowSize();
      var live = (self._signedLive || 0) + (self._initWaiters && self._initWaiters.length || 0);
      var room = windowSize - live;
      if (room <= 0) {
        return;
      }
      var started = 0;

      var _loop3 = function _loop3(i) {
        var item = items[i];
        if (!item || item.statusText !== '等待上传') {
          return 'continue';
        }
        if (item._preInit || item._preInitPromise || item.sessionId) {
          return 'continue';
        }
        started++;
        var dir = item.dir === '/' ? '' : item.dir;
        self.ensureDir(rootParentId, dir, cache).then(function (parentId) {
          if (self.uploadHalt || item.statusText !== '等待上传') {
            return;
          }
          var file = self._uploadFiles ? self._uploadFiles[item.key] : null;
          if (!file) {
            return;
          }
          item.parentId = parentId;
          return self.warmUploadInit(item, parentId, file);
        }).catch(function () {});
      };

      for (var i = 0; i < items.length && started < room; i++) {
        var _ret3 = _loop3(i);

        if (_ret3 === 'continue') continue;
      }
    },
    scheduleInitFlush: function scheduleInitFlush() {
      var self = this;
      if (self._initFlushTimer) {
        return;
      }
      self._initFlushTimer = setTimeout(function () {
        self._initFlushTimer = null;
        self.flushInitBatch();
      }, 16);
    },
    flushInitBatch: function flushInitBatch() {
      var self = this;
      if (self._initFlushing) {
        return;
      }
      var waiters = self._initWaiters || [];
      if (!waiters.length) {
        return;
      }

      var windowSize = self.uploadSignWindowSize();
      var room = windowSize - (self._signedLive || 0);
      if (room <= 0) {
        return;
      }
      var take = Math.min(50, room, waiters.length);
      var batch = waiters.splice(0, take);
      if (!batch.length) {
        return;
      }
      self._initFlushing = true;
      var payload = {
        overwrite: self.overwriteSame ? 1 : 0,
        items: batch.map(function (entry) {
          return {
            clientKey: entry.item.key,
            parentId: entry.parentId,
            fileName: entry.file.name,
            size: entry.file.size,
            mime: entry.file.type || 'application/octet-stream'
          };
        })
      };
      self.postDiskJson('/disk/upload/initBatch', payload).then(function (res) {
        var rows = res && res.status === 'ok' && res.data ? res.data : [];
        var byKey = {};
        rows.forEach(function (row) {
          if (row && row.clientKey) {
            byKey[row.clientKey] = row;
          }
        });
        var renamed = false;
        batch.forEach(function (entry, idx) {
          var row = byKey[entry.item.key] || rows[idx];
          if (!row || row.ok === false || !row.sessionId) {
            entry.reject(new Error(row && row.error || '初始化失败'));
            return;
          }
          if (row.fileName && entry.item) {
            entry.item.name = row.fileName;
            renamed = true;
          }
          entry.item._signedCounted = true;
          self._signedLive = (self._signedLive || 0) + 1;
          entry.resolve(row);
        });
        if (renamed) {
          self.commitQueue();
        }
      }).catch(function () {
        batch.forEach(function (entry) {
          entry.reject(new Error('初始化失败'));
        });
      }).then(function () {
        self._initFlushing = false;
        if ((self._initWaiters || []).length) {
          self.scheduleInitFlush();
        }
      });
    },
    ensureFreshPutUrl: function ensureFreshPutUrl(task) {
      var self = this;
      if (!task || !task.sessionId) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('参数错误'));
      }
      var expireSeconds = Number(task.urlExpireSeconds) || 7200;
      var halfMs = expireSeconds * 500;
      var age = Date.now() - (task.urlSignedAt || 0);
      if (task.putUrl && age < halfMs) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(task.putUrl);
      }
      return self.$http.post('/disk/upload/signPut', { sessionId: task.sessionId }, { silent: true }).then(function (res) {
        if (!res || res.status !== 'ok' || !res.data || !res.data.url) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res && res.msg || '签名失败'));
        }
        task.putUrl = res.data.url;
        task.urlSignedAt = Date.now();
        task.urlExpireSeconds = Number(res.data.expireSeconds) || expireSeconds;
        return task.putUrl;
      });
    },
    completeUpload: function completeUpload(task) {
      var self = this;
      if (!task || task.paused || self.uploadHalt) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      var runId = task.runId;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!self._completeBuffer) {
          self._completeBuffer = [];
        }
        self._completeBuffer.push({ task: task, runId: runId, resolve: resolve });
        self.scheduleCompleteFlush();
      });
    },
    scheduleCompleteFlush: function scheduleCompleteFlush() {
      var self = this;
      if (self._completeFlushTimer) {
        return;
      }
      self._completeFlushTimer = setTimeout(function () {
        self._completeFlushTimer = null;
        self.flushCompleteBatch();
      }, 30);
    },
    flushCompleteBatch: function flushCompleteBatch() {
      var self = this;
      if (self._completeFlushing) {
        return;
      }
      var buffer = self._completeBuffer || [];
      if (!buffer.length) {
        return;
      }
      var batch = buffer.splice(0, 50);
      self._completeFlushing = true;
      var sessionIds = batch.map(function (entry) {
        return entry.task.sessionId;
      });
      self.postDiskJson('/disk/upload/completeBatch', { sessionIds: sessionIds }).then(function (res) {
        var rows = res && res.status === 'ok' && res.data ? res.data : null;
        var byId = {};
        if (rows && rows.length) {
          rows.forEach(function (row) {
            if (row && row.sessionId != null) {
              byId[row.sessionId] = row;
            }
          });
        }
        batch.forEach(function (entry) {
          var task = entry.task;
          if (task.runId !== entry.runId) {
            entry.resolve();
            return;
          }
          var row = byId[task.sessionId];
          var ok = rows ? row && row.ok !== false : res && res.status === 'ok';
          if (ok) {
            task.percent = 100;
            task.statusText = '已完成';
            self.touchQueue(task);
            if (!self.uploading) {
              self.loadList();
            }
            self.loadPending();
          } else {
            task.failMsg = row && row.error || res && res.msg || '合并失败';
            task.statusText = '合并失败';
            self.touchQueue(task);
            self.abortFailedSession(task);
          }
          entry.resolve();
        });
      }).catch(function () {
        var chain = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        batch.forEach(function (entry) {
          chain = chain.then(function () {
            return self.completeUploadSingle(entry.task, entry.runId).then(entry.resolve, entry.resolve);
          });
        });
        return chain;
      }).then(function () {
        self._completeFlushing = false;
        if ((self._completeBuffer || []).length) {
          self.scheduleCompleteFlush();
        }
      });
    },
    completeUploadSingle: function completeUploadSingle(task, runId) {
      var self = this;
      if (!task || task.paused || self.uploadHalt) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }
      runId = runId == null ? task.runId : runId;
      return self.$http.post('/disk/upload/complete', { sessionId: task.sessionId }, { silent: true }).then(function (res) {
        if (task.runId !== runId) {
          return;
        }
        if (res && res.status === 'ok') {
          task.percent = 100;
          task.statusText = '已完成';
          self.touchQueue(task);
          if (!self.uploading) {
            self.loadList();
          }
          self.loadPending();
        } else {
          if (res && res.msg) {
            task.failMsg = res.msg;
          }
          task.statusText = '合并失败';
          self.touchQueue(task);
          self.abortFailedSession(task);
        }
      }).catch(function () {
        if (task.runId !== runId) {
          return;
        }
        task.statusText = '合并失败';
        self.touchQueue(task);
        self.abortFailedSession(task);
      });
    }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiskShare',
  data: function data() {
    var _this = this;

    return {
      token: '',
      extractCode: '',
      loading: true,
      opening: false,
      invalid: false,
      invalidMsg: '链接失效',
      needCode: false,
      codeError: '',
      opened: false,
      share: {},
      showPreviewModal: false,
      previewUrl: '',
      previewBlobUrl: '',
      previewEngine: '',
      previewWebofficeUrl: '',
      previewAccessToken: '',
      previewRefreshToken: '',
      previewType: '',
      previewName: '',
      previewExt: '',
      previewDownloadId: null,
      previewLoading: false,
      previewError: '',
      previewText: '',
      previewHtml: '',
      previewRows: [],
      previewEmpty: false,
      jsonError: false,
      mediaError: false,
      columns: [{ title: '名称', minWidth: 220, key: 'name' }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.nodeType === 2 ? '文件' : '文件夹');
        }
      }, {
        title: '大小',
        width: 120,
        align: 'right',
        render: function render(h, params) {
          return h('span', params.row.nodeType === 2 ? _this.formatSize(params.row.size) : '-');
        }
      }, {
        title: '操作',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          if (params.row.nodeType !== 2) {
            return h('span', '-');
          }
          return h('div', [h('Button', {
            props: { size: 'small' },
            style: { marginRight: '8px' },
            on: { click: function click() {
                return _this.preview(params.row.id, params.row);
              } }
          }, '预览'), h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.download(params.row.id);
              } }
          }, '下载')]);
        }
      }]
    };
  },

  computed: {
    centerPreview: function centerPreview() {
      return ['image', 'pdf', 'video', 'audio'].indexOf(this.previewType) >= 0;
    },
    officeUrl: function officeUrl() {
      return 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(this.previewUrl || '');
    }
  },
  created: function created() {
    this.token = this.$route.query.token || '';
    this.extractCode = this.$route.query.extractCode || '';
    if (!this.token) {
      this.loading = false;
      this.invalid = true;
      return;
    }
    this.loadMeta();
  },

  methods: {
    loadMeta: function loadMeta() {
      var self = this;
      self.loading = true;
      self.$http.get('/disk/share/meta', { params: { token: self.token } }).then(function (res) {
        self.loading = false;
        if (res.status !== 'ok' || !res.data) {
          self.invalid = true;
          self.invalidMsg = res.msg || '链接失效';
          return;
        }
        var meta = res.data;
        if (meta.expired) {
          self.invalid = true;
          self.invalidMsg = '链接失效';
          return;
        }
        self.needCode = !!meta.needCode;
        if (!self.needCode || self.extractCode) {
          self.openShare();
        }
      });
    },
    openShare: function openShare() {
      var self = this;
      if (self.needCode && !self.extractCode) {
        self.$Message.warning('请输入提取码');
        return;
      }
      self.opening = true;
      self.codeError = '';
      self.$http.post('/disk/share/open', { token: self.token, extractCode: self.extractCode }).then(function (res) {
        self.opening = false;
        if (res.status !== 'ok' || !res.data) {
          var msg = res.msg || '链接失效';
          if (msg.indexOf('提取码') >= 0) {
            self.codeError = msg;
          } else {
            self.invalid = true;
            self.invalidMsg = msg;
          }
          return;
        }
        self.share = res.data;
        self.needCode = false;
        self.opened = true;
      }).catch(function () {
        self.opening = false;
      });
    },
    download: function download(nodeId) {
      var self = this;
      if (nodeId == null || nodeId === '') {
        nodeId = self.share.id || '';
      }
      self.$http.post('/disk/share/fileUrl', {
        token: self.token,
        extractCode: self.extractCode,
        nodeId: nodeId
      }).then(function (res) {
        if (res.status === 'ok' && res.data && res.data.url) {
          self.openUrl(res.data.url);
        } else if (res.msg) {
          self.$Message.error(res.msg);
        }
      });
    },
    preview: function preview(nodeId, row) {
      var self = this;
      var file = row || self.share;
      if (!file || file.nodeType !== 2) {
        return;
      }
      if (!self.resolvePreviewType(file)) {
        self.$Message.warning('请下载后查看');
        return;
      }
      var id = nodeId == null || nodeId === '' ? file.id : nodeId;
      self.$http.post('/disk/share/fileUrl', {
        token: self.token,
        extractCode: self.extractCode,
        nodeId: id,
        inline: true
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data && (res.data.url || res.data.engine === 'aliyun')) {
          self.resetPreview();
          self.previewUrl = res.data.url || '';
          self.previewType = self.resolvePreviewType(file);
          self.previewExt = self.resolveExt(file);
          self.previewName = file.name;
          self.previewDownloadId = id;
          if (self.previewType === 'office' && res.data.engine === 'aliyun') {
            self.openAliyunOffice(res.data);
          } else {
            self.previewEngine = 'oss';
            self.showPreviewModal = true;
            if (self.previewType === 'pdf') {
              self.loadPreviewPdf();
            } else if (self.isTextPreview()) {
              self.loadPreviewText();
            }
          }
        } else if (res && res.msg) {
          self.$Message.error(res.msg);
        }
      });
    },
    resetPreview: function resetPreview() {
      this.destroyAliyunOffice();
      this.revokePreviewBlob();
      this.previewUrl = '';
      this.previewType = '';
      this.previewExt = '';
      this.previewName = '';
      this.previewDownloadId = null;
      this.previewLoading = false;
      this.previewError = '';
      this.previewText = '';
      this.previewHtml = '';
      this.previewRows = [];
      this.previewEmpty = false;
      this.jsonError = false;
      this.mediaError = false;
    },
    resolveExt: function resolveExt(row) {
      var ext = (row.ext || '').toLowerCase().replace(/^\./, '');
      if (ext) {
        return ext;
      }
      var name = row.name || '';
      var index = name.lastIndexOf('.');
      if (index >= 0 && index < name.length - 1) {
        return name.substring(index + 1).toLowerCase();
      }
      return '';
    },
    resolvePreviewType: function resolvePreviewType(row) {
      var ext = this.resolveExt(row);
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'].indexOf(ext) >= 0) {
        return 'image';
      }
      if (ext === 'pdf') {
        return 'pdf';
      }
      if (['mp4', 'webm', 'ogv', 'mov', 'm4v'].indexOf(ext) >= 0) {
        return 'video';
      }
      if (['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'].indexOf(ext) >= 0) {
        return 'audio';
      }
      if (['md', 'markdown'].indexOf(ext) >= 0) {
        return 'markdown';
      }
      if (ext === 'json') {
        return 'json';
      }
      if (['csv', 'tsv'].indexOf(ext) >= 0) {
        return 'csv';
      }
      if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].indexOf(ext) >= 0) {
        return 'office';
      }
      if (['txt', 'text', 'log', 'xml', 'html', 'htm', 'css', 'js', 'yml', 'yaml', 'ini', 'properties', 'sql', 'conf', 'cfg'].indexOf(ext) >= 0) {
        return 'text';
      }
      return '';
    },
    stopPreviewMedia: function stopPreviewMedia() {
      var players = [this.$refs.previewVideo, this.$refs.previewAudio];
      for (var i = 0; i < players.length; i++) {
        var player = players[i];
        if (!player) {
          continue;
        }
        player.pause();
        player.removeAttribute('src');
        player.load();
      }
      this.previewUrl = '';
    },
    onPreviewVisible: function onPreviewVisible(visible) {
      if (!visible) {
        this.stopPreviewMedia();
        this.revokePreviewBlob();
        this.destroyAliyunOffice();
      }
    },
    openAliyunOffice: function openAliyunOffice(data) {
      var self = this;
      self.previewEngine = 'aliyun';
      self.previewWebofficeUrl = data.webofficeUrl;
      self.previewAccessToken = data.accessToken;
      self.previewRefreshToken = data.refreshToken;
      self.showPreviewModal = true;
      self.loadAliyunSdk().then(function () {
        self.$nextTick(function () {
          if (!self.$refs.aliyunOffice) {
            self.$nextTick(function () {
              self.mountAliyunOffice();
            });
            return;
          }
          self.mountAliyunOffice();
        });
      }).catch(function () {
        self.previewError = '阿里云预览组件加载失败';
      });
    },
    loadAliyunSdk: function loadAliyunSdk() {
      if (window.aliyun && window.aliyun.config) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (this._aliyunSdkPromise) {
        return this._aliyunSdkPromise;
      }
      this._aliyunSdkPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://g.alicdn.com/IMM/office-js/1.1.19/aliyun-web-office-sdk.min.js';
        script.onload = function () {
          resolve();
        };
        script.onerror = function () {
          reject();
        };
        document.head.appendChild(script);
      });
      return this._aliyunSdkPromise;
    },
    mountAliyunOffice: function mountAliyunOffice() {
      var self = this;
      var mount = self.$refs.aliyunOffice;
      if (!mount || !window.aliyun || !window.aliyun.config) {
        self.previewError = '阿里云预览组件加载失败';
        return;
      }
      var ins = window.aliyun.config({
        mount: mount,
        url: self.previewWebofficeUrl,
        refreshToken: function refreshToken() {
          return self.refreshAliyunOffice();
        }
      });
      ins.setToken({
        token: self.previewAccessToken,
        timeout: 25 * 60 * 1000
      });
      self._aliyunOffice = ins;
    },
    refreshAliyunOffice: function refreshAliyunOffice() {
      var self = this;
      return self.$http.post('/disk/share/previewRefresh', {
        token: self.token,
        extractCode: self.extractCode,
        nodeId: self.previewDownloadId,
        accessToken: self.previewAccessToken,
        refreshToken: self.previewRefreshToken
      }).then(function (res) {
        if (!res || res.status !== 'ok' || !res.data || !res.data.accessToken) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();
        }
        self.previewAccessToken = res.data.accessToken;
        if (res.data.refreshToken) {
          self.previewRefreshToken = res.data.refreshToken;
        }
        return {
          token: res.data.accessToken,
          timeout: 25 * 60 * 1000
        };
      });
    },
    destroyAliyunOffice: function destroyAliyunOffice() {
      var ins = this._aliyunOffice;
      this._aliyunOffice = null;
      if (ins && ins.destroy) {
        try {
          ins.destroy();
        } catch (e) {}
      }
      this.previewEngine = '';
      this.previewWebofficeUrl = '';
      this.previewAccessToken = '';
      this.previewRefreshToken = '';
    },
    revokePreviewBlob: function revokePreviewBlob() {
      if (this.previewBlobUrl) {
        URL.revokeObjectURL(this.previewBlobUrl);
        this.previewBlobUrl = '';
      }
    },
    loadPreviewPdf: function loadPreviewPdf() {
      var self = this;
      var maxSize = 40 * 1024 * 1024;
      var tooLarge = false;
      self.previewLoading = true;
      self.previewError = '';
      self.revokePreviewBlob();
      var xhr = new XMLHttpRequest();
      xhr.open('GET', self.previewUrl, true);
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 2) {
          return;
        }
        var headerLength = Number(xhr.getResponseHeader('Content-Length'));
        if (!isNaN(headerLength) && headerLength > maxSize) {
          tooLarge = true;
          xhr.abort();
        }
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          self.previewLoading = false;
          self.previewError = '预览加载失败，请下载';
          return;
        }
        var blob = new Blob([xhr.response], { type: 'application/pdf' });
        self.previewBlobUrl = URL.createObjectURL(blob);
        self.previewLoading = false;
      };
      xhr.onerror = function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      };
      xhr.onabort = function () {
        if (tooLarge) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
        }
      };
      xhr.send();
    },
    isTextPreview: function isTextPreview() {
      return ['markdown', 'json', 'csv', 'text'].indexOf(this.previewType) >= 0;
    },
    onMediaError: function onMediaError() {
      this.mediaError = true;
    },
    loadPreviewText: function loadPreviewText() {
      var self = this;
      var maxSize = 2 * 1024 * 1024;
      var tooLarge = false;
      self.previewLoading = true;
      self.previewError = '';
      self.previewText = '';
      self.previewHtml = '';
      self.previewRows = [];
      self.previewEmpty = false;
      self.jsonError = false;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', self.previewUrl, true);
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 2) {
          return;
        }
        var headerLength = Number(xhr.getResponseHeader('Content-Length'));
        if (!isNaN(headerLength) && headerLength > maxSize) {
          tooLarge = true;
          xhr.abort();
        }
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          self.previewLoading = false;
          self.previewError = '预览加载失败，请下载';
          return;
        }
        if (self.isSpreadsheetBytes(xhr.response)) {
          self.loadPreviewSheet();
          return;
        }
        var text = self.decodePreviewBytes(xhr.response);
        var bodyLength = Number(xhr.getResponseHeader('Content-Length'));
        if (isNaN(bodyLength) || bodyLength <= 0) {
          bodyLength = self.byteLength(text);
        }
        if (bodyLength > maxSize) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
          return;
        }
        self.previewText = text;
        self.renderPreviewText();
        self.previewLoading = false;
      };
      xhr.onerror = function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      };
      xhr.onabort = function () {
        if (tooLarge) {
          self.previewLoading = false;
          self.previewError = '文件过大，请下载';
        }
      };
      xhr.send();
    },
    isSpreadsheetBytes: function isSpreadsheetBytes(buffer) {
      var bytes = new Uint8Array(buffer || []);
      if (bytes.length >= 8 && bytes[0] === 208 && bytes[1] === 207 && bytes[2] === 17 && bytes[3] === 224) {
        return true;
      }
      return bytes.length >= 4 && bytes[0] === 80 && bytes[1] === 75;
    },
    loadPreviewSheet: function loadPreviewSheet() {
      var self = this;
      self.previewType = 'csv';
      self.$http.post('/disk/share/previewTable', {
        token: self.token,
        extractCode: self.extractCode,
        nodeId: self.previewDownloadId
      }).then(function (res) {
        self.previewLoading = false;
        if (res && res.status === 'ok') {
          self.previewRows = res.data || [];
          self.previewEmpty = !self.previewRows.length;
          return;
        }
        self.previewError = res && res.msg || '请下载后查看';
      }).catch(function () {
        self.previewLoading = false;
        self.previewError = '预览加载失败，请下载';
      });
    },
    decodePreviewBytes: function decodePreviewBytes(buffer) {
      var bytes = new Uint8Array(buffer || []);
      if (bytes.length >= 3 && bytes[0] === 239 && bytes[1] === 187 && bytes[2] === 191) {
        bytes = bytes.subarray(3);
      }
      if (!window.TextDecoder) {
        return '';
      }
      try {
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      } catch (e) {
        try {
          return new TextDecoder('gbk').decode(bytes);
        } catch (e2) {
          return new TextDecoder('utf-8').decode(bytes);
        }
      }
    },
    byteLength: function byteLength(text) {
      var value = String(text == null ? '' : text);
      if (window.Blob) {
        return new Blob([value]).size;
      }
      return value.length;
    },
    renderPreviewText: function renderPreviewText() {
      if (this.previewType === 'markdown') {
        this.previewHtml = this.renderMarkdown(this.previewText);
        return;
      }
      if (this.previewType === 'json') {
        try {
          this.previewText = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(this.previewText), null, 2);
        } catch (e) {
          this.jsonError = true;
        }
        return;
      }
      if (this.previewType === 'csv') {
        this.previewRows = this.parseTable(this.previewText);
        this.previewEmpty = !this.previewRows.length;
      }
    },
    parseTable: function parseTable(text) {
      var content = String(text == null ? '' : text).replace(/^\uFEFF/, '');
      if (!content.replace(/\s/g, '')) {
        return [];
      }
      var lines = content.replace(/\r\n?/g, '\n').split('\n');
      while (lines.length && !lines[lines.length - 1].trim()) {
        lines.pop();
      }
      if (this.previewExt === 'tsv') {
        return lines.map(function (line) {
          return line.split('\t');
        });
      }
      return this.parseCsv(lines.join('\n'));
    },
    parseCsv: function parseCsv(text) {
      var rows = [];
      var row = [];
      var field = '';
      var inQuotes = false;
      var index = 0;
      while (index < text.length) {
        var char = text.charAt(index);
        if (inQuotes) {
          if (char === '"') {
            if (text.charAt(index + 1) === '"') {
              field += '"';
              index += 2;
            } else {
              inQuotes = false;
              index++;
            }
          } else {
            field += char;
            index++;
          }
          continue;
        }
        if (char === '"' && field === '') {
          inQuotes = true;
          index++;
          continue;
        }
        if (char === ',') {
          row.push(field);
          field = '';
          index++;
          continue;
        }
        if (char === '\n') {
          row.push(field);
          rows.push(row);
          row = [];
          field = '';
          index++;
          continue;
        }
        field += char;
        index++;
      }
      if (field !== '' || row.length) {
        row.push(field);
        rows.push(row);
      }
      return rows;
    },
    escapeHtml: function escapeHtml(text) {
      return String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    safeUrl: function safeUrl(url) {
      var value = String(url == null ? '' : url).trim();
      if (/^(https?:|mailto:|\/|\.\/|\.\.\/|#)/i.test(value)) {
        return value;
      }
      return '#';
    },
    attrValue: function attrValue(text) {
      return String(text == null ? '' : text).replace(/&quot;|&#34;|&#x0*22;|&#39;|&#x0*27;|"|'/gi, '');
    },
    renderInline: function renderInline(text) {
      var self = this;
      var segments = String(text == null ? '' : text).split('`');
      var html = '';
      for (var i = 0; i < segments.length; i++) {
        if (i % 2 === 1) {
          html += '<code>' + segments[i] + '</code>';
        } else {
          html += self.renderInlineFormat(segments[i]);
        }
      }
      return html;
    },
    renderInlineFormat: function renderInlineFormat(text) {
      var self = this;
      var html = text;
      html = html.replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, function (match, alt, src) {
        return '<img src="' + self.attrValue(self.safeUrl(src)) + '" alt="' + self.attrValue(alt) + '">';
      });
      html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (match, label, href) {
        return '<a href="' + self.attrValue(self.safeUrl(href)) + '" target="_blank" rel="noopener">' + label + '</a>';
      });
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
      return html;
    },
    renderMarkdown: function renderMarkdown(text) {
      var self = this;
      var lines = self.escapeHtml(text).replace(/\r\n?/g, '\n').split('\n');
      var html = [];
      var paragraph = [];
      var quoteLines = [];
      var listType = '';
      var codeLines = [];
      var inCode = false;
      var index = 0;
      var flushParagraph = function flushParagraph() {
        if (paragraph.length) {
          html.push('<p>' + self.renderInline(paragraph.join(' ')) + '</p>');
          paragraph = [];
        }
      };
      var flushQuote = function flushQuote() {
        if (quoteLines.length) {
          html.push('<blockquote>' + self.renderInline(quoteLines.join(' ')) + '</blockquote>');
          quoteLines = [];
        }
      };
      var flushList = function flushList() {
        if (listType) {
          html.push('</' + listType + '>');
          listType = '';
        }
      };
      while (index < lines.length) {
        var line = lines[index];
        if (/^\s*```/.test(line)) {
          if (inCode) {
            html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>');
            codeLines = [];
            inCode = false;
          } else {
            flushParagraph();
            flushList();
            flushQuote();
            inCode = true;
          }
          index++;
          continue;
        }
        if (inCode) {
          codeLines.push(line);
          index++;
          continue;
        }
        if (line.indexOf('|') >= 0 && index + 1 < lines.length && self.isTableSeparator(lines[index + 1])) {
          flushParagraph();
          flushList();
          flushQuote();
          var rows = [line];
          index += 2;
          while (index < lines.length && lines[index].indexOf('|') >= 0 && lines[index].trim()) {
            rows.push(lines[index]);
            index++;
          }
          html.push(self.renderTable(rows));
          continue;
        }
        if (!line.trim()) {
          flushParagraph();
          flushList();
          flushQuote();
          index++;
          continue;
        }
        var heading = /^(#{1,6})\s+(.*)$/.exec(line);
        if (heading) {
          flushParagraph();
          flushList();
          flushQuote();
          html.push('<h' + heading[1].length + '>' + self.renderInline(heading[2].trim()) + '</h' + heading[1].length + '>');
          index++;
          continue;
        }
        if (/^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(line)) {
          flushParagraph();
          flushList();
          flushQuote();
          html.push('<hr>');
          index++;
          continue;
        }
        var quote = /^\s*&gt;\s?(.*)$/.exec(line);
        if (quote) {
          flushParagraph();
          flushList();
          quoteLines.push(quote[1]);
          index++;
          continue;
        }
        flushQuote();
        var unordered = /^\s*[-*+]\s+(.*)$/.exec(line);
        if (unordered) {
          flushParagraph();
          if (listType !== 'ul') {
            flushList();
            html.push('<ul>');
            listType = 'ul';
          }
          html.push('<li>' + self.renderInline(unordered[1]) + '</li>');
          index++;
          continue;
        }
        var ordered = /^\s*\d+\.\s+(.*)$/.exec(line);
        if (ordered) {
          flushParagraph();
          if (listType !== 'ol') {
            flushList();
            html.push('<ol>');
            listType = 'ol';
          }
          html.push('<li>' + self.renderInline(ordered[1]) + '</li>');
          index++;
          continue;
        }
        flushList();
        paragraph.push(line.trim());
        index++;
      }
      if (inCode) {
        html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>');
      }
      flushParagraph();
      flushList();
      flushQuote();
      return html.join('\n');
    },
    isTableSeparator: function isTableSeparator(line) {
      if (!line || line.indexOf('-') < 0) {
        return false;
      }
      var cells = this.splitTableRow(line);
      if (!cells.length) {
        return false;
      }
      for (var i = 0; i < cells.length; i++) {
        if (!/^:?-{2,}:?$/.test(cells[i].replace(/\s/g, ''))) {
          return false;
        }
      }
      return true;
    },
    splitTableRow: function splitTableRow(line) {
      var text = String(line == null ? '' : line).trim();
      if (text.charAt(0) === '|') {
        text = text.substring(1);
      }
      if (text.charAt(text.length - 1) === '|') {
        text = text.substring(0, text.length - 1);
      }
      return text.split('|').map(function (cell) {
        return cell.trim();
      });
    },
    renderTable: function renderTable(rows) {
      var self = this;
      var head = self.splitTableRow(rows[0]);
      var html = ['<table>', '<thead><tr>'];
      head.forEach(function (cell) {
        html.push('<th>' + self.renderInline(cell) + '</th>');
      });
      html.push('</tr></thead><tbody>');
      for (var i = 1; i < rows.length; i++) {
        var cells = self.splitTableRow(rows[i]);
        html.push('<tr>');
        for (var c = 0; c < head.length; c++) {
          html.push('<td>' + self.renderInline(cells[c] || '') + '</td>');
        }
        html.push('</tr>');
      }
      html.push('</tbody></table>');
      return html.join('');
    },
    openUrl: function openUrl(url) {
      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatSize: function formatSize(size) {
      if (size == null || size === '') {
        return '-';
      }
      var n = Number(size);
      if (isNaN(n) || n <= 0) {
        return '0 B';
      }
      var units = ['B', 'KB', 'MB', 'GB', 'TB'];
      var i = 0;
      while (n >= 1024 && i < units.length - 1) {
        n = n / 1024;
        i++;
      }
      return (i === 0 ? n : n.toFixed(2)) + ' ' + units[i];
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiskShareRecords',
  data: function data() {
    var _this = this;

    return {
      loading: false,
      list: [],
      showLog: false,
      logLoading: false,
      logList: [],
      columns: [{
        title: '文件',
        width: 320,
        render: function render(h, params) {
          var name = params.row.nodeName || '';
          var url = _this.buildShareUrl(params.row.token, params.row.extractCode);
          return h('a', {
            attrs: { href: url, target: '_blank', rel: 'noopener', title: name },
            style: { display: 'inline-block', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-all', lineHeight: '20px' }
          }, name);
        }
      }, { title: '分享人', width: 100, key: 'creatorName' }, {
        title: '分享时间',
        width: 170,
        render: function render(h, params) {
          return h('span', _this.formatTime(params.row.gmtCreate));
        }
      }, {
        title: '到期时间',
        width: 170,
        render: function render(h, params) {
          return h('span', params.row.expireTime ? _this.formatTime(params.row.expireTime) : '永久');
        }
      }, {
        title: '提取码',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.extractCode || '无');
        }
      }, {
        title: '状态',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.statusText(params.row));
        }
      }, { title: '访问次数', width: 90, align: 'center', key: 'visitCount' }, { title: '预览次数', width: 90, align: 'center', key: 'previewCount' }, { title: '下载次数', width: 90, align: 'center', key: 'downloadCount' }, {
        title: '操作',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var links = [h('a', {
            style: { marginRight: '16px' },
            on: { click: function click() {
                return _this.copyText(_this.buildShareUrl(params.row.token, params.row.extractCode));
              } }
          }, '复制'), h('a', {
            style: { marginRight: params.row.status === 1 ? '16px' : '0' },
            on: { click: function click() {
                return _this.openLog(params.row);
              } }
          }, '详细记录')];
          if (params.row.status === 1) {
            links.push(h('a', { on: { click: function click() {
                  return _this.revoke(params.row);
                } } }, '撤销'));
          }
          return h('div', links);
        }
      }],
      logColumns: [{ title: '访问 IP', minWidth: 140, key: 'ip' }, {
        title: '访问时间',
        width: 170,
        render: function render(h, params) {
          return h('span', _this.formatTime(params.row.gmtCreate));
        }
      }, { title: '预览次数', width: 100, align: 'center', key: 'previewCount' }, { title: '下载次数', width: 100, align: 'center', key: 'downloadCount' }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var self = this;
      self.loading = true;
      self.$http.get('/disk/share/all').then(function (res) {
        self.loading = false;
        if (res && res.status === 'ok') {
          self.list = res.data || [];
        }
      }).catch(function () {
        self.loading = false;
      });
    },
    statusText: function statusText(row) {
      if (!row || row.status !== 1) {
        return '已撤销';
      }
      if (row.expireTime && this.$moment(row.expireTime).isBefore(this.$moment())) {
        return '已过期';
      }
      return '有效';
    },
    formatTime: function formatTime(value) {
      if (value == null || value === '') {
        return '';
      }
      if (typeof value === 'number') {
        return this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
      }
      var text = String(value);
      if (/^\d{10,}$/.test(text)) {
        return this.$moment(Number(text)).format('YYYY-MM-DD HH:mm:ss');
      }
      return text;
    },
    buildShareUrl: function buildShareUrl(token, extractCode) {
      var url = window.location.origin + window.location.pathname + '#/disk/share?token=' + (token || '');
      if (extractCode) {
        url += '&extractCode=' + extractCode;
      }
      return url;
    },
    copyText: function copyText(text) {
      var input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$Message.success('已复制');
      } catch (e) {
        this.$Message.error('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },
    openLog: function openLog(row) {
      var self = this;
      if (!row) {
        return;
      }
      self.logList = [];
      self.logLoading = true;
      self.showLog = true;
      self.$http.get('/disk/share/access', { params: { id: row.id } }).then(function (res) {
        self.logLoading = false;
        if (res && res.status === 'ok') {
          self.logList = res.data || [];
        }
      }).catch(function () {
        self.logLoading = false;
      });
    },
    revoke: function revoke(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定撤销该分享链接吗？',
        onOk: function onOk() {
          self.$http.post('/disk/share/revoke', { id: row.id }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已撤销');
              self.load();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_AdminUserSelect_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_AdminUserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_AdminUserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_tchScore__ = __webpack_require__(2);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeacherPoolOriginal',
  components: {
    AdminUserSelect: __WEBPACK_IMPORTED_MODULE_6__common_AdminUserSelect_vue___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_7__teacher_modal_TchInfoModal_vue___default.a
  },

  data: function data() {
    return {
      showTchInfoModal: false,
      rankScoreSeq: 0,
      tchInfoId: null,
      activeTab: 'pool',
      daysOfWeek: __WEBPACK_IMPORTED_MODULE_5__utils_constants__["a" /* DAYS_OF_WEEK */],
      timeSlots: __WEBPACK_IMPORTED_MODULE_5__utils_constants__["b" /* TIME_SLOTS */],
      levelOptions: [{ value: '1', label: 'Level1' }, { value: '5', label: 'Level2' }, { value: '2', label: 'Level3-Level5' }, { value: '3', label: 'Level6-Level9' }, { value: '4', label: 'Wonders及其他' }, { value: '6', label: 'PU' }],
      materialOptions: [{ value: '4', label: 'Wonders' }, { value: '6', label: 'Power up' }],
      filters: {
        searchText: '',
        tchStudyAdviserId: '',
        tchChannel: '',
        emergency: '0',
        isAudition: '',
        canBound: '',
        chinese: '',
        levelGroups: [],
        materialCodes: [],
        sameTeacher: '1',
        requiredSlots: [{ day: '', slotId: '' }],
        backupSlots: [{ day: '', slotId: '' }],
        tempSchedule: '',
        gender: '',
        accent: '',
        days: [],
        slotIds: [],
        minSlots: '',
        occupyDate: this.$moment().format('YYYY-MM-DD'),
        bookMode: 'bind'
      },
      currentMonth: this.$moment().format('YYYY-MM'),
      statistics: {
        totalTeachers: 0,
        qualifiedTeachers: 0,
        totalAvailableSlots: 0,
        usedSlots: 0,
        pendingSlots: 0
      },
      teachers: [],
      matrixData: {},
      pendingSlots: [],
      selectedIds: [],
      selectAll: false,
      loading: false,
      loadSeq: 0,
      runCheckLoading: false,
      runRangeVisible: false,
      runDateRange: [],
      backupFilterEnabled: false,
      slotDetailVisible: false,
      slotDetailLoading: false,
      slotDetailKind: 'available',
      slotDetail: {
        weekStart: '',
        weekEnd: '',
        total: 0,
        list: []
      },
      slotDetailDateRange: [],
      slotDetailQueryKey: '',
      slotDetailRangeSilent: false
    };
  },


  computed: {
    isTrialPool: function isTrialPool() {
      var route = this.$route || {};
      return route.name === 'TrialTeacherPool' || route.path === '/emergency/trialTeacherPool';
    },
    canRunEmergencyPool: function canRunEmergencyPool() {
      return Number(this.$store.get('id')) === 318;
    },
    filteredTeachers: function filteredTeachers() {
      return this.teachers;
    },
    pendingList: function pendingList() {
      return this.pendingSlots.filter(function (p) {
        return p.status === 'pending' || p.status === 1;
      });
    },
    weekRangeLabel: function weekRangeLabel() {
      var day = this.$moment(this.filters.occupyDate || this.defaultOccupyDate());

      if (this.isTrialPool) {
        var _start = day.clone().isoWeekday(1);
        var _end = day.clone().isoWeekday(7);
        return '\u7EDF\u8BA1\u5468 ' + _start.format('YYYY-MM-DD') + ' ~ ' + _end.format('YYYY-MM-DD');
      }
      if (this.filters.bookMode === 'temp') {
        return '\u7EDF\u8BA1\u65E5 ' + day.format('YYYY-MM-DD');
      }
      var start = day.clone().isoWeekday(1);
      var end = day.clone().isoWeekday(7);
      return '\u7EDF\u8BA1\u5468 ' + start.format('YYYY-MM-DD') + ' ~ ' + end.format('YYYY-MM-DD');
    },
    slotDetailTitle: function slotDetailTitle() {
      return this.slotDetailKind === 'used' ? '已使用时段明细' : '可用时段明细';
    },
    slotDetailColumns: function slotDetailColumns() {
      var dateTitle = this.slotDetailKind === 'used' ? '日期' : '本周日期';
      var columns = [{ title: '老师ID', key: 'teacherId', width: 100 }, { title: '老师姓名', key: 'teacherName', minWidth: 140 }, { title: '星期', key: 'dayLabel', width: 90 }, { title: '时段', key: 'slotLabel', width: 100 }, { title: dateTitle, key: 'date', width: 130 }, { title: '状态', key: 'statusLabel', width: 100 }, { title: '绑定学生', key: 'boundStudent', width: 160 }, { title: '空闲出来的时间', key: 'freedAt', width: 170 }, { title: '使用时间', key: 'usedAt', width: 170 }];
      if (this.slotDetailKind !== 'used') {
        return columns.filter(function (col) {
          return col.key !== 'boundStudent';
        });
      }
      return columns;
    }
  },

  watch: {
    '$route.name': function $routeName() {
      if (this.isTrialPool) {
        this.activeTab = 'pool';
        this.runRangeVisible = false;
        this.filters.bookMode = 'temp';
        this.$set(this.filters, 'occupyDate', this.defaultOccupyDate());
      }
      this.loadData();
    }
  },

  mounted: function mounted() {
    if (this.isTrialPool) {
      this.filters.bookMode = 'temp';
      this.$set(this.filters, 'occupyDate', this.defaultOccupyDate());
    }
    this.loadData();
  },


  methods: {
    getDayLabel: __WEBPACK_IMPORTED_MODULE_5__utils_constants__["c" /* getDayLabel */],
    getSlotLabel: __WEBPACK_IMPORTED_MODULE_5__utils_constants__["d" /* getSlotLabel */],

    buildQuery: function buildQuery() {
      var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      var requiredSlotKeys = this.buildSlotKeys(this.filters.requiredSlots);
      var backupSlotKeys = this.buildSlotKeys(this.filters.backupSlots);
      var levelGroups = this.filters.levelGroups || [];
      var materialCodes = this.filters.materialCodes || [];
      var query = {
        month: this.currentMonth,
        startDate: this.filters.occupyDate || this.defaultOccupyDate(),
        bookMode: this.isTrialPool ? 'temp' : this.filters.bookMode || 'bind',
        searchText: this.filters.searchText || null,
        tchStudyAdviserId: this.toNumberOrNull(this.filters.tchStudyAdviserId),
        tchChannel: this.toNumberOrNull(this.filters.tchChannel),
        emergency: this.toNumberOrNull(this.filters.emergency),
        isAudition: this.filters.isAudition || null,
        canBound: this.toNumberOrNull(this.filters.canBound),
        chinese: this.toNumberOrNull(this.filters.chinese),
        levelGroups: levelGroups.length ? levelGroups : null,
        materialCodes: materialCodes.length ? materialCodes : null,
        requiredSlotKeys: requiredSlotKeys.length ? requiredSlotKeys : null,
        sameTeacher: this.toNumberOrNull(this.filters.sameTeacher),
        backupSlotKeys: this.backupFilterEnabled && backupSlotKeys.length ? backupSlotKeys : null,
        tempSchedule: this.toNumberOrNull(this.filters.tempSchedule),
        gender: this.filters.gender || null,
        accent: this.filters.accent || null,
        minSlots: this.filters.minSlots ? Number(this.filters.minSlots) : null,
        days: this.filters.days.length ? this.filters.days : null,
        slotIds: this.filters.slotIds.length ? this.filters.slotIds : null,
        qualifiedOnly: false,
        pageIndex: 1,
        pageSize: pageSize
      };
      if (this.isTrialPool) {
        query.pool = 'trial';
        query.emergency = null;
      }
      return query;
    },
    defaultOccupyDate: function defaultOccupyDate() {
      return this.$moment().format('YYYY-MM-DD');
    },
    onOccupyDateChange: function onOccupyDateChange(val) {
      var occupyDate = val ? this.$moment(val).format('YYYY-MM-DD') : this.defaultOccupyDate();
      this.$set(this.filters, 'occupyDate', occupyDate);
      this.applyFilters();
    },
    toNumberOrNull: function toNumberOrNull(value) {
      return value === '' || value === null || value === undefined ? null : Number(value);
    },
    buildSlotKeys: function buildSlotKeys(list) {
      return (list || []).filter(function (item) {
        return item && item.day && item.slotId;
      }).map(function (item) {
        return item.day + ':' + item.slotId;
      });
    },
    getSlotFilterList: function getSlotFilterList(type) {
      return type === 'required' ? this.filters.requiredSlots : this.filters.backupSlots;
    },
    addSlotFilter: function addSlotFilter(type) {
      this.getSlotFilterList(type).push({ day: '', slotId: '' });
    },
    removeSlotFilter: function removeSlotFilter(type, index) {
      var list = this.getSlotFilterList(type);
      list.splice(index, 1);
      if (!list.length) {
        list.push({ day: '', slotId: '' });
      }
      this.applyFilters();
    },
    loadData: function loadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var seq;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                seq = ++_this.loadSeq;

                _this.loading = true;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.loadStatistics(), _this.loadTeachers(), _this.loadMatrix()]);

              case 5:
                _context.prev = 5;

                if (seq === _this.loadSeq) {
                  _this.loading = false;
                }
                return _context.finish(5);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2,, 5, 8]]);
      }))();
    },
    loadStatistics: function loadStatistics() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var seq, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                seq = _this2.loadSeq;
                _context2.next = 3;
                return _this2.$http.post('/emergency/teacherPool/statistics', _this2.buildQuery());

              case 3:
                res = _context2.sent;

                if (!(seq !== _this2.loadSeq)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                if (res && res.data) {
                  _this2.statistics = res.data;
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    openSlotDetail: function openSlotDetail(kind) {
      this.slotDetailKind = kind;
      this.slotDetail = {
        weekStart: '',
        weekEnd: '',
        total: 0,
        list: []
      };
      this.slotDetailVisible = true;
      if (kind === 'used') {
        this.applyUsedWeekRange(true);
        return;
      }
      this.loadSlotDetails();
    },
    defaultUsedWeekRange: function defaultUsedWeekRange() {
      var start = this.$moment().isoWeekday(1).startOf('day');
      var end = start.clone().isoWeekday(7).startOf('day');
      return [start.toDate(), end.toDate()];
    },
    usedRangeKey: function usedRangeKey(range) {
      var list = Array.isArray(range) ? range : [];
      var startDate = this.formatRunDate(list[0]);
      var endDate = this.formatRunDate(list[1]);
      if (!startDate || !endDate) {
        return '';
      }
      return startDate + '|' + endDate;
    },
    applyUsedWeekRange: function applyUsedWeekRange(reload) {
      var _this3 = this;

      var range = this.defaultUsedWeekRange();
      this.slotDetailQueryKey = this.usedRangeKey(range);
      this.slotDetailRangeSilent = true;
      this.slotDetailDateRange = range;
      this.$nextTick(function () {
        _this3.$nextTick(function () {
          _this3.slotDetailRangeSilent = false;
        });
      });
      if (reload) {
        this.loadSlotDetails();
      }
    },
    onSlotDetailRangeChange: function onSlotDetailRangeChange(value) {
      if (this.slotDetailKind !== 'used' || this.slotDetailRangeSilent) {
        return;
      }
      var key = this.usedRangeKey(value);
      if (!key) {
        this.applyUsedWeekRange(true);
        return;
      }
      if (key === this.slotDetailQueryKey) {
        return;
      }
      this.slotDetailQueryKey = key;
      this.loadSlotDetails();
    },
    isCurrentSlotDetailQuery: function isCurrentSlotDetailQuery(kind, queryKey) {
      if (kind !== this.slotDetailKind) {
        return false;
      }
      if (kind !== 'used') {
        return true;
      }
      return queryKey === this.slotDetailQueryKey;
    },
    loadSlotDetails: function loadSlotDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var kind, queryKey, payload, parts, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                kind = _this4.slotDetailKind;
                queryKey = 'available';
                payload = _this4.buildQuery();

                payload.kind = kind;
                if (kind === 'used') {
                  if (!_this4.slotDetailQueryKey) {
                    _this4.slotDetailQueryKey = _this4.usedRangeKey(_this4.defaultUsedWeekRange());
                  }
                  queryKey = _this4.slotDetailQueryKey;
                  parts = queryKey.split('|');

                  payload.startDate = parts[0];
                  payload.endDate = parts[1];
                }
                _this4.slotDetailLoading = true;
                _context3.prev = 6;
                _context3.next = 9;
                return _this4.$http.post('/emergency/teacherPool/slotDetails', payload);

              case 9:
                res = _context3.sent;

                if (_this4.isCurrentSlotDetailQuery(kind, queryKey)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt('return');

              case 12:
                if (res && res.data) {
                  _this4.slotDetail = {
                    weekStart: res.data.weekStart || '',
                    weekEnd: res.data.weekEnd || '',
                    total: res.data.total || 0,
                    list: res.data.list || []
                  };
                }

              case 13:
                _context3.prev = 13;

                if (_this4.isCurrentSlotDetailQuery(kind, queryKey)) {
                  _this4.slotDetailLoading = false;
                }
                return _context3.finish(13);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[6,, 13, 16]]);
      }))();
    },
    loadTeachers: function loadTeachers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var seq, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                seq = _this5.loadSeq;
                _context4.next = 3;
                return _this5.$http.post('/emergency/teacherPool/teachers', _this5.buildQuery());

              case 3:
                res = _context4.sent;

                if (!(seq !== _this5.loadSeq)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return');

              case 6:
                _this5.teachers = res && res.data && res.data.data ? res.data.data : [];
                _this5.loadMonthRankScores();

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    loadMatrix: function loadMatrix() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var seq, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                seq = _this6.loadSeq;
                _context5.next = 3;
                return _this6.$http.post('/emergency/teacherPool/matrix', _this6.buildQuery());

              case 3:
                res = _context5.sent;

                if (!(seq !== _this6.loadSeq)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt('return');

              case 6:
                _this6.matrixData = res && res.data && res.data.matrix ? res.data.matrix : {};

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    loadPending: function loadPending() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.$http.post('/emergency/teacherPool/pending', {
                  month: _this7.currentMonth,
                  status: 'pending',
                  pageIndex: 1,
                  pageSize: 1000
                });

              case 2:
                res = _context6.sent;

                _this7.pendingSlots = res && res.data && res.data.data ? res.data.data : [];

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    isQualified: function isQualified(teacher) {
      return teacher && teacher.qualified;
    },
    handleSelectAll: function handleSelectAll(checked) {
      var _this8 = this;

      if (checked) {
        this.selectedIds = this.pendingList.map(function (p) {
          return Number(p.id);
        });
      } else {
        this.selectedIds = [];
      }

      this.$nextTick(function () {
        _this8.$forceUpdate();
      });
    },
    slotDisplayClass: function slotDisplayClass(slot) {
      if (!slot) {
        return 'buyout';
      }
      if (slot.status === 'schedule' || slot.status === 'bound' || slot.status === 'leave' || slot.status === 'pending') {
        return slot.status;
      }
      return slot.type || 'buyout';
    },
    isApprovedEmergencySlot: function isApprovedEmergencySlot(slot) {
      if (!slot) return false;
      return slot.emergency === 1 || slot.emergency === '1';
    },
    getTeacherSlots: function getTeacherSlots(teacherId) {
      var _this9 = this;

      var teacher = this.teachers.find(function (item) {
        return item.id === teacherId;
      });
      if (!teacher || !teacher.slots || !teacher.slots.length) {
        return [];
      }
      var slotsByDay = {};
      teacher.slots.forEach(function (slot) {
        if (!slotsByDay[slot.day]) {
          slotsByDay[slot.day] = [];
        }
        slotsByDay[slot.day].push(slot);
      });
      var dayOrder = this.daysOfWeek.map(function (item) {
        return item.key;
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(slotsByDay).sort(function (a, b) {
        return dayOrder.indexOf(a) - dayOrder.indexOf(b);
      }).map(function (day) {
        return {
          day: day,
          slots: slotsByDay[day].slice().sort(function (a, b) {
            var left = a.label || _this9.getSlotLabel(a.slotId) || a.slotId || '';
            var right = b.label || _this9.getSlotLabel(b.slotId) || b.slotId || '';
            return left.localeCompare(right);
          })
        };
      });
    },
    getCellCount: function getCellCount(day, slotId) {
      if (this.matrixData[day] && this.matrixData[day][slotId] !== undefined) {
        return this.matrixData[day][slotId];
      }
      return 0;
    },
    isCellSelected: function isCellSelected(day, slotId) {
      return (this.filters.requiredSlots || []).some(function (item) {
        return item && item.day === day && item.slotId === slotId;
      });
    },
    getCellClass: function getCellClass(day, slotId) {
      var _ref;

      var count = this.getCellCount(day, slotId);
      var level = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_constants__["e" /* getHeatLevel */])(count);
      return _ref = {
        'matrix-cell': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'level-' + level, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selected', this.isCellSelected(day, slotId)), _ref;
    },
    handleCellClick: function handleCellClick(day, slotId) {
      var list = (this.filters.requiredSlots || []).filter(function (item) {
        return item && item.day && item.slotId;
      });
      var idx = list.findIndex(function (item) {
        return item.day === day && item.slotId === slotId;
      });
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push({ day: day, slotId: slotId });
      }
      this.$set(this.filters, 'requiredSlots', list.length ? list : [{ day: '', slotId: '' }]);
      this.applyFilters();
    },
    handleTabChange: function handleTabChange(tabName) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this10.activeTab = tabName;

                if (!(tabName === 'pending')) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 4;
                return _this10.loadPending();

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    defaultRunDateRange: function defaultRunDateRange() {
      var start = this.$moment().isoWeekday(1).subtract(1, 'week').startOf('day');
      var end = start.clone().add(6, 'days');
      return [start.toDate(), end.toDate()];
    },
    formatRunDate: function formatRunDate(value) {
      if (!value) {
        return '';
      }
      var day = this.$moment(value);
      if (!day.isValid()) {
        return '';
      }
      return day.format('YYYY-MM-DD');
    },
    runEmergencyPoolCheck: function runEmergencyPoolCheck() {
      this.runDateRange = this.defaultRunDateRange();
      this.runRangeVisible = true;
    },
    closeRunRange: function closeRunRange() {
      this.runRangeVisible = false;
    },
    submitRunCheck: function submitRunCheck() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var range, startDate, endDate, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this11.runCheckLoading) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return');

              case 2:
                range = Array.isArray(_this11.runDateRange) ? _this11.runDateRange : [];
                startDate = _this11.formatRunDate(range[0]);
                endDate = _this11.formatRunDate(range[1]);

                if (!(!startDate || !endDate)) {
                  _context8.next = 8;
                  break;
                }

                _this11.$Message.warning('请选择时间范围');
                return _context8.abrupt('return');

              case 8:
                if (!(startDate > endDate)) {
                  _context8.next = 11;
                  break;
                }

                _this11.$Message.warning('开始不能晚于结束');
                return _context8.abrupt('return');

              case 11:
                _this11.runCheckLoading = true;
                _context8.prev = 12;
                _context8.next = 15;
                return _this11.$http.post('/emergency/teacherPool/runCheck', {
                  startDate: startDate,
                  endDate: endDate
                });

              case 15:
                res = _context8.sent;

                if (!(res && res.status === 'ok')) {
                  _context8.next = 21;
                  break;
                }

                _this11.runRangeVisible = false;
                _this11.$Message.success(res.data && String(res.data) || '已执行');
                _context8.next = 21;
                return _this11.loadData();

              case 21:
                _context8.prev = 21;

                _this11.runCheckLoading = false;
                return _context8.finish(21);

              case 24:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[12,, 21, 24]]);
      }))();
    },
    applyFilters: function applyFilters() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this12.loadData();

              case 2:
                _this12.$Message.success('筛选条件已应用');

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    resetFilters: function resetFilters() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.filters = {
                  searchText: '',
                  tchStudyAdviserId: '',
                  tchChannel: '',
                  emergency: '0',
                  isAudition: '',
                  canBound: '',
                  chinese: '',
                  levelGroups: [],
                  materialCodes: [],
                  sameTeacher: '1',
                  requiredSlots: [{ day: '', slotId: '' }],
                  backupSlots: [{ day: '', slotId: '' }],
                  tempSchedule: '',
                  gender: '',
                  accent: '',
                  days: [],
                  slotIds: [],
                  minSlots: '',
                  occupyDate: _this13.defaultOccupyDate(),
                  bookMode: _this13.isTrialPool ? 'temp' : 'bind'
                };
                _context10.next = 3;
                return _this13.loadData();

              case 3:
                _this13.$Message.success('筛选条件已重置');

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    handleApprove: function handleApprove(pendingId) {
      this.approveSlot(pendingId);
    },
    handleReject: function handleReject(pendingId) {
      this.rejectSlot(pendingId);
    },
    approveSlot: function approveSlot(pendingId) {
      var _this14 = this;

      this.$Modal.confirm({
        title: '确认审核',
        content: '确定通过此时段审核吗？通过后将加入应急池。',
        onOk: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return _this14.$http.post('/emergency/teacherPool/review/approve/' + pendingId, {});

                  case 2:
                    _this14.$Message.success('审核通过');
                    _context11.next = 5;
                    return _this14.loadData();

                  case 5:
                    _context11.next = 7;
                    return _this14.loadPending();

                  case 7:
                  case 'end':
                    return _context11.stop();
                }
              }
            }, _callee11, _this14);
          }));

          return function onOk() {
            return _ref2.apply(this, arguments);
          };
        }()
      });
    },
    rejectSlot: function rejectSlot(pendingId) {
      var _this15 = this;

      this.$Modal.confirm({
        title: '确认拒绝',
        content: '确定拒绝此时段申请吗？拒绝后将从待审核列表移除。',
        onOk: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return _this15.$http.post('/emergency/teacherPool/review/reject/' + pendingId, {});

                  case 2:
                    _this15.$Message.info('已拒绝');
                    _context12.next = 5;
                    return _this15.loadData();

                  case 5:
                    _context12.next = 7;
                    return _this15.loadPending();

                  case 7:
                  case 'end':
                    return _context12.stop();
                }
              }
            }, _callee12, _this15);
          }));

          return function onOk() {
            return _ref3.apply(this, arguments);
          };
        }()
      });
    },
    batchApprove: function batchApprove() {
      var _this16 = this;

      if (!this.selectedIds.length) {
        this.$Message.warning('请先选择要审核的时段');
        return;
      }
      this.$Modal.confirm({
        title: '批量审核通过',
        content: '\u786E\u5B9A\u901A\u8FC7\u9009\u4E2D\u7684 ' + this.selectedIds.length + ' \u4E2A\u65F6\u6BB5\u5417\uFF1F',
        onOk: function () {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return _this16.$http.post('/emergency/teacherPool/review/batchApprove', { ids: _this16.selectedIds });

                  case 2:
                    _this16.selectedIds = [];
                    _this16.selectAll = false;
                    _this16.$Message.success('批量审核通过');
                    _context13.next = 7;
                    return _this16.loadData();

                  case 7:
                    _context13.next = 9;
                    return _this16.loadPending();

                  case 9:
                  case 'end':
                    return _context13.stop();
                }
              }
            }, _callee13, _this16);
          }));

          return function onOk() {
            return _ref4.apply(this, arguments);
          };
        }()
      });
    },
    batchReject: function batchReject() {
      var _this17 = this;

      if (!this.selectedIds.length) {
        this.$Message.warning('请先选择要拒绝的时段');
        return;
      }
      this.$Modal.confirm({
        title: '批量拒绝',
        content: '\u786E\u5B9A\u62D2\u7EDD\u9009\u4E2D\u7684 ' + this.selectedIds.length + ' \u4E2A\u65F6\u6BB5\u5417\uFF1F',
        onOk: function () {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    _context14.next = 2;
                    return _this17.$http.post('/emergency/teacherPool/review/batchReject', { ids: _this17.selectedIds });

                  case 2:
                    _this17.selectedIds = [];
                    _this17.selectAll = false;
                    _this17.$Message.info('批量拒绝成功');
                    _context14.next = 7;
                    return _this17.loadData();

                  case 7:
                    _context14.next = 9;
                    return _this17.loadPending();

                  case 9:
                  case 'end':
                    return _context14.stop();
                }
              }
            }, _callee14, _this17);
          }));

          return function onOk() {
            return _ref5.apply(this, arguments);
          };
        }()
      });
    },
    scoreText: function scoreText(teacher) {
      if (!teacher || teacher.monthRankScore == null || teacher.monthRankScore === '') {
        return '';
      }
      var num = Number(teacher.monthRankScore);
      if (isNaN(num)) {
        return '';
      }
      return num.toFixed(2);
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.teachers || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'id', 'monthRankScore', map);
      });
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      startDate: '',
      endDate: '',
      statisticsSum: {},
      queryParam: {
        uid: '',
        nickName: '',
        payWay: null,
        beginTime: '',
        endTime: ''
      },
      title: [{
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + ' ' + row.nickname);
        }
      }, {
        title: '订单号',
        width: 150,
        align: 'center',
        key: 'orderId'
      }, {
        title: '支付方式',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var payWayEnum = $constant.getEnum($constant.payWay, params.row.payWay);
          return h('span', payWayEnum && payWayEnum.text);
        }
      }, {
        title: '套餐金额',
        width: 100,
        align: 'center',
        key: 'amount'
      }, {
        title: '订单金额',
        width: 100,
        align: 'center',
        key: 'payAmount'
      }, {
        title: '订单课时',
        width: 100,
        align: 'center',
        key: 'orderLessonNum'
      }, {
        title: '赠送课时',
        width: 100,
        align: 'center',
        key: 'totalOtherDiscountNum'
      }, {
        title: '合计课节',
        width: 100,
        align: 'center',
        key: 'totalLessonNum'
      }, {
        title: '本期消耗',
        width: 100,
        align: 'center',
        key: 'periodUseNum'
      }, {
        title: '本期赠送',
        width: 100,
        align: 'center',
        key: 'periodOtherDiscountNum'
      }, {
        title: '累计消耗',
        width: 100,
        align: 'center',
        key: 'totalUseNum'
      }, {
        title: '剩余课时',
        width: 100,
        align: 'center',
        key: 'leaveLessonNum'
      }, {
        title: '课时均价',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', Number(params.row.averagePrice).toFixed(2));
        }
      }, {
        title: '本期收入',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', Number(params.row.periodIncome).toFixed(2));
        }
      }, {
        title: '剩余',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', Number(params.row.totalLeaveAmount).toFixed(2));
        }
      }, {
        title: '退费',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', Number(params.row.refundAmount).toFixed(2));
        }
      }]
    };
  },

  mounted: function mounted() {
    this.loadStatisticsSum();
  },
  filters: {
    numFilter: function numFilter(value) {
      var realVal = Number(value).toFixed(2);
      return Number(realVal);
    }
  },
  created: function created() {
    var momentDate = this.$moment();
    momentDate.millisecond(0);
    momentDate.second(0);
    momentDate.minute(0);
    momentDate.hour(0);
    momentDate.date(1);
    this.startDate = momentDate.toDate();
    this.endDate = this.$moment().toDate();
    console.log('this.$moment():' + this.$moment());
    console.log('this.$moment().toDate():' + this.$moment().toDate());
    this.queryParam.beginTime = momentDate.format('X');
    this.queryParam.endTime = this.$moment().format('X');
  },
  methods: {
    loadStatisticsSum: function loadStatisticsSum() {
      var self = this;
      this.$http.post('/fundPackage/incomeStatistics/sum', self.queryParam).then(function (res) {
        self.statisticsSum = res.data;
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    beginTimeChange: function beginTimeChange(value) {
      this.queryParam.beginTime = value && this.$moment(value, 'YYYY-M-D').format('X');
    },
    endTimeChange: function endTimeChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D').format('X');
    },
    search: function search() {
      this.reload = new Date().getTime();
      this.loadStatisticsSum();
    },
    exportData: function exportData() {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/fundPackage/incomeStatistics/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '收入统计.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditInvoiceModal__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditInvoiceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_EditInvoiceModal__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EditInvoiceModal: __WEBPACK_IMPORTED_MODULE_0__modal_EditInvoiceModal___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      totalInvoiceAmount: 0,
      totalHasPayAmount: 0,
      notTotalInvoiceAmount: 0,
      uid: null,
      orderId: null,
      invoiceDetail: null,
      editInvoice: false,
      listUrl: '/financial/invoiceList',
      queryParam: {
        uid: '',
        nickname: '',
        state: '',
        invoiceState: '',
        beginTime: '',
        endTime: ''
      },
      title: [{
        title: '学生ID/姓名',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + ' ' + row.nickname);
        }
      }, {
        title: '订单号',
        align: 'center',
        key: 'orderId'
      }, {
        title: '订单金额',
        align: 'center',
        key: 'payAmount'
      }, {
        title: '已付金额',
        align: 'center',
        key: 'hasPayAmount'
      }, {
        title: '开票状态',
        align: 'center',
        render: function render(h, params) {
          var invoiceState = params.row.invoiceState;
          var invoiceStateEnum = $constant.getEnum($constant.invoiceState, invoiceState);
          return h('div', invoiceStateEnum && invoiceStateEnum.text);
        }
      }, {
        title: '已开票',
        align: 'center',
        key: 'invoiceAmount'
      }, {
        title: '未开票',
        align: 'center',
        key: 'notInvoiceAmount'
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return self.edit(row.uid, row.orderId, row.invoiceDetail);
              } } }, '开票')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    self.$http.get('/financial/invoiceSum').then(function (res) {
      if (res.data) {
        var data = res.data;
        self.totalInvoiceAmount = data.totalInvoiceAmount;
        self.totalHasPayAmount = data.totalHasPayAmount;
        self.notTotalInvoiceAmount = data.notTotalInvoiceAmount;
      }
    });
  },
  created: function created() {},
  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    beginTimeChange: function beginTimeChange(value) {
      this.queryParam.beginTime = value;
    },
    endTimeChange: function endTimeChange(value) {
      this.queryParam.endTime = value;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    edit: function edit(uid, orderId, invoiceDetail) {
      this.uid = uid;
      this.orderId = orderId;
      this.invoiceDetail = invoiceDetail;
      this.editInvoice = true;
    },
    closeModal: function closeModal(val) {
      this.reload = new Date().getTime();
      this.uid = null;
      this.orderId = null;
      this.invoiceDetail = null;
      this.editInvoice = false;
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_RefundInsertModal_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_RefundInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_RefundInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RefundInsertModal: __WEBPACK_IMPORTED_MODULE_1__modal_RefundInsertModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      startTime: '',
      endTime: '',
      statistics: {
        waitAuditNum: 0,
        waitRefundNum: 0,
        refundNum: 0
      },
      searchLoading: false,
      refundInsertModal: false,
      id: null,
      canSave: true,
      reload: 0,
      rankScoreSeq: 0,
      orderId: '',
      queryParam: {
        uid: '',
        applyName: '',
        invoiceState: '',
        status: '',
        startTime: '',
        endTime: '',
        orderId: ''
      },
      title: [{
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '付款日期',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var payTime = params.row.payTime;
          if (payTime === 0) {
            return;
          }
          return h('span', payTime && $moment(payTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '订单ID',
        key: 'orderId',
        width: 130,
        align: 'center'
      }, {
        title: '退款原因分类',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var statusEnum = $constant.getEnum($constant.refundReasonCategory, params.row.refundReasonCategory);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '订单金额',
        width: 100,
        align: 'center',
        key: 'fundAmount'
      }, {
        title: '消耗',
        width: 100,
        align: 'center',
        key: 'costAmount'
      }, {
        title: '教材金额',
        width: 100,
        align: 'center',
        key: 'textAmount'
      }, {
        title: '其他扣款',
        width: 100,
        align: 'center',
        key: 'otherAmount'
      }, {
        title: '课时单价',
        width: 100,
        align: 'center',
        key: 'courseUnitPrice'
      }, {
        title: '课时费',
        width: 100,
        align: 'center',
        key: 'lessonFee'
      }, {
        title: '礼品费',
        width: 100,
        align: 'center',
        key: 'giftFee'
      }, {
        title: '手续费',
        width: 100,
        align: 'center',
        key: 'serviceFee'
      }, {
        title: '实际退款金额',
        width: 120,
        align: 'center',
        key: 'actualRefundAmount'
      }, {
        title: '最后一节课老师',
        width: 180,
        align: 'center',
        key: 'lastTchName',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.lastTchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '对应老师外管',
        width: 120,
        align: 'center',
        key: 'tchAdviserName'
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regChannel'
      }, {
        title: '退费金额',
        width: 100,
        align: 'center',
        key: 'refundAmount'
      }, {
        title: '发票',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var statusEnum = $constant.getEnum($constant.refundInvoice, params.row.invoiceState);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '申请人',
        width: 100,
        align: 'center',
        key: 'applyName'
      }, {
        title: '申请时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var applyTime = params.row.applyTime;
          if (applyTime === 0) {
            return;
          }
          return h('span', applyTime && $moment(applyTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '状态',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          var statusEnum = $constant.getEnum($constant.refundState, params.row.status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var auditTime = params.row.auditTime;
          if (auditTime === 0) {
            return;
          }
          return h('span', auditTime && $moment(auditTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'show' } }, '查看'));
          btn.push(h('Dropdown-item', { props: { name: 'reBack' } }, '劝退成功'));
          btn.push(h('Dropdown-item', { props: { name: 'pass' } }, '通过'));
          btn.push(h('Dropdown-item', { props: { name: 'reject' } }, '驳回'));
          btn.push(h('Dropdown-item', { props: { name: 'recieveInvoice' } }, '收到发票'));
          btn.push(h('Dropdown-item', { props: { name: 'refund' } }, '已退款'));

          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'show') {
                  _this.id = parseInt(row.id);
                  _this.orderId = row.orderId;
                  _this.canSave = false;
                  _this.refundInsertModal = true;
                } else if (name === 'reBack') {
                  _this.reBack(row.id);
                } else if (name === 'pass') {
                  _this.audit(row.id);
                } else if (name === 'reject') {
                  _this.reject(row.id);
                } else if (name === 'recieveInvoice') {
                  _this.recieveInvoice(row.id);
                } else if (name === 'refund') {
                  _this.refund(row.id);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var self = this;
    self.$http.get('/financial/refund/statistics/list', { silent: true }).then(function (res) {
      if (res && res.status === 'ok' && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object') {
        self.statistics = res.data;
      }
    });
  },
  watch: {},
  methods: {
    onLoading: function onLoading(loading) {
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.lastTchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'lastTchId', 'monthRankScore', map);
      });
    },
    reject: function reject(id) {
      var self = this;
      self.$http.post('/financial/refund/reject', { id: id }).then(function (res) {
        if (res.data && res.data > 0) {
          self.$Message.success('驳回成功!');
          self.search();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    recieveInvoice: function recieveInvoice(id) {
      var self = this;
      self.$http.post('/financial/refund/receiveInvoice', { id: id }).then(function (res) {
        if (res.data && res.data > 0) {
          self.$Message.success('回收发票成功!');
          self.search();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    refund: function refund(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确认将该退费标记为已退款？',
        onOk: function onOk() {
          self.$http.post('/financial/refund/financePass', { id: id }).then(function (res) {
            if (res.data && res.data > 0) {
              self.$Message.success('退费成功!');
              self.search();
            } else {
              this.$Message.error(res.msg);
            }
          });
        }
      });
    },
    audit: function audit(id) {
      var self = this;
      self.$http.post('/financial/refund/pass', { id: id }).then(function (res) {
        if (res.data && res.data > 0) {
          self.$Message.success('审核成功!');
          self.search();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    reBack: function reBack(id) {
      var self = this;
      self.$http.post('/financial/refund/reBack', { id: id }).then(function (res) {
        if (res.data && res.data > 0) {
          self.$Message.success('劝退成功!');
          self.search();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    showInsertRefundModal: function showInsertRefundModal() {
      this.canSave = true;
      this.refundInsertModal = true;
    },
    onRefundInsertClose: function onRefundInsertClose() {
      this.id = null;
      this.refundInsertModal = false;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value;
    },
    search: function search() {
      this.reload = new Date().getTime();
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudyAdviserRefundDashboard',
  data: function data() {
    var _this = this;

    var months = [];
    var now = new Date();
    for (var i = 0; i < 12; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      var m = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
      months.push(m);
    }
    return {
      loading: false,
      mode: 'days',
      days: 90,
      month: '',
      startDate: '',
      endDate: '',
      studyAdviserId: null,
      keyword: '',
      reasonCategory: null,
      signType: '',
      monthOptions: months,
      periodNote: '',
      periodLabel: '',
      periodDays: 90,
      privileged: true,
      advisers: [],
      kpi: {},
      alerts: [],
      rateRows: [],
      reasonRows: [],
      trend: [],
      teacherRows: [],
      studentRows: [],
      palette: ['#e5484d', '#f5a524', '#8b5cf6', '#3b82f6', '#eab308', '#30a46c'],
      teacherColumns: [{ title: '班主任', key: 'teacher', minWidth: 100 }, { title: '新生', key: 'newCount', width: 70, sortable: true }, { title: '续费', key: 'renewCount', width: 70, sortable: true }, { title: '在册', key: 'cohort', width: 70, sortable: true }, { title: '退费数', key: 'refundCount', width: 80, sortable: true }, { title: '退费率', key: 'rate', width: 90, sortable: true, render: function render(h, p) {
          return h('span', _this.pct(p.row.rate));
        } }, { title: '退费金额', key: 'refundAmount', width: 110, sortable: true, render: function render(h, p) {
          return h('span', _this.money(p.row.refundAmount));
        } }, { title: '新生退费', key: 'refundNew', width: 90 }, { title: '续费退费', key: 'refundRenew', width: 90 }, { title: '主要原因', key: 'mainReason', minWidth: 100 }, { title: '风险', key: 'riskLabel', width: 80, render: function render(h, p) {
          return h('span', { class: 'badge ' + _this.riskBadge(p.row.riskKey) }, p.row.riskLabel || '—');
        } }],
      studentColumns: [{ title: '学生', key: 'student', minWidth: 100 }, { title: '班主任', key: 'teacher', minWidth: 90 }, { title: '类型', key: 'signType', width: 70 }, { title: '报名日期', key: 'enrollDate', width: 110 }, { title: '退费日期', key: 'refundDate', width: 110 }, { title: '在册时长(天)', key: 'daysOnRoll', width: 110 }, { title: '课时进度', key: 'lessonProgress', width: 90 }, { title: '退费金额', key: 'amount', width: 100, render: function render(h, p) {
          return h('span', _this.money(p.row.amount));
        } }, { title: '退费原因', key: 'reason', minWidth: 100 }, { title: '关注点', key: 'focus', width: 90 }]
    };
  },

  computed: {
    kpiCards: function kpiCards() {
      var k = this.kpi || {};
      return [{ lab: '新生总数', val: k.newCount || 0, unit: '人', foot: '周期内新签类（按付款日）' }, { lab: '续费总数', val: k.renewCount || 0, unit: '人', foot: '周期内续费类' }, { lab: '退费总数', val: k.refundCount || 0, unit: '人', foot: '\u5F53\u671F\u7B7E\u5F53\u671F\u9000 ' + (k.refundInPeriod || 0) + ' \xB7 \u5F80\u671F\u5B66\u5458 ' + (k.refundFromOld || 0), cls: 'warn' }, { lab: '整体退费率', val: ((k.rate || 0) * 100).toFixed(1), unit: '%', foot: '\u5728\u518C ' + (k.cohort || 0) + ' \u4EBA \xB7 \u5E08\u5747 ' + (k.avgRefundPerTeacher || 0).toFixed(1) + ' \u4EBA\u9000\u8D39', cls: 'warn' }, { lab: '退费金额', val: this.money(k.refundAmount), unit: '', foot: '实际退款优先' }, { lab: '需介入班主任', val: k.needIntervene || 0, unit: '人', foot: '高风险 + 关注', cls: k.needIntervene ? 'warn' : '' }];
    },
    avgRate: function avgRate() {
      if (!this.rateRows.length) return 0;
      var s = this.rateRows.reduce(function (a, r) {
        return a + (r.rate || 0);
      }, 0);
      return s / this.rateRows.length;
    },
    avgRateLeft: function avgRateLeft() {
      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.rateRows.map(function (r) {
        return r.rate || 0;
      })).concat([0.05]));
      var scale = max * 1.18;
      return Math.min(100, this.avgRate / scale * 100);
    },
    maxReason: function maxReason() {
      return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.reasonRows.map(function (r) {
        return r.count || 0;
      })).concat([1]));
    },
    maxTrend: function maxTrend() {
      return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.trend.map(function (t) {
        return t.count || 0;
      })).concat([1]));
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    pct: function pct(v) {
      return ((v || 0) * 100).toFixed(1) + '%';
    },
    money: function money(v) {
      var n = Number(v || 0);
      if (n >= 10000) return (n / 10000).toFixed(1) + '万';
      return n.toLocaleString('zh-CN');
    },
    rateWidth: function rateWidth(rate) {
      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.rateRows.map(function (r) {
        return r.rate || 0;
      })).concat([0.05]));
      return Math.min(100, (rate || 0) / (max * 1.18) * 100);
    },
    reasonWidth: function reasonWidth(c) {
      return c / this.maxReason * 100;
    },
    trendHeight: function trendHeight(c) {
      return Math.max(4, c / this.maxTrend * 120);
    },
    levelLabel: function levelLabel(lv) {
      return { high: '高风险', mid: '关注', low: '提示' }[lv] || lv;
    },
    levelBadge: function levelBadge(lv) {
      return { high: 'b-red', mid: 'b-org', low: 'b-yel' }[lv] || 'b-gry';
    },
    riskBadge: function riskBadge(k) {
      return { high: 'b-red', mid: 'b-org', low: 'b-yel', ok: 'b-grn' }[k] || 'b-gry';
    },
    setDays: function setDays(d) {
      this.mode = 'days';this.days = d;this.month = '';this.startDate = '';this.endDate = '';this.load();
    },
    setAll: function setAll() {
      this.mode = 'all';this.month = '';this.startDate = '';this.endDate = '';this.load();
    },
    onMonth: function onMonth(v) {
      if (!v) return;
      this.mode = 'month';this.startDate = '';this.endDate = '';this.load();
    },
    onCustomDate: function onCustomDate() {
      if (!this.startDate && !this.endDate) return;
      this.mode = 'range';this.month = '';this.load();
    },
    resetRange: function resetRange() {
      this.mode = 'days';this.days = 90;this.month = '';this.startDate = '';this.endDate = '';this.load();
    },
    fmtDate: function fmtDate(v) {
      if (!v) return '';
      if (typeof v === 'string') return v.substring(0, 10);
      var d = new Date(v);
      if (isNaN(d.getTime())) return '';
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    },
    load: function load() {
      var self = this;
      self.loading = true;
      var params = {
        studyAdviserId: self.studyAdviserId || undefined,
        keyword: self.keyword || undefined,
        reasonCategory: self.reasonCategory || undefined,
        signType: self.signType || undefined
      };
      if (self.mode === 'all') {
        params.allTime = true;
      } else if (self.mode === 'month' && self.month) {
        params.month = self.month;
      } else if (self.mode === 'range') {
        params.startDate = self.fmtDate(self.startDate) || undefined;
        params.endDate = self.fmtDate(self.endDate) || undefined;
      } else {
        params.days = self.days;
      }
      self.$http.get('/financial/studyAdviserRefund/dashboard', { params: params }).then(function (res) {
        self.loading = false;
        if (!res || res.status !== 'ok') {
          self.$Message.error(res && res.msg || '看板加载失败');
          return;
        }
        var d = res.data || {};
        self.kpi = d.kpi || {};
        self.alerts = d.alerts || [];
        self.rateRows = d.rateRows || [];
        self.reasonRows = d.reasonRows || [];
        self.trend = d.trend || [];
        self.teacherRows = d.teacherRows || [];
        self.studentRows = d.studentRows || [];
        self.periodNote = d.periodNote || '';
        self.periodLabel = d.periodLabel || '';
        self.periodDays = d.periodDays || 0;
        self.privileged = !!d.privileged;
        self.advisers = d.advisers || [];
      }).catch(function () {
        self.loading = false;
        self.$Message.error('看板加载失败');
      });
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    invoiceDetail: {
      type: String,
      default: null
    },
    uid: {
      type: Number,
      default: null
    },
    orderId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      visible: this.value,
      loading: false,
      reload: 0,
      orderId: null,
      invoiceData: [],
      invoiceFormData: {
        id: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        tchName: '',
        content: '',
        state: '',
        number: '',
        amount: '',
        invoiceTime: ''
      },
      invoiceRule: {
        state: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }],
        amount: [{ required: true, message: '不能为空', trigger: 'blur' }],
        number: [{ type: 'string', required: true, message: '不能为空', trigger: 'blur' }]
      },
      invoiceTitle: [{
        title: '发票类型',
        render: function render(h, params) {
          var invoiceStatus = params.row.state;
          var invoiceStatusEnum = $constant.getEnum($constant.invoiceStatus, invoiceStatus);
          return h('div', invoiceStatusEnum && invoiceStatusEnum.text);
        }
      }, {
        title: '发票号码',
        key: 'number'
      }, {
        title: '开票金额',
        key: 'amount'
      }, {
        title: '开票日期',
        key: 'invoiceTimeStr'
      }, {
        title: '开票人',
        key: 'creatorName'
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          if (row.status === 1) {
            return h('div', [h('a', { on: { click: function click() {
                  return self.updateStatus(row.id);
                } } }, '作废')]);
          } else if (row.status === -1) {
            return '已作废';
          }
        }
      }]
    };
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    invoiceTimeChange: function invoiceTimeChange(value) {
      this.invoiceFormData.invoiceTime = value;
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    callback: function callback() {
      this.successCallback();
      this.onClose();
      this.onSuccess();
    },
    insert: function insert() {
      var self = this;
      self.$refs.form.validate(function (valid) {
        if (valid) {
          if (self.orderId) {
            self.$http.post('/financial/invoiceInsert', { orderId: self.orderId, amount: self.invoiceFormData.amount, state: self.invoiceFormData.state, number: self.invoiceFormData.number, content: self.invoiceFormData.content, invoiceTime: self.invoiceFormData.invoiceTime }).then(function (res) {
              if (res.data > 0) {
                self.$http.get('/financial/userInvoiceList?orderId=' + self.orderId).then(function (res) {
                  if (res.data) {
                    self.invoiceFormData.amount = '';
                    self.invoiceFormData.state = '';
                    self.invoiceFormData.number = '';
                    self.invoiceFormData.invoiceTime = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today();
                    self.invoiceData = res.data;
                  }
                });
              }
            });
          }
        } else {
          self.$Message.warning('表单验证失败!');
        }
      });
    },
    updateStatus: function updateStatus(val) {
      if (val) {
        var self = this;
        self.$http.post('/financial/invoiceUpdateStatus', { id: val, status: -1, orderId: self.orderId }).then(function (res) {
          if (res.data > 0) {
            self.$http.get('/financial/userInvoiceList?orderId=' + self.orderId).then(function (res) {
              if (res.data) {
                self.invoiceData = res.data;
              }
            });
          }
        });
      }
    }
  },
  watch: {
    value: function value(val) {
      var self = this;
      this.visible = val;
      if (val) {
        self.invoiceFormData.amount = '';
        self.invoiceFormData.state = '';
        self.invoiceFormData.number = '';
        self.invoiceFormData.content = '';
        self.invoiceFormData.invoiceTime = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today();
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close', val);
      }
    },
    uid: function uid(val) {
      var self = this;
      if (val) {
        self.$http.get('/saleTrace/followUp?id=' + val).then(function (res) {
          if (res.data) {
            self.invoiceFormData.id = res.data.id;
            self.invoiceFormData.adviserName = res.data.adviserName;
            self.invoiceFormData.nickname = res.data.nickname;
            self.invoiceFormData.studyAdviserName = res.data.studyAdviserName;
            self.invoiceFormData.tchName = res.data.tchName;
          }
        });
      }
    },
    orderId: function orderId(val) {
      var self = this;
      if (val) {
        self.orderId = val;
        self.$http.get('/financial/userInvoiceList?orderId=' + val).then(function (res) {
          if (res.data) {
            self.invoiceData = res.data;
          }
        });
      }
    },
    invoiceDetail: function invoiceDetail(val) {
      if (val) {
        this.invoiceFormData.content = val;
      } else {
        this.invoiceFormData.content = '';
      }
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RefundInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    },
    successCallback: {
      type: Function
    },
    canSave: {
      type: Boolean,
      default: true
    },
    orderNum: {
      type: Object
    }
  },
  data: function data() {
    var _this = this;

    return {
      visible: this.value,
      loadingInsertUser: false,
      user: {},
      formData: {
        id: '',
        uid: '',
        otherAmount: '',
        lessonFee: '',
        giftFee: '',
        serviceFee: '',
        actualRefundAmount: '',
        courseUnitPrice: 180,
        lastTchId: null,
        lastTchName: '',
        tchAdviserName: '',
        regChannel: '',
        refundAccount: '原路退回',
        refundReason: '',
        refundReasonCategory: null,
        refundRemark: '',
        orderId: ''
      },
      checkedList: [],
      dataList: [],
      rules: {
        uid: [{ type: 'integer', required: true, message: '学生id不能为空', trigger: 'blur' }],
        otherAmount: [{ type: 'number', required: true, message: '其他扣款不能为空', trigger: 'blur' }],
        lessonFee: [{ type: 'number', required: true, message: '课时费不能为空', trigger: 'blur' }],
        giftFee: [{ type: 'number', required: true, message: '礼品费不能为空', trigger: 'blur' }],
        serviceFee: [{ type: 'number', required: true, message: '手续费不能为空', trigger: 'blur' }],
        actualRefundAmount: [{ type: 'number', required: true, message: '实际退款金额不能为空', trigger: 'blur' }],
        courseUnitPrice: [{ type: 'number', required: true, message: '课时单价不能为空', trigger: 'blur' }],
        refundAccount: [{ type: 'string', required: true, message: '退款账号不能为空', trigger: 'blur' }],
        refundReason: [{ type: 'string', required: true, message: '退款原因不能为空', trigger: 'blur' }],
        refundReasonCategory: [{ type: 'number', required: true, message: '退款原因分类不能为空', trigger: 'change' }],
        orderId: [{ type: 'string', required: true, message: '请选择订单', trigger: 'blur' }],
        lastTchId: [{
          validator: function validator(rule, value, callback) {
            _this.validateRefundTeacher(rule, value, callback);
          },
          trigger: 'change'
        }]
      },
      colSpan: '',
      hiddenTd: 'hiddenTd',
      title: [{
        title: '订单编号',
        key: 'orderSn'
      }, {
        title: '订单金额',
        key: 'orderAmount'
      }, {
        title: '订单课时'
      }, {
        title: '合计课节'
      }, {
        title: '累计消耗(课时)'
      }, {
        title: '补课次数'
      }, {
        title: '课时单价',
        render: function render(h, params) {
          return h('span', params.row.courseUnitPrice);
        }
      }, {
        title: '消耗',
        key: 'costAmount'
      }, {
        title: '教材金额',
        key: 'textAmount'
      }, {
        title: '开票金额',
        key: 'invoiceAmount'
      }]
    };
  },

  computed: {
    refundTeacherRequired: function refundTeacherRequired() {
      return Number(this.formData.refundReasonCategory) === 1;
    },
    lastTeacherLabel: function lastTeacherLabel() {
      if (this.refundTeacherRequired) {
        return '退款老师';
      }
      return '最后一节课老师';
    },
    displayCostAmount: function displayCostAmount() {
      if (!this.dataList || this.dataList.length === 0) {
        return '';
      }
      var first = this.dataList[0];
      var price = this.formData.courseUnitPrice;
      if (price === '' || price == null) {
        return first.costAmount;
      }
      var num = Number(first.costCourseNum || 0);
      return this.round2(Number(price) * num);
    }
  },
  methods: {
    emptyNum: function emptyNum(val) {
      if (val === '' || val == null || isNaN(Number(val))) {
        return 0;
      }
      return Number(val);
    },
    round2: function round2(val) {
      return Math.round(this.emptyNum(val) * 100) / 100;
    },
    findSelectedOrders: function findSelectedOrders() {
      var orders = [];
      if (!this.formData.orderId || !this.dataList || this.dataList.length === 0) {
        return orders;
      }
      var ids = String(this.formData.orderId).split(',');
      var i = void 0;
      for (i = 0; i < ids.length; i++) {
        var j = void 0;
        for (j = 0; j < this.dataList.length; j++) {
          if (this.dataList[j] && this.dataList[j].orderSn === ids[i]) {
            orders.push(this.dataList[j]);
            break;
          }
        }
      }
      return orders;
    },
    selectedOrderAmount: function selectedOrderAmount() {
      var orders = this.findSelectedOrders();
      var amount = 0;
      var i = void 0;
      for (i = 0; i < orders.length; i++) {
        amount += this.emptyNum(orders[i].orderAmount);
      }
      return amount;
    },
    selectedOrderCourseNum: function selectedOrderCourseNum() {
      var orders = this.findSelectedOrders();
      var num = 0;
      var i = void 0;
      for (i = 0; i < orders.length; i++) {
        num += this.emptyNum(orders[i].orderCourseNum);
      }
      return num;
    },
    costCourseNum: function costCourseNum() {
      if (!this.dataList || this.dataList.length === 0) {
        return 0;
      }
      return this.emptyNum(this.dataList[0].costCourseNum);
    },
    recalcLessonFee: function recalcLessonFee() {
      this.formData.lessonFee = this.round2(this.emptyNum(this.formData.courseUnitPrice) * this.costCourseNum());
    },
    recalcActualRefund: function recalcActualRefund() {
      if (this.findSelectedOrders().length === 0) {
        return;
      }
      this.formData.actualRefundAmount = this.round2(this.selectedOrderAmount() - this.emptyNum(this.formData.lessonFee) - this.emptyNum(this.formData.giftFee) - this.emptyNum(this.formData.serviceFee) - this.emptyNum(this.formData.otherAmount));
    },
    applyOrderAutoFill: function applyOrderAutoFill() {
      if (this.findSelectedOrders().length === 0) {
        return;
      }
      var hours = this.selectedOrderCourseNum();
      var amount = this.selectedOrderAmount();
      this.formData.courseUnitPrice = hours === 0 ? 0 : this.round2(amount / hours);
      this.recalcLessonFee();
      this.formData.serviceFee = this.round2(amount * 0.03);
      if (!this.formData.refundAccount) {
        this.formData.refundAccount = '原路退回';
      }
      this.recalcActualRefund();
    },
    onUnitPriceChange: function onUnitPriceChange() {
      this.recalcLessonFee();
      this.recalcActualRefund();
    },
    onFeeFieldChange: function onFeeFieldChange() {
      this.recalcActualRefund();
    },
    handleCheckedOrderListChange: function handleCheckedOrderListChange(value) {
      if (value && value.length > 0) {
        this.formData.orderId = value.join(',');
        this.applyOrderAutoFill();
      } else {
        this.formData.orderId = '';
      }
    },
    selectedHasGift: function selectedHasGift() {
      var orders = this.findSelectedOrders();
      var i = void 0;
      for (i = 0; i < orders.length; i++) {
        if (orders[i].hasGift) {
          return true;
        }
      }
      return false;
    },
    validateRefundTeacher: function validateRefundTeacher(rule, value, callback) {
      if (Number(this.formData.refundReasonCategory) !== 1) {
        callback();
        return;
      }
      var idEmpty = value === null || value === undefined || value === '' || Number(value) === 0;
      var name = this.formData.lastTchName;
      var nameEmpty = name === null || name === undefined || String(name).trim() === '';
      if (idEmpty && nameEmpty) {
        callback(new Error('退款老师不能为空'));
        return;
      }
      callback();
    },
    assertGiftFeeIfNeeded: function assertGiftFeeIfNeeded() {
      if (!this.selectedHasGift()) {
        return true;
      }
      if (this.formData.giftFee === '' || this.formData.giftFee == null || Number(this.formData.giftFee) <= 0) {
        this.$Message.warning('赠送过礼品必须要填写');
        return false;
      }
      return true;
    },
    searchUserInfo: function searchUserInfo(keepFill) {
      if (!this.formData.uid) {
        return;
      }
      var self = this;
      self.$http.get('/user/queryById?uid=' + self.formData.uid).then(function (res) {
        if (res.data) {
          self.user = res.data;
        }
      });
      if (keepFill !== true) {
        self.$http.get('/financial/refund/fillByUid', { params: { uid: self.formData.uid } }).then(function (res) {
          if (res.data) {
            self.formData.lastTchId = res.data.lastTchId;
            self.formData.lastTchName = res.data.lastTchName || '';
            self.formData.tchAdviserName = res.data.tchAdviserName || '';
            self.formData.regChannel = res.data.regChannel || '';
          }
        });
      }
      var path = '/financial/refund/listByUid?uid=' + self.formData.uid;
      if (this.orderNum) {
        path += '&orderId=' + this.orderNum;
      }
      self.$http.get(path).then(function (res) {
        if (res.data) {
          self.dataList = res.data;
          self.setColSpanNum();
        }
      });
    },
    onTchChange: function onTchChange(id, name) {
      if (!id) {
        this.formData.lastTchId = null;
        this.formData.lastTchName = '';
        this.formData.tchAdviserName = '';
        return;
      }
      var self = this;
      var cleanName = (name || '').replace(/null/g, '').replace(/undefined/g, '').replace(/\s+/g, ' ').trim();
      self.formData.lastTchId = id;
      self.formData.lastTchName = cleanName ? id + '-' + cleanName : '';
      self.$http.get('/tch/queryById?tchId=' + id).then(function (res) {
        if (!res.data) {
          return;
        }
        self.formData.tchAdviserName = res.data.studyAdviserName || '';
        var first = (res.data.firstName || '').trim();
        var last = (res.data.lastName || '').trim();
        var full = (first + ' ' + last).trim();
        if (full) {
          self.formData.lastTchName = id + '-' + full;
        }
      });
    },
    insert: function insert() {
      var self = this;
      self.loadingInsertUser = true;
      self.$refs.insertUserForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsertUser = false;
          return;
        }
        if (!self.assertGiftFeeIfNeeded()) {
          self.loadingInsertUser = false;
          return;
        }
        var url = '';
        if (self.formData.id) {
          url = '/financial/refund/update';
        } else {
          url = '/financial/refund/insert';
        }
        self.$http.post(url, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
          }
          self.loadingInsertUser = false;
        }).catch(function (e) {
          self.showInsertUserModal = false;
          self.loadingInsertUser = false;
        });
      });
    },
    setColSpanNum: function setColSpanNum() {
      this.colSpan = this.dataList.length;
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    'formData.refundReasonCategory': function formDataRefundReasonCategory() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.$refs.insertUserForm) {
          _this2.$refs.insertUserForm.validateField('lastTchId');
        }
      });
    },
    id: function id(val) {
      var self = this;
      if (val) {
        this.formData.id = val;
        self.$http.get('/financial/refund/list?id=' + val).then(function (res) {
          if (res.data.data.length > 0) {
            var data = res.data.data[0];
            self.formData = data;
            self.formData.id = data.id;
            self.formData.uid = data.uid;
            self.formData.otherAmount = data.otherAmount;
            self.formData.lessonFee = data.lessonFee;
            self.formData.giftFee = data.giftFee;
            self.formData.serviceFee = data.serviceFee;
            self.formData.actualRefundAmount = data.actualRefundAmount;
            self.formData.courseUnitPrice = data.courseUnitPrice != null ? data.courseUnitPrice : 180;
            self.formData.lastTchId = data.lastTchId;
            self.formData.lastTchName = data.lastTchName;
            self.formData.tchAdviserName = data.tchAdviserName;
            self.formData.regChannel = data.regChannel;
            self.formData.refundAccount = data.refundAccount;
            self.formData.refundReason = data.refundReason;
            self.formData.refundReasonCategory = data.refundReasonCategory;
            self.formData.refundRemark = data.refundRemark;
            self.searchUserInfo(true);
          }
        });
      }
    },
    visible: function visible(val) {
      this.queryParam = {};
      this.user = {};
      this.dataList = [];
      this.checkedList = [];
      this.formData = {
        id: '',
        uid: null,
        otherAmount: '',
        lessonFee: '',
        giftFee: '',
        serviceFee: '',
        actualRefundAmount: '',
        courseUnitPrice: 180,
        lastTchId: null,
        lastTchName: '',
        tchAdviserName: '',
        regChannel: '',
        refundAccount: '原路退回',
        refundReason: '',
        refundReasonCategory: null,
        refundRemark: '',
        orderId: ''
      };
      if (val === true) {} else {
        this.$emit('on-close', val);
      }
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    var $numeral = this.$numeral;
    return {
      searchLoading: false,
      reload: 0,
      statistics: {
        totalPayment: 0,
        totalAmount: 0,
        totalDiscount: 0
      },
      queryParam: {
        uid: ''
      },
      adminUser: [],
      title: [{
        title: '学生ID、姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('br'), h('span', row.userNickname || '')]);
        }
      }, {
        title: '订单号',

        align: 'center',
        key: 'outOrderId'
      }, {
        title: '课时次数',

        align: 'center',
        key: 'num'
      }, {
        title: '课程原价',

        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.fundPackageAmount).format('0,0.00'));
        }
      }, {
        title: '优惠金额',

        key: 'discount',
        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.fundPackageDiscount).format('0,0.00'));
        }
      }, {
        title: '实付金额',

        key: 'payAmount',
        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.fundPackagePayAmount).format('0,0.00'));
        }
      }, {
        title: '支付类型',
        align: 'center',

        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.fundUserBillType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '描述',

        align: 'center',
        key: 'description'
      }, {
        title: '创建时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.adminUser = res.data;
    });
  },
  created: function created() {
    var _this = this;

    this.$http.get('/fundUserBill/statistics', { params: { state: 1 } }).then(function (res) {
      _this.statistics = res.data;
    });
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdviserSelect',
  props: {
    value: {
      type: String,
      default: 'all'
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    totalCount: function totalCount() {
      return this.list.reduce(function (n, item) {
        return n + (item.count || 0);
      }, 0);
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    load: function load() {
      var self = this;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* API_PREFIX */] + '/advisers', {}).then(function (res) {
        if (res && res.status === 'ok') {
          self.list = res.data || [];
          self.$emit('on-loaded', self.list);
        }
      });
    },
    onChange: function onChange(val) {
      var v = val == null || val === '' ? 'all' : String(val);
      if (v === this.value) {
        return;
      }
      this.$emit('input', v);
      this.$emit('on-change', v);
    }
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ContractRenewModal_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ContractRenewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_ContractRenewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tchScore__ = __webpack_require__(2);








var LEVEL_KEYS = ['open', 'expired', 'expiring', 'normal', 'all'];
var SUGGEST = {
  expired: '立即推进签署',
  expiring: '发起续签沟通，确认续签意向',
  normal: '正常履约',
  missing: '未登记合同'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchContract',
  components: { AdviserSelect: __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default.a, ContractRenewModal: __WEBPACK_IMPORTED_MODULE_2__modal_ContractRenewModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    var q = this.$route.query || {};
    return {
      adviserId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* resolveAdviserId */])(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showRenew: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    };
  },

  computed: {
    levelTabs: function levelTabs() {
      return [{ value: 'open', label: '待处理' }, { value: 'expired', label: '已超期' }, { value: 'expiring', label: (this.rules.contractAlertDays || '—') + ' 天内到期' }, { value: 'normal', label: '有效期内' }, { value: 'all', label: '全部' }];
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
    this.$root.$emit('hr-badges-refresh');

    var self = this;
    this.columns = [{
      title: '外教',
      key: 'tchName',
      width: 200,
      render: function render(h, params) {
        return self.renderTch(h, params.row);
      }
    }, {
      title: '外教运营',
      key: 'studyAdviserName',
      width: 140,
      render: function render(h, params) {
        return h('span', params.row.studyAdviserName || '未分配');
      }
    }, {
      title: '合同期',
      key: 'crtEndDate',
      width: 200,
      render: function render(h, params) {
        var row = params.row;
        if (!row.crtEndDate) {
          return h('span', { class: 'muted' }, '未登记合同');
        }
        return h('span', (row.crtBeginDate || '—') + ' ~ ' + row.crtEndDate);
      }
    }, {
      title: '剩余/超期(天)',
      key: 'daysLeft',
      width: 110,
      align: 'center',
      render: function render(h, params) {
        var row = params.row;
        if (row.daysLeft == null || row.level === 'missing') {
          return h('span', { class: 'muted' }, '—');
        }
        return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft);
      }
    }, {
      title: '状态',
      key: 'level',
      width: 230,
      render: function render(h, params) {
        var row = params.row;
        var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* CONTRACT_LEVEL */], row.level) || '—';
        if (row.level === 'expired' && row.daysLeft != null) {
          text = '超期 ' + Math.abs(row.daysLeft) + ' 天';
        } else if ((row.level === 'expiring' || row.level === 'normal') && row.daysLeft != null) {
          text = '剩 ' + row.daysLeft + ' 天';
        }
        var tags = [h('Tag', { props: { color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* CONTRACT_LEVEL */], row.level) } }, text)];
        if (row.renewCount) {
          tags.push(h('Tag', '已续签 ' + row.renewCount + ' 次'));
        }
        if (row.schedulePaused) {
          tags.push(h('Tag', { props: { color: 'yellow' } }, '已暂停排课'));
        }
        return h('div', tags);
      }
    }, {
      title: '最近续签备注',
      key: 'lastRenewNote',
      width: 180,
      render: function render(h, params) {
        return h('span', { class: params.row.lastRenewNote ? '' : 'muted' }, params.row.lastRenewNote || '—');
      }
    }, {
      title: '建议动作',
      key: 'suggest',
      width: 180,
      render: function render(h, params) {
        return h('span', { class: 'muted' }, SUGGEST[params.row.level] || '');
      }
    }, {
      title: '操作',
      key: 'action',
      width: 250,
      align: 'center',
      render: function render(h, params) {
        var row = params.row;
        return h('div', [h('Button', {
          props: { size: 'small' },
          on: { click: function click() {
              return self.openTchInfo(row.tchId);
            } }
        }, '档案'), h('Button', {
          props: { type: 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: function click() {
              return self.openRenew(row);
            } }
        }, '登记续签'), h('Button', {
          props: { size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: function click() {
              return self.confirmSchedule(row);
            } }
        }, row.schedulePaused ? '恢复排课' : '暂停排课')]);
      }
    }];
  },
  mounted: function mounted() {
    this.search();
  },

  methods: {
    renderTch: function renderTch(h, row) {
      var self = this;
      return h('div', { class: 'tch-cell' }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
        text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row),
        score: row.monthRankScore,
        onClick: function onClick() {
          return self.openTchInfo(row.tchId);
        }
      }), h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))]);
    },
    rowClassName: function rowClassName(row) {
      return row.level === 'expired' ? 'row-danger' : '';
    },
    changeLevel: function changeLevel(level) {
      this.level = level;
      this.search();
    },
    onAdviserChange: function onAdviserChange() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
      this.$root.$emit('hr-badges-refresh');
      this.search();
    },
    search: function search() {
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ level: self.level }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* adviserParam */])(self.adviserId));
      self.searchLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* API_PREFIX */] + '/contract/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {};
          self.rules = res.data.rules || {};
          self.dataList = res.data.rows || [];
          self.loadMonthRankScores();
        } else {
          self.dataList = [];
        }
      }).finally(function () {
        self.searchLoading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.dataList || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    openRenew: function openRenew(row) {
      this.currentRow = row;
      this.showRenew = true;
    },
    openTchInfo: function openTchInfo(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    confirmSchedule: function confirmSchedule(row) {
      var self = this;
      var paused = !!row.schedulePaused;
      self.$Modal.confirm({
        title: paused ? '恢复排课' : '暂停排课',
        content: '这只是工作台标记，不改老师在职状态，不挡新约课。',
        onOk: function onOk() {
          self.postSchedule(row, paused ? 'RESUME' : 'PAUSE');
        }
      });
    },
    postSchedule: function postSchedule(row, action) {
      var self = this;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* API_PREFIX */] + '/contract/schedule', {
        tchId: row.tchId,
        action: action,
        note: ''
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(action === 'PAUSE' ? '已标记暂停排课' : '已恢复排课标记');
          self.$root.$emit('hr-badges-refresh');
          self.search();
        }
      });
    },
    tchExport: function tchExport(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '');
    },
    periodExport: function periodExport(row) {
      if (!row.crtEndDate) {
        return '未登记合同';
      }
      return (row.crtBeginDate || '—') + ' ~ ' + row.crtEndDate;
    },
    daysExport: function daysExport(row) {
      if (row.daysLeft == null || row.level === 'missing') {
        return '—';
      }
      return row.daysLeft;
    },
    statusExport: function statusExport(row) {
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* CONTRACT_LEVEL */], row.level) || '—';
      if (row.level === 'expired' && row.daysLeft != null) {
        text = '超期 ' + Math.abs(row.daysLeft) + ' 天';
      } else if ((row.level === 'expiring' || row.level === 'normal') && row.daysLeft != null) {
        text = '剩 ' + row.daysLeft + ' 天';
      }
      if (row.renewCount) {
        text += ' 已续签 ' + row.renewCount + ' 次';
      }
      if (row.schedulePaused) {
        text += ' 已暂停排课';
      }
      return text;
    },
    exportCsv: function exportCsv() {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      var self = this;
      var rows = this.dataList.map(function (row) {
        return [self.tchExport(row), row.studyAdviserName || '未分配', self.periodExport(row), self.daysExport(row), self.statusExport(row), row.lastRenewNote || '—', SUGGEST[row.level] || '', '档案 登记续签 ' + (row.schedulePaused ? '恢复排课' : '暂停排课')];
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* downloadCsv */])('合同到期提醒.csv', ['外教', '外教运营', '合同期', '剩余/超期(天)', '状态', '最近续签备注', '建议动作', '操作'], rows);
    }
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ReviewSaveModal_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ReviewSaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_ReviewSaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tchScore__ = __webpack_require__(2);










var SEVERITY_ORDER = { danger: 0, warning: 1, info: 2 };
var TODO_LIST_API = {
  PROBATION: '/probation/list',
  CONTRACT: '/contract/list',
  REVIEW: '/review/list'
};
function num(v) {
  return typeof v === 'number' && !isNaN(v) ? v : 0;
}
function pendingLevel(danger, warning) {
  if (danger > 0) {
    return 'danger';
  }
  return warning > 0 ? 'warning' : 'healthy';
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchDashboard',
  components: { AdviserSelect: __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default.a, ProbationDecideModal: __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue___default.a, ReviewSaveModal: __WEBPACK_IMPORTED_MODULE_3__modal_ReviewSaveModal_vue___default.a, ContractRenewModal: __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    var q = this.$route.query || {};
    return {
      adviserId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* resolveAdviserId */])(q),
      advisers: [],
      loading: false,
      loadedAt: '',
      todayStr: this.$moment().format('YYYY-MM-DD'),
      yesterdayStr: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
      rules: {},
      kpi: {},
      todos: [],
      rankScoreSeq: 0,
      trend: [],
      probationDist: {},
      contractDist: {},
      modal: {
        probation: false,
        review: false,
        contract: false
      },
      modalRow: null,
      todoLoadingKey: '',
      showTchInfoModal: false,
      tchInfoId: null
    };
  },

  computed: {
    adviserName: function adviserName() {
      if (this.adviserId === 'all') {
        return '全部运营';
      }
      var id = this.adviserId;
      var hit = this.advisers.filter(function (a) {
        return String(a.id) === id;
      })[0];
      return hit ? hit.nickname || '未分配' : id;
    },
    metaRows: function metaRows() {
      return [{ label: '数据来源', value: '在职外教 · 处理记录' }, { label: '口径版本', value: '规则与设置（实时）' }, { label: '最近更新', value: this.loadedAt || '—' }];
    },
    chips: function chips() {
      var r = this.rules;
      return [{ label: '今天', value: this.todayStr }, { label: '外教运营', value: this.adviserName }, { label: '试用期', value: (r.probationMonths || '—') + ' 个月' }, { label: '合同提醒', value: (r.contractAlertDays || '—') + ' 天' }, { label: '回访节点', value: (r.reviewDays || '—') + ' 天' }];
    },
    kpiCards: function kpiCards() {
      var k = this.kpi;
      var r = this.rules;
      var pExpired = num(k.probationExpired);
      var pUrgent = num(k.probationUrgent);
      var rOverdue = num(k.reviewOverdue);
      var rSoon = num(k.reviewSoon);
      var cExpiring = num(k.contractExpiring);
      var cExpired = num(k.contractExpired);
      var fTeachers = num(k.followupTeachers);
      var fLessons = num(k.followupPendingLessons);
      var risk = num(k.riskHighCount);
      var clean = num(k.cleanCount);
      var pop = num(k.riskPopulation);
      var cleanRate = pop > 0 ? Math.round(clean / pop * 100) : null;
      var today = '截至 ' + this.todayStr;
      return [{
        key: 'active',
        title: '在职外教',
        value: num(k.activeCount),
        level: 'healthy',
        period: today,
        compare: '试用期 ' + num(k.probationCount) + ' 人',
        compareTone: 'neutral',
        foot: '含试用期',
        to: '/hrWorkbench/contract',
        tab: 'all'
      }, {
        key: 'probationCount',
        title: '试用期中',
        value: num(k.probationCount),
        level: 'healthy',
        period: today,
        compare: '',
        foot: '试用期 ' + (r.probationMonths || '—') + ' 个月',
        to: '/hrWorkbench/probation',
        tab: 'all'
      }, {
        key: 'probationPending',
        title: '试用期待处理',
        value: pExpired + pUrgent,
        level: pendingLevel(pExpired, pExpired + pUrgent),
        period: today,
        compare: pExpired ? '逾期 ' + pExpired + ' 人' : '',
        compareTone: 'danger',
        foot: '逾期 ' + pExpired + ' · ' + (r.probationUrgentDays || '—') + ' 天内 ' + pUrgent,
        to: '/hrWorkbench/probation',
        tab: 'open'
      }, {
        key: 'review',
        title: '新外教待回访',
        value: rOverdue + rSoon,
        level: pendingLevel(rOverdue, rOverdue + rSoon),
        period: today,
        compare: rOverdue ? '逾期 ' + rOverdue + ' 人' : '',
        compareTone: 'danger',
        foot: '逾期 ' + rOverdue + ' · 即将 ' + rSoon,
        to: '/hrWorkbench/review',
        tab: 'open'
      }, {
        key: 'contractExpiring',
        title: '合同 ' + (r.contractAlertDays || '—') + ' 天内到期',
        value: cExpiring,
        level: cExpiring > 0 ? 'warning' : 'healthy',
        period: today,
        compare: '',
        foot: '需发起续签沟通',
        to: '/hrWorkbench/contract',
        tab: 'expiring'
      }, {
        key: 'contractExpired',
        title: '合同已超期',
        value: cExpired,
        level: cExpired > 0 ? 'danger' : 'healthy',
        period: today,
        compare: '',
        foot: '存在用工合规风险',
        to: '/hrWorkbench/contract',
        tab: 'expired'
      }, {
        key: 'followup',
        title: '待跟进老师',
        value: fTeachers,
        level: fTeachers > 0 ? 'danger' : 'healthy',
        period: '昨日 ' + this.yesterdayStr,
        compare: fLessons ? fLessons + ' 节待跟进' : '',
        compareTone: 'danger',
        foot: '昨日请假/旷课 ' + fLessons + ' 节待跟进',
        to: '/hrWorkbench/followup'
      }, {
        key: 'cleanRate',
        title: '零瑕疵占比',
        value: cleanRate == null ? '—' : cleanRate + '%',
        level: cleanRate == null ? 'healthy' : cleanRate >= 80 ? 'healthy' : cleanRate >= 50 ? 'warning' : 'danger',
        period: pop > 0 ? clean + ' / ' + pop + ' 人' : '在职外教',
        compare: '',
        foot: '风险分低于异动线',
        to: '/tch/tchRiskWarningList',
        external: true
      }, {
        key: 'risk',
        title: '异动高危老师',
        value: risk,
        level: risk > 0 ? 'danger' : 'healthy',
        period: '外教异动风险监测',
        compare: '',
        foot: '点开去外教异动风险监测',
        to: '/tch/tchRiskWarningList',
        external: true
      }];
    },
    shownTodos: function shownTodos() {
      var list = this.todos.slice();
      list.sort(function (a, b) {
        var wa = SEVERITY_ORDER[a.severity] == null ? 3 : SEVERITY_ORDER[a.severity];
        var wb = SEVERITY_ORDER[b.severity] == null ? 3 : SEVERITY_ORDER[b.severity];
        return wa - wb;
      });
      return list.slice(0, 16);
    },
    trendBars: function trendBars() {
      var self = this;
      var max = 1;
      this.trend.forEach(function (d) {
        if (num(d.count) > max) {
          max = num(d.count);
        }
      });
      return this.trend.map(function (d) {
        var label = d.date ? d.date.slice(5) : '';
        if (d.date === self.todayStr) {
          label = '今日';
        } else if (d.date === self.yesterdayStr) {
          label = '昨日';
        }
        return {
          date: d.date,
          count: num(d.count),
          label: label,
          isYesterday: d.date === self.yesterdayStr,
          height: Math.round(num(d.count) / max * 110) + 4
        };
      });
    },
    probationBars: function probationBars() {
      var d = this.probationDist;
      var r = this.rules;
      return this.toBars([{ key: 'expired', label: '已逾期，待结论', value: num(d.expired), tone: 'danger' }, { key: 'urgent', label: (r.probationUrgentDays || '—') + ' 天内到期', value: num(d.urgent), tone: 'warning' }, { key: 'near', label: (r.probationNearDays || '—') + ' 天内到期', value: num(d.near), tone: 'info' }, { key: 'normal', label: '试用期中（未触发）', value: num(d.normal), tone: 'healthy' }]);
    },
    contractBars: function contractBars() {
      var d = this.contractDist;
      return this.toBars([{ key: 'expired', label: '已超期', value: num(d.expired), tone: 'danger' }, { key: 'expiring', label: (this.rules.contractAlertDays || '—') + ' 天内到期', value: num(d.expiring), tone: 'warning' }, { key: 'normal', label: '有效期内', value: num(d.normal), tone: 'healthy' }]);
    }
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
    this.$root.$emit('hr-badges-refresh');

    this.loadSummary();
  },

  methods: {
    toBars: function toBars(list) {
      var total = list.reduce(function (n, item) {
        return n + item.value;
      }, 0) || 1;
      return list.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, { percent: Math.round(item.value / total * 1000) / 10 });
      });
    },
    tchText: function tchText(t) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* tchLabel */])(t);
    },
    kindText: function kindText(kind) {
      return __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* TODO_KIND */][kind] && __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* TODO_KIND */][kind].text || kind || '';
    },
    kindButton: function kindButton(kind) {
      return __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* TODO_KIND */][kind] && __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* TODO_KIND */][kind].button || '处理';
    },
    todoKey: function todoKey(t) {
      return t.kind + '-' + t.tchId;
    },
    onAdviserChange: function onAdviserChange() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
      this.$root.$emit('hr-badges-refresh');
      this.loadSummary();
    },
    loadSummary: function loadSummary() {
      var self = this;
      self.loading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* API_PREFIX */] + '/summary', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* adviserParam */])(self.adviserId)).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          var d = res.data;
          self.rules = d.rules || {};
          self.kpi = d.kpi || {};
          self.todos = d.todos || [];
          self.trend = d.trend || [];
          self.probationDist = d.probationDist || {};
          self.contractDist = d.contractDist || {};
          self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
          self.loadMonthRankScores();
        }
      }).finally(function () {
        self.loading = false;
      });
    },
    scoreText: function scoreText(t) {
      if (!t || t.monthRankScore == null || t.monthRankScore === '') {
        return '';
      }
      var num = Number(t.monthRankScore);
      if (isNaN(num)) {
        return '';
      }
      return num.toFixed(2);
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.todos || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    routeQuery: function routeQuery(extra) {
      var q = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, extra || {});
      if (this.adviserId !== 'all') {
        q.studyAdviserId = this.adviserId;
      }
      return q;
    },
    goCard: function goCard(card) {
      if (card.external) {
        this.$router.push(card.to);
        return;
      }
      this.$router.push({ path: card.to, query: this.routeQuery(card.tab ? { level: card.tab } : null) });
    },
    handleTodo: function handleTodo(t) {
      if (t.kind === 'RISK') {
        this.$router.push('/tch/tchRiskWarningList');
        return;
      }
      if (t.kind === 'FOLLOWUP') {
        this.$router.push({
          path: '/hrWorkbench/followup',
          query: this.routeQuery({ keyword: t.tchName || String(t.tchId) })
        });
        return;
      }
      var api = TODO_LIST_API[t.kind];
      if (!api) {
        return;
      }
      var self = this;
      var key = self.todoKey(t);
      self.todoLoadingKey = key;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ level: 'open' }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* adviserParam */])(self.adviserId));
      self.$http.post(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* API_PREFIX */] + api, params).then(function (res) {
        var rows = res && res.status === 'ok' && res.data && res.data.rows || [];
        var row = rows.filter(function (r) {
          return r.tchId === t.tchId;
        })[0];
        self.openTodoModal(t.kind, row || { tchId: t.tchId, tchName: t.tchName });
      }).finally(function () {
        if (self.todoLoadingKey === key) {
          self.todoLoadingKey = '';
        }
      });
    },
    openTodoModal: function openTodoModal(kind, row) {
      this.modalRow = row;
      if (kind === 'PROBATION') {
        this.modal.probation = true;
      } else if (kind === 'CONTRACT') {
        this.modal.contract = true;
      } else if (kind === 'REVIEW') {
        this.modal.review = true;
      }
    },
    openTchInfo: function openTchInfo(tchId) {
      if (!tchId) {
        return;
      }
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    }
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_FollowupManualModal_vue__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_FollowupManualModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_FollowupManualModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tchScore__ = __webpack_require__(2);









var TYPE_TABS = [{ value: 'main', label: '请假+旷课', types: ['LEAVE', 'ABSENT', 'LOST'] }, { value: 'leave', label: '请假', types: ['LEAVE'] }, { value: 'absent', label: '旷课', types: ['ABSENT', 'LOST'] }, { value: 'late', label: '迟到', types: ['LATE'] }, { value: 'all', label: '全部类型', types: ['LEAVE', 'ABSENT', 'LOST', 'LATE'] }];
var STATUS_KEYS = ['pending', 'done', 'all'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchFollowup',
  components: { AdviserSelect: __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default.a, FollowupHandleModal: __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue___default.a, FollowupManualModal: __WEBPACK_IMPORTED_MODULE_3__modal_FollowupManualModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_4__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    var q = this.$route.query || {};
    var dateMode = 'yesterday';
    var customDate = '';
    if (q.date === 'today') {
      dateMode = 'today';
    } else if (q.date && /^\d{4}-\d{2}-\d{2}$/.test(q.date)) {
      dateMode = 'custom';
      customDate = q.date;
    }
    return {
      adviserId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* resolveAdviserId */])(q),
      dateMode: dateMode,
      customDate: customDate,
      status: STATUS_KEYS.indexOf(q.status) >= 0 ? q.status : 'pending',
      typeKey: 'main',
      keyword: q.keyword || '',
      statusTabs: [{ value: 'pending', label: '待跟进' }, { value: 'done', label: '已跟进' }, { value: 'all', label: '全部' }],
      typeTabs: TYPE_TABS,
      typeDict: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FOLLOWUP_TYPE */],
      yesterdayStr: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
      todayStr: this.$moment().format('YYYY-MM-DD'),
      searchLoading: false,
      typeCounts: {},
      pendingLessons: 0,
      groups: [],
      rankScoreSeq: 0,
      showHandle: false,
      handleLessons: [],
      showManual: false,
      showTchInfoModal: false,
      tchInfoId: null
    };
  },

  computed: {
    queryDate: function queryDate() {
      if (this.dateMode === 'today') {
        return this.todayStr;
      }
      if (this.dateMode === 'custom' && this.customDate) {
        return this.customDate;
      }
      return this.yesterdayStr;
    },
    queryTypes: function queryTypes() {
      var key = this.typeKey;
      var tab = TYPE_TABS.filter(function (t) {
        return t.value === key;
      })[0] || TYPE_TABS[0];
      return tab.types;
    },
    pendingList: function pendingList() {
      var list = [];
      var self = this;
      this.groups.forEach(function (g) {
        (g.lessons || []).forEach(function (l) {
          if (!l.handled) {
            list.push(self.toHandleItem(g, l));
          }
        });
      });
      return list;
    }
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
    this.$root.$emit('hr-badges-refresh');

    this.search();
  },

  methods: {
    tchLabel: function tchLabel(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* tchLabel */])(row);
    },
    initials: function initials(g) {
      var name = g.tchName || String(g.tchId || '?');
      return name.split(/\s+/).map(function (w) {
        return w.charAt(0);
      }).slice(0, 2).join('').toUpperCase();
    },
    isAbsentType: function isAbsentType(type) {
      return type === 'ABSENT' || type === 'LOST';
    },
    typeText: function typeText(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FOLLOWUP_TYPE */], code);
    },
    typeColor: function typeColor(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FOLLOWUP_TYPE */], code);
    },
    resultText: function resultText(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* FOLLOWUP_RESULT */], code) || '—';
    },
    changeDateMode: function changeDateMode(mode) {
      this.dateMode = mode;
      this.search();
    },
    onCustomDate: function onCustomDate(val) {
      if (!val) {
        return;
      }
      this.customDate = val;
      this.dateMode = 'custom';
      this.search();
    },
    changeStatus: function changeStatus(status) {
      this.status = status;
      this.search();
    },
    changeType: function changeType(key) {
      this.typeKey = key;
      this.search();
    },
    onAdviserChange: function onAdviserChange() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
      this.$root.$emit('hr-badges-refresh');
      this.search();
    },
    search: function search() {
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        date: self.queryDate,
        types: self.queryTypes.join(','),
        status: self.status
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* adviserParam */])(self.adviserId));
      if (self.keyword && self.keyword.trim()) {
        params.keyword = self.keyword.trim();
      }
      self.searchLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* API_PREFIX */] + '/followup/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.typeCounts = res.data.typeCounts || {};
          self.pendingLessons = res.data.pendingLessons || 0;
          self.groups = res.data.groups || [];
          self.loadMonthRankScores();
        } else {
          self.typeCounts = {};
          self.pendingLessons = 0;
          self.groups = [];
        }
      }).finally(function () {
        self.searchLoading = false;
      });
    },
    scoreText: function scoreText(g) {
      if (!g || g.monthRankScore == null || g.monthRankScore === '') {
        return '';
      }
      var num = Number(g.monthRankScore);
      if (isNaN(num)) {
        return '';
      }
      return num.toFixed(2);
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.groups || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    toHandleItem: function toHandleItem(g, l) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, l, {
        tchId: g.tchId,
        tchName: g.tchName,
        lessonDate: l.lessonDate || this.queryDate
      });
    },
    openSingle: function openSingle(g, l) {
      this.handleLessons = [this.toHandleItem(g, l)];
      this.showHandle = true;
    },
    openBatch: function openBatch() {
      if (!this.pendingList.length) {
        this.$Message.info('当前范围内没有待跟进课节');
        return;
      }
      this.handleLessons = this.pendingList.slice();
      this.showHandle = true;
    },
    openTchInfo: function openTchInfo(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    lessonRowKey: function lessonRowKey(l) {
      if (l.manualId != null) {
        return 'manual-' + l.manualId;
      }
      return String(l.lessonId) + '-' + String(l.type || '');
    },
    openManual: function openManual() {
      this.showManual = true;
    },
    exportCsv: function exportCsv() {
      var self = this;
      var rows = [];
      this.groups.forEach(function (g) {
        (g.lessons || []).forEach(function (l) {
          rows.push([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* tchLabel */])(g), g.tchId, g.country || '', g.studyAdviserName || '未分配', g.cleanDays == null ? '' : g.cleanDays, l.manual ? '' : l.beginTime || '', self.typeText(l.type), l.handled ? '已跟进' : '待跟进', l.manual ? '手动' : l.lessonId == null ? '' : l.lessonId, l.manual || l.type === 'LEAVE' ? l.type === 'LEAVE' ? '—' : '无学生' : l.studentName || l.uid || '', l.manual ? '' : l.reason || '', l.handled ? self.resultText(l.result) : '', l.note || '', l.handledBy || '', l.handledAt || '', l.handled ? '改判' : '跟进']);
        });
      });
      if (!rows.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* downloadCsv */])('出勤风险跟进-' + this.queryDate + '.csv', ['外教', '老师ID', '国家', '外教运营', '连续无异常天数', '时间', '类型', '跟进状态', '课节/请假单', '学员', '原因', '跟进结果', '跟进备注', '跟进人', '跟进时间', '操作'], rows);
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tchScore__ = __webpack_require__(2);








var LEVEL_KEYS = ['open', 'expired', 'urgent', 'near', 'all', 'done'];
var SUGGEST = {
  expired: '立即提交转正 / 延长 / 未通过结论',
  urgent: '准备转正评估材料，同步带教反馈',
  near: '关注出勤与课堂质量数据',
  normal: '尚未触发提醒',
  done: '已完成评估，归档',
  missing: '入职日缺失，不进提醒'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchProbation',
  components: { AdviserSelect: __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default.a, ProbationDecideModal: __WEBPACK_IMPORTED_MODULE_2__modal_ProbationDecideModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    var q = this.$route.query || {};
    return {
      adviserId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* resolveAdviserId */])(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showDecide: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    };
  },

  computed: {
    levelTabs: function levelTabs() {
      var r = this.rules;
      return [{ value: 'open', label: '待处理' }, { value: 'expired', label: '已逾期' }, { value: 'urgent', label: (r.probationUrgentDays || '—') + ' 天内' }, { value: 'near', label: (r.probationNearDays || '—') + ' 天内' }, { value: 'all', label: '全部' }, { value: 'done', label: '已归档' }];
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
    this.$root.$emit('hr-badges-refresh');

    var self = this;
    this.columns = [{
      title: '外教',
      key: 'tchName',
      width: 200,
      render: function render(h, params) {
        return self.renderTch(h, params.row);
      }
    }, {
      title: '外教运营',
      key: 'studyAdviserName',
      width: 140,
      render: function render(h, params) {
        return h('span', params.row.studyAdviserName || '未分配');
      }
    }, {
      title: '入职日期',
      key: 'hireDate',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.hireDate || '—');
      }
    }, {
      title: '试用期',
      key: 'probationMonths',
      width: 110,
      render: function render(h, params) {
        var row = params.row;
        if (row.probationMonths == null) {
          return h('span', '—');
        }
        var text = row.probationMonths + ' 个月';
        if (row.extendMonths) {
          text += '（含延长 ' + row.extendMonths + '）';
        }
        return h('span', text);
      }
    }, {
      title: '到期日',
      key: 'probationEnd',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.probationEnd || '—');
      }
    }, {
      title: '剩余(天)',
      key: 'daysLeft',
      width: 90,
      align: 'center',
      render: function render(h, params) {
        return self.renderDays(h, params.row);
      }
    }, {
      title: '状态',
      key: 'level',
      width: 110,
      render: function render(h, params) {
        var row = params.row;
        if (row.level === 'done' && row.lastResult) {
          return h('Tag', { props: { color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* PROBATION_RESULT */], row.lastResult) } }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* PROBATION_RESULT */], row.lastResult));
        }
        return h('Tag', { props: { color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* PROBATION_LEVEL */], row.level) } }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* PROBATION_LEVEL */], row.level) || '—');
      }
    }, {
      title: '最近结论',
      key: 'lastResult',
      width: 200,
      render: function render(h, params) {
        var row = params.row;
        if (!row.lastResult) {
          return h('span', { class: 'muted' }, '—');
        }
        return h('div', [h('div', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* PROBATION_RESULT */], row.lastResult) + (row.lastDecidedAt ? ' · ' + row.lastDecidedAt : '')), row.lastNote ? h('div', { class: 'muted' }, row.lastNote) : null]);
      }
    }, {
      title: '建议动作',
      key: 'suggest',
      width: 200,
      render: function render(h, params) {
        return h('span', { class: 'muted' }, SUGGEST[params.row.level] || '');
      }
    }, {
      title: '操作',
      key: 'action',
      width: 160,
      align: 'center',
      render: function render(h, params) {
        return self.renderAction(h, params.row);
      }
    }];
  },
  mounted: function mounted() {
    this.search();
  },

  methods: {
    renderTch: function renderTch(h, row) {
      var self = this;
      return h('div', { class: 'tch-cell' }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
        text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row),
        score: row.monthRankScore,
        onClick: function onClick() {
          return self.openTchInfo(row.tchId);
        }
      }), h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))]);
    },
    renderDays: function renderDays(h, row) {
      if (row.daysLeft == null || row.level === 'done' || row.level === 'missing') {
        return h('span', { class: 'muted' }, '—');
      }
      return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft);
    },
    rowClassName: function rowClassName(row) {
      return row.level === 'expired' ? 'row-danger' : '';
    },
    changeLevel: function changeLevel(level) {
      this.level = level;
      this.search();
    },
    onAdviserChange: function onAdviserChange() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
      this.$root.$emit('hr-badges-refresh');
      this.search();
    },
    search: function search() {
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ level: self.level }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* adviserParam */])(self.adviserId));
      self.searchLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* API_PREFIX */] + '/probation/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {};
          self.rules = res.data.rules || {};
          self.dataList = res.data.rows || [];
          self.loadMonthRankScores();
        } else {
          self.dataList = [];
        }
      }).finally(function () {
        self.searchLoading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.dataList || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    openDecide: function openDecide(row) {
      this.currentRow = row;
      this.showDecide = true;
    },
    openTchInfo: function openTchInfo(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    renderAction: function renderAction(h, row) {
      var self = this;
      var nodes = [h('Button', {
        props: { size: 'small' },
        on: { click: function click() {
            return self.openTchInfo(row.tchId);
          } }
      }, '档案')];
      if (row.level !== 'missing') {
        nodes.push(h('Button', {
          props: { type: 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: function click() {
              return self.openDecide(row);
            } }
        }, row.level === 'done' ? '改判' : '处理'));
      }
      return h('div', nodes);
    },
    tchExport: function tchExport(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '');
    },
    monthsExport: function monthsExport(row) {
      if (row.probationMonths == null) {
        return '—';
      }
      var text = row.probationMonths + ' 个月';
      if (row.extendMonths) {
        text += '（含延长 ' + row.extendMonths + '）';
      }
      return text;
    },
    daysExport: function daysExport(row) {
      if (row.daysLeft == null || row.level === 'done' || row.level === 'missing') {
        return '—';
      }
      return row.daysLeft;
    },
    statusExport: function statusExport(row) {
      if (row.level === 'done' && row.lastResult) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* PROBATION_RESULT */], row.lastResult);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* PROBATION_LEVEL */], row.level) || '—';
    },
    lastExport: function lastExport(row) {
      if (!row.lastResult) {
        return '—';
      }
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* PROBATION_RESULT */], row.lastResult) + (row.lastDecidedAt ? ' · ' + row.lastDecidedAt : '');
      if (row.lastNote) {
        text += ' ' + row.lastNote;
      }
      return text;
    },
    actionExport: function actionExport(row) {
      if (row.level === 'missing') {
        return '档案';
      }
      return '档案 ' + (row.level === 'done' ? '改判' : '处理');
    },
    exportCsv: function exportCsv() {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      var self = this;
      var rows = this.dataList.map(function (row) {
        return [self.tchExport(row), row.studyAdviserName || '未分配', row.hireDate || '—', self.monthsExport(row), row.probationEnd || '—', self.daysExport(row), self.statusExport(row), self.lastExport(row), SUGGEST[row.level] || '', self.actionExport(row)];
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* downloadCsv */])('试用期到期提醒.csv', ['外教', '外教运营', '入职日期', '试用期', '到期日', '剩余(天)', '状态', '最近结论', '建议动作', '操作'], rows);
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ReviewSaveModal_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ReviewSaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_ReviewSaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tchScore__ = __webpack_require__(2);








var LEVEL_KEYS = ['open', 'overdue', 'soon', 'done', 'all'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchReview',
  components: { AdviserSelect: __WEBPACK_IMPORTED_MODULE_1__AdviserSelect_vue___default.a, ReviewSaveModal: __WEBPACK_IMPORTED_MODULE_2__modal_ReviewSaveModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_3__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    var q = this.$route.query || {};
    return {
      adviserId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* resolveAdviserId */])(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      levelTabs: [{ value: 'open', label: '待回访' }, { value: 'overdue', label: '已逾期' }, { value: 'soon', label: '即将' }, { value: 'done', label: '已完成' }, { value: 'all', label: '全部' }],
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showReview: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    };
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
    this.$root.$emit('hr-badges-refresh');

    var self = this;
    this.columns = [{
      title: '外教',
      key: 'tchName',
      width: 200,
      render: function render(h, params) {
        return self.renderTch(h, params.row);
      }
    }, {
      title: '外教运营',
      key: 'studyAdviserName',
      width: 140,
      render: function render(h, params) {
        return h('span', params.row.studyAdviserName || '未分配');
      }
    }, {
      title: '入职日期',
      key: 'hireDate',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.hireDate || '—');
      }
    }, {
      title: '回访节点日',
      key: 'reviewDue',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.reviewDue || '—');
      }
    }, {
      title: '距节点(天)',
      key: 'daysLeft',
      width: 95,
      align: 'center',
      render: function render(h, params) {
        var row = params.row;
        if (row.level === 'done' || row.daysLeft == null) {
          return h('span', { class: 'muted' }, '—');
        }
        return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft);
      }
    }, {
      title: '状态',
      key: 'level',
      width: 110,
      render: function render(h, params) {
        return h('Tag', { props: { color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* REVIEW_LEVEL */], params.row.level) } }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* REVIEW_LEVEL */], params.row.level) || '—');
      }
    }, {
      title: '最近回访结论',
      key: 'lastReview',
      width: 160,
      render: function render(h, params) {
        var r = params.row.lastReview;
        if (!r) {
          return h('span', { class: 'muted' }, '—');
        }
        return h('div', { class: 'tch-cell' }, [h('Tag', { props: { color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* REVIEW_RESULT */], r.result) } }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* REVIEW_RESULT */], r.result) || '—'), h('div', { class: 'muted' }, (r.reviewDate || '') + ' · ' + (r.channel || '') + (r.creatorName ? ' · ' + r.creatorName : ''))]);
      }
    }, {
      title: '回访记录',
      key: 'note',
      width: 220,
      render: function render(h, params) {
        var r = params.row.lastReview;
        if (!r || !r.note && !r.nextAction) {
          return h('span', { class: 'muted' }, '—');
        }
        return h('div', [r.note ? h('div', r.note) : null, r.nextAction ? h('div', { class: 'muted' }, '后续：' + r.nextAction) : null]);
      }
    }, {
      title: '操作',
      key: 'action',
      width: 190,
      align: 'center',
      render: function render(h, params) {
        var row = params.row;
        var done = !!row.lastReview;
        return h('div', [h('Button', {
          props: { size: 'small' },
          on: { click: function click() {
              return self.openTchInfo(row.tchId);
            } }
        }, '档案'), h('Button', {
          props: { type: done ? 'ghost' : 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: function click() {
              return self.openReview(row);
            } }
        }, done ? '更新回访' : '登记回访')]);
      }
    }];
  },
  mounted: function mounted() {
    this.search();
  },

  methods: {
    renderTch: function renderTch(h, row) {
      var self = this;
      return h('div', { class: 'tch-cell' }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
        text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row),
        score: row.monthRankScore,
        onClick: function onClick() {
          return self.openTchInfo(row.tchId);
        }
      }), h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))]);
    },
    rowClassName: function rowClassName(row) {
      return row.level === 'overdue' ? 'row-danger' : '';
    },
    changeLevel: function changeLevel(level) {
      this.level = level;
      this.search();
    },
    onAdviserChange: function onAdviserChange() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* writeStoredAdviserId */])(this.adviserId);
      this.$root.$emit('hr-badges-refresh');
      this.search();
    },
    search: function search() {
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ level: self.level }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* adviserParam */])(self.adviserId));
      self.searchLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* API_PREFIX */] + '/review/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {};
          self.rules = res.data.rules || {};
          self.dataList = res.data.rows || [];
          self.loadMonthRankScores();
        } else {
          self.dataList = [];
        }
      }).finally(function () {
        self.searchLoading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.dataList || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    openReview: function openReview(row) {
      this.currentRow = row;
      this.showReview = true;
    },
    openTchInfo: function openTchInfo(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    tchExport: function tchExport(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* tchLabel */])(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '');
    },
    daysExport: function daysExport(row) {
      if (row.level === 'done' || row.daysLeft == null) {
        return '—';
      }
      return row.daysLeft;
    },
    lastExport: function lastExport(row) {
      var r = row.lastReview;
      if (!r) {
        return '—';
      }
      return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* REVIEW_RESULT */], r.result) || '—') + ' ' + (r.reviewDate || '') + ' · ' + (r.channel || '') + (r.creatorName ? ' · ' + r.creatorName : '');
    },
    noteExport: function noteExport(row) {
      var r = row.lastReview;
      if (!r || !r.note && !r.nextAction) {
        return '—';
      }
      var parts = [];
      if (r.note) {
        parts.push(r.note);
      }
      if (r.nextAction) {
        parts.push('后续：' + r.nextAction);
      }
      return parts.join(' ');
    },
    exportCsv: function exportCsv() {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      var self = this;
      var rows = this.dataList.map(function (row) {
        var done = !!row.lastReview;
        return [self.tchExport(row), row.studyAdviserName || '未分配', row.hireDate || '—', row.reviewDue || '—', self.daysExport(row), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* REVIEW_LEVEL */], row.level) || '—', self.lastExport(row), self.noteExport(row), '档案 ' + (done ? '更新回访' : '登记回访')];
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* downloadCsv */])('新外教跟进.csv', ['外教', '外教运营', '入职日期', '回访节点日', '距节点(天)', '状态', '最近回访结论', '回访记录', '操作'], rows);
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tchScore__ = __webpack_require__(2);






var FIELDS = [{ key: 'probationMonths', label: '试用期时长', unit: '个月', min: 1, max: 24, desc: '入职日起试用期长度，到期日按整月对日（月末收敛）' }, { key: 'probationNearDays', label: '试用期首次提醒', unit: '天', min: 1, max: 90, desc: '到期前多少天进入提醒（须大于二次提醒）' }, { key: 'probationUrgentDays', label: '试用期二次提醒', unit: '天', min: 1, max: 90, desc: '到期前多少天升级为紧急' }, { key: 'contractAlertDays', label: '合同提醒提前量', unit: '天', min: 1, max: 365, desc: '合同到期前多少天触发续签提醒' }, { key: 'reviewDays', label: '新外教回访节点', unit: '天', min: 1, max: 90, desc: '入职后第几天需完成回访' }, { key: 'reviewAlertDays', label: '回访提前提示', unit: '天', min: 1, max: 90, desc: '节点前多少天开始出现在待回访清单' }];
var RESULT_DICT = {
  PROBATION: __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* PROBATION_RESULT */],
  REVIEW: __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* REVIEW_RESULT */],
  CONTRACT: {},
  FOLLOWUP: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* FOLLOWUP_RESULT */]
};
function emptyForm() {
  return {
    probationMonths: null,
    probationNearDays: null,
    probationUrgentDays: null,
    contractAlertDays: null,
    reviewDays: null,
    reviewAlertDays: null,
    reviewStartDate: ''
  };
}
function emptyRiskForm() {
  return {
    lookbackMonths: null,
    anomalyScore: null,
    high: null
  };
}
function isInt(v) {
  return typeof v === 'number' && Math.floor(v) === v;
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchSettings',
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fields: FIELDS,
      form: emptyForm(),
      ruleLoading: false,
      ruleSaving: false,
      riskForm: emptyRiskForm(),
      riskLoading: false,
      riskSaving: false,
      logLimit: 50,
      logList: [],
      logLoading: false,
      rankScoreSeq: 0,
      logColumns: []
    };
  },
  created: function created() {
    this.logColumns = [{ title: '时间', key: 'gmtCreate', width: 160 }, {
      title: '操作人',
      key: 'creatorName',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.creatorName || '—');
      }
    }, {
      title: '老师',
      key: 'tchName',
      width: 200,
      render: function render(h, params) {
        var row = params.row;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* tchLabel */])(row) + (row.tchId ? '（' + row.tchId + '）' : ''),
          score: row.monthRankScore
        });
      }
    }, {
      title: '类型',
      key: 'bizType',
      width: 120,
      render: function render(h, params) {
        var row = params.row;
        var text = __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* BIZ_TYPE */][row.bizType] || row.bizType || '—';
        if (row.bizType === 'FOLLOWUP' && row.refType) {
          text += ' · ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FOLLOWUP_TYPE */], row.refType);
        }
        return h('span', text);
      }
    }, {
      title: '内容',
      key: 'note',
      width: 280,
      render: function render(h, params) {
        var row = params.row;
        var parts = [];
        var dict = RESULT_DICT[row.bizType] || {};
        if (row.result) {
          parts.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* codeText */])(dict, row.result));
        }
        if (row.bizType === 'REVIEW' && row.refType) {
          parts.push(row.refType);
        }
        if (row.note) {
          parts.push(row.note);
        }
        return h('span', parts.join(' · ') || '—');
      }
    }];
  },
  mounted: function mounted() {
    this.loadRules();
    this.loadRiskRules();
    this.loadLogs();
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.logList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    loadRules: function loadRules() {
      var self = this;
      self.ruleLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* API_PREFIX */] + '/rules/get', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.applyRules(res.data);
        }
      }).finally(function () {
        self.ruleLoading = false;
      });
    },
    applyRules: function applyRules(data) {
      var form = emptyForm();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(form).forEach(function (k) {
        if (data[k] != null) {
          form[k] = data[k];
        }
      });
      if (form.reviewDays == null) {
        form.reviewDays = 7;
      }
      this.form = form;
    },
    validate: function validate() {
      var f = this.form;
      for (var i = 0; i < FIELDS.length; i++) {
        var item = FIELDS[i];
        var v = f[item.key];
        if (!isInt(v) || v < item.min || v > item.max) {
          return item.label + '需为 ' + item.min + '–' + item.max + ' 的整数';
        }
      }
      if (f.probationNearDays <= f.probationUrgentDays) {
        return '试用期首次提醒天数须大于二次提醒天数';
      }
      if (f.reviewAlertDays > f.reviewDays) {
        return '回访提前提示天数须不大于回访节点天数';
      }
      if (!f.reviewStartDate) {
        return '请选择回访规则上线日';
      }
      return '';
    },
    saveRules: function saveRules() {
      var self = this;
      var msg = self.validate();
      if (msg) {
        self.$Message.warning(msg);
        return;
      }
      self.ruleSaving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* API_PREFIX */] + '/rules/save', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.form)).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('规则已保存');
          self.$root.$emit('hr-badges-refresh');
          if (res.data) {
            self.applyRules(res.data);
          }
        }
      }).finally(function () {
        self.ruleSaving = false;
      });
    },
    loadRiskRules: function loadRiskRules() {
      var self = this;
      self.riskLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* API_PREFIX */] + '/risk-rules/get', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.applyRisk(res.data);
        }
      }).finally(function () {
        self.riskLoading = false;
      });
    },
    applyRisk: function applyRisk(data) {
      var form = emptyRiskForm();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(form).forEach(function (k) {
        if (data[k] != null && data[k] !== '') {
          form[k] = Number(data[k]);
        }
      });
      this.riskForm = form;
    },
    validateRisk: function validateRisk() {
      var f = this.riskForm;
      if (!isInt(f.lookbackMonths) || f.lookbackMonths < 6 || f.lookbackMonths > 36) {
        return '回溯月数需为 6–36 的整数';
      }
      if (!isInt(f.anomalyScore) || f.anomalyScore < 1) {
        return '异动线需为正整数';
      }
      if (!isInt(f.high) || f.high < 1) {
        return '高危线需为正整数';
      }
      return '';
    },
    saveRiskRules: function saveRiskRules() {
      var self = this;
      var msg = self.validateRisk();
      if (msg) {
        self.$Message.warning(msg);
        return;
      }
      self.riskSaving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* API_PREFIX */] + '/risk-rules/save', {
        lookbackMonths: self.riskForm.lookbackMonths,
        anomalyScore: self.riskForm.anomalyScore,
        high: self.riskForm.high
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('异动阈值已保存');
          self.$root.$emit('hr-badges-refresh');
          if (res.data) {
            self.applyRisk(res.data);
          }
        }
      }).finally(function () {
        self.riskSaving = false;
      });
    },
    loadLogs: function loadLogs() {
      var self = this;
      self.logLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* API_PREFIX */] + '/log/list', { limit: self.logLimit }).then(function (res) {
        if (res && res.status === 'ok') {
          self.logList = res.data || [];
          self.loadMonthRankScores();
        }
      }).finally(function () {
        self.logLoading = false;
      });
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HrWorkbenchSettings_vue__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HrWorkbenchSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HrWorkbenchSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ReviewSaveModal_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ReviewSaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_ReviewSaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ProbationDecideModal_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ProbationDecideModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_ProbationDecideModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tchScore__ = __webpack_require__(2);










var KIND_ORDER = ['REVIEW', 'FOLLOWUP', 'PROBATION', 'CONTRACT'];
var KIND_META = {
  REVIEW: { text: '新外教回访', color: 'blue', action: '登记回访' },
  FOLLOWUP: { text: '出勤风险跟进', color: 'red', action: '登记跟进' },
  PROBATION: { text: '试用期结论', color: 'yellow', action: '试用期结论' },
  CONTRACT: { text: '合同续签', color: 'red', action: '登记续签' }
};
function _num(v) {
  var n = Number(v);
  return isFinite(n) ? n : 0;
}
function kindKey(kind) {
  return kind == null ? '' : String(kind).toUpperCase();
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HrWorkbenchSupervise',
  components: { HrWorkbenchSettings: __WEBPACK_IMPORTED_MODULE_0__HrWorkbenchSettings_vue___default.a, ReviewSaveModal: __WEBPACK_IMPORTED_MODULE_1__modal_ReviewSaveModal_vue___default.a, FollowupHandleModal: __WEBPACK_IMPORTED_MODULE_2__modal_FollowupHandleModal_vue___default.a, ProbationDecideModal: __WEBPACK_IMPORTED_MODULE_3__modal_ProbationDecideModal_vue___default.a, ContractRenewModal: __WEBPACK_IMPORTED_MODULE_4__modal_ContractRenewModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_5__teacher_modal_TchInfoModal_vue___default.a },
  data: function data() {
    return {
      loading: false,
      overallRate: null,
      totalDue: 0,
      totalDone: 0,
      totalOpen: 0,
      operatorOpenCount: 0,
      operatorCount: 0,
      maxOverdueDays: 0,
      groups: [],
      operators: [],
      items: [],
      kindFilter: 'all',
      operatorFilter: 'all',
      currentItem: null,
      handleLessons: [],
      showTchInfoModal: false,
      tchInfoId: null,
      rankScoreSeq: 0,
      modal: {
        review: false,
        followup: false,
        probation: false,
        contract: false
      },
      operatorColumns: [],
      itemColumns: []
    };
  },

  computed: {
    summaryCards: function summaryCards() {
      var totalDue = _num(this.totalDue);
      var totalDone = _num(this.totalDone);
      return [{
        key: 'rate',
        label: '可量化动作闭环率',
        value: this.formatRate(this.overallRate),
        foot: '回访 + 出勤 ' + totalDone + ' / ' + totalDue
      }, {
        key: 'open',
        label: '未闭环动作',
        value: _num(this.totalOpen),
        foot: '四类未闭环合计'
      }, {
        key: 'operator',
        label: '涉及外管',
        value: _num(this.operatorOpenCount),
        foot: '未闭环明细涉及（含未分配）· 共 ' + _num(this.operatorCount) + ' 位'
      }, {
        key: 'overdue',
        label: '最长逾期',
        value: _num(this.maxOverdueDays) + ' 天',
        foot: '明细最大逾期天数'
      }];
    },
    groupCards: function groupCards() {
      var list = (this.groups || []).slice();
      list.sort(function (a, b) {
        var ia = KIND_ORDER.indexOf(kindKey(a.key));
        var ib = KIND_ORDER.indexOf(kindKey(b.key));
        if (ia < 0) {
          ia = KIND_ORDER.length;
        }
        if (ib < 0) {
          ib = KIND_ORDER.length;
        }
        return ia - ib;
      });
      return list;
    },
    operatorRows: function operatorRows() {
      var list = (this.operators || []).slice();
      list.sort(function (a, b) {
        return _num(b.openTasks) - _num(a.openTasks);
      });
      return list;
    },
    operatorOptions: function operatorOptions() {
      var options = (this.operators || []).map(function (op) {
        return {
          value: String(op.id),
          label: op.name || '未分配'
        };
      });
      var seen = {};
      options.forEach(function (op) {
        seen[op.value] = true;
      });
      var extra = [];
      var items = this.items || [];
      items.forEach(function (item) {
        var value = String(item.operatorId);
        if (!seen[value]) {
          seen[value] = true;
          extra.push({ value: value, label: item.operatorName || '未分配' });
        }
      });
      return options.concat(extra);
    },
    kindOptions: function kindOptions() {
      return KIND_ORDER.map(function (key) {
        return { key: key, label: KIND_META[key].text };
      });
    },
    filteredItems: function filteredItems() {
      var self = this;
      return (this.items || []).filter(function (item) {
        if (self.kindFilter !== 'all' && kindKey(item.kind) !== self.kindFilter) {
          return false;
        }
        if (self.operatorFilter !== 'all' && String(item.operatorId) !== self.operatorFilter) {
          return false;
        }
        return true;
      });
    },
    modalRow: function modalRow() {
      var item = this.currentItem;
      if (!item) {
        return null;
      }
      var kind = kindKey(item.kind);
      var overdue = _num(item.overdueDays);
      return {
        tchId: item.tchId,
        tchName: item.tchName,
        country: item.country,
        reviewDue: kind === 'REVIEW' ? item.due : '',
        probationEnd: kind === 'PROBATION' ? item.due : '',
        crtEndDate: kind === 'CONTRACT' ? item.due : '',
        daysLeft: overdue > 0 ? -overdue : 0
      };
    }
  },
  created: function created() {
    var self = this;
    this.operatorColumns = [{
      title: '外管',
      key: 'name',
      width: 190,
      render: function render(h, params) {
        var op = params.row;
        return h('div', { class: 'op-cell' }, [h('span', { class: 'op-name' }, op.name || '未分配'), h('a', {
          class: 'op-link',
          attrs: { href: 'javascript:;' },
          on: { click: function click() {
              return self.onlyOperator(op);
            } }
        }, '只看 TA')]);
      }
    }, {
      title: '在管老师',
      key: 'active',
      width: 95,
      align: 'center',
      render: function render(h, params) {
        return h('span', _num(params.row.active));
      }
    }, {
      title: '试用期中',
      key: 'onProbation',
      width: 95,
      align: 'center',
      render: function render(h, params) {
        return h('span', _num(params.row.onProbation));
      }
    }, {
      title: '回访逾期',
      key: 'reviewOpen',
      width: 95,
      align: 'center',
      render: function render(h, params) {
        return self.renderCount(h, params.row.reviewOpen);
      }
    }, {
      title: '昨日跟进未登记',
      key: 'followupOpen',
      width: 125,
      align: 'center',
      render: function render(h, params) {
        return self.renderCount(h, params.row.followupOpen);
      }
    }, {
      title: '试用期未结论',
      key: 'probationOpen',
      width: 110,
      align: 'center',
      render: function render(h, params) {
        return self.renderCount(h, params.row.probationOpen);
      }
    }, {
      title: '合同超期',
      key: 'contractOpen',
      width: 95,
      align: 'center',
      render: function render(h, params) {
        return self.renderCount(h, params.row.contractOpen);
      }
    }, {
      title: '风险（高危 / 监测人数）',
      key: 'risk',
      width: 170,
      align: 'center',
      render: function render(h, params) {
        return h('span', _num(params.row.riskHigh) + ' / ' + _num(params.row.riskTotal));
      }
    }, {
      title: '未闭环合计',
      key: 'openTasks',
      width: 105,
      align: 'center',
      render: function render(h, params) {
        return self.renderOpenTasks(h, params.row.openTasks);
      }
    }];
    this.itemColumns = [{
      title: '动作类型',
      key: 'kind',
      width: 130,
      render: function render(h, params) {
        return self.renderKind(h, params.row.kind);
      }
    }, {
      title: '外管',
      key: 'operatorName',
      width: 130,
      render: function render(h, params) {
        return h('span', params.row.operatorName || '未分配');
      }
    }, {
      title: '外教',
      key: 'tchName',
      width: 190,
      render: function render(h, params) {
        return self.renderTch(h, params.row);
      }
    }, {
      title: '事项',
      key: 'title',
      minWidth: 260,
      render: function render(h, params) {
        return self.renderTitle(h, params.row);
      }
    }, {
      title: '应完成日',
      key: 'due',
      width: 110,
      render: function render(h, params) {
        return h('span', params.row.due || '—');
      }
    }, {
      title: '逾期天数',
      key: 'overdueDays',
      width: 100,
      align: 'center',
      render: function render(h, params) {
        return self.renderOverdue(h, params.row.overdueDays);
      }
    }, {
      title: '操作',
      key: 'action',
      width: 200,
      align: 'center',
      render: function render(h, params) {
        return self.renderAction(h, params.row);
      }
    }];
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: function num(v) {
      return _num(v);
    },
    formatRate: function formatRate(v) {
      if (v == null || v === '') {
        return '—';
      }
      var n = Number(v);
      if (!isFinite(n)) {
        return '—';
      }
      return Math.round(n * 10) / 10 + '%';
    },
    kindText: function kindText(kind) {
      var meta = KIND_META[kindKey(kind)];
      return meta ? meta.text : kind || '—';
    },
    kindColor: function kindColor(kind) {
      var meta = KIND_META[kindKey(kind)];
      return meta ? meta.color : 'default';
    },
    kindAction: function kindAction(kind) {
      var meta = KIND_META[kindKey(kind)];
      return meta ? meta.action : '';
    },
    renderCount: function renderCount(h, value) {
      var n = _num(value);
      return h('span', { class: n > 0 ? 'text-danger' : 'muted' }, n);
    },
    renderOpenTasks: function renderOpenTasks(h, value) {
      var n = _num(value);
      return h('b', { class: n > 0 ? 'text-danger' : '' }, n);
    },
    renderKind: function renderKind(h, kind) {
      return h('Tag', { props: { color: this.kindColor(kind) } }, this.kindText(kind));
    },
    renderTch: function renderTch(h, row) {
      var self = this;
      return h('div', { class: 'tch-cell' }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
        text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* tchLabel */])(row),
        score: row.monthRankScore,
        onClick: function onClick() {
          return self.openTchInfo(row.tchId);
        }
      }), h('div', { class: 'muted' }, 'ID ' + row.tchId)]);
    },
    renderTitle: function renderTitle(h, row) {
      return h('div', { class: 'tch-cell' }, [h('div', row.title || '—'), row.detail ? h('div', { class: 'muted' }, row.detail) : null]);
    },
    renderOverdue: function renderOverdue(h, value) {
      var n = _num(value);
      return h('b', { class: n > 0 ? 'text-danger' : '' }, n);
    },
    renderAction: function renderAction(h, row) {
      var self = this;
      var nodes = [h('Button', {
        props: { size: 'small' },
        on: { click: function click() {
            return self.openTchInfo(row.tchId);
          } }
      }, '档案')];
      var action = self.kindAction(row.kind);
      if (action) {
        nodes.push(h('Button', {
          props: { type: 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: function click() {
              return self.openItem(row);
            } }
        }, action));
      }
      return h('div', nodes);
    },
    load: function load() {
      var self = this;
      self.loading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* API_PREFIX */] + '/supervise', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          var d = res.data;
          self.overallRate = d.overallRate;
          self.totalDue = d.totalDue || 0;
          self.totalDone = d.totalDone || 0;
          self.totalOpen = d.totalOpen || 0;
          self.operatorOpenCount = d.operatorOpenCount || 0;
          self.operatorCount = d.operatorCount || 0;
          self.maxOverdueDays = d.maxOverdueDays || 0;
          self.groups = d.groups || [];
          self.operators = d.operators || [];
          self.items = d.items || [];
          self.loadMonthRankScores();
        }
      }).finally(function () {
        self.loading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.items || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    resetFilter: function resetFilter() {
      this.kindFilter = 'all';
      this.operatorFilter = 'all';
    },
    onlyOperator: function onlyOperator(op) {
      this.operatorFilter = String(op.id);
    },
    openItem: function openItem(item) {
      var kind = kindKey(item.kind);
      this.currentItem = item;
      if (kind === 'REVIEW') {
        this.modal.review = true;
      } else if (kind === 'FOLLOWUP') {
        this.handleLessons = [this.toFollowupLesson(item)];
        this.modal.followup = true;
      } else if (kind === 'PROBATION') {
        this.modal.probation = true;
      } else if (kind === 'CONTRACT') {
        this.modal.contract = true;
      }
    },
    toFollowupLesson: function toFollowupLesson(item) {
      return {
        lessonId: item.lessonId,
        manualId: item.manualId,
        manual: item.manualId != null,
        type: item.refType,
        tchId: item.tchId,
        tchName: item.tchName,
        lessonDate: item.lessonDate || item.due,
        reason: item.detail,
        handled: false
      };
    },
    openTchInfo: function openTchInfo(tchId) {
      if (!tchId) {
        return;
      }
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContractRenewModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      visible: false,
      saving: false,
      form: {
        crtBeginDate: '',
        crtEndDate: '',
        note: ''
      }
    };
  },

  computed: {
    tchText: function tchText() {
      var r = this.row;
      if (!r) {
        return '—';
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* tchLabel */])(r) + '（ID ' + r.tchId + '）';
    },
    title: function title() {
      return '登记续签 · ' + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* tchLabel */])(this.row) || '');
    },
    daysLabel: function daysLabel() {
      var d = this.row && this.row.daysLeft;
      if (d == null) {
        return '';
      }
      return d < 0 ? '已超期 ' + Math.abs(d) + ' 天' : '剩 ' + d + ' 天';
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.resetForm();
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      var end = this.row && this.row.crtEndDate;
      var begin = end ? this.$moment(end, 'YYYY-MM-DD').add(1, 'days') : this.$moment();
      this.form = {
        crtBeginDate: begin.format('YYYY-MM-DD'),
        crtEndDate: this.defaultEnd(begin.format('YYYY-MM-DD')),
        note: ''
      };
    },
    defaultEnd: function defaultEnd(begin) {
      return this.$moment(begin, 'YYYY-MM-DD').add(12, 'months').format('YYYY-MM-DD');
    },
    onBeginChange: function onBeginChange(val) {
      this.form.crtBeginDate = val;
      if (val) {
        this.form.crtEndDate = this.defaultEnd(val);
      }
    },
    submit: function submit() {
      var self = this;
      var f = self.form;
      if (!self.row || !self.row.tchId) {
        return;
      }
      if (!f.crtBeginDate || !f.crtEndDate) {
        self.$Message.warning('请填写完整的新合同起止日期');
        return;
      }
      if (f.crtBeginDate > f.crtEndDate) {
        self.$Message.warning('到期日不能早于起始日');
        return;
      }
      self.saving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* API_PREFIX */] + '/contract/renew', {
        tchId: self.row.tchId,
        crtBeginDate: f.crtBeginDate,
        crtEndDate: f.crtEndDate,
        note: f.note
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('续签已登记，提醒解除');
          self.visible = false;
          self.$root.$emit('hr-badges-refresh');
          self.$emit('on-success');
        }
      }).finally(function () {
        self.saving = false;
      });
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FollowupHandleModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },

    lessons: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      saving: false,
      resultDict: __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FOLLOWUP_RESULT_OPTIONS */],
      form: {
        result: 'NORMAL_CLASS',
        note: ''
      }
    };
  },

  computed: {
    single: function single() {
      return this.lessons.length === 1 ? this.lessons[0] : null;
    },
    title: function title() {
      if (this.single) {
        return '出勤跟进 · ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(this.single);
      }
      return '批量跟进 ' + this.lessons.length + ' 节课';
    },
    teacherNames: function teacherNames() {
      var seen = {};
      var names = [];
      this.lessons.forEach(function (l) {
        var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(l);
        if (n && !seen[n]) {
          seen[n] = 1;
          names.push(n);
        }
      });
      return names.join('、');
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        var s = this.single;
        var next = 'NORMAL_CLASS';
        if (s && s.handled && s.result && __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FOLLOWUP_RESULT_OPTIONS */][s.result]) {
          next = s.result;
        }
        this.form = {
          result: next,
          note: s && s.handled ? s.note || '' : ''
        };
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    tchText: function tchText(l) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(l) + '（ID ' + l.tchId + '）';
    },
    singleMeta: function singleMeta(l) {
      if (!l) return '';
      if (l.manual) return '无学生';
      if (l.type === 'LEAVE') return '请假单 ' + l.lessonId;
      return '课节 ' + l.lessonId + ' · 学员 ' + (l.studentName || l.uid || '—');
    },
    typeText: function typeText(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FOLLOWUP_TYPE */], code);
    },
    typeColor: function typeColor(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* codeColor */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FOLLOWUP_TYPE */], code);
    },
    resultText: function resultText(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* codeText */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FOLLOWUP_RESULT */], code) || '—';
    },
    submit: function submit() {
      var self = this;
      if (!self.lessons.length) {
        return;
      }
      if (!self.form.result) {
        self.$Message.warning('请选择跟进结果');
        return;
      }
      var items = self.lessons.map(function (l) {
        var item = { type: l.type, tchId: l.tchId, date: l.lessonDate };
        if (l.lessonId != null && l.lessonId !== '') {
          item.lessonId = l.lessonId;
        }
        if (l.manualId != null && l.manualId !== '') {
          item.manualId = l.manualId;
        }
        return item;
      });
      self.saving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* API_PREFIX */] + '/followup/handle', {
        items: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(items),
        result: self.form.result,
        note: self.form.note
      }).then(function (res) {
        if (res && res.status === 'ok') {
          var n = typeof res.data === 'number' ? res.data : items.length;
          self.$Message.success('已跟进 ' + n + ' 条');
          self.visible = false;
          self.$root.$emit('hr-badges-refresh');
          self.$emit('on-success');
        }
      }).finally(function () {
        self.saving = false;
      });
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);



var TYPE_ORDER = ['LEAVE', 'ABSENT', 'LOST', 'LATE'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FollowupManualModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    defaultDate: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: false,
      saving: false,
      typeOptions: TYPE_ORDER.map(function (code) {
        return { value: code, text: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FOLLOWUP_TYPE */][code] && __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FOLLOWUP_TYPE */][code].text || code };
      }),
      form: {
        tchId: '',
        date: '',
        type: 'LEAVE',
        note: ''
      }
    };
  },

  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.form = {
          tchId: '',
          date: this.defaultDate || '',
          type: 'LEAVE',
          note: ''
        };
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    submit: function submit() {
      var self = this;
      var tchId = parseInt(String(self.form.tchId == null ? '' : self.form.tchId).trim(), 10);
      if (!tchId || tchId <= 0) {
        self.$Message.warning('请填写老师 ID');
        return;
      }
      if (!self.form.date) {
        self.$Message.warning('请选择日期');
        return;
      }
      if (TYPE_ORDER.indexOf(self.form.type) < 0) {
        self.$Message.warning('请选择类型');
        return;
      }
      if (self.form.note && self.form.note.length > 1000) {
        self.$Message.warning('备注最长 1000 字');
        return;
      }
      self.saving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* API_PREFIX */] + '/followup/manual', {
        tchId: tchId,
        date: self.form.date,
        type: self.form.type,
        note: self.form.note || ''
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已登记');
          self.visible = false;
          self.$root.$emit('hr-badges-refresh');
          self.$emit('on-success');
        }
      }).finally(function () {
        self.saving = false;
      });
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);



function emptyForm() {
  return {
    result: 'CONVERTED',
    extendMonths: 1,
    crtBeginDate: '',
    crtEndDate: '',
    note: ''
  };
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProbationDecideModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      visible: false,
      saving: false,
      resultDict: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PROBATION_RESULT */],
      form: emptyForm()
    };
  },

  computed: {
    tchText: function tchText() {
      var r = this.row;
      if (!r) {
        return '—';
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* tchLabel */])(r) + '（ID ' + r.tchId + '）';
    },
    title: function title() {
      return '试用期结论 · ' + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* tchLabel */])(this.row) || '');
    },
    daysLabel: function daysLabel() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* daysText */])(this.row && this.row.daysLeft);
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.form = emptyForm();
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    submit: function submit() {
      var self = this;
      var f = self.form;
      if (!self.row || !self.row.tchId) {
        return;
      }
      if (!f.result) {
        self.$Message.warning('请选择评估结论');
        return;
      }
      var params = { tchId: self.row.tchId, result: f.result, note: f.note };
      if (f.result === 'EXTENDED') {
        if (!f.extendMonths || f.extendMonths < 1 || f.extendMonths > 6) {
          self.$Message.warning('延长月数需为 1–6');
          return;
        }
        params.extendMonths = f.extendMonths;
      }
      if (f.result === 'CONVERTED') {
        if (f.crtBeginDate && !f.crtEndDate || !f.crtBeginDate && f.crtEndDate) {
          self.$Message.warning('新合同起止需同时填写或都留空');
          return;
        }
        if (f.crtBeginDate && f.crtEndDate) {
          if (f.crtBeginDate > f.crtEndDate) {
            self.$Message.warning('到期日不能早于起始日');
            return;
          }
          params.crtBeginDate = f.crtBeginDate;
          params.crtEndDate = f.crtEndDate;
        }
      }
      self.saving = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* API_PREFIX */] + '/probation/decide', params).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已提交试用期结论');
          self.visible = false;
          self.$root.$emit('hr-badges-refresh');
          self.$emit('on-success');
        }
      }).finally(function () {
        self.saving = false;
      });
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(17);




var DEFAULT_TRACK_TYPE = 7;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReviewSaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      visible: false,
      saving: false,
      headers: {},
      defaultPicsList: [],
      form: {
        trackType: DEFAULT_TRACK_TYPE,
        content: '',
        picUrl: ''
      },
      rules: {
        trackType: [{ type: 'number', required: true, message: '类型不能为空', trigger: 'change' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },

  computed: {
    trackTypes: function trackTypes() {
      return this.$constant && this.$constant.tchTrackRecordType || [];
    },
    tchText: function tchText() {
      var r = this.row;
      if (!r) {
        return '—';
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(r) + '（ID ' + r.tchId + '）';
    },
    title: function title() {
      return '新外教回访 · ' + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(this.row) || '');
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.resetForm();
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      var _this = this;

      this.form = {
        trackType: DEFAULT_TRACK_TYPE,
        content: '',
        picUrl: ''
      };
      this.defaultPicsList = [];
      this.$nextTick(function () {
        if (_this.$refs.trackForm) {
          _this.$refs.trackForm.resetFields();
          _this.form.trackType = DEFAULT_TRACK_TYPE;
        }
      });
    },
    syncHeaders: function syncHeaders() {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
    },
    handleTrackFileChange: function handleTrackFileChange(file, fileList) {
      this.defaultPicsList = fileList;
      var names = fileList.filter(function (f) {
        return f.serverName;
      }).map(function (f) {
        return f.serverName;
      }).join(',');
      this.form.picUrl = names;
    },
    trackFileSuccess: function trackFileSuccess(res, file, fileList) {
      this.$Message.destroy();
      file.serverName = res && res.data && res.data.name;
      var names = fileList.filter(function (f) {
        return f.serverName;
      }).map(function (f) {
        return f.serverName;
      }).join(',');
      this.form.picUrl = names;
      this.defaultPicsList = fileList;
    },
    beforeUploadTrackFile: function beforeUploadTrackFile(file) {
      var isLt30M = file.size / 1024 / 1024 < 30;
      if (!isLt30M) {
        this.$Message.error('文件大小不能超过30MB!');
        return false;
      }
      this.syncHeaders();
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event) {
      if (event && event.percent === 100) {
        event.percent = 99;
      }
    },
    handleContentPaste: function handleContentPaste(event) {
      var _this2 = this;

      var items = event.clipboardData && event.clipboardData.items;
      if (!items) return;
      for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image/') === 0) {
          event.preventDefault();
          var blob = items[i].getAsFile();
          var formData = new FormData();
          formData.append('file', blob, 'paste-' + Date.now() + '.png');
          formData.append('bucket', 'hellokid');
          this.$Message.loading('图片上传中...', 0);
          this.$http.post('/upload/fileUpload', formData, {
            transformRequest: [function (data) {
              return data;
            }],
            headers: {
              'token': this.$store.get('token'),
              'account': this.$store.get('account') || '',
              'password': this.$store.get('password') || ''
            }
          }).then(function (res) {
            _this2.$Message.destroy();
            var data = res.data;
            if (data && data.name) {
              var fileInfo = {
                name: data.name,
                url: data.url,
                status: 'success',
                serverName: data.name,
                percentage: 100,
                uid: Date.now()
              };
              _this2.defaultPicsList = _this2.defaultPicsList.concat([fileInfo]);
              _this2.form.picUrl = _this2.defaultPicsList.filter(function (f) {
                return f.serverName;
              }).map(function (f) {
                return f.serverName;
              }).join(',');
              _this2.$Message.success('图片上传成功');
            }
          }).catch(function () {
            _this2.$Message.destroy();
            _this2.$Message.error('图片上传失败');
          });
          break;
        }
      }
    },
    submit: function submit() {
      var self = this;
      if (!self.row || !self.row.tchId) {
        return;
      }
      self.$refs.trackForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('请填写类型和内容');
          return;
        }
        var content = (self.form.content || '').trim();
        if (!content) {
          self.$Message.warning('请填写类型和内容');
          return;
        }
        self.saving = true;
        var trackPayload = {
          tchId: self.row.tchId,
          tchName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* tchLabel */])(self.row),
          trackType: self.form.trackType,
          content: content,
          picUrl: self.form.picUrl || ''
        };
        var note = content.length > 1000 ? content.slice(0, 1000) : content;
        var reviewPayload = {
          tchId: self.row.tchId,
          reviewDate: self.$moment().format('YYYY-MM-DD'),
          channel: __WEBPACK_IMPORTED_MODULE_1__constants__["o" /* REVIEW_CHANNELS */][0],
          result: 'GOOD',
          note: note,
          nextAction: ''
        };
        self.$http.post('/tchTrack/addTrackRecord', trackPayload).then(function (res) {
          if (!(res && res.data > 0)) {
            self.$Message.error('跟踪记录保存失败');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('track fail'));
          }
          return self.$http.post(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* API_PREFIX */] + '/review/save', reviewPayload);
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.$Message.success('回访已登记');
            self.visible = false;
            self.$root.$emit('hr-badges-refresh');
            self.$emit('on-success');
          } else {
            self.$Message.warning('跟踪已写入，回访状态更新失败，请重试或联系管理员');
          }
        }).catch(function () {}).finally(function () {
          self.saving = false;
        });
      });
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_kbApi__ = __webpack_require__(128);





var MIN_W = 360;
var MIN_H = 320;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KbAssistant',
  data: function data() {
    return {
      visible: false,
      open: false,
      maximized: false,
      fab: { left: null, top: null },
      win: { left: 0, top: 0, width: 720, height: 560 },
      preMaxWin: null,
      fabDragging: false,
      fabMoved: false,
      fabOff: { x: 0, y: 0 },
      winDragging: false,
      winMoved: false,
      winOff: { x: 0, y: 0 },
      resizing: false,
      resizeDir: '',
      resizeStart: null,
      resizeDirs: ['n', 's', 'e', 'w', 'ne', 'nw', 'se', 'sw'],
      bases: [],
      hasBind: false,
      providerConfigured: true,
      messages: [],
      draft: '',
      sending: false,
      maskArmed: false
    };
  },

  computed: {
    fabStyle: function fabStyle() {
      var left = this.fab.left;
      var top = this.fab.top;
      if (left == null || top == null) {
        return { right: '24px', bottom: '24px', left: 'auto', top: 'auto' };
      }
      return { left: left + 'px', top: top + 'px', right: 'auto', bottom: 'auto' };
    },
    panelStyle: function panelStyle() {
      return {
        left: this.win.left + 'px',
        top: this.win.top + 'px',
        width: this.win.width + 'px',
        height: this.win.height + 'px'
      };
    },
    emptyText: function emptyText() {
      return '先问一句。有关联知识库时会检索后回答；未关联则为普通问答。';
    },
    providerHint: function providerHint() {
      return this.providerConfigured ? '' : '模拟模式（未配置 IMA 密钥）';
    }
  },
  created: function created() {
    this.restoreFab();
    this.restoreWin();
    this.bootstrap();
    window.addEventListener('resize', this.onViewportResize);
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindPointer();
    window.removeEventListener('resize', this.onViewportResize);
  },

  methods: {
    defaultWinGeom: function defaultWinGeom() {
      var vw = window.innerWidth || 1280;
      var vh = window.innerHeight || 800;
      var width = Math.round(vw * 0.72);
      var height = Math.round(vh * 0.78);
      width = Math.max(MIN_W, Math.min(width, vw - 24));
      height = Math.max(MIN_H, Math.min(height, vh - 24));
      var left = Math.round((vw - width) / 2);
      var top = Math.round((vh - height) / 2);
      return { left: left, top: top, width: width, height: height };
    },
    clampWin: function clampWin(g) {
      var vw = window.innerWidth || 1280;
      var vh = window.innerHeight || 800;
      var width = Math.max(MIN_W, Math.min(g.width, vw - 16));
      var height = Math.max(MIN_H, Math.min(g.height, vh - 16));
      var left = Math.max(0, Math.min(g.left, vw - width));
      var top = Math.max(0, Math.min(g.top, vh - height));
      return { left: left, top: top, width: width, height: height };
    },
    restoreFab: function restoreFab() {
      try {
        var raw = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["b" /* KB_FAB_POS_KEY */]);
        if (!raw) return;
        var pos = JSON.parse(raw);
        if (pos && typeof pos.left === 'number' && typeof pos.top === 'number') {
          this.fab = { left: pos.left, top: pos.top };
        }
      } catch (e) {}
    },
    saveFab: function saveFab() {
      try {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["b" /* KB_FAB_POS_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.fab));
      } catch (e) {}
    },
    restoreWin: function restoreWin() {
      try {
        var raw = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["c" /* KB_WIN_GEOM_KEY */]);
        if (!raw) {
          this.win = this.defaultWinGeom();
          return;
        }
        var g = JSON.parse(raw);
        if (g && typeof g.left === 'number' && typeof g.top === 'number' && typeof g.width === 'number' && typeof g.height === 'number') {
          this.win = this.clampWin(g);
        } else {
          this.win = this.defaultWinGeom();
        }
      } catch (e) {
        this.win = this.defaultWinGeom();
      }
    },
    saveWin: function saveWin() {
      if (this.maximized) return;
      try {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["c" /* KB_WIN_GEOM_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.win));
      } catch (e) {}
    },
    onViewportResize: function onViewportResize() {
      if (!this.open) return;
      if (this.maximized) {
        this.applyMaximizeGeom();
      } else {
        this.win = this.clampWin(this.win);
      }
    },
    bootstrap: function bootstrap() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["a" /* KB_URI */].askAllowed, {}).then(function (res) {
        if (res && res.status === 'ok' && res.data && res.data.allowed === true) {
          _this.visible = true;
          _this.hasBind = !!res.data.hasBind;
          _this.providerConfigured = res.data.providerConfigured !== false;
          _this.bases = res.data.bases || [];
        } else {
          _this.visible = false;
        }
      }).catch(function () {
        _this.visible = false;
      });
    },
    onFabDown: function onFabDown(e) {
      this.fabDragging = true;
      this.fabMoved = false;
      var rect = e.currentTarget.getBoundingClientRect();
      this.fabOff = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      if (this.fab.left == null) {
        this.fab = { left: rect.left, top: rect.top };
      }
      document.addEventListener('mousemove', this.onFabMove);
      document.addEventListener('mouseup', this.onFabUp);
      e.preventDefault();
    },
    onFabMove: function onFabMove(e) {
      if (!this.fabDragging) return;
      this.fabMoved = true;
      var left = e.clientX - this.fabOff.x;
      var top = e.clientY - this.fabOff.y;
      left = Math.max(8, Math.min(window.innerWidth - 60, left));
      top = Math.max(8, Math.min(window.innerHeight - 60, top));
      this.fab = { left: left, top: top };
    },
    onFabUp: function onFabUp() {
      var _this2 = this;

      if (this.fabDragging && this.fabMoved) {
        this.saveFab();
      }
      this.fabDragging = false;
      document.removeEventListener('mousemove', this.onFabMove);
      document.removeEventListener('mouseup', this.onFabUp);
      setTimeout(function () {
        _this2.fabMoved = false;
      }, 0);
    },
    onFabClick: function onFabClick() {
      if (this.fabMoved) return;
      this.openPanel();
    },
    openPanel: function openPanel() {
      var raw = null;
      try {
        raw = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["c" /* KB_WIN_GEOM_KEY */]);
      } catch (e) {}
      if (!raw) {
        this.win = this.defaultWinGeom();
      } else {
        this.win = this.clampWin(this.win);
      }
      this.maximized = false;
      this.preMaxWin = null;
      this.open = true;
      this.maskArmed = false;
    },
    closePanel: function closePanel() {
      this.open = false;
      this.maximized = false;
      this.maskArmed = false;
      this.unbindPointer();
    },
    applyMaximizeGeom: function applyMaximizeGeom() {
      var vw = window.innerWidth || 1280;
      var vh = window.innerHeight || 800;
      var width = Math.round(vw * 0.92);
      var height = Math.round(vh * 0.9);
      var left = Math.round((vw - width) / 2);
      var top = Math.round((vh - height) / 2);
      this.win = this.clampWin({ left: left, top: top, width: width, height: height });
    },
    toggleMaximize: function toggleMaximize() {
      var _this3 = this;

      if (this.maximized) {
        this.maximized = false;
        this.maskArmed = false;
        if (this.preMaxWin) {
          this.win = this.clampWin(this.preMaxWin);
        } else {
          this.win = this.defaultWinGeom();
        }
        this.preMaxWin = null;
        this.saveWin();
        return;
      }
      this.preMaxWin = {
        left: this.win.left,
        top: this.win.top,
        width: this.win.width,
        height: this.win.height
      };
      this.maximized = true;
      this.applyMaximizeGeom();

      this.maskArmed = false;
      setTimeout(function () {
        _this3.maskArmed = true;
      }, 280);
    },
    onMaskDown: function onMaskDown() {
      if (!this.maskArmed) return;
      this.toggleMaximize();
    },
    onWinDragDown: function onWinDragDown(e) {
      if (e.button != null && e.button !== 0) return;
      if (this.maximized) return;
      this.winDragging = true;
      this.winMoved = false;
      this.winOff = {
        x: e.clientX - this.win.left,
        y: e.clientY - this.win.top
      };
      document.addEventListener('mousemove', this.onWinDragMove);
      document.addEventListener('mouseup', this.onWinDragUp);
      e.preventDefault();
    },
    onWinDragMove: function onWinDragMove(e) {
      if (!this.winDragging) return;
      this.winMoved = true;
      var left = e.clientX - this.winOff.x;
      var top = e.clientY - this.winOff.y;
      this.win = this.clampWin({
        left: left,
        top: top,
        width: this.win.width,
        height: this.win.height
      });
    },
    onWinDragUp: function onWinDragUp() {
      if (this.winDragging && this.winMoved) {
        this.saveWin();
      }
      this.winDragging = false;
      document.removeEventListener('mousemove', this.onWinDragMove);
      document.removeEventListener('mouseup', this.onWinDragUp);
    },
    onResizeDown: function onResizeDown(dir, e) {
      if (this.maximized) return;
      this.resizing = true;
      this.resizeDir = dir;
      this.resizeStart = {
        x: e.clientX,
        y: e.clientY,
        left: this.win.left,
        top: this.win.top,
        width: this.win.width,
        height: this.win.height
      };
      document.addEventListener('mousemove', this.onResizeMove);
      document.addEventListener('mouseup', this.onResizeUp);
    },
    onResizeMove: function onResizeMove(e) {
      if (!this.resizing || !this.resizeStart) return;
      var dx = e.clientX - this.resizeStart.x;
      var dy = e.clientY - this.resizeStart.y;
      var left = this.resizeStart.left;
      var top = this.resizeStart.top;
      var width = this.resizeStart.width;
      var height = this.resizeStart.height;
      var dir = this.resizeDir;
      if (dir.indexOf('e') >= 0) {
        width = this.resizeStart.width + dx;
      }
      if (dir.indexOf('s') >= 0) {
        height = this.resizeStart.height + dy;
      }
      if (dir.indexOf('w') >= 0) {
        width = this.resizeStart.width - dx;
        left = this.resizeStart.left + dx;
      }
      if (dir.indexOf('n') >= 0) {
        height = this.resizeStart.height - dy;
        top = this.resizeStart.top + dy;
      }
      if (width < MIN_W) {
        if (dir.indexOf('w') >= 0) {
          left = this.resizeStart.left + (this.resizeStart.width - MIN_W);
        }
        width = MIN_W;
      }
      if (height < MIN_H) {
        if (dir.indexOf('n') >= 0) {
          top = this.resizeStart.top + (this.resizeStart.height - MIN_H);
        }
        height = MIN_H;
      }
      this.win = this.clampWin({ left: left, top: top, width: width, height: height });
    },
    onResizeUp: function onResizeUp() {
      if (this.resizing) {
        this.saveWin();
      }
      this.resizing = false;
      this.resizeDir = '';
      this.resizeStart = null;
      document.removeEventListener('mousemove', this.onResizeMove);
      document.removeEventListener('mouseup', this.onResizeUp);
    },
    unbindPointer: function unbindPointer() {
      document.removeEventListener('mousemove', this.onFabMove);
      document.removeEventListener('mouseup', this.onFabUp);
      document.removeEventListener('mousemove', this.onWinDragMove);
      document.removeEventListener('mouseup', this.onWinDragUp);
      document.removeEventListener('mousemove', this.onResizeMove);
      document.removeEventListener('mouseup', this.onResizeUp);
    },
    clearChat: function clearChat() {
      this.messages = [];
    },
    onKey: function onKey(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.send();
      }
    },
    send: function send() {
      var _this4 = this;

      var q = (this.draft || '').trim();
      if (!q) {
        this.$Message.warning('请输入问题');
        return;
      }
      if (this.sending) return;
      this.messages.push({ role: 'user', text: q });
      this.draft = '';
      this.sending = true;
      var payload = { question: q };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__tools_kbApi__["a" /* KB_URI */].ask, payload).then(function (res) {
        _this4.sending = false;
        if (res && res.status === 'ok' && res.data) {
          _this4.messages.push({
            role: 'bot',
            text: res.data.answer || '',
            sources: res.data.sources || []
          });
        } else {
          _this4.messages.push({ role: 'bot', text: '请求失败，请稍后重试。' });
        }
        _this4.$nextTick(function () {
          var el = _this4.$refs.msgs;
          if (el) el.scrollTop = el.scrollHeight;
        });
      }).catch(function () {
        _this4.sending = false;
        _this4.messages.push({ role: 'bot', text: '请求失败，请稍后重试。' });
      });
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_kbApi__ = __webpack_require__(128);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var self = this;
    return {
      keyword: '',
      loading: false,
      rows: [],
      syncModal: false,
      syncExternalId: '',
      syncExternalIdManual: '',
      syncing: false,
      remoteLoading: false,
      remoteOptions: [],
      saveModal: false,
      saving: false,
      form: { id: null, externalKbId: '', name: '', status: 1, remark: '', createRemote: true },
      browseModal: false,
      browseLoading: false,
      browseTarget: null,
      browseParentId: '',
      browseKeyword: '',
      browseRows: [],
      browseCrumbs: [],
      uploadModal: false,
      uploadTarget: null,
      uploadFile: null,
      uploading: false,
      columns: [{ title: 'ID', key: 'id', width: 80, align: 'center' }, { title: '名称', key: 'name', minWidth: 140 }, { title: '外部 ID', key: 'externalKbId', minWidth: 160 }, { title: '提供商', key: 'provider', width: 90, align: 'center' }, {
        title: '状态',
        width: 90,
        align: 'center',
        render: function render(h, p) {
          return h('span', p.row.status === 1 ? '启用' : '停用');
        }
      }, {
        title: '备份目录',
        width: 110,
        align: 'center',
        render: function render(h, p) {
          return h('span', p.row.backupNodeId || '未建');
        }
      }, { title: '更新时间', key: 'gmtModified', minWidth: 160 }, {
        title: '操作',
        minWidth: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return self.openSave(row);
              } } }, '编辑'), h('span', { class: 'divider' }, ' | '), h('a', { on: { click: function click() {
                return self.openBrowse(row);
              } } }, '浏览'), h('span', { class: 'divider' }, ' | '), h('a', { on: { click: function click() {
                return self.openUpload(row);
              } } }, '上传')]);
        }
      }],
      browseColumns: [{
        title: '名称',
        minWidth: 220,
        render: function render(h, p) {
          var row = p.row;
          if (row.type === 'folder') {
            return h('span', {
              class: 'folder-link',
              on: { click: function click() {
                  return self.browseEnterFolder(row);
                } }
            }, '📁 ' + (row.name || row.title || row.folder_id));
          }
          return h('span', row.name || row.title || row.media_id || '-');
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, p) {
          return h('span', p.row.type === 'folder' ? '文件夹' : '文件');
        }
      }, { title: 'ID', minWidth: 160, render: function render(h, p) {
          return h('span', p.row.media_id || p.row.folder_id || '-');
        } }, { title: '摘要', key: 'snippet', minWidth: 160 }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      this.loading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].baseList, { keyword: this.keyword }).then(function (res) {
        _this.loading = false;
        if (res && res.status === 'ok') {
          _this.rows = res.data || [];
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    loadRemoteBases: function loadRemoteBases() {
      var _this2 = this;

      this.remoteLoading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].providerBases, { keyword: '' }).then(function (res) {
        _this2.remoteLoading = false;
        if (res && res.status === 'ok') {
          var remote = res.data && res.data.remoteList || {};
          var list = remote.list || remote.info_list || [];
          _this2.remoteOptions = (list || []).map(function (it) {
            return {
              id: it.knowledge_base_id || it.id,
              name: it.name || it.knowledge_base_id || it.id
            };
          }).filter(function (it) {
            return !!it.id;
          });
        }
      }).catch(function () {
        _this2.remoteLoading = false;
      });
    },
    openSync: function openSync() {
      this.syncExternalId = '';
      this.syncExternalIdManual = '';
      this.syncModal = true;
      this.loadRemoteBases();
    },
    doSync: function doSync() {
      var _this3 = this;

      var id = (this.syncExternalIdManual || this.syncExternalId || '').trim();
      if (!id) {
        this.$Message.warning('请选择或填写外部库 ID');
        return;
      }
      this.syncing = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].baseSync, { externalKbId: id }).then(function (res) {
        _this3.syncing = false;
        if (res && res.status === 'ok') {
          _this3.$Message.success('同步成功');
          _this3.syncModal = false;
          _this3.load();
        }
      }).catch(function () {
        _this3.syncing = false;
      });
    },
    openSave: function openSave(row) {
      if (row) {
        this.form = {
          id: row.id,
          externalKbId: row.externalKbId,
          name: row.name,
          status: row.status,
          remark: row.remark || '',
          createRemote: false
        };
      } else {
        this.form = { id: null, externalKbId: '', name: '', status: 1, remark: '', createRemote: true };
      }
      this.saveModal = true;
    },
    doSave: function doSave() {
      var _this4 = this;

      if (!this.form.name) {
        this.$Message.warning('名称必填');
        return;
      }
      if (!this.form.id && !this.form.createRemote && !this.form.externalKbId) {
        this.$Message.warning('请填写外部库 ID，或打开「同步创建 IMA」');
        return;
      }
      var payload = {
        id: this.form.id,
        name: this.form.name,
        status: this.form.status,
        remark: this.form.remark
      };
      if (this.form.id) {
        payload.externalKbId = this.form.externalKbId;
      } else if (!this.form.createRemote) {
        payload.externalKbId = this.form.externalKbId;
      }

      this.saving = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].baseSave, payload).then(function (res) {
        _this4.saving = false;
        if (res && res.status === 'ok') {
          _this4.$Message.success('已保存');
          _this4.saveModal = false;
          _this4.load();
        }
      }).catch(function () {
        _this4.saving = false;
      });
    },
    openBrowse: function openBrowse(row) {
      this.browseTarget = row;
      this.browseParentId = '';
      this.browseKeyword = '';
      this.browseCrumbs = [];
      this.browseModal = true;
      this.browseReload();
    },
    browseReload: function browseReload() {
      var _this5 = this;

      if (!this.browseTarget) {
        return;
      }
      this.browseLoading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].browse, {
        kbBaseId: this.browseTarget.id,
        parentId: this.browseParentId || '',
        keyword: this.browseKeyword || ''
      }).then(function (res) {
        _this5.browseLoading = false;
        if (res && res.status === 'ok') {
          var remote = res.data && res.data.remote || {};
          _this5.browseRows = remote.list || [];
        }
      }).catch(function () {
        _this5.browseLoading = false;
      });
    },
    doBrowseSearch: function doBrowseSearch() {
      this.browseReload();
    },
    browseEnterFolder: function browseEnterFolder(row) {
      var fid = row.folder_id;
      if (!fid) {
        return;
      }
      this.browseCrumbs.push({ id: fid, name: row.name || row.title || fid });
      this.browseParentId = fid;
      this.browseKeyword = '';
      this.browseReload();
    },
    browseGoRoot: function browseGoRoot() {
      this.browseCrumbs = [];
      this.browseParentId = '';
      this.browseKeyword = '';
      this.browseReload();
    },
    browseGoCrumb: function browseGoCrumb(idx) {
      if (idx < 0 || idx >= this.browseCrumbs.length - 1) {
        return;
      }
      this.browseCrumbs = this.browseCrumbs.slice(0, idx + 1);
      this.browseParentId = this.browseCrumbs[idx].id;
      this.browseKeyword = '';
      this.browseReload();
    },
    openUpload: function openUpload(row) {
      this.uploadTarget = row;
      this.uploadFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.uploadModal = true;
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files;
      this.uploadFile = files && files.length ? files[0] : null;
    },
    doUpload: function doUpload() {
      var _this6 = this;

      if (!this.uploadTarget) {
        return;
      }
      if (!this.uploadFile) {
        this.$Message.warning('请选择文件');
        return;
      }
      var fd = new FormData();
      fd.append('kbBaseId', this.uploadTarget.id);
      fd.append('file', this.uploadFile);
      this.uploading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__tools_kbApi__["a" /* KB_URI */].upload, fd).then(function (res) {
        _this6.uploading = false;
        if (res && res.status === 'ok') {
          var tip = res.data && res.data.message || '上传成功';
          if (res.data && res.data.backupStatus === 2) {
            tip += '（网盘备份失败：' + (res.data && res.data.base && '' || '') + (res.data.lastError || '见服务端日志') + '）';

            tip = (res.data && res.data.message || '上传成功') + '（IMA 已成功；网盘备份失败，非超管或目录未建）';
          } else if (res.data && res.data.backupStatus === 1) {
            tip = (res.data && res.data.message || '上传成功') + '（已双写网盘）';
          }
          _this6.$Message.success(tip);
          _this6.uploadModal = false;
          _this6.uploadFile = null;
          if (_this6.$refs.fileInput) {
            _this6.$refs.fileInput.value = '';
          }
          _this6.load();
        }
      }).catch(function () {
        _this6.uploading = false;
      });
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Announcement',
  components: {},
  data: function data() {
    return {
      show: false,
      animate: false,
      items: []
    };
  },
  created: function created() {},

  methods: {
    scroll: function scroll() {
      this.animate = true;
      var self = this;
      setTimeout(function () {
        if (self.items) {
          self.items.push(self.items[0]);
        }
        self.items.shift();
        self.animate = false;
      }, 500);
    },
    getNewOrders: function getNewOrders() {
      var self = this;
      var items = [];
      self.$http.get('/fundPackage/getNewOrders').then(function (res) {
        if (res.data) {
          self.show = true;
          for (var i = 0; i < res.data.length; i++) {
            items[i] = res.data[i] + '';
          }
          self.items = items;
        } else {
          self.show = false;
        }
      });
    },
    init: function init() {}
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__message_message_vue__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__message_message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__message_message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Announcement_vue__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Announcement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Announcement_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__Announcement_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_0__message_message_vue___default.a
  },
  data: function data() {
    return {
      isLogin: false,
      mobile: ''
    };
  },

  methods: {
    userMenuClick: function userMenuClick(name) {
      if (name === 'logout') {
        this.$store.remove('token');
        this.$store.remove('mobile');
        this.$store.remove('password');

        this.$router.push({ path: '/login', query: { backUrl: this.$route.path } });
      }
    }
  },
  created: function created() {
    this.mobile = this.$store.get('mobile');
    this.isLogin = this.mobile !== undefined && this.mobile !== '';
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftMenu_vue__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LeftMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_kb_KbAssistant_vue__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_kb_KbAssistant_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_kb_KbAssistant_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftMenu: __WEBPACK_IMPORTED_MODULE_0__LeftMenu_vue___default.a,
    KbAssistant: __WEBPACK_IMPORTED_MODULE_1__components_kb_KbAssistant_vue___default.a
  },
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {}
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hrWorkbench_constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_matcher__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_matcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_matcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_aiAccess__ = __webpack_require__(30);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeftMenu',
  watch: {
    '$route': function $route(to, from) {
      this.currentMenu = this.selectMenu(to);
      this.ensureOpenParents(to);
      if (this.isHrWorkbenchRoute(to) !== this.isHrWorkbenchRoute(from)) {
        this.loadHrBadges();
      }
      if (this.isRecruitRoute(to) !== this.isRecruitRoute(from)) {
        this.loadRecruitBadges();
      }
    }
  },
  data: function data() {
    return {
      theme: 'primary',
      currentMenu: '',
      hrBadges: {
        supervise: 0,
        probation: 0,
        review: 0,
        contract: 0,
        followup: 0
      },
      recruitBadges: {
        interviewing: 0,
        reserved: 0
      },
      menuGroups: [{
        hasPermission: false,
        name: '首页',
        icon: 'person-stalker',
        url: '/index',
        menuItems: []
      }, {
        hasPermission: false,
        name: '市场管理',
        icon: 'person-stalker',
        menuItems: [{
          hasPermission: false,
          name: '渠道管理',
          url: '/market/channelManagement'
        }, {
          hasPermission: false,
          name: '渠道成交率',
          url: '/market/ChannelDealRate'
        }, {
          hasPermission: false,
          name: '文章发布表',
          url: '/market/ArticlePublishList'
        }, {
          hasPermission: false,
          name: '发布渠道收录表',
          url: '/market/ChannelIncludeList'
        }, {
          hasPermission: false,
          name: 'AI渠道收录表',
          url: '/market/AiChannelIncludeList'
        }, {
          hasPermission: false,
          name: '活动列表',
          url: '/market/activityList'
        }, {
          hasPermission: false,
          name: '分享有礼海报管理',
          url: '/market/shareManagement'
        }, {
          hasPermission: false,
          name: '兑换课程审核',
          url: '/market/exChangeRecordListB'
        }, {
          hasPermission: false,
          name: '代理管理',
          subItems: [{
            hasPermission: false,
            name: '代理用户',
            url: '/agent/agentUserList'
          }, {
            hasPermission: false,
            name: '推荐记录',
            url: '/agent/agentInviteList'
          }]
        }]
      }, {
        hasPermission: false,
        name: 'crm',
        icon: 'person-stalker',
        menuItems: [{
          hasPermission: false,
          name: '个人资源',
          url: '/crm/MyResource'
        }, {
          hasPermission: false,
          name: '打卡分单',
          url: '/crm/adviserPunchList'
        }, {
          hasPermission: false,
          name: '分配记录',
          url: '/crm/DistributionList'
        }, {
          hasPermission: false,
          name: '首次跟踪记录',
          url: '/crm/FirstFollowList'
        }, {
          hasPermission: false,
          name: '今日将转出名单',
          url: '/crm/dailyTransferList'
        }, {
          hasPermission: false,
          name: '公共资源',
          url: '/crm/TreasuryResource'
        }, {
          hasPermission: false,
          name: '拼团记录',
          url: '/crm/SpellGroupList'
        }, {
          hasPermission: false,
          name: '销售通话记录',
          url: '/crm/PhoneRecordList'
        }, {
          hasPermission: false,
          name: '销售通话记录AI',
          url: '/crm/DviAudioList'
        }, {
          hasPermission: false,
          name: '通话转写词表',
          url: '/crm/CallAsrWord'
        }, {
          hasPermission: false,
          name: '销售话术库',
          url: '/crm/CallScript'
        }]
      }, {
        hasPermission: false,
        name: '学生管理',
        icon: 'happy-outline',
        menuItems: [{
          hasPermission: false,
          name: '体验名单',
          url: '/user/bookTestList'
        }, {
          hasPermission: false,
          name: '体验学生',
          url: '/user/userExperienceList'
        }, {
          hasPermission: false,
          name: '待分配学生',
          url: '/user/userProvisionalList'
        }, {
          hasPermission: false,
          name: '常规学生',
          url: '/user/userPayList'
        }, {
          hasPermission: false,
          name: '新生分配',
          url: '/user/userTodayNewList'
        }, {
          hasPermission: false,
          name: '学情反馈',
          url: '/user/newStudentService'
        }, {
          hasPermission: false,
          name: '课时流水',
          url: '/user/classHourFlow'
        }, {
          hasPermission: false,
          name: '学员跟踪记录',
          url: '/user/userTrackList'
        }, {
          hasPermission: false,
          name: '学员风险',
          url: '/user/studentRiskList'
        }, {
          hasPermission: false,
          name: '学生请假列表',
          url: '/user/bookUserLeaveTimeList'
        }, {
          hasPermission: false,
          name: '学生状态审核',
          url: '/user/UserStatusAuditList'
        }, {
          hasPermission: false,
          name: '补课时记录',
          url: '/user/bookCourseChangeList'
        }, {
          hasPermission: false,
          name: 'followUp记录',
          url: '/user/followUpList'
        }, {
          hasPermission: false,
          name: '朋友圈分享审核列表',
          url: '/user/activityExamineList'
        }, {
          hasPermission: false,
          name: '兑换记录',
          url: '/user/exchangeRecordList'
        }, {
          hasPermission: false,
          name: '退费学生列表',
          url: '/user/userRefundList'
        }, {
          hasPermission: false,
          name: '结课学生列表',
          url: '/user/userOverClassList'
        }, {
          hasPermission: false,
          name: '停课学生列表',
          url: '/user/userLessonsStopList'
        }, {
          hasPermission: false,
          name: '禁用学生列表',
          url: '/user/userNotAllowedList'
        }, {
          hasPermission: false,
          name: '每日作业',
          url: '/bookMaterialLessons/dailyStudy'
        }, {
          hasPermission: false,
          name: '取消课程记录',
          url: '/user/cancelLessonRecord'
        }, {
          hasPermission: false,
          name: '分配学导记录',
          url: '/user/DistributionStudyRecord'
        }, {
          hasPermission: false,
          name: '周数据',
          url: '/user/StudentWeekStatList'
        }, {
          hasPermission: false,
          name: '月数据',
          url: '/user/StudentMonthStatList'
        }, {
          hasPermission: false,
          name: '修改绑定记录',
          url: '/user/BindTeacherOperationRecord'
        }, {
          hasPermission: false,
          name: '绑定分组课件修复',
          url: '/user/bindGroupLessonScan'
        }, {
          hasPermission: false,
          name: '多级别绑定等级',
          url: '/user/bindGroupLevel'
        }, {
          hasPermission: false,
          name: '单词卡',
          url: '/user/wordCardList'
        }, {
          hasPermission: false,
          name: '句子翻译',
          url: '/user/sentenceCardList'
        }, {
          hasPermission: false,
          name: '学生单词本',
          url: '/user/studentWordbookList'
        }, {
          hasPermission: false,
          name: '跟读记录',
          url: '/user/studentWordcardEvalList'
        }, {
          hasPermission: false,
          name: '异动老师',
          url: '/tch/tchAnomalyList'
        }, {
          hasPermission: false,
          name: '异动老师看板',
          url: '/user/tchRebindBoard'
        }]
      }, {
        hasPermission: false,
        name: '老师管理',
        icon: 'person',
        menuItems: [{
          hasPermission: false,
          name: '外教招聘',
          subItems: [{
            hasPermission: false,
            name: '数据看板',
            url: '/tch/recruit/dashboard'
          }, {
            hasPermission: false,
            name: '招聘培训统计',
            url: '/tch/recruitTrainStat'
          }, {
            hasPermission: false,
            name: '待审核老师',
            url: '/tch/tchUnauditedList'
          }, {
            hasPermission: false,
            name: '已审核老师',
            url: '/tch/tchAuditList'
          }, {
            hasPermission: false,
            name: '待面试老师',
            url: '/tch/recruit/pendingInterview',
            recruitBadgeKey: 'interviewing'
          }, {
            hasPermission: false,
            name: '招聘龙虎榜',
            url: '/tch/recruit/leaderboard'
          }, {
            hasPermission: false,
            name: '注册渠道管理',
            url: '/tch/regChannelList'
          }, {
            hasPermission: false,
            name: '推荐官管理',
            url: '/tch/referrerList'
          }, {
            hasPermission: false,
            name: '被推荐人管理',
            url: '/tch/referrerFeeList'
          }, {
            hasPermission: false,
            name: '储备老师',
            url: '/tch/recruit/reserved',
            recruitBadgeKey: 'reserved'
          }]
        }, {
          hasPermission: false,
          name: '外教管理',
          subItems: [{
            hasPermission: false,
            name: '培训中老师',
            url: '/tch/trainingList'
          }, {
            hasPermission: false,
            name: '正式老师',
            url: '/tch/tchFormalList'
          }, {
            hasPermission: false,
            name: '正式老师(菲)',
            url: '/tch/filipino/tchFormalList'
          }, {
            hasPermission: false,
            name: '课堂投诉',
            url: '/tch/tchComplaintList'
          }, {
            hasPermission: false,
            name: '外教对接中心',
            url: '/tch/foreignTchMatchCenter'
          }, {
            hasPermission: false,
            name: '上课异常列表',
            url: '/tch/tchOpenedExceptionList'
          }, {
            hasPermission: false,
            name: '离职外教',
            url: '/tch/tchResignFormalList'
          }, {
            hasPermission: false,
            name: '老师请假列表',
            url: '/tch/tchLeaveList'
          }, {
            hasPermission: false,
            name: '优秀外教排行榜',
            url: '/tch/tchTeacherRanking'
          }, {
            hasPermission: false,
            name: '外教核心数据看板',
            url: '/tch/tchHrMetricsDashboard'
          }, {
            hasPermission: false,
            name: '外教异动风险监测',
            url: '/tch/tchRiskWarningList'
          }, {
            hasPermission: false,
            name: '在职老师请假率',
            url: '/tch/tchLeaveRateList'
          }]
        }, {
          hasPermission: false,
          name: '外管工作台',
          subItems: [{
            hasPermission: false,
            name: '在职老师',
            url: '/tch/tchNormalList'
          }, {
            hasPermission: false,
            name: '主管管理',
            url: '/hrWorkbench/supervise',
            badgeKey: 'supervise'
          }, {
            hasPermission: false,
            name: '工作台',
            url: '/hrWorkbench/dashboard'
          }, {
            hasPermission: false,
            name: '试用期到期提醒',
            url: '/hrWorkbench/probation',
            badgeKey: 'probation'
          }, {
            hasPermission: false,
            name: '新外教跟进',
            url: '/hrWorkbench/review',
            badgeKey: 'review'
          }, {
            hasPermission: false,
            name: '合同到期提醒',
            url: '/hrWorkbench/contract',
            badgeKey: 'contract'
          }, {
            hasPermission: false,
            name: '出勤风险跟进',
            url: '/hrWorkbench/followup',
            badgeKey: 'followup'
          }]
        }, {
          hasPermission: false,
          name: 'Tutor Page管理',
          subItems: [{
            hasPermission: false,
            name: '开课Checklist管理',
            url: '/tch/onboardingManage'
          }, {
            hasPermission: false,
            name: '外教中心展示资料',
            url: '/tch/learningMaterialList'
          }, {
            hasPermission: false,
            name: '外管消息',
            url: '/tch/messageCenter'
          }]
        }, {
          hasPermission: false,
          name: '其他操作记录',
          subItems: [{
            hasPermission: false,
            name: '老师签到日志',
            url: '/tch/tchSignLogList'
          }, {
            hasPermission: false,
            name: '签到记录',
            url: '/tch/tchSignTimeList'
          }, {
            hasPermission: false,
            name: '外教首课签到',
            url: '/tch/tchFirstCheckList'
          }, {
            hasPermission: false,
            name: '异常操作日志',
            url: '/tch/tchExceptionLogList'
          }, {
            hasPermission: false,
            name: '老师跟踪记录',
            url: '/tch/tchTrackList'
          }, {
            hasPermission: false,
            name: '老师考勤',
            url: '/tch/tchAttendanceList'
          }, {
            hasPermission: false,
            name: '老师考勤明细',
            url: '/tch/tchAttendanceDetailList'
          }]
        }, {
          hasPermission: false,
          name: '老师工资条',
          url: '/tch/tchWagesList'
        }, {
          hasPermission: false,
          name: '外管绩效',
          url: '/tch/tchPerformanceList'
        }, {
          hasPermission: false,
          name: '外管数据',
          url: '/tch/tchForeignManageData'
        }, {
          hasPermission: false,
          name: '老师反馈记录',
          url: '/tch/tchFeedbackList'
        }, {
          hasPermission: false,
          name: '外教开课Checklist',
          url: '/tch/onboardingChecklist'
        }]
      }, {
        hasPermission: false,
        name: '智能人事',
        icon: 'ios-people',
        menuItems: [{
          hasPermission: false,
          name: '员工管理',
          subItems: [{ hasPermission: false, name: '花名册', url: '/smartHr/roster' }, { hasPermission: false, name: '用工安全', url: '/smartHr/safety' }]
        }, {
          hasPermission: false,
          name: '员工关系',
          subItems: [{ hasPermission: false, name: '入职管理', url: '/smartHr/onboarding' }, { hasPermission: false, name: '新人成长', url: '/smartHr/growth' }, { hasPermission: false, name: '转正管理', url: '/smartHr/regularization' }, { hasPermission: false, name: '异动管理', url: '/smartHr/transfer' }, { hasPermission: false, name: '离职管理', url: '/smartHr/resignation' }, { hasPermission: false, name: '合同管理', url: '/smartHr/contract' }, { hasPermission: false, name: '退休管理', url: '/smartHr/retire' }, { hasPermission: false, name: '员工关怀', url: '/smartHr/care' }]
        }]
      }, {
        hasPermission: false,
        name: '学生风险看板',
        icon: 'stats-bars',
        menuItems: [{
          hasPermission: false,
          name: '影响总览',
          url: '/tchImpact/overview'
        }, {
          hasPermission: false,
          name: '学生异动影响',
          url: '/tchImpact/change'
        }, {
          hasPermission: false,
          name: '请假/旷课影响',
          url: '/tchImpact/leave'
        }, {
          hasPermission: false,
          name: '学生影响明细',
          url: '/tchImpact/student'
        }, {
          hasPermission: false,
          name: '综合风险视图',
          url: '/tchImpact/risk'
        }, {
          hasPermission: false,
          name: '指标口径',
          url: '/tchImpact/model'
        }]
      }, {
        hasPermission: false,
        name: '约课管理',
        icon: 'compose',
        menuItems: [{
          hasPermission: false,
          name: '色块排课表',
          url: '/lesson/timetableList'
        }, {
          hasPermission: false,
          name: '常规课程列表',
          url: '/lesson/bookLessonOpenedList'
        }, {
          hasPermission: false,
          name: '实时监课',
          url: '/lesson/liveMonitor'
        }, {
          hasPermission: false,
          name: '已结束课表',
          url: '/lesson/bookLessonFinishedList'
        }, {
          hasPermission: false,
          name: 'classin临时账号',
          url: '/lesson/bookClassinList'
        }, {
          hasPermission: false,
          name: '老师代课记录',
          url: '/lesson/ReplaceRecord'
        }, {
          hasPermission: false,
          name: '当天订课信息',
          url: '/lesson/bookLessonTempList'
        }, {
          hasPermission: false,
          name: '体验课上课要求',
          url: '/tch/trialLessonRequirements'
        }]
      }, {
        hasPermission: false,
        name: '审批管理',
        icon: 'compose',
        menuItems: [{
          hasPermission: false,
          name: '修改绑定审批',
          url: '/auditList'
        }, {
          hasPermission: false,
          name: '修改绑定解冻',
          url: '/bindUnfreezeAuditList'
        }]
      }, {
        hasPermission: false,
        name: '教研题库',
        icon: 'ios-bookmarks',
        menuItems: [{
          hasPermission: false,
          name: '等级测试',
          subItems: [{
            hasPermission: false,
            name: '等级测试列表',
            url: '/level/levelGradeList'
          }, {
            hasPermission: false,
            name: '测试题列表',
            url: '/level/levelQuestionList'
          }, {
            hasPermission: false,
            name: '测试结果',
            url: '/level/levelRecordList'
          }, {
            hasPermission: false,
            name: '课后结果',
            url: '/level/reviewRecore'
          }]
        }, {
          hasPermission: false,
          name: '课程管理',
          subItems: [{
            name: '公开课',
            url: '/course/openClassList'
          }, {
            name: '单节课列表',
            url: '/course/bookLessonList'
          }, {
            name: '等级列表',
            url: '/course/materialLevelList'
          }, {
            hasPermission: false,
            name: 'classin文件目录',
            url: '/course/classinFolder'
          }, {
            hasPermission: false,
            name: '课后习题',
            url: '/course/classReview'
          }, {
            hasPermission: false,
            name: '课前课后题目',
            url: '/course/lessonSubject'
          }, {
            hasPermission: false,
            name: '课前预习',
            url: '/course/lessonPreviewList'
          }, {
            hasPermission: false,
            name: '课后视频',
            url: '/course/lessonVideoList'
          }, {
            hasPermission: false,
            name: '课程音频',
            url: '/course/lessonAudioList'
          }, {
            hasPermission: false,
            name: '教材价格列表',
            url: '/course/coursePriceList'
          }, {
            hasPermission: false,
            name: '教材报错',
            url: '/course/BookMaterialLessonsErr'
          }]
        }, {
          hasPermission: false,
          name: '机侧题库',
          subItems: [{
            hasPermission: false,
            name: '综合题库',
            url: '/mex/comp/questions'
          }, {
            hasPermission: false,
            name: '口语题库',
            url: '/mex/speak/questions'
          }, {
            hasPermission: false,
            name: '蓝图',
            url: '/mex/blueprints'
          }, {
            hasPermission: false,
            name: '试做试卷',
            url: '/mex/trial'
          }, {
            hasPermission: false,
            name: '场次记录',
            url: '/mex/sessions'
          }, {
            hasPermission: false,
            name: '题目反馈',
            url: '/mex/feedback'
          }, {
            hasPermission: false,
            name: '升班建议',
            url: '/mex/promotions'
          }, {
            hasPermission: false,
            name: '学习建议',
            url: '/mex/advice'
          }, {
            hasPermission: false,
            name: '实测统计',
            url: '/mex/stats'
          }, {
            hasPermission: false,
            name: '同龄分群',
            url: '/mex/cohorts'
          }, {
            hasPermission: false,
            name: '灰度设置',
            url: '/mex/gray'
          }]
        }]
      }, {
        hasPermission: false,
        name: '题库',
        icon: 'archive',
        menuItems: [{
          hasPermission: false,
          name: '英语能力信息列表',
          url: '/question/abilityList'
        }, {
          hasPermission: false,
          name: '机测等级题目页面',
          url: '/question/abilityList'
        }, {
          hasPermission: false,
          name: '题目模板管理',
          url: '/question/templateList'
        }]
      }, {
        hasPermission: false,
        name: '订单管理',
        icon: 'clipboard',
        menuItems: [{
          name: '订单列表',
          url: '/order/fundPackageList'
        }, {
          hasPermission: false,
          name: '龙虎榜',
          url: '/order/dragonTigerListV2'
        }, {
          hasPermission: false,
          name: '班主任龙虎榜',
          url: '/order/studyAdviserDragonTiger'
        }, {
          hasPermission: false,
          name: '业绩统计',
          url: '/order/performanceList'
        }, {
          hasPermission: false,
          name: '销售成交率',
          url: '/crm/SalesDealRate'
        }, {
          hasPermission: false,
          name: '合同模板',
          url: '/data/contract-version'
        }]
      }, {
        hasPermission: false,
        name: '财务管理',
        icon: 'social-yen',
        menuItems: [{
          hasPermission: false,
          name: '应开发票',
          url: '/financial/InvoiceList'
        }, {
          hasPermission: false,
          name: '收入统计',
          url: '/financial/IncomeStatistics'
        }, {
          hasPermission: false,
          name: '退费列表',
          url: '/financial/refundList'
        }, {
          hasPermission: false,
          name: '班主任退费看板',
          url: '/financial/studyAdviserRefundDashboard'
        }, {
          hasPermission: false,
          name: '资金管理',
          subItems: [{
            name: '用户账单',
            url: '/fund/fundUserBillList'
          }]
        }]
      }, {
        hasPermission: false,
        name: '系统',
        icon: 'gear-a',
        menuItems: [{
          hasPermission: false,
          name: '管理员列表',
          url: '/adminUser/adminUserList'
        }, {
          hasPermission: false,
          name: '权限组管理',
          url: '/adminGroup/adminGroupList'
        }, {
          hasPermission: false,
          name: '权限菜单列表',
          url: '/adminGroup/adminRuleList'
        }, {
          hasPermission: false,
          name: '配置管理',
          url: '/admin/adminConfigList'
        }, {
          hasPermission: false,
          name: '自动排课配置',
          url: '/admin/adminTConfigList'
        }, {
          hasPermission: false,
          name: '短信群发',
          url: '/admin/sendSms'
        }]
      }, {
        hasPermission: false,
        name: '日常辅助',
        icon: 'wrench',
        menuItems: [{
          hasPermission: false,
          name: '班主任值班表',
          url: '/adminUser/StudyDutyList'
        }, {
          hasPermission: false,
          name: '操作日志',
          url: '/adminUser/LogList'
        }, {
          hasPermission: false,
          name: '消息模板',
          url: '/adminUser/MessageTemplate'
        }, {
          hasPermission: false,
          name: '消息日志',
          url: '/adminUser/MessageLog'
        }, {
          hasPermission: false,
          name: '短信电话记录',
          url: '/sms/recordList'
        }, {
          hasPermission: false,
          name: '课时对照',
          url: '/support/classInfoList'
        }, {
          hasPermission: false,
          name: '总课时充值对照',
          url: '/support/totalClassInfoList'
        }, {
          hasPermission: false,
          name: '个人站内信',
          url: '/message/personMessage'
        }, {
          hasPermission: false,
          name: '内部手机号',
          url: '/support/internalMobile'
        }, {
          hasPermission: false,
          name: '学生临时登录密码',
          url: '/support/studentTempLoginPassword'
        }, {
          hasPermission: false,
          name: '外教风险地区',
          url: '/support/diplomaticRisk'
        }, {
          hasPermission: false,
          name: 'IP黑名单',
          url: '/support/ipBlacklist'
        }]
      }, {
        hasPermission: false,
        name: '数据中心',
        icon: 'wrench',
        menuItems: [{
          hasPermission: false,
          name: '老师绩效统计',
          url: '/data/teacherPerformanceList'
        }, {
          hasPermission: false,
          name: '老师薪酬统计',
          url: '/data/teacherSalaryList'
        }, {
          hasPermission: false,
          name: '外教课上课统计',
          url: '/data/foreignTeacherDeductionSummary'
        }, {
          hasPermission: false,
          name: '老师薪酬统计(菲)',
          url: '/data/filipino/teacherSalaryList'
        }, {
          hasPermission: false,
          name: '老师数据统计',
          url: '/data/tchClassUsageList'
        }, {
          hasPermission: false,
          name: '老师核心数据',
          url: '/data/teacherMonthlyCoreData'
        }, {
          hasPermission: false,
          name: '老师使用率',
          url: '/data/tchUsageList'
        }, {
          hasPermission: false,
          name: '学导跟进数据',
          url: '/data/studyAdviserTrack'
        }, {
          hasPermission: false,
          name: '课顾跟进数据',
          url: '/data/adviserData'
        }, {
          hasPermission: false,
          name: '续费数据列表',
          url: '/data/RenewDataList'
        }, {
          hasPermission: false,
          name: '课耗数据列表',
          url: '/data/LessonExpendDailyList'
        }, {
          hasPermission: false,
          name: '学生量数据列表',
          url: '/data/StudentDailyList'
        }, {
          hasPermission: false,
          name: '常规生转化率列表',
          url: '/data/finishRenewalRateList'
        }, {
          hasPermission: false,
          name: '数据汇总列表',
          url: '/data/statisticsGatherList'
        }, {
          hasPermission: false,
          name: '销售名单利用数据',
          url: '/data/salesUtilizationList'
        }, {
          hasPermission: false,
          name: '后端学导数据',
          url: '/data/studyAdviserList'
        }, {
          hasPermission: false,
          name: '班主任课耗绩效',
          url: '/data/studyAdviserConsumeList'
        }, {
          hasPermission: false,
          name: '学员生命周期',
          url: '/data/studentLifeCycle'
        }, {
          hasPermission: false,
          name: '财务每日数据',
          url: '/data/financeDaily'
        }]
      }, {
        hasPermission: false,
        name: '应急外教池',
        icon: 'person-stalker',
        menuItems: [{
          hasPermission: false,
          name: '外教池管理',
          url: '/emergency/teacherPool'
        }, {
          hasPermission: false,
          name: '试听外教池',
          url: '/emergency/trialTeacherPool'
        }]
      }, {
        hasPermission: false,
        name: '官网活动',
        icon: 'wrench',
        menuItems: [{
          hasPermission: false,
          name: '学生作品管理',
          url: '/activity/UserVideoList'
        }, {
          hasPermission: false,
          name: '合作平台作品',
          url: '/safenessVote/UserVideoList'
        }]
      }, {
        hasPermission: false,
        name: '语音合成',
        icon: 'volume-medium',
        menuItems: [{
          hasPermission: false,
          name: '音色',
          url: '/speech/voice'
        }, {
          hasPermission: false,
          name: '合成',
          url: '/speech/compose'
        }, {
          hasPermission: false,
          name: '成片',
          url: '/speech/clip'
        }]
      }, {
        hasPermission: false,
        name: '网盘',
        icon: 'folder',
        menuItems: [{
          hasPermission: false,
          name: '网盘',
          url: '/disk/index'
        }, {
          hasPermission: false,
          name: '回收站',
          url: '/disk/recycle'
        }, {
          hasPermission: false,
          name: '分享记录',
          url: '/disk/shares'
        }]
      }, {
        hasPermission: false,
        name: '知识库',
        icon: 'ios-book',
        menuItems: [{
          hasPermission: false,
          name: '库管理',
          url: '/kb/index'
        }]
      }],
      openNames: []
    };
  },

  mounted: function mounted() {},
  created: function created() {
    try {
      this.$store.remove('menuOpenNames');
    } catch (e) {}
    this.openNames = [];
    this.currentMenu = this.selectMenu(this.$route);
    this.ensureOpenParents(this.$route);

    this.init();
    this.$root.$on('hr-badges-refresh', this.loadHrBadges);
    this.$root.$on('recruit-badges-refresh', this.loadRecruitBadges);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('hr-badges-refresh', this.loadHrBadges);
    this.$root.$off('recruit-badges-refresh', this.loadRecruitBadges);
  },
  methods: {
    init: function init() {
      var self = this;
      var ruleReq = this.$http.get('/adminRule/queryUserAllAdminRule');
      var allowReq = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tools_aiAccess__["b" /* fetchAiAllowed */])(this.$http);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([ruleReq, allowReq]).then(function (results) {
        var res = results[0];
        var allowed = results[1];
        var data = res.data;
        var modules = data.filter(function (item) {
          return item.type === 2 && item.status === 1 && item.havePermission === true;
        });
        self.menuGroups.forEach(function (menuGroup) {
          modules.filter(function (child) {
            return child.title === menuGroup.name;
          }).forEach(function (child) {
            menuGroup.hasPermission = true;
          });

          menuGroup.menuItems.forEach(function (menuItem) {
            modules.filter(function (child) {
              return child.title === menuItem.name;
            }).forEach(function (child) {
              menuItem.hasPermission = true;
              menuGroup.hasPermission = true;
            });
            if (menuItem.subItems) {
              menuItem.subItems.forEach(function (sub) {
                modules.filter(function (child) {
                  return child.title === sub.name;
                }).forEach(function (child) {
                  sub.hasPermission = true;
                  menuItem.hasPermission = true;
                  menuGroup.hasPermission = true;
                });
              });
            }
          });
          if (menuGroup.name === '网盘') {
            var diskMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.url === '/disk/index';
            });
            var recycleMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.url === '/disk/recycle';
            });
            var shareMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.url === '/disk/shares';
            });
            if (diskMenu && diskMenu.hasPermission) {
              if (recycleMenu) {
                recycleMenu.hasPermission = true;
              }
              if (shareMenu) {
                shareMenu.hasPermission = true;
              }
            }
          }
          if (menuGroup.name === '数据中心') {
            var teacherDataMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.name === '老师数据统计';
            });
            var teacherCoreDataMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.name === '老师核心数据';
            });
            var teacherSalaryMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.name === '老师薪酬统计';
            });
            var foreignTeacherDeductionMenu = menuGroup.menuItems.find(function (menuItem) {
              return menuItem.name === '外教课上课统计';
            });
            if (teacherDataMenu && teacherCoreDataMenu && teacherDataMenu.hasPermission) {
              teacherCoreDataMenu.hasPermission = true;
              menuGroup.hasPermission = true;
            }
            if (teacherSalaryMenu && foreignTeacherDeductionMenu && teacherSalaryMenu.hasPermission) {
              foreignTeacherDeductionMenu.hasPermission = true;
              menuGroup.hasPermission = true;
            }
          }
        });
        if (!allowed) {
          self.menuGroups.forEach(function (menuGroup) {
            if (!menuGroup.menuItems) {
              return;
            }
            menuGroup.menuItems.forEach(function (menuItem) {
              if (menuItem.name === '学员风险') {
                menuItem.hasPermission = false;
              }
            });
          });
        }
        if (self.hasHrWorkbenchMenu()) {
          self.loadHrBadges();
        }
        self.loadRecruitBadges();
      });
    },
    findMenuUrl: function findMenuUrl(name) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.menuGroups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var menuGroup = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuGroup.menuItems || []), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var menuItem = _step2.value;

              if (menuItem.name === name && menuItem.url) return menuItem.url;
              if (menuItem.subItems) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuItem.subItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var sub = _step3.value;

                    if (sub.name === name && sub.url) return sub.url;
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return '';
    },
    selectMenu: function selectMenu(route) {
      if (!route) {
        return;
      }
      var path = route.path;
      if (!path) {
        this.$logger.debug('path 不存在');
        return;
      }

      if (path && path.length > 1 && path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
      }
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.menuGroups), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var menuGroup = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuGroup.menuItems), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var menuItem = _step5.value;

              if (menuItem.url === path) {
                return menuItem.name;
              } else if (menuItem.subItems) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuItem.subItems), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var sub = _step6.value;

                    if (sub.url === path) {
                      return sub.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }
              } else if (menuItem.children) {
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                  for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuItem.children), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var pathPattern = _step7.value;

                    if (__WEBPACK_IMPORTED_MODULE_3_matcher___default.a.isMatch(path, pathPattern)) {
                      return menuItem.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError7 = true;
                  _iteratorError7 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                      _iterator7.return();
                    }
                  } finally {
                    if (_didIteratorError7) {
                      throw _iteratorError7;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return this.selectParentMenu(route);
    },
    selectParentMenu: function selectParentMenu(route) {
      if (!route || !route.path) {
        return;
      }
      var path = route.path;
      if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
      }
      path = path.substring(0, path.lastIndexOf('/'));
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.menuGroups), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var menuGroup = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuGroup.menuItems), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var menuItem = _step9.value;

              if (menuItem.url === path) {
                return menuItem.name;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    onSelect: function onSelect(name) {
      var _this = this;

      this.menuGroups.forEach(function (menuGroup) {
        if (menuGroup.url) {
          if (menuGroup.name === name) {
            _this.$router.push(menuGroup.url);
            return;
          }
        }
        if (!menuGroup.menuItems) {
          return true;
        }
        menuGroup.menuItems.forEach(function (menuItem) {
          if (menuItem.name === name && menuItem.url) {
            _this.$router.push(menuItem.url);
            return;
          }
          if (menuItem.subItems) {
            menuItem.subItems.forEach(function (sub) {
              if (sub.name === name && sub.url) {
                _this.$router.push(sub.url);
              }
            });
          }
        });
      });
    },
    onOpenChange: function onOpenChange(names) {
      if (Array.isArray(names) && names !== this.openNames) {
        this.openNames = names;
      }
    },
    ensureOpenParents: function ensureOpenParents(route) {
      var _this2 = this;

      if (!route || !route.path) return;
      var path = route.path;
      if (path.length > 1 && path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
      }
      var need = [];
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.menuGroups), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var menuGroup = _step10.value;
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuGroup.menuItems || []), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var menuItem = _step11.value;

              if (menuItem.url === path) {
                need = [menuGroup.name];
              } else if (menuItem.subItems) {
                var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                  for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuItem.subItems), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var sub = _step12.value;

                    if (sub.url === path) {
                      need = [menuGroup.name, menuItem.name];
                    }
                  }
                } catch (err) {
                  _didIteratorError12 = true;
                  _iteratorError12 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                      _iterator12.return();
                    }
                  } finally {
                    if (_didIteratorError12) {
                      throw _iteratorError12;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      var cur = this.openNames || [];
      var next = need;
      var changed = next.length !== cur.length || next.some(function (n) {
        return cur.indexOf(n) < 0;
      }) || cur.some(function (n) {
        return next.indexOf(n) < 0;
      });
      if (changed) {
        this.openNames = next;
      }
      this.$nextTick(function () {
        _this2.syncSubmenuOpened();
      });
    },
    syncSubmenuOpened: function syncSubmenuOpened() {
      var menu = this.$refs.sideMenu;
      if (!menu) return;
      if (menu.updateOpened) {
        menu.updateOpened();
      }

      var open = this.openNames || [];
      var walk = function walk(vm, out) {
        ;(vm.$children || []).forEach(function (c) {
          if (c.$options && c.$options.name === 'Submenu') out.push(c);
          walk(c, out);
        });
        return out;
      };
      walk(menu, []).forEach(function (item) {
        if (open.indexOf(item.name) < 0) {
          item.opened = false;
        } else {
          item.opened = true;
        }
      });
    },
    isHrWorkbenchRoute: function isHrWorkbenchRoute(route) {
      var path = route && route.path || '';
      return path === '/hrWorkbench' || path.indexOf('/hrWorkbench/') === 0;
    },
    isRecruitRoute: function isRecruitRoute(route) {
      var path = route && route.path || '';
      return path.indexOf('/tch/recruit/') === 0;
    },
    hrBadgeCount: function hrBadgeCount(menuItem) {
      if (menuItem && menuItem.recruitBadgeKey) {
        return this.hrBadgeNum(this.recruitBadges[menuItem.recruitBadgeKey]);
      }
      if (!menuItem || !menuItem.badgeKey) {
        return 0;
      }
      var n = Number(this.hrBadges[menuItem.badgeKey]);
      if (!isFinite(n) || n <= 0) {
        return 0;
      }
      return Math.floor(n);
    },
    hasHrWorkbenchMenu: function hasHrWorkbenchMenu() {
      var groups = this.menuGroups || [];
      for (var i = 0; i < groups.length; i++) {
        var items = groups[i].menuItems || [];
        for (var j = 0; j < items.length; j++) {
          if (items[j].badgeKey && items[j].hasPermission) {
            return true;
          }
          var subs = items[j].subItems || [];
          for (var k = 0; k < subs.length; k++) {
            if (subs[k].badgeKey && subs[k].hasPermission) {
              return true;
            }
          }
        }
      }
      return false;
    },
    loadHrBadges: function loadHrBadges() {
      if (!this.hasHrWorkbenchMenu()) {
        return;
      }
      var self = this;
      self.$http.post('/tch/hr-workbench/badges', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hrWorkbench_constants__["u" /* badgesAdviserParam */])(), { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          var d = res.data;
          self.hrBadges = {
            supervise: self.hrBadgeNum(d.supervise),
            probation: self.hrBadgeNum(d.probation),
            review: self.hrBadgeNum(d.review),
            contract: self.hrBadgeNum(d.contract),
            followup: self.hrBadgeNum(d.followup)
          };
        }
      });
    },
    hasRecruitBadgeMenu: function hasRecruitBadgeMenu() {
      var groups = this.menuGroups || [];
      for (var i = 0; i < groups.length; i++) {
        var items = groups[i].menuItems || [];
        for (var j = 0; j < items.length; j++) {
          if (items[j].recruitBadgeKey && items[j].hasPermission) {
            return true;
          }
          var subs = items[j].subItems || [];
          for (var k = 0; k < subs.length; k++) {
            if (subs[k].recruitBadgeKey && subs[k].hasPermission) {
              return true;
            }
          }
        }
      }
      return false;
    },
    loadRecruitBadges: function loadRecruitBadges() {
      if (!this.hasRecruitBadgeMenu()) {
        return;
      }
      var self = this;
      self.$http.post('/tchRecruit/interview/summary', {}, { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.recruitBadges = {
            interviewing: self.hrBadgeNum(res.data.interviewing),
            reserved: self.hrBadgeNum(res.data.reserved)
          };
        }
      }).catch(function () {});
    },
    hrBadgeNum: function hrBadgeNum(v) {
      var n = Number(v);
      if (!isFinite(n) || n <= 0) {
        return 0;
      }
      return Math.floor(n);
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BalanceModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      fundParam: {
        amount: 43.43,
        id: this.openedId
      },
      loadingBalance: false,
      fundRule: {
        amount: [{ type: 'number', required: true, message: '请输入金额', trigger: 'blur' }, { type: 'number', message: '必须为数字', trigger: 'blur' }]
      }
    };
  },

  methods: {
    balance: function balance() {
      var _this = this;

      var self = this;
      this.loadingAdd = true;
      this.$refs.fundForm.validate(function (valid) {
        if (!valid) {
          _this.$Message.warning('信息输入错误!');
          _this.loadingAdd = false;
          return;
        }
        _this.loadingAdd = false;
        _this.visible = false;
        _this.$http.post('/bookLesson/balanceBook', { amount: _this.fundParam.amount, id: _this.openedId }).then(function (res) {
          console.log(_this.openedId);
          self.loadingAdd = false;
          if (res) {
            self.successCallback();
            self.$Message.success('处理成功!');
            self.visible = false;
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_ResetPassWordModal_vue__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_ResetPassWordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_ResetPassWordModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ResetPassWordModal: __WEBPACK_IMPORTED_MODULE_0__modal_ResetPassWordModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      reload: 0,
      resetModal: false,
      queryParam: {},
      formData: {
        classinAccout: null
      },
      bookClassinStatusList: [{ code: 0, text: '未使用' }, { code: 1, text: '己使用' }, { code: 2, text: '失败' }, { code: 2, text: '禁用' }],
      title: [{
        title: '临时账号',
        key: 'classinAccout'
      }, {
        title: '临时密码',
        key: 'classinPwd'
      }, {
        title: '密码重置时间',
        align: 'center',
        render: function render(h, params) {
          var classinResetTime = params.row.classinResetTime || '';
          return h('span', classinResetTime && $moment(classinResetTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '课程结束时间',
        align: 'center',
        render: function render(h, params) {
          var lsnEndTime = params.row.lsnEndTime || '';
          return h('span', lsnEndTime && $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '是否已经使用',
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum(_this.bookClassinStatusList, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                return _this.reSetPassword(params.row);
              } } }, '重置密码')]);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    reSetPassword: function reSetPassword(row) {
      var self = this;
      self.formData.classinAccout = row.classinAccout;
      self.resetModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    delAll: function delAll() {
      this.$refs.dataList.delAll();
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalanceModal_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalanceModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BalanceModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RejectBalanceModal_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RejectBalanceModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RejectBalanceModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookUserFeedbackModal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookUserFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BookUserFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BookTchFeedbackModal_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BookTchFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BookTchFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BookTchScoreFeedbackModal_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BookTchScoreFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BookTchScoreFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClassMemberTimeModal_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClassMemberTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ClassMemberTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_MonitorLessonRecordListModal_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_MonitorLessonRecordListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_MonitorLessonRecordListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_StudentWriteReviewDemoModal_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_StudentWriteReviewDemoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__user_StudentWriteReviewDemoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_StudentWriteReviewRegularModal_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_StudentWriteReviewRegularModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__user_StudentWriteReviewRegularModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_StudentWriteReviewFinishLevelModal_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_StudentWriteReviewFinishLevelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__user_StudentWriteReviewFinishLevelModal_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BalanceModal: __WEBPACK_IMPORTED_MODULE_1__BalanceModal_vue___default.a,
    RejectBalanceModal: __WEBPACK_IMPORTED_MODULE_2__RejectBalanceModal_vue___default.a,
    BookUserFeedbackModal: __WEBPACK_IMPORTED_MODULE_3__BookUserFeedbackModal_vue___default.a,
    BookTchFeedbackModal: __WEBPACK_IMPORTED_MODULE_4__BookTchFeedbackModal_vue___default.a,
    ClassMemberTimeModal: __WEBPACK_IMPORTED_MODULE_6__ClassMemberTimeModal_vue___default.a,
    BookTchScoreFeedbackModal: __WEBPACK_IMPORTED_MODULE_5__BookTchScoreFeedbackModal_vue___default.a,
    MonitorLessonRecordListModal: __WEBPACK_IMPORTED_MODULE_7__modal_MonitorLessonRecordListModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_8__crm_UserInfoModal_vue___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_9__teacher_modal_TchInfoModal_vue___default.a,
    StudentWriteReviewDemoModal: __WEBPACK_IMPORTED_MODULE_11__user_StudentWriteReviewDemoModal_vue___default.a,
    StudentWriteReviewRegularModal: __WEBPACK_IMPORTED_MODULE_12__user_StudentWriteReviewRegularModal_vue___default.a,
    StudentWriteReviewFinishLevelModal: __WEBPACK_IMPORTED_MODULE_13__user_StudentWriteReviewFinishLevelModal_vue___default.a
  },
  data: function data() {
    var _this = this,
        _ref,
        _ref2;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      studentWriteReviewRegularModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        word1: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word2: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word3: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word4: [{ remark: '' }, { remark: '' }, { remark: '' }],
        fileList: [],
        parent: '',
        levelMsg: ''
      },
      studentWriteReviewDemoModalFormData: {
        remark: '',
        word1: '',
        word2: ''
      },
      studentWriteReviewFinishLevelModalFormData: {
        remark: '',
        suggestions: '',
        fileList: []
      },
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewDemoModal: false,
      searchLoading: false,
      rankScoreSeq: 0,
      editUser: false,
      uid: null,
      reload: 0,
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnType: '',
        courseType: '',
        checkStatus: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        reviewState: '',
        stageSummary: '',
        isTenthLesson: '',
        tchIsFeedback: '',
        userIsComplaint: ''
      },
      openedId: null,
      showBalanceModal: false,
      showRejectBalanceModal: false,
      showBookUserFeedbackModal: false,
      showClassMemberTimeModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      showMonitorLessonRecordListModal: false,
      monitorLessonRecordId: null,
      tchStudyAdviserList: [],
      title: [{
        title: '学生ID、姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '老师姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId, row.tchClassin);
            }
          });
        }
      }, {
        title: '学导',
        width: 70,
        align: 'center',
        key: 'studyAdviserNickname'
      }, (_ref = {
        title: '课程名称',
        width: 110,
        align: 'center'
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'align', 'center'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'key', 'lessonTitle'), _ref), (_ref2 = {
        title: '课程类型',
        align: 'center',
        width: 110
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'align', 'center'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'render', function render(h, params) {
        var lsnType = params.row.lsnType;
        var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
        return h('span', typeEnum && typeEnum.text);
      }), _ref2), {
        title: '课程顾问',
        width: 110,
        align: 'center',
        key: 'adviserNickname'
      }, {
        title: '外教运营',
        width: 110,
        align: 'center',
        key: 'tchAdviserNickname'
      }, {
        title: '上课时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 110,
        key: 'courseTime'
      }, {
        title: '状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '学生对老师评价',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookUserFeedbackId = row.bookUserFeedbackId;
          var bookUserFeedbackStar = row.bookUserFeedbackStar;
          if (bookUserFeedbackId) {
            return h('div', [h('Rate', {
              props: {
                disabled: true,
                count: bookUserFeedbackStar,
                value: bookUserFeedbackStar
              }
            }), h('br'), h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showBookUserFeedbackModal = true;
                }
              } }, '查看')]);
          }
          return h('span', { style: { color: 'red' } }, '未评论');
        }
      }, {
        title: '老师对学生评价',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookTchFeedbackUid = row.bookTchFeedbackUid;
          if (bookTchFeedbackUid) {
            return h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  if (row.lsnType === 1) {
                    _this.studentWriteReviewDemoModal = true;
                  } else if (row.lsnType === 2) {
                    if (row.stageSummary) {
                      _this.studentWriteReviewFinishLevelModal = true;
                    } else {
                      _this.studentWriteReviewRegularModal = true;
                    }
                  }
                }
              } }, '查看');
          }
          return h('span', { style: { color: 'red' } }, '未评论');
        }
      }, {
        title: '上课情况',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('a', { on: {
              click: function click() {
                _this.openedId = params.row.id;
                _this.showClassMemberTimeModal = true;
              }
            } }, '查看');
        }
      }, {
        title: '教室',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var classType = row.classType;
          var typeEnum = $constant.getEnum($constant.classType, classType);
          return h('div', [h('span', typeEnum && typeEnum.text), h('span', '-'), h('br'), h('span', row.courseId)]);
        }
      }, {
        title: '监课记录',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isMonitorLessonRecord = row.isMonitorLessonRecord;
          if (isMonitorLessonRecord) {
            return h('a', { on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showMonitorLessonRecordListModal = true;
                }
              } }, '查看');
          }
          return h('span', { style: { color: 'red' } }, '未记录');
        }
      }, {
        title: '审核状态',
        width: 85,
        align: 'center',
        render: function render(h, params) {
          var checkStatus = params.row.checkStatus;
          var statusEnum = $constant.getEnum($constant.bookLessonOpenedCheckStatus, checkStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核备注',
        width: 120,
        align: 'center',
        key: 'checkReason'
      }, {
        title: '最后操作人',
        width: 120,
        align: 'center',
        key: 'adminNickname'
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 90,
        render: function render(h, params) {
          var id = params.row.id;
          return h('div', [h('a', { on: { click: function click() {
                _this.openedId = id;
                _this.showBalanceModal = true;
              } } }, '课程结算'), h('br', { class: 'divider' }), h('a', { on: { click: function click() {
                _this.openedId = id;
                _this.showRejectBalanceModal = true;
              } } }, '拒绝结算')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      self.tchStudyAdviserList = res.data;
    });
  },
  created: function created() {

    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-3, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    openTchInfoModal: function openTchInfoModal(val, classIn) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    onBookUserFeedBackClose: function onBookUserFeedBackClose() {
      this.showBookUserFeedbackModal = false;
    },
    onBookTchScoreFeedBackClose: function onBookTchScoreFeedBackClose() {
      this.showBookTchScoreFeedbackModal = false;
    },
    onBookTchFeedBackClose: function onBookTchFeedBackClose() {
      this.showBookTchFeedbackModal = false;
    },
    onClassMemberClose: function onClassMemberClose(val) {
      this.showClassMemberTimeModal = false;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonFinishedList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    closeReviewModal: function closeReviewModal(val) {
      this.studentWriteReviewRegularModal = false;
      this.studentWriteReviewDemoModal = false;
      this.studentWriteReviewFinishLevelModal = false;
    }
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LessonFeedBackModal_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LessonFeedBackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LessonFeedBackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_SearchChangeTchModal_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_SearchChangeTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modal_SearchChangeTchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_modal_UserTempLessonModal_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_modal_UserTempLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__user_modal_UserTempLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_AddLessonFeedbackModal_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_AddLessonFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_AddLessonFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__teacher_modal_AddClassRequirementModal_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__teacher_modal_AddClassRequirementModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__teacher_modal_AddClassRequirementModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BookTchFeedbackModal_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BookTchFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__BookTchFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BookTchScoreFeedbackModal_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BookTchScoreFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__BookTchScoreFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__BookUserFeedbackModal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__BookUserFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__BookUserFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_StudentWriteReviewDemoModal_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_StudentWriteReviewDemoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__user_StudentWriteReviewDemoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_StudentWriteReviewRegularModal_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_StudentWriteReviewRegularModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__user_StudentWriteReviewRegularModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__user_StudentWriteReviewFinishLevelModal_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__user_StudentWriteReviewFinishLevelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__user_StudentWriteReviewFinishLevelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__user_StudentWriteReviewDemoV2Modal_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__user_StudentWriteReviewDemoV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__user_StudentWriteReviewDemoV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__user_StudentWriteReviewRegularV2Modal_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__user_StudentWriteReviewRegularV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__user_StudentWriteReviewRegularV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__user_StudentWriteReviewFinishLevelV2Modal_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__user_StudentWriteReviewFinishLevelV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__user_StudentWriteReviewFinishLevelV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ClassFeedback_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ClassFeedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ClassFeedback_vue__);



























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserTempLessonModal: __WEBPACK_IMPORTED_MODULE_12__user_modal_UserTempLessonModal_vue___default.a,
    LessonFeedBackModal: __WEBPACK_IMPORTED_MODULE_10__LessonFeedBackModal_vue___default.a,
    ChangeLessonModal: __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue___default.a,
    ChangeClassTypeModal: __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue___default.a,
    AddMonitorLessonRecordModal: __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue___default.a,
    TchLessonLeaveModal: __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue___default.a,
    LessonCancelModal: __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue___default.a,
    UserOneLeaveModal: __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue___default.a,
    SearchChangeTchModal: __WEBPACK_IMPORTED_MODULE_11__modal_SearchChangeTchModal_vue___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue___default.a,
    AddLessonFeedbackModal: __WEBPACK_IMPORTED_MODULE_13__modal_AddLessonFeedbackModal_vue___default.a,
    AddClassRequirementModal: __WEBPACK_IMPORTED_MODULE_14__teacher_modal_AddClassRequirementModal_vue___default.a,
    BookTchFeedbackModal: __WEBPACK_IMPORTED_MODULE_15__BookTchFeedbackModal_vue___default.a,
    BookTchScoreFeedbackModal: __WEBPACK_IMPORTED_MODULE_16__BookTchScoreFeedbackModal_vue___default.a,
    BookUserFeedbackModal: __WEBPACK_IMPORTED_MODULE_17__BookUserFeedbackModal_vue___default.a,
    StudentWriteReviewDemoModal: __WEBPACK_IMPORTED_MODULE_18__user_StudentWriteReviewDemoModal_vue___default.a,
    StudentWriteReviewRegularModal: __WEBPACK_IMPORTED_MODULE_19__user_StudentWriteReviewRegularModal_vue___default.a,
    StudentWriteReviewFinishLevelModal: __WEBPACK_IMPORTED_MODULE_20__user_StudentWriteReviewFinishLevelModal_vue___default.a,
    StudentWriteReviewDemoV2Modal: __WEBPACK_IMPORTED_MODULE_21__user_StudentWriteReviewDemoV2Modal_vue___default.a,
    StudentWriteReviewRegularV2Modal: __WEBPACK_IMPORTED_MODULE_22__user_StudentWriteReviewRegularV2Modal_vue___default.a,
    StudentWriteReviewFinishLevelV2Modal: __WEBPACK_IMPORTED_MODULE_23__user_StudentWriteReviewFinishLevelV2Modal_vue___default.a,
    ClassFeedback: __WEBPACK_IMPORTED_MODULE_24__ClassFeedback_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      editUser: false,
      uid: null,
      showTchInfoModal: false,
      unifiedHolidayModal: false,
      showSearchChangeTchModal: false,
      showUserTempLessonModal: false,
      changeTeacherOnly: false,
      optType: 0,
      tchId: null,
      userNickname: '',
      reload: 0,
      reloadWithPage: 0,
      param: {
        date: __WEBPACK_IMPORTED_MODULE_9__tools_date_dates_js___default.a.today(),
        studyAdviserId: '',
        keywords: '',
        totalCount: 0,
        isAudition: null,
        category: null,
        tchType: null,
        accent: null,
        sex: null,
        pageIndex: 1,
        pageSize: 20

      },
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        materialVersionId: '',
        isStudyAdviser: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnSelStatusList: [],
        lsnType: '',
        courseType: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        startCreateDate: '',
        endCreateDate: '',
        startCreateTime: '',
        endCreateTime: '',
        adviserId: '',
        adviserIds: [],
        operatorIds: [],
        regStartDate: '',
        regEndDate: '',
        regStartTime: '',
        regEndTime: '',
        creatorName: '',
        adminUserId: '',
        regType: '',
        tchChannel: '',
        tchStudyAdviserId: '',
        isLastSection: '',
        levelId: '',
        lessonId: ''
      },
      holidayParam: {
        startTime: '',
        endTime: '',
        content: ''
      },
      tempLessonUser: {},
      holidayRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        content: [{ required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      weekMap: {
        'Sun': '周日',
        'Mon': '周一',
        'Tue': '周二',
        'Wed': '周三',
        'Thu': '周四',
        'Fri': '周五',
        'Sat': '周六'
      },
      tchStudyAdviserList: [],
      bookMaterialLevelList: [],
      bookMaterialLessonsList: [],
      selectionOpenedIds: [],
      openedId: null,
      lsnType: null,
      openId: null,
      lessonOpened: {},
      classType: null,
      lessonTitle: null,
      lsnBeginTime: null,
      showChangeLessonModal: false,
      showChangeLClassTypeModal: false,
      showMonitorLessonRecordModal: false,
      showTchLessonLeaveModal: false,
      showLessonCancelModal: false,
      showLessonFeedBackModal: false,
      tchChannel: null,
      showUserOneLeaveModal: false,
      addLessonFeedbackModal: false,
      studentName: '',
      teacherName: '',
      lessonTime: '',
      showAddClassRequirementModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      showBookUserFeedbackModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewDemoV2Modal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      showClassFeedback: false,
      classFeedbackOpenedId: '',
      classFeedbackRow: null,
      currentUid: null,
      currentTchId: null,
      currentOpenedId: null,
      currentTchName: '',
      classRequirement: '',
      classRequirementTags: [],
      currentStudentName: '',
      showCameraStatus: false,
      title: [{
        type: 'selection',
        width: 40,
        align: 'center'
      }, {
        title: '课程ID',
        align: 'center',
        width: 80,
        key: 'id'
      }, {
        title: '课程信息',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          var lsnType = row.lsnType;
          var title = row.lessonTitle;
          var lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          var cType = typeEnum && typeEnum.text;
          if (cType) {
            cType = '课程类别：' + cType;
          } else {
            cType = '';
          }
          return h('div', { style: { 'font-size': '13px' } }, [h('p', { style: { color: '#2d8cf0' } }, title), h('p', '课程类型：' + (lsnTypeEnum && lsnTypeEnum.text)), h('p', cType)]);
        }
      }, {
        title: '当前上课时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var isHighlighted = params.row.firstLesson || false;

          var cellStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }, isHighlighted ? { backgroundColor: '#adf3c1' } : {});

          var date = $moment(lsnBeginTime, 'X');
          var dateStr = date.format('YYYY-MM-DD HH:mm');
          var weekStr = _this.weekMap[date.format('ddd')] || date.format('ddd');

          return h('div', { style: cellStyle }, [h('div', dateStr), h('div', { style: { fontSize: '12px', marginTop: '2px' } }, weekStr)]);
        }
      }, {
        title: '固定上课时间',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          var tchBoundNum = row.bookWorkLessonOpenedTimeList;
          if (tchBoundNum) {
            var list = row.bookWorkLessonOpenedTimeList;
            var spanArr = [];
            if (list) {
              list.forEach(function (element) {
                var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
                spanArr.push(h('br'));
              });
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '当前老师',
        align: 'center',
        width: 220,
        render: function render(h, params) {
          var row = params.row;
          var isChange = '';
          if (row.isNewTch === 1) {
            isChange = '(替)';
          }

          var statusText = '';
          var statusClass = '';
          if (row.tchAbsent === 1) {
            statusText = '缺席';
            statusClass = 'status-absent';
          } else if (row.tchLate === 1) {
            statusText = '迟到';
            statusClass = 'status-late';
          }

          var statusTag = statusText ? h('span', { class: 'status-tag ' + statusClass }, ' [' + statusText + ']') : null;

          var content = [h('span', row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange)];

          if (row.tchReceivedDemoMsg > 0) {
            content.push(h('Icon', {
              props: {
                type: 'md-checkmark-circle',
                color: '#19be6b'
              },
              style: {
                marginLeft: '4px',
                fontSize: '16px'
              },
              domProps: {
                innerHTML: '✅'
              }
            }));
          } else {
            var hasClassRequirement = row.classRequirement && typeof row.classRequirement === 'string' && row.classRequirement.trim().length > 0;
            var hasClassRequirementTags = row.classRequirementTags && Array.isArray(row.classRequirementTags) && row.classRequirementTags.length > 0;
            if (hasClassRequirement || hasClassRequirementTags) {
              content.push(h('Icon', {
                props: {
                  type: 'md-checkmark-circle',
                  color: '#c5c8ce'
                },
                style: {
                  marginLeft: '4px',
                  fontSize: '16px',
                  filter: 'grayscale(100%)'
                },
                domProps: {
                  innerHTML: '✅'
                }
              }));
            }
          }
          if (statusTag) {
            content.push(statusTag);
          }

          var deviceStatusIcons = [];

          if (row.cameraStatus === 1) {
            deviceStatusIcons.push(h('Icon', {
              props: {
                type: 'ios-videocam',
                color: '#19be6b'
              },
              style: {
                marginRight: '4px',
                fontSize: '16px'
              },
              title: '摄像头正常'
            }));
          } else if (row.cameraStatus === 2) {
            deviceStatusIcons.push(h('span', {
              style: {
                marginRight: '4px',
                fontSize: '16px',
                color: '#909399',
                filter: 'grayscale(100%)',
                opacity: 0.5,
                cursor: 'default'
              },
              attrs: {
                title: '摄像头异常'
              }
            }, '📹'));
          }

          if (row.micStatus === 1) {
            deviceStatusIcons.push(h('Icon', {
              props: {
                type: 'ios-mic',
                color: '#19be6b'
              },
              style: {
                marginRight: '4px',
                fontSize: '16px'
              },
              title: '麦克风正常'
            }));
          } else if (row.micStatus === 2) {
            deviceStatusIcons.push(h('Icon', {
              props: {
                type: 'ios-mic-off',
                color: '#909399'
              },
              style: {
                marginRight: '4px',
                fontSize: '16px'
              },
              title: '麦克风异常'
            }));
          }

          if (row.headphoneStatus === 1) {
            deviceStatusIcons.push(h('span', {
              style: {
                marginRight: '4px',
                fontSize: '16px',
                cursor: 'default'
              },
              attrs: {
                title: '耳机正常'
              }
            }, '🎧'));
          } else if (row.headphoneStatus === 2) {
            deviceStatusIcons.push(h('span', {
              style: {
                marginRight: '4px',
                fontSize: '16px',
                color: '#909399',
                filter: 'grayscale(100%)',
                opacity: 0.5,
                cursor: 'default'
              },
              attrs: {
                title: '耳机异常'
              }
            }, '🎧'));
          }

          if (deviceStatusIcons.length > 0) {}
          var str = '';
          if (row.openCamara === 0 && _this.showCameraStatus) {
            str = '课前未打开摄像头';
          }

          return h('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } }, [h('a', { on: { click: function click() {
                return _this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName);
              } } }, content), h('span', { style: { color: 'red' } }, str)]);
        }
      }, {
        title: '学生ID、姓名',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          var row = params.row;

          var statusText = '';
          var statusClass = '';
          if (row.stdAbsent === 1) {
            statusText = '缺席';
            statusClass = 'status-absent';
          } else if (row.stdLate === 1) {
            statusText = '迟到';
            statusClass = 'status-late';
          }

          var statusTag = statusText ? h('span', { class: 'status-tag ' + statusClass }, ' [' + statusText + ']') : null;

          var textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {};
          var content = [h('span', { style: textStyle }, row.uid + '-' + row.userNickname)];

          if (statusTag) {
            content.push(statusTag);
          }

          return h('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } }, [h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, content)]);
        }
      }, {
        title: '学生手机号',
        align: 'center',
        width: 120,
        key: 'mobile',
        render: function render(h, params) {
          var row = params.row;
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', row.mobile.length === 11 ? row.mobile.substring(0, 3) + '****' + row.mobile.substring(7) : row.mobile), h('div', { slot: 'content' }, row.mobile)]);
        }
      }, {
        title: '课节情况',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('p', '已上课:' + row.endLessonNum), h('p', '总课节:' + row.routineNum)]);
        }
      }, {
        title: '学导',
        align: 'center',
        width: 110,
        key: 'studyAdviserNickname'
      }, {
        title: '课程顾问',
        width: 110,
        key: 'adviserNickname'
      }, {
        title: '外管',
        align: 'center',
        width: 110,
        key: 'tchStudyName'
      }, {
        title: '状态',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '渠道',
        align: 'center',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          var children = [h('span', row.regType || '')];
          if (row.inviteId) {
            children.push(h('br'));
            children.push(h('span', { style: { fontSize: '12px', color: '#E6A23C' } }, row.inviteId + '-' + (row.inviteName || '')));
          }
          return h('div', children);
        }
      }, {
        title: '课堂反馈',
        align: 'center',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          var n = parseInt(row.classFeedbackStar, 10);
          if (row.lsnSelStatus === 1 && (!n || n < 1)) {
            return h('span', '未评分');
          }
          if (!n || n < 1) {
            return h('a', {
              style: { color: '#2d8cf0', cursor: 'pointer' },
              on: {
                click: function click() {
                  _this.openClassFeedback(row);
                }
              }
            }, '去评分');
          }
          if (n > 5) {
            n = 5;
          }
          return h('span', {
            style: { color: '#f0a020', cursor: 'pointer', fontSize: '16px', letterSpacing: '1px' },
            on: {
              click: function click() {
                _this.openClassFeedback(row);
              }
            }
          }, '★'.repeat(n));
        }
      }, {
        title: '操作时间',
        width: 170,
        align: 'center',
        key: 'gmtModified'
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          var id = row.id;
          var lsnType = row.lsnType;
          var lessonTitle = row.lessonTitle;
          var lsnBeginTime = row.lsnBeginTime;
          var tchChannel = row.tchChannel;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'lessonUrl' } }, '课程链接'));
          if (row.lsnSelStatus === 1) {
            var time = new Date().getTime();
            if (lsnBeginTime * 1000 - time >= 20 * 60 * 1000) {
              btn.push(h('Dropdown-item', { props: { name: 'changeLesson' } }, '调课件'));
            }
            btn.push(h('Dropdown-item', { props: { name: 'userTemp' } }, '临时约课'));
            btn.push(h('Dropdown-item', { props: { name: 'userLeave' } }, '学生请假'));

            if (row.lsnSelStatus !== 2 && lsnBeginTime * 1000 > time) {
              btn.push(h('Dropdown-item', { props: { name: 'cancelLesson' } }, '取消课程'));
            }
            if (row.isNewTch === 1) {
              btn.push(h('Dropdown-item', { props: { name: 'cancelProxy' } }, '取消代课'));
            }
            btn.push(h('Dropdown-item', { props: { name: 'classRequire' } }, '上课要求'));
            if (row.isRecordScreen === 1) {
              btn.push(h('Dropdown-item', { props: { name: 'closeRecordScreen' } }, '关闭录屏'));
            } else {
              btn.push(h('Dropdown-item', { props: { name: 'openRecordScreen' } }, '开启录屏'));
            }
            if (lsnBeginTime * 1000 > time + 20 * 60 * 1000) {}
            btn.push(h('Dropdown-item', { props: { name: 'reloadClassIn' } }, '手动生成ClassIn ID'));
          }
          if (row.lsnSelStatus === 6 || row.lsnSelStatus === 13) {
            var _time = new Date().getTime();
            if (lsnBeginTime * 1000 > _time) {
              btn.push(h('Dropdown-item', { props: { name: 'proxyLesson' } }, '老师代课'));
            }
          }
          if (row.makeUp === 1) {
            btn.push(h('Dropdown-item', { props: { name: 'cancelMakeUp' } }, '取消补课'));
          } else {
            btn.push(h('Dropdown-item', { props: { name: 'confirmMakeUp' } }, '补课'));
          }
          if (row.lsnSelStatus <= 3 && row.liveUrl) {
            btn.push(h('Dropdown-item', { props: { name: 'viewRecordScreen' } }, '监课/回放'));
          }
          if (row.lsnSelStatus === 3 || row.lsnSelStatus === 6 || row.lsnSelStatus === 13) {
            btn.push(h('Dropdown-item', { props: { name: 'lessonFeedBack' } }, '我要投诉'));
            btn.push(h('Dropdown-item', { props: { name: 'addLessonFeedback' } }, '上课反馈'));
            btn.push(h('Dropdown-item', { props: { name: 'classRequire' } }, '上课要求'));
            btn.push(h('Dropdown-item', { props: { name: 'viewTchFeedback' } }, '查看外教评价'));
          }

          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click',
              placement: 'bottom-end'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'reloadClassIn') {
                  _this.onReloadClassIn(row);
                } else if (name === 'lessonUrl') {
                  window.open('https://medias.kouyujie.cn/' + row.filePath);
                } else if (name === 'changeLesson') {
                  _this.lessonOpened = row;
                  _this.showChangeLessonModal = true;
                } else if (name === 'userLeave') {
                  _this.openId = id;
                  _this.lessonTitle = lessonTitle;
                  _this.lsnBeginTime = lsnBeginTime;
                  _this.showUserOneLeaveModal = true;
                } else if (name === 'tchLeave') {
                  _this.openedId = id;
                  _this.lessonTitle = lessonTitle;
                  _this.lsnBeginTime = lsnBeginTime;
                  _this.showTchLessonLeaveModal = true;
                } else if (name === 'cancelLesson') {
                  _this.openedId = id;
                  _this.uid = row.uid;
                  _this.tchId = row.tchId;
                  _this.lsnType = lsnType;
                  _this.showLessonCancelModal = true;
                  _this.tchChannel = tchChannel;
                } else if (name === 'userAbsent') {
                  _this.onUserAbsent(row);
                } else if (name === 'confirmMakeUp') {
                  _this.onConfirmMakeUp(row);
                } else if (name === 'tchAbsent') {
                  _this.onTchAbsent(row);
                } else if (name === 'monitorLesson') {
                  _this.openedId = id;
                  _this.showMonitorLessonRecordModal = true;
                } else if (name === 'closeRecordScreen') {
                  _this.closeRecordScreen(row);
                } else if (name === 'openRecordScreen') {
                  _this.openRecordScreen(row);
                } else if (name === 'viewRecordScreen') {
                  _this.viewRecordScreen(row);
                } else if (name === 'lessonFeedBack') {
                  _this.lessonFeedBack(row);
                } else if (name === 'proxyLesson') {
                  _this.tempLessonUser = row;
                  _this.showSearchChangeTchModal = true;
                  _this.changeTeacherOnly = false;
                  _this.optType = 1;
                } else if (name === 'changeTeacherOnly') {
                  _this.tempLessonUser = row;
                  _this.showSearchChangeTchModal = true;
                  _this.changeTeacherOnly = true;
                  _this.optType = 2;
                } else if (name === 'userTemp') {
                  _this.showUserTempLessonModal = true;
                  _this.tempLessonUser = {
                    id: row.uid,
                    nickname: row.nickname,
                    levelId: row.levelId,
                    mobile: row.mobile
                  };
                } else if (name === 'cancelProxy') {
                  _this.cancelProxy(row);
                } else if (name === 'addLessonFeedback') {
                  _this.openedId = id;
                  _this.studentName = row.uid + '-' + row.userNickname;
                  _this.teacherName = row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + (row.isNewTch === 1 ? '(替)' : '');
                  _this.lessonTime = $moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm');
                  _this.addLessonFeedbackModal = true;
                } else if (name === 'classRequire') {
                  _this.currentUid = row.uid;
                  _this.currentStudentName = row.userNickname;
                  _this.currentTchId = row.tchId;
                  _this.currentOpenedId = row.id;
                  _this.currentTchName = row.tchFirstName + ' ' + row.tchLastName;
                  _this.classRequirement = row.classRequirement || '';
                  _this.classRequirementTags = row.classRequirementTags || [];
                  _this.showAddClassRequirementModal = true;
                } else if (name === 'viewTchFeedback') {
                  _this.viewTchFeedback(row);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.init();
    var self = this;
    self.queryParam.uid = this.$route.query.uid;
    self.queryParam.adviserId = this.$route.query.adviserId;
    self.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      self.tchStudyAdviserList = res.data;
    });
    this.loadBookMaterialLevel();
  },
  created: function created() {
    var self = this;
    var startTime = self.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment();
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      self.queryParam.startTimeDate = momentDate.toDate();
      self.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    init: function init() {
      var self = this;
      var query = self.$route.query;
      if (query) {
        if (query.regStartDate) {
          self.queryParam.regStartDate = parseInt(query.regStartTime) * 1000;
        }
        if (query.regEndDate) {
          self.queryParam.regEndDate = parseInt(query.regEndTime) * 1000;
        }
        if (query.startTimeDate) {
          self.queryParam.startTimeDate = parseInt(query.startTime) * 1000;
        }
        if (query.fromCrm === 1) {
          self.queryParam.startTimeDate = '';
        }
        if (query.endTimeDate) {
          self.queryParam.endTimeDate = parseInt(query.endTime) * 1000;
        }
        if (query.startCreateDate) {
          self.queryParam.startCreateDate = parseInt(query.startCreateTime) * 1000;
        }
        if (query.endCreateDate) {
          self.queryParam.endCreateDate = parseInt(query.endCreateTime) * 1000;
        }
        if (query.tchId) {
          self.queryParam.tchId = parseInt(query.tchId);
        }
        if (query.tchName) {
          self.queryParam.tchName = query.tchName;
        }
        if (query.materialVersionId) {
          self.queryParam.materialVersionId = parseInt(query.materialVersionId);
        }
        if (query.levelId) {
          self.queryParam.levelId = parseInt(query.levelId);
        }
        if (query.lessonId) {
          self.queryParam.lessonId = parseInt(query.lessonId);
        }
        if (query.levelId) {
          self.changeMaterialLevel(self.queryParam.levelId, true);
        }
        if (query.isStudyAdviser) {
          self.queryParam.isStudyAdviser = query.isStudyAdviser;
        }
        if (query.uid) {
          self.queryParam.uid = parseInt(query.uid);
        }
        if (query.userMobile) {
          self.queryParam.userMobile = query.userMobile;
        }
        if (query.userNickname) {
          self.queryParam.userNickname = query.userNickname;
        }
        if (query.adviserNickname) {
          self.queryParam.adviserNickname = query.adviserNickname;
        }
        if (query.studyAdviserNickname) {
          self.queryParam.studyAdviserNickname = query.studyAdviserNickname;
        }
        if (query.tchCategory) {
          self.queryParam.tchCategory = parseInt(query.tchCategory);
        }
        if (query.lsnSelStatus) {
          self.queryParam.lsnSelStatus = parseInt(query.lsnSelStatus);
        }

        if (query.lsnType) {
          self.queryParam.lsnType = parseInt(query.lsnType);
        }
        if (query.courseType) {
          self.queryParam.courseType = parseInt(query.courseType);
        }
        if (query.adviserId) {
          self.queryParam.adviserId = parseInt(query.adviserId);
        }
        if (query.creatorName) {
          self.queryParam.creatorName = query.creatorName;
        }
      }
    },
    openTchInfoModal: function openTchInfoModal(val, classIn) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.selectionOpenedIds = [];
      this.reload = new Date().getTime();
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    changeMaterialLevel: function changeMaterialLevel(val, skipSearch) {
      if (!skipSearch) {
        this.queryParam.lessonId = '';
      }
      this.bookMaterialLessonsList = [];
      if (val) {
        var _self = this;
        _self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          _self.bookMaterialLessonsList = res.data;
        });
      }
      if (!skipSearch) {
        this.search();
      }
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookLesson/regularClass/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '常规课程列表.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
      this.UserOneLeaveModal = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonOpenedList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openNewLessonModal: function openNewLessonModal(k, v) {
      if (this.$appConfig.active === 'prod') {
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      } else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startCreateTimeChange: function startCreateTimeChange(value) {
      this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endCreateTimeChange: function endCreateTimeChange(value) {
      this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startTimeRegChange: function startTimeRegChange(value) {
      this.queryParam.regStartTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeRegChange: function endTimeRegChange(value) {
      this.queryParam.regEndTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startTimeHolidayChange: function startTimeHolidayChange(value) {
      this.holidayParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeHolidayChange: function endTimeHolidayChange(value) {
      this.holidayParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onUserLeave: function onUserLeave(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 请假？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookUserLeaveTime/addByOpenedId', { openedId: id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('请假成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onTchLeave: function onTchLeave(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 请假？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookTchLeaveTime/addByOpenedId', { openedId: id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('请假成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onUserAbsent: function onUserAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/userAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onConfirmMakeUp: function onConfirmMakeUp(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 补课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/confirmMakeUp', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onTchAbsent: function onTchAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/tchAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onReloadClassIn: function onReloadClassIn(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/lesson/reloadClassIn', { openedId: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('生成成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    closeRecordScreen: function closeRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 0 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    openRecordScreen: function openRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 1 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    viewRecordScreen: function viewRecordScreen(row) {
      window.open(row.liveUrl);
    },
    lessonFeedBack: function lessonFeedBack(row) {
      this.openedId = row.id;
      this.uid = row.uid;
      this.tchId = row.tchId;
      this.userNickname = row.userNickname;
      this.showLessonFeedBackModal = true;
    },
    selectedChange: function selectedChange(selection) {
      this.selectionOpenedIds = selection;
    },
    batchCancelLesson: function batchCancelLesson() {
      if (this.selectionOpenedIds.length <= 0) {
        this.$Message.warning('请选择需要取消的课程！');
        return;
      }
      var self = this;
      var ids = [];
      var startedCount = 0;
      var now = Date.now();
      if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
        for (var i in this.selectionOpenedIds) {
          var dto = this.selectionOpenedIds[i];
          if (dto.lsnSelStatus === 2 || dto.lsnBeginTime * 1000 <= now) {
            startedCount++;
          } else {
            ids.push(dto.id);
          }
        }
      }
      if (startedCount > 0) {
        this.$Message.warning('课程已开始，不可取消');
      }
      if (ids.length <= 0) {
        return;
      }
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认取消已选课程？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookLesson/batchCancelLesson', {
            openedIds: ids.join(','),
            reason: '管理员取消'
          }).then(function (res) {
            self.search();
            self.$Message.success('操作成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    saveHoliday: function saveHoliday() {
      var self = this;
      var holidayValidate = 0;
      if (this.holidayParam.startTime && this.holidayParam.startTime !== '') {
        holidayValidate += 1;
      }
      if (this.holidayParam.endTime && this.holidayParam.endTime !== '') {
        holidayValidate += 1;
      }
      if (this.holidayParam.content && this.holidayParam.content !== '') {
        holidayValidate += 1;
      }
      if (holidayValidate !== 3) {
        return;
      }
      self.$http.post('/holiday/insert', this.holidayParam).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('新增成功!');
          self.unifiedHolidayModal = false;
          self.successCallback();
        } else {
          self.$Message.error('新增失败!');
        }
      }).catch(function (e) {});
    },
    cancelProxy: function cancelProxy(row) {
      var self = this;
      self.tempLessonUser = row;
      self.showSearchChangeTchModal = true;
      self.changeTeacherOnly = true;
      self.optType = 3;
    },
    viewTchFeedback: function viewTchFeedback(row) {
      this.openedId = row.id;
      if (row.lsnType === 1) {
        this.studentWriteReviewDemoV2Modal = true;
      } else if (row.lsnType === 2) {
        if (row.stageSummary) {
          this.studentWriteReviewFinishLevelV2Modal = true;
        } else {
          this.studentWriteReviewRegularV2Modal = true;
        }
      }
    },
    openClassFeedback: function openClassFeedback(row) {
      this.classFeedbackRow = row;
      this.classFeedbackOpenedId = row.id;
      this.showClassFeedback = true;
    },
    onClassFeedbackSaved: function onClassFeedbackSaved(payload) {
      var star = payload && payload.star;
      var openedId = payload && payload.openedId;
      var list = this.$refs.dataList;
      var rows = list && list.tableData;
      if (rows && rows.length) {
        for (var i = 0; i < rows.length; i++) {
          if (String(rows[i].id) === String(openedId)) {
            rows[i].classFeedbackStar = star;
            break;
          }
        }
        list.tableData = rows.slice();
      } else if (this.classFeedbackRow) {
        this.classFeedbackRow.classFeedbackStar = star;
      }
      this.showClassFeedback = false;
      this.classFeedbackRow = null;
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LessonFeedBackModal_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LessonFeedBackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LessonFeedBackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_SearchChangeTchModal_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_SearchChangeTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_SearchChangeTchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_modal_UserTempLessonModal_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_modal_UserTempLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__user_modal_UserTempLessonModal_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserTempLessonModal: __WEBPACK_IMPORTED_MODULE_13__user_modal_UserTempLessonModal_vue___default.a,
    LessonFeedBackModal: __WEBPACK_IMPORTED_MODULE_11__LessonFeedBackModal_vue___default.a,
    ChangeLessonModal: __WEBPACK_IMPORTED_MODULE_1__ChangeLessonModal_vue___default.a,
    ChangeClassTypeModal: __WEBPACK_IMPORTED_MODULE_2__ChangeClassTypeModal_vue___default.a,
    AddMonitorLessonRecordModal: __WEBPACK_IMPORTED_MODULE_3__modal_AddMonitorLessonRecordModal_vue___default.a,
    TchLessonLeaveModal: __WEBPACK_IMPORTED_MODULE_4__teacher_TchLessonLeaveModal_vue___default.a,
    LessonCancelModal: __WEBPACK_IMPORTED_MODULE_5__lesson_LessonCancelModal_vue___default.a,
    UserOneLeaveModal: __WEBPACK_IMPORTED_MODULE_6__UserOneLeaveModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_7__crm_UserInfoModal_vue___default.a,
    SearchChangeTchModal: __WEBPACK_IMPORTED_MODULE_12__modal_SearchChangeTchModal_vue___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_8__teacher_modal_TchInfoModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      editUser: false,
      uid: null,
      showTchInfoModal: false,
      unifiedHolidayModal: false,
      showSearchChangeTchModal: false,
      showUserTempLessonModal: false,
      changeTeacherOnly: false,
      optType: 0,
      tchId: null,
      userNickname: '',
      reload: 0,
      reloadWithPage: 0,
      param: {
        date: __WEBPACK_IMPORTED_MODULE_10__tools_date_dates_js___default.a.today(),
        studyAdviserId: '',
        keywords: '',
        totalCount: 0,
        isAudition: null,
        category: null,
        tchType: null,
        accent: null,
        sex: null,
        pageIndex: 1,
        pageSize: 20

      },
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        materialVersionId: '',
        isStudyAdviser: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnType: '',
        courseType: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        startCreateDate: '',
        endCreateDate: '',
        startCreateTime: '',
        endCreateTime: '',
        adviserId: '',
        adviserIds: [],
        operatorIds: [],
        regStartDate: '',
        regEndDate: '',
        regStartTime: '',
        regEndTime: '',
        creatorName: '',
        adminUserId: '',
        regType: '',
        tchChannel: '',
        tchStudyAdviserId: '',
        checkStatus: ''
      },
      holidayParam: {
        startTime: '',
        endTime: '',
        content: ''
      },
      tempLessonUser: {},
      holidayRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        content: [{ required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      tchStudyAdviserList: [],
      selectionOpenedIds: [],
      openedId: null,
      lsnType: null,
      openId: null,
      lessonOpened: {},
      classType: null,
      lessonTitle: null,
      lsnBeginTime: null,
      showChangeLessonModal: false,
      showChangeLClassTypeModal: false,
      showMonitorLessonRecordModal: false,
      showTchLessonLeaveModal: false,
      showLessonCancelModal: false,
      showLessonFeedBackModal: false,
      tchChannel: null,
      showUserOneLeaveModal: false,
      title: [{
        title: '课程ID',
        align: 'center',
        width: 80,
        key: 'id'
      }, {
        title: '课程内容',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          var lsnType = row.lsnType;
          var title = row.lessonTitle;
          var lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          var cType = typeEnum && typeEnum.text;
          if (cType) {
            cType = '课程类别：' + cType;
          } else {
            cType = '';
          }
          return h('div', { style: { 'font-size': '13px' } }, [h('p', { style: { color: '#2d8cf0' } }, title), h('p', '课程类型：' + (lsnTypeEnum && lsnTypeEnum.text)), h('p', cType)]);
        }
      }, {
        title: '课程等级',
        align: 'center',
        width: 120,
        key: 'levelTitle'
      }, {
        title: '开课日期',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var isHighlighted = params.row.firstLesson || false;

          var cellStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }, isHighlighted ? { backgroundColor: '#adf3c1' } : {});
          return h('div', { style: cellStyle }, $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '课程状态',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '当前老师',
        align: 'center',
        width: 200,
        render: function render(h, params) {
          var row = params.row;
          var isChange = '';
          if (row.isNewTch === 1) {
            isChange = '(替)';
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName);
            }
          });
        }
      }, {
        title: '是否代课',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var isNewTch = params.row.isNewTch;
          if (isNewTch > 0) {
            return h('div', '是');
          } else {
            return h('div', '否');
          }
        }
      }, {
        title: '学生ID、姓名',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '学导',
        align: 'center',
        width: 110,
        key: 'studyAdviserNickname'
      }, {
        title: '课程顾问',
        width: 110,
        key: 'adviserNickname'
      }, {
        title: '外管',
        align: 'center',
        width: 110,
        key: 'tchStudyName'
      }, {
        title: '外教是否确认',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var checkStatus = params.row.checkStatus;
          var statusEnum = $constant.getEnum($constant.checkStatus, checkStatus);
          var color = '#909399';
          if (checkStatus === 1) {
            color = 'green';
          } else if (checkStatus === 2) {
            color = 'red';
          }
          return h('span', {
            style: {
              color: color,
              'font-weight': '500 !important'
            }
          }, statusEnum && statusEnum.text);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.init();
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      self.tchStudyAdviserList = res.data;
    });
    this.initStartTime();
  },
  created: function created() {
    this.initStartTime();
  },
  methods: {
    initStartTime: function initStartTime() {
      var todayStart = this.$moment().startOf('day');
      var todayEnd = this.$moment().endOf('day');

      this.queryParam.startTimeDate = todayStart.toDate();
      this.queryParam.startTime = todayStart.format('X');

      this.queryParam.endTimeDate = todayEnd.toDate();
      this.queryParam.endTime = todayEnd.format('X');
    },
    init: function init() {
      var self = this;
      var query = self.$route.query;
      if (query) {
        if (query.regStartDate) {
          self.queryParam.regStartDate = parseInt(query.regStartTime) * 1000;
        }
        if (query.regEndDate) {
          self.queryParam.regEndDate = parseInt(query.regEndTime) * 1000;
        }
        if (query.startTimeDate) {
          self.queryParam.startTimeDate = parseInt(query.startTime) * 1000;
        }
        if (query.endTimeDate) {
          self.queryParam.endTimeDate = parseInt(query.endTime) * 1000;
        }
        if (query.startCreateDate) {
          self.queryParam.startCreateDate = parseInt(query.startCreateTime) * 1000;
        }
        if (query.endCreateDate) {
          self.queryParam.endCreateDate = parseInt(query.endCreateTime) * 1000;
        }
        if (query.tchId) {
          self.queryParam.tchId = parseInt(query.tchId);
        }
        if (query.tchName) {
          self.queryParam.tchName = query.tchName;
        }
        if (query.materialVersionId) {
          self.queryParam.materialVersionId = parseInt(query.materialVersionId);
        }
        if (query.isStudyAdviser) {
          self.queryParam.isStudyAdviser = query.isStudyAdviser;
        }
        if (query.uid) {
          self.queryParam.uid = parseInt(query.uid);
        }
        if (query.userMobile) {
          self.queryParam.userMobile = query.userMobile;
        }
        if (query.userNickname) {
          self.queryParam.userNickname = query.userNickname;
        }
        if (query.adviserNickname) {
          self.queryParam.adviserNickname = query.adviserNickname;
        }
        if (query.studyAdviserNickname) {
          self.queryParam.studyAdviserNickname = query.studyAdviserNickname;
        }
        if (query.tchCategory) {
          self.queryParam.tchCategory = parseInt(query.tchCategory);
        }
        if (query.lsnSelStatus) {
          self.queryParam.lsnSelStatus = parseInt(query.lsnSelStatus);
        }
        if (query.lsnType) {
          self.queryParam.lsnType = parseInt(query.lsnType);
        }
        if (query.courseType) {
          self.queryParam.courseType = parseInt(query.courseType);
        }
        if (query.adviserId) {
          self.queryParam.adviserId = parseInt(query.adviserId);
        }
        if (query.creatorName) {
          self.queryParam.creatorName = query.creatorName;
        }
        if (query.checkStatus) {
          self.queryParam.checkStatus = parseInt(query.checkStatus);
        }
      }
    },
    openTchInfoModal: function openTchInfoModal(val, classIn) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.selectionOpenedIds = [];
      this.reload = new Date().getTime();
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookLesson/opened/take-list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '当天订课信息.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
      this.UserOneLeaveModal = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonTempList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openNewLessonModal: function openNewLessonModal(k, v) {
      window.open('http://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startCreateTimeChange: function startCreateTimeChange(value) {
      this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endCreateTimeChange: function endCreateTimeChange(value) {
      this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startTimeRegChange: function startTimeRegChange(value) {
      this.queryParam.regStartTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeRegChange: function endTimeRegChange(value) {
      this.queryParam.regEndTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startTimeHolidayChange: function startTimeHolidayChange(value) {
      this.holidayParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeHolidayChange: function endTimeHolidayChange(value) {
      this.holidayParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onUserLeave: function onUserLeave(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 请假？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookUserLeaveTime/addByOpenedId', { openedId: id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('请假成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onTchLeave: function onTchLeave(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 请假？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookTchLeaveTime/addByOpenedId', { openedId: id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('请假成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onUserAbsent: function onUserAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/userAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onConfirmMakeUp: function onConfirmMakeUp(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 补课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/confirmMakeUp', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onTchAbsent: function onTchAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/tchAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onReloadClassIn: function onReloadClassIn(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/lesson/reloadClassIn', { openedId: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('生成成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    closeRecordScreen: function closeRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 0 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    openRecordScreen: function openRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 1 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    viewRecordScreen: function viewRecordScreen(row) {
      window.open(row.liveUrl);
    },
    lessonFeedBack: function lessonFeedBack(row) {
      this.openedId = row.id;
      this.uid = row.uid;
      this.tchId = row.tchId;
      this.userNickname = row.userNickname;
      this.showLessonFeedBackModal = true;
    },
    selectedChange: function selectedChange(selection) {
      this.selectionOpenedIds = selection;
    },
    batchCancelLesson: function batchCancelLesson() {
      if (this.selectionOpenedIds.length <= 0) {
        this.$Message.warning('请选择需要取消的课程！');
        return;
      }
      var self = this;
      var ids = [];
      var startedCount = 0;
      var now = Date.now();
      if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
        for (var i in this.selectionOpenedIds) {
          var dto = this.selectionOpenedIds[i];
          if (dto.lsnSelStatus === 2 || dto.lsnBeginTime * 1000 <= now) {
            startedCount++;
          } else {
            ids.push(dto.id);
          }
        }
      }
      if (startedCount > 0) {
        this.$Message.warning('课程已开始，不可取消');
      }
      if (ids.length <= 0) {
        return;
      }
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认取消已选课程？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookLesson/batchCancelLesson', {
            openedIds: ids.join(','),
            reason: '管理员取消'
          }).then(function (res) {
            self.search();
            self.$Message.success('操作成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    saveHoliday: function saveHoliday() {
      var self = this;
      var holidayValidate = 0;
      if (this.holidayParam.startTime && this.holidayParam.startTime !== '') {
        holidayValidate += 1;
      }
      if (this.holidayParam.endTime && this.holidayParam.endTime !== '') {
        holidayValidate += 1;
      }
      if (this.holidayParam.content && this.holidayParam.content !== '') {
        holidayValidate += 1;
      }
      if (holidayValidate !== 3) {
        return;
      }
      self.$http.post('/holiday/insert', this.holidayParam).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('新增成功!');
          self.unifiedHolidayModal = false;
          self.successCallback();
        } else {
          self.$Message.error('新增失败!');
        }
      }).catch(function (e) {});
    },
    cancelProxy: function cancelProxy(row) {
      var self = this;
      self.tempLessonUser = row;
      self.showSearchChangeTchModal = true;
      self.changeTeacherOnly = true;
      self.optType = 3;
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookTchFeedbackModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.value,
      isUpdate: false,
      loadingUpdate: false,
      feedbackTime: '',
      feedback: {},
      feedbackRule: {
        learnedComment: [{ type: 'string', required: true, message: '学习内容评价', trigger: 'blur' }],
        goodComment: [{ type: 'string', required: true, message: '表现好的评价', trigger: 'blur' }],
        betterComment: [{ type: 'string', required: true, message: '请填写可以改进的评价', trigger: 'blur' }]
      }
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/bookTchFeedback/queryByLsnOpenId', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          self.$emit('on-close');
          return;
        }
        self.visible = true;
        self.feedback = res.data;
        self.feedbackTime = res.data.gmtModified;
      });
    },
    update: function update() {
      var self = this;
      this.$refs.feedbakcForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.loadingUpdate = true;
        var params = self.feedback;
        params.lsnOpenId = self.openedId;
        self.$http.post('/bookTchFeedback/update', params).then(function (res) {
          self.loadingUpdate = false;
          if (res && res.data > 0) {
            self.$Message.success('保存成功!');
            self.visible = false;
          }
        }).catch(function (e) {
          self.loadingUpdate = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.feedback = {};
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.isUpdate = false;
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookTchScoreFeedbackModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      feedTime: '',
      visible: this.value,
      isUpdate: false,
      loadingUpdate: false,
      score: {},
      vocabularyTotal: '',
      listenTotal: '',
      total: '',
      assessmentLessonEvaluation: {
        General_Description: {},
        Learning_Content: {},
        Suggestion: {}
      },
      scroeLevel: '',
      scroePoints: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      scroeAlias: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'],
      scroeLevelList: ['Zero Level-Level 0', 'Basic-Level 1', 'Low Beginner-Level 2', 'Beginner-Level 3', 'Low Intermediate-Level 4', 'Intermediate-Level 5', 'Low advanced-Level 6', 'Advanced-Level 7'],
      feedback: {},
      feedbackRule: {
        learnedComment: [{ type: 'string', required: true, message: '学习内容评价', trigger: 'blur' }],
        goodComment: [{ type: 'string', required: true, message: '表现好的评价', trigger: 'blur' }],
        betterComment: [{ type: 'string', required: true, message: '请填写可以改进的评价', trigger: 'blur' }]
      }
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.assessmentLessonEvaluation = null;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          self.$emit('on-close');
          return;
        }
        self.feedback = res.data;
        self.score = JSON.parse(res.data.scoreComment);
        if (res.data.assessmentLessonEvaluation != null) {
          self.assessmentLessonEvaluation = JSON.parse(res.data.assessmentLessonEvaluation);
        }
        if (self.assessmentLessonEvaluation === null) {
          self.assessmentLessonEvaluation = {};
          self.assessmentLessonEvaluation.Learning_Content = {};
          self.assessmentLessonEvaluation.Suggestion = {};
          self.assessmentLessonEvaluation.General_Description = {};
          self.assessmentLessonEvaluation.General_Description.General_Description_1 = '';
          self.assessmentLessonEvaluation.General_Description.General_Description_2 = '';
          self.assessmentLessonEvaluation.General_Description.General_Description_3 = '';
          self.assessmentLessonEvaluation.General_Description.General_Description_4 = '';
          self.assessmentLessonEvaluation.Unit = '';
          self.assessmentLessonEvaluation.Learning_Content.Learning_Content_1 = '';
          self.assessmentLessonEvaluation.Learning_Content.Learning_Content_2 = '';
          self.assessmentLessonEvaluation.Learning_Content.Learning_Content_3 = '';
          self.assessmentLessonEvaluation.Learning_Content.Learning_Content_4 = '';
          self.assessmentLessonEvaluation.Learning_Content.Learning_Content_5 = '';
          self.assessmentLessonEvaluation.Suggestion.Suggestion_1 = '';
          self.assessmentLessonEvaluation.Suggestion.Suggestion_2 = '';
          self.assessmentLessonEvaluation.Suggestion.Suggestion_3 = '';
          self.assessmentLessonEvaluation.Suggestion.Suggestion_4 = '';
          self.assessmentLessonEvaluation.Suggestion.Suggestion_5 = '';
          self.assessmentLessonEvaluation.Suitable_level = '';
          self.assessmentLessonEvaluation.Ending_words = '';
        }
        self.feedTime = res.data.gmtModified;
        self.visible = true;
      });
    },
    update: function update() {
      var _this = this;

      var self = this;
      this.$refs.feedbakcForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.loadingUpdate = true;
        var params = self.feedback;
        params.lsnOpenId = self.openedId;
        params.scoreComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.score);
        params.assessmentLessonEvaluation = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.assessmentLessonEvaluation);
        self.$http.post('/bookTchFeedback/update', params).then(function (res) {
          self.loadingUpdate = false;
          if (res && res.data > 0) {
            self.$Message.success('保存成功!');
            self.visible = false;
          }
        }).catch(function (e) {
          self.loadingUpdate = false;
        });
      });
    },
    scoreCompute: function scoreCompute() {
      var score = this.score;
      this.vocabularyTotal = parseInt(score['0']) + parseInt(score[1]) + parseInt(score[2]) + parseInt(score[3]) + parseInt(score[4]);
      this.listenTotal = parseInt(score[5]) + parseInt(score[6]) + parseInt(score[7]) + parseInt(score[8]) + parseInt(score[9]);
      this.total = this.vocabularyTotal + this.listenTotal;
      this.scroeLevel = this.scroeLevelList[(this.total - 1) / 10 > 7 ? 7 : parseInt((this.total - 1) / 10)];
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.feedback = {};
        this.visible = val;
      }
    },
    score: function score(val) {
      this.scoreCompute();
    },
    visible: function visible(val) {
      this.isUpdate = false;
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookUserFeedbackModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    }
  },
  data: function data() {
    return {
      visible: this.value,
      feedback: {}
    };
  },

  methods: {
    cancel: function cancel() {
      var _this = this;

      var self = this;
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">取消</span>该差评?',
        width: 300,
        okText: '确认关闭',
        loading: true,
        onOk: function onOk() {
          _this.$http.post('/bookUserFeedback/canalComplaint', { lsnOpenId: self.openedId }).then(function (res) {
            if (res) {
              _this.$Message.success('更改成功');
              _this.$Modal.remove();
              self.value = false;
              _this.search();
            }
          });
        }
      });
    },
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/bookUserFeedback/queryByLsnOpenId', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          self.$emit('on-close');
          return;
        }
        self.visible = true;
        self.feedback = res.data;
        var complaintReason = res.data.complaintReason.split(',');
        var complaintReasonArr = [];
        complaintReason.forEach(function (element) {
          var reason = self.$constant.getEnum(self.$constant.complaintReason, parseInt(element));
          complaintReasonArr.push(reason && reason.text);
        });
        self.feedback.complaintReasonStr = complaintReasonArr.join('，');
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangeLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    classType: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      lessonParam: {
        classType: null
      },
      loadingChange: false
    };
  },

  methods: {
    change: function change() {
      var self = this;
      self.loadingChange = true;
      self.$refs.lessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingChange = false;
          return;
        }
        self.loadingChange = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.lessonParam.classType = this.classType;
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangeLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    lessonOpened: {
      type: Object,
      default: {
        levelTitle: '',
        lessonTitle: ''
      }
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      lessonParam: {
        levelId: null,
        lessonId: null,
        postpone: 1
      },
      isInit: true,
      loadingChange: false,
      lessonRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur' }]
      }
    };
  },

  methods: {
    changeLevel: function changeLevel(val) {
      if (!val) return;
      var self = this;
      self.lessonParam.lessonId = '';
      self.bookMaterialLessonsList = null;
      self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLessonsList = res.data;
        if (self.isInit) {
          var lessonId = self.lessonOpened.lessonId;
          self.lessonParam.lessonId = lessonId;
        }
        self.isInit = false;
      });
    },
    change: function change() {
      var self = this;
      self.loadingChange = true;
      self.$refs.lessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingChange = false;
          return;
        }
        var params = {};
        params.openedId = self.lessonOpened.id;
        params.lessonId = self.lessonParam.lessonId;
        params.postpone = self.lessonParam.postpone;
        self.$http.post('/bookLesson/changeLesson', params).then(function (res) {
          self.loadingChange = false;
          if (res) {
            self.$Message.success('调课件成功!');
            self.successCallback();
            self.visible = false;
            return;
          }
        });
      });
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        var levelId = self.lessonOpened.levelId;
        self.lessonParam.levelId = parseInt(levelId);
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=' + self.lessonOpened.lsnType).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
        var levelId = self.lessonOpened.levelId;
        self.lessonParam.levelId = parseInt(levelId);
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.isInit = true;
        this.lessonParam.postpone = 1;
        this.loadBookMaterialLevel();
      } else {
        this.bookMaterialLessonsList = null;
        this.bookMaterialLevelList = null;
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);




var RAW = {
  '上课准备与讲解': [['无备课痕迹', '课件不熟或选错进度', '讲解混乱', '大量中文', '环节严重缺失'], ['照读课件', '内容不熟悉', '中文偏多', '讲解粗浅'], ['内容一般', '目标笼统', '讲解平淡', '中文解释较多'], ['内容较熟练', '目标清晰', '环节较完整', '讲解较细致', '少量中文辅助'], ['备课充分', '目标清晰', '上课环节完整', '内容熟练', '课件操作无误', '讲解细致', '全英文授课']],
  '语言输入质量': [['严重口音', '语音含混难懂', '语法错误较多', '大量中文'], ['口音较重', '语速失控', '指令听不懂', '依赖中文解释'], ['稍有口音', '语速偏快', '指令偶需重复', '轻微用词不当'], ['发音基本标准', '偶有口音', '语速较适配', '指令清楚有示范'], ['语音标准流畅', '语速适配学生水平', '指令简短易懂', '善用 TPR 与动作', '示范准确', '全英文授课']],
  '互动与学生开口': [['教师单向灌输', '学生几乎不开口 占比＜20%', '不给表达机会'], ['学生开口少 占比 20–30%', '提问封闭', '频繁打断', '替学生说完'], ['学生开口一般 占比 30–40%', '以跟读和是非问答为主', '等待时间偏短', '缺少追问'], ['学生开口较多 占比 40–50%', '半开放式提问', '有追问', '等待时间基本足够'], ['学生开口充分 占比≥50%', '开放式提问', '追问扩展充分', '等待 3–5 秒', '不抢答不代答']],
  '纠错与反馈': [['完全没有纠音', '错误放任不管', '无正向激励', '无课后反馈'], ['基本没纠音', '纠错生硬', '学生退缩', '同类错误反复出现'], ['偶有纠音', '只纠明显错误', '直接给答案', '表扬笼统'], ['有纠音但不详细', '偶有遗漏', '示范+重复为主', '表扬偏泛'], ['纠音详细及时', '循循善诱', '引导自我修正', '给重试机会', '表扬具体', '课末明确下一步练习']],
  '课堂氛围与控时': [['冷漠不耐烦', '斥责学生', '严重拖堂或提前结束', '环节严重缺失'], ['氛围沉闷', '缺乏眼神交流', '控时前松后紧', '学生走神无干预'], ['态度友好但平淡', '控时偏差 3–5 分钟', '走神靠口头提醒'], ['亲和有能量', '氛围良好', '控时偏差≤2 分钟', '学生投入'], ['情绪饱满', '亲和耐心有感染力', '控时得当', '趣味引导拉回走神', '全程无斥责']],
  '出勤与设备形象': [['缺课或迟到＞5 分钟', '网络频繁卡顿掉线', '长时间关摄像头', '仪表不正'], ['迟到 3–5 分钟', '网络不畅影响教学', '摄像头多次关闭', '背景不整洁'], ['迟到 1–3 分钟', '网络偶有延迟', '短暂关摄像头', '仪表基本得体'], ['踩点到课未测设备', '网络良好', '偶有关摄像头', '仪表整洁'], ['提前 3–5 分钟到课', '网络流畅音视频清晰', '摄像头全程开启', '仪表整洁背景专业']]
};

function buildPool() {
  var pool = [];
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(RAW).forEach(function (dim) {
    RAW[dim].forEach(function (arr, si) {
      arr.forEach(function (text) {
        pool.push({
          dim: dim,
          star: si + 1,
          text: text,
          id: dim + '|' + (si + 1) + '|' + text
        });
      });
    });
  });
  return pool;
}

function shuffle(a) {
  for (var i = a.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a;
}

var POOL = buildPool();
var FACES = ['😞', '😕', '😐', '🙂', '🤩'];
var FACE_TXT = ['不合格', '待改进', '合格', '良好', '优秀'];
var GRADES = [{ min: 5, stars: 5, label: '★★★★★ 优秀', advice: '处置：优先排课 / 课时费上浮 / 示范课候选' }, { min: 4, stars: 4, label: '★★★★ 良好', advice: '处置：正常排课，正常激励' }, { min: 3, stars: 3, label: '★★★ 合格', advice: '处置：正常排课 + 指定 1 项改进点' }, { min: 2, stars: 2, label: '★★ 待改进', advice: '处置：1v1 反馈 + 指定改进点 + 30 天复查' }, { min: 1, stars: 1, label: '★ 不合格', advice: '处置：暂停排课 + PIP 改进计划（30 天，≥2 次复听）' }];
var RED_LIST = [{ code: 'R1', title: '态度粗鲁', desc: '冷漠敷衍、不耐烦、呵斥学生' }, { code: 'R2', title: '言辞不当', desc: '不当玩笑、不当用语、语气伤人' }, { code: 'R3', title: '羞辱学生', desc: '嘲讽、贬低、负面比较（如“你太笨了”）' }, { code: 'R4', title: '歧视言论', desc: '涉及国籍、种族、外貌、性别的歧视性言论' }, { code: 'R5', title: '敏感话题', desc: '涉及政治、宗教、色情、暴力的内容或引导讨论' }];
var RED_MAP = {
  R1: '态度粗鲁',
  R2: '言辞不当',
  R3: '羞辱学生',
  R4: '歧视言论',
  R5: '敏感话题'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    lessonOpenedId: { type: [String, Number], default: '' },
    embedded: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      openedId: '',
      loaded: false,
      canEdit: false,
      blockTip: '',
      raterName: '',
      star: 0,
      pickedIds: [],
      redCodes: [],
      note: '',
      recList: [],
      libOpen: false,
      libKw: '',
      saving: false,
      redList: RED_LIST
    };
  },

  computed: {
    face: function face() {
      if (!this.star) return '';
      return FACES[this.star - 1];
    },
    faceTxt: function faceTxt() {
      if (!this.star) return '';
      return FACE_TXT[this.star - 1];
    },
    rateStarText: function rateStarText() {
      if (!this.star) return '';
      return '★'.repeat(this.star) + '☆'.repeat(5 - this.star);
    },
    finalStar: function finalStar() {
      if (!this.star) return 0;
      if (this.redCodes.length) return 1;
      return this.star;
    },
    gradeItem: function gradeItem() {
      var s = this.finalStar;
      if (!s) return null;
      return GRADES.find(function (x) {
        return s >= x.min;
      }) || null;
    },
    scoreText: function scoreText() {
      if (!this.star) return '—';
      return this.finalStar.toFixed(2);
    },
    summaryStars: function summaryStars() {
      if (!this.star) return '☆☆☆☆☆';
      return '★'.repeat(this.finalStar) + '☆'.repeat(5 - this.finalStar);
    },
    gradeText: function gradeText() {
      if (!this.star) return '待评分';
      if (this.redCodes.length) return '★ 不合格（红线）';
      return this.gradeItem ? this.gradeItem.label : '';
    },
    adviceText: function adviceText() {
      if (!this.star) return '打星后自动计算';
      if (this.redCodes.length) return '';
      return this.gradeItem ? this.gradeItem.advice : '';
    },
    redNames: function redNames() {
      return this.redCodes.map(function (code) {
        return RED_MAP[code];
      }).filter(function (name) {
        return !!name;
      });
    },
    redWarn: function redWarn() {
      if (!this.redCodes.length) return '';
      return '红线已触发（' + this.redNames.join('、') + '）：本次直接判 1 星。';
    },
    starTotal: function starTotal() {
      var star = this.star;
      if (!star) return 0;
      return POOL.filter(function (o) {
        return o.star === star;
      }).length;
    },
    libBtnText: function libBtnText() {
      if (!this.star) return '该星级全部选项';
      return '该星级全部选项（' + this.star + '星 · ' + this.starTotal + '项）';
    },
    libKwTrim: function libKwTrim() {
      return (this.libKw || '').trim();
    },
    libSuffix: function libSuffix() {
      if (!this.libKwTrim) return '（该星级全部选项）';
      return '（已按「' + this.libKwTrim + '」过滤，共 ' + this.starTotal + ' 项）';
    },
    libList: function libList() {
      var star = this.star;
      if (!star) return [];
      var kw = this.libKwTrim;
      return POOL.filter(function (o) {
        return o.star === star && (!kw || o.text.indexOf(kw) !== -1 || o.dim.indexOf(kw) !== -1);
      });
    },
    pickedItems: function pickedItems() {
      var ids = this.pickedIds;
      return POOL.filter(function (o) {
        return ids.indexOf(o.id) !== -1;
      });
    },
    pickCountText: function pickCountText() {
      return '共 ' + this.pickedIds.length + ' 项（点击可移除）';
    },
    conflictText: function conflictText() {
      var ids = this.pickedIds;
      var dimStars = {};
      POOL.forEach(function (o) {
        if (ids.indexOf(o.id) === -1) return;
        if (!dimStars[o.dim]) dimStars[o.dim] = {};
        dimStars[o.dim][o.star] = true;
      });
      var bad = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dimStars).filter(function (dim) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dimStars[dim]).length > 1;
      });
      if (!bad.length) return '';
      return '注意：' + bad.join('、') + ' 同时选了不同档位的表现，请核对后再提交。';
    }
  },
  mounted: function mounted() {
    this.openedId = this.lessonOpenedId || this.$route.query && this.$route.query.openedId || '';
    this.load();
  },

  methods: {
    load: function load() {
      if (!this.openedId) return;
      var self = this;
      this.$http.get('/bookLesson/classFeedback/detail', { params: { openedId: this.openedId } }).then(function (res) {
        if (!res || res.status !== 'ok') return;
        var d = res.data || {};
        self.loaded = true;
        self.canEdit = !!d.canEdit;
        self.blockTip = d.blockTip || '';
        self.raterName = d.raterName || '';
        self.note = d.note || '';
        self.pickedIds = self.parsePicked(d.pickedIds);
        self.redCodes = self.parseReds(d.redCodes);
        var n = parseInt(d.star, 10);
        if (n >= 1 && n <= 5) {
          self.applyStar(n);
        }
      });
    },
    parsePicked: function parsePicked(raw) {
      if (!raw) return [];
      var arr = raw;
      if (typeof raw === 'string') {
        try {
          arr = JSON.parse(raw);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (id) {
        return typeof id === 'string' && id;
      });
    },
    parseReds: function parseReds(raw) {
      if (!raw) return [];
      return String(raw).split(',').map(function (s) {
        return s.trim();
      }).filter(function (code) {
        return !!RED_MAP[code];
      });
    },
    applyStar: function applyStar(n) {
      this.star = n;
      this.refresh();
    },
    setStar: function setStar(n) {
      if (!this.canEdit) return;
      this.applyStar(n);
    },
    refresh: function refresh() {
      if (!this.star) return;
      var star = this.star;
      var pool = POOL.filter(function (o) {
        return o.star === star;
      });
      var byDim = {};
      pool.forEach(function (o) {
        if (!byDim[o.dim]) {
          byDim[o.dim] = [];
        }
        byDim[o.dim].push(o);
      });
      var picks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(byDim).map(function (dim) {
        var list = byDim[dim];
        return list[Math.floor(Math.random() * list.length)];
      });
      var chosen = {};
      picks.forEach(function (o) {
        chosen[o.id] = true;
      });
      var rest = shuffle(pool.filter(function (o) {
        return !chosen[o.id];
      }));
      var extra = Math.floor(Math.random() * 3);
      this.recList = shuffle(picks.concat(rest.slice(0, extra)));
    },
    isPicked: function isPicked(id) {
      return this.pickedIds.indexOf(id) !== -1;
    },
    toggle: function toggle(id) {
      if (!this.canEdit) return;
      var i = this.pickedIds.indexOf(id);
      if (i >= 0) {
        this.pickedIds.splice(i, 1);
      } else {
        this.pickedIds.push(id);
      }
    },
    removePicked: function removePicked(id) {
      if (!this.canEdit) return;
      var i = this.pickedIds.indexOf(id);
      if (i >= 0) {
        this.pickedIds.splice(i, 1);
      }
    },
    toggleLib: function toggleLib() {
      this.libOpen = !this.libOpen;
    },
    isRed: function isRed(code) {
      return this.redCodes.indexOf(code) !== -1;
    },
    toggleRed: function toggleRed(code) {
      if (!this.canEdit) return;
      var i = this.redCodes.indexOf(code);
      if (i >= 0) {
        this.redCodes.splice(i, 1);
      } else {
        this.redCodes.push(code);
      }
    },
    save: function save() {
      if (!this.canEdit || this.saving) return;
      if (!(this.star >= 1 && this.star <= 5)) {
        this.$Message.warning('请先打星');
        return;
      }
      var self = this;
      this.saving = true;
      this.$http.post('/bookLesson/classFeedback/save', {
        openedId: this.openedId,
        star: this.star,
        redCodes: this.redCodes.join(','),
        pickedIds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pickedIds),
        note: this.note || ''
      }).then(function (res) {
        self.saving = false;
        if (res && res.status === 'ok') {
          if (self.embedded) {
            self.$emit('saved', { openedId: self.openedId, star: self.finalStar });
          } else {
            self.$router.push('/lesson/bookLessonOpenedList');
          }
        }
      }).catch(function () {
        self.saving = false;
      });
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClassMemberTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      dataList: [],
      column: [{
        title: '老师进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchStartTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.tchStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师最后出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchEndTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.tchEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生进教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdStartTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '学生出教室时间',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdEndTime === 0) {
            return h('span', '');
          }
          return h('span', $moment(params.row.sdEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '老师在教室时间(秒)',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          if (params.row.tchTime === 0) {
            return h('span', '');
          }
          return h('span', params.row.tchTime);
        }
      }, {
        title: '学生在教室时间(秒)',
        width: 121,
        align: 'center',
        render: function render(h, params) {
          if (params.row.sdTime === 0) {
            return h('span', '');
          }
          return h('span', params.row.sdTime);
        }
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/bookLesson/getClassMemberTime', { params: { lsnOpenId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          self.$emit('on-close');
          return;
        }
        self.dataList = [res.data];
        self.visible = true;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonCancelModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    lsnType: {
      type: Number
    },
    tchChannel: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      defaultPicList: [],
      visible: this.value,
      formData: {
        reason: '',
        attachment: '',
        makeUpTime: ''
      },
      loadingAdd: false,
      rule: {
        reason: [{ type: 'string', required: true, message: '请填写取消课程原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(fileList) {
      this.defaultPicList = fileList;
    },
    onTchLeave: function onTchLeave() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.formData.openedId = self.openedId;
        if (self.lsnType === 2 && self.tchChannel === 1) {
          self.formData.makeUpTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.formData.makeUpTime).format('YYYY-MM-DD HH:mm:ss');
        } else {
          self.formData.makeUpTime = '';
        }
        self.$http.post('/bookLesson/cancelLesson', self.formData).then(function (res) {
          self.loadingAdd = false;
          if (res) {
            self.$Message.success('课程取消成功!');
            self.visible = false;
            self.successCallback();
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.formData.reason = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonFeedBackModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    tchId: {
      type: Number
    },
    uid: {
      type: Number
    },
    userNickname: {
      type: String
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      defaultPicList: [],
      visible: this.value,
      formData: {
        reason: '',
        url: '',
        remark: ''
      },
      loadingAdd: false,
      rule: {
        reason: [{ type: 'string', required: true, message: '请填写投诉理由', trigger: 'blur' }]
      }
    };
  },

  methods: {
    feedBack: function feedBack() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.formData.openedId = self.openedId;
        self.formData.uid = self.uid;
        self.formData.tchId = self.tchId;
        self.formData.nickname = self.userNickname;
        self.formData.content = self.formData.reason;
        self.formData.reason = [];
        self.$http.post('/bookLesson/insertLessonFeedBack2', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          self.$Message.success('投诉成功!已通知外管处理中');
          self.visible = false;
          self.loadingAdd = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.formData.reason = '';
        this.formData.userNickname = '';
        this.formData.url = '';
        this.defaultPicList = [];
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LiveMonitorWindow__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LiveMonitorWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LiveMonitorWindow__);




var AUTO_PLAY_KEY = 'bops.liveMonitor.autoPlay';
var PLAY_LIMIT_KEY = 'bops.liveMonitor.playLimit';
var COLS_KEY = 'bops.liveMonitor.colsPerRow';
var WIN_W = 360;
var WIN_H = 280;
var MARGIN = 12;
var MAX_Z = 300;
var QUERY_LOOKBACK_SEC = 7200;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LiveMonitor',
  components: {
    LiveMonitorWindow: __WEBPACK_IMPORTED_MODULE_0__LiveMonitorWindow___default.a
  },
  data: function data() {
    return {
      selectedUids: [],
      selectedStudents: [],
      studentOptions: [],
      studentLoading: false,
      lsnType: null,
      tchKey: '',
      onlyMine: false,
      autoPlay: true,
      playLimit: 1,
      trialBeforeMin: 3,
      trialAfterMin: 1,
      regularBeforeMin: 1,
      regularAfterMin: 1,
      colsPerRow: 0,
      loading: false,
      allLessons: [],
      windows: [],
      topZ: MAX_Z,
      playSeq: 0,
      resizeTimer: null,
      canvasMinHeight: 400
    };
  },
  computed: {
    hiddenLessons: function hiddenLessons() {
      var shown = {};
      this.windows.forEach(function (win) {
        shown[win.id] = true;
      });
      return this.allLessons.filter(function (lesson) {
        return !shown[lesson.id];
      });
    },
    canFilterMine: function canFilterMine() {
      var rule = Number(this.$store.get('adminRule'));
      return rule === 1 || rule === 2;
    },
    playLimitMax: function playLimitMax() {
      var n = this.windows.length;
      if (n < 1) {
        return 9;
      }
      return Math.min(9, n);
    },
    effectivePlayLimit: function effectivePlayLimit() {
      var n = this.playLimit;
      if (!n || n < 1) {
        n = 1;
      }
      if (n > 9) {
        n = 9;
      }
      if (this.windows.length > 0 && n > this.windows.length) {
        n = this.windows.length;
      }
      return n;
    }
  },
  mounted: function mounted() {
    this.loadSettings();
    window.addEventListener('resize', this.onResize);
    var self = this;
    this.$nextTick(function () {
      self.disableSearchAutofill();
      self.loadWindowConfig();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
  },
  methods: {
    disableSearchAutofill: function disableSearchAutofill() {
      var nodes = [];
      var stu = this.$refs.stuSelect;
      if (stu && stu.$el) {
        nodes = nodes.concat(Array.prototype.slice.call(stu.$el.querySelectorAll('input')));
      }
      var tch = this.$refs.tchInput;
      if (tch && tch.$el) {
        nodes = nodes.concat(Array.prototype.slice.call(tch.$el.querySelectorAll('input')));
      }
      nodes.forEach(function (el, index) {
        el.setAttribute('autocomplete', 'off');
        el.setAttribute('autocorrect', 'off');
        el.setAttribute('autocapitalize', 'off');
        el.setAttribute('spellcheck', 'false');
        el.setAttribute('name', 'lm-search-' + index);
        el.setAttribute('readonly', 'readonly');
        el.addEventListener('focus', function () {
          el.removeAttribute('readonly');
        });
      });
    },
    loadSettings: function loadSettings() {
      var auto = localStorage.getItem(AUTO_PLAY_KEY);
      if (auto === '0' || auto === 'false') {
        this.autoPlay = false;
      } else {
        this.autoPlay = true;
      }
      var limit = parseInt(localStorage.getItem(PLAY_LIMIT_KEY), 10);
      if (isNaN(limit) || limit < 1) {
        this.playLimit = 1;
      } else if (limit > 9) {
        this.playLimit = 9;
      } else {
        this.playLimit = limit;
      }
      var cols = parseInt(localStorage.getItem(COLS_KEY), 10);
      if (isNaN(cols) || cols < 1) {
        this.colsPerRow = 0;
      } else if (cols > 6) {
        this.colsPerRow = 6;
      } else {
        this.colsPerRow = cols;
      }
    },
    persistAutoPlay: function persistAutoPlay() {
      localStorage.setItem(AUTO_PLAY_KEY, this.autoPlay ? '1' : '0');
    },
    persistPlayLimit: function persistPlayLimit() {
      localStorage.setItem(PLAY_LIMIT_KEY, String(this.playLimit));
    },
    persistCols: function persistCols() {
      localStorage.setItem(COLS_KEY, String(this.colsPerRow || 0));
    },
    contentRect: function contentRect() {
      var el = this.$refs.canvas;
      if (el && el.clientWidth > 80 && el.clientHeight > 80) {
        return {
          width: el.clientWidth,
          height: el.clientHeight
        };
      }
      return {
        width: Math.max(WIN_W, window.innerWidth - 282),
        height: Math.max(WIN_H, window.innerHeight - 220)
      };
    },
    calcGrid: function calcGrid(itemCount) {
      var area = this.contentRect();
      var cellW = WIN_W;
      var cellH = WIN_H;
      var cols = Math.max(1, Math.floor((area.width - MARGIN) / WIN_W));
      var fixed = parseInt(this.colsPerRow, 10);
      if (fixed >= 1 && fixed <= 6) {
        cols = fixed;
        cellW = Math.max(240, Math.floor((area.width - MARGIN) / cols));
        cellH = Math.round(cellW * WIN_H / WIN_W);
      }
      var n = itemCount != null ? itemCount : this.allLessons.length;
      if (n < 1) {
        n = 1;
      }
      var rows = Math.max(1, Math.ceil(n / cols));
      return {
        cols: cols,
        rows: rows,
        cellW: cellW,
        cellH: cellH,
        slotCount: n,
        originLeft: MARGIN,
        originTop: MARGIN
      };
    },
    syncCanvasHeight: function syncCanvasHeight(grid) {
      var rows = grid && grid.rows ? grid.rows : 1;
      var cellH = grid && grid.cellH ? grid.cellH : WIN_H;
      this.canvasMinHeight = rows * cellH + MARGIN * 2;
    },
    gridRect: function gridRect(index, grid) {
      if (!grid) {
        grid = this.calcGrid();
      }
      var cols = grid.cols || 1;
      var cellW = grid.cellW || WIN_W;
      var cellH = grid.cellH || WIN_H;
      return {
        left: grid.originLeft + index % cols * cellW,
        top: grid.originTop + Math.floor(index / cols) * cellH,
        width: cellW,
        height: cellH
      };
    },
    createWindow: function createWindow(lesson, rect) {
      this.topZ += 1;
      return {
        id: lesson.id,
        lesson: lesson,
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        playing: false,
        maximized: false,
        restoreRect: null,
        zIndex: this.topZ,
        playStamp: 0
      };
    },
    monitorMinutes: function monitorMinutes(value, fallback) {
      var n = parseInt(value, 10);
      if (isNaN(n) || n < 0) {
        return fallback;
      }
      return n;
    },
    applyWindowConfig: function applyWindowConfig(data) {
      if (!data) {
        return;
      }
      this.trialBeforeMin = this.monitorMinutes(data.trialBeforeMin, 3);
      this.trialAfterMin = this.monitorMinutes(data.trialAfterMin, 1);
      this.regularBeforeMin = this.monitorMinutes(data.regularBeforeMin, 1);
      this.regularAfterMin = this.monitorMinutes(data.regularAfterMin, 1);
    },
    loadWindowConfig: function loadWindowConfig() {
      var self = this;
      this.$http.get('/bookLesson/opened/monitorWindow').then(function (res) {
        self.applyWindowConfig(res.data);
        self.fetchLessons();
      }).catch(function () {
        self.fetchLessons();
      });
    },
    inMonitorWindow: function inMonitorWindow(lesson) {
      if (!lesson || !lesson.lsnBeginTime || !lesson.lsnEndTime) {
        return false;
      }
      var now = this.$moment().unix();
      var trial = Number(lesson.lsnType) === 1;
      var beforeMin = trial ? this.trialBeforeMin : this.regularBeforeMin;
      var afterMin = trial ? this.trialAfterMin : this.regularAfterMin;
      var before = beforeMin * 60;
      var after = afterMin * 60;
      return now >= lesson.lsnBeginTime - before && now <= lesson.lsnEndTime + after;
    },
    fetchLessons: function fetchLessons() {
      var self = this;
      var now = this.$moment();
      var params = {
        startTime: now.clone().subtract(QUERY_LOOKBACK_SEC, 'seconds').format('X'),
        endTime: now.clone().add(Math.max(this.trialBeforeMin, this.regularBeforeMin) * 60, 'seconds').format('X'),
        lsnSelStatusList: [1, 2, 3],
        pageIndex: 1,
        pageSize: 300
      };
      if (this.selectedUids && this.selectedUids.length) {
        params.uidList = this.selectedUids;
      }
      if (this.lsnType === 1 || this.lsnType === 2) {
        params.lsnType = this.lsnType;
      }
      var tchKey = this.tchKey ? String(this.tchKey).trim() : '';
      if (tchKey) {
        if (/^\d+$/.test(tchKey)) {
          params.tchId = parseInt(tchKey, 10);
        } else {
          params.tchName = tchKey;
        }
      }
      if (this.onlyMine && this.canFilterMine) {
        var myId = parseInt(this.$store.get('id'), 10);
        var rule = Number(this.$store.get('adminRule'));
        if (myId > 0 && rule === 1) {
          params.adviserId = myId;
        } else if (myId > 0 && rule === 2) {
          params.studyConsultantId = myId;
        }
      }
      this.loading = true;
      this.$http.post('/bookLesson/opened/list', params).then(function (res) {
        var list = [];
        if (res.data && res.data.data) {
          list = res.data.data;
        } else if (res.data && res.data.length) {
          list = res.data;
        }
        self.allLessons = (list || []).filter(function (item) {
          return self.inMonitorWindow(item);
        });
        self.rebuildWindows(true);
        self.loading = false;
      }).catch(function () {
        self.allLessons = [];
        self.windows = [];
        self.loading = false;
      });
    },
    rebuildWindows: function rebuildWindows(autoPlayNow) {
      var grid = this.calcGrid(this.allLessons.length);
      this.syncCanvasHeight(grid);
      var next = [];
      for (var i = 0; i < this.allLessons.length; i++) {
        next.push(this.createWindow(this.allLessons[i], this.gridRect(i, grid)));
      }
      this.windows = next;
      this.clampPlayLimit();
      if (autoPlayNow && this.autoPlay) {
        this.autoPlayWindows();
      }
    },
    applySlotCount: function applySlotCount() {
      if (!this.windows.length) {
        return;
      }
      var grid = this.calcGrid(this.windows.length);
      this.syncCanvasHeight(grid);
      var self = this;
      this.windows.forEach(function (win, index) {
        if (win.maximized) {
          return;
        }
        var rect = self.gridRect(index, grid);
        win.left = rect.left;
        win.top = rect.top;
        win.width = rect.width;
        win.height = rect.height;
      });
    },
    autoPlayWindows: function autoPlayWindows() {
      var limit = this.effectivePlayLimit;
      var started = 0;
      for (var i = 0; i < this.windows.length && started < limit; i++) {
        if (this.windows[i].lesson && this.windows[i].lesson.liveHls) {
          this.startPlay(this.windows[i]);
          started += 1;
        }
      }
    },
    playingCount: function playingCount() {
      var n = 0;
      this.windows.forEach(function (win) {
        if (win.playing) {
          n += 1;
        }
      });
      return n;
    },
    startPlay: function startPlay(win) {
      if (!win || !win.lesson || !win.lesson.liveHls) {
        return;
      }
      this.playSeq += 1;
      win.playing = true;
      win.playStamp = this.playSeq;
    },
    pauseOldest: function pauseOldest() {
      var oldest = null;
      this.windows.forEach(function (win) {
        if (!win.playing) {
          return;
        }
        if (!oldest || win.playStamp < oldest.playStamp) {
          oldest = win;
        }
      });
      if (oldest) {
        oldest.playing = false;
        oldest.playStamp = 0;
      }
    },
    enforcePlayLimit: function enforcePlayLimit() {
      while (this.playingCount() > this.effectivePlayLimit) {
        this.pauseOldest();
      }
    },
    clampPlayLimit: function clampPlayLimit() {
      this.enforcePlayLimit();
    },
    playWin: function playWin(win) {
      if (!win.lesson || !win.lesson.liveHls) {
        return;
      }
      if (win.playing) {
        return;
      }
      if (this.playingCount() >= this.effectivePlayLimit) {
        this.pauseOldest();
      }
      this.startPlay(win);
      this.focusWin(win);
    },
    pauseWin: function pauseWin(win) {
      win.playing = false;
      win.playStamp = 0;
    },
    focusWin: function focusWin(win) {
      this.topZ += 1;
      win.zIndex = this.topZ;
    },
    maximizeWin: function maximizeWin(win) {
      if (win.maximized) {
        return;
      }
      win.restoreRect = {
        left: win.left,
        top: win.top,
        width: win.width,
        height: win.height
      };
      var area = this.contentRect();
      win.left = 0;
      win.top = 0;
      win.width = Math.max(WIN_W, area.width);
      win.height = Math.max(WIN_H, area.height);
      win.maximized = true;
      this.focusWin(win);
    },
    restoreWin: function restoreWin(win) {
      if (!win.maximized) {
        return;
      }
      var rect = win.restoreRect;
      if (rect) {
        win.left = rect.left;
        win.top = rect.top;
        win.width = rect.width;
        win.height = rect.height;
      }
      win.maximized = false;
      win.restoreRect = null;
    },
    openExternal: function openExternal(win) {
      if (win.lesson && win.lesson.liveUrl) {
        window.open(win.lesson.liveUrl);
      }
    },
    resetLayout: function resetLayout() {
      var grid = this.calcGrid(this.windows.length);
      this.syncCanvasHeight(grid);
      var self = this;
      this.windows.forEach(function (win, index) {
        var rect = self.gridRect(index, grid);
        win.left = rect.left;
        win.top = rect.top;
        win.width = rect.width;
        win.height = rect.height;
        win.maximized = false;
        win.restoreRect = null;
      });
    },
    hiddenLabel: function hiddenLabel(lesson) {
      var name = lesson.userNickname || '学生';
      var uid = lesson.uid != null ? lesson.uid : '';
      var title = lesson.lessonTitle || '';
      return name + '(' + uid + ') ' + title;
    },
    onHiddenClick: function onHiddenClick(name) {
      var id = parseInt(name, 10);
      var lesson = null;
      this.hiddenLessons.forEach(function (item) {
        if (item.id === id) {
          lesson = item;
        }
      });
      if (lesson) {
        this.replaceWithLesson(lesson);
      }
    },
    replaceWithLesson: function replaceWithLesson(lesson) {
      if (!lesson) {
        return;
      }
      var grid = this.calcGrid(this.windows.length + 1);
      this.syncCanvasHeight(grid);
      if (this.hiddenLessons.length) {
        this.windows.push(this.createWindow(lesson, this.gridRect(this.windows.length, grid)));
        this.clampPlayLimit();
        return;
      }
      var idx = -1;
      for (var i = this.windows.length - 1; i >= 0; i--) {
        if (!this.windows[i].playing) {
          idx = i;
          break;
        }
      }
      if (idx < 0) {
        idx = this.windows.length - 1;
      }
      if (idx < 0) {
        this.windows.push(this.createWindow(lesson, this.gridRect(0, grid)));
        this.clampPlayLimit();
        return;
      }
      var old = this.windows[idx];
      var rect = {
        left: old.left,
        top: old.top,
        width: old.width,
        height: old.height
      };
      this.windows.splice(idx, 1, this.createWindow(lesson, rect));
      this.clampPlayLimit();
    },
    remoteStudent: function remoteStudent(query) {
      query = query === null || query === undefined ? '' : String(query).trim();
      if (!query) {
        this.studentOptions = this.selectedStudents.slice();
        return;
      }
      var self = this;
      this.studentLoading = true;
      this.$http.get('/user/listByCondition', { params: { infoKeyword: query } }).then(function (res) {
        var list = res.data || [];
        var merged = list.slice();
        self.selectedStudents.forEach(function (stu) {
          var exists = merged.some(function (item) {
            return item.id === stu.id;
          });
          if (!exists) {
            merged.unshift(stu);
          }
        });
        self.studentOptions = merged;
        self.studentLoading = false;
      }).catch(function () {
        self.studentLoading = false;
      });
    },
    onStudentChange: function onStudentChange(uids) {
      var ids = uids || [];
      this.selectedStudents = this.studentOptions.filter(function (item) {
        return ids.indexOf(item.id) >= 0;
      });
      this.fetchLessons();
    },
    onLsnTypeChange: function onLsnTypeChange() {
      this.fetchLessons();
    },
    onOnlyMineChange: function onOnlyMineChange() {
      this.fetchLessons();
    },
    onAutoPlayChange: function onAutoPlayChange(val) {
      this.autoPlay = val;
      this.persistAutoPlay();
    },
    onColsChange: function onColsChange() {
      this.persistCols();
      this.resetLayout();
    },
    onPlayLimitChange: function onPlayLimitChange(val) {
      var n = parseInt(val, 10);
      if (isNaN(n) || n < 1) {
        n = 1;
      }
      if (n > this.playLimitMax) {
        n = this.playLimitMax;
      }
      this.playLimit = n;
      this.persistPlayLimit();
      this.enforcePlayLimit();
    },
    onResize: function onResize() {
      var self = this;
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(function () {
        self.applySlotCount();
      }, 150);
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var HLS_CDN = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LiveMonitorWindow',
  props: {
    win: {
      type: Object,
      required: true
    }
  },
  computed: {
    winStyle: function winStyle() {
      return {
        left: this.win.left + 'px',
        top: this.win.top + 'px',
        width: this.win.width + 'px',
        height: this.win.height + 'px',
        zIndex: this.win.zIndex
      };
    },
    titleText: function titleText() {
      var lesson = this.win.lesson || {};
      var name = lesson.userNickname || '学生';
      var uid = lesson.uid != null ? lesson.uid : '';
      var time = this.formatTimeRange(lesson.lsnBeginTime, lesson.lsnEndTime);
      var tch = this.formatTchName(lesson);
      var title = lesson.lessonTitle || '';
      var adviser = lesson.studyAdviserNickname || '未分配';
      var sale = lesson.adviserNickname || '未分配';
      return name + '(' + uid + ')  ' + time + '  ' + tch + '  ' + title + '  班主任' + adviser + '  销售' + sale;
    },
    placeholderText: function placeholderText() {
      if (this.win.lesson && this.win.lesson.liveHls) {
        return '点击播放';
      }
      if (this.win.lesson && this.win.lesson.liveUrl) {
        return '无拉流';
      }
      return '未同步 / 未开播';
    },
    playerUrl: function playerUrl() {
      return this.win.lesson && this.win.lesson.liveHls ? this.win.lesson.liveHls : '';
    }
  },
  data: function data() {
    return {
      hls: null,
      tipVisible: false,
      tipStyle: {},
      tipTimer: null
    };
  },
  watch: {
    'win.playing': function winPlaying(val) {
      var self = this;
      this.$nextTick(function () {
        if (val) {
          self.attachPlayer();
        } else {
          self.detachPlayer();
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.win.playing) {
      this.$nextTick(this.attachPlayer);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.detachPlayer();
    this.clearTipTimer();
  },
  methods: {
    formatTimeRange: function formatTimeRange(begin, end) {
      var a = begin ? this.$moment.unix(begin).format('HH:mm') : '--:--';
      var b = end ? this.$moment.unix(end).format('HH:mm') : '--:--';
      return a + '-' + b;
    },
    formatTchName: function formatTchName(lesson) {
      if (!lesson) {
        return '';
      }
      if (lesson.tchName) {
        return lesson.tchName;
      }
      var first = lesson.tchFirstName || '';
      var last = lesson.tchLastName || '';
      return (first + ' ' + last).trim();
    },
    onFocus: function onFocus() {
      this.$emit('focus', this.win);
    },
    clearTipTimer: function clearTipTimer() {
      if (this.tipTimer) {
        clearTimeout(this.tipTimer);
        this.tipTimer = null;
      }
    },
    showTitleTip: function showTitleTip() {
      this.clearTipTimer();
      this.$emit('focus', this.win);
      var el = this.$el;
      if (!el) {
        return;
      }
      var title = el.querySelector('.lm-title');
      var rect = title ? title.getBoundingClientRect() : el.getBoundingClientRect();
      this.tipStyle = {
        left: rect.left + 'px',
        top: rect.bottom + 4 + 'px',
        maxWidth: Math.max(rect.width, 360) + 'px'
      };
      this.tipVisible = true;
    },
    hideTitleTip: function hideTitleTip() {
      var self = this;
      this.clearTipTimer();
      this.tipTimer = setTimeout(function () {
        self.tipVisible = false;
        self.tipTimer = null;
      }, 200);
    },
    onOpenExternal: function onOpenExternal() {
      if (this.win.lesson && this.win.lesson.liveUrl) {
        window.open(this.win.lesson.liveUrl);
        return;
      }
      this.$emit('open-external', this.win);
    },
    loadHlsScript: function loadHlsScript(cb) {
      if (window.Hls) {
        cb();
        return;
      }
      if (window.__lmHlsLoading) {
        window.__lmHlsLoading.push(cb);
        return;
      }
      window.__lmHlsLoading = [cb];
      var script = document.createElement('script');
      script.src = HLS_CDN;
      script.onload = function () {
        var list = window.__lmHlsLoading || [];
        window.__lmHlsLoading = null;
        for (var i = 0; i < list.length; i++) {
          list[i]();
        }
      };
      script.onerror = function () {
        window.__lmHlsLoading = null;
      };
      document.head.appendChild(script);
    },
    attachPlayer: function attachPlayer() {
      var video = this.$refs.player;
      if (!video) {
        return;
      }
      this.detachPlayer();
      if (!this.playerUrl) {
        return;
      }
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.playerUrl;
        video.play();
        return;
      }
      var self = this;
      this.loadHlsScript(function () {
        if (!window.Hls || !window.Hls.isSupported()) {
          return;
        }
        if (!self.win.playing || !self.$refs.player || !self.playerUrl) {
          return;
        }
        self.hls = new window.Hls();
        self.hls.loadSource(self.playerUrl);
        self.hls.attachMedia(self.$refs.player);
        self.hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
          if (self.$refs.player) {
            self.$refs.player.play();
          }
        });
      });
    },
    detachPlayer: function detachPlayer() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
      var video = this.$refs.player;
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    },
    onBodyClick: function onBodyClick() {
      if (!this.win.playing && this.win.lesson && this.win.lesson.liveHls) {
        this.$emit('play', this.win);
      }
    }
  }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RejectBalanceModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      fundParam: {
        reason: ''
      },
      loadingBalance: false,
      fundRule: {
        reason: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    balance: function balance() {
      var _this = this;

      this.loadingBalance = true;
      this.$refs.fundForm.validate(function (valid) {
        if (!valid) {
          _this.$Message.warning('信息输入错误!');
          _this.loadingBalance = false;
          return;
        }
        _this.loadingBalance = false;
        _this.visible = false;
        _this.$http.post('/bookLesson/balanceBookFail', { reason: _this.fundParam.reason, id: _this.openedId }).then(function (res) {
          if (res) {
            _this.successCallback();
            _this.$Message.success('处理成功!');
            _this.visible = false;
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_SearchChangeTchModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_SearchChangeTchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_SearchChangeTchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SearchChangeTchModal: __WEBPACK_IMPORTED_MODULE_0__modal_SearchChangeTchModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      cancelPermission: false,
      searchLoading: false,
      exportLoading: false,
      reloadWithPage: 0,
      reload: 0,
      rankScoreSeq: 0,
      tempLessonUser: {},
      changeTeacherOnly: false,
      optType: 3,
      showSearchChangeTchModal: false,
      queryParam: {
        courseType: '',
        oldTchId: '',
        oldTchName: '',
        newTchId: '',
        newTchName: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        startCreateDate: '',
        endCreateDate: '',
        startCreateTime: '',
        endCreateTime: '',
        adviserId: ''
      },
      title: [{
        title: '学生ID/姓名',
        fixed: 'left',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('br'), h('span', row.nickname)]);
        }
      }, {
        title: '代课类型',
        align: 'center',
        key: 'type'
      }, {
        title: '班主任',
        align: 'center',
        key: 'studyAdviserName'
      }, {
        title: '原老师ID/姓名',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.beforeTchId != null ? row.beforeTchId + ' ' : '') + (row.oldTchName || ''),
            score: row.monthRankScore
          });
        }
      }, {
        title: '新老师ID/姓名',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.afterTchId != null ? row.afterTchId + ' ' : '') + (row.newTchName || ''),
            score: row.monthRankScoreNew
          });
        }
      }, {
        title: '操作人',
        width: 100,
        align: 'center',
        key: 'creatorName'
      }, {
        title: '课程名称',
        width: 150,
        align: 'center',
        key: 'lessonTitle'
      }, {
        title: '课程类型',
        width: 100,
        align: 'center',
        key: 'lsnType'
      }, {
        title: '课程类别',
        align: 'center',
        width: 100,
        key: 'courseType'
      }, {
        title: '原上课时间',
        align: 'center',
        key: 'lsnBeginTime'
      }, {
        title: '新上课时间',
        align: 'center',
        key: 'lsnBeginTimeNew'
      }, {
        title: '原课程状态',
        width: 120,
        align: 'center',
        key: 'lsnSelStatus'
      }, {
        title: '新课程状态',
        width: 120,
        align: 'center',
        key: 'lsnSelStatusNew'
      }, {
        title: '替换时间',
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '操作',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          if (self.cancelPermission !== true) {
            return '';
          }
          var row = params.row;
          if (row.lsnSelStatusNew === '已选') {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.cancelProxy(row);
                }
              }
            }, '取消代课')]);
          } else {
            return h('div', [h('span', { style: { color: '#999', cursor: 'not-allowed' } }, '取消代课')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    this.$http.post('/common/getPermissionByUrl', { url: '/cancel-proxy' }).then(function (res) {
      if (res.data === true) {
        self.cancelPermission = true;
      }
    });
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = [];
      table.forEach(function (row) {
        if (row.beforeTchId != null) {
          ids.push(row.beforeTchId);
        }
        if (row.afterTchId != null) {
          ids.push(row.afterTchId);
        }
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'beforeTchId', 'monthRankScore', map);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'afterTchId', 'monthRankScoreNew', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    cancelProxy: function cancelProxy(row) {
      this.tempLessonUser = row.bookLessonInfo;
      this.showSearchChangeTchModal = true;
      this.changeTeacherOnly = true;
      this.optType = 3;
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/tchChange/list-export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '老师代课记录.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderCell__ = __webpack_require__(910);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { renderCell: __WEBPACK_IMPORTED_MODULE_1__renderCell__["a" /* default */] },
  name: 'TimetableCell',
  props: {
    row: {
      type: Object
    },
    column: {
      type: Object
    },
    activeId: {
      type: Number
    },
    types: {
      type: Array
    }
  },
  data: function data() {
    return {
      delay: 500
    };
  },

  computed: {
    bookTchOpenedTimeList: function bookTchOpenedTimeList() {
      var _this = this;

      if (!this.row || !this.row.bookTchOpenedTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('opened') === -1) {
        return [];
      }

      var bookTchOpenedTimeList = this.row.bookTchOpenedTimeDtoList.filter(function (item) {
        return (!item.endDate || item.endDate === 0) && item.startTime / 60 / 60 < _this.column.hour + 1 && item.endTime / 60 / 60 > _this.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      bookTchOpenedTimeList.forEach(function (item) {
        var startHour = Math.floor(item.startTime / 60 / 60);
        var startMinute = item.startTime / 60 % 60;

        if (startHour < _this.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startMinute / 5);
        }

        var duration = item.endTime - _this.column.hour * 60 * 60;
        if (duration >= 3600) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(duration / 60 / 5 - item.startIndex);
        }
      });

      return bookTchOpenedTimeList;
    },

    bookTchShortTermOpenedTimeList: function bookTchShortTermOpenedTimeList() {
      var _this2 = this;

      if (!this.row || !this.row.bookTchOpenedTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('shortTerm') === -1) {
        return [];
      }

      var list = this.row.bookTchOpenedTimeDtoList.filter(function (item) {
        if (!item.endDate || item.endDate <= 0) return false;

        var endDateMoment = _this2.$moment.unix(item.endDate);
        var rowDateMoment = _this2.$moment(_this2.row.dateStr, 'YYYY-MM-DD');
        if (rowDateMoment.isAfter(endDateMoment, 'day')) return false;

        return item.startTime / 60 / 60 < _this2.column.hour + 1 && item.endTime / 60 / 60 > _this2.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      list.forEach(function (item) {
        var startHour = Math.floor(item.startTime / 60 / 60);
        var startMinute = item.startTime / 60 % 60;

        if (startHour < _this2.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startMinute / 5);
        }

        var duration = item.endTime - _this2.column.hour * 60 * 60;
        if (duration >= 3600) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(duration / 60 / 5 - item.startIndex);
        }
      });

      return list;
    },

    tchScheduleBookLessonOpenedDtoList: function tchScheduleBookLessonOpenedDtoList() {
      var _this3 = this;

      if (!this.row || !this.row.tchScheduleBookLessonOpenedDtoList) {
        return [];
      }

      if (this.types.indexOf('schedule') === -1) {
        return [];
      }

      var tchScheduleBookLessonOpenedDtoList = this.row.tchScheduleBookLessonOpenedDtoList.filter(function (item) {
        var startHour = new Date(item.lsnBeginTime * 1000).getHours();
        var endHour = new Date(item.lsnEndTime * 1000).getHours();
        return startHour < _this3.column.hour + 1 && endHour >= _this3.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      tchScheduleBookLessonOpenedDtoList.forEach(function (item) {
        var startDate = new Date(item.lsnBeginTime * 1000);
        var startHour = startDate.getHours();
        if (startHour < _this3.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startDate.getMinutes() / 5);
        }

        var endDate = new Date(item.lsnEndTime * 1000);
        if (endDate.getHours() >= _this3.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex);
        }
      });

      return tchScheduleBookLessonOpenedDtoList;
    },

    bookTchRandomPartnerTimeDtoList: function bookTchRandomPartnerTimeDtoList() {
      var _this4 = this;

      if (!this.row || !this.row.bookTchRandomPartnerTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('partner') === -1) {
        return [];
      }

      var bookTchRandomPartnerTimeDtoList = this.row.bookTchRandomPartnerTimeDtoList.filter(function (item) {
        var startHour = new Date(item.lsnBeginTime * 1000).getHours();
        var endHour = new Date(item.lsnEndTime * 1000).getHours();
        return startHour < _this4.column.hour + 1 && endHour >= _this4.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      bookTchRandomPartnerTimeDtoList.forEach(function (item) {
        var startDate = new Date(item.lsnBeginTime * 1000);
        var startHour = startDate.getHours();
        if (startHour < _this4.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startDate.getMinutes() / 5);
        }

        var endDate = new Date(item.lsnEndTime * 1000);
        if (endDate.getHours() >= _this4.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex);
        }
      });

      return bookTchRandomPartnerTimeDtoList;
    },

    bookWorkLessonOpenedTimeDtoList: function bookWorkLessonOpenedTimeDtoList() {
      var _this5 = this;

      if (!this.row || !this.row.bookWorkLessonOpenedTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('book') === -1) {
        return [];
      }

      var bookWorkLessonOpenedTimeDtoList = this.row.bookWorkLessonOpenedTimeDtoList.filter(function (item) {
        var startHour = Math.floor(item.startTime / 60 / 60);
        var endHour = Math.floor(item.endTime / 60 / 60);
        return startHour < _this5.column.hour + 1 && endHour >= _this5.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      bookWorkLessonOpenedTimeDtoList.forEach(function (item) {
        var startHour = Math.floor(item.startTime / 60 / 60);
        var startMinute = Math.floor(item.startTime / 60 % 60);
        if (startHour < _this5.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startMinute / 5);
        }

        var endHour = Math.floor(item.endTime / 60 / 60);
        var endMinute = Math.floor(item.endTime / 60 % 60);
        if (endHour >= _this5.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endMinute / 5 - item.startIndex);
        }
      });

      return bookWorkLessonOpenedTimeDtoList;
    },

    tchScheduleBookLessonTestOpenedDtoList: function tchScheduleBookLessonTestOpenedDtoList() {
      var _this6 = this;

      if (!this.row || !this.row.tchScheduleBookLessonTestOpenedDtoList) {
        return [];
      }

      if (this.types.indexOf('test') === -1) {
        return [];
      }

      var tchScheduleBookLessonTestOpenedDtoList = this.row.tchScheduleBookLessonTestOpenedDtoList.filter(function (item) {
        var startHour = new Date(item.lsnBeginTime * 1000).getHours();
        var endHour = new Date(item.lsnEndTime * 1000).getHours();
        return startHour < _this6.column.hour + 1 && endHour >= _this6.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      tchScheduleBookLessonTestOpenedDtoList.forEach(function (item) {
        var startDate = new Date(item.lsnBeginTime * 1000);
        var startHour = startDate.getHours();
        if (startHour < _this6.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startDate.getMinutes() / 5);
        }

        var endDate = new Date(item.lsnEndTime * 1000);
        if (endDate.getHours() >= _this6.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex);
        }
      });

      return tchScheduleBookLessonTestOpenedDtoList;
    },

    bookTchRandomOpenedTimeDtoList: function bookTchRandomOpenedTimeDtoList() {
      var _this7 = this;

      if (!this.row || !this.row.bookTchRandomOpenedTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('free') === -1) {
        return [];
      }

      var bookTchRandomOpenedTimeDtoList = this.row.bookTchRandomOpenedTimeDtoList.filter(function (item) {
        var startHour = new Date(item.startTime * 1000).getHours();
        var endHour = new Date(item.endTime * 1000).getHours();
        return startHour < _this7.column.hour + 1 && endHour >= _this7.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      bookTchRandomOpenedTimeDtoList.forEach(function (item) {
        var startDate = new Date(item.startTime * 1000);
        var startHour = startDate.getHours();
        if (startHour < _this7.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startDate.getMinutes() / 5);
        }

        var endDate = new Date(item.endTime * 1000);
        if (endDate.getHours() >= _this7.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex);
        }
      });

      return bookTchRandomOpenedTimeDtoList;
    },

    bookTchLeaveTimeDtoList: function bookTchLeaveTimeDtoList() {
      var _this8 = this;

      if (!this.row || !this.row.bookTchLeaveTimeDtoList) {
        return [];
      }

      if (this.types.indexOf('leave') === -1) {
        return [];
      }

      var bookTchLeaveTimeDtoList = this.row.bookTchLeaveTimeDtoList.filter(function (item) {
        if (!item.endTime || item.endTime <= item.startTime) {
          return false;
        }

        var startHour = 23;
        var endHour = 0;
        if (new Date(_this8.row.dateStr).getDate() === new Date(item.startTime * 1000).getDate() && new Date(_this8.row.dateStr).getDate() === new Date(item.endTime * 1000 - 1).getDate()) {
          startHour = Math.min(Math.floor(new Date(item.startTime * 1000).getHours()), startHour);
          endHour = Math.max(Math.floor(new Date(item.endTime * 1000 - 1).getHours()), endHour);
        } else if (new Date(_this8.row.dateStr).getDate() === new Date(item.startTime * 1000).getDate() && new Date(_this8.row.dateStr).getDate() !== new Date(item.endTime * 1000 - 1).getDate()) {
          startHour = Math.min(Math.floor(new Date(item.startTime * 1000).getHours()), startHour);
          endHour = Math.max(23, endHour);
        } else if (new Date(_this8.row.dateStr).getDate() !== new Date(item.startTime * 1000).getDate() && new Date(_this8.row.dateStr).getDate() === new Date(item.endTime * 1000 - 1).getDate()) {
          startHour = Math.min(9, startHour);
          endHour = Math.max(Math.floor(new Date(item.endTime * 1000 - 1).getHours()), endHour);
        } else if (new Date(_this8.row.dateStr).getDate() !== new Date(item.startTime * 1000).getDate() && new Date(_this8.row.dateStr).getDate() !== new Date(item.endTime * 1000 - 1).getDate()) {
          startHour = Math.min(9, startHour);
          endHour = Math.max(23, endHour);
        }
        return startHour < _this8.column.hour + 1 && endHour >= _this8.column.hour;
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      });

      bookTchLeaveTimeDtoList.forEach(function (item) {
        var startDate = new Date(item.startTime * 1000).getDate() !== new Date(_this8.row.dateStr).getDate() ? new Date(_this8.row.dateStr) : new Date(item.startTime * 1000);
        var startHour = startDate.getHours();
        if (startHour < _this8.column.hour) {
          item.startIndex = 0;
        } else {
          item.startIndex = Math.floor(startDate.getMinutes() / 5);
        }

        var endDate = new Date(item.endTime * 1000 - 1).getDate() !== new Date(_this8.row.dateStr).getDate() ? new Date(_this8.row.dateStr + ' 23:00:00') : new Date(item.endTime * 1000 - 1);
        if (endDate.getHours() >= _this8.column.hour + 1) {
          item.colspan = 12 - item.startIndex;
        } else {
          item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex);
        }
      });

      return bookTchLeaveTimeDtoList;
    }
  },
  methods: {
    onMouseOver: function onMouseOver(row) {
      console.log(row.id);
      this.$emit('hover-active', row.id);
    },
    onMouseOut: function onMouseOut() {
      this.$emit('hover-active', -1);
    }
  },
  mounted: function mounted() {},

  watch: {}
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimetableHeader',
  props: {
    hour: {
      type: [Number, String]
    },
    columns: {
      type: Array
    }
  },
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {},
  watch: {}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimetableCell_vue__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimetableCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TimetableCell_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimetableRow',
  components: {
    TimetableCell: __WEBPACK_IMPORTED_MODULE_0__TimetableCell_vue___default.a
  },
  props: {
    columns: {
      type: Array
    },
    row: {
      type: Object
    },
    types: {
      type: Array
    }
  },
  data: function data() {
    return {
      activeId: -1
    };
  },

  computed: {},
  methods: {
    onActive: function onActive(id) {
      this.activeId = id;
    }
  },
  mounted: function mounted() {},

  watch: {}
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserOneLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openId: {
      type: Number,
      default: false
    },
    title: {
      type: String,
      default: false
    },
    beginTime: {
      type: Number,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loading: false,
      leaveParam: {
        openId: '',
        remark: '',
        title: '',
        beginTime: '',
        isSixHoursAgo: 0
      },
      leaveRule: {
        remark: [{ type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    add: function add() {
      var _this = this;

      var self = this;
      self.loading = true;
      self.$refs.leaveForm.validate(function (valid) {
        if (!valid) {
          self.loading = false;
          return;
        }
        _this.loading = true;
        self.$http.post('/bookUserLeaveTime/addByOpenedId', {
          openedId: self.leaveParam.openId,
          remark: self.leaveParam.remark,
          isSixHoursAgo: self.leaveParam.isSixHoursAgo
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.loading = false;
            self.$Message.success('请假成功!');
            self.visible = false;
            self.successCallback();
          } else {
            self.loading = false;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.leaveParam.remark = '';
        this.$emit('on-close', val);
      }
      this.$emit('input', val);
    },
    openId: function openId(val) {
      this.leaveParam.openId = val;
    },
    title: function title(val) {
      this.leaveParam.title = val;
    },
    beginTime: function beginTime(val) {
      var $moment = this.$moment;
      this.leaveParam.beginTime = $moment(val, 'X').format('YYYY-MM-DD HH:mm');
    }
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddLessonFeedbackModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    studentName: {
      type: String
    },
    teacherName: {
      type: String
    },
    lessonTime: {
      type: String
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      recordParam: {
        feedContent: ''
      },
      loadingAdd: false,
      recordRule: {
        feedContent: [{ type: 'string', required: true, message: '请填写上课反馈', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    add: function add() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.recordForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.recordParam.bookLessonOpenedId = self.openedId;
        self.$http.post('/stageReport/fm-message-book-lesson-add', self.recordParam).then(function (res) {
          self.loadingAdd = false;
          if (res) {
            self.$Message.success('添加成功!');
            self.visible = false;
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.recordParam.feedContent = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddMonitorLessonRecordModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      recordParam: {
        recordingContent: ''
      },
      loadingAdd: false,
      recordRule: {
        recordingContent: [{ type: 'string', required: true, message: '请填写监课情况', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    add: function add() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.recordForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.recordParam.opendId = self.openedId;
        self.$http.post('/monitorLessonRecord/add', self.recordParam).then(function (res) {
          self.loadingAdd = false;
          if (res) {
            self.$Message.success('添加成功!');
            self.visible = false;
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.recordParam.recordingContent = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonFeedbackDealModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    feedBackParamData: {
      type: Object,
      default: function _default() {
        return {
          uid: '',
          stdName: '',
          tchId: '',
          tchName: '',
          bizType: '',
          fromUser: '',
          createTime: '',
          feedContent: '',
          auditStatus: '',
          auditRemark: '',
          showTch: false,
          feedRemark: ''
        };
      }
    },
    timeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      showClassRequirementModal: false,
      classRequirementList: [],
      visible: this.value,
      auditParam: {
        id: '',
        auditStatus: '',
        auditRemark: '',
        showTch: false,
        feedContent: ''
      },
      loadingAdd: false,
      recordRule: {
        feedContent: [{ type: 'string', required: true, message: '请填写反馈内容', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }],
        auditRemark: [{ type: 'string', required: true, message: '请填写审批意见', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: '',
        day: ''
      },
      openedTimeList: [],
      timeRule1: {
        week: [{ type: 'integer', required: true, message: '请选择星期' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间' }],
        useDate: [{ type: 'integer', required: true, message: '请选择有效日期' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule1: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加时间');
            }
            callback(errors);
          }
        }]
      },
      timeRule2: {
        day: [{ type: 'integer', required: true, message: '请选择日期' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var day = self.timeParam.day;
            var startTime = self.timeParam.startTime;
            var errors = [];
            var nowTime = new Date().getTime() / 1000;
            if (day !== '' && startTime !== '' && nowTime >= day + startTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            var openedTimeList = self.openedTimeList;
            var endTime = self.timeParam.endTime;
            if (day === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            openedTimeList.forEach(function (element) {
              var tmpDay = element.day;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (day === tmpDay && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + element.dayStr + ' ' + element.startTimeStr + '-' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule2: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加时间');
            }
            callback(errors);
          }
        }]
      },
      classRequirementColumn: [{
        title: '上课要求',
        key: 'content'
      }, {
        title: '上课要求en',
        key: 'contentEn'
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    console.log(self.feedBackParamData);
    if (['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType)) {
      this.openedTimeList = JSON.parse(self.feedBackParamData.feedContent);
    } else {
      this.openedTimeList = [];
    }
  },

  methods: {
    showClassRequirement: function showClassRequirement() {
      var self = this;
      self.$http.get('/stageReport/user-require-list?uid=' + this.feedBackParamData.uid).then(function (res) {
        if (res && res.status === 'ok') {
          self.classRequirementList = res.data;
          self.showClassRequirementModal = true;
        }
      });
    },
    addOpenedTime1: function addOpenedTime1() {
      var week = this.timeParam.week;
      var startTime = this.timeParam.startTime;
      var endTime = this.timeParam.endTime;
      var useDate = this.timeParam.useDate;
      if (!week || startTime === '' || endTime === '' || useDate === '') {
        this.$Message.warning('请完善时间信息');
        return;
      }
      if (startTime >= endTime) {
        this.$Message.warning('开始时间应在结束时间之前');
        return;
      }

      var conflict = this.openedTimeList.some(function (element) {
        return week === element.week && (element.startTime < startTime && element.endTime > startTime || element.startTime < endTime && element.endTime > endTime || element.startTime >= startTime && element.endTime <= endTime);
      });
      if (conflict) {
        this.$Message.warning('添加的时间与已选时间冲突');
        return;
      }
      var openedTime = {};
      openedTime.week = week;
      openedTime.weekStr = this.$constant.weekZh[week];
      openedTime.startTime = startTime;
      openedTime.startTimeStr = this.timeParam.startTimeStr;
      openedTime.endTime = endTime;
      openedTime.endTimeStr = this.timeParam.endTimeStr;
      openedTime.useDate = useDate;
      openedTime.useDateStr = this.timeParam.useDateStr;
      this.openedTimeList.push(openedTime);
    },
    addOpenedTime2: function addOpenedTime2() {
      var day = this.timeParam.day;
      var startTime = this.timeParam.startTime;
      var endTime = this.timeParam.endTime;
      if (day === '' || startTime === '' || endTime === '') {
        this.$Message.warning('请完善时间信息');
        return;
      }
      if (startTime >= endTime) {
        this.$Message.warning('开始时间应在结束时间之前');
        return;
      }
      var nowTime = new Date().getTime() / 1000;
      if (nowTime >= day + startTime) {
        this.$Message.warning('开始时间应在当前时间之后');
        return;
      }

      var conflict = this.openedTimeList.some(function (element) {
        return day === element.day && (element.startTime < startTime && element.endTime > startTime || element.startTime < endTime && element.endTime > endTime || element.startTime >= startTime && element.endTime <= endTime);
      });
      if (conflict) {
        this.$Message.warning('添加的时间与已选时间冲突');
        return;
      }
      var openedTime = {};
      openedTime.day = day;
      openedTime.dayStr = this.timeParam.dayStr;
      openedTime.startTime = startTime;
      openedTime.startTimeStr = this.timeParam.startTimeStr;
      openedTime.endTime = endTime;
      openedTime.endTimeStr = this.timeParam.endTimeStr;
      this.openedTimeList.push(openedTime);
    },
    removeOpenedTime: function removeOpenedTime(index) {
      this.openedTimeList.splice(index, 1);
    },
    onChangeDate: function onChangeDate(val) {
      this.timeParam.dayStr = val;
      this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.useDateStr = val;
    },
    add: function add() {
      var self = this;
      if (['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType) && self.openedTimeList.length === 0) {
        self.$Message.warning('请添加时间');
        return;
      }
      self.loadingAdd = true;
      self.$refs.recordForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.auditParam.id = self.feedBackParamData.id;
        self.auditParam.auditStatus = self.feedBackParamData.auditStatus;
        self.auditParam.auditRemark = self.feedBackParamData.auditRemark;
        self.auditParam.showTch = self.feedBackParamData.showTch === 1 ? true : false;
        if (['加开固定时间', '加开临时时间'].includes(self.feedBackParamData.bizType)) {
          self.auditParam.feedContent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
        } else {
          self.auditParam.feedContent = self.feedBackParamData.feedContent;
        }
        self.$http.post('/stageReport/fm-message-audit', self.auditParam).then(function (res) {
          self.loadingAdd = false;
          if (res && res.status === 'ok') {
            self.successCallback();
            self.$Message.success('审批成功!');
            self.visible = false;
            self.openedTimeList = [];
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.auditParam.auditRemark = '';
      }
      this.$emit('input', val);
    },
    timeList: function timeList(val) {
      if (val) {
        this.openedTimeList = val;
      }
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MonitorLessonRecordListModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      recordList: [],
      recordColumn: [{
        title: '记录人',
        width: 121,
        key: 'adminNickname'
      }, {
        title: '记录时间',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var recordingTime = params.row.recordingTime;
          return h('span', $moment(recordingTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '记录内容',
        width: 230,
        key: 'recordingContent'
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/monitorLessonRecord/queryByOpenId', { params: { openId: self.openedId } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          return;
        }
        self.visible = true;
        self.recordList = res.data;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetPassWordModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    classinAccout: {
      type: String
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      formData: {
        classinAccout: '',
        password: ''
      },
      loadingAdd: false,
      recordRule: {
        password: [{ type: 'string', required: true, message: '密码不能为空', trigger: 'blur' }]
      }
    };
  },

  methods: {
    reset: function reset() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.recordForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        var params = self.formData;
        self.$http.post('/bookClassin/reSetPassword', { classinAccout: params.classinAccout, password: params.password }).then(function (res) {
          self.loadingAdd = false;
          if (res) {
            self.$Message.success('添加成功!');
            self.visible = false;
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.formData.password = '';
      }
      if (!val) {
        this.$emit('on-close', val);
      }
      this.$emit('input', val);
    },
    classinAccout: function classinAccout(val) {
      if (val) {
        this.formData.classinAccout = val;
      }
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchChangeTchModal',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal_vue___default.a },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    changeTeacherOnly: {
      type: Boolean
    },
    optType: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingConfirm: false,
      onlyChangeTeacher: false,
      loadingSearch: false,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tchName: '',
      title: '',
      tId: '',
      tempLessonParam: {
        levelId: null,
        uid: null,
        category: '',
        makeUp: '',
        tchId: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        postpone: 0,
        time: null,
        sex: null,
        channel: null,
        schoolId: 0,
        tchType: '',
        optType: 0
      },
      timeStr: '',
      tempLessonRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.tempLessonParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            var lsnBeginTime = self.getLsnBeginTime();
            var nowTime = new Date().getTime() / 1000;
            if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            callback();
          }
        }]
      },
      tchId: null,
      showTchInfoModal: false,
      ptype: ''
    };
  },

  methods: {
    tchAvatarSrc: function tchAvatarSrc(avatar) {
      return __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default.a.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
    },
    insertTempLesson: function insertTempLesson() {
      var self = this;
      self.loadingConfirm = true;
      self.$http.post('/bookLesson/opened/changeTch', {
        lsnBeginTime: self.getLsnBeginTime(),
        timeLength: self.tempLessonParam.timeLength,
        openedId: self.tempLessonParam.openedId,
        tchId: self.tempLessonParam.tchId,
        changeTeacherOnly: self.onlyChangeTeacher
      }).then(function (res) {
        self.loadingConfirm = false;
        if (res) {
          self.$Message.success('约课成功!');
          self.successCallback();
          self.visible = false;
        }
      });
    },
    searchTch: function searchTch() {
      var self = this;
      self.loadingSearch = true;
      self.tchList = [];
      var path = '/tch/time/queryFreeNotChineseTch?lsnBeginTime=' + self.getLsnBeginTime() + '&timeLength=' + self.tempLessonParam.timeLength + '&tempSchedule=1&uid=' + self.tempLessonParam.uid;
      path = path + '&tchType=' + self.tempLessonParam.tchType;
      if (self.ptype === '1') {
        path = path + '&isAudition=y';
      }
      if (self.tempLessonParam.canBound) {
        path = path + '&canBound=' + self.tempLessonParam.canBound;
      }
      if (self.tempLessonParam.category) {
        path = path + '&category=' + self.tempLessonParam.category;
      }
      if (self.tId) {
        path = path + '&tchId=' + self.tId;
      }
      if (self.tempLessonParam.accent) {
        path = path + '&accent=' + self.tempLessonParam.accent;
      }
      if (self.tempLessonParam.sex) {
        path = path + '&sex=' + self.tempLessonParam.sex;
      }
      if (self.tempLessonParam.channel) {
        path = path + '&channel=' + self.tempLessonParam.channel;
      }

      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data;
        }
        self.loadingSearch = false;
      });
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.tempLessonParam.lsnBeginDayTime) + parseInt(this.tempLessonParam.time);
    },
    clearTchList: function clearTchList() {
      this.tchList = [];
      this.tempLessonParam.tchId = '';
    },
    showTchMessage: function showTchMessage(id) {
      this.tchId = parseInt(id);
      this.showTchInfoModal = true;
    },
    updateTchInfoSuccess: function updateTchInfoSuccess() {
      this.showTchInfoModal = false;
    },
    onTchChange: function onTchChange(id, name) {
      this.tchName = name;
      if (id) {
        this.searchTch();
      }
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.tempLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
      this.clearTchList();
    },
    onChangeTime: function onChangeTime(val) {
      this.tempLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
      this.clearTchList();
    },
    cancelProxy: function cancelProxy() {
      var self = this;
      self.loadingConfirm = true;
      self.$http.post('/bookLesson/cancelProxy', { id: this.tempLessonParam.openedId }).then(function (res) {
        self.loadingConfirm = false;
        if (res.status === 'ok') {
          self.successCallback();
          self.visible = false;
        } else {
          self.$Message.error(res.msg);
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      var $moment = this.$moment;
      if (val === true) {
        this.tchList = [];
        this.loadingConfirm = false;
        this.loadingSearch = false;
        this.bookMaterialLevelList = null;
        this.bookMaterialLessonsList = null;
        this.tempLessonParam.uid = this.user.uid;
        this.tempLessonParam.nickname = this.user.userNickname;
        this.tempLessonParam.mobile = this.user.mobile;
        this.tempLessonParam.lsnBeginTimeDate = this.user.lsnBeginTime * 1000;
        this.tempLessonParam.lsnBeginDayTime = Math.floor(new Date(this.user.lsnBeginTime * 1000).setHours(0, 0, 0, 0) / 1000);
        this.tempLessonParam.timeLength = this.user.courseTime;
        this.tempLessonParam.timeStr = $moment(this.user.lsnBeginTime, 'X').format('HH:mm');
        this.tempLessonParam.time = parseInt(this.$dateUtil.getSecondByHm(this.tempLessonParam.timeStr));
        this.tempLessonParam.channel = this.user.tchChannel;
        this.tempLessonParam.openedId = this.user.id;
        this.tempLessonParam.tchType = '';
        this.tempLessonParam.optType = this.optType;
        this.onlyChangeTeacher = this.changeTeacherOnly;
        this.title = this.optType === 2 ? '更换老师/时间' : this.optType === 1 ? '老师代课' : '取消代课';
      } else {
        this.tId = '';
        this.tchName = '';
        this.tempLessonParam = {};
        this.clearTchList();
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_CreateActivityModal_vue__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_CreateActivityModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_CreateActivityModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        CreateActivityModal: __WEBPACK_IMPORTED_MODULE_0__modal_CreateActivityModal_vue___default.a
    },
    data: function data() {
        var _this = this;

        var $constant = this.$constant;
        return {
            selectDefaultImages: [],
            selectionUser: [],
            reload: 0,
            onLoading: false,
            searchLoading: false,
            loadingAddActivity: false,
            showAddActivityModal: false,
            showUpdateActivityModal: false,
            defaultTime: [],
            updateActivityParams: {
                id: 0,
                name: '',
                activityType: '',
                tag: '',
                startTimeStr: '',
                endTimeStr: '',
                status: '',
                description: '',
                createTime: '',
                updateTime: ''
            },
            queryParams: {
                name: '',
                activityType: '',
                status: ''
            },
            activityRules: {
                name: [{ type: 'string', required: true, message: '请输入活动名称', trigger: 'blur' }],
                activityType: [{ type: 'string', required: true, message: '请选择活动分类', trigger: 'blur' }],
                activityTime: [{ type: 'array', required: true, fields: {
                        0: { required: true, message: ' ', trigger: 'change' },
                        1: { required: true, message: ' ', trigger: 'change' }
                    } }],
                tag: [{ type: 'string', required: true, message: '请输入活动参数', trigger: 'blur' }],
                status: [{ type: 'integer', required: true, message: '请选择活动状态', trigger: 'blur' }]
            },
            tableColumns: [{
                type: 'selection',

                align: 'center'
            }, {
                title: '活动Id',

                align: 'center',
                key: 'id'
            }, {
                title: '活动名称',

                align: 'center',
                key: 'name'
            }, {
                title: '活动分类',

                align: 'center',
                key: 'activityType',
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', $constant.getEnum($constant.activityType, row.activityType).text);
                }
            }, {
                title: '活动标识',

                align: 'center',
                key: 'tag'
            }, {
                title: '活动时长',
                width: 250,
                align: 'center',
                key: 'receiverName',
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', [h('div', '开始时间：' + row.startTime), h('div', '结束时间：' + row.endTime)]);
                }
            }, {
                title: '状态',

                align: 'center',
                key: 'status',
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', row.status === 1 ? '启用' : '禁用');
                }
            }, {
                title: '活动描述',

                align: 'center',
                key: 'description'
            }, {
                title: '创建时间',

                align: 'center',
                key: 'createTime'
            }, {
                title: '操作',

                align: 'center',
                render: function render(h, params) {
                    var row = params.row;
                    return h('div', [h('a', { on: { click: function click() {
                                return _this.showUpdateActivity(row);
                            } } }, '编辑')]);
                }

            }]
        };
    },

    mounted: function mounted() {},
    created: function created() {},
    methods: {
        timeDateChange: function timeDateChange(value) {
            console.log('value', value);
            var self = this;
            self.createActivityForm.startTimeStr = value[0] + ' 00:00:00';
            self.createActivityForm.endTimeStr = value[1] + ' 23:59:59';
        },
        toShowAddActivityModal: function toShowAddActivityModal() {
            var self = this;
            self.showAddActivityModal = true;
        },
        showUpdateActivity: function showUpdateActivity(row) {
            var self = this;
            self.updateActivityParams.id = row.id;
            self.updateActivityParams.name = row.name;
            self.updateActivityParams.activityType = row.activityType;
            self.updateActivityParams.tag = row.tag;
            self.updateActivityParams.status = row.status == '1' ? 'yes' : 'no';
            self.updateActivityParams.description = row.description;
            self.updateActivityParams.createTime = row.createTime;
            self.updateActivityParams.updateTime = row.updateTime;
            self.updateActivityParams.startTimeStr = row.startTime;
            self.updateActivityParams.endTimeStr = row.endTime;
            self.defaultTime = [row.startTime, row.endTime];
            self.showUpdateActivityModal = true;
        },
        search: function search() {
            this.selectionUser = [];
            this.reload = new Date().getTime();
        },
        selectionChange: function selectionChange(selection) {
            this.selectionUser = selection;
        },
        updateActivity: function updateActivity() {
            var self = this;
            self.updateActivityParams.status = self.updateActivityParams.status == 'yes' ? 1 : 0;
            self.$refs.updateActivityForm.validate(function (valid) {
                if (!valid) {
                    self.$Message.warning('信息输入错误!');
                    self.loadingAddActivity = false;
                    return;
                }
                self.$http.post('/activity/update', self.updateActivityParams).then(function (res) {
                    if (res) {
                        self.$message.success('修改成功');
                        self.showUpdateActivityModal = false;
                        self.search();
                    }
                }).catch(function (err) {
                    console.log('err', err);
                    self.$message.error(err);
                });
            });
        },
        closeModal: function closeModal(val) {
            this.uid = null;
            this.editUser = false;
        }
    }

});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__ = __webpack_require__(127);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AiChannelIncludeList',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__["a" /* default */]],
  data: function data() {
    return {
      bizType: 'AI_CHANNEL_INCLUDE',
      pageTitle: 'AI渠道收录表',
      listUrl: '/marketAiChannelInclude/list',
      insertUrl: '/marketAiChannelInclude/insert',
      updateUrl: '/marketAiChannelInclude/update',
      deleteUrl: '/marketAiChannelInclude/delete'
    };
  },

  methods: {
    onChannelVisible: function onChannelVisible(visible) {
      if (!visible) {
        this.onChannelModalClose();
      }
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__ = __webpack_require__(127);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticlePublishList',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__["a" /* default */]],
  data: function data() {
    return {
      bizType: 'ARTICLE_PUBLISH',
      pageTitle: '文章发布表',
      listUrl: '/marketArticlePublish/list',
      insertUrl: '/marketArticlePublish/insert',
      updateUrl: '/marketArticlePublish/update',
      deleteUrl: '/marketArticlePublish/delete'
    };
  },

  methods: {
    onChannelVisible: function onChannelVisible(visible) {
      if (!visible) {
        this.onChannelModalClose();
      }
    }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      exportLoading: false,
      startDate: '',
      endDate: '',
      dateRange: [],
      dimension: 'category',
      marketCategoryKey: '',
      searchSeq: 0,
      list: [],
      totalAssignCount: 0,
      totalDealCount: 0,
      totalDealRate: null,
      totalCurrentDealCount: 0,
      totalCurrentDealRate: null,
      tableHeight: null,
      channelColumns: [{
        title: '渠道名称',
        key: 'channelName',
        sortable: true,
        sortMethod: this.sortText
      }, {
        title: '渠道分类',
        key: 'channelType',
        sortable: true,
        sortMethod: this.sortText
      }, {
        title: '分配数量',
        key: 'assignCount',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          var count = params.row.assignCount == null ? 0 : params.row.assignCount;
          var href = _this.$router.resolve({
            path: '/crm/DistributionList',
            query: _this.assignQuery(params.row)
          }).href;
          return h('a', {
            attrs: { href: href },
            style: { color: '#2d8cf0' },
            on: {
              click: function click(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                  return;
                }
                e.preventDefault();
                _this.$router.push({
                  path: '/crm/DistributionList',
                  query: _this.assignQuery(params.row)
                });
              }
            }
          }, String(count));
        }
      }, {
        title: '累计成交数量',
        key: 'dealCount',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          var count = params.row.dealCount == null ? 0 : params.row.dealCount;
          var href = _this.$router.resolve({
            path: '/order/performanceDetail',
            query: _this.dealQuery(params.row)
          }).href;
          return h('a', {
            attrs: { href: href },
            style: { color: '#2d8cf0' },
            on: {
              click: function click(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                  return;
                }
                e.preventDefault();
                _this.$router.push({
                  path: '/order/performanceDetail',
                  query: _this.dealQuery(params.row)
                });
              }
            }
          }, String(count));
        }
      }, {
        title: '累计成交率',
        key: 'dealRate',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          return h('span', _this.formatRate(params.row.dealRate));
        }
      }, {
        title: '当前成交数量',
        key: 'currentDealCount',
        sortable: true,
        sortMethod: this.sortNumber
      }, {
        title: '当前成交率',
        key: 'currentDealRate',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          return h('span', _this.formatRate(params.row.currentDealRate));
        }
      }],
      categoryColumns: [{
        title: '市场分类',
        key: 'marketCategory',
        sortable: true,
        sortMethod: this.sortText,
        render: function render(h, params) {
          var text = params.row.marketCategory;
          var href = _this.$router.resolve({
            path: '/market/ChannelDealRate',
            query: _this.categoryQuery(params.row)
          }).href;
          return h('a', {
            attrs: { href: href },
            style: { color: '#2d8cf0' },
            on: {
              click: function click(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                  return;
                }
                e.preventDefault();
                _this.enterCategory(params.row.marketCategoryKey);
              }
            }
          }, text == null ? '' : String(text));
        }
      }, {
        title: '分配数量',
        key: 'assignCount',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          var count = params.row.assignCount == null ? 0 : params.row.assignCount;
          return h('span', String(count));
        }
      }, {
        title: '累计成交数量',
        key: 'dealCount',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          var count = params.row.dealCount == null ? 0 : params.row.dealCount;
          return h('span', String(count));
        }
      }, {
        title: '累计成交率',
        key: 'dealRate',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          return h('span', _this.formatRate(params.row.dealRate));
        }
      }, {
        title: '当前成交数量',
        key: 'currentDealCount',
        sortable: true,
        sortMethod: this.sortNumber
      }, {
        title: '当前成交率',
        key: 'currentDealRate',
        sortable: true,
        sortMethod: this.sortNumber,
        render: function render(h, params) {
          return h('span', _this.formatRate(params.row.currentDealRate));
        }
      }]
    };
  },

  computed: {
    columns: function columns() {
      if (this.dimension === 'category') {
        return this.categoryColumns;
      }
      return this.channelColumns;
    }
  },
  created: function created() {
    var query = this.$route.query;
    if (query.marketCategory) {
      this.dimension = 'channel';
      this.marketCategoryKey = query.marketCategory;
    }
    if (query.startDate && query.endDate) {
      this.setRange(query.startDate, query.endDate);
      this.search();
    } else if (query.weekStart) {
      var start = this.$moment(query.weekStart, 'YYYY-MM-DD').startOf('isoWeek');
      this.setRange(start.format('YYYY-MM-DD'), start.clone().add(6, 'days').format('YYYY-MM-DD'));
      this.search();
    } else {
      this.goThisWeek();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.onResize = function () {
      _this2.updateTableHeight();
    };
    window.addEventListener('resize', this.onResize);
    this.updateTableHeight();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    list: function list() {
      this.updateTableHeight();
    },
    dimension: function dimension() {
      this.updateTableHeight();
    }
  },
  methods: {
    updateTableHeight: function updateTableHeight() {
      var _this3 = this;

      this.$nextTick(function () {
        var table = _this3.$refs.dealTable;
        if (!table || !table.$el) {
          return;
        }
        var el = table.$el;
        var main = document.querySelector('.layout-content-main');
        var mainBottom = main ? main.getBoundingClientRect().bottom : window.innerHeight;
        var visibleBottom = Math.min(mainBottom, window.innerHeight);
        var available = Math.floor(visibleBottom - el.getBoundingClientRect().top - 64);
        var header = el.querySelector('.ivu-table-header');
        var rows = el.querySelectorAll('.ivu-table-tbody tr');
        var content = header ? header.offsetHeight : 40;
        for (var i = 0; i < rows.length; i++) {
          content += rows[i].offsetHeight || 48;
        }
        if (!rows.length) {
          content += 48;
        }
        var next = content > available && available > 80 ? available : null;
        if (next !== _this3.tableHeight) {
          _this3.tableHeight = next;
        }
      });
    },
    setRange: function setRange(start, end) {
      this.startDate = start;
      this.endDate = end;
      this.dateRange = [start, end];
    },
    onRangeChange: function onRangeChange(value) {
      if (!value || !value[0] || !value[1]) {
        this.dateRange = [this.startDate, this.endDate];
        return;
      }
      this.setRange(value[0], value[1]);
    },
    goThisWeek: function goThisWeek() {
      var start = this.$moment().startOf('isoWeek');
      this.setRange(start.format('YYYY-MM-DD'), start.clone().add(6, 'days').format('YYYY-MM-DD'));
      this.search();
    },
    channelIdOf: function channelIdOf(row) {
      if (row.channelId == null || row.channelId === '') {
        return 0;
      }
      return row.channelId;
    },
    withMarketCategory: function withMarketCategory(query) {
      if (this.marketCategoryKey) {
        query.marketCategory = this.marketCategoryKey;
      }
      return query;
    },
    categoryQuery: function categoryQuery(row) {
      var query = {};
      if (this.startDate && this.endDate) {
        query.startDate = this.startDate;
        query.endDate = this.endDate;
      }
      if (row.marketCategoryKey) {
        query.marketCategory = row.marketCategoryKey;
      }
      return query;
    },
    enterCategory: function enterCategory(key) {
      if (!key) {
        return;
      }
      this.dimension = 'channel';
      this.marketCategoryKey = key;
      this.list = [];
      this.syncLevelQuery();
      this.search();
    },
    backToCategory: function backToCategory() {
      this.dimension = 'category';
      this.marketCategoryKey = '';
      this.list = [];
      this.syncLevelQuery();
      this.search();
    },
    syncLevelQuery: function syncLevelQuery() {
      var query = {};
      if (this.startDate && this.endDate) {
        query.startDate = this.startDate;
        query.endDate = this.endDate;
      }
      if (this.dimension !== 'category' && this.marketCategoryKey) {
        query.marketCategory = this.marketCategoryKey;
      }
      this.$router.replace({
        path: '/market/ChannelDealRate',
        query: query
      });
    },
    assignQuery: function assignQuery(row) {
      return this.withMarketCategory({
        channelDealRate: 1,
        channelId: this.channelIdOf(row),
        weekStart: this.startDate,
        linkStartTimeDate: this.startDate,
        linkEndTimeDate: this.endDate,
        startDate: this.startDate,
        endDate: this.endDate
      });
    },
    dealQuery: function dealQuery(row) {
      return this.withMarketCategory({
        channelDealRate: 1,
        channelId: this.channelIdOf(row),
        startDate: this.startDate,
        endDate: this.endDate,
        weekStart: this.startDate
      });
    },
    sortText: function sortText(a, b, type) {
      var left = a === null || a === undefined ? '' : String(a);
      var right = b === null || b === undefined ? '' : String(b);
      var result = left.localeCompare(right, 'zh');
      return type === 'desc' ? -result : result;
    },
    sortNumberValue: function sortNumberValue(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var number = Number(value);
      if (isNaN(number)) {
        return null;
      }
      return number;
    },
    sortNumber: function sortNumber(a, b, type) {
      var left = this.sortNumberValue(a);
      var right = this.sortNumberValue(b);
      if (left === null && right === null) {
        return 0;
      }
      if (left === null) {
        return type === 'desc' ? 1 : -1;
      }
      if (right === null) {
        return type === 'desc' ? -1 : 1;
      }
      var result = left - right;
      return type === 'desc' ? -result : result;
    },
    formatRate: function formatRate(rate) {
      if (rate === null || rate === undefined || rate === '') {
        return '-';
      }
      return this.$numeral(Number(rate) * 100).format('0.00') + '%';
    },
    rowClassName: function rowClassName(row) {
      if (row.dealRate === null || row.dealRate === undefined || row.dealRate === '') {
        return '';
      }
      return Number(row.dealRate) < 0.07 ? 'low-deal-rate' : '';
    },
    exportData: function exportData() {
      var _this4 = this;

      this.exportLoading = true;
      var params = {
        startDate: this.startDate,
        endDate: this.endDate
      };
      if (this.dimension === 'category') {
        params.dimension = 'category';
      } else if (this.marketCategoryKey) {
        params.marketCategory = this.marketCategoryKey;
      }
      this.$http.get('/userinfo/channelDealRate/export', {
        params: params,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '渠道成交率-' + _this4.startDate + '_' + _this4.endDate + '.xlsx';
          link.click();
          _this4.exportLoading = false;
        } else {
          _this4.$Message.error(response.msg || '导出失败');
          _this4.exportLoading = false;
        }
      }).catch(function () {
        _this4.$Message.error('导出失败');
        _this4.exportLoading = false;
      });
    },
    search: function search() {
      var _this5 = this;

      this.searchLoading = true;
      var seq = (this.searchSeq || 0) + 1;
      this.searchSeq = seq;
      var params = {
        startDate: this.startDate,
        endDate: this.endDate
      };
      if (this.dimension === 'category') {
        params.dimension = 'category';
      } else if (this.marketCategoryKey) {
        params.marketCategory = this.marketCategoryKey;
      }
      this.$http.get('/userinfo/channelDealRate', {
        params: params
      }).then(function (res) {
        if (seq !== _this5.searchSeq) {
          return;
        }
        var data = res.data || {};
        _this5.list = data.list || [];
        _this5.totalAssignCount = data.totalAssignCount || 0;
        _this5.totalDealCount = data.totalDealCount || 0;
        _this5.totalDealRate = data.totalDealRate;
        _this5.totalCurrentDealCount = data.totalCurrentDealCount || 0;
        _this5.totalCurrentDealRate = data.totalCurrentDealRate;
        if (data.weekStart && data.weekEnd) {
          _this5.setRange(data.weekStart, data.weekEnd);
        }
        if (_this5.dimension !== 'category') {
          _this5.syncLevelQuery();
        }
        _this5.searchLoading = false;
      }).catch(function () {
        if (seq !== _this5.searchSeq) {
          return;
        }
        _this5.searchLoading = false;
      });
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__ = __webpack_require__(127);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelIncludeList',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__marketChannelDynamicMixin__["a" /* default */]],
  data: function data() {
    return {
      bizType: 'CHANNEL_INCLUDE',
      pageTitle: '发布渠道收录表',
      listUrl: '/marketChannelInclude/list',
      insertUrl: '/marketChannelInclude/insert',
      updateUrl: '/marketChannelInclude/update',
      deleteUrl: '/marketChannelInclude/delete'
    };
  },

  methods: {
    onChannelVisible: function onChannelVisible(visible) {
      if (!visible) {
        this.onChannelModalClose();
      }
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateChannelModal__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateChannelModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateChannelModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdminUserMultSelect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_AdminUserMultSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_AdminUserMultSelect__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_2__common_AdminUserMultSelect___default.a,
    CreateChannelModal: __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateChannelModal___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      selectDefaultImages: [],
      selectionUser: [],
      reload: 0,
      searchLoading: false,
      onLoading: false,
      loadingAddActivity: false,
      showAddChannelModal: false,
      showUpdateChannelModal: false,
      createChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        status: '',
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: []
      },
      updateChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        status: '',
        tchChannel: '',
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: []
      },
      marketCategoryNames: [],
      queryParams: {
        channelName: '',
        channelType: '',
        status: '',
        tchChannel: '',
        marketCategory: ''
      },
      channelRules: {
        channelName: [{ type: 'string', required: true, message: '请输入渠道名称', trigger: 'blur' }],
        channelType: [{ type: 'string', required: true, message: '请输入渠道分类', trigger: 'blur' }],
        channelParam: [{ type: 'string', required: true, message: '请输入渠道参数', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择渠道状态', trigger: 'blur' }]
      },
      tableColumns: [{
        title: '渠道ID',

        align: 'center',
        key: 'id'
      }, {
        title: '渠道名称',

        align: 'center',
        key: 'channelName'
      }, {
        title: '渠道分类',
        align: 'center',
        key: 'type',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('Select', {
            props: {
              value: row.type,
              transfer: true,
              placement: 'top'
            },
            on: {
              'on-change': function onChange(value) {
                _this.updateChannelType(row.id, value);
              }
            }
          }, [h('Option', { props: { value: '' } }, '请选择')].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.$constant.channelTypeEnum.map(function (item) {
            return h('Option', { props: { value: item.id } }, item.text);
          }))))]);
        }
      }, {
        title: '市场分类',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.marketCategory || '',
              size: 'small',
              placeholder: '未分类'
            },
            on: {
              'on-blur': function onBlur(event) {
                _this.saveMarketCategory(row, event);
              }
            }
          });
        }
      }, {
        title: '获客终端',

        align: 'center',
        key: 'channelType',
        render: function render(h, params) {
          var row = params.row;
          var text = row.channelType === 'MOBILE' ? '手机端' : 'PC端';
          return h('span', text);
        }
      }, {
        title: '渠道参数',

        align: 'center',
        key: 'channelParam'
      }, {
        title: '状态',

        align: 'center',
        key: 'status',
        render: function render(h, params) {
          var row = params.row;
          var text = row.status === 1 ? '启用' : '禁用';
          return h('span', text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.tchChannel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '渠道描述',

        align: 'center',
        key: 'description'
      }, {
        title: '创建时间',

        align: 'center',
        key: 'createTime'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.showUpdate(row);
              } } }, '编辑')]);
        }

      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.loadMarketCategories();
  },
  methods: {
    loadMarketCategories: function loadMarketCategories() {
      var self = this;
      self.$http.get('/channel/marketCategories').then(function (res) {
        if (!res || res.status !== 'ok') {
          return;
        }
        var data = res.data;
        self.marketCategoryNames = Array.isArray(data) ? data : [];
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveMarketCategory: function saveMarketCategory(row, event) {
      var raw = event && event.target ? event.target.value : '';
      var next = raw == null ? '' : String(raw).trim();
      var prev = row.marketCategory == null ? '' : String(row.marketCategory).trim();
      if (next.length > 64) {
        this.$message.warning('市场分类不能超过 64 个字');
        return;
      }
      if (next === prev) {
        return;
      }
      var self = this;
      var isNewName = next && self.marketCategoryNames.indexOf(next) === -1;
      self.$http.post('/channel/updateMarketCategory', {
        id: row.id,
        marketCategory: next
      }).then(function (res) {
        if (res.status === 'ok') {
          self.$message.success('修改成功');
          self.$set(row, 'marketCategory', next);
          var list = self.$refs.channelList;
          if (list && list.tableData) {
            var target = list.tableData.find(function (item) {
              return item.id === row.id;
            });
            if (target && target !== row) {
              self.$set(target, 'marketCategory', next);
            }
          }
          if (isNewName) {
            self.loadMarketCategories();
          }
        }
      }).catch(function (err) {
        self.$message.error(err);
      });
    },
    toshowAddChannelModal: function toshowAddChannelModal() {
      var self = this;
      self.showAddChannelModal = true;
    },
    showUpdate: function showUpdate(row) {
      var self = this;
      self.updateChannelParams.id = row.id;
      self.updateChannelParams.channelName = row.channelName;
      self.updateChannelParams.channelType = row.channelType;
      self.updateChannelParams.channelParam = row.channelParam;
      self.updateChannelParams.status = row.status == 1 ? 'yes' : 'no';
      self.updateChannelParams.description = row.description;
      self.updateChannelParams.createTime = row.createTime;
      self.updateChannelParams.updateTime = row.updateTime;
      self.updateChannelParams.tchChannel = row.tchChannel;
      self.updateChannelParams.adminUserIds = row.adminUserIds;
      self.showUpdateChannelModal = true;
    },
    updateChannel: function updateChannel() {
      var self = this;
      self.updateChannelParams.status = self.updateChannelParams.status == 'yes' ? 1 : 0;
      self.$refs.updateChannelForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddActivity = false;
          return;
        }
        self.$http.post('/channel/update', self.updateChannelParams).then(function (res) {
          if (res.status === 'ok') {
            self.showUpdateChannelModal = false;
            self.$message.success('修改成功');
            self.search();
          }
        }).catch(function (err) {
          console.log('err', err);
          self.$message.error(err);
        });
      });
    },
    updateChannelType: function updateChannelType(id, type) {
      var self = this;
      self.$http.post('/channel/updateChannelType', { id: id, type: type }).then(function (res) {
        if (res.status === 'ok') {
          self.$message.success('修改成功');
        }
      }).catch(function (err) {
        self.$message.error(err);
      });
    },
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_LogicModal_vue__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_LogicModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_LogicModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_src_components_grid_row__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LogicModal: __WEBPACK_IMPORTED_MODULE_0__modal_LogicModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    return {
      exportLoading: false,
      reload: 0,
      onLoading: false,
      logicModal: false,
      queryParams: {},
      statisticsSum: {
        consumeTotal: 0
      },
      startTime: '',
      endTime: '',
      itemId: null,
      logicName: null,
      logicNumber: null,
      tableColumns: [{
        title: '兑换记录序列号',
        width: 80,
        align: 'center',
        key: 'id'
      }, {
        title: '课程名称',
        width: 200,
        align: 'center',
        key: 'name'
      }, {
        title: '获得课时',
        width: 200,
        align: 'center',
        key: 'obtainNum'
      }, {
        title: '兑换数量',
        width: 200,
        align: 'center',
        key: 'num'
      }, {
        title: '学生ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.userId);
              } } }, row.userId + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 200,
        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '学导',
        width: 100,
        key: 'studyAdviserName',
        render: function render(h, params) {
          return h('span', params.row.studyAdviserName || '未分配');
        }
      }, {
        title: '用户使用课时数',
        width: 200,
        align: 'center',
        key: 'userNum'
      }, {
        title: '收货地址',
        width: 200,
        align: 'center',
        key: 'address'
      }, {
        title: '审核状态',
        width: 200,
        align: 'center',
        key: 'auditStatus',
        render: function render(h, params) {
          var row = params.row;
          return h('div', row.auditStatus == 0 ? '待审核' : row.auditStatus == 1 ? "审核通过" : "审核不通过");
        }
      }, {
        title: '审核人',
        width: 200,
        align: 'center',
        key: 'adminName'
      }, {
        title: '快递公司',
        width: 200,
        align: 'center',
        key: 'logicName'
      }, {
        title: '快递单号',
        width: 200,
        align: 'center',
        key: 'logicNumber'
      }, {
        title: '创建时间',
        width: 200,
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '更新时间',
        width: 200,
        align: 'center',
        key: 'gmtModified'
      }, {
        title: '操作',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.auditStatus == 0) {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.pass(1, row.id);
                } } }, '通过'), h('span', ' / '), h('a', { on: { click: function click() {
                  return _this.pass(2, row.id);
                } } }, '不通过')]);
          }
          if (row.auditStatus == 1) {
            return h('el-button', {
              props: { type: 'primary', size: 'mini' },
              on: {
                click: function click() {
                  _this.onEdit(params.row);
                }
              }
            }, '编辑物流');
          }
          return '';
        }

      }]
    };
  },

  mounted: function mounted() {
    this.loadStatisticsSum();
  },
  created: function created() {},
  methods: {
    loadStatisticsSum: function loadStatisticsSum() {
      var self = this;
      this.$http.post('/courseEx/sum', self.queryParams).then(function (res) {
        self.statisticsSum = res.data;
      });
    },
    search: function search() {
      this.startTime = this.queryParams.startGmtCreate;
      this.endTime = this.queryParams.endGmtCreate;
      this.reload = new Date().getTime();
      this.loadStatisticsSum();
    },
    editSuccess: function editSuccess() {
      this.search();
    },
    clearId: function clearId() {
      this.itemId = null;
      this.logicName = null;
      this.logicNumber = null;
    },
    onEdit: function onEdit(row) {
      this.itemId = row.id;
      this.logicName = row.logicName;
      this.logicNumber = row.logicNumber;
      this.logicModal = true;
    },
    pass: function pass(val, id) {
      var self = this;
      self.$http.post('/courseEx/audit', { auditStatus: val, id: id }).then(function (res) {
        if (res) {
          self.$message.success('审核成功');
          self.search();
        }
      }).catch(function (err) {
        self.$message.error(err);
      });
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParams, backPath: '/user/UserExperienceList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/courseEx/export', { responseType: 'arraybuffer', params: this.queryParams }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '兑换课记录.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParams.startGmtCreate = value;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParams.endGmtCreate = value;
    }
  },
  watch: {
    startGmtCreate: function startGmtCreate(val) {
      this.startTime = val;
    },
    endGmtCreate: function endGmtCreate(val) {
      this.endTime = val;
    }
  }

});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ActivitySelect_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ActivitySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ActivitySelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateShareModal__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateShareModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateShareModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ActivitySelect: __WEBPACK_IMPORTED_MODULE_0__common_ActivitySelect_vue___default.a, CreateShareModal: __WEBPACK_IMPORTED_MODULE_1__components_market_modal_CreateShareModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      updateDefalutPic: [],
      showAddPosterModel: false,
      showUpdatePosterModel: false,
      searchLoading: false,
      loadingAddPoster: false,
      selectionUser: [],
      reload: 0,
      updatePosterParams: {
        id: '',
        name: '',
        sharePosterType: '',
        activityId: '',
        activityName: '',
        status: '',
        url: '',
        sort: null,
        createTime: '',
        updateTime: ''
      },
      queryParams: {
        name: '',
        sharePosterType: '',
        activityId: '',
        activityName: '',
        status: '',
        url: '',
        sort: null,
        createTime: '',
        updateTime: ''
      },
      shareRules: {
        name: [{ type: 'string', required: true, message: '请输入海报名称', trigger: 'blur' }, { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur' }],
        sharePosterType: [{ required: true, message: '选择海报分类', trigger: 'blur' }],
        activityId: [{ type: 'integer', required: true, message: '请选择活动归属', trigger: 'blur' }],
        url: [{ type: 'string', required: true, message: '请上传图片', trigger: 'blur' }],
        sort: [{ type: 'number', required: true, message: '请输入图片排序', trigger: 'blur' }],
        status: [{ type: 'integer', required: true, message: '请选择渠道状态', trigger: 'blur' }]
      },
      tableColumns: [{
        title: '海报id',

        key: 'id',
        sortable: true
      }, {
        title: '海报名称',

        key: 'name'
      }, {
        title: '海报分类',

        align: 'center',
        key: 'sharePosterType',
        render: function render(h, params) {
          var row = params.row;
          return h('span', $constant.getEnum($constant.sharePosterType, row.sharePosterType).text);
        }
      }, {
        title: '预览',
        height: 10,

        align: 'center',
        key: 'url',
        render: function render(h, params) {
          var row = params.row;
          return h('viewer', [h('img', {
            style: {
              width: '100px',
              cursor: 'pointer'
            },
            attrs: {
              src: row.url
            }
          })]);
        }
      }, {
        title: '归属活动',

        align: 'center',
        key: 'activityName'
      }, {
        title: '海报排序',

        align: 'center',
        key: 'sort',
        sortable: true
      }, {
        title: '状态',

        align: 'center',
        key: 'status',
        render: function render(h, params) {
          var row = params.row;
          return h('div', row.status == 1 ? '启用' : '禁用');
        }
      }, {
        title: '创建时间',

        align: 'center',
        key: 'createTime',
        sortable: true
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.toShowUpdateModel(row);
              } } }, '编辑')]);
        }

      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    toShowAddposterModel: function toShowAddposterModel() {
      var self = this;
      self.showAddPosterModel = true;
    },
    toShowUpdateModel: function toShowUpdateModel(row) {
      var self = this;
      self.updatePosterParams.id = row.id;
      self.updatePosterParams.name = row.name;
      self.updatePosterParams.sharePosterType = row.sharePosterType;
      self.updatePosterParams.activityId = row.activityId;
      self.updatePosterParams.activityName = row.activityName;
      self.updatePosterParams.status = row.status == 1 ? 'yes' : 'no';
      self.updatePosterParams.url = row.url;
      this.updateDefalutPic = row.name ? [{ name: row.name, url: row.url }] : [];
      self.updatePosterParams.sort = row.sort ? row.sort : null;
      self.updatePosterParams.createTime = row.createTime;
      self.updatePosterParams.updateTime = row.updateTime;
      self.showUpdatePosterModel = true;
    },
    update: function update() {
      var self = this;
      self.updatePosterParams.status = self.updatePosterParams.status == 'yes' ? 1 : 0;
      self.$refs.updatePosterForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddPoster = false;
          return;
        }
        self.$http.post('/share/poster/update', self.updatePosterParams).then(function (res) {
          if (res) {
            console.log(res);
            self.$message.success('成功');
            self.search();
            self.showUpdatePosterModel = false;
          }
        }).catch(function (err) {
          console.log('err', err);
          self.$message.error(err);
          self.showUpdatePosterModel = false;
        });
      });
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
    },
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateActivityModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visible: this.value,
      bookMaterialLevelList: null,
      loadingAddActivity: false,
      adviserList: [],
      time: [],
      createActivityParams: {
        id: 0,
        name: '',
        activityType: '',
        tag: '',
        startTimeStr: '',
        endTimeStr: '',
        status: '',
        description: '',
        createTime: '',
        updateTime: ''
      },
      activityRules: {
        name: [{ type: 'string', required: true, message: '请输入活动名称', trigger: 'blur' }],
        activityType: [{ required: true, message: '请选择活动分类', trigger: 'blur' }],
        activityTime: [{ type: 'array', required: true, fields: {
            0: { required: true, message: ' ', trigger: 'change' },
            1: { required: true, message: ' ', trigger: 'change' }
          } }],
        tag: [{ type: 'string', required: true, message: '请输入活动参数', trigger: 'blur' }],
        status: [{ required: true, message: '请选择活动状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    timeDateChange: function timeDateChange(value) {
      console.log('value', value);
      var self = this;
      self.createActivityParams.startTimeStr = value[0] + ' 00:00:00';
      self.createActivityParams.endTimeStr = value[1] + ' 23:59:59';
    },
    createActivity: function createActivity() {
      var self = this;
      self.loadingAddActivity = true;
      self.$refs.createActivityForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddActivity = false;
          return;
        }
        self.$http.post('/activity/save', self.createActivityParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('创建成功!');
            self.successCallback();
          }
          self.loadingAddActivity = false;
        }).catch(function (e) {
          self.showAddActivityModal = false;
          self.loadingAddActivity = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.createActivityParams = {
          id: 0,
          name: '',
          activityType: '',
          tag: '',
          startTimeStr: '',
          endTimeStr: '',
          status: '',
          description: '',
          createTime: '',
          updateTime: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateChannelModal',
  components: { AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_0__common_AdminUserMultSelect___default.a },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visible: this.value,
      bookMaterialLevelList: null,
      loadingAddActivity: false,
      adviserList: [],
      date: [],
      createChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        type: '',
        status: 1,
        tchChannel: 1,
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: []
      },
      channelRules: {
        channelName: [{ type: 'string', required: true, message: '请输入渠道名称', trigger: 'blur' }],
        channelType: [{ type: 'string', required: true, message: '请选择获客终端', trigger: 'blur' }],
        type: [{ type: 'string', required: true, message: '请选择渠道分类', trigger: 'change' }],
        channelParam: [{ type: 'string', required: true, message: '请输入渠道参数', trigger: 'blur' }],
        status: [{ type: 'string', required: true, message: '请选择渠道状态', trigger: 'blur' }],
        tchChannel: [{ type: 'integer', required: true, message: '请选择渠道来源', trigger: 'blur' }]
      }
    };
  },

  methods: {
    createNewChannel: function createNewChannel() {
      var self = this;
      self.loadingAddActivity = true;
      self.$refs.createChannelForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddActivity = false;
          return;
        }
        self.$http.post('/channel/save', self.createChannelParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('创建成功!');
            self.successCallback();
            self.date = [];
          }
          self.loadingAddActivity = false;
        }).catch(function (e) {
          self.showAddActivityModal = false;
          self.loadingAddActivity = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.createChannelParams = {
          id: 0,
          channelName: '',
          channelType: '',
          channelParam: '',
          type: '',
          status: '',
          description: '',
          createTime: '',
          updateTime: '',
          adminUserIds: []
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateChannelModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visible: this.value,
      loadingAddPoster: false,
      defaultPicList: [],
      addPosterparams: {
        name: '',
        sharePosterType: '',
        activityId: '',
        activityName: '',
        status: '',
        url: '',
        sort: null,
        createTime: '',
        updateTime: ''
      },
      shareRules: {
        name: [{ type: 'string', required: true, message: '请输入海报名称', trigger: 'blur' }, { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur' }],
        sharePosterType: [{ required: true, message: '选择海报分类', trigger: 'blur' }],
        activityId: [{ type: 'integer', required: true, message: '请选择活动归属', trigger: 'blur' }],
        url: [{ type: 'string', required: true, message: '请上传图片', trigger: 'blur' }],
        sort: [{ type: 'number', required: true, message: '请输入图片排序', trigger: 'blur' }],
        status: [{ type: 'string', required: true, message: '请选择渠道状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    createPoster: function createPoster() {
      var self = this;
      self.loadingAddPoster = true;
      self.$refs.addPosterForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAddPoster = false;
          return;
        }
        self.$http.post('/share/poster/save', self.addPosterparams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('创建成功!');
            self.successCallback();
            self.defaultPicList = [];
          }
          self.loadingAddPoster = false;
        }).catch(function (e) {
          self.showAddActivityModal = false;
          self.loadingAddPoster = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.addPosterparams = {
          name: '',
          sharePosterType: '',
          activityId: '',
          activityName: '',
          status: '',
          url: '',
          sort: null,
          createTime: '',
          updateTime: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LogicModal',
  props: {
    itemId: Number,
    value: {
      type: Boolean,
      default: false
    },
    logicName: String,
    logicNumber: String
  },
  data: function data() {
    return {
      showIs: this.value,
      formRule: {},
      searchLoading: false,
      loadingEdit: false,
      formData: {
        id: null,
        logicName: '',
        logicNumber: ''
      }
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      var self = this;
      if (!val) {
        self.$emit('on-close');
      }
    },
    edit: function edit() {
      var self = this;
      self.loadingEdit = true;
      self.showIs = true;
      var path = '/courseEx/logic';
      self.$http.post(path, self.formData).then(function (res) {
        self.showIs = false;
        self.$Message.success('提交成功!');
        self.$emit('on-edit-success');
        self.clearItem();
        self.loadingEdit = false;
      });
    },
    clearItem: function clearItem() {
      var self = this;
      self.formData.id = '';
      self.formData.logicNumber = '';
      self.formData.logicName = '';
      self.showIs = false;
    }
  },
  watch: {
    value: function value(val) {
      var self = this;
      if (val) {
        self.showIs = true;
      } else {
        this.clearItem();
      }
    },
    itemId: function itemId(val) {
      var self = this;
      if (val) {
        self.formData.id = val;
      }
      self.$emit('on-edit-clearid');
    },
    logicName: function logicName(val) {
      var self = this;
      if (val) {
        self.formData.logicName = val;
      }
      self.$emit('on-edit-clearid');
    },
    logicNumber: function logicNumber(val) {
      var self = this;
      if (val) {
        self.formData.logicNumber = val;
      }
      self.$emit('on-edit-clearid');
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_ChangeDirectorModal__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_ChangeDirectorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__user_ChangeDirectorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__order_ShowImageCarousel__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_3__order_ShowImageCarousel___default.a, ChangeDirectorModal: __WEBPACK_IMPORTED_MODULE_2__user_ChangeDirectorModal___default.a },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    return {
      showImgModal: false,
      showImgList: [],
      tabName: 0,
      tabItem: '',
      tabContent: '',
      labelList: ['新注册学生', '分配记录', '试听课记录', '成交记录', '交接记录', '绑定记录', '上课跟进记录', '其他'],
      tabCountStatistic: [],
      labelNumList: [],
      currentPersonMessageList: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      keyword: '',
      totalPersonMessageList: [],
      columnList: [{
        title: '学生ID/姓名',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickname);
        }
      }, {
        title: '提醒内容',
        width: 400,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;

          var formattedContent = params.row.content.replace(/\n/g, '<br>');

          if (row.state === 0) {
            var children = [h('div', {
              domProps: {
                innerHTML: formattedContent
              },
              style: {
                textAlign: 'left'
              }
            })];

            if (row.urls && row.urls.length > 0) {
              children.push(h('Badge', [h('sub', {
                class: 'ivu-badge-dot'
              })]));
              children.push(h('a', { on: { click: function click() {
                    return _this.viewPic(row);
                  } } }, '查看附件'));
            }

            return h('div', children);
          } else {
            return h('div', {
              domProps: {
                innerHTML: formattedContent
              },
              style: {
                textAlign: 'left'
              }
            });
          }
        }
      }, {
        title: '提醒时间',
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', $moment(createTime, 'X').format('YYYY-MM-DD HH:ss'));
        }
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var btnArr = [];
          if (row.state === 0) {
            var type = row.type;
            var typeNum = __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default.a.getShortNumByTraceType(type);
            if (typeNum === 0 || typeNum === 5 || typeNum === 1 || type === 64 || type === 63 || type === 65 || type === 52 || type === 51 || type === 71) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatus(row);
                  } }
              }, '已读'));
            } else if (type === 21) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写学员消息'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 24) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写试听课反馈'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 23) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写试听课缺席原因'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 42) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写家长沟通记录'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 41) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写教材配送信息'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 43) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写家长沟通记录'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 22) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '填写试听课失败原因'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 25) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '学员是否报名'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else if (type === 66) {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '开课日期是否生效'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            } else {
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.goOnNextStep(row);
                  } }
              }, '下一步'));
              btnArr.push(h('span', '        '));
              btnArr.push(h('Button', {
                props: { type: 'primary' },
                on: { click: function click() {
                    return _this.updateTraceOperatorStatusAlert(row);
                  } }
              }, '已操作'));
            }
          }

          return h('div', btnArr);
        }
      }],
      openModal: false,
      editData: null
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var self = this;
    if (self.$route.query.tabName) {
      self.tabName = self.$route.query.tabName;
    }
    self.getAllTypesNewPersonMessageCount();
    self.getMessage(self.tabName);
  },
  methods: {
    searchMessage: function searchMessage() {
      this.pageIndex = 1;
      this.getMessage(this.tabName, true);
    },
    getMessage: function getMessage(index, keepPage, retried) {
      var self = this;
      index = Number(index);
      if (isNaN(index)) {
        index = 0;
      }
      self.tabName = index;
      if (!keepPage) {
        self.pageIndex = 1;
      }
      self.currentPersonMessageList = [];
      var typeList = __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default.a.getTraceTypeListByShortNum(index) || [];
      var queryList = [];
      for (var i = 0; i < typeList.length; i++) {
        queryList.push('messageTypeList=' + typeList[i]);
      }
      queryList.push('pageIndex=' + self.pageIndex);
      queryList.push('pageSize=' + self.pageSize);
      var keyword = (self.keyword || '').trim();
      if (keyword) {
        queryList.push('keyword=' + encodeURIComponent(keyword));
      }
      self.$http.get('/message/getPersonMessage?' + queryList.join('&')).then(function (res) {
        var payload = res && res.data ? res.data : {};
        var list = payload.data || [];
        self.currentPersonMessageList = list;
        self.totalCount = payload.totalCount || 0;
        if (list.length === 0 && self.pageIndex > 1 && !retried) {
          self.pageIndex = self.pageIndex - 1;
          self.getMessage(self.tabName, true, true);
        }
      });
    },
    onPageChange: function onPageChange(page) {
      this.pageIndex = page;
      this.getMessage(this.tabName, true);
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.getMessage(this.tabName, true);
    },
    getAllTypesNewPersonMessageCount: function getAllTypesNewPersonMessageCount() {
      var self = this;
      self.$http.get('/message/getAllTypesNewPersonMessageCount').then(function (res) {
        if (res.data) {
          self.tabCountStatistic = res.data;
        }
      });
    },
    rowClassName: function rowClassName(row, index) {
      if (row.state === 0) {
        return 'demo-table-error-row';
      } else {
        return 'demo-table-info-row';
      }
    },
    goOnNextStep: function goOnNextStep(row) {
      var data = this.$constant.personMessageRouter;
      if (row.type === 25) {
        this.alertDealSuccess(row);
      } else if (row.type === 66) {
        this.changeDirector(row);
      } else {
        this.$router.push({ path: __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default.a.getUrlByTraceType(data, row.type), query: { row: row } });
      }
    },
    alertDealSuccess: function alertDealSuccess(row) {
      var _this2 = this;

      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: row.content,
        width: 300,
        loading: false,
        okText: '已报名',
        cancelText: '未报名',
        onOk: function onOk() {
          _this2.$router.push({ path: '/order/fundPackageList' });
        },
        onCancel: function onCancel() {
          _this2.$router.push({ path: '/user/addOrderFailRecords', query: { row: row } });
        }
      });
    },
    changeDirector: function changeDirector(row) {
      var _this3 = this;

      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '您的该学员即将开课，是否转移学员至学导部门？',
        width: 300,
        loading: false,
        okText: '是',
        cancelText: '否',
        onOk: function onOk() {
          _this3.openModal = true;
          _this3.editData = row;
        },
        onCancel: function onCancel() {
          _this3.$router.push({ path: '/user/bindingValidTimeFailRecords', query: { row: row } });
        }
      });
    },
    updateTraceOperatorStatusAlert: function updateTraceOperatorStatusAlert(row) {
      var _this4 = this;

      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认该信息后续操作已执行？确认后该条信息将不再提醒',
        width: 300,
        loading: false,
        okText: '是',
        cancelText: '否',
        onOk: function onOk() {
          _this4.updateTraceOperatorStatus(row);
        },
        onCancel: function onCancel() {}
      });
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    updateTraceOperatorStatus: function updateTraceOperatorStatus(row) {
      var self = this;
      self.$http.post('/message/updateTraceOperatorStatus', { 'personMessageId': row.id }).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('操作成功!');
          self.getAllTypesNewPersonMessageCount();
          self.getMessage(self.tabName, true);
          __WEBPACK_IMPORTED_MODULE_1__eventBus_js__["a" /* default */].$emit('reloadMessageCount', 0);
        }
      });
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Row: __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__["a" /* default */] },
  data: function data() {
    return {
      absentReason: [],
      formData: {
        uid: '',
        nickName: '',
        nextTimeDate: '',
        reason: [],
        state: '',
        otherReason: '',
        feedBackType: 23
      },
      formValidate: {
        uid: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: ''
      }
    };
  },
  created: function created() {
    var self = this;
    self.$http.get('/adminConfig/getItemByItemType?itemType=' + 3).then(function (res) {
      self.absentReason = res.data;
    });
  },
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.formData.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formData.nickName = res.data.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
  },

  methods: {
    dateChange: function dateChange(value) {
      this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onAbsentReasonChange: function onAbsentReasonChange(val) {
      this.formData.reason = val;
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      self.$http.post('/bookLesson/insertLessonFeedBack', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingBind = false;
        if (!res) {
          self.$Message.error('操作失败!');
        } else if (res.data > 0) {
          self.$Message.success('添加成功!');
          self.visible = false;
          if (self.successCallback !== undefined) {
            self.successCallback();
          }
          self.$router.push({ path: '/message/personMessage', query: { tabName: __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default.a.getShortNumByTraceType(21) } });
        } else {
          self.$Message.error(res.message);
        }
      });
    }
  },
  watch: {}
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Row: __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__["a" /* default */] },
  data: function data() {
    return {
      failReason: [],
      formData: {
        uid: '',
        nickName: '',
        nextTimeDate: '',
        reason: [],
        state: '',
        otherReason: '',
        feedBackType: 22
      },
      formValidate: {
        uid: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: ''
      }
    };
  },
  created: function created() {
    var self = this;
    self.$http.get('/adminConfig/getItemByItemType?itemType=' + 2).then(function (res) {
      self.failReason = res.data;
    });
  },
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.formData.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formData.nickName = self.formValidate.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
  },

  methods: {
    dateChange: function dateChange(value) {
      this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onFailReasonChange: function onFailReasonChange(val) {
      this.formData.reason = val;
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      self.$http.post('/bookLesson/insertLessonFeedBack', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingBind = false;
        if (!res) {
          self.$Message.error('操作失败!');
        } else if (res.data > 0) {
          self.$Message.success('添加成功!');
          self.visible = false;
          if (self.successCallback !== undefined) {
            self.successCallback();
          }
          self.$router.push({ path: '/message/personMessage', query: { tabName: __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default.a.getShortNumByTraceType(21) } });
        } else {
          self.$Message.error(res.message);
        }
      });
    }
  },
  watch: {}
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Row: __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__["a" /* default */] },
  data: function data() {
    return {
      failReason: [],
      formData: {
        uid: '',
        nickName: '',
        nextTimeDate: '',
        state: '',
        otherReason: '',
        feedBackType: 24
      },
      formValidate: {
        uid: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: ''
      }
    };
  },
  created: function created() {
    var self = this;
    self.$http.get('/adminConfig/getItemByItemType?itemType=' + 2).then(function (res) {
      self.failReason = res.data;
    });
  },
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.formData.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formData.nickName = res.data.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
  },

  methods: {
    dateChange: function dateChange(value) {
      this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onFailReasonChange: function onFailReasonChange(val) {
      this.formData.failReasonList = val;
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      self.$http.post('/bookLesson/insertLessonFeedBack', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingBind = false;
        if (!res) {
          self.$Message.error('操作失败!');
        } else if (res.data > 0) {
          self.$Message.success('添加成功!');
          self.visible = false;
          if (self.successCallback !== undefined) {
            self.successCallback();
          }
          self.$router.push({ path: '/message/personMessage', query: { tabName: __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default.a.getShortNumByTraceType(21) } });
        } else {
          self.$Message.error(res.message);
        }
      });
    }
  },
  watch: {}
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus_js__ = __webpack_require__(212);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: '',
      count: 0,
      userNickName: '',
      rules: [],
      hasPermission: false,
      msg: [],
      openCount: -1,
      showCount: 0
    };
  },

  methods: {
    getPersonMessageNotice: function getPersonMessageNotice() {
      var self = this;
      self.$http.get('/message/getPersonMessage?needAlert=1&state=0').then(function (res) {
        if (res.data.data) {
          self.msg = res.data.data;
          var list = self.msg;
          if (list.length > 0) {
            for (self.openCount = 0; self.openCount < list.length; self.openCount++) {
              self.openMsg();
            }
          }
        }
      });
    },
    showEmailNews: function showEmailNews() {
      this.$router.push({ path: '/message/personMessage' });
    },
    openMsg: function openMsg() {
      var self = this;
      var index = self.openCount;
      if (index < 0) {
        return;
      }
      this.$Notice.config({
        top: 50,
        duration: 0
      });
      this.$Notice.success({
        name: index + '',
        title: '站内消息提醒',
        render: function render(h) {
          return h('div', [h('span', { style: { fontSize: '12px' } }, self.msg[index].content), h('br'), h('br'), h('Button', { on: { click: function click() {
                return self.openMessageDetail(self.msg[index]);
              } }, style: { width: '80px', float: 'left' } }, '查看详情'), h('Button', { on: { click: function click() {
                return self.handlerMsg(self.msg[index].id, index + '');
              } }, style: { width: '80px', float: 'right' } }, '不再提示')]);
        }
      });
    },
    openMessageDetail: function openMessageDetail(msg) {
      var self = this;
      this.$Notice.destroy();
      self.$router.push({ path: '/message/personMessage', query: { tabName: __WEBPACK_IMPORTED_MODULE_0__tools_commonUtils_js___default.a.getShortNumByTraceType(msg.type) } });
    },
    handlerMsg: function handlerMsg(id, item) {
      var self = this;
      self.$http.post('/message/handlerMessage', { id: id });
      this.$Notice.close(item);
    },
    getMessageCount: function getMessageCount(getNotice) {
      var self = this;
      this.$http.post('/message/getPersonMessageCount', { state: 0 }).then(function (res) {
        if (res.status === 'ok') {
          self.count = res.data;
          if (self.count > 0 && getNotice > 0) {
            self.getPersonMessageNotice();
          }
        }
      });
    },
    updateUserAllMessageNeedAlertStatus: function updateUserAllMessageNeedAlertStatus() {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认现有未处理信息不再弹出？',
        width: 300,
        loading: false,
        okText: '是',
        cancelText: '否',
        onOk: function onOk() {
          self.$Notice.destroy();
          self.$http.post('/message/notNeedAlert', { needAlert: 0 }).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('操作成功!');
            }
          });
        },
        onCancel: function onCancel() {}
      });
    }
  },
  created: function created() {
    this.getMessageCount(1);
  },

  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1__eventBus_js__["a" /* default */].$on('reloadMessageCount', function (count) {
      self.getMessageCount(count);
    });
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexAdviceList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {},
      form: {},
      tableColumns: [{ title: 'ID', key: 'id', width: 80, ellipsis: true }, { title: '年龄档', key: 'ageBand', width: 150, ellipsis: true, render: function render(h, params) {
          return h('span', _this.ageBandLabel(params.row.ageBand));
        } }, { title: '技能', key: 'skill', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', _this.skillLabel(params.row.skill));
        } }, { title: '分数档', key: 'scoreBand', width: 110, ellipsis: true, render: function render(h, params) {
          return h('span', _this.scoreBandLabel(params.row.scoreBand));
        } }, { title: '状态', key: 'status', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status));
        } }, { title: '文案', key: 'content', width: 420, ellipsis: true }, {
        title: '操作',
        key: 'action',
        width: 240,
        render: function render(h, params) {
          return h('div', { style: { whiteSpace: 'nowrap' } }, [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row.id, 'online');
              } }
          }, '上线'), h('Button', {
            props: { size: 'small' },
            on: { click: function click() {
                return _this.changeStatus(params.row.id, 'offline');
              } }
          }, '下线')]);
        }
      }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    statusLabel: function statusLabel(code) {
      if (code === 'ONLINE') return '已上线 ONLINE';
      if (code === 'OFFLINE') return '已下线 OFFLINE';
      return code || '';
    },
    skillLabel: function skillLabel(code) {
      if (code === 'Listening') return '听力 Listening';
      if (code === 'Speaking') return '口语 Speaking';
      if (code === 'Reading') return '阅读 Reading';
      if (code === 'Writing') return '写作 Writing';
      return code || '';
    },
    ageBandLabel: function ageBandLabel(code) {
      if (code === 'LOW') return '低档 LOW（3-5）';
      if (code === 'MID') return '中档 MID（6-8）';
      if (code === 'HIGH') return '高档 HIGH（9+）';
      return code || '';
    },
    scoreBandLabel: function scoreBandLabel(code) {
      if (code === 'LOW') return '低档 LOW';
      if (code === 'MID') return '中档 MID';
      if (code === 'HIGH') return '高档 HIGH';
      return code || '';
    },
    emptyForm: function emptyForm() {
      return {
        ageBand: 'MID',
        skill: 'Listening',
        scoreBand: 'LOW',
        content: '',
        status: 'ONLINE'
      };
    },
    search: function search() {
      var _this2 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.editVisible = true;
    },
    openEdit: function openEdit(row) {
      this.form = {
        id: row.id,
        ageBand: row.ageBand,
        skill: row.skill,
        scoreBand: row.scoreBand,
        content: row.content,
        status: row.status
      };
      this.editVisible = true;
    },
    save: function save() {
      var _this3 = this;

      this.$http.post('/mex/advice/save', this.form).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success(_this3.form.id ? '已更新' : '已新建');
          _this3.editVisible = false;
          _this3.search();
        } else {
          _this3.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(id, action) {
      var _this4 = this;

      this.$http.post('/mex/advice/' + action, { id: id }).then(function (res) {
        if (res.status === 'ok') {
          _this4.$Message.success('已更新');
          _this4.search();
        } else {
          _this4.$Message.error(res.msg || '操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mex_asset__ = __webpack_require__(95);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexAssetPreview',
  props: {
    path: {
      type: String,
      default: ''
    },
    skill: {
      type: String,
      default: ''
    },
    bank: {
      type: String,
      default: 'comp'
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      uploading: false
    };
  },

  computed: {
    url: function url() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_asset__["a" /* assetUrl */])(this.path, this.skill);
    },
    kind: function kind() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_asset__["b" /* assetKind */])(this.url);
    },
    uploadUrl: function uploadUrl() {
      return this.bank === 'speak' ? '/mex/speak/questions/asset' : '/mex/comp/questions/asset';
    }
  },
  methods: {
    pick: function pick() {
      if (!this.skill) {
        this.$Message.warning('请先选择技能');
        return;
      }
      this.$refs.file && this.$refs.file.click();
    },
    onFile: function onFile(e) {
      var _this = this;

      var file = e.target && e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      var fd = new FormData();
      fd.append('file', file);
      fd.append('skill', this.skill);
      var hint = String(this.path || '').trim();
      if (hint) fd.append('fileName', hint);
      this.uploading = true;
      this.$http.post(this.uploadUrl, fd, { transformRequest: [] }).then(function (res) {
        _this.uploading = false;
        if (res.status === 'ok' && res.data && res.data.fileName) {
          _this.$emit('input', res.data.fileName);
          _this.$Message.success('已上传');
        } else {
          _this.$Message.error(res.msg || '上传失败');
        }
      }).catch(function () {
        _this.uploading = false;
        _this.$Message.error('上传失败');
      });
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mex_question_type__ = __webpack_require__(40);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexBlueprintList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {},
      form: {},
      slots: [],
      weights: [],
      typeMap: {
        Listening: [],
        Speaking: [],
        Reading: [],
        Writing: []
      },
      tableColumns: [{ title: 'ID', key: 'id', width: 80, ellipsis: true }, { title: '考试类型', key: 'examType', width: 120, ellipsis: true, render: function render(h, params) {
          return h('span', _this.examTypeLabel(params.row.examType));
        } }, { title: '学段', key: 'segment', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', _this.segmentLabel(params.row.examType, params.row.segment));
        } }, { title: '版本号', key: 'versionNo', width: 100, ellipsis: true }, { title: '题量上限', key: 'itemLimit', width: 100, ellipsis: true }, { title: '限时（秒）', key: 'durationSec', width: 110, ellipsis: true }, { title: '状态', key: 'status', width: 100, ellipsis: true, render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status));
        } }, { title: '组卷槽位', key: 'slotsJson', width: 420, ellipsis: true, render: function render(h, params) {
          return h('span', _this.slotSummary(params.row.slotsJson));
        } }, {
        title: '操作',
        key: 'action',
        width: 240,
        render: function render(h, params) {
          return h('div', { style: { whiteSpace: 'nowrap' } }, [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row.id, 'online');
              } }
          }, '上线'), h('Button', {
            props: { size: 'small' },
            on: { click: function click() {
                return _this.changeStatus(params.row.id, 'offline');
              } }
          }, '下线')]);
        }
      }]
    };
  },

  computed: {
    weightSum: function weightSum() {
      var n = 0;
      this.weights.forEach(function (item) {
        n += Number(item.weight) || 0;
      });
      return n;
    }
  },
  created: function created() {
    this.loadAllQuestionTypes();
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    examTypeLabel: function examTypeLabel(code) {
      if (code === 'PLACEMENT') return '入门测';
      if (code === 'SUMMATIVE') return '阶段测';
      return code || '';
    },
    segmentOptions: function segmentOptions(examType, current) {
      var list = void 0;
      if (examType === 'SUMMATIVE') {
        list = [{ value: 'L1-L2', label: 'L1-L2' }, { value: 'L3-L4', label: 'L3-L4' }, { value: 'L5-L6', label: 'L5-L6' }, { value: 'L7-L8', label: 'L7-L8' }, { value: 'LISTENING', label: '听力（旧）' }, { value: 'SPEAKING', label: '口语（旧）' }, { value: 'READING', label: '阅读（旧）' }, { value: 'WRITING', label: '写作（旧）' }];
      } else {
        list = [{ value: 'LOW', label: '低段 L1-L2' }, { value: 'MID', label: '中段 L3-L5' }, { value: 'HIGH', label: '高段 L6-L7' }];
      }
      if (current) {
        var hit = false;
        for (var i = 0; i < list.length; i++) {
          if (list[i].value === current) {
            hit = true;
            break;
          }
        }
        if (!hit) {
          list.push({ value: current, label: current + '（已有）' });
        }
      }
      return list;
    },
    segmentLabel: function segmentLabel(examType, code) {
      if (!code) return '';
      var list = this.segmentOptions(examType, code);
      for (var i = 0; i < list.length; i++) {
        if (list[i].value === code) return list[i].label;
      }
      return code;
    },
    onExamTypeChange: function onExamTypeChange() {
      var opts = this.segmentOptions(this.form.examType);
      var hit = false;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].value === this.form.segment) {
          hit = true;
          break;
        }
      }
      if (!hit) {
        this.form.segment = this.form.examType === 'SUMMATIVE' ? 'L1-L2' : 'MID';
      }
      this.syncWeightsToExamType();
    },
    statusLabel: function statusLabel(code) {
      if (code === 'ONLINE') return '已上线';
      if (code === 'OFFLINE') return '已下线';
      return code || '';
    },
    skillLabel: function skillLabel(code) {
      if (code === 'Listening') return '听力';
      if (code === 'Speaking') return '口语';
      if (code === 'Reading') return '阅读';
      if (code === 'Writing') return '写作';
      return code || '';
    },
    toTypeOptions: function toTypeOptions(list, skill) {
      var rows = list || [];
      return rows.filter(function (t) {
        return t;
      }).map(function (t) {
        return { value: t, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mex_question_type__["b" /* questionTypeLabel */])(t, skill) };
      });
    },
    loadAllQuestionTypes: function loadAllQuestionTypes() {
      var _this2 = this;

      var skills = ['Listening', 'Reading', 'Writing'];
      skills.forEach(function (skill) {
        _this2.$http.post('/mex/comp/questions/types', { skill: skill }).then(function (res) {
          if (res.status === 'ok') {
            _this2.$set(_this2.typeMap, skill, _this2.toTypeOptions(res.data, skill));
          }
        });
      });
      this.$http.post('/mex/speak/questions/types').then(function (res) {
        if (res.status === 'ok') {
          _this2.$set(_this2.typeMap, 'Speaking', _this2.toTypeOptions(res.data, 'Speaking'));
        }
      });
    },
    firstTypeOf: function firstTypeOf(skill) {
      var list = this.typeMap[skill] || [];
      return list[0] ? list[0].value : '';
    },
    questionTypesOf: function questionTypesOf(skill, current) {
      var list = (this.typeMap[skill] || []).slice();
      if (current) {
        var hit = false;
        for (var i = 0; i < list.length; i++) {
          if (list[i].value === current) {
            hit = true;
            break;
          }
        }
        if (!hit) {
          list.push({ value: current, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mex_question_type__["b" /* questionTypeLabel */])(current, skill) });
        }
      }
      return list;
    },
    emptySlot: function emptySlot() {
      return {
        bank: 'COMP',
        skill: 'Listening',
        questionType: this.firstTypeOf('Listening'),
        count: 1,
        scoreEach: 1
      };
    },
    emptyForm: function emptyForm() {
      return {
        examType: 'PLACEMENT',
        segment: 'MID',
        versionNo: 'v1.0',
        itemLimit: 0,
        durationSec: 0,
        status: 'ONLINE'
      };
    },
    defaultWeights: function defaultWeights(examType) {
      if (examType === 'SUMMATIVE') {
        return [{ skill: 'Listening', weight: 25 }, { skill: 'Speaking', weight: 25 }, { skill: 'Reading', weight: 25 }, { skill: 'Writing', weight: 25 }];
      }
      return [{ skill: 'Listening', weight: 40 }, { skill: 'Speaking', weight: 30 }, { skill: 'Reading', weight: 30 }];
    },
    parseWeights: function parseWeights(raw, examType) {
      var defaults = this.defaultWeights(examType);
      if (!raw) return defaults;
      try {
        var obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) !== 'object' || obj.length != null) {
          this.$Message.warning('原模块权重无法解析，已套用默认值');
          return defaults;
        }
        var used = {};
        var list = defaults.map(function (item) {
          used[item.skill] = true;
          var val = obj[item.skill];
          return {
            skill: item.skill,
            weight: val == null ? item.weight : Number(val)
          };
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (!used[key]) {
            list.push({ skill: key, weight: Number(obj[key]) });
          }
        });
        return list;
      } catch (e) {
        this.$Message.warning('原模块权重无法解析，已套用默认值');
        return defaults;
      }
    },
    stringifyWeights: function stringifyWeights() {
      var obj = {};
      this.weights.forEach(function (item) {
        if (item.skill) {
          obj[item.skill] = Number(item.weight) || 0;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj);
    },
    syncWeightsToExamType: function syncWeightsToExamType() {
      var prev = {};
      this.weights.forEach(function (item) {
        prev[item.skill] = item.weight;
      });
      this.weights = this.defaultWeights(this.form.examType).map(function (item) {
        return {
          skill: item.skill,
          weight: prev[item.skill] == null ? item.weight : prev[item.skill]
        };
      });
    },
    parseSlots: function parseSlots(raw) {
      var _this3 = this;

      if (!raw) return [this.emptySlot()];
      try {
        var arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!arr || !arr.length) return [this.emptySlot()];
        return arr.map(function (item) {
          var skill = item.skill || 'Listening';
          var bank = item.bank || (skill === 'Speaking' ? 'SPEAK' : 'COMP');
          var types = _this3.questionTypesOf(skill);
          var questionType = item.questionType || types[0] && types[0].value || '';
          return {
            bank: bank,
            skill: skill,
            questionType: questionType,
            count: item.count == null ? 1 : Number(item.count),
            scoreEach: item.scoreEach == null ? 1 : Number(item.scoreEach)
          };
        });
      } catch (e) {
        this.$Message.warning('原槽位数据无法解析，已重置为一行');
        return [this.emptySlot()];
      }
    },
    slotSummary: function slotSummary(raw) {
      var _this4 = this;

      try {
        var arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!arr || !arr.length) return '';
        return arr.map(function (item) {
          return _this4.skillLabel(item.skill) + ' ' + (item.count || 0) + '道';
        }).join(' / ');
      } catch (e) {
        return raw || '';
      }
    },
    addSlot: function addSlot() {
      this.slots.push(this.emptySlot());
    },
    removeSlot: function removeSlot(idx) {
      if (this.slots.length <= 1) {
        this.$Message.warning('至少保留一类题');
        return;
      }
      this.slots.splice(idx, 1);
    },
    onBankChange: function onBankChange(slot) {
      if (slot.bank === 'SPEAK') {
        slot.skill = 'Speaking';
      } else if (slot.skill === 'Speaking') {
        slot.skill = 'Listening';
      }
      this.onSkillChange(slot);
    },
    onSkillChange: function onSkillChange(slot) {
      if (slot.skill === 'Speaking') {
        slot.bank = 'SPEAK';
      } else {
        slot.bank = 'COMP';
      }
      var types = this.questionTypesOf(slot.skill);
      var hit = false;
      for (var i = 0; i < types.length; i++) {
        if (types[i].value === slot.questionType) {
          hit = true;
          break;
        }
      }
      if (!hit && types.length) {
        slot.questionType = types[0].value;
      }
    },
    search: function search() {
      var _this5 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this5.$refs.list && _this5.$refs.list.search();
      });
    },
    openCreate: function openCreate() {
      this.loadAllQuestionTypes();
      this.form = this.emptyForm();
      this.slots = [this.emptySlot()];
      this.weights = this.defaultWeights(this.form.examType);
      this.editVisible = true;
    },
    openEdit: function openEdit(row) {
      this.loadAllQuestionTypes();
      this.form = {
        id: row.id,
        examType: row.examType,
        segment: row.segment,
        versionNo: row.versionNo,
        itemLimit: row.itemLimit == null ? 0 : Number(row.itemLimit),
        durationSec: row.durationSec == null ? 0 : Number(row.durationSec),
        status: row.status
      };
      this.slots = this.parseSlots(row.slotsJson);
      this.weights = this.parseWeights(row.moduleWeightsJson, row.examType);
      this.editVisible = true;
    },
    save: function save() {
      var _this6 = this;

      if (!this.slots.length) {
        this.$Message.error('请至少添加一类题');
        return;
      }
      for (var i = 0; i < this.slots.length; i++) {
        var slot = this.slots[i];
        if (!slot.bank || !slot.skill || !slot.questionType) {
          this.$Message.error('第 ' + (i + 1) + ' 类题的题库、技能、题型都要填');
          return;
        }
        if (this.form.examType === 'PLACEMENT' && slot.skill === 'Writing') {
          this.$Message.error('入门测不能包含写作');
          return;
        }
        if (!slot.count || slot.count < 1) {
          this.$Message.error('第 ' + (i + 1) + ' 类题的出题数量至少为 1');
          return;
        }
      }
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form, {
        itemLimit: Number(this.form.itemLimit) || 0,
        durationSec: Number(this.form.durationSec) || 0,
        slotsJson: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.slots),
        moduleWeightsJson: this.stringifyWeights()
      });
      this.$http.post('/mex/blueprints/save', payload).then(function (res) {
        if (res.status === 'ok') {
          _this6.$Message.success(_this6.form.id ? '已更新' : '已新建');
          _this6.editVisible = false;
          _this6.search();
        } else {
          _this6.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(id, action) {
      var _this7 = this;

      this.$http.post('/mex/blueprints/' + action, { id: id }).then(function (res) {
        if (res.status === 'ok') {
          _this7.$Message.success('已更新');
          _this7.search();
        } else {
          _this7.$Message.error(res.msg || '操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MexAssetPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mex_question_type__ = __webpack_require__(40);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexCompQuestionList',
  components: { MexQuestionBatchModal: __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal___default.a, MexAssetPreview: __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      importSkill: 'Listening',
      batchVisible: false,
      inspectVisible: false,
      inspectLoading: false,
      inspectReport: null,
      inspectRows: [],
      inspectColumns: [{ title: '码', key: 'code', width: 100 }, { title: '库', key: 'bank', width: 80 }, { title: '题目ID', key: 'id', width: 100 }, { title: '级别', key: 'level', width: 80 }, { title: '技能', key: 'skill', width: 100 }, { title: '档', key: 'band', width: 60 }, { title: '数量', key: 'count', width: 70 }, { title: '详情', key: 'detail', minWidth: 220, ellipsis: true }],
      selection: [],
      editVisible: false,
      createMode: false,
      businessCode: '',
      selectedVersionId: null,
      versions: [],
      form: {},
      dimensions: [],
      skipDimSync: false,
      optionMode: 'NONE',
      choiceOptions: [],
      dragTokens: [],
      optionCodes: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
      blanks: [],
      queryParam: {},
      questionTypes: [],
      editQuestionTypes: [],
      editSubSkills: [],
      skipSubSkillSync: false,
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0'],
      tableColumns: [{ type: 'selection', width: 60, align: 'center' }, { title: '版本 ID', key: 'currentVersionId', width: 90, ellipsis: true }, { title: '题头 ID', key: 'id', width: 80, ellipsis: true }, { title: '业务键', key: 'businessCode', width: 200, ellipsis: true }, { title: '技能', key: 'skill', width: 140, ellipsis: true, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["a" /* skillLabel */])(p.row.skill));
        } }, { title: '级别', key: 'levelCode', width: 80, ellipsis: true }, { title: '题型', key: 'questionType', width: 280, ellipsis: true, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(p.row.questionType, p.row.skill));
        } }, { title: '版本', key: 'versionNo', width: 80, ellipsis: true }, { title: '状态', key: 'status', width: 200, ellipsis: true, render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status));
        } }, { title: '场景', key: 'examScene', width: 220, ellipsis: true, render: function render(h, params) {
          return h('span', _this.examSceneLabel(params.row.examScene));
        } }, { title: '锚题', key: 'isAnchor', width: 70, ellipsis: true }, { title: '曝光', key: 'exposureCount', width: 70, ellipsis: true }, { title: '通过率', key: 'passRate', width: 80, ellipsis: true }, { title: '题干', key: 'stem', width: 240, render: function render(h, p) {
          return _this.renderStem(h, p.row.stem);
        } }, {
        title: '操作',
        key: 'action',
        width: 420,
        render: function render(h, params) {
          return h('div', { style: { whiteSpace: 'nowrap' } }, [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row, 'online');
              } }
          }, '上线'), h('Button', {
            props: { size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row, 'offline');
              } }
          }, '下线'), h('Button', {
            props: { size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.markAnchor(params.row);
              } }
          }, params.row.isAnchor === 1 ? '取消锚题' : '标锚题'), h('Button', {
            props: { type: 'error', size: 'small' },
            on: { click: function click() {
                return _this.discard(params.row);
              } }
          }, '废弃')]);
        }
      }]
    };
  },

  computed: {
    isClozeType: function isClozeType() {
      return (this.form.questionType || '') === 'Cloze';
    },
    isFillBlanksType: function isFillBlanksType() {
      return (this.form.questionType || '') === 'Fill in the Blanks';
    },
    isWordFormType: function isWordFormType() {
      var t = this.form.questionType || '';
      return t === 'Fill Passage - Word Form' || t === 'Fill in Blank - Word Form';
    },
    isGapFillType: function isGapFillType() {
      return (this.form.questionType || '') === 'Gap Fill';
    },
    isPassageMcqType: function isPassageMcqType() {
      var t = this.form.questionType || '';
      return t === 'Multiple Choice' || t === 'True/False Judgment' || t === 'Reading Comprehension' || t === 'Advanced Reading' || t === 'Multiple Choice - Reading Comprehension' || t === 'Information Matching';
    },
    isBlankChoiceType: function isBlankChoiceType() {
      return this.isClozeType || this.isGapFillType || this.isPassageMcqType && this.blanks.length > 0;
    },
    dimSum: function dimSum() {
      var n = 0;
      this.dimensions.forEach(function (item) {
        n += Number(item.weight) || 0;
      });
      return n;
    },
    answerPlaceholder: function answerPlaceholder() {
      if (this.optionMode === 'CHOICE') return '填选项代号，如 A。多种答案用 | 分隔，如 A|B';
      if (this.optionMode === 'DRAG') return '填拼好后的词或整句，如 ball 或 What do you need?';
      if (this.isClozeType || this.isBlankChoiceType) return '每空填选项代号，多空用 | 连起来，如 A|B|C';
      if (this.isFillBlanksType) return '每空填短语，多空用 | 连起来；答案里有分号也不要拆成多空';
      if (this.isWordFormType) return '每空填变化后的词形，多空用 ; 连起来，如 is coloring; wrote; do';
      if (this.blanks.length) return '可与各空答案一致；多空用 | 连起来，如 hiking|camping';
      return '选择题填 A；判断填 T 或 F；拼写填单词；多种答案用 | 分隔';
    },
    answerHint: function answerHint() {
      if (this.optionMode === 'CHOICE') {
        return '判分只认选项代号，不要填选项文字。例如正确答案是 A，这里就填 A。';
      }
      if (this.optionMode === 'DRAG') {
        return '判分比对拼好后的完整词或整句，和上面拖拽词块顺序无关。';
      }
      if (this.isClozeType || this.isBlankChoiceType) {
        return '每问一个选项代号，多问用 | 分隔。';
      }
      if (this.isFillBlanksType) {
        return '每空填短语，多空用 | 分隔。答案里的分号是短语的一部分，不要按分号拆空。';
      }
      if (this.isWordFormType) {
        return '词库在上面选项里。判分按分号拆空，填变化后的词形，不是词库原词。';
      }
      if (this.blanks.length) {
        return '每空的词已写在上面「填空」里。这里仍建议填一份判分答案，多空用 | 分隔。';
      }
      return '客观题判分比对这一栏。选择题填代号 A；判断填 T 或 F；拼写/填空填单词。多种可接受答案用 | 分隔。';
    },
    editTypeOptions: function editTypeOptions() {
      var skill = this.form && this.form.skill;
      var list = [];
      var seen = {};(this.editQuestionTypes || []).forEach(function (t) {
        if (!t || seen[t]) return;
        seen[t] = true;
        list.push({ value: t, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(t, skill) });
      });
      var cur = this.form && this.form.questionType;
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(cur, skill) });
      }
      return list;
    },
    subSkillEnOptions: function subSkillEnOptions() {
      return this.buildSubSkillOptions('en');
    },
    subSkillCnOptions: function subSkillCnOptions() {
      return this.buildSubSkillOptions('cn');
    }
  },
  watch: {
    optionMode: function optionMode(val) {
      if (((this.form.questionType || '') === 'Cloze' || (this.form.questionType || '') === 'Fill in the Blanks' || this.isBlankChoiceType) && val !== 'NONE') {
        this.optionMode = 'NONE';
        this.choiceOptions = [];
        this.dragTokens = [];
        return;
      }
      if (val === 'CHOICE' && !this.choiceOptions.length) {
        this.choiceOptions = [{ code: 'A', text: '', image: '' }, { code: 'B', text: '', image: '' }, { code: 'C', text: '', image: '' }, { code: 'D', text: '', image: '' }];
      }
      if (val === 'DRAG' && !this.dragTokens.length) {
        this.dragTokens = [{ value: '' }];
      }
    }
  },
  created: function created() {
    this.loadQuestionTypes();
  },

  methods: {
    questionTypeLabel: __WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */],
    skillLabel: __WEBPACK_IMPORTED_MODULE_6__mex_question_type__["a" /* skillLabel */],
    renderStem: function renderStem(h, stem) {
      var text = stem || '';
      if (!text) return h('span', '—');
      return h('Poptip', {
        props: { trigger: 'click', transfer: true, placement: 'bottom', width: 480, wordWrap: true }
      }, [h('a', {
        style: {
          display: 'inline-block',
          maxWidth: '220px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'bottom'
        }
      }, text), h('div', {
        slot: 'content',
        style: {
          maxHeight: '360px',
          overflow: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          lineHeight: '22px'
        }
      }, text)]);
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    loadQuestionTypes: function loadQuestionTypes() {
      var _this2 = this;

      this.$http.post('/mex/comp/questions/types', { skill: this.queryParam.skill }).then(function (res) {
        _this2.questionTypes = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this2.questionTypes = [];
      });
    },
    loadEditQuestionTypes: function loadEditQuestionTypes() {
      var _this3 = this;

      this.$http.post('/mex/comp/questions/types', { skill: this.form.skill }).then(function (res) {
        _this3.editQuestionTypes = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this3.editQuestionTypes = [];
      });
    },
    loadEditSubSkills: function loadEditSubSkills() {
      var _this4 = this;

      this.$http.post('/mex/comp/questions/sub-skills', { skill: this.form.skill }).then(function (res) {
        _this4.editSubSkills = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this4.editSubSkills = [];
      });
    },
    buildSubSkillOptions: function buildSubSkillOptions(field) {
      var list = [];
      var seen = {};(this.editSubSkills || []).forEach(function (item) {
        var value = field === 'en' ? item.en : item.cn;
        if (!value || seen[value]) return;
        seen[value] = true;
        list.push({ value: value, label: value });
      });
      var cur = field === 'en' ? this.form.subSkillEn : this.form.subSkillCn;
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: cur });
      }
      return list;
    },
    findSubSkillBy: function findSubSkillBy(field, value) {
      if (!value) return null;
      var rows = this.editSubSkills || [];
      for (var i = 0; i < rows.length; i++) {
        if ((field === 'en' ? rows[i].en : rows[i].cn) === value) {
          return rows[i];
        }
      }
      return null;
    },
    onSubSkillEnChange: function onSubSkillEnChange(en) {
      var _this5 = this;

      if (this.skipSubSkillSync) return;
      var pair = this.findSubSkillBy('en', en);
      if (pair && pair.cn && this.form.subSkillCn !== pair.cn) {
        this.skipSubSkillSync = true;
        this.form.subSkillCn = pair.cn;
        this.$nextTick(function () {
          _this5.skipSubSkillSync = false;
        });
      }
    },
    onSubSkillCnChange: function onSubSkillCnChange(cn) {
      var _this6 = this;

      if (this.skipSubSkillSync) return;
      var pair = this.findSubSkillBy('cn', cn);
      if (pair && pair.en && this.form.subSkillEn !== pair.en) {
        this.skipSubSkillSync = true;
        this.form.subSkillEn = pair.en;
        this.$nextTick(function () {
          _this6.skipSubSkillSync = false;
        });
      }
    },
    onEditQuestionTypeChange: function onEditQuestionTypeChange() {
      this.syncDimensionsToType();
    },
    onFormSkillChange: function onFormSkillChange() {
      this.loadEditQuestionTypes();
      this.loadEditSubSkills();
      this.syncDimensionsToType();
    },
    statusLabel: function statusLabel(code) {
      if (code === 'PENDING_REVIEW') return '待审核 PENDING_REVIEW';
      if (code === 'ONLINE') return '已上线 ONLINE';
      if (code === 'OFFLINE') return '已下线 OFFLINE';
      if (code === 'DISCARDED') return '已废弃 DISCARDED';
      return code || '';
    },
    examSceneLabel: function examSceneLabel(code) {
      if (code === 'GENERAL') return '通用 GENERAL';
      if (code === 'PLACEMENT_ONLY') return '仅入门测 PLACEMENT_ONLY';
      if (code === 'SUMMATIVE_ONLY') return '仅阶段测 SUMMATIVE_ONLY';
      return code || '';
    },
    dimLabel: function dimLabel(key) {
      if (key === 'correctness') return '正确性';
      if (key === 'content') return '内容';
      if (key === 'logic') return '逻辑';
      if (key === 'grammar') return '语法';
      if (key === 'vocab') return '词汇';
      if (key === 'accuracy') return '准确度';
      if (key === 'fluency') return '流利度';
      if (key === 'completeness') return '完整度';
      return key;
    },
    isWriteSubjective: function isWriteSubjective(skill, questionType) {
      if (skill !== 'Writing') return false;
      var t = questionType || '';
      return t.indexOf('Picture Writing') >= 0 || t.indexOf('Practical Writing') >= 0 || t.indexOf('Guided Writing') >= 0;
    },
    defaultDimensions: function defaultDimensions(skill, questionType) {
      if (this.isWriteSubjective(skill, questionType)) {
        return [{ key: 'content', weight: 30 }, { key: 'logic', weight: 20 }, { key: 'grammar', weight: 30 }, { key: 'vocab', weight: 20 }];
      }
      return [{ key: 'correctness', weight: 100 }];
    },
    toPercent: function toPercent(val) {
      var n = Number(val);
      if (isNaN(n)) return 0;
      if (n > 1) return n;
      return Math.round(n * 1000) / 10;
    },
    parseDimensions: function parseDimensions(raw, skill, questionType) {
      var _this7 = this;

      var defaults = this.defaultDimensions(skill, questionType);
      if (!raw) return defaults;
      try {
        var obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) !== 'object' || obj.length != null) {
          this.$Message.warning('原评分维度无法解析，已套用默认值');
          return defaults;
        }
        var used = {};
        var list = defaults.map(function (item) {
          used[item.key] = true;
          var val = obj[item.key];
          return {
            key: item.key,
            weight: val == null ? item.weight : _this7.toPercent(val)
          };
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (!used[key]) {
            list.push({ key: key, weight: _this7.toPercent(obj[key]) });
          }
        });
        return list;
      } catch (e) {
        this.$Message.warning('原评分维度无法解析，已套用默认值');
        return defaults;
      }
    },
    stringifyDimensions: function stringifyDimensions() {
      var obj = {};
      this.dimensions.forEach(function (item) {
        if (item.key) {
          obj[item.key] = Math.round((Number(item.weight) || 0) * 10) / 1000;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj);
    },
    nextChoiceCode: function nextChoiceCode() {
      var used = {};
      this.choiceOptions.forEach(function (item) {
        used[item.code] = true;
      });
      for (var i = 0; i < this.optionCodes.length; i++) {
        if (!used[this.optionCodes[i]]) return this.optionCodes[i];
      }
      return this.optionCodes[this.choiceOptions.length % this.optionCodes.length];
    },
    emptyChoice: function emptyChoice() {
      return { code: this.nextChoiceCode(), text: '', image: '' };
    },
    resetOptions: function resetOptions() {
      this.optionMode = 'NONE';
      this.choiceOptions = [];
      this.dragTokens = [];
    },
    parseOptions: function parseOptions(raw) {
      var _this8 = this;

      this.resetOptions();
      if (!raw) return;
      try {
        var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (Array.isArray(data)) {
          if (!data.length) return;
          if ((this.form.questionType || '') === 'Cloze' || (this.form.questionType || '') === 'Gap Fill' || (this.form.questionType || '') === 'Fill in the Blanks' || this.isBlankChoiceType) {
            this.optionMode = 'NONE';
            this.choiceOptions = [];
            return;
          }
          if ((this.form.questionType || '') === 'Picture Writing - Four Panel Story') {
            this.optionMode = 'NONE';
            this.choiceOptions = [];
            return;
          }
          var dragTokens = this.tokensFromMisimportedChoice(data);
          if (dragTokens) {
            this.optionMode = 'DRAG';
            this.dragTokens = dragTokens;
            return;
          }
          this.optionMode = 'CHOICE';
          this.choiceOptions = data.map(function (item, i) {
            if (typeof item === 'string') {
              return { code: _this8.optionCodes[i] || String(i + 1), text: item, image: '' };
            }
            return {
              code: item.code || _this8.optionCodes[i] || '',
              text: item.text || '',
              image: item.image || ''
            };
          });
          return;
        }
        if (data && (data.mode === 'DRAG' || data.tokens)) {
          this.optionMode = 'DRAG';
          var tokens = data.tokens || [];
          this.dragTokens = tokens.map(function (t) {
            return { value: t == null ? '' : String(t) };
          });
          if (!this.dragTokens.length) {
            this.dragTokens = [{ value: '' }];
          }
          return;
        }
        this.$Message.warning('原选项无法按选择题或拖拽解析，已清空');
      } catch (e) {
        this.$Message.warning('原选项无法解析，已清空');
      }
    },
    isDragTokenType: function isDragTokenType(type) {
      var t = type || '';
      return t.indexOf('Drag Letters') === 0 || t === 'Sequence - Sentence Ordering';
    },
    tokensFromMisimportedChoice: function tokensFromMisimportedChoice(data) {
      if (!this.isDragTokenType(this.form.questionType) || !data || data.length !== 1) return null;
      var text = (typeof data[0] === 'string' ? data[0] : data[0].text || '').replace(/｜/g, '|');
      if (text.indexOf('|') < 0) return null;
      var tokens = text.split('|').map(function (s) {
        return s.trim();
      }).filter(function (s) {
        return s;
      }).map(function (v) {
        return { value: v };
      });
      return tokens.length ? tokens : null;
    },
    stringifyOptions: function stringifyOptions() {
      var _this9 = this;

      if (this.optionMode === 'DRAG') {
        var tokens = this.dragTokens.map(function (item) {
          return (item.value || '').trim();
        }).filter(function (v) {
          return v;
        });
        if (!tokens.length) return '[]';
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ mode: 'DRAG', tokens: tokens });
      }
      if (this.optionMode !== 'CHOICE') return '[]';
      var list = this.choiceOptions.filter(function (item) {
        return item.code && (item.text || !_this9.isWordFormType && item.image);
      }).map(function (item) {
        if (_this9.isWordFormType) {
          return {
            code: item.code,
            text: item.text || ''
          };
        }
        return {
          code: item.code,
          text: item.text || '',
          image: item.image || ''
        };
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(list);
    },
    addChoice: function addChoice() {
      this.choiceOptions.push(this.emptyChoice());
    },
    removeChoice: function removeChoice(idx) {
      this.choiceOptions.splice(idx, 1);
    },
    addDrag: function addDrag() {
      this.dragTokens.push({ value: '' });
    },
    removeDrag: function removeDrag(idx) {
      if (this.dragTokens.length <= 1) {
        this.dragTokens = [{ value: '' }];
        return;
      }
      this.dragTokens.splice(idx, 1);
    },
    nextBlankNo: function nextBlankNo() {
      var max = 0;
      this.blanks.forEach(function (item) {
        var n = Number(item.no) || 0;
        if (n > max) max = n;
      });
      return max + 1;
    },
    parseBlanks: function parseBlanks(raw) {
      var _this10 = this;

      this.blanks = [];
      if (!raw) return;
      try {
        var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!data || !data.length) return;
        this.blanks = data.map(function (item, i) {
          if (typeof item === 'string') {
            return { no: i + 1, prompt: '', answer: item, explanation: '' };
          }
          return {
            no: item.no == null ? i + 1 : Number(item.no),
            prompt: item.prompt || '',
            answer: item.answer || '',
            explanation: item.explanation || '',
            options: _this10.normalizeBlankOptions(item.options)
          };
        });
      } catch (e) {
        this.$Message.warning('原填空无法解析，已清空');
        this.blanks = [];
      }
    },
    stringifyBlanks: function stringifyBlanks() {
      var _this11 = this;

      var list = this.blanks.filter(function (item) {
        return item.prompt || item.answer || item.explanation || item.options && item.options.length;
      }).map(function (item) {
        var row = {
          no: Number(item.no) || 0,
          prompt: item.prompt || '',
          answer: item.answer || '',
          explanation: item.explanation || ''
        };
        if (_this11.isClozeType || _this11.isBlankChoiceType) {
          row.options = _this11.normalizeBlankOptions(item.options);
        }
        return row;
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(list);
    },
    addBlank: function addBlank() {
      this.blanks.push(this.emptyBlank());
    },
    emptyBlank: function emptyBlank() {
      var row = { no: this.nextBlankNo(), prompt: '', answer: '', explanation: '' };
      if (this.isClozeType || this.isBlankChoiceType) {
        row.options = this.defaultBlankOptions();
      }
      return row;
    },
    defaultBlankOptions: function defaultBlankOptions() {
      if (this.isGapFillType) {
        return ['A', 'B', 'C', 'D', 'E', 'F', 'G'].map(function (c) {
          return { code: c, text: '', image: '' };
        });
      }
      return [{ code: 'A', text: '', image: '' }, { code: 'B', text: '', image: '' }, { code: 'C', text: '', image: '' }, { code: 'D', text: '', image: '' }];
    },
    normalizeBlankOptions: function normalizeBlankOptions(raw) {
      var _this12 = this;

      if (!raw || !raw.length) {
        return this.isClozeType || this.isBlankChoiceType ? this.defaultBlankOptions() : [];
      }
      return raw.map(function (item, i) {
        if (typeof item === 'string') {
          return { code: _this12.optionCodes[i] || String(i + 1), text: item, image: '' };
        }
        return {
          code: item.code || _this12.optionCodes[i] || '',
          text: item.text || '',
          image: item.image || ''
        };
      });
    },
    hydrateClozeBlanks: function hydrateClozeBlanks() {
      var _this13 = this;

      var t = this.form.questionType || '';
      if (t === 'Cloze' || t === 'Gap Fill' || t === 'Fill in the Blanks' || this.isPassageMcqType && this.blanks.length) {
        this.optionMode = 'NONE';
        this.choiceOptions = [];
      }
      if (t === 'Picture Writing - Four Panel Story') {
        this.optionMode = 'NONE';
        this.choiceOptions = [];
      }
      if (t === 'Cloze' || t === 'Gap Fill' || this.isPassageMcqType && this.blanks.length) {
        this.blanks.forEach(function (item) {
          item.options = _this13.normalizeBlankOptions(item.options);
        });
      }
    },
    splitClozeExplanation: function splitClozeExplanation(raw) {
      if (!raw) return [];
      var text = String(raw).trim();
      var chunks = [];
      if (/^(?:空\s*)?\d+[.)．、:：\s]/m.test(text)) {
        chunks = text.split(/(?=^(?:空\s*)?\d+[.)．、:：\s])/m);
      } else if (text.indexOf(';') >= 0 || text.indexOf('；') >= 0) {
        chunks = text.split(/[;；]/);
      } else {
        chunks = [text];
      }
      return chunks.map(function (s) {
        return s.replace(/^(?:空\s*)?(?:[A-Da-d]|\d+)[.)．、:：\-\s]+/, '').trim();
      }).filter(function (s) {
        return s;
      });
    },
    joinClozeExplanation: function joinClozeExplanation() {
      return this.blanks.filter(function (item) {
        return item.explanation;
      }).map(function (item, i) {
        return (item.no || i + 1) + '. ' + item.explanation;
      }).join('\n');
    },
    removeBlank: function removeBlank(idx) {
      this.blanks.splice(idx, 1);
    },
    syncDimensionsToType: function syncDimensionsToType() {
      if (this.skipDimSync) return;
      var prev = {};
      this.dimensions.forEach(function (item) {
        prev[item.key] = item.weight;
      });
      this.dimensions = this.defaultDimensions(this.form.skill, this.form.questionType).map(function (item) {
        return {
          key: item.key,
          weight: prev[item.key] == null ? item.weight : prev[item.key]
        };
      });
    },
    search: function search() {
      var _this14 = this;

      this.selection = [];
      this.reload = Date.now();
      this.$nextTick(function () {
        if (_this14.$refs.list) {
          _this14.$refs.list.search();
        }
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selection = selection || [];
    },
    openBatch: function openBatch() {
      this.batchVisible = true;
    },
    openBankInspect: function openBankInspect() {
      var _this15 = this;

      this.inspectLoading = true;
      this.inspectVisible = true;
      this.$http.get('/mex/placement/bank/inspect').then(function (res) {
        _this15.inspectLoading = false;
        if (res.status === 'ok') {
          _this15.inspectReport = res.data || {};
          var issues = _this15.inspectReport.issues || [];
          _this15.inspectRows = issues.map(function (row) {
            return {
              code: row.code || '',
              bank: row.bank || '',
              id: row.id == null ? '' : row.id,
              level: row.level || '',
              skill: row.skill || '',
              band: row.band || '',
              count: row.count == null ? '' : row.count,
              detail: row.detail || ''
            };
          });
        } else {
          _this15.$Message.error(res.msg || '自检失败');
        }
      }).catch(function () {
        _this15.inspectLoading = false;
        _this15.$Message.error('自检失败');
      });
    },
    escapeHtml: function escapeHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    showImportResult: function showImportResult(d, prefix) {
      var _this16 = this;

      var data = d || {};
      var msg = (prefix || '导入') + '成功 ' + (data.successCount || 0) + '，跳过 ' + (data.skipCount || 0) + '，失败 ' + (data.failCount || 0);
      var rows = data.failRows || [];
      if (rows.length) {
        var body = rows.map(function (r) {
          return _this16.escapeHtml(r);
        }).join('<br>');
        this.$Modal.warning({
          title: '导入结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        });
      } else {
        this.$Message.success(msg);
      }
    },
    triggerImport: function triggerImport(skill) {
      this.importSkill = skill;
      this.$refs.fileInput.click();
    },
    downloadTemplate: function downloadTemplate() {
      var _this17 = this;

      this.$http.get('/mex/comp/questions/template', { responseType: 'arraybuffer' }).then(function (res) {
        var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '综合题库导入模板.xlsx';
        link.click();
      }).catch(function () {
        _this17.$Message.error('模板下载失败');
      });
    },
    importData: function importData(event) {
      var _this18 = this;

      var file = event.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('skill', this.importSkill);
      this.$http.post('/mex/comp/questions/import', formData, { transformRequest: [] }).then(function (res) {
        if (res.status === 'ok') {
          _this18.showImportResult(res.data, _this18.importSkill);
          _this18.loadQuestionTypes();
          _this18.search();
        } else {
          _this18.$Message.error(res.msg || '导入失败');
        }
        _this18.$refs.fileInput.value = '';
      }).catch(function () {
        _this18.$Message.error('导入失败');
        _this18.$refs.fileInput.value = '';
      });
    },
    triggerIrt: function triggerIrt() {
      this.$refs.irtInput.click();
    },
    importIrt: function importIrt(event) {
      var _this19 = this;

      var file = event.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      this.$http.post('/mex/comp/questions/irt', formData, { transformRequest: [] }).then(function (res) {
        if (res.status === 'ok') {
          _this19.showImportResult(res.data, 'IRT');
          _this19.search();
        } else {
          _this19.$Message.error(res.msg || 'IRT 回填失败');
        }
        _this19.$refs.irtInput.value = '';
      }).catch(function () {
        _this19.$Message.error('IRT 回填失败');
        _this19.$refs.irtInput.value = '';
      });
    },
    openCreate: function openCreate() {
      var _this20 = this;

      this.createMode = true;
      this.businessCode = '';
      this.versions = [];
      this.selectedVersionId = null;
      this.skipDimSync = true;
      this.form = {
        skill: 'Listening',
        levelCode: 'L1.0',
        examScene: 'GENERAL',
        questionType: '',
        stem: '',
        versionNo: 'v1.0',
        status: 'PENDING_REVIEW'
      };
      this.dimensions = this.defaultDimensions(this.form.skill, this.form.questionType);
      this.resetOptions();
      this.blanks = [];
      this.editVisible = true;
      this.loadEditQuestionTypes();
      this.loadEditSubSkills();
      this.$nextTick(function () {
        _this20.skipDimSync = false;
      });
    },
    applyDetail: function applyDetail(data) {
      var _this21 = this;

      this.skipDimSync = true;
      this.businessCode = data.businessCode;
      this.form = data.comp || {};
      this.dimensions = this.parseDimensions(this.form.dimensionsJson, this.form.skill, this.form.questionType);
      this.parseBlanks(this.form.blanksJson);
      this.parseOptions(this.form.optionsJson);
      this.hydrateClozeBlanks();
      this.versions = data.versions || [];
      this.selectedVersionId = this.form.id;
      this.createMode = false;
      this.editVisible = true;
      this.loadEditQuestionTypes();
      this.loadEditSubSkills();
      this.$nextTick(function () {
        _this21.skipDimSync = false;
      });
    },
    openEdit: function openEdit(row) {
      var _this22 = this;

      this.$http.post('/mex/comp/questions/detail', { versionId: row.currentVersionId }).then(function (res) {
        if (res.status === 'ok' && res.data && res.data.comp) {
          _this22.applyDetail(res.data);
        } else {
          _this22.$Message.error(res.msg || '加载失败');
        }
      });
    },
    switchVersion: function switchVersion(versionId) {
      var _this23 = this;

      if (!versionId || versionId === this.form.id) return;
      this.$http.post('/mex/comp/questions/detail', { versionId: versionId }).then(function (res) {
        if (res.status === 'ok' && res.data && res.data.comp) {
          _this23.applyDetail(res.data);
        } else {
          _this23.$Message.error(res.msg || '加载失败');
        }
      });
    },
    savePayload: function savePayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.reviewedAt;
      delete payload.reviewer;
      delete payload.checksum;
      return payload;
    },
    saveEdit: function saveEdit() {
      var _this24 = this;

      this.form.dimensionsJson = this.stringifyDimensions();
      this.form.optionsJson = this.stringifyOptions();
      this.form.blanksJson = this.stringifyBlanks();
      if (this.isClozeType || this.isFillBlanksType || this.isBlankChoiceType) {
        this.form.optionsJson = '[]';
        this.form.explanation = this.joinClozeExplanation();
        if (this.blanks.length) {
          this.form.answerKey = this.blanks.filter(function (item) {
            return item.answer;
          }).map(function (item) {
            return item.answer;
          }).join('|');
        }
      } else if (this.isWordFormType) {
        this.form.explanation = this.joinClozeExplanation();
        if (this.blanks.length) {
          this.form.answerKey = this.blanks.filter(function (item) {
            return item.answer;
          }).map(function (item) {
            return item.answer;
          }).join(';');
        }
      }
      if (this.createMode) {
        var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.savePayload(), { businessCode: this.businessCode });
        this.$http.post('/mex/comp/questions/create', payload).then(function (res) {
          if (res.status === 'ok') {
            _this24.$Message.success('已新建，待审核上线');
            _this24.editVisible = false;
            _this24.loadQuestionTypes();
            _this24.search();
          } else {
            _this24.$Message.error(res.msg || '保存失败');
          }
        });
        return;
      }
      this.$http.post('/mex/comp/questions/save', this.savePayload()).then(function (res) {
        if (res.status === 'ok') {
          _this24.$Message.success(_this24.form.status === 'ONLINE' ? '已升版本，待审核上线' : '已保存');
          _this24.editVisible = false;
          _this24.loadQuestionTypes();
          _this24.search();
        } else {
          _this24.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(row, action) {
      var _this25 = this;

      if (action === 'online') {
        this.$Modal.confirm({
          title: '确认上线',
          content: '上线该版本后，同一题目其它已上线版本会自动下线。',
          onOk: function onOk() {
            return _this25.doChangeStatus(row, action);
          }
        });
        return;
      }
      this.doChangeStatus(row, action);
    },
    doChangeStatus: function doChangeStatus(row, action) {
      var _this26 = this;

      this.$http.post('/mex/comp/questions/' + action, { versionId: row.currentVersionId }).then(function (res) {
        if (res.status === 'ok') {
          _this26.$Message.success('已更新');
          _this26.search();
        } else {
          _this26.$Message.error(res.msg || '操作失败');
        }
      });
    },
    discard: function discard(row) {
      var _this27 = this;

      this.$Modal.confirm({
        title: '废弃版本',
        content: '确认废弃该版本？已上线须先下线。不能回滚，只能再上线其它版本。',
        onOk: function onOk() {
          _this27.$http.post('/mex/comp/questions/discard', { versionId: row.currentVersionId }).then(function (res) {
            if (res.status === 'ok') {
              _this27.$Message.success('已废弃');
              _this27.search();
            } else {
              _this27.$Message.error(res.msg || '操作失败');
            }
          });
        }
      });
    },
    markAnchor: function markAnchor(row) {
      var _this28 = this;

      this.$http.post('/mex/comp/questions/anchor', {
        versionId: row.currentVersionId,
        isAnchor: row.isAnchor === 1 ? 0 : 1
      }).then(function (res) {
        if (res.status === 'ok') {
          _this28.$Message.success('已更新锚题');
          _this28.search();
        } else {
          _this28.$Message.error(res.msg || '操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mex_question_type__ = __webpack_require__(40);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexFeedbackList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      batchLoading: false,
      reload: 0,
      detailVisible: false,
      queryParam: {},
      detail: {},
      handleRemark: '',
      handleMethod: '',
      selection: [],
      tableColumns: [{ type: 'selection', width: 60, align: 'center' }, { title: 'ID', key: 'id', width: 80, ellipsis: true }, { title: '提交时间', key: 'gmtCreate', width: 160, ellipsis: true }, { title: '学员', key: 'studentName', width: 120, ellipsis: true }, { title: 'uid', key: 'uid', width: 90, ellipsis: true }, { title: '场次', key: 'sessionId', width: 90, ellipsis: true }, { title: '题目编码', key: 'questionCode', width: 160, ellipsis: true }, { title: '技能', key: 'skill', width: 140, ellipsis: true, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_question_type__["a" /* skillLabel */])(p.row.skill));
        } }, {
        title: '类型',
        key: 'feedbackType',
        width: 140,
        ellipsis: true,
        render: function render(h, params) {
          return h('span', _this.typeLabel(params.row.feedbackType));
        }
      }, { title: '内容', key: 'content', width: 240, ellipsis: true }, {
        title: '状态',
        key: 'handleStatus',
        width: 90,
        ellipsis: true,
        render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.handleStatus));
        }
      }, {
        title: '处理方式',
        key: 'handleMethod',
        width: 140,
        ellipsis: true,
        render: function render(h, params) {
          return h('span', _this.methodLabel(params.row.handleMethod));
        }
      }, { title: '处理人', key: 'handlerName', width: 100, ellipsis: true }, { title: '处理时间', key: 'handledAt', width: 160, ellipsis: true }, {
        title: '操作',
        key: 'action',
        width: 100,
        render: function render(h, params) {
          return h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.openDetail(params.row);
              } }
          }, '处理');
        }
      }]
    };
  },

  computed: {
    canHandle: function canHandle() {
      var s = this.detail && this.detail.handleStatus;
      return s === 'PENDING' || s === 'PROCESSING';
    },
    images: function images() {
      var raw = this.detail && this.detail.imagesJson;
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      try {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
  },
  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    statusLabel: function statusLabel(code) {
      if (code === 'PENDING') return '待处理';
      if (code === 'PROCESSING') return '处理中';
      if (code === 'DONE') return '已处理';
      if (code === 'REJECTED') return '不成立';
      return code || '';
    },
    methodLabel: function methodLabel(code) {
      var map = {
        FIX_CONTENT: '已改正文/选项/答案',
        FIX_ASSET: '已替换音频或图片',
        OFFLINE: '已下线题目',
        NO_ISSUE: '题目无误',
        CONTACT: '已联系学员/家长',
        OTHER: '其他'
      };
      return map[code] || code || '—';
    },
    typeLabel: function typeLabel(code) {
      var map = {
        STEM_ERROR: '题干错误',
        OPTION_ERROR: '选项错误',
        AUDIO_ERROR: '音频错误',
        IMAGE_ERROR: '图片错误',
        ANSWER_ERROR: '答案或解析错误',
        DISPLAY_ERROR: '展示异常',
        OTHER: '其他'
      };
      return map[code] || code || '';
    },
    examLabel: function examLabel(code) {
      if (code === 'PLACEMENT') return '入门测';
      if (code === 'SUMMATIVE') return '阶段测';
      return code || '';
    },

    skillLabel: __WEBPACK_IMPORTED_MODULE_0__mex_question_type__["a" /* skillLabel */],
    search: function search() {
      var _this2 = this;

      this.selection = [];
      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selection = selection || [];
    },
    batchOffline: function batchOffline() {
      var _this3 = this;

      var rows = this.selection || [];
      if (!rows.length) {
        this.$Message.warning('请先勾选反馈');
        return;
      }
      var ids = rows.map(function (r) {
        return r.id;
      }).filter(function (id) {
        return id != null;
      });
      if (!ids.length) {
        this.$Message.warning('请先勾选反馈');
        return;
      }
      this.$Modal.confirm({
        title: '批量下线',
        content: '将对勾选的 ' + ids.length + ' 条反馈：状态改为已处理、方式改为已下线题目，并同步下线对应题目。确认继续？',
        onOk: function onOk() {
          _this3.batchLoading = true;
          return _this3.$http.post('/mex/feedback/batchOffline', {
            ids: ids.join(','),
            handleRemark: '批量下线'
          }).then(function (res) {
            _this3.batchLoading = false;
            if (res.status === 'ok') {
              var msg = res.data && res.data.message || '已批量下线';
              _this3.$Message.success(msg);
              _this3.selection = [];
              _this3.search();
            } else {
              _this3.$Message.error(res.msg || '批量下线失败');
            }
          }).catch(function () {
            _this3.batchLoading = false;
          });
        }
      });
    },
    jumpToQuestion: function jumpToQuestion() {
      var d = this.detail || {};
      var qid = d.questionId;
      if (qid == null || qid === '') {
        this.$Message.warning('无法定位题目：缺少题头 ID');
        return;
      }
      var bank = String(d.bank || '').toUpperCase();
      var path = '';
      if (bank === 'SPEAK') {
        path = '/mex/speak/questions';
      } else if (bank === 'COMP') {
        path = '/mex/comp/questions';
      } else if (d.skill === 'Speaking') {
        path = '/mex/speak/questions';
      } else if (d.skill) {
        path = '/mex/comp/questions';
      }
      if (!path) {
        this.$Message.warning('无法判断题库类型');
        return;
      }
      var route = this.$router.resolve({ path: path, query: { id: String(qid) } });
      window.open(route.href, '_blank');
    },
    openDetail: function openDetail(row) {
      var _this4 = this;

      this.$http.post('/mex/feedback/detail', { id: row.id }).then(function (res) {
        if (res.status === 'ok' && res.data) {
          _this4.detail = res.data;
          _this4.handleRemark = res.data.handleRemark || '';
          _this4.handleMethod = res.data.handleMethod || '';
          _this4.detailVisible = true;
        } else {
          _this4.$Message.error(res.msg || '加载失败');
        }
      });
    },
    handle: function handle(status) {
      var _this5 = this;

      this.$http.post('/mex/feedback/handle', {
        id: this.detail.id,
        handleStatus: status,
        handleMethod: this.handleMethod,
        handleRemark: this.handleRemark
      }).then(function (res) {
        if (res.status === 'ok') {
          _this5.$Message.success('已更新');
          _this5.detailVisible = false;
          _this5.search();
        } else {
          _this5.$Message.error(res.msg || '处理失败');
        }
      });
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexGraySetting',
  data: function data() {
    var _this = this;

    return {
      saving: false,
      allEnabled: 0,
      adviserId: null,
      sellerId: null,
      studentKeyword: '',
      advisers: [],
      sellers: [],
      students: [],
      ruleColumns: [{ title: 'ID', key: 'id', width: 90, ellipsis: true }, {
        title: '名称',
        key: 'targetName',
        minWidth: 180,
        ellipsis: true,
        render: function render(h, params) {
          return h('span', params.row.targetName || params.row.name || '—');
        }
      }, { title: 'targetId', key: 'targetId', width: 140, ellipsis: true }, {
        title: '操作',
        key: 'action',
        width: 100,
        render: function render(h, params) {
          return h('Button', {
            props: { type: 'error', size: 'small' },
            on: { click: function click() {
                return _this.remove(params.row.id);
              } }
          }, '删除');
        }
      }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var _this2 = this;

      this.$http.post('/mex/gray/get').then(function (res) {
        if (res.status === 'ok') {
          var d = res.data || {};
          _this2.allEnabled = d.allEnabled === true || d.allEnabled === 1 || d.allEnabled === '1' ? 1 : 0;
          _this2.advisers = d.advisers || [];
          _this2.sellers = d.sellers || [];
          _this2.students = d.students || [];
        } else {
          _this2.$Message.error(res.msg || '加载失败');
        }
      });
    },
    onAllChange: function onAllChange(on) {
      var _this3 = this;

      this.saving = true;
      this.$http.post('/mex/gray/saveAll', { enabled: on ? 1 : 0 }).then(function (res) {
        _this3.saving = false;
        if (res.status === 'ok') {
          _this3.$Message.success('已更新');
          _this3.load();
        } else {
          _this3.$Message.error(res.msg || '保存失败');
          _this3.load();
        }
      }).catch(function () {
        _this3.saving = false;
        _this3.$Message.error('保存失败');
        _this3.load();
      });
    },
    addAdviser: function addAdviser() {
      var _this4 = this;

      if (!this.adviserId) {
        this.$Message.error('请选择学导');
        return;
      }
      this.addRule({ scope: 'ADVISER', targetId: this.adviserId }, function () {
        _this4.adviserId = null;
      });
    },
    addSeller: function addSeller() {
      var _this5 = this;

      if (!this.sellerId) {
        this.$Message.error('请选择销售');
        return;
      }
      this.addRule({ scope: 'SELLER', targetId: this.sellerId }, function () {
        _this5.sellerId = null;
      });
    },
    addStudent: function addStudent() {
      var _this6 = this;

      var keyword = (this.studentKeyword || '').trim();
      if (!keyword) {
        this.$Message.error('请输入学生ID或手机号');
        return;
      }
      var payload = { scope: 'UID', keyword: keyword };
      if (/^\d+$/.test(keyword)) {
        payload.targetId = keyword;
      }
      this.addRule(payload, function () {
        _this6.studentKeyword = '';
      });
    },
    addRule: function addRule(payload, onOk) {
      var _this7 = this;

      this.saving = true;
      this.$http.post('/mex/gray/add', payload).then(function (res) {
        _this7.saving = false;
        if (res.status === 'ok') {
          _this7.$Message.success('已添加');
          if (onOk) onOk();
          _this7.load();
        } else {
          _this7.$Message.error(res.msg || '添加失败');
        }
      }).catch(function () {
        _this7.saving = false;
        _this7.$Message.error('添加失败');
      });
    },
    remove: function remove(id) {
      var _this8 = this;

      if (!id) return;
      this.saving = true;
      this.$http.post('/mex/gray/remove', { id: id }).then(function (res) {
        _this8.saving = false;
        if (res.status === 'ok') {
          _this8.$Message.success('已删除');
          _this8.load();
        } else {
          _this8.$Message.error(res.msg || '删除失败');
        }
      }).catch(function () {
        _this8.saving = false;
        _this8.$Message.error('删除失败');
      });
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mex_question_type__ = __webpack_require__(40);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexItemStatsList',
  data: function data() {
    return {
      searchLoading: false,
      reload: 0,
      bank: 'comp',
      queryParam: {},
      tableColumns: [{ title: '题头ID', key: 'questionId', width: 90, ellipsis: true }, { title: '业务键', key: 'businessCode', width: 220, ellipsis: true }, { title: '技能', key: 'skill', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_question_type__["a" /* skillLabel */])(params.row.skill));
        } }, { title: '级别', key: 'levelCode', width: 80, ellipsis: true }, { title: '题型', key: 'questionType', minWidth: 220, ellipsis: true, render: function render(h, params) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_question_type__["b" /* questionTypeLabel */])(params.row.questionType, params.row.skill));
        } }, { title: '曝光', key: 'exposureCount', width: 80, ellipsis: true }, { title: '作答', key: 'answerCount', width: 80, ellipsis: true }, { title: '答对', key: 'correctCount', width: 80, ellipsis: true }, { title: '通过率', key: 'passRate', width: 90, ellipsis: true }, { title: '均时秒', key: 'avgDurationSec', width: 90, ellipsis: true }]
    };
  },

  computed: {
    listUrl: function listUrl() {
      return this.bank === 'speak' ? '/mex/stats/speak' : '/mex/stats/comp';
    }
  },
  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      var _this = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this.$refs.list && _this.$refs.list.search();
      });
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexPromotionList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      tableColumns: [{ title: '场次', key: 'sessionId', width: 90, ellipsis: true }, { title: '学生ID', key: 'uid', width: 100, ellipsis: true }, { title: '当前级别', key: 'courseLevel', width: 90, ellipsis: true }, { title: '场次状态', key: 'status', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status, params.row.publishStatus || params.row.flags));
        } }, { title: '总分', key: 'totalScore', width: 80, ellipsis: true }, { title: '升班建议', key: 'promotion', width: 120, ellipsis: true, render: function render(h, params) {
          return h('span', _this.labelOf(params.row.promotion));
        } }, {
        title: '模块分',
        key: 'moduleJson',
        minWidth: 280,
        render: function render(h, params) {
          return h('span', { style: { whiteSpace: 'normal', lineHeight: '1.4' } }, _this.moduleScoreText(params.row.moduleJson));
        }
      }, { title: '标记', key: 'flags', width: 120, ellipsis: true, render: function render(h, params) {
          return h('span', _this.flagsLabel(params.row.flags));
        } }, { title: '时间', key: 'gmtCreate', width: 170, ellipsis: true }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      var _this2 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    labelOf: function labelOf(code) {
      if (code === 'UP') return '直接升班';
      if (code === 'CONSOLIDATE') return '巩固后升';
      if (code === 'REMEDIATE') return '先补核心';
      if (code === 'REPEAT') return '本级重学';
      return code || '';
    },
    statusLabel: function statusLabel(code, publishOrFlags) {
      if (code === 'CREATED') return '已创建';
      if (code === 'CONSENT') return '待同意公约';
      if (code === 'PROFILE') return '信息采集';
      if (code === 'DEV_AUDIO') return '设备调试（音频）';
      if (code === 'DEV_MIC') return '设备调试（麦克风）';
      if (code === 'IN_PROGRESS') return '答题中';
      if (code === 'PAUSED') return '已暂停';
      if (code === 'SCORING') return '评分中';
      if (code === 'READY') return '已交卷';
      if (code === 'COMPLETED') return '已完成';
      if (code === 'ABANDONED') return '已放弃';
      if (code === 'INCOMPLETE_REF') {
        var pub = publishOrFlags || '';
        if (pub === 'REVIEW' || pub === 'PROVISIONAL' || pub === 'BELOW_L1') return '待复核';
        return '作答不足';
      }
      if (code === 'INVALID') return '已作废';
      return code || '—';
    },
    moduleScoreText: function moduleScoreText(raw) {
      var obj = this.parseModule(raw);
      var keys = [['Listening', '听力'], ['Speaking', '口语'], ['Reading', '阅读'], ['Writing', '写作']];
      var parts = [];
      for (var i = 0; i < keys.length; i++) {
        var en = keys[i][0];
        if (obj[en] === undefined || obj[en] === null || obj[en] === '') continue;
        parts.push(keys[i][1] + ' ' + obj[en]);
      }
      return parts.length ? parts.join(' · ') : '—';
    },
    flagsLabel: function flagsLabel(code) {
      if (code === 'TRIAL') return '试做';
      if (code === 'ABNORMAL_FAST') return '作答过快';
      if (!code) return '—';
      return code;
    },
    parseModule: function parseModule(raw) {
      if (!raw) return {};
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object') return raw;
      try {
        return JSON.parse(raw) || {};
      } catch (e) {
        return {};
      }
    }
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mex_question_type__ = __webpack_require__(40);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexQuestionBatchModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bank: {
      type: String,
      default: 'comp'
    },
    selectedRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    skill: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      saving: false,
      form: this.emptyForm(),
      questionTypes: [],
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0']
    };
  },

  computed: {
    visible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    selectedCount: function selectedCount() {
      return this.selectedIds().length;
    },
    typeSkill: function typeSkill() {
      if (this.bank === 'speak') return 'Speaking';
      return this.form.skill || this.skill || '';
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.form = this.emptyForm();
        this.form.ids = this.selectedIds().join(',');
        this.form.skill = this.skill || '';
        if (this.form.ids) {
          this.form.scope = 'IDS';
        }
        this.loadQuestionTypes();
      }
    }
  },
  methods: {
    questionTypeLabel: __WEBPACK_IMPORTED_MODULE_0__mex_question_type__["b" /* questionTypeLabel */],
    emptyForm: function emptyForm() {
      return {
        scope: 'IDS',
        ids: '',
        levelCodes: [],
        questionType: '',
        skill: '',
        updateEn: false,
        instructionEn: '',
        updateCn: false,
        instructionCn: '',
        statusAction: 'none'
      };
    },
    onScopeChange: function onScopeChange(scope) {
      if (scope !== 'LEVEL') {
        this.form.levelCodes = [];
      }
      if (scope !== 'TYPE') {
        this.form.questionType = '';
      }
    },
    loadQuestionTypes: function loadQuestionTypes() {
      var _this = this;

      var url = this.bank === 'speak' ? '/mex/speak/questions/types' : '/mex/comp/questions/types';
      var payload = {};
      if (this.bank === 'comp' && this.form.skill) {
        payload.skill = this.form.skill;
      }
      this.$http.post(url, payload).then(function (res) {
        if (res.status === 'ok') {
          _this.questionTypes = res.data || [];
        } else {
          _this.questionTypes = [];
        }
        if (_this.form.questionType && _this.questionTypes.indexOf(_this.form.questionType) < 0) {
          _this.form.questionType = '';
        }
      }).catch(function () {
        _this.questionTypes = [];
      });
    },
    selectedIds: function selectedIds() {
      var rows = this.selectedRows || [];
      var ids = [];
      var seen = {};
      rows.forEach(function (row) {
        if (!row) return;
        var id = row.currentVersionId != null ? row.currentVersionId : row.id;
        if (id != null && !seen[id]) {
          seen[id] = true;
          ids.push(id);
        }
      });
      return ids;
    },
    escapeHtml: function escapeHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    scopeHint: function scopeHint() {
      if (this.form.scope === 'IDS') {
        return '将改这些勾选/填写的版本，共 ' + (this.form.ids ? this.form.ids.split(/[,;\s]+/).filter(Boolean).length : 0) + ' 个 ID';
      }
      if (this.form.scope === 'LEVEL') {
        return '将改级别 ' + (this.form.levelCodes || []).join('、') + ' 下全部当前版本';
      }
      return '将改题型「' + this.form.questionType + '」下全部当前版本';
    },
    submit: function submit() {
      var _this2 = this;

      if (this.form.scope === 'IDS' && !this.form.ids) {
        this.$Message.warning('请勾选或填写题目 ID');
        return;
      }
      if (this.form.scope === 'LEVEL' && (!this.form.levelCodes || !this.form.levelCodes.length)) {
        this.$Message.warning('请选择级别');
        return;
      }
      if (this.form.scope === 'TYPE' && !this.form.questionType) {
        this.$Message.warning('请选择题型');
        return;
      }
      if (!this.form.updateEn && !this.form.updateCn && (!this.form.statusAction || this.form.statusAction === 'none')) {
        this.$Message.warning('请至少勾选改指令或选择上线/下线/废弃');
        return;
      }
      this.$Modal.confirm({
        title: '确认批量编辑',
        content: this.scopeHint() + '。已上线须先下线再废弃。',
        onOk: function onOk() {
          return _this2.doSubmit();
        }
      });
    },
    doSubmit: function doSubmit() {
      var _this3 = this;

      var url = this.bank === 'speak' ? '/mex/speak/questions/batch' : '/mex/comp/questions/batch';
      var payload = {
        scope: this.form.scope,
        ids: this.form.ids,
        levelCode: (this.form.levelCodes || []).join(','),
        questionType: this.form.questionType,
        skill: this.form.skill,
        updateInstructionEn: this.form.updateEn ? 1 : 0,
        instructionEn: this.form.instructionEn,
        updateInstructionCn: this.form.updateCn ? 1 : 0,
        instructionCn: this.form.instructionCn,
        statusAction: this.form.statusAction === 'none' ? '' : this.form.statusAction
      };
      this.saving = true;
      this.$http.post(url, payload).then(function (res) {
        _this3.saving = false;
        if (res.status === 'ok') {
          _this3.showResult(res.data);
          _this3.visible = false;
          _this3.$emit('success');
        } else {
          _this3.$Message.error(res.msg || '批量编辑失败');
        }
      }).catch(function () {
        _this3.saving = false;
        _this3.$Message.error('批量编辑失败');
      });
    },
    showResult: function showResult(d) {
      var _this4 = this;

      var data = d || {};
      var msg = '成功 ' + (data.successCount || 0) + '，失败 ' + (data.failCount || 0);
      var rows = data.failRows || [];
      if (rows.length) {
        var body = rows.map(function (r) {
          return _this4.escapeHtml(r);
        }).join('<br>');
        this.$Modal.warning({
          title: '批量编辑结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        });
      } else {
        this.$Message.success(data.message || msg);
      }
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexScoreCohortList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      tableColumns: [{ title: 'ID', key: 'id', width: 80, ellipsis: true }, { title: '考试类型', key: 'examType', width: 120, ellipsis: true, render: function render(h, params) {
          return h('span', _this.examTypeLabel(params.row.examType));
        } }, { title: '年龄档', key: 'ageBand', width: 140, ellipsis: true, render: function render(h, params) {
          return h('span', _this.ageBandLabel(params.row.ageBand));
        } }, { title: '城市码', key: 'cityCode', width: 120, ellipsis: true }, { title: '样本 n', key: 'sampleN', width: 100, ellipsis: true }, { title: '平均分', key: 'avgScore', width: 100, ellipsis: true }, { title: '更新时间', key: 'gmtModified', width: 180, ellipsis: true }]
    };
  },

  methods: {
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      var _this2 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this2.$refs.list && _this2.$refs.list.search();
      });
    },
    examTypeLabel: function examTypeLabel(code) {
      if (code === 'PLACEMENT') return '入门测';
      if (code === 'SUMMATIVE') return '阶段测';
      return code || '—';
    },
    ageBandLabel: function ageBandLabel(code) {
      if (code === 'LOW') return '低档（3-5）';
      if (code === 'MID') return '中档（6-8）';
      if (code === 'HIGH') return '高档（9+）';
      return code || '—';
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mex_question_type__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mex_asset__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MexSessionReport__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MexSessionReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MexSessionReport__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexSessionList',
  components: { MexSessionReport: __WEBPACK_IMPORTED_MODULE_3__MexSessionReport___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      replayVisible: false,
      replay: null,
      reportVisible: false,
      report: null,
      fullTextVisible: false,
      fullTextTitle: '',
      fullText: '',
      moduleColumns: [{ title: '技能', key: 'label', width: 160 }, { title: '百分制', key: 'score', width: 120 }],
      itemColumns: [{ type: 'expand', width: 50, render: function render(h, p) {
          return _this.renderExpand(h, p.row);
        } }, { title: '序', key: 'seq', width: 50, ellipsis: true }, { title: '库', key: 'bank', width: 80, ellipsis: true, render: function render(h, p) {
          return h('span', _this.bankLabel(p.row.bank));
        } }, { title: '业务键', key: 'businessCode', width: 180, ellipsis: true }, { title: '题型', key: 'questionType', width: 340, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mex_question_type__["b" /* questionTypeLabel */])(p.row.questionType, p.row.bank === 'SPEAK' ? 'Speaking' : p.row.skill));
        } }, { title: '抽题', key: 'catReason', width: 90, ellipsis: true, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mex_question_type__["c" /* catReasonLabel */])(p.row.catReason));
        } }, { title: '学生作答', key: 'studentPayload', width: 220, ellipsis: true, render: function render(h, p) {
          return _this.renderFullTextCell(h, p.row.studentPayload, '学生作答');
        } }, { title: '标准答案', key: 'answerKey', width: 160, ellipsis: true, render: function render(h, p) {
          return _this.renderFullTextCell(h, p.row.answerKey, '标准答案');
        } }, { title: '得分', key: 'rawScore', width: 70, ellipsis: true }, { title: '掌握', key: 'mastered', width: 60, ellipsis: true }, { title: '跳过', key: 'skipped', width: 60, ellipsis: true }, {
        title: '音频',
        key: 'audioUrl',
        width: 80,
        render: function render(h, params) {
          var url = params.row.audioUrl;
          if (!url) return h('span', '');
          return h('a', { attrs: { href: url, target: '_blank' } }, '打开');
        }
      }],
      queryParam: {},
      tableColumns: [{ title: 'ID', key: 'id', width: 80, ellipsis: true }, { title: '来源', key: 'algoVersion', width: 80, ellipsis: true, render: function render(h, p) {
          return h('span', p.row.algoVersion === 'TRIAL' ? '试做' : '学生');
        } }, { title: '学生/操作人', key: 'uid', width: 110, ellipsis: true }, { title: '考试类型', key: 'examType', width: 100, ellipsis: true, render: function render(h, p) {
          return h('span', p.row.examType === 'SUMMATIVE' ? '阶段测' : p.row.examType === 'PLACEMENT' ? '入门测' : p.row.examType);
        } }, { title: '创建时间', key: 'gmtCreate', width: 180, ellipsis: true }, { title: '状态', key: 'status', width: 110, ellipsis: true, render: function render(h, p) {
          return h('span', _this.statusLabel(p.row.status, p.row.publishStatus || p.row.flags));
        } }, { title: '定级', key: 'placementLevel', width: 90, ellipsis: true }, { title: '题数', key: 'itemCount', width: 70, ellipsis: true }, { title: '续考次数', key: 'reopenCount', width: 90, ellipsis: true }, {
        title: '操作',
        key: 'action',
        width: 360,
        render: function render(h, params) {
          var buttons = [];
          if (params.row.status === 'READY' || params.row.status === 'INCOMPLETE_REF') {
            buttons.push(h('Button', {
              props: { type: 'success', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.openReport(params.row.id);
                } }
            }, '查看报告'));
          }
          buttons.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openReplay(params.row.id);
              } }
          }, '回放'));
          buttons.push(h('Button', {
            props: { type: 'error', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.act(params.row.id, 'invalidate');
              } }
          }, '作废'));
          buttons.push(h('Button', {
            props: { size: 'small' },
            on: { click: function click() {
                return _this.act(params.row.id, 'reopen');
              } }
          }, '开启续考'));
          return h('div', { style: { whiteSpace: 'nowrap' } }, buttons);
        }
      }]
    };
  },

  computed: {
    reportModalTitle: function reportModalTitle() {
      if (this.report && this.report.examType === 'PLACEMENT') return '英语能力测评报告';
      if (this.report && this.report.examType === 'SUMMATIVE') return '成绩报告';
      return '测试报告';
    },
    moduleRows: function moduleRows() {
      var obj = this.parseObj(this.replay && this.replay.result && this.replay.result.moduleJson);
      var keys = ['Listening', 'Speaking', 'Reading', 'Writing'];
      var rows = [];
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (obj[k] === undefined || obj[k] === null) continue;
        rows.push({ label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mex_question_type__["a" /* skillLabel */])(k), score: obj[k] });
      }
      return rows;
    },
    radarRows: function radarRows() {
      var obj = this.parseObj(this.replay && this.replay.result && this.replay.result.radarJson);
      var pairs = [['listen', '听力'], ['speak', '口语'], ['read', '阅读'], ['write', '写作'], ['vocab', '词汇'], ['grammar', '语法']];
      var rows = [];
      for (var i = 0; i < pairs.length; i++) {
        var k = pairs[i][0];
        if (obj[k] === undefined || obj[k] === null) continue;
        rows.push({ label: pairs[i][1], score: obj[k] });
      }
      return rows;
    },
    radarPlot: function radarPlot() {
      var rows = this.radarRows;
      if (!rows.length) return null;
      var cx = 180;
      var cy = 158;
      var r = 100;
      var n = rows.length;
      var pt = function pt(i, ratio) {
        var ang = -Math.PI / 2 + i * 2 * Math.PI / n;
        return {
          x: +(cx + r * ratio * Math.cos(ang)).toFixed(1),
          y: +(cy + r * ratio * Math.sin(ang)).toFixed(1)
        };
      };
      var rings = [];
      var levels = [0.2, 0.4, 0.6, 0.8, 1];
      for (var L = 0; L < levels.length; L++) {
        var pts = [];
        for (var i = 0; i < n; i++) {
          var p = pt(i, levels[L]);
          pts.push(p.x + ',' + p.y);
        }
        rings.push(pts.join(' '));
      }
      var axes = [];
      var dots = [];
      var poly = [];
      for (var _i = 0; _i < n; _i++) {
        var outer = pt(_i, 1);
        var lab = pt(_i, 1.32);
        var score = Number(rows[_i].score);
        if (isNaN(score)) score = 0;
        var ratio = Math.max(0, Math.min(100, score)) / 100;
        var d = pt(_i, ratio);
        poly.push(d.x + ',' + d.y);
        dots.push(d);
        axes.push({
          x2: outer.x,
          y2: outer.y,
          lx: lab.x,
          ly: lab.y,
          label: rows[_i].label,
          score: score
        });
      }
      return { cx: cx, cy: cy, rings: rings, axes: axes, dots: dots, polygon: poly.join(' ') };
    }
  },
  methods: {
    renderFullTextCell: function renderFullTextCell(h, raw, title) {
      var _this2 = this;

      var text = raw == null ? '' : String(raw);
      if (!text.trim()) return h('span', '—');
      if (text.length <= 24) return h('span', text);
      return h('a', {
        style: { whiteSpace: 'nowrap' },
        on: { click: function click() {
            return _this2.showFullText(title, text);
          } }
      }, text.slice(0, 24) + '...');
    },
    showFullText: function showFullText(title, text) {
      this.fullTextTitle = title;
      this.fullText = text;
      this.fullTextVisible = true;
    },
    parseObj: function parseObj(raw) {
      if (!raw) return {};
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object') return raw;
      try {
        return JSON.parse(raw) || {};
      } catch (e) {
        return {};
      }
    },
    dash: function dash(v) {
      if (v === undefined || v === null || v === '') return '—';
      return v;
    },
    renderExpand: function renderExpand(h, row) {
      var nodes = [this.kv(h, '原题', this.stemText(row)), this.kvMedia(h, '题干音频', row && row.stemAudio, row), this.kvMedia(h, '题干图', row && row.stemImage, row), this.kvMedia(h, '篇章图', row && row.passageImage, row), this.optionsBlock(h, row), this.kvMedia(h, '范文图', row && row.answerSampleImage, row), this.kvMedia(h, '示范音频', row && row.answerAudioSample, row), this.kv(h, '知识点', this.examPointText(row)), this.kv(h, '解析', row && row.explanation || '—')];
      return h('div', { class: 'mex-replay-expand' }, nodes.filter(Boolean));
    },
    kv: function kv(h, label, text) {
      return h('div', { class: 'mex-replay-kv' }, [h('div', { class: 'mex-replay-k' }, label), h('div', { class: 'mex-replay-v' }, text)]);
    },
    kvMedia: function kvMedia(h, label, path, row) {
      var node = this.mediaNode(h, path, row);
      if (!node) return null;
      return h('div', { class: 'mex-replay-kv' }, [h('div', { class: 'mex-replay-k' }, label), node]);
    },
    mediaNode: function mediaNode(h, path, row) {
      var skill = row && (row.skill || (row.bank === 'SPEAK' ? 'Speaking' : '')) || '';
      var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mex_asset__["a" /* assetUrl */])(path, skill);
      if (!url) return null;
      var kind = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mex_asset__["b" /* assetKind */])(url);
      if (kind === 'image') {
        return h('img', { attrs: { src: url }, class: 'mex-replay-img' });
      }
      if (kind === 'audio') {
        return h('audio', { attrs: { src: url, controls: true }, class: 'mex-replay-audio' });
      }
      if (kind === 'video') {
        return h('video', { attrs: { src: url, controls: true }, class: 'mex-replay-video' });
      }
      return h('a', { attrs: { href: url, target: '_blank' } }, url);
    },
    optionsBlock: function optionsBlock(h, row) {
      var _this3 = this;

      var data = this.parseJsonValue(row && row.optionsJson);
      if (!data) return null;
      if (Array.isArray(data) && data.length) {
        var items = data.map(function (o, idx) {
          var code = o && (o.code || o.key) || String.fromCharCode(65 + idx);
          var text = o && (o.text || o.label || o.value) || '';
          var children = [h('div', String(code).toUpperCase() + '. ' + text)];
          var img = _this3.mediaNode(h, o && o.image, row);
          if (img) children.push(img);
          return h('div', { class: 'mex-replay-opt' }, children);
        });
        return h('div', { class: 'mex-replay-kv' }, [h('div', { class: 'mex-replay-k' }, '选项'), h('div', items)]);
      }
      if (data.tokens && data.tokens.length) {
        return this.kv(h, '选项', '可拖：' + data.tokens.join(' / '));
      }
      return null;
    },
    stemText: function stemText(row) {
      if (!row) return '—';
      var parts = [];
      if (row.instructionCn) parts.push(row.instructionCn);
      if (row.instructionEn && row.instructionEn !== row.instructionCn) parts.push(row.instructionEn);
      if (row.script) parts.push(row.script);
      if (row.passageText) parts.push(row.passageText);
      if (row.stem) parts.push(row.stem);
      var blank = this.blanksText(row.blanksJson);
      if (blank) parts.push(blank);
      return parts.join('\n') || '—';
    },
    examPointText: function examPointText(row) {
      if (!row) return '—';
      var parts = [];
      if (row.examPoint) parts.push(row.examPoint);
      if (row.knowledgePointHierarchy && row.knowledgePointHierarchy !== row.examPoint) {
        parts.push('路径：' + row.knowledgePointHierarchy);
      }
      return parts.join('\n') || '—';
    },
    blanksText: function blanksText(raw) {
      var data = this.parseJsonValue(raw);
      if (!Array.isArray(data) || !data.length) return '';
      return data.map(function (b, i) {
        var no = b && b.no || i + 1;
        var prompt = b && b.prompt || '';
        var ans = b && (b.answer || b.key) || '';
        return '空' + no + (prompt ? ' ' + prompt : '') + (ans ? ' → ' + ans : '');
      }).join('\n');
    },
    parseJsonValue: function parseJsonValue(raw) {
      if (!raw) return null;
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object') return raw;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    medalLabel: function medalLabel(code) {
      if (code === 'GOLD') return '金牌';
      if (code === 'SILVER') return '银牌';
      if (code === 'BRONZE') return '铜牌';
      return code || '—';
    },
    promotionLabel: function promotionLabel(code) {
      if (code === 'UP') return '直接升班';
      if (code === 'CONSOLIDATE') return '巩固后升';
      if (code === 'REMEDIATE') return '先补核心';
      if (code === 'REPEAT') return '本级重学';
      return '—';
    },
    flagsLabel: function flagsLabel(code) {
      if (code === 'TRIAL') return '试做';
      if (!code) return '学生考试';
      return code;
    },
    bankLabel: function bankLabel(code) {
      if (code === 'COMP') return '综合库';
      if (code === 'SPEAK') return '口语库';
      return code || '—';
    },
    statusLabel: function statusLabel(code, publishOrFlags) {
      if (code === 'CREATED') return '已创建';
      if (code === 'CONSENT') return '待同意公约';
      if (code === 'PROFILE') return '信息采集';
      if (code === 'DEV_AUDIO') return '设备调试（音频）';
      if (code === 'DEV_MIC') return '设备调试（麦克风）';
      if (code === 'IN_PROGRESS') return '答题中';
      if (code === 'PAUSED') return '已暂停';
      if (code === 'SCORING') return '评分中';
      if (code === 'READY') return '已交卷';
      if (code === 'COMPLETED') return '已完成';
      if (code === 'ABANDONED') return '已放弃';
      if (code === 'INCOMPLETE_REF') {
        var pub = publishOrFlags || '';
        if (pub === 'REVIEW' || pub === 'PROVISIONAL' || pub === 'BELOW_L1') return '待复核';
        return '作答不足';
      }
      if (code === 'INVALID') return '已作废';
      return code || '—';
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      var _this4 = this;

      this.reload = Date.now();
      this.$nextTick(function () {
        return _this4.$refs.list && _this4.$refs.list.search();
      });
    },
    openReplay: function openReplay(id) {
      var _this5 = this;

      this.$http.post('/mex/sessions/detail', { id: id }).then(function (res) {
        if (res.status === 'ok') {
          _this5.replay = res.data;
          _this5.replayVisible = true;
        } else {
          _this5.$Message.error(res.msg || '回放失败');
        }
      });
    },
    openReport: function openReport(id) {
      var _this6 = this;

      this.$http.post('/mex/sessions/report', { id: id }).then(function (res) {
        if (res.status === 'ok' && res.data) {
          _this6.report = res.data;
          _this6.reportVisible = true;
        } else {
          _this6.$Message.error(res && res.msg || '暂无测试报告');
        }
      }).catch(function () {
        _this6.$Message.error('加载报告失败');
      });
    },
    act: function act(id, action) {
      var _this7 = this;

      this.$http.post('/mex/sessions/' + action, { id: id }).then(function (res) {
        if (res.status === 'ok') {
          _this7.$Message.success('已更新');
          _this7.search();
        } else {
          _this7.$Message.error(res.msg || '操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mex_asset__ = __webpack_require__(95);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexSessionReport',
  props: {
    report: { type: Object, default: null }
  },
  data: function data() {
    return {
      foxSrc: __webpack_require__(1294),
      radarIconSrc: __webpack_require__(1296),
      dimIconSrc: __webpack_require__(1295),
      activeSkill: 'Speaking',
      openedExplain: {},
      openedSample: {},
      levelCols: [{ code: 'L1', ccss: 'ESL Skill Building', cefr: 'Pre-A1', cam: 'YLE-Starters' }, { code: 'L2', ccss: 'Grade K', cefr: 'Pre-A1', cam: 'YLE-Starters' }, { code: 'L3', ccss: 'Grade K', cefr: 'Pre-A1', cam: 'YLE-Starters' }, { code: 'L4', ccss: 'Grade 1', cefr: 'A1', cam: 'YLE Movers' }, { code: 'L5', ccss: 'Grade 2', cefr: 'A1', cam: 'YLE Movers' }, { code: 'L6', ccss: 'Grade 3', cefr: 'A2', cam: 'YLE Flyers' }, { code: 'L7', ccss: 'Grade 4', cefr: 'A2-B1', cam: 'Flyers / KET' }, { code: 'L8', ccss: 'Grade 5', cefr: 'B1', cam: 'PET' }, { code: 'L9', ccss: 'Grade 6', cefr: 'B2', cam: 'PET' }]
    };
  },

  watch: {
    report: function report() {
      this.openedExplain = {};
      this.openedSample = {};
      this.activeSkill = 'Speaking';
    }
  },
  computed: {
    isPlacement: function isPlacement() {
      return this.report && this.report.examType === 'PLACEMENT';
    },
    isSummative: function isSummative() {
      return this.report && this.report.examType === 'SUMMATIVE';
    },
    showDimAnalysis: function showDimAnalysis() {
      if (!this.report) return false;
      if (this.isPlacement || this.isSummative) return true;
      var dims = this.report.dimensions;
      return !!(dims && dims.length);
    },
    kicker: function kicker() {
      return this.isPlacement ? '英语能力测评报告' : '成绩报告';
    },
    scoreInt: function scoreInt() {
      var n = Number(this.report && this.report.totalScore);
      if (isNaN(n)) return '—';
      return Math.round(n);
    },
    levelText: function levelText() {
      var raw = this.formalLevelRaw || this.candidateLevelRaw || this.report && this.report.placementLevel;
      if (!raw) return '';
      return String(raw).replace(/\.0$/, '');
    },
    formalLevelRaw: function formalLevelRaw() {
      if (!this.report || this.report.examType !== 'PLACEMENT') return '';
      var st = this.report.publishStatus;
      if (st && st !== 'VERIFIED') return '';
      return this.report.confirmedLevel || this.report.placementLevel || '';
    },
    formalLevelText: function formalLevelText() {
      var raw = this.formalLevelRaw;
      if (!raw) return '';
      return String(raw).replace(/\.0$/, '');
    },
    candidateLevelRaw: function candidateLevelRaw() {
      return this.report && this.report.candidateLevel || '';
    },
    candidateLevelText: function candidateLevelText() {
      var raw = this.candidateLevelRaw;
      if (!raw) return '';
      return String(raw).replace(/\.0$/, '');
    },
    visitedLevelText: function visitedLevelText() {
      var raw = this.report && this.report.visitedMaxLevel;
      if (!raw) return '';
      return String(raw).replace(/\.0$/, '');
    },
    publishStatusText: function publishStatusText() {
      var st = this.report && this.report.publishStatus;
      var m = {
        PROVISIONAL: '暂定等级（非正式）',
        REVIEW: '待复核（无正式定级）',
        BELOW_L1: '未达 L1（无正式定级）'
      };
      return m[st] || '';
    },
    levelBrief: function levelBrief() {
      var code = this.formalLevelText || this.levelText;
      var col = this.levelCols.filter(function (c) {
        return c.code === code;
      })[0];
      if (!col) return code;
      return code + '（' + col.ccss + ' / ' + col.cefr + ' / ' + col.cam + '）';
    },
    showPercentile: function showPercentile() {
      return this.report && this.report.benchmarkVisible === true && this.report.nationalPercentile != null;
    },
    medalText: function medalText() {
      var m = {
        GOLD: '金松果',
        SILVER: '银松果',
        BRONZE: '铜松果',
        IRON: '铁松果',
        WOOD: '木松果',
        GRASS: '草编松果'
      };
      return m[this.report && this.report.medal] || this.report && this.report.medal || '';
    },
    promotionText: function promotionText() {
      var m = {
        UP: '升班建议：升班',
        CONSOLIDATE: '升班建议：巩固',
        REMEDIATE: '升班建议：补弱',
        REPEAT: '升班建议：重学'
      };
      return m[this.report && this.report.promotion] || '';
    },
    cityLine: function cityLine() {
      return this.parseObj(this.report && this.report.cityRadarJson);
    },
    nationLine: function nationLine() {
      return this.parseObj(this.report && this.report.nationalRadarJson);
    },
    cityLegend: function cityLegend() {
      var name = this.report && this.report.cityName || '';
      return name ? name + '学生标准' : '同城学生标准';
    },
    radarFoot: function radarFoot() {
      return this.isPlacement ? '五项总得分均为100分，图中数据为各维度得分。' : '六项总得分均为100分，图中数据为各维度得分。';
    },
    radarKeys: function radarKeys() {
      if (this.isPlacement) {
        return [['listen', '听力理解'], ['speak', '口语表达'], ['read', '阅读理解'], ['vocab', '词汇运用'], ['grammar', '语法运用']];
      }
      return [['listen', '听力理解'], ['speak', '口语表达'], ['read', '阅读理解'], ['vocab', '词汇运用'], ['grammar', '语法运用'], ['write', '写作运用']];
    },
    radarPlot: function radarPlot() {
      var self = this.parseObj(this.report && this.report.radarJson);
      var keys = this.radarKeys;
      if (!keys.length) return null;
      var has = false;
      for (var i = 0; i < keys.length; i++) {
        if (self[keys[i][0]] != null) has = true;
      }
      if (!has) return null;
      var city = this.cityLine;
      var nation = this.nationLine;
      var cx = 210;
      var cy = 180;
      var r = 108;
      var n = keys.length;
      var pt = function pt(i, ratio) {
        var ang = -Math.PI / 2 + i * 2 * Math.PI / n;
        return {
          x: +(cx + r * ratio * Math.cos(ang)).toFixed(1),
          y: +(cy + r * ratio * Math.sin(ang)).toFixed(1)
        };
      };
      var rings = [];
      var levels = [0.25, 0.5, 0.75, 1];
      for (var L = 0; L < levels.length; L++) {
        var pts = [];
        for (var _i = 0; _i < n; _i++) {
          var p = pt(_i, levels[L]);
          pts.push(p.x + ',' + p.y);
        }
        rings.push(pts.join(' '));
      }
      var axes = [];
      var selfDots = [];
      var selfPoly = [];
      var cityPoly = [];
      var nationPoly = [];
      var hasCity = false;
      var hasNation = false;
      for (var _i2 = 0; _i2 < n; _i2++) {
        var outer = pt(_i2, 1);
        var lab = pt(_i2, 1.28);
        var score = Number(self[keys[_i2][0]]);
        if (isNaN(score)) score = 0;
        var d = pt(_i2, Math.max(0, Math.min(100, score)) / 100);
        selfPoly.push(d.x + ',' + d.y);
        selfDots.push(d);
        axes.push({ x2: outer.x, y2: outer.y, lx: lab.x, ly: lab.y, label: keys[_i2][1] });
        if (city && city[keys[_i2][0]] != null) {
          hasCity = true;
          var cs = Number(city[keys[_i2][0]]);
          if (isNaN(cs)) cs = 0;
          var cp = pt(_i2, Math.max(0, Math.min(100, cs)) / 100);
          cityPoly.push(cp.x + ',' + cp.y);
        }
        if (nation && nation[keys[_i2][0]] != null) {
          hasNation = true;
          var ns = Number(nation[keys[_i2][0]]);
          if (isNaN(ns)) ns = 0;
          var np = pt(_i2, Math.max(0, Math.min(100, ns)) / 100);
          nationPoly.push(np.x + ',' + np.y);
        }
      }
      return {
        cx: cx,
        cy: cy,
        rings: rings,
        axes: axes,
        selfDots: selfDots,
        selfPoly: selfPoly.join(' '),
        cityPoly: hasCity ? cityPoly.join(' ') : '',
        nationPoly: hasNation ? nationPoly.join(' ') : ''
      };
    },
    dimTabs: function dimTabs() {
      var tabs = [{ skill: 'Listening', label: '听力' }, { skill: 'Speaking', label: '口语' }, { skill: 'Reading', label: '阅读' }, { skill: 'Vocab', label: '词汇' }, { skill: 'Grammar', label: '语法' }];
      if (this.isSummative) {
        tabs.push({ skill: 'Writing', label: '写作' });
      }
      return tabs;
    },
    activeDim: function activeDim() {
      var dims = this.report && this.report.dimensions || [];
      for (var i = 0; i < dims.length; i++) {
        if (dims[i].skill === this.activeSkill) return dims[i];
      }
      return dims[0] || null;
    },
    dimScoreInt: function dimScoreInt() {
      var n = Number(this.activeDim && this.activeDim.score);
      if (isNaN(n)) return '—';
      return Math.round(n);
    }
  },
  methods: {
    parseObj: function parseObj(raw) {
      if (!raw) return null;
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object') return raw;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    num: function num(v) {
      if (v === undefined || v === null || v === '') return '—';
      return v;
    },
    stars: function stars(n) {
      var x = Number(n);
      if (isNaN(x) || x < 1) x = 0;
      if (x > 5) x = 5;
      var s = '';
      for (var i = 1; i <= 5; i++) {
        s += i <= x ? '★' : '☆';
      }return s;
    },
    sampleUrl: function sampleUrl(item) {
      if (!item || !item.sampleAudio) return '';
      var skill = this.activeSkill === 'Vocab' || this.activeSkill === 'Grammar' ? 'Reading' : this.activeSkill;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mex_asset__["a" /* assetUrl */])(item.sampleAudio, skill);
    },
    toggleExplain: function toggleExplain(id) {
      this.$set(this.openedExplain, id, !this.openedExplain[id]);
    },
    toggleSample: function toggleSample(id) {
      this.$set(this.openedSample, id, !this.openedSample[id]);
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MexAssetPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mex_question_type__ = __webpack_require__(40);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexSpeakQuestionList',
  components: { MexQuestionBatchModal: __WEBPACK_IMPORTED_MODULE_4__MexQuestionBatchModal___default.a, MexAssetPreview: __WEBPACK_IMPORTED_MODULE_5__MexAssetPreview___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      batchVisible: false,
      selection: [],
      editVisible: false,
      createMode: false,
      businessCode: '',
      selectedVersionId: null,
      versions: [],
      form: {},
      dimensions: [],
      queryParam: {},
      questionTypes: [],
      editQuestionTypes: [],
      editSubSkills: [],
      skipSubSkillSync: false,
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0'],
      tableColumns: [{ type: 'selection', width: 60, align: 'center' }, { title: '版本 ID', key: 'currentVersionId', width: 90, ellipsis: true }, { title: '题头 ID', key: 'id', width: 80, ellipsis: true }, { title: '业务键', key: 'businessCode', width: 200, ellipsis: true }, { title: '级别', key: 'levelCode', width: 80, ellipsis: true }, { title: '题型', key: 'questionType', width: 280, ellipsis: true, render: function render(h, p) {
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(p.row.questionType, 'Speaking'));
        } }, { title: '版本', key: 'versionNo', width: 80, ellipsis: true }, { title: '状态', key: 'status', width: 200, ellipsis: true, render: function render(h, params) {
          return h('span', _this.statusLabel(params.row.status));
        } }, { title: '场景', key: 'examScene', width: 220, ellipsis: true, render: function render(h, params) {
          return h('span', _this.examSceneLabel(params.row.examScene));
        } }, { title: '曝光', key: 'exposureCount', width: 70, ellipsis: true }, { title: '通过率', key: 'passRate', width: 80, ellipsis: true }, { title: '题干', key: 'stem', width: 240, render: function render(h, p) {
          return _this.renderStem(h, p.row.stem);
        } }, {
        title: '操作',
        key: 'action',
        width: 300,
        render: function render(h, params) {
          return h('div', { style: { whiteSpace: 'nowrap' } }, [h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openEdit(params.row);
              } }
          }, '编辑'), h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row, 'online');
              } }
          }, '上线'), h('Button', {
            props: { size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.changeStatus(params.row, 'offline');
              } }
          }, '下线'), h('Button', {
            props: { type: 'error', size: 'small' },
            on: { click: function click() {
                return _this.discard(params.row);
              } }
          }, '废弃')]);
        }
      }]
    };
  },

  computed: {
    dimSum: function dimSum() {
      var n = 0;
      this.dimensions.forEach(function (item) {
        n += Number(item.weight) || 0;
      });
      return n;
    },
    editTypeOptions: function editTypeOptions() {
      var list = [];
      var seen = {};(this.editQuestionTypes || []).forEach(function (t) {
        if (!t || seen[t]) return;
        seen[t] = true;
        list.push({ value: t, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(t, 'Speaking') });
      });
      var cur = this.form && this.form.questionType;
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */])(cur, 'Speaking') });
      }
      return list;
    },
    subSkillEnOptions: function subSkillEnOptions() {
      return this.buildSubSkillOptions('en');
    },
    subSkillCnOptions: function subSkillCnOptions() {
      return this.buildSubSkillOptions('cn');
    }
  },
  created: function created() {
    this.loadQuestionTypes();
  },

  methods: {
    questionTypeLabel: __WEBPACK_IMPORTED_MODULE_6__mex_question_type__["b" /* questionTypeLabel */],
    renderStem: function renderStem(h, stem) {
      var text = stem || '';
      if (!text) return h('span', '—');
      return h('Poptip', {
        props: { trigger: 'click', transfer: true, placement: 'bottom', width: 480, wordWrap: true }
      }, [h('a', {
        style: {
          display: 'inline-block',
          maxWidth: '220px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'bottom'
        }
      }, text), h('div', {
        slot: 'content',
        style: {
          maxHeight: '360px',
          overflow: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          lineHeight: '22px'
        }
      }, text)]);
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    loadQuestionTypes: function loadQuestionTypes() {
      var _this2 = this;

      this.$http.post('/mex/speak/questions/types').then(function (res) {
        _this2.questionTypes = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this2.questionTypes = [];
      });
    },
    loadEditQuestionTypes: function loadEditQuestionTypes() {
      var _this3 = this;

      this.$http.post('/mex/speak/questions/types').then(function (res) {
        _this3.editQuestionTypes = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this3.editQuestionTypes = [];
      });
    },
    loadEditSubSkills: function loadEditSubSkills() {
      var _this4 = this;

      this.$http.post('/mex/speak/questions/sub-skills').then(function (res) {
        _this4.editSubSkills = res.status === 'ok' ? res.data || [] : [];
      }).catch(function () {
        _this4.editSubSkills = [];
      });
    },
    buildSubSkillOptions: function buildSubSkillOptions(field) {
      var list = [];
      var seen = {};(this.editSubSkills || []).forEach(function (item) {
        var value = field === 'en' ? item.en : item.cn;
        if (!value || seen[value]) return;
        seen[value] = true;
        list.push({ value: value, label: value });
      });
      var cur = field === 'en' ? this.form.subSkillEn : this.form.subSkillCn;
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: cur });
      }
      return list;
    },
    findSubSkillBy: function findSubSkillBy(field, value) {
      if (!value) return null;
      var rows = this.editSubSkills || [];
      for (var i = 0; i < rows.length; i++) {
        if ((field === 'en' ? rows[i].en : rows[i].cn) === value) {
          return rows[i];
        }
      }
      return null;
    },
    onSubSkillEnChange: function onSubSkillEnChange(en) {
      var _this5 = this;

      if (this.skipSubSkillSync) return;
      var pair = this.findSubSkillBy('en', en);
      if (pair && pair.cn && this.form.subSkillCn !== pair.cn) {
        this.skipSubSkillSync = true;
        this.form.subSkillCn = pair.cn;
        this.$nextTick(function () {
          _this5.skipSubSkillSync = false;
        });
      }
    },
    onSubSkillCnChange: function onSubSkillCnChange(cn) {
      var _this6 = this;

      if (this.skipSubSkillSync) return;
      var pair = this.findSubSkillBy('cn', cn);
      if (pair && pair.en && this.form.subSkillEn !== pair.en) {
        this.skipSubSkillSync = true;
        this.form.subSkillEn = pair.en;
        this.$nextTick(function () {
          _this6.skipSubSkillSync = false;
        });
      }
    },
    statusLabel: function statusLabel(code) {
      if (code === 'PENDING_REVIEW') return '待审核 PENDING_REVIEW';
      if (code === 'ONLINE') return '已上线 ONLINE';
      if (code === 'OFFLINE') return '已下线 OFFLINE';
      if (code === 'DISCARDED') return '已废弃 DISCARDED';
      return code || '';
    },
    examSceneLabel: function examSceneLabel(code) {
      if (code === 'GENERAL') return '通用 GENERAL';
      if (code === 'PLACEMENT_ONLY') return '仅入门测 PLACEMENT_ONLY';
      if (code === 'SUMMATIVE_ONLY') return '仅阶段测 SUMMATIVE_ONLY';
      return code || '';
    },
    dimLabel: function dimLabel(key) {
      if (key === 'accuracy') return '准确度';
      if (key === 'fluency') return '流利度';
      if (key === 'completeness') return '完整度';
      return key;
    },
    defaultDimensions: function defaultDimensions() {
      return [{ key: 'accuracy', weight: 40 }, { key: 'fluency', weight: 30 }, { key: 'completeness', weight: 30 }];
    },
    toPercent: function toPercent(val) {
      var n = Number(val);
      if (isNaN(n)) return 0;
      if (n > 1) return n;
      return Math.round(n * 1000) / 10;
    },
    parseDimensions: function parseDimensions(raw) {
      var _this7 = this;

      if (!raw) return this.defaultDimensions();
      try {
        var obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) !== 'object' || obj.length != null) {
          this.$Message.warning('原评分维度无法解析，已套用默认值');
          return this.defaultDimensions();
        }
        var defaults = this.defaultDimensions();
        var used = {};
        var list = defaults.map(function (item) {
          used[item.key] = true;
          var val = obj[item.key];
          return {
            key: item.key,
            weight: val == null ? item.weight : _this7.toPercent(val)
          };
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (!used[key]) {
            list.push({ key: key, weight: _this7.toPercent(obj[key]) });
          }
        });
        return list;
      } catch (e) {
        this.$Message.warning('原评分维度无法解析，已套用默认值');
        return this.defaultDimensions();
      }
    },
    stringifyDimensions: function stringifyDimensions() {
      var obj = {};
      this.dimensions.forEach(function (item) {
        if (item.key) {
          obj[item.key] = Math.round((Number(item.weight) || 0) * 10) / 1000;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj);
    },
    search: function search() {
      var _this8 = this;

      this.selection = [];
      this.reload = Date.now();
      this.$nextTick(function () {
        if (_this8.$refs.list) {
          _this8.$refs.list.search();
        }
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selection = selection || [];
    },
    openBatch: function openBatch() {
      this.batchVisible = true;
    },
    escapeHtml: function escapeHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    showImportResult: function showImportResult(d) {
      var _this9 = this;

      var data = d || {};
      var msg = '导入成功 ' + (data.successCount || 0) + '，跳过 ' + (data.skipCount || 0) + '，失败 ' + (data.failCount || 0);
      var rows = data.failRows || [];
      if (rows.length) {
        var body = rows.map(function (r) {
          return _this9.escapeHtml(r);
        }).join('<br>');
        this.$Modal.warning({
          title: '导入结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        });
      } else {
        this.$Message.success(msg);
      }
    },
    triggerImport: function triggerImport() {
      this.$refs.fileInput.click();
    },
    downloadTemplate: function downloadTemplate() {
      var _this10 = this;

      this.$http.get('/mex/speak/questions/template', { responseType: 'arraybuffer' }).then(function (res) {
        var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '口语题库导入模板.xlsx';
        link.click();
      }).catch(function () {
        _this10.$Message.error('模板下载失败');
      });
    },
    importData: function importData(event) {
      var _this11 = this;

      var file = event.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      this.$http.post('/mex/speak/questions/import', formData, { transformRequest: [] }).then(function (res) {
        if (res.status === 'ok') {
          _this11.showImportResult(res.data);
          _this11.loadQuestionTypes();
          _this11.search();
        } else {
          _this11.$Message.error(res.msg || '导入失败');
        }
        _this11.$refs.fileInput.value = '';
      }).catch(function () {
        _this11.$Message.error('导入失败');
        _this11.$refs.fileInput.value = '';
      });
    },
    openCreate: function openCreate() {
      this.createMode = true;
      this.businessCode = '';
      this.versions = [];
      this.selectedVersionId = null;
      this.form = {
        skill: 'Speaking',
        levelCode: 'L1.0',
        examScene: 'GENERAL',
        questionType: '',
        stem: '',
        versionNo: 'v1.0',
        status: 'PENDING_REVIEW'
      };
      this.dimensions = this.defaultDimensions();
      this.editVisible = true;
      this.loadEditQuestionTypes();
      this.loadEditSubSkills();
    },
    applyDetail: function applyDetail(data) {
      this.businessCode = data.businessCode;
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ skill: 'Speaking' }, data.speak || {});
      this.form.skill = 'Speaking';
      this.dimensions = this.parseDimensions(this.form.dimensionsJson);
      this.versions = data.versions || [];
      this.selectedVersionId = this.form.id;
      this.createMode = false;
      this.editVisible = true;
      this.loadEditQuestionTypes();
      this.loadEditSubSkills();
    },
    openEdit: function openEdit(row) {
      var _this12 = this;

      this.$http.post('/mex/speak/questions/detail', { versionId: row.currentVersionId }).then(function (res) {
        if (res.status === 'ok' && res.data && res.data.speak) {
          _this12.applyDetail(res.data);
        } else {
          _this12.$Message.error(res.msg || '加载失败');
        }
      });
    },
    switchVersion: function switchVersion(versionId) {
      var _this13 = this;

      if (!versionId || versionId === this.form.id) return;
      this.$http.post('/mex/speak/questions/detail', { versionId: versionId }).then(function (res) {
        if (res.status === 'ok' && res.data && res.data.speak) {
          _this13.applyDetail(res.data);
        } else {
          _this13.$Message.error(res.msg || '加载失败');
        }
      });
    },
    savePayload: function savePayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.checksum;
      return payload;
    },
    saveEdit: function saveEdit() {
      var _this14 = this;

      this.form.dimensionsJson = this.stringifyDimensions();
      if (this.createMode) {
        var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.savePayload(), { businessCode: this.businessCode });
        this.$http.post('/mex/speak/questions/create', payload).then(function (res) {
          if (res.status === 'ok') {
            _this14.$Message.success('已新建，待审核上线');
            _this14.editVisible = false;
            _this14.loadQuestionTypes();
            _this14.search();
          } else {
            _this14.$Message.error(res.msg || '保存失败');
          }
        });
        return;
      }
      this.$http.post('/mex/speak/questions/save', this.savePayload()).then(function (res) {
        if (res.status === 'ok') {
          _this14.$Message.success(_this14.form.status === 'ONLINE' ? '已升版本，待审核上线' : '已保存');
          _this14.editVisible = false;
          _this14.loadQuestionTypes();
          _this14.search();
        } else {
          _this14.$Message.error(res.msg || '保存失败');
        }
      });
    },
    changeStatus: function changeStatus(row, action) {
      var _this15 = this;

      if (action === 'online') {
        this.$Modal.confirm({
          title: '确认上线',
          content: '上线该版本后，同一题目其它已上线版本会自动下线。',
          onOk: function onOk() {
            return _this15.doChangeStatus(row, action);
          }
        });
        return;
      }
      this.doChangeStatus(row, action);
    },
    doChangeStatus: function doChangeStatus(row, action) {
      var _this16 = this;

      this.$http.post('/mex/speak/questions/' + action, { versionId: row.currentVersionId }).then(function (res) {
        if (res.status === 'ok') {
          _this16.$Message.success('已更新');
          _this16.search();
        } else {
          _this16.$Message.error(res.msg || '操作失败');
        }
      });
    },
    discard: function discard(row) {
      var _this17 = this;

      this.$Modal.confirm({
        title: '废弃版本',
        content: '确认废弃该版本？已上线须先下线。不能回滚，只能再上线其它版本。',
        onOk: function onOk() {
          _this17.$http.post('/mex/speak/questions/discard', { versionId: row.currentVersionId }).then(function (res) {
            if (res.status === 'ok') {
              _this17.$Message.success('已废弃');
              _this17.search();
            } else {
              _this17.$Message.error(res.msg || '操作失败');
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mex_asset__ = __webpack_require__(95);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MexTrialPaper',
  data: function data() {
    return {
      drawing: false,
      scoring: false,
      form: {
        examType: 'PLACEMENT',
        selfLevel: 'BASIC',
        courseLevel: 'L2',
        shuffle: 0,
        birthYear: 2018,
        birthMonth: 6
      },
      courseLevels: ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8'],
      birthYears: [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      paper: null,
      items: [],
      index: 0,
      progressRev: 0,
      report: null,
      preparing: false,
      prepStep: 'consent',
      showGuide: false,
      entering: false,
      prep: {
        agreed: false,
        birthYear: 2018,
        birthMonth: 6,
        selfLevel: 'BASIC',
        profileAgreed: false,
        audioPlayed: false,
        micOk: false,
        micBusy: false,
        micHint: '',
        loadPct: 0
      },
      draft: { choice: '', text: '', ocrConfirm: false },
      shownAt: 0
    };
  },

  watch: {
    index: function index() {
      this.markShown();
    },
    inExam: function inExam(val) {
      if (val) this.markShown();
    }
  },
  computed: {
    current: function current() {
      return this.items[this.index] || null;
    },
    inExam: function inExam() {
      if (!this.paper || this.entering) return false;
      var s = this.paper.sessionStatus;
      return s === 'IN_PROGRESS' || s === 'READY';
    },
    prepVisible: function prepVisible() {
      return this.paper && !this.inExam && !this.report;
    },
    optView: function optView() {
      return this.parseOptions(this.current);
    },
    blankView: function blankView() {
      if (!this.current) return [];
      return this.current._blanks || [];
    },
    isCloze: function isCloze() {
      if (!this.current) return false;
      return (this.current.questionType || '') === 'Cloze';
    },
    isChoiceBlanks: function isChoiceBlanks() {
      if (this.isCloze) return true;
      var blanks = this.blankView;
      if (!blanks || !blanks.length) return false;
      return blanks.some(function (b) {
        return b.options && b.options.length;
      });
    },
    isFillBlanks: function isFillBlanks() {
      if (!this.current) return false;
      return (this.current.questionType || '') === 'Fill in the Blanks';
    },
    isWordForm: function isWordForm() {
      if (!this.current) return false;
      var t = this.current.questionType || '';
      return t === 'Fill Passage - Word Form' || t === 'Fill in Blank - Word Form';
    },
    isSubjectiveWrite: function isSubjectiveWrite() {
      if (!this.current) return false;
      var t = this.current.questionType || '';
      return t.indexOf('Picture Writing') >= 0 || t.indexOf('Practical Writing') >= 0 || t.indexOf('Guided Writing') >= 0;
    },
    isWalkPaper: function isWalkPaper() {
      if (!this.paper) return false;
      return this.paper.walkMode === 'ALL' || this.paper.walkMode === 'TYPES';
    },
    answerPh: function answerPh() {
      if (!this.current) return '请输入作答';
      if (this.current.bank === 'SPEAK') return '试做填跟读/标准文本，如 apple';
      if (this.isSubjectiveWrite) return '写入作答文本，并勾选已确认';
      if (this.isFillBlanks) return '每空填短语，多空用 | 连起来';
      if (this.isWordForm) return '每空填词形，多空用 ; 连起来，如 is coloring; wrote; do';
      return '选择题填代号；判断填 T/F；拼写填单词';
    },
    doneCount: function doneCount() {
      this.progressRev;
      var n = 0;
      this.items.forEach(function (it) {
        if (it.result) n++;
      });
      return n;
    },
    totalGot: function totalGot() {
      this.progressRev;
      var n = 0;
      this.items.forEach(function (it) {
        if (it.result) n += Number(it.result.score) || 0;
      });
      return Math.round(n * 100) / 100;
    },
    totalFull: function totalFull() {
      this.progressRev;
      var n = 0;
      this.items.forEach(function (it) {
        n += Number(it.fullScore) || 1;
      });
      return Math.round(n * 100) / 100;
    },
    bpColumns: function bpColumns() {
      var _this = this;

      return [{ title: 'ID', key: 'id', width: 70 }, { title: '考试', key: 'examType', width: 90, render: function render(h, p) {
          return h('span', _this.examTypeLabel(p.row.examType));
        } }, { title: '档位/级别段', key: 'segment', width: 110, render: function render(h, p) {
          return h('span', _this.segmentLabel(p.row.segment));
        } }, { title: '版本', key: 'versionNo', width: 90 }, { title: '状态', key: 'status', width: 80, render: function render(h, p) {
          return h('span', _this.statusLabel(p.row.status));
        } }, { title: '限时(秒)', key: 'durationSec', width: 90 }, { title: '题量上限', key: 'itemLimit', width: 90 }, { title: '模块权重', key: 'moduleWeightsJson', render: function render(h, p) {
          return h('span', p.row.moduleWeightsJson || '—');
        } }];
    },
    traceColumns: function traceColumns() {
      var _this2 = this;

      return [{ title: '来源', key: 'source', width: 80, render: function render(h, p) {
          return h('span', p.row.source === 'ANCHOR' ? '锚题' : '槽位');
        } }, { title: '蓝图ID', key: 'blueprintId', width: 80 }, { title: '蓝图档位', key: 'blueprintSegment', width: 90, render: function render(h, p) {
          return h('span', _this2.segmentLabel(p.row.blueprintSegment));
        } }, { title: '版本', key: 'blueprintVersion', width: 80 }, { title: '题库', key: 'bank', width: 90, render: function render(h, p) {
          return h('span', _this2.bankLabel(p.row.bank));
        } }, { title: '技能', key: 'skill', width: 90, render: function render(h, p) {
          return h('span', _this2.skillLabel(p.row.skill));
        } }, { title: '题型', key: 'questionType', minWidth: 160 }, { title: '应抽', key: 'need', width: 70 }, { title: '实抽', key: 'got', width: 70 }, { title: '分值', key: 'scoreEach', width: 70 }, { title: '放宽', key: 'loosened', width: 70, render: function render(h, p) {
          return h('span', p.row.loosened === 1 ? '是' : '否');
        } }, { title: '业务键', key: 'businessCodes', minWidth: 160, render: function render(h, p) {
          return h('span', (p.row.businessCodes || []).join('、') || '—');
        } }, { title: '说明', key: 'note', minWidth: 220 }];
    },
    skillColumns: function skillColumns() {
      return [{ title: '技能', key: 'skillLabel', width: 100 }, { title: '百分制', key: 'score', width: 100 }, { title: '强弱项', key: 'tag' }];
    }
  },
  methods: {
    mediaSrc: function mediaSrc(path) {
      if (!this.current) return '';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mex_asset__["a" /* assetUrl */])(path, this.current.skill);
    },
    skillLabel: function skillLabel(code) {
      if (code === 'Listening') return '听力';
      if (code === 'Speaking') return '口语';
      if (code === 'Reading') return '阅读';
      if (code === 'Writing') return '写作';
      if (code === 'Listening/Reading') return '听/读';
      return code || '';
    },
    catReasonLabel: function catReasonLabel(code) {
      if (code === 'ANCHOR') return '锚题';
      if (code === 'WALK_ALL') return '通刷';
      if (code === 'WALK_TYPES') return '题型覆盖';
      return '槽位';
    },
    examTypeLabel: function examTypeLabel(code) {
      if (code === 'PLACEMENT') return '入门测';
      if (code === 'SUMMATIVE') return '阶段测';
      return code || '';
    },
    statusLabel: function statusLabel(code) {
      if (code === 'ONLINE') return '已上线';
      if (code === 'OFFLINE') return '已下线';
      if (code === 'PENDING_REVIEW') return '待审核';
      if (code === 'DISCARDED') return '已废弃';
      return code || '—';
    },
    bankLabel: function bankLabel(code) {
      if (code === 'COMP') return '综合库';
      if (code === 'SPEAK') return '口语库';
      return code || '—';
    },
    scorerLabel: function scorerLabel(code) {
      if (code === 'OBJECTIVE') return '客观题自动判分';
      if (code === 'WRITE_SUBJECTIVE') return '写作主观（字数规则）';
      if (code === 'SKIP') return '跳过记 0 分';
      return code || '—';
    },
    segmentLabel: function segmentLabel(code) {
      if (code === 'LOW') return '低档';
      if (code === 'MID') return '中档';
      if (code === 'HIGH') return '高档';
      if (code === 'LISTENING') return '听力';
      if (code === 'SPEAKING') return '口语';
      if (code === 'READING') return '阅读';
      if (code === 'WRITING') return '写作';
      if (code === 'L1-L2' || code === 'L3-L4' || code === 'L5-L6' || code === 'L7-L8') return code;
      return code || '—';
    },
    placementPublishLabel: function placementPublishLabel(status) {
      var m = {
        VERIFIED: '已验证（正式定级）',
        PROVISIONAL: '暂定（非正式）',
        REVIEW: '待复核（无正式定级）',
        BELOW_L1: '未达 L1（无正式定级）'
      };
      return m[status] || status || '—';
    },
    placementPublishLine: function placementPublishLine(report) {
      if (!report || report.examType === 'SUMMATIVE') {
        return '定级 ' + (report && report.placementLevel || '—');
      }
      var st = report.publishStatus;
      if (st === 'VERIFIED') {
        return this.placementPublishLabel(st) + ' ' + (report.confirmedLevel || report.placementLevel || '—');
      }
      if (st === 'PROVISIONAL') {
        return this.placementPublishLabel(st) + ' ' + (report.candidateLevel || report.placementLevel || '—');
      }
      if (st === 'REVIEW' || st === 'BELOW_L1') {
        return this.placementPublishLabel(st);
      }
      return '定级 ' + (report.placementLevel || '—');
    },
    ageBandLabel: function ageBandLabel(code) {
      if (code === 'LOW') return '低龄';
      if (code === 'HIGH') return '高龄';
      if (code === 'MID') return '中龄';
      return code || '—';
    },
    traceRowClass: function traceRowClass(row) {
      if ((row.got || 0) < (row.need || 0)) return 'mex-trial-trace-short';
      if (row.loosened === 1) return 'mex-trial-trace-loose';
      return '';
    },
    parseOptions: function parseOptions(item) {
      if (!item) return { mode: 'NONE', options: [], tokens: [] };
      var qtype = item.questionType || '';
      if (qtype === 'Cloze' || qtype === 'Gap Fill') {
        return { mode: 'NONE', options: [], tokens: item._wordBank || [] };
      }
      if (qtype === 'Picture Writing - Four Panel Story') {
        return { mode: 'NONE', options: [], tokens: [] };
      }
      var wordForm = qtype === 'Fill Passage - Word Form' || qtype === 'Fill in Blank - Word Form';
      if (!item.optionsJson) return { mode: 'NONE', options: [], tokens: [] };
      try {
        var data = typeof item.optionsJson === 'string' ? JSON.parse(item.optionsJson) : item.optionsJson;
        if (Array.isArray(data) && data.length) {
          if (wordForm) {
            return { mode: 'BANK', options: data, tokens: [] };
          }
          var dragTokens = this.tokensFromMisimportedChoice(qtype, data);
          if (dragTokens) {
            return { mode: 'DRAG', options: [], tokens: dragTokens };
          }
          return { mode: 'CHOICE', options: data, tokens: [] };
        }
        if (data && (data.mode === 'DRAG' || data.tokens)) {
          return { mode: 'DRAG', options: [], tokens: data.tokens || [] };
        }
      } catch (e) {}
      return { mode: 'NONE', options: [], tokens: [] };
    },
    tokensFromMisimportedChoice: function tokensFromMisimportedChoice(qtype, data) {
      var drag = (qtype || '').indexOf('Drag Letters') === 0 || qtype === 'Sequence - Sentence Ordering';
      if (!drag || !data || data.length !== 1) return null;
      var text = (typeof data[0] === 'string' ? data[0] : data[0].text || '').replace(/｜/g, '|');
      if (text.indexOf('|') < 0) return null;
      var tokens = text.split('|').map(function (s) {
        return s.trim();
      }).filter(function (s) {
        return s;
      });
      return tokens.length ? tokens : null;
    },
    shuffleWords: function shuffleWords(arr) {
      var a = (arr || []).slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    },
    attachBlanks: function attachBlanks(item) {
      var list = [];
      if (item.blanksJson) {
        try {
          var data = typeof item.blanksJson === 'string' ? JSON.parse(item.blanksJson) : item.blanksJson;
          if (data && data.length) {
            list = data.map(function (b, i) {
              var options = (b.options || []).map(function (opt) {
                if (typeof opt === 'string') return { code: '', text: opt };
                return { code: opt.code || '', text: opt.text || '' };
              });
              return { no: b.no || i + 1, prompt: b.prompt || '', value: '', options: options };
            });
          }
        } catch (e) {}
      }
      this.$set(item, '_blanks', list);
    },
    drawBlueprint: function drawBlueprint() {
      this.doDraw('');
    },
    drawWalk: function drawWalk(mode) {
      this.doDraw(mode);
    },
    draw: function draw() {
      this.doDraw('');
    },
    doDraw: function doDraw(walkMode) {
      var _this3 = this;

      if (this.form.examType === 'PLACEMENT' && !this.form.selfLevel) {
        this.$Message.error('请选择宝贝目前的英语水平');
        return;
      }
      if (this.form.examType === 'SUMMATIVE' && !this.form.courseLevel) {
        this.$Message.error('请选择当前课程级别');
        return;
      }
      this.drawing = true;
      this.$http.post('/mex/trial/draw', this.drawPayload(walkMode)).then(function (res) {
        _this3.drawing = false;
        if (res.status === 'ok' && res.data) {
          _this3.paper = res.data;
          _this3.items = (res.data.items || []).map(function (it) {
            it.result = null;
            return it;
          });
          _this3.items.forEach(function (it) {
            return _this3.attachBlanks(it);
          });
          _this3.index = 0;
          _this3.progressRev = 0;
          _this3.report = null;
          _this3.entering = false;
          _this3.showGuide = false;
          _this3.prepStep = 'consent';
          _this3.prep = {
            agreed: false,
            birthYear: _this3.form.birthYear,
            birthMonth: _this3.form.birthMonth,
            selfLevel: _this3.form.selfLevel || 'BASIC',
            profileAgreed: false,
            audioPlayed: false,
            micOk: false,
            micBusy: false,
            micHint: '',
            loadPct: 0
          };
          _this3.resetDraft();
        } else {
          _this3.$Message.error(res.msg || '抽题失败');
        }
      }).catch(function () {
        _this3.drawing = false;
        _this3.$Message.error('抽题失败');
      });
    },
    drawPayload: function drawPayload(walkMode) {
      var m = this.form.birthMonth < 10 ? '0' + this.form.birthMonth : '' + this.form.birthMonth;
      var payload = {
        examType: this.form.examType,
        shuffle: this.form.shuffle,
        birthYm: this.form.birthYear + '-' + m
      };
      if (this.form.examType === 'PLACEMENT') {
        payload.selfLevel = this.form.selfLevel;
      } else {
        payload.courseLevel = this.form.courseLevel;
      }
      if (walkMode) {
        payload.walkMode = walkMode;
      }
      return payload;
    },
    resetPaper: function resetPaper() {
      this.paper = null;
      this.items = [];
      this.index = 0;
      this.progressRev = 0;
      this.report = null;
      this.entering = false;
      this.showGuide = false;
      this.prepStep = 'consent';
    },
    goSession: function goSession() {
      this.$router.push({ path: '/mex/sessions' });
    },
    birthYm: function birthYm() {
      var m = this.prep.birthMonth < 10 ? '0' + this.prep.birthMonth : '' + this.prep.birthMonth;
      return this.prep.birthYear + '-' + m;
    },
    playAudio: function playAudio() {
      this.prep.audioPlayed = true;
      var text = '嗨，我是小松鼠！你能听到我说话吗？我们一起去森林里收集金色松果吧！';
      if (window.speechSynthesis) {
        window.speechSynthesis.cancel();
        var u = new SpeechSynthesisUtterance(text);
        u.lang = 'zh-CN';
        window.speechSynthesis.speak(u);
      } else {
        this.$Message.info(text);
      }
    },
    startMic: function startMic() {
      var self = this;
      if (self.prep.micBusy) return;
      self.prep.micBusy = true;
      self.prep.micOk = false;
      var n = 3;
      self.prep.micHint = '倒计时 ' + n + ' 秒';
      var timer = setInterval(function () {
        n--;
        if (n > 0) {
          self.prep.micHint = '倒计时 ' + n + ' 秒';
          return;
        }
        clearInterval(timer);
        self.prep.micHint = '正在录音，请说 Hello, squirrel!';
        self.captureMic(function (ok) {
          self.prep.micBusy = false;
          self.prep.micOk = !!ok;
          self.prep.micHint = ok ? '录音成功，可以回听并开始探险' : '没听到有效人声，请再试一次';
        });
      }, 1000);
    },
    captureMic: function captureMic(done) {
      var _this4 = this;

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setTimeout(function () {
          return done(true);
        }, 3000);
        return;
      }
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
        var rec = null;
        try {
          rec = new MediaRecorder(stream);
        } catch (e) {
          stream.getTracks().forEach(function (t) {
            return t.stop();
          });
          setTimeout(function () {
            return done(true);
          }, 3000);
          return;
        }
        rec.start();
        setTimeout(function () {
          rec.stop();
        }, 3000);
        rec.onstop = function () {
          stream.getTracks().forEach(function (t) {
            return t.stop();
          });
          done(true);
        };
      }).catch(function () {
        _this4.$Message.warning('浏览器未授权麦克风，已按调试通过处理');
        setTimeout(function () {
          return done(true);
        }, 800);
      });
    },
    submitPrep: function submitPrep(step) {
      var _this5 = this;

      if (!this.paper || !this.paper.sessionId) return;
      var payload = {
        sessionId: this.paper.sessionId,
        step: step,
        policyVersion: 'forest-v2.5',
        birthYm: this.birthYm(),
        selfLevel: this.prep.selfLevel,
        canHear: this.prep.audioPlayed ? 1 : 0,
        vadOk: this.prep.micOk ? 1 : 0
      };
      this.preparing = true;
      this.$http.post('/mex/trial/prepare', payload).then(function (res) {
        _this5.preparing = false;
        if (res.status !== 'ok') {
          _this5.$Message.error(res.msg || '准备步骤失败');
          return;
        }
        _this5.paper.sessionStatus = res.data;
        if (step === 'CONSENT') _this5.prepStep = 'profile';
        if (step === 'PROFILE') _this5.prepStep = 'audio';
        if (step === 'AUDIO') _this5.prepStep = 'mic';
        if (step === 'MIC') _this5.enterExam();
      }).catch(function () {
        _this5.preparing = false;
        _this5.$Message.error('准备步骤失败');
      });
    },
    enterExam: function enterExam() {
      var _this6 = this;

      this.prepStep = 'loading';
      this.entering = true;
      this.prep.loadPct = 0;
      var n = 0;
      var timer = setInterval(function () {
        n += 8;
        if (n > 100) n = 100;
        _this6.prep.loadPct = n;
        if (n >= 100) {
          clearInterval(timer);
          _this6.entering = false;
          _this6.showGuide = true;
          setTimeout(function () {
            _this6.showGuide = false;
          }, 3000);
        }
      }, 200);
    },
    loadReport: function loadReport() {
      var _this7 = this;

      if (!this.paper || !this.paper.sessionId) return;
      this.$http.post('/mex/trial/report', { sessionId: this.paper.sessionId }).then(function (res) {
        if (res.status === 'ok' && res.data) {
          _this7.report = res.data;
        } else {
          _this7.$Message.error(res.msg || '报告尚未生成');
        }
      }).catch(function () {
        _this7.$Message.error('加载报告失败');
      });
    },
    resetDraft: function resetDraft() {
      this.draft = { choice: '', text: '', ocrConfirm: false };
      if (this.current && this.current._blanks) {
        this.current._blanks.forEach(function (b) {
          b.value = '';
        });
      }
    },
    payloadOf: function payloadOf() {
      if (this.isWordForm && this.blankView.length) {
        return this.blankView.map(function (b) {
          return (b.value || '').trim();
        }).join(';');
      }
      if (this.optView.mode === 'CHOICE') return this.draft.choice;
      if (this.blankView.length) {
        return this.blankView.map(function (b) {
          return (b.value || '').trim();
        }).join('|');
      }
      return this.draft.text;
    },
    hasPayload: function hasPayload() {
      if (this.blankView.length) {
        return this.blankView.some(function (b) {
          return (b.value || '').trim() !== '';
        });
      }
      var v = this.payloadOf();
      return v !== null && v !== undefined && String(v).trim() !== '';
    },
    applyScore: function applyScore(data) {
      var idx = this.index;
      var item = this.items[idx];
      if (!item) return;
      this.$set(item, 'result', data);
      this.$set(this.items, idx, item);
      this.progressRev += 1;
    },
    submitCurrent: function submitCurrent(skipped, after) {
      var _this8 = this;

      if (!this.current) return;
      if (!skipped && !this.hasPayload()) {
        this.$Message.warning('请先作答，或点跳过');
        return;
      }
      this.scoring = true;
      this.$http.post('/mex/trial/score', {
        bank: this.current.bank,
        versionId: this.current.versionId,
        sessionId: this.paper.sessionId,
        seq: this.current.seq,
        payload: this.payloadOf(),
        skipped: skipped,
        ocrConfirm: this.draft.ocrConfirm ? 1 : 0,
        elapsedMs: this.elapsedMs()
      }).then(function (res) {
        _this8.scoring = false;
        if (res.status === 'ok') {
          _this8.applyScore(res.data);
          if (res.data && res.data.sessionStatus) {
            _this8.paper.sessionStatus = res.data.sessionStatus;
          }
          if (res.data && res.data.report) {
            _this8.report = res.data.report;
            _this8.$Message.success('本套已全部提交，下方为模拟家长报告');
          }
          if (typeof after === 'function') after();
        } else {
          _this8.$Message.error(res.msg || '判分失败');
        }
      }).catch(function () {
        _this8.scoring = false;
        _this8.$Message.error('判分失败');
      });
    },
    go: function go(i) {
      this.index = i;
      this.resetDraft();
    },
    markShown: function markShown() {
      this.shownAt = Date.now();
    },
    elapsedMs: function elapsedMs() {
      if (!this.shownAt) return 0;
      var n = Date.now() - this.shownAt;
      return n < 0 ? 0 : n;
    },
    prev: function prev() {
      if (this.index > 0) this.go(this.index - 1);
    },
    next: function next() {
      var _this9 = this;

      if (this.index >= this.items.length - 1) return;
      if (this.current && !this.current.result) {
        if (!this.hasPayload()) {
          this.$Message.warning('请先提交本题或点跳过，进度才会更新');
          return;
        }
        this.submitCurrent(0, function () {
          if (_this9.index < _this9.items.length - 1) _this9.go(_this9.index + 1);
        });
        return;
      }
      this.go(this.index + 1);
    },
    dotClass: function dotClass(it) {
      if (it.issues && it.issues.length && !it.result) return 'warn';
      if (!it.result) return '';
      if (it.result.mastered === 1) return 'ok';
      return 'bad';
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      isAdviser: false,
      courseScheduleListData: null,
      allCoursePackageList: [],
      isAgent: null,
      packageSelectKey: 0,
      discountTypeList: [{
        value: 1,
        label: '课时赠送'
      }, {
        value: 2,
        label: '现金减免'
      }, {
        value: 3,
        label: '不参与活动'
      }],
      materialPrice: [],
      versionList: [],
      showDealMonth: false,
      dealMonthOptions: [{
        value: 1,
        label: '上月'
      }, {
        value: 0,
        label: '本月'
      }],
      formData: {
        uid: null,
        mobile: null,
        amount: null,
        preferentialAmount: null,
        payAmount: null,
        courseType: null,
        discountType: null,
        discountNum: 0,
        discount: 0,
        discountRemark: null,
        bookMaterialLevel: [],
        leaveNum: 0,
        makeupLessonNum: 0,
        effectDays: null,
        minorNum: 0,
        address: null,
        contractVersionId: null,
        contractName: null,
        tchChannel: null,
        desc: '',
        needInvoice: '0',
        needContract: '0',
        invoiceDetail: '',
        hasTwoPay: false,
        twoPayNum: 2,
        firstPay: 0,
        secondPay: 0,
        lastPay: 0,
        limitCancelLessonNum: 0,
        limitOffsetLessonNum: 0,
        giveNum: 0,
        agentOrder: '0',
        channel: null,
        url: '',
        inviteId: null,
        inviteClassHour: '',
        dealMonth: null,
        payCompany: 11
      },
      formRule: {},
      defaultPicList: []
    };
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    inputMobile: function inputMobile() {
      var self = this;
      var uid = self.formData.uid;
      if (uid) {
        self.$http.get('/agentInvite/queryByUid', { params: { 'uid': uid } }).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.formData.inviteId = res.data.inviteId;
          self.formData.contractName = res.data.userNickname;
          if (typeof res.data.isAgent === 'boolean') {
            self.isAgent = res.data.isAgent;
          } else {
            self.isAgent = null;
          }
          self.applyPackageFilters();
        });
      } else {
        self.isAgent = null;
        self.applyPackageFilters();
      }
    },
    onInsert: function onInsert() {
      var self = this;

      self.formRule = {
        uid: [{ type: 'integer', required: true, message: '学生 ID 不能为空', trigger: 'blur' }],
        amount: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        payAmount: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        courseType: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        discount: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        discountNum: [{ type: 'integer', required: true, message: '不能为空', trigger: 'blur' }],
        contractVersionId: [{ type: 'integer', required: true, message: '合同不能为空', trigger: 'blur' }],
        contractName: [{ type: 'string', required: true, message: '不能为空', trigger: 'blur' }],
        tchChannel: [{ type: 'integer', required: true, message: '不能为空', trigger: 'blur' }],
        channel: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }]
      };

      self.loading = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loading = false;
          return;
        }
        if (self.formData.channel === 1 && self.formData.url === '') {
          self.$Message.warning('请上传转介绍凭证!');
          self.loading = false;
          return;
        }
        if (self.formData.channel === 1 && self.formData.inviteId === '') {
          self.$Message.warning('请填介绍人 ID!');
          self.loading = false;
          return;
        }if (self.formData.channel === 1 && (self.formData.inviteClassHour === '' || self.formData.inviteClassHour < 0)) {
          self.$Message.warning('请填写转介绍课时');
          self.loading = false;
          return;
        }
        self.$http.post('/fundPackage/insert', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.successCallback();
            self.onClose();
            self.onSuccess();
          }
          if (res && res.status === '505') {
            self.formData.dealMonth = 1;
            self.showDealMonth = true;

            self.formRule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, self.formRule, {
              dealMonth: [{ type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur' }]
            });
            self.$Message.warning('请选择成交月份');
          }
          self.loading = false;
        });
      });
    },
    loadCoursePackageTypeData: function loadCoursePackageTypeData(val) {
      var self = this;
      self.$http.get('/common/coursePackageTypeList?tchChannel=' + val).then(function (res) {
        if (!res || !res.data) {
          return;
        }

        res.data.forEach(function (item) {
          item.label = item.title + '：' + item.routineNum + '节外教课';
        });

        self.allCoursePackageList = res.data;
        self.applyPackageFilters();
      });
    },
    loadCoursePackageTypeData2: function loadCoursePackageTypeData2(channel) {
      this.applyPackageFilters();
    },
    applyPackageFilters: function applyPackageFilters() {
      var list = (this.allCoursePackageList || []).slice();
      if (this.formData.channel === 11) {
        list = list.filter(function (item) {
          return item.routineNum === 1;
        });
      }
      if (this.isAgent === true) {
        list = list.filter(function (item) {
          return (item.title || '').indexOf('D') >= 0;
        });
      } else if (this.isAgent === false) {
        list = list.filter(function (item) {
          return (item.title || '').indexOf('D') < 0;
        });
      }
      this.courseScheduleListData = list;
      if (this.formData.courseType && !list.some(function (item) {
        return item.id === this.formData.courseType;
      }.bind(this))) {
        this.clearSelectedCourseType();
        this.$Message.warning('当前学生渠道与已选套餐不符，请重新选择');
      }
    },
    clearSelectedCourseType: function clearSelectedCourseType() {
      this.formData.courseType = null;
      this.packageSelectKey += 1;
      this.formData.amount = null;
      this.formData.num = null;
      this.formData.livingNum = null;
      this.formData.chineseNum = null;
      this.formData.partnerNum = null;
      this.formData.preferentialAmount = null;
      this.formData.giveNum = null;
      this.formData.leaveNum = null;
      this.formData.makeupLessonNum = null;
      this.formData.desc = '';
      this.formData.effectDays = null;
      this.formData.payAmount = null;
    },
    onCourseTypeChange: function onCourseTypeChange(val) {
      var self = this;
      if (val) {
        self.courseScheduleListData.forEach(function (item) {
          if (val === item.id) {
            self.formData.amount = item.amount;
            self.formData.num = item.routineNum;
            self.formData.livingNum = item.livingNum;
            self.formData.chineseNum = item.chineseNum;
            self.formData.partnerNum = item.partnerNum;
            self.formData.preferentialAmount = item.preferentialAmount;
            self.formData.giveNum = item.giveNum;
            self.formData.leaveNum = item.limitCancelLessonNum;
            self.formData.makeupLessonNum = item.limitOffsetLessonNum;
            self.formData.desc = item.title;
            self.formData.effectDays = item.effectDays;
            self.calculatePayAmount();
            self.calculateLeaveNum();
          }
        });
      } else {
        self.formData.amount = null;
      }
    },
    calculatePayAmount: function calculatePayAmount() {
      this.zero();
      if (this.formData.amount) {
        if (this.formData.discount) {
          this.formData.payAmount = (this.formData.amount - this.formData.discount).toFixed(2);
        } else {
          this.formData.payAmount = this.formData.amount;
        }
      }
      if (this.formData.tchChannel === 2) {
        if (this.formData.discount) {
          this.formData.payAmount = (this.formData.preferentialAmount - this.formData.discount).toFixed(2);
        } else {
          this.formData.payAmount = this.formData.preferentialAmount;
        }
      }
    },
    calculateLeaveNum: function calculateLeaveNum() {
      if (this.formData.tchChannel === 2) {
        return;
      }
      if (this.formData.num) {
        if (this.formData.discountNum) {
          this.formData.leaveNum = Math.floor((this.formData.num + this.formData.discountNum) / 40);
          this.formData.makeupLessonNum = Math.floor((this.formData.num + this.formData.discountNum) / 10);
        } else {
          this.formData.leaveNum = Math.floor(this.formData.num / 40);
          this.formData.makeupLessonNum = Math.floor(this.formData.num / 10);
        }
      }
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    zero: function zero() {
      this.formData.firstPay = 0;
      this.formData.secondPay = 0;
      this.formData.lastPay = 0;
    },
    calculate: function calculate() {
      if (this.formData.twoPayNum === 2) {
        this.formData.lastPay = (this.formData.payAmount - this.formData.firstPay).toFixed(2);
      } else if (this.formData.twoPayNum === 3) {
        this.formData.lastPay = (this.formData.payAmount - (this.formData.firstPay + this.formData.secondPay)).toFixed(2);
      }
    },
    queryContract: function queryContract() {
      var self = this;
      self.$http.post('/common/contractSelect?type=1', {
        pageSize: 1000,
        pageIndex: 1
      }).then(function (res) {
        if (res && res.data) {
          self.versionList = res.data.data;
        }
      });
    },
    onChangeSelectContractVersion: function onChangeSelectContractVersion(val) {
      this.formData.contractVersionId = val;
    },
    resetDealMonthField: function resetDealMonthField() {
      this.showDealMonth = false;
      this.formData.dealMonth = null;

      this.formRule = {};
    },
    setDefaultPayCompany: function setDefaultPayCompany() {
      if (this.isAdviser) {
        this.formData.payCompany = '11';
      } else {
        this.formData.channel = 3;
        this.formData.payCompany = '11';
      }
    }
  },
  created: function created() {
    this.isAdviser = !!this.$store.get('adviserInfo');
  },

  watch: {
    value: function value(val) {
      var self = this;
      if (val === true) {
        self.isAgent = null;
        self.formData.hasTwoPay = false;
        self.formData.twoPayNum = 2;
        self.formData.firstPay = 0;
        self.formData.secondPay = 0;
        self.formData.lastPay = 0;
        self.formData.dealMonth = null;
        self.resetDealMonthField();
        self.setDefaultPayCompany();
        self.loadCoursePackageTypeData(1);
        self.queryContract();
        self.$http.get('/materialPrice/list').then(function (res) {
          if (res.data) {
            self.materialPrice = res.data;
          }
        });
      } else if (val === false) {
        this.formData.needInvoice = '0';
        this.formData.needContract = '0';
      }
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddOtherOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      discountTypeList: [{
        value: 1,
        label: '课时赠送'
      }, {
        value: 2,
        label: '现金减免'
      }, {
        value: 3,
        label: '不参与活动'
      }],
      materialPrice: [],
      orderList: [],
      versionList: [],
      showDealMonth: false,
      dealMonthOptions: [{
        value: 1,
        label: '上月'
      }, {
        value: 0,
        label: '本月'
      }],
      isAdviser: false,
      isAgent: null,
      formData: {
        uid: null,
        mobile: null,
        amount: null,
        payAmount: null,
        courseType: null,
        discountType: null,
        tchChannel: 1,
        discountNum: 0,
        discount: 0,
        discountRemark: null,
        bookMaterialLevel: [],
        leaveNum: null,
        makeupLessonNum: null,
        minorNum: 0,
        partnerNum: 0,
        address: null,
        contractName: null,
        desc: null,
        num: null,
        livingNum: null,
        chineseNum: null,
        needInvoice: '0',
        needContract: '0',
        invoiceDetail: '',
        hasTwoPay: false,
        twoPayNum: 2,
        firstPay: 0,
        secondPay: 0,
        lastPay: 0,
        channel: null,
        inviteId: null,
        url: '',
        dealMonth: null,
        payCompany: 11
      },
      formRule: {}
    };
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    inputMobile: function inputMobile() {
      var self = this;
      var uid = self.formData.uid;
      if (uid) {
        self.$http.get('/agentInvite/queryByUid', { params: { 'uid': uid, 'orgOrderList': 1 } }).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.formData.inviteId = res.data.inviteId;
          self.formData.contractName = res.data.userNickname;
          self.orderList = res.data.orderList;
          if (typeof res.data.isAgent === 'boolean') {
            self.isAgent = res.data.isAgent;
          } else {
            self.isAgent = null;
          }
        });
      } else {
        self.isAgent = null;
      }
    },
    onFileChange: function onFileChange(fileList) {
      this.defaultPicList = fileList;
    },
    queryContract: function queryContract() {
      var self = this;
      self.$http.post('/common/contractSelect?type=1', {
        pageSize: 1000,
        pageIndex: 1
      }).then(function (res) {
        if (res && res.data) {
          self.versionList = res.data.data;
        }
      });
    },
    setDefaultPayCompany: function setDefaultPayCompany() {
      if (this.isAdviser) {
        this.formData.payCompany = '11';
      } else {
        this.formData.channel = 8;
        this.formData.payCompany = '11';
      }
    },
    onInsert: function onInsert() {
      var self = this;

      self.formRule = {
        uid: [{ type: 'integer', required: true, message: '学生 ID 不能为空', trigger: 'blur' }],
        payAmount: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        discountNum: [{ type: 'integer', required: true, message: '不能为空', trigger: 'blur' }],
        contractName: [{ type: 'string', required: true, message: '不能为空', trigger: 'blur' }],
        num: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }],
        channel: [{ type: 'number', required: true, message: '不能为空', trigger: 'blur' }]
      };

      self.loading = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loading = false;
          return;
        }
        if (self.formData.channel === 1 && self.formData.url === '') {
          self.$Message.warning('请上传转介绍凭证!');
          self.loading = false;
          return;
        }
        self.formData.amount = self.formData.payAmount;
        self.$http.post('/fundPackage/insertOther', self.formData).then(function (res) {
          if (res && res.status === 'ok') {
            self.$Message.success('提交成功!');
            self.successCallback();
            self.onClose();
            self.onSuccess();
          }
          if (res && res.status === '505') {
            self.formData.dealMonth = 1;
            self.showDealMonth = true;

            self.formRule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, self.formRule, {
              dealMonth: [{ type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur' }]
            });
            self.$Message.warning('请选择成交月份');
          }
          self.loading = false;
        });
      });
    },
    onDiscountTypeChange: function onDiscountTypeChange(val) {
      if (val === 1) {
        this.formData.discountNum = null;
        this.formData.discount = 0;
      } else if (val === 2) {
        this.formData.discountNum = 0;
        this.formData.discount = null;
      } else if (val === 3) {
        this.formData.discountNum = 0;
        this.formData.discount = 0;
      } else if (val === 4) {
        this.formData.discountNum = null;
        this.formData.discount = null;
      }
      this.calculatePayAmount();
    },
    calculatePayAmount: function calculatePayAmount() {
      this.zero();
      if (this.formData.amount) {
        if (this.formData.discount) {
          this.formData.payAmount = (this.formData.amount - this.formData.discount).toFixed(2);
        } else {
          this.formData.payAmount = this.formData.amount;
        }
      }
    },
    calculateLeaveNum: function calculateLeaveNum() {
      if (this.formData.num) {
        if (this.formData.discountNum) {
          this.formData.leaveNum = Math.floor((this.formData.num + this.formData.discountNum) / 40);
          this.formData.makeupLessonNum = Math.floor((this.formData.num + this.formData.discountNum) / 10);
        } else {
          this.formData.leaveNum = Math.floor(this.formData.num / 40);
          this.formData.makeupLessonNum = Math.floor(this.formData.num / 10);
        }
      }
    },
    zero: function zero() {
      this.formData.firstPay = 0;
      this.formData.secondPay = 0;
      this.formData.lastPay = 0;
    },
    calculate: function calculate() {
      if (this.formData.twoPayNum === 2) {
        this.formData.lastPay = this.formData.payAmount - this.formData.firstPay;
      } else if (this.formData.twoPayNum === 3) {
        this.formData.lastPay = this.formData.payAmount - (this.formData.firstPay + this.formData.secondPay);
      }
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    resetDealMonthField: function resetDealMonthField() {
      this.showDealMonth = false;
      this.formData.dealMonth = null;

      this.formRule = {};
    }
  },
  created: function created() {
    this.isAdviser = !!this.$store.get('adviserInfo');
  },

  watch: {
    editModal: function editModal(val) {
      if (val === false) {
        this.formData.needInvoice = '0';
        this.formData.needContract = '0';
      }
    },
    value: function value(val) {
      var self = this;
      if (val === true) {
        self.isAgent = null;
        self.$http.get('/materialPrice/list').then(function (res) {
          if (res.data) {
            self.materialPrice = res.data;
          }
        });
        self.queryContract();
        self.setDefaultPayCompany();
        this.formData.hasTwoPay = false;
        this.formData.twoPayNum = 2;
        this.formData.firstPay = 0;
        this.formData.secondPay = 0;
        this.formData.lastPay = 0;
        this.formData.dealMonth = null;
        self.resetDealMonthField();
      }
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddVoucherModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {},
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      subNum: 0,
      nextHandler: [],
      payWayList: this.$constant.payWayNew,
      defaultPicList: [],
      lastPayAmount: 0,
      payTime: null,
      payTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      showDealMonth: false,
      dealMonthOptions: [{
        value: 1,
        label: '上月'
      }, {
        value: 0,
        label: '本月'
      }],
      fundPackageData: {
        id: '',
        uid: null,
        nickname: '',
        num: null,
        amount: null,
        discount: null,
        discountNum: null,
        payAmount: null,
        leaveNum: null,
        desc: null,
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        payWay: null,
        payTime: null,
        isTeacherGood: null,
        isServiceGood: null,
        isPriceGood: null,
        likeFixedMode: null,
        specialRemark: null,
        url: '',
        state: 4,
        hasPayAmount: 0,
        dealMonth: null
      },
      formData: {
        uid: null,
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_1__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        payWay: null,
        payTime: null,
        isTeacherGood: null,
        isServiceGood: null,
        isPriceGood: null,
        likeFixedMode: null,
        specialRemark: null,
        url: null
      },
      fromRules: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        payWay: [{ type: 'number', required: true, message: '付款方式不能为空', trigger: 'blur' }],
        payTime: [{ type: 'number', required: true, message: '支付时间不能为空', trigger: 'blur' }],
        url: [{ type: 'string', required: true, message: '凭证图片不能为空', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    onFileChange: function onFileChange(fileList) {
      this.defaultPicList = fileList;
    },
    changPayTime: function changPayTime() {
      if (this.payTime && this.payTime > Date.now()) {
        this.$Message.warning('支付时间不能晚于当前时间');
        this.payTime = null;
        this.fundPackageData.payTime = null;
        this.formData.payTime = null;
        return;
      }
      this.fundPackageData.payTime = this.payTime;
      this.formData.payTime = this.payTime / 1000;
    },
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.fundPackageData.nextHandlerTime = value;
    },
    calculate: function calculate() {
      this.lastPayAmount = this.fundPackageData.payAmount - this.data.hasPayAmount;
      this.lastPayAmount = this.lastPayAmount - this.fundPackageData.hasPayAmount;
    },
    allThePay: function allThePay() {
      if (this.fundPackageData.state === 5) {
        this.fundPackageData.hasPayAmount = this.lastPayAmount;
        this.lastPayAmount = 0;
      }
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      if (self.subNum === 0) {
        this.$refs.form.validate(function (valid) {
          if (!valid) {
            self.$Message.warning('信息输入错误!');
            self.loading = false;
            return;
          }
          if (self.payTime && self.payTime > Date.now()) {
            self.$Message.warning('支付时间不能晚于当前时间');
            self.loading = false;
            return;
          }
          self.subNum++;
          self.loading = true;
          self.formData = self.fundPackageData;
          self.formData.fundPackageId = self.fundPackageData.id;
          self.formData.payTime = self.payTime / 1000;
          self.$http.post('/userTrack/buySuccess', self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!');
              self.successCallback();
              self.onClose();
              self.onSuccess();
            }
            if (res && res.status === '505') {
              self.fundPackageData.dealMonth = 1;
              self.showDealMonth = true;

              self.fromRules = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, self.fromRules, {
                dealMonth: [{ type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur' }]
              });
              self.$Message.warning('请选择成交月份');
            }
            self.subNum = 0;
            self.loading = false;
          });
        });
      }
    },
    onChange: function onChange() {
      var arr = [];
      if (this.fundPackageData.isTeacherGood === '1') {
        arr.push('老师专业');
        arr.push('、');
      }
      if (this.fundPackageData.isServiceGood === '1') {
        arr.push('服务贴心');
        arr.push('、');
      }
      if (this.fundPackageData.isPriceGood === '1') {
        arr.push('性价比高');
        arr.push('、');
      }
      if (this.fundPackageData.likeFixedMode === '1') {
        arr.push('喜欢固定模式');
        arr.push('、');
      }

      arr.splice(-1, 1, ' ');

      if (this.fundPackageData.specialRemark) {
        arr.push('备注：');
        arr.push(this.fundPackageData.specialRemark);
      }

      this.fundPackageData.content = arr.join('');
      console.log(this.fundPackageData.content);
    },
    onClose: function onClose() {
      this.$emit('on-close');
      this.payTime = null;
      this.resetDealMonthField();
      this.successCallback();
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    resetDealMonthField: function resetDealMonthField() {
      this.showDealMonth = false;
      this.fundPackageData.dealMonth = null;

      delete this.fromRules.dealMonth;
    }
  },
  watch: {
    value: function value(val) {
      this.$refs['form'].resetFields();
      this.defaultPicList = [];
      this.fundPackageData = {};
      this.resetDealMonthField();
      if (val && this.data) {
        this.$helper.mergeProperties(this.data, this.fundPackageData);
        this.payTime = this.fundPackageData.payTime;
        var pics = this.data.urls;
        if (pics) {
          for (var i in pics) {
            var url = pics[i] + '';
            var name = pics[i] + '';
            for (var _i = 0; _i < 3; _i++) {
              name = name.substring(name.indexOf('/') + 1);
            }
            this.defaultPicList.push({ name: name, url: url });
          }
        }
      } else {
        this.defaultPicList = [];
      }
      if (val) {
        this.fundPackageData.state = 4;
        this.fundPackageData.hasPayAmount = 0;
        this.lastPayAmount = this.fundPackageData.payAmount - this.data.hasPayAmount;
      }
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DragonTigerList',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserGroup: '',
        adviserId: ''
      },
      dataList: [],
      adviserGroupList: this.$constant.adviserGroup
    };
  },
  created: function created() {
    this.search();
  },

  watch: {
    'queryParam.adviserId': function queryParamAdviserId(newVal) {
      if (this.searchLoading) return;
      this.search();
    }
  },
  methods: {
    search: function search() {
      var _this = this;

      this.searchLoading = true;
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      this.$http.get('/fundPackage/dragonTigerList', {
        params: {
          month: month,
          adviserGroup: this.queryParam.adviserGroup || null,
          adviserId: this.queryParam.adviserId || null
        }
      }).then(function (res) {
        if (res && res.data) {
          _this.dataList = _this.processData(res.data);
        }
        _this.searchLoading = false;
      }).catch(function () {
        _this.searchLoading = false;
      });
    },
    processData: function processData(data) {
      var result = [];
      if (!data || !data.length) {
        return result;
      }

      data.forEach(function (item, index) {
        var quantityRow = {
          type: 'quantity',
          adviserName: '',
          target: item.target,
          completed: item.completed,
          index: index,
          tchChannel: item.tchChannel
        };

        var amountRow = {
          type: 'amount',
          adviserName: item.adviserName,
          target: item.totalAmount,
          completed: item.completedAmount,
          index: index,
          tchChannel: item.tchChannel
        };

        for (var i = 1; i <= 31; i++) {
          var dayKey = 'day' + i;
          var dayData = item['day' + i];
          quantityRow[dayKey] = dayData ? dayData.count : 0;
          amountRow[dayKey] = dayData ? dayData.amount : 0;
        }

        result.push(quantityRow);
        result.push(amountRow);
      });

      return result;
    },
    onStartDateChange: function onStartDateChange(value) {
      if (value) {
        this.queryParam.month = this.$moment(value).format('YYYY-MM');
      } else {
        this.queryParam.month = '';
      }
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      this.$http.get('/fundPackage/dragonTigerList/export', {
        responseType: 'arraybuffer',
        params: {
          month: month,
          adviserGroup: this.queryParam.adviserGroup || null,
          adviserId: this.queryParam.adviserId || null
        }
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '\u51FA\u5355\u8282\u594F\u56FE-' + month + '.xlsx';
          link.click();
          _this2.$Message.success('导出成功');
        } else {
          _this2.$Message.error(response.msg || '导出失败');
        }
        _this2.exportLoading = false;
      }).catch(function (error) {
        _this2.$Message.error('导出失败：' + error.message);
        _this2.exportLoading = false;
      });
    }
  },
  computed: {
    columns: function columns() {
      var monthName = this.$moment(this.queryParam.month).format('M 月份');
      var $moment = this.$moment;
      var $numeral = this.$numeral;

      return [{
        title: '' + monthName,
        align: 'center',
        width: 100,
        fixed: 'left',
        renderHeader: function renderHeader(h) {
          return h('div', { style: { fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' } }, '' + monthName);
        },
        render: function render(h, params) {
          if (params.row.type === 'amount') {
            return h('b', {
              style: {
                fontSize: '14px'
              }
            }, params.row.adviserName || '');
          }

          return h('span');
        }
      }, {
        title: '#',
        align: 'center',
        width: 60,
        fixed: 'left',
        renderHeader: function renderHeader(h) {
          return h('div', { style: { fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' } }, '#');
        },
        render: function render(h, params) {
          var label = params.row.type === 'quantity' ? '单量' : '金额';
          return h('span', { style: { fontWeight: 'bold' } }, label);
        }
      }, {
        title: '目标',
        align: 'center',
        width: 80,
        fixed: 'left',
        renderHeader: function renderHeader(h) {
          return h('div', { style: { fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } }, '目标');
        },
        render: function render(h, params) {
          if (params.row.type === 'amount') {
            return h('span', { style: { fontWeight: 'bold', fontSize: '14px' } }, params.row.target ? $numeral(params.row.target).format('0') : '');
          }
          return h('span', { style: { fontWeight: 'bold', fontSize: '14px' } }, params.row.target);
        }
      }, {
        title: '完成',
        align: 'center',
        width: 100,
        fixed: 'left',
        renderHeader: function renderHeader(h) {
          return h('div', { style: { fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } }, '完成');
        },
        render: function render(h, params) {
          if (params.row.type === 'amount') {
            return h('span', { style: { color: '#19be6b', 'font-weight': 'bold', fontSize: '16px' } }, params.row.completed ? $numeral(params.row.completed).format('0') : '');
          }
          return h('span', { style: { color: '#19be6b', 'font-weight': 'bold', fontSize: '14px' } }, params.row.completed);
        }
      }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 31 }, function (_, i) {
        return {
          title: (i + 1).toString(),
          key: 'day' + (i + 1),
          align: 'center',
          width: 65,
          renderHeader: function renderHeader(h) {
            return h('div', { style: { fontStyle: 'italic', borderRight: '1px solid #000', padding: '8px', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } }, (i + 1).toString() + '日');
          },
          render: function render(h, params) {
            var row = params.row;
            var value = row['day' + (i + 1)];
            var bgColor = '#fff';
            var fontColor = '#000';

            if (value && value > 0) {
              var colors = [{ bg: '#ffe6e6', font: '#333' }, { bg: '#e6f3ff', font: '#333' }, { bg: '#e6ffe6', font: '#333' }, { bg: '#fff4e6', font: '#333' }, { bg: '#f0e6ff', font: '#333' }, { bg: '#ffe6f0', font: '#333' }];
              var colorInfo = colors[row.index % colors.length];
              bgColor = colorInfo.bg;
              fontColor = colorInfo.font;
            }

            if (row.type === 'amount' && value) {
              return h('div', {
                style: {
                  backgroundColor: bgColor,
                  padding: '5px',
                  color: fontColor,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  borderRight: '1px solid #000',
                  height: '100%',
                  boxSizing: 'border-box'
                }
              }, $numeral(value).format('0'));
            }

            return h('div', {
              style: {
                backgroundColor: bgColor,
                padding: '5px',
                color: fontColor,
                textAlign: 'center',
                borderRight: '1px solid #000',
                height: '100%',
                boxSizing: 'border-box'
              }
            }, value || '');
          }
        };
      })));
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DragonTigerListV2',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserGroup: '',
        adviserId: '',
        tchChannel: 1
      },
      rankingData: [],
      totalAdvisers: 0,
      totalQuantity: 0,
      totalAmount: 0,
      adviserGroupList: this.$constant.adviserGroup,
      newOrderList: []
    };
  },
  created: function created() {
    this.search();
    this.getNewOrders();
    this.timer = setInterval(this.getNewOrders, 10 * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  computed: {
    monthName: function monthName() {
      return this.$moment(this.queryParam.month).format('YYYY 年 M 月');
    }
  },
  watch: {
    'queryParam.adviserId': function queryParamAdviserId(newVal) {
      if (this.searchLoading) return;
      this.search();
    }
  },
  methods: {
    search: function search() {
      var _this = this;

      this.searchLoading = true;
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');

      this.$http.get('/fundPackage/dragonTigerListV2', {
        params: {
          month: month,
          adviserGroup: this.queryParam.adviserGroup || null,
          adviserId: this.queryParam.adviserId || null,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(function (res) {
        if (res && res.data) {
          _this.processData(res.data);
        }
        _this.searchLoading = false;
      }).catch(function () {
        _this.searchLoading = false;
      });
    },
    processData: function processData(data) {
      if (!data) {
        this.rankingData = [];
        this.totalAdvisers = 0;
        this.totalQuantity = 0;
        this.totalAmount = 0;
        return;
      }

      this.totalAdvisers = data.totalAdvisers || 0;
      this.totalQuantity = data.totalQuantity || 0;
      this.totalAmount = data.totalAmount || 0;

      var rankingList = data.rankingList || [];

      this.rankingData = rankingList.map(function (item) {
        return {
          rank: item.rank,
          department: item.department,
          adviserId: item.adviserId,
          adviserName: item.adviserName,
          quantity: item.completed || 0,
          amount: item.completedAmount || 0,
          canSeeDetail: item.canSeeDetail
        };
      });
    },
    getDepartmentText: function getDepartmentText(department) {
      var group = this.adviserGroupList.find(function (item) {
        return item.code === department;
      });
      return group ? group.text : department;
    },
    getRankClass: function getRankClass(rank) {
      if (rank === 1) return 'rank-1';
      if (rank === 2) return 'rank-2';
      if (rank === 3) return 'rank-3';
      return '';
    },
    getMedalClass: function getMedalClass(rank) {
      if (rank === 1) return 'medal-gold';
      if (rank === 2) return 'medal-silver';
      if (rank === 3) return 'medal-bronze';
      return '';
    },
    getMedalIcon: function getMedalIcon(rank) {
      if (rank === 1) return '🥇';
      if (rank === 2) return '🥈';
      if (rank === 3) return '🥉';
      return rank;
    },
    goToPerformanceDetail: function goToPerformanceDetail(item) {
      if (item.canSeeDetail === false) {
        return;
      }
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      this.$router.push({
        path: '/order/performanceDetail',
        query: {
          month: month,
          adviserId: item.adviserId
        }
      });
    },
    goToTotalPerformanceDetail: function goToTotalPerformanceDetail() {
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      var params = {
        month: month
      };
      if (this.queryParam.adviserGroup) {
        params.adviserGroup = this.queryParam.adviserGroup;
      }
      this.$router.push({
        path: '/order/performanceDetail',
        query: params
      });
    },
    viewDetail: function viewDetail() {
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      var params = {
        month: month
      };
      if (this.queryParam.adviserGroup) {
        params.adviserGroup = this.queryParam.adviserGroup;
      }
      if (this.queryParam.adviserId) {
        params.adviserId = this.queryParam.adviserId;
      }
      this.$router.push({
        path: '/order/dragonTigerList',
        query: params
      });
    },
    exportToImage: function exportToImage() {
      var _this2 = this;

      if (this.rankingData.length === 0) {
        this.$Message.warning('暂无数据，无法导出');
        return;
      }
      this.exportLoading = true;
      var el = this.$refs.exportArea;
      __WEBPACK_IMPORTED_MODULE_1_html2canvas___default()(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        onclone: function onclone(clonedDoc) {
          var badges = clonedDoc.querySelectorAll('.medal-gold, .medal-silver, .medal-bronze');
          badges.forEach(function (badge) {
            var isGold = badge.classList.contains('medal-gold');
            var isSilver = badge.classList.contains('medal-silver');
            var number = isGold ? '1' : isSilver ? '2' : '3';
            var bgColor = isGold ? 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)' : isSilver ? 'linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%)' : 'linear-gradient(135deg, #cd7f32 0%, #e8a87c 100%)';
            var textColor = isGold ? '#8b6914' : isSilver ? '#5a5a5a' : '#8b5a2b';
            badge.innerHTML = number;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(badge.style, {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              fontWeight: '700',
              fontSize: '16px',
              background: bgColor,
              color: textColor
            });
          });
        }
      }).then(function (canvas) {
        var link = document.createElement('a');
        link.download = '龙虎榜_' + _this2.$moment(_this2.queryParam.month).format('YYYY-MM') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        _this2.exportLoading = false;
        _this2.$Message.success('导出成功');
      }).catch(function () {
        _this2.exportLoading = false;
        _this2.$Message.error('导出失败');
      });
    },
    getNewOrders: function getNewOrders() {
      var self = this;
      self.$http.get('/fundPackage/getNewOrders').then(function (res) {
        if (res && res.data) {
          self.newOrderList = res.data;
        } else {
          self.newOrderList = [];
        }
      }).catch(function () {
        self.newOrderList = [];
      });
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fundData: {},
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      materialPrice: [],
      formData: {
        bookNum: null,
        address: '',
        contractName: '',
        guardian: '',
        bookMaterialLevel: [],
        needInvoice: '0',
        needContract: '0',
        invoiceDetail: ''
      },
      formRule: {
        bookMaterialLevel: [{ type: 'array', required: true, message: '不能为空', trigger: 'blur' }],
        address: [{ type: 'string', required: true, message: '不能为空', trigger: 'blur' }],
        contractName: [{ type: 'string', required: true, message: '不能为空', trigger: 'blur' }]
      }
    };
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    onInsert: function onInsert() {
      var _this = this;

      var self = this;
      self.loading = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loading = false;
          return;
        }

        self.$http.post('/fundPackage/update', {
          id: self.formData.id,
          uid: self.formData.uid,
          contractName: self.formData.contractName,
          needInvoice: self.formData.needInvoice,
          needContract: self.formData.needContract,
          invoiceDetail: self.formData.invoiceDetail
        }).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            _this.successCallback();
            self.onClose();
            self.onSuccess();
          }
          self.loading = false;
        }).catch(function (e) {
          self.onClose();
          self.loading = false;
        });
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    },
    allClear: function allClear() {
      this.formData.bookMaterialLevel = [];
    }
  },
  watch: {
    value: function value(val) {
      var self = this;
      if (val && this.fundData) {
        this.formData = this.fundData;
        self.$http.get('/materialPrice/list').then(function (res) {
          if (res.data) {
            self.materialPrice = res.data;
          }
        });
      }
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddOrderModal_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddOrderModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AddOrderModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditOrderModal_vue__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditOrderModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditOrderModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserCredential2_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserCredential2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserCredential2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserCredential_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserCredential_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserCredential_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddOtherOrderModal_vue__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddOtherOrderModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddOtherOrderModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddVoucherModal_vue__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddVoucherModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddVoucherModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderGiftModal_vue__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderGiftModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OrderGiftModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ShowImageCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderClassHourModal_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrderClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tchScore__ = __webpack_require__(2);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AddOrderModal: __WEBPACK_IMPORTED_MODULE_0__AddOrderModal_vue___default.a,
    EditOrderModal: __WEBPACK_IMPORTED_MODULE_1__EditOrderModal_vue___default.a,
    UserCredential: __WEBPACK_IMPORTED_MODULE_3__UserCredential_vue___default.a,
    UserCredential2: __WEBPACK_IMPORTED_MODULE_2__UserCredential2_vue___default.a,
    AddOtherOrderModal: __WEBPACK_IMPORTED_MODULE_4__AddOtherOrderModal_vue___default.a,
    AddVoucherModal: __WEBPACK_IMPORTED_MODULE_5__AddVoucherModal_vue___default.a,
    OrderGiftModal: __WEBPACK_IMPORTED_MODULE_6__OrderGiftModal_vue___default.a,
    OrderClassHourModal: __WEBPACK_IMPORTED_MODULE_8__OrderClassHourModal_vue___default.a,
    ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_7__ShowImageCarousel_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var $numeral = this.$numeral;
    var self = this;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      fundPackageId: null,
      uid: null,
      totalNum: null,
      statistics: {
        totalPayment: 0,
        totalAmount: 0,
        totalDiscount: 0
      },

      filterStatistics: {
        totalPayment: 0,
        totalAmount: 0,
        totalDiscount: 0
      },

      queryParam: {
        uid: '',
        creatorId: null,
        auditId: null,
        auditStatus: null,
        state: '',
        stateList: [],
        startTimeDate: '',
        endTimeDate: '',
        startCreateDate: '',
        endCreateDate: '',
        presented: null,
        tchChannel: null,
        channel: null,
        channelList: [],
        sorts: [],
        coursePackage: '',
        coursePackageList: []
      },
      adminUser: [],
      adminUserAudit: [],
      isDepLeader: true,
      editData: null,
      loadingEdit: false,
      editModal: false,
      addModal: false,
      addOtherModal: false,
      showAddOtherButton: true,
      addVoucherModal: false,
      giftModal: false,
      giftOrderId: '',
      showImgModal: false,
      showImgList: [],
      showOrderClassHourModal: false,
      formData: {
        livingNum: 0,
        chineseNum: 0,
        bookNum: 0,
        cdNum: 0,
        leaveNum: 0,
        address: '',
        contractName: ''
      },
      formRule: {},
      title: [{
        title: '学生ID',
        fixed: 'left',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          if (row.seeStdDetail === true) {
            return h('a', { on: { click: function click() {
                  return _this.openInfoModal(row.uid);
                } } }, row.uid);
          }
          return h('a', row.uid);
        }
      }, {
        title: '学生姓名',
        width: 150,
        align: 'center',
        key: 'nickname',
        fixed: 'left'
      }, {
        title: '订单类型',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var channel = row.channel;
          var channelEnum = $constant.getEnum($constant.orderChannel, channel);
          return h('div', channelEnum && channelEnum.text);
        },
        key: 'channel'
      }, {
        title: '订单号',
        width: 150,
        align: 'center',
        key: 'orderId'
      }, {
        title: '外教课节',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchChannel === 1) {
            return h('span', row.num);
          }
          return h('div', [h('a', { on: { click: function click() {
                return _this.showOrderClassHour(row);
              } } }, row.num)]);
        }
      }, {
        title: '赠送课时',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchChannel === 1) {
            return h('span', row.discountNum);
          }
          return h('span', '<<-看左边');
        }
      }, {
        title: '套餐金额',
        width: 100,
        key: 'amount',
        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.amount).format('0,0.00'));
        }
      }, {
        title: '优惠金额',
        width: 100,
        key: 'discount',
        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.discount).format('0,0.00'));
        }
      }, {
        title: '实付金额',
        width: 120,
        key: 'payAmount',
        align: 'center',
        render: function render(h, params) {
          return h('span', $numeral(params.row.payAmount).format('0,0.00'));
        }
      }, {
        title: '支付状态',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var state = params.row.state;
          var stateEnum = $constant.getEnum($constant.fundPackageState, state);
          return h('div', stateEnum && stateEnum.text);
        }
      }, {
        title: '课程类型',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.tchChannel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '支付方式',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var payWay = params.row.payWay;
          var stateEnum = $constant.getEnum($constant.payWayNew, payWay);
          return h('div', stateEnum && stateEnum.text);
        }
      }, {
        title: '支付凭证',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.url) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看凭证');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '绑定老师',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchBoundNum && row.tchBoundNum > 0) {
            var list = row.bookWorkLessonOpenedTimeList;
            var spanArr = [];
            var scoreMap = _this.rankScoreMap || {};
            if (list) {
              list.forEach(function (element) {
                var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                spanArr.push(h('span', [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["a" /* renderTchNameWithScore */])(h, { text: element.tchId + '-' + element.tchName, score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
                spanArr.push(h('br'));
              });
            }
            var levelTitle = row.levelTitle;
            if (levelTitle) {
              levelTitle = '当前等级：' + levelTitle;
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', levelTitle), h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '试听课外教',
        width: 180,
        align: 'center',
        key: 'demoTchName',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.demoTchName,
            score: row.monthRankScoreDemo
          });
        }
      }, {
        title: '创建人',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var creatorId = params.row.creatorId;
          var creatorName = params.row.creatorName;
          return h('div', [h('span', creatorId), h('br'), h('span', creatorName)]);
        }
      }, {
        title: '创建时间',
        width: 170,
        align: 'center',
        key: 'createTime',
        sortable: 'custom',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '支付时间',
        width: 170,
        align: 'center',
        key: 'lastPayTime',
        sortable: 'custom',
        render: function render(h, params) {
          return h('span', params.row.lastPayTime);
        }
      }, {
        title: '审核人',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var auditId = params.row.auditId;
          var auditName = params.row.auditName;
          return h('div', [h('span', auditId), h('br'), h('span', auditName)]);
        }
      }, {
        title: '审核时间',
        width: 170,
        align: 'center',
        key: 'auditTime',
        sortable: 'custom',
        render: function render(h, params) {
          var auditTime = params.row.auditTime;
          return h('span', auditTime);
        }
      }, {
        title: '合同确认时间',
        width: 170,
        align: 'center',
        key: 'contractConfirmDate',
        sortable: 'custom'
      }, {
        title: '合同确认人',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var confirmUser = params.row.confirmUser;
          if (!confirmUser) {
            confirmUser = '';
          }
          var style = {};
          if (confirmUser === '学生本人') {
            style.color = '#19be6b';
          } else if (confirmUser === '系统自动确认') {
            style.color = '#ff9900';
          }
          return h('span', { style: style }, confirmUser);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 130,
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'onPreview' } }, '预览合同'));
          btn.push(h('Dropdown-item', { props: { name: 'uploadVoucher' } }, '上传凭证'));
          if (row.state === 0 || row.state === 1 || params.row.state === 4 || params.row.state === 5) {
            btn.push(h('Dropdown-item', { props: { name: 'onOpen' } }, '开启合同'));
          }
          if (row.state !== 3) {
            btn.push(h('Dropdown-item', { props: { name: 'closeOrder' } }, '关闭合同'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'sendContract' } }, '发送合同'));
          if (params.row.state !== 3) {
            btn.push(h('Dropdown-item', { props: { name: 'onPrint' } }, '打印凭据'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'delOrder' } }, '删除订单'));
          if (row.contractVersion === 2 || row.tchChannel === 2) {
            btn.push(h('Dropdown-item', { props: { name: 'editContract' } }, '编辑合同'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'onEdit' } }, '编辑'));
          btn.push(h('Dropdown-item', { props: { name: 'giftOrder' } }, '赠送礼品'));

          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'onEdit') {
                  self.onEdit(row);
                } else if (name === 'onPreview') {
                  self.onPreview(row);
                } else if (name === 'editContract') {
                  self.editContract(row);
                } else if (name === 'uploadVoucher') {
                  self.uploadVoucher(row);
                } else if (name === 'onPrint') {
                  self.onPrint(row);
                } else if (name === 'onOpen') {
                  self.onOpen(row);
                } else if (name === 'onActivate') {
                  self.onActivate(row);
                } else if (name === 'closeOrder') {
                  self.closeOrder(row);
                } else if (name === 'hideContract') {
                  self.hideContract(row);
                } else if (name === 'delOrder') {
                  self.delOrder(row);
                } else if (name === 'sendContract') {
                  self.sendContract(row);
                } else if (name === 'financialAudit') {
                  self.financialAudit(row);
                } else if (name === 'giftOrder') {
                  self.openGift(row);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;

    var depLeader = this.$store.get('depLeader');
    if (depLeader !== true) {
      self.isDepLeader = false;

      queryParam.creatorId = this.$store.get('id');
    }

    this.$http.post('/adminUser/listByCondition', { status: 1, groupIds: [4, 10] }).then(function (res) {
      self.adminUser = res.data;
    });
    this.$http.post('/adminUser/listByCondition', { status: 1, idSet: [224, 581, 360, 462] }).then(function (res) {
      self.adminUserAudit = res.data;
    });

    this.$http.post('/common/getPermissionByUrl', { url: '/fundPackage/insertOther' }).then(function (res) {
      if (res.data) {
        self.showAddOtherButton = false;
      }
    });
  },
  created: function created() {
    this.queryParam.startTimeDate = this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
    this.filterStatistic();
  },
  methods: {
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookTestList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    search: function search() {
      this.reload = new Date().getTime();
      this.filterStatistic();
    },
    search2: function search2() {
      this.reload = new Date().getTime();
    },
    startTimeDateChange: function startTimeDateChange(value) {
      if (value) {
        this.queryParam.startTimeDate = value;
      } else {
        this.queryParam.startTimeDate = '';
      }
    },
    endTimeDateChange: function endTimeDateChange(value) {
      if (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
        this.queryParam.endTimeDate = value;
      } else {
        this.queryParam.endTime = '';
        this.queryParam.endTimeDate = '';
      }
    },
    startCreateDateChange: function startCreateDateChange(value) {
      if (value) {
        this.queryParam.startCreateDate = value;
      } else {
        this.queryParam.startCreateDate = '';
      }
    },
    endCreateDateChange: function endCreateDateChange(value) {
      if (value) {
        this.queryParam.endCreateDate = value;
      } else {
        this.queryParam.endCreateDate = '';
      }
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;

      if (!loading) {
        this.loadBoundTchMonthScores();
      }
    },
    loadBoundTchMonthScores: function loadBoundTchMonthScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        this.rankScoreMap = {};
        return;
      }
      var ids = [];
      table.forEach(function (row) {
        var list = row.bookWorkLessonOpenedTimeList || [];
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId);
          }
        });
        if (row.demoTchId != null) {
          ids.push(row.demoTchId);
        }
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        self.rankScoreMap = map || {};
        table.forEach(function (row) {
          var score = map[row.demoTchId];
          if (score == null) {
            score = map[String(row.demoTchId)];
          }
          self.$set(row, 'monthRankScoreDemo', score == null ? null : score);
        });
      });
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    delAll: function delAll() {
      this.$refs.dataList.delAll();
    },
    onEdit: function onEdit(row) {
      this.editData = row;
      this.editModal = true;
    },
    onPreview: function onPreview(row) {
      var self = this;
      if (row.tchChannel === 1) {
        if (row.contractVersion === 2) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id);
          } else {
            window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id);
          }
        } else {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid);
          } else {
            window.open('https://test-student.kouyujie.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid);
          }
        }
      } else if (row.tchChannel === 2) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id);
        } else {
          window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id);
        }
      }
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    uploadVoucher: function uploadVoucher(row) {
      this.editData = row;
      if (row.payTime) {
        this.editData.payTime = row.payTime * 1000;
      }
      this.addVoucherModal = true;
    },
    openGift: function openGift(row) {
      this.giftOrderId = row.orderId;
      this.giftModal = true;
    },
    editContract: function editContract(row) {
      this.$router.push({ path: '/student-contract', query: { row: row } });
    },
    onPrint: function onPrint(row) {
      if (row.id <= 17209) {
        this.$router.push({ path: '/order/userCredential2?orderSn=' + row.orderId });
      } else {
        this.$router.push({ path: '/order/userCredential?orderSn=' + row.orderId });
      }
    },
    onOpen: function onOpen(row) {
      var _this2 = this;

      this.$http.get('/fundPackage/openFundPackage', { params: { id: row.id } }).then(function (res) {
        if (res && res.data > 0) {
          _this2.$Message.success('合同开启成功!');
          _this2.search();
        }
      });
    },
    financialAudit: function financialAudit(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认该订单审核通过？',
        width: 300,
        okText: '确认通过',
        onOk: function onOk() {
          self.$http.get('/fundPackage/financialAudit', { params: { id: row.id } }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('合同审核成功!');
              self.$Modal.remove();
              self.search();
            }
          });
        }
      });
    },
    onActivate: function onActivate(row) {
      var _this3 = this;

      this.$http.get('/fundPackage/activateFundPackage', { params: { id: row.id } }).then(function (res) {
        if (res && res.data > 0) {
          _this3.$Message.success('激活成功!');
          _this3.search();
        }
      });
    },
    exportData: function exportData() {
      var _this4 = this;

      this.exportLoading = true;
      var params = {};
      this.$helper.mergeProperties(this.queryParam, params);
      this.$http.get('/fundPackage/export', { responseType: 'arraybuffer', params: params }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '订单列表.csv';
          link.click();
          _this4.exportLoading = false;
        } else {
          _this4.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this4.exportLoading = false;
        _this4.$Message.error('无权限');
      });
    },
    closeOrder: function closeOrder(row) {
      var _this5 = this;

      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">关闭</span>该合同?',
        width: 300,
        okText: '确认关闭',
        loading: true,
        onOk: function onOk() {
          _this5.$http.get('/fundPackage/closeOrder', { params: { orderSn: row.orderId } }).then(function (res) {
            if (res && res.data > 0) {
              _this5.$Message.success('关闭成功');
              _this5.$Modal.remove();
              _this5.search();
            }
          });
        }
      });
    },
    hideContract: function hideContract(row) {
      var _this6 = this;

      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">' + row.enabled === true ? '隐藏' : '显示' + '</span>该合同?',
        width: 300,
        okText: row.enabled === true ? '确认隐藏' : '确认显示',
        loading: true,
        onOk: function onOk() {
          _this6.$http.get('/fundPackage/hideContract', { params: { fundPackageId: row.id, enabled: !row.enabled } }).then(function (res) {
            if (res && res.data > 0) {
              _this6.$Message.success('操作成功');
              _this6.$Modal.remove();
              _this6.search();
            }
          });
        }
      });
    },
    delOrder: function delOrder(row) {
      var _this7 = this;

      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">删除</span>当前订单?',
        width: 300,
        okText: '确认删除',
        loading: true,
        onOk: function onOk() {
          _this7.$http.get('/fundPackage/delOrder', { params: { orderSn: row.orderId } }).then(function (res) {
            if (res && res.data > 0) {
              _this7.$Message.success('删除成功');
              _this7.$Modal.remove();
              _this7.search();
            }
          });
        }
      });
    },
    sendContract: function sendContract(row) {
      var _this8 = this;

      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">发送短信</span>提醒用户签署?',
        width: 300,
        okText: '确认发送',
        loading: true,
        onOk: function onOk() {
          _this8.$http.get('/fundPackage/sendContract', { params: { id: row.id } }).then(function (res) {
            if (res && res.status === 'ok') {
              _this8.$Message.success('发送成功');
              _this8.$Modal.remove();
            }
          });
        }
      });
    },
    edit: function edit() {
      var self = this;
      self.loadingEdit = true;
      self.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEdit = false;
          return;
        }
        var path = '/fundPackage/save';
        self.$http.post(path, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.editModal = false;
            self.$Message.success('提交成功!');
            self.search();
          }
          self.loadingEdit = false;
        });
      });
    },
    filterStatistic: function filterStatistic() {
      var _this9 = this;

      this.$http.get('/fundPackage/statistics', { params: this.queryParam }).then(function (res) {
        _this9.filterStatistics = res.data;
      });
    },
    showOrderClassHour: function showOrderClassHour(row) {
      this.uid = row.uid;
      this.totalNum = row.num;
      this.fundPackageId = row.id;
      this.showOrderClassHourModal = true;
    },
    handleSortChange: function handleSortChange(column, key, order) {
      delete this.queryParam.sorts;

      if (order && order !== 'normal') {
        this.queryParam.sorts = [{
          property: key,
          direction: order
        }];
      }

      this.search2();
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderClassHourModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fundPackageId: {
      type: Number
    },
    totalNum: {
      type: Number
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      dataList: [],
      column: [{
        title: '数量(节|次)',
        width: 135,
        align: 'center',
        key: 'num'
      }, {
        title: '订单类型',
        width: 135,
        align: 'center',
        key: 'type'
      }, {
        title: '权益',
        width: 135,
        align: 'center',
        key: 'channel'
      }, {
        title: '权益说明',
        width: 135,
        align: 'center',
        key: 'remark'
      }, {
        title: '有效期(天)',
        width: 135,
        align: 'center',
        key: 'effectDays'
      }, {
        title: '操作人)',
        width: 135,
        align: 'center',
        key: 'creatorName'
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      self.$http.get('/fundPackage/list-order-class-hour', { params: { fundPackageId: self.fundPackageId, uid: self.uid } }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.dataList = res.data;
        self.visible = true;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderGiftModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: this.value,
      giftName: '',
      saving: false,
      records: []
    };
  },

  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.$emit('input', val);
      if (!val) {
        this.$emit('on-close');
      }
    },
    orderId: function orderId() {
      if (this.visible) {
        this.loadList();
      }
    }
  },
  methods: {
    onVisible: function onVisible(val) {
      if (val) {
        this.giftName = '';
        this.loadList();
      }
    },
    loadList: function loadList() {
      var self = this;
      if (!self.orderId) {
        self.records = [];
        return;
      }
      self.$http.get('/fundPackage/gift/list', { params: { orderId: self.orderId } }).then(function (res) {
        self.records = res.data || [];
      });
    },
    save: function save() {
      var self = this;
      var name = (self.giftName || '').trim();
      if (!name) {
        self.$Message.warning('请输入礼品名称');
        return;
      }
      if (!self.orderId) {
        self.$Message.warning('订单编号不能为空');
        return;
      }
      self.saving = true;
      self.$http.post('/fundPackage/gift/insert', { orderId: self.orderId, giftName: name }).then(function (res) {
        if (res && (res.status === 'ok' || res.data > 0)) {
          self.$Message.success('保存成功');
          self.giftName = '';
          self.loadList();
        }
        self.saving = false;
      }).catch(function () {
        self.saving = false;
      });
    },
    formatTime: function formatTime(v) {
      if (!v) {
        return '';
      }
      if (typeof v === 'string') {
        return v.replace('T', ' ');
      }
      if (Object.prototype.toString.call(v) === '[object Array]' && v.length >= 3) {
        var p = function p(n) {
          return n < 10 ? '0' + n : '' + n;
        };
        return v[0] + '-' + p(v[1]) + '-' + p(v[2]) + ' ' + p(v[3] || 0) + ':' + p(v[4] || 0);
      }
      return v;
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PerformanceDetail',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        weekStart: '',
        startDate: '',
        endDate: '',
        weeks: 1,
        salesDealRate: null,
        channelDealRate: null,
        channelId: ''
      },
      fromSalesDealRate: false,
      fromChannelDealRate: false,
      adviserName: '',
      tableData: []
    };
  },

  computed: {
    weekLabel: function weekLabel() {
      if (this.queryParam.startDate && this.queryParam.endDate && (this.fromSalesDealRate || this.fromChannelDealRate)) {
        return this.queryParam.startDate + ' ~ ' + this.queryParam.endDate;
      }
      if (!this.queryParam.weekStart) {
        return '';
      }
      var start = this.$moment(this.queryParam.weekStart, 'YYYY-MM-DD');
      if (!this.fromSalesDealRate && this.fromChannelDealRate) {
        var weekStart = start.clone().startOf('isoWeek');
        var weekEnd = weekStart.clone().add(6, 'days');
        return weekStart.format('YYYY-MM-DD') + ' ~ ' + weekEnd.format('YYYY-MM-DD');
      }
      var days = this.fromSalesDealRate ? this.queryParam.weeks * 7 - 1 : 6;
      var end = start.clone().add(days, 'days');
      return start.format('YYYY-MM-DD') + ' ~ ' + end.format('YYYY-MM-DD');
    }
  },
  created: function created() {
    var adviserId = this.$route.query.adviserId;
    var month = this.$route.query.month;
    var salesDealRate = this.$route.query.salesDealRate;
    var weekStart = this.$route.query.weekStart;
    var channelDealRate = this.$route.query.channelDealRate;
    var channelId = this.$route.query.channelId;
    var startDate = this.$route.query.startDate;
    var endDate = this.$route.query.endDate;

    if (adviserId) {
      this.queryParam.adviserId = adviserId;
    }
    if (month) {
      this.queryParam.month = month;
    }
    if (salesDealRate == 1 || salesDealRate === '1') {
      this.fromSalesDealRate = true;
      this.queryParam.salesDealRate = 1;
      if (startDate && endDate) {
        this.queryParam.startDate = startDate;
        this.queryParam.endDate = endDate;
        this.queryParam.weekStart = startDate;
      } else {
        var weeks = this.$route.query.weeks;
        this.queryParam.weeks = String(weeks) === '8' ? 8 : 1;
        if (weekStart) {
          this.queryParam.weekStart = weekStart;
        }
      }
    }
    if (channelDealRate === 1 || channelDealRate === '1') {
      this.fromChannelDealRate = true;
      this.queryParam.channelDealRate = 1;
      if (startDate && endDate) {
        this.queryParam.startDate = startDate;
        this.queryParam.endDate = endDate;
        this.queryParam.weekStart = startDate;
      } else if (weekStart) {
        this.queryParam.weekStart = weekStart;
      }
      if (channelId !== undefined && channelId !== null && channelId !== '') {
        this.queryParam.channelId = channelId;
      }
    }

    this.search();
  },

  methods: {
    onMonthChange: function onMonthChange(val) {
      this.queryParam.month = val;
    },
    salesQueryParams: function salesQueryParams() {
      var params = {
        salesDealRate: 1,
        adviserId: this.queryParam.adviserId
      };
      if (this.queryParam.startDate && this.queryParam.endDate) {
        params.startDate = this.queryParam.startDate;
        params.endDate = this.queryParam.endDate;
        params.weekStart = this.queryParam.startDate;
      } else {
        params.weekStart = this.queryParam.weekStart;
        params.weeks = this.queryParam.weeks;
      }
      return params;
    },
    channelQueryParams: function channelQueryParams() {
      var params = {
        channelDealRate: 1,
        weekStart: this.queryParam.weekStart,
        channelId: this.queryParam.channelId
      };
      if (this.queryParam.startDate && this.queryParam.endDate) {
        params.startDate = this.queryParam.startDate;
        params.endDate = this.queryParam.endDate;
        params.weekStart = this.queryParam.startDate;
      }
      return params;
    },
    search: function search() {
      var _this = this;

      this.searchLoading = true;

      this.$http.get('/fundPackage/performanceDetail', {
        params: this.fromSalesDealRate ? this.salesQueryParams() : this.fromChannelDealRate ? this.channelQueryParams() : {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId
        }
      }).then(function (res) {
        if (res && res.data) {
          _this.processData(res.data);
        }
        _this.searchLoading = false;
      }).catch(function () {
        _this.searchLoading = false;
      });
    },
    processData: function processData(data) {
      if (!data) {
        this.tableData = [];
        return;
      }

      this.adviserName = data.adviserName || '';
      this.tableData = (data.list || []).map(function (item) {
        if (item.trialLessonTeachers && item.trialLessonTeachers.length > 0) {
          item.selectedTeacher = item.trialLessonTeachers.includes(item.foreignTeacher) ? item.foreignTeacher : null;
        } else {
          item.selectedTeacher = null;
        }
        return item;
      });
    },
    goBack: function goBack() {
      if (this.fromSalesDealRate) {
        var startDate = this.queryParam.startDate;
        var endDate = this.queryParam.endDate;
        var query = void 0;
        if (startDate && endDate) {
          query = {
            startDate: startDate,
            endDate: endDate
          };
        } else {
          query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart,
            weeks: this.queryParam.weeks || this.$route.query.weeks
          };
        }
        this.$router.push({
          path: '/crm/SalesDealRate',
          query: query
        });
        return;
      }
      if (this.fromChannelDealRate) {
        var _startDate = this.queryParam.startDate;
        var _endDate = this.queryParam.endDate;
        var _query = void 0;
        if (_startDate && _endDate) {
          _query = {
            startDate: _startDate,
            endDate: _endDate
          };
        } else {
          _query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart
          };
        }
        if (this.$route.query.marketCategory) {
          _query.marketCategory = this.$route.query.marketCategory;
        }
        this.$router.push({
          path: '/market/ChannelDealRate',
          query: _query
        });
        return;
      }
      this.$router.push({ path: '/order/dragonTigerListV2' });
    },
    getChannelClass: function getChannelClass(channel) {
      if (!channel) return '';
      if (channel.includes('市场')) return 'channel-market';
      if (channel.includes('转介绍')) return 'channel-referral';
      if (channel.includes('结课新签')) return 'channel-renew';
      return '';
    },
    getFunctionClass: function getFunctionClass(functionCover) {
      if (!functionCover) return '';
      if (functionCover.includes('补升')) return 'function-upgrade';
      if (functionCover.includes('续费')) return 'function-renew';
      return '';
    },
    handleRemarkChange: function handleRemarkChange(item) {
      var _this2 = this;

      if (item.saveTimer) clearTimeout(item.saveTimer);
      item.saveTimer = setTimeout(function () {
        _this2.saveRemark(item);
      }, 500);
    },
    saveRemark: function saveRemark(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (item.fundPackageId) {
                  _context.next = 3;
                  break;
                }

                _this3.$Message.warning('缺少 fundPackageId，无法保存');
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _this3.$http.post('/fundPackage/updateRemark', {
                  fundPackageId: item.fundPackageId,
                  remark: item.remark || ''
                });

              case 6:
                _this3.$Message.success('备注已保存');
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                _this3.$Message.error('保存失败，请重试');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 9]]);
      }))();
    },
    handleTeacherChange: function handleTeacherChange(item) {
      var _this4 = this;

      if (item.teacherTimer) clearTimeout(item.teacherTimer);
      item.teacherTimer = setTimeout(function () {
        _this4.saveForeignTeacher(item);
      }, 500);
    },
    saveForeignTeacher: function saveForeignTeacher(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedTeacherName;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (item.fundPackageId) {
                  _context2.next = 3;
                  break;
                }

                _this5.$Message.warning('缺少 fundPackageId，无法保存');
                return _context2.abrupt('return');

              case 3:
                selectedTeacherName = item.selectedTeacher;

                if (selectedTeacherName) {
                  _context2.next = 7;
                  break;
                }

                _this5.$Message.warning('未选择老师');
                return _context2.abrupt('return');

              case 7:
                _context2.prev = 7;
                _context2.next = 10;
                return _this5.$http.post('/fundPackage/updateRemark', {
                  fundPackageId: item.fundPackageId,
                  demoTch: selectedTeacherName || ''
                });

              case 10:
                item.foreignTeacher = selectedTeacherName;
                _this5.$Message.success('成交外教已更新');
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](7);

                _this5.$Message.error('更新失败，请重试');

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[7, 14]]);
      }))();
    },
    exportData: function exportData() {
      var _this6 = this;

      this.exportLoading = true;

      this.$http.get('/fundPackage/performanceDetail/export', {
        responseType: 'arraybuffer',
        params: this.fromSalesDealRate ? this.salesQueryParams() : this.fromChannelDealRate ? this.channelQueryParams() : {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId
        }
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          var suffix = _this6.fromSalesDealRate || _this6.fromChannelDealRate ? _this6.queryParam.startDate || _this6.queryParam.weekStart : _this6.queryParam.month;
          link.download = '\u4E1A\u7EE9\u8BE6\u60C5-' + _this6.adviserName + '-' + suffix + '.xlsx';
          link.click();
          _this6.$Message.success('导出成功');
        } else {
          _this6.$Message.error(response.msg || '导出失败');
        }
        _this6.exportLoading = false;
      }).catch(function (error) {
        _this6.$Message.error('导出失败：' + error.message);
        _this6.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerformanceModel_vue__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerformanceModel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PerformanceModel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShowImageCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_src_components_grid_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tchScore__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PerformanceModel: __WEBPACK_IMPORTED_MODULE_0__PerformanceModel_vue___default.a, ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_1__ShowImageCarousel_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var self = this;
    return {
      top: 260,
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      showImgModal: false,
      showImgList: [],
      queryParam: {
        uid: null,
        recommendId: null,
        recommendName: '',
        channel: null,
        payWay: null,
        isReceive: null,
        depmId: null,
        teamType: null,
        adminName: '',
        studyAdviser: '',
        adviserName: '',
        payStartTime: '',
        payStartTimeDate: '',
        payEndTime: null,
        regStartTime: null,
        regEndTime: null,
        refundStartTime: null,
        refundEndTime: null,
        orderId: '',
        orderCode: '',
        receiveType: null,
        regType: '',
        agentOrder: null,
        materialVersion: null
      },
      payEndTime: null,
      refundStartTime: null,
      refundEndTime: null,
      regStartTime: null,
      regEndTime: null,
      showEditPerfModel: false,
      formData: {
        id: null,
        receiveType: null,
        money: null,
        time: null,
        remark: '',
        invoiceTime: null,
        invoiceMoney: null,
        isRushRed: null,
        refundMoney: null,
        refundTime: null
      },
      isEditisReceive: false,
      pData: {
        time: null,
        invoiceTime: null,
        refundTime: null
      },
      rowId: null,
      title: [{
        title: '序号',
        width: 80,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          return h('span', params.row._index + 1);
        }
      }, {
        title: '订单id',
        width: 120,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var row = params.row;
          var agentOrder = row.agentOrder;
          if (agentOrder === 1) {
            return h('span', [h('span', row.orderId), h('span', { style: { color: 'red' } }, '(代)')]);
          } else {
            return h('span', row.orderId);
          }
        }
      }, {
        title: '是否到账',
        width: 150,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var isReceive = params.row.isReceive;
          var propsYes = { size: 'mini' };
          var propsNo = { size: 'mini' };
          if (isReceive === 1) {
            propsYes = { type: 'primary', size: 'mini' };
          } else if (isReceive === 0) {
            propsNo = { type: 'primary', size: 'mini' };
          }
          return h('el-row', [h('el-button', { props: propsYes,
            on: { click: function click() {
                params.row.isReceive = 1;
                self.editPerformance(params.row, true);
              } } }, '是'), h('el-button', { props: propsNo,
            on: { click: function click() {
                params.row.isReceive = 0;
                self.editPerformance(params.row, true);
              } } }, '否')]);
        }
      }, {
        title: '签约渠道',
        width: 120,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var channel = params.row.channel;
          var orderChannel = $constant.getEnum($constant.orderChannel, channel);
          return h('span', orderChannel && orderChannel.text);
        }
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        fixed: 'left',
        key: 'regType'
      }, {
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var uid = params.row.uid;
          var stuName = params.row.stuName;
          return h('span', uid + '-' + stuName);
        }
      }, {
        title: '学习账号',
        width: 130,
        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '绑定老师',
        width: 270,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchBoundNum && row.tchBoundNum > 0) {
            var list = row.bookWorkLessonOpenedTimeList;
            var spanArr = [];
            var scoreMap = _this.rankScoreMap || {};
            if (list) {
              list.forEach(function (element) {
                var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                spanArr.push(h('span', [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["a" /* renderTchNameWithScore */])(h, { text: element.tchId + '-' + element.tchName + '-', score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }), h('span', { style: { color: '#FF6103' } }, '外管' + '-' + element.tchAdviserNickname), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
                spanArr.push(h('br'));
              });
            }
            var levelTitle = row.levelTitle;
            if (levelTitle) {
              levelTitle = '当前等级：' + levelTitle;
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', levelTitle), h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '部门',
        width: 100,
        align: 'center',
        key: 'department'
      }, {
        title: '团队',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var teamType = params.row.teamType;
          if (teamType) {
            var team = $constant.getEnum($constant.adviserGroup, teamType);
            return h('span', team && team.text);
          }
          return h('span', null);
        }
      }, {
        title: '签单人',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var adminName = params.row.adminName;
          return h('span', adminName);
        }
      }, {
        title: '学导',
        width: 100,
        align: 'center',
        key: 'studyAdviser'
      }, {
        title: '课程顾问',
        width: 100,
        align: 'center',
        key: 'adviserName'
      }, {
        title: '付款金额',
        width: 100,
        align: 'center',
        key: 'amount'
      }, {
        title: '核算金额',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var amount = params.row.amount;
          var payWay = params.row.payWay;
          if (payWay === 4) {
            return h('span', Number(amount * 0.94).toFixed(2));
          }
          return h('span', amount);
        }
      }, {
        title: '外教课节',
        width: 95,
        align: 'center',
        key: 'num'
      }, {
        title: '赠送课时',
        width: 95,
        align: 'center',
        key: 'discountNum'
      }, {
        title: '付款时间',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var time = params.row.payTime;
          return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '第三方付款码',
        key: 'orderCode',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.orderCode) {
            return h('span', row.orderCode);
          } else if (row.url) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看凭证');
          }
          return h('span', '');
        }
      }, {
        title: '到帐方式',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var type = params.row.receiveType;
          var receiveType = $constant.getEnum($constant.receiveType, type);
          return h('span', receiveType && receiveType.text);
        }
      }, {
        title: '到帐金额',
        width: 120,
        align: 'center',
        key: 'money'
      }, {
        title: '到账时间',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var time = params.row.time;
          return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '备注',
        width: 110,
        align: 'center',
        key: 'remark'
      }, {
        title: '开票时间',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var time = params.row.invoiceTime;
          return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '开票金额',
        width: 120,
        align: 'center',
        key: 'invoiceMoney'
      }, {
        title: '退票冲红',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var val = params.row.isRushRed;
          var isRushRed = $constant.getEnum($constant.yesNoNum, val);
          return h('span', isRushRed && isRushRed.text);
        }
      }, {
        title: '退款金额',
        width: 120,
        align: 'center',
        key: 'refundMoney'
      }, {
        title: '退款时间',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var val = params.row.refundTime;
          return h('span', val && $moment(val, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          return h('el-row', [h('el-button', { props: { size: 'mini', type: 'text' },
            on: { click: function click() {
                self.editPerformance(params.row, false);
              } } }, '编辑')]);
        }
      }, {
        title: '推荐人ID',
        width: 120,
        align: 'center',
        key: 'recommendId'
      }, {
        title: '推荐人学导',
        width: 120,
        align: 'center',
        key: 'recommendName'
      }, {
        title: '付款方式',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var payWay = params.row.payWay;
          if (payWay !== null) {
            var p = $constant.getEnum($constant.payWay2, payWay);
            return h('span', p && p.text);
          }
          return h('span', null);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query.receiveType) {
      this.queryParam.receiveType = parseInt(query.receiveType);
    }
    if (query.payWay) {
      this.queryParam.payWay = parseInt(query.payWay);
    }
    if (query.isReceive) {
      this.queryParam.isReceive = parseInt(query.isReceive);
    }
    if (query.channel) {
      this.queryParam.channel = parseInt(query.channel);
    }
    if (query.regType) {
      this.queryParam.regType = query.regType;
    }
    if (query.teamType) {
      this.queryParam.teamType = parseInt(query.teamType);
    }
    if (query.uid) {
      this.queryParam.uid = parseInt(query.uid);
    }
    if (query.recommendId) {
      this.queryParam.recommendId = parseInt(query.recommendId);
    }
    if (query.recommendName) {
      this.queryParam.recommendName = query.recommendName;
    }
    if (query.depmId) {
      this.queryParam.depmId = parseInt(query.depmId);
    }
    if (query.adminName) {
      this.queryParam.adminName = query.adminName;
    }
    if (query.studyAdviser) {
      this.queryParam.studyAdviser = query.studyAdviser;
    }
    if (query.adviserName) {
      this.queryParam.adviserName = query.adviserName;
    }
    if (query.orderId) {
      this.queryParam.orderId = query.orderId;
    }
    if (query.orderCode) {
      this.queryParam.orderCode = query.orderCode;
    }
    if (query.payStartTime) {
      this.queryParam.payStartTime = parseInt(query.payStartTime) * 1000;
    }
    if (query.payEndTime) {
      this.payEndTime = parseInt(query.payEndTime) * 1000;
    }
    if (query.regStartTime) {
      this.regStartTime = parseInt(query.regStartTime) * 1000;
    }
    if (query.regEndTime) {
      this.regEndTime = parseInt(query.regEndTime) * 1000;
    }
    if (query.refundStartTime) {
      this.refundStartTime = parseInt(query.refundStartTime) * 1000;
    }
    if (query.refundEndTime) {
      this.refundEndTime = parseInt(query.refundEndTime) * 1000;
    }
  },

  created: function created() {

    var startTime = this.queryParam.payStartTime;
    if (startTime !== '') {
      this.queryParam.payStartTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-24, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.payStartTimeDate = momentDate.toDate();
      this.queryParam.payStartTime = momentDate.format('X');
    }
  },

  methods: {
    search: function search() {

      if (this.payEndTime) {
        this.queryParam.payEndTime = this.payEndTime / 1000;
      } else {
        this.queryParam.payEndTime = null;
      }
      if (this.regStartTime) {
        this.queryParam.regStartTime = this.regStartTime / 1000;
      } else {
        this.queryParam.regStartTime = null;
      }
      if (this.regEndTime) {
        this.queryParam.regEndTime = this.regEndTime / 1000;
      } else {
        this.queryParam.regEndTime = null;
      }
      if (this.refundStartTime) {
        this.queryParam.refundStartTime = this.refundStartTime / 1000;
      } else {
        this.queryParam.refundStartTime = null;
      }
      if (this.refundEndTime) {
        this.queryParam.refundEndTime = this.refundEndTime / 1000;
      } else {
        this.queryParam.refundEndTime = null;
      }
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;

      if (!loading) {
        this.loadBoundTchMonthScores();
      }
    },
    loadBoundTchMonthScores: function loadBoundTchMonthScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        this.rankScoreMap = {};
        return;
      }
      var ids = [];
      table.forEach(function (row) {
        var list = row.bookWorkLessonOpenedTimeList || [];
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId);
          }
        });
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        self.rankScoreMap = map || {};
      });
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    payStartTimeChange: function payStartTimeChange(val) {
      this.queryParam.payStartTime = val && this.$moment(val, 'YYYY-M-D H:m').format('X');
    },
    payEndTimeChange: function payEndTimeChange(val) {
      if (val) {
        this.queryParam.payEndTime = val / 1000;
      } else {
        this.queryParam.payEndTime = null;
      }
    },
    regStartTimeChange: function regStartTimeChange(val) {
      if (val) {
        this.queryParam.regStartTime = val / 1000;
      } else {
        this.queryParam.regStartTime = null;
      }
    },
    regEndTimeChange: function regEndTimeChange(val) {
      if (val) {
        this.queryParam.regEndTime = val / 1000;
      } else {
        this.queryParam.regEndTime = null;
      }
    },
    refundStartTimeChange: function refundStartTimeChange(val) {
      if (val) {
        this.queryParam.refundStartTime = val / 1000;
      } else {
        this.queryParam.refundStartTime = null;
      }
    },
    refundEndTimeChange: function refundEndTimeChange(val) {
      if (val) {
        this.queryParam.refundEndTime = val / 1000;
      } else {
        this.queryParam.refundEndTime = null;
      }
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      var params = {};
      this.$helper.mergeProperties(this.queryParam, params);
      this.$http.get('/performance/export', { responseType: 'arraybuffer', params: params }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '业绩统计.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
        _this2.$Message.error('无权限');
      });
    },
    editPerformance: function editPerformance(row, isEditisReceive) {
      if (row.isReceive === 1 && isEditisReceive) {
        var self = this;
        this.$http.post('/performance/update', { id: row.id, isReceive: row.isReceive }).then(function (res) {
          if (res && res.data > 0) {
            self.search();
          }
        });
      } else {
        this.top = parseInt((row._index + 1) * 64 + 200);
        if (this.top < 530) {
          this.$refs.tmodal.$el.lastChild.style.paddingTop = this.top + 'px';
        } else {
          this.$refs.tmodal.$el.lastChild.style.paddingTop = this.top - 380 - window.scrollY + 'px';
        }
        this.showEditPerfModel = true;
        this.isEditisReceive = isEditisReceive;
        this.formData.id = row.id;
        this.formData.isReceive = row.isReceive;
        this.formData.receiveType = row.receiveType || null;
        this.formData.money = row.money || null;
        this.formData.time = row.time || null;
        if (row.time) {
          this.pData.time = row.time * 1000;
        }
        this.formData.remark = row.remark || null;
        this.formData.invoiceMoney = row.invoiceMoney || null;
        this.formData.invoiceTime = row.invoiceTime || null;
        if (row.invoiceTime) {
          this.pData.invoiceTime = row.invoiceTime * 1000;
        }
        this.formData.isRushRed = row.isRushRed;
        this.formData.refundMoney = row.refundMoney || null;
        this.formData.refundTime = row.refundTime || null;
        if (row.refundTime) {
          this.pData.refundTime = row.refundTime * 1000;
        }
      }
    }
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PerformanceModel',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    formData: {
      default: {
        id: null,
        receiveType: null,
        money: null,
        time: null,
        remark: '',
        invoiceTime: null,
        invoiceMoney: null,
        isRushRed: null,
        refundMoney: null,
        refundTime: null,
        isReceive: null
      }
    },
    isEditisReceive: {
      type: Boolean,
      default: false
    },
    pData: {
      time: null,
      invoiceTime: null,
      refundTime: null
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    editModal: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    onClose: function onClose() {
      this.pData.time = null;
      this.pData.invoiceTime = null;
      this.pData.refundTime = null;
      this.$emit('on-close');
      this.successCallback();
    },
    onSubmit: function onSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.$http.post('/performance/update', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('保存成功!');
            self.successCallback();
            self.onClose();
          }
        });
      });
    },
    changeTime: function changeTime() {
      this.formData.time = this.pData.time / 1000;
    },
    changeInvoiceTime: function changeInvoiceTime() {
      this.formData.invoiceTime = this.pData.invoiceTime / 1000;
    },
    changeRefundTime: function changeRefundTime() {
      this.formData.refundTime = this.pData.refundTime / 1000;
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowImageCarousel',
  props: {
    imgList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false,
      showList: this.imgList,
      showViewer: false,
      currentImage: '',
      initialIndex: 0,

      touchStartX: 0,
      touchStartY: 0,
      touchStartTime: 0
    };
  },

  watch: {
    value: function value(val) {
      if (val) {
        this.showModal = val;
      }
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    imgList: function imgList(val) {
      if (val) {
        this.showList = val;
      }
    }
  },
  methods: {
    handleImageClick: function handleImageClick(index) {
      this.initialIndex = index;
      this.currentImage = this.showList[index];
      this.showViewer = true;
    },
    closeViewer: function closeViewer() {
      this.showViewer = false;
    },
    handleModalVisibleChange: function handleModalVisibleChange(visible) {
      if (!visible) {
        this.showViewer = false;
      }
    },
    handleTouchStart: function handleTouchStart(e) {
      var touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchStartTime = new Date().getTime();
    },
    handleTouchMove: function handleTouchMove(e) {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    },
    handleTouchEnd: function handleTouchEnd(e) {
      var touchEndTime = new Date().getTime();
      var touchDuration = touchEndTime - this.touchStartTime;

      if (touchDuration < 300) {
        var touch = e.changedTouches[0];
        var deltaX = Math.abs(touch.clientX - this.touchStartX);
        var deltaY = Math.abs(touch.clientY - this.touchStartY);

        if (deltaX < 10 && deltaY < 10) {
          this.closeViewer();
        }
      }
    }
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudyAdviserDragonTigerList',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        tchChannel: 1
      },
      rankingData: [],
      totalAdvisers: 0,
      totalQuantity: 0,
      totalAmount: 0,
      newOrderList: []
    };
  },
  created: function created() {
    this.search();
    this.getNewOrders();
    this.timer = setInterval(this.getNewOrders, 10 * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  computed: {
    monthName: function monthName() {
      return this.$moment(this.queryParam.month).format('YYYY 年 M 月');
    }
  },
  watch: {
    'queryParam.adviserId': function queryParamAdviserId(newVal) {
      if (this.searchLoading) return;
      this.search();
    }
  },
  methods: {
    search: function search() {
      var _this = this;

      this.searchLoading = true;
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');

      this.$http.get('/fundPackage/studyAdviserDragonTigerList', {
        params: {
          month: month,
          adviserId: this.queryParam.adviserId || null,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(function (res) {
        if (res && res.data) {
          _this.processData(res.data);
        }
        _this.searchLoading = false;
      }).catch(function () {
        _this.searchLoading = false;
      });
    },
    processData: function processData(data) {
      var _this2 = this;

      if (!data) {
        this.rankingData = [];
        this.totalAdvisers = 0;
        this.totalQuantity = 0;
        this.totalAmount = 0;
        return;
      }

      this.totalAdvisers = data.totalAdvisers || 0;
      this.totalQuantity = data.totalQuantity || 0;
      this.totalAmount = data.totalAmount || 0;

      var rankingList = data.rankingList || [];

      this.rankingData = rankingList.filter(function (item) {
        return !_this2.isTotalRow(item);
      }).map(function (item) {
        return {
          rank: item.rank,
          adviserId: item.adviserId,
          adviserName: item.adviserName,
          quantity: item.completed || 0,
          amount: item.completedAmount || 0,
          canSeeDetail: item.canSeeDetail
        };
      });
    },
    getRankClass: function getRankClass(rank) {
      if (rank === 1) return 'rank-1';
      if (rank === 2) return 'rank-2';
      if (rank === 3) return 'rank-3';
      return '';
    },
    getMedalClass: function getMedalClass(rank) {
      if (rank === 1) return 'medal-gold';
      if (rank === 2) return 'medal-silver';
      if (rank === 3) return 'medal-bronze';
      return '';
    },
    getMedalIcon: function getMedalIcon(rank) {
      if (rank === 1) return '🥇';
      if (rank === 2) return '🥈';
      if (rank === 3) return '🥉';
      return rank;
    },
    isTotalRow: function isTotalRow(item) {
      if (!item) return true;
      var name = String(item.adviserName || '').replace(/\s/g, '');
      return name === 'Total' || name === '合计' || name === '汇总';
    },
    canSeeRowDetail: function canSeeRowDetail(item) {
      if (!item || this.isTotalRow(item) || !item.adviserId) {
        return false;
      }
      return !!item.canSeeDetail;
    },
    goToPerformanceDetail: function goToPerformanceDetail(item) {
      if (!this.canSeeRowDetail(item)) {
        return;
      }
      var month = this.$moment(this.queryParam.month).format('YYYY-MM');
      this.$router.push({
        path: '/order/studyAdviserPerformanceDetail',
        query: {
          month: month,
          adviserId: item.adviserId,
          tchChannel: this.queryParam.tchChannel || 1
        }
      });
    },
    exportToImage: function exportToImage() {
      var _this3 = this;

      if (this.rankingData.length === 0) {
        this.$Message.warning('暂无数据，无法导出');
        return;
      }
      this.exportLoading = true;
      var el = this.$refs.exportArea;
      __WEBPACK_IMPORTED_MODULE_1_html2canvas___default()(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        onclone: function onclone(clonedDoc) {
          var badges = clonedDoc.querySelectorAll('.medal-gold, .medal-silver, .medal-bronze');
          badges.forEach(function (badge) {
            var isGold = badge.classList.contains('medal-gold');
            var isSilver = badge.classList.contains('medal-silver');
            var number = isGold ? '1' : isSilver ? '2' : '3';
            var bgColor = isGold ? 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)' : isSilver ? 'linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%)' : 'linear-gradient(135deg, #cd7f32 0%, #e8a87c 100%)';
            var textColor = isGold ? '#8b6914' : isSilver ? '#5a5a5a' : '#8b5a2b';
            badge.innerHTML = number;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(badge.style, {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              fontWeight: '700',
              fontSize: '16px',
              background: bgColor,
              color: textColor
            });
          });
        }
      }).then(function (canvas) {
        var link = document.createElement('a');
        link.download = '班主任龙虎榜_' + _this3.$moment(_this3.queryParam.month).format('YYYY-MM') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        _this3.exportLoading = false;
        _this3.$Message.success('导出成功');
      }).catch(function () {
        _this3.exportLoading = false;
        _this3.$Message.error('导出失败');
      });
    },
    getNewOrders: function getNewOrders() {
      var self = this;
      self.$http.get('/fundPackage/studyAdviserNewOrders').then(function (res) {
        if (res && res.data) {
          self.newOrderList = res.data;
        } else {
          self.newOrderList = [];
        }
      }).catch(function () {
        self.newOrderList = [];
      });
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudyAdviserPerformanceDetail',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      noPermission: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        tchChannel: 1
      },
      adviserName: '',
      tableData: []
    };
  },
  created: function created() {
    var adviserId = this.$route.query.adviserId;
    var month = this.$route.query.month;

    if (adviserId) {
      this.queryParam.adviserId = adviserId;
    }
    if (month) {
      this.queryParam.month = month;
    }
    var tchChannel = this.$route.query.tchChannel;
    if (tchChannel !== undefined && tchChannel !== null && tchChannel !== '') {
      this.queryParam.tchChannel = Number(tchChannel) || 1;
    }

    this.search();
  },

  computed: {
    totalAmount: function totalAmount() {
      return this.tableData.reduce(function (sum, item) {
        return sum + (Number(item.amount) || 0);
      }, 0);
    }
  },
  methods: {
    onMonthChange: function onMonthChange(val) {
      this.queryParam.month = val;
    },
    search: function search() {
      var _this = this;

      this.searchLoading = true;
      this.noPermission = false;

      this.$http.get('/fundPackage/studyAdviserPerformanceDetail', {
        params: {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.processData(res.data);
        } else {
          _this.tableData = [];
          _this.adviserName = '';
          if (res && res.msg && String(res.msg).indexOf('无权限') !== -1) {
            _this.noPermission = true;
          }
        }
        _this.searchLoading = false;
      }).catch(function () {
        _this.searchLoading = false;
      });
    },
    processData: function processData(data) {
      if (!data) {
        this.tableData = [];
        return;
      }

      this.adviserName = data.adviserName || '';
      this.tableData = data.list || [];
    },
    goBack: function goBack() {
      this.$router.push({ path: '/order/studyAdviserDragonTiger' });
    },
    getChannelClass: function getChannelClass(channel) {
      if (!channel) return '';
      if (channel.includes('市场')) return 'channel-market';
      if (channel.includes('转介绍')) return 'channel-referral';
      if (channel.includes('结课新签')) return 'channel-renew';
      return '';
    },
    getFunctionClass: function getFunctionClass(functionCover) {
      if (!functionCover) return '';
      if (functionCover.includes('补升')) return 'function-upgrade';
      if (functionCover.includes('续费')) return 'function-renew';
      return '';
    },
    handleRemarkChange: function handleRemarkChange(item) {
      var _this2 = this;

      if (item.saveTimer) clearTimeout(item.saveTimer);
      item.saveTimer = setTimeout(function () {
        _this2.saveRemark(item);
      }, 500);
    },
    saveRemark: function saveRemark(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (item.fundPackageId) {
                  _context.next = 3;
                  break;
                }

                _this3.$Message.warning('缺少 fundPackageId，无法保存');
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _this3.$http.post('/fundPackage/updateRemark', {
                  fundPackageId: item.fundPackageId,
                  remark: item.remark || ''
                });

              case 6:
                _this3.$Message.success('备注已保存');
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                _this3.$Message.error('保存失败，请重试');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 9]]);
      }))();
    },
    exportData: function exportData() {
      var _this4 = this;

      this.exportLoading = true;

      this.$http.get('/fundPackage/studyAdviserPerformanceDetail/export', {
        responseType: 'arraybuffer',
        params: {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '\u73ED\u4E3B\u4EFB\u4E1A\u7EE9\u8BE6\u60C5-' + _this4.adviserName + '-' + _this4.queryParam.month + '.xlsx';
          link.click();
          _this4.$Message.success('导出成功');
        } else {
          _this4.$Message.error(response.msg || '导出失败');
        }
        _this4.exportLoading = false;
      }).catch(function (error) {
        _this4.$Message.error('导出失败：' + error.message);
        _this4.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderNum: '',
      orderDate: '',
      userId: '',
      nickName: '',
      amount: '',
      payAmount: '',
      discount: '',
      discountNum: '',
      num: '',
      livingNum: '',
      chineseNum: '',
      createUser: '',
      tchChannel: '1'
    };
  },

  computed: {
    currencyLabel: function currencyLabel() {
      return this.tchChannel === 2 ? '人民币' : '港币';
    },
    basePlanDetail: function basePlanDetail() {
      var parts = [];
      if (this.num) parts.push(this.num + '節一對一外教課');
      if (this.livingNum) parts.push(this.livingNum + '節直播課');
      if (this.chineseNum) parts.push(this.chineseNum + '節中教課');
      return parts.join('+');
    },
    totalLessons: function totalLessons() {
      var parts = [];
      var totalOneOnOne = (Number(this.num) || 0) + (Number(this.discountNum) || 0);
      if (totalOneOnOne) parts.push(totalOneOnOne + '節一對一外教課');
      if (this.livingNum) parts.push(this.livingNum + '節直播課');
      if (this.chineseNum) parts.push(this.chineseNum + '節中教課');
      return parts.join('+');
    },
    hasActivity: function hasActivity() {
      return this.discountNum && Number(this.discountNum) > 0 || this.discount && Number(this.discount) > 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    this.orderNum = this.$route.query.orderSn;
    this.$http.post('/fundPackage/getFundPackage', { orderSn: this.orderNum }).then(function (res) {
      if (res.data.id <= 17209) {
        self.$router.push({ path: '/order/userCredential2?orderSn=' + res.data.orderId });
        return;
      }
      var time = new Date(res.data.createTime * 1000);
      self.orderDate = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
      self.userId = res.data.uid;
      self.nickName = res.data.nickname;
      self.amount = res.data.amount;
      self.payAmount = res.data.payAmount;
      self.discount = res.data.discount;
      self.discountNum = res.data.discountNum;
      self.num = res.data.num;
      self.livingNum = res.data.livingNum;
      self.chineseNum = res.data.chineseNum;
      self.createUser = res.data.creatorName;
      self.tchChannel = res.data.tchChannel;
    });
  },
  methods: {
    cancelPrint: function cancelPrint() {
      this.$router.push({ path: '/order/fundPackageList' });
    },
    printWeb: function printWeb() {
      var content = this.$refs.printContent.innerHTML;
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;';
      document.body.appendChild(iframe);

      var doc = iframe.contentWindow.document;
      doc.open();
      doc.write('<!DOCTYPE html>\n<html>\n<head>\n  <meta charset="utf-8">\n  <title>\u8BFE\u7A0B\u8D2D\u4E70\u51ED\u636E</title>\n  <style>\n    @page { margin: 1.5cm; }\n    body { font-family: "Microsoft YaHei", "PingFang SC", sans-serif; color: #202124; margin: 0; padding: 0; }\n    .credential-card { background: #fff; border: 1px solid #e0e0e0; border-radius: 8px; padding: 48px; max-width: 800px; margin: 0 auto; box-sizing: border-box; }\n    .credential-title { font-size: 28px; font-weight: bold; text-align: center; margin: 0 0 40px; color: #202124; }\n    .section { margin-bottom: 32px; }\n    .section-title { font-size: 19px; font-weight: bold; color: #202124; margin: 0 0 16px; }\n    .info-row { display: flex; margin-bottom: 12px; }\n    .info-item { flex: 1; font-size: 16px; color: #202124; }\n    .info-label { font-weight: bold; }\n    .signer-item { display: flex; flex-direction: row; align-items: flex-start; }\n    .signer-item .info-label { flex-shrink: 0; white-space: nowrap; }\n    .signer-name-block { display: flex; flex-direction: column; align-items: flex-start; }\n    .company-seal { width: 112px; height: auto; margin-top: 4px; pointer-events: none; }\n    .detail-table { width: 100%; border-collapse: collapse; font-size: 16px; color: #202124; margin-bottom: 32px; }\n    .detail-table th, .detail-table td { border: 1px solid #e0e0e0; padding: 12px 16px; text-align: left; vertical-align: top; }\n    .detail-table th { background: #f8f9fa; font-weight: bold; }\n    .detail-table .col-project { width: 20%; }\n    .detail-table .col-detail { width: 55%; }\n    .detail-table .col-total { width: 25%; }\n    .detail-table .total-row { font-weight: bold; }\n    .activity-list { margin: 0; padding: 0; list-style: none; }\n    .activity-list li { margin-bottom: 4px; }\n  </style>\n</head>\n<body>\n  <div class="credential-card">' + content + '</div>\n</body>\n</html>');
      doc.close();
      iframe.contentWindow.focus();
      setTimeout(function () {
        iframe.contentWindow.print();
      }, 250);

      var remove = function remove() {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
      };
      iframe.contentWindow.addEventListener('afterprint', remove);
      setTimeout(remove, 60000);
    }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderNum: '',
      orderDate: '',
      userId: '',
      mobile: '',
      nickName: '',
      address: '',
      amount: '',
      lessonStr: '',
      bookNum: '',
      createUser: '',
      auditUser: '',
      discount: '',
      discountNum: '',
      payAmount: '',
      payAmountCN: '',
      needInvoice: '',
      needContract: '',
      invoiceDetail: ''
    };
  },

  mounted: function mounted() {
    var self = this;
    this.orderNum = this.$route.query.orderSn;
    this.$http.post('/fundPackage/getFundPackage', { orderSn: this.orderNum }).then(function (res) {
      var time = new Date(res.data.createTime * 1000);
      self.orderDate = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
      self.userId = res.data.uid;
      self.mobile = res.data.mobile;
      self.nickName = res.data.nickname;
      self.bookNum = res.data.bookNum;
      self.amount = res.data.amount;
      self.createUser = res.data.adminName;
      self.auditUser = res.data.auditName;
      self.address = res.data.address;
      self.discount = res.data.discount;
      self.discountNum = res.data.discountNum;
      self.payAmount = res.data.payAmount;
      self.payAmountCN = res.data.chineseMoney;
      self.needContract = res.data.needContract;
      self.needInvoice = res.data.needInvoice;
      self.invoiceDetail = res.data.invoiceDetail;
      if (res.data.num) {
        self.lessonStr = self.lessonStr + res.data.num + '外教课时';
      }
      if (res.data.livingNum) {
        if (self.lessonStr) {
          self.lessonStr = self.lessonStr + '+' + res.data.livingNum + '直播课时';
        } else {
          self.lessonStr = self.lessonStr + res.data.livingNum + '直播课时';
        }
      }
      if (res.data.chineseNum) {
        if (self.lessonStr) {
          self.lessonStr = self.lessonStr + '+' + res.data.chineseNum + '中教课时';
        } else {
          self.lessonStr = self.lessonStr + res.data.chineseNum + '中教课时';
        }
      }
    });
  },
  methods: {
    cancelPrint: function cancelPrint() {
      this.$router.push({ path: '/order/fundPackageList' });
    },
    printWeb: function printWeb() {
      document.body.innerHTML = this.$refs.printBill.innerHTML;
      window.print();
    }
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    return {
      reload: 0,
      showCreateAbilityModal: false,
      showUpdateAbilityModal: false,
      queryParams: {},
      updateAbilityParams: {},
      Rules: {
        name: [{ type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' }, { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur' }],
        type: [{ required: true, message: '请选择对应等级', trigger: 'blur' }]
      },
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '能力信息',
        key: '',
        align: 'center'
      }, {
        title: '关联等级',
        key: '',
        align: 'center'
      }, {
        title: '创建时间',
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('div', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '修改时间',
        align: 'center',
        render: function render(h, params) {
          var updateTime = params.row.modifiyTime;
          return h('div', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.updateAbility(row);
              } } }, '编辑');
        }
      }]
    };
  },

  methods: {
    updateAbility: function updateAbility() {}
  }

});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_question_modal_CreateTemplateModal__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_question_modal_CreateTemplateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_question_modal_CreateTemplateModal__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CreateTemplateModal: __WEBPACK_IMPORTED_MODULE_0__components_question_modal_CreateTemplateModal___default.a
  },
  data: function data() {
    var _this = this;

    return {
      reload: 0,
      showAddTemplateList: false,
      showUpdateTemplateList: false,
      queryParams: {},
      updateTemplateParams: {},
      Rules: {
        name: [{ type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' }, { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur' }],
        type: [{ required: true, message: '请选择模板大类', trigger: 'blur' }]
      },
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '题目模板',
        key: '',
        align: 'center'
      }, {
        title: '题目大类',
        key: '',
        align: 'center'
      }, {
        title: '题目模板对应英文',
        key: '',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.updateTemplate(row);
              } } }, '编辑');
        }
      }]
    };
  },

  methods: {
    updateTemplate: function updateTemplate(row) {
      var self = this;
      self.updateTemplateParams.name = row.name;
      self.updateTemplateParams.type = row.type;
      self.updateTemplateParams.english = row.english;
      self.showUpdateTemplateList = true;
      console.log('row', row);
    },
    update: function update() {
      var self = this;
      self.$refs.updateTemplateForm.validate(function (valid) {
        if (!valid) {
          self.$message.waring('信息输入错误！');
          return;
        }
        self.$http.post('', self.updateTemplateParams).then(function (res) {
          if (res) {}
        }).catch(function (err) {
          self.$message.error(err);
        });
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    }
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateTemplateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      createTemplateParams: {},
      Rules: {
        name: [{ type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' }, { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur' }],
        type: [{ required: true, message: '选择海报分类', trigger: 'blur' }]
      }
    };
  },

  methods: {
    createTemplate: function createTemplate() {
      var self = this;
      self.$refs.createTemplateForm.validate(function (valid) {
        if (!valid) {
          self.$message.waring('信息输入错误！');
          return;
        }
        self.$http.post('', self.createTemplateParams).then(function (res) {
          if (res) {}
        }).catch(function (err) {
          self.$message.error(err);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
    }
  }

});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditUserVideoModal__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_EditUserVideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_EditUserVideoModal__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserVideoList',
  components: { EditUserVideoModal: __WEBPACK_IMPORTED_MODULE_0__modal_EditUserVideoModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      selectionRecords: [],
      queryParam: {
        uid: null,
        title: '',
        userName: '',
        mobile: '',
        competitionArea: null,
        ageGroup: null
      },
      itemId: null,
      showAddUserVideoModal: false,
      showEditUserVideoModal: false,
      columnShow: false,
      title: [{
        type: 'selection',
        width: 40,
        align: 'center'
      }, {
        title: '作品编号',
        width: 100,
        align: 'center',
        key: 'id'
      }, {
        title: '学生ID',
        width: 80,
        align: 'center',
        key: 'userId'
      }, {
        title: '学生姓名',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.userName);
        }
      }, {
        title: '家长姓名',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.parentName);
        }
      }, {
        title: '手机号后六位',
        width: 125,
        align: 'center',
        key: 'cardId'
      }, {
        title: '作品名称',
        width: 150,
        align: 'center',
        key: 'title'
      }, {
        title: '作品封面',
        width: 180,
        align: 'center',
        key: 'videoCover',
        render: function render(h, params) {
          var row = params.row;
          if (row.videoCover) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(row.videoCover);
                } } }, row.videoCover);
          } else {
            return h('span');
          }
        }
      }, {
        title: '作品',
        width: 180,
        align: 'center',
        key: 'videoCover',
        render: function render(h, params) {
          var row = params.row;
          if (row.videoUrl) {
            return h('a', { domProps: { title: '点击预览' }, on: { click: function click() {
                  return _this.showIndex(row.videoUrl);
                } } }, row.videoUrl);
          } else {
            return h('span');
          }
        }
      }, {
        title: '所属赛区',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var competitionArea = row.competitionArea;
          var competitionAreaEnum = $constant.getEnum($constant.competitionAreaEnum, competitionArea);
          return h('span', competitionAreaEnum && competitionAreaEnum.text);
        }
      }, {
        title: '所属分组',
        width: 95,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var ageGroup = row.ageGroup;
          var ageGroupEnum = $constant.getEnum($constant.ageGroupEnum, ageGroup);
          return h('span', ageGroupEnum && ageGroupEnum.text);
        }
      }, {
        title: '票数',
        width: 80,
        align: 'center',
        key: 'voteCount'
      }, {
        title: '评分',
        width: 80,
        align: 'center',
        key: 'score'
      }, {
        title: '比赛阶段',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var phase = row.phase;
          var phaseEnum = $constant.getEnum($constant.phaseEnum, phase);
          return h('span', phaseEnum && phaseEnum.text);
        }
      }, {
        title: '审核状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var status = row.status;
          var statusEnum = $constant.getEnum($constant.auditStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var row = params.row;
          var status = row.status;
          return h('span', [h('a', { on: { click: function click() {
                return self.onEdit(row);
              } } }, '编辑'), h('span', ' | '), h('a', { on: { click: function click() {
                return self.auditVideo(row.id, status === 1 ? 2 : 1);
              } } }, status === 1 ? '不通过' : '通过')]);
        }
      }]
    };
  },

  methods: {
    showIndex: function showIndex(videoPicUrl) {
      if (videoPicUrl) {
        window.open('http://medias.kouyujie.cn/' + videoPicUrl + '?' + Date.parse(new Date()));
      }
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    selectionChange: function selectionChange(selection) {
      this.selectionRecords = selection;
    },
    onAdd: function onAdd() {
      this.showAddUserVideoModal = true;
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    clearid: function clearid() {
      this.itemId = null;
    },
    onEdit: function onEdit(row) {
      this.showEditUserVideoModal = true;
      this.itemId = row.id;
    },
    showVideo: function showVideo(row) {
      var videoUrl = row.videoUrl;
      if (videoUrl) {
        window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()));
      }
    },
    auditVideo: function auditVideo(id, auditStatus) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: auditStatus === 1 ? '是否 <b>通过</b> 此作品？' : '是否 <b>不通过</b> 此作品？',
        width: 300,
        okText: auditStatus === 1 ? '确定通过' : '确定不通过',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/safenessUserVideo/check', { id: id, status: auditStatus }).then(function (resp) {
            self.search();
            self.$Message.success('操作成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    goNextPhase: function goNextPhase() {
      var _this2 = this;

      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定进入下一阶段？',
        width: 300,
        okText: '确定',
        loading: true,
        onOk: function onOk() {
          var userIds = [];
          if (_this2.selectionRecords && _this2.selectionRecords.length > 0) {
            for (var i in _this2.selectionRecords) {
              var userVideo = _this2.selectionRecords[i];
              userIds[i] = userVideo.userId;
            }
          }
          self.$http.post('/safenessUserVideo/goNextPhase', { ids: userIds.join(',') }).then(function (resp) {
            if (resp && resp.status === 'ok') {
              self.$Message.success('批量操作成功！');
              self.cancelLoading = false;
              self.search();
            } else {
              self.$Message.error('批量操作失败！');
              self.cancelLoading = false;
            }
          }).catch(function (e) {
            _this2.cancelLoading = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditUserVideoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    itemId: Number
  },
  data: function data() {
    return {
      visible: this.value,
      userVideoParams: {
        userId: null,
        userName: '',
        title: '',
        score: null
      },
      userVideoRules: {
        score: [{ type: 'string', required: true, message: '请填写评分', trigger: 'blur' }]
      },
      headers: {},
      loadingEditModal: false
    };
  },

  methods: {
    editUserVideo: function editUserVideo() {
      var self = this;
      self.loadingEditModal = true;
      self.$refs.userVideoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.$http.post('/safenessUserVideo/updateVideo', self.userVideoParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
            self.loadingEditModal = false;
          } else {
            self.$Message.error(res.msg);
          }
        }).catch(function (e) {
          self.visible = false;
          self.loadingEditModal = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.userVideoParams = {};
        this.videoFileList = [];
        this.videoPicFileList = [];
        this.$emit('on-close', false);
      }
    },
    itemId: function itemId(val) {
      if (val) {
        var self = this;
        self.$http.get('/safenessUserVideo/queryById?id=' + val).then(function (res) {
          if (res.data) {
            self.userVideoParams.id = res.data.id;
            self.userVideoParams.title = res.data.title;
            self.userVideoParams.userId = res.data.userId;
            self.userVideoParams.userName = res.data.userName;
          }
          self.$emit('on-edit-clearid');
        });
      }
    }
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrCare',
  components: { SmartHrLocalList: __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default.a }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrContract',
  components: { SmartHrLocalList: __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default.a }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrGrowth',
  components: { SmartHrLocalList: __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default.a }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrLocalList',
  props: {
    moduleType: { type: String, required: true },
    title: { type: String, required: true },
    groupName: { type: String, default: '员工关系' }
  },
  data: function data() {
    var _this = this;

    return {
      loading: false,
      showForm: false,
      rows: [],
      total: 0,
      query: { pageIndex: 1, pageSize: 20, status: '', keyword: '', moduleType: this.moduleType },
      form: {},
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '员工', key: 'empName', minWidth: 120 }, { title: '标题', key: 'title', minWidth: 160 }, { title: '状态', key: 'status', width: 100,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('span', _this.statusText(row.status));
        } }, { title: '备注', key: 'remark', minWidth: 140 }, { title: '更新时间', key: 'gmtModified', minWidth: 160 }, { title: '操作', width: 90, fixed: 'right',
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('a', { on: { click: function click() {
                return _this.openEdit(row);
              } } }, '编辑');
        } }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    statusText: function statusText(s) {
      if (s === 'OPEN') return '进行中';
      if (s === 'DONE') return '已完成';
      if (s === 'CANCEL') return '已取消';
      return s || '-';
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      this.query.moduleType = this.moduleType;
      this.$http.post('/smartHr/local/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.rows = res.data.data || [];
          _this2.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    openAdd: function openAdd() {
      this.form = { moduleType: this.moduleType, empName: '', dingUserId: '', title: '', status: 'OPEN', content: '', remark: '' };
      this.showForm = true;
    },
    openEdit: function openEdit(row) {
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row);
      this.showForm = true;
    },
    save: function save() {
      var _this3 = this;

      var url = this.form.id ? '/smartHr/local/update' : '/smartHr/local/add';
      var payload = this.stripReadonlyTimes(this.form);
      this.$http.post(url, payload).then(function (res) {
        if (res && res.status === 'ok') {
          _this3.$Message.success('已保存（仅本地）');
          _this3.showForm = false;
          _this3.load();
        }
      });
    }
  }
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enumLabels__ = __webpack_require__(96);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrOnboarding',
  data: function data() {
    return {
      loading: false, syncing: false, showAdd: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: 'PENDING', keyword: '' },
      form: { name: '', mobile: '', preEntryTime: null, remark: '' },
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '姓名', key: 'name', minWidth: 120 }, { title: '手机', key: 'mobile', minWidth: 120 }, { title: '预计入职', key: 'preEntryTime', minWidth: 160 }, { title: '状态', key: 'status', width: 100,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["f" /* onboardingStatusText */])(row.status));
        } }, { title: '来源', key: 'source', width: 90,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["b" /* sourceText */])(row.source));
        } }, { title: '备注', key: 'remark', minWidth: 140 }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this = this;

      this.loading = true;
      this.$http.post('/smartHr/onboarding/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.rows = res.data.data || [];
          _this.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    doSync: function doSync() {
      var _this2 = this;

      this.syncing = true;
      this.$http.post('/smartHr/sync', { scope: 'onboarding', mode: 'full' }).then(function () {
        _this2.$Message.success('已触发同步');
        _this2.load();
      }).finally(function () {
        _this2.syncing = false;
      });
    },
    addRow: function addRow() {
      var _this3 = this;

      if (!this.form.name || !this.form.mobile) {
        this.$Message.warning('姓名和手机必填');
        return;
      }
      var payload = this.stripReadonlyTimes(this.form);
      if (payload.preEntryTime instanceof Date) {
        payload.preEntryTime = this.formatDate(payload.preEntryTime);
      }
      this.$http.post('/smartHr/onboarding/add', payload).then(function (res) {
        if (res && res.status === 'ok') {
          _this3.$Message.success('已添加（仅本地）');
          _this3.showAdd = false;
          _this3.form = { name: '', mobile: '', preEntryTime: null, remark: '' };
          _this3.load();
        }
      });
    },
    formatDate: function formatDate(d) {
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enumLabels__ = __webpack_require__(96);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrRegularization',
  data: function data() {
    var _this = this;

    return {
      loading: false, syncing: false, showSubmit: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: 'OPEN', keyword: '', processType: 'REGULAR' },
      form: { empName: '', dingUserId: '', reason: '' },
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '员工', key: 'empName', minWidth: 120 }, { title: '钉钉userId', key: 'dingUserId', minWidth: 140 }, { title: '状态', key: 'status', width: 100,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["e" /* regularizationStatusText */])(row.status));
        } }, { title: '说明', key: 'reason', minWidth: 160 }, { title: '来源', key: 'source', width: 90,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["b" /* sourceText */])(row.source));
        } }, { title: '操作', width: 120,
        render: function render(h, _ref3) {
          var row = _ref3.row;

          if (row.status !== 'OPEN') return h('span', '-');
          return h('a', { on: { click: function click() {
                return _this.markDone(row);
              } } }, '办结（本地）');
        }
      }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      this.$http.post('/smartHr/process/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.rows = res.data.data || [];
          _this2.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    doSync: function doSync() {
      var _this3 = this;

      this.syncing = true;
      this.$http.post('/smartHr/sync', { scope: 'regularization', mode: 'full' }).then(function () {
        _this3.$Message.success('已触发同步');
        _this3.load();
      }).finally(function () {
        _this3.syncing = false;
      });
    },
    openSubmit: function openSubmit() {
      this.form = { empName: '', dingUserId: '', reason: '' };
      this.showSubmit = true;
    },
    submit: function submit() {
      var _this4 = this;

      this.$http.post('/smartHr/process/submit', this.stripReadonlyTimes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ processType: 'REGULAR', status: 'OPEN' }, this.form))).then(function (res) {
        if (res && res.status === 'ok') {
          _this4.$Message.success('已创建（仅本地）');
          _this4.showSubmit = false;
          _this4.load();
        }
      });
    },
    markDone: function markDone(row) {
      var _this5 = this;

      this.$Modal.confirm({
        title: '确认办结？',
        content: '仅更新本后台，不会写回钉钉。',
        onOk: function onOk() {
          _this5.$http.post('/smartHr/process/update', { id: row.id, status: 'DONE' }).then(function (res) {
            if (res && res.status === 'ok') {
              _this5.$Message.success('已办结');
              _this5.load();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enumLabels__ = __webpack_require__(96);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrResignation',
  data: function data() {
    var _this = this;

    return {
      loading: false, syncing: false, showSubmit: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: '', keyword: '', processType: 'RESIGN' },
      form: { empName: '', dingUserId: '', reason: '' },
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '员工', key: 'empName', minWidth: 120 }, { title: '钉钉userId', key: 'dingUserId', minWidth: 140 }, { title: '状态', key: 'status', width: 100,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["a" /* resignationStatusText */])(row.status));
        } }, { title: '原因', key: 'reason', minWidth: 160 }, { title: '来源', key: 'source', width: 90,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["b" /* sourceText */])(row.source));
        } }, { title: '操作', width: 140,
        render: function render(h, _ref3) {
          var row = _ref3.row;

          if (row.status !== 'OPEN') return h('span', '-');
          return h('a', { on: { click: function click() {
                return _this.markDone(row);
              } } }, '确认离职（本地）');
        }
      }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      this.$http.post('/smartHr/process/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.rows = res.data.data || [];
          _this2.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    doSync: function doSync() {
      var _this3 = this;

      this.syncing = true;
      this.$http.post('/smartHr/sync', { scope: 'resignation', mode: 'full' }).then(function () {
        _this3.$Message.success('已触发同步');
        _this3.load();
      }).finally(function () {
        _this3.syncing = false;
      });
    },
    openSubmit: function openSubmit() {
      this.form = { empName: '', dingUserId: '', reason: '' };
      this.showSubmit = true;
    },
    submit: function submit() {
      var _this4 = this;

      var payload = this.stripReadonlyTimes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ processType: 'RESIGN', status: 'OPEN' }, this.form));
      this.$http.post('/smartHr/process/submit', payload).then(function (res) {
        if (res && res.status === 'ok') {
          _this4.$Message.success('已创建（仅本地）');
          _this4.showSubmit = false;
          _this4.load();
        }
      });
    },
    markDone: function markDone(row) {
      var _this5 = this;

      this.$Modal.confirm({
        title: '确认离职？',
        content: '仅更新本后台员工为已离职，不会写回钉钉。',
        onOk: function onOk() {
          _this5.$http.post('/smartHr/process/update', { id: row.id, status: 'DONE' }).then(function (res) {
            if (res && res.status === 'ok') {
              _this5.$Message.success('已确认离职（本地）');
              _this5.load();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrRetire',
  components: { SmartHrLocalList: __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default.a }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrRoster',
  data: function data() {
    var _this = this;

    return {
      loading: false,
      syncing: false,
      saving: false,
      importing: false,
      exportLoading: false,
      tplLoading: false,
      showAdd: false,
      syncMsg: '',
      addForm: { name: '', mobile: '', jobNumber: '', position: '', deptNames: '' },
      rows: [],
      total: 0,
      query: { pageIndex: 1, pageSize: 20, empStatus: 'ACTIVE', keyword: '' },
      drawer: false,
      detail: null,
      edit: {},
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '姓名', key: 'name', minWidth: 140,
        render: function render(h, _ref) {
          var row = _ref.row;

          var badge = row.localDirty === 1 || row.source === 'LOCAL' ? h('span', { class: 'badge-local' }, '本地维护') : h('span', { class: 'badge-ding' }, '钉钉同步');
          return h('span', [row.name || '-', ' ', badge]);
        }
      }, { title: '手机', key: 'mobile', minWidth: 120 }, { title: '工号', key: 'jobNumber', minWidth: 100 }, { title: '部门', key: 'deptNames', minWidth: 140 }, { title: '职位', key: 'position', minWidth: 120 }, { title: '钉钉userId', key: 'dingUserId', minWidth: 140 }, { title: '状态', key: 'empStatus', width: 90,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('span', _this.statusText(row.empStatus));
        } }, { title: '操作', width: 90, fixed: 'right',
        render: function render(h, _ref3) {
          var row = _ref3.row;
          return h('a', { on: { click: function click() {
                return _this.openDetail(row.id);
              } } }, '详情');
        } }],
      fieldColumns: [{ title: '分组', key: 'groupId', width: 100 }, { title: '字段', key: 'fieldName', minWidth: 120 }, { title: '值', key: 'labelValue', minWidth: 160 }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    statusText: function statusText(s) {
      if (s === 'ACTIVE') return '在职';
      if (s === 'DIMISSION') return '已离职';
      if (s === 'PREHIRE') return '待入职';
      return s || '-';
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    reset: function reset() {
      this.query = { pageIndex: 1, pageSize: 20, empStatus: 'ACTIVE', keyword: '' };
      this.load();
    },
    onPage: function onPage(p) {
      this.query.pageIndex = p;this.load();
    },
    onSize: function onSize(s) {
      this.query.pageSize = s;this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      this.$http.post('/smartHr/roster/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.rows = res.data.data || [];
          _this2.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    doSync: function doSync() {
      var _this3 = this;

      this.syncing = true;
      this.syncMsg = '';
      this.$http.post('/smartHr/sync', { scope: 'roster', mode: 'full' }).then(function (res) {
        if (res && res.status === 'ok') {
          _this3.syncMsg = '同步完成';
          _this3.$Message.success('同步完成');
          _this3.load();
        } else {
          _this3.syncMsg = res && res.msg || '同步失败';
        }
      }).catch(function (err) {
        _this3.syncMsg = err && err.message || '同步失败';
      }).finally(function () {
        _this3.syncing = false;
      });
    },
    openDetail: function openDetail(id) {
      var _this4 = this;

      this.$http.post('/smartHr/roster/detail', { id: id }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this4.detail = res.data;
          _this4.edit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.data.employee || {});
          _this4.drawer = true;
        }
      });
    },
    openAdd: function openAdd() {
      this.addForm = { name: '', mobile: '', jobNumber: '', position: '', deptNames: '' };
      this.showAdd = true;
    },
    addLocal: function addLocal() {
      var _this5 = this;

      if (!this.addForm.name) {
        this.$Message.warning('姓名必填');
        return;
      }
      this.$http.post('/smartHr/roster/add', this.stripReadonlyTimes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ empStatus: 'ACTIVE' }, this.addForm))).then(function (res) {
        if (res && res.status === 'ok') {
          _this5.$Message.success('已本地新增');
          _this5.showAdd = false;
          _this5.load();
        }
      });
    },
    downloadBlob: function downloadBlob(response, filename) {
      if (!response || !response.data) {
        this.$Message.error('下载失败：无文件内容');
        return;
      }
      var blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    doExport: function doExport() {
      var _this6 = this;

      this.exportLoading = true;
      this.$http.post('/smartHr/roster/export', this.query, { responseType: 'arraybuffer' }).then(function (response) {
        _this6.downloadBlob(response, 'smart-hr-roster.xlsx');
      }).catch(function () {
        _this6.$Message.error('导出失败');
      }).finally(function () {
        _this6.exportLoading = false;
      });
    },
    doTemplate: function doTemplate() {
      var _this7 = this;

      this.tplLoading = true;
      this.$http.post('/smartHr/roster/importTemplate', {}, { responseType: 'arraybuffer' }).then(function (response) {
        _this7.downloadBlob(response, '钉钉智能人事花名册模板.xlsx');
        _this7.$Message.success('模板已下载');
      }).catch(function () {
        _this7.$Message.error('下载导入模板失败');
      }).finally(function () {
        _this7.tplLoading = false;
      });
    },
    beforeImport: function beforeImport(file) {
      var _this8 = this;

      var fd = new FormData();
      fd.append('file', file);
      this.importing = true;
      this.$http.post('/smartHr/roster/import', fd).then(function (res) {
        if (res && res.status === 'ok') {
          var n = res.data && res.data.imported || 0;
          _this8.$Message.success('已导入 ' + n + ' 条（仅本地）');
          _this8.load();
        }
      }).finally(function () {
        _this8.importing = false;
      });
      return false;
    },
    saveLocal: function saveLocal() {
      var _this9 = this;

      this.saving = true;
      var payload = this.stripReadonlyTimes(this.edit);
      this.$http.post('/smartHr/roster/update', payload).then(function (res) {
        if (res && res.status === 'ok') {
          _this9.$Message.success('已保存到本地');
          _this9.drawer = false;
          _this9.load();
        }
      }).finally(function () {
        _this9.saving = false;
      });
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrSafety',
  components: { SmartHrLocalList: __WEBPACK_IMPORTED_MODULE_0__SmartHrLocalList___default.a }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enumLabels__ = __webpack_require__(96);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmartHrTransfer',
  data: function data() {
    return {
      loading: false, syncing: false, showSubmit: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: '', keyword: '', processType: '' },
      form: { processType: 'TRANSFER', empName: '', dingUserId: '', reason: '' },
      columns: [{ title: 'ID', key: 'id', width: 80 }, { title: '类型', key: 'processType', width: 100,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["c" /* processTypeText */])(row.processType));
        } }, { title: '员工', key: 'empName', minWidth: 120 }, { title: '钉钉userId', key: 'dingUserId', minWidth: 140 }, { title: '状态', key: 'status', width: 100,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["d" /* transferStatusText */])(row.status));
        } }, { title: '说明', key: 'reason', minWidth: 160 }, { title: '来源', key: 'source', width: 90,
        render: function render(h, _ref3) {
          var row = _ref3.row;
          return h('span', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__enumLabels__["b" /* sourceText */])(row.source));
        } }]
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    stripReadonlyTimes: function stripReadonlyTimes(obj) {
      if (!obj || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
      delete payload.gmtCreate;
      delete payload.gmtModified;
      delete payload.syncedAt;
      return payload;
    },
    search: function search() {
      this.query.pageIndex = 1;this.load();
    },
    load: function load() {
      var _this = this;

      this.loading = true;
      this.$http.post('/smartHr/process/page', this.query).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.rows = res.data.data || [];
          _this.total = res.data.totalCount || 0;
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    doSync: function doSync() {
      var _this2 = this;

      this.syncing = true;
      this.$http.post('/smartHr/sync', { scope: 'transfer', mode: 'full' }).then(function () {
        _this2.$Message.success('已触发同步');
        _this2.load();
      }).finally(function () {
        _this2.syncing = false;
      });
    },
    openSubmit: function openSubmit() {
      this.form = { processType: 'TRANSFER', empName: '', dingUserId: '', reason: '' };
      this.showSubmit = true;
    },
    submit: function submit() {
      var _this3 = this;

      this.$http.post('/smartHr/process/submit', this.stripReadonlyTimes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ status: 'OPEN' }, this.form))).then(function (res) {
        if (res && res.status === 'ok') {
          _this3.$Message.success('已创建（仅本地）');
          _this3.showSubmit = false;
          _this3.load();
        }
      });
    }
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_impact__ = __webpack_require__(41);









var DEPTH_COLORS = ['#0B9E8D', '#8FA3C7', '#E89F2D', '#E6464E', '#B3312F'];
var REGAP_COLORS = ['#0B9E8D', '#5FA9A0', '#8FA3C7', '#E89F2D', '#E6464E'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactChange',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default.a, KpiCard: __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default.a, BarList: __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default.a, FilterPills: __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default.a },
  data: function data() {
    return {
      loading: false,
      exporting: false,
      loadedAt: '',
      days: 90,
      type: '',
      newOnly: 0,
      tchId: null,
      switchStatus: '',
      teachers: [],
      dayOptions: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["c" /* DAY_OPTIONS */],
      typeOptions: [{ value: '', label: '全部' }, { value: 'resign', label: '离职' }, { value: 'close', label: '关闭时间' }, { value: 'elim', label: '淘汰' }],
      newOptions: [{ value: 0, label: '全部学生' }, { value: 1, label: '只看新生优先' }],
      switchOptions: [{ value: '', label: '全部' }, { value: 'waiting', label: '待换老师' }, { value: 'switched', label: '已换完' }],
      d: {}
    };
  },

  computed: {
    params: function params() {
      return {
        days: this.days,
        newOnly: this.newOnly,
        type: this.type,
        tchId: this.tchId,
        switchStatus: this.switchStatus
      };
    },
    list: function list() {
      return this.d.list || [];
    },
    byType: function byType() {
      return this.d.byType || [];
    },
    chips: function chips() {
      return [{ label: '时间窗口', value: '近 ' + this.days + ' 天' }, { label: '异动类型', value: this.type ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["l" /* typeLabel */])(this.type) : '全部' }, { label: '学生范围', value: this.newOnly ? '只看新生优先' : '全部学生' }, { label: '新生优先', value: '开课 ≤ 30 天' }];
    },
    listSub: function listSub() {
      return '近 ' + this.days + ' 天 · ' + (this.newOnly ? '仅看新生优先' : '新生优先 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(this.d.newCount) + ' 人置顶，其余按风险分降序');
    },
    retainGap: function retainGap() {
      var d = this.d;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["n" /* isNum */])(d.keepRetain30Rate) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["n" /* isNum */])(d.changeRetain30Rate)) {
        return null;
      }
      return Math.round((Number(d.keepRetain30Rate) - Number(d.changeRetain30Rate)) * 10) / 10;
    },
    kpiCards: function kpiCards() {
      var d = this.d;
      var stu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.studentCount);
      var lostShare = stu > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.lostStudentCount) / stu * 100 : null;
      var gap = this.retainGap;
      return [{
        key: 'student',
        title: '受异动影响学生',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.studentCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.newCount) > 0 ? 'danger' : stu > 0 ? 'warning' : 'healthy',
        period: '敞口 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.exposureHours) + ' 课时',
        compare: '新生优先 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.newCount) + ' 人',
        compareTone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.newCount) > 0 ? 'danger' : 'neutral',
        foot: '离职 / 淘汰 / 关闭时间波及、需要换老师的学生，去重'
      }, {
        key: 'waiting',
        title: '待换老师',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.waitingCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.waitingOver7Count) > 0 ? 'danger' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.waitingCount) > 0 ? 'warning' : 'healthy',
        period: '异动已生效、未在新老师处上课',
        compare: '超 7 天 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.waitingOver7Count) + ' 人',
        compareTone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.waitingOver7Count) > 0 ? 'danger' : 'neutral',
        foot: '最需要人工介入的名单'
      }, {
        key: 'switch7',
        title: '7 天换完率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["p" /* fmtRateNum */])(d.switched7dRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["q" /* levelHigh */])(d.switched7dRate, 80, 60),
        period: '7 天换完 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.switched7dCount) + ' / 受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.studentCount),
        compare: '',
        foot: '生效后 7 天内已选新老师课 ÷ 受影响学生'
      }, {
        key: 'switched',
        title: '已换老师',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.switchedCount),
        unit: '人',
        level: 'healthy',
        period: '已换完 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.switchedCount) + ' / 受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.studentCount),
        compare: '',
        foot: '生效后首节已选课的老师 ≠ 原老师'
      }, {
        key: 'keep',
        title: '保时率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["p" /* fmtRateNum */])(d.keepSlotRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["q" /* levelHigh */])(d.keepSlotRate, 80, 60),
        period: '保时 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.keepSlotCount) + ' 人',
        compare: '保时留存 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.keepRetain30Rate),
        compareTone: 'healthy',
        foot: '新老师首课同星期、开始时间相差 ≤ 30 分钟 ÷ 已换老师'
      }, {
        key: 'changeSlot',
        title: '换老师 + 改时间',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.changeSlotCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.changeSlotRate, 15, 30),
        period: '占已换完 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.changeSlotRate),
        compare: '改时留存 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.changeRetain30Rate),
        compareTone: 'danger',
        foot: '没能保住原时段、被迫改约，是流失主力'
      }, {
        key: 'gap',
        title: '保时 vs 改时留存差',
        value: gap == null ? '—' : String(gap),
        unit: 'pp',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(gap, 5, 10),
        period: '30 天留存：保时 − 改时',
        compare: '',
        foot: '仅统计生效满 30 天的已换老师学生'
      }, {
        key: 'lost',
        title: '累计损失课次',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.lostTotal),
        unit: '课次',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.lostTotal) <= 0 ? 'healthy' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(lostShare, 0, 30),
        period: '有损失学生 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.lostStudentCount) + ' 人',
        compare: lostShare == null ? '' : '占 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(lostShare),
        compareTone: 'danger',
        foot: '生效后 14 天应上（原周课量 × 2）− 实上'
      }];
    },
    chainRows: function chainRows() {
      var d = this.d;
      var stu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.studentCount);
      var base = stu || 1;
      var pct = function pct(v) {
        return stu > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(v) / stu * 100) : '—';
      };
      return [{ key: 'stu', label: '受影响学生', value: d.studentCount, rate: stu > 0 ? '100%' : '—', color: '#8FA3C7' }, { key: 'switched', label: '已换完老师', value: d.switchedCount, rate: pct(d.switchedCount), color: '#5C78A8' }, { key: 'switched7d', label: '7 天内换完', value: d.switched7dCount, rate: pct(d.switched7dCount), color: '#2A3C62' }, { key: 'keep', label: '保住原时段', value: d.keepSlotCount, rate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.keepSlotRate) + '（按已换）', color: '#0B9E8D' }].map(function (row) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(row, { width: Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(row.value) / base * 100, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(row.value) > 0 ? 8 : 0) });
      });
    },
    depthRows: function depthRows() {
      return (this.d.depth || []).map(function (r, i) {
        return { key: r.label, label: r.label, value: r.count, color: DEPTH_COLORS[i] || DEPTH_COLORS[4] };
      });
    },
    depthInsight: function depthInsight() {
      var depth = this.d.depth || [];
      var stu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(this.d.studentCount);
      if (!depth.length || stu <= 0) {
        return '';
      }
      var zero = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(depth[0].count);
      var hurt = stu - zero;
      return '近 ' + this.days + ' 天 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(stu) + ' 名受影响学生中，' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(zero) + ' 人（' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(zero / stu * 100) + '）零损失顺利过渡；' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(hurt) + ' 人（' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(hurt / stu * 100) + '）有真实课次损失，合计损失 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(this.d.lostTotal) + ' 课次。';
    },
    keepRows: function keepRows() {
      return this.byType.map(function (r) {
        return {
          key: r.type,
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["l" /* typeLabel */])(r.type),
          value: r.keepSlotRate,
          percent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(r.keepSlotRate),
          valueText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(r.keepSlotRate),
          extra: '已换 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(r.switched),
          color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["m" /* typeColor */])(r.type)
        };
      });
    },
    regapRows: function regapRows() {
      return (this.d.regap || []).map(function (r, i) {
        return { key: r.label, label: r.label, value: r.count, color: REGAP_COLORS[i] || REGAP_COLORS[4] };
      });
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */],
    isNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["n" /* isNum */],
    fmtNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */],
    fmtRate: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */],
    typeLabel: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["l" /* typeLabel */],
    typeBadge: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["s" /* typeBadge */],
    levelBadge: function levelBadge(level) {
      return __WEBPACK_IMPORTED_MODULE_5__parts_impact__["h" /* LEVEL_BADGE */][level] || 'is-gray';
    },
    onTchChange: function onTchChange() {
      if (this._suppressTchReload) {
        return;
      }
      this.load();
    },
    load: function load() {
      var self = this;
      self.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["i" /* postImpact */])(self, '/change', self.params).then(function (data) {
        if (!data) {
          return;
        }
        self.d = data;
        self.teachers = data.teachers || [];
        self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
        if (self.tchId != null && self.tchId !== '') {
          var found = self.teachers.some(function (t) {
            return t.id === self.tchId || String(t.id) === String(self.tchId);
          });
          if (!found) {
            self._suppressTchReload = true;
            self.tchId = null;
            self._suppressTchReload = false;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["i" /* postImpact */])(self, '/change', self.params).then(function (data2) {
              if (data2) {
                self.d = data2;
                self.teachers = data2.teachers || [];
                self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
              }
            });
          }
        }
      }).finally(function () {
        self.loading = false;
      });
    },
    doExport: function doExport() {
      if (this.exporting) {
        return;
      }
      var self = this;
      self.exporting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["j" /* exportImpact */])(self, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ view: 'change' }, self.params), '外教异动受影响学生.xlsx').finally(function () {
        self.exporting = false;
      });
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_impact__ = __webpack_require__(41);









var PROXY_COLOR = '#0B9E8D';
var LOSS_COLOR = '#E6464E';
var OTHER_COLOR = '#C9D0DC';

function niceMax(v) {
  if (v <= 10) {
    return 10;
  }
  var step = Math.pow(10, Math.floor(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default()(v)));
  return Math.ceil(v / step) * step;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactLeave',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default.a, KpiCard: __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default.a, BarList: __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default.a, FilterPills: __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default.a },
  data: function data() {
    return {
      loading: false,
      loadedAt: '',
      days: 90,
      dayOptions: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["c" /* DAY_OPTIONS */],
      d: {}
    };
  },

  computed: {
    weekly: function weekly() {
      return this.d.weekly || [];
    },
    students: function students() {
      return this.d.students || [];
    },
    chips: function chips() {
      return [{ label: '时间窗口', value: '近 ' + this.days + ' 天' }, { label: '课节状态', value: '老师请假（状态）+ 考勤缺席' }, { label: '3 小时线', value: '外 代课 / 内 不代课' }, { label: '结果', value: '成功代课 / 未代课' }];
    },
    kpiCards: function kpiCards() {
      var d = this.d;
      return [{
        key: 'scope',
        title: '受老师请假 / 旷课波及',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.lessonCount) > 0 ? 'warning' : 'healthy',
        period: '请假 / 旷课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.eventCount) + ' 次',
        compare: '次均 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.avgLessonsPerEvent) + ' 课节',
        foot: '常规外教课：请假状态，或考勤标记老师缺席的课节'
      }, {
        key: 'proxy',
        title: '代课安排率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["p" /* fmtRateNum */])(d.proxyRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["q" /* levelHigh */])(d.proxyRate, 80, 60),
        period: '成功代课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.proxyCount) + ' 课节',
        compare: '3h 外 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.outerProxyRate),
        compareTone: 'healthy',
        foot: '有代课课节（原课节派生）且已排或已完成 ÷ 受影响课节'
      }, {
        key: 'loss',
        title: '未代课率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["p" /* fmtRateNum */])(d.lossRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.lossRate, 10, 25),
        period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.lossCount) + ' 课节',
        compare: '3h 外 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.outerLossRate) + ' vs 3h 内 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.innerLossRate),
        compareTone: 'danger',
        foot: '未代课 = 损失课次，家长取消与改期补回在系统里无法区分'
      }, {
        key: 'innerLoss',
        title: '3 小时内未代课',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.innerLossCount),
        unit: '课节',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.innerLossCount) > 0 ? 'danger' : 'healthy',
        period: '3h 内含 1–3h / <1h / 旷课',
        compare: '占全部未代课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.innerLossShare),
        compareTone: 'danger',
        foot: '3 小时内不安排代课，只能改约或取消'
      }, {
        key: 'outer',
        title: '3 小时外请假',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.outerCount),
        unit: '课节',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.outerLossRate, 5, 15),
        period: '未代课率 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.outerLossRate),
        compare: '代课率 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.outerProxyRate),
        compareTone: 'healthy',
        foot: '提前 > 3 小时申请，系统应安排代课'
      }, {
        key: 'inner',
        title: '3 小时内请假 / 旷课',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.innerCount),
        unit: '课节',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.innerShare, 15, 30),
        period: '占受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.innerShare),
        compare: '未代课率 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.innerLossRate),
        compareTone: 'danger',
        foot: '没有系统兜底的课节'
      }, {
        key: 'absent',
        title: '旷课',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.absentCount),
        unit: '课节',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.absentCount) > 0 ? 'danger' : 'healthy',
        period: '占受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.absentShare),
        compare: '未代课率 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.absentLossRate),
        compareTone: 'danger',
        foot: '考勤标记老师缺席（is_tch_absent），归入 3 小时内'
      }, {
        key: 'proxyCount',
        title: '成功代课',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.proxyCount),
        unit: '课节',
        level: 'healthy',
        period: '受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.lessonCount) + ' 课节',
        compare: '',
        foot: '代课课节状态为已约 / 待上 / 已完成'
      }];
    },
    bucketRows: function bucketRows() {
      return (this.d.buckets || []).map(function (b) {
        var other = Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(b.total) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(b.proxy) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(b.loss));
        var segs = [{ value: b.proxy, color: PROXY_COLOR, title: '成功代课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(b.proxy) }, { value: b.loss, color: LOSS_COLOR, title: '未代课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(b.loss) }];
        if (other > 0) {
          segs.push({ value: other, color: OTHER_COLOR, title: '其他 ' + other });
        }
        var lossHigh = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["n" /* isNum */])(b.lossRate) && Number(b.lossRate) > 50;
        return {
          key: b.key,
          label: b.label,
          labelClass: b.side === 'inner' ? 'is-danger' : b.side === 'unknown' ? 'is-muted' : '',
          segs: segs,
          value: b.total,
          extra: '未代课 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(b.lossRate),
          extraClass: lossHigh ? 'is-danger' : ''
        };
      });
    },
    trend: function trend() {
      var W = 720;
      var H = 240;
      var PL = 40;
      var PR = 16;
      var PT = 16;
      var PB = 30;
      var list = this.weekly;
      var n = list.length;
      var maxV = 0;
      list.forEach(function (w) {
        maxV = Math.max(maxV, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(w.lessons), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(w.loss));
      });
      var max = niceMax(maxV);
      var sx = function sx(i) {
        return n > 1 ? PL + i / (n - 1) * (W - PL - PR) : (PL + W - PR) / 2;
      };
      var sy = function sy(v) {
        return H - PB - v / max * (H - PT - PB);
      };
      var grid = [];
      for (var i = 0; i <= 4; i++) {
        grid.push({ y: H - PB - i / 4 * (H - PT - PB), label: Math.round(i / 4 * max) });
      }
      var pts = function pts(key, name) {
        return list.map(function (w, i) {
          return {
            label: w.label,
            x: sx(i),
            y: sy(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(w[key])),
            title: w.label + (w.weekStart ? '（' + w.weekStart + ' 起）' : '') + ' ' + name + ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(w[key])
          };
        });
      };
      var lessons = pts('lessons', '受影响课节');
      var loss = pts('loss', '未代课');
      var path = function path(arr) {
        return arr.map(function (p, i) {
          return (i ? 'L' : 'M') + p.x + ',' + p.y;
        }).join(' ');
      };
      var lessonPath = path(lessons);
      var area = n ? lessonPath + ' L' + sx(n - 1) + ',' + (H - PB) + ' L' + sx(0) + ',' + (H - PB) + ' Z' : '';
      return { W: W, H: H, PL: PL, PR: PR, PB: PB, grid: grid, lessons: lessons, loss: loss, lessonPath: lessonPath, lossPath: path(loss), area: area };
    },
    studentSub: function studentSub() {
      var np = this.students.filter(function (r) {
        return r.newPriority;
      }).length;
      return '近 ' + this.days + ' 天 · 新生优先 ' + np + ' 人置顶 · 其余按风险高 → 低';
    },
    studentInsight: function studentInsight() {
      var rows = this.students;
      if (!rows.length) {
        return '';
      }
      var hi = rows.filter(function (r) {
        return r.level === '高';
      }).length;
      var np = rows.filter(function (r) {
        return r.newPriority;
      }).length;
      var inner = rows.reduce(function (s, r) {
        return s + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(r.innerCount);
      }, 0);
      return '近 ' + this.days + ' 天：' + rows.length + ' 名高频被请假学生中，' + hi + ' 人高风险，' + np + ' 人属于「新生优先」（开课 30 天内被请假 ≥ 2 次）。另有 ' + inner + ' 次请假发生在课前 3 小时内，不安排代课。';
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */],
    isNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["n" /* isNum */],
    fmtNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */],
    fmtRate: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */],
    fmtRateNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["p" /* fmtRateNum */],
    shortDate: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["r" /* shortDate */],
    levelBadge: function levelBadge(level) {
      return __WEBPACK_IMPORTED_MODULE_5__parts_impact__["h" /* LEVEL_BADGE */][level] || 'is-gray';
    },
    load: function load() {
      var self = this;
      self.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["i" /* postImpact */])(self, '/leave', { days: self.days }).then(function (data) {
        if (data) {
          self.d = data;
          self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
        }
      }).finally(function () {
        self.loading = false;
      });
    }
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parts_ImpactHeader_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactModel',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_0__parts_ImpactHeader_vue___default.a },
  data: function data() {
    return {
      chips: [{ label: '时区', value: 'Asia/Shanghai' }, { label: '老师', value: '欧美外教' }, { label: '课节', value: '常规外教课' }, { label: '比率', value: '分母为 0 显示 —' }],
      baseRows: [{ name: '时间', desc: '一律 Asia/Shanghai；「今天」= 服务器当日。' }, { name: '老师范围', desc: '欧美外教（外教且渠道为欧美）；菲教不算。' }, { name: '常规外教课', desc: '常规课节、课程类型为常规 / 外教常规且有学生的课节。' }, { name: '完成课', desc: '课节状态为已完成。' }, { name: '学生 / 班主任', desc: '学生昵称；班主任取学生当前的学导。' }, { name: '剩余课时', desc: '学生课包常规课时 − 已消常规课时，取当前值，不是事件时点快照。' }, { name: '开课天数', desc: '事件生效日 − 该生最早一节完成常规外教课日期；≤ 30 天为新生优先。' }, { name: '比率', desc: '百分数保留 1 位小数；分母为 0 显示「—」。' }],
      eventRows: [{ type: 'resign', label: '离职', badge: 'is-purple', source: '老师状态为离职（含失联、老记录无类型）', date: '最后工作日', notice: '生效日 − 最新一条离职跟进记录创建日' }, { type: 'elim', label: '淘汰', badge: 'is-danger', source: '同离职，且该条跟进记录离职类型为淘汰', date: '最后工作日', notice: '同离职' }, { type: 'close', label: '关闭时间', badge: 'is-warning', source: '老师关闭时间每行一起', date: '关闭日期', notice: '关闭日期 − 提交日期' }],
      changeRows: [{ name: '波及学生（离职 / 淘汰）', desc: '生效日前 30 天内与该老师有完成常规外教课的学生，去重。' }, { name: '波及学生（关闭时间）', desc: '同一区间内，与该老师、同星期、课节开始时间落在关闭区间 [开始, 结束) 的完成课学生。' }, { name: '原时段 / 原周课量', desc: '上述课节里出现最多的（星期, 开始时间）；原周课量 = 不同（星期, 开始时间）个数。' }, { name: '已换老师 / 换老师天数', desc: '生效日起该生第一节已选常规外教课（lsn_sel_status=1）且老师 ≠ 原老师；天数 = 该课日期 − 生效日。' }, { name: '待换老师 / 超 7 天', desc: '还没有上述已选新老师课；生效日距今 > 7 天仍待换即超 7 天。' }, { name: '保时 / 改时', desc: '新老师首课同星期，且开始时间与原时段相差 ≤ 30 分钟为保时，否则改时。' }, { name: '损失课次', desc: '生效后 14 天应上 = 原周课量 × 2（不满 14 天按已过整周折算），实上 = 该生这段时间任意老师完成课数，损失 = max(0, 应上 − 实上)。' }, { name: '30 天留存', desc: '生效满 30 天的事件才评估；生效后 30 天内有完成常规外教课即留存。' }, { name: '对照组', desc: '参考日 R = min(窗口结束日, 今天 − 30)；R 前 30 天有完成课、且 R 前 90 天到 R 后 30 天没被任何异动波及的学生；R 后 30 天有完成课即留存。' }],
      leaveRows: [{ name: '受影响课节', desc: '常规外教课、范围老师：请假状态（lsn_sel_status=6），或 book_calls 老师缺席标记=1；按课节开始时间落窗口。' }, { name: '提前小时', desc: '（课节开始时间 − 老师最早一条请假申请时间）÷ 3600。' }, { name: '分桶', desc: '>24h / 12–24h / 6–12h / 3–6h / 1–3h / <1h / 旷课（考勤缺席）/ 无申请记录（请假状态但查不到申请）。' }, { name: '3 小时线', desc: '3h 外 = >24h、12–24h、6–12h、3–6h；3h 内 = 1–3h、<1h、旷课；无申请记录只进总量。' }, { name: '成功代课', desc: '存在以本课节为原课节的代课课节，且状态为已约 / 待上 / 已完成。' }, { name: '未代课', desc: '= 损失课次。系统里家长取消与改期补回无法区分，结果只分「成功代课 / 未代课」两种。' }, { name: '请假事件数', desc: '按（老师, 申请时间）去重 + 旷课课节数。' }],
      studentRows: [{ name: '学生事件', desc: '异动事件（离职 / 淘汰 / 关闭时间）+ 请假课节（3h 内请假、3h 外或无申请记录的请假、旷课，每节 1 次）。' }, { name: '学生损失课次', desc: '异动损失课次之和 + 未代课的请假课节数。' }, { name: '当前状态', desc: '流失预警（近 30 天无完成课 且 剩余课时 > 10 且 受影响 ≥ 2 次）→ 待换老师 → 已换老师 → 正常上课，按此优先级取第一个命中。' }, { name: '主老师', desc: '学生当前固定排课的老师（去重顿号连接）；没有则取最近受影响事件的老师。' }, { name: '综合风险分', desc: '每起异动 +10，待换 +6，已换但改时 +4；每节请假 +3，3h 内再 +4；两类都有 +7；剩余 ≥ 40 +5、20–39 +3；损失每节 +1；上限 100。' }, { name: '风险分档', desc: '极高 ≥ 55 / 高 40–54 / 中 25–39 / 低 < 25；学生影响明细「风险」列：极高 / 高 → 高，中 → 中，低 → 低。' }, { name: '学生异动清单风险', desc: '损失课次 × 3 + 待换 10 + 已换改时 6 + 剩余课时 × 0.3，新生优先 +15 置顶；≥ 25 高 / ≥ 16 中 / 其余低。' }, { name: '高频被请假学生风险', desc: '被请假次数 × 2 + 3h 内次数 × 3 + 近 7 天有被请假 +4；≥ 15 高 / ≥ 8 中 / 其余低；开课 30 天内被请假 ≥ 2 次为新生优先，置顶。' }],
      pendingRows: [{ name: '「保时」的容差', now: '同星期且开始时间相差 ≤ 30 分钟算保时，超过算改时。', todo: '阈值直接决定保时率高低，需和运营对齐后固化。' }, { name: '关闭时间的波及边界', now: '按课节开始时间是否落在关闭区间判定，避免一节课算半次。', todo: '课节跨越关闭边界时是否也算波及。' }, { name: '改期补回是否算损失', now: '系统无法区分家长取消与改期补回，统一计「未代课」。', todo: '后续若有改约记录，再拆出改期补回单列。' }, { name: '对照组怎么选', now: '同期未被任何异动波及的活跃学生，未做分层匹配。', todo: '是否按课程类型、剩余课时分位、地区做 1:3 匹配。' }, { name: '剩余课时口径', now: '取学生当前剩余课时，不是事件时点快照。', todo: '是否需要按事件时点回溯。' }, { name: '排课策略：先锁时段再配老师', now: '看板只呈现保时 / 改时与留存差异，不改排课逻辑。', todo: '「快」和「稳」的取舍：例如剩余课时 > 20 的学生优先保时，课时少的优先保速度。' }]
    };
  }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_impact__ = __webpack_require__(41);








var DEPTH_COLORS = ['#0B9E8D', '#8FA3C7', '#E89F2D', '#E6464E', '#B3312F'];
var FREQ_COLORS = ['#C9D3E8', '#E89F2D', '#E6464E', '#B3312F'];
var MAX_DAYS = 93;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactOverview',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default.a, KpiCard: __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default.a, BarList: __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default.a },
  data: function data() {
    var today = this.$moment();
    return {
      loading: false,
      loadedAt: '',
      todayStr: today.format('YYYY-MM-DD'),
      dateRange: [today.clone().startOf('month').format('YYYY-MM-DD'), today.format('YYYY-MM-DD')],
      typeKeys: ['resign', 'close', 'elim'],
      d: {}
    };
  },

  computed: {
    period: function period() {
      return this.d.period || {};
    },
    periodText: function periodText() {
      var p = this.period;
      return p.startDate ? p.startDate + ' ~ ' + p.endDate : this.dateRange[0] + ' ~ ' + this.dateRange[1];
    },
    prevPeriodText: function prevPeriodText() {
      var p = this.period;
      return p.prevStartDate ? p.prevStartDate + ' ~ ' + p.prevEndDate : '上期';
    },
    funnel: function funnel() {
      return this.d.funnel || {};
    },
    byType: function byType() {
      return this.d.byType || [];
    },
    riskPool: function riskPool() {
      return this.d.riskPool || [];
    },
    chips: function chips() {
      return [{ label: '统计区间', value: this.periodText }, { label: '对比期', value: this.prevPeriodText }, { label: '老师范围', value: '欧美外教' }, { label: '事件', value: '离职 / 淘汰 / 关闭时间' }];
    },
    switched7dRate: function switched7dRate() {
      var f = this.funnel;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(f.students) > 0 ? Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(f.switched7d) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(f.students) * 1000) / 10 : null;
    },
    kpiCards: function kpiCards() {
      var d = this.d;
      var f = this.funnel;
      var ev = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["t" /* changeVsPrev */])(d.eventCount, d.prevEventCount, ' 起');
      var st = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["t" /* changeVsPrev */])(d.studentCount, d.prevStudentCount, ' 人');
      var retainGap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.retain30Rate) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.controlRetain30Rate) ? Math.round((Number(d.retain30Rate) - Number(d.controlRetain30Rate)) * 10) / 10 : null;
      var medianDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.switchMedianDays) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.prevSwitchMedianDays) ? Math.round((Number(d.switchMedianDays) - Number(d.prevSwitchMedianDays)) * 10) / 10 : null;
      return [{
        key: 'event',
        title: '老师异动事件',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.eventCount),
        unit: '起',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["u" /* levelVsPrev */])(d.eventCount, d.prevEventCount),
        period: this.periodText,
        compare: ev.text,
        compareTone: ev.tone,
        foot: '离职 + 淘汰 + 关闭时间，按生效日计数；同一老师多次关闭时间算多起'
      }, {
        key: 'student',
        title: '波及学生',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.studentCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["g" /* levelLow */])(d.studentRate, 2, 5),
        period: '占活跃学生 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(d.studentRate),
        compare: st.text,
        compareTone: st.tone,
        foot: '活跃 = 区间内有完成常规外教课，共 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.activeStudentCount) + ' 人'
      }, {
        key: 'exposure',
        title: '未消课时敞口',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.exposureHours),
        unit: '课时',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(d.exposureHours) > 0 ? 'warning' : 'healthy',
        period: '人均 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.avgExposureHours) + ' 课时',
        compare: '',
        foot: '波及学生当前剩余课时之和（非事件时点快照）'
      }, {
        key: 'median',
        title: '换老师时长中位数',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.switchMedianDays),
        unit: '天',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["g" /* levelLow */])(d.switchMedianDays, 4, 8),
        period: 'P90 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.switchP90Days) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.switchP90Days) ? ' 天' : ''),
        compare: medianDiff == null ? '' : medianDiff === 0 ? '与上期持平' : (medianDiff > 0 ? '↑ ' : '↓ ') + Math.abs(medianDiff) + ' 天 vs 上期',
        compareTone: medianDiff == null || medianDiff === 0 ? 'neutral' : medianDiff > 0 ? 'danger' : 'healthy',
        foot: '生效日 → 学生首次已选新老师常规外教课，已换老师学生'
      }, {
        key: 'retain',
        title: '异动后 30 天留存',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["p" /* fmtRateNum */])(d.retain30Rate),
        unit: '%',
        level: retainGap == null ? 'healthy' : retainGap >= -2 ? 'healthy' : retainGap >= -5 ? 'warning' : 'danger',
        period: '对照组 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(d.controlRetain30Rate),
        compare: retainGap == null ? '' : '差值 ' + (retainGap > 0 ? '+' : '') + retainGap + 'pp',
        compareTone: retainGap == null ? 'neutral' : retainGap < 0 ? 'danger' : 'healthy',
        foot: '生效满 30 天的学生才评估，共 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(d.retainEligibleCount) + ' 人；30 天内有完成课即留存'
      }, {
        key: 'switch7',
        title: '7 天换完率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["p" /* fmtRateNum */])(this.switched7dRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["q" /* levelHigh */])(this.switched7dRate, 80, 60),
        period: '7 天换完 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(f.switched7d) + ' / 波及 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(f.students),
        compare: '',
        foot: '生效后 7 天内已选新老师常规外教课'
      }, {
        key: 'wait7',
        title: '超 7 天待换老师',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(f.waitingOver7),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(f.waitingOver7) > 0 ? 'danger' : 'healthy',
        period: '已换老师 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(f.switched) + ' 人',
        compare: '',
        foot: '生效已过 7 天仍未在新老师处上课，最该人工介入'
      }, {
        key: 'repeat',
        title: '重复受影响率',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["p" /* fmtRateNum */])(d.repeatRate),
        unit: '%',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["g" /* levelLow */])(d.repeatRate, 5, 10),
        period: '90 天内被波及 ≥ 2 次',
        compare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */])(d.repeatLostShare) ? '贡献损失 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(d.repeatLostShare) : '',
        compareTone: 'danger',
        foot: '异动 + 请假/旷课课节都算一次波及'
      }];
    },
    trendCols: function trendCols() {
      var list = this.d.trend || [];
      var keys = this.typeKeys;
      var max = 1;
      list.forEach(function (m) {
        var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.resign) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.close) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.elim);
        if (t > max) {
          max = t;
        }
      });
      return list.map(function (m) {
        var total = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.resign) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.close) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m.elim);
        var label = m.month && m.month.length >= 7 ? Number(m.month.slice(5, 7)) + '月' : m.month || '';
        return {
          month: m.month,
          label: label,
          total: total,
          height: Math.round(total / max * 150),
          segs: keys.slice().reverse().map(function (t) {
            return {
              type: t,
              color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["m" /* typeColor */])(t),
              title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["l" /* typeLabel */])(t) + ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m[t]),
              height: Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(m[t]) / max * 150)
            };
          })
        };
      });
    },
    funnelRows: function funnelRows() {
      var f = this.funnel;
      var total = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(f.students);
      var base = total || 1;
      var pct = function pct(v) {
        return total > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(v) / total * 100) : '—';
      };
      return [{ key: 'students', label: '波及学生', value: f.students, rate: total > 0 ? '100%' : '—', color: '#8FA3C7' }, { key: 'switched', label: '已完成换老师', value: f.switched, rate: pct(f.switched), color: '#5C78A8' }, { key: 'switched7d', label: '7 天内换完', value: f.switched7d, rate: pct(f.switched7d), color: '#2A3C62' }, { key: 'retained30', label: '30 天留存', value: f.retained30, rate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(this.d.retain30Rate), color: '#0B9E8D' }].map(function (row) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(row, { width: Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(row.value) / base * 100, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(row.value) > 0 ? 10 : 0) });
      });
    },
    noticeInsight: function noticeInsight() {
      var list = this.byType.filter(function (r) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */])(r.students) > 0;
      });
      if (!list.length) {
        return '';
      }
      var parts = list.map(function (r) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["l" /* typeLabel */])(r.type) + '平均通知 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */])(r.avgNoticeDays) + ' 天、7 天换完 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */])(r.switched7dRate);
      });
      return '按类型拆：' + parts.join('；') + '。通知窗口越短，7 天换完率通常越低——先看是不是通知太晚，再看老师资源。';
    },
    depthRows: function depthRows() {
      return (this.d.depth || []).map(function (r, i) {
        return { key: r.label, label: r.label, value: r.count, color: DEPTH_COLORS[i] || DEPTH_COLORS[4] };
      });
    },
    freqRows: function freqRows() {
      return (this.d.freq || []).map(function (r, i) {
        return { key: r.label, label: r.label, value: r.count, color: FREQ_COLORS[i] || FREQ_COLORS[3] };
      });
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["e" /* num */],
    isNum: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["n" /* isNum */],
    fmtNum: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["d" /* fmtNum */],
    fmtRate: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["f" /* fmtRate */],
    shortDate: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["r" /* shortDate */],
    typeLabel: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["l" /* typeLabel */],
    typeColor: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["m" /* typeColor */],
    typeBadge: __WEBPACK_IMPORTED_MODULE_4__parts_impact__["s" /* typeBadge */],
    onDateChange: function onDateChange(val) {
      if (!val || !val[0] || !val[1]) {
        return;
      }
      var days = this.$moment(val[1]).diff(this.$moment(val[0]), 'days') + 1;
      if (days > MAX_DAYS) {
        this.$Message.error('统计区间不能超过 93 天');
        this.dateRange = this.dateRange.slice();
        return;
      }
      this.dateRange = [val[0], val[1]];
      this.load();
    },
    load: function load() {
      var self = this;
      self.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parts_impact__["i" /* postImpact */])(self, '/overview', { startDate: self.dateRange[0], endDate: self.dateRange[1] }).then(function (data) {
        if (data) {
          self.d = data;
          self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
        }
      }).finally(function () {
        self.loading = false;
      });
    }
  }
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_impact__ = __webpack_require__(41);









var SOURCE_COLORS = { both: '#E6464E', change: '#7C5CFF', leave: '#E89F2D' };
var BAND_META = {
  '极高': { label: '极高 ≥55', color: '#B3312F' },
  '高': { label: '高 40–54', color: '#E6464E' },
  '中': { label: '中 25–39', color: '#E89F2D' },
  '低': { label: '低 <25', color: '#8FA3C7' }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactRisk',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_1__parts_ImpactHeader_vue___default.a, KpiCard: __WEBPACK_IMPORTED_MODULE_2__parts_KpiCard_vue___default.a, BarList: __WEBPACK_IMPORTED_MODULE_3__parts_BarList_vue___default.a, FilterPills: __WEBPACK_IMPORTED_MODULE_4__parts_FilterPills_vue___default.a },
  data: function data() {
    return {
      loading: false,
      exporting: false,
      loadedAt: '',
      days: 90,
      source: '',
      dayOptions: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["c" /* DAY_OPTIONS */],
      sourceOptions: [{ value: '', label: '全部来源' }, { value: 'both', label: '两类叠加', color: SOURCE_COLORS.both }, { value: 'change', label: '仅异动', color: SOURCE_COLORS.change }, { value: 'leave', label: '仅请假/旷课', color: SOURCE_COLORS.leave }],
      d: {}
    };
  },

  computed: {
    params: function params() {
      return { days: this.days, source: this.source };
    },
    list: function list() {
      return this.d.list || [];
    },
    sourceLabel: function sourceLabel() {
      var _this = this;

      var hit = this.sourceOptions.filter(function (o) {
        return o.value === _this.source;
      })[0];
      return hit ? hit.label : '全部来源';
    },
    chips: function chips() {
      return [{ label: '时间窗口', value: '近 ' + this.days + ' 天' }, { label: '来源', value: this.sourceLabel }, { label: '高风险线', value: '≥ 40 分' }, { label: '极高线', value: '≥ 55 分' }];
    },
    kpiCards: function kpiCards() {
      var d = this.d;
      return [{
        key: 'student',
        title: '纳入评分学生',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.studentCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.studentCount) > 0 ? 'warning' : 'healthy',
        period: '敞口 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.exposureHours) + ' 课时',
        compare: '新生优先 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.newCount) + ' 人',
        compareTone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.newCount) > 0 ? 'danger' : 'neutral',
        foot: '窗口内至少被异动或请假波及一次的学生'
      }, {
        key: 'high',
        title: '高风险学生',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.highCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.topCount) > 0 ? 'danger' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.highCount) > 0 ? 'warning' : 'healthy',
        period: '占纳入学生 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.highRate),
        compare: '极高 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.topCount) + ' 人',
        compareTone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.topCount) > 0 ? 'danger' : 'neutral',
        foot: '风险分 ≥ 40，未消课时合计 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.highHours) + '，应当天进入人工跟进'
      }, {
        key: 'both',
        title: '两类叠加',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.bothCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.bothCount) <= 0 ? 'healthy' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.bothAvg, 25, 40),
        period: '平均风险分 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.bothAvg),
        compare: '单一来源 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.singleAvg) + ' 分',
        compareTone: 'neutral',
        foot: '同时被异动和请假波及的学生'
      }, {
        key: 'avg',
        title: '平均风险分',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.avgScore),
        unit: '分',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["g" /* levelLow */])(d.avgScore, 25, 40),
        period: 'P90 分位 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.p90Score) + ' 分',
        compare: '',
        foot: '纳入学生风险分的算术平均，观察整体恶化趋势'
      }];
    },
    sourceRows: function sourceRows() {
      return (this.d.sourceGroups || []).map(function (g) {
        return {
          key: g.key,
          label: g.label,
          value: g.count,
          color: SOURCE_COLORS[g.key] || '#8FA3C7',
          extra: '均 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(g.avgScore) + ' 分'
        };
      });
    },
    bandRows: function bandRows() {
      return (this.d.bands || []).map(function (b) {
        var meta = BAND_META[b.key] || { label: b.key, color: '#8FA3C7' };
        return { key: b.key, label: meta.label, value: b.count, color: meta.color, extra: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(b.rate) };
      });
    },
    bandInsight: function bandInsight() {
      var d = this.d;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.studentCount)) {
        return '';
      }
      var top = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.topCount);
      var high = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(d.highCount);
      return '近 ' + this.days + ' 天：' + top + ' 人极高风险、' + (high - top) + ' 人高风险，合计 ' + high + ' 人需要人工介入，占纳入学生 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["f" /* fmtRate */])(d.highRate) + '，未消课时合计 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */])(d.highHours) + '。';
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */],
    fmtNum: __WEBPACK_IMPORTED_MODULE_5__parts_impact__["d" /* fmtNum */],
    levelBadge: function levelBadge(band) {
      return __WEBPACK_IMPORTED_MODULE_5__parts_impact__["h" /* LEVEL_BADGE */][band] || 'is-gray';
    },
    scoreColor: function scoreColor(score) {
      var s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["e" /* num */])(score);
      if (s >= 55) {
        return BAND_META['极高'].color;
      }
      if (s >= 40) {
        return BAND_META['高'].color;
      }
      return s >= 25 ? BAND_META['中'].color : BAND_META['低'].color;
    },
    load: function load() {
      var self = this;
      self.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["i" /* postImpact */])(self, '/risk', self.params).then(function (data) {
        if (data) {
          self.d = data;
          self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
        }
      }).finally(function () {
        self.loading = false;
      });
    },
    doExport: function doExport() {
      if (this.exporting) {
        return;
      }
      var self = this;
      self.exporting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_impact__["j" /* exportImpact */])(self, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ view: 'risk' }, self.params), '综合风险榜.xlsx').finally(function () {
        self.exporting = false;
      });
    }
  }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_ImpactHeader_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_ImpactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_ImpactHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_KpiCard_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_KpiCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_KpiCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_BarList_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_BarList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__parts_BarList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_FilterPills_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_FilterPills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__parts_FilterPills_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_impact__ = __webpack_require__(41);










var REMAIN_LINE = 20;

function niceMax(v, floor) {
  if (v <= floor) {
    return floor;
  }
  var step = Math.pow(10, Math.floor(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10___default()(v)));
  return Math.ceil(v / step) * step;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchImpactStudent',
  components: { ImpactHeader: __WEBPACK_IMPORTED_MODULE_2__parts_ImpactHeader_vue___default.a, KpiCard: __WEBPACK_IMPORTED_MODULE_3__parts_KpiCard_vue___default.a, BarList: __WEBPACK_IMPORTED_MODULE_4__parts_BarList_vue___default.a, FilterPills: __WEBPACK_IMPORTED_MODULE_5__parts_FilterPills_vue___default.a },
  data: function data() {
    return {
      loading: false,
      exporting: false,
      loadedAt: '',
      days: 90,
      minCount: 2,
      minRemain: '',
      status: '',
      sortKey: 'cnt',
      sortDir: 'desc',
      pageIndex: 1,
      pageSize: 20,
      dayOptions: __WEBPACK_IMPORTED_MODULE_6__parts_impact__["c" /* DAY_OPTIONS */],
      countOptions: [{ value: 1, label: '≥ 1 次' }, { value: 2, label: '≥ 2 次' }, { value: 3, label: '≥ 3 次' }],
      remainOptions: [{ value: '', label: '不限' }, { value: 20, label: '≥ 20' }],
      statusOptions: [{ value: '', label: '全部' }, { value: '待换老师', label: '待换老师', color: '#E89F2D' }, { value: '已换老师', label: '已换老师', color: '#0B9E8D' }, { value: '正常上课', label: '正常上课', color: '#5B8FF9' }, { value: '流失预警', label: '流失预警', color: '#E6464E' }],
      d: {}
    };
  },

  computed: {
    filterParams: function filterParams() {
      return {
        days: this.days,
        minCount: this.minCount,
        minRemain: this.minRemain,
        status: this.status,
        sortKey: this.sortKey,
        sortDir: this.sortDir
      };
    },
    list: function list() {
      return this.d.list || [];
    },
    scatterList: function scatterList() {
      return this.d.scatter || [];
    },
    chips: function chips() {
      return [{ label: '时间窗口', value: '近 ' + this.days + ' 天' }, { label: '受影响', value: '≥ ' + this.minCount + ' 次' }, { label: '未消课时', value: this.minRemain === '' ? '不限' : '≥ ' + this.minRemain }, { label: '状态', value: this.status || '全部' }];
    },
    listSub: function listSub() {
      return '近 ' + this.days + ' 天 · 按' + (this.sortKey === 'cnt' ? '受影响次数' : '损失课次') + (this.sortDir === 'desc' ? '高 → 低' : '低 → 高') + ' · 点击表头切换排序';
    },
    kpiCards: function kpiCards() {
      var d = this.d;
      return [{
        key: 'highFreq',
        title: '高频受影响学生',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.highFreqCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["g" /* levelLow */])(d.highFreqRate, 5, 10),
        period: '占受影响学生 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["f" /* fmtRate */])(d.highFreqRate),
        compare: '受影响 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.affectedCount) + ' 人',
        compareTone: 'neutral',
        foot: '近 ' + this.days + ' 天被异动或请假波及 ≥ ' + this.minCount + ' 次'
      }, {
        key: 'lost',
        title: '累计损失课次',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.lostTotal),
        unit: '课次',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["g" /* levelLow */])(d.lostAvg, 2, 5),
        period: '人均 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.lostAvg) + ' 课次',
        compare: '',
        foot: '高频学生：异动损失课次 + 未代课请假课节'
      }, {
        key: 'waiting',
        title: '待换老师',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.waitingCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(d.waitingOver7Count) > 0 ? 'danger' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(d.waitingCount) > 0 ? 'warning' : 'healthy',
        period: '异动已生效，未在新老师处上课',
        compare: '超 7 天 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.waitingOver7Count) + ' 人',
        compareTone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(d.waitingOver7Count) > 0 ? 'danger' : 'neutral',
        foot: '事件已发生但仍未换上新老师'
      }, {
        key: 'churn',
        title: '高风险流失',
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.churnRiskCount),
        unit: '人',
        level: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(d.churnRiskCount) > 0 ? 'danger' : 'healthy',
        period: '涉及未消课时 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */])(d.churnRiskHours),
        compare: '',
        foot: '近 30 天无课 + 剩余课时 > 10 + 受影响 ≥ 2 次，三条同时满足'
      }];
    },
    sourceTotal: function sourceTotal() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["k" /* sumCount */])(this.d.source);
    },
    sourceRows: function sourceRows() {
      var total = this.sourceTotal;
      return (this.d.source || []).map(function (s) {
        return {
          key: s.type,
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["l" /* typeLabel */])(s.type),
          value: s.count,
          color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["m" /* typeColor */])(s.type),
          extra: total > 0 ? Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(s.count) / total * 100) + '%' : ''
        };
      });
    },
    sc: function sc() {
      var W = 700;
      var H = 260;
      var PL = 44;
      var PR = 16;
      var PT = 14;
      var PB = 32;
      var list = this.scatterList;
      var maxL = 0;
      var maxR = 0;
      list.forEach(function (p) {
        maxL = Math.max(maxL, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.lost));
        maxR = Math.max(maxR, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.remain));
      });
      var maxX = niceMax(maxL, 10);
      var maxY = niceMax(maxR, 40);
      var sx = function sx(v) {
        return PL + v / maxX * (W - PL - PR);
      };
      var sy = function sy(v) {
        return H - PB - v / maxY * (H - PT - PB);
      };
      var lostLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["n" /* isNum */])(this.d.lostAvg) && Number(this.d.lostAvg) > 0 ? Number(this.d.lostAvg) : 5;
      var dangerCount = 0;
      var points = list.map(function (p) {
        var danger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.lost) >= lostLine && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.remain) >= REMAIN_LINE;
        if (danger) {
          dangerCount++;
        }
        return {
          uid: p.uid,
          x: sx(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.lost)),
          y: sy(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.remain)),
          danger: danger,
          title: '学生 ' + p.uid + ' · 损失 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.lost) + ' · 剩余 ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */])(p.remain)
        };
      });
      var xTicks = [];
      var yTicks = [];
      for (var i = 0; i <= 4; i++) {
        xTicks.push({ v: Math.round(i / 4 * maxX), x: PL + i / 4 * (W - PL - PR) });
        yTicks.push({ v: Math.round(i / 4 * maxY), y: H - PB - i / 4 * (H - PT - PB) });
      }
      var zoneX = Math.min(sx(lostLine), W - PR);
      var zoneY = Math.max(sy(REMAIN_LINE), PT);
      return {
        W: W,
        H: H,
        PL: PL,
        PR: PR,
        PT: PT,
        PB: PB,
        points: points,
        xTicks: xTicks,
        yTicks: yTicks,
        zoneX: zoneX,
        zoneW: Math.max(0, W - PR - zoneX),
        zoneH: Math.max(0, zoneY - PT),
        lostLine: lostLine,
        remainLine: REMAIN_LINE,
        dangerCount: dangerCount
      };
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    num: __WEBPACK_IMPORTED_MODULE_6__parts_impact__["e" /* num */],
    fmtNum: __WEBPACK_IMPORTED_MODULE_6__parts_impact__["d" /* fmtNum */],
    fmtRate: __WEBPACK_IMPORTED_MODULE_6__parts_impact__["f" /* fmtRate */],
    typeLabel: __WEBPACK_IMPORTED_MODULE_6__parts_impact__["l" /* typeLabel */],
    sourceStyle: function sourceStyle(type) {
      var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["m" /* typeColor */])(type);
      return { color: c, background: c + '1A' };
    },
    levelBadge: function levelBadge(level) {
      return __WEBPACK_IMPORTED_MODULE_6__parts_impact__["h" /* LEVEL_BADGE */][level] || 'is-gray';
    },
    statusBadge: function statusBadge(status) {
      return __WEBPACK_IMPORTED_MODULE_6__parts_impact__["o" /* STATUS_BADGE */][status] || 'is-gray';
    },
    sortInd: function sortInd(key) {
      if (this.sortKey !== key) {
        return '';
      }
      return this.sortDir === 'desc' ? '▾' : '▴';
    },
    toggleSort: function toggleSort(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.sortKey = key;
        this.sortDir = 'desc';
      }
      this.reload();
    },
    reload: function reload() {
      this.pageIndex = 1;
      this.load();
    },
    onPageChange: function onPageChange(p) {
      if (p === this.pageIndex) {
        return;
      }
      this.pageIndex = p;
      this.load();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.load();
    },
    load: function load() {
      var self = this;
      self.loading = true;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ pageIndex: self.pageIndex, pageSize: self.pageSize }, self.filterParams);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["i" /* postImpact */])(self, '/student', params).then(function (data) {
        if (data) {
          self.d = data;
          self.loadedAt = self.$moment().format('YYYY-MM-DD HH:mm:ss');
        }
      }).finally(function () {
        self.loading = false;
      });
    },
    doExport: function doExport() {
      if (this.exporting) {
        return;
      }
      var self = this;
      self.exporting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_impact__["j" /* exportImpact */])(self, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ view: 'student' }, self.filterParams), '学生影响明细.xlsx').finally(function () {
        self.exporting = false;
      });
    }
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__impact__ = __webpack_require__(41);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BarList',
  props: {
    rows: { type: Array, default: function _default() {
        return [];
      } },
    unit: { type: String, default: '人' },
    labelWidth: { type: Number, default: 84 },
    rightWidth: { type: Number, default: 110 },
    defaultColor: { type: String, default: '#5C78A8' }
  },
  computed: {
    gridStyle: function gridStyle() {
      return { gridTemplateColumns: this.labelWidth + 'px minmax(0, 1fr) ' + this.rightWidth + 'px' };
    },
    shownRows: function shownRows() {
      var max = 0;
      this.rows.forEach(function (row) {
        var total = row.segs ? row.segs.reduce(function (n, s) {
          return n + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["e" /* num */])(s.value);
        }, 0) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["e" /* num */])(row.value);
        if (total > max) {
          max = total;
        }
      });
      max = max || 1;
      return this.rows.map(function (row) {
        var out = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row);
        out.valueText = row.valueText != null ? row.valueText : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["d" /* fmtNum */])(row.value);
        if (row.segs) {
          out.segs = row.segs.map(function (s) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, s, { width: Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["e" /* num */])(s.value) / max * 1000) / 10 });
          });
        } else if (row.percent != null) {
          out.width = Math.max(0, Math.min(100, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["e" /* num */])(row.percent)));
        } else {
          out.width = Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__impact__["e" /* num */])(row.value) / max * 1000) / 10;
        }
        return out;
      });
    }
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FilterPills',
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, default: function _default() {
        return [];
      } },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    isOn: function isOn(v) {
      return String(v) === String(this.value);
    },
    pick: function pick(v) {
      if (this.disabled || this.isOn(v)) {
        return;
      }
      this.$emit('input', v);
      this.$emit('on-change', v);
    }
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__impact__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImpactHeader',
  props: {
    title: { type: String, default: '' },
    tags: { type: Array, default: function _default() {
        return [];
      } },
    chips: { type: Array, default: function _default() {
        return [];
      } },
    loadedAt: { type: String, default: '' }
  },
  computed: {
    subText: function subText() {
      return ['Teacher Disruption Impact'].concat(this.tags).join(' / ');
    },
    metaRows: function metaRows() {
      return [{ label: '数据来源', value: __WEBPACK_IMPORTED_MODULE_0__impact__["a" /* DATA_SOURCE */] }, { label: '口径版本', value: __WEBPACK_IMPORTED_MODULE_0__impact__["b" /* RULE_VERSION */] }, { label: '最近更新', value: this.loadedAt || '—' }];
    }
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KpiCard',
  props: {
    level: { type: String, default: 'healthy' },
    title: { type: String, default: '' },
    value: { type: [String, Number], default: '—' },
    unit: { type: String, default: '' },
    period: { type: String, default: '' },
    compare: { type: String, default: '' },
    compareTone: { type: String, default: 'neutral' },
    foot: { type: String, default: '' }
  }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AllTchLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAdd: false,
      leaveParam: {
        startTime: '',
        endTime: '',
        remark: ''
      },
      leaveRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        remark: [{ required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    add: function add() {
      var self = this;
      this.$refs.leaveForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.loadingAdd = true;
        var params = self.leaveParam;
        self.$http.post('/bookTchLeaveTime/allTchLeave', params).then(function (res) {
          self.loadingAdd = false;
          if (res && res.data > 0) {
            self.$Message.success('请假成功!');
            self.visible = false;
          }
        }).catch(function (e) {
          self.loadingAdd = false;
        });
      });
    },
    startTimeChange: function startTimeChange(value) {
      this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeChange: function endTimeChange(value) {
      this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);





var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_0_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_0_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  name: 'BonusAndDeduction',
  data: function data() {
    return {
      headers: {},
      uploadType: '',
      loadingInsert: false,
      fullscreenLoading: false,
      action: this.$appConfig.baseUrl + '/upload/fileUpload',
      acceptType: '',
      formData: {
        content: '',
        id: null
      },
      options: {},
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link', 'image', 'video']]
          }
        }
      }
    };
  },

  methods: {
    textChange: function textChange(val) {
      localStorage.setItem('bonusAndDeduction', this.formData.content);
    },
    beforeUpload: function beforeUpload(file) {
      if (file) {
        var names = file.name.split('.');
        if (names.length > 0 && names[names.length - 1] === 'mp3') {
          this.uploadType = 'audio';
        }
      }
      this.fullscreenLoading = true;
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
    },
    imgHandler: function imgHandler(state) {
      this.uploadType = 'image';
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('imgInput');
        fileInput.click();
      }
    },
    videoHandler: function videoHandler(state) {
      this.uploadType = 'video';
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        var fileInput = document.getElementById('imgInput');
        fileInput.click();
      }
    },
    upScuccess: function upScuccess(e, file, fileList) {
      var self = this;
      var response = file.response.data;
      if (!response || !response.url) {
        this.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        this.fullscreenLoading = false;
        return;
      }
      var url = response.url;
      if (url != null && url.length > 0) {
        self.addRange = self.$refs.myQuillEditor.quill.getSelection();
        var index = self.addRange != null ? self.addRange.index : 0;
        self.$refs.myQuillEditor.quill.insertEmbed(index, self.uploadType, url, 'user');
        this.fullscreenLoading = false;
      } else {
        this.$Message.error(self.uploadType + '\u63D2\u5165\u5931\u8D25');
        this.fullscreenLoading = false;
      }
      self.uploadType = '';
      this.$refs['upload'].clearFiles();
    },
    openPreview: function openPreview() {
      var url = '/#/course/lessonPreview';
      window.open(url);
    },
    saveData: function saveData() {
      var self = this;
      self.loadingInsert = true;
      self.$http.post('/tch/updateBonusDeduction', this.formData).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('保存成功!');
          self.loadData();
          self.loadingInsert = false;
        }
      }).catch(function (e) {
        self.loadingInsert = false;
      });
    },
    loadData: function loadData() {
      var self = this;
      self.$http.get('/tch/getBonusDeductionList').then(function (res) {
        if (res.data) {
          self.formData = res.data;
        }
      });
    }
  },
  mounted: function mounted() {
    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler);
    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);
  },

  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      visible: this.value,
      loadingAdd: false,
      leaveParam: {
        noProxy: '0',
        leaveType: '',
        remark: ''
      }
    };
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      this.$Message.loading('文件上传中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {},
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.status !== 'ok') {
        this.$Message.error(res.msg);
        this.resetLeaveParam();
      } else {
        this.$Message.success('上传成功，请耐心等待并关注最终结果');
        this.fileList = [];
      }
      this.visible = false;
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    resetLeaveParam: function resetLeaveParam() {
      this.fileList = [];
      this.leaveParam.leaveType = '';
      this.leaveParam.remark = '';
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.resetLeaveParam();
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ResignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_lesson_modal_LessonFeedbackDealModal_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_lesson_modal_LessonFeedbackDealModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_lesson_modal_LessonFeedbackDealModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_AddMatchCenterModal_vue__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_AddMatchCenterModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modal_AddMatchCenterModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_store__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_store__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue___default.a,
    ExportLeaveModal: __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_5__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_7__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_8__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_9__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_10__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect___default.a,
    ResignModal: __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue___default.a,
    LessonFeedbackDealModal: __WEBPACK_IMPORTED_MODULE_19__components_lesson_modal_LessonFeedbackDealModal_vue___default.a,
    AddMatchCenterModal: __WEBPACK_IMPORTED_MODULE_20__modal_AddMatchCenterModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    var self = this;
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      queryParam: {
        creator: '',
        tchId: '',
        tchName: '',
        content: '',
        startDate: '',
        endDate: '',
        completed: '0',
        auditStatus: '',
        bizTypes: ['加开固定时间', '上课反馈', '外教回复', '加开临时时间', '其他', '加开短期固定时间', '开绑定权限', '开临时约课权限']
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      showTchResignModal: false,
      showLessonFeedbackDealModal: false,
      showAddMatchCenterModal: false,
      feedBackParamData: {},
      timeList: [],
      resignTitle: '',
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: null,
        substituteTchId: ''
      },
      title: [{
        title: '反馈人',
        width: 80,
        align: 'center',
        key: 'fromUser'
      }, {
        title: '反馈时间',
        width: 120,
        align: 'center',
        key: 'createTime'
      }, {
        title: '反馈端口',
        width: 100,
        align: 'center',
        key: 'bizFrom'
      }, {
        title: '反馈类型',
        width: 130,
        align: 'center',
        key: 'bizType'
      }, {
        title: '反馈内容',
        key: 'feedContent',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var feedContent = params.row.feedContent;
          var lessonTime = params.row.lessonTime;
          var bizType = params.row.bizType;
          if (['加开固定的时间', '加开固定时间', '加开短期固定时间'].includes(bizType)) {
            try {
              var list = JSON.parse(feedContent);
              var spanArr = [];
              if (list) {
                list.forEach(function (set) {
                  var timeText = set.weekStr + ' ' + (set.startTimeStr || '00:00') + ' - ' + set.endTimeStr + '\uFF0C\u751F\u6548\u65F6\u95F4\uFF1A' + set.useDateStr;
                  if (set.endDateStr) {
                    timeText += '\uFF0C\u5931\u6548\u65F6\u95F4\uFF1A' + (set.endDateStr || set.endDateStr);
                  }
                  spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }), h('span', timeText)]));
                  spanArr.push(h('br'));
                });
              }
              return h('div', { style: { 'font-size': '12px' } }, [h('p', spanArr)]);
            } catch (e) {
              return h('span', feedContent);
            }
          } else if (bizType === '加开临时时间') {
            try {
              var _list = JSON.parse(feedContent);
              var _spanArr = [];
              if (_list) {
                _list.forEach(function (set) {
                  _spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }), h('span', set.dayStr + ' ' + set.startTimeStr + ' - ' + set.endTimeStr)]));
                  _spanArr.push(h('br'));
                });
              }
              return h('div', { style: { 'font-size': '12px' } }, [h('p', _spanArr)]);
            } catch (e) {
              return h('span', feedContent);
            }
          } else if (bizType === '体验课上课要求') {
            if (feedContent && feedContent.includes('|')) {
              var parts = feedContent.split('|');
              var firstPart = parts[0];
              var secondPart = parts[1];
              var tags = [];
              if (secondPart) {
                var tagsString = secondPart.replace(/[[\]"']/g, '');
                if (tagsString.trim()) {
                  tags = tagsString.split(',').map(function (tag) {
                    return tag.trim();
                  }).filter(function (tag) {
                    return tag;
                  });
                }
              }

              var children = [];

              if (firstPart) {
                children.push(h('div', { style: 'margin-bottom: 5px;' }, firstPart));
              }

              if (tags.length > 0) {
                var tagColors = ['green', 'orange', 'red', 'blue', 'purple'];

                var tagElements = tags.map(function (tag, index) {
                  return h('Tag', {
                    props: {
                      color: tagColors[index % tagColors.length],
                      closable: false
                    },
                    style: {
                      margin: '2px 5px 2px 0',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }
                  }, tag);
                });

                children.push(h('div', {
                  style: 'display: flex; flex-wrap: wrap; align-items: center;'
                }, tagElements));
              }

              return h('div', children);
            } else {
              return h('span', feedContent);
            }
          } else {
            if (lessonTime) {
              return h('div', { style: 'display: flex; flex-direction: column;' }, [h('a', { on: { click: function click() {
                    return _this.openLessonList(params.row.bookLessonOpenedId);
                  } } }, lessonTime), h('span', feedContent)]);
            } else {
              return h('span', feedContent);
            }
          }
        }
      }, {
        title: '学生ID、名称',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var uid = params.row.uid;
          var stdName = params.row.stdName;
          var str = '-';
          if (uid) {
            str = uid + '-' + stdName;
          }
          if (str === '-') {
            return h('span', '-');
          } else {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.openInfoModal(uid);
                } } }, uid + '-' + stdName)]);
          }
        }
      }, {
        title: '老师ID、名称',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchId) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: row.tchId + '-' + row.tchName,
              score: row.monthRankScore,
              onClick: function onClick() {
                return _this.openTchInfoModal(row.tchId);
              }
            });
          } else {
            return h('span', '-');
          }
        }
      }, {
        title: 'sc/cc',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var scName = params.row.scName;
          var ccName = params.row.ccName;
          return h('div', [h('div', scName || '-'), h('div', ccName || '-')]);
        }
      }, {
        title: '是否完结',
        width: 70,
        align: 'center',
        key: 'completed',
        render: function render(h, params) {
          var completed = params.row.completed;
          var completedEnum = $constant.getEnum($constant.yesOrNo, completed);
          return h('span', completedEnum && completedEnum.text);
        }
      }, {
        title: '审批状态',
        key: 'auditStatus',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var auditStatus = params.row.auditStatus;
          var auditStatusEnum = $constant.getEnum($constant.auditStatus, auditStatus);
          return h('span', auditStatusEnum && auditStatusEnum.text);
        }
      }, {
        title: '审批人',
        key: 'auditorName',
        width: 100,
        align: 'center'
      }, {
        title: '审批意见',
        key: 'auditRemark',
        width: 120,
        align: 'center'
      }, {
        title: '是否展示给老师',
        key: 'showTch',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var showTch = params.row.showTch;
          var showTchEnum = $constant.getEnum($constant.yesOrNo, showTch);
          return h('span', showTchEnum && showTchEnum.text);
        }
      }, {
        title: '老师是否收到',
        key: 'received',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var received = params.row.received;
          var receivedEnum = $constant.getEnum($constant.yesOrNo, received);
          return h('span', receivedEnum && receivedEnum.text);
        }
      }, {
        title: '老师确认',
        key: 'tchConfirm',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchConfirmEnum = [{ code: 0, text: '未回复' }, { code: 1, text: '同意' }, { code: 2, text: '拒绝' }];
          var tchConfirm = params.row.tchConfirm;
          var tchConfirmItem = $constant.getEnum(tchConfirmEnum, tchConfirm);
          return h('span', tchConfirmItem && tchConfirmItem.text || '未回复');
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: function render(h, params) {
          return h('div', {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px'
            }
          }, [h('a', {
            on: {
              click: function click() {
                if (params.row.auditStatus != 0 || params.row.completed) {
                  return;
                }
                _this.showLessonFeedbackDealModal = true;
                if (['加开固定时间', '加开临时时间'].includes(params.row.bizType)) {
                  _this.timeList = JSON.parse(params.row.feedContent);
                } else {
                  _this.timeList = [];
                }
                _this.feedBackParamData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params.row, { showTch: params.row.showTch === true ? 1 : 0 });
              }
            },
            style: {
              color: params.row.auditStatus == 0 && !params.row.completed ? '#2d8cf0' : 'gray'
            }
          }, '审批'), h('a', {
            on: {
              click: function click() {
                if (params.row.completed) {
                  return;
                }
                _this.handleEnd(params.row);
              }
            },
            style: {
              color: params.row.completed ? 'gray' : '#2d8cf0'
            }
          }, '完结')]);
        }
      }]
    };
  },

  created: function created() {},
  methods: {
    openLessonList: function openLessonList(val) {
      var _$router$resolve = this.$router.resolve({
        name: 'bookLessonOpenedList',
        query: { bookLessonOpenedId: val, pageIndex: 1, pageSize: 10 } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve2 = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList' } }),
          href = _$router$resolve2.href;

      window.open(href, '_blank');
    },
    startDateChange: function startDateChange(value) {
      this.queryParam.startDate = value;
    },
    endDateChange: function endDateChange(value) {
      this.queryParam.endDate = value;
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    addTch: function addTch() {
      this.showAddMatchCenterModal = true;
      this.tchId = null;
    },
    handleEnd: function handleEnd(row) {
      var _this2 = this;

      this.$http.post('/stageReport/fm-message-completed?id=' + row.id).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('完结成功');
          _this2.search();
        } else {
          _this2.$Message.error('完结失败');
        }
      });
    }
  },
  watch: {}
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      tableLoading: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 10,
      selectedRows: [],
      summaryLesson: 0,
      summaryAmount: '0.00',
      fmList: [],
      queryParam: {
        recommendedKeyword: '',
        referrerKeyword: '',
        fmId: null,
        openClassMonth: '',
        month: '',
        grantStatus: null,
        isInRewardPeriod: null,
        hr: ''
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '被推荐人',
        width: 180,
        ellipsis: true,
        render: function render(h, params) {
          return _this.renderIdName(h, params.row.recommendedId, params.row.recommendedName);
        }
      }, {
        title: '开课日期',
        width: 120,
        align: 'center',
        key: 'openClassDate'
      }, {
        title: '是否奖励期',
        width: 96,
        align: 'center',
        render: function render(h, params) {
          return h('span', {
            style: { color: params.row.isInRewardPeriod ? '#19be6b' : '#999' }
          }, params.row.isInRewardPeriod ? '是' : '否');
        }
      }, {
        title: '推荐官',
        width: 180,
        ellipsis: true,
        render: function render(h, params) {
          return _this.renderIdName(h, params.row.referrerId, params.row.referrerName);
        }
      }, {
        title: '推荐官FM',
        width: 140,
        ellipsis: true,
        render: function render(h, params) {
          return _this.renderIdName(h, params.row.fmId, params.row.fmName);
        }
      }, {
        title: 'HR',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var options = _this.$constant.hrList.slice();
          if (row.hr && !options.some(function (item) {
            return item.code === row.hr;
          })) {
            options = [{ code: row.hr, text: row.hr }].concat(options);
          }
          return h('Select', {
            props: {
              value: row.hr,
              transfer: true,
              clearable: true
            },
            on: {
              'on-change': function onChange(value) {
                var newValue = value || '';
                if (newValue !== (row.hr || '')) {
                  row.hr = newValue;
                  _this.updateHr(row, newValue);
                }
              }
            }
          }, options.map(function (item) {
            return h('Option', { props: { value: item.code }, key: item.code }, item.text);
          }));
        }
      }, {
        title: '完成课时',
        width: 90,
        align: 'center',
        key: 'lessonCount'
      }, {
        title: '奖励截止年月',
        width: 120,
        align: 'center',
        key: 'rewardEndMonth'
      }, {
        title: '奖励金额($)',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', {
            style: { color: params.row.isInRewardPeriod ? '#19be6b' : '#999' }
          }, params.row.feeAmount || 0);
        }
      }, {
        title: '发放状态',
        width: 112,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.grantStatus;
          return h('Select', {
            props: {
              value: status,
              size: 'small',
              transfer: true
            },
            class: 'grant-status-select',
            on: {
              'on-change': function onChange(value) {
                return _this.updateGrantStatus(params.row, value);
              }
            }
          }, [h('Option', { props: { value: 0 } }, '待审核'), h('Option', { props: { value: 1 } }, '已发放')]);
        }
      }, {
        title: '发放时间',
        width: 160,
        align: 'center',
        key: 'grantTime'
      }]
    };
  },
  mounted: function mounted() {
    this.loadFmList();
    this.loadList();
  },

  methods: {
    loadFmList: function loadFmList() {
      var _this2 = this;

      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        _this2.fmList = res.data || [];
      });
    },
    search: function search() {
      this.pageIndex = 1;
      this.loadList();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    openClassMonthChange: function openClassMonthChange(value) {
      this.queryParam.openClassMonth = value;
    },
    monthChange: function monthChange(value) {
      this.queryParam.month = value;
    },
    formatIdName: function formatIdName(id, name) {
      var nameText = name == null ? '' : String(name).trim();
      if (!nameText) {
        nameText = '-';
      }
      if (id == null || String(id).trim() === '') {
        return nameText;
      }
      return id + '-' + nameText;
    },
    renderIdName: function renderIdName(h, id, name) {
      var text = this.formatIdName(id, name);
      return h('Poptip', {
        class: 'fee-name-poptip',
        props: {
          trigger: 'click',
          transfer: true,
          placement: 'bottom-start',
          wordWrap: true
        }
      }, [h('span', {
        class: 'fee-name-cell'
      }, text), h('div', {
        slot: 'content',
        style: {
          maxWidth: '320px',
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '22px'
        }
      }, text)]);
    },
    toYearMonth: function toYearMonth(value) {
      if (value == null || value === '') {
        return '';
      }
      if (value instanceof Date && !isNaN(value.getTime())) {
        var y = value.getFullYear();
        var m = value.getMonth() + 1;
        return y + '-' + (m < 10 ? '0' + m : '' + m);
      }
      var text = String(value).trim();
      if (!text) {
        return '';
      }

      if (/^\d{4}-\d{2}/.test(text)) {
        return text.slice(0, 7);
      }
      return text;
    },
    buildQueryParam: function buildQueryParam() {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.queryParam);
      if (params.hr === '') {
        delete params.hr;
      }
      if (params.fmId === null || params.fmId === undefined || params.fmId === '') {
        delete params.fmId;
      }
      var openClassMonth = this.toYearMonth(params.openClassMonth);
      if (openClassMonth) {
        params.openClassMonth = openClassMonth;
      } else {
        delete params.openClassMonth;
      }
      var month = this.toYearMonth(params.month);
      if (month) {
        params.month = month;
      } else {
        delete params.month;
      }
      return params;
    },
    updateHr: function updateHr(row, newValue) {
      var _this3 = this;

      this.$http.post('/tch/update-direct', { tchForm: { tchId: row.recommendedId, hr: newValue } }).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success('更新成功');
        } else {
          _this3.$Message.error(res.msg);
        }
      });
    },
    loadList: function loadList() {
      var self = this;
      this.tableLoading = true;
      var params = this.buildQueryParam();
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;

      this.$http.post('/referrer/fee/list', params).then(function (res) {
        if (res && res.data) {
          self.tableData = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
          self.applySummary(res.data.result);
        } else {
          self.tableData = [];
          self.totalCount = 0;
          self.applySummary('');
        }
      }).finally(function () {
        self.tableLoading = false;
      });
    },
    applySummary: function applySummary(result) {
      var parts = String(result || '').split(',');
      this.summaryLesson = parts[0] || 0;
      this.summaryAmount = parts[1] || '0.00';
    },
    changePageIndex: function changePageIndex(page) {
      this.pageIndex = page;
      this.loadList();
    },
    selectionChange: function selectionChange(selection) {
      this.selectedRows = selection || [];
    },
    buildFeePayload: function buildFeePayload(row, grantStatus) {
      var payload = {
        id: row.id,
        recommendedId: row.recommendedId,
        month: row.month,
        referrerId: row.referrerId,
        lessonCount: row.lessonCount,
        feeAmount: row.feeAmount,
        openClassDate: row.openClassDate,
        rewardEndMonth: row.rewardEndMonth
      };
      if (grantStatus !== undefined && grantStatus !== null) {
        payload.grantStatus = grantStatus;
      }
      return payload;
    },
    updateGrantStatus: function updateGrantStatus(row, grantStatus) {
      var _this4 = this;

      if (!row || row.grantStatus === grantStatus) {
        return;
      }
      this.$http.post('/referrer/fee/grantStatus', this.buildFeePayload(row, grantStatus)).then(function (res) {
        _this4.$Message.success('发放状态已更新');
        _this4.loadList();
      }).catch(function () {
        _this4.loadList();
      });
    },
    handleExport: function handleExport() {
      this.$http.get('/referrer/fee/export', {
        responseType: 'arraybuffer',
        params: this.buildQueryParam()
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '被推荐人管理.csv';
          link.click();
        }
      });
    },
    handleBatchGrant: function handleBatchGrant() {
      var _this5 = this;

      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$Message.warning('请先勾选要发放的记录');
        return;
      }
      this.$Modal.confirm({
        title: '确认发放',
        content: '\u786E\u5B9A\u8981\u53D1\u653E\u9009\u4E2D\u7684 ' + this.selectedRows.length + ' \u6761\u8BB0\u5F55\u5417\uFF1F',
        loading: true,
        onOk: function onOk() {
          var payload = _this5.selectedRows.map(function (row) {
            return _this5.buildFeePayload(row);
          });
          _this5.$http.post('/referrer/fee/grant', payload, {
            headers: { 'Content-Type': 'application/json;charset=utf-8' }
          }).then(function (res) {
            _this5.$Message.success('发放成功');
            _this5.selectedRows = [];
            _this5.loadList();
          }).finally(function () {
            _this5.$Modal.remove();
          });
        }
      });
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      loadingAdd: false,
      loadingHr: false,
      rankLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showAddModal: false,
      showDetailModal: false,
      showHrModal: false,
      showBackfillModal: false,
      loadingBackfill: false,
      backfillParam: {
        startMonth: '',
        endMonth: ''
      },
      fmList: [],
      rankList: [],
      selectedIds: [],
      detailData: null,
      monthlyStats: [],
      addParam: {
        referrerId: null,
        referrerName: '',
        fmId: null,
        hrName: '',
        joinDate: '',
        status: 1
      },
      hrParam: {
        referrerIds: [],
        hrName: ''
      },
      queryParam: {
        referrerKeyword: '',
        fmId: null,
        hrName: '',
        status: null,
        yearMonth: ''
      },
      addRules: {
        referrerId: [{ required: true, type: 'number', message: '请输入推荐官ID' }]
      },
      rankColumns: [{
        title: '名次',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.index + 1);
        }
      }, {
        title: '姓名',
        key: 'referrerName',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.referrerName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '预计奖励($)',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.formatAmount(params.row));
        }
      }],
      detailColumns: [{ title: '月份', key: 'month', align: 'center' }, { title: '推荐数', key: 'recommendCount', align: 'center' }, { title: '审核通过', key: 'approveCount', align: 'center' }, { title: '审核拒绝', key: 'rejectCount', align: 'center' }, { title: '开课数', key: 'openClassCount', align: 'center' }],
      title: [{
        type: 'selection',
        width: 50,
        fixed: 'left',
        align: 'center',
        className: 'referrer-select-column'
      }, {
        title: 'ID-姓名',
        width: 180,
        fixed: 'left',
        ellipsis: true,
        render: function render(h, params) {
          var name = params.row.referrerName || '-';
          var tid = params.row.referrerId;
          var text = tid == null ? name : tid + '-' + name;
          return h('Poptip', {
            class: 'referrer-name-poptip',
            props: {
              trigger: 'click',
              transfer: true,
              placement: 'bottom-start',
              wordWrap: true
            }
          }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: text,
            score: params.row.monthRankScore
          }), h('div', {
            slot: 'content',
            style: {
              maxWidth: '320px',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              lineHeight: '22px'
            }
          }, text)]);
        }
      }, {
        title: '状态',
        width: 130,
        minWidth: 130,
        fixed: 'left',
        align: 'center',
        className: 'referrer-status-column',
        render: function render(h, params) {
          return h('Select', {
            props: {
              value: params.row.status,
              size: 'small',
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                return _this.updateStatus(params.row, value);
              }
            }
          }, [h('Option', { props: { value: 1 } }, '招聘试用期'), h('Option', { props: { value: 2 } }, '招聘转正'), h('Option', { props: { value: 3 } }, '招聘停用')]);
        }
      }, {
        title: 'FM',
        width: 100,
        key: 'fmName'
      }, {
        title: 'HR负责人',
        width: 100,
        key: 'hrName'
      }, {
        title: '加入日期',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          return h('DatePicker', {
            props: {
              value: params.row.joinDate,
              type: 'date',
              format: 'yyyy-MM-dd',
              size: 'small',
              transfer: true,
              clearable: false
            },
            on: {
              'on-change': function onChange(value) {
                return _this.updateJoinDate(params.row, value);
              }
            }
          });
        }
      }, {
        title: '奖励期限(月)',
        width: 110,
        align: 'center',
        className: 'referrer-reward-months-column',
        render: function render(h, params) {
          var options = [];
          for (var i = 1; i <= 12; i++) {
            options.push(h('Option', { props: { value: i } }, String(i)));
          }
          return h('Select', {
            props: {
              value: params.row.rewardMonths,
              size: 'small',
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                return _this.updateRewardMonths(params.row, value);
              }
            }
          }, options);
        }
      }, {
        title: '开课日期',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.formatOpenCourseDate(params.row.openCourseTime));
        }
      }, {
        title: '本月推荐',
        width: 90,
        align: 'center',
        key: 'monthRecommendCount'
      }, {
        title: '本月审核通过',
        width: 110,
        align: 'center',
        key: 'monthApproveCount'
      }, {
        title: '本月审核拒绝',
        width: 110,
        align: 'center',
        key: 'monthRejectCount'
      }, {
        title: '本月开课',
        width: 90,
        align: 'center',
        key: 'monthOpenClassCount'
      }, {
        title: '累计推荐',
        width: 90,
        align: 'center',
        key: 'totalRecommendCount'
      }, {
        title: '累计审核通过',
        width: 110,
        align: 'center',
        key: 'totalApproveCount'
      }, {
        title: '累计审核拒绝',
        width: 110,
        align: 'center',
        key: 'totalRejectCount'
      }, {
        title: '累计开课',
        width: 90,
        align: 'center',
        key: 'totalOpenClassCount'
      }, {
        title: '本月预计奖励($)',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.formatAmount({ monthRewardAmount: params.row.monthRewardAmount }));
        }
      }, {
        title: '累计奖励($)',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.formatAmount({ monthRewardAmount: params.row.totalRewardAmount }));
        }
      }, {
        title: '是否达到转正条件',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.reachFormal ? '是' : '否');
        }
      }, {
        title: '操作',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: { click: function click() {
                return _this.showDetail(params.row);
              } }
          }, '详情')]);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.loadFmList();
    this.loadRewardRank();
  },

  methods: {
    loadRankMonthScores: function loadRankMonthScores() {
      var table = this.rankList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.referrerId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'referrerId', 'monthRankScore', map);
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
      this.loadRewardRank();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.referrerId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'referrerId', 'monthRankScore', map);
      });
    },
    yearMonthChange: function yearMonthChange(value) {
      this.queryParam.yearMonth = value;
      this.search();
    },
    getStatusText: function getStatusText(status) {
      var map = { 1: '招聘试用期', 2: '招聘转正', 3: '招聘停用' };
      return map[status] || '-';
    },
    formatAmount: function formatAmount(row) {
      var value = row ? row.monthRewardAmount : null;
      if (value === undefined || value === null) {
        value = row ? row.rewardAmount : null;
      }
      if (value === undefined || value === null) {
        value = row ? row.amount : null;
      }
      var num = Number(value || 0);
      return isNaN(num) ? '0.00' : num.toFixed(2);
    },
    loadFmList: function loadFmList() {
      var _this2 = this;

      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        _this2.fmList = res.data || [];
      });
    },
    loadRewardRank: function loadRewardRank() {
      var _this3 = this;

      this.rankLoading = true;
      var params = {};
      if (this.queryParam.yearMonth) {
        params.yearMonth = this.queryParam.yearMonth;
      }
      this.$http.get('/referrer/info/rewardRank', { params: params }).then(function (res) {
        _this3.rankList = res.data || [];
        _this3.loadRankMonthScores();
      }).catch(function () {
        _this3.rankList = [];
      }).finally(function () {
        _this3.rankLoading = false;
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectedIds = selection.map(function (item) {
        return item.referrerId;
      });
    },
    onReferrerIdChange: function onReferrerIdChange(val) {
      this.addParam.referrerId = val;
      this.fillAddByTchId();
    },
    onReferrerIdBlur: function onReferrerIdBlur() {
      this.fillAddByTchId();
    },
    fillAddByTchId: function fillAddByTchId() {
      var _this4 = this;

      if (!this.addParam.referrerId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
      var tchId = this.addParam.referrerId;
      return this.$http.get('/referrer/info/getByTchId', {
        params: { tchId: tchId }
      }).then(function (res) {
        if (_this4.addParam.referrerId !== tchId) {
          return;
        }
        var info = res.data;
        if (!info) {
          _this4.$Message.warning('老师不存在，无法带出信息');
          return;
        }

        _this4.addParam.referrerName = info.referrerName || '';
        _this4.addParam.fmId = info.fmId || null;
        _this4.addParam.fmName = info.fmName || '';
        _this4.addParam.hrName = info.hrName || '';
      }).catch(function () {});
    },
    openAddModal: function openAddModal() {
      var _this5 = this;

      this.addParam = {
        referrerId: null,
        referrerName: '',
        fmId: null,
        hrName: '',
        joinDate: '',
        status: 1
      };
      this.showAddModal = true;
      this.$nextTick(function () {
        if (_this5.$refs.addForm) {
          _this5.$refs.addForm.resetFields();
        }
      });
    },
    onAdd: function onAdd() {
      var _this6 = this;

      this.$refs.addForm.validate(function (valid) {
        if (!valid) return;
        _this6.loadingAdd = true;

        var keptJoin = _this6.formatJoinDate(_this6.addParam.joinDate);
        _this6.fillAddByTchId().then(function () {
          _this6.addParam.joinDate = keptJoin;
          var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.addParam);
          if (keptJoin) {
            payload.joinDate = keptJoin;
          } else {
            delete payload.joinDate;
          }
          return _this6.$http.post('/referrer/info/add', payload);
        }).then(function (res) {
          _this6.$Message.success('添加成功');
          _this6.showAddModal = false;
          _this6.addParam = {
            referrerId: null,
            referrerName: '',
            fmId: null,
            hrName: '',
            joinDate: '',
            status: 1
          };
          _this6.search();
        }).finally(function () {
          _this6.loadingAdd = false;
        });
      });
    },
    formatOpenCourseDate: function formatOpenCourseDate(value) {
      if (value == null || value === '') {
        return '';
      }
      var text = String(value).slice(0, 10);
      return (/^\d{4}-\d{2}-\d{2}$/.test(text) ? text : ''
      );
    },
    formatJoinDate: function formatJoinDate(value) {
      if (!value) {
        return '';
      }
      if (typeof value === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return value;
        }
        var d = new Date(value);
        if (!isNaN(d.getTime())) {
          var y = d.getFullYear();
          var m = ('0' + (d.getMonth() + 1)).slice(-2);
          var day = ('0' + d.getDate()).slice(-2);
          return y + '-' + m + '-' + day;
        }
        return value.slice(0, 10);
      }
      if (value instanceof Date && !isNaN(value.getTime())) {
        var _y = value.getFullYear();
        var _m = ('0' + (value.getMonth() + 1)).slice(-2);
        var _day = ('0' + value.getDate()).slice(-2);
        return _y + '-' + _m + '-' + _day;
      }
      return '';
    },
    onAddJoinDateChange: function onAddJoinDateChange(value) {
      this.addParam.joinDate = value || '';
    },
    updateJoinDate: function updateJoinDate(row, value) {
      var _this7 = this;

      var joinDate = this.formatJoinDate(value);
      if (!joinDate || joinDate === row.joinDate) {
        return;
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        joinDate: joinDate
      }).then(function (res) {
        _this7.$Message.success('加入日期已更新');
        _this7.search();
      }).catch(function () {
        _this7.search();
      });
    },
    updateRewardMonths: function updateRewardMonths(row, value) {
      var _this8 = this;

      if (value == null || value === row.rewardMonths) {
        return;
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        rewardMonths: value
      }).then(function (res) {
        _this8.$Message.success('奖励期限已更新');
        _this8.search();
      }).catch(function () {
        _this8.search();
      });
    },
    updateStatus: function updateStatus(row, value) {
      var _this9 = this;

      if (value === row.status) {
        return;
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        status: value
      }).then(function (res) {
        _this9.$Message.success('状态已更新');
        _this9.search();
      }).catch(function () {
        _this9.search();
      });
    },
    showDetail: function showDetail(row) {
      var _this10 = this;

      this.$http.get('/referrer/info/detail', { params: { referrerId: row.referrerId } }).then(function (res) {
        _this10.detailData = res.data;
      });
      this.$http.get('/referrer/info/monthlyStats', { params: { referrerId: row.referrerId } }).then(function (res) {
        _this10.monthlyStats = res.data || [];
      });
      this.showDetailModal = true;
    },
    openBackfillModal: function openBackfillModal() {
      this.backfillParam = { startMonth: '', endMonth: '' };
      this.showBackfillModal = true;
    },
    onBackfillStartChange: function onBackfillStartChange(value) {
      this.backfillParam.startMonth = value || '';
    },
    onBackfillEndChange: function onBackfillEndChange(value) {
      this.backfillParam.endMonth = value || '';
    },
    onGenerateRewardMonth: function onGenerateRewardMonth() {
      var _this11 = this;

      if (!this.backfillParam.startMonth || !this.backfillParam.endMonth) {
        this.$Message.warning('请选择开始月和结束月');
        return;
      }
      this.loadingBackfill = true;
      this.$http.post('/referrer/info/generateRewardMonth', {
        startMonth: this.backfillParam.startMonth,
        endMonth: this.backfillParam.endMonth
      }).then(function (res) {
        var months = res.data;
        _this11.$Message.success('历史汇总已生成，处理月份数：' + (months == null ? 0 : months));
        _this11.showBackfillModal = false;
        _this11.search();
      }).finally(function () {
        _this11.loadingBackfill = false;
      });
    },
    openBatchHrModal: function openBatchHrModal() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.$Message.warning('请选择数据');
        return;
      }
      this.hrParam = {
        referrerIds: this.selectedIds.slice(),
        hrName: ''
      };
      this.showHrModal = true;
    },
    onUpdateHr: function onUpdateHr() {
      var _this12 = this;

      if (!this.hrParam.hrName) {
        this.$Message.warning('请选择HR负责人');
        return;
      }
      if (!this.hrParam.referrerIds || this.hrParam.referrerIds.length === 0) {
        this.$Message.warning('请先勾选推荐官');
        return;
      }
      var hrName = this.hrParam.hrName;
      this.loadingHr = true;
      var requests = this.hrParam.referrerIds.map(function (referrerId) {
        return _this12.$http.post('/referrer/info/updateHr', {
          referrerId: referrerId,
          hrName: hrName
        });
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(requests).then(function () {
        _this12.$Message.success('分配成功');
        _this12.showHrModal = false;
        _this12.selectedIds = [];
        _this12.search();
      }).finally(function () {
        _this12.loadingHr = false;
      });
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number,
      default: false
    },
    title: {
      type: String,
      default: '确认老师离职吗？'
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      visible: this.value,
      oldTch: null,
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '外教运营',
        width: 80,
        key: 'tchStudyAdviserNickname'
      }, {
        title: '学导',
        width: 80,
        key: 'studyAdviserNickname'
      }, {
        title: '课顾',
        width: 80,
        key: 'adviserNickname'
      }, {
        title: '课程类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        width: 180,
        key: 'lessonTitle'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '是否代课',
        width: 70,
        key: 'isProxy',
        render: function render(h, params) {
          var isProxy = params.row.isProxy;
          return h('div', isProxy === 1 ? '是' : '否');
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 72,
        render: function render(h, params) {
          _this.oldTch = params.row.oldOpenedId;
          var courseType = params.row.courseType;
          var isProxy = params.row.isProxy;
          if (courseType === 8) {
            if (isProxy === 1) {
              return h('a', { on: { click: function click() {
                    return _this.cancelProxyClass(params.row);
                  } } }, '取消代课');
            } else {
              return h('a', { on: { click: function click() {
                    return _this.proxyClass(params.row);
                  } } }, '代课');
            }
          }
        }
      }],
      bookLessonOpenedList: [],
      loadingSearch: false,
      loadingAdd: false,
      leaveParam: {
        lastWorkDay: '',
        startTime: '',
        resignReason: '',
        rehireFlag: null,
        resignType: null
      },
      leaveRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];

            callback(errors);
          }
        }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        remark: [{ type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      startTime: '',
      endTime: '',
      remarkType: [{ type: 'string', required: true, message: '请填写请假原因类别', trigger: 'blur' }, { type: 'string', max: 100, message: '不知道就问主管', trigger: 'blur' }]
    };
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.bookLessonOpenedList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    add: function add() {
      var self = this;
      if (!self.leaveParam.resignType) {
        self.$Message.error('请选择离职类型');
        return;
      }
      if (self.leaveParam.lastWorkDay === '') {
        self.$Message.error('请选择最后工作日期');
        return;
      }
      self.loadingAdd = true;
      var params = {
        lastWorkDay: self.leaveParam.lastWorkDay,
        tchId: self.tchId,
        resignReason: self.leaveParam.resignReason,
        rehireFlag: self.leaveParam.rehireFlag,
        resignType: self.leaveParam.resignType
      };
      self.$http.post('/tch/to-resigned', params).then(function (res) {
        self.loadingAdd = false;
        if (res && res.status === 'ok') {
          self.$Message.success('离职成功!');
          self.visible = false;
          self.title = '';
          if (self.successCallback) {
            self.successCallback();
          }
        }
      }).catch(function (e) {
        self.loadingAdd = false;
      });
    },
    startTimeChange: function startTimeChange(value) {
      this.leaveParam.lastWorkDay = value;
    },
    onBookLessonOpened: function onBookLessonOpened() {
      var self = this;
      var isNotError = true;
      this.$refs.leaveForm.validateField('startTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      this.$refs.leaveForm.validateField('endTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      var params = {};
      params.tchId = self.tchId;
      params.startTime = self.leaveParam.startTime;
      params.endTime = self.leaveParam.endTime;
      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.loadingSearch = false;
        if (res.data.length <= 0) {
          self.$Message.info('没有涉及任何课节!');
          self.bookLessonOpenedList = [];
          return;
        }
        self.bookLessonOpenedList = res.data;
        self.loadMonthRankScores();
        self.bookLessonOpenedList.map(function (item) {
          if (item.oldTch > 0) {
            item.isProxy = 1;
          } else {
            item.isProxy = 0;
          }
        });
      });
    },
    proxyClass: function proxyClass(row) {
      row.show = true;
      this.$emit('getProxyClassData', row);
    },
    cancelProxyClass: function cancelProxyClass(row) {
      this.$emit('getCancelProxyClassData', row);
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.startTime = '';
      this.endTime = '';
      this.leaveParam.startTime = '';
      this.leaveParam.endTime = '';
      this.leaveParam.remark = '';
      this.leaveParam.remarkType = '';
      this.leaveParam.leaveType = 1;
      this.leaveParam.resignType = null;
      this.bookLessonOpenedList = [];
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_timeSlotValidator__ = __webpack_require__(97);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchAddOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      existingOpenedSlots: [],
      existingShortTermSlots: [],
      existingRandomSlots: [],
      timeRule: {
        week: [{ type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间', trigger: 'change' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加买断时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    addOpenedTime: function addOpenedTime() {
      var _this = this;

      var self = this;
      self.$refs.timeForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var openedTime = {};
        openedTime.week = _this.timeParam.week;
        openedTime.weekStr = _this.$constant.weekZh[_this.timeParam.week];
        openedTime.startTime = _this.timeParam.startTime;
        openedTime.startTimeStr = _this.timeParam.startTimeStr;
        openedTime.endTime = _this.timeParam.endTime;
        openedTime.endTimeStr = _this.timeParam.endTimeStr;
        openedTime.useDate = _this.timeParam.useDate;
        openedTime.useDateStr = _this.timeParam.useDateStr;
        _this.openedTimeList.push(openedTime);
        _this.timeParam.week = '';
        _this.$refs.timeListForm.validate();
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      this.openedTimeList.splice(index, 1);
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && this.$moment(val, 'YYYY-M-D').format('X');
      this.timeParam.useDateStr = val;
    },
    add: function add() {
      var self = this;
      this.$refs.timeListForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools_timeSlotValidator__["a" /* validateSlots */])(self.openedTimeList, self.existingOpenedSlots, self.existingShortTermSlots, self.existingRandomSlots);
        if (!result.valid) {
          self.$Message.warning(result.errors[0]);
          return;
        }
        self.loadingAdd = true;
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
        });
        self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=0', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          self.loadingAdd = false;
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            self.$Message.error({
              content: res.data.message,
              duration: 5
            });
          }
        }).catch(function (e) {
          self.loadingAdd = false;
          self.$Message.success('操作失败!');
        });
      });
    },
    loadExistingTimes: function loadExistingTimes() {
      var self = this;
      self.existingOpenedSlots = [];
      self.existingShortTermSlots = [];
      self.existingRandomSlots = [];

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingOpenedSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingShortTermSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD');
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingRandomSlots.push(e);
          });
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.loadExistingTimes();
      }
      this.visible = val;
    },
    visible: function visible(val) {
      this.openedTimeList = [];
      if (val === false) {
        this.$refs.timeForm.resetFields();
        this.$refs.timeListForm.resetFields();
        this.timeParam = {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_timeSlotValidator__ = __webpack_require__(97);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchInsertOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      timeParam: {
        day: '',
        startTime: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      existingOpenedSlots: [],
      existingShortTermSlots: [],
      existingRandomSlots: [],
      timeRule: {
        day: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间', trigger: 'blur' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var day = self.timeParam.day;
            var startTime = self.timeParam.startTime;
            var errors = [];
            var nowTime = new Date().getTime() / 1000;
            if (day !== '' && startTime !== '' && nowTime >= day + startTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            var openedTimeList = self.openedTimeList;
            var endTime = self.timeParam.endTime;
            if (day === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            openedTimeList.forEach(function (element) {
              var tmpDay = element.day;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (day === tmpDay && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + element.dayStr + ' ' + element.startTimeStr + '-' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加上课时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    addOpenedTime: function addOpenedTime() {
      var self = this;
      self.$refs.timeForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var openedTime = {};
        openedTime.day = self.timeParam.day;
        openedTime.dayStr = self.timeParam.dayStr;
        openedTime.startTime = self.timeParam.startTime;
        openedTime.startTimeStr = self.timeParam.startTimeStr;
        openedTime.endTime = self.timeParam.endTime;
        openedTime.endTimeStr = self.timeParam.endTimeStr;
        self.openedTimeList.push(openedTime);
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      this.openedTimeList.splice(index, 1);
    },
    onChangeDate: function onChangeDate(val) {
      this.timeParam.dayStr = val;
      this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = val && parseInt(this.$dateUtil.getSecondByHm(val));
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = val && parseInt(this.$dateUtil.getSecondByHm(val));
      this.timeParam.endTimeStr = val;
    },
    add: function add() {
      var self = this;
      this.$refs.timeListForm.validate(function (valid) {
        if (!valid) {
          return;
        }

        self.loadingAdd = true;
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
        });
        self.$http.post('/tch/time/addBookRandomOpenedTime', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          self.loadingAdd = false;
          var data = res.data;
          if (!data.isConflict) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            var content = '';
            if (data.conflictOpenedTime.length > 0) {
              content += '与买断时间冲突：</br>';
              data.conflictOpenedTime.forEach(function (element) {
                content += '<b>' + self.$constant.weekZh[element.week] + ' ' + self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' + self.$moment.unix(element.endTime).utc().format('HH:mm') + '</b></br>';
              });
            }
            if (data.conflictRandomOpenedTime.length > 0) {
              content += '与上课时间冲突：</br>';
              data.conflictRandomOpenedTime.forEach(function (element) {
                content += '<b>' + self.$moment.unix(element.startTime).format('YYYY-M-D HH:mm') + ' - ' + self.$moment.unix(element.endTime).format('YYYY-M-D HH:mm') + '</b></br>';
              });
            }
            self.$Message.error({
              content: content,
              duration: 3
            });
          }
        }).catch(function (e) {
          self.loadingAdd = false;
        });
      });
    },
    loadExistingTimes: function loadExistingTimes() {
      var self = this;
      self.existingOpenedSlots = [];
      self.existingShortTermSlots = [];
      self.existingRandomSlots = [];

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingOpenedSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingShortTermSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD');
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingRandomSlots.push(e);
          });
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.loadExistingTimes();
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.timeParam.dayStr = '';
        this.timeParam.startTimeStr = '';
        this.timeParam.endTimeStr = '';
        this.openedTimeList = [];
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_AdminUserMultSelect_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_12__common_AdminUserMultSelect_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_10__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_9__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_7__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_11__components_common_SubstituteTchSelect___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      loadingStudents: {},
      studentDataCache: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      queryParam: {
        studyConsultantId: '',
        isAudition: '',
        tempSchedule: '',
        sex: '',
        accent: '',
        channel: '1',
        uid: '',
        mobile: '',
        name: '',
        nickname: '',
        inviteTchName: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: '',
        tchTags: []
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: null,
        substituteTchId: ''
      },
      title: [{
        title: '老师ID',
        align: 'center',
        key: 'tchId'
      }, {
        title: '老师昵称',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var cell = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [cell, h('div', { slot: 'content' }, [_this.tchTagPermission ? h('p', '' + row.tchTags) : h('p', '')])]);
        }
      }, {
        title: '异动信息',
        align: 'center',
        render: function render(h, params) {
          return h('div', {
            domProps: {
              innerHTML: params.row.account
            }
          });
        }
      }, {
        title: '详情',
        type: 'expand',
        width: 80,
        render: function render(h, params) {
          var row = params.row;

          var cachedStudents = _this.studentDataCache[row.tchId];
          _this.loadStudentData(row.tchId, row.status === 3 ? '' : '/v2', row.tchCloseTimeId || '');
          if (cachedStudents !== undefined) {
            var students = cachedStudents || [];
            if (students.length === 0) {
              return h('div', '暂无数据');
            }

            var columns = [{
              title: '学生ID',
              width: 170,
              key: 'uid'
            }, {
              title: '中(英)文名',
              width: 170,
              align: 'center',
              render: function render(h, params) {
                var student = params.row;
                return h('div', [h('a', { on: { click: function click() {
                      return _this.openInfoModal(student.uid);
                    } } }, student.nickname), h('p', student.enName)]);
              }
            }, {
              title: '上课时间',
              width: 170,
              render: function render(h, params) {
                var list = params.row.bookWorkLessonOpenedTimeList;
                var spanArr = [];
                if (list) {
                  list.forEach(function (element) {
                    var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                    spanArr.push(h('span', '[' + $constant.weekZh[element.week] + startTime + ']'));
                    spanArr.push(h('br'));
                  });
                }
                return h('div', spanArr);
              }
            }, {
              title: '学习导师',
              width: 170,
              key: 'studyAdviserName'
            }];
            return h('Table', {
              props: {
                columns: columns,
                data: students,
                size: 'small'
              },
              style: {
                margin: '10px'
              }
            });
          } else {
            return h('div', '数据加载中...');
          }
        }
      }, {
        title: '绑定权限',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.isCanBound === 1 ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '临时约课权限',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.tempSchedule === 1 ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '试听课权限',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.isAudition === 'y' ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '买断时间',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var isOpened = params.row.isOpened;
          if (isOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.tchId;
                  _this.showTchCancelOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '上课时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var isRandomOpened = params.row.isRandomOpened;
          if (isRandomOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.tchId;
                  _this.showCancelRandomOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '外教运营',
        key: 'studyAdviserNickname',
        width: 120,
        align: 'center'

      }, {
        title: '授课类型',
        key: 'tchType',
        width: 100,
        align: 'center',

        render: function render(h, params) {
          var tchType = params.row.tchType;
          var tchTypeEnum = $constant.getEnum($constant.tchType, tchType);
          return h('span', tchTypeEnum && tchTypeEnum.text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var permission = self.$store.get('permissions');
    this.tchTagPermission = permission.indexOf('865') >= 0 || permission.indexOf('all') >= 0;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {},
  methods: {
    loadStudentData: function loadStudentData(tchId, version, tchCloseTimeId) {
      var self = this;

      if (self.loadingStudents[tchId]) {
        return;
      }
      self.loadingStudents[tchId] = true;

      this.$http.get('/tch' + version + ('/std-list?tchId=' + tchId + '&studyConsultantId=' + self.queryParam.studyConsultantId + '&tchCloseTimeId=' + tchCloseTimeId)).then(function (res) {
        if (res && res.data) {
          self.$set(self.studentDataCache, tchId, res.data.data);

          self.$nextTick(function () {
            self.$forceUpdate();
          });
        }
      }).finally(function () {
        self.loadingStudents[tchId] = false;
      });
    },
    linkTimeStartChange: function linkTimeStartChange(val) {
      this.queryParam.linkStartTimeDate = val;
    },
    linkTimeEndChange: function linkTimeEndChange(val) {
      this.queryParam.linkEndTimeDate = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    }
  },
  watch: {}
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreDetailModal__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreDetailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ModifyAttendanceScoreDetailModal: __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreDetailModal___default.a, ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      complaintRemarkList: $constant.tchComplaintRemark,
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showImgModal: false,
      complaintRow: null,
      showUpdateScoreModal: false,
      showImgList: [],
      studyAdviserList: [],
      startDateSelected: this.getCurrentMonth(),
      endDateSelected: this.getCurrentMonth(),
      queryParam: {
        tchKey: null,
        remark: null,
        startDate: null,
        endDate: null,
        studyAdviserId: null
      },
      title: [{
        title: '月份',
        width: 130,
        key: 'createMonth'
      }, {
        title: '老师ID',
        width: 150,
        key: 'tchId'
      }, {
        title: '老师姓名',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '打分类型',
        width: 150,
        align: 'center',
        key: 'typeDesc'
      }, {
        title: '分数',
        width: 150,
        align: 'center',
        key: 'score'
      }, {
        title: '上课时间',
        align: 'center',
        key: 'lessonTime'
      }, {
        title: '打分时间',
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '说明',
        width: 150,
        align: 'center',
        key: 'remark'
      }, {
        title: '操作',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onUpdateComplaint(params.row);
              }
            }
          }, '修改分数')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var _$route$query = this.$route.query,
        tchId = _$route$query.tchId,
        startDate = _$route$query.startDate,
        endDate = _$route$query.endDate;

    if (startDate) {
      this.queryParam.startDate = startDate || this.getCurrentMonth();
      this.startDateSelected = startDate || this.getCurrentMonth();
    }

    if (endDate) {
      this.queryParam.endDate = endDate || this.getCurrentMonth();
      this.endDateSelected = endDate || this.getCurrentMonth();
    }
    if (tchId) {
      this.queryParam.tchKey = tchId || null;
    }

    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.pics;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeComplaintModal: function closeComplaintModal(val) {
      this.showUpdateScoreModal = false;
      this.complaintRow = {};
    },
    onUpdateComplaint: function onUpdateComplaint(row) {
      this.showUpdateScoreModal = true;
      this.complaintRow = row;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/tch/lesson/attendance-detail-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '老师月度考勤明细.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startDate = value;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endDate = value;
    },
    getCurrentMonth: function getCurrentMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      return year + '-' + (month < 10 ? '0' + month : month);
    }
  }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreModal__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default.a, ModifyAttendanceScoreModal: __WEBPACK_IMPORTED_MODULE_1__modal_ModifyAttendanceScoreModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      complaintRemarkList: $constant.tchComplaintRemark,
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showImgModal: false,
      complaintRow: null,
      showUpdateScoreModal: false,
      showImgList: [],
      studyAdviserList: [],
      startDateSelected: this.getCurrentMonth(),
      endDateSelected: this.getCurrentMonth(),
      queryParam: {
        tchKey: null,
        remark: null,
        startDate: this.getCurrentMonth(),
        endDate: this.getCurrentMonth(),
        studyAdviserId: null
      },
      title: [{
        title: '月份',
        width: 130,
        key: 'createMonth'
      }, {
        title: '老师ID',
        width: 150,
        key: 'tchId'
      }, {
        title: '老师姓名',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '外管打分',
        width: 150,
        align: 'center',
        key: 'adminScore'
      }, {
        title: '出勤分数',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.goToAttendanceDetail(params.row);
              }
            }
          }, params.row.score)]);
        }
      }, {
        title: '总分',
        width: 150,
        align: 'center',
        key: 'totalScore'
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onUpdateComplaint(params.row);
              }
            }
          }, '打分')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.pics;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeComplaintModal: function closeComplaintModal(val) {
      this.showUpdateScoreModal = false;
      this.complaintRow = {};
    },
    onUpdateComplaint: function onUpdateComplaint(row) {
      this.showUpdateScoreModal = true;
      this.complaintRow = row;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/tch/lesson/attendance-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '老师月度考勤.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startDate = value;
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endDate = value;
    },
    getCurrentMonth: function getCurrentMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      return year + '-' + (month < 10 ? '0' + month : month);
    },
    goToAttendanceDetail: function goToAttendanceDetail(row) {
      this.$router.push({
        path: '/tch/tchAttendanceDetailList',
        query: {
          tchId: row.tchId,
          startDate: row.createMonth,
          endDate: row.createMonth
        }
      });
    }
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SendEmailModal: __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a, TchApplyFormModal: __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      showApplyModal: false,
      applyTchId: null,
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      queryParam: {
        auditName: '',
        regFrom: '',
        ethnicity: '',
        country: '',
        accent: '',
        sex: '',
        channel: '',
        inviteTchName: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        status: '',
        rejectFailKind: '',
        startCreateDate: '',
        endCreateDate: '',
        startAuditDate: '',
        endAuditDate: ''
      },
      channelOptions: [],

      showPassModal: false,
      loadingPass: false,
      passParam: {
        remark: ''
      },
      passRule: {
        remark: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur' }]
      },

      showRejectModal: false,
      loadingReject: false,
      rejectParam: {
        id: '',
        remark: ''
      },
      rejectRule: {
        remark: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur' }]
      },
      showInsertTchModal: false,
      tchId: null,
      showUpdateTchModal: false,

      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '修改类别',
        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.tchChangeStatusType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '原来状态',
        render: function render(h, params) {
          var row = params.row;
          var oldStatus = row.oldStatus;
          var type = row.type;
          if (type === 1) {
            var oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus);
            return h('span', oldStatusEnum && oldStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.oldNickname || '');
          }
          return h('span', oldStatus);
        }
      }, {
        title: '现在状态',
        render: function render(h, params) {
          var row = params.row;
          var newStatus = row.newStatus;
          var type = row.type;
          if (type === 1) {
            var newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus);
            return h('span', newStatusEnum && newStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.newNickname || '');
          }
          return h('span', newStatus);
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '理由',
        key: 'remark'
      }],
      selectionTch: [],
      showBatchReviewModal: false,
      reviewParam: {
        ids: '',
        remark: ''
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '老师ID',
        width: 80,
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
        }
      }, {
        title: 'Full Name',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openTchInfoModal(row.id);
              } } }, row.fullName);
        }
      }, {
        title: '老师账号',
        key: 'account',
        width: 130,
        align: 'center'
      }, {
        title: '推荐人',
        key: 'inviteTchName',
        width: 130,
        align: 'center'
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regFrom'
      }, {
        title: '注册时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '现居地',
        width: 150,
        align: 'center',
        key: 'country'
      }, {
        title: '种族',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.ethnicity,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.ethnicity = value;
                _this.updateTchDirect({ tchForm: { tchId: row.id, ethnicity: value } });
              }
            }
          }, [h('Option', { props: { value: 'African' } }, 'African'), h('Option', { props: { value: 'Coloured' } }, 'Coloured'), h('Option', { props: { value: 'White' } }, 'White'), h('Option', { props: { value: 'Indian/Asian' } }, 'Indian/Asian')]);
        }
      }, {
        title: '类型',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '状态',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var status = row.status;
          var failKind = row.rejectFailKind;
          var failReason = row.rejectFailReason;
          var text = void 0;
          if (status === 2 && failKind === 'interview') {
            text = '面试未通过';
          } else if (status === 2 && failKind === 'demo') {
            text = '试讲未通过';
          } else {
            var statusEnum = $constant.getEnum($constant.teacherStatus, status);
            text = statusEnum && statusEnum.text;
          }
          if (failReason) {
            return h('Tooltip', {
              props: { content: failReason, transfer: true, placement: 'top' }
            }, [h('div', [h('div', text), h('div', {
              style: {
                fontSize: '12px',
                color: '#999',
                marginTop: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '120px'
              }
            }, failReason)])]);
          }
          return h('span', text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '最近跟踪',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var trackTime = params.row.trackTime;
          var trackContent = params.row.trackContent;
          return h('div', [h('div', {
            attrs: {
              title: trackContent },
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, trackContent || ''), h('div', {
            style: {
              fontSize: '12px',
              color: '#999',
              marginTop: '4px'
            }
          }, trackTime || '')]);
        }
      }, {
        title: '操作日志',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var isTchChange = params.row.isTchChange;
          var id = params.row.id;
          if (isTchChange) {
            return h('a', { on: {
                click: function click() {
                  self.onTchChangeStatusList(id);
                }
              } }, '查看');
          } else {
            return h('span', '无记录');
          }
        }
      }, {
        title: '审核人',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var auditName = params.row.auditName;
          var auditTime = params.row.auditTime;
          return h('div', [h('div', auditName || ''), h('div', {
            style: {
              fontSize: '12px',
              color: '#999',
              marginTop: '4px'
            }
          }, auditTime || '')]);
        }
      }, {
        title: '操作',
        width: 220,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          var operationArr = [];
          if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
            operationArr.push(h('a', { on: { click: function click() {
                  _this.onShowApply(row);
                } } }, '注册资料'));
            operationArr.push(h('span', { class: 'divider' }));
          }
          operationArr.push(h('a', { on: { click: function click() {
                _this.onPass(row);
              } } }, '通过'));
          if (row.status === 0) {
            operationArr.push(h('span', { class: 'divider' }));
            operationArr.push(h('a', { on: { click: function click() {
                  _this.onReject(row);
                } } }, '拒绝'));
          }
          operationArr.push(h('span', { class: 'divider' }));
          operationArr.push(h('a', { on: { click: function click() {
                _this.onSendEmail(row);
              } } }, '发送邮件'));
          return h('div', operationArr);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.loadRegChannels();
  },
  computed: {
    filteredTeacherStatus: function filteredTeacherStatus() {
      var allowedCodes = [0, 2];
      return this.$constant.teacherStatus.filter(function (item) {
        return allowedCodes.includes(item.code);
      });
    },
    teacherCategoryList: function teacherCategoryList() {
      var allowedCodes = [4, 5];
      return this.$constant.teacherCategory.filter(function (item) {
        return allowedCodes.includes(item.code);
      });
    }
  },
  methods: {
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onRejectFailKindChange: function onRejectFailKindChange(val) {
      if (val) {
        this.queryParam.status = 2;
      }
      this.search();
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    },
    auditDateChange: function auditDateChange(value) {
      this.queryParam.startAuditDate = value && value[0] || '';
      this.queryParam.endAuditDate = value && value[1] || '';
      this.search();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    loadRegChannels: function loadRegChannels() {
      var self = this;
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onPass: function onPass(row) {
      this.showPassModal = true;
      this.passParam.id = row.id;
      this.passParam.firstName = row.firstName;
      this.passParam.lastName = row.lastName;
      this.passParam.remark = '';
    },
    pass: function pass() {
      var self = this;
      self.loadingPass = true;
      self.$refs.passForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingPass = false;
          return;
        }
        var params = {};
        params.id = self.passParam.id;
        params.remark = self.passParam.remark;
        self.$http.post('/tch/pass', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage();
            self.showPassModal = false;
          }
          self.loadingPass = false;
        }).catch(function (e) {
          self.showPassModal = false;
          self.loadingPass = false;
        });
      });
    },
    onReject: function onReject(row) {
      this.showRejectModal = true;
      this.rejectParam.id = row.id;
      this.rejectParam.firstName = row.firstName;
      this.rejectParam.lastName = row.lastName;
      this.passParam.remark = '';
    },
    reject: function reject() {
      var self = this;
      self.loadingReject = true;
      self.$refs.rejectForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingReject = false;
          return;
        }
        var params = {};
        params.id = self.rejectParam.id;
        params.remark = self.rejectParam.remark;
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage();
            self.showRejectModal = false;
          }
          self.loadingReject = false;
        }).catch(function (e) {
          self.showRejectModal = false;
          self.loadingReject = false;
        });
      });
    },
    onInsertTch: function onInsertTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
    },
    onShowApply: function onShowApply(row) {
      this.applyTchId = row.id;
      this.showApplyModal = true;
    },
    onSendEmail: function onSendEmail(row) {
      this.emailTchId = row.id;
      this.emailTchName = row.firstName + ' ' + row.lastName;
      this.showEmailModal = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data;
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    showBatchReview: function showBatchReview() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择待审核老师！');
        return;
      }
      this.showBatchReviewModal = true;
    },
    batchReview: function batchReview(val) {
      var self = this;
      self.$refs.reviewForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.selectionTch.map(function (element) {
          return element.id;
        });
        self.reviewParam.ids = idList.join(',');
        var path = '/tch/' + val;
        console.log(self.reviewParam);
        self.$http.post(path, self.reviewParam).then(function (res) {
          self.$Message.success('审核成功');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
        }).catch(function (e) {
          self.$Message.error('审核失败');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
        });
      });
    }
  }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchCancelOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingCancel: false,
      openedTimeIdList: [],
      openedTimeList: []
    };
  },

  methods: {
    loadTchOpenedTime: function loadTchOpenedTime() {
      var loadMsg = this.$Message.loading({
        content: '正在加载中...',
        duration: 0
      });
      var self = this;

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        loadMsg();
        self.visible = true;
        res.data.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week];
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm');
          self.openedTimeIdList.push(element.id);
          self.openedTimeList.push(element);
        });
      });
    },
    canceOpenedTime: function canceOpenedTime() {
      var self = this;
      var ids = [];
      var openedTimeIdList = this.openedTimeIdList;
      this.openedTimeList.forEach(function (element) {
        openedTimeIdList.includes(element.id) || ids.push(element.id);
      });
      if (ids.length <= 0) {
        self.visible = false;
        return;
      }
      self.loadingCancel = true;
      var params = {};
      params.tchId = self.tchId;
      params.openedTimeIds = ids.join(',');
      self.$http.post('/tch/time/cancelBookOpenedTime', params).then(function (res) {
        self.loadingCancel = false;
        var data = res.data;
        if (data || data.length <= 0) {
          self.successCallback();
          self.visible = false;
        } else {
          var content = '与学生上课时间冲突：</br>';
          data.forEach(function (element) {
            content += '<b>' + self.$constant.weekZh[element.week] + ' ' + self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' + self.$moment.unix(element.endTime).utc().format('HH:mm') + '</b></br>';
          });
          self.$Message.error({
            content: content,
            duration: 3
          });
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.openedTimeList = [];
        this.openedTimeIdList = [];
        this.loadTchOpenedTime();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchCancelRandomOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingCancel: false,
      openedTimeList: [],
      randomOpenedTimeIdList: [],
      randomOpenedTimeList: []
    };
  },

  methods: {
    selectAll: function selectAll() {
      this.randomOpenedTimeIdList = this.randomOpenedTimeList.map(function (item) {
        return item.id;
      });
    },
    invertSelect: function invertSelect() {
      var _this = this;

      var allIds = this.randomOpenedTimeList.map(function (item) {
        return item.id;
      });
      this.randomOpenedTimeIdList = allIds.filter(function (id) {
        return !_this.randomOpenedTimeIdList.includes(id);
      });
    },
    loadRandomOpenedTime: function loadRandomOpenedTime(row) {
      var loadMsg = this.$Message.loading({
        content: '正在加载中...',
        duration: 0
      });
      var self = this;
      self.openedTimeList = [];
      self.randomOpenedTimeList = [];
      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.openedTimeList = res.data;
      });
      self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        loadMsg();
        self.visible = true;
        self.randomOpenedTimeList = res.data;
      });
    },
    canceOpenedTime: function canceOpenedTime() {
      var self = this;
      var ids = [];
      var randomOpenedTimeIdList = this.randomOpenedTimeIdList;
      this.randomOpenedTimeList.forEach(function (element) {
        randomOpenedTimeIdList.includes(element.id) || ids.push(element.id);
      });
      if (ids.length <= 0) {
        self.visible = false;
        return;
      }
      self.loadingCancel = true;
      var params = {};
      params.tchId = self.tchId;
      params.randomOpenedTimeIds = ids.join(',');
      self.$http.post('/tch/time/cancelBookRandomOpenedTime', params).then(function (res) {
        self.loadingCancel = false;
        var data = res.data;
        if (data || data.length <= 0) {
          self.successCallback();
          self.visible = false;
        } else {
          var content = '与学生上课时间冲突：</br>';
          data.forEach(function (element) {
            content += '<b>' + self.$constant.weekZh[element.week] + ' ' + self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' + self.$moment.unix(element.endTime).utc().format('HH:mm') + '</b></br>';
          });
          self.$Message.error({
            content: content,
            duration: 3
          });
        }
      });
    }
  },
  watch: {
    value: function value(val) {
      this.openedTimeList = [];
      this.randomOpenedTimeIdList = [];
      this.randomOpenedTimeList = [];
      if (val === true) {
        this.loadRandomOpenedTime();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    },
    openedTimeList: function openedTimeList(val) {
      var self = this;
      val.forEach(function (element) {
        element.weekStr = self.$constant.weekZh[element.week];
        element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
        element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm');
      });
    },
    randomOpenedTimeList: function randomOpenedTimeList(val) {
      var self = this;
      self.randomOpenedTimeIdList = [];
      val.forEach(function (element) {
        self.randomOpenedTimeIdList.push(element.id);
        element.startTimeStr = self.$moment(element.startTime, 'X').format('YYYY-MM-DD HH:mm');
        element.endTimeStr = self.$moment(element.endTime, 'X').format('YYYY-MM-DD HH:mm');
      });
    }
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyComplaintModal__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ModifyComplaintModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_ModifyComplaintModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel___default.a, ModifyComplaintModal: __WEBPACK_IMPORTED_MODULE_1__modal_ModifyComplaintModal___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      subSalaryEnum: [{ code: 0, text: '正常计算' }, { code: 1, text: '不计算' }],
      complaintRemarkList: $constant.tchComplaintRemark,
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showImgModal: false,
      complaintRow: null,
      showComplaintModal: false,
      showImgList: [],
      studyAdviserList: [],
      queryParam: {
        tchKey: null,
        remark: '',
        subSalary: '',
        stdReturnNum: '',
        uidKey: null,
        adminKey: null,
        studyAdviserId: null
      },
      title: [{
        title: '课程信息',
        width: 130,
        render: function render(h, params) {
          var row = params.row;
          var lsnType = row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.courseType;
          var courseTypeEnum = $constant.getEnum($constant.courseType, courseType);
          var cType = courseTypeEnum && courseTypeEnum.text;
          if (cType) {
            cType = '课程类别:' + cType;
          } else {
            cType = '';
          }
          return h('div', [h('p', row.bookLessonOpenedId), h('p', row.lessonTitle), h('p', { style: { 'font-size': '12px', color: 'red' } }, cType), h('p', { style: { 'font-size': '12px', color: '#2d8cf0' } }, '课程类型:' + (typeEnum && typeEnum.text))]);
        }
      }, {
        title: '老师ID/姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.tchId != null ? row.tchId + '-' : '') + (row.tchName || ''),
            score: row.monthRankScore
          });
        }
      }, {
        title: '学生ID、姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.nickname);
        }
      }, {
        title: '外管',
        width: 150,
        align: 'center',
        key: 'tchStudyAdviserName'
      }, {
        title: '上课时间',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var children = [h('p', row.lessonTime)];
          if (row.liveUrl) {
            children.push(h('a', { on: { click: function click() {
                  return window.open(row.liveUrl);
                } } }, '课程回放'));
          }
          return h('div', children);
        }
      }, {
        title: '投诉人',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('p', row.adminName), h('p', row.createTime)]);
        }
      }, {
        title: '投诉理由',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.pics.length > 0) {
            return h('div', [h('span', row.remark), h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看附件')]);
          }
          return h('div', [h('span', row.remark)]);
        }
      }, {
        title: '备注',
        width: 200,
        align: 'center',
        key: 'remarkOthers'
      }, {
        title: '处理结果',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return '待处理';
          }
          var hs = [];
          if (row.stdNum > 0) {
            hs.push(h('p', '学生反课时:' + row.stdNum + '节'));
          }
          if (row.tchNum > 0) {
            hs.push(h('p', '老师额外扣除:' + row.tchNum + '￥'));
          }
          if (row.subSalary === 1) {
            hs.push(h('p', '老师扣除本节课耗'));
          }
          return h('div', hs);
        }
      }, {
        title: '老师课耗',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.subSalary === 1) {
            return h('span', '不计算');
          }
          return h('span', '正常计算');
        }
      }, {
        title: '处理人',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return '';
          }
          return h('div', [h('p', row.adminDoName), h('p', row.updateTime)]);
        }
      }, {
        title: '处理意见',
        align: 'center',
        width: 150,
        key: 'doRemark'
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          if (params.row.status === 0) {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.onUpdateComplaint(params.row);
                }
              }
            }, '去处理')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.pics;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeComplaintModal: function closeComplaintModal(val) {
      this.showComplaintModal = false;
      this.complaintRow = {};
    },
    onUpdateComplaint: function onUpdateComplaint(row) {
      this.showComplaintModal = true;
      this.complaintRow = row;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/tchList/complaint/exportExcel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '老师投诉记录.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startDate = value[0];
      this.queryParam.endDate = value[1];
    }
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_date_dates__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_date_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tools_date_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_timeSlotValidator__ = __webpack_require__(97);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchAddOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      existingShortTermSlots: [],
      existingRandomSlots: [],
      timeRule: {
        week: [{ type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间', trigger: 'change' }],
        useDate: [{ type: 'integer', required: true, message: '请选择有效日期', trigger: 'change' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加买断时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    addOpenedTime: function addOpenedTime() {
      var _this = this;

      var self = this;
      self.$refs.timeForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var openedTime = {};
        openedTime.week = _this.timeParam.week;
        openedTime.weekStr = _this.$constant.weekZh[_this.timeParam.week];
        openedTime.startTime = _this.timeParam.startTime;
        openedTime.startTimeStr = _this.timeParam.startTimeStr;
        openedTime.endTime = _this.timeParam.endTime;
        openedTime.endTimeStr = _this.timeParam.endTimeStr;
        openedTime.useDate = _this.timeParam.useDate;
        openedTime.useDateStr = _this.timeParam.useDateStr;
        openedTime.endDate = 0;
        _this.openedTimeList.push(openedTime);
        _this.timeParam.week = '';
        _this.$refs.timeListForm.validate();
      });
    },
    deleteAll: function deleteAll() {
      var self = this;
      if (self.openedTimeList.length === 0) {
        this.$Message.warning('没有可删除的时间');
        return;
      }
      self.$Modal.confirm({
        title: '提示',
        content: '此操作将删除全部买断时间，不可撤销。时间段内有绑定学生时，绑定时段将自动拆分另存。如果需要删除已绑学生时段，请先解绑该学生！',
        width: 380,
        okText: '确定全部删除',
        onOk: function onOk() {
          var listSnapshot = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(self.openedTimeList));
          self.openedTimeList = [];
          self.delect(listSnapshot);
          self.$Modal.remove();
        }
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      var self = this;
      var item = self.openedTimeList[index];
      if (!item.id) {
        self.openedTimeList.splice(index, 1);
        return;
      }
      self.$Modal.confirm({
        title: '提示',
        content: '此操作将直接删除老师绑定时间，不可撤销。时间段内有绑定学生时，绑定时段将自动拆分另存。如果需要删除已绑学生时段，请先解绑该学生！',
        width: 300,
        okText: '确定删除',
        loading: true,
        onOk: function onOk() {
          self.openedTimeList.splice(index, 1);
          self.delect();
          self.$Modal.remove();
        }
      });
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.useDateStr = val;
    },
    add: function add() {
      var self = this;
      self.$refs.timeListForm.validate(function (valid) {
        if (!valid) return;

        if (self.openedTimeList.length === 0) {
          self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback();
              self.visible = false;
              self.$Message.success('删除成功!');
            } else {
              self.$Message.error({
                content: res.msg || '删除失败',
                duration: 5
              });
            }
          });
        } else {
          self.openedTimeList.forEach(function (element) {
            element.tchId = self.tchId;
            element.endDate = 0;
          });
          self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=0', {}, {
            transformRequest: [function (data, headers) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
            }],
            headers: { 'Content-Type': 'application/json;charset=utf-8' }
          }).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback();
              self.visible = false;
              self.$Message.success('提交成功!');
            } else {
              self.$Message.error({
                content: res.msg || '提交失败',
                duration: 5
              });
            }
          }).catch(function (e) {});
        }
      });
    },
    delect: function delect(rollbackList) {
      var self = this;

      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('删除成功!');
          } else {
            if (rollbackList) {
              self.openedTimeList = rollbackList;
            }
            self.successCallback();
            self.$Message.error({
              content: res.msg || '操作失败',
              duration: 5
            });
          }
        }).catch(function () {
          if (rollbackList) {
            self.openedTimeList = rollbackList;
            self.successCallback();
          }
        });
      } else {
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
          element.endDate = 0;
        });
        self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=0', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          if (res && res.data > 0) {
            self.loadTchOpenedTime();
            self.successCallback();

            self.$Message.success('删除成功');
          } else {
            if (rollbackList) {
              self.openedTimeList = rollbackList;
            }
            self.loadTchOpenedTime();
            self.$Message.error({
              content: res.msg || '操作失败',
              duration: 5
            });
          }
        }).catch(function (e) {
          if (rollbackList) {
            self.openedTimeList = rollbackList;
          }
        });
      }
    },
    loadExistingTimes: function loadExistingTimes() {
      var self = this;
      self.existingShortTermSlots = [];
      self.existingRandomSlots = [];

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingShortTermSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD');
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingRandomSlots.push(e);
          });
        }
      });
    },
    loadTchOpenedTime: function loadTchOpenedTime() {
      var self = this;
      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.visible = true;
        self.openedTimeList = [];
        res.data.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week];
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm');
          element.useDateStr = __WEBPACK_IMPORTED_MODULE_2__tools_date_dates___default.a.formatUnix(element.useDate, 'YYYY-MM-DD');
          self.openedTimeList.push(element);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.openedTimeList = [];
        this.loadTchOpenedTime();
        this.loadExistingTimes();
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.openedTimeList = [];
        this.$refs.timeForm.resetFields();
        this.$refs.timeListForm.resetFields();
        this.timeParam = {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_timeSlotValidator__ = __webpack_require__(97);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchEditShortTermOpenedTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: '',
        endDate: '',
        endDateStr: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      existingOpenedSlots: [],
      existingRandomSlots: [],
      timeRule: {
        week: [{ type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间', trigger: 'change' }],
        useDate: [{ type: 'integer', required: true, message: '请选择有效日期', trigger: 'change' }],
        endDate: [{ type: 'integer', required: true, message: '请选择截至有效期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var useDate = self.timeParam.useDate;
            var errors = [];
            if (useDate !== '' && value !== '' && value <= useDate) {
              errors.push('截至有效期应在生效日期之后');
            }
            callback(errors);
          }
        }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加短期固定时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    addOpenedTime: function addOpenedTime() {
      var _this = this;

      var self = this;
      self.$refs.timeForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.$Modal.confirm({
          title: '提示',
          content: '至少持续三周，如果没有三周但是想开这个时间，可以操作临时时间',
          okText: '确认添加',
          cancelText: '取消',
          onOk: function onOk() {
            var openedTime = {};
            openedTime.week = _this.timeParam.week;
            openedTime.weekStr = _this.$constant.weekZh[_this.timeParam.week];
            openedTime.startTime = _this.timeParam.startTime;
            openedTime.startTimeStr = _this.timeParam.startTimeStr;
            openedTime.endTime = _this.timeParam.endTime;
            openedTime.endTimeStr = _this.timeParam.endTimeStr;
            openedTime.useDate = _this.timeParam.useDate;
            openedTime.useDateStr = _this.timeParam.useDateStr;
            openedTime.endDate = _this.timeParam.endDate;
            openedTime.endDateStr = _this.timeParam.endDateStr;
            _this.openedTimeList.push(openedTime);
            _this.timeParam.week = '';
            _this.$refs.timeListForm.validate();
          }
        });
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      var self = this;
      var item = self.openedTimeList[index];
      if (!item.id) {
        self.openedTimeList.splice(index, 1);
        return;
      }
      self.$Modal.confirm({
        title: '提示',
        content: '此操作将直接删除老师绑定时间，不可撤销。时间段内有绑定学生时，绑定时段将自动拆分另存。如果需要删除已绑学生时段，请先解绑该学生！',
        width: 300,
        okText: '确定删除',
        loading: true,
        onOk: function onOk() {
          self.$http.get('/tch/time/deleteBookOpenedTimeById?id=' + item.id).then(function (res) {
            if (res && res.data > 0) {
              self.openedTimeList.splice(index, 1);
              self.successCallback();
              self.$Message.success('删除成功!');
            } else {
              self.$Message.error({
                content: res.msg || '操作失败',
                duration: 5
              });
            }
            self.$Modal.remove();
          }).catch(function () {
            self.$Modal.remove();
          });
        }
      });
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.useDateStr = val;
    },
    onChangeEndDate: function onChangeEndDate(val) {
      this.timeParam.endDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.endDateStr = val;
    },
    add: function add() {
      var self = this;
      self.openedTimeList.forEach(function (element) {
        element.tchId = self.tchId;
      });
      var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools_timeSlotValidator__["a" /* validateSlots */])(self.openedTimeList, self.existingOpenedSlots, [], self.existingRandomSlots);
      if (!result.valid) {
        self.$Message.warning(result.errors[0]);
        return;
      }
      self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=1', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback();
          self.visible = false;
          self.$Message.success('提交成功!');
        } else {
          self.$Message.error({
            content: res.msg || '操作失败',
            duration: 5
          });
        }
      }).catch(function (e) {});
    },
    loadExistingTimes: function loadExistingTimes() {
      var self = this;
      self.existingOpenedSlots = [];
      self.existingRandomSlots = [];

      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.weekStr = self.$constant.weekZh[e.week];
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingOpenedSlots.push(e);
          });
        }
      });

      self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
        if (res && res.data) {
          res.data.forEach(function (e) {
            e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD');
            e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm');
            e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm');
            self.existingRandomSlots.push(e);
          });
        }
      });
    },
    loadTchOpenedTime: function loadTchOpenedTime() {
      var self = this;
      self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.visible = true;
        self.openedTimeList = [];
        res.data.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week];
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm');
          element.useDateStr = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default.a.formatUnix(element.useDate, 'YYYY-MM-DD');
          element.endDateStr = element.endDate ? __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default.a.formatUnix(element.endDate, 'YYYY-MM-DD') : '';
          self.openedTimeList.push(element);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.openedTimeList = [];
        this.loadTchOpenedTime();
        this.loadExistingTimes();
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.openedTimeList = [];
        this.$refs.timeForm.resetFields();
        this.$refs.timeListForm.resetFields();
        this.timeParam = {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: '',
          endDate: '',
          endDateStr: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      tchId: null,
      queryParam: {
        tchId: '',
        tchName: '',
        uid: '',
        nickname: ''
      },
      title: [{
        title: '课次ID',
        align: 'center',
        width: 100,
        key: 'lsnOpenId'
      }, {
        title: '老师',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchName,
            score: row.monthRankScore,
            onClick: row.tchId ? function () {
              return _this.openTchInfoModal(row.tchId);
            } : null
          });
        }
      }, {
        title: '学生',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickname);
        }
      }, {
        title: '开课时间',
        align: 'center',
        width: 150,
        key: 'lsnBeginTimeStr'
      }, {
        title: '课程类型',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', lsnTypeEnum && lsnTypeEnum.text);
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var courseTypeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', courseTypeEnum && courseTypeEnum.text);
        }
      }, {
        title: '课节ID',
        align: 'center',
        width: 80,
        key: 'lessonId'
      }, {
        title: '课节标题',
        align: 'center',
        width: 200,
        key: 'title'
      }, {
        title: '反馈时间',
        align: 'center',
        width: 170,
        key: 'createTimeStr'
      }, {
        title: '学习内容的评论',
        align: 'center',
        width: 170,
        key: 'learnedComment'
      }, {
        title: '表现好的评论',
        align: 'center',
        width: 170,
        key: 'goodComment'
      }, {
        title: '可以改进的评论',
        align: 'center',
        width: 170,
        key: 'betterComment'
      }, {
        title: '状态',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.tchFeedbackStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          var status = params.row.status;
          if (status === 2) {
            return h('a', { on: { click: function click() {
                  _this.onHideOrShow(params.row.lsnOpenId, 1, '显示');
                } } }, '显示');
          } else if (status === 1) {
            return h('a', { on: { click: function click() {
                  _this.onHideOrShow(params.row.lsnOpenId, 2, '隐藏');
                } } }, '隐藏');
          }
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    onHideOrShow: function onHideOrShow(lsnOpenId, status, text) {
      var _this2 = this;

      this.$Modal.confirm({
        title: '提示',
        content: '确定' + text + '？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          _this2.$http.post('/bookTchFeedback/update', { lsnOpenId: lsnOpenId, status: status }).then(function (res) {
            this.search();
            this.$Message.success(text + '成功!');
            this.$Modal.remove();
          });
        }
      });
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tools_aiAccess__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tools_aiApi__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_tchScore__ = __webpack_require__(2);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ExportLeaveModal: __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect___default.a,
    AiDrawer: __WEBPACK_IMPORTED_MODULE_15__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      aiAllowed: false,
      aiVisible: false,
      aiUid: null,
      aiSnapshotId: null,
      riskMap: {},
      riskLoadSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '修改类别',
        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.tchChangeStatusType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '原来状态',
        render: function render(h, params) {
          var row = params.row;
          var oldStatus = row.oldStatus;
          var type = row.type;
          if (type === 1) {
            var oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus);
            return h('span', oldStatusEnum && oldStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.oldNickname || '');
          }
          return h('span', oldStatus);
        }
      }, {
        title: '现在状态',
        render: function render(h, params) {
          var row = params.row;
          var newStatus = row.newStatus;
          var type = row.type;
          if (type === 1) {
            var newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus);
            return h('span', newStatusEnum && newStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.newNickname || '');
          }
          return h('span', newStatus);
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '理由',
        key: 'remark'
      }],
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        sex: '',
        accent: '',
        channel: '2',
        inviteTchName: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: ''
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: null,
        substituteTchId: ''
      },
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: '老师ID',
        width: 80,
        fixed: 'left',
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 140,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
        }
      }, {
        title: '老师账号',
        key: 'account',
        width: 130,
        align: 'center'
      }, {
        title: '绑定权限',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.isCanBound === 1 ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '无试听权限原因',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.invalidListenCause || '',
              rows: 2 },
            props: {
              value: row.invalidListenCause,
              placeholder: '',
              type: 'textarea'
            },
            style: {
              resize: 'vertical' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.invalidListenCause) {
                  row.invalidListenCause = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, invalidListenCause: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.invalidListenCause) {
                  row.invalidListenCause = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, invalidListenCause: value } });
                }
              }
            }
          });
        }
      }, {
        title: '推荐人',
        key: 'inviteTchName',
        width: 130,
        align: 'center'
      }, {
        title: '合同开始时间',
        key: 'crtBeginTimeStr',
        width: 120,
        align: 'center'
      }, {
        title: '合同结束时间',

        width: 120,
        align: 'center',
        render: function render(h, params) {

          var row = params.row;
          var day = row.crtEndTimeDay;
          var crtEndTimeStr = row.crtEndTimeStr;
          if (crtEndTimeStr) {
            if (day <= 30) {
              return h('div', [h('p', {}, row.crtEndTimeStr), h('span', { style: { color: 'red' } }, '距结束' + day + '天')]);
            } else {
              return h('div', [h('p', {}, row.crtEndTimeStr)]);
            }
          }
        }
      }, {
        title: '买断时间',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var isOpened = params.row.isOpened;
          if (isOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showTchCancelOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '上课时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var isRandomOpened = params.row.isRandomOpened;
          if (isRandomOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showCancelRandomOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '外教运营',
        key: 'studyAdviserNickname',
        width: 120,
        align: 'center'

      }, {
        title: '操作日志',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var isTchChange = params.row.isTchChange;
          var id = params.row.id;
          if (isTchChange) {
            return h('a', {
              on: {
                click: function click() {
                  self.onTchChangeStatusList(id);
                }
              }
            }, '查看');
          } else {
            return h('span', '无记录');
          }
        }
      }, {
        title: '授课类型',
        key: 'tchType',
        width: 100,
        align: 'center',

        render: function render(h, params) {
          var tchType = params.row.tchType;
          var tchTypeEnum = $constant.getEnum($constant.tchType, tchType);
          return h('span', tchTypeEnum && tchTypeEnum.text);
        }
      }, {
        title: '应急外教',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.emergency,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.emergency = value;
                _this.updateTchDirect({ tchList: { id: row.id, emergency: value } });
              }
            }
          }, [h('Option', { props: { value: 1 } }, '是'), h('Option', { props: { value: 0 } }, '否')]);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '风险',
        key: 'tchRisk',
        width: 70,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var snap = _this.riskMap[row.id] || _this.riskMap[String(row.id)];
          var level = row.riskLevel;
          if (level == null && snap) {
            level = snap.level;
          }
          var text = _this.riskLevelText(level);
          if (!text) {
            return h('span', '—');
          }
          return h('span', {
            style: {
              color: _this.riskLevelColor(level),
              fontWeight: '600'
            }
          }, text);
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          var tchType = row.tchType;
          var btn = null;
          if (row.category !== 3) {
            if (tchType === 2) {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'addOpenedTime') {
                      _this.tchId = row.id;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showEditDingModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '老师请假(正常)'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '老师离职(请假)'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h()])]);
            } else {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'addOpenedTime') {
                      _this.tchId = row.id;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showTeacherDingTalkModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '老师请假(正常)'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '老师请假(离职)'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h()])]);
            }
          } else {
            btn = h('a', { on: {} }, '禁用');
          }
          return h('div', [_this.aiAllowed ? h('a', {
            style: { marginRight: '8px' },
            on: { click: function click() {
                return _this.openRiskExplain(row);
              } }
          }, 'AI') : null, btn]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {
    var self = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__tools_aiAccess__["b" /* fetchAiAllowed */])(this.$http).then(function (allowed) {
      self.aiAllowed = !!allowed;
      if (self.aiAllowed) {
        self.$nextTick(function () {
          self.loadRiskFromList();
        });
      }
    });
  },
  methods: {
    riskLevelText: function riskLevelText(level) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__tools_aiApi__["g" /* tchRiskLevelText */])(level);
    },
    riskLevelColor: function riskLevelColor(level) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__tools_aiApi__["h" /* tchRiskLevelColor */])(level);
    },
    openRiskExplain: function openRiskExplain(row) {
      if (!row || !this.aiAllowed) {
        return;
      }
      var snap = this.riskMap[row.id] || this.riskMap[String(row.id)] || {};
      this.aiUid = row.id;
      this.aiSnapshotId = row.riskSnapshotId || snap.snapshotId || snap.id || null;
      this.aiVisible = true;
    },
    loadRiskFromList: function loadRiskFromList() {
      var list = this.$refs.dataList;
      var rows = list && list.tableData || [];
      var ids = [];
      rows.forEach(function (row) {
        if (row && row.id != null && ids.indexOf(row.id) === -1) {
          ids.push(row.id);
        }
      });
      this.loadRiskMap(ids);
    },
    loadRiskMap: function loadRiskMap(tchIds) {
      var self = this;
      if (!self.aiAllowed) {
        return;
      }
      var seq = ++self.riskLoadSeq;
      if (!tchIds || !tchIds.length) {
        self.riskMap = {};
        return;
      }
      self.$http.post(__WEBPACK_IMPORTED_MODULE_17__tools_aiApi__["i" /* TCH_RISK_URI */].latestBatch, { tchIds: tchIds.join(',') }).then(function (res) {
        if (seq !== self.riskLoadSeq) {
          return;
        }
        var list = [];
        if (res && res.status === 'ok') {
          list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__tools_aiApi__["j" /* normalizeTchRiskList */])(res.data);
        }
        var map = {};
        list.forEach(function (item) {
          if (!item) {
            return;
          }
          var id = item.tchId != null ? item.tchId : item.tch_id;
          if (id == null) {
            return;
          }
          var snap = {
            level: item.level,
            score: item.score,
            snapshotId: item.snapshotId != null ? item.snapshotId : item.id,
            reasonsJson: item.reasonsJson || item.reasons_json,
            calcDate: item.calcDate || item.calc_date
          };
          map[id] = snap;
          map[String(id)] = snap;
        });
        self.riskMap = map;
        var table = self.$refs.dataList && self.$refs.dataList.tableData;
        if (table && table.length) {
          table.forEach(function (row) {
            var rowSnap = map[row.id] || map[String(row.id)];
            if (rowSnap) {
              self.$set(row, 'riskLevel', rowSnap.level);
              self.$set(row, 'riskSnapshotId', rowSnap.snapshotId);
            } else {
              self.$set(row, 'riskLevel', null);
              self.$set(row, 'riskSnapshotId', null);
            }
          });
        }
      }).catch(function () {});
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
      this.aiSnapshotId = null;
    },
    onAiExecuted: function onAiExecuted() {},
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading && this.aiAllowed) {
        this.loadRiskFromList();
      }
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data;
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！');
        return;
      }
      this.showAssignTchStudyAdviserModal = true;
    },
    onDisableTch: function onDisableTch(row) {
      var self = this;
      var name = row.id + ' - ' + row.firstName + ' ' + row.lastName;
      self.$Modal.confirm({
        title: '提示',
        content: '确定禁用 <b>' + name + '</b> 老师？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tch/disable', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('禁用成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    addTch: function addTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
    },
    uploadLeaveTemplate: function uploadLeaveTemplate() {
      this.showExportLeaveModal = true;
    },
    downloadLeaveTemplate: function downloadLeaveTemplate() {
      var _this3 = this;

      this.$http.get('/bookTchLeaveTime/downloadLeaveTemplate', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '请假模板.xlsx';
          link.click();
        } else {
          _this3.$Message.error(response.msg);
        }
      }).catch(function (e) {
        console.log(e);
        _this3.$Message.error('下载失败');
      });
    },
    allTeachersLeave: function allTeachersLeave() {
      this.showAllTeacherLeaveModel = true;
    },
    closeEditDingModal: function closeEditDingModal() {
      this.showEditDingModal = false;
      this.tchId = null;
    },
    closeTeacherDingTalkModal: function closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false;
      this.tchId = null;
    },
    showProxyClass: function showProxyClass(row) {
      var self = this;
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm');
      self.selectTchParam = row;
      self.showSelectTch = row.show;
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data;
        } else {
          self.activityList = [];
        }
      });
    },
    cancelProxyClassData: function cancelProxyClassData(row) {
      var self = this;
      row.isProxy = 0;
      self.activityList.map(function (item, index) {
        if (item.id == row.id) {
          self.activityList[index].replace(item, row);
        }
      });
    },
    updateTch: function updateTch() {
      var self = this;
      self.selectTchParam.isProxy = 1;
      console.log('self.substituteTchId', self.substituteTchId);
      if (self.substituteTchId == null || self.substituteTchId == '') {
        self.$message.warning('请选择代课老师');
        return;
      }
      self.selectTchParam.substituteTchId = self.substituteTchId;
      if (self.substituteList.find(function (item) {
        return self.selectTchParam.id == item.id;
      }) == null) {
        self.substituteList.push(self.selectTchParam);
      }
      self.showSelectTch = false;
    }
  },
  computed: {
    visibleColumns: function visibleColumns() {
      if (this.aiAllowed) {
        return this.title;
      }
      return this.title.filter(function (col) {
        return col.key !== 'tchRisk';
      });
    }
  },
  watch: {}
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tchScore__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchFirstCheckList',
  data: function data() {
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      tableLoading: false,
      queryParam: {
        tchId: '',
        tchName: '',
        studyAdviserId: '',
        hasSign: '',
        lsnBeginTime: '',
        pageIndex: 1,
        pageSize: 10
      },
      studyAdviserList: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableData: [],
      columns: [{
        title: '老师ID',
        key: 'tchId',
        width: 100,
        align: 'center',
        fixed: 'left'
      }, {
        title: '老师姓名',
        key: 'tchName',
        width: 160,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '外管姓名',
        key: 'fmName',
        width: 120,
        align: 'center',
        fixed: 'left'
      }, {
        title: 'HR',
        key: 'hr',
        width: 100,
        align: 'center',
        fixed: 'left'
      }, {
        title: '国籍',
        key: 'nationality',
        width: 100,
        align: 'center',
        fixed: 'left'
      }, {
        title: '时差',
        key: 'timeDiff',
        width: 80,
        align: 'center',
        fixed: 'left'
      }]
    };
  },
  mounted: function mounted() {
    this.getStudyAdviserList();

    this.search();
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    getStudyAdviserList: function getStudyAdviserList() {
      var self = this;
      self.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.studyAdviserList = res.data;
      });
    },
    search: function search() {
      var _this = this;

      this.tableLoading = true;
      this.searchLoading = true;

      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.queryParam);
      params.pageIndex = this.pagination.pageIndex;
      params.pageSize = this.pagination.pageSize;

      this.$http.post('/tchSignLog/foreign-teacher-first-check', params).then(function (res) {
        if (res && res.data && res.data.data) {
          _this.tableData = res.data.data;
          _this.loadMonthRankScores();
          _this.pagination.totalCount = res.data.totalCount;
          _this.pagination.pageIndex = res.data.pageIndex;
          _this.pagination.pageSize = res.data.pageSize;

          _this.generateSignInfoColumns(res.data.data);
        } else {
          if (res.msg) {
            _this.$Message.error(res.msg);
          }
          _this.tableData = [];
          _this.pagination.totalCount = 0;
        }
      }).catch(function () {
        _this.tableData = [];
        _this.pagination.totalCount = 0;
      }).finally(function () {
        _this.tableLoading = false;
        _this.searchLoading = false;
      });
    },
    generateSignInfoColumns: function generateSignInfoColumns(data) {
      var _this2 = this;

      this.columns = this.columns.filter(function (col) {
        return !col.isDynamic;
      });

      var signDateMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      data.forEach(function (item) {
        if (item.signInfoList && Array.isArray(item.signInfoList)) {
          item.signInfoList.forEach(function (signInfo) {
            var key = signInfo.signDate;
            if (!signDateMap.has(key)) {
              signDateMap.set(key, signInfo.week || '');
            }
          });
        }
      });

      var sortedDateEntries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(signDateMap.entries()).sort(function (a, b) {
        return b[0].localeCompare(a[0]);
      });

      sortedDateEntries.forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            date = _ref2[0],
            week = _ref2[1];

        _this2.columns.push({
          title: date,
          key: 'sign_' + date,
          width: 120,
          align: 'center',
          isDynamic: true,
          renderHeader: function renderHeader(h) {
            return h('div', [h('div', date), h('div', { style: { fontSize: '12px', color: '#999', marginTop: '2px' } }, week)]);
          },
          render: function render(h, params) {
            var row = params.row;
            if (row.signInfoList && Array.isArray(row.signInfoList)) {
              var signInfo = row.signInfoList.find(function (info) {
                return info.signDate === date;
              });
              if (signInfo) {
                var firstLine = h('div', { style: { marginBottom: '4px' } }, '首课：' + (signInfo.firstLessonTime || ''));
                var secondLine = h('div', {}, '签到:-');
                if (signInfo.signTime) {
                  var style = {};

                  if (signInfo.lateSign === 0) {
                    style = { color: '#19be6b' };
                  } else if (signInfo.lateSign === 1) {
                    style = { color: '#ed4014' };
                  } else if (signInfo.lateSign === 2) {
                    style = { color: '#ff9900' };
                  }
                  secondLine = h('div', { style: style }, '签到:' + signInfo.signTime);
                }
                var container = h('div', { style: { display: 'flex', flexDirection: 'column' } }, [firstLine, secondLine]);
                return container;
              }
            }
            return h('span', '-');
          }
        });
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      this.exportLoading = true;

      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.queryParam);
      params.pageIndex = 1;
      params.pageSize = 999999;

      this.$http.post('/tchSignLog/foreign-teacher-first-check-export', params, { responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '外教首课签到.xlsx';
        link.click();
        _this3.$Message.success('导出成功');
      }).catch(function (error) {
        _this3.$Message.error('导出失败：' + error.message);
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    changePage: function changePage(pageIndex) {
      this.pagination.pageIndex = pageIndex;
      this.search();
    },
    changePageSize: function changePageSize(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageIndex = 1;
      this.search();
    },
    handleSortChange: function handleSortChange(column) {
      console.log('排序字段:', column.key, '排序方式:', column.order);
    },
    onStartDateChange: function onStartDateChange(value) {
      if (value) {
        this.queryParam.startDate = this.$moment(value).format('YYYY-MM-DD');
      } else {
        this.queryParam.startDate = '';
      }
    },
    onEndDateChange: function onEndDateChange(value) {
      if (value) {
        this.queryParam.endDate = this.$moment(value).format('YYYY-MM-DD');
      } else {
        this.queryParam.endDate = '';
      }
    },
    onLsnBeginTimeChange: function onLsnBeginTimeChange(value) {
      if (value) {
        this.queryParam.lsnBeginTime = value.substring(0, 5);
      } else {
        this.queryParam.lsnBeginTime = '';
      }
    }
  }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchForeignManageData',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      tableLoading: false,
      studyAdviserList: [],
      dateRange: [],
      queryParam: {
        startDate: '',
        endDate: '',
        studyAdviserId: '',
        channel: ''
      },
      columns: [{
        title: ' ',
        key: 'teacherType',
        align: 'center',
        width: 100,
        fixed: 'left',
        renderHeader: function renderHeader(h) {
          return h('span', '');
        }
      }, { title: '老师数', key: 'teacherCount', align: 'center', width: 100 }, { title: '买断课时数', key: 'buyOutLessonCount', align: 'center', width: 120 }, { title: '上课数', key: 'lessonCount', align: 'center', width: 100 }, { title: '上课率', key: 'attendanceRate', align: 'center', width: 100 }, { title: '第四周上课率', key: 'fourthWeekAttendanceRate', align: 'center', width: 130 }, { title: '请假数', key: 'leaveCount', align: 'center', width: 100 }, { title: '外教请假率', key: 'foreignTeacherLeaveRate', align: 'center', width: 120 }, { title: '临时正常上课数', key: 'temporaryNormalLessonCount', align: 'center', width: 140 }, { title: '临时请假数', key: 'temporaryLeaveCount', align: 'center', width: 120 }, { title: '临时请假率', key: 'temporaryLeaveRate', align: 'center', width: 120 }, { title: '返课时', key: 'returnLessonHours', align: 'center', width: 100 }, { title: 'CPE+回访', key: 'cpeAndFollowUp', align: 'center', width: 100 }, { title: '外教离职', key: 'foreignTeacherResigned', align: 'center', width: 100 }, { title: '外教淘汰数', key: 'foreignTeacherEliminated', align: 'center', width: 100 }, { title: '外教流失数', key: 'foreignTeacherLost', align: 'center', width: 100 }, { title: '培训中外教数', key: 'trainingForeignTeachers', align: 'center', width: 140 }],
      tableData: this.createDefaultTableRows()
    };
  },
  mounted: function mounted() {
    this.getStudyAdviserList();
    this.initDefaultDate();
    this.search();
  },

  methods: {
    getStudyAdviserList: function getStudyAdviserList() {
      var _this = this;

      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        _this.studyAdviserList = res && res.data ? res.data : [];
      });
    },
    initDefaultDate: function initDefaultDate() {
      var now = this.$moment();
      var day = now.day();
      var friday = now.clone();
      if (day === 0) {
        friday = now.clone().subtract(2, 'days');
      } else if (day >= 6) {
        friday = now.clone().subtract(1, 'days');
      } else {
        friday = now.clone().add(5 - day, 'days');
      }
      var saturday = friday.clone().subtract(6, 'days');
      this.dateRange = [saturday.format('YYYY-MM-DD'), friday.format('YYYY-MM-DD')];
      this.queryParam.startDate = this.dateRange[0];
      this.queryParam.endDate = this.dateRange[1];
    },
    onDateRangeChange: function onDateRangeChange(value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0];
        this.queryParam.endDate = value[1];
      } else {
        this.queryParam.startDate = '';
        this.queryParam.endDate = '';
      }
    },
    search: function search() {
      var _this2 = this;

      this.searchLoading = true;
      this.tableLoading = true;
      this.$http.post('/tch/statistics', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.queryParam)).then(function (res) {
        _this2.tableData = _this2.normalizeTableData(res && res.data ? res.data : []);
      }).catch(function () {
        _this2.tableData = _this2.normalizeTableData([]);
      }).finally(function () {
        _this2.searchLoading = false;
        _this2.tableLoading = false;
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      this.exportLoading = true;
      this.$http.post('/tch/statistics/export', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.queryParam), { responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '外管数据.xlsx';
        link.click();
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    createDefaultTableRows: function createDefaultTableRows() {
      return ['正式老师', '试用期老师', '汇总'].map(function (type) {
        return {
          teacherType: type,
          teacherCount: 0,
          buyOutLessonCount: 0,
          lessonCount: 0,
          attendanceRate: 0,
          fourthWeekAttendanceRate: 0,
          leaveCount: 0,
          foreignTeacherLeaveRate: 0,
          temporaryNormalLessonCount: 0,
          temporaryLeaveCount: 0,
          temporaryLeaveRate: 0,
          returnLessonHours: 0,
          cpeAndFollowUp: 0,
          foreignTeacherResigned: 0,
          foreignTeacherEliminated: 0,
          foreignTeacherLost: 0,
          trainingForeignTeachers: 0
        };
      });
    },
    normalizeTableData: function normalizeTableData(data) {
      var defaultRows = this.createDefaultTableRows();
      if (!data || data.length === 0) {
        return defaultRows;
      }
      var dataMap = {};
      data.forEach(function (item) {
        if (item && item.teacherType) {
          dataMap[item.teacherType] = item;
        }
      });
      return defaultRows.map(function (row) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row, dataMap[row.teacherType] || {});
      });
    }
  }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchEditShortTermOpenedTimeModal_vue__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchEditShortTermOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchEditShortTermOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_TchEditCloseTimeModal_vue__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_TchEditCloseTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_TchEditCloseTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ResignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal_SendEmailModal_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal_SendEmailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__modal_SendEmailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_InvalidListenCauseLogModal_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_InvalidListenCauseLogModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modal_InvalidListenCauseLogModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tools_aiAccess__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tools_aiApi__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_tchScore__ = __webpack_require__(2);




























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SendEmailModal: __WEBPACK_IMPORTED_MODULE_19__modal_SendEmailModal_vue___default.a,
    InvalidListenCauseLogModal: __WEBPACK_IMPORTED_MODULE_20__modal_InvalidListenCauseLogModal_vue___default.a,
    AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_17__common_AdminUserMultSelect_vue___default.a,
    ExportLeaveModal: __WEBPACK_IMPORTED_MODULE_16__ExportLeaveModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_14__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_13__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchEditShortTermOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchEditShortTermOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_5__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_6__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_7__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_8__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_9__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_10__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_12__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_11__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_15__components_common_SubstituteTchSelect___default.a,
    ResignModal: __WEBPACK_IMPORTED_MODULE_18__ResignModal_vue___default.a,
    TchEditCloseTimeModal: __WEBPACK_IMPORTED_MODULE_4__modal_TchEditCloseTimeModal_vue___default.a,
    AiDrawer: __WEBPACK_IMPORTED_MODULE_21__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      showEmailModal: false,
      emailTchId: null,
      showInvalidListenCauseLog: false,
      invalidListenCauseLogTchId: null,
      emailTchName: '',
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      exportLoading: false,
      aiAllowed: false,
      aiVisible: false,
      aiUid: null,
      aiSnapshotId: null,
      riskMap: {},
      riskLoadSeq: 0,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '原来的外教运营',
        render: function render(h, params) {
          return h('span', params.row.oldNickname || '');
        }
      }, {
        title: '新的外教运营',
        render: function render(h, params) {
          return h('span', params.row.newNickname || '');
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }],
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      rankScoreMap: {},
      rankScoreSeq: 0,
      queryParam: {
        isAudition: '',
        hasTesol: '',
        hasTefl: '',
        tempSchedule: '',
        acceptSubWithin2h: '',
        sex: '',
        accent: '',
        channel: '1',
        uid: '',
        mobile: '',
        name: '',
        nickname: '',
        inviteTchName: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: '',
        tchTags: [],
        suitableLevels: [],
        startOpenCourseDate: '',
        endOpenCourseDate: '',
        startCreateDate: '',
        endCreateDate: '',
        scoreMin: '',
        scoreMax: ''
      },
      suitableLevelOptions: [{ code: '1', text: 'Level1' }, { code: '5', text: 'Level2' }, { code: '2', text: 'Level3-Level5' }, { code: '3', text: 'Level6-Level9' }, { code: '4', text: 'Wonders及其他' }, { code: '6', text: 'PU' }],
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchEditShortTermOpenedTimeModal: false,
      showTchEditCloseTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      showTchResignModal: false,
      resignTitle: '',
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: null,
        substituteTchId: ''
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '老师ID',
        width: 80,
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var cell = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [cell, h('div', { slot: 'content' }, [_this.tchTagPermission ? h('p', '' + row.tchTags) : h('p', '')])]);
        }
      }, {
        title: '绑定权限',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.isCanBound === 1 ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '接受2h内订课',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var yes = row.acceptSubWithin2h !== false;
          var style = yes ? {} : { color: 'red' };
          return h('span', { style: style }, yes ? '是' : '否');
        }
      }, {
        title: '无试听权限原因',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var input = h('Input', {
            attrs: {
              title: row.invalidListenCause || '',
              rows: 2 },
            props: {
              value: row.invalidListenCause,
              placeholder: '',
              type: 'textarea'
            },
            style: {
              resize: 'vertical' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.invalidListenCause) {
                  row.invalidListenCause = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, invalidListenCause: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.invalidListenCause) {
                  row.invalidListenCause = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, invalidListenCause: value } });
                }
              }
            }
          });
          var historyLink = h('a', {
            style: { fontSize: '12px' },
            on: {
              click: function click() {
                _this.openInvalidListenCauseLog(row.id);
              }
            }
          }, '历史');
          return h('div', [input, historyLink]);
        }
      }, {
        title: '外教运营',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var name = row.studyAdviserNickname;
          if (!name) {
            return h('span', '');
          }
          return h('a', {
            on: {
              click: function click() {
                _this.onTchChangeStatusList(row.id);
              }
            }
          }, name);
        }
      }, {
        title: '老师账号',
        key: 'account',
        sensitive: true,
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var countryCode = row.countryCode;
          return h('div', {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }, [countryCode ? h('span', {
            attrs: {
              class: 'fi fi-' + countryCode
            },
            style: {
              marginRight: '8px',
              fontSize: '18px'
            }
          }) : null, h('span', {}, row.account)]);
        }
      }, {
        title: '推荐人说明',
        sensitive: true,
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.inviteRemark || '' },
            props: {
              value: row.inviteRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.inviteRemark) {
                  row.inviteRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, inviteRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.inviteRemark) {
                  row.inviteRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, inviteRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '开课时间',
        sensitive: true,
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('DatePicker', {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              value: row.openCourseTime,
              placeholder: '选择日期',
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                if (value !== row.openCourseTime) {
                  row.openCourseTime = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, openCourseTime: value } });
                }
              }
            }
          });
        }
      }, {
        title: '合同开始时间',
        sensitive: true,
        key: 'crtBeginTimeStr',
        width: 120,
        align: 'center'
      }, {
        title: '合同结束时间',
        sensitive: true,

        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var day = row.crtEndTimeDay;
          var crtEndTimeStr = row.crtEndTimeStr;
          if (crtEndTimeStr) {
            if (day <= 30) {
              return h('div', [h('p', {}, row.crtEndTimeStr), h('span', { style: { color: 'red' } }, '距结束' + day + '天')]);
            } else {
              return h('div', [h('p', {}, row.crtEndTimeStr)]);
            }
          }
        }
      }, {
        title: '买断时间',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var isOpened = params.row.isOpened;
          if (isOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showTchCancelOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '上课时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var isRandomOpened = params.row.isRandomOpened;
          if (isRandomOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showCancelRandomOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '授课类型',
        key: 'tchType',
        width: 100,
        align: 'center',

        render: function render(h, params) {
          var tchType = params.row.tchType;
          var tchTypeEnum = $constant.getEnum($constant.tchType, tchType);
          return h('span', tchTypeEnum && tchTypeEnum.text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '风险',
        key: 'tchRisk',
        width: 70,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var snap = _this.riskMap[row.id] || _this.riskMap[String(row.id)];
          var level = row.riskLevel;
          if (level == null && snap) {
            level = snap.level;
          }
          var text = _this.riskLevelText(level);
          if (!text) {
            return h('span', '—');
          }
          return h('span', {
            style: {
              color: _this.riskLevelColor(level),
              fontWeight: '600'
            }
          }, text);
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          var tchType = row.tchType;
          var btn = null;
          if (row.category !== 3) {
            if (tchType === 2) {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'editTchTags') {
                      _this.tchId = row.id;
                      _this.tchTags = row.tchTags;
                      _this.showEditTagsModal = true;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'editShortTermOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditShortTermOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showEditDingModal = true;
                    } else if (name === 'resign') {
                      _this.tchId = row.id;
                      _this.showTchResignModal = true;
                      _this.resignTitle = '\u786E\u5B9A\u8001\u5E08 ' + row.id + ' -' + row.firstName + ' ' + row.lastName + ' \u79BB\u804C \uFF1F';
                    } else if (name === 'sendEmail') {
                      _this.emailTchId = row.id;
                      _this.emailTchName = row.firstName + ' ' + row.lastName;
                      _this.showEmailModal = true;
                    } else if (name === 'editCloseTime') {
                      _this.tchId = row.id;
                      _this.showTchEditCloseTimeModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', {
                props: { name: 'editTchTags' },
                style: _this.tchTagPermission ? {} : { display: 'none' }
              }, '编辑标签'), h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'editShortTermOpenedTime' } }, '编辑短期固定时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '老师请假(正常)'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '老师离职(请假)'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h('Dropdown-item', { props: { name: 'resign' } }, '离职'), h('Dropdown-item', { props: { name: 'sendEmail' } }, '发送邮件'), h('Dropdown-item', { props: { name: 'editCloseTime' } }, '关闭时间'), h()])]);
            } else {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'editTchTags') {
                      _this.tchId = row.id;
                      _this.tchTags = row.tchTags;
                      _this.showEditTagsModal = true;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'editShortTermOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditShortTermOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showTeacherDingTalkModal = true;
                    } else if (name === 'resign') {
                      _this.tchId = row.id;
                      _this.showTchResignModal = true;
                      _this.resignTitle = '\u786E\u5B9A\u8001\u5E08 ' + row.id + ' -' + row.firstName + ' ' + row.lastName + ' \u79BB\u804C \uFF1F';
                    } else if (name === 'sendEmail') {
                      _this.emailTchId = row.id;
                      _this.emailTchName = row.firstName + ' ' + row.lastName;
                      _this.showEmailModal = true;
                    } else if (name === 'editCloseTime') {
                      _this.tchId = row.id;
                      _this.showTchEditCloseTimeModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', {
                props: { name: 'editTchTags' },
                style: _this.tchTagPermission ? {} : { display: 'none' }
              }, '编辑标签'), h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'editShortTermOpenedTime' } }, '编辑短期固定时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '需代课请假'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '无需代课请假'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h('Dropdown-item', { props: { name: 'resign' } }, '离职'), h('Dropdown-item', { props: { name: 'sendEmail' } }, '发送邮件'), h('Dropdown-item', { props: { name: 'editCloseTime' } }, '关闭时间')])]);
            }
          } else {
            btn = h('a', { on: {} }, '禁用');
          }
          return h('div', [_this.aiAllowed ? h('a', {
            style: { marginRight: '8px' },
            on: { click: function click() {
                return _this.openRiskExplain(row);
              } }
          }, 'AI') : null, btn]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var permission = self.$store.get('permissions');
    this.tchTagPermission = permission.indexOf('865') >= 0 || permission.indexOf('all') >= 0;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {
    var self = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__tools_aiAccess__["b" /* fetchAiAllowed */])(this.$http).then(function (allowed) {
      self.aiAllowed = !!allowed;
      if (self.aiAllowed) {
        self.$nextTick(function () {
          self.loadRiskFromList();
        });
      }
    });
  },
  methods: {
    riskLevelText: function riskLevelText(level) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__tools_aiApi__["g" /* tchRiskLevelText */])(level);
    },
    riskLevelColor: function riskLevelColor(level) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__tools_aiApi__["h" /* tchRiskLevelColor */])(level);
    },
    openRiskExplain: function openRiskExplain(row) {
      if (!row || !this.aiAllowed) {
        return;
      }
      var snap = this.riskMap[row.id] || this.riskMap[String(row.id)] || {};
      this.aiUid = row.id;
      this.aiSnapshotId = row.riskSnapshotId || snap.snapshotId || snap.id || null;
      this.aiVisible = true;
    },
    loadRiskFromList: function loadRiskFromList() {
      var list = this.$refs.dataList;
      var rows = list && list.tableData || [];
      var ids = [];
      rows.forEach(function (row) {
        if (row && row.id != null && ids.indexOf(row.id) === -1) {
          ids.push(row.id);
        }
      });
      this.loadRiskMap(ids);
    },
    loadRiskMap: function loadRiskMap(tchIds) {
      var self = this;
      if (!self.aiAllowed) {
        return;
      }
      var seq = ++self.riskLoadSeq;
      if (!tchIds || !tchIds.length) {
        self.riskMap = {};
        return;
      }
      self.$http.post(__WEBPACK_IMPORTED_MODULE_23__tools_aiApi__["i" /* TCH_RISK_URI */].latestBatch, { tchIds: tchIds.join(',') }).then(function (res) {
        if (seq !== self.riskLoadSeq) {
          return;
        }
        var list = [];
        if (res && res.status === 'ok') {
          list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__tools_aiApi__["j" /* normalizeTchRiskList */])(res.data);
        }
        var map = {};
        list.forEach(function (item) {
          if (!item) {
            return;
          }
          var id = item.tchId != null ? item.tchId : item.tch_id;
          if (id == null) {
            return;
          }
          var snap = {
            level: item.level,
            score: item.score,
            snapshotId: item.snapshotId != null ? item.snapshotId : item.id,
            reasonsJson: item.reasonsJson || item.reasons_json,
            calcDate: item.calcDate || item.calc_date
          };
          map[id] = snap;
          map[String(id)] = snap;
        });
        self.riskMap = map;
        var table = self.$refs.dataList && self.$refs.dataList.tableData;
        if (table && table.length) {
          table.forEach(function (row) {
            var rowSnap = map[row.id] || map[String(row.id)];
            if (rowSnap) {
              self.$set(row, 'riskLevel', rowSnap.level);
              self.$set(row, 'riskSnapshotId', rowSnap.snapshotId);
            } else {
              self.$set(row, 'riskLevel', null);
              self.$set(row, 'riskSnapshotId', null);
            }
          });
        }
      }).catch(function () {});
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
      this.aiSnapshotId = null;
    },
    onAiExecuted: function onAiExecuted() {},
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        self.rankScoreMap = map;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/tch/formal/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '正式老师.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg || '导出失败');
          _this2.exportLoading = false;
        }
      }).catch(function () {
        _this2.$Message.error('导出失败');
        _this2.exportLoading = false;
      });
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading && this.aiAllowed) {
        this.loadRiskFromList();
      }
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    openInvalidListenCauseLog: function openInvalidListenCauseLog(tchId) {
      this.invalidListenCauseLogTchId = tchId;
      this.showInvalidListenCauseLog = true;
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data.filter(function (item) {
          return item.type === 4;
        });
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！');
        return;
      }
      this.showAssignTchStudyAdviserModal = true;
    },
    onDisableTch: function onDisableTch(row) {
      var self = this;
      var name = row.id + ' - ' + row.firstName + ' ' + row.lastName;
      self.$Modal.confirm({
        title: '提示',
        content: '确定禁用 <b>' + name + '</b> 老师？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tch/disable', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('禁用成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this3 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success('更新成功');
        } else {
          _this3.$Message.error(res.msg);
        }
      }).catch(function () {
        _this3.$Message.error('更新失败');
      });
    },
    addTch: function addTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
    },
    uploadLeaveTemplate: function uploadLeaveTemplate() {
      this.showExportLeaveModal = true;
    },
    downloadLeaveTemplate: function downloadLeaveTemplate() {
      var _this4 = this;

      this.$http.get('/bookTchLeaveTime/downloadLeaveTemplate', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '请假模板.xlsx';
          link.click();
        } else {
          _this4.$Message.error(response.msg);
        }
      }).catch(function (e) {
        console.log(e);
        _this4.$Message.error('下载失败');
      });
    },
    allTeachersLeave: function allTeachersLeave() {
      this.showAllTeacherLeaveModel = true;
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startOpenCourseDate = value[0];
      this.queryParam.endOpenCourseDate = value[1];
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    },
    closeEditDingModal: function closeEditDingModal() {
      this.showEditDingModal = false;
      this.tchId = null;
    },
    closeTeacherDingTalkModal: function closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false;
      this.tchId = null;
    },
    closeTchResignModal: function closeTchResignModal() {
      this.showTchResignModal = false;
      this.tchId = null;
    },
    showProxyClass: function showProxyClass(row) {
      var self = this;
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm');
      self.selectTchParam = row;
      self.showSelectTch = row.show;
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data;
        } else {
          self.activityList = [];
        }
      });
    },
    cancelProxyClassData: function cancelProxyClassData(row) {
      var self = this;
      row.isProxy = 0;
      self.activityList.map(function (item, index) {
        if (item.id === row.id) {
          self.activityList[index].replace(item, row);
        }
      });
    },
    updateTch: function updateTch() {
      var self = this;
      self.selectTchParam.isProxy = 1;
      console.log('self.substituteTchId', self.substituteTchId);
      if (self.substituteTchId == null || self.substituteTchId === '') {
        self.$message.warning('请选择代课老师');
        return;
      }
      self.selectTchParam.substituteTchId = self.substituteTchId;
      if (self.substituteList.find(function (item) {
        return self.selectTchParam.id === item.id;
      }) == null) {
        self.substituteList.push(self.selectTchParam);
      }
      self.showSelectTch = false;
    },
    editTag: function editTag() {
      var self = this;
      self.loadingEdit = true;
      self.$http.post('/tch/lesson/edit-tag', {
        tchId: self.tchId,
        tchTag: self.tchTags
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.showEditTagsModal = false;
          self.$Message.success('提交成功!');
        }
        self.loadingEdit = false;
      });
    }
  },
  computed: {
    visibleColumns: function visibleColumns() {
      var adminRule = this.$store.get('adminRule');

      var showSensitive = adminRule === 0 || adminRule === 3 || adminRule === '0' || adminRule === '3';
      var cols = showSensitive ? this.title : this.title.filter(function (col) {
        return !col.sensitive;
      });
      if (!this.aiAllowed) {
        cols = cols.filter(function (col) {
          return col.key !== 'tchRisk';
        });
      }
      return cols;
    }
  },
  watch: {}
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tchScore__ = __webpack_require__(2);









var DEFAULT_THRESHOLDS = {
  leaveRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  resignRate: { healthy: 2, attention: 5, alert: 8, higherWorse: true },
  returnLessonHours: { healthy: 30, attention: 80, alert: 150, higherWorse: true },
  refundStudentCount: { healthy: 5, attention: 15, alert: 30, higherWorse: true },
  demoAttendDealRate: { healthy: 40, attention: 25, alert: 12, higherWorse: false },
  fullAttendanceRate: { healthy: 90, attention: 80, alert: 70, higherWorse: false },
  teacherLateRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  teacherEarlyRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  attendLessonRate: { healthy: 90, attention: 80, alert: 70, higherWorse: false },
  lessonLeaveRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  tempLeaveRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  lateRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true },
  earlyRate: { healthy: 5, attention: 12, alert: 20, higherWorse: true }
};

function cloneThresholds(src) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(src));
}

function fileNameWithRange(name, start, end) {
  var a = start || '';
  var b = end || '';
  var time = a;
  if (b && b !== a) {
    time = a + '-' + b;
  }
  return name + time + '.xlsx';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchHrMetricsDashboard',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue___default.a, UserInfoModal: __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default.a },
  data: function data() {
    return {
      showTchInfoModal: false,
      rankScoreSeq: 0,
      tchInfoId: null,
      showUserInfoModal: false,
      userInfoUid: null,
      searchLoading: false,
      saveLoading: false,
      overviewExportLoading: false,
      exportLoading: false,
      showThresholdModal: false,
      showTrendModal: false,
      showDetail: false,
      detailLoading: false,
      detailField: '',
      detailPeriod: '',
      detailStartDate: '',
      detailEndDate: '',
      detailTchId: null,
      detailTchName: '',
      detailPageIndex: 1,
      detailPageSize: 20,
      detailTotal: 0,
      detailTableData: [],
      studyAdviserList: [],
      detailStudyAdviserId: null,
      detailAdviserSilent: false,
      trendStudyAdviserId: null,
      trendAdviserSilent: false,
      nonFullLoading: false,
      nonFullKeyword: '',
      nonFullPageIndex: 1,
      nonFullPageSize: 20,
      nonFullTotal: 0,
      nonFullTableData: [],
      trendLoading: false,
      trendMetric: '',
      trendPeriodType: 'day',
      trendDateRange: [],
      trendQuery: {
        startDate: '',
        endDate: ''
      },
      trendTableData: [],
      editKey: '',
      editDirection: 'worse',
      editBand: { healthy: 0, attention: 0, alert: 0 },
      thresholds: cloneThresholds(DEFAULT_THRESHOLDS),
      thresholdFields: [{ key: 'leaveRate', name: '请假率', unit: '%', hint: '已通过请假或老师缺席的老师占比，越低越好。' }, { key: 'resignRate', name: '离职率', unit: '%', hint: '期内离职人数 ÷ 月初在职人数，越低越好。' }, { key: 'returnLessonHours', name: '返课时数', unit: '课时', hint: '课堂投诉审核通过、外教课、赠课原因是老师，越少越好。' }, { key: 'refundStudentCount', name: '退费学生数', unit: '人', hint: '财务退费里老师原因学生数，越少越好。' }, { key: 'demoAttendDealRate', name: 'Demo出席成交率', unit: '%', hint: '出席试听后成交比例，越高越好。' }, { key: 'fullAttendanceRate', name: '全勤率', unit: '%', hint: '只看老师责任。学生请假、管理员取消、学生缺席且老师未迟到早退缺席的课不进分子分母。老师请假、离职课算未全勤。' }, { key: 'teacherLateRate', name: '老师迟到率', unit: '%', hint: '至少有一节迟到的正常上课老师 ÷ 有正常上课的老师，越低越好。' }, { key: 'teacherEarlyRate', name: '老师早退率', unit: '%', hint: '至少有一节早退的正常上课老师 ÷ 有正常上课的老师，越低越好。' }, { key: 'attendLessonRate', name: '上课率', unit: '%', hint: '已上课未缺席课节 ÷（买断 + 已上课临时课），越高越好。' }, { key: 'lessonLeaveRate', name: '课节请假率', unit: '%', hint: '全部请假类型或老师缺席 ÷ 应上课课节，越低越好。' }, { key: 'tempLeaveRate', name: '临时请假率', unit: '%', hint: '（临时请假 + 失联 + 取消课或老师缺席）÷ 应上课课节，越低越好。' }, { key: 'lateRate', name: '迟到率', unit: '%', hint: '老师迟到的课 ÷ 正常上课的课，越低越好。' }, { key: 'earlyRate', name: '早退率', unit: '%', hint: '老师早退的课 ÷ 正常上课的课，越低越好。' }],
      dateRange: [],
      queryParam: {
        startDate: '',
        endDate: ''
      },
      leaveRate: '—',
      leaveTeacherCount: null,
      taughtTeacherCount: null,
      resignRate: '—',
      resignTeacherCount: null,
      resignBaseCount: null,
      returnLessonHours: null,
      refundStudentCount: null,
      demoAttendDealRate: '—',
      demoAttendDealCount: null,
      demoAttendCount: null,
      fullAttendanceRate: '—',
      fullAttendanceCount: null,
      fullAttendanceTotalCount: null,
      teacherLateRate: '—',
      teacherLateCount: null,
      teacherLateBaseCount: null,
      teacherEarlyRate: '—',
      teacherEarlyCount: null,
      teacherEarlyBaseCount: null,
      attendLessonRate: '—',
      attendLessonCount: null,
      attendLessonBaseCount: null,
      lessonLeaveRate: '—',
      lessonLeaveCount: null,
      lessonLeaveBaseCount: null,
      tempLeaveRate: '—',
      tempLeaveCount: null,
      tempLeaveBaseCount: null,
      lateRate: '—',
      lateCount: null,
      lateBaseCount: null,
      earlyRate: '—',
      earlyCount: null,
      earlyBaseCount: null,
      metaRows: [{ label: '数据来源', value: 'book_lesson_opened / book_calls / book_tch_leave_time / book_course_change' }, { label: '口径版本', value: 'v1' }, { label: '最近更新', value: '—' }],
      infoChips: [{ label: '口径覆盖', value: '已通过请假/老师缺席' }, { label: '老师请假明细', value: '—' }, { label: '涉及老师', value: '—' }]
    };
  },

  computed: {
    periodText: function periodText() {
      if (!this.queryParam.startDate || !this.queryParam.endDate) {
        return '—';
      }
      return this.queryParam.startDate + ' ~ ' + this.queryParam.endDate;
    },
    compareText: function compareText() {
      if (this.leaveTeacherCount == null || this.taughtTeacherCount == null) {
        return '—';
      }
      return this.leaveTeacherCount + ' / ' + this.taughtTeacherCount + ' 人';
    },
    resignCompareText: function resignCompareText() {
      if (this.resignTeacherCount == null || this.resignBaseCount == null) {
        return '—';
      }
      return this.resignTeacherCount + ' / ' + this.resignBaseCount + ' 人';
    },
    returnLessonHoursText: function returnLessonHoursText() {
      return this.returnLessonHours == null ? '—' : String(this.returnLessonHours);
    },
    returnLessonHoursCompare: function returnLessonHoursCompare() {
      return this.returnLessonHours == null ? '—' : this.returnLessonHours + ' 课时';
    },
    refundStudentCountText: function refundStudentCountText() {
      return this.refundStudentCount == null ? '—' : String(this.refundStudentCount);
    },
    refundStudentCountCompare: function refundStudentCountCompare() {
      return this.refundStudentCount == null ? '—' : this.refundStudentCount + ' 人';
    },
    demoAttendDealCompare: function demoAttendDealCompare() {
      if (this.demoAttendDealCount == null || this.demoAttendCount == null) {
        return '—';
      }
      return this.demoAttendDealCount + ' / ' + this.demoAttendCount + ' 人';
    },
    fullAttendanceCompare: function fullAttendanceCompare() {
      if (this.fullAttendanceCount == null || this.fullAttendanceTotalCount == null) {
        return '—';
      }
      return this.fullAttendanceCount + ' / ' + this.fullAttendanceTotalCount + ' 人';
    },
    teacherLateCompare: function teacherLateCompare() {
      if (this.teacherLateCount == null || this.teacherLateBaseCount == null) {
        return '—';
      }
      return this.teacherLateCount + ' / ' + this.teacherLateBaseCount + ' 人';
    },
    teacherEarlyCompare: function teacherEarlyCompare() {
      if (this.teacherEarlyCount == null || this.teacherEarlyBaseCount == null) {
        return '—';
      }
      return this.teacherEarlyCount + ' / ' + this.teacherEarlyBaseCount + ' 人';
    },
    lateCompare: function lateCompare() {
      if (this.lateCount == null || this.lateBaseCount == null) {
        return '—';
      }
      return this.lateCount + ' / ' + this.lateBaseCount + ' 课节';
    },
    earlyCompare: function earlyCompare() {
      if (this.earlyCount == null || this.earlyBaseCount == null) {
        return '—';
      }
      return this.earlyCount + ' / ' + this.earlyBaseCount + ' 课节';
    },
    leaveRateLevel: function leaveRateLevel() {
      return this.levelClass(this.parsePercent(this.leaveRate), this.thresholds.leaveRate);
    },
    resignRateLevel: function resignRateLevel() {
      return this.levelClass(this.parsePercent(this.resignRate), this.thresholds.resignRate);
    },
    returnLessonHoursLevel: function returnLessonHoursLevel() {
      return this.levelClass(this.returnLessonHours, this.thresholds.returnLessonHours);
    },
    refundStudentCountLevel: function refundStudentCountLevel() {
      return this.levelClass(this.refundStudentCount, this.thresholds.refundStudentCount);
    },
    demoAttendDealRateLevel: function demoAttendDealRateLevel() {
      return this.levelClass(this.parsePercent(this.demoAttendDealRate), this.thresholds.demoAttendDealRate);
    },
    fullAttendanceRateLevel: function fullAttendanceRateLevel() {
      return this.levelClass(this.parsePercent(this.fullAttendanceRate), this.thresholds.fullAttendanceRate);
    },
    teacherLateRateLevel: function teacherLateRateLevel() {
      return this.levelClass(this.parsePercent(this.teacherLateRate), this.thresholds.teacherLateRate);
    },
    teacherEarlyRateLevel: function teacherEarlyRateLevel() {
      return this.levelClass(this.parsePercent(this.teacherEarlyRate), this.thresholds.teacherEarlyRate);
    },
    lateRateLevel: function lateRateLevel() {
      return this.levelClass(this.parsePercent(this.lateRate), this.thresholds.lateRate);
    },
    earlyRateLevel: function earlyRateLevel() {
      return this.levelClass(this.parsePercent(this.earlyRate), this.thresholds.earlyRate);
    },
    attendLessonRateLevel: function attendLessonRateLevel() {
      return this.levelClass(this.parsePercent(this.attendLessonRate), this.thresholds.attendLessonRate);
    },
    lessonLeaveRateLevel: function lessonLeaveRateLevel() {
      return this.levelClass(this.parsePercent(this.lessonLeaveRate), this.thresholds.lessonLeaveRate);
    },
    tempLeaveRateLevel: function tempLeaveRateLevel() {
      return this.levelClass(this.parsePercent(this.tempLeaveRate), this.thresholds.tempLeaveRate);
    },
    attendLessonCompare: function attendLessonCompare() {
      if (this.attendLessonCount == null || this.attendLessonBaseCount == null) {
        return '—';
      }
      return this.attendLessonCount + ' / ' + this.attendLessonBaseCount + ' 课节';
    },
    lessonLeaveCompare: function lessonLeaveCompare() {
      if (this.lessonLeaveCount == null || this.lessonLeaveBaseCount == null) {
        return '—';
      }
      return this.lessonLeaveCount + ' / ' + this.lessonLeaveBaseCount + ' 课节';
    },
    tempLeaveCompare: function tempLeaveCompare() {
      if (this.tempLeaveCount == null || this.tempLeaveBaseCount == null) {
        return '—';
      }
      return this.tempLeaveCount + ' / ' + this.tempLeaveBaseCount + ' 课节';
    },
    editCardMeta: function editCardMeta() {
      var _this = this;

      return this.thresholdFields.find(function (item) {
        return item.key === _this.editKey;
      }) || {};
    },
    editCardTitle: function editCardTitle() {
      return (this.editCardMeta.name || '指标') + '阈值';
    },
    editCardUnit: function editCardUnit() {
      return this.editCardMeta.unit || '';
    },
    editCardHint: function editCardHint() {
      return this.editCardMeta.hint || '按该指标实际含义设置三个阈值。';
    },
    trendTitle: function trendTitle() {
      var names = {
        leaveRate: '请假率',
        resignRate: '离职率',
        fullAttendanceRate: '全勤率',
        teacherLateRate: '老师迟到率',
        teacherEarlyRate: '老师早退率',
        returnLessonHours: '返课时数',
        refundStudentCount: '退费学生数',
        demoAttendDealRate: 'Demo出席成交率',
        attendLessonRate: '上课率',
        lessonLeaveRate: '请假率',
        tempLeaveRate: '临时请假率',
        lateRate: '迟到率',
        earlyRate: '早退率'
      };
      return (names[this.trendMetric] || '指标') + '区间统计';
    },
    trendModalWidth: function trendModalWidth() {
      if (this.showDetail) {
        return 880;
      }
      return this.trendMetric === 'fullAttendanceRate' ? 920 : 760;
    },
    trendModalTitle: function trendModalTitle() {
      if (this.showDetail) {
        return this.trendTitle + ' › 明细';
      }
      return this.trendTitle;
    },
    trendHint: function trendHint() {
      var hints = {
        leaveRate: '已通过请假的老师 + 老师缺席的老师 ÷ 该段有课老师。点分子或分母看该段名单，比率不点。',
        resignRate: '离职人数 ÷ 该段起始日所在月 1 号在职人数。点分子或分母看该段名单，比率不点。',
        fullAttendanceRate: '全勤有课老师 ÷ 该段有课老师。学生请假、管理员取消、学生缺席且老师未迟到早退缺席的课不进分子分母；老师请假、离职课算未全勤。点分子或分母看名单；下方是未全勤老师。',
        teacherLateRate: '老师维度。至少有一节迟到的正常上课老师 ÷ 有正常上课的老师。正常上课是已经上完，学生、老师都未缺席。一个老师只计一次。点分子或分母看名单，比率不点。',
        teacherEarlyRate: '老师维度。至少有一节早退的正常上课老师 ÷ 有正常上课的老师。分母与老师迟到率相同。点分子或分母看名单，比率不点。',
        returnLessonHours: '课堂投诉审核通过、外教课、赠课原因是老师。点数字看该段记录。',
        refundStudentCount: '财务退费老师原因学生数，按人去重。点数字看该段名单。',
        demoAttendDealRate: '段内成交学生数 ÷ 段内出席学生数。点分子或分母看该段名单，比率不点。',
        attendLessonRate: '已上课未缺席课节 ÷（买断课节 + 已上课临时课）。点分子看课节，点分母按老师汇总。',
        lessonLeaveRate: '全部请假类型或老师缺席 ÷ 应上课课节。点分子看课节，点分母按老师汇总。',
        tempLeaveRate: '（临时请假 + 失联 + 取消课或老师缺席）÷ 应上课课节。点分子看课节，点分母按老师汇总。',
        lateRate: '课节维度。老师迟到的课 ÷ 正常上课的课。正常上课是已经上完，学生、老师都未缺席。点分子或分母看课节，比率不点。',
        earlyRate: '课节维度。老师早退的课 ÷ 正常上课的课。分母与迟到率相同。点分子或分母看课节，比率不点。'
      };
      return hints[this.trendMetric] || '';
    },
    trendPeriodOptions: function trendPeriodOptions() {
      if (this.trendMetric === 'returnLessonHours') {
        return [{ value: 'week', label: '周' }, { value: 'month', label: '月' }, { value: 'year', label: '年' }];
      }
      if (this.trendMetric === 'refundStudentCount' || this.trendMetric === 'demoAttendDealRate') {
        return [{ value: 'month', label: '月' }, { value: 'year', label: '年' }];
      }
      return [{ value: 'day', label: '日' }, { value: 'week', label: '周' }, { value: 'month', label: '月' }, { value: 'year', label: '年' }];
    },
    trendColumns: function trendColumns() {
      var self = this;
      var numLink = function numLink(title, minWidth) {
        return {
          title: title,
          key: 'numerator',
          align: 'center',
          minWidth: minWidth || 110,
          render: function render(h, params) {
            return h('a', {
              class: 'trend-num-link',
              style: { color: '#2d8cf0', cursor: 'pointer' },
              on: {
                click: function click(e) {
                  e.stopPropagation();
                  self.openDetail(params.row, 'numerator');
                }
              }
            }, params.row.numerator == null ? '0' : String(params.row.numerator));
          }
        };
      };
      var denLink = function denLink(title) {
        return {
          title: title,
          key: 'denominator',
          align: 'center',
          minWidth: 120,
          render: function render(h, params) {
            return h('a', {
              class: 'trend-num-link',
              style: { color: '#2d8cf0', cursor: 'pointer' },
              on: {
                click: function click(e) {
                  e.stopPropagation();
                  self.openDetail(params.row, 'denominator');
                }
              }
            }, params.row.denominator == null ? '0' : String(params.row.denominator));
          }
        };
      };
      if (this.trendMetric === 'returnLessonHours') {
        return [{ title: '周期', key: 'period', align: 'center', minWidth: 160 }, numLink('返课时数', 120)];
      }
      if (this.trendMetric === 'refundStudentCount') {
        return [{ title: '周期', key: 'period', align: 'center', minWidth: 160 }, numLink('退费学生数', 120)];
      }
      var rateTitle = this.trendTitle.replace('区间统计', '');
      var rateColumn = {
        title: rateTitle,
        key: 'rate',
        align: 'center',
        minWidth: 110
      };
      if (this.trendMetric === 'lessonLeaveRate' || this.trendMetric === 'tempLeaveRate') {
        rateColumn.render = function (h, params) {
          var row = params.row || {};
          return h('span', self.emptyLessonRate(row.rate, row.denominator));
        };
      }
      var numTitle = {
        leaveRate: '请假老师数',
        resignRate: '离职人数',
        fullAttendanceRate: '全勤外教数',
        teacherLateRate: '迟到老师',
        teacherEarlyRate: '早退老师',
        demoAttendDealRate: '成交学生数',
        attendLessonRate: '已上课课节',
        lessonLeaveRate: '全部请假或老师缺席',
        tempLeaveRate: '临时请假+失联+取消课或老师缺席',
        lateRate: '迟到课节',
        earlyRate: '早退课节'
      }[this.trendMetric] || '分子';
      var denTitle = {
        leaveRate: '有课老师数',
        resignRate: '月初在职人数',
        fullAttendanceRate: '有课老师数',
        teacherLateRate: '正常上课老师',
        teacherEarlyRate: '正常上课老师',
        demoAttendDealRate: '出席学生数',
        attendLessonRate: '买断+临时课节',
        lessonLeaveRate: '应上课课节',
        tempLeaveRate: '应上课课节',
        lateRate: '正常上课课节',
        earlyRate: '正常上课课节'
      }[this.trendMetric] || '分母';
      return [{ title: '周期', key: 'period', align: 'center', minWidth: 160 }, numLink(numTitle, 110), denLink(denTitle), rateColumn];
    },
    detailTitle: function detailTitle() {
      var names = {
        leaveRate: '请假率',
        resignRate: '离职率',
        fullAttendanceRate: '全勤率',
        teacherLateRate: '老师迟到率',
        teacherEarlyRate: '老师早退率',
        returnLessonHours: '返课时数',
        refundStudentCount: '退费学生数',
        demoAttendDealRate: 'Demo出席成交率',
        attendLessonRate: '上课率',
        lessonLeaveRate: '请假率',
        tempLeaveRate: '临时请假率',
        lateRate: '迟到率',
        earlyRate: '早退率'
      };
      var fieldNames = {
        leaveRate: { numerator: '请假老师', denominator: '有课老师' },
        resignRate: { numerator: '离职老师', denominator: '月初在职老师' },
        fullAttendanceRate: { numerator: '全勤外教', denominator: '有课老师', nonFull: '未全勤老师', nonFullLessons: '异常课节' },
        teacherLateRate: { numerator: '迟到老师', denominator: '正常上课老师' },
        teacherEarlyRate: { numerator: '早退老师', denominator: '正常上课老师' },
        returnLessonHours: { numerator: '返课记录' },
        refundStudentCount: { numerator: '退费学生' },
        demoAttendDealRate: { numerator: '成交学生', denominator: '出席学生' },
        attendLessonRate: { numerator: '已上课课节', denominator: '买断+临时' },
        lessonLeaveRate: { numerator: '全部请假或老师缺席', denominator: '应上课课节' },
        tempLeaveRate: { numerator: '临时请假+失联+取消课或老师缺席', denominator: '应上课课节' },
        lateRate: { numerator: '迟到课节', denominator: '正常上课课节' },
        earlyRate: { numerator: '早退课节', denominator: '正常上课课节' }
      };
      var metricName = names[this.trendMetric] || '指标';
      var fieldName = (fieldNames[this.trendMetric] || {})[this.detailField] || '明细';
      var period = this.detailPeriod ? ' · ' + this.detailPeriod : '';
      var tch = this.detailField === 'nonFullLessons' && this.detailTchName ? ' · ' + this.detailTchName : this.detailField === 'nonFullLessons' && this.detailTchId ? ' · 老师' + this.detailTchId : '';
      return metricName + ' · ' + fieldName + tch + period;
    },
    detailHint: function detailHint() {
      if (this.detailField === 'nonFullLessons') {
        if (!this.detailStartDate || !this.detailEndDate) {
          return '该老师区间内老师责任异常课节：迟到、早退、缺席、请假、离职等。学生请假、管理员取消、学生缺席且老师未缺席的课不计入。';
        }
        return '该老师 ' + this.detailStartDate + ' ~ ' + this.detailEndDate + ' 的异常课节：迟到、早退、缺席、请假、离职等。学生请假、管理员取消、学生缺席且老师未缺席的课不计入。';
      }
      if (!this.detailStartDate || !this.detailEndDate) {
        return '口径与看板该段数字一致。';
      }
      return '口径与看板该段数字一致，日期 ' + this.detailStartDate + ' ~ ' + this.detailEndDate + '。0 也可点，空表即无人。';
    },
    detailColumns: function detailColumns() {
      if (this.detailField === 'nonFullLessons') {
        return [this.buildTeacherColumn(), { title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110 }, { title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170 }, { title: '异常原因', key: 'extra', align: 'center', minWidth: 180 }];
      }
      if (this.trendMetric === 'returnLessonHours') {
        return [{ title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '学生姓名', key: 'studentName', align: 'center', minWidth: 120 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, { title: '课时', key: 'num', align: 'center', minWidth: 80 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '审核时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.trendMetric === 'refundStudentCount') {
        var _self = this;
        var $constant = this.$constant;
        return [{
          title: '学生',
          key: 'student',
          align: 'center',
          minWidth: 180,
          render: function render(h, params) {
            var row = params.row || {};
            var id = row.uid == null ? '' : String(row.uid);
            var name = (row.studentName || '').trim();
            return h('a', {
              style: { color: '#2d8cf0', cursor: 'pointer' },
              on: {
                click: function click() {
                  if (row.uid) {
                    _self.openInfoModal(row.uid);
                  }
                }
              }
            }, name ? id + '-' + name : id);
          }
        }, {
          title: '最后一节课老师',
          key: 'lastTchName',
          align: 'center',
          minWidth: 200,
          render: function render(h, params) {
            var row = params.row || {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: (row.lastTchName || '').trim(),
              score: row.monthRankScore
            });
          }
        }, { title: '对应老师外管', key: 'tchAdviserName', align: 'center', minWidth: 140 }, {
          title: '退费原因分类',
          align: 'center',
          minWidth: 130,
          render: function render(h, params) {
            var statusEnum = $constant.getEnum($constant.refundReasonCategory, params.row.refundReasonCategory);
            return h('span', statusEnum && statusEnum.text);
          }
        }, { title: '退费原因', key: 'refundReason', align: 'center', minWidth: 180 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.trendMetric === 'demoAttendDealRate') {
        return [{ title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '学生姓名', key: 'studentName', align: 'center', minWidth: 140 }, { title: '成交外教', key: 'demoTch', align: 'center', minWidth: 140 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.trendMetric === 'lateRate' || this.trendMetric === 'earlyRate') {
        var _self2 = this;
        return [{ title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, {
          title: '姓名',
          key: 'tchName',
          align: 'center',
          minWidth: 140,
          render: function render(h, params) {
            var row = params.row;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: _self2.formatHrTeacherName(row),
              score: row.monthRankScore,
              onClick: row.tchId ? function () {
                return _self2.openTchInfoModal(row.tchId);
              } : null
            });
          }
        }, { title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170 }, { title: '类型', key: 'extra', align: 'center', minWidth: 100 }].concat(this.detailField === 'numerator' ? [{
          title: '时长',
          key: 'durationText',
          align: 'center',
          minWidth: 100,
          render: function render(h, params) {
            var text = (params.row && params.row.durationText || '').trim();
            return h('span', text || '—');
          }
        }] : []);
      }
      if (this.trendMetric === 'attendLessonRate' || this.trendMetric === 'lessonLeaveRate' || this.trendMetric === 'tempLeaveRate') {
        var _self3 = this;
        return [{ title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, {
          title: '姓名',
          key: 'tchName',
          align: 'center',
          minWidth: 140,
          render: function render(h, params) {
            var row = params.row;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: _self3.formatHrTeacherName(row),
              score: row.monthRankScore,
              onClick: row.tchId ? function () {
                return _self3.openTchInfoModal(row.tchId);
              } : null
            });
          }
        }, { title: '课节数', key: 'num', align: 'center', minWidth: 80 }, { title: '类型', key: 'extra', align: 'center', minWidth: 160 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.trendMetric === 'fullAttendanceRate') {
        return [this.buildTeacherColumn(), { title: '类型', key: 'extra', align: 'center', minWidth: 120 }, { title: '最后工作日', key: 'lastWorkDay', align: 'center', minWidth: 120 }, { title: '开课时间', key: 'openCourseTime', align: 'center', minWidth: 160 }];
      }
      var self = this;
      return [{ title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, {
        title: '姓名',
        key: 'tchName',
        align: 'center',
        minWidth: 140,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: self.formatHrTeacherName(row),
            score: row.monthRankScore,
            onClick: row.tchId ? function () {
              return self.openTchInfoModal(row.tchId);
            } : null
          });
        }
      }, { title: '类型', key: 'extra', align: 'center', minWidth: 120 }, { title: '最后工作日', key: 'lastWorkDay', align: 'center', minWidth: 120 }, { title: '开课时间', key: 'openCourseTime', align: 'center', minWidth: 160 }];
    },
    nonFullColumns: function nonFullColumns() {
      var self = this;
      return [this.buildTeacherColumn(), {
        title: '异常课节数',
        key: 'num',
        align: 'center',
        minWidth: 110,
        render: function render(h, params) {
          return h('a', {
            class: 'trend-num-link',
            style: { color: '#2d8cf0', cursor: 'pointer' },
            on: {
              click: function click(e) {
                e.stopPropagation();
                self.openNonFullLessons(params.row);
              }
            }
          }, params.row.num == null ? '0' : String(params.row.num));
        }
      }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '最后工作日', key: 'lastWorkDay', align: 'center', minWidth: 120 }, { title: '开课时间', key: 'openCourseTime', align: 'center', minWidth: 160 }];
    }
  },
  created: function created() {
    this.thresholds = this.loadThresholds();
    this.loadStudyAdviserList();
  },
  mounted: function mounted() {
    this.initDefaultDate();
    this.search();
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores(listKey) {
      var table = this[listKey];
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    loadStudyAdviserList: function loadStudyAdviserList() {
      var _this2 = this;

      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.studyAdviserList = res.data;
        }
      });
    },
    positiveAdviserId: function positiveAdviserId(value) {
      var id = Number(value);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(id) && id > 0) {
        return id;
      }
      return null;
    },
    selectedStudyAdviserId: function selectedStudyAdviserId() {
      return this.positiveAdviserId(this.detailStudyAdviserId);
    },
    selectedTrendStudyAdviserId: function selectedTrendStudyAdviserId() {
      return this.positiveAdviserId(this.trendStudyAdviserId);
    },
    withStudyAdviser: function withStudyAdviser(body, adviserId) {
      var query = body || {};
      if (adviserId) {
        query.studyAdviserId = adviserId;
      }
      return query;
    },
    formatHrTeacherName: function formatHrTeacherName(row) {
      var item = row || {};
      var first = (item.firstName || '').trim();
      var last = (item.lastName || '').trim();
      return (first + ' ' + last).trim();
    },
    teacherLabel: function teacherLabel(row) {
      if (!row) {
        return '';
      }
      var id = row.tchId == null ? '' : String(row.tchId);
      var first = (row.firstName || '').trim();
      var last = (row.lastName || '').trim();
      var name = (first + ' ' + last).trim() || (row.tchName || '').trim();
      return name ? id + '-' + name : id;
    },
    buildTeacherColumn: function buildTeacherColumn() {
      var self = this;
      return {
        title: '老师',
        key: 'teacher',
        align: 'center',
        minWidth: 240,
        render: function render(h, params) {
          var row = params.row || {};
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: self.teacherLabel(row),
            score: row.monthRankScore,
            onClick: row.tchId ? function () {
              return self.openTchInfoModal(row.tchId);
            } : null
          });
        }
      };
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    openInfoModal: function openInfoModal(uid) {
      this.userInfoUid = uid;
      this.showUserInfoModal = true;
    },
    emptyLessonRate: function emptyLessonRate(rate, base) {
      if (base === 0 || base === '0') {
        return '一';
      }
      if (base == null && (rate == null || rate === '')) {
        return '一';
      }
      return rate || '0%';
    },
    parsePercent: function parsePercent(text) {
      if (text == null || text === '—' || text === '') {
        return null;
      }
      var num = parseFloat(String(text).replace('%', ''));
      return isNaN(num) ? null : num;
    },
    levelClass: function levelClass(value, spec) {
      if (value == null || !spec) {
        return '';
      }
      var healthy = Number(spec.healthy);
      var attention = Number(spec.attention);
      var higherWorse = spec.higherWorse !== false;
      if (higherWorse) {
        if (value <= healthy) {
          return 'is-healthy';
        }
        if (value <= attention) {
          return 'is-warning';
        }
        return 'is-danger';
      }
      if (value >= healthy) {
        return 'is-healthy';
      }
      if (value >= attention) {
        return 'is-warning';
      }
      return 'is-danger';
    },
    mergeThresholds: function mergeThresholds(saved) {
      var merged = cloneThresholds(DEFAULT_THRESHOLDS);
      if (!saved) {
        return merged;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(merged).forEach(function (key) {
        if (!saved[key]) {
          return;
        }
        var healthy = Number(saved[key].healthy);
        var attention = Number(saved[key].attention);
        var alert = Number(saved[key].alert);
        if (!isNaN(healthy)) {
          merged[key].healthy = healthy;
        }
        if (!isNaN(attention)) {
          merged[key].attention = attention;
        }
        if (!isNaN(alert)) {
          merged[key].alert = alert;
        }
        if (saved[key].higherWorse === false || saved[key].higherWorse === true) {
          merged[key].higherWorse = saved[key].higherWorse;
        }
      });
      return merged;
    },
    loadThresholds: function loadThresholds() {
      return cloneThresholds(DEFAULT_THRESHOLDS);
    },
    openCardThreshold: function openCardThreshold(key) {
      var current = this.thresholds[key] || DEFAULT_THRESHOLDS[key];
      this.editKey = key;
      this.editBand = {
        healthy: current.healthy,
        attention: current.attention,
        alert: current.alert
      };
      this.editDirection = current.higherWorse === false ? 'better' : 'worse';
      this.showThresholdModal = true;
    },
    saveThresholds: function saveThresholds() {
      var _this3 = this;

      var item = this.editCardMeta;
      var healthy = Number(this.editBand.healthy);
      var attention = Number(this.editBand.attention);
      var alert = Number(this.editBand.alert);
      var higherWorse = this.editDirection !== 'better';
      if (!item.key || isNaN(healthy) || isNaN(attention) || isNaN(alert) || healthy < 0 || attention < 0 || alert < 0) {
        this.$Message.error('阈值须为不小于 0 的数字');
        return false;
      }
      if (higherWorse && !(healthy < attention && attention < alert)) {
        this.$Message.error('越小越健康时须满足健康 < 需关注 < 预警');
        return false;
      }
      if (!higherWorse && !(alert < attention && attention < healthy)) {
        this.$Message.error('越大越健康时须满足预警 < 需关注 < 健康');
        return false;
      }
      var next = cloneThresholds(this.thresholds);
      next[item.key] = { healthy: healthy, attention: attention, alert: alert, higherWorse: higherWorse };
      this.saveLoading = true;
      this.$http.post('/tch/hr-metrics-threshold', {
        thresholds: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(next)
      }).then(function (res) {
        if (res && res.status === 'ok') {
          _this3.thresholds = next;
          _this3.$Message.success('阈值已保存');
          _this3.showThresholdModal = false;
        } else {
          _this3.$Message.error(res && res.msg || '保存失败');
        }
      }).catch(function () {
        _this3.$Message.error('保存失败');
      }).finally(function () {
        _this3.saveLoading = false;
      });
      return false;
    },
    initDefaultDate: function initDefaultDate() {
      var now = this.$moment();
      this.dateRange = [now.clone().startOf('month').format('YYYY-MM-DD'), now.format('YYYY-MM-DD')];
      this.queryParam.startDate = this.dateRange[0];
      this.queryParam.endDate = this.dateRange[1];
    },
    onPeriodChange: function onPeriodChange(value) {
      if (value && value.length === 2 && value[0] && value[1]) {
        this.dateRange = value;
        this.queryParam.startDate = value[0];
        this.queryParam.endDate = value[1];
        this.search();
      }
    },
    applyMetrics: function applyMetrics(data) {
      this.leaveRate = data && data.leaveRate ? data.leaveRate : '—';
      this.leaveTeacherCount = data && data.leaveTeacherCount != null ? data.leaveTeacherCount : 0;
      this.taughtTeacherCount = data && data.taughtTeacherCount != null ? data.taughtTeacherCount : 0;
      this.resignRate = data && data.resignRate ? data.resignRate : '0%';
      this.resignTeacherCount = data && data.resignTeacherCount != null ? data.resignTeacherCount : 0;
      this.resignBaseCount = data && data.resignBaseCount != null ? data.resignBaseCount : 0;
      this.returnLessonHours = data && data.returnLessonHours != null ? data.returnLessonHours : 0;
      this.refundStudentCount = data && data.refundStudentCount != null ? data.refundStudentCount : 0;
      this.demoAttendDealRate = data && data.demoAttendDealRate ? data.demoAttendDealRate : '0%';
      this.demoAttendDealCount = data && data.demoAttendDealCount != null ? data.demoAttendDealCount : 0;
      this.demoAttendCount = data && data.demoAttendCount != null ? data.demoAttendCount : 0;
      this.fullAttendanceRate = data && data.fullAttendanceRate ? data.fullAttendanceRate : '0%';
      this.fullAttendanceCount = data && data.fullAttendanceCount != null ? data.fullAttendanceCount : 0;
      this.fullAttendanceTotalCount = data && data.fullAttendanceTotalCount != null ? data.fullAttendanceTotalCount : 0;
      this.teacherLateCount = data && data.teacherLateCount != null ? data.teacherLateCount : 0;
      this.teacherLateBaseCount = data && data.teacherLateBaseCount != null ? data.teacherLateBaseCount : 0;
      this.teacherLateRate = data && data.teacherLateBaseCount === 0 ? '—' : data && data.teacherLateRate ? data.teacherLateRate : '—';
      this.teacherEarlyCount = data && data.teacherEarlyCount != null ? data.teacherEarlyCount : 0;
      this.teacherEarlyBaseCount = data && data.teacherEarlyBaseCount != null ? data.teacherEarlyBaseCount : 0;
      this.teacherEarlyRate = data && data.teacherEarlyBaseCount === 0 ? '—' : data && data.teacherEarlyRate ? data.teacherEarlyRate : '—';
      this.attendLessonRate = data && data.attendLessonRate ? data.attendLessonRate : '0.00%';
      this.attendLessonCount = data && data.attendLessonCount != null ? data.attendLessonCount : 0;
      this.attendLessonBaseCount = data && data.attendLessonBaseCount != null ? data.attendLessonBaseCount : 0;
      this.lessonLeaveCount = data && data.lessonLeaveCount != null ? data.lessonLeaveCount : 0;
      this.lessonLeaveBaseCount = data && data.lessonLeaveBaseCount != null ? data.lessonLeaveBaseCount : 0;
      this.lessonLeaveRate = this.emptyLessonRate(data && data.lessonLeaveRate, data && data.lessonLeaveBaseCount);
      this.tempLeaveCount = data && data.tempLeaveCount != null ? data.tempLeaveCount : 0;
      this.tempLeaveBaseCount = data && data.tempLeaveBaseCount != null ? data.tempLeaveBaseCount : 0;
      this.tempLeaveRate = this.emptyLessonRate(data && data.tempLeaveRate, data && data.tempLeaveBaseCount);
      this.lateCount = data && data.lateCount != null ? data.lateCount : 0;
      this.lateBaseCount = data && data.lateBaseCount != null ? data.lateBaseCount : 0;
      this.lateRate = data && data.lateBaseCount === 0 ? '—' : data && data.lateRate ? data.lateRate : '—';
      this.earlyCount = data && data.earlyCount != null ? data.earlyCount : 0;
      this.earlyBaseCount = data && data.earlyBaseCount != null ? data.earlyBaseCount : 0;
      this.earlyRate = data && data.earlyBaseCount === 0 ? '—' : data && data.earlyRate ? data.earlyRate : '—';
      this.thresholds = this.mergeThresholds(data && data.thresholds);
      if (data && data.startDate && data.endDate) {
        this.queryParam.startDate = data.startDate;
        this.queryParam.endDate = data.endDate;
        this.dateRange = [data.startDate, data.endDate];
      }
      this.infoChips = [{ label: '口径覆盖', value: '已通过请假/老师缺席' }, { label: '老师请假明细', value: this.leaveTeacherCount == null ? '—' : String(this.leaveTeacherCount) }, { label: '涉及老师', value: this.taughtTeacherCount == null ? '—' : String(this.taughtTeacherCount) }];
      this.metaRows = [{ label: '数据来源', value: 'book_lesson_opened / book_calls / book_tch_leave_time / book_course_change' }, { label: '口径版本', value: 'v1' }, { label: '最近更新', value: this.$moment().format('YYYY-MM-DD HH:mm') }];
    },
    resetMetrics: function resetMetrics() {
      this.leaveRate = '—';
      this.leaveTeacherCount = null;
      this.taughtTeacherCount = null;
      this.resignRate = '—';
      this.resignTeacherCount = null;
      this.resignBaseCount = null;
      this.returnLessonHours = null;
      this.refundStudentCount = null;
      this.demoAttendDealRate = '—';
      this.demoAttendDealCount = null;
      this.demoAttendCount = null;
      this.fullAttendanceRate = '—';
      this.fullAttendanceCount = null;
      this.fullAttendanceTotalCount = null;
      this.teacherLateRate = '—';
      this.teacherLateCount = null;
      this.teacherLateBaseCount = null;
      this.teacherEarlyRate = '—';
      this.teacherEarlyCount = null;
      this.teacherEarlyBaseCount = null;
      this.attendLessonRate = '—';
      this.attendLessonCount = null;
      this.attendLessonBaseCount = null;
      this.lessonLeaveRate = '—';
      this.lessonLeaveCount = null;
      this.lessonLeaveBaseCount = null;
      this.tempLeaveRate = '—';
      this.tempLeaveCount = null;
      this.tempLeaveBaseCount = null;
      this.lateRate = '—';
      this.lateCount = null;
      this.lateBaseCount = null;
      this.earlyRate = '—';
      this.earlyCount = null;
      this.earlyBaseCount = null;
      this.infoChips = [{ label: '口径覆盖', value: '已通过请假/老师缺席' }, { label: '老师请假明细', value: '—' }, { label: '涉及老师', value: '—' }];
    },
    openTrend: function openTrend(metric) {
      var _this4 = this;

      var defaultPeriod = {
        leaveRate: 'day',
        resignRate: 'day',
        fullAttendanceRate: 'day',
        teacherLateRate: 'day',
        teacherEarlyRate: 'day',
        returnLessonHours: 'week',
        refundStudentCount: 'month',
        demoAttendDealRate: 'month',
        attendLessonRate: 'day',
        lessonLeaveRate: 'day',
        tempLeaveRate: 'day',
        lateRate: 'day',
        earlyRate: 'day'
      };
      this.trendMetric = metric;
      this.trendPeriodType = defaultPeriod[metric] || 'day';
      this.trendQuery.startDate = this.queryParam.startDate;
      this.trendQuery.endDate = this.queryParam.endDate;
      this.trendDateRange = [this.queryParam.startDate, this.queryParam.endDate];
      this.trendAdviserSilent = true;
      this.trendStudyAdviserId = null;
      this.$nextTick(function () {
        _this4.trendAdviserSilent = false;
      });
      this.resetDetail();
      this.showTrendModal = true;
      this.searchTrend();
    },
    closeTrendModal: function closeTrendModal() {
      this.showTrendModal = false;
      this.resetDetail();
    },
    onTrendVisible: function onTrendVisible(visible) {
      if (!visible) {
        this.resetDetail();
      }
    },
    resetDetail: function resetDetail() {
      this.showDetail = false;
      this.detailField = '';
      this.detailPeriod = '';
      this.detailStartDate = '';
      this.detailEndDate = '';
      this.detailTchId = null;
      this.detailTchName = '';
      this.detailPageIndex = 1;
      this.detailPageSize = 20;
      this.detailTotal = 0;
      this.detailTableData = [];
      this.nonFullKeyword = '';
      this.nonFullPageIndex = 1;
      this.nonFullPageSize = 20;
      this.nonFullTotal = 0;
      this.nonFullTableData = [];
    },
    backToTrend: function backToTrend() {
      this.showDetail = false;
      this.detailField = '';
      this.detailPeriod = '';
      this.detailStartDate = '';
      this.detailEndDate = '';
      this.detailTchId = null;
      this.detailTchName = '';
      this.detailTableData = [];
      this.detailTotal = 0;
      this.detailPageIndex = 1;
    },
    onTrendPeriodChange: function onTrendPeriodChange(value) {
      if (value && value.length === 2 && value[0] && value[1]) {
        this.trendDateRange = value;
        this.trendQuery.startDate = value[0];
        this.trendQuery.endDate = value[1];
        this.searchTrend();
      }
    },
    searchTrend: function searchTrend() {
      var _this5 = this;

      if (!this.trendMetric || !this.trendQuery.startDate || !this.trendQuery.endDate) {
        this.trendTableData = [];
        return;
      }
      this.trendLoading = true;
      this.$http.post('/tch/hr-metrics-trend', this.withStudyAdviser({
        metric: this.trendMetric,
        periodType: this.trendPeriodType,
        startDate: this.trendQuery.startDate,
        endDate: this.trendQuery.endDate
      }, this.selectedTrendStudyAdviserId())).then(function (res) {
        _this5.trendTableData = res && res.status === 'ok' && Array.isArray(res.data) ? res.data : [];
      }).catch(function () {
        _this5.trendTableData = [];
      }).finally(function () {
        _this5.trendLoading = false;
      });
      if (this.trendMetric === 'fullAttendanceRate') {
        this.nonFullPageIndex = 1;
        this.searchNonFull();
      } else {
        this.nonFullTableData = [];
        this.nonFullTotal = 0;
      }
    },
    searchNonFull: function searchNonFull() {
      var _this6 = this;

      if (this.trendMetric !== 'fullAttendanceRate' || !this.trendQuery.startDate || !this.trendQuery.endDate) {
        this.nonFullTableData = [];
        this.nonFullTotal = 0;
        return;
      }
      this.nonFullLoading = true;
      var nonFullQuery = {
        metric: 'fullAttendanceRate',
        field: 'nonFull',
        startDate: this.trendQuery.startDate,
        endDate: this.trendQuery.endDate,
        pageIndex: this.nonFullPageIndex,
        pageSize: this.nonFullPageSize
      };
      var kw = (this.nonFullKeyword || '').trim();
      if (kw) {
        nonFullQuery.keyword = kw;
      }
      this.$http.post('/tch/hr-metrics-trend-detail', this.withStudyAdviser(nonFullQuery, this.selectedTrendStudyAdviserId())).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this6.nonFullTableData = res.data.data || [];
          _this6.loadMonthRankScores('nonFullTableData');
          _this6.nonFullTotal = res.data.totalCount || 0;
        } else {
          _this6.nonFullTableData = [];
          _this6.nonFullTotal = 0;
          _this6.$Message.error(res && res.msg || '未全勤老师加载失败');
        }
      }).catch(function () {
        _this6.nonFullTableData = [];
        _this6.nonFullTotal = 0;
        _this6.$Message.error('未全勤老师加载失败');
      }).finally(function () {
        _this6.nonFullLoading = false;
      });
    },
    onNonFullPageChange: function onNonFullPageChange(page) {
      this.nonFullPageIndex = page;
      this.searchNonFull();
    },
    onNonFullPageSizeChange: function onNonFullPageSizeChange(size) {
      this.nonFullPageSize = size;
      this.nonFullPageIndex = 1;
      this.searchNonFull();
    },
    onNonFullKeywordSearch: function onNonFullKeywordSearch() {
      this.nonFullPageIndex = 1;
      this.searchNonFull();
    },
    openNonFullLessons: function openNonFullLessons(row) {
      if (!row || !row.tchId) {
        return;
      }
      this.detailField = 'nonFullLessons';
      this.detailPeriod = (this.trendQuery.startDate || '') + ' ~ ' + (this.trendQuery.endDate || '');
      this.detailStartDate = this.trendQuery.startDate;
      this.detailEndDate = this.trendQuery.endDate;
      this.detailTchId = row.tchId;
      this.detailTchName = ((row.firstName || '') + ' ' + (row.lastName || '')).trim() || String(row.tchId);
      this.detailPageIndex = 1;
      this.detailPageSize = 20;
      this.detailTableData = [];
      this.detailTotal = 0;
      this.carryTrendAdviserToDetail();
      this.showDetail = true;
      this.searchDetail();
    },
    openDetail: function openDetail(row, field) {
      if (!row || !this.trendMetric || !field) {
        return;
      }
      this.detailField = field;
      this.detailPeriod = row.period || '';
      this.detailStartDate = row.startDate;
      this.detailEndDate = row.endDate;
      this.detailTchId = null;
      this.detailTchName = '';
      this.detailPageIndex = 1;
      this.detailPageSize = 20;
      this.detailTableData = [];
      this.detailTotal = 0;
      this.carryTrendAdviserToDetail();
      this.showDetail = true;
      this.searchDetail();
    },
    resetDetailStudyAdviser: function resetDetailStudyAdviser() {
      var _this7 = this;

      this.detailAdviserSilent = true;
      this.detailStudyAdviserId = null;
      this.$nextTick(function () {
        _this7.detailAdviserSilent = false;
      });
    },
    carryTrendAdviserToDetail: function carryTrendAdviserToDetail() {
      var _this8 = this;

      this.detailAdviserSilent = true;
      this.detailStudyAdviserId = this.selectedTrendStudyAdviserId();
      this.$nextTick(function () {
        _this8.detailAdviserSilent = false;
      });
    },
    onTrendStudyAdviserChange: function onTrendStudyAdviserChange() {
      if (this.trendAdviserSilent) {
        return;
      }
      this.searchTrend();
    },
    onDetailStudyAdviserChange: function onDetailStudyAdviserChange() {
      if (this.detailAdviserSilent) {
        return;
      }
      this.detailPageIndex = 1;
      this.searchDetail();
    },
    onDetailPageChange: function onDetailPageChange(page) {
      this.detailPageIndex = page;
      this.searchDetail();
    },
    onDetailPageSizeChange: function onDetailPageSizeChange(size) {
      this.detailPageSize = size;
      this.detailPageIndex = 1;
      this.searchDetail();
    },
    searchDetail: function searchDetail() {
      var _this9 = this;

      if (!this.trendMetric || !this.detailField || !this.detailStartDate || !this.detailEndDate) {
        this.detailTableData = [];
        this.detailTotal = 0;
        return;
      }
      this.detailLoading = true;
      var detailQuery = {
        metric: this.trendMetric,
        field: this.detailField,
        startDate: this.detailStartDate,
        endDate: this.detailEndDate,
        tchId: this.detailTchId,
        pageIndex: this.detailPageIndex,
        pageSize: this.detailPageSize
      };
      var studyAdviserId = this.selectedStudyAdviserId();
      if (studyAdviserId) {
        detailQuery.studyAdviserId = studyAdviserId;
      }
      this.$http.post('/tch/hr-metrics-trend-detail', detailQuery).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this9.detailTableData = res.data.data || [];
          _this9.loadMonthRankScores('detailTableData');
          _this9.detailTotal = res.data.totalCount || 0;
        } else {
          _this9.detailTableData = [];
          _this9.detailTotal = 0;
          _this9.$Message.error(res && res.msg || '明细加载失败');
        }
      }).catch(function () {
        _this9.detailTableData = [];
        _this9.detailTotal = 0;
        _this9.$Message.error('明细加载失败');
      }).finally(function () {
        _this9.detailLoading = false;
      });
    },
    search: function search() {
      var _this10 = this;

      this.searchLoading = true;
      this.$http.post('/tch/hr-metrics', {
        startDate: this.queryParam.startDate,
        endDate: this.queryParam.endDate
      }).then(function (res) {
        if (res && res.status === 'ok') {
          _this10.applyMetrics(res.data || {});
        } else {
          _this10.resetMetrics();
        }
      }).catch(function () {
        _this10.resetMetrics();
      }).finally(function () {
        _this10.searchLoading = false;
      });
    },
    exportOverview: function exportOverview() {
      var _this11 = this;

      this.overviewExportLoading = true;
      this.downloadExcel('/tch/hr-metrics-export', {
        startDate: this.queryParam.startDate,
        endDate: this.queryParam.endDate
      }, fileNameWithRange('人事看板', this.queryParam.startDate, this.queryParam.endDate)).finally(function () {
        _this11.overviewExportLoading = false;
      });
    },
    exportCurrent: function exportCurrent() {
      if (this.showDetail) {
        this.exportDetail();
      } else {
        this.exportTrend();
      }
    },
    exportTrend: function exportTrend() {
      var _this12 = this;

      var names = {
        leaveRate: '请假率区间',
        resignRate: '离职率区间',
        fullAttendanceRate: '全勤率区间',
        teacherLateRate: '老师迟到率区间',
        teacherEarlyRate: '老师早退率区间',
        returnLessonHours: '返课时数区间',
        refundStudentCount: '退费学生数区间',
        demoAttendDealRate: 'Demo出席成交率区间',
        attendLessonRate: '上课率区间',
        lessonLeaveRate: '课节请假率区间',
        tempLeaveRate: '临时请假率区间',
        lateRate: '迟到率区间',
        earlyRate: '早退率区间'
      };
      this.exportLoading = true;
      this.downloadExcel('/tch/hr-metrics-trend-export', this.withStudyAdviser({
        metric: this.trendMetric,
        periodType: this.trendPeriodType,
        startDate: this.trendQuery.startDate,
        endDate: this.trendQuery.endDate
      }, this.selectedTrendStudyAdviserId()), fileNameWithRange(names[this.trendMetric] || '人事看板区间', this.trendQuery.startDate, this.trendQuery.endDate)).finally(function () {
        _this12.exportLoading = false;
      });
    },
    exportDetail: function exportDetail() {
      var _this13 = this;

      var names = {
        leaveRate: { numerator: '请假老师明细', denominator: '有课老师明细' },
        resignRate: { numerator: '离职老师明细', denominator: '月初在职老师明细' },
        fullAttendanceRate: { numerator: '全勤外教明细', denominator: '有课老师明细', nonFull: '未全勤老师明细', nonFullLessons: '异常课节明细' },
        teacherLateRate: { numerator: '迟到老师明细', denominator: '正常上课老师明细' },
        teacherEarlyRate: { numerator: '早退老师明细', denominator: '正常上课老师明细' },
        returnLessonHours: { numerator: '返课记录明细' },
        refundStudentCount: { numerator: '退费学生明细' },
        demoAttendDealRate: { numerator: '成交学生明细', denominator: '出席学生明细' },
        attendLessonRate: { numerator: '已上课课节明细', denominator: '买断临时课节明细' },
        lessonLeaveRate: { numerator: '全部请假或老师缺席明细', denominator: '应上课课节明细' },
        tempLeaveRate: { numerator: '临时请假失联取消课或缺席明细', denominator: '应上课课节明细' },
        lateRate: { numerator: '迟到课节明细', denominator: '正常上课课节明细' },
        earlyRate: { numerator: '早退课节明细', denominator: '正常上课课节明细' }
      };
      var file = fileNameWithRange((names[this.trendMetric] || {})[this.detailField] || '人事看板明细', this.detailStartDate, this.detailEndDate);
      var detailQuery = {
        metric: this.trendMetric,
        field: this.detailField,
        startDate: this.detailStartDate,
        endDate: this.detailEndDate,
        tchId: this.detailTchId
      };
      var studyAdviserId = this.selectedStudyAdviserId();
      if (studyAdviserId) {
        detailQuery.studyAdviserId = studyAdviserId;
      }
      if ((this.trendMetric === 'lateRate' || this.trendMetric === 'earlyRate') && this.detailField === 'numerator') {
        detailQuery.withDuration = 1;
      }
      this.exportLoading = true;
      this.downloadExcel('/tch/hr-metrics-trend-detail-export', detailQuery, file).finally(function () {
        _this13.exportLoading = false;
      });
    },
    downloadExcel: function downloadExcel(url, data, filename) {
      var _this14 = this;

      return this.$http({
        method: 'post',
        url: url,
        data: data,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response && response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else {
          _this14.$Message.error('导出失败');
        }
      }).catch(function () {
        _this14.$Message.error('导出失败');
      });
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchInsertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingInsertTch: false,
      countryList: null,
      tchParam: {
        type: 1,
        status: 0,
        country: 'Nationallity',
        sex: 1,
        password: '',
        category: 0,
        isAudition: '',
        tchType: 0,
        areaNum: '',
        salary: ''
      },
      ruleTch: {
        firstName: [{ type: 'string', required: true, message: '名字不能为空', trigger: 'blur' }, { type: 'string', max: 20, message: '名字不要超过20个字符', trigger: 'blur' }],
        lastName: [{ type: 'string', max: 20, message: '姓氏不要超过20个字符', trigger: 'blur' }],
        areaNum: [{ type: 'number', required: true, message: '请选择区号', trigger: 'blur' }],
        account: [{ required: true, message: '手机不能为空', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value === '') {
              callback(errors);
              return;
            }
            var telNumber = '';
            var num = parseInt(self.tchParam.areaNum);
            if (num === 86) {
              telNumber = value;
            } else {
              telNumber = '00' + num + '-' + value;
            }
            if (!telNumber) {
              return;
            }
            self.$http.post('/tch/queryByEmail?account=' + telNumber).then(function (res) {
              if (res && res.data) {
                errors.push('手机号已存在');
              }
              callback(errors);
              return;
            }).catch(function (e) {
              errors.push('系统异常');
              callback(errors);
              return;
            });
          }
        }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }, { type: 'string', min: 6, max: 16, message: '密码应为6到16位的字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    onAreaNumChange: function onAreaNumChange(val) {
      if (val) {
        this.tchParam.areaNum = val;
      }
    },
    insert: function insert() {
      var self = this;
      self.loadingInsertTch = true;
      self.$refs.tchForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsertTch = false;
          return;
        }
        self.$http.post('/tch/bopsInsert', self.tchParam).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          }
          self.visible = false;
        }).catch(function (e) {
          self.loadingInsertTch = false;
        });
      });
    },
    loadCountry: function loadCountry() {
      var self = this;
      if (self.countryList) {
        return;
      }
      self.$http.get('/country/list').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.countryList = res.data;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.loadCountry();
        this.$refs['tchForm'].resetFields();
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_FilePreview__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_FilePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_FilePreview__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FilePreview: __WEBPACK_IMPORTED_MODULE_1__components_common_FilePreview___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      saveLoading: false,
      reload: 0,
      showModal: false,
      showFolderModal: false,
      folderSaving: false,
      folderForm: { title: '', status: 1 },
      folderTrail: [],
      currentParentId: 0,
      editingFolder: false,
      previewVisible: false,
      previewUrl: '',
      previewType: '',
      previewFileName: '',
      tchList: [],
      defaultFileList: [],
      queryParam: {
        title: '',
        status: null,
        parentId: 0
      },
      formData: this.emptyForm(),
      formRules: {
        title: [{ required: true, message: '请输入标题' }],
        fileUrl: [{ required: true, message: '请上传文件' }]
      },
      title: [{
        title: '标题',
        minWidth: 180,
        render: function render(h, params) {
          var row = params.row;
          if (_this.isFolder(row)) {
            return h('a', {
              attrs: { href: 'javascript:void(0)' },
              style: { fontWeight: 'bold' },
              on: { click: function click() {
                  return _this.goFolder(row.id);
                } }
            }, '[文件夹] ' + (row.title || ''));
          }
          return h('span', row.title || '');
        }
      }, {
        title: '文件',
        minWidth: 160,
        render: function render(h, params) {
          var row = params.row;
          if (_this.isFolder(row)) {
            return h('span', '—');
          }
          var name = row.fileName || '查看文件';
          return h('div', [h('a', {
            attrs: { href: 'javascript:void(0)' },
            on: { click: function click() {
                return _this.previewOrDownload(row);
              } }
          }, name)]);
        }
      }, {
        title: '可见范围',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          if (_this.isFolder(row)) return h('span', '—');
          if (row.visibleType === 1) {
            var n = row.tchIds && row.tchIds.length ? row.tchIds.length : 0;
            return h('span', '指定老师(' + n + ')');
          }
          return h('span', _this.visibleTypeText(row.visibleType));
        }
      }, {
        title: '有效期',
        minWidth: 240,
        render: function render(h, params) {
          if (_this.isFolder(params.row)) return h('span', '—');
          return h('span', _this.formatValidity(params.row));
        }
      }, {
        title: '弹窗',
        minWidth: 180,
        render: function render(h, params) {
          if (_this.isFolder(params.row)) return h('span', '—');
          return h('span', _this.formatPopupPeriods(params.row));
        }
      }, { title: '状态', width: 90, key: 'statusText' }, { title: '创建人', width: 110, key: 'creatorName' }, { title: '创建时间', minWidth: 160, key: 'gmtCreate' }, {
        title: '操作',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          var btns = [];
          if (row.statusText === '启用') {
            btns.push(h('Button', {
              props: { type: 'warning', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 0);
                } }
            }, '停用'));
          } else {
            btns.push(h('Button', {
              props: { type: 'success', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 1);
                } }
            }, '启用'));
          }
          btns.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.openModal(row);
              } }
          }, '编辑'));
          return h('div', btns);
        }
      }]
    };
  },
  created: function created() {
    this.loadTchList();
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        parentId: this.currentParentId || 0,
        title: '',
        fileUrl: '',
        fileName: '',
        fileType: '',
        visibleType: 0,
        tchIds: [],
        effectDays: 0,
        status: 1,
        popupPeriods: []
      };
    },
    isFolder: function isFolder(row) {
      return !!(row && (row.nodeType === 2 || row.node_type === 2));
    },
    openFolderModal: function openFolderModal() {
      this.folderForm = { title: '', status: 1 };
      this.showFolderModal = true;
    },
    onSaveFolder: function onSaveFolder() {
      var title = (this.folderForm.title || '').trim();
      if (!title) {
        this.$Message.warning('请输入文件夹名称');
        return;
      }
      var self = this;
      self.folderSaving = true;
      self.$http.post('/tchLearningMaterial/mkdir', {
        parentId: self.currentParentId || 0,
        title: title,
        status: self.folderForm.status
      }).then(function (res) {
        self.folderSaving = false;
        if (res.status === 'ok') {
          self.$Message.success('创建成功');
          self.showFolderModal = false;
          self.search();
        }
      }).catch(function () {
        self.folderSaving = false;
      });
    },
    goFolder: function goFolder(id) {
      var parentId = id == null ? 0 : id;
      this.currentParentId = parentId;
      this.queryParam.parentId = parentId;
      this.loadBreadcrumb(parentId);
      this.search();
    },
    loadBreadcrumb: function loadBreadcrumb(parentId) {
      var self = this;
      if (!parentId) {
        self.folderTrail = [];
        return;
      }
      self.$http.get('/tchLearningMaterial/breadcrumb', { params: { parentId: parentId } }).then(function (res) {
        var list = res.data || [];
        self.folderTrail = list.filter(function (item) {
          return item && item.id;
        });
      });
    },
    loadTchList: function loadTchList() {
      var self = this;
      self.$http.get('/tch/listByCondition?tchType=1').then(function (res) {
        var foreignList = res.data || [];
        self.$http.get('/tch/listByCondition?tchType=2').then(function (res2) {
          var chineseList = res2.data || [];
          self.tchList = self.mergeTchList(foreignList, chineseList);
        });
      });
    },
    mergeTchList: function mergeTchList(listA, listB) {
      var merged = [];
      var seen = {};
      var all = (listA || []).concat(listB || []);
      all.forEach(function (item) {
        if (item && item.id != null && !seen[item.id]) {
          seen[item.id] = true;
          merged.push(item);
        }
      });
      return merged;
    },
    visibleTypeText: function visibleTypeText(visibleType) {
      if (visibleType === 2) return '欧美外教';
      if (visibleType === 3) return '菲教';
      if (visibleType === 4) return '中教';
      return '全部老师';
    },
    addPopupPeriod: function addPopupPeriod() {
      this.formData.popupPeriods.push({ startDate: null, endDate: null, freq: 1 });
    },
    removePopupPeriod: function removePopupPeriod(index) {
      this.formData.popupPeriods.splice(index, 1);
    },
    normalizePopupPeriods: function normalizePopupPeriods(list) {
      var self = this;
      var result = [];
      var source = list || [];
      source.forEach(function (item) {
        result.push({
          startDate: self.parseDayToDate(item.startDate),
          endDate: self.parseDayToDate(item.endDate),
          freq: item.freq === 2 ? 2 : 1
        });
      });
      return result;
    },
    parseDayToDate: function parseDayToDate(value) {
      var day = this.toDayString(value);
      if (!day) return null;
      var parts = day.split('-');
      return new Date(parts[0], parts[1] - 1, parts[2]);
    },
    toDayString: function toDayString(value) {
      if (!value) return '';
      if (value instanceof Date) {
        var pad = function pad(v) {
          return (v < 10 ? '0' : '') + v;
        };
        return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate());
      }
      var m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
      return m ? m[1] + '-' + m[2] + '-' + m[3] : '';
    },
    buildPopupPeriods: function buildPopupPeriods() {
      var self = this;
      var result = [];
      var source = this.formData.popupPeriods || [];
      source.forEach(function (item) {
        result.push({
          startDate: self.toDayString(item.startDate),
          endDate: self.toDayString(item.endDate),
          freq: item.freq === 2 ? 2 : 1
        });
      });
      return result;
    },
    validatePopupPeriods: function validatePopupPeriods() {
      var self = this;
      var source = this.formData.popupPeriods || [];
      var rows = source.map(function (item) {
        return {
          start: self.toDayString(item.startDate),
          end: self.toDayString(item.endDate)
        };
      });
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].start || !rows[i].end) {
          return '请选择弹窗周期的开始日期和结束日期';
        }
        if (rows[i].start > rows[i].end) {
          return '弹窗周期开始日期不能晚于结束日期';
        }
      }
      for (var _i = 0; _i < rows.length; _i++) {
        for (var j = _i + 1; j < rows.length; j++) {
          if (rows[_i].start <= rows[j].end && rows[j].start <= rows[_i].end) {
            return '弹窗周期不能重叠';
          }
        }
      }
      return '';
    },
    formatPopupPeriods: function formatPopupPeriods(row) {
      var list = row && row.popupPeriods || [];
      if (!list.length) {
        return row.popupOnce ? '默认一次' : '不弹';
      }
      if (list.length === 1) {
        var p = list[0];
        var freqText = p.freq === 2 ? '每周' : '每天';
        return freqText + ' ' + this.toDayString(p.startDate) + ' 至 ' + this.toDayString(p.endDate);
      }
      return list.length + ' 段';
    },
    buildSavePayload: function buildSavePayload() {
      var f = this.formData;
      return {
        id: f.id,
        parentId: f.parentId != null ? f.parentId : this.currentParentId || 0,
        title: f.title,
        fileUrl: f.fileUrl,
        fileName: f.fileName,
        fileType: f.fileType,
        visibleType: f.visibleType,
        tchIds: f.tchIds,
        effectDays: f.effectDays,
        status: f.status,
        popupPeriods: this.buildPopupPeriods()
      };
    },
    openModal: function openModal(row) {
      this.editingFolder = !!(row && this.isFolder(row));
      if (row) {
        this.formData = {
          id: row.id,
          parentId: row.parentId != null ? row.parentId : this.currentParentId || 0,
          title: row.title,
          fileUrl: this.normalizeHttpsUrl(row.fileUrl),
          fileName: row.fileName,
          fileType: row.fileType,
          visibleType: row.visibleType == null ? 0 : row.visibleType,
          tchIds: row.tchIds ? row.tchIds.slice() : [],
          effectDays: row.effectDays || 0,
          status: row.status == null ? 1 : row.status,
          popupPeriods: this.normalizePopupPeriods(row.popupPeriods)
        };
        var httpsUrl = this.normalizeHttpsUrl(row.fileUrl);
        this.defaultFileList = httpsUrl ? [{ name: row.fileName || httpsUrl, url: httpsUrl, status: 'finished' }] : [];
      } else {
        this.formData = this.emptyForm();
        this.defaultFileList = [];
      }
      this.showModal = true;
    },
    onFileChange: function onFileChange(files) {
      if (files && files.length) {
        this.formData.fileUrl = this.normalizeHttpsUrl(files[0].url);
        this.formData.fileName = files[0].name;
        this.formData.fileType = this.guessType(files[0].name || files[0].url);
      } else {
        this.formData.fileUrl = '';
        this.formData.fileName = '';
        this.formData.fileType = '';
      }
    },
    onSave: function onSave() {
      if (!this.formData.title) {
        this.$Message.warning('请输入标题');
        return;
      }
      if (!this.editingFolder && !this.formData.fileUrl) {
        this.$Message.warning('请上传文件');
        return;
      }
      if (!this.editingFolder && this.formData.visibleType === 1 && (!this.formData.tchIds || !this.formData.tchIds.length)) {
        this.$Message.warning('请选择指定老师');
        return;
      }
      if (!this.editingFolder) {
        var periodError = this.validatePopupPeriods();
        if (periodError) {
          this.$Message.warning(periodError);
          return;
        }
      }
      var self = this;
      self.saveLoading = true;
      self.$http.post('/tchLearningMaterial/save', {}, {
        transformRequest: [function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.buildSavePayload());
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.saveLoading = false;
        if (res.status === 'ok') {
          self.$Message.success('保存成功');
          self.showModal = false;
          self.search();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    changeStatus: function changeStatus(row, status) {
      var self = this;
      self.$http.post('/tchLearningMaterial/updateStatus', { id: row.id, status: status }).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('操作成功');
          self.search();
        }
      });
    },
    previewOrDownload: function previewOrDownload(row) {
      var type = this.resolveType(row);
      if (this.isPreviewable(type) || !!this.rowFileUrl(row)) {
        this.previewType = type;

        this.previewUrl = this.normalizeHttpsUrl(this.rowFileUrl(row));
        this.previewFileName = row.fileName || this.rowFileUrl(row) || '';
        this.previewVisible = true;
      } else {
        var url = this.rowFileUrl(row);
        if (url) window.open(url, '_blank');
      }
    },
    isPreviewable: function isPreviewable(t) {
      return ['image', 'video', 'audio', 'pdf', 'office', 'csv'].indexOf(t) >= 0;
    },
    resolveType: function resolveType(row) {
      var fromUrl = this.guessType(this.rowFileUrl(row));
      if (this.isPreviewable(fromUrl)) {
        return fromUrl;
      }
      var fromName = this.guessType(row && row.fileName || '');
      if (this.isPreviewable(fromName)) {
        return fromName;
      }
      var t = (row && (row.fileType || row.file_type) || '').toLowerCase();
      if (t === 'text/csv' || t === 'xls' || t === 'xlsx') {
        return 'csv';
      }
      if (t === 'doc' || t === 'docx' || t === 'ppt' || t === 'pptx') {
        return 'office';
      }
      if (this.isPreviewable(t)) {
        return t;
      }
      return fromUrl || fromName || t;
    },
    rowFileUrl: function rowFileUrl(row) {
      if (!row) return '';
      return row.fileUrl || row.file_url || '';
    },
    normalizeHttpsUrl: function normalizeHttpsUrl(url) {
      if (!url) return url;
      var s = String(url).trim();
      if (!s) return url;

      if (/^https:\/\//i.test(s)) return s;
      if (/^http:\/\//i.test(s)) return 'https://' + s.substring(7);
      if (s.indexOf('//') === 0) return 'https:' + s;
      if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}(:\d+)?(\/|$)/i.test(s)) return 'https://' + s;
      if (s.charAt(0) === '/') return 'https://medias.kouyujie.cn' + s;
      return 'https://medias.kouyujie.cn/' + s;
    },
    guessType: function guessType(name) {
      if (!name) return '';
      var lower = String(name).toLowerCase();
      var path = lower.split('?')[0].split('#')[0];
      if (path === 'text/csv') return 'csv';
      var ext = path.split('.').pop();
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].indexOf(ext) >= 0) return 'image';
      if (['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v'].indexOf(ext) >= 0) return 'video';
      if (['mp3', 'wav', 'aac', 'ogg', 'm4a'].indexOf(ext) >= 0) return 'audio';
      if (ext === 'pdf') return 'pdf';
      if (['doc', 'docx', 'ppt', 'pptx'].indexOf(ext) >= 0) return 'office';
      if (['csv', 'xls', 'xlsx'].indexOf(ext) >= 0) return 'csv';
      return ext;
    },
    formatValidity: function formatValidity(row) {
      var d = row && row.effectDays;
      if (d == null || d === '' || d <= 0) {
        return '永久有效';
      }
      var start = this.parseEnableDate(row.enableTime);
      if (!start) {
        return '启用后' + d + '天';
      }
      var end = this.addCalendarDays(start, d);
      return this.formatDayStart(start) + ' 至 ' + this.formatDayStart(end);
    },
    parseEnableDate: function parseEnableDate(enableTime) {
      if (!enableTime) return null;
      var m = String(enableTime).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return null;
      return { y: +m[1], mo: +m[2], d: +m[3] };
    },
    addCalendarDays: function addCalendarDays(ymd, n) {
      var dt = new Date(Date.UTC(ymd.y, ymd.mo - 1, ymd.d + n));
      return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
    },
    formatDayStart: function formatDayStart(ymd) {
      var pad = function pad(v) {
        return (v < 10 ? '0' : '') + v;
      };
      return ymd.y + '-' + pad(ymd.mo) + '-' + pad(ymd.d) + ' 00:00';
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLeaveLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number,
      default: null
    },
    startTime: {
      type: Number,
      default: null
    },
    endTime: {
      type: Number,
      default: null
    },
    lsnSelStatus: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      visible: this.value,
      bookLessonOpenedList: [],
      tchLeaveLessonColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('br', '  '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '老师账号',
        width: 100,
        key: 'tchEmail'
      }, {
        title: '外教运营',
        width: 90,
        key: 'tchStudyAdviserNickname'
      }, {
        title: '学顾',
        width: 90,
        key: 'studyAdviserNickname'
      }, {
        title: '课程类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        key: 'lessonTitle'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '是否代课',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var oldTch = params.row.oldOpenedId;
          if (oldTch > 0) {
            return h('div', '是');
          } else {
            return h('div', '否');
          }
        }
      }],
      tchLeaveLessonList: []
    };
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.bookLessonOpenedList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    loadTchLeaveLesson: function loadTchLeaveLesson() {
      var self = this;
      var params = {};
      params.tchId = this.tchId;
      params.startTime = this.startTime;
      params.endTime = this.endTime;
      params.lsnSelStatus = this.lsnSelStatus;

      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.bookLessonOpenedList = res.data;
        self.loadMonthRankScores();
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.bookLessonOpenedList = [];
        this.loadTchLeaveLesson();
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchLeaveLessonModal_vue__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchLeaveLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchLeaveLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TchLeaveLessonModal: __WEBPACK_IMPORTED_MODULE_0__TchLeaveLessonModal_vue___default.a, TchInfoModal: __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var self = this;
    return {
      editModal: false,
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      exportLoading: false,
      reload: 0,
      leavlId: null,
      leaveType: null,
      showTchInfoModal: false,
      tchId: null,
      showModifyLeaveTimeModal: false,
      leaveTimeChangeParam: {
        startLeaveTimeDate: '',
        endLeaveTimeDate: '',
        startLeaveTime: 0,
        endLeaveTime: 0,
        leaveType: null,
        endTime: 0,
        maxLeaveLessonTime: 0
      },
      bookLessonOpenedList: [],
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        leaveType: null
      },
      studyAdviserList: [],
      modifyLeaveTimeRule: {
        endTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (!self.leaveTimeChangeParam.endTime) {
              errors.push('选择的时间不能为空！');
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime * 1000 < new Date().getTime()) {
              errors.push('所选时间不能小于当前时间！');
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime < self.leaveTimeChangeParam.maxLeaveLessonTime) {
              errors.push('所选时间不能小于：' + self.$moment(self.leaveTimeChangeParam.maxLeaveLessonTime, 'X').format('YYYY-MM-DD HH:mm'));
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime > self.leaveTimeChangeParam.endLeaveTime) {
              errors.push('所选时间不能大于：' + self.$moment(self.leaveTimeChangeParam.endLeaveTime, 'X').format('YYYY-MM-DD HH:mm'));
              callback(errors);
              return;
            }
            callback(errors);
          }
        }]
      },
      tchLeaveLessonColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('br', '  '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore,
            onClick: row.tchId ? function () {
              return _this.openTchInfoModal(row.tchId);
            } : null
          });
        }
      }, {
        title: '老师账号',
        width: 100,
        key: 'tchEmail'
      }, {
        title: '外教运营',
        width: 90,
        key: 'tchStudyAdviserNickname'
      }, {
        title: '学顾',
        width: 90,
        key: 'studyAdviserNickname'
      }, {
        title: '课程类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        key: 'lessonTitle'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var btns = [];
          var now = new Date().getTime();
          var startTime = params.row.lsnBeginTime;
          if (now / 1000 < startTime) {
            btns.push(h('a', {
              on: {
                click: function click() {
                  _this.onCancelLesson(params.row);
                }
              }
            }, '取消'));
          }
          return h('div', [btns]);
        }
      }],
      showTchLeaveLessonModal: false,
      tchLeaveLessonParam: {},
      title: [{
        title: '老师姓名',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, {
        title: '老师账号',
        key: 'tchEmail',
        width: 130,
        align: 'center'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm:ss') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '涉及课节',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onTchLeaveLesson(row);
              }
            }
          }, '查看')]);
        }
      }, {
        title: '涉及节数',
        width: 100,
        align: 'center',
        key: 'touchClassNum'
      }, {
        title: '操作人',
        width: 100,
        key: 'adminNickname'
      }, {
        title: '所属外管',
        width: 100,
        key: 'studyAdviserNickname'
      }, {
        title: '操作时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var updateTime = params.row.updateTime;
          return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '请假原因分类',
        width: 150,
        align: 'center',
        key: 'remarkType'
      }, {
        title: '请假原因',
        width: 150,
        align: 'center',
        key: 'remark'
      }, {
        title: '请假类型',
        width: 270,
        align: 'center',
        render: function render(h, params) {
          var tchLeaveType = params.row.leaveType;
          var tchLeaveTypeEnum = $constant.getEnum($constant.tchLeaveType, tchLeaveType);
          return h('div', tchLeaveTypeEnum && tchLeaveTypeEnum.text);
        }
      }, {
        title: '状态',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.tchLeaveStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 300,
        render: function render(h, params) {
          var btns = [h('a', {
            on: {
              click: function click() {
                _this.onEdit(params.row);
              }
            }
          }, '修改请假类型')];
          btns.push(h('span', ' | '));
          var status = params.row.status;
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          var now = new Date().getTime();

          if (status === 1 && now / 1000 < startTime) {
            btns.push(h('a', {
              on: {
                click: function click() {
                  _this.onCancel(params.row);
                }
              }
            }, '取消'));
          }
          if (status === 1 && now / 1000 > startTime && now / 1000 < endTime) {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.onModify(params.row);
                }
              }
            }, '修改请假时间')]);
          }
          return h('div', [btns]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {
    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-1, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    onEdit: function onEdit(row) {
      var self = this;
      self.leavlId = row.id;
      self.leaveType = row.leaveType;
      this.editModal = true;
    },
    edit: function edit() {
      var self = this;
      var path = '/bookTchLeaveTime/editType';
      self.$http.post(path, { id: self.leavlId, leaveType: self.leaveType }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('修改成功!');
          self.editModal = false;
          self.search();
        }
      });
    },
    onModifyLeaveEndTime: function onModifyLeaveEndTime() {
      var self = this;
      self.$refs.modifyTimeForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.$Modal.confirm({
          title: '提示',
          content: '是否确认修改改请假时间？',
          width: 300,
          okText: '确定修改',
          onOk: function onOk() {
            self.$http.post('/bookTchLeaveTime/modifyEndTime', self.leaveTimeChangeParam).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('修改成功!');
                self.showModifyLeaveTimeModal = false;
                self.search();
              } else {
                self.$Message.error(res.message);
              }
              self.$Modal.remove();
            });
          }
        });
      });
    },
    onModify: function onModify(row) {
      var self = this;
      self.leavlId = row.id;
      self.leaveTimeChangeParam.id = row.id;
      self.leaveTimeChangeParam.startLeaveTime = row.startTime;
      self.leaveTimeChangeParam.endLeaveTime = row.endTime;
      self.leaveTimeChangeParam.startLeaveTimeDate = self.$moment(row.startTime, 'X').format('YYYY-MM-DD HH:mm');
      self.leaveTimeChangeParam.endLeaveTimeDate = self.$moment(row.endTime, 'X').format('YYYY-MM-DD HH:mm');
      self.leaveTimeChangeParam.leaveType = row.leaveType;
      var params = {};
      params.tchId = row.tchId;
      params.startTime = row.startTime;
      params.endTime = row.endTime;
      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.showModifyLeaveTimeModal = true;
        self.bookLessonOpenedList = res.data;
        for (var j = 0; self.bookLessonOpenedList[j] != null; j++) {
          if (self.leaveTimeChangeParam.maxLeaveLessonTime < self.bookLessonOpenedList[j].lsnEndTime) {
            self.leaveTimeChangeParam.maxLeaveLessonTime = self.bookLessonOpenedList[j].lsnEndTime;
          }
        }
      });
    },
    newEndLeaveTimeChange: function newEndLeaveTimeChange(value) {
      this.leaveTimeChangeParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    onTchLeaveLesson: function onTchLeaveLesson(row) {
      this.tchLeaveLessonParam.tchId = row.tchId;
      this.tchLeaveLessonParam.startTime = row.startTime;
      this.tchLeaveLessonParam.endTime = row.endTime;
      this.tchLeaveLessonParam.lsnSelStatus = 6;
      this.showTchLeaveLessonModal = true;
    },
    onCancelLesson: function onCancelLesson(row) {
      var self = this;
      if (!row.id) {
        self.$Message.warning('刷新重新点击');
        return;
      }
      if (!self.leavlId) {
        self.$Message.warning('刷新重新点击');
        return;
      }
      self.$http.post('/bookTchLeaveTime/splitLeavlTime', {
        openId: row.id,
        leavlId: self.leavlId
      }).then(function (res) {
        if (res) {
          self.$Message.success('取消成功!');
          self.showModifyLeaveTimeModal = false;
          self.search();
        }
      });
    },
    onCancel: function onCancel(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定取消该次请假？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookTchLeaveTime/cancel', { id: row.id }).then(function (res) {
            if (res) {
              self.$Message.success('取消成功!');
              self.search();
            }
            self.$Modal.remove();
          });
        }
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookTchLeaveTime/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '老师请假列表.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number,
      default: false
    },
    substituteList: {
      type: [Array],
      default: []
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      visible: this.value,
      oldTch: null,
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '外教运营',
        width: 80,
        key: 'tchStudyAdviserNickname'
      }, {
        title: '学导',
        width: 80,
        key: 'studyAdviserNickname'
      }, {
        title: '课顾',
        width: 80,
        key: 'adviserNickname'
      }, {
        title: '课程类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        width: 180,
        key: 'lessonTitle'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '是否代课',
        width: 70,
        key: 'isProxy',
        render: function render(h, params) {
          var isProxy = params.row.isProxy;
          return h('div', isProxy === 1 ? '是' : '否');
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 72,
        render: function render(h, params) {
          _this.oldTch = params.row.oldOpenedId;
          var courseType = params.row.courseType;
          var isProxy = params.row.isProxy;
          if (courseType === 8) {
            if (isProxy === 1) {
              return h('a', { on: { click: function click() {
                    return _this.cancelProxyClass(params.row);
                  } } }, '取消代课');
            } else {
              return h('a', { on: { click: function click() {
                    return _this.proxyClass(params.row);
                  } } }, '代课');
            }
          }
        }
      }],
      bookLessonOpenedList: [],
      loadingSearch: false,
      loadingAdd: false,
      leaveParam: {
        leaveType: 1,
        startTime: '',
        remark: '',
        remarkType: '',
        endTime: ''
      },
      leaveRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];

            callback(errors);
          }
        }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        remark: [{ type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      startTime: '',
      endTime: '',
      remarkType: [{ type: 'string', required: true, message: '请填写请假原因类别', trigger: 'blur' }, { type: 'string', max: 100, message: '不知道就问主管', trigger: 'blur' }]
    };
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.bookLessonOpenedList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    add: function add() {
      var _this2 = this;

      var self = this;
      this.$refs.leaveForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.loadingAdd = true;
        var params = self.leaveParam;
        params.tchId = self.tchId;
        var tchList = [];
        _this2.substituteList.map(function (item) {
          if (item.isProxy === 1) {
            tchList.push({ id: item.id, tchId: item.substituteTchId });
          }
        });
        if (_this2.substituteList) {
          params.substituteListJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tchList);
        }
        self.$http.post('/bookTchLeaveTime/add', params).then(function (res) {
          self.loadingAdd = false;
          if (res && res.data > 0) {
            self.$Message.success('请假成功!');
            self.visible = false;
            this.substituteList = [];
          }
        }).catch(function (e) {
          self.loadingAdd = false;
        });
      });
    },
    startTimeChange: function startTimeChange(value) {
      this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeChange: function endTimeChange(value) {
      this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookLessonOpened: function onBookLessonOpened() {
      var self = this;
      var isNotError = true;
      this.$refs.leaveForm.validateField('startTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      this.$refs.leaveForm.validateField('endTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      var params = {};
      params.tchId = self.tchId;
      params.startTime = self.leaveParam.startTime;
      params.endTime = self.leaveParam.endTime;
      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.loadingSearch = false;
        if (res.data.length <= 0) {
          self.$Message.info('没有涉及任何课节!');
          self.bookLessonOpenedList = [];
          return;
        }
        self.bookLessonOpenedList = res.data;
        self.loadMonthRankScores();
        self.bookLessonOpenedList.map(function (item) {
          if (item.oldTch > 0) {
            item.isProxy = 1;
          } else {
            item.isProxy = 0;
          }
        });
      });
    },
    proxyClass: function proxyClass(row) {
      row.show = true;
      this.$emit('getProxyClassData', row);
    },
    cancelProxyClass: function cancelProxyClass(row) {
      this.$emit('getCancelProxyClassData', row);
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.startTime = '';
      this.endTime = '';
      this.leaveParam.startTime = '';
      this.leaveParam.endTime = '';
      this.leaveParam.remark = '';
      this.leaveParam.remarkType = '';
      this.leaveParam.leaveType = 1;
      this.bookLessonOpenedList = [];
      this.$emit('input', val);
    },
    substituteList: function substituteList(val) {
      console.log('val', val);
      this.bookLessonOpenedList = this.bookLessonOpenedList.map(function (item) {
        val.map(function (i) {
          if (item.id === i.id) {
            item = i;
          }
        });
      });
    }
  }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number,
      default: false
    },
    substituteList: {
      type: [Array],
      default: []
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      visible: this.value,
      oldTch: null,
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '外教运营',
        width: 80,
        key: 'tchStudyAdviserNickname'
      }, {
        title: '学导',
        width: 80,
        key: 'studyAdviserNickname'
      }, {
        title: '课顾',
        width: 80,
        key: 'adviserNickname'
      }, {
        title: '课程类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        width: 180,
        key: 'lessonTitle'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '是否代课',
        width: 70,
        key: 'isProxy',
        render: function render(h, params) {
          var isProxy = params.row.isProxy;
          return h('div', isProxy == 1 ? '是' : '否');
        }
      }, {
        title: '操作',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          _this.oldTch = params.row.oldOpenedId;
          var courseType = params.row.courseType;
          var isProxy = params.row.isProxy;
          if (courseType == 8) {
            if (isProxy == 1) {
              return h('a', { on: { click: function click() {
                    return _this.cancelProxyClass(params.row);
                  } } }, '取消代课');
            } else {
              return h('a', { on: { click: function click() {
                    return _this.proxyClass(params.row);
                  } } }, '代课');
            }
          }
        }
      }],
      bookLessonOpenedList: [],
      loadingSearch: false,
      loadingAdd: false,
      leaveParam: {
        leaveType: 9,
        startTime: '',
        remark: '离职请假',
        endTime: ''
      },
      leaveRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];

            callback(errors);
          }
        }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        remark: [{ type: 'string', required: true, message: '请填写离职原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      },
      startTime: '',
      endTime: ''
    };
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.bookLessonOpenedList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    add: function add() {
      var _this2 = this;

      var self = this;
      this.$refs.leaveForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        self.loadingAdd = true;
        var params = self.leaveParam;
        params.tchId = self.tchId;
        var tchList = [];
        _this2.substituteList.map(function (item) {
          if (item.isProxy === 1) {
            tchList.push({ id: item.id, tchId: item.substituteTchId });
          }
        });
        if (_this2.substituteList) {
          params.substituteListJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tchList);
        }
        self.$http.post('/bookTchLeaveTime/add', params).then(function (res) {
          self.loadingAdd = false;
          if (res && res.data > 0) {
            self.$Message.success('请假成功!');
            self.visible = false;
            this.substituteList = [];
          }
        }).catch(function (e) {
          self.loadingAdd = false;
        });
      });
    },
    startTimeChange: function startTimeChange(value) {
      this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeChange: function endTimeChange(value) {
      this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookLessonOpened: function onBookLessonOpened() {
      var self = this;
      var isNotError = true;
      this.$refs.leaveForm.validateField('startTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      this.$refs.leaveForm.validateField('endTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      var params = {};
      params.tchId = self.tchId;
      params.startTime = self.leaveParam.startTime;
      params.endTime = self.leaveParam.endTime;
      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.loadingSearch = false;
        if (res.data.length <= 0) {
          self.$Message.info('没有涉及任何课节!');
          self.bookLessonOpenedList = [];
          return;
        }
        self.bookLessonOpenedList = res.data;
        self.loadMonthRankScores();
        self.bookLessonOpenedList.map(function (item) {
          if (item.oldTch > 0) {
            item.isProxy = 1;
          } else {
            item.isProxy = 0;
          }
        });
      });
    },
    proxyClass: function proxyClass(row) {
      row.show = true;
      this.$emit('getProxyClassData', row);
    },
    cancelProxyClass: function cancelProxyClass(row) {
      this.$emit('getCancelProxyClassData', row);
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {}
      this.startTime = '';
      this.endTime = '';
      this.leaveParam.startTime = '';
      this.leaveParam.endTime = '';
      this.leaveParam.remark = '';
      this.leaveParam.leaveType = '';
      this.bookLessonOpenedList = [];
      this.$emit('input', val);
    },
    substituteList: function substituteList(val) {
      console.log('val', val);
      this.bookLessonOpenedList = this.bookLessonOpenedList.map(function (item) {
        val.map(function (i) {
          if (item.id === i.id) {
            item = i;
          }
        });
      });
    }
  }
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);




function pad(n) {
  return n < 10 ? '0' + n : '' + n;
}
function monthRange(d) {
  var y = d.getFullYear();
  var m = d.getMonth();
  var start = y + '-' + pad(m + 1) + '-01';
  var endDay = new Date(y, m + 1, 0).getDate();
  var end = y + '-' + pad(m + 1) + '-' + pad(endDay);
  return { startDate: start, endDate: end };
}
var RATE_KIND = {
  leave: {
    label: '请假率',
    numerator: '请假课节',
    denominator: '正常上课课节',
    metric: 'leaveRate',
    formula: '请假率：请假率 = 全部请假类型或老师缺席的课 ÷ 有课课节。分子是全部请假类型，或通话里老师缺席，不看迟到、早退。没有分母时显示 —。'
  },
  late: {
    label: '迟到率',
    numerator: '迟到课节',
    denominator: '正常上课课节',
    metric: 'lateRate',
    formula: '迟到率：迟到率 = 老师迟到的课 ÷ 正常上课的课。正常上课是指这节课已经上完，学生没有缺席，老师也没有缺席。分子只算这些课里面记了老师迟到的。一节课只算一次。没有通话记录时，按学生和老师都没缺席、老师也没迟到来算。没有正常上课课节时显示 —。'
  },
  early: {
    label: '早退率',
    numerator: '早退课节',
    denominator: '正常上课课节',
    metric: 'earlyRate',
    formula: '早退率：早退率 = 老师早退的课 ÷ 正常上课的课。分母和迟到率一样：已经上完，并且学生、老师都没有缺席。分子只算这些课里面记了老师早退的。一节课只算一次。没有通话记录时，按都没缺席、老师也没早退来算。没有正常上课课节时显示 —。'
  }
};
function rateKind(type) {
  return RATE_KIND[type] || RATE_KIND.leave;
}
function detailFieldTitle(type, field) {
  var kind = rateKind(type);
  var name = field === 'numerator' ? kind.numerator : kind.denominator;
  return name + '明细';
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLeaveRateList',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var now = new Date();
    var range = monthRange(now);
    return {
      monthDate: now,
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      showTchInfoModal: false,
      tchInfoId: null,
      dataList: [],
      totalCount: 0,
      searchedRateType: 'leave',
      tableSortKey: 0,
      queryParam: {
        pageIndex: 1,
        pageSize: 20,
        startDate: range.startDate,
        endDate: range.endDate,
        tchId: '',
        tchName: '',
        rateType: 'leave'
      },
      showDetailModal: false,
      detailLoading: false,
      detailExportLoading: false,
      detailList: [],
      detailTotal: 0,
      detailPageIndex: 1,
      detailPageSize: 20,
      detailTchId: null,
      detailTchName: '',
      detailField: '',
      detailRateType: 'leave',
      detailColumns: [{ title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, { title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170 }, { title: '类型', key: 'extra', align: 'center', minWidth: 140 }]
    };
  },

  computed: {
    rateFormula: function rateFormula() {
      return rateKind(this.searchedRateType).formula;
    },
    columns: function columns() {
      var self = this;
      var kind = rateKind(this.searchedRateType);
      return [{
        title: '老师',
        key: 'tchId',
        minWidth: 200,
        render: function render(h, params) {
          var row = params.row || {};
          var id = row.tchId == null ? '' : String(row.tchId);
          var name = row.nickname || '';
          var label = id;
          if (name) {
            label = id ? id + ' ' + name : name;
          }
          if (!id) {
            return h('span', label || '—');
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: label,
            score: row.monthRankScore,
            onClick: function onClick() {
              return self.openTchInfoModal(row.tchId);
            }
          });
        }
      }, {
        title: kind.label,
        key: 'leaveRate',
        width: 120,
        sortable: 'custom',
        sortType: self.queryParam.sortProperty === 'leaveRate' ? self.queryParam.sortDirection : ''
      }, {
        title: kind.numerator,
        key: 'leaveNumerator',
        width: 120,
        sortable: 'custom',
        sortType: self.queryParam.sortProperty === 'leaveNumerator' ? self.queryParam.sortDirection : '',
        render: function render(h, params) {
          var val = params.row.leaveNumerator;
          var num = val == null ? 0 : Number(val);
          if (num > 0) {
            return h('a', {
              attrs: { href: 'javascript:;' },
              on: {
                click: function click() {
                  self.openDetail(params.row, 'numerator');
                }
              }
            }, String(num));
          }
          return h('span', String(num));
        }
      }, {
        title: kind.denominator,
        key: 'leaveDenominator',
        width: 140,
        render: function render(h, params) {
          var val = params.row.leaveDenominator;
          var num = val == null ? 0 : Number(val);
          if (num > 0) {
            return h('a', {
              attrs: { href: 'javascript:;' },
              on: {
                click: function click() {
                  self.openDetail(params.row, 'denominator');
                }
              }
            }, String(num));
          }
          return h('span', String(num));
        }
      }];
    },
    detailModalTitle: function detailModalTitle() {
      var fieldName = detailFieldTitle(this.detailRateType, this.detailField);
      var name = this.detailTchName || '';
      var id = this.detailTchId == null ? '' : String(this.detailTchId);
      var who = name ? name + '（' + id + '）' : id;
      return who ? who + ' · ' + fieldName : fieldName;
    }
  },
  mounted: function mounted() {
    this.search();
  },

  methods: {
    onMonthChange: function onMonthChange(val) {
      var d = val ? new Date(val + '-01') : new Date();
      if (isNaN(d.getTime())) {
        d = new Date();
      }
      this.monthDate = d;
      var range = monthRange(d);
      this.queryParam.startDate = range.startDate;
      this.queryParam.endDate = range.endDate;
    },
    reset: function reset() {
      var now = new Date();
      this.monthDate = now;
      var range = monthRange(now);
      this.queryParam = {
        pageIndex: 1,
        pageSize: 20,
        startDate: range.startDate,
        endDate: range.endDate,
        tchId: '',
        tchName: '',
        rateType: 'leave',
        sortProperty: '',
        sortDirection: ''
      };
      this.tableSortKey = this.tableSortKey + 1;
      this.search();
    },
    onSortChange: function onSortChange(column) {
      var nextProp = '';
      var nextDir = '';
      if (column && column.order && column.order !== 'normal') {
        nextProp = column.key || '';
        nextDir = column.order;
      }
      if ((this.queryParam.sortProperty || '') === nextProp && (this.queryParam.sortDirection || '') === nextDir) {
        return;
      }
      this.queryParam.sortProperty = nextProp;
      this.queryParam.sortDirection = nextDir;
      this.queryParam.pageIndex = 1;
      this.search(false);
    },
    onPageChange: function onPageChange(page) {
      this.queryParam.pageIndex = page;
      this.search(false);
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.queryParam.pageSize = size;
      this.queryParam.pageIndex = 1;
      this.search(false);
    },
    buildListParams: function buildListParams(withPage) {
      var params = {
        startDate: this.queryParam.startDate,
        endDate: this.queryParam.endDate,
        rateType: this.queryParam.rateType || 'leave'
      };
      if (withPage !== false) {
        params.pageIndex = this.queryParam.pageIndex;
        params.pageSize = this.queryParam.pageSize;
      }
      if (this.queryParam.tchId) {
        params.tchId = Number(this.queryParam.tchId);
      }
      if (this.queryParam.tchName) {
        params.tchName = this.queryParam.tchName;
      }
      if (this.queryParam.sortProperty && this.queryParam.sortDirection) {
        params.sortProperty = this.queryParam.sortProperty;
        params.sortDirection = this.queryParam.sortDirection;
      }
      return params;
    },
    search: function search(resetPage) {
      if (resetPage !== false) {
        this.queryParam.pageIndex = 1;
      }
      var self = this;
      var params = self.buildListParams();
      var rateType = params.rateType;
      self.searchLoading = true;
      self.$http.post('/tch/leave-rate/list', params).then(function (res) {
        self.searchLoading = false;
        self.searchedRateType = rateType;
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
          self.loadMonthRankScores();
        } else {
          self.dataList = [];
          self.totalCount = 0;
        }
      }).catch(function () {
        self.searchLoading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.dataList || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    exportList: function exportList() {
      var self = this;
      if (!self.queryParam.startDate || !self.queryParam.endDate) {
        self.$Message.error('请先选择统计月份');
        return;
      }
      var params = self.buildListParams(false);
      var kind = rateKind(params.rateType);
      var file = '在职老师' + kind.label + '_' + self.queryParam.startDate + '_' + self.queryParam.endDate + '.xlsx';
      self.exportLoading = true;
      self.downloadExcel('/tch/leave-rate/list-export', params, file).finally(function () {
        self.exportLoading = false;
      });
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    openDetail: function openDetail(row, field) {
      if (!row || !row.tchId) {
        return;
      }
      this.detailTchId = row.tchId;
      this.detailTchName = row.nickname || '';
      this.detailField = field;
      this.detailRateType = this.searchedRateType || 'leave';
      this.detailPageIndex = 1;
      this.detailList = [];
      this.detailTotal = 0;
      this.showDetailModal = true;
      this.loadDetail();
    },
    onDetailPageChange: function onDetailPageChange(page) {
      this.detailPageIndex = page;
      this.loadDetail();
    },
    onDetailPageSizeChange: function onDetailPageSizeChange(size) {
      this.detailPageSize = size;
      this.detailPageIndex = 1;
      this.loadDetail();
    },
    loadDetail: function loadDetail() {
      var self = this;
      if (!self.detailTchId || !self.detailField || !self.queryParam.startDate || !self.queryParam.endDate) {
        self.detailList = [];
        self.detailTotal = 0;
        return;
      }
      var kind = rateKind(self.detailRateType);
      self.detailLoading = true;
      self.$http.post('/tch/hr-metrics-trend-detail', {
        metric: kind.metric,
        field: self.detailField,
        startDate: self.queryParam.startDate,
        endDate: self.queryParam.endDate,
        tchId: self.detailTchId,
        pageIndex: self.detailPageIndex,
        pageSize: self.detailPageSize
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.detailList = res.data.data || [];
          self.detailTotal = res.data.totalCount || 0;
        } else {
          self.detailList = [];
          self.detailTotal = 0;
          self.$Message.error(res && res.msg || '明细加载失败');
        }
      }).catch(function () {
        self.detailList = [];
        self.detailTotal = 0;
        self.$Message.error('明细加载失败');
      }).finally(function () {
        self.detailLoading = false;
      });
    },
    exportDetail: function exportDetail() {
      var self = this;
      if (!self.detailTchId || !self.detailField || !self.queryParam.startDate || !self.queryParam.endDate) {
        self.$Message.error('请先打开课节明细');
        return;
      }
      var kind = rateKind(self.detailRateType);
      var fieldName = detailFieldTitle(self.detailRateType, self.detailField);
      var file = fieldName + '_' + self.detailTchId + '_' + self.queryParam.startDate + '_' + self.queryParam.endDate + '.xlsx';
      self.detailExportLoading = true;
      self.downloadExcel('/tch/hr-metrics-trend-detail-export', {
        metric: kind.metric,
        field: self.detailField,
        startDate: self.queryParam.startDate,
        endDate: self.queryParam.endDate,
        tchId: self.detailTchId
      }, file).finally(function () {
        self.detailExportLoading = false;
      });
    },
    downloadExcel: function downloadExcel(url, data, filename) {
      var self = this;
      return self.$http({
        method: 'post',
        url: url,
        data: data,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response && response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else {
          self.$Message.error('导出失败');
        }
      }).catch(function () {
        self.$Message.error('导出失败');
      });
    }
  }
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchLessonLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    openedId: {
      type: Number
    },
    title: {
      type: String,
      default: false
    },
    beginTime: {
      type: Number,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      formData: {
        remark: '',
        leaveType: 1,
        beginTime: '',
        title: ''
      },
      loadingAdd: false,
      rule: {
        remark: [{ type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    onTchLeave: function onTchLeave() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        self.formData.openedId = self.openedId;
        self.$http.post('/bookTchLeaveTime/addByOpenedId', self.formData).then(function (res) {
          self.loadingAdd = false;
          if (res) {
            self.$Message.success('请假成功!');
            self.visible = false;
            self.successCallback();
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.formData.remark = '';
      }
      this.$emit('input', val);
    },
    title: function title(val) {
      this.formData.title = val;
    },
    beginTime: function beginTime(val) {
      var $moment = this.$moment;
      this.formData.beginTime = $moment(val, 'X').format('YYYY-MM-DD HH:mm');
    }
  }
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SendEmailModal: __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect___default.a
  },
  name: 'tchNormalList',
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      reviewParam: {
        ids: '',
        remark: ''
      },
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      loadingReject: false,
      showRejectModal: false,
      showBatchReviewModal: false,
      rejectParam: {
        id: '',
        remark: ''
      },
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '原来的外教运营',
        render: function render(h, params) {
          return h('span', params.row.oldNickname || '');
        }
      }, {
        title: '新的外教运营',
        render: function render(h, params) {
          return h('span', params.row.newNickname || '');
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }],
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        tchKey: '',
        sex: '',
        accent: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: '',
        channel: '',
        regFrom: '',
        excellent: '',
        startCreateDate: '',
        endCreateDate: ''
      },
      channelOptions: [],
      excellentOptions: ['是', '否'],
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: $constant.teacherCategory.filter(function (item) {
        return [1, 2, 3].includes(item.code);
      }),
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: '',
        substituteTchId: ''
      },
      title: [{
        title: '老师ID',
        width: 80,
        fixed: 'left',
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 150,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
        }
      }, {
        title: 'Full Name',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.fullName,
              placeholder: 'Full Name'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.fullName) {
                  row.fullName = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, fullName: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.fullName) {
                  row.fullName = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, fullName: value } });
                }
              }
            }
          });
        }
      }, {
        title: '真实国籍',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var countryCode = row.nationality ? row.nationality.toLowerCase() : '';
          return h('div', {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }, [countryCode ? h('span', {
            attrs: {
              class: 'fi fi-' + countryCode
            },
            style: {
              marginRight: '8px',
              fontSize: '18px'
            }
          }) : null, h('Input', {
            attrs: {
              title: row.nationality || '' },
            props: {
              value: row.nationality,
              placeholder: '真实国籍'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.nationality) {
                  row.nationality = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, nationality: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.nationality) {
                  row.nationality = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, nationality: value } });
                }
              }
            }
          })]);
        }
      }, {
        title: '现居地',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.address || '' },
            props: {
              value: row.address,
              placeholder: 'address',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.address) {
                  row.address = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, address: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.address) {
                  row.address = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, address: value } });
                }
              }
            }
          });
        }
      }, {
        title: '风险地区',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var level = Number(params.row.riskRegionLevel);
          if (level === 1) {
            return h('Tag', { props: { color: 'red' } }, '禁止');
          }
          if (level === 2) {
            return h('Tag', { props: { color: 'orange' } }, '极高风险');
          }
          if (level === 3) {
            return h('Tag', { props: { color: '#d48806' } }, '高风险');
          }
          return h('span');
        }
      }, {
        title: '外教等级',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.tchLevel || '' },
            props: {
              value: row.tchLevel,
              placeholder: '等级'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.tchLevel) {
                  row.tchLevel = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, tchLevel: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.tchLevel) {
                  row.tchLevel = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, tchLevel: value } });
                }
              }
            }
          });
        }
      }, {
        title: '外教运营',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var name = row.studyAdviserNickname;
          if (!name) {
            return h('span', '');
          }
          return h('a', {
            on: {
              click: function click() {
                _this.onTchChangeStatusList(row.id);
              }
            }
          }, name);
        }
      }, {
        title: 'HR',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var options = _this.$constant.hrList.slice();
          if (row.hr && !options.some(function (item) {
            return item.code === row.hr;
          })) {
            options = [{ code: row.hr, text: row.hr }].concat(options);
          }
          return h('Select', {
            props: {
              value: row.hr,
              transfer: true,
              clearable: true
            },
            on: {
              'on-change': function onChange(value) {
                var newValue = value || '';
                if (newValue !== (row.hr || '')) {
                  row.hr = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, hr: newValue } });
                }
              }
            }
          }, options.map(function (item) {
            return h('Option', { props: { value: item.code }, key: item.code }, item.text);
          }));
        }
      }, {
        title: '推荐人说明',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.inviteRemark || '' },
            props: {
              value: row.inviteRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.inviteRemark) {
                  row.inviteRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, inviteRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.inviteRemark) {
                  row.inviteRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, inviteRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '开课时间',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('DatePicker', {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              value: row.openCourseTime,
              placeholder: '选择日期',
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                if (value !== row.openCourseTime) {
                  row.openCourseTime = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, openCourseTime: value } });
                }
              }
            }
          });
        }
      }, {
        title: '注册渠道',
        width: 100,
        align: 'center',
        key: 'regFrom'
      }, {
        title: '类型',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '应急外教',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.emergency,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.emergency = value;
                _this.updateTchDirect({ tchList: { id: row.id, emergency: value } });
              }
            }
          }, [h('Option', { props: { value: 1 } }, '是'), h('Option', { props: { value: 0 } }, '否')]);
        }
      }, {
        title: '转正时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.regularTime || '' },
            props: {
              value: row.regularTime,
              placeholder: '1900-06-01'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.regularTime) {
                  row.regularTime = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularTime: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.regularTime) {
                  row.regularTime = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularTime: value } });
                }
              }
            }
          });
        }
      }, {
        title: '优秀外教',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.excellent,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.excellent = value;
                _this.updateTchDirect({ tchForm: { tchId: row.id, excellent: value } });
              }
            }
          }, _this.excellentOptions.map(function (item) {
            return h('Option', { props: { value: item } }, item);
          }));
        }
      }, {
        title: '合同版本',
        key: 'contractVersion',
        width: 120,
        align: 'center'
      }, {
        title: '绑定权限',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.isCanBound,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.isCanBound = value;
                _this.updateTchDirect({ tchList: { id: row.id, isCanBound: value } });
              }
            }
          }, _this.$constant.yesNoNum.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '临时约课权限',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.tempSchedule,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.tempSchedule = value;
                _this.updateTchDirect({ tchList: { id: row.id, tempSchedule: value } });
              }
            }
          }, _this.$constant.yesNoNum.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '试听权限',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.isAudition,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.isAudition = value;
                _this.updateTchDirect({ tchList: { id: row.id, isAudition: value } });
              }
            }
          }, _this.$constant.yn.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '性别',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.sex,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.sex = value;
                _this.updateTchDirect({ tchList: { id: row.id, sex: value } });
              }
            }
          }, _this.$constant.sex.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '口音',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.accent,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.sex = value;
                _this.updateTchDirect({ tchInfo: { tchId: row.id, accent: value } });
              }
            }
          }, _this.$constant.accent.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '进度',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.progressRemark || '' },
            props: {
              value: row.progressRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.progressRemark) {
                  row.progressRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, progressRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.progressRemark) {
                  row.progressRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, progressRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '周末时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.weekendRemark || '' },
            props: {
              value: row.weekendRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.weekendRemark) {
                  row.weekendRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, weekendRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.weekendRemark) {
                  row.weekendRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, weekendRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '期望时薪',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.expectSalary || '' },
            props: {
              value: row.expectSalary,
              placeholder: '期望时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.expectSalary) {
                  row.expectSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, expectSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.expectSalary) {
                  row.expectSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, expectSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '试用期时薪',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.probationHourlySalary || '' },
            props: {
              value: row.probationHourlySalary,
              placeholder: '试用期时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.probationHourlySalary) {
                  row.probationHourlySalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationHourlySalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.probationHourlySalary) {
                  row.probationHourlySalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationHourlySalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '试用期课薪',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.probationClassSalary || '' },
            props: {
              value: row.probationClassSalary,
              placeholder: '试用期课薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.probationClassSalary) {
                  row.probationClassSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationClassSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.probationClassSalary) {
                  row.probationClassSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationClassSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '转正时薪',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.regularHourlySalary || '' },
            props: {
              value: row.regularHourlySalary,
              placeholder: '转正时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.regularHourlySalary) {
                  row.regularHourlySalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularHourlySalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.regularHourlySalary) {
                  row.regularHourlySalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularHourlySalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '转正课薪',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.regularClassSalary || '' },
            props: {
              value: row.regularClassSalary,
              placeholder: '转正课薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.regularClassSalary) {
                  row.regularClassSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularClassSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.regularClassSalary) {
                  row.regularClassSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularClassSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '证书',
        key: 'certs',
        width: 120,
        align: 'center'
      }, {
        title: '最高学历',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.eduLevel || '' },
            props: {
              value: row.eduLevel,
              placeholder: '最高学历'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.eduLevel) {
                  row.eduLevel = newValue;
                  _this.updateTchDirect({ tchList: { id: row.id, eduLevel: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.eduLevel) {
                  row.eduLevel = value;
                  _this.updateTchDirect({ tchList: { id: row.id, eduLevel: value } });
                }
              }
            }
          });
        }
      }, {
        title: '备注',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.remark || '',
              rows: 3 },
            props: {
              value: row.remark,
              placeholder: 'remark',
              type: 'textarea'
            },
            style: {
              resize: 'vertical' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.remark) {
                  row.remark = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, remark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.remark) {
                  row.remark = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, remark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '合同开始时间',
        key: 'crtBeginTime',
        width: 120,
        align: 'center'
      }, {
        title: '合同结束时间',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var day = row.crtEndTimeDay;
          var crtEndTime = row.crtEndTime;
          if (crtEndTime) {
            if (day <= 30) {
              return h('div', [h('p', {}, row.crtEndTime), h('span', { style: { color: 'red' } }, '距结束' + day + '天')]);
            } else {
              return h('div', [h('p', {}, row.crtEndTime)]);
            }
          }
        }
      }, {
        title: '注册时间',
        width: 120,
        align: 'center',
        key: 'createTime'
      }, {
        title: '邮箱',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.email), h('div', { slot: 'content' }, params.row.email)]);
        }
      }, {
        title: '生日',
        width: 150,
        align: 'center',
        key: 'birthday'
      }, {
        title: '账号/classin账号',
        width: 250,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.account,
              placeholder: 'Login Account'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.account) {
                  row.account = newValue;
                  _this.updateTchDirect({ tchList: { id: row.id, account: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.account) {
                  row.account = value;
                  _this.updateTchDirect({ tchList: { id: row.id, account: value } });
                }
              }
            }
          });
        }
      }, {
        title: '时差(小时)',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.timeDiff,
              placeholder: '正负数字'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.timeDiff) {
                  row.timeDiff = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, timeDiff: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.timeDiff) {
                  row.timeDiff = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, timeDiff: value } });
                }
              }
            }
          });
        }
      }, {
        title: '专业',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.major,
              placeholder: '大学专业'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.major) {
                  row.major = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, major: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.major) {
                  row.major = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, major: value } });
                }
              }
            }
          });
        }
      }, {
        title: '展示邀请海报',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.showPoster,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.showPoster = value;
                _this.updateTchDirect({ tchForm: { tchId: row.id, showPoster: value } });
              }
            }
          }, _this.$constant.yesNoNum.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '最近跟踪',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var trackTime = params.row.trackTime;
          var trackContent = params.row.trackContent;
          return h('div', [h('div', {
            attrs: {
              title: trackContent },
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, trackContent || ''), h('div', {
            style: {
              fontSize: '12px',
              color: '#999',
              marginTop: '4px'
            }
          }, trackTime || '')]);
        }
      }, {
        title: '操作',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onSendEmail(row);
              }
            }
          }, '发送邮件')]);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.loadRegChannels();
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;

    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },

  methods: {
    loadRegChannels: function loadRegChannels() {
      var self = this;
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data;
        }
      });
    },
    onSendEmail: function onSendEmail(row) {
      this.emailTchId = row.id;
      this.emailTchName = row.firstName + ' ' + row.lastName;
      this.showEmailModal = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    onReject: function onReject(row) {
      this.showRejectModal = true;
      this.rejectParam.id = row.id;
      this.rejectParam.firstName = row.firstName;
      this.rejectParam.lastName = row.lastName;
      this.passParam.remark = '';
    },
    reject: function reject() {
      var self = this;
      self.loadingReject = true;
      self.$refs.rejectForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingReject = false;
          return;
        }
        var params = {};
        params.id = self.rejectParam.id;
        params.remark = self.rejectParam.remark;
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.search();
            self.showRejectModal = false;
          }
          self.loadingReject = false;
        }).catch(function (e) {
          self.showRejectModal = false;
          self.loadingReject = false;
        });
      });
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data.filter(function (item) {
          return item.type === 4;
        });
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！');
        return;
      }
      this.showAssignTchStudyAdviserModal = true;
    },
    batchReject: function batchReject() {
      var self = this;
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！');
        return;
      }
      this.showBatchReviewModal = true;
    },
    closeEditDingModal: function closeEditDingModal() {
      this.showEditDingModal = false;
      this.tchId = null;
    },
    closeTeacherDingTalkModal: function closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false;
      this.tchId = null;
    },
    exportData: function exportData() {
      var _this3 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/tchList/normal-list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '在职老师.xlsx';
          link.click();
          _this3.exportLoading = false;
        } else {
          _this3.$Message.error(response.msg || '导出失败');
        }
      }).catch(function (e) {
        _this3.$Message.error('导出失败');
        _this3.exportLoading = false;
      });
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startOpenCourseDate = value[0];
      this.queryParam.endOpenCourseDate = value[1];
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    }
  },

  watch: {}
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchOnboardingList',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      rankScoreSeq: 0,
      tableLoading: false,
      detailLoading: false,
      detailVisible: false,
      detailName: '',
      detailDoneCount: 0,
      detailTotalCount: 0,
      detailRows: [],
      tableData: [],
      queryParam: {
        tchId: '',
        keyword: ''
      },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
      },
      columns: [{
        title: '老师ID',
        key: 'tchId',
        width: 100,
        align: 'center',
        fixed: 'left'
      }, {
        title: '姓名',
        minWidth: 180,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: _this.tchName(params.row),
            score: params.row.monthRankScore
          });
        }
      }, {
        title: '版本',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.versionId == null ? '-' : params.row.versionId);
        }
      }, {
        title: '总进度',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.progressText(params.row.doneCount, params.row.totalCount));
        }
      }, {
        title: '最后更新',
        minWidth: 160,
        key: 'lastUpdateTime'
      }, {
        title: '操作',
        width: 90,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          return h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.openDetail(params.row);
              } }
          }, '查看');
        }
      }],
      detailColumns: [{
        title: '阶段',
        key: 'stageName',
        width: 180
      }, {
        title: '标题',
        key: 'title',
        minWidth: 200
      }, {
        title: '是否完成',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('Tag', {
            props: { color: params.row.done ? 'green' : 'default' }
          }, params.row.done ? '已完成' : '未完成');
        }
      }, {
        title: '文字',
        minWidth: 160,
        render: function render(h, params) {
          return h('span', params.row.textValue || '-');
        }
      }, {
        title: '图片',
        width: 180,
        render: function render(h, params) {
          return _this.renderPhotos(h, params.row.photoUrls);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.search();
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    tchName: function tchName(row) {
      if (!row) {
        return '';
      }
      return ((row.firstName || '') + ' ' + (row.lastName || '')).trim();
    },
    progressText: function progressText(done, total) {
      return (done || 0) + '/' + (total || 0);
    },
    search: function search() {
      this.pagination.pageIndex = 1;
      this.loadList();
    },
    loadList: function loadList() {
      var self = this;
      self.tableLoading = true;
      self.searchLoading = true;
      var params = {
        keyword: self.queryParam.keyword,
        page: self.pagination.pageIndex,
        pageSize: self.pagination.pageSize
      };
      if (self.queryParam.tchId) {
        params.tchId = self.queryParam.tchId;
      }
      self.$http.get('/tchOnboarding/list', { params: params }).then(function (res) {
        var data = res.data || {};
        self.tableData = data.data || [];
        self.loadMonthRankScores();
        self.pagination.totalCount = data.totalCount || 0;
      }).catch(function () {
        self.tableData = [];
        self.pagination.totalCount = 0;
      }).then(function () {
        self.tableLoading = false;
        self.searchLoading = false;
      });
    },
    changePage: function changePage(pageIndex) {
      this.pagination.pageIndex = pageIndex;
      this.loadList();
    },
    changePageSize: function changePageSize(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageIndex = 1;
      this.loadList();
    },
    openDetail: function openDetail(row) {
      var self = this;
      self.detailVisible = true;
      self.detailLoading = true;
      self.detailName = self.tchName(row);
      self.detailRows = [];
      self.detailDoneCount = 0;
      self.detailTotalCount = 0;
      self.$http.get('/tchOnboarding/detail', { params: { tchId: row.tchId } }).then(function (res) {
        var data = res.data || {};
        if (data.firstName || data.lastName) {
          self.detailName = ((data.firstName || '') + ' ' + (data.lastName || '')).trim();
        }
        var stages = data.stages || [];
        self.detailRows = self.buildDetailRows(stages);
        var done = 0;
        var total = 0;
        stages.forEach(function (stage) {
          done += stage.doneCount || 0;
          total += stage.totalCount || 0;
        });
        self.detailDoneCount = done;
        self.detailTotalCount = total;
      }).catch(function () {
        self.detailRows = [];
      }).then(function () {
        self.detailLoading = false;
      });
    },
    buildDetailRows: function buildDetailRows(stages) {
      var rows = [];
      var list = stages || [];
      list.forEach(function (stage) {
        var items = stage.items || [];
        items.forEach(function (item) {
          rows.push({
            stageName: stage.name,
            title: item.title,
            done: item.done,
            textValue: item.textValue,
            photoUrls: item.photoUrls,
            finishTime: item.finishTime
          });
        });
      });
      return rows;
    },
    parsePhotoUrls: function parsePhotoUrls(photoUrls) {
      if (!photoUrls) {
        return [];
      }
      if (Array.isArray(photoUrls)) {
        return photoUrls.map(function (url) {
          return (url || '').trim();
        }).filter(function (url) {
          return !!url;
        });
      }
      return String(photoUrls).split(',').map(function (url) {
        return url.trim();
      }).filter(function (url) {
        return !!url;
      });
    },
    renderPhotos: function renderPhotos(h, photoUrls) {
      var urls = this.parsePhotoUrls(photoUrls);
      if (!urls.length) {
        return h('span', '-');
      }
      var images = urls.map(function (url) {
        return h('img', {
          attrs: { src: url },
          style: {
            width: '48px',
            height: '48px',
            objectFit: 'cover',
            marginRight: '4px',
            borderRadius: '3px',
            cursor: 'pointer'
          },
          on: { click: function click() {
              return window.open(url, '_blank');
            } }
        });
      });
      return h('div', images);
    }
  }
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchOnboardingManage',
  data: function data() {
    var _this = this;

    return {
      loading: false,
      saveLoading: false,
      publishLoading: false,
      showStageModal: false,
      showItemModal: false,
      stages: [],
      latestVersionId: null,
      latestPublishTime: '',
      stageForm: this.emptyStageForm(),
      itemForm: this.emptyItemForm(),
      itemColumns: [{
        title: '标题',
        key: 'title',
        minWidth: 200,
        render: function render(h, params) {
          return h('span', { class: { 'is-offline': !_this.isEnabled(params.row.enabled) } }, params.row.title);
        }
      }, {
        title: '说明',
        key: 'guideText',
        minWidth: 200,
        render: function render(h, params) {
          return h('span', params.row.guideText || '-');
        }
      }, {
        title: '提示',
        key: 'hint',
        minWidth: 140,
        render: function render(h, params) {
          return h('span', params.row.hint || '-');
        }
      }, {
        title: '类型',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.itemTypeText(params.row.itemType));
        }
      }, {
        title: '排序',
        width: 80,
        align: 'center',
        key: 'sort'
      }, {
        title: '状态',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          if (_this.isEnabled(params.row.enabled)) {
            return h('Tag', { props: { color: 'green' } }, '已上线');
          }
          return h('Tag', { props: { color: 'default' } }, '已下线');
        }
      }, {
        title: '操作',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var btns = [];
          btns.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '6px' },
            on: { click: function click() {
                return _this.openItemModal(row);
              } }
          }, '编辑'));
          btns.push(h('Button', {
            props: { type: _this.isEnabled(row.enabled) ? 'warning' : 'success', size: 'small' },
            on: { click: function click() {
                return _this.toggleItem(row);
              } }
          }, _this.isEnabled(row.enabled) ? '下线' : '上线'));
          return h('div', btns);
        }
      }]
    };
  },
  mounted: function mounted() {
    this.loadTemplate();
  },

  methods: {
    emptyStageForm: function emptyStageForm() {
      return {
        id: null,
        name: '',
        sort: null
      };
    },
    emptyItemForm: function emptyItemForm() {
      return {
        id: null,
        stage: null,
        title: '',
        guideText: '',
        hint: '',
        itemType: 1,
        sort: null
      };
    },
    isEnabled: function isEnabled(enabled) {
      return enabled === 1 || enabled === true;
    },
    itemTypeText: function itemTypeText(itemType) {
      if (itemType === 2) return '必须填文字';
      if (itemType === 3) return '必须传图';
      return '勾选';
    },
    loadTemplate: function loadTemplate() {
      var self = this;
      self.loading = true;
      self.$http.get('/tchOnboarding/template').then(function (res) {
        var data = res && res.data || {};
        self.stages = data.stages || [];
        self.latestVersionId = data.latestVersionId || null;
        self.latestPublishTime = data.latestPublishTime || '';
      }).catch(function () {
        self.stages = [];
        self.latestVersionId = null;
        self.latestPublishTime = '';
      }).then(function () {
        self.loading = false;
      });
    },
    openStageModal: function openStageModal(stage) {
      if (stage) {
        this.stageForm = {
          id: stage.id,
          name: stage.name,
          sort: stage.sort
        };
      } else {
        this.stageForm = this.emptyStageForm();
      }
      this.showStageModal = true;
    },
    saveStage: function saveStage() {
      var self = this;
      if (!self.stageForm.name) {
        self.$Message.warning('请输入分类名称');
        return;
      }
      self.saveLoading = true;
      self.$http.post('/tchOnboarding/stage/save', {
        id: self.stageForm.id,
        name: self.stageForm.name,
        sort: self.stageForm.sort
      }).then(function (res) {
        self.saveLoading = false;
        if (res && res.status === 'ok') {
          self.showStageModal = false;
          self.$Message.success('保存成功');
          self.loadTemplate();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    toggleStage: function toggleStage(stage) {
      var self = this;
      var enabled = self.isEnabled(stage.enabled) ? 0 : 1;
      self.$http.post('/tchOnboarding/stage/enabled', { id: stage.id, enabled: enabled }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(enabled === 1 ? '已上线' : '已下线');
          self.loadTemplate();
        }
      });
    },
    openItemModal: function openItemModal(item, stage) {
      if (item) {
        this.itemForm = {
          id: item.id,
          stage: item.stage,
          title: item.title,
          guideText: item.guideText,
          hint: item.hint,
          itemType: item.itemType,
          sort: item.sort
        };
      } else {
        this.itemForm = this.emptyItemForm();
        if (stage) {
          this.itemForm.stage = stage.id;
        }
      }
      this.showItemModal = true;
    },
    saveItem: function saveItem() {
      var self = this;
      if (!self.itemForm.stage) {
        self.$Message.warning('请选择所属分类');
        return;
      }
      if (!self.itemForm.title) {
        self.$Message.warning('请输入标题');
        return;
      }
      if ([1, 2, 3].indexOf(self.itemForm.itemType) < 0) {
        self.$Message.warning('请选择类型');
        return;
      }
      self.saveLoading = true;
      self.$http.post('/tchOnboarding/item/save', {
        id: self.itemForm.id,
        stage: self.itemForm.stage,
        title: self.itemForm.title,
        guideText: self.itemForm.guideText,
        hint: self.itemForm.hint,
        itemType: self.itemForm.itemType,
        sort: self.itemForm.sort
      }).then(function (res) {
        self.saveLoading = false;
        if (res && res.status === 'ok') {
          self.showItemModal = false;
          self.$Message.success('保存成功');
          self.loadTemplate();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    toggleItem: function toggleItem(item) {
      var self = this;
      var enabled = self.isEnabled(item.enabled) ? 0 : 1;
      self.$http.post('/tchOnboarding/item/enabled', { id: item.id, enabled: enabled }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(enabled === 1 ? '已上线' : '已下线');
          self.loadTemplate();
        }
      });
    },
    publish: function publish() {
      var self = this;
      self.$Modal.confirm({
        title: '发布确认',
        content: '发布后会把当前上线的分类和选项生成一个新版本，确定发布吗？',
        onOk: function onOk() {
          self.publishLoading = true;
          self.$http.post('/tchOnboarding/publish').then(function (res) {
            self.publishLoading = false;
            if (res && res.status === 'ok') {
              self.$Message.success('发布成功');
              self.loadTemplate();
            }
          }).catch(function () {
            self.publishLoading = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchPerformanceList',
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      tableLoading: false,
      queryParam: {
        startDate: '',
        endDate: '',
        studyAdviserId: ''
      },
      startDate: '',
      endDate: '',
      studyAdviserList: [],
      columns: [{
        title: '老师类型',
        key: 'teacherType',
        align: 'center',
        width: 120,
        fixed: 'left'
      }, {
        title: '老师数量',
        key: 'teacherCount',
        align: 'center',
        width: 100
      }, {
        title: '买断课时数',
        key: 'buyOutLessonCount',
        align: 'center',
        width: 120
      }, {
        title: '上课数',
        key: 'lessonCount',
        align: 'center',
        width: 100
      }, {
        title: '上课率',
        key: 'attendanceRate',
        align: 'center',
        width: 100
      }, {
        title: '第四周上课率',
        key: 'fourthWeekAttendanceRate',
        align: 'center',
        width: 130
      }, {
        title: '请假数',
        key: 'leaveCount',
        align: 'center',
        width: 100
      }, {
        title: '外教请假率',
        key: 'foreignTeacherLeaveRate',
        align: 'center',
        width: 120
      }, {
        title: '临时正常上课数',
        key: 'temporaryNormalLessonCount',
        align: 'center',
        width: 140
      }, {
        title: '临时请假数',
        key: 'temporaryLeaveCount',
        align: 'center',
        width: 120
      }, {
        title: '临时请假率',
        key: 'temporaryLeaveRate',
        align: 'center',
        width: 120
      }, {
        title: '返课时',
        key: 'returnLessonHours',
        align: 'center',
        width: 100
      }, {
        title: 'CPE+回访',
        key: 'cpeAndFollowUp',
        align: 'center',
        width: 120
      }, {
        title: '外教离职',
        key: 'foreignTeacherResigned',
        align: 'center',
        width: 100
      }, {
        title: '培训中外教数',
        key: 'trainingForeignTeachers',
        align: 'center',
        width: 140
      }],
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getStudyAdviserList();

    this.initDefaultDate();

    this.search();
  },

  methods: {
    getStudyAdviserList: function getStudyAdviserList() {
      var self = this;
      self.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.studyAdviserList = res.data;
      });
    },
    initDefaultDate: function initDefaultDate() {
      var now = this.$moment();
      var currentDay = now.day();
      var friday = now.clone();
      if (currentDay === 0) {
        friday = now.clone().subtract(2, 'days');
      } else if (currentDay >= 6) {
        friday = now.clone().subtract(1, 'days');
      } else {
        friday = now.clone().add(5 - currentDay, 'days');
      }

      var lastSaturday = friday.clone().subtract(6, 'days');

      var startDate = lastSaturday.format('YYYY-MM-DD');
      var endDate = friday.format('YYYY-MM-DD');

      this.queryParam.startDate = startDate;
      this.queryParam.endDate = endDate;
      this.startDate = startDate;
      this.endDate = endDate;
    },
    onStartDateChange: function onStartDateChange(value) {
      if (value) {
        this.queryParam.startDate = this.$moment(value).format('YYYY-MM-DD');
      } else {
        this.queryParam.startDate = '';
      }
    },
    onEndDateChange: function onEndDateChange(value) {
      if (value) {
        this.queryParam.endDate = this.$moment(value).format('YYYY-MM-DD');
      } else {
        this.queryParam.endDate = '';
      }
    },
    search: function search() {
      var _this = this;

      this.tableLoading = true;
      this.searchLoading = true;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.queryParam);

      this.$http.post('/tch/statistics', params).then(function (res) {
        if (res.data) {
          _this.tableData = res.data;
        } else {
          _this.$Message.error(res.data.message || '获取数据失败');
        }
      }).catch(function (error) {
        _this.$Message.error('请求失败：' + error.message);
      }).finally(function () {
        _this.tableLoading = false;
        _this.searchLoading = false;
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.queryParam);
      if (params.startDate && !params.startDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        params.startDate = this.$moment(params.startDate).format('YYYY-MM-DD');
      }
      if (params.endDate && !params.endDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        params.endDate = this.$moment(params.endDate).format('YYYY-MM-DD');
      }

      this.$http.post('/tch/statistics/export', params, { responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '外管绩效统计.xlsx';
        link.click();
        _this2.$Message.success('导出成功');
      }).catch(function (error) {
        _this2.$Message.error('导出失败：' + error.message);
      }).finally(function () {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      queryParam: {
        inviteId: null,
        account: '',
        nickname: ''
      },
      title: [{
        title: '老师ID',
        width: 150,
        key: 'newTchId'
      }, {
        title: '老师昵称',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.firstName || '') + (row.lastName || ''),
            score: row.monthRankScore
          });
        }
      }, {
        title: '老师账号',
        width: 150,
        key: 'account'
      }, {
        title: '推荐人',
        width: 200,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.inviteId + '-' + row.referrerFirstName + row.referrerLastName);
        }
      }, {
        title: '注册时间',
        width: 200,
        align: 'center',
        key: 'gmtCreate'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.newTchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'newTchId', 'monthRankScore', map);
      });
    }
  }
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);


var STAT_COLUMNS = [{ title: '注册人数', key: 'added', minWidth: 110, tip: '筛选时间范围内总注册人数' }, { title: '待审核', key: 'pending', minWidth: 100, tip: '注册总人数中待审核人数，也就是老师管理/待审核老师' }, { title: '已审核', key: 'audited', minWidth: 100, tip: '注册总人数中已审核的人数，也就是老师管理/已审核老师' }, { title: '培训中', key: 'newTraining', minWidth: 100, tip: '注册总人数中培训中的人数，也就是老师管理/培训中老师' }, { title: '培训淘汰', key: 'eliminate', minWidth: 110, tip: '注册总人数中培训淘汰的人数' }, { title: '培训流失', key: 'attrit', minWidth: 110, tip: '注册总人数中培训流失的人数' }, { title: '在职人数', key: 'openClass', minWidth: 110, tip: '注册总人数中在职的人数，也就是老师管理/在职老师' }, { title: '离职人数', key: 'resigned', minWidth: 110, tip: '注册总人数中离职的人数，也就是老师管理/离职老师' }, { title: '已禁用', key: 'disabled', minWidth: 100, tip: '注册总人数中账号禁用的人数' }];

var DETAIL_EXTRA = {
  pending: { time: '变更时间', operator: '操作人' },
  audited: { time: '审核时间', operator: '审核人' },
  newTraining: { time: '进入培训时间', operator: '操作人' },
  eliminate: { time: '淘汰时间', operator: '操作人' },
  attrit: { time: '流失时间', operator: '操作人' },
  openClass: { time: '开课时间', operator: '操作人' },
  resigned: { time: '离职时间', operator: '操作人' },
  disabled: { time: '禁用时间', operator: '操作人' }
};



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRecruitTrainStat',
  data: function data() {
    var today = this.$moment().format('YYYY-MM-DD');
    return {
      rankScoreSeq: 0,
      searchLoading: false,
      tableLoading: false,
      exportLoading: false,
      dateRange: [today, today],
      startDate: today,
      endDate: today,
      hr: '',
      statTemplate: 'default',
      summaryColumns: [],
      channelColumns: [],
      summaryData: [],
      channelData: [],
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detailColumns: [],
      detailData: [],
      detailTotal: 0,
      detailPageIndex: 1,
      detailPageSize: 20,
      detailColumn: '',
      detailChannelScope: 'all',
      detailChannel: '',
      detailReqId: 0,
      channelTableHeight: null
    };
  },
  created: function created() {
    this.summaryColumns = [{ title: '日期', key: 'period', align: 'center', minWidth: 180 }].concat(this.buildStatColumns('all'));
    this.channelColumns = [{ title: '日期', key: 'period', align: 'center', minWidth: 180 }, { title: '注册渠道', key: 'channel', align: 'center', minWidth: 140 }].concat(this.buildStatColumns('channel'));
  },
  mounted: function mounted() {
    var _this = this;

    this.onResize = function () {
      _this.updateChannelTableHeight();
    };
    window.addEventListener('resize', this.onResize);
    this.search();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    channelTableData: function channelTableData() {
      var rows = this.channelData || [];
      if (!rows.length) {
        return [];
      }
      var summary = { _summary: true, channel: '合计' };
      var period = rows[0] && rows[0].period;
      if (period == null || period === '') {
        var s0 = this.summaryData && this.summaryData[0];
        period = s0 && s0.period;
      }
      if (period == null || period === '') {
        period = (this.startDate || '') + ' ~ ' + (this.endDate || '');
      }
      summary.period = period;
      STAT_COLUMNS.forEach(function (item) {
        var sum = 0;
        for (var i = 0; i < rows.length; i++) {
          var v = rows[i][item.key];
          sum += v == null ? 0 : Number(v) || 0;
        }
        summary[item.key] = sum;
      });
      return rows.concat([summary]);
    }
  },
  watch: {
    channelTableData: function channelTableData() {
      this.updateChannelTableHeight();
    }
  },
  methods: {
    channelRowClassName: function channelRowClassName(row) {
      return row && row._summary ? 'channel-summary-row' : '';
    },
    updateChannelTableHeight: function updateChannelTableHeight() {
      var _this2 = this;

      this.$nextTick(function () {
        var table = _this2.$refs.channelTable;
        if (!table || !table.$el) {
          return;
        }
        var el = table.$el;
        var main = document.querySelector('.layout-content-main');
        var mainBottom = main ? main.getBoundingClientRect().bottom : window.innerHeight;
        var visibleBottom = Math.min(mainBottom, window.innerHeight);
        var available = Math.floor(visibleBottom - el.getBoundingClientRect().top - 64);
        var header = el.querySelector('.ivu-table-header');
        var rows = el.querySelectorAll('.ivu-table-tbody tr');
        var content = header ? header.offsetHeight : 40;
        for (var i = 0; i < rows.length; i++) {
          content += rows[i].offsetHeight || 48;
        }
        if (!rows.length) {
          content += 48;
        }
        var next = content > available && available > 80 ? available : null;
        if (next !== _this2.channelTableHeight) {
          _this2.channelTableHeight = next;
        }
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.detailData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    buildStatColumns: function buildStatColumns(channelScope) {
      var self = this;
      return STAT_COLUMNS.map(function (item) {
        var column = {
          title: item.title,
          key: item.key,
          align: 'center',
          minWidth: item.minWidth,
          render: function render(h, params) {
            var value = params.row[item.key];
            var count = value == null ? 0 : Number(value);
            var text = value == null ? '0' : String(value);
            if (!count) {
              return h('span', text);
            }
            return h('span', {
              style: { color: '#2d8cf0', cursor: 'pointer' },
              on: {
                click: function click(e) {
                  e.stopPropagation();
                  var scope = params.row && params.row._summary ? 'all' : channelScope;
                  self.openDetail(params.row, item.key, scope);
                }
              }
            }, text);
          }
        };
        if (!item.tip) {
          return column;
        }
        column.renderHeader = function (h) {
          return h('span', { class: 'col-head' }, [h('span', item.title), h('Poptip', {
            props: {
              trigger: 'click',
              content: item.tip,
              placement: 'top',
              transfer: true,
              width: 260
            }
          }, [h('Icon', {
            class: 'col-help-icon',
            props: { type: 'help-circled' }
          })])]);
        };
        return column;
      });
    },
    onDateRangeChange: function onDateRangeChange(value) {
      var start = value && value[0];
      var end = value && value[1];
      if (!start || !end) {
        var today = this.$moment().format('YYYY-MM-DD');
        start = today;
        end = today;
      }
      this.startDate = start;
      this.endDate = end;
      this.dateRange = [start, end];
      this.search();
    },
    onHrChange: function onHrChange(value) {
      this.hr = value || '';
      this.search();
    },
    onStatTemplateChange: function onStatTemplateChange(value) {
      this.statTemplate = value || 'default';
      this.search();
    },
    queryBody: function queryBody() {
      var body = {
        startDate: this.startDate,
        endDate: this.endDate,
        template: this.statTemplate || 'default'
      };
      if (this.hr) {
        body.hr = this.hr;
      }
      return body;
    },
    search: function search() {
      var _this3 = this;

      this.searchLoading = true;
      this.tableLoading = true;
      this.$http.post('/tch/recruit-train-stat', this.queryBody()).then(function (res) {
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this3.summaryData = data.summary || [];
          _this3.channelData = data.channels || [];
        } else {
          _this3.summaryData = [];
          _this3.channelData = [];
        }
      }).catch(function () {
        _this3.summaryData = [];
        _this3.channelData = [];
      }).finally(function () {
        _this3.searchLoading = false;
        _this3.tableLoading = false;
        _this3.updateChannelTableHeight();
      });
    },
    exportData: function exportData() {
      var _this4 = this;

      this.exportLoading = true;
      this.$http.post('/tch/recruit-train-stat-export', this.queryBody(), { responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '招聘培训统计.xlsx';
        link.click();
        _this4.$Message.success('导出成功');
      }).catch(function (error) {
        _this4.$Message.error('导出失败：' + (error.message || '未知错误'));
      }).finally(function () {
        _this4.exportLoading = false;
      });
    },
    openDetail: function openDetail(row, column, channelScope) {
      this.detailColumn = column;
      this.detailChannelScope = channelScope;
      if (channelScope === 'channel') {
        this.detailChannel = row.channelParam == null ? '' : row.channelParam;
      } else {
        this.detailChannel = '';
      }
      this.detailPageIndex = 1;
      this.detailTitle = this.detailTitleOf(row, column, channelScope);
      this.detailColumns = this.buildDetailColumns(column);
      this.detailData = [];
      this.detailTotal = 0;
      this.detailVisible = true;
      this.loadDetail();
    },
    detailTitleOf: function detailTitleOf(row, column, channelScope) {
      var stat = STAT_COLUMNS.find(function (item) {
        return item.key === column;
      });
      var name = stat ? stat.title : '';
      var period = row.period == null ? '' : row.period;
      var title = name + '明细 · ' + period;
      if (channelScope === 'channel') {
        var channelName = row.channel == null ? '' : row.channel;
        title += ' · ' + channelName;
      }
      return title;
    },
    buildDetailColumns: function buildDetailColumns(column) {
      var columns = [{ title: '注册时间', key: 'registerTime', align: 'center', minWidth: 170 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 100 }, {
        title: '姓名',
        key: 'name',
        align: 'center',
        minWidth: 160,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.name,
            score: row.monthRankScore
          });
        }
      }];
      var extra = DETAIL_EXTRA[column];
      if (extra) {
        columns.push({ title: extra.time, key: 'changeTime', align: 'center', minWidth: 170 });
        columns.push({ title: extra.operator, key: 'operatorName', align: 'center', minWidth: 120 });
      }
      return columns;
    },
    detailBody: function detailBody() {
      var body = this.queryBody();
      body.channelScope = this.detailChannelScope;
      body.column = this.detailColumn;
      body.pageIndex = this.detailPageIndex;
      body.pageSize = this.detailPageSize;
      if (this.detailChannelScope === 'channel') {
        body.channel = this.detailChannel == null ? '' : this.detailChannel;
      }
      return body;
    },
    loadDetail: function loadDetail() {
      var _this5 = this;

      var reqId = ++this.detailReqId;
      this.detailLoading = true;
      this.$http.post('/tch/recruit-train-stat-detail', this.detailBody()).then(function (res) {
        if (reqId !== _this5.detailReqId) {
          return;
        }
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this5.detailData = data.data || [];
          _this5.loadMonthRankScores();
          _this5.detailTotal = data.totalCount || 0;
        } else {
          _this5.detailData = [];
          _this5.detailTotal = 0;
          _this5.$Message.error(res && res.msg || '明细加载失败');
        }
      }).catch(function (error) {
        if (reqId !== _this5.detailReqId) {
          return;
        }
        _this5.detailData = [];
        _this5.detailTotal = 0;
        _this5.$Message.error('明细加载失败：' + (error && error.message || '未知错误'));
      }).finally(function () {
        if (reqId === _this5.detailReqId) {
          _this5.detailLoading = false;
        }
      });
    },
    onDetailPageChange: function onDetailPageChange(page) {
      if (page === this.detailPageIndex) {
        return;
      }
      this.detailPageIndex = page;
      this.loadDetail();
    },
    onDetailPageSizeChange: function onDetailPageSizeChange(size) {
      this.detailPageSize = size;
      this.detailPageIndex = 1;
      this.loadDetail();
    }
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRegChannelList',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var self = this;
    return {
      activeTab: 'channel',
      searchLoading: false,
      tableLoading: false,
      saveLoading: false,
      showModal: false,
      totalCount: 0,
      queryParam: {
        name: '',
        param: '',
        status: null,
        pageIndex: 1,
        pageSize: 20
      },
      formData: {
        id: null,
        name: '',
        param: '',
        status: 1
      },
      dataList: [],
      columns: [{ title: '渠道名称', key: 'name', minWidth: 140 }, { title: '渠道参数', key: 'param', minWidth: 140 }, {
        title: '状态',
        key: 'status',
        width: 100,
        render: function render(h, params) {
          var disabled = params.row.param === '转介绍';
          return h('i-switch', {
            props: {
              value: params.row.status === 1,
              disabled: disabled
            },
            on: {
              'on-change': function onChange(val) {
                self.toggleStatus(params.row, val ? 1 : 0);
              }
            }
          });
        }
      }, {
        title: '操作',
        width: 100,
        render: function render(h, params) {
          return h('Button', {
            props: { type: 'primary', size: 'small' },
            on: {
              click: function click() {
                self.openEdit(params.row);
              }
            }
          }, '编辑');
        }
      }],
      agencySearchLoading: false,
      agencyTableLoading: false,
      agencyTotal: 0,
      agencyList: [],
      agencyQuery: {
        id: '',
        name: '',
        account: '',
        status: null,
        pageIndex: 1,
        pageSize: 20
      },
      showTchInfoModal: false,
      agencyTchId: null,
      agencyAddType: 'agency',
      agencyColumns: [{ title: '老师ID', key: 'id', width: 100 }, {
        title: '姓名',
        minWidth: 160,
        render: function render(h, params) {
          var row = params.row || {};
          var full = row.fullName || '';
          var name = ((row.firstName || '') + ' ' + (row.lastName || '')).trim();
          return h('span', full || name || '-');
        }
      }, { title: '账号', key: 'account', minWidth: 140 }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          var st = self.$constant.getEnum(self.$constant.teacherStatus, params.row.status);
          return h('span', st && st.text || String(params.row.status == null ? '' : params.row.status));
        }
      }, {
        title: '类型',
        width: 110,
        render: function render(h) {
          return h('span', '中介老师');
        }
      }, {
        title: '操作',
        width: 100,
        render: function render(h, params) {
          return h('Button', {
            props: { type: 'primary', size: 'small' },
            on: {
              click: function click() {
                self.openAgencyEdit(params.row);
              }
            }
          }, '编辑');
        }
      }]
    };
  },

  created: function created() {
    this.search();
  },
  watch: {
    activeTab: function activeTab(val) {
      if (val === 'agency' && this.agencyList.length === 0 && !this.agencyTableLoading) {
        this.searchAgency();
      }
    }
  },
  methods: {
    search: function search() {
      var self = this;
      self.searchLoading = true;
      self.tableLoading = true;
      self.queryParam.pageIndex = 1;
      this.loadList();
    },
    loadList: function loadList() {
      var self = this;
      this.$http.post('/tch/reg-channel/list', self.queryParam).then(function (res) {
        self.searchLoading = false;
        self.tableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
        }
      }).catch(function () {
        self.searchLoading = false;
        self.tableLoading = false;
      });
    },
    onPageChange: function onPageChange(page) {
      this.queryParam.pageIndex = page;
      this.tableLoading = true;
      this.loadList();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.queryParam.pageSize = size;
      this.queryParam.pageIndex = 1;
      this.tableLoading = true;
      this.loadList();
    },
    openAdd: function openAdd() {
      this.formData = { id: null, name: '', param: '', status: 1 };
      this.showModal = true;
    },
    openEdit: function openEdit(row) {
      this.formData = {
        id: row.id,
        name: row.name,
        param: row.param,
        status: row.status
      };
      this.showModal = true;
    },
    save: function save() {
      var self = this;
      if (!self.formData.name || !self.formData.param) {
        self.$Message.warning('渠道名称和渠道参数不能为空');
        return;
      }
      self.saveLoading = true;
      var url = self.formData.id ? '/tch/reg-channel/update' : '/tch/reg-channel/insert';
      this.$http.post(url, self.formData).then(function (res) {
        self.saveLoading = false;
        if (res && res.status === 'ok') {
          self.showModal = false;
          self.$Message.success('保存成功');
          self.loadList();
        } else {
          self.showModal = true;
        }
      }).catch(function () {
        self.saveLoading = false;
        self.showModal = true;
      });
    },
    toggleStatus: function toggleStatus(row, status) {
      var self = this;
      this.$http.post('/tch/reg-channel/update', {
        id: row.id,
        name: row.name,
        param: row.param,
        status: status
      }).then(function (res) {
        if (res && res.status === 'ok') {
          row.status = status;
          self.$Message.success(status === 1 ? '已启用' : '已停用');
        } else {
          self.loadList();
        }
      }).catch(function () {
        self.loadList();
      });
    },
    searchAgency: function searchAgency() {
      this.agencyQuery.pageIndex = 1;
      this.loadAgencyList();
    },
    buildAgencyParam: function buildAgencyParam() {
      var q = this.agencyQuery;
      var param = {
        pageIndex: q.pageIndex,
        pageSize: q.pageSize,
        name: q.name || undefined,
        account: q.account || undefined
      };
      if (q.id !== '' && q.id != null) {
        var idNum = parseInt(q.id, 10);
        if (!isNaN(idNum)) {
          param.id = idNum;
        }
      }
      if (q.status !== null && q.status !== undefined && q.status !== '') {
        param.status = q.status;
      }
      return param;
    },
    loadAgencyList: function loadAgencyList() {
      var self = this;
      self.agencySearchLoading = true;
      self.agencyTableLoading = true;
      this.$http.post('/tch/agency/list', self.buildAgencyParam()).then(function (res) {
        self.agencySearchLoading = false;
        self.agencyTableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.agencyList = res.data.data || [];
          self.agencyTotal = res.data.totalCount || 0;
        }
      }).catch(function () {
        self.agencySearchLoading = false;
        self.agencyTableLoading = false;
      });
    },
    onAgencyPageChange: function onAgencyPageChange(page) {
      this.agencyQuery.pageIndex = page;
      this.loadAgencyList();
    },
    onAgencyPageSizeChange: function onAgencyPageSizeChange(size) {
      this.agencyQuery.pageSize = size;
      this.agencyQuery.pageIndex = 1;
      this.loadAgencyList();
    },
    openAgencyAdd: function openAgencyAdd() {
      this.agencyTchId = null;
      this.agencyAddType = 'agency';
      this.showTchInfoModal = true;
    },
    openAgencyEdit: function openAgencyEdit(row) {
      this.agencyAddType = 'agency';
      this.agencyTchId = row.id;
      this.showTchInfoModal = true;
    },
    onAgencyModalClose: function onAgencyModalClose() {
      this.showTchInfoModal = false;
      this.agencyTchId = null;
    },
    onAgencySaved: function onAgencySaved() {
      this.showTchInfoModal = false;
      this.agencyTchId = null;
      this.loadAgencyList();
    }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_AdminUserMultSelect_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_AdminUserMultSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_AdminUserMultSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_tchScore__ = __webpack_require__(2);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdminUserMultSelect: __WEBPACK_IMPORTED_MODULE_15__common_AdminUserMultSelect_vue___default.a,
    ExportLeaveModal: __WEBPACK_IMPORTED_MODULE_14__ExportLeaveModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_12__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_11__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_10__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_13__components_common_SubstituteTchSelect___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '原来的外教运营',
        render: function render(h, params) {
          return h('span', params.row.oldNickname || '');
        }
      }, {
        title: '新的外教运营',
        render: function render(h, params) {
          return h('span', params.row.newNickname || '');
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }],
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      queryParam: {
        hr: '',
        isAudition: '',
        tempSchedule: '',
        sex: '',
        accent: '',
        channel: '1',
        uid: '',
        mobile: '',
        name: '',
        nickname: '',
        inviteTchName: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: '',
        tchTags: [],
        startOpenCourseDate: '',
        endOpenCourseDate: '',
        linkStartTimeDate: '',
        linkEndTimeDate: '',
        startCreateDate: '',
        endCreateDate: ''
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: null,
        substituteTchId: ''
      },
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: '最后一个工作日',
        width: 150,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('DatePicker', {
            props: {
              value: row.lastWorkDay,
              format: 'yyyy-MM-dd',
              placeholder: '选择日期',
              transfer: true,
              placement: 'top' },
            on: {
              'on-change': function onChange(date) {
                _this.updateTchDirect({ tchList: { id: row.id, lastWorkDay: date } });
              }
            }
          })]);
        }
      }, {
        title: '老师ID',
        width: 80,
        fixed: 'left',
        align: 'center',
        key: 'id'
      }, {
        title: '状态',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.teacherStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '老师昵称',
        width: 140,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var cell = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [cell, h('div', { slot: 'content' }, [_this.tchTagPermission ? h('p', '' + row.tchTags) : h('p', '')])]);
        }
      }, {
        title: '开课时间',
        width: 120,
        align: 'center',
        key: 'openCourseTime'
      }, {
        title: '绑定权限',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var isCanBoundText = row.isCanBound === 1 ? '是' : '否';
          var style = row.isCanBound === 1 ? {} : { color: 'red' };
          return h('span', { style: style }, isCanBoundText);
        }
      }, {
        title: '老师账号',
        key: 'account',
        width: 130,
        align: 'center'
      }, {
        title: '推荐人',
        key: 'inviteTchName',
        width: 130,
        align: 'center'
      }, {
        title: '合同开始时间',
        key: 'crtBeginTimeStr',
        width: 120,
        align: 'center'
      }, {
        title: '合同结束时间',

        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var day = row.crtEndTimeDay;
          var crtEndTimeStr = row.crtEndTimeStr;
          if (crtEndTimeStr) {
            if (day <= 30) {
              return h('div', [h('p', {}, row.crtEndTimeStr), h('span', { style: { color: 'red' } }, '距结束' + day + '天')]);
            } else {
              return h('div', [h('p', {}, row.crtEndTimeStr)]);
            }
          }
        }
      }, {
        title: '买断时间',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var isOpened = params.row.isOpened;
          if (isOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showTchCancelOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '上课时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var isRandomOpened = params.row.isRandomOpened;
          if (isRandomOpened) {
            return h('a', {
              on: {
                click: function click() {
                  _this.tchId = params.row.id;
                  _this.showCancelRandomOpenedTimeModal = true;
                }
              }
            }, '查看');
          } else {
            return h('span', '未添加');
          }
        }
      }, {
        title: '类型',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '外教运营',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var name = row.studyAdviserNickname;
          if (!name) {
            return h('span', '');
          }
          return h('a', {
            on: {
              click: function click() {
                _this.onTchChangeStatusList(row.id);
              }
            }
          }, name);
        }
      }, {
        title: 'HR',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.hr || ''
            },
            props: {
              value: row.hr,
              placeholder: 'hr'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.hr) {
                  row.hr = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, hr: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.hr) {
                  row.hr = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, hr: value } });
                }
              }
            }
          });
        }
      }, {
        title: '授课类型',
        key: 'tchType',
        width: 100,
        align: 'center',

        render: function render(h, params) {
          var tchType = params.row.tchType;
          var tchTypeEnum = $constant.getEnum($constant.tchType, tchType);
          return h('span', tchTypeEnum && tchTypeEnum.text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          var tchType = row.tchType;
          var btn = null;
          if (row.category !== 3) {
            if (tchType === 2) {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'editTchTags') {
                      _this.tchId = row.id;
                      _this.tchTags = row.tchTags;
                      _this.showEditTagsModal = true;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showEditDingModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', {
                props: { name: 'editTchTags' }
              }, '编辑标签'), h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '老师请假(正常)'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '老师离职(请假)'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h()])]);
            } else {
              btn = h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click'
                },
                on: {
                  'on-click': function onClick(name) {
                    if (name === 'editTchTags') {
                      _this.tchId = row.id;
                      _this.tchTags = row.tchTags;
                      _this.showEditTagsModal = true;
                    } else if (name === 'editOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchEditOpenedTimeModal = true;
                    } else if (name === 'addRandomOpenedTime') {
                      _this.tchId = row.id;
                      _this.showTchAddRandomOpenedTimeModal = true;
                    } else if (name === 'tchLeave') {
                      _this.tchId = row.id;
                      _this.showTchLeaveModal = true;
                    } else if (name === 'tchLeaveOffice') {
                      _this.tchId = row.id;
                      _this.showTchLeaveOfficeModal = true;
                    } else if (name === 'disable') {
                      _this.onDisableTch(row);
                    } else if (name === 'editDing') {
                      _this.tchId = row.id;
                      _this.showTeacherDingTalkModal = true;
                    }
                  }
                }
              }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, [h('Dropdown-item', { props: { name: 'editTchTags' }
              }, '编辑标签'), h('Dropdown-item', { props: { name: 'editOpenedTime' } }, '编辑买断时间'), h('Dropdown-item', { props: { name: 'addRandomOpenedTime' } }, '添加上课时间'), h('Dropdown-item', { props: { name: 'tchLeave' } }, '老师请假(正常)'), h('Dropdown-item', { props: { name: 'tchLeaveOffice' } }, '老师请假(离职)'), h('Dropdown-item', { props: { name: 'editDing' } }, '钉钉用户'), h('Dropdown-item', { props: { name: 'disable' } }, '禁用'), h()])]);
            }
          } else {
            btn = h('a', { on: {} }, '禁用');
          }
          return h('div', [btn]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var permission = self.$store.get('permissions');
    this.tchTagPermission = permission.indexOf('865') >= 0 || permission.indexOf('all') >= 0;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {},
  methods: {
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/tch/resigned/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '离职外教.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg || '导出失败');
          _this2.exportLoading = false;
        }
      }).catch(function () {
        _this2.$Message.error('导出失败');
        _this2.exportLoading = false;
      });
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startOpenCourseDate = value[0];
      this.queryParam.endOpenCourseDate = value[1];
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    },
    lastWorkDayStartChange: function lastWorkDayStartChange(value) {
      this.queryParam.linkStartTimeDate = value || '';
      this.queryParam.linkEndTimeDate = value ? this.$moment().format('YYYY-MM-DD') : '';
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data.filter(function (item) {
          return item.type === 4;
        });
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！');
        return;
      }
      this.showAssignTchStudyAdviserModal = true;
    },
    onDisableTch: function onDisableTch(row) {
      var self = this;
      var name = row.id + ' - ' + row.firstName + ' ' + row.lastName;
      self.$Modal.confirm({
        title: '提示',
        content: '确定禁用 <b>' + name + '</b> 老师？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tch/disable', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('禁用成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    addTch: function addTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
    },
    uploadLeaveTemplate: function uploadLeaveTemplate() {
      this.showExportLeaveModal = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this3 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success('更新成功');
        } else {
          _this3.$Message.error(res.msg);
        }
      }).catch(function () {
        _this3.$Message.error('更新失败');
      });
    },
    downloadLeaveTemplate: function downloadLeaveTemplate() {
      var _this4 = this;

      this.$http.get('/bookTchLeaveTime/downloadLeaveTemplate', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '请假模板.xlsx';
          link.click();
        } else {
          _this4.$Message.error(response.msg);
        }
      }).catch(function (e) {
        console.log(e);
        _this4.$Message.error('下载失败');
      });
    },
    allTeachersLeave: function allTeachersLeave() {
      this.showAllTeacherLeaveModel = true;
    },
    closeEditDingModal: function closeEditDingModal() {
      this.showEditDingModal = false;
      this.tchId = null;
    },
    closeTeacherDingTalkModal: function closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false;
      this.tchId = null;
    },
    showProxyClass: function showProxyClass(row) {
      var self = this;
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm');
      self.selectTchParam = row;
      self.showSelectTch = row.show;
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data;
        } else {
          self.activityList = [];
        }
      });
    },
    cancelProxyClassData: function cancelProxyClassData(row) {
      var self = this;
      row.isProxy = 0;
      self.activityList.map(function (item, index) {
        if (item.id === row.id) {
          self.activityList[index].replace(item, row);
        }
      });
    },
    updateTch: function updateTch() {
      var self = this;
      self.selectTchParam.isProxy = 1;
      console.log('self.substituteTchId', self.substituteTchId);
      if (self.substituteTchId == null || self.substituteTchId === '') {
        self.$message.warning('请选择代课老师');
        return;
      }
      self.selectTchParam.substituteTchId = self.substituteTchId;
      if (self.substituteList.find(function (item) {
        return self.selectTchParam.id === item.id;
      }) == null) {
        self.substituteList.push(self.selectTchParam);
      }
      self.showSelectTch = false;
    },
    editTag: function editTag() {
      var self = this;
      self.loadingEdit = true;
      self.$http.post('/tch/lesson/edit-tag', {
        tchId: self.tchId,
        tchTag: self.tchTags
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.showEditTagsModal = false;
          self.$Message.success('提交成功!');
        }
        self.loadingEdit = false;
      });
    }
  },
  watch: {}
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





var LEVEL_OPTIONS = ['高危', '中危', '观察', '提示', '正常'];
var LEVEL_COLORS = {
  '高危': '#ed3f14',
  '中危': '#ff9900',
  '观察': '#f5c518',
  '提示': '#2d8cf0',
  '正常': '#19be6b'
};

var LEVEL_TAG_COLORS = {
  '高危': 'red',
  '观察': 'yellow',
  '提示': 'blue',
  '正常': 'green'
};
var METRIC_TITLES = {
  lastMonth: '上月请假明细',
  total: '全周期请假明细',
  continuous: '最长连续请假明细',
  singleMax: '单次最多课节明细'
};
function emptyQuery() {
  return {
    pageIndex: 1,
    pageSize: 20,
    tchId: '',
    tchName: '',
    studyAdviserId: '',
    level: '',
    onlyAnomaly: false,
    channel: null
  };
}
function pad2(n) {
  return n < 10 ? '0' + n : '' + n;
}
function monthStringToDate(ym) {
  if (!ym || typeof ym !== 'string') {
    return '';
  }
  var parts = ym.split('-');
  if (parts.length < 2) {
    return '';
  }
  var y = Number(parts[0]);
  var m = Number(parts[1]);
  if (!y || !m) {
    return '';
  }
  return new Date(y, m - 1, 1);
}
function toMonthString(v) {
  if (!v) {
    return '';
  }
  if (typeof v === 'string') {
    return v.length >= 7 ? v.slice(0, 7) : '';
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1);
  }
  return '';
}
function toDayString(v) {
  if (!v) {
    return '';
  }
  if (typeof v === 'string') {
    return v.length >= 10 ? v.slice(0, 10) : '';
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1) + '-' + pad2(v.getDate());
  }
  return '';
}
function isPositive(v) {
  return typeof v === 'number' && !isNaN(v) && v > 0;
}
function isInt(v) {
  return typeof v === 'number' && Math.floor(v) === v;
}
function errMsg(res, def) {
  return res && (res.msg || res.message) || def;
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRiskWarningList',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default.a },
  data: function data() {
    return {
      levelOptions: LEVEL_OPTIONS,
      searchLoading: false,
      rankScoreSeq: 0,
      showTchInfoModal: false,
      tchInfoId: null,
      dataList: [],
      totalCount: 0,
      levelCounts: {},
      studyAdviserList: [],
      monthDate: '',
      dateRange: [],
      statMonth: '',
      windowStart: '',
      windowEnd: '',
      appliedStatMonth: '',
      appliedWindowStart: '',
      appliedWindowEnd: '',
      fillingWindow: false,
      queryParam: emptyQuery(),
      columns: [],
      showRuleModal: false,
      ruleLoading: false,
      ruleSaveLoading: false,
      ruleResetLoading: false,
      ruleConfig: null,
      showLeaveDetailModal: false,
      leaveDetailLoading: false,
      leaveDetailTitle: '',
      leaveDetailMetric: '',
      leaveDetail: null,
      leaveDetailSeq: 0,
      leaveColumns: [],
      lessonColumns: []
    };
  },

  computed: {
    leaveDetailLeaves: function leaveDetailLeaves() {
      return this.leaveDetail && this.leaveDetail.leaves || [];
    },
    leaveDetailLessons: function leaveDetailLessons() {
      return this.leaveDetail && this.leaveDetail.lessons || [];
    },
    leaveDetailValueText: function leaveDetailValueText() {
      var d = this.leaveDetail;
      if (!d) {
        return '';
      }
      var v = d.value == null ? 0 : d.value;
      if (this.leaveDetailMetric === 'continuous') {
        return '连续 ' + v + ' 天';
      }
      if (this.leaveDetailMetric === 'singleMax') {
        return v + ' 节';
      }
      return '共 ' + v + ' 次';
    }
  },
  created: function created() {
    var self = this;
    this.columns = [{ title: '排名', key: 'rank', width: 60, align: 'center' }, { title: '老师ID', key: 'tchId', width: 80, align: 'center' }, {
      title: '老师姓名',
      key: 'tchName',
      width: 150,
      render: function render(h, params) {
        var row = params.row || {};
        var name = row.tchName || (row.tchId == null ? '' : String(row.tchId));
        if (!row.tchId) {
          return h('span', name || '—');
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
          text: name,
          score: row.monthRankScore,
          onClick: function onClick() {
            return self.openTchInfoModal(row.tchId);
          }
        });
      }
    }, {
      title: '外管',
      key: 'studyAdviserName',
      width: 90,
      render: function render(h, params) {
        return h('span', params.row.studyAdviserName || '—');
      }
    }, { title: '风险分', key: 'riskScore', width: 70, align: 'center' }, {
      title: '风险等级',
      key: 'level',
      width: 80,
      align: 'center',
      render: function render(h, params) {
        return self.renderLevelTag(h, params.row.level);
      }
    }, {
      title: '命中规则',
      key: 'hitRules',
      width: 380,
      render: function render(h, params) {
        var rules = params.row.hitRules || [];
        if (!rules.length) {
          return h('span', { style: { color: '#bbb' } }, '—');
        }
        return h('div', { style: { padding: '4px 0' } }, rules.map(function (r) {
          return self.renderHitRule(h, r);
        }));
      }
    }, {
      title: '上月请假次数',
      key: 'lastMonthLeaveCount',
      width: 100,
      align: 'center',
      render: function render(h, params) {
        return self.renderMetricCell(h, params.row, 'lastMonthLeaveCount', 'lastMonth');
      }
    }, {
      title: '全周期请假次数',
      key: 'totalLeaveCount',
      width: 110,
      align: 'center',
      render: function render(h, params) {
        return self.renderMetricCell(h, params.row, 'totalLeaveCount', 'total');
      }
    }, {
      title: '最长连续请假天数',
      key: 'maxContinuousDays',
      width: 120,
      align: 'center',
      render: function render(h, params) {
        return self.renderMetricCell(h, params.row, 'maxContinuousDays', 'continuous');
      }
    }, {
      title: '单次最多课节',
      key: 'maxSingleLessons',
      width: 100,
      align: 'center',
      render: function render(h, params) {
        return self.renderMetricCell(h, params.row, 'maxSingleLessons', 'singleMax');
      }
    }];
    this.leaveColumns = [{ title: '请假ID', key: 'id', width: 80, align: 'center' }, {
      title: '开始时间',
      key: 'startTime',
      width: 140,
      render: function render(h, params) {
        return h('span', self.formatUnix(params.row.startTime));
      }
    }, {
      title: '结束时间',
      key: 'endTime',
      width: 140,
      render: function render(h, params) {
        return h('span', self.formatUnix(params.row.endTime));
      }
    }, { title: '跨天数', key: 'days', width: 70, align: 'center' }, {
      title: '请假类型',
      key: 'leaveType',
      width: 120,
      render: function render(h, params) {
        var typeEnum = self.$constant.getEnum(self.$constant.tchLeaveType, params.row.leaveType);
        return h('span', typeEnum && typeEnum.text || '—');
      }
    }, { title: '影响课节数', key: 'lessonCount', width: 90, align: 'center' }, {
      title: '提交时间',
      key: 'gmtCreate',
      width: 150,
      render: function render(h, params) {
        return h('span', params.row.gmtCreate || '—');
      }
    }, {
      title: '备注',
      key: 'remark',
      render: function render(h, params) {
        return h('span', params.row.remark || '—');
      }
    }];
    this.lessonColumns = [{ title: '课节ID', key: 'id', width: 100, align: 'center' }, {
      title: '上课时间',
      key: 'lsnBeginTime',
      render: function render(h, params) {
        return h('span', self.formatUnix(params.row.lsnBeginTime));
      }
    }, { title: '学生UID', key: 'uid', width: 120, align: 'center' }, {
      title: '课节状态',
      key: 'lsnSelStatus',
      width: 120,
      render: function render(h, params) {
        var statusEnum = self.$constant.getEnum(self.$constant.lsnSelStatus, params.row.lsnSelStatus);
        return h('span', statusEnum && statusEnum.text || '—');
      }
    }];
  },
  mounted: function mounted() {
    var self = this;
    self.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (res && res.data) {
        self.studyAdviserList = res.data;
      }
    });
    self.search();
  },

  methods: {
    levelColor: function levelColor(level) {
      return LEVEL_COLORS[level] || '#bbb';
    },
    renderLevelTag: function renderLevelTag(h, level) {
      if (!level) {
        return h('span', '—');
      }
      if (LEVEL_TAG_COLORS[level]) {
        return h('Tag', { props: { color: LEVEL_TAG_COLORS[level] } }, level);
      }
      return h('Tag', {
        style: { background: LEVEL_COLORS[level] || '#fff', borderColor: LEVEL_COLORS[level] || '#e9eaec' }
      }, [h('span', { style: { color: '#fff' } }, level)]);
    },
    renderHitRule: function renderHitRule(h, r) {
      var counted = r.counted !== false;
      var tips = [h('div', r.actual ? '实际：' + r.actual : '实际：—'), h('div', '权重 ' + (r.weight == null ? '—' : r.weight))];
      if (!counted) {
        tips.push(h('div', '（同组已取更高权重，不计分）'));
      }
      return h('Tooltip', {
        props: { placement: 'top', transfer: true },
        style: { marginRight: '4px' }
      }, [h('Tag', {
        style: counted ? {} : { opacity: 0.45, textDecoration: 'line-through' }
      }, (r.code || '') + ' ' + (r.name || '')), h('div', { slot: 'content' }, tips)]);
    },
    reset: function reset() {
      this.queryParam = emptyQuery();
      this.statMonth = '';
      this.windowStart = '';
      this.windowEnd = '';
      this.fillingWindow = true;
      this.monthDate = '';
      this.dateRange = [];
      var self = this;
      this.$nextTick(function () {
        self.fillingWindow = false;
      });
      this.search();
    },
    onStatMonthChange: function onStatMonthChange(val) {
      if (this.fillingWindow) {
        return;
      }
      this.statMonth = toMonthString(val);
    },
    onWindowChange: function onWindowChange(value) {
      if (this.fillingWindow) {
        return;
      }
      var start = value && value.length === 2 ? toDayString(value[0]) : '';
      var end = value && value.length === 2 ? toDayString(value[1]) : '';
      if (start && end) {
        this.windowStart = start;
        this.windowEnd = end;
      } else {
        this.windowStart = '';
        this.windowEnd = '';
      }
    },
    applyReturnedWindow: function applyReturnedWindow(data) {
      var statMonth = data && data.lastMonth || '';
      var windowStart = data && data.windowStart || '';
      var windowEnd = data && data.windowEnd || '';
      this.appliedStatMonth = statMonth;
      this.appliedWindowStart = windowStart;
      this.appliedWindowEnd = windowEnd;
      this.fillingWindow = true;
      this.monthDate = monthStringToDate(statMonth);
      this.dateRange = windowStart && windowEnd ? [windowStart, windowEnd] : [];
      this.statMonth = statMonth;
      this.windowStart = windowStart;
      this.windowEnd = windowEnd;
      var self = this;
      this.$nextTick(function () {
        self.fillingWindow = false;
      });
    },
    filterByLevel: function filterByLevel(level) {
      this.queryParam.level = level;
      this.search();
    },
    onPageChange: function onPageChange(page) {
      this.queryParam.pageIndex = page;
      this.search(false);
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.queryParam.pageSize = size;
      this.queryParam.pageIndex = 1;
      this.search(false);
    },
    buildListParams: function buildListParams() {
      var params = {
        pageIndex: this.queryParam.pageIndex,
        pageSize: this.queryParam.pageSize
      };
      if (this.queryParam.tchId) {
        params.tchId = Number(this.queryParam.tchId);
      }
      if (this.queryParam.tchName) {
        params.tchName = this.queryParam.tchName;
      }
      if (this.queryParam.studyAdviserId) {
        params.studyAdviserId = this.queryParam.studyAdviserId;
      }
      if (this.queryParam.level) {
        params.level = this.queryParam.level;
      }
      if (this.queryParam.onlyAnomaly) {
        params.onlyAnomaly = 1;
      }
      if (this.queryParam.channel) {
        params.channel = this.queryParam.channel;
      }
      if (this.statMonth) {
        params.statMonth = this.statMonth;
      }
      if (this.windowStart && this.windowEnd) {
        params.windowStart = this.windowStart;
        params.windowEnd = this.windowEnd;
      }
      return params;
    },
    search: function search(resetPage) {
      if (resetPage !== false) {
        this.queryParam.pageIndex = 1;
      }
      var self = this;
      self.searchLoading = true;
      self.$http.post('/tch/risk-warning/list', self.buildListParams()).then(function (res) {
        self.searchLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
          self.levelCounts = res.data.levelCounts || {};
          self.applyReturnedWindow(res.data);
          self.loadMonthRankScores();
        } else {
          self.dataList = [];
          self.totalCount = 0;
          self.levelCounts = {};
          self.$Message.error(errMsg(res, '列表加载失败'));
        }
      }).catch(function () {
        self.searchLoading = false;
      });
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.dataList || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchInfoId = tchId;
      this.showTchInfoModal = true;
    },
    formatUnix: function formatUnix(ts) {
      if (!ts) {
        return '—';
      }
      return this.$moment(ts, 'X').format('YYYY-MM-DD HH:mm');
    },
    renderMetricCell: function renderMetricCell(h, row, key, metric) {
      var _this = this;

      var v = row[key];
      if (!isPositive(v) || !row.tchId) {
        return h('span', v == null ? 0 : v);
      }
      return h('a', {
        attrs: { href: 'javascript:;' },
        on: {
          click: function click() {
            _this.openLeaveDetail(row, metric);
          }
        }
      }, v);
    },
    openLeaveDetail: function openLeaveDetail(row, metric) {
      var self = this;
      var seq = self.leaveDetailSeq + 1;
      self.leaveDetailSeq = seq;
      self.leaveDetail = null;
      self.leaveDetailMetric = metric;
      var name = row.tchName || String(row.tchId);
      self.leaveDetailTitle = name + ' · ' + (METRIC_TITLES[metric] || '请假明细');
      self.showLeaveDetailModal = true;
      self.leaveDetailLoading = true;
      var detailParams = { tchId: row.tchId, metric: metric };
      if (self.appliedStatMonth) {
        detailParams.statMonth = self.appliedStatMonth;
      }
      if (self.appliedWindowStart && self.appliedWindowEnd) {
        detailParams.windowStart = self.appliedWindowStart;
        detailParams.windowEnd = self.appliedWindowEnd;
      }
      self.$http.post('/tch/risk-warning/leave-detail', detailParams).then(function (res) {
        if (seq !== self.leaveDetailSeq) {
          return;
        }
        if (res && res.status === 'ok' && res.data) {
          self.leaveDetail = res.data;
        } else {
          self.$Message.error(errMsg(res, '明细加载失败'));
        }
      }).catch(function () {
        if (seq === self.leaveDetailSeq) {
          self.$Message.error('明细加载失败');
        }
      }).finally(function () {
        if (seq === self.leaveDetailSeq) {
          self.leaveDetailLoading = false;
        }
      });
    },
    paramStep: function paramStep(p) {
      return p.key === 'ratio' && Number(p.value) < 10 ? 0.1 : 1;
    },
    openRuleModal: function openRuleModal() {
      var self = this;
      self.ruleConfig = null;
      self.showRuleModal = true;
      self.ruleLoading = true;
      self.$http.post('/tch/risk-warning/rules', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.ruleConfig = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        } else {
          self.$Message.error(errMsg(res, '规则加载失败'));
        }
      }).catch(function () {
        self.$Message.error('规则加载失败');
      }).finally(function () {
        self.ruleLoading = false;
      });
    },
    validateRules: function validateRules(c) {
      if (!isInt(c.lookbackMonths) || c.lookbackMonths < 6 || c.lookbackMonths > 36) {
        return '回溯月数需为 6~36 的整数';
      }
      if (!(isInt(c.high) && isInt(c.medium) && isInt(c.watch) && isInt(c.hint))) {
        return '分档线需为整数';
      }
      if (!(c.high > c.medium && c.medium > c.watch && c.watch >= c.hint && c.hint >= 1)) {
        return '分档线需满足 高危 > 中危 > 观察 ≥ 提示 ≥ 1';
      }
      if (!isInt(c.upgradeWeight) || c.upgradeWeight < 1) {
        return '升级单条权重需为正整数';
      }
      if (!isInt(c.anomalyScore) || c.anomalyScore < 1) {
        return '异动线需为正整数';
      }
      var rules = c.rules || [];
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (!isInt(r.weight) || r.weight < 0 || r.weight > 20) {
          return r.code + ' 权重需为 0~20 的整数';
        }
        if (!r.mutexGroup || !String(r.mutexGroup).trim()) {
          return r.code + ' 互斥组不能为空';
        }
        var ps = r.params || [];
        for (var j = 0; j < ps.length; j++) {
          if (!isPositive(ps[j].value)) {
            return r.code + ' 参数「' + ps[j].label + '」需为正数';
          }
        }
      }
      return '';
    },
    saveRules: function saveRules() {
      var self = this;
      var c = self.ruleConfig;
      if (!c) {
        return;
      }
      var msg = self.validateRules(c);
      if (msg) {
        self.$Message.error(msg);
        return;
      }
      (c.rules || []).forEach(function (r) {
        r.mutexGroup = String(r.mutexGroup).trim();
      });
      self.ruleSaveLoading = true;
      self.$http.post('/tch/risk-warning/rules-save', {
        rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(c)
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('规则已保存');
          self.showRuleModal = false;
          self.search();
        } else {
          self.$Message.error(errMsg(res, '保存失败'));
        }
      }).catch(function () {
        self.$Message.error('保存失败');
      }).finally(function () {
        self.ruleSaveLoading = false;
      });
    },
    resetRules: function resetRules() {
      var self = this;
      self.$Modal.confirm({
        title: '恢复默认',
        content: '确定恢复为默认规则？当前自定义的参数、权重、互斥组和启停将被清除。',
        onOk: function onOk() {
          self.ruleResetLoading = true;
          self.$http.post('/tch/risk-warning/rules-save', { reset: 1 }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已恢复默认规则');
              self.showRuleModal = false;
              self.search();
            } else {
              self.$Message.error(errMsg(res, '恢复默认失败'));
            }
          }).catch(function () {
            self.$Message.error('恢复默认失败');
          }).finally(function () {
            self.ruleResetLoading = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: ''
      },
      title: [{
        title: '老师姓名',

        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, {
        title: '老师账号',
        key: 'tchEmail',

        align: 'center'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm:ss') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '状态',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.tchSignLogStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '签到时间',
        align: 'center',

        render: function render(h, params) {
          var updateTime = params.row.updateTime;
          return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        renderHeader: function renderHeader(h, params) {
          return h('div', [h('span', '是否'), h('br'), h('span', '是补签')]);
        },

        align: 'center',
        render: function render(h, params) {
          var isOperatorSign = params.row.isOperatorSign;
          var sign = isOperatorSign === 1 ? '是' : '否';
          return h('span', sign);
        }
      }, {
        align: 'center',
        renderHeader: function renderHeader(h, params) {
          return h('div', [h('span', '补签'), h('br'), h('span', '操作人')]);
        },

        key: 'operator'
      }, {
        title: '补签时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var operatorTime = params.row.operatorTime;
          return h('span', operatorTime && $moment(operatorTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '创建时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          if (params.row.status === 2) {
            return h('div', [h('a', { on: { click: function click() {
                  _this.onCancel(params.row);
                } } }, '补签')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    onCancel: function onCancel(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定补签？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tchSignLog/makeUp', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('补签成功!');
            self.$Modal.remove();
          });
        }
      });
    }
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_1__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      showTchInfoModal: false,
      tchId: null,
      dateRange: [],
      studyAdviserList: [],
      queryParam: {
        startTime: null,
        endTime: null,
        studyAdviserId: null,
        tchId: '',
        tchName: ''
      },
      title: [{
        title: '老师ID/姓名',

        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, {
        title: '授课类型',

        align: 'center',
        render: function render(h, params) {
          var tchType = params.row.tchType;
          var typeEnum = $constant.getEnum($constant.tchType, tchType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '首课时间',
        align: 'center',

        render: function render(h, params) {
          var firstLessonTime = params.row.firstLessonTime;
          return h('span', firstLessonTime && $moment(firstLessonTime, 'X').format('HH:mm'));
        }
      }, {
        title: '签到时间',
        align: 'center',

        render: function render(h, params) {
          var signInTime = params.row.signInTime;
          var lateSign = params.row.lateSign;
          var style = lateSign === 1 || lateSign === 2 ? 'color: #ed4014' : '';
          return h('span', { style: style }, signInTime && $moment(signInTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '外管',
        align: 'center',
        key: 'studyAdviser'
      }, {
        title: '签到状态',
        align: 'center',
        render: function render(h, params) {
          var lateSign = params.row.lateSign;
          if (lateSign === 1) {
            return h('span', { style: 'color: #ed4014' }, '晚签');
          } else if (lateSign === 2) {
            return h('span', { style: 'color: #ed4014' }, '迟到');
          }
          return h('span', '正常');
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query) {
      if (query.startTime) {
        self.dateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates___default.a.format(query.startTime * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
      if (query.endTime) {
        self.dateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates___default.a.format(query.endTime * 1000, 'YYYY-MM-DD HH:mm:ss') + '';
      }
    }
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },
  created: function created() {
    this.initDateRange();
  },
  methods: {
    initDateRange: function initDateRange() {
      var startTime = new Date(new Date().toLocaleDateString()).getTime();
      var startDate = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates___default.a.format(startTime, 'YYYY-MM-DD HH:mm:ss');
      var endTime = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
      var endDate = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates___default.a.format(endTime, 'YYYY-MM-DD HH:mm:ss');
      this.dateRange = [startDate, endDate];
      this.queryParam.startTime = parseInt(startTime / 1000);
      this.queryParam.endTime = parseInt(endTime / 1000);
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    onDateChange: function onDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryParam.startTime = parseInt(new Date(dateRange[0]).getTime() / 1000);
        this.queryParam.endTime = parseInt(new Date(dateRange[1]).getTime() / 1000);
      } else {
        this.queryParam.startTime = parseInt(new Date(this.dateRange[0]).getTime() / 1000);
        this.queryParam.endTime = parseInt(new Date(this.dateRange[1]).getTime() / 1000);
      }
      this.search();
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue__);






var ALL_START_DATE = '2018-01-01';

var METRICS = [{ title: '全勤率', weight: 20, value: 'fullAttendanceRate', grade: 'fullAttendanceGrade', score: 'fullAttendanceScore' }, { title: '上课率', weight: 30, value: 'attendLessonRate', grade: 'attendLessonGrade', score: 'attendLessonScore' }, { title: '星级评价', weight: 15, value: 'starRating', grade: 'starGrade', score: 'starScore', extra: 'ratedCount', extraLabel: '已评分节数' }, { title: '请假率', weight: 10, value: 'leaveRate', grade: 'leaveGrade', score: 'leaveScore' }, { title: '临时请假率', weight: 6, value: 'tempLeaveRate', grade: 'tempLeaveGrade', score: 'tempLeaveScore' }, { title: '迟到率', weight: 4, value: 'lateRate', grade: 'lateGrade', score: 'lateScore' }, { title: '早退率', weight: 4, value: 'earlyRate', grade: 'earlyGrade', score: 'earlyScore' }, { title: '退费学生数', weight: 6, value: 'refundStudentCount', grade: 'refundGrade', score: 'refundScore' }, { title: '返课时数', weight: 3, value: 'returnLessonHours', grade: 'returnLessonGrade', score: 'returnLessonScore' }, { title: 'Demo成交率', weight: 2, value: 'demoAttendDealRate', grade: 'demoGrade', score: 'demoScore', extra: 'demoAttendCount', extraLabel: 'Demo出席学生数' }];

var ROOKIE_METRICS = [{ title: '星级评价', weight: 60, value: 'starRating', grade: 'starGrade', score: 'starScore', extra: 'ratedCount', extraLabel: '已评分节数' }, { title: '全勤率', weight: 6, value: 'fullAttendanceRate', grade: 'fullAttendanceGrade', score: 'fullAttendanceScore' }, { title: '上课率', weight: 4, value: 'attendLessonRate', grade: 'attendLessonGrade', score: 'attendLessonScore' }, { title: '请假率', weight: 6, value: 'leaveRate', grade: 'leaveGrade', score: 'leaveScore' }, { title: '临时请假率', weight: 5, value: 'tempLeaveRate', grade: 'tempLeaveGrade', score: 'tempLeaveScore' }, { title: '迟到率', weight: 4, value: 'lateRate', grade: 'lateGrade', score: 'lateScore' }, { title: '早退率', weight: 4, value: 'earlyRate', grade: 'earlyGrade', score: 'earlyScore' }, { title: '退费学生数', weight: 6, value: 'refundStudentCount', grade: 'refundGrade', score: 'refundScore' }, { title: '返课时数', weight: 3, value: 'returnLessonHours', grade: 'returnLessonGrade', score: 'returnLessonScore' }, { title: 'Demo成交率', weight: 2, value: 'demoAttendDealRate', grade: 'demoGrade', score: 'demoScore', extra: 'demoAttendCount', extraLabel: 'Demo出席学生数' }];

var GRADE_WIDTH = { A: '100%', B: '80%', C: '60%', D: '30%', E: '6%', OUT: '6%' };

function pad(n) {
  return n < 10 ? '0' + n : '' + n;
}

function formatDate(date) {
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
}

function isBlank(val) {
  return val === null || val === undefined || val === '';
}

function toDateText(val) {
  if (val instanceof Date) {
    return isNaN(val.getTime()) ? '' : formatDate(val);
  }
  return isBlank(val) ? '' : String(val).slice(0, 10);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchTeacherRanking',
  components: {
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue___default.a
  },
  data: function data() {
    return {
      periodOptions: [{ label: '日', value: 'day' }, { label: '周', value: 'week' }, { label: '月', value: 'month' }, { label: '年', value: 'year' }, { label: '全部', value: 'all' }],
      metrics: METRICS,
      rookieMetrics: ROOKIE_METRICS,
      podiumMetrics: METRICS.slice(0, 3),
      periodType: 'month',
      dateRange: [],
      studyAdviserId: null,
      sex: null,
      boardFilter: '',
      boardFilterOptions: [{ label: '老老师', value: 'veteran' }, { label: '新锐榜', value: 'rookie' }, { label: '出榜老师', value: 'out' }],
      studyAdviserList: [],
      openCourseRange: [],
      exportLoading: false,
      champion: null,
      podiumCache: [],
      expanded: {},
      rookieExpanded: {},
      frPageIndex: 1,
      frPageSize: 20,
      frTotal: 0,
      frData: [],
      frLoading: false,
      frSeq: 0,
      fuPageIndex: 1,
      fuPageSize: 20,
      fuTotal: 0,
      fuData: [],
      fuLoading: false,
      fuSeq: 0,
      rrPageIndex: 1,
      rrPageSize: 20,
      rrTotal: 0,
      rrData: [],
      rrLoading: false,
      rrSeq: 0,
      ruPageIndex: 1,
      ruPageSize: 20,
      ruTotal: 0,
      ruData: [],
      ruLoading: false,
      ruSeq: 0,
      showTchInfoModal: false,
      tchId: null,
      ruleModal: false,
      ruleRows: [{ name: '上课率', dir: '正', weight: 30, grades: ['≥95%', '≥85%', '≥70%', '≥50%', '<50%'] }, { name: '全勤率', dir: '正', weight: 20, grades: ['≥95%', '≥85%', '≥70%', '≥50%', '<50%'] }, { name: '星级评价', dir: '正', weight: 15, grades: ['≥4.50', '≥4.00', '≥3.50', '≥3.00', '<3.00'] }, { name: '请假率', dir: '反', weight: 10, grades: ['0', '≤1.5%', '≤2.5%', '≤4%', '>4%'] }, { name: '临时请假率', dir: '反', weight: 6, grades: ['0', '≤0.6%', '≤1.2%', '≤2%', '>2%'] }, { name: '迟到率', dir: '反', weight: 4, grades: ['0', '≤1%', '≤3%', '≤5%', '>5%'] }, { name: '早退率', dir: '反', weight: 4, grades: ['0', '≤1%', '≤3%', '≤5%', '>5%'] }, { name: '退费学生数', dir: '反', weight: 6, grades: ['0 人', '1 人', '2 人', '3 人', '>3 人出榜'] }, { name: '返课时数', dir: '反', weight: 3, grades: ['0', '≤3', '≤5', '≤8', '>8 出榜'] }, { name: 'Demo 出席成交率', dir: '正', weight: 2, grades: ['≥20%', '其余（含无 Demo）', '—', '—', '—'] }],
      rookieRuleRows: [{ name: '星级评价', dir: '正', weight: 60, grades: ['≥4.50', '≥4.00', '≥3.50', '≥3.00', '<3.00'] }, { name: '全勤率', dir: '正', weight: 6, grades: ['≥95%', '≥85%', '≥70%', '≥50%', '<50%'] }, { name: '上课率', dir: '正', weight: 4, grades: ['≥95%', '≥85%', '≥70%', '≥50%', '<50%'] }, { name: '请假率', dir: '反', weight: 6, grades: ['0', '≤1.5%', '≤2.5%', '≤4%', '>4%'] }, { name: '临时请假率', dir: '反', weight: 5, grades: ['0', '≤0.6%', '≤1.2%', '≤2%', '>2%'] }, { name: '迟到率', dir: '反', weight: 4, grades: ['0', '≤1%', '≤3%', '≤5%', '>5%'] }, { name: '早退率', dir: '反', weight: 4, grades: ['0', '≤1%', '≤3%', '≤5%', '>5%'] }, { name: '退费学生数', dir: '反', weight: 6, grades: ['0 人', '1 人', '2 人', '3 人', '>3 人（不出榜）'] }, { name: '返课时数', dir: '反', weight: 3, grades: ['0', '≤3', '≤5', '≤8', '>8（不出榜）'] }, { name: 'Demo 出席成交率', dir: '正', weight: 2, grades: ['≥20%', '≥10%', '其余（含无 Demo）', '—', '—'] }]
    };
  },

  computed: {
    pageLoading: function pageLoading() {
      return this.frLoading || this.fuLoading || this.rrLoading || this.ruLoading;
    },
    showPodium: function showPodium() {
      return !this.boardFilter;
    },
    showChallengers: function showChallengers() {
      return !this.boardFilter || this.boardFilter === 'veteran';
    },
    showFormalUnranked: function showFormalUnranked() {
      return !this.boardFilter || this.boardFilter === 'out';
    },
    showRookie: function showRookie() {
      return !this.boardFilter || this.boardFilter === 'rookie';
    },
    showRookieUnranked: function showRookieUnranked() {
      return !this.boardFilter;
    },
    formalUnrankedTitle: function formalUnrankedTitle() {
      return this.boardFilter === 'out' ? '出榜老师' : '挑战者未入榜';
    },
    formalUnrankedLegend: function formalUnrankedLegend() {
      if (this.boardFilter === 'out') {
        return '退费学生数 > 3 或返课时数 > 8；名单随上方统计周期变化';
      }
      return '结束日当周买断<20，或退费学生数>3 / 返课时数>8；名单随上方统计周期变化';
    },
    formalUnrankedEmpty: function formalUnrankedEmpty() {
      return this.boardFilter === 'out' ? '暂无出榜老师' : '暂无未入榜老师';
    },
    podium: function podium() {
      var top = (this.podiumCache || []).filter(function (row) {
        return Number(row.rank) <= 3;
      });
      var byRank = {};
      top.forEach(function (row) {
        byRank[row.rank] = row;
      });
      return [byRank[2], byRank[1], byRank[3]].filter(Boolean);
    },
    challengers: function challengers() {
      return (this.frData || []).filter(function (row) {
        return !isBlank(row.rank) && Number(row.rank) > 3;
      });
    },
    fuRows: function fuRows() {
      var rows = this.fuData || [];
      if (this.boardFilter === 'out') {
        return rows.filter(function (row) {
          return !isBlank(row.outReason);
        });
      }
      return rows;
    },
    rrRows: function rrRows() {
      return this.rrData || [];
    },
    ruRows: function ruRows() {
      return this.ruData || [];
    },
    heroStats: function heroStats() {
      return [{ label: '挑战者', value: this.frTotal }, { label: '挑战者未入榜', value: this.fuTotal }, { label: '新锐', value: this.rrTotal }, { label: '新锐未入榜', value: this.ruTotal }];
    },
    showEmpty: function showEmpty() {
      if (this.pageLoading) {
        return false;
      }
      return this.frTotal === 0 && this.fuTotal === 0 && this.rrTotal === 0 && this.ruTotal === 0;
    }
  },
  mounted: function mounted() {
    this.applyPeriod('month');
    this.loadStudyAdviserList();
    this.searchAll();
  },

  methods: {
    loadStudyAdviserList: function loadStudyAdviserList() {
      var _this = this;

      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.studyAdviserList = res.data;
        }
      });
    },
    applyPeriod: function applyPeriod(type) {
      var today = new Date();
      var start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      if (type === 'week') {
        var day = start.getDay() || 7;
        start.setDate(start.getDate() - day + 1);
      } else if (type === 'month') {
        start = new Date(today.getFullYear(), today.getMonth(), 1);
      } else if (type === 'year') {
        start = new Date(today.getFullYear(), 0, 1);
      }
      var startText = type === 'all' ? ALL_START_DATE : formatDate(start);
      this.dateRange = [startText, formatDate(today)];
    },
    onPeriodTypeChange: function onPeriodTypeChange(type) {
      this.periodType = type;
      this.applyPeriod(type);
      this.onFilterChange();
    },
    onDateRangeChange: function onDateRangeChange() {
      this.periodType = '';
      this.onFilterChange();
    },
    onFilterChange: function onFilterChange() {
      var _this2 = this;

      this.frPageIndex = 1;
      this.fuPageIndex = 1;
      this.rrPageIndex = 1;
      this.ruPageIndex = 1;
      this.$nextTick(function () {
        _this2.searchAll();
      });
    },
    onFrPageChange: function onFrPageChange(page) {
      this.frPageIndex = page;
      this.searchBlock('fr');
    },
    onFuPageChange: function onFuPageChange(page) {
      this.fuPageIndex = page;
      this.searchBlock('fu');
    },
    onRrPageChange: function onRrPageChange(page) {
      this.rrPageIndex = page;
      this.searchBlock('rr');
    },
    onRuPageChange: function onRuPageChange(page) {
      this.ruPageIndex = page;
      this.searchBlock('ru');
    },
    buildQuery: function buildQuery(pageIndex, pageSize, board, listType) {
      var query = {
        startDate: toDateText(this.dateRange[0]),
        endDate: toDateText(this.dateRange[1]),
        pageIndex: pageIndex,
        pageSize: pageSize,
        listType: listType
      };
      if (board === 'rookie') {
        query.board = 'rookie';
      } else {
        query.board = 'formal';
        query.tier = 5;
      }
      var adviserId = Number(this.studyAdviserId);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(adviserId) && adviserId > 0) {
        query.studyAdviserId = adviserId;
      }
      var sex = Number(this.sex);
      if (sex === 1 || sex === 2) {
        query.sex = sex;
      }
      if (this.openCourseRange && toDateText(this.openCourseRange[0]) && toDateText(this.openCourseRange[1])) {
        query.startOpenCourseDate = toDateText(this.openCourseRange[0]);
        query.endOpenCourseDate = toDateText(this.openCourseRange[1]);
      }
      return query;
    },
    searchAll: function searchAll() {
      this.searchBlock('fr');
      this.searchBlock('fu');
      this.searchBlock('rr');
      this.searchBlock('ru');
    },
    blockMeta: function blockMeta(key) {
      var map = {
        fr: { board: 'formal', listType: 'ranked', pageIndex: 'frPageIndex', pageSize: 'frPageSize', total: 'frTotal', data: 'frData', loading: 'frLoading', seq: 'frSeq', label: '挑战者' },
        fu: { board: 'formal', listType: 'unranked', pageIndex: 'fuPageIndex', pageSize: 'fuPageSize', total: 'fuTotal', data: 'fuData', loading: 'fuLoading', seq: 'fuSeq', label: '挑战者未入榜' },
        rr: { board: 'rookie', listType: 'ranked', pageIndex: 'rrPageIndex', pageSize: 'rrPageSize', total: 'rrTotal', data: 'rrData', loading: 'rrLoading', seq: 'rrSeq', label: '新锐榜' },
        ru: { board: 'rookie', listType: 'unranked', pageIndex: 'ruPageIndex', pageSize: 'ruPageSize', total: 'ruTotal', data: 'ruData', loading: 'ruLoading', seq: 'ruSeq', label: '新锐榜未入榜' }
      };
      return map[key];
    },
    searchBlock: function searchBlock(key) {
      var _this3 = this;

      if (!this.dateRange || !toDateText(this.dateRange[0]) || !toDateText(this.dateRange[1])) {
        return;
      }
      var meta = this.blockMeta(key);
      if (!meta) {
        return;
      }
      var seq = ++this[meta.seq];
      var query = this.buildQuery(this[meta.pageIndex], this[meta.pageSize], meta.board, meta.listType);
      this[meta.loading] = true;
      this.$http.post('/tch/hr-ranking', query).then(function (res) {
        if (seq !== _this3[meta.seq]) {
          return;
        }
        if (res && res.status === 'ok' && res.data) {
          var rows = res.data.data || [];
          _this3[meta.data] = rows;
          _this3[meta.total] = res.data.totalCount || 0;
          if (key === 'fr') {
            _this3.expanded = {};
            if (_this3.frPageIndex === 1) {
              _this3.podiumCache = rows.filter(function (row) {
                return !isBlank(row.rank) && Number(row.rank) <= 3;
              });
              _this3.champion = rows.find(function (row) {
                return Number(row.rank) === 1;
              }) || null;
            }
          }
          if (key === 'rr') {
            _this3.rookieExpanded = {};
          }
        } else {
          _this3.resetBlock(key);
          _this3.$Message.error(res && res.msg || meta.label + '加载失败');
        }
      }).catch(function () {
        if (seq !== _this3[meta.seq]) {
          return;
        }
        _this3.resetBlock(key);
        _this3.$Message.error(meta.label + '加载失败');
      }).finally(function () {
        if (seq === _this3[meta.seq]) {
          _this3[meta.loading] = false;
        }
      });
    },
    resetBlock: function resetBlock(key) {
      var meta = this.blockMeta(key);
      if (!meta) {
        return;
      }
      this[meta.data] = [];
      this[meta.total] = 0;
      if (key === 'fr') {
        this.champion = null;
        this.podiumCache = [];
        this.expanded = {};
      }
      if (key === 'rr') {
        this.rookieExpanded = {};
      }
    },
    toggle: function toggle(tchId) {
      this.$set(this.expanded, tchId, !this.expanded[tchId]);
    },
    toggleRookie: function toggleRookie(tchId) {
      this.$set(this.rookieExpanded, tchId, !this.rookieExpanded[tchId]);
    },
    rookieRank: function rookieRank(row, idx) {
      return isBlank(row.rank) ? idx + 1 : row.rank;
    },
    unrankedReasonText: function unrankedReasonText(row) {
      if (!row) {
        return '';
      }
      var parts = [];
      if (!isBlank(row.unrankedReason)) {
        parts.push(row.unrankedReason);
      }
      if (!isBlank(row.outReason)) {
        parts.push(row.outReason);
      }
      return parts.join('；');
    },
    isOutOnly: function isOutOnly(row) {
      return row && isBlank(row.unrankedReason) && !isBlank(row.outReason);
    },
    unrankedBadge: function unrankedBadge(row) {
      return this.isOutOnly(row) ? '出榜' : '未入榜';
    },
    openTchInfo: function openTchInfo(row) {
      var id = Number(row && row.tchId);
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(id) || id <= 0) {
        return;
      }
      this.tchId = id;
      this.showTchInfoModal = true;
    },
    initials: function initials(name) {
      if (isBlank(name)) {
        return '?';
      }
      var parts = String(name).trim().split(/\s+/);
      var text = parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2);
      return text.toUpperCase();
    },
    medalClass: function medalClass(rank) {
      var r = Number(rank);
      if (r === 1) {
        return 'is-gold';
      }
      if (r === 2) {
        return 'is-silver';
      }
      if (r === 3) {
        return 'is-bronze';
      }
      return r <= 10 ? 'is-navy' : 'is-plain';
    },
    rankTitle: function rankTitle(rank) {
      return { 1: 'CHAMPION', 2: 'RUNNER-UP', 3: 'THIRD' }[rank] || '';
    },
    formatOpenCourse: function formatOpenCourse(val) {
      if (isBlank(val)) {
        return '—';
      }
      if (typeof val === 'number') {
        return formatDate(new Date(val));
      }
      return String(val).slice(0, 10);
    },
    formatScore: function formatScore(val) {
      if (isBlank(val)) {
        return '—';
      }
      var num = Number(val);
      return isNaN(num) ? String(val) : num.toFixed(2);
    },
    formatScoreShort: function formatScoreShort(val) {
      var num = Number(val);
      if (isBlank(val) || isNaN(num)) {
        return '—';
      }
      return num % 1 === 0 ? String(num) : num.toFixed(1);
    },
    displayValue: function displayValue(val) {
      return isBlank(val) ? '—' : String(val);
    },
    gradeText: function gradeText(grade) {
      if (isBlank(grade)) {
        return '—';
      }
      return grade;
    },
    gradeLevel: function gradeLevel(grade) {
      if (grade === 'A' || grade === 'B') {
        return 'is-healthy';
      }
      if (grade === 'C') {
        return 'is-warning';
      }
      if (grade === 'D' || grade === 'E' || grade === 'OUT') {
        return 'is-danger';
      }
      return '';
    },
    gradeWidth: function gradeWidth(grade) {
      return GRADE_WIDTH[grade] || '0%';
    },
    scoreLevel: function scoreLevel(score) {
      var num = Number(score);
      if (num >= 85) {
        return 'is-healthy';
      }
      if (num >= 70) {
        return 'is-warning';
      }
      return 'is-danger';
    },
    exportToImage: function exportToImage() {
      var _this4 = this;

      if (this.frTotal === 0 && this.fuTotal === 0 && this.rrTotal === 0 && this.ruTotal === 0) {
        this.$Message.warning('暂无数据，无法导出');
        return;
      }
      if (this.exportLoading) {
        return;
      }
      this.exportLoading = true;
      var start = toDateText(this.dateRange[0]);
      var end = toDateText(this.dateRange[1]);
      var el = this.$refs.exportArea;
      var prevWidth = el.style.width;
      el.style.width = '1120px';
      __WEBPACK_IMPORTED_MODULE_1_html2canvas___default()(el, {
        scale: 2,
        backgroundColor: '#F5F6FA',
        useCORS: true,
        onclone: function onclone(doc) {
          doc.querySelectorAll('.export-skip').forEach(function (node) {
            node.style.display = 'none';
          });
          doc.querySelectorAll('.podium-col, .rank-card, .hero').forEach(function (node) {
            node.style.animation = 'none';
            node.style.opacity = '1';
            node.style.transform = 'none';
          });
          var stage = doc.querySelector('.stage');
          if (stage) {
            stage.style.background = '#172440';
          }
        }
      }).then(function (canvas) {
        el.style.width = prevWidth;
        var link = document.createElement('a');
        link.download = '优秀外教排行榜_' + start + '_' + end + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        _this4.exportLoading = false;
        _this4.$Message.success('导出成功');
      }).catch(function () {
        el.style.width = prevWidth;
        _this4.exportLoading = false;
        _this4.$Message.error('导出失败');
      });
    },
    ringStyle: function ringStyle(score) {
      var num = Math.max(0, Math.min(100, Number(score) || 0));
      var level = this.scoreLevel(score);
      var color = level === 'is-healthy' ? '#0B9E8D' : level === 'is-warning' ? '#E89F2D' : '#E6464E';
      return { background: 'conic-gradient(' + color + ' ' + num * 3.6 + 'deg, #EEF0F5 0deg)' };
    },
    metricTip: function metricTip(row, metric) {
      var gradeLabel = (row[metric.grade] || '—') + ' 档';
      var tip = metric.title + '（权重 ' + metric.weight + '）：' + this.displayValue(row[metric.value]) + ' · ' + gradeLabel + ' · ' + this.formatScore(row[metric.score]) + ' 分';
      if (metric.extra && !isBlank(row[metric.extra])) {
        tip += ' · ' + metric.extraLabel + ' ' + row[metric.extra];
      }
      return tip;
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__order_ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__order_ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__order_ShowImageCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_trackContentAttach__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview_src_components_grid_row__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a, ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_2__order_ShowImageCarousel_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      showImgModal: false,
      tchId: null,
      showTchInfoModal: false,
      showImgList: [],
      reload: 0,
      editUser: false,
      uid: null,
      queryParam: {
        uid: '',
        mobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        type: '',
        tchId: null,
        subType: null,
        auditorName: ''
      },
      title: [{
        title: '老师ID/姓名',

        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' ' + row.tchName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, {
        title: '添加时间',
        align: 'center',
        width: 170,
        key: 'gmtCreate'
      }, {
        title: '类型',
        align: 'center',
        key: 'trackType',

        render: function render(h, params) {
          var type = params.row.trackType;
          var typeEnum = $constant.getEnum($constant.tchTrackRecordType, type);
          return h('div', typeEnum && typeEnum.text);
        }
      }, {
        title: '内容',
        align: 'center',
        width: 250,
        render: function render(h, params) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_trackContentAttach__["a" /* renderTrackContentAttach */])(h, params.row.content, function (urls, index) {
            return _this.viewFile(urls, index);
          });
        }
      }, {
        title: '外管',
        align: 'center',

        key: 'adminName'
      }, {
        title: '图片',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          if (row.picUrl) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看图片');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '处理人',
        align: 'center',

        key: 'modifierName'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                _this.ondelete(params.row);
              } } }, '删除')]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query.startTime) {
      this.queryParam.startTimeDate = parseInt(query.startTime) * 1000;
    }
    if (query.endTime) {
      this.queryParam.endTimeDate = parseInt(query.endTime) * 1000;
    }
  },
  created: function created() {},
  methods: {
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    viewFile: function viewFile(urls, index) {
      this.showImgList = urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;
      this.editUser = true;
    },
    searchWithPage: function searchWithPage() {
      this.reload = new Date().getTime();
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    ondelete: function ondelete(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>删除</b> 此记录？',
        width: 300,
        okText: '确定删除',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tchTrack/delete', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('提交成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modal_TchApplyFormModal_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modal_TchApplyFormModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modal_TchApplyFormModal_vue__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SendEmailModal: __WEBPACK_IMPORTED_MODULE_15__modal_SendEmailModal_vue___default.a,
    TchApplyFormModal: __WEBPACK_IMPORTED_MODULE_16__modal_TchApplyFormModal_vue___default.a,
    TeachersDingTalkModal: __WEBPACK_IMPORTED_MODULE_13__modal_TeachersDingTalkModal___default.a,
    EditDingDingModal: __WEBPACK_IMPORTED_MODULE_12__modal_EditDingDingModal___default.a,
    TchCancelOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_0__TchCancelOpenedTimeModal_vue___default.a,
    TchAddOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_1__TchAddOpenedTimeModal_vue___default.a,
    TchEditOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_2__TchEditOpenedTimeModal_vue___default.a,
    TchCancelRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_3__TchCancelRandomOpenedTimeModal_vue___default.a,
    TchAddRandomOpenedTimeModal: __WEBPACK_IMPORTED_MODULE_4__TchAddRandomOpenedTimeModal_vue___default.a,
    TchLeaveModal: __WEBPACK_IMPORTED_MODULE_5__TchLeaveModal_vue___default.a,
    TchLeaveOfficeModal: __WEBPACK_IMPORTED_MODULE_6__TchLeaveOfficeModal_vue___default.a,
    AssignTchStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_7__modal_AssignTchStudyAdviserModal_vue___default.a,
    TchInsertModal: __WEBPACK_IMPORTED_MODULE_8__TchInsertModal_vue___default.a,
    AllTeachersLeaveModal: __WEBPACK_IMPORTED_MODULE_11__AllTchLeaveModal___default.a,
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_9__modal_TchInfoModal_vue___default.a,
    SubstituteTchSelect: __WEBPACK_IMPORTED_MODULE_14__components_common_SubstituteTchSelect___default.a
  },
  name: 'tchTrainingList',
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    return {
      reviewParam: {
        ids: '',
        remark: '',
        leaveKind: null
      },
      rejectRule: {
        leaveKind: [{ required: true, type: 'number', message: '请选择淘汰或流失', trigger: 'change' }],
        remark: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur' }, {
          validator: function validator(rule, value, callback) {
            if (!value || !String(value).trim()) {
              callback(new Error('理由不能为空'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      showApplyModal: false,
      applyTchId: null,
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      loadingReject: false,
      showRejectModal: false,
      showBatchReviewModal: false,
      rejectParam: {
        id: '',
        remark: '',
        leaveKind: null
      },
      exportLoading: false,
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '修改类别',
        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.tchChangeStatusType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '原来状态',
        render: function render(h, params) {
          var row = params.row;
          var oldStatus = row.oldStatus;
          var type = row.type;
          if (type === 1) {
            var oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus);
            return h('span', oldStatusEnum && oldStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.oldNickname || '');
          }
          return h('span', oldStatus);
        }
      }, {
        title: '现在状态',
        render: function render(h, params) {
          var row = params.row;
          var newStatus = row.newStatus;
          var type = row.type;
          if (type === 1) {
            var newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus);
            return h('span', newStatusEnum && newStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.newNickname || '');
          }
          return h('span', newStatus);
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '理由',
        key: 'remark'
      }],
      showTchInfoModal: false,
      tchId: null,
      addType: null,
      queryParam: {
        hr: '',
        sex: '',
        accent: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        category: 4,
        channel: '',
        regFrom: '',
        startCreateDate: '',
        endCreateDate: ''
      },
      channelOptions: [],
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: $constant.teacherCategory.filter(function (item) {
        return item.code !== 6;
      }),
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '',
        adviser: '',
        openedId: '',
        substituteTchId: ''
      },
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: '老师ID',
        width: 80,
        fixed: 'left',
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 140,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstName + row.lastName,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
        }
      }, {
        title: 'Full Name',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.fullName,
              placeholder: 'Full Name'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.fullName) {
                  row.fullName = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, fullName: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.fullName) {
                  row.fullName = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, fullName: value } });
                }
              }
            }
          });
        }
      }, {
        title: '真实国籍',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.nationality || '' },
            props: {
              value: row.nationality,
              placeholder: '真实国籍'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.nationality) {
                  row.nationality = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, nationality: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.nationality) {
                  row.nationality = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, nationality: value } });
                }
              }
            }
          });
        }
      }, {
        title: '现居地',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.address || '' },
            props: {
              value: row.address,
              placeholder: 'address',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.address) {
                  row.address = newValue;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, address: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.address) {
                  row.address = value;
                  _this.updateTchDirect({ tchInfo: { tchId: row.id, address: value } });
                }
              }
            }
          });
        }
      }, {
        title: '外教等级',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.tchLevel || '' },
            props: {
              value: row.tchLevel,
              placeholder: '等级'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.tchLevel) {
                  row.tchLevel = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, tchLevel: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.tchLevel) {
                  row.tchLevel = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, tchLevel: value } });
                }
              }
            }
          });
        }
      }, {
        title: 'FM',
        key: 'studyAdviserNickname',
        width: 120,
        align: 'center'
      }, {
        title: 'HR',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.hr || '' },
            props: {
              value: row.hr,
              placeholder: 'hr'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.hr) {
                  row.hr = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, hr: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.hr) {
                  row.hr = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, hr: value } });
                }
              }
            }
          });
        }
      }, {
        title: '推荐人',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.inviteTchName || '',
              placeholder: '输入推荐人ID'
            },
            style: { width: '160px' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.inviteTchName || '')) {
                  row.inviteTchName = newValue;
                  _this.updateInviteTch(row, newValue);
                }
              },
              'on-enter': function onEnter(event) {
                var val = event.target ? event.target.value : event;
                if (val !== (row.inviteTchName || '')) {
                  row.inviteTchName = val;
                  _this.updateInviteTch(row, val);
                }
              }
            }
          });
        }
      }, {
        title: '注册渠道',
        width: 100,
        align: 'center',
        key: 'regFrom'
      }, {
        title: '进度',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.progressRemark || '' },
            props: {
              value: row.progressRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.progressRemark) {
                  row.progressRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, progressRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.progressRemark) {
                  row.progressRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, progressRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '周末时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.weekendRemark || '' },
            props: {
              value: row.weekendRemark,
              placeholder: 'remark',
              type: 'textarea',
              autosize: {
                minRows: 1,
                maxRows: 3
              }
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.weekendRemark) {
                  row.weekendRemark = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, weekendRemark: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.weekendRemark) {
                  row.weekendRemark = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, weekendRemark: value } });
                }
              }
            }
          });
        }
      }, {
        title: '预计开课时间',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('DatePicker', {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              value: row.openCourseTime,
              placeholder: '选择日期',
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                if (value !== row.openCourseTime) {
                  row.openCourseTime = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, openCourseTime: value } });
                }
              }
            }
          });
        }
      }, {
        title: '性别',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.sex,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.sex = value;
                _this.updateTchDirect({ tchList: { id: row.id, sex: value } });
              }
            }
          }, _this.$constant.sex.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '口音',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.accent,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.sex = value;
                _this.updateTchDirect({ tchInfo: { tchId: row.id, accent: value } });
              }
            }
          }, _this.$constant.accent.map(function (item) {
            return h('Option', { props: { value: item.code } }, item.text);
          }));
        }
      }, {
        title: '老师账号',
        width: 250,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.account,
              placeholder: 'Login Account'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.account) {
                  row.account = newValue;
                  _this.updateTchDirect({ tchList: { id: row.id, account: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.account) {
                  row.account = value;
                  _this.updateTchDirect({ tchList: { id: row.id, account: value } });
                }
              }
            }
          });
        }
      }, {
        title: '试用期时薪',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.probationHourlySalary || '' },
            props: {
              value: row.probationHourlySalary,
              placeholder: '试用期时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.probationHourlySalary) {
                  row.probationHourlySalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationHourlySalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.probationHourlySalary) {
                  row.probationHourlySalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationHourlySalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '试用期课薪',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.probationClassSalary || '' },
            props: {
              value: row.probationClassSalary,
              placeholder: '试用期课薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.probationClassSalary) {
                  row.probationClassSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationClassSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.probationClassSalary) {
                  row.probationClassSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, probationClassSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '转正时薪',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.regularHourlySalary || '' },
            props: {
              value: row.regularHourlySalary,
              placeholder: '转正时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.regularHourlySalary) {
                  row.regularHourlySalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularHourlySalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.regularHourlySalary) {
                  row.regularHourlySalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularHourlySalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '转正课薪',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.regularClassSalary || '' },
            props: {
              value: row.regularClassSalary,
              placeholder: '转正课薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.regularClassSalary) {
                  row.regularClassSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularClassSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.regularClassSalary) {
                  row.regularClassSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, regularClassSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '期望时薪',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.expectSalary || '' },
            props: {
              value: row.expectSalary,
              placeholder: '期望时薪'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.expectSalary) {
                  row.expectSalary = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, expectSalary: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.expectSalary) {
                  row.expectSalary = value;
                  _this.updateTchDirect({ tchForm: { tchId: row.id, expectSalary: value } });
                }
              }
            }
          });
        }
      }, {
        title: '最高学历',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            attrs: {
              title: row.eduLevel || '' },
            props: {
              value: row.eduLevel,
              placeholder: '最高学历'
            },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== row.eduLevel) {
                  row.eduLevel = newValue;
                  _this.updateTchDirect({ tchList: { id: row.id, eduLevel: newValue } });
                }
              },
              'on-enter': function onEnter(value) {
                if (value !== row.eduLevel) {
                  row.eduLevel = value;
                  _this.updateTchDirect({ tchList: { id: row.id, eduLevel: value } });
                }
              }
            }
          });
        }
      }, {
        title: '合同开始时间',
        key: 'crtBeginTimeStr',
        width: 120,
        align: 'center'
      }, {
        title: '合同结束时间',

        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var day = row.crtEndTimeDay;
          var crtEndTimeStr = row.crtEndTimeStr;
          if (crtEndTimeStr) {
            if (day <= 30) {
              return h('div', [h('p', {}, row.crtEndTimeStr), h('span', { style: { color: 'red' } }, '距结束' + day + '天')]);
            } else {
              return h('div', [h('p', {}, row.crtEndTimeStr)]);
            }
          }
        }
      }, {
        title: '最近跟踪',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var trackTime = params.row.trackTime;
          var trackContent = params.row.trackContent;
          return h('div', [h('div', {
            attrs: {
              title: trackContent },
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, trackContent || ''), h('div', {
            style: {
              fontSize: '12px',
              color: '#999',
              marginTop: '4px'
            }
          }, trackTime || '')]);
        }
      }, {
        title: '操作日志',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var isTchChange = params.row.isTchChange;
          var id = params.row.id;
          if (isTchChange) {
            return h('a', {
              on: {
                click: function click() {
                  self.onTchChangeStatusList(id);
                }
              }
            }, '查看');
          } else {
            return h('span', '无记录');
          }
        }
      }, {
        title: '操作',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var operationArr = [];
          if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
            operationArr.push(h('a', {
              on: {
                click: function click() {
                  _this.onShowApply(row);
                }
              }
            }, '注册资料'));
          }
          if (row.category === 4) {
            if (operationArr.length) {
              operationArr.push(h('span', { class: 'divider' }));
            }
            operationArr.push(h('a', {
              on: {
                click: function click() {
                  _this.onOpenClass(row);
                }
              }
            }, '开课'));
            operationArr.push(h('span', { class: 'divider' }));
            operationArr.push(h('a', {
              on: {
                click: function click() {
                  _this.onReject(row);
                }
              }
            }, '拒绝'));
            operationArr.push(h('span', { class: 'divider' }));
            operationArr.push(h('a', { on: { click: function click() {
                  _this.onSendEmail(row);
                } } }, '发送邮件'));
          }
          if (!operationArr.length) {
            return h('span', '');
          }
          return h('div', operationArr);
        }
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    var queryParam = this.queryParam;
    queryParam.uid = this.$route.query.uid;
    this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.studyAdviserList = res.data;
    });
  },

  created: function created() {
    this.loadRegChannels();
  },

  methods: {
    loadRegChannels: function loadRegChannels() {
      var self = this;
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data;
        }
      });
    },
    onShowApply: function onShowApply(row) {
      this.applyTchId = row.id;
      this.showApplyModal = true;
    },
    onSendEmail: function onSendEmail(row) {
      this.emailTchId = row.id;
      this.emailTchName = row.firstName + ' ' + row.lastName;
      this.showEmailModal = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    onReject: function onReject(row) {
      this.showRejectModal = true;
      this.rejectParam.id = row.id;
      this.rejectParam.firstName = row.firstName;
      this.rejectParam.lastName = row.lastName;
      this.rejectParam.leaveKind = null;
      this.rejectParam.remark = '';
    },
    reject: function reject() {
      var self = this;
      self.loadingReject = true;
      self.$refs.rejectForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingReject = false;
          return;
        }
        var params = {};
        params.id = self.rejectParam.id;
        params.remark = self.rejectParam.remark ? self.rejectParam.remark.trim() : '';
        params.leaveKind = self.rejectParam.leaveKind;
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.search();
            self.showRejectModal = false;
          }
          self.loadingReject = false;
        }).catch(function (e) {
          self.showRejectModal = false;
          self.loadingReject = false;
        });
      });
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data;
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！');
        return;
      }
      this.showAssignTchStudyAdviserModal = true;
    },
    batchReview: function batchReview() {
      var self = this;
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！');
        return;
      }
      self.$refs.reviewForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        var idList = self.selectionTch.map(function (element) {
          return element.id;
        });
        self.reviewParam.ids = idList.join(',');
        self.reviewParam.remark = self.reviewParam.remark ? self.reviewParam.remark.trim() : '';
        self.$http.post('/tch/batchReject', self.reviewParam).then(function (res) {
          self.$Message.success('审核成功');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
          self.search();
        }).catch(function (e) {
          self.$Message.error('审核失败');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
          self.search();
        });
      });
    },
    batchReject: function batchReject() {
      var self = this;
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！');
        return;
      }
      this.reviewParam.leaveKind = null;
      this.reviewParam.remark = '';
      this.showBatchReviewModal = true;
    },
    onOpenClass: function onOpenClass(row) {
      var self = this;
      var name = row.id + ' - ' + row.firstName + ' ' + row.lastName;
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + name + '</b> 老师进入试用期？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/tch/openClass', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('开课成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    addTch: function addTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
      this.addType = 'training';
    },
    allTeachersLeave: function allTeachersLeave() {
      this.showAllTeacherLeaveModel = true;
    },
    closeEditDingModal: function closeEditDingModal() {
      this.showEditDingModal = false;
      this.tchId = null;
    },
    closeTeacherDingTalkModal: function closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false;
      this.tchId = null;
    },
    showProxyClass: function showProxyClass(row) {
      var self = this;
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm');
      self.selectTchParam = row;
      self.showSelectTch = row.show;
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data;
        } else {
          self.activityList = [];
        }
      });
    },
    cancelProxyClassData: function cancelProxyClassData(row) {
      var self = this;
      row.isProxy = 0;
      self.activityList.map(function (item, index) {
        if (item.id === row.id) {
          self.activityList[index].replace(item, row);
        }
      });
    },
    updateTch: function updateTch() {
      var self = this;
      self.selectTchParam.isProxy = 1;
      console.log('self.substituteTchId', self.substituteTchId);
      if (self.substituteTchId == null || self.substituteTchId === '') {
        self.$message.warning('请选择代课老师');
        return;
      }
      self.selectTchParam.substituteTchId = self.substituteTchId;
      if (self.substituteList.find(function (item) {
        return self.selectTchParam.id === item.id;
      }) == null) {
        self.substituteList.push(self.selectTchParam);
      }
      self.showSelectTch = false;
    },
    exportData: function exportData() {
      var _this3 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/tch/training/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '培训中老师.xlsx';
          link.click();
          _this3.exportLoading = false;
        } else {
          _this3.$Message.error(response.msg || '导出失败');
        }
      }).catch(function (e) {
        _this3.$Message.error('导出失败');
        _this3.exportLoading = false;
      });
    },
    updateInviteTch: function updateInviteTch(row, val) {
      var _this4 = this;

      var inviteId = parseInt(val);
      if (!inviteId || inviteId <= 0) {
        this.$Message.warning('请输入有效的推荐人ID');
        return;
      }
      this.$http.post('/tch/update-referrer', { newTchId: row.id, inviteId: inviteId }).then(function (res) {
        if (res.status === 'ok') {
          _this4.$Message.success('推荐人更新成功');
          _this4.searchWithPage();
        } else {
          _this4.$Message.error(res.msg || '更新失败');
        }
      }).catch(function () {
        _this4.$Message.error('更新失败');
      });
    }
  },

  watch: {}
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a, SendEmailModal: __WEBPACK_IMPORTED_MODULE_2__modal_SendEmailModal_vue___default.a, TchApplyFormModal: __WEBPACK_IMPORTED_MODULE_3__modal_TchApplyFormModal_vue___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      queryParam: {
        country: '',
        accent: '',
        sex: '',
        channel: '',
        inviteTchName: '',
        regFrom: '',
        ethnicity: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        status: 0,
        startCreateDate: '',
        endCreateDate: ''
      },
      channelOptions: [],
      teacherCategoryList: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }],

      showPassModal: false,
      loadingPass: false,
      passParam: {
        remark: ''
      },
      passRule: {
        remark: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur' }]
      },

      showRejectModal: false,
      loadingReject: false,
      rejectParam: {
        id: '',
        remark: ''
      },
      rejectRule: {
        remark: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur' }]
      },

      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      showApplyModal: false,
      applyTchId: null,
      showInsertTchModal: false,
      tchId: null,
      showUpdateTchModal: false,

      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [{
        title: '修改类别',
        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.tchChangeStatusType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '原来状态',
        render: function render(h, params) {
          var row = params.row;
          var oldStatus = row.oldStatus;
          var type = row.type;
          if (type === 1) {
            var oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus);
            return h('span', oldStatusEnum && oldStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.oldNickname || '');
          }
          return h('span', oldStatus);
        }
      }, {
        title: '现在状态',
        render: function render(h, params) {
          var row = params.row;
          var newStatus = row.newStatus;
          var type = row.type;
          if (type === 1) {
            var newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus);
            return h('span', newStatusEnum && newStatusEnum.text);
          } else if (type === 4) {
            return h('span', row.newNickname || '');
          }
          return h('span', newStatus);
        }
      }, {
        title: '操作人',
        key: 'adminNickname'
      }, {
        title: '操作时间',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '理由',
        key: 'remark'
      }],
      selectionTch: [],
      showBatchReviewModal: false,
      reviewParam: {
        ids: '',
        remark: ''
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '老师ID',
        width: 80,
        align: 'center',
        key: 'id'
      }, {
        title: '老师昵称',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: (row.firstName || '') + ' ' + (row.lastName || ''),
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.id);
            }
          });
        }
      }, {
        title: 'Full Name',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openTchInfoModal(row.id);
              } } }, row.fullName);
        }
      }, {
        title: '老师账号',
        key: 'account',
        width: 130,
        align: 'center'
      }, {
        title: '推荐人',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Input', {
            props: {
              value: row.inviteTchName || '',
              placeholder: '输入推荐人ID'
            },
            style: { width: '160px' },
            on: {
              'on-blur': function onBlur(event) {
                var newValue = event.target.value;
                if (newValue !== (row.inviteTchName || '')) {
                  row.inviteTchName = newValue;
                  _this.updateInviteTch(row, newValue);
                }
              },
              'on-enter': function onEnter(event) {
                var val = event.target ? event.target.value : event;
                if (val !== (row.inviteTchName || '')) {
                  row.inviteTchName = val;
                  _this.updateInviteTch(row, val);
                }
              }
            }
          });
        }
      }, {
        title: '注册时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '现居地',
        width: 150,
        align: 'center',
        key: 'country'
      }, {
        title: '种族',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('Select', {
            props: {
              value: row.ethnicity,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                row.ethnicity = value;
                _this.updateTchDirect({ tchForm: { tchId: row.id, ethnicity: value } });
              }
            }
          }, [h('Option', { props: { value: 'African' } }, 'African'), h('Option', { props: { value: 'Coloured' } }, 'Coloured'), h('Option', { props: { value: 'White' } }, 'White'), h('Option', { props: { value: 'Indian/Asian' } }, 'Indian/Asian')]);
        }
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regFrom'
      }, {
        title: '类型',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var category = params.row.category;
          var categoryEnum = $constant.getEnum($constant.teacherCategory, category);
          return h('span', categoryEnum && categoryEnum.text);
        }
      }, {
        title: '状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.teacherStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.channel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '最近跟踪',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var trackTime = params.row.trackTime;
          var trackContent = params.row.trackContent;
          return h('div', [h('div', {
            attrs: {
              title: trackContent },
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, trackContent || ''), h('div', {
            style: {
              fontSize: '12px',
              color: '#999',
              marginTop: '4px'
            }
          }, trackTime || '')]);
        }
      }, {
        title: '操作日志',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var self = _this;
          var isTchChange = params.row.isTchChange;
          var id = params.row.id;
          if (isTchChange) {
            return h('a', {
              on: {
                click: function click() {
                  self.onTchChangeStatusList(id);
                }
              }
            }, '查看');
          } else {
            return h('span', '无记录');
          }
        }
      }, {
        title: '操作',
        width: 220,
        fixed: 'right',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var operationArr = [];
          if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
            operationArr.push(h('a', {
              on: {
                click: function click() {
                  _this.onShowApply(row);
                }
              }
            }, '注册资料'));
            operationArr.push(h('span', { class: 'divider' }));
          }
          operationArr.push(h('a', {
            on: {
              click: function click() {
                _this.onPass(row);
              }
            }
          }, '通过'));
          if (row.status === 0) {
            operationArr.push(h('span', { class: 'divider' }));
            operationArr.push(h('a', {
              on: {
                click: function click() {
                  _this.onReject(row);
                }
              }
            }, '拒绝'));
          }
          operationArr.push(h('span', { class: 'divider' }));
          operationArr.push(h('a', { on: { click: function click() {
                _this.onSendEmail(row);
              } } }, '发送邮件'));
          return h('div', operationArr);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    this.loadRegChannels();
  },
  computed: {
    filteredTeacherStatus: function filteredTeacherStatus() {
      var allowedCodes = [-1, 0, 2];
      return this.$constant.teacherStatus.filter(function (item) {
        return allowedCodes.includes(item.code);
      });
    }
  },
  methods: {
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    createDateChange: function createDateChange(value) {
      this.queryParam.startCreateDate = value && value[0] || '';
      this.queryParam.endCreateDate = value && value[1] || '';
      this.search();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    loadRegChannels: function loadRegChannels() {
      var self = this;
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'id', 'monthRankScore', map);
      });
    },
    onPass: function onPass(row) {
      this.showPassModal = true;
      this.passParam.id = row.id;
      this.passParam.firstName = row.firstName;
      this.passParam.lastName = row.lastName;
      this.passParam.remark = '';
    },
    pass: function pass() {
      var self = this;
      self.loadingPass = true;
      self.$refs.passForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingPass = false;
          return;
        }
        var params = {};
        params.id = self.passParam.id;
        params.remark = self.passParam.remark;
        self.$http.post('/tch/pass', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage();
            self.showPassModal = false;
          }
          self.loadingPass = false;
        }).catch(function (e) {
          self.showPassModal = false;
          self.loadingPass = false;
        });
      });
    },
    onReject: function onReject(row) {
      this.showRejectModal = true;
      this.rejectParam.id = row.id;
      this.rejectParam.firstName = row.firstName;
      this.rejectParam.lastName = row.lastName;
      this.passParam.remark = '';
    },
    reject: function reject() {
      var self = this;
      self.loadingReject = true;
      self.$refs.rejectForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingReject = false;
          return;
        }
        var params = {};
        params.id = self.rejectParam.id;
        params.remark = self.rejectParam.remark;
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage();
            self.showRejectModal = false;
          }
          self.loadingReject = false;
        }).catch(function (e) {
          self.showRejectModal = false;
          self.loadingReject = false;
        });
      });
    },
    onInsertTch: function onInsertTch() {
      this.showTchInfoModal = true;
      this.tchId = null;
    },
    onTchChangeStatusList: function onTchChangeStatusList(tchId) {
      var self = this;
      self.tchChangeStatusList = [];
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true;
        if (!res || !res.data) {
          return;
        }
        self.tchChangeStatusList = res.data;
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionTch = selection;
    },
    showBatchReview: function showBatchReview() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择待审核老师！');
        return;
      }
      this.showBatchReviewModal = true;
    },
    batchReview: function batchReview(val) {
      var self = this;
      self.$refs.reviewForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.selectionTch.map(function (element) {
          return element.id;
        });
        self.reviewParam.ids = idList.join(',');
        var path = '/tch/' + val;
        self.$http.post(path, self.reviewParam).then(function (res) {
          self.$Message.success('审核成功');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
          self.searchWithPage();
        }).catch(function (e) {
          self.$Message.error('审核失败');
          self.showBatchReviewModal = false;
          self.selectionTch = [];
          self.searchWithPage();
        });
      });
    },
    onShowApply: function onShowApply(row) {
      this.applyTchId = row.id;
      this.showApplyModal = true;
    },
    onSendEmail: function onSendEmail(row) {
      this.emailTchId = row.id;
      this.emailTchName = row.firstName + ' ' + row.lastName;
      this.showEmailModal = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this2 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('更新成功');
        } else {
          _this2.$Message.error(res.msg);
        }
      }).catch(function () {
        _this2.$Message.error('更新失败');
      });
    },
    updateInviteTch: function updateInviteTch(row, val) {
      var _this3 = this;

      var inviteId = parseInt(val);
      if (!inviteId || inviteId <= 0) {
        this.$Message.warning('请输入有效的推荐人ID');
        return;
      }
      this.$http.post('/tch/update-referrer', { newTchId: row.id, inviteId: inviteId }).then(function (res) {
        if (res.status === 'ok') {
          _this3.$Message.success('推荐人更新成功');
          _this3.searchWithPage();
        } else {
          _this3.$Message.error(res.msg || '更新失败');
        }
      }).catch(function () {
        _this3.$Message.error('更新失败');
      });
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchWagesList',
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      queryParam: {
        yearMonth: '',
        id: null,
        tchId: null,
        tchName: '',
        contractVersion: '',
        tchType: '',
        month: null,
        confirm: ''
      },
      myMonth: null,
      searchLoading: false,
      headers: {},
      reload: 0,
      rankScoreSeq: 0,
      fileList: [],
      title: [{
        title: 'ID',
        key: 'id',
        width: 75,
        align: 'center'
      }, {
        title: '年月',
        key: 'yearMonth',
        width: 85,
        align: 'center'
      }, {
        title: '是否确认',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var regType = params.row.confirm;
          var canalEnum = $constant.getEnum($constant.confirm, regType);
          return h('div', canalEnum && canalEnum.text);
        }
      }, {
        title: '老师ID-姓名',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '时薪',
        key: 'hourlyPay',
        width: 80,
        align: 'center'
      }, {
        title: '老师状态',
        width: 100,
        align: 'center',
        key: 'tchCategory',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.teacherCategory, row.tchCategory);
          return h('span', cons && cons.text);
        }
      }, {
        title: '每课薪资',
        key: 'partTimePayRate',
        width: 100,
        align: 'center'
      }, {
        title: '异常请假率',
        key: 'abnormalLeaveRate',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var abnormalLeaveRate = params.row.abnormalLeaveRate;
          return h('span', abnormalLeaveRate + '%');
        }
      }, {
        title: '实际每课薪资',
        key: 'actualPartTimePayRate',
        width: 150,
        align: 'center'
      }, {
        title: '贝宝账号',
        key: 'paypalEmail',
        width: 250,
        align: 'center'
      }, {
        title: '绩效奖金',
        key: 'kpi',
        width: 100,
        align: 'center'
      }, {
        title: '上课数',
        key: 'partOrOverTimeClasses',
        width: 80,
        align: 'center'
      }, {
        title: '两小时内学生请假数',
        key: 'inTwoHoursLeave',
        width: 200,
        align: 'center'
      }, {
        title: '新签学生奖金',
        key: 'signUpBonus',
        width: 150,
        align: 'center'
      }, {
        title: '推荐老师奖',
        key: 'referenceBonus',
        width: 120,
        align: 'center'
      }, {
        title: '临时请假数',
        key: 'emergencyCount',
        width: 120,
        align: 'center'
      }, {
        title: '取消课数',
        key: 'cancellationClasses',
        width: 120,
        align: 'center'
      }, {
        title: '旷课数',
        key: 'absentClasses',
        width: 120,
        align: 'center'
      }, {
        title: '老师失联数',
        key: 'ncnsClasses',
        width: 120,
        align: 'center'
      }, {
        title: '迟到/早退',
        key: 'lateOrLeaveEarlyClasses',
        width: 120,
        align: 'center'
      }, {
        title: '差评投诉',
        key: 'negativeFeedbackClasses',
        width: 120,
        align: 'center'
      }, {
        title: '未评价',
        key: 'noReviewClasses',
        width: 120,
        align: 'center'
      }, {
        title: '评价超时',
        key: 'reviewSubmittedLateClasses',
        width: 120,
        align: 'center'
      }, {
        title: '退费学生',
        key: 'studentsRefundClasses',
        width: 120,
        align: 'center'
      }, {
        title: '附加',
        key: 'additional',
        width: 120,
        align: 'center'
      }, {
        title: '合计',
        key: 'total',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.total.toFixed(3));
        }
      }, {
        title: '手续费',
        key: 'transactionFee',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.transactionFee.toFixed(3));
        }
      }, {
        title: '实付',
        key: 'totalSentSalary',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.totalSentSalary.toFixed(2));
        }
      }, {
        title: '操作',
        fixed: 'right',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          return h('span', [h('a', { on: { click: function click() {
                return _this.delTchWages(row.id);
              } } }, '删除')]);
        }
      }],
      exportLoading: false,
      action: this.$appConfig.baseUrl + '/tchWages/importExe'
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var self = this;
      var query = self.$route.query;
      if (query) {
        if (query.month) {
          this.myMonth = query.month;
        }
        if (query.id) {
          self.queryParam.id = query.id;
        }
        if (query.tchId) {
          self.queryParam.tchId = query.tchId;
        }
        if (query.tchName) {
          self.queryParam.tchName = query.tchName;
        }
        if (query.contractVersion) {
          self.queryParam.contractVersion = query.contractVersion;
        }
        if (query.tchType) {
          self.queryParam.tchType = query.tchType;
        }
      }
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    changeMonth: function changeMonth(val) {
      if (val) {
        this.queryParam.month = val;
        var date = new Date(val);
        var month = date.getMonth() + 1;
        if (month < 10) {
          month = '0' + month;
        }
        this.queryParam.yearMonth = date.getFullYear() + '' + month;
      } else {
        this.queryParam.month = null;
        this.queryParam.yearMonth = '';
      }
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    beforeUpload: function beforeUpload(file) {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    delTchWages: function delTchWages(id) {
      var self = this;
      if (id) {
        self.$http.post('/tchWages/delTchWages?id=' + id).then(function (res) {
          if (res.data) {
            self.search();
          }
        });
      }
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      this.$Message.success('上传成功');
      this.fileList = [];
      this.search();
    },
    downTchWagesMobal: function downTchWagesMobal() {
      var self = this;
      self.exportLoading = true;
      self.$http.get('/tchWages/downLoadTchWagesModal', { responseType: 'arraybuffer' }).then(function (res) {
        var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '老师工资条模板.xls';
        link.click();
        self.exportLoading = false;
      }).catch(function (e) {
        self.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson_BookUserFeedbackModal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson_BookUserFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lesson_BookUserFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_BookTchFeedbackModal_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_BookTchFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_BookTchFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_BookTchScoreFeedbackModal_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_BookTchScoreFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lesson_BookTchScoreFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_StudentWriteReviewDemoModal_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_StudentWriteReviewDemoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__user_StudentWriteReviewDemoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_StudentWriteReviewDemoV2Modal_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_StudentWriteReviewDemoV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__user_StudentWriteReviewDemoV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_StudentWriteReviewRegularModal_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_StudentWriteReviewRegularModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__user_StudentWriteReviewRegularModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_StudentWriteReviewRegularV2Modal_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_StudentWriteReviewRegularV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__user_StudentWriteReviewRegularV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_StudentWriteReviewFinishLevelModal_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_StudentWriteReviewFinishLevelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__user_StudentWriteReviewFinishLevelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_StudentWriteReviewFinishLevelV2Modal_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_StudentWriteReviewFinishLevelV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__user_StudentWriteReviewFinishLevelV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lesson_ClassFeedback_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lesson_ClassFeedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__lesson_ClassFeedback_vue__);














var GRADES = {
  1: '不合格',
  2: '待改进',
  3: '合格',
  4: '良好',
  5: '优秀'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeacherClassScore',
  components: {
    BookUserFeedbackModal: __WEBPACK_IMPORTED_MODULE_1__lesson_BookUserFeedbackModal_vue___default.a,
    BookTchFeedbackModal: __WEBPACK_IMPORTED_MODULE_2__lesson_BookTchFeedbackModal_vue___default.a,
    BookTchScoreFeedbackModal: __WEBPACK_IMPORTED_MODULE_3__lesson_BookTchScoreFeedbackModal_vue___default.a,
    StudentWriteReviewDemoModal: __WEBPACK_IMPORTED_MODULE_4__user_StudentWriteReviewDemoModal_vue___default.a,
    StudentWriteReviewDemoV2Modal: __WEBPACK_IMPORTED_MODULE_5__user_StudentWriteReviewDemoV2Modal_vue___default.a,
    StudentWriteReviewRegularModal: __WEBPACK_IMPORTED_MODULE_6__user_StudentWriteReviewRegularModal_vue___default.a,
    StudentWriteReviewRegularV2Modal: __WEBPACK_IMPORTED_MODULE_7__user_StudentWriteReviewRegularV2Modal_vue___default.a,
    StudentWriteReviewFinishLevelModal: __WEBPACK_IMPORTED_MODULE_8__user_StudentWriteReviewFinishLevelModal_vue___default.a,
    StudentWriteReviewFinishLevelV2Modal: __WEBPACK_IMPORTED_MODULE_9__user_StudentWriteReviewFinishLevelV2Modal_vue___default.a,
    ClassFeedback: __WEBPACK_IMPORTED_MODULE_10__lesson_ClassFeedback_vue___default.a
  },
  props: {
    tchId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var start = $moment().startOf('day').subtract(6, 'days');
    var end = $moment().endOf('day');
    return {
      startDate: start.format('YYYY-MM-DD'),
      endDate: end.format('YYYY-MM-DD'),
      queryParam: {
        tchId: this.tchId,
        startTime: start.format('X'),
        endTime: end.format('X'),
        studyAdviserNickname: '',
        adviserNickname: '',
        lsnType: null,
        lsnSelStatus: null,
        classFeedbackRated: null
      },
      reload: 0,
      ratedCount: 0,
      totalStar: 0,
      openedId: null,
      showBookUserFeedbackModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewDemoV2Modal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      showClassFeedback: false,
      classFeedbackOpenedId: '',
      classFeedbackRow: null,
      columns: [{
        title: '课程信息',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, row.lsnType);
          var courseTypeEnum = $constant.getEnum($constant.courseType, row.courseType);
          var cType = courseTypeEnum && courseTypeEnum.text;
          if (cType) {
            cType = '课程类别:' + cType;
          } else {
            cType = '';
          }
          return h('div', [h('p', row.id), h('p', row.lessonTitle), h('p', { style: { 'font-size': '12px', color: 'red' } }, cType), h('p', { style: { 'font-size': '12px', color: '#2d8cf0' } }, '课程类型:' + (typeEnum && typeEnum.text))]);
        }
      }, {
        title: '上课时间',
        width: 180,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var week = $moment(lsnBeginTime, 'X').day();
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $constant.weekZh[week]);
        }
      }, {
        title: '时长',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          var minutes = row.courseTime;
          if (minutes === null || minutes === undefined || minutes === '') {
            minutes = (row.lsnEndTime - row.lsnBeginTime) / 60;
          }
          return h('span', minutes);
        }
      }, {
        title: '学生',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.userNickname);
        }
      }, {
        title: '状态',
        width: 120,
        render: function render(h, params) {
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, params.row.lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '课堂反馈',
        align: 'center',
        width: 140,
        render: function render(h, params) {
          var row = params.row;
          var n = parseInt(row.classFeedbackStar, 10);
          if (!n || n < 1) {
            return h('span', '未评分');
          }
          if (n > 5) {
            n = 5;
          }
          return h('span', {
            style: { color: '#f0a020', cursor: 'pointer', fontSize: '16px', letterSpacing: '1px' },
            on: {
              click: function click() {
                _this.openClassFeedback(row);
              }
            }
          }, '★'.repeat(n));
        }
      }, {
        title: '评价',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookTchFeedbackUid = row.bookTchFeedbackUid;
          var spanArr = [];
          var version = row.version;
          if (bookTchFeedbackUid) {
            var obj = h('a', {
              on: {
                click: function click() {
                  _this.openedId = row.id;
                  if (version === 0) {
                    if (row.lsnType === 1) {
                      _this.showBookTchScoreFeedbackModal = true;
                    } else {
                      _this.showBookTchFeedbackModal = true;
                    }
                  } else if (version === 1) {
                    if (row.lsnType === 1) {
                      _this.studentWriteReviewDemoModal = true;
                    } else if (row.lsnType === 2) {
                      if (row.stageSummary) {
                        _this.studentWriteReviewFinishLevelModal = true;
                      } else {
                        _this.studentWriteReviewRegularModal = true;
                      }
                    }
                  } else if (version === 2) {
                    if (row.lsnType === 1) {
                      _this.studentWriteReviewDemoV2Modal = true;
                    } else if (row.lsnType === 2) {
                      if (row.stageSummary) {
                        _this.studentWriteReviewFinishLevelV2Modal = true;
                      } else {
                        _this.studentWriteReviewRegularV2Modal = true;
                      }
                    }
                  }
                }
              }
            }, '老师对学生评价');
            var her = 'https://test-h5.kouyujie.cn/std-report/report.html?bookLessonId=' + row.id;
            if (_this.$appConfig.active === 'prod') {
              her = 'https://h5.speakstreet.cn/std-report/report.html?bookLessonId=' + row.id;
            }
            var previewLink = h('a', {
              attrs: {
                href: her,
                target: '_blank'
              },
              style: {
                marginLeft: '10px'
              }
            }, '预览');
            spanArr.push(obj);
            spanArr.push(h('br'));
            if (row.lsnType === 1 && version === 2) {
              spanArr.push(h('br'));
              spanArr.push(previewLink);
              spanArr.push(h('br'));
            }
          }
          var bookUserFeedbackId = row.bookUserFeedbackId;
          var bookUserFeedbackStar = row.bookUserFeedbackStar;
          if (bookUserFeedbackId) {
            var obj2 = h('div', [h('Rate', {
              props: {
                disabled: true,
                count: bookUserFeedbackStar,
                value: bookUserFeedbackStar
              },
              style: { 'font-size': '12px' }
            }), h('br'), h('a', {
              on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showBookUserFeedbackModal = true;
                }
              }
            }, '学生对老师评价')]);
            spanArr.push(obj2);
          }
          if (spanArr.length === 0) {
            return h('div', { style: { color: 'red' } }, '未评论');
          }
          return h('div', { style: { 'font-size': '13px', color: 'red' } }, spanArr);
        }
      }, {
        title: '监课/回放',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          if (params.row.liveUrl) {
            return h('a', {
              on: {
                click: function click() {
                  window.open(params.row.liveUrl);
                }
              }
            }, '进入');
          }
          return h('span');
        }
      }]
    };
  },

  computed: {
    hasScore: function hasScore() {
      var count = parseInt(this.ratedCount, 10);
      return !!count && count > 0;
    },
    avg: function avg() {
      if (!this.hasScore) {
        return 0;
      }
      return Number(this.totalStar) / parseInt(this.ratedCount, 10);
    },
    starCount: function starCount() {
      if (!this.hasScore) {
        return 0;
      }
      var n = Math.round(this.avg);
      if (n < 1) {
        n = 1;
      }
      if (n > 5) {
        n = 5;
      }
      return n;
    },
    scoreMain: function scoreMain() {
      if (!this.hasScore) {
        return '—';
      }
      return this.avg.toFixed(2);
    },
    solidStars: function solidStars() {
      if (!this.hasScore) {
        return '';
      }
      return '★'.repeat(this.starCount);
    },
    hollowStars: function hollowStars() {
      if (!this.hasScore) {
        return '☆☆☆☆☆';
      }
      return '☆'.repeat(5 - this.starCount);
    },
    gradeText: function gradeText() {
      if (!this.hasScore) {
        return '待评分';
      }
      return GRADES[this.starCount] || '待评分';
    },
    ratedCountText: function ratedCountText() {
      var count = parseInt(this.ratedCount, 10);
      if (!count || count < 0) {
        return 0;
      }
      return count;
    }
  },
  created: function created() {
    this.loadSummary();
  },

  watch: {
    tchId: function tchId(val) {
      this.queryParam.tchId = val;
      this.loadSummary();
      this.reload = new Date().getTime();
    }
  },
  methods: {
    onStartDateChange: function onStartDateChange(value) {
      this.startDate = value;
    },
    onEndDateChange: function onEndDateChange(value) {
      this.endDate = value;
    },
    search: function search() {
      if (!this.startDate || !this.endDate) {
        return;
      }
      var start = this.$moment(this.startDate, 'YYYY-MM-DD').startOf('day');
      var end = this.$moment(this.endDate, 'YYYY-MM-DD').endOf('day');
      this.queryParam.tchId = this.tchId;
      this.queryParam.startTime = start.format('X');
      this.queryParam.endTime = end.format('X');
      this.queryParam.studyAdviserNickname = this.queryParam.studyAdviserNickname || '';
      this.queryParam.adviserNickname = this.queryParam.adviserNickname || '';
      var lsnType = this.queryParam.lsnType;
      if (lsnType === '' || lsnType === null || lsnType === undefined) {
        this.queryParam.lsnType = null;
      } else {
        lsnType = Number(lsnType);
        this.queryParam.lsnType = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(lsnType) && lsnType >= 0 ? lsnType : null;
      }
      var lsnSelStatus = this.queryParam.lsnSelStatus;
      if (lsnSelStatus === '' || lsnSelStatus === null || lsnSelStatus === undefined) {
        this.queryParam.lsnSelStatus = null;
      } else {
        lsnSelStatus = Number(lsnSelStatus);
        this.queryParam.lsnSelStatus = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(lsnSelStatus) && lsnSelStatus > 0 ? lsnSelStatus : null;
      }
      var classFeedbackRated = this.queryParam.classFeedbackRated;
      if (classFeedbackRated === '' || classFeedbackRated === null || classFeedbackRated === undefined) {
        this.queryParam.classFeedbackRated = null;
      } else {
        classFeedbackRated = Number(classFeedbackRated);
        this.queryParam.classFeedbackRated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(classFeedbackRated) && (classFeedbackRated === 0 || classFeedbackRated === 1) ? classFeedbackRated : null;
      }
      this.reload = new Date().getTime();
    },
    onRatedClick: function onRatedClick() {
      this.queryParam.classFeedbackRated = 1;
      this.search();
    },
    loadSummary: function loadSummary() {
      var self = this;
      if (!this.tchId) {
        return;
      }
      this.$http.get('/bookLesson/classFeedback/summary', {
        params: {
          tchId: this.tchId
        }
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.ratedCount = res.data.ratedCount || 0;
          self.totalStar = res.data.totalStar || 0;
        } else {
          self.ratedCount = 0;
          self.totalStar = 0;
        }
      }).catch(function () {
        self.ratedCount = 0;
        self.totalStar = 0;
      });
    },
    openClassFeedback: function openClassFeedback(row) {
      this.classFeedbackRow = row;
      this.classFeedbackOpenedId = row.id;
      this.showClassFeedback = true;
    },
    onClassFeedbackSaved: function onClassFeedbackSaved(payload) {
      var star = payload && payload.star;
      var openedId = payload && payload.openedId;
      var list = this.$refs.dataList;
      var rows = list && list.tableData;
      if (rows && rows.length) {
        for (var i = 0; i < rows.length; i++) {
          if (String(rows[i].id) === String(openedId)) {
            rows[i].classFeedbackStar = star;
            break;
          }
        }
        list.tableData = rows.slice();
      } else if (this.classFeedbackRow) {
        this.classFeedbackRow.classFeedbackStar = star;
      }
      this.showClassFeedback = false;
      this.classFeedbackRow = null;
      this.loadSummary();
    }
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeTab: 'history',
      recordCount: 0,
      tchList: [],
      showTch: false,
      buttonLoading: false,
      listLoading: false,
      resendLoading: false,
      queryParam: { tchType: '' },
      formData: { sendType: '', content: '', tchIds: [] },
      records: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      detailVisible: false,
      detail: null,
      resendVisible: false,
      resendRow: null
    };
  },
  mounted: function mounted() {
    this.loadRecords();
  },

  methods: {
    switchTab: function switchTab(name) {
      this.activeTab = name;
      if (name === 'history') {
        this.loadRecords();
      }
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      if (typeof val === 'string') return val.replace('T', ' ').substring(0, 19);
      try {
        var d = new Date(val);
        if (isNaN(d.getTime())) return String(val);
        var pad = function pad(n) {
          return n < 10 ? '0' + n : '' + n;
        };
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
      } catch (e) {
        return String(val);
      }
    },
    formatNum: function formatNum(n) {
      if (n === null || n === undefined || n === '') return '0';
      return Number(n).toLocaleString();
    },
    sendTypeLabel: function sendTypeLabel(sendType) {
      var map = {
        1: '全体中教老师', 2: '全体外教老师', 3: '个人中教老师', 4: '个人外教老师',
        5: '全体陪练老师', 6: '个人陪练老师', 7: '全部老师', 8: '欧美外教', 9: '菲教', 10: '指定老师'
      };
      return map[sendType] || '类型' + sendType;
    },
    isAllLike: function isAllLike(sendType) {
      return sendType === 1 || sendType === 2 || sendType === 5 || sendType === 7 || sendType === 8 || sendType === 9;
    },
    sendMessage: function sendMessage() {
      var self = this;
      if (!self.formData.sendType) {
        self.$Message.warning('请选择接收对象');
        return;
      }
      if (!self.formData.content || !String(self.formData.content).trim()) {
        self.$Message.warning('请输入消息内容');
        return;
      }
      if (self.showTch && (!self.formData.tchIds || !self.formData.tchIds.length)) {
        self.$Message.warning('请选择老师');
        return;
      }
      self.buttonLoading = true;
      self.$http.post('/message/sendMessage', {}, {
        transformRequest: [function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.buttonLoading = false;
        if (res.data > 0) {
          self.$Message.success('发送成功!');
          self.formData.content = '';
          self.activeTab = 'history';
          self.pageNum = 1;
          self.loadRecords();
        }
      }).catch(function () {
        self.buttonLoading = false;
      });
    },
    loadRecords: function loadRecords() {
      var self = this;
      self.listLoading = true;
      self.$http.get('/message/batch/list?pageNum=' + self.pageNum + '&pageSize=' + self.pageSize).then(function (res) {
        self.listLoading = false;
        var data = res.data || {};
        self.records = data.list || [];
        self.total = data.total || 0;
        self.recordCount = data.total || 0;
      }).catch(function () {
        self.listLoading = false;
      });
    },
    onPageChange: function onPageChange(p) {
      this.pageNum = p;
      this.loadRecords();
    },
    openDetail: function openDetail(row) {
      var self = this;
      self.$http.get('/message/batch/detail?batchId=' + row.id + '&pageNum=1&pageSize=200').then(function (res) {
        self.detail = res.data || null;
        self.detailVisible = true;
      });
    },
    openResend: function openResend(row) {
      this.resendRow = row;
      this.resendVisible = true;
    },
    confirmResend: function confirmResend() {
      var self = this;
      if (!self.resendRow) return;
      self.resendLoading = true;
      self.$http.post('/message/batch/resend?batchId=' + self.resendRow.id).then(function () {
        self.resendLoading = false;
        self.resendVisible = false;
        self.$Message.success('已向未读老师再次发送');
        self.loadRecords();
      }).catch(function () {
        self.resendLoading = false;
      });
    },
    sendTypeChange: function sendTypeChange(val) {
      var sendType = Number(val);
      this.formData.tchIds = [];
      this.tchList = [];
      this.showTch = sendType === 3 || sendType === 4 || sendType === 6 || sendType === 10;
      if (!this.showTch) {
        return;
      }
      var self = this;
      if (sendType === 10) {
        self.$http.get('/tch/listByCondition?tchType=1').then(function (res) {
          var list = res.data || [];
          self.$http.get('/tch/listByCondition?tchType=2').then(function (res2) {
            var secondList = res2.data || [];
            var idMap = {};
            var mergedList = [];
            list.concat(secondList).forEach(function (item) {
              if (!idMap[item.id]) {
                idMap[item.id] = true;
                mergedList.push(item);
              }
            });
            self.tchList = mergedList;
          });
        });
        return;
      }
      if (sendType === 3) {
        this.queryParam.tchType = 2;
      } else if (sendType === 4) {
        this.queryParam.tchType = 1;
      } else if (sendType === 6) {
        this.queryParam.tchType = 3;
      }
      self.$http.get('/tch/listByCondition?tchType=' + self.queryParam.tchType).then(function (res) {
        if (res.data) {
          self.tchList = res.data;
        }
      });
    }
  }
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_modal_LessonFeedbackDealModal_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_modal_LessonFeedbackDealModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_modal_LessonFeedbackDealModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddClassRequirementModal_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_AddClassRequirementModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_AddClassRequirementModal_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__modal_TchInfoModal_vue___default.a,
    LessonFeedbackDealModal: __WEBPACK_IMPORTED_MODULE_2__lesson_modal_LessonFeedbackDealModal_vue___default.a,
    AddClassRequirementModal: __WEBPACK_IMPORTED_MODULE_3__modal_AddClassRequirementModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $moment = this.$moment;
    var $constant = this.$constant;
    var self = this;
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      dateRange: '',
      queryParam: {
        creator: '',
        tchId: '',
        tchName: '',
        content: '',
        startDate: '',
        endDate: '',
        completed: '0',
        auditStatus: '',
        bizTypes: ['体验课上课要求']
      },
      showLessonFeedbackDealModal: false,
      feedBackParamData: {},
      timeList: [],
      showAddClassRequirementModal: false,
      currentUid: null,
      currentStudentName: '',
      currentTchId: null,
      currentTchName: '',
      title: [{
        title: '反馈人',
        width: 80,
        align: 'center',
        key: 'fromUser'
      }, {
        title: '反馈时间',
        width: 120,
        align: 'center',
        key: 'createTime'
      }, {
        title: '标签',
        key: 'feedContent',
        width: 500,
        align: 'center',
        render: function render(h, params) {
          var feedContent = params.row.feedContent;
          if (feedContent && feedContent.includes('|')) {
            var parts = feedContent.split('|');
            var secondPart = parts[1];
            var tags = [];
            if (secondPart) {
              var tagsString = secondPart.replace(/[[\]"']/g, '');
              if (tagsString.trim()) {
                tags = tagsString.split(',').map(function (tag) {
                  return tag.trim();
                }).filter(function (tag) {
                  return tag;
                });
              }
            }

            var children = [];

            if (tags.length > 0) {
              var tagColors = ['green', 'orange', 'red', 'blue', 'purple'];

              var tagElements = tags.map(function (tag, index) {
                return h('Tag', {
                  props: {
                    color: tagColors[index % tagColors.length],
                    closable: false
                  },
                  style: {
                    margin: '2px 5px 2px 0',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }
                }, tag);
              });
              children.push(h('div', {
                style: 'display: flex; flex-wrap: wrap; align-items: center;'
              }, tagElements));
            }
            return h('div', children);
          } else {
            return h('span', feedContent);
          }
        }
      }, {
        title: '其他反馈内容',
        key: 'feedContent',
        width: 300,
        align: 'center',
        render: function render(h, params) {
          var feedContent = params.row.feedContent;
          if (feedContent && feedContent.includes('|')) {
            var parts = feedContent.split('|');
            var firstPart = parts[0];
            var children = [];

            if (firstPart) {
              children.push(h('div', { style: 'margin-bottom: 5px;' }, firstPart));
            }
            return h('div', children);
          } else {
            return h('span', feedContent);
          }
        }
      }, {
        title: '学生 ID、名称',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var uid = params.row.uid;
          var stdName = params.row.stdName;
          var str = '-';
          if (uid) {
            str = uid + '-' + stdName;
          }
          if (str === '-') {
            return h('span', '-');
          } else {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.openInfoModal(uid);
                } } }, uid + '-' + stdName)]);
          }
        }
      }, {
        title: '老师 ID、名称',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchId) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: row.tchId + '-' + row.tchName,
              score: row.monthRankScore,
              onClick: function onClick() {
                return _this.openTchInfoModal(row.tchId);
              }
            });
          } else {
            return h('span', '-');
          }
        }
      }, {
        title: '上课时间',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                return _this.openLessonList(params.row.bookLessonOpenedId);
              } } }, params.row.lessonTime)]);
        }
      }, {
        title: 'sc/cc',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var scName = params.row.scName;
          var ccName = params.row.ccName;
          return h('div', [h('div', scName || '-'), h('div', ccName || '-')]);
        }
      }, {
        title: '是否完结',
        width: 70,
        align: 'center',
        key: 'completed',
        render: function render(h, params) {
          var completed = params.row.completed;
          var completedEnum = $constant.getEnum($constant.yesOrNo, completed);
          return h('span', completedEnum && completedEnum.text);
        }
      }, {
        title: '老师是否收到',
        key: 'received',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var received = params.row.received;
          var receivedEnum = $constant.getEnum($constant.yesOrNo, received);
          return h('span', receivedEnum && receivedEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: function render(h, params) {
          return h('div', {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px'
            }
          }, [h('a', {
            on: {
              click: function click() {
                if (params.row.completed) {
                  return;
                }
                _this.handleEnd(params.row);
              }
            },
            style: {
              color: params.row.completed ? 'gray' : '#2d8cf0'
            }
          }, '完结')]);
        }
      }]
    };
  },

  created: function created() {},
  methods: {
    dateRangeChange: function dateRangeChange(value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0];
        this.queryParam.endDate = value[1];
      } else {
        this.queryParam.startDate = '';
        this.queryParam.endDate = '';
      }
    },
    openLessonList: function openLessonList(val) {
      var _$router$resolve = this.$router.resolve({
        name: 'bookLessonOpenedList',
        query: { bookLessonOpenedId: val, pageIndex: 1, pageSize: 10 } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve2 = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList' } }),
          href = _$router$resolve2.href;

      window.open(href, '_blank');
    },
    startDateChange: function startDateChange(value) {
      this.queryParam.startDate = value;
    },
    endDateChange: function endDateChange(value) {
      this.queryParam.endDate = value;
    },
    openTchInfoModal: function openTchInfoModal(val) {
      this.tchId = val;
      this.showTchInfoModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    handleEnd: function handleEnd(row) {
      var _this2 = this;

      this.$http.post('/stageReport/fm-message-completed?id=' + row.id).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('完结成功');
          _this2.search();
        } else {
          _this2.$Message.error('完结失败');
        }
      });
    },
    addClassRequirement: function addClassRequirement() {
      var uid = this.$route.query.uid;
      var studentName = this.$route.query.studentName || '';

      if (!uid) {
        this.$Message.warning('请先选择学生');
        return;
      }

      this.currentUid = uid;
      this.currentStudentName = studentName;

      this.currentTchId = this.$route.query.tchId || null;
      this.currentTchName = this.$route.query.tchName || '';
      this.showAddClassRequirementModal = true;
    }
  },
  watch: {}
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddClassRequirementModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String]
    },
    studentName: {
      type: String
    },
    tchId: {
      type: [Number]
    },
    bookLessonOpenedId: {
      type: [Number]
    },
    tchName: {
      type: String
    },
    classRequirement: {
      type: String,
      default: ''
    },
    classRequirementTags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      showModal: false,
      loading: false,
      formData: {
        uid: this.uid,
        studentName: this.studentName,
        tchId: this.tchId,
        tchName: this.tchName,
        classRequirement: this.classRequirement || '',
        classRequirementTags: this.classRequirementTags || []
      },
      formRule: {}
    };
  },

  watch: {
    value: function value(val) {
      this.showModal = val;
      if (val) {
        this.formData.uid = this.uid;
        this.formData.studentName = this.studentName;
        this.formData.tchId = this.tchId;
        this.formData.bookLessonOpenedId = this.bookLessonOpenedId;
        this.formData.tchName = this.tchName;
        this.formData.classRequirement = this.classRequirement || '';
        this.formData.classRequirementTags = this.classRequirementTags || [];
      } else {
        this.formData.classRequirement = '';
        this.formData.classRequirementTags = [];
      }
    },
    uid: function uid(val) {
      this.formData.uid = val;
    },
    studentName: function studentName(val) {
      this.formData.studentName = val;
    },
    tchId: function tchId(val) {
      this.formData.tchId = val;
    },
    tchName: function tchName(val) {
      this.formData.tchName = val;
    },
    bookLessonOpenedId: function bookLessonOpenedId(val) {
      this.formData.bookLessonOpenedId = val;
    }
  },
  methods: {
    saveClassRequirement: function saveClassRequirement() {
      var self = this;
      self.loading = true;

      var req = {
        uid: self.formData.uid,
        classRequirement: self.formData.classRequirement,
        classRequirementTags: self.formData.classRequirementTags,
        tchId: self.formData.tchId,
        bookLessonOpenedId: self.formData.bookLessonOpenedId
      };

      self.$http.post('/stageReport/fm-message-demo-require-add', req, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loading = false;
        if (res) {
          self.$Message.success('保存成功!');

          self.showModal = false;

          self.$emit('input', false);
          if (self.successCallback) {
            self.successCallback();
          }
          return;
        }
      }).catch(function (e) {
        self.loading = false;
      });
    },
    cancel: function cancel() {
      this.showModal = false;

      this.$emit('input', false);
    },
    handleCancel: function handleCancel() {
      this.showModal = false;
      this.$emit('input', false);
    }
  }
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddMatchCenterModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      tempLessonParam: {
        tchId: '',
        tchName: '',
        feedBackType: '加开固定时间',
        content: '',
        otherContent: '',
        feedRemark: ''
      },
      timeParamEndDateStr: '',
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: '',
        endDate: '',
        endDateStr: '',
        day: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      timeRule: {},
      timeRule1: {
        week: [{ type: 'integer', required: true, message: '请选择星期' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间' }],
        useDate: [{ type: 'integer', required: true, message: '请选择有效日期' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule1: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加时间');
            }
            callback(errors);
          }
        }]
      },
      timeRule2: {
        day: [{ type: 'integer', required: true, message: '请选择日期' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var day = self.timeParam.day;
            var startTime = self.timeParam.startTime;
            var errors = [];
            var nowTime = new Date().getTime() / 1000;
            if (day !== '' && startTime !== '' && nowTime >= day + startTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            var openedTimeList = self.openedTimeList;
            var endTime = self.timeParam.endTime;
            if (day === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            openedTimeList.forEach(function (element) {
              var tmpDay = element.day;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (day === tmpDay && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + element.dayStr + ' ' + element.startTimeStr + '-' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule2: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    onChangeFeedBackType: function onChangeFeedBackType(val) {
      this.tempLessonParam.feedBackType = val;
      this.openedTimeList = [];
      this.timeParam = {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        useDateStr: '',
        day: ''
      };
    },
    addOpenedTime1: function addOpenedTime1() {
      var _this = this;

      var self = this;
      self.$refs.timeForm1.validate(function (valid) {
        if (!valid) {
          return;
        }
        if (self.tempLessonParam.feedBackType === '加开短期固定时间') {
          if (!_this.timeParam.endDate) {
            _this.$Message.warning('请选择截止有效期');
            return;
          }
          if (_this.timeParam.endDate <= _this.timeParam.useDate) {
            _this.$Message.warning('截止有效期应在生效日期之后');
            return;
          }
        }
        var openedTime = {};
        openedTime.week = _this.timeParam.week;
        openedTime.weekStr = _this.$constant.weekZh[_this.timeParam.week];
        openedTime.startTime = _this.timeParam.startTime;
        openedTime.startTimeStr = _this.timeParam.startTimeStr;
        openedTime.endTime = _this.timeParam.endTime;
        openedTime.endTimeStr = _this.timeParam.endTimeStr;
        openedTime.useDate = _this.timeParam.useDate;
        openedTime.useDateStr = _this.timeParam.useDateStr;
        openedTime.endDate = _this.timeParam.endDate;
        openedTime.endDateStr = _this.timeParam.endDateStr;
        _this.openedTimeList.push(openedTime);
        _this.timeParam.week = null;
        _this.timeParam.startTime = '';
        _this.timeParam.endTime = '';
        _this.timeParam.startTimeStr = '';
        _this.timeParam.endTimeStr = '';
      });
    },
    addOpenedTime2: function addOpenedTime2() {
      var _this2 = this;

      var self = this;
      self.$refs.timeForm2.validate(function (valid) {
        if (!valid) {
          return;
        }
        var openedTime = {};
        openedTime.day = self.timeParam.day;
        openedTime.dayStr = self.timeParam.dayStr;
        openedTime.startTime = self.timeParam.startTime;
        openedTime.startTimeStr = self.timeParam.startTimeStr;
        openedTime.endTime = self.timeParam.endTime;
        openedTime.endTimeStr = self.timeParam.endTimeStr;
        self.openedTimeList.push(openedTime);
        _this2.timeParam = {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: '',
          day: ''
        };
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      this.openedTimeList.splice(index, 1);
    },
    onChangeDate: function onChangeDate(val) {
      this.timeParam.dayStr = val;
      this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.useDateStr = val;
    },
    onChangeEndDate: function onChangeEndDate(val) {
      this.timeParam.endDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.endDateStr = val;
    },
    add: function add() {
      var self = this;
      if (self.tempLessonParam.feedBackType === '其他') {
        if (!self.tempLessonParam.otherContent) {
          this.$Message.error('请输入留言内容');
          return;
        }
        self.$http.post('/stageReport/fm-message-center-add', {
          tchId: self.tempLessonParam.tchId,
          bizType: '其他',
          feedContent: self.tempLessonParam.otherContent,
          feedRemark: self.tempLessonParam.feedRemark
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            self.$Message.error({ content: res.msg || '提交失败', duration: 5 });
          }
        });
        return;
      }
      if (self.tempLessonParam.feedBackType === '开绑定权限') {
        if (!self.tempLessonParam.otherContent) {
          this.$Message.error('请输入申请理由');
          return;
        }
        self.$http.post('/stageReport/fm-message-center-add', {
          tchId: self.tempLessonParam.tchId,
          bizType: '开绑定权限',
          feedContent: self.tempLessonParam.otherContent
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            self.$Message.error({ content: res.msg || '提交失败', duration: 5 });
          }
        });
        return;
      }
      if (self.tempLessonParam.feedBackType === '开临时约课权限') {
        if (!self.tempLessonParam.otherContent) {
          this.$Message.error('请输入申请理由');
          return;
        }
        self.$http.post('/stageReport/fm-message-center-add', {
          tchId: self.tempLessonParam.tchId,
          bizType: '开临时约课权限',
          feedContent: self.tempLessonParam.otherContent
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            self.$Message.error({ content: res.msg || '提交失败', duration: 5 });
          }
        });
        return;
      }
      if (self.openedTimeList.length === 0) {
        this.$Message.error('请添加时间');
        return;
      }
      self.$http.post('/stageReport/fm-message-center-add', {
        tchId: self.tempLessonParam.tchId,
        bizType: self.tempLessonParam.feedBackType,
        feedContent: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList),
        feedRemark: self.tempLessonParam.feedRemark
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.successCallback();
          self.visible = false;
          self.$Message.success('提交成功!');
        } else {
          self.$Message.error({
            content: res.data(),
            duration: 5
          });
        }
      }).catch(function (e) {});
    },
    delect: function delect() {
      var self = this;
      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('删除成功!');
          } else {
            self.successCallback();
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        });
      } else {
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
        });
        self.$http.post('/tch/time/addBookOpenedTime', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.$Message.success('删除成功');
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        }).catch(function (e) {});
      }
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.openedTimeList = [];
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.openedTimeList = [];
        this.timeParam = {
          day: '',
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignTchStudyAdviserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAssignAdviser: false,
      adviserParam: {
        studyAdviserId: ''
      },
      adviserRule: {
        studyAdviserId: [{ type: 'integer', required: true, message: '请选择外教运营', trigger: 'blur' }]
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      self.$refs.assignAdviserForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.tchList.map(function (element) {
          return element.id;
        });
        self.loadingAssignAdviser = true;
        var params = { ids: idList.join(','), studyAdviserId: self.adviserParam.studyAdviserId };
        self.$http.get('/tch/updateStudyAdviser', { params: params }).then(function (res) {
          self.successCallback();
          self.visible = false;
          self.loadingAssignAdviser = false;
        }).catch(function (e) {
          self.visible = false;
          self.loadingAssignAdviser = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.adviserParam.studyAdviserId = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditDingDingModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAdd: false,
      userList: {},
      formData: {
        tchId: null,
        dingtalkDepartmentId: 135668087,
        dingtalkUserid: 0,
        isReceiveMsg: ''
      },
      dingRules: {
        dingtalkUserid: [{ type: 'string', required: true, message: '请选择钉钉用户', trigger: 'blur' }],
        isReceiveMsg: [{ type: 'number', required: true, message: '请选择是否接收钉钉消息', trigger: 'blur' }]
      }
    };
  },

  created: function created() {
    this.loadDingtalkUser(135668087);
  },
  methods: {
    saveDing: function saveDing() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.editDingForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        if (self.formData.tchId) {
          self.$http.post('/tch/formal/saveOrUpdate', self.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('保存成功!');
              self.loadingAdd = false;
              self.visible = false;
              self.successCallback();
            }
          }).catch(function (e) {
            self.loadingAdd = false;
            self.$Message.error(e.msg);
          });
        }
      });
    },
    loadDingtalkUser: function loadDingtalkUser(val) {
      var self = this;
      if (val) {
        self.$http.get('/dingTalk/userList?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.userList = res.data;
        });
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.userList = [];
        this.formData = {};
        this.$emit('on-close', val);
      } else {}
    },
    tchId: function tchId(val) {
      if (val) {
        var self = this;
        self.loadDingtalkUser(135668087);

        self.$http.get('/tch/formal/queryByTchId?tchId=' + val).then(function (res) {
          if (res.data) {
            self.formData.tchId = res.data.tchId;
            self.formData.dingtalkDepartmentId = 135668087;
            self.formData.dingtalkUserid = res.data.dingtalkUserid;
            if (!res.data.dingtalkUserid && res.data.isReceiveMsg === 0) {
              self.formData.isReceiveMsg = parseInt(1);
            } else {
              self.formData.isReceiveMsg = parseInt(res.data.isReceiveMsg);
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvalidListenCauseLogModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loading: false,
      logList: [],
      columns: [{ title: '填写时间', key: 'gmtCreate', width: 160, align: 'center' }, { title: '填写人', key: 'creatorName', width: 120, align: 'center' }, {
        title: '原因',
        key: 'cause',
        render: function render(h, params) {
          var cause = params.row.cause;
          if (!cause) {
            return h('span', { style: { color: '#bbbec4' } }, '（清空）');
          }
          return h('span', { style: { whiteSpace: 'pre-wrap', wordBreak: 'break-all' } }, cause);
        }
      }]
    };
  },

  methods: {
    loadLogs: function loadLogs() {
      var self = this;
      self.logList = [];
      if (!self.tchId) {
        return;
      }
      self.loading = true;
      self.$http.get('/tch/invalid-listen-cause-logs?tchId=' + self.tchId).then(function (res) {
        self.loading = false;
        if (!res || !res.data) {
          return;
        }
        self.logList = res.data;
      }).catch(function (e) {
        self.loading = false;
        self.$Message.error(e && e.msg || '加载失败');
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val) {
        this.loadLogs();
      } else {
        this.$emit('input', false);
        this.$emit('on-close', false);
      }
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModifyAttendanceScoreDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      attendanceRowThis: {}
    };
  },

  methods: {
    editSalary: function editSalary() {
      var self = this;
      self.loadingEditSalary = true;
      self.$http.post('/tch/lesson/update-score', this.attendanceRowThis).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('成功!');
          self.visibleThis = false;
          self.loadingEditSalary = false;
          self.successCallback();
        }
      }).catch(function (e) {
        self.loadingEditSalary = false;
      });
    }
  },
  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.attendanceRowThis = {};
        this.$emit('on-close', val);
      }
    },
    complaintRow: function complaintRow(val) {
      var _this = this;

      this.attendanceRowThis = val;
      if (this.attendanceRowThis.status === 0) {
        this.complaintRemarkList.forEach(function (item) {
          if (item.text === val.remark) {
            _this.attendanceRowThis.stdNum = item.stdNum;
            _this.attendanceRowThis.tchNum = item.tchNum;
            _this.attendanceRowThis.subSalary = item.subSalary;
          }
        });
      }
    }
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModifyAttendanceScoreModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      attendanceRowThis: {}
    };
  },

  methods: {
    editSalary: function editSalary() {
      var self = this;
      self.loadingEditSalary = true;
      self.$http.post('/tch/lesson/add-score', this.attendanceRowThis).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('成功!');
          self.visibleThis = false;
          self.loadingEditSalary = false;
          self.successCallback();
        }
      }).catch(function (e) {
        self.loadingEditSalary = false;
      });
    }
  },
  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.attendanceRowThis = {};
        this.$emit('on-close', val);
      }
    },
    complaintRow: function complaintRow(val) {
      var _this = this;

      this.attendanceRowThis = val;
      if (this.attendanceRowThis.status === 0) {
        this.complaintRemarkList.forEach(function (item) {
          if (item.text === val.remark) {
            _this.attendanceRowThis.stdNum = item.stdNum;
            _this.attendanceRowThis.tchNum = item.tchNum;
            _this.attendanceRowThis.subSalary = item.subSalary;
          }
        });
      }
    }
  }
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModifyComplaintModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      complaintRowThis: {},
      ruleSalary: {},
      complaintRemarkList: $constant.tchComplaintRemark,
      subSalaryEnum: [{ code: 0, text: '正常计算' }, { code: 1, text: '不计算' }]
    };
  },

  methods: {
    editSalary: function editSalary() {
      var _this = this;

      var self = this;
      self.loadingEditSalary = true;
      self.$refs.editSalaryForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEditSalary = false;
          return;
        }
        self.$http.post('/tchList/complaint/update', _this.complaintRowThis).then(function (res) {
          self.$Message.success('成功!');
          self.visibleThis = false;
          self.loadingEditSalary = false;
          self.successCallback();
        }).catch(function (e) {
          self.loadingEditSalary = false;
        });
      });
    },
    changeRemark: function changeRemark(val) {
      var _this2 = this;

      this.complaintRemarkList.forEach(function (item) {
        if (item.text === val.remark) {
          _this2.complaintRowThis.stdNum = item.stdNum;
          _this2.complaintRowThis.tchNum = item.tchNum;
          _this2.complaintRowThis.subSalary = item.subSalary;
        }
      });
    }
  },
  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.complaintRowThis = {};
        this.$emit('on-close', val);
      }
    },
    complaintRow: function complaintRow(val) {
      var _this3 = this;

      this.complaintRowThis = val;
      if (this.complaintRowThis.status === 0) {
        this.complaintRemarkList.forEach(function (item) {
          if (item.text === val.remark) {
            _this3.complaintRowThis.stdNum = item.stdNum;
            _this3.complaintRowThis.tchNum = item.tchNum;
            _this3.complaintRowThis.subSalary = item.subSalary;
          }
        });
      }
    }
  }
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);





var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
var Font = __WEBPACK_IMPORTED_MODULE_0_quill__["import"]('formats/font');
Font.whitelist = fonts;
__WEBPACK_IMPORTED_MODULE_0_quill__["register"](Font, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SendEmailModal',
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: [Number, String],
      default: null
    },
    tchName: {
      type: String,
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visibleThis: this.visible,
      loadingSend: false,
      emailParam: {
        tchId: '',
        title: '',
        content: ''
      },
      emailRule: {
        title: [{ type: 'string', required: true, message: '邮件标题不能为空', trigger: 'blur' }, { type: 'string', max: 100, message: '邮件标题不能超过100个字', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '邮件内容不能为空', trigger: 'change' }]
      },
      editorOption: {
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], [{ 'font': fonts }], ['clean'], ['link']]
        }
      }
    };
  },

  methods: {
    cancel: function cancel() {
      this.resetForm();
      this.visibleThis = false;
    },
    sendEmail: function sendEmail() {
      var self = this;
      self.loadingSend = true;
      self.$refs.emailForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingSend = false;
          return;
        }

        self.$http.post('/tch/send-email', self.emailParam).then(function (res) {
          self.$Message.success('邮件发送成功!');
          self.visibleThis = false;
          self.loadingSend = false;
          if (self.successCallback) {
            self.successCallback();
          }
        }).catch(function (e) {
          self.$Message.error('邮件发送失败!');
          self.loadingSend = false;
        });
      });
    },
    resetForm: function resetForm() {
      this.emailParam = {
        tchId: this.tchId,
        title: '',
        content: ''
      };
      if (this.$refs.emailForm) {
        this.$refs.emailForm.resetFields();
      }

      if (this.$refs.myQuillEditor) {
        this.$refs.myQuillEditor.quill.setText('');
      }
    }
  },
  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.resetForm();
        this.$emit('on-close');
      }
    },
    tchId: function tchId(val) {
      this.emailParam.tchId = val;
    }
  }
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchApplyFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      visibleThis: this.visible,
      loading: false,
      applyData: null,
      tabName: '1',
      courseDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      courseSlots: ['6:00pm-6:30pm', '6:30pm-7:00pm', '7:00pm-7:30pm', '7:30pm-8:00pm', '8:00pm-8:30pm', '8:30pm-9:00pm', '9:00pm-9:30pm'],
      scheduleMap: {}
    };
  },

  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
      if (val) {
        this.loadApply();
      }
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.$emit('on-close');
      }
    }
  },
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.$emit('on-close');
      }
    },
    display: function display(val) {
      if (val === null || val === undefined || val === '') {
        return '未填写';
      }
      return val;
    },
    genderText: function genderText(val) {
      if (val === 1 || val === '1') {
        return '男';
      }
      if (val === 2 || val === '2') {
        return '女';
      }
      return this.display(val);
    },
    ynText: function ynText(val) {
      if (val === 'Y' || val === 'y') {
        return '是';
      }
      if (val === 'N' || val === 'n') {
        return '否';
      }
      return this.display(val);
    },
    subjectsText: function subjectsText(list) {
      if (!list || !list.length) {
        return '未填写';
      }
      return list.join('、');
    },
    mediaUrl: function mediaUrl(value) {
      if (!value) {
        return '';
      }
      if (String(value).indexOf('http') === 0) {
        return value;
      }
      return 'https://medias.kouyujie.cn/' + value;
    },
    openUrl: function openUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    toDisplaySlot: function toDisplaySlot(hhmm) {
      var raw = String(hhmm || '').replace('pm', '').replace('am', '');
      var parts = raw.split(':');
      var hour = parseInt(parts[0], 10);
      var minute = parts[1] || '00';
      if (isNaN(hour)) {
        return '';
      }
      if (hour > 12) {
        hour = hour - 12;
      }
      return hour + ':' + minute + 'pm';
    },
    buildScheduleMap: function buildScheduleMap(rows) {
      var map = {};
      var list = rows || [];
      var self = this;
      list.forEach(function (row) {
        if (!row || !row.week || !row.startTime || !row.endTime) {
          return;
        }
        var day = self.courseDays[Number(row.week) - 1];
        if (!day) {
          return;
        }
        var slot = self.toDisplaySlot(row.startTime) + '-' + self.toDisplaySlot(row.endTime);
        var key = day + '-' + slot;
        var status = row.status || '';
        if (status === 'available') {
          map[key] = '√';
        } else if (status === 'unsure') {
          map[key] = '?';
        } else if (status === 'unavailable') {
          map[key] = '×';
        } else {
          map[key] = '-';
        }
      });
      return map;
    },
    scheduleSymbol: function scheduleSymbol(day, slot) {
      var val = this.scheduleMap[day + '-' + slot];
      return val || '-';
    },
    loadApply: function loadApply() {
      var self = this;
      self.tabName = '1';
      self.applyData = null;
      self.scheduleMap = {};
      if (!self.tchId) {
        return;
      }
      self.loading = true;
      self.$http.get('/tch/apply?tchId=' + self.tchId).then(function (res) {
        self.loading = false;
        if (res && res.status === 'ok') {
          self.applyData = res.data || null;
          if (self.applyData) {
            self.scheduleMap = self.buildScheduleMap(self.applyData.workTimes);
          }
          return;
        }
        self.$Message.error('加载注册资料失败');
      }).catch(function () {
        self.loading = false;
        self.$Message.error('加载注册资料失败');
      });
    }
  }
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_dates__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchEditCloseTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      remark: '',
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        endDate: '',
        useDateStr: '',
        endDateStr: '',
        remark: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      timeRule: {
        remark: [{ type: 'string', required: true, message: '请输入关闭的原因', trigger: 'blur' }],
        week: [{ type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择开始时间', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.timeParam.endTime;
            var errors = [];
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前 ');
            }
            callback(errors);
          }
        }],
        endTime: [{ type: 'integer', required: true, message: '请选择结束时间', trigger: 'change' }],
        useDate: [{ type: 'integer', required: true, message: '请选择有效日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endDate = self.timeParam.endDate;
            var errors = [];
            if (endDate !== '' && value >= endDate) {
              errors.push('生效日期应在结束日期之前 ');
            }
            callback(errors);
          }
        }],
        endDate: [{ type: 'integer', required: true, message: '请选择结束日期', trigger: 'change' }],
        openedTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var week = self.timeParam.week;
            var startTime = self.timeParam.startTime;
            var endTime = self.timeParam.endTime;
            if (week === '' || startTime === '' || endTime === '' || startTime >= endTime) {
              return;
            }
            var errors = [];
            openedTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = element.endTime;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' + element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }]
      },
      timeListRule: {
        openedTimeList: [{
          validator: function validator(rule, value, callback, source, options) {
            var openedTimeList = self.openedTimeList;
            var errors = [];
            if (openedTimeList.length <= 0) {
              errors.push('请添加关闭时间');
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    addOpenedTime: function addOpenedTime() {
      var _this = this;

      var self = this;
      self.$refs.timeForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var openedTime = {};
        openedTime.week = _this.timeParam.week;
        openedTime.weekStr = _this.$constant.weekZh[_this.timeParam.week];
        openedTime.startTime = _this.timeParam.startTime;
        openedTime.startTimeStr = _this.timeParam.startTimeStr;
        openedTime.endTime = _this.timeParam.endTime;
        openedTime.endTimeStr = _this.timeParam.endTimeStr;
        openedTime.useDate = _this.timeParam.useDate;
        openedTime.endDate = _this.timeParam.endDate;
        openedTime.useDateStr = _this.timeParam.useDateStr;
        openedTime.endDateStr = _this.timeParam.endDateStr;
        _this.openedTimeList.push(openedTime);
        _this.timeParam.week = '';
        _this.$refs.timeListForm.validate();
      });
    },
    removeOpenedTime: function removeOpenedTime(index) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '此操作将直接删除老师关闭时间，学生可以继续预约该老师！',
        width: 300,
        okText: '确定删除',
        loading: true,
        onOk: function onOk() {
          self.openedTimeList.splice(index, 1);
          self.delect();
          self.$Modal.remove();
        }
      });
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.startTimeStr = val;
    },
    onChangeEndTime: function onChangeEndTime(val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val);
      this.timeParam.endTimeStr = val;
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.useDateStr = val;
    },
    onChangeEndDate: function onChangeEndDate(val) {
      this.timeParam.endDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'));
      this.timeParam.endDateStr = val;
    },
    add: function add() {
      var self = this;
      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteCloseTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.status === 'ok') {
            self.visible = false;
            self.$Message.success('删除成功!');
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        });
      } else {
        if (self.remark === '') {
          self.$Message.error('请填写原因');
          return;
        }
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
          element.remark = self.remark;
        });
        self.$http.post('/tch/time/addCloseTime', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.visible = false;
            self.$Message.success('提交成功!');
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        }).catch(function (e) {});
      }
    },
    delect: function delect() {
      var self = this;
      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteCloseTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback();
            self.visible = false;
            self.$Message.success('删除成功!');
          } else {
            self.successCallback();
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        });
      } else {
        if (self.remark === '') {
          self.$Message.error('请填写原因');
          return;
        }
        self.openedTimeList.forEach(function (element) {
          element.tchId = self.tchId;
          element.remark = self.remark;
        });
        self.$http.post('/tch/time/addCloseTime', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.openedTimeList);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.loadTchOpenedTime();
            self.successCallback();

            self.$Message.success('删除成功');
          } else {
            self.loadTchOpenedTime();
            self.$Message.error({
              content: res.data(),
              duration: 5
            });
          }
        }).catch(function (e) {});
      }
    },
    loadTchOpenedTime: function loadTchOpenedTime() {
      var self = this;
      self.$http.get('/tch/closeTime?tchId=' + self.tchId).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.visible = true;
        self.openedTimeList = [];
        res.data.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week];
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm');
          element.useDateStr = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default.a.formatUnix(element.useDate, 'YYYY-MM-DD');
          element.endDateStr = __WEBPACK_IMPORTED_MODULE_1__tools_date_dates___default.a.formatUnix(element.endDate, 'YYYY-MM-DD');
          self.openedTimeList.push(element);
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.openedTimeList = [];
        this.loadTchOpenedTime();
      }
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.openedTimeList = [];
        this.$refs.timeForm.resetFields();
        this.$refs.timeListForm.resetFields();
        this.timeParam = {
          week: null,
          remark: '',
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          endDate: '',
          useDateStr: '',
          endDateStr: ''
        };
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toArray__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_SingleOnePicUpload_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_SingleOnePicUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_SingleOnePicUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tools_date_format_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lesson_TimetableHeader_vue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lesson_TimetableHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__lesson_TimetableHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lesson_TimetableRow_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lesson_TimetableRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__lesson_TimetableRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_multipleImageUpload_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_multipleImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_multipleImageUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directive_drag_modal__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__order_ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__order_ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__order_ShowImageCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TeacherClassScore_vue__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TeacherClassScore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__TeacherClassScore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InvalidListenCauseLogModal_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InvalidListenCauseLogModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__InvalidListenCauseLogModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_trackContentAttach__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_viewer__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_v_viewer__);

























__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_v_viewer___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SingleOnePicUpload: __WEBPACK_IMPORTED_MODULE_8__common_SingleOnePicUpload_vue___default.a, TimetableHeader: __WEBPACK_IMPORTED_MODULE_12__lesson_TimetableHeader_vue___default.a, TimetableRow: __WEBPACK_IMPORTED_MODULE_13__lesson_TimetableRow_vue___default.a, multipleImageUpload: __WEBPACK_IMPORTED_MODULE_14__common_multipleImageUpload_vue___default.a, ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_17__order_ShowImageCarousel_vue___default.a, TeacherClassScore: __WEBPACK_IMPORTED_MODULE_18__TeacherClassScore_vue___default.a, InvalidListenCauseLogModal: __WEBPACK_IMPORTED_MODULE_19__InvalidListenCauseLogModal_vue___default.a
  },
  name: 'TchInfoModal',
  dialLoading: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    tchId: {
      type: Number,
      default: null
    },
    addType: {
      type: String,
      default: null
    },
    recruitFlowEntry: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    showTchSelf: {
      type: Boolean,
      default: false
    },
    showStuList: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      showInvalidListenCauseLog: false,
      seeTchTrack: false,
      seeStuList: this.showStuList,
      saveType: this.addType,
      showImgModal: false,
      showImgList: [],
      dateRange: [],
      colorBlockReqKey: '',
      colorBlockSeq: 0,
      dataList: [],
      types: ['opened', 'shortTerm', 'free', 'schedule', 'book', 'test', 'leave', 'partner'],
      insertLoading: false,
      channelOptions: [],
      reload: 0,
      reloadStuList: 0,
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      text: '编辑头像',
      totalImageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      featuresArray: [],
      levelArray: [],
      defaultPicsList: [],
      certificateTesolUrl: '',
      certificateTesolUrlList: [],
      certificateTesolOutUrl: '',
      certificateTesolOutUrlList: [],
      certificateTeflUrl: '',
      certificateTeflUrlList: [],
      certificateTeflOutUrl: '',
      certificateTeflOutUrlList: [],
      certificateTeylUrl: '',
      certificateTeylUrlList: [],
      certificateEnglishUrl: '',
      certificateEnglishUrlList: [],
      certificateEnglishOutUrl: '',
      certificateEnglishOutUrlList: [],
      introduceDocUrl: '',
      teachVideo: '',
      images: [],
      introduceDocUrlList: [],
      introduceVideoUrl: '',
      introduceVideoUrlList: [],
      nationalityImageUrl: '',
      nationalityImageUrlList: [],
      selfIntroductionVideo: '',
      selfIntroductionVideoList: [],
      teachVideoList: [],
      teachImagesList: [],
      polishLessonVideoList: [''],
      headers: {},
      resume: '',
      resumeList: [],
      tabName: '基本信息',
      detailTabSeq: 0,
      detailTabRules: {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      },
      referrerTabVisible: false,
      referrerDetail: {},
      referrerMonthlyStats: [],
      referrerMonthlyLoading: false,
      referrerMonthlyColumns: [{ title: '月份', key: 'month', align: 'center' }, { title: '推荐总数', key: 'recommendCount', align: 'center' }, { title: '审核通过数', key: 'approveCount', align: 'center' }, { title: '审核拒绝数', key: 'rejectCount', align: 'center' }, { title: '开课数', key: 'openClassCount', align: 'center' }],
      action: '',
      uploadText: '上传',
      formData: {
        editPermission: false,
        id: null,
        tchId: null,
        studyAdviserName: '',
        lastName: '',
        firstName: '',
        password: '',
        newPassword: '',
        sex: null,
        age: null,
        channel: 1,
        country: '',
        eduLevel: '',
        accent: null,
        category: this.addType === 'agency' ? 6 : 0,
        salary: '',
        tchType: '',
        timezone: '',
        timeDiff: '',
        certificateTesol: '',
        certificateTesolOut: '',
        certificateTefl: '',
        certificateTeflOut: '',
        certificateTeyl: '',
        certificateEnglish: '',
        certificateEnglishOut: '',
        experience: '',
        features: '',
        suitableLevel: '',
        introduceDoc: '',
        introduceVideo: '',
        polishLessonVideos: '',
        nationalityImage: '',
        sign: '',
        birthday: '',
        star: '',
        areaNum: '',
        account: '',
        mobile: '',
        loginBy: 2,
        skype: '',
        isAudition: 'n',
        status: 0,
        remark: '',
        isRecordScreen: 0,
        serviceType: 0,
        tempSchedule: 0,
        address: '',
        classin: '',
        selfIntroductionVideo: '',
        resume: '',
        itemUrl: '',
        imageUrl: '',
        email: '',
        isCanBound: 0,
        isStandby: 1,
        accentScore: '',
        cpuScore: '',
        upSpeed: '',
        downSpeed: '',
        screenCapAdvice: '',
        os: '',
        characteristic: '',
        startClassTime: '',
        invalidListenCause: '',
        fm: '',
        teachVideo: '',
        images: '',
        teachVideoList: '',
        disable18: 0,
        crtBeginTime: '',
        crtEndTime: '',
        tchForm: {
          mobile: '',
          email: '',
          mobileSos: '',
          whatAccount: '',
          faceBook: '',
          townOrCity: '',
          address: '',
          school: '',
          major: '',
          yearOfGraduation: '',
          upSpeed: '',
          downSpeed: '',
          backUpInternetSpeed: '',
          backUpPower: '',
          expectSalary: '',
          showSalary: false,
          networkProviders: '',
          regFrom: ''
        },
        workTimes: []
      },
      title: [{
        title: '创建时间',
        width: 170,
        render: function render(h, params) {
          var time = params.row.createTime;
          return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '类型',
        width: 110,
        render: function render(h, params) {
          var trackType = params.row.trackType;
          var typeEnum = $constant.getEnum($constant.tchTrackRecordType, trackType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '内容',
        render: function render(h, params) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_trackContentAttach__["a" /* renderTrackContentAttach */])(h, params.row.content, function (urls, index) {
            return _this.viewFile(urls, index);
          });
        }
      }, {
        title: '附件',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          if (row.urls && row.urls.length > 0) {
            var nodes = [];
            var imageUrls = row.urls.filter(function (url) {
              return (/\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i.test(url)
              );
            });
            row.urls.forEach(function (url, index) {
              var isImage = /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i.test(url);
              var isOfficeDoc = /\.(doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)(\?|$)/i.test(url);
              if (isImage) {
                var imgIndex = imageUrls.indexOf(url);
                nodes.push(h('img', {
                  attrs: { src: url },
                  style: {
                    width: '48px',
                    height: '48px',
                    objectFit: 'cover',
                    marginRight: '4px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    verticalAlign: 'middle'
                  },
                  on: { click: function click() {
                      return _this.viewFile(imageUrls, imgIndex);
                    } }
                }));
              } else if (isOfficeDoc) {
                nodes.push(h('a', {
                  style: { display: 'inline-block', marginRight: '4px' },
                  attrs: { href: 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), target: '_blank' }
                }, '预览'));
              } else {
                nodes.push(h('a', {
                  style: { display: 'inline-block', marginRight: '4px' },
                  attrs: { href: url, target: '_blank' }
                }, '下载'));
              }
            });
            return h('div', nodes);
          }
          return h('span', '');
        }
      }, {
        title: '处理人',
        width: 110,
        key: 'creatorName'
      }],
      titleStuList: [{
        title: '学生ID',
        width: 110,
        key: 'uid'
      }, {
        title: '学生姓名',
        key: 'nickname',
        width: 110
      }, {
        title: '销售',
        width: 110,
        key: 'adviserName'
      }, {
        title: '学导',
        width: 110,
        key: 'studyAdviserName'
      }, {
        title: '上课时间',
        width: 170,
        render: function render(h, params) {
          var list = params.row.bookWorkLessonOpenedTimeList;
          var spanArr = [];
          if (list) {
            list.forEach(function (element) {
              var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
              spanArr.push(h('span', '[' + $constant.weekZh[element.week] + startTime + ']'));
              spanArr.push(h('br'));
            });
          }
          return h('div', spanArr);
        }
      }],
      visible: this.value,
      isAddTch: true,
      tchRule: {
        sex: [{ type: 'number', required: true, message: '性别不能为空', trigger: 'blur' }],
        status: [{ type: 'number', required: true, message: '状态不能为空', trigger: 'blur' }],
        category: [{ type: 'number', required: true, message: '类型不能为空', trigger: 'blur' }],
        tchType: [{ type: 'number', required: true, message: '授课类型不能为空', trigger: 'blur' }],
        isAudition: [{ type: 'string', required: true, message: '试听权限不能为空', trigger: 'blur' }]
      },
      tchTrackFormData: {
        trackType: null,
        content: '',
        tchId: null,
        tchName: '',
        studyAdviserName: '',
        createTime: null,
        picUrl: ''
      },
      queryParam: {
        trackType: null,
        tchId: ''
      },
      queryParams: {
        startTime: '',
        endTime: '',
        tchId: '',
        totalCount: 0,
        pageIndex: 1,
        pageSize: 20
      },
      tchTrackRule: {
        tchId: [{ type: 'number', required: true, message: 'tchId不能为空', trigger: 'blur' }],
        trackType: [{ type: 'number', required: true, message: '类型不能为空', trigger: 'blur' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }]
      },
      timeSlots: [{ time: '6:00pm-6:30pm', startTime: '18:00', endTime: '18:30' }, { time: '6:30pm-7:00pm', startTime: '18:30', endTime: '19:00' }, { time: '7:00pm-7:30pm', startTime: '19:00', endTime: '19:30' }, { time: '7:30pm-8:00pm', startTime: '19:30', endTime: '20:00' }, { time: '8:00pm-8:30pm', startTime: '20:00', endTime: '20:30' }, { time: '8:30pm-9:00pm', startTime: '20:30', endTime: '21:00' }, { time: '9:00pm-9:30pm', startTime: '21:00', endTime: '21:30' }],
      courseDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      courseSlots: ['6:00pm-6:30pm', '6:30pm-7:00pm', '7:00pm-7:30pm', '7:30pm-8:00pm', '8:00pm-8:30pm', '8:30pm-9:00pm', '9:00pm-9:30pm'],
      availabilityStates: ['available', 'unsure', 'unavailable', ''],
      availabilitySymbols: {
        available: '√',
        unsure: '?',
        unavailable: '×',
        '': '-'
      },
      workTimeSelections: {},
      statPeriodType: 'month',
      statDate: new Date(),
      statStartDate: '',
      statEndDate: '',
      statLoading: false,
      statExportLoading: false,
      personalStat: {
        leaveRate: '—',
        leaveNumerator: null,
        leaveDenominator: null,
        tempLeaveRate: '—',
        tempLeaveCount: null,
        tempLeaveBaseCount: null,
        fullAttendanceRate: '—',
        fullAttendanceCount: null,
        fullAttendanceTotalCount: null,
        lateRate: '—',
        lateCount: null,
        lateBaseCount: null,
        earlyRate: '—',
        earlyCount: null,
        earlyBaseCount: null,
        returnLessonHours: null,
        refundStudentCount: null,
        demoAttendDealRate: '—',
        demoAttendDealCount: null,
        demoAttendCount: null,
        attendLessonRate: '—',
        attendLessonCount: null,
        attendLessonBaseCount: null,
        asOfTime: ''
      },
      showStatDetailModal: false,
      statDetailMetric: '',
      statDetailField: '',
      statDetailSplit: false,
      statDetailLeftTitle: '',
      statDetailLeftValue: '—',
      statDetailRightTitle: '',
      statDetailRightValue: '—',
      statDetailHasDiff: false,
      statDetailDiffTitle: '未全勤课节',
      statDetailDiffValue: '—',
      statDetailFieldTitle: '',
      statDetailLoading: false,
      rankScoreSeq: 0,
      statDetailExportLoading: false,
      statDetailTableData: [],
      statDetailTotal: 0,
      statDetailPageIndex: 1,
      statDetailPageSize: 20,
      onboardingLoading: false,
      onboardingRows: [],
      onboardingDoneCount: 0,
      onboardingTotalCount: 0,
      onboardingVersionId: null,
      onboardingColumns: [{
        title: '阶段',
        key: 'stageName',
        width: 180
      }, {
        title: '标题',
        key: 'title',
        minWidth: 200
      }, {
        title: '是否完成',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          return h('Tag', {
            props: { color: params.row.done ? 'green' : 'default' }
          }, params.row.done ? '已完成' : '未完成');
        }
      }, {
        title: '文字',
        minWidth: 160,
        render: function render(h, params) {
          return h('span', params.row.textValue || '-');
        }
      }, {
        title: '图片',
        width: 180,
        render: function render(h, params) {
          return _this.renderOnboardingPhotos(h, params.row.photoUrls);
        }
      }]
    };
  },

  computed: {
    tabBarKey: function tabBarKey() {
      var rules = this.detailTabRules || {};
      return [this.isAddTch ? '1' : '0', this.tchId || 0, this.seeStuList ? '1' : '0', this.seeTchTrack ? '1' : '0', this.referrerTabVisible ? '1' : '0', rules.referrer ? '1' : '0', rules.colorBlock ? '1' : '0', rules.bindStu ? '1' : '0', rules.track ? '1' : '0', rules.stat ? '1' : '0', rules.onboarding ? '1' : '0', rules.classFeedback ? '1' : '0'].join('-');
    },
    showBirthday: function showBirthday() {
      var adminRule = this.$store.get('adminRule');

      return adminRule === 0 || adminRule === 3 || adminRule === '0' || adminRule === '3';
    },
    enabledChannelOptions: function enabledChannelOptions() {
      var list = (this.channelOptions || []).filter(function (item) {
        return item.status === 1;
      });
      var current = this.formData.tchForm && this.formData.tchForm.regFrom;
      if (current && !list.some(function (item) {
        return item.param === current;
      })) {
        var extra = (this.channelOptions || []).find(function (item) {
          return item.param === current;
        });
        if (extra) {
          list = list.concat([extra]);
        }
      }
      return list;
    },

    titles: function titles() {
      var startHour = 23;
      var endHour = 0;
      this.dataList.forEach(function (item) {
        if (item.bookTchOpenedTimeDtoList) {
          item.bookTchOpenedTimeDtoList.forEach(function (i) {
            startHour = Math.min(Math.floor(i.startTime / 60 / 60), startHour);
            endHour = Math.max(Math.floor(i.endTime / 60 / 60), endHour);

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchOpenedTimeDtoList time error', item);
            }
          });
        }
        if (item.bookWorkLessonOpenedTimeDtoList) {
          item.bookWorkLessonOpenedTimeDtoList.forEach(function (i) {
            startHour = Math.min(Math.floor(i.startTime / 60 / 60), startHour);
            endHour = Math.max(Math.floor(i.endTime / 60 / 60), endHour);

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookWorkLessonOpenedTimeDtoList time error', item);
            }
          });
        }
        if (item.tchScheduleBookLessonOpenedDtoList) {
          item.tchScheduleBookLessonOpenedDtoList.forEach(function (i) {
            startHour = Math.min(Math.floor(new Date(i.lsnBeginTime * 1000).getHours()), startHour);
            endHour = Math.max(Math.floor(new Date(i.lsnEndTime * 1000).getHours()), endHour);

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('tchScheduleBookLessonOpenedDtoList time error', item);
            }
          });
        }
        if (item.tchScheduleBookLessonTestOpenedDtoList) {
          item.tchScheduleBookLessonTestOpenedDtoList.forEach(function (i) {
            startHour = Math.min(Math.floor(new Date(i.lsnBeginTime * 1000).getHours()), startHour);
            endHour = Math.max(Math.floor(new Date(i.lsnEndTime * 1000).getHours()), endHour);

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('tchScheduleBookLessonTestOpenedDtoList time error', item);
            }
          });
        }
        if (item.bookTchRandomOpenedTimeDtoList) {
          item.bookTchRandomOpenedTimeDtoList.forEach(function (i) {
            startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour);
            endHour = Math.max(Math.floor(new Date(i.endTime * 1000).getHours()), endHour);

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchRandomOpenedTimeDtoList time error', item);
            }
          });
        }
        if (item.bookTchLeaveTimeDtoList) {
          item.bookTchLeaveTimeDtoList.forEach(function (i) {
            if (new Date(item.dateStr).getDate() === new Date(i.startTime * 1000).getDate() && new Date(item.dateStr).getDate() === new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour);
              endHour = Math.max(Math.floor(new Date(i.endTime * 1000 - 1).getHours()), endHour);
            } else if (new Date(item.dateStr).getDate() === new Date(i.startTime * 1000).getDate() && new Date(item.dateStr).getDate() !== new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour);
              endHour = Math.max(23, endHour);
            } else if (new Date(item.dateStr).getDate() !== new Date(i.startTime * 1000).getDate() && new Date(item.dateStr).getDate() === new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour);
              endHour = Math.max(Math.floor(new Date(i.endTime * 1000 - 1).getHours()), endHour);
            } else if (new Date(item.dateStr).getDate() !== new Date(i.startTime * 1000).getDate() && new Date(item.dateStr).getDate() !== new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour);
              endHour = Math.max(23, endHour);
            }

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchLeaveTimeDtoList time error', item);
            }
          });
        }
      });
      var columns = [{
        title: '时间',
        width: 100,
        key: 'title'
      }];

      startHour = Math.max(9, startHour);
      for (var i = startHour; i <= endHour; i++) {
        columns.push({
          title: i,
          hour: i
        });
      }
      return columns;
    },
    groupedDataList: function groupedDataList() {
      var _this2 = this;

      console.log('groupedDataList 计算属性被调用');
      console.log('dataList:', this.dataList);

      if (!this.dataList || this.dataList.length === 0) {
        console.log('dataList 为空，返回 []');
        return [];
      }

      var groups = [];
      var currentGroup = [];

      this.dataList.forEach(function (item, index) {
        currentGroup.push(item);
        console.log('\u6DFB\u52A0\u7B2C ' + (index + 1) + ' \u5929\u6570\u636E\uFF0Cweek=' + item.week);

        if (item.week === 7 || index === _this2.dataList.length - 1) {
          console.log('\u7ED3\u675F\u5F53\u524D\u7EC4\uFF0C\u5171 ' + currentGroup.length + ' \u5929');
          groups.push(currentGroup);
          currentGroup = [];
        }
      });

      console.log('最终分组结果:', groups);
      return groups;
    },
    statWeekRangeText: function statWeekRangeText() {
      if (this.statPeriodType !== 'week' || !this.statStartDate || !this.statEndDate) {
        return '';
      }
      return this.statStartDate + ' ~ ' + this.statEndDate;
    },
    statDatePickerType: function statDatePickerType() {
      if (this.statPeriodType === 'year') {
        return 'year';
      }
      if (this.statPeriodType === 'month') {
        return 'month';
      }
      return 'date';
    },
    statDatePickerFormat: function statDatePickerFormat() {
      if (this.statPeriodType === 'year') {
        return 'yyyy';
      }
      if (this.statPeriodType === 'month') {
        return 'yyyy-MM';
      }
      return 'yyyy-MM-dd';
    },
    statLeaveRateText: function statLeaveRateText() {
      if (this.personalStat.leaveDenominator === 0) {
        return '—';
      }
      return this.personalStat.leaveRate || '—';
    },
    statLeaveSub: function statLeaveSub() {
      var n = this.personalStat.leaveNumerator;
      var d = this.personalStat.leaveDenominator;
      if (n == null || d == null || d === 0) {
        return '—';
      }
      return n + ' / ' + d + ' 节';
    },
    statTempLeaveRateText: function statTempLeaveRateText() {
      if (this.personalStat.tempLeaveBaseCount === 0) {
        return '—';
      }
      return this.personalStat.tempLeaveRate || '—';
    },
    statTempLeaveSub: function statTempLeaveSub() {
      var n = this.personalStat.tempLeaveCount;
      var d = this.personalStat.tempLeaveBaseCount;
      if (n == null || d == null || d === 0) {
        return '—';
      }
      return n + ' / ' + d;
    },
    statFullAttendRateText: function statFullAttendRateText() {
      if (this.personalStat.fullAttendanceTotalCount === 0) {
        return '—';
      }
      return this.personalStat.fullAttendanceRate || '—';
    },
    statFullAttendSub: function statFullAttendSub() {
      var n = this.personalStat.fullAttendanceCount;
      var d = this.personalStat.fullAttendanceTotalCount;
      if (n == null || d == null || d === 0) {
        return '—';
      }
      return n + ' / ' + d + ' 节';
    },
    statFullAttendDiffText: function statFullAttendDiffText() {
      var n = this.personalStat.fullAttendanceCount;
      var d = this.personalStat.fullAttendanceTotalCount;
      if (n == null || d == null) {
        return '—';
      }
      return String(Math.max(d - n, 0));
    },
    statLateRateText: function statLateRateText() {
      if (this.personalStat.lateBaseCount === 0) {
        return '—';
      }
      return this.personalStat.lateRate || '—';
    },
    statLateSub: function statLateSub() {
      var n = this.personalStat.lateCount;
      var d = this.personalStat.lateBaseCount;
      if (n == null || d == null || d === 0) {
        return '—';
      }
      return n + ' / ' + d + ' 节';
    },
    statEarlyRateText: function statEarlyRateText() {
      if (this.personalStat.earlyBaseCount === 0) {
        return '—';
      }
      return this.personalStat.earlyRate || '—';
    },
    statEarlySub: function statEarlySub() {
      var n = this.personalStat.earlyCount;
      var d = this.personalStat.earlyBaseCount;
      if (n == null || d == null || d === 0) {
        return '—';
      }
      return n + ' / ' + d + ' 节';
    },
    statReturnHoursText: function statReturnHoursText() {
      return this.personalStat.returnLessonHours == null ? '0' : String(this.personalStat.returnLessonHours);
    },
    statReturnHoursSub: function statReturnHoursSub() {
      return '课堂投诉审核通过、外教课、赠课原因是老师';
    },
    statRefundText: function statRefundText() {
      return this.personalStat.refundStudentCount == null ? '—' : String(this.personalStat.refundStudentCount);
    },
    statRefundSub: function statRefundSub() {
      if (this.personalStat.refundStudentCount == null) {
        return '人';
      }
      return this.personalStat.refundStudentCount + ' 人';
    },
    statDemoRateText: function statDemoRateText() {
      return this.personalStat.demoAttendDealRate || '—';
    },
    statDemoSub: function statDemoSub() {
      var n = this.personalStat.demoAttendDealCount;
      var d = this.personalStat.demoAttendCount;
      if (n == null || d == null) {
        return '—';
      }
      return n + ' / ' + d;
    },
    statAttendRateText: function statAttendRateText() {
      return this.personalStat.attendLessonRate || '—';
    },
    statAttendSub: function statAttendSub() {
      var n = this.personalStat.attendLessonCount;
      var d = this.personalStat.attendLessonBaseCount;
      if (n == null || d == null) {
        return '—';
      }
      return n + ' / ' + d;
    },
    statDetailSplitHint: function statDetailSplitHint() {
      if (this.statDetailHasDiff) {
        return '跟看板详情同一口径，点分子、分母或未全勤课节看明细。';
      }
      return '跟看板详情同一口径，点分子或分母看明细。';
    },
    statDetailModalTitle: function statDetailModalTitle() {
      var names = {
        leaveRate: '请假率',
        tempLeaveRate: '临时请假率',
        fullAttendanceRate: '全勤率',
        lateRate: '迟到率',
        earlyRate: '早退率',
        attendLessonRate: '上课率',
        returnLessonHours: '返课时数',
        refundStudentCount: '退费学生数',
        demoAttendDealRate: 'Demo出席成交率'
      };
      var name = names[this.statDetailMetric] || '数据统计';
      if (this.statStartDate && this.statEndDate) {
        return name + ' · ' + this.statStartDate + ' ~ ' + this.statEndDate;
      }
      return name;
    },
    statDetailColumns: function statDetailColumns() {
      var _this3 = this;

      var $constant = this.$constant;
      if (this.statDetailField === 'nonFullLessons') {
        return [{
          title: '老师',
          key: 'teacher',
          align: 'center',
          minWidth: 220,
          render: function render(h, params) {
            var row = params.row || {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: _this3.statTeacherLabel(row),
              score: row.monthRankScore
            });
          }
        }, { title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110 }, { title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170 }, { title: '异常原因', key: 'extra', align: 'center', minWidth: 220 }];
      }
      if (this.statDetailMetric === 'returnLessonHours') {
        return [{ title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '学生姓名', key: 'studentName', align: 'center', minWidth: 120 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, { title: '课时', key: 'num', align: 'center', minWidth: 80 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '审核时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.statDetailMetric === 'refundStudentCount') {
        return [{ title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '学生姓名', key: 'studentName', align: 'center', minWidth: 120 }, {
          title: '最后一节课老师',
          key: 'lastTchName',
          align: 'center',
          minWidth: 200,
          render: function render(h, params) {
            var row = params.row || {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: (row.lastTchName || '').trim(),
              score: row.monthRankScore
            });
          }
        }, { title: '对应老师外管', key: 'tchAdviserName', align: 'center', minWidth: 140 }, {
          title: '退费原因分类',
          align: 'center',
          minWidth: 130,
          render: function render(h, params) {
            var statusEnum = $constant.getEnum($constant.refundReasonCategory, params.row.refundReasonCategory);
            return h('span', statusEnum && statusEnum.text);
          }
        }, { title: '退费原因', key: 'refundReason', align: 'center', minWidth: 180 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.statDetailMetric === 'demoAttendDealRate') {
        return [{ title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '学生姓名', key: 'studentName', align: 'center', minWidth: 140 }, { title: '成交外教', key: 'demoTch', align: 'center', minWidth: 140 }, { title: '类型', key: 'extra', align: 'center', minWidth: 90 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      if (this.statDetailMetric === 'leaveRate' || this.statDetailMetric === 'fullAttendanceRate' || this.statDetailMetric === 'lateRate' || this.statDetailMetric === 'earlyRate') {
        return [{ title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110 }, { title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, { title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170 }, { title: '类型', key: 'extra', align: 'center', minWidth: 140 }];
      }
      if (this.statDetailMetric === 'attendLessonRate' || this.statDetailMetric === 'tempLeaveRate') {
        var self = this;
        return [{ title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, {
          title: '姓名',
          key: 'tchName',
          align: 'center',
          minWidth: 140,
          render: function render(h, params) {
            var row = params.row;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
              text: self.formatStatFirstLastName(row),
              score: row.monthRankScore
            });
          }
        }, { title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '课节数', key: 'num', align: 'center', minWidth: 80 }, { title: '类型', key: 'extra', align: 'center', minWidth: 160 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
      }
      return [{ title: '老师ID', key: 'tchId', align: 'center', minWidth: 90 }, { title: '账号', key: 'account', align: 'center', minWidth: 140 }, {
        title: '姓名',
        key: 'tchName',
        align: 'center',
        minWidth: 160,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchName || ((row.firstName || '') + ' ' + (row.lastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, { title: '学生ID', key: 'uid', align: 'center', minWidth: 90 }, { title: '课节数', key: 'num', align: 'center', minWidth: 80 }, { title: '类型', key: 'extra', align: 'center', minWidth: 160 }, { title: '时间', key: 'occurTime', align: 'center', minWidth: 160 }];
    },
    statCards: function statCards() {
      return [{
        title: '请假率',
        metric: 'leaveRate',
        split: true,
        value: this.statLeaveRateText,
        sub: this.statLeaveSub,
        leftTitle: '全部请假类型或老师缺席',
        leftValue: this.personalStat.leaveNumerator == null ? '—' : String(this.personalStat.leaveNumerator),
        rightTitle: '有课课节',
        rightValue: this.personalStat.leaveDenominator == null ? '—' : String(this.personalStat.leaveDenominator)
      }, {
        title: '临时请假率',
        metric: 'tempLeaveRate',
        split: true,
        value: this.statTempLeaveRateText,
        sub: this.statTempLeaveSub,
        leftTitle: '临时请假+失联+取消课或老师缺席',
        leftValue: this.personalStat.tempLeaveCount == null ? '—' : String(this.personalStat.tempLeaveCount),
        rightTitle: '有课课节',
        rightValue: this.personalStat.tempLeaveBaseCount == null ? '—' : String(this.personalStat.tempLeaveBaseCount)
      }, {
        title: '全勤率',
        metric: 'fullAttendanceRate',
        split: true,
        value: this.statFullAttendRateText,
        sub: this.statFullAttendSub,
        leftTitle: '全勤课节',
        leftValue: this.personalStat.fullAttendanceCount == null ? '—' : String(this.personalStat.fullAttendanceCount),
        rightTitle: '有课课节',
        rightValue: this.personalStat.fullAttendanceTotalCount == null ? '—' : String(this.personalStat.fullAttendanceTotalCount)
      }, {
        title: '迟到率',
        metric: 'lateRate',
        split: true,
        value: this.statLateRateText,
        sub: this.statLateSub,
        foot: '迟到率 = 老师迟到的课 ÷ 正常上课的课。正常上课是已经上完，学生没有缺席，老师也没有缺席。没有通话记录按都没缺席、老师也没迟到/早退来算。没有正常上课课节显示 —。',
        leftTitle: '迟到课节',
        leftValue: this.personalStat.lateCount == null ? '—' : String(this.personalStat.lateCount),
        rightTitle: '正常上课课节',
        rightValue: this.personalStat.lateBaseCount == null ? '—' : String(this.personalStat.lateBaseCount)
      }, {
        title: '早退率',
        metric: 'earlyRate',
        split: true,
        value: this.statEarlyRateText,
        sub: this.statEarlySub,
        foot: '早退率 = 老师早退的课 ÷ 正常上课的课。正常上课是已经上完，学生没有缺席，老师也没有缺席。没有通话记录按都没缺席、老师也没迟到/早退来算。没有正常上课课节显示 —。',
        leftTitle: '早退课节',
        leftValue: this.personalStat.earlyCount == null ? '—' : String(this.personalStat.earlyCount),
        rightTitle: '正常上课课节',
        rightValue: this.personalStat.earlyBaseCount == null ? '—' : String(this.personalStat.earlyBaseCount)
      }, {
        title: '上课率',
        metric: 'attendLessonRate',
        split: true,
        value: this.statAttendRateText,
        sub: this.statAttendSub,
        leftTitle: '已上课课节',
        leftValue: this.personalStat.attendLessonCount == null ? '—' : String(this.personalStat.attendLessonCount),
        rightTitle: '买断+临时课节',
        rightValue: this.personalStat.attendLessonBaseCount == null ? '—' : String(this.personalStat.attendLessonBaseCount)
      }, {
        title: '返课时数',
        metric: 'returnLessonHours',
        split: false,
        value: this.statReturnHoursText,
        sub: this.statReturnHoursSub
      }, {
        title: '退费学生数',
        metric: 'refundStudentCount',
        split: false,
        value: this.statRefundText,
        sub: this.statRefundSub
      }, {
        title: 'Demo出席成交率',
        metric: 'demoAttendDealRate',
        split: true,
        value: this.statDemoRateText,
        sub: this.statDemoSub,
        leftTitle: '成交学生',
        leftValue: this.personalStat.demoAttendDealCount == null ? '—' : String(this.personalStat.demoAttendDealCount),
        rightTitle: '出席学生',
        rightValue: this.personalStat.demoAttendCount == null ? '—' : String(this.personalStat.demoAttendCount)
      }];
    }
  },
  created: function created() {
    this.loadRegChannels();
    this.isAddTch = !(this.tchId > 0);
    if (this.addType === 'agency' && this.isAddTch) {
      this.saveType = 'agency';
      this.formData.category = 6;
    }
    if (this.value) {
      this.loadDetailTabRules();
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.statDetailTableData;
      if (!table || !table.length) {
        return;
      }

      var rows = Array.isArray(table) ? table : table.data || [];
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    loadDetailTabRules: function loadDetailTabRules() {
      var self = this;
      var rules = [{ url: '/tch/detail/referrer', key: 'referrer' }, { url: '/tch/detail/colorBlock', key: 'colorBlock' }, { url: '/tch/detail/bindStu', key: 'bindStu' }, { url: '/tch/detail/track', key: 'track' }, { url: '/tch/detail/stat', key: 'stat' }, { url: '/tch/detail/onboarding', key: 'onboarding' }, { url: '/tch/detail/classFeedback', key: 'classFeedback' }];
      var next = {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      };
      var seq = ++this.detailTabSeq;
      this.detailTabRules = {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      };
      var pending = rules.length;
      rules.forEach(function (rule) {
        self.$http.post('/common/getPermissionByUrl', { url: rule.url }).then(function (res) {
          next[rule.key] = !!(res && res.data === true);
        }).catch(function () {
          next[rule.key] = true;
        }).finally(function () {
          pending -= 1;
          if (pending === 0 && seq === self.detailTabSeq) {
            self.detailTabRules = next;
            self.ensureDetailTabVisible();
          }
        });
      });
    },
    ensureDetailTabVisible: function ensureDetailTabVisible() {
      var allowed = {
        '基本信息': true,
        '推荐官': this.referrerTabVisible && this.detailTabRules.referrer,
        '色块表': !this.isAddTch && this.detailTabRules.colorBlock,
        '在绑学生': this.seeStuList && this.tchTrackFormData.tchId > 0 && this.detailTabRules.bindStu,
        '老师跟踪记录': this.seeTchTrack && this.detailTabRules.track,
        '数据统计': !this.isAddTch && this.tchId && this.detailTabRules.stat,
        '开课Checklist': !this.isAddTch && this.tchId && this.detailTabRules.onboarding,
        '老师评分及课堂展示': !this.isAddTch && this.tchId && this.detailTabRules.classFeedback
      };
      if (!allowed[this.tabName]) {
        this.tabName = '基本信息';
      }
    },
    loadRegChannels: function loadRegChannels() {
      var self = this;
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data;
        }
      });
    },
    onYearChange: function onYearChange(val) {
      this.formData.tchForm.yearOfGraduation = val;
    },
    onAgeChange: function onAgeChange(val) {
      var _this4 = this;

      if (this._syncingAgeBirthday) return;
      if (!val) return;
      this._syncingAgeBirthday = true;
      var now = new Date();
      var year = now.getFullYear() - val;
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      this.formData.birthday = year + '-' + month + '-' + day;
      this.$nextTick(function () {
        _this4._syncingAgeBirthday = false;
      });
    },
    onBirthdayChange: function onBirthdayChange() {
      var _this5 = this;

      if (this._syncingAgeBirthday) return;
      var val = this.formData.birthday;
      if (!val) return;
      this._syncingAgeBirthday = true;
      var birth = new Date(val);
      if (isNaN(birth.getTime())) {
        this._syncingAgeBirthday = false;
        return;
      }
      var now = new Date();
      var age = now.getFullYear() - birth.getFullYear();
      var m = now.getMonth() - birth.getMonth();
      if (m < 0 || m === 0 && now.getDate() < birth.getDate()) {
        age--;
      }
      this.formData.age = age;
      this.$nextTick(function () {
        _this5._syncingAgeBirthday = false;
      });
    },
    validateNumericField: function validateNumericField(obj, key) {
      var value = obj[key];
      if (value === '' || value === null || value === undefined) return;
      var strValue = String(value);
      var trimmed = strValue.trim();
      if (trimmed !== strValue) {
        obj[key] = trimmed;
        strValue = trimmed;
      }
      if (strValue === '') return;
      if (/[^\d.]/.test(strValue) || (strValue.match(/\./g) || []).length > 1) {
        this.$Message.warning('请输入数字类型');
      }
    },
    getWorkTimeStatus: function getWorkTimeStatus(week, startTime, endTime) {
      if (!this.formData.workTimes || this.formData.workTimes.length === 0) {
        return null;
      }
      var workTime = this.formData.workTimes.find(function (wt) {
        return wt.week === week && wt.startTime === startTime && wt.endTime === endTime;
      });
      return workTime ? workTime.status : null;
    },
    toggleAvailability: function toggleAvailability(week, slot) {
      var key = week + '-' + slot;
      var current = this.workTimeSelections[key] || '';
      var currentIndex = this.availabilityStates.indexOf(current);
      var nextIndex = (currentIndex + 1) % this.availabilityStates.length;
      var nextState = this.availabilityStates[nextIndex];

      if (nextState === '') {
        this.$delete(this.workTimeSelections, key);
      } else {
        this.$set(this.workTimeSelections, key, nextState);
      }
      this.syncWorkTimes();
    },
    availabilitySymbol: function availabilitySymbol(week, slot) {
      var key = week + '-' + slot;
      var state = this.workTimeSelections[key] || '';
      return this.availabilitySymbols[state];
    },
    availabilityClass: function availabilityClass(week, slot) {
      var key = week + '-' + slot;
      var state = this.workTimeSelections[key] || '';
      return state ? 'state-' + state : 'state-empty';
    },
    syncWorkTimes: function syncWorkTimes() {
      var _this6 = this;

      this.formData.workTimes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.workTimeSelections).map(function (key) {
        var _key$split = key.split('-'),
            _key$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toArray___default()(_key$split),
            week = _key$split2[0],
            timeParts = _key$split2.slice(1);

        var slot = timeParts.join('-');

        var _slot$split = slot.split('-'),
            _slot$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_slot$split, 2),
            startTime = _slot$split2[0],
            endTime = _slot$split2[1];

        var convertTime = function convertTime(timeStr) {
          var isPM = timeStr.includes('pm');
          var cleanTime = timeStr.replace('pm', '').replace('am', '');

          var _cleanTime$split = cleanTime.split(':'),
              _cleanTime$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_cleanTime$split, 2),
              hour = _cleanTime$split2[0],
              minute = _cleanTime$split2[1];

          var hourNum = parseInt(hour);

          if (isPM && hourNum !== 12) {
            hourNum += 12;
          } else if (!isPM && hourNum === 12) {
            hourNum = 0;
          }

          return hourNum.toString().padStart(2, '0') + ':' + minute;
        };

        var convertedStartTime = convertTime(startTime);
        var convertedEndTime = convertTime(endTime);

        return {
          week: parseInt(week),
          timeSlot: convertedStartTime + '-' + convertedEndTime,
          status: _this6.workTimeSelections[key],
          startTime: convertedStartTime,
          endTime: convertedEndTime
        };
      });
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    viewFile: function viewFile(urls, index) {
      this.showImgList = urls;
      this.showImgModal = true;
    },
    redirectToTchSystem: function redirectToTchSystem() {
      var _this7 = this;

      var self = this;
      this.$http.get('/tch/getAdminToken?type=teacher').then(function (res) {
        if (res.data) {
          if (_this7.$appConfig.active === 'prod') {
            window.open('https://tutor.kouyujie.cn/#/login?mobile=' + self.formData.account + '&token=' + res.data + '&type=admin');
          } else {
            window.open('https://test.tutor.kouyujie.cn/#/login?mobile=' + self.formData.account + '&token=' + res.data + '&type=admin');
          }
        }
      });
      return;
    },
    handleResume: function handleResume(file, fileList) {
      this.resumeList = fileList.slice(-1);
    },
    resumeSuccess: function resumeSuccess(res, file, fileList) {
      this.formData.resume = res.data.name;
      this.resume = res.data.url;
    },
    handleSelfIntroductionVideo: function handleSelfIntroductionVideo(file, fileList) {
      this.selfIntroductionVideoList = fileList.slice(-1);
    },
    handleTeachVideo: function handleTeachVideo(file, fileList) {
      this.teachVideoList = fileList.slice(-1);
    },
    handleTeachImages: function handleTeachImages(file, fileList) {
      this.teachImagesList = fileList;
    },
    addPolishLessonVideoRow: function addPolishLessonVideoRow() {
      if (this.polishLessonVideoList.length < 10) {
        this.polishLessonVideoList.push('');
      }
    },
    fillPolishLessonVideoList: function fillPolishLessonVideoList(raw) {
      var rows = [];
      if (raw) {
        raw.split(',').forEach(function (url) {
          var trimmed = (url || '').trim();
          if (trimmed) {
            rows.push(__WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(trimmed) || trimmed);
          }
        });
      }
      this.polishLessonVideoList = rows.length ? rows : [''];
    },
    handleNationalityImageChange: function handleNationalityImageChange(file, fileList) {
      this.nationalityImageUrlList = fileList.slice(-1);
    },
    nationalityImageSuccess: function nationalityImageSuccess(res, file, fileList) {
      this.formData.tchForm.nationalityImage = res.data.name;
      this.nationalityImageUrl = res.data.url;
    },
    nationalityImageRemove: function nationalityImageRemove(file, fileList) {
      if (!fileList || fileList.length === 0) {
        this.formData.tchForm.nationalityImage = '';
        this.nationalityImageUrl = '';
      }
    },
    beforeUploadNationalityImage: function beforeUploadNationalityImage(file) {
      var isImage = file.type.startsWith('image/');
      var isLt30M = file.size / 1024 / 1024 < 30;

      if (!isImage) {
        this.$Message.error('只能上传图片文件!');
      }
      if (!isLt30M) {
        this.$Message.error('图片大小不能超过30MB!');
      }

      return isImage && isLt30M;
    },
    selfIntroductionVideoSuccess: function selfIntroductionVideoSuccess(res, file, fileList) {
      this.formData.selfIntroductionVideo = res.data.name;
      this.selfIntroductionVideo = res.data.url;
    },
    teachVideoSuccess: function teachVideoSuccess(res, file, fileList) {
      this.formData.teachVideo = res.data.name;
      this.teachVideo = res.data.url;
    },
    teachImagesSuccess: function teachImagesSuccess(res, file, fileList) {
      this.images.push(res.data.url);
    },
    onAreaNumChange: function onAreaNumChange(val) {
      if (val) {
        this.formData.areaNum = val;
      }
    },
    onTimeZoneChange: function onTimeZoneChange(val) {
      if (val) {
        this.formData.timeDiff = val;
      }
    },
    openImage: function openImage(url) {
      if (url) {
        window.open(url);
      }
    },
    updateTchInfo: function updateTchInfo() {
      var _this8 = this;

      var self = this;
      if (self.formData.account === '无查看权限') {
        self.$Message.warning('无修改权限!');
        return;
      }

      var numericFields = [{ obj: self.formData, key: 'salary', label: '时薪' }, { obj: self.formData.tchForm, key: 'expectSalary', label: '期望时薪' }, { obj: self.formData, key: 'upSpeed', label: '上传速度' }, { obj: self.formData, key: 'downSpeed', label: '下载速度' }];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(numericFields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          var val = field.obj[field.key];
          if (val !== '' && val !== null && val !== undefined) {
            var trimmed = String(val).trim();
            if (trimmed !== '' && (/[^\d.]/.test(trimmed) || (trimmed.match(/\./g) || []).length > 1)) {
              self.$Message.warning(field.label + '：请输入数字类型');
              return;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.$refs.tchForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        if (!_this8.tchId) {
          var firstName = self.formData.firstName || '';
          var lastName = self.formData.lastName || '';
          var fullName = self.formData.tchForm && self.formData.tchForm.fullName || '';
          if (!firstName.trim() && !lastName.trim() && !fullName.trim()) {
            self.$Message.warning('First Name、Last Name 和 Full Name 至少填写一个!');
            return;
          }
        }
        if (self.featuresArray) {
          self.formData.features = self.featuresArray.join(',');
        }
        if (self.levelArray) {
          self.formData.suitableLevel = self.levelArray.join(',');
        }
        if (self.images) {
          self.formData.images = self.images.join(',');
        }
        var polishUrls = [];
        var polishRows = self.polishLessonVideoList || [];
        polishRows.forEach(function (url) {
          var trimmed = (url || '').trim();
          if (trimmed) {
            polishUrls.push(trimmed);
          }
        });
        self.formData.polishLessonVideos = polishUrls.join(',');
        var url;
        if (_this8.tchId) {
          url = '/tch/bopsUpdate';
        } else {
          url = '/tch/bopsInsert';
          if (_this8.saveType === 'training') {
            self.formData.category = 4;
          }
          if (_this8.saveType === 'agency') {
            self.formData.category = 6;
          }
          if (_this8.recruitFlowEntry) {
            self.formData.recruitFlowEntry = _this8.recruitFlowEntry;
          } else if (_this8.saveType === 'training') {
            self.formData.recruitFlowEntry = '培训中老师';
          } else if (_this8.saveType === 'agency') {
            self.formData.recruitFlowEntry = '中介';
          }
        }
        self.insertLoading = true;
        self.$http.post(url, self.formData, {
          headers: { 'Content-Type': 'application/json;charset=utf-8' },
          transformRequest: [function (data) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data);
          }]
        }).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
            self.$Message.success('提交成功!');
          }
          self.insertLoading = false;
        }).catch(function (e) {
          self.insertLoading = false;
        });
      });
    },
    onLoading: function onLoading(loading) {
      this.insertLoading = loading;
    },
    handleResult: function handleResult(file) {
      this.formData.avatar = file.name;
      this.totalImageUrl = file.url;
    },
    handleTESOL: function handleTESOL(file, fileList) {
      this.certificateTesolUrlList = fileList.slice(-1);
    },
    TESOLSuccess: function TESOLSuccess(res, file, fileList) {
      this.formData.certificateTesol = res.data.name;
      this.certificateTesolUrl = res.data.url;
    },
    handleTESOLOut: function handleTESOLOut(file, fileList) {
      this.certificateTesolOutUrlList = fileList.slice(-1);
    },
    TESOLOutSuccess: function TESOLOutSuccess(res, file, fileList) {
      this.formData.certificateTesolOut = res.data.name;
      this.certificateTesolOutUrl = res.data.url;
    },
    handleTEFL: function handleTEFL(file, fileList) {
      this.certificateTeflUrlList = fileList.slice(-1);
    },
    TEFLSuccess: function TEFLSuccess(res, file, fileList) {
      this.formData.certificateTefl = res.data.name;
      this.certificateTeflUrl = res.data.url;
    },
    handleTEFLOut: function handleTEFLOut(file, fileList) {
      this.certificateTeflOutUrlList = fileList.slice(-1);
    },
    TEFLOutSuccess: function TEFLOutSuccess(res, file, fileList) {
      this.formData.certificateTeflOut = res.data.name;
      this.certificateTeflOutUrl = res.data.url;
    },
    handleTEYL: function handleTEYL(file, fileList) {
      this.certificateTeylUrlList = fileList.slice(-1);
    },
    TEYLSuccess: function TEYLSuccess(res, file, fileList) {
      this.formData.certificateTeyl = res.data.name;
      this.certificateTeylUrl = res.data.url;
    },
    handleEnglish: function handleEnglish(file, fileList) {
      this.certificateEnglishUrlList = fileList.slice(-1);
    },
    handleEnglishOut: function handleEnglishOut(file, fileList) {
      this.certificateEnglishOutUrlList = fileList.slice(-1);
    },
    EnglishSuccess: function EnglishSuccess(res, file, fileList) {
      this.formData.certificateEnglish = res.data.name;
      this.certificateEnglishUrl = res.data.url;
    },
    EnglishOutSuccess: function EnglishOutSuccess(res, file, fileList) {
      this.formData.certificateEnglishOut = res.data.name;
      this.certificateEnglishOutUrl = res.data.url;
    },
    handleIntroduceDoc: function handleIntroduceDoc(file, fileList) {
      this.introduceDocUrlList = fileList.slice(-1);
    },
    IntroduceDocSuccess: function IntroduceDocSuccess(res, file, fileList) {
      this.formData.introduceDoc = res.data.name;
      this.introduceDocUrl = res.data.url;
    },
    handleIntroduceVideoUrl: function handleIntroduceVideoUrl(file, fileList) {
      this.introduceVideoUrlList = fileList.slice(-1);
    },
    IntroduceVideoUrlSuccess: function IntroduceVideoUrlSuccess(res, file, fileList) {
      this.formData.introduceVideo = res.data.name;
      this.introduceVideoUrl = res.data.url;
    },
    openDetailLink: function openDetailLink() {
      if (this.$appConfig.active === 'prod') {
        window.open('https://t.speakstreet.cn/?tchId=' + this.formData.id + '&tchName=' + this.formData.firstName + '' + this.formData.lastName, '_blank');
      } else {
        window.open('https://test-t.kouyujie.cn/?tchId=' + this.formData.id + '&tchName=' + this.formData.firstName + '' + this.formData.lastName, '_blank');
      }
    },
    editContract: function editContract() {
      var currentPath = this.$route.path;
      var currentQuery = this.$route.query;

      window.open(this.$router.resolve({ path: '/tch-contract',
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          from: encodeURIComponent(currentPath) }, currentQuery, {
          tchId: this.tchId }) }).href, '_blank');
    },
    deleteUrl: function deleteUrl(type) {
      if (type === 'TESOL') {
        this.formData.certificateTesol = '';
        this.certificateTesolUrl = '';
        this.certificateTesolUrlList = [];
        this.$Message.success('TESOL 删除成功!');
      } else if (type === 'TESOLOut') {
        this.formData.certificateTesolOut = '';
        this.certificateTesolOutUrl = '';
        this.certificateTesolOutUrlList = [];
        this.$Message.success('TESOL 删除成功!');
      } else if (type === 'TEFL') {
        this.formData.certificateTefl = '';
        this.certificateTeflUrl = '';
        this.certificateTeflUrlList = [];
        this.$Message.success('TEFL 删除成功!');
      } else if (type === 'TEFLOut') {
        this.formData.certificateTeflOut = '';
        this.certificateTeflOutUrl = '';
        this.certificateTeflOutUrlList = [];
        this.$Message.success('TEFL 删除成功!');
      } else if (type === 'TEYL') {
        this.formData.certificateTeyl = '';
        this.certificateTeylUrl = '';
        this.certificateTeylUrlList = [];
        this.$Message.success('TEYL 删除成功!');
      } else if (type === 'ENGLISH') {
        this.formData.certificateEnglish = '';
        this.certificateEnglishUrl = '';
        this.certificateEnglishUrlList = [];
        this.$Message.success('英语证件 删除成功!');
      } else if (type === 'ENGLISHOut') {
        this.formData.certificateEnglishOut = '';
        this.certificateEnglishOutUrl = '';
        this.certificateEnglishOutUrlList = [];
        this.$Message.success('英语证件 删除成功!');
      } else if (type === 'DOC') {
        this.formData.introduceDoc = '';
        this.introduceDocUrl = '';
        this.introduceDocUrlList = [];
        this.$Message.success('介绍文档 删除成功!');
      } else if (type === 'VIDEO') {
        this.formData.introduceVideo = '';
        this.introduceVideoUrl = '';
        this.introduceVideoUrlList = [];
        this.$Message.success('介绍视频 删除成功!');
      } else if (type === 'RESUME') {
        this.formData.resume = '';
        this.resume = '';
        this.resumeList = [];
        this.$Message.success('简历 删除成功!');
      } else if (type === 'SELFINTRODUCTIONVIDEO') {
        this.formData.selfIntroductionVideo = '';
        this.selfIntroductionVideo = '';
        this.selfIntroductionVideoList = [];
        this.$Message.success('自我介绍视频 删除成功!');
      } else if (type === 'TEACHVIDEO') {
        this.formData.teachVideo = '';
        this.teachVideo = '';
        this.teachVideoList = [];
        this.$Message.success('上课片段 删除成功!');
      } else if (type === 'NATIONALITY_IMAGE') {
        this.formData.tchForm.nationalityImage = '';
        this.nationalityImageUrl = '';
        this.nationalityImageUrlList = [];
        this.$Message.success('国籍图片 删除成功!');
      }
    },
    deleteImages: function deleteImages(type, item) {
      if (type === 'IMAGES') {
        var index = this.images.indexOf(item);
        if (index !== -1) {
          this.images.splice(index, 1);
        }
      }
    },
    loadTchInfo: function loadTchInfo() {
      var self = this;
      if (self.tchId > 0) {
        self.formData.tchId = self.tchId;
        self.tchTrackFormData.tchId = self.tchId;
        self.queryParam.tchId = self.tchId;
        if (self.tabName === '老师跟踪记录') {
          self.search();
        }
        self.$http.get('/tch/queryById?tchId=' + self.tchId).then(function (res) {
          if (res.data) {
            var data = res.data;
            self.tchTrackFormData.tchName = data.firstName + ' ' + data.lastName;
            self.tchTrackFormData.studyAdviserName = data.studyAdviserName;
            self.$helper.copyProperties(data, self.formData);
            self.certificateTeflUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateTefl);
            self.certificateTesolUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateTesol);
            self.certificateTeflOutUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateTeflOut);
            self.certificateTesolOutUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateTesolOut);
            self.certificateTeylUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateTeyl);
            self.certificateEnglishUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateEnglish);
            self.certificateEnglishOutUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.certificateEnglishOut);
            self.introduceDocUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.introduceDoc);
            self.introduceVideoUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.introduceVideo);
            self.nationalityImageUrl = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.tchForm.nationalityImage);
            self.selfIntroductionVideo = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.selfIntroductionVideo);
            self.resume = __WEBPACK_IMPORTED_MODULE_9__tools_commonUtils_js___default.a.getTotalUrl(data.resume);
            self.teachVideoList = data.teachVideoList;
            if (data.features) {
              self.formData.features = data.features;
              self.featuresArray = data.features.split(',');
            }
            if (data.suitableLevel) {
              self.formData.suitableLevel = data.suitableLevel;
              self.levelArray = data.suitableLevel.split(',');
            }
            if (data.images) {
              self.images = data.images.split(',');
            }
            self.fillPolishLessonVideoList(data.polishLessonVideos);

            if (data.workTimes && data.workTimes.length > 0) {
              self.workTimeSelections = {};
              data.workTimes.forEach(function (wt) {
                var convertTime = function convertTime(timeStr) {
                  var _timeStr$split = timeStr.split(':'),
                      _timeStr$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_timeStr$split, 2),
                      hour = _timeStr$split2[0],
                      minute = _timeStr$split2[1];

                  var hourNum = parseInt(hour);
                  var period = 'am';

                  if (hourNum >= 12) {
                    period = 'pm';
                    if (hourNum > 12) {
                      hourNum -= 12;
                    }
                  } else if (hourNum === 0) {
                    hourNum = 12;
                  }

                  return hourNum + ':' + minute + period;
                };

                var startTime = convertTime(wt.startTime);
                var endTime = convertTime(wt.endTime);
                var key = wt.week + '-' + startTime + '-' + endTime;
                self.$set(self.workTimeSelections, key, wt.status);
              });
            }

            if (data.avatar) {
              if (data.avatar.indexOf('http://') !== -1 || data.avatar.indexOf('https://') !== -1) {
                self.totalImageUrl = data.avatar;
              } else {
                if (data.avatar.substr(0, 1) === '/') {
                  self.totalImageUrl = 'https://medias.kouyujie.cn' + data.avatar;
                } else {
                  self.totalImageUrl = 'https://medias.kouyujie.cn/' + data.avatar;
                }
              }
              self.text = '编辑头像';
            } else {
              self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
              self.text = '上传头像';
            }
            self.seeTchTrack = data.seeTchTrack;
          }
        });
      }
    },
    beforeUploadIntroduceVideoUrl: function beforeUploadIntroduceVideoUrl(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!');
        this.introduceVideoUrlList = [];
        return false;
      } else {
        this.beforeUp();
        return true;
      }
    },
    beforeUploadIntroductionVideo: function beforeUploadIntroductionVideo(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!');
        this.selfIntroductionVideoList = [];
        return false;
      } else {
        this.beforeUp();
        return true;
      }
    },
    beforeUploadTeachVideo: function beforeUploadTeachVideo(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!');
        this.teachVideoList = [];
        return false;
      } else {
        this.beforeUp();
        return true;
      }
    },
    beforeUploadTeachImages: function beforeUploadTeachImages(file) {
      if (file.size > 31457280) {
        this.$Message.error('文件大小不能超过30M!');
        this.teachImagesList = [];
        return false;
      } else {
        this.beforeUp();
        return true;
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.beforeUp();
      return true;
    },
    beforeUp: function beforeUp() {
      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
    },
    handleProgress: function handleProgress(event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99;
      }
    },
    onLoading2: function onLoading2(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    saveTrackRecord: function saveTrackRecord() {
      var self = this;
      this.searchLoading = true;
      self.$refs.tchTrackRecordForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.searchLoading = true;
        self.$http.post('/tchTrack/addTrackRecord', self.tchTrackFormData).then(function (res) {
          if (res && res.data > 0) {
            self.resetTrackRecord();
            self.$Message.success('提交成功!');
          }
          self.searchLoading = false;
          self.search();
        }).catch(function (e) {
          self.searchLoading = false;
          self.search();
        });
      });
    },
    resetTrackRecord: function resetTrackRecord() {
      this.tchTrackFormData.trackType = null;
      this.tchTrackFormData.content = '';
      this.tchTrackFormData.picUrl = '';
      this.defaultPicsList = [];
    },
    handleTrackFileChange: function handleTrackFileChange(file, fileList) {
      this.defaultPicsList = fileList;
      var names = fileList.filter(function (f) {
        return f.serverName;
      }).map(function (f) {
        return f.serverName;
      }).join(',');
      this.tchTrackFormData.picUrl = names;
    },
    trackFileSuccess: function trackFileSuccess(res, file, fileList) {
      file.serverName = res.data.name;
      var names = fileList.filter(function (f) {
        return f.serverName;
      }).map(function (f) {
        return f.serverName;
      }).join(',');
      this.tchTrackFormData.picUrl = names;
    },
    beforeUploadTrackFile: function beforeUploadTrackFile(file) {
      var isLt30M = file.size / 1024 / 1024 < 30;

      if (!isLt30M) {
        this.$Message.error('文件大小不能超过30MB!');
        return false;
      }

      this.headers.token = this.$store.get('token');
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account');
        this.headers.password = this.$store.get('password');
      }
      this.$Message.loading('服务器正在处理中...', 0);
      return true;
    },
    handleContentPaste: function handleContentPaste(event) {
      var _this9 = this;

      var items = event.clipboardData && event.clipboardData.items;
      if (!items) return;

      for (var i = 0; i < items.length; i++) {
        if (items[i].type.startsWith('image/')) {
          event.preventDefault();
          var blob = items[i].getAsFile();
          var formData = new FormData();
          formData.append('file', blob, 'paste-' + Date.now() + '.png');
          formData.append('bucket', 'hellokid');

          this.$Message.loading('图片上传中...', 0);
          this.$http.post('/upload/fileUpload', formData, {
            transformRequest: [function (data) {
              return data;
            }],
            headers: {
              'token': this.$store.get('token'),
              'account': this.$store.get('account') || '',
              'password': this.$store.get('password') || ''
            }
          }).then(function (res) {
            _this9.$Message.destroy();
            var data = res.data;
            if (data && data.name) {
              var fileInfo = {
                name: data.name,
                url: data.url,
                status: 'success',
                serverName: data.name,
                percentage: 100,
                uid: Date.now()
              };
              _this9.defaultPicsList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this9.defaultPicsList), [fileInfo]);
              var names = _this9.defaultPicsList.filter(function (f) {
                return f.serverName;
              }).map(function (f) {
                return f.serverName;
              }).join(',');
              _this9.tchTrackFormData.picUrl = names;
              _this9.$Message.success('图片上传成功');
            }
          }).catch(function () {
            _this9.$Message.destroy();
            _this9.$Message.error('图片上传失败');
          });
          break;
        }
      }
    },
    search: function search() {
      this.queryParam.tchId = this.tchId;
      this.reload = new Date().getTime();
    },
    handleModalScroll: function handleModalScroll() {
      console.log('Modal scrolled');
    },
    parseStatDate: function parseStatDate(value) {
      if (!value) {
        return new Date();
      }
      if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }
      var text = String(value).replace(/-/g, '/');
      if (/^\d{4}$/.test(text)) {
        text = text + '/01/01';
      }
      if (text.length === 7) {
        text = text + '/01';
      }
      var d = new Date(text);
      if (isNaN(d.getTime())) {
        return new Date();
      }
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },
    calcStatRange: function calcStatRange() {
      var d = this.parseStatDate(this.statDate);
      this.statDate = d;
      if (this.statPeriodType === 'day') {
        var day = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(d, 'YYYY-MM-DD');
        this.statStartDate = day;
        this.statEndDate = day;
        return;
      }
      if (this.statPeriodType === 'week') {
        var weekDay = d.getDay();
        var mondayOffset = weekDay === 0 ? -6 : 1 - weekDay;
        var monday = new Date(d.getFullYear(), d.getMonth(), d.getDate() + mondayOffset);
        var sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
        this.statStartDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(monday, 'YYYY-MM-DD');
        this.statEndDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(sunday, 'YYYY-MM-DD');
        return;
      }
      if (this.statPeriodType === 'year') {
        var _start = new Date(d.getFullYear(), 0, 1);
        var _end = new Date(d.getFullYear(), 11, 31);
        this.statStartDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(_start, 'YYYY-MM-DD');
        this.statEndDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(_end, 'YYYY-MM-DD');
        return;
      }
      var start = new Date(d.getFullYear(), d.getMonth(), 1);
      var end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      this.statStartDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(start, 'YYYY-MM-DD');
      this.statEndDate = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(end, 'YYYY-MM-DD');
    },
    resolveStatTchId: function resolveStatTchId() {
      return this.tchId || this.tchTrackFormData && this.tchTrackFormData.tchId;
    },
    applyPersonalStat: function applyPersonalStat(data) {
      this.personalStat.leaveRate = data.leaveRate || '—';
      this.personalStat.leaveNumerator = data.leaveNumerator != null ? data.leaveNumerator : data.leaveTeacherCount;
      this.personalStat.leaveDenominator = data.leaveDenominator != null ? data.leaveDenominator : data.taughtTeacherCount;
      this.personalStat.tempLeaveRate = data.tempLeaveRate || '—';
      this.personalStat.tempLeaveCount = data.tempLeaveCount != null ? data.tempLeaveCount : null;
      this.personalStat.tempLeaveBaseCount = data.tempLeaveBaseCount != null ? data.tempLeaveBaseCount : null;
      this.personalStat.fullAttendanceRate = data.fullAttendanceRate || '—';
      this.personalStat.fullAttendanceCount = data.fullAttendanceCount != null ? data.fullAttendanceCount : data.fullAttendanceNumerator;
      this.personalStat.fullAttendanceTotalCount = data.fullAttendanceTotalCount != null ? data.fullAttendanceTotalCount : data.fullAttendanceDenominator;
      this.personalStat.lateRate = data.lateRate || '—';
      this.personalStat.lateCount = data.lateCount != null ? data.lateCount : null;
      this.personalStat.lateBaseCount = data.lateBaseCount != null ? data.lateBaseCount : null;
      this.personalStat.earlyRate = data.earlyRate || '—';
      this.personalStat.earlyCount = data.earlyCount != null ? data.earlyCount : null;
      this.personalStat.earlyBaseCount = data.earlyBaseCount != null ? data.earlyBaseCount : null;
      this.personalStat.returnLessonHours = data.returnLessonHours != null ? data.returnLessonHours : null;
      this.personalStat.refundStudentCount = data.refundStudentCount != null ? data.refundStudentCount : null;
      this.personalStat.demoAttendDealRate = data.demoAttendDealRate || '—';
      this.personalStat.demoAttendDealCount = data.demoAttendDealCount != null ? data.demoAttendDealCount : null;
      this.personalStat.demoAttendCount = data.demoAttendCount != null ? data.demoAttendCount : null;
      this.personalStat.attendLessonRate = data.attendLessonRate || '—';
      this.personalStat.attendLessonCount = data.attendLessonCount != null ? data.attendLessonCount : null;
      this.personalStat.attendLessonBaseCount = data.attendLessonBaseCount != null ? data.attendLessonBaseCount : null;
      this.personalStat.asOfTime = data.asOfTime || '';
    },
    formatStatFirstLastName: function formatStatFirstLastName(row) {
      var item = row || {};
      var first = (item.firstName || '').trim();
      var last = (item.lastName || '').trim();
      return (first + ' ' + last).trim();
    },
    statTeacherLabel: function statTeacherLabel(row) {
      if (!row) {
        return '';
      }
      var id = row.tchId == null ? '' : String(row.tchId);
      var first = (row.firstName || '').trim();
      var last = (row.lastName || '').trim();
      var name = (first + ' ' + last).trim() || (row.tchName || '').trim();
      return name ? id + '-' + name : id;
    },
    openStatDetail: function openStatDetail(item) {
      if (!item || !item.metric) {
        return;
      }
      this.calcStatRange();
      if (!this.statStartDate || !this.statEndDate) {
        this.$Message.error('请先选择统计时间');
        return;
      }
      if (!this.resolveStatTchId()) {
        this.$Message.error('老师ID不能为空');
        return;
      }
      this.statDetailMetric = item.metric;
      this.statDetailSplit = !!item.split;
      this.statDetailLeftTitle = item.leftTitle || '分子';
      this.statDetailLeftValue = item.leftValue == null ? '—' : String(item.leftValue);
      this.statDetailRightTitle = item.rightTitle || '分母';
      this.statDetailRightValue = item.rightValue == null ? '—' : String(item.rightValue);
      this.statDetailHasDiff = item.metric === 'fullAttendanceRate';
      this.statDetailDiffTitle = '未全勤课节';
      this.statDetailDiffValue = this.statFullAttendDiffText;
      this.statDetailField = item.split ? '' : 'numerator';
      this.statDetailFieldTitle = item.split ? '' : item.title;
      this.statDetailPageIndex = 1;
      this.statDetailTableData = [];
      this.statDetailTotal = 0;
      this.showStatDetailModal = true;
      if (!item.split) {
        this.loadStatDetail();
      }
    },
    openStatDetailField: function openStatDetailField(field) {
      this.statDetailField = field;
      if (field === 'numerator') {
        this.statDetailFieldTitle = this.statDetailLeftTitle;
      } else if (field === 'denominator') {
        this.statDetailFieldTitle = this.statDetailRightTitle;
      } else if (field === 'nonFullLessons') {
        this.statDetailFieldTitle = this.statDetailDiffTitle;
      } else {
        this.statDetailFieldTitle = '';
      }
      this.statDetailPageIndex = 1;
      this.statDetailTableData = [];
      this.statDetailTotal = 0;
      this.loadStatDetail();
    },
    backStatDetailCards: function backStatDetailCards() {
      this.statDetailField = '';
      this.statDetailFieldTitle = '';
      this.statDetailTableData = [];
      this.statDetailTotal = 0;
    },
    onStatDetailPageChange: function onStatDetailPageChange(page) {
      this.statDetailPageIndex = page;
      this.loadStatDetail();
    },
    onStatDetailPageSizeChange: function onStatDetailPageSizeChange(size) {
      this.statDetailPageSize = size;
      this.statDetailPageIndex = 1;
      this.loadStatDetail();
    },
    loadStatDetail: function loadStatDetail() {
      var _this10 = this;

      if (!this.statDetailMetric || !this.statDetailField || !this.statStartDate || !this.statEndDate) {
        this.statDetailTableData = [];
        this.statDetailTotal = 0;
        return;
      }
      var tchId = this.resolveStatTchId();
      if (!tchId) {
        return;
      }
      this.statDetailLoading = true;
      this.$http.post('/tch/hr-metrics-trend-detail', {
        metric: this.statDetailMetric,
        field: this.statDetailField,
        startDate: this.statStartDate,
        endDate: this.statEndDate,
        tchId: tchId,
        pageIndex: this.statDetailPageIndex,
        pageSize: this.statDetailPageSize
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this10.statDetailTableData = res.data.data || [];
          _this10.loadMonthRankScores();
          _this10.statDetailTotal = res.data.totalCount || 0;
        } else {
          _this10.statDetailTableData = [];
          _this10.statDetailTotal = 0;
          _this10.$Message.error(res && res.msg || '明细加载失败');
        }
      }).catch(function () {
        _this10.statDetailTableData = [];
        _this10.statDetailTotal = 0;
        _this10.$Message.error('明细加载失败');
      }).finally(function () {
        _this10.statDetailLoading = false;
      });
    },
    exportStatDetail: function exportStatDetail() {
      var _this11 = this;

      if (this.statDetailSplit && !this.statDetailField) {
        this.$Message.warning(this.statDetailHasDiff ? '请先点开分子、分母或未全勤课节' : '请先点开分子或分母');
        return;
      }
      this.calcStatRange();
      var tchId = this.resolveStatTchId();
      if (!this.statDetailMetric || !this.statDetailField || !this.statStartDate || !this.statEndDate || !tchId) {
        this.$Message.error('请先选择统计时间和老师');
        return;
      }
      var names = {
        leaveRate: { numerator: '全部请假或老师缺席明细', denominator: '有课课节明细' },
        tempLeaveRate: { numerator: '临时请假失联取消课或缺席明细', denominator: '有课课节明细' },
        fullAttendanceRate: { numerator: '全勤课节明细', denominator: '有课课节明细', nonFullLessons: '未全勤课节明细' },
        lateRate: { numerator: '迟到课节明细', denominator: '正常上课课节明细' },
        earlyRate: { numerator: '早退课节明细', denominator: '正常上课课节明细' },
        attendLessonRate: { numerator: '已上课课节明细', denominator: '买断临时课节明细' },
        returnLessonHours: { numerator: '返课记录' },
        refundStudentCount: { numerator: '退费学生' },
        demoAttendDealRate: { numerator: '成交学生明细', denominator: '出席学生明细' }
      };
      var file = this.fileNameWithRange((names[this.statDetailMetric] || {})[this.statDetailField] || '数据统计明细', this.statStartDate, this.statEndDate);
      this.statDetailExportLoading = true;
      this.downloadStatExcel('/tch/hr-metrics-trend-detail-export', {
        metric: this.statDetailMetric,
        field: this.statDetailField,
        startDate: this.statStartDate,
        endDate: this.statEndDate,
        tchId: tchId
      }, file).finally(function () {
        _this11.statDetailExportLoading = false;
      });
    },
    downloadStatExcel: function downloadStatExcel(url, data, filename) {
      var _this12 = this;

      return this.$http({
        method: 'post',
        url: url,
        data: data,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response && response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else {
          _this12.$Message.error('导出失败');
        }
      }).catch(function () {
        _this12.$Message.error('导出失败');
      });
    },
    fileNameWithRange: function fileNameWithRange(name, start, end) {
      var a = start || '';
      var b = end || '';
      var time = a;
      if (b && b !== a) {
        time = a + '-' + b;
      }
      return name + time + '.xlsx';
    },
    escapeExcelCell: function escapeExcelCell(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    exportPersonalStat: function exportPersonalStat() {
      var _this13 = this;

      this.calcStatRange();
      if (!this.statStartDate) {
        this.$Message.error('请先选择统计时间');
        return;
      }
      this.statExportLoading = true;
      try {
        var tchId = this.resolveStatTchId() || '';
        var first = this.formData && this.formData.firstName ? String(this.formData.firstName).trim() : '';
        var last = this.formData && this.formData.lastName ? String(this.formData.lastName).trim() : '';
        var tchName = (first + ' ' + last).trim();
        if (!tchName && this.tchTrackFormData && this.tchTrackFormData.tchName) {
          tchName = String(this.tchTrackFormData.tchName).trim();
        }
        var html = '<html><head><meta charset="UTF-8"></head><body><table>';
        html += '<tr><th>外教ID</th><th>外教名字</th><th>指标</th><th>数值</th><th>说明</th></tr>';
        this.statCards.forEach(function (item) {
          html += '<tr><td>' + _this13.escapeExcelCell(tchId) + '</td><td>' + _this13.escapeExcelCell(tchName) + '</td><td>' + _this13.escapeExcelCell(item.title) + '</td><td>' + _this13.escapeExcelCell(item.value) + '</td><td>' + _this13.escapeExcelCell(item.sub) + '</td></tr>';
        });
        html += '</table></body></html>';
        var blob = new Blob(['\uFEFF' + html], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = this.fileNameWithRange('数据统计', this.statStartDate, this.statEndDate);
        link.click();
        window.URL.revokeObjectURL(link.href);
      } finally {
        this.statExportLoading = false;
      }
    },
    loadPersonalStat: function loadPersonalStat() {
      var _this14 = this;

      var tchId = this.resolveStatTchId();
      if (!tchId) {
        return;
      }
      this.calcStatRange();
      this.statLoading = true;
      this.$http.post('/tch/hr-metrics-personal', {
        tchId: tchId,
        periodType: this.statPeriodType,
        startDate: this.statStartDate,
        endDate: this.statEndDate
      }).then(function (res) {
        if (res && res.status === 'ok') {
          _this14.applyPersonalStat(res.data || {});
        } else {
          _this14.$Message.error(res && res.msg || '加载失败');
        }
        _this14.statLoading = false;
      }).catch(function () {
        _this14.$Message.error('加载失败');
        _this14.statLoading = false;
      });
    },
    onStatPeriodChange: function onStatPeriodChange() {
      this.calcStatRange();
      this.loadPersonalStat();
    },
    onStatDateChange: function onStatDateChange(value) {
      this.statDate = this.parseStatDate(value);
      this.calcStatRange();
      this.loadPersonalStat();
    },
    initColorBlockRange: function initColorBlockRange() {
      var week = new Date().getDay();
      var left = week;
      var right = 49 - week;
      if (week === 0) {
        left = 7;
      }
      var now = Date.now();
      var start = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(new Date(now - (left + 6) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD');
      var end = __WEBPACK_IMPORTED_MODULE_10__tools_date_format_js___default()(new Date(now + right * 24 * 60 * 60 * 1000), 'YYYY-MM-DD');
      this.dateRange = [start, end];
    },
    onColorDateChange: function onColorDateChange(value) {
      if (!value || value.length < 2 || !value[0] || !value[1]) {
        return;
      }
      var start = __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(value[0], 'YYYY-MM-DD');
      var end = __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(value[1], 'YYYY-MM-DD');
      var currentStart = this.dateRange[0] ? __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(this.dateRange[0], 'YYYY-MM-DD') : '';
      var currentEnd = this.dateRange[1] ? __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(this.dateRange[1], 'YYYY-MM-DD') : '';
      if (start !== currentStart || end !== currentEnd) {
        this.dateRange = [start, end];
      }
      this.loadColorBlock();
    },
    loadColorBlock: function loadColorBlock() {
      var self = this;
      if (!this.dateRange || this.dateRange.length < 2 || !this.dateRange[0] || !this.dateRange[1]) {
        return;
      }
      var tchId = this.tchTrackFormData.tchId;
      var startTime = __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(this.dateRange[0]);
      var endTime = __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.format(this.dateRange[1]);
      if (!tchId || !startTime || !endTime) {
        return;
      }
      var key = tchId + '|' + startTime + '|' + endTime;
      if (key === this.colorBlockReqKey) {
        return;
      }
      this.colorBlockReqKey = key;
      var seq = ++this.colorBlockSeq;
      this.queryParams.tchId = tchId;
      this.queryParams.startTime = startTime;
      this.queryParams.endTime = endTime;
      self.$http.get('/teacherSchedule/queryTeacherDateSchedule', { params: this.queryParams }).then(function (res) {
        if (seq !== self.colorBlockSeq) {
          return;
        }
        if (res.data) {
          self.dataList = res.data.map(function (item) {
            var row = item.teacherDateDetailScheduleDtoList;
            var dateStr = item.dateStr;
            var week = __WEBPACK_IMPORTED_MODULE_11__tools_date_dates_js___default.a.toWeek(item.week);
            row.week = item.week;
            row.title = week + '(' + dateStr + ')';
            row.dateStr = dateStr;
            return row;
          });
        }
      }).catch(function () {
        if (self.colorBlockReqKey === key) {
          self.colorBlockReqKey = '';
        }
      });
    },
    onTabClick: function onTabClick(name) {
      if (name === '老师跟踪记录') {
        this.queryParam.tchId = this.tchId;
        this.search();
        return;
      }
      if (name === '数据统计') {
        this.loadPersonalStat();
        return;
      }
      if (name === '推荐官') {
        this.loadReferrerTab();
        return;
      }
      if (name === '开课Checklist') {
        this.loadOnboardingDetail();
        return;
      }
      if (name === '色块表') {
        this.initColorBlockRange();
        this.colorBlockReqKey = '';
        this.loadColorBlock();
        return;
      }
      if (name === '在绑学生' && this.seeStuList) {
        this.reloadStuList = new Date().getTime();
      }
    },
    loadReferrerInfo: function loadReferrerInfo() {
      var self = this;
      if (!self.tchId) {
        self.referrerTabVisible = false;
        self.referrerDetail = {};
        return;
      }
      self.$http.get('/referrer/info/getByTchId', { params: { tchId: self.tchId } }).then(function (res) {
        var info = res && res.data ? res.data : {};
        self.referrerTabVisible = !!info.referrerId;
        self.referrerDetail = self.referrerTabVisible ? info : {};
      }).catch(function () {
        self.referrerTabVisible = false;
        self.referrerDetail = {};
      });
    },
    loadReferrerTab: function loadReferrerTab() {
      var self = this;
      if (!self.referrerDetail || !self.referrerDetail.referrerId) {
        return;
      }
      var referrerId = self.referrerDetail.referrerId;
      self.referrerMonthlyLoading = true;
      self.$http.get('/referrer/info/detail', { params: { referrerId: referrerId } }).then(function (res) {
        if (res && res.data) {
          self.referrerDetail = res.data;
        }
      });
      self.$http.get('/referrer/info/monthlyStats', { params: { referrerId: referrerId } }).then(function (res) {
        self.referrerMonthlyStats = res && res.data ? res.data : [];
      }).finally(function () {
        self.referrerMonthlyLoading = false;
      });
    },
    loadOnboardingDetail: function loadOnboardingDetail() {
      var self = this;
      if (!self.tchId) {
        return;
      }
      self.onboardingLoading = true;
      self.onboardingRows = [];
      self.onboardingDoneCount = 0;
      self.onboardingTotalCount = 0;
      self.onboardingVersionId = null;
      self.$http.get('/tchOnboarding/detail', { params: { tchId: self.tchId } }).then(function (res) {
        if (!res || res.status !== 'ok' || !res.data) {
          return;
        }
        var data = res.data;
        var stages = data.stages || [];
        self.onboardingRows = self.buildOnboardingRows(stages);
        self.onboardingVersionId = data.versionId || null;
        var done = 0;
        var total = 0;
        stages.forEach(function (stage) {
          done += stage.doneCount || 0;
          total += stage.totalCount || 0;
        });
        self.onboardingDoneCount = done;
        self.onboardingTotalCount = total;
      }).catch(function () {
        self.onboardingRows = [];
        self.onboardingDoneCount = 0;
        self.onboardingTotalCount = 0;
        self.onboardingVersionId = null;
      }).then(function () {
        self.onboardingLoading = false;
      });
    },
    buildOnboardingRows: function buildOnboardingRows(stages) {
      var rows = [];
      var list = stages || [];
      list.forEach(function (stage) {
        var items = stage.items || [];
        items.forEach(function (item) {
          rows.push({
            stageName: stage.name,
            title: item.title,
            done: item.done,
            textValue: item.textValue,
            photoUrls: item.photoUrls
          });
        });
      });
      return rows;
    },
    parseOnboardingPhotoUrls: function parseOnboardingPhotoUrls(photoUrls) {
      if (!photoUrls) {
        return [];
      }
      if (Array.isArray(photoUrls)) {
        return photoUrls.map(function (url) {
          return (url || '').trim();
        }).filter(function (url) {
          return !!url;
        });
      }
      return String(photoUrls).split(',').map(function (url) {
        return url.trim();
      }).filter(function (url) {
        return !!url;
      });
    },
    renderOnboardingPhotos: function renderOnboardingPhotos(h, photoUrls) {
      var urls = this.parseOnboardingPhotoUrls(photoUrls);
      if (!urls.length) {
        return h('span', '-');
      }
      var images = urls.map(function (url) {
        return h('img', {
          attrs: { src: url },
          style: {
            width: '48px',
            height: '48px',
            objectFit: 'cover',
            marginRight: '4px',
            borderRadius: '3px',
            cursor: 'pointer'
          },
          on: { click: function click() {
              return window.open(url, '_blank');
            } }
        });
      });
      return h('div', images);
    },
    crtBeginTimeDateChange: function crtBeginTimeDateChange(value) {
      this.formData.crtBeginTime = value && new Date(value);
    },
    crtEndTimeDateChange: function crtEndTimeDateChange(value) {
      this.formData.crtEndTime = value && new Date(value);
    }
  },
  watch: {
    value: function value(val) {
      var _this15 = this;

      this.visible = val;
      if (val) {
        this.isAddTch = !(this.tchId > 0);
        this.saveType = this.addType;
        if ((this.saveType === 'agency' || this.addType === 'agency') && this.isAddTch) {
          this.$nextTick(function () {
            _this15.formData.category = 6;
          });
          this.formData.category = 6;
        }
        this.loadDetailTabRules();
      }
      if (val && this.tchId) {
        this.loadTchInfo();
        this.loadReferrerInfo();
      }
    },
    visible: function visible(val) {
      if (val === false) {
        this.$helper.reset(this.formData);
        this.$refs['tchForm'].resetFields();
        this.formData.tchForm = {};
        this.featuresArray = [];
        this.levelArray = [];
        this.isEmail = false;
        this.certificateTesolUrl = '';
        this.certificateTeflUrl = '';
        this.certificateTeylUrl = '';
        this.certificateEnglishUrl = '';
        this.certificateEnglishOutUrl = '';
        this.introduceDocUrl = '';
        this.introduceVideoUrl = '';
        this.nationalityImageUrl = '';
        this.certificateTesolOutUrl = '';
        this.certificateTeflOutUrl = '';
        this.selfIntroductionVideo = '';
        this.resume = '';
        this.resumeList = [];
        this.certificateTeflOutUrlList = [];
        this.certificateTesolOutUrlList = [];
        this.certificateTesolUrlList = [];
        this.certificateTeflUrlList = [];
        this.certificateTeylUrlList = [];
        this.certificateEnglishUrlList = [];
        this.certificateEnglishOutUrlList = [];
        this.introduceDocUrlList = [];
        this.introduceVideoUrlList = [];
        this.nationalityImageUrlList = [];
        this.selfIntroductionVideoList = [];
        this.images = [];
        this.polishLessonVideoList = [''];
        this.workTimeSelections = {};
        this.resetTrackRecord();
        this.queryParam = { trackType: null, tchId: '' };
        this.tabName = '基本信息';
        this.referrerTabVisible = false;
        this.referrerDetail = {};
        this.referrerMonthlyStats = [];
        this.imageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
        this.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
        this.$emit('on-close');
      }
    },
    tchId: function tchId(val) {
      if (val && val > 0) {
        this.isAddTch = false;
        if (this.visible) {
          this.loadTchInfo();
          this.loadReferrerInfo();
          if (this.tabName === '老师跟踪记录') {
            this.search();
          }
        }
      }
    },
    showStuList: function showStuList(val) {
      this.seeStuList = val;
    },
    addType: function addType(val) {
      this.saveType = val;
      if (val === 'agency' && !this.tchId) {
        this.formData.category = 6;
      }
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditDingDingModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAdd: false,
      userList: {},
      formData: {
        tchId: null,
        dingtalkDepartmentId: 35668088,
        dingtalkUserid: 0,
        isReceiveMsg: ''
      },
      dingRules: {
        dingtalkUserid: [{ type: 'string', required: true, message: '请选择钉钉用户', trigger: 'blur' }],
        isReceiveMsg: [{ type: 'number', required: true, message: '请选择是否接收钉钉消息', trigger: 'blur' }]
      }
    };
  },

  created: function created() {
    this.loadDingtalkUser(135668088);
  },
  methods: {
    saveDing: function saveDing() {
      var self = this;
      self.loadingAdd = true;
      self.$refs.editDingForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingAdd = false;
          return;
        }
        if (self.formData.tchId) {
          self.$http.post('/tch/formal/saveOrUpdate', self.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('保存成功!');
              self.loadingAdd = false;
              self.visible = false;
              self.successCallback();
            }
          }).catch(function (e) {
            self.loadingAdd = false;
            self.$Message.error(e.msg);
          });
        }
      });
    },
    loadDingtalkUser: function loadDingtalkUser(val) {
      var self = this;
      if (val) {
        self.$http.get('/dingTalk/userList?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.userList = res.data;
        });
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.userList = [];
        this.formData = {};
        this.$emit('on-close', val);
      } else {}
    },
    tchId: function tchId(val) {
      if (val) {
        var self = this;
        self.loadDingtalkUser(135668088);

        self.$http.get('/tch/formal/queryByTchId?tchId=' + val).then(function (res) {
          if (res.data) {
            self.formData.tchId = res.data.tchId;
            self.formData.dingtalkDepartmentId = 135668087;
            self.formData.dingtalkUserid = res.data.dingtalkUserid;
            if (!res.data.dingtalkUserid && res.data.isReceiveMsg === 0) {
              self.formData.isReceiveMsg = 1;
            } else {
              self.formData.isReceiveMsg = parseInt(res.data.isReceiveMsg);
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recruitConst__ = __webpack_require__(59);




var SLOT_START = 14 * 60;
var SLOT_END = 21 * 60 + 30;
var SLOT_STEP = 30;

function pad2(n) {
  return n < 10 ? '0' + n : String(n);
}

function hm(minutes) {
  return pad2(Math.floor(minutes / 60)) + ':' + pad2(minutes % 60);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecruitScheduleBoard',
  data: function data() {
    var slots = [];
    for (var m = SLOT_START; m + SLOT_STEP <= SLOT_END; m += SLOT_STEP) {
      slots.push({ startMin: m, label: hm(m) + '-' + hm(m + SLOT_STEP) });
    }
    return {
      dayLabels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      slots: slots,
      weekStart: this.$moment().startOf('isoWeek').format('YYYY-MM-DD'),
      todayYmd: this.$moment().format('YYYY-MM-DD'),
      scheduled: [],
      unscheduled: [],
      loading: false,
      addVisible: false,
      addSlot: null,
      pickedTchId: null,
      saving: false
    };
  },

  computed: {
    weekDays: function weekDays() {
      var days = [];
      for (var i = 0; i < 7; i++) {
        var d = this.$moment(this.weekStart, 'YYYY-MM-DD').add(i, 'days');
        days.push({ ymd: d.format('YYYY-MM-DD'), md: d.format('M/D') });
      }
      return days;
    },
    rangeLabel: function rangeLabel() {
      return this.weekDays[0].ymd + ' - ' + this.weekDays[6].ymd;
    },
    slotMap: function slotMap() {
      var _this = this;

      var map = {};
      var dayIndex = {};
      this.weekDays.forEach(function (d, i) {
        dayIndex[d.ymd] = i;
      });
      this.scheduled.forEach(function (t) {
        var pos = _this.slotPos(t, dayIndex);
        if (!pos || pos.outside) {
          return;
        }
        var key = pos.dayIdx + '-' + pos.startMin;
        if (!map[key]) {
          map[key] = [];
        }
        map[key].push(t);
      });
      return map;
    },
    outsideItems: function outsideItems() {
      var _this2 = this;

      var dayIndex = {};
      this.weekDays.forEach(function (d, i) {
        dayIndex[d.ymd] = i;
      });
      return this.scheduled.filter(function (t) {
        var pos = _this2.slotPos(t, dayIndex);
        return pos && pos.outside;
      });
    },
    stats: function stats() {
      var total = this.scheduled.length;
      var unbooked = this.scheduled.filter(this.isUnbooked).length;
      return { total: total, unbooked: unbooked, confirmed: total - unbooked };
    },
    candidates: function candidates() {
      var seen = {};
      var list = [];
      this.unscheduled.concat(this.scheduled).forEach(function (t) {
        if (t && !seen[t.tchId]) {
          seen[t.tchId] = true;
          list.push(t);
        }
      });
      return list;
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    nameOf: function nameOf(t) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__recruitConst__["a" /* tchName */])(t);
    },
    isUnbooked: function isUnbooked(t) {
      var st = t.interviewStatus || 'pending';
      return st === 'pending' || st === 'failed';
    },
    slotPos: function slotPos(t, dayIndex) {
      if (!t || !t.interviewTime) {
        return null;
      }
      var m = this.$moment(t.interviewTime, 'YYYY-MM-DD HH:mm:ss');
      if (!m.isValid()) {
        return null;
      }
      var idx = dayIndex[m.format('YYYY-MM-DD')];
      if (idx === undefined) {
        return null;
      }
      var minutes = m.hours() * 60 + m.minutes();
      var aligned = Math.floor(minutes / SLOT_STEP) * SLOT_STEP;
      return { dayIdx: idx, startMin: aligned, outside: aligned < SLOT_START || aligned >= SLOT_END };
    },
    slotItems: function slotItems(dayIdx, startMin) {
      return this.slotMap[dayIdx + '-' + startMin] || [];
    },
    moveWeek: function moveWeek(days) {
      this.weekStart = this.$moment(this.weekStart, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD');
      this.load();
    },
    goThisWeek: function goThisWeek() {
      this.weekStart = this.$moment().startOf('isoWeek').format('YYYY-MM-DD');
      this.load();
    },
    load: function load() {
      var _this3 = this;

      this.loading = true;
      this.$http.post('/tchRecruit/interview/schedule-board', { weekStart: this.weekStart }, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this3.scheduled = data.scheduled || [];
          _this3.unscheduled = data.unscheduled || [];
        } else {
          _this3.scheduled = [];
          _this3.unscheduled = [];
          _this3.$Message.error(res && res.msg || '时间表加载失败');
        }
      }).catch(function () {}).finally(function () {
        _this3.loading = false;
      });
    },
    openAdd: function openAdd(day, startMin) {
      this.addSlot = {
        ymd: day.ymd,
        startMin: startMin,
        label: hm(startMin) + '–' + hm(startMin + SLOT_STEP)
      };
      this.pickedTchId = null;
      this.addVisible = true;
    },
    confirmAdd: function confirmAdd() {
      var _this4 = this;

      if (!this.pickedTchId) {
        this.$Message.error('请选择老师');
        return;
      }
      var time = this.addSlot.ymd + ' ' + hm(this.addSlot.startMin) + ':00';
      this.saving = true;
      this.$http.post('/tchRecruit/interview/schedule', { tchId: this.pickedTchId, interviewTime: time }, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this4.$Message.success('已安排面试');
          _this4.addVisible = false;
          _this4.load();
          _this4.$emit('on-change');
        } else {
          _this4.$Message.error(res && res.msg || '安排失败');
        }
      }).catch(function () {}).finally(function () {
        _this4.saving = false;
      });
    },
    clear: function clear(t) {
      var _this5 = this;

      this.$Modal.confirm({
        title: '清除面试时段',
        content: '确定清除 ' + t.tchId + ' ' + this.nameOf(t) + ' 的面试时间？面试状态将回到待安排。',
        onOk: function onOk() {
          _this5.$http.post('/tchRecruit/interview/clear-interview', { tchId: t.tchId }, { silent: true }).then(function (res) {
            if (res && res.status === 'ok') {
              _this5.$Message.success('已清除面试时段');
              _this5.load();
              _this5.$emit('on-change');
            } else {
              _this5.$Message.error(res && res.msg || '清除失败');
            }
          }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecruitScheduleBoard_vue__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecruitScheduleBoard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RecruitScheduleBoard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_RecruitScheduleModal_vue__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_RecruitScheduleModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modal_RecruitScheduleModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_RecruitNotesModal_vue__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_RecruitNotesModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modal_RecruitNotesModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_RecruitReviewModal_vue__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_RecruitReviewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modal_RecruitReviewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_RecruitReasonModal_vue__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_RecruitReasonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modal_RecruitReasonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TchApplyFormModal_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_TchApplyFormModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modal_TchApplyFormModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__recruitConst__ = __webpack_require__(59);















function rangeToHalfOpen(range) {
  if (!range || !range[0] || !range[1]) {
    return null;
  }
  var start = String(range[0]).trim();
  var end = String(range[1]).trim();
  if (!start || !end) {
    return null;
  }
  var endDate = new Date(end.replace(/-/g, '/') + ' 00:00:00');
  if (isNaN(endDate.getTime())) {
    return null;
  }
  endDate.setDate(endDate.getDate() + 1);
  var y = endDate.getFullYear();
  var m = ('0' + (endDate.getMonth() + 1)).slice(-2);
  var d = ('0' + endDate.getDate()).slice(-2);
  return {
    from: start + ' 00:00:00',
    to: y + '-' + m + '-' + d + ' 00:00:00'
  };
}

function emptyQuery() {
  return {
    keyword: '',
    nationality: '',
    regFrom: '',
    hr: '',
    interviewStatus: '',
    demoStatus: '',
    reviewStatus: '',
    offerStatus: ''
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchPendingInterview',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_3__modal_TchInfoModal_vue___default.a, RecruitScheduleBoard: __WEBPACK_IMPORTED_MODULE_5__RecruitScheduleBoard_vue___default.a, RecruitScheduleModal: __WEBPACK_IMPORTED_MODULE_6__modal_RecruitScheduleModal_vue___default.a, RecruitNotesModal: __WEBPACK_IMPORTED_MODULE_7__modal_RecruitNotesModal_vue___default.a, RecruitReviewModal: __WEBPACK_IMPORTED_MODULE_8__modal_RecruitReviewModal_vue___default.a, RecruitReasonModal: __WEBPACK_IMPORTED_MODULE_9__modal_RecruitReasonModal_vue___default.a, TchApplyFormModal: __WEBPACK_IMPORTED_MODULE_10__modal_TchApplyFormModal_vue___default.a },
  data: function data() {
    return {
      view: 'list',
      stageStatus: __WEBPACK_IMPORTED_MODULE_11__recruitConst__["b" /* STAGE_STATUS */],
      reviewStatus: __WEBPACK_IMPORTED_MODULE_11__recruitConst__["c" /* REVIEW_STATUS */],
      offerStatus: __WEBPACK_IMPORTED_MODULE_11__recruitConst__["d" /* OFFER_STATUS */],
      channelOptions: [],
      queryParam: emptyQuery(),
      interviewRange: [],
      demoRange: [],
      referrerName: '',
      noReferrer: false,
      appliedQuery: {},
      loading: false,
      rankScoreSeq: 0,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      summary: {},
      activeRow: null,
      scheduleVisible: false,
      scheduleKind: 'both',
      notesVisible: false,
      reviewVisible: false,
      reviewMode: 'review',
      reasonVisible: false,
      reasonLoading: false,
      reason: { type: '', title: '', label: '', desc: '', placeholder: '', init: '', row: null, kind: '', kindOptions: null, kindLabel: '类型', initKind: '' },
      showTchInfoModal: false,
      tchId: null,
      showApplyModal: false,
      applyTchId: null,
      selectedRows: [],
      batchLoading: false,
      columns: []
    };
  },
  created: function created() {
    this.columns = this.buildColumns();
    this.loadRegChannels();
    this.loadSummary();
    this.search();
  },

  methods: {
    buildColumns: function buildColumns() {
      var _this = this;

      return [{ type: 'selection', width: 48, align: 'center' }, { title: '老师ID', key: 'tchId', width: 80, align: 'center' }, {
        title: '姓名',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(row) || String(row.tchId),
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, { title: '国籍', key: 'nationality', width: 100, align: 'center' }, { title: '渠道', key: 'regFrom', width: 100, align: 'center' }, {
        title: '推荐人',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.inviteTchName || '—');
        }
      }, {
        title: 'HR',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var options = _this.$constant.hrList.slice();
          if (row.hr && !options.some(function (item) {
            return item.code === row.hr;
          })) {
            options = [{ code: row.hr, text: row.hr }].concat(options);
          }
          return h('Select', {
            props: {
              value: row.hr,
              transfer: true,
              clearable: true
            },
            on: {
              'on-change': function onChange(value) {
                var newValue = value || '';
                if (newValue !== (row.hr || '')) {
                  row.hr = newValue;
                  _this.updateTchDirect({ tchForm: { tchId: row.tchId, hr: newValue } });
                }
              }
            }
          }, options.map(function (item) {
            return h('Option', { props: { value: item.code }, key: item.code }, item.text);
          }));
        }
      }, {
        title: '面试状态',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          return _this.renderStage(h, params.row, 'interview');
        }
      }, {
        title: '试讲状态',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          return _this.renderStage(h, params.row, 'demo');
        }
      }, {
        title: '邀约环节',
        width: 240,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', { class: 'invite-cell' }, [h('Button', {
            props: { size: 'small', icon: 'calendar' },
            on: { click: function click() {
                return _this.openSchedule(row, 'both');
              } }
          }, '安排面试/试讲'), h('Button', {
            props: { size: 'small', type: row.hasNotes ? 'success' : 'primary', icon: 'document-text' },
            style: { marginLeft: '4px' },
            on: { click: function click() {
                return _this.openNotes(row);
              } }
          }, row.hasNotes ? '查看笔记' : '添加笔记')]);
        }
      }, {
        title: '复审',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          return _this.renderReview(h, params.row);
        }
      }, {
        title: '发Offer',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return _this.renderOffer(h, params.row);
        }
      }, {
        title: '操作',
        width: 200,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          var children = [h('a', { on: { click: function click() {
                return _this.openReserve(row);
              } } }, '转储备')];
          if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
            children.push(h('span', { style: { margin: '0 6px', color: '#dddee1' } }, '|'));
            children.push(h('a', { on: { click: function click() {
                  return _this.onShowApply(row);
                } } }, '注册资料'));
          }
          return h('div', children);
        }
      }];
    },
    renderPill: function renderPill(h, item, clickable) {
      var cls = { 'status-pill': true, 'is-clickable': clickable };
      cls['tone-' + item.color] = true;
      return h('span', { class: cls }, item.text + (clickable ? ' ▾' : ''));
    },
    renderStage: function renderStage(h, row, kind) {
      var _this2 = this;

      var status = kind === 'interview' ? row.interviewStatus : row.demoStatus;
      var time = kind === 'interview' ? row.interviewTime : row.demoTime;
      var failReason = kind === 'interview' ? row.interviewFailReason : row.demoFailReason;
      var item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["b" /* STAGE_STATUS */], status, 'pending');
      var menu = __WEBPACK_IMPORTED_MODULE_11__recruitConst__["b" /* STAGE_STATUS */].map(function (s) {
        return h('Dropdown-item', { props: { name: s.code, selected: s.code === item.code } }, s.text);
      });
      var children = [h('Dropdown', {
        props: { trigger: 'click', transfer: true },
        on: { 'on-click': function onClick(name) {
            return _this2.changeStage(row, kind, name);
          } }
      }, [this.renderPill(h, item, true), h('Dropdown-menu', { slot: 'list' }, menu)])];
      if (time && item.code !== 'pending') {
        children.push(h('div', { class: 'cell-time' }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["f" /* shortTime */])(time)));
      }
      if (item.code === 'failed' && failReason) {
        children.push(h('Tooltip', { props: { content: failReason, transfer: true, placement: 'top' } }, [h('div', { class: 'cell-reason' }, '理由：' + failReason)]));
      }
      return h('div', children);
    },
    renderReview: function renderReview(h, row) {
      var _this3 = this;

      var status = row.reviewStatus || 'submit';
      if (status === 'submit') {
        var ready = !!row.notesComplete;
        var btn = h('Button', {
          props: { size: 'small', type: 'primary', disabled: !ready },
          on: { click: function click() {
              return _this3.submitReview(row);
            } }
        }, '提交复审');
        if (ready) {
          return btn;
        }
        return h('Tooltip', { props: { content: '请先填写完整面试笔记与试讲打分', transfer: true, placement: 'top' } }, [btn]);
      }
      var item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["c" /* REVIEW_STATUS */], status, 'submit');
      if (status === 'pending_review') {
        return h('div', [this.renderPill(h, item, false), h('Button', {
          props: { size: 'small', type: 'warning' },
          style: { marginLeft: '4px' },
          on: { click: function click() {
              return _this3.openReview(row, 'review');
            } }
        }, '复审')]);
      }
      return h('a', {
        attrs: { title: '查看复审结果' },
        on: { click: function click() {
            return _this3.openReview(row, 'view');
          } }
      }, [this.renderPill(h, item, false), row.reviewGrade ? h('span', { class: 'cell-grade' }, row.reviewGrade) : null]);
    },
    renderOffer: function renderOffer(h, row) {
      var _this4 = this;

      var item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["d" /* OFFER_STATUS */], row.offerStatus, 'pending');
      var canEdit = row.reviewStatus === 'approved';
      var children = [];
      if (!canEdit) {
        children.push(h('Tooltip', { props: { content: '复审通过后才可发Offer', transfer: true, placement: 'top' } }, [h('span', { class: 'status-pill tone-gray is-disabled' }, item.text)]));
      } else {
        var menu = __WEBPACK_IMPORTED_MODULE_11__recruitConst__["d" /* OFFER_STATUS */].map(function (s) {
          return h('Dropdown-item', { props: { name: s.code, selected: s.code === item.code } }, s.text);
        });
        children.push(h('Dropdown', {
          props: { trigger: 'click', transfer: true },
          on: { 'on-click': function onClick(name) {
              return _this4.changeOffer(row, name);
            } }
        }, [this.renderPill(h, item, true), h('Dropdown-menu', { slot: 'list' }, menu)]));
      }
      if (item.code === 'rejected' && row.offerRejectReason) {
        children.push(h('Tooltip', { props: { content: row.offerRejectReason, transfer: true, placement: 'top' } }, [h('div', { class: 'cell-reason' }, '理由：' + row.offerRejectReason)]));
      }
      return h('div', children);
    },
    loadRegChannels: function loadRegChannels() {
      var _this5 = this;

      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this5.channelOptions = res.data;
        }
      }).catch(function () {});
    },
    loadSummary: function loadSummary() {
      var _this6 = this;

      this.$http.post('/tchRecruit/interview/summary', {}, { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this6.summary = res.data;
        }
      }).catch(function () {});
    },
    switchView: function switchView(view) {
      this.view = view;
      if (view === 'list') {
        this.loadList();
      }
    },
    onInterviewRangeChange: function onInterviewRangeChange(value) {
      this.interviewRange = value && value[0] && value[1] ? [value[0], value[1]] : [];
    },
    onDemoRangeChange: function onDemoRangeChange(value) {
      this.demoRange = value && value[0] && value[1] ? [value[0], value[1]] : [];
    },
    buildQuery: function buildQuery() {
      var q = {};
      var src = this.queryParam;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(src).forEach(function (k) {
        var v = src[k];
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          q[k] = String(v).trim();
        }
      });
      if (this.noReferrer) {
        q.referrer = __WEBPACK_IMPORTED_MODULE_11__recruitConst__["g" /* NO_REFERRER */];
      } else if (this.referrerName && this.referrerName.trim()) {
        q.referrer = this.referrerName.trim();
      }
      var interviewHalf = rangeToHalfOpen(this.interviewRange);
      if (interviewHalf) {
        q.interviewFrom = interviewHalf.from;
        q.interviewTo = interviewHalf.to;
      }
      var demoHalf = rangeToHalfOpen(this.demoRange);
      if (demoHalf) {
        q.demoFrom = demoHalf.from;
        q.demoTo = demoHalf.to;
      }
      return q;
    },
    search: function search() {
      this.appliedQuery = this.buildQuery();
      this.pageIndex = 1;
      this.loadList();
    },
    reset: function reset() {
      this.queryParam = emptyQuery();
      this.interviewRange = [];
      this.demoRange = [];
      this.referrerName = '';
      this.noReferrer = false;
      this.search();
    },
    reloadPage: function reloadPage() {
      this.loadList();
    },
    loadList: function loadList() {
      var _this7 = this;

      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.appliedQuery, {
        pageNum: this.pageIndex,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
      this.loading = true;
      this.$http.post('/tchRecruit/interview/list', params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this7.tableData = data.data || [];
          _this7.loadMonthRankScores();
          _this7.totalCount = data.totalCount || 0;
          _this7.selectedRows = [];
        } else {
          _this7.tableData = [];
          _this7.totalCount = 0;
          _this7.selectedRows = [];
          _this7.$Message.error(res && res.msg || '列表加载失败');
        }
      }).catch(function () {}).finally(function () {
        _this7.loading = false;
      });
    },
    onPageChange: function onPageChange(page) {
      this.pageIndex = page;
      this.loadList();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.loadList();
    },
    afterChange: function afterChange(reloadList) {
      if (reloadList && this.view === 'list') {
        this.loadList();
      }
      this.loadSummary();
      this.$root.$emit('recruit-badges-refresh');
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.tableData || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    onShowApply: function onShowApply(row) {
      this.applyTchId = row.tchId;
      this.showApplyModal = true;
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchId = Number(tchId);
      this.showTchInfoModal = true;
    },
    openSchedule: function openSchedule(row, kind) {
      this.activeRow = row;
      this.scheduleKind = kind;
      this.scheduleVisible = true;
    },
    openNotes: function openNotes(row) {
      this.activeRow = row;
      this.notesVisible = true;
    },
    openReview: function openReview(row, mode) {
      this.activeRow = row;
      this.reviewMode = mode;
      this.reviewVisible = true;
    },
    openReason: function openReason(opts) {
      this.reason = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        type: '', title: '', label: '', desc: '', placeholder: '', init: '', row: null, kind: '',
        kindOptions: null, kindLabel: '类型', initKind: ''
      }, opts);
      this.reasonLoading = false;
      this.reasonVisible = true;
    },
    updateTchDirect: function updateTchDirect(req) {
      var _this8 = this;

      this.$http.post('/tch/update-direct', req).then(function (res) {
        if (res.status === 'ok') {
          _this8.$Message.success('更新成功');
        } else {
          _this8.$Message.error(res.msg);
        }
      }).catch(function () {
        _this8.$Message.error('更新失败');
      });
    },
    action: function action(url, params, successText) {
      var _this9 = this;

      return this.$http.post(url, params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this9.$Message.success(successText);
          _this9.afterChange(true);
          return true;
        }
        _this9.$Message.error(res && res.msg || '操作失败');
        return false;
      }).catch(function () {
        return false;
      });
    },
    changeStage: function changeStage(row, kind, status) {
      var current = (kind === 'interview' ? row.interviewStatus : row.demoStatus) || 'pending';
      var label = kind === 'interview' ? '面试' : '试讲';
      if (status === 'failed') {
        var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(row);
        this.openReason({
          type: 'stageFail',
          kind: kind,
          row: row,
          title: '填写未通过理由' + (name ? ' - ' + name : ''),
          label: '未通过理由',
          desc: '确认后将标记' + label + '未通过，老师转到「已审核老师」并发送拒绝邮件。',
          placeholder: '请填写' + label + '未通过的原因',
          init: (kind === 'interview' ? row.interviewFailReason : row.demoFailReason) || ''
        });
        return;
      }
      if (status === current) {
        return;
      }
      var time = kind === 'interview' ? row.interviewTime : row.demoTime;
      if ((status === 'scheduled' || status === 'confirmed') && !time) {
        this.openSchedule(row, kind);
        return;
      }
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["b" /* STAGE_STATUS */], status).text;
      this.action('/tchRecruit/interview/status', { tchId: row.tchId, kind: kind, status: status }, label + '状态已更新为「' + text + '」');
    },
    submitReview: function submitReview(row) {
      if (!row.notesComplete) {
        this.$Message.error('请先完善面试笔记与试讲打分后再提交复审');
        return;
      }
      this.action('/tchRecruit/interview/submit-review', { tchId: row.tchId }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(row) + ' 已提交复审');
    },
    changeOffer: function changeOffer(row, status) {
      var _this10 = this;

      if (row.reviewStatus !== 'approved') {
        this.$Message.error('复审通过后才可发Offer');
        return;
      }
      if (status === (row.offerStatus || 'pending') && status !== 'rejected') {
        return;
      }
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(row);
      if (status === 'rejected') {
        this.openReason({
          type: 'offerReject',
          row: row,
          title: '填写拒绝理由' + (name ? ' - ' + name : ''),
          label: '拒绝理由',
          placeholder: '请填写拒绝 Offer 的原因',
          init: row.offerRejectReason || ''
        });
        return;
      }
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["d" /* OFFER_STATUS */], status).text;
      var doIt = function doIt() {
        return _this10.action('/tchRecruit/interview/offer', { tchId: row.tchId, offerStatus: status }, '发Offer状态已更新为「' + text + '」');
      };
      if (status === 'accepted') {
        this.$Modal.confirm({
          title: '接受Offer',
          content: '接受后老师将进入培训中，确定 ' + name + ' 接受Offer？',
          onOk: doIt
        });
        return;
      }
      doIt();
    },
    openReserve: function openReserve(row) {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(row);
      this.openReason({
        type: 'reserve',
        row: row,
        title: '转储备' + (name ? ' - ' + name : ''),
        label: '储备原因',
        desc: '转储备后老师从待面试移出，可在「储备老师」重新激活。',
        placeholder: '请填写转储备的原因'
      });
    },
    onSelectionChange: function onSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    selectedTchIds: function selectedTchIds() {
      return this.selectedRows.map(function (r) {
        return r.tchId;
      }).filter(Boolean).join(',');
    },
    formatBatchMsg: function formatBatchMsg(data) {
      var success = data && data.successCount || 0;
      var skip = data && data.skipCount || 0;
      var fail = data && data.failCount || 0;
      var parts = ['成功 ' + success + ' 人'];
      if (skip) {
        parts.push('跳过 ' + skip + ' 人');
      }
      if (fail) {
        parts.push('失败 ' + fail + ' 人');
      }
      var reasons = [];
      var items = data && data.items || [];
      items.forEach(function (it) {
        if (it.outcome !== 'success' && it.reason) {
          reasons.push('ID' + it.tchId + '：' + it.reason);
        }
      });
      var msg = parts.join('，');
      if (reasons.length) {
        msg += '。' + reasons.slice(0, 5).join('；');
        if (reasons.length > 5) {
          msg += '…';
        }
      }
      return { msg: msg, success: success, skip: skip, fail: fail };
    },
    runBatch: function runBatch(url, params, loadingKey) {
      var _this11 = this;

      if (!params.tchIds) {
        this.$Message.warning('请先勾选老师');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      this.batchLoading = loadingKey || true;
      return this.$http.post(url, params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          var info = _this11.formatBatchMsg(res.data || {});
          if (info.fail > 0) {
            _this11.$Message.warning(info.msg);
          } else if (info.skip > 0 && info.success === 0) {
            _this11.$Message.warning(info.msg);
          } else if (info.skip > 0) {
            _this11.$Message.warning(info.msg);
          } else {
            _this11.$Message.success(info.msg);
          }
          _this11.afterChange(true);
          return true;
        }
        _this11.$Message.error(res && res.msg || '批量操作失败');
        return false;
      }).catch(function () {
        _this11.$Message.error('批量操作失败');
        return false;
      }).finally(function () {
        _this11.batchLoading = false;
      });
    },
    batchSubmitReview: function batchSubmitReview() {
      this.runBatch('/tchRecruit/interview/batch-submit-review', { tchIds: this.selectedTchIds() }, 'review');
    },
    openBatchReserve: function openBatchReserve() {
      var n = this.selectedRows.length;
      if (!n) {
        this.$Message.warning('请先勾选老师');
        return;
      }
      this.openReason({
        type: 'batchReserve',
        row: { tchId: 0 },
        title: '批量转储备（' + n + ' 人）',
        label: '储备原因',
        desc: '所选老师将共用该原因转储备；不符合条件的会跳过。',
        placeholder: '请填写转储备的原因'
      });
    },
    batchOfferSent: function batchOfferSent() {
      var _this12 = this;

      var n = this.selectedRows.length;
      if (!n) {
        this.$Message.warning('请先勾选老师');
        return;
      }
      this.$Modal.confirm({
        title: '批量发Offer',
        content: '将把所选 ' + n + ' 人标为「已发 Offer」（仅复审通过且仍在面试中的会成功，其余跳过）。确定？',
        onOk: function onOk() {
          return _this12.runBatch('/tchRecruit/interview/batch-offer', { tchIds: _this12.selectedTchIds() }, 'offer');
        }
      });
    },
    onReasonOk: function onReasonOk(text, kind) {
      var _this13 = this;

      var r = this.reason;
      if (!r.row && r.type !== 'batchReserve') {
        return;
      }
      var req = void 0;
      if (r.type === 'stageFail') {
        var failLabel = r.kind === 'demo' ? '试讲未通过' : '面试未通过';
        req = this.action('/tchRecruit/interview/fail-reject', { tchId: r.row.tchId, failKind: r.kind, reason: text }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(r.row) + ' 已标记为「' + failLabel + '」并转到已审核');
      } else if (r.type === 'offerReject') {
        req = this.action('/tchRecruit/interview/offer', { tchId: r.row.tchId, offerStatus: 'rejected', rejectReason: text }, '发Offer状态已更新为「拒绝Offer」');
      } else if (r.type === 'reserve') {
        req = this.action('/tchRecruit/interview/to-reserve', { tchId: r.row.tchId, reason: text }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__recruitConst__["a" /* tchName */])(r.row) + ' 已转储备');
      } else if (r.type === 'batchReserve') {
        this.reasonLoading = true;
        this.runBatch('/tchRecruit/interview/batch-to-reserve', { tchIds: this.selectedTchIds(), reason: text }, 'reserve').then(function (ok) {
          _this13.reasonLoading = false;
          if (ok) {
            _this13.reasonVisible = false;
          }
        });
        return;
      } else {
        return;
      }
      this.reasonLoading = true;
      req.then(function (ok) {
        _this13.reasonLoading = false;
        if (ok) {
          _this13.reasonVisible = false;
        }
      });
    }
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



var TREND_KEYS = [{ key: 'newReg', title: '新增注册' }, { key: 'invite', title: '邀约' }, { key: 'interviewDone', title: '面试完成' }, { key: 'offerSent', title: '发Offer' }, { key: 'offerAccepted', title: '接Offer' }, { key: 'toTraining', title: '进入培训' }, { key: 'opened', title: '开课' }, { key: 'reserved', title: '转储备' }, { key: 'eliminated', title: '培训淘汰流失' }, { key: 'total', title: '合计' }];

function backlogLevel(n) {
  if (n >= 20) {
    return 'danger';
  }
  if (n > 0) {
    return 'warning';
  }
  return 'healthy';
}

function num(v) {
  var n = Number(v);
  return isFinite(n) ? n : 0;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRecruitDashboard',
  data: function data() {
    var end = this.$moment().format('YYYY-MM-DD');
    var start = this.$moment().subtract(6, 'days').format('YYYY-MM-DD');
    return {
      channelOptions: [],
      nationalityInput: '',
      filters: {
        nationality: '',
        regFrom: '',
        hr: ''
      },
      dateRange: [start, end],
      loading: false,
      reqId: 0,
      updatedAt: '',
      data: {
        counts: {},
        globalCounts: {},
        todayTodo: 0,
        trend: []
      },
      exportLoading: false,
      trendColumns: [{ title: '日期', key: 'date', align: 'center', minWidth: 110 }].concat(TREND_KEYS.map(function (c) {
        return {
          title: c.title,
          key: c.key,
          align: 'center',
          minWidth: c.key === 'eliminated' ? 120 : 84
        };
      }))
    };
  },

  computed: {
    todayText: function todayText() {
      return this.$moment().format('YYYY-MM-DD');
    },
    metaRows: function metaRows() {
      return [{ label: '数据来源', value: 'tch_list / tch_recruit_flow' }, { label: '口径版本', value: '外教招聘 v1' }, { label: '最近更新', value: this.updatedAt || '—' }];
    },
    channelName: function channelName() {
      var code = this.filters.regFrom;
      if (!code) {
        return '全部';
      }
      var item = this.channelOptions.find(function (c) {
        return c.param === code;
      });
      return item ? item.name : code;
    },
    chips: function chips() {
      return [{ label: '国籍', value: this.filters.nationality || '全部' }, { label: '渠道', value: this.channelName }, { label: 'HR', value: this.filters.hr || '全部' }, { label: '时间', value: this.chipRangeText }, { label: '今日待办', value: num(this.data.todayTodo) }];
    },
    kpiCards: function kpiCards() {
      var c = this.data.counts || {};
      var g = this.data.globalCounts || {};
      var period = '截至 ' + this.todayText;
      var todo = num(this.data.todayTodo);
      return [{
        key: 'todayTodo',
        title: '今日待办',
        value: todo,
        level: backlogLevel(todo),
        period: period,
        compare: '待审核 ' + num(c.pendingReview) + ' + 待面试 ' + num(c.interviewing),
        foot: '今日待办 = 待审核老师 + 待面试老师'
      }, {
        key: 'pendingReview',
        title: '待审核老师',
        value: num(c.pendingReview),
        level: backlogLevel(num(c.pendingReview)),
        period: period,
        compare: '全局 ' + num(g.pendingReview),
        foot: '注册后还没审核的老师（未审核、未激活）'
      }, {
        key: 'interviewing',
        title: '待面试老师',
        value: num(c.interviewing),
        level: backlogLevel(num(c.interviewing)),
        period: period,
        compare: '全局 ' + num(g.interviewing),
        foot: '面试中老师，不含已转储备 · 点击进入待面试老师',
        link: '/tch/recruit/pendingInterview'
      }, {
        key: 'training',
        title: '培训中老师',
        value: num(c.training),
        level: num(c.training) > 0 ? 'healthy' : 'warning',
        period: period,
        compare: '全局 ' + num(g.training),
        foot: '和「培训中老师」列表同口径'
      }, {
        key: 'probation',
        title: '试用期老师',
        value: num(c.probation),
        level: 'healthy',
        period: period,
        compare: '全局 ' + num(g.probation),
        foot: '类型试用期、状态激活'
      }, {
        key: 'formal',
        title: '正式老师',
        value: num(c.formal),
        level: 'healthy',
        period: period,
        compare: '全局 ' + num(g.formal),
        foot: '类型正式、状态激活'
      }, {
        key: 'reserved',
        title: '储备老师',
        value: num(c.reserved),
        level: num(c.reserved) > 0 ? 'warning' : 'healthy',
        period: period,
        compare: '全局 ' + num(g.reserved),
        foot: '已转储备且未归档 · 点击进入储备老师',
        link: '/tch/recruit/reserved'
      }, {
        key: 'rejected',
        title: '已拒绝老师',
        value: num(c.rejected),
        level: num(c.rejected) > 0 ? 'danger' : 'healthy',
        period: period,
        compare: '全局 ' + num(g.rejected),
        foot: '老师状态为被拒绝'
      }];
    },
    rangeText: function rangeText() {
      var r = this.dateRange || [];
      return (r[0] || '—') + ' ~ ' + (r[1] || '—');
    },
    chipRangeText: function chipRangeText() {
      var r = this.dateRange || [];
      if (!r[0] || !r[1]) {
        return '—';
      }
      return this.$moment(r[0]).format('MM-DD') + ' ~ ' + this.$moment(r[1]).format('MM-DD');
    },
    trendRows: function trendRows() {
      return this.withTotal(this.data.trend);
    },
    trendTableHeight: function trendTableHeight() {
      var r = this.dateRange || [];
      if (!r[0] || !r[1]) {
        return null;
      }
      var days = this.$moment(r[1]).diff(this.$moment(r[0]), 'days') + 1;
      return days > 7 ? 460 : null;
    }
  },
  created: function created() {
    this.loadRegChannels();
    this.load();
  },

  methods: {
    loadRegChannels: function loadRegChannels() {
      var _this = this;

      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.channelOptions = res.data;
        }
      }).catch(function () {});
    },
    applyNationality: function applyNationality() {
      var val = (this.nationalityInput || '').trim();
      if (val === this.filters.nationality) {
        return;
      }
      this.filters.nationality = val;
      this.load();
    },
    queryBody: function queryBody() {
      var body = {};
      var f = this.filters;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(f).forEach(function (k) {
        if (f[k]) {
          body[k] = f[k];
        }
      });
      var r = this.dateRange || [];
      body.startDate = r[0];
      body.endDate = r[1];
      return body;
    },
    onDateRangeChange: function onDateRangeChange(value) {
      var start = value && value[0];
      var end = value && value[1];
      if (!start || !end) {
        this.dateRange = this.dateRange.slice();
        return;
      }
      var days = this.$moment(end).diff(this.$moment(start), 'days') + 1;
      if (days > 90) {
        this.$Message.warning('时间跨度不能超过90天');
        this.dateRange = this.dateRange.slice();
        return;
      }
      this.dateRange = [start, end];
      this.load();
    },
    setQuickRange: function setQuickRange(days) {
      var end = this.$moment().format('YYYY-MM-DD');
      var start = this.$moment().subtract(days - 1, 'days').format('YYYY-MM-DD');
      this.dateRange = [start, end];
      this.load();
    },
    load: function load() {
      var _this2 = this;

      var reqId = ++this.reqId;
      this.loading = true;
      this.$http.post('/tchRecruit/dashboard', this.queryBody(), { silent: true }).then(function (res) {
        if (reqId !== _this2.reqId) {
          return;
        }
        if (res && res.status === 'ok') {
          var d = res.data || {};
          _this2.data = {
            counts: d.counts || {},
            globalCounts: d.globalCounts || {},
            todayTodo: d.todayTodo,
            trend: d.trend || []
          };
          _this2.updatedAt = _this2.$moment().format('YYYY-MM-DD HH:mm');
        } else {
          _this2.$Message.error(res && res.msg || '看板加载失败');
        }
      }).catch(function () {}).finally(function () {
        if (reqId === _this2.reqId) {
          _this2.loading = false;
        }
      });
    },
    withTotal: function withTotal(rows) {
      var list = (rows || []).map(function (r) {
        var row = { date: r.date };
        TREND_KEYS.forEach(function (c) {
          row[c.key] = num(r[c.key]);
        });
        return row;
      });
      var sum = { date: '合计', isTotal: true };
      TREND_KEYS.forEach(function (c) {
        sum[c.key] = list.reduce(function (a, r) {
          return a + r[c.key];
        }, 0);
      });
      return list.concat([sum]);
    },
    trendRowClass: function trendRowClass(row) {
      return row.isTotal ? 'row-total' : '';
    },
    openCard: function openCard(card) {
      if (card.link) {
        this.$router.push(card.link);
      }
    },
    exportTrend: function exportTrend() {
      var _this3 = this;

      var body = this.queryBody();
      var r = this.dateRange || [];
      var start = (r[0] || '').replace(/-/g, '');
      var end = (r[1] || '').replace(/-/g, '');
      this.exportLoading = true;
      this.$http.post('/tchRecruit/dashboard-trend-export', body, { responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '外教招聘看板_流转_' + start + '-' + end + '.xlsx';
        link.click();
        _this3.$Message.success('导出成功');
      }).catch(function (error) {
        _this3.$Message.error('导出失败：' + (error && error.message || '未知错误'));
      }).finally(function () {
        _this3.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var HIGH_CHURN = 0.15;

var LEADERBOARD_EXCLUDED_HR = 'Amanda';

var NUM_COLUMNS = [{ title: '开课数', key: 'classesStarted', strong: true }, { title: '邀约数', key: 'invitations' }, { title: '面试数', key: 'interviews' }, { title: '发offer数', key: 'offersSent' }, { title: '接offer数', key: 'offersAccepted' }, { title: '培训中数', key: 'inTraining' }, { title: '新外教60天内离职量', key: 'churn60d', churn: true }, { title: '渠道开发数', key: 'channelDev' }];

function churnRate(row) {
  var opened = Number(row.classesStarted) || 0;
  if (opened <= 0) {
    return 0;
  }
  return (Number(row.churn60d) || 0) / opened;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRecruitLeaderboard',
  data: function data() {
    return {
      periodOptions: [{ value: 'day', label: '日' }, { value: 'week', label: '周' }, { value: 'month', label: '月' }, { value: 'year', label: '年' }],
      period: 'month',
      anchor: this.$moment().format('YYYY-MM-DD'),
      hr: '',
      loading: false,
      result: { timeLabel: '', startDate: '', endDate: '', rows: [] },
      appliedPeriod: 'month',
      appliedHr: '',
      reqId: 0,
      columns: []
    };
  },

  computed: {
    hrOptions: function hrOptions() {
      return (this.$constant.hrList || []).filter(function (item) {
        return item && item.code !== LEADERBOARD_EXCLUDED_HR;
      });
    },
    anchorDate: function anchorDate() {
      return this.$moment(this.anchor, 'YYYY-MM-DD').toDate();
    },
    rangeText: function rangeText() {
      var r = this.result;
      if (!r.startDate || !r.endDate) {
        return '';
      }
      return r.startDate === r.endDate ? r.startDate : r.startDate + ' ~ ' + r.endDate;
    },
    tableRows: function tableRows() {
      var _this = this;

      var rows = (this.result.rows || []).filter(function (r) {
        return r && r.hr && r.hr !== LEADERBOARD_EXCLUDED_HR;
      }).map(function (r) {
        return _this.normalizeRow(r);
      });
      var exists = {};
      rows.forEach(function (r) {
        exists[r.hr] = true;
      });
      var hrs = this.appliedHr ? [this.appliedHr] : this.hrOptions.map(function (item) {
        return item.code;
      });
      hrs.forEach(function (code) {
        if (!exists[code]) {
          rows.push(_this.normalizeRow({ hr: code }));
          exists[code] = true;
        }
      });
      if (this.appliedHr) {
        rows = rows.filter(function (r) {
          return r.hr === _this.appliedHr;
        });
      }
      rows = rows.map(function (r, i) {
        return { row: r, idx: i };
      }).sort(function (a, b) {
        var diff = b.row.classesStarted - a.row.classesStarted;
        return diff !== 0 ? diff : a.idx - b.idx;
      }).map(function (x) {
        return x.row;
      });
      var label = this.result.timeLabel || '';
      return rows.map(function (r, i) {
        r.timeLabel = label;
        r.rank = i;
        return r;
      });
    }
  },
  created: function created() {
    this.columns = this.buildColumns();
    this.search();
  },

  methods: {
    normalizeRow: function normalizeRow(r) {
      var row = { hr: r.hr };
      NUM_COLUMNS.forEach(function (c) {
        row[c.key] = Number(r[c.key]) || 0;
      });
      return row;
    },
    buildColumns: function buildColumns() {
      var _this2 = this;

      var columns = [{ title: '时间', key: 'timeLabel', align: 'center', minWidth: 160 }, {
        title: 'HR',
        align: 'center',
        minWidth: 120,
        render: function render(h, params) {
          var row = params.row;
          var showTrophy = row.rank === 0 && _this2.appliedPeriod === 'month' && !_this2.appliedHr && row.classesStarted > 0;
          return h('span', { class: 'hr-cell' }, [showTrophy ? h('Icon', { props: { type: 'trophy' }, class: 'trophy' }) : null, row.hr]);
        }
      }];
      NUM_COLUMNS.forEach(function (c) {
        columns.push({
          title: c.title,
          key: c.key,
          align: 'center',
          minWidth: c.churn ? 150 : 100,
          render: function render(h, params) {
            var row = params.row;
            var cls = 'num-cell';
            if (c.strong) {
              cls += ' is-strong';
            }
            if (c.churn && churnRate(row) >= HIGH_CHURN) {
              cls += ' is-churn';
            }
            return h('span', { class: cls }, String(row[c.key]));
          }
        });
      });
      return columns;
    },
    rowClassName: function rowClassName(row) {
      return churnRate(row) >= HIGH_CHURN ? 'row-high-churn' : '';
    },
    onPeriodChange: function onPeriodChange() {
      this.anchor = this.$moment().format('YYYY-MM-DD');
      this.search();
    },
    onDateChange: function onDateChange(value) {
      if (!value) {
        return;
      }
      if (this.period === 'month') {
        this.anchor = value + '-01';
      } else if (this.period === 'year') {
        this.anchor = value + '-01-01';
      } else {
        this.anchor = value;
      }
      this.search();
    },
    queryDate: function queryDate() {
      var m = this.$moment(this.anchor, 'YYYY-MM-DD');
      if (this.period === 'week') {
        return m.startOf('isoWeek').format('YYYY-MM-DD');
      }
      if (this.period === 'month') {
        return m.startOf('month').format('YYYY-MM-DD');
      }
      if (this.period === 'year') {
        return m.startOf('year').format('YYYY-MM-DD');
      }
      return m.format('YYYY-MM-DD');
    },
    search: function search() {
      var _this3 = this;

      var params = { period: this.period, date: this.queryDate() };
      if (this.hr) {
        params.hr = this.hr;
      }
      var reqId = ++this.reqId;
      var period = this.period;
      var hr = this.hr || '';
      this.loading = true;
      this.$http.post('/tchRecruit/leaderboard', params, { silent: true }).then(function (res) {
        if (reqId !== _this3.reqId) {
          return;
        }
        _this3.appliedPeriod = period;
        _this3.appliedHr = hr;
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this3.result = {
            timeLabel: data.timeLabel || '',
            startDate: data.startDate || '',
            endDate: data.endDate || '',
            rows: data.rows || []
          };
        } else {
          _this3.result = { timeLabel: '', startDate: '', endDate: '', rows: [] };
          _this3.$Message.error(res && res.msg || '龙虎榜加载失败');
        }
      }).catch(function () {}).finally(function () {
        if (reqId === _this3.reqId) {
          _this3.loading = false;
        }
      });
    }
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recruitConst__ = __webpack_require__(59);








function emptyQuery() {
  return {
    keyword: '',
    nationality: '',
    regFrom: '',
    hr: ''
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchReservedList',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_2__modal_TchInfoModal_vue___default.a },
  data: function data() {
    var _this = this;

    return {
      channelOptions: [],
      queryParam: emptyQuery(),
      appliedQuery: {},
      loading: false,
      rankScoreSeq: 0,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      showTchInfoModal: false,
      tchId: null,
      columns: [{ title: '老师ID', key: 'tchId', width: 90, align: 'center' }, {
        title: '姓名',
        minWidth: 140,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["a" /* tchName */])(row) || String(row.tchId),
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openTchInfoModal(row.tchId);
            }
          });
        }
      }, { title: '国籍', key: 'nationality', width: 110, align: 'center' }, { title: '渠道', key: 'regFrom', width: 110, align: 'center' }, {
        title: '推荐人',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.inviteTchName || '—');
        }
      }, { title: 'HR', key: 'hr', width: 100, align: 'center' }, {
        title: '中断环节',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.reserveFrom || '—');
        }
      }, {
        title: '储备原因',
        minWidth: 180,
        render: function render(h, params) {
          var reason = params.row.reserveReason || '';
          return h('div', {
            attrs: { title: reason },
            style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
          }, reason || '—');
        }
      }, { title: '转入时间', key: 'reserveTime', width: 160, align: 'center' }, {
        title: '操作',
        width: 140,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.reactivate(row);
              } } }, '重新激活'), h('span', { class: 'divider' }), h('a', { style: { color: '#ed3f14' }, on: { click: function click() {
                return _this.archive(row);
              } } }, '归档')]);
        }
      }]
    };
  },
  created: function created() {
    this.loadRegChannels();
    this.search();
  },

  methods: {
    loadRegChannels: function loadRegChannels() {
      var _this2 = this;

      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this2.channelOptions = res.data;
        }
      }).catch(function () {});
    },
    buildQuery: function buildQuery() {
      var q = {};
      var src = this.queryParam;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(src).forEach(function (k) {
        var v = src[k];
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          q[k] = String(v).trim();
        }
      });
      return q;
    },
    search: function search() {
      this.appliedQuery = this.buildQuery();
      this.pageIndex = 1;
      this.loadList();
    },
    reset: function reset() {
      this.queryParam = emptyQuery();
      this.search();
    },
    loadList: function loadList() {
      var _this3 = this;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.appliedQuery, {
        pageNum: this.pageIndex,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
      this.loading = true;
      this.$http.post('/tchRecruit/reserve/list', params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          var data = res.data || {};
          _this3.tableData = data.data || [];
          _this3.loadMonthRankScores();
          _this3.totalCount = data.totalCount || 0;
        } else {
          _this3.tableData = [];
          _this3.totalCount = 0;
          _this3.$Message.error(res && res.msg || '列表加载失败');
        }
      }).catch(function () {}).finally(function () {
        _this3.loading = false;
      });
    },
    onPageChange: function onPageChange(page) {
      this.pageIndex = page;
      this.loadList();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.loadList();
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var rows = this.tableData || [];
      if (!rows.length) {
        return;
      }
      var ids = rows.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, 'tchId', 'monthRankScore', map);
      });
    },
    openTchInfoModal: function openTchInfoModal(tchId) {
      this.tchId = Number(tchId);
      this.showTchInfoModal = true;
    },
    action: function action(url, row, successText) {
      var _this4 = this;

      this.$http.post(url, { tchId: row.tchId }, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this4.$Message.success(successText);
          _this4.loadList();
          _this4.$root.$emit('recruit-badges-refresh');
        } else {
          _this4.$Message.error(res && res.msg || '操作失败');
        }
      }).catch(function () {});
    },
    reactivate: function reactivate(row) {
      var _this5 = this;

      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["a" /* tchName */])(row);
      this.$Modal.confirm({
        title: '重新激活',
        content: '确定将 ' + name + ' 重新激活回待面试？',
        onOk: function onOk() {
          return _this5.action('/tchRecruit/reserve/reactivate', row, name + ' 已重新激活至待面试');
        }
      });
    },
    archive: function archive(row) {
      var _this6 = this;

      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["a" /* tchName */])(row);
      this.$Modal.confirm({
        title: '归档',
        content: '归档后 ' + name + ' 将从储备列表移除，确定归档？',
        onOk: function onOk() {
          return _this6.action('/tchRecruit/reserve/archive', row, name + ' 已归档');
        }
      });
    }
  }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recruitConst__ = __webpack_require__(59);








var MAX_SIZE_KB = 102400;
var MAX_SIZE_BYTES = MAX_SIZE_KB * 1024;
var DRAFT_DEBOUNCE_MS = 800;

function emptyForm() {
  return {
    classLink: '',
    attachments: [],
    personalSituation: '',
    workSituation: '',
    probationSalary: '',
    regularSalary: '',
    demoStrengths: '',
    demoWeaknesses: '',
    demoScores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["i" /* emptyScores */])(),
    demoRemarks: ''
  };
}

function notBlank(v) {
  return v !== null && v !== undefined && String(v).trim() !== '';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecruitNotesModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      form: emptyForm(),
      criteria: __WEBPACK_IMPORTED_MODULE_4__recruitConst__["j" /* DEMO_SCORE_CRITERIA */],
      scoreOptions: __WEBPACK_IMPORTED_MODULE_4__recruitConst__["k" /* DEMO_SCORE_OPTIONS */],
      maxSizeKb: MAX_SIZE_KB,
      uploadAction: this.$appConfig.baseUrl + '/upload/fileUpload',
      uploadHeaders: {},
      uploading: false,
      uploadingCount: 0,
      detailLoading: false,
      saving: false,
      hasNotes: false,
      noteTime: '',
      noteBy: '',
      draftHint: '',
      draftTimer: null,
      restoringDraft: false
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["a" /* tchName */])(this.row);
      return (this.hasNotes ? '查看笔记' : '添加笔记') + (name ? ' - ' + name : '');
    },
    classLinkOpenable: function classLinkOpenable() {
      return notBlank(this.form.classLink);
    },
    classLinkHref: function classLinkHref() {
      var u = (this.form.classLink || '').trim();
      if (!u) {
        return '#';
      }
      if (!/^https?:\/\//i.test(u)) {
        return 'https://' + u;
      }
      return u;
    },
    scoreStats: function scoreStats() {
      var scores = this.form.demoScores || {};
      var vals = __WEBPACK_IMPORTED_MODULE_4__recruitConst__["j" /* DEMO_SCORE_CRITERIA */].map(function (c) {
        return Number(scores[c.key]) || 0;
      });
      var sum = vals.reduce(function (a, b) {
        return a + b;
      }, 0);
      var avg = vals.length ? sum / vals.length : 0;
      return {
        hasScored: vals.some(function (v) {
          return v > 0;
        }),
        sumText: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(sum) ? String(sum) : sum.toFixed(1),
        avgText: avg.toFixed(1)
      };
    },
    complete: function complete() {
      var f = this.form;
      if (!notBlank(f.personalSituation) || !notBlank(f.workSituation) || !notBlank(f.probationSalary) || !notBlank(f.regularSalary) || !notBlank(f.demoStrengths) || !notBlank(f.demoWeaknesses)) {
        return false;
      }
      var scores = f.demoScores || {};
      return __WEBPACK_IMPORTED_MODULE_4__recruitConst__["j" /* DEMO_SCORE_CRITERIA */].every(function (c) {
        return (Number(scores[c.key]) || 0) > 0;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.init();
      }
    },

    form: {
      deep: true,
      handler: function handler() {
        if (!this.value || this.detailLoading || this.restoringDraft || this.saving) {
          return;
        }
        this.scheduleDraftSave();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.draftTimer) {
      clearTimeout(this.draftTimer);
      this.draftTimer = null;
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      this.form = emptyForm();
      this.uploadHeaders = this.buildUploadHeaders();
      this.uploading = false;
      this.uploadingCount = 0;
      this.saving = false;
      this.draftHint = '';
      this.fillForm(this.row);
      if (!this.row || !this.row.tchId) {
        return;
      }
      this.detailLoading = true;
      this.$http.post('/tchRecruit/interview/detail', { tchId: this.row.tchId }, { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          _this.fillForm(res.data);
        }
      }).catch(function () {}).finally(function () {
        _this.detailLoading = false;
        _this.restoreDraft();
      });
    },
    fillForm: function fillForm(row) {
      if (!row) {
        return;
      }
      var attachments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["l" /* parseJson */])(row.attachments, []);
      var scores = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["l" /* parseJson */])(row.demoScores, {});
      this.form = {
        classLink: row.classLink || '',
        attachments: Array.isArray(attachments) ? attachments : [],
        personalSituation: row.personalSituation || '',
        workSituation: row.workSituation || '',
        probationSalary: row.probationSalary || '',
        regularSalary: row.regularSalary || '',
        demoStrengths: row.demoStrengths || '',
        demoWeaknesses: row.demoWeaknesses || '',
        demoScores: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["i" /* emptyScores */])(), this.normalizeScores(scores)),
        demoRemarks: row.demoRemarks || ''
      };
      this.hasNotes = !!row.hasNotes;
      this.noteTime = row.noteTime || '';
      this.noteBy = row.noteBy || '';
    },
    normalizeScores: function normalizeScores(scores) {
      var out = {};
      if (!scores || (typeof scores === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(scores)) !== 'object') {
        return out;
      }
      __WEBPACK_IMPORTED_MODULE_4__recruitConst__["j" /* DEMO_SCORE_CRITERIA */].forEach(function (c) {
        if (scores[c.key] !== undefined && scores[c.key] !== null) {
          out[c.key] = Number(scores[c.key]) || 0;
        }
      });
      return out;
    },
    draftStorageKey: function draftStorageKey() {
      var tchId = this.row && this.row.tchId;
      if (!tchId) {
        return '';
      }
      var account = this.$store.get('account') || 'anon';
      return 'recruit-notes-draft:' + account + ':' + tchId;
    },
    scheduleDraftSave: function scheduleDraftSave() {
      var self = this;
      if (this.draftTimer) {
        clearTimeout(this.draftTimer);
      }
      this.draftTimer = setTimeout(function () {
        self.persistDraft();
      }, DRAFT_DEBOUNCE_MS);
    },
    persistDraft: function persistDraft() {
      var key = this.draftStorageKey();
      if (!key || !this.value) {
        return;
      }
      try {
        localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          savedAt: Date.now(),
          form: this.form
        }));
        this.draftHint = '已自动暂存';
      } catch (e) {}
    },
    restoreDraft: function restoreDraft() {
      var key = this.draftStorageKey();
      if (!key) {
        return false;
      }
      var raw = null;
      try {
        raw = localStorage.getItem(key);
      } catch (e) {
        return false;
      }
      if (!raw) {
        return false;
      }
      var parsed = null;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        return false;
      }
      if (!parsed || !parsed.form || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(parsed.form) !== 'object') {
        return false;
      }
      var f = parsed.form;
      this.restoringDraft = true;
      this.form = {
        classLink: f.classLink || '',
        attachments: Array.isArray(f.attachments) ? f.attachments : [],
        personalSituation: f.personalSituation || '',
        workSituation: f.workSituation || '',
        probationSalary: f.probationSalary || '',
        regularSalary: f.regularSalary || '',
        demoStrengths: f.demoStrengths || '',
        demoWeaknesses: f.demoWeaknesses || '',
        demoScores: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__recruitConst__["i" /* emptyScores */])(), this.normalizeScores(f.demoScores || {})),
        demoRemarks: f.demoRemarks || ''
      };
      this.draftHint = '已恢复未保存草稿';
      var self = this;
      this.$nextTick(function () {
        self.restoringDraft = false;
      });
      return true;
    },
    clearDraft: function clearDraft() {
      var key = this.draftStorageKey();
      if (!key) {
        return;
      }
      try {
        localStorage.removeItem(key);
      } catch (e) {}
      this.draftHint = '';
    },
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.close();
      }
    },
    close: function close() {
      if (this.draftTimer) {
        clearTimeout(this.draftTimer);
        this.draftTimer = null;
        if (this.value && !this.saving) {
          this.persistDraft();
        }
      }
      this.$emit('input', false);
    },
    buildUploadHeaders: function buildUploadHeaders() {
      var headers = { token: this.$store.get('token') };
      if (this.$store.get('account') && this.$store.get('password')) {
        headers.account = this.$store.get('account');
        headers.password = this.$store.get('password');
      }
      return headers;
    },
    beforeUpload: function beforeUpload() {
      this.uploadingCount++;
      this.uploading = true;
      return true;
    },
    finishOneUpload: function finishOneUpload() {
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);
      this.uploading = this.uploadingCount > 0;
    },
    uploadSuccess: function uploadSuccess(res, file) {
      this.finishOneUpload();
      if (!res || res.status !== 'ok' || !res.data || !res.data.url) {
        this.$Message.error(res && res.msg || '「' + file.name + '」上传失败');
        return;
      }
      this.form.attachments.push({
        name: res.data.fileName || file.name || res.data.name,
        url: res.data.url,
        size: res.data.size || file.size || 0
      });
    },
    uploadError: function uploadError(error, file) {
      this.finishOneUpload();
      this.$Message.error('「' + (file && file.name || '') + '」上传失败：' + (error && error.message || '网络错误'));
    },
    exceededSize: function exceededSize(file) {
      this.$Message.error('「' + file.name + '」超过 100MB');
    },
    collectPasteFiles: function collectPasteFiles(clipboardData) {
      var files = [];
      if (!clipboardData) {
        return files;
      }
      if (clipboardData.files && clipboardData.files.length) {
        for (var i = 0; i < clipboardData.files.length; i++) {
          if (clipboardData.files[i]) {
            files.push(clipboardData.files[i]);
          }
        }
        return files;
      }
      var items = clipboardData.items;
      if (!items) {
        return files;
      }
      for (var _i = 0; _i < items.length; _i++) {
        var item = items[_i];
        if (item && item.kind === 'file') {
          var f = item.getAsFile();
          if (f) {
            files.push(f);
          }
        }
      }
      return files;
    },
    onPaste: function onPaste(e) {
      var files = this.collectPasteFiles(e && e.clipboardData);
      if (!files.length) {
        return;
      }
      e.preventDefault();
      this.uploadPastedFiles(files);
    },
    uploadPastedFiles: function uploadPastedFiles(files) {
      var upload = this.$refs.attachUpload;
      if (!upload || !files || !files.length) {
        return;
      }
      this.uploadHeaders = this.buildUploadHeaders();
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (!file) {
          continue;
        }
        if (file.size > MAX_SIZE_BYTES) {
          this.$Message.error('「' + (file.name || '粘贴文件') + '」超过 100MB');
          continue;
        }
        if (typeof upload.post === 'function') {
          upload.post(file);
        }
      }
    },
    removeAttachment: function removeAttachment(index) {
      this.form.attachments.splice(index, 1);
    },
    formatSize: function formatSize(bytes) {
      var n = Number(bytes) || 0;
      if (n < 1024) {
        return n + ' B';
      }
      if (n < 1024 * 1024) {
        return (n / 1024).toFixed(1) + ' KB';
      }
      return (n / (1024 * 1024)).toFixed(1) + ' MB';
    },
    save: function save() {
      var _this2 = this;

      if (!this.row) {
        return;
      }
      var f = this.form;
      var params = {
        tchId: this.row.tchId,
        classLink: (f.classLink || '').trim(),
        attachments: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(f.attachments || []),
        personalSituation: f.personalSituation,
        workSituation: f.workSituation,
        probationSalary: f.probationSalary,
        regularSalary: f.regularSalary,
        demoStrengths: f.demoStrengths,
        demoWeaknesses: f.demoWeaknesses,
        demoScores: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(f.demoScores || {}),
        demoRemarks: f.demoRemarks
      };
      this.saving = true;
      this.$http.post('/tchRecruit/interview/note-save', params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this2.clearDraft();
          _this2.$Message.success('已保存笔记');
          _this2.close();
          _this2.$emit('on-success');
        } else {
          _this2.$Message.error(res && res.msg || '保存失败');
        }
      }).catch(function () {}).finally(function () {
        _this2.saving = false;
      });
    }
  }
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecruitReasonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '填写理由'
    },
    label: {
      type: String,
      default: '理由'
    },
    desc: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请填写理由'
    },
    initReason: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    kindOptions: {
      type: Array,
      default: null
    },
    kindLabel: {
      type: String,
      default: '类型'
    },
    kindPlaceholder: {
      type: String,
      default: '请选择'
    },
    initKind: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      reason: '',
      kind: ''
    };
  },

  watch: {
    value: function value(val) {
      if (val) {
        this.reason = this.initReason || '';
        this.kind = this.initKind || '';
      }
    }
  },
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.close();
      }
    },
    close: function close() {
      this.$emit('input', false);
    },
    ok: function ok() {
      if (this.kindOptions && this.kindOptions.length && !this.kind) {
        this.$Message.error('请选择' + this.kindLabel);
        return;
      }
      var reason = (this.reason || '').trim();
      if (!reason) {
        this.$Message.error('请填写' + this.label);
        return;
      }
      this.$emit('on-ok', reason, this.kind || '');
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recruitConst__ = __webpack_require__(59);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecruitReviewModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'review'
    }
  },
  data: function data() {
    return {
      grades: __WEBPACK_IMPORTED_MODULE_0__recruitConst__["h" /* GRADES */],
      decision: 'pass',
      grade: 'B',
      remark: '',
      loading: false
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__recruitConst__["a" /* tchName */])(this.row);
      return (this.mode === 'review' ? '复审' : '复审结果') + (name ? ' - ' + name : '');
    },
    statusText: function statusText() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__recruitConst__["e" /* findStatus */])(__WEBPACK_IMPORTED_MODULE_0__recruitConst__["c" /* REVIEW_STATUS */], this.row && this.row.reviewStatus, 'submit').text;
    },
    decisionText: function decisionText() {
      var status = this.row && this.row.reviewStatus;
      if (status === 'approved') {
        return '通过';
      }
      if (status === 'rejected') {
        return '不通过';
      }
      return '—';
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.decision = 'pass';
        this.grade = 'B';
        this.remark = '';
        this.loading = false;
      }
    }
  },
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.close();
      }
    },
    close: function close() {
      this.$emit('input', false);
    },
    submit: function submit() {
      var _this = this;

      if (!this.row) {
        return;
      }
      if (!this.grade) {
        this.$Message.error('请选择定级');
        return;
      }
      var params = {
        tchId: this.row.tchId,
        decision: this.decision,
        grade: this.grade,
        remark: (this.remark || '').trim()
      };
      this.loading = true;
      this.$http.post('/tchRecruit/interview/review', params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this.$Message.success('复审结果已提交');
          _this.close();
          _this.$emit('on-success');
        } else {
          _this.$Message.error(res && res.msg || '复审失败');
        }
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recruitConst__ = __webpack_require__(59);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecruitScheduleModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    },
    kind: {
      type: String,
      default: 'both'
    }
  },
  data: function data() {
    return {
      useInterview: true,
      useDemo: true,
      interviewTime: '',
      demoTime: '',
      loading: false
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__recruitConst__["a" /* tchName */])(this.row);
      return '安排面试/试讲' + (name ? ' - ' + name : '');
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        var row = this.row || {};
        this.useInterview = this.kind === 'interview' || this.kind === 'both';
        this.useDemo = this.kind === 'demo' || this.kind === 'both';
        this.interviewTime = row.interviewTime || '';
        this.demoTime = row.demoTime || '';
        this.loading = false;
      }
    }
  },
  methods: {
    onVisibleChange: function onVisibleChange(val) {
      if (!val) {
        this.close();
      }
    },
    close: function close() {
      this.$emit('input', false);
    },
    ok: function ok() {
      var _this = this;

      if (!this.row) {
        return;
      }
      if (!this.useInterview && !this.useDemo) {
        this.$Message.error('请至少选择「面试」或「试讲」');
        return;
      }
      if (this.useInterview && !this.interviewTime) {
        this.$Message.error('请选择面试时间');
        return;
      }
      if (this.useDemo && !this.demoTime) {
        this.$Message.error('请选择试讲时间');
        return;
      }
      var params = { tchId: this.row.tchId };
      if (this.useInterview) {
        params.interviewTime = this.interviewTime;
      }
      if (this.useDemo) {
        params.demoTime = this.demoTime;
      }
      this.loading = true;
      this.$http.post('/tchRecruit/interview/schedule', params, { silent: true }).then(function (res) {
        if (res && res.status === 'ok') {
          _this.$Message.success('已安排');
          _this.close();
          _this.$emit('on-success');
        } else {
          _this.$Message.error(res && res.msg || '安排失败');
        }
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default.a, ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      showImgModal: false,
      showImgList: [],
      reload: 0,
      editUser: false,
      uid: null,
      queryParam: {
        uid: '',
        mobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        type: '',
        tchId: null,
        subType: null,
        auditorName: '',
        studyAdviserId: null
      },
      title: [{
        title: '学生ID/姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '参与凭证',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          if (row.pic) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看凭证');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '活动类型',
        align: 'center',

        render: function render(h, params) {
          var type = params.row.type;
          var text = '未知活动';
          if (type == 1) {
            text = '朋友圈';
          }
          return h('div', text);
        }
      }, {
        title: '赠送课时',
        align: 'center',

        key: 'activity'
      }, {
        title: '申请人',

        align: 'center',
        key: 'userNickname'
      }, {
        title: '学导ID/姓名',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserId + '-' + row.studyAdviserName);
        }
      }, {
        title: '参与时间',

        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '状态',
        align: 'center',

        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核人',

        align: 'center',
        key: 'auNickname'
      }, {
        title: '审核时间',
        align: 'center',
        key: 'auditorTime'
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          var status = params.row.status;
          if (status === 0) {
            return h('div', [h('a', { on: { click: function click() {
                  _this.onPass(params.row);
                } } }, '通过'), h('span', { class: 'divider' }), h('a', { on: { click: function click() {
                  _this.onReject(params.row);
                } } }, '拒绝')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/ActivityExamineList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookCourseChange/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '补课时记录.csv';
        link.click();
        _this2.exportLoading = false;
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onPass: function onPass(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>通过</b> 此次申请？',
        width: 300,
        okText: '确定通过',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/activityExamine/pass', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('提交成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    onReject: function onReject(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>拒绝</b> 此次申请？',
        width: 300,
        okText: '确定拒绝',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/activityExamine/reject', { id: row.id }).then(function (res) {
            self.search();
            self.$Message.success('提交成功!');
            self.$Modal.remove();
          });
        }
      });
    }
  }
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextHandler: [],
      uidReadonly: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        teacherReason: '0',
        equipmentReason: '0',
        netReason: '0',
        highPrice: '0',
        registerOtherAgencies: '0',
        likeShortTermCourse: '0',
        contrastiveCompetition: '0',
        inThinking: '0',
        childNotCooperate: '0',
        worryEffect: '0',
        lossOfUnion: '0',
        specialRemark: ''
      },
      ruleValidate: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    this.getUserInfo();
  },

  methods: {
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
      console.log(this.formValidate.nextHandlerTime);
    },
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formValidate.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formValidate.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formValidate.nickname = user.nickname;
        self.formValidate.adviserName = user.adviserName;
        self.formValidate.studyAdviserName = user.studyAdviserName;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/buyFail', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.$router.push('/user/userTrackList');
          }
        });
      });
    },
    onChange: function onChange() {
      var arr = [];
      if (this.formValidate.teacherReason === '1') {
        arr.push('老师原因');
        arr.push('、');
      }
      if (this.formValidate.equipmentReason === '1') {
        arr.push('设备原因');
        arr.push('、');
      }
      if (this.formValidate.netReason === '1') {
        arr.push('网络原因');
        arr.push('、');
      }
      if (this.formValidate.highPrice === '1') {
        arr.push('价格偏高');
        arr.push('、');
      }
      if (this.formValidate.registerOtherAgencies === '1') {
        arr.push('已报名其它机构');
        arr.push('、');
      }
      if (this.formValidate.likeShortTermCourse === '1') {
        arr.push('意向短期课程');
        arr.push('、');
      }
      if (this.formValidate.contrastiveCompetition === '1') {
        arr.push('对比竞品');
        arr.push('、');
      }
      if (this.formValidate.inThinking === '1') {
        arr.push('考虑中');
        arr.push('、');
      }
      if (this.formValidate.childNotCooperate === '1') {
        arr.push('孩子不配合');
        arr.push('、');
      }
      if (this.formValidate.worryEffect === '1') {
        arr.push('担心效果');
        arr.push('、');
      }
      if (this.formValidate.lossOfUnion === '1') {
        arr.push('学员失联');
        arr.push('、');
      }

      arr.splice(-1, 1, ' ');

      if (this.formValidate.specialRemark) {
        arr.push('备注：');
        arr.push(this.formValidate.specialRemark);
      }

      this.formValidate.content = arr.join(' ');
    }
  },
  watch: {}
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextHandler: [],
      uidReadonly: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        bookMaterialLevel: [],
        address: '',
        fundPackageId: null
      },
      ruleValidate: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }],
        bookMaterialLevel: [{ type: 'array', required: true, message: '请选择教材', trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '地址不能超过200个字', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    var formValidate = this.formValidate;
    formValidate.uid = this.$route.query.row.uid;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    this.getUserInfo();
    this.getFundPackageData();
  },

  methods: {
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
      console.log(this.formValidate.nextHandlerTime);
    },
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formValidate.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formValidate.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formValidate.nickname = user.nickname;
        self.formValidate.adviserName = user.adviserName;
        self.formValidate.studyAdviserName = user.studyAdviserName;
      });
    },
    getFundPackageData: function getFundPackageData() {
      var self = this;
      if (!self.formValidate.uid) {
        return;
      }
      self.$http.post('/fundPackage/list', { 'uid': self.formValidate.uid, 'pageIndex': 1, 'pageSize': 1 }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var fundPackageData = res.data.data[0];
        self.formValidate.address = fundPackageData.address;
        self.formValidate.bookMaterialLevel = fundPackageData.bookMaterialLevel;
        self.formValidate.fundPackageId = fundPackageData.id;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/addSendMaterialRecords', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.$router.push('/user/userTrackList');
          }
        });
      });
    },
    allClear: function allClear() {
      this.formValidate.bookMaterialLevel = [];
    }
  },
  watch: {}
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAdvierModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    },

    restrictToSelf: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAssignAdviser: false,
      adviserParam: {
        adviserId: ''
      },
      adviserRule: {
        adviserId: [{ type: 'integer', required: true, message: '请选择课程顾问', trigger: 'blur' }]
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      self.$refs.assignAdviserForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.userList.map(function (element) {
          if (element.uid) {
            return element.uid;
          }
          return element.id;
        });
        self.loadingAssignAdviser = true;
        var params = { ids: idList.join(','), adviserId: self.adviserParam.adviserId, resourceStatus: 1 };
        self.$http.get('/user/updateAdviser', { params: params }).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback();
            self.visible = false;
          }
          self.loadingAssignAdviser = false;
        }).catch(function (e) {
          self.visible = false;
          self.loadingAssignAdviser = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.adviserParam.adviserId = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BannedUserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingBannedUser: false
    };
  },

  methods: {
    bannedUser: function bannedUser() {
      var self = this;

      var idList = self.userList.map(function (element) {
        if (element.uid) {
          return element.uid;
        }
        return element.id;
      });
      self.loadingBannedUser = true;
      var params = { ids: idList.join(',') };
      self.$http.get('/user/banned', { params: params }).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingBannedUser = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingBannedUser = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BatchCompletedCoursesModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uidStr: {
      type: String,
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      completedTypeList: [{ code: 1, text: '无购课记录或无有效订单' }, { code: 2, text: '课程有效期已到期' }, { code: 3, text: '课时已完结' }],
      visible: this.value,
      loadingBatchCompletedCourses: false,
      batchCompletedCoursesParam: {
        uIds: '',
        completedType: 0
      }
    };
  },

  methods: {
    batchCompletedCourses: function batchCompletedCourses() {
      var self = this;

      self.loadingBatchCompletedCourses = true;
      self.$http.post('/user/overClass/batch', this.batchCompletedCoursesParam).then(function (res) {
        if (res && res.data === 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingBatchCompletedCourses = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingBatchCompletedCourses = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.batchCompletedCoursesParam.uIds = '';
        this.batchCompletedCoursesParam.completedType = 0;
      } else {
        this.batchCompletedCoursesParam.uIds = this.uidStr;
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BatchCourseChangeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      courseTypeList: [{ code: 1, text: '外教课' }, { code: 2, text: '中教课' }, { code: 8, text: '陪练课' }],
      visible: this.value,
      loadingBatchCourseChange: false,
      BatchCourseChangeParam: {
        uIds: '',
        courseType: 0,
        memo: ''
      }
    };
  },

  methods: {
    BatchCourseChange: function BatchCourseChange() {
      var self = this;

      self.loadingBatchCourseChange = true;
      self.$http.post('/bookCourseChange/batch-add', this.BatchCourseChangeParam).then(function (res) {
        if (res && res.data === 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingBatchCourseChange = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingBatchCourseChange = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.BatchCourseChangeParam.uIds = '';
        this.BatchCourseChangeParam.courseType = 0;
        this.BatchCourseChangeParam.memo = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BatchMoveUserModal',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingBatchMoveUser: false
    };
  },

  methods: {
    batchMoveUser: function batchMoveUser() {
      var self = this;
      var idList = self.userList.map(function (element) {
        if (element.uid) {
          return element.uid;
        }
        return element.id;
      });
      self.loadingBatchMoveUser = true;
      self.$http.post('/userList/crmResourceUpdate/batch', { ids: idList.join(',') }).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingBatchMoveUser = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingBatchMoveUser = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rankScoreSeq: 0,
      uid: '',
      scanLoading: false,
      fixLoading: false,
      result: {},
      rows: [],
      columns: [{ title: '学生ID', key: 'uid', width: 100 }, { title: '课ID', key: 'openedId', width: 100 }, { title: '星期', key: 'week', width: 70 }, { title: '开始时间', key: 'startTime', width: 90 }, {
        title: '老师ID',
        key: 'tchId',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId,
            score: row.monthRankScore
          });
        }
      }, { title: '开课时间', key: 'lsnBeginText', width: 160 }, { title: '绑定等级', key: 'bindLevelId', width: 90 }, { title: '当前课件', key: 'oldLessonId', width: 90 }, { title: '应为课件', key: 'newLessonId', width: 90 }, { title: '已修复', key: 'fixedText', width: 80 }, { title: '跳过', key: 'skipReason', width: 100 }]
    };
  },

  computed: {
    canFix: function canFix() {
      return !this.scanLoading && !this.fixLoading && (this.result.wrongCount || 0) > 0;
    }
  },
  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.rows;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    formatTime: function formatTime(sec) {
      if (!sec) {
        return '';
      }
      var d = new Date(sec * 1000);
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    flatten: function flatten(data) {
      var rows = [];
      var students = data && data.students || [];
      students.forEach(function (s) {
        (s.items || []).forEach(function (it) {
          rows.push({
            uid: it.uid,
            openedId: it.openedId,
            week: it.week,
            startTime: it.startTime,
            tchId: it.tchId,
            lsnBeginText: this.formatTime(it.lsnBeginTime),
            bindLevelId: it.bindLevelId,
            oldLessonId: it.oldLessonId,
            newLessonId: it.newLessonId,
            fixedText: it.fixed ? '是' : '否',
            skipReason: it.skipReason || ''
          });
        }.bind(this));
      }.bind(this));
      return rows;
    },
    request: function request(fix) {
      var self = this;
      var params = { fix: fix };
      if (self.uid && String(self.uid).trim() !== '') {
        params.uid = String(self.uid).trim();
      }
      return self.$http.get('/user/lesson/scanBindGroupLesson', { params: params });
    },
    scan: function scan(fix) {
      var self = this;
      if (fix) {
        self.fixLoading = true;
      } else {
        self.scanLoading = true;
      }
      self.request(fix).then(function (res) {
        self.scanLoading = false;
        self.fixLoading = false;
        if (!res || res.status !== 'ok') {
          return;
        }
        self.result = res.data || {};
        self.rows = self.flatten(self.result);
        self.loadMonthRankScores();
        if (!fix) {
          if ((self.result.wrongCount || 0) === 0) {
            self.$Message.success('未发现需要修复的课件');
          } else {
            self.$Message.success('查出 ' + self.result.wrongCount + ' 节错课，确认后可一键修复');
          }
        } else {
          self.$Message.success('已修复 ' + (self.result.fixedCount || 0) + ' 节');
        }
      }).catch(function () {
        self.scanLoading = false;
        self.fixLoading = false;
      });
    },
    confirmFix: function confirmFix() {
      var self = this;
      self.$Modal.confirm({
        title: '确认一键修复',
        content: '将按检查结果改 ' + (self.result.wrongCount || 0) + ' 节未来已选课件，不可撤销。只处理 stars>1 的学生。',
        width: 420,
        okText: '确认修复',
        onOk: function onOk() {
          self.scan(true);
        }
      });
    }
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: '',
      tableLoading: false,
      saveLoading: false,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      levelOptions: [],
      rows: []
    };
  },
  mounted: function mounted() {
    this.loadLevels();
    this.loadList();
  },

  methods: {
    loadLevels: function loadLevels() {
      var self = this;
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || res.status !== 'ok') {
          return;
        }
        self.levelOptions = res.data || [];
      });
    },
    search: function search() {
      this.pageIndex = 1;
      this.loadList();
    },
    onPageChange: function onPageChange(page) {
      this.pageIndex = page;
      this.loadList();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.loadList();
    },
    loadList: function loadList() {
      var self = this;
      self.tableLoading = true;
      var params = {
        pageIndex: self.pageIndex,
        pageSize: self.pageSize
      };
      if (self.uid && String(self.uid).trim() !== '') {
        params.uid = String(self.uid).trim();
      }
      self.$http.get('/user/lesson/listBindGroupLevel', { params: params }).then(function (res) {
        self.tableLoading = false;
        if (!res || res.status !== 'ok') {
          return;
        }
        var page = res.data || {};
        self.totalCount = page.totalCount || 0;
        self.rows = self.flatten(page.data || []);
      }).catch(function () {
        self.tableLoading = false;
      });
    },
    flatten: function flatten(students) {
      var rows = [];
      students.forEach(function (s) {
        var binds = s.binds && s.binds.length ? s.binds : [{}];
        binds.forEach(function (b, i) {
          rows.push({
            rowKey: s.uid + '-' + (b.bindId || 'empty') + '-' + i,
            uid: s.uid,
            nickname: s.nickname,
            bindId: b.bindId,
            tchTime: formatTchTime(b),
            levelId: b.levelId,
            savedLevelId: b.levelId,
            rowSpan: i === 0 ? binds.length : 0
          });
        });
      });
      return rows;
    },
    onLevelChange: function onLevelChange(row, levelId) {
      var self = this;
      if (!row.bindId || levelId == null || levelId === row.savedLevelId) {
        return;
      }
      if (self.saveLoading) {
        row.levelId = row.savedLevelId;
        return;
      }
      self.saveLoading = true;
      self.$http.post('/user/lesson/updateBindGroupLevel', {
        bindId: row.bindId,
        levelId: levelId
      }).then(function (res) {
        self.saveLoading = false;
        if (!res || res.status !== 'ok') {
          row.levelId = row.savedLevelId;
          return;
        }
        row.savedLevelId = levelId;
        self.$Message.success('已改绑定level');
      }).catch(function () {
        self.saveLoading = false;
        row.levelId = row.savedLevelId;
      });
    }
  }
});

function formatTchTime(b) {
  if (!b || !b.bindId) {
    return '无绑定';
  }
  var week = b.weekName || '';
  var time = b.startTimeStr || '';
  if (time && time.length >= 5) {
    time = time.substring(0, 5);
  }
  var tch = (b.tchId || '') + (b.tchName ? '-' + b.tchName : '');
  return [week, time, tch].filter(function (v) {
    return v;
  }).join(' ');
}

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        operator: '',
        startTime: '',
        endTime: '',
        startTimeDate: '',
        endTimeDate: '',
        tchId: '',
        tchName: '',
        userId: '',
        userName: '',
        operation: '',
        delReason: ''
      },
      title: [{
        title: '学生ID/姓名',
        align: 'center',
        width: 200,
        render: function render(h, params) {
          var row = params.row;
          if (!row.groupHead) {
            return h('span', '');
          }
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.stdName)]);
        }
      }, {
        title: '操作人',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          if (!params.row.groupHead) {
            return h('span', '');
          }
          return h('span', params.row.creatorName);
        }
      }, {
        title: '操作时间',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          if (!params.row.groupHead) {
            return h('span', '');
          }
          return h('span', params.row.gmtCreate);
        }
      }, {
        title: '绑定内容',
        width: 380,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var startTime = $moment.unix(row.startTime).utc().format('HH:mm');
          var children = [h('span', { style: { color: '#2d8cf0' } }, row.tchId + '-' + row.tchName), h('span', ' [' + $constant.weekZh[row.week] + startTime + ']')];
          if (row.delReasonText) {
            children.push(h('span', ' ' + row.delReasonText));
          }
          return h('div', { style: { 'font-size': '12px' } }, children);
        }
      }, {
        title: '绑定/解绑',
        align: 'center',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          var text = row.status === 1 ? '绑定' : '解绑';
          var color = row.status === 1 ? '#19be6b' : '#ed4014';
          return h('span', {
            style: {
              color: color
            }
          }, text);
        }
      }, {
        title: '操作说明',
        align: 'center',
        width: 260,
        key: 'remark'
      }]
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var body = _this.$el.querySelector('.ivu-table-body');
      if (!body) {
        return;
      }
      _this.tableObserver = new MutationObserver(function () {
        _this.mergeGroupCells();
      });
      _this.tableObserver.observe(body, { childList: true, subtree: true });
      _this.mergeGroupCells();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.tableObserver) {
      this.tableObserver.disconnect();
    }
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/operation-log/export/user-bind-teacher', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '绑定老师记录.xlsx';
          link.click();
          _this2.$Message.success('导出成功');
        } else {
          _this2.$Message.error(response.msg || '导出失败');
        }
        _this2.exportLoading = false;
      }).catch(function (error) {
        _this2.$Message.error('导出失败：' + error.message);
        _this2.exportLoading = false;
      });
    },
    atimeDateChange: function atimeDateChange(value) {
      this.queryParam.startDate = value[0];
      this.queryParam.endDate = value[1];
    },
    rowClass: function rowClass(row) {
      var cls = row.groupSeq % 2 === 1 ? 'op-group-odd' : 'op-group-even';
      if (row.groupHead) {
        cls += ' op-group-head';
      }
      return cls;
    },
    mergeGroupCells: function mergeGroupCells() {
      if (this.merging) {
        return;
      }
      var body = this.$el.querySelector('.ivu-table-body tbody');
      if (!body) {
        return;
      }
      var rows = Array.prototype.filter.call(body.children, function (tr) {
        return tr.classList.contains('ivu-table-row');
      });
      if (!rows.length) {
        return;
      }
      var already = rows.some(function (tr) {
        return !tr.classList.contains('op-group-head') && tr.children.length < 6;
      });
      if (already) {
        return;
      }
      this.merging = true;
      var i = 0;
      while (i < rows.length) {
        var j = i + 1;
        while (j < rows.length && !rows[j].classList.contains('op-group-head')) {
          j++;
        }
        var span = j - i;
        if (span > 1) {
          for (var c = 0; c < 3; c++) {
            rows[i].children[c].rowSpan = span;
            rows[i].children[c].style.verticalAlign = 'middle';
          }
          for (var r = i + 1; r < j; r++) {
            for (var _c = 0; _c < 3; _c++) {
              rows[r].removeChild(rows[r].children[0]);
            }
          }
        }
        i = j;
      }
      this.merging = false;
    }
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      nextHandler: [],
      uidReadonly: false,
      formData: {
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0'
      },
      formRules: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    var formData = this.formData;
    formData.uid = this.$route.query.row.uid;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    this.getUserInfo();
  },

  methods: {
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formData.nextHandlerTime = value;
    },
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formData.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formData.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formData.nickname = user.nickname;
        self.formData.adviserName = user.adviserName;
        self.formData.studyAdviserName = user.studyAdviserName;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/bindingValidTimeFail', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.$router.push('/user/userTrackList');
          }
        });
      });
    },
    allClear: function allClear() {
      this.formData.bookMaterialLevel = [];
    }
  },
  watch: {}
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserClassHourModal_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BatchCourseChangeModal_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BatchCourseChangeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BatchCourseChangeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tchScore__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BatchCourseChangeModal: __WEBPACK_IMPORTED_MODULE_3__BatchCourseChangeModal_vue___default.a,
    UserClassHourModal: __WEBPACK_IMPORTED_MODULE_2__UserClassHourModal_vue___default.a,
    ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_1__order_ShowImageCarousel___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      rejectLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      editUser: false,
      uid: null,
      selectionUser: [],
      showImgList: [],
      givingTypeChild: [],
      showImgModal: false,
      showUserClassHourModal: false,
      showBatchCourseChangeModal: false,
      showRejectModal: false,
      rejectParam: {
        id: null,
        memo: ''
      },
      rejectRule: {
        memo: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
      },
      queryParam: {
        uid: '',
        userMobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        givingType: '',
        givingTypeChild: '',
        tchId: null,
        subType: null,
        checkAdmin: '',
        courseType: null,
        applyDepartment: ''
      },

      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生ID/姓名',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '课程类别',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          var typeEnum = $constant.getEnum($constant.courseType, courseType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '申请类型',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var type = params.row.type;
          var typeEnum = $constant.getEnum($constant.addSubType, type);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '加减课时',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var type = params.row.type;
          var num = 0;
          if (type === 1 || type === 2) {
            num = type === 2 ? -params.row.num : params.row.num;
          }
          return h('span', num);
        }
      }, {
        title: '加减请假次数',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var type = params.row.type;
          var num = 0;
          if (type === 3 || type === 4) {
            num = type === 4 ? -params.row.num : params.row.num;
          }
          return h('span', num);
        }
      }, {
        title: '加减补课次数',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var type = params.row.type;
          var num = 0;
          if (type === 5 || type === 6) {
            num = type === 6 ? -params.row.num : params.row.num;
          }
          return h('span', num);
        }
      }, {
        title: '一级类型',
        key: 'givingType',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var givingType = params.row.givingType;
          var givingTypeEnum = $constant.getEnum($constant.givingTypeEnum, givingType);
          return h('span', givingTypeEnum && givingTypeEnum.text);
        }
      }, {
        title: '二级类型',
        key: 'givingTypeChild',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var givingTypeChild = params.row.givingTypeChild;
          var givingTypeChildEnum = $constant.getEnum($constant.givingTypeChildEnum, givingTypeChild);
          return h('span', givingTypeChildEnum && givingTypeChildEnum.text);
        }
      }, {
        title: '申请时间',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '凭证',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.url) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '审核人',
        key: 'checkAdmin',
        width: 100,
        align: 'center'
      }, {
        title: '审核时间',
        key: 'checkTime',
        width: 110,
        align: 'center'
      }, {
        title: '原因',
        key: 'reason',
        width: 300,
        align: 'center'
      }, {
        title: '申请人',
        key: 'adminNickname',
        width: 100,
        align: 'center'
      }, {
        title: '老师',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId ? row.tchId + '-' + row.tchName : '',
            score: row.monthRankScore
          });
        }
      }, {
        title: '外教运营',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.foreignOperations ? params.row.foreignOperations : '');
        }
      }, {
        title: '备注/拒绝原因',
        width: 180,
        key: 'memo',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        width: 110,
        render: function render(h, params) {
          var status = params.row.status;
          if (status === 0 || status === 3) {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.onPass(params.row);
                }
              }
            }, '通过'), h('span', { class: 'divider' }), h('a', {
              on: {
                click: function click() {
                  _this.onReject(params.row);
                }
              }
            }, '拒绝')]);
          }
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-3, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookCourseChangeList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    changeGivingType: function changeGivingType(val) {
      var self = this;
      if (val === 1) {
        self.givingTypeChild = [];
      } else if (val === 2) {
        self.givingTypeChild = [{ code: 10, text: '转介绍成功购课' }, { code: 11, text: '邀请好友试听成功' }];
      } else if (val === 3) {
        self.givingTypeChild = [{ code: 8, text: '特殊请假' }, { code: 9, text: '家长态度强硬非要返还课时' }];
      } else if (val === 4) {
        self.givingTypeChild = [];
      } else if (val === 5) {
        self.givingTypeChild = [{ code: 1, text: '课件编辑错' }];
      } else if (val === 6) {
        self.givingTypeChild = [{ code: 2, text: '老师离职' }, { code: 3, text: '老师旷课' }, {
          code: 4,
          text: '老师迟到10分钟以及以上'
        }, { code: 5, text: '老师网络原因不能上课' }];
      } else if (val === 7) {
        self.givingTypeChild = [{ code: 6, text: '教材不顺延' }, { code: 7, text: '课件排错' }];
      } else if (val === 8) {
        self.givingTypeChild = [];
      } else if (val === 9) {
        self.givingTypeChild = [];
      }
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookCourseChange/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = window.URL.createObjectURL(blob);
        link.download = '补课时记录.csv';
        link.click();
        _this2.exportLoading = false;
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    isAutoInviteGift: function isAutoInviteGift(row) {
      return (/^被邀请人【\d+】上满一个月转介绍自动赠课$/.test(row && row.reason || '')
      );
    },
    blockManualInviteGift: function blockManualInviteGift(rows) {
      var list = rows || [];
      for (var i = 0; i < list.length; i++) {
        if (this.isAutoInviteGift(list[i])) {
          this.$Message.warning('不需要人工操作');
          return true;
        }
      }
      return false;
    },
    onPass: function onPass(row) {
      if (this.blockManualInviteGift([row])) {
        return;
      }
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>通过</b> 此次申请？',
        width: 300,
        okText: '确定通过',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookCourseChange/pass', { id: row.id }).then(function (res) {
            self.search();
            if (res && res.data == -1) {
              self.$Message.success('进入复审中!');
            } else {
              self.$Message.success('提交成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onReject: function onReject(row) {
      if (this.blockManualInviteGift([row])) {
        return;
      }
      this.rejectParam.id = row.id;
      this.rejectParam.memo = '';
      this.showRejectModal = true;
    },
    submitReject: function submitReject() {
      var _this3 = this;

      var self = this;
      this.$refs.rejectForm.validate(function (valid) {
        if (!valid) {
          _this3.$Message.warning('请填写拒绝原因');
          return;
        }
        self.rejectLoading = true;
        self.$http.post('/bookCourseChange/reject', {
          id: self.rejectParam.id,
          memo: self.rejectParam.memo
        }).then(function (res) {
          self.rejectLoading = false;
          self.showRejectModal = false;
          self.search();
          self.$Message.success('提交成功!');
        }).catch(function () {
          self.rejectLoading = false;
        });
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    batchPass: function batchPass() {
      var _this4 = this;

      if (this.blockManualInviteGift(this.selectionUser)) {
        return;
      }
      this.passLoading = true;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      }
      var self = this;
      this.$http.post('/bookCourseChange/batchReview', { ids: ids.join(','), status: 1 }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('批量通过成功！');
          self.passLoading = false;
          self.search();
        } else {
          self.$Message.error('批量通过失败！');
          self.passLoading = false;
        }
      }).catch(function (e) {
        _this4.passLoading = false;
      });
    },
    batchReject: function batchReject() {
      if (this.blockManualInviteGift(this.selectionUser)) {
        return;
      }
      this.rejectLoading = true;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      }
      var self = this;
      this.$http.post('/bookCourseChange/batchReview', { ids: ids.join(',') + '', status: 2, memo: this.rejectParam.memo }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('批量拒绝成功！');
          self.rejectLoading = false;
          self.search();
        } else {
          self.$Message.error('批量拒绝失败！');
          self.rejectLoading = false;
        }
      }).catch(function (e) {
        self.$Message.error('批量拒绝失败！');
        self.rejectLoading = false;
      });
    },
    openUserClassHourModal: function openUserClassHourModal() {
      this.showUserClassHourModal = true;
    },
    openBatchCourseChangeModal: function openBatchCourseChangeModal() {
      this.showBatchCourseChangeModal = true;
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookExchangeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingUpdate: false,
      param: {
        code: ''
      },
      bookExchangeRule: {
        code: [{ required: true, message: '请输入兑换码', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value.length === 0) {
              errors.push('不能为空');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    exchange: function exchange() {
      var self = this;
      self.loadingUpdate = true;
      if (!self.param.code) {
        self.$Message.warning('兑换码不能为空!');
        self.loadingUpdate = false;
      } else {
        self.param.uid = self.uid;
        self.$http.post('/book/exchange', self.param).then(function (res) {
          self.loadingUpdate = false;
          if (res) {
            self.visible = false;
            self.$Message.success('兑换成功!');
            self.successCallback();
          }
        });
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.param = {
        code: ''
      };
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_StudentSelect_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_StudentSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_StudentSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BannedUserModal_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BannedUserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BannedUserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_InsertUserModal_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_InsertUserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_InsertUserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_aiAccess__ = __webpack_require__(30);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    InsertUserModal: __WEBPACK_IMPORTED_MODULE_3__modal_InsertUserModal_vue___default.a,
    BannedUserModal: __WEBPACK_IMPORTED_MODULE_2__BannedUserModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default.a,
    StudentSelect: __WEBPACK_IMPORTED_MODULE_1__common_StudentSelect_vue___default.a,
    AiDrawer: __WEBPACK_IMPORTED_MODULE_4__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      editUser: false,
      uid: null,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      queryParam: {
        uid: null,
        stdTab: null,
        tchChannel: null,
        startTime: '',
        endTime: '',
        nickname: '',
        mobile: '',
        inviteId: null,
        referrerStudyAdviserName: '',
        regType: '',
        marketUserId: '',
        wechatAccount: '',
        remark: ''
      },
      showBannedUserModal: false,
      showInsertUserModal: false,
      selectionUser: [],
      startTimeDate: '',
      endTimeDate: '',
      isSynchronizeList: [{ code: 1, text: '成功' }, { code: 2, text: '手动同步' }, { code: 3, text: '失败' }, { code: 4, text: '未同步' }],
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: '学生ID',
        fixed: 'left',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.id);
        }
      }, {
        title: '昵称',
        width: 130,
        fixed: 'left',
        render: function render(h, params) {
          var nickName = params.row.nickname;
          var inviteId = params.row.inviteId;
          if (inviteId) {
            return h('span', [h('span', nickName), h('span', { style: { color: 'red' } }, '(推荐)')]);
          } else {
            return h('span', nickName);
          }
        }
      }, {
        title: '年龄',
        width: 70,
        key: 'age'
      }, {
        title: '微信号',
        width: 90,
        key: 'wechatAccount'
      }, {
        title: '手机号',
        align: 'center',
        width: 130,
        key: 'mobile',
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '创建时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '省',
        width: 80,
        align: 'center',
        key: 'province'
      }, {
        title: '市',
        width: 80,
        align: 'center',
        key: 'city'
      }, {
        title: '渠道',
        width: 110,
        align: 'center',
        key: 'regType'
      }, {
        title: '渠道来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.tchChannel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '归属活动',
        width: 110,
        align: 'center',
        key: 'stdTabText'
      }, {
        title: '链接来源',
        width: 150,
        align: 'center',
        key: 'ip'
      }, {
        title: '学生状态',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var stdStatus = params.row.stdStatus;
          var status = $constant.getEnum($constant.stdStatus, stdStatus);
          if (status) {
            return h('span', status.text);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '已试听',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var isAudition = params.row.isAudition;
          var audition = $constant.getEnum($constant.yesNoNum, isAudition);
          if (audition) {
            return h('span', audition.text);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '推荐人',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var referrerName = params.row.referrerName;
          var inviteId = params.row.inviteId;
          if (referrerName && inviteId) {
            return h('span', inviteId + '-' + referrerName);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '推荐人学导',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var referrerStudyAdviserName = params.row.referrerStudyAdviserName;
          var referrerStudyAdviserId = params.row.referrerStudyAdviserId;
          if (referrerStudyAdviserName && referrerStudyAdviserId) {
            return h('span', referrerStudyAdviserId + '-' + referrerStudyAdviserName);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '首次分配课程顾问',
        width: 150,
        align: 'center',
        key: 'firstAdviserName'
      }, {
        title: '最终归属课程顾问',
        width: 150,
        align: 'center',
        key: 'adviserName'
      }, {
        title: 'Follow Up',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var content = params.row.content;
          if (!content) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover',
              placement: 'top',
              transfer: true
            }
          }, [h('span', {
            style: {
              display: 'inline-block',
              width: '130px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              verticalAlign: 'middle'
            }
          }, content), h('div', {
            slot: 'content',
            style: {
              maxWidth: '360px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              textAlign: 'left'
            }
          }, content)]);
        }
      }, {
        title: '操作',
        width: 160,
        fixed: 'right',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return 'span', [h('a', { on: { click: function click() {
                return _this.showEditRegType(row);
              } } }, '编辑渠道'), h('br', '  '), h('a', { on: { click: function click() {
                return _this.showEditReferrer(row);
              } } }, '修改推荐人'), h('br', '  '), h('a', { on: { click: function click() {
                return _this.showEditFirstConsultant(row);
              } } }, '修改首次顾问'), _this.aiAllowed ? h('br', '  ') : null, _this.aiAllowed ? h('a', { on: { click: function click() {
                return _this.openAiDrawer(row.id);
              } } }, 'AI') : null];
        }
      }],
      regTypeForm: {
        id: '',
        regType: ''
      },
      referrerForm: {
        uid: null,
        inviteId: null,
        referrerName: ''
      },
      regTypeRule: {
        regType: [{ type: 'string', required: true, message: '渠道不能为空', trigger: 'blur' }]
      },
      firstConsultantForm: {
        adviserId: '',
        uid: 0
      },
      showEditRegTypeModal: false,
      loadingEditRegType: false,
      loadingEditReferrer: false,
      loadingEditFirstConsultant: false,
      showEditReferrerModal: false,
      showEditFirstConsultantModal: false,
      inviteName: ''
    };
  },

  mounted: function mounted() {},
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tools_aiAccess__["a" /* bindAiAllowed */])(this);
    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-1, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    onInsertUser: function onInsertUser() {
      this.showInsertUserModal = true;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookTestList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
      this.reload = new Date().getTime();
    },
    openAiDrawer: function openAiDrawer(id) {
      this.aiUid = id;
      this.aiVisible = true;
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
    },
    onAiExecuted: function onAiExecuted() {
      this.reload = new Date().getTime();
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    exportExcel: function exportExcel() {
      var self = this;
      self.exportLoading = true;
      self.$http.get('/bookTest/exportExcel', {
        responseType: 'arraybuffer',
        params: self.queryParam
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '学生体验名单.xls';
        link.click();
        self.exportLoading = false;
      }).catch(function (e) {
        self.exportLoading = false;
      });
    },
    bannedUser: function bannedUser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需封禁的学生！');
        return;
      }
      this.showBannedUserModal = true;
    },
    showEditRegType: function showEditRegType(row) {
      this.showEditRegTypeModal = true;
      this.regTypeForm.id = row.id;
      this.regTypeForm.regType = row.regType;
    },
    showEditReferrer: function showEditReferrer(row) {
      this.showEditReferrerModal = true;
      this.referrerForm.uid = row.id;
      this.referrerForm.inviteId = row.inviteId;
    },
    showEditFirstConsultant: function showEditFirstConsultant(row) {
      this.showEditFirstConsultantModal = true;
      this.firstConsultantForm.uid = row.id;
    },
    showIPBanned: function showIPBanned(row) {
      this.showEditFirstConsultantModal = true;
      this.firstConsultantForm.uid = row.id;
    },
    editRegType: function editRegType() {
      var self = this;
      self.loadingEditRegType = true;
      self.$refs.editRegType.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingEditRegType = false;
          return;
        }
        var params = {};
        params.id = self.regTypeForm.id;
        params.regType = self.regTypeForm.regType;
        self.$http.post('/bookTest/editRegType', params).then(function (res) {
          if (res && res.data > 0) {
            self.search();
            self.showEditRegTypeModal = false;
          }
          self.loadingEditRegType = false;
        }).catch(function (e) {
          self.showEditRegTypeModal = false;
          self.loadingEditRegType = false;
        });
      });
    },
    editReferrer: function editReferrer() {
      var self = this;
      self.loadingEditReferrer = true;
      var params = {};
      params.uid = self.referrerForm.uid;
      params.referrerId = self.referrerForm.inviteId;
      if (!params.uid || !params.referrerId) {
        self.$Message.warning('信息输入错误!');
        self.loadingEditReferrer = false;
        return;
      }
      self.$http.post('/user/editReferrer', params).then(function (res) {
        if (res && res.data > 0) {
          self.search();
          self.showEditReferrerModal = false;
        }
        self.loadingEditReferrer = false;
      }).catch(function (e) {
        self.showEditReferrerModal = false;
        self.loadingEditReferrer = false;
      });
      self.referrerForm = [];
      params = {};
    },
    editFirstConsultant: function editFirstConsultant() {
      var self = this;
      self.loadingEditFirstConsultant = true;

      self.$http.get('/userList/updateFirstAdviserId?uid=' + self.firstConsultantForm.uid + '&firstAdviserId=' + self.firstConsultantForm.adviserId).then(function (res) {
        if (res && res.status == "ok") {
          self.$Message.success('修改成功!');
          self.search();
          self.showEditFirstConsultantModal = false;
        }
        self.loadingEditFirstConsultant = false;
      }).catch(function (err) {
        self.$Message.error(err);
        self.showEditFirstConsultantModal = false;
        self.loadingEditFirstConsultant = false;
      });
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_1__crm_UserInfoModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var self = this;
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      editUser: false,
      uid: null,
      queryParam: {
        uid: '',
        userMobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        leaveType: null,
        status: '',
        adminUserId: ''
      },
      leaveTimeChangeParam: {
        startLeaveTimeDate: '',
        endLeaveTimeDate: '',
        startLeaveTime: 0,
        endLeaveTime: 0,
        endTime: 0,
        maxLeaveLessonTime: 0
      },
      modifyLeaveTimeRule: {
        endTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (!self.leaveTimeChangeParam.endTime) {
              errors.push('选择的时间不能为空！');
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime * 1000 < new Date().getTime()) {
              errors.push('所选时间不能小于当前时间！');
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime < self.leaveTimeChangeParam.maxLeaveLessonTime) {
              errors.push('所选时间不能小于：' + self.$moment(self.leaveTimeChangeParam.maxLeaveLessonTime, 'X').format('YYYY-MM-DD HH:mm'));
              callback(errors);
              return;
            }
            if (self.leaveTimeChangeParam.endTime > self.leaveTimeChangeParam.endLeaveTime) {
              errors.push('所选时间不能大于：' + self.$moment(self.leaveTimeChangeParam.endLeaveTime, 'X').format('YYYY-MM-DD HH:mm'));
              callback(errors);
              return;
            }
            callback(errors);
          }
        }]
      },
      title: [{
        title: '学生ID、姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {};
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } }, style: textStyle }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '手机号码',
        align: 'center',

        key: 'userMobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, params.row.userMobile.length === 11 ? params.row.userMobile.substring(0, 3) + '****' + params.row.userMobile.substring(7) : params.row.userMobile), h('div', { slot: 'content' }, params.row.userMobile)]);
        }
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 150,
        render: function render(h, params) {
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '涉及课节',
        align: 'center',

        render: function render(h, params) {
          return h('div', [h('a', { on: { click: function click() {
                _this.onBookLessonOpened(params.row);
              } } }, '查看')]);
        }
      }, {
        title: '操作人',

        align: 'center',
        key: 'adminNickname',
        render: function render(h, params) {
          var adminNickname = params.row.adminNickname;
          return h('div', adminNickname && adminNickname.trim() !== '' ? adminNickname : '学生本人');
        }
      }, {
        title: '请假类型',

        align: 'center',
        render: function render(h, params) {
          var leaveType = params.row.leaveType;
          var leaveTypeEnum = $constant.getEnum($constant.leaveType, leaveType);
          return h('div', leaveTypeEnum && leaveTypeEnum.text);
        }
      }, {
        title: '是否3小时前',

        align: 'center',
        render: function render(h, params) {
          var isSixHoursAgo = params.row.isSixHoursAgo;
          var isSixHoursAgoEnum = $constant.getEnum($constant.yesNoNum, isSixHoursAgo);
          return h('div', isSixHoursAgoEnum && isSixHoursAgoEnum.text);
        }
      }, {
        title: '操作时间',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var updateTime = params.row.updateTime;
          return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '请假原因',
        key: 'remark'
      }, {
        title: '状态',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.userLeaveStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          var status = params.row.status;
          var startTime = params.row.startTime;
          var endTime = params.row.endTime;
          var now = new Date().getTime();

          if (status === 1 && now / 1000 < startTime) {
            return h('div', [h('a', { on: { click: function click() {
                  _this.onCancel(params.row);
                } } }, '取消')]);
          }
          if (status === 1 && now / 1000 > startTime && now / 1000 < endTime) {
            return h('div', [h('a', { on: { click: function click() {
                  _this.onModify(params.row);
                } } }, '修改请假时间')]);
          }
        }
      }],
      showBookLessonOpenedModal: false,
      showModifyLeaveTimeModal: false,
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '手机号码',
        align: 'center',
        width: 100,
        key: 'userMobile'
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '学顾',
        width: 90,
        key: 'studyAdviserNickname'
      }, {
        title: '外教运营',
        width: 90,
        key: 'adviserNickname'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        key: 'lessonTitle',
        width: 100
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }],
      bookLessonOpenedList: []
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-6, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/bookUserLeaveTime/excel', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data && response.data.byteLength > 0) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '请假学生列表.xlsx';
          link.click();
          _this2.$Message.success('导出成功');
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg || '导出失败：未获取到数据');
          _this2.exportLoading = false;
        }
      }).catch(function (e) {
        console.log(e);
        _this2.$Message.error('导出失败：' + (e.message || '未知错误'));
        _this2.exportLoading = false;
      });
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    newEndLeaveTimeChange: function newEndLeaveTimeChange(value) {
      this.leaveTimeChangeParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookLessonOpened: function onBookLessonOpened(row) {
      var self = this;
      var params = {};
      params.uid = row.uid;
      params.startTime = row.startTime;
      params.endTime = row.endTime;

      self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
        self.showBookLessonOpenedModal = true;
        self.bookLessonOpenedList = res.data;
      });
    },
    onModify: function onModify(row) {
      var self = this;
      self.leaveTimeChangeParam.id = row.id;
      self.leaveTimeChangeParam.startLeaveTime = row.startTime;
      self.leaveTimeChangeParam.endLeaveTime = row.endTime;
      self.leaveTimeChangeParam.startLeaveTimeDate = self.$moment(row.startTime, 'X').format('YYYY-MM-DD HH:mm');
      self.leaveTimeChangeParam.endLeaveTimeDate = self.$moment(row.endTime, 'X').format('YYYY-MM-DD HH:mm');

      var params = {};
      params.uid = row.uid;
      params.startTime = row.startTime;
      params.endTime = row.endTime;
      self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
        self.showModifyLeaveTimeModal = true;
        self.bookLessonOpenedList = res.data;
        console.log('A:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.bookLessonOpenedList));
        for (var j = 0; self.bookLessonOpenedList[j] != null; j++) {
          console.log('B:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.bookLessonOpenedList[j]));
          console.log('item.lsnEndTime:' + self.bookLessonOpenedList[j].lsnEndTime);
          if (self.leaveTimeChangeParam.maxLeaveLessonTime < self.bookLessonOpenedList[j].lsnEndTime) {
            self.leaveTimeChangeParam.maxLeaveLessonTime = self.bookLessonOpenedList[j].lsnEndTime;
          }
        }
      });
    },
    onCancel: function onCancel(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>取消</b> 此次请假？',
        width: 300,
        okText: '确定取消',
        loading: true,
        onOk: function onOk() {
          self.$http.post('/bookUserLeaveTime/cancel', { id: row.id }).then(function (res) {
            if (res) {
              self.$Message.success('取消成功!');
              self.search();
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onModifyLeaveEndTime: function onModifyLeaveEndTime() {
      var self = this;
      self.$refs.modifyTimeForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        self.$Modal.confirm({
          title: '提示',
          content: '是否确认修改请假时间？',
          width: 300,
          okText: '确定修改',
          onOk: function onOk() {
            self.$http.post('/bookUserLeaveTime/modifyEndTime', self.leaveTimeChangeParam).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('修改成功!');
                self.showModifyLeaveTimeModal = false;
                self.search();
              } else {
                self.$Message.error(res.message);
              }
              self.$Modal.remove();
            });
          }
        });
      });
    }
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tchScore__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_0__order_ShowImageCarousel_vue___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      uid: null,
      selectionIds: [],
      showImgModal: false,
      showImgList: [],
      queryParam: {
        uid: null,
        status: null,
        studyConsultantId: null,
        startTime: '',
        endTime: ''
      },
      title: [{
        title: '学生信息',
        width: 150,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('p', [h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid, row.userNickname);
              } } }, row.uid + '-' + row.userNickname)])]);
        }
      }, {
        title: '老师ID/姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          var isChange = '';
          if (row.isNewTch === 1) {
            isChange = '(替)';
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName);
            }
          });
        }
      }, {
        title: '课程顾问',
        width: 100,
        key: 'adviserNickname'
      }, {
        title: '学导',
        width: 100,
        key: 'studyAdviserNickname'
      }, {
        title: '外管',
        width: 100,
        key: 'tchStudyName'
      }, {
        title: '课程信息',
        width: 130,
        render: function render(h, params) {
          var row = params.row;
          var lsnType = row.lsnType;
          var typeEnum = _this.$constant.getEnum(_this.$constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.courseType;
          var courseTypeEnum = _this.$constant.getEnum(_this.$constant.courseType, courseType);
          var cType = courseTypeEnum && courseTypeEnum.text;
          if (cType) {
            cType = '课程类别:' + cType;
          } else {
            cType = '';
          }
          return h('div', [h('p', row.id), h('p', row.lessonTitle), h('p', { style: { 'font-size': '12px', color: 'red' } }, cType), h('p', { style: { 'font-size': '12px', color: '#2d8cf0' } }, '课程类型:' + (typeEnum && typeEnum.text))]);
        }
      }, {
        title: '补课信息',
        width: 130,
        render: function render(h, params) {
          var row = params.row;
          if (!row.cancelLogs || !row.cancelLogs.makeUpLesson) {
            return '无';
          }
          var lsnType = row.cancelLogs.makeUpLesson.lsnType;
          var typeEnum = _this.$constant.getEnum(_this.$constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.cancelLogs.makeUpLesson.courseType;
          var courseTypeEnum = _this.$constant.getEnum(_this.$constant.courseType, courseType);
          var cType = courseTypeEnum && courseTypeEnum.text;
          if (cType) {
            cType = '课程类别:' + cType;
          } else {
            cType = '';
          }
          return h('div', [h('p', row.cancelLogs.makeUpLesson.id), h('p', row.cancelLogs.makeUpLesson.lessonTitle), h('p', { style: { 'font-size': '12px', color: 'red' } }, cType), h('p', { style: { 'font-size': '12px', color: '#2d8cf0' } }, '课程类型:' + (typeEnum && typeEnum.text))]);
        }
      }, {
        title: '补课时间',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          if (row.cancelLogs) {
            return h('span', row.cancelLogs.makeUpTime);
          } else {
            return h('span', '无');
          }
        }
      }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          var remark = params.row.remark;
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = _this.$constant.getEnum(_this.$constant.lsnSelStatus, lsnSelStatus);
          return h('div', { style: { 'font-size': '14px' } }, [h('span', statusEnum && statusEnum.text), h('br'), h('span', { style: { 'font-size': '13px', color: 'red' } }, remark)]);
        }
      }, {
        title: '取消原因',
        width: 120,
        key: 'cancelReason'
      }, {
        title: '截图',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.cancelLogs && row.cancelLogs.attachment) {
            return h('a', { on: { click: function click() {
                  return _this.viewPic(row);
                } } }, '查看');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '操作人',
        width: 120,
        key: 'creatorName',
        render: function render(h, params) {
          var row = params.row;
          if (row.cancelLogs) {
            return h('span', row.cancelLogs.adminName);
          }
          return h('p', row.adminNickname);
        }
      }, {
        title: '取消时间',
        width: 110,
        key: 'gmtModified'
      }, {
        title: '上课时间',
        width: 110,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          return h('span', _this.$moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '排课时间',
        width: 110,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lessonOpenTime;
          return h('span', _this.$moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserProvisionalList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    openNewLessonModal: function openNewLessonModal(k, v) {
      if (this.$appConfig.active === 'prod') {
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      } else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      }
    },
    search: function search() {
      this.selectionIds = [];
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionIds = selection;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.cancelLogs.urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    }
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'changeDirectorModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {},
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      nextHandler: [],
      formData: {
        uid: null,
        nickname: ''
      },
      fromRules: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }],
        nickname: [{ type: 'string', required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getUserInfo();
  },

  computed: {
    visible: {
      get: function get() {
        return this.value;
      },
      set: function set() {
        this.onClose();
      }
    }
  },
  methods: {
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formData.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formData.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formData.nickname = user.nickname;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/changeDirectorRecord', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');

            self.onClose();
            self.onSuccess();
          }
        });
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSuccess: function onSuccess() {
      this.$emit('on-success');
    }
  },
  watch: {
    value: function value(val) {
      console.log(this.data);
      this.formData.uid = this.data.uid;
      this.formData.nickname = this.data.nickName;
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      channelList: [],
      loadingWhyNot: false,
      reload: 0,
      queryParam: {
        remark: '',
        channel: '',
        studentKey: '',
        startTime: '',
        endTime: '',
        addNum: ''
      },
      tableColumns: [{
        title: '学生ID',
        width: 100,
        align: 'center',
        key: 'uid'
      }, {
        title: '中(英)文名',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.nickname), h('p', row.enName)]);
        }
      }, {
        title: '课时类型',
        width: 100,
        align: 'center',
        key: 'type'
      }, {
        title: '课时来源',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return [h('span', row.channel + '('), h('span', { style: { color: 'blue' } }, row.totalNum), h('span', ')')];
        }
      }, {
        title: '变动前',
        width: 100,
        align: 'center',
        key: 'beforeNum'
      }, {
        title: '变动课时',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.addNum) {
            return h('span', { style: { color: 'green' } }, '+' + params.row.num);
          }
          return h('span', { style: { color: 'red' } }, '-' + params.row.num);
        }
      }, {
        title: '剩余课时',
        width: 100,
        align: 'center',
        key: 'afterNum'
      }, {
        title: '变动原因',
        width: 200,
        align: 'center',
        key: 'remark'
      }, {
        title: '时间',
        width: 180,
        align: 'center',
        key: 'gmtCreate'
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$http.get('/class-hour/channel').then(function (res) {
      if (!res || !res.data) {
        return;
      }
      self.channelList = res.data;
    });
  },

  methods: {
    timeDateChange: function timeDateChange(value) {
      var self = this;
      self.queryParam.startTime = value[0] + ' 00:00:00';
      self.queryParam.endTime = value[1] + ' 23:59:59';
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: { id: val }, backPath: '/user/UserPayList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    }
  }

});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_FilePreview__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_FilePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_FilePreview__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FilePreview: __WEBPACK_IMPORTED_MODULE_0__components_common_FilePreview___default.a },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      reload: 0,
      uid: null,
      selectionIds: [],
      videoVisible: false,
      videoUrl: '',
      queryParam: {
        uid: null,
        status: null,
        studyConsultantId: null,
        date: new Date()
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickname);
        }
      }, {
        title: '学导',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          if (row.studyConsultantId === 0) {
            return h('span', '未分配');
          }
          return h('span', row.studyConsultantId + '-' + row.studyAdviserName);
        }
      }, {
        title: '课程名称',
        align: 'center',
        width: 150,
        key: 'lessonTitle'
      }, {
        title: '上课时间',
        align: 'center',
        width: 170,
        key: 'lessonTime'
      }, {
        title: '单词跟读',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.readWord.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.readWord.exist && row.readWord.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.readWord.exist && !row.readWord.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '句子跟读',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.readSentence.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.readSentence.exist && row.readSentence.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.readSentence.exist && !row.readSentence.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '听音选图',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.choiceWord.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.choiceWord.exist && row.choiceWord.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.choiceWord.exist && !row.choiceWord.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '情景理解',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.choiceSentence.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.choiceSentence.exist && row.choiceSentence.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.choiceSentence.exist && !row.choiceSentence.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '课后习题',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.lessonQuestions.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.lessonQuestions.exist && row.lessonQuestions.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.lessonQuestions.exist && !row.lessonQuestions.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '内容闯关',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = '';
          var color = '';
          if (!row.recordVideo.exist) {
            text = '没有题目';
            color = 'blue';
          } else if (row.recordVideo.exist && row.recordVideo.completed) {
            text = '已完成';
            color = 'green';
          } else if (row.recordVideo.exist && !row.recordVideo.completed) {
            text = '未完成';
            color = 'red';
          }
          return h('span', { style: { color: color } }, text);
        }
      }, {
        title: '闯关视频',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          if (row.recordVideo.exist && row.recordVideo.completed) {
            var videoUrls = (row.recordVideo.videoUrl || []).filter(function (url) {
              return !!url;
            });
            var index = 1;
            var links = videoUrls.map(function (url) {
              return h('a', {
                on: { click: function click() {
                    return _this.openVideoModal(url);
                  } },
                style: { display: 'block', margin: '5px 0' }
              }, '查看' + index++);
            });
            if (links.length === 0) {
              return h('span', '');
            }
            return h('div', links);
          }
        }
      }, {
        title: '批改时间',
        align: 'center',
        width: 170,
        key: 'reviewTime'
      }, {
        title: '批改人',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          if (row.adminId === undefined) {
            return h('span', '未批改');
          }
          return h('span', row.adminId + '-' + row.adminName);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var text = row.status ? '撤销批改' : '批改';
          var color = row.status ? 'red' : '';
          return h('a', { on: { click: function click() {
                return _this.check(row.bookLessonOpenedId, !row.status, text);
              } }, style: { color: color } }, text);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    openVideoModal: function openVideoModal(val) {
      if (!val) {
        return;
      }
      this.videoUrl = val;
      this.videoVisible = true;
    },
    onVideoVisibleChange: function onVideoVisibleChange(visible) {
      if (!visible) {
        this.videoUrl = '';
      }
    },
    search: function search() {
      this.selectionIds = [];
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    check: function check(id, status, text) {
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">' + text + '</span>?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/bookMaterialLessons/check', { ids: [id], status: status }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionIds = selection;
    },
    batchCheck: function batchCheck() {
      if (this.selectionIds.length <= 0) {
        this.$Message.warning('请选择需批改的记录！');
        return;
      }
      var self = this;
      var idList = self.selectionIds.map(function (element) {
        return element.bookLessonOpenedId;
      });
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">批量完成批改</span>?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/bookMaterialLessons/check', { ids: idList, status: 1 }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/study_record/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '打卡闯关列表.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      selectionUser: [],
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        id: 0,
        uid: 0,
        reason: '',
        oldAdminId: 0,
        oldAdminName: '',
        receiverId: 0,
        receiverName: '',
        distributionId: 0,
        distributionName: '',
        createTime: '',
        updateTime: '',
        beginTime: '',
        beginTimeDate: '',
        endTimeDate: '',
        searchIdOrName: '',
        nickName: '',
        routineNum: 0,
        partnerNum: 0,
        chineseNum: 0,
        routineEndNum: 0
      },
      tableColumns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生ID/姓名',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '课程顾问',
        width: 120,
        key: 'adviserName'
      }, {
        title: '课时信息',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var num = row.routineNum - row.routineEndNum;
          return h('div', [h('div', '外教课课时：' + row.routineNum), h('div', '陪练课课时：' + row.partnerNum), h('div', '中教课课时：' + row.chineseNum), h('div', '外教课课时已消耗：' + row.routineEndNum), h('div', '剩余外教课课时：' + num)]);
        }
      }, {
        title: '绑定老师',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var list = row.bookWorkLessonOpenedTimeList;
          if (list.length > 0) {
            var spanArr = [];
            var scoreMap = _this.rankScoreMap || {};
            list.forEach(function (element) {
              var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
              spanArr.push(h('span', [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, { text: element.tchId + '-' + element.tchName, score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
              spanArr.push(h('br'));
            });
            var levelTitle = row.levelTitle;
            if (levelTitle) {
              levelTitle = '当前等级：' + levelTitle;
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', levelTitle), h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '分配原因',

        align: 'center',
        key: 'intReason',
        render: function render(h, params) {
          var row = params.row;
          var text = $constant.getEnum($constant.distributionReason, row.intReason).text;
          return h('div', text);
        }
      }, {
        title: '原学导',

        align: 'center',
        key: 'oldAdminName'
      }, {
        title: '接收人',

        align: 'center',
        key: 'receiverName'
      }, {
        title: '分配人',

        align: 'center',
        key: 'distributionName'
      }, {
        title: '分配时间',

        align: 'center',
        key: 'createTime'
      }]
    };
  },


  created: function created() {},

  methods: {
    beginTimeChange: function beginTimeChange(value) {
      var self = this;
      self.queryParam.beginTimeDate = value;
    },
    endTimeChange: function endTimeChange(value) {
      var self = this;
      self.queryParam.endTimeDate = value;
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;

      if (!loading) {
        this.loadBoundTchMonthScores();
      }
    },
    loadBoundTchMonthScores: function loadBoundTchMonthScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        this.rankScoreMap = {};
        return;
      }
      var ids = [];
      table.forEach(function (row) {
        var list = row.bookWorkLessonOpenedTimeList || [];
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId);
          }
        });
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        self.rankScoreMap = map || {};
      });
    },
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/distributionLearnRecord/page-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '分配学导记录.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Checkbox: __WEBPACK_IMPORTED_MODULE_1_iview_src_components_checkbox__["a" /* default */] },
  data: function data() {
    return {
      checkBoxes: [],
      studentNature: [],
      studyExperience: [],
      hobby: [],
      grades: [],
      englishLevel: [],
      tchRequirement: [],
      formData: {
        uid: '',
        nickName: '',
        nextTimeDate: '',
        studentNatureList: [],
        studyExperienceList: [],
        hobbyList: [],
        gradesList: [],
        englishLevelList: [],
        tchRequirementList: []
      },
      formValidate: {
        uid: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: ''
      }
    };
  },
  created: function created() {
    var self = this;
    self.$http.get('/adminConfig/getItemByItemType?itemType=' + 1).then(function (res) {
      self.checkBoxes = res.data;
      self.classifyBox(self.checkBoxes);
    });
  },
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.formData.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formData.nickName = self.formValidate.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
  },

  methods: {
    dateChange: function dateChange(value) {
      this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onGradeChange: function onGradeChange(val) {
      this.formData.gradesList = val;
    },
    onStudyExperienceChange: function onStudyExperienceChange(val) {
      this.formData.studyExperienceList = val;
    },
    onStudentNature: function onStudentNature(val) {
      this.formData.studentNatureList = val;
    },
    onHobbyChange: function onHobbyChange(val) {
      this.formData.hobbyList = val;
    },
    onEnglishLevelChange: function onEnglishLevelChange(val) {
      this.formData.englishLevelList = val;
    },
    ontchRequirementChange: function ontchRequirementChange(val) {
      this.formData.tchRequirementList = val;
    },
    classifyBox: function classifyBox(checkBoxes) {
      var self = this;
      for (var index = 0; index < checkBoxes.length; index++) {
        if (checkBoxes[index].parentTitle === '学习经历') {
          self.studyExperience.push(checkBoxes[index]);
        }
        if (checkBoxes[index].parentTitle === '孩子性格') {
          self.studentNature.push(checkBoxes[index]);
        }
        if (checkBoxes[index].parentTitle === '兴趣爱好') {
          self.hobby.push(checkBoxes[index]);
        }
        if (checkBoxes[index].parentTitle === '所处年级') {
          self.grades.push(checkBoxes[index]);
        }
        if (checkBoxes[index].parentTitle === '老师要求') {
          self.tchRequirement.push(checkBoxes[index]);
        }
      }
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      self.$http.post('/userList/insertUserModal', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingBind = false;
        if (!res) {
          self.$Message.error('操作失败!');
        } else if (res.data > 0) {
          self.$Message.success('添加成功!');
          self.visible = false;
          if (self.successCallback !== undefined) {
            self.successCallback();
          }
          self.$router.push({ path: '/message/personMessage', query: { tabName: __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default.a.getShortNumByTraceType(21) } });
        } else {
          self.$Message.error(res.message);
        }
      });
    }
  },
  watch: {}
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      showImgModal: false,
      showImgList: [],
      reload: 0,
      editUser: false,
      uid: null,
      queryParam: {
        uid: '',
        mobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        type: '',
        tchId: null,
        subType: null,
        auditorName: ''
      },
      title: [{
        title: '学生ID/姓名',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '兑换类型',
        align: 'center',

        render: function render(h, params) {
          var type = params.row.giveType;
          var typeEnum = $constant.getEnum($constant.giveType, type);
          return h('div', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程赠送',
        align: 'center',
        key: 'lessonNum'
      }, {
        title: '物品赠送',
        align: 'center',
        key: 'remark'
      }, {
        title: '扣除积分',
        align: 'center',

        key: 'activity'
      }, {
        title: '兑换时间',
        align: 'center',

        key: 'gmtCreate'
      }, {
        title: '兑换人',

        align: 'center',
        key: 'creatorName'
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/ExchangeRecordList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_0__crm_UserInfoModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      showImgModal: false,
      showImgList: [],
      followList: [],
      adviserGroupList: this.$constant.adviserGroup,
      reload: 0,
      snextDate: '',
      enextDate: '',
      editUser: false,
      uid: null,
      queryParam: {
        uid: '',
        mobile: '',
        snextDate: '',
        enextDate: '',
        adviserName: '',
        studyNickname: '',
        traceStatus: '',
        traceItem: '',
        teamType: 0,
        userNickname: '',
        adminNickname: '',
        modifierName: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        type: '',
        tchId: null,
        subType: null,
        auditorName: ''
      },
      title: [{
        title: '学生ID/姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.userNickname);
        }
      }, {
        title: '添加时间',
        key: 'gmtCreate',

        align: 'center'
      }, {
        title: '课程顾问',
        key: 'adviserName',

        align: 'center'
      }, {
        title: '学导',
        key: 'studyNickname',

        align: 'center'
      }, {
        title: '状态',

        align: 'center',
        render: function render(h, params) {
          var type = params.row.traceStatus;
          var typeEnum = $constant.getEnum($constant.traceStatus, type);
          return h('div', typeEnum && typeEnum.text);
        }
      }, {
        title: 'followUp选项',

        align: 'center',
        render: function render(h, params) {
          var type = params.row.traceItem;
          var typeEnum = $constant.getEnum($constant.traceItem, type);
          return h('div', typeEnum && typeEnum.text);
        }
      }, {
        title: '内容',
        width: 380,
        align: 'center',
        key: 'content'
      }, {
        title: '下次联系时间',

        align: 'center',
        key: 'nextContactTime'
      }, {
        title: '处理人',

        align: 'center',
        key: 'modifierName'
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query.startTime) {
      this.queryParam.startTimeDate = parseInt(query.startTime) * 1000;
    }
    if (query.endTime) {
      this.queryParam.endTimeDate = parseInt(query.endTime) * 1000;
    }
    if (query.snextDate) {
      this.snextDate = query.snextDate;
    }
    if (query.enextDate) {
      this.enextDate = query.enextDate;
    }
    if (query.teamType) {
      this.queryParam.teamType = parseInt(query.teamType);
    }
    if (query.traceItem) {
      this.queryParam.traceItem = parseInt(query.traceItem);
      var i = parseInt(query.traceStatus);
      if (i === 1) {
        self.followList = [{ id: 1, text: '课后-同意购买' }, { id: 2, text: '课后-付款成功，持续跟进' }];
      }
      if (i === 2) {
        self.followList = [{ id: 3, text: '课后-讲解产品，学习方案' }];
      }
      if (i === 3) {
        self.followList = [{ id: 4, text: '课后-开场' }, { id: 5, text: '课前跟进，确认出席' }, { id: 6, text: '课前跟进，改期' }, { id: 7, text: '课前约课' }];
      }
      if (i === 4) {
        self.followList = [{ id: 8, text: '价格问题' }, { id: 9, text: '行业对比' }, { id: 10, text: '不信任' }, { id: 11, text: '级别年龄不符' }];
      }
      if (i === 5) {
        self.followList = [{ id: 12, text: '无人接听' }, { id: 13, text: '挂断' }, { id: 14, text: '关机/停机' }, { id: 15, text: '空号' }];
      }
    }
  },
  created: function created() {

    var startTime = this.queryParam.startTime;
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate();
    }
    if (startTime === '') {
      var momentDate = this.$moment().add(-24, 'M');
      momentDate.millisecond(0);
      momentDate.second(0);
      momentDate.minute(0);
      momentDate.hour(0);
      this.queryParam.startTimeDate = momentDate.toDate();
      this.queryParam.startTime = momentDate.format('X');
    }
  },
  methods: {
    viewPic: function viewPic(row) {
      this.showImgList = row.urls;
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/FollowUpList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    schangeDate: function schangeDate(value) {
      this.queryParam.snextDate = value;
    },
    echangeDate: function echangeDate(value) {
      this.queryParam.enextDate = value;
    },
    changeFollow: function changeFollow(val) {
      var self = this;
      if (!val) {
        return;
      }

      if (val === '1') {
        self.followList = [{ id: 1, text: '课后-同意购买' }, { id: 2, text: '课后-付款成功，持续跟进' }];
      }
      if (val === '2') {
        self.followList = [{ id: 3, text: '课后-讲解产品，学习方案' }];
      }
      if (val === '3') {
        self.followList = [{ id: 4, text: '课后-开场' }, { id: 5, text: '课前跟进，确认出席' }, { id: 6, text: '课前跟进，改期' }, { id: 7, text: '课前约课' }];
      }
      if (val === '4') {
        self.followList = [{ id: 8, text: '价格问题' }, { id: 9, text: '行业对比' }, { id: 10, text: '不信任' }, { id: 11, text: '级别年龄不符' }];
      }
      if (val === '5') {
        self.followList = [{ id: 12, text: '无人接听' }, { id: 13, text: '挂断' }, { id: 14, text: '关机/停机' }, { id: 15, text: '空号' }];
      }
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var SERVICE_WAYS = ['微信监课', '作业点评', '电话回访', 'classin上课'];

function headerCell(h, text, tip) {
  return h('span', {
    attrs: {
      title: tip || text
    },
    style: {
      display: 'inline-block',
      lineHeight: '18px',
      whiteSpace: 'nowrap'
    }
  }, text);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewStudentService',
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      exportLoading: false,
      svcTab: 'new',
      oldTitle: [{
        title: '学生ID',
        key: 'uid',
        fixed: 'left',
        width: 100,
        align: 'center',
        render: function render(h, _ref) {
          var row = _ref.row;

          if (!row.uid) {
            return h('span', '');
          }
          return h('a', {
            on: {
              click: function click() {
                return _this.openInfoModal(row.uid);
              }
            }
          }, String(row.uid));
        }
      }, { title: '学生姓名', key: 'studentName', fixed: 'left', width: 140 }, { title: '外教总课时', key: 'foreignTotalHour', width: 110, align: 'center' }, { title: '最近已上课件', key: 'lastFinishedLesson', width: 180 }, { title: '外教剩余课时', key: 'foreignLeftHour', width: 120, align: 'center', sortable: 'custom' }, {
        title: '服务方式',
        key: 'serviceWay',
        width: 140,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return _this.renderOldWay(h, row);
        }
      }, {
        title: '时长',
        key: 'duration',
        width: 110,
        render: function render(h, _ref3) {
          var row = _ref3.row;
          return _this.renderOldInput(h, row, 'duration', '时长');
        }
      }, {
        title: '日期',
        key: 'serviceDate',
        width: 150,
        sortable: 'custom',
        render: function render(h, _ref4) {
          var row = _ref4.row;
          return _this.renderOldDate(h, row);
        }
      }, {
        title: '备注',
        key: 'remark',
        minWidth: 180,
        render: function render(h, _ref5) {
          var row = _ref5.row;
          return _this.renderOldText(h, row, 'remark', '备注');
        }
      }],
      reload: 0,
      reloadWithPage: 0,
      oldReload: 0,
      oldReloadWithPage: 0,
      servedCount: 0,
      studentTotal: 0,
      progressLoading: false,
      progressData: [],
      progressTitle: [{ title: '班主任', key: 'adviserName', minWidth: 160 }, {
        title: '新生服务进度',
        key: 'newProgress',
        width: 160,
        align: 'center',
        render: function render(h, _ref6) {
          var row = _ref6.row;
          return _this.renderProgress(h, row, 'new');
        }
      }, {
        title: '老生服务进度',
        key: 'oldProgress',
        width: 160,
        align: 'center',
        render: function render(h, _ref7) {
          var row = _ref7.row;
          return _this.renderProgress(h, row, 'old');
        }
      }],
      serviceDateRange: [],
      bookMaterialLevelList: [],
      bookMaterialLessonsList: [],
      queryParam: {
        uid: '',
        adminUserId: null,
        served: '',
        serviceDateStart: '',
        serviceDateEnd: '',
        levelId: '',
        lessonId: '',
        leftHourMin: '',
        leftHourMax: ''
      },
      editVisible: false,
      editTitle: '',
      editValue: '',
      editRow: null,
      editField: '',
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      title: [{
        title: '序号',
        key: 'seq',
        fixed: 'left',
        width: 56,
        align: 'center'
      }, {
        title: '学生信息',
        key: 'student',
        fixed: 'left',
        width: 150,
        render: function render(h, _ref8) {
          var row = _ref8.row;
          return _this.renderStudent(h, row);
        }
      }, {
        title: '销售',
        key: 'adviserName',
        width: 90
      }, {
        title: '开课日期',
        key: 'openCourseTime',
        width: 150,
        render: function render(h, _ref9) {
          var row = _ref9.row;
          return _this.renderTime(h, row, 'openCourseTime', 'date');
        }
      }, {
        title: '首通时间',
        key: 'firstWeekTime',
        width: 200,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '首通时间', '第一周首通：沟通时间、沟通方式');
        },
        render: function render(h, _ref10) {
          var row = _ref10.row;
          return _this.renderTimeAndWay(h, row, 'firstWeekTime', 'firstWeekWay');
        }
      }, {
        title: '首通内容',
        key: 'firstWeekContent',
        width: 220,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '首通内容', '1 了解学生信息:是否学过英语/报课原因/英语期望\n2 做高课耗&核对上课时间\n3 课程信息确认\n4 预复习告知 & 首月适应期打预防针\n5 请假规则 & 上课前智能语音电话提醒');
        },
        render: function render(h, _ref11) {
          var row = _ref11.row;
          return _this.renderServiceContent(h, row, 'firstWeekContent', 'firstWeekServiceWay', '第一周首通内容');
        }
      }, {
        title: '1课后时间',
        key: 'firstVisitTime',
        width: 200,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '1课后时间', '第1次课后回访（72小时内）：沟通时间、沟通方式');
        },
        render: function render(h, _ref12) {
          var row = _ref12.row;
          return _this.renderTimeAndWay(h, row, 'firstVisitTime', 'firstVisitWay');
        }
      }, {
        title: '1课后内容',
        key: 'firstVisitContent',
        width: 200,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '1课后内容', '1.确认是否适应课堂\n2.确认是否喜欢老师\n3.告知转介绍\n4.APP使用情况');
        },
        render: function render(h, _ref13) {
          var row = _ref13.row;
          return _this.renderServiceContent(h, row, 'firstVisitContent', 'firstVisitServiceWay', '第1次课后回访内容');
        }
      }, {
        title: '5课后时间',
        key: 'fifthVisitTime',
        width: 200,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '5课后时间', '第5课课后回访（72小时内）：沟通时间、沟通方式');
        },
        render: function render(h, _ref14) {
          var row = _ref14.row;
          return _this.renderTimeAndWay(h, row, 'fifthVisitTime', 'fifthVisitWay');
        }
      }, {
        title: '5课后内容',
        key: 'fifthVisitContent',
        width: 180,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '5课后内容', '监课反馈/电话');
        },
        render: function render(h, _ref15) {
          var row = _ref15.row;
          return _this.renderServiceContent(h, row, 'fifthVisitContent', 'fifthVisitServiceWay', '监课反馈/电话');
        }
      }, {
        title: '10课时间',
        key: 'tenthVisitTime',
        width: 200,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '10课时间', '第10课电话（72小时内）：沟通时间、沟通方式');
        },
        render: function render(h, _ref16) {
          var row = _ref16.row;
          return _this.renderTimeAndWay(h, row, 'tenthVisitTime', 'tenthVisitWay');
        }
      }, {
        title: '10课内容',
        key: 'tenthVisitContent',
        width: 220,
        renderHeader: function renderHeader(h) {
          return headerCell(h, '10课内容', '1.学情分析（作业频率，出勤，纪律，学习环境）\n2.加课&转介绍\n3.赠送steve&meggie（L1-L3）\n4.提醒补升特权\n5.提醒后期服务频率');
        },
        render: function render(h, _ref17) {
          var row = _ref17.row;
          return _this.renderServiceContent(h, row, 'tenthVisitContent', 'tenthVisitServiceWay', '第10课电话内容');
        }
      }]
    };
  },
  watch: {
    svcTab: function svcTab(val) {
      if (val === 'old') {
        this.$set(this.queryParam, 'oldStudent', 1);
        this.loadOldProgress();
      } else {
        this.$delete(this.queryParam, 'oldStudent');
        this.$delete(this.queryParam, 'served');
        this.$delete(this.queryParam, 'serviceDateStart');
        this.$delete(this.queryParam, 'serviceDateEnd');
        this.$delete(this.queryParam, 'sortProperty');
        this.$delete(this.queryParam, 'sortDirection');
        this.$delete(this.queryParam, 'levelId');
        this.$delete(this.queryParam, 'lessonId');
        this.$delete(this.queryParam, 'leftHourMin');
        this.$delete(this.queryParam, 'leftHourMax');
        this.serviceDateRange = [];
        this.bookMaterialLessonsList = [];
        if (val === 'progress') {
          this.loadProgress();
        } else {
          this.progressData = [];
        }
      }
    }
  },
  created: function created() {
    if (this.isStudyAdviser) {
      this.queryParam.adminUserId = parseInt(this.$store.get('id'));
    }
    this.loadBookMaterialLevel();
  },
  methods: {
    renderStudent: function renderStudent(h, row) {
      var _this2 = this;

      if (!row.uid) {
        return h('span', row.student || '');
      }
      var name = '';
      var text = row.student ? String(row.student) : '';
      var prefix = String(row.uid) + '-';
      if (text.indexOf(prefix) === 0) {
        name = text.substring(prefix.length);
      } else if (text.indexOf('-') >= 0) {
        name = text.substring(text.indexOf('-') + 1);
      }
      return h('span', [h('a', {
        on: {
          click: function click() {
            return _this2.openInfoModal(row.uid);
          }
        }
      }, String(row.uid)), name ? h('span', '-' + name) : '']);
    },
    openInfoModal: function openInfoModal(uid) {
      if (!uid) {
        return;
      }
      var resolved = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: uid, tabName: 0, parm: this.queryParam, backPath: '/user/newStudentService' }
      });
      window.open(resolved.href, '_blank');
    },
    renderTime: function renderTime(h, row, key, type) {
      var _this3 = this;

      var pickerType = type || 'datetime';
      var format = pickerType === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
      var overdue = key === 'firstVisitTime' && !!row.firstVisitOverdue;
      return h('DatePicker', {
        class: overdue ? 'new-svc-overdue' : '',
        props: {
          type: pickerType,
          value: row[key] || '',
          format: format,
          transfer: true,
          clearable: true,
          size: 'small',
          placeholder: pickerType === 'date' ? '选择日期' : '选择时间'
        },
        style: {
          width: pickerType === 'date' ? '128px' : '168px'
        },
        on: {
          'on-change': function onChange(val) {
            _this3.$set(row, key, val || '');
            _this3.saveField(row, key, val || '');
          }
        }
      });
    },
    renderText: function renderText(h, row, key, title) {
      var _this4 = this;

      var text = row[key] || '';
      return h('div', {
        class: 'new-svc-text',
        attrs: {
          title: text
        }
      }, [h('span', {
        class: text ? 'new-svc-text-body' : 'new-svc-text-empty'
      }, text || '未填写'), h('a', {
        class: 'new-svc-edit',
        on: {
          click: function click(e) {
            if (e && e.stopPropagation) {
              e.stopPropagation();
            }
            _this4.openTextEdit(row, key, title);
          }
        }
      }, '编辑')]);
    },
    renderServiceContent: function renderServiceContent(h, row, contentKey, wayKey, title) {
      var _this5 = this;

      var ways = SERVICE_WAYS;
      var options = [];
      for (var i = 0; i < ways.length; i++) {
        options.push(h('Option', {
          props: {
            value: ways[i]
          }
        }, ways[i]));
      }
      return h('div', {
        class: 'new-svc-content'
      }, [h('Select', {
        props: {
          value: row[wayKey] || '',
          clearable: true,
          transfer: true,
          size: 'small',
          placeholder: '服务方式'
        },
        style: {
          width: '100%',
          marginBottom: '4px'
        },
        on: {
          'on-change': function onChange(val) {
            _this5.$set(row, wayKey, val || '');
            _this5.saveField(row, wayKey, val || '');
          }
        }
      }, options), this.renderText(h, row, contentKey, title)]);
    },
    renderTimeAndWay: function renderTimeAndWay(h, row, timeKey, wayKey) {
      return h('div', {
        class: 'new-svc-time-way'
      }, [this.renderTime(h, row, timeKey, 'date'), this.renderText(h, row, wayKey, '沟通方式')]);
    },
    openTextEdit: function openTextEdit(row, field, title) {
      this.editRow = row;
      this.editField = field;
      this.editTitle = title;
      this.editValue = row[field] || '';
      this.editVisible = true;
    },
    closeEdit: function closeEdit() {
      this.editVisible = false;
      this.editRow = null;
      this.editField = '';
      this.editValue = '';
    },
    confirmEdit: function confirmEdit() {
      if (!this.editRow || !this.editField) {
        this.closeEdit();
        return;
      }
      var row = this.editRow;
      var field = this.editField;
      var value = this.editValue || '';
      this.$set(row, field, value);
      this.saveField(row, field, value);
      this.closeEdit();
    },
    renderOldWay: function renderOldWay(h, row) {
      var _this6 = this;

      var ways = SERVICE_WAYS;
      var options = [];
      for (var i = 0; i < ways.length; i++) {
        options.push(h('Option', {
          props: {
            value: ways[i]
          }
        }, ways[i]));
      }
      return h('Select', {
        props: {
          value: row.serviceWay || '',
          clearable: true,
          transfer: true,
          size: 'small',
          placeholder: '服务方式'
        },
        style: {
          width: '100%'
        },
        on: {
          'on-change': function onChange(val) {
            _this6.setOldField(row, 'serviceWay', val || '');
          }
        }
      }, options);
    },
    renderOldInput: function renderOldInput(h, row, key, placeholder) {
      var _this7 = this;

      return h('Input', {
        props: {
          value: row[key] || '',
          size: 'small',
          placeholder: placeholder
        },
        on: {
          'on-blur': function onBlur(e) {
            var val = e && e.target ? e.target.value : '';
            _this7.setOldField(row, key, val || '');
          }
        }
      });
    },
    renderOldDate: function renderOldDate(h, row) {
      var _this8 = this;

      return h('DatePicker', {
        props: {
          type: 'date',
          value: row.serviceDate || '',
          format: 'yyyy-MM-dd',
          transfer: true,
          clearable: true,
          size: 'small',
          placeholder: '选择日期'
        },
        style: {
          width: '128px'
        },
        on: {
          'on-change': function onChange(val) {
            _this8.setOldField(row, 'serviceDate', val || '');
          }
        }
      });
    },
    renderOldText: function renderOldText(h, row, key, title) {
      return this.renderText(h, row, key, title);
    },
    renderProgress: function renderProgress(h, row, type) {
      var servedKey = type === 'new' ? 'newServedCount' : 'oldServedCount';
      var totalKey = type === 'new' ? 'newStudentTotal' : 'oldStudentTotal';
      return h('span', (row[servedKey] || 0) + '/' + (row[totalKey] || 0));
    },
    setOldField: function setOldField(row, field, value) {
      this.$set(row, field, value);
      this.saveField(row, field, value);
    },
    saveField: function saveField(row, field, value) {
      var _this9 = this;

      if (!row.uid) {
        this.$Message.error('学生ID不能为空');
        return;
      }
      this.$http.post('/user/new-student-service/save', {
        uid: row.uid,
        field: field,
        value: value || ''
      }).then(function (res) {
        if (res && res.status === 'ok') {
          _this9.$Message.success('已保存');
        }
        if (_this9.svcTab === 'old') {
          _this9.loadOldProgress();
        }
      });
    },
    loadOldProgress: function loadOldProgress() {
      var _this10 = this;

      this.$http.post('/user/new-student-service/list', {
        oldStudent: 1,
        uid: this.queryParam.uid,
        adminUserId: this.queryParam.adminUserId,
        progress: 1,
        pageIndex: 1,
        pageSize: 1
      }).then(function (res) {
        var data = res && res.data ? res.data : {};
        _this10.servedCount = data.servedCount || 0;
        _this10.studentTotal = data.studentTotal || 0;
      });
    },
    loadProgress: function loadProgress() {
      var _this11 = this;

      this.progressLoading = true;
      this.$http.post('/user/new-student-service/progress-by-adviser', {}).then(function (res) {
        var list = res && res.status === 'ok' && Array.isArray(res.data) ? res.data : [];
        _this11.progressData = list.map(function (item) {
          return {
            adminUserId: item.adminUserId === undefined ? null : item.adminUserId,
            adviserName: item.adviserName || '',
            newServedCount: item.newServedCount || 0,
            newStudentTotal: item.newStudentTotal || 0,
            oldServedCount: item.oldServedCount || 0,
            oldStudentTotal: item.oldStudentTotal || 0
          };
        });
        _this11.progressLoading = false;
      }).catch(function () {
        _this11.progressData = [];
        _this11.progressLoading = false;
      });
    },
    changeServiceDate: function changeServiceDate(val) {
      if (val && val.length === 2 && val[0] && val[1]) {
        this.$set(this.queryParam, 'serviceDateStart', val[0]);
        this.$set(this.queryParam, 'serviceDateEnd', val[1]);
        return;
      }
      this.$set(this.queryParam, 'serviceDateStart', '');
      this.$set(this.queryParam, 'serviceDateEnd', '');
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var _this12 = this;

      this.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        _this12.bookMaterialLevelList = res.data;
      });
    },
    changeMaterialLevel: function changeMaterialLevel(val) {
      var _this13 = this;

      this.$set(this.queryParam, 'lessonId', '');
      this.bookMaterialLessonsList = [];
      if (val) {
        this.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          _this13.bookMaterialLessonsList = res.data;
        });
      }
    },
    handleOldSortChange: function handleOldSortChange(column, key, order) {
      if (key !== 'foreignLeftHour' && key !== 'serviceDate') {
        return;
      }
      this.$delete(this.queryParam, 'sortProperty');
      this.$delete(this.queryParam, 'sortDirection');
      if (order && order !== 'normal') {
        this.$set(this.queryParam, 'sortProperty', key);
        this.$set(this.queryParam, 'sortDirection', order);
      }
      this.oldReload = new Date().getTime();
    },
    search: function search() {
      if (this.svcTab === 'old') {
        this.oldReload = new Date().getTime();
        this.loadOldProgress();
        return;
      }
      this.reload = new Date().getTime();
    },
    exportData: function exportData() {
      var _this14 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/user/new-student-service/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = _this14.svcTab === 'old' ? '老生服务.xlsx' : '新生服务.xlsx';
          link.click();
          _this14.exportLoading = false;
        } else {
          _this14.$Message.error(response.msg || '导出失败');
          _this14.exportLoading = false;
        }
      }).catch(function () {
        _this14.$Message.error('导出失败');
        _this14.exportLoading = false;
      });
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextHandler: [],
      uidReadonly: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        isBatchedTch: '0',
        isBatchedTime: '0',
        isCheckedForeignTchTime: '0',
        havaTellChineseLessonRule: '0',
        havaTellLeaveRule: '0',
        haveWebChat: '0',
        haveTellRestTime: '0',
        havaTellLivingLessonRule: '0'
      },
      ruleValidate: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    var row = self.$route.query.row;
    self.formValidate.uid = row.uid;
    self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
      self.formValidate.nickname = res.data.nickname;
      self.formValidate.adviserName = res.data.adviserName;
      self.formValidate.studyAdviserName = res.data.studyAdviserName;
    });
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    this.getUserInfo();
  },

  methods: {
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
      console.log(this.formValidate.nextHandlerTime);
    },
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formValidate.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formValidate.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formValidate.nickname = user.nickname;
        self.formValidate.adviserName = user.adviserName;
        self.formValidate.studyAdviserName = user.studyAdviserName;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/comunicationWithParent', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.$router.push('/user/userTrackList');
          }
        });
      });
    },
    onChange: function onChange() {
      var arr = [];
      if (this.formValidate.isBatchedTch === '1') {
        arr.push('已确定绑定老师');
      } else {
        arr.push('未确定绑定老师');
      }
      if (this.formValidate.isBatchedTime === '1') {
        arr.push('已确定绑定时间');
      } else {
        arr.push('未确定绑定时间');
      }
      if (this.formValidate.isCheckedForeignTchTime === '1') {
        arr.push('已核对外教主课时');
      } else {
        arr.push('未核对外教主课时');
      }
      if (this.formValidate.havaTellChineseLessonRule === '1') {
        arr.push('已告知中教课上课规则');
      } else {
        arr.push('未告知中教课上课规则');
      }
      if (this.formValidate.havaTellLeaveRule === '1') {
        arr.push('已告知请假制度');
      } else {
        arr.push('未告知中教课上课规则');
      }
      if (this.formValidate.haveWebChat === '1') {
        arr.push('已加上家长微信');
      } else {
        arr.push('未加上家长微信');
      }
      if (this.formValidate.haveTellRestTime === '1') {
        arr.push('已告知自己的休息时间');
      } else {
        arr.push('未告知自己的休息时间');
      }
      if (this.formValidate.havaTellLivingLessonRule === '1') {
        arr.push('已告知直播课上课规则');
      } else {
        arr.push('未告知直播课上课规则');
      }
      this.formValidate.content = arr.join(' ');
      console.log(this.formValidate.content);
    }
  },
  watch: {}
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextHandler: [],
      uidReadonly: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerTime: __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.today(),
        nextHandlerId: null,
        operateStatus: '0',
        isBatchedTch: '0',
        isBatchedTime: '0',
        isCheckedForeignTchTime: '0',
        havaTellChineseLessonRule: '0',
        havaTellLeaveRule: '0',
        haveWebChat: '0',
        haveTellRestTime: '0',
        havaTellLivingLessonRule: '0'
      },
      ruleValidate: {
        uid: [{ type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var self = this;
    this.formValidate.uid = this.$route.query.row.uid;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    this.getUserInfo();
  },

  methods: {
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
      console.log(this.formValidate.nextHandlerTime);
    },
    getUserInfo: function getUserInfo() {
      var self = this;
      if (!self.formValidate.uid) {
        return;
      }
      self.$http.post('/user/queryById', { 'uid': self.formValidate.uid }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        var user = res.data;
        self.formValidate.nickname = user.nickname;
        self.formValidate.adviserName = user.adviserName;
        self.formValidate.studyAdviserName = user.studyAdviserName;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }

        self.$http.post('/userTrack/comunicationWithParent', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.$router.push('/user/userTrackList');
          }
        });
      });
    },
    onChange: function onChange() {
      var arr = [];
      if (this.formValidate.isBatchedTch === '1') {
        arr.push('已确定绑定老师');
      } else {
        arr.push('未确定绑定老师');
      }
      if (this.formValidate.isBatchedTime === '1') {
        arr.push('已确定绑定时间');
      } else {
        arr.push('未确定绑定时间');
      }
      if (this.formValidate.isCheckedForeignTchTime === '1') {
        arr.push('已核对外教主课时');
      } else {
        arr.push('未核对外教主课时');
      }
      if (this.formValidate.havaTellChineseLessonRule === '1') {
        arr.push('已告知中教课上课规则');
      } else {
        arr.push('未告知中教课上课规则');
      }
      if (this.formValidate.havaTellLeaveRule === '1') {
        arr.push('已告知请假制度');
      } else {
        arr.push('未告知中教课上课规则');
      }
      if (this.formValidate.haveWebChat === '1') {
        arr.push('已加上家长微信');
      } else {
        arr.push('未加上家长微信');
      }
      if (this.formValidate.haveTellRestTime === '1') {
        arr.push('已告知自己的休息时间');
      } else {
        arr.push('未告知自己的休息时间');
      }
      if (this.formValidate.havaTellLivingLessonRule === '1') {
        arr.push('已告知直播课上课规则');
      } else {
        arr.push('未告知直播课上课规则');
      }
      this.formValidate.content = arr.join(' ');
      console.log(this.formValidate.content);
    }
  },
  watch: {}
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackContentPreview_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackContentPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TrackContentPreview_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TrackContentPreview: __WEBPACK_IMPORTED_MODULE_2__TrackContentPreview_vue___default.a },
  props: {
    showData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      bindTch: '',
      adviserName: '',
      studyAdviserName: '',
      tableData: [],
      rowTypeCount: 1,
      rowSpanList: [],
      spanRow: [],
      count: 0,
      index: 0,
      span: 1,
      onLoading: false,
      adminList: [],
      queryParam: {
        trackTypeStr: '',
        trackType: '',
        totalCount: 0,
        pageSize: 10,
        pageIndex: 1,
        id: '',
        uid: '',
        nickName: '',
        mobile: '',
        content: '',
        startTimeDate: '',
        endTimeDate: '',
        nextHandlerId: '',
        startTime: '',
        endTime: '',
        traceType: '',
        createStartTime: '',
        createEndTime: '',
        createName: ''
      },
      time: [],
      addTime: [],
      contentVisible: false,
      contentHtml: '',
      contentRawText: '',
      contentViewMode: 'markdown',
      contentMeta: {},
      exportImageLoading: false
    };
  },

  methods: {
    renderContent: function renderContent(content) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(content);
    },
    openContentView: function openContentView(item) {
      if (!item || !item.content) {
        this.$Message.warning('暂无内容');
        return;
      }
      this.contentMeta = {
        uid: item.uid || this.queryParam.uid || '',
        id: item.id || '',
        createTime: item.createTime || ''
      };
      this.contentHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(item.content);
      this.contentRawText = item.contentRaw || '';
      this.contentViewMode = 'markdown';
      this.contentVisible = true;
    },
    switchContentView: function switchContentView() {},
    exportContentPng: function exportContentPng() {
      var el = this.$refs.contentExportArea;
      if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
        this.$Message.warning('暂无内容可导出');
        return;
      }
      this.exportImageLoading = true;
      var self = this;

      var width = Math.max(el.clientWidth || 0, 680);
      var holder = document.createElement('div');
      holder.setAttribute('data-track-png-export', '1');
      holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;';
      var clone = el.cloneNode(true);
      clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim();
      if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
        clone.className = (clone.className + ' track-md').trim();
      }
      clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;';
      holder.appendChild(clone);
      document.body.appendChild(holder);
      var cleanup = function cleanup() {
        if (holder && holder.parentNode) {
          holder.parentNode.removeChild(holder);
        }
      };
      void clone.offsetHeight;
      var w = Math.max(clone.scrollWidth, width);
      var h = Math.max(clone.scrollHeight, clone.offsetHeight, 1);
      __WEBPACK_IMPORTED_MODULE_1_html2canvas___default()(clone, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        width: w,
        height: h,
        windowWidth: w,
        windowHeight: h
      }).then(function (canvas) {
        cleanup();
        var meta = self.contentMeta || {};
        var stamp = String(meta.createTime || '').replace(/[^\d]/g, '');
        var link = document.createElement('a');
        link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        self.exportImageLoading = false;
        self.$Message.success('导出成功');
      }).catch(function () {
        cleanup();
        self.exportImageLoading = false;
        self.$Message.error('导出失败');
      });
    },
    formatNextHandlerTime: function formatNextHandlerTime(item) {
      var t = item && item.nextHandlerTime;
      if (!t || t === '0000-00-00 00:00:00') {
        return '0';
      }
      return t;
    },
    addTrace: function addTrace() {
      this.$router.push('/user/userTrackEdit?uid=' + this.queryParam.uid);
    },
    changePageIndex: function changePageIndex(page) {
      this.queryParam.pageIndex = page;
      this.getPersonTrace(this.queryParam.uid);
    },
    search: function search() {
      var self = this;
      self.onLoading = true;
      var params = self.queryParam;
      params.pageIndex = 1;
      self.$http.post('/userTrack/getPersonTrace', params).then(function (res) {
        self.onLoading = false;
        if (!res.data || !res.data.data) {
          self.queryParam.totalCount = 0;
          self.tableData = [];
          return;
        }
        self.queryParam.uid = res.data.data[0].uid;
        self.queryParam.nickName = res.data.data[0].nickname;
        self.queryParam.mobile = res.data.data[0].mobile;
        self.queryParam.totalCount = res.data.totalCount;

        self.tableData = res.data.data;
        self.getTypeCount(res.data.data);
      });
    },
    goOnTrack: function goOnTrack(row) {
      this.queryParam.id = row.id;
      this.queryParam.traceType = row.trackType;
      this.$router.push({ path: '/user/userTrackEdit', query: this.queryParam });
    },
    getTypeCount: function getTypeCount(val) {
      var self = this;
      var listIndex = 0;
      if (val) {
        self.rowSpanList[listIndex] = 1;
        for (var index = 0; index < val.length; index++) {
          if (val[index + 1]) {
            if (val[index].showType === val[index + 1].showType) {
              self.rowSpanList[listIndex] = self.rowSpanList[listIndex] + 1;
            } else {
              listIndex++;
              self.rowSpanList[listIndex] = 1;
            }
          }
        }
      }
      this.setColSpanNum(this.tableData);
    },
    setColSpanNum: function setColSpanNum(val) {
      var self = this;
      self.count = 0;
      for (var i = 0; i < val.length; i++) {
        val[i].rowSpan = 1;
        val[i].hidden = false;
        if (val[i - 1]) {
          if (val[i].showType === val[i - 1].showType) {
            val[i].hidden = true;
          }
        }
      }
      for (var index = 0; index < self.rowSpanList.length; index++) {
        if (!val[self.count]) {
          return;
        }
        val[self.count].rowSpan = self.rowSpanList[index];
        self.count = self.count + self.rowSpanList[index];
      }
    },
    generateContent: function generateContent(data) {
      if (data) {
        for (var index = 0; index < data.length; index++) {
          this.creatContent(data[index], null);
          this.nodeToList(null, data[index]);
        }
      }
    },
    creatContent: function creatContent(oldData, newData) {
      if (oldData) {
        if (newData) {
          if (newData.traceNode) {
            this.creatContent(oldData, newData.traceNode);
          } else {
            oldData.nextHandlerTime = newData.nextHandlerTime;
            oldData.nextHandlerName = newData.nextHandlerName;
            oldData.operateStatus = newData.operateStatus;
          }
        } else {
          if (oldData.traceNode) {
            this.creatContent(oldData, oldData.traceNode);
          }
        }
      }
    },
    nodeToList: function nodeToList(val, oldVal) {
      if (!val) {
        if (oldVal) {
          if (!oldVal.list) {
            oldVal.list = [];
            oldVal.list.push(oldVal.content);
            if (oldVal.traceNode) {
              this.nodeToList(oldVal.traceNode, oldVal);
            }
          }
        }
      } else {
        oldVal.list.push(val.content);
        if (val.traceNode) {
          this.nodeToList(val.traceNode, oldVal);
        }
      }
    },
    getPersonTrace: function getPersonTrace(uid) {
      var self = this;
      var params = self.queryParam;
      if (uid) {
        self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&createName=' + params.createName + '&createStartTime=' + params.createStartTime + '&createEndTime=' + params.createEndTime + '&startTime=' + params.startTime + '&endTime=' + params.endTime + '&nextHandlerId=' + params.nextHandlerId + '&trackType=' + params.trackType).then(function (res) {
          if (!res.data.data || !res.data.data[0]) {
            self.queryParam.totalCount = 0;
            return;
          }
          self.queryParam.totalCount = res.data.totalCount;
          self.queryParam.pageIndex = res.data.pageIndex;
          self.queryParam.pageSize = res.data.pageSize;
          self.queryParam.uid = res.data.data[0].uid;
          self.queryParam.nickName = res.data.data[0].nickname;
          self.queryParam.mobile = res.data.data[0].mobile;
          self.generateContent(res.data.data);
          self.tableData = res.data.data;
          self.getTypeCount(res.data.data);
        });
        self.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
          if (res.data) {
            self.adminList = res.data;
          }
        });
      }
    }
  },
  created: function created() {
    var self = this;
    self.queryParam.uid = localStorage.getItem('userTraceUid');
    var uid = self.queryParam.uid;
    self.$http.get('/user/queryById?uid=' + uid).then(function (res) {
      if (res.data) {
        if (res.data.firstName) {
          self.bindTch = res.data.firstName + res.data.lastName;
        } else {
          self.bindTch = '';
        }
        self.adviserName = res.data.adviserName;
        self.studyAdviserName = res.data.studyAdviserName;
      }
    });
    self.getPersonTrace(uid);
  },
  mounted: function mounted() {},
  watch: {
    addTime: function addTime(val) {
      if (!val) {
        this.queryParam.createStartTime = '';
        this.queryParam.createEndTime = '';
        return;
      }
      if (val[0]) {
        var left = Date.parse(val[0]);
        this.queryParam.createStartTime = left / 1000;
      }
      if (val[1]) {
        var right = Date.parse(val[1]);
        this.queryParam.createEndTime = right / 1000 + 86399;
      }
    },
    time: function time(val) {
      if (!val) {
        this.queryParam.startTime = '';
        this.queryParam.endTime = '';
        return;
      }
      if (val[0]) {
        var left = Date.parse(val[0]);
        this.queryParam.startTime = left / 1000;
      }
      if (val[1]) {
        var right = Date.parse(val[1]);
        this.queryParam.endTime = right / 1000 + 86399;
      }
    }
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      reload: 0,
      uid: null,
      selectionIds: [],
      queryParam: {
        uid: null,
        status: null,
        studyAdviserId: null,
        startTime: null,
        endTime: null,
        startUpdateTime: null,
        endUpdateTime: null,
        recordType: null
      },
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '状态',
        width: 90,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.reviewClockRecordStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '类型',
        width: 80,
        align: 'center',
        key: 'recordType'
      }, {
        title: '学生',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickname);
        }
      }, {
        title: '学导',
        align: 'center',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserId + '-' + row.studyAdviserName);
        }
      }, {
        title: '课程名称',
        align: 'center',
        width: 150,
        key: 'lessonName'
      }, {
        title: '打卡日期',
        align: 'center',
        width: 170,
        key: 'createdAt'
      }, {
        title: '打卡时长(分)',
        align: 'center',
        width: 120,
        key: 'totalTimeStr'
      }, {
        title: '闯关上传日期',
        align: 'center',
        width: 170,
        key: 'createdAt'
      }, {
        title: '完成批改日期',
        align: 'center',
        width: 170,
        key: 'updatedAt'
      }, {
        title: '闯关视频',
        align: 'center',
        width: 230,
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openVideoModal(row.videoUrl);
              } } }, row.videoUrl);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var statusParam = row.status === 0 ? 1 : 0;
          var text = statusParam === 1 ? '完成批改' : '撤销批改';
          return h('a', { on: { click: function click() {
                return _this.check(row.id, statusParam, text);
              } } }, text);
        }
      }]
    };
  },

  mounted: function mounted() {},
  created: function created() {},
  methods: {
    openVideoModal: function openVideoModal(val) {
      window.open(val, '_blank');
    },
    search: function search() {
      this.selectionIds = [];
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    check: function check(id, status, text) {
      var self = this;
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">' + text + '</span>?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/study_record/check', { id: id, status: status }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionIds = selection;
    },
    batchCheck: function batchCheck() {
      if (this.selectionIds.length <= 0) {
        this.$Message.warning('请选择需批改的记录！');
        return;
      }
      var self = this;
      var idList = self.selectionIds.map(function (element) {
        return element.id;
      });
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">批量完成批改</span>?',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.$http.post('/study_record/batchCheck', { ids: idList, status: 1 }).then(function (res) {
            if (res) {
              self.search();
            }
          });
        }
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/study_record/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '打卡闯关列表.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      saveLoading: false,
      reload: 0,
      showModal: false,
      defaultFileList: [],
      queryParam: {
        sentence: '',
        status: null
      },
      formData: this.emptyForm(),
      formRules: {
        sentence: [{ required: true, message: '请输入原句' }]
      },
      title: [{
        title: '原句',
        minWidth: 200,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.displaySentence || row.sentence || '');
        }
      }, { title: '中文翻译', minWidth: 180, key: 'cnTranslate' }, {
        title: '音频',
        minWidth: 200,
        render: function render(h, params) {
          var url = params.row.audioUrl;
          if (!url) {
            return h('span', '');
          }
          return h('audio', {
            attrs: { src: url, controls: 'controls', preload: 'none' },
            style: { width: '180px', height: '32px' }
          });
        }
      }, {
        title: '状态',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          if (row.statusText) {
            return h('span', row.statusText);
          }
          return h('span', row.status === 1 ? '启用' : '停用');
        }
      }, { title: '修改时间', minWidth: 160, key: 'gmtModified' }, {
        title: '操作',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          var btns = [];
          if (row.status === 1 || row.statusText === '启用') {
            btns.push(h('Button', {
              props: { type: 'warning', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 0);
                } }
            }, '停用'));
          } else {
            btns.push(h('Button', {
              props: { type: 'success', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 1);
                } }
            }, '启用'));
          }
          btns.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.openModal(row);
              } }
          }, '编辑'));
          return h('div', btns);
        }
      }]
    };
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        sentence: '',
        cnTranslate: '',
        audioUrl: '',
        status: 1
      };
    },
    openModal: function openModal(row) {
      if (row) {
        this.formData = {
          id: row.id,
          sentence: row.sentence || row.displaySentence || '',
          cnTranslate: row.cnTranslate || '',
          audioUrl: row.audioUrl || '',
          status: row.status == null ? 1 : row.status
        };
        var url = row.audioUrl;
        this.defaultFileList = url ? [{ name: row.audioName || url, url: url, status: 'finished' }] : [];
      } else {
        this.formData = this.emptyForm();
        this.defaultFileList = [];
      }
      this.showModal = true;
    },
    onFileChange: function onFileChange(files) {
      if (files && files.length) {
        this.formData.audioUrl = files[0].url;
      } else {
        this.formData.audioUrl = '';
      }
    },
    onSave: function onSave() {
      if (!this.formData.sentence) {
        this.$Message.warning('请输入原句');
        return;
      }
      var self = this;
      self.saveLoading = true;
      self.$http.post('/sentenceCard/save', {}, {
        transformRequest: [function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.saveLoading = false;
        if (res.status === 'ok') {
          self.$Message.success('保存成功');
          self.showModal = false;
          self.search();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    changeStatus: function changeStatus(row, status) {
      var self = this;
      self.$http.post('/sentenceCard/updateStatus', { id: row.id, status: status }).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('操作成功');
          self.search();
        }
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentMonthStatList',
  data: function data() {
    return {
      searchLoading: false,
      tableLoading: false,
      totalCount: 0,
      tableData: [],
      queryParam: {
        periodLabel: '',
        pageIndex: 1,
        pageSize: 20
      },
      columns: [{ title: '年月', key: 'periodLabel', minWidth: 90 }, { title: '学生总数', key: 'totalStudent', minWidth: 90 }, { title: '在读学生', key: 'activeStudent', minWidth: 90 }, { title: '停课学员', key: 'stopStudent', minWidth: 90 }, { title: '一周一节课', key: 'oneWeekOneLesson', minWidth: 100 }, { title: '新增量', key: 'newAssign', minWidth: 80 }, { title: '实际结课量', key: 'finishCount', minWidth: 100 }, { title: '总课耗', key: 'consumeNum', minWidth: 80 }, { title: '课耗系数', key: 'consumeCoef', minWidth: 90 }, { title: '提前请假', key: 'earlyLeave', minWidth: 90 }, { title: '临时请假', key: 'tempLeave', minWidth: 90 }, { title: '学生缺席数', key: 'absentNum', minWidth: 100 }, { title: '返还课时', key: 'returnNum', minWidth: 90 }, { title: '续费业绩', key: 'renewAmount', minWidth: 100 }, { title: '续费量', key: 'renewCount', minWidth: 80 }, { title: '学导人数', key: 'adviserCount', minWidth: 90 }, { title: '人效', key: 'efficiency', minWidth: 90 }, { title: '每单均价', key: 'avgOrderAmount', minWidth: 90 }, { title: '续费总课时', key: 'renewLessonNum', minWidth: 100 }, { title: '课单价', key: 'lessonUnitPrice', minWidth: 90 }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    search: function search() {
      this.queryParam.pageIndex = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(p) {
      this.queryParam.pageIndex = p;
      this.loadData();
    },
    onPageSizeChange: function onPageSizeChange(s) {
      this.queryParam.pageSize = s;
      this.queryParam.pageIndex = 1;
      this.loadData();
    },
    loadData: function loadData() {
      var self = this;
      self.searchLoading = true;
      self.tableLoading = true;
      var url = '/studentMonthStat/list';
      self.$http.post(url, self.queryParam).then(function (res) {
        self.searchLoading = false;
        self.tableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.tableData = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
        }
      }).catch(function () {
        self.searchLoading = false;
        self.tableLoading = false;
      });
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_aiApi__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_aiAccess__ = __webpack_require__(30);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentRiskList',
  components: {
    AiDrawer: __WEBPACK_IMPORTED_MODULE_2__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      aiSnapshotId: null,
      showFollowupModal: false,
      followupLoading: false,
      followupForm: {
        snapshotId: null,
        uid: null,
        action: 'CALL',
        result: null,
        comment: '',
        writeTrack: false
      },
      queryParam: {
        level: null,
        studyAdviserId: null,
        days: 7,
        unfollowedOnly: true
      },
      title: [{
        title: '学生ID',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var uid = row.uid;
          return h('a', { on: { click: function click() {
                return _this.openStudent(uid);
              } } }, uid);
        }
      }, {
        title: '等级',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var level = params.row.level;
          var text = _this.levelText(level);
          var color = Number(level) === 2 ? '#ed4014' : Number(level) === 1 ? '#ff9900' : '#19be6b';
          return h('span', { style: { color: color, fontWeight: '600' } }, text);
        }
      }, {
        title: '分数',
        width: 80,
        align: 'center',
        key: 'score'
      }, {
        title: '原因摘要',
        align: 'center',
        render: function render(h, params) {
          var text = _this.reasonText(params.row);
          if (!text) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover',
              placement: 'top',
              transfer: true
            }
          }, [h('span', {
            style: {
              display: 'inline-block',
              maxWidth: '220px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              verticalAlign: 'middle'
            }
          }, text), h('div', {
            slot: 'content',
            style: {
              maxWidth: '360px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              textAlign: 'left'
            }
          }, text)]);
        }
      }, {
        title: '学导',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserName || row.studyAdviserId || '');
        }
      }, {
        title: '计算日',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.calcDate || params.row.calc_date || '');
        }
      }, {
        title: '是否已跟进',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.followedText(params.row));
        }
      }, {
        title: '操作',
        width: 140,
        align: 'center',
        fixed: 'right',
        render: function render(h, params) {
          var row = params.row;
          return h('span', [h('a', { on: { click: function click() {
                return _this.openExplain(row);
              } } }, '解释'), h('span', '  '), h('a', { on: { click: function click() {
                return _this.openFollowup(row);
              } } }, '写跟进')]);
        }
      }]
    };
  },
  created: function created() {
    var self = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tools_aiAccess__["b" /* fetchAiAllowed */])(this.$http).then(function (allowed) {
      if (!allowed) {
        self.$router.replace('/index');
        return;
      }
      self.aiAllowed = true;
    });
  },
  methods: {
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    levelText: function levelText(level) {
      if (Number(level) === 2) {
        return '高';
      }
      if (Number(level) === 1) {
        return '中';
      }
      if (Number(level) === 0) {
        return '低';
      }
      return level == null ? '' : String(level);
    },
    reasonText: function reasonText(row) {
      var raw = row.reasonsJson || row.reasons_json || row.reasonSummary || row.reasonText || row.reasons || '';
      if (raw && (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(raw)) === 'object') {
        try {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(raw);
        } catch (e) {
          return String(raw);
        }
      }
      return raw || '';
    },
    followedText: function followedText(row) {
      if (row.followed === true || row.hasFollowup === true || row.followedFlag === true || row.unfollowed === false) {
        return '已跟进';
      }
      if (row.lastFollowupTime || row.followupTime || row.lastFollowTime || row.followupId) {
        return '已跟进';
      }
      if (row.followed === false || row.hasFollowup === false || row.unfollowed === true) {
        return '未跟进';
      }
      return row.followedText || '未跟进';
    },
    openStudent: function openStudent(uid) {
      if (!uid) {
        return;
      }
      var resolved = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: uid, tabName: 0, backPath: '/user/studentRiskList' }
      });
      window.open(resolved.href, '_blank');
    },
    openExplain: function openExplain(row) {
      this.aiUid = row.uid;
      this.aiSnapshotId = row.snapshotId || row.id;
      this.aiVisible = true;
    },
    openFollowup: function openFollowup(row) {
      this.followupForm = {
        snapshotId: row.snapshotId || row.id,
        uid: row.uid,
        action: 'CALL',
        result: null,
        comment: '',
        writeTrack: false
      };
      this.showFollowupModal = true;
    },
    submitFollowup: function submitFollowup() {
      var self = this;
      if (!self.followupForm.snapshotId) {
        self.$Message.warning('缺少快照');
        return;
      }
      if (!self.followupForm.action) {
        self.$Message.warning('请选择动作');
        return;
      }
      self.followupLoading = true;
      self.$http.post(__WEBPACK_IMPORTED_MODULE_3__tools_aiApi__["k" /* RISK_URI */].followup, {
        snapshotId: self.followupForm.snapshotId,
        action: self.followupForm.action,
        result: self.followupForm.result,
        comment: self.followupForm.comment,
        writeTrack: self.followupForm.writeTrack
      }).then(function (res) {
        self.followupLoading = false;
        if (res && res.status === 'ok') {
          self.showFollowupModal = false;
          self.reload = new Date().getTime();
          self.$Message.success('跟进已保存');
        }
      }).catch(function () {
        self.followupLoading = false;
      });
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
      this.aiSnapshotId = null;
    },
    onAiExecuted: function onAiExecuted() {
      this.reload = new Date().getTime();
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWeekStatList',
  data: function data() {
    return {
      searchLoading: false,
      tableLoading: false,
      totalCount: 0,
      tableData: [],
      queryParam: {
        periodLabel: '',
        pageIndex: 1,
        pageSize: 20
      },
      columns: [{ title: '部门', key: 'deptName', minWidth: 90 }, { title: '周时间', key: 'periodLabel', minWidth: 180 }, { title: '总学生', key: 'totalStudent', minWidth: 90 }, { title: '在读学生', key: 'activeStudent', minWidth: 90 }, { title: '停课学生', key: 'stopStudent', minWidth: 90 }, { title: '一周一节课学生', key: 'oneWeekOneLesson', minWidth: 120 }, { title: '新增量', key: 'newAssign', minWidth: 80 }, { title: '结课量', key: 'finishCount', minWidth: 80 }, { title: '课耗', key: 'consumeNum', minWidth: 80 }, { title: '提前请假', key: 'earlyLeave', minWidth: 90 }, { title: '临时请假', key: 'tempLeave', minWidth: 90 }, { title: '缺席', key: 'absentNum', minWidth: 80 }, { title: '学导原因返还课时', key: 'adviserReturnNum', minWidth: 140 }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    search: function search() {
      this.queryParam.pageIndex = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(p) {
      this.queryParam.pageIndex = p;
      this.loadData();
    },
    onPageSizeChange: function onPageSizeChange(s) {
      this.queryParam.pageSize = s;
      this.queryParam.pageIndex = 1;
      this.loadData();
    },
    loadData: function loadData() {
      var self = this;
      self.searchLoading = true;
      self.tableLoading = true;
      var url = '/studentWeekStat/list';
      self.$http.post(url, self.queryParam).then(function (res) {
        self.searchLoading = false;
        self.tableLoading = false;
        if (res && res.status === 'ok' && res.data) {
          self.tableData = res.data.data || [];
          self.totalCount = res.data.totalCount || 0;
        }
      }).catch(function () {
        self.searchLoading = false;
        self.tableLoading = false;
      });
    }
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        studentId: '',
        username: '',
        mobile: '',
        word: ''
      },
      title: [{ title: '学生ID', width: 100, key: 'studentId' }, { title: '姓名', minWidth: 100, key: 'username' }, {
        title: '手机号',
        width: 130,
        render: function render(h, params) {
          return _this.renderMobile(h, params.row.mobile);
        }
      }, {
        title: '单词',
        minWidth: 120,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.displayWord || row.word || '');
        }
      }, { title: '音标', minWidth: 120, key: 'usPhonetic' }, {
        title: '释义',
        minWidth: 180,
        render: function render(h, params) {
          var text = params.row.explains || '';
          return h('div', {
            attrs: { title: text },
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }, text);
        }
      }, { title: '跟读次数', width: 100, key: 'evalCount' }, { title: '平均分', width: 90, key: 'avgScore' }, { title: '最近得分', width: 90, key: 'lastScore' }, {
        title: '最近录音',
        minWidth: 200,
        render: function render(h, params) {
          var url = params.row.lastAudioUrl;
          if (!url) {
            return h('span', '');
          }
          return h('audio', {
            attrs: { src: url, controls: 'controls', preload: 'none' },
            style: { width: '180px', height: '32px' }
          });
        }
      }, { title: '收藏时间', minWidth: 160, key: 'gmtModified' }]
    };
  },

  methods: {
    renderMobile: function renderMobile(h, mobile) {
      if (!mobile || typeof mobile === 'string' && mobile.startsWith('n')) {
        return h('span', '');
      }
      var display = String(mobile).length === 11 ? String(mobile).substring(0, 3) + '****' + String(mobile).substring(7) : mobile;
      return h('Poptip', {
        props: { trigger: 'hover' }
      }, [h('span', {}, display), h('div', { slot: 'content' }, mobile)]);
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        studentId: '',
        username: '',
        mobile: '',
        evalType: '',
        content: ''
      },
      title: [{ title: '学生ID', width: 100, key: 'studentId' }, { title: '姓名', minWidth: 100, key: 'username' }, {
        title: '手机号',
        width: 130,
        render: function render(h, params) {
          return _this.renderMobile(h, params.row.mobile);
        }
      }, {
        title: '类型',
        width: 90,
        render: function render(h, params) {
          var t = params.row.evalType;
          if (t === 'WORD') {
            return h('span', '单词');
          }
          if (t === 'SENTENCE') {
            return h('span', '句子');
          }
          return h('span', t || '');
        }
      }, { title: '文本', minWidth: 180, key: 'content' }, { title: '得分', width: 80, key: 'score' }, { title: '反馈', minWidth: 160, key: 'feedback' }, {
        title: '录音',
        minWidth: 200,
        render: function render(h, params) {
          var url = params.row.audioUrl;
          if (!url) {
            return h('span', '');
          }
          return h('audio', {
            attrs: { src: url, controls: 'controls', preload: 'none' },
            style: { width: '180px', height: '32px' }
          });
        }
      }, { title: '时间', minWidth: 160, key: 'gmtCreate' }]
    };
  },

  methods: {
    renderMobile: function renderMobile(h, mobile) {
      if (!mobile || typeof mobile === 'string' && mobile.startsWith('n')) {
        return h('span', '');
      }
      var display = String(mobile).length === 11 ? String(mobile).substring(0, 3) + '****' + String(mobile).substring(7) : mobile;
      return h('Poptip', {
        props: { trigger: 'hover' }
      }, [h('span', {}, display), h('div', { slot: 'content' }, mobile)]);
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewDemo',
  props: {
    formData: {
      type: Object,
      default: {
        return: {}
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    },
    skipPart1: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  data: function data() {
    return {
      uid: '',
      openid: '',
      state: '',
      showModal: this.value,
      loading: false,
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            demoComment = _res$data.demoComment;

        self.uid = uid;
        if (demoComment) {
          var obj = JSON.parse(demoComment);
          _this.formData.remark = obj.part1;
          var word = obj.part2.split(',');
          if (word.length > 1) {
            var _word = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(word, 2);

            _this.formData.word1 = _word[0];
            _this.formData.word2 = _word[1];
          }
        } else {
          _this.formData.remark = '';
          _this.formData.word1 = '';
          _this.formData.word2 = '';
        }
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSubmit: function onSubmit() {
      var self = this;
      var part1 = this.formData.remark;

      if (this.formData.word1 === '' || this.formData.word2 === '') {
        self.$Message.error('Part 2 needs to be fully filled');
        return;
      }
      var part2 = [this.formData.word1, this.formData.word2].join(',');
      var data = {
        part1: part1,
        part2: part2
      };
      var parmas = {};
      parmas.demoComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      parmas.lsnOpenId = self.openid;

      parmas.uid = self.uid;
      parmas.version = 1;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        self.$Message.success('success');
        self.showModal = false;
      }).catch(function (e) {});
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewDemoV2',
  props: {
    formData: {
      type: Object,
      default: {
        return: {
          part1: {
            type: '',
            words: ''
          },
          part2: {
            type: '',
            words: ''
          },
          part3: {
            type: '',
            words: ''
          },
          part4: {
            type: '',
            words: ''
          },
          part5: {
            type: '',
            words: 'a perfect fit'
          },
          part6: {
            type: '',
            words: ''
          },
          part7: {
            type: '',
            words: ''
          },
          part8: {
            type: '',
            words: ''
          },
          part9: {
            type: '',
            words: false
          },
          part10: {
            type: '',
            words: false
          }
        }
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uid: '',
      openid: '',
      state: '',
      showModal: this.value,
      loading: false,
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      },
      nickname: '',
      title: '',
      version: 1,
      evaluation: '',
      levels: ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8'],
      levelNames: ['a bit difficult', 'a perfect fit', 'a bit easy'],
      partData: {
        part1: {
          type: '',
          words: ''
        },
        part2: {
          type: '',
          words: ''
        },
        part3: {
          type: '',
          words: ''
        },
        part4: {
          type: '',
          words: ''
        },
        part5: {
          type: '',
          words: 'a perfect fit'
        },
        part6: {
          type: '',
          words: ''
        },
        part7: {
          type: '',
          words: ''
        },
        part8: {
          type: '',
          words: ''
        },
        part9: {
          type: '',
          words: false
        },
        part10: {
          type: '',
          words: false
        }
      }
    };
  },

  methods: {
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            demoComment = _res$data.demoComment,
            nickname = _res$data.nickname,
            title = _res$data.title,
            version = _res$data.version,
            evaluation = _res$data.evaluation;

        self.uid = uid;
        self.nickname = nickname;
        self.title = title;
        self.version = version;
        self.evaluation = evaluation;
        if (demoComment) {
          console.log(demoComment);

          var dataObj = JSON.parse(demoComment);
          _this.partData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.partData, dataObj);
        } else {
          _this.partData = {
            part1: {
              type: '',
              words: ''
            },
            part2: {
              type: '',
              words: ''
            },
            part3: {
              type: '',
              words: ''
            },
            part4: {
              type: '',
              words: ''
            },
            part5: {
              type: '',
              words: ''
            },
            part6: {
              type: '',
              words: ''
            },
            part7: {
              type: '',
              words: ''
            },
            part8: {
              type: '',
              words: ''
            },
            part9: {
              type: '',
              words: false
            },
            part10: {
              type: '',
              words: false
            }
          };
        }
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (self.partData.part1.type === '') {
        self.$Message.error('Part 1 requires priority selection');
        return;
      }
      if (!self.partData.part2.type || !self.partData.part3.type || !self.partData.part3.words || !self.partData.part4.type || !self.partData.part5.type || !self.partData.part5.words) {
        self.$Message.error('Part 2 needs to be fully filled');
        return;
      }
      if (!self.partData.part6.type) {
        self.$Message.error('Part 3 needs to be fully filled');
        return;
      }
      if (!self.partData.part7.words) {
        self.$Message.error('Part 4 needs to be fully filled');
        return;
      }

      if (!self.partData.part9.words && !self.partData.part10.words) {
        self.$Message.error('This suggestion requires selecting no less than one');
        return;
      }
      if (!self.evaluation) {
        self.$Message.error("The student's English level must be entered (e.g. Level 5.1)");
        return;
      }
      var isValid = self.evaluation;
      if (isValid.includes('.')) {
        isValid = isValid.split('.')[0];
      } else {
        if (!self.levels.includes(isValid)) {
          self.$Message.error("The student's English level must be entered (e.g. Level 1 ~ Level 8)");
          return;
        }
      }
      var parmas = {};
      parmas.demoComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partData);
      parmas.lsnOpenId = self.openid;
      parmas.reviewState = self.state;
      parmas.uid = self.uid;
      parmas.evaluation = self.evaluation;
      parmas.version = 2;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        self.$Message.success('success');
        self.showModal = false;
      }).catch(function (e) {
        self.$Message.error('Failed to submit');
      });
    },
    changeType: function changeType(key, value) {
      this.partData[key].type = value;
      this.partData[key].words = '';
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewFinishLevel',
  props: {
    formData: {
      type: Object,
      default: {
        return: {}
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      title: '',
      uid: '',
      openid: '',
      state: '',
      form: {
        rating: 4
      },
      rateValue: 0,
      v1: 4,
      v2: 2,
      showModal: this.value,
      loading: false,
      StudentWriteReiviewFormData: {
        lessonId: null,
        tchId: null,
        status: 0,
        remark: ''
      },
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    changeFile: function changeFile(fileList) {
      this.formData.fileList = fileList;
    },
    handleChange: function handleChange(value) {
      if (value < 2) {
        this.rateValue = 2;
      }
    },
    starChange: function starChange(v) {
      console.log(this.v2);
      console.log(this.v2);
    },
    onClose: function onClose() {
      this.StudentWriteReiviewFormData = {};
      this.$emit('on-close');
    },
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            stageComment = _res$data.stageComment,
            nickname = _res$data.nickname,
            routineEndNum = _res$data.routineEndNum;

        _this.title = nickname + ' congratulations on completing ' + routineEndNum + ' English classes! You should be proud of yourself for making it through this course, with all of the hard work and dedication that you put in. English is a challenging language to learn, but you pushed through and made progress each day. Whether it was improving your grammar, expanding your vocabulary, or practicing your speaking and listening skills, you\'ve developed valuable language abilities that will serve you well in the future.';
        if (stageComment) {
          var _JSON$parse = JSON.parse(stageComment),
              part1 = _JSON$parse.part1,
              part2 = _JSON$parse.part2;

          _this.formData.remark = part1;
          _this.formData.suggestions = part2.text;
          if (part2.file !== '') {
            _this.formData.fileList = [{ url: part2.file }];
          } else {
            _this.formData.fileList = [];
          }
        } else {
          _this.formData.remark = '';
          _this.formData.suggestions = '';
          _this.formData.fileList = [];
        }
        self.uid = uid;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      var part1 = this.formData.remark;
      if (!self.hasNumWords(part1, 80)) {
        self.$Message.error('Part 1 requires at least 80 words to be entered');
        return;
      }
      var part2 = {
        text: this.formData.suggestions,
        file: this.formData.fileList.length > 0 ? this.formData.fileList[0].url : ''
      };
      var data = {
        part1: part1,
        part2: part2
      };
      var parmas = {};
      parmas.stageComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      parmas.lsnOpenId = self.openid;

      parmas.uid = self.uid;
      parmas.version = 1;
      parmas.stageSummary = true;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        self.$Message.success('success');
        self.showModal = false;
      }).catch(function (e) {});
      console.log(data);
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewFinishLevelV2',
  props: {
    formData: {
      type: Object,
      default: {
        return: {
          rate1: 2,
          rate2: 2,
          rate3: 2,
          rate4: 2,
          rate5: 2,
          rate6: 2,
          word1: '',
          word2: '',
          word3: ''
        }
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    successCallback: {
      type: Function
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uid: '',
      openid: '',
      state: '',
      form: {
        rating: 4
      },
      rateValue: 0,
      v1: 4,
      v2: 2,
      showModal: this.value,
      loading: false,
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    changeFile: function changeFile(fileList) {
      this.formData.fileList = fileList;
    },
    deleteItem: function deleteItem(element, index, limit) {
      if (element.length === 1) {
        this.$Message.warning('can\'t not remove defalut input');
        return;
      }
      if (element.length > limit) {
        element.splice(index, 1);
      } else {
        this.$Message.warning('At least ' + limit + ' words!');
      }
    },
    addItem: function addItem(element) {
      element.push({ remark: '' });
    },
    handleChange: function handleChange(value) {
      this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2;
      this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2;
      this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2;
      this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2;
      this.formData.rate5 = this.formData.rate5 > 2 ? this.formData.rate5 : 2;
      this.formData.rate6 = this.formData.rate6 > 2 ? this.formData.rate6 : 2;
    },
    starChange: function starChange(v) {
      console.log(this.v2);
      console.log(this.v2);
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    getWord: function getWord(element) {
      if (!element) {
        return [];
      }
      var word = [];
      element.match(/[^,，\s]+/g).forEach(function (v) {
        if (v.trim() !== '') {
          word.push(v.trim());
        }
      });
      return word;
    },
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            goodComment = _res$data.goodComment;

        self.uid = uid;
        if (goodComment) {
          var _JSON$parse = JSON.parse(goodComment),
              part1 = _JSON$parse.part1,
              part2 = _JSON$parse.part2;

          var rateList = part1.split(',');
          var intList = rateList.map(function (v) {
            return parseInt(v, 10);
          });
          if (rateList.length >= 6) {
            var _intList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(intList, 6);

            _this.formData.rate1 = _intList[0];
            _this.formData.rate2 = _intList[1];
            _this.formData.rate3 = _intList[2];
            _this.formData.rate4 = _intList[3];
            _this.formData.rate5 = _intList[4];
            _this.formData.rate6 = _intList[5];
          }
          _this.handleChange();
          _this.formData.word1 = part2[0];
          _this.formData.word2 = part2[1];
          _this.formData.word3 = part2[2];
        } else {
          var _ref = [2, 2, 2, 2, 2, 2];
          _this.formData.rate1 = _ref[0];
          _this.formData.rate2 = _ref[1];
          _this.formData.rate3 = _ref[2];
          _this.formData.rate4 = _ref[3];
          _this.formData.rate5 = _ref[4];
          _this.formData.rate6 = _ref[5];

          _this.formData.word1 = '';
          _this.formData.word2 = '';
          _this.formData.word3 = '';
        }
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      var word1 = this.getWord(this.formData.word1);
      if (word1.length < 20) {
        this.$Message.error('1.Improvements of the words: At least 20 words!');
        return;
      }
      var word2 = this.getWord(this.formData.word2);
      if (word2.length < 20) {
        this.$Message.error('2.Difficulties of the words: At least 20 words!');
        return;
      }
      var word3 = this.getWord(this.formData.word3);
      if (word3.length < 30) {
        this.$Message.error('3.Suggestions of the words: At least 30 words!');
        return;
      }

      var part1 = [];
      part1.push(this.formData.rate1 + '');
      part1.push(this.formData.rate2 + '');
      part1.push(this.formData.rate3 + '');
      part1.push(this.formData.rate4 + '');
      part1.push(this.formData.rate5 + '');
      part1.push(this.formData.rate6 + '');

      console.log('word1', this.formData.word1);
      var part2 = {
        0: this.formData.word1,
        1: this.formData.word2,
        2: this.formData.word3
      };
      var data = {
        part1: part1.join(','),
        part2: part2
      };
      var parmas = {};
      parmas.goodComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      parmas.lsnOpenId = self.openid;
      parmas.reviewState = self.state;
      parmas.uid = self.uid;
      parmas.version = 2;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('success!');
          self.showModal = false;
          self.$emit('on-close');
          self.successCallback();
        }
      }).catch(function (e) {});
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    myValue: function myValue(val) {
      this.myValue = 2;
      this.v1 = 3;
      this.$nextTick();
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewRegular',
  props: {
    formData: {
      type: Object,
      default: {
        return: {}
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uid: '',
      openid: '',
      state: '',
      form: {
        rating: 4
      },
      rateValue: 0,
      v1: 4,
      v2: 2,
      showModal: this.value,
      loading: false,
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    changeFile: function changeFile(fileList) {
      this.formData.fileList = fileList;
    },
    deleteItem: function deleteItem(element, index, limit) {
      if (element.length === 1) {
        this.$Message.warning('can\'t not remove defalut input');
        return;
      }
      if (element.length > limit) {
        element.splice(index, 1);
      } else {
        this.$Message.warning('At least ' + limit + ' words!');
      }
    },
    addItem: function addItem(element) {
      element.push({ remark: '' });
    },
    handleChange: function handleChange(value) {
      this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2;
      this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2;
      this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2;
      this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2;
    },
    starChange: function starChange(v) {
      console.log(this.v2);
      console.log(this.v2);
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    getWord: function getWord(element) {
      var word = [];
      element.forEach(function (v) {
        if (v.remark !== '') {
          word.push(v.remark);
        }
      });
      return word;
    },
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            regularComment = _res$data.regularComment;

        self.uid = uid;
        if (regularComment) {
          var _JSON$parse = JSON.parse(regularComment),
              part1 = _JSON$parse.part1,
              part2 = _JSON$parse.part2,
              part3 = _JSON$parse.part3;

          var rateList = part1.split(',');
          var intList = rateList.map(function (v) {
            return parseInt(v, 10);
          });
          if (rateList.length >= 4) {
            var _intList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(intList, 4);

            _this.formData.rate1 = _intList[0];
            _this.formData.rate2 = _intList[1];
            _this.formData.rate3 = _intList[2];
            _this.formData.rate4 = _intList[3];
          }
          _this.handleChange();
          _this.formData.word1 = [];
          part2[0].forEach(function (v) {
            _this.formData.word1.push({ remark: v });
          });
          _this.formData.word2 = [];
          part2[1].forEach(function (v) {
            _this.formData.word2.push({ remark: v });
          });
          _this.formData.word3 = [];
          part2[2].forEach(function (v) {
            _this.formData.word3.push({ remark: v });
          });
          _this.formData.word4 = [];
          part2[3].forEach(function (v) {
            _this.formData.word4.push({ remark: v });
          });
          _this.formData.parent = part3[0];
          if (part3[1] !== '') {
            _this.formData.fileList = [{ url: part3[1] }];
          } else {
            _this.formData.fileList = [];
          }
          console.log('fileurl', _this.formData.fileList);
          _this.formData.levelMsg = part3[2];
        } else {
          var _ref = [2, 2, 2, 2];
          _this.formData.rate1 = _ref[0];
          _this.formData.rate2 = _ref[1];
          _this.formData.rate3 = _ref[2];
          _this.formData.rate4 = _ref[3];

          _this.formData.word1 = [{ remark: '' }, { remark: '' }, { remark: '' }];
          _this.formData.word2 = [{ remark: '' }, { remark: '' }, { remark: '' }];
          _this.formData.word3 = [{ remark: '' }];
          _this.formData.word4 = [{ remark: '' }];
          _this.formData.fileList = [];
          _this.formData.levelMsg = '';
        }
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      var word1 = this.getWord(this.formData.word1);
      if (word1.length < 3) {
        this.$Message.error('1.Pronunciation of the words: At least 3 words!');
        return;
      }
      var word2 = this.getWord(this.formData.word2);
      if (word2.length < 3) {
        this.$Message.error('2.Usage of the words: At least 3 words!');
        return;
      }
      var word3 = this.getWord(this.formData.word3);
      if (word3.length < 1) {
        this.$Message.error('3.Difficult sentences: At least 1  sentences!');
        return;
      }
      var word4 = this.getWord(this.formData.word4);
      var part1 = [];
      part1.push(this.formData.rate1 + '');
      part1.push(this.formData.rate2 + '');
      part1.push(this.formData.rate3 + '');
      part1.push(this.formData.rate4 + '');
      var part2 = {
        0: word1,
        1: word2,
        2: word3,
        3: word4
      };
      var part3 = {
        0: this.formData.parent,
        1: this.formData.fileList.length > 0 ? this.formData.fileList[0].url : '',
        2: this.formData.levelMsg
      };
      var data = {
        part1: part1.join(','),
        part2: part2,
        part3: part3
      };
      var parmas = {};
      parmas.regularComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      parmas.lsnOpenId = self.openid;
      parmas.reviewState = self.state;
      parmas.uid = self.uid;
      parmas.version = 1;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        self.$Message.success('success');
        self.showModal = false;
      }).catch(function (e) {});
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    myValue: function myValue(val) {
      console.log(this.v2);
      this.myValue = 2;
      this.v1 = 3;
      this.$nextTick();
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        console.log(1231321);

        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentWriteReviewRegularV2',
  props: {
    formData: {
      type: Object,
      default: {
        return: {
          rate1: 2,
          rate2: 2,
          rate3: 2,
          rate4: 2,
          rate5: 2,
          rate6: 2,
          parent: ''
        }
      }
    },
    value: {
      type: Boolean,
      default: {
        return: false
      }
    },
    openedId: {
      type: Number
    },
    reviewState: {
      type: Number
    },
    successCallback: {
      type: Function
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uid: '',
      openid: '',
      state: '',
      form: {
        rating: 4
      },
      rateValue: 0,
      v1: 4,
      v2: 2,
      showModal: this.value,
      loading: false,
      lessonErrRule: {
        remark: [{ type: 'string', required: true, message: ' ', trigger: 'blur' }]
      },
      remark: 'Please review the lesson content from our app today, I hope to see you again in the next class.'
    };
  },

  methods: {
    changeFile: function changeFile(fileList) {
      this.formData.fileList = fileList;
    },
    deleteItem: function deleteItem(element, index, limit) {
      if (element.length === 1) {
        this.$Message.warning('can\'t not remove defalut input');
        return;
      }
      if (element.length > limit) {
        element.splice(index, 1);
      } else {
        this.$Message.warning('At least ' + limit + ' words!');
      }
    },
    addItem: function addItem(element) {
      element.push({ remark: '' });
    },
    handleChange: function handleChange(value) {
      this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2;
      this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2;
      this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2;
      this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2;
      this.formData.rate5 = this.formData.rate5 > 2 ? this.formData.rate5 : 2;
      this.formData.rate6 = this.formData.rate6 > 2 ? this.formData.rate6 : 2;
    },
    starChange: function starChange(v) {
      console.log(this.v2);
      console.log(this.v2);
    },
    onClose: function onClose() {
      this.$emit('on-close');
    },
    getWord: function getWord(element) {
      if (!element) {
        return [];
      }
      var word = [];
      element.match(/[^,，\s]+/g).forEach(function (v) {
        if (v.trim() !== '') {
          word.push(v.trim());
        }
      });
      return word;
    },
    hasNumWords: function hasNumWords(str, num) {
      var words = str.split(' ');
      return words.length >= num;
    },
    onload: function onload() {
      var _this = this;

      var self = this;
      self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(function (res) {
        var _res$data = res.data,
            uid = _res$data.uid,
            learnedComment = _res$data.learnedComment;

        self.uid = uid;
        if (learnedComment) {
          var _JSON$parse = JSON.parse(learnedComment),
              part1 = _JSON$parse.part1,
              part3 = _JSON$parse.part3;

          var rateList = part1.split(',');
          var intList = rateList.map(function (v) {
            return parseInt(v, 10);
          });
          if (rateList.length >= 6) {
            var _intList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(intList, 6);

            _this.formData.rate1 = _intList[0];
            _this.formData.rate2 = _intList[1];
            _this.formData.rate3 = _intList[2];
            _this.formData.rate4 = _intList[3];
            _this.formData.rate5 = _intList[4];
            _this.formData.rate6 = _intList[5];
          }
          _this.handleChange();

          _this.formData.parent = part3[0];
        } else {
          var _ref = [2, 2, 2, 2, 2, 2];
          _this.formData.rate1 = _ref[0];
          _this.formData.rate2 = _ref[1];
          _this.formData.rate3 = _ref[2];
          _this.formData.rate4 = _ref[3];
          _this.formData.rate5 = _ref[4];
          _this.formData.rate6 = _ref[5];
        }
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      var word1 = this.getWord(this.formData.parent);
      if (word1.length < 30) {
        this.$Message.error("Teacher's Feedback of the words: At least 30 words!");
        return;
      }

      var part1 = [];
      part1.push(this.formData.rate1 + '');
      part1.push(this.formData.rate2 + '');
      part1.push(this.formData.rate3 + '');
      part1.push(this.formData.rate4 + '');
      part1.push(this.formData.rate5 + '');
      part1.push(this.formData.rate6 + '');

      var part3 = {
        0: this.formData.parent
      };
      var data = {
        part1: part1.join(','),
        part3: part3
      };
      var parmas = {};
      parmas.learnedComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      parmas.lsnOpenId = self.openid;
      parmas.reviewState = self.state;
      parmas.uid = self.uid;
      parmas.version = 2;
      this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('success!');
          self.showModal = false;
          self.$emit('on-close');
          self.successCallback(res.data);
        }
      }).catch(function (e) {});
    }
  },
  watch: {
    reviewState: function reviewState(val) {
      this.state = val;
    },
    openedId: function openedId(val) {
      this.openid = val;
    },
    myValue: function myValue(val) {
      console.log(this.v2);
      this.myValue = 2;
      this.v1 = 3;
      this.$nextTick();
    },
    value: function value(val) {
      this.showModal = val;
      if (val === true) {
        console.log(1231321);

        this.onload();
      } else {}
    },
    showModal: function showModal(val) {
      if (val === false) {
        this.$emit('on-close');
      }
    },
    formData: function formData(val) {
      if (val) {
        this.lessonErrFormData = val;
      }
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TchRebindBoard',
  data: function data() {
    var _this = this;

    var now = this.$moment();
    var startDate = '2025-09-01';
    var endDate = now.format('YYYY-MM-DD');
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      dateRange: [startDate, endDate],
      queryParam: {
        uid: '',
        studyAdviserId: null,
        tchName: '',
        startDate: startDate,
        endDate: endDate
      },
      title: [{
        title: '学员ID',
        key: 'uid',
        width: 100,
        align: 'center',
        fixed: 'left'
      }, {
        title: '学员姓名',
        key: 'userName',
        width: 120
      }, {
        title: '班主任',
        key: 'adviserName',
        width: 110,
        align: 'center'
      }, {
        title: '首次绑定外教',
        key: 'firstTchName',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.firstTchName,
            score: row.monthRankScoreFirst
          });
        }
      }, {
        title: '外教变更完整链路',
        width: 280,
        render: function render(h, params) {
          return _this.renderTchChain(h, params.row.tchChain, params.row.tchResignFlags, params.row.tchChainIds);
        }
      }, {
        title: '本年更换过的外教总人数',
        key: 'tchChangeCount',
        width: 130,
        align: 'center'
      }, {
        title: '历次换绑时间',
        width: 220,
        render: function render(h, params) {
          return _this.renderChangeDates(h, params.row.changeDates);
        }
      }, {
        title: '当前绑定外教',
        width: 180,
        render: function render(h, params) {
          return _this.renderCurrentTch(h, params.row);
        }
      }, {
        title: '本年上课总课时',
        key: 'yearLessonCount',
        width: 120,
        align: 'center'
      }, {
        title: '备注',
        width: 220,
        render: function render(h, params) {
          return _this.renderLongText(h, params.row.remark);
        }
      }]
    };
  },

  created: function created() {
    if (this.isStudyAdviser) {
      this.queryParam.studyAdviserId = parseInt(this.$store.get('id'));
    }
  },
  methods: {
    renderLongText: function renderLongText(h, text) {
      var value = text === undefined || text === null ? '' : String(text);
      if (!value) {
        return h('span', '');
      }
      return h('div', {
        attrs: {
          title: value
        },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, value);
    },
    renderTchChain: function renderTchChain(h, chain, flags, ids) {
      var chainValue = chain === undefined || chain === null ? '' : String(chain);
      if (!chainValue) {
        return h('span', '');
      }
      var flagsValue = flags === undefined || flags === null ? '' : String(flags);
      var idsValue = ids === undefined || ids === null ? '' : String(ids);
      var names = chainValue.split(' → ');
      var flagList = flagsValue ? flagsValue.split(',') : [];
      var idList = idsValue ? idsValue.split(',') : [];

      if (names.length !== flagList.length) {
        return this.renderLongText(h, chainValue);
      }
      var scoreMap = this.rankScoreMap || {};
      var children = [];
      names.forEach(function (name, index) {
        if (index > 0) {
          children.push(' → ');
        }
        var tid = idList[index] != null ? String(idList[index]).trim() : '';
        var score = tid ? scoreMap[tid] != null ? scoreMap[tid] : scoreMap[Number(tid)] : null;
        var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, { text: name, score: score });
        if (String(flagList[index]).trim() === '1') {
          children.push(h('span', { style: { color: 'red' } }, [node]));
        } else {
          children.push(node);
        }
      });
      return h('div', {
        attrs: {
          title: chainValue
        },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, children);
    },
    renderCurrentTch: function renderCurrentTch(h, row) {
      row = row || {};
      var text = row.currentTchName === undefined || row.currentTchName === null ? '' : String(row.currentTchName);
      if (!text) {
        return h('span', '');
      }
      var idsValue = row.currentTchIds === undefined || row.currentTchIds === null ? '' : String(row.currentTchIds);
      var names = text.split('、');
      var idList = idsValue ? idsValue.split(',') : [];
      var scoreMap = this.rankScoreMap || {};
      if (!idList.length || idList.length !== names.length) {
        return this.renderLongText(h, text);
      }
      var children = [];
      names.forEach(function (name, index) {
        if (index > 0) {
          children.push('、');
        }
        var tid = String(idList[index]).trim();
        var score = scoreMap[tid] != null ? scoreMap[tid] : scoreMap[Number(tid)];
        children.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, { text: name, score: score }));
      });
      return h('div', {
        attrs: { title: text },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, children);
    },
    renderChangeDates: function renderChangeDates(h, text) {
      var value = text === undefined || text === null ? '' : String(text);
      if (!value) {
        return h('span', '');
      }
      return h('Poptip', {
        props: {
          trigger: 'click',
          placement: 'top',
          transfer: true
        }
      }, [h('span', {
        style: {
          display: 'inline-block',
          maxWidth: '190px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'middle',
          cursor: 'pointer'
        }
      }, value), h('div', {
        slot: 'content',
        style: {
          maxWidth: '360px',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          textAlign: 'left'
        }
      }, value)]);
    },
    disabledDate: function disabledDate(date) {
      return date && date.valueOf() < this.$moment('2025-09-01').valueOf();
    },
    onDateRangeChange: function onDateRangeChange(value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0] || '';
        this.queryParam.endDate = value[1] || '';
        return;
      }
      this.queryParam.startDate = '';
      this.queryParam.endDate = '';
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        this.rankScoreMap = {};
        return;
      }
      var ids = [];
      table.forEach(function (row) {
        if (row.firstTchId != null) {
          ids.push(row.firstTchId);
        }
        String(row.tchChainIds || '').split(',').forEach(function (id) {
          id = String(id).trim();
          if (id) {
            ids.push(id);
          }
        });
        String(row.currentTchIds || '').split(',').forEach(function (id) {
          id = String(id).trim();
          if (id) {
            ids.push(id);
          }
        });
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        self.rankScoreMap = map || {};
        table.forEach(function (row) {
          var score = map[row.firstTchId];
          if (score == null) {
            score = map[String(row.firstTchId)];
          }
          self.$set(row, 'monthRankScoreFirst', score == null ? null : score);
        });
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      this.exportLoading = true;
      this.$http({
        method: 'post',
        url: '/user/tch-rebind/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '外教换绑学员汇总.xlsx';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg || '导出失败');
          _this2.exportLoading = false;
        }
      }).catch(function () {
        _this2.$Message.error('导出失败');
        _this2.exportLoading = false;
      });
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__ = __webpack_require__(60);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrackContentPreview',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      overflow: false
    };
  },

  computed: {
    html: function html() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(this.content);
    }
  },
  watch: {
    content: function content() {
      this.scheduleCheck();
    },
    html: function html() {
      this.scheduleCheck();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.scheduleCheck();
    if (typeof ResizeObserver !== 'undefined') {
      this._ro = new ResizeObserver(function () {
        return _this.checkOverflow();
      });
      if (this.$el) this._ro.observe(this.$el);
    } else if (typeof window !== 'undefined') {
      this._onResize = function () {
        return _this.checkOverflow();
      };
      window.addEventListener('resize', this._onResize);
    }
  },
  updated: function updated() {
    this.scheduleCheck();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._ro) {
      this._ro.disconnect();
      this._ro = null;
    }
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      this._onResize = null;
    }
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  },

  methods: {
    scheduleCheck: function scheduleCheck() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2._timer) clearTimeout(_this2._timer);
        _this2._timer = setTimeout(function () {
          _this2._timer = null;
          _this2.checkOverflow();
        }, 0);
      });
    },
    checkOverflow: function checkOverflow() {
      var el = this.$refs.clamp;
      if (!el) {
        this.overflow = false;
        return;
      }

      this.overflow = el.scrollHeight > el.clientHeight + 1;
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAdvierTreModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAssignAdviser: false,
      adviserParam: {
        adviserId: '',
        resourceStatus: 2
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      var idList = self.userList.map(function (element) {
        return element.id;
      });
      self.loadingAssignAdviser = true;
      var params = { ids: idList.join(',') };
      self.$http.get('/user/UnBinStudy', { params: params }).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingAssignAdviser = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingAssignAdviser = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.adviserParam.adviserId = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAdvierTreModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingAssignAdviser: false,
      adviserParam: {
        adviserId: '',
        resourceStatus: 2
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      var idList = self.userList.map(function (element) {
        return element.id;
      });
      self.loadingAssignAdviser = true;
      var params = { ids: idList.join(',') };
      self.$http.get('/user/lssonUnBinStudy', { params: params }).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback();
          self.visible = false;
        }
        self.loadingAssignAdviser = false;
      }).catch(function (e) {
        self.visible = false;
        self.loadingAssignAdviser = false;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.adviserParam.adviserId = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserActivityNumModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingUpdate: false,
      param: {
        giveType: 1,
        activity: '',
        lessonNum: '',
        remark: ''
      },
      classHourRule: {
        lessonNum: [{ type: 'integer', required: true, message: '请输入数量', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value === 0) {
              errors.push('数量不能为0');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }, { type: 'integer', min: -100, max: 100, message: '请输入 -100 到 100 之间的整数', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }],
        activity: [{ type: 'integer', required: true, message: '请输入数量', trigger: 'blur' }]
      }
    };
  },

  methods: {
    update: function update() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.classHourForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        self.param.uid = self.uid;
        self.$http.post('/activityExamine/activty', self.param).then(function (res) {
          self.loadingUpdate = false;
          if (res) {
            self.visible = false;
            self.$Message.success('兑换成功!');
            self.successCallback();
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.param = {
        giveType: 1,
        activity: '',
        lessonNum: '',
        remark: ''
      };
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal___default.a
  },
  name: 'UserChineseLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tId: '',
      tchName: '',
      chineseLessonParam: {
        uid: null,
        tchId: '',
        category: '',
        classType: 1,
        courseType: 2,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        beginTime: '18:00',
        schoolId: 0
      },
      timeStr: '18:00',
      chineseLessonRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.chineseLessonParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            var lsnBeginTime = self.getLsnBeginTime();
            var nowTime = new Date().getTime() / 1000;
            if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            callback();
          }
        }]
      },
      tchId: null,
      showTchInfoModal: false
    };
  },

  methods: {
    tchAvatarSrc: function tchAvatarSrc(avatar) {
      return __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default.a.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
    },
    insertChineseLesson: function insertChineseLesson() {
      var self = this;
      self.$http.get('/bookLesson/selectTchOpendCount?tchId=' + self.chineseLessonParam.tchId + '&courseType=' + self.chineseLessonParam.courseType).then(function (res) {
        if (res && res.data >= 120) {
          self.$Modal.confirm({
            title: '提示',
            content: '选择的中教老师单月已超过120课，当前老师本月已上课' + res.data + '节，上课费用增加，是否继续预约此老师课程！',
            width: 300,
            okText: '确定',
            loading: true,
            onOk: function onOk() {
              self.insertLesson();
              self.$Modal.remove();
            }
          });
        } else {
          self.insertLesson();
        }
      });
    },
    insertLesson: function insertLesson() {
      var self = this;
      self.loadingConfirm = true;
      self.$refs.chineseLessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingConfirm = false;
          return;
        }
        self.chineseLessonParam.lsnBeginTime = self.getLsnBeginTime();
        self.$http.post('/user/lesson/addCourse', self.chineseLessonParam).then(function (res) {
          self.loadingConfirm = false;
          if (res) {
            self.$Message.success('约课成功!');
            self.visible = false;
            return;
          }
        });
      });
    },
    searchTch: function searchTch() {
      var self = this;
      var isNotError = true;
      self.$refs.chineseLessonForm.validateField('lsnBeginDayTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      self.tchList = [];
      var path = '/tch/time/queryFreeTimeTch?lsnBeginTime=' + self.getLsnBeginTime() + '&timeLength=' + self.chineseLessonParam.timeLength + '&tchType=2';
      if (self.tId) {
        path = path + '&tchId=' + self.tId;
      }
      if (self.chineseLessonParam.category) {
        path = path + '&category=' + self.chineseLessonParam.category;
      }
      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data;
        }
        self.loadingSearch = false;
      });
    },
    onChangeTime: function onChangeTime(val) {
      this.chineseLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.chineseLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    changeLevel: function changeLevel(val) {
      if (!val) {
        return;
      } else {
        var self = this;
        self.bookMaterialLessonsList = null;
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.bookMaterialLessonsList = res.data;
        });
      }
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.chineseLessonParam.lsnBeginDayTime) + this.chineseLessonParam.beginTime.getMinutes() * 60 + this.chineseLessonParam.beginTime.getHours() * 60 * 60;
    },
    clearTchList: function clearTchList() {
      this.tchList = [];
      this.chineseLessonParam.tchId = '';
    },
    showTchMessage: function showTchMessage(id) {
      this.tchId = parseInt(id);
      this.showTchInfoModal = true;
    },
    updateTchInfoSuccess: function updateTchInfoSuccess() {
      this.showTchInfoModal = false;
    },
    onTchChange: function onTchChange(id, name) {
      this.tchName = name;
      if (id) {
        this.searchTch();
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.loadingConfirm = false;
        this.loadBookMaterialLevel();
        this.clearTchList();
        this.$refs['chineseLessonForm'].resetFields();
        this.chineseLessonParam.uid = this.user.id;
        this.chineseLessonParam.nickname = this.user.nickname;
        this.chineseLessonParam.mobile = this.user.mobile;

        var now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.chineseLessonParam.lsnBeginTimeDate = now;
        this.chineseLessonParam.lsnBeginDayTime = now.getTime() / 1000;
        this.timeStr = '18:00';
        this.chineseLessonParam.time = 18 * 3600;
      } else {
        this.tId = '';
        this.tchName = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserClassHourModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    },
    courseType: {
      type: Number,
      default: 1
    },
    showUid: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingUpdate: false,
      defaultPicList: [],
      givingTypeChild: [],
      classHourParam: {
        courseType: this.courseType,
        num: '',
        reason: '',
        givingType: '',
        givingTypeChild: '',
        tchId: null,
        url: '',
        uid: '',
        classTime: '',
        inviteUid: ''
      },
      classHourRule: {
        num: [{ type: 'integer', required: true, message: '请输入数量', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value === 0) {
              errors.push('数量不能为0');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }],
        url: [{ type: 'string', required: true, message: '凭证图片不能为空', trigger: 'blur' }],
        givingType: [{ type: 'integer', required: true, message: '请选择类型', trigger: 'blur' }],
        givingTypeChild: [{ type: 'integer', required: true, message: '请选择子类型', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }],
        tchId: [{ type: 'integer', required: true, message: '请选择老师', trigger: 'blur' }]
      }
    };
  },

  methods: {
    classTimeDateChange: function classTimeDateChange(value) {
      this.classHourParam.classTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onFileChange: function onFileChange(fileList) {
      this.defaultPicList = fileList;
    },
    update: function update() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.classHourForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        if (self.uid) {
          self.classHourParam.uid = self.uid;
        }
        self.validateShuang11Gift().then(function (ok) {
          if (!ok) {
            self.loadingUpdate = false;
            return;
          }
          self.$http.post('/bookCourseChange/add', self.classHourParam).then(function (res) {
            self.loadingUpdate = false;
            if (res) {
              self.visible = false;
              self.$Message.success('提交申请加减课时成功!');
            }
          }).catch(function () {
            self.loadingUpdate = false;
          });
        }).catch(function () {
          self.loadingUpdate = false;
        });
      });
    },
    validateShuang11Gift: function validateShuang11Gift() {
      var self = this;
      var reason = self.classHourParam.reason || '';
      var num = self.classHourParam.num;
      if (reason.indexOf('双十一') < 0 || !(num > 0)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
      }
      if (num !== 2 && num !== 4) {
        self.$Message.warning('双十一赠课节数只能是 2 或 4 节');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      var uid = self.classHourParam.uid || self.uid;
      if (!uid) {
        self.$Message.warning('请填写学生id');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      return self.$http.get('/fundPackage/list', {
        params: { uid: uid, pageSize: 100, state: 1 }
      }).then(function (res) {
        var list = res && (res.data || res.list || res) || [];
        if (!Array.isArray(list)) {
          list = list.data || list.list || [] || [];
        }
        function pickLatest(channels) {
          return list.filter(function (row) {
            return row && Number(row.state) === 1 && channels.indexOf(Number(row.channel)) >= 0;
          }).sort(function (a, b) {
            return (Number(b.createTime) || 0) - (Number(a.createTime) || 0);
          })[0];
        }

        var order = pickLatest([0, 5]) || pickLatest([1, 7]);
        if (!order) {
          return true;
        }
        var pkgNum = Number(order.num);
        var expected = null;
        if (pkgNum === 50) expected = 2;else if ([72, 110, 144, 210].indexOf(pkgNum) >= 0) expected = 4;
        if (expected == null) {
          self.$Message.warning('当前套餐（' + pkgNum + '节）不支持双十一赠课');
          return false;
        }
        if (num !== expected) {
          self.$Message.warning('双十一赠课节数应为' + expected + '节（当前套餐' + pkgNum + '节）');
          return false;
        }
        return true;
      }).catch(function () {
        return true;
      });
    },
    changeGivingType: function changeGivingType(val) {
      var self = this;
      if (val === 1) {
        self.givingTypeChild = [];
      } else if (val === 2) {
        self.givingTypeChild = [{ code: 10, text: '转介绍成功购课' }, { code: 11, text: '邀请好友试听成功' }];
      } else if (val === 3) {
        self.givingTypeChild = [{ code: 8, text: '特殊请假' }, { code: 9, text: '家长态度强硬非要返还课时' }];
      } else if (val === 4) {
        self.givingTypeChild = [];
      } else if (val === 5) {
        self.givingTypeChild = [{ code: 1, text: '课件编辑错' }];
      } else if (val === 6) {
        self.givingTypeChild = [{ code: 2, text: '老师离职' }, { code: 3, text: '老师旷课' }, { code: 4, text: '老师迟到10分钟以及以上' }, { code: 5, text: '老师网络原因不能上课' }];
      } else if (val === 7) {
        self.givingTypeChild = [{ code: 6, text: '教材不顺延' }, { code: 7, text: '课件排错' }];
      } else if (val === 8) {
        self.givingTypeChild = [];
      } else if (val === 9) {
        self.givingTypeChild = [];
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      var courseType = this.courseType;
      this.classHourParam = {
        courseType: courseType,
        num: '',
        reason: '',
        url: ''
      };
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_InsertUserModal_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_InsertUserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_InsertUserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserTrialLessonModal_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserTrialLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserTrialLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_UserTestNetworkModal_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_UserTestNetworkModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_UserTestNetworkModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_aiAccess__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_iview_src_components_grid_row__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_iview_src_components_grid_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_iview_src_components_grid_row__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AssignAdviserModal: __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default.a, InsertUserModal: __WEBPACK_IMPORTED_MODULE_1__modal_InsertUserModal_vue___default.a, UserTrialLessonModal: __WEBPACK_IMPORTED_MODULE_2__UserTrialLessonModal_vue___default.a, UserTestNetworkModal: __WEBPACK_IMPORTED_MODULE_3__modal_UserTestNetworkModal_vue___default.a, UserInfoModal: __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default.a, AiDrawer: __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer___default.a },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;

    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      queryParam: {
        searchKeyword: '',
        isAdviser: '',
        lessonStatus: '',
        adviserName: '',
        adviserMobile: '',
        regType: '',
        tchChannel: '',
        startTime: '',
        endTime: ''
      },
      startTime: '',
      endTime: '',
      isAdviserList: [{ code: 1, text: '已分配' }, { code: 0, text: '未分配' }],
      editUser: false,

      showInsertUserModal: false,
      showUserTrialLessonModal: false,
      loadingInsertUser: false,
      ruleUser: {
        nickname: [{ type: 'string', required: true, message: '昵称不能为空', trigger: 'blur' }, { type: 'string', min: 1, max: 20, message: '昵称应为1-20个字', trigger: 'blur' }],
        mobile: [{ type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur' }],
        password: [{ type: 'string', required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      uid: null,
      updateUser: {},
      trialaLessonUser: {},

      showAssignAdviserModal: false,
      selectionUser: [],

      showTestNetworkModal: false,
      testNetworkParam: {},
      testNetworkBookMaterialLevelList: [],

      bookMaterialLevelList: null,
      userListStatusList: $constant.userListStatus,
      userLessonStatusList: $constant.userLessonStatus,
      sexList: $constant.sex,
      title: [{
        type: 'selection',

        align: 'center'
      }, {
        title: '学生ID、姓名',

        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.id + '-' + row.nickname);
        }
      }, {
        title: '渠道',
        align: 'center',
        key: 'regType'
      }, {
        title: '渠道来源',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var tchChannel = params.row.tchChannel;
          var tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel);
          return h('div', tchChannelEnum && tchChannelEnum.text);
        }
      }, {
        title: '手机号',
        align: 'center',

        key: 'mobile',
        render: function render(h, params) {
          if (params.row.mobile.startsWith('n')) {
            return h('span', '');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '注册时间',
        align: 'center',

        render: function render(h, params) {
          var regTime = params.row.regTime;
          if (regTime === 0) {
            return;
          }
          return h('span', regTime && $moment(regTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '课程顾问',
        key: 'adviserName',

        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '状态',
        align: 'center',

        render: function render(h, params) {
          var statusEnum = $constant.getEnum($constant.userLessonStatus, params.row.lessonStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          var btn = [];
          if (_this.aiAllowed) {
            btn.push(h('Dropdown-item', { props: { name: 'ai' } }, 'AI'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'testNetwork' } }, '约测网课'));
          if (row.lessonStatus !== 1 && row.lessonStatus !== 2) {
            btn.push(h('Dropdown-item', { props: { name: 'completeTestNetwork' } }, '已通过测网'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'trialLesson' } }, '约试听课'));
          if (row.lessonStatus !== 2) {
            btn.push(h('Dropdown-item', { props: { name: 'completeTrialLesson' } }, '已试听'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'paid' } }, '已付款'));

          return h('div', [h('span', { class: 'divider' }), h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                var row = params.row;
                if (name === 'ai') {
                  _this.aiUid = row.id;
                  _this.aiVisible = true;
                } else if (name === 'testNetwork') {
                  _this.onTestNetwork(row);
                } else if (name === 'completeTestNetwork') {
                  _this.onCompleteTestNetwork(row);
                } else if (name === 'trialLesson') {
                  _this.onTrialLesson(row);
                } else if (name === 'completeTrialLesson') {
                  _this.onCompleteTrialLesson(row);
                } else if (name === 'paid') {
                  _this.onPaid(row);
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }]
    };
  },

  mounted: function mounted() {
    var query = this.$route.query;
    if (query) {
      if (query.startTime) {
        this.startTime = parseInt(query.startTime) * 1000;
      }
      if (query.endTime) {
        this.endTime = parseInt(query.endTime) * 1000;
      }
      if (query.lessonStatus) {
        this.queryParam.lessonStatus = parseInt(query.lessonStatus);
      }
      if (query.isAdviser) {
        this.queryParam.isAdviser = parseInt(query.isAdviser);
      }
      if (query.searchKeyword) {
        this.queryParam.searchKeyword = query.searchKeyword;
      }
      if (query.adviserName) {
        this.queryParam.adviserName = query.adviserName;
      }
      if (query.adviserMobile) {
        this.queryParam.adviserMobile = query.adviserMobile;
      }
      if (query.regType) {
        this.queryParam.regType = query.regType;
      }
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tools_aiAccess__["a" /* bindAiAllowed */])(this);
    var query = this.$route.query;
    if (query) {
      if (query.startTime) {
        this.startTime = parseInt(query.startTime) * 1000;
      }

      if (query.endTime) {
        this.endTime = parseInt(query.endTime) * 1000;
      }
      if (query.lessonStatus) {
        this.queryParam.lessonStatus = parseInt(query.lessonStatus);
      }
      if (query.isAdviser) {
        this.queryParam.isAdviser = parseInt(query.isAdviser);
      }
      if (query.searchKeyword) {
        this.queryParam.searchKeyword = query.searchKeyword;
      }
      if (query.adviserName) {
        this.queryParam.adviserName = query.adviserName;
      }
      if (query.adviserMobile) {
        this.queryParam.adviserMobile = query.adviserMobile;
      }
      if (query.regType) {
        this.queryParam.regType = query.regType;
      }
    }
  },
  methods: {
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserExperienceList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = false;
    },
    search: function search(val) {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onInsertUser: function onInsertUser() {
      this.showInsertUserModal = true;
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showAssignAdviserModal = true;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/user/experience/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '体验学生.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    onTestNetwork: function onTestNetwork(row) {
      this.testNetworkParam = row;
      this.showTestNetworkModal = true;
    },
    onTrialLesson: function onTrialLesson(row) {
      this.showUserTrialLessonModal = true;
      this.trialaLessonUser = row;
    },
    onCompleteTestNetwork: function onCompleteTestNetwork(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已通过测网？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/updateLessonStatus', { id: row.id, lessonStatus: 1 }).then(function (res) {
            self.search();
            self.$Message.success('提交成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    onCompleteTrialLesson: function onCompleteTrialLesson(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已试听？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/updateLessonStatus', { id: row.id, lessonStatus: 2 }).then(function (res) {
            self.search();
            self.$Message.success('提交成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    onPaid: function onPaid(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已付款？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/updateIsPay', { id: row.id, isPay: 1 }).then(function (res) {
            if (res.data) {
              self.search();
              self.$Message.success('提交成功!');
              self.$Modal.remove();
            }
          });
        }
      });
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tchScore__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      rankScoreSeq: 0,
      visible: this.value,
      bookLessonOpenedList: [],
      userLessonOpend: [],
      bookLessonOpenedColumn: [{
        title: '学生ID、姓名',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('span', row.uid), h('span', ' - '), h('span', row.userNickname || '')]);
        }
      }, {
        title: '老师ID、姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
            score: row.monthRankScore
          });
        }
      }, {
        title: '学导',
        width: 90,
        key: 'studyAdviserNickname'
      }, {
        title: '外教运营',
        width: 90,
        key: 'adviserNickname'
      }, {
        title: '开始、结束时间',
        align: 'center',
        width: 122,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '上课类型',
        align: 'center',
        width: 72,
        render: function render(h, params) {
          var lsnType = params.row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          return h('span', typeEnum && typeEnum.text);
        }
      }, {
        title: '课程名称',
        key: 'lessonTitle'
      }, {
        title: '上课时长',
        align: 'center',
        width: 72,
        key: 'courseTime'
      }, {
        title: '上课状态',
        width: 72,
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }],
      loadingSearch: false,
      loadingAdd: false,
      leaveParam: {
        leaveType: 1,
        startTime: '',
        endTime: '',
        remark: '',
        day: '',
        isSixHoursAgo: 0
      },
      showModal: {
        showModel: 1,
        id: ''
      },
      leaveRule: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var endTime = self.leaveParam.endTime;
            var errors = [];
            var nowTime = new Date().getTime() / 1000;
            if (nowTime >= value) {
              errors.push('开始时间应在当前时间之后');
            }
            if (endTime !== '' && value >= endTime) {
              errors.push('开始时间应在结束时间之前');
            }
            callback(errors);
          }
        }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        remark: [{ type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.bookLessonOpenedList;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    add: function add() {
      var self = this;
      self.loadingAdd = true;
      if (self.showModal.showModel === 1) {
        this.$refs.leaveForm.validate(function (valid) {
          if (!valid) {
            self.loadingAdd = false;
            return;
          }
          self.$http.post('/bookUserLeaveTime/addByOpenedId', {
            openedId: self.showModal.id,
            remark: self.leaveParam.remark,
            isSixHoursAgo: self.leaveParam.isSixHoursAgo
          }).then(function (res) {
            self.loadingAdd = false;
            if (res && res.data > 0) {
              self.$Message.success('请假成功!');
              self.visible = false;
              self.successCallback();
            }
          });
        });
      } else {
        var nTime = this.leaveParam.endTime - this.leaveParam.startTime;
        var day = Math.floor(nTime / 86400);
        this.leaveParam.day = day;
        this.leaveParam.leaveType = this.showModal.showModel;
        this.$refs.leaveForm.validate(function (valid) {
          if (!valid) {
            return;
          }
          if (self.showModal.showModel === 2) {
            if (day > 7) {
              self.$Message.warning('时间超过7天,请申请停课');
              return;
            }
          }
          self.loadingAdd = true;
          var params = self.leaveParam;
          params.uid = self.uid;
          if (day > 20) {
            self.loadingAdd = false;
            self.$Modal.confirm({
              title: '提示',
              content: '停课时间大于20天，确定请假后立即解除绑定老师，假期结束后需要您重新绑定',
              width: 300,
              loading: true,
              onOk: function onOk() {
                self.$http.post('/bookUserLeaveTime/add', params).then(function (res) {
                  self.$Message.success('解绑成功!');
                  self.$Modal.remove();
                  self.visible = false;
                  self.successCallback();
                });
              }
            });
          } else {
            self.$http.post('/bookUserLeaveTime/add', params).then(function (res) {
              self.loadingAdd = false;
              if (res && res.data > 0) {
                self.$Message.success('请假成功!');
                self.visible = false;
                self.successCallback();
              }
            }).catch(function (e) {
              self.loadingAdd = false;
            });
          }
        });
      }
    },
    startTimeChange: function startTimeChange(value) {
      this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeChange: function endTimeChange(value) {
      this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookLessonOpened: function onBookLessonOpened() {
      var self = this;
      var isNotError = true;
      this.$refs.leaveForm.validateField('startTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      this.$refs.leaveForm.validateField('endTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      var params = {};
      params.uid = self.uid;
      params.startTime = self.leaveParam.startTime;
      params.endTime = self.leaveParam.endTime;
      self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
        self.loadingSearch = false;
        if (res.data.length <= 0) {
          self.$Message.info('没有涉及任何课节!');
          return;
        }
        self.bookLessonOpenedList = res.data;
        self.loadMonthRankScores();
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === false) {
        this.bookLessonOpenedList = [];

        this.leaveParam = {
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          remark: ''
        };
        this.$emit('on-close', val);
      }
      this.$emit('input', val);
    },
    uid: function uid(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookLesson/selectUserLesson?uid=' + val).then(function (res) {
          self.userLessonOpend = res.data;
        });
      }
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserLeaveNumModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingUpdate: false,
      classHourParam: {
        num: '',
        reason: ''
      },
      classHourRule: {
        num: [{ type: 'integer', required: true, message: '请输入数量', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value === 0) {
              errors.push('数量不能为0');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }, { type: 'integer', min: -100, max: 100, message: '请输入 -100 到 100 之间的整数', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    update: function update() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.classHourForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        self.classHourParam.uid = self.uid;
        self.$http.post('/bookCourseChange/addLeave', self.classHourParam).then(function (res) {
          self.loadingUpdate = false;
          if (res) {
            self.visible = false;
            self.$Message.success('提交申请加减课时成功!');
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.classHourParam = {
        num: '',
        reason: ''
      };
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserLeaveNumModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingUpdate: false,
      classHourParam: {
        num: '',
        reason: ''
      },
      classHourRule: {
        num: [{ type: 'integer', required: true, message: '请输入数量', trigger: 'blur' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (value === 0) {
              errors.push('数量不能为0');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }, { type: 'integer', min: -100, max: 100, message: '请输入 -100 到 100 之间的整数', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }, { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    update: function update() {
      var self = this;
      self.loadingUpdate = true;
      self.$refs.classHourForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingUpdate = false;
          return;
        }
        self.classHourParam.uid = self.uid;
        self.$http.post('/bookCourseChange/addLesson', self.classHourParam).then(function (res) {
          self.loadingUpdate = false;
          if (res) {
            self.visible = false;
            self.$Message.success('提交申请加减补课成功!');
            return;
          }
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      this.classHourParam = {
        num: '',
        reason: ''
      };
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnBinStudyModals_vue__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnBinStudyModals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UnBinStudyModals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BatchCompletedCoursesModal_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BatchCompletedCoursesModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BatchCompletedCoursesModal_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BatchCompletedCoursesModal: __WEBPACK_IMPORTED_MODULE_2__BatchCompletedCoursesModal_vue___default.a,
    UnBinStudyModals: __WEBPACK_IMPORTED_MODULE_1__UnBinStudyModals_vue___default.a
  },
  name: 'UserRefundList',
  data: function data() {
    var $constant = this.$constant;
    return {
      uidStr: '',
      searchLoading: false,
      showBatchCompletedCoursesModal: false,
      showUnBinStudyModal: false,
      reload: 0,
      timer: '',
      smsCode: '',
      time: 60,
      disabled: false,
      queryParam: {
        startTime: null,
        endTime: null,
        uid: '',
        adviserName: '',
        nickname: '',
        mobile: '',
        stopRemark: '',
        studyAdviserName: '',
        stdStatus: 10,
        adminUserId: '',
        adviserId: '',
        resumeLessonTimeStart: '',
        resumeLessonTimeEnd: '',
        stopLessonTimeStart: null,
        stopLessonTimeEnd: null
      },
      remark: '',
      cancelLoading: false,
      exportLoading: false,
      selectionUser: [],
      regDateRange: [],
      title: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 130,
        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '剩余课时',
        width: 160,
        align: 'center',
        key: 'availableClassHour'
      }, {
        title: '学导',
        width: 130,
        align: 'center',
        key: 'studyAdviserName'
      }, {
        title: '课程顾问',
        width: 130,
        align: 'center',
        key: 'adviserName'
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regType'
      }, {
        title: '注册时间',
        align: 'center',
        width: 170,
        key: 'gmtCreate'
      }, {
        title: '停课时间',
        align: 'center',
        width: 170,
        key: 'stopLessonTime'
      }, {
        title: '停课原因',
        align: 'center',
        width: 170,
        key: 'stopRemark'
      }, {
        title: '预计复课时间',
        align: 'center',
        width: 170,
        key: 'resumeLessonTime'
      }, {
        title: '等级',
        width: 120,
        align: 'center',
        key: 'levelTitle'
      }, {
        title: '是否付款',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var isPay = params.row.isPay;
          var isPayEnum = $constant.getEnum($constant.yesNoNum, isPay);
          return h('span', isPayEnum && isPayEnum.text);
        }
      }, {
        title: '用户状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.userListStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '资源状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var resourceStatus = params.row.resourceStatus;
          var resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus);
          return h('span', resourceStatusEnum && resourceStatusEnum.text);
        }
      }, {
        title: '学生状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var studentStatus = params.row.studentStatus;
          var studentStatusEnum = $constant.getEnum($constant.studentStatus, studentStatus);
          return h('span', studentStatusEnum && studentStatusEnum.text);
        }
      }, {
        title: '学员状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var stdStatus = params.row.stdStatus;
          var stdStatusEnum = $constant.getEnum($constant.stdStatus, stdStatus);
          return h('span', stdStatusEnum && stdStatusEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var query = this.$route.query;
      if (query) {
        if (query.startTime) {
          this.regDateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.endTime) {
          this.regDateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.uid) {
          this.queryParam.uid = query.uid;
        }
        if (query.adviserName) {
          this.queryParam.adviserName = query.adviserName;
        }
        if (query.studyAdviserName) {
          this.queryParam.studyAdviserName = query.studyAdviserName;
        }
        if (query.nickname) {
          this.queryParam.nickname = query.nickname;
        }
        if (query.mobile) {
          this.queryParam.mobile = query.mobile;
        }
      }
    },
    timeDateChange: function timeDateChange(value) {
      this.queryParam.resumeLessonTimeStart = value[0] && this.$moment(value[0], 'YYYY-M-D H:m').format('X');
      this.queryParam.resumeLessonTimeEnd = value[1] && this.$moment(value[1], 'YYYY-M-D H:m').format('X');
    },
    stopLessonTimeDateChange: function stopLessonTimeDateChange(value) {
      if (!value || !value[0] || !value[1]) {
        this.queryParam.stopLessonTimeStart = null;
        this.queryParam.stopLessonTimeEnd = null;
        return;
      }
      this.queryParam.stopLessonTimeStart = value[0];
      this.queryParam.stopLessonTimeEnd = value[1];
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要解绑的学生！');
        return;
      }
      this.showUnBinStudyModal = true;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    exportData: function exportData(type) {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/user/stopClass/exportExcel', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '停课学生.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    onBatchCompletedCourses: function onBatchCompletedCourses() {
      var self = this;
      if (self.selectionUser.length <= 0) {
        self.$Message.warning('请选择需学生！');
        return;
      }
      var idList = self.selectionUser.map(function (element) {
        return element.id;
      });
      self.uidStr = idList.join(';');
      self.showBatchCompletedCoursesModal = true;
    },
    batchCancel: function batchCancel() {
      var _this2 = this;

      var self = this;
      this.cancelLoading = true;
      var ids = [];
      var user = null;
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          user = dto;
          ids[i] = dto.id;
        }
      } else {
        self.$Message.warning('请选择取消停课人');
        this.cancelLoading = false;
        return;
      }
      this.$Modal.confirm({
        title: '[' + user.id + '-' + user.nickname + ']' + '>>取消停课',
        width: 300,
        okText: '确定',
        loading: true,
        render: function render(h, params) {
          return h('div', [h('Input', {
            props: {
              placeholder: '请输入复课原因'
            },
            on: {
              input: function input(e) {
                self.remark = e;
              }
            }
          }), h('Button', {
            attrs: { disabled: self.disabled },
            on: {
              click: function click() {
                self.$http.get('/userinfo/sendUpdateMobileSmsCode', { params: { uid: user.id, key: 'call_back_from_stop_sms' } }).then(function (res) {
                  if (res.status === 'ok') {
                    self.disabled = true;
                    self.$Message.success('验证码发送成功!');
                    self.timer = setInterval(function () {
                      if (self.time <= 0) {
                        self.disabled = false;
                        self.time = 60;
                        clearInterval(_this2.timer);
                      } else {
                        self.time -= 1;
                      }
                    }, 1000);
                  }
                });
              }
            }
          }, self.disabled ? self.time + '秒' : '发送验证码'), h('Input', {
            props: {
              placeholder: '短信验证码'
            },
            on: {
              input: function input(e) {
                self.smsCode = e;
              }
            }
          })]);
        },
        onOk: function onOk() {
          _this2.$http.post('/user/lessonsStop/batchCancelUserStopLesson', {
            ids: ids.join(','),
            remark: _this2.remark,
            isStop: 1,
            smsCode: _this2.smsCode
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('移出申请已提交');
              self.cancelLoading = false;
              self.search();
              self.$Modal.remove();
            } else {
              self.$Message.error('批量移出失败！');
              self.cancelLoading = false;
              self.$Modal.remove();
            }
          }).catch(function (e) {
            _this2.cancelLoading = false;
          });
        },
        onCancel: function onCancel() {
          _this2.cancelLoading = false;
          self.time = 60;
          clearInterval(_this2.timer);
          self.disabled = false;
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserRefundList',
  data: function data() {
    var $constant = this.$constant;
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        startTime: null,
        endTime: null,
        uid: '',
        adviserName: '',
        nickname: '',
        mobile: '',
        studyAdviserName: '',
        status: 0
      },
      regDateRange: [],
      title: [{
        title: '学生ID/姓名',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',

        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '学导',

        align: 'center',
        key: 'studyAdviserName'
      }, {
        title: '课程顾问',

        align: 'center',
        key: 'adviserName'
      }, {
        title: '注册渠道',

        align: 'center',
        key: 'regType'
      }, {
        title: '注册时间',
        align: 'center',
        width: 170,
        key: 'gmtCreate'
      }, {
        title: '等级',

        align: 'center',
        key: 'levelTitle'
      }, {
        title: '是否付款',

        align: 'center',
        render: function render(h, params) {
          var isPay = params.row.isPay;
          var isPayEnum = $constant.getEnum($constant.yesNoNum, isPay);
          return h('span', isPayEnum && isPayEnum.text);
        }
      }, {
        title: '用户状态',

        align: 'center',
        render: function render(h, params) {
          var status = params.row.status;
          var statusEnum = $constant.getEnum($constant.userListStatus, status);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '资源状态',

        align: 'center',
        render: function render(h, params) {
          var resourceStatus = params.row.resourceStatus;
          var resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus);
          return h('span', resourceStatusEnum && resourceStatusEnum.text);
        }
      }, {
        title: '学生状态',

        align: 'center',
        render: function render(h, params) {
          var studentStatus = params.row.studentStatus;
          var studentStatusEnum = $constant.getEnum($constant.studentStatus, studentStatus);
          return h('span', studentStatusEnum && studentStatusEnum.text);
        }
      }, {
        title: '学员状态',

        align: 'center',
        render: function render(h, params) {
          var stdStatus = params.row.stdStatus;
          var stdStatusEnum = $constant.getEnum($constant.stdStatus, stdStatus);
          return h('span', stdStatusEnum && stdStatusEnum.text);
        }
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var query = this.$route.query;
      if (query) {
        if (query.startTime) {
          this.regDateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.endTime) {
          this.regDateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.uid) {
          this.queryParam.uid = query.uid;
        }
        if (query.adviserName) {
          this.queryParam.adviserName = query.adviserName;
        }
        if (query.studyAdviserName) {
          this.queryParam.studyAdviserName = query.studyAdviserName;
        }
        if (query.nickname) {
          this.queryParam.nickname = query.nickname;
        }
        if (query.mobile) {
          this.queryParam.mobile = query.mobile;
        }
      }
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    regDateChange: function regDateChange(dateRange) {
      if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        var startTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime();
        var endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        this.queryParam.startTime = parseInt(startTime / 1000);
        this.queryParam.endTime = parseInt(endTime / 1000);
      } else {
        this.queryParam.startTime = null;
        this.queryParam.endTime = null;
        this.regDateRange = [];
      }
      this.search();
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnBinStudyModal_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnBinStudyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UnBinStudyModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BatchCompletedCoursesModal_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BatchCompletedCoursesModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BatchCompletedCoursesModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_EditOverRemarkModal_vue__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_EditOverRemarkModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_EditOverRemarkModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tchScore__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EditOverRemarkModal: __WEBPACK_IMPORTED_MODULE_2__modal_EditOverRemarkModal_vue___default.a,
    UnBinStudyModal: __WEBPACK_IMPORTED_MODULE_0__UnBinStudyModal_vue___default.a,
    BatchCompletedCoursesModal: __WEBPACK_IMPORTED_MODULE_1__BatchCompletedCoursesModal_vue___default.a
  },
  name: 'UserRefundList',
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      timer: '',
      smsCode: '',
      time: 60,
      disabled: false,
      exportLoading: false,
      cancelLoading: false,
      selectionUser: [],
      searchLoading: false,
      showUnBinStudyModal: false,
      showUpdateScoreModal: false,
      complaintRow: null,
      complaintRemarkList: $constant.stdOverRemark,
      showBatchCompletedCoursesModal: false,
      reload: 0,
      rankScoreSeq: 0,
      queryParam: {
        startFinishedTime: null,
        endFinishedTime: null,
        uid: '',
        adviserName: '',
        nickname: '',
        mobile: '',
        studyAdviserName: '',
        stdStatus: 8
      },
      regDateRange: [],
      title: [{
        type: 'selection',
        width: 60,
        align: 'center',
        fixed: 'left'
      }, {
        title: '学生ID/姓名',
        width: 150,
        align: 'center',
        fixed: 'left',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.id + '-' + row.nickname);
        }
      }, {
        title: '手机号',
        width: 130,
        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '班主任老师',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', '\u5B66\u5BFC\uFF1A' + (params.row.studyAdviserName || '')), h('p', '\u8BFE\u7A0B\u987E\u95EE\uFF1A' + (params.row.adviserName || '')), h('p', '\u8001\u5E08\u5BF9\u5E94\u5916\u7BA1\uFF1A' + (params.row.tchAdviserNickname || ''))]);
        }
      }, {
        title: '绑定老师',
        width: 180,
        align: 'center',
        key: 'tchName',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '注册渠道',
        width: 120,
        align: 'center',
        key: 'regType'
      }, {
        title: '最后一个订单总课时',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var value = params.row.lastOrderTotalClassHour;
          return h('span', value === null || value === undefined ? '-' : value);
        }
      }, {
        title: '时间信息',
        width: 340,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', '\u6CE8\u518C\u65F6\u95F4\uFF1A' + (params.row.gmtCreate || '')), h('p', '\u7ED3\u8BFE\u65F6\u95F4\uFF1A' + (params.row.finishedTime || ''))]);
        }
      }, {
        title: '不续费原因',
        width: 340,
        align: 'left',
        render: function render(h, params) {
          var attachmentUrls = params.row.overRemark && params.row.overRemark.attachmentUrls;
          var imageElements = [];
          if (attachmentUrls) {
            var urls = attachmentUrls.split(',').filter(function (url) {
              return url.trim();
            });
            urls.forEach(function (url, index) {
              imageElements.push(h('img', {
                attrs: {
                  src: 'https://imgs.kouyujie.cn/' + url.trim()
                },
                style: {
                  width: '50px',
                  height: '50px',
                  marginRight: '5px',
                  marginBottom: '5px',
                  objectFit: 'cover',
                  cursor: 'pointer',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                },
                on: {
                  click: function click() {
                    window.open('https://imgs.kouyujie.cn/' + url.trim(), '_blank');
                  }
                }
              }));
            });
          }

          return h('div', [h('p', '\u4E00\u7EA7\u539F\u56E0\uFF1A' + (params.row.overRemark.remark || '')), h('p', '\u5176\u4ED6\u539F\u56E0\uFF1A' + (params.row.overRemark.remarkExt || '')), attachmentUrls ? h('div', {
            style: {
              marginTop: '5px',
              display: 'flex',
              flexWrap: 'wrap'
            }
          }, imageElements) : null]);
        }
      }, {
        title: '等级',
        width: 120,
        align: 'center',
        key: 'levelTitle'
      }, {
        title: '付款与状态',
        width: 200,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', '\u662F\u5426\u4ED8\u6B3E\uFF1A' + (params.row.isPay === 1 ? '是' : '否')), h('p', '\u7528\u6237\u72B6\u6001\uFF1A' + (params.row.status === 1 ? '激活' : '停用'))]);
        }
      }, {
        title: '资源状态',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var resourceStatus = params.row.resourceStatus;
          var resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus);
          return h('span', resourceStatusEnum && resourceStatusEnum.text);
        }
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          return h('div', [h('a', {
            on: {
              click: function click() {
                _this.onUpdateComplaint(params.row);
              }
            }
          }, '不续费原因')]);
        }
      }]
    };
  },

  methods: {
    closeComplaintModal: function closeComplaintModal(val) {
      this.showUpdateScoreModal = false;
      this.complaintRow = {};
    },
    onUpdateComplaint: function onUpdateComplaint(row) {
      this.showUpdateScoreModal = true;
      this.complaintRow = row;
    },
    exportData: function exportData(type) {
      var _this2 = this;

      this.exportLoading = true;
      this.$http.get('/user/overClass/exportExcel', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '结课学生.csv';
          link.click();
          _this2.exportLoading = false;
        } else {
          _this2.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要解绑的学生！');
        return;
      }
      this.showUnBinStudyModal = true;
    },
    onBatchCompletedCourses: function onBatchCompletedCourses() {
      this.showBatchCompletedCoursesModal = true;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    startFinishedTimeChange: function startFinishedTimeChange(value) {
      this.queryParam.startFinishedTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endFinishedTimeChange: function endFinishedTimeChange(value) {
      this.queryParam.endFinishedTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;

      if (!loading) {
        this.loadMonthRankScores();
      }
    },
    loadMonthRankScores: function loadMonthRankScores() {
      var table = this.$refs.dataList && this.$refs.dataList.tableData;
      if (!table || !table.length) {
        return;
      }
      var ids = table.map(function (row) {
        return row.tchId;
      }).filter(function (id) {
        return id != null;
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_tchScore__["c" /* applyTchScoresToRows */])(self, table, 'tchId', 'monthRankScore', map);
      });
    },
    batchCancel: function batchCancel() {
      var _this3 = this;

      var self = this;
      this.cancelLoading = true;
      var ids = [];
      var user = null;
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          user = dto;
          ids[i] = dto.id;
        }
      } else {
        self.$Message.warning('请选择目标');
        this.cancelLoading = false;
        return;
      }
      this.$Modal.confirm({
        title: '[' + user.id + '-' + user.nickname + ']' + '>>取消结课',
        width: 300,
        okText: '确定',
        loading: true,
        render: function render(h, params) {
          return h('div', [h('Input', {
            props: {
              placeholder: '请输入复课原因'
            },
            on: {
              input: function input(e) {
                self.remark = e;
              }
            }
          }), h('Button', {
            attrs: { disabled: self.disabled },
            on: {
              click: function click() {
                self.$http.get('/userinfo/sendUpdateMobileSmsCode', { params: { uid: user.id, key: 'call_back_from_stop_sms' } }).then(function (res) {
                  if (res.status === 'ok') {
                    self.disabled = true;
                    self.$Message.success('验证码发送成功!');
                    self.timer = setInterval(function () {
                      if (self.time <= 0) {
                        self.disabled = false;
                        self.time = 60;
                        clearInterval(_this3.timer);
                      } else {
                        self.time -= 1;
                      }
                    }, 1000);
                  }
                });
              }
            }
          }, self.disabled ? self.time + '秒' : '发送验证码'), h('Input', {
            props: {
              placeholder: '短信验证码'
            },
            on: {
              input: function input(e) {
                self.smsCode = e;
              }
            }
          })]);
        },
        onOk: function onOk() {
          _this3.$http.post('/user/lessonsStop/batchCancelUserStopLesson', {
            ids: ids.join(','),
            remark: _this3.remark,
            isStop: 2,
            smsCode: _this3.smsCode
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('移出申请已提交');
              self.cancelLoading = false;
              self.search();
              self.$Modal.remove();
            } else {
              self.$Message.error('批量移出失败！');
              self.cancelLoading = false;
              self.$Modal.remove();
            }
          }).catch(function (e) {
            _this3.cancelLoading = false;
          });
        },
        onCancel: function onCancel() {
          _this3.cancelLoading = false;
          self.time = 60;
          clearInterval(_this3.timer);
          self.disabled = false;
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TchInfoModal: __WEBPACK_IMPORTED_MODULE_0__teacher_modal_TchInfoModal___default.a
  },
  name: 'UserPLLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tId: '',
      tchName: '',
      companionPracticingParam: {
        uid: null,
        tchId: '',
        category: '',
        classType: 1,
        courseType: 8,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        beginTime: '18:00',
        schoolId: 0
      },
      timeStr: '18:00',
      chineseLessonRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.companionPracticingParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            var lsnBeginTime = self.getLsnBeginTime();
            var nowTime = new Date().getTime() / 1000;
            if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            callback();
          }
        }]
      },
      tchId: null,
      showTchInfoModal: false
    };
  },

  methods: {
    tchAvatarSrc: function tchAvatarSrc(avatar) {
      return __WEBPACK_IMPORTED_MODULE_1__tools_commonUtils_js___default.a.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
    },
    insertChineseLesson: function insertChineseLesson() {
      var self = this;
      self.$http.get('/bookLesson/selectTchOpendCount?tchId=' + self.companionPracticingParam.tchId + '&courseType=' + self.companionPracticingParam.courseType).then(function (res) {
        if (res && res.data >= 120) {
          self.$Modal.confirm({
            title: '提示',
            content: '选择的陪练老师单月已超过120课，当前老师本月已上课' + res.data + '节，上课费用增加，是否继续预约此老师课程！',
            width: 300,
            okText: '确定',
            loading: true,
            onOk: function onOk() {
              self.insertLesson();
              self.$Modal.remove();
            }
          });
        } else {
          self.insertLesson();
        }
      });
    },
    insertLesson: function insertLesson() {
      var self = this;
      self.loadingConfirm = true;
      self.$refs.chineseLessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingConfirm = false;
          return;
        }
        self.companionPracticingParam.lsnBeginTime = self.getLsnBeginTime();
        self.$http.post('/user/lesson/addCourse', self.companionPracticingParam).then(function (res) {
          self.loadingConfirm = false;
          if (res) {
            self.$Message.success('约课成功!');
            self.visible = false;
            return;
          }
        });
      });
    },
    searchTch: function searchTch() {
      var self = this;
      var isNotError = true;
      self.$refs.chineseLessonForm.validateField('lsnBeginDayTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      self.tchList = [];
      var path = '/tch/time/queryFreeTimeTch?lsnBeginTime=' + self.getLsnBeginTime() + '&timeLength=' + self.companionPracticingParam.timeLength + '&tchType=3';
      if (self.tId) {
        path = path + '&tchId=' + self.tId;
      }
      if (self.companionPracticingParam.category) {
        path = path + '&category=' + self.companionPracticingParam.category;
      }
      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data;
        }
        self.loadingSearch = false;
      });
    },
    onChangeTime: function onChangeTime(val) {
      this.companionPracticingParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.companionPracticingParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    changeLevel: function changeLevel(val) {
      if (!val) {
        return;
      } else {
        var self = this;
        self.bookMaterialLessonsList = null;
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.bookMaterialLessonsList = res.data;
        });
      }
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.companionPracticingParam.lsnBeginDayTime) + this.companionPracticingParam.beginTime.getMinutes() * 60 + this.companionPracticingParam.beginTime.getHours() * 60 * 60;
    },
    clearTchList: function clearTchList() {
      this.tchList = [];
      this.companionPracticingParam.tchId = '';
    },
    showTchMessage: function showTchMessage(id) {
      this.tchId = parseInt(id);
      this.showTchInfoModal = true;
    },
    updateTchInfoSuccess: function updateTchInfoSuccess() {
      this.showTchInfoModal = false;
    },
    onTchChange: function onTchChange(id, name) {
      this.tchName = name;
      if (id) {
        this.searchTch();
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.loadingConfirm = false;
        this.loadBookMaterialLevel();
        this.clearTchList();
        this.$refs['chineseLessonForm'].resetFields();
        this.companionPracticingParam.uid = this.user.id;
        this.companionPracticingParam.nickname = this.user.nickname;
        this.companionPracticingParam.mobile = this.user.mobile;

        var now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.companionPracticingParam.lsnBeginTimeDate = now;
        this.companionPracticingParam.lsnBeginDayTime = now.getTime() / 1000;
        this.timeStr = '18:00';
        this.companionPracticingParam.time = 18 * 3600;
      } else {
        this.tId = '';
        this.tchName = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tchScore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_RecommendTeacherModal_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_RecommendTeacherModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__crm_RecommendTeacherModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_distpicker__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_distpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_distpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_StageReportModal_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_StageReportModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__crm_StageReportModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_EvaluationSheetModal_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_EvaluationSheetModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__crm_EvaluationSheetModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lesson_BookUserFeedbackModal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lesson_BookUserFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lesson_BookUserFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lesson_BookTchFeedbackModal_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lesson_BookTchFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__lesson_BookTchFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lesson_BookTchScoreFeedbackModal_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lesson_BookTchScoreFeedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lesson_BookTchScoreFeedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lesson_ClassMemberTimeModal_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lesson_ClassMemberTimeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__lesson_ClassMemberTimeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lesson_ChangeLessonModal_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lesson_ChangeLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__lesson_ChangeLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lesson_UserOneLeaveModal_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lesson_UserOneLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__lesson_UserOneLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__teacher_TchLessonLeaveModal_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__teacher_TchLessonLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__teacher_TchLessonLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lesson_LessonCancelModal_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lesson_LessonCancelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__lesson_LessonCancelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lesson_BalanceModal_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lesson_BalanceModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__lesson_BalanceModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lesson_RejectBalanceModal_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lesson_RejectBalanceModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__lesson_RejectBalanceModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lesson_modal_MonitorLessonRecordListModal_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lesson_modal_MonitorLessonRecordListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__lesson_modal_MonitorLessonRecordListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UserClassHourModal_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UserClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__UserClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lesson_modal_AddMonitorLessonRecordModal_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lesson_modal_AddMonitorLessonRecordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__lesson_modal_AddMonitorLessonRecordModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__StudentWriteReviewDemoModal_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__StudentWriteReviewDemoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__StudentWriteReviewDemoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StudentWriteReviewDemoV2Modal_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StudentWriteReviewDemoV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__StudentWriteReviewDemoV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StudentWriteReviewRegularModal_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StudentWriteReviewRegularModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__StudentWriteReviewRegularModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StudentWriteReviewRegularV2Modal_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StudentWriteReviewRegularV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__StudentWriteReviewRegularV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__StudentWriteReviewFinishLevelModal_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__StudentWriteReviewFinishLevelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__StudentWriteReviewFinishLevelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__StudentWriteReviewFinishLevelV2Modal_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__StudentWriteReviewFinishLevelV2Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__StudentWriteReviewFinishLevelV2Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tools_date_format_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__tools_date_format_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__order_ShowImageCarousel__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__order_ShowImageCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__order_ShowImageCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__UserTrackContentModal_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__UserTrackContentModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__UserTrackContentModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__TrackContentPreview_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__TrackContentPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__TrackContentPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lesson_modal_SearchChangeTchModal_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lesson_modal_SearchChangeTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__lesson_modal_SearchChangeTchModal_vue__);





































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserPayDetail',
  components: {
    TrackContentPreview: __WEBPACK_IMPORTED_MODULE_32__TrackContentPreview_vue___default.a,
    SearchChangeTchModal: __WEBPACK_IMPORTED_MODULE_33__lesson_modal_SearchChangeTchModal_vue___default.a,
    ShowImageCarousel: __WEBPACK_IMPORTED_MODULE_30__order_ShowImageCarousel___default.a,
    SingleOnePicUpload: __WEBPACK_IMPORTED_MODULE_3__common_SingleOnePicUpload_vue___default.a,
    RecommendTeacher: __WEBPACK_IMPORTED_MODULE_4__crm_RecommendTeacherModal_vue___default.a,
    RecommendList: __WEBPACK_IMPORTED_MODULE_5__common_RecommendList_vue___default.a,
    VDistpicker: __WEBPACK_IMPORTED_MODULE_6_v_distpicker___default.a,
    StageReportModal: __WEBPACK_IMPORTED_MODULE_7__crm_StageReportModal_vue___default.a,
    EvaluationSheetModal: __WEBPACK_IMPORTED_MODULE_8__crm_EvaluationSheetModal_vue___default.a,
    BookUserFeedbackModal: __WEBPACK_IMPORTED_MODULE_9__lesson_BookUserFeedbackModal_vue___default.a,
    BookTchFeedbackModal: __WEBPACK_IMPORTED_MODULE_10__lesson_BookTchFeedbackModal_vue___default.a,
    BookTchScoreFeedbackModal: __WEBPACK_IMPORTED_MODULE_11__lesson_BookTchScoreFeedbackModal_vue___default.a,
    ClassMemberTimeModal: __WEBPACK_IMPORTED_MODULE_12__lesson_ClassMemberTimeModal_vue___default.a,
    ChangeLessonModal: __WEBPACK_IMPORTED_MODULE_13__lesson_ChangeLessonModal_vue___default.a,
    UserOneLeaveModal: __WEBPACK_IMPORTED_MODULE_14__lesson_UserOneLeaveModal_vue___default.a,
    TchLessonLeaveModal: __WEBPACK_IMPORTED_MODULE_15__teacher_TchLessonLeaveModal_vue___default.a,
    LessonCancelModal: __WEBPACK_IMPORTED_MODULE_16__lesson_LessonCancelModal_vue___default.a,
    BalanceModal: __WEBPACK_IMPORTED_MODULE_17__lesson_BalanceModal_vue___default.a,
    RejectBalanceModal: __WEBPACK_IMPORTED_MODULE_18__lesson_RejectBalanceModal_vue___default.a,
    MonitorLessonRecordListModal: __WEBPACK_IMPORTED_MODULE_19__lesson_modal_MonitorLessonRecordListModal_vue___default.a,
    UserClassHourModal: __WEBPACK_IMPORTED_MODULE_20__UserClassHourModal_vue___default.a,
    AddMonitorLessonRecordModal: __WEBPACK_IMPORTED_MODULE_21__lesson_modal_AddMonitorLessonRecordModal_vue___default.a,
    StudentWriteReviewDemoModal: __WEBPACK_IMPORTED_MODULE_22__StudentWriteReviewDemoModal_vue___default.a,
    StudentWriteReviewDemoV2Modal: __WEBPACK_IMPORTED_MODULE_23__StudentWriteReviewDemoV2Modal_vue___default.a,
    StudentWriteReviewRegularModal: __WEBPACK_IMPORTED_MODULE_24__StudentWriteReviewRegularModal_vue___default.a,
    StudentWriteReviewRegularV2Modal: __WEBPACK_IMPORTED_MODULE_25__StudentWriteReviewRegularV2Modal_vue___default.a,
    StudentWriteReviewFinishLevelModal: __WEBPACK_IMPORTED_MODULE_26__StudentWriteReviewFinishLevelModal_vue___default.a,
    StudentWriteReviewFinishLevelV2Modal: __WEBPACK_IMPORTED_MODULE_27__StudentWriteReviewFinishLevelV2Modal_vue___default.a,
    UserTrackContentModal: __WEBPACK_IMPORTED_MODULE_31__UserTrackContentModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    var $numeral = this.$numeral;
    var self = this;
    return {
      studentWriteReviewRegularModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        word1: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word2: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word3: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word4: [{ remark: '' }, { remark: '' }, { remark: '' }],
        fileList: [],
        parent: '',
        levelMsg: ''
      },
      studentWriteReviewRegularV2ModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        rate5: 2,
        rate6: 2,
        word1: [{ remark: '' }, { remark: '' }, { remark: '' }],
        word2: [{ remark: '' }, { remark: '' }, { remark: '' }],
        parent: ''
      },
      studentWriteReviewDemoModalFormData: {
        remark: '',
        word1: '',
        word2: ''
      },
      studentWriteReviewFinishLevelModalFormData: {
        remark: '',
        suggestions: '',
        fileList: []
      },
      studentWriteReviewFinishLevelV2ModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        rate5: 2,
        rate6: 2,
        word1: '',
        word2: '',
        word3: ''
      },
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewDemoV2Modal: false,
      showVersionModel: false,
      showContractStatusModel: false,
      fundPackageId: '',
      reload_fundPackage: 0,
      timer: '',
      time: 60,
      disabled: false,
      askForTch: false,
      nextDate: '',
      reprotId: null,
      cityInfo: '',
      insertLoading: false,
      fixedClassRequire: '',
      fixedClassRequireEn: '',
      fixedClassRequireSaving: false,
      StageReportModal: false,
      showEvaluationSheetModal: false,
      defaultPicList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      followList: [],
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      reload: 0,
      text: '编辑头像',
      totalImageUrl: '',
      currentTab: 'one',
      recommendData: null,
      fundPackageData: null,
      courseTypeData: [],
      classHourListData: [],
      paramsErrors: [],
      recommendEdit: false,
      reset: false,
      fundPackageRest: false,
      tabName: 'one',
      summativeEnabled: false,
      harvardForeignEnabled: false,
      harvardForeignLoaded: false,
      summativeBlueprintId: null,
      summativeBlueprints: [],
      summativeLoaded: false,
      placeholders: {
        province: '------- 省 --------',
        city: '--- 市 ---',
        area: '--- 区 ---'
      },
      formData: {
        enabledRule: false,
        stars: 1,
        tchIdCopy: 0,
        channelParam: '',
        oldMobile: '',
        smsCode: '',
        uid: null,
        reprotId: null,
        itemUrl: '',
        enName: '',
        cnName: '',
        canal: '',
        payCanal: '',
        mobile: '',
        remarkMobile: '',
        phoneRole: '',
        wechatAccount: '',
        infoRemark: '',
        address: '',
        learnEnglishTime: '',
        haveContactForeignTeacher: '',
        familyEconomicSituation: '',
        attentionEnglish: '',
        province: '',
        city: '',
        block: '',
        sex: '',
        password: '',
        imageUrl: '',
        intentLevel: '',
        noStudyAdviserRemind: 0,
        age: '',
        connectionStatus: '',
        userContacts: [],
        grade: '',
        birthday: null,
        exten: null,
        allowCallReminder: '',
        allowSmsReminder: '',
        mobileRemind: 1,
        remarkMobileRemind: 1,
        beforeClassCall: 0,
        remindHours: '',
        classRequirement: '',
        classRequirementTags: [],
        vipDesc: '',
        tchChannel: 1
      },
      followFormData: {
        id: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        tchNames: [],
        traceStatus: '',
        traceItem: '',
        content: '',
        nextDate: '',
        files: '',
        stuDescCheckGroup: [],
        askForTchCheckGroup: []
      },
      showWo: false,
      woChecked: false,
      userInfoChecked: false,
      showwoSubmit: true,
      showImgModal: false,
      woSubmitLoading: false,
      showImgList: [],
      woReadonly: false,
      woFormData: {
        saleWo: {
          id: '',
          studentId: '',
          payAmount: null,
          adviserName: '',
          studyAdviserName: '',
          teacherName: '',
          woStatus: '',
          remark: '',
          classOpeningTime: '',
          disableTimeList: null,
          woVersion: null,
          age: null
        },
        follows: []
      },
      nextHandler: [],
      uidReadonly: false,
      disable: false,
      aiLoading: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        contentRaw: '',
        nextHandlerId: null,
        status: '0',
        traceType: '',
        nextHandlerTime: '',
        nextTimeDate: '',
        files: ''
      },
      traceParam: {
        totalCount: 0,
        pageSize: 10,
        pageIndex: 1,
        uid: ''
      },
      tableData: [],
      ruleValidate: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur' }],
        traceType: [{ required: true, message: '属性不能为空', trigger: 'blur' }]

      },
      woRule: {
        remark: [{ type: 'string', max: 1000, message: '内容不能超过1000个字', trigger: 'blur' }],
        payAmount: [{ type: 'number', required: true, min: 0, max: 100000, message: '请填写正确的支付金额', trigger: 'blur' }]
      },
      callRecordData: [],
      userModal: null,
      studentNature: [],
      studyExperience: [],
      hobby: [],
      englishLevel: [],
      tchRequirement: [],
      queryParam: {
        intentLevel: '',
        uid: '',
        mobile: ''
      },
      callRecordTitle: [{
        title: '通话时间',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('p', { style: { margin: '0' } }, params.row.beginTime), h('p', { style: { margin: '0' } }, '通话时长:' + _this.formatRecordTime(params.row.hold))]);
        }
      }, {
        title: '员工',
        key: 'callerId',
        align: 'center'
      }, {
        title: '通话录音',
        render: function render(h, params) {
          var audioUrl = params.row.recordUrl;
          if (audioUrl) {
            if (audioUrl === '失败') {
              return h('span', '无录音');
            }
            return h('audio', {
              attrs: {
                src: audioUrl,
                controls: true },
              style: {
                width: '100%'
              }
            });
          } else {
            return h('span', '无录音');
          }
        }
      }, {
        title: '备注',
        align: 'center',
        key: 'content'
      }],
      visible: this.value,
      userRule: {
        age: [{ pattern: /^[0-9]+$/, message: '只能输入数字', trigger: 'blur' }]
      },
      followRule: {
        traceStatus: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        traceItem: [{ type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      },
      followData: [],
      stageReportData: [],
      appVersionData: {},
      woFollowTitle: [{
        title: '时间',
        width: 100,
        key: 'gmtCreate'
      }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          var woStatus = params.row.newStatus;
          var woStatusEnum = $constant.getEnum($constant.woStatus, woStatus);
          return h('span', woStatusEnum && woStatusEnum.text);
        }
      }, {
        title: '备注',
        key: 'remark'
      }, {
        title: '角色',
        width: 100,
        key: 'roleName'
      }, {
        title: '处理人',
        width: 100,
        key: 'creatorName'
      }],
      followtitle: [{
        title: '时间',
        width: 100,
        key: 'gmtCreate'
      }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          if (params.row.traceStatus == 100 || params.row.creatorName === '注册备注') return h('span', '注册备注');
          var traceStatus = params.row.traceStatus;
          var traceStatusEnum = $constant.getEnum($constant.traceStatus, traceStatus);
          return h('span', traceStatusEnum && traceStatusEnum.text);
        }
      }, {
        title: 'follow up选项',
        key: 'traceItem',
        width: 90,
        render: function render(h, params) {
          var traceItem = params.row.traceItem;
          var traceItemEnum = $constant.getEnum($constant.traceItem, traceItem);
          return h('span', traceItemEnum && traceItemEnum.text);
        }
      }, {
        title: '内容',
        key: 'content'
      }, {
        title: '下次联系时间',
        width: 100,
        key: 'nextContactTime'
      }, {
        title: '处理人',
        width: 100,
        key: 'creatorName'
      }],
      stageReportTitle: [{
        title: '老师ID/姓名',
        key: 'tchNameId',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchNameId,
            score: row.monthRankScore
          });
        }
      }, {
        title: '报告对应课节',
        key: 'lessonNum'
      }, {
        title: '外管',
        key: 'studyName'
      }, {
        title: '学导',
        key: 'tutorName'
      }, {
        title: '阶段测评报告',
        render: function render(h, params) {
          var row = params.row;
          if (row.reportDoc !== '') {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.lookRerot(row.id);
                } } }, '查看与编辑')]);
          }
        }
      }, {
        title: '添加时间',
        key: 'gmtCreate'
      }, {
        title: '添加人',
        key: 'creatorName'
      }, {
        title: '状态',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 1) {
            return h('span', '待审核');
          } else {
            return h('span', '已通过');
          }
        }
      }, {
        title: '操作',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 2) {
            return h('span', '');
          } else {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  _this.editReport(row.id, 2);
                }
              }
            }, '通过')]);
          }
        }
      }],
      recommendTitle: [{
        title: '老师ID/姓名',
        render: function render(h, params) {
          var row = params.row;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
            score: row.monthRankScore
          });
        }
      }, {
        title: '类型',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.teacherCategory, row.category);
          return h('span', cons && cons.text);
        }
      }, {
        title: '授课类型',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.tchType, row.tchType);
          return h('span', cons && cons.text);
        }
      }, {
        title: '性别',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.sex, row.sex);
          return h('span', cons && cons.text);
        }
      }, {
        title: '口音',
        render: function render(h, params) {
          var row = params.row;
          var cons = _this.$constant.getEnum(_this.$constant.accent, row.accent);
          return h('span', cons && cons.text);
        }
      }, {
        title: '年龄',
        key: 'age'
      }, {
        title: '推荐理由',
        key: 'reason'
      }, {
        title: '推荐人',
        key: 'recommendName'
      }, {
        title: '取消人',
        key: 'cancelName'
      }, {
        title: '操作',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 1) {
            return h('a', { on: { click: function click() {
                  return _this.cancelRecommend(row.id);
                } } }, '取消推荐');
          } else {
            return h('span', '已取消');
          }
        }
      }],
      fundPackageTitle: [{
        title: '订单号',
        width: 100,
        key: 'orderId'
      }, {
        title: '姓名',
        width: 100,
        key: 'nickname'
      }, {
        title: '渠道',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          var channel = row.channel;
          var channelEnum = $constant.getEnum($constant.orderChannel, channel);
          return h('div', channelEnum && channelEnum.text);
        },
        key: 'channel'
      }, {
        title: '订单权益',
        width: 250,
        render: function render(h, params) {
          var row = params.row;
          if (row.tchChannel === 1) {
            return h('div', [h('p', '外教课时:' + (row.num || 0)), h('p', '中教课时:' + (row.chineseNum || 0)), h('p', '陪练课时:' + (row.partnerNum || 0)), h('p', '赠送课时:' + (row.discountNum || 0)), h('p', '直播课时:' + (row.livingNum || 0)), h('p', '辅修课时:' + (row.minorNum || 0)), h('p', '请假次数:' + (row.leaveNum || 0)), h('p', '补课次数:' + (row.makeupLessonNum || 0))]);
          }
          var attrs = [];
          row.classHourList.forEach(function (item) {
            attrs.push(h('p', item.channel + ':' + (item.num > 0 ? item.num : '')));
          });
          return h('div', attrs);
        }
      }, {
        title: '套餐金额',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          return h('div', [h('p', { style: { color: '#2d8cf0' } }, '套餐金额:' + $numeral(row.amount).format('0,0.00')), h('p', '优惠金额:' + $numeral(row.discount).format('0,0.00')), h('p', '实付金额:' + $numeral(row.payAmount).format('0,0.00')), h('p', { style: { color: 'red' } }, '已付金额:' + $numeral(row.hasPayAmount).format('0,0.00'))]);
        }
      }, {
        title: '订单状态',
        width: 110,
        align: 'center',
        render: function render(h, params) {
          var state = params.row.state;
          var stateEnum = $constant.getEnum($constant.fundPackageState, state);
          return h('div', stateEnum && stateEnum.text);
        }
      }, {
        title: '支付方式',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var payWay = params.row.payWay;
          var stateEnum = $constant.getEnum($constant.payWayNew, payWay);
          return h('div', stateEnum && stateEnum.text);
        }
      }, {
        title: '创建时间',
        width: 170,
        align: 'center',
        render: function render(h, params) {
          var createTime = params.row.createTime;
          return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '版本号',
        width: 80,
        render: function render(h, params) {
          var num = ['版本一', '版本二', '版本三', '版本四'];
          return h('div', params.row.version === -1 ? '-' : num[params.row.version - 1]);
        }
      }, {
        title: '合同状态',
        width: 100,
        render: function render(h, params) {
          var status = params.row.contractStatus === -1 ? '-' : $constant.getEnum($constant.contractStatus, params.row.contractStatus).text;
          return h('div', status);
        }
      }, {
        title: '创建人',
        width: 150,
        render: function render(h, params) {
          var creatorId = params.row.creatorId;
          var creatorName = params.row.creatorName;
          return h('div', [h('span', creatorId), h('span', '-'), h('span', creatorName)]);
        }
      }, {
        title: '操作',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.contractStatus === 2) {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  self.showModel('version', row);
                }
              }
            }, '修改版本号'), h('br'), h('a', {
              on: {
                click: function click() {
                  self.showModel('contractStatus', row);
                }
              }
            }, '修改合同状态')]);
          } else {
            return h('div', [h('a', {
              on: {
                click: function click() {
                  self.onPreview(row);
                }
              }
            }, '查看合同'), h('br'), h('a', {
              on: {
                click: function click() {
                  self.showModel('version', row);
                }
              }
            }, '修改版本号'), h('br'), h('a', {
              on: {
                click: function click() {
                  self.showModel('contractStatus', row);
                }
              }
            }, '修改合同状态')]);
          }
        }
      }],
      uid: null,
      parm: {},
      courseTypeTitle: [{
        title: '课程类型',
        width: 150,
        render: function render(h, params) {
          var courseType = params.row.courseType;
          if (courseType && courseType === 1) {
            return h('span', '外教课');
          } else if (courseType && courseType === 2) {
            return h('span', '中教课');
          } else if (courseType && courseType === 8) {
            return h('span', '陪练课');
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '订单总课时',
        width: 200,
        render: function render(h, params) {
          var row = params.row;
          var totalOrderNum = row.totalOrderNum;
          totalOrderNum = totalOrderNum > 0 ? totalOrderNum : 0;
          var totalPresenterNum = row.totalPresenterNum;
          totalPresenterNum = totalPresenterNum > 0 ? totalPresenterNum : 0;
          var totalNum = row.totalOrderNum + row.totalPresenterNum;
          totalNum = totalNum > 0 ? totalNum : 0;
          return h('div', [h('p', '套餐课时:' + totalOrderNum), h('p', '赠送课时:' + totalPresenterNum), h('p', { style: { color: 'red' } }, '订单总课时:' + totalNum)]);
        }
      }, {
        title: '手动添加课时',
        width: 100,
        render: function render(h, params) {
          var totalAddNum = params.row.totalAddNum;
          totalAddNum = totalAddNum > 0 ? totalAddNum : 0;
          return h('span', totalAddNum);
        }
      }, {
        title: '手动减少课时',
        width: 100,
        render: function render(h, params) {
          var totalReduceNum = params.row.totalReduceNum;
          totalReduceNum = totalReduceNum > 0 ? totalReduceNum : 0;
          return h('span', totalReduceNum);
        }
      }, {
        title: '总课时',
        width: 100,
        render: function render(h, params) {
          var totalNum = params.row.totalNum;
          totalNum = totalNum > 0 ? totalNum : 0;
          return h('span', totalNum);
        }
      }, {
        title: '正常消耗',
        width: 100,
        render: function render(h, params) {
          var endNum = params.row.endNum;
          endNum = endNum > 0 ? endNum : 0;
          return h('span', endNum);
        }
      }, {
        title: '总剩余课时',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var num = row.totalNum - row.endNum;
          num = num >= 0 ? num : 0;
          return h('span', num);
        }
      }, {
        title: '锁定课时',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var num = row.lockNum;
          num = num >= 0 ? num : 0;
          return h('span', num);
        }
      }, {
        title: '剩余可用',
        width: 100,
        render: function render(h, params) {
          var row = params.row;
          var num = row.totalNum - row.endNum - row.lockNum;
          num = num >= 0 ? num : 0;
          return h('span', num);
        }
      }, {
        title: '剩余请假次数',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          var num = row.remainingLeaveNum;
          num = num >= 0 ? num : '';
          return h('span', num);
        }
      }, {
        title: '剩余补课次数',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          var num = row.remainingMakeupNum;
          num = num >= 0 ? num : '';
          return h('span', num);
        }
      }, {
        title: '总试听课次数',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          var num = row.demoClassHourNum;
          num = num >= 0 ? num : '';
          return h('span', num);
        }
      }, {
        title: '剩余试听课次数',
        width: 150,
        render: function render(h, params) {
          var row = params.row;
          var num = row.demoClassHourResidueNum;
          num = num >= 0 ? num : '';
          return h('span', num);
        }
      }],
      courseHourTitle: [{
        title: '数量(节|次)',
        width: 100,
        align: 'center',
        key: 'num'
      }, {
        title: '已消耗',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'red' } }, params.row.consumeNum);
        }
      }, {
        title: '锁定(已选)',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'orange' } }, params.row.lockNum);
        }
      }, {
        title: '剩余可用',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'green' } }, params.row.num - params.row.consumeNum - params.row.lockNum);
        }
      }, {
        title: '类型',
        width: 135,
        align: 'center',
        key: 'type'
      }, {
        title: '权益说明',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.taskNum > 0) {
            return [h('span', row.channel + '（'), h('span', { style: { color: 'blue' } }, row.taskNum), h('span', '）')];
          }
          return row.channel;
        }
      }, {
        title: '生效时间',
        width: 135,
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '有效期(天)',
        width: 135,
        align: 'center',
        key: 'effectDays'
      }, {
        title: '到期时间',
        width: 135,
        align: 'center',
        key: 'expireTime'
      }, {
        title: '操作人)',
        width: 135,
        align: 'center',
        key: 'creatorName'
      }],
      bookLessonTitle: [{
        title: '老师ID/姓名',
        width: 180,
        render: function render(h, params) {
          var row = params.row;
          var isChange = '';
          if (row.isNewTch === 1) {
            isChange = '(替)';
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["a" /* renderTchNameWithScore */])(h, {
            text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
            score: row.monthRankScore,
            onClick: function onClick() {
              return _this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName);
            }
          });
        }
      }, {
        title: '课程信息',
        width: 130,
        render: function render(h, params) {
          var row = params.row;
          var lsnType = row.lsnType;
          var typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType);
          var courseType = row.courseType;
          var courseTypeEnum = $constant.getEnum($constant.courseType, courseType);
          var cType = courseTypeEnum && courseTypeEnum.text;
          if (cType) {
            cType = '课程类别:' + cType;
          } else {
            cType = '';
          }
          return h('div', [h('p', row.id), h('p', row.lessonTitle), h('p', { style: { 'font-size': '12px', color: 'red' } }, cType), h('p', { style: { 'font-size': '12px', color: '#2d8cf0' } }, '课程类型:' + (typeEnum && typeEnum.text))]);
        }
      }, {
        title: '上课时间',
        width: 110,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var week = $moment(lsnBeginTime, 'X').day();
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $constant.weekZh[week]);
        }
      }, {
        title: '时长',
        align: 'center',
        width: 60,
        key: 'courseTime',
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', (lsnEndTime - lsnBeginTime) / 60);
        }
      }, {
        title: '教室',
        width: 120,
        render: function render(h, params) {
          var row = params.row;
          var classType = row.classType;
          var typeEnum = $constant.getEnum($constant.classType, classType);
          return h('div', { style: { 'font-size': '14px' } }, [h('span', typeEnum && typeEnum.text), h('span', ' - '), h('br'), h('span', row.courseId)]);
        }
      }, {
        title: '状态',
        width: 110,
        render: function render(h, params) {
          var row = params.row;
          var remark = row.remark;
          var lsnSelStatus = row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          var absentArr = [];
          if (row.tchAbsent === 1) {
            absentArr.push('老师缺席');
          }
          if (row.stdAbsent === 1) {
            absentArr.push('学生缺席');
          }
          return h('div', { style: { 'font-size': '14px' } }, [h('span', statusEnum && statusEnum.text), absentArr.length ? h('span', { style: { 'font-size': '13px', color: 'red' } }, ' [' + absentArr.join(' ') + ']') : null, h('br'), h('span', { style: { 'font-size': '13px', color: 'red' } }, remark)]);
        }
      }, {
        title: '创建操作人',
        width: 180,
        key: 'creatorName',
        render: function render(h, params) {
          var row = params.row;
          var studyAdviserNickname = row.studyAdviserNickname;
          if (!studyAdviserNickname) {
            studyAdviserNickname = '未分配';
          }
          var adviserNickname = row.adviserNickname;
          if (!adviserNickname) {
            adviserNickname = '未分配';
          }
          var tchStudyName = row.tchStudyName;
          if (!tchStudyName) {
            tchStudyName = '未分配';
          }
          return h('div', { style: { 'font-size': '13px' } }, [h('p', '学导:' + studyAdviserNickname), h('p', '课顾:' + adviserNickname), h('p', '外管:' + tchStudyName), h('p', '创建人：' + row.creatorName), h('p', '最后操作人：' + row.adminNickname)]);
        }
      }, {
        title: '操作时间',
        width: 110,
        key: 'gmtModified'
      }, {
        title: '排课时间',
        width: 110,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lessonOpenTime;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'));
        }
      }, {
        title: '评价',
        width: 130,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var bookTchFeedbackUid = row.bookTchFeedbackUid;
          var spanArr = [];
          var version = row.version;
          if (bookTchFeedbackUid) {
            var obj = h('a', {
              on: {
                click: function click() {
                  _this.openedId = row.id;

                  if (version === 0) {
                    if (row.lsnType === 1) {
                      _this.showBookTchScoreFeedbackModal = true;
                    } else {
                      _this.showBookTchFeedbackModal = true;
                    }
                  } else if (version === 1) {
                    if (row.lsnType === 1) {
                      _this.studentWriteReviewDemoModal = true;
                    } else if (row.lsnType === 2) {
                      if (row.stageSummary) {
                        _this.studentWriteReviewFinishLevelModal = true;
                      } else {
                        _this.studentWriteReviewRegularModal = true;
                      }
                    }
                  } else if (version === 2) {
                    if (row.lsnType === 1) {
                      _this.studentWriteReviewDemoV2Modal = true;
                    } else if (row.lsnType === 2) {
                      if (row.stageSummary) {
                        _this.studentWriteReviewFinishLevelV2Modal = true;
                      } else {
                        _this.studentWriteReviewRegularV2Modal = true;
                      }
                    }
                  }
                }
              }
            }, '老师对学生评价');
            var her = 'https://test-h5.kouyujie.cn/std-report/report.html?bookLessonId=' + row.id;
            if (_this.$appConfig.active === 'prod') {
              her = 'https://h5.speakstreet.cn/std-report/report.html?bookLessonId=' + row.id;
            }

            var previewLink = h('a', {
              attrs: {
                href: her,
                target: '_blank'
              },
              style: {
                marginLeft: '10px'
              }
            }, '预览');
            spanArr.push(obj);
            spanArr.push(h('br'));
            if (row.lsnType === 1 && version === 2) {
              spanArr.push(h('br'));
              spanArr.push(previewLink);
              spanArr.push(h('br'));
            }
          }
          var bookUserFeedbackId = row.bookUserFeedbackId;
          var bookUserFeedbackStar = row.bookUserFeedbackStar;
          if (bookUserFeedbackId) {
            var obj2 = h('div', [h('Rate', {
              props: {
                disabled: true,
                count: bookUserFeedbackStar,
                value: bookUserFeedbackStar
              },
              style: { 'font-size': '12px' }
            }), h('br'), h('a', {
              on: {
                click: function click() {
                  _this.openedId = row.id;
                  _this.showBookUserFeedbackModal = true;
                }
              }
            }, '学生对老师评价')]);
            spanArr.push(obj2);
          }
          if (spanArr.length === 0) {
            return h('div', { style: { color: 'red' } }, '未评论');
          }
          return h('div', { style: { 'font-size': '13px', color: 'red' } }, spanArr);
        }
      }, {
        title: '上课情况',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('a', {
            on: {
              click: function click() {
                _this.openedId = params.row.id;
                _this.showClassMemberTimeModal = true;
              }
            }
          }, '查看');
        }
      }, {
        title: '监课/回放',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          if (params.row.liveUrl) {
            return h('a', {
              on: {
                click: function click() {
                  window.open(params.row.liveUrl);
                }
              }
            }, '进入');
          } else {
            return h('span');
          }
        }
      }, {
        title: '操作',
        align: 'center',
        width: 80,
        render: function render(h, params) {
          var row = params.row;
          var id = parseInt(row.id);
          var lsnType = row.lsnType;
          var lessonTitle = row.lessonTitle;
          var lsnBeginTime = row.lsnBeginTime;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'reloadClassIn' } }, '手动生成ClassIn ID'));
          btn.push(h('Dropdown-item', { props: { name: 'lessonUrl' } }, '课程链接'));

          if (row.lsnSelStatus === 1) {
            var time = new Date().getTime();
            if (lsnBeginTime * 1000 - time >= 600000) {
              btn.push(h('Dropdown-item', { props: { name: 'changeLesson' } }, '调课件'));
            }
            btn.push(h('Dropdown-item', { props: { name: 'userLeave' } }, '学生请假'));

            if (row.lsnSelStatus !== 2 && lsnBeginTime * 1000 > time) {
              btn.push(h('Dropdown-item', { props: { name: 'cancelLesson' } }, '取消课程'));
            }
            if (row.isRecordScreen === 1) {
              btn.push(h('Dropdown-item', { props: { name: 'closeRecordScreen' } }, '关闭录屏'));
            } else {
              btn.push(h('Dropdown-item', { props: { name: 'openRecordScreen' } }, '开启录屏'));
            }
            if (lsnBeginTime * 1000 > time + 20 * 60 * 1000) {}
          }
          if (row.lsnSelStatus === 3) {
            btn.push(h('Dropdown-item', { props: { name: 'userAbsent' } }, '学生旷课'));
            btn.push(h('Dropdown-item', { props: { name: 'tchAbsent' } }, '老师旷课'));
            if (row.liveUrl) {
              btn.push(h('Dropdown-item', { props: { name: 'viewRecordScreen' } }, '查看录屏'));
            }
            btn.push(h('Dropdown-item', { props: { name: 'balance' } }, '课程结算'));
            btn.push(h('Dropdown-item', { props: { name: 'rejectBalance' } }, '拒绝结算'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'monitorLesson' } }, '添加监课记录'));

          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click',
              placement: 'bottom-end'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'reloadClassIn') {
                  _this.onReloadClassIn(row);
                } else if (name === 'lessonUrl') {
                  window.open('https://medias.kouyujie.cn/' + row.filePath);
                } else if (name === 'changeLesson') {
                  _this.lessonOpened = row;
                  _this.showChangeLessonModal = true;
                } else if (name === 'userLeave') {
                  _this.openId = id;
                  _this.lessonTitle = lessonTitle;
                  _this.lsnBeginTime = lsnBeginTime;
                  _this.showUserOneLeaveModal = true;
                } else if (name === 'tchLeave') {
                  _this.openedId = id;
                  _this.lessonTitle = lessonTitle;
                  _this.lsnBeginTime = lsnBeginTime;
                  _this.showTchLessonLeaveModal = true;
                } else if (name === 'cancelLesson') {
                  _this.openedId = id;
                  _this.lsnType = lsnType;
                  _this.showLessonCancelModal = true;
                } else if (name === 'userAbsent') {
                  _this.onUserAbsent(row);
                } else if (name === 'tchAbsent') {
                  _this.onTchAbsent(row);
                } else if (name === 'monitorLesson') {
                  _this.openedId = id;
                  _this.showMonitorLessonRecordModal = true;
                } else if (name === 'closeRecordScreen') {
                  _this.closeRecordScreen(row);
                } else if (name === 'openRecordScreen') {
                  _this.openRecordScreen(row);
                } else if (name === 'viewRecordScreen') {
                  _this.viewRecordScreen(row);
                } else if (name === 'balance') {
                  _this.openedId = id;
                  _this.showBalanceModal = true;
                } else if (name === 'rejectBalance') {
                  _this.openedId = id;
                  _this.showRejectBalanceModal = true;
                } else if (name === 'changeTeacherOnly') {
                  _this.tempLessonUser = row;
                  _this.showSearchChangeTchModal = true;
                  _this.changeTeacherOnly = true;
                  _this.optType = 2;
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      bookLessonReset: false,
      showBookUserFeedbackModal: false,
      showClassMemberTimeModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      showMonitorLessonRecordListModal: false,
      showChangeLessonModal: false,
      UserOneLeaveModal: false,
      showUserOneLeaveModal: false,
      showChangeLClassTypeModal: false,
      showMonitorLessonRecordModal: false,
      showTchLessonLeaveModal: false,
      showLessonCancelModal: false,
      showBalanceModal: false,
      showRejectBalanceModal: false,
      openedId: null,
      tempLessonUser: {},
      showSearchChangeTchModal: false,
      changeTeacherOnly: true,
      lsnType: null,
      openId: null,
      lessonOpened: {},
      lessonTitle: '',
      lsnBeginTime: null,
      reloadWithPage: 0,
      editUser: false,
      lessonParams: {
        date: __WEBPACK_IMPORTED_MODULE_28__tools_date_dates_js___default.a.today(),
        studyAdviserId: '',
        keywords: '',
        totalCount: 0,
        isAudition: null,
        category: null,
        tchType: null,
        accent: null,
        sex: null,
        backPath: ''
      },
      showUserClassHourModal: false,
      courseType: null,
      disableTimeParams: {
        disableWeek: null,
        disableWeekStr: null,
        disableStartTime: null,
        disableStartTimeStr: null,
        disableEndTime: null,
        disableEndTimeStr: null
      },
      disableTimeList: [],
      woVersion: null,
      woDisable: false
    };
  },
  computed: {
    appVersionTypeText: function appVersionTypeText() {
      var type = this.appVersionData.type;
      if (type === 1) return 'iOS';
      if (type === 2) return '安卓';
      return '-';
    },
    detailTabsReady: function detailTabsReady() {
      return this.woChecked && this.userInfoChecked;
    },
    fixedRequireLines: function fixedRequireLines() {
      return this.splitFixedRequire(this.fixedClassRequire);
    },
    fixedRequireEnLines: function fixedRequireEnLines() {
      return this.splitFixedRequire(this.fixedClassRequireEn);
    }
  },
  methods: {
    loadMonthRankScoresFor: function loadMonthRankScoresFor(rows, idKey) {
      idKey = idKey || 'tchId';
      if (!rows || !rows.length) {
        return;
      }
      var ids = [];
      rows.forEach(function (row) {
        var id = row[idKey];
        if ((id == null || id === '') && row.tchNameId) {
          var matched = String(row.tchNameId).match(/^(\d+)/);
          if (matched) {
            id = Number(matched[1]);
            row._scoreTchId = id;
          }
        }
        if (id != null && id !== '') {
          ids.push(id);
        }
      });
      var seq = ++this.rankScoreSeq;
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["b" /* fetchTchScoreMap */])(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_tchScore__["c" /* applyTchScoresToRows */])(self, rows, idKey, 'monthRankScore', map);
        rows.forEach(function (row) {
          if (row.monthRankScore == null && row._scoreTchId != null) {
            var score = map[row._scoreTchId];
            if (score == null) {
              score = map[String(row._scoreTchId)];
            }
            if (score != null) {
              self.$set(row, 'monthRankScore', score);
            }
          }
        });
      });
    },
    handleMultiLevelScheduleChange: function handleMultiLevelScheduleChange(value) {
      this.formData.stars = value ? 2 : 1;
    },
    handleSelfBookingChange: function handleSelfBookingChange(value) {
      this.formData.tchIdCopy = value ? 1 : 0;
    },
    handleNoStudyAdviserRemindChange: function handleNoStudyAdviserRemindChange(value) {
      this.formData.noStudyAdviserRemind = value ? 1 : 0;
    },
    handleMobileRemindChange: function handleMobileRemindChange(value) {
      this.formData.mobileRemind = value ? 1 : 0;
    },
    handleRemarkMobileRemindChange: function handleRemarkMobileRemindChange(value) {
      this.formData.remarkMobileRemind = value ? 1 : 0;
    },
    handleBeforeClassCallChange: function handleBeforeClassCallChange(value) {
      this.formData.beforeClassCall = value ? 1 : 0;
    },
    handleHarvardForeignAuthChange: function handleHarvardForeignAuthChange(value) {
      var _this2 = this;

      if (!this.harvardForeignLoaded) {
        return;
      }
      var prev = this.harvardForeignEnabled;
      this.harvardForeignEnabled = value;
      this.$http.post('/user/harvardForeignAuth/save', {
        uid: this.formData.uid,
        enabled: value ? 1 : 0
      }).then(function (res) {
        if (res) {
          _this2.$Message.success('修改成功');
        } else {
          _this2.harvardForeignEnabled = prev;
          _this2.$Message.error('修改失败');
        }
      }).catch(function () {
        _this2.harvardForeignEnabled = prev;
        _this2.$Message.error('修改失败');
      });
    },
    handleEnabledRuleChange: function handleEnabledRuleChange(value) {
      var _this3 = this;

      this.$http.post('/user/updateEnabledRule', {
        uid: this.formData.uid,
        enabledRule: value
      }).then(function (res) {
        if (res) {
          _this3.$Message.success('修改成功');
        } else {
          _this3.formData.enabledRule = !value;
          _this3.$Message.error('修改失败');
        }
      }).catch(function () {
        _this3.formData.enabledRule = !value;
        _this3.$Message.error('修改失败');
      });
    },
    handleSummativeEnabledChange: function handleSummativeEnabledChange(value) {
      var _this4 = this;

      if (!this.summativeLoaded) {
        return;
      }
      if (value && !this.summativeBlueprintId) {
        this.$Message.warning('请先选择阶段测蓝图');
        this.summativeEnabled = true;
        this.$nextTick(function () {
          _this4.summativeEnabled = false;
        });
        return;
      }
      var prevEnabled = this.summativeEnabled;
      this.summativeEnabled = value;
      this.saveStudentSummative({ prevEnabled: prevEnabled });
    },
    handleSummativeBlueprintChange: function handleSummativeBlueprintChange(id) {
      if (!this.summativeLoaded) {
        return;
      }
      if (id === this.summativeBlueprintId) {
        return;
      }
      var prevBlueprintId = this.summativeBlueprintId;
      this.summativeBlueprintId = id;
      this.saveStudentSummative({ prevBlueprintId: prevBlueprintId });
    },
    saveStudentSummative: function saveStudentSummative(rollback) {
      var self = this;
      self.$http.post('/mex/student-summative/save', {
        uid: self.formData.uid || self.uid,
        enabled: self.summativeEnabled ? 1 : 0,
        blueprintId: self.summativeBlueprintId
      }).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('修改成功');
        } else {
          self.rollbackSummativeSave(rollback);
          self.$Message.error(res.msg || '修改失败');
        }
      }).catch(function () {
        self.rollbackSummativeSave(rollback);
        self.$Message.error('修改失败');
      });
    },
    rollbackSummativeSave: function rollbackSummativeSave(rollback) {
      if (!rollback) {
        return;
      }
      if (rollback.prevEnabled !== undefined) {
        this.summativeEnabled = rollback.prevEnabled;
      }
      if (rollback.prevBlueprintId !== undefined) {
        this.summativeBlueprintId = rollback.prevBlueprintId;
      }
    },
    formatRecordTime: function formatRecordTime(time) {
      var sTime = time;
      var mTime = 0;
      var hTime = 0;
      if (sTime > 60) {
        mTime = parseInt(sTime / 60);
        sTime = parseInt(sTime % 60);
        if (mTime > 60) {
          hTime = parseInt(mTime / 60);
          mTime = parseInt(mTime % 60);
        }
      }
      if (hTime === 0) {
        if (mTime === 0) {
          return sTime + '秒';
        }
        return mTime + '分' + sTime + '秒';
      }
      if (mTime === 0) {
        return sTime + '秒';
      }
      return hTime + '小时' + mTime + '分' + sTime + '秒';
    },
    showModel: function showModel(type, data) {
      if (type == 'version') {
        this.fundPackageId = data.id;
        this.showVersionModel = true;
      } else {
        this.fundPackageId = data.id;
        this.showContractStatusModel = true;
      }
    },
    saveVersion: function saveVersion() {
      var _this5 = this;

      var self = this;
      self.$http.post('/fundPackage/upateVersion', { id: this.fundPackageId, version: this.needversion }).then(function (res) {
        if (res) {
          self.$Message.success('处理成功!');
          _this5.reload_fundPackage = new Date().getTime();
        }
        _this5.showVersionModel = false;
      });
    },
    saveContractStatus: function saveContractStatus() {
      var _this6 = this;

      var self = this;
      self.$http.post('/fundPackage/upateContractStatus', {
        id: this.fundPackageId,
        contractStatus: this.needContractStatus
      }).then(function (res) {
        if (res) {
          self.$Message.success('处理成功!');
          _this6.reload_fundPackage = new Date().getTime();
        }
        _this6.showContractStatusModel = false;
      });
    },
    openUserClassHourModal: function openUserClassHourModal() {
      this.showUserClassHourModal = true;
    },
    onUserAbsent: function onUserAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/userAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onTchAbsent: function onTchAbsent(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/tchAbsent', { id: row.id }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    closeRecordScreen: function closeRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 0 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    formateCountber: function formateCountber(Count) {
      Count = Count + '';
      var index = Count.indexOf('.');
      if (index > 0) {
        Count = Count.substring(0, index + 3);
      }
      return Count;
    },
    getWodetail: function getWodetail(id) {
      var self = this;
      self.$http.post('/sale/wo/detail?studentId=' + id).then(function (res) {
        var data = res.data;
        if (data) {
          self.showWo = true;
          self.woFormData.saleWo = data.saleWo;
          self.woFormData.saleWo.woStatus = self.$constant.getEnum(self.$constant.woStatus, data.saleWo.status);
          self.woFormData.saleWo.orderChannel = self.$constant.getEnum(self.$constant.orderChannel, data.saleWo.fundChannel);
          self.woFormData.follows = data.follows;
          var status = self.woFormData.saleWo.status;
          self.woVersion = data.saleWo.version + '';
          self.woReadonly = status !== 'UN_SUBMITTED' && status !== 'REJECTED';
          self.woDisable = status !== 'UN_SUBMITTED' && status !== 'REJECTED';

          self.disableTimeList = data.saleWo.disableTimeList;
          if (self.disableTimeList && self.disableTimeList !== '') {
            self.disableTimeList.forEach(function (item) {
              item.disableWeek = item.week;
              item.disableWeekStr = self.$constant.weekZh[item.week];
              item.disableStartTime = self.$dateUtil.getSecondByHm(item.startTime);
              item.disableStartTimeStr = item.startTime;
              item.disableEndTime = self.$dateUtil.getSecondByHm(item.endTime);
              item.disableEndTimeStr = item.endTime;
            });
          } else {
            self.disableTimeList = [];
          }
        }
        self.woChecked = true;
      }).catch(function () {
        self.woChecked = true;
      });
    },
    submitWoData: function submitWoData() {
      var _this7 = this;

      var self = this;
      self.woSubmitLoading = true;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>提交</b>工单？',
        width: 300,
        loading: true,
        onCancel: function onCancel() {
          self.woSubmitLoading = false;
        },
        onOk: function onOk() {
          self.$Modal.remove();
          self.$refs.woFormData.validate(function (valid) {
            if (!valid) {
              self.$Message.warning('信息输入错误!');
              self.woSubmitLoading = false;
              return;
            }
            var data = _this7.woFormData.saleWo;
            var params = {};
            params.studentId = data.studentId;
            params.payAmount = data.payAmount;
            params.adviserName = data.adviserName;
            params.studyAdviserName = data.studyAdviserName;
            params.teacherName = data.teacherName;
            params.woStatus = data.woStatus;
            params.remark = data.remark;
            params.classOpeningTime = __WEBPACK_IMPORTED_MODULE_29__tools_date_format_js___default()(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss');
            if (self.woVersion && self.woVersion !== 'undefined') {
              params.version = self.woVersion;
            }
            if (self.disableTimeList) {
              params.disableTimeList = self.disableTimeList;
            }
            self.$http.post('/sale/wo/submit', {}, {
              transformRequest: [function (data, headers) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params);
              }],
              headers: { 'Content-Type': 'application/json;charset=utf-8' }
            }).then(function (res) {
              if (!res) {
                self.$Message.error('处理失败!');
              } else if (res.data > 0) {
                self.search();
                self.$Message.success('处理成功!');
                self.getWodetail(self.queryParam.uid);
              }
              self.woSubmitLoading = false;
              self.$Modal.remove();
            });
          });
        }
      });
    },
    saveWoData: function saveWoData() {
      var _this8 = this;

      var self = this;
      self.woSubmitLoading = true;
      self.$refs.woFormData.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.woSubmitLoading = false;
          return;
        }

        var data = _this8.woFormData.saleWo;
        var params = {};
        params.studentId = data.studentId;
        params.payAmount = data.payAmount;
        params.adviserName = data.adviserName;
        params.studyAdviserName = data.studyAdviserName;
        params.teacherName = data.teacherName;
        params.woStatus = data.woStatus;
        params.remark = data.remark;
        params.classOpeningTime = __WEBPACK_IMPORTED_MODULE_29__tools_date_format_js___default()(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss');
        if (self.woVersion && self.woVersion !== 'undefined') {
          params.version = self.woVersion;
        }
        if (self.disableTimeList) {
          params.disableTimeList = self.disableTimeList;
        }
        self.$http.post('/sale/wo/save', {}, {
          transformRequest: [function (data, headers) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params);
          }],
          headers: { 'Content-Type': 'application/json;charset=utf-8' }
        }).then(function (res) {
          if (!res) {
            self.$Message.error('操作失败!');
          } else if (res.data > 0) {
            self.search();
            self.$Message.success('保存成功!');
          }
          self.woSubmitLoading = false;
        });
      });
    },
    rollbackWoData: function rollbackWoData() {
      var _this9 = this;

      var self = this;
      self.woSubmitLoading = true;
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>撤回</b>工单？',
        width: 300,
        loading: true,
        onCancel: function onCancel() {
          self.woSubmitLoading = false;
        },
        onOk: function onOk() {
          self.$Modal.remove();
          self.$refs.woFormData.validate(function (valid) {
            if (!valid) {
              self.$Message.warning('信息输入错误!');
              self.woSubmitLoading = false;
              return;
            }
            var data = _this9.woFormData.saleWo;
            data.classOpeningTime = __WEBPACK_IMPORTED_MODULE_29__tools_date_format_js___default()(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss');
            self.$http.post('/sale/wo/rollback', data).then(function (res) {
              if (res) {
                self.search();
                self.$Message.success('撤回成功!');
                self.getWodetail(self.queryParam.uid);
              }
              self.$Modal.remove();
              self.woSubmitLoading = false;
            });
          });
        }
      });
    },
    openRecordScreen: function openRecordScreen(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          self.$http.post('/bookLesson/updateRecordScreen', { openedId: row.id, isRecordScreen: 1 }).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('处理成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    closeModal: function closeModal(val) {
      this.editUser = false;
      this.UserOneLeaveModal = val;
    },
    searchWithPage: function searchWithPage() {
      this.reloadWithPage = new Date().getTime();
    },
    onReloadClassIn: function onReloadClassIn(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/user/lesson/reloadClassIn', { openedId: row.id }).then(function (res) {
            if (res) {
              self.searchWithPage();
              self.$Message.success('生成成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    viewRecordScreen: function viewRecordScreen(row) {
      this.$http.get('/bookLesson/getRecordScreenUrl?openedId=' + row.id).then(function (res) {
        window.open(res.data);
      });
    },
    openNewLessonModal: function openNewLessonModal(k, v) {
      if (this.$appConfig.active === 'prod') {
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      } else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v);
      }
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.lessonParams.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.lessonParams.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    startCreateTimeChange: function startCreateTimeChange(value) {
      this.lessonParams.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endCreateTimeChange: function endCreateTimeChange(value) {
      this.lessonParams.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onBookUserFeedBackClose: function onBookUserFeedBackClose() {
      this.showBookUserFeedbackModal = false;
    },
    onBookTchScoreFeedBackClose: function onBookTchScoreFeedBackClose() {
      this.showBookTchScoreFeedbackModal = false;
    },
    onBookTchFeedBackClose: function onBookTchFeedBackClose() {
      this.showBookTchFeedbackModal = false;
    },
    onClassMemberClose: function onClassMemberClose(val) {
      this.showClassMemberTimeModal = false;
    },
    onPreview: function onPreview(row) {
      var self = this;
      if (row.tchChannel === 1) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://hellokid.speakstreet.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid);
        } else {
          window.open('https://test-student.kouyujie.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid);
        }
      } else if (row.tchChannel === 2) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id);
        } else {
          window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id);
        }
      }
    },
    goBack: function goBack() {
      this.$router.push({ path: this.backPath, query: { param: this.parm } });
    },
    onEvaluationSheetModalClose: function onEvaluationSheetModalClose() {
      this.showEvaluationSheetModal = false;
      this.reprotId = null;
    },
    changeDate: function changeDate(value) {
      this.followFormData.nextDate = value;
    },
    onSelectedProvince: function onSelectedProvince(data) {
      if (data.value) {
        this.formData.province = data.value;
      }
    },
    onSelectedCity: function onSelectedCity(data) {
      if (data.value) {
        this.formData.city = data.value;
      }
    },
    onSelectedArea: function onSelectedArea(data) {
      if (data.value) {
        this.formData.block = data.value;
      }
    },
    cancelRecommend: function cancelRecommend(id) {
      var self = this;
      this.$http.post('/tchRecommend/cancelRecommend', { id: id }).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('取消成功!');
          self.searTchRecommend();
        }
      });
    },
    onTabClick: function onTabClick(name) {
      if (name === 'three') {
        this.searTchRecommend();
      }
      if (name === 'six') {
        this.searFundPackageList();
      }
      if (name === 'seven') {
        this.searCourseTypeList();
      }

      if (name === 'nine') {
        this.searClassHourList();
      }
      this.currentTab = name;
    },
    searCourseTypeList: function searCourseTypeList() {
      var self = this;
      this.$http.get('/userList/courseTypeList?uid=' + this.uid).then(function (res) {
        if (res.data) {
          self.courseTypeData = res.data;
        }
      });
      this.searchWithPage();
    },
    searClassHourList: function searClassHourList() {
      var self = this;
      this.$http.get('/class-hour/list?queryAll=true&uid=' + this.uid).then(function (res) {
        if (res.data) {
          self.classHourListData = res.data;
        }
      });
      this.searchWithPage();
    },
    searFundPackageList: function searFundPackageList() {
      var self = this;
      this.$http.get('/fundPackage/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.fundPackageData = res;
        }
      });
    },
    searTchRecommend: function searTchRecommend() {
      var self = this;
      this.$http.get('/tchRecommend/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.recommendData = res;
          self.loadMonthRankScoresFor(self.recommendData && self.recommendData.data ? self.recommendData.data : self.recommendData, 'tchId');
        }
      });
    },
    closeRecommendEdit: function closeRecommendEdit() {
      this.searTchRecommend();
      this.recommendEdit = false;
    },
    openRecommendEdit: function openRecommendEdit() {
      this.recommendEdit = true;
    },
    deleteContact: function deleteContact(val) {
      var contact = this.formData.userContacts;
      var newContact = [];
      for (var i in contact) {
        if (i !== val + '') {
          newContact.push(contact[i]);
        }
      }
      this.formData.userContacts = newContact;
    },
    addContact: function addContact() {
      if (this.formData.userContacts.length >= 3) {
        this.$Message.warning('已到添加号码上限!');
        return;
      }
      var contact = {};
      this.formData.userContacts.push(contact);
    },
    openStudentPage: function openStudentPage() {
      var self = this;
      this.$http.get('/adminUser/getAdminToken?type=student').then(function (res) {
        if (res.data) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/adminUserLogin?uid=' + self.formData.uid + '&token=' + res.data);
          } else {
            window.open('https://test-student.kouyujie.cn/adminUserLogin?uid=' + self.formData.uid + '&token=' + res.data);
          }
        }
      });
      return;
    },
    lookRerot: function lookRerot(id) {
      if (id) {
        this.reprotId = id;
        this.showEvaluationSheetModal = true;
      }
    },
    editReport: function editReport(id, status) {
      var self = this;
      if (id) {
        var path = '/stageReport/update?id=' + id + '&status=' + status;
        self.$http.post(path, this.formData).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!');
            self.reportList();
          }
        });
      }
    },
    reportList: function reportList() {
      var self = this;
      self.$http.get('/stageReport/list?uid=' + self.followFormData.id).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data;
          self.loadMonthRankScoresFor(self.stageReportData, 'tchId');
        }
      });
    },
    insertReport: function insertReport() {
      this.StageReportModal = true;
    },
    play: function play(url) {
      window.open(url);
    },
    search: function search() {
      var self = this;
      self.$http.get('/call_record/pageList?uid=' + self.queryParam.uid).then(function (res) {
        if (res.data.data) {
          self.callRecordData = res.data.data;
        }
      });
    },
    onLoading: function onLoading(loading) {
      this.insertLoading = loading;
    },
    onLessonLoading: function onLessonLoading(loading) {
      this.searchLoading = loading;

      if (!loading) {
        var bookList = this.$refs.bookLessonList && this.$refs.bookLessonList.tableData;
        this.loadMonthRankScoresFor(bookList, 'tchId');
      }
    },
    changeFollow: function changeFollow(val) {
      var self = this;
      if (!val) {
        return;
      }
      self.followFormData.traceItem = '';
      if (val === '100') {
        self.followList = [{ id: 100, text: '注册备注' }];
        self.followFormData.traceItem = 100;
      }
      if (val === '1') {
        self.followList = [{ id: 1, text: '课后-同意购买' }, { id: 2, text: '课后-付款成功，持续跟进' }];
      }
      if (val === '2') {
        self.followList = [{ id: 3, text: '课后-讲解产品，学习方案' }];
      }
      if (val === '3') {
        self.followList = [{ id: 4, text: '课后-开场' }, { id: 5, text: '课前跟进，确认出席' }, {
          id: 6,
          text: '课前跟进，改期'
        }, { id: 7, text: '课前约课' }];
      }
      if (val === '4') {
        self.followList = [{ id: 8, text: '价格问题' }, { id: 9, text: '行业对比' }, { id: 10, text: '不信任' }, {
          id: 11,
          text: '级别年龄不符'
        }];
      }
      if (val === '5') {
        self.followList = [{ id: 12, text: '无人接听' }, { id: 13, text: '挂断' }, { id: 14, text: '关机/停机' }, {
          id: 15,
          text: '空号'
        }];
      }
    },
    addFollow: function addFollow() {
      var self = this;
      self.$refs.followForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.followFormData.id) {
          if (self.followFormData.traceStatus == 100 || self.followFormData.traceStatus == '100') {
            self.$http.post('/userTrack/insert', {
              uid: self.followFormData.id,
              content: self.followFormData.content,
              files: self.followFormData.files || '',
              traceType: 100
            }).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('保存成功!');
                self.followFormData.traceStatus = '';
                self.followFormData.traceItem = '';
                self.followFormData.content = '';
                self.followFormData.nextDate = '';
                self.followFormData.files = '';
                self.nextDate = '';
                self.askForTch = false;
                self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                  if (res && res.data) {
                    self.followData = res.data.list || [];
                  }
                });
              }
            });
            return;
          }
          var requireNum = [];
          requireNum.push.apply(requireNum, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.followFormData.stuDescCheckGroup));
          requireNum.push.apply(requireNum, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.followFormData.askForTchCheckGroup));
          self.$http.post('/saleTrace/insert', {
            uid: self.followFormData.id,
            traceStatus: self.followFormData.traceStatus,
            traceItem: self.followFormData.traceItem,
            content: self.followFormData.content,
            nextDate: self.followFormData.nextDate,
            requireNum: requireNum.toString()
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('保存成功!');
              self.followFormData.traceStatus = '';
              self.followFormData.traceItem = '';
              self.followFormData.content = '';
              self.followFormData.nextDate = '';
              self.nextDate = '';
              self.askForTch = false;
              self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                if (res && res.data) {
                  self.followData = res.data.list || [];
                }
              });
            }
          });
        }
      });
    },
    resetRequireNum: function resetRequireNum() {
      this.nextDate = '';
      this.followFormData.askForTchCheckGroup = [];
      this.followFormData.stuDescCheckGroup = [];
      this.askForTch = false;
    },
    calcAgeFromBirthday: function calcAgeFromBirthday() {
      if (!this.formData.birthday) return;
      var now = new Date();
      var birthday = new Date(this.formData.birthday);
      var age = now.getFullYear() - birthday.getFullYear();
      var m = now.getMonth() - birthday.getMonth();
      if (m < 0 || m === 0 && now.getDate() < birthday.getDate()) {
        age--;
      }
      if (age >= 0) {
        this.formData.age = age;
      }
    },
    calcBirthdayFromAge: function calcBirthdayFromAge() {
      if (!this.formData.age || parseInt(this.formData.age) <= 0) return;
      var now = new Date();
      var year = now.getFullYear() - parseInt(this.formData.age);
      var birthday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      birthday.setFullYear(year);
      this.formData.birthday = birthday.getTime();
    },
    toSubmitFormData: function toSubmitFormData() {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.formData));
      if (data.birthday) {
        data.birthday = data.birthday / 1000;
      }
      return data;
    },
    addStudent: function addStudent() {
      var _this10 = this;

      var self = this;
      self.insertLoading = true;
      var res = self.valiDateParam();
      if (!res) {
        this.$Message.warning('参数输入错误!');
        if (self.paramsErrors.length > 0) {
          for (var i in self.paramsErrors) {
            this.$Message.warning(self.paramsErrors[i]);
          }
          self.paramsErrors = [];
        }
        self.insertLoading = false;
        return;
      }
      if (!self.formData.uid) {
        self.$http.get('/user/queryByMobile?mobile=' + self.formData.mobile).then(function (res) {
          if (res.data) {
            this.$Message.warning('学员手机号已经存在!');
          }
        });
        self.$http.post('/userinfo/insertUserInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.toSubmitFormData())).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('新增成功!');
            self.successCallback();
          }
          self.insertLoading = false;
        }).catch(function (e) {
          self.visible = false;
          self.insertLoading = false;
        });
      } else {
        if (self.formData.smsCode !== '' || self.formData.smsCode != null) self.formData.smsCode = '';
        if (!self.formData.oldMobile.startsWith('n') && this.formData.oldMobile !== self.formData.mobile) {
          self.$Modal.confirm({
            title: '⚠警告',
            width: 300,
            loading: true,
            okText: '修改',
            render: function render(h, params) {
              return h('div', [h('b', { style: { color: 'red' } }, '系统检测到您正常修改学生的手机号，这可能会影响用户上课，我们需要对修改后的手机号进行验证码验证，以确保是正式学员家长的诉求'), h('Input', {
                attrs: { maxlength: 6 },
                on: {
                  input: function input(e) {
                    self.formData.smsCode = e;
                  }
                }
              }), h('Button', {
                attrs: { disabled: self.disabled },
                on: {
                  click: function click() {
                    self.$http.get('/userinfo/sendUpdateMobileSmsCode', { params: { uid: self.formData.uid }, key: 'update_mobile_sms' }).then(function (res) {
                      if (res.status === 'ok') {
                        self.$Message.success('验证码发送成功!');
                        self.disabled = true;
                        self.timer = setInterval(function () {
                          if (self.time <= 0) {
                            self.time = 60;
                            clearInterval(_this10.timer);
                            self.disabled = false;
                          } else {
                            self.time -= 1;
                          }
                        }, 1000);
                      }
                    });
                  }
                }
              }, self.disabled ? self.time : '发送验证码')]);
            },
            onOk: function onOk() {
              self.$Modal.remove();
              if (self.currentTab === 'one') {
                self.formData.classRequirement = '';
                if (self.followData) self.followData.classRequirementTags = [];
              } else if (self.currentTab === 'classRequirement') {
                var uid = self.formData.uid;
                var classRequirement = self.formData.classRequirement;
                var classRequirementTags = self.formData.classRequirementTags;
                self.formData = {};
                self.formData.uid = uid;
                self.formData.classRequirement = classRequirement;
                self.formData.classRequirementTags = classRequirementTags;
              }
              self.$http.post('/userinfo/updateUserInfo', {}, {
                transformRequest: [function (data, headers) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.toSubmitFormData());
                }],
                headers: { 'Content-Type': 'application/json;charset=utf-8' }
              }).then(function (res) {
                self.insertLoading = false;
                if (res) {
                  self.$Message.success('修改成功!');
                  self.visible = false;
                  return;
                }
              }).catch(function (e) {
                self.insertLoading = false;
              });
            },
            onCancel: function onCancel() {
              self.time = 60;
              clearInterval(_this10.timer);
              self.insertLoading = false;
              self.disabled = false;
              return false;
            }
          });
        } else {
          if (self.formData.mobile === '') {
            self.formData.mobile = self.formData.oldMobile;
          }
          var req = {};
          if (self.currentTab === 'classRequirement') {
            req.uid = self.formData.uid;
            req.classRequirement = self.formData.classRequirement;
            req.classRequirementTags = self.formData.classRequirementTags;
          } else {
            self.formData.classRequirement = '';
            self.formData.classRequirementTags = [];
            req = self.toSubmitFormData();
          }
          self.$http.post('/userinfo/updateUserInfo', {}, {
            transformRequest: [function (data, headers) {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(req);
            }],
            headers: { 'Content-Type': 'application/json;charset=utf-8' }
          }).then(function (res) {
            self.insertLoading = false;
            if (res) {
              self.$Message.success('修改成功!');
              self.visible = false;
              if (self.formData.mobile.startsWith('n')) {
                self.formData.mobile = '';
              }
              return;
            }
          }).catch(function (e) {
            self.insertLoading = false;
          });
        }
      }
    },
    valiDateParam: function valiDateParam() {
      var self = this;
      var isPass = false;
      self.$refs.userInfoForm.validate(function (valid) {
        var res = self.valiDateMobile();
        if (valid && res) {
          isPass = true;
        }
      });
      return isPass;
    },
    closeReviewModal: function closeReviewModal(val) {
      this.studentWriteReviewRegularModal = false;
      this.studentWriteReviewDemoModal = false;
      this.studentWriteReviewDemoV2Modal = false;
      this.studentWriteReviewFinishLevelModal = false;
      this.studentWriteReviewFinishLevelV2Modal = false;
      this.studentWriteReviewRegularV2Modal = false;
    },
    valiDateMobile: function valiDateMobile() {
      var isPass = false;
      var self = this;
      var pattern = /^[0-9]+$/;
      if (self.formData.userContacts && self.formData.userContacts.length > 0) {
        for (var i in self.formData.userContacts) {
          var param = self.formData.userContacts[i];
          if (!param.name) {
            self.paramsErrors.push('联系人名字不能为空!');
          } else if (!param.mobile) {
            self.paramsErrors.push('联系人号码不能为空!');
          } else if (!pattern.test(param.mobile)) {
            self.paramsErrors.push('手机号只能输入数字!');
          } else {
            isPass = true;
          }
        }
      }
      if (self.paramsErrors && self.paramsErrors.length > 0) {
        isPass = false;
      } else {
        isPass = true;
      }
      return isPass;
    },
    dialTel: function dialTel() {
      if (!this.formData.mobile) {
        this.$Message.warning('无效手机号码');
        return;
      }
      this.dialLoading = true;
      var self = this;
      this.$http.get('/moor/call?callNo=' + this.formData.mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!');
          self.dialLoading = false;
        }
      });
    },
    handleResult: function handleResult(file) {
      this.formData.imageUrl = file.name;
      this.totalImageUrl = file.url;
    },
    openTrackContent: function openTrackContent(item) {
      this.$refs.trackContentModal && this.$refs.trackContentModal.open(item);
    },
    handleAiMarkdown: function handleAiMarkdown() {
      var self = this;
      var content = (self.formValidate.content || '').trim();
      if (!content) {
        self.$Message.warning('请先填写内容');
        return;
      }
      self.aiLoading = true;
      self.$http.post('/userTrack/aiMarkdown', { content: content }).then(function (res) {
        self.aiLoading = false;
        if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
          return;
        }
        var markdown = res.data.markdown;
        self.$Modal.confirm({
          title: '确认覆盖',
          content: '将用 AI 结果覆盖当前内容，是否继续？',
          onOk: function onOk() {
            if (!(self.formValidate.contentRaw || '').trim()) {
              self.formValidate.contentRaw = content;
            }
            self.formValidate.content = markdown;
            self.$Message.success('已用 AI 结果更新内容');
          }
        });
      }).catch(function () {
        self.aiLoading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
          if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
            self.$Message.warning('请填写下次联系人和下次联系日期!');
            return;
          }
        }
        self.$http.post('/userTrack/insert', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            self.formValidate.content = '';
            self.formValidate.contentRaw = '';
            self.formValidate.nextHandlerId = null;
            self.formValidate.nextHandlerTime = '';
            self.formValidate.traceType = '';
            self.formValidate.nextTimeDate = '';
            self.getPersonTrace(self.formValidate.uid);
          }
        });
      });
    },
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
    },
    getPersonTrace: function getPersonTrace(uid) {
      var self = this;
      var params = self.traceParam;
      if (uid) {
        self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize).then(function (res) {
          if (!res.data || !res.data.data) {
            self.traceParam.totalCount = 0;
            self.tableData = [];
            return;
          }
          self.traceParam.uid = res.data.data[0].uid;
          self.traceParam.nickName = res.data.data[0].nickname;
          self.traceParam.totalCount = res.data.totalCount;
          self.tableData = res.data.data;
        });
      }
    },
    changePageIndex: function changePageIndex(page) {
      this.traceParam.pageIndex = page;
      this.getPersonTrace(this.traceParam.uid);
    },
    splitFixedRequire: function splitFixedRequire(text) {
      if (!text) {
        return [];
      }
      return text.split(/\r?\n/).map(function (line) {
        return line.trim();
      }).filter(function (line) {
        return line.length > 0;
      });
    },
    loadFixedClassRequire: function loadFixedClassRequire() {
      var self = this;
      var uid = self.uid || self.formData.uid;
      if (!uid) {
        return;
      }
      self.$http.get('/stageReport/fixed-class-require?uid=' + uid).then(function (res) {
        if (res && res.status === 'ok') {
          var data = res.data || {};
          self.fixedClassRequire = data.fixedContent || '';
          self.fixedClassRequireEn = data.fixedContentEn || '';
        }
      }).catch(function () {});
    },
    saveFixedClassRequire: function saveFixedClassRequire() {
      var self = this;
      var uid = self.uid || self.formData.uid;
      if (!uid) {
        return;
      }
      self.fixedClassRequireSaving = true;
      self.$http.post('/stageReport/fixed-class-require-save', {
        uid: uid,
        fixedContent: self.fixedClassRequire
      }).then(function (res) {
        self.fixedClassRequireSaving = false;
        if (res && res.status === 'ok') {
          var data = res.data || {};
          self.fixedClassRequire = data.fixedContent || '';
          self.fixedClassRequireEn = data.fixedContentEn || '';
          self.$Message.success('保存成功');
        }
      }).catch(function () {
        self.fixedClassRequireSaving = false;
      });
    },
    init: function init() {
      var self = this;
      var query = self.$route.query;
      if (query) {
        if (query.startTimeDate) {
          self.lessonParams.startTimeDate = parseInt(query.startTime) * 1000;
        }
        if (query.endTimeDate) {
          self.lessonParams.endTimeDate = parseInt(query.endTime) * 1000;
        }
        if (query.startCreateDate) {
          self.lessonParams.startCreateDate = parseInt(query.startCreateTime) * 1000;
        }
        if (query.endCreateDate) {
          self.lessonParams.endCreateDate = parseInt(query.endCreateTime) * 1000;
        }
        if (query.tchId) {
          self.lessonParams.tchId = parseInt(query.tchId);
        }
        if (query.tchName) {
          self.lessonParams.tchName = query.tchName;
        }
        if (query.materialVersionId) {
          self.lessonParams.materialVersionId = parseInt(query.materialVersionId);
        }
        if (query.isStudyAdviser) {
          self.lessonParams.isStudyAdviser = query.isStudyAdviser;
        }
        if (query.userNickname) {
          self.lessonParams.userNickname = query.userNickname;
        }
        if (query.adviserNickname) {
          self.lessonParams.adviserNickname = query.adviserNickname;
        }
        if (query.studyAdviserNickname) {
          self.lessonParams.studyAdviserNickname = query.studyAdviserNickname;
        }
        if (query.tchCategory) {
          self.lessonParams.tchCategory = parseInt(query.tchCategory);
        }
        if (query.lsnSelStatus) {
          self.lessonParams.lsnSelStatus = parseInt(query.lsnSelStatus);
        }
        if (query.lsnType) {
          self.lessonParams.lsnType = parseInt(query.lsnType);
        }
        if (query.courseType) {
          self.lessonParams.courseType = parseInt(query.courseType);
        }
        if (query.adviserId) {
          self.lessonParams.adviserId = parseInt(query.adviserId);
        }
        if (query.creatorName) {
          self.lessonParams.creatorName = query.creatorName;
        }
      }
    },
    cancelAllClass: function cancelAllClass() {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 取消全部排课？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.get('/bookLesson/cancelAllClass?uid=' + self.queryParam.uid).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('取消成功!');
              self.searchWithPage();
            }
            self.$Modal.remove();
          });
        }
      });
    },
    onChangeDisableStartTime: function onChangeDisableStartTime(val) {
      this.disableTimeParams.disableStartTimeStr = val;
      this.disableTimeParams.disableStartTime = this.$dateUtil.getSecondByHm(val);
    },
    onChangeDisableEndTime: function onChangeDisableEndTime(val) {
      this.disableTimeParams.disableEndTimeStr = val;
      this.disableTimeParams.disableEndTime = this.$dateUtil.getSecondByHm(val);
    },
    addDisableTime: function addDisableTime() {
      var self = this;
      var isPass = true;

      var disableTimeList = self.disableTimeList;
      var week = self.disableTimeParams.disableWeek;
      var startTime = self.disableTimeParams.disableStartTime;
      var endTime = self.disableTimeParams.disableEndTime;

      if (!week || week === '') {
        self.$Message.error('不可用星期选项不能为空');
        isPass = false;
      }

      if (isPass) {
        if (!startTime) {
          self.disableTimeParams.disableStartTimeStr = '00:00';
          startTime = this.$dateUtil.getSecondByHm('00:00');
          self.disableTimeParams.disableStartTime = startTime;
        }
        if (!endTime) {
          self.disableTimeParams.disableEndTimeStr = '23:59';
          endTime = this.$dateUtil.getSecondByHm('23:59');
          self.disableTimeParams.disableEndTime = endTime;
        }
      }

      if (isPass && startTime && endTime) {
        if (startTime > endTime) {
          self.$Message.error('开始时间 ' + self.disableTimeParams.disableStartTimeStr + '必须小于' + self.disableTimeParams.disableEndTimeStr);
          isPass = false;
        } else if (startTime === endTime) {
          self.$Message.error('开始时间 ' + self.disableTimeParams.disableStartTimeStr + '不能与结束时间' + self.disableTimeParams.disableEndTimeStr + '相等');
          isPass = false;
        }
      }

      if (isPass && disableTimeList && disableTimeList.length > 0) {
        disableTimeList.forEach(function (item) {
          var tmpWeek = item.disableWeek;
          var tmpStartTime = item.disableStartTime;
          var tmpEndTime = item.disableEndTime;
          if (week === tmpWeek) {
            if (tmpStartTime < startTime && tmpEndTime > startTime || tmpStartTime < endTime && tmpEndTime > endTime || tmpStartTime >= startTime && tmpEndTime <= endTime) {
              self.$Message.error('添加的时间与 ' + item.disableWeekStr + ' ' + item.disableStartTimeStr + '--' + item.disableEndTimeStr + ' 冲突');
              isPass = false;
            }
          }
        });
      }

      if (isPass) {
        var disableTime = {};
        disableTime.disableWeek = self.disableTimeParams.disableWeek;
        disableTime.disableWeekStr = self.$constant.weekZh[self.disableTimeParams.disableWeek];
        disableTime.disableStartTime = self.disableTimeParams.disableStartTime;
        disableTime.disableStartTimeStr = self.disableTimeParams.disableStartTimeStr;
        disableTime.disableEndTime = self.disableTimeParams.disableEndTime;
        disableTime.disableEndTimeStr = self.disableTimeParams.disableEndTimeStr;
        self.disableTimeList.push(disableTime);
      }
    },
    removeDisableTime: function removeDisableTime(index) {
      this.disableTimeList.splice(index, 1);
    },
    clickWoVersion: function clickWoVersion(val) {
      if (val) {
        this.woVersion = '1';
      } else {
        this.woVersion = '0';
        this.disableTimeList = [];
      }
    },
    viewPic: function viewPic(row) {
      this.showImgList = row.nickname ? row.nickname.split(',').map(function (item) {
        if (!item.startsWith('http')) {
          return 'https://imgs.speakstreet.cn/' + item;
        }
        return item;
      }) : [];
      this.showImgModal = true;
    },
    closeImgModal: function closeImgModal() {
      this.showImgList = [];
      this.showImgModal = false;
    },

    generalRequirements: ['活跃一些', '多微笑，不要太严肃', '纠音', '纠正错误表达', '引导多开口', '多些互动', '引导整句输出', '多鼓励孩子', '多给些奖励'],
    lowLevelRequirements: ['语速慢一点', '多些TPR', '多些道具', '课前互动简单一些最多3个问题', '学生零基础，不要拓展', '减少拓展'],
    highLevelRequirements: ['内容拓展']
  },
  watch: {
    cityInfo: function cityInfo(val) {
      if (val) {
        this.formData.province = val.province.name;
        this.formData.city = val.city.name;
        this.formData.block = val.block.name;
      }
    }
  },

  created: function created() {
    var uid = parseInt(this.$route.query.uid);

    var validTabs = ['one', 'two', 'tree', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    var tabName = this.$route.query.tabName;
    if (tabName !== undefined && tabName !== null && tabName !== '') {
      if (typeof tabName === 'string') {
        this.tabName = tabName;
      } else {
        this.tabName = String(tabName);
      }
      if (!validTabs.includes(this.tabName)) {
        this.tabName = 'one';
      }
    }
    this.currentTab = this.tabName;
    this.parm = this.$route.query.parm;
    this.backPath = this.$route.query.backPath;
    var self = this;
    if (uid) {
      this.uid = uid;
      self.formData.uid = uid;
      self.loadFixedClassRequire();
      self.getWodetail(uid);
      self.$http.get('/saleTrace/followUp?id=' + uid).then(function (res) {
        if (res.data) {
          self.followFormData.id = res.data.id;
          self.followFormData.adviserName = res.data.adviserName;
          self.followFormData.nickname = res.data.nickname;
          self.followFormData.studyAdviserName = res.data.studyAdviserName;
          var requireNum = res.data.requireNum;
          if (requireNum) {
            var require = requireNum.split(',');
            for (var i in require) {
              var j = parseInt(require[i]);
              var len = self.$constant.stuDesc.length + 1;
              if (j < len) {
                self.followFormData.stuDescCheckGroup.push(j);
              } else {
                self.followFormData.askForTchCheckGroup.push(j);
              }
            }
          }
          self.formValidate.uid = uid;
          self.formValidate.nickname = res.data.nickname;
          self.formValidate.adviserName = res.data.adviserName;
          self.formValidate.studyAdviserName = res.data.studyAdviserName;
          self.followFormData.tchNames = res.data.tchNames;
          self.followData = res.data.list || [];
        }
      });
      this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
        self.nextHandler = res.data;
      });
      self.getPersonTrace(uid);
      self.$http.get('/stageReport/list?uid=' + uid).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data;
        }
      });
      self.$http.get('/userinfo/appVersion/list?uid=' + uid).then(function (res) {
        self.appVersionData = res.data || {};
      });
      self.$http.get('/mex/blueprints/list', {
        params: { examType: 'SUMMATIVE', status: 'ONLINE', pageIndex: 1, pageSize: 200 }
      }).then(function (res) {
        var rows = [];
        if (res.status === 'ok' && res.data && res.data.data) {
          rows = res.data.data;
        }
        self.summativeBlueprints = rows;
      });

      self.harvardForeignLoaded = false;
      self.$http.get('/user/harvardForeignAuth/get', { params: { uid: uid } }).then(function (res) {
        if (res && res.data) {
          self.harvardForeignEnabled = res.data.enabled === 1;
        } else {
          self.harvardForeignEnabled = false;
        }
        self.harvardForeignLoaded = true;
      }).catch(function () {
        self.harvardForeignEnabled = false;
        self.harvardForeignLoaded = true;
      });

      self.$http.get('/mex/student-summative/get', { params: { uid: uid } }).then(function (res) {
        if (res.status === 'ok' && res.data) {
          self.summativeEnabled = res.data.enabled === 1;
          self.summativeBlueprintId = res.data.blueprintId || null;
        }
        self.$nextTick(function () {
          self.summativeLoaded = true;
        });
      }).catch(function () {
        self.summativeLoaded = true;
      });
      self.$http.get('/userinfo/getUserInfo?uid=' + uid).then(function (res) {
        if (res.data) {
          self.formData.oldMobile = res.data.mobile;
          var data = res.data;
          self.formData.channelParam = data.channelParam;
          self.formData.enName = data.enName;
          self.formData.enabledRule = data.enabledRule;
          self.formData.stars = data.stars;
          self.formData.tchIdCopy = data.tchIdCopy;
          self.formData.cnName = data.cnName;
          self.formData.vipDesc = data.vipDesc;
          self.formData.sex = data.sex;
          self.formData.regType = data.regType;
          self.formData.payCanal = data.payCanal;
          if (data.mobile.startsWith('n')) {
            self.formData.mobile = '';
          } else {
            self.formData.mobile = data.mobile;
          }
          self.formData.remarkMobile = data.remarkMobile;
          self.formData.phoneName = data.phoneName;
          self.formData.wechatAccount = data.wechatAccount;
          self.formData.phoneRole = data.phoneRole;
          self.formData.infoRemark = data.infoRemark;
          self.formData.address = data.address;
          self.formData.learnEnglishTime = data.learnEnglishTime;
          self.formData.haveContactForeignTeacher = data.haveContactForeignTeacher;
          self.formData.familyEconomicSituation = data.familyEconomicSituation;
          self.formData.attentionEnglish = data.attentionEnglish;
          self.formData.province = data.province;
          self.formData.city = data.city;
          self.formData.block = data.block;
          self.formData.imageUrl = data.imageUrl;
          self.formData.age = data.age;
          self.formData.intentLevel = data.intentLevel;
          self.formData.noStudyAdviserRemind = data.noStudyAdviserRemind === 1 ? 1 : 0;
          self.formData.connectionStatus = data.connectionStatus;
          self.formData.userContacts = data.userContacts;
          self.formData.grade = data.grade;
          self.formData.exten = data.exten;
          self.formData.birthday = data.birthday * 1000;
          self.formData.tchChannel = data.tchChannel;
          if (data.imageUrl) {
            if (data.imageUrl.indexOf('http://') !== -1) {
              self.totalImageUrl = data.imageUrl;
            } else {
              if (data.imageUrl.substr(0, 4) === 'http') {
                self.totalImageUrl = data.imageUrl;
              } else {
                self.totalImageUrl = 'http://medias.kouyujie.cn/' + data.imageUrl;
              }
            }
            self.text = '编辑头像';
          } else {
            self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
            self.text = '上传头像';
          }

          self.userModal = data.userModal;
          self.formData.allowCallReminder = data.allowCallReminder;
          self.formData.allowSmsReminder = data.allowSmsReminder;
          self.formData.mobileRemind = data.mobileRemind == null ? 1 : data.mobileRemind;
          self.formData.remarkMobileRemind = data.remarkMobileRemind == null ? 1 : data.remarkMobileRemind;
          self.formData.beforeClassCall = data.beforeClassCall == null ? 0 : data.beforeClassCall;
          self.formData.remindHours = data.remindHours || '';
          self.formData.classRequirement = data.classRequirement;
          self.formData.classRequirementTags = data.classRequirementTags;
        }
        self.userInfoChecked = true;
      }).catch(function () {
        self.userInfoChecked = true;
      });
      self.queryParam.uid = uid;
      self.queryParam.mobile = self.formData.oldMobile;
      self.search();
    } else {
      self.formData.password = '';
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyAdviserModal_vue__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPLLessonModal_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPLLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserPLLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserChineseLessonModal_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserChineseLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserChineseLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UserActivityNumModal_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UserActivityNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__UserActivityNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BookExchangeModal_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BookExchangeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__BookExchangeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modal_StudentClassHourModal_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modal_StudentClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modal_StudentClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modal_ToRefundModal_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modal_ToRefundModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__modal_ToRefundModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__order_OrderClassHourModal_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__order_OrderClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__order_OrderClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tools_aiAccess__ = __webpack_require__(30);























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrderClassHourModal: __WEBPACK_IMPORTED_MODULE_18__order_OrderClassHourModal_vue___default.a,
    BookExchangeModal: __WEBPACK_IMPORTED_MODULE_15__BookExchangeModal_vue___default.a,
    AssignAdviserModal: __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default.a,
    AssignUserStudyAdviserModal: __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyAdviserModal_vue___default.a,
    UserTestNetworkModal: __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue___default.a,
    UserLeaveModal: __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue___default.a,
    UserTempLessonModal: __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue___default.a,
    UserPLLessonModal: __WEBPACK_IMPORTED_MODULE_5__UserPLLessonModal_vue___default.a,
    UserChineseLessonModal: __WEBPACK_IMPORTED_MODULE_6__UserChineseLessonModal_vue___default.a,
    UserClassHourModal: __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue___default.a,
    UserLeaveNumModal: __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue___default.a,
    CourseSchedulingModal: __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue___default.a,
    BindTchModal: __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue___default.a,
    UserLessonNumModal: __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue___default.a,
    UserActivityNumModal: __WEBPACK_IMPORTED_MODULE_13__UserActivityNumModal_vue___default.a,
    StudentClassHourModal: __WEBPACK_IMPORTED_MODULE_16__modal_StudentClassHourModal_vue___default.a,
    ToRefundModal: __WEBPACK_IMPORTED_MODULE_17__modal_ToRefundModal_vue___default.a,
    AiDrawer: __WEBPACK_IMPORTED_MODULE_19__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      exportLoading: false,
      cancelLoading: false,
      stopLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      isSalesGroup10: false,
      editUser: false,
      showStudentLeaveModal: false,
      loadingShowStudentLeave: false,
      ids: '',
      options: {
        disabledDate: function disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      showStudentLeaveForm: {
        startStudyDate: '',
        leaveResult: ''
      },
      showStudentLeaveRule: {
        startStudyDate: [{ type: 'string', required: true, message: '请选择时间', trigger: 'blur' }],
        leaveResult: [{ type: 'string', required: true, message: '请输入停课原因', trigger: 'blur' }]
      },
      dateRange: [],
      newTab: 'today',
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      queryParam: {
        startTime: '',
        adviserId: '',
        adminUserId: '',
        endTime: '',
        isStudyAdviser: '',
        isTch: '',
        tchBoundNum: null,
        tchChannel: '',
        isNextWeekLessonOpened: '',
        status: null,
        searchKeyword: '',
        studyAdviserName: '',
        studyAdviserMobile: '',
        materialVersionId: '',
        bookMaterialLevelId: '',
        bindLessonNum: '',
        age: null,
        lessonWeek: '',
        lessonId: '',
        lessonNum: '',
        lastLessonNum: ''
      },
      lessonWeek: [],
      uid: null,
      currentRow: null,
      showAssignAdviserModal: false,
      showAssignUserStudyAdviserModal: false,
      selectionUser: [],
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModal: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showCourseSchedulingModal: false,
      showActivityNumModal: false,
      showBookExchangeModal: false,
      showBindTchModal: false,
      showStudentClassHourModal: false,
      showRefundModal: false,
      refundUid: '',
      testNetworkParam: {},
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: 'ID',
        key: 'id',
        align: 'center',
        fixed: 'left',
        width: 84
      }, {
        title: '中(英)文名',
        width: 90,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var age = row.age;
          if (age) {
            age = age + '岁';
          }
          var textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {};
          return h('div', [h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } }, style: textStyle }, row.nickname), h('p', { style: textStyle }, row.enName), h('p', { style: textStyle }, age)]);
        }
      }, {
        title: '手机号',
        align: 'center',
        width: 85,
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + "****" + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '等级',

        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.levelTitle || '未分级');
        }
      }, {
        title: '绑定老师',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var tchBoundNum = row.tchBoundNum;
          if (tchBoundNum && tchBoundNum > 0) {
            var list = row.bookWorkLessonOpenedTimeList;
            var spanArr = [];
            if (list) {
              list.forEach(function (element) {
                var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }, element.tchId + '-' + element.tchName), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
                spanArr.push(h('br'));
              });
            }
            var levelTitle = row.levelTitle;
            if (levelTitle) {
              levelTitle = '当前等级：' + levelTitle;
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', levelTitle), h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '订单列表',
        align: 'center',
        width: 310,
        render: function render(h, params) {
          var row = params.row;
          var list = row.fundPackageDtoList;
          var spanArr = [];
          if (list) {
            list.forEach(function (e) {
              var state = e.state;
              var stateStr = '';
              if (state) {
                if (state === 4) {
                  stateStr = '部分支付';
                } else if (state === 5) {
                  stateStr = '全部支付';
                } else if (state === 1) {
                  stateStr = '支付成功';
                } else if (state === 6) {
                  stateStr = '财务审核';
                }
              } else {
                if (state === 0) {
                  stateStr = '待支付';
                }
              }
              var channel = '';
              if (e.channel) {
                var channelEnum = $constant.getEnum($constant.orderChannel, e.channel);
                channel = channelEnum && channelEnum.text;
              }
              if (row.tchChannel === 1) {
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }, e.orderId + ':'), h('span', channel + '外教课' + e.num + '节/直播课' + e.livingNum + '/中教课' + e.chineseNum + '节(' + e.amount + '元)->'), h('span', { style: { color: 'red' } }, stateStr)]));
              }
              if (row.tchChannel === 2) {
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }, e.orderId + ':'), h('span', '(' + e.amount + '元)->'), h('span', { style: { color: 'red' } }, stateStr)]));
              }
              spanArr.push(h('br'));
            });
          }
          return h('div', { style: { 'font-size': '13px' } }, spanArr);
        }
      }, {
        title: '课时信息',
        align: 'center',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          if (row.tchChannel === 2) {
            return h('a', { on: { click: function click() {
                  return _this.showStudentClassHour(row);
                } } }, '可用课时：' + row.availableClassHour);
          }
          var leftRoutineNum = row.routineNum - row.routineEndNum;
          leftRoutineNum = leftRoutineNum > 0 ? leftRoutineNum : 0;
          var leftChineseNum = row.chineseNum - row.chineseEndNum;
          leftChineseNum = leftChineseNum > 0 ? leftChineseNum : 0;
          var leftPartNum = row.partnerNum - row.partnerEndNum;
          leftPartNum = leftPartNum > 0 ? leftPartNum : 0;
          return h('div', { style: { 'font-size': '13px' } }, [h('p', '外教/中教/陪练课'), h('p', '总课时:' + row.routineNum + ' / ' + row.chineseNum + ' / ' + row.partnerNum), h('p', '已完结:' + row.routineEndNum + ' / ' + row.chineseEndNum + ' / ' + row.partnerEndNum), h('p', { style: { color: 'red' } }, '剩余:' + leftRoutineNum + ' / ' + leftChineseNum + ' / ' + leftPartNum), h('p', { style: { color: 'green' } }, '锁定:' + row.waitEngNum + ' / ' + row.waitChineseNum + ' / ' + row.waitPartnerNum)]);
        }
      }, {
        title: '课程顾问',
        width: 90,
        align: 'center',
        key: 'adviserName',
        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '学导',
        width: 90,
        align: 'center',
        key: 'studyAdviserName',
        render: function render(h, params) {
          return h('span', params.row.studyAdviserName || '未分配');
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 70,
        render: function render(h, params) {
          var row = params.row;
          var id = row.id;

          var btn = [];
          if (_this.aiAllowed) {
            btn.push(h('Dropdown-item', { props: { name: 'ai' } }, 'AI'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'testNetwork' } }, '约测网课'));
          btn.push(h('Dropdown-item', { props: { name: 'courseScheduling' } }, '固定排课'));
          btn.push(h('Dropdown-item', { props: { name: 'userTemp' } }, '临时约课'));

          btn.push(h('Dropdown-item', { props: { name: 'PracticePartnerLesson' } }, '约陪练课'));
          btn.push(h('Dropdown-item', { props: { name: 'chineseLesson' } }, '约中教课'));
          btn.push(h('Dropdown-item', { props: { name: 'userLeave' } }, '学生请假'));
          var bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList;
          if (!bookWorkLessonOpenedTimeList) {
            btn.push(h('Dropdown-item', { props: { name: 'bindTch' } }, '绑定老师'));
          } else if (!_this.isSalesGroup10) {
            btn.push(h('Dropdown-item', { props: { name: 'editBindTch' } }, '修改绑定'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'changeDirector' } }, '学员转移'));
          btn.push(h('Dropdown-item', { props: { name: 'classHour' } }, '加减课时'));
          btn.push(h('Dropdown-item', { props: { name: 'leaveNum' } }, '加减请假次数'));
          btn.push(h('Dropdown-item', { props: { name: 'lessonNum' } }, '加减补课次数'));
          btn.push(h('Dropdown-item', { props: { name: 'track' } }, '跟踪记录'));
          btn.push(h('Dropdown-item', { props: { name: 'activity' } }, '积分兑换'));
          btn.push(h('Dropdown-item', { props: { name: 'book' } }, '绘本兑换'));
          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'ai') {
                  _this.aiUid = row.id;
                  _this.aiVisible = true;
                } else if (name === 'testNetwork') {
                  _this.showTestNetworkModal = true;
                  _this.testNetworkParam = row;
                  _this.testNetworkParam.uid = row.id;
                } else if (name === 'userTemp') {
                  _this.showUserTempLessonModal = true;
                  _this.tempLessonUser = row;
                } else if (name === 'userLeave') {
                  _this.uid = id;
                  _this.showUserLeaveModal = true;
                } else if (name === 'PracticePartnerLesson') {
                  _this.pLLessonUser = row;
                  _this.showUserPLLessonModal = true;
                } else if (name === 'chineseLesson') {
                  _this.chineseLessonUser = row;
                  _this.showUserChineseLessonModal = true;
                } else if (name === 'bindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                } else if (name === 'editBindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                } else if (name === 'unbindTch') {
                  _this.onUnbingTch(row);
                } else if (name === 'classHour') {
                  _this.uid = id;
                  _this.showUserClassHourModal = true;
                } else if (name === 'changeDirector') {
                  _this.uid = id;
                  _this.onChangeDirector(row);
                } else if (name === 'leaveNum') {
                  _this.uid = id;
                  _this.showUserLeaveNumModal = true;
                } else if (name === 'lessonNum') {
                  _this.uid = id;
                  _this.showUserLessonNumModal = true;
                } else if (name === 'courseScheduling') {
                  _this.uid = id;
                  _this.showCourseSchedulingModal = true;
                } else if (name === 'track') {
                  _this.$router.push({ path: '/user/userTrackList', query: _this.userTrackListQueryParam });
                } else if (name === 'activity') {
                  _this.uid = id;
                  _this.showActivityNumModal = true;
                } else if (name === 'book') {
                  _this.uid = id;
                  _this.showBookExchangeModal = true;
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      bookMaterialLevelList: [],
      lessonAll: []
    };
  },

  computed: {
    isTodayNew: function isTodayNew() {
      return this.$route.path === '/user/userTodayNewList';
    },
    pageTitle: function pageTitle() {
      if (!this.isTodayNew) {
        return '常规学生列表';
      }
      return this.newTab === 'month' ? '本月新生' : '新生分配';
    },
    pageRoute: function pageRoute() {
      return this.isTodayNew ? '/user/userTodayNewList' : '/user/userPayList';
    },
    tableColumns: function tableColumns() {
      if (!this.isTodayNew) {
        return this.title;
      }
      var cols = this.title.slice();
      var idx = cols.findIndex(function (col) {
        return col.key === 'studyAdviserName';
      });
      if (idx < 0) {
        return cols;
      }
      var self = this;
      cols.splice(idx + 1, 0, {
        title: '分配时间',
        width: 160,
        align: 'center',
        key: 'studyAdviserAssignTime',
        sortable: 'custom',
        sortType: self.queryParam.sortDirection === 'desc' ? 'desc' : 'asc',
        render: function render(h, params) {
          var time = params.row.studyAdviserAssignTime;
          if (!time) {
            return h('span', '-');
          }
          return h('span', self.$moment(time).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '是否联系过',
        width: 120,
        align: 'center',
        key: 'studyAdviserContacted',
        render: function render(h, params) {
          var row = params.row;
          var contacted = row.studyAdviserContacted === 1 ? 1 : 0;
          return h('Select', {
            style: { color: contacted === 1 ? 'green' : 'red' },
            props: {
              value: contacted,
              transfer: true
            },
            on: {
              'on-change': function onChange(value) {
                self.updateTodayNewContacted(row, value);
              }
            }
          }, [h('Option', { props: { value: 0 }, style: { color: 'red' } }, '未联系'), h('Option', { props: { value: 1 }, style: { color: 'green' } }, '已联系')]);
        }
      });
      return cols;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (!from || to.path === from.path) {
        return;
      }
      this.applyTodayNewFlag();
      this.applyTodayNewStudyAdviser();
      this.reload = new Date().getTime();
    }
  },
  mounted: function mounted() {
    var query = this.$route.query;
    if (query) {
      if (query.lessonWeek) {
        var lessonWeekArr = query.lessonWeek.split(',');
        for (var i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i]);
        }
      }
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__tools_aiAccess__["a" /* bindAiAllowed */])(this);
    this.loadSalesGroupFlag();
    this.applyTodayNewFlag();
    this.applyTodayNewStudyAdviser();
    var query = this.$route.query;
    if (query) {
      if (query.lessonWeek) {
        var lessonWeekArr = query.lessonWeek.split(',');
        for (var i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i]);
        }
      }
    }
  },
  methods: {
    loadSalesGroupFlag: function loadSalesGroupFlag() {
      var self = this;
      var id = this.$store.get('id');
      if (!id) {
        return;
      }
      this.$http.get('/adminUser/queryById', { params: { id: id } }).then(function (res) {
        if (res && res.data) {
          self.isSalesGroup10 = Number(res.data.groupId) === 10;
        }
      });
    },
    applyTodayNewStudyAdviser: function applyTodayNewStudyAdviser() {
      if (this.isTodayNew && this.isStudyAdviser) {
        this.queryParam.adminUserId = parseInt(this.$store.get('id'));
      }
    },
    applyTodayNewFlag: function applyTodayNewFlag() {
      if (!this.isTodayNew) {
        this.$delete(this.queryParam, 'queryTodayNew');
        this.$delete(this.queryParam, 'queryMonthNew');
        this.$delete(this.queryParam, 'sortProperty');
        this.$delete(this.queryParam, 'sortDirection');
        return;
      }
      if (this.newTab === 'month') {
        this.$set(this.queryParam, 'queryMonthNew', true);
        this.$delete(this.queryParam, 'queryTodayNew');
      } else {
        this.$set(this.queryParam, 'queryTodayNew', true);
        this.$delete(this.queryParam, 'queryMonthNew');
      }
      if (!this.queryParam.sortProperty) {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime');
      }
      if (!this.queryParam.sortDirection) {
        this.$set(this.queryParam, 'sortDirection', 'asc');
      }
    },
    onNewTabClick: function onNewTabClick(name) {
      this.newTab = name;
      this.applyTodayNewFlag();
      this.search();
    },
    handleAssignTimeSortChange: function handleAssignTimeSortChange(column, key, order) {
      if (!this.isTodayNew || key !== 'studyAdviserAssignTime') {
        return;
      }
      if (order && order !== 'normal') {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime');
        this.$set(this.queryParam, 'sortDirection', order);
      } else {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime');
        this.$set(this.queryParam, 'sortDirection', 'asc');
      }
      this.reload = new Date().getTime();
    },
    updateTodayNewContacted: function updateTodayNewContacted(row, value) {
      var _this2 = this;

      var contacted = value === 1 ? 1 : 0;
      this.$http.post('/user/pay/today-new-contact', { uid: row.id, contacted: contacted }).then(function (res) {
        if (res.status === 'ok') {
          row.studyAdviserContacted = contacted;
        } else {
          _this2.$Message.error(res.msg || '保存失败');
        }
      });
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: this.pageRoute }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    onStudyAdviserClose: function onStudyAdviserClose() {
      this.showAssignUserStudyAdviserModal = false;
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
    },
    onAiExecuted: function onAiExecuted() {
      this.reload = new Date().getTime();
    },
    search: function search() {
      var self = this;
      if (this.dateRange.length === 2) {
        if (this.dateRange[0]) {
          var startTimeDate = __WEBPACK_IMPORTED_MODULE_14__tools_date_dates_js___default.a.format(this.dateRange[0]);
          self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
        } else {
          self.queryParam.startTime = '';
        }
        if (this.dateRange[1]) {
          self.queryParam.endTime = this.$moment(this.dateRange[1], 'YYYY-M-D H:m').format('X');
        } else {
          self.queryParam.endTime = '';
        }
      } else {
        self.queryParam.startTime = '';
        self.queryParam.endTime = '';
      }

      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    searchList: function searchList() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    exportData: function exportData() {
      var _this3 = this;

      this.applyTodayNewFlag();
      this.exportLoading = true;
      this.$http.get('/user/pay/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          var downloadName = '付费学生.xls';
          if (_this3.isTodayNew) {
            downloadName = _this3.newTab === 'month' ? '本月新生.xls' : '今日新生.xls';
          }
          link.download = downloadName;
          link.click();
          _this3.exportLoading = false;
        } else {
          _this3.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this3.exportLoading = false;
      });
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showAssignAdviserModal = true;
    },
    batchCancel: function batchCancel() {
      var _this4 = this;

      this.cancelLoading = true;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      }
      var self = this;
      this.$http.post('/user/lessonsStop/inUserOverLesson', { ids: ids.join(',') }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('移至结课成功！');
          self.cancelLoading = false;
          self.search();
        } else {
          self.$Message.error(res.msg);
          self.cancelLoading = false;
        }
      }).catch(function (e) {
        self.$Message.error(e);
        _this4.cancelLoading = false;
      });
    },
    startStudyDate: function startStudyDate(value) {
      console.log('value', value);
      if (value === '') {
        this.$Message.warning('请输入复课时间');
      }
      this.showStudentLeaveForm.startStudyDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    showStopLessonModel: function showStopLessonModel() {
      var self = this;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      } else {
        this.$Message.warning('请选择停课目标');
        return;
      }
      self.ids = ids.join(',');
      self.showStudentLeaveModal = true;
    },
    showToRefundModal: function showToRefundModal() {
      if (!this.selectionUser || this.selectionUser.length !== 1) {
        this.$Message.warning('请勾选恰好1名学生');
        return;
      }
      this.refundUid = this.selectionUser[0].id;
      this.showRefundModal = true;
    },
    inStopLesson: function inStopLesson() {
      var _this5 = this;

      var self = this;
      this.stopLoading = true;
      if (self.showStudentLeaveForm.startStudyDate == '' || self.showStudentLeaveForm.leaveResult == '') {
        this.$Message.warning('请填写停课信息');
        return;
      }
      this.$http.post('/user/lessonsStop/inUserStopLesson', {
        ids: self.ids,
        resumeClassDate: this.showStudentLeaveForm.startStudyDate,
        remark: this.showStudentLeaveForm.leaveResult
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('移至停课，申请审核成功！');
          self.stopLoading = false;
          self.showStudentLeaveModal = false;
          self.search();
        } else {
          self.$Message.error(res.msg);
          self.stopLoading = false;
          self.showStudentLeaveModal = false;
        }
      }).catch(function (e) {
        _this5.stopLoading = false;
        self.$Message.error(e);
      });
    },
    onAssignStudyAdviser: function onAssignStudyAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！');
        return;
      }
      this.showAssignUserStudyAdviserModal = true;
    },
    onChangeDirector: function onChangeDirector(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search();
            self.$Message.success('转移成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    selectWeek: function selectWeek() {
      this.queryParam.lessonWeek = [];
      this.queryParam.lessonWeek = this.lessonWeek.join(',');
    },
    loadLevelIds: function loadLevelIds(val) {
      var self = this;
      var url = '/bookMaterialLevel/listByCondition';
      if (val) {
        url = '/bookMaterialLevel/listByCondition?materialVersion=' + val;
      }
      self.$http.get(url).then(function (res) {
        if (res && res.data) {
          self.bookMaterialLevelList = res.data;
        }
      });
    },
    changeLevel: function changeLevel(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAll = res.data;
          }
        });
      }
    },
    cannelStudy: function cannelStudy() {
      var self = this;
      var idList = self.selectionUser.map(function (element) {
        return element.id;
      });
      self.loadingAssignAdviser = true;
      var params = { ids: idList.join(','), studyAdviserId: 0, reason: '' };
      self.$http.get('/user/updateStudyAdviser', { params: params }).then(function (res) {
        if (res) {
          self.$Message.success('成功！');
          self.loadingAssignAdviser = false;
          self.search();
        }
      }).catch(function (e) {
        self.$Message.error('失败！');
        self.loadingAssignAdviser = false;
      });
    },
    showStudentClassHour: function showStudentClassHour(row) {
      this.uid = row.id;
      this.showStudentClassHourModal = true;
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyModal_vue__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserChineseLessonModal_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserChineseLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserChineseLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserPLLessonModal_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserPLLessonModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserPLLessonModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_RejectWoModal_vue__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_RejectWoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modal_RejectWoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UserActivityNumModal_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UserActivityNumModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__UserActivityNumModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BookExchangeModal_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BookExchangeModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__BookExchangeModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modal_UpdateLevelModal_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modal_UpdateLevelModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__modal_UpdateLevelModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_StudentClassHourModal_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_StudentClassHourModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__modal_StudentClassHourModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BatchCompletedCoursesModal_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BatchCompletedCoursesModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__BatchCompletedCoursesModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_ToRefundModal_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_ToRefundModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modal_ToRefundModal_vue__);
























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BatchCompletedCoursesModal: __WEBPACK_IMPORTED_MODULE_19__BatchCompletedCoursesModal_vue___default.a,
    UpdateLevelModal: __WEBPACK_IMPORTED_MODULE_17__modal_UpdateLevelModal_vue___default.a,
    BookExchangeModal: __WEBPACK_IMPORTED_MODULE_16__BookExchangeModal_vue___default.a,
    AssignAdviserModal: __WEBPACK_IMPORTED_MODULE_0__AssignAdviserModal_vue___default.a,
    AssignUserStudyModal: __WEBPACK_IMPORTED_MODULE_1__modal_AssignUserStudyModal_vue___default.a,
    UserTestNetworkModal: __WEBPACK_IMPORTED_MODULE_2__modal_UserTestNetworkModal_vue___default.a,
    UserLeaveModal: __WEBPACK_IMPORTED_MODULE_3__UserLeaveModal_vue___default.a,
    UserTempLessonModal: __WEBPACK_IMPORTED_MODULE_4__modal_UserTempLessonModal_vue___default.a,
    UserChineseLessonModal: __WEBPACK_IMPORTED_MODULE_5__UserChineseLessonModal_vue___default.a,
    UserPLLessonModal: __WEBPACK_IMPORTED_MODULE_6__UserPLLessonModal_vue___default.a,
    UserClassHourModal: __WEBPACK_IMPORTED_MODULE_7__UserClassHourModal_vue___default.a,
    UserLeaveNumModal: __WEBPACK_IMPORTED_MODULE_8__UserLeaveNumModal_vue___default.a,
    CourseSchedulingModal: __WEBPACK_IMPORTED_MODULE_10__modal_CourseSchedulingModal_vue___default.a,
    BindTchModal: __WEBPACK_IMPORTED_MODULE_12__modal_BindTchModal_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_11__crm_UserInfoModal_vue___default.a,
    UserLessonNumModal: __WEBPACK_IMPORTED_MODULE_9__UserLessonNumModal_vue___default.a,
    UserActivityNumModal: __WEBPACK_IMPORTED_MODULE_14__UserActivityNumModal_vue___default.a,
    RejectWoModal: __WEBPACK_IMPORTED_MODULE_13__modal_RejectWoModal_vue___default.a,
    StudentClassHourModal: __WEBPACK_IMPORTED_MODULE_18__modal_StudentClassHourModal_vue___default.a,
    ToRefundModal: __WEBPACK_IMPORTED_MODULE_20__modal_ToRefundModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      searchLoading: false,
      loadingShowStudentLeave: false,
      exportLoading: false,
      reload: 0,

      editUser: false,
      showStudentClassHourModal: false,
      showRefundModal: false,
      refundUid: '',
      showBatchCompletedCoursesModal: false,
      showStudentLeaveModal: false,
      showStudentLeaveForm: {
        startStudyDate: '',
        leaveResult: ''
      },
      options: {
        disabledDate: function disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      showStudentLeaveRule: {
        startStudyDate: [{ type: 'string', required: true, message: '请选择时间', trigger: 'blur' }],
        leaveResult: [{ type: 'string', required: true, message: '请输入停课原因', trigger: 'blur' }]
      },
      dateRange: [],
      queryParam: {
        startTime: '',
        endTime: '',
        isStudyAdviser: '',
        isTch: '',
        tchBoundNum: null,
        isNextWeekLessonOpened: '',
        status: null,
        searchKeyword: '',
        studyAdviserName: '',
        serviceAttribution: '',
        studyAdviserMobile: '',
        materialVersionId: '',
        bookMaterialLevelId: '',
        bindLessonNum: '',
        age: null,
        lessonWeek: '',
        lessonId: '',
        lessonNum: '',
        lastLessonNum: '',
        adminUserId: '',
        adviserId: '',
        woStatus: '',
        woVersion: null
      },
      lessonWeek: [],
      uid: null,
      uidStr: '',
      currentRow: null,
      showAssignAdviserModal: false,
      showAssignUserStudyAdviserModal: false,
      selectionUser: [],
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModal: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showBookExchangeModal: false,
      showCourseSchedulingModal: false,
      showActivityNumModal: false,
      showBindTchModal: false,
      showUpdateLevelModal: false,
      rejectWoModal: false,
      testNetworkParam: {},
      title: [{
        type: 'selection',
        width: 40,
        fixed: 'left',
        align: 'center'
      }, {
        title: 'ID',
        key: 'id',
        fixed: 'left',
        align: 'center',
        width: 100
      }, {
        title: '中 (英) 文名',
        width: 140,
        fixed: 'left',
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var age = row.age;
          if (age) {
            age = age + '岁';
          }
          var content = [h('Tooltip', {
            props: {
              content: row.remark || '',
              placement: 'right',
              disabled: !row.remark,
              transfer: true
            }
          }, [h('a', { on: { click: function click() {
                return _this.openInfoModal(row.id);
              } } }, row.nickname)]), h('p', row.enName)];
          content.push(h('p', age));
          if (row.fullGiftRemain > 0) {
            content.push(h('p', { style: { color: 'red', 'font-size': '12px' } }, '畅学满赠剩余' + row.fullGiftRemain + '次'));
          }
          return h('div', content);
        }
      }, {
        title: '手机号',
        align: 'center',
        width: 130,
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '课程顾问',
        width: 90,
        align: 'center',
        key: 'adviserName',
        render: function render(h, params) {
          return h('span', params.row.adviserName || '未分配');
        }
      }, {
        title: '学导',
        width: 90,
        align: 'center',
        key: 'studyAdviserName',
        render: function render(h, params) {
          return h('span', params.row.studyAdviserName || '未分配');
        }
      }, {
        title: '学生服务归属',
        width: 150,
        align: 'center',
        key: 'serviceAttribution',
        render: function render(h, params) {
          return h('span', $constant.getEnum($constant.studentServerBy, params.row.serviceAttribution).text);
        }
      }, {
        title: '绑定老师',
        width: 220,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchBoundNum && row.tchBoundNum > 0) {
            var list = row.bookWorkLessonOpenedTimeList;
            var spanArr = [];
            if (list) {
              list.forEach(function (element) {
                var startTime = $moment.unix(element.startTime).utc().format(' HH:mm');
                spanArr.push(h('span', [h('span', element.tchId + '-' + element.tchName), h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]));
                spanArr.push(h('br'));
              });
            }
            var levelTitle = row.levelTitle;
            if (levelTitle) {
              levelTitle = '当前等级：' + levelTitle;
            }
            return h('div', { style: { 'font-size': '12px' } }, [h('p', levelTitle), h('p', spanArr)]);
          } else {
            return h('div', '未绑定');
          }
        }
      }, {
        title: '等级',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          return h('span', params.row.levelTitle || '未分级');
        }
      }, {
        title: '订单列表',
        width: 320,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var list = row.fundPackageDtoList;
          var spanArr = [];
          if (list) {
            list.forEach(function (e) {
              var state = e.state;
              var stateStr = '';
              if (state) {
                if (state === 4) {
                  stateStr = '部分支付';
                } else if (state === 5) {
                  stateStr = '全部支付';
                } else if (state === 1) {
                  stateStr = '支付成功';
                } else if (state === 6) {
                  stateStr = '财务审核';
                }
              } else {
                if (state === 0) {
                  stateStr = '待支付';
                }
              }
              var channel = '';
              if (e.channel) {
                var channelEnum = $constant.getEnum($constant.orderChannel, e.channel);
                channel = channelEnum && channelEnum.text;
              }
              if (row.tchChannel === 1) {
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }, e.orderId + ':'), h('span', channel + '外教课' + e.num + '节/直播课' + e.livingNum + '/中教课' + e.chineseNum + '节(' + e.amount + '元)->'), h('span', { style: { color: 'red' } }, stateStr)]));
              }
              if (row.tchChannel === 2) {
                spanArr.push(h('span', [h('span', { style: { color: '#2d8cf0' } }, e.orderId + ':'), h('span', '(' + e.amount + '元)->'), h('span', { style: { color: 'red' } }, stateStr)]));
              }

              spanArr.push(h('br'));
            });
          }
          return h('div', { style: { 'font-size': '13px' } }, spanArr);
        }
      }, {
        title: '课时信息',
        width: 160,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.tchChannel === 2) {
            return h('a', { on: { click: function click() {
                  return _this.showStudentClassHour(row);
                } } }, '剩余课时：' + row.availableClassHour);
          }
          var leftRoutineNum = row.routineNum - row.routineEndNum;
          leftRoutineNum = leftRoutineNum > 0 ? leftRoutineNum : 0;
          var leftChineseNum = row.chineseNum - row.chineseEndNum;
          leftChineseNum = leftChineseNum > 0 ? leftChineseNum : 0;
          var leftPartNum = row.partnerNum - row.partnerEndNum;
          leftPartNum = leftPartNum > 0 ? leftPartNum : 0;
          return h('div', { style: { 'font-size': '13px' } }, [h('p', '外教/中教/陪练'), h('p', '总课时:' + row.routineNum + ' / ' + row.chineseNum + ' / ' + row.partnerNum), h('p', '已完结:' + row.routineEndNum + ' / ' + row.chineseEndNum + ' / ' + row.partnerEndNum), h('p', { style: { color: 'red' } }, '剩余:' + leftRoutineNum + ' / ' + leftChineseNum + ' / ' + leftPartNum), h('p', { style: { color: 'green' } }, '锁定:' + row.waitEngNum + ' / ' + row.waitChineseNum + ' / ' + row.waitPartnerNum)]);
        }
      }, {
        title: '请假统计',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var leaveNum = row.leaveNum;
          leaveNum = leaveNum > 0 ? leaveNum : 0;
          var leftMakeUpLessonNum = row.makeupLessonNum - row.makeupLessonEndNum;
          leftMakeUpLessonNum = leftMakeUpLessonNum > 0 ? leftMakeUpLessonNum : 0;
          return h('div', [h('p', '请假次数:' + leaveNum), h('p', '补课次数:' + leftMakeUpLessonNum)]);
        }
      }, {
        title: '工单类型',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var woVersion = row.woVersion;
          var woVersionStr = '';
          if (woVersion >= 0) {
            var woVersionEnum = $constant.getEnum($constant.woVersion, woVersion);
            woVersionStr = woVersionEnum && woVersionEnum.text;
          }
          return h('span', woVersionStr);
        }
      }, {
        title: '工单状态',
        width: 80,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var status = row.woStatus;
          var woStatus = '';
          if (status) {
            var statusEnum = $constant.getEnum($constant.woStatus, status);
            woStatus = statusEnum && statusEnum.text;
          }
          return h('span', woStatus);
        }
      }, {
        title: '开课时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.classOpeningTime);
        }
      }, {
        title: '工单提交时间',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.woSubmitTime);
        }
      }, {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 70,
        render: function render(h, params) {
          var row = params.row;
          var id = row.id;

          var status = row.woStatus;
          var btn = [];
          btn.push(h('Dropdown-item', { props: { name: 'testNetwork' } }, '约测网课'));
          btn.push(h('Dropdown-item', { props: { name: 'courseScheduling' } }, '固定排课'));
          btn.push(h('Dropdown-item', { props: { name: 'userTemp' } }, '临时约课'));
          if (status === 'UNAUDITED') {
            btn.push(h('Dropdown-item', { props: { name: 'woApprove' } }, '审批工单'));
            btn.push(h('Dropdown-item', { props: { name: 'woInProgress' } }, '处理中'));
            btn.push(h('Dropdown-item', { props: { name: 'woReject' } }, '驳回工单'));
          }

          btn.push(h('Dropdown-item', { props: { name: 'PracticePartnerLesson' } }, '约陪练课'));
          btn.push(h('Dropdown-item', { props: { name: 'chineseLesson' } }, '约中教课'));
          btn.push(h('Dropdown-item', { props: { name: 'userLeave' } }, '学生请假'));
          var bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList;
          if (!bookWorkLessonOpenedTimeList) {
            btn.push(h('Dropdown-item', { props: { name: 'bindTch' } }, '绑定老师'));
          } else {
            btn.push(h('Dropdown-item', { props: { name: 'editBindTch' } }, '修改绑定'));
          }
          btn.push(h('Dropdown-item', { props: { name: 'updateLevel' } }, '学员定级'));
          btn.push(h('Dropdown-item', { props: { name: 'changeDirector' } }, '学员转移'));
          btn.push(h('Dropdown-item', { props: { name: 'classHour' } }, '加减课时'));
          btn.push(h('Dropdown-item', { props: { name: 'leaveNum' } }, '加减请假次数'));
          btn.push(h('Dropdown-item', { props: { name: 'lessonNum' } }, '加减补课次数'));
          btn.push(h('Dropdown-item', { props: { name: 'track' } }, '跟踪记录'));
          btn.push(h('Dropdown-item', { props: { name: 'activity' } }, '积分兑换'));
          btn.push(h('Dropdown-item', { props: { name: 'book' } }, '绘本兑换'));
          return h('div', [h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click'
            },
            on: {
              'on-click': function onClick(name) {
                if (name === 'testNetwork') {
                  _this.showTestNetworkModal = true;
                  _this.testNetworkParam = row;
                  _this.testNetworkParam.uid = row.id;
                } else if (name === 'userTemp') {
                  _this.showUserTempLessonModal = true;
                  _this.tempLessonUser = row;
                } else if (name === 'userLeave') {
                  _this.uid = id;
                  _this.showUserLeaveModal = true;
                } else if (name === 'PracticePartnerLesson') {
                  _this.pLLessonUser = row;
                  _this.showUserPLLessonModal = true;
                } else if (name === 'chineseLesson') {
                  _this.chineseLessonUser = row;
                  _this.showUserChineseLessonModal = true;
                } else if (name === 'bindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                } else if (name === 'editBindTch') {
                  _this.currentRow = row;
                  _this.showBindTchModal = true;
                } else if (name === 'updateLevel') {
                  _this.currentRow = row;
                  _this.showUpdateLevelModal = true;
                } else if (name === 'classHour') {
                  _this.uid = id;
                  _this.showUserClassHourModal = true;
                } else if (name === 'changeDirector') {
                  _this.uid = id;
                  _this.onChangeDirector(row);
                } else if (name === 'leaveNum') {
                  _this.uid = id;
                  _this.showUserLeaveNumModal = true;
                } else if (name === 'lessonNum') {
                  _this.uid = id;
                  _this.showUserLessonNumModal = true;
                } else if (name === 'courseScheduling') {
                  _this.uid = id;
                  _this.showCourseSchedulingModal = true;
                } else if (name === 'track') {
                  _this.$router.push({ path: '/user/userTrackList', query: _this.userTrackListQueryParam });
                } else if (name === 'activity') {
                  _this.uid = id;
                  _this.showActivityNumModal = true;
                } else if (name === 'woApprove') {
                  _this.woApprove(id);
                } else if (name === 'woReject') {
                  _this.woReject(row);
                } else if (name === 'woInProgress') {
                  _this.woInProgress(id);
                } else if (name === 'book') {
                  _this.uid = id;
                  _this.showBookExchangeModal = true;
                }
              }
            }
          }, [h('a', [h('span', '更多 '), h('Icon', { props: { type: 'ios-arrow-down' } })]), h('Dropdown-menu', { slot: 'list' }, btn)])]);
        }
      }],
      bookMaterialLevelList: [],
      lessonAll: []
    };
  },

  mounted: function mounted() {
    var query = this.$route.query;
    if (query) {
      if (query.lessonWeek) {
        var lessonWeekArr = query.lessonWeek.split(',');
        for (var i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i]);
        }
      }
    }
  },
  created: function created() {
    var query = this.$route.query;
    if (query) {
      if (query.lessonWeek) {
        var lessonWeekArr = query.lessonWeek.split(',');
        for (var i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i]);
        }
      }
    }
  },
  methods: {
    inStopLesson: function inStopLesson() {
      var _this2 = this;

      var self = this;
      this.stopLoading = true;
      if (self.showStudentLeaveForm.startStudyDate == '' || self.showStudentLeaveForm.leaveResult == '') {
        this.$Message.warning('请填写停课信息');
        return;
      }
      this.$http.post('/user/lessonsStop/inUserStopLesson', {
        ids: self.uidStr,
        resumeClassDate: this.showStudentLeaveForm.startStudyDate,
        remark: this.showStudentLeaveForm.leaveResult
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('移至停课，申请审核成功！');
          self.stopLoading = false;
          self.showStudentLeaveModal = false;
          self.search();
        } else {
          self.$Message.error(res.msg);
          self.stopLoading = false;
          self.showStudentLeaveModal = false;
        }
      }).catch(function (e) {
        _this2.stopLoading = false;
        self.$Message.error(e);
      });
    },
    startStudyDate: function startStudyDate(value) {
      console.log('value', value);
      if (value === '') {
        this.$Message.warning('请输入复课时间');
      }
      this.showStudentLeaveForm.startStudyDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    onDateChange: function onDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryParam.startTime = this.$moment(dateRange[0], 'YYYY-M-D H:m').format('X');
        this.queryParam.endTime = this.$moment(dateRange[1], 'YYYY-M-D H:m').format('X');
      } else {
        this.queryParam.startTime = '';
        this.queryParam.endTime = '';
      }
    },
    startTimeDateChange: function startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    endTimeDateChange: function endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X');
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserProvisionalList' }
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    onStudyAdviserClose: function onStudyAdviserClose() {
      this.showAssignUserStudyAdviserModal = false;
    },
    search: function search() {
      var self = this;
      if (this.dateRange.length == 2) {
        if (this.dateRange[0]) {
          var startTimeDate = __WEBPACK_IMPORTED_MODULE_15__tools_date_dates_js___default.a.format(this.dateRange[0]);
          self.queryParam.startTime = Date.parse(startTimeDate) / 1000;
        } else {
          self.queryParam.startTime = '';
        }
        if (this.dateRange[1]) {
          self.queryParam.endTime = this.$moment(this.dateRange[1], 'YYYY-M-D H:m').format('X');
        } else {
          self.queryParam.endTime = '';
        }
      } else {
        self.queryParam.startTime = '';
        self.queryParam.endTime = '';
      }

      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    searchList: function searchList() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    },
    exportData: function exportData() {
      var _this3 = this;

      this.exportLoading = true;
      this.$http.get('/user/pay/provisional-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '待分配学生.csv';
          link.click();
          _this3.exportLoading = false;
        } else {
          _this3.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this3.exportLoading = false;
      });
    },
    onAssignAdviser: function onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！');
        return;
      }
      this.showAssignAdviserModal = true;
    },
    onAssignStudyAdviser: function onAssignStudyAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！');
        return;
      }
      this.showAssignUserStudyAdviserModal = true;
    },
    salesServerAlone: function salesServerAlone() {
      var self = this;
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要销售独立服务的学生！');
        return;
      }
      var idList = self.selectionUser.map(function (element) {
        return element.id;
      });
      var params = { ids: idList.join(',') };
      self.$http.get('/user/lessonsStop/batchUpdateServiceAttribution', { params: params }).then(function (res) {
        if (res.status == 'ok') {
          self.$Message.success('学生已转变为销售独立服务');
          self.search();
        }
      }).catch(function (e) {
        self.$Message.error('系统异常');
      });
    },
    onChangeDirector: function onChangeDirector(row) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search();
            self.$Message.success('转移成功!');
            self.$Modal.remove();
          });
        }
      });
    },
    selectWeek: function selectWeek() {
      this.queryParam.lessonWeek = [];
      this.queryParam.lessonWeek = this.lessonWeek.join(',');
    },
    loadLevelIds: function loadLevelIds(val) {
      var self = this;
      var url = '/bookMaterialLevel/listByCondition';
      if (val) {
        url = '/bookMaterialLevel/listByCondition?materialVersion=' + val;
      }
      self.$http.get(url).then(function (res) {
        if (res && res.data) {
          self.bookMaterialLevelList = res.data;
        }
      });
    },
    woApprove: function woApprove(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>审批</b>工单？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          var data = { studentId: id };
          self.$http.post('/sale/wo/approve', data).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('审核成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    woInProgress: function woInProgress(id) {
      var self = this;
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>处理</b>工单？',
        width: 300,
        loading: true,
        onOk: function onOk() {
          self.$Modal.remove();
          var data = { studentId: id };
          self.$http.post('/sale/wo/inProgress', data).then(function (res) {
            if (res) {
              self.search();
              self.$Message.success('操作成功!');
            }
            self.$Modal.remove();
          });
        }
      });
    },
    woReject: function woReject(row) {
      this.uid = row.id;
      this.rejectWoModal = true;
    },
    changeLevel: function changeLevel(val) {
      var self = this;
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAll = res.data;
          }
        });
      }
    },
    cannelStudy: function cannelStudy() {
      var self = this;
      var idList = self.selectionUser.map(function (element) {
        return element.id;
      });
      self.loadingAssignAdviser = true;
      var params = { ids: idList.join(','), studyAdviserId: 0, reason: '' };
      self.$http.get('/user/updateStudyAdviser', { params: params }).then(function (res) {
        if (res) {
          self.$Message.success('成功！');
          self.loadingAssignAdviser = false;
          self.search();
        }
      }).catch(function (e) {
        self.$Message.error('失败！');
        self.loadingAssignAdviser = false;
      });
    },
    onBatchCompletedCourses: function onBatchCompletedCourses() {
      var self = this;
      if (self.selectionUser.length <= 0) {
        self.$Message.warning('请选择需学生！');
        return;
      }
      var idList = self.selectionUser.map(function (element) {
        return element.id;
      });
      self.uidStr = idList.join(';');
      self.showBatchCompletedCoursesModal = true;
    },
    showStopLessonModel: function showStopLessonModel() {
      var self = this;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      } else {
        this.$Message.warning('请选择停课目标');
        return;
      }
      self.uidStr = ids.join(',');
      self.showStudentLeaveModal = true;
    },
    showToRefundModal: function showToRefundModal() {
      if (!this.selectionUser || this.selectionUser.length !== 1) {
        this.$Message.warning('请勾选恰好1名学生');
        return;
      }
      this.refundUid = this.selectionUser[0].id;
      this.showRefundModal = true;
    },
    showStudentClassHour: function showStudentClassHour(row) {
      this.uid = row.id;
      this.showStudentClassHourModal = true;
    }
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ToRefundModal_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_ToRefundModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_ToRefundModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserRefundList',
  components: {
    ToRefundModal: __WEBPACK_IMPORTED_MODULE_1__modal_ToRefundModal_vue___default.a
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      showRefundModal: false,
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        regStartTime: null,
        regEndTime: null,
        applyStartTime: null,
        applyEndTime: null,
        uid: '',
        adviser: '',
        stuName: '',
        mobile: '',
        studyAdviser: '',
        adviserId: '',
        adminUserId: ''
      },
      regDateRange: [],
      applyDateRange: [],
      title: [{
        title: 'ID/姓名',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '手机号',

        align: 'center',
        key: 'mobile',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover'
            }
          }, [h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) + '****' + params.row.mobile.substring(7) : params.row.mobile), h('div', { slot: 'content' }, params.row.mobile)]);
        }
      }, {
        title: '学导',

        align: 'center',
        key: 'studyAdviser'
      }, {
        title: '课程顾问',

        align: 'center',
        key: 'adviser'
      }, {
        title: '注册渠道',

        align: 'center',
        key: 'regType'
      }, {
        title: '注册时间',
        align: 'center',

        key: 'regTime',
        render: function render(h, params) {
          var regTime = params.row.regTime;
          if (regTime === 0) {
            return;
          }
          return h('span', regTime && $moment(regTime, 'X').format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '退费时间',
        align: 'center',

        key: 'refundTime'
      }, {
        title: '退费原因',
        align: 'center',

        key: 'remark'
      }]
    };
  },

  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var query = this.$route.query;
      if (query) {
        if (query.regStartTime) {
          this.regDateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.regStartTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.regEndTime) {
          this.regDateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.regEndTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.applyStartTime) {
          this.applyDateRange[0] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.applyStartTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.applyEndTime) {
          this.applyDateRange[1] = __WEBPACK_IMPORTED_MODULE_0__tools_date_dates_js___default.a.format(parseInt(query.applyEndTime) * 1000, 'YYYY-MM-DD') + '';
        }
        if (query.uid) {
          this.queryParam.uid = query.uid;
        }
        if (query.adviser) {
          this.queryParam.adviser = query.adviser;
        }
        if (query.studyAdviser) {
          this.queryParam.studyAdviser = query.studyAdviser;
        }
        if (query.stuName) {
          this.queryParam.stuName = query.stuName;
        }
        if (query.mobile) {
          this.queryParam.mobile = query.mobile;
        }
      }
    },
    exportData: function exportData(type) {
      var _this = this;

      this.exportLoading = true;
      this.$http.get('/financial/user/refund/export', { responseType: 'arraybuffer', params: this.queryParam }).then(function (response) {
        if (response.data) {
          var blob = new Blob([response.data], { type: 'text/csv' });
          var link = document.createElement('a');
          link.target = '_blank';
          link.href = window.URL.createObjectURL(blob);
          link.download = '退费学生.csv';
          link.click();
          _this.exportLoading = false;
        } else {
          _this.$Message.error(response.msg);
        }
      }).catch(function (e) {
        _this.exportLoading = false;
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    showInsertRefundModal: function showInsertRefundModal() {
      this.showRefundModal = true;
    },
    applyDateChange: function applyDateChange(dateRange) {
      if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        var startTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime();
        var endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        this.queryParam.applyStartTime = parseInt(startTime / 1000);
        this.queryParam.applyEndTime = parseInt(endTime / 1000);
      } else {
        this.queryParam.applyStartTime = null;
        this.queryParam.applyEndTime = null;
        this.applyDateRange = [];
      }
      this.search();
    }
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $constant = this.$constant;
    return {
      searchLoading: false,
      showWhyNotModal: false,
      loadingWhyNot: false,
      selectionUser: [],
      reload: 0,
      queryParam: {
        createdId: '',
        uid: '',
        beforeStatusRecord: '',
        afterStatusRecord: '',
        beginTime: '',
        endTime: '',
        status: ''
      },
      auditParams: {
        ids: 0,
        status: '',
        refuse: ''
      },
      tableColumns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '学生ID/姓名',
        align: 'center',

        render: function render(h, params) {
          var row = params.row;
          return h('span', row.uid + '-' + row.nickName);
        }
      }, {
        title: '学生等级',

        align: 'center',
        key: 'platLevel'
      }, {
        title: '课时信息',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var num = row.routineNum - row.routineEndNum;
          return h('div', [h('div', '外教课课时：' + row.routineNum), h('div', '陪练课课时：' + row.partnerNum), h('div', '中教课课时：' + row.chineseNum), h('div', '外教课课时消耗：' + row.routineEndNum), h('div', '剩余外教课课时：' + num)]);
        }
      }, {
        title: '状态变更',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          var before = row.beforeStatusRecord ? $constant.getEnum($constant.studentStatusAudit, row.beforeStatusRecord).text : '未知状态';
          var after = row.afterStatusRecord ? $constant.getEnum($constant.studentStatusAudit, row.afterStatusRecord).text : '未知状态';
          return h('div', before + ' —> ' + after);
        }
      }, {
        title: '申请人',

        align: 'center',
        key: 'createdName'
      }, {
        title: '申请原因',

        align: 'center',
        key: 'description'
      }, {
        title: '拒绝理由',

        align: 'center',
        key: 'refuse'
      }, {
        title: '审批状态',

        align: 'center',
        key: 'status',
        render: function render(h, params) {
          var text = '';
          switch (params.row.status) {
            case 1:
              text = '已通过';
              break;
            case 2:
              text = '已驳回';
              break;
            default:
              text = '待审核';
              break;
          }
          return h('div', text);
        }
      }, {
        title: '提交时间',
        width: 120,
        align: 'center',
        key: 'createTime'
      }, {
        title: '审批时间',
        width: 120,
        align: 'center',
        key: 'reviewTime'
      }, {
        title: '操作',

        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.status === 0) {
            return h('div', [h('a', { on: { click: function click() {
                  return _this.showPass(row);
                } } }, '通过'), h('br', '  '), h('a', { on: { click: function click() {
                  return _this.showRefused(row);
                } } }, '拒绝')]);
          } else {
            return;
          }
        }
      }]
    };
  },

  methods: {
    timeDateChange: function timeDateChange(value) {
      var self = this;
      self.queryParam.beginTime = value[0] + ' 00:00:00';
      self.queryParam.endTime = value[1] + ' 23:59:59';
    },
    showPassAll: function showPassAll() {
      var self = this;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      }
      self.$Modal.confirm({
        title: '确认通过吗',
        content: '通过后及时通知对应学导或者教务服务学员',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.auditParams.ids = ids.join(',');
          self.auditParams.status = 1;
          self.audit();
        }
      });
    },
    showPass: function showPass(row) {
      var self = this;
      self.$Modal.confirm({
        title: '确认通过吗',
        content: '通过后及时通知对应学导或者教务服务学员',
        width: 300,
        okText: '确认',
        onOk: function onOk() {
          self.auditParams.ids = row.id;
          self.auditParams.status = 1;
          self.audit();
        }
      });
    },
    showRefusedAll: function showRefusedAll() {
      var self = this;
      var ids = [];
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (var i in this.selectionUser) {
          var dto = this.selectionUser[i];
          ids[i] = dto.id;
        }
      }
      self.auditParams.ids = ids.join(',');
      self.auditParams.status = 2;
      this.showWhyNotModal = true;
    },
    showRefused: function showRefused(row) {
      var self = this;
      self.auditParams.ids = row.id;
      self.auditParams.status = 2;
      this.showWhyNotModal = true;
    },
    audit: function audit() {
      var _this2 = this;

      var self = this;
      self.$http.post('/userstatusreview/batchreviewstatus', self.auditParams).then(function (res) {
        if (res.status === 'ok') {
          _this2.$Message.success('成功');
          _this2.showWhyNotModal = false;
          _this2.search();
          _this2.auditParams.refuse = '';
        }
      }).catch(function (error) {
        _this2.$Message.error(error);
      });
    },
    cancel: function cancel() {
      this.showWhyNotModal = false;
      this.auditParams.refuse = '';
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    search: function search() {
      this.selectionUser = [];
      this.reload = new Date().getTime();
    },
    selectionChange: function selectionChange(selection) {
      this.selectionUser = selection;
    }
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserTrackContentModal',
  data: function data() {
    return {
      visible: false,
      html: '',
      rawText: '',
      viewMode: 'markdown',
      meta: {},
      exportLoading: false
    };
  },

  methods: {
    open: function open(item) {
      if (!item || !item.content) {
        this.$Message.warning('暂无内容');
        return;
      }
      this.meta = {
        uid: item.uid || '',
        id: item.id || '',
        createTime: item.createTime || ''
      };
      this.html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(item.content);
      this.rawText = item.contentRaw || '';
      this.viewMode = 'markdown';
      this.visible = true;
    },
    exportPng: function exportPng() {
      var el = this.$refs.contentExportArea;
      if (!el || (this.viewMode === 'markdown' ? !this.html : !this.rawText)) {
        this.$Message.warning('暂无内容可导出');
        return;
      }
      this.exportLoading = true;
      var self = this;

      var width = Math.max(el.clientWidth || 0, 680);
      var holder = document.createElement('div');
      holder.setAttribute('data-track-png-export', '1');
      holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;';
      var clone = el.cloneNode(true);
      clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim();
      if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
        clone.className = (clone.className + ' track-md').trim();
      }
      clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;';
      holder.appendChild(clone);
      document.body.appendChild(holder);
      var cleanup = function cleanup() {
        if (holder && holder.parentNode) {
          holder.parentNode.removeChild(holder);
        }
      };
      void clone.offsetHeight;
      var w = Math.max(clone.scrollWidth, width);
      var h = Math.max(clone.scrollHeight, clone.offsetHeight, 1);
      __WEBPACK_IMPORTED_MODULE_1_html2canvas___default()(clone, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        width: w,
        height: h,
        windowWidth: w,
        windowHeight: h
      }).then(function (canvas) {
        cleanup();
        var meta = self.meta || {};
        var stamp = String(meta.createTime || '').replace(/[^\d]/g, '');
        var link = document.createElement('a');
        link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        self.exportLoading = false;
        self.$Message.success('导出成功');
      }).catch(function () {
        cleanup();
        self.exportLoading = false;
        self.$Message.error('导出失败');
      });
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TrackContentPreview: __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue___default.a },
  data: function data() {
    var _this = this;

    return {
      nextHandler: [],
      uidReadonly: false,
      trackType: '',
      nextTimeDate: '',
      disable: false,
      aiLoading: false,
      contentVisible: false,
      contentHtml: '',
      contentRawText: '',
      contentViewMode: 'markdown',
      contentMeta: {},
      exportImageLoading: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        nextHandlerId: null,
        status: '0',
        traceType: '',
        nextHandlerTime: ''
      },
      ruleValidate: {
        uid: [{ validator: this.validateUid, trigger: 'blur' }, { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }, { type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur' }],
        traceType: [{ required: true, message: '属性不能为空', trigger: 'blur' }],
        nextHandlerId: [{ type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur' }]
      },
      userTrackRecordList: [],
      userTrackRecordColumns: [{
        title: '内容',
        minWidth: 220,
        key: 'content',
        render: function render(h, params) {
          var row = params.row;
          return h('TrackContentPreview', {
            props: { content: row.content },
            on: { view: function view() {
                return _this.openContentView(row);
              } }
          });
        }
      }, {
        title: '处理人',
        width: 100,
        key: 'nextHandlerName'
      }, {
        title: '处理时间',
        width: 100,
        key: 'createTime'
      }]
    };
  },
  created: function created() {
    this.disable = false;
    var uid = this.$route.query.uid;
    if (uid) {
      this.disable = true;
      this.formValidate.uid = parseInt(uid);
      var self = this;
      self.$http.get('/user/queryById?uid=' + uid).then(function (res) {
        if (res.data) {
          self.formValidate.nickname = res.data.nickname;
          self.formValidate.adviserName = res.data.adviserName;
          self.formValidate.studyAdviserName = res.data.studyAdviserName;
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var formValidate = this.formValidate;
    formValidate.id = this.$route.query.id;
    formValidate.traceType = this.$route.query.traceType;
    this.trackType = formValidate.traceType;
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });

    if (!this.formValidate.id || this.formValidate.id === '') {
      return;
    }
    self.uidReadonly = true;
    this.$http.get('/userTrack/queryById?id=' + this.formValidate.id).then(function (res) {
      if (!res || !res.data) {
        return;
      }
      var userTrack = res.data;
      formValidate.uid = userTrack.uid;
      formValidate.nickname = userTrack.nickname;
      formValidate.adviserName = userTrack.adviserName;
      formValidate.studyAdviserName = userTrack.studyAdviserName;
      if (!formValidate.traceType) {
        formValidate.traceType = userTrack.traceType;
      }
      self.listOldTrace(userTrack);
    });
  },

  methods: {
    openContentView: function openContentView(row) {
      if (!row || !row.content) {
        this.$Message.warning('暂无内容');
        return;
      }
      this.contentMeta = {
        uid: row.uid || this.formValidate.uid || '',
        id: row.id || '',
        createTime: row.createTime || ''
      };
      this.contentHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(row.content);
      this.contentRawText = row.contentRaw || '';
      this.contentViewMode = 'markdown';
      this.contentVisible = true;
    },
    switchContentView: function switchContentView() {},
    exportContentPng: function exportContentPng() {
      var el = this.$refs.contentExportArea;
      if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
        this.$Message.warning('暂无内容可导出');
        return;
      }
      this.exportImageLoading = true;
      var self = this;

      var width = Math.max(el.clientWidth || 0, 680);
      var holder = document.createElement('div');
      holder.setAttribute('data-track-png-export', '1');
      holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;';
      var clone = el.cloneNode(true);
      clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim();
      if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
        clone.className = (clone.className + ' track-md').trim();
      }
      clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;';
      holder.appendChild(clone);
      document.body.appendChild(holder);
      var cleanup = function cleanup() {
        if (holder && holder.parentNode) {
          holder.parentNode.removeChild(holder);
        }
      };
      void clone.offsetHeight;
      var w = Math.max(clone.scrollWidth, width);
      var h = Math.max(clone.scrollHeight, clone.offsetHeight, 1);
      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(clone, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        width: w,
        height: h,
        windowWidth: w,
        windowHeight: h
      }).then(function (canvas) {
        cleanup();
        var meta = self.contentMeta || {};
        var stamp = String(meta.createTime || '').replace(/[^\d]/g, '');
        var link = document.createElement('a');
        link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        self.exportImageLoading = false;
        self.$Message.success('导出成功');
      }).catch(function () {
        cleanup();
        self.exportImageLoading = false;
        self.$Message.error('导出失败');
      });
    },
    listOldTrace: function listOldTrace(val) {
      var self = this;
      if (val) {
        self.userTrackRecordList.push(val);
        if (val.traceNode) {
          self.listOldTrace(val.traceNode);
        }
      }
    },
    nextTimeDateChange: function nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value;
    },
    validateUid: function validateUid(rule, value, callback) {
      var self = this;
      var formValidate = self.formValidate;
      console.log(formValidate.uid);
      if (!value) {
        return callback();
      }
      self.$http.post('/user/queryById', { 'uid': value }).then(function (res) {
        var user = res.data;
        if (!user) {
          formValidate.nickname = '';
          formValidate.adviserName = '';
          formValidate.nextHandlerId = '';
          formValidate.studyAdviserName = '';
          return callback(new Error('学生ID不存在'));
        }
        formValidate.nickname = user.nickname || '';
        formValidate.adviserName = user.adviserName || '';
        formValidate.studyAdviserName = user.studyAdviserName || '';
        return callback();
      });
    },
    handleAiMarkdown: function handleAiMarkdown() {
      var self = this;
      var content = (self.formValidate.content || '').trim();
      if (!content) {
        self.$Message.warning('请先填写内容');
        return;
      }
      self.aiLoading = true;
      self.$http.post('/userTrack/aiMarkdown', { content: content }).then(function (res) {
        self.aiLoading = false;
        if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
          return;
        }
        var markdown = res.data.markdown;
        self.$Modal.confirm({
          title: '确认覆盖',
          content: '将用 AI 结果覆盖当前内容，是否继续？',
          onOk: function onOk() {
            if (!(self.formValidate.contentRaw || '').trim()) {
              self.formValidate.contentRaw = content;
            }
            self.formValidate.content = markdown;
            self.$Message.success('已用 AI 结果更新内容');
          }
        });
      }).catch(function () {
        self.aiLoading = false;
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
          if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
            self.$Message.warning('请填写下次联系人和下次联系日期!');
            return;
          }
        }
        var path = '/userTrack/update';
        if (!_this2.formValidate.id || _this2.formValidate.id === '') {
          path = '/userTrack/insert';
        }
        self.$http.post(path, self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!');
            localStorage.setItem('userTraceUid', self.formValidate.uid);
            self.$router.push('/user/personUserTrackList');
          }
        });
      });
    }
  },
  watch: {}
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_aiAccess__ = __webpack_require__(30);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TrackContentPreview: __WEBPACK_IMPORTED_MODULE_1__TrackContentPreview_vue___default.a,
    UserInfoModal: __WEBPACK_IMPORTED_MODULE_4__crm_UserInfoModal_vue___default.a,
    AiDrawer: __WEBPACK_IMPORTED_MODULE_5__components_ai_AiDrawer___default.a
  },
  data: function data() {
    var _this = this;

    var $constant = this.$constant;

    return {
      searchLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      contentVisible: false,
      contentHtml: '',
      contentRawText: '',
      contentViewMode: 'markdown',
      contentMeta: {},
      exportImageLoading: false,
      editUser: false,
      uid: null,
      addsTimeDate: '',
      addeTimeDate: '',
      queryParam: {
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        addStartTimeDate: '',
        addEndTimeDate: '',
        traceType: '',
        trackType: '',
        createName: '',
        startTime: '',
        endTime: '',
        addStartTime: '',
        addEndTime: ''
      },
      nextHandler: [],
      title: [{
        title: '学生ID/姓名',
        width: 180,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return h('a', { on: { click: function click() {
                return _this.openInfoModal(row.uid);
              } } }, row.uid + '-' + row.nickname);
        }
      }, {
        title: '添加时间',
        width: 170,
        align: 'center',
        key: 'createTime'
      }, {
        title: '记录属性',
        align: 'center',
        width: 170,
        render: function render(h, params) {
          var trackType = params.row.trackType;
          var traceTypeEnum = $constant.getEnum($constant.userTraceType, trackType);
          return h('span', traceTypeEnum && traceTypeEnum.text);
        }
      }, {
        title: '课程顾问',
        width: 110,
        align: 'center',
        key: 'adviserName',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.adviserName);
        }
      }, {
        title: '学导',
        width: 110,
        align: 'center',
        key: 'studyAdviserName',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.studyAdviserName);
        }
      }, {
        title: '内容',

        align: 'left',
        minWidth: 220,
        key: 'content',
        render: function render(h, params) {
          var row = params.row;
          return h('TrackContentPreview', {
            props: { content: row.content },
            on: { view: function view() {
                return _this.openContentView(row);
              } }
          });
        }
      }, {
        title: '下次联系日期',
        width: 120,
        align: 'center',
        render: function render(h, params) {
          var content = params.row.nextHandlerTime;
          if (!content || content === '0000-00-00 00:00:00') {
            return h('span', '0');
          }
          return h('Poptip', {
            props: {
              trigger: 'hover',
              placement: 'top',
              transfer: true
            }
          }, [h('span', {
            style: {
              display: 'inline-block',
              width: '100px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              verticalAlign: 'middle'
            }
          }, content), h('div', {
            slot: 'content',
            style: {
              maxWidth: '360px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              textAlign: 'left'
            }
          }, content)]);
        }
      }, {
        title: '下次联系人',
        width: 110,
        align: 'center',
        key: 'nextHandlerName',
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.nextHandlerName);
        }
      }, {
        title: '操作人',
        width: 110,
        align: 'center',
        key: 'createName'
      }, {
        title: '操作',
        width: 140,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          return 'span', [h('a', { on: { click: function click() {
                return _this.showMore(row.uid);
              } } }, '更多'), _this.aiAllowed ? h('br') : null, _this.aiAllowed ? h('a', { on: { click: function click() {
                return _this.openAiDrawer(row.uid);
              } } }, 'AI') : null];
        }
      }]
    };
  },

  mounted: function mounted() {
    var self = this;
    var query = self.$route.query;
    if (query.addStartTime) {
      this.addsTimeDate = parseInt(query.addStartTime) * 1000;
    }
    if (query.addEndTime) {
      this.addeTimeDate = parseInt(query.addEndTime) * 1000;
    }
    this.$http.post('/adminUser/listByCondition', { status: 1 }).then(function (res) {
      self.nextHandler = res.data;
    });
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tools_aiAccess__["a" /* bindAiAllowed */])(this);
    var row = this.$route.query.row;
    if (row) {
      this.queryParam.uid = row.uid;
    }
  },
  methods: {
    closeModal: function closeModal(val) {
      this.uid = null;
      this.editUser = val;
    },
    openInfoModal: function openInfoModal(val) {
      this.uid = val;

      var _$router$resolve = this.$router.resolve({
        name: 'userPayDetail',
        query: { uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserTrackList' } }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    showMore: function showMore(uid) {
      localStorage.setItem('userTraceUid', uid);
      this.$router.push({ path: '/user/personUserTrackList' });
    },
    getTrackType: function getTrackType(type) {
      var typeNum = __WEBPACK_IMPORTED_MODULE_3__tools_commonUtils_js___default.a.getShortNumByTraceType(type);
      var typeName = this.$constant.getEnum(this.$constant.userTraceType, typeNum);
      return typeName && typeName.text;
    },
    openContentView: function openContentView(row) {
      if (!row || !row.content) {
        this.$Message.warning('暂无内容');
        return;
      }
      this.contentMeta = {
        uid: row.uid || '',
        id: row.id || '',
        createTime: row.createTime || ''
      };
      this.contentHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_simpleMarkdown__["a" /* renderSimpleMarkdown */])(row.content);
      this.contentRawText = row.contentRaw || '';
      this.contentViewMode = 'markdown';
      this.contentVisible = true;
    },
    switchContentView: function switchContentView() {},
    exportContentPng: function exportContentPng() {
      var el = this.$refs.contentExportArea;
      if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
        this.$Message.warning('暂无内容可导出');
        return;
      }
      this.exportImageLoading = true;
      var self = this;

      var width = Math.max(el.clientWidth || 0, 680);
      var holder = document.createElement('div');
      holder.setAttribute('data-track-png-export', '1');
      holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;';
      var clone = el.cloneNode(true);
      clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim();
      if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
        clone.className = (clone.className + ' track-md').trim();
      }
      clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;';
      holder.appendChild(clone);
      document.body.appendChild(holder);
      var cleanup = function cleanup() {
        if (holder && holder.parentNode) {
          holder.parentNode.removeChild(holder);
        }
      };
      void clone.offsetHeight;
      var w = Math.max(clone.scrollWidth, width);
      var h = Math.max(clone.scrollHeight, clone.offsetHeight, 1);
      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(clone, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        width: w,
        height: h,
        windowWidth: w,
        windowHeight: h
      }).then(function (canvas) {
        cleanup();
        var meta = self.contentMeta || {};
        var stamp = String(meta.createTime || '').replace(/[^\d]/g, '');
        var link = document.createElement('a');
        link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        self.exportImageLoading = false;
        self.$Message.success('导出成功');
      }).catch(function () {
        cleanup();
        self.exportImageLoading = false;
        self.$Message.error('导出失败');
      });
    },
    openAiDrawer: function openAiDrawer(uid) {
      this.aiUid = uid;
      this.aiVisible = true;
    },
    onAiClose: function onAiClose() {
      this.aiVisible = false;
      this.aiUid = null;
    },
    onAiExecuted: function onAiExecuted() {
      this.reload = new Date().getTime();
    },
    search: function search() {
      if (this.queryParam.uid) {
        this.showMore(this.queryParam.uid);
        return;
      }
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    },
    onSelection: function onSelection(selection) {
      this.selection = selection;
    },
    delAll: function delAll() {
      this.$refs.dataList.delAll();
    },
    startTimeDateChange: function startTimeDateChange(value) {
      if (value) {
        this.queryParam.startTime = Date.parse(new Date(value)) / 1000 - 28800;
      } else {
        this.queryParam.startTime = '';
      }
    },
    endTimeDateChange: function endTimeDateChange(value) {
      if (value) {
        this.queryParam.endTime = Date.parse(new Date(value)) / 1000 + 57599;
      } else {
        this.queryParam.endTime = '';
      }
    },
    addStartTimeDateChange: function addStartTimeDateChange(value) {
      if (value) {
        this.queryParam.addStartTime = Date.parse(new Date(value)) / 1000 - 28800;
      } else {
        this.queryParam.addStartTime = '';
      }
    },
    addEndTimeDateChange: function addEndTimeDateChange(value) {
      if (value) {
        this.queryParam.addEndTime = Date.parse(new Date(value)) / 1000 + 57599;
      } else {
        this.queryParam.addEndTime = '';
      }
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal___default.a },
  name: 'UserTrialLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      trialLessonParam: {
        uid: null,
        tchId: '',
        category: '',
        channel: '1',
        accent: '',
        sex: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        lsnType: 1,
        schoolId: 0
      },
      timeStr: '',
      timePickerKey: 0,
      ruleTrialLesson: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.trialLessonParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            var lsnBeginTime = self.getLsnBeginTime();
            var nowTime = new Date().getTime() / 1000;
            if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            callback();
          }
        }]
      },
      tchId: null,
      showTchInfoModal: false,
      tId: '',
      tchName: ''
    };
  },

  methods: {
    tchAvatarSrc: function tchAvatarSrc(avatar) {
      return __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default.a.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
    },
    secondsFromPicker: function secondsFromPicker() {
      var val = this.timeStr;
      if (val instanceof Date && !isNaN(val.getTime())) {
        return val.getHours() * 3600 + val.getMinutes() * 60;
      }
      if (typeof val === 'string' && val.indexOf(':') !== -1) {
        return parseInt(this.$dateUtil.getSecondByHm(val), 10);
      }
      return '';
    },
    syncPickerTime: function syncPickerTime() {
      var sec = this.secondsFromPicker();
      this.trialLessonParam.time = sec === '' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(sec) ? '' : sec;
    },
    insertTrialLesson: function insertTrialLesson() {
      var self = this;
      self.syncPickerTime();
      self.loadingConfirm = true;
      self.$refs.trialLessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingConfirm = false;
          return;
        }
        self.trialLessonParam.lsnBeginTime = self.getLsnBeginTime();
        self.$http.post('/user/lesson/addCourse', self.trialLessonParam).then(function (res) {
          self.loadingConfirm = false;
          if (res) {
            self.$Message.success('约课成功!');
            self.visible = false;
          }
        });
      });
    },
    searchTch: function searchTch(courseType) {
      var self = this;
      self.syncPickerTime();
      var isNotError = true;
      self.$refs.trialLessonForm.validateField('lsnBeginDayTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      self.tchList = [];
      var path = '/tch/time/queryFreeNotChineseTch?isAudition=y&lsnBeginTime=' + self.getLsnBeginTime() + '&timeLength=' + self.trialLessonParam.timeLength + '&tchType=1' + '&uid=' + self.trialLessonParam.uid;
      if (self.tId) {
        path = path + '&tchId=' + self.tId;
      }
      if (self.trialLessonParam.category) {
        path = path + '&category=' + self.trialLessonParam.category;
      }
      if (self.trialLessonParam.suitableLevel) {
        path = path + '&suitableLevel=' + self.trialLessonParam.suitableLevel;
      }
      if (self.trialLessonParam.channel) {
        path = path + '&channel=' + self.trialLessonParam.channel;
      }
      if (self.trialLessonParam.accent) {
        path = path + '&accent=' + self.trialLessonParam.accent;
      }
      if (self.trialLessonParam.sex) {
        path = path + '&sex=' + self.trialLessonParam.sex;
      }
      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data;
        }
        self.loadingSearch = false;
      });
    },
    onChangeTime: function onChangeTime(val) {
      this.trialLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
      this.clearTchList();
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.trialLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
      this.clearTchList();
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    loadTimeLengthList: function loadTimeLengthList(val) {
      var self = this;
      self.$http.get('/user/lesson/timeLengthList?uid=' + val).then(function (res) {
        if (res && res.data) {
          self.timeLengthList = res.data;

          if (self.timeLengthList && self.timeLengthList.length > 0) {
            self.trialLessonParam.timeLength = self.timeLengthList[0].code;
          }
        } else {
          if (self.user.tchChannel === 1) {
            self.timeLengthList = [{ code: 25, text: '25' }];
            self.trialLessonParam.timeLength = 25;
          } else {
            self.timeLengthList = [{ code: 25, text: '25' }];
            self.trialLessonParam.timeLength = 25;
          }
        }
      }).catch(function (error) {
        console.error('获取时长列表失败:', error);
        if (self.user.tchChannel === 1) {
          self.timeLengthList = [{ code: 25, text: '25' }];
          self.trialLessonParam.timeLength = 25;
        } else {
          self.timeLengthList = [{ code: 25, text: '25' }];
          self.trialLessonParam.timeLength = 25;
        }
      });
    },
    changeLevel: function changeLevel(val) {
      if (!val) {
        return;
      } else {
        var self = this;
        self.bookMaterialLessonsList = null;
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return;
          }
          self.bookMaterialLessonsList = res.data;
        });
      }
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.trialLessonParam.lsnBeginDayTime) + parseInt(this.trialLessonParam.time);
    },
    clearTchList: function clearTchList() {
      this.tchList = [];
      this.trialLessonParam.tchId = '';
    },
    showTchMessage: function showTchMessage(id) {
      this.tchId = parseInt(id);
      this.showTchInfoModal = true;
    },
    updateTchInfoSuccess: function updateTchInfoSuccess() {
      this.showTchInfoModal = false;
    },
    onTchChange: function onTchChange(id, name) {
      this.tchName = name;
      if (id) {
        this.searchTch();
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.loadingConfirm = false;
        this.loadBookMaterialLevel();
        this.loadTimeLengthList(this.user.id);
        this.$refs['trialLessonForm'].resetFields();
        this.trialLessonParam.uid = this.user.id;
        this.trialLessonParam.nickname = this.user.nickname;
        this.trialLessonParam.mobile = this.user.mobile;

        var now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.trialLessonParam.lsnBeginTimeDate = now;
        this.trialLessonParam.lsnBeginDayTime = now.getTime() / 1000;
        this.timeStr = '18:00';
        this.trialLessonParam.time = 18 * 3600;
        this.timePickerKey += 1;
        this.clearTchList();
      } else {
        this.tId = '';
        this.tchName = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      saveLoading: false,
      reload: 0,
      showModal: false,
      defaultFileList: [],
      queryParam: {
        word: '',
        status: null
      },
      formData: this.emptyForm(),
      formRules: {
        word: [{ required: true, message: '请输入单词' }]
      },
      title: [{
        title: '单词',
        minWidth: 120,
        render: function render(h, params) {
          var row = params.row;
          return h('span', row.displayWord || row.word || '');
        }
      }, { title: '英文释义', minWidth: 180, key: 'enDef' }, { title: '例句', minWidth: 200, key: 'exampleSentence' }, {
        title: '例句音频',
        minWidth: 200,
        render: function render(h, params) {
          var url = params.row.exampleAudio;
          if (!url) {
            return h('span', '');
          }
          return h('audio', {
            attrs: { src: url, controls: 'controls', preload: 'none' },
            style: { width: '180px', height: '32px' }
          });
        }
      }, {
        title: '状态',
        width: 90,
        render: function render(h, params) {
          var row = params.row;
          if (row.statusText) {
            return h('span', row.statusText);
          }
          return h('span', row.status === 1 ? '启用' : '停用');
        }
      }, { title: '修改时间', minWidth: 160, key: 'gmtModified' }, {
        title: '操作',
        width: 160,
        render: function render(h, params) {
          var row = params.row;
          var btns = [];
          if (row.status === 1 || row.statusText === '启用') {
            btns.push(h('Button', {
              props: { type: 'warning', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 0);
                } }
            }, '停用'));
          } else {
            btns.push(h('Button', {
              props: { type: 'success', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: function click() {
                  return _this.changeStatus(row, 1);
                } }
            }, '启用'));
          }
          btns.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            on: { click: function click() {
                return _this.openModal(row);
              } }
          }, '编辑'));
          return h('div', btns);
        }
      }]
    };
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        word: '',
        enDef: '',
        exampleSentence: '',
        exampleAudio: '',
        status: 1
      };
    },
    openModal: function openModal(row) {
      if (row) {
        this.formData = {
          id: row.id,
          word: row.word || row.displayWord || '',
          enDef: row.enDef || '',
          exampleSentence: row.exampleSentence || '',
          exampleAudio: row.exampleAudio || '',
          status: row.status == null ? 1 : row.status
        };
        var url = row.exampleAudio;
        this.defaultFileList = url ? [{ name: row.exampleAudioName || url, url: url, status: 'finished' }] : [];
      } else {
        this.formData = this.emptyForm();
        this.defaultFileList = [];
      }
      this.showModal = true;
    },
    onFileChange: function onFileChange(files) {
      if (files && files.length) {
        this.formData.exampleAudio = files[0].url;
      } else {
        this.formData.exampleAudio = '';
      }
    },
    onSave: function onSave() {
      if (!this.formData.word) {
        this.$Message.warning('请输入单词');
        return;
      }
      var self = this;
      self.saveLoading = true;
      self.$http.post('/wordCard/save', {}, {
        transformRequest: [function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.saveLoading = false;
        if (res.status === 'ok') {
          self.$Message.success('保存成功');
          self.showModal = false;
          self.search();
        }
      }).catch(function () {
        self.saveLoading = false;
      });
    },
    changeStatus: function changeStatus(row, status) {
      var self = this;
      self.$http.post('/wordCard/updateStatus', { id: row.id, status: status }).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('操作成功');
          self.search();
        }
      });
    },
    search: function search() {
      this.reload = new Date().getTime();
    },
    onLoading: function onLoading(loading) {
      this.searchLoading = loading;
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignUserStudyAdviserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loadingAssignAdviser: false,
      visible: false,
      adviserParam: {
        studyAdviserId: null,
        reason: ''
      },
      adviserRule: {
        studyAdviserId: [{ type: 'integer', required: true, message: '请选择学习导师', trigger: 'blur' }],
        reason: [{ type: 'string', required: true, message: '请选择分配原因', trigger: 'blur' }]
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;

      self.$refs.assignAdviserForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.userList.map(function (element) {
          return element.id;
        });
        self.loadingAssignAdviser = true;
        var params = { ids: idList.join(','), studyAdviserId: self.adviserParam.studyAdviserId, reason: self.adviserParam.reason };
        self.$http.get('/user/updateStudyAdviser', { params: params }).then(function (res) {
          self.successCallback();
          self.visible = false;
          self.loadingAssignAdviser = false;
        }).catch(function (e) {
          self.visible = false;
          self.loadingAssignAdviser = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.adviserParam.studyAdviserId = null;
        this.$emit('on-close');
      }
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignUserStudyAdviserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      loadingAssignAdviser: false,
      visible: false,
      adviserParam: {
        studyAdviserId: null,
        reason: ''
      },
      adviserRule: {
        studyAdviserId: [{ type: 'integer', required: true, message: '请选择学习导师', trigger: 'blur' }],
        reason: [{ type: 'string', required: true, message: '请选择分配原因', trigger: 'blur' }]
      }
    };
  },

  methods: {
    assignAdviser: function assignAdviser() {
      var self = this;
      self.$refs.assignAdviserForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var idList = self.userList.map(function (element) {
          return element.id;
        });
        self.loadingAssignAdviser = true;
        var params = { ids: idList.join(','), studyAdviserId: self.adviserParam.studyAdviserId, reason: self.adviserParam.reason };
        self.$http.get('/user/allotStudyAdviser', { params: params }).then(function (res) {
          if (res) {
            self.successCallback();
            self.visible = false;
          }
          self.loadingAssignAdviser = false;
        }).catch(function (e) {
          self.visible = false;
          self.loadingAssignAdviser = false;
        });
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (!val) {
        this.adviserParam.studyAdviserId = null;
        console.log(this.adviserParam);
        this.$emit('on-close');
      }
    }
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BindTchModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      defaultPicList: [],
      visible: this.value,
      timeLengthList: [{ code: 25, text: '25' }],
      loadingBind: false,
      loadingCheck: false,
      checkSeq: 0,
      bookMaterialLevelList: null,
      limitMonthTimes: '11111',
      workTimeList: [],
      removeReasonList: [],
      showDelReasonModal: false,
      pendingDelIndex: null,
      pendingDelReason: null,
      formData: {
        attachment: '',
        uid: '',
        nickname: '',
        mobile: '',
        tchId: null,
        tchName: '',
        levelId: null,
        week: '',
        startTime: '',
        timeLength: 25,
        useDate: '',
        schoolId: 0
      },
      formRule: {
        tchId: [{ type: 'integer', required: true, message: '请选择老师', trigger: 'change' }],
        week: [{ type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }],
        startTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }],
        timeLength: [{ type: 'integer', required: true, message: '请选择时长', trigger: 'change' }],
        useDate: [{ required: true, message: '请选择生效日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            var startTime = self.formData.startTime;
            if (startTime === '') {
              callback(errors);
              return;
            }
            var nowTime = new Date().getTime() / 1000;
            if (nowTime >= parseInt(value) + parseInt(startTime)) {
              errors.push('生效日期应在当前日期之后');
              callback(errors);
              return;
            }
          }
        }],
        workTime: [{
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            var workTimeList = self.workTimeList;
            var week = self.formData.week;
            var startTime = self.formData.startTime;
            var timeLength = self.formData.timeLength;
            var useDate = self.formData.useDate;
            if (week === '' || startTime === '' || timeLength === '' || useDate === '') {
              return;
            }
            var endTime = parseInt(startTime) + parseInt(timeLength) * 60;
            workTimeList.forEach(function (element) {
              var tmpWeek = element.week;
              var tmpStratTime = element.startTime;
              var tmpEndTime = parseInt(tmpStratTime) + parseInt(element.timeLength) * 60;
              if (week === tmpWeek && (tmpStratTime < startTime && tmpEndTime > startTime || tmpStratTime < endTime && tmpEndTime > endTime || tmpStratTime >= startTime && tmpEndTime <= endTime)) {
                errors.push('添加的时间与 ' + element.weekStr + ' ' + element.startTimeStr + ' 冲突');
              }
            });
            callback(errors);
          }
        }],
        workTimeList: []
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(fileList) {
      this.defaultPicList = fileList;
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    bindCheckParams: function bindCheckParams() {
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.formData);
      var ids = [];
      this.removeReasonList.forEach(function (item) {
        if (item && item.tchId != null && ids.indexOf(item.tchId) < 0) {
          ids.push(item.tchId);
        }
      });
      if (ids.length) {
        params.unbindTchIds = ids.join(',');
      }
      return params;
    },
    checkTchTimeConflict: function checkTchTimeConflict() {
      var self = this;
      var formData = self.formData;
      if (!formData.tchId || !formData.week || formData.startTime == null || formData.startTime === '' || !formData.timeLength || !formData.useDate) {
        return;
      }
      self.checkSeq++;
      var seq = self.checkSeq;
      self.$http.get('/bookWordLessonOpenedTime/checkBindTch', {
        params: self.bindCheckParams(),
        silent: true
      }).then(function (res) {
        if (seq !== self.checkSeq) {
          return;
        }
        if (!res || res.status !== 'ok' || !res.data) {
          if (res && res.msg) {
            self.$Message.error(res.msg);
          }
        }
      });
    },
    addWorkTime: function addWorkTime() {
      var self = this;
      var isNotError = true;
      self.loadingCheck = true;
      self.$refs.modalForm.validateField('tchId', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.modalForm.validateField('week', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.modalForm.validateField('startTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.modalForm.validateField('timeLength', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.modalForm.validateField('useDate', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.modalForm.validateField('workTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) {
        self.loadingCheck = false;
        return;
      }

      self.$http.get('/bookWordLessonOpenedTime/checkBindTch', { params: self.bindCheckParams() }).then(function (res) {
        self.loadingCheck = false;
        if (!res) {
          return;
        } else if (res && res.data) {
          var buildWorkTime = function buildWorkTime() {
            var workTime = {};
            workTime.week = self.formData.week;
            workTime.weekStr = self.$constant.weekZh[self.formData.week];
            workTime.startTime = self.formData.startTime;
            workTime.startTimeStr = self.formData.startTimeStr;
            workTime.timeLength = self.formData.timeLength;
            workTime.useDate = self.formData.useDate;
            workTime.useDateStr = self.formData.useDateStr;
            workTime.tchId = self.formData.tchId;
            workTime.tchName = self.formData.tchName;
            workTime.levelId = self.formData.levelId;
            workTime.levelTitle = self.getLevelName(self.formData.levelId);
            workTime.endDate = res.data.endDate || 0;
            self.workTimeList.push(workTime);
          };
          if (res.data.endDate) {
            var endDateStr = self.$moment(res.data.endDate, 'X').format('YYYY-MM-DD');
            self.$Modal.confirm({
              title: '提示',
              content: '该时间段为短期固定时间，有效期至 ' + endDateStr + '，系统排课截至 ' + endDateStr + '，到期自动解绑无法排课，确认绑定？',
              width: 420,
              okText: '确认绑定',
              loading: true,
              onOk: function onOk() {
                self.$Modal.remove();
                if (res.data.message) {
                  self.$Modal.confirm({
                    title: '警告:',
                    content: res.data.message,
                    width: 300,
                    okText: '确认选择',
                    loading: true,
                    onOk: function onOk() {
                      buildWorkTime();
                      self.$Modal.remove();
                    }
                  });
                } else {
                  buildWorkTime();
                }
              }
            });
          } else if (res.data.message) {
            self.$Modal.confirm({
              title: '警告:',
              content: res.data.message,
              width: 300,
              okText: '确认选择',
              loading: true,
              onOk: function onOk() {
                buildWorkTime();
                self.$Modal.remove();
              }
            });
          } else {
            self.$Message.success('校验通过!');
            buildWorkTime();
          }
        } else {
          self.$Message.error(res.message);
        }
      });
    },
    removeWorkTime: function removeWorkTime(index) {
      var item = this.workTimeList[index];

      if (!item || !item.id) {
        this.workTimeList.splice(index, 1);
        return;
      }
      this.pendingDelIndex = index;
      this.pendingDelReason = null;
      this.showDelReasonModal = true;
    },
    cancelDelReason: function cancelDelReason() {
      this.showDelReasonModal = false;
      this.pendingDelIndex = null;
      this.pendingDelReason = null;
    },
    confirmDelReason: function confirmDelReason() {
      if (!this.pendingDelReason) {
        this.$Message.warning('请选择删除原因');
        return;
      }
      var index = this.pendingDelIndex;
      var item = this.workTimeList[index];
      if (!item) {
        this.cancelDelReason();
        return;
      }
      this.removeReasonList.push({
        tchId: item.tchId,
        week: item.week,
        startTime: item.startTime,
        endTime: item.endTime,
        levelId: item.levelId,
        delReason: this.pendingDelReason
      });
      this.workTimeList.splice(index, 1);
      this.cancelDelReason();
    },
    bindWorkTime: function bindWorkTime() {
      var self = this;
      self.loadingBind = true;
      for (var i = 0; i < self.removeReasonList.length; i++) {
        var reason = self.removeReasonList[i].delReason;
        if ([1, 2, 3, 4, 5, 6].indexOf(reason) < 0) {
          self.$Message.warning('请选择删除原因');
          self.loadingBind = false;
          return;
        }
      }

      var params = {};
      params.uid = self.formData.uid;
      params.levelId = self.formData.levelId;
      params.workTimeList = self.workTimeList;
      params.schoolId = self.formData.schoolId;
      params.attachment = self.formData.attachment;
      params.removeReasonList = self.removeReasonList;
      self.$http.post('/bookWordLessonOpenedTime/addBindTch', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingBind = false;
        if (res.status === 'ok') {
          self.$Message.success(res.data);
          self.visible = false;
          if (self.successCallback !== undefined) {
            self.successCallback();
          }
        }
      });
    },
    onChangeStratTime: function onChangeStratTime(val) {
      this.formData.startTime = this.$dateUtil.getSecondByHm(val);
      this.formData.startTimeStr = val;
      this.checkTchTimeConflict();
    },
    onChangeUseDate: function onChangeUseDate(val) {
      this.formData.useDate = val && this.$moment(val, 'YYYY-M-D').format('X');
      this.formData.useDateStr = val;
      this.checkTchTimeConflict();
    },
    onChangeWeek: function onChangeWeek(val) {
      this.formData.week = val;
      this.checkTchTimeConflict();
    },
    onChangeTimeLength: function onChangeTimeLength(val) {
      this.formData.timeLength = val;
      this.checkTchTimeConflict();
    },
    loadBindTch: function loadBindTch() {
      var loadMsg = this.$Message.loading({
        content: '正在加载中...',
        duration: 0
      });
      var self = this;

      self.$http.get('/bookWordLessonOpenedTime/getBindTch?uid=' + self.formData.uid).then(function (res) {
        loadMsg();
        self.visible = true;
        self.limitMonthTimes = res.data.limitMonthTimes;
        if (!res || !res.data || res.data.workTimeList.length === 0) {
          return;
        }
        var data = res.data;
        self.formData.schoolId = data.schoolId;
        self.workTimeList = data.workTimeList;
        self.removeReasonList = [];
        self.workTimeList.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week];
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm');
          element.timeLength = (element.endTime - element.startTime) / 60;
          element.useDateStr = self.$moment(element.useDate, 'X').format('YYYY-MM-DD');

          if (!element.levelId) element.levelId = data.levelId;
        });
      });
    },
    getLevelName: function getLevelName(levelId) {
      if (!levelId) return '';
      if (!this.bookMaterialLevelList) return levelId;
      var item = this.bookMaterialLevelList.find(function (l) {
        return l.id === levelId;
      });
      return item ? item.title : levelId;
    },
    onTchSelect: function onTchSelect(tch) {
      if (tch) {
        this.formData.tchId = tch.id;
        this.formData.tchName = tch.firstName + ' ' + tch.lastName;
        this.checkTchTimeConflict();
      } else {
        this.formData.tchId = null;
        this.formData.tchName = '';

        this.checkSeq++;
      }
    },
    onClose: function onClose() {
      this.$emit('on-close');
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.formData.uid = this.user.id;
        this.formData.nickname = this.user.nickname;
        this.formData.mobile = this.user.mobile;
        this.loadBookMaterialLevel();
        this.loadBindTch();
      } else {
        this.formData = {
          attachment: '',
          uid: '',
          nickname: '',
          mobile: '',
          tchId: null,
          tchName: '',
          levelId: null,
          week: '',
          startTime: '',
          timeLength: 25,
          startTimeStr: '',
          useDate: '',
          useDateStr: '',
          schoolId: 0
        };
        this.workTimeList = [];
        this.removeReasonList = [];
        this.showDelReasonModal = false;
        this.pendingDelIndex = null;
        this.pendingDelReason = null;
        this.checkSeq++;
        this.$refs.modalForm.resetFields();
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CourseSchedulingModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    var $moment = this.$moment;
    return {
      visible: this.value,
      loadingAdd: false,
      bookLessonOpenedList: [],
      bookLessonOpenedColumn: [{
        title: '日期',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var week = params.row.week;
          return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD') + ' ' + $constant.weekZh[week]);
        }
      }, {
        title: '时间',
        align: 'center',
        width: 100,
        render: function render(h, params) {
          var lsnBeginTime = params.row.lsnBeginTime;
          var lsnEndTime = params.row.lsnEndTime;
          return h('span', $moment(lsnBeginTime, 'X').format('HH:mm') + ' - ' + $moment(lsnEndTime, 'X').format('HH:mm'));
        }
      }, {
        title: '老师',
        align: 'center',
        width: 120,
        render: function render(h, params) {
          if (params.row.tchFirstName || params.row.tchLastName) {
            return h('span', params.row.tchFirstName + ' ' + params.row.tchLastName);
          } else {
            return h('span', '');
          }
        }
      }, {
        title: '状态',
        width: 85,
        align: 'center',
        render: function render(h, params) {
          var lsnSelStatus = params.row.lsnSelStatus;
          var statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus);
          return h('span', statusEnum && statusEnum.text);
        }
      }, {
        title: '等级名称',
        width: 120,
        key: 'levelTitleEn'
      }, {
        title: '课程名称',
        key: 'lessonTitle'
      }],
      bookUserPackage: {},

      user: {},
      scheduleIndexList: [],
      bookMaterialLevelList: null,
      courseScheduleListData: [],
      bookMaterialLessonsList: [],
      bookMaterialLessonsListCache: []
    };
  },

  methods: {
    add: function add() {
      var self = this;
      self.loadingAdd = true;
      var courseScheduleListDataTmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.courseScheduleListData));
      var courseScheduleListData = [];
      self.scheduleIndexList.forEach(function (element) {
        var courseSchedule = courseScheduleListDataTmp[element];
        delete courseSchedule.bookMaterialLessonsList;
        courseScheduleListData.push(courseSchedule);
      });
      self.$http.post('/user/lesson/addCourseSchedule', {}, {
        transformRequest: [function (data, headers) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(courseScheduleListData);
        }],
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(function (res) {
        self.loadingAdd = false;
        if (res) {
          self.$Message.success('排课成功!');
          self.visible = false;
          return;
        }
      }).catch(function (e) {
        self.loadingAdd = false;
      });
    },
    onLoad: function onLoad() {
      var self = this;
      var loadMsg = this.$Message.loading('正在加载中...', 0);
      self.$http.get('/user/lesson/queryCourseSchedule', { params: { uid: self.uid } }).then(function (res) {
        loadMsg();
        if (!res || !res.data) {
          self.$emit('input', false);
          return;
        }
        var data = res.data;
        self.bookUserPackage = data.bookUserPackage;
        self.bookLessonOpenedList = data.historyLesson;

        self.user = data.user;
        self.courseScheduleListData = data.courseSchedule;
        var scheduleIndex = 0;
        var scheduleIndexList = [];
        self.courseScheduleListData.forEach(function (element) {
          self.bookMaterialLessonsList = data.bookMaterialLessonsList;
          scheduleIndexList.push(scheduleIndex++);
          element.uid = self.user.id;
          element.classType = '1';
        });

        self.scheduleIndexList = scheduleIndexList;

        self.visible = true;
      });
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    onBookMaterialLevelChange: function onBookMaterialLevelChange(val, index) {
      var self = this;
      if (val.levelId === '' || val.levelId === null || val.levelId === undefined) {
        return;
      }
      this.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val.levelId).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        val.lessonId = '';
        self.bookMaterialLessonsList.splice(index, 1, res.data);
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.onLoad();
        this.loadBookMaterialLevel();
      } else {
        this.$emit('on-close', val);
        this.scheduleIndexList = [];
        this.bookMaterialLevelList = null;
        this.courseScheduleListData = [];
        this.bookMaterialLessonsList = [];
        this.bookMaterialLessonsList = [];
        this.bookMaterialLessonsListCache = [];
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_multipleImageUpload_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_multipleImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_multipleImageUpload_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditOverRemarkModal',
  components: {
    multipleImageUpload: __WEBPACK_IMPORTED_MODULE_0__common_multipleImageUpload_vue___default.a
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      attendanceRowThis: {},
      attachmentFileList: []
    };
  },

  methods: {
    editSalary: function editSalary() {
      var self = this;
      self.loadingEditSalary = true;

      if (this.attendanceRowThis.attachmentUrls && Array.isArray(this.attendanceRowThis.attachmentUrls)) {
        this.attendanceRowThis.attachmentUrlsStr = this.attendanceRowThis.attachmentUrls.join(',');
      }
      self.$http.post('/tch/lesson/add-std-over-remark', this.attendanceRowThis).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('成功!');
          self.visibleThis = false;
          self.loadingEditSalary = false;
          self.successCallback();
        }
      }).catch(function (e) {
        self.loadingEditSalary = false;
      });
    },
    handleAttachmentChange: function handleAttachmentChange(files) {
      this.attendanceRowThis.attachmentUrls = files.map(function (file) {
        return file.url;
      });
    }
  },
  watch: {
    visible: function visible(val) {
      this.visibleThis = val;
    },
    visibleThis: function visibleThis(val) {
      if (!val) {
        this.attendanceRowThis = {};
        this.$emit('on-close', val);
      }
    },
    complaintRow: function complaintRow(val) {
      var _this = this;

      this.attendanceRowThis = val;

      this.attachmentFileList = [];
      if (val.attachmentUrlsStr) {
        var urls = val.attachmentUrlsStr.split(',');
        this.attachmentFileList = urls.filter(function (url) {
          return url;
        }).map(function (url, index) {
          return {
            uid: Date.now() + index,
            name: 'image_' + index + '.jpg',
            url: url,
            status: 'finished'
          };
        });

        this.$set(this.attendanceRowThis, 'attachmentUrls', urls.filter(function (url) {
          return url;
        }));
      } else {
        this.$set(this.attendanceRowThis, 'attachmentUrls', []);
      }

      if (this.attendanceRowThis.status === 0) {
        this.complaintRemarkList.forEach(function (item) {
          if (item.text === val.remark) {
            _this.attendanceRowThis.stdNum = item.stdNum;
            _this.attendanceRowThis.tchNum = item.tchNum;
            _this.attendanceRowThis.subSalary = item.subSalary;
          }
        });
      }
    }
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InsertUserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $constant = this.$constant;

    return {
      visible: this.value,
      userListStatusList: $constant.userListStatus,
      regTypes: $constant.studentCanal,
      sexList: $constant.sex,
      bookMaterialLevelList: null,
      loadingInsertUser: false,
      defaultPicList: [],
      adviserList: [],
      insertUserParam: {
        areaNum: 86,
        nickname: '',
        wechatAccount: '',
        mobile: '',
        password: '',
        sex: 1,
        regType: '',
        adviserId: 0,
        inviteId: '',
        schoolId: 0,
        remark: '',
        files: ''
      },
      ruleUser: {
        nickname: [{ type: 'string', required: true, message: '昵称不能为空', trigger: 'blur' }, { type: 'string', min: 1, max: 20, message: '昵称应为1-20个字', trigger: 'blur' }],
        mobile: [],
        regType: [{ type: 'string', required: false, message: '渠道不能为空', trigger: 'blur' }],
        inviteId: [{ type: 'number', required: true, message: '推荐ID不能为空' }]
      }
    };
  },

  methods: {
    insertUser: function insertUser() {
      var self = this;
      self.loadingInsertUser = true;

      if (!self.insertUserParam.regType) {
        self.$Message.warning('渠道不能为空!');
        self.loadingInsertUser = false;
        return;
      }

      self.$refs.insertUserForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingInsertUser = false;
          return;
        }
        if (self.insertUserParam.mobile !== '' && self.insertUserParam.areaNum !== undefined && self.insertUserParam.areaNum !== 86) {
          self.insertUserParam.mobile = '00' + self.insertUserParam.areaNum + '-' + self.insertUserParam.mobile;
        }
        self.$http.post('/user/bopsInsert', self.insertUserParam).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
          }
          self.loadingInsertUser = false;
        }).catch(function (e) {
          self.showInsertUserModal = false;
          self.loadingInsertUser = false;
        });
      });
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
      });
    },
    getAdviserList: function getAdviserList() {
      var self = this;
      self.adviserList = [];
      self.$http.get('/adviser/listNoPage').then(function (res) {
        if (res && res.data) {
          self.adviserList = res.data;
        }
      });
    },
    onAreaNumChange: function onAreaNumChange(val) {
      this.insertUserParam.areaNum = val;
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      var lastRegType = this.insertUserParam.regType;
      if (val === true) {
        this.insertUserParam = {
          areaNum: 86,
          nickname: '',
          wechatAccount: '',
          mobile: '',
          password: '',
          sex: 1,
          regType: lastRegType,
          adviserId: 0,
          inviteId: '',
          schoolId: 0,
          remark: '',
          files: ''
        };
        this.defaultPicList = [];
        this.loadBookMaterialLevel();
        this.getAdviserList();
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RejectWoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    studentId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingReject: false,
      formData: {
        studentId: null,
        reason: null
      },
      ruleWo: {
        reason: [{ type: 'string', required: true, message: '理由不能为空', trigger: 'blur' }]
      }
    };
  },

  methods: {
    reject: function reject() {
      var self = this;
      self.loadingReject = true;
      self.$refs.rejectWoForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingReject = false;
          return;
        }
        self.$http.post('/sale/wo/reject', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false;
            self.$Message.success('提交成功!');
            self.successCallback();
          }
          self.loadingReject = false;
        }).catch(function (e) {
          self.loadingReject = false;
        });
      });
    }
  },
  watch: {
    studentId: function studentId(val) {
      if (val) {
        this.formData.studentId = val;
      }
    },
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {} else {
        this.formData = {};
        this.$emit('on-close', val);
      }
    }
  }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserClassHourModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var $moment = this.$moment;
    return {
      visible: this.value,
      dataList: [],
      totalNum: 0,
      totalConsumeNum: 0,
      totalLockNum: 0,
      column: [{
        title: '合计',
        width: 100,
        align: 'center',
        key: 'title'
      }, {
        title: '课时数量',
        width: 100,
        align: 'center',
        key: 'num'
      }, {
        title: '已消耗课时',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'red' } }, params.row.consumeNum);
        }
      }, {
        title: '锁定课时(已选未上)',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'orange' } }, params.row.lockNum);
        }
      }, {
        title: '剩余可用',
        width: 100,
        align: 'center',
        render: function render(h, params) {
          return h('span', { style: { color: 'green' } }, params.row.num - params.row.consumeNum - params.row.lockNum);
        }
      }, {
        title: '课时类型',
        width: 135,
        align: 'center',
        key: 'type'
      }, {
        title: '课时来源',
        width: 135,
        align: 'center',
        render: function render(h, params) {
          var row = params.row;
          if (row.taskNum > 0) {
            return [h('span', row.channel + '（'), h('span', { style: { color: 'blue' } }, row.taskNum), h('span', '）')];
          }
          return row.channel;
        }
      }, {
        title: '生效时间',
        width: 135,
        align: 'center',
        key: 'gmtCreate'
      }, {
        title: '有效期(天)',
        width: 135,
        align: 'center',
        key: 'effectDays'
      }, {
        title: '到期时间',
        width: 135,
        align: 'center',
        key: 'expireTime'
      }, {
        title: '操作人)',
        width: 135,
        align: 'center',
        key: 'creatorName'
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      var self = this;
      self.$http.get('/class-hour/list', { params: { uid: self.uid } }).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.dataList = res.data;
        self.dataList.forEach(function (item) {
          self.totalNum += item.num;
          self.totalConsumeNum += item.consumeNum;
          self.totalLockNum += item.lockNum;
        });
        self.dataList.push({
          num: self.totalNum,
          consumeNum: self.totalConsumeNum,
          lockNum: self.totalLockNum,
          title: '合计'
        });
        self.visible = true;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.totalNum = 0;
        this.totalConsumeNum = 0;
        this.totalLockNum = 0;
        this.onLoad();
      } else {
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToRefundModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String],
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingRemain: false,
      loadingSubmit: false,
      remainLoaded: false,
      loadedUid: '',
      tchChannel: 1,
      nickname: '',
      mobile: '',
      stdStatus: '',
      foreignRemain: 0,
      foreignLock: 0,
      chineseRemain: 0,
      chineseLock: 0,
      partnerRemain: 0,
      partnerLock: 0,
      figAvailable: 0,
      figLock: 0,
      teacherCauseChecked: false,
      timer: null,
      smsCodeTime: 60,
      smsCodeDisabled: false,
      formData: {
        uid: '',
        remark: '',
        smsCode: '',
        tchId: null,
        tchName: '',
        foreignDeduct: 0,
        chineseDeduct: 0,
        partnerDeduct: 0,
        figAvailableDeduct: 0,
        figLockDeduct: 0
      },
      formRule: {
        uid: [{ required: true, message: '请输入学员ID', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入退费原因', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
      }
    };
  },

  computed: {
    uidDisabled: function uidDisabled() {
      return this.uid !== '' && this.uid !== null && this.uid !== undefined;
    }
  },
  methods: {
    toNum: function toNum(val) {
      if (val === '' || val === null || val === undefined) {
        return 0;
      }
      var num = Number(val);
      if (isNaN(num)) {
        return 0;
      }
      return num;
    },
    resetForm: function resetForm() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.loadingRemain = false;
      this.loadingSubmit = false;
      this.remainLoaded = false;
      this.loadedUid = '';
      this.tchChannel = 1;
      this.nickname = '';
      this.mobile = '';
      this.stdStatus = '';
      this.foreignRemain = 0;
      this.foreignLock = 0;
      this.chineseRemain = 0;
      this.chineseLock = 0;
      this.partnerRemain = 0;
      this.partnerLock = 0;
      this.figAvailable = 0;
      this.figLock = 0;
      this.teacherCauseChecked = false;
      this.smsCodeTime = 60;
      this.smsCodeDisabled = false;
      this.formData = {
        uid: this.uid || '',
        remark: '',
        smsCode: '',
        tchId: null,
        tchName: '',
        foreignDeduct: 0,
        chineseDeduct: 0,
        partnerDeduct: 0,
        figAvailableDeduct: 0,
        figLockDeduct: 0
      };
    },
    onUidBlur: function onUidBlur() {
      if (!this.formData.uid) {
        return;
      }
      if (this.remainLoaded && String(this.loadedUid) === String(this.formData.uid)) {
        return;
      }
      this.loadRemainHour();
    },
    loadRemainHour: function loadRemainHour() {
      var self = this;
      if (!self.formData.uid) {
        self.$Message.warning('请先输入学员ID');
        return;
      }
      self.loadingRemain = true;
      self.remainLoaded = false;
      self.$http.get('/user/refund/remain-hour', { params: { uid: self.formData.uid } }).then(function (res) {
        self.loadingRemain = false;
        if (res && res.status === 'ok' && res.data) {
          self.applyRemain(res.data);
        }
      }).catch(function () {
        self.loadingRemain = false;
      });
    },
    applyRemain: function applyRemain(data) {
      this.remainLoaded = true;
      this.loadedUid = data.uid;
      this.formData.uid = data.uid;
      this.tchChannel = data.tchChannel;
      this.nickname = data.nickname || '';
      this.mobile = data.mobile || '';
      this.stdStatus = data.stdStatus;
      this.foreignRemain = this.toNum(data.foreignRemain);
      this.foreignLock = this.toNum(data.foreignLock);
      this.chineseRemain = this.toNum(data.chineseRemain);
      this.chineseLock = this.toNum(data.chineseLock);
      this.partnerRemain = this.toNum(data.partnerRemain);
      this.partnerLock = this.toNum(data.partnerLock);
      this.figAvailable = this.toNum(data.figAvailable);
      this.figLock = this.toNum(data.figLock);
      this.formData.foreignDeduct = this.toNum(data.foreignDeduct);
      this.formData.chineseDeduct = this.toNum(data.chineseDeduct);
      this.formData.partnerDeduct = this.toNum(data.partnerDeduct);
      this.formData.figAvailableDeduct = this.toNum(data.figAvailableDeduct);
      this.formData.figLockDeduct = this.toNum(data.figLockDeduct);
    },
    onTeacherCauseChange: function onTeacherCauseChange(val) {
      if (!val) {
        this.formData.tchId = null;
        this.formData.tchName = '';
      }
    },
    onTchSelect: function onTchSelect(tch) {
      if (tch) {
        this.formData.tchId = tch.id;
        this.formData.tchName = tch.firstName + ' ' + tch.lastName;
      } else {
        this.formData.tchId = null;
        this.formData.tchName = '';
      }
    },
    validateDeduct: function validateDeduct() {
      if (this.tchChannel === 2) {
        var availableDeduct = this.toNum(this.formData.figAvailableDeduct);
        var lockDeduct = this.toNum(this.formData.figLockDeduct);
        if (availableDeduct < 0 || availableDeduct > this.figAvailable) {
          this.$Message.warning('可用本次扣减不能大于该类剩余且不能为负');
          return false;
        }
        if (lockDeduct < 0 || lockDeduct > this.figLock) {
          this.$Message.warning('锁定本次扣减不能大于该类剩余且不能为负');
          return false;
        }
        return true;
      }
      var foreignDeduct = this.toNum(this.formData.foreignDeduct);
      var chineseDeduct = this.toNum(this.formData.chineseDeduct);
      var partnerDeduct = this.toNum(this.formData.partnerDeduct);
      if (foreignDeduct < 0 || foreignDeduct > this.foreignRemain) {
        this.$Message.warning('外教本次扣减不能大于该类剩余且不能为负');
        return false;
      }
      if (chineseDeduct < 0 || chineseDeduct > this.chineseRemain) {
        this.$Message.warning('中教本次扣减不能大于该类剩余且不能为负');
        return false;
      }
      if (partnerDeduct < 0 || partnerDeduct > this.partnerRemain) {
        this.$Message.warning('陪练本次扣减不能大于该类剩余且不能为负');
        return false;
      }
      return true;
    },
    buildPayload: function buildPayload() {
      var isFig = this.tchChannel === 2;
      return {
        uid: this.formData.uid,
        remark: this.formData.remark,
        smsCode: this.formData.smsCode,
        teacherCause: this.teacherCauseChecked ? 1 : 0,
        tchId: this.teacherCauseChecked ? this.formData.tchId : '',
        tchName: this.teacherCauseChecked ? this.formData.tchName : '',
        foreignDeduct: isFig ? 0 : this.toNum(this.formData.foreignDeduct),
        chineseDeduct: isFig ? 0 : this.toNum(this.formData.chineseDeduct),
        partnerDeduct: isFig ? 0 : this.toNum(this.formData.partnerDeduct),
        figAvailableDeduct: isFig ? this.toNum(this.formData.figAvailableDeduct) : 0,
        figLockDeduct: isFig ? this.toNum(this.formData.figLockDeduct) : 0
      };
    },
    submit: function submit() {
      var self = this;
      self.$refs.refundForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          return;
        }
        if (!self.remainLoaded) {
          self.$Message.warning('请先查询课时');
          return;
        }
        if (self.teacherCauseChecked && !self.formData.tchId) {
          self.$Message.warning('请选择外教老师');
          return;
        }
        if (!self.validateDeduct()) {
          return;
        }
        self.loadingSubmit = true;
        self.$http.post('/user/request-refund', self.buildPayload()).then(function (res) {
          self.loadingSubmit = false;
          if (res && res.status === 'ok') {
            self.visible = false;
            self.$Message.success('已移至退费库');
            if (self.successCallback) {
              self.successCallback();
            }
          }
        }).catch(function () {
          self.loadingSubmit = false;
        });
      });
    },
    sendSmsCode: function sendSmsCode() {
      var self = this;
      if (!self.formData.uid) {
        self.$Message.warning('请先输入学员ID');
        return;
      }
      self.$http.get('/userinfo/sendUpdateMobileSmsCode', {
        params: {
          uid: self.formData.uid,
          key: 'request_refund_sms'
        }
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.smsCodeDisabled = true;
          self.$Message.success('验证码发送成功!');
          self.timer = setInterval(function () {
            if (self.smsCodeTime <= 0) {
              self.smsCodeDisabled = false;
              self.smsCodeTime = 60;
              clearInterval(self.timer);
              self.timer = null;
            } else {
              self.smsCodeTime -= 1;
            }
          }, 1000);
        } else {
          self.$Message.error('验证码发送失败!');
        }
      }).catch(function () {
        self.$Message.error('验证码发送失败!');
      });
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
      if (val) {
        this.resetForm();
        if (this.formData.uid) {
          this.loadRemainHour();
        }
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateLevelModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    return {
      visible: this.value,
      loadingBind: false,
      bookMaterialLevelList: null,
      formData: {
        uid: '',
        nickname: '',
        mobile: '',
        levelId: null
      },
      formRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择Level', trigger: 'change' }]
      }
    };
  },

  methods: {
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
        self.visible = true;
      });
    },
    updateLevel: function updateLevel() {
      var self = this;
      var isNotError = true;
      self.loadingBind = true;
      self.$refs.modalForm.validateField('levelId', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) {
        self.loadingBind = false;
        return;
      }

      var params = {};
      params.uid = self.formData.uid;
      params.levelId = self.formData.levelId;
      self.$http.post('/userList/updateLevel', params).then(function (res) {
        self.$Message.success('操作成功!');
        self.visible = false;
        self.loadingBind = false;
        self.successCallback();
      });
    },
    onClose: function onClose() {
      this.$emit('on-close');
    }
  },
  watch: {
    value: function value(val) {
      if (val === true) {
        this.formData.uid = this.user.id;
        this.formData.nickname = this.user.nickname;
        this.formData.mobile = this.user.mobile;
        this.loadBookMaterialLevel();
      } else {
        this.formData = {
          uid: '',
          nickname: '',
          mobile: '',
          levelId: null
        };
        this.$refs.modalForm.resetFields();
        this.bookMaterialLevelList = [];
        this.visible = val;
      }
    },
    visible: function visible(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directive_drag_modal__ = __webpack_require__(211);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserTempLessonModal',
  components: { TchInfoModal: __WEBPACK_IMPORTED_MODULE_1__teacher_modal_TchInfoModal___default.a },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tchName: '',
      tId: '',
      tempLessonParam: {
        levelId: null,
        uid: null,
        category: '',
        makeUp: '',
        tchId: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        postpone: 1,
        time: null,
        sex: null,
        channel: null,
        schoolId: 0
      },
      timeStr: '',
      timePickerKey: 0,
      tempLessonRule: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.tempLessonParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            var lsnBeginTime = self.getLsnBeginTime();
            var nowTime = new Date().getTime() / 1000;
            if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
              errors.push('开始时间应在当前时间之后');
              callback(errors);
              return;
            }
            callback();
          }
        }]
      },
      tchId: null,
      showTchInfoModal: false,
      ptype: ''
    };
  },

  methods: {
    tchAvatarSrc: function tchAvatarSrc(avatar) {
      return __WEBPACK_IMPORTED_MODULE_2__tools_commonUtils_js___default.a.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg';
    },
    secondsFromPicker: function secondsFromPicker() {
      var val = this.timeStr;
      if (val instanceof Date && !isNaN(val.getTime())) {
        return val.getHours() * 3600 + val.getMinutes() * 60;
      }
      if (typeof val === 'string' && val.indexOf(':') !== -1) {
        return parseInt(this.$dateUtil.getSecondByHm(val), 10);
      }
      return '';
    },
    syncPickerTime: function syncPickerTime() {
      var sec = this.secondsFromPicker();
      this.tempLessonParam.time = sec === '' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(sec) ? '' : sec;
    },
    insertTempLesson: function insertTempLesson() {
      var self = this;
      self.syncPickerTime();
      self.loadingConfirm = true;
      self.$refs.tempLessonForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingConfirm = false;
          return;
        }
        self.tempLessonParam.lsnBeginTime = self.getLsnBeginTime();
        self.$http.post('/user/lesson/addCourse', self.tempLessonParam).then(function (res) {
          self.loadingConfirm = false;
          if (res) {
            self.visible = false;
            self.$Message.success('约课成功!');
            self.successCallback();
            return;
          }
        });
      });
    },
    searchTch: function searchTch() {
      var self = this;
      self.syncPickerTime();
      var isNotError = true;
      self.$refs.tempLessonForm.validateField('lsnBeginDayTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) return;
      self.loadingSearch = true;
      self.tchList = [];
      var path = '/tch/time/queryFreeNotChineseTch?lsnBeginTime=' + self.getLsnBeginTime() + '&timeLength=' + self.tempLessonParam.timeLength + '&tchType=1&tempSchedule=1&uid=' + self.tempLessonParam.uid;
      if (self.ptype === '1') {
        path = path + '&isAudition=y';
      }
      if (self.tempLessonParam.canBound) {
        path = path + '&canBound=' + self.tempLessonParam.canBound;
      }
      if (self.tempLessonParam.category) {
        path = path + '&category=' + self.tempLessonParam.category;
      }
      if (self.tId) {
        path = path + '&tchId=' + self.tId;
      }
      if (self.tempLessonParam.suitableLevel) {
        path = path + '&suitableLevel=' + self.tempLessonParam.suitableLevel;
      }
      if (self.tempLessonParam.accent) {
        path = path + '&accent=' + self.tempLessonParam.accent;
      }
      if (self.tempLessonParam.sex) {
        path = path + '&sex=' + self.tempLessonParam.sex;
      }
      if (self.tempLessonParam.channel) {
        path = path + '&channel=' + self.tempLessonParam.channel;
      }

      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data;
        }
        self.loadingSearch = false;
      });
    },
    onChangeTime: function onChangeTime(val) {
      this.tempLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
      this.clearTchList();
      this.selectLevel();
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.tempLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
      this.clearTchList();
      this.selectLevel();
    },
    selectLevel: function selectLevel() {
      var self = this;
      var lsnEndTime = self.getLsnBeginTime() + self.tempLessonParam.timeLength * 60;
      var uid = self.tempLessonParam.uid;
      self.$http.get('/user/selectLevelIdByUidAndTime?uid=' + uid + '&lsnEndTime=' + lsnEndTime).then(function (res) {
        if (res && res.data > 0) {
          self.tempLessonParam.levelId = res.data;
        }
      });
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptypeList=1&ptypeList=2').then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLevelList = res.data;
        self.tempLessonParam.levelId = self.user.levelId;
      });
    },
    changeLevel: function changeLevel(val) {
      if (!val) {
        return;
      }
      var self = this;
      for (var i = 0; i < self.bookMaterialLevelList.length; i++) {
        var item = self.bookMaterialLevelList[i];
        if (item.id === val) {
          self.ptype = item.ptype;
          self.tempLessonParam.courseType = item.lessonType;
          break;
        }
      }
      self.bookMaterialLessonsList = null;
      self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLessonsList = res.data;
      });
      if (self.tempLessonParam.courseType === 1) {
        self.timeLength = 25;
      }
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.tempLessonParam.lsnBeginDayTime) + parseInt(this.tempLessonParam.time);
    },
    clearTchList: function clearTchList() {
      this.tchList = [];
      this.tempLessonParam.tchId = '';
    },
    showTchMessage: function showTchMessage(id) {
      this.tchId = parseInt(id);
      this.showTchInfoModal = true;
    },
    updateTchInfoSuccess: function updateTchInfoSuccess() {
      this.showTchInfoModal = false;
    },
    onTchChange: function onTchChange(id, name) {
      this.tchName = name;
      if (id) {
        this.searchTch();
      }
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.tchList = [];
        this.loadingConfirm = false;
        this.loadingSearch = false;
        this.bookMaterialLevelList = null;
        this.bookMaterialLessonsList = null;
        this.loadBookMaterialLevel();
        this.tempLessonParam.uid = this.user.id;
        this.tempLessonParam.nickname = this.user.nickname;
        this.tempLessonParam.mobile = this.user.mobile;
        this.tempLessonParam.levelId = this.user.levelId;
        var now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.tempLessonParam.lsnBeginTimeDate = now;
        this.tempLessonParam.lsnBeginDayTime = now.getTime() / 1000;
        this.timeStr = '18:00';
        this.tempLessonParam.time = 18 * 3600;
        this.timePickerKey += 1;
        this.tempLessonParam.levelId = '';
        this.tempLessonParam.lessonId = '';
      } else {
        this.tId = '';
        this.tchName = '';
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserTestNetworkModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data: function data() {
    var self = this;
    return {
      visible: this.value,
      classTypeList: [{ code: 1, text: 'ClassIn' }],
      timeLengthList: [{ code: 25, text: '25' }],
      showTestNetworkModal: false,
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      testNetworkParam: {
        uid: '',
        nickname: '',
        mobile: '',
        classType: 1,
        courseType: 1,
        tchId: null,
        levelId: null,
        lessonId: null,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        schoolId: 0
      },
      timeStr: '',
      loadingCheck: false,
      loadingTestNetwork: false,
      ruleTestNetwork: {
        levelId: [{ type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }],
        lessonId: [{ type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }],
        classType: [{ type: 'integer', required: true, message: '请选择教室', trigger: 'change' }],
        tchId: [{ type: 'integer', required: true, message: '请选择老师', trigger: 'change' }],
        lsnBeginDayTime: [{ type: 'integer', required: true, message: '请选择日期', trigger: 'change' }, {
          validator: function validator(rule, value, callback, source, options) {
            var errors = [];
            if (self.testNetworkParam.time === '') {
              errors.push('请选择时间');
              callback(errors);
              return;
            }
            callback(errors);
          }
        }]
      }
    };
  },

  methods: {
    changeLevel: function changeLevel(val) {
      var self = this;
      self.bookMaterialLessonsList = null;
      self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        self.bookMaterialLessonsList = res.data;
        if (res.data.length > 0) {
          self.testNetworkParam.lessonId = res.data[0].id;
        }
      });
    },
    onChangeTime: function onChangeTime(val) {
      this.testNetworkParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val));
    },
    lsnBeginTimeDateChange: function lsnBeginTimeDateChange(value) {
      this.testNetworkParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'));
    },
    checkTime: function checkTime() {
      var self = this;
      var isNotError = true;
      self.loadingCheck = true;
      self.$refs.testNetworkForm.validateField('tchId', function (valid) {
        if (valid !== '') isNotError = false;
      });
      self.$refs.testNetworkForm.validateField('lsnBeginDayTime', function (valid) {
        if (valid !== '') isNotError = false;
      });
      if (!isNotError) {
        self.loadingCheck = false;
        return;
      }
      self.testNetworkParam.lsnBeginTime = self.getLsnBeginTime();
      self.$http.post('/user/lesson/checkTime', self.testNetworkParam).then(function (res) {
        self.loadingCheck = false;
        if (res) {
          self.$Message.success('检查成功!');
          return;
        }
      });
    },
    insertTestNetwork: function insertTestNetwork() {
      var self = this;
      self.loadingTestNetwork = true;
      self.$refs.testNetworkForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!');
          self.loadingTestNetwork = false;
          return;
        }
        self.testNetworkParam.lsnBeginTime = self.getLsnBeginTime();
        self.$http.post('/user/lesson/addCourse', self.testNetworkParam).then(function (res) {
          self.loadingTestNetwork = false;
          if (res) {
            self.$Message.success('约课成功!');
            self.visible = false;
            return;
          }
        });
      });
    },
    loadBookMaterialLevel: function loadBookMaterialLevel() {
      var self = this;
      if (self.bookMaterialLevelList) {
        return;
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=0').then(function (res) {
        if (!res || !res.data || res.data.length < 1) {
          return;
        }
        self.bookMaterialLevelList = res.data;

        self.testNetworkParam.levelId = res.data[0].id;
        self.changeLevel(res.data[0].id);
      });
    },
    getLsnBeginTime: function getLsnBeginTime() {
      return parseInt(this.testNetworkParam.lsnBeginDayTime) + parseInt(this.testNetworkParam.time);
    }
  },
  watch: {
    value: function value(val) {
      this.visible = val;
    },
    visible: function visible(val) {
      if (val === true) {
        this.loadBookMaterialLevel();
        this.testNetworkParam.uid = this.user.uid;
        this.testNetworkParam.nickname = this.user.nickname;
        this.testNetworkParam.mobile = this.user.mobile;
        this.testNetworkBookMaterialLevelList = this.bookMaterialLevelList;

        var now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.testNetworkParam.lsnBeginTimeDate = now;
        this.testNetworkParam.lsnBeginDayTime = now.getTime() / 1000;
        this.timeStr = '18:00';
        this.testNetworkParam.time = 18 * 3600;
      }
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RenderCell',
  functional: true,
  props: {
    render: Function,
    params: Object
  },
  render: function render(h, ctx) {
    return ctx.props.render(h, ctx.props.params);
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_dist_styles_iview_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_common_less__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_index__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_List_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_RecommendList_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_RecommendList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_RecommendList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_CheckBox_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_CheckBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_CheckBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_RuleButton_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_RuleButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_RuleButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppConfig__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_Store__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_Logger__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_Helper__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_Http__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_Constant__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_DateUtil__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_TableStyle__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plugins_PhoneArea__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_v_distpicker__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_v_distpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_v_distpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_numeral__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plugins_TimeZone__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_quill_editor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_quill_dist_quill_core_css__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_quill_dist_quill_snow_css__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_quill_dist_quill_bubble_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_quill__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plugins_Audio__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_simple_uploader__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_simple_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_simple_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_v_viewer__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_viewerjs_dist_viewer_css__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__directive_permissions__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tools_domainHelper__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tools_domainHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__tools_domainHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_common_AdminUserSelect_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_common_AdminUserSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_common_AdminUserSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_common_TeacherSelect_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_common_TeacherSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_common_TeacherSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_common_PhoneAreaSelect_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_common_PhoneAreaSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_common_PhoneAreaSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_common_CitySelect_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_common_CitySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_common_CitySelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_common_MultiUpload_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_common_MultiUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_common_MultiUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_TimeZoneSelect_vue__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_TimeZoneSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_common_TimeZoneSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_common_ImageUpload_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_common_ImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_common_ImageUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_ImageUploadNew__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_ImageUploadNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_common_ImageUploadNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_common_multipleImageUpload_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_common_multipleImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_common_multipleImageUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_common_FileUpload_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_common_FileUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_common_FileUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_common_StudentSelect_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_common_StudentSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_common_StudentSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_common_ActivitySelect__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_common_ActivitySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_common_ActivitySelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_common_SalesAdviserSelect__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_common_SalesAdviserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_common_SalesAdviserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_common_ChannelSelect__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_common_ChannelSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_common_ChannelSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_flag_icons_css_flag_icons_css__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_flag_icons_css_flag_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_flag_icons_css_flag_icons_css__);





































(function () {
  var _open = window.open;
  window.open = function (url, target, features) {
    if (typeof url === 'string' && __WEBPACK_IMPORTED_MODULE_34__tools_domainHelper___default.a.isQuqukidDomain()) {
      url = __WEBPACK_IMPORTED_MODULE_34__tools_domainHelper___default.a.replaceDomain(url);
    }
    return _open.call(window, url, target, features);
  };
})();

__WEBPACK_IMPORTED_MODULE_28_quill__["register"]('formats/audio', __WEBPACK_IMPORTED_MODULE_29__plugins_Audio__["a" /* default */]);





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_21_moment___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$numeral = __WEBPACK_IMPORTED_MODULE_22_numeral___default.a;

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: __WEBPACK_IMPORTED_MODULE_6__router_index__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  var search = new URLSearchParams(window.location.search);
  var authCode = search.get('authCode') || search.get('code');
  if (authCode && to.path !== '/login') {
    var state = search.get('state');
    window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash);
    var query = { authCode: authCode };
    if (state) {
      query.state = state;
    }
    next({ path: '/login', query: query });
    return;
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_vue_simple_uploader___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__AppConfig__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__plugins_Store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__plugins_Logger__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__plugins_Helper__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__plugins_Constant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__plugins_DateUtil__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__plugins_TableStyle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__plugins_PhoneArea__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38__components_common_CitySelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugins_Http__["a" /* default */], { router: router });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_49_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__plugins_TimeZone__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_quill_editor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31_v_viewer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33__directive_permissions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_31_v_viewer___default.a.setDefaults({
  navbar: false,

  toolbar: false,

  button: false,

  title: false,

  movable: true,

  zoomable: true,

  transition: false
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('List', __WEBPACK_IMPORTED_MODULE_7__components_common_List_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('CheckBox', __WEBPACK_IMPORTED_MODULE_9__components_common_CheckBox_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('AdminUserSelect', __WEBPACK_IMPORTED_MODULE_35__components_common_AdminUserSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('TeacherSelect', __WEBPACK_IMPORTED_MODULE_36__components_common_TeacherSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('PhoneAreaSelect', __WEBPACK_IMPORTED_MODULE_37__components_common_PhoneAreaSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('CitySelect', __WEBPACK_IMPORTED_MODULE_38__components_common_CitySelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('RuleButton', __WEBPACK_IMPORTED_MODULE_10__components_common_RuleButton_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ImageUpload', __WEBPACK_IMPORTED_MODULE_41__components_common_ImageUpload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ImageUploadNew', __WEBPACK_IMPORTED_MODULE_42__components_common_ImageUploadNew___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multipleImageUpload', __WEBPACK_IMPORTED_MODULE_43__components_common_multipleImageUpload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('FileUpload', __WEBPACK_IMPORTED_MODULE_44__components_common_FileUpload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('MultiUpload', __WEBPACK_IMPORTED_MODULE_39__components_common_MultiUpload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('RecommendList', __WEBPACK_IMPORTED_MODULE_8__components_common_RecommendList_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-distpicker', __WEBPACK_IMPORTED_MODULE_20_v_distpicker___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('TimeZoneSelect', __WEBPACK_IMPORTED_MODULE_40__components_common_TimeZoneSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('StudentSelect', __WEBPACK_IMPORTED_MODULE_45__components_common_StudentSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ActivitySelect', __WEBPACK_IMPORTED_MODULE_46__components_common_ActivitySelect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('SalesAdviserSelect', __WEBPACK_IMPORTED_MODULE_47__components_common_SalesAdviserSelect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ChannelSelect', __WEBPACK_IMPORTED_MODULE_48__components_common_ChannelSelect___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$domainHelper = __WEBPACK_IMPORTED_MODULE_34__tools_domainHelper___default.a;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  name: 'centerDealVue'
}));

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = [{
  'code': '110000',
  'sheng': '11',
  'di': '00',
  'xian': '00',
  'name': '北京市',
  'level': 1
}, { 'code': '110100',
  'sheng': '11',
  'di': '01',
  'xian': '00',
  'name': '市辖区',
  'level': 2
}, {
  'code': '110101',
  'sheng': '11',
  'di': '01',
  'xian': '01',
  'name': '东城区',
  'level': 3
}, {
  'code': '110102',
  'sheng': '11',
  'di': '01',
  'xian': '02',
  'name': '西城区',
  'level': 3
}, {
  'code': '110105',
  'sheng': '11',
  'di': '01',
  'xian': '05',
  'name': '朝阳区',
  'level': 3
}, {
  'code': '110106',
  'sheng': '11',
  'di': '01',
  'xian': '06',
  'name': '丰台区',
  'level': 3
}, {
  'code': '110107',
  'sheng': '11',
  'di': '01',
  'xian': '07',
  'name': '石景山区',
  'level': 3
}, {
  'code': '110108',
  'sheng': '11',
  'di': '01',
  'xian': '08',
  'name': '海淀区',
  'level': 3
}, {
  'code': '110109',
  'sheng': '11',
  'di': '01',
  'xian': '09',
  'name': '门头沟区',
  'level': 3
}, {
  'code': '110111',
  'sheng': '11',
  'di': '01',
  'xian': '11',
  'name': '房山区',
  'level': 3
}, {
  'code': '110112',
  'sheng': '11',
  'di': '01',
  'xian': '12',
  'name': '通州区',
  'level': 3
}, {
  'code': '110113',
  'sheng': '11',
  'di': '01',
  'xian': '13',
  'name': '顺义区',
  'level': 3
}, {
  'code': '110114',
  'sheng': '11',
  'di': '01',
  'xian': '14',
  'name': '昌平区',
  'level': 3
}, {
  'code': '110115',
  'sheng': '11',
  'di': '01',
  'xian': '15',
  'name': '大兴区',
  'level': 3
}, {
  'code': '110116',
  'sheng': '11',
  'di': '01',
  'xian': '16',
  'name': '怀柔区',
  'level': 3
}, {
  'code': '110117',
  'sheng': '11',
  'di': '01',
  'xian': '17',
  'name': '平谷区',
  'level': 3
}, {
  'code': '110200',
  'sheng': '11',
  'di': '02',
  'xian': '00',
  'name': '县',
  'level': 2
}, {
  'code': '110228',
  'sheng': '11',
  'di': '02',
  'xian': '28',
  'name': '密云县',
  'level': 3
}, {
  'code': '110229',
  'sheng': '11',
  'di': '02',
  'xian': '29',
  'name': '延庆县',
  'level': 3
}, {
  'code': '120000',
  'sheng': '12',
  'di': '00',
  'xian': '00',
  'name': '天津市',
  'level': 1
}, {
  'code': '120100',
  'sheng': '12',
  'di': '01',
  'xian': '00',
  'name': '市辖区',
  'level': 2
}, {
  'code': '120101',
  'sheng': '12',
  'di': '01',
  'xian': '01',
  'name': '和平区',
  'level': 3
}, {
  'code': '120102',
  'sheng': '12',
  'di': '01',
  'xian': '02',
  'name': '河东区',
  'level': 3
}, {
  'code': '120103',
  'sheng': '12',
  'di': '01',
  'xian': '03',
  'name': '河西区',
  'level': 3
}, {
  'code': '120104',
  'sheng': '12',
  'di': '01',
  'xian': '04',
  'name': '南开区',
  'level': 3
}, {
  'code': '120105',
  'sheng': '12',
  'di': '01',
  'xian': '05',
  'name': '河北区',
  'level': 3
}, {
  'code': '120106',
  'sheng': '12',
  'di': '01',
  'xian': '06',
  'name': '红桥区',
  'level': 3
}, {
  'code': '120110',
  'sheng': '12',
  'di': '01',
  'xian': '10',
  'name': '东丽区',
  'level': 3
}, {
  'code': '120111',
  'sheng': '12',
  'di': '01',
  'xian': '11',
  'name': '西青区',
  'level': 3
}, {
  'code': '120112',
  'sheng': '12',
  'di': '01',
  'xian': '12',
  'name': '津南区',
  'level': 3
}, {
  'code': '120113',
  'sheng': '12',
  'di': '01',
  'xian': '13',
  'name': '北辰区',
  'level': 3
}, {
  'code': '120114',
  'sheng': '12',
  'di': '01',
  'xian': '14',
  'name': '武清区',
  'level': 3
}, {
  'code': '120115',
  'sheng': '12',
  'di': '01',
  'xian': '15',
  'name': '宝坻区',
  'level': 3
}, {
  'code': '120116',
  'sheng': '12',
  'di': '01',
  'xian': '16',
  'name': '滨海新区',
  'level': 3
}, {
  'code': '120200',
  'sheng': '12',
  'di': '02',
  'xian': '00',
  'name': '县',
  'level': 2
}, {
  'code': '120221',
  'sheng': '12',
  'di': '02',
  'xian': '21',
  'name': '宁河县',
  'level': 3
}, {
  'code': '120223',
  'sheng': '12',
  'di': '02',
  'xian': '23',
  'name': '静海县',
  'level': 3
}, {
  'code': '120225',
  'sheng': '12',
  'di': '02',
  'xian': '25',
  'name': '蓟县',
  'level': 3
}, {
  'code': '130000',
  'sheng': '13',
  'di': '00',
  'xian': '00',
  'name': '河北省',
  'level': 1
}, {
  'code': '130100',
  'sheng': '13',
  'di': '01',
  'xian': '00',
  'name': '石家庄市',
  'level': 2
}, {
  'code': '130101',
  'sheng': '13',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130102',
  'sheng': '13',
  'di': '01',
  'xian': '02',
  'name': '长安区',
  'level': 3
}, {
  'code': '130104',
  'sheng': '13',
  'di': '01',
  'xian': '04',
  'name': '桥西区',
  'level': 3
}, {
  'code': '130105',
  'sheng': '13',
  'di': '01',
  'xian': '05',
  'name': '新华区',
  'level': 3
}, {
  'code': '130107',
  'sheng': '13',
  'di': '01',
  'xian': '07',
  'name': '井陉矿区',
  'level': 3
}, {
  'code': '130108',
  'sheng': '13',
  'di': '01',
  'xian': '08',
  'name': '裕华区',
  'level': 3
}, {
  'code': '130109',
  'sheng': '13',
  'di': '01',
  'xian': '09',
  'name': '藁城区',
  'level': 3
}, {
  'code': '130110',
  'sheng': '13',
  'di': '01',
  'xian': '10',
  'name': '鹿泉区',
  'level': 3
}, {
  'code': '130111',
  'sheng': '13',
  'di': '01',
  'xian': '11',
  'name': '栾城区',
  'level': 3
}, {
  'code': '130121',
  'sheng': '13',
  'di': '01',
  'xian': '21',
  'name': '井陉县',
  'level': 3
}, {
  'code': '130123',
  'sheng': '13',
  'di': '01',
  'xian': '23',
  'name': '正定县',
  'level': 3
}, {
  'code': '130125',
  'sheng': '13',
  'di': '01',
  'xian': '25',
  'name': '行唐县',
  'level': 3
}, {
  'code': '130126',
  'sheng': '13',
  'di': '01',
  'xian': '26',
  'name': '灵寿县',
  'level': 3
}, {
  'code': '130127',
  'sheng': '13',
  'di': '01',
  'xian': '27',
  'name': '高邑县',
  'level': 3
}, {
  'code': '130128',
  'sheng': '13',
  'di': '01',
  'xian': '28',
  'name': '深泽县',
  'level': 3
}, {
  'code': '130129',
  'sheng': '13',
  'di': '01',
  'xian': '29',
  'name': '赞皇县',
  'level': 3
}, {
  'code': '130130',
  'sheng': '13',
  'di': '01',
  'xian': '30',
  'name': '无极县',
  'level': 3
}, {
  'code': '130131',
  'sheng': '13',
  'di': '01',
  'xian': '31',
  'name': '平山县',
  'level': 3
}, {
  'code': '130132',
  'sheng': '13',
  'di': '01',
  'xian': '32',
  'name': '元氏县',
  'level': 3
}, {
  'code': '130133',
  'sheng': '13',
  'di': '01',
  'xian': '33',
  'name': '赵县',
  'level': 3
}, {
  'code': '130181',
  'sheng': '13',
  'di': '01',
  'xian': '81',
  'name': '辛集市',
  'level': 3
}, {
  'code': '130183',
  'sheng': '13',
  'di': '01',
  'xian': '83',
  'name': '晋州市',
  'level': 3
}, {
  'code': '130184',
  'sheng': '13',
  'di': '01',
  'xian': '84',
  'name': '新乐市',
  'level': 3
}, {
  'code': '130200',
  'sheng': '13',
  'di': '02',
  'xian': '00',
  'name': '唐山市',
  'level': 2
}, {
  'code': '130201',
  'sheng': '13',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130202',
  'sheng': '13',
  'di': '02',
  'xian': '02',
  'name': '路南区',
  'level': 3
}, {
  'code': '130203',
  'sheng': '13',
  'di': '02',
  'xian': '03',
  'name': '路北区',
  'level': 3
}, {
  'code': '130204',
  'sheng': '13',
  'di': '02',
  'xian': '04',
  'name': '古冶区',
  'level': 3
}, {
  'code': '130205',
  'sheng': '13',
  'di': '02',
  'xian': '05',
  'name': '开平区',
  'level': 3
}, {
  'code': '130207',
  'sheng': '13',
  'di': '02',
  'xian': '07',
  'name': '丰南区',
  'level': 3
}, {
  'code': '130208',
  'sheng': '13',
  'di': '02',
  'xian': '08',
  'name': '丰润区',
  'level': 3
}, {
  'code': '130209',
  'sheng': '13',
  'di': '02',
  'xian': '09',
  'name': '曹妃甸区',
  'level': 3
}, {
  'code': '130223',
  'sheng': '13',
  'di': '02',
  'xian': '23',
  'name': '滦县',
  'level': 3
}, {
  'code': '130224',
  'sheng': '13',
  'di': '02',
  'xian': '24',
  'name': '滦南县',
  'level': 3
}, {
  'code': '130225',
  'sheng': '13',
  'di': '02',
  'xian': '25',
  'name': '乐亭县',
  'level': 3
}, {
  'code': '130227',
  'sheng': '13',
  'di': '02',
  'xian': '27',
  'name': '迁西县',
  'level': 3
}, {
  'code': '130229',
  'sheng': '13',
  'di': '02',
  'xian': '29',
  'name': '玉田县',
  'level': 3
}, {
  'code': '130281',
  'sheng': '13',
  'di': '02',
  'xian': '81',
  'name': '遵化市',
  'level': 3
}, {
  'code': '130283',
  'sheng': '13',
  'di': '02',
  'xian': '83',
  'name': '迁安市',
  'level': 3
}, {
  'code': '130300',
  'sheng': '13',
  'di': '03',
  'xian': '00',
  'name': '秦皇岛市',
  'level': 2
}, {
  'code': '130301',
  'sheng': '13',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130302',
  'sheng': '13',
  'di': '03',
  'xian': '02',
  'name': '海港区',
  'level': 3
}, {
  'code': '130303',
  'sheng': '13',
  'di': '03',
  'xian': '03',
  'name': '山海关区',
  'level': 3
}, {
  'code': '130304',
  'sheng': '13',
  'di': '03',
  'xian': '04',
  'name': '北戴河区',
  'level': 3
}, {
  'code': '130321',
  'sheng': '13',
  'di': '03',
  'xian': '21',
  'name': '青龙满族自治县',
  'level': 3
}, {
  'code': '130322',
  'sheng': '13',
  'di': '03',
  'xian': '22',
  'name': '昌黎县',
  'level': 3
}, {
  'code': '130323',
  'sheng': '13',
  'di': '03',
  'xian': '23',
  'name': '抚宁县',
  'level': 3
}, {
  'code': '130324',
  'sheng': '13',
  'di': '03',
  'xian': '24',
  'name': '卢龙县',
  'level': 3
}, {
  'code': '130400',
  'sheng': '13',
  'di': '04',
  'xian': '00',
  'name': '邯郸市',
  'level': 2
}, {
  'code': '130401',
  'sheng': '13',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130402',
  'sheng': '13',
  'di': '04',
  'xian': '02',
  'name': '邯山区',
  'level': 3
}, {
  'code': '130403',
  'sheng': '13',
  'di': '04',
  'xian': '03',
  'name': '丛台区',
  'level': 3
}, {
  'code': '130404',
  'sheng': '13',
  'di': '04',
  'xian': '04',
  'name': '复兴区',
  'level': 3
}, {
  'code': '130406',
  'sheng': '13',
  'di': '04',
  'xian': '06',
  'name': '峰峰矿区',
  'level': 3
}, {
  'code': '130421',
  'sheng': '13',
  'di': '04',
  'xian': '21',
  'name': '邯郸县',
  'level': 3
}, {
  'code': '130423',
  'sheng': '13',
  'di': '04',
  'xian': '23',
  'name': '临漳县',
  'level': 3
}, {
  'code': '130424',
  'sheng': '13',
  'di': '04',
  'xian': '24',
  'name': '成安县',
  'level': 3
}, {
  'code': '130425',
  'sheng': '13',
  'di': '04',
  'xian': '25',
  'name': '大名县',
  'level': 3
}, {
  'code': '130426',
  'sheng': '13',
  'di': '04',
  'xian': '26',
  'name': '涉县',
  'level': 3
}, {
  'code': '130427',
  'sheng': '13',
  'di': '04',
  'xian': '27',
  'name': '磁县',
  'level': 3
}, {
  'code': '130428',
  'sheng': '13',
  'di': '04',
  'xian': '28',
  'name': '肥乡县',
  'level': 3
}, {
  'code': '130429',
  'sheng': '13',
  'di': '04',
  'xian': '29',
  'name': '永年县',
  'level': 3
}, {
  'code': '130430',
  'sheng': '13',
  'di': '04',
  'xian': '30',
  'name': '邱县',
  'level': 3
}, {
  'code': '130431',
  'sheng': '13',
  'di': '04',
  'xian': '31',
  'name': '鸡泽县',
  'level': 3
}, {
  'code': '130432',
  'sheng': '13',
  'di': '04',
  'xian': '32',
  'name': '广平县',
  'level': 3
}, {
  'code': '130433',
  'sheng': '13',
  'di': '04',
  'xian': '33',
  'name': '馆陶县',
  'level': 3
}, {
  'code': '130434',
  'sheng': '13',
  'di': '04',
  'xian': '34',
  'name': '魏县',
  'level': 3
}, {
  'code': '130435',
  'sheng': '13',
  'di': '04',
  'xian': '35',
  'name': '曲周县',
  'level': 3
}, {
  'code': '130481',
  'sheng': '13',
  'di': '04',
  'xian': '81',
  'name': '武安市',
  'level': 3
}, {
  'code': '130500',
  'sheng': '13',
  'di': '05',
  'xian': '00',
  'name': '邢台市',
  'level': 2
}, {
  'code': '130501',
  'sheng': '13',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130502',
  'sheng': '13',
  'di': '05',
  'xian': '02',
  'name': '桥东区',
  'level': 3
}, {
  'code': '130503',
  'sheng': '13',
  'di': '05',
  'xian': '03',
  'name': '桥西区',
  'level': 3
}, {
  'code': '130521',
  'sheng': '13',
  'di': '05',
  'xian': '21',
  'name': '邢台县',
  'level': 3
}, {
  'code': '130522',
  'sheng': '13',
  'di': '05',
  'xian': '22',
  'name': '临城县',
  'level': 3
}, {
  'code': '130523',
  'sheng': '13',
  'di': '05',
  'xian': '23',
  'name': '内丘县',
  'level': 3
}, {
  'code': '130524',
  'sheng': '13',
  'di': '05',
  'xian': '24',
  'name': '柏乡县',
  'level': 3
}, {
  'code': '130525',
  'sheng': '13',
  'di': '05',
  'xian': '25',
  'name': '隆尧县',
  'level': 3
}, {
  'code': '130526',
  'sheng': '13',
  'di': '05',
  'xian': '26',
  'name': '任县',
  'level': 3
}, {
  'code': '130527',
  'sheng': '13',
  'di': '05',
  'xian': '27',
  'name': '南和县',
  'level': 3
}, {
  'code': '130528',
  'sheng': '13',
  'di': '05',
  'xian': '28',
  'name': '宁晋县',
  'level': 3
}, {
  'code': '130529',
  'sheng': '13',
  'di': '05',
  'xian': '29',
  'name': '巨鹿县',
  'level': 3
}, {
  'code': '130530',
  'sheng': '13',
  'di': '05',
  'xian': '30',
  'name': '新河县',
  'level': 3
}, {
  'code': '130531',
  'sheng': '13',
  'di': '05',
  'xian': '31',
  'name': '广宗县',
  'level': 3
}, {
  'code': '130532',
  'sheng': '13',
  'di': '05',
  'xian': '32',
  'name': '平乡县',
  'level': 3
}, {
  'code': '130533',
  'sheng': '13',
  'di': '05',
  'xian': '33',
  'name': '威县',
  'level': 3
}, {
  'code': '130534',
  'sheng': '13',
  'di': '05',
  'xian': '34',
  'name': '清河县',
  'level': 3
}, {
  'code': '130535',
  'sheng': '13',
  'di': '05',
  'xian': '35',
  'name': '临西县',
  'level': 3
}, {
  'code': '130581',
  'sheng': '13',
  'di': '05',
  'xian': '81',
  'name': '南宫市',
  'level': 3
}, {
  'code': '130582',
  'sheng': '13',
  'di': '05',
  'xian': '82',
  'name': '沙河市',
  'level': 3
}, {
  'code': '130600',
  'sheng': '13',
  'di': '06',
  'xian': '00',
  'name': '保定市',
  'level': 2
}, {
  'code': '130601',
  'sheng': '13',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130602',
  'sheng': '13',
  'di': '06',
  'xian': '02',
  'name': '新市区',
  'level': 3
}, {
  'code': '130603',
  'sheng': '13',
  'di': '06',
  'xian': '03',
  'name': '北市区',
  'level': 3
}, {
  'code': '130604',
  'sheng': '13',
  'di': '06',
  'xian': '04',
  'name': '南市区',
  'level': 3
}, {
  'code': '130621',
  'sheng': '13',
  'di': '06',
  'xian': '21',
  'name': '满城县',
  'level': 3
}, {
  'code': '130622',
  'sheng': '13',
  'di': '06',
  'xian': '22',
  'name': '清苑县',
  'level': 3
}, {
  'code': '130623',
  'sheng': '13',
  'di': '06',
  'xian': '23',
  'name': '涞水县',
  'level': 3
}, {
  'code': '130624',
  'sheng': '13',
  'di': '06',
  'xian': '24',
  'name': '阜平县',
  'level': 3
}, {
  'code': '130625',
  'sheng': '13',
  'di': '06',
  'xian': '25',
  'name': '徐水县',
  'level': 3
}, {
  'code': '130626',
  'sheng': '13',
  'di': '06',
  'xian': '26',
  'name': '定兴县',
  'level': 3
}, {
  'code': '130627',
  'sheng': '13',
  'di': '06',
  'xian': '27',
  'name': '唐县',
  'level': 3
}, {
  'code': '130628',
  'sheng': '13',
  'di': '06',
  'xian': '28',
  'name': '高阳县',
  'level': 3
}, {
  'code': '130629',
  'sheng': '13',
  'di': '06',
  'xian': '29',
  'name': '容城县',
  'level': 3
}, {
  'code': '130630',
  'sheng': '13',
  'di': '06',
  'xian': '30',
  'name': '涞源县',
  'level': 3
}, {
  'code': '130631',
  'sheng': '13',
  'di': '06',
  'xian': '31',
  'name': '望都县',
  'level': 3
}, {
  'code': '130632',
  'sheng': '13',
  'di': '06',
  'xian': '32',
  'name': '安新县',
  'level': 3
}, {
  'code': '130633',
  'sheng': '13',
  'di': '06',
  'xian': '33',
  'name': '易县',
  'level': 3
}, {
  'code': '130634',
  'sheng': '13',
  'di': '06',
  'xian': '34',
  'name': '曲阳县',
  'level': 3
}, {
  'code': '130635',
  'sheng': '13',
  'di': '06',
  'xian': '35',
  'name': '蠡县',
  'level': 3
}, {
  'code': '130636',
  'sheng': '13',
  'di': '06',
  'xian': '36',
  'name': '顺平县',
  'level': 3
}, {
  'code': '130637',
  'sheng': '13',
  'di': '06',
  'xian': '37',
  'name': '博野县',
  'level': 3
}, {
  'code': '130638',
  'sheng': '13',
  'di': '06',
  'xian': '38',
  'name': '雄县',
  'level': 3
}, {
  'code': '130681',
  'sheng': '13',
  'di': '06',
  'xian': '81',
  'name': '涿州市',
  'level': 3
}, {
  'code': '130682',
  'sheng': '13',
  'di': '06',
  'xian': '82',
  'name': '定州市',
  'level': 3
}, {
  'code': '130683',
  'sheng': '13',
  'di': '06',
  'xian': '83',
  'name': '安国市',
  'level': 3
}, {
  'code': '130684',
  'sheng': '13',
  'di': '06',
  'xian': '84',
  'name': '高碑店市',
  'level': 3
}, {
  'code': '130700',
  'sheng': '13',
  'di': '07',
  'xian': '00',
  'name': '张家口市',
  'level': 2
}, {
  'code': '130701',
  'sheng': '13',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130702',
  'sheng': '13',
  'di': '07',
  'xian': '02',
  'name': '桥东区',
  'level': 3
}, {
  'code': '130703',
  'sheng': '13',
  'di': '07',
  'xian': '03',
  'name': '桥西区',
  'level': 3
}, {
  'code': '130705',
  'sheng': '13',
  'di': '07',
  'xian': '05',
  'name': '宣化区',
  'level': 3
}, {
  'code': '130706',
  'sheng': '13',
  'di': '07',
  'xian': '06',
  'name': '下花园区',
  'level': 3
}, {
  'code': '130721',
  'sheng': '13',
  'di': '07',
  'xian': '21',
  'name': '宣化县',
  'level': 3
}, {
  'code': '130722',
  'sheng': '13',
  'di': '07',
  'xian': '22',
  'name': '张北县',
  'level': 3
}, {
  'code': '130723',
  'sheng': '13',
  'di': '07',
  'xian': '23',
  'name': '康保县',
  'level': 3
}, {
  'code': '130724',
  'sheng': '13',
  'di': '07',
  'xian': '24',
  'name': '沽源县',
  'level': 3
}, {
  'code': '130725',
  'sheng': '13',
  'di': '07',
  'xian': '25',
  'name': '尚义县',
  'level': 3
}, {
  'code': '130726',
  'sheng': '13',
  'di': '07',
  'xian': '26',
  'name': '蔚县',
  'level': 3
}, {
  'code': '130727',
  'sheng': '13',
  'di': '07',
  'xian': '27',
  'name': '阳原县',
  'level': 3
}, {
  'code': '130728',
  'sheng': '13',
  'di': '07',
  'xian': '28',
  'name': '怀安县',
  'level': 3
}, {
  'code': '130729',
  'sheng': '13',
  'di': '07',
  'xian': '29',
  'name': '万全县',
  'level': 3
}, {
  'code': '130730',
  'sheng': '13',
  'di': '07',
  'xian': '30',
  'name': '怀来县',
  'level': 3
}, {
  'code': '130731',
  'sheng': '13',
  'di': '07',
  'xian': '31',
  'name': '涿鹿县',
  'level': 3
}, {
  'code': '130732',
  'sheng': '13',
  'di': '07',
  'xian': '32',
  'name': '赤城县',
  'level': 3
}, {
  'code': '130733',
  'sheng': '13',
  'di': '07',
  'xian': '33',
  'name': '崇礼县',
  'level': 3
}, {
  'code': '130800',
  'sheng': '13',
  'di': '08',
  'xian': '00',
  'name': '承德市',
  'level': 2
}, {
  'code': '130801',
  'sheng': '13',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130802',
  'sheng': '13',
  'di': '08',
  'xian': '02',
  'name': '双桥区',
  'level': 3
}, {
  'code': '130803',
  'sheng': '13',
  'di': '08',
  'xian': '03',
  'name': '双滦区',
  'level': 3
}, {
  'code': '130804',
  'sheng': '13',
  'di': '08',
  'xian': '04',
  'name': '鹰手营子矿区',
  'level': 3
}, {
  'code': '130821',
  'sheng': '13',
  'di': '08',
  'xian': '21',
  'name': '承德县',
  'level': 3
}, {
  'code': '130822',
  'sheng': '13',
  'di': '08',
  'xian': '22',
  'name': '兴隆县',
  'level': 3
}, {
  'code': '130823',
  'sheng': '13',
  'di': '08',
  'xian': '23',
  'name': '平泉县',
  'level': 3
}, {
  'code': '130824',
  'sheng': '13',
  'di': '08',
  'xian': '24',
  'name': '滦平县',
  'level': 3
}, {
  'code': '130825',
  'sheng': '13',
  'di': '08',
  'xian': '25',
  'name': '隆化县',
  'level': 3
}, {
  'code': '130826',
  'sheng': '13',
  'di': '08',
  'xian': '26',
  'name': '丰宁满族自治县',
  'level': 3
}, {
  'code': '130827',
  'sheng': '13',
  'di': '08',
  'xian': '27',
  'name': '宽城满族自治县',
  'level': 3
}, {
  'code': '130828',
  'sheng': '13',
  'di': '08',
  'xian': '28',
  'name': '围场满族蒙古族自治县',
  'level': 3
}, {
  'code': '130900',
  'sheng': '13',
  'di': '09',
  'xian': '00',
  'name': '沧州市',
  'level': 2
}, {
  'code': '130901',
  'sheng': '13',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '130902',
  'sheng': '13',
  'di': '09',
  'xian': '02',
  'name': '新华区',
  'level': 3
}, {
  'code': '130903',
  'sheng': '13',
  'di': '09',
  'xian': '03',
  'name': '运河区',
  'level': 3
}, {
  'code': '130921',
  'sheng': '13',
  'di': '09',
  'xian': '21',
  'name': '沧县',
  'level': 3
}, {
  'code': '130922',
  'sheng': '13',
  'di': '09',
  'xian': '22',
  'name': '青县',
  'level': 3
}, {
  'code': '130923',
  'sheng': '13',
  'di': '09',
  'xian': '23',
  'name': '东光县',
  'level': 3
}, {
  'code': '130924',
  'sheng': '13',
  'di': '09',
  'xian': '24',
  'name': '海兴县',
  'level': 3
}, {
  'code': '130925',
  'sheng': '13',
  'di': '09',
  'xian': '25',
  'name': '盐山县',
  'level': 3
}, {
  'code': '130926',
  'sheng': '13',
  'di': '09',
  'xian': '26',
  'name': '肃宁县',
  'level': 3
}, {
  'code': '130927',
  'sheng': '13',
  'di': '09',
  'xian': '27',
  'name': '南皮县',
  'level': 3
}, {
  'code': '130928',
  'sheng': '13',
  'di': '09',
  'xian': '28',
  'name': '吴桥县',
  'level': 3
}, {
  'code': '130929',
  'sheng': '13',
  'di': '09',
  'xian': '29',
  'name': '献县',
  'level': 3
}, {
  'code': '130930',
  'sheng': '13',
  'di': '09',
  'xian': '30',
  'name': '孟村回族自治县',
  'level': 3
}, {
  'code': '130981',
  'sheng': '13',
  'di': '09',
  'xian': '81',
  'name': '泊头市',
  'level': 3
}, {
  'code': '130982',
  'sheng': '13',
  'di': '09',
  'xian': '82',
  'name': '任丘市',
  'level': 3
}, {
  'code': '130983',
  'sheng': '13',
  'di': '09',
  'xian': '83',
  'name': '黄骅市',
  'level': 3
}, {
  'code': '130984',
  'sheng': '13',
  'di': '09',
  'xian': '84',
  'name': '河间市',
  'level': 3
}, {
  'code': '131000',
  'sheng': '13',
  'di': '10',
  'xian': '00',
  'name': '廊坊市',
  'level': 2
}, {
  'code': '131001',
  'sheng': '13',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '131002',
  'sheng': '13',
  'di': '10',
  'xian': '02',
  'name': '安次区',
  'level': 3
}, {
  'code': '131003',
  'sheng': '13',
  'di': '10',
  'xian': '03',
  'name': '广阳区',
  'level': 3
}, {
  'code': '131022',
  'sheng': '13',
  'di': '10',
  'xian': '22',
  'name': '固安县',
  'level': 3
}, {
  'code': '131023',
  'sheng': '13',
  'di': '10',
  'xian': '23',
  'name': '永清县',
  'level': 3
}, {
  'code': '131024',
  'sheng': '13',
  'di': '10',
  'xian': '24',
  'name': '香河县',
  'level': 3
}, {
  'code': '131025',
  'sheng': '13',
  'di': '10',
  'xian': '25',
  'name': '大城县',
  'level': 3
}, {
  'code': '131026',
  'sheng': '13',
  'di': '10',
  'xian': '26',
  'name': '文安县',
  'level': 3
}, {
  'code': '131028',
  'sheng': '13',
  'di': '10',
  'xian': '28',
  'name': '大厂回族自治县',
  'level': 3
}, {
  'code': '131081',
  'sheng': '13',
  'di': '10',
  'xian': '81',
  'name': '霸州市',
  'level': 3
}, {
  'code': '131082',
  'sheng': '13',
  'di': '10',
  'xian': '82',
  'name': '三河市',
  'level': 3
}, {
  'code': '131100',
  'sheng': '13',
  'di': '11',
  'xian': '00',
  'name': '衡水市',
  'level': 2
}, {
  'code': '131101',
  'sheng': '13',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '131102',
  'sheng': '13',
  'di': '11',
  'xian': '02',
  'name': '桃城区',
  'level': 3
}, {
  'code': '131121',
  'sheng': '13',
  'di': '11',
  'xian': '21',
  'name': '枣强县',
  'level': 3
}, {
  'code': '131122',
  'sheng': '13',
  'di': '11',
  'xian': '22',
  'name': '武邑县',
  'level': 3
}, {
  'code': '131123',
  'sheng': '13',
  'di': '11',
  'xian': '23',
  'name': '武强县',
  'level': 3
}, {
  'code': '131124',
  'sheng': '13',
  'di': '11',
  'xian': '24',
  'name': '饶阳县',
  'level': 3
}, {
  'code': '131125',
  'sheng': '13',
  'di': '11',
  'xian': '25',
  'name': '安平县',
  'level': 3
}, {
  'code': '131126',
  'sheng': '13',
  'di': '11',
  'xian': '26',
  'name': '故城县',
  'level': 3
}, {
  'code': '131127',
  'sheng': '13',
  'di': '11',
  'xian': '27',
  'name': '景县',
  'level': 3
}, {
  'code': '131128',
  'sheng': '13',
  'di': '11',
  'xian': '28',
  'name': '阜城县',
  'level': 3
}, {
  'code': '131181',
  'sheng': '13',
  'di': '11',
  'xian': '81',
  'name': '冀州市',
  'level': 3
}, {
  'code': '131182',
  'sheng': '13',
  'di': '11',
  'xian': '82',
  'name': '深州市',
  'level': 3
}, {
  'code': '140000',
  'sheng': '14',
  'di': '00',
  'xian': '00',
  'name': '山西省',
  'level': 1
}, {
  'code': '140100',
  'sheng': '14',
  'di': '01',
  'xian': '00',
  'name': '太原市',
  'level': 2
}, {
  'code': '140101',
  'sheng': '14',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140105',
  'sheng': '14',
  'di': '01',
  'xian': '05',
  'name': '小店区',
  'level': 3
}, {
  'code': '140106',
  'sheng': '14',
  'di': '01',
  'xian': '06',
  'name': '迎泽区',
  'level': 3
}, {
  'code': '140107',
  'sheng': '14',
  'di': '01',
  'xian': '07',
  'name': '杏花岭区',
  'level': 3
}, {
  'code': '140108',
  'sheng': '14',
  'di': '01',
  'xian': '08',
  'name': '尖草坪区',
  'level': 3
}, {
  'code': '140109',
  'sheng': '14',
  'di': '01',
  'xian': '09',
  'name': '万柏林区',
  'level': 3
}, {
  'code': '140110',
  'sheng': '14',
  'di': '01',
  'xian': '10',
  'name': '晋源区',
  'level': 3
}, {
  'code': '140121',
  'sheng': '14',
  'di': '01',
  'xian': '21',
  'name': '清徐县',
  'level': 3
}, {
  'code': '140122',
  'sheng': '14',
  'di': '01',
  'xian': '22',
  'name': '阳曲县',
  'level': 3
}, {
  'code': '140123',
  'sheng': '14',
  'di': '01',
  'xian': '23',
  'name': '娄烦县',
  'level': 3
}, {
  'code': '140181',
  'sheng': '14',
  'di': '01',
  'xian': '81',
  'name': '古交市',
  'level': 3
}, {
  'code': '140200',
  'sheng': '14',
  'di': '02',
  'xian': '00',
  'name': '大同市',
  'level': 2
}, {
  'code': '140201',
  'sheng': '14',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140202',
  'sheng': '14',
  'di': '02',
  'xian': '02',
  'name': '城区',
  'level': 3
}, {
  'code': '140203',
  'sheng': '14',
  'di': '02',
  'xian': '03',
  'name': '矿区',
  'level': 3
}, {
  'code': '140211',
  'sheng': '14',
  'di': '02',
  'xian': '11',
  'name': '南郊区',
  'level': 3
}, {
  'code': '140212',
  'sheng': '14',
  'di': '02',
  'xian': '12',
  'name': '新荣区',
  'level': 3
}, {
  'code': '140221',
  'sheng': '14',
  'di': '02',
  'xian': '21',
  'name': '阳高县',
  'level': 3
}, {
  'code': '140222',
  'sheng': '14',
  'di': '02',
  'xian': '22',
  'name': '天镇县',
  'level': 3
}, {
  'code': '140223',
  'sheng': '14',
  'di': '02',
  'xian': '23',
  'name': '广灵县',
  'level': 3
}, {
  'code': '140224',
  'sheng': '14',
  'di': '02',
  'xian': '24',
  'name': '灵丘县',
  'level': 3
}, {
  'code': '140225',
  'sheng': '14',
  'di': '02',
  'xian': '25',
  'name': '浑源县',
  'level': 3
}, {
  'code': '140226',
  'sheng': '14',
  'di': '02',
  'xian': '26',
  'name': '左云县',
  'level': 3
}, {
  'code': '140227',
  'sheng': '14',
  'di': '02',
  'xian': '27',
  'name': '大同县',
  'level': 3
}, {
  'code': '140300',
  'sheng': '14',
  'di': '03',
  'xian': '00',
  'name': '阳泉市',
  'level': 2
}, {
  'code': '140301',
  'sheng': '14',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140302',
  'sheng': '14',
  'di': '03',
  'xian': '02',
  'name': '城区',
  'level': 3
}, {
  'code': '140303',
  'sheng': '14',
  'di': '03',
  'xian': '03',
  'name': '矿区',
  'level': 3
}, {
  'code': '140311',
  'sheng': '14',
  'di': '03',
  'xian': '11',
  'name': '郊区',
  'level': 3
}, {
  'code': '140321',
  'sheng': '14',
  'di': '03',
  'xian': '21',
  'name': '平定县',
  'level': 3
}, {
  'code': '140322',
  'sheng': '14',
  'di': '03',
  'xian': '22',
  'name': '盂县',
  'level': 3
}, {
  'code': '140400',
  'sheng': '14',
  'di': '04',
  'xian': '00',
  'name': '长治市',
  'level': 2
}, {
  'code': '140401',
  'sheng': '14',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140402',
  'sheng': '14',
  'di': '04',
  'xian': '02',
  'name': '城区',
  'level': 3
}, {
  'code': '140411',
  'sheng': '14',
  'di': '04',
  'xian': '11',
  'name': '郊区',
  'level': 3
}, {
  'code': '140421',
  'sheng': '14',
  'di': '04',
  'xian': '21',
  'name': '长治县',
  'level': 3
}, {
  'code': '140423',
  'sheng': '14',
  'di': '04',
  'xian': '23',
  'name': '襄垣县',
  'level': 3
}, {
  'code': '140424',
  'sheng': '14',
  'di': '04',
  'xian': '24',
  'name': '屯留县',
  'level': 3
}, {
  'code': '140425',
  'sheng': '14',
  'di': '04',
  'xian': '25',
  'name': '平顺县',
  'level': 3
}, {
  'code': '140426',
  'sheng': '14',
  'di': '04',
  'xian': '26',
  'name': '黎城县',
  'level': 3
}, {
  'code': '140427',
  'sheng': '14',
  'di': '04',
  'xian': '27',
  'name': '壶关县',
  'level': 3
}, {
  'code': '140428',
  'sheng': '14',
  'di': '04',
  'xian': '28',
  'name': '长子县',
  'level': 3
}, {
  'code': '140429',
  'sheng': '14',
  'di': '04',
  'xian': '29',
  'name': '武乡县',
  'level': 3
}, {
  'code': '140430',
  'sheng': '14',
  'di': '04',
  'xian': '30',
  'name': '沁县',
  'level': 3
}, {
  'code': '140431',
  'sheng': '14',
  'di': '04',
  'xian': '31',
  'name': '沁源县',
  'level': 3
}, {
  'code': '140481',
  'sheng': '14',
  'di': '04',
  'xian': '81',
  'name': '潞城市',
  'level': 3
}, {
  'code': '140500',
  'sheng': '14',
  'di': '05',
  'xian': '00',
  'name': '晋城市',
  'level': 2
}, {
  'code': '140501',
  'sheng': '14',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140502',
  'sheng': '14',
  'di': '05',
  'xian': '02',
  'name': '城区',
  'level': 3
}, {
  'code': '140521',
  'sheng': '14',
  'di': '05',
  'xian': '21',
  'name': '沁水县',
  'level': 3
}, {
  'code': '140522',
  'sheng': '14',
  'di': '05',
  'xian': '22',
  'name': '阳城县',
  'level': 3
}, {
  'code': '140524',
  'sheng': '14',
  'di': '05',
  'xian': '24',
  'name': '陵川县',
  'level': 3
}, {
  'code': '140525',
  'sheng': '14',
  'di': '05',
  'xian': '25',
  'name': '泽州县',
  'level': 3
}, {
  'code': '140581',
  'sheng': '14',
  'di': '05',
  'xian': '81',
  'name': '高平市',
  'level': 3
}, {
  'code': '140600',
  'sheng': '14',
  'di': '06',
  'xian': '00',
  'name': '朔州市',
  'level': 2
}, {
  'code': '140601',
  'sheng': '14',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140602',
  'sheng': '14',
  'di': '06',
  'xian': '02',
  'name': '朔城区',
  'level': 3
}, {
  'code': '140603',
  'sheng': '14',
  'di': '06',
  'xian': '03',
  'name': '平鲁区',
  'level': 3
}, {
  'code': '140621',
  'sheng': '14',
  'di': '06',
  'xian': '21',
  'name': '山阴县',
  'level': 3
}, {
  'code': '140622',
  'sheng': '14',
  'di': '06',
  'xian': '22',
  'name': '应县',
  'level': 3
}, {
  'code': '140623',
  'sheng': '14',
  'di': '06',
  'xian': '23',
  'name': '右玉县',
  'level': 3
}, {
  'code': '140624',
  'sheng': '14',
  'di': '06',
  'xian': '24',
  'name': '怀仁县',
  'level': 3
}, {
  'code': '140700',
  'sheng': '14',
  'di': '07',
  'xian': '00',
  'name': '晋中市',
  'level': 2
}, {
  'code': '140701',
  'sheng': '14',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140702',
  'sheng': '14',
  'di': '07',
  'xian': '02',
  'name': '榆次区',
  'level': 3
}, {
  'code': '140721',
  'sheng': '14',
  'di': '07',
  'xian': '21',
  'name': '榆社县',
  'level': 3
}, {
  'code': '140722',
  'sheng': '14',
  'di': '07',
  'xian': '22',
  'name': '左权县',
  'level': 3
}, {
  'code': '140723',
  'sheng': '14',
  'di': '07',
  'xian': '23',
  'name': '和顺县',
  'level': 3
}, {
  'code': '140724',
  'sheng': '14',
  'di': '07',
  'xian': '24',
  'name': '昔阳县',
  'level': 3
}, {
  'code': '140725',
  'sheng': '14',
  'di': '07',
  'xian': '25',
  'name': '寿阳县',
  'level': 3
}, {
  'code': '140726',
  'sheng': '14',
  'di': '07',
  'xian': '26',
  'name': '太谷县',
  'level': 3
}, {
  'code': '140727',
  'sheng': '14',
  'di': '07',
  'xian': '27',
  'name': '祁县',
  'level': 3
}, {
  'code': '140728',
  'sheng': '14',
  'di': '07',
  'xian': '28',
  'name': '平遥县',
  'level': 3
}, {
  'code': '140729',
  'sheng': '14',
  'di': '07',
  'xian': '29',
  'name': '灵石县',
  'level': 3
}, {
  'code': '140781',
  'sheng': '14',
  'di': '07',
  'xian': '81',
  'name': '介休市',
  'level': 3
}, {
  'code': '140800',
  'sheng': '14',
  'di': '08',
  'xian': '00',
  'name': '运城市',
  'level': 2
}, {
  'code': '140801',
  'sheng': '14',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140802',
  'sheng': '14',
  'di': '08',
  'xian': '02',
  'name': '盐湖区',
  'level': 3
}, {
  'code': '140821',
  'sheng': '14',
  'di': '08',
  'xian': '21',
  'name': '临猗县',
  'level': 3
}, {
  'code': '140822',
  'sheng': '14',
  'di': '08',
  'xian': '22',
  'name': '万荣县',
  'level': 3
}, {
  'code': '140823',
  'sheng': '14',
  'di': '08',
  'xian': '23',
  'name': '闻喜县',
  'level': 3
}, {
  'code': '140824',
  'sheng': '14',
  'di': '08',
  'xian': '24',
  'name': '稷山县',
  'level': 3
}, {
  'code': '140825',
  'sheng': '14',
  'di': '08',
  'xian': '25',
  'name': '新绛县',
  'level': 3
}, {
  'code': '140826',
  'sheng': '14',
  'di': '08',
  'xian': '26',
  'name': '绛县',
  'level': 3
}, {
  'code': '140827',
  'sheng': '14',
  'di': '08',
  'xian': '27',
  'name': '垣曲县',
  'level': 3
}, {
  'code': '140828',
  'sheng': '14',
  'di': '08',
  'xian': '28',
  'name': '夏县',
  'level': 3
}, {
  'code': '140829',
  'sheng': '14',
  'di': '08',
  'xian': '29',
  'name': '平陆县',
  'level': 3
}, {
  'code': '140830',
  'sheng': '14',
  'di': '08',
  'xian': '30',
  'name': '芮城县',
  'level': 3
}, {
  'code': '140881',
  'sheng': '14',
  'di': '08',
  'xian': '81',
  'name': '永济市',
  'level': 3
}, {
  'code': '140882',
  'sheng': '14',
  'di': '08',
  'xian': '82',
  'name': '河津市',
  'level': 3
}, {
  'code': '140900',
  'sheng': '14',
  'di': '09',
  'xian': '00',
  'name': '忻州市',
  'level': 2
}, {
  'code': '140901',
  'sheng': '14',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '140902',
  'sheng': '14',
  'di': '09',
  'xian': '02',
  'name': '忻府区',
  'level': 3
}, {
  'code': '140921',
  'sheng': '14',
  'di': '09',
  'xian': '21',
  'name': '定襄县',
  'level': 3
}, {
  'code': '140922',
  'sheng': '14',
  'di': '09',
  'xian': '22',
  'name': '五台县',
  'level': 3
}, {
  'code': '140923',
  'sheng': '14',
  'di': '09',
  'xian': '23',
  'name': '代县',
  'level': 3
}, {
  'code': '140924',
  'sheng': '14',
  'di': '09',
  'xian': '24',
  'name': '繁峙县',
  'level': 3
}, {
  'code': '140925',
  'sheng': '14',
  'di': '09',
  'xian': '25',
  'name': '宁武县',
  'level': 3
}, {
  'code': '140926',
  'sheng': '14',
  'di': '09',
  'xian': '26',
  'name': '静乐县',
  'level': 3
}, {
  'code': '140927',
  'sheng': '14',
  'di': '09',
  'xian': '27',
  'name': '神池县',
  'level': 3
}, {
  'code': '140928',
  'sheng': '14',
  'di': '09',
  'xian': '28',
  'name': '五寨县',
  'level': 3
}, {
  'code': '140929',
  'sheng': '14',
  'di': '09',
  'xian': '29',
  'name': '岢岚县',
  'level': 3
}, {
  'code': '140930',
  'sheng': '14',
  'di': '09',
  'xian': '30',
  'name': '河曲县',
  'level': 3
}, {
  'code': '140931',
  'sheng': '14',
  'di': '09',
  'xian': '31',
  'name': '保德县',
  'level': 3
}, {
  'code': '140932',
  'sheng': '14',
  'di': '09',
  'xian': '32',
  'name': '偏关县',
  'level': 3
}, {
  'code': '140981',
  'sheng': '14',
  'di': '09',
  'xian': '81',
  'name': '原平市',
  'level': 3
}, {
  'code': '141000',
  'sheng': '14',
  'di': '10',
  'xian': '00',
  'name': '临汾市',
  'level': 2
}, {
  'code': '141001',
  'sheng': '14',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '141002',
  'sheng': '14',
  'di': '10',
  'xian': '02',
  'name': '尧都区',
  'level': 3
}, {
  'code': '141021',
  'sheng': '14',
  'di': '10',
  'xian': '21',
  'name': '曲沃县',
  'level': 3
}, {
  'code': '141022',
  'sheng': '14',
  'di': '10',
  'xian': '22',
  'name': '翼城县',
  'level': 3
}, {
  'code': '141023',
  'sheng': '14',
  'di': '10',
  'xian': '23',
  'name': '襄汾县',
  'level': 3
}, {
  'code': '141024',
  'sheng': '14',
  'di': '10',
  'xian': '24',
  'name': '洪洞县',
  'level': 3
}, {
  'code': '141025',
  'sheng': '14',
  'di': '10',
  'xian': '25',
  'name': '古县',
  'level': 3
}, {
  'code': '141026',
  'sheng': '14',
  'di': '10',
  'xian': '26',
  'name': '安泽县',
  'level': 3
}, {
  'code': '141027',
  'sheng': '14',
  'di': '10',
  'xian': '27',
  'name': '浮山县',
  'level': 3
}, {
  'code': '141028',
  'sheng': '14',
  'di': '10',
  'xian': '28',
  'name': '吉县',
  'level': 3
}, {
  'code': '141029',
  'sheng': '14',
  'di': '10',
  'xian': '29',
  'name': '乡宁县',
  'level': 3
}, {
  'code': '141030',
  'sheng': '14',
  'di': '10',
  'xian': '30',
  'name': '大宁县',
  'level': 3
}, {
  'code': '141031',
  'sheng': '14',
  'di': '10',
  'xian': '31',
  'name': '隰县',
  'level': 3
}, {
  'code': '141032',
  'sheng': '14',
  'di': '10',
  'xian': '32',
  'name': '永和县',
  'level': 3
}, {
  'code': '141033',
  'sheng': '14',
  'di': '10',
  'xian': '33',
  'name': '蒲县',
  'level': 3
}, {
  'code': '141034',
  'sheng': '14',
  'di': '10',
  'xian': '34',
  'name': '汾西县',
  'level': 3
}, {
  'code': '141081',
  'sheng': '14',
  'di': '10',
  'xian': '81',
  'name': '侯马市',
  'level': 3
}, {
  'code': '141082',
  'sheng': '14',
  'di': '10',
  'xian': '82',
  'name': '霍州市',
  'level': 3
}, {
  'code': '141100',
  'sheng': '14',
  'di': '11',
  'xian': '00',
  'name': '吕梁市',
  'level': 2
}, {
  'code': '141101',
  'sheng': '14',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '141102',
  'sheng': '14',
  'di': '11',
  'xian': '02',
  'name': '离石区',
  'level': 3
}, {
  'code': '141121',
  'sheng': '14',
  'di': '11',
  'xian': '21',
  'name': '文水县',
  'level': 3
}, {
  'code': '141122',
  'sheng': '14',
  'di': '11',
  'xian': '22',
  'name': '交城县',
  'level': 3
}, {
  'code': '141123',
  'sheng': '14',
  'di': '11',
  'xian': '23',
  'name': '兴县',
  'level': 3
}, {
  'code': '141124',
  'sheng': '14',
  'di': '11',
  'xian': '24',
  'name': '临县',
  'level': 3
}, {
  'code': '141125',
  'sheng': '14',
  'di': '11',
  'xian': '25',
  'name': '柳林县',
  'level': 3
}, {
  'code': '141126',
  'sheng': '14',
  'di': '11',
  'xian': '26',
  'name': '石楼县',
  'level': 3
}, {
  'code': '141127',
  'sheng': '14',
  'di': '11',
  'xian': '27',
  'name': '岚县',
  'level': 3
}, {
  'code': '141128',
  'sheng': '14',
  'di': '11',
  'xian': '28',
  'name': '方山县',
  'level': 3
}, {
  'code': '141129',
  'sheng': '14',
  'di': '11',
  'xian': '29',
  'name': '中阳县',
  'level': 3
}, {
  'code': '141130',
  'sheng': '14',
  'di': '11',
  'xian': '30',
  'name': '交口县',
  'level': 3
}, {
  'code': '141181',
  'sheng': '14',
  'di': '11',
  'xian': '81',
  'name': '孝义市',
  'level': 3
}, {
  'code': '141182',
  'sheng': '14',
  'di': '11',
  'xian': '82',
  'name': '汾阳市',
  'level': 3
}, {
  'code': '150000',
  'sheng': '15',
  'di': '00',
  'xian': '00',
  'name': '内蒙古自治区',
  'level': 1
}, {
  'code': '150100',
  'sheng': '15',
  'di': '01',
  'xian': '00',
  'name': '呼和浩特市',
  'level': 2
}, {
  'code': '150101',
  'sheng': '15',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150102',
  'sheng': '15',
  'di': '01',
  'xian': '02',
  'name': '新城区',
  'level': 3
}, {
  'code': '150103',
  'sheng': '15',
  'di': '01',
  'xian': '03',
  'name': '回民区',
  'level': 3
}, {
  'code': '150104',
  'sheng': '15',
  'di': '01',
  'xian': '04',
  'name': '玉泉区',
  'level': 3
}, {
  'code': '150105',
  'sheng': '15',
  'di': '01',
  'xian': '05',
  'name': '赛罕区',
  'level': 3
}, {
  'code': '150121',
  'sheng': '15',
  'di': '01',
  'xian': '21',
  'name': '土默特左旗',
  'level': 3
}, {
  'code': '150122',
  'sheng': '15',
  'di': '01',
  'xian': '22',
  'name': '托克托县',
  'level': 3
}, {
  'code': '150123',
  'sheng': '15',
  'di': '01',
  'xian': '23',
  'name': '和林格尔县',
  'level': 3
}, {
  'code': '150124',
  'sheng': '15',
  'di': '01',
  'xian': '24',
  'name': '清水河县',
  'level': 3
}, {
  'code': '150125',
  'sheng': '15',
  'di': '01',
  'xian': '25',
  'name': '武川县',
  'level': 3
}, {
  'code': '150200',
  'sheng': '15',
  'di': '02',
  'xian': '00',
  'name': '包头市',
  'level': 2
}, {
  'code': '150201',
  'sheng': '15',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150202',
  'sheng': '15',
  'di': '02',
  'xian': '02',
  'name': '东河区',
  'level': 3
}, {
  'code': '150203',
  'sheng': '15',
  'di': '02',
  'xian': '03',
  'name': '昆都仑区',
  'level': 3
}, {
  'code': '150204',
  'sheng': '15',
  'di': '02',
  'xian': '04',
  'name': '青山区',
  'level': 3
}, {
  'code': '150205',
  'sheng': '15',
  'di': '02',
  'xian': '05',
  'name': '石拐区',
  'level': 3
}, {
  'code': '150206',
  'sheng': '15',
  'di': '02',
  'xian': '06',
  'name': '白云鄂博矿区',
  'level': 3
}, {
  'code': '150207',
  'sheng': '15',
  'di': '02',
  'xian': '07',
  'name': '九原区',
  'level': 3
}, {
  'code': '150221',
  'sheng': '15',
  'di': '02',
  'xian': '21',
  'name': '土默特右旗',
  'level': 3
}, {
  'code': '150222',
  'sheng': '15',
  'di': '02',
  'xian': '22',
  'name': '固阳县',
  'level': 3
}, {
  'code': '150223',
  'sheng': '15',
  'di': '02',
  'xian': '23',
  'name': '达尔罕茂明安联合旗',
  'level': 3
}, {
  'code': '150300',
  'sheng': '15',
  'di': '03',
  'xian': '00',
  'name': '乌海市',
  'level': 2
}, {
  'code': '150301',
  'sheng': '15',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150302',
  'sheng': '15',
  'di': '03',
  'xian': '02',
  'name': '海勃湾区',
  'level': 3
}, {
  'code': '150303',
  'sheng': '15',
  'di': '03',
  'xian': '03',
  'name': '海南区',
  'level': 3
}, {
  'code': '150304',
  'sheng': '15',
  'di': '03',
  'xian': '04',
  'name': '乌达区',
  'level': 3
}, {
  'code': '150400',
  'sheng': '15',
  'di': '04',
  'xian': '00',
  'name': '赤峰市',
  'level': 2
}, {
  'code': '150401',
  'sheng': '15',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150402',
  'sheng': '15',
  'di': '04',
  'xian': '02',
  'name': '红山区',
  'level': 3
}, {
  'code': '150403',
  'sheng': '15',
  'di': '04',
  'xian': '03',
  'name': '元宝山区',
  'level': 3
}, {
  'code': '150404',
  'sheng': '15',
  'di': '04',
  'xian': '04',
  'name': '松山区',
  'level': 3
}, {
  'code': '150421',
  'sheng': '15',
  'di': '04',
  'xian': '21',
  'name': '阿鲁科尔沁旗',
  'level': 3
}, {
  'code': '150422',
  'sheng': '15',
  'di': '04',
  'xian': '22',
  'name': '巴林左旗',
  'level': 3
}, {
  'code': '150423',
  'sheng': '15',
  'di': '04',
  'xian': '23',
  'name': '巴林右旗',
  'level': 3
}, {
  'code': '150424',
  'sheng': '15',
  'di': '04',
  'xian': '24',
  'name': '林西县',
  'level': 3
}, {
  'code': '150425',
  'sheng': '15',
  'di': '04',
  'xian': '25',
  'name': '克什克腾旗',
  'level': 3
}, {
  'code': '150426',
  'sheng': '15',
  'di': '04',
  'xian': '26',
  'name': '翁牛特旗',
  'level': 3
}, {
  'code': '150428',
  'sheng': '15',
  'di': '04',
  'xian': '28',
  'name': '喀喇沁旗',
  'level': 3
}, {
  'code': '150429',
  'sheng': '15',
  'di': '04',
  'xian': '29',
  'name': '宁城县',
  'level': 3
}, {
  'code': '150430',
  'sheng': '15',
  'di': '04',
  'xian': '30',
  'name': '敖汉旗',
  'level': 3
}, {
  'code': '150500',
  'sheng': '15',
  'di': '05',
  'xian': '00',
  'name': '通辽市',
  'level': 2
}, {
  'code': '150501',
  'sheng': '15',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150502',
  'sheng': '15',
  'di': '05',
  'xian': '02',
  'name': '科尔沁区',
  'level': 3
}, {
  'code': '150521',
  'sheng': '15',
  'di': '05',
  'xian': '21',
  'name': '科尔沁左翼中旗',
  'level': 3
}, {
  'code': '150522',
  'sheng': '15',
  'di': '05',
  'xian': '22',
  'name': '科尔沁左翼后旗',
  'level': 3
}, {
  'code': '150523',
  'sheng': '15',
  'di': '05',
  'xian': '23',
  'name': '开鲁县',
  'level': 3
}, {
  'code': '150524',
  'sheng': '15',
  'di': '05',
  'xian': '24',
  'name': '库伦旗',
  'level': 3
}, {
  'code': '150525',
  'sheng': '15',
  'di': '05',
  'xian': '25',
  'name': '奈曼旗',
  'level': 3
}, {
  'code': '150526',
  'sheng': '15',
  'di': '05',
  'xian': '26',
  'name': '扎鲁特旗',
  'level': 3
}, {
  'code': '150581',
  'sheng': '15',
  'di': '05',
  'xian': '81',
  'name': '霍林郭勒市',
  'level': 3
}, {
  'code': '150600',
  'sheng': '15',
  'di': '06',
  'xian': '00',
  'name': '鄂尔多斯市',
  'level': 2
}, {
  'code': '150601',
  'sheng': '15',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150602',
  'sheng': '15',
  'di': '06',
  'xian': '02',
  'name': '东胜区',
  'level': 3
}, {
  'code': '150621',
  'sheng': '15',
  'di': '06',
  'xian': '21',
  'name': '达拉特旗',
  'level': 3
}, {
  'code': '150622',
  'sheng': '15',
  'di': '06',
  'xian': '22',
  'name': '准格尔旗',
  'level': 3
}, {
  'code': '150623',
  'sheng': '15',
  'di': '06',
  'xian': '23',
  'name': '鄂托克前旗',
  'level': 3
}, {
  'code': '150624',
  'sheng': '15',
  'di': '06',
  'xian': '24',
  'name': '鄂托克旗',
  'level': 3
}, {
  'code': '150625',
  'sheng': '15',
  'di': '06',
  'xian': '25',
  'name': '杭锦旗',
  'level': 3
}, {
  'code': '150626',
  'sheng': '15',
  'di': '06',
  'xian': '26',
  'name': '乌审旗',
  'level': 3
}, {
  'code': '150627',
  'sheng': '15',
  'di': '06',
  'xian': '27',
  'name': '伊金霍洛旗',
  'level': 3
}, {
  'code': '150700',
  'sheng': '15',
  'di': '07',
  'xian': '00',
  'name': '呼伦贝尔市',
  'level': 2
}, {
  'code': '150701',
  'sheng': '15',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150702',
  'sheng': '15',
  'di': '07',
  'xian': '02',
  'name': '海拉尔区',
  'level': 3
}, {
  'code': '150703',
  'sheng': '15',
  'di': '07',
  'xian': '03',
  'name': '扎赉诺尔区',
  'level': 3
}, {
  'code': '150721',
  'sheng': '15',
  'di': '07',
  'xian': '21',
  'name': '阿荣旗',
  'level': 3
}, {
  'code': '150722',
  'sheng': '15',
  'di': '07',
  'xian': '22',
  'name': '莫力达瓦达斡尔族自治旗',
  'level': 3
}, {
  'code': '150723',
  'sheng': '15',
  'di': '07',
  'xian': '23',
  'name': '鄂伦春自治旗',
  'level': 3
}, {
  'code': '150724',
  'sheng': '15',
  'di': '07',
  'xian': '24',
  'name': '鄂温克族自治旗',
  'level': 3
}, {
  'code': '150725',
  'sheng': '15',
  'di': '07',
  'xian': '25',
  'name': '陈巴尔虎旗',
  'level': 3
}, {
  'code': '150726',
  'sheng': '15',
  'di': '07',
  'xian': '26',
  'name': '新巴尔虎左旗',
  'level': 3
}, {
  'code': '150727',
  'sheng': '15',
  'di': '07',
  'xian': '27',
  'name': '新巴尔虎右旗',
  'level': 3
}, {
  'code': '150781',
  'sheng': '15',
  'di': '07',
  'xian': '81',
  'name': '满洲里市',
  'level': 3
}, {
  'code': '150782',
  'sheng': '15',
  'di': '07',
  'xian': '82',
  'name': '牙克石市',
  'level': 3
}, {
  'code': '150783',
  'sheng': '15',
  'di': '07',
  'xian': '83',
  'name': '扎兰屯市',
  'level': 3
}, {
  'code': '150784',
  'sheng': '15',
  'di': '07',
  'xian': '84',
  'name': '额尔古纳市',
  'level': 3
}, {
  'code': '150785',
  'sheng': '15',
  'di': '07',
  'xian': '85',
  'name': '根河市',
  'level': 3
}, {
  'code': '150800',
  'sheng': '15',
  'di': '08',
  'xian': '00',
  'name': '巴彦淖尔市',
  'level': 2
}, {
  'code': '150801',
  'sheng': '15',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150802',
  'sheng': '15',
  'di': '08',
  'xian': '02',
  'name': '临河区',
  'level': 3
}, {
  'code': '150821',
  'sheng': '15',
  'di': '08',
  'xian': '21',
  'name': '五原县',
  'level': 3
}, {
  'code': '150822',
  'sheng': '15',
  'di': '08',
  'xian': '22',
  'name': '磴口县',
  'level': 3
}, {
  'code': '150823',
  'sheng': '15',
  'di': '08',
  'xian': '23',
  'name': '乌拉特前旗',
  'level': 3
}, {
  'code': '150824',
  'sheng': '15',
  'di': '08',
  'xian': '24',
  'name': '乌拉特中旗',
  'level': 3
}, {
  'code': '150825',
  'sheng': '15',
  'di': '08',
  'xian': '25',
  'name': '乌拉特后旗',
  'level': 3
}, {
  'code': '150826',
  'sheng': '15',
  'di': '08',
  'xian': '26',
  'name': '杭锦后旗',
  'level': 3
}, {
  'code': '150900',
  'sheng': '15',
  'di': '09',
  'xian': '00',
  'name': '乌兰察布市',
  'level': 2
}, {
  'code': '150901',
  'sheng': '15',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '150902',
  'sheng': '15',
  'di': '09',
  'xian': '02',
  'name': '集宁区',
  'level': 3
}, {
  'code': '150921',
  'sheng': '15',
  'di': '09',
  'xian': '21',
  'name': '卓资县',
  'level': 3
}, {
  'code': '150922',
  'sheng': '15',
  'di': '09',
  'xian': '22',
  'name': '化德县',
  'level': 3
}, {
  'code': '150923',
  'sheng': '15',
  'di': '09',
  'xian': '23',
  'name': '商都县',
  'level': 3
}, {
  'code': '150924',
  'sheng': '15',
  'di': '09',
  'xian': '24',
  'name': '兴和县',
  'level': 3
}, {
  'code': '150925',
  'sheng': '15',
  'di': '09',
  'xian': '25',
  'name': '凉城县',
  'level': 3
}, {
  'code': '150926',
  'sheng': '15',
  'di': '09',
  'xian': '26',
  'name': '察哈尔右翼前旗',
  'level': 3
}, {
  'code': '150927',
  'sheng': '15',
  'di': '09',
  'xian': '27',
  'name': '察哈尔右翼中旗',
  'level': 3
}, {
  'code': '150928',
  'sheng': '15',
  'di': '09',
  'xian': '28',
  'name': '察哈尔右翼后旗',
  'level': 3
}, {
  'code': '150929',
  'sheng': '15',
  'di': '09',
  'xian': '29',
  'name': '四子王旗',
  'level': 3
}, {
  'code': '150981',
  'sheng': '15',
  'di': '09',
  'xian': '81',
  'name': '丰镇市',
  'level': 3
}, {
  'code': '152200',
  'sheng': '15',
  'di': '22',
  'xian': '00',
  'name': '兴安盟',
  'level': 2
}, {
  'code': '152201',
  'sheng': '15',
  'di': '22',
  'xian': '01',
  'name': '乌兰浩特市',
  'level': 3
}, {
  'code': '152202',
  'sheng': '15',
  'di': '22',
  'xian': '02',
  'name': '阿尔山市',
  'level': 3
}, {
  'code': '152221',
  'sheng': '15',
  'di': '22',
  'xian': '21',
  'name': '科尔沁右翼前旗',
  'level': 3
}, {
  'code': '152222',
  'sheng': '15',
  'di': '22',
  'xian': '22',
  'name': '科尔沁右翼中旗',
  'level': 3
}, {
  'code': '152223',
  'sheng': '15',
  'di': '22',
  'xian': '23',
  'name': '扎赉特旗',
  'level': 3
}, {
  'code': '152224',
  'sheng': '15',
  'di': '22',
  'xian': '24',
  'name': '突泉县',
  'level': 3
}, {
  'code': '152500',
  'sheng': '15',
  'di': '25',
  'xian': '00',
  'name': '锡林郭勒盟',
  'level': 2
}, {
  'code': '152501',
  'sheng': '15',
  'di': '25',
  'xian': '01',
  'name': '二连浩特市',
  'level': 3
}, {
  'code': '152502',
  'sheng': '15',
  'di': '25',
  'xian': '02',
  'name': '锡林浩特市',
  'level': 3
}, {
  'code': '152522',
  'sheng': '15',
  'di': '25',
  'xian': '22',
  'name': '阿巴嘎旗',
  'level': 3
}, {
  'code': '152523',
  'sheng': '15',
  'di': '25',
  'xian': '23',
  'name': '苏尼特左旗',
  'level': 3
}, {
  'code': '152524',
  'sheng': '15',
  'di': '25',
  'xian': '24',
  'name': '苏尼特右旗',
  'level': 3
}, {
  'code': '152525',
  'sheng': '15',
  'di': '25',
  'xian': '25',
  'name': '东乌珠穆沁旗',
  'level': 3
}, {
  'code': '152526',
  'sheng': '15',
  'di': '25',
  'xian': '26',
  'name': '西乌珠穆沁旗',
  'level': 3
}, {
  'code': '152527',
  'sheng': '15',
  'di': '25',
  'xian': '27',
  'name': '太仆寺旗',
  'level': 3
}, {
  'code': '152528',
  'sheng': '15',
  'di': '25',
  'xian': '28',
  'name': '镶黄旗',
  'level': 3
}, {
  'code': '152529',
  'sheng': '15',
  'di': '25',
  'xian': '29',
  'name': '正镶白旗',
  'level': 3
}, {
  'code': '152530',
  'sheng': '15',
  'di': '25',
  'xian': '30',
  'name': '正蓝旗',
  'level': 3
}, {
  'code': '152531',
  'sheng': '15',
  'di': '25',
  'xian': '31',
  'name': '多伦县',
  'level': 3
}, {
  'code': '152900',
  'sheng': '15',
  'di': '29',
  'xian': '00',
  'name': '阿拉善盟',
  'level': 2
}, {
  'code': '152921',
  'sheng': '15',
  'di': '29',
  'xian': '21',
  'name': '阿拉善左旗',
  'level': 3
}, {
  'code': '152922',
  'sheng': '15',
  'di': '29',
  'xian': '22',
  'name': '阿拉善右旗',
  'level': 3
}, {
  'code': '152923',
  'sheng': '15',
  'di': '29',
  'xian': '23',
  'name': '额济纳旗',
  'level': 3
}, {
  'code': '210000',
  'sheng': '21',
  'di': '00',
  'xian': '00',
  'name': '辽宁省',
  'level': 1
}, {
  'code': '210100',
  'sheng': '21',
  'di': '01',
  'xian': '00',
  'name': '沈阳市',
  'level': 2
}, {
  'code': '210101',
  'sheng': '21',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210102',
  'sheng': '21',
  'di': '01',
  'xian': '02',
  'name': '和平区',
  'level': 3
}, {
  'code': '210103',
  'sheng': '21',
  'di': '01',
  'xian': '03',
  'name': '沈河区',
  'level': 3
}, {
  'code': '210104',
  'sheng': '21',
  'di': '01',
  'xian': '04',
  'name': '大东区',
  'level': 3
}, {
  'code': '210105',
  'sheng': '21',
  'di': '01',
  'xian': '05',
  'name': '皇姑区',
  'level': 3
}, {
  'code': '210106',
  'sheng': '21',
  'di': '01',
  'xian': '06',
  'name': '铁西区',
  'level': 3
}, {
  'code': '210111',
  'sheng': '21',
  'di': '01',
  'xian': '11',
  'name': '苏家屯区',
  'level': 3
}, {
  'code': '210112',
  'sheng': '21',
  'di': '01',
  'xian': '12',
  'name': '浑南区',
  'level': 3
}, {
  'code': '210113',
  'sheng': '21',
  'di': '01',
  'xian': '13',
  'name': '沈北新区',
  'level': 3
}, {
  'code': '210114',
  'sheng': '21',
  'di': '01',
  'xian': '14',
  'name': '于洪区',
  'level': 3
}, {
  'code': '210122',
  'sheng': '21',
  'di': '01',
  'xian': '22',
  'name': '辽中县',
  'level': 3
}, {
  'code': '210123',
  'sheng': '21',
  'di': '01',
  'xian': '23',
  'name': '康平县',
  'level': 3
}, {
  'code': '210124',
  'sheng': '21',
  'di': '01',
  'xian': '24',
  'name': '法库县',
  'level': 3
}, {
  'code': '210181',
  'sheng': '21',
  'di': '01',
  'xian': '81',
  'name': '新民市',
  'level': 3
}, {
  'code': '210200',
  'sheng': '21',
  'di': '02',
  'xian': '00',
  'name': '大连市',
  'level': 2
}, {
  'code': '210201',
  'sheng': '21',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210202',
  'sheng': '21',
  'di': '02',
  'xian': '02',
  'name': '中山区',
  'level': 3
}, {
  'code': '210203',
  'sheng': '21',
  'di': '02',
  'xian': '03',
  'name': '西岗区',
  'level': 3
}, {
  'code': '210204',
  'sheng': '21',
  'di': '02',
  'xian': '04',
  'name': '沙河口区',
  'level': 3
}, {
  'code': '210211',
  'sheng': '21',
  'di': '02',
  'xian': '11',
  'name': '甘井子区',
  'level': 3
}, {
  'code': '210212',
  'sheng': '21',
  'di': '02',
  'xian': '12',
  'name': '旅顺口区',
  'level': 3
}, {
  'code': '210213',
  'sheng': '21',
  'di': '02',
  'xian': '13',
  'name': '金州区',
  'level': 3
}, {
  'code': '210224',
  'sheng': '21',
  'di': '02',
  'xian': '24',
  'name': '长海县',
  'level': 3
}, {
  'code': '210281',
  'sheng': '21',
  'di': '02',
  'xian': '81',
  'name': '瓦房店市',
  'level': 3
}, {
  'code': '210282',
  'sheng': '21',
  'di': '02',
  'xian': '82',
  'name': '普兰店市',
  'level': 3
}, {
  'code': '210283',
  'sheng': '21',
  'di': '02',
  'xian': '83',
  'name': '庄河市',
  'level': 3
}, {
  'code': '210300',
  'sheng': '21',
  'di': '03',
  'xian': '00',
  'name': '鞍山市',
  'level': 2
}, {
  'code': '210301',
  'sheng': '21',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210302',
  'sheng': '21',
  'di': '03',
  'xian': '02',
  'name': '铁东区',
  'level': 3
}, {
  'code': '210303',
  'sheng': '21',
  'di': '03',
  'xian': '03',
  'name': '铁西区',
  'level': 3
}, {
  'code': '210304',
  'sheng': '21',
  'di': '03',
  'xian': '04',
  'name': '立山区',
  'level': 3
}, {
  'code': '210311',
  'sheng': '21',
  'di': '03',
  'xian': '11',
  'name': '千山区',
  'level': 3
}, {
  'code': '210321',
  'sheng': '21',
  'di': '03',
  'xian': '21',
  'name': '台安县',
  'level': 3
}, {
  'code': '210323',
  'sheng': '21',
  'di': '03',
  'xian': '23',
  'name': '岫岩满族自治县',
  'level': 3
}, {
  'code': '210381',
  'sheng': '21',
  'di': '03',
  'xian': '81',
  'name': '海城市',
  'level': 3
}, {
  'code': '210400',
  'sheng': '21',
  'di': '04',
  'xian': '00',
  'name': '抚顺市',
  'level': 2
}, {
  'code': '210401',
  'sheng': '21',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210402',
  'sheng': '21',
  'di': '04',
  'xian': '02',
  'name': '新抚区',
  'level': 3
}, {
  'code': '210403',
  'sheng': '21',
  'di': '04',
  'xian': '03',
  'name': '东洲区',
  'level': 3
}, {
  'code': '210404',
  'sheng': '21',
  'di': '04',
  'xian': '04',
  'name': '望花区',
  'level': 3
}, {
  'code': '210411',
  'sheng': '21',
  'di': '04',
  'xian': '11',
  'name': '顺城区',
  'level': 3
}, {
  'code': '210421',
  'sheng': '21',
  'di': '04',
  'xian': '21',
  'name': '抚顺县',
  'level': 3
}, {
  'code': '210422',
  'sheng': '21',
  'di': '04',
  'xian': '22',
  'name': '新宾满族自治县',
  'level': 3
}, {
  'code': '210423',
  'sheng': '21',
  'di': '04',
  'xian': '23',
  'name': '清原满族自治县',
  'level': 3
}, {
  'code': '210500',
  'sheng': '21',
  'di': '05',
  'xian': '00',
  'name': '本溪市',
  'level': 2
}, {
  'code': '210501',
  'sheng': '21',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210502',
  'sheng': '21',
  'di': '05',
  'xian': '02',
  'name': '平山区',
  'level': 3
}, {
  'code': '210503',
  'sheng': '21',
  'di': '05',
  'xian': '03',
  'name': '溪湖区',
  'level': 3
}, {
  'code': '210504',
  'sheng': '21',
  'di': '05',
  'xian': '04',
  'name': '明山区',
  'level': 3
}, {
  'code': '210505',
  'sheng': '21',
  'di': '05',
  'xian': '05',
  'name': '南芬区',
  'level': 3
}, {
  'code': '210521',
  'sheng': '21',
  'di': '05',
  'xian': '21',
  'name': '本溪满族自治县',
  'level': 3
}, {
  'code': '210522',
  'sheng': '21',
  'di': '05',
  'xian': '22',
  'name': '桓仁满族自治县',
  'level': 3
}, {
  'code': '210600',
  'sheng': '21',
  'di': '06',
  'xian': '00',
  'name': '丹东市',
  'level': 2
}, {
  'code': '210601',
  'sheng': '21',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210602',
  'sheng': '21',
  'di': '06',
  'xian': '02',
  'name': '元宝区',
  'level': 3
}, {
  'code': '210603',
  'sheng': '21',
  'di': '06',
  'xian': '03',
  'name': '振兴区',
  'level': 3
}, {
  'code': '210604',
  'sheng': '21',
  'di': '06',
  'xian': '04',
  'name': '振安区',
  'level': 3
}, {
  'code': '210624',
  'sheng': '21',
  'di': '06',
  'xian': '24',
  'name': '宽甸满族自治县',
  'level': 3
}, {
  'code': '210681',
  'sheng': '21',
  'di': '06',
  'xian': '81',
  'name': '东港市',
  'level': 3
}, {
  'code': '210682',
  'sheng': '21',
  'di': '06',
  'xian': '82',
  'name': '凤城市',
  'level': 3
}, {
  'code': '210700',
  'sheng': '21',
  'di': '07',
  'xian': '00',
  'name': '锦州市',
  'level': 2
}, {
  'code': '210701',
  'sheng': '21',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210702',
  'sheng': '21',
  'di': '07',
  'xian': '02',
  'name': '古塔区',
  'level': 3
}, {
  'code': '210703',
  'sheng': '21',
  'di': '07',
  'xian': '03',
  'name': '凌河区',
  'level': 3
}, {
  'code': '210711',
  'sheng': '21',
  'di': '07',
  'xian': '11',
  'name': '太和区',
  'level': 3
}, {
  'code': '210726',
  'sheng': '21',
  'di': '07',
  'xian': '26',
  'name': '黑山县',
  'level': 3
}, {
  'code': '210727',
  'sheng': '21',
  'di': '07',
  'xian': '27',
  'name': '义县',
  'level': 3
}, {
  'code': '210781',
  'sheng': '21',
  'di': '07',
  'xian': '81',
  'name': '凌海市',
  'level': 3
}, {
  'code': '210782',
  'sheng': '21',
  'di': '07',
  'xian': '82',
  'name': '北镇市',
  'level': 3
}, {
  'code': '210800',
  'sheng': '21',
  'di': '08',
  'xian': '00',
  'name': '营口市',
  'level': 2
}, {
  'code': '210801',
  'sheng': '21',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210802',
  'sheng': '21',
  'di': '08',
  'xian': '02',
  'name': '站前区',
  'level': 3
}, {
  'code': '210803',
  'sheng': '21',
  'di': '08',
  'xian': '03',
  'name': '西市区',
  'level': 3
}, {
  'code': '210804',
  'sheng': '21',
  'di': '08',
  'xian': '04',
  'name': '鲅鱼圈区',
  'level': 3
}, {
  'code': '210811',
  'sheng': '21',
  'di': '08',
  'xian': '11',
  'name': '老边区',
  'level': 3
}, {
  'code': '210881',
  'sheng': '21',
  'di': '08',
  'xian': '81',
  'name': '盖州市',
  'level': 3
}, {
  'code': '210882',
  'sheng': '21',
  'di': '08',
  'xian': '82',
  'name': '大石桥市',
  'level': 3
}, {
  'code': '210900',
  'sheng': '21',
  'di': '09',
  'xian': '00',
  'name': '阜新市',
  'level': 2
}, {
  'code': '210901',
  'sheng': '21',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '210902',
  'sheng': '21',
  'di': '09',
  'xian': '02',
  'name': '海州区',
  'level': 3
}, {
  'code': '210903',
  'sheng': '21',
  'di': '09',
  'xian': '03',
  'name': '新邱区',
  'level': 3
}, {
  'code': '210904',
  'sheng': '21',
  'di': '09',
  'xian': '04',
  'name': '太平区',
  'level': 3
}, {
  'code': '210905',
  'sheng': '21',
  'di': '09',
  'xian': '05',
  'name': '清河门区',
  'level': 3
}, {
  'code': '210911',
  'sheng': '21',
  'di': '09',
  'xian': '11',
  'name': '细河区',
  'level': 3
}, {
  'code': '210921',
  'sheng': '21',
  'di': '09',
  'xian': '21',
  'name': '阜新蒙古族自治县',
  'level': 3
}, {
  'code': '210922',
  'sheng': '21',
  'di': '09',
  'xian': '22',
  'name': '彰武县',
  'level': 3
}, {
  'code': '211000',
  'sheng': '21',
  'di': '10',
  'xian': '00',
  'name': '辽阳市',
  'level': 2
}, {
  'code': '211001',
  'sheng': '21',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '211002',
  'sheng': '21',
  'di': '10',
  'xian': '02',
  'name': '白塔区',
  'level': 3
}, {
  'code': '211003',
  'sheng': '21',
  'di': '10',
  'xian': '03',
  'name': '文圣区',
  'level': 3
}, {
  'code': '211004',
  'sheng': '21',
  'di': '10',
  'xian': '04',
  'name': '宏伟区',
  'level': 3
}, {
  'code': '211005',
  'sheng': '21',
  'di': '10',
  'xian': '05',
  'name': '弓长岭区',
  'level': 3
}, {
  'code': '211011',
  'sheng': '21',
  'di': '10',
  'xian': '11',
  'name': '太子河区',
  'level': 3
}, {
  'code': '211021',
  'sheng': '21',
  'di': '10',
  'xian': '21',
  'name': '辽阳县',
  'level': 3
}, {
  'code': '211081',
  'sheng': '21',
  'di': '10',
  'xian': '81',
  'name': '灯塔市',
  'level': 3
}, {
  'code': '211100',
  'sheng': '21',
  'di': '11',
  'xian': '00',
  'name': '盘锦市',
  'level': 2
}, {
  'code': '211101',
  'sheng': '21',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '211102',
  'sheng': '21',
  'di': '11',
  'xian': '02',
  'name': '双台子区',
  'level': 3
}, {
  'code': '211103',
  'sheng': '21',
  'di': '11',
  'xian': '03',
  'name': '兴隆台区',
  'level': 3
}, {
  'code': '211121',
  'sheng': '21',
  'di': '11',
  'xian': '21',
  'name': '大洼县',
  'level': 3
}, {
  'code': '211122',
  'sheng': '21',
  'di': '11',
  'xian': '22',
  'name': '盘山县',
  'level': 3
}, {
  'code': '211200',
  'sheng': '21',
  'di': '12',
  'xian': '00',
  'name': '铁岭市',
  'level': 2
}, {
  'code': '211201',
  'sheng': '21',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '211202',
  'sheng': '21',
  'di': '12',
  'xian': '02',
  'name': '银州区',
  'level': 3
}, {
  'code': '211204',
  'sheng': '21',
  'di': '12',
  'xian': '04',
  'name': '清河区',
  'level': 3
}, {
  'code': '211221',
  'sheng': '21',
  'di': '12',
  'xian': '21',
  'name': '铁岭县',
  'level': 3
}, {
  'code': '211223',
  'sheng': '21',
  'di': '12',
  'xian': '23',
  'name': '西丰县',
  'level': 3
}, {
  'code': '211224',
  'sheng': '21',
  'di': '12',
  'xian': '24',
  'name': '昌图县',
  'level': 3
}, {
  'code': '211281',
  'sheng': '21',
  'di': '12',
  'xian': '81',
  'name': '调兵山市',
  'level': 3
}, {
  'code': '211282',
  'sheng': '21',
  'di': '12',
  'xian': '82',
  'name': '开原市',
  'level': 3
}, {
  'code': '211300',
  'sheng': '21',
  'di': '13',
  'xian': '00',
  'name': '朝阳市',
  'level': 2
}, {
  'code': '211301',
  'sheng': '21',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '211302',
  'sheng': '21',
  'di': '13',
  'xian': '02',
  'name': '双塔区',
  'level': 3
}, {
  'code': '211303',
  'sheng': '21',
  'di': '13',
  'xian': '03',
  'name': '龙城区',
  'level': 3
}, {
  'code': '211321',
  'sheng': '21',
  'di': '13',
  'xian': '21',
  'name': '朝阳县',
  'level': 3
}, {
  'code': '211322',
  'sheng': '21',
  'di': '13',
  'xian': '22',
  'name': '建平县',
  'level': 3
}, {
  'code': '211324',
  'sheng': '21',
  'di': '13',
  'xian': '24',
  'name': '喀喇沁左翼蒙古族自治县',
  'level': 3
}, {
  'code': '211381',
  'sheng': '21',
  'di': '13',
  'xian': '81',
  'name': '北票市',
  'level': 3
}, {
  'code': '211382',
  'sheng': '21',
  'di': '13',
  'xian': '82',
  'name': '凌源市',
  'level': 3
}, {
  'code': '211400',
  'sheng': '21',
  'di': '14',
  'xian': '00',
  'name': '葫芦岛市',
  'level': 2
}, {
  'code': '211401',
  'sheng': '21',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '211402',
  'sheng': '21',
  'di': '14',
  'xian': '02',
  'name': '连山区',
  'level': 3
}, {
  'code': '211403',
  'sheng': '21',
  'di': '14',
  'xian': '03',
  'name': '龙港区',
  'level': 3
}, {
  'code': '211404',
  'sheng': '21',
  'di': '14',
  'xian': '04',
  'name': '南票区',
  'level': 3
}, {
  'code': '211421',
  'sheng': '21',
  'di': '14',
  'xian': '21',
  'name': '绥中县',
  'level': 3
}, {
  'code': '211422',
  'sheng': '21',
  'di': '14',
  'xian': '22',
  'name': '建昌县',
  'level': 3
}, {
  'code': '211481',
  'sheng': '21',
  'di': '14',
  'xian': '81',
  'name': '兴城市',
  'level': 3
}, {
  'code': '220000',
  'sheng': '22',
  'di': '00',
  'xian': '00',
  'name': '吉林省',
  'level': 1
}, {
  'code': '220100',
  'sheng': '22',
  'di': '01',
  'xian': '00',
  'name': '长春市',
  'level': 2
}, {
  'code': '220101',
  'sheng': '22',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220102',
  'sheng': '22',
  'di': '01',
  'xian': '02',
  'name': '南关区',
  'level': 3
}, {
  'code': '220103',
  'sheng': '22',
  'di': '01',
  'xian': '03',
  'name': '宽城区',
  'level': 3
}, {
  'code': '220104',
  'sheng': '22',
  'di': '01',
  'xian': '04',
  'name': '朝阳区',
  'level': 3
}, {
  'code': '220105',
  'sheng': '22',
  'di': '01',
  'xian': '05',
  'name': '二道区',
  'level': 3
}, {
  'code': '220106',
  'sheng': '22',
  'di': '01',
  'xian': '06',
  'name': '绿园区',
  'level': 3
}, {
  'code': '220112',
  'sheng': '22',
  'di': '01',
  'xian': '12',
  'name': '双阳区',
  'level': 3
}, {
  'code': '220113',
  'sheng': '22',
  'di': '01',
  'xian': '13',
  'name': '九台区',
  'level': 3
}, {
  'code': '220122',
  'sheng': '22',
  'di': '01',
  'xian': '22',
  'name': '农安县',
  'level': 3
}, {
  'code': '220182',
  'sheng': '22',
  'di': '01',
  'xian': '82',
  'name': '榆树市',
  'level': 3
}, {
  'code': '220183',
  'sheng': '22',
  'di': '01',
  'xian': '83',
  'name': '德惠市',
  'level': 3
}, {
  'code': '220200',
  'sheng': '22',
  'di': '02',
  'xian': '00',
  'name': '吉林市',
  'level': 2
}, {
  'code': '220201',
  'sheng': '22',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220202',
  'sheng': '22',
  'di': '02',
  'xian': '02',
  'name': '昌邑区',
  'level': 3
}, {
  'code': '220203',
  'sheng': '22',
  'di': '02',
  'xian': '03',
  'name': '龙潭区',
  'level': 3
}, {
  'code': '220204',
  'sheng': '22',
  'di': '02',
  'xian': '04',
  'name': '船营区',
  'level': 3
}, {
  'code': '220211',
  'sheng': '22',
  'di': '02',
  'xian': '11',
  'name': '丰满区',
  'level': 3
}, {
  'code': '220221',
  'sheng': '22',
  'di': '02',
  'xian': '21',
  'name': '永吉县',
  'level': 3
}, {
  'code': '220281',
  'sheng': '22',
  'di': '02',
  'xian': '81',
  'name': '蛟河市',
  'level': 3
}, {
  'code': '220282',
  'sheng': '22',
  'di': '02',
  'xian': '82',
  'name': '桦甸市',
  'level': 3
}, {
  'code': '220283',
  'sheng': '22',
  'di': '02',
  'xian': '83',
  'name': '舒兰市',
  'level': 3
}, {
  'code': '220284',
  'sheng': '22',
  'di': '02',
  'xian': '84',
  'name': '磐石市',
  'level': 3
}, {
  'code': '220300',
  'sheng': '22',
  'di': '03',
  'xian': '00',
  'name': '四平市',
  'level': 2
}, {
  'code': '220301',
  'sheng': '22',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220302',
  'sheng': '22',
  'di': '03',
  'xian': '02',
  'name': '铁西区',
  'level': 3
}, {
  'code': '220303',
  'sheng': '22',
  'di': '03',
  'xian': '03',
  'name': '铁东区',
  'level': 3
}, {
  'code': '220322',
  'sheng': '22',
  'di': '03',
  'xian': '22',
  'name': '梨树县',
  'level': 3
}, {
  'code': '220323',
  'sheng': '22',
  'di': '03',
  'xian': '23',
  'name': '伊通满族自治县',
  'level': 3
}, {
  'code': '220381',
  'sheng': '22',
  'di': '03',
  'xian': '81',
  'name': '公主岭市',
  'level': 3
}, {
  'code': '220382',
  'sheng': '22',
  'di': '03',
  'xian': '82',
  'name': '双辽市',
  'level': 3
}, {
  'code': '220400',
  'sheng': '22',
  'di': '04',
  'xian': '00',
  'name': '辽源市',
  'level': 2
}, {
  'code': '220401',
  'sheng': '22',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220402',
  'sheng': '22',
  'di': '04',
  'xian': '02',
  'name': '龙山区',
  'level': 3
}, {
  'code': '220403',
  'sheng': '22',
  'di': '04',
  'xian': '03',
  'name': '西安区',
  'level': 3
}, {
  'code': '220421',
  'sheng': '22',
  'di': '04',
  'xian': '21',
  'name': '东丰县',
  'level': 3
}, {
  'code': '220422',
  'sheng': '22',
  'di': '04',
  'xian': '22',
  'name': '东辽县',
  'level': 3
}, {
  'code': '220500',
  'sheng': '22',
  'di': '05',
  'xian': '00',
  'name': '通化市',
  'level': 2
}, {
  'code': '220501',
  'sheng': '22',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220502',
  'sheng': '22',
  'di': '05',
  'xian': '02',
  'name': '东昌区',
  'level': 3
}, {
  'code': '220503',
  'sheng': '22',
  'di': '05',
  'xian': '03',
  'name': '二道江区',
  'level': 3
}, {
  'code': '220521',
  'sheng': '22',
  'di': '05',
  'xian': '21',
  'name': '通化县',
  'level': 3
}, {
  'code': '220523',
  'sheng': '22',
  'di': '05',
  'xian': '23',
  'name': '辉南县',
  'level': 3
}, {
  'code': '220524',
  'sheng': '22',
  'di': '05',
  'xian': '24',
  'name': '柳河县',
  'level': 3
}, {
  'code': '220581',
  'sheng': '22',
  'di': '05',
  'xian': '81',
  'name': '梅河口市',
  'level': 3
}, {
  'code': '220582',
  'sheng': '22',
  'di': '05',
  'xian': '82',
  'name': '集安市',
  'level': 3
}, {
  'code': '220600',
  'sheng': '22',
  'di': '06',
  'xian': '00',
  'name': '白山市',
  'level': 2
}, {
  'code': '220601',
  'sheng': '22',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220602',
  'sheng': '22',
  'di': '06',
  'xian': '02',
  'name': '浑江区',
  'level': 3
}, {
  'code': '220605',
  'sheng': '22',
  'di': '06',
  'xian': '05',
  'name': '江源区',
  'level': 3
}, {
  'code': '220621',
  'sheng': '22',
  'di': '06',
  'xian': '21',
  'name': '抚松县',
  'level': 3
}, {
  'code': '220622',
  'sheng': '22',
  'di': '06',
  'xian': '22',
  'name': '靖宇县',
  'level': 3
}, {
  'code': '220623',
  'sheng': '22',
  'di': '06',
  'xian': '23',
  'name': '长白朝鲜族自治县',
  'level': 3
}, {
  'code': '220681',
  'sheng': '22',
  'di': '06',
  'xian': '81',
  'name': '临江市',
  'level': 3
}, {
  'code': '220700',
  'sheng': '22',
  'di': '07',
  'xian': '00',
  'name': '松原市',
  'level': 2
}, {
  'code': '220701',
  'sheng': '22',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220702',
  'sheng': '22',
  'di': '07',
  'xian': '02',
  'name': '宁江区',
  'level': 3
}, {
  'code': '220721',
  'sheng': '22',
  'di': '07',
  'xian': '21',
  'name': '前郭尔罗斯蒙古族自治县',
  'level': 3
}, {
  'code': '220722',
  'sheng': '22',
  'di': '07',
  'xian': '22',
  'name': '长岭县',
  'level': 3
}, {
  'code': '220723',
  'sheng': '22',
  'di': '07',
  'xian': '23',
  'name': '乾安县',
  'level': 3
}, {
  'code': '220781',
  'sheng': '22',
  'di': '07',
  'xian': '81',
  'name': '扶余市',
  'level': 3
}, {
  'code': '220800',
  'sheng': '22',
  'di': '08',
  'xian': '00',
  'name': '白城市',
  'level': 2
}, {
  'code': '220801',
  'sheng': '22',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '220802',
  'sheng': '22',
  'di': '08',
  'xian': '02',
  'name': '洮北区',
  'level': 3
}, {
  'code': '220821',
  'sheng': '22',
  'di': '08',
  'xian': '21',
  'name': '镇赉县',
  'level': 3
}, {
  'code': '220822',
  'sheng': '22',
  'di': '08',
  'xian': '22',
  'name': '通榆县',
  'level': 3
}, {
  'code': '220881',
  'sheng': '22',
  'di': '08',
  'xian': '81',
  'name': '洮南市',
  'level': 3
}, {
  'code': '220882',
  'sheng': '22',
  'di': '08',
  'xian': '82',
  'name': '大安市',
  'level': 3
}, {
  'code': '222400',
  'sheng': '22',
  'di': '24',
  'xian': '00',
  'name': '延边朝鲜族自治州',
  'level': 2
}, {
  'code': '222401',
  'sheng': '22',
  'di': '24',
  'xian': '01',
  'name': '延吉市',
  'level': 3
}, {
  'code': '222402',
  'sheng': '22',
  'di': '24',
  'xian': '02',
  'name': '图们市',
  'level': 3
}, {
  'code': '222403',
  'sheng': '22',
  'di': '24',
  'xian': '03',
  'name': '敦化市',
  'level': 3
}, {
  'code': '222404',
  'sheng': '22',
  'di': '24',
  'xian': '04',
  'name': '珲春市',
  'level': 3
}, {
  'code': '222405',
  'sheng': '22',
  'di': '24',
  'xian': '05',
  'name': '龙井市',
  'level': 3
}, {
  'code': '222406',
  'sheng': '22',
  'di': '24',
  'xian': '06',
  'name': '和龙市',
  'level': 3
}, {
  'code': '222424',
  'sheng': '22',
  'di': '24',
  'xian': '24',
  'name': '汪清县',
  'level': 3
}, {
  'code': '222426',
  'sheng': '22',
  'di': '24',
  'xian': '26',
  'name': '安图县',
  'level': 3
}, {
  'code': '230000',
  'sheng': '23',
  'di': '00',
  'xian': '00',
  'name': '黑龙江省',
  'level': 1
}, {
  'code': '230100',
  'sheng': '23',
  'di': '01',
  'xian': '00',
  'name': '哈尔滨市',
  'level': 2
}, {
  'code': '230101',
  'sheng': '23',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230102',
  'sheng': '23',
  'di': '01',
  'xian': '02',
  'name': '道里区',
  'level': 3
}, {
  'code': '230103',
  'sheng': '23',
  'di': '01',
  'xian': '03',
  'name': '南岗区',
  'level': 3
}, {
  'code': '230104',
  'sheng': '23',
  'di': '01',
  'xian': '04',
  'name': '道外区',
  'level': 3
}, {
  'code': '230108',
  'sheng': '23',
  'di': '01',
  'xian': '08',
  'name': '平房区',
  'level': 3
}, {
  'code': '230109',
  'sheng': '23',
  'di': '01',
  'xian': '09',
  'name': '松北区',
  'level': 3
}, {
  'code': '230110',
  'sheng': '23',
  'di': '01',
  'xian': '10',
  'name': '香坊区',
  'level': 3
}, {
  'code': '230111',
  'sheng': '23',
  'di': '01',
  'xian': '11',
  'name': '呼兰区',
  'level': 3
}, {
  'code': '230112',
  'sheng': '23',
  'di': '01',
  'xian': '12',
  'name': '阿城区',
  'level': 3
}, {
  'code': '230123',
  'sheng': '23',
  'di': '01',
  'xian': '23',
  'name': '依兰县',
  'level': 3
}, {
  'code': '230124',
  'sheng': '23',
  'di': '01',
  'xian': '24',
  'name': '方正县',
  'level': 3
}, {
  'code': '230125',
  'sheng': '23',
  'di': '01',
  'xian': '25',
  'name': '宾县',
  'level': 3
}, {
  'code': '230126',
  'sheng': '23',
  'di': '01',
  'xian': '26',
  'name': '巴彦县',
  'level': 3
}, {
  'code': '230127',
  'sheng': '23',
  'di': '01',
  'xian': '27',
  'name': '木兰县',
  'level': 3
}, {
  'code': '230128',
  'sheng': '23',
  'di': '01',
  'xian': '28',
  'name': '通河县',
  'level': 3
}, {
  'code': '230129',
  'sheng': '23',
  'di': '01',
  'xian': '29',
  'name': '延寿县',
  'level': 3
}, {
  'code': '230182',
  'sheng': '23',
  'di': '01',
  'xian': '82',
  'name': '双城市',
  'level': 3
}, {
  'code': '230183',
  'sheng': '23',
  'di': '01',
  'xian': '83',
  'name': '尚志市',
  'level': 3
}, {
  'code': '230184',
  'sheng': '23',
  'di': '01',
  'xian': '84',
  'name': '五常市',
  'level': 3
}, {
  'code': '230200',
  'sheng': '23',
  'di': '02',
  'xian': '00',
  'name': '齐齐哈尔市',
  'level': 2
}, {
  'code': '230201',
  'sheng': '23',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230202',
  'sheng': '23',
  'di': '02',
  'xian': '02',
  'name': '龙沙区',
  'level': 3
}, {
  'code': '230203',
  'sheng': '23',
  'di': '02',
  'xian': '03',
  'name': '建华区',
  'level': 3
}, {
  'code': '230204',
  'sheng': '23',
  'di': '02',
  'xian': '04',
  'name': '铁锋区',
  'level': 3
}, {
  'code': '230205',
  'sheng': '23',
  'di': '02',
  'xian': '05',
  'name': '昂昂溪区',
  'level': 3
}, {
  'code': '230206',
  'sheng': '23',
  'di': '02',
  'xian': '06',
  'name': '富拉尔基区',
  'level': 3
}, {
  'code': '230207',
  'sheng': '23',
  'di': '02',
  'xian': '07',
  'name': '碾子山区',
  'level': 3
}, {
  'code': '230208',
  'sheng': '23',
  'di': '02',
  'xian': '08',
  'name': '梅里斯达斡尔族区',
  'level': 3
}, {
  'code': '230221',
  'sheng': '23',
  'di': '02',
  'xian': '21',
  'name': '龙江县',
  'level': 3
}, {
  'code': '230223',
  'sheng': '23',
  'di': '02',
  'xian': '23',
  'name': '依安县',
  'level': 3
}, {
  'code': '230224',
  'sheng': '23',
  'di': '02',
  'xian': '24',
  'name': '泰来县',
  'level': 3
}, {
  'code': '230225',
  'sheng': '23',
  'di': '02',
  'xian': '25',
  'name': '甘南县',
  'level': 3
}, {
  'code': '230227',
  'sheng': '23',
  'di': '02',
  'xian': '27',
  'name': '富裕县',
  'level': 3
}, {
  'code': '230229',
  'sheng': '23',
  'di': '02',
  'xian': '29',
  'name': '克山县',
  'level': 3
}, {
  'code': '230230',
  'sheng': '23',
  'di': '02',
  'xian': '30',
  'name': '克东县',
  'level': 3
}, {
  'code': '230231',
  'sheng': '23',
  'di': '02',
  'xian': '31',
  'name': '拜泉县',
  'level': 3
}, {
  'code': '230281',
  'sheng': '23',
  'di': '02',
  'xian': '81',
  'name': '讷河市',
  'level': 3
}, {
  'code': '230300',
  'sheng': '23',
  'di': '03',
  'xian': '00',
  'name': '鸡西市',
  'level': 2
}, {
  'code': '230301',
  'sheng': '23',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230302',
  'sheng': '23',
  'di': '03',
  'xian': '02',
  'name': '鸡冠区',
  'level': 3
}, {
  'code': '230303',
  'sheng': '23',
  'di': '03',
  'xian': '03',
  'name': '恒山区',
  'level': 3
}, {
  'code': '230304',
  'sheng': '23',
  'di': '03',
  'xian': '04',
  'name': '滴道区',
  'level': 3
}, {
  'code': '230305',
  'sheng': '23',
  'di': '03',
  'xian': '05',
  'name': '梨树区',
  'level': 3
}, {
  'code': '230306',
  'sheng': '23',
  'di': '03',
  'xian': '06',
  'name': '城子河区',
  'level': 3
}, {
  'code': '230307',
  'sheng': '23',
  'di': '03',
  'xian': '07',
  'name': '麻山区',
  'level': 3
}, {
  'code': '230321',
  'sheng': '23',
  'di': '03',
  'xian': '21',
  'name': '鸡东县',
  'level': 3
}, {
  'code': '230381',
  'sheng': '23',
  'di': '03',
  'xian': '81',
  'name': '虎林市',
  'level': 3
}, {
  'code': '230382',
  'sheng': '23',
  'di': '03',
  'xian': '82',
  'name': '密山市',
  'level': 3
}, {
  'code': '230400',
  'sheng': '23',
  'di': '04',
  'xian': '00',
  'name': '鹤岗市',
  'level': 2
}, {
  'code': '230401',
  'sheng': '23',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230402',
  'sheng': '23',
  'di': '04',
  'xian': '02',
  'name': '向阳区',
  'level': 3
}, {
  'code': '230403',
  'sheng': '23',
  'di': '04',
  'xian': '03',
  'name': '工农区',
  'level': 3
}, {
  'code': '230404',
  'sheng': '23',
  'di': '04',
  'xian': '04',
  'name': '南山区',
  'level': 3
}, {
  'code': '230405',
  'sheng': '23',
  'di': '04',
  'xian': '05',
  'name': '兴安区',
  'level': 3
}, {
  'code': '230406',
  'sheng': '23',
  'di': '04',
  'xian': '06',
  'name': '东山区',
  'level': 3
}, {
  'code': '230407',
  'sheng': '23',
  'di': '04',
  'xian': '07',
  'name': '兴山区',
  'level': 3
}, {
  'code': '230421',
  'sheng': '23',
  'di': '04',
  'xian': '21',
  'name': '萝北县',
  'level': 3
}, {
  'code': '230422',
  'sheng': '23',
  'di': '04',
  'xian': '22',
  'name': '绥滨县',
  'level': 3
}, {
  'code': '230500',
  'sheng': '23',
  'di': '05',
  'xian': '00',
  'name': '双鸭山市',
  'level': 2
}, {
  'code': '230501',
  'sheng': '23',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230502',
  'sheng': '23',
  'di': '05',
  'xian': '02',
  'name': '尖山区',
  'level': 3
}, {
  'code': '230503',
  'sheng': '23',
  'di': '05',
  'xian': '03',
  'name': '岭东区',
  'level': 3
}, {
  'code': '230505',
  'sheng': '23',
  'di': '05',
  'xian': '05',
  'name': '四方台区',
  'level': 3
}, {
  'code': '230506',
  'sheng': '23',
  'di': '05',
  'xian': '06',
  'name': '宝山区',
  'level': 3
}, {
  'code': '230521',
  'sheng': '23',
  'di': '05',
  'xian': '21',
  'name': '集贤县',
  'level': 3
}, {
  'code': '230522',
  'sheng': '23',
  'di': '05',
  'xian': '22',
  'name': '友谊县',
  'level': 3
}, {
  'code': '230523',
  'sheng': '23',
  'di': '05',
  'xian': '23',
  'name': '宝清县',
  'level': 3
}, {
  'code': '230524',
  'sheng': '23',
  'di': '05',
  'xian': '24',
  'name': '饶河县',
  'level': 3
}, {
  'code': '230600',
  'sheng': '23',
  'di': '06',
  'xian': '00',
  'name': '大庆市',
  'level': 2
}, {
  'code': '230601',
  'sheng': '23',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230602',
  'sheng': '23',
  'di': '06',
  'xian': '02',
  'name': '萨尔图区',
  'level': 3
}, {
  'code': '230603',
  'sheng': '23',
  'di': '06',
  'xian': '03',
  'name': '龙凤区',
  'level': 3
}, {
  'code': '230604',
  'sheng': '23',
  'di': '06',
  'xian': '04',
  'name': '让胡路区',
  'level': 3
}, {
  'code': '230605',
  'sheng': '23',
  'di': '06',
  'xian': '05',
  'name': '红岗区',
  'level': 3
}, {
  'code': '230606',
  'sheng': '23',
  'di': '06',
  'xian': '06',
  'name': '大同区',
  'level': 3
}, {
  'code': '230621',
  'sheng': '23',
  'di': '06',
  'xian': '21',
  'name': '肇州县',
  'level': 3
}, {
  'code': '230622',
  'sheng': '23',
  'di': '06',
  'xian': '22',
  'name': '肇源县',
  'level': 3
}, {
  'code': '230623',
  'sheng': '23',
  'di': '06',
  'xian': '23',
  'name': '林甸县',
  'level': 3
}, {
  'code': '230624',
  'sheng': '23',
  'di': '06',
  'xian': '24',
  'name': '杜尔伯特蒙古族自治县',
  'level': 3
}, {
  'code': '230700',
  'sheng': '23',
  'di': '07',
  'xian': '00',
  'name': '伊春市',
  'level': 2
}, {
  'code': '230701',
  'sheng': '23',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230702',
  'sheng': '23',
  'di': '07',
  'xian': '02',
  'name': '伊春区',
  'level': 3
}, {
  'code': '230703',
  'sheng': '23',
  'di': '07',
  'xian': '03',
  'name': '南岔区',
  'level': 3
}, {
  'code': '230704',
  'sheng': '23',
  'di': '07',
  'xian': '04',
  'name': '友好区',
  'level': 3
}, {
  'code': '230705',
  'sheng': '23',
  'di': '07',
  'xian': '05',
  'name': '西林区',
  'level': 3
}, {
  'code': '230706',
  'sheng': '23',
  'di': '07',
  'xian': '06',
  'name': '翠峦区',
  'level': 3
}, {
  'code': '230707',
  'sheng': '23',
  'di': '07',
  'xian': '07',
  'name': '新青区',
  'level': 3
}, {
  'code': '230708',
  'sheng': '23',
  'di': '07',
  'xian': '08',
  'name': '美溪区',
  'level': 3
}, {
  'code': '230709',
  'sheng': '23',
  'di': '07',
  'xian': '09',
  'name': '金山屯区',
  'level': 3
}, {
  'code': '230710',
  'sheng': '23',
  'di': '07',
  'xian': '10',
  'name': '五营区',
  'level': 3
}, {
  'code': '230711',
  'sheng': '23',
  'di': '07',
  'xian': '11',
  'name': '乌马河区',
  'level': 3
}, {
  'code': '230712',
  'sheng': '23',
  'di': '07',
  'xian': '12',
  'name': '汤旺河区',
  'level': 3
}, {
  'code': '230713',
  'sheng': '23',
  'di': '07',
  'xian': '13',
  'name': '带岭区',
  'level': 3
}, {
  'code': '230714',
  'sheng': '23',
  'di': '07',
  'xian': '14',
  'name': '乌伊岭区',
  'level': 3
}, {
  'code': '230715',
  'sheng': '23',
  'di': '07',
  'xian': '15',
  'name': '红星区',
  'level': 3
}, {
  'code': '230716',
  'sheng': '23',
  'di': '07',
  'xian': '16',
  'name': '上甘岭区',
  'level': 3
}, {
  'code': '230722',
  'sheng': '23',
  'di': '07',
  'xian': '22',
  'name': '嘉荫县',
  'level': 3
}, {
  'code': '230781',
  'sheng': '23',
  'di': '07',
  'xian': '81',
  'name': '铁力市',
  'level': 3
}, {
  'code': '230800',
  'sheng': '23',
  'di': '08',
  'xian': '00',
  'name': '佳木斯市',
  'level': 2
}, {
  'code': '230801',
  'sheng': '23',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230803',
  'sheng': '23',
  'di': '08',
  'xian': '03',
  'name': '向阳区',
  'level': 3
}, {
  'code': '230804',
  'sheng': '23',
  'di': '08',
  'xian': '04',
  'name': '前进区',
  'level': 3
}, {
  'code': '230805',
  'sheng': '23',
  'di': '08',
  'xian': '05',
  'name': '东风区',
  'level': 3
}, {
  'code': '230811',
  'sheng': '23',
  'di': '08',
  'xian': '11',
  'name': '郊区',
  'level': 3
}, {
  'code': '230822',
  'sheng': '23',
  'di': '08',
  'xian': '22',
  'name': '桦南县',
  'level': 3
}, {
  'code': '230826',
  'sheng': '23',
  'di': '08',
  'xian': '26',
  'name': '桦川县',
  'level': 3
}, {
  'code': '230828',
  'sheng': '23',
  'di': '08',
  'xian': '28',
  'name': '汤原县',
  'level': 3
}, {
  'code': '230833',
  'sheng': '23',
  'di': '08',
  'xian': '33',
  'name': '抚远县',
  'level': 3
}, {
  'code': '230881',
  'sheng': '23',
  'di': '08',
  'xian': '81',
  'name': '同江市',
  'level': 3
}, {
  'code': '230882',
  'sheng': '23',
  'di': '08',
  'xian': '82',
  'name': '富锦市',
  'level': 3
}, {
  'code': '230900',
  'sheng': '23',
  'di': '09',
  'xian': '00',
  'name': '七台河市',
  'level': 2
}, {
  'code': '230901',
  'sheng': '23',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '230902',
  'sheng': '23',
  'di': '09',
  'xian': '02',
  'name': '新兴区',
  'level': 3
}, {
  'code': '230903',
  'sheng': '23',
  'di': '09',
  'xian': '03',
  'name': '桃山区',
  'level': 3
}, {
  'code': '230904',
  'sheng': '23',
  'di': '09',
  'xian': '04',
  'name': '茄子河区',
  'level': 3
}, {
  'code': '230921',
  'sheng': '23',
  'di': '09',
  'xian': '21',
  'name': '勃利县',
  'level': 3
}, {
  'code': '231000',
  'sheng': '23',
  'di': '10',
  'xian': '00',
  'name': '牡丹江市',
  'level': 2
}, {
  'code': '231001',
  'sheng': '23',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '231002',
  'sheng': '23',
  'di': '10',
  'xian': '02',
  'name': '东安区',
  'level': 3
}, {
  'code': '231003',
  'sheng': '23',
  'di': '10',
  'xian': '03',
  'name': '阳明区',
  'level': 3
}, {
  'code': '231004',
  'sheng': '23',
  'di': '10',
  'xian': '04',
  'name': '爱民区',
  'level': 3
}, {
  'code': '231005',
  'sheng': '23',
  'di': '10',
  'xian': '05',
  'name': '西安区',
  'level': 3
}, {
  'code': '231024',
  'sheng': '23',
  'di': '10',
  'xian': '24',
  'name': '东宁县',
  'level': 3
}, {
  'code': '231025',
  'sheng': '23',
  'di': '10',
  'xian': '25',
  'name': '林口县',
  'level': 3
}, {
  'code': '231081',
  'sheng': '23',
  'di': '10',
  'xian': '81',
  'name': '绥芬河市',
  'level': 3
}, {
  'code': '231083',
  'sheng': '23',
  'di': '10',
  'xian': '83',
  'name': '海林市',
  'level': 3
}, {
  'code': '231084',
  'sheng': '23',
  'di': '10',
  'xian': '84',
  'name': '宁安市',
  'level': 3
}, {
  'code': '231085',
  'sheng': '23',
  'di': '10',
  'xian': '85',
  'name': '穆棱市',
  'level': 3
}, {
  'code': '231100',
  'sheng': '23',
  'di': '11',
  'xian': '00',
  'name': '黑河市',
  'level': 2
}, {
  'code': '231101',
  'sheng': '23',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '231102',
  'sheng': '23',
  'di': '11',
  'xian': '02',
  'name': '爱辉区',
  'level': 3
}, {
  'code': '231121',
  'sheng': '23',
  'di': '11',
  'xian': '21',
  'name': '嫩江县',
  'level': 3
}, {
  'code': '231123',
  'sheng': '23',
  'di': '11',
  'xian': '23',
  'name': '逊克县',
  'level': 3
}, {
  'code': '231124',
  'sheng': '23',
  'di': '11',
  'xian': '24',
  'name': '孙吴县',
  'level': 3
}, {
  'code': '231181',
  'sheng': '23',
  'di': '11',
  'xian': '81',
  'name': '北安市',
  'level': 3
}, {
  'code': '231182',
  'sheng': '23',
  'di': '11',
  'xian': '82',
  'name': '五大连池市',
  'level': 3
}, {
  'code': '231200',
  'sheng': '23',
  'di': '12',
  'xian': '00',
  'name': '绥化市',
  'level': 2
}, {
  'code': '231201',
  'sheng': '23',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '231202',
  'sheng': '23',
  'di': '12',
  'xian': '02',
  'name': '北林区',
  'level': 3
}, {
  'code': '231221',
  'sheng': '23',
  'di': '12',
  'xian': '21',
  'name': '望奎县',
  'level': 3
}, {
  'code': '231222',
  'sheng': '23',
  'di': '12',
  'xian': '22',
  'name': '兰西县',
  'level': 3
}, {
  'code': '231223',
  'sheng': '23',
  'di': '12',
  'xian': '23',
  'name': '青冈县',
  'level': 3
}, {
  'code': '231224',
  'sheng': '23',
  'di': '12',
  'xian': '24',
  'name': '庆安县',
  'level': 3
}, {
  'code': '231225',
  'sheng': '23',
  'di': '12',
  'xian': '25',
  'name': '明水县',
  'level': 3
}, {
  'code': '231226',
  'sheng': '23',
  'di': '12',
  'xian': '26',
  'name': '绥棱县',
  'level': 3
}, {
  'code': '231281',
  'sheng': '23',
  'di': '12',
  'xian': '81',
  'name': '安达市',
  'level': 3
}, {
  'code': '231282',
  'sheng': '23',
  'di': '12',
  'xian': '82',
  'name': '肇东市',
  'level': 3
}, {
  'code': '231283',
  'sheng': '23',
  'di': '12',
  'xian': '83',
  'name': '海伦市',
  'level': 3
}, {
  'code': '232700',
  'sheng': '23',
  'di': '27',
  'xian': '00',
  'name': '大兴安岭地区',
  'level': 2
}, {
  'code': '232721',
  'sheng': '23',
  'di': '27',
  'xian': '21',
  'name': '呼玛县',
  'level': 3
}, {
  'code': '232722',
  'sheng': '23',
  'di': '27',
  'xian': '22',
  'name': '塔河县',
  'level': 3
}, {
  'code': '232723',
  'sheng': '23',
  'di': '27',
  'xian': '23',
  'name': '漠河县',
  'level': 3
}, {
  'code': '310000',
  'sheng': '31',
  'di': '00',
  'xian': '00',
  'name': '上海市',
  'level': 1
}, {
  'code': '310100',
  'sheng': '31',
  'di': '01',
  'xian': '00',
  'name': '市辖区',
  'level': 2
}, {
  'code': '310101',
  'sheng': '31',
  'di': '01',
  'xian': '01',
  'name': '黄浦区',
  'level': 3
}, {
  'code': '310104',
  'sheng': '31',
  'di': '01',
  'xian': '04',
  'name': '徐汇区',
  'level': 3
}, {
  'code': '310105',
  'sheng': '31',
  'di': '01',
  'xian': '05',
  'name': '长宁区',
  'level': 3
}, {
  'code': '310106',
  'sheng': '31',
  'di': '01',
  'xian': '06',
  'name': '静安区',
  'level': 3
}, {
  'code': '310107',
  'sheng': '31',
  'di': '01',
  'xian': '07',
  'name': '普陀区',
  'level': 3
}, {
  'code': '310108',
  'sheng': '31',
  'di': '01',
  'xian': '08',
  'name': '闸北区',
  'level': 3
}, {
  'code': '310109',
  'sheng': '31',
  'di': '01',
  'xian': '09',
  'name': '虹口区',
  'level': 3
}, {
  'code': '310110',
  'sheng': '31',
  'di': '01',
  'xian': '10',
  'name': '杨浦区',
  'level': 3
}, {
  'code': '310112',
  'sheng': '31',
  'di': '01',
  'xian': '12',
  'name': '闵行区',
  'level': 3
}, {
  'code': '310113',
  'sheng': '31',
  'di': '01',
  'xian': '13',
  'name': '宝山区',
  'level': 3
}, {
  'code': '310114',
  'sheng': '31',
  'di': '01',
  'xian': '14',
  'name': '嘉定区',
  'level': 3
}, {
  'code': '310115',
  'sheng': '31',
  'di': '01',
  'xian': '15',
  'name': '浦东新区',
  'level': 3
}, {
  'code': '310116',
  'sheng': '31',
  'di': '01',
  'xian': '16',
  'name': '金山区',
  'level': 3
}, {
  'code': '310117',
  'sheng': '31',
  'di': '01',
  'xian': '17',
  'name': '松江区',
  'level': 3
}, {
  'code': '310118',
  'sheng': '31',
  'di': '01',
  'xian': '18',
  'name': '青浦区',
  'level': 3
}, {
  'code': '310120',
  'sheng': '31',
  'di': '01',
  'xian': '20',
  'name': '奉贤区',
  'level': 3
}, {
  'code': '310200',
  'sheng': '31',
  'di': '02',
  'xian': '00',
  'name': '县',
  'level': 2
}, {
  'code': '310230',
  'sheng': '31',
  'di': '02',
  'xian': '30',
  'name': '崇明县',
  'level': 3
}, {
  'code': '320000',
  'sheng': '32',
  'di': '00',
  'xian': '00',
  'name': '江苏省',
  'level': 1
}, {
  'code': '320100',
  'sheng': '32',
  'di': '01',
  'xian': '00',
  'name': '南京市',
  'level': 2
}, {
  'code': '320101',
  'sheng': '32',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320102',
  'sheng': '32',
  'di': '01',
  'xian': '02',
  'name': '玄武区',
  'level': 3
}, {
  'code': '320104',
  'sheng': '32',
  'di': '01',
  'xian': '04',
  'name': '秦淮区',
  'level': 3
}, {
  'code': '320105',
  'sheng': '32',
  'di': '01',
  'xian': '05',
  'name': '建邺区',
  'level': 3
}, {
  'code': '320106',
  'sheng': '32',
  'di': '01',
  'xian': '06',
  'name': '鼓楼区',
  'level': 3
}, {
  'code': '320111',
  'sheng': '32',
  'di': '01',
  'xian': '11',
  'name': '浦口区',
  'level': 3
}, {
  'code': '320113',
  'sheng': '32',
  'di': '01',
  'xian': '13',
  'name': '栖霞区',
  'level': 3
}, {
  'code': '320114',
  'sheng': '32',
  'di': '01',
  'xian': '14',
  'name': '雨花台区',
  'level': 3
}, {
  'code': '320115',
  'sheng': '32',
  'di': '01',
  'xian': '15',
  'name': '江宁区',
  'level': 3
}, {
  'code': '320116',
  'sheng': '32',
  'di': '01',
  'xian': '16',
  'name': '六合区',
  'level': 3
}, {
  'code': '320117',
  'sheng': '32',
  'di': '01',
  'xian': '17',
  'name': '溧水区',
  'level': 3
}, {
  'code': '320118',
  'sheng': '32',
  'di': '01',
  'xian': '18',
  'name': '高淳区',
  'level': 3
}, {
  'code': '320200',
  'sheng': '32',
  'di': '02',
  'xian': '00',
  'name': '无锡市',
  'level': 2
}, {
  'code': '320201',
  'sheng': '32',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320202',
  'sheng': '32',
  'di': '02',
  'xian': '02',
  'name': '崇安区',
  'level': 3
}, {
  'code': '320203',
  'sheng': '32',
  'di': '02',
  'xian': '03',
  'name': '南长区',
  'level': 3
}, {
  'code': '320204',
  'sheng': '32',
  'di': '02',
  'xian': '04',
  'name': '北塘区',
  'level': 3
}, {
  'code': '320205',
  'sheng': '32',
  'di': '02',
  'xian': '05',
  'name': '锡山区',
  'level': 3
}, {
  'code': '320206',
  'sheng': '32',
  'di': '02',
  'xian': '06',
  'name': '惠山区',
  'level': 3
}, {
  'code': '320211',
  'sheng': '32',
  'di': '02',
  'xian': '11',
  'name': '滨湖区',
  'level': 3
}, {
  'code': '320281',
  'sheng': '32',
  'di': '02',
  'xian': '81',
  'name': '江阴市',
  'level': 3
}, {
  'code': '320282',
  'sheng': '32',
  'di': '02',
  'xian': '82',
  'name': '宜兴市',
  'level': 3
}, {
  'code': '320300',
  'sheng': '32',
  'di': '03',
  'xian': '00',
  'name': '徐州市',
  'level': 2
}, {
  'code': '320301',
  'sheng': '32',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320302',
  'sheng': '32',
  'di': '03',
  'xian': '02',
  'name': '鼓楼区',
  'level': 3
}, {
  'code': '320303',
  'sheng': '32',
  'di': '03',
  'xian': '03',
  'name': '云龙区',
  'level': 3
}, {
  'code': '320305',
  'sheng': '32',
  'di': '03',
  'xian': '05',
  'name': '贾汪区',
  'level': 3
}, {
  'code': '320311',
  'sheng': '32',
  'di': '03',
  'xian': '11',
  'name': '泉山区',
  'level': 3
}, {
  'code': '320312',
  'sheng': '32',
  'di': '03',
  'xian': '12',
  'name': '铜山区',
  'level': 3
}, {
  'code': '320321',
  'sheng': '32',
  'di': '03',
  'xian': '21',
  'name': '丰县',
  'level': 3
}, {
  'code': '320322',
  'sheng': '32',
  'di': '03',
  'xian': '22',
  'name': '沛县',
  'level': 3
}, {
  'code': '320324',
  'sheng': '32',
  'di': '03',
  'xian': '24',
  'name': '睢宁县',
  'level': 3
}, {
  'code': '320381',
  'sheng': '32',
  'di': '03',
  'xian': '81',
  'name': '新沂市',
  'level': 3
}, {
  'code': '320382',
  'sheng': '32',
  'di': '03',
  'xian': '82',
  'name': '邳州市',
  'level': 3
}, {
  'code': '320400',
  'sheng': '32',
  'di': '04',
  'xian': '00',
  'name': '常州市',
  'level': 2
}, {
  'code': '320401',
  'sheng': '32',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320402',
  'sheng': '32',
  'di': '04',
  'xian': '02',
  'name': '天宁区',
  'level': 3
}, {
  'code': '320404',
  'sheng': '32',
  'di': '04',
  'xian': '04',
  'name': '钟楼区',
  'level': 3
}, {
  'code': '320405',
  'sheng': '32',
  'di': '04',
  'xian': '05',
  'name': '戚墅堰区',
  'level': 3
}, {
  'code': '320411',
  'sheng': '32',
  'di': '04',
  'xian': '11',
  'name': '新北区',
  'level': 3
}, {
  'code': '320412',
  'sheng': '32',
  'di': '04',
  'xian': '12',
  'name': '武进区',
  'level': 3
}, {
  'code': '320481',
  'sheng': '32',
  'di': '04',
  'xian': '81',
  'name': '溧阳市',
  'level': 3
}, {
  'code': '320482',
  'sheng': '32',
  'di': '04',
  'xian': '82',
  'name': '金坛市',
  'level': 3
}, {
  'code': '320500',
  'sheng': '32',
  'di': '05',
  'xian': '00',
  'name': '苏州市',
  'level': 2
}, {
  'code': '320501',
  'sheng': '32',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320505',
  'sheng': '32',
  'di': '05',
  'xian': '05',
  'name': '虎丘区',
  'level': 3
}, {
  'code': '320506',
  'sheng': '32',
  'di': '05',
  'xian': '06',
  'name': '吴中区',
  'level': 3
}, {
  'code': '320507',
  'sheng': '32',
  'di': '05',
  'xian': '07',
  'name': '相城区',
  'level': 3
}, {
  'code': '320508',
  'sheng': '32',
  'di': '05',
  'xian': '08',
  'name': '姑苏区',
  'level': 3
}, {
  'code': '320509',
  'sheng': '32',
  'di': '05',
  'xian': '09',
  'name': '吴江区',
  'level': 3
}, {
  'code': '320581',
  'sheng': '32',
  'di': '05',
  'xian': '81',
  'name': '常熟市',
  'level': 3
}, {
  'code': '320582',
  'sheng': '32',
  'di': '05',
  'xian': '82',
  'name': '张家港市',
  'level': 3
}, {
  'code': '320583',
  'sheng': '32',
  'di': '05',
  'xian': '83',
  'name': '昆山市',
  'level': 3
}, {
  'code': '320585',
  'sheng': '32',
  'di': '05',
  'xian': '85',
  'name': '太仓市',
  'level': 3
}, {
  'code': '320600',
  'sheng': '32',
  'di': '06',
  'xian': '00',
  'name': '南通市',
  'level': 2
}, {
  'code': '320601',
  'sheng': '32',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320602',
  'sheng': '32',
  'di': '06',
  'xian': '02',
  'name': '崇川区',
  'level': 3
}, {
  'code': '320611',
  'sheng': '32',
  'di': '06',
  'xian': '11',
  'name': '港闸区',
  'level': 3
}, {
  'code': '320612',
  'sheng': '32',
  'di': '06',
  'xian': '12',
  'name': '通州区',
  'level': 3
}, {
  'code': '320621',
  'sheng': '32',
  'di': '06',
  'xian': '21',
  'name': '海安县',
  'level': 3
}, {
  'code': '320623',
  'sheng': '32',
  'di': '06',
  'xian': '23',
  'name': '如东县',
  'level': 3
}, {
  'code': '320681',
  'sheng': '32',
  'di': '06',
  'xian': '81',
  'name': '启东市',
  'level': 3
}, {
  'code': '320682',
  'sheng': '32',
  'di': '06',
  'xian': '82',
  'name': '如皋市',
  'level': 3
}, {
  'code': '320684',
  'sheng': '32',
  'di': '06',
  'xian': '84',
  'name': '海门市',
  'level': 3
}, {
  'code': '320700',
  'sheng': '32',
  'di': '07',
  'xian': '00',
  'name': '连云港市',
  'level': 2
}, {
  'code': '320701',
  'sheng': '32',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320703',
  'sheng': '32',
  'di': '07',
  'xian': '03',
  'name': '连云区',
  'level': 3
}, {
  'code': '320706',
  'sheng': '32',
  'di': '07',
  'xian': '06',
  'name': '海州区',
  'level': 3
}, {
  'code': '320707',
  'sheng': '32',
  'di': '07',
  'xian': '07',
  'name': '赣榆区',
  'level': 3
}, {
  'code': '320722',
  'sheng': '32',
  'di': '07',
  'xian': '22',
  'name': '东海县',
  'level': 3
}, {
  'code': '320723',
  'sheng': '32',
  'di': '07',
  'xian': '23',
  'name': '灌云县',
  'level': 3
}, {
  'code': '320724',
  'sheng': '32',
  'di': '07',
  'xian': '24',
  'name': '灌南县',
  'level': 3
}, {
  'code': '320800',
  'sheng': '32',
  'di': '08',
  'xian': '00',
  'name': '淮安市',
  'level': 2
}, {
  'code': '320801',
  'sheng': '32',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320802',
  'sheng': '32',
  'di': '08',
  'xian': '02',
  'name': '清河区',
  'level': 3
}, {
  'code': '320803',
  'sheng': '32',
  'di': '08',
  'xian': '03',
  'name': '淮安区',
  'level': 3
}, {
  'code': '320804',
  'sheng': '32',
  'di': '08',
  'xian': '04',
  'name': '淮阴区',
  'level': 3
}, {
  'code': '320811',
  'sheng': '32',
  'di': '08',
  'xian': '11',
  'name': '清浦区',
  'level': 3
}, {
  'code': '320826',
  'sheng': '32',
  'di': '08',
  'xian': '26',
  'name': '涟水县',
  'level': 3
}, {
  'code': '320829',
  'sheng': '32',
  'di': '08',
  'xian': '29',
  'name': '洪泽县',
  'level': 3
}, {
  'code': '320830',
  'sheng': '32',
  'di': '08',
  'xian': '30',
  'name': '盱眙县',
  'level': 3
}, {
  'code': '320831',
  'sheng': '32',
  'di': '08',
  'xian': '31',
  'name': '金湖县',
  'level': 3
}, {
  'code': '320900',
  'sheng': '32',
  'di': '09',
  'xian': '00',
  'name': '盐城市',
  'level': 2
}, {
  'code': '320901',
  'sheng': '32',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '320902',
  'sheng': '32',
  'di': '09',
  'xian': '02',
  'name': '亭湖区',
  'level': 3
}, {
  'code': '320903',
  'sheng': '32',
  'di': '09',
  'xian': '03',
  'name': '盐都区',
  'level': 3
}, {
  'code': '320921',
  'sheng': '32',
  'di': '09',
  'xian': '21',
  'name': '响水县',
  'level': 3
}, {
  'code': '320922',
  'sheng': '32',
  'di': '09',
  'xian': '22',
  'name': '滨海县',
  'level': 3
}, {
  'code': '320923',
  'sheng': '32',
  'di': '09',
  'xian': '23',
  'name': '阜宁县',
  'level': 3
}, {
  'code': '320924',
  'sheng': '32',
  'di': '09',
  'xian': '24',
  'name': '射阳县',
  'level': 3
}, {
  'code': '320925',
  'sheng': '32',
  'di': '09',
  'xian': '25',
  'name': '建湖县',
  'level': 3
}, {
  'code': '320981',
  'sheng': '32',
  'di': '09',
  'xian': '81',
  'name': '东台市',
  'level': 3
}, {
  'code': '320982',
  'sheng': '32',
  'di': '09',
  'xian': '82',
  'name': '大丰市',
  'level': 3
}, {
  'code': '321000',
  'sheng': '32',
  'di': '10',
  'xian': '00',
  'name': '扬州市',
  'level': 2
}, {
  'code': '321001',
  'sheng': '32',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '321002',
  'sheng': '32',
  'di': '10',
  'xian': '02',
  'name': '广陵区',
  'level': 3
}, {
  'code': '321003',
  'sheng': '32',
  'di': '10',
  'xian': '03',
  'name': '邗江区',
  'level': 3
}, {
  'code': '321012',
  'sheng': '32',
  'di': '10',
  'xian': '12',
  'name': '江都区',
  'level': 3
}, {
  'code': '321023',
  'sheng': '32',
  'di': '10',
  'xian': '23',
  'name': '宝应县',
  'level': 3
}, {
  'code': '321081',
  'sheng': '32',
  'di': '10',
  'xian': '81',
  'name': '仪征市',
  'level': 3
}, {
  'code': '321084',
  'sheng': '32',
  'di': '10',
  'xian': '84',
  'name': '高邮市',
  'level': 3
}, {
  'code': '321100',
  'sheng': '32',
  'di': '11',
  'xian': '00',
  'name': '镇江市',
  'level': 2
}, {
  'code': '321101',
  'sheng': '32',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '321102',
  'sheng': '32',
  'di': '11',
  'xian': '02',
  'name': '京口区',
  'level': 3
}, {
  'code': '321111',
  'sheng': '32',
  'di': '11',
  'xian': '11',
  'name': '润州区',
  'level': 3
}, {
  'code': '321112',
  'sheng': '32',
  'di': '11',
  'xian': '12',
  'name': '丹徒区',
  'level': 3
}, {
  'code': '321181',
  'sheng': '32',
  'di': '11',
  'xian': '81',
  'name': '丹阳市',
  'level': 3
}, {
  'code': '321182',
  'sheng': '32',
  'di': '11',
  'xian': '82',
  'name': '扬中市',
  'level': 3
}, {
  'code': '321183',
  'sheng': '32',
  'di': '11',
  'xian': '83',
  'name': '句容市',
  'level': 3
}, {
  'code': '321200',
  'sheng': '32',
  'di': '12',
  'xian': '00',
  'name': '泰州市',
  'level': 2
}, {
  'code': '321201',
  'sheng': '32',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '321202',
  'sheng': '32',
  'di': '12',
  'xian': '02',
  'name': '海陵区',
  'level': 3
}, {
  'code': '321203',
  'sheng': '32',
  'di': '12',
  'xian': '03',
  'name': '高港区',
  'level': 3
}, {
  'code': '321204',
  'sheng': '32',
  'di': '12',
  'xian': '04',
  'name': '姜堰区',
  'level': 3
}, {
  'code': '321281',
  'sheng': '32',
  'di': '12',
  'xian': '81',
  'name': '兴化市',
  'level': 3
}, {
  'code': '321282',
  'sheng': '32',
  'di': '12',
  'xian': '82',
  'name': '靖江市',
  'level': 3
}, {
  'code': '321283',
  'sheng': '32',
  'di': '12',
  'xian': '83',
  'name': '泰兴市',
  'level': 3
}, {
  'code': '321300',
  'sheng': '32',
  'di': '13',
  'xian': '00',
  'name': '宿迁市',
  'level': 2
}, {
  'code': '321301',
  'sheng': '32',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '321302',
  'sheng': '32',
  'di': '13',
  'xian': '02',
  'name': '宿城区',
  'level': 3
}, {
  'code': '321311',
  'sheng': '32',
  'di': '13',
  'xian': '11',
  'name': '宿豫区',
  'level': 3
}, {
  'code': '321322',
  'sheng': '32',
  'di': '13',
  'xian': '22',
  'name': '沭阳县',
  'level': 3
}, {
  'code': '321323',
  'sheng': '32',
  'di': '13',
  'xian': '23',
  'name': '泗阳县',
  'level': 3
}, {
  'code': '321324',
  'sheng': '32',
  'di': '13',
  'xian': '24',
  'name': '泗洪县',
  'level': 3
}, {
  'code': '330000',
  'sheng': '33',
  'di': '00',
  'xian': '00',
  'name': '浙江省',
  'level': 1
}, {
  'code': '330100',
  'sheng': '33',
  'di': '01',
  'xian': '00',
  'name': '杭州市',
  'level': 2
}, {
  'code': '330101',
  'sheng': '33',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330102',
  'sheng': '33',
  'di': '01',
  'xian': '02',
  'name': '上城区',
  'level': 3
}, {
  'code': '330103',
  'sheng': '33',
  'di': '01',
  'xian': '03',
  'name': '下城区',
  'level': 3
}, {
  'code': '330104',
  'sheng': '33',
  'di': '01',
  'xian': '04',
  'name': '江干区',
  'level': 3
}, {
  'code': '330105',
  'sheng': '33',
  'di': '01',
  'xian': '05',
  'name': '拱墅区',
  'level': 3
}, {
  'code': '330106',
  'sheng': '33',
  'di': '01',
  'xian': '06',
  'name': '西湖区',
  'level': 3
}, {
  'code': '330108',
  'sheng': '33',
  'di': '01',
  'xian': '08',
  'name': '滨江区',
  'level': 3
}, {
  'code': '330109',
  'sheng': '33',
  'di': '01',
  'xian': '09',
  'name': '萧山区',
  'level': 3
}, {
  'code': '330110',
  'sheng': '33',
  'di': '01',
  'xian': '10',
  'name': '余杭区',
  'level': 3
}, {
  'code': '330122',
  'sheng': '33',
  'di': '01',
  'xian': '22',
  'name': '桐庐县',
  'level': 3
}, {
  'code': '330127',
  'sheng': '33',
  'di': '01',
  'xian': '27',
  'name': '淳安县',
  'level': 3
}, {
  'code': '330182',
  'sheng': '33',
  'di': '01',
  'xian': '82',
  'name': '建德市',
  'level': 3
}, {
  'code': '330183',
  'sheng': '33',
  'di': '01',
  'xian': '83',
  'name': '富阳市',
  'level': 3
}, {
  'code': '330185',
  'sheng': '33',
  'di': '01',
  'xian': '85',
  'name': '临安市',
  'level': 3
}, {
  'code': '330200',
  'sheng': '33',
  'di': '02',
  'xian': '00',
  'name': '宁波市',
  'level': 2
}, {
  'code': '330201',
  'sheng': '33',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330203',
  'sheng': '33',
  'di': '02',
  'xian': '03',
  'name': '海曙区',
  'level': 3
}, {
  'code': '330204',
  'sheng': '33',
  'di': '02',
  'xian': '04',
  'name': '江东区',
  'level': 3
}, {
  'code': '330205',
  'sheng': '33',
  'di': '02',
  'xian': '05',
  'name': '江北区',
  'level': 3
}, {
  'code': '330206',
  'sheng': '33',
  'di': '02',
  'xian': '06',
  'name': '北仑区',
  'level': 3
}, {
  'code': '330211',
  'sheng': '33',
  'di': '02',
  'xian': '11',
  'name': '镇海区',
  'level': 3
}, {
  'code': '330212',
  'sheng': '33',
  'di': '02',
  'xian': '12',
  'name': '鄞州区',
  'level': 3
}, {
  'code': '330225',
  'sheng': '33',
  'di': '02',
  'xian': '25',
  'name': '象山县',
  'level': 3
}, {
  'code': '330226',
  'sheng': '33',
  'di': '02',
  'xian': '26',
  'name': '宁海县',
  'level': 3
}, {
  'code': '330281',
  'sheng': '33',
  'di': '02',
  'xian': '81',
  'name': '余姚市',
  'level': 3
}, {
  'code': '330282',
  'sheng': '33',
  'di': '02',
  'xian': '82',
  'name': '慈溪市',
  'level': 3
}, {
  'code': '330283',
  'sheng': '33',
  'di': '02',
  'xian': '83',
  'name': '奉化市',
  'level': 3
}, {
  'code': '330300',
  'sheng': '33',
  'di': '03',
  'xian': '00',
  'name': '温州市',
  'level': 2
}, {
  'code': '330301',
  'sheng': '33',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330302',
  'sheng': '33',
  'di': '03',
  'xian': '02',
  'name': '鹿城区',
  'level': 3
}, {
  'code': '330303',
  'sheng': '33',
  'di': '03',
  'xian': '03',
  'name': '龙湾区',
  'level': 3
}, {
  'code': '330304',
  'sheng': '33',
  'di': '03',
  'xian': '04',
  'name': '瓯海区',
  'level': 3
}, {
  'code': '330322',
  'sheng': '33',
  'di': '03',
  'xian': '22',
  'name': '洞头县',
  'level': 3
}, {
  'code': '330324',
  'sheng': '33',
  'di': '03',
  'xian': '24',
  'name': '永嘉县',
  'level': 3
}, {
  'code': '330326',
  'sheng': '33',
  'di': '03',
  'xian': '26',
  'name': '平阳县',
  'level': 3
}, {
  'code': '330327',
  'sheng': '33',
  'di': '03',
  'xian': '27',
  'name': '苍南县',
  'level': 3
}, {
  'code': '330328',
  'sheng': '33',
  'di': '03',
  'xian': '28',
  'name': '文成县',
  'level': 3
}, {
  'code': '330329',
  'sheng': '33',
  'di': '03',
  'xian': '29',
  'name': '泰顺县',
  'level': 3
}, {
  'code': '330381',
  'sheng': '33',
  'di': '03',
  'xian': '81',
  'name': '瑞安市',
  'level': 3
}, {
  'code': '330382',
  'sheng': '33',
  'di': '03',
  'xian': '82',
  'name': '乐清市',
  'level': 3
}, {
  'code': '330400',
  'sheng': '33',
  'di': '04',
  'xian': '00',
  'name': '嘉兴市',
  'level': 2
}, {
  'code': '330401',
  'sheng': '33',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330402',
  'sheng': '33',
  'di': '04',
  'xian': '02',
  'name': '南湖区',
  'level': 3
}, {
  'code': '330411',
  'sheng': '33',
  'di': '04',
  'xian': '11',
  'name': '秀洲区',
  'level': 3
}, {
  'code': '330421',
  'sheng': '33',
  'di': '04',
  'xian': '21',
  'name': '嘉善县',
  'level': 3
}, {
  'code': '330424',
  'sheng': '33',
  'di': '04',
  'xian': '24',
  'name': '海盐县',
  'level': 3
}, {
  'code': '330481',
  'sheng': '33',
  'di': '04',
  'xian': '81',
  'name': '海宁市',
  'level': 3
}, {
  'code': '330482',
  'sheng': '33',
  'di': '04',
  'xian': '82',
  'name': '平湖市',
  'level': 3
}, {
  'code': '330483',
  'sheng': '33',
  'di': '04',
  'xian': '83',
  'name': '桐乡市',
  'level': 3
}, {
  'code': '330500',
  'sheng': '33',
  'di': '05',
  'xian': '00',
  'name': '湖州市',
  'level': 2
}, {
  'code': '330501',
  'sheng': '33',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330502',
  'sheng': '33',
  'di': '05',
  'xian': '02',
  'name': '吴兴区',
  'level': 3
}, {
  'code': '330503',
  'sheng': '33',
  'di': '05',
  'xian': '03',
  'name': '南浔区',
  'level': 3
}, {
  'code': '330521',
  'sheng': '33',
  'di': '05',
  'xian': '21',
  'name': '德清县',
  'level': 3
}, {
  'code': '330522',
  'sheng': '33',
  'di': '05',
  'xian': '22',
  'name': '长兴县',
  'level': 3
}, {
  'code': '330523',
  'sheng': '33',
  'di': '05',
  'xian': '23',
  'name': '安吉县',
  'level': 3
}, {
  'code': '330600',
  'sheng': '33',
  'di': '06',
  'xian': '00',
  'name': '绍兴市',
  'level': 2
}, {
  'code': '330601',
  'sheng': '33',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330602',
  'sheng': '33',
  'di': '06',
  'xian': '02',
  'name': '越城区',
  'level': 3
}, {
  'code': '330603',
  'sheng': '33',
  'di': '06',
  'xian': '03',
  'name': '柯桥区',
  'level': 3
}, {
  'code': '330604',
  'sheng': '33',
  'di': '06',
  'xian': '04',
  'name': '上虞区',
  'level': 3
}, {
  'code': '330624',
  'sheng': '33',
  'di': '06',
  'xian': '24',
  'name': '新昌县',
  'level': 3
}, {
  'code': '330681',
  'sheng': '33',
  'di': '06',
  'xian': '81',
  'name': '诸暨市',
  'level': 3
}, {
  'code': '330683',
  'sheng': '33',
  'di': '06',
  'xian': '83',
  'name': '嵊州市',
  'level': 3
}, {
  'code': '330700',
  'sheng': '33',
  'di': '07',
  'xian': '00',
  'name': '金华市',
  'level': 2
}, {
  'code': '330701',
  'sheng': '33',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330702',
  'sheng': '33',
  'di': '07',
  'xian': '02',
  'name': '婺城区',
  'level': 3
}, {
  'code': '330703',
  'sheng': '33',
  'di': '07',
  'xian': '03',
  'name': '金东区',
  'level': 3
}, {
  'code': '330723',
  'sheng': '33',
  'di': '07',
  'xian': '23',
  'name': '武义县',
  'level': 3
}, {
  'code': '330726',
  'sheng': '33',
  'di': '07',
  'xian': '26',
  'name': '浦江县',
  'level': 3
}, {
  'code': '330727',
  'sheng': '33',
  'di': '07',
  'xian': '27',
  'name': '磐安县',
  'level': 3
}, {
  'code': '330781',
  'sheng': '33',
  'di': '07',
  'xian': '81',
  'name': '兰溪市',
  'level': 3
}, {
  'code': '330782',
  'sheng': '33',
  'di': '07',
  'xian': '82',
  'name': '义乌市',
  'level': 3
}, {
  'code': '330783',
  'sheng': '33',
  'di': '07',
  'xian': '83',
  'name': '东阳市',
  'level': 3
}, {
  'code': '330784',
  'sheng': '33',
  'di': '07',
  'xian': '84',
  'name': '永康市',
  'level': 3
}, {
  'code': '330800',
  'sheng': '33',
  'di': '08',
  'xian': '00',
  'name': '衢州市',
  'level': 2
}, {
  'code': '330801',
  'sheng': '33',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330802',
  'sheng': '33',
  'di': '08',
  'xian': '02',
  'name': '柯城区',
  'level': 3
}, {
  'code': '330803',
  'sheng': '33',
  'di': '08',
  'xian': '03',
  'name': '衢江区',
  'level': 3
}, {
  'code': '330822',
  'sheng': '33',
  'di': '08',
  'xian': '22',
  'name': '常山县',
  'level': 3
}, {
  'code': '330824',
  'sheng': '33',
  'di': '08',
  'xian': '24',
  'name': '开化县',
  'level': 3
}, {
  'code': '330825',
  'sheng': '33',
  'di': '08',
  'xian': '25',
  'name': '龙游县',
  'level': 3
}, {
  'code': '330881',
  'sheng': '33',
  'di': '08',
  'xian': '81',
  'name': '江山市',
  'level': 3
}, {
  'code': '330900',
  'sheng': '33',
  'di': '09',
  'xian': '00',
  'name': '舟山市',
  'level': 2
}, {
  'code': '330901',
  'sheng': '33',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '330902',
  'sheng': '33',
  'di': '09',
  'xian': '02',
  'name': '定海区',
  'level': 3
}, {
  'code': '330903',
  'sheng': '33',
  'di': '09',
  'xian': '03',
  'name': '普陀区',
  'level': 3
}, {
  'code': '330921',
  'sheng': '33',
  'di': '09',
  'xian': '21',
  'name': '岱山县',
  'level': 3
}, {
  'code': '330922',
  'sheng': '33',
  'di': '09',
  'xian': '22',
  'name': '嵊泗县',
  'level': 3
}, {
  'code': '331000',
  'sheng': '33',
  'di': '10',
  'xian': '00',
  'name': '台州市',
  'level': 2
}, {
  'code': '331001',
  'sheng': '33',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '331002',
  'sheng': '33',
  'di': '10',
  'xian': '02',
  'name': '椒江区',
  'level': 3
}, {
  'code': '331003',
  'sheng': '33',
  'di': '10',
  'xian': '03',
  'name': '黄岩区',
  'level': 3
}, {
  'code': '331004',
  'sheng': '33',
  'di': '10',
  'xian': '04',
  'name': '路桥区',
  'level': 3
}, {
  'code': '331021',
  'sheng': '33',
  'di': '10',
  'xian': '21',
  'name': '玉环县',
  'level': 3
}, {
  'code': '331022',
  'sheng': '33',
  'di': '10',
  'xian': '22',
  'name': '三门县',
  'level': 3
}, {
  'code': '331023',
  'sheng': '33',
  'di': '10',
  'xian': '23',
  'name': '天台县',
  'level': 3
}, {
  'code': '331024',
  'sheng': '33',
  'di': '10',
  'xian': '24',
  'name': '仙居县',
  'level': 3
}, {
  'code': '331081',
  'sheng': '33',
  'di': '10',
  'xian': '81',
  'name': '温岭市',
  'level': 3
}, {
  'code': '331082',
  'sheng': '33',
  'di': '10',
  'xian': '82',
  'name': '临海市',
  'level': 3
}, {
  'code': '331100',
  'sheng': '33',
  'di': '11',
  'xian': '00',
  'name': '丽水市',
  'level': 2
}, {
  'code': '331101',
  'sheng': '33',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '331102',
  'sheng': '33',
  'di': '11',
  'xian': '02',
  'name': '莲都区',
  'level': 3
}, {
  'code': '331121',
  'sheng': '33',
  'di': '11',
  'xian': '21',
  'name': '青田县',
  'level': 3
}, {
  'code': '331122',
  'sheng': '33',
  'di': '11',
  'xian': '22',
  'name': '缙云县',
  'level': 3
}, {
  'code': '331123',
  'sheng': '33',
  'di': '11',
  'xian': '23',
  'name': '遂昌县',
  'level': 3
}, {
  'code': '331124',
  'sheng': '33',
  'di': '11',
  'xian': '24',
  'name': '松阳县',
  'level': 3
}, {
  'code': '331125',
  'sheng': '33',
  'di': '11',
  'xian': '25',
  'name': '云和县',
  'level': 3
}, {
  'code': '331126',
  'sheng': '33',
  'di': '11',
  'xian': '26',
  'name': '庆元县',
  'level': 3
}, {
  'code': '331127',
  'sheng': '33',
  'di': '11',
  'xian': '27',
  'name': '景宁畲族自治县',
  'level': 3
}, {
  'code': '331181',
  'sheng': '33',
  'di': '11',
  'xian': '81',
  'name': '龙泉市',
  'level': 3
}, {
  'code': '340000',
  'sheng': '34',
  'di': '00',
  'xian': '00',
  'name': '安徽省',
  'level': 1
}, {
  'code': '340100',
  'sheng': '34',
  'di': '01',
  'xian': '00',
  'name': '合肥市',
  'level': 2
}, {
  'code': '340101',
  'sheng': '34',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340102',
  'sheng': '34',
  'di': '01',
  'xian': '02',
  'name': '瑶海区',
  'level': 3
}, {
  'code': '340103',
  'sheng': '34',
  'di': '01',
  'xian': '03',
  'name': '庐阳区',
  'level': 3
}, {
  'code': '340104',
  'sheng': '34',
  'di': '01',
  'xian': '04',
  'name': '蜀山区',
  'level': 3
}, {
  'code': '340111',
  'sheng': '34',
  'di': '01',
  'xian': '11',
  'name': '包河区',
  'level': 3
}, {
  'code': '340121',
  'sheng': '34',
  'di': '01',
  'xian': '21',
  'name': '长丰县',
  'level': 3
}, {
  'code': '340122',
  'sheng': '34',
  'di': '01',
  'xian': '22',
  'name': '肥东县',
  'level': 3
}, {
  'code': '340123',
  'sheng': '34',
  'di': '01',
  'xian': '23',
  'name': '肥西县',
  'level': 3
}, {
  'code': '340124',
  'sheng': '34',
  'di': '01',
  'xian': '24',
  'name': '庐江县',
  'level': 3
}, {
  'code': '340181',
  'sheng': '34',
  'di': '01',
  'xian': '81',
  'name': '巢湖市',
  'level': 3
}, {
  'code': '340200',
  'sheng': '34',
  'di': '02',
  'xian': '00',
  'name': '芜湖市',
  'level': 2
}, {
  'code': '340201',
  'sheng': '34',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340202',
  'sheng': '34',
  'di': '02',
  'xian': '02',
  'name': '镜湖区',
  'level': 3
}, {
  'code': '340203',
  'sheng': '34',
  'di': '02',
  'xian': '03',
  'name': '弋江区',
  'level': 3
}, {
  'code': '340207',
  'sheng': '34',
  'di': '02',
  'xian': '07',
  'name': '鸠江区',
  'level': 3
}, {
  'code': '340208',
  'sheng': '34',
  'di': '02',
  'xian': '08',
  'name': '三山区',
  'level': 3
}, {
  'code': '340221',
  'sheng': '34',
  'di': '02',
  'xian': '21',
  'name': '芜湖县',
  'level': 3
}, {
  'code': '340222',
  'sheng': '34',
  'di': '02',
  'xian': '22',
  'name': '繁昌县',
  'level': 3
}, {
  'code': '340223',
  'sheng': '34',
  'di': '02',
  'xian': '23',
  'name': '南陵县',
  'level': 3
}, {
  'code': '340225',
  'sheng': '34',
  'di': '02',
  'xian': '25',
  'name': '无为县',
  'level': 3
}, {
  'code': '340300',
  'sheng': '34',
  'di': '03',
  'xian': '00',
  'name': '蚌埠市',
  'level': 2
}, {
  'code': '340301',
  'sheng': '34',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340302',
  'sheng': '34',
  'di': '03',
  'xian': '02',
  'name': '龙子湖区',
  'level': 3
}, {
  'code': '340303',
  'sheng': '34',
  'di': '03',
  'xian': '03',
  'name': '蚌山区',
  'level': 3
}, {
  'code': '340304',
  'sheng': '34',
  'di': '03',
  'xian': '04',
  'name': '禹会区',
  'level': 3
}, {
  'code': '340311',
  'sheng': '34',
  'di': '03',
  'xian': '11',
  'name': '淮上区',
  'level': 3
}, {
  'code': '340321',
  'sheng': '34',
  'di': '03',
  'xian': '21',
  'name': '怀远县',
  'level': 3
}, {
  'code': '340322',
  'sheng': '34',
  'di': '03',
  'xian': '22',
  'name': '五河县',
  'level': 3
}, {
  'code': '340323',
  'sheng': '34',
  'di': '03',
  'xian': '23',
  'name': '固镇县',
  'level': 3
}, {
  'code': '340400',
  'sheng': '34',
  'di': '04',
  'xian': '00',
  'name': '淮南市',
  'level': 2
}, {
  'code': '340401',
  'sheng': '34',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340402',
  'sheng': '34',
  'di': '04',
  'xian': '02',
  'name': '大通区',
  'level': 3
}, {
  'code': '340403',
  'sheng': '34',
  'di': '04',
  'xian': '03',
  'name': '田家庵区',
  'level': 3
}, {
  'code': '340404',
  'sheng': '34',
  'di': '04',
  'xian': '04',
  'name': '谢家集区',
  'level': 3
}, {
  'code': '340405',
  'sheng': '34',
  'di': '04',
  'xian': '05',
  'name': '八公山区',
  'level': 3
}, {
  'code': '340406',
  'sheng': '34',
  'di': '04',
  'xian': '06',
  'name': '潘集区',
  'level': 3
}, {
  'code': '340421',
  'sheng': '34',
  'di': '04',
  'xian': '21',
  'name': '凤台县',
  'level': 3
}, {
  'code': '340500',
  'sheng': '34',
  'di': '05',
  'xian': '00',
  'name': '马鞍山市',
  'level': 2
}, {
  'code': '340501',
  'sheng': '34',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340503',
  'sheng': '34',
  'di': '05',
  'xian': '03',
  'name': '花山区',
  'level': 3
}, {
  'code': '340504',
  'sheng': '34',
  'di': '05',
  'xian': '04',
  'name': '雨山区',
  'level': 3
}, {
  'code': '340506',
  'sheng': '34',
  'di': '05',
  'xian': '06',
  'name': '博望区',
  'level': 3
}, {
  'code': '340521',
  'sheng': '34',
  'di': '05',
  'xian': '21',
  'name': '当涂县',
  'level': 3
}, {
  'code': '340522',
  'sheng': '34',
  'di': '05',
  'xian': '22',
  'name': '含山县',
  'level': 3
}, {
  'code': '340523',
  'sheng': '34',
  'di': '05',
  'xian': '23',
  'name': '和县',
  'level': 3
}, {
  'code': '340600',
  'sheng': '34',
  'di': '06',
  'xian': '00',
  'name': '淮北市',
  'level': 2
}, {
  'code': '340601',
  'sheng': '34',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340602',
  'sheng': '34',
  'di': '06',
  'xian': '02',
  'name': '杜集区',
  'level': 3
}, {
  'code': '340603',
  'sheng': '34',
  'di': '06',
  'xian': '03',
  'name': '相山区',
  'level': 3
}, {
  'code': '340604',
  'sheng': '34',
  'di': '06',
  'xian': '04',
  'name': '烈山区',
  'level': 3
}, {
  'code': '340621',
  'sheng': '34',
  'di': '06',
  'xian': '21',
  'name': '濉溪县',
  'level': 3
}, {
  'code': '340700',
  'sheng': '34',
  'di': '07',
  'xian': '00',
  'name': '铜陵市',
  'level': 2
}, {
  'code': '340701',
  'sheng': '34',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340702',
  'sheng': '34',
  'di': '07',
  'xian': '02',
  'name': '铜官山区',
  'level': 3
}, {
  'code': '340703',
  'sheng': '34',
  'di': '07',
  'xian': '03',
  'name': '狮子山区',
  'level': 3
}, {
  'code': '340711',
  'sheng': '34',
  'di': '07',
  'xian': '11',
  'name': '郊区',
  'level': 3
}, {
  'code': '340721',
  'sheng': '34',
  'di': '07',
  'xian': '21',
  'name': '铜陵县',
  'level': 3
}, {
  'code': '340800',
  'sheng': '34',
  'di': '08',
  'xian': '00',
  'name': '安庆市',
  'level': 2
}, {
  'code': '340801',
  'sheng': '34',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '340802',
  'sheng': '34',
  'di': '08',
  'xian': '02',
  'name': '迎江区',
  'level': 3
}, {
  'code': '340803',
  'sheng': '34',
  'di': '08',
  'xian': '03',
  'name': '大观区',
  'level': 3
}, {
  'code': '340811',
  'sheng': '34',
  'di': '08',
  'xian': '11',
  'name': '宜秀区',
  'level': 3
}, {
  'code': '340822',
  'sheng': '34',
  'di': '08',
  'xian': '22',
  'name': '怀宁县',
  'level': 3
}, {
  'code': '340823',
  'sheng': '34',
  'di': '08',
  'xian': '23',
  'name': '枞阳县',
  'level': 3
}, {
  'code': '340824',
  'sheng': '34',
  'di': '08',
  'xian': '24',
  'name': '潜山县',
  'level': 3
}, {
  'code': '340825',
  'sheng': '34',
  'di': '08',
  'xian': '25',
  'name': '太湖县',
  'level': 3
}, {
  'code': '340826',
  'sheng': '34',
  'di': '08',
  'xian': '26',
  'name': '宿松县',
  'level': 3
}, {
  'code': '340827',
  'sheng': '34',
  'di': '08',
  'xian': '27',
  'name': '望江县',
  'level': 3
}, {
  'code': '340828',
  'sheng': '34',
  'di': '08',
  'xian': '28',
  'name': '岳西县',
  'level': 3
}, {
  'code': '340881',
  'sheng': '34',
  'di': '08',
  'xian': '81',
  'name': '桐城市',
  'level': 3
}, {
  'code': '341000',
  'sheng': '34',
  'di': '10',
  'xian': '00',
  'name': '黄山市',
  'level': 2
}, {
  'code': '341001',
  'sheng': '34',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341002',
  'sheng': '34',
  'di': '10',
  'xian': '02',
  'name': '屯溪区',
  'level': 3
}, {
  'code': '341003',
  'sheng': '34',
  'di': '10',
  'xian': '03',
  'name': '黄山区',
  'level': 3
}, {
  'code': '341004',
  'sheng': '34',
  'di': '10',
  'xian': '04',
  'name': '徽州区',
  'level': 3
}, {
  'code': '341021',
  'sheng': '34',
  'di': '10',
  'xian': '21',
  'name': '歙县',
  'level': 3
}, {
  'code': '341022',
  'sheng': '34',
  'di': '10',
  'xian': '22',
  'name': '休宁县',
  'level': 3
}, {
  'code': '341023',
  'sheng': '34',
  'di': '10',
  'xian': '23',
  'name': '黟县',
  'level': 3
}, {
  'code': '341024',
  'sheng': '34',
  'di': '10',
  'xian': '24',
  'name': '祁门县',
  'level': 3
}, {
  'code': '341100',
  'sheng': '34',
  'di': '11',
  'xian': '00',
  'name': '滁州市',
  'level': 2
}, {
  'code': '341101',
  'sheng': '34',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341102',
  'sheng': '34',
  'di': '11',
  'xian': '02',
  'name': '琅琊区',
  'level': 3
}, {
  'code': '341103',
  'sheng': '34',
  'di': '11',
  'xian': '03',
  'name': '南谯区',
  'level': 3
}, {
  'code': '341122',
  'sheng': '34',
  'di': '11',
  'xian': '22',
  'name': '来安县',
  'level': 3
}, {
  'code': '341124',
  'sheng': '34',
  'di': '11',
  'xian': '24',
  'name': '全椒县',
  'level': 3
}, {
  'code': '341125',
  'sheng': '34',
  'di': '11',
  'xian': '25',
  'name': '定远县',
  'level': 3
}, {
  'code': '341126',
  'sheng': '34',
  'di': '11',
  'xian': '26',
  'name': '凤阳县',
  'level': 3
}, {
  'code': '341181',
  'sheng': '34',
  'di': '11',
  'xian': '81',
  'name': '天长市',
  'level': 3
}, {
  'code': '341182',
  'sheng': '34',
  'di': '11',
  'xian': '82',
  'name': '明光市',
  'level': 3
}, {
  'code': '341200',
  'sheng': '34',
  'di': '12',
  'xian': '00',
  'name': '阜阳市',
  'level': 2
}, {
  'code': '341201',
  'sheng': '34',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341202',
  'sheng': '34',
  'di': '12',
  'xian': '02',
  'name': '颍州区',
  'level': 3
}, {
  'code': '341203',
  'sheng': '34',
  'di': '12',
  'xian': '03',
  'name': '颍东区',
  'level': 3
}, {
  'code': '341204',
  'sheng': '34',
  'di': '12',
  'xian': '04',
  'name': '颍泉区',
  'level': 3
}, {
  'code': '341221',
  'sheng': '34',
  'di': '12',
  'xian': '21',
  'name': '临泉县',
  'level': 3
}, {
  'code': '341222',
  'sheng': '34',
  'di': '12',
  'xian': '22',
  'name': '太和县',
  'level': 3
}, {
  'code': '341225',
  'sheng': '34',
  'di': '12',
  'xian': '25',
  'name': '阜南县',
  'level': 3
}, {
  'code': '341226',
  'sheng': '34',
  'di': '12',
  'xian': '26',
  'name': '颍上县',
  'level': 3
}, {
  'code': '341282',
  'sheng': '34',
  'di': '12',
  'xian': '82',
  'name': '界首市',
  'level': 3
}, {
  'code': '341300',
  'sheng': '34',
  'di': '13',
  'xian': '00',
  'name': '宿州市',
  'level': 2
}, {
  'code': '341301',
  'sheng': '34',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341302',
  'sheng': '34',
  'di': '13',
  'xian': '02',
  'name': '埇桥区',
  'level': 3
}, {
  'code': '341321',
  'sheng': '34',
  'di': '13',
  'xian': '21',
  'name': '砀山县',
  'level': 3
}, {
  'code': '341322',
  'sheng': '34',
  'di': '13',
  'xian': '22',
  'name': '萧县',
  'level': 3
}, {
  'code': '341323',
  'sheng': '34',
  'di': '13',
  'xian': '23',
  'name': '灵璧县',
  'level': 3
}, {
  'code': '341324',
  'sheng': '34',
  'di': '13',
  'xian': '24',
  'name': '泗县',
  'level': 3
}, {
  'code': '341500',
  'sheng': '34',
  'di': '15',
  'xian': '00',
  'name': '六安市',
  'level': 2
}, {
  'code': '341501',
  'sheng': '34',
  'di': '15',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341502',
  'sheng': '34',
  'di': '15',
  'xian': '02',
  'name': '金安区',
  'level': 3
}, {
  'code': '341503',
  'sheng': '34',
  'di': '15',
  'xian': '03',
  'name': '裕安区',
  'level': 3
}, {
  'code': '341521',
  'sheng': '34',
  'di': '15',
  'xian': '21',
  'name': '寿县',
  'level': 3
}, {
  'code': '341522',
  'sheng': '34',
  'di': '15',
  'xian': '22',
  'name': '霍邱县',
  'level': 3
}, {
  'code': '341523',
  'sheng': '34',
  'di': '15',
  'xian': '23',
  'name': '舒城县',
  'level': 3
}, {
  'code': '341524',
  'sheng': '34',
  'di': '15',
  'xian': '24',
  'name': '金寨县',
  'level': 3
}, {
  'code': '341525',
  'sheng': '34',
  'di': '15',
  'xian': '25',
  'name': '霍山县',
  'level': 3
}, {
  'code': '341600',
  'sheng': '34',
  'di': '16',
  'xian': '00',
  'name': '亳州市',
  'level': 2
}, {
  'code': '341601',
  'sheng': '34',
  'di': '16',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341602',
  'sheng': '34',
  'di': '16',
  'xian': '02',
  'name': '谯城区',
  'level': 3
}, {
  'code': '341621',
  'sheng': '34',
  'di': '16',
  'xian': '21',
  'name': '涡阳县',
  'level': 3
}, {
  'code': '341622',
  'sheng': '34',
  'di': '16',
  'xian': '22',
  'name': '蒙城县',
  'level': 3
}, {
  'code': '341623',
  'sheng': '34',
  'di': '16',
  'xian': '23',
  'name': '利辛县',
  'level': 3
}, {
  'code': '341700',
  'sheng': '34',
  'di': '17',
  'xian': '00',
  'name': '池州市',
  'level': 2
}, {
  'code': '341701',
  'sheng': '34',
  'di': '17',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341702',
  'sheng': '34',
  'di': '17',
  'xian': '02',
  'name': '贵池区',
  'level': 3
}, {
  'code': '341721',
  'sheng': '34',
  'di': '17',
  'xian': '21',
  'name': '东至县',
  'level': 3
}, {
  'code': '341722',
  'sheng': '34',
  'di': '17',
  'xian': '22',
  'name': '石台县',
  'level': 3
}, {
  'code': '341723',
  'sheng': '34',
  'di': '17',
  'xian': '23',
  'name': '青阳县',
  'level': 3
}, {
  'code': '341800',
  'sheng': '34',
  'di': '18',
  'xian': '00',
  'name': '宣城市',
  'level': 2
}, {
  'code': '341801',
  'sheng': '34',
  'di': '18',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '341802',
  'sheng': '34',
  'di': '18',
  'xian': '02',
  'name': '宣州区',
  'level': 3
}, {
  'code': '341821',
  'sheng': '34',
  'di': '18',
  'xian': '21',
  'name': '郎溪县',
  'level': 3
}, {
  'code': '341822',
  'sheng': '34',
  'di': '18',
  'xian': '22',
  'name': '广德县',
  'level': 3
}, {
  'code': '341823',
  'sheng': '34',
  'di': '18',
  'xian': '23',
  'name': '泾县',
  'level': 3
}, {
  'code': '341824',
  'sheng': '34',
  'di': '18',
  'xian': '24',
  'name': '绩溪县',
  'level': 3
}, {
  'code': '341825',
  'sheng': '34',
  'di': '18',
  'xian': '25',
  'name': '旌德县',
  'level': 3
}, {
  'code': '341881',
  'sheng': '34',
  'di': '18',
  'xian': '81',
  'name': '宁国市',
  'level': 3
}, {
  'code': '350000',
  'sheng': '35',
  'di': '00',
  'xian': '00',
  'name': '福建省',
  'level': 1
}, {
  'code': '350100',
  'sheng': '35',
  'di': '01',
  'xian': '00',
  'name': '福州市',
  'level': 2
}, {
  'code': '350101',
  'sheng': '35',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350102',
  'sheng': '35',
  'di': '01',
  'xian': '02',
  'name': '鼓楼区',
  'level': 3
}, {
  'code': '350103',
  'sheng': '35',
  'di': '01',
  'xian': '03',
  'name': '台江区',
  'level': 3
}, {
  'code': '350104',
  'sheng': '35',
  'di': '01',
  'xian': '04',
  'name': '仓山区',
  'level': 3
}, {
  'code': '350105',
  'sheng': '35',
  'di': '01',
  'xian': '05',
  'name': '马尾区',
  'level': 3
}, {
  'code': '350111',
  'sheng': '35',
  'di': '01',
  'xian': '11',
  'name': '晋安区',
  'level': 3
}, {
  'code': '350121',
  'sheng': '35',
  'di': '01',
  'xian': '21',
  'name': '闽侯县',
  'level': 3
}, {
  'code': '350122',
  'sheng': '35',
  'di': '01',
  'xian': '22',
  'name': '连江县',
  'level': 3
}, {
  'code': '350123',
  'sheng': '35',
  'di': '01',
  'xian': '23',
  'name': '罗源县',
  'level': 3
}, {
  'code': '350124',
  'sheng': '35',
  'di': '01',
  'xian': '24',
  'name': '闽清县',
  'level': 3
}, {
  'code': '350125',
  'sheng': '35',
  'di': '01',
  'xian': '25',
  'name': '永泰县',
  'level': 3
}, {
  'code': '350128',
  'sheng': '35',
  'di': '01',
  'xian': '28',
  'name': '平潭县',
  'level': 3
}, {
  'code': '350181',
  'sheng': '35',
  'di': '01',
  'xian': '81',
  'name': '福清市',
  'level': 3
}, {
  'code': '350182',
  'sheng': '35',
  'di': '01',
  'xian': '82',
  'name': '长乐市',
  'level': 3
}, {
  'code': '350200',
  'sheng': '35',
  'di': '02',
  'xian': '00',
  'name': '厦门市',
  'level': 2
}, {
  'code': '350201',
  'sheng': '35',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350203',
  'sheng': '35',
  'di': '02',
  'xian': '03',
  'name': '思明区',
  'level': 3
}, {
  'code': '350205',
  'sheng': '35',
  'di': '02',
  'xian': '05',
  'name': '海沧区',
  'level': 3
}, {
  'code': '350206',
  'sheng': '35',
  'di': '02',
  'xian': '06',
  'name': '湖里区',
  'level': 3
}, {
  'code': '350211',
  'sheng': '35',
  'di': '02',
  'xian': '11',
  'name': '集美区',
  'level': 3
}, {
  'code': '350212',
  'sheng': '35',
  'di': '02',
  'xian': '12',
  'name': '同安区',
  'level': 3
}, {
  'code': '350213',
  'sheng': '35',
  'di': '02',
  'xian': '13',
  'name': '翔安区',
  'level': 3
}, {
  'code': '350300',
  'sheng': '35',
  'di': '03',
  'xian': '00',
  'name': '莆田市',
  'level': 2
}, {
  'code': '350301',
  'sheng': '35',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350302',
  'sheng': '35',
  'di': '03',
  'xian': '02',
  'name': '城厢区',
  'level': 3
}, {
  'code': '350303',
  'sheng': '35',
  'di': '03',
  'xian': '03',
  'name': '涵江区',
  'level': 3
}, {
  'code': '350304',
  'sheng': '35',
  'di': '03',
  'xian': '04',
  'name': '荔城区',
  'level': 3
}, {
  'code': '350305',
  'sheng': '35',
  'di': '03',
  'xian': '05',
  'name': '秀屿区',
  'level': 3
}, {
  'code': '350322',
  'sheng': '35',
  'di': '03',
  'xian': '22',
  'name': '仙游县',
  'level': 3
}, {
  'code': '350400',
  'sheng': '35',
  'di': '04',
  'xian': '00',
  'name': '三明市',
  'level': 2
}, {
  'code': '350401',
  'sheng': '35',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350402',
  'sheng': '35',
  'di': '04',
  'xian': '02',
  'name': '梅列区',
  'level': 3
}, {
  'code': '350403',
  'sheng': '35',
  'di': '04',
  'xian': '03',
  'name': '三元区',
  'level': 3
}, {
  'code': '350421',
  'sheng': '35',
  'di': '04',
  'xian': '21',
  'name': '明溪县',
  'level': 3
}, {
  'code': '350423',
  'sheng': '35',
  'di': '04',
  'xian': '23',
  'name': '清流县',
  'level': 3
}, {
  'code': '350424',
  'sheng': '35',
  'di': '04',
  'xian': '24',
  'name': '宁化县',
  'level': 3
}, {
  'code': '350425',
  'sheng': '35',
  'di': '04',
  'xian': '25',
  'name': '大田县',
  'level': 3
}, {
  'code': '350426',
  'sheng': '35',
  'di': '04',
  'xian': '26',
  'name': '尤溪县',
  'level': 3
}, {
  'code': '350427',
  'sheng': '35',
  'di': '04',
  'xian': '27',
  'name': '沙县',
  'level': 3
}, {
  'code': '350428',
  'sheng': '35',
  'di': '04',
  'xian': '28',
  'name': '将乐县',
  'level': 3
}, {
  'code': '350429',
  'sheng': '35',
  'di': '04',
  'xian': '29',
  'name': '泰宁县',
  'level': 3
}, {
  'code': '350430',
  'sheng': '35',
  'di': '04',
  'xian': '30',
  'name': '建宁县',
  'level': 3
}, {
  'code': '350481',
  'sheng': '35',
  'di': '04',
  'xian': '81',
  'name': '永安市',
  'level': 3
}, {
  'code': '350500',
  'sheng': '35',
  'di': '05',
  'xian': '00',
  'name': '泉州市',
  'level': 2
}, {
  'code': '350501',
  'sheng': '35',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350502',
  'sheng': '35',
  'di': '05',
  'xian': '02',
  'name': '鲤城区',
  'level': 3
}, {
  'code': '350503',
  'sheng': '35',
  'di': '05',
  'xian': '03',
  'name': '丰泽区',
  'level': 3
}, {
  'code': '350504',
  'sheng': '35',
  'di': '05',
  'xian': '04',
  'name': '洛江区',
  'level': 3
}, {
  'code': '350505',
  'sheng': '35',
  'di': '05',
  'xian': '05',
  'name': '泉港区',
  'level': 3
}, {
  'code': '350521',
  'sheng': '35',
  'di': '05',
  'xian': '21',
  'name': '惠安县',
  'level': 3
}, {
  'code': '350524',
  'sheng': '35',
  'di': '05',
  'xian': '24',
  'name': '安溪县',
  'level': 3
}, {
  'code': '350525',
  'sheng': '35',
  'di': '05',
  'xian': '25',
  'name': '永春县',
  'level': 3
}, {
  'code': '350526',
  'sheng': '35',
  'di': '05',
  'xian': '26',
  'name': '德化县',
  'level': 3
}, {
  'code': '350527',
  'sheng': '35',
  'di': '05',
  'xian': '27',
  'name': '金门县',
  'level': 3
}, {
  'code': '350581',
  'sheng': '35',
  'di': '05',
  'xian': '81',
  'name': '石狮市',
  'level': 3
}, {
  'code': '350582',
  'sheng': '35',
  'di': '05',
  'xian': '82',
  'name': '晋江市',
  'level': 3
}, {
  'code': '350583',
  'sheng': '35',
  'di': '05',
  'xian': '83',
  'name': '南安市',
  'level': 3
}, {
  'code': '350600',
  'sheng': '35',
  'di': '06',
  'xian': '00',
  'name': '漳州市',
  'level': 2
}, {
  'code': '350601',
  'sheng': '35',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350602',
  'sheng': '35',
  'di': '06',
  'xian': '02',
  'name': '芗城区',
  'level': 3
}, {
  'code': '350603',
  'sheng': '35',
  'di': '06',
  'xian': '03',
  'name': '龙文区',
  'level': 3
}, {
  'code': '350622',
  'sheng': '35',
  'di': '06',
  'xian': '22',
  'name': '云霄县',
  'level': 3
}, {
  'code': '350623',
  'sheng': '35',
  'di': '06',
  'xian': '23',
  'name': '漳浦县',
  'level': 3
}, {
  'code': '350624',
  'sheng': '35',
  'di': '06',
  'xian': '24',
  'name': '诏安县',
  'level': 3
}, {
  'code': '350625',
  'sheng': '35',
  'di': '06',
  'xian': '25',
  'name': '长泰县',
  'level': 3
}, {
  'code': '350626',
  'sheng': '35',
  'di': '06',
  'xian': '26',
  'name': '东山县',
  'level': 3
}, {
  'code': '350627',
  'sheng': '35',
  'di': '06',
  'xian': '27',
  'name': '南靖县',
  'level': 3
}, {
  'code': '350628',
  'sheng': '35',
  'di': '06',
  'xian': '28',
  'name': '平和县',
  'level': 3
}, {
  'code': '350629',
  'sheng': '35',
  'di': '06',
  'xian': '29',
  'name': '华安县',
  'level': 3
}, {
  'code': '350681',
  'sheng': '35',
  'di': '06',
  'xian': '81',
  'name': '龙海市',
  'level': 3
}, {
  'code': '350700',
  'sheng': '35',
  'di': '07',
  'xian': '00',
  'name': '南平市',
  'level': 2
}, {
  'code': '350701',
  'sheng': '35',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350702',
  'sheng': '35',
  'di': '07',
  'xian': '02',
  'name': '延平区',
  'level': 3
}, {
  'code': '350721',
  'sheng': '35',
  'di': '07',
  'xian': '21',
  'name': '顺昌县',
  'level': 3
}, {
  'code': '350722',
  'sheng': '35',
  'di': '07',
  'xian': '22',
  'name': '浦城县',
  'level': 3
}, {
  'code': '350723',
  'sheng': '35',
  'di': '07',
  'xian': '23',
  'name': '光泽县',
  'level': 3
}, {
  'code': '350724',
  'sheng': '35',
  'di': '07',
  'xian': '24',
  'name': '松溪县',
  'level': 3
}, {
  'code': '350725',
  'sheng': '35',
  'di': '07',
  'xian': '25',
  'name': '政和县',
  'level': 3
}, {
  'code': '350781',
  'sheng': '35',
  'di': '07',
  'xian': '81',
  'name': '邵武市',
  'level': 3
}, {
  'code': '350782',
  'sheng': '35',
  'di': '07',
  'xian': '82',
  'name': '武夷山市',
  'level': 3
}, {
  'code': '350783',
  'sheng': '35',
  'di': '07',
  'xian': '83',
  'name': '建瓯市',
  'level': 3
}, {
  'code': '350784',
  'sheng': '35',
  'di': '07',
  'xian': '84',
  'name': '建阳市',
  'level': 3
}, {
  'code': '350800',
  'sheng': '35',
  'di': '08',
  'xian': '00',
  'name': '龙岩市',
  'level': 2
}, {
  'code': '350801',
  'sheng': '35',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350802',
  'sheng': '35',
  'di': '08',
  'xian': '02',
  'name': '新罗区',
  'level': 3
}, {
  'code': '350821',
  'sheng': '35',
  'di': '08',
  'xian': '21',
  'name': '长汀县',
  'level': 3
}, {
  'code': '350822',
  'sheng': '35',
  'di': '08',
  'xian': '22',
  'name': '永定县',
  'level': 3
}, {
  'code': '350823',
  'sheng': '35',
  'di': '08',
  'xian': '23',
  'name': '上杭县',
  'level': 3
}, {
  'code': '350824',
  'sheng': '35',
  'di': '08',
  'xian': '24',
  'name': '武平县',
  'level': 3
}, {
  'code': '350825',
  'sheng': '35',
  'di': '08',
  'xian': '25',
  'name': '连城县',
  'level': 3
}, {
  'code': '350881',
  'sheng': '35',
  'di': '08',
  'xian': '81',
  'name': '漳平市',
  'level': 3
}, {
  'code': '350900',
  'sheng': '35',
  'di': '09',
  'xian': '00',
  'name': '宁德市',
  'level': 2
}, {
  'code': '350901',
  'sheng': '35',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '350902',
  'sheng': '35',
  'di': '09',
  'xian': '02',
  'name': '蕉城区',
  'level': 3
}, {
  'code': '350921',
  'sheng': '35',
  'di': '09',
  'xian': '21',
  'name': '霞浦县',
  'level': 3
}, {
  'code': '350922',
  'sheng': '35',
  'di': '09',
  'xian': '22',
  'name': '古田县',
  'level': 3
}, {
  'code': '350923',
  'sheng': '35',
  'di': '09',
  'xian': '23',
  'name': '屏南县',
  'level': 3
}, {
  'code': '350924',
  'sheng': '35',
  'di': '09',
  'xian': '24',
  'name': '寿宁县',
  'level': 3
}, {
  'code': '350925',
  'sheng': '35',
  'di': '09',
  'xian': '25',
  'name': '周宁县',
  'level': 3
}, {
  'code': '350926',
  'sheng': '35',
  'di': '09',
  'xian': '26',
  'name': '柘荣县',
  'level': 3
}, {
  'code': '350981',
  'sheng': '35',
  'di': '09',
  'xian': '81',
  'name': '福安市',
  'level': 3
}, {
  'code': '350982',
  'sheng': '35',
  'di': '09',
  'xian': '82',
  'name': '福鼎市',
  'level': 3
}, {
  'code': '360000',
  'sheng': '36',
  'di': '00',
  'xian': '00',
  'name': '江西省',
  'level': 1
}, {
  'code': '360100',
  'sheng': '36',
  'di': '01',
  'xian': '00',
  'name': '南昌市',
  'level': 2
}, {
  'code': '360101',
  'sheng': '36',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360102',
  'sheng': '36',
  'di': '01',
  'xian': '02',
  'name': '东湖区',
  'level': 3
}, {
  'code': '360103',
  'sheng': '36',
  'di': '01',
  'xian': '03',
  'name': '西湖区',
  'level': 3
}, {
  'code': '360104',
  'sheng': '36',
  'di': '01',
  'xian': '04',
  'name': '青云谱区',
  'level': 3
}, {
  'code': '360105',
  'sheng': '36',
  'di': '01',
  'xian': '05',
  'name': '湾里区',
  'level': 3
}, {
  'code': '360111',
  'sheng': '36',
  'di': '01',
  'xian': '11',
  'name': '青山湖区',
  'level': 3
}, {
  'code': '360121',
  'sheng': '36',
  'di': '01',
  'xian': '21',
  'name': '南昌县',
  'level': 3
}, {
  'code': '360122',
  'sheng': '36',
  'di': '01',
  'xian': '22',
  'name': '新建县',
  'level': 3
}, {
  'code': '360123',
  'sheng': '36',
  'di': '01',
  'xian': '23',
  'name': '安义县',
  'level': 3
}, {
  'code': '360124',
  'sheng': '36',
  'di': '01',
  'xian': '24',
  'name': '进贤县',
  'level': 3
}, {
  'code': '360200',
  'sheng': '36',
  'di': '02',
  'xian': '00',
  'name': '景德镇市',
  'level': 2
}, {
  'code': '360201',
  'sheng': '36',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360202',
  'sheng': '36',
  'di': '02',
  'xian': '02',
  'name': '昌江区',
  'level': 3
}, {
  'code': '360203',
  'sheng': '36',
  'di': '02',
  'xian': '03',
  'name': '珠山区',
  'level': 3
}, {
  'code': '360222',
  'sheng': '36',
  'di': '02',
  'xian': '22',
  'name': '浮梁县',
  'level': 3
}, {
  'code': '360281',
  'sheng': '36',
  'di': '02',
  'xian': '81',
  'name': '乐平市',
  'level': 3
}, {
  'code': '360300',
  'sheng': '36',
  'di': '03',
  'xian': '00',
  'name': '萍乡市',
  'level': 2
}, {
  'code': '360301',
  'sheng': '36',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360302',
  'sheng': '36',
  'di': '03',
  'xian': '02',
  'name': '安源区',
  'level': 3
}, {
  'code': '360313',
  'sheng': '36',
  'di': '03',
  'xian': '13',
  'name': '湘东区',
  'level': 3
}, {
  'code': '360321',
  'sheng': '36',
  'di': '03',
  'xian': '21',
  'name': '莲花县',
  'level': 3
}, {
  'code': '360322',
  'sheng': '36',
  'di': '03',
  'xian': '22',
  'name': '上栗县',
  'level': 3
}, {
  'code': '360323',
  'sheng': '36',
  'di': '03',
  'xian': '23',
  'name': '芦溪县',
  'level': 3
}, {
  'code': '360400',
  'sheng': '36',
  'di': '04',
  'xian': '00',
  'name': '九江市',
  'level': 2
}, {
  'code': '360401',
  'sheng': '36',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360402',
  'sheng': '36',
  'di': '04',
  'xian': '02',
  'name': '庐山区',
  'level': 3
}, {
  'code': '360403',
  'sheng': '36',
  'di': '04',
  'xian': '03',
  'name': '浔阳区',
  'level': 3
}, {
  'code': '360421',
  'sheng': '36',
  'di': '04',
  'xian': '21',
  'name': '九江县',
  'level': 3
}, {
  'code': '360423',
  'sheng': '36',
  'di': '04',
  'xian': '23',
  'name': '武宁县',
  'level': 3
}, {
  'code': '360424',
  'sheng': '36',
  'di': '04',
  'xian': '24',
  'name': '修水县',
  'level': 3
}, {
  'code': '360425',
  'sheng': '36',
  'di': '04',
  'xian': '25',
  'name': '永修县',
  'level': 3
}, {
  'code': '360426',
  'sheng': '36',
  'di': '04',
  'xian': '26',
  'name': '德安县',
  'level': 3
}, {
  'code': '360427',
  'sheng': '36',
  'di': '04',
  'xian': '27',
  'name': '星子县',
  'level': 3
}, {
  'code': '360428',
  'sheng': '36',
  'di': '04',
  'xian': '28',
  'name': '都昌县',
  'level': 3
}, {
  'code': '360429',
  'sheng': '36',
  'di': '04',
  'xian': '29',
  'name': '湖口县',
  'level': 3
}, {
  'code': '360430',
  'sheng': '36',
  'di': '04',
  'xian': '30',
  'name': '彭泽县',
  'level': 3
}, {
  'code': '360481',
  'sheng': '36',
  'di': '04',
  'xian': '81',
  'name': '瑞昌市',
  'level': 3
}, {
  'code': '360482',
  'sheng': '36',
  'di': '04',
  'xian': '82',
  'name': '共青城市',
  'level': 3
}, {
  'code': '360500',
  'sheng': '36',
  'di': '05',
  'xian': '00',
  'name': '新余市',
  'level': 2
}, {
  'code': '360501',
  'sheng': '36',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360502',
  'sheng': '36',
  'di': '05',
  'xian': '02',
  'name': '渝水区',
  'level': 3
}, {
  'code': '360521',
  'sheng': '36',
  'di': '05',
  'xian': '21',
  'name': '分宜县',
  'level': 3
}, {
  'code': '360600',
  'sheng': '36',
  'di': '06',
  'xian': '00',
  'name': '鹰潭市',
  'level': 2
}, {
  'code': '360601',
  'sheng': '36',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360602',
  'sheng': '36',
  'di': '06',
  'xian': '02',
  'name': '月湖区',
  'level': 3
}, {
  'code': '360622',
  'sheng': '36',
  'di': '06',
  'xian': '22',
  'name': '余江县',
  'level': 3
}, {
  'code': '360681',
  'sheng': '36',
  'di': '06',
  'xian': '81',
  'name': '贵溪市',
  'level': 3
}, {
  'code': '360700',
  'sheng': '36',
  'di': '07',
  'xian': '00',
  'name': '赣州市',
  'level': 2
}, {
  'code': '360701',
  'sheng': '36',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360702',
  'sheng': '36',
  'di': '07',
  'xian': '02',
  'name': '章贡区',
  'level': 3
}, {
  'code': '360703',
  'sheng': '36',
  'di': '07',
  'xian': '03',
  'name': '南康区',
  'level': 3
}, {
  'code': '360721',
  'sheng': '36',
  'di': '07',
  'xian': '21',
  'name': '赣县',
  'level': 3
}, {
  'code': '360722',
  'sheng': '36',
  'di': '07',
  'xian': '22',
  'name': '信丰县',
  'level': 3
}, {
  'code': '360723',
  'sheng': '36',
  'di': '07',
  'xian': '23',
  'name': '大余县',
  'level': 3
}, {
  'code': '360724',
  'sheng': '36',
  'di': '07',
  'xian': '24',
  'name': '上犹县',
  'level': 3
}, {
  'code': '360725',
  'sheng': '36',
  'di': '07',
  'xian': '25',
  'name': '崇义县',
  'level': 3
}, {
  'code': '360726',
  'sheng': '36',
  'di': '07',
  'xian': '26',
  'name': '安远县',
  'level': 3
}, {
  'code': '360727',
  'sheng': '36',
  'di': '07',
  'xian': '27',
  'name': '龙南县',
  'level': 3
}, {
  'code': '360728',
  'sheng': '36',
  'di': '07',
  'xian': '28',
  'name': '定南县',
  'level': 3
}, {
  'code': '360729',
  'sheng': '36',
  'di': '07',
  'xian': '29',
  'name': '全南县',
  'level': 3
}, {
  'code': '360730',
  'sheng': '36',
  'di': '07',
  'xian': '30',
  'name': '宁都县',
  'level': 3
}, {
  'code': '360731',
  'sheng': '36',
  'di': '07',
  'xian': '31',
  'name': '于都县',
  'level': 3
}, {
  'code': '360732',
  'sheng': '36',
  'di': '07',
  'xian': '32',
  'name': '兴国县',
  'level': 3
}, {
  'code': '360733',
  'sheng': '36',
  'di': '07',
  'xian': '33',
  'name': '会昌县',
  'level': 3
}, {
  'code': '360734',
  'sheng': '36',
  'di': '07',
  'xian': '34',
  'name': '寻乌县',
  'level': 3
}, {
  'code': '360735',
  'sheng': '36',
  'di': '07',
  'xian': '35',
  'name': '石城县',
  'level': 3
}, {
  'code': '360781',
  'sheng': '36',
  'di': '07',
  'xian': '81',
  'name': '瑞金市',
  'level': 3
}, {
  'code': '360800',
  'sheng': '36',
  'di': '08',
  'xian': '00',
  'name': '吉安市',
  'level': 2
}, {
  'code': '360801',
  'sheng': '36',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360802',
  'sheng': '36',
  'di': '08',
  'xian': '02',
  'name': '吉州区',
  'level': 3
}, {
  'code': '360803',
  'sheng': '36',
  'di': '08',
  'xian': '03',
  'name': '青原区',
  'level': 3
}, {
  'code': '360821',
  'sheng': '36',
  'di': '08',
  'xian': '21',
  'name': '吉安县',
  'level': 3
}, {
  'code': '360822',
  'sheng': '36',
  'di': '08',
  'xian': '22',
  'name': '吉水县',
  'level': 3
}, {
  'code': '360823',
  'sheng': '36',
  'di': '08',
  'xian': '23',
  'name': '峡江县',
  'level': 3
}, {
  'code': '360824',
  'sheng': '36',
  'di': '08',
  'xian': '24',
  'name': '新干县',
  'level': 3
}, {
  'code': '360825',
  'sheng': '36',
  'di': '08',
  'xian': '25',
  'name': '永丰县',
  'level': 3
}, {
  'code': '360826',
  'sheng': '36',
  'di': '08',
  'xian': '26',
  'name': '泰和县',
  'level': 3
}, {
  'code': '360827',
  'sheng': '36',
  'di': '08',
  'xian': '27',
  'name': '遂川县',
  'level': 3
}, {
  'code': '360828',
  'sheng': '36',
  'di': '08',
  'xian': '28',
  'name': '万安县',
  'level': 3
}, {
  'code': '360829',
  'sheng': '36',
  'di': '08',
  'xian': '29',
  'name': '安福县',
  'level': 3
}, {
  'code': '360830',
  'sheng': '36',
  'di': '08',
  'xian': '30',
  'name': '永新县',
  'level': 3
}, {
  'code': '360881',
  'sheng': '36',
  'di': '08',
  'xian': '81',
  'name': '井冈山市',
  'level': 3
}, {
  'code': '360900',
  'sheng': '36',
  'di': '09',
  'xian': '00',
  'name': '宜春市',
  'level': 2
}, {
  'code': '360901',
  'sheng': '36',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '360902',
  'sheng': '36',
  'di': '09',
  'xian': '02',
  'name': '袁州区',
  'level': 3
}, {
  'code': '360921',
  'sheng': '36',
  'di': '09',
  'xian': '21',
  'name': '奉新县',
  'level': 3
}, {
  'code': '360922',
  'sheng': '36',
  'di': '09',
  'xian': '22',
  'name': '万载县',
  'level': 3
}, {
  'code': '360923',
  'sheng': '36',
  'di': '09',
  'xian': '23',
  'name': '上高县',
  'level': 3
}, {
  'code': '360924',
  'sheng': '36',
  'di': '09',
  'xian': '24',
  'name': '宜丰县',
  'level': 3
}, {
  'code': '360925',
  'sheng': '36',
  'di': '09',
  'xian': '25',
  'name': '靖安县',
  'level': 3
}, {
  'code': '360926',
  'sheng': '36',
  'di': '09',
  'xian': '26',
  'name': '铜鼓县',
  'level': 3
}, {
  'code': '360981',
  'sheng': '36',
  'di': '09',
  'xian': '81',
  'name': '丰城市',
  'level': 3
}, {
  'code': '360982',
  'sheng': '36',
  'di': '09',
  'xian': '82',
  'name': '樟树市',
  'level': 3
}, {
  'code': '360983',
  'sheng': '36',
  'di': '09',
  'xian': '83',
  'name': '高安市',
  'level': 3
}, {
  'code': '361000',
  'sheng': '36',
  'di': '10',
  'xian': '00',
  'name': '抚州市',
  'level': 2
}, {
  'code': '361001',
  'sheng': '36',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '361002',
  'sheng': '36',
  'di': '10',
  'xian': '02',
  'name': '临川区',
  'level': 3
}, {
  'code': '361021',
  'sheng': '36',
  'di': '10',
  'xian': '21',
  'name': '南城县',
  'level': 3
}, {
  'code': '361022',
  'sheng': '36',
  'di': '10',
  'xian': '22',
  'name': '黎川县',
  'level': 3
}, {
  'code': '361023',
  'sheng': '36',
  'di': '10',
  'xian': '23',
  'name': '南丰县',
  'level': 3
}, {
  'code': '361024',
  'sheng': '36',
  'di': '10',
  'xian': '24',
  'name': '崇仁县',
  'level': 3
}, {
  'code': '361025',
  'sheng': '36',
  'di': '10',
  'xian': '25',
  'name': '乐安县',
  'level': 3
}, {
  'code': '361026',
  'sheng': '36',
  'di': '10',
  'xian': '26',
  'name': '宜黄县',
  'level': 3
}, {
  'code': '361027',
  'sheng': '36',
  'di': '10',
  'xian': '27',
  'name': '金溪县',
  'level': 3
}, {
  'code': '361028',
  'sheng': '36',
  'di': '10',
  'xian': '28',
  'name': '资溪县',
  'level': 3
}, {
  'code': '361029',
  'sheng': '36',
  'di': '10',
  'xian': '29',
  'name': '东乡县',
  'level': 3
}, {
  'code': '361030',
  'sheng': '36',
  'di': '10',
  'xian': '30',
  'name': '广昌县',
  'level': 3
}, {
  'code': '361100',
  'sheng': '36',
  'di': '11',
  'xian': '00',
  'name': '上饶市',
  'level': 2
}, {
  'code': '361101',
  'sheng': '36',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '361102',
  'sheng': '36',
  'di': '11',
  'xian': '02',
  'name': '信州区',
  'level': 3
}, {
  'code': '361121',
  'sheng': '36',
  'di': '11',
  'xian': '21',
  'name': '上饶县',
  'level': 3
}, {
  'code': '361122',
  'sheng': '36',
  'di': '11',
  'xian': '22',
  'name': '广丰县',
  'level': 3
}, {
  'code': '361123',
  'sheng': '36',
  'di': '11',
  'xian': '23',
  'name': '玉山县',
  'level': 3
}, {
  'code': '361124',
  'sheng': '36',
  'di': '11',
  'xian': '24',
  'name': '铅山县',
  'level': 3
}, {
  'code': '361125',
  'sheng': '36',
  'di': '11',
  'xian': '25',
  'name': '横峰县',
  'level': 3
}, {
  'code': '361126',
  'sheng': '36',
  'di': '11',
  'xian': '26',
  'name': '弋阳县',
  'level': 3
}, {
  'code': '361127',
  'sheng': '36',
  'di': '11',
  'xian': '27',
  'name': '余干县',
  'level': 3
}, {
  'code': '361128',
  'sheng': '36',
  'di': '11',
  'xian': '28',
  'name': '鄱阳县',
  'level': 3
}, {
  'code': '361129',
  'sheng': '36',
  'di': '11',
  'xian': '29',
  'name': '万年县',
  'level': 3
}, {
  'code': '361130',
  'sheng': '36',
  'di': '11',
  'xian': '30',
  'name': '婺源县',
  'level': 3
}, {
  'code': '361181',
  'sheng': '36',
  'di': '11',
  'xian': '81',
  'name': '德兴市',
  'level': 3
}, {
  'code': '370000',
  'sheng': '37',
  'di': '00',
  'xian': '00',
  'name': '山东省',
  'level': 1
}, {
  'code': '370100',
  'sheng': '37',
  'di': '01',
  'xian': '00',
  'name': '济南市',
  'level': 2
}, {
  'code': '370101',
  'sheng': '37',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370102',
  'sheng': '37',
  'di': '01',
  'xian': '02',
  'name': '历下区',
  'level': 3
}, {
  'code': '370103',
  'sheng': '37',
  'di': '01',
  'xian': '03',
  'name': '市中区',
  'level': 3
}, {
  'code': '370104',
  'sheng': '37',
  'di': '01',
  'xian': '04',
  'name': '槐荫区',
  'level': 3
}, {
  'code': '370105',
  'sheng': '37',
  'di': '01',
  'xian': '05',
  'name': '天桥区',
  'level': 3
}, {
  'code': '370112',
  'sheng': '37',
  'di': '01',
  'xian': '12',
  'name': '历城区',
  'level': 3
}, {
  'code': '370113',
  'sheng': '37',
  'di': '01',
  'xian': '13',
  'name': '长清区',
  'level': 3
}, {
  'code': '370124',
  'sheng': '37',
  'di': '01',
  'xian': '24',
  'name': '平阴县',
  'level': 3
}, {
  'code': '370125',
  'sheng': '37',
  'di': '01',
  'xian': '25',
  'name': '济阳县',
  'level': 3
}, {
  'code': '370126',
  'sheng': '37',
  'di': '01',
  'xian': '26',
  'name': '商河县',
  'level': 3
}, {
  'code': '370181',
  'sheng': '37',
  'di': '01',
  'xian': '81',
  'name': '章丘市',
  'level': 3
}, {
  'code': '370200',
  'sheng': '37',
  'di': '02',
  'xian': '00',
  'name': '青岛市',
  'level': 2
}, {
  'code': '370201',
  'sheng': '37',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370202',
  'sheng': '37',
  'di': '02',
  'xian': '02',
  'name': '市南区',
  'level': 3
}, {
  'code': '370203',
  'sheng': '37',
  'di': '02',
  'xian': '03',
  'name': '市北区',
  'level': 3
}, {
  'code': '370211',
  'sheng': '37',
  'di': '02',
  'xian': '11',
  'name': '黄岛区',
  'level': 3
}, {
  'code': '370212',
  'sheng': '37',
  'di': '02',
  'xian': '12',
  'name': '崂山区',
  'level': 3
}, {
  'code': '370213',
  'sheng': '37',
  'di': '02',
  'xian': '13',
  'name': '李沧区',
  'level': 3
}, {
  'code': '370214',
  'sheng': '37',
  'di': '02',
  'xian': '14',
  'name': '城阳区',
  'level': 3
}, {
  'code': '370281',
  'sheng': '37',
  'di': '02',
  'xian': '81',
  'name': '胶州市',
  'level': 3
}, {
  'code': '370282',
  'sheng': '37',
  'di': '02',
  'xian': '82',
  'name': '即墨市',
  'level': 3
}, {
  'code': '370283',
  'sheng': '37',
  'di': '02',
  'xian': '83',
  'name': '平度市',
  'level': 3
}, {
  'code': '370285',
  'sheng': '37',
  'di': '02',
  'xian': '85',
  'name': '莱西市',
  'level': 3
}, {
  'code': '370300',
  'sheng': '37',
  'di': '03',
  'xian': '00',
  'name': '淄博市',
  'level': 2
}, {
  'code': '370301',
  'sheng': '37',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370302',
  'sheng': '37',
  'di': '03',
  'xian': '02',
  'name': '淄川区',
  'level': 3
}, {
  'code': '370303',
  'sheng': '37',
  'di': '03',
  'xian': '03',
  'name': '张店区',
  'level': 3
}, {
  'code': '370304',
  'sheng': '37',
  'di': '03',
  'xian': '04',
  'name': '博山区',
  'level': 3
}, {
  'code': '370305',
  'sheng': '37',
  'di': '03',
  'xian': '05',
  'name': '临淄区',
  'level': 3
}, {
  'code': '370306',
  'sheng': '37',
  'di': '03',
  'xian': '06',
  'name': '周村区',
  'level': 3
}, {
  'code': '370321',
  'sheng': '37',
  'di': '03',
  'xian': '21',
  'name': '桓台县',
  'level': 3
}, {
  'code': '370322',
  'sheng': '37',
  'di': '03',
  'xian': '22',
  'name': '高青县',
  'level': 3
}, {
  'code': '370323',
  'sheng': '37',
  'di': '03',
  'xian': '23',
  'name': '沂源县',
  'level': 3
}, {
  'code': '370400',
  'sheng': '37',
  'di': '04',
  'xian': '00',
  'name': '枣庄市',
  'level': 2
}, {
  'code': '370401',
  'sheng': '37',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370402',
  'sheng': '37',
  'di': '04',
  'xian': '02',
  'name': '市中区',
  'level': 3
}, {
  'code': '370403',
  'sheng': '37',
  'di': '04',
  'xian': '03',
  'name': '薛城区',
  'level': 3
}, {
  'code': '370404',
  'sheng': '37',
  'di': '04',
  'xian': '04',
  'name': '峄城区',
  'level': 3
}, {
  'code': '370405',
  'sheng': '37',
  'di': '04',
  'xian': '05',
  'name': '台儿庄区',
  'level': 3
}, {
  'code': '370406',
  'sheng': '37',
  'di': '04',
  'xian': '06',
  'name': '山亭区',
  'level': 3
}, {
  'code': '370481',
  'sheng': '37',
  'di': '04',
  'xian': '81',
  'name': '滕州市',
  'level': 3
}, {
  'code': '370500',
  'sheng': '37',
  'di': '05',
  'xian': '00',
  'name': '东营市',
  'level': 2
}, {
  'code': '370501',
  'sheng': '37',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370502',
  'sheng': '37',
  'di': '05',
  'xian': '02',
  'name': '东营区',
  'level': 3
}, {
  'code': '370503',
  'sheng': '37',
  'di': '05',
  'xian': '03',
  'name': '河口区',
  'level': 3
}, {
  'code': '370521',
  'sheng': '37',
  'di': '05',
  'xian': '21',
  'name': '垦利县',
  'level': 3
}, {
  'code': '370522',
  'sheng': '37',
  'di': '05',
  'xian': '22',
  'name': '利津县',
  'level': 3
}, {
  'code': '370523',
  'sheng': '37',
  'di': '05',
  'xian': '23',
  'name': '广饶县',
  'level': 3
}, {
  'code': '370600',
  'sheng': '37',
  'di': '06',
  'xian': '00',
  'name': '烟台市',
  'level': 2
}, {
  'code': '370601',
  'sheng': '37',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370602',
  'sheng': '37',
  'di': '06',
  'xian': '02',
  'name': '芝罘区',
  'level': 3
}, {
  'code': '370611',
  'sheng': '37',
  'di': '06',
  'xian': '11',
  'name': '福山区',
  'level': 3
}, {
  'code': '370612',
  'sheng': '37',
  'di': '06',
  'xian': '12',
  'name': '牟平区',
  'level': 3
}, {
  'code': '370613',
  'sheng': '37',
  'di': '06',
  'xian': '13',
  'name': '莱山区',
  'level': 3
}, {
  'code': '370634',
  'sheng': '37',
  'di': '06',
  'xian': '34',
  'name': '长岛县',
  'level': 3
}, {
  'code': '370681',
  'sheng': '37',
  'di': '06',
  'xian': '81',
  'name': '龙口市',
  'level': 3
}, {
  'code': '370682',
  'sheng': '37',
  'di': '06',
  'xian': '82',
  'name': '莱阳市',
  'level': 3
}, {
  'code': '370683',
  'sheng': '37',
  'di': '06',
  'xian': '83',
  'name': '莱州市',
  'level': 3
}, {
  'code': '370684',
  'sheng': '37',
  'di': '06',
  'xian': '84',
  'name': '蓬莱市',
  'level': 3
}, {
  'code': '370685',
  'sheng': '37',
  'di': '06',
  'xian': '85',
  'name': '招远市',
  'level': 3
}, {
  'code': '370686',
  'sheng': '37',
  'di': '06',
  'xian': '86',
  'name': '栖霞市',
  'level': 3
}, {
  'code': '370687',
  'sheng': '37',
  'di': '06',
  'xian': '87',
  'name': '海阳市',
  'level': 3
}, {
  'code': '370700',
  'sheng': '37',
  'di': '07',
  'xian': '00',
  'name': '潍坊市',
  'level': 2
}, {
  'code': '370701',
  'sheng': '37',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370702',
  'sheng': '37',
  'di': '07',
  'xian': '02',
  'name': '潍城区',
  'level': 3
}, {
  'code': '370703',
  'sheng': '37',
  'di': '07',
  'xian': '03',
  'name': '寒亭区',
  'level': 3
}, {
  'code': '370704',
  'sheng': '37',
  'di': '07',
  'xian': '04',
  'name': '坊子区',
  'level': 3
}, {
  'code': '370705',
  'sheng': '37',
  'di': '07',
  'xian': '05',
  'name': '奎文区',
  'level': 3
}, {
  'code': '370724',
  'sheng': '37',
  'di': '07',
  'xian': '24',
  'name': '临朐县',
  'level': 3
}, {
  'code': '370725',
  'sheng': '37',
  'di': '07',
  'xian': '25',
  'name': '昌乐县',
  'level': 3
}, {
  'code': '370781',
  'sheng': '37',
  'di': '07',
  'xian': '81',
  'name': '青州市',
  'level': 3
}, {
  'code': '370782',
  'sheng': '37',
  'di': '07',
  'xian': '82',
  'name': '诸城市',
  'level': 3
}, {
  'code': '370783',
  'sheng': '37',
  'di': '07',
  'xian': '83',
  'name': '寿光市',
  'level': 3
}, {
  'code': '370784',
  'sheng': '37',
  'di': '07',
  'xian': '84',
  'name': '安丘市',
  'level': 3
}, {
  'code': '370785',
  'sheng': '37',
  'di': '07',
  'xian': '85',
  'name': '高密市',
  'level': 3
}, {
  'code': '370786',
  'sheng': '37',
  'di': '07',
  'xian': '86',
  'name': '昌邑市',
  'level': 3
}, {
  'code': '370800',
  'sheng': '37',
  'di': '08',
  'xian': '00',
  'name': '济宁市',
  'level': 2
}, {
  'code': '370801',
  'sheng': '37',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370811',
  'sheng': '37',
  'di': '08',
  'xian': '11',
  'name': '任城区',
  'level': 3
}, {
  'code': '370812',
  'sheng': '37',
  'di': '08',
  'xian': '12',
  'name': '兖州区',
  'level': 3
}, {
  'code': '370826',
  'sheng': '37',
  'di': '08',
  'xian': '26',
  'name': '微山县',
  'level': 3
}, {
  'code': '370827',
  'sheng': '37',
  'di': '08',
  'xian': '27',
  'name': '鱼台县',
  'level': 3
}, {
  'code': '370828',
  'sheng': '37',
  'di': '08',
  'xian': '28',
  'name': '金乡县',
  'level': 3
}, {
  'code': '370829',
  'sheng': '37',
  'di': '08',
  'xian': '29',
  'name': '嘉祥县',
  'level': 3
}, {
  'code': '370830',
  'sheng': '37',
  'di': '08',
  'xian': '30',
  'name': '汶上县',
  'level': 3
}, {
  'code': '370831',
  'sheng': '37',
  'di': '08',
  'xian': '31',
  'name': '泗水县',
  'level': 3
}, {
  'code': '370832',
  'sheng': '37',
  'di': '08',
  'xian': '32',
  'name': '梁山县',
  'level': 3
}, {
  'code': '370881',
  'sheng': '37',
  'di': '08',
  'xian': '81',
  'name': '曲阜市',
  'level': 3
}, {
  'code': '370883',
  'sheng': '37',
  'di': '08',
  'xian': '83',
  'name': '邹城市',
  'level': 3
}, {
  'code': '370900',
  'sheng': '37',
  'di': '09',
  'xian': '00',
  'name': '泰安市',
  'level': 2
}, {
  'code': '370901',
  'sheng': '37',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '370902',
  'sheng': '37',
  'di': '09',
  'xian': '02',
  'name': '泰山区',
  'level': 3
}, {
  'code': '370911',
  'sheng': '37',
  'di': '09',
  'xian': '11',
  'name': '岱岳区',
  'level': 3
}, {
  'code': '370921',
  'sheng': '37',
  'di': '09',
  'xian': '21',
  'name': '宁阳县',
  'level': 3
}, {
  'code': '370923',
  'sheng': '37',
  'di': '09',
  'xian': '23',
  'name': '东平县',
  'level': 3
}, {
  'code': '370982',
  'sheng': '37',
  'di': '09',
  'xian': '82',
  'name': '新泰市',
  'level': 3
}, {
  'code': '370983',
  'sheng': '37',
  'di': '09',
  'xian': '83',
  'name': '肥城市',
  'level': 3
}, {
  'code': '371000',
  'sheng': '37',
  'di': '10',
  'xian': '00',
  'name': '威海市',
  'level': 2
}, {
  'code': '371001',
  'sheng': '37',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371002',
  'sheng': '37',
  'di': '10',
  'xian': '02',
  'name': '环翠区',
  'level': 3
}, {
  'code': '371003',
  'sheng': '37',
  'di': '10',
  'xian': '03',
  'name': '文登区',
  'level': 3
}, {
  'code': '371082',
  'sheng': '37',
  'di': '10',
  'xian': '82',
  'name': '荣成市',
  'level': 3
}, {
  'code': '371083',
  'sheng': '37',
  'di': '10',
  'xian': '83',
  'name': '乳山市',
  'level': 3
}, {
  'code': '371100',
  'sheng': '37',
  'di': '11',
  'xian': '00',
  'name': '日照市',
  'level': 2
}, {
  'code': '371101',
  'sheng': '37',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371102',
  'sheng': '37',
  'di': '11',
  'xian': '02',
  'name': '东港区',
  'level': 3
}, {
  'code': '371103',
  'sheng': '37',
  'di': '11',
  'xian': '03',
  'name': '岚山区',
  'level': 3
}, {
  'code': '371121',
  'sheng': '37',
  'di': '11',
  'xian': '21',
  'name': '五莲县',
  'level': 3
}, {
  'code': '371122',
  'sheng': '37',
  'di': '11',
  'xian': '22',
  'name': '莒县',
  'level': 3
}, {
  'code': '371200',
  'sheng': '37',
  'di': '12',
  'xian': '00',
  'name': '莱芜市',
  'level': 2
}, {
  'code': '371201',
  'sheng': '37',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371202',
  'sheng': '37',
  'di': '12',
  'xian': '02',
  'name': '莱城区',
  'level': 3
}, {
  'code': '371203',
  'sheng': '37',
  'di': '12',
  'xian': '03',
  'name': '钢城区',
  'level': 3
}, {
  'code': '371300',
  'sheng': '37',
  'di': '13',
  'xian': '00',
  'name': '临沂市',
  'level': 2
}, {
  'code': '371301',
  'sheng': '37',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371302',
  'sheng': '37',
  'di': '13',
  'xian': '02',
  'name': '兰山区',
  'level': 3
}, {
  'code': '371311',
  'sheng': '37',
  'di': '13',
  'xian': '11',
  'name': '罗庄区',
  'level': 3
}, {
  'code': '371312',
  'sheng': '37',
  'di': '13',
  'xian': '12',
  'name': '河东区',
  'level': 3
}, {
  'code': '371321',
  'sheng': '37',
  'di': '13',
  'xian': '21',
  'name': '沂南县',
  'level': 3
}, {
  'code': '371322',
  'sheng': '37',
  'di': '13',
  'xian': '22',
  'name': '郯城县',
  'level': 3
}, {
  'code': '371323',
  'sheng': '37',
  'di': '13',
  'xian': '23',
  'name': '沂水县',
  'level': 3
}, {
  'code': '371324',
  'sheng': '37',
  'di': '13',
  'xian': '24',
  'name': '兰陵县',
  'level': 3
}, {
  'code': '371325',
  'sheng': '37',
  'di': '13',
  'xian': '25',
  'name': '费县',
  'level': 3
}, {
  'code': '371326',
  'sheng': '37',
  'di': '13',
  'xian': '26',
  'name': '平邑县',
  'level': 3
}, {
  'code': '371327',
  'sheng': '37',
  'di': '13',
  'xian': '27',
  'name': '莒南县',
  'level': 3
}, {
  'code': '371328',
  'sheng': '37',
  'di': '13',
  'xian': '28',
  'name': '蒙阴县',
  'level': 3
}, {
  'code': '371329',
  'sheng': '37',
  'di': '13',
  'xian': '29',
  'name': '临沭县',
  'level': 3
}, {
  'code': '371400',
  'sheng': '37',
  'di': '14',
  'xian': '00',
  'name': '德州市',
  'level': 2
}, {
  'code': '371401',
  'sheng': '37',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371402',
  'sheng': '37',
  'di': '14',
  'xian': '02',
  'name': '德城区',
  'level': 3
}, {
  'code': '371403',
  'sheng': '37',
  'di': '14',
  'xian': '03',
  'name': '陵城区',
  'level': 3
}, {
  'code': '371422',
  'sheng': '37',
  'di': '14',
  'xian': '22',
  'name': '宁津县',
  'level': 3
}, {
  'code': '371423',
  'sheng': '37',
  'di': '14',
  'xian': '23',
  'name': '庆云县',
  'level': 3
}, {
  'code': '371424',
  'sheng': '37',
  'di': '14',
  'xian': '24',
  'name': '临邑县',
  'level': 3
}, {
  'code': '371425',
  'sheng': '37',
  'di': '14',
  'xian': '25',
  'name': '齐河县',
  'level': 3
}, {
  'code': '371426',
  'sheng': '37',
  'di': '14',
  'xian': '26',
  'name': '平原县',
  'level': 3
}, {
  'code': '371427',
  'sheng': '37',
  'di': '14',
  'xian': '27',
  'name': '夏津县',
  'level': 3
}, {
  'code': '371428',
  'sheng': '37',
  'di': '14',
  'xian': '28',
  'name': '武城县',
  'level': 3
}, {
  'code': '371481',
  'sheng': '37',
  'di': '14',
  'xian': '81',
  'name': '乐陵市',
  'level': 3
}, {
  'code': '371482',
  'sheng': '37',
  'di': '14',
  'xian': '82',
  'name': '禹城市',
  'level': 3
}, {
  'code': '371500',
  'sheng': '37',
  'di': '15',
  'xian': '00',
  'name': '聊城市',
  'level': 2
}, {
  'code': '371501',
  'sheng': '37',
  'di': '15',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371502',
  'sheng': '37',
  'di': '15',
  'xian': '02',
  'name': '东昌府区',
  'level': 3
}, {
  'code': '371521',
  'sheng': '37',
  'di': '15',
  'xian': '21',
  'name': '阳谷县',
  'level': 3
}, {
  'code': '371522',
  'sheng': '37',
  'di': '15',
  'xian': '22',
  'name': '莘县',
  'level': 3
}, {
  'code': '371523',
  'sheng': '37',
  'di': '15',
  'xian': '23',
  'name': '茌平县',
  'level': 3
}, {
  'code': '371524',
  'sheng': '37',
  'di': '15',
  'xian': '24',
  'name': '东阿县',
  'level': 3
}, {
  'code': '371525',
  'sheng': '37',
  'di': '15',
  'xian': '25',
  'name': '冠县',
  'level': 3
}, {
  'code': '371526',
  'sheng': '37',
  'di': '15',
  'xian': '26',
  'name': '高唐县',
  'level': 3
}, {
  'code': '371581',
  'sheng': '37',
  'di': '15',
  'xian': '81',
  'name': '临清市',
  'level': 3
}, {
  'code': '371600',
  'sheng': '37',
  'di': '16',
  'xian': '00',
  'name': '滨州市',
  'level': 2
}, {
  'code': '371601',
  'sheng': '37',
  'di': '16',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371602',
  'sheng': '37',
  'di': '16',
  'xian': '02',
  'name': '滨城区',
  'level': 3
}, {
  'code': '371603',
  'sheng': '37',
  'di': '16',
  'xian': '03',
  'name': '沾化区',
  'level': 3
}, {
  'code': '371621',
  'sheng': '37',
  'di': '16',
  'xian': '21',
  'name': '惠民县',
  'level': 3
}, {
  'code': '371622',
  'sheng': '37',
  'di': '16',
  'xian': '22',
  'name': '阳信县',
  'level': 3
}, {
  'code': '371623',
  'sheng': '37',
  'di': '16',
  'xian': '23',
  'name': '无棣县',
  'level': 3
}, {
  'code': '371625',
  'sheng': '37',
  'di': '16',
  'xian': '25',
  'name': '博兴县',
  'level': 3
}, {
  'code': '371626',
  'sheng': '37',
  'di': '16',
  'xian': '26',
  'name': '邹平县',
  'level': 3
}, {
  'code': '371700',
  'sheng': '37',
  'di': '17',
  'xian': '00',
  'name': '菏泽市',
  'level': 2
}, {
  'code': '371701',
  'sheng': '37',
  'di': '17',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '371702',
  'sheng': '37',
  'di': '17',
  'xian': '02',
  'name': '牡丹区',
  'level': 3
}, {
  'code': '371721',
  'sheng': '37',
  'di': '17',
  'xian': '21',
  'name': '曹县',
  'level': 3
}, {
  'code': '371722',
  'sheng': '37',
  'di': '17',
  'xian': '22',
  'name': '单县',
  'level': 3
}, {
  'code': '371723',
  'sheng': '37',
  'di': '17',
  'xian': '23',
  'name': '成武县',
  'level': 3
}, {
  'code': '371724',
  'sheng': '37',
  'di': '17',
  'xian': '24',
  'name': '巨野县',
  'level': 3
}, {
  'code': '371725',
  'sheng': '37',
  'di': '17',
  'xian': '25',
  'name': '郓城县',
  'level': 3
}, {
  'code': '371726',
  'sheng': '37',
  'di': '17',
  'xian': '26',
  'name': '鄄城县',
  'level': 3
}, {
  'code': '371727',
  'sheng': '37',
  'di': '17',
  'xian': '27',
  'name': '定陶县',
  'level': 3
}, {
  'code': '371728',
  'sheng': '37',
  'di': '17',
  'xian': '28',
  'name': '东明县',
  'level': 3
}, {
  'code': '410000',
  'sheng': '41',
  'di': '00',
  'xian': '00',
  'name': '河南省',
  'level': 1
}, {
  'code': '410100',
  'sheng': '41',
  'di': '01',
  'xian': '00',
  'name': '郑州市',
  'level': 2
}, {
  'code': '410101',
  'sheng': '41',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410102',
  'sheng': '41',
  'di': '01',
  'xian': '02',
  'name': '中原区',
  'level': 3
}, {
  'code': '410103',
  'sheng': '41',
  'di': '01',
  'xian': '03',
  'name': '二七区',
  'level': 3
}, {
  'code': '410104',
  'sheng': '41',
  'di': '01',
  'xian': '04',
  'name': '管城回族区',
  'level': 3
}, {
  'code': '410105',
  'sheng': '41',
  'di': '01',
  'xian': '05',
  'name': '金水区',
  'level': 3
}, {
  'code': '410106',
  'sheng': '41',
  'di': '01',
  'xian': '06',
  'name': '上街区',
  'level': 3
}, {
  'code': '410108',
  'sheng': '41',
  'di': '01',
  'xian': '08',
  'name': '惠济区',
  'level': 3
}, {
  'code': '410122',
  'sheng': '41',
  'di': '01',
  'xian': '22',
  'name': '中牟县',
  'level': 3
}, {
  'code': '410181',
  'sheng': '41',
  'di': '01',
  'xian': '81',
  'name': '巩义市',
  'level': 3
}, {
  'code': '410182',
  'sheng': '41',
  'di': '01',
  'xian': '82',
  'name': '荥阳市',
  'level': 3
}, {
  'code': '410183',
  'sheng': '41',
  'di': '01',
  'xian': '83',
  'name': '新密市',
  'level': 3
}, {
  'code': '410184',
  'sheng': '41',
  'di': '01',
  'xian': '84',
  'name': '新郑市',
  'level': 3
}, {
  'code': '410185',
  'sheng': '41',
  'di': '01',
  'xian': '85',
  'name': '登封市',
  'level': 3
}, {
  'code': '410200',
  'sheng': '41',
  'di': '02',
  'xian': '00',
  'name': '开封市',
  'level': 2
}, {
  'code': '410201',
  'sheng': '41',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410202',
  'sheng': '41',
  'di': '02',
  'xian': '02',
  'name': '龙亭区',
  'level': 3
}, {
  'code': '410203',
  'sheng': '41',
  'di': '02',
  'xian': '03',
  'name': '顺河回族区',
  'level': 3
}, {
  'code': '410204',
  'sheng': '41',
  'di': '02',
  'xian': '04',
  'name': '鼓楼区',
  'level': 3
}, {
  'code': '410205',
  'sheng': '41',
  'di': '02',
  'xian': '05',
  'name': '禹王台区',
  'level': 3
}, {
  'code': '410211',
  'sheng': '41',
  'di': '02',
  'xian': '11',
  'name': '金明区',
  'level': 3
}, {
  'code': '410221',
  'sheng': '41',
  'di': '02',
  'xian': '21',
  'name': '杞县',
  'level': 3
}, {
  'code': '410222',
  'sheng': '41',
  'di': '02',
  'xian': '22',
  'name': '通许县',
  'level': 3
}, {
  'code': '410223',
  'sheng': '41',
  'di': '02',
  'xian': '23',
  'name': '尉氏县',
  'level': 3
}, {
  'code': '410224',
  'sheng': '41',
  'di': '02',
  'xian': '24',
  'name': '开封县',
  'level': 3
}, {
  'code': '410225',
  'sheng': '41',
  'di': '02',
  'xian': '25',
  'name': '兰考县',
  'level': 3
}, {
  'code': '410300',
  'sheng': '41',
  'di': '03',
  'xian': '00',
  'name': '洛阳市',
  'level': 2
}, {
  'code': '410301',
  'sheng': '41',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410302',
  'sheng': '41',
  'di': '03',
  'xian': '02',
  'name': '老城区',
  'level': 3
}, {
  'code': '410303',
  'sheng': '41',
  'di': '03',
  'xian': '03',
  'name': '西工区',
  'level': 3
}, {
  'code': '410304',
  'sheng': '41',
  'di': '03',
  'xian': '04',
  'name': '瀍河回族区',
  'level': 3
}, {
  'code': '410305',
  'sheng': '41',
  'di': '03',
  'xian': '05',
  'name': '涧西区',
  'level': 3
}, {
  'code': '410306',
  'sheng': '41',
  'di': '03',
  'xian': '06',
  'name': '吉利区',
  'level': 3
}, {
  'code': '410311',
  'sheng': '41',
  'di': '03',
  'xian': '11',
  'name': '洛龙区',
  'level': 3
}, {
  'code': '410322',
  'sheng': '41',
  'di': '03',
  'xian': '22',
  'name': '孟津县',
  'level': 3
}, {
  'code': '410323',
  'sheng': '41',
  'di': '03',
  'xian': '23',
  'name': '新安县',
  'level': 3
}, {
  'code': '410324',
  'sheng': '41',
  'di': '03',
  'xian': '24',
  'name': '栾川县',
  'level': 3
}, {
  'code': '410325',
  'sheng': '41',
  'di': '03',
  'xian': '25',
  'name': '嵩县',
  'level': 3
}, {
  'code': '410326',
  'sheng': '41',
  'di': '03',
  'xian': '26',
  'name': '汝阳县',
  'level': 3
}, {
  'code': '410327',
  'sheng': '41',
  'di': '03',
  'xian': '27',
  'name': '宜阳县',
  'level': 3
}, {
  'code': '410328',
  'sheng': '41',
  'di': '03',
  'xian': '28',
  'name': '洛宁县',
  'level': 3
}, {
  'code': '410329',
  'sheng': '41',
  'di': '03',
  'xian': '29',
  'name': '伊川县',
  'level': 3
}, {
  'code': '410381',
  'sheng': '41',
  'di': '03',
  'xian': '81',
  'name': '偃师市',
  'level': 3
}, {
  'code': '410400',
  'sheng': '41',
  'di': '04',
  'xian': '00',
  'name': '平顶山市',
  'level': 2
}, {
  'code': '410401',
  'sheng': '41',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410402',
  'sheng': '41',
  'di': '04',
  'xian': '02',
  'name': '新华区',
  'level': 3
}, {
  'code': '410403',
  'sheng': '41',
  'di': '04',
  'xian': '03',
  'name': '卫东区',
  'level': 3
}, {
  'code': '410404',
  'sheng': '41',
  'di': '04',
  'xian': '04',
  'name': '石龙区',
  'level': 3
}, {
  'code': '410411',
  'sheng': '41',
  'di': '04',
  'xian': '11',
  'name': '湛河区',
  'level': 3
}, {
  'code': '410421',
  'sheng': '41',
  'di': '04',
  'xian': '21',
  'name': '宝丰县',
  'level': 3
}, {
  'code': '410422',
  'sheng': '41',
  'di': '04',
  'xian': '22',
  'name': '叶县',
  'level': 3
}, {
  'code': '410423',
  'sheng': '41',
  'di': '04',
  'xian': '23',
  'name': '鲁山县',
  'level': 3
}, {
  'code': '410425',
  'sheng': '41',
  'di': '04',
  'xian': '25',
  'name': '郏县',
  'level': 3
}, {
  'code': '410481',
  'sheng': '41',
  'di': '04',
  'xian': '81',
  'name': '舞钢市',
  'level': 3
}, {
  'code': '410482',
  'sheng': '41',
  'di': '04',
  'xian': '82',
  'name': '汝州市',
  'level': 3
}, {
  'code': '410500',
  'sheng': '41',
  'di': '05',
  'xian': '00',
  'name': '安阳市',
  'level': 2
}, {
  'code': '410501',
  'sheng': '41',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410502',
  'sheng': '41',
  'di': '05',
  'xian': '02',
  'name': '文峰区',
  'level': 3
}, {
  'code': '410503',
  'sheng': '41',
  'di': '05',
  'xian': '03',
  'name': '北关区',
  'level': 3
}, {
  'code': '410505',
  'sheng': '41',
  'di': '05',
  'xian': '05',
  'name': '殷都区',
  'level': 3
}, {
  'code': '410506',
  'sheng': '41',
  'di': '05',
  'xian': '06',
  'name': '龙安区',
  'level': 3
}, {
  'code': '410522',
  'sheng': '41',
  'di': '05',
  'xian': '22',
  'name': '安阳县',
  'level': 3
}, {
  'code': '410523',
  'sheng': '41',
  'di': '05',
  'xian': '23',
  'name': '汤阴县',
  'level': 3
}, {
  'code': '410526',
  'sheng': '41',
  'di': '05',
  'xian': '26',
  'name': '滑县',
  'level': 3
}, {
  'code': '410527',
  'sheng': '41',
  'di': '05',
  'xian': '27',
  'name': '内黄县',
  'level': 3
}, {
  'code': '410581',
  'sheng': '41',
  'di': '05',
  'xian': '81',
  'name': '林州市',
  'level': 3
}, {
  'code': '410600',
  'sheng': '41',
  'di': '06',
  'xian': '00',
  'name': '鹤壁市',
  'level': 2
}, {
  'code': '410601',
  'sheng': '41',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410602',
  'sheng': '41',
  'di': '06',
  'xian': '02',
  'name': '鹤山区',
  'level': 3
}, {
  'code': '410603',
  'sheng': '41',
  'di': '06',
  'xian': '03',
  'name': '山城区',
  'level': 3
}, {
  'code': '410611',
  'sheng': '41',
  'di': '06',
  'xian': '11',
  'name': '淇滨区',
  'level': 3
}, {
  'code': '410621',
  'sheng': '41',
  'di': '06',
  'xian': '21',
  'name': '浚县',
  'level': 3
}, {
  'code': '410622',
  'sheng': '41',
  'di': '06',
  'xian': '22',
  'name': '淇县',
  'level': 3
}, {
  'code': '410700',
  'sheng': '41',
  'di': '07',
  'xian': '00',
  'name': '新乡市',
  'level': 2
}, {
  'code': '410701',
  'sheng': '41',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410702',
  'sheng': '41',
  'di': '07',
  'xian': '02',
  'name': '红旗区',
  'level': 3
}, {
  'code': '410703',
  'sheng': '41',
  'di': '07',
  'xian': '03',
  'name': '卫滨区',
  'level': 3
}, {
  'code': '410704',
  'sheng': '41',
  'di': '07',
  'xian': '04',
  'name': '凤泉区',
  'level': 3
}, {
  'code': '410711',
  'sheng': '41',
  'di': '07',
  'xian': '11',
  'name': '牧野区',
  'level': 3
}, {
  'code': '410721',
  'sheng': '41',
  'di': '07',
  'xian': '21',
  'name': '新乡县',
  'level': 3
}, {
  'code': '410724',
  'sheng': '41',
  'di': '07',
  'xian': '24',
  'name': '获嘉县',
  'level': 3
}, {
  'code': '410725',
  'sheng': '41',
  'di': '07',
  'xian': '25',
  'name': '原阳县',
  'level': 3
}, {
  'code': '410726',
  'sheng': '41',
  'di': '07',
  'xian': '26',
  'name': '延津县',
  'level': 3
}, {
  'code': '410727',
  'sheng': '41',
  'di': '07',
  'xian': '27',
  'name': '封丘县',
  'level': 3
}, {
  'code': '410728',
  'sheng': '41',
  'di': '07',
  'xian': '28',
  'name': '长垣县',
  'level': 3
}, {
  'code': '410781',
  'sheng': '41',
  'di': '07',
  'xian': '81',
  'name': '卫辉市',
  'level': 3
}, {
  'code': '410782',
  'sheng': '41',
  'di': '07',
  'xian': '82',
  'name': '辉县市',
  'level': 3
}, {
  'code': '410800',
  'sheng': '41',
  'di': '08',
  'xian': '00',
  'name': '焦作市',
  'level': 2
}, {
  'code': '410801',
  'sheng': '41',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410802',
  'sheng': '41',
  'di': '08',
  'xian': '02',
  'name': '解放区',
  'level': 3
}, {
  'code': '410803',
  'sheng': '41',
  'di': '08',
  'xian': '03',
  'name': '中站区',
  'level': 3
}, {
  'code': '410804',
  'sheng': '41',
  'di': '08',
  'xian': '04',
  'name': '马村区',
  'level': 3
}, {
  'code': '410811',
  'sheng': '41',
  'di': '08',
  'xian': '11',
  'name': '山阳区',
  'level': 3
}, {
  'code': '410821',
  'sheng': '41',
  'di': '08',
  'xian': '21',
  'name': '修武县',
  'level': 3
}, {
  'code': '410822',
  'sheng': '41',
  'di': '08',
  'xian': '22',
  'name': '博爱县',
  'level': 3
}, {
  'code': '410823',
  'sheng': '41',
  'di': '08',
  'xian': '23',
  'name': '武陟县',
  'level': 3
}, {
  'code': '410825',
  'sheng': '41',
  'di': '08',
  'xian': '25',
  'name': '温县',
  'level': 3
}, {
  'code': '410882',
  'sheng': '41',
  'di': '08',
  'xian': '82',
  'name': '沁阳市',
  'level': 3
}, {
  'code': '410883',
  'sheng': '41',
  'di': '08',
  'xian': '83',
  'name': '孟州市',
  'level': 3
}, {
  'code': '410900',
  'sheng': '41',
  'di': '09',
  'xian': '00',
  'name': '濮阳市',
  'level': 2
}, {
  'code': '410901',
  'sheng': '41',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '410902',
  'sheng': '41',
  'di': '09',
  'xian': '02',
  'name': '华龙区',
  'level': 3
}, {
  'code': '410922',
  'sheng': '41',
  'di': '09',
  'xian': '22',
  'name': '清丰县',
  'level': 3
}, {
  'code': '410923',
  'sheng': '41',
  'di': '09',
  'xian': '23',
  'name': '南乐县',
  'level': 3
}, {
  'code': '410926',
  'sheng': '41',
  'di': '09',
  'xian': '26',
  'name': '范县',
  'level': 3
}, {
  'code': '410927',
  'sheng': '41',
  'di': '09',
  'xian': '27',
  'name': '台前县',
  'level': 3
}, {
  'code': '410928',
  'sheng': '41',
  'di': '09',
  'xian': '28',
  'name': '濮阳县',
  'level': 3
}, {
  'code': '411000',
  'sheng': '41',
  'di': '10',
  'xian': '00',
  'name': '许昌市',
  'level': 2
}, {
  'code': '411001',
  'sheng': '41',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411002',
  'sheng': '41',
  'di': '10',
  'xian': '02',
  'name': '魏都区',
  'level': 3
}, {
  'code': '411023',
  'sheng': '41',
  'di': '10',
  'xian': '23',
  'name': '许昌县',
  'level': 3
}, {
  'code': '411024',
  'sheng': '41',
  'di': '10',
  'xian': '24',
  'name': '鄢陵县',
  'level': 3
}, {
  'code': '411025',
  'sheng': '41',
  'di': '10',
  'xian': '25',
  'name': '襄城县',
  'level': 3
}, {
  'code': '411081',
  'sheng': '41',
  'di': '10',
  'xian': '81',
  'name': '禹州市',
  'level': 3
}, {
  'code': '411082',
  'sheng': '41',
  'di': '10',
  'xian': '82',
  'name': '长葛市',
  'level': 3
}, {
  'code': '411100',
  'sheng': '41',
  'di': '11',
  'xian': '00',
  'name': '漯河市',
  'level': 2
}, {
  'code': '411101',
  'sheng': '41',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411102',
  'sheng': '41',
  'di': '11',
  'xian': '02',
  'name': '源汇区',
  'level': 3
}, {
  'code': '411103',
  'sheng': '41',
  'di': '11',
  'xian': '03',
  'name': '郾城区',
  'level': 3
}, {
  'code': '411104',
  'sheng': '41',
  'di': '11',
  'xian': '04',
  'name': '召陵区',
  'level': 3
}, {
  'code': '411121',
  'sheng': '41',
  'di': '11',
  'xian': '21',
  'name': '舞阳县',
  'level': 3
}, {
  'code': '411122',
  'sheng': '41',
  'di': '11',
  'xian': '22',
  'name': '临颍县',
  'level': 3
}, {
  'code': '411200',
  'sheng': '41',
  'di': '12',
  'xian': '00',
  'name': '三门峡市',
  'level': 2
}, {
  'code': '411201',
  'sheng': '41',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411202',
  'sheng': '41',
  'di': '12',
  'xian': '02',
  'name': '湖滨区',
  'level': 3
}, {
  'code': '411221',
  'sheng': '41',
  'di': '12',
  'xian': '21',
  'name': '渑池县',
  'level': 3
}, {
  'code': '411222',
  'sheng': '41',
  'di': '12',
  'xian': '22',
  'name': '陕县',
  'level': 3
}, {
  'code': '411224',
  'sheng': '41',
  'di': '12',
  'xian': '24',
  'name': '卢氏县',
  'level': 3
}, {
  'code': '411281',
  'sheng': '41',
  'di': '12',
  'xian': '81',
  'name': '义马市',
  'level': 3
}, {
  'code': '411282',
  'sheng': '41',
  'di': '12',
  'xian': '82',
  'name': '灵宝市',
  'level': 3
}, {
  'code': '411300',
  'sheng': '41',
  'di': '13',
  'xian': '00',
  'name': '南阳市',
  'level': 2
}, {
  'code': '411301',
  'sheng': '41',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411302',
  'sheng': '41',
  'di': '13',
  'xian': '02',
  'name': '宛城区',
  'level': 3
}, {
  'code': '411303',
  'sheng': '41',
  'di': '13',
  'xian': '03',
  'name': '卧龙区',
  'level': 3
}, {
  'code': '411321',
  'sheng': '41',
  'di': '13',
  'xian': '21',
  'name': '南召县',
  'level': 3
}, {
  'code': '411322',
  'sheng': '41',
  'di': '13',
  'xian': '22',
  'name': '方城县',
  'level': 3
}, {
  'code': '411323',
  'sheng': '41',
  'di': '13',
  'xian': '23',
  'name': '西峡县',
  'level': 3
}, {
  'code': '411324',
  'sheng': '41',
  'di': '13',
  'xian': '24',
  'name': '镇平县',
  'level': 3
}, {
  'code': '411325',
  'sheng': '41',
  'di': '13',
  'xian': '25',
  'name': '内乡县',
  'level': 3
}, {
  'code': '411326',
  'sheng': '41',
  'di': '13',
  'xian': '26',
  'name': '淅川县',
  'level': 3
}, {
  'code': '411327',
  'sheng': '41',
  'di': '13',
  'xian': '27',
  'name': '社旗县',
  'level': 3
}, {
  'code': '411328',
  'sheng': '41',
  'di': '13',
  'xian': '28',
  'name': '唐河县',
  'level': 3
}, {
  'code': '411329',
  'sheng': '41',
  'di': '13',
  'xian': '29',
  'name': '新野县',
  'level': 3
}, {
  'code': '411330',
  'sheng': '41',
  'di': '13',
  'xian': '30',
  'name': '桐柏县',
  'level': 3
}, {
  'code': '411381',
  'sheng': '41',
  'di': '13',
  'xian': '81',
  'name': '邓州市',
  'level': 3
}, {
  'code': '411400',
  'sheng': '41',
  'di': '14',
  'xian': '00',
  'name': '商丘市',
  'level': 2
}, {
  'code': '411401',
  'sheng': '41',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411402',
  'sheng': '41',
  'di': '14',
  'xian': '02',
  'name': '梁园区',
  'level': 3
}, {
  'code': '411403',
  'sheng': '41',
  'di': '14',
  'xian': '03',
  'name': '睢阳区',
  'level': 3
}, {
  'code': '411421',
  'sheng': '41',
  'di': '14',
  'xian': '21',
  'name': '民权县',
  'level': 3
}, {
  'code': '411422',
  'sheng': '41',
  'di': '14',
  'xian': '22',
  'name': '睢县',
  'level': 3
}, {
  'code': '411423',
  'sheng': '41',
  'di': '14',
  'xian': '23',
  'name': '宁陵县',
  'level': 3
}, {
  'code': '411424',
  'sheng': '41',
  'di': '14',
  'xian': '24',
  'name': '柘城县',
  'level': 3
}, {
  'code': '411425',
  'sheng': '41',
  'di': '14',
  'xian': '25',
  'name': '虞城县',
  'level': 3
}, {
  'code': '411426',
  'sheng': '41',
  'di': '14',
  'xian': '26',
  'name': '夏邑县',
  'level': 3
}, {
  'code': '411481',
  'sheng': '41',
  'di': '14',
  'xian': '81',
  'name': '永城市',
  'level': 3
}, {
  'code': '411500',
  'sheng': '41',
  'di': '15',
  'xian': '00',
  'name': '信阳市',
  'level': 2
}, {
  'code': '411501',
  'sheng': '41',
  'di': '15',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411502',
  'sheng': '41',
  'di': '15',
  'xian': '02',
  'name': '浉河区',
  'level': 3
}, {
  'code': '411503',
  'sheng': '41',
  'di': '15',
  'xian': '03',
  'name': '平桥区',
  'level': 3
}, {
  'code': '411521',
  'sheng': '41',
  'di': '15',
  'xian': '21',
  'name': '罗山县',
  'level': 3
}, {
  'code': '411522',
  'sheng': '41',
  'di': '15',
  'xian': '22',
  'name': '光山县',
  'level': 3
}, {
  'code': '411523',
  'sheng': '41',
  'di': '15',
  'xian': '23',
  'name': '新县',
  'level': 3
}, {
  'code': '411524',
  'sheng': '41',
  'di': '15',
  'xian': '24',
  'name': '商城县',
  'level': 3
}, {
  'code': '411525',
  'sheng': '41',
  'di': '15',
  'xian': '25',
  'name': '固始县',
  'level': 3
}, {
  'code': '411526',
  'sheng': '41',
  'di': '15',
  'xian': '26',
  'name': '潢川县',
  'level': 3
}, {
  'code': '411527',
  'sheng': '41',
  'di': '15',
  'xian': '27',
  'name': '淮滨县',
  'level': 3
}, {
  'code': '411528',
  'sheng': '41',
  'di': '15',
  'xian': '28',
  'name': '息县',
  'level': 3
}, {
  'code': '411600',
  'sheng': '41',
  'di': '16',
  'xian': '00',
  'name': '周口市',
  'level': 2
}, {
  'code': '411601',
  'sheng': '41',
  'di': '16',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411602',
  'sheng': '41',
  'di': '16',
  'xian': '02',
  'name': '川汇区',
  'level': 3
}, {
  'code': '411621',
  'sheng': '41',
  'di': '16',
  'xian': '21',
  'name': '扶沟县',
  'level': 3
}, {
  'code': '411622',
  'sheng': '41',
  'di': '16',
  'xian': '22',
  'name': '西华县',
  'level': 3
}, {
  'code': '411623',
  'sheng': '41',
  'di': '16',
  'xian': '23',
  'name': '商水县',
  'level': 3
}, {
  'code': '411624',
  'sheng': '41',
  'di': '16',
  'xian': '24',
  'name': '沈丘县',
  'level': 3
}, {
  'code': '411625',
  'sheng': '41',
  'di': '16',
  'xian': '25',
  'name': '郸城县',
  'level': 3
}, {
  'code': '411626',
  'sheng': '41',
  'di': '16',
  'xian': '26',
  'name': '淮阳县',
  'level': 3
}, {
  'code': '411627',
  'sheng': '41',
  'di': '16',
  'xian': '27',
  'name': '太康县',
  'level': 3
}, {
  'code': '411628',
  'sheng': '41',
  'di': '16',
  'xian': '28',
  'name': '鹿邑县',
  'level': 3
}, {
  'code': '411681',
  'sheng': '41',
  'di': '16',
  'xian': '81',
  'name': '项城市',
  'level': 3
}, {
  'code': '411700',
  'sheng': '41',
  'di': '17',
  'xian': '00',
  'name': '驻马店市',
  'level': 2
}, {
  'code': '411701',
  'sheng': '41',
  'di': '17',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '411702',
  'sheng': '41',
  'di': '17',
  'xian': '02',
  'name': '驿城区',
  'level': 3
}, {
  'code': '411721',
  'sheng': '41',
  'di': '17',
  'xian': '21',
  'name': '西平县',
  'level': 3
}, {
  'code': '411722',
  'sheng': '41',
  'di': '17',
  'xian': '22',
  'name': '上蔡县',
  'level': 3
}, {
  'code': '411723',
  'sheng': '41',
  'di': '17',
  'xian': '23',
  'name': '平舆县',
  'level': 3
}, {
  'code': '411724',
  'sheng': '41',
  'di': '17',
  'xian': '24',
  'name': '正阳县',
  'level': 3
}, {
  'code': '411725',
  'sheng': '41',
  'di': '17',
  'xian': '25',
  'name': '确山县',
  'level': 3
}, {
  'code': '411726',
  'sheng': '41',
  'di': '17',
  'xian': '26',
  'name': '泌阳县',
  'level': 3
}, {
  'code': '411727',
  'sheng': '41',
  'di': '17',
  'xian': '27',
  'name': '汝南县',
  'level': 3
}, {
  'code': '411728',
  'sheng': '41',
  'di': '17',
  'xian': '28',
  'name': '遂平县',
  'level': 3
}, {
  'code': '411729',
  'sheng': '41',
  'di': '17',
  'xian': '29',
  'name': '新蔡县',
  'level': 3
}, {
  'code': '419000',
  'sheng': '41',
  'di': '90',
  'xian': '00',
  'name': '省直辖县级行政区划',
  'level': 2
}, {
  'code': '419001',
  'sheng': '41',
  'di': '90',
  'xian': '01',
  'name': '济源市',
  'level': 3
}, {
  'code': '420000',
  'sheng': '42',
  'di': '00',
  'xian': '00',
  'name': '湖北省',
  'level': 1
}, {
  'code': '420100',
  'sheng': '42',
  'di': '01',
  'xian': '00',
  'name': '武汉市',
  'level': 2
}, {
  'code': '420101',
  'sheng': '42',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420102',
  'sheng': '42',
  'di': '01',
  'xian': '02',
  'name': '江岸区',
  'level': 3
}, {
  'code': '420103',
  'sheng': '42',
  'di': '01',
  'xian': '03',
  'name': '江汉区',
  'level': 3
}, {
  'code': '420104',
  'sheng': '42',
  'di': '01',
  'xian': '04',
  'name': '硚口区',
  'level': 3
}, {
  'code': '420105',
  'sheng': '42',
  'di': '01',
  'xian': '05',
  'name': '汉阳区',
  'level': 3
}, {
  'code': '420106',
  'sheng': '42',
  'di': '01',
  'xian': '06',
  'name': '武昌区',
  'level': 3
}, {
  'code': '420107',
  'sheng': '42',
  'di': '01',
  'xian': '07',
  'name': '青山区',
  'level': 3
}, {
  'code': '420111',
  'sheng': '42',
  'di': '01',
  'xian': '11',
  'name': '洪山区',
  'level': 3
}, {
  'code': '420112',
  'sheng': '42',
  'di': '01',
  'xian': '12',
  'name': '东西湖区',
  'level': 3
}, {
  'code': '420113',
  'sheng': '42',
  'di': '01',
  'xian': '13',
  'name': '汉南区',
  'level': 3
}, {
  'code': '420114',
  'sheng': '42',
  'di': '01',
  'xian': '14',
  'name': '蔡甸区',
  'level': 3
}, {
  'code': '420115',
  'sheng': '42',
  'di': '01',
  'xian': '15',
  'name': '江夏区',
  'level': 3
}, {
  'code': '420116',
  'sheng': '42',
  'di': '01',
  'xian': '16',
  'name': '黄陂区',
  'level': 3
}, {
  'code': '420117',
  'sheng': '42',
  'di': '01',
  'xian': '17',
  'name': '新洲区',
  'level': 3
}, {
  'code': '420200',
  'sheng': '42',
  'di': '02',
  'xian': '00',
  'name': '黄石市',
  'level': 2
}, {
  'code': '420201',
  'sheng': '42',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420202',
  'sheng': '42',
  'di': '02',
  'xian': '02',
  'name': '黄石港区',
  'level': 3
}, {
  'code': '420203',
  'sheng': '42',
  'di': '02',
  'xian': '03',
  'name': '西塞山区',
  'level': 3
}, {
  'code': '420204',
  'sheng': '42',
  'di': '02',
  'xian': '04',
  'name': '下陆区',
  'level': 3
}, {
  'code': '420205',
  'sheng': '42',
  'di': '02',
  'xian': '05',
  'name': '铁山区',
  'level': 3
}, {
  'code': '420222',
  'sheng': '42',
  'di': '02',
  'xian': '22',
  'name': '阳新县',
  'level': 3
}, {
  'code': '420281',
  'sheng': '42',
  'di': '02',
  'xian': '81',
  'name': '大冶市',
  'level': 3
}, {
  'code': '420300',
  'sheng': '42',
  'di': '03',
  'xian': '00',
  'name': '十堰市',
  'level': 2
}, {
  'code': '420301',
  'sheng': '42',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420302',
  'sheng': '42',
  'di': '03',
  'xian': '02',
  'name': '茅箭区',
  'level': 3
}, {
  'code': '420303',
  'sheng': '42',
  'di': '03',
  'xian': '03',
  'name': '张湾区',
  'level': 3
}, {
  'code': '420304',
  'sheng': '42',
  'di': '03',
  'xian': '04',
  'name': '郧阳区',
  'level': 3
}, {
  'code': '420322',
  'sheng': '42',
  'di': '03',
  'xian': '22',
  'name': '郧西县',
  'level': 3
}, {
  'code': '420323',
  'sheng': '42',
  'di': '03',
  'xian': '23',
  'name': '竹山县',
  'level': 3
}, {
  'code': '420324',
  'sheng': '42',
  'di': '03',
  'xian': '24',
  'name': '竹溪县',
  'level': 3
}, {
  'code': '420325',
  'sheng': '42',
  'di': '03',
  'xian': '25',
  'name': '房县',
  'level': 3
}, {
  'code': '420381',
  'sheng': '42',
  'di': '03',
  'xian': '81',
  'name': '丹江口市',
  'level': 3
}, {
  'code': '420500',
  'sheng': '42',
  'di': '05',
  'xian': '00',
  'name': '宜昌市',
  'level': 2
}, {
  'code': '420501',
  'sheng': '42',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420502',
  'sheng': '42',
  'di': '05',
  'xian': '02',
  'name': '西陵区',
  'level': 3
}, {
  'code': '420503',
  'sheng': '42',
  'di': '05',
  'xian': '03',
  'name': '伍家岗区',
  'level': 3
}, {
  'code': '420504',
  'sheng': '42',
  'di': '05',
  'xian': '04',
  'name': '点军区',
  'level': 3
}, {
  'code': '420505',
  'sheng': '42',
  'di': '05',
  'xian': '05',
  'name': '猇亭区',
  'level': 3
}, {
  'code': '420506',
  'sheng': '42',
  'di': '05',
  'xian': '06',
  'name': '夷陵区',
  'level': 3
}, {
  'code': '420525',
  'sheng': '42',
  'di': '05',
  'xian': '25',
  'name': '远安县',
  'level': 3
}, {
  'code': '420526',
  'sheng': '42',
  'di': '05',
  'xian': '26',
  'name': '兴山县',
  'level': 3
}, {
  'code': '420527',
  'sheng': '42',
  'di': '05',
  'xian': '27',
  'name': '秭归县',
  'level': 3
}, {
  'code': '420528',
  'sheng': '42',
  'di': '05',
  'xian': '28',
  'name': '长阳土家族自治县',
  'level': 3
}, {
  'code': '420529',
  'sheng': '42',
  'di': '05',
  'xian': '29',
  'name': '五峰土家族自治县',
  'level': 3
}, {
  'code': '420581',
  'sheng': '42',
  'di': '05',
  'xian': '81',
  'name': '宜都市',
  'level': 3
}, {
  'code': '420582',
  'sheng': '42',
  'di': '05',
  'xian': '82',
  'name': '当阳市',
  'level': 3
}, {
  'code': '420583',
  'sheng': '42',
  'di': '05',
  'xian': '83',
  'name': '枝江市',
  'level': 3
}, {
  'code': '420600',
  'sheng': '42',
  'di': '06',
  'xian': '00',
  'name': '襄阳市',
  'level': 2
}, {
  'code': '420601',
  'sheng': '42',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420602',
  'sheng': '42',
  'di': '06',
  'xian': '02',
  'name': '襄城区',
  'level': 3
}, {
  'code': '420606',
  'sheng': '42',
  'di': '06',
  'xian': '06',
  'name': '樊城区',
  'level': 3
}, {
  'code': '420607',
  'sheng': '42',
  'di': '06',
  'xian': '07',
  'name': '襄州区',
  'level': 3
}, {
  'code': '420624',
  'sheng': '42',
  'di': '06',
  'xian': '24',
  'name': '南漳县',
  'level': 3
}, {
  'code': '420625',
  'sheng': '42',
  'di': '06',
  'xian': '25',
  'name': '谷城县',
  'level': 3
}, {
  'code': '420626',
  'sheng': '42',
  'di': '06',
  'xian': '26',
  'name': '保康县',
  'level': 3
}, {
  'code': '420682',
  'sheng': '42',
  'di': '06',
  'xian': '82',
  'name': '老河口市',
  'level': 3
}, {
  'code': '420683',
  'sheng': '42',
  'di': '06',
  'xian': '83',
  'name': '枣阳市',
  'level': 3
}, {
  'code': '420684',
  'sheng': '42',
  'di': '06',
  'xian': '84',
  'name': '宜城市',
  'level': 3
}, {
  'code': '420700',
  'sheng': '42',
  'di': '07',
  'xian': '00',
  'name': '鄂州市',
  'level': 2
}, {
  'code': '420701',
  'sheng': '42',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420702',
  'sheng': '42',
  'di': '07',
  'xian': '02',
  'name': '梁子湖区',
  'level': 3
}, {
  'code': '420703',
  'sheng': '42',
  'di': '07',
  'xian': '03',
  'name': '华容区',
  'level': 3
}, {
  'code': '420704',
  'sheng': '42',
  'di': '07',
  'xian': '04',
  'name': '鄂城区',
  'level': 3
}, {
  'code': '420800',
  'sheng': '42',
  'di': '08',
  'xian': '00',
  'name': '荆门市',
  'level': 2
}, {
  'code': '420801',
  'sheng': '42',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420802',
  'sheng': '42',
  'di': '08',
  'xian': '02',
  'name': '东宝区',
  'level': 3
}, {
  'code': '420804',
  'sheng': '42',
  'di': '08',
  'xian': '04',
  'name': '掇刀区',
  'level': 3
}, {
  'code': '420821',
  'sheng': '42',
  'di': '08',
  'xian': '21',
  'name': '京山县',
  'level': 3
}, {
  'code': '420822',
  'sheng': '42',
  'di': '08',
  'xian': '22',
  'name': '沙洋县',
  'level': 3
}, {
  'code': '420881',
  'sheng': '42',
  'di': '08',
  'xian': '81',
  'name': '钟祥市',
  'level': 3
}, {
  'code': '420900',
  'sheng': '42',
  'di': '09',
  'xian': '00',
  'name': '孝感市',
  'level': 2
}, {
  'code': '420901',
  'sheng': '42',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '420902',
  'sheng': '42',
  'di': '09',
  'xian': '02',
  'name': '孝南区',
  'level': 3
}, {
  'code': '420921',
  'sheng': '42',
  'di': '09',
  'xian': '21',
  'name': '孝昌县',
  'level': 3
}, {
  'code': '420922',
  'sheng': '42',
  'di': '09',
  'xian': '22',
  'name': '大悟县',
  'level': 3
}, {
  'code': '420923',
  'sheng': '42',
  'di': '09',
  'xian': '23',
  'name': '云梦县',
  'level': 3
}, {
  'code': '420981',
  'sheng': '42',
  'di': '09',
  'xian': '81',
  'name': '应城市',
  'level': 3
}, {
  'code': '420982',
  'sheng': '42',
  'di': '09',
  'xian': '82',
  'name': '安陆市',
  'level': 3
}, {
  'code': '420984',
  'sheng': '42',
  'di': '09',
  'xian': '84',
  'name': '汉川市',
  'level': 3
}, {
  'code': '421000',
  'sheng': '42',
  'di': '10',
  'xian': '00',
  'name': '荆州市',
  'level': 2
}, {
  'code': '421001',
  'sheng': '42',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '421002',
  'sheng': '42',
  'di': '10',
  'xian': '02',
  'name': '沙市区',
  'level': 3
}, {
  'code': '421003',
  'sheng': '42',
  'di': '10',
  'xian': '03',
  'name': '荆州区',
  'level': 3
}, {
  'code': '421022',
  'sheng': '42',
  'di': '10',
  'xian': '22',
  'name': '公安县',
  'level': 3
}, {
  'code': '421023',
  'sheng': '42',
  'di': '10',
  'xian': '23',
  'name': '监利县',
  'level': 3
}, {
  'code': '421024',
  'sheng': '42',
  'di': '10',
  'xian': '24',
  'name': '江陵县',
  'level': 3
}, {
  'code': '421081',
  'sheng': '42',
  'di': '10',
  'xian': '81',
  'name': '石首市',
  'level': 3
}, {
  'code': '421083',
  'sheng': '42',
  'di': '10',
  'xian': '83',
  'name': '洪湖市',
  'level': 3
}, {
  'code': '421087',
  'sheng': '42',
  'di': '10',
  'xian': '87',
  'name': '松滋市',
  'level': 3
}, {
  'code': '421100',
  'sheng': '42',
  'di': '11',
  'xian': '00',
  'name': '黄冈市',
  'level': 2
}, {
  'code': '421101',
  'sheng': '42',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '421102',
  'sheng': '42',
  'di': '11',
  'xian': '02',
  'name': '黄州区',
  'level': 3
}, {
  'code': '421121',
  'sheng': '42',
  'di': '11',
  'xian': '21',
  'name': '团风县',
  'level': 3
}, {
  'code': '421122',
  'sheng': '42',
  'di': '11',
  'xian': '22',
  'name': '红安县',
  'level': 3
}, {
  'code': '421123',
  'sheng': '42',
  'di': '11',
  'xian': '23',
  'name': '罗田县',
  'level': 3
}, {
  'code': '421124',
  'sheng': '42',
  'di': '11',
  'xian': '24',
  'name': '英山县',
  'level': 3
}, {
  'code': '421125',
  'sheng': '42',
  'di': '11',
  'xian': '25',
  'name': '浠水县',
  'level': 3
}, {
  'code': '421126',
  'sheng': '42',
  'di': '11',
  'xian': '26',
  'name': '蕲春县',
  'level': 3
}, {
  'code': '421127',
  'sheng': '42',
  'di': '11',
  'xian': '27',
  'name': '黄梅县',
  'level': 3
}, {
  'code': '421181',
  'sheng': '42',
  'di': '11',
  'xian': '81',
  'name': '麻城市',
  'level': 3
}, {
  'code': '421182',
  'sheng': '42',
  'di': '11',
  'xian': '82',
  'name': '武穴市',
  'level': 3
}, {
  'code': '421200',
  'sheng': '42',
  'di': '12',
  'xian': '00',
  'name': '咸宁市',
  'level': 2
}, {
  'code': '421201',
  'sheng': '42',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '421202',
  'sheng': '42',
  'di': '12',
  'xian': '02',
  'name': '咸安区',
  'level': 3
}, {
  'code': '421221',
  'sheng': '42',
  'di': '12',
  'xian': '21',
  'name': '嘉鱼县',
  'level': 3
}, {
  'code': '421222',
  'sheng': '42',
  'di': '12',
  'xian': '22',
  'name': '通城县',
  'level': 3
}, {
  'code': '421223',
  'sheng': '42',
  'di': '12',
  'xian': '23',
  'name': '崇阳县',
  'level': 3
}, {
  'code': '421224',
  'sheng': '42',
  'di': '12',
  'xian': '24',
  'name': '通山县',
  'level': 3
}, {
  'code': '421281',
  'sheng': '42',
  'di': '12',
  'xian': '81',
  'name': '赤壁市',
  'level': 3
}, {
  'code': '421300',
  'sheng': '42',
  'di': '13',
  'xian': '00',
  'name': '随州市',
  'level': 2
}, {
  'code': '421301',
  'sheng': '42',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '421303',
  'sheng': '42',
  'di': '13',
  'xian': '03',
  'name': '曾都区',
  'level': 3
}, {
  'code': '421321',
  'sheng': '42',
  'di': '13',
  'xian': '21',
  'name': '随县',
  'level': 3
}, {
  'code': '421381',
  'sheng': '42',
  'di': '13',
  'xian': '81',
  'name': '广水市',
  'level': 3
}, {
  'code': '422800',
  'sheng': '42',
  'di': '28',
  'xian': '00',
  'name': '恩施土家族苗族自治州',
  'level': 2
}, {
  'code': '422801',
  'sheng': '42',
  'di': '28',
  'xian': '01',
  'name': '恩施市',
  'level': 3
}, {
  'code': '422802',
  'sheng': '42',
  'di': '28',
  'xian': '02',
  'name': '利川市',
  'level': 3
}, {
  'code': '422822',
  'sheng': '42',
  'di': '28',
  'xian': '22',
  'name': '建始县',
  'level': 3
}, {
  'code': '422823',
  'sheng': '42',
  'di': '28',
  'xian': '23',
  'name': '巴东县',
  'level': 3
}, {
  'code': '422825',
  'sheng': '42',
  'di': '28',
  'xian': '25',
  'name': '宣恩县',
  'level': 3
}, {
  'code': '422826',
  'sheng': '42',
  'di': '28',
  'xian': '26',
  'name': '咸丰县',
  'level': 3
}, {
  'code': '422827',
  'sheng': '42',
  'di': '28',
  'xian': '27',
  'name': '来凤县',
  'level': 3
}, {
  'code': '422828',
  'sheng': '42',
  'di': '28',
  'xian': '28',
  'name': '鹤峰县',
  'level': 3
}, {
  'code': '429000',
  'sheng': '42',
  'di': '90',
  'xian': '00',
  'name': '省直辖县级行政区划',
  'level': 2
}, {
  'code': '429004',
  'sheng': '42',
  'di': '90',
  'xian': '04',
  'name': '仙桃市',
  'level': 3
}, {
  'code': '429005',
  'sheng': '42',
  'di': '90',
  'xian': '05',
  'name': '潜江市',
  'level': 3
}, {
  'code': '429006',
  'sheng': '42',
  'di': '90',
  'xian': '06',
  'name': '天门市',
  'level': 3
}, {
  'code': '429021',
  'sheng': '42',
  'di': '90',
  'xian': '21',
  'name': '神农架林区',
  'level': 3
}, {
  'code': '430000',
  'sheng': '43',
  'di': '00',
  'xian': '00',
  'name': '湖南省',
  'level': 1
}, {
  'code': '430100',
  'sheng': '43',
  'di': '01',
  'xian': '00',
  'name': '长沙市',
  'level': 2
}, {
  'code': '430101',
  'sheng': '43',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430102',
  'sheng': '43',
  'di': '01',
  'xian': '02',
  'name': '芙蓉区',
  'level': 3
}, {
  'code': '430103',
  'sheng': '43',
  'di': '01',
  'xian': '03',
  'name': '天心区',
  'level': 3
}, {
  'code': '430104',
  'sheng': '43',
  'di': '01',
  'xian': '04',
  'name': '岳麓区',
  'level': 3
}, {
  'code': '430105',
  'sheng': '43',
  'di': '01',
  'xian': '05',
  'name': '开福区',
  'level': 3
}, {
  'code': '430111',
  'sheng': '43',
  'di': '01',
  'xian': '11',
  'name': '雨花区',
  'level': 3
}, {
  'code': '430112',
  'sheng': '43',
  'di': '01',
  'xian': '12',
  'name': '望城区',
  'level': 3
}, {
  'code': '430121',
  'sheng': '43',
  'di': '01',
  'xian': '21',
  'name': '长沙县',
  'level': 3
}, {
  'code': '430124',
  'sheng': '43',
  'di': '01',
  'xian': '24',
  'name': '宁乡县',
  'level': 3
}, {
  'code': '430181',
  'sheng': '43',
  'di': '01',
  'xian': '81',
  'name': '浏阳市',
  'level': 3
}, {
  'code': '430200',
  'sheng': '43',
  'di': '02',
  'xian': '00',
  'name': '株洲市',
  'level': 2
}, {
  'code': '430201',
  'sheng': '43',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430202',
  'sheng': '43',
  'di': '02',
  'xian': '02',
  'name': '荷塘区',
  'level': 3
}, {
  'code': '430203',
  'sheng': '43',
  'di': '02',
  'xian': '03',
  'name': '芦淞区',
  'level': 3
}, {
  'code': '430204',
  'sheng': '43',
  'di': '02',
  'xian': '04',
  'name': '石峰区',
  'level': 3
}, {
  'code': '430211',
  'sheng': '43',
  'di': '02',
  'xian': '11',
  'name': '天元区',
  'level': 3
}, {
  'code': '430221',
  'sheng': '43',
  'di': '02',
  'xian': '21',
  'name': '株洲县',
  'level': 3
}, {
  'code': '430223',
  'sheng': '43',
  'di': '02',
  'xian': '23',
  'name': '攸县',
  'level': 3
}, {
  'code': '430224',
  'sheng': '43',
  'di': '02',
  'xian': '24',
  'name': '茶陵县',
  'level': 3
}, {
  'code': '430225',
  'sheng': '43',
  'di': '02',
  'xian': '25',
  'name': '炎陵县',
  'level': 3
}, {
  'code': '430281',
  'sheng': '43',
  'di': '02',
  'xian': '81',
  'name': '醴陵市',
  'level': 3
}, {
  'code': '430300',
  'sheng': '43',
  'di': '03',
  'xian': '00',
  'name': '湘潭市',
  'level': 2
}, {
  'code': '430301',
  'sheng': '43',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430302',
  'sheng': '43',
  'di': '03',
  'xian': '02',
  'name': '雨湖区',
  'level': 3
}, {
  'code': '430304',
  'sheng': '43',
  'di': '03',
  'xian': '04',
  'name': '岳塘区',
  'level': 3
}, {
  'code': '430321',
  'sheng': '43',
  'di': '03',
  'xian': '21',
  'name': '湘潭县',
  'level': 3
}, {
  'code': '430381',
  'sheng': '43',
  'di': '03',
  'xian': '81',
  'name': '湘乡市',
  'level': 3
}, {
  'code': '430382',
  'sheng': '43',
  'di': '03',
  'xian': '82',
  'name': '韶山市',
  'level': 3
}, {
  'code': '430400',
  'sheng': '43',
  'di': '04',
  'xian': '00',
  'name': '衡阳市',
  'level': 2
}, {
  'code': '430401',
  'sheng': '43',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430405',
  'sheng': '43',
  'di': '04',
  'xian': '05',
  'name': '珠晖区',
  'level': 3
}, {
  'code': '430406',
  'sheng': '43',
  'di': '04',
  'xian': '06',
  'name': '雁峰区',
  'level': 3
}, {
  'code': '430407',
  'sheng': '43',
  'di': '04',
  'xian': '07',
  'name': '石鼓区',
  'level': 3
}, {
  'code': '430408',
  'sheng': '43',
  'di': '04',
  'xian': '08',
  'name': '蒸湘区',
  'level': 3
}, {
  'code': '430412',
  'sheng': '43',
  'di': '04',
  'xian': '12',
  'name': '南岳区',
  'level': 3
}, {
  'code': '430421',
  'sheng': '43',
  'di': '04',
  'xian': '21',
  'name': '衡阳县',
  'level': 3
}, {
  'code': '430422',
  'sheng': '43',
  'di': '04',
  'xian': '22',
  'name': '衡南县',
  'level': 3
}, {
  'code': '430423',
  'sheng': '43',
  'di': '04',
  'xian': '23',
  'name': '衡山县',
  'level': 3
}, {
  'code': '430424',
  'sheng': '43',
  'di': '04',
  'xian': '24',
  'name': '衡东县',
  'level': 3
}, {
  'code': '430426',
  'sheng': '43',
  'di': '04',
  'xian': '26',
  'name': '祁东县',
  'level': 3
}, {
  'code': '430481',
  'sheng': '43',
  'di': '04',
  'xian': '81',
  'name': '耒阳市',
  'level': 3
}, {
  'code': '430482',
  'sheng': '43',
  'di': '04',
  'xian': '82',
  'name': '常宁市',
  'level': 3
}, {
  'code': '430500',
  'sheng': '43',
  'di': '05',
  'xian': '00',
  'name': '邵阳市',
  'level': 2
}, {
  'code': '430501',
  'sheng': '43',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430502',
  'sheng': '43',
  'di': '05',
  'xian': '02',
  'name': '双清区',
  'level': 3
}, {
  'code': '430503',
  'sheng': '43',
  'di': '05',
  'xian': '03',
  'name': '大祥区',
  'level': 3
}, {
  'code': '430511',
  'sheng': '43',
  'di': '05',
  'xian': '11',
  'name': '北塔区',
  'level': 3
}, {
  'code': '430521',
  'sheng': '43',
  'di': '05',
  'xian': '21',
  'name': '邵东县',
  'level': 3
}, {
  'code': '430522',
  'sheng': '43',
  'di': '05',
  'xian': '22',
  'name': '新邵县',
  'level': 3
}, {
  'code': '430523',
  'sheng': '43',
  'di': '05',
  'xian': '23',
  'name': '邵阳县',
  'level': 3
}, {
  'code': '430524',
  'sheng': '43',
  'di': '05',
  'xian': '24',
  'name': '隆回县',
  'level': 3
}, {
  'code': '430525',
  'sheng': '43',
  'di': '05',
  'xian': '25',
  'name': '洞口县',
  'level': 3
}, {
  'code': '430527',
  'sheng': '43',
  'di': '05',
  'xian': '27',
  'name': '绥宁县',
  'level': 3
}, {
  'code': '430528',
  'sheng': '43',
  'di': '05',
  'xian': '28',
  'name': '新宁县',
  'level': 3
}, {
  'code': '430529',
  'sheng': '43',
  'di': '05',
  'xian': '29',
  'name': '城步苗族自治县',
  'level': 3
}, {
  'code': '430581',
  'sheng': '43',
  'di': '05',
  'xian': '81',
  'name': '武冈市',
  'level': 3
}, {
  'code': '430600',
  'sheng': '43',
  'di': '06',
  'xian': '00',
  'name': '岳阳市',
  'level': 2
}, {
  'code': '430601',
  'sheng': '43',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430602',
  'sheng': '43',
  'di': '06',
  'xian': '02',
  'name': '岳阳楼区',
  'level': 3
}, {
  'code': '430603',
  'sheng': '43',
  'di': '06',
  'xian': '03',
  'name': '云溪区',
  'level': 3
}, {
  'code': '430611',
  'sheng': '43',
  'di': '06',
  'xian': '11',
  'name': '君山区',
  'level': 3
}, {
  'code': '430621',
  'sheng': '43',
  'di': '06',
  'xian': '21',
  'name': '岳阳县',
  'level': 3
}, {
  'code': '430623',
  'sheng': '43',
  'di': '06',
  'xian': '23',
  'name': '华容县',
  'level': 3
}, {
  'code': '430624',
  'sheng': '43',
  'di': '06',
  'xian': '24',
  'name': '湘阴县',
  'level': 3
}, {
  'code': '430626',
  'sheng': '43',
  'di': '06',
  'xian': '26',
  'name': '平江县',
  'level': 3
}, {
  'code': '430681',
  'sheng': '43',
  'di': '06',
  'xian': '81',
  'name': '汨罗市',
  'level': 3
}, {
  'code': '430682',
  'sheng': '43',
  'di': '06',
  'xian': '82',
  'name': '临湘市',
  'level': 3
}, {
  'code': '430700',
  'sheng': '43',
  'di': '07',
  'xian': '00',
  'name': '常德市',
  'level': 2
}, {
  'code': '430701',
  'sheng': '43',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430702',
  'sheng': '43',
  'di': '07',
  'xian': '02',
  'name': '武陵区',
  'level': 3
}, {
  'code': '430703',
  'sheng': '43',
  'di': '07',
  'xian': '03',
  'name': '鼎城区',
  'level': 3
}, {
  'code': '430721',
  'sheng': '43',
  'di': '07',
  'xian': '21',
  'name': '安乡县',
  'level': 3
}, {
  'code': '430722',
  'sheng': '43',
  'di': '07',
  'xian': '22',
  'name': '汉寿县',
  'level': 3
}, {
  'code': '430723',
  'sheng': '43',
  'di': '07',
  'xian': '23',
  'name': '澧县',
  'level': 3
}, {
  'code': '430724',
  'sheng': '43',
  'di': '07',
  'xian': '24',
  'name': '临澧县',
  'level': 3
}, {
  'code': '430725',
  'sheng': '43',
  'di': '07',
  'xian': '25',
  'name': '桃源县',
  'level': 3
}, {
  'code': '430726',
  'sheng': '43',
  'di': '07',
  'xian': '26',
  'name': '石门县',
  'level': 3
}, {
  'code': '430781',
  'sheng': '43',
  'di': '07',
  'xian': '81',
  'name': '津市市',
  'level': 3
}, {
  'code': '430800',
  'sheng': '43',
  'di': '08',
  'xian': '00',
  'name': '张家界市',
  'level': 2
}, {
  'code': '430801',
  'sheng': '43',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430802',
  'sheng': '43',
  'di': '08',
  'xian': '02',
  'name': '永定区',
  'level': 3
}, {
  'code': '430811',
  'sheng': '43',
  'di': '08',
  'xian': '11',
  'name': '武陵源区',
  'level': 3
}, {
  'code': '430821',
  'sheng': '43',
  'di': '08',
  'xian': '21',
  'name': '慈利县',
  'level': 3
}, {
  'code': '430822',
  'sheng': '43',
  'di': '08',
  'xian': '22',
  'name': '桑植县',
  'level': 3
}, {
  'code': '430900',
  'sheng': '43',
  'di': '09',
  'xian': '00',
  'name': '益阳市',
  'level': 2
}, {
  'code': '430901',
  'sheng': '43',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '430902',
  'sheng': '43',
  'di': '09',
  'xian': '02',
  'name': '资阳区',
  'level': 3
}, {
  'code': '430903',
  'sheng': '43',
  'di': '09',
  'xian': '03',
  'name': '赫山区',
  'level': 3
}, {
  'code': '430921',
  'sheng': '43',
  'di': '09',
  'xian': '21',
  'name': '南县',
  'level': 3
}, {
  'code': '430922',
  'sheng': '43',
  'di': '09',
  'xian': '22',
  'name': '桃江县',
  'level': 3
}, {
  'code': '430923',
  'sheng': '43',
  'di': '09',
  'xian': '23',
  'name': '安化县',
  'level': 3
}, {
  'code': '430981',
  'sheng': '43',
  'di': '09',
  'xian': '81',
  'name': '沅江市',
  'level': 3
}, {
  'code': '431000',
  'sheng': '43',
  'di': '10',
  'xian': '00',
  'name': '郴州市',
  'level': 2
}, {
  'code': '431001',
  'sheng': '43',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '431002',
  'sheng': '43',
  'di': '10',
  'xian': '02',
  'name': '北湖区',
  'level': 3
}, {
  'code': '431003',
  'sheng': '43',
  'di': '10',
  'xian': '03',
  'name': '苏仙区',
  'level': 3
}, {
  'code': '431021',
  'sheng': '43',
  'di': '10',
  'xian': '21',
  'name': '桂阳县',
  'level': 3
}, {
  'code': '431022',
  'sheng': '43',
  'di': '10',
  'xian': '22',
  'name': '宜章县',
  'level': 3
}, {
  'code': '431023',
  'sheng': '43',
  'di': '10',
  'xian': '23',
  'name': '永兴县',
  'level': 3
}, {
  'code': '431024',
  'sheng': '43',
  'di': '10',
  'xian': '24',
  'name': '嘉禾县',
  'level': 3
}, {
  'code': '431025',
  'sheng': '43',
  'di': '10',
  'xian': '25',
  'name': '临武县',
  'level': 3
}, {
  'code': '431026',
  'sheng': '43',
  'di': '10',
  'xian': '26',
  'name': '汝城县',
  'level': 3
}, {
  'code': '431027',
  'sheng': '43',
  'di': '10',
  'xian': '27',
  'name': '桂东县',
  'level': 3
}, {
  'code': '431028',
  'sheng': '43',
  'di': '10',
  'xian': '28',
  'name': '安仁县',
  'level': 3
}, {
  'code': '431081',
  'sheng': '43',
  'di': '10',
  'xian': '81',
  'name': '资兴市',
  'level': 3
}, {
  'code': '431100',
  'sheng': '43',
  'di': '11',
  'xian': '00',
  'name': '永州市',
  'level': 2
}, {
  'code': '431101',
  'sheng': '43',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '431102',
  'sheng': '43',
  'di': '11',
  'xian': '02',
  'name': '零陵区',
  'level': 3
}, {
  'code': '431103',
  'sheng': '43',
  'di': '11',
  'xian': '03',
  'name': '冷水滩区',
  'level': 3
}, {
  'code': '431121',
  'sheng': '43',
  'di': '11',
  'xian': '21',
  'name': '祁阳县',
  'level': 3
}, {
  'code': '431122',
  'sheng': '43',
  'di': '11',
  'xian': '22',
  'name': '东安县',
  'level': 3
}, {
  'code': '431123',
  'sheng': '43',
  'di': '11',
  'xian': '23',
  'name': '双牌县',
  'level': 3
}, {
  'code': '431124',
  'sheng': '43',
  'di': '11',
  'xian': '24',
  'name': '道县',
  'level': 3
}, {
  'code': '431125',
  'sheng': '43',
  'di': '11',
  'xian': '25',
  'name': '江永县',
  'level': 3
}, {
  'code': '431126',
  'sheng': '43',
  'di': '11',
  'xian': '26',
  'name': '宁远县',
  'level': 3
}, {
  'code': '431127',
  'sheng': '43',
  'di': '11',
  'xian': '27',
  'name': '蓝山县',
  'level': 3
}, {
  'code': '431128',
  'sheng': '43',
  'di': '11',
  'xian': '28',
  'name': '新田县',
  'level': 3
}, {
  'code': '431129',
  'sheng': '43',
  'di': '11',
  'xian': '29',
  'name': '江华瑶族自治县',
  'level': 3
}, {
  'code': '431200',
  'sheng': '43',
  'di': '12',
  'xian': '00',
  'name': '怀化市',
  'level': 2
}, {
  'code': '431201',
  'sheng': '43',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '431202',
  'sheng': '43',
  'di': '12',
  'xian': '02',
  'name': '鹤城区',
  'level': 3
}, {
  'code': '431221',
  'sheng': '43',
  'di': '12',
  'xian': '21',
  'name': '中方县',
  'level': 3
}, {
  'code': '431222',
  'sheng': '43',
  'di': '12',
  'xian': '22',
  'name': '沅陵县',
  'level': 3
}, {
  'code': '431223',
  'sheng': '43',
  'di': '12',
  'xian': '23',
  'name': '辰溪县',
  'level': 3
}, {
  'code': '431224',
  'sheng': '43',
  'di': '12',
  'xian': '24',
  'name': '溆浦县',
  'level': 3
}, {
  'code': '431225',
  'sheng': '43',
  'di': '12',
  'xian': '25',
  'name': '会同县',
  'level': 3
}, {
  'code': '431226',
  'sheng': '43',
  'di': '12',
  'xian': '26',
  'name': '麻阳苗族自治县',
  'level': 3
}, {
  'code': '431227',
  'sheng': '43',
  'di': '12',
  'xian': '27',
  'name': '新晃侗族自治县',
  'level': 3
}, {
  'code': '431228',
  'sheng': '43',
  'di': '12',
  'xian': '28',
  'name': '芷江侗族自治县',
  'level': 3
}, {
  'code': '431229',
  'sheng': '43',
  'di': '12',
  'xian': '29',
  'name': '靖州苗族侗族自治县',
  'level': 3
}, {
  'code': '431230',
  'sheng': '43',
  'di': '12',
  'xian': '30',
  'name': '通道侗族自治县',
  'level': 3
}, {
  'code': '431281',
  'sheng': '43',
  'di': '12',
  'xian': '81',
  'name': '洪江市',
  'level': 3
}, {
  'code': '431300',
  'sheng': '43',
  'di': '13',
  'xian': '00',
  'name': '娄底市',
  'level': 2
}, {
  'code': '431301',
  'sheng': '43',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '431302',
  'sheng': '43',
  'di': '13',
  'xian': '02',
  'name': '娄星区',
  'level': 3
}, {
  'code': '431321',
  'sheng': '43',
  'di': '13',
  'xian': '21',
  'name': '双峰县',
  'level': 3
}, {
  'code': '431322',
  'sheng': '43',
  'di': '13',
  'xian': '22',
  'name': '新化县',
  'level': 3
}, {
  'code': '431381',
  'sheng': '43',
  'di': '13',
  'xian': '81',
  'name': '冷水江市',
  'level': 3
}, {
  'code': '431382',
  'sheng': '43',
  'di': '13',
  'xian': '82',
  'name': '涟源市',
  'level': 3
}, {
  'code': '433100',
  'sheng': '43',
  'di': '31',
  'xian': '00',
  'name': '湘西土家族苗族自治州',
  'level': 2
}, {
  'code': '433101',
  'sheng': '43',
  'di': '31',
  'xian': '01',
  'name': '吉首市',
  'level': 3
}, {
  'code': '433122',
  'sheng': '43',
  'di': '31',
  'xian': '22',
  'name': '泸溪县',
  'level': 3
}, {
  'code': '433123',
  'sheng': '43',
  'di': '31',
  'xian': '23',
  'name': '凤凰县',
  'level': 3
}, {
  'code': '433124',
  'sheng': '43',
  'di': '31',
  'xian': '24',
  'name': '花垣县',
  'level': 3
}, {
  'code': '433125',
  'sheng': '43',
  'di': '31',
  'xian': '25',
  'name': '保靖县',
  'level': 3
}, {
  'code': '433126',
  'sheng': '43',
  'di': '31',
  'xian': '26',
  'name': '古丈县',
  'level': 3
}, {
  'code': '433127',
  'sheng': '43',
  'di': '31',
  'xian': '27',
  'name': '永顺县',
  'level': 3
}, {
  'code': '433130',
  'sheng': '43',
  'di': '31',
  'xian': '30',
  'name': '龙山县',
  'level': 3
}, {
  'code': '440000',
  'sheng': '44',
  'di': '00',
  'xian': '00',
  'name': '广东省',
  'level': 1
}, {
  'code': '440100',
  'sheng': '44',
  'di': '01',
  'xian': '00',
  'name': '广州市',
  'level': 2
}, {
  'code': '440101',
  'sheng': '44',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440103',
  'sheng': '44',
  'di': '01',
  'xian': '03',
  'name': '荔湾区',
  'level': 3
}, {
  'code': '440104',
  'sheng': '44',
  'di': '01',
  'xian': '04',
  'name': '越秀区',
  'level': 3
}, {
  'code': '440105',
  'sheng': '44',
  'di': '01',
  'xian': '05',
  'name': '海珠区',
  'level': 3
}, {
  'code': '440106',
  'sheng': '44',
  'di': '01',
  'xian': '06',
  'name': '天河区',
  'level': 3
}, {
  'code': '440111',
  'sheng': '44',
  'di': '01',
  'xian': '11',
  'name': '白云区',
  'level': 3
}, {
  'code': '440112',
  'sheng': '44',
  'di': '01',
  'xian': '12',
  'name': '黄埔区',
  'level': 3
}, {
  'code': '440113',
  'sheng': '44',
  'di': '01',
  'xian': '13',
  'name': '番禺区',
  'level': 3
}, {
  'code': '440114',
  'sheng': '44',
  'di': '01',
  'xian': '14',
  'name': '花都区',
  'level': 3
}, {
  'code': '440115',
  'sheng': '44',
  'di': '01',
  'xian': '15',
  'name': '南沙区',
  'level': 3
}, {
  'code': '440116',
  'sheng': '44',
  'di': '01',
  'xian': '16',
  'name': '萝岗区',
  'level': 3
}, {
  'code': '440117',
  'sheng': '44',
  'di': '01',
  'xian': '17',
  'name': '从化区',
  'level': 3
}, {
  'code': '440118',
  'sheng': '44',
  'di': '01',
  'xian': '18',
  'name': '增城区',
  'level': 3
}, {
  'code': '440200',
  'sheng': '44',
  'di': '02',
  'xian': '00',
  'name': '韶关市',
  'level': 2
}, {
  'code': '440201',
  'sheng': '44',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440203',
  'sheng': '44',
  'di': '02',
  'xian': '03',
  'name': '武江区',
  'level': 3
}, {
  'code': '440204',
  'sheng': '44',
  'di': '02',
  'xian': '04',
  'name': '浈江区',
  'level': 3
}, {
  'code': '440205',
  'sheng': '44',
  'di': '02',
  'xian': '05',
  'name': '曲江区',
  'level': 3
}, {
  'code': '440222',
  'sheng': '44',
  'di': '02',
  'xian': '22',
  'name': '始兴县',
  'level': 3
}, {
  'code': '440224',
  'sheng': '44',
  'di': '02',
  'xian': '24',
  'name': '仁化县',
  'level': 3
}, {
  'code': '440229',
  'sheng': '44',
  'di': '02',
  'xian': '29',
  'name': '翁源县',
  'level': 3
}, {
  'code': '440232',
  'sheng': '44',
  'di': '02',
  'xian': '32',
  'name': '乳源瑶族自治县',
  'level': 3
}, {
  'code': '440233',
  'sheng': '44',
  'di': '02',
  'xian': '33',
  'name': '新丰县',
  'level': 3
}, {
  'code': '440281',
  'sheng': '44',
  'di': '02',
  'xian': '81',
  'name': '乐昌市',
  'level': 3
}, {
  'code': '440282',
  'sheng': '44',
  'di': '02',
  'xian': '82',
  'name': '南雄市',
  'level': 3
}, {
  'code': '440300',
  'sheng': '44',
  'di': '03',
  'xian': '00',
  'name': '深圳市',
  'level': 2
}, {
  'code': '440301',
  'sheng': '44',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440303',
  'sheng': '44',
  'di': '03',
  'xian': '03',
  'name': '罗湖区',
  'level': 3
}, {
  'code': '440304',
  'sheng': '44',
  'di': '03',
  'xian': '04',
  'name': '福田区',
  'level': 3
}, {
  'code': '440305',
  'sheng': '44',
  'di': '03',
  'xian': '05',
  'name': '南山区',
  'level': 3
}, {
  'code': '440306',
  'sheng': '44',
  'di': '03',
  'xian': '06',
  'name': '宝安区',
  'level': 3
}, {
  'code': '440307',
  'sheng': '44',
  'di': '03',
  'xian': '07',
  'name': '龙岗区',
  'level': 3
}, {
  'code': '440308',
  'sheng': '44',
  'di': '03',
  'xian': '08',
  'name': '盐田区',
  'level': 3
}, {
  'code': '440400',
  'sheng': '44',
  'di': '04',
  'xian': '00',
  'name': '珠海市',
  'level': 2
}, {
  'code': '440401',
  'sheng': '44',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440402',
  'sheng': '44',
  'di': '04',
  'xian': '02',
  'name': '香洲区',
  'level': 3
}, {
  'code': '440403',
  'sheng': '44',
  'di': '04',
  'xian': '03',
  'name': '斗门区',
  'level': 3
}, {
  'code': '440404',
  'sheng': '44',
  'di': '04',
  'xian': '04',
  'name': '金湾区',
  'level': 3
}, {
  'code': '440500',
  'sheng': '44',
  'di': '05',
  'xian': '00',
  'name': '汕头市',
  'level': 2
}, {
  'code': '440501',
  'sheng': '44',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440507',
  'sheng': '44',
  'di': '05',
  'xian': '07',
  'name': '龙湖区',
  'level': 3
}, {
  'code': '440511',
  'sheng': '44',
  'di': '05',
  'xian': '11',
  'name': '金平区',
  'level': 3
}, {
  'code': '440512',
  'sheng': '44',
  'di': '05',
  'xian': '12',
  'name': '濠江区',
  'level': 3
}, {
  'code': '440513',
  'sheng': '44',
  'di': '05',
  'xian': '13',
  'name': '潮阳区',
  'level': 3
}, {
  'code': '440514',
  'sheng': '44',
  'di': '05',
  'xian': '14',
  'name': '潮南区',
  'level': 3
}, {
  'code': '440515',
  'sheng': '44',
  'di': '05',
  'xian': '15',
  'name': '澄海区',
  'level': 3
}, {
  'code': '440523',
  'sheng': '44',
  'di': '05',
  'xian': '23',
  'name': '南澳县',
  'level': 3
}, {
  'code': '440600',
  'sheng': '44',
  'di': '06',
  'xian': '00',
  'name': '佛山市',
  'level': 2
}, {
  'code': '440601',
  'sheng': '44',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440604',
  'sheng': '44',
  'di': '06',
  'xian': '04',
  'name': '禅城区',
  'level': 3
}, {
  'code': '440605',
  'sheng': '44',
  'di': '06',
  'xian': '05',
  'name': '南海区',
  'level': 3
}, {
  'code': '440606',
  'sheng': '44',
  'di': '06',
  'xian': '06',
  'name': '顺德区',
  'level': 3
}, {
  'code': '440607',
  'sheng': '44',
  'di': '06',
  'xian': '07',
  'name': '三水区',
  'level': 3
}, {
  'code': '440608',
  'sheng': '44',
  'di': '06',
  'xian': '08',
  'name': '高明区',
  'level': 3
}, {
  'code': '440700',
  'sheng': '44',
  'di': '07',
  'xian': '00',
  'name': '江门市',
  'level': 2
}, {
  'code': '440701',
  'sheng': '44',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440703',
  'sheng': '44',
  'di': '07',
  'xian': '03',
  'name': '蓬江区',
  'level': 3
}, {
  'code': '440704',
  'sheng': '44',
  'di': '07',
  'xian': '04',
  'name': '江海区',
  'level': 3
}, {
  'code': '440705',
  'sheng': '44',
  'di': '07',
  'xian': '05',
  'name': '新会区',
  'level': 3
}, {
  'code': '440781',
  'sheng': '44',
  'di': '07',
  'xian': '81',
  'name': '台山市',
  'level': 3
}, {
  'code': '440783',
  'sheng': '44',
  'di': '07',
  'xian': '83',
  'name': '开平市',
  'level': 3
}, {
  'code': '440784',
  'sheng': '44',
  'di': '07',
  'xian': '84',
  'name': '鹤山市',
  'level': 3
}, {
  'code': '440785',
  'sheng': '44',
  'di': '07',
  'xian': '85',
  'name': '恩平市',
  'level': 3
}, {
  'code': '440800',
  'sheng': '44',
  'di': '08',
  'xian': '00',
  'name': '湛江市',
  'level': 2
}, {
  'code': '440801',
  'sheng': '44',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440802',
  'sheng': '44',
  'di': '08',
  'xian': '02',
  'name': '赤坎区',
  'level': 3
}, {
  'code': '440803',
  'sheng': '44',
  'di': '08',
  'xian': '03',
  'name': '霞山区',
  'level': 3
}, {
  'code': '440804',
  'sheng': '44',
  'di': '08',
  'xian': '04',
  'name': '坡头区',
  'level': 3
}, {
  'code': '440811',
  'sheng': '44',
  'di': '08',
  'xian': '11',
  'name': '麻章区',
  'level': 3
}, {
  'code': '440823',
  'sheng': '44',
  'di': '08',
  'xian': '23',
  'name': '遂溪县',
  'level': 3
}, {
  'code': '440825',
  'sheng': '44',
  'di': '08',
  'xian': '25',
  'name': '徐闻县',
  'level': 3
}, {
  'code': '440881',
  'sheng': '44',
  'di': '08',
  'xian': '81',
  'name': '廉江市',
  'level': 3
}, {
  'code': '440882',
  'sheng': '44',
  'di': '08',
  'xian': '82',
  'name': '雷州市',
  'level': 3
}, {
  'code': '440883',
  'sheng': '44',
  'di': '08',
  'xian': '83',
  'name': '吴川市',
  'level': 3
}, {
  'code': '440900',
  'sheng': '44',
  'di': '09',
  'xian': '00',
  'name': '茂名市',
  'level': 2
}, {
  'code': '440901',
  'sheng': '44',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '440902',
  'sheng': '44',
  'di': '09',
  'xian': '02',
  'name': '茂南区',
  'level': 3
}, {
  'code': '440904',
  'sheng': '44',
  'di': '09',
  'xian': '04',
  'name': '电白区',
  'level': 3
}, {
  'code': '440981',
  'sheng': '44',
  'di': '09',
  'xian': '81',
  'name': '高州市',
  'level': 3
}, {
  'code': '440982',
  'sheng': '44',
  'di': '09',
  'xian': '82',
  'name': '化州市',
  'level': 3
}, {
  'code': '440983',
  'sheng': '44',
  'di': '09',
  'xian': '83',
  'name': '信宜市',
  'level': 3
}, {
  'code': '441200',
  'sheng': '44',
  'di': '12',
  'xian': '00',
  'name': '肇庆市',
  'level': 2
}, {
  'code': '441201',
  'sheng': '44',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441202',
  'sheng': '44',
  'di': '12',
  'xian': '02',
  'name': '端州区',
  'level': 3
}, {
  'code': '441203',
  'sheng': '44',
  'di': '12',
  'xian': '03',
  'name': '鼎湖区',
  'level': 3
}, {
  'code': '441223',
  'sheng': '44',
  'di': '12',
  'xian': '23',
  'name': '广宁县',
  'level': 3
}, {
  'code': '441224',
  'sheng': '44',
  'di': '12',
  'xian': '24',
  'name': '怀集县',
  'level': 3
}, {
  'code': '441225',
  'sheng': '44',
  'di': '12',
  'xian': '25',
  'name': '封开县',
  'level': 3
}, {
  'code': '441226',
  'sheng': '44',
  'di': '12',
  'xian': '26',
  'name': '德庆县',
  'level': 3
}, {
  'code': '441283',
  'sheng': '44',
  'di': '12',
  'xian': '83',
  'name': '高要市',
  'level': 3
}, {
  'code': '441284',
  'sheng': '44',
  'di': '12',
  'xian': '84',
  'name': '四会市',
  'level': 3
}, {
  'code': '441300',
  'sheng': '44',
  'di': '13',
  'xian': '00',
  'name': '惠州市',
  'level': 2
}, {
  'code': '441301',
  'sheng': '44',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441302',
  'sheng': '44',
  'di': '13',
  'xian': '02',
  'name': '惠城区',
  'level': 3
}, {
  'code': '441303',
  'sheng': '44',
  'di': '13',
  'xian': '03',
  'name': '惠阳区',
  'level': 3
}, {
  'code': '441322',
  'sheng': '44',
  'di': '13',
  'xian': '22',
  'name': '博罗县',
  'level': 3
}, {
  'code': '441323',
  'sheng': '44',
  'di': '13',
  'xian': '23',
  'name': '惠东县',
  'level': 3
}, {
  'code': '441324',
  'sheng': '44',
  'di': '13',
  'xian': '24',
  'name': '龙门县',
  'level': 3
}, {
  'code': '441400',
  'sheng': '44',
  'di': '14',
  'xian': '00',
  'name': '梅州市',
  'level': 2
}, {
  'code': '441401',
  'sheng': '44',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441402',
  'sheng': '44',
  'di': '14',
  'xian': '02',
  'name': '梅江区',
  'level': 3
}, {
  'code': '441403',
  'sheng': '44',
  'di': '14',
  'xian': '03',
  'name': '梅县区',
  'level': 3
}, {
  'code': '441422',
  'sheng': '44',
  'di': '14',
  'xian': '22',
  'name': '大埔县',
  'level': 3
}, {
  'code': '441423',
  'sheng': '44',
  'di': '14',
  'xian': '23',
  'name': '丰顺县',
  'level': 3
}, {
  'code': '441424',
  'sheng': '44',
  'di': '14',
  'xian': '24',
  'name': '五华县',
  'level': 3
}, {
  'code': '441426',
  'sheng': '44',
  'di': '14',
  'xian': '26',
  'name': '平远县',
  'level': 3
}, {
  'code': '441427',
  'sheng': '44',
  'di': '14',
  'xian': '27',
  'name': '蕉岭县',
  'level': 3
}, {
  'code': '441481',
  'sheng': '44',
  'di': '14',
  'xian': '81',
  'name': '兴宁市',
  'level': 3
}, {
  'code': '441500',
  'sheng': '44',
  'di': '15',
  'xian': '00',
  'name': '汕尾市',
  'level': 2
}, {
  'code': '441501',
  'sheng': '44',
  'di': '15',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441502',
  'sheng': '44',
  'di': '15',
  'xian': '02',
  'name': '城区',
  'level': 3
}, {
  'code': '441521',
  'sheng': '44',
  'di': '15',
  'xian': '21',
  'name': '海丰县',
  'level': 3
}, {
  'code': '441523',
  'sheng': '44',
  'di': '15',
  'xian': '23',
  'name': '陆河县',
  'level': 3
}, {
  'code': '441581',
  'sheng': '44',
  'di': '15',
  'xian': '81',
  'name': '陆丰市',
  'level': 3
}, {
  'code': '441600',
  'sheng': '44',
  'di': '16',
  'xian': '00',
  'name': '河源市',
  'level': 2
}, {
  'code': '441601',
  'sheng': '44',
  'di': '16',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441602',
  'sheng': '44',
  'di': '16',
  'xian': '02',
  'name': '源城区',
  'level': 3
}, {
  'code': '441621',
  'sheng': '44',
  'di': '16',
  'xian': '21',
  'name': '紫金县',
  'level': 3
}, {
  'code': '441622',
  'sheng': '44',
  'di': '16',
  'xian': '22',
  'name': '龙川县',
  'level': 3
}, {
  'code': '441623',
  'sheng': '44',
  'di': '16',
  'xian': '23',
  'name': '连平县',
  'level': 3
}, {
  'code': '441624',
  'sheng': '44',
  'di': '16',
  'xian': '24',
  'name': '和平县',
  'level': 3
}, {
  'code': '441625',
  'sheng': '44',
  'di': '16',
  'xian': '25',
  'name': '东源县',
  'level': 3
}, {
  'code': '441700',
  'sheng': '44',
  'di': '17',
  'xian': '00',
  'name': '阳江市',
  'level': 2
}, {
  'code': '441701',
  'sheng': '44',
  'di': '17',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441702',
  'sheng': '44',
  'di': '17',
  'xian': '02',
  'name': '江城区',
  'level': 3
}, {
  'code': '441721',
  'sheng': '44',
  'di': '17',
  'xian': '21',
  'name': '阳西县',
  'level': 3
}, {
  'code': '441723',
  'sheng': '44',
  'di': '17',
  'xian': '23',
  'name': '阳东县',
  'level': 3
}, {
  'code': '441781',
  'sheng': '44',
  'di': '17',
  'xian': '81',
  'name': '阳春市',
  'level': 3
}, {
  'code': '441800',
  'sheng': '44',
  'di': '18',
  'xian': '00',
  'name': '清远市',
  'level': 2
}, {
  'code': '441801',
  'sheng': '44',
  'di': '18',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '441802',
  'sheng': '44',
  'di': '18',
  'xian': '02',
  'name': '清城区',
  'level': 3
}, {
  'code': '441803',
  'sheng': '44',
  'di': '18',
  'xian': '03',
  'name': '清新区',
  'level': 3
}, {
  'code': '441821',
  'sheng': '44',
  'di': '18',
  'xian': '21',
  'name': '佛冈县',
  'level': 3
}, {
  'code': '441823',
  'sheng': '44',
  'di': '18',
  'xian': '23',
  'name': '阳山县',
  'level': 3
}, {
  'code': '441825',
  'sheng': '44',
  'di': '18',
  'xian': '25',
  'name': '连山壮族瑶族自治县',
  'level': 3
}, {
  'code': '441826',
  'sheng': '44',
  'di': '18',
  'xian': '26',
  'name': '连南瑶族自治县',
  'level': 3
}, {
  'code': '441881',
  'sheng': '44',
  'di': '18',
  'xian': '81',
  'name': '英德市',
  'level': 3
}, {
  'code': '441882',
  'sheng': '44',
  'di': '18',
  'xian': '82',
  'name': '连州市',
  'level': 3
}, {
  'code': '441900',
  'sheng': '44',
  'di': '19',
  'xian': '00',
  'name': '东莞市',
  'level': 2
}, {
  'code': '442000',
  'sheng': '44',
  'di': '20',
  'xian': '00',
  'name': '中山市',
  'level': 2
}, {
  'code': '445100',
  'sheng': '44',
  'di': '51',
  'xian': '00',
  'name': '潮州市',
  'level': 2
}, {
  'code': '445101',
  'sheng': '44',
  'di': '51',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '445102',
  'sheng': '44',
  'di': '51',
  'xian': '02',
  'name': '湘桥区',
  'level': 3
}, {
  'code': '445103',
  'sheng': '44',
  'di': '51',
  'xian': '03',
  'name': '潮安区',
  'level': 3
}, {
  'code': '445122',
  'sheng': '44',
  'di': '51',
  'xian': '22',
  'name': '饶平县',
  'level': 3
}, {
  'code': '445200',
  'sheng': '44',
  'di': '52',
  'xian': '00',
  'name': '揭阳市',
  'level': 2
}, {
  'code': '445201',
  'sheng': '44',
  'di': '52',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '445202',
  'sheng': '44',
  'di': '52',
  'xian': '02',
  'name': '榕城区',
  'level': 3
}, {
  'code': '445203',
  'sheng': '44',
  'di': '52',
  'xian': '03',
  'name': '揭东区',
  'level': 3
}, {
  'code': '445222',
  'sheng': '44',
  'di': '52',
  'xian': '22',
  'name': '揭西县',
  'level': 3
}, {
  'code': '445224',
  'sheng': '44',
  'di': '52',
  'xian': '24',
  'name': '惠来县',
  'level': 3
}, {
  'code': '445281',
  'sheng': '44',
  'di': '52',
  'xian': '81',
  'name': '普宁市',
  'level': 3
}, {
  'code': '445300',
  'sheng': '44',
  'di': '53',
  'xian': '00',
  'name': '云浮市',
  'level': 2
}, {
  'code': '445301',
  'sheng': '44',
  'di': '53',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '445302',
  'sheng': '44',
  'di': '53',
  'xian': '02',
  'name': '云城区',
  'level': 3
}, {
  'code': '445303',
  'sheng': '44',
  'di': '53',
  'xian': '03',
  'name': '云安区',
  'level': 3
}, {
  'code': '445321',
  'sheng': '44',
  'di': '53',
  'xian': '21',
  'name': '新兴县',
  'level': 3
}, {
  'code': '445322',
  'sheng': '44',
  'di': '53',
  'xian': '22',
  'name': '郁南县',
  'level': 3
}, {
  'code': '445381',
  'sheng': '44',
  'di': '53',
  'xian': '81',
  'name': '罗定市',
  'level': 3
}, {
  'code': '450000',
  'sheng': '45',
  'di': '00',
  'xian': '00',
  'name': '广西壮族自治区',
  'level': 1
}, {
  'code': '450100',
  'sheng': '45',
  'di': '01',
  'xian': '00',
  'name': '南宁市',
  'level': 2
}, {
  'code': '450101',
  'sheng': '45',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450102',
  'sheng': '45',
  'di': '01',
  'xian': '02',
  'name': '兴宁区',
  'level': 3
}, {
  'code': '450103',
  'sheng': '45',
  'di': '01',
  'xian': '03',
  'name': '青秀区',
  'level': 3
}, {
  'code': '450105',
  'sheng': '45',
  'di': '01',
  'xian': '05',
  'name': '江南区',
  'level': 3
}, {
  'code': '450107',
  'sheng': '45',
  'di': '01',
  'xian': '07',
  'name': '西乡塘区',
  'level': 3
}, {
  'code': '450108',
  'sheng': '45',
  'di': '01',
  'xian': '08',
  'name': '良庆区',
  'level': 3
}, {
  'code': '450109',
  'sheng': '45',
  'di': '01',
  'xian': '09',
  'name': '邕宁区',
  'level': 3
}, {
  'code': '450122',
  'sheng': '45',
  'di': '01',
  'xian': '22',
  'name': '武鸣县',
  'level': 3
}, {
  'code': '450123',
  'sheng': '45',
  'di': '01',
  'xian': '23',
  'name': '隆安县',
  'level': 3
}, {
  'code': '450124',
  'sheng': '45',
  'di': '01',
  'xian': '24',
  'name': '马山县',
  'level': 3
}, {
  'code': '450125',
  'sheng': '45',
  'di': '01',
  'xian': '25',
  'name': '上林县',
  'level': 3
}, {
  'code': '450126',
  'sheng': '45',
  'di': '01',
  'xian': '26',
  'name': '宾阳县',
  'level': 3
}, {
  'code': '450127',
  'sheng': '45',
  'di': '01',
  'xian': '27',
  'name': '横县',
  'level': 3
}, {
  'code': '450200',
  'sheng': '45',
  'di': '02',
  'xian': '00',
  'name': '柳州市',
  'level': 2
}, {
  'code': '450201',
  'sheng': '45',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450202',
  'sheng': '45',
  'di': '02',
  'xian': '02',
  'name': '城中区',
  'level': 3
}, {
  'code': '450203',
  'sheng': '45',
  'di': '02',
  'xian': '03',
  'name': '鱼峰区',
  'level': 3
}, {
  'code': '450204',
  'sheng': '45',
  'di': '02',
  'xian': '04',
  'name': '柳南区',
  'level': 3
}, {
  'code': '450205',
  'sheng': '45',
  'di': '02',
  'xian': '05',
  'name': '柳北区',
  'level': 3
}, {
  'code': '450221',
  'sheng': '45',
  'di': '02',
  'xian': '21',
  'name': '柳江县',
  'level': 3
}, {
  'code': '450222',
  'sheng': '45',
  'di': '02',
  'xian': '22',
  'name': '柳城县',
  'level': 3
}, {
  'code': '450223',
  'sheng': '45',
  'di': '02',
  'xian': '23',
  'name': '鹿寨县',
  'level': 3
}, {
  'code': '450224',
  'sheng': '45',
  'di': '02',
  'xian': '24',
  'name': '融安县',
  'level': 3
}, {
  'code': '450225',
  'sheng': '45',
  'di': '02',
  'xian': '25',
  'name': '融水苗族自治县',
  'level': 3
}, {
  'code': '450226',
  'sheng': '45',
  'di': '02',
  'xian': '26',
  'name': '三江侗族自治县',
  'level': 3
}, {
  'code': '450300',
  'sheng': '45',
  'di': '03',
  'xian': '00',
  'name': '桂林市',
  'level': 2
}, {
  'code': '450301',
  'sheng': '45',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450302',
  'sheng': '45',
  'di': '03',
  'xian': '02',
  'name': '秀峰区',
  'level': 3
}, {
  'code': '450303',
  'sheng': '45',
  'di': '03',
  'xian': '03',
  'name': '叠彩区',
  'level': 3
}, {
  'code': '450304',
  'sheng': '45',
  'di': '03',
  'xian': '04',
  'name': '象山区',
  'level': 3
}, {
  'code': '450305',
  'sheng': '45',
  'di': '03',
  'xian': '05',
  'name': '七星区',
  'level': 3
}, {
  'code': '450311',
  'sheng': '45',
  'di': '03',
  'xian': '11',
  'name': '雁山区',
  'level': 3
}, {
  'code': '450312',
  'sheng': '45',
  'di': '03',
  'xian': '12',
  'name': '临桂区',
  'level': 3
}, {
  'code': '450321',
  'sheng': '45',
  'di': '03',
  'xian': '21',
  'name': '阳朔县',
  'level': 3
}, {
  'code': '450323',
  'sheng': '45',
  'di': '03',
  'xian': '23',
  'name': '灵川县',
  'level': 3
}, {
  'code': '450324',
  'sheng': '45',
  'di': '03',
  'xian': '24',
  'name': '全州县',
  'level': 3
}, {
  'code': '450325',
  'sheng': '45',
  'di': '03',
  'xian': '25',
  'name': '兴安县',
  'level': 3
}, {
  'code': '450326',
  'sheng': '45',
  'di': '03',
  'xian': '26',
  'name': '永福县',
  'level': 3
}, {
  'code': '450327',
  'sheng': '45',
  'di': '03',
  'xian': '27',
  'name': '灌阳县',
  'level': 3
}, {
  'code': '450328',
  'sheng': '45',
  'di': '03',
  'xian': '28',
  'name': '龙胜各族自治县',
  'level': 3
}, {
  'code': '450329',
  'sheng': '45',
  'di': '03',
  'xian': '29',
  'name': '资源县',
  'level': 3
}, {
  'code': '450330',
  'sheng': '45',
  'di': '03',
  'xian': '30',
  'name': '平乐县',
  'level': 3
}, {
  'code': '450331',
  'sheng': '45',
  'di': '03',
  'xian': '31',
  'name': '荔浦县',
  'level': 3
}, {
  'code': '450332',
  'sheng': '45',
  'di': '03',
  'xian': '32',
  'name': '恭城瑶族自治县',
  'level': 3
}, {
  'code': '450400',
  'sheng': '45',
  'di': '04',
  'xian': '00',
  'name': '梧州市',
  'level': 2
}, {
  'code': '450401',
  'sheng': '45',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450403',
  'sheng': '45',
  'di': '04',
  'xian': '03',
  'name': '万秀区',
  'level': 3
}, {
  'code': '450405',
  'sheng': '45',
  'di': '04',
  'xian': '05',
  'name': '长洲区',
  'level': 3
}, {
  'code': '450406',
  'sheng': '45',
  'di': '04',
  'xian': '06',
  'name': '龙圩区',
  'level': 3
}, {
  'code': '450421',
  'sheng': '45',
  'di': '04',
  'xian': '21',
  'name': '苍梧县',
  'level': 3
}, {
  'code': '450422',
  'sheng': '45',
  'di': '04',
  'xian': '22',
  'name': '藤县',
  'level': 3
}, {
  'code': '450423',
  'sheng': '45',
  'di': '04',
  'xian': '23',
  'name': '蒙山县',
  'level': 3
}, {
  'code': '450481',
  'sheng': '45',
  'di': '04',
  'xian': '81',
  'name': '岑溪市',
  'level': 3
}, {
  'code': '450500',
  'sheng': '45',
  'di': '05',
  'xian': '00',
  'name': '北海市',
  'level': 2
}, {
  'code': '450501',
  'sheng': '45',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450502',
  'sheng': '45',
  'di': '05',
  'xian': '02',
  'name': '海城区',
  'level': 3
}, {
  'code': '450503',
  'sheng': '45',
  'di': '05',
  'xian': '03',
  'name': '银海区',
  'level': 3
}, {
  'code': '450512',
  'sheng': '45',
  'di': '05',
  'xian': '12',
  'name': '铁山港区',
  'level': 3
}, {
  'code': '450521',
  'sheng': '45',
  'di': '05',
  'xian': '21',
  'name': '合浦县',
  'level': 3
}, {
  'code': '450600',
  'sheng': '45',
  'di': '06',
  'xian': '00',
  'name': '防城港市',
  'level': 2
}, {
  'code': '450601',
  'sheng': '45',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450602',
  'sheng': '45',
  'di': '06',
  'xian': '02',
  'name': '港口区',
  'level': 3
}, {
  'code': '450603',
  'sheng': '45',
  'di': '06',
  'xian': '03',
  'name': '防城区',
  'level': 3
}, {
  'code': '450621',
  'sheng': '45',
  'di': '06',
  'xian': '21',
  'name': '上思县',
  'level': 3
}, {
  'code': '450681',
  'sheng': '45',
  'di': '06',
  'xian': '81',
  'name': '东兴市',
  'level': 3
}, {
  'code': '450700',
  'sheng': '45',
  'di': '07',
  'xian': '00',
  'name': '钦州市',
  'level': 2
}, {
  'code': '450701',
  'sheng': '45',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450702',
  'sheng': '45',
  'di': '07',
  'xian': '02',
  'name': '钦南区',
  'level': 3
}, {
  'code': '450703',
  'sheng': '45',
  'di': '07',
  'xian': '03',
  'name': '钦北区',
  'level': 3
}, {
  'code': '450721',
  'sheng': '45',
  'di': '07',
  'xian': '21',
  'name': '灵山县',
  'level': 3
}, {
  'code': '450722',
  'sheng': '45',
  'di': '07',
  'xian': '22',
  'name': '浦北县',
  'level': 3
}, {
  'code': '450800',
  'sheng': '45',
  'di': '08',
  'xian': '00',
  'name': '贵港市',
  'level': 2
}, {
  'code': '450801',
  'sheng': '45',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450802',
  'sheng': '45',
  'di': '08',
  'xian': '02',
  'name': '港北区',
  'level': 3
}, {
  'code': '450803',
  'sheng': '45',
  'di': '08',
  'xian': '03',
  'name': '港南区',
  'level': 3
}, {
  'code': '450804',
  'sheng': '45',
  'di': '08',
  'xian': '04',
  'name': '覃塘区',
  'level': 3
}, {
  'code': '450821',
  'sheng': '45',
  'di': '08',
  'xian': '21',
  'name': '平南县',
  'level': 3
}, {
  'code': '450881',
  'sheng': '45',
  'di': '08',
  'xian': '81',
  'name': '桂平市',
  'level': 3
}, {
  'code': '450900',
  'sheng': '45',
  'di': '09',
  'xian': '00',
  'name': '玉林市',
  'level': 2
}, {
  'code': '450901',
  'sheng': '45',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '450902',
  'sheng': '45',
  'di': '09',
  'xian': '02',
  'name': '玉州区',
  'level': 3
}, {
  'code': '450903',
  'sheng': '45',
  'di': '09',
  'xian': '03',
  'name': '福绵区',
  'level': 3
}, {
  'code': '450921',
  'sheng': '45',
  'di': '09',
  'xian': '21',
  'name': '容县',
  'level': 3
}, {
  'code': '450922',
  'sheng': '45',
  'di': '09',
  'xian': '22',
  'name': '陆川县',
  'level': 3
}, {
  'code': '450923',
  'sheng': '45',
  'di': '09',
  'xian': '23',
  'name': '博白县',
  'level': 3
}, {
  'code': '450924',
  'sheng': '45',
  'di': '09',
  'xian': '24',
  'name': '兴业县',
  'level': 3
}, {
  'code': '450981',
  'sheng': '45',
  'di': '09',
  'xian': '81',
  'name': '北流市',
  'level': 3
}, {
  'code': '451000',
  'sheng': '45',
  'di': '10',
  'xian': '00',
  'name': '百色市',
  'level': 2
}, {
  'code': '451001',
  'sheng': '45',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '451002',
  'sheng': '45',
  'di': '10',
  'xian': '02',
  'name': '右江区',
  'level': 3
}, {
  'code': '451021',
  'sheng': '45',
  'di': '10',
  'xian': '21',
  'name': '田阳县',
  'level': 3
}, {
  'code': '451022',
  'sheng': '45',
  'di': '10',
  'xian': '22',
  'name': '田东县',
  'level': 3
}, {
  'code': '451023',
  'sheng': '45',
  'di': '10',
  'xian': '23',
  'name': '平果县',
  'level': 3
}, {
  'code': '451024',
  'sheng': '45',
  'di': '10',
  'xian': '24',
  'name': '德保县',
  'level': 3
}, {
  'code': '451025',
  'sheng': '45',
  'di': '10',
  'xian': '25',
  'name': '靖西县',
  'level': 3
}, {
  'code': '451026',
  'sheng': '45',
  'di': '10',
  'xian': '26',
  'name': '那坡县',
  'level': 3
}, {
  'code': '451027',
  'sheng': '45',
  'di': '10',
  'xian': '27',
  'name': '凌云县',
  'level': 3
}, {
  'code': '451028',
  'sheng': '45',
  'di': '10',
  'xian': '28',
  'name': '乐业县',
  'level': 3
}, {
  'code': '451029',
  'sheng': '45',
  'di': '10',
  'xian': '29',
  'name': '田林县',
  'level': 3
}, {
  'code': '451030',
  'sheng': '45',
  'di': '10',
  'xian': '30',
  'name': '西林县',
  'level': 3
}, {
  'code': '451031',
  'sheng': '45',
  'di': '10',
  'xian': '31',
  'name': '隆林各族自治县',
  'level': 3
}, {
  'code': '451100',
  'sheng': '45',
  'di': '11',
  'xian': '00',
  'name': '贺州市',
  'level': 2
}, {
  'code': '451101',
  'sheng': '45',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '451102',
  'sheng': '45',
  'di': '11',
  'xian': '02',
  'name': '八步区',
  'level': 3
}, {
  'code': '451121',
  'sheng': '45',
  'di': '11',
  'xian': '21',
  'name': '昭平县',
  'level': 3
}, {
  'code': '451122',
  'sheng': '45',
  'di': '11',
  'xian': '22',
  'name': '钟山县',
  'level': 3
}, {
  'code': '451123',
  'sheng': '45',
  'di': '11',
  'xian': '23',
  'name': '富川瑶族自治县',
  'level': 3
}, {
  'code': '451200',
  'sheng': '45',
  'di': '12',
  'xian': '00',
  'name': '河池市',
  'level': 2
}, {
  'code': '451201',
  'sheng': '45',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '451202',
  'sheng': '45',
  'di': '12',
  'xian': '02',
  'name': '金城江区',
  'level': 3
}, {
  'code': '451221',
  'sheng': '45',
  'di': '12',
  'xian': '21',
  'name': '南丹县',
  'level': 3
}, {
  'code': '451222',
  'sheng': '45',
  'di': '12',
  'xian': '22',
  'name': '天峨县',
  'level': 3
}, {
  'code': '451223',
  'sheng': '45',
  'di': '12',
  'xian': '23',
  'name': '凤山县',
  'level': 3
}, {
  'code': '451224',
  'sheng': '45',
  'di': '12',
  'xian': '24',
  'name': '东兰县',
  'level': 3
}, {
  'code': '451225',
  'sheng': '45',
  'di': '12',
  'xian': '25',
  'name': '罗城仫佬族自治县',
  'level': 3
}, {
  'code': '451226',
  'sheng': '45',
  'di': '12',
  'xian': '26',
  'name': '环江毛南族自治县',
  'level': 3
}, {
  'code': '451227',
  'sheng': '45',
  'di': '12',
  'xian': '27',
  'name': '巴马瑶族自治县',
  'level': 3
}, {
  'code': '451228',
  'sheng': '45',
  'di': '12',
  'xian': '28',
  'name': '都安瑶族自治县',
  'level': 3
}, {
  'code': '451229',
  'sheng': '45',
  'di': '12',
  'xian': '29',
  'name': '大化瑶族自治县',
  'level': 3
}, {
  'code': '451281',
  'sheng': '45',
  'di': '12',
  'xian': '81',
  'name': '宜州市',
  'level': 3
}, {
  'code': '451300',
  'sheng': '45',
  'di': '13',
  'xian': '00',
  'name': '来宾市',
  'level': 2
}, {
  'code': '451301',
  'sheng': '45',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '451302',
  'sheng': '45',
  'di': '13',
  'xian': '02',
  'name': '兴宾区',
  'level': 3
}, {
  'code': '451321',
  'sheng': '45',
  'di': '13',
  'xian': '21',
  'name': '忻城县',
  'level': 3
}, {
  'code': '451322',
  'sheng': '45',
  'di': '13',
  'xian': '22',
  'name': '象州县',
  'level': 3
}, {
  'code': '451323',
  'sheng': '45',
  'di': '13',
  'xian': '23',
  'name': '武宣县',
  'level': 3
}, {
  'code': '451324',
  'sheng': '45',
  'di': '13',
  'xian': '24',
  'name': '金秀瑶族自治县',
  'level': 3
}, {
  'code': '451381',
  'sheng': '45',
  'di': '13',
  'xian': '81',
  'name': '合山市',
  'level': 3
}, {
  'code': '451400',
  'sheng': '45',
  'di': '14',
  'xian': '00',
  'name': '崇左市',
  'level': 2
}, {
  'code': '451401',
  'sheng': '45',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '451402',
  'sheng': '45',
  'di': '14',
  'xian': '02',
  'name': '江州区',
  'level': 3
}, {
  'code': '451421',
  'sheng': '45',
  'di': '14',
  'xian': '21',
  'name': '扶绥县',
  'level': 3
}, {
  'code': '451422',
  'sheng': '45',
  'di': '14',
  'xian': '22',
  'name': '宁明县',
  'level': 3
}, {
  'code': '451423',
  'sheng': '45',
  'di': '14',
  'xian': '23',
  'name': '龙州县',
  'level': 3
}, {
  'code': '451424',
  'sheng': '45',
  'di': '14',
  'xian': '24',
  'name': '大新县',
  'level': 3
}, {
  'code': '451425',
  'sheng': '45',
  'di': '14',
  'xian': '25',
  'name': '天等县',
  'level': 3
}, {
  'code': '451481',
  'sheng': '45',
  'di': '14',
  'xian': '81',
  'name': '凭祥市',
  'level': 3
}, {
  'code': '460000',
  'sheng': '46',
  'di': '00',
  'xian': '00',
  'name': '海南省',
  'level': 1
}, {
  'code': '460100',
  'sheng': '46',
  'di': '01',
  'xian': '00',
  'name': '海口市',
  'level': 2
}, {
  'code': '460101',
  'sheng': '46',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '460105',
  'sheng': '46',
  'di': '01',
  'xian': '05',
  'name': '秀英区',
  'level': 3
}, {
  'code': '460106',
  'sheng': '46',
  'di': '01',
  'xian': '06',
  'name': '龙华区',
  'level': 3
}, {
  'code': '460107',
  'sheng': '46',
  'di': '01',
  'xian': '07',
  'name': '琼山区',
  'level': 3
}, {
  'code': '460108',
  'sheng': '46',
  'di': '01',
  'xian': '08',
  'name': '美兰区',
  'level': 3
}, {
  'code': '460200',
  'sheng': '46',
  'di': '02',
  'xian': '00',
  'name': '三亚市',
  'level': 2
}, {
  'code': '460201',
  'sheng': '46',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '460202',
  'sheng': '46',
  'di': '02',
  'xian': '02',
  'name': '海棠区',
  'level': 3
}, {
  'code': '460203',
  'sheng': '46',
  'di': '02',
  'xian': '03',
  'name': '吉阳区',
  'level': 3
}, {
  'code': '460204',
  'sheng': '46',
  'di': '02',
  'xian': '04',
  'name': '天涯区',
  'level': 3
}, {
  'code': '460205',
  'sheng': '46',
  'di': '02',
  'xian': '05',
  'name': '崖州区',
  'level': 3
}, {
  'code': '460300',
  'sheng': '46',
  'di': '03',
  'xian': '00',
  'name': '三沙市',
  'level': 2
}, {
  'code': '469000',
  'sheng': '46',
  'di': '90',
  'xian': '00',
  'name': '省直辖县级行政区划',
  'level': 2
}, {
  'code': '469001',
  'sheng': '46',
  'di': '90',
  'xian': '01',
  'name': '五指山市',
  'level': 3
}, {
  'code': '469002',
  'sheng': '46',
  'di': '90',
  'xian': '02',
  'name': '琼海市',
  'level': 3
}, {
  'code': '469003',
  'sheng': '46',
  'di': '90',
  'xian': '03',
  'name': '儋州市',
  'level': 3
}, {
  'code': '469005',
  'sheng': '46',
  'di': '90',
  'xian': '05',
  'name': '文昌市',
  'level': 3
}, {
  'code': '469006',
  'sheng': '46',
  'di': '90',
  'xian': '06',
  'name': '万宁市',
  'level': 3
}, {
  'code': '469007',
  'sheng': '46',
  'di': '90',
  'xian': '07',
  'name': '东方市',
  'level': 3
}, {
  'code': '469021',
  'sheng': '46',
  'di': '90',
  'xian': '21',
  'name': '定安县',
  'level': 3
}, {
  'code': '469022',
  'sheng': '46',
  'di': '90',
  'xian': '22',
  'name': '屯昌县',
  'level': 3
}, {
  'code': '469023',
  'sheng': '46',
  'di': '90',
  'xian': '23',
  'name': '澄迈县',
  'level': 3
}, {
  'code': '469024',
  'sheng': '46',
  'di': '90',
  'xian': '24',
  'name': '临高县',
  'level': 3
}, {
  'code': '469025',
  'sheng': '46',
  'di': '90',
  'xian': '25',
  'name': '白沙黎族自治县',
  'level': 3
}, {
  'code': '469026',
  'sheng': '46',
  'di': '90',
  'xian': '26',
  'name': '昌江黎族自治县',
  'level': 3
}, {
  'code': '469027',
  'sheng': '46',
  'di': '90',
  'xian': '27',
  'name': '乐东黎族自治县',
  'level': 3
}, {
  'code': '469028',
  'sheng': '46',
  'di': '90',
  'xian': '28',
  'name': '陵水黎族自治县',
  'level': 3
}, {
  'code': '469029',
  'sheng': '46',
  'di': '90',
  'xian': '29',
  'name': '保亭黎族苗族自治县',
  'level': 3
}, {
  'code': '469030',
  'sheng': '46',
  'di': '90',
  'xian': '30',
  'name': '琼中黎族苗族自治县',
  'level': 3
}, {
  'code': '500000',
  'sheng': '50',
  'di': '00',
  'xian': '00',
  'name': '重庆市',
  'level': 1
}, {
  'code': '500100',
  'sheng': '50',
  'di': '01',
  'xian': '00',
  'name': '市辖区',
  'level': 2
}, {
  'code': '500101',
  'sheng': '50',
  'di': '01',
  'xian': '01',
  'name': '万州区',
  'level': 3
}, {
  'code': '500102',
  'sheng': '50',
  'di': '01',
  'xian': '02',
  'name': '涪陵区',
  'level': 3
}, {
  'code': '500103',
  'sheng': '50',
  'di': '01',
  'xian': '03',
  'name': '渝中区',
  'level': 3
}, {
  'code': '500104',
  'sheng': '50',
  'di': '01',
  'xian': '04',
  'name': '大渡口区',
  'level': 3
}, {
  'code': '500105',
  'sheng': '50',
  'di': '01',
  'xian': '05',
  'name': '江北区',
  'level': 3
}, {
  'code': '500106',
  'sheng': '50',
  'di': '01',
  'xian': '06',
  'name': '沙坪坝区',
  'level': 3
}, {
  'code': '500107',
  'sheng': '50',
  'di': '01',
  'xian': '07',
  'name': '九龙坡区',
  'level': 3
}, {
  'code': '500108',
  'sheng': '50',
  'di': '01',
  'xian': '08',
  'name': '南岸区',
  'level': 3
}, {
  'code': '500109',
  'sheng': '50',
  'di': '01',
  'xian': '09',
  'name': '北碚区',
  'level': 3
}, {
  'code': '500110',
  'sheng': '50',
  'di': '01',
  'xian': '10',
  'name': '綦江区',
  'level': 3
}, {
  'code': '500111',
  'sheng': '50',
  'di': '01',
  'xian': '11',
  'name': '大足区',
  'level': 3
}, {
  'code': '500112',
  'sheng': '50',
  'di': '01',
  'xian': '12',
  'name': '渝北区',
  'level': 3
}, {
  'code': '500113',
  'sheng': '50',
  'di': '01',
  'xian': '13',
  'name': '巴南区',
  'level': 3
}, {
  'code': '500114',
  'sheng': '50',
  'di': '01',
  'xian': '14',
  'name': '黔江区',
  'level': 3
}, {
  'code': '500115',
  'sheng': '50',
  'di': '01',
  'xian': '15',
  'name': '长寿区',
  'level': 3
}, {
  'code': '500116',
  'sheng': '50',
  'di': '01',
  'xian': '16',
  'name': '江津区',
  'level': 3
}, {
  'code': '500117',
  'sheng': '50',
  'di': '01',
  'xian': '17',
  'name': '合川区',
  'level': 3
}, {
  'code': '500118',
  'sheng': '50',
  'di': '01',
  'xian': '18',
  'name': '永川区',
  'level': 3
}, {
  'code': '500119',
  'sheng': '50',
  'di': '01',
  'xian': '19',
  'name': '南川区',
  'level': 3
}, {
  'code': '500120',
  'sheng': '50',
  'di': '01',
  'xian': '20',
  'name': '璧山区',
  'level': 3
}, {
  'code': '500151',
  'sheng': '50',
  'di': '01',
  'xian': '51',
  'name': '铜梁区',
  'level': 3
}, {
  'code': '500200',
  'sheng': '50',
  'di': '02',
  'xian': '00',
  'name': '县',
  'level': 2
}, {
  'code': '500223',
  'sheng': '50',
  'di': '02',
  'xian': '23',
  'name': '潼南县',
  'level': 3
}, {
  'code': '500226',
  'sheng': '50',
  'di': '02',
  'xian': '26',
  'name': '荣昌县',
  'level': 3
}, {
  'code': '500228',
  'sheng': '50',
  'di': '02',
  'xian': '28',
  'name': '梁平县',
  'level': 3
}, {
  'code': '500229',
  'sheng': '50',
  'di': '02',
  'xian': '29',
  'name': '城口县',
  'level': 3
}, {
  'code': '500230',
  'sheng': '50',
  'di': '02',
  'xian': '30',
  'name': '丰都县',
  'level': 3
}, {
  'code': '500231',
  'sheng': '50',
  'di': '02',
  'xian': '31',
  'name': '垫江县',
  'level': 3
}, {
  'code': '500232',
  'sheng': '50',
  'di': '02',
  'xian': '32',
  'name': '武隆县',
  'level': 3
}, {
  'code': '500233',
  'sheng': '50',
  'di': '02',
  'xian': '33',
  'name': '忠县',
  'level': 3
}, {
  'code': '500234',
  'sheng': '50',
  'di': '02',
  'xian': '34',
  'name': '开县',
  'level': 3
}, {
  'code': '500235',
  'sheng': '50',
  'di': '02',
  'xian': '35',
  'name': '云阳县',
  'level': 3
}, {
  'code': '500236',
  'sheng': '50',
  'di': '02',
  'xian': '36',
  'name': '奉节县',
  'level': 3
}, {
  'code': '500237',
  'sheng': '50',
  'di': '02',
  'xian': '37',
  'name': '巫山县',
  'level': 3
}, {
  'code': '500238',
  'sheng': '50',
  'di': '02',
  'xian': '38',
  'name': '巫溪县',
  'level': 3
}, {
  'code': '500240',
  'sheng': '50',
  'di': '02',
  'xian': '40',
  'name': '石柱土家族自治县',
  'level': 3
}, {
  'code': '500241',
  'sheng': '50',
  'di': '02',
  'xian': '41',
  'name': '秀山土家族苗族自治县',
  'level': 3
}, {
  'code': '500242',
  'sheng': '50',
  'di': '02',
  'xian': '42',
  'name': '酉阳土家族苗族自治县',
  'level': 3
}, {
  'code': '500243',
  'sheng': '50',
  'di': '02',
  'xian': '43',
  'name': '彭水苗族土家族自治县',
  'level': 3
}, {
  'code': '510000',
  'sheng': '51',
  'di': '00',
  'xian': '00',
  'name': '四川省',
  'level': 1
}, {
  'code': '510100',
  'sheng': '51',
  'di': '01',
  'xian': '00',
  'name': '成都市',
  'level': 2
}, {
  'code': '510101',
  'sheng': '51',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510104',
  'sheng': '51',
  'di': '01',
  'xian': '04',
  'name': '锦江区',
  'level': 3
}, {
  'code': '510105',
  'sheng': '51',
  'di': '01',
  'xian': '05',
  'name': '青羊区',
  'level': 3
}, {
  'code': '510106',
  'sheng': '51',
  'di': '01',
  'xian': '06',
  'name': '金牛区',
  'level': 3
}, {
  'code': '510107',
  'sheng': '51',
  'di': '01',
  'xian': '07',
  'name': '武侯区',
  'level': 3
}, {
  'code': '510108',
  'sheng': '51',
  'di': '01',
  'xian': '08',
  'name': '成华区',
  'level': 3
}, {
  'code': '510112',
  'sheng': '51',
  'di': '01',
  'xian': '12',
  'name': '龙泉驿区',
  'level': 3
}, {
  'code': '510113',
  'sheng': '51',
  'di': '01',
  'xian': '13',
  'name': '青白江区',
  'level': 3
}, {
  'code': '510114',
  'sheng': '51',
  'di': '01',
  'xian': '14',
  'name': '新都区',
  'level': 3
}, {
  'code': '510115',
  'sheng': '51',
  'di': '01',
  'xian': '15',
  'name': '温江区',
  'level': 3
}, {
  'code': '510121',
  'sheng': '51',
  'di': '01',
  'xian': '21',
  'name': '金堂县',
  'level': 3
}, {
  'code': '510122',
  'sheng': '51',
  'di': '01',
  'xian': '22',
  'name': '双流县',
  'level': 3
}, {
  'code': '510124',
  'sheng': '51',
  'di': '01',
  'xian': '24',
  'name': '郫县',
  'level': 3
}, {
  'code': '510129',
  'sheng': '51',
  'di': '01',
  'xian': '29',
  'name': '大邑县',
  'level': 3
}, {
  'code': '510131',
  'sheng': '51',
  'di': '01',
  'xian': '31',
  'name': '蒲江县',
  'level': 3
}, {
  'code': '510132',
  'sheng': '51',
  'di': '01',
  'xian': '32',
  'name': '新津县',
  'level': 3
}, {
  'code': '510181',
  'sheng': '51',
  'di': '01',
  'xian': '81',
  'name': '都江堰市',
  'level': 3
}, {
  'code': '510182',
  'sheng': '51',
  'di': '01',
  'xian': '82',
  'name': '彭州市',
  'level': 3
}, {
  'code': '510183',
  'sheng': '51',
  'di': '01',
  'xian': '83',
  'name': '邛崃市',
  'level': 3
}, {
  'code': '510184',
  'sheng': '51',
  'di': '01',
  'xian': '84',
  'name': '崇州市',
  'level': 3
}, {
  'code': '510300',
  'sheng': '51',
  'di': '03',
  'xian': '00',
  'name': '自贡市',
  'level': 2
}, {
  'code': '510301',
  'sheng': '51',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510302',
  'sheng': '51',
  'di': '03',
  'xian': '02',
  'name': '自流井区',
  'level': 3
}, {
  'code': '510303',
  'sheng': '51',
  'di': '03',
  'xian': '03',
  'name': '贡井区',
  'level': 3
}, {
  'code': '510304',
  'sheng': '51',
  'di': '03',
  'xian': '04',
  'name': '大安区',
  'level': 3
}, {
  'code': '510311',
  'sheng': '51',
  'di': '03',
  'xian': '11',
  'name': '沿滩区',
  'level': 3
}, {
  'code': '510321',
  'sheng': '51',
  'di': '03',
  'xian': '21',
  'name': '荣县',
  'level': 3
}, {
  'code': '510322',
  'sheng': '51',
  'di': '03',
  'xian': '22',
  'name': '富顺县',
  'level': 3
}, {
  'code': '510400',
  'sheng': '51',
  'di': '04',
  'xian': '00',
  'name': '攀枝花市',
  'level': 2
}, {
  'code': '510401',
  'sheng': '51',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510402',
  'sheng': '51',
  'di': '04',
  'xian': '02',
  'name': '东区',
  'level': 3
}, {
  'code': '510403',
  'sheng': '51',
  'di': '04',
  'xian': '03',
  'name': '西区',
  'level': 3
}, {
  'code': '510411',
  'sheng': '51',
  'di': '04',
  'xian': '11',
  'name': '仁和区',
  'level': 3
}, {
  'code': '510421',
  'sheng': '51',
  'di': '04',
  'xian': '21',
  'name': '米易县',
  'level': 3
}, {
  'code': '510422',
  'sheng': '51',
  'di': '04',
  'xian': '22',
  'name': '盐边县',
  'level': 3
}, {
  'code': '510500',
  'sheng': '51',
  'di': '05',
  'xian': '00',
  'name': '泸州市',
  'level': 2
}, {
  'code': '510501',
  'sheng': '51',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510502',
  'sheng': '51',
  'di': '05',
  'xian': '02',
  'name': '江阳区',
  'level': 3
}, {
  'code': '510503',
  'sheng': '51',
  'di': '05',
  'xian': '03',
  'name': '纳溪区',
  'level': 3
}, {
  'code': '510504',
  'sheng': '51',
  'di': '05',
  'xian': '04',
  'name': '龙马潭区',
  'level': 3
}, {
  'code': '510521',
  'sheng': '51',
  'di': '05',
  'xian': '21',
  'name': '泸县',
  'level': 3
}, {
  'code': '510522',
  'sheng': '51',
  'di': '05',
  'xian': '22',
  'name': '合江县',
  'level': 3
}, {
  'code': '510524',
  'sheng': '51',
  'di': '05',
  'xian': '24',
  'name': '叙永县',
  'level': 3
}, {
  'code': '510525',
  'sheng': '51',
  'di': '05',
  'xian': '25',
  'name': '古蔺县',
  'level': 3
}, {
  'code': '510600',
  'sheng': '51',
  'di': '06',
  'xian': '00',
  'name': '德阳市',
  'level': 2
}, {
  'code': '510601',
  'sheng': '51',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510603',
  'sheng': '51',
  'di': '06',
  'xian': '03',
  'name': '旌阳区',
  'level': 3
}, {
  'code': '510623',
  'sheng': '51',
  'di': '06',
  'xian': '23',
  'name': '中江县',
  'level': 3
}, {
  'code': '510626',
  'sheng': '51',
  'di': '06',
  'xian': '26',
  'name': '罗江县',
  'level': 3
}, {
  'code': '510681',
  'sheng': '51',
  'di': '06',
  'xian': '81',
  'name': '广汉市',
  'level': 3
}, {
  'code': '510682',
  'sheng': '51',
  'di': '06',
  'xian': '82',
  'name': '什邡市',
  'level': 3
}, {
  'code': '510683',
  'sheng': '51',
  'di': '06',
  'xian': '83',
  'name': '绵竹市',
  'level': 3
}, {
  'code': '510700',
  'sheng': '51',
  'di': '07',
  'xian': '00',
  'name': '绵阳市',
  'level': 2
}, {
  'code': '510701',
  'sheng': '51',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510703',
  'sheng': '51',
  'di': '07',
  'xian': '03',
  'name': '涪城区',
  'level': 3
}, {
  'code': '510704',
  'sheng': '51',
  'di': '07',
  'xian': '04',
  'name': '游仙区',
  'level': 3
}, {
  'code': '510722',
  'sheng': '51',
  'di': '07',
  'xian': '22',
  'name': '三台县',
  'level': 3
}, {
  'code': '510723',
  'sheng': '51',
  'di': '07',
  'xian': '23',
  'name': '盐亭县',
  'level': 3
}, {
  'code': '510724',
  'sheng': '51',
  'di': '07',
  'xian': '24',
  'name': '安县',
  'level': 3
}, {
  'code': '510725',
  'sheng': '51',
  'di': '07',
  'xian': '25',
  'name': '梓潼县',
  'level': 3
}, {
  'code': '510726',
  'sheng': '51',
  'di': '07',
  'xian': '26',
  'name': '北川羌族自治县',
  'level': 3
}, {
  'code': '510727',
  'sheng': '51',
  'di': '07',
  'xian': '27',
  'name': '平武县',
  'level': 3
}, {
  'code': '510781',
  'sheng': '51',
  'di': '07',
  'xian': '81',
  'name': '江油市',
  'level': 3
}, {
  'code': '510800',
  'sheng': '51',
  'di': '08',
  'xian': '00',
  'name': '广元市',
  'level': 2
}, {
  'code': '510801',
  'sheng': '51',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510802',
  'sheng': '51',
  'di': '08',
  'xian': '02',
  'name': '利州区',
  'level': 3
}, {
  'code': '510811',
  'sheng': '51',
  'di': '08',
  'xian': '11',
  'name': '昭化区',
  'level': 3
}, {
  'code': '510812',
  'sheng': '51',
  'di': '08',
  'xian': '12',
  'name': '朝天区',
  'level': 3
}, {
  'code': '510821',
  'sheng': '51',
  'di': '08',
  'xian': '21',
  'name': '旺苍县',
  'level': 3
}, {
  'code': '510822',
  'sheng': '51',
  'di': '08',
  'xian': '22',
  'name': '青川县',
  'level': 3
}, {
  'code': '510823',
  'sheng': '51',
  'di': '08',
  'xian': '23',
  'name': '剑阁县',
  'level': 3
}, {
  'code': '510824',
  'sheng': '51',
  'di': '08',
  'xian': '24',
  'name': '苍溪县',
  'level': 3
}, {
  'code': '510900',
  'sheng': '51',
  'di': '09',
  'xian': '00',
  'name': '遂宁市',
  'level': 2
}, {
  'code': '510901',
  'sheng': '51',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '510903',
  'sheng': '51',
  'di': '09',
  'xian': '03',
  'name': '船山区',
  'level': 3
}, {
  'code': '510904',
  'sheng': '51',
  'di': '09',
  'xian': '04',
  'name': '安居区',
  'level': 3
}, {
  'code': '510921',
  'sheng': '51',
  'di': '09',
  'xian': '21',
  'name': '蓬溪县',
  'level': 3
}, {
  'code': '510922',
  'sheng': '51',
  'di': '09',
  'xian': '22',
  'name': '射洪县',
  'level': 3
}, {
  'code': '510923',
  'sheng': '51',
  'di': '09',
  'xian': '23',
  'name': '大英县',
  'level': 3
}, {
  'code': '511000',
  'sheng': '51',
  'di': '10',
  'xian': '00',
  'name': '内江市',
  'level': 2
}, {
  'code': '511001',
  'sheng': '51',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511002',
  'sheng': '51',
  'di': '10',
  'xian': '02',
  'name': '市中区',
  'level': 3
}, {
  'code': '511011',
  'sheng': '51',
  'di': '10',
  'xian': '11',
  'name': '东兴区',
  'level': 3
}, {
  'code': '511024',
  'sheng': '51',
  'di': '10',
  'xian': '24',
  'name': '威远县',
  'level': 3
}, {
  'code': '511025',
  'sheng': '51',
  'di': '10',
  'xian': '25',
  'name': '资中县',
  'level': 3
}, {
  'code': '511028',
  'sheng': '51',
  'di': '10',
  'xian': '28',
  'name': '隆昌县',
  'level': 3
}, {
  'code': '511100',
  'sheng': '51',
  'di': '11',
  'xian': '00',
  'name': '乐山市',
  'level': 2
}, {
  'code': '511101',
  'sheng': '51',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511102',
  'sheng': '51',
  'di': '11',
  'xian': '02',
  'name': '市中区',
  'level': 3
}, {
  'code': '511111',
  'sheng': '51',
  'di': '11',
  'xian': '11',
  'name': '沙湾区',
  'level': 3
}, {
  'code': '511112',
  'sheng': '51',
  'di': '11',
  'xian': '12',
  'name': '五通桥区',
  'level': 3
}, {
  'code': '511113',
  'sheng': '51',
  'di': '11',
  'xian': '13',
  'name': '金口河区',
  'level': 3
}, {
  'code': '511123',
  'sheng': '51',
  'di': '11',
  'xian': '23',
  'name': '犍为县',
  'level': 3
}, {
  'code': '511124',
  'sheng': '51',
  'di': '11',
  'xian': '24',
  'name': '井研县',
  'level': 3
}, {
  'code': '511126',
  'sheng': '51',
  'di': '11',
  'xian': '26',
  'name': '夹江县',
  'level': 3
}, {
  'code': '511129',
  'sheng': '51',
  'di': '11',
  'xian': '29',
  'name': '沐川县',
  'level': 3
}, {
  'code': '511132',
  'sheng': '51',
  'di': '11',
  'xian': '32',
  'name': '峨边彝族自治县',
  'level': 3
}, {
  'code': '511133',
  'sheng': '51',
  'di': '11',
  'xian': '33',
  'name': '马边彝族自治县',
  'level': 3
}, {
  'code': '511181',
  'sheng': '51',
  'di': '11',
  'xian': '81',
  'name': '峨眉山市',
  'level': 3
}, {
  'code': '511300',
  'sheng': '51',
  'di': '13',
  'xian': '00',
  'name': '南充市',
  'level': 2
}, {
  'code': '511301',
  'sheng': '51',
  'di': '13',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511302',
  'sheng': '51',
  'di': '13',
  'xian': '02',
  'name': '顺庆区',
  'level': 3
}, {
  'code': '511303',
  'sheng': '51',
  'di': '13',
  'xian': '03',
  'name': '高坪区',
  'level': 3
}, {
  'code': '511304',
  'sheng': '51',
  'di': '13',
  'xian': '04',
  'name': '嘉陵区',
  'level': 3
}, {
  'code': '511321',
  'sheng': '51',
  'di': '13',
  'xian': '21',
  'name': '南部县',
  'level': 3
}, {
  'code': '511322',
  'sheng': '51',
  'di': '13',
  'xian': '22',
  'name': '营山县',
  'level': 3
}, {
  'code': '511323',
  'sheng': '51',
  'di': '13',
  'xian': '23',
  'name': '蓬安县',
  'level': 3
}, {
  'code': '511324',
  'sheng': '51',
  'di': '13',
  'xian': '24',
  'name': '仪陇县',
  'level': 3
}, {
  'code': '511325',
  'sheng': '51',
  'di': '13',
  'xian': '25',
  'name': '西充县',
  'level': 3
}, {
  'code': '511381',
  'sheng': '51',
  'di': '13',
  'xian': '81',
  'name': '阆中市',
  'level': 3
}, {
  'code': '511400',
  'sheng': '51',
  'di': '14',
  'xian': '00',
  'name': '眉山市',
  'level': 2
}, {
  'code': '511401',
  'sheng': '51',
  'di': '14',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511402',
  'sheng': '51',
  'di': '14',
  'xian': '02',
  'name': '东坡区',
  'level': 3
}, {
  'code': '511421',
  'sheng': '51',
  'di': '14',
  'xian': '21',
  'name': '仁寿县',
  'level': 3
}, {
  'code': '511422',
  'sheng': '51',
  'di': '14',
  'xian': '22',
  'name': '彭山县',
  'level': 3
}, {
  'code': '511423',
  'sheng': '51',
  'di': '14',
  'xian': '23',
  'name': '洪雅县',
  'level': 3
}, {
  'code': '511424',
  'sheng': '51',
  'di': '14',
  'xian': '24',
  'name': '丹棱县',
  'level': 3
}, {
  'code': '511425',
  'sheng': '51',
  'di': '14',
  'xian': '25',
  'name': '青神县',
  'level': 3
}, {
  'code': '511500',
  'sheng': '51',
  'di': '15',
  'xian': '00',
  'name': '宜宾市',
  'level': 2
}, {
  'code': '511501',
  'sheng': '51',
  'di': '15',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511502',
  'sheng': '51',
  'di': '15',
  'xian': '02',
  'name': '翠屏区',
  'level': 3
}, {
  'code': '511503',
  'sheng': '51',
  'di': '15',
  'xian': '03',
  'name': '南溪区',
  'level': 3
}, {
  'code': '511521',
  'sheng': '51',
  'di': '15',
  'xian': '21',
  'name': '宜宾县',
  'level': 3
}, {
  'code': '511523',
  'sheng': '51',
  'di': '15',
  'xian': '23',
  'name': '江安县',
  'level': 3
}, {
  'code': '511524',
  'sheng': '51',
  'di': '15',
  'xian': '24',
  'name': '长宁县',
  'level': 3
}, {
  'code': '511525',
  'sheng': '51',
  'di': '15',
  'xian': '25',
  'name': '高县',
  'level': 3
}, {
  'code': '511526',
  'sheng': '51',
  'di': '15',
  'xian': '26',
  'name': '珙县',
  'level': 3
}, {
  'code': '511527',
  'sheng': '51',
  'di': '15',
  'xian': '27',
  'name': '筠连县',
  'level': 3
}, {
  'code': '511528',
  'sheng': '51',
  'di': '15',
  'xian': '28',
  'name': '兴文县',
  'level': 3
}, {
  'code': '511529',
  'sheng': '51',
  'di': '15',
  'xian': '29',
  'name': '屏山县',
  'level': 3
}, {
  'code': '511600',
  'sheng': '51',
  'di': '16',
  'xian': '00',
  'name': '广安市',
  'level': 2
}, {
  'code': '511601',
  'sheng': '51',
  'di': '16',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511602',
  'sheng': '51',
  'di': '16',
  'xian': '02',
  'name': '广安区',
  'level': 3
}, {
  'code': '511603',
  'sheng': '51',
  'di': '16',
  'xian': '03',
  'name': '前锋区',
  'level': 3
}, {
  'code': '511621',
  'sheng': '51',
  'di': '16',
  'xian': '21',
  'name': '岳池县',
  'level': 3
}, {
  'code': '511622',
  'sheng': '51',
  'di': '16',
  'xian': '22',
  'name': '武胜县',
  'level': 3
}, {
  'code': '511623',
  'sheng': '51',
  'di': '16',
  'xian': '23',
  'name': '邻水县',
  'level': 3
}, {
  'code': '511681',
  'sheng': '51',
  'di': '16',
  'xian': '81',
  'name': '华蓥市',
  'level': 3
}, {
  'code': '511700',
  'sheng': '51',
  'di': '17',
  'xian': '00',
  'name': '达州市',
  'level': 2
}, {
  'code': '511701',
  'sheng': '51',
  'di': '17',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511702',
  'sheng': '51',
  'di': '17',
  'xian': '02',
  'name': '通川区',
  'level': 3
}, {
  'code': '511703',
  'sheng': '51',
  'di': '17',
  'xian': '03',
  'name': '达川区',
  'level': 3
}, {
  'code': '511722',
  'sheng': '51',
  'di': '17',
  'xian': '22',
  'name': '宣汉县',
  'level': 3
}, {
  'code': '511723',
  'sheng': '51',
  'di': '17',
  'xian': '23',
  'name': '开江县',
  'level': 3
}, {
  'code': '511724',
  'sheng': '51',
  'di': '17',
  'xian': '24',
  'name': '大竹县',
  'level': 3
}, {
  'code': '511725',
  'sheng': '51',
  'di': '17',
  'xian': '25',
  'name': '渠县',
  'level': 3
}, {
  'code': '511781',
  'sheng': '51',
  'di': '17',
  'xian': '81',
  'name': '万源市',
  'level': 3
}, {
  'code': '511800',
  'sheng': '51',
  'di': '18',
  'xian': '00',
  'name': '雅安市',
  'level': 2
}, {
  'code': '511801',
  'sheng': '51',
  'di': '18',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511802',
  'sheng': '51',
  'di': '18',
  'xian': '02',
  'name': '雨城区',
  'level': 3
}, {
  'code': '511803',
  'sheng': '51',
  'di': '18',
  'xian': '03',
  'name': '名山区',
  'level': 3
}, {
  'code': '511822',
  'sheng': '51',
  'di': '18',
  'xian': '22',
  'name': '荥经县',
  'level': 3
}, {
  'code': '511823',
  'sheng': '51',
  'di': '18',
  'xian': '23',
  'name': '汉源县',
  'level': 3
}, {
  'code': '511824',
  'sheng': '51',
  'di': '18',
  'xian': '24',
  'name': '石棉县',
  'level': 3
}, {
  'code': '511825',
  'sheng': '51',
  'di': '18',
  'xian': '25',
  'name': '天全县',
  'level': 3
}, {
  'code': '511826',
  'sheng': '51',
  'di': '18',
  'xian': '26',
  'name': '芦山县',
  'level': 3
}, {
  'code': '511827',
  'sheng': '51',
  'di': '18',
  'xian': '27',
  'name': '宝兴县',
  'level': 3
}, {
  'code': '511900',
  'sheng': '51',
  'di': '19',
  'xian': '00',
  'name': '巴中市',
  'level': 2
}, {
  'code': '511901',
  'sheng': '51',
  'di': '19',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '511902',
  'sheng': '51',
  'di': '19',
  'xian': '02',
  'name': '巴州区',
  'level': 3
}, {
  'code': '511903',
  'sheng': '51',
  'di': '19',
  'xian': '03',
  'name': '恩阳区',
  'level': 3
}, {
  'code': '511921',
  'sheng': '51',
  'di': '19',
  'xian': '21',
  'name': '通江县',
  'level': 3
}, {
  'code': '511922',
  'sheng': '51',
  'di': '19',
  'xian': '22',
  'name': '南江县',
  'level': 3
}, {
  'code': '511923',
  'sheng': '51',
  'di': '19',
  'xian': '23',
  'name': '平昌县',
  'level': 3
}, {
  'code': '512000',
  'sheng': '51',
  'di': '20',
  'xian': '00',
  'name': '资阳市',
  'level': 2
}, {
  'code': '512001',
  'sheng': '51',
  'di': '20',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '512002',
  'sheng': '51',
  'di': '20',
  'xian': '02',
  'name': '雁江区',
  'level': 3
}, {
  'code': '512021',
  'sheng': '51',
  'di': '20',
  'xian': '21',
  'name': '安岳县',
  'level': 3
}, {
  'code': '512022',
  'sheng': '51',
  'di': '20',
  'xian': '22',
  'name': '乐至县',
  'level': 3
}, {
  'code': '512081',
  'sheng': '51',
  'di': '20',
  'xian': '81',
  'name': '简阳市',
  'level': 3
}, {
  'code': '513200',
  'sheng': '51',
  'di': '32',
  'xian': '00',
  'name': '阿坝藏族羌族自治州',
  'level': 2
}, {
  'code': '513221',
  'sheng': '51',
  'di': '32',
  'xian': '21',
  'name': '汶川县',
  'level': 3
}, {
  'code': '513222',
  'sheng': '51',
  'di': '32',
  'xian': '22',
  'name': '理县',
  'level': 3
}, {
  'code': '513223',
  'sheng': '51',
  'di': '32',
  'xian': '23',
  'name': '茂县',
  'level': 3
}, {
  'code': '513224',
  'sheng': '51',
  'di': '32',
  'xian': '24',
  'name': '松潘县',
  'level': 3
}, {
  'code': '513225',
  'sheng': '51',
  'di': '32',
  'xian': '25',
  'name': '九寨沟县',
  'level': 3
}, {
  'code': '513226',
  'sheng': '51',
  'di': '32',
  'xian': '26',
  'name': '金川县',
  'level': 3
}, {
  'code': '513227',
  'sheng': '51',
  'di': '32',
  'xian': '27',
  'name': '小金县',
  'level': 3
}, {
  'code': '513228',
  'sheng': '51',
  'di': '32',
  'xian': '28',
  'name': '黑水县',
  'level': 3
}, {
  'code': '513229',
  'sheng': '51',
  'di': '32',
  'xian': '29',
  'name': '马尔康县',
  'level': 3
}, {
  'code': '513230',
  'sheng': '51',
  'di': '32',
  'xian': '30',
  'name': '壤塘县',
  'level': 3
}, {
  'code': '513231',
  'sheng': '51',
  'di': '32',
  'xian': '31',
  'name': '阿坝县',
  'level': 3
}, {
  'code': '513232',
  'sheng': '51',
  'di': '32',
  'xian': '32',
  'name': '若尔盖县',
  'level': 3
}, {
  'code': '513233',
  'sheng': '51',
  'di': '32',
  'xian': '33',
  'name': '红原县',
  'level': 3
}, {
  'code': '513300',
  'sheng': '51',
  'di': '33',
  'xian': '00',
  'name': '甘孜藏族自治州',
  'level': 2
}, {
  'code': '513321',
  'sheng': '51',
  'di': '33',
  'xian': '21',
  'name': '康定县',
  'level': 3
}, {
  'code': '513322',
  'sheng': '51',
  'di': '33',
  'xian': '22',
  'name': '泸定县',
  'level': 3
}, {
  'code': '513323',
  'sheng': '51',
  'di': '33',
  'xian': '23',
  'name': '丹巴县',
  'level': 3
}, {
  'code': '513324',
  'sheng': '51',
  'di': '33',
  'xian': '24',
  'name': '九龙县',
  'level': 3
}, {
  'code': '513325',
  'sheng': '51',
  'di': '33',
  'xian': '25',
  'name': '雅江县',
  'level': 3
}, {
  'code': '513326',
  'sheng': '51',
  'di': '33',
  'xian': '26',
  'name': '道孚县',
  'level': 3
}, {
  'code': '513327',
  'sheng': '51',
  'di': '33',
  'xian': '27',
  'name': '炉霍县',
  'level': 3
}, {
  'code': '513328',
  'sheng': '51',
  'di': '33',
  'xian': '28',
  'name': '甘孜县',
  'level': 3
}, {
  'code': '513329',
  'sheng': '51',
  'di': '33',
  'xian': '29',
  'name': '新龙县',
  'level': 3
}, {
  'code': '513330',
  'sheng': '51',
  'di': '33',
  'xian': '30',
  'name': '德格县',
  'level': 3
}, {
  'code': '513331',
  'sheng': '51',
  'di': '33',
  'xian': '31',
  'name': '白玉县',
  'level': 3
}, {
  'code': '513332',
  'sheng': '51',
  'di': '33',
  'xian': '32',
  'name': '石渠县',
  'level': 3
}, {
  'code': '513333',
  'sheng': '51',
  'di': '33',
  'xian': '33',
  'name': '色达县',
  'level': 3
}, {
  'code': '513334',
  'sheng': '51',
  'di': '33',
  'xian': '34',
  'name': '理塘县',
  'level': 3
}, {
  'code': '513335',
  'sheng': '51',
  'di': '33',
  'xian': '35',
  'name': '巴塘县',
  'level': 3
}, {
  'code': '513336',
  'sheng': '51',
  'di': '33',
  'xian': '36',
  'name': '乡城县',
  'level': 3
}, {
  'code': '513337',
  'sheng': '51',
  'di': '33',
  'xian': '37',
  'name': '稻城县',
  'level': 3
}, {
  'code': '513338',
  'sheng': '51',
  'di': '33',
  'xian': '38',
  'name': '得荣县',
  'level': 3
}, {
  'code': '513400',
  'sheng': '51',
  'di': '34',
  'xian': '00',
  'name': '凉山彝族自治州',
  'level': 2
}, {
  'code': '513401',
  'sheng': '51',
  'di': '34',
  'xian': '01',
  'name': '西昌市',
  'level': 3
}, {
  'code': '513422',
  'sheng': '51',
  'di': '34',
  'xian': '22',
  'name': '木里藏族自治县',
  'level': 3
}, {
  'code': '513423',
  'sheng': '51',
  'di': '34',
  'xian': '23',
  'name': '盐源县',
  'level': 3
}, {
  'code': '513424',
  'sheng': '51',
  'di': '34',
  'xian': '24',
  'name': '德昌县',
  'level': 3
}, {
  'code': '513425',
  'sheng': '51',
  'di': '34',
  'xian': '25',
  'name': '会理县',
  'level': 3
}, {
  'code': '513426',
  'sheng': '51',
  'di': '34',
  'xian': '26',
  'name': '会东县',
  'level': 3
}, {
  'code': '513427',
  'sheng': '51',
  'di': '34',
  'xian': '27',
  'name': '宁南县',
  'level': 3
}, {
  'code': '513428',
  'sheng': '51',
  'di': '34',
  'xian': '28',
  'name': '普格县',
  'level': 3
}, {
  'code': '513429',
  'sheng': '51',
  'di': '34',
  'xian': '29',
  'name': '布拖县',
  'level': 3
}, {
  'code': '513430',
  'sheng': '51',
  'di': '34',
  'xian': '30',
  'name': '金阳县',
  'level': 3
}, {
  'code': '513431',
  'sheng': '51',
  'di': '34',
  'xian': '31',
  'name': '昭觉县',
  'level': 3
}, {
  'code': '513432',
  'sheng': '51',
  'di': '34',
  'xian': '32',
  'name': '喜德县',
  'level': 3
}, {
  'code': '513433',
  'sheng': '51',
  'di': '34',
  'xian': '33',
  'name': '冕宁县',
  'level': 3
}, {
  'code': '513434',
  'sheng': '51',
  'di': '34',
  'xian': '34',
  'name': '越西县',
  'level': 3
}, {
  'code': '513435',
  'sheng': '51',
  'di': '34',
  'xian': '35',
  'name': '甘洛县',
  'level': 3
}, {
  'code': '513436',
  'sheng': '51',
  'di': '34',
  'xian': '36',
  'name': '美姑县',
  'level': 3
}, {
  'code': '513437',
  'sheng': '51',
  'di': '34',
  'xian': '37',
  'name': '雷波县',
  'level': 3
}, {
  'code': '520000',
  'sheng': '52',
  'di': '00',
  'xian': '00',
  'name': '贵州省',
  'level': 1
}, {
  'code': '520100',
  'sheng': '52',
  'di': '01',
  'xian': '00',
  'name': '贵阳市',
  'level': 2
}, {
  'code': '520101',
  'sheng': '52',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '520102',
  'sheng': '52',
  'di': '01',
  'xian': '02',
  'name': '南明区',
  'level': 3
}, {
  'code': '520103',
  'sheng': '52',
  'di': '01',
  'xian': '03',
  'name': '云岩区',
  'level': 3
}, {
  'code': '520111',
  'sheng': '52',
  'di': '01',
  'xian': '11',
  'name': '花溪区',
  'level': 3
}, {
  'code': '520112',
  'sheng': '52',
  'di': '01',
  'xian': '12',
  'name': '乌当区',
  'level': 3
}, {
  'code': '520113',
  'sheng': '52',
  'di': '01',
  'xian': '13',
  'name': '白云区',
  'level': 3
}, {
  'code': '520115',
  'sheng': '52',
  'di': '01',
  'xian': '15',
  'name': '观山湖区',
  'level': 3
}, {
  'code': '520121',
  'sheng': '52',
  'di': '01',
  'xian': '21',
  'name': '开阳县',
  'level': 3
}, {
  'code': '520122',
  'sheng': '52',
  'di': '01',
  'xian': '22',
  'name': '息烽县',
  'level': 3
}, {
  'code': '520123',
  'sheng': '52',
  'di': '01',
  'xian': '23',
  'name': '修文县',
  'level': 3
}, {
  'code': '520181',
  'sheng': '52',
  'di': '01',
  'xian': '81',
  'name': '清镇市',
  'level': 3
}, {
  'code': '520200',
  'sheng': '52',
  'di': '02',
  'xian': '00',
  'name': '六盘水市',
  'level': 2
}, {
  'code': '520201',
  'sheng': '52',
  'di': '02',
  'xian': '01',
  'name': '钟山区',
  'level': 3
}, {
  'code': '520203',
  'sheng': '52',
  'di': '02',
  'xian': '03',
  'name': '六枝特区',
  'level': 3
}, {
  'code': '520221',
  'sheng': '52',
  'di': '02',
  'xian': '21',
  'name': '水城县',
  'level': 3
}, {
  'code': '520222',
  'sheng': '52',
  'di': '02',
  'xian': '22',
  'name': '盘县',
  'level': 3
}, {
  'code': '520300',
  'sheng': '52',
  'di': '03',
  'xian': '00',
  'name': '遵义市',
  'level': 2
}, {
  'code': '520301',
  'sheng': '52',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '520302',
  'sheng': '52',
  'di': '03',
  'xian': '02',
  'name': '红花岗区',
  'level': 3
}, {
  'code': '520303',
  'sheng': '52',
  'di': '03',
  'xian': '03',
  'name': '汇川区',
  'level': 3
}, {
  'code': '520321',
  'sheng': '52',
  'di': '03',
  'xian': '21',
  'name': '遵义县',
  'level': 3
}, {
  'code': '520322',
  'sheng': '52',
  'di': '03',
  'xian': '22',
  'name': '桐梓县',
  'level': 3
}, {
  'code': '520323',
  'sheng': '52',
  'di': '03',
  'xian': '23',
  'name': '绥阳县',
  'level': 3
}, {
  'code': '520324',
  'sheng': '52',
  'di': '03',
  'xian': '24',
  'name': '正安县',
  'level': 3
}, {
  'code': '520325',
  'sheng': '52',
  'di': '03',
  'xian': '25',
  'name': '道真仡佬族苗族自治县',
  'level': 3
}, {
  'code': '520326',
  'sheng': '52',
  'di': '03',
  'xian': '26',
  'name': '务川仡佬族苗族自治县',
  'level': 3
}, {
  'code': '520327',
  'sheng': '52',
  'di': '03',
  'xian': '27',
  'name': '凤冈县',
  'level': 3
}, {
  'code': '520328',
  'sheng': '52',
  'di': '03',
  'xian': '28',
  'name': '湄潭县',
  'level': 3
}, {
  'code': '520329',
  'sheng': '52',
  'di': '03',
  'xian': '29',
  'name': '余庆县',
  'level': 3
}, {
  'code': '520330',
  'sheng': '52',
  'di': '03',
  'xian': '30',
  'name': '习水县',
  'level': 3
}, {
  'code': '520381',
  'sheng': '52',
  'di': '03',
  'xian': '81',
  'name': '赤水市',
  'level': 3
}, {
  'code': '520382',
  'sheng': '52',
  'di': '03',
  'xian': '82',
  'name': '仁怀市',
  'level': 3
}, {
  'code': '520400',
  'sheng': '52',
  'di': '04',
  'xian': '00',
  'name': '安顺市',
  'level': 2
}, {
  'code': '520401',
  'sheng': '52',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '520402',
  'sheng': '52',
  'di': '04',
  'xian': '02',
  'name': '西秀区',
  'level': 3
}, {
  'code': '520421',
  'sheng': '52',
  'di': '04',
  'xian': '21',
  'name': '平坝县',
  'level': 3
}, {
  'code': '520422',
  'sheng': '52',
  'di': '04',
  'xian': '22',
  'name': '普定县',
  'level': 3
}, {
  'code': '520423',
  'sheng': '52',
  'di': '04',
  'xian': '23',
  'name': '镇宁布依族苗族自治县',
  'level': 3
}, {
  'code': '520424',
  'sheng': '52',
  'di': '04',
  'xian': '24',
  'name': '关岭布依族苗族自治县',
  'level': 3
}, {
  'code': '520425',
  'sheng': '52',
  'di': '04',
  'xian': '25',
  'name': '紫云苗族布依族自治县',
  'level': 3
}, {
  'code': '520500',
  'sheng': '52',
  'di': '05',
  'xian': '00',
  'name': '毕节市',
  'level': 2
}, {
  'code': '520501',
  'sheng': '52',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '520502',
  'sheng': '52',
  'di': '05',
  'xian': '02',
  'name': '七星关区',
  'level': 3
}, {
  'code': '520521',
  'sheng': '52',
  'di': '05',
  'xian': '21',
  'name': '大方县',
  'level': 3
}, {
  'code': '520522',
  'sheng': '52',
  'di': '05',
  'xian': '22',
  'name': '黔西县',
  'level': 3
}, {
  'code': '520523',
  'sheng': '52',
  'di': '05',
  'xian': '23',
  'name': '金沙县',
  'level': 3
}, {
  'code': '520524',
  'sheng': '52',
  'di': '05',
  'xian': '24',
  'name': '织金县',
  'level': 3
}, {
  'code': '520525',
  'sheng': '52',
  'di': '05',
  'xian': '25',
  'name': '纳雍县',
  'level': 3
}, {
  'code': '520526',
  'sheng': '52',
  'di': '05',
  'xian': '26',
  'name': '威宁彝族回族苗族自治县',
  'level': 3
}, {
  'code': '520527',
  'sheng': '52',
  'di': '05',
  'xian': '27',
  'name': '赫章县',
  'level': 3
}, {
  'code': '520600',
  'sheng': '52',
  'di': '06',
  'xian': '00',
  'name': '铜仁市',
  'level': 2
}, {
  'code': '520601',
  'sheng': '52',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '520602',
  'sheng': '52',
  'di': '06',
  'xian': '02',
  'name': '碧江区',
  'level': 3
}, {
  'code': '520603',
  'sheng': '52',
  'di': '06',
  'xian': '03',
  'name': '万山区',
  'level': 3
}, {
  'code': '520621',
  'sheng': '52',
  'di': '06',
  'xian': '21',
  'name': '江口县',
  'level': 3
}, {
  'code': '520622',
  'sheng': '52',
  'di': '06',
  'xian': '22',
  'name': '玉屏侗族自治县',
  'level': 3
}, {
  'code': '520623',
  'sheng': '52',
  'di': '06',
  'xian': '23',
  'name': '石阡县',
  'level': 3
}, {
  'code': '520624',
  'sheng': '52',
  'di': '06',
  'xian': '24',
  'name': '思南县',
  'level': 3
}, {
  'code': '520625',
  'sheng': '52',
  'di': '06',
  'xian': '25',
  'name': '印江土家族苗族自治县',
  'level': 3
}, {
  'code': '520626',
  'sheng': '52',
  'di': '06',
  'xian': '26',
  'name': '德江县',
  'level': 3
}, {
  'code': '520627',
  'sheng': '52',
  'di': '06',
  'xian': '27',
  'name': '沿河土家族自治县',
  'level': 3
}, {
  'code': '520628',
  'sheng': '52',
  'di': '06',
  'xian': '28',
  'name': '松桃苗族自治县',
  'level': 3
}, {
  'code': '522300',
  'sheng': '52',
  'di': '23',
  'xian': '00',
  'name': '黔西南布依族苗族自治州',
  'level': 2
}, {
  'code': '522301',
  'sheng': '52',
  'di': '23',
  'xian': '01',
  'name': '兴义市',
  'level': 3
}, {
  'code': '522322',
  'sheng': '52',
  'di': '23',
  'xian': '22',
  'name': '兴仁县',
  'level': 3
}, {
  'code': '522323',
  'sheng': '52',
  'di': '23',
  'xian': '23',
  'name': '普安县',
  'level': 3
}, {
  'code': '522324',
  'sheng': '52',
  'di': '23',
  'xian': '24',
  'name': '晴隆县',
  'level': 3
}, {
  'code': '522325',
  'sheng': '52',
  'di': '23',
  'xian': '25',
  'name': '贞丰县',
  'level': 3
}, {
  'code': '522326',
  'sheng': '52',
  'di': '23',
  'xian': '26',
  'name': '望谟县',
  'level': 3
}, {
  'code': '522327',
  'sheng': '52',
  'di': '23',
  'xian': '27',
  'name': '册亨县',
  'level': 3
}, {
  'code': '522328',
  'sheng': '52',
  'di': '23',
  'xian': '28',
  'name': '安龙县',
  'level': 3
}, {
  'code': '522600',
  'sheng': '52',
  'di': '26',
  'xian': '00',
  'name': '黔东南苗族侗族自治州',
  'level': 2
}, {
  'code': '522601',
  'sheng': '52',
  'di': '26',
  'xian': '01',
  'name': '凯里市',
  'level': 3
}, {
  'code': '522622',
  'sheng': '52',
  'di': '26',
  'xian': '22',
  'name': '黄平县',
  'level': 3
}, {
  'code': '522623',
  'sheng': '52',
  'di': '26',
  'xian': '23',
  'name': '施秉县',
  'level': 3
}, {
  'code': '522624',
  'sheng': '52',
  'di': '26',
  'xian': '24',
  'name': '三穗县',
  'level': 3
}, {
  'code': '522625',
  'sheng': '52',
  'di': '26',
  'xian': '25',
  'name': '镇远县',
  'level': 3
}, {
  'code': '522626',
  'sheng': '52',
  'di': '26',
  'xian': '26',
  'name': '岑巩县',
  'level': 3
}, {
  'code': '522627',
  'sheng': '52',
  'di': '26',
  'xian': '27',
  'name': '天柱县',
  'level': 3
}, {
  'code': '522628',
  'sheng': '52',
  'di': '26',
  'xian': '28',
  'name': '锦屏县',
  'level': 3
}, {
  'code': '522629',
  'sheng': '52',
  'di': '26',
  'xian': '29',
  'name': '剑河县',
  'level': 3
}, {
  'code': '522630',
  'sheng': '52',
  'di': '26',
  'xian': '30',
  'name': '台江县',
  'level': 3
}, {
  'code': '522631',
  'sheng': '52',
  'di': '26',
  'xian': '31',
  'name': '黎平县',
  'level': 3
}, {
  'code': '522632',
  'sheng': '52',
  'di': '26',
  'xian': '32',
  'name': '榕江县',
  'level': 3
}, {
  'code': '522633',
  'sheng': '52',
  'di': '26',
  'xian': '33',
  'name': '从江县',
  'level': 3
}, {
  'code': '522634',
  'sheng': '52',
  'di': '26',
  'xian': '34',
  'name': '雷山县',
  'level': 3
}, {
  'code': '522635',
  'sheng': '52',
  'di': '26',
  'xian': '35',
  'name': '麻江县',
  'level': 3
}, {
  'code': '522636',
  'sheng': '52',
  'di': '26',
  'xian': '36',
  'name': '丹寨县',
  'level': 3
}, {
  'code': '522700',
  'sheng': '52',
  'di': '27',
  'xian': '00',
  'name': '黔南布依族苗族自治州',
  'level': 2
}, {
  'code': '522701',
  'sheng': '52',
  'di': '27',
  'xian': '01',
  'name': '都匀市',
  'level': 3
}, {
  'code': '522702',
  'sheng': '52',
  'di': '27',
  'xian': '02',
  'name': '福泉市',
  'level': 3
}, {
  'code': '522722',
  'sheng': '52',
  'di': '27',
  'xian': '22',
  'name': '荔波县',
  'level': 3
}, {
  'code': '522723',
  'sheng': '52',
  'di': '27',
  'xian': '23',
  'name': '贵定县',
  'level': 3
}, {
  'code': '522725',
  'sheng': '52',
  'di': '27',
  'xian': '25',
  'name': '瓮安县',
  'level': 3
}, {
  'code': '522726',
  'sheng': '52',
  'di': '27',
  'xian': '26',
  'name': '独山县',
  'level': 3
}, {
  'code': '522727',
  'sheng': '52',
  'di': '27',
  'xian': '27',
  'name': '平塘县',
  'level': 3
}, {
  'code': '522728',
  'sheng': '52',
  'di': '27',
  'xian': '28',
  'name': '罗甸县',
  'level': 3
}, {
  'code': '522729',
  'sheng': '52',
  'di': '27',
  'xian': '29',
  'name': '长顺县',
  'level': 3
}, {
  'code': '522730',
  'sheng': '52',
  'di': '27',
  'xian': '30',
  'name': '龙里县',
  'level': 3
}, {
  'code': '522731',
  'sheng': '52',
  'di': '27',
  'xian': '31',
  'name': '惠水县',
  'level': 3
}, {
  'code': '522732',
  'sheng': '52',
  'di': '27',
  'xian': '32',
  'name': '三都水族自治县',
  'level': 3
}, {
  'code': '530000',
  'sheng': '53',
  'di': '00',
  'xian': '00',
  'name': '云南省',
  'level': 1
}, {
  'code': '530100',
  'sheng': '53',
  'di': '01',
  'xian': '00',
  'name': '昆明市',
  'level': 2
}, {
  'code': '530101',
  'sheng': '53',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530102',
  'sheng': '53',
  'di': '01',
  'xian': '02',
  'name': '五华区',
  'level': 3
}, {
  'code': '530103',
  'sheng': '53',
  'di': '01',
  'xian': '03',
  'name': '盘龙区',
  'level': 3
}, {
  'code': '530111',
  'sheng': '53',
  'di': '01',
  'xian': '11',
  'name': '官渡区',
  'level': 3
}, {
  'code': '530112',
  'sheng': '53',
  'di': '01',
  'xian': '12',
  'name': '西山区',
  'level': 3
}, {
  'code': '530113',
  'sheng': '53',
  'di': '01',
  'xian': '13',
  'name': '东川区',
  'level': 3
}, {
  'code': '530114',
  'sheng': '53',
  'di': '01',
  'xian': '14',
  'name': '呈贡区',
  'level': 3
}, {
  'code': '530122',
  'sheng': '53',
  'di': '01',
  'xian': '22',
  'name': '晋宁县',
  'level': 3
}, {
  'code': '530124',
  'sheng': '53',
  'di': '01',
  'xian': '24',
  'name': '富民县',
  'level': 3
}, {
  'code': '530125',
  'sheng': '53',
  'di': '01',
  'xian': '25',
  'name': '宜良县',
  'level': 3
}, {
  'code': '530126',
  'sheng': '53',
  'di': '01',
  'xian': '26',
  'name': '石林彝族自治县',
  'level': 3
}, {
  'code': '530127',
  'sheng': '53',
  'di': '01',
  'xian': '27',
  'name': '嵩明县',
  'level': 3
}, {
  'code': '530128',
  'sheng': '53',
  'di': '01',
  'xian': '28',
  'name': '禄劝彝族苗族自治县',
  'level': 3
}, {
  'code': '530129',
  'sheng': '53',
  'di': '01',
  'xian': '29',
  'name': '寻甸回族彝族自治县',
  'level': 3
}, {
  'code': '530181',
  'sheng': '53',
  'di': '01',
  'xian': '81',
  'name': '安宁市',
  'level': 3
}, {
  'code': '530300',
  'sheng': '53',
  'di': '03',
  'xian': '00',
  'name': '曲靖市',
  'level': 2
}, {
  'code': '530301',
  'sheng': '53',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530302',
  'sheng': '53',
  'di': '03',
  'xian': '02',
  'name': '麒麟区',
  'level': 3
}, {
  'code': '530321',
  'sheng': '53',
  'di': '03',
  'xian': '21',
  'name': '马龙县',
  'level': 3
}, {
  'code': '530322',
  'sheng': '53',
  'di': '03',
  'xian': '22',
  'name': '陆良县',
  'level': 3
}, {
  'code': '530323',
  'sheng': '53',
  'di': '03',
  'xian': '23',
  'name': '师宗县',
  'level': 3
}, {
  'code': '530324',
  'sheng': '53',
  'di': '03',
  'xian': '24',
  'name': '罗平县',
  'level': 3
}, {
  'code': '530325',
  'sheng': '53',
  'di': '03',
  'xian': '25',
  'name': '富源县',
  'level': 3
}, {
  'code': '530326',
  'sheng': '53',
  'di': '03',
  'xian': '26',
  'name': '会泽县',
  'level': 3
}, {
  'code': '530328',
  'sheng': '53',
  'di': '03',
  'xian': '28',
  'name': '沾益县',
  'level': 3
}, {
  'code': '530381',
  'sheng': '53',
  'di': '03',
  'xian': '81',
  'name': '宣威市',
  'level': 3
}, {
  'code': '530400',
  'sheng': '53',
  'di': '04',
  'xian': '00',
  'name': '玉溪市',
  'level': 2
}, {
  'code': '530401',
  'sheng': '53',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530402',
  'sheng': '53',
  'di': '04',
  'xian': '02',
  'name': '红塔区',
  'level': 3
}, {
  'code': '530421',
  'sheng': '53',
  'di': '04',
  'xian': '21',
  'name': '江川县',
  'level': 3
}, {
  'code': '530422',
  'sheng': '53',
  'di': '04',
  'xian': '22',
  'name': '澄江县',
  'level': 3
}, {
  'code': '530423',
  'sheng': '53',
  'di': '04',
  'xian': '23',
  'name': '通海县',
  'level': 3
}, {
  'code': '530424',
  'sheng': '53',
  'di': '04',
  'xian': '24',
  'name': '华宁县',
  'level': 3
}, {
  'code': '530425',
  'sheng': '53',
  'di': '04',
  'xian': '25',
  'name': '易门县',
  'level': 3
}, {
  'code': '530426',
  'sheng': '53',
  'di': '04',
  'xian': '26',
  'name': '峨山彝族自治县',
  'level': 3
}, {
  'code': '530427',
  'sheng': '53',
  'di': '04',
  'xian': '27',
  'name': '新平彝族傣族自治县',
  'level': 3
}, {
  'code': '530428',
  'sheng': '53',
  'di': '04',
  'xian': '28',
  'name': '元江哈尼族彝族傣族自治县',
  'level': 3
}, {
  'code': '530500',
  'sheng': '53',
  'di': '05',
  'xian': '00',
  'name': '保山市',
  'level': 2
}, {
  'code': '530501',
  'sheng': '53',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530502',
  'sheng': '53',
  'di': '05',
  'xian': '02',
  'name': '隆阳区',
  'level': 3
}, {
  'code': '530521',
  'sheng': '53',
  'di': '05',
  'xian': '21',
  'name': '施甸县',
  'level': 3
}, {
  'code': '530522',
  'sheng': '53',
  'di': '05',
  'xian': '22',
  'name': '腾冲县',
  'level': 3
}, {
  'code': '530523',
  'sheng': '53',
  'di': '05',
  'xian': '23',
  'name': '龙陵县',
  'level': 3
}, {
  'code': '530524',
  'sheng': '53',
  'di': '05',
  'xian': '24',
  'name': '昌宁县',
  'level': 3
}, {
  'code': '530600',
  'sheng': '53',
  'di': '06',
  'xian': '00',
  'name': '昭通市',
  'level': 2
}, {
  'code': '530601',
  'sheng': '53',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530602',
  'sheng': '53',
  'di': '06',
  'xian': '02',
  'name': '昭阳区',
  'level': 3
}, {
  'code': '530621',
  'sheng': '53',
  'di': '06',
  'xian': '21',
  'name': '鲁甸县',
  'level': 3
}, {
  'code': '530622',
  'sheng': '53',
  'di': '06',
  'xian': '22',
  'name': '巧家县',
  'level': 3
}, {
  'code': '530623',
  'sheng': '53',
  'di': '06',
  'xian': '23',
  'name': '盐津县',
  'level': 3
}, {
  'code': '530624',
  'sheng': '53',
  'di': '06',
  'xian': '24',
  'name': '大关县',
  'level': 3
}, {
  'code': '530625',
  'sheng': '53',
  'di': '06',
  'xian': '25',
  'name': '永善县',
  'level': 3
}, {
  'code': '530626',
  'sheng': '53',
  'di': '06',
  'xian': '26',
  'name': '绥江县',
  'level': 3
}, {
  'code': '530627',
  'sheng': '53',
  'di': '06',
  'xian': '27',
  'name': '镇雄县',
  'level': 3
}, {
  'code': '530628',
  'sheng': '53',
  'di': '06',
  'xian': '28',
  'name': '彝良县',
  'level': 3
}, {
  'code': '530629',
  'sheng': '53',
  'di': '06',
  'xian': '29',
  'name': '威信县',
  'level': 3
}, {
  'code': '530630',
  'sheng': '53',
  'di': '06',
  'xian': '30',
  'name': '水富县',
  'level': 3
}, {
  'code': '530700',
  'sheng': '53',
  'di': '07',
  'xian': '00',
  'name': '丽江市',
  'level': 2
}, {
  'code': '530701',
  'sheng': '53',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530702',
  'sheng': '53',
  'di': '07',
  'xian': '02',
  'name': '古城区',
  'level': 3
}, {
  'code': '530721',
  'sheng': '53',
  'di': '07',
  'xian': '21',
  'name': '玉龙纳西族自治县',
  'level': 3
}, {
  'code': '530722',
  'sheng': '53',
  'di': '07',
  'xian': '22',
  'name': '永胜县',
  'level': 3
}, {
  'code': '530723',
  'sheng': '53',
  'di': '07',
  'xian': '23',
  'name': '华坪县',
  'level': 3
}, {
  'code': '530724',
  'sheng': '53',
  'di': '07',
  'xian': '24',
  'name': '宁蒗彝族自治县',
  'level': 3
}, {
  'code': '530800',
  'sheng': '53',
  'di': '08',
  'xian': '00',
  'name': '普洱市',
  'level': 2
}, {
  'code': '530801',
  'sheng': '53',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530802',
  'sheng': '53',
  'di': '08',
  'xian': '02',
  'name': '思茅区',
  'level': 3
}, {
  'code': '530821',
  'sheng': '53',
  'di': '08',
  'xian': '21',
  'name': '宁洱哈尼族彝族自治县',
  'level': 3
}, {
  'code': '530822',
  'sheng': '53',
  'di': '08',
  'xian': '22',
  'name': '墨江哈尼族自治县',
  'level': 3
}, {
  'code': '530823',
  'sheng': '53',
  'di': '08',
  'xian': '23',
  'name': '景东彝族自治县',
  'level': 3
}, {
  'code': '530824',
  'sheng': '53',
  'di': '08',
  'xian': '24',
  'name': '景谷傣族彝族自治县',
  'level': 3
}, {
  'code': '530825',
  'sheng': '53',
  'di': '08',
  'xian': '25',
  'name': '镇沅彝族哈尼族拉祜族自治县',
  'level': 3
}, {
  'code': '530826',
  'sheng': '53',
  'di': '08',
  'xian': '26',
  'name': '江城哈尼族彝族自治县',
  'level': 3
}, {
  'code': '530827',
  'sheng': '53',
  'di': '08',
  'xian': '27',
  'name': '孟连傣族拉祜族佤族自治县',
  'level': 3
}, {
  'code': '530828',
  'sheng': '53',
  'di': '08',
  'xian': '28',
  'name': '澜沧拉祜族自治县',
  'level': 3
}, {
  'code': '530829',
  'sheng': '53',
  'di': '08',
  'xian': '29',
  'name': '西盟佤族自治县',
  'level': 3
}, {
  'code': '530900',
  'sheng': '53',
  'di': '09',
  'xian': '00',
  'name': '临沧市',
  'level': 2
}, {
  'code': '530901',
  'sheng': '53',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '530902',
  'sheng': '53',
  'di': '09',
  'xian': '02',
  'name': '临翔区',
  'level': 3
}, {
  'code': '530921',
  'sheng': '53',
  'di': '09',
  'xian': '21',
  'name': '凤庆县',
  'level': 3
}, {
  'code': '530922',
  'sheng': '53',
  'di': '09',
  'xian': '22',
  'name': '云县',
  'level': 3
}, {
  'code': '530923',
  'sheng': '53',
  'di': '09',
  'xian': '23',
  'name': '永德县',
  'level': 3
}, {
  'code': '530924',
  'sheng': '53',
  'di': '09',
  'xian': '24',
  'name': '镇康县',
  'level': 3
}, {
  'code': '530925',
  'sheng': '53',
  'di': '09',
  'xian': '25',
  'name': '双江拉祜族佤族布朗族傣族自治县',
  'level': 3
}, {
  'code': '530926',
  'sheng': '53',
  'di': '09',
  'xian': '26',
  'name': '耿马傣族佤族自治县',
  'level': 3
}, {
  'code': '530927',
  'sheng': '53',
  'di': '09',
  'xian': '27',
  'name': '沧源佤族自治县',
  'level': 3
}, {
  'code': '532300',
  'sheng': '53',
  'di': '23',
  'xian': '00',
  'name': '楚雄彝族自治州',
  'level': 2
}, {
  'code': '532301',
  'sheng': '53',
  'di': '23',
  'xian': '01',
  'name': '楚雄市',
  'level': 3
}, {
  'code': '532322',
  'sheng': '53',
  'di': '23',
  'xian': '22',
  'name': '双柏县',
  'level': 3
}, {
  'code': '532323',
  'sheng': '53',
  'di': '23',
  'xian': '23',
  'name': '牟定县',
  'level': 3
}, {
  'code': '532324',
  'sheng': '53',
  'di': '23',
  'xian': '24',
  'name': '南华县',
  'level': 3
}, {
  'code': '532325',
  'sheng': '53',
  'di': '23',
  'xian': '25',
  'name': '姚安县',
  'level': 3
}, {
  'code': '532326',
  'sheng': '53',
  'di': '23',
  'xian': '26',
  'name': '大姚县',
  'level': 3
}, {
  'code': '532327',
  'sheng': '53',
  'di': '23',
  'xian': '27',
  'name': '永仁县',
  'level': 3
}, {
  'code': '532328',
  'sheng': '53',
  'di': '23',
  'xian': '28',
  'name': '元谋县',
  'level': 3
}, {
  'code': '532329',
  'sheng': '53',
  'di': '23',
  'xian': '29',
  'name': '武定县',
  'level': 3
}, {
  'code': '532331',
  'sheng': '53',
  'di': '23',
  'xian': '31',
  'name': '禄丰县',
  'level': 3
}, {
  'code': '532500',
  'sheng': '53',
  'di': '25',
  'xian': '00',
  'name': '红河哈尼族彝族自治州',
  'level': 2
}, {
  'code': '532501',
  'sheng': '53',
  'di': '25',
  'xian': '01',
  'name': '个旧市',
  'level': 3
}, {
  'code': '532502',
  'sheng': '53',
  'di': '25',
  'xian': '02',
  'name': '开远市',
  'level': 3
}, {
  'code': '532503',
  'sheng': '53',
  'di': '25',
  'xian': '03',
  'name': '蒙自市',
  'level': 3
}, {
  'code': '532504',
  'sheng': '53',
  'di': '25',
  'xian': '04',
  'name': '弥勒市',
  'level': 3
}, {
  'code': '532523',
  'sheng': '53',
  'di': '25',
  'xian': '23',
  'name': '屏边苗族自治县',
  'level': 3
}, {
  'code': '532524',
  'sheng': '53',
  'di': '25',
  'xian': '24',
  'name': '建水县',
  'level': 3
}, {
  'code': '532525',
  'sheng': '53',
  'di': '25',
  'xian': '25',
  'name': '石屏县',
  'level': 3
}, {
  'code': '532527',
  'sheng': '53',
  'di': '25',
  'xian': '27',
  'name': '泸西县',
  'level': 3
}, {
  'code': '532528',
  'sheng': '53',
  'di': '25',
  'xian': '28',
  'name': '元阳县',
  'level': 3
}, {
  'code': '532529',
  'sheng': '53',
  'di': '25',
  'xian': '29',
  'name': '红河县',
  'level': 3
}, {
  'code': '532530',
  'sheng': '53',
  'di': '25',
  'xian': '30',
  'name': '金平苗族瑶族傣族自治县',
  'level': 3
}, {
  'code': '532531',
  'sheng': '53',
  'di': '25',
  'xian': '31',
  'name': '绿春县',
  'level': 3
}, {
  'code': '532532',
  'sheng': '53',
  'di': '25',
  'xian': '32',
  'name': '河口瑶族自治县',
  'level': 3
}, {
  'code': '532600',
  'sheng': '53',
  'di': '26',
  'xian': '00',
  'name': '文山壮族苗族自治州',
  'level': 2
}, {
  'code': '532601',
  'sheng': '53',
  'di': '26',
  'xian': '01',
  'name': '文山市',
  'level': 3
}, {
  'code': '532622',
  'sheng': '53',
  'di': '26',
  'xian': '22',
  'name': '砚山县',
  'level': 3
}, {
  'code': '532623',
  'sheng': '53',
  'di': '26',
  'xian': '23',
  'name': '西畴县',
  'level': 3
}, {
  'code': '532624',
  'sheng': '53',
  'di': '26',
  'xian': '24',
  'name': '麻栗坡县',
  'level': 3
}, {
  'code': '532625',
  'sheng': '53',
  'di': '26',
  'xian': '25',
  'name': '马关县',
  'level': 3
}, {
  'code': '532626',
  'sheng': '53',
  'di': '26',
  'xian': '26',
  'name': '丘北县',
  'level': 3
}, {
  'code': '532627',
  'sheng': '53',
  'di': '26',
  'xian': '27',
  'name': '广南县',
  'level': 3
}, {
  'code': '532628',
  'sheng': '53',
  'di': '26',
  'xian': '28',
  'name': '富宁县',
  'level': 3
}, {
  'code': '532800',
  'sheng': '53',
  'di': '28',
  'xian': '00',
  'name': '西双版纳傣族自治州',
  'level': 2
}, {
  'code': '532801',
  'sheng': '53',
  'di': '28',
  'xian': '01',
  'name': '景洪市',
  'level': 3
}, {
  'code': '532822',
  'sheng': '53',
  'di': '28',
  'xian': '22',
  'name': '勐海县',
  'level': 3
}, {
  'code': '532823',
  'sheng': '53',
  'di': '28',
  'xian': '23',
  'name': '勐腊县',
  'level': 3
}, {
  'code': '532900',
  'sheng': '53',
  'di': '29',
  'xian': '00',
  'name': '大理白族自治州',
  'level': 2
}, {
  'code': '532901',
  'sheng': '53',
  'di': '29',
  'xian': '01',
  'name': '大理市',
  'level': 3
}, {
  'code': '532922',
  'sheng': '53',
  'di': '29',
  'xian': '22',
  'name': '漾濞彝族自治县',
  'level': 3
}, {
  'code': '532923',
  'sheng': '53',
  'di': '29',
  'xian': '23',
  'name': '祥云县',
  'level': 3
}, {
  'code': '532924',
  'sheng': '53',
  'di': '29',
  'xian': '24',
  'name': '宾川县',
  'level': 3
}, {
  'code': '532925',
  'sheng': '53',
  'di': '29',
  'xian': '25',
  'name': '弥渡县',
  'level': 3
}, {
  'code': '532926',
  'sheng': '53',
  'di': '29',
  'xian': '26',
  'name': '南涧彝族自治县',
  'level': 3
}, {
  'code': '532927',
  'sheng': '53',
  'di': '29',
  'xian': '27',
  'name': '巍山彝族回族自治县',
  'level': 3
}, {
  'code': '532928',
  'sheng': '53',
  'di': '29',
  'xian': '28',
  'name': '永平县',
  'level': 3
}, {
  'code': '532929',
  'sheng': '53',
  'di': '29',
  'xian': '29',
  'name': '云龙县',
  'level': 3
}, {
  'code': '532930',
  'sheng': '53',
  'di': '29',
  'xian': '30',
  'name': '洱源县',
  'level': 3
}, {
  'code': '532931',
  'sheng': '53',
  'di': '29',
  'xian': '31',
  'name': '剑川县',
  'level': 3
}, {
  'code': '532932',
  'sheng': '53',
  'di': '29',
  'xian': '32',
  'name': '鹤庆县',
  'level': 3
}, {
  'code': '533100',
  'sheng': '53',
  'di': '31',
  'xian': '00',
  'name': '德宏傣族景颇族自治州',
  'level': 2
}, {
  'code': '533102',
  'sheng': '53',
  'di': '31',
  'xian': '02',
  'name': '瑞丽市',
  'level': 3
}, {
  'code': '533103',
  'sheng': '53',
  'di': '31',
  'xian': '03',
  'name': '芒市',
  'level': 3
}, {
  'code': '533122',
  'sheng': '53',
  'di': '31',
  'xian': '22',
  'name': '梁河县',
  'level': 3
}, {
  'code': '533123',
  'sheng': '53',
  'di': '31',
  'xian': '23',
  'name': '盈江县',
  'level': 3
}, {
  'code': '533124',
  'sheng': '53',
  'di': '31',
  'xian': '24',
  'name': '陇川县',
  'level': 3
}, {
  'code': '533300',
  'sheng': '53',
  'di': '33',
  'xian': '00',
  'name': '怒江傈僳族自治州',
  'level': 2
}, {
  'code': '533321',
  'sheng': '53',
  'di': '33',
  'xian': '21',
  'name': '泸水县',
  'level': 3
}, {
  'code': '533323',
  'sheng': '53',
  'di': '33',
  'xian': '23',
  'name': '福贡县',
  'level': 3
}, {
  'code': '533324',
  'sheng': '53',
  'di': '33',
  'xian': '24',
  'name': '贡山独龙族怒族自治县',
  'level': 3
}, {
  'code': '533325',
  'sheng': '53',
  'di': '33',
  'xian': '25',
  'name': '兰坪白族普米族自治县',
  'level': 3
}, {
  'code': '533400',
  'sheng': '53',
  'di': '34',
  'xian': '00',
  'name': '迪庆藏族自治州',
  'level': 2
}, {
  'code': '533421',
  'sheng': '53',
  'di': '34',
  'xian': '21',
  'name': '香格里拉县',
  'level': 3
}, {
  'code': '533422',
  'sheng': '53',
  'di': '34',
  'xian': '22',
  'name': '德钦县',
  'level': 3
}, {
  'code': '533423',
  'sheng': '53',
  'di': '34',
  'xian': '23',
  'name': '维西傈僳族自治县',
  'level': 3
}, {
  'code': '540000',
  'sheng': '54',
  'di': '00',
  'xian': '00',
  'name': '西藏自治区',
  'level': 1
}, {
  'code': '540100',
  'sheng': '54',
  'di': '01',
  'xian': '00',
  'name': '拉萨市',
  'level': 2
}, {
  'code': '540101',
  'sheng': '54',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '540102',
  'sheng': '54',
  'di': '01',
  'xian': '02',
  'name': '城关区',
  'level': 3
}, {
  'code': '540121',
  'sheng': '54',
  'di': '01',
  'xian': '21',
  'name': '林周县',
  'level': 3
}, {
  'code': '540122',
  'sheng': '54',
  'di': '01',
  'xian': '22',
  'name': '当雄县',
  'level': 3
}, {
  'code': '540123',
  'sheng': '54',
  'di': '01',
  'xian': '23',
  'name': '尼木县',
  'level': 3
}, {
  'code': '540124',
  'sheng': '54',
  'di': '01',
  'xian': '24',
  'name': '曲水县',
  'level': 3
}, {
  'code': '540125',
  'sheng': '54',
  'di': '01',
  'xian': '25',
  'name': '堆龙德庆县',
  'level': 3
}, {
  'code': '540126',
  'sheng': '54',
  'di': '01',
  'xian': '26',
  'name': '达孜县',
  'level': 3
}, {
  'code': '540127',
  'sheng': '54',
  'di': '01',
  'xian': '27',
  'name': '墨竹工卡县',
  'level': 3
}, {
  'code': '540200',
  'sheng': '54',
  'di': '02',
  'xian': '00',
  'name': '日喀则市',
  'level': 2
}, {
  'code': '540202',
  'sheng': '54',
  'di': '02',
  'xian': '02',
  'name': '桑珠孜区',
  'level': 3
}, {
  'code': '540221',
  'sheng': '54',
  'di': '02',
  'xian': '21',
  'name': '南木林县',
  'level': 3
}, {
  'code': '540222',
  'sheng': '54',
  'di': '02',
  'xian': '22',
  'name': '江孜县',
  'level': 3
}, {
  'code': '540223',
  'sheng': '54',
  'di': '02',
  'xian': '23',
  'name': '定日县',
  'level': 3
}, {
  'code': '540224',
  'sheng': '54',
  'di': '02',
  'xian': '24',
  'name': '萨迦县',
  'level': 3
}, {
  'code': '540225',
  'sheng': '54',
  'di': '02',
  'xian': '25',
  'name': '拉孜县',
  'level': 3
}, {
  'code': '540226',
  'sheng': '54',
  'di': '02',
  'xian': '26',
  'name': '昂仁县',
  'level': 3
}, {
  'code': '540227',
  'sheng': '54',
  'di': '02',
  'xian': '27',
  'name': '谢通门县',
  'level': 3
}, {
  'code': '540228',
  'sheng': '54',
  'di': '02',
  'xian': '28',
  'name': '白朗县',
  'level': 3
}, {
  'code': '540229',
  'sheng': '54',
  'di': '02',
  'xian': '29',
  'name': '仁布县',
  'level': 3
}, {
  'code': '540230',
  'sheng': '54',
  'di': '02',
  'xian': '30',
  'name': '康马县',
  'level': 3
}, {
  'code': '540231',
  'sheng': '54',
  'di': '02',
  'xian': '31',
  'name': '定结县',
  'level': 3
}, {
  'code': '540232',
  'sheng': '54',
  'di': '02',
  'xian': '32',
  'name': '仲巴县',
  'level': 3
}, {
  'code': '540233',
  'sheng': '54',
  'di': '02',
  'xian': '33',
  'name': '亚东县',
  'level': 3
}, {
  'code': '540234',
  'sheng': '54',
  'di': '02',
  'xian': '34',
  'name': '吉隆县',
  'level': 3
}, {
  'code': '540235',
  'sheng': '54',
  'di': '02',
  'xian': '35',
  'name': '聂拉木县',
  'level': 3
}, {
  'code': '540236',
  'sheng': '54',
  'di': '02',
  'xian': '36',
  'name': '萨嘎县',
  'level': 3
}, {
  'code': '540237',
  'sheng': '54',
  'di': '02',
  'xian': '37',
  'name': '岗巴县',
  'level': 3
}, {
  'code': '542100',
  'sheng': '54',
  'di': '21',
  'xian': '00',
  'name': '昌都地区',
  'level': 2
}, {
  'code': '542121',
  'sheng': '54',
  'di': '21',
  'xian': '21',
  'name': '昌都县',
  'level': 3
}, {
  'code': '542122',
  'sheng': '54',
  'di': '21',
  'xian': '22',
  'name': '江达县',
  'level': 3
}, {
  'code': '542123',
  'sheng': '54',
  'di': '21',
  'xian': '23',
  'name': '贡觉县',
  'level': 3
}, {
  'code': '542124',
  'sheng': '54',
  'di': '21',
  'xian': '24',
  'name': '类乌齐县',
  'level': 3
}, {
  'code': '542125',
  'sheng': '54',
  'di': '21',
  'xian': '25',
  'name': '丁青县',
  'level': 3
}, {
  'code': '542126',
  'sheng': '54',
  'di': '21',
  'xian': '26',
  'name': '察雅县',
  'level': 3
}, {
  'code': '542127',
  'sheng': '54',
  'di': '21',
  'xian': '27',
  'name': '八宿县',
  'level': 3
}, {
  'code': '542128',
  'sheng': '54',
  'di': '21',
  'xian': '28',
  'name': '左贡县',
  'level': 3
}, {
  'code': '542129',
  'sheng': '54',
  'di': '21',
  'xian': '29',
  'name': '芒康县',
  'level': 3
}, {
  'code': '542132',
  'sheng': '54',
  'di': '21',
  'xian': '32',
  'name': '洛隆县',
  'level': 3
}, {
  'code': '542133',
  'sheng': '54',
  'di': '21',
  'xian': '33',
  'name': '边坝县',
  'level': 3
}, {
  'code': '542200',
  'sheng': '54',
  'di': '22',
  'xian': '00',
  'name': '山南地区',
  'level': 2
}, {
  'code': '542221',
  'sheng': '54',
  'di': '22',
  'xian': '21',
  'name': '乃东县',
  'level': 3
}, {
  'code': '542222',
  'sheng': '54',
  'di': '22',
  'xian': '22',
  'name': '扎囊县',
  'level': 3
}, {
  'code': '542223',
  'sheng': '54',
  'di': '22',
  'xian': '23',
  'name': '贡嘎县',
  'level': 3
}, {
  'code': '542224',
  'sheng': '54',
  'di': '22',
  'xian': '24',
  'name': '桑日县',
  'level': 3
}, {
  'code': '542225',
  'sheng': '54',
  'di': '22',
  'xian': '25',
  'name': '琼结县',
  'level': 3
}, {
  'code': '542226',
  'sheng': '54',
  'di': '22',
  'xian': '26',
  'name': '曲松县',
  'level': 3
}, {
  'code': '542227',
  'sheng': '54',
  'di': '22',
  'xian': '27',
  'name': '措美县',
  'level': 3
}, {
  'code': '542228',
  'sheng': '54',
  'di': '22',
  'xian': '28',
  'name': '洛扎县',
  'level': 3
}, {
  'code': '542229',
  'sheng': '54',
  'di': '22',
  'xian': '29',
  'name': '加查县',
  'level': 3
}, {
  'code': '542231',
  'sheng': '54',
  'di': '22',
  'xian': '31',
  'name': '隆子县',
  'level': 3
}, {
  'code': '542232',
  'sheng': '54',
  'di': '22',
  'xian': '32',
  'name': '错那县',
  'level': 3
}, {
  'code': '542233',
  'sheng': '54',
  'di': '22',
  'xian': '33',
  'name': '浪卡子县',
  'level': 3
}, {
  'code': '542400',
  'sheng': '54',
  'di': '24',
  'xian': '00',
  'name': '那曲地区',
  'level': 2
}, {
  'code': '542421',
  'sheng': '54',
  'di': '24',
  'xian': '21',
  'name': '那曲县',
  'level': 3
}, {
  'code': '542422',
  'sheng': '54',
  'di': '24',
  'xian': '22',
  'name': '嘉黎县',
  'level': 3
}, {
  'code': '542423',
  'sheng': '54',
  'di': '24',
  'xian': '23',
  'name': '比如县',
  'level': 3
}, {
  'code': '542424',
  'sheng': '54',
  'di': '24',
  'xian': '24',
  'name': '聂荣县',
  'level': 3
}, {
  'code': '542425',
  'sheng': '54',
  'di': '24',
  'xian': '25',
  'name': '安多县',
  'level': 3
}, {
  'code': '542426',
  'sheng': '54',
  'di': '24',
  'xian': '26',
  'name': '申扎县',
  'level': 3
}, {
  'code': '542427',
  'sheng': '54',
  'di': '24',
  'xian': '27',
  'name': '索县',
  'level': 3
}, {
  'code': '542428',
  'sheng': '54',
  'di': '24',
  'xian': '28',
  'name': '班戈县',
  'level': 3
}, {
  'code': '542429',
  'sheng': '54',
  'di': '24',
  'xian': '29',
  'name': '巴青县',
  'level': 3
}, {
  'code': '542430',
  'sheng': '54',
  'di': '24',
  'xian': '30',
  'name': '尼玛县',
  'level': 3
}, {
  'code': '542431',
  'sheng': '54',
  'di': '24',
  'xian': '31',
  'name': '双湖县',
  'level': 3
}, {
  'code': '542500',
  'sheng': '54',
  'di': '25',
  'xian': '00',
  'name': '阿里地区',
  'level': 2
}, {
  'code': '542521',
  'sheng': '54',
  'di': '25',
  'xian': '21',
  'name': '普兰县',
  'level': 3
}, {
  'code': '542522',
  'sheng': '54',
  'di': '25',
  'xian': '22',
  'name': '札达县',
  'level': 3
}, {
  'code': '542523',
  'sheng': '54',
  'di': '25',
  'xian': '23',
  'name': '噶尔县',
  'level': 3
}, {
  'code': '542524',
  'sheng': '54',
  'di': '25',
  'xian': '24',
  'name': '日土县',
  'level': 3
}, {
  'code': '542525',
  'sheng': '54',
  'di': '25',
  'xian': '25',
  'name': '革吉县',
  'level': 3
}, {
  'code': '542526',
  'sheng': '54',
  'di': '25',
  'xian': '26',
  'name': '改则县',
  'level': 3
}, {
  'code': '542527',
  'sheng': '54',
  'di': '25',
  'xian': '27',
  'name': '措勤县',
  'level': 3
}, {
  'code': '542600',
  'sheng': '54',
  'di': '26',
  'xian': '00',
  'name': '林芝地区',
  'level': 2
}, {
  'code': '542621',
  'sheng': '54',
  'di': '26',
  'xian': '21',
  'name': '林芝县',
  'level': 3
}, {
  'code': '542622',
  'sheng': '54',
  'di': '26',
  'xian': '22',
  'name': '工布江达县',
  'level': 3
}, {
  'code': '542623',
  'sheng': '54',
  'di': '26',
  'xian': '23',
  'name': '米林县',
  'level': 3
}, {
  'code': '542624',
  'sheng': '54',
  'di': '26',
  'xian': '24',
  'name': '墨脱县',
  'level': 3
}, {
  'code': '542625',
  'sheng': '54',
  'di': '26',
  'xian': '25',
  'name': '波密县',
  'level': 3
}, {
  'code': '542626',
  'sheng': '54',
  'di': '26',
  'xian': '26',
  'name': '察隅县',
  'level': 3
}, {
  'code': '542627',
  'sheng': '54',
  'di': '26',
  'xian': '27',
  'name': '朗县',
  'level': 3
}, {
  'code': '610000',
  'sheng': '61',
  'di': '00',
  'xian': '00',
  'name': '陕西省',
  'level': 1
}, {
  'code': '610100',
  'sheng': '61',
  'di': '01',
  'xian': '00',
  'name': '西安市',
  'level': 2
}, {
  'code': '610101',
  'sheng': '61',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610102',
  'sheng': '61',
  'di': '01',
  'xian': '02',
  'name': '新城区',
  'level': 3
}, {
  'code': '610103',
  'sheng': '61',
  'di': '01',
  'xian': '03',
  'name': '碑林区',
  'level': 3
}, {
  'code': '610104',
  'sheng': '61',
  'di': '01',
  'xian': '04',
  'name': '莲湖区',
  'level': 3
}, {
  'code': '610111',
  'sheng': '61',
  'di': '01',
  'xian': '11',
  'name': '灞桥区',
  'level': 3
}, {
  'code': '610112',
  'sheng': '61',
  'di': '01',
  'xian': '12',
  'name': '未央区',
  'level': 3
}, {
  'code': '610113',
  'sheng': '61',
  'di': '01',
  'xian': '13',
  'name': '雁塔区',
  'level': 3
}, {
  'code': '610114',
  'sheng': '61',
  'di': '01',
  'xian': '14',
  'name': '阎良区',
  'level': 3
}, {
  'code': '610115',
  'sheng': '61',
  'di': '01',
  'xian': '15',
  'name': '临潼区',
  'level': 3
}, {
  'code': '610116',
  'sheng': '61',
  'di': '01',
  'xian': '16',
  'name': '长安区',
  'level': 3
}, {
  'code': '610122',
  'sheng': '61',
  'di': '01',
  'xian': '22',
  'name': '蓝田县',
  'level': 3
}, {
  'code': '610124',
  'sheng': '61',
  'di': '01',
  'xian': '24',
  'name': '周至县',
  'level': 3
}, {
  'code': '610125',
  'sheng': '61',
  'di': '01',
  'xian': '25',
  'name': '户县',
  'level': 3
}, {
  'code': '610126',
  'sheng': '61',
  'di': '01',
  'xian': '26',
  'name': '高陵县',
  'level': 3
}, {
  'code': '610200',
  'sheng': '61',
  'di': '02',
  'xian': '00',
  'name': '铜川市',
  'level': 2
}, {
  'code': '610201',
  'sheng': '61',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610202',
  'sheng': '61',
  'di': '02',
  'xian': '02',
  'name': '王益区',
  'level': 3
}, {
  'code': '610203',
  'sheng': '61',
  'di': '02',
  'xian': '03',
  'name': '印台区',
  'level': 3
}, {
  'code': '610204',
  'sheng': '61',
  'di': '02',
  'xian': '04',
  'name': '耀州区',
  'level': 3
}, {
  'code': '610222',
  'sheng': '61',
  'di': '02',
  'xian': '22',
  'name': '宜君县',
  'level': 3
}, {
  'code': '610300',
  'sheng': '61',
  'di': '03',
  'xian': '00',
  'name': '宝鸡市',
  'level': 2
}, {
  'code': '610301',
  'sheng': '61',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610302',
  'sheng': '61',
  'di': '03',
  'xian': '02',
  'name': '渭滨区',
  'level': 3
}, {
  'code': '610303',
  'sheng': '61',
  'di': '03',
  'xian': '03',
  'name': '金台区',
  'level': 3
}, {
  'code': '610304',
  'sheng': '61',
  'di': '03',
  'xian': '04',
  'name': '陈仓区',
  'level': 3
}, {
  'code': '610322',
  'sheng': '61',
  'di': '03',
  'xian': '22',
  'name': '凤翔县',
  'level': 3
}, {
  'code': '610323',
  'sheng': '61',
  'di': '03',
  'xian': '23',
  'name': '岐山县',
  'level': 3
}, {
  'code': '610324',
  'sheng': '61',
  'di': '03',
  'xian': '24',
  'name': '扶风县',
  'level': 3
}, {
  'code': '610326',
  'sheng': '61',
  'di': '03',
  'xian': '26',
  'name': '眉县',
  'level': 3
}, {
  'code': '610327',
  'sheng': '61',
  'di': '03',
  'xian': '27',
  'name': '陇县',
  'level': 3
}, {
  'code': '610328',
  'sheng': '61',
  'di': '03',
  'xian': '28',
  'name': '千阳县',
  'level': 3
}, {
  'code': '610329',
  'sheng': '61',
  'di': '03',
  'xian': '29',
  'name': '麟游县',
  'level': 3
}, {
  'code': '610330',
  'sheng': '61',
  'di': '03',
  'xian': '30',
  'name': '凤县',
  'level': 3
}, {
  'code': '610331',
  'sheng': '61',
  'di': '03',
  'xian': '31',
  'name': '太白县',
  'level': 3
}, {
  'code': '610400',
  'sheng': '61',
  'di': '04',
  'xian': '00',
  'name': '咸阳市',
  'level': 2
}, {
  'code': '610401',
  'sheng': '61',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610402',
  'sheng': '61',
  'di': '04',
  'xian': '02',
  'name': '秦都区',
  'level': 3
}, {
  'code': '610403',
  'sheng': '61',
  'di': '04',
  'xian': '03',
  'name': '杨陵区',
  'level': 3
}, {
  'code': '610404',
  'sheng': '61',
  'di': '04',
  'xian': '04',
  'name': '渭城区',
  'level': 3
}, {
  'code': '610422',
  'sheng': '61',
  'di': '04',
  'xian': '22',
  'name': '三原县',
  'level': 3
}, {
  'code': '610423',
  'sheng': '61',
  'di': '04',
  'xian': '23',
  'name': '泾阳县',
  'level': 3
}, {
  'code': '610424',
  'sheng': '61',
  'di': '04',
  'xian': '24',
  'name': '乾县',
  'level': 3
}, {
  'code': '610425',
  'sheng': '61',
  'di': '04',
  'xian': '25',
  'name': '礼泉县',
  'level': 3
}, {
  'code': '610426',
  'sheng': '61',
  'di': '04',
  'xian': '26',
  'name': '永寿县',
  'level': 3
}, {
  'code': '610427',
  'sheng': '61',
  'di': '04',
  'xian': '27',
  'name': '彬县',
  'level': 3
}, {
  'code': '610428',
  'sheng': '61',
  'di': '04',
  'xian': '28',
  'name': '长武县',
  'level': 3
}, {
  'code': '610429',
  'sheng': '61',
  'di': '04',
  'xian': '29',
  'name': '旬邑县',
  'level': 3
}, {
  'code': '610430',
  'sheng': '61',
  'di': '04',
  'xian': '30',
  'name': '淳化县',
  'level': 3
}, {
  'code': '610431',
  'sheng': '61',
  'di': '04',
  'xian': '31',
  'name': '武功县',
  'level': 3
}, {
  'code': '610481',
  'sheng': '61',
  'di': '04',
  'xian': '81',
  'name': '兴平市',
  'level': 3
}, {
  'code': '610500',
  'sheng': '61',
  'di': '05',
  'xian': '00',
  'name': '渭南市',
  'level': 2
}, {
  'code': '610501',
  'sheng': '61',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610502',
  'sheng': '61',
  'di': '05',
  'xian': '02',
  'name': '临渭区',
  'level': 3
}, {
  'code': '610521',
  'sheng': '61',
  'di': '05',
  'xian': '21',
  'name': '华县',
  'level': 3
}, {
  'code': '610522',
  'sheng': '61',
  'di': '05',
  'xian': '22',
  'name': '潼关县',
  'level': 3
}, {
  'code': '610523',
  'sheng': '61',
  'di': '05',
  'xian': '23',
  'name': '大荔县',
  'level': 3
}, {
  'code': '610524',
  'sheng': '61',
  'di': '05',
  'xian': '24',
  'name': '合阳县',
  'level': 3
}, {
  'code': '610525',
  'sheng': '61',
  'di': '05',
  'xian': '25',
  'name': '澄城县',
  'level': 3
}, {
  'code': '610526',
  'sheng': '61',
  'di': '05',
  'xian': '26',
  'name': '蒲城县',
  'level': 3
}, {
  'code': '610527',
  'sheng': '61',
  'di': '05',
  'xian': '27',
  'name': '白水县',
  'level': 3
}, {
  'code': '610528',
  'sheng': '61',
  'di': '05',
  'xian': '28',
  'name': '富平县',
  'level': 3
}, {
  'code': '610581',
  'sheng': '61',
  'di': '05',
  'xian': '81',
  'name': '韩城市',
  'level': 3
}, {
  'code': '610582',
  'sheng': '61',
  'di': '05',
  'xian': '82',
  'name': '华阴市',
  'level': 3
}, {
  'code': '610600',
  'sheng': '61',
  'di': '06',
  'xian': '00',
  'name': '延安市',
  'level': 2
}, {
  'code': '610601',
  'sheng': '61',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610602',
  'sheng': '61',
  'di': '06',
  'xian': '02',
  'name': '宝塔区',
  'level': 3
}, {
  'code': '610621',
  'sheng': '61',
  'di': '06',
  'xian': '21',
  'name': '延长县',
  'level': 3
}, {
  'code': '610622',
  'sheng': '61',
  'di': '06',
  'xian': '22',
  'name': '延川县',
  'level': 3
}, {
  'code': '610623',
  'sheng': '61',
  'di': '06',
  'xian': '23',
  'name': '子长县',
  'level': 3
}, {
  'code': '610624',
  'sheng': '61',
  'di': '06',
  'xian': '24',
  'name': '安塞县',
  'level': 3
}, {
  'code': '610625',
  'sheng': '61',
  'di': '06',
  'xian': '25',
  'name': '志丹县',
  'level': 3
}, {
  'code': '610626',
  'sheng': '61',
  'di': '06',
  'xian': '26',
  'name': '吴起县',
  'level': 3
}, {
  'code': '610627',
  'sheng': '61',
  'di': '06',
  'xian': '27',
  'name': '甘泉县',
  'level': 3
}, {
  'code': '610628',
  'sheng': '61',
  'di': '06',
  'xian': '28',
  'name': '富县',
  'level': 3
}, {
  'code': '610629',
  'sheng': '61',
  'di': '06',
  'xian': '29',
  'name': '洛川县',
  'level': 3
}, {
  'code': '610630',
  'sheng': '61',
  'di': '06',
  'xian': '30',
  'name': '宜川县',
  'level': 3
}, {
  'code': '610631',
  'sheng': '61',
  'di': '06',
  'xian': '31',
  'name': '黄龙县',
  'level': 3
}, {
  'code': '610632',
  'sheng': '61',
  'di': '06',
  'xian': '32',
  'name': '黄陵县',
  'level': 3
}, {
  'code': '610700',
  'sheng': '61',
  'di': '07',
  'xian': '00',
  'name': '汉中市',
  'level': 2
}, {
  'code': '610701',
  'sheng': '61',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610702',
  'sheng': '61',
  'di': '07',
  'xian': '02',
  'name': '汉台区',
  'level': 3
}, {
  'code': '610721',
  'sheng': '61',
  'di': '07',
  'xian': '21',
  'name': '南郑县',
  'level': 3
}, {
  'code': '610722',
  'sheng': '61',
  'di': '07',
  'xian': '22',
  'name': '城固县',
  'level': 3
}, {
  'code': '610723',
  'sheng': '61',
  'di': '07',
  'xian': '23',
  'name': '洋县',
  'level': 3
}, {
  'code': '610724',
  'sheng': '61',
  'di': '07',
  'xian': '24',
  'name': '西乡县',
  'level': 3
}, {
  'code': '610725',
  'sheng': '61',
  'di': '07',
  'xian': '25',
  'name': '勉县',
  'level': 3
}, {
  'code': '610726',
  'sheng': '61',
  'di': '07',
  'xian': '26',
  'name': '宁强县',
  'level': 3
}, {
  'code': '610727',
  'sheng': '61',
  'di': '07',
  'xian': '27',
  'name': '略阳县',
  'level': 3
}, {
  'code': '610728',
  'sheng': '61',
  'di': '07',
  'xian': '28',
  'name': '镇巴县',
  'level': 3
}, {
  'code': '610729',
  'sheng': '61',
  'di': '07',
  'xian': '29',
  'name': '留坝县',
  'level': 3
}, {
  'code': '610730',
  'sheng': '61',
  'di': '07',
  'xian': '30',
  'name': '佛坪县',
  'level': 3
}, {
  'code': '610800',
  'sheng': '61',
  'di': '08',
  'xian': '00',
  'name': '榆林市',
  'level': 2
}, {
  'code': '610801',
  'sheng': '61',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610802',
  'sheng': '61',
  'di': '08',
  'xian': '02',
  'name': '榆阳区',
  'level': 3
}, {
  'code': '610821',
  'sheng': '61',
  'di': '08',
  'xian': '21',
  'name': '神木县',
  'level': 3
}, {
  'code': '610822',
  'sheng': '61',
  'di': '08',
  'xian': '22',
  'name': '府谷县',
  'level': 3
}, {
  'code': '610823',
  'sheng': '61',
  'di': '08',
  'xian': '23',
  'name': '横山县',
  'level': 3
}, {
  'code': '610824',
  'sheng': '61',
  'di': '08',
  'xian': '24',
  'name': '靖边县',
  'level': 3
}, {
  'code': '610825',
  'sheng': '61',
  'di': '08',
  'xian': '25',
  'name': '定边县',
  'level': 3
}, {
  'code': '610826',
  'sheng': '61',
  'di': '08',
  'xian': '26',
  'name': '绥德县',
  'level': 3
}, {
  'code': '610827',
  'sheng': '61',
  'di': '08',
  'xian': '27',
  'name': '米脂县',
  'level': 3
}, {
  'code': '610828',
  'sheng': '61',
  'di': '08',
  'xian': '28',
  'name': '佳县',
  'level': 3
}, {
  'code': '610829',
  'sheng': '61',
  'di': '08',
  'xian': '29',
  'name': '吴堡县',
  'level': 3
}, {
  'code': '610830',
  'sheng': '61',
  'di': '08',
  'xian': '30',
  'name': '清涧县',
  'level': 3
}, {
  'code': '610831',
  'sheng': '61',
  'di': '08',
  'xian': '31',
  'name': '子洲县',
  'level': 3
}, {
  'code': '610900',
  'sheng': '61',
  'di': '09',
  'xian': '00',
  'name': '安康市',
  'level': 2
}, {
  'code': '610901',
  'sheng': '61',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '610902',
  'sheng': '61',
  'di': '09',
  'xian': '02',
  'name': '汉滨区',
  'level': 3
}, {
  'code': '610921',
  'sheng': '61',
  'di': '09',
  'xian': '21',
  'name': '汉阴县',
  'level': 3
}, {
  'code': '610922',
  'sheng': '61',
  'di': '09',
  'xian': '22',
  'name': '石泉县',
  'level': 3
}, {
  'code': '610923',
  'sheng': '61',
  'di': '09',
  'xian': '23',
  'name': '宁陕县',
  'level': 3
}, {
  'code': '610924',
  'sheng': '61',
  'di': '09',
  'xian': '24',
  'name': '紫阳县',
  'level': 3
}, {
  'code': '610925',
  'sheng': '61',
  'di': '09',
  'xian': '25',
  'name': '岚皋县',
  'level': 3
}, {
  'code': '610926',
  'sheng': '61',
  'di': '09',
  'xian': '26',
  'name': '平利县',
  'level': 3
}, {
  'code': '610927',
  'sheng': '61',
  'di': '09',
  'xian': '27',
  'name': '镇坪县',
  'level': 3
}, {
  'code': '610928',
  'sheng': '61',
  'di': '09',
  'xian': '28',
  'name': '旬阳县',
  'level': 3
}, {
  'code': '610929',
  'sheng': '61',
  'di': '09',
  'xian': '29',
  'name': '白河县',
  'level': 3
}, {
  'code': '611000',
  'sheng': '61',
  'di': '10',
  'xian': '00',
  'name': '商洛市',
  'level': 2
}, {
  'code': '611001',
  'sheng': '61',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '611002',
  'sheng': '61',
  'di': '10',
  'xian': '02',
  'name': '商州区',
  'level': 3
}, {
  'code': '611021',
  'sheng': '61',
  'di': '10',
  'xian': '21',
  'name': '洛南县',
  'level': 3
}, {
  'code': '611022',
  'sheng': '61',
  'di': '10',
  'xian': '22',
  'name': '丹凤县',
  'level': 3
}, {
  'code': '611023',
  'sheng': '61',
  'di': '10',
  'xian': '23',
  'name': '商南县',
  'level': 3
}, {
  'code': '611024',
  'sheng': '61',
  'di': '10',
  'xian': '24',
  'name': '山阳县',
  'level': 3
}, {
  'code': '611025',
  'sheng': '61',
  'di': '10',
  'xian': '25',
  'name': '镇安县',
  'level': 3
}, {
  'code': '611026',
  'sheng': '61',
  'di': '10',
  'xian': '26',
  'name': '柞水县',
  'level': 3
}, {
  'code': '620000',
  'sheng': '62',
  'di': '00',
  'xian': '00',
  'name': '甘肃省',
  'level': 1
}, {
  'code': '620100',
  'sheng': '62',
  'di': '01',
  'xian': '00',
  'name': '兰州市',
  'level': 2
}, {
  'code': '620101',
  'sheng': '62',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620102',
  'sheng': '62',
  'di': '01',
  'xian': '02',
  'name': '城关区',
  'level': 3
}, {
  'code': '620103',
  'sheng': '62',
  'di': '01',
  'xian': '03',
  'name': '七里河区',
  'level': 3
}, {
  'code': '620104',
  'sheng': '62',
  'di': '01',
  'xian': '04',
  'name': '西固区',
  'level': 3
}, {
  'code': '620105',
  'sheng': '62',
  'di': '01',
  'xian': '05',
  'name': '安宁区',
  'level': 3
}, {
  'code': '620111',
  'sheng': '62',
  'di': '01',
  'xian': '11',
  'name': '红古区',
  'level': 3
}, {
  'code': '620121',
  'sheng': '62',
  'di': '01',
  'xian': '21',
  'name': '永登县',
  'level': 3
}, {
  'code': '620122',
  'sheng': '62',
  'di': '01',
  'xian': '22',
  'name': '皋兰县',
  'level': 3
}, {
  'code': '620123',
  'sheng': '62',
  'di': '01',
  'xian': '23',
  'name': '榆中县',
  'level': 3
}, {
  'code': '620200',
  'sheng': '62',
  'di': '02',
  'xian': '00',
  'name': '嘉峪关市',
  'level': 2
}, {
  'code': '620201',
  'sheng': '62',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620300',
  'sheng': '62',
  'di': '03',
  'xian': '00',
  'name': '金昌市',
  'level': 2
}, {
  'code': '620301',
  'sheng': '62',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620302',
  'sheng': '62',
  'di': '03',
  'xian': '02',
  'name': '金川区',
  'level': 3
}, {
  'code': '620321',
  'sheng': '62',
  'di': '03',
  'xian': '21',
  'name': '永昌县',
  'level': 3
}, {
  'code': '620400',
  'sheng': '62',
  'di': '04',
  'xian': '00',
  'name': '白银市',
  'level': 2
}, {
  'code': '620401',
  'sheng': '62',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620402',
  'sheng': '62',
  'di': '04',
  'xian': '02',
  'name': '白银区',
  'level': 3
}, {
  'code': '620403',
  'sheng': '62',
  'di': '04',
  'xian': '03',
  'name': '平川区',
  'level': 3
}, {
  'code': '620421',
  'sheng': '62',
  'di': '04',
  'xian': '21',
  'name': '靖远县',
  'level': 3
}, {
  'code': '620422',
  'sheng': '62',
  'di': '04',
  'xian': '22',
  'name': '会宁县',
  'level': 3
}, {
  'code': '620423',
  'sheng': '62',
  'di': '04',
  'xian': '23',
  'name': '景泰县',
  'level': 3
}, {
  'code': '620500',
  'sheng': '62',
  'di': '05',
  'xian': '00',
  'name': '天水市',
  'level': 2
}, {
  'code': '620501',
  'sheng': '62',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620502',
  'sheng': '62',
  'di': '05',
  'xian': '02',
  'name': '秦州区',
  'level': 3
}, {
  'code': '620503',
  'sheng': '62',
  'di': '05',
  'xian': '03',
  'name': '麦积区',
  'level': 3
}, {
  'code': '620521',
  'sheng': '62',
  'di': '05',
  'xian': '21',
  'name': '清水县',
  'level': 3
}, {
  'code': '620522',
  'sheng': '62',
  'di': '05',
  'xian': '22',
  'name': '秦安县',
  'level': 3
}, {
  'code': '620523',
  'sheng': '62',
  'di': '05',
  'xian': '23',
  'name': '甘谷县',
  'level': 3
}, {
  'code': '620524',
  'sheng': '62',
  'di': '05',
  'xian': '24',
  'name': '武山县',
  'level': 3
}, {
  'code': '620525',
  'sheng': '62',
  'di': '05',
  'xian': '25',
  'name': '张家川回族自治县',
  'level': 3
}, {
  'code': '620600',
  'sheng': '62',
  'di': '06',
  'xian': '00',
  'name': '武威市',
  'level': 2
}, {
  'code': '620601',
  'sheng': '62',
  'di': '06',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620602',
  'sheng': '62',
  'di': '06',
  'xian': '02',
  'name': '凉州区',
  'level': 3
}, {
  'code': '620621',
  'sheng': '62',
  'di': '06',
  'xian': '21',
  'name': '民勤县',
  'level': 3
}, {
  'code': '620622',
  'sheng': '62',
  'di': '06',
  'xian': '22',
  'name': '古浪县',
  'level': 3
}, {
  'code': '620623',
  'sheng': '62',
  'di': '06',
  'xian': '23',
  'name': '天祝藏族自治县',
  'level': 3
}, {
  'code': '620700',
  'sheng': '62',
  'di': '07',
  'xian': '00',
  'name': '张掖市',
  'level': 2
}, {
  'code': '620701',
  'sheng': '62',
  'di': '07',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620702',
  'sheng': '62',
  'di': '07',
  'xian': '02',
  'name': '甘州区',
  'level': 3
}, {
  'code': '620721',
  'sheng': '62',
  'di': '07',
  'xian': '21',
  'name': '肃南裕固族自治县',
  'level': 3
}, {
  'code': '620722',
  'sheng': '62',
  'di': '07',
  'xian': '22',
  'name': '民乐县',
  'level': 3
}, {
  'code': '620723',
  'sheng': '62',
  'di': '07',
  'xian': '23',
  'name': '临泽县',
  'level': 3
}, {
  'code': '620724',
  'sheng': '62',
  'di': '07',
  'xian': '24',
  'name': '高台县',
  'level': 3
}, {
  'code': '620725',
  'sheng': '62',
  'di': '07',
  'xian': '25',
  'name': '山丹县',
  'level': 3
}, {
  'code': '620800',
  'sheng': '62',
  'di': '08',
  'xian': '00',
  'name': '平凉市',
  'level': 2
}, {
  'code': '620801',
  'sheng': '62',
  'di': '08',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620802',
  'sheng': '62',
  'di': '08',
  'xian': '02',
  'name': '崆峒区',
  'level': 3
}, {
  'code': '620821',
  'sheng': '62',
  'di': '08',
  'xian': '21',
  'name': '泾川县',
  'level': 3
}, {
  'code': '620822',
  'sheng': '62',
  'di': '08',
  'xian': '22',
  'name': '灵台县',
  'level': 3
}, {
  'code': '620823',
  'sheng': '62',
  'di': '08',
  'xian': '23',
  'name': '崇信县',
  'level': 3
}, {
  'code': '620824',
  'sheng': '62',
  'di': '08',
  'xian': '24',
  'name': '华亭县',
  'level': 3
}, {
  'code': '620825',
  'sheng': '62',
  'di': '08',
  'xian': '25',
  'name': '庄浪县',
  'level': 3
}, {
  'code': '620826',
  'sheng': '62',
  'di': '08',
  'xian': '26',
  'name': '静宁县',
  'level': 3
}, {
  'code': '620900',
  'sheng': '62',
  'di': '09',
  'xian': '00',
  'name': '酒泉市',
  'level': 2
}, {
  'code': '620901',
  'sheng': '62',
  'di': '09',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '620902',
  'sheng': '62',
  'di': '09',
  'xian': '02',
  'name': '肃州区',
  'level': 3
}, {
  'code': '620921',
  'sheng': '62',
  'di': '09',
  'xian': '21',
  'name': '金塔县',
  'level': 3
}, {
  'code': '620922',
  'sheng': '62',
  'di': '09',
  'xian': '22',
  'name': '瓜州县',
  'level': 3
}, {
  'code': '620923',
  'sheng': '62',
  'di': '09',
  'xian': '23',
  'name': '肃北蒙古族自治县',
  'level': 3
}, {
  'code': '620924',
  'sheng': '62',
  'di': '09',
  'xian': '24',
  'name': '阿克塞哈萨克族自治县',
  'level': 3
}, {
  'code': '620981',
  'sheng': '62',
  'di': '09',
  'xian': '81',
  'name': '玉门市',
  'level': 3
}, {
  'code': '620982',
  'sheng': '62',
  'di': '09',
  'xian': '82',
  'name': '敦煌市',
  'level': 3
}, {
  'code': '621000',
  'sheng': '62',
  'di': '10',
  'xian': '00',
  'name': '庆阳市',
  'level': 2
}, {
  'code': '621001',
  'sheng': '62',
  'di': '10',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '621002',
  'sheng': '62',
  'di': '10',
  'xian': '02',
  'name': '西峰区',
  'level': 3
}, {
  'code': '621021',
  'sheng': '62',
  'di': '10',
  'xian': '21',
  'name': '庆城县',
  'level': 3
}, {
  'code': '621022',
  'sheng': '62',
  'di': '10',
  'xian': '22',
  'name': '环县',
  'level': 3
}, {
  'code': '621023',
  'sheng': '62',
  'di': '10',
  'xian': '23',
  'name': '华池县',
  'level': 3
}, {
  'code': '621024',
  'sheng': '62',
  'di': '10',
  'xian': '24',
  'name': '合水县',
  'level': 3
}, {
  'code': '621025',
  'sheng': '62',
  'di': '10',
  'xian': '25',
  'name': '正宁县',
  'level': 3
}, {
  'code': '621026',
  'sheng': '62',
  'di': '10',
  'xian': '26',
  'name': '宁县',
  'level': 3
}, {
  'code': '621027',
  'sheng': '62',
  'di': '10',
  'xian': '27',
  'name': '镇原县',
  'level': 3
}, {
  'code': '621100',
  'sheng': '62',
  'di': '11',
  'xian': '00',
  'name': '定西市',
  'level': 2
}, {
  'code': '621101',
  'sheng': '62',
  'di': '11',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '621102',
  'sheng': '62',
  'di': '11',
  'xian': '02',
  'name': '安定区',
  'level': 3
}, {
  'code': '621121',
  'sheng': '62',
  'di': '11',
  'xian': '21',
  'name': '通渭县',
  'level': 3
}, {
  'code': '621122',
  'sheng': '62',
  'di': '11',
  'xian': '22',
  'name': '陇西县',
  'level': 3
}, {
  'code': '621123',
  'sheng': '62',
  'di': '11',
  'xian': '23',
  'name': '渭源县',
  'level': 3
}, {
  'code': '621124',
  'sheng': '62',
  'di': '11',
  'xian': '24',
  'name': '临洮县',
  'level': 3
}, {
  'code': '621125',
  'sheng': '62',
  'di': '11',
  'xian': '25',
  'name': '漳县',
  'level': 3
}, {
  'code': '621126',
  'sheng': '62',
  'di': '11',
  'xian': '26',
  'name': '岷县',
  'level': 3
}, {
  'code': '621200',
  'sheng': '62',
  'di': '12',
  'xian': '00',
  'name': '陇南市',
  'level': 2
}, {
  'code': '621201',
  'sheng': '62',
  'di': '12',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '621202',
  'sheng': '62',
  'di': '12',
  'xian': '02',
  'name': '武都区',
  'level': 3
}, {
  'code': '621221',
  'sheng': '62',
  'di': '12',
  'xian': '21',
  'name': '成县',
  'level': 3
}, {
  'code': '621222',
  'sheng': '62',
  'di': '12',
  'xian': '22',
  'name': '文县',
  'level': 3
}, {
  'code': '621223',
  'sheng': '62',
  'di': '12',
  'xian': '23',
  'name': '宕昌县',
  'level': 3
}, {
  'code': '621224',
  'sheng': '62',
  'di': '12',
  'xian': '24',
  'name': '康县',
  'level': 3
}, {
  'code': '621225',
  'sheng': '62',
  'di': '12',
  'xian': '25',
  'name': '西和县',
  'level': 3
}, {
  'code': '621226',
  'sheng': '62',
  'di': '12',
  'xian': '26',
  'name': '礼县',
  'level': 3
}, {
  'code': '621227',
  'sheng': '62',
  'di': '12',
  'xian': '27',
  'name': '徽县',
  'level': 3
}, {
  'code': '621228',
  'sheng': '62',
  'di': '12',
  'xian': '28',
  'name': '两当县',
  'level': 3
}, {
  'code': '622900',
  'sheng': '62',
  'di': '29',
  'xian': '00',
  'name': '临夏回族自治州',
  'level': 2
}, {
  'code': '622901',
  'sheng': '62',
  'di': '29',
  'xian': '01',
  'name': '临夏市',
  'level': 3
}, {
  'code': '622921',
  'sheng': '62',
  'di': '29',
  'xian': '21',
  'name': '临夏县',
  'level': 3
}, {
  'code': '622922',
  'sheng': '62',
  'di': '29',
  'xian': '22',
  'name': '康乐县',
  'level': 3
}, {
  'code': '622923',
  'sheng': '62',
  'di': '29',
  'xian': '23',
  'name': '永靖县',
  'level': 3
}, {
  'code': '622924',
  'sheng': '62',
  'di': '29',
  'xian': '24',
  'name': '广河县',
  'level': 3
}, {
  'code': '622925',
  'sheng': '62',
  'di': '29',
  'xian': '25',
  'name': '和政县',
  'level': 3
}, {
  'code': '622926',
  'sheng': '62',
  'di': '29',
  'xian': '26',
  'name': '东乡族自治县',
  'level': 3
}, {
  'code': '622927',
  'sheng': '62',
  'di': '29',
  'xian': '27',
  'name': '积石山保安族东乡族撒拉族自治县',
  'level': 3
}, {
  'code': '623000',
  'sheng': '62',
  'di': '30',
  'xian': '00',
  'name': '甘南藏族自治州',
  'level': 2
}, {
  'code': '623001',
  'sheng': '62',
  'di': '30',
  'xian': '01',
  'name': '合作市',
  'level': 3
}, {
  'code': '623021',
  'sheng': '62',
  'di': '30',
  'xian': '21',
  'name': '临潭县',
  'level': 3
}, {
  'code': '623022',
  'sheng': '62',
  'di': '30',
  'xian': '22',
  'name': '卓尼县',
  'level': 3
}, {
  'code': '623023',
  'sheng': '62',
  'di': '30',
  'xian': '23',
  'name': '舟曲县',
  'level': 3
}, {
  'code': '623024',
  'sheng': '62',
  'di': '30',
  'xian': '24',
  'name': '迭部县',
  'level': 3
}, {
  'code': '623025',
  'sheng': '62',
  'di': '30',
  'xian': '25',
  'name': '玛曲县',
  'level': 3
}, {
  'code': '623026',
  'sheng': '62',
  'di': '30',
  'xian': '26',
  'name': '碌曲县',
  'level': 3
}, {
  'code': '623027',
  'sheng': '62',
  'di': '30',
  'xian': '27',
  'name': '夏河县',
  'level': 3
}, {
  'code': '630000',
  'sheng': '63',
  'di': '00',
  'xian': '00',
  'name': '青海省',
  'level': 1
}, {
  'code': '630100',
  'sheng': '63',
  'di': '01',
  'xian': '00',
  'name': '西宁市',
  'level': 2
}, {
  'code': '630101',
  'sheng': '63',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '630102',
  'sheng': '63',
  'di': '01',
  'xian': '02',
  'name': '城东区',
  'level': 3
}, {
  'code': '630103',
  'sheng': '63',
  'di': '01',
  'xian': '03',
  'name': '城中区',
  'level': 3
}, {
  'code': '630104',
  'sheng': '63',
  'di': '01',
  'xian': '04',
  'name': '城西区',
  'level': 3
}, {
  'code': '630105',
  'sheng': '63',
  'di': '01',
  'xian': '05',
  'name': '城北区',
  'level': 3
}, {
  'code': '630121',
  'sheng': '63',
  'di': '01',
  'xian': '21',
  'name': '大通回族土族自治县',
  'level': 3
}, {
  'code': '630122',
  'sheng': '63',
  'di': '01',
  'xian': '22',
  'name': '湟中县',
  'level': 3
}, {
  'code': '630123',
  'sheng': '63',
  'di': '01',
  'xian': '23',
  'name': '湟源县',
  'level': 3
}, {
  'code': '630200',
  'sheng': '63',
  'di': '02',
  'xian': '00',
  'name': '海东市',
  'level': 2
}, {
  'code': '630202',
  'sheng': '63',
  'di': '02',
  'xian': '02',
  'name': '乐都区',
  'level': 3
}, {
  'code': '630221',
  'sheng': '63',
  'di': '02',
  'xian': '21',
  'name': '平安县',
  'level': 3
}, {
  'code': '630222',
  'sheng': '63',
  'di': '02',
  'xian': '22',
  'name': '民和回族土族自治县',
  'level': 3
}, {
  'code': '630223',
  'sheng': '63',
  'di': '02',
  'xian': '23',
  'name': '互助土族自治县',
  'level': 3
}, {
  'code': '630224',
  'sheng': '63',
  'di': '02',
  'xian': '24',
  'name': '化隆回族自治县',
  'level': 3
}, {
  'code': '630225',
  'sheng': '63',
  'di': '02',
  'xian': '25',
  'name': '循化撒拉族自治县',
  'level': 3
}, {
  'code': '632200',
  'sheng': '63',
  'di': '22',
  'xian': '00',
  'name': '海北藏族自治州',
  'level': 2
}, {
  'code': '632221',
  'sheng': '63',
  'di': '22',
  'xian': '21',
  'name': '门源回族自治县',
  'level': 3
}, {
  'code': '632222',
  'sheng': '63',
  'di': '22',
  'xian': '22',
  'name': '祁连县',
  'level': 3
}, {
  'code': '632223',
  'sheng': '63',
  'di': '22',
  'xian': '23',
  'name': '海晏县',
  'level': 3
}, {
  'code': '632224',
  'sheng': '63',
  'di': '22',
  'xian': '24',
  'name': '刚察县',
  'level': 3
}, {
  'code': '632300',
  'sheng': '63',
  'di': '23',
  'xian': '00',
  'name': '黄南藏族自治州',
  'level': 2
}, {
  'code': '632321',
  'sheng': '63',
  'di': '23',
  'xian': '21',
  'name': '同仁县',
  'level': 3
}, {
  'code': '632322',
  'sheng': '63',
  'di': '23',
  'xian': '22',
  'name': '尖扎县',
  'level': 3
}, {
  'code': '632323',
  'sheng': '63',
  'di': '23',
  'xian': '23',
  'name': '泽库县',
  'level': 3
}, {
  'code': '632324',
  'sheng': '63',
  'di': '23',
  'xian': '24',
  'name': '河南蒙古族自治县',
  'level': 3
}, {
  'code': '632500',
  'sheng': '63',
  'di': '25',
  'xian': '00',
  'name': '海南藏族自治州',
  'level': 2
}, {
  'code': '632521',
  'sheng': '63',
  'di': '25',
  'xian': '21',
  'name': '共和县',
  'level': 3
}, {
  'code': '632522',
  'sheng': '63',
  'di': '25',
  'xian': '22',
  'name': '同德县',
  'level': 3
}, {
  'code': '632523',
  'sheng': '63',
  'di': '25',
  'xian': '23',
  'name': '贵德县',
  'level': 3
}, {
  'code': '632524',
  'sheng': '63',
  'di': '25',
  'xian': '24',
  'name': '兴海县',
  'level': 3
}, {
  'code': '632525',
  'sheng': '63',
  'di': '25',
  'xian': '25',
  'name': '贵南县',
  'level': 3
}, {
  'code': '632600',
  'sheng': '63',
  'di': '26',
  'xian': '00',
  'name': '果洛藏族自治州',
  'level': 2
}, {
  'code': '632621',
  'sheng': '63',
  'di': '26',
  'xian': '21',
  'name': '玛沁县',
  'level': 3
}, {
  'code': '632622',
  'sheng': '63',
  'di': '26',
  'xian': '22',
  'name': '班玛县',
  'level': 3
}, {
  'code': '632623',
  'sheng': '63',
  'di': '26',
  'xian': '23',
  'name': '甘德县',
  'level': 3
}, {
  'code': '632624',
  'sheng': '63',
  'di': '26',
  'xian': '24',
  'name': '达日县',
  'level': 3
}, {
  'code': '632625',
  'sheng': '63',
  'di': '26',
  'xian': '25',
  'name': '久治县',
  'level': 3
}, {
  'code': '632626',
  'sheng': '63',
  'di': '26',
  'xian': '26',
  'name': '玛多县',
  'level': 3
}, {
  'code': '632700',
  'sheng': '63',
  'di': '27',
  'xian': '00',
  'name': '玉树藏族自治州',
  'level': 2
}, {
  'code': '632701',
  'sheng': '63',
  'di': '27',
  'xian': '01',
  'name': '玉树市',
  'level': 3
}, {
  'code': '632722',
  'sheng': '63',
  'di': '27',
  'xian': '22',
  'name': '杂多县',
  'level': 3
}, {
  'code': '632723',
  'sheng': '63',
  'di': '27',
  'xian': '23',
  'name': '称多县',
  'level': 3
}, {
  'code': '632724',
  'sheng': '63',
  'di': '27',
  'xian': '24',
  'name': '治多县',
  'level': 3
}, {
  'code': '632725',
  'sheng': '63',
  'di': '27',
  'xian': '25',
  'name': '囊谦县',
  'level': 3
}, {
  'code': '632726',
  'sheng': '63',
  'di': '27',
  'xian': '26',
  'name': '曲麻莱县',
  'level': 3
}, {
  'code': '632800',
  'sheng': '63',
  'di': '28',
  'xian': '00',
  'name': '海西蒙古族藏族自治州',
  'level': 2
}, {
  'code': '632801',
  'sheng': '63',
  'di': '28',
  'xian': '01',
  'name': '格尔木市',
  'level': 3
}, {
  'code': '632802',
  'sheng': '63',
  'di': '28',
  'xian': '02',
  'name': '德令哈市',
  'level': 3
}, {
  'code': '632821',
  'sheng': '63',
  'di': '28',
  'xian': '21',
  'name': '乌兰县',
  'level': 3
}, {
  'code': '632822',
  'sheng': '63',
  'di': '28',
  'xian': '22',
  'name': '都兰县',
  'level': 3
}, {
  'code': '632823',
  'sheng': '63',
  'di': '28',
  'xian': '23',
  'name': '天峻县',
  'level': 3
}, {
  'code': '640000',
  'sheng': '64',
  'di': '00',
  'xian': '00',
  'name': '宁夏回族自治区',
  'level': 1
}, {
  'code': '640100',
  'sheng': '64',
  'di': '01',
  'xian': '00',
  'name': '银川市',
  'level': 2
}, {
  'code': '640101',
  'sheng': '64',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '640104',
  'sheng': '64',
  'di': '01',
  'xian': '04',
  'name': '兴庆区',
  'level': 3
}, {
  'code': '640105',
  'sheng': '64',
  'di': '01',
  'xian': '05',
  'name': '西夏区',
  'level': 3
}, {
  'code': '640106',
  'sheng': '64',
  'di': '01',
  'xian': '06',
  'name': '金凤区',
  'level': 3
}, {
  'code': '640121',
  'sheng': '64',
  'di': '01',
  'xian': '21',
  'name': '永宁县',
  'level': 3
}, {
  'code': '640122',
  'sheng': '64',
  'di': '01',
  'xian': '22',
  'name': '贺兰县',
  'level': 3
}, {
  'code': '640181',
  'sheng': '64',
  'di': '01',
  'xian': '81',
  'name': '灵武市',
  'level': 3
}, {
  'code': '640200',
  'sheng': '64',
  'di': '02',
  'xian': '00',
  'name': '石嘴山市',
  'level': 2
}, {
  'code': '640201',
  'sheng': '64',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '640202',
  'sheng': '64',
  'di': '02',
  'xian': '02',
  'name': '大武口区',
  'level': 3
}, {
  'code': '640205',
  'sheng': '64',
  'di': '02',
  'xian': '05',
  'name': '惠农区',
  'level': 3
}, {
  'code': '640221',
  'sheng': '64',
  'di': '02',
  'xian': '21',
  'name': '平罗县',
  'level': 3
}, {
  'code': '640300',
  'sheng': '64',
  'di': '03',
  'xian': '00',
  'name': '吴忠市',
  'level': 2
}, {
  'code': '640301',
  'sheng': '64',
  'di': '03',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '640302',
  'sheng': '64',
  'di': '03',
  'xian': '02',
  'name': '利通区',
  'level': 3
}, {
  'code': '640303',
  'sheng': '64',
  'di': '03',
  'xian': '03',
  'name': '红寺堡区',
  'level': 3
}, {
  'code': '640323',
  'sheng': '64',
  'di': '03',
  'xian': '23',
  'name': '盐池县',
  'level': 3
}, {
  'code': '640324',
  'sheng': '64',
  'di': '03',
  'xian': '24',
  'name': '同心县',
  'level': 3
}, {
  'code': '640381',
  'sheng': '64',
  'di': '03',
  'xian': '81',
  'name': '青铜峡市',
  'level': 3
}, {
  'code': '640400',
  'sheng': '64',
  'di': '04',
  'xian': '00',
  'name': '固原市',
  'level': 2
}, {
  'code': '640401',
  'sheng': '64',
  'di': '04',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '640402',
  'sheng': '64',
  'di': '04',
  'xian': '02',
  'name': '原州区',
  'level': 3
}, {
  'code': '640422',
  'sheng': '64',
  'di': '04',
  'xian': '22',
  'name': '西吉县',
  'level': 3
}, {
  'code': '640423',
  'sheng': '64',
  'di': '04',
  'xian': '23',
  'name': '隆德县',
  'level': 3
}, {
  'code': '640424',
  'sheng': '64',
  'di': '04',
  'xian': '24',
  'name': '泾源县',
  'level': 3
}, {
  'code': '640425',
  'sheng': '64',
  'di': '04',
  'xian': '25',
  'name': '彭阳县',
  'level': 3
}, {
  'code': '640500',
  'sheng': '64',
  'di': '05',
  'xian': '00',
  'name': '中卫市',
  'level': 2
}, {
  'code': '640501',
  'sheng': '64',
  'di': '05',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '640502',
  'sheng': '64',
  'di': '05',
  'xian': '02',
  'name': '沙坡头区',
  'level': 3
}, {
  'code': '640521',
  'sheng': '64',
  'di': '05',
  'xian': '21',
  'name': '中宁县',
  'level': 3
}, {
  'code': '640522',
  'sheng': '64',
  'di': '05',
  'xian': '22',
  'name': '海原县',
  'level': 3
}, {
  'code': '650000',
  'sheng': '65',
  'di': '00',
  'xian': '00',
  'name': '新疆维吾尔自治区',
  'level': 1
}, {
  'code': '650100',
  'sheng': '65',
  'di': '01',
  'xian': '00',
  'name': '乌鲁木齐市',
  'level': 2
}, {
  'code': '650101',
  'sheng': '65',
  'di': '01',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '650102',
  'sheng': '65',
  'di': '01',
  'xian': '02',
  'name': '天山区',
  'level': 3
}, {
  'code': '650103',
  'sheng': '65',
  'di': '01',
  'xian': '03',
  'name': '沙依巴克区',
  'level': 3
}, {
  'code': '650104',
  'sheng': '65',
  'di': '01',
  'xian': '04',
  'name': '新市区',
  'level': 3
}, {
  'code': '650105',
  'sheng': '65',
  'di': '01',
  'xian': '05',
  'name': '水磨沟区',
  'level': 3
}, {
  'code': '650106',
  'sheng': '65',
  'di': '01',
  'xian': '06',
  'name': '头屯河区',
  'level': 3
}, {
  'code': '650107',
  'sheng': '65',
  'di': '01',
  'xian': '07',
  'name': '达坂城区',
  'level': 3
}, {
  'code': '650109',
  'sheng': '65',
  'di': '01',
  'xian': '09',
  'name': '米东区',
  'level': 3
}, {
  'code': '650121',
  'sheng': '65',
  'di': '01',
  'xian': '21',
  'name': '乌鲁木齐县',
  'level': 3
}, {
  'code': '650200',
  'sheng': '65',
  'di': '02',
  'xian': '00',
  'name': '克拉玛依市',
  'level': 2
}, {
  'code': '650201',
  'sheng': '65',
  'di': '02',
  'xian': '01',
  'name': '市辖区',
  'level': 3
}, {
  'code': '650202',
  'sheng': '65',
  'di': '02',
  'xian': '02',
  'name': '独山子区',
  'level': 3
}, {
  'code': '650203',
  'sheng': '65',
  'di': '02',
  'xian': '03',
  'name': '克拉玛依区',
  'level': 3
}, {
  'code': '650204',
  'sheng': '65',
  'di': '02',
  'xian': '04',
  'name': '白碱滩区',
  'level': 3
}, {
  'code': '650205',
  'sheng': '65',
  'di': '02',
  'xian': '05',
  'name': '乌尔禾区',
  'level': 3
}, {
  'code': '652100',
  'sheng': '65',
  'di': '21',
  'xian': '00',
  'name': '吐鲁番地区',
  'level': 2
}, {
  'code': '652101',
  'sheng': '65',
  'di': '21',
  'xian': '01',
  'name': '吐鲁番市',
  'level': 3
}, {
  'code': '652122',
  'sheng': '65',
  'di': '21',
  'xian': '22',
  'name': '鄯善县',
  'level': 3
}, {
  'code': '652123',
  'sheng': '65',
  'di': '21',
  'xian': '23',
  'name': '托克逊县',
  'level': 3
}, {
  'code': '652200',
  'sheng': '65',
  'di': '22',
  'xian': '00',
  'name': '哈密地区',
  'level': 2
}, {
  'code': '652201',
  'sheng': '65',
  'di': '22',
  'xian': '01',
  'name': '哈密市',
  'level': 3
}, {
  'code': '652222',
  'sheng': '65',
  'di': '22',
  'xian': '22',
  'name': '巴里坤哈萨克自治县',
  'level': 3
}, {
  'code': '652223',
  'sheng': '65',
  'di': '22',
  'xian': '23',
  'name': '伊吾县',
  'level': 3
}, {
  'code': '652300',
  'sheng': '65',
  'di': '23',
  'xian': '00',
  'name': '昌吉回族自治州',
  'level': 2
}, {
  'code': '652301',
  'sheng': '65',
  'di': '23',
  'xian': '01',
  'name': '昌吉市',
  'level': 3
}, {
  'code': '652302',
  'sheng': '65',
  'di': '23',
  'xian': '02',
  'name': '阜康市',
  'level': 3
}, {
  'code': '652323',
  'sheng': '65',
  'di': '23',
  'xian': '23',
  'name': '呼图壁县',
  'level': 3
}, {
  'code': '652324',
  'sheng': '65',
  'di': '23',
  'xian': '24',
  'name': '玛纳斯县',
  'level': 3
}, {
  'code': '652325',
  'sheng': '65',
  'di': '23',
  'xian': '25',
  'name': '奇台县',
  'level': 3
}, {
  'code': '652327',
  'sheng': '65',
  'di': '23',
  'xian': '27',
  'name': '吉木萨尔县',
  'level': 3
}, {
  'code': '652328',
  'sheng': '65',
  'di': '23',
  'xian': '28',
  'name': '木垒哈萨克自治县',
  'level': 3
}, {
  'code': '652700',
  'sheng': '65',
  'di': '27',
  'xian': '00',
  'name': '博尔塔拉蒙古自治州',
  'level': 2
}, {
  'code': '652701',
  'sheng': '65',
  'di': '27',
  'xian': '01',
  'name': '博乐市',
  'level': 3
}, {
  'code': '652702',
  'sheng': '65',
  'di': '27',
  'xian': '02',
  'name': '阿拉山口市',
  'level': 3
}, {
  'code': '652722',
  'sheng': '65',
  'di': '27',
  'xian': '22',
  'name': '精河县',
  'level': 3
}, {
  'code': '652723',
  'sheng': '65',
  'di': '27',
  'xian': '23',
  'name': '温泉县',
  'level': 3
}, {
  'code': '652800',
  'sheng': '65',
  'di': '28',
  'xian': '00',
  'name': '巴音郭楞蒙古自治州',
  'level': 2
}, {
  'code': '652801',
  'sheng': '65',
  'di': '28',
  'xian': '01',
  'name': '库尔勒市',
  'level': 3
}, {
  'code': '652822',
  'sheng': '65',
  'di': '28',
  'xian': '22',
  'name': '轮台县',
  'level': 3
}, {
  'code': '652823',
  'sheng': '65',
  'di': '28',
  'xian': '23',
  'name': '尉犁县',
  'level': 3
}, {
  'code': '652824',
  'sheng': '65',
  'di': '28',
  'xian': '24',
  'name': '若羌县',
  'level': 3
}, {
  'code': '652825',
  'sheng': '65',
  'di': '28',
  'xian': '25',
  'name': '且末县',
  'level': 3
}, {
  'code': '652826',
  'sheng': '65',
  'di': '28',
  'xian': '26',
  'name': '焉耆回族自治县',
  'level': 3
}, {
  'code': '652827',
  'sheng': '65',
  'di': '28',
  'xian': '27',
  'name': '和静县',
  'level': 3
}, {
  'code': '652828',
  'sheng': '65',
  'di': '28',
  'xian': '28',
  'name': '和硕县',
  'level': 3
}, {
  'code': '652829',
  'sheng': '65',
  'di': '28',
  'xian': '29',
  'name': '博湖县',
  'level': 3
}, {
  'code': '652900',
  'sheng': '65',
  'di': '29',
  'xian': '00',
  'name': '阿克苏地区',
  'level': 2
}, {
  'code': '652901',
  'sheng': '65',
  'di': '29',
  'xian': '01',
  'name': '阿克苏市',
  'level': 3
}, {
  'code': '652922',
  'sheng': '65',
  'di': '29',
  'xian': '22',
  'name': '温宿县',
  'level': 3
}, {
  'code': '652923',
  'sheng': '65',
  'di': '29',
  'xian': '23',
  'name': '库车县',
  'level': 3
}, {
  'code': '652924',
  'sheng': '65',
  'di': '29',
  'xian': '24',
  'name': '沙雅县',
  'level': 3
}, {
  'code': '652925',
  'sheng': '65',
  'di': '29',
  'xian': '25',
  'name': '新和县',
  'level': 3
}, {
  'code': '652926',
  'sheng': '65',
  'di': '29',
  'xian': '26',
  'name': '拜城县',
  'level': 3
}, {
  'code': '652927',
  'sheng': '65',
  'di': '29',
  'xian': '27',
  'name': '乌什县',
  'level': 3
}, {
  'code': '652928',
  'sheng': '65',
  'di': '29',
  'xian': '28',
  'name': '阿瓦提县',
  'level': 3
}, {
  'code': '652929',
  'sheng': '65',
  'di': '29',
  'xian': '29',
  'name': '柯坪县',
  'level': 3
}, {
  'code': '653000',
  'sheng': '65',
  'di': '30',
  'xian': '00',
  'name': '克孜勒苏柯尔克孜自治州',
  'level': 2
}, {
  'code': '653001',
  'sheng': '65',
  'di': '30',
  'xian': '01',
  'name': '阿图什市',
  'level': 3
}, {
  'code': '653022',
  'sheng': '65',
  'di': '30',
  'xian': '22',
  'name': '阿克陶县',
  'level': 3
}, {
  'code': '653023',
  'sheng': '65',
  'di': '30',
  'xian': '23',
  'name': '阿合奇县',
  'level': 3
}, {
  'code': '653024',
  'sheng': '65',
  'di': '30',
  'xian': '24',
  'name': '乌恰县',
  'level': 3
}, {
  'code': '653100',
  'sheng': '65',
  'di': '31',
  'xian': '00',
  'name': '喀什地区',
  'level': 2
}, {
  'code': '653101',
  'sheng': '65',
  'di': '31',
  'xian': '01',
  'name': '喀什市',
  'level': 3
}, {
  'code': '653121',
  'sheng': '65',
  'di': '31',
  'xian': '21',
  'name': '疏附县',
  'level': 3
}, {
  'code': '653122',
  'sheng': '65',
  'di': '31',
  'xian': '22',
  'name': '疏勒县',
  'level': 3
}, {
  'code': '653123',
  'sheng': '65',
  'di': '31',
  'xian': '23',
  'name': '英吉沙县',
  'level': 3
}, {
  'code': '653124',
  'sheng': '65',
  'di': '31',
  'xian': '24',
  'name': '泽普县',
  'level': 3
}, {
  'code': '653125',
  'sheng': '65',
  'di': '31',
  'xian': '25',
  'name': '莎车县',
  'level': 3
}, {
  'code': '653126',
  'sheng': '65',
  'di': '31',
  'xian': '26',
  'name': '叶城县',
  'level': 3
}, {
  'code': '653127',
  'sheng': '65',
  'di': '31',
  'xian': '27',
  'name': '麦盖提县',
  'level': 3
}, {
  'code': '653128',
  'sheng': '65',
  'di': '31',
  'xian': '28',
  'name': '岳普湖县',
  'level': 3
}, {
  'code': '653129',
  'sheng': '65',
  'di': '31',
  'xian': '29',
  'name': '伽师县',
  'level': 3
}, {
  'code': '653130',
  'sheng': '65',
  'di': '31',
  'xian': '30',
  'name': '巴楚县',
  'level': 3
}, {
  'code': '653131',
  'sheng': '65',
  'di': '31',
  'xian': '31',
  'name': '塔什库尔干塔吉克自治县',
  'level': 3
}, {
  'code': '653200',
  'sheng': '65',
  'di': '32',
  'xian': '00',
  'name': '和田地区',
  'level': 2
}, {
  'code': '653201',
  'sheng': '65',
  'di': '32',
  'xian': '01',
  'name': '和田市',
  'level': 3
}, {
  'code': '653221',
  'sheng': '65',
  'di': '32',
  'xian': '21',
  'name': '和田县',
  'level': 3
}, {
  'code': '653222',
  'sheng': '65',
  'di': '32',
  'xian': '22',
  'name': '墨玉县',
  'level': 3
}, {
  'code': '653223',
  'sheng': '65',
  'di': '32',
  'xian': '23',
  'name': '皮山县',
  'level': 3
}, {
  'code': '653224',
  'sheng': '65',
  'di': '32',
  'xian': '24',
  'name': '洛浦县',
  'level': 3
}, {
  'code': '653225',
  'sheng': '65',
  'di': '32',
  'xian': '25',
  'name': '策勒县',
  'level': 3
}, {
  'code': '653226',
  'sheng': '65',
  'di': '32',
  'xian': '26',
  'name': '于田县',
  'level': 3
}, {
  'code': '653227',
  'sheng': '65',
  'di': '32',
  'xian': '27',
  'name': '民丰县',
  'level': 3
}, {
  'code': '654000',
  'sheng': '65',
  'di': '40',
  'xian': '00',
  'name': '伊犁哈萨克自治州',
  'level': 2
}, {
  'code': '654002',
  'sheng': '65',
  'di': '40',
  'xian': '02',
  'name': '伊宁市',
  'level': 3
}, {
  'code': '654003',
  'sheng': '65',
  'di': '40',
  'xian': '03',
  'name': '奎屯市',
  'level': 3
}, {
  'code': '654021',
  'sheng': '65',
  'di': '40',
  'xian': '21',
  'name': '伊宁县',
  'level': 3
}, {
  'code': '654022',
  'sheng': '65',
  'di': '40',
  'xian': '22',
  'name': '察布查尔锡伯自治县',
  'level': 3
}, {
  'code': '654023',
  'sheng': '65',
  'di': '40',
  'xian': '23',
  'name': '霍城县',
  'level': 3
}, {
  'code': '654024',
  'sheng': '65',
  'di': '40',
  'xian': '24',
  'name': '巩留县',
  'level': 3
}, {
  'code': '654025',
  'sheng': '65',
  'di': '40',
  'xian': '25',
  'name': '新源县',
  'level': 3
}, {
  'code': '654026',
  'sheng': '65',
  'di': '40',
  'xian': '26',
  'name': '昭苏县',
  'level': 3
}, {
  'code': '654027',
  'sheng': '65',
  'di': '40',
  'xian': '27',
  'name': '特克斯县',
  'level': 3
}, {
  'code': '654028',
  'sheng': '65',
  'di': '40',
  'xian': '28',
  'name': '尼勒克县',
  'level': 3
}, {
  'code': '654200',
  'sheng': '65',
  'di': '42',
  'xian': '00',
  'name': '塔城地区',
  'level': 2
}, {
  'code': '654201',
  'sheng': '65',
  'di': '42',
  'xian': '01',
  'name': '塔城市',
  'level': 3
}, {
  'code': '654202',
  'sheng': '65',
  'di': '42',
  'xian': '02',
  'name': '乌苏市',
  'level': 3
}, {
  'code': '654221',
  'sheng': '65',
  'di': '42',
  'xian': '21',
  'name': '额敏县',
  'level': 3
}, {
  'code': '654223',
  'sheng': '65',
  'di': '42',
  'xian': '23',
  'name': '沙湾县',
  'level': 3
}, {
  'code': '654224',
  'sheng': '65',
  'di': '42',
  'xian': '24',
  'name': '托里县',
  'level': 3
}, {
  'code': '654225',
  'sheng': '65',
  'di': '42',
  'xian': '25',
  'name': '裕民县',
  'level': 3
}, {
  'code': '654226',
  'sheng': '65',
  'di': '42',
  'xian': '26',
  'name': '和布克赛尔蒙古自治县',
  'level': 3
}, {
  'code': '654300',
  'sheng': '65',
  'di': '43',
  'xian': '00',
  'name': '阿勒泰地区',
  'level': 2
}, {
  'code': '654301',
  'sheng': '65',
  'di': '43',
  'xian': '01',
  'name': '阿勒泰市',
  'level': 3
}, {
  'code': '654321',
  'sheng': '65',
  'di': '43',
  'xian': '21',
  'name': '布尔津县',
  'level': 3
}, {
  'code': '654322',
  'sheng': '65',
  'di': '43',
  'xian': '22',
  'name': '富蕴县',
  'level': 3
}, {
  'code': '654323',
  'sheng': '65',
  'di': '43',
  'xian': '23',
  'name': '福海县',
  'level': 3
}, {
  'code': '654324',
  'sheng': '65',
  'di': '43',
  'xian': '24',
  'name': '哈巴河县',
  'level': 3
}, {
  'code': '654325',
  'sheng': '65',
  'di': '43',
  'xian': '25',
  'name': '青河县',
  'level': 3
}, {
  'code': '654326',
  'sheng': '65',
  'di': '43',
  'xian': '26',
  'name': '吉木乃县',
  'level': 3
}, {
  'code': '659000',
  'sheng': '65',
  'di': '90',
  'xian': '00',
  'name': '自治区直辖县级行政区划',
  'level': 2
}, {
  'code': '659001',
  'sheng': '65',
  'di': '90',
  'xian': '01',
  'name': '石河子市',
  'level': 3
}, {
  'code': '659002',
  'sheng': '65',
  'di': '90',
  'xian': '02',
  'name': '阿拉尔市',
  'level': 3
}, {
  'code': '659003',
  'sheng': '65',
  'di': '90',
  'xian': '03',
  'name': '图木舒克市',
  'level': 3
}, {
  'code': '659004',
  'sheng': '65',
  'di': '90',
  'xian': '04',
  'name': '五家渠市',
  'level': 3
}, {
  'code': '710000',
  'sheng': '71',
  'di': '00',
  'xian': '00',
  'name': '台湾省',
  'level': 1
}, {
  'code': '810000',
  'sheng': '81',
  'di': '00',
  'xian': '00',
  'name': '香港特别行政区',
  'level': 1
}, {
  'code': '820000',
  'sheng': '82',
  'di': '00',
  'xian': '00',
  'name': '澳门特别行政区',
  'level': 1
}];

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAYS_OF_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIME_SLOTS; });
/* unused harmony export QUALIFICATION_CONFIG */
/* harmony export (immutable) */ __webpack_exports__["c"] = getDayLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSlotLabel;
/* unused harmony export getYearsEmployed */
/* unused harmony export isTeacherQualified */
/* unused harmony export getTeacherSlotCount */
/* harmony export (immutable) */ __webpack_exports__["e"] = getHeatLevel;
/* unused harmony export getGenderLabel */
/* unused harmony export getAccentLabel */

var DAYS_OF_WEEK = [{ key: 'monday', label: '周一' }, { key: 'tuesday', label: '周二' }, { key: 'wednesday', label: '周三' }, { key: 'thursday', label: '周四' }, { key: 'friday', label: '周五' }, { key: 'saturday', label: '周六' }, { key: 'sunday', label: '周日' }];

var TIME_SLOTS = [{ id: 'slot9', label: '17:00', startTime: '17:00', endTime: '17:30' }, { id: 'slot10', label: '17:30', startTime: '17:30', endTime: '18:00' }, { id: 'slot1', label: '18:00', startTime: '18:00', endTime: '18:30' }, { id: 'slot2', label: '18:30', startTime: '18:30', endTime: '19:00' }, { id: 'slot3', label: '19:00', startTime: '19:00', endTime: '19:30' }, { id: 'slot4', label: '19:30', startTime: '19:30', endTime: '20:00' }, { id: 'slot5', label: '20:00', startTime: '20:00', endTime: '20:30' }, { id: 'slot6', label: '20:30', startTime: '20:30', endTime: '21:00' }, { id: 'slot7', label: '21:00', startTime: '21:00', endTime: '21:30' }, { id: 'slot8', label: '21:30', startTime: '21:30', endTime: '22:00' }];

var QUALIFICATION_CONFIG = {
  minYearsEmployed: 1,
  minFillRate: 65,
  minBuyoutSlots: 28 };

function getDayLabel(day) {
  var item = DAYS_OF_WEEK.find(function (d) {
    return d.key === day;
  });
  return item ? item.label : '';
}

function getSlotLabel(slotId) {
  var item = TIME_SLOTS.find(function (s) {
    return s.id === slotId;
  });
  return item ? item.label : '';
}

function getYearsEmployed(hireDate) {
  var hire = new Date(hireDate);
  var now = new Date();
  return (now.getTime() - hire.getTime()) / (1000 * 60 * 60 * 24 * 365);
}

function isTeacherQualified(teacher) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : QUALIFICATION_CONFIG;

  var yearsEmployed = getYearsEmployed(teacher.hireDate);

  var fillPct = teacher.fillRate <= 1 ? teacher.fillRate * 100 : teacher.fillRate;
  return yearsEmployed >= config.minYearsEmployed && fillPct >= config.minFillRate && teacher.buyoutSlots >= config.minBuyoutSlots;
}

function getTeacherSlotCount(teacherId, availability) {
  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';

  var teacherAvail = availability.find(function (a) {
    return a.teacherId === teacherId;
  });
  if (!teacherAvail) return 0;

  if (status === 'all') {
    return teacherAvail.slots.length;
  }
  return teacherAvail.slots.filter(function (s) {
    return s.status === status;
  }).length;
}

function getHeatLevel(count) {
  if (count === 0) return 0;
  if (count === 1) return 1;
  if (count === 2) return 2;
  if (count === 3) return 3;
  if (count === 4) return 4;
  return 5;
}

function getGenderLabel(gender) {
  return gender === 'male' ? '男' : '女';
}

function getAccentLabel(accent) {
  return accent === 'american' ? '美音' : '英音';
}

/***/ }),
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 256,
	"./af.js": 256,
	"./am-et": 257,
	"./am-et.js": 257,
	"./ar": 265,
	"./ar-dz": 258,
	"./ar-dz.js": 258,
	"./ar-kw": 259,
	"./ar-kw.js": 259,
	"./ar-ly": 260,
	"./ar-ly.js": 260,
	"./ar-ma": 261,
	"./ar-ma.js": 261,
	"./ar-ps": 262,
	"./ar-ps.js": 262,
	"./ar-sa": 263,
	"./ar-sa.js": 263,
	"./ar-tn": 264,
	"./ar-tn.js": 264,
	"./ar.js": 265,
	"./az": 266,
	"./az.js": 266,
	"./be": 267,
	"./be.js": 267,
	"./bg": 268,
	"./bg.js": 268,
	"./bm": 269,
	"./bm.js": 269,
	"./bn": 271,
	"./bn-bd": 270,
	"./bn-bd.js": 270,
	"./bn.js": 271,
	"./bo": 272,
	"./bo.js": 272,
	"./br": 273,
	"./br.js": 273,
	"./bs": 274,
	"./bs.js": 274,
	"./ca": 275,
	"./ca.js": 275,
	"./cs": 276,
	"./cs.js": 276,
	"./cv": 277,
	"./cv.js": 277,
	"./cy": 278,
	"./cy.js": 278,
	"./da": 279,
	"./da.js": 279,
	"./de": 282,
	"./de-at": 280,
	"./de-at.js": 280,
	"./de-ch": 281,
	"./de-ch.js": 281,
	"./de.js": 282,
	"./dv": 283,
	"./dv.js": 283,
	"./el": 284,
	"./el.js": 284,
	"./en-au": 285,
	"./en-au.js": 285,
	"./en-ca": 286,
	"./en-ca.js": 286,
	"./en-gb": 287,
	"./en-gb.js": 287,
	"./en-ie": 288,
	"./en-ie.js": 288,
	"./en-il": 289,
	"./en-il.js": 289,
	"./en-in": 290,
	"./en-in.js": 290,
	"./en-nz": 291,
	"./en-nz.js": 291,
	"./en-sg": 292,
	"./en-sg.js": 292,
	"./eo": 293,
	"./eo.js": 293,
	"./es": 297,
	"./es-do": 294,
	"./es-do.js": 294,
	"./es-mx": 295,
	"./es-mx.js": 295,
	"./es-us": 296,
	"./es-us.js": 296,
	"./es.js": 297,
	"./et": 298,
	"./et.js": 298,
	"./eu": 299,
	"./eu.js": 299,
	"./fa": 300,
	"./fa.js": 300,
	"./fi": 301,
	"./fi.js": 301,
	"./fil": 302,
	"./fil.js": 302,
	"./fo": 303,
	"./fo.js": 303,
	"./fr": 306,
	"./fr-ca": 304,
	"./fr-ca.js": 304,
	"./fr-ch": 305,
	"./fr-ch.js": 305,
	"./fr.js": 306,
	"./fy": 307,
	"./fy.js": 307,
	"./ga": 308,
	"./ga.js": 308,
	"./gd": 309,
	"./gd.js": 309,
	"./gl": 310,
	"./gl.js": 310,
	"./gom-deva": 311,
	"./gom-deva.js": 311,
	"./gom-latn": 312,
	"./gom-latn.js": 312,
	"./gu": 313,
	"./gu.js": 313,
	"./he": 314,
	"./he.js": 314,
	"./hi": 315,
	"./hi.js": 315,
	"./hr": 316,
	"./hr.js": 316,
	"./hu": 317,
	"./hu.js": 317,
	"./hy-am": 318,
	"./hy-am.js": 318,
	"./id": 319,
	"./id.js": 319,
	"./is": 320,
	"./is.js": 320,
	"./it": 322,
	"./it-ch": 321,
	"./it-ch.js": 321,
	"./it.js": 322,
	"./ja": 323,
	"./ja.js": 323,
	"./jv": 324,
	"./jv.js": 324,
	"./ka": 325,
	"./ka.js": 325,
	"./kk": 326,
	"./kk.js": 326,
	"./km": 327,
	"./km.js": 327,
	"./kn": 328,
	"./kn.js": 328,
	"./ko": 329,
	"./ko.js": 329,
	"./ku": 331,
	"./ku-kmr": 330,
	"./ku-kmr.js": 330,
	"./ku.js": 331,
	"./ky": 332,
	"./ky.js": 332,
	"./lb": 333,
	"./lb.js": 333,
	"./lo": 334,
	"./lo.js": 334,
	"./lt": 335,
	"./lt.js": 335,
	"./lv": 336,
	"./lv.js": 336,
	"./me": 337,
	"./me.js": 337,
	"./mi": 338,
	"./mi.js": 338,
	"./mk": 339,
	"./mk.js": 339,
	"./ml": 340,
	"./ml.js": 340,
	"./mn": 341,
	"./mn.js": 341,
	"./mr": 342,
	"./mr.js": 342,
	"./ms": 344,
	"./ms-my": 343,
	"./ms-my.js": 343,
	"./ms.js": 344,
	"./mt": 345,
	"./mt.js": 345,
	"./my": 346,
	"./my.js": 346,
	"./nb": 347,
	"./nb.js": 347,
	"./ne": 348,
	"./ne.js": 348,
	"./nl": 350,
	"./nl-be": 349,
	"./nl-be.js": 349,
	"./nl.js": 350,
	"./nn": 351,
	"./nn.js": 351,
	"./oc-lnc": 352,
	"./oc-lnc.js": 352,
	"./pa-in": 353,
	"./pa-in.js": 353,
	"./pl": 354,
	"./pl.js": 354,
	"./ps": 355,
	"./ps.js": 355,
	"./pt": 357,
	"./pt-br": 356,
	"./pt-br.js": 356,
	"./pt.js": 357,
	"./ro": 358,
	"./ro.js": 358,
	"./ru": 359,
	"./ru.js": 359,
	"./sd": 360,
	"./sd.js": 360,
	"./se": 361,
	"./se.js": 361,
	"./si": 362,
	"./si.js": 362,
	"./sk": 363,
	"./sk.js": 363,
	"./sl": 364,
	"./sl.js": 364,
	"./sq": 365,
	"./sq.js": 365,
	"./sr": 367,
	"./sr-cyrl": 366,
	"./sr-cyrl.js": 366,
	"./sr.js": 367,
	"./ss": 368,
	"./ss.js": 368,
	"./sv": 369,
	"./sv.js": 369,
	"./sw": 370,
	"./sw.js": 370,
	"./ta": 371,
	"./ta.js": 371,
	"./te": 372,
	"./te.js": 372,
	"./tet": 373,
	"./tet.js": 373,
	"./tg": 374,
	"./tg.js": 374,
	"./th": 375,
	"./th.js": 375,
	"./tk": 376,
	"./tk.js": 376,
	"./tl-ph": 377,
	"./tl-ph.js": 377,
	"./tlh": 378,
	"./tlh.js": 378,
	"./tr": 379,
	"./tr.js": 379,
	"./tzl": 380,
	"./tzl.js": 380,
	"./tzm": 382,
	"./tzm-latn": 381,
	"./tzm-latn.js": 381,
	"./tzm.js": 382,
	"./ug-cn": 383,
	"./ug-cn.js": 383,
	"./uk": 384,
	"./uk.js": 384,
	"./ur": 385,
	"./ur.js": 385,
	"./uz": 387,
	"./uz-latn": 386,
	"./uz-latn.js": 386,
	"./uz.js": 387,
	"./vi": 388,
	"./vi.js": 388,
	"./x-pseudo": 389,
	"./x-pseudo.js": 389,
	"./yo": 390,
	"./yo.js": 390,
	"./zh-cn": 391,
	"./zh-cn.js": 391,
	"./zh-hk": 392,
	"./zh-hk.js": 392,
	"./zh-mo": 393,
	"./zh-mo.js": 393,
	"./zh-tw": 394,
	"./zh-tw.js": 394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;

/***/ }),
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fox.3848d55.png";

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjU1LjQ3MTMiIGhlaWdodD0iNTUuNDcxMyIgdmlld0JveD0iMCAwIDU1LjQ3MTMgNTUuNDcxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDkyOCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0yNy43MzU3IDU1LjQ3MTNDNDMuMDUzNyA1NS40NzEzIDU1LjQ3MTMgNDMuMDUzNyA1NS40NzEzIDI3LjczNTdDNTUuNDcxMyAxMi40MTc3IDQzLjA1MzcgMCAyNy43MzU3IDBDMTIuNDE3NyAwIDAgMTIuNDE3NyAwIDI3LjczNTdDMCA0My4wNTM3IDEyLjQxNzcgNTUuNDcxMyAyNy43MzU3IDU1LjQ3MTNaIiBmaWxsPSIjRkY4QTJCIi8+CjxnIGlkPSJHcm91cCA5MjciPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0yMC42ODQxIDMyLjQzMzdDMjAuNjg0MSAzMC42MTYzIDE5LjAwMDMgMjkuMTQzMSAxNi45MjMzIDI5LjE0MzFDMTQuODQ2MyAyOS4xNDMxIDEzLjE2MjYgMzAuNjE2MyAxMy4xNjI2IDMyLjQzMzdWMzguMDc0OUMxMy4xNjI2IDM5Ljg5MjMgMTQuODQ2MyA0MS4zNjU2IDE2LjkyMzMgNDEuMzY1NkMxOS4wMDAzIDQxLjM2NTYgMjAuNjg0MSAzOS44OTIzIDIwLjY4NDEgMzguMDc0OVYzMi40MzM3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNMzEuMDI2IDIzLjE4MDRDMzEuMDI2IDIxLjI4MDQgMjkuNTUyNyAxOS43NDAyIDI3LjczNTMgMTkuNzQwMkMyNS45MTggMTkuNzQwMiAyNC40NDQ3IDIxLjI4MDQgMjQuNDQ0NyAyMy4xODA0VjM3LjkyNDNDMjQuNDQ0NyAzOS44MjQzIDI1LjkxOCA0MS4zNjQ2IDI3LjczNTMgNDEuMzY0NkMyOS41NTI3IDQxLjM2NDYgMzEuMDI2IDM5LjgyNDMgMzEuMDI2IDM3LjkyNDNWMjMuMTgwNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGlkPSJWZWN0b3JfNCIgZD0iTTQxLjM2OCAxNC42NzEzQzQxLjM2OCAxMi43OTUzIDM5Ljg5NDggMTEuMjc0NSAzOC4wNzc0IDExLjI3NDVDMzYuMjYgMTEuMjc0NSAzNC43ODY3IDEyLjc5NTMgMzQuNzg2NyAxNC42NzEzVjM3Ljk2MzhDMzQuNzg2NyAzOS44Mzk4IDM2LjI2IDQxLjM2MDYgMzguMDc3NCA0MS4zNjA2QzM5Ljg5NDggNDEuMzYwNiA0MS4zNjggMzkuODM5OCA0MS4zNjggMzcuOTYzOFYxNC42NzEzWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiB2aWV3Qm94PSIwIDAgNTYgNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJvdmVyYWxsLWV2YWx1YXRpb24iPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMjggNTZDNDMuNDY0IDU2IDU2IDQzLjQ2NCA1NiAyOEM1NiAxMi41MzYgNDMuNDY0IDAgMjggMEMxMi41MzYgMCAwIDEyLjUzNiAwIDI4QzAgNDMuNDY0IDEyLjUzNiA1NiAyOCA1NloiIGZpbGw9IiNGRjhBMkIiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMjggMTQuOTMzM0wxNS44NjY3IDM3LjMzMzNINDAuMTMzM0wyOCAxNC45MzMzWiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNMjggMTkuNkMzMC41NzczIDE5LjYgMzIuNjY2NyAxNy41MTA3IDMyLjY2NjcgMTQuOTMzM0MzMi42NjY3IDEyLjM1NiAzMC41NzczIDEwLjI2NjcgMjggMTAuMjY2N0MyNS40MjI3IDEwLjI2NjcgMjMuMzMzMyAxMi4zNTYgMjMuMzMzMyAxNC45MzMzQzIzLjMzMzMgMTcuNTEwNyAyNS40MjI3IDE5LjYgMjggMTkuNloiIGZpbGw9IiNGRjhBMkIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBpZD0iVmVjdG9yXzQiIGQ9Ik0xNS44NjY3IDQyQzE4LjQ0NCA0MiAyMC41MzMzIDM5LjkxMDcgMjAuNTMzMyAzNy4zMzMzQzIwLjUzMzMgMzQuNzU2IDE4LjQ0NCAzMi42NjY3IDE1Ljg2NjcgMzIuNjY2N0MxMy4yODkzIDMyLjY2NjcgMTEuMiAzNC43NTYgMTEuMiAzNy4zMzMzQzExLjIgMzkuOTEwNyAxMy4yODkzIDQyIDE1Ljg2NjcgNDJaIiBmaWxsPSIjRkY4QTJCIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggaWQ9IlZlY3Rvcl81IiBkPSJNNDAuMTMzMyA0MkM0Mi43MTA3IDQyIDQ0LjggMzkuOTEwNyA0NC44IDM3LjMzMzNDNDQuOCAzNC43NTYgNDIuNzEwNyAzMi42NjY3IDQwLjEzMzMgMzIuNjY2N0MzNy41NTYgMzIuNjY2NyAzNS40NjY3IDM0Ljc1NiAzNS40NjY3IDM3LjMzMzNDMzUuNDY2NyAzOS45MTA3IDM3LjU1NiA0MiA0MC4xMzMzIDQyWiIgZmlsbD0iI0ZGOEEyQiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI0Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhGQAZAIABAElQYAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozMzQ4Qzk3QTM2NzAxMUU5OTU2QkIzREM5MDdEQTAxNyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozMzQ4Qzk3QjM2NzAxMUU5OTU2QkIzREM5MDdEQTAxNyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjMzNDhDOTc4MzY3MDExRTk5NTZCQjNEQzkwN0RBMDE3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjMzNDhDOTc5MzY3MDExRTk5NTZCQjNEQzkwN0RBMDE3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAQAsAAAAABkAGQAAAieMj6nL7Q+jnLTaSwHARm/sfVmoWWRZneKkmuf1gh4XzDRK5/rOYwUAIfkEBRcAAQAsCgAKAAMACAAAAgdEbqiR5lcAACH5BAUbAAEALA8ABwADAA0AAAIKRAKGl+wLTZPyFAAh+QQFKAABACwUAAUABAAQAAACDkQOhpoX/Zh6Tq4LW3YFADs="

/***/ }),
/* 1298 */,
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1703),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1884),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc198014",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30107d9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1789),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f11eab1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1982),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1960),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1857),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e4d92f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e288708",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1810),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-588fdf1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19d6df36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1901),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1757),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ecc15f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1906),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-965e3362",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1790),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f742200",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a0eda524",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1863),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1791),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ffb2c8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1745),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a84832f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1756),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01c6078a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14eb6a02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6e5cf8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33879e3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1766),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1867),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1625),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28cd9ffd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1847),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1679),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1932),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07cc4b5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1883),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a4eb168",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1947),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1229)
  __webpack_require__(1230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1946),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bdd53cd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1641),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1680),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1695),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1176)
  __webpack_require__(1175)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1845),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66f2807e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1838),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f2d97d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1873),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1640),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1717),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
  __webpack_require__(1046)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14405e24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1102)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-361c80b9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1896),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8907c798",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1682),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1866),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1898),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-897222f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-618e689c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1748),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-058ef0fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2272265f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1796),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3786e74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1881),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1690),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1771),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1683),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1916),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1114)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1753),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d412f64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1622),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fea98ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06da9061",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28d5f352",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1921),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3d81c5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1976),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1837),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1878),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1752),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1687),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1929),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1977),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1963),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1826),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1765),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1811),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58e10340",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1767),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4426c574",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a07b145a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da1a87c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-568b3b1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1148)
  __webpack_require__(1149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1809),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58038a96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1662),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-618166ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1098)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34f52142",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1667),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b022b6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2db93d1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1989),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fe27a288",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cbc4114",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1744),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a52b2e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7c72740",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1227)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bdae10aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d540468",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1922),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3e402dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52b40886",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1865),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71823a99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ccd39590",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1899),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8a6ecdac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1973),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1781),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1816),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1220)
  __webpack_require__(1221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1935),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1871),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75888efa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1122)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1770),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44f704ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1591),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1244)
  __webpack_require__(1243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e557aa62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1665),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1706),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1691),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1803),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1673),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1848),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68262782",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1685),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1215)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1928),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1164)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1829),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-615fed00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1664),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1853),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1746),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1732),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36032612",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1979),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1900),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1684),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1923),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1940),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1689),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1654),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1637),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1121)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1768),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1937),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1726),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-345c94bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1820),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1986),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1905),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26d48a14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1156)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1819),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e767812",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1693),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1775),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46f91d6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0855b413",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1728),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34e21426",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1772),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45c9b0ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1776),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1190)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1869),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74bed6b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07e01dec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1130)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1785),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c23e002",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3120de8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1978),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1886),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1862),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1793),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5086145f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae25b1e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17a1fa1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1acc4acf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5139892f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1204)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1911),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99b92ee8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22827b0b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47a59e7d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1168)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1835),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-628bb4d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1090)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3074d92b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ba4824e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-298e4e75",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1205)
  __webpack_require__(1206)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1912),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a54ec76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1184)
  __webpack_require__(1185)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1858),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e4ff8ed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1797),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-537044b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1890),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1938),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9655560",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1874),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1958),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1713),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17ed5da0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05f31fcf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1908),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96e27e4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28ee2df4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-add373d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1818),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1742),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1162)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1827),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60de6c2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-089b5ba8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b119404",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1854),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b5472b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1934),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b43e160e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1731),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35485d36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1918),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1926),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a804e512",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1910),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1131)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4df7b6d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa068bfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1611),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26341801",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bdd0a466",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1971),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2197f2b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1186)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e6fa614",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1750),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c1a4480",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f9ac19c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15afef88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1704),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a2aa0be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1952),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1769),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1877),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1784),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1844),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06563332",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65eec272",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1030)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03edc3be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-037470b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f05412a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1159)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1822),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f9f6037",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1160)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fbf580e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1850),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6934697a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7e2244a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1959),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1623),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1712),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1807),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1629),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1798),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1860),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f69c8b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
  __webpack_require__(1075)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-280a4b44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1830),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1161)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1825),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-607b7d2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24c395ad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-054fd3b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1936),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1851),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1709),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddbac40e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1734),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(1614),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1814),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bb5d2b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1083)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b7a0804",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1647),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1894),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1715),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1943),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1902),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1875),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77889124",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1800),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-548da162",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1849),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1163)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1828),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-612ea114",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1804),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-565acd4d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1053)
  __webpack_require__(1054)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17383fcc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
  __webpack_require__(1044)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13e77f32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1895),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8643099c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1856),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d16657b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-390d9e29",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29c576bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1833),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1780),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1870),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1624),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1941),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "批量编辑",
      "width": "680"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作范围"
    }
  }, [_c('Radio-group', {
    on: {
      "on-change": _vm.onScopeChange
    },
    model: {
      value: (_vm.form.scope),
      callback: function($$v) {
        _vm.$set(_vm.form, "scope", $$v)
      },
      expression: "form.scope"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "IDS"
    }
  }, [_vm._v("勾选题目 ID（" + _vm._s(_vm.selectedCount) + "）")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "LEVEL"
    }
  }, [_vm._v("按级别")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "TYPE"
    }
  }, [_vm._v("按题型")])], 1)], 1), _vm._v(" "), (_vm.form.scope === 'IDS') ? _c('Form-item', {
    key: "scope-ids",
    attrs: {
      "label": "题目 ID"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "已勾选会自动填入该行版本 ID，也可逗号或换行补充"
    },
    model: {
      value: (_vm.form.ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "ids", $$v)
      },
      expression: "form.ids"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.scope === 'LEVEL') ? _c('Form-item', {
    key: "scope-level",
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "placeholder": "选择一个或多个级别"
    },
    model: {
      value: (_vm.form.levelCodes),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCodes", $$v)
      },
      expression: "form.levelCodes"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.scope === 'TYPE') ? _c('Form-item', {
    key: "scope-type",
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "选择题库中的题型"
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, _vm.typeSkill)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bank === 'comp' && _vm.form.scope !== 'IDS') ? _c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "不选则该级别/题型全部技能"
    },
    on: {
      "on-change": _vm.loadQuestionTypes
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.form.updateEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateEn", $$v)
      },
      expression: "form.updateEn"
    }
  }, [_vm._v("修改 question_direction")]), _vm._v(" "), (_vm.form.updateEn) ? _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "将覆盖选中题目当前版本的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.form.updateCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateCn", $$v)
      },
      expression: "form.updateCn"
    }
  }, [_vm._v("修改 question_direction_chinese")]), _vm._v(" "), (_vm.form.updateCn) ? _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "将覆盖选中题目当前版本的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Radio-group', {
    model: {
      value: (_vm.form.statusAction),
      callback: function($$v) {
        _vm.$set(_vm.form, "statusAction", $$v)
      },
      expression: "form.statusAction"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("不改状态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "online"
    }
  }, [_vm._v("上线")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "offline"
    }
  }, [_vm._v("下线")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "discard"
    }
  }, [_vm._v("废弃")])], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("已上线须先下线再废弃。指令改当前版本，不升版本。")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配学习导师"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id + ' - ' + item.nickname) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "userStudyAdviser",
      "needDefaultStudyAdviser": "0",
      "transfer": ""
    },
    model: {
      value: (_vm.adviserParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "studyAdviserId", $$v)
      },
      expression: "adviserParam.studyAdviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配原因",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.adviserParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "reason", $$v)
      },
      expression: "adviserParam.reason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新生分配")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("离职原因")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("投诉属实更换班主任")]), _vm._v(" "), _c('Option', {
    key: "5",
    attrs: {
      "value": "5"
    }
  }, [_vm._v("无效投诉更换班主任 ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "640",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "trackForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "入职 / 节点日"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.hireDate) || '—') + " / " + _vm._s((_vm.row && _vm.row.reviewDue) || '—'))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "trackType"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "transfer": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.form.trackType),
      callback: function($$v) {
        _vm.$set(_vm.form, "trackType", $$v)
      },
      expression: "form.trackType"
    }
  }, _vm._l((_vm.trackTypes), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('div', {
    on: {
      "paste": _vm.handleContentPaste
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": 2000,
      "placeholder": "填写回访/跟踪内容，可粘贴图片作为附件"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "上传附件"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTrackFileChange,
      "on-success": _vm.trackFileSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTrackFile,
      "limit": 5,
      "multiple": "",
      "file-list": _vm.defaultPicsList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("教材报错")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "提交时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "align": "right",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": _vm.onDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.loadLevelIds
    },
    model: {
      value: (_vm.queryParam.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersionId", $$v)
      },
      expression: "queryParam.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "课程等级："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", $$v)
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师ID："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师姓名："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "处理方式："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.lessonErrStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookMaterialLessonsErr/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师代课记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.oldTchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "oldTchId", $$v)
      },
      expression: "queryParam.oldTchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课类型"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.queryParam.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "type", $$v)
      },
      expression: "queryParam.type"
    }
  }, [_c('Option', {
    attrs: {
      "value": "老师请假-人工代课"
    }
  }, [_vm._v("老师请假-人工代课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "老师请假-自动代课"
    }
  }, [_vm._v("老师请假-自动代课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "更换老师"
    }
  }, [_vm._v("更换老师")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "新老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.newTchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "newTchId", $$v)
      },
      expression: "queryParam.newTchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "tchChange/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reloadWithPage": _vm.reloadWithPage,
      "operator": ""
    }
  }), _vm._v(" "), _c('SearchChangeTchModal', {
    attrs: {
      "optType": _vm.optType,
      "user": _vm.tempLessonUser,
      "changeTeacherOnly": _vm.changeTeacherOnly,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showSearchChangeTchModal),
      callback: function($$v) {
        _vm.showSearchChangeTchModal = $$v
      },
      expression: "showSearchChangeTchModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("朋友圈分享审核列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "lable-positon": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.bookCourseChangeStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "活动类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "type", _vm._n($$v))
      },
      expression: "queryParam.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("朋友圈")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "checkAdmin"
    },
    model: {
      value: (_vm.queryParam.auditorName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditorName", $$v)
      },
      expression: "queryParam.auditorName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activityExamine/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "查看买断时间",
      "width": "450"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "买断时间"
    }
  }, [_c('Checkbox-group', {
    model: {
      value: (_vm.openedTimeIdList),
      callback: function($$v) {
        _vm.openedTimeIdList = $$v
      },
      expression: "openedTimeIdList"
    }
  }, _vm._l((_vm.openedTimeList), function(item) {
    return _c('Checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr))])])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list leaderboard-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("招聘龙虎榜")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-head"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("外教招聘龙虎榜")]), _vm._v(" "), _c('span', {
    staticClass: "page-badge"
  }, [_c('Icon', {
    attrs: {
      "type": "trophy"
    }
  }), _vm._v(" 招聘绩效")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "lb-toolbar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("时间")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "88px"
    },
    attrs: {
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onPeriodChange
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, _vm._l((_vm.periodOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), (_vm.period === 'day' || _vm.period === 'week') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading,
      "title": _vm.period === 'week' ? '选择该周内任意一天，自动对齐到周一' : ''
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period === 'month') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period === 'year') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "year",
      "format": "yyyy",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rangeText) ? _c('span', {
    staticClass: "toolbar-range"
  }, [_vm._v(_vm._s(_vm.rangeText))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "toolbar-label",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.hr),
      callback: function($$v) {
        _vm.hr = $$v
      },
      expression: "hr"
    }
  }, _vm._l((_vm.hrOptions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('p', {
    staticClass: "table-tip"
  }, [_vm._v("按开课数倒序；新外教60天内离职量 ÷ 开课数 ≥ 15% 的行标红")]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.tableRows,
      "loading": _vm.loading,
      "row-class-name": _vm.rowClassName,
      "no-data-text": "暂无数据"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.showModal.showModel),
      callback: function($$v) {
        _vm.$set(_vm.showModal, "showModel", $$v)
      },
      expression: "showModal.showModel"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("请单节课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("请长假")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("申请停课")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showModal.showModel == 1) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择课程：",
      "prop": "status"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.showModal.id),
      callback: function($$v) {
        _vm.$set(_vm.showModal, "id", $$v)
      },
      expression: "showModal.id"
    }
  }, _vm._l((_vm.userLessonOpend), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.stringLsnTime) + " " + _vm._s(item.lessonTitle))])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showModal.showModel == 2 || _vm.showModal.showModel == 3) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间",
      "value": _vm.leaveParam.startTimeStr
    },
    on: {
      "on-change": _vm.startTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间",
      "value": _vm.leaveParam.endTimeStr
    },
    on: {
      "on-change": _vm.endTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.onBookLessonOpened
    }
  }, [_vm._v("查看涉及课节")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showModal.showModel == 2 || _vm.showModal.showModel == 3) ? _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("奖惩机制")])], 1)], 1), _vm._v(" "), _c('div', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "headers": _vm.headers,
      "accept": _vm.acceptType,
      "on-success": _vm.upScuccess
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "imgInput",
      "element-loading-text": "插入中,请稍候"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recruit-dash-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("国籍")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部国籍"
    },
    on: {
      "on-enter": _vm.applyNationality,
      "on-blur": _vm.applyNationality
    },
    model: {
      value: (_vm.nationalityInput),
      callback: function($$v) {
        _vm.nationalityInput = $$v
      },
      expression: "nationalityInput"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("渠道")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "全部渠道",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.filters.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.filters, "regFrom", $$v)
      },
      expression: "filters.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部HR",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.filters.hr),
      callback: function($$v) {
        _vm.$set(_vm.filters, "hr", $$v)
      },
      expression: "filters.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("时间")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "value": _vm.dateRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": false,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    }
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.setQuickRange(7)
      }
    }
  }, [_vm._v("近7天")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.setQuickRange(30)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    staticClass: "filter-spin",
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, _vm._l((_vm.kpiCards), function(card) {
    return _c('article', {
      key: card.key,
      staticClass: "kpi-card",
      class: ['is-' + card.level, {
        'is-clickable': !!card.link
      }],
      on: {
        "click": function($event) {
          return _vm.openCard(card)
        }
      }
    }, [_c('div', {
      staticClass: "kpi-bar"
    }), _vm._v(" "), _c('div', {
      staticClass: "kpi-body"
    }, [_c('div', {
      staticClass: "kpi-title"
    }, [_c('i', {
      staticClass: "kpi-dot"
    }), _vm._v("\n            " + _vm._s(card.title) + "\n            "), (card.link) ? _c('Icon', {
      staticClass: "kpi-link",
      attrs: {
        "type": "ios-arrow-right"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(card.value)), _c('span', {
      staticClass: "kpi-unit"
    }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-period-row"
    }, [_c('span', {
      staticClass: "kpi-period"
    }, [_vm._v(_vm._s(card.period))]), _vm._v(" "), _c('span', {
      staticClass: "kpi-compare"
    }, [_vm._v(_vm._s(card.compare))])]), _vm._v(" "), _c('p', {
      staticClass: "kpi-foot"
    }, [_vm._v(_vm._s(card.foot))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("环节流转（按日）")]), _vm._v(" "), _c('Button', {
    staticClass: "dash-export",
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportTrend
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('p', {
    staticClass: "section-desc"
  }, [_vm._v("每天进入各环节的人数，按 tch_recruit_flow 流转记录统计；当前区间 " + _vm._s(_vm.rangeText))]), _vm._v(" "), _c('div', {
    staticClass: "block-card"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.trendColumns,
      "data": _vm.trendRows,
      "loading": _vm.loading,
      "height": _vm.trendTableHeight,
      "row-class-name": _vm.trendRowClass,
      "size": "small"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外教招聘数据看板")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("Teacher Recruitment Dashboard / 招聘漏斗 / 今日待办 / 环节流转")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("招聘漏斗")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 主数字为筛选后人数，右侧为不加筛选的全局人数")])])
}]}

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("课程顾问跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课顾汇总数据详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.nickName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickName", $$v)
      },
      expression: "queryParam.nickName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "label-width": 75
    }
  }, [_c('channel-select', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminUser/getAdviserDataDetail",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Excel导入请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.leaveParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "leaveType", $$v)
      },
      expression: "leaveParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "无需代课："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.leaveParam.noProxy),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "noProxy", $$v)
      },
      expression: "leaveParam.noProxy"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "说明",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.uploadLeaveUrl,
      "on-change": _vm.handleChange,
      "headers": _vm.headers,
      "on-success": _vm.handleSuccess,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "data": this.leaveParam,
      "accept": ".xls,.xlsx",
      "limit": 1,
      "multiple": false,
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传请假文件")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员转移工单",
      "width": "450"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.fromRules
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", $$v)
      },
      expression: "formData.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('p', {
    staticClass: "thick"
  }, [_vm._v("确认转移学员" + _vm._s(_vm.formData.uid) + "-" + _vm._s(_vm.formData.nickname) + "至学导部门？")])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("否")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("常规生转化率列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM",
      "placeholder": "请选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryParam.estimateEndYearMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "estimateEndYearMonth", $$v)
      },
      expression: "queryParam.estimateEndYearMonth"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyConsultantId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyConsultantId", $$v)
      },
      expression: "queryParam.studyConsultantId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/dataCenter/finishRenewalRateList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外教首课签到")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择开始日期"
    },
    on: {
      "on-change": _vm.onStartDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "结束日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择结束日期"
    },
    on: {
      "on-change": _vm.onEndDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId",
      "placeholder": "请输入老师ID"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外管"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                  " + _vm._s(item.nickname) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否签到"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.hasSign),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasSign", $$v)
      },
      expression: "queryParam.hasSign"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已签到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("未签到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("晚签到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("迟签到")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Time-picker', {
    attrs: {
      "type": "time",
      "format": "HH:mm",
      "value-format": "HH:mm:ss",
      "placeholder": "选择上课时间"
    },
    on: {
      "on-change": _vm.onLsnBeginTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    },
    on: {
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.pagination.totalCount,
      "current": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage,
      "on-page-size-change": _vm.changePageSize
    }
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "手动登记出勤",
      "width": "520",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师 ID",
      "required": ""
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "在职外教 ID"
    },
    model: {
      value: (_vm.form.tchId),
      callback: function($$v) {
        _vm.$set(_vm.form, "tchId", $$v)
      },
      expression: "form.tchId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "日期",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.date,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.date = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "可空，最长 1000 字"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("登记")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "board-bar"
  }, [_c('div', [_c('div', {
    staticClass: "board-range"
  }, [_vm._v(_vm._s(_vm.rangeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "board-stat"
  }, [_vm._v("\n        本周共 " + _vm._s(_vm.stats.total) + " 场已安排面试 · " + _vm._s(_vm.stats.confirmed) + " 场已确定 · " + _vm._s(_vm.stats.unbooked) + " 待预约 ·\n        空格点击 + 新增 · 已有面试的格子可再点 + 叠加\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "board-nav"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "icon": "chevron-left"
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(-7)
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goThisWeek
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "icon": "chevron-right"
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(7)
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "icon": "refresh",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "board-grid-wrap"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "board-grid"
  }, [_c('div', {
    staticClass: "cell cell-head cell-time"
  }, [_vm._v("Time")]), _vm._v(" "), _vm._l((_vm.weekDays), function(day, i) {
    return _c('div', {
      key: day.ymd,
      staticClass: "cell cell-head",
      class: {
        'is-today': day.ymd === _vm.todayYmd
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.dayLabels[i]))]), _vm._v(" "), _c('div', {
      staticClass: "cell-date"
    }, [_vm._v(_vm._s(day.md))])])
  }), _vm._v(" "), _vm._l((_vm.slots), function(ts) {
    return [_c('div', {
      key: 't' + ts.startMin,
      staticClass: "cell cell-time"
    }, [_vm._v(_vm._s(ts.label))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day, dayIdx) {
      return _c('div', {
        key: dayIdx + '-' + ts.startMin,
        staticClass: "cell cell-body"
      }, [(!_vm.slotItems(dayIdx, ts.startMin).length) ? _c('button', {
        staticClass: "slot-add",
        attrs: {
          "type": "button",
          "title": "新增面试"
        },
        on: {
          "click": function($event) {
            return _vm.openAdd(day, ts.startMin)
          }
        }
      }, [_vm._v("+")]) : [_vm._l((_vm.slotItems(dayIdx, ts.startMin)), function(t) {
        return _c('div', {
          key: t.tchId,
          staticClass: "slot-card",
          class: {
            'is-unbooked': _vm.isUnbooked(t)
          },
          on: {
            "click": function($event) {
              return _vm.$emit('open-tch', t)
            }
          }
        }, [_c('a', {
          staticClass: "slot-clear",
          attrs: {
            "title": "清除此时段"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.clear(t)
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": "close"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "slot-name",
          attrs: {
            "title": t.tchId + ' ' + _vm.nameOf(t)
          }
        }, [_vm._v(_vm._s(t.tchId) + " " + _vm._s(_vm.nameOf(t)))]), _vm._v(" "), _c('div', {
          staticClass: "slot-state"
        }, [_vm._v(_vm._s(_vm.isUnbooked(t) ? '未预约 / Not booked' : '已确定 / Confirmed'))])])
      }), _vm._v(" "), _c('button', {
        staticClass: "slot-add is-more",
        attrs: {
          "type": "button",
          "title": "再新增一位"
        },
        on: {
          "click": function($event) {
            return _vm.openAdd(day, ts.startMin)
          }
        }
      }, [_vm._v("+")])]], 2)
    })]
  })], 2), _vm._v(" "), (_vm.outsideItems.length) ? _c('div', {
    staticClass: "board-outside"
  }, [_c('span', {
    staticClass: "outside-title"
  }, [_vm._v("不在 14:00-21:30 时段内的面试：")]), _vm._v(" "), _vm._l((_vm.outsideItems), function(t) {
    return _c('Tag', {
      key: t.tchId,
      attrs: {
        "closable": ""
      },
      on: {
        "on-close": function($event) {
          return _vm.clear(t)
        }
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.$emit('open-tch', t)
        }
      }
    }, [_vm._v(_vm._s(t.tchId) + " " + _vm._s(_vm.nameOf(t)))]), _vm._v(" " + _vm._s(t.interviewTime) + "\n      ")])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "安排面试到此时段",
      "mask-closable": false
    },
    model: {
      value: (_vm.addVisible),
      callback: function($$v) {
        _vm.addVisible = $$v
      },
      expression: "addVisible"
    }
  }, [(_vm.addSlot) ? _c('p', {
    staticClass: "add-slot-text"
  }, [_vm._v(_vm._s(_vm.addSlot.ymd) + " · " + _vm._s(_vm.addSlot.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-label"
  }, [_vm._v("选择老师")]), _vm._v(" "), _c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "请选择待面试老师"
    },
    model: {
      value: (_vm.pickedTchId),
      callback: function($$v) {
        _vm.pickedTchId = $$v
      },
      expression: "pickedTchId"
    }
  }, _vm._l((_vm.candidates), function(t) {
    return _c('Option', {
      key: t.tchId,
      attrs: {
        "value": t.tchId,
        "label": t.tchId + ' · ' + _vm.nameOf(t)
      }
    }, [_vm._v("\n        " + _vm._s(t.tchId) + " · " + _vm._s(_vm.nameOf(t)) + _vm._s(t.interviewTime ? '（已有安排，将改期）' : '') + "\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.confirmAdd
    }
  }, [_vm._v("确认安排")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('div', [_c('div', {
    staticClass: "board-title"
  }, [_vm._v("面试时间表")]), _vm._v(" "), _c('div', {
    staticClass: "board-sub"
  }, [_vm._v("按自然周查看每日面试安排")])])])
}]}

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学员生命周期")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-position": "left",
      "label-width": 80
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32,
      "index": "1"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [(_vm.queryParam.dayOfMonth == 0) ? _c('FormItem', {
    attrs: {
      "label": "选择日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placement": "bottom-start",
      "format": "yyyy-MM-dd",
      "type": _vm.type,
      "value": _vm.defaultDate,
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.getTimeDateChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.queryParam.dayOfMonth == 1) ? _c('FormItem', {
    attrs: {
      "label": "选择月:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": _vm.type,
      "placeholder": "选择月"
    },
    on: {
      "on-change": _vm.getTimeMonthChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "查看方式:"
    }
  }, [_c('Radio-group', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.dayOfMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "dayOfMonth", $$v)
      },
      expression: "queryParam.dayOfMonth"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("按日查看")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("按月查看")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n      ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.table,
      "listUrl": "/data/report/querystudyadviserdata",
      "params": _vm.queryParam,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "规则"
    },
    model: {
      value: (_vm.tableRulePrompt),
      callback: function($$v) {
        _vm.tableRulePrompt = $$v
      },
      expression: "tableRulePrompt"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tableRulePromptContent) + "\n        "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生早退详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listStudentEarlyDetail",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('EarlyLessonMemeberTimeModal', {
    attrs: {
      "openedId": _vm.openId
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "新增课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", $$v)
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", $$v)
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('uploader', {
    staticClass: "uploader-example",
    attrs: {
      "options": _vm.options
    },
    on: {
      "file-success": _vm.uploadSucess
    }
  }, [_c('uploader-unsupport'), _vm._v(" "), _c('uploader-drop', [_c('p', {
    staticClass: "info"
  }, [_vm._v("上传本地课前预习"), _c('span', [_vm._v("(注意将主页面改为index.html)")])]), _vm._v(" "), _c('uploader-btn', {
    attrs: {
      "directory": true
    }
  }, [_vm._v("选择一个文件夹")])], 1), _vm._v(" "), _c('uploader-list')], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "performance-detail"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('h1', [_vm._v("班主任业绩详情")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.adviserName))])]), _vm._v(" "), _c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回班主任龙虎榜")])], 1)]), _vm._v(" "), _c('Card', {
    staticClass: "search-card"
  }, [_c('Form', {
    attrs: {
      "model": _vm.queryParam,
      "label-width": 80,
      "inline": ""
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份",
      "value": _vm.queryParam.month
    },
    on: {
      "on-change": _vm.onMonthChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "师资",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择师资",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" 搜索\n          ")], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-download"
    }
  }), _vm._v(" 导出\n          ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "table-card"
  }, [(_vm.tableData.length > 0) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "data-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("成交日期")]), _vm._v(" "), _c('th', [_vm._v("报名时间")]), _vm._v(" "), _c('th', [_vm._v("学生ID")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("收费")]), _vm._v(" "), _c('th', [_vm._v("基础课时")]), _vm._v(" "), _c('th', [_vm._v("赠送课时")]), _vm._v(" "), _c('th', [_vm._v("师资")]), _vm._v(" "), _c('th', [_vm._v("课程顾问")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("订单类型")]), _vm._v(" "), _c('th', [_vm._v("渠道")]), _vm._v(" "), _c('th', [_vm._v("转介绍")]), _vm._v(" "), _c('th', [_vm._v("转介绍学员班主任")]), _vm._v(" "), _c('th', [_vm._v("备注")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.dealDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.signUpTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$numeral(item.amount).format('0,0')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.baseHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.giftHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.teacherType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.adviserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.studyAdviserName))]), _vm._v(" "), _c('td', {
      class: _vm.getChannelClass(item.channel)
    }, [_vm._v(_vm._s(item.channel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.referralSC))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.referralSCName))]), _vm._v(" "), _c('td', [_c('Input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "请输入备注"
      },
      on: {
        "on-change": function($event) {
          return _vm.handleRemarkChange(item)
        }
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("合计 " + _vm._s(_vm.tableData.length) + " 条")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.$numeral(_vm.totalAmount).format('0,0')))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  })])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tableData.length === 0 && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-inbox",
      "size": "60",
      "color": "#dcdee2"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.noPermission ? '只能查看自己的业绩详情' : '暂无数据'))]), _vm._v(" "), (_vm.noPermission) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回班主任龙虎榜")]) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员批量结课"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "BatchCompletedCoursesForm",
    staticClass: "form",
    attrs: {
      "model": _vm.batchCompletedCoursesParam,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "id以 ; 拼接"
    },
    model: {
      value: (_vm.batchCompletedCoursesParam.uIds),
      callback: function($$v) {
        _vm.$set(_vm.batchCompletedCoursesParam, "uIds", $$v)
      },
      expression: "batchCompletedCoursesParam.uIds"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "结课类型",
      "prop": "completedType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.batchCompletedCoursesParam.completedType),
      callback: function($$v) {
        _vm.$set(_vm.batchCompletedCoursesParam, "completedType", _vm._n($$v))
      },
      expression: "batchCompletedCoursesParam.completedType"
    }
  }, _vm._l((_vm.completedTypeList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBatchCompletedCourses
    },
    on: {
      "click": _vm.batchCompletedCourses
    }
  }, [_vm._v("结课\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "赠送礼品",
      "width": "640"
    },
    on: {
      "on-visible-change": _vm.onVisible
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "礼品"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入礼品名称"
    },
    model: {
      value: (_vm.giftName),
      callback: function($$v) {
        _vm.giftName = $$v
      },
      expression: "giftName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('table', {
    staticClass: "track-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("赠送时间")]), _vm._v(" "), _c('th', [_vm._v("礼品")]), _vm._v(" "), _c('th', [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.records), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.gmtCreate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.giftName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.creatorName))])])
  }), _vm._v(" "), (!_vm.records.length) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "#999"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("暂无赠送记录")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师签到日志")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchEmail"
    },
    model: {
      value: (_vm.queryParam.tchEmail),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchEmail", $$v)
      },
      expression: "queryParam.tchEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchSignLog/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("在职老师请假率")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计月份"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份",
      "clearable": false
    },
    on: {
      "on-change": _vm.onMonthChange
    },
    model: {
      value: (_vm.monthDate),
      callback: function($$v) {
        _vm.monthDate = $$v
      },
      expression: "monthDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确匹配"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计指标"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.rateType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "rateType", $$v)
      },
      expression: "queryParam.rateType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "leave"
    }
  }, [_vm._v("请假率")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "late"
    }
  }, [_vm._v("迟到率")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "early"
    }
  }, [_vm._v("早退率")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportList
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('div', {
    staticClass: "rate-formula"
  }, [_vm._v(_vm._s(_vm.rateFormula))]), _vm._v(" "), _c('Table', {
    key: _vm.tableSortKey,
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": ""
    },
    on: {
      "on-sort-change": _vm.onSortChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.detailModalTitle,
      "width": "880",
      "mask-closable": true,
      "transfer": ""
    },
    model: {
      value: (_vm.showDetailModal),
      callback: function($$v) {
        _vm.showDetailModal = $$v
      },
      expression: "showDetailModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailList,
      "loading": _vm.detailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.detailTotal,
      "current": _vm.detailPageIndex,
      "page-size": _vm.detailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onDetailPageChange,
      "on-page-size-change": _vm.onDetailPageSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.detailExportLoading
    },
    on: {
      "click": _vm.exportDetail
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-content-preview"
  }, [(!_vm.content) ? _c('span', [_vm._v("—")]) : [_c('div', {
    ref: "clamp",
    staticClass: "track-md track-content-clamp",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }), _vm._v(" "), (_vm.overflow) ? _c('a', {
    staticClass: "track-content-view",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('view')
      }
    }
  }, [_vm._v("查看")]) : _vm._e()], _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-家长沟通确认记录-学导")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('span', [_vm._v("  是否确定绑定老师  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isBatchedTch),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isBatchedTch", $$v)
      },
      expression: "formValidate.isBatchedTch"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否确定绑定时间  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isBatchedTime),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isBatchedTime", $$v)
      },
      expression: "formValidate.isBatchedTime"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否核对外教主课时  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isCheckedForeignTchTime),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isCheckedForeignTchTime", $$v)
      },
      expression: "formValidate.isCheckedForeignTchTime"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否告知中教课上课规则  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.havaTellChineseLessonRule),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "havaTellChineseLessonRule", $$v)
      },
      expression: "formValidate.havaTellChineseLessonRule"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', [_vm._v("  是否告知请假制度  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.havaTellLeaveRule),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "havaTellLeaveRule", $$v)
      },
      expression: "formValidate.havaTellLeaveRule"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否加上家长微信  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.haveWebChat),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "haveWebChat", $$v)
      },
      expression: "formValidate.haveWebChat"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否告知自己的休息时间  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.haveTellRestTime),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "haveTellRestTime", $$v)
      },
      expression: "formValidate.haveTellRestTime"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否告知直播课上课规则  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.havaTellLivingLessonRule),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "havaTellLivingLessonRule", $$v)
      },
      expression: "formValidate.havaTellLivingLessonRule"
    }
  }, [_vm._v("YES")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.wrapClasses
  }, [_c('span', {
    class: _vm.checkboxClasses
  }, [_c('span', {
    class: _vm.innerClasses
  }), _vm._v(" "), (_vm.group) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    class: _vm.inputClasses,
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.label,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.change]
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.group) ? _c('input', {
    class: _vm.inputClasses,
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.change
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("default", function() {
    return [(_vm.showSlot) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "新增课程音频",
      "width": "600px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "audioForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.audioRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", _vm._n($$v))
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "音频标题",
      "prop": "title",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传音频",
      "label-width": 100,
      "prop": "audioUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "audio/mpeg",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("在职老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-position": "top",
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                " + _vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, _vm._l((_vm.$constant.isStudyAdviser), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, _vm._l((_vm.$constant.accent), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "ID/姓名"
    },
    model: {
      value: (_vm.queryParam.tchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchKey", $$v)
      },
      expression: "queryParam.tchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "登录账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开课时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteRemark",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteRemark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteRemark", $$v)
      },
      expression: "queryParam.inviteRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优秀外教"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.excellent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "excellent", $$v)
      },
      expression: "queryParam.excellent"
    }
  }, _vm._l((_vm.excellentOptions), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disabled": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n        搜索\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.exportLoading,
      "disabled": _vm.exportLoading,
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n        导出\n      ")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tchList/normal-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "外教运营分配记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("财务每日数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "查询日期"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row')], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    staticClass: "left-button",
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/dataCenter/financeDailyList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加学生"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.insertUserParam,
      "rules": _vm.ruleUser
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickname"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "nickname", $$v)
      },
      expression: "insertUserParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "微信号",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和微信号至少填一个"
    },
    model: {
      value: (_vm.insertUserParam.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "wechatAccount", $$v)
      },
      expression: "insertUserParam.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "区号",
      "prop": "areaNum"
    }
  }, [_c('PhoneAreaSelect', {
    on: {
      "on-change": _vm.onAreaNumChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 13
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和微信号至少填一个"
    },
    model: {
      value: (_vm.insertUserParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "mobile", $$v)
      },
      expression: "insertUserParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.password),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "password", $$v)
      },
      expression: "insertUserParam.password"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "sex", _vm._n($$v))
      },
      expression: "insertUserParam.sex"
    }
  }, _vm._l((_vm.sexList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级",
      "prop": "userInfoLevelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.insertUserParam.userInfoLevelId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "userInfoLevelId", _vm._n($$v))
      },
      expression: "insertUserParam.userInfoLevelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "type": "number",
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.insertUserParam.age),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "age", _vm._n($$v))
      },
      expression: "insertUserParam.age"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "prop": "regType"
    }
  }, [_c('channel-select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "regType", $$v)
      },
      expression: "insertUserParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "adviserId",
      "label": "课程顾问："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "adviserId", _vm._n($$v))
      },
      expression: "insertUserParam.adviserId"
    }
  }, _vm._l((_vm.adviserList), function(item) {
    return _c('Option', {
      key: item.adviserId,
      attrs: {
        "value": item.adviserId
      }
    }, [_vm._v(_vm._s(item.adviserName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "rows": 3,
      "type": "textarea"
    },
    model: {
      value: (_vm.insertUserParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "remark", $$v)
      },
      expression: "insertUserParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.insertUserParam.files),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "files", $$v)
      },
      expression: "insertUserParam.files"
    }
  })], 1)], 1), _vm._v(" "), (_vm.insertUserParam.regType === 'tj') ? _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐学生Id",
      "prop": "inviteId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "inviteId", _vm._n($$v))
      },
      expression: "insertUserParam.inviteId"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertUser
    },
    on: {
      "click": _vm.insertUser
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "上课反馈审批",
      "width": 640
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.feedBackParamData,
      "rules": _vm.recordRule,
      "label-width": 90
    }
  }, [(['加开固定时间', '加开临时时间', '上课反馈'].includes(_vm.feedBackParamData.bizType)) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID、姓名"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedBackParamData.tchId) + " " + _vm._s(_vm.feedBackParamData.tchName))])])], 1)], 1) : _vm._e(), _vm._v(" "), (['体验课上课要求', '上课反馈'].includes(_vm.feedBackParamData.bizType)) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID、姓名"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedBackParamData.uid) + " " + _vm._s(_vm.feedBackParamData.stdName))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedBackParamData.bizType))]), _vm._v(" "), (_vm.feedBackParamData.bizType === '体验课上课要求') ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showClassRequirement
    }
  }, [_vm._v("查看上课要求")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.showClassRequirementModal) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.classRequirementColumn,
      "data": _vm.classRequirementList
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [(!['加开固定时间', '加开临时时间'].includes(_vm.feedBackParamData.bizType)) ? _c('Form-item', {
    attrs: {
      "label": "反馈内容",
      "prop": "feedContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符",
      "disabled": _vm.feedBackParamData.bizType === '体验课上课要求'
    },
    model: {
      value: (_vm.feedBackParamData.feedContent),
      callback: function($$v) {
        _vm.$set(_vm.feedBackParamData, "feedContent", $$v)
      },
      expression: "feedBackParamData.feedContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feedBackParamData.bizType === '加开固定时间') ? _c('Form', {
    ref: "timeForm1",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule1
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择买断时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime1
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.feedBackParamData.bizType === '加开固定时间') ? _c('Form', {
    ref: "timeListForm1",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule1
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "19"
      }
    }, [_c('label', [_c('b', [_vm._v("时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,    生效日期：" + _vm._s(item.useDateStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.feedBackParamData.bizType === '加开临时时间') ? _c('Form', {
    ref: "timeForm2",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.timeParam,
      "rules": _vm.timeRule2
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择上课时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "day"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value": _vm.timeParam.dayStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 3
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime2
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.feedBackParamData.bizType === '加开临时时间') ? _c('Form', {
    ref: "timeListForm2",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": {},
      "rules": _vm.timeListRule2
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "8"
      }
    }, [_c('label', [_c('b', [_vm._v(_vm._s(item.dayStr) + " " + _vm._s(item.startTimeStr) + "-" + _vm._s(item.endTimeStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.feedBackParamData.feedRemark) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教留言"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedBackParamData.feedRemark))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈时间"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedBackParamData.fromUser) + " " + _vm._s(_vm.feedBackParamData.createTime))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审批状态"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.feedBackParamData.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.feedBackParamData, "auditStatus", $$v)
      },
      expression: "feedBackParamData.auditStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("暂不处理")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审批意见",
      "prop": "auditRemark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 15
      },
      "maxlength": 500,
      "placeholder": "长度不要超过500个字符"
    },
    model: {
      value: (_vm.feedBackParamData.auditRemark),
      callback: function($$v) {
        _vm.$set(_vm.feedBackParamData, "auditRemark", $$v)
      },
      expression: "feedBackParamData.auditRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.feedBackParamData.bizType !== '开绑定权限' && _vm.feedBackParamData.bizType !== '开临时约课权限') ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否反馈外教"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.feedBackParamData.showTch),
      callback: function($$v) {
        _vm.$set(_vm.feedBackParamData, "showTch", $$v)
      },
      expression: "feedBackParamData.showTch"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "label": _vm.label,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.studentList), function(student) {
    return _c('Option', {
      key: student.id,
      attrs: {
        "value": student.id
      }
    }, [_vm._v("\n    " + _vm._s(student.id) + " - " + _vm._s(student.nickname) + "\n  ")])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生量统计列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间："
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryParam.statisticalDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "statisticalDate", $$v)
      },
      expression: "queryParam.statisticalDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyConsultantId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyConsultantId", $$v)
      },
      expression: "queryParam.studyConsultantId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/dataCenter/studentDailyList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-教材配送记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "寄送教材",
      "prop": "bookMaterialLevel"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.formValidate.bookMaterialLevel),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "bookMaterialLevel", $$v)
      },
      expression: "formValidate.bookMaterialLevel"
    }
  }, [_c('OptionGroup', {
    attrs: {
      "label": "Pre"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Pre 1"
    }
  }, [_vm._v("Pre 1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 2"
    }
  }, [_vm._v("Pre 2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 3"
    }
  }, [_vm._v("Pre 3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 4"
    }
  }, [_vm._v("Pre 4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 5"
    }
  }, [_vm._v("Pre 5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 6"
    }
  }, [_vm._v("Pre 6")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "Phonics"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Phonics 1"
    }
  }, [_vm._v("Phonics 1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 2"
    }
  }, [_vm._v("Phonics 2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 3"
    }
  }, [_vm._v("Phonics 3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 4"
    }
  }, [_vm._v("Phonics 4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 5"
    }
  }, [_vm._v("Phonics 5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 6"
    }
  }, [_vm._v("Phonics 6")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "G"
    }
  }, [_c('Option', {
    attrs: {
      "value": "G-1A"
    }
  }, [_vm._v("G-1A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-1B"
    }
  }, [_vm._v("G-1B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-2A"
    }
  }, [_vm._v("G-2A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-2B"
    }
  }, [_vm._v("G-2B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-3A"
    }
  }, [_vm._v("G-3A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-3B"
    }
  }, [_vm._v("G-3B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-4A"
    }
  }, [_vm._v("G-4A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-4B"
    }
  }, [_vm._v("G-4B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-5A"
    }
  }, [_vm._v("G-5A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-5B"
    }
  }, [_vm._v("G-5B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-6A"
    }
  }, [_vm._v("G-6A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-6B"
    }
  }, [_vm._v("G-6B")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "JS"
    }
  }, [_c('Option', {
    attrs: {
      "value": "JS1A"
    }
  }, [_vm._v("JS1A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS1B"
    }
  }, [_vm._v("JS1B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS2A"
    }
  }, [_vm._v("JS2A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS2B"
    }
  }, [_vm._v("JS2B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS3A"
    }
  }, [_vm._v("JS3A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS3B"
    }
  }, [_vm._v("JS3B")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "Wonders"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Wonders 无教材"
    }
  }, [_vm._v("Wonders 无教材")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('Button', {
    attrs: {
      "icon": "trash-a"
    },
    on: {
      "click": _vm.allClear
    }
  }, [_vm._v("清空教材")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮寄地址",
      "prop": "address"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formValidate.address),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "address", $$v)
      },
      expression: "formValidate.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "拒绝工单"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "rejectWoForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData,
      "rules": _vm.ruleWo
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拒绝理由",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  }, _vm._l((_vm.$constant.woReason), function(item) {
    return _c('Option', {
      key: item.text,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("驳回")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "新增课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", $$v)
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", $$v)
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "headers": _vm.headers,
      "accept": _vm.acceptType,
      "on-success": _vm.upScuccess
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "imgInput",
      "element-loading-text": "插入中,请稍候"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_vm._v("请假类型：请单节课")])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px",
      "width": "400px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._v("请假课程：" + _vm._s(_vm.leaveParam.beginTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.leaveParam.title))])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "监课记录",
      "width": "535"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.recordColumn,
      "data": _vm.recordList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "移至公库"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "batchMoveUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.id + ' - ' + item.nickname) + "\n          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBatchMoveUser
    },
    on: {
      "click": _vm.batchMoveUser
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("差评投诉列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listNegativeComment",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('other-reason-modal', {
    attrs: {
      "otherReason": _vm.otherReason
    },
    model: {
      value: (_vm.ohterReasonModal),
      callback: function($$v) {
        _vm.ohterReasonModal = $$v
      },
      expression: "ohterReasonModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("待分配学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开课时间"
    }
  }, [_c('Row', [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": true,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.queryParam.bookMaterialLevelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "bookMaterialLevelId", _vm._n($$v))
      },
      expression: "queryParam.bookMaterialLevelId"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分级")]), _vm._v(" "), _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "排序规则"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sortRule),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sortRule", _vm._n($$v))
      },
      expression: "queryParam.sortRule"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("由少到多")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("由多到少")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Select', {
    attrs: {
      "name": "lessonWeek",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.selectWeek
    },
    model: {
      value: (_vm.lessonWeek),
      callback: function($$v) {
        _vm.lessonWeek = $$v
      },
      expression: "lessonWeek"
    }
  }, _vm._l((_vm.$constant.weekSelect), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定课节数"
    }
  }, [_c('Input', {
    attrs: {
      "name": "bindLessonNum"
    },
    model: {
      value: (_vm.queryParam.bindLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "bindLessonNum", _vm._n($$v))
      },
      expression: "queryParam.bindLessonNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "剩余课节数"
    }
  }, [_c('Input', {
    attrs: {
      "name": "lastLessonNum"
    },
    model: {
      value: (_vm.queryParam.lastLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lastLessonNum", $$v)
      },
      expression: "queryParam.lastLessonNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课节数"
    }
  }, [_c('Select', {
    attrs: {
      "name": "lessonNum",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonNum", $$v)
      },
      expression: "queryParam.lessonNum"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("前8节课学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("剩余10节课学生")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.loadLevelIds
    },
    model: {
      value: (_vm.queryParam.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersionId", $$v)
      },
      expression: "queryParam.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师名字"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否绑定老师",
      "prop": "isTch"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isTch),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isTch", _vm._n($$v))
      },
      expression: "queryParam.isTch"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已绑定老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未绑定老师")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下周是否排课",
      "prop": "isNextWeekLessonOpened"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isNextWeekLessonOpened),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isNextWeekLessonOpened", _vm._n($$v))
      },
      expression: "queryParam.isNextWeekLessonOpened"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已排课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未排课")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", _vm._n($$v))
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    staticClass: "left-button",
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n        搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          导出\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配课程顾问")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignStudyAdviser
    }
  }, [_vm._v("分配学导")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.salesServerAlone
    }
  }, [_vm._v("销售独立服务")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.cannelStudy
    }
  }, [_vm._v("取消学导绑定")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onBatchCompletedCourses
    }
  }, [_vm._v("批量结课")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showStopLessonModel
    }
  }, [_vm._v("移至停课")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showToRefundModal
    }
  }, [_vm._v("移至退费")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/pay/provisional",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('AssignAdviserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  }), _vm._v(" "), _c('AssignUserStudyModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    on: {
      "on-close": _vm.onStudyAdviserClose
    },
    model: {
      value: (_vm.showAssignUserStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignUserStudyAdviserModal = $$v
      },
      expression: "showAssignUserStudyAdviserModal"
    }
  }), _vm._v(" "), _c('UserTestNetworkModal', {
    attrs: {
      "user": _vm.testNetworkParam
    },
    model: {
      value: (_vm.showTestNetworkModal),
      callback: function($$v) {
        _vm.showTestNetworkModal = $$v
      },
      expression: "showTestNetworkModal"
    }
  }), _vm._v(" "), _c('UserLeaveModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserLeaveModal),
      callback: function($$v) {
        _vm.showUserLeaveModal = $$v
      },
      expression: "showUserLeaveModal"
    }
  }), _vm._v(" "), _c('UserTempLessonModal', {
    attrs: {
      "user": _vm.tempLessonUser
    },
    model: {
      value: (_vm.showUserTempLessonModal),
      callback: function($$v) {
        _vm.showUserTempLessonModal = $$v
      },
      expression: "showUserTempLessonModal"
    }
  }), _vm._v(" "), _c('UserChineseLessonModal', {
    attrs: {
      "user": _vm.chineseLessonUser
    },
    model: {
      value: (_vm.showUserChineseLessonModal),
      callback: function($$v) {
        _vm.showUserChineseLessonModal = $$v
      },
      expression: "showUserChineseLessonModal"
    }
  }), _vm._v(" "), _c('UserPLLessonModal', {
    attrs: {
      "user": _vm.pLLessonUser
    },
    model: {
      value: (_vm.showUserPLLessonModal),
      callback: function($$v) {
        _vm.showUserPLLessonModal = $$v
      },
      expression: "showUserPLLessonModal"
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('UserLeaveNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLeaveNumModal),
      callback: function($$v) {
        _vm.showUserLeaveNumModal = $$v
      },
      expression: "showUserLeaveNumModal"
    }
  }), _vm._v(" "), _c('UserLessonNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLessonNumModal),
      callback: function($$v) {
        _vm.showUserLessonNumModal = $$v
      },
      expression: "showUserLessonNumModal"
    }
  }), _vm._v(" "), _c('CourseSchedulingModal', {
    attrs: {
      "uid": _vm.uid
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showCourseSchedulingModal),
      callback: function($$v) {
        _vm.showCourseSchedulingModal = $$v
      },
      expression: "showCourseSchedulingModal"
    }
  }), _vm._v(" "), _c('BindTchModal', {
    attrs: {
      "user": _vm.currentRow,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBindTchModal),
      callback: function($$v) {
        _vm.showBindTchModal = $$v
      },
      expression: "showBindTchModal"
    }
  }), _vm._v(" "), _c('UpdateLevelModal', {
    attrs: {
      "user": _vm.currentRow,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showUpdateLevelModal),
      callback: function($$v) {
        _vm.showUpdateLevelModal = $$v
      },
      expression: "showUpdateLevelModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('reject-wo-modal', {
    attrs: {
      "successCallback": _vm.search,
      "studentId": _vm.uid
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.rejectWoModal),
      callback: function($$v) {
        _vm.rejectWoModal = $$v
      },
      expression: "rejectWoModal"
    }
  }), _vm._v(" "), _c('UserActivityNumModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showActivityNumModal),
      callback: function($$v) {
        _vm.showActivityNumModal = $$v
      },
      expression: "showActivityNumModal"
    }
  }), _vm._v(" "), _c('BookExchangeModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showBookExchangeModal),
      callback: function($$v) {
        _vm.showBookExchangeModal = $$v
      },
      expression: "showBookExchangeModal"
    }
  }), _vm._v(" "), _c('StudentClassHourModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showStudentClassHourModal),
      callback: function($$v) {
        _vm.showStudentClassHourModal = $$v
      },
      expression: "showStudentClassHourModal"
    }
  }), _vm._v(" "), _c('ToRefundModal', {
    attrs: {
      "uid": _vm.refundUid,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showRefundModal),
      callback: function($$v) {
        _vm.showRefundModal = $$v
      },
      expression: "showRefundModal"
    }
  }), _vm._v(" "), _c('BatchCompletedCoursesModal', {
    attrs: {
      "uidStr": _vm.uidStr,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBatchCompletedCoursesModal),
      callback: function($$v) {
        _vm.showBatchCompletedCoursesModal = $$v
      },
      expression: "showBatchCompletedCoursesModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "请填写停课理由"
    },
    model: {
      value: (_vm.showStudentLeaveModal),
      callback: function($$v) {
        _vm.showStudentLeaveModal = $$v
      },
      expression: "showStudentLeaveModal"
    }
  }, [_c('Form', {
    ref: "showStudentLeave",
    staticClass: "form",
    attrs: {
      "model": _vm.showStudentLeaveForm,
      "rules": _vm.showStudentLeaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "复课时间",
      "prop": "startStudyDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "options": _vm.options,
      "placeholder": "选择时间"
    },
    on: {
      "on-change": _vm.startStudyDate
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "停课原因",
      "prop": "leaveResult"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入停课理由"
    },
    model: {
      value: (_vm.showStudentLeaveForm.leaveResult),
      callback: function($$v) {
        _vm.$set(_vm.showStudentLeaveForm, "leaveResult", $$v)
      },
      expression: "showStudentLeaveForm.leaveResult"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showStudentLeaveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingShowStudentLeave
    },
    on: {
      "click": _vm.inStopLesson
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": !_vm.disabled,
      "filterable": "",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    on: {
      "on-change": _vm.onChange,
      "on-clear": _vm.onClear
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.adminUserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname + ' - ' + item.phone))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("个人资源")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Row', {
    staticClass: "margin"
  }, [_c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.todayAllotType,
      "loading": _vm.todayLoading,
      "disable": _vm.todayLoading,
      "icon": "android-document "
    },
    on: {
      "click": _vm.todayAllot
    }
  }, [_vm._v("今日新分\n            ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.todayContactType,
      "loading": _vm.todayLoading,
      "disable": _vm.todayLoading,
      "icon": "android-document "
    },
    on: {
      "click": _vm.todayContact
    }
  }, [_vm._v("今日联系\n            ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.todayPublicType,
      "loading": _vm.todayLoading,
      "disable": _vm.todayLoading,
      "icon": "android-document "
    },
    on: {
      "click": _vm.publicUser
    }
  }, [_vm._v("公库新领\n            ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.myStudentType,
      "icon": "beer"
    },
    on: {
      "click": _vm.myStudent
    }
  }, [_vm._v("我的学生")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.godent,
      "icon": "beer"
    },
    on: {
      "click": _vm.vault
    }
  }, [_vm._v("小金库")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.payStudentType,
      "icon": "beer"
    },
    on: {
      "click": _vm.payStudent
    }
  }, [_vm._v("常规学生")])], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "margin"
  }, [_c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "icon": "music-note"
    },
    on: {
      "click": _vm.todayLisent
    }
  }, [_vm._v("今日试听")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "icon": "ios-list-outline"
    },
    on: {
      "click": _vm.todayOpenClass
    }
  }, [_vm._v("今日约课")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": _vm.typeData,
      "icon": "beer"
    },
    on: {
      "click": _vm.myStudentAll
    }
  }, [_vm._v("全部学生")])], 1)], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 100,
      "label-position": "right"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学员状态："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.stdStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdStatus", $$v)
      },
      expression: "queryParam.stdStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("已预约")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已试听")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("付款未绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("已绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("已开课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("已完课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("退费")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "下次联系"
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.beginNextContactTime
    },
    model: {
      value: (_vm.beginNextContact),
      callback: function($$v) {
        _vm.beginNextContact = $$v
      },
      expression: "beginNextContact"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endNextContactTime
    },
    model: {
      value: (_vm.endNextContact),
      callback: function($$v) {
        _vm.endNextContact = $$v
      },
      expression: "endNextContact"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生:",
      "label-width": 70
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "意向等级："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "intentLevel", $$v)
      },
      expression: "queryParam.intentLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("意向一般")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无效资源")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "渠道来源："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道分类"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.channelType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channelType", $$v)
      },
      expression: "queryParam.channelType"
    }
  }, _vm._l((this.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 18,
      "sm": 18,
      "md": 20
    }
  }, [_c('adviser-float-modal', {
    attrs: {
      "adviserId": _vm.queryParam.adviserId,
      "teamType": _vm.queryParam.teamType
    },
    on: {
      "get_adviser": _vm.getAdviserInfo
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    staticClass: "left-button",
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "move-round"
    },
    on: {
      "click": _vm.onBatchMoveUser
    }
  }, [_vm._v("批量移至公库")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round",
      "class-name": ""
    },
    on: {
      "click": _vm.onInsertUser
    }
  }, [_vm._v("添加学生")]), _vm._v(" "), (_vm.myStudentType === 'success') ? _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "person-add"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("批量分配课程顾问")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "height": 680,
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": _vm.listUrl,
      "pageSize": _vm.num,
      "show-sizer": "",
      "page-size-opts": [10, 20, 50, 100],
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange,
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('today-punch-statistics-modal', {
    attrs: {
      "value": _vm.showTodayPunchStatisticsModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showTodayPunchStatisticsModal = false
      }
    }
  }), _vm._v(" "), _c('UserLeaveModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserLeaveModal),
      callback: function($$v) {
        _vm.showUserLeaveModal = $$v
      },
      expression: "showUserLeaveModal"
    }
  }), _vm._v(" "), _c('UserTempLessonModal', {
    attrs: {
      "user": _vm.tempLessonUser
    },
    model: {
      value: (_vm.showUserTempLessonModal),
      callback: function($$v) {
        _vm.showUserTempLessonModal = $$v
      },
      expression: "showUserTempLessonModal"
    }
  }), _vm._v(" "), _c('UserPLLessonModal', {
    attrs: {
      "user": _vm.pLLessonUser
    },
    model: {
      value: (_vm.showUserPLLessonModel),
      callback: function($$v) {
        _vm.showUserPLLessonModel = $$v
      },
      expression: "showUserPLLessonModel"
    }
  }), _vm._v(" "), _c('UserChineseLessonModal', {
    attrs: {
      "user": _vm.chineseLessonUser
    },
    model: {
      value: (_vm.showUserChineseLessonModal),
      callback: function($$v) {
        _vm.showUserChineseLessonModal = $$v
      },
      expression: "showUserChineseLessonModal"
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('UserLeaveNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLeaveNumModal),
      callback: function($$v) {
        _vm.showUserLeaveNumModal = $$v
      },
      expression: "showUserLeaveNumModal"
    }
  }), _vm._v(" "), _c('UserLessonNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLessonNumModal),
      callback: function($$v) {
        _vm.showUserLessonNumModal = $$v
      },
      expression: "showUserLessonNumModal"
    }
  }), _vm._v(" "), _c('CourseSchedulingModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showCourseSchedulingModal),
      callback: function($$v) {
        _vm.showCourseSchedulingModal = $$v
      },
      expression: "showCourseSchedulingModal"
    }
  }), _vm._v(" "), _c('BindTchModal', {
    attrs: {
      "user": _vm.currentRow,
      "successCallback": _vm.search,
      "isBinded": _vm.isBinded
    },
    model: {
      value: (_vm.showBindTchModal),
      callback: function($$v) {
        _vm.showBindTchModal = $$v
      },
      expression: "showBindTchModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "tabValue": _vm.tabValue,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('InsertUserModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showInsertUserModal),
      callback: function($$v) {
        _vm.showInsertUserModal = $$v
      },
      expression: "showInsertUserModal"
    }
  }), _vm._v(" "), _c('UserTrialLessonModal', {
    attrs: {
      "user": _vm.trialaLessonUser
    },
    model: {
      value: (_vm.showUserTrialLessonModal),
      callback: function($$v) {
        _vm.showUserTrialLessonModal = $$v
      },
      expression: "showUserTrialLessonModal"
    }
  }), _vm._v(" "), _c('add-order-modal', {
    attrs: {
      "value": _vm.addOrderModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addOrderModal = false
      }
    }
  }), _vm._v(" "), _c('BatchMoveUserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showBatchMoveUser),
      callback: function($$v) {
        _vm.showBatchMoveUser = $$v
      },
      expression: "showBatchMoveUser"
    }
  }), _vm._v(" "), _c('AssignAdviserModal', {
    attrs: {
      "successCallback": _vm.reloadAfterAssign,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "调课件"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "lessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.lessonParam,
      "rules": _vm.lessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原课件信息"
    }
  }, [_c('label', [_vm._v("等级："), _c('b', [_vm._v(_vm._s(_vm.lessonOpened.levelTitle))]), _vm._v(" 课程："), _c('b', [_vm._v(_vm._s(_vm.lessonOpened.lessonTitle))])])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.lessonParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParam, "levelId", _vm._n($$v))
      },
      expression: "lessonParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.lessonParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParam, "lessonId", _vm._n($$v))
      },
      expression: "lessonParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否顺延"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.lessonParam.postpone),
      callback: function($$v) {
        _vm.$set(_vm.lessonParam, "postpone", $$v)
      },
      expression: "lessonParam.postpone"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingChange
    },
    on: {
      "click": _vm.change
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "约试听课",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "trialLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.trialLessonParam,
      "rules": _vm.ruleTrialLesson,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.trialLessonParam.uid) + " - " + _vm._s(_vm.trialLessonParam.mobile) + " - " + _vm._s(_vm.trialLessonParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择等级，支持搜索",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.trialLessonParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "levelId", _vm._n($$v))
      },
      expression: "trialLessonParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "schoolId", _vm._n($$v))
      },
      expression: "trialLessonParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "lessonId", _vm._n($$v))
      },
      expression: "trialLessonParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.trialLessonParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "lsnBeginTimeDate", $$v)
      },
      expression: "trialLessonParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    key: _vm.timePickerKey,
    attrs: {
      "clearable": false,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.timeStr),
      callback: function($$v) {
        _vm.timeStr = $$v
      },
      expression: "timeStr"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "timeLength", _vm._n($$v))
      },
      expression: "trialLessonParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "isAudition": _vm.y,
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "适宜级别"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.suitableLevel),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "suitableLevel", $$v)
      },
      expression: "trialLessonParam.suitableLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("Level1")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5"
    }
  }, [_c('span', [_vm._v("Level2")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("Level3-Level5")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("Level6-Level9")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("Wonders及其他")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "6"
    }
  }, [_c('span', [_vm._v("PU")])])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.category),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "category", $$v)
      },
      expression: "trialLessonParam.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("全职老师")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("兼职老师")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "channel", $$v)
      },
      expression: "trialLessonParam.channel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("欧美")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("菲教")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "accent", $$v)
      },
      expression: "trialLessonParam.accent"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("英音")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("美音")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "sex", $$v)
      },
      expression: "trialLessonParam.sex"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("男")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("女")])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.trialLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "tchId", _vm._n($$v))
      },
      expression: "trialLessonParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + "\n                    ")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertTrialLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课后习题")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "labe-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.medition
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", $$v)
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.queryParam.levelItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelItem", $$v)
      },
      expression: "queryParam.levelItem"
    }
  }, _vm._l((_vm.levelAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程标题："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.lessonItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonItem", $$v)
      },
      expression: "queryParam.lessonItem"
    }
  }, _vm._l((_vm.lessonAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课后题标题：",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊查询"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('Col')], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("添加课后习题\n          ")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/bookLessonNewReview/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "课后习题",
      "scrollable": true,
      "styles": {
        top: '60px',
        marginBottom: '50px'
      },
      "width": "1000"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form formModal",
    staticStyle: {
      "overflow": "visible",
      "height": "auto"
    },
    attrs: {
      "model": _vm.formDate,
      "rules": _vm.ruleLevelGrade,
      "label-width": 80
    }
  }, [_c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本：",
      "prop": "materialVersion",
      "label-width": 110
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.meditions
    },
    model: {
      value: (_vm.formDate.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "materialVersion", $$v)
      },
      expression: "formDate.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择level：",
      "label-width": 110,
      "prop": "levelItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeModelLevel
    },
    model: {
      value: (_vm.formDate.levelItem),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "levelItem", $$v)
      },
      expression: "formDate.levelItem"
    }
  }, _vm._l((_vm.levelAlls), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程：",
      "label-width": 110,
      "prop": "lessonItem",
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formDate.lessonItem),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "lessonItem", $$v)
      },
      expression: "formDate.lessonItem"
    }
  }, _vm._l((_vm.lessonAlls), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "序号：",
      "prop": "sort",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.sort),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "sort", _vm._n($$v))
      },
      expression: "formDate.sort"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考核能力：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formDate.appraise),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "appraise", $$v)
      },
      expression: "formDate.appraise"
    }
  }, _vm._l((_vm.$constant.appraise), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeQuestionType
    },
    model: {
      value: (_vm.formDate.questionType),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "questionType", $$v)
      },
      expression: "formDate.questionType"
    }
  }, _vm._l((_vm.$constant.questionType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeQuestionDev
    },
    model: {
      value: (_vm.formDate.questionDev),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "questionDev", $$v)
      },
      expression: "formDate.questionDev"
    }
  }, _vm._l((_vm.questionDevList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题：",
      "prop": "title",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.title),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "title", $$v)
      },
      expression: "formDate.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "主内容：",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.content),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "content", $$v)
      },
      expression: "formDate.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('Row', _vm._l((_vm.answerList.length), function(index) {
    return _c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.SecondlyContext + index,
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (_vm.manyContext[index]),
        callback: function($$v) {
          _vm.$set(_vm.manyContext, index, $$v)
        },
        expression: "manyContext[index]"
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [(_vm.formDate.questionType === 1 || (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 2)) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：894 X 370 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 1) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：475 X 472 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：372 X 213 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：542 X 309 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：917 X 288 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('i-col', {
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('image-upload', {
    attrs: {
      "defaultFileList": _vm.defaultPicList,
      "text": "上传图片"
    },
    model: {
      value: (_vm.formDate.pic),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "pic", $$v)
      },
      expression: "formDate.pic"
    }
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "音频"
    }
  }, [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('file-upload', {
    attrs: {
      "defaultFileList": _vm.defaultAudioList,
      "text": "上传音频",
      "accept": "audio/*"
    },
    model: {
      value: (_vm.formDate.video),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "video", $$v)
      },
      expression: "formDate.video"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("车过桥类型：答案图片上传时不管是3张图片或4张图片宽度总和要为361,高度每张为179")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('Row', [_c('Row', [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：185 X 215 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拼图"
    }
  }, [_c('image-upload', {
    attrs: {
      "defaultFileList": _vm.pinPicList,
      "text": "上传图片"
    },
    model: {
      value: (_vm.formDate.pinPic),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "pinPic", $$v)
      },
      expression: "formDate.pinPic"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 1) ? _c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [(_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 1) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "padding-left": "45px",
        "color": "#e60000"
      }
    }, [_vm._v("图片尺寸：271 X 178 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 2) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('span', [_vm._v("选项" + _vm._s(index + 1))]), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "padding-left": "45px",
        "color": "#e60000"
      }
    }, [_vm._v("图片尺寸 235 X 216 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _vm._l((_vm.answerList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.answerText + (index + 1),
        "label-width": 110,
        "transfer": ""
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      model: {
        value: (_vm.answerMore[index]),
        callback: function($$v) {
          _vm.$set(_vm.answerMore, index, $$v)
        },
        expression: "answerMore[index]"
      }
    }, _vm._l((_vm.$constant.questionAnswer), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('span', [_vm._v("选项" + _vm._s(index + 1))]), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _vm._l((_vm.answerList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.answerText + (index + 1),
        "label-width": 110,
        "transfer": ""
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      model: {
        value: (_vm.answerMore[index]),
        callback: function($$v) {
          _vm.$set(_vm.answerMore, index, $$v)
        },
        expression: "answerMore[index]"
      }
    }, _vm._l((_vm.$constant.questionAnswer), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)]
  })], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("灰度设置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所有学生"
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.allEnabled === 1,
      "size": "large",
      "disabled": _vm.saving
    },
    on: {
      "on-change": _vm.onAllChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])])], 1), _vm._v(" "), (_vm.allEnabled === 1) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("全量已开，名单不参与判定")]) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addAdviser
    }
  }, [_vm._v("添加学导")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "销售"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.sellerId),
      callback: function($$v) {
        _vm.sellerId = $$v
      },
      expression: "sellerId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addSeller
    }
  }, [_vm._v("添加销售")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID或手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入学生 uid 或手机号"
    },
    model: {
      value: (_vm.studentKeyword),
      callback: function($$v) {
        _vm.studentKeyword = $$v
      },
      expression: "studentKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("添加学生")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("学导")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.advisers,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("销售")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.sellers,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("指定学生")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.students,
      "size": "small"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("场次记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生/操作人ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生 uid，试做则为后台账号 ID"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场次状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "CREATED"
    }
  }, [_vm._v("已创建")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IN_PROGRESS"
    }
  }, [_vm._v("答题中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PAUSED"
    }
  }, [_vm._v("已暂停")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SCORING"
    }
  }, [_vm._v("评分中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "READY"
    }
  }, [_vm._v("已交卷")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ABANDONED"
    }
  }, [_vm._v("已放弃")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "INCOMPLETE_REF"
    }
  }, [_vm._v("作答不足/待复核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "INVALID"
    }
  }, [_vm._v("已作废")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次来源"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场次来源"
    },
    model: {
      value: (_vm.queryParam.source),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "source", $$v)
      },
      expression: "queryParam.source"
    }
  }, [_c('Option', {
    attrs: {
      "value": "TRIAL"
    }
  }, [_vm._v("试做")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "STUDENT"
    }
  }, [_vm._v("学生考试")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/sessions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.reportModalTitle,
      "width": "920",
      "class-name": "mex-rpt-modal"
    },
    model: {
      value: (_vm.reportVisible),
      callback: function($$v) {
        _vm.reportVisible = $$v
      },
      expression: "reportVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "78vh",
      "overflow-y": "auto"
    }
  }, [_c('MexSessionReport', {
    attrs: {
      "report": _vm.report
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reportVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "场次回放",
      "width": "1180"
    },
    model: {
      value: (_vm.replayVisible),
      callback: function($$v) {
        _vm.replayVisible = $$v
      },
      expression: "replayVisible"
    }
  }, [(_vm.replay) ? _c('p', [_vm._v("场次 " + _vm._s(_vm.replay.session && _vm.replay.session.id) + " / " + _vm._s(_vm.statusLabel(_vm.replay.session && _vm.replay.session.status, (_vm.replay.result && (_vm.replay.result.publishStatus || _vm.replay.result.flags)) || (_vm.replay.session && (_vm.replay.session.publishStatus || _vm.replay.session.flags)))) + " / 定级 " + _vm._s(_vm.replay.session && _vm.replay.session.placementLevel || '—'))]) : _vm._e(), _vm._v(" "), (_vm.replay) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("点左侧箭头可看原题、知识点和解析")]) : _vm._e(), _vm._v(" "), (_vm.replay) ? _c('div', {
    staticClass: "mex-replay-table-wrap"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.itemColumns,
      "data": _vm.replay.replayItems || [],
      "size": "small"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.replay && _vm.replay.result) ? _c('div', {
    staticClass: "mex-replay-result"
  }, [_c('h4', [_vm._v("成绩摘要")]), _vm._v(" "), _c('div', {
    staticClass: "mex-replay-hero"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.replay.result.title || '—'))]), _vm._v("\n          · " + _vm._s(_vm.medalLabel(_vm.replay.result.medal)) + "\n          · 百分制 " + _vm._s(_vm.dash(_vm.replay.result.totalScore)) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          定级 " + _vm._s(_vm.replay.result.placementLevel || '—') + "\n          · 升班 " + _vm._s(_vm.promotionLabel(_vm.replay.result.promotion)) + "\n          · " + _vm._s(_vm.flagsLabel(_vm.replay.result.flags)) + "\n        ")])]), _vm._v(" "), _c('h4', [_vm._v("模块分")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.moduleColumns,
      "data": _vm.moduleRows,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("雷达维度")]), _vm._v(" "), (_vm.radarPlot) ? _c('div', {
    staticClass: "mex-radar-wrap"
  }, [_c('svg', {
    staticClass: "mex-radar",
    attrs: {
      "viewBox": "0 0 360 320"
    }
  }, [_vm._l((_vm.radarPlot.rings), function(ring, i) {
    return _c('polygon', {
      key: 'ring' + i,
      staticClass: "mex-radar-ring",
      attrs: {
        "points": ring
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('line', {
      key: 'axis' + i,
      staticClass: "mex-radar-axis",
      attrs: {
        "x1": _vm.radarPlot.cx,
        "y1": _vm.radarPlot.cy,
        "x2": ax.x2,
        "y2": ax.y2
      }
    })
  }), _vm._v(" "), _c('polygon', {
    staticClass: "mex-radar-area",
    attrs: {
      "points": _vm.radarPlot.polygon
    }
  }), _vm._v(" "), _vm._l((_vm.radarPlot.dots), function(d, i) {
    return _c('circle', {
      key: 'dot' + i,
      staticClass: "mex-radar-dot",
      attrs: {
        "cx": d.x,
        "cy": d.y,
        "r": "3.5"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('text', {
      key: 'lab' + i,
      staticClass: "mex-radar-label",
      attrs: {
        "x": ax.lx,
        "y": ax.ly,
        "text-anchor": "middle"
      }
    }, [_c('tspan', {
      attrs: {
        "x": ax.lx,
        "dy": "0"
      }
    }, [_vm._v(_vm._s(ax.label))]), _vm._v(" "), _c('tspan', {
      attrs: {
        "x": ax.lx,
        "dy": "14"
      }
    }, [_vm._v(_vm._s(ax.score))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "mex-radar-legend"
  }, _vm._l((_vm.radarRows), function(row) {
    return _c('li', {
      key: row.label
    }, [_c('span', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.score))])])
  }), 0)]) : _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("暂无雷达数据")]), _vm._v(" "), (_vm.replay.result.benchmarkVisible === 1) ? _c('p', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("\n        全国均分 " + _vm._s(_vm.dash(_vm.replay.result.nationalAvgScore)) + " · 全国百分位 " + _vm._s(_vm.dash(_vm.replay.result.nationalPercentile)) + "\n        · 同城均分 " + _vm._s(_vm.dash(_vm.replay.result.cityAvgScore)) + " · 同城百分位 " + _vm._s(_vm.dash(_vm.replay.result.cityPercentile)) + "\n        · 样本 " + _vm._s(_vm.dash(_vm.replay.result.benchmarkSampleN)) + "\n      ")]) : _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("对标样本不足，全国/同城分数环不展示")])], 1) : (_vm.replay) ? _c('p', {
    staticClass: "mex-dim-hint",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("暂无成绩（场次尚未出分）")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.replayVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.fullTextTitle,
      "width": "560"
    },
    model: {
      value: (_vm.fullTextVisible),
      callback: function($$v) {
        _vm.fullTextVisible = $$v
      },
      expression: "fullTextVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-all",
      "white-space": "pre-wrap",
      "max-height": "360px",
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.fullText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fullTextVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": _vm.limitMonthTimes,
      "width": "750",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid) + "  - " + _vm._s(_vm.formData.mobile) + " - " + _vm._s(_vm.formData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "schoolId", _vm._n($$v))
      },
      expression: "formData.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('label', [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2],
      "uid": _vm.formData.uid,
      "isCanBound": 1
    },
    on: {
      "change-select": _vm.onTchSelect
    },
    model: {
      value: (_vm.formData.tchId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchId", $$v)
      },
      expression: "formData.tchId"
    }
  })], 1)])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间",
      "prop": "workTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChangeWeek
    },
    model: {
      value: (_vm.formData.week),
      callback: function($$v) {
        _vm.$set(_vm.formData, "week", $$v)
      },
      expression: "formData.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 30],
      "value": _vm.formData.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "timeLength"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "时长",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChangeTimeLength
    },
    model: {
      value: (_vm.formData.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.formData, "timeLength", $$v)
      },
      expression: "formData.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.formData.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingCheck
    },
    on: {
      "click": _vm.addWorkTime
    }
  }, [_vm._v("检查并添加")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择",
      "prop": "workTimeList"
    }
  }, [_c('Row', _vm._l((_vm.workTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "span": "22"
      }
    }, [_c('label', [_c('b', [(item.levelTitle) ? [_vm._v("Level：" + _vm._s(item.levelTitle) + "，")] : _vm._e(), _vm._v("老师：" + _vm._s(item.tchId) + "-" + _vm._s(item.tchName) + "， 时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + "， 时长：" + _vm._s(item.timeLength) + " 分钟，生效日期：" + _vm._s(item.useDateStr))], 2)])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeWorkTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "attachment"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 10,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.attachment),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attachment", $$v)
      },
      expression: "formData.attachment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBind
    },
    on: {
      "click": _vm.bindWorkTime
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "请选择删除原因",
      "mask-closable": false,
      "width": "420"
    },
    model: {
      value: (_vm.showDelReasonModal),
      callback: function($$v) {
        _vm.showDelReasonModal = $$v
      },
      expression: "showDelReasonModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "删除原因",
      "required": ""
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.pendingDelReason),
      callback: function($$v) {
        _vm.pendingDelReason = $$v
      },
      expression: "pendingDelReason"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("离职老师")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("关时间老师")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("淘汰老师")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其它")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("老师请假")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 6
    }
  }, [_vm._v("教学不好")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.cancelDelReason
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmDelReason
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("首次跟踪记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配时间:"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkStartTimeDate
    },
    on: {
      "on-change": _vm.linkTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkEndTimeDate
    },
    on: {
      "on-change": _vm.linkTimeEndChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息:"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "ID/手机号"
    },
    model: {
      value: (_vm.queryParam.stdSearchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdSearchKey", $$v)
      },
      expression: "queryParam.stdSearchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.assignTitle,
      "listUrl": "/adviser/first-follow-page",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配课程顾问"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.uid + ' - ' + item.nickName) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.adviserParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "adviserId", $$v)
      },
      expression: "adviserParam.adviserId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wm-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外管消息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wm-card"
  }, [_c('div', {
    staticClass: "wm-tabs"
  }, [_c('div', {
    staticClass: "wm-tab",
    class: {
      'wm-tab--active': _vm.activeTab === 'send'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('send')
      }
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('div', {
    staticClass: "wm-tab",
    class: {
      'wm-tab--active': _vm.activeTab === 'history'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('history')
      }
    }
  }, [_vm._v("\n        发送记录"), _c('span', {
    staticClass: "wm-badge"
  }, [_vm._v(_vm._s(_vm.recordCount))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'send'),
      expression: "activeTab === 'send'"
    }],
    staticClass: "wm-send"
  }, [_c('div', {
    staticClass: "wm-form-row"
  }, [_c('label', {
    staticClass: "wm-form-label"
  }, [_vm._v("接收对象")]), _vm._v(" "), _c('Select', {
    staticClass: "wm-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "on-change": _vm.sendTypeChange
    },
    model: {
      value: (_vm.formData.sendType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sendType", _vm._n($$v))
      },
      expression: "formData.sendType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("全体中教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("全体外教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("个人中教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("个人外教老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("全体陪练老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("个人陪练老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("全部老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 8
    }
  }, [_vm._v("欧美外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 9
    }
  }, [_vm._v("菲教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("指定老师")])], 1)], 1), _vm._v(" "), (_vm.showTch) ? _c('div', {
    staticClass: "wm-form-row"
  }, [_c('Select', {
    staticClass: "wm-select",
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.tchIds),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchIds", $$v)
      },
      expression: "formData.tchIds"
    }
  }, _vm._l((_vm.tchList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-form-row"
  }, [_c('label', {
    staticClass: "wm-form-label"
  }, [_vm._v("消息内容")]), _vm._v(" "), _c('Input', {
    staticClass: "wm-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "输入要发送的消息"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.buttonLoading ? '发送中…' : '发 送'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'history'),
      expression: "activeTab === 'history'"
    }],
    staticClass: "wm-history"
  }, [(_vm.listLoading) ? _c('div', {
    staticClass: "wm-empty"
  }, [_vm._v("加载中…")]) : _c('table', {
    staticClass: "wm-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.records.length) ? _c('tr', [_c('td', {
    staticClass: "wm-empty-cell",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无发送记录")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.records), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('td', {
      staticClass: "wm-msg-cell",
      attrs: {
        "title": row.content
      }
    }, [_vm._v(_vm._s(row.content))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "wm-tag",
      class: _vm.isAllLike(row.sendType) ? 'wm-tag-all' : 'wm-tag-part'
    }, [_vm._v(_vm._s(row.targetLabel || _vm.sendTypeLabel(row.sendType)))]), _vm._v(" "), (row.resent == 1) ? _c('span', {
      staticClass: "wm-tag wm-tag-resend"
    }, [_vm._v("已追发")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(_vm.formatTime(row.gmtCreate)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(_vm.formatNum(row.totalCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num wm-read"
    }, [_vm._v(_vm._s(_vm.formatNum(row.readCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wm-num",
      class: row.unreadCount > 0 ? 'wm-unread' : ''
    }, [_vm._v(_vm._s(row.unreadCount > 0 ? _vm.formatNum(row.unreadCount) : '—'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "wm-rate-bar"
    }, [_c('i', {
      style: ({
        width: (row.readRate || 0) + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "wm-num"
    }, [_vm._v(_vm._s(row.readRate || 0) + "%")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "wm-btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openDetail(row)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), (row.unreadCount > 0) ? _c('button', {
      staticClass: "wm-btn-link wm-warn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openResend(row)
        }
      }
    }, [_vm._v("对未读人再次发送")]) : _c('span', {
      staticClass: "wm-all-read"
    }, [_vm._v("全部已读")])])])
  })], 2)]), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "wm-pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.pageNum,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wm-mask",
    class: {
      show: _vm.detailVisible
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.detailVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "wm-modal",
    staticStyle: {
      "width": "520px"
    }
  }, [_c('div', {
    staticClass: "wm-modal-head"
  }, [_vm._v("消息详情 "), _c('span', {
    staticClass: "wm-modal-close",
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.detail) ? _c('div', {
    staticClass: "wm-modal-body"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('b', [_vm._v("消息内容：")]), _vm._v(_vm._s(_vm.detail.content))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "12px",
      "color": "#888"
    }
  }, [_vm._v("发送对象：" + _vm._s(_vm.detail.targetLabel || _vm.sendTypeLabel(_vm.detail.sendType)) + " ｜ 发送时间：" + _vm._s(_vm.formatTime(_vm.detail.gmtCreate)))]), _vm._v(" "), _c('div', {
    staticClass: "wm-stat-line"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formatNum(_vm.detail.totalCount)))]), _vm._v("发送人数")]), _vm._v(" "), _c('div', [_c('b', {
    staticStyle: {
      "color": "#52c41a"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.detail.readCount)))]), _vm._v("已读")]), _vm._v(" "), _c('div', [_c('b', {
    staticStyle: {
      "color": "#fa541c"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.detail.unreadCount)))]), _vm._v("未读")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "6px",
      "color": "#888"
    }
  }, [_vm._v("老师阅读明细：")]), _vm._v(" "), _c('div', {
    staticClass: "wm-teacher-list"
  }, [_vm._l((_vm.detail.teachers), function(t) {
    return _c('div', {
      key: t.tchId + '-' + t.status,
      staticClass: "wm-teacher-row"
    }, [_c('span', [_vm._v(_vm._s(t.tchName))]), _vm._v(" "), _c('span', {
      class: t.status == 1 ? 'wm-st-read' : 'wm-st-unread'
    }, [_vm._v(_vm._s(t.statusLabel || (t.status == 1 ? '已读' : '未读')))])])
  }), _vm._v(" "), (!_vm.detail.teachers || !_vm.detail.teachers.length) ? _c('div', {
    staticStyle: {
      "padding": "12px",
      "color": "#999"
    }
  }, [_vm._v("暂无明细")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-modal-foot"
  }, [_c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关 闭")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wm-mask",
    class: {
      show: _vm.resendVisible
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resendVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "wm-modal",
    staticStyle: {
      "width": "440px"
    }
  }, [_c('div', {
    staticClass: "wm-modal-head"
  }, [_vm._v("对未读老师再次发送 "), _c('span', {
    staticClass: "wm-modal-close",
    on: {
      "click": function($event) {
        _vm.resendVisible = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.resendRow) ? _c('div', {
    staticClass: "wm-modal-body"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("即将向本条消息的 "), _c('b', {
    staticStyle: {
      "color": "#fa541c"
    }
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.resendRow.unreadCount)) + " 位未读老师")]), _vm._v(" 再次发送：")]), _vm._v(" "), _c('div', {
    staticClass: "wm-resend-box"
  }, [_vm._v(_vm._s(_vm.resendRow.content))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("已读老师不会收到重复消息。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-modal-foot"
  }, [_c('button', {
    staticClass: "wm-btn wm-btn-ghost",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resendVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('button', {
    staticClass: "wm-btn wm-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.resendLoading
    },
    on: {
      "click": _vm.confirmResend
    }
  }, [_vm._v(_vm._s(_vm.resendLoading ? '发送中…' : '确认发送'))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("消息内容")]), _vm._v(" "), _c('th', [_vm._v("发送对象")]), _vm._v(" "), _c('th', [_vm._v("发送时间")]), _vm._v(" "), _c('th', [_vm._v("发送人数")]), _vm._v(" "), _c('th', [_vm._v("已读")]), _vm._v(" "), _c('th', [_vm._v("未读")]), _vm._v(" "), _c('th', [_vm._v("阅读率")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("followUp记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.studyNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyNickname", $$v)
      },
      expression: "queryParam.studyNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "traceStatus"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.queryParam.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "traceStatus", $$v)
      },
      expression: "queryParam.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "followUp选项",
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "traceItem", $$v)
      },
      expression: "queryParam.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "user",
      "label": "处理人部门："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.queryParam.teamType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "teamType", $$v)
      },
      expression: "queryParam.teamType"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "处理人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.modifierName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "modifierName", $$v)
      },
      expression: "queryParam.modifierName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.schangeDate
    },
    model: {
      value: (_vm.snextDate),
      callback: function($$v) {
        _vm.snextDate = $$v
      },
      expression: "snextDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.echangeDate
    },
    model: {
      value: (_vm.enextDate),
      callback: function($$v) {
        _vm.enextDate = $$v
      },
      expression: "enextDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/saleTrace/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配外教运营"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师"
    }
  }, _vm._l((_vm.tchList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营",
      "prop": "studyAdviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "tchStudyAdviser"
    },
    model: {
      value: (_vm.adviserParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "studyAdviserId", $$v)
      },
      expression: "adviserParam.studyAdviserId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": _vm.title,
      "width": "600"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "tempLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.tempLessonParam,
      "rules": _vm.tempLessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.tempLessonParam.uid) + " - " + _vm._s(_vm.tempLessonParam.mobile) + " - " + _vm._s(_vm.tempLessonParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.tempLessonParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "lsnBeginTimeDate", $$v)
      },
      expression: "tempLessonParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.tempLessonParam.timeStr),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "timeStr", $$v)
      },
      expression: "tempLessonParam.timeStr"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 15
    }
  }, [_c('Form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "accent", $$v)
      },
      expression: "tempLessonParam.accent"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("英音")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("美音")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "sex", $$v)
      },
      expression: "tempLessonParam.sex"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("男")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("女")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 25
    }
  }, [_c('Form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.canBound),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "canBound", $$v)
      },
      expression: "tempLessonParam.canBound"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("有绑定权限")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("无绑定权限")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "tchType", $$v)
      },
      expression: "tempLessonParam.tchType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("外教课")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("陪练课")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 28
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), (_vm.tchList.length > 0) ? _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.tempLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "tchId", _vm._n($$v))
      },
      expression: "tempLessonParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      key: item.id,
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('Row', [_c('Radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName))])], 1), _vm._v(" "), _c('div', [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])])], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.tempLessonParam.optType !== 3) ? _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.optType === 3) ? _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("等会儿再看")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertTempLesson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tempLessonParam.optType === 3 ? '修改代课信息' : '确认') + "\n      ")]), _vm._v(" "), (_vm.tempLessonParam.optType === 3) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.cancelProxy
    }
  }, [_vm._v("直接取消")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "解绑学导"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id + ' - ' + item.nickname) + "\n        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("解绑")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("月数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年月"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-09"
    },
    model: {
      value: (_vm.queryParam.periodLabel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "periodLabel", $$v)
      },
      expression: "queryParam.periodLabel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [20, 50, 100]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v(_vm._s(_vm.pageTitle))])], 1)], 1), _vm._v(" "), (_vm.isTodayNew) ? _c('Tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "on-click": _vm.onNewTabClick
    },
    model: {
      value: (_vm.newTab),
      callback: function($$v) {
        _vm.newTab = $$v
      },
      expression: "newTab"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "今日新生",
      "name": "today"
    }
  }), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "本月新生",
      "name": "month"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-positon": "right"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": true,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课节数"
    }
  }, [_c('Select', {
    attrs: {
      "name": "lessonNum",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonNum", $$v)
      },
      expression: "queryParam.lessonNum"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("前8节课学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("剩余10节课学生")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "剩余课节数"
    }
  }, [_c('Input', {
    attrs: {
      "name": "lastLessonNum"
    },
    model: {
      value: (_vm.queryParam.lastLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lastLessonNum", $$v)
      },
      expression: "queryParam.lastLessonNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定课节数"
    }
  }, [_c('Input', {
    attrs: {
      "name": "bindLessonNum"
    },
    model: {
      value: (_vm.queryParam.bindLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "bindLessonNum", _vm._n($$v))
      },
      expression: "queryParam.bindLessonNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Select', {
    attrs: {
      "name": "lessonWeek",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.selectWeek
    },
    model: {
      value: (_vm.lessonWeek),
      callback: function($$v) {
        _vm.lessonWeek = $$v
      },
      expression: "lessonWeek"
    }
  }, _vm._l((_vm.$constant.weekSelect), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导姓名"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser",
      "disabled": _vm.isTodayNew && _vm.isStudyAdviser
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.loadLevelIds
    },
    model: {
      value: (_vm.queryParam.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersionId", $$v)
      },
      expression: "queryParam.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师名字"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师数"
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.tchBoundNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchBoundNum", $$v)
      },
      expression: "queryParam.tchBoundNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否绑定老师",
      "prop": "isTch"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isTch),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isTch", _vm._n($$v))
      },
      expression: "queryParam.isTch"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已绑定老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未绑定老师")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下周是否排课",
      "prop": "isNextWeekLessonOpened"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isNextWeekLessonOpened),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isNextWeekLessonOpened", _vm._n($$v))
      },
      expression: "queryParam.isNextWeekLessonOpened"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已排课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未排课")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", _vm._n($$v))
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    staticClass: "left-button",
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配课程顾问")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignStudyAdviser
    }
  }, [_vm._v("分配学导")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.stopLoading,
      "disable": _vm.stopLoading,
      "icon": ""
    },
    on: {
      "click": _vm.showStopLessonModel
    }
  }, [_vm._v("移至停课\n          ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showToRefundModal
    }
  }, [_vm._v("移至退费\n          ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.stopLoading,
      "disable": _vm.stopLoading,
      "icon": ""
    },
    on: {
      "click": _vm.cannelStudy
    }
  }, [_vm._v("取消学导绑定\n          ")]), _vm._v(" "), (_vm.isTodayNew) ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")]) : _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('309'),
      expression: "'309'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.tableColumns,
      "reload": _vm.reload,
      "listUrl": "/user/pay/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange,
      "on-sort-change": _vm.handleAssignTimeSortChange
    }
  }), _vm._v(" "), _c('AssignAdviserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  }), _vm._v(" "), _c('AssignUserStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    on: {
      "on-close": _vm.onStudyAdviserClose
    },
    model: {
      value: (_vm.showAssignUserStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignUserStudyAdviserModal = $$v
      },
      expression: "showAssignUserStudyAdviserModal"
    }
  }), _vm._v(" "), _c('UserTestNetworkModal', {
    attrs: {
      "user": _vm.testNetworkParam
    },
    model: {
      value: (_vm.showTestNetworkModal),
      callback: function($$v) {
        _vm.showTestNetworkModal = $$v
      },
      expression: "showTestNetworkModal"
    }
  }), _vm._v(" "), _c('UserLeaveModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserLeaveModal),
      callback: function($$v) {
        _vm.showUserLeaveModal = $$v
      },
      expression: "showUserLeaveModal"
    }
  }), _vm._v(" "), _c('UserTempLessonModal', {
    attrs: {
      "user": _vm.tempLessonUser
    },
    model: {
      value: (_vm.showUserTempLessonModal),
      callback: function($$v) {
        _vm.showUserTempLessonModal = $$v
      },
      expression: "showUserTempLessonModal"
    }
  }), _vm._v(" "), _c('UserPLLessonModal', {
    attrs: {
      "user": _vm.pLLessonUser
    },
    model: {
      value: (_vm.showUserPLLessonModal),
      callback: function($$v) {
        _vm.showUserPLLessonModal = $$v
      },
      expression: "showUserPLLessonModal"
    }
  }), _vm._v(" "), _c('UserChineseLessonModal', {
    attrs: {
      "user": _vm.chineseLessonUser
    },
    model: {
      value: (_vm.showUserChineseLessonModal),
      callback: function($$v) {
        _vm.showUserChineseLessonModal = $$v
      },
      expression: "showUserChineseLessonModal"
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('UserLeaveNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLeaveNumModal),
      callback: function($$v) {
        _vm.showUserLeaveNumModal = $$v
      },
      expression: "showUserLeaveNumModal"
    }
  }), _vm._v(" "), _c('UserLessonNumModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showUserLessonNumModal),
      callback: function($$v) {
        _vm.showUserLessonNumModal = $$v
      },
      expression: "showUserLessonNumModal"
    }
  }), _vm._v(" "), _c('CourseSchedulingModal', {
    attrs: {
      "uid": _vm.uid
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showCourseSchedulingModal),
      callback: function($$v) {
        _vm.showCourseSchedulingModal = $$v
      },
      expression: "showCourseSchedulingModal"
    }
  }), _vm._v(" "), _c('BindTchModal', {
    attrs: {
      "user": _vm.currentRow,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBindTchModal),
      callback: function($$v) {
        _vm.showBindTchModal = $$v
      },
      expression: "showBindTchModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('UserActivityNumModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showActivityNumModal),
      callback: function($$v) {
        _vm.showActivityNumModal = $$v
      },
      expression: "showActivityNumModal"
    }
  }), _vm._v(" "), _c('BookExchangeModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showBookExchangeModal),
      callback: function($$v) {
        _vm.showBookExchangeModal = $$v
      },
      expression: "showBookExchangeModal"
    }
  }), _vm._v(" "), _c('StudentClassHourModal', {
    attrs: {
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showStudentClassHourModal),
      callback: function($$v) {
        _vm.showStudentClassHourModal = $$v
      },
      expression: "showStudentClassHourModal"
    }
  }), _vm._v(" "), _c('ToRefundModal', {
    attrs: {
      "uid": _vm.refundUid,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showRefundModal),
      callback: function($$v) {
        _vm.showRefundModal = $$v
      },
      expression: "showRefundModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "请填写停课理由"
    },
    model: {
      value: (_vm.showStudentLeaveModal),
      callback: function($$v) {
        _vm.showStudentLeaveModal = $$v
      },
      expression: "showStudentLeaveModal"
    }
  }, [_c('Form', {
    ref: "showStudentLeave",
    staticClass: "form",
    attrs: {
      "model": _vm.showStudentLeaveForm,
      "rules": _vm.showStudentLeaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "复课时间",
      "prop": "startStudyDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "options": _vm.options,
      "placeholder": "选择时间"
    },
    on: {
      "on-change": _vm.startStudyDate
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "停课原因",
      "prop": "leaveResult"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入停课理由"
    },
    model: {
      value: (_vm.showStudentLeaveForm.leaveResult),
      callback: function($$v) {
        _vm.$set(_vm.showStudentLeaveForm, "leaveResult", $$v)
      },
      expression: "showStudentLeaveForm.leaveResult"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showStudentLeaveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingShowStudentLeave
    },
    on: {
      "click": _vm.inStopLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": _vm.pageRoute,
      "default-task-type": "ADVISOR_AFTER_CLASS"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课时流水")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生",
      "prop": "studentKey"
    }
  }, [_c('Input', {
    attrs: {
      "name": "studentKey",
      "placeholder": "ID/姓名/手机号"
    },
    model: {
      value: (_vm.queryParam.studentKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studentKey", $$v)
      },
      expression: "queryParam.studentKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时来源"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", $$v)
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((this.channelList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否加课时"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.addNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "addNum", $$v)
      },
      expression: "queryParam.addNum"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时变动时间:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "变动原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "name": "remark",
      "placeholder": "上课"
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.tableColumns,
      "reload": _vm.reload,
      "listUrl": "/class-hour/page",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "入职日 / 到期日"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.hireDate) || '—') + " ~ " + _vm._s((_vm.row && _vm.row.probationEnd) || '—'))]), _vm._v(" "), (_vm.row && _vm.row.daysLeft != null) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("（" + _vm._s(_vm.daysLabel) + "）")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评估结论",
      "required": ""
    }
  }, [_c('Radio-group', {
    model: {
      value: (_vm.form.result),
      callback: function($$v) {
        _vm.$set(_vm.form, "result", $$v)
      },
      expression: "form.result"
    }
  }, _vm._l((_vm.resultDict), function(item, code) {
    return _c('Radio', {
      key: code,
      attrs: {
        "label": code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), (_vm.form.result === 'EXTENDED') ? _c('Form-item', {
    attrs: {
      "label": "延长月数",
      "required": ""
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "max": 6,
      "step": 1
    },
    model: {
      value: (_vm.form.extendMonths),
      callback: function($$v) {
        _vm.$set(_vm.form, "extendMonths", $$v)
      },
      expression: "form.extendMonths"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("个月（1–6）")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.result === 'CONVERTED') ? _c('Form-item', {
    attrs: {
      "label": "新合同起止"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtBeginDate,
      "placeholder": "起始日",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtBeginDate = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("至")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtEndDate,
      "placeholder": "到期日",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtEndDate = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "muted"
  }, [_vm._v("可留空；填了会同时更新老师合同起止")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.result === 'TERMINATED') ? _c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("只记录结论，不改老师状态；离职请到「老师管理」走现有离职流程")])], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评估备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "课堂表现、出勤、家长反馈等"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交结论")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工关系")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("离职管理")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；确认离职仅更新本后台，不会触发钉钉确认离职。不含待退出企业与人才库。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("办理中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已离职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "姓名/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.openSubmit
    }
  }, [_vm._v("办理离职（仅本地）")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无离职单"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "办理离职（仅本地）"
    },
    on: {
      "on-ok": _vm.submit
    },
    model: {
      value: (_vm.showSubmit),
      callback: function($$v) {
        _vm.showSubmit = $$v
      },
      expression: "showSubmit"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "离职原因"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", $$v)
      },
      expression: "form.reason"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("正式老师(菲)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("陪练")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否允许绑定："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isCanBound", _vm._n($$v))
      },
      expression: "queryParam.isCanBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadLeaveTemplate
    }
  }, [_vm._v("下载请假模板")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadLeaveTemplate
    }
  }, [_vm._v("上传请假文件")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.visibleColumns,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/formal/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('ExportLeaveModal', {
    model: {
      value: (_vm.showExportLeaveModal),
      callback: function($$v) {
        _vm.showExportLeaveModal = $$v
      },
      expression: "showExportLeaveModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "subject-type": "TEACHER",
      "snapshot-id": _vm.aiSnapshotId,
      "page-route": "/tch/filipino/tchFormalList",
      "default-task-type": "TCH_RISK_EXPLAIN"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "钉钉用户",
      "width": "600px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "editDingForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.dingRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉用户",
      "prop": "dingtalkUserid"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dingtalkUserid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dingtalkUserid", $$v)
      },
      expression: "formData.dingtalkUserid"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Option', {
      key: item.userId,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(_vm._s(item.userName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否接收钉钉消息",
      "prop": "isReceiveMsg"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isReceiveMsg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isReceiveMsg", _vm._n($$v))
      },
      expression: "formData.isReceiveMsg"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.saveDing
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("题目反馈")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "处理状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "handleStatus", $$v)
      },
      expression: "queryParam.handleStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING"
    }
  }, [_vm._v("待处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PROCESSING"
    }
  }, [_vm._v("处理中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REJECTED"
    }
  }, [_vm._v("不成立")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.queryParam.feedbackType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "feedbackType", $$v)
      },
      expression: "queryParam.feedbackType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "STEM_ERROR"
    }
  }, [_vm._v("题干错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OPTION_ERROR"
    }
  }, [_vm._v("选项错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "AUDIO_ERROR"
    }
  }, [_vm._v("音频错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IMAGE_ERROR"
    }
  }, [_vm._v("图片错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ANSWER_ERROR"
    }
  }, [_vm._v("答案或解析错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISPLAY_ERROR"
    }
  }, [_vm._v("展示异常")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "测评类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择测评类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "sessionId"
    },
    model: {
      value: (_vm.queryParam.sessionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sessionId", $$v)
      },
      expression: "queryParam.sessionId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题目编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "业务编码"
    },
    model: {
      value: (_vm.queryParam.questionCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionCode", $$v)
      },
      expression: "queryParam.questionCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": !_vm.selection.length,
      "loading": _vm.batchLoading
    },
    on: {
      "click": _vm.batchOffline
    }
  }, [_vm._v("批量下线")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/feedback/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "题目反馈",
      "width": "760"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈ID"
    }
  }, [_vm._v(_vm._s(_vm.detail.id))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提交时间"
    }
  }, [_vm._v(_vm._s(_vm.detail.gmtCreate))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "学员"
    }
  }, [_vm._v(_vm._s(_vm.detail.studentName) + " / uid " + _vm._s(_vm.detail.uid))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(_vm._s(_vm.detail.contactPhone || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "场次"
    }
  }, [_vm._v(_vm._s(_vm.examLabel(_vm.detail.examType)) + " / " + _vm._s(_vm.detail.sessionId))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题目"
    }
  }, [(_vm.detail.questionCode) ? _c('a', {
    staticClass: "mex-feedback-qcode",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpToQuestion.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.detail.questionCode))]) : _c('span', [_vm._v("—")]), _vm._v("\n          · " + _vm._s(_vm.skillLabel(_vm.detail.skill)) + " · 第" + _vm._s(_vm.detail.seq) + "题\n        ")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_vm._v(_vm._s(_vm.typeLabel(_vm.detail.feedbackType)))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.detail.content))])]), _vm._v(" "), (_vm.images.length) ? _c('Form-item', {
    attrs: {
      "label": "截图"
    }
  }, _vm._l((_vm.images), function(src, idx) {
    return _c('img', {
      key: idx,
      staticClass: "mex-feedback-img",
      attrs: {
        "src": src
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "当前状态"
    }
  }, [_vm._v(_vm._s(_vm.statusLabel(_vm.detail.handleStatus)))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理方式"
    }
  }, [(_vm.canHandle) ? _c('Select', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "结单必选"
    },
    model: {
      value: (_vm.handleMethod),
      callback: function($$v) {
        _vm.handleMethod = $$v
      },
      expression: "handleMethod"
    }
  }, [_c('Option', {
    attrs: {
      "value": "FIX_CONTENT"
    }
  }, [_vm._v("已改正文/选项/答案")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FIX_ASSET"
    }
  }, [_vm._v("已替换音频或图片")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线题目")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "NO_ISSUE"
    }
  }, [_vm._v("题目无误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CONTACT"
    }
  }, [_vm._v("已联系学员/家长")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1) : _c('span', [_vm._v(_vm._s(_vm.methodLabel(_vm.detail.handleMethod)))])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理人"
    }
  }, [_vm._v(_vm._s(_vm.detail.handlerName || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理时间"
    }
  }, [_vm._v(_vm._s(_vm.detail.handledAt || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理备注"
    }
  }, [(_vm.canHandle) ? _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "结单必填，说明改了什么或为何不成立"
    },
    model: {
      value: (_vm.handleRemark),
      callback: function($$v) {
        _vm.handleRemark = $$v
      },
      expression: "handleRemark"
    }
  }) : _c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.detail.handleRemark || '—'))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    on: {
      "click": function($event) {
        return _vm.handle('PROCESSING')
      }
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handle('DONE')
      }
    }
  }, [_vm._v("已处理")]) : _vm._e(), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    on: {
      "click": function($event) {
        return _vm.handle('REJECTED')
      }
    }
  }, [_vm._v("不成立")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("口语题库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题头 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "题头主键，精确匹配"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-LR-Q001"
    },
    model: {
      value: (_vm.queryParam.businessCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "businessCode", $$v)
      },
      expression: "queryParam.businessCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.queryParam.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelCode", $$v)
      },
      expression: "queryParam.levelCode"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择题型"
    },
    model: {
      value: (_vm.queryParam.questionType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionType", $$v)
      },
      expression: "queryParam.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, 'Speaking')))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING_REVIEW"
    }
  }, [_vm._v("待审核 PENDING_REVIEW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISCARDED"
    }
  }, [_vm._v("已废弃 DISCARDED")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场景"
    },
    model: {
      value: (_vm.queryParam.examScene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examScene", $$v)
      },
      expression: "queryParam.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量编辑")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.triggerImport
    }
  }, [_vm._v("导入口语")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/speak/questions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('MexQuestionBatchModal', {
    attrs: {
      "bank": "speak",
      "selected-rows": _vm.selection
    },
    on: {
      "success": _vm.search
    },
    model: {
      value: (_vm.batchVisible),
      callback: function($$v) {
        _vm.batchVisible = $$v
      },
      expression: "batchVisible"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑口语题",
      "width": "960"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('p', [_vm._v("业务键 " + _vm._s(_vm.businessCode) + " / 版本 " + _vm._s(_vm.form.versionNo) + " / " + _vm._s(_vm.statusLabel(_vm.form.status)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.createMode) ? _c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-LR-Q001"
    },
    model: {
      value: (_vm.businessCode),
      callback: function($$v) {
        _vm.businessCode = $$v
      },
      expression: "businessCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.createMode && _vm.versions.length) ? _c('Form-item', {
    attrs: {
      "label": "历史版本"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.switchVersion
    },
    model: {
      value: (_vm.selectedVersionId),
      callback: function($$v) {
        _vm.selectedVersionId = $$v
      },
      expression: "selectedVersionId"
    }
  }, _vm._l((_vm.versions), function(v) {
    return _c('Option', {
      key: v.id,
      attrs: {
        "value": v.id
      }
    }, [_vm._v(_vm._s(v.versionNo) + " / " + _vm._s(_vm.statusLabel(v.status)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1.0"
    },
    model: {
      value: (_vm.form.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCode", $$v)
      },
      expression: "form.levelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "检索已有题型"
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.editTypeOptions), function(t) {
    return _c('Option', {
      key: t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.examScene),
      callback: function($$v) {
        _vm.$set(_vm.form, "examScene", $$v)
      },
      expression: "form.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能英文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillEnChange
    },
    model: {
      value: (_vm.form.subSkillEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillEn", $$v)
      },
      expression: "form.subSkillEn"
    }
  }, _vm._l((_vm.subSkillEnOptions), function(t) {
    return _c('Option', {
      key: 'en-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能中文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillCnChange
    },
    model: {
      value: (_vm.form.subSkillCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillCn", $$v)
      },
      expression: "form.subSkillCn"
    }
  }, _vm._l((_vm.subSkillCnOptions), function(t) {
    return _c('Option', {
      key: 'cn-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "交互类型"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 speak / record，可空"
    },
    model: {
      value: (_vm.form.interactionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "interactionType", $$v)
      },
      expression: "form.interactionType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干脚本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "口语题干脚本，可空"
    },
    model: {
      value: (_vm.form.script),
      callback: function($$v) {
        _vm.$set(_vm.form, "script", $$v)
      },
      expression: "form.script"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "题目正文"
    },
    model: {
      value: (_vm.form.stem),
      callback: function($$v) {
        _vm.$set(_vm.form, "stem", $$v)
      },
      expression: "form.stem"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "音频地址，可空"
    },
    model: {
      value: (_vm.form.stemAudio),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemAudio", $$v)
      },
      expression: "form.stemAudio"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemAudio,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemAudio = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "图片地址，可空"
    },
    model: {
      value: (_vm.form.stemImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemImage", $$v)
      },
      expression: "form.stemImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemImage,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "示范音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "标准作答音频地址，可空"
    },
    model: {
      value: (_vm.form.answerAudioSample),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerAudioSample", $$v)
      },
      expression: "form.answerAudioSample"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.answerAudioSample,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.answerAudioSample = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "答案/跟读文本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "跟读或标准作答文本，如 apple"
    },
    model: {
      value: (_vm.form.answerKey),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerKey", $$v)
      },
      expression: "form.answerKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "完整参考作答"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "完整示范答案，可空"
    },
    model: {
      value: (_vm.form.referenceAnswerFull),
      callback: function($$v) {
        _vm.$set(_vm.form, "referenceAnswerFull", $$v)
      },
      expression: "form.referenceAnswerFull"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "满分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "单题满分，如 2"
    },
    model: {
      value: (_vm.form.fullScore),
      callback: function($$v) {
        _vm.$set(_vm.form, "fullScore", $$v)
      },
      expression: "form.fullScore"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "1-5 星"
    },
    model: {
      value: (_vm.form.difficultyLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "difficultyLevel", $$v)
      },
      expression: "form.difficultyLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题权重"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "现稿多为 0.5"
    },
    model: {
      value: (_vm.form.adaptiveWeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "adaptiveWeight", $$v)
      },
      expression: "form.adaptiveWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分维度"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("口语 AI 三维权重，建议合计 100。空着保存时按准确 40 / 流利 30 / 完整 30。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.dimensions), function(d) {
    return _c('i-col', {
      key: d.key,
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.dimLabel(d.key)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 40"
      },
      model: {
        value: (d.weight),
        callback: function($$v) {
          _vm.$set(d, "weight", $$v)
        },
        expression: "d.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.dimSum))])], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分细则"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "口语评分细则，可空"
    },
    model: {
      value: (_vm.form.scoringRubric),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringRubric", $$v)
      },
      expression: "form.scoringRubric"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "AI基准"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "音素/语速等 AI 评分基准，可空"
    },
    model: {
      value: (_vm.form.aiBenchmark),
      callback: function($$v) {
        _vm.$set(_vm.form, "aiBenchmark", $$v)
      },
      expression: "form.aiBenchmark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "解析"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "解析文案，可空"
    },
    model: {
      value: (_vm.form.explanation),
      callback: function($$v) {
        _vm.$set(_vm.form, "explanation", $$v)
      },
      expression: "form.explanation"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "考点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "考查点，可空"
    },
    model: {
      value: (_vm.form.examPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "examPoint", $$v)
      },
      expression: "form.examPoint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "内部备注，可空"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "常见错误"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "常见错误说明，可空"
    },
    model: {
      value: (_vm.form.commonMistakes),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMistakes", $$v)
      },
      expression: "form.commonMistakes"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "知识点"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识点路径，可空"
    },
    model: {
      value: (_vm.form.knowledgePointHierarchy),
      callback: function($$v) {
        _vm.$set(_vm.form, "knowledgePointHierarchy", $$v)
      },
      expression: "form.knowledgePointHierarchy"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 SPE-01"
    },
    model: {
      value: (_vm.form.abilityDimensionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDimensionCode", $$v)
      },
      expression: "form.abilityDimensionCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力档"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "内部能力档，可空"
    },
    model: {
      value: (_vm.form.scoreMappingLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreMappingLevel", $$v)
      },
      expression: "form.scoreMappingLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程单元"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "对应课程单元，可空"
    },
    model: {
      value: (_vm.form.courseUnitMapping),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseUnitMapping", $$v)
      },
      expression: "form.courseUnitMapping"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "能力描述"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告用的能力描述，可空"
    },
    model: {
      value: (_vm.form.abilityDescription),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDescription", $$v)
      },
      expression: "form.abilityDescription"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全国均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 72.5，可空"
    },
    model: {
      value: (_vm.form.benchmarkNationalAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkNationalAvg", $$v)
      },
      expression: "form.benchmarkNationalAvg"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同城优秀均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 85，可空"
    },
    model: {
      value: (_vm.form.benchmarkCityExcellentAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkCityExcellentAvg", $$v)
      },
      expression: "form.benchmarkCityExcellentAvg"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提升建议"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告提升建议，可空"
    },
    model: {
      value: (_vm.form.improvementSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.form, "improvementSuggestion", $$v)
      },
      expression: "form.improvementSuggestion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "练习推荐"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "推荐练习，可空"
    },
    model: {
      value: (_vm.form.recommendedPractice),
      callback: function($$v) {
        _vm.$set(_vm.form, "recommendedPractice", $$v)
      },
      expression: "form.recommendedPractice"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "前置知识"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "前置知识，可空"
    },
    model: {
      value: (_vm.form.prerequisiteKnowledge),
      callback: function($$v) {
        _vm.$set(_vm.form, "prerequisiteKnowledge", $$v)
      },
      expression: "form.prerequisiteKnowledge"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "掌握周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 1-2周，可空"
    },
    model: {
      value: (_vm.form.learningCycle),
      callback: function($$v) {
        _vm.$set(_vm.form, "learningCycle", $$v)
      },
      expression: "form.learningCycle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "老师对学生的评价"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdate),
      expression: "!isUpdate"
    }],
    staticClass: "feedback form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习内容评价："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedback.learnedComment))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "表现好的评价："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedback.goodComment))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "可以改进的评价："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedback.betterComment))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "老师评论时间: "
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackTime))])])], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdate),
      expression: "isUpdate"
    }],
    ref: "feedbakcForm",
    staticClass: "feedback form",
    attrs: {
      "model": _vm.feedback,
      "rules": _vm.feedbackRule,
      "label-position": "top"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习内容评价：",
      "prop": "learnedComment"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "maxlength": 300
    },
    model: {
      value: (_vm.feedback.learnedComment),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "learnedComment", $$v)
      },
      expression: "feedback.learnedComment"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "表现好的评价：",
      "prop": "goodComment"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "maxlength": 300
    },
    model: {
      value: (_vm.feedback.goodComment),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "goodComment", $$v)
      },
      expression: "feedback.goodComment"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "可以改进的评价：",
      "prop": "betterComment"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "maxlength": 300
    },
    model: {
      value: (_vm.feedback.betterComment),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "betterComment", $$v)
      },
      expression: "feedback.betterComment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdate && !_vm.readonly),
      expression: "!isUpdate && !readonly"
    }],
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.isUpdate = true
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdate),
      expression: "isUpdate"
    }],
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("权限菜单列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分类",
      "prop": "nickname"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.onSearchPidChange
    }
  }, _vm._l((_vm.parentRules), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子分类",
      "prop": "mobile"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.onSearchSubPidChange
    }
  }, _vm._l((_vm.searchSubRules), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "路径",
      "prop": "name"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('')
      }
    }
  }, [_vm._v("添加权限\n    ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminRule/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "URL",
      "prop": "name"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分类",
      "prop": "pid"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onPidChange
    },
    model: {
      value: (_vm.pid),
      callback: function($$v) {
        _vm.pid = _vm._n($$v)
      },
      expression: "pid"
    }
  }, _vm._l((_vm.parentRules), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子分类"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onSubPidChange
    },
    model: {
      value: (_vm.subPid),
      callback: function($$v) {
        _vm.subPid = _vm._n($$v)
      },
      expression: "subPid"
    }
  }, _vm._l((_vm.subRules), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", _vm._n($$v))
      },
      expression: "formData.type"
    }
  }, _vm._l((_vm.adminRuleTypes), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "排序",
      "prop": "sort"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.sort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sort", $$v)
      },
      expression: "formData.sort"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-试听课成功预约提醒记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": 10
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所处年级:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.grades
    },
    on: {
      "on-select-change": _vm.onGradeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习经历:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.studyExperience
    },
    on: {
      "on-select-change": _vm.onStudyExperienceChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "孩子性格:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.studentNature
    },
    on: {
      "on-select-change": _vm.onStudentNature
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "兴趣爱好:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.hobby
    },
    on: {
      "on-select-change": _vm.onHobbyChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师要求:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.tchRequirement
    },
    on: {
      "on-select-change": _vm.ontchRequirementChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.formData.nextTimeDate
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.$constant.handlerType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "city-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProvince),
      expression: "selectedProvince"
    }],
    attrs: {
      "name": "province"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProvince = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.provinces), function(item, index) {
    return (item.level === 1) ? _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCity),
      expression: "selectedCity"
    }],
    attrs: {
      "name": "city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cities), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBlock),
      expression: "selectedBlock"
    }],
    attrs: {
      "name": "block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBlock = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.blocks), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list smart-hr-roster"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("花名册")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增/修改/导入导出不会写回钉钉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false,
      "inline": ""
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.empStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "empStatus", $$v)
      },
      expression: "query.empStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("在职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DIMISSION"
    }
  }, [_vm._v("已离职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PREHIRE"
    }
  }, [_vm._v("待入职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "姓名/手机/工号/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "left-btn"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("本地新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-btn"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.tplLoading
    },
    on: {
      "click": _vm.doTemplate
    }
  }, [_vm._v("下载导入模板")]), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "8px"
    },
    attrs: {
      "before-upload": _vm.beforeImport,
      "show-upload-list": false,
      "action": "",
      "accept": ".xlsx,.xls"
    }
  }, [_c('Button', {
    attrs: {
      "loading": _vm.importing
    }
  }, [_vm._v("导入（仅本地）")])], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), (_vm.syncMsg) ? _c('div', {
    staticClass: "sync-msg"
  }, [_vm._v(_vm._s(_vm.syncMsg))]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无员工，请先从钉钉同步"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPage,
      "on-page-size-change": _vm.onSize
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "员工详情",
      "mask-closable": false,
      "width": "640",
      "footer-hide": true
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.detail) ? _c('div', [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.mobile),
      callback: function($$v) {
        _vm.$set(_vm.edit, "mobile", $$v)
      },
      expression: "edit.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "工号"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.edit, "jobNumber", $$v)
      },
      expression: "edit.jobNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "职位"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.position),
      callback: function($$v) {
        _vm.$set(_vm.edit, "position", $$v)
      },
      expression: "edit.position"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.deptNames),
      callback: function($$v) {
        _vm.$set(_vm.edit, "deptNames", $$v)
      },
      expression: "edit.deptNames"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.edit.empStatus),
      callback: function($$v) {
        _vm.$set(_vm.edit, "empStatus", $$v)
      },
      expression: "edit.empStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("在职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DIMISSION"
    }
  }, [_vm._v("已离职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PREHIRE"
    }
  }, [_vm._v("待入职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.edit.source === 'LOCAL' || _vm.edit.localDirty === 1 ? '本地维护' : '钉钉同步'))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveLocal
    }
  }, [_vm._v("保存（仅本地）")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        _vm.drawer = false
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('Divider', [_vm._v("花名册字段")]), _vm._v(" "), (!(_vm.detail.fields && _vm.detail.fields.length)) ? _c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("暂无字段数据")]) : _c('Table', {
    attrs: {
      "size": "small",
      "columns": _vm.fieldColumns,
      "data": _vm.detail.fields
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "本地新增员工（不写回钉钉）"
    },
    on: {
      "on-ok": _vm.addLocal
    },
    model: {
      value: (_vm.showAdd),
      callback: function($$v) {
        _vm.showAdd = $$v
      },
      expression: "showAdd"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "工号"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "jobNumber", $$v)
      },
      expression: "addForm.jobNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "职位"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.position),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "position", $$v)
      },
      expression: "addForm.position"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.deptNames),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deptNames", $$v)
      },
      expression: "addForm.deptNames"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("资金管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("用户账单")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Row', {
    attrs: {
      "class-name": "statistics"
    }
  }, [_c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n        总实付金额: "), _c('label', [_vm._v(_vm._s(_vm.statistics.totalPayment))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n        总金额: "), _c('label', [_vm._v(_vm._s(_vm.statistics.totalAmount))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n        总折扣: "), _c('label', [_vm._v(_vm._s(_vm.statistics.totalDiscount))])])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "lable-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/fundUserBill/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("财务管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("应开发票")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("合计金额：" + _vm._s(this.totalHasPayAmount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("已开发票金额：" + _vm._s(this.totalInvoiceAmount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("未开发票金额：" + _vm._s(this.notTotalInvoiceAmount))])]), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "开票时间："
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.beginTimeChange
    },
    model: {
      value: (_vm.queryParam.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "beginTime", $$v)
      },
      expression: "queryParam.beginTime"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.endTimeChange
    },
    model: {
      value: (_vm.queryParam.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTime", $$v)
      },
      expression: "queryParam.endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "开票状态："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.invoiceState),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "invoiceState", _vm._n($$v))
      },
      expression: "queryParam.invoiceState"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("未开")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("部分已开")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("已开")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": -1
    }
  }, [_vm._v("全部")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "发票类型："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.state),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "state", _vm._n($$v))
      },
      expression: "queryParam.state"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("收据")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("普通发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("增值税发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("服务发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": -1
    }
  }, [_vm._v("全部")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生id"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员姓名：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生姓名"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "params": _vm.queryParam,
      "tableColumns": _vm.title,
      "listUrl": _vm.listUrl,
      "reload": _vm.reload,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('EditInvoiceModal', {
    attrs: {
      "value": _vm.editInvoice,
      "uid": _vm.uid,
      "invoiceDetail": _vm.invoiceDetail,
      "orderId": _vm.orderId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("订单列表")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生合同")])], 1)], 1)]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.formData.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.contract),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contract", $$v)
      },
      expression: "formData.contract"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分享有礼海报管理")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "归属活动"
    }
  }, [_c('Col', [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.queryParams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "activityId", $$v)
      },
      expression: "queryParams.activityId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "海报分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "sharePosterType", $$v)
      },
      expression: "queryParams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            搜索\n          ")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toShowAddposterModel
    }
  }, [_vm._v("\n          添加海报\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/share/poster/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('CreateShareModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddPosterModel),
      callback: function($$v) {
        _vm.showAddPosterModel = $$v
      },
      expression: "showAddPosterModel"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑海报"
    },
    model: {
      value: (_vm.showUpdatePosterModel),
      callback: function($$v) {
        _vm.showUpdatePosterModel = $$v
      },
      expression: "showUpdatePosterModel"
    }
  }, [_c('Form', {
    ref: "updatePosterForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.shareRules,
      "model": _vm.updatePosterParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updatePosterParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "name", $$v)
      },
      expression: "updatePosterParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报分类：",
      "prop": "sharePosterType"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updatePosterParams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "sharePosterType", $$v)
      },
      expression: "updatePosterParams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动归属：",
      "prop": "activityId"
    }
  }, [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.updatePosterParams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "activityId", $$v)
      },
      expression: "updatePosterParams.activityId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "配套海报：",
      "prop": "url"
    }
  }, [_c('image-upload-New', {
    attrs: {
      "defaultFileList": _vm.updateDefalutPic
    },
    model: {
      value: (_vm.updatePosterParams.url),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "url", $$v)
      },
      expression: "updatePosterParams.url"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报排序：",
      "prop": "sort"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 100000
    },
    model: {
      value: (_vm.updatePosterParams.sort),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "sort", $$v)
      },
      expression: "updatePosterParams.sort"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updatePosterParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "status", $$v)
      },
      expression: "updatePosterParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdatePosterModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddPoster
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "上课反馈"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.recordParam,
      "rules": _vm.recordRule,
      "label-width": 120
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID、姓名："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.studentName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID、姓名："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.teacherName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.lessonTime))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课反馈",
      "prop": "feedContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.recordParam.feedContent),
      callback: function($$v) {
        _vm.$set(_vm.recordParam, "feedContent", $$v)
      },
      expression: "recordParam.feedContent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("评价超时列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listOverTimeReview",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加退款记录",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 110,
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.searchUserInfo(false)
      }
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员姓名"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.nickname),
      callback: function($$v) {
        _vm.$set(_vm.user, "nickname", $$v)
      },
      expression: "user.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.mobile),
      callback: function($$v) {
        _vm.$set(_vm.user, "mobile", $$v)
      },
      expression: "user.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.user, "adviserName", $$v)
      },
      expression: "user.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.user.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.user, "studyAdviserName", $$v)
      },
      expression: "user.studyAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": _vm.lastTeacherLabel,
      "prop": "lastTchId",
      "required": _vm.refundTeacherRequired
    }
  }, [(!_vm.canSave) ? _c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.lastTchName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastTchName", $$v)
      },
      expression: "formData.lastTchName"
    }
  }) : _c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.formData.lastTchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.formData.lastTchId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastTchId", $$v)
      },
      expression: "formData.lastTchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对应老师外管"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.tchAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchAdviserName", $$v)
      },
      expression: "formData.tchAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.regChannel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regChannel", $$v)
      },
      expression: "formData.regChannel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时费",
      "prop": "lessonFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.lessonFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonFee", _vm._n($$v))
      },
      expression: "formData.lessonFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "礼品费",
      "prop": "giftFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.giftFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "giftFee", _vm._n($$v))
      },
      expression: "formData.giftFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手续费",
      "prop": "serviceFee"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.serviceFee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "serviceFee", _vm._n($$v))
      },
      expression: "formData.serviceFee"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "实际退款金额",
      "prop": "actualRefundAmount"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.actualRefundAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "actualRefundAmount", _vm._n($$v))
      },
      expression: "formData.actualRefundAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "其他扣款",
      "prop": "otherAmount"
    }
  }, [_c('Input', {
    on: {
      "on-change": _vm.onFeeFieldChange
    },
    model: {
      value: (_vm.formData.otherAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherAmount", _vm._n($$v))
      },
      expression: "formData.otherAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款账号",
      "prop": "refundAccount"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundAccount", $$v)
      },
      expression: "formData.refundAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款原因",
      "prop": "refundReason"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundReason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundReason", $$v)
      },
      expression: "formData.refundReason"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款原因分类",
      "prop": "refundReasonCategory"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.refundReasonCategory),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundReasonCategory", $$v)
      },
      expression: "formData.refundReasonCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("外教原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("学导原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("销售原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("技术原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("产品原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("学生客观原因")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注",
      "prop": "refundRemark"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundRemark", $$v)
      },
      expression: "formData.refundRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "orderId"
    }
  }), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "prop": "courseUnitPrice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.canSave) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertUser
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedOrderListChange
    },
    model: {
      value: (_vm.checkedList),
      callback: function($$v) {
        _vm.checkedList = $$v
      },
      expression: "checkedList"
    }
  }, [_c('table', {
    staticClass: "track-list"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("订单课时")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("教材金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("开票金额")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("合计课节")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("累计消耗")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("补课次数")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("课时单价")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("消耗")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', [_c('td', [_c('el-checkbox', {
      attrs: {
        "label": item.orderSn
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orderAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orderCourseNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.textAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.invoiceAmount))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.taotalCourseNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.costCourseNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(item.makeupNum))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_c('Input', {
      attrs: {
        "readonly": !_vm.canSave
      },
      on: {
        "on-change": _vm.onUnitPriceChange
      },
      model: {
        value: (_vm.formData.courseUnitPrice),
        callback: function($$v) {
          _vm.$set(_vm.formData, "courseUnitPrice", _vm._n($$v))
        },
        expression: "formData.courseUnitPrice"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": index == 0 ? _vm.colSpan : 0,
        "hidden": index != 0
      }
    }, [_vm._v(_vm._s(_vm.displayCostAmount))])])
  }), 0)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Demo Reivew V2",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part one: Learning Status ")]), _vm._v(" "), _c('h3', [_vm._v("Child’s Engagement  : "), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part1.type === 'typeA') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you were highly engaged in class, showing exceptional participation! You asked questions proactively and made great efforts to use new sentence structures in your responses. Excellent work in class today!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part1.type === 'typeB') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you were overall active in class participation, though you occasionally needed gentle prompts (e.g., hand gestures) to share more details or join in. Keep up the good work—your involvement was fantastic!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part1.type === 'typeC') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you seemed a bit shy in class, responding to questions in a soft voice and rarely initiating conversations. It was wonderful to see you try when guided patiently, though! Looking forward to seeing more of your participation in future classes—you’ve got this!\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part two: Learning Ability  :")]), _vm._v(" "), _c('h3', [_vm._v("1. Listening Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part2.type === 'typeA') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you grasped information accurately and followed instructions flawlessly")]), _vm._v(". You also demonstrated clear understanding of key details like greetings, class extensions, and dialogues/passages in the materials.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part2.type === 'typeB') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you comprehended information adequately and followed most instructions correctly")]), _vm._v(". You understood surface-level details such as basic greetings, simple class extensions, and straightforward dialogues from the materials.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part2.type === 'typeC') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you grasped information vaguely and followed some of the instructions correctly")]), _vm._v(". Besides, you required repeated instructions and demonstrations to process even foundational elements like basic greetings, simple class cues, or short phrases from the materials.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("2. Oral Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part3.type === 'typeA') ? _c('h4', [_vm._v("\n        You demonstrated excellent speaking skills with clear pronunciation—only minor slips, such as "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v(", and fluent verbal output. You voluntarily spoke in full sentences, showing strong command of the content.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part3.type === 'typeB') ? _c('h4', [_vm._v("\n        Your speaking skills were moderate, with minor pronunciation issues (e.g., "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v(") and average fluency. You could expand into full sentences when prompted, showing basic ability to elaborate.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part3.type === 'typeC') ? _c('h4', [_vm._v("\n        Your speaking skills were weak, with frequent pronunciation errors (e.g., "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v("). You often got stuck mid-sentence, struggling with words or phrases, and required word-by-word guidance to complete expressions.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("3. Reading Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part4.type === 'typeA') ? _c('h4', [_vm._v("\n        You read fluently and expressively, with a strong grasp of underlying logic. New and high-frequency words were pronounced correctly, with natural pauses at phrase chunks.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part4.type === 'typeB') ? _c('h4', [_vm._v("\n        Your reading was somewhat halting, but you grasped surface meanings well. Most words were correct, with slight pauses on longer ones.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part4.type === 'typeC') ? _c('h4', [_vm._v("\n        Your reading was halting, with recognition limited to basics. Mispronunciations and struggles with new words were common.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("4. Grammar & Vocabulary Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part5.type === 'typeA') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were advanced. You made only occasional minor grammar errors "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) and showed a strong ability to self-correct. You voluntarily used advanced vocabulary and confidently experimented with creating new sentences.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part5.type === 'typeB') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were at a basic level. You made a few grammar errors "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) but caught on quickly when reminded. You were skilled at using familiar words and occasionally tried new ones, though you may misuse them at times.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part5.type === 'typeC') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were developing and would benefit from focusing on basics first. You often made pronunciation errors or got stuck on new words, and you currently recognized mostly basic vocabulary. It would help to start with foundational grammar "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense usage, article/plural rules, verb collocations, complete sentences, or adjective/adverb differences) and practice using new words in simple sentences step by step.\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part three: Summary  :")]), _vm._v(" "), _c('h3', [_vm._v("Summary of overall performance.  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part6.type === 'typeA') ? _c('h4', [_vm._v("\n        Overall, I was thoroughly impressed with your engagement in today’s class! Your proactive questions and eagerness to experiment with new sentence structures made your participation truly standout. It was a joy to have you in class, and I’m already looking forward to our next session—keep up this fantastic energy!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part6.type === 'typeB') ? _c('h4', [_vm._v("\n        Overall, your participation in class was great to see! While you occasionally needed a little nudge to share more, you jumped in willingly and kept the momentum going. Keep building on that—your effort shines through, and I can’t wait to see you grow even more in our next class!​\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part6.type === 'typeC') ? _c('h4', [_vm._v("\n        Overall, I appreciated seeing you step into class today—even if you felt a bit shy. You answered questions thoughtfully, and with a little patience, you opened up more than you might realize. Let’s keep that going! I’m looking forward to our next class, where I hope to hear your voice a little louder and see you start a conversation or two—you’ve got so much to share!\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part four: Learning Suggestions  :")]), _vm._v(" "), _c('h4', [_vm._v("\n        The demo level is\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part7.words),
      expression: "partData.part7.words"
    }],
    staticClass: "redBorder",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.partData.part7, "words", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.levelNames), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" for the student because "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part8.words),
      expression: "partData.part8.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part8.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part8, "words", $event.target.value)
      }
    }
  }), _vm._v("(fill the reason if level is a bit difficult or a bit easy).\n      ")]), _vm._v(" "), _c('h2'), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose one or both suggestions for student.)")])]), _vm._v(" "), _c('h4', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part9.words),
      expression: "partData.part9.words"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.partData.part9.words) ? _vm._i(_vm.partData.part9.words, null) > -1 : (_vm.partData.part9.words)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.partData.part9.words,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.partData.part9, "words", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.partData.part9, "words", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.partData.part9, "words", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("*suggestion 1*For listening and speaking practice,")]), _vm._v(" it is recommended to listen to English songs, podcasts, English stories, etc., and engage in shadowing, imitation, and even retelling exercises. For difficult pronunciations and vocabulary, learn from teachers.\n      ")]), _vm._v(" "), _c('h4', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part10.words),
      expression: "partData.part10.words"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.partData.part10.words) ? _vm._i(_vm.partData.part10.words, null) > -1 : (_vm.partData.part10.words)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.partData.part10.words,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.partData.part10, "words", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.partData.part10, "words", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.partData.part10, "words", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("*suggestion 2*In reading, grammar, and vocabulary sections,")]), _vm._v("\n        try to read interesting English materials such as picture books and chapter books to accumulate vocabulary and sentence patterns through reading. For grammar, do targeted exercises on problematic grammar points to consolidate learning, and consult teachers for clarification on doubts.\n      ")]), _vm._v(" "), _c('h4', [_vm._v("\n        Also,  I suggest starting your English journey from "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation),
      expression: "evaluation"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.evaluation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.evaluation = $event.target.value
      }
    }
  }), _vm._v(" (a particular level that we have) and taking classes twice or three times a week to ensure a great learning outcome.\n      ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "开票",
      "width": "900px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.invoiceFormData,
      "rules": _vm.invoiceRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.id) + " -- " + _vm._s(_vm.invoiceFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.studyAdviserName))])])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票信息：",
      "prop": "content",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.invoiceFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "content", $$v)
      },
      expression: "invoiceFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票时间：",
      "label-width": 90
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.invoiceTimeChange
    },
    model: {
      value: (_vm.invoiceFormData.invoiceTime),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "invoiceTime", $$v)
      },
      expression: "invoiceFormData.invoiceTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票金额：",
      "prop": "amount",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "开票金额"
    },
    model: {
      value: (_vm.invoiceFormData.amount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "amount", $$v)
      },
      expression: "invoiceFormData.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发票类型：",
      "prop": "state",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.invoiceFormData.state),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "state", _vm._n($$v))
      },
      expression: "invoiceFormData.state"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("收据")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("普通发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("增值税发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("服务发票")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发票号码：",
      "prop": "number",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "发票号码"
    },
    model: {
      value: (_vm.invoiceFormData.number),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "number", $$v)
      },
      expression: "invoiceFormData.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "620px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("开票")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "test"
    },
    on: {
      "click": _vm.callback
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 1
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("开票记录")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.invoiceTitle,
      "data": _vm.invoiceData,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isActive) ? _c('span', [_c('Button', {
    attrs: {
      "type": _vm.buttonType,
      "icon": _vm.buttonIcon,
      "shape": _vm.buttonShape,
      "size": _vm.buttonSize
    }
  }, [_vm._v(_vm._s(_vm.buttonValue))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('span', [_c('Button', {
    attrs: {
      "type": _vm.buttonType,
      "icon": _vm.buttonIcon,
      "shape": _vm.buttonShape,
      "size": _vm.buttonSize,
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.buttonValue))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "作品评分"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          学生：" + _vm._s(_vm.userVideoParams.userId) + "-" + _vm._s(_vm.userVideoParams.userName) + "\n        ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          作品名称：" + _vm._s(_vm.userVideoParams.title) + "\n        ")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "评分",
      "prop": "score"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.score),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "score", $$v)
      },
      expression: "userVideoParams.score"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditModal
    },
    on: {
      "click": _vm.editUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("取消课程记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLesson/opened/cancelList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("文章发布表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", $$v)
      },
      expression: "queryParam.period"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊"
    },
    model: {
      value: (_vm.queryParam.personName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "personName", $$v)
      },
      expression: "queryParam.personName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openChannelManage
    }
  }, [_vm._v("渠道管理")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableDataWithSum,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [50, 100, 200]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑' : '新增',
      "width": 520
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.formData.period),
      callback: function($$v) {
        _vm.$set(_vm.formData, "period", $$v)
      },
      expression: "formData.period"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.personName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "personName", $$v)
      },
      expression: "formData.personName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.enabledChannels), function(ch) {
    return _c('Form-item', {
      key: ch.channelKey,
      attrs: {
        "label": ch.displayName
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0
      },
      model: {
        value: (_vm.formData.channelValues[ch.channelKey]),
        callback: function($$v) {
          _vm.$set(_vm.formData.channelValues, ch.channelKey, $$v)
        },
        expression: "formData.channelValues[ch.channelKey]"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.enabledChannels.length) ? _c('div', {
    staticStyle: {
      "color": "#999",
      "padding-left": "100px"
    }
  }, [_vm._v("请先在渠道管理中添加渠道")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "渠道管理",
      "width": 720
    },
    on: {
      "on-visible-change": _vm.onChannelVisible
    },
    model: {
      value: (_vm.showChannelModal),
      callback: function($$v) {
        _vm.showChannelModal = $$v
      },
      expression: "showChannelModal"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddChannel
    }
  }, [_vm._v("新增渠道")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.channelColumns,
      "data": _vm.allChannels,
      "loading": _vm.channelLoading,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showChannelModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.channelForm.id ? '改名' : '新增渠道',
      "width": 480
    },
    model: {
      value: (_vm.showChannelEdit),
      callback: function($$v) {
        _vm.showChannelEdit = $$v
      },
      expression: "showChannelEdit"
    }
  }, [(_vm.channelForm.id) ? _c('Alert', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("改名只影响展示，不影响已填数据。")]) : _vm._e(), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "展示名",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "列表列头"
    },
    model: {
      value: (_vm.channelForm.displayName),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "displayName", $$v)
      },
      expression: "channelForm.displayName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标识"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.channelForm.id,
      "placeholder": _vm.channelForm.id ? '' : '留空则自动生成'
    },
    model: {
      value: (_vm.channelForm.channelKey),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "channelKey", $$v)
      },
      expression: "channelForm.channelKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "placeholder": "默认追加到末尾"
    },
    model: {
      value: (_vm.channelForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "sort", $$v)
      },
      expression: "channelForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showChannelEdit = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.channelSaving
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("培训中老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营",
      "label-width": 109
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, _vm._l((_vm.$constant.isStudyAdviser), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音：",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, _vm._l((_vm.$constant.accent), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别：",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "推荐人姓名"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchReject
    }
  }, [_vm._v("批量拒绝")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/training/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage,
      "addType": _vm.addType,
      "recruit-flow-entry": "培训中老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', {
    attrs: {
      "model": "selectTchParam"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    staticClass: "form",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定 "), _c('b', [_vm._v(_vm._s(_vm.rejectParam.id) + " - " + _vm._s(_vm.rejectParam.firstName) + " " + _vm._s(_vm.rejectParam.lastName))]), _vm._v(" 老师未审核通过")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "leaveKind"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.rejectParam.leaveKind),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "leaveKind", $$v)
      },
      expression: "rejectParam.leaveKind"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("流失")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.rejectParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "remark", $$v)
      },
      expression: "rejectParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "批量审核"
    },
    model: {
      value: (_vm.showBatchReviewModal),
      callback: function($$v) {
        _vm.showBatchReviewModal = $$v
      },
      expression: "showBatchReviewModal"
    }
  }, [_c('Form', {
    ref: "reviewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.reviewParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "待审核老师："
    }
  }, _vm._l((_vm.selectionTch), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型：",
      "prop": "leaveKind"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.reviewParam.leaveKind),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "leaveKind", $$v)
      },
      expression: "reviewParam.leaveKind"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("流失")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.reviewParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "remark", $$v)
      },
      expression: "reviewParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.batchReview
    }
  }, [_vm._v("拒绝")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "评测报告"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.reportParam,
      "rules": _vm.ruleUser
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "tchId", $$v)
      },
      expression: "reportParam.tchId"
    }
  }, _vm._l((_vm.tchAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.tchName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "studyAdviserId", $$v)
      },
      expression: "reportParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.tutorId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "tutorId", $$v)
      },
      expression: "reportParam.tutorId"
    }
  }, _vm._l((_vm.tutorAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "测评报告："
    }
  }, [_c('file-upload', {
    attrs: {
      "defaultFileList": _vm.defaultAudioList,
      "text": "点击上传测评报告(PDF格式)",
      "accept": "application/*"
    },
    on: {
      "on-file-change": _vm.handleReportDoc
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对应课节：",
      "label-width": 90,
      "prop": "lessonNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.reportParam.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "lessonNum", _vm._n($$v))
      },
      expression: "reportParam.lessonNum"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课程消耗日报列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间:"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryParam.startDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startDate", $$v)
      },
      expression: "queryParam.startDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryParam.endDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endDate", $$v)
      },
      expression: "queryParam.endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyConsultantId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyConsultantId", $$v)
      },
      expression: "queryParam.studyConsultantId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/dataCenter/lessonDailyList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "请假 / 旷课影响",
      "tags": ['老师请假 + 旷课', '3 小时线'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 关键不是请假多少，而是来不及代课的有多少：3 小时外安排代课，3 小时内不安排代课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false), [(card.key === 'scope') ? _c('div', {
      staticClass: "kpi-split"
    }, [_c('div', [_c('div', {
      staticClass: "kpi-split-value"
    }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.studentCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-label"
    }, [_vm._v("学生（去重）")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-right"
    }, [_c('div', {
      staticClass: "kpi-split-value is-warning"
    }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.lessonCount))), _c('small', [_vm._v("课节")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-split-label"
    }, [_vm._v("受影响课节")])])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("3 小时是硬边界：3 小时外系统安排代课，3 小时内没有兜底。系统里家长取消与改期补回无法区分，结果只分「成功代课 / 未代课」。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "compare-boxes"
  }, [_c('div', {
    staticClass: "compare-box"
  }, [_c('div', {
    staticClass: "compare-box-title is-healthy"
  }, [_vm._v("3 小时外请假")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value"
  }, [_vm._v(_vm._s(_vm.fmtRateNum(_vm.d.outerLossRate))), _c('small', [_vm._v("% 未代课率")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.outerCount)) + " 课节 · 代课率 " + _vm._s(_vm.fmtRate(_vm.d.outerProxyRate)))])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box is-danger"
  }, [_c('div', {
    staticClass: "compare-box-title is-danger"
  }, [_vm._v("3 小时内请假 / 旷课")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value is-danger"
  }, [_vm._v(_vm._s(_vm.fmtRateNum(_vm.d.innerLossRate))), _c('small', [_vm._v("% 未代课率")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.innerCount)) + " 课节 · 占受影响 " + _vm._s(_vm.fmtRate(_vm.d.innerShare)))])])]), _vm._v(" "), (_vm.num(_vm.d.lossCount) > 0) ? _c('div', {
    staticClass: "note is-danger"
  }, [_c('b', [_vm._v("3 小时内的课节只占 " + _vm._s(_vm.fmtRate(_vm.d.innerShare)) + "，却贡献了 " + _vm._s(_vm.fmtRate(_vm.d.innerLossShare)) + " 的未代课。")]), _vm._v("这部分不安排代课，没有系统兜底。\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("3h 内调度策略")]), _c('dd', [_vm._v("不安排代课")]), _vm._v(" "), _c('dt', [_vm._v("3h 内未代课")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.innerLossCount)) + " 课节")]), _vm._v(" "), _c('dt', [_vm._v("旷课未代课率")]), _c('dd', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.absentLossRate)) + "（占 " + _vm._s(_vm.fmtRate(_vm.d.absentShare)) + " 课节）")]), _vm._v(" "), _c('dt', [_vm._v("请假 / 旷课事件")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.eventCount)) + " 次 · 次均 " + _vm._s(_vm.fmtNum(_vm.d.avgLessonsPerEvent)) + " 课节")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("提前时长 × 处理结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("受影响课节 " + _vm._s(_vm.fmtNum(_vm.d.lessonCount)))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.bucketRows,
      "unit": "",
      "label-width": 92,
      "right-width": 130
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bucket-axis",
    style: ({
      paddingLeft: '102px',
      paddingRight: '140px'
    })
  }, [_c('span', [_vm._v("◀ 3 小时外 · 系统安排代课")]), _vm._v(" "), _c('span', {
    staticClass: "is-danger"
  }, [_vm._v("3 小时线")]), _vm._v(" "), _c('span', [_vm._v("3 小时内 · 不安排代课 ▶")])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("提前时长 = 课节开始时间 − 老师最早一条请假申请时间。「无申请记录」= 状态为请假但查不到申请，只计入总量，不进 3 小时拆分。")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("周趋势看整体是否恶化；高频被请假学生按风险排序，新生优先置顶。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), (!_vm.weekly.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('svg', {
    staticClass: "svg-chart",
    attrs: {
      "viewBox": '0 0 ' + _vm.trend.W + ' ' + _vm.trend.H
    }
  }, [_vm._l((_vm.trend.grid), function(g) {
    return _c('g', {
      key: 'g' + g.y
    }, [_c('line', {
      staticClass: "gridline",
      attrs: {
        "x1": _vm.trend.PL,
        "y1": g.y,
        "x2": _vm.trend.W - _vm.trend.PR,
        "y2": g.y
      }
    }), _vm._v(" "), _c('text', {
      staticClass: "axis-l",
      attrs: {
        "x": _vm.trend.PL - 8,
        "y": g.y + 3,
        "text-anchor": "end"
      }
    }, [_vm._v(_vm._s(g.label))])])
  }), _vm._v(" "), _vm._l((_vm.trend.lessons), function(p) {
    return _c('text', {
      key: 'x' + p.label,
      staticClass: "axis-l",
      attrs: {
        "x": p.x,
        "y": _vm.trend.H - _vm.trend.PB + 16,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(p.label))])
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.area,
      "fill": "#E89F2D",
      "fill-opacity": "0.08"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.lessonPath,
      "fill": "none",
      "stroke": "#E89F2D",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.trend.lossPath,
      "fill": "none",
      "stroke": "#E6464E",
      "stroke-width": "2",
      "stroke-dasharray": "4 3"
    }
  }), _vm._v(" "), _vm._l((_vm.trend.lessons), function(p) {
    return _c('circle', {
      key: 'a' + p.label,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": "2.6",
        "fill": "#fff",
        "stroke": "#E89F2D",
        "stroke-width": "1.6"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  }), _vm._v(" "), _vm._l((_vm.trend.loss), function(p) {
    return _c('circle', {
      key: 'b' + p.label,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": "2.6",
        "fill": "#fff",
        "stroke": "#E6464E",
        "stroke-width": "1.6"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("高频被请假学生"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.studentSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_vm._l((_vm.students), function(row) {
    return _c('tr', {
      key: row.uid,
      class: {
        'is-priority': row.newPriority
      }
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("新生优先")]) : (row.isNew) ? _c('span', {
      staticClass: "badge is-warning"
    }, [_vm._v("新生")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(_vm._s(_vm.isNum(row.tenureDays) ? '开课第 ' + row.tenureDays + ' 天' : '—'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.fmtNum(row.leaveCount)))])]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.num(row.innerCount) > 0
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.innerCount)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lessonCount)))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, _vm._l(((row.dates || [])), function(dt, idx) {
      return _c('span', {
        key: idx,
        staticClass: "mini-badge",
        class: dt.inner ? 'is-inner' : 'is-outer'
      }, [_vm._v(_vm._s(_vm.shortDate(dt.date)))])
    }), 0), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.level)
    }, [_vm._v(_vm._s(row.level || '—'))])])])
  }), _vm._v(" "), (!_vm.students.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("当前窗口内无高频被请假学生")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.studentInsight) ? _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v(_vm._s(_vm.studentInsight))]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("3 小时线")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("核心对照")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("既然 3 小时内不做代课，"), _c('b', [_vm._v("唯一可控的杠杆是改约")]), _vm._v("：把自助改约入口和改约话术做进家长端，比建应急代课池更直接。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "chart-legend"
  }, [_c('span', [_c('i', {
    staticClass: "is-proxy"
  }), _vm._v("成功代课")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "is-loss"
  }), _vm._v("未代课")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("趋势与高频学生")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("周趋势"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("截至今天近 10 个 ISO 周")])]), _vm._v(" "), _c('span', {
    staticClass: "chart-legend"
  }, [_c('span', [_c('i', {
    staticClass: "is-lessons"
  }), _vm._v("受影响课节")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "is-loss"
  }), _vm._v("未代课")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("新生状态")]), _vm._v(" "), _c('th', [_vm._v("主老师")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("被请假次数")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("3h内")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("影响课节")]), _vm._v(" "), _c('th', [_vm._v("老师请假日期")]), _vm._v(" "), _c('th', [_vm._v("风险")])])])
}]}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "编辑买断时间",
      "width": 600,
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择买断时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 30],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 30],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "timeListForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "openedTimeList"
    }
  }, [_c('Row', [_vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "19"
      }
    }, [_c('label', [_c('b', [_vm._v("时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,    生效日期：" + _vm._s(item.useDateStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('div', [_c('Col', {
    attrs: {
      "offset": "1",
      "span": "19"
    }
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "small",
      "icon": "ios-trash-outline",
      "disabled": _vm.openedTimeList.length === 0
    },
    on: {
      "click": _vm.deleteAll
    }
  }, [_vm._v("全部删除")])], 1)], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": false
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "新增课后视频",
      "width": "600px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "videoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.videoRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", _vm._n($$v))
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传视频",
      "label-width": 100,
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "每课一曲",
      "label-width": 100,
      "prop": "musicUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChangeMusic,
      "on-success": _vm.handleSuccessMusic,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileMusicList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("通话转写词表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "错词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "错词或原词"
    },
    model: {
      value: (_vm.queryParam.srcWord),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "srcWord", $$v)
      },
      expression: "queryParam.srcWord"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.enabled),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "enabled", $$v)
      },
      expression: "queryParam.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/callAsrWord/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑词条' : '新增词条',
      "width": "520"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "错词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "识别错了的词，如哈斯理"
    },
    model: {
      value: (_vm.form.srcWord),
      callback: function($$v) {
        _vm.$set(_vm.form, "srcWord", $$v)
      },
      expression: "form.srcWord"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "正确词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "替换成的正确词，如HelloKid"
    },
    model: {
      value: (_vm.form.dstWord),
      callback: function($$v) {
        _vm.$set(_vm.form, "dstWord", $$v)
      },
      expression: "form.dstWord"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生请假列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminNickname"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminMobile"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假类型"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "leaveType", $$v)
      },
      expression: "queryParam.leaveType"
    }
  }, _vm._l((_vm.$constant.leaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假状态"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.userLeaveStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookUserLeaveTime/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "980",
      "title": "涉及请假课程"
    },
    model: {
      value: (_vm.showBookLessonOpenedModal),
      callback: function($$v) {
        _vm.showBookLessonOpenedModal = $$v
      },
      expression: "showBookLessonOpenedModal"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "980",
      "title": "修改请假时间"
    },
    model: {
      value: (_vm.showModifyLeaveTimeModal),
      callback: function($$v) {
        _vm.showModifyLeaveTimeModal = $$v
      },
      expression: "showModifyLeaveTimeModal"
    }
  }, [_c('Form', {
    ref: "modifyTimeForm",
    attrs: {
      "label-width": 60,
      "rules": _vm.modifyLeaveTimeRule
    },
    model: {
      value: (_vm.leaveTimeChangeParam),
      callback: function($$v) {
        _vm.leaveTimeChangeParam = $$v
      },
      expression: "leaveTimeChangeParam"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('Row', [_c('br')]), _vm._v(" "), _c('Row', [_vm._v(" 备注：若修改的时间不影响请假课程的可以直接修改，若影响到了课程的请联系技术人员修改！！！")]), _vm._v(" "), _c('Row', [_c('br')]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "请假结束时间修改:",
      "label-width": 120
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间",
      "disabled": ""
    },
    model: {
      value: (_vm.leaveTimeChangeParam.startLeaveTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.leaveTimeChangeParam, "startLeaveTimeDate", $$v)
      },
      expression: "leaveTimeChangeParam.startLeaveTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "修改结束日期"
    },
    on: {
      "on-change": _vm.newEndLeaveTimeChange
    },
    model: {
      value: (_vm.leaveTimeChangeParam.endLeaveTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.leaveTimeChangeParam, "endLeaveTimeDate", $$v)
      },
      expression: "leaveTimeChangeParam.endLeaveTimeDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showModifyLeaveTimeModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.onModifyLeaveEndTime
    }
  }, [_vm._v("确认修改")])], 1)], 1), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("拼团管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("拼团记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.groupStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 16,
      "md": 8
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/spellgroup/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课程消耗数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称",
      "label-width": 85
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adviserNickname"
    },
    model: {
      value: (_vm.queryParam.adviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserNickname", $$v)
      },
      expression: "queryParam.adviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 75,
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.checkStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "checkStatus", _vm._n($$v))
      },
      expression: "queryParam.checkStatus"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedCheckStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生是否投诉",
      "label-width": 85
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.userIsComplaint),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userIsComplaint", $$v)
      },
      expression: "queryParam.userIsComplaint"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师是否评价",
      "label-width": 85
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchIsFeedback),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchIsFeedback", $$v)
      },
      expression: "queryParam.tchIsFeedback"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "finished-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLesson/finished/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('ClassMemberTimeModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  }), _vm._v(" "), _c('MonitorLessonRecordListModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordListModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordListModal = $$v
      },
      expression: "showMonitorLessonRecordListModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试听课后反馈记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": 10
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈内容"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "试听课后课程反馈"
    },
    model: {
      value: (_vm.formData.otherReason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherReason", $$v)
      },
      expression: "formData.otherReason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.formData.nextTimeDate
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.$constant.handlerType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("发布渠道收录表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", $$v)
      },
      expression: "queryParam.period"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊"
    },
    model: {
      value: (_vm.queryParam.personName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "personName", $$v)
      },
      expression: "queryParam.personName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openChannelManage
    }
  }, [_vm._v("渠道管理")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableDataWithSum,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [50, 100, 200]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑' : '新增',
      "width": 520
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.formData.period),
      callback: function($$v) {
        _vm.$set(_vm.formData, "period", $$v)
      },
      expression: "formData.period"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.personName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "personName", $$v)
      },
      expression: "formData.personName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.enabledChannels), function(ch) {
    return _c('Form-item', {
      key: ch.channelKey,
      attrs: {
        "label": ch.displayName
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0
      },
      model: {
        value: (_vm.formData.channelValues[ch.channelKey]),
        callback: function($$v) {
          _vm.$set(_vm.formData.channelValues, ch.channelKey, $$v)
        },
        expression: "formData.channelValues[ch.channelKey]"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.enabledChannels.length) ? _c('div', {
    staticStyle: {
      "color": "#999",
      "padding-left": "100px"
    }
  }, [_vm._v("请先在渠道管理中添加渠道")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "渠道管理",
      "width": 720
    },
    on: {
      "on-visible-change": _vm.onChannelVisible
    },
    model: {
      value: (_vm.showChannelModal),
      callback: function($$v) {
        _vm.showChannelModal = $$v
      },
      expression: "showChannelModal"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddChannel
    }
  }, [_vm._v("新增渠道")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.channelColumns,
      "data": _vm.allChannels,
      "loading": _vm.channelLoading,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showChannelModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.channelForm.id ? '改名' : '新增渠道',
      "width": 480
    },
    model: {
      value: (_vm.showChannelEdit),
      callback: function($$v) {
        _vm.showChannelEdit = $$v
      },
      expression: "showChannelEdit"
    }
  }, [(_vm.channelForm.id) ? _c('Alert', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("改名只影响展示，不影响已填数据。")]) : _vm._e(), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "展示名",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "列表列头"
    },
    model: {
      value: (_vm.channelForm.displayName),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "displayName", $$v)
      },
      expression: "channelForm.displayName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标识"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.channelForm.id,
      "placeholder": _vm.channelForm.id ? '' : '留空则自动生成'
    },
    model: {
      value: (_vm.channelForm.channelKey),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "channelKey", $$v)
      },
      expression: "channelForm.channelKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "placeholder": "默认追加到末尾"
    },
    model: {
      value: (_vm.channelForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "sort", $$v)
      },
      expression: "channelForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showChannelEdit = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.channelSaving
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("签到记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "签到时间"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd HH:mm:ss",
      "clearable": false,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchSignTime/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "查看上课情况",
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.cancelAbsent
    }
  }, [_vm._v("取消学生旷课")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("出单节奏图")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": "12"
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "value-format": "yyyy-MM",
      "placeholder": "选择开始日期"
    },
    on: {
      "on-change": _vm.onStartDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部门",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.adviserGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserGroup", $$v)
      },
      expression: "queryParam.adviserGroup"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('Row', {
    staticClass: "form-search"
  }, [_c('i-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.month),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "month", $$v)
      },
      expression: "queryParam.month"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4,
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disabled": _vm.exportLoading,
      "icon": "ios-download"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("综合题库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题头 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "题头主键，精确匹配"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-VR-Q001"
    },
    model: {
      value: (_vm.queryParam.businessCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "businessCode", $$v)
      },
      expression: "queryParam.businessCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择技能"
    },
    on: {
      "on-change": _vm.loadQuestionTypes
    },
    model: {
      value: (_vm.queryParam.skill),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "skill", $$v)
      },
      expression: "queryParam.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.queryParam.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelCode", $$v)
      },
      expression: "queryParam.levelCode"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择题型"
    },
    model: {
      value: (_vm.queryParam.questionType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionType", $$v)
      },
      expression: "queryParam.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, _vm.queryParam.skill)))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING_REVIEW"
    }
  }, [_vm._v("待审核 PENDING_REVIEW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISCARDED"
    }
  }, [_vm._v("已废弃 DISCARDED")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场景"
    },
    model: {
      value: (_vm.queryParam.examScene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examScene", $$v)
      },
      expression: "queryParam.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量编辑")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Listening')
      }
    }
  }, [_vm._v("导入听力")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Reading')
      }
    }
  }, [_vm._v("导入阅读")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Writing')
      }
    }
  }, [_vm._v("导入写作")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.triggerIrt
    }
  }, [_vm._v("IRT 回填")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.inspectLoading
    },
    on: {
      "click": _vm.openBankInspect
    }
  }, [_vm._v("入门测题库自检")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importData
    }
  }), _vm._v(" "), _c('input', {
    ref: "irtInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importIrt
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/comp/questions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('MexQuestionBatchModal', {
    attrs: {
      "bank": "comp",
      "selected-rows": _vm.selection,
      "skill": _vm.queryParam.skill
    },
    on: {
      "success": _vm.search
    },
    model: {
      value: (_vm.batchVisible),
      callback: function($$v) {
        _vm.batchVisible = $$v
      },
      expression: "batchVisible"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "入门测题库自检",
      "width": "900",
      "mask-closable": false
    },
    model: {
      value: (_vm.inspectVisible),
      callback: function($$v) {
        _vm.inspectVisible = $$v
      },
      expression: "inspectVisible"
    }
  }, [(_vm.inspectReport) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("\n      规则 " + _vm._s(_vm.inspectReport.ruleVersion || '—') + " / 校准 " + _vm._s(_vm.inspectReport.calibrationVersion || '—') + "\n      · 问题 " + _vm._s(_vm.inspectReport.issueCount || 0) + " 条\n      · " + _vm._s(_vm.inspectReport.ok ? '通过' : '未通过') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspectRows.length) ? _c('Table', {
    attrs: {
      "columns": _vm.inspectColumns,
      "data": _vm.inspectRows,
      "size": "small",
      "max-height": "420"
    }
  }) : (_vm.inspectReport) ? _c('p', [_vm._v("未发现 BANK 问题")]) : _c('p', [_vm._v("加载中…")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.inspectVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.inspectLoading
    },
    on: {
      "click": _vm.openBankInspect
    }
  }, [_vm._v("重新自检")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑题目",
      "width": "960"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('p', [_vm._v("业务键 " + _vm._s(_vm.businessCode) + " / 版本 " + _vm._s(_vm.form.versionNo) + " / " + _vm._s(_vm.statusLabel(_vm.form.status))), (_vm.form.reviewer) ? _c('span', [_vm._v(" / 审核 " + _vm._s(_vm.form.reviewer))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.createMode) ? _c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-VR-Q001"
    },
    model: {
      value: (_vm.businessCode),
      callback: function($$v) {
        _vm.businessCode = $$v
      },
      expression: "businessCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.createMode && _vm.versions.length) ? _c('Form-item', {
    attrs: {
      "label": "历史版本"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.switchVersion
    },
    model: {
      value: (_vm.selectedVersionId),
      callback: function($$v) {
        _vm.selectedVersionId = $$v
      },
      expression: "selectedVersionId"
    }
  }, _vm._l((_vm.versions), function(v) {
    return _c('Option', {
      key: v.id,
      attrs: {
        "value": v.id
      }
    }, [_vm._v(_vm._s(v.versionNo) + " / " + _vm._s(_vm.statusLabel(v.status)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onFormSkillChange
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1.0"
    },
    model: {
      value: (_vm.form.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCode", $$v)
      },
      expression: "form.levelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "检索已有题型"
    },
    on: {
      "on-change": _vm.onEditQuestionTypeChange
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.editTypeOptions), function(t) {
    return _c('Option', {
      key: t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.examScene),
      callback: function($$v) {
        _vm.$set(_vm.form, "examScene", $$v)
      },
      expression: "form.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "锚题"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.isAnchor),
      callback: function($$v) {
        _vm.$set(_vm.form, "isAnchor", $$v)
      },
      expression: "form.isAnchor"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "交互类型"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 tap / speak / drag，可空"
    },
    model: {
      value: (_vm.form.interactionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "interactionType", $$v)
      },
      expression: "form.interactionType"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能英文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillEnChange
    },
    model: {
      value: (_vm.form.subSkillEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillEn", $$v)
      },
      expression: "form.subSkillEn"
    }
  }, _vm._l((_vm.subSkillEnOptions), function(t) {
    return _c('Option', {
      key: 'en-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能中文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillCnChange
    },
    model: {
      value: (_vm.form.subSkillCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillCn", $$v)
      },
      expression: "form.subSkillCn"
    }
  }, _vm._l((_vm.subSkillCnOptions), function(t) {
    return _c('Option', {
      key: 'cn-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "次要技能JSON"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "雷达次要技能，可空。如 [\"vocab\",\"grammar\"]"
    },
    model: {
      value: (_vm.form.secondarySkillsJson),
      callback: function($$v) {
        _vm.$set(_vm.form, "secondarySkillsJson", $$v)
      },
      expression: "form.secondarySkillsJson"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干脚本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "听力朗读脚本，听力题必填"
    },
    model: {
      value: (_vm.form.script),
      callback: function($$v) {
        _vm.$set(_vm.form, "script", $$v)
      },
      expression: "form.script"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "题目正文"
    },
    model: {
      value: (_vm.form.stem),
      callback: function($$v) {
        _vm.$set(_vm.form, "stem", $$v)
      },
      expression: "form.stem"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "音频地址，可空"
    },
    model: {
      value: (_vm.form.stemAudio),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemAudio", $$v)
      },
      expression: "form.stemAudio"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemAudio,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemAudio = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "图片地址，可空"
    },
    model: {
      value: (_vm.form.stemImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemImage", $$v)
      },
      expression: "form.stemImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "选项"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("选择题填代号、文字和图片；拖字母/句子排序填可拖的字母或词块；完形、Gap Fill、判断、填空、四格写作选「无选项」。词形选词填空把词库写在选项文字里，不要填图片。")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-bottom": "8px"
    },
    model: {
      value: (_vm.optionMode),
      callback: function($$v) {
        _vm.optionMode = $$v
      },
      expression: "optionMode"
    }
  }, [_c('Option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("无选项")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CHOICE"
    }
  }, [_vm._v("选择题")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DRAG"
    }
  }, [_vm._v("拖拽字母/词块")])], 1), _vm._v(" "), (_vm.optionMode === 'CHOICE') ? _c('div', [_vm._l((_vm.choiceOptions), function(opt, idx) {
    return _c('div', {
      key: 'opt-' + idx,
      staticClass: "mex-dim-card",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "mex-opt-head"
    }, [_c('span', [_vm._v("选项 " + _vm._s(opt.code || (idx + 1)))]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeChoice(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "代号"
      }
    }, [_c('Select', {
      model: {
        value: (opt.code),
        callback: function($$v) {
          _vm.$set(opt, "code", $$v)
        },
        expression: "opt.code"
      }
    }, _vm._l((_vm.optionCodes), function(c) {
      return _c('Option', {
        key: c,
        attrs: {
          "value": c
        }
      }, [_vm._v(_vm._s(c))])
    }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "文字"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "选项文案；纯图题可空"
      },
      model: {
        value: (opt.text),
        callback: function($$v) {
          _vm.$set(opt, "text", $$v)
        },
        expression: "opt.text"
      }
    })], 1)], 1), _vm._v(" "), (!_vm.isWordFormType) ? _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "选项图片地址，可空"
      },
      model: {
        value: (opt.image),
        callback: function($$v) {
          _vm.$set(opt, "image", $$v)
        },
        expression: "opt.image"
      }
    }), _vm._v(" "), _c('MexAssetPreview', {
      attrs: {
        "path": opt.image,
        "skill": _vm.form.skill,
        "bank": "comp",
        "accept": "image/*"
      },
      on: {
        "input": function($event) {
          opt.image = $event
        }
      }
    })], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addChoice
    }
  }, [_vm._v("添加选项")])], 2) : _vm._e(), _vm._v(" "), (_vm.optionMode === 'DRAG') ? _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, _vm._l((_vm.dragTokens), function(tok, idx) {
    return _c('i-col', {
      key: 'tok-' + idx,
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": '第 ' + (idx + 1) + ' 块'
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "如 l 或 ball"
      },
      model: {
        value: (tok.value),
        callback: function($$v) {
          _vm.$set(tok, "value", $$v)
        },
        expression: "tok.value"
      }
    }, [_c('Button', {
      attrs: {
        "slot": "append"
      },
      on: {
        "click": function($event) {
          return _vm.removeDrag(idx)
        }
      },
      slot: "append"
    }, [_vm._v("删")])], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addDrag
    }
  }, [_vm._v("添加一块")])], 1) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "填空"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("完形、Gap Fill、听读同篇多问：每一问是选项。听力 Fill in the Blanks：同一段音频多空，每空填短语。写作词形：短文留空，上面选项是词库，下面每空填变化后的词形。")]), _vm._v(" "), _vm._l((_vm.blanks), function(blank, idx) {
    return _c('div', {
      key: 'blank-' + idx,
      staticClass: "mex-dim-card",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "mex-opt-head"
    }, [_c('span', [_vm._v("第 " + _vm._s(blank.no || (idx + 1)) + " 空")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeBlank(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "空号"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 1,
        "max": 50,
        "placeholder": "空号，如 1"
      },
      model: {
        value: (blank.no),
        callback: function($$v) {
          _vm.$set(blank, "no", $$v)
        },
        expression: "blank.no"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "提示"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "题干里这一空的提示，可空"
      },
      model: {
        value: (blank.prompt),
        callback: function($$v) {
          _vm.$set(blank, "prompt", $$v)
        },
        expression: "blank.prompt"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "答案"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": _vm.isFillBlanksType ? '这一空的短语答案，如 Rock climbing and kayaking' : '这一空的标准答案，如 hiking'
      },
      model: {
        value: (blank.answer),
        callback: function($$v) {
          _vm.$set(blank, "answer", $$v)
        },
        expression: "blank.answer"
      }
    })], 1)], 1)], 1), _vm._v(" "), (_vm.isBlankChoiceType) ? _c('Form-item', {
      attrs: {
        "label": "本空选项"
      }
    }, _vm._l(((blank.options || [])), function(opt, oi) {
      return _c('div', {
        key: 'bopt-' + idx + '-' + oi,
        staticStyle: {
          "margin-bottom": "6px"
        }
      }, [_c('Row', {
        attrs: {
          "gutter": 8
        }
      }, [_c('i-col', {
        attrs: {
          "span": 6
        }
      }, [_c('Input', {
        attrs: {
          "placeholder": "代号 A"
        },
        model: {
          value: (opt.code),
          callback: function($$v) {
            _vm.$set(opt, "code", $$v)
          },
          expression: "opt.code"
        }
      })], 1), _vm._v(" "), _c('i-col', {
        attrs: {
          "span": 18
        }
      }, [_c('Input', {
        attrs: {
          "placeholder": "选项文字"
        },
        model: {
          value: (opt.text),
          callback: function($$v) {
            _vm.$set(opt, "text", $$v)
          },
          expression: "opt.text"
        }
      })], 1)], 1)], 1)
    }), 0) : _vm._e(), _vm._v(" "), (_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? _c('Form-item', {
      attrs: {
        "label": "本空解析"
      }
    }, [_c('Input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": _vm.isFillBlanksType ? '这一空的短语解析，可空' : '这一问为什么选这个答案'
      },
      model: {
        value: (blank.explanation),
        callback: function($$v) {
          _vm.$set(blank, "explanation", $$v)
        },
        expression: "blank.explanation"
      }
    })], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addBlank
    }
  }, [_vm._v("添加一空")])], 2), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标准答案"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.answerHint))]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": _vm.answerPlaceholder
    },
    model: {
      value: (_vm.form.answerKey),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerKey", $$v)
      },
      expression: "form.answerKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "完整参考作答"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "完整示范答案，可空"
    },
    model: {
      value: (_vm.form.referenceAnswerFull),
      callback: function($$v) {
        _vm.$set(_vm.form, "referenceAnswerFull", $$v)
      },
      expression: "form.referenceAnswerFull"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "满分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听1-3，读1-5，写客观1-2、主观5-10"
    },
    model: {
      value: (_vm.form.fullScore),
      callback: function($$v) {
        _vm.$set(_vm.form, "fullScore", $$v)
      },
      expression: "form.fullScore"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "1-5 星"
    },
    model: {
      value: (_vm.form.difficultyLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "difficultyLevel", $$v)
      },
      expression: "form.difficultyLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题权重"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "现稿多为 0.5"
    },
    model: {
      value: (_vm.form.adaptiveWeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "adaptiveWeight", $$v)
      },
      expression: "form.adaptiveWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "听力播放次数"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听力默认 2，其他可空"
    },
    model: {
      value: (_vm.form.audioPlayLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "audioPlayLimit", $$v)
      },
      expression: "form.audioPlayLimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分维度"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("听读客观题填正确性。看图写句、四格故事、邮件/回信用内容、逻辑、语法、词汇。建议合计 100。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.dimensions), function(d) {
    return _c('i-col', {
      key: d.key,
      attrs: {
        "span": _vm.dimensions.length > 1 ? 6 : 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.dimLabel(d.key)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 100"
      },
      model: {
        value: (d.weight),
        callback: function($$v) {
          _vm.$set(d, "weight", $$v)
        },
        expression: "d.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.dimSum))])], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分细则"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "人工/规则评分细则，可空"
    },
    model: {
      value: (_vm.form.scoringRubric),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringRubric", $$v)
      },
      expression: "form.scoringRubric"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "AI基准"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "AI 评分基准；客观题可空，写作主观建议填"
    },
    model: {
      value: (_vm.form.aiBenchmark),
      callback: function($$v) {
        _vm.$set(_vm.form, "aiBenchmark", $$v)
      },
      expression: "form.aiBenchmark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "解析"
    }
  }, [(_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("各空解析写在上面每一空里。这里保存时会按空号拼成备份文案。")]) : _vm._e(), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": (_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? '可由每空解析自动拼接' : '解析文案，可空'
    },
    model: {
      value: (_vm.form.explanation),
      callback: function($$v) {
        _vm.$set(_vm.form, "explanation", $$v)
      },
      expression: "form.explanation"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "考点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "考查点，可空"
    },
    model: {
      value: (_vm.form.examPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "examPoint", $$v)
      },
      expression: "form.examPoint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "内部备注，可空"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "常见错误"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "常见错误说明，可空"
    },
    model: {
      value: (_vm.form.commonMistakes),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMistakes", $$v)
      },
      expression: "form.commonMistakes"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "知识点"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识点路径，可空"
    },
    model: {
      value: (_vm.form.knowledgePointHierarchy),
      callback: function($$v) {
        _vm.$set(_vm.form, "knowledgePointHierarchy", $$v)
      },
      expression: "form.knowledgePointHierarchy"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "同篇阅读共用，如 P-L3-001"
    },
    model: {
      value: (_vm.form.passageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageId", $$v)
      },
      expression: "form.passageId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "填空组ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "同组填空共用，可空"
    },
    model: {
      value: (_vm.form.groupId),
      callback: function($$v) {
        _vm.$set(_vm.form, "groupId", $$v)
      },
      expression: "form.groupId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "篇章图片地址，可空"
    },
    model: {
      value: (_vm.form.passageImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageImage", $$v)
      },
      expression: "form.passageImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.passageImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.passageImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "篇章正文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "阅读篇章正文，可空"
    },
    model: {
      value: (_vm.form.passageText),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageText", $$v)
      },
      expression: "form.passageText"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "字数要求"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 3-4句话，20-40词；客观拼写可填「无」"
    },
    model: {
      value: (_vm.form.wordCountRequirement),
      callback: function($$v) {
        _vm.$set(_vm.form, "wordCountRequirement", $$v)
      },
      expression: "form.wordCountRequirement"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写作得分要点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "写作主观得分要点，可空"
    },
    model: {
      value: (_vm.form.scoringPoints),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringPoints", $$v)
      },
      expression: "form.scoringPoints"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写作参考范文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "写作参考范文，可空"
    },
    model: {
      value: (_vm.form.scoringReference),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringReference", $$v)
      },
      expression: "form.scoringReference"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "配图提示词"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "配图生成提示词，可空"
    },
    model: {
      value: (_vm.form.imageGenerationPrompt),
      callback: function($$v) {
        _vm.$set(_vm.form, "imageGenerationPrompt", $$v)
      },
      expression: "form.imageGenerationPrompt"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手写范文图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手写范文图地址，可空"
    },
    model: {
      value: (_vm.form.answerSampleImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerSampleImage", $$v)
      },
      expression: "form.answerSampleImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.answerSampleImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.answerSampleImage = $event
      }
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 LIS-01 / REA-01 / WRI-01"
    },
    model: {
      value: (_vm.form.abilityDimensionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDimensionCode", $$v)
      },
      expression: "form.abilityDimensionCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力档"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "内部能力档，可空"
    },
    model: {
      value: (_vm.form.scoreMappingLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreMappingLevel", $$v)
      },
      expression: "form.scoreMappingLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程单元"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "对应课程单元，可空"
    },
    model: {
      value: (_vm.form.courseUnitMapping),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseUnitMapping", $$v)
      },
      expression: "form.courseUnitMapping"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "能力描述"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告用的能力描述，可空"
    },
    model: {
      value: (_vm.form.abilityDescription),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDescription", $$v)
      },
      expression: "form.abilityDescription"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全国均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 72.5，可空"
    },
    model: {
      value: (_vm.form.benchmarkNationalAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkNationalAvg", $$v)
      },
      expression: "form.benchmarkNationalAvg"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同城优秀均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 85，可空"
    },
    model: {
      value: (_vm.form.benchmarkCityExcellentAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkCityExcellentAvg", $$v)
      },
      expression: "form.benchmarkCityExcellentAvg"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提升建议"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告提升建议，可空"
    },
    model: {
      value: (_vm.form.improvementSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.form, "improvementSuggestion", $$v)
      },
      expression: "form.improvementSuggestion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "练习推荐"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "推荐练习，可空"
    },
    model: {
      value: (_vm.form.recommendedPractice),
      callback: function($$v) {
        _vm.$set(_vm.form, "recommendedPractice", $$v)
      },
      expression: "form.recommendedPractice"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "前置知识"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "前置知识，可空"
    },
    model: {
      value: (_vm.form.prerequisiteKnowledge),
      callback: function($$v) {
        _vm.$set(_vm.form, "prerequisiteKnowledge", $$v)
      },
      expression: "form.prerequisiteKnowledge"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "掌握周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 1-2周，可空"
    },
    model: {
      value: (_vm.form.learningCycle),
      callback: function($$v) {
        _vm.$set(_vm.form, "learningCycle", $$v)
      },
      expression: "form.learningCycle"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT b"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "难度 b，可空"
    },
    model: {
      value: (_vm.form.irtB),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtB", $$v)
      },
      expression: "form.irtB"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT a"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "区分度 a，可空"
    },
    model: {
      value: (_vm.form.irtA),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtA", $$v)
      },
      expression: "form.irtA"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT c"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "猜测 c，可空"
    },
    model: {
      value: (_vm.form.irtC),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtC", $$v)
      },
      expression: "form.irtC"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "失误率"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "儿童失误率，可空"
    },
    model: {
      value: (_vm.form.childSlip),
      callback: function($$v) {
        _vm.$set(_vm.form, "childSlip", $$v)
      },
      expression: "form.childSlip"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学导申请请假记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookCourseChange/listByAdviserId",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("活动列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "活动名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.queryParams.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "name", $$v)
      },
      expression: "queryParams.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "活动分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "activityType", $$v)
      },
      expression: "queryParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "justify": "end",
      "type": "flex"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toShowAddActivityModal
    }
  }, [_vm._v("新建活动")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/activity/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('CreateActivityModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddActivityModal),
      callback: function($$v) {
        _vm.showAddActivityModal = $$v
      },
      expression: "showAddActivityModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑活动"
    },
    model: {
      value: (_vm.showUpdateActivityModal),
      callback: function($$v) {
        _vm.showUpdateActivityModal = $$v
      },
      expression: "showUpdateActivityModal"
    }
  }, [_c('Form', {
    ref: "updateActivityForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.activityRules,
      "model": _vm.updateActivityParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updateActivityParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "name", $$v)
      },
      expression: "updateActivityParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动分类：",
      "prop": "activityType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateActivityParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "activityType", $$v)
      },
      expression: "updateActivityParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动时间：",
      "prop": "activityTime"
    }
  }, [_c('DatePicker', {
    attrs: {
      "value": _vm.defaultTime,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动标识：",
      "prop": "tag"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动标识"
    },
    model: {
      value: (_vm.updateActivityParams.tag),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "tag", $$v)
      },
      expression: "updateActivityParams.tag"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateActivityParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "status", $$v)
      },
      expression: "updateActivityParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动说明："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入活动描述"
    },
    model: {
      value: (_vm.updateActivityParams.description),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "description", $$v)
      },
      expression: "updateActivityParams.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateActivityModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.updateActivity
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "积分兑换"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.param,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "赠课类型",
      "prop": "givingType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.param.giveType),
      callback: function($$v) {
        _vm.$set(_vm.param, "giveType", _vm._n($$v))
      },
      expression: "param.giveType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("课时赠送")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("物品赠送")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "积分扣除",
      "prop": "activity"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.activity),
      callback: function($$v) {
        _vm.$set(_vm.param, "activity", _vm._n($$v))
      },
      expression: "param.activity"
    }
  })], 1)], 1), _vm._v(" "), (_vm.param.giveType === 1) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠课次数",
      "prop": "lessonNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.param, "lessonNum", _vm._n($$v))
      },
      expression: "param.lessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.param.giveType === 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物品备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.param.remark),
      callback: function($$v) {
        _vm.$set(_vm.param, "remark", $$v)
      },
      expression: "param.remark"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑订单"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "contractName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.contractName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractName", $$v)
      },
      expression: "formData.contractName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "监护人",
      "prop": "guardian"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.guardian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "guardian", $$v)
      },
      expression: "formData.guardian"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("绑定老师记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "operator"
    },
    model: {
      value: (_vm.queryParam.operator),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "operator", $$v)
      },
      expression: "queryParam.operator"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/Name",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号",
      "name": "userName"
    },
    model: {
      value: (_vm.queryParam.userName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userName", $$v)
      },
      expression: "queryParam.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.operation),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "operation", $$v)
      },
      expression: "queryParam.operation"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("绑定")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("解绑")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "删除原因"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.delReason),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "delReason", $$v)
      },
      expression: "queryParam.delReason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("离职老师")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("关时间老师")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("淘汰老师")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("其它")]), _vm._v(" "), _c('Option', {
    key: "5",
    attrs: {
      "value": "5"
    }
  }, [_vm._v("老师请假")]), _vm._v(" "), _c('Option', {
    key: "6",
    attrs: {
      "value": "6"
    }
  }, [_vm._v("教学不好")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作说明"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "remark"
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "operation-log/list/user-bind-teacher",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": "",
      "stripe": false,
      "rowClassName": _vm.rowClass
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售话术库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.scene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scene", $$v)
      },
      expression: "queryParam.scene"
    }
  }, _vm._l((_vm.sceneOptions), function(opt) {
    return _c('Option', {
      key: opt.value,
      attrs: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("候选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已发布")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "话术"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "关键字"
    },
    model: {
      value: (_vm.queryParam.phrase),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "phrase", $$v)
      },
      expression: "queryParam.phrase"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/callScript/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑话术' : '新增话术',
      "width": "560"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.scene),
      callback: function($$v) {
        _vm.$set(_vm.form, "scene", $$v)
      },
      expression: "form.scene"
    }
  }, _vm._l((_vm.sceneOptions), function(opt) {
    return _c('Option', {
      key: opt.value,
      attrs: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "话术"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "给销售复用的标准句"
    },
    model: {
      value: (_vm.form.phrase),
      callback: function($$v) {
        _vm.$set(_vm.form, "phrase", $$v)
      },
      expression: "form.phrase"
    }
  })], 1), _vm._v(" "), (_vm.form.id) ? _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("候选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已发布")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("停用")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课前预习")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", $$v)
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", $$v)
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程标题"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLessonChange
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "预习题标题"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊查询"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNativePreview
    }
  }, [_vm._v("新增本地课前预习")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/lessonPreview/listByPage",
      "params": _vm.queryParam
    }
  }), _vm._v(" "), _c('LessonPreviewInsertModal', {
    attrs: {
      "successCallback": _vm.search,
      "value": _vm.insertPreviewModal
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('LessonPreviewUpdateModal', {
    attrs: {
      "successCallback": _vm.search,
      "previewId": _vm.previewId,
      "value": _vm.updatePreviewModal
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('NativeLessonPreviewInsertModal', {
    attrs: {
      "value": _vm.nativeInsertModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('NativeLessonPreviewUpdateModal', {
    attrs: {
      "previewId": _vm.previewId,
      "value": _vm.nativeUpdateModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("班主任课耗绩效")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-position": "left",
      "label-width": 50
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM",
      "value-format": "yyyy-MM",
      "placeholder": "起始"
    },
    model: {
      value: (_vm.queryParam.queryStartTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "queryStartTime", $$v)
      },
      expression: "queryParam.queryStartTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM",
      "value-format": "yyyy-MM",
      "placeholder": "结束"
    },
    model: {
      value: (_vm.queryParam.queryEndTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "queryEndTime", $$v)
      },
      expression: "queryParam.queryEndTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.table,
      "listUrl": "/userStudyAdviserLog/class-consumption-statistics",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("正式老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("陪练")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否允许绑定："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isCanBound", _vm._n($$v))
      },
      expression: "queryParam.isCanBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试听权限："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isAudition", _vm._n($$v))
      },
      expression: "queryParam.isAudition"
    }
  }, [_c('Option', {
    attrs: {
      "value": "y"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "n"
    }
  }, [_vm._v("无")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "临时约课权限："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tempSchedule),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tempSchedule", _vm._n($$v))
      },
      expression: "queryParam.tempSchedule"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("无")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "接受2h内订课："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.acceptSubWithin2h),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "acceptSubWithin2h", _vm._n($$v))
      },
      expression: "queryParam.acceptSubWithin2h"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否有TESOL"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hasTesol),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasTesol", _vm._n($$v))
      },
      expression: "queryParam.hasTesol"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("无")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否有TEFL"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hasTefl),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasTefl", _vm._n($$v))
      },
      expression: "queryParam.hasTefl"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("无")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开课时间:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), (this.tchTagPermission) ? _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标签："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchTags),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchTags", $$v)
      },
      expression: "queryParam.tchTags"
    }
  }, _vm._l((_vm.$constant.tchTags), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.suitableLevels),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "suitableLevels", $$v)
      },
      expression: "queryParam.suitableLevels"
    }
  }, _vm._l((_vm.suitableLevelOptions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教评分",
      "label-width": 70
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "placeholder": "最低",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.scoreMin),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scoreMin", $$v)
      },
      expression: "queryParam.scoreMin"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 4px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "placeholder": "最高",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.scoreMax),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scoreMax", $$v)
      },
      expression: "queryParam.scoreMax"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadLeaveTemplate
    }
  }, [_vm._v("下载请假模板")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadLeaveTemplate
    }
  }, [_vm._v("上传请假文件")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.visibleColumns,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/formal/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditShortTermOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditShortTermOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditShortTermOpenedTimeModal = $$v
      },
      expression: "showTchEditShortTermOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditCloseTimeModal', {
    attrs: {
      "tchId": _vm.tchId
    },
    model: {
      value: (_vm.showTchEditCloseTimeModal),
      callback: function($$v) {
        _vm.showTchEditCloseTimeModal = $$v
      },
      expression: "showTchEditCloseTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('ExportLeaveModal', {
    model: {
      value: (_vm.showExportLeaveModal),
      callback: function($$v) {
        _vm.showExportLeaveModal = $$v
      },
      expression: "showExportLeaveModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('ResignModal', {
    attrs: {
      "tchId": _vm.tchId,
      "title": _vm.resignTitle,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "on-close": _vm.closeTchResignModal,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchResignModal),
      callback: function($$v) {
        _vm.showTchResignModal = $$v
      },
      expression: "showTchResignModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑标签"
    },
    model: {
      value: (_vm.showEditTagsModal),
      callback: function($$v) {
        _vm.showEditTagsModal = $$v
      },
      expression: "showEditTagsModal"
    }
  }, [_c('Form', {
    ref: "form1",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (this.tchTags),
      callback: function($$v) {
        _vm.$set(this, "tchTags", $$v)
      },
      expression: "this.tchTags"
    }
  }, _vm._l((_vm.$constant.tchTags), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditTagsModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.editTag
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "subject-type": "TEACHER",
      "snapshot-id": _vm.aiSnapshotId,
      "page-route": "/tch/tchFormalList",
      "default-task-type": "TCH_RISK_EXPLAIN"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('invalid-listen-cause-log-modal', {
    attrs: {
      "tchId": _vm.invalidListenCauseLogTchId
    },
    model: {
      value: (_vm.showInvalidListenCauseLog),
      callback: function($$v) {
        _vm.showInvalidListenCauseLog = $$v
      },
      expression: "showInvalidListenCauseLog"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "外教运营分配记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外教对接中心")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈时间"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startDateChange
    },
    model: {
      value: (_vm.queryParam.startDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startDate", $$v)
      },
      expression: "queryParam.startDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endDateChange
    },
    model: {
      value: (_vm.queryParam.endDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endDate", $$v)
      },
      expression: "queryParam.endDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "tchId"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师名称",
      "prop": "tchName"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "name": "content",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.content),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "content", $$v)
      },
      expression: "queryParam.content"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "md": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否完结"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.completed),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "completed", $$v)
      },
      expression: "queryParam.completed"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "md": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审批状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditStatus", $$v)
      },
      expression: "queryParam.auditStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待审批")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已通过")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("未通过")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈人",
      "prop": "creator"
    }
  }, [_c('Input', {
    attrs: {
      "name": "creator",
      "placeholder": "ID、名字"
    },
    model: {
      value: (_vm.queryParam.creator),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "creator", $$v)
      },
      expression: "queryParam.creator"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 10
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加反馈")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/stageReport/fm-message-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('LessonFeedbackDealModal', {
    attrs: {
      "feedBackParamData": _vm.feedBackParamData,
      "successCallback": _vm.search,
      "timeList": _vm.timeList
    },
    model: {
      value: (_vm.showLessonFeedbackDealModal),
      callback: function($$v) {
        _vm.showLessonFeedbackDealModal = $$v
      },
      expression: "showLessonFeedbackDealModal"
    }
  }), _vm._v(" "), _c('AddMatchCenterModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showAddMatchCenterModal),
      callback: function($$v) {
        _vm.showAddMatchCenterModal = $$v
      },
      expression: "showAddMatchCenterModal"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学员跟踪记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "lable-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nextHandlerId", _vm._n($$v))
      },
      expression: "queryParam.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.createName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "createName", $$v)
      },
      expression: "queryParam.createName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "记录属性"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.traceType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "traceType", $$v)
      },
      expression: "queryParam.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.addStartTimeDateChange
    },
    model: {
      value: (_vm.addsTimeDate),
      callback: function($$v) {
        _vm.addsTimeDate = $$v
      },
      expression: "addsTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.addEndTimeDateChange
    },
    model: {
      value: (_vm.addeTimeDate),
      callback: function($$v) {
        _vm.addeTimeDate = $$v
      },
      expression: "addeTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/user/userTrackEdit')
      }
    }
  }, [_vm._v("添加记录\n    ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userTrack/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection,
      "operator": ""
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/user/userTrackList",
      "default-task-type": "ADVISOR_AFTER_CLASS"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "跟踪记录内容",
      "width": "720",
      "mask-closable": false
    },
    model: {
      value: (_vm.contentVisible),
      callback: function($$v) {
        _vm.contentVisible = $$v
      },
      expression: "contentVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "size": "small"
    },
    on: {
      "on-change": _vm.switchContentView
    },
    model: {
      value: (_vm.contentViewMode),
      callback: function($$v) {
        _vm.contentViewMode = $$v
      },
      expression: "contentViewMode"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "markdown"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "raw",
      "disabled": !_vm.contentRawText
    }
  }, [_vm._v("原文")])], 1), _vm._v(" "), (!_vm.contentRawText) ? _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("无原始内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.contentViewMode === 'markdown') ? _c('div', {
    ref: "contentExportArea",
    staticClass: "track-md track-md-dialog",
    domProps: {
      "innerHTML": _vm._s(_vm.contentHtml)
    }
  }) : _c('pre', {
    ref: "contentExportArea",
    staticClass: "track-raw-dialog"
  }, [_vm._v(_vm._s(_vm.contentRawText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportImageLoading,
      "disabled": _vm.exportImageLoading || (_vm.contentViewMode === 'markdown' ? !_vm.contentHtml : !_vm.contentRawText)
    },
    on: {
      "click": _vm.exportContentPng
    }
  }, [_vm._v("导出 PNG")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contentVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师考勤明细")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "tchId",
      "placeholder": "ID/昵称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchKey", $$v)
      },
      expression: "queryParam.tchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "情况说明："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "tchId",
      "placeholder": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startDateSelected),
      callback: function($$v) {
        _vm.startDateSelected = $$v
      },
      expression: "startDateSelected"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endDateSelected),
      callback: function($$v) {
        _vm.endDateSelected = $$v
      },
      expression: "endDateSelected"
    }
  })], 1)], 1)], 1)], 1), _vm._v("\n        >\n      ")], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tch/lesson/attendance-list-detail",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('ModifyAttendanceScoreDetailModal', {
    attrs: {
      "successCallback": _vm.search,
      "complaintRow": this.complaintRow,
      "visible": _vm.showUpdateScoreModal
    },
    on: {
      "on-close": _vm.closeComplaintModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "固定排课",
      "width": "950"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    staticClass: "form scheduling"
  }, [_c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("学生信息")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 18
    }
  }, [_c('Row', [_c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("学生姓名：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 10
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("学生手机号：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.user.mobile))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineNum))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课已选次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineSelectNum))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课已上次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineEndNum))])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("历史课程")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("上课时间")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Checkbox-group', {
    model: {
      value: (_vm.scheduleIndexList),
      callback: function($$v) {
        _vm.scheduleIndexList = $$v
      },
      expression: "scheduleIndexList"
    }
  }, _vm._l((_vm.courseScheduleListData), function(item, index) {
    return _c('Row', {
      key: index,
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "gutter": 8
      }
    }, [_c('Col', {
      attrs: {
        "span": 9
      }
    }, [_c('Checkbox', {
      attrs: {
        "label": index,
        "disabled": ""
      }
    }, [_c('i')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$moment(item.day, 'X').format('YYYY-MM-DD')) + " " + _vm._s(_vm.$constant.weekZh[item.week]) + " " + _vm._s(_vm.$moment.unix(item.startTime).utc().format('HH:mm')) + " - " + _vm._s(_vm.$moment.unix(item.endTime).utc().format('HH:mm')))])], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 5
      }
    }, [(item.lsnSelStatus === 6 || item.lsnSelStatus === 13) ? _c('span', [_vm._v(_vm._s(item.lsnSelStatus === 13 ? '老师离职' : '老师请假'))]) : _c('Select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onBookMaterialLevelChange(item, index)
        }
      },
      model: {
        value: (item.levelId),
        callback: function($$v) {
          _vm.$set(item, "levelId", $$v)
        },
        expression: "item.levelId"
      }
    }, _vm._l((_vm.bookMaterialLevelList), function(levelItem) {
      return _c('Option', {
        key: levelItem.id,
        attrs: {
          "value": levelItem.id
        }
      }, [_vm._v(_vm._s(levelItem.title))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 6
      }
    }, [(item.lsnSelStatus === 6 || item.lsnSelStatus === 13) ? _c('span', [_vm._v("不占课件顺序")]) : _c('Select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "transfer": ""
      },
      model: {
        value: (item.lessonId),
        callback: function($$v) {
          _vm.$set(item, "lessonId", $$v)
        },
        expression: "item.lessonId"
      }
    }, _vm._l((_vm.bookMaterialLessonsList[index]), function(lessonItem) {
      return _c('Option', {
        key: lessonItem.id,
        attrs: {
          "value": lessonItem.id
        }
      }, [_vm._v(_vm._s(lessonItem.titleEn))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 4
      }
    }, [_c('Select', {
      model: {
        value: (item.schoolId),
        callback: function($$v) {
          _vm.$set(item, "schoolId", $$v)
        },
        expression: "item.schoolId"
      }
    }, _vm._l((_vm.$constant.schoolEnums), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("体验课上课要求")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈时间"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placement": "bottom-end"
    },
    on: {
      "on-change": _vm.dateRangeChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师 ID",
      "prop": "tchId"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId",
      "placeholder": "请输入老师 ID"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师名称",
      "prop": "tchName"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "name": "content",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.content),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "content", $$v)
      },
      expression: "queryParam.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否完结"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.completed),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "completed", $$v)
      },
      expression: "queryParam.completed"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈人",
      "prop": "creator"
    }
  }, [_c('Input', {
    attrs: {
      "name": "creator",
      "placeholder": "ID、名字"
    },
    model: {
      value: (_vm.queryParam.creator),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "creator", $$v)
      },
      expression: "queryParam.creator"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/stageReport/fm-message-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('LessonFeedbackDealModal', {
    attrs: {
      "feedBackParamData": _vm.feedBackParamData,
      "successCallback": _vm.search,
      "timeList": _vm.timeList
    },
    model: {
      value: (_vm.showLessonFeedbackDealModal),
      callback: function($$v) {
        _vm.showLessonFeedbackDealModal = $$v
      },
      expression: "showLessonFeedbackDealModal"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('AddClassRequirementModal', {
    attrs: {
      "uid": _vm.currentUid,
      "studentName": _vm.currentStudentName,
      "tchId": _vm.currentTchId,
      "tchName": _vm.currentTchName,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showAddClassRequirementModal),
      callback: function($$v) {
        _vm.showAddClassRequirementModal = $$v
      },
      expression: "showAddClassRequirementModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("打卡闯关记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.recordType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recordType", _vm._n($$v))
      },
      expression: "queryParam.recordType"
    }
  }, _vm._l((_vm.$constant.reviewClockRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.reviewClockRecordStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "批改时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryParam.startUpdateTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startUpdateTime", $$v)
      },
      expression: "queryParam.startUpdateTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryParam.endUpdateTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endUpdateTime", $$v)
      },
      expression: "queryParam.endUpdateTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "打卡时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryParam.startTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTime", $$v)
      },
      expression: "queryParam.startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryParam.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTime", $$v)
      },
      expression: "queryParam.endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.batchCheck
    }
  }, [_vm._v("批量批改\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/study_record/pageList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "重置密码"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.recordRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "新密码",
      "prop": "recordingContent"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("出勤风险跟进")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', [_c('Button', {
    attrs: {
      "type": _vm.dateMode === 'yesterday' ? 'primary' : 'ghost'
    },
    on: {
      "click": function($event) {
        return _vm.changeDateMode('yesterday')
      }
    }
  }, [_vm._v("\n        昨日（" + _vm._s(_vm.yesterdayStr.slice(5)) + "）\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.dateMode === 'today' ? 'primary' : 'ghost'
    },
    on: {
      "click": function($event) {
        return _vm.changeDateMode('today')
      }
    }
  }, [_vm._v("今日")])], 1), _vm._v(" "), _c('Date-picker', {
    staticClass: "date-picker",
    class: {
      'is-active': _vm.dateMode === 'custom'
    },
    attrs: {
      "type": "date",
      "value": _vm.customDate,
      "placeholder": "自选日期",
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onCustomDate
    }
  }), _vm._v(" "), _c('Button-group', _vm._l((_vm.statusTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.status === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('Button-group', _vm._l((_vm.typeTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.typeKey === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeType(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('Input', {
    staticClass: "keyword",
    attrs: {
      "placeholder": "搜索老师姓名 / ID",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.search,
      "on-clear": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-spacer"
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.openManual
    }
  }, [_vm._v("手动登记")]), _vm._v(" "), (_vm.pendingList.length) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量跟进当前 " + _vm._s(_vm.pendingList.length) + " 节")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-bar"
  }, [_c('span', {
    staticClass: "stat-date"
  }, [_vm._v(_vm._s(_vm.queryDate))]), _vm._v(" "), _vm._l((_vm.typeDict), function(item, code) {
    return _c('Tag', {
      key: code,
      attrs: {
        "color": item.color
      }
    }, [_vm._v(_vm._s(item.text) + " " + _vm._s(_vm.typeCounts[code] || 0))])
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("当前 " + _vm._s(_vm.groups.length) + " 位老师 · " + _vm._s(_vm.pendingLessons) + " 节课待跟进")])], 2), _vm._v(" "), (_vm.searchLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.groups.length && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-card"
  }, [_c('div', {
    staticClass: "empty-big"
  }, [_vm._v("当日无需跟进的老师")]), _vm._v(" "), _c('div', {
    staticClass: "muted"
  }, [_vm._v("当天有请假单、旷课课节的老师会出现在这里，供外管逐人跟进")])]) : _c('div', {
    staticClass: "follow-list"
  }, _vm._l((_vm.groups), function(g) {
    return _c('div', {
      key: g.tchId,
      staticClass: "tch-card"
    }, [_c('div', {
      staticClass: "tch-card-head"
    }, [_c('span', {
      staticClass: "avatar",
      class: g.absentCount ? 'is-danger' : 'is-warning'
    }, [_vm._v(_vm._s(_vm.initials(g)))]), _vm._v(" "), _c('div', {
      staticClass: "tch-card-name"
    }, [_c('span', {
      staticClass: "tch-name-row"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(g.tchId)
        }
      }
    }, [_vm._v(_vm._s(_vm.tchLabel(g)))]), _vm._v(" "), (_vm.scoreText(g)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(g)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "muted"
    }, [_vm._v("ID " + _vm._s(g.tchId)), (g.country) ? _c('span', [_vm._v(" · " + _vm._s(g.country))]) : _vm._e(), _vm._v(" · " + _vm._s(g.studyAdviserName || '未分配'))])]), _vm._v(" "), _c('div', {
      staticClass: "tch-card-tags"
    }, [(g.absentCount) ? _c('Tag', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("旷课 " + _vm._s(g.absentCount) + " 节")]) : _vm._e(), _vm._v(" "), (g.leaveCount) ? _c('Tag', {
      attrs: {
        "color": "yellow"
      }
    }, [_vm._v("请假 " + _vm._s(g.leaveCount) + " 条")]) : _vm._e(), _vm._v(" "), (g.lateCount) ? _c('Tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("迟到 " + _vm._s(g.lateCount) + " 节")]) : _vm._e(), _vm._v(" "), (g.pendingCount) ? _c('Tag', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(g.pendingCount) + " 节待跟进")]) : _c('Tag', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("已全部跟进")])], 1), _vm._v(" "), (g.cleanDays != null) ? _c('span', {
      staticClass: "clean-days"
    }, [_vm._v("连续无异常 " + _vm._s(g.cleanDays) + " 天")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "toolbar-spacer"
    }), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v("共 " + _vm._s(g.total || (g.lessons || []).length) + " 节")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(g.tchId)
        }
      }
    }, [_vm._v("档案")])], 1), _vm._v(" "), _c('div', {
      staticClass: "tch-card-body"
    }, _vm._l((g.lessons), function(l) {
      return _c('div', {
        key: _vm.lessonRowKey(l),
        staticClass: "lesson-row"
      }, [_c('span', {
        staticClass: "lesson-bar",
        class: _vm.isAbsentType(l.type) ? 'is-danger' : 'is-warning'
      }), _vm._v(" "), _c('div', {
        staticClass: "lesson-main"
      }, [_c('div', {
        staticClass: "lesson-title"
      }, [(!l.manual) ? _c('b', [_vm._v(_vm._s(l.beginTime || '—'))]) : _vm._e(), _vm._v(" "), _c('Tag', {
        attrs: {
          "color": _vm.typeColor(l.type)
        }
      }, [_vm._v(_vm._s(_vm.typeText(l.type)))]), _vm._v(" "), (l.handled) ? _c('Tag', {
        attrs: {
          "color": "green"
        }
      }, [_vm._v("已跟进")]) : _c('Tag', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("待跟进")])], 1), _vm._v(" "), (l.manual) ? _c('div', {
        staticClass: "muted"
      }, [_vm._v("手动 · 无学生")]) : _c('div', {
        staticClass: "muted"
      }, [(l.type === 'LEAVE') ? [_vm._v("请假单 " + _vm._s(l.lessonId) + " · 原因：" + _vm._s(l.reason || '未填写'))] : [_vm._v("课节 " + _vm._s(l.lessonId) + " · 学员 " + _vm._s(l.studentName || l.uid || '—') + " · 原因：" + _vm._s(l.reason || '未填写'))]], 2), _vm._v(" "), (l.handled) ? _c('div', {
        staticClass: "lesson-handled"
      }, [_vm._v("\n            跟进结果：" + _vm._s(_vm.resultText(l.result))), (l.note) ? _c('span', [_vm._v(" · " + _vm._s(l.note))]) : _vm._e(), _vm._v("\n            · " + _vm._s(l.handledBy || '') + " " + _vm._s(l.handledAt || '') + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('Button', {
        attrs: {
          "size": "small",
          "type": l.handled ? 'ghost' : 'primary'
        },
        on: {
          "click": function($event) {
            return _vm.openSingle(g, l)
          }
        }
      }, [_vm._v("\n          " + _vm._s(l.handled ? '改判' : '跟进') + "\n        ")])], 1)
    }), 0)])
  }), 0), _vm._v(" "), _c('followup-handle-modal', {
    attrs: {
      "value": _vm.showHandle,
      "lessons": _vm.handleLessons
    },
    on: {
      "on-close": function($event) {
        _vm.showHandle = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('followup-manual-modal', {
    attrs: {
      "value": _vm.showManual,
      "default-date": _vm.queryDate
    },
    on: {
      "on-close": function($event) {
        _vm.showManual = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    跟进口径：当天有 "), _c('b', [_vm._v("请假单")]), _vm._v("（一条请假记录一条跟进，含无约课）或 "), _c('b', [_vm._v("旷课")]), _vm._v("（含旷课·失联）课节的老师进入本板块，由外管核实并登记跟进结果；迟到只在类型选「迟到 / 全部」时出现。\n  ")])
}]}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Table', {
    ref: "table",
    attrs: {
      "border": "",
      "height": _vm.height,
      "columns": _vm.innerColumns,
      "data": _vm.tableData,
      "stripe": _vm.stripe,
      "size": "large",
      "row-class-name": _vm.rowClassName
    },
    on: {
      "on-selection-change": _vm.selectionChange,
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.page.pageIndex,
      "pageSize": _vm.page.pageSize,
      "show-sizer": _vm.showSizer,
      "page-size-opts": _vm.pageSizeOpts,
      "placement": _vm.showSizer ? 'top' : 'bottom',
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex,
      "on-page-size-change": _vm.changePageSize
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("兑换记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false,
      "lable-positon": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "兑换类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "type", _vm._n($$v))
      },
      expression: "queryParam.type"
    }
  }, _vm._l((_vm.$constant.giveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "checkAdmin"
    },
    model: {
      value: (_vm.queryParam.auditorName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditorName", $$v)
      },
      expression: "queryParam.auditorName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activityExamine/recordList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("合同到期提醒")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    规则：合同到期前 "), _c('b', [_vm._v(_vm._s(_vm.rules.contractAlertDays))]), _vm._v(" 天触发续签提醒；到期日次日起进入"), _c('b', [_vm._v("超期")]), _vm._v("状态并按天累计，直至登记新合同。未登记合同的老师只在「全部」里显示。\n    "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/hrWorkbench/settings')
      }
    }
  }, [_vm._v("调整规则")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', {
    staticClass: "seg"
  }, _vm._l((_vm.levelTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.level === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeLevel(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + " " + _vm._s(_vm.counts[item.value] || 0) + "\n      ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-total"
  }, [_vm._v("共 " + _vm._s(_vm.dataList.length) + " 人")]), _vm._v(" "), _c('Button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": "",
      "row-class-name": _vm.rowClassName,
      "no-data-text": "当前筛选下无记录"
    }
  })], 1), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.showRenew,
      "row": _vm.currentRow
    },
    on: {
      "on-close": function($event) {
        _vm.showRenew = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "无需代课请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型",
      "prop": "leaveType"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.leaveParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "leaveType", $$v)
      },
      expression: "leaveParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchResignType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.onBookLessonOpened
    }
  }, [_vm._v("查看涉及课节")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "离职原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("操作后记得点击“保存”按钮")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "封禁注册学生"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "bannedUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.id + ' - ' + item.nickname + ' - ' + item.ip) + "\n          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBannedUser
    },
    on: {
      "click": _vm.bannedUser
    }
  }, [_vm._v("封禁")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师反馈列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookTchFeedback/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "绘本兑换"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "bookExchangeForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.param,
      "rules": _vm.bookExchangeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请输入兑换码",
      "prop": "activity"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.code),
      callback: function($$v) {
        _vm.$set(_vm.param, "code", _vm._n($$v))
      },
      expression: "param.code"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.exchange
    }
  }, [_vm._v("兑换")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("跟读记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生ID："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.studentId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studentId", $$v)
      },
      expression: "queryParam.studentId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "姓名："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.username),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "username", $$v)
      },
      expression: "queryParam.username"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "手机号："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "类型："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.evalType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "evalType", $$v)
      },
      expression: "queryParam.evalType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "WORD"
    }
  }, [_vm._v("单词")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SENTENCE"
    }
  }, [_vm._v("句子")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "文本："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.content),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "content", $$v)
      },
      expression: "queryParam.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/studentWordcardEval/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售通话记录AI")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "录音日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.defaultDate,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听记标题",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.fileName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fileName", $$v)
      },
      expression: "queryParam.fileName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定人"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/crm/dviAudio/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.detailTitle,
      "width": "960",
      "mask-closable": false,
      "class-name": "dvi-audio-detail-modal"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [(_vm.detailLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "color": "#808695"
    }
  }, [_vm._v("加载中…")])], 1) : (_vm.detail) ? _c('div', {
    staticClass: "dvi-detail"
  }, [_c('div', {
    staticClass: "dvi-detail-head"
  }, [_c('div', {
    staticClass: "dvi-detail-title",
    attrs: {
      "title": _vm.displayTitle(_vm.detail.fileName)
    }
  }, [_vm._v(_vm._s(_vm.displayTitle(_vm.detail.fileName)))]), _vm._v(" "), _c('div', {
    staticClass: "dvi-detail-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.detail.createTime || '—'))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDuration(_vm.detail.durationMs)))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.adminUserName || '—'))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), (_vm.detail.uid) ? _c('span', [_vm._v("学生 · " + _vm._s(_vm.studentLabel(_vm.detail))), (_vm.detail.studentMobile) ? [_vm._v(" · " + _vm._s(_vm.detail.studentMobile))] : _vm._e()], 2) : _c('span', [_vm._v("学生 · 未绑定 "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openBind(_vm.detail)
      }
    }
  }, [_vm._v("绑定学生")])]), _vm._v(" "), _c('Tag', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "color": _vm.detail.hasSummary ? 'green' : 'default'
    }
  }, [_vm._v("摘要" + _vm._s(_vm.detail.hasSummary ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasAsrClean ? 'green' : 'default'
    }
  }, [_vm._v("清洗" + _vm._s(_vm.detail.hasAsrClean ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasTranscript ? 'blue' : 'default'
    }
  }, [_vm._v("原文" + _vm._s(_vm.detail.hasTranscript ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasAudio ? 'blue' : 'default'
    }
  }, [_vm._v("音频" + _vm._s(_vm.detail.hasAudio ? '有' : '无'))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [(_vm.detail.storageUrl) ? _c('audio', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.detail.storageUrl,
      "controls": ""
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无音频（尚未转存到七牛）")])]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("摘要")]), _vm._v(" "), (_vm.detail.summaryContent) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.summaryHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无摘要")])]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-head"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("AI清洗")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "ghost": "",
      "loading": _vm.aiCleanLoading,
      "disabled": _vm.aiCleanLoading || !_vm.canAiClean
    },
    on: {
      "click": _vm.handleAiClean
    }
  }, [_vm._v(_vm._s(_vm.aiCleanBtnText))])], 1), _vm._v(" "), (_vm.detail.asrCleanContent) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.cleanHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无 AI 清洗内容")])]), _vm._v(" "), (_vm.hasTodos || _vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("待办")]), _vm._v(" "), (_vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-empty",
    staticStyle: {
      "color": "#ed4014"
    }
  }, [_vm._v(_vm._s(_vm.detail.todoError))]) : _vm._e(), _vm._v(" "), (_vm.hasTodos) ? _c('ul', {
    staticClass: "dvi-todo-list"
  }, _vm._l((_vm.detail.todos), function(t, idx) {
    return _c('li', {
      key: idx
    }, [_c('span', {
      staticClass: "todo-box"
    }, [_vm._v("☐")]), _vm._v(_vm._s(t))])
  }), 0) : (!_vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无待办")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-head"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("原始对话")]), _vm._v(" "), (_vm.chatBubbles.length) ? _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleRoleSwap
    }
  }, [_vm._v("转换角色")]) : _vm._e()], 1), _vm._v(" "), (_vm.chatBubbles.length) ? _c('div', {
    staticClass: "dvi-chat"
  }, _vm._l((_vm.chatBubbles), function(b, idx) {
    return _c('div', {
      key: idx,
      staticClass: "dvi-bubble-row",
      class: b.side
    }, [_c('div', {
      staticClass: "dvi-bubble"
    }, [_c('div', {
      staticClass: "dvi-bubble-meta"
    }, [_c('span', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(b.nick))]), _vm._v(" "), (b.timeLabel) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(b.timeLabel))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dvi-bubble-text"
    }, [_vm._v(_vm._s(b.text))])])])
  }), 0) : (_vm.fallbackTranscript) ? _c('pre', {
    staticClass: "dvi-raw"
  }, [_vm._v(_vm._s(_vm.fallbackTranscript))]) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无原始对话")])]), _vm._v(" "), _c('Collapse', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "simple": ""
    }
  }, [_c('Panel', {
    attrs: {
      "name": "meta"
    }
  }, [_vm._v("元信息\n          "), _c('div', {
    staticClass: "dvi-meta-extra",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_vm._v("ID：" + _vm._s(_vm.detail.id))]), _vm._v(" "), _c('div', [_vm._v("SN：" + _vm._s(_vm.detail.sn || '—'))]), _vm._v(" "), _c('div', [_vm._v("fileId：" + _vm._s(_vm.detail.fileId || '—'))]), _vm._v(" "), _c('div', [_vm._v("minutesId：" + _vm._s(_vm.detail.minutesId || '—'))])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "绑定学生",
      "width": "480",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.closeBind
    },
    model: {
      value: (_vm.bindVisible),
      callback: function($$v) {
        _vm.bindVisible = $$v
      },
      expression: "bindVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入6位学生ID",
      "clearable": "",
      "disabled": _vm.bindResolving
    },
    on: {
      "on-blur": _vm.resolveStudent,
      "on-enter": _vm.resolveStudent
    },
    model: {
      value: (_vm.bindForm.uidInput),
      callback: function($$v) {
        _vm.$set(_vm.bindForm, "uidInput", $$v)
      },
      expression: "bindForm.uidInput"
    }
  }), _vm._v(" "), (_vm.bindResolving) ? _c('Spin', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bindForm.studentName || '—'))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bindForm.studentMobile || '—'))])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeBind
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.bindForm.resolvedUid,
      "loading": _vm.bindSaving
    },
    on: {
      "click": _vm.saveBind
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.previewTitle,
      "width": "760",
      "mask-closable": false,
      "class-name": "dvi-audio-preview-modal"
    },
    on: {
      "on-cancel": _vm.closePreview
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "color": "#808695"
    }
  }, [_vm._v("加载中…")])], 1) : (_vm.previewDetail) ? _c('div', {
    staticClass: "dvi-preview-body"
  }, [(_vm.previewKind === 'summary') ? [(_vm.previewSummaryHtml) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSummaryHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无摘要")])] : (_vm.previewKind === 'clean') ? [(_vm.previewCleanHtml) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.previewCleanHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无 AI 清洗内容")])] : (_vm.previewKind === 'transcript') ? [_c('div', {
    staticClass: "dvi-section-head",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('div', {
    staticClass: "dvi-section-title",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("原始对话")]), _vm._v(" "), (_vm.previewChatBubbles.length) ? _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.togglePreviewRoleSwap
    }
  }, [_vm._v("转换角色")]) : _vm._e()], 1), _vm._v(" "), (_vm.previewChatBubbles.length) ? _c('div', {
    staticClass: "dvi-chat dvi-chat-preview"
  }, _vm._l((_vm.previewChatBubbles), function(b, idx) {
    return _c('div', {
      key: 'p' + idx,
      staticClass: "dvi-bubble-row",
      class: b.side
    }, [_c('div', {
      staticClass: "dvi-bubble"
    }, [_c('div', {
      staticClass: "dvi-bubble-meta"
    }, [_c('span', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(b.nick))]), _vm._v(" "), (b.timeLabel) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(b.timeLabel))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dvi-bubble-text"
    }, [_vm._v(_vm._s(b.text))])])])
  }), 0) : (_vm.previewFallbackTranscript) ? _c('pre', {
    staticClass: "dvi-raw"
  }, [_vm._v(_vm._s(_vm.previewFallbackTranscript))]) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无原始对话")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closePreview
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "手动分配",
      "width": "800"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 18
    }
  }, [_c('FormItem', [_c('label', [_c('h3', [_vm._v("您选择的名单共计" + _vm._s(_vm.formData.totalNum) + "个, 当前未分配客户数" + _vm._s(_vm.formData.remainder) + "个")])])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择课顾分组"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.formData.teamType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "teamType", $$v)
      },
      expression: "formData.teamType"
    }
  }, _vm._l((_vm.formData.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('ul', _vm._l((_vm.formData.adviserList), function(item) {
    return _c('li', [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": item.adviserName
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "名单数"
      },
      on: {
        "on-change": _vm.onCountChange
      },
      model: {
        value: (item.count),
        callback: function($$v) {
          _vm.$set(item, "count", $$v)
        },
        expression: "item.count"
      }
    })], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.confirmAssign
    }
  }, [_vm._v("确认分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacher-class-score"
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "sum-label"
  }, [_vm._v("综合评分")]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_c('span', [_vm._v(_vm._s(_vm.scoreMain))]), _c('small', [_vm._v(" / 5.00")])])]), _vm._v(" "), _c('div', {
    staticClass: "sum-right"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('span', {
    staticClass: "solid"
  }, [_vm._v(_vm._s(_vm.solidStars))]), _c('span', [_vm._v(_vm._s(_vm.hollowStars))])]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_vm._v(_vm._s(_vm.gradeText))])])])]), _vm._v(" "), _c('div', {
    staticClass: "rated-row"
  }, [_c('div', {
    staticClass: "rated",
    on: {
      "click": _vm.onRatedClick
    }
  }, [_vm._v("已评分 "), _c('strong', {
    staticClass: "rated-num"
  }, [_vm._v(_vm._s(_vm.ratedCountText))]), _vm._v(" 节")]), _vm._v(" "), _c('span', {
    staticClass: "rated-hint"
  }, [_vm._v("点击数字筛选明细")])]), _vm._v(" "), _c('div', {
    staticClass: "score-filter"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("上课日期")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.startDate,
      "clearable": false,
      "transfer": "",
      "placeholder": "开始日期"
    },
    on: {
      "on-change": _vm.onStartDateChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v("至")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.endDate,
      "clearable": false,
      "transfer": "",
      "placeholder": "结束日期"
    },
    on: {
      "on-change": _vm.onEndDateChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('span', {
    staticClass: "label extra"
  }, [_vm._v("学导")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.studyAdviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserNickname", $$v)
      },
      expression: "queryParam.studyAdviserNickname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('span', {
    staticClass: "label extra"
  }, [_vm._v("课程顾问")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserNickname", $$v)
      },
      expression: "queryParam.adviserNickname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('span', {
    staticClass: "label extra"
  }, [_vm._v("课程类型")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('span', {
    staticClass: "label extra"
  }, [_vm._v("课程状态")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.lsnSelStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnSelStatus", _vm._n($$v))
      },
      expression: "queryParam.lsnSelStatus"
    }
  }, _vm._l((_vm.$constant.lsnSelStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('span', {
    staticClass: "label extra"
  }, [_vm._v("是否评分")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.classFeedbackRated),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "classFeedbackRated", _vm._n($$v))
      },
      expression: "queryParam.classFeedbackRated"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已评分")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("未评分")])], 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.columns,
      "listUrl": "/bookLesson/opened/list",
      "params": _vm.queryParam,
      "reload": _vm.reload,
      "sync-route": false
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true
    },
    on: {
      "on-close": function($event) {
        _vm.showBookTchFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true
    },
    on: {
      "on-close": function($event) {
        _vm.showBookTchScoreFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": function($event) {
        _vm.showBookUserFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewDemoModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewDemoModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewRegularModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewRegularModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewFinishLevelModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewFinishLevelModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewDemoV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewDemoV2Modal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewRegularV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewRegularV2Modal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewFinishLevelV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewFinishLevelV2Modal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "课堂反馈",
      "width": "960",
      "footer-hide": true,
      "mask-closable": false
    },
    model: {
      value: (_vm.showClassFeedback),
      callback: function($$v) {
        _vm.showClassFeedback = $$v
      },
      expression: "showClassFeedback"
    }
  }, [(_vm.showClassFeedback) ? _c('class-feedback', {
    attrs: {
      "lesson-opened-id": _vm.classFeedbackOpenedId,
      "embedded": true
    },
    on: {
      "saved": _vm.onClassFeedbackSaved
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "modalSms"
  }, [_c('h2', [_vm._v(_vm._s(_vm.welcomeText))]), _vm._v(" "), _c('i-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入手机号",
      "disabled": "true"
    },
    model: {
      value: (_vm.loginForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "mobile", $$v)
      },
      expression: "loginForm.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "size": "large",
      "placeholder": "请输入验证码"
    },
    on: {
      "on-enter": _vm.submit
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  }), _vm._v(" "), _c('i-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('i-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "count",
    attrs: {
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.count) + " s")])], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('i', [_vm._v("二次身份验证")])]), _vm._v(" "), _c('Form-item', [_c('i-button', {
    attrs: {
      "type": "info",
      "long": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "综合风险视图",
      "tags": ['异动 + 请假合并打分', '谁最危险、先救谁'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.sourceOptions,
      "label": "来源"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 分档：极高 ≥55 / 高 40–54 / 中 25–39 / 低 <25，上限 100 分")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("对学生来说只有一件事：我的老师出问题了。两类影响合并到同一个学生身上，用统一口径打分排序。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.sourceRows,
      "unit": "人",
      "right-width": 130
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          异动本来就伤一次，请假又在同一个人身上反复叠加。两类叠加的学生必须走「换老师 + 时段保障 + 主动沟通」的组合处理，单做一项不够。\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.bandRows,
      "unit": "人",
      "right-width": 110
    }
  }), _vm._v(" "), (_vm.bandInsight) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v(_vm._s(_vm.bandInsight))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("综合风险榜")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v("近 " + _vm._s(_vm.days) + " 天 · 按风险分高 → 低 · 前 50 名，导出为全部")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("待处理名单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.sourceLabel))])]), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出待处理名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid
    }, [_c('td', {
      staticClass: "num t-muted"
    }, [_vm._v(_vm._s(row.rank))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "mini-badge is-new"
    }, [_vm._v("新生优先")]) : _vm._e(), _vm._v(" "), (_vm.num(row.changeCount) > 0) ? _c('span', {
      staticClass: "mini-badge is-change"
    }, [_vm._v("异动×" + _vm._s(row.changeCount))]) : _vm._e(), _vm._v(" "), (_vm.num(row.leaveCount) > 0) ? _c('span', {
      staticClass: "mini-badge is-leave"
    }, [_vm._v("请假×" + _vm._s(row.leaveCount))]) : _vm._e(), _vm._v(" "), (row.source === 'both') ? _c('span', {
      staticClass: "mini-badge is-both"
    }, [_vm._v("叠加")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.num(row.changeCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.num(row.leaveCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.num(row.innerCount) > 0
      }
    }, [_vm._v(_vm._s(_vm.num(row.innerCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 6
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('span', {
      staticClass: "score-cell"
    }, [_c('span', {
      staticClass: "score-track"
    }, [_c('div', {
      style: ({
        width: Math.min(100, _vm.num(row.score)) + '%',
        background: _vm.scoreColor(row.score)
      })
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.fmtNum(row.score, 0)))])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.band)
    }, [_vm._v(_vm._s(row.band || '—'))])]), _vm._v(" "), _c('td', {
      staticClass: "t-action"
    }, [_vm._v(_vm._s(row.action || '—'))])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("当前筛选下没有纳入评分的学生")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("风险构成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("风险来源构成"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("按学生 · 两类叠加最危险")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("风险等级分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("极高 ≥55 · 高 40–54 · 中 25–39 · 低 <25")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "num"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("原老师")]), _vm._v(" "), _c('th', [_vm._v("风险来源")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("异动")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("请假")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("3h内")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("风险分")]), _vm._v(" "), _c('th', [_vm._v("等级")]), _vm._v(" "), _c('th', [_vm._v("建议动作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("打分口径")])]), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("可调，但每一项都要有业务理由。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("风险分 = 异动 + 请假 + 叠加 + 敞口 + 损失")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("异动：淘汰 / 离职 / 关闭时间 "), _c('b', [_vm._v("统一每起 10 分")])]), _vm._v(" "), _c('li', [_vm._v("异动结果修正：还没换老师 "), _c('b', [_vm._v("+6")]), _vm._v("；换完但没保住原时段 "), _c('b', [_vm._v("+4")])]), _vm._v(" "), _c('li', [_vm._v("请假：每节 3 分；"), _c('b', [_vm._v("3 小时内（含旷课）每节再加 4 分")]), _vm._v("（无代课兜底）")]), _vm._v(" "), _c('li', [_vm._v("两类叠加："), _c('b', [_vm._v("+7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('ul', [_c('li', [_vm._v("课时敞口：剩余 ≥ 40 课时 +5；20–39 课时 +3")]), _vm._v(" "), _c('li', [_vm._v("损失课次：每课次 +1")]), _vm._v(" "), _c('li', [_vm._v("上限 100 分，四舍五入取整")]), _vm._v(" "), _c('li', [_vm._v("设计意图：异动权重高于请假，因为一次异动等于关系断裂；3 小时内的请假给到接近异动的单位权重，因为它同样没有兜底")])])])])])
}]}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("题目模板管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showAddTemplateList = true
      }
    }
  }, [_vm._v("添加模板")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "",
      "params": _vm.queryParams,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('CreateTemplateModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showAddTemplateList),
      callback: function($$v) {
        _vm.showAddTemplateList = $$v
      },
      expression: "showAddTemplateList"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑题目模板"
    },
    model: {
      value: (_vm.showUpdateTemplateList),
      callback: function($$v) {
        _vm.showUpdateTemplateList = $$v
      },
      expression: "showUpdateTemplateList"
    }
  }, [_c('Form', {
    ref: "updateTemplateForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.Rules,
      "model": _vm.updateTemplateParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updateTemplateParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "name", $$v)
      },
      expression: "updateTemplateParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "题目大类",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateTemplateParams.type),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "type", $$v)
      },
      expression: "updateTemplateParams.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "video"
    }
  }, [_vm._v("录音题")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "read"
    }
  }, [_vm._v("阅读理解")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("听力题")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板英文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板英文"
    },
    model: {
      value: (_vm.updateTemplateParams.english),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "english", $$v)
      },
      expression: "updateTemplateParams.english"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateTemplateList = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "left-menu"
  }, [_c('LeftMenu')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content-main"
  }, [_c('div', {
    staticClass: "layout-inner-content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('KbAssistant')], 1)
},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("教材价格列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("添加教材价格")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/materialPrice/listByPage",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑教材价格"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材价格",
      "prop": "price"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "price", _vm._n($$v))
      },
      expression: "formData.price"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "老师对学生的评价"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdate),
      expression: "!isUpdate"
    }],
    staticClass: "score-feedback form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("1.词汇与运用: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.vocabularyTotal) + " ")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("2.听力与口语: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.listenTotal) + " ")])])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "词汇应用："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[0]))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "听力理解："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[5]))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "词汇理解："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[1]))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "声调辨别："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[6]))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "清晰表达："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[2]))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章表达："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[7]))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "表达语速："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[3]))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发音准确："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[8]))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "语法精准："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[4]))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "互动参与："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.score[9]))])])], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("总的分数: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.total) + " ")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.scroeLevel) + " ")])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("老师评价：")]), _vm._v(" "), _c('h4', [_vm._v("今天总评价:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.General_Description.General_Description_1))]), _vm._v(" did a great job in class today!\n        "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.General_Description.General_Description_2))]), _vm._v(" were able to "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.General_Description.General_Description_3))]), _vm._v(".\n        You participated in "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.General_Description.General_Description_4))]), _vm._v(".\n        "), _c('h4', [_vm._v("今天学习的单元:")]), _vm._v("\n        We studied "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Unit))]), _vm._v(".\n        "), _c('h4', [_vm._v("今天我们学了:")]), _vm._v("\n        This level includes vocabulary concerning "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_1))]), _vm._v(".\n        Today's key vocabulary terms were "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_2))]), _vm._v(", You were able to use "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_3))]), _vm._v(".\n        And you learned phonics "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_4))]), _vm._v(". and can pronounce "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_5))]), _vm._v(".\n        "), _c('h4', [_vm._v("今天你还可以更棒:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suggestion.Suggestion_1))]), _vm._v(" did a good job with "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suggestion.Suggestion_2))]), _vm._v(".\n        I recommend practice the grammar "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suggestion.Suggestion_3))]), _vm._v(" in your Hellokid textbook, especially\n        "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suggestion.Suggestion_4))]), _vm._v("\n        and pay attention to the pronunciation of "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suggestion.Suggestion_5))]), _vm._v(".\n        "), _c('h4', [_vm._v("适合的课程级别和上课频率:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Suitable_level))]), _vm._v(" a perfect fit for you to start the journey of learning English,\n        and twice or three times a week are suitable for you to have great outcome.\n        "), _c('h4', [_vm._v("今日寄语:")]), _vm._v("\n        Overall I am very pleased with our first class together. Great work today "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.assessmentLessonEvaluation.Ending_words))]), _vm._v("!\n        I look forward to seeing you again soon in the classroom.\n      ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("评论时间：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.feedTime))])])], 1)], 1), _vm._v(" "), _c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdate),
      expression: "isUpdate"
    }],
    ref: "feedbakcForm",
    staticClass: "score-feedback form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": 10,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("1.词汇与运用: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.vocabularyTotal) + " ")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("2.听力与口语: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.listenTotal) + " ")])])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "词汇应用："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.scoreCompute
    },
    model: {
      value: (_vm.score[0]),
      callback: function($$v) {
        _vm.$set(_vm.score, 0, $$v)
      },
      expression: "score[0]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "听力理解："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[5]),
      callback: function($$v) {
        _vm.$set(_vm.score, 5, $$v)
      },
      expression: "score[5]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "词汇理解："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[1]),
      callback: function($$v) {
        _vm.$set(_vm.score, 1, $$v)
      },
      expression: "score[1]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "声调辨别："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[6]),
      callback: function($$v) {
        _vm.$set(_vm.score, 6, $$v)
      },
      expression: "score[6]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "清晰表达："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[2]),
      callback: function($$v) {
        _vm.$set(_vm.score, 2, $$v)
      },
      expression: "score[2]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章表达："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[7]),
      callback: function($$v) {
        _vm.$set(_vm.score, 7, $$v)
      },
      expression: "score[7]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "表达语速："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[3]),
      callback: function($$v) {
        _vm.$set(_vm.score, 3, $$v)
      },
      expression: "score[3]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发音准确："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[8]),
      callback: function($$v) {
        _vm.$set(_vm.score, 8, $$v)
      },
      expression: "score[8]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8,
      "offset": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "语法精准："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.score[4]),
      callback: function($$v) {
        _vm.$set(_vm.score, 4, $$v)
      },
      expression: "score[4]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "互动参与："
    }
  }, [_c('Select', {
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.scoreCompute
    },
    model: {
      value: (_vm.score[9]),
      callback: function($$v) {
        _vm.$set(_vm.score, 9, $$v)
      },
      expression: "score[9]"
    }
  }, _vm._l((_vm.scroePoints), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 3
    }
  }, [_c('h3', [_vm._v("总的分数: "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.total) + " ")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.scroeLevel) + " ")])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("老师评价：")]), _vm._v(" "), _c('h4', [_vm._v("今天总评价:")]), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.General_Description.General_Description_1),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.General_Description, "General_Description_1", $$v)
      },
      expression: "assessmentLessonEvaluation.General_Description.General_Description_1"
    }
  })], 1), _vm._v("did a great job in class today!\n      "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.General_Description.General_Description_2),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.General_Description, "General_Description_2", $$v)
      },
      expression: "assessmentLessonEvaluation.General_Description.General_Description_2"
    }
  })], 1), _vm._v("were able to\n      "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.General_Description.General_Description_3),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.General_Description, "General_Description_3", $$v)
      },
      expression: "assessmentLessonEvaluation.General_Description.General_Description_3"
    }
  })], 1), _vm._v("\n      You participated in\n      "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.General_Description.General_Description_4),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.General_Description, "General_Description_4", $$v)
      },
      expression: "assessmentLessonEvaluation.General_Description.General_Description_4"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("今天学习的单元:")]), _vm._v("\n      We studied  "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Unit),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation, "Unit", $$v)
      },
      expression: "assessmentLessonEvaluation.Unit"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("今天我们学了:")]), _vm._v("\n      This level includes vocabulary concerning\n      "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_1),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Learning_Content, "Learning_Content_1", $$v)
      },
      expression: "assessmentLessonEvaluation.Learning_Content.Learning_Content_1"
    }
  })], 1), _vm._v("\n      Today's key vocabulary terms were "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_2),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Learning_Content, "Learning_Content_2", $$v)
      },
      expression: "assessmentLessonEvaluation.Learning_Content.Learning_Content_2"
    }
  })], 1), _vm._v(" You were able to use "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_3),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Learning_Content, "Learning_Content_3", $$v)
      },
      expression: "assessmentLessonEvaluation.Learning_Content.Learning_Content_3"
    }
  })], 1), _vm._v("\n      And you learned phonics "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_4),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Learning_Content, "Learning_Content_4", $$v)
      },
      expression: "assessmentLessonEvaluation.Learning_Content.Learning_Content_4"
    }
  })], 1), _vm._v(" and can pronounce "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Learning_Content.Learning_Content_5),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Learning_Content, "Learning_Content_5", $$v)
      },
      expression: "assessmentLessonEvaluation.Learning_Content.Learning_Content_5"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("今天你还可以更棒:")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suggestion.Suggestion_1),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Suggestion, "Suggestion_1", $$v)
      },
      expression: "assessmentLessonEvaluation.Suggestion.Suggestion_1"
    }
  })], 1), _vm._v("\n        did a good job with "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suggestion.Suggestion_2),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Suggestion, "Suggestion_2", $$v)
      },
      expression: "assessmentLessonEvaluation.Suggestion.Suggestion_2"
    }
  })], 1), _vm._v("\n      I recommend practice the grammar "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suggestion.Suggestion_3),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Suggestion, "Suggestion_3", $$v)
      },
      expression: "assessmentLessonEvaluation.Suggestion.Suggestion_3"
    }
  })], 1), _vm._v(" in your Hellokid textbook, especially "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suggestion.Suggestion_4),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Suggestion, "Suggestion_4", $$v)
      },
      expression: "assessmentLessonEvaluation.Suggestion.Suggestion_4"
    }
  })], 1), _vm._v("\n      and pay attention to the pronunciation of "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suggestion.Suggestion_5),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation.Suggestion, "Suggestion_5", $$v)
      },
      expression: "assessmentLessonEvaluation.Suggestion.Suggestion_5"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("适合的课程级别和上课频率:")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Suitable_level),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation, "Suitable_level", $$v)
      },
      expression: "assessmentLessonEvaluation.Suitable_level"
    }
  })], 1), _vm._v(" a perfect fit for you to start the journey of learning English,\n      and twice or three times a week are suitable for you to have great outcome.\n      "), _c('h4', [_vm._v("今日寄语:")]), _vm._v("\n      Overall I am very pleased with our first class together. Great work today "), _c('Form-item', {
    attrs: {
      "prop": "evaluation",
      "label-width": 1
    }
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "autosize": ""
    },
    model: {
      value: (_vm.assessmentLessonEvaluation.Ending_words),
      callback: function($$v) {
        _vm.$set(_vm.assessmentLessonEvaluation, "Ending_words", $$v)
      },
      expression: "assessmentLessonEvaluation.Ending_words"
    }
  })], 1), _vm._v("!\n      I look forward to seeing you again soon in the classroom.\n      ")], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdate && !_vm.readonly),
      expression: "!isUpdate && !readonly"
    }],
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.isUpdate = true
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdate),
      expression: "isUpdate"
    }],
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Periodical Evaluation Report( when finishing 20/80/160 classes)",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('el-alert', {
    attrs: {
      "closable": false,
      "title": _vm.title,
      "type": "info",
      "description": "Remember that learning is a continuous process, With your dedication and hard work, you can continue to grow and excel in your language learning journey. Keep up the good work!"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one：Student's overal performance in English learning (must include the student's progress in listening, speaking, reading, writing/grammar/vocabulary building，no less than 80 words in total)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two： Learning Suggestions")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("You can list learning suggestions, learning websites etc, and encourage the student to continue English courses.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.suggestions),
      callback: function($$v) {
        _vm.$set(_vm.formData, "suggestions", $$v)
      },
      expression: "formData.suggestions"
    }
  }), _vm._v(" "), _c('MultiUpload', {
    staticClass: "title",
    attrs: {
      "num": 1,
      "defaultFileList": this.formData.fileList
    },
    on: {
      "on-file-change": _vm.changeFile
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.report) ? _c('div', {
    staticClass: "mex-rpt"
  }, [_c('div', {
    staticClass: "mex-rpt-hero"
  }, [_c('div', {
    staticClass: "mex-rpt-hero-copy"
  }, [_c('p', {
    staticClass: "mex-rpt-kicker"
  }, [_vm._v(_vm._s(_vm.kicker))]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-score-row"
  }, [_c('span', {
    staticClass: "mex-rpt-score"
  }, [_vm._v(_vm._s(_vm.scoreInt))]), _vm._v(" "), _c('span', {
    staticClass: "mex-rpt-score-unit"
  }, [_vm._v("分")])]), _vm._v(" "), (_vm.isPlacement && _vm.formalLevelText) ? _c('p', {
    staticClass: "mex-rpt-level"
  }, [_vm._v("\n        综合等级 "), _c('b', [_vm._v(_vm._s(_vm.formalLevelText))])]) : (_vm.isPlacement && _vm.publishStatusText) ? _c('p', {
    staticClass: "mex-rpt-level mex-rpt-level-soft"
  }, [_vm._v("\n        " + _vm._s(_vm.publishStatusText) + "\n        "), (_vm.candidateLevelText) ? [_vm._v(" · 候选 "), _c('b', [_vm._v(_vm._s(_vm.candidateLevelText))])] : _vm._e(), _vm._v(" "), (_vm.visitedLevelText) ? [_vm._v(" · 触达 " + _vm._s(_vm.visitedLevelText))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSummative && _vm.promotionText) ? _c('p', {
    staticClass: "mex-rpt-promo"
  }, [_vm._v(_vm._s(_vm.promotionText))]) : _vm._e(), _vm._v(" "), (_vm.showPercentile) ? _c('p', {
    staticClass: "mex-rpt-peer"
  }, [_vm._v("\n        超过 "), _c('em', [_vm._v(_vm._s(_vm.report.nationalPercentile) + "%")]), _vm._v(" 同龄学员\n      ")]) : _c('p', {
    staticClass: "mex-rpt-peer mex-rpt-peer-muted"
  }, [_vm._v("全国样本不足，暂不对标")]), _vm._v(" "), (_vm.report.title) ? _c('p', {
    staticClass: "mex-rpt-title"
  }, [_vm._v(_vm._s(_vm.report.title) + " · " + _vm._s(_vm.medalText))]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "mex-rpt-fox",
    attrs: {
      "src": _vm.foxSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.radarIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      综合能力评估\n    ")]), _vm._v(" "), (_vm.radarPlot) ? _c('div', {
    staticClass: "mex-rpt-radar-box"
  }, [_c('ul', {
    staticClass: "mex-rpt-legend"
  }, [_vm._m(0), _vm._v(" "), (_vm.cityLine) ? _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-city"
  }), _vm._v(_vm._s(_vm.cityLegend))]) : _vm._e(), _vm._v(" "), (_vm.nationLine) ? _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-nation"
  }), _vm._v("全国学生标准")]) : _vm._e()]), _vm._v(" "), _c('svg', {
    staticClass: "mex-rpt-svg",
    attrs: {
      "viewBox": "0 0 420 360"
    }
  }, [_vm._l((_vm.radarPlot.rings), function(ring, i) {
    return _c('polygon', {
      key: 'r' + i,
      staticClass: "mex-rpt-ring",
      attrs: {
        "points": ring
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('line', {
      key: 'a' + i,
      staticClass: "mex-rpt-axis",
      attrs: {
        "x1": _vm.radarPlot.cx,
        "y1": _vm.radarPlot.cy,
        "x2": ax.x2,
        "y2": ax.y2
      }
    })
  }), _vm._v(" "), (_vm.radarPlot.nationPoly) ? _c('polygon', {
    staticClass: "mex-rpt-poly-nation",
    attrs: {
      "points": _vm.radarPlot.nationPoly
    }
  }) : _vm._e(), _vm._v(" "), (_vm.radarPlot.cityPoly) ? _c('polygon', {
    staticClass: "mex-rpt-poly-city",
    attrs: {
      "points": _vm.radarPlot.cityPoly
    }
  }) : _vm._e(), _vm._v(" "), _c('polygon', {
    staticClass: "mex-rpt-poly-self",
    attrs: {
      "points": _vm.radarPlot.selfPoly
    }
  }), _vm._v(" "), _vm._l((_vm.radarPlot.selfDots), function(d, i) {
    return _c('circle', {
      key: 'd' + i,
      staticClass: "mex-rpt-self-dot",
      attrs: {
        "cx": d.x,
        "cy": d.y,
        "r": "4"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('text', {
      key: 'l' + i,
      staticClass: "mex-rpt-axis-lab",
      attrs: {
        "x": ax.lx,
        "y": ax.ly,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(ax.label))])
  })], 2)]) : _c('p', {
    staticClass: "mex-rpt-hint"
  }, [_vm._v("暂无雷达数据")]), _vm._v(" "), _c('p', {
    staticClass: "mex-rpt-foot"
  }, [_vm._v(_vm._s(_vm.radarFoot))])]), _vm._v(" "), (_vm.isPlacement) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.dimIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      英语能力等级对照表\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-table-wrap"
  }, [_c('table', {
    staticClass: "mex-rpt-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('th', {
      key: col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.code))])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'c' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.ccss))])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'e' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.cefr))])
  })], 2), _vm._v(" "), _c('tr', [_c('th', [_vm._v("剑桥标准")]), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'm' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.cam))])
  })], 2)])])]), _vm._v(" "), (_vm.formalLevelText) ? _c('p', {
    staticClass: "mex-rpt-level-note"
  }, [_vm._v("\n      当前综合等级为 "), _c('b', [_vm._v(_vm._s(_vm.levelBrief))]), _vm._v("，继续加油，向更高的等级迈进！\n    ")]) : (_vm.isPlacement && _vm.publishStatusText) ? _c('p', {
    staticClass: "mex-rpt-level-note"
  }, [_vm._v("\n      " + _vm._s(_vm.publishStatusText) + "，非正式定级\n      "), (_vm.candidateLevelText) ? [_vm._v("（候选 " + _vm._s(_vm.candidateLevelText) + "）")] : _vm._e(), _vm._v(" "), (_vm.visitedLevelText) ? [_vm._v("；最高触达 " + _vm._s(_vm.visitedLevelText))] : _vm._e(), _vm._v("。\n    ")], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showDimAnalysis) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.dimIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      能力维度分析\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-tabs"
  }, _vm._l((_vm.dimTabs), function(tab) {
    return _c('button', {
      key: tab.skill,
      staticClass: "mex-rpt-tab",
      class: {
        'is-on': tab.skill === _vm.activeSkill
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeSkill = tab.skill
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 0), _vm._v(" "), (_vm.activeDim) ? _c('div', {
    staticClass: "mex-rpt-dim"
  }, [_c('div', {
    staticClass: "mex-rpt-dim-head"
  }, [_c('div', {
    staticClass: "mex-rpt-dim-score"
  }, [_c('span', [_vm._v(_vm._s(_vm.dimScoreInt))]), _c('small', [_vm._v("分")])]), _vm._v(" "), (_vm.activeDim.speakDims) ? _c('div', {
    staticClass: "mex-rpt-3d"
  }, [_c('div', [_c('label', [_vm._v("准确度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.accuracy)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("流利度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.fluency)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("完整度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.completeness)))])])]) : (_vm.activeDim.subs && _vm.activeDim.subs.length) ? _c('div', {
    staticClass: "mex-rpt-3d"
  }, _vm._l((_vm.activeDim.subs), function(sub) {
    return _c('div', {
      key: sub.code
    }, [_c('label', [_vm._v(_vm._s(sub.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.num(sub.score)))])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.activeDim.summary) ? _c('p', {
    staticClass: "mex-rpt-summary"
  }, [_vm._v(_vm._s(_vm.activeDim.summary))]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.activeDim.items || [])), function(item) {
    return _c('div', {
      key: item.sessionItemId,
      staticClass: "mex-rpt-q"
    }, [_c('div', {
      staticClass: "mex-rpt-q-top"
    }, [_c('span', {
      staticClass: "mex-rpt-q-no"
    }, [_vm._v("第 " + _vm._s(item.seq) + " 题")]), _vm._v(" "), _c('span', {
      staticClass: "mex-rpt-q-diff"
    }, [_vm._v("难度")]), _vm._v(" "), _c('span', {
      staticClass: "mex-rpt-stars"
    }, [_vm._v(_vm._s(_vm.stars(item.difficultyLevel)))])]), _vm._v(" "), (item.audioUrl) ? _c('div', {
      staticClass: "mex-rpt-audio-block"
    }, [_c('p', [_vm._v("宝贝发音")]), _vm._v(" "), _c('audio', {
      staticClass: "mex-rpt-audio",
      attrs: {
        "src": item.audioUrl,
        "controls": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mex-rpt-q-actions"
    }, [(item.explanation) ? _c('button', {
      staticClass: "mex-rpt-btn-fill",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleExplain(item.sessionItemId)
        }
      }
    }, [_vm._v("查看解析")]) : _vm._e(), _vm._v(" "), (_vm.sampleUrl(item)) ? _c('button', {
      staticClass: "mex-rpt-btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleSample(item.sessionItemId)
        }
      }
    }, [_vm._v("示范音")]) : _vm._e()]), _vm._v(" "), (_vm.openedExplain[item.sessionItemId]) ? _c('p', {
      staticClass: "mex-rpt-explain"
    }, [_vm._v(_vm._s(item.explanation))]) : _vm._e(), _vm._v(" "), (_vm.openedSample[item.sessionItemId] && _vm.sampleUrl(item)) ? _c('audio', {
      staticClass: "mex-rpt-audio",
      attrs: {
        "src": _vm.sampleUrl(item),
        "controls": ""
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!(_vm.activeDim.items && _vm.activeDim.items.length)) ? _c('p', {
    staticClass: "mex-rpt-hint"
  }, [_vm._v("该维暂无逐题")]) : _vm._e(), _vm._v(" "), (_vm.activeDim.tip) ? _c('p', {
    staticClass: "mex-rpt-tip"
  }, [_vm._v("小贴士：" + _vm._s(_vm.activeDim.tip))]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.report.advice) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_vm._v("学习建议")]), _vm._v(" "), _c('p', {
    staticClass: "mex-rpt-advice"
  }, [_vm._v(_vm._s(_vm.report.advice))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-self"
  }), _vm._v("本次测评")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("美国 CCSS"), _c('br'), _vm._v("对应年级")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("CEFR 欧洲"), _c('br'), _vm._v("共同语言标准")])
}]}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "钉钉用户",
      "width": "600px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "editDingForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.dingRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉用户",
      "prop": "dingtalkUserid"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dingtalkUserid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dingtalkUserid", $$v)
      },
      expression: "formData.dingtalkUserid"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Option', {
      key: item.userId,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(_vm._s(item.userName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否接收钉钉消息",
      "prop": "isReceiveMsg"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isReceiveMsg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isReceiveMsg", _vm._n($$v))
      },
      expression: "formData.isReceiveMsg"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.saveDing
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "performance-detail"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('h1', [_vm._v("业绩详情")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.adviserName))])]), _vm._v(" "), (_vm.fromSalesDealRate) ? _c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回销售成交率")]) : (_vm.fromChannelDealRate) ? _c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回渠道成交率")]) : _c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回龙虎榜")])], 1)]), _vm._v(" "), _c('Card', {
    staticClass: "search-card"
  }, [_c('Form', {
    attrs: {
      "model": _vm.queryParam,
      "label-width": 80,
      "inline": ""
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [(_vm.fromSalesDealRate || _vm.fromChannelDealRate) ? _c('FormItem', {
    attrs: {
      "label": "统计周"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.weekLabel))])]) : _c('FormItem', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份",
      "value": _vm.queryParam.month
    },
    on: {
      "on-change": _vm.onMonthChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" 搜索\n          ")], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-download"
    }
  }), _vm._v(" 导出\n          ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "table-card"
  }, [(_vm.tableData.length > 0) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "data-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("成交日期")]), _vm._v(" "), _c('th', [_vm._v("报名时间")]), _vm._v(" "), _c('th', [_vm._v("学生ID")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("收费")]), _vm._v(" "), _c('th', [_vm._v("基础课时")]), _vm._v(" "), _c('th', [_vm._v("赠送课时")]), _vm._v(" "), _c('th', [_vm._v("师资")]), _vm._v(" "), _c('th', [_vm._v("成交外教")]), _vm._v(" "), _c('th', [_vm._v("课程顾问")]), _vm._v(" "), _c('th', [_vm._v("订单类型")]), _vm._v(" "), _c('th', [_vm._v("渠道")]), _vm._v(" "), _c('th', [_vm._v("转介绍")]), _vm._v(" "), _c('th', [_vm._v("转介绍学员班主任")]), _vm._v(" "), _c('th', [_vm._v("备注")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.dealDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.signUpTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$numeral(item.amount).format('0,0')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.baseHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.giftHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.teacherType))]), _vm._v(" "), _c('td', [_c('Select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "请选择老师",
        "transfer": "",
        "transfer-class-name": 'performance-teacher-select'
      },
      on: {
        "on-change": function($event) {
          return _vm.handleTeacherChange(item)
        }
      },
      model: {
        value: (item.selectedTeacher),
        callback: function($$v) {
          _vm.$set(item, "selectedTeacher", $$v)
        },
        expression: "item.selectedTeacher"
      }
    }, _vm._l((item.trialLessonTeachers), function(teacher) {
      return _c('Option', {
        key: teacher,
        attrs: {
          "value": teacher
        }
      }, [_vm._v("\n                  " + _vm._s(teacher) + "\n                ")])
    }), 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.adviserName))]), _vm._v(" "), _c('td', {
      class: _vm.getChannelClass(item.channel)
    }, [_vm._v(_vm._s(item.channel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.referralSC))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.referralSCName))]), _vm._v(" "), _c('td', [_c('Input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "请输入备注"
      },
      on: {
        "on-change": function($event) {
          return _vm.handleRemarkChange(item)
        }
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.tableData.length === 0 && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-inbox",
      "size": "60",
      "color": "#dcdee2"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sa-refund-dash"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("财务管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("班主任退费看板")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dash-head"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("班主任退费看板")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.periodNote || '统计口径加载中…'))])])]), _vm._v(" "), _c('div', {
    staticClass: "filterbar"
  }, [_c('span', {
    staticClass: "fblabel"
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('div', {
    staticClass: "seg"
  }, [_c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 30
    },
    on: {
      "click": function($event) {
        return _vm.setDays(30)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 90
    },
    on: {
      "click": function($event) {
        return _vm.setDays(90)
      }
    }
  }, [_vm._v("近90天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 180
    },
    on: {
      "click": function($event) {
        return _vm.setDays(180)
      }
    }
  }, [_vm._v("近180天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'all'
    },
    on: {
      "click": _vm.setAll
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按月份查看…"
    },
    on: {
      "on-change": _vm.onMonth
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  }, _vm._l((_vm.monthOptions), function(m) {
    return _c('Option', {
      key: m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m))])
  }), 1), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "开始"
    },
    on: {
      "on-change": _vm.onCustomDate
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("至")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束"
    },
    on: {
      "on-change": _vm.onCustomDate
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetRange.apply(null, arguments)
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "全部班主任",
      "disabled": !_vm.privileged && _vm.advisers.length <= 1
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.studyAdviserId),
      callback: function($$v) {
        _vm.studyAdviserId = $$v
      },
      expression: "studyAdviserId"
    }
  }, _vm._l((_vm.advisers), function(a) {
    return _c('Option', {
      key: a.id,
      attrs: {
        "value": a.id
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1), _vm._v(" "), (_vm.periodLabel) ? _c('span', {
    staticClass: "range-text"
  }, [_vm._v("当前："), _c('b', [_vm._v(_vm._s(_vm.periodLabel))]), _vm._v("（" + _vm._s(_vm.periodDays) + " 天）")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, _vm._l((_vm.kpiCards), function(c) {
    return _c('div', {
      key: c.lab,
      staticClass: "kpi",
      class: c.cls
    }, [_c('div', {
      staticClass: "lab"
    }, [_vm._v(_vm._s(c.lab))]), _vm._v(" "), _c('div', {
      staticClass: "val"
    }, [_vm._v(_vm._s(c.val)), (c.unit) ? _c('small', [_vm._v(_vm._s(c.unit))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "foot"
    }, [_vm._v(_vm._s(c.foot))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("预警提示 "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.alerts.length))])]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("规则自动触发，优先级从高到低")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.alerts.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("当前周期内没有触发预警，团队状态平稳。")]) : _c('div', {
    staticClass: "alerts"
  }, _vm._l((_vm.alerts), function(a, i) {
    return _c('div', {
      key: i,
      staticClass: "alert",
      class: a.level
    }, [_c('div', [_c('div', {
      staticClass: "who"
    }, [_vm._v(_vm._s(a.teacher) + "\n              "), _c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(a.level)
    }, [_vm._v(_vm._s(_vm.levelLabel(a.level)))])]), _vm._v(" "), _c('div', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(a.text)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grid2"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.rateRows.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rateRows), function(r) {
    return _c('div', {
      key: 'r' + r.studyAdviserId,
      staticClass: "bar-row"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": r.teacher
      }
    }, [_vm._v(_vm._s(r.teacher))]), _vm._v(" "), _c('div', {
      staticClass: "track"
    }, [_c('div', {
      staticClass: "fill",
      style: ({
        width: _vm.rateWidth(r.rate) + '%',
        background: r.riskColor || '#3b82f6'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "avgline",
      style: ({
        left: _vm.avgRateLeft + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.pct(r.rate)))]), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(r.refundCount) + "人")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "avglegend"
  }, [_vm._v("虚线为团队均值 "), _c('b', [_vm._v(_vm._s(_vm.pct(_vm.avgRate)))]), _vm._v(" · 分级按 90 天口径折算")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.reasonRows.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无退费记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reasonRows), function(r, i) {
    return _c('div', {
      key: 'c' + r.category,
      staticClass: "bar-row reason"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": r.name
      }
    }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('div', {
      staticClass: "track"
    }, [_c('div', {
      staticClass: "fill",
      style: ({
        width: _vm.reasonWidth(r.count) + '%',
        background: _vm.palette[i % _vm.palette.length]
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(r.count))]), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(_vm.pct(r.share)))])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [_c('div', {
    staticClass: "cols"
  }, _vm._l((_vm.trend), function(t) {
    return _c('div', {
      key: t.month,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "cval"
    }, [_vm._v(_vm._s(t.count || ''))]), _vm._v(" "), _c('div', {
      staticClass: "cbar",
      style: ({
        height: _vm.trendHeight(t.count) + 'px'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "clab"
    }, [_vm._v(_vm._s(t.month.slice(5)) + "月")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-bd scroll"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.teacherColumns,
      "data": _vm.teacherRows,
      "size": "small",
      "loading": _vm.loading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("退费学生明细")]), _vm._v(" "), _c('div', {
    staticClass: "filterbar inline"
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "搜学生姓名/班主任",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.load,
      "on-clear": _vm.load
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "全部原因"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.reasonCategory),
      callback: function($$v) {
        _vm.reasonCategory = $$v
      },
      expression: "reasonCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("外教原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("学导原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("销售原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("技术原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("产品原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("学生客观原因")])], 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "新生+续费"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.signType),
      callback: function($$v) {
        _vm.signType = $$v
      },
      expression: "signType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "新生"
    }
  }, [_vm._v("仅新生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "续费"
    }
  }, [_vm._v("仅续费")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("筛选")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-bd scroll"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.studentColumns,
      "data": _vm.studentRows,
      "size": "small",
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading && !_vm.studentRows.length) ? _c('div', {
    staticClass: "empty",
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v("没有符合条件的退费记录")]) : _vm._e()], 1), _vm._v(" "), _vm._m(4)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("各班主任退费率")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("退费率 = 退费人数 ÷ 在册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("退费原因分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("近 6 个月退费趋势")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("按申请时间 · 人数去重")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("班主任明细")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot-note"
  }, [_c('b', [_vm._v("口径说明：")]), _vm._v("退费率 = 周期内退费人数 ÷ 周期内在册学员（曾归属 − 期前退费完结）；金额优先实际退款金额；\n      退费状态含已审核/已退费/劝退成功；时间按申请时间；新生/续费按购买渠道。三数（新生、续费、退费）不可直接相除。\n    ")])
}]}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "headers": _vm.headers,
      "with-credentials": true,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": false,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "onProgress": _vm.onProgress,
      "showUploadList": false,
      "accept": _vm.accept,
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v("   "), _c('a', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    }, [_vm._v("删除")])] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外管绩效")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择开始日期"
    },
    on: {
      "on-change": _vm.onStartDateChange
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "结束日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择结束日期"
    },
    on: {
      "on-change": _vm.onEndDateChange
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("个人邮箱")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper-header"
  }, [_c('ul', {
    staticClass: "ivu-menu ivu-menu-light ivu-menu-horizontal"
  }, [_c('div', {
    staticClass: "wrapper-header-nav-list",
    attrs: {
      "id": "tabPanel"
    }
  }, _vm._l((_vm.labelList), function(value, index) {
    return _c('li', {
      staticClass: "ivu-menu-item",
      class: {
        'ivu-menu-item-active': index === _vm.tabName
      },
      on: {
        "click": function($event) {
          return _vm.getMessage(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(value) + "\n            "), _vm._l((_vm.tabCountStatistic), function(countObj, countIndex) {
      return (index === countObj.tabName && countObj.count > 0) ? _c('span', {
        staticClass: "ivu-badge"
      }, [_c('sup', {
        staticClass: "ivu-badge-dot"
      })]) : _vm._e()
    })], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-container"
  }, [_c('div', {
    staticClass: "ivu-row"
  }, [_c('div', {
    staticClass: "wrapper-content ivu-article"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "学生ID / 姓名 / 提醒内容",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.searchMessage,
      "on-clear": _vm.searchMessage
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchMessage
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('i-table', {
    attrs: {
      "columns": _vm.columnList,
      "data": _vm.currentPersonMessageList,
      "row-class-name": _vm.rowClassName
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('change-director-modal', {
    attrs: {
      "value": _vm.openModal,
      "data": _vm.editData
    },
    on: {
      "on-close": function($event) {
        _vm.openModal = false
      }
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售通话记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "通话日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.defaultDate,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "默认当天"
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "被呼叫的号码",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "员工名称",
      "name": "ecUserName"
    },
    model: {
      value: (_vm.queryParam.ecUserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ecUserName", $$v)
      },
      expression: "queryParam.ecUserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n              搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncSalesUser
    }
  }, [_vm._v("同步销售工号")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.SynchronousData
    }
  }, [_vm._v("同步记录")])], 1)], 1), _vm._v(" "), _c('List', {
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/call_record/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/crm/PhoneRecordList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-家长沟通确认记录-课顾")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('span', [_vm._v("  是否教授录屏工具  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isBatchedTch),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isBatchedTch", $$v)
      },
      expression: "formValidate.isBatchedTch"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否教用电子教材  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isBatchedTime),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isBatchedTime", $$v)
      },
      expression: "formValidate.isBatchedTime"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否发送专属二维码  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.isCheckedForeignTchTime),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isCheckedForeignTchTime", $$v)
      },
      expression: "formValidate.isCheckedForeignTchTime"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否知悉协议条款  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.havaTellChineseLessonRule),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "havaTellChineseLessonRule", $$v)
      },
      expression: "formValidate.havaTellChineseLessonRule"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', [_vm._v("  是否告知请假规则  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.havaTellLeaveRule),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "havaTellLeaveRule", $$v)
      },
      expression: "formValidate.havaTellLeaveRule"
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('span', [_vm._v("  是否确认教材授课顺序  ")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.haveWebChat),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "haveWebChat", $$v)
      },
      expression: "formValidate.haveWebChat"
    }
  }, [_vm._v("YES")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("升班建议")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入学生 uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "升班建议"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择升班建议"
    },
    model: {
      value: (_vm.queryParam.promotion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "promotion", $$v)
      },
      expression: "queryParam.promotion"
    }
  }, [_c('Option', {
    attrs: {
      "value": "UP"
    }
  }, [_vm._v("直接升班")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CONSOLIDATE"
    }
  }, [_vm._v("巩固后升")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REMEDIATE"
    }
  }, [_vm._v("先补核心")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REPEAT"
    }
  }, [_vm._v("本级重学")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/promotions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "约陪练课",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "chineseLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.companionPracticingParam,
      "rules": _vm.chineseLessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.companionPracticingParam.uid) + "  - " + _vm._s(_vm.companionPracticingParam.mobile) + " - " + _vm._s(_vm.companionPracticingParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.companionPracticingParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "levelId", _vm._n($$v))
      },
      expression: "companionPracticingParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.companionPracticingParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "schoolId", _vm._n($$v))
      },
      expression: "companionPracticingParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.companionPracticingParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "lessonId", _vm._n($$v))
      },
      expression: "companionPracticingParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.companionPracticingParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "lsnBeginTimeDate", $$v)
      },
      expression: "companionPracticingParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "value": _vm.timeStr,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.companionPracticingParam.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "beginTime", $$v)
      },
      expression: "companionPracticingParam.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.clearTchList
    },
    model: {
      value: (_vm.companionPracticingParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "timeLength", _vm._n($$v))
      },
      expression: "companionPracticingParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.companionPracticingParam.category),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "category", $$v)
      },
      expression: "companionPracticingParam.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("全职老师")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("兼职老师")])])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.companionPracticingParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "tchId", _vm._n($$v))
      },
      expression: "companionPracticingParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertChineseLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加海报"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "addPosterForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.shareRules,
      "model": _vm.addPosterparams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.addPosterparams.name),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "name", $$v)
      },
      expression: "addPosterparams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报分类：",
      "prop": "sharePosterType"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.addPosterparams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "sharePosterType", $$v)
      },
      expression: "addPosterparams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动归属：",
      "prop": "activityId"
    }
  }, [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.addPosterparams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "activityId", $$v)
      },
      expression: "addPosterparams.activityId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "配套海报：",
      "prop": "url"
    }
  }, [_c('image-upload-New', {
    attrs: {
      "defaultFileList": _vm.defaultPicList
    },
    model: {
      value: (_vm.addPosterparams.url),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "url", $$v)
      },
      expression: "addPosterparams.url"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报排序：",
      "prop": "sort"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 100000
    },
    model: {
      value: (_vm.addPosterparams.sort),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "sort", $$v)
      },
      expression: "addPosterparams.sort"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.addPosterparams.status),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "status", $$v)
      },
      expression: "addPosterparams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddPoster
    },
    on: {
      "click": _vm.createPoster
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "凭证/附件展示",
      "width": "80%",
      "footer-hide": true
    },
    on: {
      "on-visible-change": _vm.handleModalVisibleChange
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [
    [_c('div', {
      staticClass: "carousel-container"
    }, [_c('el-carousel', {
      ref: "carousel",
      attrs: {
        "indicator-position": "outside",
        "initial-index": _vm.initialIndex
      }
    }, _vm._l((_vm.showList), function(item, index) {
      return _c('el-carousel-item', {
        key: item,
        staticClass: "carousel-item"
      }, [_c('img', {
        staticClass: "preview-image",
        attrs: {
          "src": item,
          "alt": 'Image ' + (index + 1)
        },
        on: {
          "click": function($event) {
            return _vm.handleImageClick(index)
          }
        }
      })])
    }), 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showViewer),
        expression: "showViewer"
      }],
      staticClass: "image-viewer-wrapper",
      on: {
        "click": _vm.closeViewer
      }
    }, [_c('img', {
      staticClass: "viewer-image",
      attrs: {
        "src": _vm.currentImage
      },
      on: {
        "touchstart": _vm.handleTouchStart,
        "touchmove": _vm.handleTouchMove,
        "touchend": _vm.handleTouchEnd
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "viewer-toolbar"
    }, [_c('button', {
      staticClass: "viewer-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeViewer.apply(null, arguments)
        }
      }
    }, [_vm._v("关闭")])])])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "原合同期"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.crtBeginDate) || '—') + " ~ " + _vm._s((_vm.row && _vm.row.crtEndDate) || '—'))]), _vm._v(" "), (_vm.row && _vm.row.daysLeft != null) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("（" + _vm._s(_vm.daysLabel) + "）")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新合同起始日",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtBeginDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onBeginChange
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新合同到期日",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtEndDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtEndDate = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "续签年限、薪资调整、签署状态等"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认续签")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": _vm.uidReadonly,
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "历史跟踪记录"
    }
  }, [_c('Table', {
    attrs: {
      "size": "small",
      "columns": _vm.userTrackRecordColumns,
      "data": _vm.userTrackRecordList
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [(_vm.trackType == '' || _vm.trackType == null) ? _c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "跟踪记录内容",
      "width": "720",
      "mask-closable": false
    },
    model: {
      value: (_vm.contentVisible),
      callback: function($$v) {
        _vm.contentVisible = $$v
      },
      expression: "contentVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "size": "small"
    },
    on: {
      "on-change": _vm.switchContentView
    },
    model: {
      value: (_vm.contentViewMode),
      callback: function($$v) {
        _vm.contentViewMode = $$v
      },
      expression: "contentViewMode"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "markdown"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "raw",
      "disabled": !_vm.contentRawText
    }
  }, [_vm._v("原文")])], 1), _vm._v(" "), (!_vm.contentRawText) ? _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("无原始内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.contentViewMode === 'markdown') ? _c('div', {
    ref: "contentExportArea",
    staticClass: "track-md track-md-dialog",
    domProps: {
      "innerHTML": _vm._s(_vm.contentHtml)
    }
  }) : _c('pre', {
    ref: "contentExportArea",
    staticClass: "track-raw-dialog"
  }, [_vm._v(_vm._s(_vm.contentRawText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportImageLoading,
      "disabled": _vm.exportImageLoading || (_vm.contentViewMode === 'markdown' ? !_vm.contentHtml : !_vm.contentRawText)
    },
    on: {
      "click": _vm.exportContentPng
    }
  }, [_vm._v("导出 PNG")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contentVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "CARE",
      "title": "员工关怀",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "width": "980",
      "title": "涉及请假课程"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.tchLeaveLessonColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "取消课程"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "dataForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "取消课程原因：",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  })], 1)], 1), _vm._v(" "), (_vm.lsnType === 2 && _vm.tchChannel === 1) ? _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "补课时间"
    }
  }, [_c('Row', [_c('Date-picker', {
    attrs: {
      "format": "yyyy-MM-dd HH:mm",
      "clearable": true,
      "type": "datetime",
      "placement": "bottom-start",
      "placeholder": "补课时间必填"
    },
    model: {
      value: (_vm.formData.makeUpTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeUpTime", $$v)
      },
      expression: "formData.makeUpTime"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lsnType === 2 && _vm.tchChannel === 1) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "attachment"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.attachment),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attachment", $$v)
      },
      expression: "formData.attachment"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.onTchLeave
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试用期到期提醒")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    规则：入职日（首次开课日）起 "), _c('b', [_vm._v(_vm._s(_vm.rules.probationMonths))]), _vm._v(" 个月为试用期（含延长月数），到期前\n    "), _c('b', [_vm._v(_vm._s(_vm.rules.probationNearDays))]), _vm._v(" 天、"), _c('b', [_vm._v(_vm._s(_vm.rules.probationUrgentDays))]), _vm._v(" 天各提醒一次；到期日次日转为逾期待处理。\n    "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/hrWorkbench/settings')
      }
    }
  }, [_vm._v("调整规则")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', {
    staticClass: "seg"
  }, _vm._l((_vm.levelTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.level === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeLevel(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + " " + _vm._s(_vm.counts[item.value] || 0) + "\n      ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-total"
  }, [_vm._v("共 " + _vm._s(_vm.dataList.length) + " 人")]), _vm._v(" "), _c('Button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": "",
      "row-class-name": _vm.rowClassName,
      "no-data-text": "当前筛选下无记录"
    }
  })], 1), _vm._v(" "), _c('probation-decide-modal', {
    attrs: {
      "value": _vm.showDecide,
      "row": _vm.currentRow
    },
    on: {
      "on-close": function($event) {
        _vm.showDecide = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("代理管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("推荐记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老生"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteKey",
      "placeholder": "老生ID/手机号/昵称"
    },
    model: {
      value: (_vm.queryParam.inviteKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteKey", $$v)
      },
      expression: "queryParam.inviteKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "新生"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "新生ID/手机号/昵称",
      "name": "stdKey"
    },
    model: {
      value: (_vm.queryParam.stdKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdKey", $$v)
      },
      expression: "queryParam.stdKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "推荐人学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "是否已试听"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isAudition", _vm._n($$v))
      },
      expression: "queryParam.isAudition"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "justify": "end",
      "type": "flex",
      "class-name": "export"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/agentInvite/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    },
    model: {
      value: (_vm.showIs),
      callback: function($$v) {
        _vm.showIs = $$v
      },
      expression: "showIs"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物流名称",
      "prop": "logicName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.logicName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logicName", $$v)
      },
      expression: "formData.logicName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物流单号",
      "prop": "logicNumber"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.logicNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logicNumber", $$v)
      },
      expression: "formData.logicNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showIs = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("当天订课信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 7,
      "lg": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px 0"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 2,
      "lg": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchStudyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchStudyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.tchStudyAdviserId"
    }
  }, _vm._l((_vm.tchStudyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n              搜索\n            ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('619'),
      expression: "'619'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "opened-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLesson/opened/take-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reloadWithPage": _vm.reloadWithPage,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectedChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("合同模板")])], 1)], 1)]), _vm._v(" "), _c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formData.id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id", $$v)
      },
      expression: "formData.id"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(null, true)
      }
    }
  }, [_vm._v("新增模版")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.formData, false)
      }
    }
  }, [_vm._v("修改模版名称")])], 1)], 1), _vm._v(" "), _c('Row', [_c('div', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_c('p', [_vm._v("\n          合同中可以引用动态数据:\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          学生订单合同：{学生ID},{订单编号},{付款金额},{付款金额大写},\n          {课程有效期},{课时},{学生姓名英文},{学生姓名中文},{学生姓名中文繁体},{付款金额英文},{付款金额繁体}\n        ")]), _vm._v(" "), _c('p', [_vm._v("老师合同:{老师ID},{老师姓名},{合同开始时间},{合同结束时间},{签字时间}")])])])], 1), _vm._v(" "), _c('Row', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.contract),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contract", $$v)
      },
      expression: "formData.contract"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增/编辑"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.enabledStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": _vm.num > 1,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      staticClass: "upload-list"
    }, [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-mask",
    on: {
      "click": _vm.onCarouselClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "2002",
      "right": "40px",
      "top": "20px",
      "cursor": "hand"
    },
    on: {
      "click": _vm.onCarouselClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close",
      "color": "white",
      "size": "40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-content"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": false,
      "autoplay-speed": 1000,
      "dots": "outside",
      "trigger": "click",
      "arrow": "always"
    },
    model: {
      value: (_vm.showIndex),
      callback: function($$v) {
        _vm.showIndex = $$v
      },
      expression: "showIndex"
    }
  }, _vm._l((_vm.fileList), function(file) {
    return _c('CarouselItem', {
      key: file.url,
      staticClass: "item"
    }, [_c('img', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("工资条管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年月"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM",
      "placeholder": "选择年月"
    },
    on: {
      "on-change": _vm.changeMonth
    },
    model: {
      value: (_vm.myMonth),
      callback: function($$v) {
        _vm.myMonth = $$v
      },
      expression: "myMonth"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "版本"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "contractVersion"
    },
    model: {
      value: (_vm.queryParam.contractVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "contractVersion", $$v)
      },
      expression: "queryParam.contractVersion"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", $$v)
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "part time"
    }
  }, [_vm._v("part time")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "full time"
    }
  }, [_vm._v("full time")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否确认",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.confirm),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "confirm", $$v)
      },
      expression: "queryParam.confirm"
    }
  }, _vm._l((_vm.$constant.confirm), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.action,
      "on-change": _vm.handleChange,
      "headers": _vm.headers,
      "on-success": _vm.handleSuccess,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": ".xls,.xlsx",
      "limit": 2,
      "multiple": "",
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.downTchWagesMobal
    }
  }, [_vm._v("下载模板")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchWages/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-preview"
  }, [(_vm.resolvedType === 'image') ? _c('div', {
    staticClass: "file-preview-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpsUrl
    }
  })]) : (_vm.resolvedType === 'video') ? _c('video', {
    staticClass: "file-preview-media",
    attrs: {
      "src": _vm.httpsUrl,
      "controls": ""
    }
  }) : (_vm.resolvedType === 'audio') ? _c('audio', {
    staticClass: "file-preview-audio",
    attrs: {
      "src": _vm.httpsUrl,
      "controls": ""
    }
  }) : (_vm.resolvedType === 'office') ? _c('div', {
    staticClass: "handbook-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.officeViewerUrl,
      "width": "100%",
      "height": "600",
      "frameborder": "0"
    }
  })]) : (_vm.resolvedType === 'pdf') ? _c('div', {
    staticClass: "handbook-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.httpsUrl,
      "width": "100%",
      "height": "600",
      "frameborder": "0"
    }
  })]) : (_vm.resolvedType === 'csv') ? _c('div', {
    staticClass: "csv-preview"
  }, [(_vm.tableLoading) ? _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("Loading preview...")])]) : (_vm.tableError) ? _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v(_vm._s(_vm.tableError))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1) : (_vm.csvHeaders.length) ? _c('div', {
    staticClass: "csv-table-wrap"
  }, [_c('table', {
    staticClass: "csv-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.csvHeaders), function(h, i) {
    return _c('th', {
      key: 'h-' + i
    }, [_vm._v(_vm._s(h))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.csvRows), function(row, ri) {
    return _c('tr', {
      key: 'r-' + ri
    }, _vm._l((row), function(cell, ci) {
      return _c('td', {
        key: 'c-' + ri + '-' + ci
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])]) : _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("Preview is empty.")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1)]) : _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("This file type cannot be previewed in the browser.")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "查看上课情况",
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("数据汇总列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 50,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy",
      "value-format": "yyyy",
      "placeholder": "请选择年份"
    },
    model: {
      value: (_vm.queryParam.paramYear),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "paramYear", $$v)
      },
      expression: "queryParam.paramYear"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM",
      "value-format": "MM",
      "placeholder": "请选择月份"
    },
    model: {
      value: (_vm.queryParam.paramMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "paramMonth", $$v)
      },
      expression: "queryParam.paramMonth"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n    ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/dataCenter/statisticsGatherList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("主管管理")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sum-grid"
  }, _vm._l((_vm.summaryCards), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "sum-card"
    }, [_c('div', {
      staticClass: "sum-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "sum-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "sum-foot"
    }, [_vm._v(_vm._s(item.foot))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("动作闭环检查")]), _vm._v(" "), _c('div', {
    staticClass: "group-grid"
  }, [_vm._l((_vm.groupCards), function(g) {
    return _c('div', {
      key: g.key,
      staticClass: "group-card"
    }, [_c('div', {
      staticClass: "group-head"
    }, [_c('span', {
      staticClass: "group-label"
    }, [_vm._v(_vm._s(g.label))]), _vm._v(" "), _c('span', {
      staticClass: "group-open",
      class: {
        'is-danger': _vm.num(g.open) > 0
      }
    }, [_vm._v(_vm._s(_vm.num(g.open))), _c('i', [_vm._v(_vm._s(g.unit || '项'))])])]), _vm._v(" "), (g.rate != null) ? _c('div', {
      staticClass: "group-rate"
    }, [_vm._v("闭环率 "), _c('b', [_vm._v(_vm._s(_vm.formatRate(g.rate)))])]) : _vm._e(), _vm._v(" "), (g.mode === 'rate') ? _c('div', {
      staticClass: "group-meta"
    }, [_vm._v("应完成 " + _vm._s(_vm.num(g.due)) + " · 已完成 " + _vm._s(_vm.num(g.done)))]) : _vm._e(), _vm._v(" "), (g.extra) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v(_vm._s(g.extra))]) : _vm._e(), _vm._v(" "), (_vm.num(g.soon) > 0) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v("另 " + _vm._s(_vm.num(g.soon)) + " 项临近")]) : _vm._e(), _vm._v(" "), (_vm.num(g.overdueMax) > 0) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v("最长逾期 " + _vm._s(_vm.num(g.overdueMax)) + " 天")]) : _vm._e()])
  }), _vm._v(" "), (!_vm.groupCards.length) ? _c('div', {
    staticClass: "group-empty"
  }, [_vm._v("暂无动作数据")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("外管执行看板")]), _vm._v(" "), _c('div', {
    staticClass: "block-note"
  }, [_vm._v("按未闭环合计从多到少")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.operatorColumns,
      "data": _vm.operatorRows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无外管数据"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "detailBlock",
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("\n      未闭环明细\n      "), _c('span', {
    staticClass: "block-desc"
  }, [_vm._v("共 " + _vm._s(_vm.filteredItems.length) + " 项")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("动作类型")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.kindFilter),
      callback: function($$v) {
        _vm.kindFilter = $$v
      },
      expression: "kindFilter"
    }
  }, [_c('Option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部动作")]), _vm._v(" "), _vm._l((_vm.kindOptions), function(item) {
    return _c('Option', {
      key: item.key,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外管")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.operatorFilter),
      callback: function($$v) {
        _vm.operatorFilter = $$v
      },
      expression: "operatorFilter"
    }
  }, [_c('Option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部外管")]), _vm._v(" "), _vm._l((_vm.operatorOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), (_vm.operatorFilter !== 'all' || _vm.kindFilter !== 'all') ? _c('Button', {
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("清除筛选")]) : _vm._e()], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.itemColumns,
      "data": _vm.filteredItems,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "当前筛选下无未闭环事项"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block settings-block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("规则与设置")]), _vm._v(" "), _c('hr-workbench-settings', {
    attrs: {
      "embedded": ""
    }
  })], 1), _vm._v(" "), _c('review-save-modal', {
    attrs: {
      "value": _vm.modal.review,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.review = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('followup-handle-modal', {
    attrs: {
      "value": _vm.modal.followup,
      "lessons": _vm.handleLessons
    },
    on: {
      "on-close": function($event) {
        _vm.modal.followup = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('probation-decide-modal', {
    attrs: {
      "value": _vm.modal.probation,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.probation = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.modal.contract,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.contract = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    口径：始终统计全部在职外教，不受工作台外教运营筛选影响。可量化动作闭环率只看新外教回访与出勤跟进；试用期、合同只统计已逾期，临近项单独提示。\n  ")])
}]}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加监课记录"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.recordParam,
      "rules": _vm.recordRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "监课情况",
      "prop": "recordingContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.recordParam.recordingContent),
      callback: function($$v) {
        _vm.$set(_vm.recordParam, "recordingContent", $$v)
      },
      expression: "recordParam.recordingContent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("代理管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("代理用户")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 75,
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/agentUser/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("管理员列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickname",
      "label-width": 40
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "登录账号",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊",
      "name": "phone"
    },
    model: {
      value: (_vm.queryParam.phone),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "phone", $$v)
      },
      expression: "queryParam.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "groupId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.groupId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "groupId", _vm._n($$v))
      },
      expression: "queryParam.groupId"
    }
  }, _vm._l((_vm.adminGroupList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "left-btn"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-btn"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('')
      }
    }
  }, [_vm._v("添加管理员\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncLoading,
      "disable": _vm.syncLoading,
      "icon": "refresh"
    },
    on: {
      "click": _vm.syncDingtalkName
    }
  }, [_vm._v("同步钉钉名称\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "export"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("绑定次数导出\n      ")])], 1)]), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminUser/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    model: {
      value: (_vm.showAdminUserEditModal),
      callback: function($$v) {
        _vm.showAdminUserEditModal = $$v
      },
      expression: "showAdminUserEditModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.editAdminUser,
      "rules": _vm.ruleAdminUser,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickname"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.nickname),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "nickname", $$v)
      },
      expression: "editAdminUser.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "修改密码填写"
    },
    model: {
      value: (_vm.editAdminUser.password),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "password", $$v)
      },
      expression: "editAdminUser.password"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "登录账号",
      "prop": "mobile"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "mobile", $$v)
      },
      expression: "editAdminUser.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "联系号码",
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "用于bops 后台登录接收验证码"
    },
    model: {
      value: (_vm.editAdminUser.phone),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "phone", $$v)
      },
      expression: "editAdminUser.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉手机号",
      "prop": "dingMobile"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.dingMobile),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "dingMobile", $$v)
      },
      expression: "editAdminUser.dingMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.status),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "status", _vm._n($$v))
      },
      expression: "editAdminUser.status"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "groupId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.groupId),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "groupId", _vm._n($$v))
      },
      expression: "editAdminUser.groupId"
    }
  }, _vm._l((_vm.adminGroupList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉部门"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.loadDingtalkUser
    },
    model: {
      value: (_vm.editAdminUser.dingtalkDepartmentId),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "dingtalkDepartmentId", _vm._n($$v))
      },
      expression: "editAdminUser.dingtalkDepartmentId"
    }
  }, _vm._l((_vm.departmentList), function(item) {
    return _c('Option', {
      key: item.departmentId,
      attrs: {
        "value": item.departmentId
      }
    }, [_vm._v("\n                " + _vm._s(item.departmentName) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉用户"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.dingtalkUserid),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "dingtalkUserid", $$v)
      },
      expression: "editAdminUser.dingtalkUserid"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Option', {
      key: item.userId,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(_vm._s(item.userName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否接收钉钉消息",
      "prop": "isReceiveMsg"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.isReceiveMsg),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "isReceiveMsg", _vm._n($$v))
      },
      expression: "editAdminUser.isReceiveMsg"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "工号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "EC 手机号"
    },
    model: {
      value: (_vm.editAdminUser.agentMoor),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "agentMoor", $$v)
      },
      expression: "editAdminUser.agentMoor"
    }
  })], 1)], 1), _vm._v(" "), (_vm.editAdminUser.groupId === 10) ? _c('div', [_c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属小组",
      "prop": "teamType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.teamType),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "teamType", _vm._n($$v))
      },
      expression: "editAdminUser.teamType"
    }
  }, _vm._l((_vm.$constant.adviserGroup), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "职位",
      "prop": "positionType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.editAdminUser.positionType),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser, "positionType", _vm._n($$v))
      },
      expression: "editAdminUser.positionType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("普通组员")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("小组长")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("部门经理")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师限制(个)"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.adminConfig.limitBindTchNum),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser.adminConfig, "limitBindTchNum", $$v)
      },
      expression: "editAdminUser.adminConfig.limitBindTchNum"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定时间限制(个)"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.adminConfig.limitBindTimeNum),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser.adminConfig, "limitBindTimeNum", $$v)
      },
      expression: "editAdminUser.adminConfig.limitBindTimeNum"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定次数限制(次/月)"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.editAdminUser.adminConfig.limitBindTimesMonth),
      callback: function($$v) {
        _vm.$set(_vm.editAdminUser.adminConfig, "limitBindTimesMonth", $$v)
      },
      expression: "editAdminUser.adminConfig.limitBindTimesMonth"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showAdminUserEditModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑权限"
    },
    model: {
      value: (_vm.editPermissionModal),
      callback: function($$v) {
        _vm.editPermissionModal = $$v
      },
      expression: "editPermissionModal"
    }
  }, [_c('el-tree', {
    ref: "permissionTree",
    staticClass: "permission-tree",
    attrs: {
      "data": _vm.permissionData,
      "show-checkbox": "",
      "check-strictly": true,
      "node-key": "id",
      "default-checked-keys": _vm.checkKeys
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editPermissionModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.editPermission
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "跟踪记录内容",
      "width": "720",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "size": "small"
    },
    model: {
      value: (_vm.viewMode),
      callback: function($$v) {
        _vm.viewMode = $$v
      },
      expression: "viewMode"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "markdown"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "raw",
      "disabled": !_vm.rawText
    }
  }, [_vm._v("原文")])], 1), _vm._v(" "), (!_vm.rawText) ? _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("无原始内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.viewMode === 'markdown') ? _c('div', {
    ref: "contentExportArea",
    staticClass: "track-md track-md-dialog",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }) : _c('pre', {
    ref: "contentExportArea",
    staticClass: "track-raw-dialog"
  }, [_vm._v(_vm._s(_vm.rawText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportLoading,
      "disabled": _vm.exportLoading || (_vm.viewMode === 'markdown' ? !_vm.html : !_vm.rawText)
    },
    on: {
      "click": _vm.exportPng
    }
  }, [_vm._v("导出 PNG")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "编辑课后视频",
      "width": "600px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "videoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.videoRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", _vm._n($$v))
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传视频",
      "label-width": 100,
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), (_vm.formData.videoUrl) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "position": "absolute",
      "top": "0px",
      "left": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showIndex(_vm.formData.videoUrl)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-view el-icon--left"
  }), _vm._v("预览")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "每课一曲",
      "label-width": 100,
      "prop": "musicUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChangeMusic,
      "on-success": _vm.handleSuccessMusic,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileMusicList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), (_vm.formData.musicUrl) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "position": "absolute",
      "top": "0px",
      "left": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showIndex(_vm.formData.musicUrl)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-view el-icon--left"
  }), _vm._v("预览")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.activityList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.id + ' - ' + item.nickname))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "发送邮件",
      "width": "800",
      "mask-closable": false
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "emailForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.emailParam,
      "rules": _vm.emailRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.emailParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.emailParam, "tchId", $$v)
      },
      expression: "emailParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.tchName),
      callback: function($$v) {
        _vm.tchName = $$v
      },
      expression: "tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮件标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入邮件标题"
    },
    model: {
      value: (_vm.emailParam.title),
      callback: function($$v) {
        _vm.$set(_vm.emailParam, "title", $$v)
      },
      expression: "emailParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮件内容",
      "prop": "content"
    }
  }, [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.emailParam.content),
      callback: function($$v) {
        _vm.$set(_vm.emailParam, "content", $$v)
      },
      expression: "emailParam.content"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "cancel",
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingSend
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("\n      确定\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学员风险")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.level),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "level", $$v)
      },
      expression: "queryParam.level"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("高")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "天数"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": 90
    },
    model: {
      value: (_vm.queryParam.days),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "days", $$v)
      },
      expression: "queryParam.days"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "仅未跟进"
    }
  }, [_c('i-switch', {
    model: {
      value: (_vm.queryParam.unfollowedOnly),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "unfollowedOnly", $$v)
      },
      expression: "queryParam.unfollowedOnly"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.aiAllowed) ? _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/studentRisk/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "snapshot-id": _vm.aiSnapshotId,
      "page-route": "/user/studentRiskList",
      "default-task-type": "RISK_EXPLAIN"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "写跟进",
      "mask-closable": false
    },
    model: {
      value: (_vm.showFollowupModal),
      callback: function($$v) {
        _vm.showFollowupModal = $$v
      },
      expression: "showFollowupModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "动作",
      "required": ""
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.followupForm.action),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "action", $$v)
      },
      expression: "followupForm.action"
    }
  }, [_c('Option', {
    attrs: {
      "value": "CALL"
    }
  }, [_vm._v("CALL 电话")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REMARK"
    }
  }, [_vm._v("REMARK 备注")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("TRANSFER 转交")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IGNORE"
    }
  }, [_vm._v("IGNORE 忽略")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "结果"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "可空"
    },
    model: {
      value: (_vm.followupForm.result),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "result", $$v)
      },
      expression: "followupForm.result"
    }
  }, [_c('Option', {
    attrs: {
      "value": "MISREPORT"
    }
  }, [_vm._v("MISREPORT")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SCHEDULE"
    }
  }, [_vm._v("SCHEDULE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "LEARNING"
    }
  }, [_vm._v("LEARNING")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SERVICE"
    }
  }, [_vm._v("SERVICE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PRICE"
    }
  }, [_vm._v("PRICE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PAUSE"
    }
  }, [_vm._v("PAUSE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RECOVERED"
    }
  }, [_vm._v("RECOVERED")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "LOST"
    }
  }, [_vm._v("LOST")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "跟进说明"
    },
    model: {
      value: (_vm.followupForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "comment", $$v)
      },
      expression: "followupForm.comment"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写跟踪"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.followupForm.writeTrack),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "writeTrack", $$v)
      },
      expression: "followupForm.writeTrack"
    }
  }, [_vm._v("同时写 user_track_record（trackType=61，不推送）")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showFollowupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.followupLoading
    },
    on: {
      "click": _vm.submitFollowup
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Course Report",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one： Overall Performance(minimum 2 stars, maximum 5 stars)  :")]), _vm._v(" "), _c('Form', {
    ref: "formData",
    staticClass: "feedback form regluarForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Comprehension："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate1),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate1", $$v)
      },
      expression: "formData.rate1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Speaking Skill："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate2", $$v)
      },
      expression: "formData.rate2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Pronunciation："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate3),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate3", $$v)
      },
      expression: "formData.rate3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Vocabulary："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate4),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate4", $$v)
      },
      expression: "formData.rate4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Use of Expression："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate5),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate5", $$v)
      },
      expression: "formData.rate5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Sentence Construction："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate6),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate6", $$v)
      },
      expression: "formData.rate6"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two: Teacher's Feedback   :")]), _vm._v(" "), _c('p', [_vm._v("Please list at least 1 point which the student really did well, and 1 point which the student\nreally needs to improve\nYou can write your suggestions according to the student's speaking, listening, usage of\nsentences, adaptability. Interaction with the teacher.")]), _vm._v(" "), _c('h4', [_vm._v("Improvements：(at least 20 words)  :")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.word1),
      callback: function($$v) {
        _vm.$set(_vm.formData, "word1", $$v)
      },
      expression: "formData.word1"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Difficulties：(at least 20 words)  :")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.word2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "word2", $$v)
      },
      expression: "formData.word2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Suggestions：(at least 30 words)  :")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.word3),
      callback: function($$v) {
        _vm.$set(_vm.formData, "word3", $$v)
      },
      expression: "formData.word3"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "课程结算"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "fundForm",
    staticClass: "form",
    attrs: {
      "model": _vm.fundParam,
      "rules": _vm.fundRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "金额",
      "prop": "amount"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.fundParam.amount),
      callback: function($$v) {
        _vm.$set(_vm.fundParam, "amount", _vm._n($$v))
      },
      expression: "fundParam.amount"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBalance
    },
    on: {
      "click": _vm.balance
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生常规请假详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": _vm.listUrl,
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课程音频")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.queryParam,
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", _vm._n($$v))
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", _vm._n($$v))
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程标题"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLessonChange
    },
    model: {
      value: (_vm.queryParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonId", _vm._n($$v))
      },
      expression: "queryParam.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "音乐标题"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', [_c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLessonAudio/listByPage",
      "params": _vm.queryParam
    }
  }), _vm._v(" "), _c('LessonAudioInsertModal', {
    attrs: {
      "value": _vm.showInsertModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('LessonAudioUpdateModal', {
    attrs: {
      "value": _vm.showUpdateModal,
      "successCallback": _vm.search,
      "id": _vm.id
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list disk-index"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("网盘")]), _vm._v(" "), _vm._l((_vm.breadcrumb), function(item, index) {
    return _c('Breadcrumb-item', {
      key: item.id
    }, [(index < _vm.breadcrumb.length - 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.jumpTo(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-body"
  }, [_c('div', {
    staticClass: "disk-side"
  }, [_vm._l((_vm.mainSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": sp.key === 'recycle' ? 'ios-trash' : 'folder'
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.spaceLabel(sp)))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-side-section"
  }, [_c('div', {
    staticClass: "disk-side-title"
  }, [_c('span', [_vm._v("我的群")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openCreateGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("新建群")])]), _vm._v(" "), _c('div', {
    staticClass: "disk-group-search"
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "搜索群名称",
      "icon": "ios-search"
    },
    model: {
      value: (_vm.groupKeyword),
      callback: function($$v) {
        _vm.groupKeyword = $$v
      },
      expression: "groupKeyword"
    }
  })], 1), _vm._v(" "), (!_vm.groupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("暂无群")]) : (!_vm.filteredGroupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("没有匹配的群")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredGroupSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', 'disk-group-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-people"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "title": sp.node.name
      }
    }, [_vm._v(_vm._s(sp.node.name))])], 1)
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-main"
  }, [(_vm.inGroupSpace && _vm.activeGroup) ? _c('div', {
    staticClass: "disk-group-header"
  }, [_c('div', {
    staticClass: "disk-group-meta"
  }, [_c('strong', [_vm._v(_vm._s(_vm.activeGroup.name))]), _vm._v(" "), _c('span', [_vm._v("成员 " + _vm._s(_vm.activeGroup.memberCount || 0) + " 人")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.roleText(_vm.activeGroup.myRole)))]), _vm._v(" "), _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text",
      "icon": "ios-time"
    },
    on: {
      "click": _vm.openActivityPanel
    }
  }, [_vm._v("活动")]), _vm._v(" "), (_vm.isGroupManager) ? _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text",
      "icon": "ios-people"
    },
    on: {
      "click": _vm.openMemberManage
    }
  }, [_vm._v("成员管理")]) : _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text"
    },
    on: {
      "click": _vm.leaveGroup
    }
  }, [_vm._v("退群")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.inGroupSpace && _vm.activeGroup && Number(_vm.activeGroup.id) === 1) ? _c('disk-group-nav', {
    attrs: {
      "group-id": _vm.activeGroup.id,
      "root-node-id": _vm.activeGroup.rootNodeId || (_vm.activeSpace && _vm.activeSpace.node && _vm.activeSpace.node.id),
      "current-folder-id": _vm.currentFolder && _vm.currentFolder.id
    },
    on: {
      "open-target": _vm.onNavOpenTarget
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inRecycle),
      expression: "!inRecycle"
    }],
    staticClass: "disk-toolbar"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('input', {
    ref: "folderInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "webkitdirectory": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-cloud-upload",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.chooseUpload
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-folder",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.openMkdir
    }
  }, [_vm._v("新建文件夹")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-download",
      "disabled": !_vm.canDownload
    },
    on: {
      "click": _vm.downloadSelected
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-redo",
      "disabled": !_vm.canMove
    },
    on: {
      "click": _vm.openMoveSelected
    }
  }, [_vm._v("移动")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "share",
      "disabled": !_vm.canShare
    },
    on: {
      "click": function($event) {
        return _vm.openShare()
      }
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "key",
      "disabled": !_vm.canAcl
    },
    on: {
      "click": function($event) {
        return _vm.openAcl()
      }
    }
  }, [_vm._v("授权")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-trash",
      "disabled": !_vm.canDelete
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
    staticClass: "disk-search"
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "搜索当前目录及子目录",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Table', {
    class: _vm.inRecycle ? '' : 'disk-file-table',
    attrs: {
      "border": "",
      "highlight-row": "",
      "columns": _vm.displayColumns,
      "data": _vm.list,
      "loading": _vm.loading
    },
    on: {
      "on-selection-change": _vm.onSelectionChange,
      "on-current-change": _vm.onCurrentChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v(_vm._s(_vm.inRecycle ? '删除只移入回收站，云上的文件仍保留。这里可以恢复。' : '点文件名直接预览。可勾选多行后批量下载、移动、分享、授权、删除。名称后面的「操作」可打开、下载、预览、重命名、移动、复制、分享、授权、删除'))])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建文件夹",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMkdirModal),
      callback: function($$v) {
        _vm.showMkdirModal = $$v
      },
      expression: "showMkdirModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入文件夹名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onMkdir
    },
    model: {
      value: (_vm.mkdirName),
      callback: function($$v) {
        _vm.mkdirName = $$v
      },
      expression: "mkdirName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMkdirModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.mkdirLoading
    },
    on: {
      "click": _vm.onMkdir
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "重命名",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameModal),
      callback: function($$v) {
        _vm.showRenameModal = $$v
      },
      expression: "showRenameModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入新名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onRename
    },
    model: {
      value: (_vm.renameName),
      callback: function($$v) {
        _vm.renameName = $$v
      },
      expression: "renameName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameLoading
    },
    on: {
      "click": _vm.onRename
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.pickerMode === 'copy' ? '复制' : '移动',
      "width": "520",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMoveModal),
      callback: function($$v) {
        _vm.showMoveModal = $$v
      },
      expression: "showMoveModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.moveTitle))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.moveSpaces), function(sp) {
    return _c('Button', {
      key: sp.key,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.switchMoveSpace(sp)
        }
      }
    }, [_vm._v(_vm._s(sp.node.name))])
  }), 1), _vm._v(" "), _c('Breadcrumb', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.moveCrumbs), function(item, index) {
    return _c('Breadcrumb-item', {
      key: item.id
    }, [(index < _vm.moveCrumbs.length - 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.jumpMove(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), (_vm.moveFolderLoading) ? _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v("加载中...")]) : (!_vm.moveFolders.length) ? _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '该目录下没有文件夹。可以直接复制到此处。' : '该目录下没有文件夹。可以直接移动到此处。'))]) : _c('div', {
    staticClass: "disk-move-folders"
  }, _vm._l((_vm.moveFolders), function(folder) {
    return _c('div', {
      key: folder.id,
      staticClass: "disk-move-folder",
      on: {
        "click": function($event) {
          return _vm.enterMoveFolder(folder)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "folder"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(folder.name))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMoveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.moveSaving,
      "disabled": _vm.moveHereDisabled
    },
    on: {
      "click": _vm.confirmMove
    }
  }, [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '复制到此处' : '移动到此处'))])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": '预览 - ' + _vm.previewName,
      "width": "960"
    },
    on: {
      "on-visible-change": _vm.onPreviewVisible
    },
    model: {
      value: (_vm.showPreviewModal),
      callback: function($$v) {
        _vm.showPreviewModal = $$v
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "disk-preview",
    class: {
      'disk-preview-center': _vm.centerPreview
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("加载中...")]) : (_vm.previewError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v(_vm._s(_vm.previewError))]) : (_vm.previewType === 'image') ? _c('img', {
    staticClass: "disk-preview-image",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : (_vm.previewType === 'pdf') ? _c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.previewBlobUrl
    }
  }) : (_vm.previewType === 'video') ? [_c('video', {
    ref: "previewVideo",
    staticClass: "disk-preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'audio') ? [_c('audio', {
    ref: "previewAudio",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'office' && _vm.previewEngine === 'aliyun') ? [_c('div', {
    ref: "aliyunOffice",
    staticClass: "disk-preview-frame"
  })] : (_vm.previewType === 'office') ? [_c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.officeUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("若无法打开，请下载后查看")])] : (_vm.previewType === 'csv') ? [(_vm.previewEmpty) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("没有可预览的内容")]) : _c('div', {
    staticClass: "disk-preview-table-wrap"
  }, [_c('table', {
    staticClass: "disk-preview-table"
  }, [_c('tbody', _vm._l((_vm.previewRows), function(line, lineIndex) {
    return _c('tr', {
      key: lineIndex
    }, _vm._l((line), function(cell, cellIndex) {
      return _c('td', {
        key: cellIndex,
        class: {
          'disk-preview-th': lineIndex === 0
        }
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])])] : (_vm.previewType === 'markdown') ? _c('div', {
    staticClass: "disk-preview-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.previewHtml)
    }
  }) : (_vm.previewType === 'json') ? [(_vm.jsonError) ? _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("不是合法 JSON")]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))])] : (_vm.previewType === 'text') ? _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))]) : _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.previewDownloadId)
      }
    }
  }, [_vm._v("下载")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "授权",
      "width": "860"
    },
    model: {
      value: (_vm.showAclModal),
      callback: function($$v) {
        _vm.showAclModal = $$v
      },
      expression: "showAclModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.aclTitle))]), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-form"
  }, [_c('Select', {
    staticStyle: {
      "width": "110px"
    },
    on: {
      "on-change": _vm.onSubjectTypeChange
    },
    model: {
      value: (_vm.aclForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectType", $$v)
      },
      expression: "aclForm.subjectType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("权限组")])], 1), _vm._v(" "), (_vm.aclForm.subjectType === 1) ? [_c('Select', {
    key: 'acl-users-' + _vm.adminUserSelectKey,
    staticStyle: {
      "width": "280px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "disabled": _vm.adminUserLoading,
      "placeholder": "选择员工"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.aclAdminUsers), function(user) {
    return _c('Option', {
      key: user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n            " + _vm._s(_vm.userLabel(user)) + "\n          ")])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": _vm.adminUserLoading || !_vm.aclAdminUsers.length
    },
    on: {
      "click": _vm.selectAllUsers
    }
  }, [_vm._v("全选全部员工")])] : [_c('Select', {
    key: 'acl-groups-' + _vm.adminGroupSelectKey,
    staticStyle: {
      "width": "280px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "disabled": _vm.adminGroupLoading,
      "placeholder": "选择权限组"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v(_vm._s(group.title))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": _vm.adminGroupLoading || !_vm.adminGroups.length
    },
    on: {
      "click": _vm.selectAllGroups
    }
  }, [_vm._v("全选全部权限组")])], _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.aclSaving
    },
    on: {
      "click": _vm.saveAcl
    }
  }, [_vm._v("保存")])], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-perm"
  }, [_c('span', {
    staticClass: "disk-acl-perm-label"
  }, [_vm._v("权限")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.aclForm.permBits),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "permBits", $$v)
      },
      expression: "aclForm.permBits"
    }
  }, _vm._l((_vm.permOptions), function(item) {
    return _c('Checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), (_vm.aclNodes.length <= 1) ? _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.aclColumns,
      "data": _vm.aclList,
      "loading": _vm.aclLoading
    }
  }) : _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v("保存后，同样的授权会写到每一个选中项。")])], 1), _vm._v(" "), _c('Modal', {
    staticClass: "disk-share-modal",
    attrs: {
      "title": "分享",
      "width": "1100"
    },
    model: {
      value: (_vm.showShareModal),
      callback: function($$v) {
        _vm.showShareModal = $$v
      },
      expression: "showShareModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.shareTitle))]), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.shareForm.expireType),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "expireType", $$v)
      },
      expression: "shareForm.expireType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("1天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v("7天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "30"
    }
  }, [_vm._v("30天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("自定义时间")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "forever"
    }
  }, [_vm._v("永久")])], 1)], 1), _vm._v(" "), (_vm.shareForm.expireType === 'custom') ? _c('FormItem', {
    attrs: {
      "label": "到期时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择到期时间",
      "value": _vm.shareForm.customExpireDate
    },
    on: {
      "on-change": _vm.onCustomExpire
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "提取码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "maxlength": 4,
      "placeholder": "4位提取码，可空"
    },
    model: {
      value: (_vm.shareForm.extractCode),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "extractCode", $$v)
      },
      expression: "shareForm.extractCode"
    }
  })], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.shareSaving
    },
    on: {
      "click": _vm.createShare
    }
  }, [_vm._v("生成链接")]), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.shareColumns,
      "data": _vm.shareList
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "详细记录",
      "width": "720"
    },
    model: {
      value: (_vm.showShareLogModal),
      callback: function($$v) {
        _vm.showShareLogModal = $$v
      },
      expression: "showShareLogModal"
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.shareLogColumns,
      "data": _vm.shareLogList,
      "loading": _vm.shareLogLoading,
      "no-data-text": "还没有预览或下载"
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "上传文件",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showUploadModal),
      callback: function($$v) {
        _vm.showUploadModal = $$v
      },
      expression: "showUploadModal"
    }
  }, [_c('div', {
    staticClass: "disk-upload-target"
  }, [_vm._v("上传到：" + _vm._s(_vm.currentFolder ? _vm.currentFolder.name : '当前目录'))]), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-target"
  }, [_c('span', [_vm._v("同名是否覆盖")]), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.overwriteSame),
      callback: function($$v) {
        _vm.overwriteSame = $$v
      },
      expression: "overwriteSame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-label"
  }, [_vm._v("待上传文件")]), _vm._v(" "), _c('div', {
    staticClass: "disk-drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDropFiles.apply(null, arguments)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload",
      "size": "36"
    }
  }), _vm._v(" "), _c('p', [_vm._v("将目录或多个文件拖拽到此进行扫描")]), _vm._v(" "), _c('div', [_c('Button', {
    on: {
      "click": _vm.pickFiles
    }
  }, [_vm._v("扫描文件")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.pickFolder
    }
  }, [_vm._v("扫描文件夹")])], 1), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("文件命名规范：1.使用 UTF-8 编码 2.区分大小写 3.长度必须在 1~1023 字节之间 4. 不能以 / 或者 \\ 字符开头")]), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("文件上传提示：待上传列表最多允许添加 10000 个文件，超出部分被丢弃，如果要完整上传，请将文件打包成 Zip 包，上传后解压。")]), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("扫描只加入待上传列表，不会上传。点下方「上传文件」后才开始。同名是否覆盖默认关闭。关闭时同名文件会另存为「主名.1.0.后缀」，已有 1.x 则次版本加 1。打开后原文件会被彻底删除，不进回收站，再用同名上传新文件。同名文件夹仍直接使用。")])], 1), _vm._v(" "), (_vm.scanning) ? _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("正在扫描，已读取 " + _vm._s(_vm.scanCount) + " 个文件…")]) : _vm._e(), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.uploadColumns,
      "data": _vm.uploadPageRows,
      "no-data-text": "没有文件或文件夹"
    }
  }), _vm._v(" "), (_vm.uploadTotal) ? _c('div', {
    staticClass: "disk-upload-page"
  }, [_c('span', [_vm._v("共 " + _vm._s(_vm.uploadTotal) + " 个")]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.uploadTotal,
      "page-size": _vm.uploadPageSize,
      "current": _vm.uploadPage,
      "size": "small"
    },
    on: {
      "on-change": _vm.onUploadPage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canBeginUpload,
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.beginUpload
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        _vm.showUploadModal = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), (_vm.activityPanelOpen) ? _c('div', {
    staticClass: "disk-activity-drawer"
  }, [_c('div', {
    staticClass: "disk-activity-head"
  }, [_c('span', [_vm._v("群动态")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.activityPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.activityLoading && !_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (!_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("暂无群动态")]) : _c('div', {
    staticClass: "disk-activity-body",
    on: {
      "scroll": _vm.onActivityScroll
    }
  }, [_vm._l((_vm.activityGroups), function(g) {
    return _c('div', {
      key: g.day,
      staticClass: "disk-activity-day"
    }, [_c('div', {
      staticClass: "disk-activity-day-label"
    }, [_vm._v(_vm._s(g.label))]), _vm._v(" "), _vm._l((g.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "disk-activity-card"
      }, [_c('div', {
        staticClass: "disk-activity-dot"
      }), _vm._v(" "), _c('div', {
        staticClass: "disk-activity-card-main"
      }, [_c('div', {
        staticClass: "disk-activity-card-top"
      }, [_c('strong', [_vm._v(_vm._s(item.actorName || '成员'))]), _vm._v(" "), _c('span', {
        staticClass: "disk-activity-time"
      }, [_vm._v(_vm._s(_vm.formatActivityTime(item.gmtCreate)))])]), _vm._v(" "), _c('div', {
        staticClass: "disk-activity-summary"
      }, [_vm._v(_vm._s(item.summary))])])])
    })], 2)
  }), _vm._v(" "), (_vm.activityLoading) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (_vm.activityNoMore && _vm.activityList.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("没有更多了")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-float",
    class: {
      open: _vm.taskPanelOpen
    }
  }, [(_vm.taskPanelOpen) ? _c('div', {
    staticClass: "disk-task-panel"
  }, [_c('div', {
    staticClass: "disk-task-head"
  }, [_c('span', [_vm._v("任务列表")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.showTaskOverall) ? _c('div', {
    staticClass: "disk-task-overall"
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.taskOverallPercent,
      "stroke-width": 8
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-task-overall-text"
  }, [_vm._v("\n          已传 " + _vm._s(_vm.formatSize(_vm.taskOverallDone)) + " / 共 " + _vm._s(_vm.formatSize(_vm.taskOverallTotal)) + "（" + _vm._s(_vm.taskOverallPercent) + "%）\n          "), _c('span', {
    staticClass: "disk-task-speed"
  }, [_vm._v(_vm._s(_vm.formatSpeed(_vm.taskSpeedBps)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-note"
  }, [_vm._v("刷新或关闭浏览器会取消当前上传任务，并清除全部记录。")]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-filters"
  }, _vm._l((_vm.taskTabs), function(tab) {
    return _c('a', {
      key: tab.key,
      class: {
        on: _vm.taskFilter === tab.key
      },
      on: {
        "click": function($event) {
          _vm.taskFilter = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.label) + "(" + _vm._s(tab.count) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tools"
  }, [_c('span', {
    staticClass: "disk-task-concurrency"
  }, [_vm._v("\n          并发：智能\n          "), (_vm.uploadAutoHint) ? _c('span', {
    staticClass: "disk-upload-auto-hint"
  }, [_vm._v(_vm._s(_vm.uploadAutoHint))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tool-btns"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.taskUploadingCount
    },
    on: {
      "click": _vm.stopUploads
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskResumableCount || _vm.uploading
    },
    on: {
      "click": _vm.startAllUploads
    }
  }, [_vm._v("全部开始")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskRemovableCount
    },
    on: {
      "click": _vm.clearAllTasks
    }
  }, [_vm._v("全部移除")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.taskView.length) ? _c('div', {
    staticClass: "disk-task-empty"
  }, [_vm._v("暂无上传任务")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskView), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-task-row"
    }, [_c('div', [_c('div', {
      staticClass: "disk-task-name",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-size"
    }, [_vm._v(_vm._s(_vm.formatSize(item.size)))]), _vm._v(" "), (_vm.taskFilter === 'uploading' && item.state === 'uploading') ? _c('Progress', {
      attrs: {
        "percent": item.percent,
        "stroke-width": 6
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "disk-task-dest",
      attrs: {
        "title": item.dest
      }
    }, [_vm._v(_vm._s(item.dest || '/'))]), _vm._v(" "), _c('div', {
      class: ['disk-task-state', item.state],
      attrs: {
        "title": item.failMsg || item.stateLabel
      }
    }, [_vm._v(_vm._s(item.stateLabel))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-ops"
    }, [(item.state === 'uploading') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.pauseUpload(item)
        }
      }
    }, [_vm._v("暂停")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.continueUpload(item)
        }
      }
    }, [_vm._v("继续上传")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed' || item.state === 'success') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.clearTask(item)
        }
      }
    }, [_vm._v("移除")]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-bar",
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = !_vm.taskPanelOpen
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("任务列表")]), _vm._v(" "), (_vm.taskBadge) ? _c('span', {
    staticClass: "disk-task-badge"
  }, [_vm._v(_vm._s(_vm.taskBadge))]) : _vm._e()], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建群",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showCreateGroupModal),
      callback: function($$v) {
        _vm.showCreateGroupModal = $$v
      },
      expression: "showCreateGroupModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入群名称",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onCreateGroup
    },
    model: {
      value: (_vm.createGroupName),
      callback: function($$v) {
        _vm.createGroupName = $$v
      },
      expression: "createGroupName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showCreateGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.createGroupLoading
    },
    on: {
      "click": _vm.onCreateGroup
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "成员管理",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMemberModal),
      callback: function($$v) {
        _vm.showMemberModal = $$v
      },
      expression: "showMemberModal"
    }
  }, [(_vm.activeGroup) ? _c('div', {
    staticClass: "disk-member-toolbar"
  }, [_c('Select', {
    staticStyle: {
      "width": "110px"
    },
    on: {
      "on-change": function($event) {
        _vm.memberForm.subjectIds = []
      }
    },
    model: {
      value: (_vm.memberForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectType", $$v)
      },
      expression: "memberForm.subjectType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("账号组")])], 1), _vm._v(" "), (_vm.memberForm.subjectType === 1) ? _c('Select', {
    staticStyle: {
      "width": "320px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "placeholder": "选择员工"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminUsers), function(user) {
    return _c('Option', {
      key: 'mu-' + user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n          " + _vm._s(_vm.userLabel(user)) + "\n        ")])
  }), 1) : _c('Select', {
    staticStyle: {
      "width": "320px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "placeholder": "选择账号组"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: 'mg-' + group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v("\n          " + _vm._s(group.title) + "\n        ")])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.memberSaving
    },
    on: {
      "click": _vm.addGroupMembers
    }
  }, [_vm._v("添加")]), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openRenameGroup
    }
  }, [_vm._v("改名")]) : _vm._e(), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openTransferGroup
    }
  }, [_vm._v("转让群主")]) : _vm._e(), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.dissolveGroup
    }
  }, [_vm._v("解散群")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.memberColumns,
      "data": _vm.memberList,
      "loading": _vm.memberLoading
    },
    on: {
      "on-expand": _vm.onMemberExpand
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMemberModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "群改名",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameGroupModal),
      callback: function($$v) {
        _vm.showRenameGroupModal = $$v
      },
      expression: "showRenameGroupModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入新群名称",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onRenameGroup
    },
    model: {
      value: (_vm.renameGroupName),
      callback: function($$v) {
        _vm.renameGroupName = $$v
      },
      expression: "renameGroupName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameGroupLoading
    },
    on: {
      "click": _vm.onRenameGroup
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "转让群主",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showTransferModal),
      callback: function($$v) {
        _vm.showTransferModal = $$v
      },
      expression: "showTransferModal"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "选择新群主（须已是群成员）"
    },
    model: {
      value: (_vm.transferOwnerId),
      callback: function($$v) {
        _vm.transferOwnerId = $$v
      },
      expression: "transferOwnerId"
    }
  }, _vm._l((_vm.personMembers), function(m) {
    return _c('Option', {
      key: 'tr-' + m.subjectId,
      attrs: {
        "value": m.subjectId,
        "label": m.subjectName
      }
    }, [_vm._v("\n        " + _vm._s(m.subjectName) + "（" + _vm._s(_vm.roleText(m.role)) + "）\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showTransferModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.transferLoading
    },
    on: {
      "click": _vm.onTransferGroup
    }
  }, [_vm._v("确定转让")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-task-cols"
  }, [_c('span', [_vm._v("文件")]), _vm._v(" "), _c('span', [_vm._v("上传到")]), _vm._v(" "), _c('span', [_vm._v("状态")]), _vm._v(" "), _c('span', [_vm._v("操作")])])
}]}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("实测统计")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题库"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择题库"
    },
    model: {
      value: (_vm.bank),
      callback: function($$v) {
        _vm.bank = $$v
      },
      expression: "bank"
    }
  }, [_c('Option', {
    attrs: {
      "value": "comp"
    }
  }, [_vm._v("综合")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "speak"
    }
  }, [_vm._v("口语")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-VR-Q001"
    },
    model: {
      value: (_vm.queryParam.businessCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "businessCode", $$v)
      },
      expression: "queryParam.businessCode"
    }
  })], 1)], 1), _vm._v(" "), (_vm.bank === 'comp') ? _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择技能"
    },
    model: {
      value: (_vm.queryParam.skill),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "skill", $$v)
      },
      expression: "queryParam.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": _vm.listUrl,
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "修改分数"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.attendanceRowThis,
      "model": _vm.attendanceRowThis
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.createMonth),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "createMonth", $$v)
      },
      expression: "attendanceRowThis.createMonth"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.lessonTime),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "lessonTime", $$v)
      },
      expression: "attendanceRowThis.lessonTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.tchName),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "tchName", $$v)
      },
      expression: "attendanceRowThis.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "请打分"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.attendanceRowThis.score),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "score", $$v)
      },
      expression: "attendanceRowThis.score"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lm-win",
    class: {
      'lm-win-max': _vm.win.maximized
    },
    style: (_vm.winStyle),
    on: {
      "mousedown": _vm.onFocus
    }
  }, [_c('div', {
    staticClass: "lm-title",
    on: {
      "mouseenter": _vm.showTitleTip,
      "mouseleave": _vm.hideTitleTip,
      "click": _vm.showTitleTip
    }
  }, [_c('div', {
    staticClass: "lm-title-text"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "lm-title-actions"
  }, [(_vm.win.lesson.liveUrl) ? _c('Button', {
    attrs: {
      "size": "small",
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onOpenExternal.apply(null, arguments)
      }
    }
  }, [_vm._v("新窗口打开")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipVisible),
      expression: "tipVisible"
    }],
    staticClass: "lm-title-tip",
    style: (_vm.tipStyle),
    on: {
      "mouseenter": _vm.showTitleTip,
      "mouseleave": _vm.hideTitleTip
    }
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "lm-body",
    on: {
      "click": _vm.onBodyClick
    }
  }, [(_vm.win.playing) ? _c('video', {
    ref: "player",
    staticClass: "lm-video",
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "controls": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('div', {
    staticClass: "lm-placeholder"
  }, [_vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("课程顾问跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配名单详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.nickName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickName", $$v)
      },
      expression: "queryParam.nickName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "label-width": 75
    }
  }, [_c('channel-select', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userList/getAssignDetails",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("\n    官网:" + _vm._s(_vm.assignNum.pcNum) + "\n    移动:" + _vm._s(_vm.assignNum.mobileNum) + "\n    在线咨询:" + _vm._s(_vm.assignNum.onlineAskNum) + "\n    来电咨询:" + _vm._s(_vm.assignNum.telAskNum) + "\n    二维码转介绍:" + _vm._s(_vm.assignNum.qrNum) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("业绩统计")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "lable-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID：",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "stuId",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道："
    }
  }, [_c('channel-select', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "签约渠道："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", $$v)
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.orderChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adviserName",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人ID：",
      "prop": "recommendId"
    }
  }, [_c('Input', {
    attrs: {
      "name": "recommendId",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.recommendId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recommendId", $$v)
      },
      expression: "queryParam.recommendId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人学导：",
      "prop": "recommendName"
    }
  }, [_c('Input', {
    attrs: {
      "name": "recommendName",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.recommendName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recommendName", $$v)
      },
      expression: "queryParam.recommendName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款方式："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.payWay),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "payWay", $$v)
      },
      expression: "queryParam.payWay"
    }
  }, _vm._l((_vm.$constant.payWay2), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否到账："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isReceive),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isReceive", $$v)
      },
      expression: "queryParam.isReceive"
    }
  }, _vm._l((_vm.$constant.isReceive), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代理订单："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.agentOrder),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "agentOrder", $$v)
      },
      expression: "queryParam.agentOrder"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "签单人："
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminName", $$v)
      },
      expression: "queryParam.adminName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "部门："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.depmId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "depmId", $$v)
      },
      expression: "queryParam.depmId"
    }
  }, _vm._l((_vm.$constant.department), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "团队："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.teamType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "teamType", _vm._n($$v))
      },
      expression: "queryParam.teamType"
    }
  }, _vm._l((_vm.$constant.adviserGroup), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('Input', {
    attrs: {
      "name": "studyAdviser",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.studyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviser", $$v)
      },
      expression: "queryParam.studyAdviser"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单ID："
    }
  }, [_c('Input', {
    attrs: {
      "name": "orderId",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "orderId", $$v)
      },
      expression: "queryParam.orderId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "第三方付款码："
    }
  }, [_c('Input', {
    attrs: {
      "name": "orderCode",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.orderCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "orderCode", $$v)
      },
      expression: "queryParam.orderCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到账方式："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.receiveType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "receiveType", $$v)
      },
      expression: "queryParam.receiveType"
    }
  }, _vm._l((_vm.$constant.payWay2), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.regStartTimeChange
    },
    model: {
      value: (_vm.regStartTime),
      callback: function($$v) {
        _vm.regStartTime = $$v
      },
      expression: "regStartTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v("-")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.regEndTimeChange
    },
    model: {
      value: (_vm.regEndTime),
      callback: function($$v) {
        _vm.regEndTime = $$v
      },
      expression: "regEndTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.refundStartTimeChange
    },
    model: {
      value: (_vm.refundStartTime),
      callback: function($$v) {
        _vm.refundStartTime = $$v
      },
      expression: "refundStartTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v("-")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.refundEndTimeChange
    },
    model: {
      value: (_vm.refundEndTime),
      callback: function($$v) {
        _vm.refundEndTime = $$v
      },
      expression: "refundEndTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间",
      "value": _vm.queryParam.payStartTimeDate
    },
    on: {
      "on-change": _vm.payStartTimeChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v("-")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.payEndTimeChange
    },
    model: {
      value: (_vm.payEndTime),
      callback: function($$v) {
        _vm.payEndTime = $$v
      },
      expression: "payEndTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", _vm._n($$v))
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('535'),
      expression: "'535'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "height": 710,
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/performance/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection,
      "operator": ""
    }
  }), _vm._v(" "), _c('performance-model', {
    ref: "tmodal",
    attrs: {
      "value": _vm.showEditPerfModel,
      "isEditisReceive": _vm.isEditisReceive,
      "pData": _vm.pData,
      "successCallback": _vm.search,
      "formData": _vm.formData
    },
    on: {
      "on-close": function($event) {
        _vm.showEditPerfModel = false
      }
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加买断时间",
      "width": 600
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择买断时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期"
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "timeListForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "19"
      }
    }, [_c('label', [_c('b', [_vm._v("时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,    生效日期：" + _vm._s(item.useDateStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("添加")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Course Report",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one： Class Performance(minimum 2 stars, maximum 5 stars)  :")]), _vm._v(" "), _c('Form', {
    ref: "formData",
    staticClass: "feedback form regluarForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Focus："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate1),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate1", $$v)
      },
      expression: "formData.rate1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Speaking Frequency："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate2", $$v)
      },
      expression: "formData.rate2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Listening Comprehension Accuracy："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate3),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate3", $$v)
      },
      expression: "formData.rate3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Fluency and Cohisence："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate4),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate4", $$v)
      },
      expression: "formData.rate4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Connection and Device："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate5),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate5", $$v)
      },
      expression: "formData.rate5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Classroom Environment："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate6),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate6", $$v)
      },
      expression: "formData.rate6"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two: Teacher's Feedback(at least 30 words)  :")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.parent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "parent", $$v)
      },
      expression: "formData.parent"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.remark))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("订单列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "class-name": "statistics"
    }
  }, [_c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n            筛选实付金额: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalPayment))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n            筛选金额: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalAmount))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n            筛选折扣: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalDiscount))])])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.startCreateDate
    },
    on: {
      "on-change": _vm.startCreateDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.endCreateDate
    },
    on: {
      "on-change": _vm.endCreateDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.startTimeDate
    },
    on: {
      "on-change": _vm.startTimeDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.endTimeDate
    },
    on: {
      "on-change": _vm.endTimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.creatorId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "creatorId", $$v)
      },
      expression: "queryParam.creatorId"
    }
  }, _vm._l((_vm.adminUser), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.auditId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditId", $$v)
      },
      expression: "queryParam.auditId"
    }
  }, _vm._l((_vm.adminUserAudit), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditStatus", $$v)
      },
      expression: "queryParam.auditStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未审核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已审核")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.stateList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stateList", $$v)
      },
      expression: "queryParam.stateList"
    }
  }, [_c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("订单已添加")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待支付")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("支付成功")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      ":xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单号",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "orderId", $$v)
      },
      expression: "queryParam.orderId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channelList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channelList", $$v)
      },
      expression: "queryParam.channelList"
    }
  }, _vm._l((_vm.$constant.orderChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "套餐"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.coursePackageList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "coursePackageList", $$v)
      },
      expression: "queryParam.coursePackageList"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1-20"
    }
  }, [_vm._v("欧美20")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-40"
    }
  }, [_vm._v("欧美40")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-50"
    }
  }, [_vm._v("欧美50")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-72"
    }
  }, [_vm._v("欧美72")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-110"
    }
  }, [_vm._v("欧美110")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-144"
    }
  }, [_vm._v("欧美144")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-210"
    }
  }, [_vm._v("欧美210")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-60"
    }
  }, [_vm._v("菲教60")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-100"
    }
  }, [_vm._v("菲教100")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-320"
    }
  }, [_vm._v("菲教320")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-630"
    }
  }, [_vm._v("菲教630")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12,
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addModal = true
      }
    }
  }, [_vm._v("添加订单")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.showAddOtherButton
    },
    on: {
      "click": function($event) {
        _vm.addOtherModal = true
      }
    }
  }, [_vm._v("添加补升订单")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('713'),
      expression: "'713'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "height": 680,
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/fundPackage/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection,
      "operator": ""
    },
    on: {
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('add-order-modal', {
    attrs: {
      "value": _vm.addModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addModal = false
      }
    }
  }), _vm._v(" "), _c('edit-order-modal', {
    attrs: {
      "value": _vm.editModal,
      "fundData": _vm.editData,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.editModal = false
      }
    }
  }), _vm._v(" "), _c('add-other-order-modal', {
    attrs: {
      "value": _vm.addOtherModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addOtherModal = false
      }
    }
  }), _vm._v(" "), _c('add-voucher-modal', {
    attrs: {
      "value": _vm.addVoucherModal,
      "data": _vm.editData,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addVoucherModal = false
      }
    }
  }), _vm._v(" "), _c('order-gift-modal', {
    attrs: {
      "value": _vm.giftModal,
      "order-id": _vm.giftOrderId
    },
    on: {
      "on-close": function($event) {
        _vm.giftModal = false
      }
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('OrderClassHourModal', {
    attrs: {
      "totalNum": _vm.totalNum,
      "fundPackageId": _vm.fundPackageId,
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showOrderClassHourModal),
      callback: function($$v) {
        _vm.showOrderClassHourModal = $$v
      },
      expression: "showOrderClassHourModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal",
    attrs: {
      "title": "编辑订单信息",
      "width": "1200"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData
    }
  }, [(_vm.isEditisReceive) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到帐方式：",
      "prop": "receiveType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.receiveType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "receiveType", _vm._n($$v))
      },
      expression: "formData.receiveType"
    }
  }, _vm._l((_vm.$constant.receiveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到帐金额：",
      "prop": "money"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.money),
      callback: function($$v) {
        _vm.$set(_vm.formData, "money", _vm._n($$v))
      },
      expression: "formData.money"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到账时间：",
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.pData.time),
      callback: function($$v) {
        _vm.$set(_vm.pData, "time", _vm._n($$v))
      },
      expression: "pData.time"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注：",
      "prop": "remark"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isEditisReceive) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票时间：",
      "prop": "invoiceTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeInvoiceTime
    },
    model: {
      value: (_vm.pData.invoiceTime),
      callback: function($$v) {
        _vm.$set(_vm.pData, "invoiceTime", _vm._n($$v))
      },
      expression: "pData.invoiceTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票金额：",
      "prop": "invoiceMoney"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.invoiceMoney),
      callback: function($$v) {
        _vm.$set(_vm.formData, "invoiceMoney", _vm._n($$v))
      },
      expression: "formData.invoiceMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退票冲红：",
      "prop": "isRushRed"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.isRushRed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isRushRed", _vm._n($$v))
      },
      expression: "formData.isRushRed"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款金额：",
      "prop": "refundMoney"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundMoney),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundMoney", _vm._n($$v))
      },
      expression: "formData.refundMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款时间：",
      "prop": "refundTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeRefundTime
    },
    model: {
      value: (_vm.pData.refundTime),
      callback: function($$v) {
        _vm.$set(_vm.pData, "refundTime", _vm._n($$v))
      },
      expression: "pData.refundTime"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "指标口径",
      "tags": ['口径说明', '先对齐定义再看图'],
      "chips": _vm.chips,
      "loaded-at": "静态说明，随口径版本更新"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("这几条决定了看板上每个数字怎么算、为什么这么算。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.baseRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("「影响总览」「学生异动影响」两页的事件、波及和事件后结果口径。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.eventRows), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: row.badge
    }, [_vm._v(_vm._s(row.label))])]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.source))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.date))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.notice))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("离职老师生效日为空不进统计；通知天数小于 0 记 0。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.changeRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("「请假/旷课影响」「学生影响明细」「综合风险视图」三页的口径。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.leaveRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.studentRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("一期已按下面的「当前处理」上线，业务拍板后再调整。")]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.pendingRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name wrap"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.now))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.todo))])])
  }), 0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心设计原则")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("1. 三类事件统一归到「换老师」，不拆链路。")]), _vm._v("离职、淘汰、关闭时间对学生的结果一样——原来那位老师上不了了，得换人。敞口口径统一为未消课时；类型之间的差异只落在"), _c('b', [_vm._v("波及范围")]), _vm._v("（离职 / 淘汰按老师全部学生，关闭时间只看原时段落在关闭区间的学生）和"), _c('b', [_vm._v("通知窗口")]), _vm._v("上。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v("2. 学生是归因主键，不是老师。")]), _vm._v("一个学生可能同时被多位老师波及，按老师计数会重复。窗口内同一学生被多起事件波及，只归因到生效日最早的一起，其余计「重复受影响」。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-danger"
  }, [_c('b', [_vm._v("3. 真正的分水岭是保时换还是改时换。")]), _vm._v("同样换老师，保住原时段和被迫改时间的 30 天留存差距，比「属于哪种异动类型」更能解释留存。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-healthy"
  }, [_c('b', [_vm._v("4. 结果指标必须带对照组。")]), _vm._v("异动后 30 天留存单独看没有意义，要和同期未被波及的活跃学生比，差值才是真实影响。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("5. 3 小时内不代课，这个窗口单独看。")]), _vm._v("3 小时内的课节不安排代课，不能和 3 小时外混在一起看代课率，否则整体指标会被 3 小时外拉平，看不出无人兜底的那部分。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("范围与基础口径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("项")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("异动事件与波及学生")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("三类异动事件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("类型")]), _c('th', [_vm._v("来源")]), _c('th', [_vm._v("生效日")]), _c('th', [_vm._v("通知天数")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("波及与事件后结果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("请假 / 旷课与学生汇总")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("请假 / 旷课（课节维度）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生事件、状态与风险分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("待确认口径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("问题")]), _c('th', [_vm._v("当前处理")]), _c('th', [_vm._v("待拍板")])])])
}]}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1100px",
      "margin": "auto",
      "white-space": "pre",
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "preview-select",
    domProps: {
      "innerHTML": _vm._s(_vm.data)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-header"
  }, [_c('nav', {
    staticClass: "preview-header-wrapper preview-navbar preview-navbar-default preview-navbar-fixed-top"
  }, [_c('div', {
    staticClass: "preview-header-content container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 logo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "hellokid"
    }
  })])])])])])])
}]}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加渠道"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createChannelForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.channelRules,
      "model": _vm.createChannelParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道名称：",
      "prop": "channelName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.createChannelParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelName", $$v)
      },
      expression: "createChannelParams.channelName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "获客终端：",
      "prop": "channelType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createChannelParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelType", $$v)
      },
      expression: "createChannelParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道分类：",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createChannelParams.type),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "type", $$v)
      },
      expression: "createChannelParams.type"
    }
  }, _vm._l((_vm.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道参数：",
      "prop": "channelParam"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道参数"
    },
    model: {
      value: (_vm.createChannelParams.channelParam),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelParam", $$v)
      },
      expression: "createChannelParams.channelParam"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.createChannelParams.status),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "status", $$v)
      },
      expression: "createChannelParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.createChannelParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "tchChannel", $$v)
      },
      expression: "createChannelParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道描述："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入渠道描述"
    },
    model: {
      value: (_vm.createChannelParams.description),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "description", $$v)
      },
      expression: "createChannelParams.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "市场专员"
    }
  }, [_c('AdminUserMultSelect', {
    attrs: {
      "status": 1,
      "adminGroupCode": "marketGroup"
    },
    model: {
      value: (_vm.createChannelParams.adminUserIds),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "adminUserIds", $$v)
      },
      expression: "createChannelParams.adminUserIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.createNewChannel
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配学习导师"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + " - " + item.nickname) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "userStudyAdviser",
      "needDefaultStudyAdviser": "0",
      "transfer": ""
    },
    model: {
      value: (_vm.adviserParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "studyAdviserId", $$v)
      },
      expression: "adviserParam.studyAdviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配原因",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.adviserParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "reason", $$v)
      },
      expression: "adviserParam.reason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新生分配")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("离职原因")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("投诉属实更换班主任")]), _vm._v(" "), _c('Option', {
    key: "5",
    attrs: {
      "value": "5"
    }
  }, [_vm._v("无效投诉更换班主任 ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("ClassIn临时账号")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookClassin/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection,
      "operator": ""
    }
  }), _vm._v(" "), _c('ResetPassWordModal', {
    attrs: {
      "classinAccout": _vm.formData.classinAccout,
      "value": _vm.resetModal
    },
    on: {
      "on-close": function($event) {
        _vm.resetModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v(_vm._s(_vm.groupName))]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v(_vm._s(_vm.title))])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("\n    本模块为后台本地维护，不与钉钉同步；新增/修改仅落本地库。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "员工/标题"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": '暂无' + _vm.title + '记录'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": (_vm.form.id ? '编辑' : '新增') + _vm.title
    },
    on: {
      "on-ok": _vm.save
    },
    model: {
      value: (_vm.showForm),
      callback: function($$v) {
        _vm.showForm = $$v
      },
      expression: "showForm"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "处理投诉"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.complaintRowThis,
      "model": _vm.complaintRowThis,
      "rules": _vm.ruleSalary
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "投诉理由",
      "prop": "remark"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": ""
    },
    on: {
      "on-change": _vm.changeRemark
    },
    model: {
      value: (_vm.complaintRowThis.remark),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "remark", $$v)
      },
      expression: "complaintRowThis.remark"
    }
  }, _vm._l((_vm.$constant.tchComplaintRemark), function(item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "学生赠送课时",
      "prop": "stdNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.complaintRowThis.stdNum),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "stdNum", $$v)
      },
      expression: "complaintRowThis.stdNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师课耗",
      "prop": "subSalary"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.complaintRowThis.subSalary),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "subSalary", $$v)
      },
      expression: "complaintRowThis.subSalary"
    }
  }, _vm._l((this.subSalaryEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师额外扣除($)",
      "prop": "tchNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.complaintRowThis.tchNum),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "tchNum", $$v)
      },
      expression: "complaintRowThis.tchNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "处理意见",
      "prop": "doRemark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入处理意见:警告"
    },
    model: {
      value: (_vm.complaintRowThis.doRemark),
      callback: function($$v) {
        _vm.$set(_vm.complaintRowThis, "doRemark", $$v)
      },
      expression: "complaintRowThis.doRemark"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("英语能力信息列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "能力信息："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入能力信息"
    },
    model: {
      value: (_vm.ability),
      callback: function($$v) {
        _vm.ability = $$v
      },
      expression: "ability"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "关联等级："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.aa),
      callback: function($$v) {
        _vm.aa = $$v
      },
      expression: "aa"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showCreateAbilityModal = true
      }
    }
  }, [_vm._v("添加能力信息")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "",
      "params": _vm.queryParams,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑能力信息"
    },
    model: {
      value: (_vm.showUpdateAbilityModal),
      callback: function($$v) {
        _vm.showUpdateAbilityModal = $$v
      },
      expression: "showUpdateAbilityModal"
    }
  }, [_c('Form', {
    ref: "updateTemplateForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.Rules,
      "model": _vm.updateAbilityParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "能力信息名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入能力信息名称"
    },
    model: {
      value: (_vm.updateAbilityParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updateAbilityParams, "name", $$v)
      },
      expression: "updateAbilityParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "对应等级：",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择关联等级"
    },
    model: {
      value: (_vm.updateAbilityParams.type),
      callback: function($$v) {
        _vm.$set(_vm.updateAbilityParams, "type", $$v)
      },
      expression: "updateAbilityParams.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "video"
    }
  }, [_vm._v("录音题")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "read"
    }
  }, [_vm._v("阅读理解")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("听力题")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateAbilityModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("离职外教")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试听权限："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isAudition", _vm._n($$v))
      },
      expression: "queryParam.isAudition"
    }
  }, [_c('Option', {
    attrs: {
      "value": "y"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "n"
    }
  }, [_vm._v("无")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "临时约课权限："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tempSchedule),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tempSchedule", _vm._n($$v))
      },
      expression: "queryParam.tempSchedule"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("无")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("陪练")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否允许绑定："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isCanBound", _vm._n($$v))
      },
      expression: "queryParam.isCanBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), (this.tchTagPermission) ? _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标签："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchTags),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchTags", $$v)
      },
      expression: "queryParam.tchTags"
    }
  }, _vm._l((_vm.$constant.tchTags), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开课时间:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "离职日期"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.queryParam.linkStartTimeDate,
      "format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "开始至今",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.lastWorkDayStartChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadLeaveTemplate
    }
  }, [_vm._v("下载请假模板")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadLeaveTemplate
    }
  }, [_vm._v("上传请假文件")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/resigned/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('ExportLeaveModal', {
    model: {
      value: (_vm.showExportLeaveModal),
      callback: function($$v) {
        _vm.showExportLeaveModal = $$v
      },
      expression: "showExportLeaveModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showStuList": true,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑标签"
    },
    model: {
      value: (_vm.showEditTagsModal),
      callback: function($$v) {
        _vm.showEditTagsModal = $$v
      },
      expression: "showEditTagsModal"
    }
  }, [_c('Form', {
    ref: "form1",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (this.tchTags),
      callback: function($$v) {
        _vm.$set(this, "tchTags", $$v)
      },
      expression: "this.tchTags"
    }
  }, _vm._l((_vm.$constant.tchTags), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditTagsModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.editTag
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "外教运营分配记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学习建议")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择年龄档"
    },
    model: {
      value: (_vm.queryParam.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageBand", $$v)
      },
      expression: "queryParam.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH（9+）")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择技能"
    },
    model: {
      value: (_vm.queryParam.skill),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "skill", $$v)
      },
      expression: "queryParam.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分数档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择分数档"
    },
    model: {
      value: (_vm.queryParam.scoreBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scoreBand", $$v)
      },
      expression: "queryParam.scoreBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/advice/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑学习建议' : '新建学习建议',
      "width": "760"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.form, "ageBand", $$v)
      },
      expression: "form.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH（9+）")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分数档"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.scoreBand),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreBand", $$v)
      },
      expression: "form.scoreBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "文案"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6,
      "placeholder": "给该年龄档、技能、分数档的学习建议正文"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": false,
      "on-success": _vm.onSuccess,
      "before-upload": _vm.beforeUpload,
      "accept": _vm.accept,
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Button', {
    attrs: {
      "type": "ghost",
      "icon": "ios-cloud-upload-outline"
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("官网活动")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生作品管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-postion": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "name": "userName"
    },
    model: {
      value: (_vm.queryParam.userName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userName", $$v)
      },
      expression: "queryParam.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "title"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageGroup", _vm._n($$v))
      },
      expression: "queryParam.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "期数"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", _vm._n($$v))
      },
      expression: "queryParam.period"
    }
  }, _vm._l((_vm.$constant.userVideoPeriod), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否已上传作品",
      "prop": "isUploadVideo"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.isUploadVideo),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isUploadVideo", _vm._n($$v))
      },
      expression: "queryParam.isUploadVideo"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditStatus", _vm._n($$v))
      },
      expression: "queryParam.auditStatus"
    }
  }, _vm._l((_vm.$constant.auditStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "大众口碑分",
      "prop": "hasPublicScore"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.hasPublicScore),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasPublicScore", _vm._n($$v))
      },
      expression: "queryParam.hasPublicScore"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("上传作品")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchToNextRound
    }
  }, [_vm._v("进入下一轮")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userVideo/pageList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectedChange
    }
  }), _vm._v(" "), _c('AddUserVideoModal', {
    attrs: {
      "value": _vm.showAddUserVideoModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showAddUserVideoModal = false
      }
    }
  }), _vm._v(" "), _c('EditUserVideoModal', {
    attrs: {
      "value": _vm.showEditUserVideoModal,
      "itemId": _vm.itemId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEditUserVideoModal = false
      },
      "on-edit-clearid": _vm.clearid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("日常辅助")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("消息日志")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发送时间:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetimerange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "模板名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "params"
    },
    model: {
      value: (_vm.queryParam.params),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "params", $$v)
      },
      expression: "queryParam.params"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "消息内容"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "params"
    },
    model: {
      value: (_vm.queryParam.adminKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminKey", $$v)
      },
      expression: "queryParam.adminKey"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activity/message-log",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("日常辅助")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("班主任值班表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "值班日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.onAddTime()
      }
    }
  }, [_vm._v("新增值班表\n    ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/todo/study-duty-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "添加值班"
    },
    model: {
      value: (_vm.showAddTimeModal),
      callback: function($$v) {
        _vm.showAddTimeModal = $$v
      },
      expression: "showAddTimeModal"
    }
  }, [_c('Form', {
    ref: "form1",
    staticClass: "form",
    attrs: {
      "model": _vm.addTimeReq,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "值班学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.addTimeReq.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.addTimeReq, "adminUserId", $$v)
      },
      expression: "addTimeReq.adminUserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('AdminUserMultSelect', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.addTimeReq.adminUserIds),
      callback: function($$v) {
        _vm.$set(_vm.addTimeReq, "adminUserIds", $$v)
      },
      expression: "addTimeReq.adminUserIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": true,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期",
      "options": {
        disabledDate: _vm.disabledDate
      }
    },
    model: {
      value: (_vm.addTimeReq.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.addTimeReq, "dateRange", $$v)
      },
      expression: "addTimeReq.dateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showAddTimeModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.saveTime
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-group"
  }, [(_vm.label) ? _c('span', {
    staticClass: "filter-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(opt) {
    return _c('span', {
      key: String(opt.value),
      staticClass: "filter-pill",
      class: {
        'is-on': _vm.isOn(opt.value)
      },
      on: {
        "click": function($event) {
          return _vm.pick(opt.value)
        }
      }
    }, [_c('i', {
      staticClass: "pill-dot",
      style: (opt.color ? {
        background: opt.color
      } : null)
    }), _vm._v(_vm._s(opt.label) + "\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工关系")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("入职管理")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。本页不含二维码邀请与欢迎公告。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING"
    }
  }, [_vm._v("待入职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已入职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "姓名/手机"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showAdd = true
      }
    }
  }, [_vm._v("添加待入职")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无待入职"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "添加待入职（仅本地）"
    },
    on: {
      "on-ok": _vm.addRow
    },
    model: {
      value: (_vm.showAdd),
      callback: function($$v) {
        _vm.showAdd = $$v
      },
      expression: "showAdd"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手机",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "预计入职"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.form.preEntryTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "preEntryTime", $$v)
      },
      expression: "form.preEntryTime"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工关系")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("异动管理")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。本页不含退休 Tab。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.processType),
      callback: function($$v) {
        _vm.$set(_vm.query, "processType", $$v)
      },
      expression: "query.processType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("调岗")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RESIGN"
    }
  }, [_vm._v("离职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("办理中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已办结")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "姓名/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openSubmit
    }
  }, [_vm._v("新建异动（仅本地）")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无异动记录"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建异动（仅本地）"
    },
    on: {
      "on-ok": _vm.submit
    },
    model: {
      value: (_vm.showSubmit),
      callback: function($$v) {
        _vm.showSubmit = $$v
      },
      expression: "showSubmit"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.processType),
      callback: function($$v) {
        _vm.$set(_vm.form, "processType", $$v)
      },
      expression: "form.processType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("调岗")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RESIGN"
    }
  }, [_vm._v("离职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", $$v)
      },
      expression: "form.reason"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("知识库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("库管理")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("上传与建库在此完成；全局助手只做问答。新建可同步创建 IMA 库；备份目录由网盘超管自动创建。")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Input', {
    staticStyle: {
      "width": "220px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "名称/外部ID"
    },
    on: {
      "on-enter": _vm.load
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.load
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.openSync
    }
  }, [_vm._v("从 IMA 同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        return _vm.openSave()
      }
    }
  }, [_vm._v("新建知识库")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "从 IMA 同步知识库"
    },
    model: {
      value: (_vm.syncModal),
      callback: function($$v) {
        _vm.syncModal = $$v
      },
      expression: "syncModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "远程知识库"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "loading": _vm.remoteLoading,
      "placeholder": "下拉选择或下方手输"
    },
    model: {
      value: (_vm.syncExternalId),
      callback: function($$v) {
        _vm.syncExternalId = $$v
      },
      expression: "syncExternalId"
    }
  }, _vm._l((_vm.remoteOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name) + "（" + _vm._s(item.id) + "）")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "或手输 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "IMA knowledge_base_id"
    },
    model: {
      value: (_vm.syncExternalIdManual),
      callback: function($$v) {
        _vm.syncExternalIdManual = $$v
      },
      expression: "syncExternalIdManual"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.syncModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("同步")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "保存知识库"
    },
    model: {
      value: (_vm.saveModal),
      callback: function($$v) {
        _vm.saveModal = $$v
      },
      expression: "saveModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识库名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), (!_vm.form.id) ? _c('Form-item', {
    attrs: {
      "label": "同步创建 IMA"
    }
  }, [_c('i-switch', {
    model: {
      value: (_vm.form.createRemote),
      callback: function($$v) {
        _vm.$set(_vm.form, "createRemote", $$v)
      },
      expression: "form.createRemote"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('span', {
    staticClass: "kb-tip",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("开：后台调 IMA 建库并回填 ID；关：需填已有外部 ID")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.id || !_vm.form.createRemote) ? _c('Form-item', {
    attrs: {
      "label": "外部库 ID",
      "required": !_vm.form.id && !_vm.form.createRemote
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.form.id,
      "placeholder": "已有 IMA knowledge_base_id"
    },
    model: {
      value: (_vm.form.externalKbId),
      callback: function($$v) {
        _vm.$set(_vm.form, "externalKbId", $$v)
      },
      expression: "form.externalKbId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.saveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.doSave
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "浏览知识库",
      "width": "820"
    },
    model: {
      value: (_vm.browseModal),
      callback: function($$v) {
        _vm.browseModal = $$v
      },
      expression: "browseModal"
    }
  }, [_c('div', {
    staticClass: "browse-bar"
  }, [_c('span', {
    staticClass: "crumb",
    on: {
      "click": _vm.browseGoRoot
    }
  }, [_vm._v("根目录")]), _vm._v(" "), _vm._l((_vm.browseCrumbs), function(c, idx) {
    return _c('span', {
      key: idx
    }, [_vm._v("\n        / "), _c('span', {
      class: ['crumb', idx === _vm.browseCrumbs.length - 1 ? 'current' : ''],
      on: {
        "click": function($event) {
          return _vm.browseGoCrumb(idx)
        }
      }
    }, [_vm._v(_vm._s(c.name))])])
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "12px"
    },
    attrs: {
      "placeholder": "关键词搜索"
    },
    on: {
      "on-enter": _vm.doBrowseSearch
    },
    model: {
      value: (_vm.browseKeyword),
      callback: function($$v) {
        _vm.browseKeyword = $$v
      },
      expression: "browseKeyword"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.doBrowseSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.browseReload
    }
  }, [_vm._v("刷新")])], 2), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "size": "small",
      "columns": _vm.browseColumns,
      "data": _vm.browseRows,
      "loading": _vm.browseLoading
    }
  }), _vm._v(" "), (!_vm.browseLoading && (!_vm.browseRows || !_vm.browseRows.length)) ? _c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("暂无文件")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.browseModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "上传到知识库"
    },
    model: {
      value: (_vm.uploadModal),
      callback: function($$v) {
        _vm.uploadModal = $$v
      },
      expression: "uploadModal"
    }
  }, [_c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("上传写入 IMA，并备份到网盘（仅网盘超管可见）。")]), _vm._v(" "), _c('p', [_vm._v("目标库：" + _vm._s(_vm.uploadTarget && _vm.uploadTarget.name))]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.uploadModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.doUpload
    }
  }, [_vm._v("开始上传")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("续费数据列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "labe-position": "left"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间范围：",
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTimeStr),
      callback: function($$v) {
        _vm.startTimeStr = $$v
      },
      expression: "startTimeStr"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTimeStr),
      callback: function($$v) {
        _vm.endTimeStr = $$v
      },
      expression: "endTimeStr"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/userStudyAdviserLog/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("异动老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyConsultantId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyConsultantId", $$v)
      },
      expression: "queryParam.studyConsultantId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 14
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "离职时间:"
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkStartTimeDate
    },
    on: {
      "on-change": _vm.linkTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n              -\n            ")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkEndTimeDate
    },
    on: {
      "on-change": _vm.linkTimeEndChange
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/anomaly/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showStuList": true,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("绑定分组课件修复")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "空则扫全部 stars>1 学生"
    },
    model: {
      value: (_vm.uid),
      callback: function($$v) {
        _vm.uid = $$v
      },
      expression: "uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.scanLoading,
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.scan(false)
      }
    }
  }, [_vm._v("检查")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "error",
      "loading": _vm.fixLoading,
      "disabled": !_vm.canFix
    },
    on: {
      "click": _vm.confirmFix
    }
  }, [_vm._v("一键修复")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0 12px"
    }
  }, [_vm._v("\n    只处理 stars>1 的多级别学生。检查只看不改；修复会改未来已选课件。\n    学生 " + _vm._s(_vm.result.studentCount || 0) + "，错课 " + _vm._s(_vm.result.wrongCount || 0) + "，已修 " + _vm._s(_vm.result.fixedCount || 0) + "，\n    近5分钟跳过 " + _vm._s(_vm.result.skippedNearCount || 0) + "，陪练组跳过 " + _vm._s(_vm.result.skippedPartnerGroups || 0) + "\n  ")]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.rows
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Demo Reivew",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one: Class performance  :")]), _vm._v(" "), _c('h4', [_vm._v("\n        Student's overal performance in English learning(must include the student's strengths and weaknesses in listening/speaking/reading/writing/grammar etc, no less than 30 words in total)\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two： Learning Suggestions :")]), _vm._v(" "), _c('p', [_vm._v("\n        The demo level is  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.word1),
      expression: "formData.word1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.word1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "word1", $event.target.value)
      }
    }
  }), _vm._v(" (a bit difficult/a perfect fit/a bit easy) for the\n        student, so I suggest starting your English journey from "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.word2),
      expression: "formData.word2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.word2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "word2", $event.target.value)
      }
    }
  }), _vm._v("(a particular level that \n        we have) and taking classes twice or three times a week to ensure a great learning outcome.\n        Overall, I am very pleased with our first class together. You did a wonderful job\n        participating the class activities and  I look forward to seeing you again soon in the\n        classroom.\n      ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("停课学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID："
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名："
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号："
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "停课原因："
    }
  }, [_c('Input', {
    attrs: {
      "name": "stopRemark",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.stopRemark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stopRemark", $$v)
      },
      expression: "queryParam.stopRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "预计复课时间："
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "停课时间："
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.stopLessonTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("解绑学导")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.cancelLoading,
      "disable": _vm.cancelLoading,
      "icon": ""
    },
    on: {
      "click": _vm.batchCancel
    }
  }, [_vm._v("批量取消停课\n        ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('601'),
      expression: "'601'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onBatchCompletedCourses
    }
  }, [_vm._v("批量结课")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/lessonsStop/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UnBinStudyModals', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showUnBinStudyModal),
      callback: function($$v) {
        _vm.showUnBinStudyModal = $$v
      },
      expression: "showUnBinStudyModal"
    }
  }), _vm._v(" "), _c('BatchCompletedCoursesModal', {
    attrs: {
      "uidStr": _vm.uidStr,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBatchCompletedCoursesModal),
      callback: function($$v) {
        _vm.showBatchCompletedCoursesModal = $$v
      },
      expression: "showBatchCompletedCoursesModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mex-asset-preview"
  }, [_c('div', [_c('Button', {
    attrs: {
      "size": "small",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.pick
    }
  }, [_vm._v("上传到七牛")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onFile
    }
  })], 1), _vm._v(" "), (_vm.url) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.url))]) : _vm._e(), _vm._v(" "), (_vm.url && _vm.kind === 'image') ? _c('img', {
    staticClass: "mex-asset-preview-img",
    attrs: {
      "src": _vm.url
    }
  }) : (_vm.url && _vm.kind === 'audio') ? _c('audio', {
    staticClass: "mex-asset-preview-audio",
    attrs: {
      "src": _vm.url,
      "controls": ""
    }
  }) : (_vm.url && _vm.kind === 'video') ? _c('video', {
    staticClass: "mex-asset-preview-video",
    attrs: {
      "src": _vm.url,
      "controls": ""
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "临时约课",
      "width": "600",
      "mask-closable": false,
      "styles": {
        right: '-300px'
      }
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "tempLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.tempLessonParam,
      "rules": _vm.tempLessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.tempLessonParam.uid) + " - " + _vm._s(_vm.tempLessonParam.mobile) + " - " + _vm._s(_vm.tempLessonParam.nickname) + " -\n              " + _vm._s(_vm.tempLessonParam.levelId))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "请选择等级，支持搜索"
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.tempLessonParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "levelId", _vm._n($$v))
      },
      expression: "tempLessonParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tempLessonParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "schoolId", _vm._n($$v))
      },
      expression: "tempLessonParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tempLessonParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "lessonId", _vm._n($$v))
      },
      expression: "tempLessonParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.tempLessonParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "lsnBeginTimeDate", $$v)
      },
      expression: "tempLessonParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    key: _vm.timePickerKey,
    attrs: {
      "clearable": false,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.timeStr),
      callback: function($$v) {
        _vm.timeStr = $$v
      },
      expression: "timeStr"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tempLessonParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "timeLength", _vm._n($$v))
      },
      expression: "tempLessonParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.makeUp),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "makeUp", $$v)
      },
      expression: "tempLessonParam.makeUp"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("正常约课")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("补课")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "accent", $$v)
      },
      expression: "tempLessonParam.accent"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("英音")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("美音")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "sex", $$v)
      },
      expression: "tempLessonParam.sex"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("男")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("女")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "channel", $$v)
      },
      expression: "tempLessonParam.channel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("欧美")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("菲教")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.canBound),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "canBound", $$v)
      },
      expression: "tempLessonParam.canBound"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("有绑定权限")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("无绑定权限")])])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "适宜级别"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.tempLessonParam.suitableLevel),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "suitableLevel", $$v)
      },
      expression: "tempLessonParam.suitableLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("Level1")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5"
    }
  }, [_c('span', [_vm._v("Level2")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("Level3-Level5")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("Level6-Level9")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("Wonders及其他")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "6"
    }
  }, [_c('span', [_vm._v("PU")])])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.tempLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "tchId", _vm._n($$v))
      },
      expression: "tempLessonParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + "\n                    ")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertTempLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("AI渠道收录表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", $$v)
      },
      expression: "queryParam.period"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊"
    },
    model: {
      value: (_vm.queryParam.personName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "personName", $$v)
      },
      expression: "queryParam.personName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openChannelManage
    }
  }, [_vm._v("渠道管理")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableDataWithSum,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [50, 100, 200]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑' : '新增',
      "width": 520
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.formData.period),
      callback: function($$v) {
        _vm.$set(_vm.formData, "period", $$v)
      },
      expression: "formData.period"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.personName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "personName", $$v)
      },
      expression: "formData.personName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.enabledChannels), function(ch) {
    return _c('Form-item', {
      key: ch.channelKey,
      attrs: {
        "label": ch.displayName
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0
      },
      model: {
        value: (_vm.formData.channelValues[ch.channelKey]),
        callback: function($$v) {
          _vm.$set(_vm.formData.channelValues, ch.channelKey, $$v)
        },
        expression: "formData.channelValues[ch.channelKey]"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.enabledChannels.length) ? _c('div', {
    staticStyle: {
      "color": "#999",
      "padding-left": "100px"
    }
  }, [_vm._v("请先在渠道管理中添加渠道")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "渠道管理",
      "width": 720
    },
    on: {
      "on-visible-change": _vm.onChannelVisible
    },
    model: {
      value: (_vm.showChannelModal),
      callback: function($$v) {
        _vm.showChannelModal = $$v
      },
      expression: "showChannelModal"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddChannel
    }
  }, [_vm._v("新增渠道")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.channelColumns,
      "data": _vm.allChannels,
      "loading": _vm.channelLoading,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showChannelModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.channelForm.id ? '改名' : '新增渠道',
      "width": 480
    },
    model: {
      value: (_vm.showChannelEdit),
      callback: function($$v) {
        _vm.showChannelEdit = $$v
      },
      expression: "showChannelEdit"
    }
  }, [(_vm.channelForm.id) ? _c('Alert', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("改名只影响展示，不影响已填数据。")]) : _vm._e(), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "展示名",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "列表列头"
    },
    model: {
      value: (_vm.channelForm.displayName),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "displayName", $$v)
      },
      expression: "channelForm.displayName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标识"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.channelForm.id,
      "placeholder": _vm.channelForm.id ? '' : '留空则自动生成'
    },
    model: {
      value: (_vm.channelForm.channelKey),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "channelKey", $$v)
      },
      expression: "channelForm.channelKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "placeholder": "默认追加到末尾"
    },
    model: {
      value: (_vm.channelForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "sort", $$v)
      },
      expression: "channelForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showChannelEdit = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.channelSaving
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back"
    }
  }), _vm._v("\n      返回\n    ")], 1), _vm._v(" "), _c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("学生信息详情")]), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": "card",
      "animated": false
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "基本信息",
      "name": "one"
    }
  }, [_c('Form', {
    ref: "userInfoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.userRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("基本信息")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 14
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('span', [_c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "padding": "0"
    },
    attrs: {
      "type": "text",
      "name": "enName"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "padding": "0"
    },
    attrs: {
      "type": "password",
      "name": "password"
    }
  })]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "英文名字："
    }
  }, [_c('Input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.enName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enName", $$v)
      },
      expression: "formData.enName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "密码："
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "中文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "cnName",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.cnName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnName", $$v)
      },
      expression: "formData.cnName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10
    }
  }, [_c('a', {
    on: {
      "click": _vm.openStudentPage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "border": "1px solid #f0f0f0",
      "margin": "10px auto"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "name": "age"
    },
    on: {
      "on-change": _vm.calcBirthdayFromAge
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "年级："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.$constant.grade), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "生日："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.calcAgeFromBirthday
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", _vm._n($$v))
      },
      expression: "formData.birthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "生源地："
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.formData.province,
      "city": _vm.formData.city,
      "area": _vm.formData.block,
      "placeholders": _vm.placeholders
    },
    on: {
      "province": _vm.onSelectedProvince,
      "city": _vm.onSelectedCity,
      "area": _vm.onSelectedArea
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 16,
      "md": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "英语学习经历："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.learnEnglishTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "learnEnglishTime", $$v)
      },
      expression: "formData.learnEnglishTime"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("不足三个月")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("一年左右")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一年以上")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("没有学习过英语")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否接触过外教："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.haveContactForeignTeacher),
      callback: function($$v) {
        _vm.$set(_vm.formData, "haveContactForeignTeacher", $$v)
      },
      expression: "formData.haveContactForeignTeacher"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "允许修改请假规则："
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.handleEnabledRuleChange
    },
    model: {
      value: (_vm.formData.enabledRule),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enabledRule", $$v)
      },
      expression: "formData.enabledRule"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "支持多级别排课："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.stars === 2,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleMultiLevelScheduleChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "支持自主约课："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.tchIdCopy === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleSelfBookingChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "允许阶段测："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.summativeEnabled,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleSummativeEnabledChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "哈佛外教课权限："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.harvardForeignEnabled,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleHarvardForeignAuthChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "阶段测蓝图："
    }
  }, [_c('Select', {
    attrs: {
      "value": _vm.summativeBlueprintId,
      "placeholder": "请选择阶段测蓝图",
      "transfer": ""
    },
    on: {
      "on-change": _vm.handleSummativeBlueprintChange
    }
  }, _vm._l((_vm.summativeBlueprints), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.segment && item.versionNo ? item.segment + ' / ' + item.versionNo : item.id))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "家庭经济情况："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.familyEconomicSituation),
      callback: function($$v) {
        _vm.$set(_vm.formData, "familyEconomicSituation", $$v)
      },
      expression: "formData.familyEconomicSituation"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("非常好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("不是很好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否重视英语学习："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.attentionEnglish),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attentionEnglish", $$v)
      },
      expression: "formData.attentionEnglish"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "接通状态："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "connectionStatus", $$v)
      },
      expression: "formData.connectionStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("未拨打")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("拨打未接")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("拨打接通")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', [_c('span', [_vm._v("绘本VIP:" + _vm._s(_vm.formData.vipDesc || '未开通'))]), _vm._v(" "), (_vm.appVersionData.versionName) ? _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("APP版本信息：" + _vm._s(_vm.appVersionTypeText) + "/"), _c('span', {
    style: ({
      color: _vm.appVersionData.versionName === '7.0.5' ? '#19be6b' : '#ed4014'
    })
  }, [_vm._v(_vm._s(_vm.appVersionData.versionName === '7.0.5' ? '最新版' : '旧版本'))]), _vm._v("/" + _vm._s(_vm.appVersionData.loginTime ? _vm.$moment(_vm.appVersionData.loginTime).format('YYYY-MM-DD HH:mm') : '-'))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "学生ID："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid))])])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "手机号码：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  }), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "value": _vm.formData.mobileRemind === 1 || !(_vm.formData.remarkMobile || '').replace(/[,\s]/g, ''),
      "disabled": !(_vm.formData.remarkMobile || '').replace(/[,\s]/g, ''),
      "size": "large"
    },
    on: {
      "on-change": _vm.handleMobileRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("提醒")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（开关打开则上课短信/电话提醒发到该号码；没有备用号码时始终提醒该号码）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "备用手机号码："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.formData.remarkMobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remarkMobile", $$v)
      },
      expression: "formData.remarkMobile"
    }
  }), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "value": _vm.formData.remarkMobileRemind === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleRemarkMobileRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("提醒")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（仅用于上课提醒，多个号码用英文逗号隔开；开关打开则提醒发到该号码，两个开关都开则两个号码都提醒）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否允许电话提醒："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.allowCallReminder),
      callback: function($$v) {
        _vm.$set(_vm.formData, "allowCallReminder", $$v)
      },
      expression: "formData.allowCallReminder"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否允许短信提醒："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.allowSmsReminder),
      callback: function($$v) {
        _vm.$set(_vm.formData, "allowSmsReminder", $$v)
      },
      expression: "formData.allowSmsReminder"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "课前电话提醒："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.beforeClassCall === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleBeforeClassCallChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（打开且“允许电话提醒”为是时，课前提醒会打电话）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "课前提醒时间："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "如 2,24"
    },
    model: {
      value: (_vm.formData.remindHours),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remindHours", $$v)
      },
      expression: "formData.remindHours"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（默认课前1小时提醒；可再填小时数，多个用英文逗号隔开）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "号码对应人："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.phoneRole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phoneRole", $$v)
      },
      expression: "formData.phoneRole"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("父亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("母亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("其他")])])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("添加联系人")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "userContacts"
    }
  }, _vm._l((_vm.formData.userContacts), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Row', {
      attrs: {
        "gutter": 16
      }
    }, [_c('Form-item', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 10
      }
    }, [_c('Input', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "placeholder": "姓名"
      },
      model: {
        value: (_vm.formData.userContacts[index].name),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "name", $$v)
        },
        expression: "formData.userContacts[index].name"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 10
      }
    }, [_c('Input', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "placeholder": "手机号码",
        "number": true
      },
      model: {
        value: (_vm.formData.userContacts[index].mobile),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "mobile", $$v)
        },
        expression: "formData.userContacts[index].mobile"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 4
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteContact(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "微信账号：",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.formData.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "wechatAccount", $$v)
      },
      expression: "formData.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "地址："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%",
      "height": "60px"
    },
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "个人信息备注："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%",
      "height": "60px"
    },
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.infoRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "infoRemark", $$v)
      },
      expression: "formData.infoRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require"
  }, [_c('div', {
    staticClass: "fixed-class-require-title"
  }, [_vm._v("固定上课需求")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "一行一个要求，例如：不放儿歌"
    },
    model: {
      value: (_vm.fixedClassRequire),
      callback: function($$v) {
        _vm.fixedClassRequire = $$v
      },
      expression: "fixedClassRequire"
    }
  }), _vm._v(" "), (_vm.fixedRequireLines.length) ? _c('div', {
    staticClass: "fixed-class-require-tags"
  }, _vm._l((_vm.fixedRequireLines), function(item, index) {
    return _c('Tag', {
      key: 'zh-' + index,
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require-en"
  }, [_vm._v("老师看到的英文")]), _vm._v(" "), (_vm.fixedRequireEnLines.length) ? _c('div', {
    staticClass: "fixed-class-require-tags"
  }, _vm._l((_vm.fixedRequireEnLines), function(item, index) {
    return _c('Tag', {
      key: 'en-' + index,
      attrs: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1) : _c('div', {
    staticClass: "fixed-class-require-empty"
  }, [_vm._v("暂无")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fixedClassRequireSaving
    },
    on: {
      "click": _vm.saveFixedClassRequire
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require-tip"
  }, [_vm._v("一行一个要求。含中文会按行翻译成英文给老师看；清空后保存会去掉老师端标记。最多 500 字。")])], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生来源标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 10
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label-width": _vm.auto,
      "label": "注册渠道："
    }
  }, [_c('Input', {
    attrs: {
      "name": "regType",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.regType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regType", $$v)
      },
      expression: "formData.regType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "付费渠道："
    }
  }, _vm._l((_vm.$constant.studentTags), function(item) {
    return _c('RadioGroup', {
      key: item.code,
      model: {
        value: (_vm.formData.payCanal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "payCanal", $$v)
        },
        expression: "formData.payCanal"
      }
    }, [_c('Radio', {
      attrs: {
        "label": item.code
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课顾电话跟进")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin-left": "10px"
    }
  }, [_vm._v("意向等级：")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.formData.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "intentLevel", $$v)
      },
      expression: "formData.intentLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("不论")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("高意向")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("意向一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("待跟进")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "未分班主任提醒："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.noStudyAdviserRemind === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleNoStudyAdviserRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "border-bottom": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生属性标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return _c('span', {
      key: key,
      staticStyle: {
        "margin-left": "20px",
        "font-size": "14px",
        "display": "block"
      }
    }, [_vm._v("\n               " + _vm._s(key) + ":\n               "), (val != null) ? _c('span', _vm._l((val), function(item) {
      return _c('Tag', {
        key: item,
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    }), 1) : _c('span', [_vm._v("无")])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "telephone",
    staticStyle: {
      "text-align": "center",
      "margin": "20px 0"
    }
  }, [_c('Button', {
    staticStyle: {
      "background-color": "#007bff",
      "color": "white",
      "font-size": "14px",
      "padding": "5px 5px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dialTel
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("通话记录")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.callRecordTitle,
      "data": _vm.callRecordData,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer",
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticClass: "cancel",
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "Follow Up",
      "name": "two"
    }
  }, [_c('Form', {
    ref: "followForm",
    staticClass: "form",
    attrs: {
      "model": _vm.followFormData,
      "rules": _vm.followRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.id) + " -- " + _vm._s(_vm.followFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.studyAdviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, _vm._l((_vm.followFormData.tchNames), function(tchName) {
    return _c('el-tag', {
      staticStyle: {
        "margin-right": "2px"
      }
    }, [_vm._v(_vm._s(tchName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容：",
      "prop": "content",
      "label-width": 120
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.followFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "content", $$v)
      },
      expression: "followFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "traceStatus",
      "label-width": 120
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.followFormData.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceStatus", $$v)
      },
      expression: "followFormData.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50,
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.followFormData.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceItem", $$v)
      },
      expression: "followFormData.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.followFormData.traceStatus == 100 || _vm.followFormData.traceStatus == '100') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "label-width": 120
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100
    },
    model: {
      value: (_vm.followFormData.files),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "files", $$v)
      },
      expression: "followFormData.files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间：",
      "prop": "nextDate",
      "label-width": 120
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: (_vm.nextDate),
      callback: function($$v) {
        _vm.nextDate = $$v
      },
      expression: "nextDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 120
    }
  }, [_c('ElSwitch', {
    model: {
      value: (_vm.askForTch),
      callback: function($$v) {
        _vm.askForTch = $$v
      },
      expression: "askForTch"
    }
  })], 1), _vm._v(" "), (_vm.askForTch) ? [_c('Form-item', {
    attrs: {
      "label": "对学生描述：",
      "label-width": 120
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 3
    },
    model: {
      value: (_vm.followFormData.stuDescCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "stuDescCheckGroup", $$v)
      },
      expression: "followFormData.stuDescCheckGroup"
    }
  }, _vm._l((_vm.$constant.stuDesc), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 120
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 5
    },
    model: {
      value: (_vm.followFormData.askForTchCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "askForTchCheckGroup", $$v)
      },
      expression: "followFormData.askForTchCheckGroup"
    }
  }, _vm._l((_vm.$constant.askForTch), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFollow
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up记录")])], 1), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px"
    },
    attrs: {
      "border": "",
      "columns": _vm.followtitle,
      "data": _vm.followData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "推荐老师",
      "name": "tree"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openRecommendEdit
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('RecommendList', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uid": _vm.formData.uid,
      "listUrl": "/tchRecommend/list",
      "tableColumns": _vm.recommendTitle,
      "reset": _vm.reset,
      "data": _vm.recommendData
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "阶段报告",
      "name": "four"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.stageReportTitle,
      "data": _vm.stageReportData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "学生跟踪记录",
      "name": "five"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formValidate.files),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "files", $$v)
      },
      expression: "formValidate.files"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "track-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("记录属性")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系人")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": item.rowSpan,
        "hidden": item.hidden
      }
    }, [_vm._v(_vm._s(item.showName))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', [_c('TrackContentPreview', {
      attrs: {
        "content": item.content
      },
      on: {
        "view": function($event) {
          return _vm.openTrackContent(item)
        }
      }
    }, [(item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== '') ? _c('a', {
      staticStyle: {
        "margin-left": "8px"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.viewPic(item)
        }
      }
    }, [_vm._v("查看图片")]) : _vm._e()])], 1), _vm._v(" "), (item.nextHandlerTime == '0000-00-00 00:00:00') ? _c('td', [_vm._v(_vm._s(item.nextHandlerTime))]) : _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nextHandlerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createName))])])
  }), 0)]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.traceParam.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.traceParam.pageIndex,
      "pageSize": _vm.traceParam.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "订单合同",
      "name": "six"
    }
  }, [_c('RecommendList', {
    attrs: {
      "reload": _vm.reload_fundPackage,
      "uid": _vm.formData.uid,
      "listUrl": "/fundPackage/list",
      "tableColumns": _vm.fundPackageTitle,
      "reset": _vm.fundPackageRest,
      "data": _vm.fundPackageData
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "课时统计",
      "name": "seven"
    }
  }, [(_vm.formData.tchChannel === 1) ? _c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.courseTypeTitle,
      "data": _vm.courseTypeData
    }
  }) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "2px solid #f0f0f0",
      "margin-bottom": "20px",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchWithPage.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.lessonParams.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "startTimeDate", $$v)
      },
      expression: "lessonParams.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.lessonParams.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "endTimeDate", $$v)
      },
      expression: "lessonParams.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "studyAdviserNickname"
    },
    model: {
      value: (_vm.lessonParams.studyAdviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "studyAdviserNickname", $$v)
      },
      expression: "lessonParams.studyAdviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称",
      "label-width": 85
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adviserNickname"
    },
    model: {
      value: (_vm.lessonParams.adviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "adviserNickname", $$v)
      },
      expression: "lessonParams.adviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.lessonParams.tchId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchId", $$v)
      },
      expression: "lessonParams.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.lessonParams.tchName),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchName", $$v)
      },
      expression: "lessonParams.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "排课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startCreateTimeChange
    },
    model: {
      value: (_vm.lessonParams.startCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "startCreateDate", $$v)
      },
      expression: "lessonParams.startCreateDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endCreateTimeChange
    },
    model: {
      value: (_vm.lessonParams.endCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "endCreateDate", $$v)
      },
      expression: "lessonParams.endCreateDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.courseType),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "courseType", _vm._n($$v))
      },
      expression: "lessonParams.courseType"
    }
  }, _vm._l((_vm.$constant.courseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.lsnSelStatus),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "lsnSelStatus", _vm._n($$v))
      },
      expression: "lessonParams.lsnSelStatus"
    }
  }, _vm._l((_vm.$constant.lsnSelStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师类型",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.tchCategory),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchCategory", _vm._n($$v))
      },
      expression: "lessonParams.tchCategory"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "lsnType", _vm._n($$v))
      },
      expression: "lessonParams.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "materialVersionId", _vm._n($$v))
      },
      expression: "lessonParams.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配学导",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "isStudyAdviser", _vm._n($$v))
      },
      expression: "lessonParams.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "creatorName"
    },
    model: {
      value: (_vm.lessonParams.creatorName),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "creatorName", $$v)
      },
      expression: "lessonParams.creatorName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.searchWithPage
    }
  }, [_vm._v("搜索\n                  ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.openUserClassHourModal
    }
  }, [_vm._v("加减课时")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.cancelAllClass
    }
  }, [_vm._v("取消全部排课")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('RecommendList', {
    ref: "bookLessonList",
    attrs: {
      "onLoading": _vm.onLessonLoading,
      "params": _vm.lessonParams,
      "uid": _vm.formData.uid,
      "listUrl": "/bookLesson/opened/listByUid",
      "tableColumns": _vm.bookLessonTitle,
      "reloadWithPage": _vm.reloadWithPage,
      "reset": _vm.bookLessonReset
    }
  })], 1), _vm._v(" "), (_vm.detailTabsReady && _vm.showWo) ? _c('TabPane', {
    attrs: {
      "label": "交接工单",
      "name": "eight"
    }
  }, [_c('Form', {
    ref: "woFormData",
    staticClass: "form",
    attrs: {
      "model": _vm.woFormData.saleWo,
      "rules": _vm.woRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("交接工单")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.studentId) + " -- " + _vm._s(_vm.woFormData.saleWo.studentName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄：",
      "label-width": 80
    }
  }, [(_vm.woFormData.saleWo.age > 0) ? _c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.age))]) : _vm._e(), _vm._v(" "), (_vm.woFormData.saleWo.age === 0) ? _c('label') : _vm._e()])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.teacherName))])])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.orderChannel.text))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款金额：",
      "prop": "payAmount",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "readonly": _vm.woReadonly,
      "name": "payAmount"
    },
    model: {
      value: (_vm.woFormData.saleWo.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "payAmount", _vm._n($$v))
      },
      expression: "woFormData.saleWo.payAmount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "工单版本：",
      "label-width": "120"
    }
  }, [(!_vm.woDisable) ? _c('CheckboxGroup', {
    on: {
      "on-change": _vm.clickWoVersion
    },
    model: {
      value: (_vm.woVersion),
      callback: function($$v) {
        _vm.woVersion = $$v
      },
      expression: "woVersion"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("新版")])], 1) : _vm._e(), _vm._v(" "), (_vm.woDisable && _vm.woVersion === '1') ? _c('label', [_vm._v("新版")]) : _vm._e(), _vm._v(" "), (_vm.woDisable && _vm.woVersion !== '1') ? _c('label', [_vm._v("旧版")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.woVersion === '1') ? _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "不可用时间：",
      "prop": "disableTime",
      "label-width": "120"
    }
  }, [(!_vm.woDisable) ? _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableWeek"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": "",
      "disabled": _vm.woDisable
    },
    model: {
      value: (_vm.disableTimeParams.disableWeek),
      callback: function($$v) {
        _vm.$set(_vm.disableTimeParams, "disableWeek", $$v)
      },
      expression: "disableTimeParams.disableWeek"
    }
  }, _vm._l((_vm.$constant.weekSelect), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableStartTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "type": "date",
      "format": "HH:mm",
      "placeholder": "开始时间",
      "steps": [1, 5],
      "clearable": false,
      "value": _vm.disableTimeParams.disableStartTimeStr,
      "disabled": _vm.woDisable
    },
    on: {
      "on-change": _vm.onChangeDisableStartTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableEndTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "type": "date",
      "format": "HH:mm",
      "placeholder": "结束时间",
      "steps": [1, 5],
      "clearable": false,
      "value": _vm.disableTimeParams.disableEndTimeStr,
      "disabled": _vm.woDisable
    },
    on: {
      "on-change": _vm.onChangeDisableEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "disabled": _vm.woDisable
    },
    on: {
      "click": _vm.addDisableTime
    }
  }, [_vm._v("添加")])], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.woVersion === '1') ? _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择：",
      "prop": "disableTimeList",
      "label-width": "120"
    }
  }, [_c('Row', _vm._l((_vm.disableTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "span": "22"
      }
    }, [_c('label', [_c('b', [_vm._v("    " + _vm._s(item.disableWeekStr) + "       \n                        " + _vm._s(item.disableStartTimeStr) + "    --    \n                        " + _vm._s(item.disableEndTimeStr) + "    \n                      ")])]), _vm._v(" "), (!_vm.woDisable) ? _c('Button', {
      attrs: {
        "type": "error",
        "size": "small",
        "disabled": _vm.woDisable
      },
      on: {
        "click": function($event) {
          return _vm.removeDisableTime(index)
        }
      }
    }, [_vm._v("删除\n                      ")]) : _vm._e()], 1)], 1)
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注：",
      "prop": "remark",
      "label-width": 120
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "readonly": _vm.woReadonly,
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.woFormData.saleWo.remark),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "remark", $$v)
      },
      expression: "woFormData.saleWo.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.woStatus.text))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50
    }
  }, [(!_vm.woReadonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.saveWoData()
      }
    }
  }, [_vm._v("保存\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.woReadonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitWoData()
      }
    }
  }, [_vm._v("提交工单\n                ")]) : _vm._e(), _vm._v(" "), (_vm.woFormData.saleWo.status === 'UNAUDITED' || _vm.woFormData.saleWo.status === 'APPROVED') ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.rollbackWoData()
      }
    }
  }, [_vm._v("撤销工单\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.woVersion !== '1') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "首次开课时间：",
      "prop": "classOpeningTime",
      "label-width": 120
    }
  }, [_c('DatePicker', {
    attrs: {
      "readonly": _vm.woReadonly,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "transfer": ""
    },
    model: {
      value: (_vm.woFormData.saleWo.classOpeningTime),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "classOpeningTime", $$v)
      },
      expression: "woFormData.saleWo.classOpeningTime"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("工单记录")])], 1), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px"
    },
    attrs: {
      "border": "",
      "columns": _vm.woFollowTitle,
      "data": _vm.woFormData.follows,
      "reload": _vm.reload
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailTabsReady && _vm.formData.tchChannel === 2) ? _c('TabPane', {
    attrs: {
      "label": "用户权益",
      "name": "nine"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.courseHourTitle,
      "data": _vm.classHourListData
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('RecommendTeacher', {
    attrs: {
      "value": _vm.recommendEdit,
      "uid": _vm.formData.uid
    },
    on: {
      "on-close": _vm.closeRecommendEdit
    }
  }), _vm._v(" "), _c('StageReportModal', {
    attrs: {
      "uid": _vm.formData.uid,
      "successCallback": _vm.reportList
    },
    model: {
      value: (_vm.StageReportModal),
      callback: function($$v) {
        _vm.StageReportModal = $$v
      },
      expression: "StageReportModal"
    }
  }), _vm._v(" "), _c('EvaluationSheetModal', {
    attrs: {
      "reprotId": _vm.reprotId,
      "successCallback": _vm.reportList
    },
    on: {
      "on-close": _vm.onEvaluationSheetModalClose
    },
    model: {
      value: (_vm.showEvaluationSheetModal),
      callback: function($$v) {
        _vm.showEvaluationSheetModal = $$v
      },
      expression: "showEvaluationSheetModal"
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookUserFeedBackClose
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchFeedBackClose
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchScoreFeedBackClose
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  }), _vm._v(" "), _c('ClassMemberTimeModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onClassMemberClose
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  }), _vm._v(" "), _c('ChangeLessonModal', {
    attrs: {
      "lessonOpened": _vm.lessonOpened,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showChangeLessonModal),
      callback: function($$v) {
        _vm.showChangeLessonModal = $$v
      },
      expression: "showChangeLessonModal"
    }
  }), _vm._v(" "), _c('UserOneLeaveModal', {
    attrs: {
      "openId": _vm.openId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserOneLeaveModal),
      callback: function($$v) {
        _vm.showUserOneLeaveModal = $$v
      },
      expression: "showUserOneLeaveModal"
    }
  }), _vm._v(" "), _c('TchLessonLeaveModal', {
    attrs: {
      "openedId": _vm.openedId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchLessonLeaveModal),
      callback: function($$v) {
        _vm.showTchLessonLeaveModal = $$v
      },
      expression: "showTchLessonLeaveModal"
    }
  }), _vm._v(" "), _c('LessonCancelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "lsnType": _vm.lsnType,
      "tchChannel": _vm.formData.tchChannel,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showLessonCancelModal),
      callback: function($$v) {
        _vm.showLessonCancelModal = $$v
      },
      expression: "showLessonCancelModal"
    }
  }), _vm._v(" "), _c('BalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showBalanceModal),
      callback: function($$v) {
        _vm.showBalanceModal = $$v
      },
      expression: "showBalanceModal"
    }
  }), _vm._v(" "), _c('RejectBalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showRejectBalanceModal),
      callback: function($$v) {
        _vm.showRejectBalanceModal = $$v
      },
      expression: "showRejectBalanceModal"
    }
  }), _vm._v(" "), _c('MonitorLessonRecordListModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordListModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordListModal = $$v
      },
      expression: "showMonitorLessonRecordListModal"
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "uid": _vm.formData.uid
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('AddMonitorLessonRecordModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordModal = $$v
      },
      expression: "showMonitorLessonRecordModal"
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewDemoModal,
      "formData": _vm.studentWriteReviewDemoModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewDemoV2Modal,
      "formData": _vm.studentWriteReviewDemoV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewRegularModal,
      "formData": _vm.studentWriteReviewRegularModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewRegularV2Modal,
      "formData": _vm.studentWriteReviewRegularV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewFinishLevelModal,
      "formData": _vm.studentWriteReviewFinishLevelModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewFinishLevelV2Modal,
      "formData": _vm.studentWriteReviewFinishLevelV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('SearchChangeTchModal', {
    attrs: {
      "optType": _vm.optType,
      "user": _vm.tempLessonUser,
      "changeTeacherOnly": _vm.changeTeacherOnly,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showSearchChangeTchModal),
      callback: function($$v) {
        _vm.showSearchChangeTchModal = $$v
      },
      expression: "showSearchChangeTchModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改版本号"
    },
    model: {
      value: (_vm.showVersionModel),
      callback: function($$v) {
        _vm.showVersionModel = $$v
      },
      expression: "showVersionModel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.needversion),
      callback: function($$v) {
        _vm.needversion = $$v
      },
      expression: "needversion"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("版本一")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("版本二")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("版本三")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("版本四")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showVersionModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改合同状态"
    },
    model: {
      value: (_vm.showContractStatusModel),
      callback: function($$v) {
        _vm.showContractStatusModel = $$v
      },
      expression: "showContractStatusModel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.needContractStatus),
      callback: function($$v) {
        _vm.needContractStatus = $$v
      },
      expression: "needContractStatus"
    }
  }, [_c('Option', {
    key: "0",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("使用中")]), _vm._v(" "), _c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("未开启")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已过期")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showContractStatusModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.saveContractStatus
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('UserTrackContentModal', {
    ref: "trackContentModal"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emergency-dashboard"
  }, [_c('div', {
    staticClass: "container main-content"
  }, [_c('div', {
    staticClass: "stat-cards"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("合格外教")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalTeachers))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openSlotDetail('available')
      }
    }
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("可用时段")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalAvailableSlots))]), _vm._v(" "), _c('div', {
    staticClass: "stat-sub"
  }, [_vm._v("当前总计 · 点击查看明细")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openSlotDetail('used')
      }
    }
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("已使用时段")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.usedSlots))]), _vm._v(" "), _c('div', {
    staticClass: "stat-sub"
  }, [_vm._v("当前周 · 点击查看明细")])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('Tabs', {
    key: _vm.isTrialPool ? 'trial' : 'pool',
    staticClass: "main-tabs",
    attrs: {
      "value": "pool"
    },
    on: {
      "on-click": _vm.handleTabChange
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.isTrialPool ? '试听外教池' : '应急外教池',
      "name": "pool"
    }
  }, [(_vm.isTrialPool) ? _c('Alert', {
    staticClass: "trial-rule-alert",
    attrs: {
      "show-icon": ""
    }
  }, [_vm._v("\n          入池规则（三条同时满足）\n          "), _c('div', {
    attrs: {
      "slot": "desc"
    },
    slot: "desc"
  }, [_c('p', [_vm._v("① 所有老师（包括应急外教非应急时间）")]), _vm._v(" "), _c('p', [_vm._v("② 当前外教分数 ≥ 70 分（同本月排行榜总分 / 批量查分接口）")]), _vm._v(" "), _c('p', [_vm._v("③ 单周买断 ≥ 20 节（统计周随搜索日期所在周一至周日）")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-panel"
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "搜索老师姓名或ID"
    },
    on: {
      "on-enter": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.searchText),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchText", $$v)
      },
      expression: "filters.searchText"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prefix",
      "type": "ios-search"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "tchStudyAdviser",
      "placeholder": "外管",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.tchStudyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tchStudyAdviserId", $$v)
      },
      expression: "filters.tchStudyAdviserId"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "老师来源",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tchChannel", $$v)
      },
      expression: "filters.tchChannel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")])], 1)], 1), _vm._v(" "), (!_vm.isTrialPool) ? _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "是否应急外教",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.emergency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "emergency", $$v)
      },
      expression: "filters.emergency"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "试听权限",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isAudition", $$v)
      },
      expression: "filters.isAudition"
    }
  }, [_c('Option', {
    attrs: {
      "value": "y"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "n"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "绑定权限",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.canBound),
      callback: function($$v) {
        _vm.$set(_vm.filters, "canBound", $$v)
      },
      expression: "filters.canBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "会中文",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.chinese),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chinese", $$v)
      },
      expression: "filters.chinese"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [(!_vm.isTrialPool) ? _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "约课方式"
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.bookMode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "bookMode", $$v)
      },
      expression: "filters.bookMode"
    }
  }, [_c('Option', {
    attrs: {
      "value": "bind"
    }
  }, [_vm._v("绑定老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "temp"
    }
  }, [_vm._v("临时约课")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "口音",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.accent),
      callback: function($$v) {
        _vm.$set(_vm.filters, "accent", $$v)
      },
      expression: "filters.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "american"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "british"
    }
  }, [_vm._v("英音")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "性别",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.gender),
      callback: function($$v) {
        _vm.$set(_vm.filters, "gender", $$v)
      },
      expression: "filters.gender"
    }
  }, [_c('Option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "搜索日期",
      "clearable": false,
      "value": _vm.filters.occupyDate
    },
    on: {
      "on-change": _vm.onOccupyDateChange
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "级别",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.levelGroups),
      callback: function($$v) {
        _vm.$set(_vm.filters, "levelGroups", $$v)
      },
      expression: "filters.levelGroups"
    }
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "教材",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.materialCodes),
      callback: function($$v) {
        _vm.$set(_vm.filters, "materialCodes", $$v)
      },
      expression: "filters.materialCodes"
    }
  }, _vm._l((_vm.materialOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-actions"
  }, [_c('Button', {
    staticClass: "filter-btn",
    attrs: {
      "type": "primary",
      "size": "large",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v("\n              筛选\n            ")]), _vm._v(" "), _c('Button', {
    staticClass: "reset-btn",
    attrs: {
      "size": "large",
      "icon": "ios-refresh"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("\n              重置\n            ")]), _vm._v(" "), (_vm.canRunEmergencyPool && !_vm.isTrialPool) ? _c('Button', {
    staticClass: "run-check-btn",
    attrs: {
      "type": "warning",
      "size": "large",
      "loading": _vm.runCheckLoading
    },
    on: {
      "click": _vm.runEmergencyPoolCheck
    }
  }, [_vm._v("\n              手动执行\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "time-filter-grid"
  }, [_c('div', {
    staticClass: "time-filter-card required"
  }, [_c('div', {
    staticClass: "time-filter-title"
  }, [_vm._v("必选时段（筛选项）")]), _vm._v(" "), _c('div', {
    staticClass: "same-teacher-row"
  }, [_c('span', {
    staticClass: "same-teacher-label"
  }, [_vm._v("是否需要同一个老师")]), _vm._v(" "), _c('Select', {
    staticClass: "same-teacher-select",
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.sameTeacher),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sameTeacher", $$v)
      },
      expression: "filters.sameTeacher"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "time-row header"
  }, [_c('span', [_vm._v("周几")]), _vm._v(" "), _c('span', [_vm._v("上课时段")]), _vm._v(" "), _c('span', [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.filters.requiredSlots), function(item, index) {
    return _c('div', {
      key: 'required-' + index,
      staticClass: "time-row"
    }, [_c('Select', {
      attrs: {
        "placeholder": "周几",
        "transfer": ""
      },
      model: {
        value: (item.day),
        callback: function($$v) {
          _vm.$set(item, "day", $$v)
        },
        expression: "item.day"
      }
    }, _vm._l((_vm.daysOfWeek), function(day) {
      return _c('Option', {
        key: day.key,
        attrs: {
          "value": day.key
        }
      }, [_vm._v(_vm._s(day.label))])
    }), 1), _vm._v(" "), _c('Select', {
      attrs: {
        "placeholder": "上课时段",
        "transfer": ""
      },
      model: {
        value: (item.slotId),
        callback: function($$v) {
          _vm.$set(item, "slotId", $$v)
        },
        expression: "item.slotId"
      }
    }, _vm._l((_vm.timeSlots), function(slot) {
      return _c('Option', {
        key: slot.id,
        attrs: {
          "value": slot.id
        }
      }, [_vm._v(_vm._s(slot.label))])
    }), 1), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "icon": "trash-a"
      },
      on: {
        "click": function($event) {
          return _vm.removeSlotFilter('required', index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.addSlotFilter('required')
      }
    }
  }, [_vm._v("+必选时段")])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "matrix-container"
  }, [_c('div', {
    staticClass: "matrix-header"
  }, [_c('h3', [_vm._v("时段矩阵")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.weekRangeLabel) + "　点击单元格可多选必选时段，再点一次取消")])]), _vm._v(" "), _c('table', {
    staticClass: "matrix-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("时段")]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(day) {
    return _c('th', {
      key: day.key
    }, [_vm._v(_vm._s(day.label))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.timeSlots), function(slot) {
    return _c('tr', {
      key: slot.id
    }, [_c('td', {
      staticClass: "slot-label"
    }, [_vm._v(_vm._s(slot.label))]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(day) {
      return _c('td', {
        key: day.key,
        class: _vm.getCellClass(day.key, slot.id),
        on: {
          "click": function($event) {
            return _vm.handleCellClick(day.key, slot.id)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.getCellCount(day.key, slot.id)) + "\n                ")])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "teacher-list"
  }, [_c('div', {
    staticClass: "teacher-list-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h3', [_vm._v("外教列表")]), _vm._v(" "), _c('span', [_vm._v("共 " + _vm._s(_vm.filteredTeachers.length) + " 位符合条件的老师")]), _vm._v(" "), _c('span', {
    staticClass: "slot-legend"
  }, [_c('i', {
    staticClass: "slot-tag buyout"
  }), _vm._v("买断\n                "), _c('i', {
    staticClass: "slot-tag shortTerm"
  }), _vm._v("短期固定\n                "), _c('i', {
    staticClass: "slot-tag temp"
  }), _vm._v("临时\n                "), _c('i', {
    staticClass: "slot-tag schedule"
  }), _vm._v("已排课\n                "), _c('i', {
    staticClass: "slot-tag bound"
  }), _vm._v("已绑定\n                "), _c('i', {
    staticClass: "slot-tag leave"
  }), _vm._v("请假\n                "), _c('i', {
    staticClass: "slot-emergency-badge legend"
  }), _vm._v("应急\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "teacher-items"
  }, _vm._l((_vm.filteredTeachers), function(teacher) {
    return _c('div', {
      key: teacher.id,
      staticClass: "teacher-item"
    }, [_c('div', {
      staticClass: "teacher-info"
    }, [_c('div', {
      staticClass: "teacher-main"
    }, [_c('div', {
      staticClass: "teacher-name-row"
    }, [_c('a', {
      staticClass: "teacher-name",
      on: {
        "click": function($event) {
          return _vm.openTchInfoModal(teacher.id)
        }
      }
    }, [_vm._v(_vm._s(teacher.name))]), _vm._v(" "), (_vm.scoreText(teacher)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(teacher)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "teacher-id"
    }, [_vm._v("#" + _vm._s(teacher.id))])]), _vm._v(" "), _c('div', {
      staticClass: "teacher-meta"
    }, [_c('span', {
      class: ['priority-badge', ("p" + (teacher.priority))]
    }, [_vm._v("\n                      P" + _vm._s(teacher.priority) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "attr-tag gender"
    }, [(teacher.gender === 'male') ? _c('i', {
      staticClass: "ivu-icon ivu-icon-ios-man"
    }) : _c('i', {
      staticClass: "ivu-icon ivu-icon-ios-woman"
    }), _vm._v("\n                      " + _vm._s(teacher.gender === 'male' ? '男' : '女') + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "attr-tag accent"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-globe"
    }), _vm._v("\n                      " + _vm._s(teacher.accent === 'american' ? '美音' : '英音') + "\n                    ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-people"
    }), _vm._v("\n                      " + _vm._s(teacher.tchStudyAdviserName || '-') + "\n                    ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-calendar"
    }), _vm._v("\n                      " + _vm._s(teacher.hireDate) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "teacher-qualification"
    }, [_c('span', {
      staticClass: "qual-item pass"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-checkmark-circle"
    }), _vm._v("\n                      " + _vm._s(teacher.emergency === 1 ? '应急外教' : '非应急外教') + "\n                    ")]), _vm._v(" "), ((teacher.requiredMatchCount || 0) + (teacher.backupMatchCount || 0) > 0) ? _c('span', {
      staticClass: "qual-item match-info"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-funnel"
    }), _vm._v("\n                      必选 " + _vm._s(teacher.requiredMatchCount || 0) + " / 备选 " + _vm._s(teacher.backupMatchCount || 0) + "\n                    ")]) : _vm._e()])])]), _vm._v(" "), (_vm.getTeacherSlots(teacher.id).length > 0) ? _c('div', {
      staticClass: "teacher-slots"
    }, [_c('div', {
      staticClass: "slots-grid"
    }, _vm._l((_vm.getTeacherSlots(teacher.id)), function(daySlot) {
      return _c('div', {
        key: daySlot.day,
        staticClass: "day-slots"
      }, [_c('span', {
        staticClass: "day-label"
      }, [_vm._v(_vm._s(_vm.getDayLabel(daySlot.day)))]), _vm._v(" "), _c('div', {
        staticClass: "slot-tags"
      }, _vm._l((daySlot.slots), function(slot) {
        return _c('span', {
          key: slot.slotId,
          class: ['slot-tag', _vm.slotDisplayClass(slot)]
        }, [(_vm.isApprovedEmergencySlot(slot)) ? _c('i', {
          staticClass: "slot-emergency-badge",
          attrs: {
            "title": "应急时段"
          }
        }, [_vm._v("应急")]) : _vm._e(), _vm._v("\n                        " + _vm._s(slot.label || _vm.getSlotLabel(slot.slotId) || slot.slotId) + "\n                        "), (slot.status === 'schedule') ? [_vm._v("(已排课)")] : _vm._e(), _vm._v(" "), (slot.status === 'bound') ? [_vm._v("(已绑定)")] : _vm._e(), _vm._v(" "), (slot.status === 'leave') ? [_vm._v("(请假)")] : _vm._e(), _vm._v(" "), (slot.status === 'pending') ? [_vm._v("(待审)")] : _vm._e()], 2)
      }), 0)])
    }), 0)]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.filteredTeachers.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-person"
  }), _vm._v(" "), _c('p', [_vm._v("暂无符合条件的老师")])]) : _vm._e()])], 1), _vm._v(" "), (!_vm.isTrialPool) ? _c('TabPane', {
    attrs: {
      "label": "待审核时段",
      "name": "pending"
    }
  }, [_c('div', {
    staticClass: "pending-review"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pending-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h3', [_vm._v("待审核时段")]), _vm._v(" "), _c('Tag', {
    attrs: {
      "size": "small",
      "color": "#E6A23C"
    }
  }, [_vm._v(_vm._s(_vm.pendingList.length) + " 个待审核")])], 1), _vm._v(" "), (_vm.selectedIds.length > 0) ? _c('div', {
    staticClass: "header-right"
  }, [_c('span', {
    staticClass: "selected-count"
  }, [_vm._v("已选 " + _vm._s(_vm.selectedIds.length) + " 项")]), _vm._v(" "), _c('Button', {
    staticClass: "btn-success",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.batchApprove
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-checkmark"
  }), _vm._v(" 批量通过\n                ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn-danger",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.batchReject
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close"
  }), _vm._v(" 批量拒绝\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pending-info-bar"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-information-circle"
  }), _vm._v(" "), _c('span', [_vm._v("\n                当学生结课或停课后，空出的外教时段如符合应急时段条件，将自动锁定为\"待审核\"状态。\n                请审核后决定是否加入应急池。\n              ")])]), _vm._v(" "), (_vm.pendingList.length > 0) ? _c('div', {
    staticClass: "pending-list"
  }, [_c('Checkbox', {
    staticClass: "select-all-checkbox",
    on: {
      "on-change": _vm.handleSelectAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }, [_vm._v("\n                全选\n              ")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.selectedIds),
      callback: function($$v) {
        _vm.selectedIds = $$v
      },
      expression: "selectedIds"
    }
  }, _vm._l((_vm.pendingList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "pending-item"
    }, [_c('Checkbox', {
      staticClass: "item-checkbox",
      attrs: {
        "label": item.id
      }
    }, [_c('span')]), _vm._v(" "), _c('div', {
      staticClass: "pending-info"
    }, [_c('div', {
      staticClass: "pending-teacher"
    }, [_c('span', {
      staticClass: "teacher-name"
    }, [_vm._v(_vm._s(item.teacher && item.teacher.name || '未知老师'))]), _vm._v(" "), _c('span', {
      staticClass: "teacher-id"
    }, [_vm._v("#" + _vm._s(item.teacherId))]), _vm._v(" "), (item.teacher) ? _c('span', {
      class: ['qualification-badge', _vm.isQualified(item.teacher) ? 'qualified' : 'unqualified']
    }, [_vm._v("\n                      " + _vm._s(_vm.isQualified(item.teacher) ? '符合资格' : '不符合资格') + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "pending-slot"
    }, [_c('Tag', {
      attrs: {
        "size": "small",
        "color": "#E6A23C"
      }
    }, [_vm._v(_vm._s(_vm.getDayLabel(item.day)))]), _vm._v(" "), _c('Tag', {
      attrs: {
        "size": "small",
        "color": "#909399"
      }
    }, [_vm._v(_vm._s(_vm.getSlotLabel(item.slotId)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "pending-reason"
    }, [_c('Tag', {
      attrs: {
        "size": "small",
        "color": item.reason === 'student_completed' ? '#67C23A' : '#409EFF'
      }
    }, [_vm._v("\n                      " + _vm._s(item.reason === 'student_completed' ? '学生结课' : '学生停课') + "\n                    ")]), _vm._v(" "), (item.studentInfo) ? _c('span', [_vm._v(_vm._s(item.studentInfo))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "pending-time"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-time"
    }), _vm._v(" " + _vm._s(item.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "pending-actions"
    }, [_c('Button', {
      staticClass: "btn-success",
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.handleApprove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-checkmark"
    }), _vm._v(" 通过\n                  ")]), _vm._v(" "), _c('Button', {
      staticClass: "btn-danger",
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.handleReject(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-close"
    }), _vm._v(" 拒绝\n                  ")])], 1)], 1)
  }), 0)], 1) : _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-document"
  }), _vm._v(" "), _c('p', [_vm._v("暂无待审核时段")])])])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), (!_vm.isTrialPool) ? _c('Modal', {
    attrs: {
      "title": "手动执行",
      "mask-closable": false,
      "width": "420"
    },
    model: {
      value: (_vm.runRangeVisible),
      callback: function($$v) {
        _vm.runRangeVisible = $$v
      },
      expression: "runRangeVisible"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "transfer": ""
    },
    model: {
      value: (_vm.runDateRange),
      callback: function($$v) {
        _vm.runDateRange = $$v
      },
      expression: "runDateRange"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeRunRange
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.runCheckLoading
    },
    on: {
      "click": _vm.submitRunCheck
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.slotDetailTitle,
      "mask-closable": false,
      "width": "1200"
    },
    model: {
      value: (_vm.slotDetailVisible),
      callback: function($$v) {
        _vm.slotDetailVisible = $$v
      },
      expression: "slotDetailVisible"
    }
  }, [(_vm.slotDetailKind === 'used') ? _c('Date-picker', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onSlotDetailRangeChange
    },
    model: {
      value: (_vm.slotDetailDateRange),
      callback: function($$v) {
        _vm.slotDetailDateRange = $$v
      },
      expression: "slotDetailDateRange"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slotDetailKind === 'used') ? _c('div', {
    staticClass: "slot-detail-week"
  }, [_vm._v("统计范围 " + _vm._s(_vm.slotDetail.weekStart) + " ~ " + _vm._s(_vm.slotDetail.weekEnd) + "，共 " + _vm._s(_vm.slotDetail.total) + " 条")]) : _c('div', {
    staticClass: "slot-detail-week"
  }, [_vm._v("统计周 " + _vm._s(_vm.slotDetail.weekStart) + " ~ " + _vm._s(_vm.slotDetail.weekEnd) + "，共 " + _vm._s(_vm.slotDetail.total) + " 条")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.slotDetailColumns,
      "data": _vm.slotDetail.list,
      "loading": _vm.slotDetailLoading,
      "height": "480"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.slotDetailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon blue"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-person"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon green"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-time"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon purple"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-checkmark-circle"
  })])
}]}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": _vm.num > 1,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      staticClass: "upload-list"
    }, [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-list-cover"
    }, [(_vm.isView) ? _c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-mask",
    on: {
      "click": _vm.onCarouselClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "2002",
      "right": "40px",
      "top": "20px",
      "cursor": "hand"
    },
    on: {
      "click": _vm.onCarouselClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close",
      "color": "white",
      "size": "40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-content"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": false,
      "autoplay-speed": 1000,
      "dots": "outside",
      "trigger": "click",
      "arrow": "always"
    },
    model: {
      value: (_vm.showIndex),
      callback: function($$v) {
        _vm.showIndex = $$v
      },
      expression: "showIndex"
    }
  }, _vm._l((_vm.fileList), function(file) {
    return _c('CarouselItem', {
      key: file.url,
      staticClass: "item"
    }, [_c('img', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员批量减课时"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "BatchCourseChangeForm",
    staticClass: "form",
    attrs: {
      "model": _vm.BatchCourseChangeParam,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "id以 ; 拼接"
    },
    model: {
      value: (_vm.BatchCourseChangeParam.uIds),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "uIds", $$v)
      },
      expression: "BatchCourseChangeParam.uIds"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "courseType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.BatchCourseChangeParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "courseType", _vm._n($$v))
      },
      expression: "BatchCourseChangeParam.courseType"
    }
  }, _vm._l((_vm.courseTypeList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "减课时备注",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "减课时备注必填"
    },
    model: {
      value: (_vm.BatchCourseChangeParam.memo),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "memo", $$v)
      },
      expression: "BatchCourseChangeParam.memo"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBatchCourseChange
    },
    on: {
      "click": _vm.BatchCourseChange
    }
  }, [_vm._v("确定\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "调课件"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "lessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.lessonParam,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "classType"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.lessonParam.classType),
      callback: function($$v) {
        _vm.$set(_vm.lessonParam, "classType", _vm._n($$v))
      },
      expression: "lessonParam.classType"
    }
  }, _vm._l((_vm.$constant.classType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingChange
    },
    on: {
      "click": _vm.change
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("财务管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("收入统计")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "时间：",
      "label-width": 50
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.beginTimeChange
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.endTimeChange
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "支付方式："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.payWay),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "payWay", _vm._n($$v))
      },
      expression: "queryParam.payWay"
    }
  }, _vm._l((_vm.$constant.payWay), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生id"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员姓名：",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生姓名"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sum",
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "small"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "套餐金额："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.amountSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单金额："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.payAmountSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单课时："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.orderLessonNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠送课时："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.totalOtherDiscountNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "合计课节："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.totalLessonNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "本期消耗："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.periodUseNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "本期赠送："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.periodOtherDiscountNumSum))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "累计消耗："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.totalUseNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "剩余课时："
    }
  }, [_vm._v(" " + _vm._s(_vm.statisticsSum.leaveLessonNumSum))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时均价："
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numFilter")(_vm.statisticsSum.averagePriceSum)))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "本期收入："
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numFilter")(_vm.statisticsSum.periodIncomeSum)))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "剩余："
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numFilter")(_vm.statisticsSum.totalLeaveAmountSum)))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退费："
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numFilter")(_vm.statisticsSum.refundAmountSum)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n    ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "params": _vm.queryParam,
      "tableColumns": _vm.title,
      "listUrl": "/fundPackage/incomeStatistics",
      "reload": _vm.reload,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("权限组管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('')
      }
    }
  }, [_vm._v("添加分组")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminGroup/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.description),
      callback: function($$v) {
        _vm.$set(_vm.formData, "description", $$v)
      },
      expression: "formData.description"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑权限"
    },
    model: {
      value: (_vm.editPermissionModal),
      callback: function($$v) {
        _vm.editPermissionModal = $$v
      },
      expression: "editPermissionModal"
    }
  }, [_c('el-tree', {
    ref: "permissionTree",
    staticClass: "permission-tree",
    attrs: {
      "data": _vm.permissionData,
      "show-checkbox": "",
      "check-strictly": true,
      "node-key": "id",
      "default-checked-keys": _vm.checkKey
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editPermissionModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.editPermission
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "关联知识库"
    },
    model: {
      value: (_vm.kbBindModal),
      callback: function($$v) {
        _vm.kbBindModal = $$v
      },
      expression: "kbBindModal"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#808695",
      "font-size": "12px",
      "margin-bottom": "12px"
    }
  }, [_vm._v("员工仅能问答此处勾选的库；与菜单权限分开。")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.kbBindPlaceholder
    },
    model: {
      value: (_vm.kbBindIds),
      callback: function($$v) {
        _vm.kbBindIds = $$v
      },
      expression: "kbBindIds"
    }
  }, _vm._l((_vm.kbAllBases), function(b) {
    return _c('Option', {
      key: b.id,
      attrs: {
        "value": String(b.id)
      }
    }, [_vm._v(_vm._s(b.name) + " (" + _vm._s(b.externalKbId) + ")")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.kbBindModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.kbBindSaving
    },
    on: {
      "click": _vm.saveKbBind
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "disk-group-nav"
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "disk-group-nav-bar"
  }, [_c('div', {
    staticClass: "disk-group-nav-bar-left"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-compass"
    }
  }), _vm._v(" "), _c('span', [_vm._v("资料导航")])], 1), _vm._v(" "), _c('a', {
    staticClass: "disk-group-nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.expand.apply(null, arguments)
      }
    }
  }, [_vm._v("展开")])]) : _c('div', {
    staticClass: "disk-group-nav-panel"
  }, [_c('div', {
    staticClass: "disk-group-nav-title"
  }, [_c('strong', [_vm._v("教研群资料导航")]), _vm._v(" "), _c('a', {
    staticClass: "disk-group-nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('div', {
    staticClass: "disk-group-nav-cats"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('span', {
      key: cat.key,
      class: ['disk-group-nav-chip', {
        on: _vm.categoryKey === cat.key
      }],
      on: {
        "click": function($event) {
          return _vm.toggleCategory(cat.key)
        }
      }
    }, [_vm._v("\n        " + _vm._s(cat.title) + "\n        "), _c('a', {
      staticClass: "disk-group-nav-chip-open",
      attrs: {
        "title": "打开此分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openNode(cat.targetNodeId)
        }
      }
    }, [_vm._v("打开")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-group-nav-search"
  }, [_c('Input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "搜索导航入口"
    },
    on: {
      "on-change": _vm.onKeywordChange
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), (_vm.hasFilter) ? _c('a', {
    staticClass: "disk-group-nav-link",
    staticStyle: {
      "margin-left": "12px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilter.apply(null, arguments)
      }
    }
  }, [_vm._v("查看全部")]) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("加载导航…")]) : (_vm.loadError) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("\n      导航加载失败，请稍后重试\n      "), _c('a', {
    staticClass: "disk-group-nav-link",
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reload.apply(null, arguments)
      }
    }
  }, [_vm._v("重试")])]) : (!_vm.entries.length) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("暂无你有权访问的导航入口")]) : (!_vm.filteredEntries.length) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("没有匹配的入口，请更换关键词或查看全部")]) : _c('div', {
    staticClass: "disk-group-nav-cards"
  }, _vm._l((_vm.filteredEntries), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-group-nav-card",
      on: {
        "click": function($event) {
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_c('div', {
      staticClass: "disk-group-nav-card-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-summary"
    }, [_vm._v(_vm._s(item.summary))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-path"
    }, [_vm._v(_vm._s(item.pathLabel || './'))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-action"
    }, [_c('Button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "loading": _vm.openingId === item.targetNodeId
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_vm._v("打开文件夹")])], 1)])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "kpi-card",
    class: 'is-' + _vm.level
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm._t("default", function() {
    return [_c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(_vm.value)), (_vm.unit && _vm.value !== '—') ? _c('span', {
      staticClass: "kpi-unit"
    }, [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])]
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), (_vm.compare) ? _c('span', {
    staticClass: "kpi-compare",
    class: 'is-' + _vm.compareTone
  }, [_vm._v(_vm._s(_vm.compare))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v(_vm._s(_vm.foot))])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "老师基本信息",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Tabs', {
    key: _vm.tabBarKey,
    attrs: {
      "type": "card",
      "animated": false
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "基本信息"
    }
  }, [_c('Form', {
    ref: "tchForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.tchRule
    }
  }, [_c('Row', {
    attrs: {
      "span": "24"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("基本信息")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "First Name：",
      "prop": "firstName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.firstName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "firstName", $$v)
      },
      expression: "formData.firstName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "Last Name：",
      "prop": "lastName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastName", $$v)
      },
      expression: "formData.lastName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Full Name：",
      "prop": "fullName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.fullName),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "fullName", $$v)
      },
      expression: "formData.tchForm.fullName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "注册渠道："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tchForm.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "regFrom", $$v)
      },
      expression: "formData.tchForm.regFrom"
    }
  }, _vm._l((_vm.enabledChannelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "密码：",
      "required": _vm.isAddTch
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newPassword", $$v)
      },
      expression: "formData.newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "性别：",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8",
      "offset": "3"
    }
  }, [_c('a', {
    on: {
      "click": _vm.redirectToTchSystem
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "来源：",
      "prop": "channel"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.channel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "channel", $$v)
      },
      expression: "formData.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showBirthday) ? _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "生日：",
      "prop": "birthday"
    }
  }, [_c('Input', {
    attrs: {
      "type": "date",
      "name": "birthday"
    },
    on: {
      "on-change": _vm.onBirthdayChange
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", $$v)
      },
      expression: "formData.birthday"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "期望时薪：",
      "prop": "channel"
    }
  }, [_c('Input', {
    attrs: {
      "name": "salary"
    },
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData.tchForm, 'expectSalary')
      }
    },
    model: {
      value: (_vm.formData.tchForm.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "expectSalary", $$v)
      },
      expression: "formData.tchForm.expectSalary"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "学历："
    }
  }, [_c('Input', {
    attrs: {
      "name": "eduLevel",
      "placeholder": "例如：本科"
    },
    model: {
      value: (_vm.formData.eduLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "eduLevel", $$v)
      },
      expression: "formData.eduLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "合同："
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.editContract()
      }
    }
  }, [_vm._v("查看合同")])])], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "国籍："
    }
  }, [_c('Input', {
    attrs: {
      "name": "country"
    },
    model: {
      value: (_vm.formData.country),
      callback: function($$v) {
        _vm.$set(_vm.formData, "country", $$v)
      },
      expression: "formData.country"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.accent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "accent", $$v)
      },
      expression: "formData.accent"
    }
  }, _vm._l((_vm.$constant.accent), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(!_vm.isAddTch || _vm.saveType === 'agency') ? _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "类型：",
      "prop": "category"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "disabled": _vm.isAddTch && _vm.saveType === 'agency'
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", _vm._n($$v))
      },
      expression: "formData.category"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('InputNumber', {
    attrs: {
      "max": 100,
      "min": 1
    },
    on: {
      "on-change": _vm.onAgeChange
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.canEdit) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": _vm.formData.tchChannel === 1 ? '时薪：' : '时薪：'
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "name": "salary"
    },
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'salary')
      }
    },
    model: {
      value: (_vm.formData.salary),
      callback: function($$v) {
        _vm.$set(_vm.formData, "salary", $$v)
      },
      expression: "formData.salary"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#666"
    }
  }, [_vm._v("对外展示")]), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.tchForm.showSalary),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "showSalary", $$v)
      },
      expression: "formData.tchForm.showSalary"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAddTch) ? _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "授课类型：",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tchType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchType", _vm._n($$v))
      },
      expression: "formData.tchType"
    }
  }, _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "合同开始时间："
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.crtBeginTimeDateChange
    },
    model: {
      value: (_vm.formData.crtBeginTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "crtBeginTime", $$v)
      },
      expression: "formData.crtBeginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "合同结束时间："
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.crtEndTimeDateChange
    },
    model: {
      value: (_vm.formData.crtEndTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "crtEndTime", $$v)
      },
      expression: "formData.crtEndTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "介绍视频："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleIntroduceVideoUrl,
      "on-success": _vm.IntroduceVideoUrlSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadIntroduceVideoUrl,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.introduceVideoUrlList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.introduceVideoUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.introduceVideoUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.introduceVideoUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('VIDEO')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formData.editPermission) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "国籍图片："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleNationalityImageChange,
      "on-success": _vm.nationalityImageSuccess,
      "on-remove": _vm.nationalityImageRemove,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadNationalityImage,
      "accept": "image/*",
      "limit": 1,
      "file-list": _vm.nationalityImageUrlList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过30M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('div', {
    staticClass: "image-preview"
  }, [_c('viewer', [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "margin-top": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.nationalityImageUrl,
      "alt": "国籍图片预览"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.nationalityImageUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('NATIONALITY_IMAGE')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "上课片段："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTeachVideo,
      "on-success": _vm.teachVideoSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTeachVideo,
      "on-progress": _vm.handleProgress,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.teachVideoList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 100
    }
  }, _vm._l((_vm.teachVideoList), function(item, index) {
    return _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.openImage(item)
        }
      }
    }, [_vm._v("查看")])])
  }), 0)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "外教介绍："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "autosize": {
        minRows: 1,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formData.sign),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sign", $$v)
      },
      expression: "formData.sign"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("教学属性")])], 1), _vm._v(" "), _c('Row', [(_vm.canEdit && _vm.showTchSelf) ? _c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "老师上传："
    }
  }, [_c('i-col', [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TESOL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTESOL,
      "on-success": _vm.TESOLSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTesolUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTesolUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTesolUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTesolUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TESOL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEFL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEFL,
      "on-success": _vm.TEFLSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeflUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeflUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeflUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeflUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEFL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "英语专业："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleEnglish,
      "on-success": _vm.EnglishSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateEnglishUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateEnglishUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateEnglishUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateEnglishUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('ENGLISH')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "简历："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleResume,
      "on-success": _vm.resumeSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.resumeList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.resume) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.resume)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.resume) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('RESUME')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "自我介绍视频："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleSelfIntroductionVideo,
      "on-success": _vm.selfIntroductionVideoSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadIntroductionVideo,
      "on-progress": _vm.handleProgress,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.selfIntroductionVideoList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfIntroductionVideo),
      expression: "selfIntroductionVideo"
    }],
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.selfIntroductionVideo)
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfIntroductionVideo),
      expression: "selfIntroductionVideo"
    }],
    on: {
      "click": function($event) {
        return _vm.deleteUrl('SELFINTRODUCTIONVIDEO')
      }
    }
  }, [_vm._v("删除")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "对外展示："
    }
  }, [_c('i-col', [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TESOL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTESOLOut,
      "on-success": _vm.TESOLOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTesolOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTesolOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTesolOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTesolOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TESOLOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEFL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEFLOut,
      "on-success": _vm.TEFLOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeflOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeflOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeflOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeflOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEFLOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEYL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEYL,
      "on-success": _vm.TEYLSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeylUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeylUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeylUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeylUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEYL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "英语专业："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleEnglishOut,
      "on-success": _vm.EnglishOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateEnglishOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateEnglishOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateEnglishOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateEnglishOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('ENGLISHOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "教学经验："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.experience),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experience", $$v)
      },
      expression: "formData.experience"
    }
  }, _vm._l((20), function(i) {
    return _c('Option', {
      key: i,
      attrs: {
        "value": String(i)
      }
    }, [_vm._v(_vm._s(i))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "教学特色："
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: (_vm.featuresArray),
      callback: function($$v) {
        _vm.featuresArray = $$v
      },
      expression: "featuresArray"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("会中文")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("长的好看")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("道具多")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("活泼")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("TPR优秀")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v("在中国教过书")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v("会板书")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "8"
    }
  }, [_vm._v("会拓展")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "适宜级别："
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: (_vm.levelArray),
      callback: function($$v) {
        _vm.levelArray = $$v
      },
      expression: "levelArray"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("Level1")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("Level2")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("Level3-Level5")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("Level6-Level9")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("Wonders及其他")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v("PU")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "在线简历："
    }
  }, [(_vm.formData.id) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openDetailLink()
      }
    }
  }, [_vm._v("老师简历(网页版)")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 160,
      "label": "磨课视频/优秀上课展示："
    }
  }, _vm._l((_vm.polishLessonVideoList), function(url, index) {
    return _c('div', {
      key: 'polish-' + index,
      staticStyle: {
        "margin-bottom": "6px"
      }
    }, [_c('Input', {
      staticStyle: {
        "width": "280px"
      },
      attrs: {
        "placeholder": "粘贴文件地址"
      },
      model: {
        value: (_vm.polishLessonVideoList[index]),
        callback: function($$v) {
          _vm.$set(_vm.polishLessonVideoList, index, $$v)
        },
        expression: "polishLessonVideoList[index]"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (url),
        expression: "url"
      }],
      staticStyle: {
        "margin-left": "8px"
      },
      on: {
        "click": function($event) {
          return _vm.openImage(url)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (index === _vm.polishLessonVideoList.length - 1 && _vm.polishLessonVideoList.length < 10) ? _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-left": "8px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": _vm.addPolishLessonVideoRow
      }
    }) : _vm._e()], 1)
  }), 0)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "老师介绍："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleIntroduceDoc,
      "on-success": _vm.IntroduceDocSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "accept": "application/*",
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.introduceDocUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), (_vm.introduceDocUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.introduceDocUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.introduceDocUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('DOC')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "风采展示(照片)："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTeachImages,
      "on-success": _vm.teachImagesSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTeachImages,
      "on-progress": _vm.handleProgress,
      "limit": 10,
      "multiple": true,
      "file-list": _vm.teachImagesList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过30M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 100
    }
  }, _vm._l((_vm.images), function(item, index) {
    return _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.openImage(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.deleteImages('IMAGES', item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0)], 1), _vm._v(" "), (_vm.formData.account && _vm.canEdit) ? _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "登录账号:"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.formData.account) + "\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备注："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 200,
      "autosize": {
        minRows: 1,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("紧急联系方式")])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "邮箱："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.email),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "email", $$v)
      },
      expression: "formData.tchForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "紧急电话："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.mobileSos),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "mobileSos", $$v)
      },
      expression: "formData.tchForm.mobileSos"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Whatsapp账号："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.whatAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "whatAccount", $$v)
      },
      expression: "formData.tchForm.whatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Facebook账号："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.faceBook),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "faceBook", $$v)
      },
      expression: "formData.tchForm.faceBook"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Row', {
    attrs: {
      "span": "24"
    }
  }, [(_vm.canEdit) ? _c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "区号："
    }
  }, [_c('phone-area-select', {
    attrs: {
      "areaNumValue": _vm.formData.areaNum
    },
    on: {
      "on-change": _vm.onAreaNumChange
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "Microsoft Teams ID："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.skype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "skype", $$v)
      },
      expression: "formData.skype"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "手机号码："
    }
  }, [_c('Input', {
    attrs: {
      "number": true,
      "placeholder": "手机号和邮箱至少填一个"
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "email："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和邮箱至少填一个"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1), _vm._v(" "), (_vm.isAddTch) ? _c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "登录方式：",
      "prop": "loginBy"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.loginBy),
      callback: function($$v) {
        _vm.$set(_vm.formData, "loginBy", $$v)
      },
      expression: "formData.loginBy"
    }
  }, _vm._l((_vm.$constant.loginBy), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("系统权限")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "试听权限：",
      "prop": "isAudition"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isAudition", $$v)
      },
      expression: "formData.isAudition"
    }
  }, _vm._l((_vm.$constant.yn), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "是否录屏："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isRecordScreen),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isRecordScreen", $$v)
      },
      expression: "formData.isRecordScreen"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "专属老师："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "serviceType", $$v)
      },
      expression: "formData.serviceType"
    }
  }, _vm._l((_vm.$constant.serviceType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "临时约课权限："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tempSchedule),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tempSchedule", $$v)
      },
      expression: "formData.tempSchedule"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "16"
    }
  }, [_c('FormItem', {
    attrs: {
      "label-width": 80,
      "label": "无试听权限原因："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.invalidListenCause),
      callback: function($$v) {
        _vm.$set(_vm.formData, "invalidListenCause", $$v)
      },
      expression: "formData.invalidListenCause"
    }
  }), _vm._v(" "), (_vm.tchId) ? _c('a', {
    staticStyle: {
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.showInvalidListenCauseLog = true
      }
    }
  }, [_vm._v("历史")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [(this.tchId) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "可绑定权限：",
      "prop": "isCanBound"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isCanBound", _vm._n($$v))
      },
      expression: "formData.isCanBound"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "是否standby：",
      "prop": "isStandby"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isStandby),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isStandby", _vm._n($$v))
      },
      expression: "formData.isStandby"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "19:00-20:30不可用",
      "prop": "isStandby"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.disable18),
      callback: function($$v) {
        _vm.$set(_vm.formData, "disable18", _vm._n($$v))
      },
      expression: "formData.disable18"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("其他信息")])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "所在城市："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.townOrCity),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "townOrCity", $$v)
      },
      expression: "formData.tchForm.townOrCity"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "当前居住地："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "毕业院校："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.school),
      callback: function($$v) {
        _vm.$set(_vm.formData, "school", $$v)
      },
      expression: "formData.school"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "大学专业："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.major),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "major", $$v)
      },
      expression: "formData.tchForm.major"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "毕业年份："
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "year",
      "placeholder": "Select year",
      "value": _vm.formData.tchForm.yearOfGraduation
    },
    on: {
      "on-change": _vm.onYearChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "上传速度："
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'upSpeed')
      }
    },
    model: {
      value: (_vm.formData.upSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "upSpeed", $$v)
      },
      expression: "formData.upSpeed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("Mbps")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "下载速度："
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'downSpeed')
      }
    },
    model: {
      value: (_vm.formData.downSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "downSpeed", $$v)
      },
      expression: "formData.downSpeed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("Mbps")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备用网络："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.backUpInternetSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "backUpInternetSpeed", $$v)
      },
      expression: "formData.tchForm.backUpInternetSpeed"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备用电源："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.backUpPower),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "backUpPower", $$v)
      },
      expression: "formData.tchForm.backUpPower"
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.editPermission) ? _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "网络供应商："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.networkProviders),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "networkProviders", $$v)
      },
      expression: "formData.tchForm.networkProviders"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', [(_vm.formData.editPermission) ? _c('i-col', [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课表登记")])], 1), _vm._v(" "), _c('span', {
    staticClass: "course-tip"
  }, [_vm._v("时间表（北京时间）。点击单元格切换状态：√ 可用，? 不确定，× 不可用")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "course-table",
    attrs: {
      "role": "grid",
      "aria-label": "老师工作时间表"
    }
  }, [_c('div', {
    staticClass: "course-row course-header"
  }, [_c('div', {
    staticClass: "course-cell time-slot"
  }, [_vm._v("时间")]), _vm._v(" "), _vm._l((_vm.courseDays), function(day) {
    return _c('div', {
      key: day,
      staticClass: "course-cell"
    }, [_vm._v(_vm._s(day))])
  })], 2), _vm._v(" "), _vm._l((_vm.courseSlots), function(slot) {
    return _c('div', {
      key: slot,
      staticClass: "course-row"
    }, [_c('div', {
      staticClass: "course-cell time-slot"
    }, [_vm._v(_vm._s(slot))]), _vm._v(" "), _vm._l((_vm.courseDays), function(day, index) {
      return _c('div', {
        key: day + slot,
        staticClass: "course-cell selectable",
        class: _vm.availabilityClass(index + 1, slot),
        style: ({
          cursor: _vm.canEdit ? 'pointer' : 'default'
        }),
        on: {
          "click": function($event) {
            _vm.canEdit && _vm.toggleAvailability(index + 1, slot)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.availabilitySymbol(index + 1, slot)) + "\n                        ")])
    })], 2)
  })], 2)])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.canEdit) ? _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    staticClass: "cancel",
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.updateTchInfo
    }
  }, [_vm._v("保存")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.referrerTabVisible && _vm.detailTabRules.referrer) ? _c('Tab-pane', {
    attrs: {
      "label": "推荐官",
      "name": "推荐官"
    }
  }, [(_vm.tabName === '推荐官') ? _c('div', {
    staticClass: "referrer-tab"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("老师ID：")]), _vm._v(_vm._s(_vm.referrerDetail.referrerId) + "\n            ")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.referrerDetail.referrerName) + "\n            ")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.referrerMonthlyColumns,
      "data": _vm.referrerMonthlyStats,
      "loading": _vm.referrerMonthlyLoading,
      "size": "small",
      "border": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.detailTabRules.colorBlock) ? _c('Tab-pane', {
    attrs: {
      "label": "色块表",
      "name": "色块表"
    }
  }, [_c('div', {
    staticClass: "color-block-container"
  }, [_c('div', {
    ref: "searchWrapper",
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": false,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onColorDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Checkbox-group', {
    model: {
      value: (_vm.types),
      callback: function($$v) {
        _vm.types = $$v
      },
      expression: "types"
    }
  }, [_c('span', [_vm._v("显示：")]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#00DEFF"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "opened"
    }
  }, [_c('span', [_vm._v("买断时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#1B5E20"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "shortTerm"
    }
  }, [_c('span', [_vm._v("短期固定时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#66CC33"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "free"
    }
  }, [_c('span', [_vm._v("临时开课时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FF9900"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "schedule"
    }
  }, [_c('span', [_vm._v("常规课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FFCCFF"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "book"
    }
  }, [_c('span', [_vm._v("绑定时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#ffff00"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "test"
    }
  }, [_c('span', [_vm._v("试听课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FF6B6B"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "partner"
    }
  }, [_c('span', [_vm._v("陪练课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#AEAEAE"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "leave"
    }
  }, [_c('span', [_vm._v("老师请假")])])], 1)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_vm._l((_vm.groupedDataList), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex
    }, [_c('table', {
      staticClass: "table"
    }, [_c('timetable-header', {
      attrs: {
        "columns": _vm.titles
      }
    }), _vm._v(" "), _c('tbody', _vm._l((group), function(item) {
      return _c('timetable-row', {
        key: item.week,
        attrs: {
          "row": item,
          "columns": _vm.titles,
          "types": _vm.types
        }
      })
    }), 1)], 1)])
  }), _vm._v(" "), (!_vm.groupedDataList || _vm.groupedDataList.length === 0) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', {
    staticStyle: {
      "height": "40px",
      "text-align": "center"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "30"
    }
  }, [_vm._v("无数据")])])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.seeStuList && _vm.tchTrackFormData.tchId > 0 && _vm.detailTabRules.bindStu) ? _c('Tab-pane', {
    attrs: {
      "label": "在绑学生",
      "name": "在绑学生"
    }
  }, [_c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.titleStuList,
      "listUrl": "/tch/std-list",
      "params": _vm.tchTrackFormData,
      "onLoading": _vm.onLoading,
      "reload": _vm.reloadStuList,
      "pageSize": 100,
      "sync-route": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.seeTchTrack && _vm.detailTabRules.track) ? _c('Tab-pane', {
    attrs: {
      "label": "老师跟踪记录",
      "name": "老师跟踪记录"
    }
  }, [(_vm.tabName === '老师跟踪记录') ? _c('div', [_c('Form', {
    ref: "tchTrackRecordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.tchTrackFormData,
      "rules": _vm.tchTrackRule
    }
  }, [_c('Row', [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("新增记录")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 80
    }
  }, [_c('span', [_vm._v("老师：" + _vm._s(_vm.tchTrackFormData.tchId + '-' + _vm.tchTrackFormData.tchName))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("所属外管：" + _vm._s(_vm.tchTrackFormData.studyAdviserName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130,
      "label": "类型：",
      "prop": "trackType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchTrackFormData.trackType),
      callback: function($$v) {
        _vm.$set(_vm.tchTrackFormData, "trackType", $$v)
      },
      expression: "tchTrackFormData.trackType"
    }
  }, _vm._l((_vm.$constant.tchTrackRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130,
      "label": "内容：",
      "prop": "content"
    }
  }, [_c('div', {
    on: {
      "paste": _vm.handleContentPaste
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.tchTrackFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.tchTrackFormData, "content", $$v)
      },
      expression: "tchTrackFormData.content"
    }
  })], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传附件",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTrackFileChange,
      "on-success": _vm.trackFileSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTrackFile,
      "limit": 5,
      "multiple": "",
      "file-list": _vm.defaultPicsList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row'), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "soan": 12
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.formData.editPermission) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTrackRecord
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.resetTrackRecord
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("跟踪记录")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form', [_c('Form-item', {
    attrs: {
      "label": "类型：",
      "label-width": 60
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.trackType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "trackType", _vm._n($$v))
      },
      expression: "queryParam.trackType"
    }
  }, _vm._l((_vm.$constant.tchTrackRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('List', {
    key: 'tch-track-' + (_vm.tchId || 0),
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchTrack/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading2,
      "onSelection": _vm.onSelection,
      "operator": "",
      "sync-route": false
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.stat) ? _c('Tab-pane', {
    attrs: {
      "label": "数据统计",
      "name": "数据统计"
    }
  }, [(_vm.tabName === '数据统计') ? _c('div', {
    staticClass: "stat-tab"
  }, [_c('div', {
    staticClass: "stat-toolbar"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button",
      "disabled": _vm.statLoading
    },
    on: {
      "on-change": _vm.onStatPeriodChange
    },
    model: {
      value: (_vm.statPeriodType),
      callback: function($$v) {
        _vm.statPeriodType = $$v
      },
      expression: "statPeriodType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "day"
    }
  }, [_vm._v("日")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "week"
    }
  }, [_vm._v("周")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "month"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "year"
    }
  }, [_vm._v("年")])], 1), _vm._v(" "), _c('DatePicker', {
    key: _vm.statPeriodType,
    staticStyle: {
      "width": "160px",
      "margin-left": "12px"
    },
    attrs: {
      "type": _vm.statDatePickerType,
      "format": _vm.statDatePickerFormat,
      "value": _vm.statDate,
      "clearable": false,
      "disabled": _vm.statLoading,
      "transfer": "",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onStatDateChange
    }
  }), _vm._v(" "), (_vm.statPeriodType === 'week' && _vm.statWeekRangeText) ? _c('span', {
    staticClass: "stat-week-hint"
  }, [_vm._v(_vm._s(_vm.statWeekRangeText))]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.statLoading
    },
    on: {
      "click": _vm.loadPersonalStat
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "loading": _vm.statExportLoading
    },
    on: {
      "click": _vm.exportPersonalStat
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-grid"
  }, _vm._l((_vm.statCards), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "stat-card is-clickable",
      on: {
        "click": function($event) {
          return _vm.openStatDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "stat-card-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "stat-card-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "stat-card-sub"
    }, [_vm._v(_vm._s(item.sub))]), _vm._v(" "), (item.foot) ? _c('div', {
      staticClass: "stat-card-foot"
    }, [_vm._v(_vm._s(item.foot))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "stat-foot"
  }, [_vm._v("统计截至 " + _vm._s(_vm.personalStat.asOfTime || '—'))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.onboarding) ? _c('Tab-pane', {
    attrs: {
      "label": "开课Checklist",
      "name": "开课Checklist"
    }
  }, [(_vm.tabName === '开课Checklist') ? _c('div', {
    staticClass: "onboarding-tab"
  }, [(_vm.onboardingLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "onboarding-head"
  }, [_c('span', {
    staticClass: "onboarding-progress"
  }, [_vm._v("总进度：" + _vm._s(_vm.onboardingDoneCount) + "/" + _vm._s(_vm.onboardingTotalCount))]), _vm._v(" "), (_vm.onboardingVersionId) ? _c('span', {
    staticClass: "onboarding-version"
  }, [_vm._v("版本 " + _vm._s(_vm.onboardingVersionId))]) : _vm._e()]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.onboardingColumns,
      "data": _vm.onboardingRows,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.classFeedback) ? _c('Tab-pane', {
    attrs: {
      "label": "老师评分及课堂展示",
      "name": "老师评分及课堂展示"
    }
  }, [(_vm.tabName === '老师评分及课堂展示') ? _c('TeacherClassScore', {
    attrs: {
      "tchId": _vm.tchId
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('InvalidListenCauseLogModal', {
    attrs: {
      "tchId": _vm.tchId
    },
    model: {
      value: (_vm.showInvalidListenCauseLog),
      callback: function($$v) {
        _vm.showInvalidListenCauseLog = $$v
      },
      expression: "showInvalidListenCauseLog"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.statDetailModalTitle,
      "width": "880",
      "mask-closable": true,
      "transfer": ""
    },
    model: {
      value: (_vm.showStatDetailModal),
      callback: function($$v) {
        _vm.showStatDetailModal = $$v
      },
      expression: "showStatDetailModal"
    }
  }, [(_vm.statDetailSplit && !_vm.statDetailField) ? _c('div', [_c('p', {
    staticClass: "stat-week-hint",
    staticStyle: {
      "margin": "0 0 12px"
    }
  }, [_vm._v(_vm._s(_vm.statDetailSplitHint))]), _vm._v(" "), _c('div', {
    staticClass: "stat-grid"
  }, [_c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('numerator')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailLeftTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailLeftValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("分子")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('denominator')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailRightTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailRightValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("分母")])]), _vm._v(" "), (_vm.statDetailHasDiff) ? _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('nonFullLessons')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailDiffTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailDiffValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("差值")])]) : _vm._e()])]) : _c('div', [(_vm.statDetailSplit) ? _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backStatDetailCards.apply(null, arguments)
      }
    }
  }, [_vm._v("返回卡片")]), _vm._v(" "), _c('span', {
    staticClass: "stat-week-hint"
  }, [_vm._v(_vm._s(_vm.statDetailFieldTitle))])]) : _vm._e(), _vm._v(" "), (_vm.statDetailField === 'nonFullLessons') ? _c('p', {
    staticClass: "stat-week-hint",
    staticStyle: {
      "margin": "0 0 12px"
    }
  }, [_vm._v("\n        该老师区间内未全勤课节。迟到写出秒数；请假区分提前请假、临时请假；早退、缺席分别写出。学生请假、管理员取消、学生缺席且老师未缺席的课不计入。\n      ")]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.statDetailColumns,
      "data": _vm.statDetailTableData,
      "loading": _vm.statDetailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.statDetailTotal,
      "current": _vm.statDetailPageIndex,
      "page-size": _vm.statDetailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onStatDetailPageChange,
      "on-page-size-change": _vm.onStatDetailPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.statDetailExportLoading,
      "disabled": _vm.statDetailSplit && !_vm.statDetailField
    },
    on: {
      "click": _vm.exportStatDetail
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.statDetailSplit && _vm.statDetailField) ? _c('Button', {
    on: {
      "click": _vm.backStatDetailCards
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showStatDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("学员服务记录")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.queryParam.uid) + "-" + _vm._s(_vm.queryParam.nickName))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("添加时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.addTime),
      callback: function($$v) {
        _vm.addTime = $$v
      },
      expression: "addTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("下次联系时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("下次联系人：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.queryParam.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nextHandlerId", $$v)
      },
      expression: "queryParam.nextHandlerId"
    }
  }, _vm._l((_vm.adminList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nickname,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("操作人：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "支持模糊搜索",
      "size": "medium"
    },
    model: {
      value: (_vm.queryParam.createName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "createName", $$v)
      },
      expression: "queryParam.createName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("记录属性：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.trackTypeStr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "trackTypeStr", $$v)
      },
      expression: "queryParam.trackTypeStr"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "新注册学生",
      "value": "(1)"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分配记录",
      "value": "(11)"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "试听课记录",
      "value": "(21,22,23,24,25)"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "成交记录",
      "value": "(31,32)"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "交接记录",
      "value": "(41,42,43)"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "绑定记录",
      "value": "(51,52)"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "上课跟进记录",
      "value": "(61,62,63,64,65,66,67,68)"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "(99)"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("学生：" + _vm._s(_vm.queryParam.uid) + "-" + _vm._s(_vm.queryParam.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("课程顾问：" + _vm._s(_vm.adviserName))]), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("学习导师：" + _vm._s(_vm.studyAdviserName))]), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("绑定老师：" + _vm._s(_vm.bindTch))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "loading": _vm.onLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTrace
    }
  }, [_vm._v("添加记录\n        ")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "track-list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "rowspan": item.rowSpan,
        "hidden": item.hidden
      }
    }, [_vm._v(_vm._s(item.showName))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', [_c('TrackContentPreview', {
      attrs: {
        "content": item.content
      },
      on: {
        "view": function($event) {
          return _vm.openContentView(item)
        }
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "next-handler-time-col"
    }, [_c('span', {
      staticClass: "next-handler-time-text",
      attrs: {
        "title": _vm.formatNextHandlerTime(item)
      }
    }, [_vm._v(_vm._s(_vm.formatNextHandlerTime(item)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nextHandlerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createName))])])
  }), 0)]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.queryParam.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.queryParam.pageIndex,
      "pageSize": _vm.queryParam.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "跟踪记录内容",
      "width": "720",
      "mask-closable": false
    },
    model: {
      value: (_vm.contentVisible),
      callback: function($$v) {
        _vm.contentVisible = $$v
      },
      expression: "contentVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "size": "small"
    },
    on: {
      "on-change": _vm.switchContentView
    },
    model: {
      value: (_vm.contentViewMode),
      callback: function($$v) {
        _vm.contentViewMode = $$v
      },
      expression: "contentViewMode"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "markdown"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "raw",
      "disabled": !_vm.contentRawText
    }
  }, [_vm._v("原文")])], 1), _vm._v(" "), (!_vm.contentRawText) ? _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("无原始内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.contentViewMode === 'markdown') ? _c('div', {
    ref: "contentExportArea",
    staticClass: "track-md track-md-dialog",
    domProps: {
      "innerHTML": _vm._s(_vm.contentHtml)
    }
  }) : _c('pre', {
    ref: "contentExportArea",
    staticClass: "track-raw-dialog"
  }, [_vm._v(_vm._s(_vm.contentRawText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportImageLoading,
      "disabled": _vm.exportImageLoading || (_vm.contentViewMode === 'markdown' ? !_vm.contentHtml : !_vm.contentRawText)
    },
    on: {
      "click": _vm.exportContentPng
    }
  }, [_vm._v("导出 PNG")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contentVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("记录属性")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('th', {
    staticClass: "next-handler-time-col"
  }, [_vm._v("下次联系日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系人")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("操作人")])])])
}]}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "加减课时"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.classHourParam,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.showUid) ? _c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "学生id",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入学生id"
    },
    model: {
      value: (_vm.classHourParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "uid", _vm._n($$v))
      },
      expression: "classHourParam.uid"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "class"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "transfer": ""
    },
    model: {
      value: (_vm.classHourParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "courseType", _vm._n($$v))
      },
      expression: "classHourParam.courseType"
    }
  }, _vm._l((_vm.$constant.newCourseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "加减课时数量",
      "prop": "num"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入课时数"
    },
    model: {
      value: (_vm.classHourParam.num),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "num", _vm._n($$v))
      },
      expression: "classHourParam.num"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "赠课类型",
      "prop": "givingType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择类型",
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeGivingType
    },
    model: {
      value: (_vm.classHourParam.givingType),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "givingType", _vm._n($$v))
      },
      expression: "classHourParam.givingType"
    }
  }, _vm._l((_vm.$constant.givingType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.classHourParam.givingType === 2 || _vm.classHourParam.givingType === 3 ||
    _vm.classHourParam.givingType === 5 || _vm.classHourParam.givingType === 6 || _vm.classHourParam.givingType === 7) ? _c('Form-item', {
    attrs: {
      "label": "子类型",
      "prop": "givingTypeChild"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.classHourParam.givingTypeChild),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "givingTypeChild", _vm._n($$v))
      },
      expression: "classHourParam.givingTypeChild"
    }
  }, _vm._l((_vm.givingTypeChild), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.classHourParam.givingType === 2) ? _c('FormItem', {
    attrs: {
      "label": "被推荐人",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID"
    },
    model: {
      value: (_vm.classHourParam.inviteUid),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "inviteUid", $$v)
      },
      expression: "classHourParam.inviteUid"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.classHourParam.givingType === 1 || _vm.classHourParam.givingType === 2 || _vm.classHourParam.givingType === 4 || _vm.classHourParam.givingType === 6 || _vm.classHourParam.givingType === 7 || _vm.classHourParam.givingType === 11) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.classHourParam.url),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "url", $$v)
      },
      expression: "classHourParam.url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.classHourParam.givingType === 4 || _vm.classHourParam.givingType === 5 || _vm.classHourParam.givingType === 6) ? _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('TeacherSelect', {
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "category": [1, 2]
    },
    model: {
      value: (_vm.classHourParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "tchId", _vm._n($$v))
      },
      expression: "classHourParam.tchId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.classHourParam.givingType === 4) ? _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "上课时间",
      "prop": "classTime",
      "required": ""
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.classHourParam.classTime
    },
    on: {
      "on-change": _vm.classTimeDateChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.classHourParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "reason", $$v)
      },
      expression: "classHourParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("已结束课表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.startTimeDate
    },
    on: {
      "on-change": _vm.startTimeDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.endTimeDate
    },
    on: {
      "on-change": _vm.endTimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "studyAdviserNickname"
    },
    model: {
      value: (_vm.queryParam.studyAdviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserNickname", $$v)
      },
      expression: "queryParam.studyAdviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adviserNickname"
    },
    model: {
      value: (_vm.queryParam.adviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserNickname", $$v)
      },
      expression: "queryParam.adviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchCategory),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchCategory", _vm._n($$v))
      },
      expression: "queryParam.tchCategory"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnSelStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnSelStatus", _vm._n($$v))
      },
      expression: "queryParam.lsnSelStatus"
    }
  }, _vm._l((_vm.$constant.lsnSelStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "courseType", _vm._n($$v))
      },
      expression: "queryParam.courseType"
    }
  }, _vm._l((_vm.$constant.courseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchStudyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchStudyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.tchStudyAdviserId"
    }
  }, _vm._l((_vm.tchStudyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchEmail"
    },
    model: {
      value: (_vm.queryParam.tchEmail),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchEmail", $$v)
      },
      expression: "queryParam.tchEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "评论时效"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.reviewState),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "reviewState", _vm._n($$v))
      },
      expression: "queryParam.reviewState"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("正常评价")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("超时评价")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("超时未评价")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.checkStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "checkStatus", _vm._n($$v))
      },
      expression: "queryParam.checkStatus"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedCheckStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生是否投诉"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.userIsComplaint),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userIsComplaint", $$v)
      },
      expression: "queryParam.userIsComplaint"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师是否评价"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchIsFeedback),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchIsFeedback", $$v)
      },
      expression: "queryParam.tchIsFeedback"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否单元报告"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.stageSummary),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stageSummary", $$v)
      },
      expression: "queryParam.stageSummary"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否是第 10 课"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isTenthLesson),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isTenthLesson", $$v)
      },
      expression: "queryParam.isTenthLesson"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "finished-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLesson/finished/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('BalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBalanceModal),
      callback: function($$v) {
        _vm.showBalanceModal = $$v
      },
      expression: "showBalanceModal"
    }
  }), _vm._v(" "), _c('RejectBalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showRejectBalanceModal),
      callback: function($$v) {
        _vm.showRejectBalanceModal = $$v
      },
      expression: "showRejectBalanceModal"
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookUserFeedBackClose
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchFeedBackClose
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchScoreFeedBackClose
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  }), _vm._v(" "), _c('ClassMemberTimeModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onClassMemberClose
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewDemoModal,
      "formData": _vm.studentWriteReviewDemoModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewRegularModal,
      "formData": _vm.studentWriteReviewRegularModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewFinishLevelModal,
      "formData": _vm.studentWriteReviewFinishLevelModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('MonitorLessonRecordListModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordListModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordListModal = $$v
      },
      expression: "showMonitorLessonRecordListModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.uid))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "学生个人信息"
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生头像:",
      "prop": "avatarUrl"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.openStudentPage
    }
  }, [(_vm.student.avatarUrl) ? _c('img', {
    attrs: {
      "src": _vm.student.avatarUrl,
      "alt": "",
      "width": "40px"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/defaultAvatar.jpeg",
      "alt": "",
      "width": "40px"
    }
  })])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名:",
      "prop": "nickname"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.nickname) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号:",
      "prop": "mobile"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.mobile) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别:",
      "prop": "sex"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.stringSex) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "生日:",
      "prop": "birthday"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.stringBirthday) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学校:",
      "prop": "school"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.school) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮箱:",
      "prop": "email"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.email) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "qq:",
      "prop": "qq"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.qq) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所在地区:",
      "prop": "province"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.province) + _vm._s(_vm.student.city) + _vm._s(_vm.student.zone) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "地址:",
      "prop": "address"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.address) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goFolder(0)
      }
    }
  }, [_vm._v("外教中心展示资料")])]), _vm._v(" "), _vm._l((_vm.folderTrail), function(item, idx) {
    return _c('Breadcrumb-item', {
      key: 'f' + item.id
    }, [(idx < _vm.folderTrail.length - 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.goFolder(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('span', [_vm._v(_vm._s(item.title))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "标题："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "default",
      "icon": "folder"
    },
    on: {
      "click": function($event) {
        return _vm.openFolderModal()
      }
    }
  }, [_vm._v("新建文件夹")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchLearningMaterial/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.editingFolder ? '编辑文件夹' : (_vm.formData.id ? '编辑资料' : '新增资料'),
      "width": "640",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "文件",
      "prop": "fileUrl"
    }
  }, [_c('FileUpload', {
    attrs: {
      "defaultFileList": _vm.defaultFileList,
      "num": 1,
      "text": "点击或拖拽上传资料"
    },
    on: {
      "on-file-change": _vm.onFileChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "可见范围",
      "prop": "visibleType"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.visibleType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "visibleType", $$v)
      },
      expression: "formData.visibleType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部老师")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("欧美外教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("菲教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("指定老师")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder && _vm.formData.visibleType === 1) ? _c('FormItem', {
    attrs: {
      "label": "指定老师",
      "prop": "tchIds"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择外教"
    },
    model: {
      value: (_vm.formData.tchIds),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchIds", $$v)
      },
      expression: "formData.tchIds"
    }
  }, _vm._l((_vm.tchList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "有效天数"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "min": 0,
      "max": 3650
    },
    model: {
      value: (_vm.formData.effectDays),
      callback: function($$v) {
        _vm.$set(_vm.formData, "effectDays", $$v)
      },
      expression: "formData.effectDays"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999"
    }
  }, [_vm._v("0 或空表示长期有效")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "首页弹窗"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#999",
      "line-height": "20px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("不添加周期时，老师确认一次后不再提示")]), _vm._v(" "), _vm._l((_vm.formData.popupPeriods), function(period, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_c('DatePicker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "date",
        "format": "yyyy-MM-dd",
        "placeholder": "开始日期"
      },
      model: {
        value: (period.startDate),
        callback: function($$v) {
          _vm.$set(period, "startDate", $$v)
        },
        expression: "period.startDate"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "0 4px"
      }
    }, [_vm._v("至")]), _vm._v(" "), _c('DatePicker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "date",
        "format": "yyyy-MM-dd",
        "placeholder": "结束日期"
      },
      model: {
        value: (period.endDate),
        callback: function($$v) {
          _vm.$set(period, "endDate", $$v)
        },
        expression: "period.endDate"
      }
    }), _vm._v(" "), _c('Select', {
      staticStyle: {
        "width": "90px",
        "margin-left": "6px"
      },
      model: {
        value: (period.freq),
        callback: function($$v) {
          _vm.$set(period, "freq", $$v)
        },
        expression: "period.freq"
      }
    }, [_c('Option', {
      attrs: {
        "value": 1
      }
    }, [_vm._v("每天")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": 2
      }
    }, [_vm._v("每周")])], 1), _vm._v(" "), _c('Button', {
      staticStyle: {
        "margin-left": "4px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removePopupPeriod(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.addPopupPeriod
    }
  }, [_vm._v("添加周期")])], 2) : _vm._e(), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建文件夹",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showFolderModal),
      callback: function($$v) {
        _vm.showFolderModal = $$v
      },
      expression: "showFolderModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "文件夹名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入文件夹名称"
    },
    model: {
      value: (_vm.folderForm.title),
      callback: function($$v) {
        _vm.$set(_vm.folderForm, "title", $$v)
      },
      expression: "folderForm.title"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.folderForm.status),
      callback: function($$v) {
        _vm.$set(_vm.folderForm, "status", $$v)
      },
      expression: "folderForm.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showFolderModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.folderSaving
    },
    on: {
      "click": _vm.onSaveFolder
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览",
      "width": "960",
      "footer-hide": ""
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [_c('FilePreview', {
    attrs: {
      "file-url": _vm.previewUrl,
      "type": _vm.previewType,
      "file-name": _vm.previewFileName
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dragon-tiger-rank-v2"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trophy",
      "size": "32",
      "color": "#f39c12"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("龙虎榜")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("销售部业绩排行榜")])], 1), _vm._v(" "), (_vm.newOrderList.length > 0) ? _c('div', {
    staticClass: "news-marquee"
  }, [_c('div', {
    staticClass: "marquee-content"
  }, _vm._l((_vm.newOrderList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "marquee-item"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-notifications",
        "size": "14",
        "color": "#ff9900"
      }
    }), _vm._v("\n              " + _vm._s(item) + " 🎉🎉🎉\n            ")], 1)
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('Card', {
    staticClass: "search-card"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.month),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "month", $$v)
      },
      expression: "queryParam.month"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部门",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.adviserGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserGroup", $$v)
      },
      expression: "queryParam.adviserGroup"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser",
      "not-in-id": [474, 468]
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "师资",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择渠道来源",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "xs": 12,
      "sm": 6,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n                搜索\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "rank-card"
  }, [_c('div', {
    staticClass: "rank-card-header"
  }, [_c('span', {
    staticClass: "rank-title"
  }, [_vm._v("排行榜")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download-outline",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportToImage
    }
  }, [_vm._v("\n            导出图片\n          ")])], 1), _vm._v(" "), _c('div', {
    ref: "exportArea",
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "rank-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "rank-col"
  }, [_vm._v("排名")]), _vm._v(" "), _c('th', {
    staticClass: "dept-col"
  }, [_vm._v("部门")]), _vm._v(" "), _c('th', {
    staticClass: "name-col"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticClass: "quantity-col"
  }, [_vm._v("单量")]), _vm._v(" "), _c('th', {
    staticClass: "amount-col"
  }, [_vm._v("业绩")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rankingData), function(item, index) {
    return _c('tr', {
      key: index,
      class: ['rank-row', _vm.getRankClass(item.rank)]
    }, [_c('td', {
      staticClass: "rank-col"
    }, [_c('div', {
      staticClass: "rank-badge",
      class: _vm.getMedalClass(item.rank)
    }, [(item.rank <= 3) ? _c('span', [_vm._v(_vm._s(_vm.getMedalIcon(item.rank)))]) : _c('span', [_vm._v(_vm._s(item.rank))])])]), _vm._v(" "), _c('td', {
      staticClass: "dept-col"
    }, [_vm._v(_vm._s(_vm.getDepartmentText(item.department)))]), _vm._v(" "), _c('td', {
      staticClass: "name-col"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.goToPerformanceDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.adviserName))])]), _vm._v(" "), _c('td', {
      staticClass: "quantity-col"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "amount-col"
    }, [_vm._v("¥ " + _vm._s(_vm.$numeral(item.amount).format('0,0')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', {
    staticClass: "total-col total-label",
    attrs: {
      "colspan": "3"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#2d8cf0",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.goToTotalPerformanceDetail
    }
  }, [_c('strong', [_vm._v("Total")])])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.$numeral(_vm.totalAmount).format('0,0')))])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  })])], 2)])]), _vm._v(" "), (_vm.rankingData.length === 0 && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-inbox",
      "size": "60",
      "color": "#dcdee2"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试做试卷")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.form.examType),
      callback: function($$v) {
        _vm.$set(_vm.form, "examType", $$v)
      },
      expression: "form.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "出生年"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "年"
    },
    model: {
      value: (_vm.form.birthYear),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthYear", $$v)
      },
      expression: "form.birthYear"
    }
  }, _vm._l((_vm.birthYears), function(y) {
    return _c('Option', {
      key: 'by' + y,
      attrs: {
        "value": y
      }
    }, [_vm._v(_vm._s(y) + " 年")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "出生月"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "月"
    },
    model: {
      value: (_vm.form.birthMonth),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthMonth", $$v)
      },
      expression: "form.birthMonth"
    }
  }, _vm._l((12), function(m) {
    return _c('Option', {
      key: 'bm' + m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m) + " 月")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.form.examType === 'PLACEMENT') ? _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "宝贝目前的英语水平"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "与 App 探险证同一套五档"
    },
    model: {
      value: (_vm.form.selfLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "selfLevel", $$v)
      },
      expression: "form.selfLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ZERO"
    }
  }, [_vm._v("基本零基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BEGINNER"
    }
  }, [_vm._v("刚入门")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("有基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "GOOD"
    }
  }, [_vm._v("挺不错")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FLUENT"
    }
  }, [_vm._v("很熟练")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.examType === 'SUMMATIVE') ? _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "当前课程级别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "与学生当前级别一致"
    },
    model: {
      value: (_vm.form.courseLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseLevel", $$v)
      },
      expression: "form.courseLevel"
    }
  }, _vm._l((_vm.courseLevels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题方式"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择抽题方式"
    },
    model: {
      value: (_vm.form.shuffle),
      callback: function($$v) {
        _vm.$set(_vm.form, "shuffle", $$v)
      },
      expression: "form.shuffle"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("按权重从高到低（接近引擎）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("随机（方便多抽几套）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.drawing
    },
    on: {
      "click": _vm.drawBlueprint
    }
  }, [_vm._v("开始抽题")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.drawing
    },
    on: {
      "click": function($event) {
        return _vm.drawWalk('TYPES')
      }
    }
  }, [_vm._v("试做所有题型")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.drawing
    },
    on: {
      "click": function($event) {
        return _vm.drawWalk('ALL')
      }
    }
  }, [_vm._v("做所有题目")]), _vm._v(" "), (_vm.paper) ? _c('Button', {
    on: {
      "click": _vm.resetPaper
    }
  }, [_vm._v("清空本套")]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.paper.sessionId) ? _c('Button', {
    on: {
      "click": _vm.goSession
    }
  }, [_vm._v("查看场次记录")]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.paper.sessionId && (_vm.report || _vm.paper.sessionStatus === 'READY')) ? _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.loadReport
    }
  }, [_vm._v("查看模拟报告")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("「开始抽题」按蓝图抽一套。「试做所有题型」每种呈现形态一道。「做所有题目」通刷该考试类型已上线全库，题量会很多。")])], 1)], 1), _vm._v(" "), (_vm.paper && _vm.paper.warnings && _vm.paper.warnings.length) ? _c('Alert', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, _vm._l((_vm.paper.warnings), function(w, i) {
    return _c('p', {
      key: 'w' + i
    }, [_vm._v(_vm._s(w))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('div', {
    staticClass: "mex-trial-explain"
  }, [_c('h3', [_vm._v("抽题规则")]), _vm._v(" "), _c('ol', _vm._l(((_vm.paper.rules || [])), function(r, i) {
    return _c('li', {
      key: 'rule' + i
    }, [_vm._v(_vm._s(r))])
  }), 0), _vm._v(" "), _c('h3', [_vm._v("使用的蓝图")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.bpColumns,
      "data": _vm.paper.blueprints || [],
      "size": "small"
    }
  }), _vm._v(" "), (!_vm.isWalkPaper) ? [_c('h3', [_vm._v("槽位对照")]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("橙色行＝应抽不足；浅黄行＝已放宽 exam_scene/级别。业务键可回题库核对。")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.traceColumns,
      "data": _vm.paper.traces || [],
      "size": "small",
      "row-class-name": _vm.traceRowClass
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.prepVisible) ? _c('div', {
    staticClass: "mex-trial-phone-wrap"
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("以下按《机考全流程设计规范 v2.5》模拟 App 测试前准备，通过后才进入答题。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-phone"
  }, [_c('div', {
    staticClass: "mex-trial-phone-bar"
  }, [_vm._v("迷雾森林 · 松鼠松果大冒险")]), _vm._v(" "), (_vm.prepStep === 'consent') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("欢迎来到迷雾森林")]), _vm._v(" "), _c('p', [_vm._v("请让孩子独立答题，不要提示或帮忙。")]), _vm._v(" "), _c('p', [_vm._v("请保持环境安静，测试时不要打扰。")]), _vm._v(" "), _c('p', [_vm._v("请仅协助操作设备，不干预答题过程。")]), _vm._v(" "), _c('p', [_vm._v("请保证结果真实，匹配适合的学习内容。")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.prep.agreed),
      callback: function($$v) {
        _vm.$set(_vm.prep, "agreed", $$v)
      },
      expression: "prep.agreed"
    }
  }, [_vm._v("我已阅读并同意以上公约，以及《用户隐私政策》《儿童个人信息保护规则》")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.agreed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('CONSENT')
      }
    }
  }, [_vm._v("同意并开始")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'profile') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("领取你的森林探险证")]), _vm._v(" "), _c('p', [_vm._v("填写年龄可以帮助我们更准确地匹配题目难度")]), _vm._v(" "), _c('p', [_vm._v("出生年月")]), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "年"
    },
    model: {
      value: (_vm.prep.birthYear),
      callback: function($$v) {
        _vm.$set(_vm.prep, "birthYear", $$v)
      },
      expression: "prep.birthYear"
    }
  }, _vm._l((_vm.birthYears), function(y) {
    return _c('Option', {
      key: y,
      attrs: {
        "value": y
      }
    }, [_vm._v(_vm._s(y) + " 年")])
  }), 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "月"
    },
    model: {
      value: (_vm.prep.birthMonth),
      callback: function($$v) {
        _vm.$set(_vm.prep, "birthMonth", $$v)
      },
      expression: "prep.birthMonth"
    }
  }, _vm._l((12), function(m) {
    return _c('Option', {
      key: m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m) + " 月")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.paper.examType === 'PLACEMENT') ? [_c('p', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("宝贝目前的英语水平")]), _vm._v(" "), _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "已按此档抽卷"
    },
    model: {
      value: (_vm.prep.selfLevel),
      callback: function($$v) {
        _vm.$set(_vm.prep, "selfLevel", $$v)
      },
      expression: "prep.selfLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ZERO"
    }
  }, [_vm._v("基本零基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BEGINNER"
    }
  }, [_vm._v("刚入门")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("有基础")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "GOOD"
    }
  }, [_vm._v("挺不错")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FLUENT"
    }
  }, [_vm._v("很熟练")])], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("已按此档抽卷，准备流里不能再改档位。")])] : _c('p', {
    staticClass: "mex-dim-hint",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("阶段测按当前课程级别 " + _vm._s(_vm.paper.courseLevel) + " 抽卷，不填英语自评。")]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-top": "12px"
    },
    model: {
      value: (_vm.prep.profileAgreed),
      callback: function($$v) {
        _vm.$set(_vm.prep, "profileAgreed", $$v)
      },
      expression: "prep.profileAgreed"
    }
  }, [_vm._v("同意使用以上信息提供测评服务，仅用于匹配题目难度，不会对外公开")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.profileAgreed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('PROFILE')
      }
    }
  }, [_vm._v("下一步")])], 2) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'audio') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("先试试你的探险耳机")]), _vm._v(" "), _c('p', [_vm._v("点击播放，听听小松鼠说话。如果能清楚听到声音，就可以继续。")]), _vm._v(" "), _c('Button', {
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.playAudio
    }
  }, [_vm._v("▶ 播放测试音频")]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("如果声音太小或太大，可以调整设备音量")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.audioPlayed,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('AUDIO')
      }
    }
  }, [_vm._v("听得到，下一步")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'mic') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("再试试你的魔法麦克风")]), _vm._v(" "), _c('p', [_vm._v("点击后 3 秒倒计时，再说一句 Hello, squirrel! 会自动录 3 秒并回听。")]), _vm._v(" "), (_vm.prep.micHint) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.prep.micHint))]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "long": "",
      "disabled": _vm.prep.micBusy
    },
    on: {
      "click": _vm.startMic
    }
  }, [_vm._v("开始录音调试")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "disabled": !_vm.prep.micOk,
      "loading": _vm.preparing
    },
    on: {
      "click": function($event) {
        return _vm.submitPrep('MIC')
      }
    }
  }, [_vm._v("没问题，开始探险")])], 1) : _vm._e(), _vm._v(" "), (_vm.prepStep === 'loading') ? _c('div', {
    staticClass: "mex-trial-phone-body"
  }, [_c('h3', [_vm._v("正在准备森林探险...")]), _vm._v(" "), _c('Progress', {
    attrs: {
      "percent": _vm.prep.loadPct,
      "stroke-width": 12
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.paper && _vm.inExam) ? _c('div', {
    staticClass: "mex-trial-wrap"
  }, [_c('div', {
    staticClass: "mex-trial-nav"
  }, [_c('p', [_vm._v("蓝图 " + _vm._s(_vm.paper.blueprintVersion) + " · " + _vm._s(_vm.segmentLabel(_vm.paper.segment)) + " · 限时 " + _vm._s(_vm.paper.durationSec || '—') + " 秒 · 场次 " + _vm._s(_vm.paper.sessionId) + " · 共 " + _vm._s(_vm.items.length) + " 题 · 已做 " + _vm._s(_vm.doneCount) + " · 得分 " + _vm._s(_vm.totalGot) + " / " + _vm._s(_vm.totalFull))]), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("提交本题会写入场次记录（可回放）；不计入题目曝光统计。「下一题」若还没交会先提交再跳。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-dots"
  }, _vm._l((_vm.items), function(it) {
    return _c('span', {
      key: it.seq,
      staticClass: "mex-trial-dot",
      class: _vm.dotClass(it),
      on: {
        "click": function($event) {
          return _vm.go(it.seq - 1)
        }
      }
    }, [_vm._v(_vm._s(it.seq))])
  }), 0), _vm._v(" "), (_vm.showGuide) ? _c('div', {
    staticClass: "mex-trial-guide",
    on: {
      "click": function($event) {
        _vm.showGuide = false
      }
    }
  }, [_vm._v("认真做题就能收集金色松果哦！不会做的题可以点「跳过」，加油！")]) : _vm._e()]), _vm._v(" "), (_vm.current) ? _c('div', {
    staticClass: "mex-trial-card"
  }, [_c('p', {
    staticClass: "mex-trial-meta"
  }, [_vm._v("\n        第 " + _vm._s(_vm.current.seq) + " 题 · " + _vm._s(_vm.skillLabel(_vm.current.skill)) + " · " + _vm._s(_vm.current.questionType) + " · " + _vm._s(_vm.current.businessCode) + " · " + _vm._s(_vm.catReasonLabel(_vm.current.catReason)) + " · 满分 " + _vm._s(_vm.current.fullScore || 1) + "\n      ")]), _vm._v(" "), (_vm.current.issues && _vm.current.issues.length) ? _c('Alert', {
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n        题目可能有错：" + _vm._s(_vm.current.issues.join('；')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.current.instructionCn) ? _c('p', [_c('b', [_vm._v("中文指令")]), _vm._v(" " + _vm._s(_vm.current.instructionCn))]) : _vm._e(), _vm._v(" "), (_vm.current.instructionEn) ? _c('p', [_c('b', [_vm._v("英文指令")]), _vm._v(" " + _vm._s(_vm.current.instructionEn))]) : _vm._e(), _vm._v(" "), (_vm.current.script) ? _c('p', [_c('b', [_vm._v("脚本")]), _vm._v(" " + _vm._s(_vm.current.script))]) : _vm._e(), _vm._v(" "), (_vm.current.passageText) ? _c('p', [_c('b', [_vm._v("篇章")]), _vm._v(" " + _vm._s(_vm.current.passageText))]) : _vm._e(), _vm._v(" "), (_vm.mediaSrc(_vm.current.passageImage)) ? _c('p', [_c('img', {
    staticClass: "mex-trial-img",
    attrs: {
      "src": _vm.mediaSrc(_vm.current.passageImage)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mex-trial-stem"
  }, [_vm._v(_vm._s(_vm.current.stem))]), _vm._v(" "), (_vm.mediaSrc(_vm.current.stemImage)) ? _c('p', [_c('img', {
    staticClass: "mex-trial-img",
    attrs: {
      "src": _vm.mediaSrc(_vm.current.stemImage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mediaSrc(_vm.current.stemAudio)) ? _c('p', [_c('audio', {
    attrs: {
      "src": _vm.mediaSrc(_vm.current.stemAudio),
      "controls": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isChoiceBlanks && _vm.blankView.length) ? _c('div', _vm._l((_vm.blankView), function(b) {
    return _c('div', {
      key: 'cz-' + b.no,
      staticClass: "mex-trial-opts",
      staticStyle: {
        "margin-bottom": "12px"
      }
    }, [_c('p', [_vm._v("第 " + _vm._s(b.no) + " 问 " + _vm._s(b.prompt))]), _vm._v(" "), _c('Radio-group', {
      model: {
        value: (b.value),
        callback: function($$v) {
          _vm.$set(b, "value", $$v)
        },
        expression: "b.value"
      }
    }, _vm._l(((b.options || [])), function(opt) {
      return _c('Radio', {
        key: b.no + '-' + opt.code,
        staticStyle: {
          "display": "block",
          "margin": "8px 0"
        },
        attrs: {
          "label": opt.code
        }
      }, [_vm._v("\n              " + _vm._s(opt.code) + ". " + _vm._s(opt.text) + "\n            ")])
    }), 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isWordForm && _vm.optView.options.length) ? _c('div', {
    staticClass: "mex-trial-opts"
  }, [_c('p', [_c('b', [_vm._v("词库")]), _vm._v(" " + _vm._s(_vm.optView.options.map(function (o) { return o.text; }).filter(function (t) { return t; }).join(' / ')))])]) : _vm._e(), _vm._v(" "), (_vm.optView.mode === 'CHOICE' && !_vm.isChoiceBlanks && !_vm.isWordForm) ? _c('div', {
    staticClass: "mex-trial-opts"
  }, [_c('Radio-group', {
    model: {
      value: (_vm.draft.choice),
      callback: function($$v) {
        _vm.$set(_vm.draft, "choice", $$v)
      },
      expression: "draft.choice"
    }
  }, _vm._l((_vm.optView.options), function(opt) {
    return _c('Radio', {
      key: opt.code,
      staticStyle: {
        "display": "block",
        "margin": "8px 0"
      },
      attrs: {
        "label": opt.code
      }
    }, [_vm._v("\n            " + _vm._s(opt.code) + ". " + _vm._s(opt.text) + "\n            "), (_vm.mediaSrc(opt.image)) ? _c('img', {
      staticClass: "mex-trial-opt-img",
      attrs: {
        "src": _vm.mediaSrc(opt.image)
      }
    }) : _vm._e()])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.optView.mode === 'DRAG') ? _c('div', [_c('p', [_vm._v("可拖词块：" + _vm._s(_vm.optView.tokens.join(' / ')))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "按正确顺序拼好后填在这里，如 ball 或 What do you need?"
    },
    model: {
      value: (_vm.draft.text),
      callback: function($$v) {
        _vm.$set(_vm.draft, "text", $$v)
      },
      expression: "draft.text"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.blankView.length && !_vm.isChoiceBlanks) ? _c('div', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.blankView), function(b) {
    return _c('i-col', {
      key: b.no,
      attrs: {
        "span": (_vm.isFillBlanks || _vm.isWordForm) ? 24 : 8
      }
    }, [_c('p', [_vm._v("第 " + _vm._s(b.no) + " 空 " + _vm._s(b.prompt))]), _vm._v(" "), _c('Input', {
      attrs: {
        "placeholder": _vm.isFillBlanks ? '这一空的短语' : (_vm.isWordForm ? '这一空的词形，如 is coloring' : (b.prompt || '这一空的答案'))
      },
      model: {
        value: (b.value),
        callback: function($$v) {
          _vm.$set(b, "value", $$v)
        },
        expression: "b.value"
      }
    })], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.optView.mode !== 'CHOICE' && !_vm.blankView.length && _vm.optView.mode !== 'DRAG' && !_vm.isChoiceBlanks) ? _c('div', [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.answerPh
    },
    model: {
      value: (_vm.draft.text),
      callback: function($$v) {
        _vm.$set(_vm.draft, "text", $$v)
      },
      expression: "draft.text"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSubjectiveWrite) ? _c('Checkbox', {
    model: {
      value: (_vm.draft.ocrConfirm),
      callback: function($$v) {
        _vm.$set(_vm.draft, "ocrConfirm", $$v)
      },
      expression: "draft.ocrConfirm"
    }
  }, [_vm._v("已确认识别内容（写作主观分需要）")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.scoring
    },
    on: {
      "click": function($event) {
        return _vm.submitCurrent(0)
      }
    }
  }, [_vm._v("提交本题")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.submitCurrent(1)
      }
    }
  }, [_vm._v("跳过（0分）")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.index >= _vm.items.length - 1
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一题")])], 1), _vm._v(" "), (_vm.current.result) ? _c('div', {
    staticClass: "mex-trial-result"
  }, [_c('p', [_c('b', [_vm._v("判分")]), _vm._v(" " + _vm._s(_vm.current.result.score) + " / " + _vm._s(_vm.current.result.fullScore) + " · " + _vm._s(_vm.current.result.mastered === 1 ? '掌握' : '未掌握') + " · " + _vm._s(_vm.scorerLabel(_vm.current.result.scorer)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("你的作答")]), _vm._v(" " + _vm._s(_vm.current.result.payload || '（空）'))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("标准答案")]), _vm._v(" " + _vm._s(_vm.current.result.expected || '（空）'))]), _vm._v(" "), (_vm.current.result.note) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.current.result.note))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.report) ? _c('div', {
    staticClass: "mex-trial-report"
  }, [_c('h3', [_vm._v("模拟家长报告")]), _vm._v(" "), _vm._l(((_vm.report.notes || [])), function(n, i) {
    return _c('p', {
      key: 'n' + i,
      staticClass: "mex-dim-hint"
    }, [_vm._v(_vm._s(n))])
  }), _vm._v(" "), _c('div', {
    staticClass: "mex-trial-report-hero"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.report.title || '—'))]), _vm._v(" · " + _vm._s(_vm.report.medalLabel || '—') + " · 百分制 " + _vm._s(_vm.report.totalScore))]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.report.examType === 'SUMMATIVE' ? '阶段测' : '入门测') + "\n        · " + _vm._s(_vm.placementPublishLine(_vm.report)) + "\n        · 升班 " + _vm._s(_vm.report.promotionLabel || '—') + "\n        · 年龄档 " + _vm._s(_vm.ageBandLabel(_vm.report.ageBand)) + "\n      ")]), _vm._v(" "), (_vm.report.examType === 'PLACEMENT') ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("\n        触达 " + _vm._s(_vm.report.visitedMaxLevel || '—') + "\n        · 候选 " + _vm._s(_vm.report.candidateLevel || '—') + "\n        · 已验证 " + _vm._s(_vm.report.confirmedLevel || '—') + "\n        · 规则 " + _vm._s(_vm.report.ruleVersion || '—') + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("听说读写")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.skillColumns,
      "data": _vm.report.skills || [],
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("学习建议")]), _vm._v(" "), _c('p', {
    staticClass: "mex-trial-advice"
  }, [_vm._v(_vm._s(_vm.report.advice || '暂无'))])], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "约中教课",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "chineseLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.chineseLessonParam,
      "rules": _vm.chineseLessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.chineseLessonParam.uid) + "  - " + _vm._s(_vm.chineseLessonParam.mobile) + " - " + _vm._s(_vm.chineseLessonParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.chineseLessonParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "levelId", _vm._n($$v))
      },
      expression: "chineseLessonParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.chineseLessonParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "schoolId", _vm._n($$v))
      },
      expression: "chineseLessonParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.chineseLessonParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "lessonId", _vm._n($$v))
      },
      expression: "chineseLessonParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.chineseLessonParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "lsnBeginTimeDate", $$v)
      },
      expression: "chineseLessonParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "value": _vm.timeStr,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.chineseLessonParam.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "beginTime", $$v)
      },
      expression: "chineseLessonParam.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.clearTchList
    },
    model: {
      value: (_vm.chineseLessonParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "timeLength", _vm._n($$v))
      },
      expression: "chineseLessonParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.chineseLessonParam.category),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "category", $$v)
      },
      expression: "chineseLessonParam.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("全职老师")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("兼职老师")])])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.chineseLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.chineseLessonParam, "tchId", _vm._n($$v))
      },
      expression: "chineseLessonParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertChineseLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "width": "760",
      "mask-closable": false,
      "class-name": "recruit-notes-modal"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.detailLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "notes-sub"
  }, [_vm._v("\n    一、面试笔记 · 二、试讲打分\n    "), (_vm.scoreStats.hasScored) ? _c('span', [_vm._v("（总分 " + _vm._s(_vm.scoreStats.sumText) + " · 平均分 " + _vm._s(_vm.scoreStats.avgText) + "）")]) : _vm._e(), _vm._v(" "), (_vm.noteTime) ? _c('span', {
    staticClass: "notes-time"
  }, [_vm._v("最近保存：" + _vm._s(_vm.noteTime) + " " + _vm._s(_vm.noteBy))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notes-body",
    on: {
      "paste": _vm.onPaste
    }
  }, [_c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("上课链接")]), _vm._v(" "), _c('div', {
    staticClass: "class-link-row"
  }, [_c('Input', {
    staticClass: "class-link-input",
    attrs: {
      "placeholder": "https:// 粘贴课堂/会议链接"
    },
    model: {
      value: (_vm.form.classLink),
      callback: function($$v) {
        _vm.$set(_vm.form, "classLink", $$v)
      },
      expression: "form.classLink"
    }
  }), _vm._v(" "), (_vm.classLinkOpenable) ? _c('a', {
    staticClass: "class-link-open",
    attrs: {
      "href": _vm.classLinkHref,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("打开")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("附件")]), _vm._v(" "), _c('Upload', {
    ref: "attachUpload",
    attrs: {
      "type": "drag",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHeaders,
      "show-upload-list": false,
      "max-size": _vm.maxSizeKb,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "on-exceeded-size": _vm.exceededSize,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-drag-inner"
  }, [_c('Icon', {
    staticClass: "upload-drag-icon",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "40"
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击或将文件拖拽到这里上传")]), _vm._v(" "), _c('p', {
    staticClass: "upload-drag-tip"
  }, [_vm._v("也可复制文件后在本弹窗内粘贴上传，单文件不超过 100MB")])], 1)]), _vm._v(" "), (_vm.form.attachments.length) ? _c('ul', {
    staticClass: "attach-list"
  }, _vm._l((_vm.form.attachments), function(file, index) {
    return _c('li', {
      key: file.url + index
    }, [_c('Icon', {
      attrs: {
        "type": "document"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank",
        "title": file.name
      }
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('span', {
      staticClass: "attach-size"
    }, [_vm._v(_vm._s(_vm.formatSize(file.size)))]), _vm._v(" "), _c('a', {
      staticClass: "attach-del",
      on: {
        "click": function($event) {
          return _vm.removeAttachment(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _c('p', {
    staticClass: "notes-empty"
  }, [_vm._v("暂无附件")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "notes-section"
  }, [_c('span', {
    staticClass: "section-no"
  }, [_vm._v("一")]), _vm._v("面试笔记")]), _vm._v(" "), _c('div', {
    staticClass: "notes-panel"
  }, [_c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("个人情况 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录个人背景、性格、沟通印象等..."
    },
    model: {
      value: (_vm.form.personalSituation),
      callback: function($$v) {
        _vm.$set(_vm.form, "personalSituation", $$v)
      },
      expression: "form.personalSituation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("工作情况 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录工作经历、在职状态、可用性等..."
    },
    model: {
      value: (_vm.form.workSituation),
      callback: function($$v) {
        _vm.$set(_vm.form, "workSituation", $$v)
      },
      expression: "form.workSituation"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("试用期薪资（美元） "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "例如 12 或 10-14"
    },
    model: {
      value: (_vm.form.probationSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "probationSalary", $$v)
      },
      expression: "form.probationSalary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("$")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("转正后薪资（美元） "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "例如 15 或 14-18"
    },
    model: {
      value: (_vm.form.regularSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "regularSalary", $$v)
      },
      expression: "form.regularSalary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("$")])])], 1)], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "notes-section"
  }, [_c('span', {
    staticClass: "section-no is-green"
  }, [_vm._v("二")]), _vm._v("试讲打分")]), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label is-green"
  }, [_vm._v("优点 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录试讲中的亮点和优势..."
    },
    model: {
      value: (_vm.form.demoStrengths),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoStrengths", $$v)
      },
      expression: "form.demoStrengths"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label is-orange"
  }, [_vm._v("缺点 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录需要改进的地方..."
    },
    model: {
      value: (_vm.form.demoWeaknesses),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoWeaknesses", $$v)
      },
      expression: "form.demoWeaknesses"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "score-head"
  }, [_c('span', {
    staticClass: "notes-label"
  }, [_vm._v("评分标准 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "score-tip"
  }, [_vm._v("0 未评 · 1 差 · 2 偏弱 · 3 中等及格 · 3.5 · 4 良好 · 4.5 · 5 优秀")])]), _vm._v(" "), (_vm.scoreStats.hasScored) ? _c('div', {
    staticClass: "score-sum"
  }, [_vm._v("\n      已打分汇总　满分 45 分　总分 "), _c('b', [_vm._v(_vm._s(_vm.scoreStats.sumText))]), _vm._v("　|　平均分 "), _c('b', [_vm._v(_vm._s(_vm.scoreStats.avgText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-panel"
  }, _vm._l((_vm.criteria), function(c) {
    return _c('div', {
      key: c.key,
      staticClass: "score-row"
    }, [_c('span', {
      staticClass: "score-label"
    }, [_vm._v(_vm._s(c.label))]), _vm._v(" "), _c('RadioGroup', {
      attrs: {
        "type": "button",
        "size": "small"
      },
      model: {
        value: (_vm.form.demoScores[c.key]),
        callback: function($$v) {
          _vm.$set(_vm.form.demoScores, c.key, $$v)
        },
        expression: "form.demoScores[c.key]"
      }
    }, _vm._l((_vm.scoreOptions), function(opt) {
      return _c('Radio', {
        key: opt,
        attrs: {
          "label": opt
        }
      }, [_vm._v(_vm._s(opt))])
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("备注")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "补充说明、后续跟进建议等..."
    },
    model: {
      value: (_vm.form.demoRemarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoRemarks", $$v)
      },
      expression: "form.demoRemarks"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "notes-complete",
    class: {
      'is-ok': _vm.complete
    }
  }, [_vm._v("\n      " + _vm._s(_vm.complete ? '笔记已齐全，可提交复审' : '带 * 的项全部填写且 9 项打分都大于 0 后，才可提交复审') + "\n    ")]), _vm._v(" "), (_vm.draftHint) ? _c('p', {
    staticClass: "draft-hint"
  }, [_vm._v(_vm._s(_vm.draftHint))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.title,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.desc) ? _c('p', {
    staticClass: "reason-desc"
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e(), _vm._v(" "), (_vm.kindOptions && _vm.kindOptions.length) ? _c('div', {
    staticClass: "reason-kind"
  }, [_c('div', {
    staticClass: "reason-label"
  }, [_vm._v(_vm._s(_vm.kindLabel) + " "), _c('span', {
    staticClass: "reason-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "transfer": "",
      "placeholder": _vm.kindPlaceholder
    },
    model: {
      value: (_vm.kind),
      callback: function($$v) {
        _vm.kind = $$v
      },
      expression: "kind"
    }
  }, _vm._l((_vm.kindOptions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reason-label"
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('span', {
    staticClass: "reason-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "描述",
      "prop": "descr"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.descr),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descr", $$v)
      },
      expression: "formData.descr"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.parentId != null) ? _c('Form-item', {
    attrs: {
      "label": "分类",
      "prop": "pid"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onPidChange
    },
    model: {
      value: (_vm.parentId),
      callback: function($$v) {
        _vm.parentId = _vm._n($$v)
      },
      expression: "parentId"
    }
  }, _vm._l((_vm.parentList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "展现类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.itemType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "itemType", _vm._n($$v))
      },
      expression: "formData.itemType"
    }
  }, _vm._l((_vm.$constant.itemType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      },
      on: {
        "on-change": _vm.search
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("体验名单")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTimeDate),
      callback: function($$v) {
        _vm.startTimeDate = $$v
      },
      expression: "startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v(" -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTimeDate),
      callback: function($$v) {
        _vm.endTimeDate = $$v
      },
      expression: "endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称：",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人ID：",
      "prop": "inviteId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不支持模糊查询",
      "name": "inviteId"
    },
    model: {
      value: (_vm.queryParam.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteId", $$v)
      },
      expression: "queryParam.inviteId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人学导名称：",
      "prop": "referrerStudyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊查询",
      "name": "referrerStudyAdviserName"
    },
    model: {
      value: (_vm.queryParam.referrerStudyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "referrerStudyAdviserName", $$v)
      },
      expression: "queryParam.referrerStudyAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID：",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不支持模糊搜索",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "联系电话：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "归属活动："
    }
  }, [_c('activity-select', {
    model: {
      value: (_vm.queryParam.stdTab),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdTab", $$v)
      },
      expression: "queryParam.stdTab"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "微信号：",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "wechatAccount"
    },
    model: {
      value: (_vm.queryParam.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "wechatAccount", $$v)
      },
      expression: "queryParam.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "市场专员",
      "prop": "marketUserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "market"
    },
    model: {
      value: (_vm.queryParam.marketUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "marketUserId", $$v)
      },
      expression: "queryParam.marketUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册备注：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "remark"
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "export"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n        搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertUser
    }
  }, [_vm._v("添加学生")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "archive"
    },
    on: {
      "click": _vm.bannedUser
    }
  }, [_vm._v("封禁\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "archive"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookTest/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑渠道"
    },
    model: {
      value: (_vm.showEditRegTypeModal),
      callback: function($$v) {
        _vm.showEditRegTypeModal = $$v
      },
      expression: "showEditRegTypeModal"
    }
  }, [_c('Form', {
    ref: "editRegType",
    staticClass: "form",
    attrs: {
      "model": _vm.regTypeForm,
      "rules": _vm.regTypeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "prop": "regType",
      "label-width": 70
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.regTypeForm.regType),
      callback: function($$v) {
        _vm.$set(_vm.regTypeForm, "regType", $$v)
      },
      expression: "regTypeForm.regType"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditRegTypeModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditRegType
    },
    on: {
      "click": _vm.editRegType
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改推荐人"
    },
    model: {
      value: (_vm.showEditReferrerModal),
      callback: function($$v) {
        _vm.showEditReferrerModal = $$v
      },
      expression: "showEditReferrerModal"
    }
  }, [_c('Form', {
    ref: "editReferrer",
    staticClass: "form",
    attrs: {
      "model": _vm.referrerForm
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('StudentSelect', {
    attrs: {
      "label": _vm.inviteName
    },
    model: {
      value: (_vm.referrerForm.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.referrerForm, "inviteId", $$v)
      },
      expression: "referrerForm.inviteId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditReferrerModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditReferrer
    },
    on: {
      "click": _vm.editReferrer
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改首次分配顾问"
    },
    model: {
      value: (_vm.showEditFirstConsultantModal),
      callback: function($$v) {
        _vm.showEditFirstConsultantModal = $$v
      },
      expression: "showEditFirstConsultantModal"
    }
  }, [_c('Form', {
    ref: "editFirstConsultant",
    staticClass: "form",
    attrs: {
      "model": _vm.firstConsultantForm
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.firstConsultantForm.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.firstConsultantForm, "adviserId", $$v)
      },
      expression: "firstConsultantForm.adviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditFirstConsultantModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditFirstConsultant
    },
    on: {
      "click": _vm.editFirstConsultant
    }
  }, [_vm._v("确定\n      ")])], 1)], 1), _vm._v(" "), _c('InsertUserModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showInsertUserModal),
      callback: function($$v) {
        _vm.showInsertUserModal = $$v
      },
      expression: "showInsertUserModal"
    }
  }), _vm._v(" "), _c('BannedUserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showBannedUserModal),
      callback: function($$v) {
        _vm.showBannedUserModal = $$v
      },
      expression: "showBannedUserModal"
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/user/bookTestList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师未评论列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listOverTimeNoReview",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师请假列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假时间"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminNickname"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminMobile"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchEmail"
    },
    model: {
      value: (_vm.queryParam.tchEmail),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchEmail", $$v)
      },
      expression: "queryParam.tchEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假类型"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "leaveType", $$v)
      },
      expression: "queryParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n      ")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "1050",
      "title": "修改请假时间"
    },
    model: {
      value: (_vm.showModifyLeaveTimeModal),
      callback: function($$v) {
        _vm.showModifyLeaveTimeModal = $$v
      },
      expression: "showModifyLeaveTimeModal"
    }
  }, [_c('Form', {
    ref: "modifyTimeForm",
    attrs: {
      "label-width": 60,
      "rules": _vm.modifyLeaveTimeRule
    },
    model: {
      value: (_vm.leaveTimeChangeParam),
      callback: function($$v) {
        _vm.leaveTimeChangeParam = $$v
      },
      expression: "leaveTimeChangeParam"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.tchLeaveLessonColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('Row', [_c('br')]), _vm._v(" "), _c('Row', [_vm._v("\n        备注：若修改的时间不影响请假课程的可以直接修改，若影响到了课程的请联系技术人员修改！！！\n      ")]), _vm._v(" "), _c('Row', [_c('br')]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "请假结束时间修改:",
      "label-width": 120
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间",
      "disabled": ""
    },
    model: {
      value: (_vm.leaveTimeChangeParam.startLeaveTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.leaveTimeChangeParam, "startLeaveTimeDate", $$v)
      },
      expression: "leaveTimeChangeParam.startLeaveTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "修改结束日期"
    },
    on: {
      "on-change": _vm.newEndLeaveTimeChange
    },
    model: {
      value: (_vm.leaveTimeChangeParam.endLeaveTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.leaveTimeChangeParam, "endLeaveTimeDate", $$v)
      },
      expression: "leaveTimeChangeParam.endLeaveTimeDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showModifyLeaveTimeModal = false
      }
    }
  }, [_vm._v("取消\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.onModifyLeaveEndTime
    }
  }, [_vm._v("确认修改\n      ")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookTchLeaveTime/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('TchLeaveLessonModal', {
    attrs: {
      "tchId": _vm.tchLeaveLessonParam.tchId,
      "startTime": _vm.tchLeaveLessonParam.startTime,
      "endTime": _vm.tchLeaveLessonParam.endTime,
      "lsnSelStatus": _vm.tchLeaveLessonParam.lsnSelStatus
    },
    model: {
      value: (_vm.showTchLeaveLessonModal),
      callback: function($$v) {
        _vm.showTchLeaveLessonModal = $$v
      },
      expression: "showTchLeaveLessonModal"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑请假类型"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.leaveType),
      callback: function($$v) {
        _vm.leaveType = $$v
      },
      expression: "leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消\n      ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("结课学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "结课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startFinishedTimeChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endFinishedTimeChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID："
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名："
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号："
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "一级原因"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  }, _vm._l((_vm.$constant.stdOverRemark), function(item) {
    return _c('Option', {
      key: item.text,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("解绑学导")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.cancelLoading,
      "disable": _vm.cancelLoading,
      "icon": ""
    },
    on: {
      "click": _vm.batchCancel
    }
  }, [_vm._v("批量取消结课\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onBatchCompletedCourses
    }
  }, [_vm._v("批量结课")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('602'),
      expression: "'602'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/overClass/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UnBinStudyModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showUnBinStudyModal),
      callback: function($$v) {
        _vm.showUnBinStudyModal = $$v
      },
      expression: "showUnBinStudyModal"
    }
  }), _vm._v(" "), _c('BatchCompletedCoursesModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBatchCompletedCoursesModal),
      callback: function($$v) {
        _vm.showBatchCompletedCoursesModal = $$v
      },
      expression: "showBatchCompletedCoursesModal"
    }
  }), _vm._v(" "), _c('EditOverRemarkModal', {
    attrs: {
      "successCallback": _vm.search,
      "complaintRow": this.complaintRow,
      "visible": _vm.showUpdateScoreModal
    },
    on: {
      "on-close": _vm.closeComplaintModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("兑换课程审核列表")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "auditStatus", $$v)
      },
      expression: "queryParams.auditStatus"
    }
  }, [_c('Option', {
    key: "0",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("审核不通过")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "uid"
    },
    model: {
      value: (_vm.queryParams.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "uid", $$v)
      },
      expression: "queryParams.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserId",
      "label-width": 60
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "userStudyAdviser",
      "needDefaultStudyAdviser": "0",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParams.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "studyAdviserId", $$v)
      },
      expression: "queryParams.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程名称",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "courseName"
    },
    model: {
      value: (_vm.queryParams.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "courseName", $$v)
      },
      expression: "queryParams.courseName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "兑换记录序列号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持范围查询:3,10",
      "name": "id"
    },
    model: {
      value: (_vm.queryParams.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "id", $$v)
      },
      expression: "queryParams.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "兑换时间",
      "label-width": 60
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择开始日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择结束日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "class-name": "export-wrap"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', [_c('span', [_vm._v("消耗课时：")]), _vm._v(_vm._s(_vm.statisticsSum.consumeTotal))])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12,
      "class-name": "export"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/courseEx/list",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('LogicModal', {
    attrs: {
      "itemId": _vm.itemId,
      "value": _vm.logicModal,
      "logicName": _vm.logicName,
      "logicNumber": _vm.logicNumber
    },
    on: {
      "on-close": function($event) {
        _vm.logicModal = false
      },
      "on-edit-success": _vm.editSuccess,
      "on-edit-clearid": _vm.clearId
    },
    model: {
      value: (_vm.logicModal),
      callback: function($$v) {
        _vm.logicModal = $$v
      },
      expression: "logicModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-绑定有效时间生效失败记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules,
      "label-width": 90
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "adviserName", $$v)
      },
      expression: "formData.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "studyAdviserName", $$v)
      },
      expression: "formData.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "开课时间生效失败原因"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formData.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formData.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nextHandlerId", _vm._n($$v))
      },
      expression: "formData.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "operateStatus", $$v)
      },
      expression: "formData.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("财务管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("退费列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n        待审核金额: "), _c('label', [_vm._v(_vm._s(_vm.statistics.waitAuditNum))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n        待退金额: "), _c('label', [_vm._v(_vm._s(_vm.statistics.waitRefundNum))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n        已退费金额: "), _c('label', [_vm._v(_vm._s(_vm.statistics.refundNum))])])], 1), _vm._v(" "), _c('Form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已审核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已退费")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("劝退成功")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发票"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.invoiceState),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "invoiceState", $$v)
      },
      expression: "queryParam.invoiceState"
    }
  }, [_c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("未开票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("需回收")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已回收")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员id",
      "prop": "nickname"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请人",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.applyName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "applyName", $$v)
      },
      expression: "queryParam.applyName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单Id",
      "prop": "orderId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "orderId", $$v)
      },
      expression: "queryParam.orderId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "nuclear"
    },
    on: {
      "click": _vm.showInsertRefundModal
    }
  }, [_vm._v("申请退费\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('List', {
    ref: "dataList",
    attrs: {
      "reload": _vm.reload,
      "params": _vm.queryParam,
      "tableColumns": _vm.title,
      "listUrl": "/financial/refund/list",
      "onLoading": _vm.onLoading
    }
  })], 1), _vm._v(" "), _c('refund-insert-modal', {
    attrs: {
      "id": _vm.id,
      "orderNum": _vm.orderId,
      "value": _vm.refundInsertModal,
      "canSave": _vm.canSave,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.onRefundInsertClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课程顾问跟进数据")])], 1)], 1), _vm._v(" "), _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "desc-wrap"
  }, [_c('span', [_vm._v("注册名单:" + _vm._s(_vm.details.totalListNum))]), _vm._v(" "), _c('span', [_vm._v("名单数:" + _vm._s(_vm.details.totalUserCount))]), _vm._v(" "), _c('span', [_vm._v("邀约数:" + _vm._s(_vm.details.inviteListNum))]), _vm._v(" "), _c('span', [_vm._v("出席数:" + _vm._s(_vm.details.attendNum))]), _vm._v(" "), _c('span', [_vm._v("成交数:" + _vm._s(_vm.details.dealNum))]), _vm._v(" "), _c('span', [_vm._v("邀约率:" + _vm._s(_vm.details.inviteRate + '%'))]), _vm._v(" "), _c('span', [_vm._v("出席率:" + _vm._s(_vm.details.attendRate + '%'))]), _vm._v(" "), _c('span', [_vm._v("成交率:" + _vm._s(_vm.details.dealRate + '%'))])]), _vm._v(" "), _c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "show-message": false,
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间",
      "label-width": 50
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": false,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名单来源"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.assignType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "assignType", _vm._n($$v))
      },
      expression: "queryParam.assignType"
    }
  }, _vm._l((_vm.$constant.assignList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课顾分组"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.queryParam.teamType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "teamType", $$v)
      },
      expression: "queryParam.teamType"
    }
  }, _vm._l((_vm.formData.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adviserName"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminUser/listAdviserData",
      "params": _vm.queryParam,
      "pageSize": 50,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("单词卡")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "单词："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.word),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "word", $$v)
      },
      expression: "queryParam.word"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/wordCard/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑单词卡' : '新增单词卡',
      "width": "640",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "单词",
      "prop": "word"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入单词",
      "disabled": !!_vm.formData.id
    },
    model: {
      value: (_vm.formData.word),
      callback: function($$v) {
        _vm.$set(_vm.formData, "word", $$v)
      },
      expression: "formData.word"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "英文释义",
      "prop": "enDef"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入英文释义"
    },
    model: {
      value: (_vm.formData.enDef),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enDef", $$v)
      },
      expression: "formData.enDef"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "例句",
      "prop": "exampleSentence"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入例句"
    },
    model: {
      value: (_vm.formData.exampleSentence),
      callback: function($$v) {
        _vm.$set(_vm.formData, "exampleSentence", $$v)
      },
      expression: "formData.exampleSentence"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "例句音频",
      "prop": "exampleAudio"
    }
  }, [_c('FileUpload', {
    attrs: {
      "defaultFileList": _vm.defaultFileList,
      "num": 1,
      "text": "点击或拖拽上传音频"
    },
    on: {
      "on-file-change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "注册资料",
      "width": "1000",
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "apply-loading"
  }, [_c('Spin', {
    attrs: {
      "fix": ""
    }
  })], 1) : (!_vm.applyData) ? _c('div', {
    staticClass: "apply-empty"
  }, [_vm._v("暂无注册资料")]) : _c('Tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "个人信息",
      "name": "1"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("头像：")]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [(_vm.mediaUrl(_vm.applyData.avatar)) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.mediaUrl(_vm.applyData.avatar),
      "alt": ""
    }
  }) : _c('span', {
    staticClass: "empty"
  }, [_vm._v("未上传")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("姓名：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.fullName)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("性别：")]), _c('span', [_vm._v(_vm._s(_vm.genderText(_vm.applyData.gender)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("出生日期：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.birthday)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("年龄：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.age)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("国籍：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.nationality)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("护照签发国：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.passportCountry)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("婚姻状况：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.maritalStatus)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("种族：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.ethnicity)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("所在国家：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.locationCountry)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("省/州：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.locationState)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("城市：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.locationCity || _vm.applyData.townOrCity)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("健康状况：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.health)))])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "教育背景",
      "name": "2"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("最高学历：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.highestQualification)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("毕业年份：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.yearOfGraduation)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("毕业院校：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.school)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("专业：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.major)))])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "当前工作",
      "name": "3"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("当前工作：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.currentJob)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("工作时间：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.currentJobSchedule)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("度假计划：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.holidayPlan)))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("教学经历")]), _vm._v(" "), (!(_vm.applyData.teachingExperiences && _vm.applyData.teachingExperiences.length)) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无教学经历")]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.applyData.teachingExperiences || [])), function(exp, idx) {
    return _c('div', {
      key: 'exp-' + idx,
      staticClass: "exp-card"
    }, [_c('Row', {
      attrs: {
        "gutter": 16
      }
    }, [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("时间：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.timePeriod)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("公司：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.company)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("职位：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.position)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("每天课时：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.lessonsPerDay)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("课时时长：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.lessonDuration)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("时薪：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.hourlyRate)))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("离职原因：")]), _c('span', [_vm._v(_vm._s(_vm.display(exp.leaveReason)))])])])], 1)], 1)
  })], 2), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "教学经历与证书",
      "name": "4"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("是否有证书：")]), _c('span', [_vm._v(_vm._s(_vm.ynText(_vm.applyData.hasCertificate)))])])]), _vm._v(" "), (_vm.applyData.hasCertificate === 'Y') ? [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("TEFL：")]), _vm._v(" "), (_vm.mediaUrl(_vm.applyData.certificateTefl)) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openUrl(_vm.mediaUrl(_vm.applyData.certificateTefl))
      }
    }
  }, [_vm._v("查看")]) : _c('span', {
    staticClass: "empty"
  }, [_vm._v("未上传")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("TESOL：")]), _vm._v(" "), (_vm.mediaUrl(_vm.applyData.certificateTesol)) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openUrl(_vm.mediaUrl(_vm.applyData.certificateTesol))
      }
    }
  }, [_vm._v("查看")]) : _c('span', {
    staticClass: "empty"
  }, [_vm._v("未上传")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("TEYL：")]), _c('span', [_vm._v(_vm._s(_vm.ynText(_vm.applyData.certTeyl)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("其他：")]), _c('span', [_vm._v(_vm._s(_vm.ynText(_vm.applyData.certOthers)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("其他说明：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.certOthersText)))])])])] : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("可教科目：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subjectsText(_vm.applyData.teachableSubjects)))])])])], 2)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "课表与设备",
      "name": "5"
    }
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("高峰课表")]), _vm._v(" "), _c('div', {
    staticClass: "schedule-wrap"
  }, [_c('table', {
    staticClass: "schedule-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("时段")]), _vm._v(" "), _vm._l((_vm.courseDays), function(day) {
    return _c('th', {
      key: day
    }, [_vm._v(_vm._s(day))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.courseSlots), function(slot) {
    return _c('tr', {
      key: slot
    }, [_c('td', [_vm._v(_vm._s(slot))]), _vm._v(" "), _vm._l((_vm.courseDays), function(day) {
      return _c('td', {
        key: day + '-' + slot
      }, [_vm._v(_vm._s(_vm.scheduleSymbol(day, slot)))])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("CPU：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.cpu)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("备用设备：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.backupDevices)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("上行网速：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.upSpeed)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("下行网速：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.downSpeed)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("备用网速：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.backUpInternetSpeed)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("备用电源：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.backUpPower)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("网络供应商：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.networkProviders)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("月费：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.monthlyNetworkFee)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("ClassIn 账号：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.classinAccount)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("ClassIn 类型：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.classinAccountType)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("ClassIn 是否自有：")]), _c('span', [_vm._v(_vm._s(_vm.ynText(_vm.applyData.classinOwn)))])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "职位信息",
      "name": "6"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("预计开课日：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.startTeachDate)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("期望时薪：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.expectSalary)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("招聘来源：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.jobSource)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("时差：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.timeDiff)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("时区：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.timezone)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("紧急电话：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.emergencyPhone)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("紧急联系人关系：")]), _c('span', [_vm._v(_vm._s(_vm.display(_vm.applyData.emergencyRelationship)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("简历：")]), _vm._v(" "), (_vm.mediaUrl(_vm.applyData.cv)) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openUrl(_vm.mediaUrl(_vm.applyData.cv))
      }
    }
  }, [_vm._v("查看")]) : _c('span', {
    staticClass: "empty"
  }, [_vm._v("未上传")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("自我介绍视频：")]), _vm._v(" "), (_vm.mediaUrl(_vm.applyData.introduceVideo)) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openUrl(_vm.mediaUrl(_vm.applyData.introduceVideo))
      }
    }
  }, [_vm._v("查看")]) : _c('span', {
    staticClass: "empty"
  }, [_vm._v("未上传")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "影响总览",
      "tags": ['离职 · 淘汰 · 关闭时间', '按受影响学生去重'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("统计区间")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "daterange",
      "value": _vm.dateRange,
      "format": "yyyy-MM-dd",
      "clearable": false,
      "placement": "bottom-start"
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 环比口径：" + _vm._s(_vm.periodText) + " vs " + _vm._s(_vm.prevPeriodText) + "（上月同日区间）· 区间最长 93 天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("三类事件殊途同归：学生最后都得换老师。看换走了多少人、敞口多大、换完后还剩多少。同一学生被多次波及只归因到最早一起。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g21"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("老师异动事件趋势"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("截至 " + _vm._s(_vm.period.endDate || '—') + " 近 6 个月 · 按生效日 · 按类型拆分")])]), _vm._v(" "), _c('span', {
    staticClass: "chart-legend"
  }, _vm._l((_vm.typeKeys), function(t) {
    return _c('span', {
      key: t
    }, [_c('i', {
      style: ({
        background: _vm.typeColor(t)
      })
    }), _vm._v(_vm._s(_vm.typeLabel(t)))])
  }), 0)]), _vm._v(" "), (!_vm.trendCols.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('div', {
    staticClass: "cols"
  }, _vm._l((_vm.trendCols), function(col) {
    return _c('div', {
      key: col.month,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "col-total"
    }, [_vm._v(_vm._s(col.total))]), _vm._v(" "), _c('div', {
      staticClass: "col-bar",
      style: ({
        height: col.height + 'px'
      })
    }, _vm._l((col.segs), function(seg) {
      return _c('div', {
        key: seg.type,
        style: ({
          height: seg.height + 'px',
          background: seg.color
        }),
        attrs: {
          "title": seg.title
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(col.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap type-table"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.byType), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.events)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtRate(row.switched7dRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.avgNoticeDays)) + _vm._s(_vm.isNum(row.avgNoticeDays) ? ' 天' : ''))])])
  }), _vm._v(" "), (!_vm.byType.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师漏斗"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.eventCount)) + " 起异动 → " + _vm._s(_vm.fmtNum(_vm.funnel.students)) + " 名学生")])])]), _vm._v(" "), _c('div', {
    staticClass: "summary-strip"
  }, [_c('span', [_vm._v("未消课时敞口 "), _c('b', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.exposureHours)))]), _vm._v(" 课时")]), _vm._v(" "), _c('span', [_vm._v("超 7 天待换 "), _c('b', {
    staticClass: "is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.funnel.waitingOver7)) + " 人")])]), _vm._v(" "), _c('span', [_vm._v("换老师且改时 "), _c('b', {
    staticClass: "is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.funnel.changeSlot)) + " 人")])])]), _vm._v(" "), _vm._l((_vm.funnelRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "funnel-row"
    }, [_c('div', {
      staticClass: "funnel-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-track"
    }, [_c('div', {
      staticClass: "funnel-fill",
      style: ({
        width: row.width + '%',
        background: row.color
      })
    }, [_vm._v(_vm._s(_vm.fmtNum(row.value)))])]), _vm._v(" "), _c('div', {
      staticClass: "funnel-rate"
    }, [_vm._v(_vm._s(row.rate))])])
  }), _vm._v(" "), (_vm.noticeInsight) ? _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v(_vm._s(_vm.noticeInsight))]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("损失课次看伤害深度，被波及次数看重复伤害，风险池看本周要处理的事件。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g3"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.depthRows,
      "unit": "人"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("损失课次 = 生效后 14 天应上（原周课量 × 2）− 实上，不足 14 天按已过整周折算。")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响频率分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.period.endDate || '—') + " 往前 90 天 · 被波及次数")])])]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.freqRows,
      "unit": "人"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.repeatRate)) + " 的学生在 90 天内被波及 2 次及以上")]), _vm._v("，这批人贡献了 " + _vm._s(_vm.fmtRate(_vm.d.repeatLostShare)) + " 的损失课次，是最优先人工干预的群体。\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_vm._l((_vm.riskPool), function(row) {
    return _c('tr', {
      key: row.type + '-' + row.tchId + '-' + row.effectiveDate
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.tchName || row.tchId))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.exposureHours)))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.shortDate(row.effectiveDate)) + "\n                "), (row.effectiveDate > _vm.todayStr) ? _c('span', {
      staticClass: "t-muted"
    }, [_vm._v("未生效")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.riskPool.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无待处理事件")])]) : _vm._e()], 2)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("事件与换老师")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("7 天换完率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("平均通知天数")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("影响程度与风险池")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响程度分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("受影响学生 · 损失课次")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("待处理风险池"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("生效日在今天前 7 天 ~ 后 14 天")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("老师")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("未消课时")]), _vm._v(" "), _c('th', [_vm._v("生效日")])])])
}]}

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.visible,
      "class-name": "ai-drawer-modal",
      "width": "520",
      "mask-closable": false,
      "closable": true,
      "title": "AI 助手"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange,
      "on-cancel": _vm.closeDrawer
    }
  }, [_c('div', {
    staticClass: "ai-drawer-body"
  }, [_c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("任务")]), _vm._v(" "), _c('RadioGroup', {
    on: {
      "on-change": _vm.onTaskTypeChange
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.taskOptions), function(opt) {
    return _c('Radio', {
      key: opt.value,
      attrs: {
        "label": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1), _vm._v(" "), (_vm.taskType === 'ADVISOR_RENEWAL') ? _c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("仅内部沟通，不向家长发送，不催费")]) : _vm._e()], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("事实")]), _vm._v(" "), (_vm.preparing) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("正在准备事实…")]) : (!_vm.uid) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.missingIdText))]) : (_vm.prepareFailed) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.displayError))]) : (_vm.factRows.length) ? _c('div', _vm._l((_vm.factRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "ai-fact-row"
    }, [_c('Checkbox', {
      attrs: {
        "value": _vm.isFactIncluded(row.key)
      },
      on: {
        "on-change": function($event) {
          return _vm.onFactCheck(row.key, $event)
        }
      }
    }, [_c('span', {
      staticClass: "ai-fact-key"
    }, [_vm._v(_vm._s(row.key))])]), _vm._v(" "), _c('span', {
      staticClass: "ai-fact-value"
    }, [_vm._v(_vm._s(row.display))]), _vm._v(" "), (row.table) ? _c('span', {
      staticClass: "ai-fact-source"
    }, [_vm._v("来源：" + _vm._s(row.table))]) : _vm._e()], 1)
  }), 0) : _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("暂无事实")])]), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("结果")]), _vm._v(" "), _c('div', {
    staticClass: "ai-result-toolbar"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.generating,
      "disabled": !_vm.canGenerate
    },
    on: {
      "click": _vm.onGenerate
    }
  }, [_vm._v("生成")]), _vm._v(" "), (_vm.isMarket) ? _c('span', {
    staticClass: "ai-hint"
  }, [_vm._v("市场角色仅生成，不写回。")]) : _vm._e()], 1), _vm._v(" "), (!_vm.uid) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.missingIdText))]) : (_vm.resultError) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.displayError))]) : (_vm.output) ? _c('div', {
    staticClass: "ai-result"
  }, [(_vm.taskType === 'SALES_FOLLOWUP') ? _c('div', [_c('p', [_c('b', [_vm._v("摘要")]), _vm._v("：" + _vm._s(_vm.output.summary))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("需求")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.needs)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("已知事实")]), _vm._v("：" + _vm._s(_vm.formatValue(_vm.output.knownFacts)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("待确认")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.missingQuestions)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("意向")]), _vm._v("：" + _vm._s(_vm.output.intentLevel))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("下一步")]), _vm._v("：" + _vm._s(_vm.formatValue(_vm.output.nextAction)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("回复草稿")]), _vm._v("：" + _vm._s(_vm.output.replyDraft))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("提醒")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.warnings)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("跟进文案")]), _vm._v("：" + _vm._s(_vm.output.followUpText))])]) : (_vm.taskType === 'SALES_CALL_ANALYSIS') ? _c('div', [_c('p', [_c('b', [_vm._v("意向")]), _vm._v("：" + _vm._s(_vm.output.intentLevel) + " " + _vm._s(_vm.output.intentReason))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("成交")]), _vm._v("：" + _vm._s(_vm.dealLabel(_vm.output.dealLikelihood)) + " " + _vm._s(_vm.output.dealReason))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("销售质量")]), _vm._v("：" + _vm._s(_vm.output.qualityScore) + " " + _vm._s(_vm.formatList(_vm.output.qualityReasons)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("结论")]), _vm._v("：" + _vm._s(_vm.output.followUpText))])]) : (_vm.taskType === 'ADVISOR_AFTER_CLASS') ? _c('div', [_c('p', [_c('b', [_vm._v("家长反馈")]), _vm._v("：" + _vm._s(_vm.output.parentFeedback))])]) : (_vm.taskType === 'ADVISOR_WEEKLY') ? _c('div', [_c('p', [_c('b', [_vm._v("总览")]), _vm._v("：" + _vm._s(_vm.output.overview))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("亮点")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.highlights)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("待复习")]), _vm._v("：" + _vm._s(_vm.output.toReview))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("家庭建议")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.homeAdvice)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("下阶段目标")]), _vm._v("：" + _vm._s(_vm.output.nextGoal))])]) : (_vm.taskType === 'ADVISOR_RENEWAL') ? _c('div', [_c('p', [_c('b', [_vm._v("内部提纲")]), _vm._v("：" + _vm._s(_vm.output.internalOutline))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("风险标记")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.riskFlags)))])]) : (_vm.taskType === 'RISK_EXPLAIN' || _vm.taskType === 'TCH_RISK_EXPLAIN') ? _c('div', [_c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("分数由规则日批计算，模型不重算")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("解释")]), _vm._v("：" + _vm._s(_vm.output.explanation))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("建议动作")]), _vm._v("：" + _vm._s(_vm.actionLabel(_vm.output.suggestedAction)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("沟通要点")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.talkingPoints)))])]) : _vm._e(), _vm._v(" "), _c('Collapse', {
    staticClass: "ai-raw-json"
  }, [_c('Panel', {
    attrs: {
      "name": "raw"
    }
  }, [_vm._v("\n            原始 JSON\n            "), _c('pre', {
    staticClass: "ai-pre",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.formatJson(_vm.output)))])])], 1)], 1) : _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("点击生成后展示结果")])]), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("确认")]), _vm._v(" "), _c('p', {
    staticClass: "ai-writeback-hint"
  }, [_vm._v(_vm._s(_vm.writebackHint))]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "disabled": _vm.confirmReadOnly,
      "placeholder": "确认写入的文案"
    },
    model: {
      value: (_vm.editedText),
      callback: function($$v) {
        _vm.editedText = $$v
      },
      expression: "editedText"
    }
  }), _vm._v(" "), (!_vm.isMarket) ? _c('div', {
    staticClass: "ai-confirm-btns"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.approving || _vm.executing,
      "disabled": !_vm.canConfirm
    },
    on: {
      "click": _vm.onConfirmWriteback
    }
  }, [_vm._v("确认并写回")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canAbandon
    },
    on: {
      "click": _vm.onAbandon
    }
  }, [_vm._v("放弃")])], 1) : _vm._e()], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("反馈")]), _vm._v(" "), _c('div', {
    staticClass: "ai-feedback-btns"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(1)
      }
    }
  }, [_vm._v("采用")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(2)
      }
    }
  }, [_vm._v("修改后采用")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(0)
      }
    }
  }, [_vm._v("不采用")])], 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px",
      "margin-top": "8px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "问题类型（可选）"
    },
    model: {
      value: (_vm.feedbackIssueType),
      callback: function($$v) {
        _vm.feedbackIssueType = $$v
      },
      expression: "feedbackIssueType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "FACT"
    }
  }, [_vm._v("事实有误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TONE"
    }
  }, [_vm._v("语气不当")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "POLICY"
    }
  }, [_vm._v("违反规范")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1), _vm._v(" "), _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "补充说明（可选）"
    },
    model: {
      value: (_vm.feedbackComment),
      callback: function($$v) {
        _vm.feedbackComment = $$v
      },
      expression: "feedbackComment"
    }
  })], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("历史")]), _vm._v(" "), (_vm.historyLoading) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("加载中…")]) : (!_vm.history.length) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("暂无历史")]) : _c('div', {
    staticClass: "ai-history"
  }, [_c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("点击一条可把该次结果填回上方")]), _vm._v(" "), _vm._l((_vm.history), function(item) {
    return _c('div', {
      key: _vm.historyKey(item),
      staticClass: "ai-history-item",
      class: {
        'ai-history-item-active': _vm.historyKey(item) === _vm.runId
      },
      on: {
        "click": function($event) {
          return _vm.onHistoryClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "ai-history-time"
    }, [_vm._v(_vm._s(_vm.historyTime(item)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.historyTaskLabel(item)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.historyStatusLabel(item)))])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeDrawer
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师合同")])], 1)], 1)]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.formData.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.enabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enabled", $$v)
      },
      expression: "formData.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.contract),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contract", $$v)
      },
      expression: "formData.contract"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配记录")])], 1)], 1), _vm._v(" "), (_vm.fromSalesDealRate) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBackSalesDealRate
    }
  }, [_vm._v("返回销售成交率")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("成交率分配明细，本周按公式筛选")])], 1) : (_vm.fromChannelDealRate) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBackChannelDealRate
    }
  }, [_vm._v("返回渠道成交率")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("渠道成交率分配明细，本周按公式筛选")])], 1) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生:",
      "label-width": 70
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学员状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.stdStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdStatus", $$v)
      },
      expression: "queryParam.stdStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("已预约")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已试听")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("付款未绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("已绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("已开课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("已完课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("退费")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("不论")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "分配来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.recordsSource),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recordsSource", $$v)
      },
      expression: "queryParam.recordsSource"
    }
  }, _vm._l((_vm.$constant.recordsSource), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配时间:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkStartTimeDate
    },
    on: {
      "on-change": _vm.linkTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkEndTimeDate
    },
    on: {
      "on-change": _vm.linkTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道分类"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.channelType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channelType", $$v)
      },
      expression: "queryParam.channelType"
    }
  }, _vm._l((this.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Col')], 1), _vm._v(" "), (!_vm.fromSalesDealRate && !_vm.fromChannelDealRate) ? _c('adviser-float-modal', {
    attrs: {
      "adviserId": _vm.queryParam.adviserId,
      "teamType": _vm.queryParam.teamType
    },
    on: {
      "get_adviser": _vm.getAdviserInfo
    }
  }) : _vm._e(), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.assignTitle,
      "listUrl": "/userinfo/distribution",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar-list"
  }, [(!_vm.rows.length) ? _c('div', {
    staticClass: "bar-empty"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shownRows), function(row) {
    return _c('div', {
      key: row.key || row.label,
      staticClass: "bar-row",
      style: (_vm.gridStyle)
    }, [_c('div', {
      staticClass: "bar-label",
      class: row.labelClass
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('div', {
      staticClass: "bar-track"
    }, [(row.segs) ? _vm._l((row.segs), function(seg, idx) {
      return _c('div', {
        key: idx,
        staticClass: "bar-fill",
        style: ({
          width: seg.width + '%',
          background: seg.color
        }),
        attrs: {
          "title": seg.title
        }
      })
    }) : _c('div', {
      staticClass: "bar-fill",
      style: ({
        width: row.width + '%',
        background: row.color || _vm.defaultColor
      })
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "bar-total"
    }, [_c('b', [_vm._v(_vm._s(row.valueText))]), (_vm.unit) ? _c('span', [_vm._v(" " + _vm._s(_vm.unit))]) : _vm._e(), _vm._v(" "), (row.extra) ? _c('span', {
      staticClass: "bar-extra",
      class: row.extraClass
    }, [_vm._v(" · " + _vm._s(row.extra))]) : _vm._e()])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "约测网课",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "testNetworkForm",
    staticClass: "form",
    attrs: {
      "model": _vm.testNetworkParam,
      "rules": _vm.ruleTestNetwork,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.testNetworkParam.uid) + "  - " + _vm._s(_vm.testNetworkParam.mobile) + " - " + _vm._s(_vm.testNetworkParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择等级，支持搜索"
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.testNetworkParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "levelId", _vm._n($$v))
      },
      expression: "testNetworkParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "schoolId", _vm._n($$v))
      },
      expression: "testNetworkParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "lessonId", _vm._n($$v))
      },
      expression: "testNetworkParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [3]
    },
    model: {
      value: (_vm.testNetworkParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "tchId", $$v)
      },
      expression: "testNetworkParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.testNetworkParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "lsnBeginTimeDate", $$v)
      },
      expression: "testNetworkParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "value": _vm.timeStr,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "timeLength", _vm._n($$v))
      },
      expression: "testNetworkParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.checkTime
    }
  }, [_vm._v("检查")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingTestNetwork
    },
    on: {
      "click": _vm.insertTestNetwork
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Regular Review",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one： Classroom status(minimum 2 stars, maximum 5 stars)  :")]), _vm._v(" "), _c('Form', {
    ref: "formData",
    staticClass: "feedback form regluarForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Student's attention to the class："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate1),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate1", $$v)
      },
      expression: "formData.rate1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Class participation："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate2", $$v)
      },
      expression: "formData.rate2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Classroom environment："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate3),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate3", $$v)
      },
      expression: "formData.rate3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Internet connection："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate4),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate4", $$v)
      },
      expression: "formData.rate4"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two: Class performance   :")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "closable": false,
      "title": "I'm very happy to see you today. You have made wonderful progress participating the class activities and  I look forward to seeing you in the next class.",
      "type": "info",
      "description": "There are some difficult parts in today's lesson, so please review and practice the following areas after class."
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        1.Pronunciation of the words: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word1), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word1, index, 3)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word1)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        2.Usage of the words: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word2), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word2, index, 3)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word2)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        3.Difficult sentences: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word3), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word3, index, 1)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word3)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        4.Others(grammar, writing etc): \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word4), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word4, index, 1)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word4)
        }
      }
    })])
  }), 0)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Other feedback（optional）:")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        1. A message to the parent\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.parent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "parent", $$v)
      },
      expression: "formData.parent"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        2. Homework\n      ")]), _vm._v(" "), _c('MultiUpload', {
    staticClass: "title",
    attrs: {
      "num": 1,
      "defaultFileList": _vm.formData.fileList
    },
    on: {
      "on-file-change": _vm.changeFile
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        3.Student needs to adjust the material level\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.levelMsg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelMsg", $$v)
      },
      expression: "formData.levelMsg"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "新增上课要求",
      "width": "700",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.handleCancel
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow-y": "auto",
      "padding-right": "5px"
    }
  }, [_c('Form', {
    ref: "classRequirementForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid) + " - " + _vm._s(_vm.formData.studentName))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11,
      "offset": "2"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.tchId) + " - " + _vm._s(_vm.formData.tchName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("(外管审核后显示给老师)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("一般需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "活跃一些"
    }
  }, [_c('span', [_vm._v("活跃一些")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多微笑，不要太严肃"
    }
  }, [_c('span', [_vm._v("多微笑，不要太严肃")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "纠音"
    }
  }, [_c('span', [_vm._v("纠音")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "纠正错误表达"
    }
  }, [_c('span', [_vm._v("纠正错误表达")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "引导多开口"
    }
  }, [_c('span', [_vm._v("引导多开口")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些互动"
    }
  }, [_c('span', [_vm._v("多些互动")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "引导整句输出"
    }
  }, [_c('span', [_vm._v("引导整句输出")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多鼓励孩子"
    }
  }, [_c('span', [_vm._v("多鼓励孩子")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多给些奖励"
    }
  }, [_c('span', [_vm._v("多给些奖励")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("低级别上课需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "语速慢一点"
    }
  }, [_c('span', [_vm._v("语速慢一点")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些 TPR"
    }
  }, [_c('span', [_vm._v("多些 TPR")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些道具"
    }
  }, [_c('span', [_vm._v("多些道具")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "课前互动简单一些最多3个问题"
    }
  }, [_c('span', [_vm._v("课前互动简单一些最多3个问题")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "学生零基础，不要拓展"
    }
  }, [_c('span', [_vm._v("学生零基础，不要拓展")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "减少拓展"
    }
  }, [_c('span', [_vm._v("减少拓展")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("高级别上课需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "内容拓展"
    }
  }, [_c('span', [_vm._v("内容拓展")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "classRequirement",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "placeholder": "可额外输入其他上课要求，支持中文哦"
    },
    model: {
      value: (_vm.formData.classRequirement),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirement", $$v)
      },
      expression: "formData.classRequirement"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveClassRequirement
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list pending-interview-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("待面试老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-actions"
  }, [_c('Button', {
    attrs: {
      "type": _vm.view === 'list' ? 'primary' : 'ghost',
      "icon": "android-list"
    },
    on: {
      "click": function($event) {
        return _vm.switchView('list')
      }
    }
  }, [_vm._v("列表视图")]), _vm._v(" "), _c('span', {
    staticClass: "pill is-blue"
  }, [_vm._v("今日面试 (" + _vm._s(_vm.summary.todayInterview || 0) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "pill is-green"
  }, [_vm._v("今日试讲 (" + _vm._s(_vm.summary.todayDemo || 0) + ")")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.view === 'schedule' ? 'primary' : 'ghost',
      "icon": "calendar"
    },
    on: {
      "click": function($event) {
        return _vm.switchView('schedule')
      }
    }
  }, [_vm._v("面试时间表")])], 1)]), _vm._v(" "), (_vm.view === 'list') ? [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "老师ID / 姓名 / 邮箱"
    },
    model: {
      value: (_vm.queryParam.keyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "keyword", $$v)
      },
      expression: "queryParam.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国籍"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "国籍"
    },
    model: {
      value: (_vm.queryParam.nationality),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nationality", $$v)
      },
      expression: "queryParam.nationality"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('div', {
    staticClass: "referrer-field"
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.noReferrer,
      "placeholder": "推荐人姓名"
    },
    model: {
      value: (_vm.referrerName),
      callback: function($$v) {
        _vm.referrerName = $$v
      },
      expression: "referrerName"
    }
  }), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.noReferrer),
      callback: function($$v) {
        _vm.noReferrer = $$v
      },
      expression: "noReferrer"
    }
  }, [_vm._v("无推荐人")])], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "面试状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.interviewStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "interviewStatus", $$v)
      },
      expression: "queryParam.interviewStatus"
    }
  }, _vm._l((_vm.stageStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试讲状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.demoStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "demoStatus", $$v)
      },
      expression: "queryParam.demoStatus"
    }
  }, _vm._l((_vm.stageStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "复审"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.reviewStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "reviewStatus", $$v)
      },
      expression: "queryParam.reviewStatus"
    }
  }, _vm._l((_vm.reviewStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Offer状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.offerStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "offerStatus", $$v)
      },
      expression: "queryParam.offerStatus"
    }
  }, _vm._l((_vm.offerStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "面试时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.interviewRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": "",
      "placeholder": "选择日期区间",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onInterviewRangeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试讲时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.demoRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": "",
      "placeholder": "选择日期区间",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onDemoRangeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 20
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "batch-bar"
  }, [_c('span', {
    staticClass: "batch-hint"
  }, [_vm._v("已选 " + _vm._s(_vm.selectedRows.length) + " 人（当前页）")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'review'
    },
    on: {
      "click": _vm.batchSubmitReview
    }
  }, [_vm._v("批量提交复审")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'reserve'
    },
    on: {
      "click": _vm.openBatchReserve
    }
  }, [_vm._v("批量转储备")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'offer'
    },
    on: {
      "click": _vm.batchOfferSent
    }
  }, [_vm._v("批量发Offer")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.loading,
      "size": "small"
    },
    on: {
      "on-selection-change": _vm.onSelectionChange
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": "",
      "show-elevator": "",
      "page-size-opts": [10, 20, 50, 100],
      "placement": "top"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })] : _c('recruit-schedule-board', {
    ref: "board",
    on: {
      "open-tch": function (row) { return _vm.openTchInfoModal(row.tchId); },
      "on-change": function($event) {
        return _vm.afterChange(false)
      }
    }
  }), _vm._v(" "), _c('recruit-schedule-modal', {
    attrs: {
      "row": _vm.activeRow,
      "kind": _vm.scheduleKind
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.scheduleVisible),
      callback: function($$v) {
        _vm.scheduleVisible = $$v
      },
      expression: "scheduleVisible"
    }
  }), _vm._v(" "), _c('recruit-notes-modal', {
    attrs: {
      "row": _vm.activeRow
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.notesVisible),
      callback: function($$v) {
        _vm.notesVisible = $$v
      },
      expression: "notesVisible"
    }
  }), _vm._v(" "), _c('recruit-review-modal', {
    attrs: {
      "row": _vm.activeRow,
      "mode": _vm.reviewMode
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.reviewVisible),
      callback: function($$v) {
        _vm.reviewVisible = $$v
      },
      expression: "reviewVisible"
    }
  }), _vm._v(" "), _c('recruit-reason-modal', {
    attrs: {
      "title": _vm.reason.title,
      "label": _vm.reason.label,
      "desc": _vm.reason.desc,
      "placeholder": _vm.reason.placeholder,
      "init-reason": _vm.reason.init,
      "loading": _vm.reasonLoading,
      "kind-options": _vm.reason.kindOptions,
      "kind-label": _vm.reason.kindLabel,
      "init-kind": _vm.reason.initKind
    },
    on: {
      "on-ok": _vm.onReasonOk
    },
    model: {
      value: (_vm.reasonVisible),
      callback: function($$v) {
        _vm.reasonVisible = $$v
      },
      expression: "reasonVisible"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.reloadPage,
      "recruit-flow-entry": "待面试老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("待面试老师")]), _vm._v(" "), _c('p', {
    staticClass: "page-sub"
  }, [_vm._v("管理面试和试讲课安排，评估外教教学能力 · Manage interview & demo")])])
}]}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑关闭时间",
      "width": 800
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择关闭时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "结束日期,不包含当天",
      "clearable": false,
      "value": _vm.timeParam.endDateStr
    },
    on: {
      "on-change": _vm.onChangeEndDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "timeListForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": 15
      }
    }, [_c('label', [_c('b', [_vm._v(_vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,   \n                  生效日期：" + _vm._s(item.useDateStr) + ", 结束日期：" + _vm._s(item.endDateStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 1
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "如果是新增时间，请输入关闭的原因",
      "rows": 3
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": false
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("今日将转出名单")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "意向等级："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "不论"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "intentLevel", $$v)
      },
      expression: "queryParam.intentLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("意向一般")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无效资源")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学员状态："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "不论"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.stdStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdStatus", $$v)
      },
      expression: "queryParam.stdStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("已预约")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已试听")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("付款未绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("已绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("已开课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("已完课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("退费")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "接通状态："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "不论"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "connectionStatus", $$v)
      },
      expression: "queryParam.connectionStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("未拨打")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("拨打未接")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("拨打接通")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生:",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册日期:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.regStartTimeDate
    },
    on: {
      "on-change": _vm.regTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.regEndTimeDate
    },
    on: {
      "on-change": _vm.regTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('adviser-float-modal', {
    attrs: {
      "adviserId": _vm.queryParam.adviserId,
      "teamType": _vm.queryParam.teamType
    },
    on: {
      "get_adviser": _vm.getAdviserInfo
    }
  }), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/userinfo/dailyTransOut",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加订单",
      "width": "700"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "channel"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.loadCoursePackageTypeData2
    },
    model: {
      value: (_vm.formData.channel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "channel", _vm._n($$v))
      },
      expression: "formData.channel"
    }
  }, _vm._l((_vm.$constant.orderChannelNew), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "on-blur": _vm.inputMobile
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formData.channel === 1) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 12,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "介绍人",
      "prop": "inviteId",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "介绍人学生ID"
    },
    model: {
      value: (_vm.formData.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inviteId", _vm._n($$v))
      },
      expression: "formData.inviteId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "转介绍课时",
      "prop": "inviteClassHour",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "上满一个月后系统系统会自动赠送"
    },
    model: {
      value: (_vm.formData.inviteClassHour),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inviteClassHour", _vm._n($$v))
      },
      expression: "formData.inviteClassHour"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "转介绍凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 200,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "contractName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.contractName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractName", $$v)
      },
      expression: "formData.contractName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.loadCoursePackageTypeData
    },
    model: {
      value: (_vm.formData.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchChannel", $$v)
      },
      expression: "formData.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 23,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时数量明细",
      "prop": "courseType"
    }
  }, [_c('Select', {
    key: _vm.packageSelectKey,
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onCourseTypeChange
    },
    model: {
      value: (_vm.formData.courseType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "courseType", $$v)
      },
      expression: "formData.courseType"
    }
  }, _vm._l((_vm.courseScheduleListData), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠送课时",
      "prop": "discountNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "赠送课时数"
    },
    on: {
      "input": _vm.calculateLeaveNum
    },
    model: {
      value: (_vm.formData.discountNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discountNum", _vm._n($$v))
      },
      expression: "formData.discountNum"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠金额",
      "prop": "discount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "优惠金额"
    },
    on: {
      "input": _vm.calculatePayAmount
    },
    model: {
      value: (_vm.formData.discount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discount", _vm._n($$v))
      },
      expression: "formData.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 23,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠说明",
      "prop": "discountRemark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "有优惠时必填"
    },
    model: {
      value: (_vm.formData.discountRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discountRemark", _vm._n($$v))
      },
      expression: "formData.discountRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单原价",
      "prop": "amount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "input": _vm.calculatePayAmount
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", _vm._n($$v))
      },
      expression: "formData.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠价",
      "prop": "amount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "payAmount", _vm._n($$v))
      },
      expression: "formData.payAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分笔："
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.formData.hasTwoPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "hasTwoPay", $$v)
      },
      expression: "formData.hasTwoPay"
    }
  }, [_vm._v("分笔付款")])], 1)], 1), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('InputNumber', {
    attrs: {
      "max": 3,
      "min": 2
    },
    on: {
      "on-change": _vm.zero
    },
    model: {
      value: (_vm.formData.twoPayNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "twoPayNum", _vm._n($$v))
      },
      expression: "formData.twoPayNum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "首笔款:",
      "prop": "firstPay",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不得少于1000"
    },
    on: {
      "on-change": _vm.calculate
    },
    model: {
      value: (_vm.formData.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "firstPay", _vm._n($$v))
      },
      expression: "formData.firstPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.twoPayNum === 3) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "二笔款:",
      "prop": "secondPay",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不得少于1000"
    },
    on: {
      "on-change": _vm.calculate
    },
    model: {
      value: (_vm.formData.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "secondPay", _vm._n($$v))
      },
      expression: "formData.secondPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "尾款:",
      "prop": "",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.lastPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastPay", _vm._n($$v))
      },
      expression: "formData.lastPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "报名加赠课时",
      "prop": "giveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.giveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "giveNum", _vm._n($$v))
      },
      expression: "formData.giveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 1) ? _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假次数",
      "prop": "leaveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.leaveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveNum", _vm._n($$v))
      },
      expression: "formData.leaveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抵消课机会",
      "prop": "leaveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.leaveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveNum", _vm._n($$v))
      },
      expression: "formData.leaveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 1) ? _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "补课次数"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.makeupLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeupLessonNum", _vm._n($$v))
      },
      expression: "formData.makeupLessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "24小时内取消课机会"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.makeupLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeupLessonNum", _vm._n($$v))
      },
      expression: "formData.makeupLessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "编辑合同",
      "prop": "contractVersionId"
    }
  }, [_c('Select', {
    attrs: {
      "placement": "top",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChangeSelectContractVersion
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.showDealMonth) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "成交月份",
      "prop": "dealMonth"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择成交月份",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dealMonth),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dealMonth", $$v)
      },
      expression: "formData.dealMonth"
    }
  }, _vm._l((_vm.dealMonthOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "编辑课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.levelTitle),
      callback: function($$v) {
        _vm.levelTitle = $$v
      },
      expression: "levelTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.lessonTitle),
      callback: function($$v) {
        _vm.lessonTitle = $$v
      },
      expression: "lessonTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('quillEditor', {
    ref: "updateQuillEditor",
    staticClass: "editor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "headers": _vm.headers,
      "accept": _vm.acceptType,
      "on-success": _vm.upScuccess
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "updateInput",
      "element-loading-text": "插入中,请稍候"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("渠道成交率")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计周:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.dateRange,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": false,
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.onRangeChange
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.dimension !== 'category') ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.backToCategory
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    ref: "dealTable",
    attrs: {
      "height": _vm.tableHeight,
      "columns": _vm.columns,
      "data": _vm.list,
      "loading": _vm.searchLoading,
      "row-class-name": _vm.rowClassName
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("\n    合计：分配 " + _vm._s(_vm.totalAssignCount) + "，累计成交 " + _vm._s(_vm.totalDealCount) + "，累计成交率 " + _vm._s(_vm.formatRate(_vm.totalDealRate)) + "，当前成交 " + _vm._s(_vm.totalCurrentDealCount) + "，当前成交率 " + _vm._s(_vm.formatRate(_vm.totalCurrentDealRate)) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("禁用学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间："
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.regDateChange
    },
    model: {
      value: (_vm.regDateRange),
      callback: function($$v) {
        _vm.regDateRange = $$v
      },
      expression: "regDateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('Input', {
    attrs: {
      "name": "studyAdviserName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserName", $$v)
      },
      expression: "queryParam.studyAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问："
    }
  }, [_c('Input', {
    attrs: {
      "name": "adviserName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID："
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名："
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号："
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/notAllowed/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.mode === 'review') ? [_c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("审核结果")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.decision),
      callback: function($$v) {
        _vm.decision = $$v
      },
      expression: "decision"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "pass"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "fail"
    }
  }, [_vm._v("不通过")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("定级")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  }, _vm._l((_vm.grades), function(g) {
    return _c('Option', {
      key: g,
      attrs: {
        "value": g
      }
    }, [_vm._v(_vm._s(g))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("意见")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": "填写复审意见…"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)] : [_c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("状态")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("审核")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s(_vm.decisionText))])]), _vm._v(" "), _c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("定级")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewGrade) || '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "result-block"
  }, [_c('div', {
    staticClass: "result-label"
  }, [_vm._v("意见")]), _vm._v(" "), _c('div', {
    staticClass: "result-remark"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewRemark) || '（无）'))])]), _vm._v(" "), _c('div', {
    staticClass: "result-meta"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewerName) || '') + " · " + _vm._s((_vm.row && _vm.row.reviewTime) || ''))])], _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.mode === 'review') ? [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交复审结果")])] : _c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配学导记录")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配时间"
    }
  }, [_c('Row', [_c('Col', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.beginTimeChange
    }
  })], 1), _vm._v(" "), _c('Col', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入id或学生名称"
    },
    model: {
      value: (_vm.queryParam.searchIdOrName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchIdOrName", $$v)
      },
      expression: "queryParam.searchIdOrName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.oldAdminId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "oldAdminId", $$v)
      },
      expression: "queryParam.oldAdminId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "接收人"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.receiverId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "receiverId", $$v)
      },
      expression: "queryParam.receiverId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配原因"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "reason", $$v)
      },
      expression: "queryParam.reason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新生分配")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("服务原因更换")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("离职交接")])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/distributionLearnRecord/page",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-page",
    class: {
      'is-lock': !_vm.canEdit,
      'is-embed': _vm.embedded
    }
  }, [_c('div', {
    staticClass: "cf-app"
  }, [(_vm.loaded && _vm.blockTip) ? _c('div', {
    staticClass: "rater"
  }, [_vm._v(_vm._s(_vm.blockTip))]) : (_vm.loaded && !_vm.canEdit) ? _c('div', {
    staticClass: "rater"
  }, [_vm._v("评分人：" + _vm._s(_vm.raterName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rate"
  }, [_c('div', {
    staticClass: "q"
  }, [_vm._v("本节课整体表现，打几星？")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("1 星最低，5 星最高；打完星自动匹配该星级对应的课堂表现")]), _vm._v(" "), _c('div', {
    staticClass: "bigstars"
  }, _vm._l((5), function(n) {
    return _c('span', {
      key: n,
      staticClass: "s",
      class: {
        on: _vm.star >= n
      },
      on: {
        "click": function($event) {
          return _vm.setStar(n)
        }
      }
    }, [_vm._v("★")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rate-read"
  }, [(!_vm.star) ? _c('span', {
    staticClass: "hint"
  }, [_vm._v("点击星星打分")]) : [_c('span', {
    staticClass: "emo"
  }, [_vm._v(_vm._s(_vm.face))]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.rateStarText))]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("　" + _vm._s(_vm.star) + " 星 · " + _vm._s(_vm.faceTxt))])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sug",
    class: {
      show: _vm.star > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.recList), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "tag",
      class: {
        sel: _vm.isPicked(o.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v(_vm._s(o.text))]), _vm._v(" "), _c('div', {
      staticClass: "d"
    }, [_vm._v(_vm._s(o.dim))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sugbtns"
  }, [_c('button', {
    staticClass: "mini strong",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("换一换")]), _vm._v(" "), _c('button', {
    staticClass: "mini",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLib
    }
  }, [_vm._v(_vm._s(_vm.libBtnText))])]), _vm._v(" "), _c('div', {
    staticClass: "lib",
    class: {
      show: _vm.libOpen
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.libKw),
      expression: "libKw"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "搜索关键词，如：纠音、口音、开口、迟到"
    },
    domProps: {
      "value": (_vm.libKw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.libKw = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.star) ? _c('div', [(_vm.libList.length) ? _c('div', {
    staticClass: "grp"
  }, [_c('h4', [_c('span', {
    staticClass: "n"
  }, [_vm._v(_vm._s(_vm.star) + "星")]), _vm._v(" " + _vm._s(_vm.faceTxt) + "　" + _vm._s(_vm.libList.length) + " 项" + _vm._s(_vm.libSuffix))]), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.libList), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "tag",
      class: {
        sel: _vm.isPicked(o.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v(_vm._s(o.text))]), _vm._v(" "), _c('div', {
      staticClass: "d"
    }, [_vm._v(_vm._s(o.dim))])])
  }), 0)]) : _c('div', {
    staticClass: "lib-empty"
  }, [_vm._v("该星级下没有匹配的选项")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "picked",
    class: {
      show: _vm.pickedIds.length > 0
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_vm._v("已选表现 "), _c('span', [_vm._v(_vm._s(_vm.pickCountText))])]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, _vm._l((_vm.pickedItems), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "chip",
      on: {
        "click": function($event) {
          return _vm.removePicked(o.id)
        }
      }
    }, [_vm._v(_vm._s(o.text) + " "), _c('i', [_vm._v("· " + _vm._s(o.dim) + " · " + _vm._s(o.star) + "星")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conflictText),
      expression: "conflictText"
    }],
    staticClass: "conflict"
  }, [_vm._v(_vm._s(_vm.conflictText))])]), _vm._v(" "), _c('div', {
    staticClass: "redcard",
    class: {
      on: _vm.redCodes.length > 0
    }
  }, [_c('div', {
    staticClass: "rt"
  }, [_vm._v("红线库（一票否决）")]), _vm._v(" "), _c('div', {
    staticClass: "rd"
  }, [_vm._v("勾选任一红线项 → 本次直接判 1 星；外教可在 7 日内申请复听重评")]), _vm._v(" "), _vm._l((_vm.redList), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "ritem",
      class: {
        sel: _vm.isRed(item.code)
      },
      on: {
        "click": function($event) {
          return _vm.toggleRed(item.code)
        }
      }
    }, [_c('span', {
      staticClass: "ck"
    }), _vm._v(" "), _c('span', {
      staticClass: "rl-t"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "rl-d"
    }, [_vm._v(_vm._s(item.desc))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "sum-label"
  }, [_vm._v("综合评分")]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_c('span', [_vm._v(_vm._s(_vm.scoreText))]), _c('small', [_vm._v(" / 5.00")])])]), _vm._v(" "), _c('div', {
    staticClass: "sum-right"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.summaryStars))]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_vm._v(_vm._s(_vm.gradeText))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.adviceText),
      expression: "adviceText"
    }],
    staticClass: "advice"
  }, [_vm._v(_vm._s(_vm.adviceText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.redWarn),
      expression: "redWarn"
    }],
    staticClass: "warn"
  }, [_vm._v(_vm._s(_vm.redWarn))])]), _vm._v(" "), _c('div', {
    staticClass: "card note"
  }, [_c('h2', [_vm._v("补充说明（可选）")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    attrs: {
      "maxlength": "500",
      "readonly": !_vm.canEdit,
      "placeholder": "我还有话说…（典型问题、亮点行为、建议复查时间）"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cnt"
  }, [_c('span', [_vm._v(_vm._s(_vm.note.length))]), _vm._v("/500")])]), _vm._v(" "), (_vm.canEdit) ? _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cap"
  }, [_c('b', [_vm._v("该星级对应的课堂表现")]), _vm._v("（勾选符合的项，可多选）：")])
}]}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加活动"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createActivityForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.activityRules,
      "model": _vm.createActivityParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.createActivityParams.name),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "name", $$v)
      },
      expression: "createActivityParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动分类：",
      "prop": "activityType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createActivityParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "activityType", $$v)
      },
      expression: "createActivityParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动时间：",
      "prop": "activityTime"
    }
  }, [_c('DatePicker', {
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动标识：",
      "prop": "tag"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动标识"
    },
    model: {
      value: (_vm.createActivityParams.tag),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "tag", $$v)
      },
      expression: "createActivityParams.tag"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createActivityParams.status),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "status", $$v)
      },
      expression: "createActivityParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动说明："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入活动描述"
    },
    model: {
      value: (_vm.createActivityParams.description),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "description", $$v)
      },
      expression: "createActivityParams.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.createActivity
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外教开课Checklist")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入老师ID",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.keyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "keyword", $$v)
      },
      expression: "queryParam.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.pagination.totalCount,
      "current": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage,
      "on-page-size-change": _vm.changePageSize
    }
  })], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "外教开课Checklist",
      "width": "960",
      "footer-hide": ""
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [(_vm.detailLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  })], 1) : _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-head"
  }, [_c('span', {
    staticClass: "detail-name"
  }, [_vm._v(_vm._s(_vm.detailName))]), _vm._v(" "), _c('span', {
    staticClass: "detail-progress"
  }, [_vm._v("总进度：" + _vm._s(_vm.detailDoneCount) + "/" + _vm._s(_vm.detailTotalCount))])]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailRows,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "移至退费",
      "width": "680"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "refundForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 110
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uid"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 14
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID",
      "disabled": _vm.uidDisabled
    },
    on: {
      "on-blur": _vm.onUidBlur
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", $$v)
      },
      expression: "formData.uid"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loadingRemain
    },
    on: {
      "click": _vm.loadRemainHour
    }
  }, [_vm._v("查询课时\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.remainLoaded) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nickname) + _vm._s(_vm.mobile ? ' / ' + _vm.mobile : ''))])])], 1) : _vm._e(), _vm._v(" "), (_vm.remainLoaded && _vm.tchChannel !== 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v("剩余 " + _vm._s(_vm.foreignRemain))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("锁定 " + _vm._s(_vm.foreignLock))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("本次扣减")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "90px",
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "扣减"
    },
    model: {
      value: (_vm.formData.foreignDeduct),
      callback: function($$v) {
        _vm.$set(_vm.formData, "foreignDeduct", _vm._n($$v))
      },
      expression: "formData.foreignDeduct"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.remainLoaded && _vm.tchChannel !== 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "中教"
    }
  }, [_c('span', [_vm._v("剩余 " + _vm._s(_vm.chineseRemain))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("锁定 " + _vm._s(_vm.chineseLock))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("本次扣减")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "90px",
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "扣减"
    },
    model: {
      value: (_vm.formData.chineseDeduct),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chineseDeduct", _vm._n($$v))
      },
      expression: "formData.chineseDeduct"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.remainLoaded && _vm.tchChannel !== 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "陪练"
    }
  }, [_c('span', [_vm._v("剩余 " + _vm._s(_vm.partnerRemain))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("锁定 " + _vm._s(_vm.partnerLock))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("本次扣减")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "90px",
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "扣减"
    },
    model: {
      value: (_vm.formData.partnerDeduct),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partnerDeduct", _vm._n($$v))
      },
      expression: "formData.partnerDeduct"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.remainLoaded && _vm.tchChannel === 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "可用"
    }
  }, [_c('span', [_vm._v("剩余 " + _vm._s(_vm.figAvailable))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("本次扣减")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "90px",
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "扣减"
    },
    model: {
      value: (_vm.formData.figAvailableDeduct),
      callback: function($$v) {
        _vm.$set(_vm.formData, "figAvailableDeduct", _vm._n($$v))
      },
      expression: "formData.figAvailableDeduct"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.remainLoaded && _vm.tchChannel === 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "锁定"
    }
  }, [_c('span', [_vm._v("剩余 " + _vm._s(_vm.figLock))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("本次扣减")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "90px",
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "扣减"
    },
    model: {
      value: (_vm.formData.figLockDeduct),
      callback: function($$v) {
        _vm.$set(_vm.formData, "figLockDeduct", _vm._n($$v))
      },
      expression: "formData.figLockDeduct"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退费原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "maxlength": 200,
      "placeholder": "请输入退费原因"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教引起"
    }
  }, [_c('Checkbox', {
    on: {
      "on-change": _vm.onTeacherCauseChange
    },
    model: {
      value: (_vm.teacherCauseChecked),
      callback: function($$v) {
        _vm.teacherCauseChecked = $$v
      },
      expression: "teacherCauseChecked"
    }
  }, [_vm._v("外教引起")])], 1)], 1), _vm._v(" "), (_vm.teacherCauseChecked) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2]
    },
    on: {
      "change-select": _vm.onTchSelect
    },
    model: {
      value: (_vm.formData.tchId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchId", $$v)
      },
      expression: "formData.tchId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "短信验证码",
      "prop": "smsCode"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "短信验证码"
    },
    model: {
      value: (_vm.formData.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "smsCode", $$v)
      },
      expression: "formData.smsCode"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.smsCodeDisabled
    },
    on: {
      "click": _vm.sendSmsCode
    }
  }, [_vm._v("\n                " + _vm._s(_vm.smsCodeDisabled ? _vm.smsCodeTime + '秒后重发' : '发送验证码') + "\n              ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生状态审核")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-postion": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID/中文名/英文名"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "变更后状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.afterStatusRecord),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "afterStatusRecord", $$v)
      },
      expression: "queryParam.afterStatusRecord"
    }
  }, _vm._l((_vm.$constant.studentStatusAudit), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请人"
    }
  }, [_c('sales-adviser-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.queryParam.createdId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "createdId", $$v)
      },
      expression: "queryParam.createdId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已通过")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已驳回")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待审核")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请提交时间:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "class-name": "btn-container",
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 2
      }
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disabled": _vm.searchLoading,
      "icon": "search",
      "long": ""
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 2
      }
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disabled": _vm.searchLoading,
      "long": ""
    },
    on: {
      "click": _vm.showPassAll
    }
  }, [_vm._v("批量审核通过\n      ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      },
      "md": {
        span: 8
      },
      "lg": {
        span: 2
      }
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disabled": _vm.searchLoading,
      "long": ""
    },
    on: {
      "click": _vm.showRefusedAll
    }
  }, [_vm._v("\n        批量审核拒绝\n      ")])], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/userstatusreview/page",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "请填写拒绝理由"
    },
    model: {
      value: (_vm.showWhyNotModal),
      callback: function($$v) {
        _vm.showWhyNotModal = $$v
      },
      expression: "showWhyNotModal"
    }
  }, [_c('Form', {
    ref: "WhyNot",
    staticClass: "form",
    attrs: {
      "model": _vm.auditParams
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "拒绝理由"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入拒绝原因"
    },
    model: {
      value: (_vm.auditParams.refuse),
      callback: function($$v) {
        _vm.$set(_vm.auditParams, "refuse", $$v)
      },
      expression: "auditParams.refuse"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingWhyNot
    },
    on: {
      "click": _vm.audit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('Row', {
    staticClass: "expand-row"
  }, _vm._l((_vm.itemList), function(item) {
    return _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Tooltip', {
      attrs: {
        "content": item.descr
      }
    }, [_c('a', {
      staticClass: "expand-value",
      on: {
        "click": function($event) {
          return _vm.editItem(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])], 1)
  }), 1)], 1), _vm._v(" "), _c('EditItemModal', {
    attrs: {
      "itemId": _vm.itemId,
      "value": _vm.editModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("推荐官管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search search-compact",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 78,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.referrerKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "referrerKeyword", $$v)
      },
      expression: "queryParam.referrerKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "FM",
      "label-width": 30
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.fmId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fmId", _vm._n($$v))
      },
      expression: "queryParam.fmId"
    }
  }, _vm._l((_vm.fmList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "HR负责人",
      "label-width": 70
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hrName", $$v)
      },
      expression: "queryParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态",
      "label-width": 44
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("招聘试用期")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("招聘转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("招聘停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "年月",
      "label-width": 44
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月份",
      "format": "yyyy-MM",
      "clearable": ""
    },
    on: {
      "on-change": _vm.yearMonthChange
    },
    model: {
      value: (_vm.queryParam.yearMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "yearMonth", $$v)
      },
      expression: "queryParam.yearMonth"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_vm._v("添加推荐官")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "person-add"
    },
    on: {
      "click": _vm.openBatchHrModal
    }
  }, [_vm._v("分配HR负责人")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-calendar"
    },
    on: {
      "click": _vm.openBackfillModal
    }
  }, [_vm._v("生成历史汇总")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rank-panel"
  }, [_c('div', {
    staticClass: "rank-title"
  }, [_vm._v("奖励排行榜（" + _vm._s(_vm.queryParam.yearMonth || '本月') + "）")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.rankColumns,
      "data": _vm.rankList,
      "loading": _vm.rankLoading,
      "size": "small",
      "border": ""
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "1050",
      "title": "添加推荐官"
    },
    model: {
      value: (_vm.showAddModal),
      callback: function($$v) {
        _vm.showAddModal = $$v
      },
      expression: "showAddModal"
    }
  }, [_c('Form', {
    ref: "addForm",
    attrs: {
      "label-width": 100,
      "model": _vm.addParam,
      "rules": _vm.addRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "推荐官ID",
      "prop": "referrerId"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "min": 1,
      "precision": 0,
      "placeholder": "请输入推荐官老师ID"
    },
    on: {
      "on-change": _vm.onReferrerIdChange,
      "on-blur": _vm.onReferrerIdBlur
    },
    model: {
      value: (_vm.addParam.referrerId),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "referrerId", $$v)
      },
      expression: "addParam.referrerId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "推荐官姓名"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "留空则自动取老师姓名"
    },
    model: {
      value: (_vm.addParam.referrerName),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "referrerName", $$v)
      },
      expression: "addParam.referrerName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "FM"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择FM",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.fmId),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "fmId", _vm._n($$v))
      },
      expression: "addParam.fmId"
    }
  }, _vm._l((_vm.fmList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "HR负责人"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择HR负责人",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "hrName", $$v)
      },
      expression: "addParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "加入日期"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请手动选择（默认空）",
      "format": "yyyy-MM-dd",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onAddJoinDateChange
    },
    model: {
      value: (_vm.addParam.joinDate),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "joinDate", $$v)
      },
      expression: "addParam.joinDate"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "选择状态",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.status),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "status", $$v)
      },
      expression: "addParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("招聘试用期")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("招聘转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("招聘停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showAddModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "推荐官详情"
    },
    model: {
      value: (_vm.showDetailModal),
      callback: function($$v) {
        _vm.showDetailModal = $$v
      },
      expression: "showDetailModal"
    }
  }, [(_vm.detailData) ? _c('div', [_c('Row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("推荐官ID：")]), _vm._v(_vm._s(_vm.detailData.referrerId) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.detailData.referrerName) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("状态：")]), _vm._v(_vm._s(_vm.getStatusText(_vm.detailData.status)) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("FM：")]), _vm._v(_vm._s(_vm.detailData.fmName || '-') + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("HR负责人：")]), _vm._v(_vm._s(_vm.detailData.hrName || '-') + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("加入日期：")]), _vm._v(_vm._s(_vm.detailData.joinDate) + "\n        ")])], 1), _vm._v(" "), _c('Divider', [_vm._v("月度统计数据")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.monthlyStats,
      "size": "small",
      "border": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "400",
      "title": "分配HR负责人"
    },
    model: {
      value: (_vm.showHrModal),
      callback: function($$v) {
        _vm.showHrModal = $$v
      },
      expression: "showHrModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "model": _vm.hrParam
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "HR负责人"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择HR负责人",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.hrParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.hrParam, "hrName", $$v)
      },
      expression: "hrParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showHrModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingHr
    },
    on: {
      "click": _vm.onUpdateHr
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "480",
      "title": "生成历史汇总"
    },
    model: {
      value: (_vm.showBackfillModal),
      callback: function($$v) {
        _vm.showBackfillModal = $$v
      },
      expression: "showBackfillModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "开始月"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择开始月",
      "format": "yyyy-MM"
    },
    on: {
      "on-change": _vm.onBackfillStartChange
    },
    model: {
      value: (_vm.backfillParam.startMonth),
      callback: function($$v) {
        _vm.$set(_vm.backfillParam, "startMonth", $$v)
      },
      expression: "backfillParam.startMonth"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "结束月"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择结束月",
      "format": "yyyy-MM"
    },
    on: {
      "on-change": _vm.onBackfillEndChange
    },
    model: {
      value: (_vm.backfillParam.endMonth),
      callback: function($$v) {
        _vm.$set(_vm.backfillParam, "endMonth", $$v)
      },
      expression: "backfillParam.endMonth"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999",
      "padding-left": "90px",
      "line-height": "1.5"
    }
  }, [_vm._v("\n        将按起止月幂等写入月汇总表；当月不落表（保持实时）。可用于支撑累计与排行历史。\n      ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showBackfillModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBackfill
    },
    on: {
      "click": _vm.onGenerateRewardMonth
    }
  }, [_vm._v("生成")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/referrer/info/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("待审核老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminNickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminMobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.filteredTeacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师国籍"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.country),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "country", $$v)
      },
      expression: "queryParam.country"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师口音"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师性别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "种族"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ethnicity", $$v)
      },
      expression: "queryParam.ethnicity"
    }
  }, [_c('Option', {
    attrs: {
      "value": "African"
    }
  }, [_vm._v("African")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Coloured"
    }
  }, [_vm._v("Coloured")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "White"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Indian/Asian"
    }
  }, [_vm._v("Indian/Asian")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertTch
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBatchReview
    }
  }, [_vm._v("批量审核")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/unaudited/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核通过"
    },
    model: {
      value: (_vm.showPassModal),
      callback: function($$v) {
        _vm.showPassModal = $$v
      },
      expression: "showPassModal"
    }
  }, [_c('Form', {
    ref: "passForm",
    staticClass: "form",
    attrs: {
      "model": _vm.passParam,
      "rules": _vm.passRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定允许 "), _c('b', [_vm._v(_vm._s(_vm.passParam.id) + " - " + _vm._s(_vm.passParam.firstName) + " " + _vm._s(_vm.passParam.lastName))]), _vm._v("\n              老师通过审核，进入培训中")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.passParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.passParam, "remark", $$v)
      },
      expression: "passParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showPassModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingPass
    },
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("通过")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    staticClass: "form",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定 "), _c('b', [_vm._v(_vm._s(_vm.rejectParam.id) + " - " + _vm._s(_vm.rejectParam.firstName) + " " + _vm._s(_vm.rejectParam.lastName))]), _vm._v(" 老师未审核通过")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.rejectParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "remark", $$v)
      },
      expression: "rejectParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "批量审核"
    },
    model: {
      value: (_vm.showBatchReviewModal),
      callback: function($$v) {
        _vm.showBatchReviewModal = $$v
      },
      expression: "showBatchReviewModal"
    }
  }, [_c('Form', {
    ref: "reviewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.reviewParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "待审核老师："
    }
  }, _vm._l((_vm.selectionTch), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.reviewParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "remark", $$v)
      },
      expression: "reviewParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchPass')
      }
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchReject')
      }
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.search,
      "recruit-flow-entry": "待审核老师列表"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("多级别绑定等级")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "空则分页查全部"
    },
    model: {
      value: (_vm.uid),
      callback: function($$v) {
        _vm.uid = $$v
      },
      expression: "uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.tableLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0 12px"
    }
  }, [_vm._v("\n    待分配 + 常规里 stars>1 的学生。按学生分组。改课件 level 只改绑定，不重排已选课。\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "bind-level-table",
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.tableLoading) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "16px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("加载中...")])]) : (!_vm.rows.length) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "16px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: row.rowKey || index
    }, [(row.rowSpan) ? _c('td', {
      attrs: {
        "rowspan": row.rowSpan
      }
    }, [_vm._v(_vm._s(row.uid))]) : _vm._e(), _vm._v(" "), (row.rowSpan) ? _c('td', {
      attrs: {
        "rowspan": row.rowSpan
      }
    }, [_vm._v(_vm._s(row.nickname))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchTime))]), _vm._v(" "), _c('td', [(row.bindId) ? _c('Select', {
      attrs: {
        "filterable": "",
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onLevelChange(row, $event)
        }
      },
      model: {
        value: (row.levelId),
        callback: function($$v) {
          _vm.$set(row, "levelId", $$v)
        },
        expression: "row.levelId"
      }
    }, _vm._l((_vm.levelOptions), function(lv) {
      return _c('Option', {
        key: lv.id,
        attrs: {
          "value": lv.id
        }
      }, [_vm._v(_vm._s(lv.title))])
    }), 1) : _c('span', [_vm._v("-")])], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "120"
    }
  }, [_vm._v("学生ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "180"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("绑定老师时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "260"
    }
  }, [_vm._v("课件level")])])])
}]}

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加推荐老师",
      "width": "1200px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("陪练")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音",
      "prop": "tchId",
      "label-width": 65
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别",
      "prop": "tchId",
      "label-width": 65
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 13
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "买断时间"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效时间"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.useStartDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "useStartDate", $$v)
      },
      expression: "queryParam.useStartDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('TimePicker', {
    staticStyle: {
      "width": "112px"
    },
    attrs: {
      "format": "HH:mm",
      "placeholder": "上课开始时间",
      "steps": [1, 30]
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.queryParam.startDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startDate", $$v)
      },
      expression: "queryParam.startDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id",
      "label-width": 65
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 8,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称",
      "prop": "name",
      "label-width": 65
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "name"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('RecommendList', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "onLoading": _vm.onLoading,
      "loading": _vm.searchLoading,
      "tableColumns": _vm.title,
      "listUrl": "/tch/searchTchInfo",
      "params": _vm.queryParam,
      "reload": _vm.reload,
      "reset": _vm.reset
    },
    on: {
      "on-selection-change": _vm.selectChange
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "GROWTH",
      "title": "新人成长",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("短信发送")])], 1)], 1), _vm._v(" "), _c('i-form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phones"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.phones),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phones", $$v)
      },
      expression: "formData.phones"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "短信内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('i-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生对老师评价"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "feedback form",
    attrs: {
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "网络状况"
    }
  }, [_c('label', [_c('Rate', {
    attrs: {
      "disabled": "",
      "count": _vm.feedback.networkStar
    },
    model: {
      value: (_vm.feedback.networkStar),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "networkStar", $$v)
      },
      expression: "feedback.networkStar"
    }
  })], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课质量"
    }
  }, [_c('label', [_c('Rate', {
    attrs: {
      "disabled": "",
      "count": _vm.feedback.qualityStar
    },
    model: {
      value: (_vm.feedback.qualityStar),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "qualityStar", $$v)
      },
      expression: "feedback.qualityStar"
    }
  })], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "喜欢程度"
    }
  }, [_c('label', [_c('Rate', {
    attrs: {
      "disabled": "",
      "count": _vm.feedback.likeStar
    },
    model: {
      value: (_vm.feedback.likeStar),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "likeStar", $$v)
      },
      expression: "feedback.likeStar"
    }
  })], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "投诉原因"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedback.complaintReasonStr))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "投诉补充"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedback.otherComplaintReason))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.feedback.isComplaint === 1) ? _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消投诉")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('ul', {
    ref: "con1",
    class: {
      anim: _vm.animate == true
    },
    attrs: {
      "id": "con1"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": __webpack_require__(1297),
        "height": "25",
        "width": "25"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "今日打卡分配数统计",
      "width": "350"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Table', {
    ref: "table",
    attrs: {
      "height": "300",
      "columns": _vm.title,
      "data": _vm.tableData,
      "stripe": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "编辑课程音频",
      "width": "600px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "audioForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.audioRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "disabled": "",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", _vm._n($$v))
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "音频标题",
      "prop": "title",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "上传音频自动获取标题，也可自定义标题"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传音频",
      "label-width": 100,
      "prop": "audioUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "audio/mpeg",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), (_vm.formData.audioUrl) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "position": "absolute",
      "top": "0px",
      "left": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showIndex(_vm.formData.audioUrl)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-view el-icon--left"
  }), _vm._v("预览")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": ("订单权益 (订单课时：" + _vm.totalNum + ")"),
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dragon-tiger-rank-v2"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trophy",
      "size": "32",
      "color": "#f39c12"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("班主任龙虎榜")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("班主任业绩排行榜")])], 1), _vm._v(" "), (_vm.newOrderList.length > 0) ? _c('div', {
    staticClass: "news-marquee"
  }, [_c('div', {
    staticClass: "marquee-content"
  }, _vm._l((_vm.newOrderList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "marquee-item"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-notifications",
        "size": "14",
        "color": "#ff9900"
      }
    }), _vm._v("\n              " + _vm._s(item) + " 🎉🎉🎉\n            ")], 1)
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('Card', {
    staticClass: "search-card"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.month),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "month", $$v)
      },
      expression: "queryParam.month"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "班主任",
      "prop": "adviserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser",
      "need-default-study-adviser": 0,
      "placeholder": "全部班主任"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "师资",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择师资",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "xs": 12,
      "sm": 6,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n                搜索\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "rank-card"
  }, [_c('div', {
    staticClass: "rank-card-header"
  }, [_c('span', {
    staticClass: "rank-title"
  }, [_vm._v("排行榜")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download-outline",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportToImage
    }
  }, [_vm._v("\n            导出图片\n          ")])], 1), _vm._v(" "), _c('div', {
    ref: "exportArea",
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "rank-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "rank-col"
  }, [_vm._v("排名")]), _vm._v(" "), _c('th', {
    staticClass: "name-col"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticClass: "quantity-col"
  }, [_vm._v("单量")]), _vm._v(" "), _c('th', {
    staticClass: "amount-col"
  }, [_vm._v("业绩")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rankingData), function(item, index) {
    return _c('tr', {
      key: index,
      class: ['rank-row', _vm.getRankClass(item.rank)]
    }, [_c('td', {
      staticClass: "rank-col"
    }, [_c('div', {
      staticClass: "rank-badge",
      class: _vm.getMedalClass(item.rank)
    }, [(item.rank <= 3) ? _c('span', [_vm._v(_vm._s(_vm.getMedalIcon(item.rank)))]) : _c('span', [_vm._v(_vm._s(item.rank))])])]), _vm._v(" "), _c('td', {
      staticClass: "name-col"
    }, [(_vm.canSeeRowDetail(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.goToPerformanceDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.adviserName))]) : _c('span', [_vm._v(_vm._s(item.adviserName))])]), _vm._v(" "), _c('td', {
      staticClass: "quantity-col"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "amount-col"
    }, [_vm._v("¥ " + _vm._s(_vm.$numeral(item.amount).format('0,0')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', {
    staticClass: "total-col total-label",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.$numeral(_vm.totalAmount).format('0,0')))])])])], 2)])]), _vm._v(" "), (_vm.rankingData.length === 0 && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-inbox",
      "size": "60",
      "color": "#dcdee2"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "不续费原因"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.attendanceRowThis,
      "model": _vm.attendanceRowThis
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.nickname),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "nickname", $$v)
      },
      expression: "attendanceRowThis.nickname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "一级原因"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.attendanceRowThis.remark),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "remark", $$v)
      },
      expression: "attendanceRowThis.remark"
    }
  }, _vm._l((_vm.$constant.stdOverRemark), function(item) {
    return _c('Option', {
      key: item.text,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "其他原因"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.attendanceRowThis.remarkExt),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "remarkExt", $$v)
      },
      expression: "attendanceRowThis.remarkExt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "附件图片"
    }
  }, [_c('multipleImageUpload', {
    attrs: {
      "defaultFileList": _vm.attachmentFileList,
      "text": "点击上传附件图片",
      "num": 5
    },
    on: {
      "on-file-change": _vm.handleAttachmentChange
    },
    model: {
      value: (_vm.attendanceRowThis.attachmentUrls),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "attachmentUrls", $$v)
      },
      expression: "attendanceRowThis.attachmentUrls"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-monitor"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("实时监课")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "lm-toolbar"
  }, [_c('input', {
    staticClass: "lm-autofill-trap",
    attrs: {
      "tabindex": "-1",
      "autocomplete": "off",
      "name": "lm-autofill-trap"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("学生")]), _vm._v(" "), _c('Select', {
    ref: "stuSelect",
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "multiple": "",
      "clearable": "",
      "transfer": "",
      "remote-method": _vm.remoteStudent,
      "loading": _vm.studentLoading,
      "placeholder": "学生姓名 / 手机号 / ID，可多选"
    },
    on: {
      "on-change": _vm.onStudentChange
    },
    model: {
      value: (_vm.selectedUids),
      callback: function($$v) {
        _vm.selectedUids = $$v
      },
      expression: "selectedUids"
    }
  }, _vm._l((_vm.studentOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id) + " - " + _vm._s(item.nickname) + " - " + _vm._s(item.mobile) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("课程类型")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "transfer": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.onLsnTypeChange
    },
    model: {
      value: (_vm.lsnType),
      callback: function($$v) {
        _vm.lsnType = _vm._n($$v)
      },
      expression: "lsnType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("常规课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("体验课")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("老师")]), _vm._v(" "), _c('Input', {
    ref: "tchInput",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "name": "lmTchKey",
      "autocomplete": "off",
      "clearable": "",
      "placeholder": "老师 ID / 姓名，回车搜索"
    },
    on: {
      "on-enter": _vm.fetchLessons,
      "on-clear": _vm.fetchLessons
    },
    model: {
      value: (_vm.tchKey),
      callback: function($$v) {
        _vm.tchKey = $$v
      },
      expression: "tchKey"
    }
  })], 1), _vm._v(" "), (_vm.canFilterMine) ? _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("只看我的学生")]), _vm._v(" "), _c('i-switch', {
    on: {
      "on-change": _vm.onOnlyMineChange
    },
    model: {
      value: (_vm.onlyMine),
      callback: function($$v) {
        _vm.onlyMine = $$v
      },
      expression: "onlyMine"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("进入自动播放")]), _vm._v(" "), _c('i-switch', {
    on: {
      "on-change": _vm.onAutoPlayChange
    },
    model: {
      value: (_vm.autoPlay),
      callback: function($$v) {
        _vm.autoPlay = $$v
      },
      expression: "autoPlay"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("同时播放数")]), _vm._v(" "), _c('InputNumber', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "min": 1,
      "max": _vm.playLimitMax
    },
    on: {
      "on-change": _vm.onPlayLimitChange
    },
    model: {
      value: (_vm.playLimit),
      callback: function($$v) {
        _vm.playLimit = $$v
      },
      expression: "playLimit"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("一行几个")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onColsChange
    },
    model: {
      value: (_vm.colsPerRow),
      callback: function($$v) {
        _vm.colsPerRow = _vm._n($$v)
      },
      expression: "colsPerRow"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("自适应")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("6")])], 1)], 1), _vm._v(" "), (_vm.hiddenLessons.length) ? _c('span', {
    staticClass: "lm-field"
  }, [_c('Dropdown', {
    attrs: {
      "trigger": "click",
      "transfer": ""
    },
    on: {
      "on-click": _vm.onHiddenClick
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          未展示 " + _vm._s(_vm.hiddenLessons.length) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.hiddenLessons), function(item) {
    return _c('Dropdown-item', {
      key: item.id,
      attrs: {
        "name": String(item.id)
      }
    }, [_vm._v("\n            " + _vm._s(_vm.hiddenLabel(item)) + "\n          ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_vm._l((_vm.hiddenLessons.slice(0, 3)), function(item) {
    return _c('Tag', {
      key: 'tag-' + item.id,
      nativeOn: {
        "click": function($event) {
          return _vm.replaceWithLesson(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.userNickname || item.uid) + "\n      ")])
  }), _vm._v(" "), (_vm.hiddenLessons.length > 3) ? _c('span', {
    staticClass: "lm-more"
  }, [_vm._v("等 " + _vm._s(_vm.hiddenLessons.length) + " 堂未展示")]) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('Button', {
    on: {
      "click": _vm.resetLayout
    }
  }, [_vm._v("重置布局")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "icon": "refresh"
    },
    on: {
      "click": _vm.fetchLessons
    }
  }, [_vm._v("刷新")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lm-hint"
  }, [_vm._v("可监课时间：体验课课前 " + _vm._s(_vm.trialBeforeMin) + " 分钟、课后 " + _vm._s(_vm.trialAfterMin) + " 分钟；常规课课前 " + _vm._s(_vm.regularBeforeMin) + " 分钟、课后 " + _vm._s(_vm.regularAfterMin) + " 分钟")]), _vm._v(" "), (!_vm.loading && !_vm.allLessons.length) ? _c('div', {
    staticClass: "lm-empty"
  }, [_vm._v("当前没有可监课的课程")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "canvas",
    staticClass: "lm-canvas",
    style: ({
      minHeight: _vm.canvasMinHeight + 'px'
    })
  }, _vm._l((_vm.windows), function(win) {
    return _c('live-monitor-window', {
      key: win.id,
      attrs: {
        "win": win
      },
      on: {
        "play": _vm.playWin,
        "pause": _vm.pauseWin,
        "focus": _vm.focusWin,
        "maximize": _vm.maximizeWin,
        "restore": _vm.restoreWin,
        "open-external": _vm.openExternal
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "查看上课时间",
      "width": "450"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "买断时间"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item) {
    return _c('Col', {
      key: item.week,
      attrs: {
        "span": 10
      }
    }, [_c('label', [_vm._v("\n                  " + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + "\n                ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "加课时间"
    }
  }, [_c('Checkbox-group', {
    model: {
      value: (_vm.randomOpenedTimeIdList),
      callback: function($$v) {
        _vm.randomOpenedTimeIdList = $$v
      },
      expression: "randomOpenedTimeIdList"
    }
  }, _vm._l((_vm.randomOpenedTimeList), function(item) {
    return _c('Checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr))])])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.invertSelect
    }
  }, [_vm._v("反选")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingCancel
    },
    on: {
      "click": _vm.canceOpenedTime
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "编辑分配权重",
      "width": "800",
      "mask-closable": false
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择课顾分组"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.formData.teamType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "teamType", $$v)
      },
      expression: "formData.teamType"
    }
  }, _vm._l((_vm.$constant.adviserGroup), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('ul', _vm._l((_vm.formData.adviserList), function(item) {
    return _c('li', [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": item.adviserName
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "权重"
      },
      on: {
        "on-change": _vm.onWeightChange
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": "渠道分类"
      }
    }, [_c('Select', {
      attrs: {
        "clearable": "",
        "multiple": "",
        "transfer": "",
        "placement": "top"
      },
      on: {
        "on-change": _vm.onTypeChange
      },
      model: {
        value: (item.channelTypes),
        callback: function($$v) {
          _vm.$set(item, "channelTypes", $$v)
        },
        expression: "item.channelTypes"
      }
    }, _vm._l((_vm.$constant.channelTypeEnum), function(item) {
      return _c('Option', {
        key: item.id,
        attrs: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.confirmAssign
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课堂投诉")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "tchId",
      "placeholder": "ID/昵称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchKey", $$v)
      },
      expression: "queryParam.tchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "uid",
      "placeholder": "ID/昵称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.uidKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uidKey", $$v)
      },
      expression: "queryParam.uidKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "投诉人："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "uid",
      "placeholder": "昵称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.adminKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminKey", $$v)
      },
      expression: "queryParam.adminKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "投诉理由："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  }, _vm._l((_vm.$constant.tchComplaintRemark), function(item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "是否处理："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师课耗"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.subSalary),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "subSalary", $$v)
      },
      expression: "queryParam.subSalary"
    }
  }, _vm._l((this.subSalaryEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生返课时："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.stdReturnNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdReturnNum", $$v)
      },
      expression: "queryParam.stdReturnNum"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "投诉日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchList/complaint/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('ModifyComplaintModal', {
    attrs: {
      "successCallback": _vm.search,
      "complaintRow": this.complaintRow,
      "visible": _vm.showComplaintModal
    },
    on: {
      "on-close": _vm.closeComplaintModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("体验学生")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 120,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lessonStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonStatus", _vm._n($$v))
      },
      expression: "queryParam.lessonStatus"
    }
  }, _vm._l((_vm.userLessonStatusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配课程顾问："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isAdviser", _vm._n($$v))
      },
      expression: "queryParam.isAdviser"
    }
  }, _vm._l((_vm.isAdviserList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "studyAdviserName"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "gutter": 12
    }
  }, [_c('Col'), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertUser
    }
  }, [_vm._v("添加学生")])], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配课程顾问")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/experience/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('AssignAdviserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser,
      "restrictToSelf": true
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  }), _vm._v(" "), _c('UserTestNetworkModal', {
    attrs: {
      "user": _vm.testNetworkParam
    },
    model: {
      value: (_vm.showTestNetworkModal),
      callback: function($$v) {
        _vm.showTestNetworkModal = $$v
      },
      expression: "showTestNetworkModal"
    }
  }), _vm._v(" "), _c('InsertUserModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showInsertUserModal),
      callback: function($$v) {
        _vm.showInsertUserModal = $$v
      },
      expression: "showInsertUserModal"
    }
  }), _vm._v(" "), _c('UserTrialLessonModal', {
    attrs: {
      "user": _vm.trialaLessonUser
    },
    model: {
      value: (_vm.showUserTrialLessonModal),
      callback: function($$v) {
        _vm.showUserTrialLessonModal = $$v
      },
      expression: "showUserTrialLessonModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/user/userExperienceList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.search,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.fileList), function(item) {
    return _c('div', {
      staticClass: "demo-upload-list"
    }, [(item.status === 'finished') ? [_c('img', {
      attrs: {
        "width": "100px",
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticStyle: {
      "display": "inline-block",
      "width": "58px"
    },
    attrs: {
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "accept": "image/*",
      "before-upload": _vm.beforeUpload,
      "type": "drag",
      "action": _vm.action,
      "multiple": false
    }
  }, [_c('div', {
    staticStyle: {
      "width": "58px",
      "height": "58px",
      "line-height": "58px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline",
      "size": "20"
    }
  }, [_vm._v("Select the file to upload")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "View Image"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "外管打分"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.attendanceRowThis,
      "model": _vm.attendanceRowThis
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.createMonth),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "createMonth", $$v)
      },
      expression: "attendanceRowThis.createMonth"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.tchName),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "tchName", $$v)
      },
      expression: "attendanceRowThis.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "请打分"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.attendanceRowThis.adminScore),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "adminScore", $$v)
      },
      expression: "attendanceRowThis.adminScore"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("电话沟通详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "主叫号码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.callTel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "callTel", $$v)
      },
      expression: "queryParam.callTel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "被叫号码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.calledTel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "calledTel", $$v)
      },
      expression: "queryParam.calledTel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  })], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/tel/listDetails",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "multiple": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.adminUserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname + ' - ' + item.phone))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配课程顾问"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.id + ' - ' + item.nickname) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "adviser",
      "restrictToSelf": _vm.restrictToSelf
    },
    model: {
      value: (_vm.adviserParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "adviserId", $$v)
      },
      expression: "adviserParam.adviserId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学导申请加课时记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookCourseChange/listAddCourseDetail",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [(_vm.single) ? [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText(_vm.single)))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "课节"
    }
  }, [(_vm.single.manual) ? _c('span', [_vm._v("手动")]) : _c('span', [_vm._v(_vm._s(_vm.single.lessonDate || '') + " " + _vm._s(_vm.single.beginTime || ''))]), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v(_vm._s(_vm.singleMeta(_vm.single)))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "异动类型"
    }
  }, [_c('Tag', {
    attrs: {
      "color": _vm.typeColor(_vm.single.type)
    }
  }, [_vm._v(_vm._s(_vm.typeText(_vm.single.type)))]), _vm._v(" "), (!_vm.single.manual) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("原因：" + _vm._s(_vm.single.reason || '未填写'))]) : _vm._e()], 1), _vm._v(" "), (_vm.single.handled) ? _c('Form-item', {
    attrs: {
      "label": "原跟进"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.resultText(_vm.single.result)))]), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v(_vm._s(_vm.single.handledBy || '') + " " + _vm._s(_vm.single.handledAt || '') + "（提交后覆盖）")])]) : _vm._e()] : _c('Form-item', {
    attrs: {
      "label": "涉及"
    }
  }, [_c('div', [_vm._v("共 " + _vm._s(_vm.lessons.length) + " 节课 · " + _vm._s(_vm.teacherNames))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.single ? '跟进结果' : '统一结果',
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.result),
      callback: function($$v) {
        _vm.$set(_vm.form, "result", $$v)
      },
      expression: "form.result"
    }
  }, _vm._l((_vm.resultDict), function(item, code) {
    return _c('Option', {
      key: code,
      attrs: {
        "value": code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.single ? '跟进备注' : '统一备注'
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": _vm.single ? '沟通内容、后续措施、是否影响全勤资格等' : '将写入每一条记录'
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.single ? '提交跟进' : '确认批量跟进'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "编辑课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.levelTitle),
      callback: function($$v) {
        _vm.levelTitle = $$v
      },
      expression: "levelTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.lessonTitle),
      callback: function($$v) {
        _vm.lessonTitle = $$v
      },
      expression: "lessonTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('uploader', {
    staticClass: "uploader-example",
    attrs: {
      "options": _vm.options
    },
    on: {
      "file-success": _vm.uploadSucess,
      "files-added": _vm.filesAdd
    }
  }, [_c('uploader-unsupport'), _vm._v(" "), _c('uploader-drop', [_c('p', {
    staticClass: "info"
  }, [_vm._v("上传本地课前预习"), _c('span', [_vm._v("(注意将主页面改为index.html)")])]), _vm._v(" "), _c('uploader-btn', {
    attrs: {
      "directory": true
    }
  }, [_vm._v("选择一个文件夹")])], 1), _vm._v(" "), _c('uploader-list')], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('CommonHeader'), _vm._v(" "), _c('CommonMain')], 1)
},staticRenderFns: []}

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.box), function(item, index) {
    return _c('checkbox', {
      attrs: {
        "true-value": item.id
      },
      on: {
        "on-change": _vm.selectArray
      },
      model: {
        value: (_vm.itemArray[index]),
        callback: function($$v) {
          _vm.$set(_vm.itemArray, index, $$v)
        },
        expression: "itemArray[index]"
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))])])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "CONTRACT",
      "title": "合同管理",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "外教离职",
      "width": "520px",
      "class-name": "resign-modal"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "resign-content"
  }, [_c('div', {
    staticClass: "resign-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle",
      "size": "20",
      "color": "#E6A23C"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('Form', {
    ref: "leaveForm",
    attrs: {
      "label-width": 120,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "离职类型",
      "prop": "resignType",
      "required": ""
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.leaveParam.resignType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "resignType", $$v)
      },
      expression: "leaveParam.resignType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("离职")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("失联")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "最后工作日期",
      "prop": "lastWorkDay"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择最后工作日期"
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "离职理由",
      "prop": "resignReason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 200,
      "placeholder": "请输入离职理由（选填）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.leaveParam.resignReason),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "resignReason", $$v)
      },
      expression: "leaveParam.resignReason"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "议后是否再录用",
      "prop": "rehireFlag"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.leaveParam.rehireFlag),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "rehireFlag", $$v)
      },
      expression: "leaveParam.rehireFlag"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确认离职")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "加减补课次数"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.classHourParam,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "加减补课次数",
      "prop": "num"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.classHourParam.num),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "num", _vm._n($$v))
      },
      expression: "classHourParam.num"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.classHourParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "reason", $$v)
      },
      expression: "classHourParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "全体老师请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeChange
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师考勤")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "tchId",
      "placeholder": "ID/昵称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchKey", $$v)
      },
      expression: "queryParam.tchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "情况说明："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "tchId",
      "placeholder": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startDateSelected),
      callback: function($$v) {
        _vm.startDateSelected = $$v
      },
      expression: "startDateSelected"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endDateSelected),
      callback: function($$v) {
        _vm.endDateSelected = $$v
      },
      expression: "endDateSelected"
    }
  })], 1)], 1)], 1)], 1), _vm._v("\n        >\n      ")], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tch/lesson/attendance-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('ModifyAttendanceScoreModal', {
    attrs: {
      "successCallback": _vm.search,
      "complaintRow": this.complaintRow,
      "visible": _vm.showUpdateScoreModal
    },
    on: {
      "on-close": _vm.closeComplaintModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    staticClass: "adviser-select",
    attrs: {
      "value": _vm.value,
      "size": _vm.size,
      "transfer": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChange
    }
  }, [_c('Option', {
    attrs: {
      "value": "all",
      "label": "全部运营"
    }
  }, [_vm._v("全部运营（" + _vm._s(_vm.totalCount) + " 人）")]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": String(item.id),
        "label": item.nickname || '未分配'
      }
    }, [_vm._v("\n    " + _vm._s(item.nickname || '未分配') + "（" + _vm._s(item.count || 0) + " 人）\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Table', {
    ref: "table",
    attrs: {
      "border": "",
      "height": _vm.height,
      "columns": _vm.innerColumns,
      "data": _vm.tableData,
      "stripe": "",
      "size": "large"
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.page.pageIndex,
      "pageSize": _vm.page.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "课程投诉"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "dataForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "投诉理由：",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  }, _vm._l((_vm.$constant.tchComplaintRemark), function(item) {
    return _c('Option', {
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注说明",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "其他必要投诉内容"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.feedBack
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生单词本")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生ID："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.studentId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studentId", $$v)
      },
      expression: "queryParam.studentId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "姓名："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.username),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "username", $$v)
      },
      expression: "queryParam.username"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "手机号："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "单词："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.word),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "word", $$v)
      },
      expression: "queryParam.word"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/studentWordbook/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("退费学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退费时间："
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.applyDateChange
    },
    model: {
      value: (_vm.applyDateRange),
      callback: function($$v) {
        _vm.applyDateRange = $$v
      },
      expression: "applyDateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID："
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid",
      "placeholder": "不支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名："
    }
  }, [_c('Input', {
    attrs: {
      "name": "stuName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.stuName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stuName", $$v)
      },
      expression: "queryParam.stuName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号："
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('Row', [_c('Col', {
    attrs: {
      "span": 1
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "ios-download"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n              ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "nuclear"
    },
    on: {
      "click": _vm.showInsertRefundModal
    }
  }, [_vm._v("申请退费\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/financial/user/refund/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('ToRefundModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showRefundModal),
      callback: function($$v) {
        _vm.showRefundModal = $$v
      },
      expression: "showRefundModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售成交率")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计周:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.dateRange,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": false,
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.onRangeChange
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部门",
      "clearable": ""
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  }, _vm._l((_vm.$constant.adviserGroup), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.list,
      "loading": _vm.searchLoading,
      "row-class-name": _vm.rowClassName
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("\n    合计：分配 " + _vm._s(_vm.totalAssignCount) + "，成交 " + _vm._s(_vm.totalDealCount) + "，成交率 " + _vm._s(_vm.formatRate(_vm.totalDealRate)) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "加减请假次数"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.classHourParam,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "加减请假次数",
      "prop": "num"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.classHourParam.num),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "num", _vm._n($$v))
      },
      expression: "classHourParam.num"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.classHourParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "reason", $$v)
      },
      expression: "classHourParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("公共资源")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "注册日期:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.regStartTimeDate
    },
    on: {
      "on-change": _vm.regTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.regEndTimeDate
    },
    on: {
      "on-change": _vm.regTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "最后联系:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkStartTimeDate
    },
    on: {
      "on-change": _vm.linkTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkEndTimeDate
    },
    on: {
      "on-change": _vm.linkTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "最近登录:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.lastLoginTimeStart
    },
    on: {
      "on-change": _vm.loginTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.lastLoginTimeEnd
    },
    on: {
      "on-change": _vm.loginTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "接通状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "connectionStatus", $$v)
      },
      expression: "queryParam.connectionStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("未拨打")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("拨打未接")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("拨打接通")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("不论")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "意向等级："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "intentLevel", $$v)
      },
      expression: "queryParam.intentLevel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("意向一般")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无效资源")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("不论")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生:",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学员状态：",
      "label-width": 95
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.stdStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdStatus", $$v)
      },
      expression: "queryParam.stdStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("已预约")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已试听")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("付款未绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("已绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("已开课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("已完课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("退费")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("不论")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Col')], 1), _vm._v(" "), _c('div', {
    staticClass: "move-btn"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("批量移至私库")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.assignTitle,
      "listUrl": "/userinfo/treasuryResource",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('AssignAdviserTreModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "active-name": "1"
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('h3', [_vm._v("管理系统")])]), _vm._v(" "), _c('div', {
    staticClass: "header-msg"
  }, [_c('Message')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-announcement"
  }, [_c('Announcement')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-user"
  }, [(_vm.isLogin) ? _c('Dropdown', {
    attrs: {
      "placement": "bottom-end"
    },
    on: {
      "on-click": _vm.userMenuClick
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.mobile) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', {
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出登录")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/login',
        query: {
          backUrl: this.$route.fullPath
        }
      }
    }
  }, [_vm._v("登录")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试听课预约失败记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": 10
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "失败原因:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.failReason
    },
    on: {
      "on-select-change": _vm.onFailReasonChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "其他/备注"
    },
    model: {
      value: (_vm.formData.otherReason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherReason", $$v)
      },
      expression: "formData.otherReason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.formData.nextTimeDate
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.$constant.handlerType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "listRoot",
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("自动排课配置管理")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminConfig/getTConfigList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "学导id",
      "width": _vm.modalWidth
    },
    model: {
      value: (_vm.showValueModal),
      callback: function($$v) {
        _vm.showValueModal = $$v
      },
      expression: "showValueModal"
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-all",
      "white-space": "pre-wrap",
      "max-height": "360px",
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.fullValue))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showValueModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    staticClass: "modal",
    attrs: {
      "title": "编辑配置信息",
      "width": _vm.modalWidth
    },
    model: {
      value: (_vm.showEditTconfig),
      callback: function($$v) {
        _vm.showEditTconfig = $$v
      },
      expression: "showEditTconfig"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ids：",
      "prop": "configValue"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.configValue),
      callback: function($$v) {
        _vm.$set(_vm.formData, "configValue", $$v)
      },
      expression: "formData.configValue"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.enabledStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "解绑学导"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id + ' - ' + item.nickname) + "\n        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("解绑")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "无试听权限原因历史",
      "width": "700px",
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.logList,
      "loading": _vm.loading,
      "no-data-text": "暂无记录",
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "printBill",
    staticClass: "centerBox2"
  }, [_c('div', [_c('div', {
    ref: "printBill",
    attrs: {
      "id": "contractdiv"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "12pt",
      "color": "black"
    }
  }, [_vm._v("\n              订单编号:"), _c('span', [_vm._v(_vm._s(_vm.orderNum))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "12pt",
      "color": "black"
    }
  }, [_vm._v("\n              购买日期:"), _c('span', [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('table', {
    staticClass: "MsoNormalTable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("学员ID："), _c('span', [_vm._v(_vm._s(_vm.userId))])]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("学员姓名:"), _c('span'), _vm._v(_vm._s(_vm.nickName))]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("学员账号:"), _c('span', [_vm._v(_vm._s(_vm.mobile))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("课程方案：")]), _vm._v(" "), _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.lessonStr))])]), _vm._v(" "), (_vm.discountNum > 0) ? _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("课时赠送：")]), _vm._v(" "), _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.discountNum) + "节外教课")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("配送教材：")]), _vm._v(" "), _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.bookNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("配送地址:")]), _vm._v(" "), _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.address))])]), _vm._v(" "), (_vm.needContract == 1) ? _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("需要合同:")]), _vm._v(" "), (_vm.needContract == 1) ? _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("是")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.needInvoice == 1) ? _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("需要发票:")]), _vm._v(" "), (_vm.needInvoice == 1) ? _c('td', {
    staticClass: "value",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.invoiceDetail))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "MsoNormalTable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [(_vm.discount > 0) ? _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("课程原价：" + _vm._s(_vm.amount) + " 元")]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("现金减免：" + _vm._s(_vm.discount))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("实付金额(小写)：" + _vm._s(_vm.payAmount) + " 元")]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("合计人民币(大写)：" + _vm._s(_vm.payAmountCN))])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "11pt",
      "color": "black"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "11pt",
      "color": "black"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("会计: " + _vm._s(_vm.auditUser))]), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("出纳: 许志成")]), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("开票人: " + _vm._s(_vm.createUser))])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "toolbar not-print"
  }, [_c('div', {
    staticClass: "toolbar_inbox"
  }, [_c('a', {
    staticClass: "toolbtn",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "#",
      "title": "打印本凭据",
      "name": "cont_print"
    },
    on: {
      "click": function($event) {
        return _vm.printWeb()
      }
    }
  }, [_vm._v("打印本凭据")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar_inbox"
  }, [_c('button', {
    staticClass: "toolbtn",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "#",
      "title": "放弃打印",
      "name": "cancel_print"
    },
    on: {
      "click": _vm.cancelPrint
    }
  }, [_vm._v("放弃打印\n                ")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "static/favicon.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "src": "static/favicon.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticStyle: {
      "font-family": "宋体",
      "color": "black"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑"
    }
  }, [_vm._v("HelloKid")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "margin-left": "10px",
      "color": "black"
    }
  }, [_vm._v("课程购买凭据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "name",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("专属服务热线: 0571-8607-0186")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_vm._v("开票单位:杭州凯伯顿科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "11pt",
      "color": "black"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "11pt",
      "color": "black"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "color": "#e60000"
    }
  }, [_c('span', [_vm._v("温馨提示：宝贝开课30天内请务必与课程老师确认教材是否寄送且签收，并确认教材是否正确。开课30天后教材问题不予负责")])])])])
}]}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "上传凭证",
      "width": "800"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "label-position": "left",
      "model": _vm.fundPackageData,
      "rules": _vm.fromRules
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.uid),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "uid", _vm._n($$v))
      },
      expression: "fundPackageData.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "nickname", $$v)
      },
      expression: "fundPackageData.nickname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时赠送",
      "prop": "discountNum"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.discountNum),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "discountNum", _vm._n($$v))
      },
      expression: "fundPackageData.discountNum"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "现金减免",
      "prop": "discount"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.discount),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "discount", $$v)
      },
      expression: "fundPackageData.discount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单原价",
      "prop": "amount"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.amount),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "amount", $$v)
      },
      expression: "fundPackageData.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "实付金额",
      "prop": "payAmount"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.fundPackageData.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "payAmount", $$v)
      },
      expression: "fundPackageData.payAmount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "支付方式",
      "prop": "payWay"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.fundPackageData.payWay),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "payWay", _vm._n($$v))
      },
      expression: "fundPackageData.payWay"
    }
  }, _vm._l((_vm.payWayList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "支付时间",
      "prop": "payTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp",
      "picker-options": _vm.payTimePickerOptions
    },
    on: {
      "change": _vm.changPayTime
    },
    model: {
      value: (_vm.payTime),
      callback: function($$v) {
        _vm.payTime = _vm._n($$v)
      },
      expression: "payTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showDealMonth) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "成交月份",
      "prop": "dealMonth"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择成交月份",
      "transfer": ""
    },
    model: {
      value: (_vm.fundPackageData.dealMonth),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "dealMonth", $$v)
      },
      expression: "fundPackageData.dealMonth"
    }
  }, _vm._l((_vm.dealMonthOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 15
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 200,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.fundPackageData.url),
      callback: function($$v) {
        _vm.$set(_vm.fundPackageData, "url", $$v)
      },
      expression: "fundPackageData.url"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("日常辅助")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("操作日志")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetimerange",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/昵称",
      "name": "adminKey"
    },
    model: {
      value: (_vm.queryParam.adminKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminKey", $$v)
      },
      expression: "queryParam.adminKey"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "入口"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "访问入口",
      "name": "action"
    },
    model: {
      value: (_vm.queryParam.action),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "action", $$v)
      },
      expression: "queryParam.action"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "路径"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "接口地址",
      "name": "uri"
    },
    model: {
      value: (_vm.queryParam.uri),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uri", $$v)
      },
      expression: "queryParam.uri"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ip"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ip地址",
      "name": "ip"
    },
    model: {
      value: (_vm.queryParam.ip),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ip", $$v)
      },
      expression: "queryParam.ip"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请求参数"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "params"
    },
    model: {
      value: (_vm.queryParam.params),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "params", $$v)
      },
      expression: "queryParam.params"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "平台"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.sysFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sysFrom", $$v)
      },
      expression: "queryParam.sysFrom"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("管理后台")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("学生中心")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activity/log/query",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加老师"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "tchForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.tchParam,
      "rules": _vm.ruleTch
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名字",
      "prop": "firstName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.firstName),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "firstName", $$v)
      },
      expression: "tchParam.firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓氏",
      "prop": "lastName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.lastName),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "lastName", $$v)
      },
      expression: "tchParam.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " 区号/地域 ",
      "prop": "areaNum"
    }
  }, [_c('phone-area-select', {
    on: {
      "on-change": _vm.onAreaNumChange
    },
    model: {
      value: (_vm.tchParam.areaNum),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "areaNum", $$v)
      },
      expression: "tchParam.areaNum"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机",
      "prop": "account"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.account),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "account", $$v)
      },
      expression: "tchParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.tchParam.password),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "password", $$v)
      },
      expression: "tchParam.password"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国家",
      "prop": "country"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.country),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "country", $$v)
      },
      expression: "tchParam.country"
    }
  }, _vm._l((_vm.countryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.cn))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "sex", _vm._n($$v))
      },
      expression: "tchParam.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级",
      "prop": "star"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.star),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "star", $$v)
      },
      expression: "tchParam.star"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课权限",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.type),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "type", _vm._n($$v))
      },
      expression: "tchParam.type"
    }
  }, _vm._l((_vm.$constant.teacherType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.tchParam.status),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "status", _vm._n($$v))
      },
      expression: "tchParam.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "category"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.category),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "category", _vm._n($$v))
      },
      expression: "tchParam.category"
    }
  }, _vm._l((_vm.$constant.teacherCategory.filter(function(c) {
    return c.code !== 6
  })), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "tchType", _vm._n($$v))
      },
      expression: "tchParam.tchType"
    }
  }, _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否有试听课权限",
      "prop": "isAudition"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.tchParam.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "isAudition", $$v)
      },
      expression: "tchParam.isAudition"
    }
  }, _vm._l((_vm.$constant.yn), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时薪",
      "prop": "salary"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.tchParam.salary),
      callback: function($$v) {
        _vm.$set(_vm.tchParam, "salary", _vm._n($$v))
      },
      expression: "tchParam.salary"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertTch
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("添加")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list foreign-manage-data-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外管数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "时间范围"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外管"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教来源"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", $$v)
      },
      expression: "queryParam.channel"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("欧美")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("菲教")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.channelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.channelParam
      }
    }, [_vm._v(_vm._s(item.id + '-' + item.channelName + ' - ' + _vm.$constant.getEnum(_vm.$constant.tchChannel, item.tchChannel).text) + "\n  ")])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("注册渠道管理")])], 1)], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "animated": false
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "渠道",
      "name": "channel"
    }
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道参数"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确匹配"
    },
    model: {
      value: (_vm.queryParam.param),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "param", $$v)
      },
      expression: "queryParam.param"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "中介",
      "name": "agency"
    }
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchAgency.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.id),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "id", $$v)
      },
      expression: "agencyQuery.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.name),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "name", $$v)
      },
      expression: "agencyQuery.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "账号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.account),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "account", $$v)
      },
      expression: "agencyQuery.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.status),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "status", $$v)
      },
      expression: "agencyQuery.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.agencySearchLoading
    },
    on: {
      "click": _vm.searchAgency
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAgencyAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.agencyColumns,
      "data": _vm.agencyList,
      "loading": _vm.agencyTableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.agencyTotal,
      "current": _vm.agencyQuery.pageIndex,
      "page-size": _vm.agencyQuery.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onAgencyPageChange,
      "on-page-size-change": _vm.onAgencyPageSizeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑渠道' : '新增渠道'
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "channelForm",
    attrs: {
      "label-width": 90,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道名称",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "渠道参数",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.formData.param === '转介绍' && !!_vm.formData.id
    },
    model: {
      value: (_vm.formData.param),
      callback: function($$v) {
        _vm.$set(_vm.formData, "param", $$v)
      },
      expression: "formData.param"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), (_vm.showTchInfoModal) ? _c('tch-info-modal', {
    key: 'agency-modal-' + (_vm.agencyTchId || 'new'),
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.agencyTchId,
      "addType": _vm.agencyAddType,
      "successCallback": _vm.onAgencySaved
    },
    on: {
      "on-close": _vm.onAgencyModalClose
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "学生异动影响",
      "tags": ['被波及 → 换老师 → 保时 / 改时 → 留存'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.typeOptions,
      "label": "异动类型"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.newOptions
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.newOnly),
      callback: function($$v) {
        _vm.newOnly = $$v
      },
      expression: "newOnly"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 窗口：生效日在近 " + _vm._s(_vm.days) + " 天（含今天）· 学生按最早一起事件归因")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("每个学生都在这条链上：被波及 → 换老师 → 保住或改掉原时段 → 留存或流失。看学生卡在哪一步。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g21"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生状态链路"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("近 " + _vm._s(_vm.days) + " 天 · " + _vm._s(_vm.fmtNum(_vm.d.studentCount)) + " 名学生")])])]), _vm._v(" "), _vm._l((_vm.chainRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "funnel-row"
    }, [_c('div', {
      staticClass: "funnel-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-track"
    }, [_c('div', {
      staticClass: "funnel-fill",
      style: ({
        width: row.width + '%',
        background: row.color
      })
    }, [_vm._v(_vm._s(_vm.fmtNum(row.value)))])]), _vm._v(" "), _c('div', {
      staticClass: "funnel-rate"
    }, [_vm._v(_vm._s(row.rate))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          盯两个缺口："), _c('b', [_vm._v("「待换老师」是运营的待办清单")]), _vm._v("（当前 " + _vm._s(_vm.fmtNum(_vm.d.waitingCount)) + " 人，超 7 天 " + _vm._s(_vm.fmtNum(_vm.d.waitingOver7Count)) + " 人），「改时间」是下一阶段流失的种子（" + _vm._s(_vm.fmtNum(_vm.d.changeSlotCount)) + " 人）。\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.depthRows,
      "unit": "人"
    }
  }), _vm._v(" "), (_vm.depthInsight) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v(_vm._s(_vm.depthInsight))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师的两种结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.switchedCount)) + " 名已换完学生 · 按是否保住原时段拆分")])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-boxes"
  }, [_c('div', {
    staticClass: "compare-box"
  }, [_c('div', {
    staticClass: "compare-box-title is-healthy"
  }, [_vm._v("保时换老师")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.keepSlotCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v("原时段不变 · 占已换 " + _vm._s(_vm.fmtRate(_vm.d.keepSlotRate)) + " · 30 天留存 "), _c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.keepRetain30Rate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box is-danger"
  }, [_c('div', {
    staticClass: "compare-box-title is-danger"
  }, [_vm._v("换老师 + 被迫改时间")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.changeSlotCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v("时段也变了 · 占已换 " + _vm._s(_vm.fmtRate(_vm.d.changeSlotRate)) + " · 30 天留存 "), _c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.changeRetain30Rate)))])])])]), _vm._v(" "), (_vm.retainGap != null) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v("\n          同样是换老师，保时和改时的 30 天留存相差 "), _c('b', [_vm._v(_vm._s(_vm.retainGap) + "pp")]), _vm._v("。真正伤人的往往不是换老师本身，而是「换人 + 作息也变了」。\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.keepRows,
      "unit": "",
      "right-width": 130
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("保时换老师 30 天留存")]), _c('dd', {
    staticClass: "t-healthy"
  }, [_vm._v(_vm._s(_vm.fmtRate(_vm.d.keepRetain30Rate)))]), _vm._v(" "), _c('dt', [_vm._v("改时换老师 30 天留存")]), _c('dd', {
    staticClass: "t-danger"
  }, [_vm._v(_vm._s(_vm.fmtRate(_vm.d.changeRetain30Rate)))]), _vm._v(" "), _c('dt', [_vm._v("留存差值")]), _c('dd', [_vm._v(_vm._s(_vm.retainGap == null ? '—' : _vm.retainGap + 'pp'))])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("关闭时间关掉的正是学生原来上课的时段，要保时只能找同档期的其他老师，保时率天然更难。")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("受影响学生清单")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v(_vm._s(_vm.listSub))])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "section-filters list-filters"
  }, [_c('span', {
    staticClass: "filter-group teacher-filter"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("原老师")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tchId),
      callback: function($$v) {
        _vm.tchId = $$v
      },
      expression: "tchId"
    }
  }, _vm._l((_vm.teachers), function(t) {
    return _c('Option', {
      key: t.id,
      attrs: {
        "value": t.id
      }
    }, [_vm._v(_vm._s(t.name || t.id))])
  }), 1)], 1), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.switchOptions,
      "label": "换老师状态"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.switchStatus),
      callback: function($$v) {
        _vm.switchStatus = $$v
      },
      expression: "switchStatus"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 原老师 / 换老师状态只过滤下方名单与导出，上方指标不变")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid + '-' + row.tchId + '-' + row.effectiveDate,
      class: {
        'is-priority': row.newPriority
      }
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("新生优先")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(_vm._s(_vm.isNum(row.tenureDays) ? '开课第 ' + row.tenureDays + ' 天' : '—'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || row.tchId))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.effectiveDate || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.origSlot || '—'))]), _vm._v(" "), _c('td', [(row.switchStatus === 'waiting') ? _c('span', {
      staticClass: "badge is-warning"
    }, [_vm._v("待换老师")]) : [_c('span', {
      staticClass: "badge is-healthy"
    }, [_vm._v("已换完")]), _vm._v(" "), (row.keepSlot === true) ? _c('span', {
      staticClass: "badge is-healthy"
    }, [_vm._v("保时")]) : (row.keepSlot === false) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("改时间")]) : _vm._e()]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.newTchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.isNum(row.switchDays) ? row.switchDays + ' 天' : '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 4
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.level)
    }, [_vm._v(_vm._s(row.level || '—'))]), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(" " + _vm._s(_vm.fmtNum(row.score)))])])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("当前筛选下没有受影响学生")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.regapRows,
      "unit": "人"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_vm._l((_vm.byType), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.switched)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtRate(row.switched7dRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.isNum(row.keepSlotRate) && row.keepSlotRate < 70
      }
    }, [_vm._v(_vm._s(_vm.fmtRate(row.keepSlotRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.avgLost)))])])
  }), _vm._v(" "), (!_vm.byType.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v("人均损失课次高的类型，说明学生在换老师之前就已经断课了。这类学生换完老师要加一轮主动沟通和首课质检。")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("学生走到哪一步")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("损失课次分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("按学生 · 生效后 14 天应上未上")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          排课侧建议："), _c('b', [_vm._v("先锁时段，再配老师")]), _vm._v("。宁可多等两天找一个能上原时段的老师，也别急着塞一个时段错位的。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("各类型保时率"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("换老师后仍在原时段（±30 分钟）的比例")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生清单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("前 50 名 · 导出为全部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("新生状态")]), _vm._v(" "), _c('th', [_vm._v("原老师")]), _vm._v(" "), _c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', [_vm._v("生效日")]), _vm._v(" "), _c('th', [_vm._v("原时段")]), _vm._v(" "), _c('th', [_vm._v("换老师状态")]), _vm._v(" "), _c('th', [_vm._v("新老师")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("迁移天数")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', [_vm._v("风险")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师时长分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("已换完学生 · 生效日到首次已选新老师课")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("异动类型 × 学生结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("学生经历了什么，而不是老师发生了什么")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("已换完")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("7 天换完率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("保时率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("人均损失课次")])])])
}]}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("被推荐人管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search search-compact",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 78,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "被推荐人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/姓名，支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.recommendedKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recommendedKeyword", $$v)
      },
      expression: "queryParam.recommendedKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "推荐官"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/姓名，支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.referrerKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "referrerKeyword", $$v)
      },
      expression: "queryParam.referrerKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "推荐官FM"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.fmId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fmId", _vm._n($$v))
      },
      expression: "queryParam.fmId"
    }
  }, _vm._l((_vm.fmList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "开课月份"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月份",
      "format": "yyyy-MM",
      "clearable": ""
    },
    on: {
      "on-change": _vm.openClassMonthChange
    },
    model: {
      value: (_vm.queryParam.openClassMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "openClassMonth", $$v)
      },
      expression: "queryParam.openClassMonth"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "上课年月"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月份",
      "format": "yyyy-MM",
      "clearable": ""
    },
    on: {
      "on-change": _vm.monthChange
    },
    model: {
      value: (_vm.queryParam.month),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "month", $$v)
      },
      expression: "queryParam.month"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "发放状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.grantStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "grantStatus", $$v)
      },
      expression: "queryParam.grantStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已发放")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "是否奖励期"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isInRewardPeriod),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isInRewardPeriod", _vm._n($$v))
      },
      expression: "queryParam.isInRewardPeriod"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download-outline"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "checkmark"
    },
    on: {
      "click": _vm.handleBatchGrant
    }
  }, [_vm._v("批量发放")])], 1)], 1), _vm._v(" "), _c('Table', {
    ref: "table",
    attrs: {
      "columns": _vm.title,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": "",
      "size": "large"
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fee-summary"
  }, [_vm._v("\n    课时汇总：" + _vm._s(_vm.summaryLesson) + "　金额汇总：$" + _vm._s(_vm.summaryAmount) + "\n  ")]), _vm._v(" "), _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.totalCount,
      "show-elevator": "",
      "current": _vm.pageIndex,
      "pageSize": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "拒绝结算"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "fundForm",
    staticClass: "form",
    attrs: {
      "model": _vm.fundParam,
      "rules": _vm.fundRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拒绝理由",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.fundParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.fundParam, "reason", $$v)
      },
      expression: "fundParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBalance
    },
    on: {
      "click": _vm.balance
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.activityList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.id + ' - ' + item.name))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("配置管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.addParent
    }
  }, [_vm._v("新增父级类目")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.parentColumn,
      "data": _vm.parentData,
      "loading": _vm.searchLoading
    }
  })], 1), _vm._v(" "), _c('EditItemModal', {
    attrs: {
      "itemId": _vm.itemId,
      "pid": _vm.pid
    },
    on: {
      "on-close": function($event) {
        _vm.editModal = false
      },
      "on-edilllt-success": _vm.editSuccess,
      "on-edit-clearid": _vm.clearid
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生请假详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6,
      "offset": 1
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookUserLeaveTime/listTotalLeaveNum",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "980",
      "title": "涉及请假课程"
    },
    model: {
      value: (_vm.showBookLessonOpenedModal),
      callback: function($$v) {
        _vm.showBookLessonOpenedModal = $$v
      },
      expression: "showBookLessonOpenedModal"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-share"
  }, [_c('div', {
    staticClass: "disk-share-box"
  }, [_c('div', {
    staticClass: "disk-share-header"
  }, [_c('Icon', {
    attrs: {
      "type": "folder"
    }
  }), _vm._v("\n      网盘分享\n    ")], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "disk-share-tip"
  }, [_vm._v("加载中...")]) : (_vm.invalid) ? _c('div', {
    staticClass: "disk-share-tip"
  }, [_vm._v(_vm._s(_vm.invalidMsg))]) : (_vm.needCode) ? _c('div', {
    staticClass: "disk-share-code"
  }, [_c('p', [_vm._v("该分享需要提取码")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请输入提取码",
      "maxlength": 8
    },
    on: {
      "on-enter": _vm.openShare
    },
    model: {
      value: (_vm.extractCode),
      callback: function($$v) {
        _vm.extractCode = $$v
      },
      expression: "extractCode"
    }
  }), _vm._v(" "), (_vm.codeError) ? _c('p', {
    staticClass: "disk-share-error"
  }, [_vm._v(_vm._s(_vm.codeError))]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.opening
    },
    on: {
      "click": _vm.openShare
    }
  }, [_vm._v("确定")])], 1) : (_vm.opened) ? _c('div', [_c('div', {
    staticClass: "disk-share-name"
  }, [_c('Icon', {
    attrs: {
      "type": _vm.share.nodeType === 2 ? 'document-text' : 'folder'
    }
  }), _vm._v("\n        " + _vm._s(_vm.share.name) + "\n      ")], 1), _vm._v(" "), (_vm.share.nodeType === 2) ? _c('div', {
    staticClass: "disk-share-file"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatSize(_vm.share.size)))]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.preview(_vm.share.id, _vm.share)
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.share.id)
      }
    }
  }, [_vm._v("下载")])], 1) : _c('div', [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.share.children || []
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": '预览 - ' + _vm.previewName,
      "width": "960"
    },
    on: {
      "on-visible-change": _vm.onPreviewVisible
    },
    model: {
      value: (_vm.showPreviewModal),
      callback: function($$v) {
        _vm.showPreviewModal = $$v
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "disk-preview",
    class: {
      'disk-preview-center': _vm.centerPreview
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("加载中...")]) : (_vm.previewError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v(_vm._s(_vm.previewError))]) : (_vm.previewType === 'image') ? _c('img', {
    staticClass: "disk-preview-image",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : (_vm.previewType === 'pdf') ? _c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.previewBlobUrl
    }
  }) : (_vm.previewType === 'video') ? [_c('video', {
    ref: "previewVideo",
    staticClass: "disk-preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'audio') ? [_c('audio', {
    ref: "previewAudio",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'office' && _vm.previewEngine === 'aliyun') ? [_c('div', {
    ref: "aliyunOffice",
    staticClass: "disk-preview-frame"
  })] : (_vm.previewType === 'office') ? [_c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.officeUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("若无法打开，请下载后查看")])] : (_vm.previewType === 'csv') ? [(_vm.previewEmpty) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("没有可预览的内容")]) : _c('div', {
    staticClass: "disk-preview-table-wrap"
  }, [_c('table', {
    staticClass: "disk-preview-table"
  }, [_c('tbody', _vm._l((_vm.previewRows), function(line, lineIndex) {
    return _c('tr', {
      key: lineIndex
    }, _vm._l((line), function(cell, cellIndex) {
      return _c('td', {
        key: cellIndex,
        class: {
          'disk-preview-th': lineIndex === 0
        }
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])])] : (_vm.previewType === 'markdown') ? _c('div', {
    staticClass: "disk-preview-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.previewHtml)
    }
  }) : (_vm.previewType === 'json') ? [(_vm.jsonError) ? _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("不是合法 JSON")]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))])] : (_vm.previewType === 'text') ? _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))]) : _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.previewDownloadId)
      }
    }
  }, [_vm._v("下载")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("推荐老师记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "推荐人ID："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "inviteId",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteId", $$v)
      },
      expression: "queryParam.inviteId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师账号："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师昵称："
    }
  }, [_c('el-input', {
    attrs: {
      "name": "nickname",
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tch/recommend/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "老师课程请假"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "dataForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.formData.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveType", $$v)
      },
      expression: "formData.leaveType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规请假Standard leave")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("临时请假 Emergency leave")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("老师失联NCNS")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("取消课Cancellation")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px",
      "width": "400px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._v("请假课程：" + _vm._s(_vm.formData.beginTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formData.title))])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.onTchLeave
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("日常辅助")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("消息模板")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "模板名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "params"
    },
    model: {
      value: (_vm.queryParam.params),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "params", $$v)
      },
      expression: "queryParam.params"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.showAddModal
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activity/message-template",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增消息模板",
      "mask-closable": false,
      "width": 600
    },
    on: {
      "on-ok": _vm.handleAddConfirm,
      "on-cancel": function($event) {
        _vm.addModalVisible = false
      }
    },
    model: {
      value: (_vm.addModalVisible),
      callback: function($$v) {
        _vm.addModalVisible = $$v
      },
      expression: "addModalVisible"
    }
  }, [_c('Form', {
    ref: "addTemplateForm",
    attrs: {
      "model": _vm.newTemplate,
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "模板名称:",
      "prop": "templateName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.newTemplate.templateName),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "templateName", $$v)
      },
      expression: "newTemplate.templateName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "标题:",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.newTemplate.title),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "title", $$v)
      },
      expression: "newTemplate.title"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "模板内容:",
      "prop": "sendContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板内容"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.newTemplate.sendContent),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "sendContent", $$v)
      },
      expression: "newTemplate.sendContent"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "消息类型:",
      "prop": "msgType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择消息类型"
    },
    model: {
      value: (_vm.newTemplate.msgType),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "msgType", $$v)
      },
      expression: "newTemplate.msgType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "DING"
    }
  }, [_vm._v("钉钉消息")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SMS"
    }
  }, [_vm._v("短信")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "EMAIL"
    }
  }, [_vm._v("邮件")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CALL"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PUSH"
    }
  }, [_vm._v("推送")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "COMMON_WEB_HOOK"
    }
  }, [_vm._v("通用webhook")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "接收人:",
      "prop": "sendTo"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择接收人"
    },
    model: {
      value: (_vm.newTemplate.sendTo),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "sendTo", $$v)
      },
      expression: "newTemplate.sendTo"
    }
  }, [_c('Option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("无身份")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TCH"
    }
  }, [_vm._v("老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "STUDENT"
    }
  }, [_vm._v("学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ADMIN"
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "WEB_HOOK"
    }
  }, [_vm._v("群机器人通知")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "AppId:",
      "prop": "dingAppId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入AppId"
    },
    model: {
      value: (_vm.newTemplate.dingAppId),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "dingAppId", $$v)
      },
      expression: "newTemplate.dingAppId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Secret:",
      "prop": "dingSecret"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入Secret"
    },
    model: {
      value: (_vm.newTemplate.dingSecret),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "dingSecret", $$v)
      },
      expression: "newTemplate.dingSecret"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "WebHook:",
      "prop": "hookUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入WebHook地址"
    },
    model: {
      value: (_vm.newTemplate.hookUrl),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "hookUrl", $$v)
      },
      expression: "newTemplate.hookUrl"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态:",
      "prop": "enabled"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.newTemplate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "enabled", $$v)
      },
      expression: "newTemplate.enabled"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("正常")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("禁用")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("后端学导数据")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-position": "left",
      "label-width": 70
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32,
      "index": "1"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [(_vm.queryParam.dayOfMonth == 0) ? _c('FormItem', {
    attrs: {
      "label": "选择日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placement": "bottom-start",
      "format": "yyyy-MM-dd",
      "type": _vm.type,
      "value": _vm.defaultDate,
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.getTimeDateChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.queryParam.dayOfMonth == 1) ? _c('FormItem', {
    attrs: {
      "label": "选择月:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": _vm.type,
      "placeholder": "选择月"
    },
    on: {
      "on-change": _vm.getTimeMonthChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "查看方式:"
    }
  }, [_c('Radio-group', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.dayOfMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "dayOfMonth", $$v)
      },
      expression: "queryParam.dayOfMonth"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("按日查看")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("按月查看")])], 1)], 1)], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n      ")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.table,
      "listUrl": "/data/report/querystudyadviserdata",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "规则"
    },
    model: {
      value: (_vm.tableRulePrompt),
      callback: function($$v) {
        _vm.tableRulePrompt = $$v
      },
      expression: "tableRulePrompt"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tableRulePromptContent) + "\n        "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.onLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "kb-fab",
    style: (_vm.fabStyle),
    on: {
      "mousedown": _vm.onFabDown,
      "click": _vm.onFabClick
    }
  }, [_vm._v("知识")]), _vm._v(" "), (_vm.open && _vm.maximized) ? _c('div', {
    staticClass: "kb-mask",
    on: {
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onMaskDown.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "kb-panel",
    style: (_vm.panelStyle),
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kb-head",
    on: {
      "mousedown": _vm.onWinDragDown
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "kb-actions",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearChat.apply(null, arguments)
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleMaximize.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.maximized ? '缩小' : '放大'))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePanel.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('div', {
    ref: "msgs",
    staticClass: "kb-msgs"
  }, [(!_vm.messages.length) ? _c('div', {
    staticClass: "kb-empty"
  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(m, idx) {
    return _c('div', {
      key: idx,
      staticClass: "kb-bubble",
      class: m.role
    }, [_c('div', [_vm._v(_vm._s(m.text))]), _vm._v(" "), (m.sources && m.sources.length) ? _c('div', {
      staticClass: "kb-sources"
    }, [_vm._v("\n          来源：\n          "), _vm._l((m.sources), function(s, i) {
      return _c('span', {
        key: i
      }, [_vm._v(_vm._s(s.kbName || s.title) + _vm._s(i < m.sources.length - 1 ? '、' : ''))])
    })], 2) : _vm._e()])
  }), _vm._v(" "), (_vm.sending) ? _c('div', {
    staticClass: "kb-empty"
  }, [_vm._v(_vm._s(_vm.hasBind ? '正在检索知识库…' : '思考中…'))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kb-foot"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft),
      expression: "draft"
    }],
    attrs: {
      "maxlength": "1000",
      "placeholder": "输入问题，Enter 发送（Shift+Enter 换行）"
    },
    domProps: {
      "value": (_vm.draft)
    },
    on: {
      "keydown": _vm.onKey,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.draft = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#64748b"
    }
  }, [_vm._v(_vm._s(_vm.providerHint))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.sending
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送")])], 1)]), _vm._v(" "), _vm._l((_vm.resizeDirs), function(dir) {
    return _c('div', {
      key: dir,
      staticClass: "kb-resize",
      class: dir,
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onResizeDown(dir, $event)
        }
      }
    })
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("知识助手")])])
}]}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.count
    }
  }, [_c('a', {
    on: {
      "click": _vm.showEmailNews
    }
  }, [_c('Icon', {
    attrs: {
      "type": "email",
      "size": "50",
      "color": "#e3e8ee"
    }
  })], 1)]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateUserAllMessageNeedAlertStatus()
      }
    }
  }, [_vm._v("一键关闭弹窗提醒")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "SAFETY",
      "title": "用工安全",
      "group-name": "员工管理"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    ref: "timeZone",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": _vm.placeNum,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('Option', {
      key: item.num,
      attrs: {
        "value": item.num
      }
    }, [_vm._v("\n          " + _vm._s(item.name.word + '----------------时差：' + item.num) + "\n  ")])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list recruit-train-stat-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("招聘培训统计")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "stat-toolbar"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.dateRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.searchLoading,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hr-label"
  }, [_vm._v("统计模板")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "transfer": "",
      "disabled": _vm.searchLoading
    },
    on: {
      "on-change": _vm.onStatTemplateChange
    },
    model: {
      value: (_vm.statTemplate),
      callback: function($$v) {
        _vm.statTemplate = $$v
      },
      expression: "statTemplate"
    }
  }, [_c('Option', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "agency"
    }
  }, [_vm._v("按中介")])], 1), _vm._v(" "), _c('span', {
    staticClass: "hr-label"
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": "",
      "disabled": _vm.searchLoading
    },
    on: {
      "on-change": _vm.onHrChange
    },
    model: {
      value: (_vm.hr),
      callback: function($$v) {
        _vm.hr = $$v
      },
      expression: "hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "stat-formula"
  }, [_vm._v("注册人数 = 待审核 + 已审核 + 培训中 + 培训淘汰 + 培训流失 + 在职人数 + 离职人数 + 已禁用")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.summaryColumns,
      "data": _vm.summaryData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("按注册渠道")]), _vm._v(" "), _c('Table', {
    ref: "channelTable",
    attrs: {
      "height": _vm.channelTableHeight,
      "columns": _vm.channelColumns,
      "data": _vm.channelTableData,
      "loading": _vm.tableLoading,
      "row-class-name": _vm.channelRowClassName,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.detailTitle,
      "width": "800"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailData,
      "loading": _vm.detailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.detailTotal,
      "current": _vm.detailPageIndex,
      "page-size": _vm.detailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onDetailPageChange,
      "on-page-size-change": _vm.onDetailPageSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外教异动风险监测")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确匹配"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外管"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "风险等级"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.level),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "level", $$v)
      },
      expression: "queryParam.level"
    }
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "只看异动"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.queryParam.onlyAnomaly),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "onlyAnomaly", $$v)
      },
      expression: "queryParam.onlyAnomaly"
    }
  }, [_vm._v("风险分≥异动线")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师分类"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", $$v)
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计窗口"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onStatMonthChange
    },
    model: {
      value: (_vm.monthDate),
      callback: function($$v) {
        _vm.monthDate = $$v
      },
      expression: "monthDate"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "lg": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全周期"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onWindowChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openRuleModal
    }
  }, [_vm._v("规则设置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "level-bar"
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('span', {
      key: item,
      staticClass: "level-item",
      class: {
        'level-item-active': _vm.queryParam.level === item
      },
      on: {
        "click": function($event) {
          return _vm.filterByLevel(item)
        }
      }
    }, [_c('span', {
      staticClass: "level-dot",
      style: ({
        background: _vm.levelColor(item)
      })
    }), _vm._v("\n      " + _vm._s(item) + "："), _c('b', [_vm._v(_vm._s(_vm.levelCounts[item] || 0))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "异动风险规则设置",
      "width": "1100",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.showRuleModal),
      callback: function($$v) {
        _vm.showRuleModal = $$v
      },
      expression: "showRuleModal"
    }
  }, [(_vm.ruleLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ruleConfig) ? _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "回溯月数"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 6,
      "max": 36,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.lookbackMonths),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "lookbackMonths", $$v)
      },
      expression: "ruleConfig.lookbackMonths"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "升级单条权重"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "max": 20,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.upgradeWeight),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "upgradeWeight", $$v)
      },
      expression: "ruleConfig.upgradeWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "异动线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.anomalyScore),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "anomalyScore", $$v)
      },
      expression: "ruleConfig.anomalyScore"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "高危 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.high),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "high", $$v)
      },
      expression: "ruleConfig.high"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "中危 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.medium),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "medium", $$v)
      },
      expression: "ruleConfig.medium"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "观察 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.watch),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "watch", $$v)
      },
      expression: "ruleConfig.watch"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "提示 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.hint),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "hint", $$v)
      },
      expression: "ruleConfig.hint"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-table-wrap"
  }, [_c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("编号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("分组")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("规则")]), _vm._v(" "), _c('th', [_vm._v("判定说明")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "230px"
    }
  }, [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("权重")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "90px"
    }
  }, [_vm._v("互斥组")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("启用")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ruleConfig.rules), function(rule) {
    return _c('tr', {
      key: rule.code,
      class: {
        'rule-disabled': !rule.enabled
      }
    }, [_c('td', [_vm._v(_vm._s(rule.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.groupName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.name))]), _vm._v(" "), _c('td', {
      staticClass: "rule-desc"
    }, [_vm._v(_vm._s(rule.desc))]), _vm._v(" "), _c('td', [(!rule.params || !rule.params.length) ? _c('span', {
      staticClass: "rule-muted"
    }, [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((rule.params), function(p) {
      return _c('div', {
        key: p.key,
        staticClass: "rule-param"
      }, [_c('span', {
        staticClass: "rule-param-label"
      }, [_vm._v(_vm._s(p.label))]), _vm._v(" "), _c('InputNumber', {
        staticStyle: {
          "width": "80px"
        },
        attrs: {
          "min": 0,
          "step": _vm.paramStep(p),
          "size": "small"
        },
        model: {
          value: (p.value),
          callback: function($$v) {
            _vm.$set(p, "value", $$v)
          },
          expression: "p.value"
        }
      })], 1)
    })], 2), _vm._v(" "), _c('td', [_c('InputNumber', {
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "min": 0,
        "max": 20,
        "step": 1,
        "size": "small"
      },
      model: {
        value: (rule.weight),
        callback: function($$v) {
          _vm.$set(rule, "weight", $$v)
        },
        expression: "rule.weight"
      }
    })], 1), _vm._v(" "), _c('td', [_c('Input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (rule.mutexGroup),
        callback: function($$v) {
          _vm.$set(rule, "mutexGroup", $$v)
        },
        expression: "rule.mutexGroup"
      }
    })], 1), _vm._v(" "), _c('td', [_c('i-switch', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (rule.enabled),
        callback: function($$v) {
          _vm.$set(rule, "enabled", $$v)
        },
        expression: "rule.enabled"
      }
    })], 1)])
  }), 0)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showRuleModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.ruleResetLoading
    },
    on: {
      "click": _vm.resetRules
    }
  }, [_vm._v("恢复默认")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ruleSaveLoading,
      "disabled": !_vm.ruleConfig
    },
    on: {
      "click": _vm.saveRules
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.leaveDetailTitle,
      "width": "960",
      "transfer": ""
    },
    model: {
      value: (_vm.showLeaveDetailModal),
      callback: function($$v) {
        _vm.showLeaveDetailModal = $$v
      },
      expression: "showLeaveDetailModal"
    }
  }, [(_vm.leaveDetail) ? _c('div', {
    staticClass: "detail-summary"
  }, [_vm._v("\n      区间：" + _vm._s(_vm.leaveDetail.windowStart || '—') + " ~ " + _vm._s(_vm.leaveDetail.windowEnd || '—') + "\n      "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.leaveDetailValueText))])]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.leaveColumns,
      "data": _vm.leaveDetailLeaves,
      "loading": _vm.leaveDetailLoading,
      "size": "small",
      "stripe": ""
    }
  }), _vm._v(" "), (_vm.leaveDetailMetric === 'singleMax') ? _c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "detail-sub-title"
  }, [_vm._v("受影响课节")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.lessonColumns,
      "data": _vm.leaveDetailLessons,
      "loading": _vm.leaveDetailLoading,
      "size": "small",
      "stripe": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showLeaveDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("渠道管理")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.queryParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "channelName", $$v)
      },
      expression: "queryParams.channelName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "获客终端"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "channelType", $$v)
      },
      expression: "queryParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "type", $$v)
      },
      expression: "queryParams.type"
    }
  }, _vm._l((this.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "市场分类"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.marketCategory),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "marketCategory", $$v)
      },
      expression: "queryParams.marketCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": "__NONE__"
    }
  }, [_vm._v("未分类")]), _vm._v(" "), _vm._l((_vm.marketCategoryNames), function(name) {
    return _c('Option', {
      key: name,
      attrs: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  })], 2)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "来源"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "tchChannel", $$v)
      },
      expression: "queryParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            搜索\n          ")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toshowAddChannelModal
    }
  }, [_vm._v("\n          新建市场渠道\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "channelList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/channel/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('CreateChannelModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddChannelModal),
      callback: function($$v) {
        _vm.showAddChannelModal = $$v
      },
      expression: "showAddChannelModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑渠道"
    },
    model: {
      value: (_vm.showUpdateChannelModal),
      callback: function($$v) {
        _vm.showUpdateChannelModal = $$v
      },
      expression: "showUpdateChannelModal"
    }
  }, [_c('Form', {
    ref: "updateChannelForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.channelRules,
      "model": _vm.updateChannelParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道名称：",
      "prop": "channelName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.updateChannelParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelName", $$v)
      },
      expression: "updateChannelParams.channelName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道分类：",
      "prop": "channelType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateChannelParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelType", $$v)
      },
      expression: "updateChannelParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道参数：",
      "prop": "channelParam"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道参数"
    },
    model: {
      value: (_vm.updateChannelParams.channelParam),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelParam", $$v)
      },
      expression: "updateChannelParams.channelParam"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateChannelParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "status", $$v)
      },
      expression: "updateChannelParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updateChannelParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "tchChannel", $$v)
      },
      expression: "updateChannelParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道描述："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入渠道描述"
    },
    model: {
      value: (_vm.updateChannelParams.description),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "description", $$v)
      },
      expression: "updateChannelParams.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "市场专员"
    }
  }, [_c('AdminUserMultSelect', {
    attrs: {
      "status": 1,
      "groupTitles": ['市场运营', '市场专员', '代理']
    },
    model: {
      value: (_vm.updateChannelParams.adminUserIds),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "adminUserIds", $$v)
      },
      expression: "updateChannelParams.adminUserIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateChannelModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.updateChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("新签学生列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listNewAssign",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hr-metrics-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, [_c('span', {
    staticClass: "dash-chip is-period"
  }, [_c('i', {
    staticClass: "chip-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "chip-label"
  }, [_vm._v("数据周期")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "period-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.searchLoading,
      "transfer": "",
      "placeholder": "选择周期"
    },
    on: {
      "on-change": _vm.onPeriodChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.infoChips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标总览")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Button', {
    staticClass: "dash-export",
    attrs: {
      "type": "primary",
      "loading": _vm.overviewExportLoading
    },
    on: {
      "click": _vm.exportOverview
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "kpi-dim-title"
  }, [_vm._v("老师维度")]), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [_c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.leaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('leaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('leaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.leaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.compareText))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("已通过请假的老师 + 老师缺席的老师 ÷ 有课老师 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.resignRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('resignRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('resignRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.resignRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.resignCompareText))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("离职人数 ÷ 月初在职人数 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.returnLessonHoursLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('returnLessonHours')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('returnLessonHours')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.returnLessonHoursText))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.returnLessonHoursCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("课堂投诉审核通过、外教课、赠课原因是老师 · 点击查看周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.refundStudentCountLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('refundStudentCount')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('refundStudentCount')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.refundStudentCountText))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.refundStudentCountCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("财务退费列表老师原因，按人去重 · 点击查看月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.demoAttendDealRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('demoAttendDealRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('demoAttendDealRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.demoAttendDealRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.demoAttendDealCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("demo成交学生数 ÷ demo出席学生数 · 点击查看月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.fullAttendanceRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('fullAttendanceRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('fullAttendanceRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.fullAttendanceRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.fullAttendanceCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("无老师迟到/早退/缺席/请假/离职的有课老师 ÷ 有课老师（不含学生请假、管理员取消、学生缺席且老师未缺席的课） · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.teacherLateRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('teacherLateRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('teacherLateRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.teacherLateRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.teacherLateCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("至少有一节迟到的正常上课老师 ÷ 有正常上课的老师。正常上课是已经上完，学生、老师都未缺席；一个老师只计一次 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.teacherEarlyRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('teacherEarlyRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('teacherEarlyRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.teacherEarlyRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.teacherEarlyCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("至少有一节早退的正常上课老师 ÷ 有正常上课的老师。正常上课是已经上完，学生、老师都未缺席；一个老师只计一次 · 点击查看日周月年")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "kpi-dim-title"
  }, [_vm._v("课节维度")]), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [_c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.attendLessonRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('attendLessonRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('attendLessonRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.attendLessonRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.attendLessonCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("已上课未缺席课节 ÷（买断课节 + 已上课临时课） · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.lessonLeaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('lessonLeaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('lessonLeaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.lessonLeaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.lessonLeaveCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("全部请假类型或老师缺席 ÷ 应上课课节 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.tempLeaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('tempLeaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('tempLeaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.tempLeaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.tempLeaveCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("（临时请假 + 失联 + 取消课或老师缺席）÷ 应上课课节 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.lateRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('lateRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('lateRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.lateRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.lateCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("老师迟到的课 ÷ 正常上课的课（已上完，学生、老师都未缺席；无通话按未缺席未迟到）· 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.earlyRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('earlyRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('earlyRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.earlyRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.earlyCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("老师早退的课 ÷ 正常上课的课（已上完，学生、老师都未缺席；无通话按未缺席未早退）· 点击查看日周月年")])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.editCardTitle,
      "width": "520",
      "mask-closable": false,
      "loading": _vm.saveLoading
    },
    on: {
      "on-ok": _vm.saveThresholds
    },
    model: {
      value: (_vm.showThresholdModal),
      callback: function($$v) {
        _vm.showThresholdModal = $$v
      },
      expression: "showThresholdModal"
    }
  }, [_c('p', {
    staticClass: "threshold-tip"
  }, [_vm._v(_vm._s(_vm.editCardHint))]), _vm._v(" "), _c('div', {
    staticClass: "threshold-row"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("方向")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.editDirection),
      callback: function($$v) {
        _vm.editDirection = $$v
      },
      expression: "editDirection"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "worse"
    }
  }, [_vm._v("越小越健康")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "better"
    }
  }, [_vm._v("越大越健康")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "threshold-row"
  }, [_c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("健康")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.healthy),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "healthy", $$v)
      },
      expression: "editBand.healthy"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1), _vm._v(" "), _c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("需关注")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.attention),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "attention", $$v)
      },
      expression: "editBand.attention"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1), _vm._v(" "), _c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("预警")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.alert),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "alert", $$v)
      },
      expression: "editBand.alert"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.trendModalTitle,
      "width": _vm.trendModalWidth,
      "mask-closable": true
    },
    on: {
      "on-visible-change": _vm.onTrendVisible
    },
    model: {
      value: (_vm.showTrendModal),
      callback: function($$v) {
        _vm.showTrendModal = $$v
      },
      expression: "showTrendModal"
    }
  }, [(!_vm.showDetail) ? _c('div', [_c('div', {
    staticClass: "trend-toolbar"
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "disabled": _vm.trendLoading
    },
    on: {
      "on-change": _vm.searchTrend
    },
    model: {
      value: (_vm.trendPeriodType),
      callback: function($$v) {
        _vm.trendPeriodType = $$v
      },
      expression: "trendPeriodType"
    }
  }, _vm._l((_vm.trendPeriodOptions), function(item) {
    return _c('Radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('Date-picker', {
    staticClass: "trend-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.trendLoading,
      "transfer": "",
      "placeholder": "选择周期"
    },
    on: {
      "on-change": _vm.onTrendPeriodChange
    },
    model: {
      value: (_vm.trendDateRange),
      callback: function($$v) {
        _vm.trendDateRange = $$v
      },
      expression: "trendDateRange"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-adviser trend-adviser"
  }, [_c('span', {
    staticClass: "detail-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "detail-adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "disabled": _vm.trendLoading
    },
    on: {
      "on-change": _vm.onTrendStudyAdviserChange
    },
    model: {
      value: (_vm.trendStudyAdviserId),
      callback: function($$v) {
        _vm.trendStudyAdviserId = _vm._n($$v)
      },
      expression: "trendStudyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v(_vm._s(_vm.trendHint))]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.trendColumns,
      "data": _vm.trendTableData,
      "loading": _vm.trendLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), (_vm.trendMetric === 'fullAttendanceRate') ? _c('div', {
    staticClass: "non-full-block"
  }, [_c('div', {
    staticClass: "non-full-head"
  }, [_c('h4', {
    staticClass: "non-full-title"
  }, [_vm._v("未全勤老师")]), _vm._v(" "), _c('Input', {
    staticClass: "non-full-search",
    attrs: {
      "clearable": "",
      "placeholder": "老师ID / 姓名"
    },
    on: {
      "on-enter": _vm.onNonFullKeywordSearch,
      "on-clear": _vm.onNonFullKeywordSearch
    },
    model: {
      value: (_vm.nonFullKeyword),
      callback: function($$v) {
        _vm.nonFullKeyword = $$v
      },
      expression: "nonFullKeyword"
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.nonFullLoading
    },
    on: {
      "click": _vm.onNonFullKeywordSearch
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v("该日期范围内有老师责任异常课节的老师。学生请假、管理员取消、学生缺席且老师未迟到早退缺席的课不计入。点异常课节数查看具体课节。")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.nonFullColumns,
      "data": _vm.nonFullTableData,
      "loading": _vm.nonFullLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "trend-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.nonFullTotal,
      "current": _vm.nonFullPageIndex,
      "page-size": _vm.nonFullPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onNonFullPageChange,
      "on-page-size-change": _vm.onNonFullPageSizeChange
    }
  })], 1)], 1) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "trend-nav"
  }, [_c('a', {
    staticClass: "trend-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToTrend.apply(null, arguments)
      }
    }
  }, [_vm._v("返回区间表")]), _vm._v(" "), _c('span', {
    staticClass: "trend-crumb"
  }, [_vm._v(_vm._s(_vm.detailTitle))])]), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v(_vm._s(_vm.detailHint))]), _vm._v(" "), _c('div', {
    staticClass: "detail-adviser"
  }, [_c('span', {
    staticClass: "detail-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "detail-adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onDetailStudyAdviserChange
    },
    model: {
      value: (_vm.detailStudyAdviserId),
      callback: function($$v) {
        _vm.detailStudyAdviserId = _vm._n($$v)
      },
      expression: "detailStudyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailTableData,
      "loading": _vm.detailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "trend-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.detailTotal,
      "current": _vm.detailPageIndex,
      "page-size": _vm.detailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onDetailPageChange,
      "on-page-size-change": _vm.onDetailPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportCurrent
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.showDetail) ? _c('Button', {
    on: {
      "click": _vm.backToTrend
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeTrendModal
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('user-info-modal', {
    attrs: {
      "value": _vm.showUserInfoModal,
      "uid": _vm.userInfoUid
    },
    on: {
      "on-close": function($event) {
        _vm.showUserInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外教核心数据看板")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("\n          Foreign Teacher HR Core Metrics Dashboard - 出勤履约 / 人员稳定 / 服务质量 / 成本效益\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 同比口径：—")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            离职率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            返课时数\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            退费学生数\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            Demo出席成交率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            全勤率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            迟到率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            早退率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            上课率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            临时请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            迟到率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            早退率\n          ")])
}]}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工关系")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("转正管理")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("待转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已办")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "姓名/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openSubmit
    }
  }, [_vm._v("新建转正（仅本地）")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无待转正"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建转正（仅本地）"
    },
    on: {
      "on-ok": _vm.submit
    },
    model: {
      value: (_vm.showSubmit),
      callback: function($$v) {
        _vm.showSubmit = $$v
      },
      expression: "showSubmit"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", $$v)
      },
      expression: "form.reason"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课后视频")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.queryParam,
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", _vm._n($$v))
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", _vm._n($$v))
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "lessonTitle"
    },
    model: {
      value: (_vm.queryParam.lessonTitle),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonTitle", $$v)
      },
      expression: "queryParam.lessonTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLessonVideo/listByPage",
      "params": _vm.queryParam
    }
  }), _vm._v(" "), _c('LessonVideoInsertModal', {
    attrs: {
      "value": _vm.showInsertModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('LessonVideoUpdateModal', {
    attrs: {
      "value": _vm.showUpdateModal,
      "successCallback": _vm.search,
      "id": _vm.id
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": _vm.num > 1,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      staticClass: "upload-list"
    }, [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-list-cover"
    }, [(_vm.isView) ? _c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-mask",
    on: {
      "click": _vm.onCarouselClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "2002",
      "right": "40px",
      "top": "20px",
      "cursor": "hand"
    },
    on: {
      "click": _vm.onCarouselClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close",
      "color": "white",
      "size": "40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-content"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": false,
      "autoplay-speed": 1000,
      "dots": "outside",
      "trigger": "click",
      "arrow": "always"
    },
    model: {
      value: (_vm.showIndex),
      callback: function($$v) {
        _vm.showIndex = $$v
      },
      expression: "showIndex"
    }
  }, _vm._l((_vm.fileList), function(file) {
    return _c('CarouselItem', {
      key: file.url,
      staticClass: "item"
    }, [_c('img', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("开课Checklist管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "publish-info"
  }, [(_vm.latestVersionId) ? _c('span', [_vm._v("最近发布：版本 " + _vm._s(_vm.latestVersionId) + " · " + _vm._s(_vm.latestPublishTime || '—'))]) : _c('span', {
    staticClass: "publish-empty"
  }, [_vm._v("最近发布：暂未发布")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openStageModal()
      }
    }
  }, [_vm._v("新增分类")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.publishLoading
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发布")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  })], 1) : _c('div', [_vm._l((_vm.stages), function(stage) {
    return _c('div', {
      key: stage.id,
      staticClass: "stage-block"
    }, [_c('div', {
      staticClass: "stage-head"
    }, [_c('span', {
      staticClass: "stage-name",
      class: {
        'is-offline': !_vm.isEnabled(stage.enabled)
      }
    }, [_vm._v(_vm._s(stage.name))]), _vm._v(" "), _c('span', {
      staticClass: "stage-sort"
    }, [_vm._v("排序：" + _vm._s(stage.sort))]), _vm._v(" "), (!_vm.isEnabled(stage.enabled)) ? _c('Tag', {
      attrs: {
        "color": "default"
      }
    }, [_vm._v("已下线")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "stage-actions"
    }, [_c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openItemModal(null, stage)
        }
      }
    }, [_vm._v("新增选项")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openStageModal(stage)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": _vm.isEnabled(stage.enabled) ? 'warning' : 'success'
      },
      on: {
        "click": function($event) {
          return _vm.toggleStage(stage)
        }
      }
    }, [_vm._v(_vm._s(_vm.isEnabled(stage.enabled) ? '下线' : '上线'))])], 1)], 1), _vm._v(" "), _c('Table', {
      attrs: {
        "columns": _vm.itemColumns,
        "data": stage.items || [],
        "border": "",
        "stripe": "",
        "size": "small"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.stages.length) ? _c('div', {
    staticClass: "empty-tip"
  }, [_vm._v("暂未配置分类，请先新增分类")]) : _vm._e()], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.stageForm.id ? '编辑分类' : '新增分类',
      "width": "480"
    },
    model: {
      value: (_vm.showStageModal),
      callback: function($$v) {
        _vm.showStageModal = $$v
      },
      expression: "showStageModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入分类名称",
      "maxlength": 50
    },
    model: {
      value: (_vm.stageForm.name),
      callback: function($$v) {
        _vm.$set(_vm.stageForm, "name", $$v)
      },
      expression: "stageForm.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "留空放到最后"
    },
    model: {
      value: (_vm.stageForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.stageForm, "sort", $$v)
      },
      expression: "stageForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showStageModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.saveStage
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.itemForm.id ? '编辑选项' : '新增选项',
      "width": "560"
    },
    model: {
      value: (_vm.showItemModal),
      callback: function($$v) {
        _vm.showItemModal = $$v
      },
      expression: "showItemModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属分类",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.itemForm.stage),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "stage", $$v)
      },
      expression: "itemForm.stage"
    }
  }, _vm._l((_vm.stages), function(stage) {
    return _c('Option', {
      key: stage.id,
      attrs: {
        "value": stage.id
      }
    }, [_vm._v(_vm._s(stage.name))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标题",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题",
      "maxlength": 200
    },
    model: {
      value: (_vm.itemForm.title),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "title", $$v)
      },
      expression: "itemForm.title"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入说明"
    },
    model: {
      value: (_vm.itemForm.guideText),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "guideText", $$v)
      },
      expression: "itemForm.guideText"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提示"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入提示"
    },
    model: {
      value: (_vm.itemForm.hint),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "hint", $$v)
      },
      expression: "itemForm.hint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.itemForm.itemType),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "itemType", $$v)
      },
      expression: "itemForm.itemType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("勾选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("必须填文字")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("必须传图")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "留空放到最后"
    },
    model: {
      value: (_vm.itemForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "sort", $$v)
      },
      expression: "itemForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showItemModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("常规课程列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('admin-user-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "排课时间"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startCreateTimeChange
    },
    model: {
      value: (_vm.queryParam.startCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startCreateDate", $$v)
      },
      expression: "queryParam.startCreateDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endCreateTimeChange
    },
    model: {
      value: (_vm.queryParam.endCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endCreateDate", $$v)
      },
      expression: "queryParam.endCreateDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "courseType", _vm._n($$v))
      },
      expression: "queryParam.courseType"
    }
  }, _vm._l((_vm.$constant.courseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生昵称"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersionId", _vm._n($$v))
      },
      expression: "queryParam.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeRegChange
    },
    model: {
      value: (_vm.queryParam.regStartDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regStartDate", $$v)
      },
      expression: "queryParam.regStartDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 11,
      "md": 11,
      "lg": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeRegChange
    },
    model: {
      value: (_vm.queryParam.regEndDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regEndDate", $$v)
      },
      expression: "queryParam.regEndDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号",
      "label-width": 75
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnSelStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnSelStatus", $$v)
      },
      expression: "queryParam.lsnSelStatus"
    }
  }, _vm._l((_vm.$constant.lsnSelStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchCategory),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchCategory", _vm._n($$v))
      },
      expression: "queryParam.tchCategory"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchStudyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchStudyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.tchStudyAdviserId"
    }
  }, _vm._l((_vm.tchStudyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "label-width": 40
    }
  }, [_c('channel-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 5
    }
  }, [_c('FormItem', {
    attrs: {
      "label-width": 80,
      "label": "渠道来源："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否复习课",
      "label-width": 80
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isLastSection),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isLastSection", _vm._n($$v))
      },
      expression: "queryParam.isLastSection"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程ID"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "bookLessonOpenedId"
    },
    model: {
      value: (_vm.queryParam.bookLessonOpenedId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "bookLessonOpenedId", $$v)
      },
      expression: "queryParam.bookLessonOpenedId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课件"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "Level"
    },
    on: {
      "on-change": _vm.changeMaterialLevel
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", _vm._n($$v))
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: 'lv-' + item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "Lesson"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonId", _vm._n($$v))
      },
      expression: "queryParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: 'ls-' + item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                " + _vm._s(item.id) + "-" + _vm._s(item.title) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disabled": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n          搜索\n        ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('619'),
      expression: "'619'"
    }],
    staticStyle: {
      "margin-bottom": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disabled": _vm.exportLoading,
      "icon": "ios-download-outline"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          导出\n        ")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchCancelLesson
    }
  }, [_vm._v("\n          批量取消课程\n        ")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.showCameraStatus),
      callback: function($$v) {
        _vm.showCameraStatus = $$v
      },
      expression: "showCameraStatus"
    }
  }, [_vm._v("课前是否打开摄像头")])], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增统一放假",
      "width": "600"
    },
    model: {
      value: (_vm.unifiedHolidayModal),
      callback: function($$v) {
        _vm.unifiedHolidayModal = $$v
      },
      expression: "unifiedHolidayModal"
    }
  }, [_c('Form', {
    ref: "holidayForm",
    staticClass: "form",
    attrs: {
      "model": _vm.holidayParam,
      "rules": _vm.holidayRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "放假时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeHolidayChange
    },
    model: {
      value: (_vm.holidayParam.startTime),
      callback: function($$v) {
        _vm.$set(_vm.holidayParam, "startTime", $$v)
      },
      expression: "holidayParam.startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeHolidayChange
    },
    model: {
      value: (_vm.holidayParam.endTime),
      callback: function($$v) {
        _vm.$set(_vm.holidayParam, "endTime", $$v)
      },
      expression: "holidayParam.endTime"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-Item', {
    attrs: {
      "label": "内容：",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.holidayParam.content),
      callback: function($$v) {
        _vm.$set(_vm.holidayParam, "content", $$v)
      },
      expression: "holidayParam.content"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.unifiedHolidayModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.saveHoliday
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "opened-list",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookLesson/opened/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reloadWithPage": _vm.reloadWithPage,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectedChange
    }
  }), _vm._v(" "), _c('ChangeLessonModal', {
    attrs: {
      "lessonOpened": _vm.lessonOpened,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showChangeLessonModal),
      callback: function($$v) {
        _vm.showChangeLessonModal = $$v
      },
      expression: "showChangeLessonModal"
    }
  }), _vm._v(" "), _c('ChangeClassTypeModal', {
    attrs: {
      "classType": _vm.classType
    },
    model: {
      value: (_vm.showChangeLClassTypeModal),
      callback: function($$v) {
        _vm.showChangeLClassTypeModal = $$v
      },
      expression: "showChangeLClassTypeModal"
    }
  }), _vm._v(" "), _c('AddMonitorLessonRecordModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordModal = $$v
      },
      expression: "showMonitorLessonRecordModal"
    }
  }), _vm._v(" "), _c('AddLessonFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "studentName": _vm.studentName,
      "teacherName": _vm.teacherName,
      "lessonTime": _vm.lessonTime
    },
    model: {
      value: (_vm.addLessonFeedbackModal),
      callback: function($$v) {
        _vm.addLessonFeedbackModal = $$v
      },
      expression: "addLessonFeedbackModal"
    }
  }), _vm._v(" "), _c('TchLessonLeaveModal', {
    attrs: {
      "openedId": _vm.openedId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchLessonLeaveModal),
      callback: function($$v) {
        _vm.showTchLessonLeaveModal = $$v
      },
      expression: "showTchLessonLeaveModal"
    }
  }), _vm._v(" "), _c('LessonCancelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "lsnType": _vm.lsnType,
      "tchChannel": _vm.tchChannel,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showLessonCancelModal),
      callback: function($$v) {
        _vm.showLessonCancelModal = $$v
      },
      expression: "showLessonCancelModal"
    }
  }), _vm._v(" "), _c('LessonFeedBackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "uid": _vm.uid,
      "tchId": _vm.tchId,
      "userNickname": _vm.userNickname
    },
    model: {
      value: (_vm.showLessonFeedBackModal),
      callback: function($$v) {
        _vm.showLessonFeedBackModal = $$v
      },
      expression: "showLessonFeedBackModal"
    }
  }), _vm._v(" "), _c('UserOneLeaveModal', {
    attrs: {
      "openId": _vm.openId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserOneLeaveModal),
      callback: function($$v) {
        _vm.showUserOneLeaveModal = $$v
      },
      expression: "showUserOneLeaveModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('SearchChangeTchModal', {
    attrs: {
      "optType": _vm.optType,
      "user": _vm.tempLessonUser,
      "changeTeacherOnly": _vm.changeTeacherOnly,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showSearchChangeTchModal),
      callback: function($$v) {
        _vm.showSearchChangeTchModal = $$v
      },
      expression: "showSearchChangeTchModal"
    }
  }), _vm._v(" "), _c('UserTempLessonModal', {
    attrs: {
      "user": _vm.tempLessonUser,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showUserTempLessonModal),
      callback: function($$v) {
        _vm.showUserTempLessonModal = $$v
      },
      expression: "showUserTempLessonModal"
    }
  }), _vm._v(" "), _c('AddClassRequirementModal', {
    attrs: {
      "uid": _vm.currentUid,
      "studentName": _vm.currentStudentName,
      "tchId": _vm.currentTchId,
      "bookLessonOpenedId": _vm.currentOpenedId,
      "tchName": _vm.currentTchName,
      "class-requirement": _vm.classRequirement,
      "class-requirement-tags": _vm.classRequirementTags,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showAddClassRequirementModal),
      callback: function($$v) {
        _vm.showAddClassRequirementModal = $$v
      },
      expression: "showAddClassRequirementModal"
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true
    },
    on: {
      "on-close": function($event) {
        _vm.showBookTchFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true
    },
    on: {
      "on-close": function($event) {
        _vm.showBookTchScoreFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": function($event) {
        _vm.showBookUserFeedbackModal = false
      }
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewDemoModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewDemoModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewRegularModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewRegularModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewFinishLevelModal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewFinishLevelModal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewDemoV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewDemoV2Modal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewRegularV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewRegularV2Modal = false
      }
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "readonly": true,
      "value": _vm.studentWriteReviewFinishLevelV2Modal
    },
    on: {
      "on-close": function($event) {
        _vm.studentWriteReviewFinishLevelV2Modal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "课堂反馈",
      "width": "960",
      "footer-hide": true,
      "mask-closable": false
    },
    model: {
      value: (_vm.showClassFeedback),
      callback: function($$v) {
        _vm.showClassFeedback = $$v
      },
      expression: "showClassFeedback"
    }
  }, [(_vm.showClassFeedback) ? _c('class-feedback', {
    attrs: {
      "lesson-opened-id": _vm.classFeedbackOpenedId,
      "embedded": true
    },
    on: {
      "saved": _vm.onClassFeedbackSaved
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("每日作业")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": ""
    },
    model: {
      value: (_vm.queryParam.date),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "date", $$v)
      },
      expression: "queryParam.date"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyConsultantId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyConsultantId", $$v)
      },
      expression: "queryParam.studyConsultantId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.reviewClockRecordStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.batchCheck
    }
  }, [_vm._v("批量批改\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookMaterialLessons/dailyStudy",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "闯关视频",
      "width": "800",
      "footer-hide": ""
    },
    on: {
      "on-visible-change": _vm.onVideoVisibleChange
    },
    model: {
      value: (_vm.videoVisible),
      callback: function($$v) {
        _vm.videoVisible = $$v
      },
      expression: "videoVisible"
    }
  }, [(_vm.videoUrl) ? _c('FilePreview', {
    attrs: {
      "file-url": _vm.videoUrl,
      "type": "video"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("同龄分群")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择年龄档"
    },
    model: {
      value: (_vm.queryParam.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageBand", $$v)
      },
      expression: "queryParam.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档（9+）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0",
      "color": "#888"
    }
  }, [_vm._v("样本 n<1000 时学生端不展示全国/同城对照。本页只读，月度校准属 P3。")]), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/cohorts/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("已审核老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "auditName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.auditName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditName", $$v)
      },
      expression: "queryParam.auditName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminNickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminMobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.filteredTeacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "未通过类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onRejectFailKindChange
    },
    model: {
      value: (_vm.queryParam.rejectFailKind),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "rejectFailKind", $$v)
      },
      expression: "queryParam.rejectFailKind"
    }
  }, [_c('Option', {
    attrs: {
      "value": "interview"
    }
  }, [_vm._v("面试未通过")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "demo"
    }
  }, [_vm._v("试讲未通过")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师国籍"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.country),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "country", $$v)
      },
      expression: "queryParam.country"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师口音"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师性别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "种族"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ethnicity", $$v)
      },
      expression: "queryParam.ethnicity"
    }
  }, [_c('Option', {
    attrs: {
      "value": "African"
    }
  }, [_vm._v("African")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Coloured"
    }
  }, [_vm._v("Coloured")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "White"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Indian/Asian"
    }
  }, [_vm._v("Indian/Asian")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.auditDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Co', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertTch
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBatchReview
    }
  }, [_vm._v("批量审核")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/audited/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核通过"
    },
    model: {
      value: (_vm.showPassModal),
      callback: function($$v) {
        _vm.showPassModal = $$v
      },
      expression: "showPassModal"
    }
  }, [_c('Form', {
    ref: "passForm",
    staticClass: "form",
    attrs: {
      "model": _vm.passParam,
      "rules": _vm.passRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定允许 "), _c('b', [_vm._v(_vm._s(_vm.passParam.id) + " - " + _vm._s(_vm.passParam.firstName) + " " + _vm._s(_vm.passParam.lastName))]), _vm._v(" 老师通过审核，进入培训中")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.passParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.passParam, "remark", $$v)
      },
      expression: "passParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showPassModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingPass
    },
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("通过")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    staticClass: "form",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定 "), _c('b', [_vm._v(_vm._s(_vm.rejectParam.id) + " - " + _vm._s(_vm.rejectParam.firstName) + " " + _vm._s(_vm.rejectParam.lastName))]), _vm._v(" 老师未审核通过")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.rejectParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "remark", $$v)
      },
      expression: "rejectParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "批量审核"
    },
    model: {
      value: (_vm.showBatchReviewModal),
      callback: function($$v) {
        _vm.showBatchReviewModal = $$v
      },
      expression: "showBatchReviewModal"
    }
  }, [_c('Form', {
    ref: "reviewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.reviewParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "待审核老师："
    }
  }, _vm._l((_vm.selectionTch), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.reviewParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "remark", $$v)
      },
      expression: "reviewParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchPass')
      }
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchReject')
      }
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.search,
      "recruit-flow-entry": "已审核老师列表"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "学生影响明细",
      "tags": ['异动 + 请假 / 旷课汇总到学生', '运营跟进名单'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.countOptions,
      "label": "受影响"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.minCount),
      callback: function($$v) {
        _vm.minCount = $$v
      },
      expression: "minCount"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.remainOptions,
      "label": "未消课时"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.minRemain),
      callback: function($$v) {
        _vm.minRemain = $$v
      },
      expression: "minRemain"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.statusOptions,
      "label": "状态"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生清单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.listSub))])]), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出待跟进名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("主老师")]), _vm._v(" "), _c('th', [_vm._v("影响来源明细")]), _vm._v(" "), _c('th', {
    staticClass: "num sortable",
    class: {
      'is-active': _vm.sortKey === 'cnt'
    },
    on: {
      "click": function($event) {
        return _vm.toggleSort('cnt')
      }
    }
  }, [_vm._v("\n                受影响次数 "), _c('span', {
    staticClass: "sort-ind"
  }, [_vm._v(_vm._s(_vm.sortInd('cnt')))])]), _vm._v(" "), _c('th', {
    staticClass: "num sortable",
    class: {
      'is-active': _vm.sortKey === 'lost'
    },
    on: {
      "click": function($event) {
        return _vm.toggleSort('lost')
      }
    }
  }, [_vm._v("\n                损失课次 "), _c('span', {
    staticClass: "sort-ind"
  }, [_vm._v(_vm._s(_vm.sortInd('lost')))])]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', [_vm._v("最近受影响")]), _vm._v(" "), _c('th', [_vm._v("当前状态")]), _vm._v(" "), _c('th', [_vm._v("风险")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._l(((row.sources || [])), function(s) {
      return _c('span', {
        key: s.type,
        staticClass: "mini-badge",
        style: (_vm.sourceStyle(s.type))
      }, [_vm._v(_vm._s(_vm.typeLabel(s.type)) + "×" + _vm._s(s.count))])
    }), _vm._v(" "), (!(row.sources || []).length) ? _c('span', {
      staticClass: "t-muted"
    }, [_vm._v("—")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.fmtNum(row.impactCount)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 10
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lastImpactDate || '—'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.statusBadge(row.status)
    }, [_vm._v(_vm._s(row.status || '—'))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.risk)
    }, [_vm._v(_vm._s(row.risk || '—'))])])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("当前筛选条件下没有学生")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.num(_vm.d.total),
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-size-opts": [20, 50, 100],
      "show-total": "",
      "show-sizer": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), (!_vm.scatterList.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('svg', {
    staticClass: "svg-chart",
    attrs: {
      "viewBox": '0 0 ' + _vm.sc.W + ' ' + _vm.sc.H
    }
  }, [_c('rect', {
    attrs: {
      "x": _vm.sc.zoneX,
      "y": _vm.sc.PT,
      "width": _vm.sc.zoneW,
      "height": _vm.sc.zoneH,
      "fill": "#E6464E",
      "fill-opacity": "0.05",
      "rx": "4"
    }
  }), _vm._v(" "), _vm._l((_vm.sc.yTicks), function(g) {
    return _c('g', {
      key: 'y' + g.v
    }, [_c('line', {
      staticClass: "gridline",
      attrs: {
        "x1": _vm.sc.PL,
        "y1": g.y,
        "x2": _vm.sc.W - _vm.sc.PR,
        "y2": g.y
      }
    }), _vm._v(" "), _c('text', {
      staticClass: "axis-l",
      attrs: {
        "x": _vm.sc.PL - 8,
        "y": g.y + 3,
        "text-anchor": "end"
      }
    }, [_vm._v(_vm._s(g.v))])])
  }), _vm._v(" "), _vm._l((_vm.sc.xTicks), function(g) {
    return _c('text', {
      key: 'x' + g.v,
      staticClass: "axis-l",
      attrs: {
        "x": g.x,
        "y": _vm.sc.H - _vm.sc.PB + 16,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(g.v))])
  }), _vm._v(" "), _vm._l((_vm.sc.points), function(p) {
    return _c('circle', {
      key: p.uid,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": p.danger ? 4.6 : 3.4,
        "fill": p.danger ? '#E6464E' : '#5C78A8',
        "fill-opacity": p.danger ? 0.75 : 0.45,
        "stroke": p.danger ? '#E6464E' : '#5C78A8',
        "stroke-width": "1.1"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.sc.PL,
      "y1": _vm.sc.H - _vm.sc.PB,
      "x2": _vm.sc.W - _vm.sc.PR,
      "y2": _vm.sc.H - _vm.sc.PB,
      "stroke": "#DFE4EE"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "axis-t",
    attrs: {
      "x": (_vm.sc.W + _vm.sc.PL) / 2,
      "y": _vm.sc.H - 2,
      "text-anchor": "middle"
    }
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('text', {
    staticClass: "axis-t",
    attrs: {
      "transform": 'translate(12,' + (_vm.sc.H - _vm.sc.PB + _vm.sc.PT) / 2 + ') rotate(-90)',
      "text-anchor": "middle"
    }
  }, [_vm._v("剩余课时")])], 2), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("\n          右上区 = 损失课次 ≥ 高频学生人均（" + _vm._s(_vm.fmtNum(_vm.sc.lostLine)) + "）且剩余课时 ≥ " + _vm._s(_vm.sc.remainLine) + "，共 "), _c('b', [_vm._v(_vm._s(_vm.sc.dangerCount))]), _vm._v(" 人。剩余课时高但损失也高，说明「钱还在、人快走了」，优先用补课 + 固定新老师处理。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响来源构成"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("高频受影响学生 · " + _vm._s(_vm.fmtNum(_vm.d.highFreqCount)) + " 人")])])]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.sourceRows,
      "unit": "次",
      "right-width": 110
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("事件总数")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.sourceTotal)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("异动类（离职 / 淘汰 / 关闭时间）")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.changeEventCount)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("请假类（3h内 / 请假 / 旷课）")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.leaveEventCount)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("请假为主的高频学生")]), _c('dd', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.leaveDominantRate)))])]), _vm._v(" "), (_vm.num(_vm.d.highFreqCount) > 0) ? _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v("近 " + _vm._s(_vm.days) + " 天 " + _vm._s(_vm.fmtNum(_vm.d.highFreqCount)) + " 名高频受影响学生中，" + _vm._s(_vm.fmtRate(_vm.d.leaveDominantRate)) + " 以请假类事件为主。")]), _vm._v("重复请假对同一学生的伤害比一次性离职更隐蔽，建议降低与高频请假老师的排课绑定度。\n        ")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("学生影响清单")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v("谁该打电话、谁该补课时、谁已经快走了")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("损失课次 vs 剩余课时"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("点 = 高频受影响学生，右上需立刻跟进")])])])
}]}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("蓝图")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/blueprints/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑蓝图' : '新建蓝图',
      "width": "980"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onExamTypeChange
    },
    model: {
      value: (_vm.form.examType),
      callback: function($$v) {
        _vm.$set(_vm.form, "examType", $$v)
      },
      expression: "form.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": _vm.form.examType === 'SUMMATIVE' ? '技能站点' : '档位'
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.segment),
      callback: function($$v) {
        _vm.$set(_vm.form, "segment", $$v)
      },
      expression: "form.segment"
    }
  }, _vm._l((_vm.segmentOptions(_vm.form.examType, _vm.form.segment)), function(s) {
    return _c('Option', {
      key: s.value,
      attrs: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "版本"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "v1.0"
    },
    model: {
      value: (_vm.form.versionNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionNo", $$v)
      },
      expression: "form.versionNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题量上限"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 200,
      "placeholder": "0 表示沿用默认"
    },
    model: {
      value: (_vm.form.itemLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "itemLimit", $$v)
      },
      expression: "form.itemLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "限时（秒）"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 7200,
      "placeholder": "0 表示沿用默认"
    },
    model: {
      value: (_vm.form.durationSec),
      callback: function($$v) {
        _vm.$set(_vm.form, "durationSec", $$v)
      },
      expression: "form.durationSec"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "组卷槽位"
    }
  }, [_c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("每一行是一类题：从哪个库抽、什么技能和题型、出几道、每道多少分。入门测不能加写作。")]), _vm._v(" "), _vm._l((_vm.slots), function(slot, idx) {
    return _c('div', {
      key: idx,
      staticClass: "mex-slot-card"
    }, [_c('div', {
      staticClass: "mex-slot-head"
    }, [_c('span', [_vm._v("第 " + _vm._s(idx + 1) + " 类题")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeSlot(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "题库"
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onBankChange(slot)
        }
      },
      model: {
        value: (slot.bank),
        callback: function($$v) {
          _vm.$set(slot, "bank", $$v)
        },
        expression: "slot.bank"
      }
    }, [_c('Option', {
      attrs: {
        "value": "COMP"
      }
    }, [_vm._v("综合库（听/读/写）")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "SPEAK"
      }
    }, [_vm._v("口语库")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "技能"
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onSkillChange(slot)
        }
      },
      model: {
        value: (slot.skill),
        callback: function($$v) {
          _vm.$set(slot, "skill", $$v)
        },
        expression: "slot.skill"
      }
    }, [_c('Option', {
      attrs: {
        "value": "Listening"
      }
    }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "Speaking"
      }
    }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "Reading"
      }
    }, [_vm._v("阅读 Reading")]), _vm._v(" "), (_vm.form.examType !== 'PLACEMENT') ? _c('Option', {
      attrs: {
        "value": "Writing"
      }
    }, [_vm._v("写作 Writing")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "题型"
      }
    }, [_c('Select', {
      attrs: {
        "filterable": "",
        "transfer": "",
        "placeholder": "与题库列表题型一致"
      },
      model: {
        value: (slot.questionType),
        callback: function($$v) {
          _vm.$set(slot, "questionType", $$v)
        },
        expression: "slot.questionType"
      }
    }, _vm._l((_vm.questionTypesOf(slot.skill, slot.questionType)), function(t) {
      return _c('Option', {
        key: t.value,
        attrs: {
          "value": t.value
        }
      }, [_vm._v(_vm._s(t.label))])
    }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "出几道"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 1,
        "max": 20,
        "placeholder": "如 4"
      },
      model: {
        value: (slot.count),
        callback: function($$v) {
          _vm.$set(slot, "count", $$v)
        },
        expression: "slot.count"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "每道分值"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 20,
        "step": 1,
        "placeholder": "如 1"
      },
      model: {
        value: (slot.scoreEach),
        callback: function($$v) {
          _vm.$set(slot, "scoreEach", $$v)
        },
        expression: "slot.scoreEach"
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addSlot
    }
  }, [_vm._v("添加一类题")])], 2), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "模块权重"
    }
  }, [_c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("报告合成总分时按模块占比加权，不参与抽题。入门测只有听/说/读，建议合计 100。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-slot-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.weights), function(w) {
    return _c('i-col', {
      key: w.skill,
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.skillLabel(w.skill)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 40"
      },
      model: {
        value: (w.weight),
        callback: function($$v) {
          _vm.$set(w, "weight", $$v)
        },
        expression: "w.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.weightSum))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员定级",
      "width": "650"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid) + "  - " + _vm._s(_vm.formData.mobile) + " - " + _vm._s(_vm.formData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n            ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBind
    },
    on: {
      "click": _vm.updateLevel
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    class: 'login-' + _vm.view,
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.dingtalkHanded) ? _c('div', {
    staticClass: "dingtalk-handed"
  }, [_c('h2', [_vm._v("钉钉授权")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dingtalkHandedText))])]) : (_vm.view === 'select') ? _c('div', {
    staticClass: "identity-select"
  }, [_c('h2', [_vm._v(_vm._s(_vm.welcomeText))]), _vm._v(" "), _c('p', {
    staticClass: "identity-tip"
  }, [_vm._v("请选择登录身份")]), _vm._v(" "), _c('div', {
    staticClass: "identity-row"
  }, [_c('div', {
    staticClass: "identity-item admin",
    on: {
      "click": _vm.enterAdmin
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact",
      "size": "36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "identity-name"
  }, [_vm._v("管理员登录")]), _vm._v(" "), _c('div', {
    staticClass: "identity-desc"
  }, [_vm._v("使用钉钉授权，或用手机钉钉扫码。确认后在这台电脑登录。")])], 1), _vm._v(" "), _c('div', {
    staticClass: "identity-item agent",
    on: {
      "click": _vm.enterAgent
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-people",
      "size": "36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "identity-name"
  }, [_vm._v("代理登录")]), _vm._v(" "), _c('div', {
    staticClass: "identity-desc"
  }, [_vm._v("使用账号和密码登录，提交后继续短信验证。")])], 1)])]) : (_vm.view === 'admin') ? _c('div', {
    staticClass: "admin-login"
  }, [_c('h2', {
    staticClass: "admin-title"
  }, [_vm._v("管理员登录")]), _vm._v(" "), (_vm.chooseAccounts.length) ? _c('div', {
    staticClass: "account-choose"
  }, [_c('p', {
    staticClass: "view-tip"
  }, [_vm._v("该钉钉绑定了多个后台账号，请选择要登录的账号")]), _vm._v(" "), _vm._l((_vm.chooseAccounts), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "account-item",
      class: {
        'account-item-disabled': _vm.chooseLoading
      },
      on: {
        "click": function($event) {
          return _vm.chooseLogin(item)
        }
      }
    }, [_c('div', {
      staticClass: "account-name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "account-sub"
    }, [_c('span', [_vm._v("登录账号：" + _vm._s(item.account))]), _vm._v(" "), _c('span', [_vm._v("编号：" + _vm._s(item.id))])])])
  })], 2) : [_c('p', {
    staticClass: "view-tip"
  }, [_vm._v("请使用钉钉登录，未绑定钉钉的账号无法登录")]), _vm._v(" "), _c('div', {
    staticClass: "dingtalk-login"
  }, [_c('i-button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.dingtalkLoginLoading
    },
    on: {
      "click": _vm.dingtalkAuthLogin
    }
  }, [_vm._v("\n            钉钉授权登录\n          ")]), _vm._v(" "), (_vm.dingtalkWaiting) ? _c('p', {
    staticClass: "dingtalk-open-tip"
  }, [_vm._v("已打开钉钉，请在钉钉里确认授权，然后回到这个页面")]) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('a', {
    on: {
      "click": _vm.backToSelect
    }
  }, [_vm._v("返回身份选择")])])]], 2) : _c('div', {
    staticClass: "agent-login"
  }, [_c('h2', {
    staticClass: "agent-title"
  }, [_vm._v("代理登录")]), _vm._v(" "), _c('p', {
    staticClass: "view-tip"
  }, [_vm._v("请使用账号密码登录")]), _vm._v(" "), _c('i-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.loginForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "mobile", $$v)
      },
      expression: "loginForm.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "size": "large",
      "placeholder": "请输入密码"
    },
    on: {
      "on-enter": _vm.submit
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.loginForm.remember),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "remember", $$v)
      },
      expression: "loginForm.remember"
    }
  }, [_vm._v("记住密码")])], 1), _vm._v(" "), _c('Form-item', [_c('i-button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('a', {
    on: {
      "click": _vm.backToSelect
    }
  }, [_vm._v("返回身份选择")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code"
  }, [_c('div', {
    attrs: {
      "id": "dingtalk-qr"
    }
  }), _vm._v(" "), _c('p', [_vm._v("使用手机钉钉扫码，确认后在这台电脑登录")])])
}]}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("异动老师看板")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学员ID/姓名",
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "班主任"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser",
      "disabled": _vm.isStudyAdviser
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "当前外教"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "外教ID/姓名",
      "name": "tchName"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计窗口"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placement": "bottom-start",
      "placeholder": "请选择统计窗口",
      "options": {
        disabledDate: _vm.disabledDate
      }
    },
    on: {
      "on-change": _vm.onDateRangeChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/tch-rebind/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [(!_vm.embedded) ? _c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("主管管理")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("提醒规则")]), _vm._v(" "), (_vm.ruleLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('Form', {
    staticClass: "rule-form",
    attrs: {
      "label-width": 160,
      "show-message": false,
      "label-position": "right"
    }
  }, [_vm._l((_vm.fields), function(item) {
    return _c('Form-item', {
      key: item.key,
      attrs: {
        "label": item.label
      }
    }, [_c('InputNumber', {
      attrs: {
        "min": item.min,
        "max": item.max,
        "step": 1
      },
      model: {
        value: (_vm.form[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.key, $$v)
        },
        expression: "form[item.key]"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "unit"
    }, [_vm._v(_vm._s(item.unit))]), _vm._v(" "), _c('span', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc) + "（" + _vm._s(item.min) + "–" + _vm._s(item.max) + "）")])], 1)
  }), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "回访规则上线日"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.reviewStartDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.reviewStartDate = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("入职日早于该日的老师不进回访清单，避免历史老师全部逾期")])], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ruleSaving
    },
    on: {
      "click": _vm.saveRules
    }
  }, [_vm._v("保存规则")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.loadRules
    }
  }, [_vm._v("还原")])], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("异动风险")]), _vm._v(" "), _c('p', {
    staticClass: "risk-note"
  }, [_vm._v("其余规则仍在「外教异动风险监测」的规则设置里。")]), _vm._v(" "), (_vm.riskLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('Form', {
    staticClass: "rule-form",
    attrs: {
      "label-width": 160,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "回溯月数"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 6,
      "max": 36,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.lookbackMonths),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "lookbackMonths", $$v)
      },
      expression: "riskForm.lookbackMonths"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("个月")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("6–36")])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "异动线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.anomalyScore),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "anomalyScore", $$v)
      },
      expression: "riskForm.anomalyScore"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("风险分低于该线计入零瑕疵")])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "高危线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.high),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "high", $$v)
      },
      expression: "riskForm.high"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("风险分达到该线为高危")])], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.riskSaving
    },
    on: {
      "click": _vm.saveRiskRules
    }
  }, [_vm._v("保存异动阈值")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.loadRiskRules
    }
  }, [_vm._v("还原")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("\n      操作日志\n      "), _c('span', {
    staticClass: "block-desc"
  }, [_vm._v("最近 " + _vm._s(_vm.logLimit) + " 条")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "small",
      "icon": "refresh"
    },
    on: {
      "click": _vm.loadLogs
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.logColumns,
      "data": _vm.logList,
      "loading": _vm.logLoading,
      "stripe": "",
      "size": "small",
      "no-data-text": "暂无操作记录"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    提醒规则保存后，工作台、试用期、新外教跟进、合同各页按新规则实时重算。异动的回溯月数、异动线、高危线在本页保存；其余规则仍在「外教异动风险监测」的规则设置里。\n  ")])
}]}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tch-ranking-page"
  }, [_c('div', {
    ref: "exportArea",
    staticClass: "export-sheet"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-glow hero-glow-a"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-glow hero-glow-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero-stats"
  }, _vm._l((_vm.heroStats), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "hero-stat"
    }, [_c('div', {
      staticClass: "hero-stat-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "hero-stat-label"
    }, [_vm._v(_vm._s(item.label))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "rank-toolbar export-skip"
  }, [_c('div', {
    staticClass: "seg"
  }, _vm._l((_vm.periodOptions), function(item) {
    return _c('a', {
      key: item.value,
      staticClass: "seg-item",
      class: {
        'is-active': _vm.periodType === item.value
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPeriodTypeChange(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("日期")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "range-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.studyAdviserId),
      callback: function($$v) {
        _vm.studyAdviserId = _vm._n($$v)
      },
      expression: "studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("开课时间")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "range-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "transfer": "",
      "placeholder": "不限"
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.openCourseRange),
      callback: function($$v) {
        _vm.openCourseRange = $$v
      },
      expression: "openCourseRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("老师性别")]), _vm._v(" "), _c('Select', {
    staticClass: "sex-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = _vm._n($$v)
      },
      expression: "sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("榜单")]), _vm._v(" "), _c('Select', {
    staticClass: "sex-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.boardFilter),
      callback: function($$v) {
        _vm.boardFilter = $$v
      },
      expression: "boardFilter"
    }
  }, _vm._l((_vm.boardFilterOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-actions"
  }, [_c('a', {
    staticClass: "rule-link",
    class: {
      'is-busy': _vm.exportLoading
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.exportToImage
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-download-outline"
    }
  }), _vm._v(" " + _vm._s(_vm.exportLoading ? '导出中' : '导出图片') + "\n      ")], 1), _vm._v(" "), _c('a', {
    staticClass: "rule-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.ruleModal = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  }), _vm._v(" 计分规则\n      ")], 1)])]), _vm._v(" "), (_vm.pageLoading) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPodium && _vm.podium.length) ? _c('div', {
    staticClass: "stage"
  }, [_c('div', {
    staticClass: "stage-beam stage-beam-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-beam stage-beam-c"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-beam stage-beam-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-title"
  }, [_vm._v("TOP 3 · 本期之星")]), _vm._v(" "), _c('div', {
    staticClass: "podium"
  }, _vm._l((_vm.podium), function(row, idx) {
    return _c('div', {
      key: row.tchId,
      staticClass: "podium-col",
      class: 'is-rank-' + row.rank,
      style: ({
        animationDelay: (idx * 0.12) + 's'
      })
    }, [_c('div', {
      staticClass: "podium-person"
    }, [(row.rank === 1) ? _c('div', {
      staticClass: "crown"
    }, [_vm._v("♛")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "avatar",
      class: _vm.medalClass(row.rank)
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "medal medal-podium",
      class: _vm.medalClass(row.rank)
    }, [_c('i', {
      staticClass: "medal-ribbon medal-ribbon-l"
    }), _vm._v(" "), _c('i', {
      staticClass: "medal-ribbon medal-ribbon-r"
    }), _vm._v(" "), _c('span', {
      staticClass: "medal-core"
    }, [_vm._v(_vm._s(row.rank))])]), _vm._v(" "), _c('a', {
      staticClass: "podium-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "podium-id"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "podium-score"
    }, [_vm._v("\n            " + _vm._s(_vm.formatScore(row.totalScore))), _c('span', {
      staticClass: "podium-score-unit"
    }, [_vm._v("分")])]), _vm._v(" "), _c('div', {
      staticClass: "podium-bars"
    }, _vm._l((_vm.podiumMetrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "pbar"
      }, [_c('span', {
        staticClass: "pbar-label"
      }, [_vm._v(_vm._s(metric.title))]), _vm._v(" "), _c('span', {
        staticClass: "pbar-track"
      }, [_c('i', {
        staticClass: "pbar-fill",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          width: _vm.gradeWidth(row[metric.grade])
        })
      })]), _vm._v(" "), _c('span', {
        staticClass: "pbar-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "pedestal"
    }, [_c('span', {
      staticClass: "pedestal-num"
    }, [_vm._v(_vm._s(row.rank))]), _vm._v(" "), _c('span', {
      staticClass: "pedestal-tag"
    }, [_vm._v(_vm._s(_vm.rankTitle(row.rank)))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showChallengers) ? [_vm._m(1), _vm._v(" "), (_vm.challengers.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.challengers), function(row, idx) {
    return _c('div', {
      key: 'c-' + row.tchId,
      staticClass: "rank-card",
      class: _vm.scoreLevel(row.totalScore),
      style: ({
        animationDelay: Math.min(idx, 12) * 0.04 + 's'
      })
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "medal medal-sm",
      class: _vm.medalClass(row.rank)
    }, [_c('i', {
      staticClass: "medal-ribbon medal-ribbon-l"
    }), _vm._v(" "), _c('i', {
      staticClass: "medal-ribbon medal-ribbon-r"
    }), _vm._v(" "), _c('span', {
      staticClass: "medal-core"
    }, [_vm._v(_vm._s(row.rank))])]), _vm._v(" "), _c('a', {
      staticClass: "rank-avatar",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v("\n            " + _vm._s(row.tchName || '—') + "\n            "), (row.rank <= 10) ? _c('span', {
      staticClass: "top10"
    }, [_vm._v("TOP 10")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("开课 " + _vm._s(_vm.formatOpenCourse(row.openCourseTime)) + " · 有课 " + _vm._s(row.lessonCount || 0) + " 节")])]), _vm._v(" "), _c('div', {
      staticClass: "score-ring",
      style: (_vm.ringStyle(row.totalScore))
    }, [_c('div', {
      staticClass: "score-ring-inner"
    }, [_c('div', {
      staticClass: "score-ring-num"
    }, [_vm._v(_vm._s(_vm.formatScoreShort(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "score-ring-unit"
    }, [_vm._v("分")])])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "strip-caption"
    }, [_c('span', [_vm._v("10 项指标（宽度 = 权重）")]), _vm._v(" "), _c('a', {
      staticClass: "toggle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toggle(row.tchId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.expanded[row.tchId] ? '收起' : '明细') + "\n          "), _c('Icon', {
      attrs: {
        "type": _vm.expanded[row.tchId] ? 'ios-arrow-up' : 'ios-arrow-down'
      }
    })], 1)]), _vm._v(" "), (_vm.expanded[row.tchId]) ? _c('div', {
      staticClass: "metric-grid"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "metric-chip",
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      }, [_c('div', {
        staticClass: "metric-chip-label"
      }, [_vm._v(_vm._s(metric.title)), _c('em', [_vm._v(_vm._s(metric.weight))])]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-grade",
        class: _vm.gradeLevel(row[metric.grade])
      }, [_vm._v("\n            " + _vm._s(_vm.gradeText(row[metric.grade])) + " · " + _vm._s(_vm.formatScore(row[metric.score])) + "\n          ")])])
    }), 0) : _vm._e()])
  }), 0) : (!_vm.frLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无挑战者")]) : _vm._e(), _vm._v(" "), (_vm.frTotal > _vm.frPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.frTotal,
      "current": _vm.frPageIndex,
      "page-size": _vm.frPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onFrPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showFormalUnranked) ? [_c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-warn"
  }, [_vm._v(_vm._s(_vm.formalUnrankedTitle))]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v(_vm._s(_vm.formalUnrankedLegend))])]), _vm._v(" "), (_vm.fuRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.fuRows), function(row) {
    return _c('div', {
      key: 'fu-' + row.tchId,
      staticClass: "rank-card is-out is-unranked"
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "out-badge",
      class: {
        'is-unranked': !_vm.isOutOnly(row)
      }
    }, [_vm._v(_vm._s(_vm.unrankedBadge(row)))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "out-reason"
    }, [_vm._v(_vm._s(_vm.unrankedReasonText(row)))])]), _vm._v(" "), _c('div', {
      staticClass: "out-score"
    }, [_c('div', {
      staticClass: "out-score-num"
    }, [_vm._v(_vm._s(_vm.formatScore(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "out-score-label"
    }, [_vm._v("计算分")])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0)])
  }), 0) : (!_vm.fuLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_c('div', [_vm._v(_vm._s(_vm.formalUnrankedEmpty))]), _vm._v(" "), (_vm.boardFilter === 'out') ? _c('div', {
    staticClass: "block-empty-hint"
  }, [_vm._v("可翻页或调整统计周期后再试")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fuTotal > _vm.fuPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.fuTotal,
      "current": _vm.fuPageIndex,
      "page-size": _vm.fuPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onFuPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showRookie) ? [_c('div', {
    staticClass: "rookie-box"
  }, [_vm._m(2), _vm._v(" "), (_vm.rrRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.rrRows), function(row, idx) {
    return _c('div', {
      key: 'rr-' + row.tchId,
      staticClass: "rank-card is-rookie",
      class: _vm.scoreLevel(row.totalScore),
      style: ({
        animationDelay: Math.min(idx, 12) * 0.04 + 's'
      })
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "medal medal-sm medal-rookie"
    }, [_c('span', {
      staticClass: "medal-core"
    }, [_vm._v("新" + _vm._s(row.rank || (idx + 1)))])]), _vm._v(" "), _c('a', {
      staticClass: "rank-avatar is-rookie",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v("\n              " + _vm._s(row.tchName || '—') + "\n              "), _c('span', {
      staticClass: "rookie-tag"
    }, [_vm._v("新锐")])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("开课 " + _vm._s(_vm.formatOpenCourse(row.openCourseTime)) + " · 有课 " + _vm._s(row.lessonCount || 0) + " 节")])]), _vm._v(" "), _c('div', {
      staticClass: "score-ring",
      style: (_vm.ringStyle(row.totalScore))
    }, [_c('div', {
      staticClass: "score-ring-inner"
    }, [_c('div', {
      staticClass: "score-ring-num"
    }, [_vm._v(_vm._s(_vm.formatScoreShort(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "score-ring-unit"
    }, [_vm._v("分")])])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "strip-caption"
    }, [_c('span', [_vm._v("10 项指标（新锐权重，宽度 = 权重）")]), _vm._v(" "), _c('a', {
      staticClass: "toggle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toggleRookie(row.tchId)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.rookieExpanded[row.tchId] ? '收起' : '明细') + "\n            "), _c('Icon', {
      attrs: {
        "type": _vm.rookieExpanded[row.tchId] ? 'ios-arrow-up' : 'ios-arrow-down'
      }
    })], 1)]), _vm._v(" "), (_vm.rookieExpanded[row.tchId]) ? _c('div', {
      staticClass: "metric-grid"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "metric-chip",
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      }, [_c('div', {
        staticClass: "metric-chip-label"
      }, [_vm._v(_vm._s(metric.title)), _c('em', [_vm._v(_vm._s(metric.weight))])]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-grade",
        class: _vm.gradeLevel(row[metric.grade])
      }, [_vm._v("\n              " + _vm._s(_vm.gradeText(row[metric.grade])) + " · " + _vm._s(_vm.formatScore(row[metric.score])) + "\n            ")])])
    }), 0) : _vm._e()])
  }), 0) : (!_vm.rrLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无新锐老师")]) : _vm._e(), _vm._v(" "), (_vm.rrTotal > _vm.rrPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.rrTotal,
      "current": _vm.rrPageIndex,
      "page-size": _vm.rrPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onRrPageChange
    }
  })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.showRookieUnranked) ? [_vm._m(3), _vm._v(" "), (_vm.ruRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.ruRows), function(row) {
    return _c('div', {
      key: 'ru-' + row.tchId,
      staticClass: "rank-card is-out is-unranked is-rookie"
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "out-badge is-unranked"
    }, [_vm._v("未入榜")]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "out-reason"
    }, [_vm._v(_vm._s(_vm.unrankedReasonText(row)))])]), _vm._v(" "), _c('div', {
      staticClass: "out-score"
    }, [_c('div', {
      staticClass: "out-score-num"
    }, [_vm._v(_vm._s(_vm.formatScore(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "out-score-label"
    }, [_vm._v("计算分")])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0)])
  }), 0) : (!_vm.ruLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无新锐未入榜老师")]) : _vm._e(), _vm._v(" "), (_vm.ruTotal > _vm.ruPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.ruTotal,
      "current": _vm.ruPageIndex,
      "page-size": _vm.ruPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onRuPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showEmpty) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-trophy"
  }, [_vm._v("🏆")]), _vm._v(" "), _c('div', {
    staticClass: "empty-title"
  }, [_vm._v("本期暂无参评老师")]), _vm._v(" "), _c('div', {
    staticClass: "empty-sub"
  }, [_vm._v("可换个统计周期或放宽筛选后再看四块榜单。")])]) : _vm._e()], 2), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "计分规则",
      "width": "860",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ruleModal),
      callback: function($$v) {
        _vm.ruleModal = $$v
      },
      expression: "ruleModal"
    }
  }, [_c('p', {
    staticClass: "rule-head"
  }, [_vm._v("单项得分 = 权重 × 档位系数（A 1.0 / B 0.8 / C 0.6 / D 0.3 / E 0），满分 100。")]), _vm._v(" "), _c('div', {
    staticClass: "rule-title"
  }, [_vm._v("老老师（正式榜）")]), _vm._v(" "), _c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _vm._v(" "), _c('th', [_vm._v("方向")]), _vm._v(" "), _c('th', [_vm._v("权重")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("E")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ruleRows), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.weight))]), _vm._v(" "), _vm._l((item.grades), function(grade, idx) {
      return _c('td', {
        key: idx
      }, [_vm._v(_vm._s(grade))])
    })], 2)
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "rule-foot"
  }, [_vm._v("比较用未四舍五入的原始比值；星级无已评分课节按 B 档；Demo 出席成交率 ≥20% 为 A，其余（含无 Demo 出席）为 B；请假、临时请假、迟到、早退无分母按 A 档；全勤率、上课率无分母按 E 档。同分按有课课节数多者在前，再按老师 ID 升序。入榜门槛只对老老师生效：查询结束日所在自然周的买断课时 ≥ 20 节，与上课率里的买断课时同一算法。")]), _vm._v(" "), _c('div', {
    staticClass: "rule-title is-rookie"
  }, [_vm._v("新锐榜（开课 30 天内）")]), _vm._v(" "), _c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _vm._v(" "), _c('th', [_vm._v("方向")]), _vm._v(" "), _c('th', [_vm._v("权重")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("E")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rookieRuleRows), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.weight))]), _vm._v(" "), _vm._l((item.grades), function(grade, idx) {
      return _c('td', {
        key: idx
      }, [_vm._v(_vm._s(grade))])
    })], 2)
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "rule-foot"
  }, [_vm._v("开课时间在查询结束日往前 30 天内（含）的老师进新锐榜，不进正式榜。星级无已评分课节按 B 档；全勤率、上课率无数据按 A 档；请假、临时请假、迟到、早退、退费、返课未发生按 A 档。只用五档；退费 >3 人、返课 >8 记 E 档得 0、不出榜；结束日当周买断 < 20 进「新锐榜未入榜」。")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-title-wrap"
  }, [_c('div', {
    staticClass: "hero-kicker"
  }, [_vm._v("HELLOKID · TEACHER HALL OF FAME")]), _vm._v(" "), _c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("优秀外教排行榜")]), _vm._v(" "), _c('p', {
    staticClass: "hero-sub"
  }, [_vm._v("老老师：在职试用或正式、统计期内有课，结束日当周买断 ≥ 20 节才入榜，退费学生 > 3 或返课时 > 8 出榜不占名次")]), _vm._v(" "), _c('p', {
    staticClass: "hero-sub"
  }, [_vm._v("新老师：开课 30 天内、统计期内有课可入新锐榜；结束日当周买断 < 20 进未入榜；退费/返课"), _c('span', {
    staticClass: "hero-sub-keep"
  }, [_vm._v("不出榜")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title"
  }, [_vm._v("挑战者")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("\n      正式有名次（领奖台为 TOP3）；指标色带：\n      "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("A/B\n      "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("C\n      "), _c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("D/E\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-rookie"
  }, [_vm._v("新锐榜")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("开课 30 天内有名次老师；退费/返课不出榜")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-warn is-rookie-unranked"
  }, [_vm._v("新锐榜未入榜")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("结束日当周买断<20 不入新锐有名次；名单随上方统计周期变化")])])
}]}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("打卡分单")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择开始日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择结束日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Col', {
    attrs: {
      "span": 12,
      "class-name": "btn-group"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.manualAssign
    }
  }, [_vm._v("手动分配")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.moveUser
    }
  }, [_vm._v("移至公库")]), _vm._v(" "), (_vm.havePermission) ? _c('span', [(_vm.autoAssignTag === -1) ? _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.autoAssignOpen(1)
      }
    }
  }, [_vm._v("开启自动分配")]) : _vm._e(), _vm._v(" "), (_vm.autoAssignTag === 1) ? _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.autoAssignOpen(-1)
      }
    }
  }, [_vm._v("关闭自动分配")]) : _vm._e()], 1) : _c('span'), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.editAssignWeight
    }
  }, [_vm._v("编辑分配权重")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addMonthTarget
    }
  }, [_vm._v("添加月度目标")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "height": 680,
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userList/listPageData",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.showUserInfoModal,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "close": function($event) {
        _vm.showUserInfoModal = false
      }
    }
  }), _vm._v(" "), _c('manual-assign-modal', {
    attrs: {
      "value": _vm.showManualAssignModal,
      "userList": _vm.selectionUser,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showManualAssignModal = false
      }
    }
  }), _vm._v(" "), _c('edit-assign-weight-modal', {
    attrs: {
      "value": _vm.showEditAssingWeightModal,
      "userList": _vm.selectionUser,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEditAssingWeightModal = false
      }
    }
  }), _vm._v(" "), _c('add-month-target-modal', {
    attrs: {
      "value": _vm.showAddMonthTargetModal
    },
    on: {
      "on-close": function($event) {
        _vm.showAddMonthTargetModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加月度目标",
      "width": "800"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择课顾分组"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.formData.teamType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "teamType", $$v)
      },
      expression: "formData.teamType"
    }
  }, _vm._l((_vm.formData.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('ul', _vm._l((_vm.formData.adviserList), function(item) {
    return _c('li', [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": item.adviserName
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "单数"
      },
      on: {
        "on-change": _vm.onOrderChange
      },
      model: {
        value: (item.orderQuantity),
        callback: function($$v) {
          _vm.$set(item, "orderQuantity", $$v)
        },
        expression: "item.orderQuantity"
      }
    })], 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": "业绩"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "金额"
      },
      on: {
        "on-change": _vm.onOrderChange
      },
      model: {
        value: (item.amount),
        callback: function($$v) {
          _vm.$set(item, "amount", $$v)
        },
        expression: "item.amount"
      }
    })], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.confirmAssign
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "width": "700px"
    },
    on: {
      "on-ok": _vm.addStageReport
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "reportForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.reportRules
    }
  }, [_c('div', {
    staticClass: "evaluation"
  }, [_c('h3', [_vm._v("Periodical Evaluation Sheet")]), _vm._v(" "), _c('div', {
    staticClass: "pd10 border-btm"
  }, [_vm._v("\n        Congratulations to " + _vm._s(_vm.name) + " for having successfully completed the study of\n        "), _c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "prop": "lessonNum"
    },
    model: {
      value: (_vm.formData.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonNum", $$v)
      },
      expression: "formData.lessonNum"
    }
  }, [_c('Option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 40
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 60
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 80
    }
  }, [_vm._v("80")])], 1), _vm._v(" lessons\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 1: Vocabulary and key language points:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        (minimum 20 key words and 10 key sentences)\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partOneVocabulary"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partOneVocabulary"
    },
    model: {
      value: (_vm.formData.partOneVocabulary),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partOneVocabulary", $$v)
      },
      expression: "formData.partOneVocabulary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 2: Ability for use\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        1. Speaking\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student speaks like native speakers.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). Intonation\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). Speech fluency\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). Pronunciation accuracy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        4). Speaking pace\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above four aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoSpeaking"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoSpeaking"
    },
    model: {
      value: (_vm.formData.partTwoSpeaking),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoSpeaking", $$v)
      },
      expression: "formData.partTwoSpeaking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        2. Listening\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can understand and follow the teacher’s instructions or modelling.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments according to the above criteria (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoListening"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoListening"
    },
    model: {
      value: (_vm.formData.partTwoListening),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoListening", $$v)
      },
      expression: "formData.partTwoListening"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        3. Usage of Sentences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can use complete sentences, or better, compound sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). Comprehension of the sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). Output of complete sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). Clarity of expression\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        4). Grammatical accuracy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above four aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoSentences"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoSentences"
    },
    model: {
      value: (_vm.formData.partTwoSentences),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoSentences", $$v)
      },
      expression: "formData.partTwoSentences"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        4. Adaptability\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can adapt to an English only class quickly and feels comfortable.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). If the student actively speaks in classes.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). If the interaction between the student and the tutor is natural and comfortable.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). If the student can follow the classroom rules.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above three aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoAdaptability"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoAdaptability"
    },
    model: {
      value: (_vm.formData.partTwoAdaptability),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoAdaptability", $$v)
      },
      expression: "formData.partTwoAdaptability"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        5. Interaction with the teacher\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can respond to the teacher, whether verbally or using body language.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments according to the above criteria (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoInteraction"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoInteraction"
    },
    model: {
      value: (_vm.formData.partTwoInteraction),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoInteraction", $$v)
      },
      expression: "formData.partTwoInteraction"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 3: Teacher’s comments (at least 25 words)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Comments that the tutor will give (it should include at least two parts: Suggestions about English learning , comments and suggestions about classroom behaviors)：\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partThreeComments"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partThreeComments"
    },
    model: {
      value: (_vm.formData.partThreeComments),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partThreeComments", $$v)
      },
      expression: "formData.partThreeComments"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 4: Tutor’s feedback about student’s English level\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Tutor’s feedback about whether student English language ability suits for the current material level.\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partFourFeedback"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partFourFeedback"
    },
    model: {
      value: (_vm.formData.partFourFeedback),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partFourFeedback", $$v)
      },
      expression: "formData.partFourFeedback"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.addStageReport
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "学员基本信息",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "基本信息"
    }
  }, [_c('Form', {
    ref: "userInfoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.userRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 14,
      "sm": 8,
      "md": 14
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "英文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.enName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enName", $$v)
      },
      expression: "formData.enName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "密码："
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "name": "enName"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "中文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.cnName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnName", $$v)
      },
      expression: "formData.cnName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "年级："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.$constant.grade), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "生日："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", _vm._n($$v))
      },
      expression: "formData.birthday"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 10,
      "sm": 8,
      "md": 7
    }
  }, [_c('a', {
    on: {
      "click": _vm.openStudentPage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "生源地："
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.formData.province,
      "city": _vm.formData.city,
      "area": _vm.formData.block,
      "placeholders": _vm.placeholders
    },
    on: {
      "province": _vm.onSelectedProvince,
      "city": _vm.onSelectedCity,
      "area": _vm.onSelectedArea
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "英语学习经历："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.learnEnglishTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "learnEnglishTime", $$v)
      },
      expression: "formData.learnEnglishTime"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("不足三个月")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("一年左右")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一年以上")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("没有学习过英语")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "是否接触过外教："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.haveContactForeignTeacher),
      callback: function($$v) {
        _vm.$set(_vm.formData, "haveContactForeignTeacher", $$v)
      },
      expression: "formData.haveContactForeignTeacher"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "家庭经济情况："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.familyEconomicSituation),
      callback: function($$v) {
        _vm.$set(_vm.formData, "familyEconomicSituation", $$v)
      },
      expression: "formData.familyEconomicSituation"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("非常好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("不是很好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "是否重视英语学习："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.attentionEnglish),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attentionEnglish", $$v)
      },
      expression: "formData.attentionEnglish"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "接通状态："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "connectionStatus", $$v)
      },
      expression: "formData.connectionStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("未拨打")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("拨打未接")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("拨打接通")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "学生ID："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid))])])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "手机号码：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "号码对应人："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.phoneRole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phoneRole", $$v)
      },
      expression: "formData.phoneRole"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("父亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("母亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("其他")])])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("添加联系人")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "userContacts"
    }
  }, _vm._l((_vm.formData.userContacts), function(item, index) {
    return _c('div', [_c('Row', {
      attrs: {
        "gutter": 22
      }
    }, [_c('Form-item', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('i-col', {
      attrs: {
        "span": "10"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "姓名"
      },
      model: {
        value: (_vm.formData.userContacts[index].name),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "name", $$v)
        },
        expression: "formData.userContacts[index].name"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "10"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "手机号码",
        "number": true
      },
      model: {
        value: (_vm.formData.userContacts[index].mobile),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "mobile", $$v)
        },
        expression: "formData.userContacts[index].mobile"
      }
    })], 1), _vm._v(" "), _c('Button', {
      on: {
        "click": function($event) {
          return _vm.deleteContact(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "微信账号：",
      "prop": "weChat"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.formData.weChat),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weChat", $$v)
      },
      expression: "formData.weChat"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "地址："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "个人信息备注："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.infoRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "infoRemark", $$v)
      },
      expression: "formData.infoRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生来源标签")])], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label-width": 80,
      "label": "注册渠道："
    }
  }, [_c('Input', {
    attrs: {
      "name": "regType",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.regType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regType", $$v)
      },
      expression: "formData.regType"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "付费渠道："
    }
  }, _vm._l((_vm.$constant.studentTags), function(item) {
    return _c('RadioGroup', {
      model: {
        value: (_vm.formData.payCanal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "payCanal", $$v)
        },
        expression: "formData.payCanal"
      }
    }, [_c('Radio', {
      attrs: {
        "label": item.code
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课顾电话跟进")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("意向等级：")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.formData.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "intentLevel", $$v)
      },
      expression: "formData.intentLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("不论")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("高意向")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("意向一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("待跟进")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "height": "326px",
      "border-bottom": "1px dotted #ddd"
    },
    attrs: {
      "span": "9"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px",
      "margin-bottom": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生属性标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '学习经历') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("学习经历:\n                    "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '英语水平') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("英语水平:\n                  "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '孩子性格') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("孩子性格:\n                    "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '兴趣爱好') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("兴趣爱好:\n                  "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '老师要求') ? _c('span', {
      staticStyle: {
        "margin-left": "40px",
        "font-size": "15px"
      }
    }, [_vm._v("老师要求:\n                   "), (val != null) ? _c('span', _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    }), 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                     无\n                   ")])]) : _vm._e()
  }), 0)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "telephone"
  }, [_c('Button', {
    attrs: {
      "shape": "circle"
    },
    on: {
      "click": _vm.dialTel
    }
  })], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "i-columns": _vm.title,
      "data": _vm.telDetails
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticClass: "cancel",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "follow up"
    }
  }, [_c('Form', {
    ref: "followForm",
    staticClass: "form",
    attrs: {
      "model": _vm.followFormData,
      "rules": _vm.followRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.id) + " -- " + _vm._s(_vm.followFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.studyAdviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, _vm._l((_vm.followFormData.tchNames), function(tchName) {
    return _c('label', [_vm._v(_vm._s(tchName)), _c('br')])
  }), 0)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容：",
      "prop": "content",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.followFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "content", $$v)
      },
      expression: "followFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "traceStatus",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.followFormData.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceStatus", $$v)
      },
      expression: "followFormData.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50,
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.followFormData.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceItem", $$v)
      },
      expression: "followFormData.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.followFormData.traceStatus == 100 || _vm.followFormData.traceStatus == '100') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "label-width": 80
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100
    },
    model: {
      value: (_vm.followFormData.files),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "files", $$v)
      },
      expression: "followFormData.files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间：",
      "prop": "nextDate",
      "label-width": 80
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: (_vm.nextDate),
      callback: function($$v) {
        _vm.nextDate = $$v
      },
      expression: "nextDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 80
    }
  }, [_c('ElSwitch', {
    model: {
      value: (_vm.askForTch),
      callback: function($$v) {
        _vm.askForTch = $$v
      },
      expression: "askForTch"
    }
  })], 1), _vm._v(" "), (_vm.askForTch) ? [_c('Form-item', {
    attrs: {
      "label": "对学生描述：",
      "label-width": 80
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 3
    },
    model: {
      value: (_vm.followFormData.stuDescCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "stuDescCheckGroup", $$v)
      },
      expression: "followFormData.stuDescCheckGroup"
    }
  }, _vm._l((_vm.$constant.stuDesc), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 80
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 5
    },
    model: {
      value: (_vm.followFormData.askForTchCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "askForTchCheckGroup", $$v)
      },
      expression: "followFormData.askForTchCheckGroup"
    }
  }, _vm._l((_vm.$constant.askForTch), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFollow
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up记录")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.followtitle,
      "data": _vm.followData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "推荐老师"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openRecommendEdit
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('RecommendList', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uid": _vm.formData.uid,
      "listUrl": "/tchRecommend/list",
      "tableColumns": _vm.recommendTitle,
      "reset": _vm.reset,
      "data": _vm.recommendData
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "阶段报告"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.stageReportTitle,
      "data": _vm.stageReportData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "学生跟踪记录"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formValidate.files),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "files", $$v)
      },
      expression: "formValidate.files"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "track-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("记录属性")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('th', {
    staticClass: "next-handler-time-col"
  }, [_vm._v("下次联系日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系人")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": item.rowSpan,
        "hidden": item.hidden
      }
    }, [_vm._v(_vm._s(item.showName))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', [_c('TrackContentPreview', {
      attrs: {
        "content": item.content
      },
      on: {
        "view": function($event) {
          return _vm.openTrackContent(item)
        }
      }
    }, [(item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== '') ? _c('a', {
      staticStyle: {
        "margin-left": "8px"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.viewPic(item)
        }
      }
    }, [_vm._v("查看图片")]) : _vm._e()])], 1), _vm._v(" "), _c('td', {
      staticClass: "next-handler-time-col"
    }, [_c('span', {
      staticClass: "next-handler-time-text",
      attrs: {
        "title": _vm.formatNextHandlerTime(item)
      }
    }, [_vm._v(_vm._s(_vm.formatNextHandlerTime(item)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nextHandlerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createName))])])
  }), 0)]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.traceParam.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.traceParam.pageIndex,
      "pageSize": _vm.traceParam.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('RecommendTeacher', {
    attrs: {
      "value": _vm.recommendEdit,
      "uid": _vm.formData.uid
    },
    on: {
      "on-close": _vm.closeRecommendEdit
    }
  }), _vm._v(" "), _c('StageReportModal', {
    attrs: {
      "uid": _vm.formData.uid,
      "successCallback": _vm.reportList
    },
    model: {
      value: (_vm.StageReportModal),
      callback: function($$v) {
        _vm.StageReportModal = $$v
      },
      expression: "StageReportModal"
    }
  }), _vm._v(" "), _c('EvaluationSheetModal', {
    attrs: {
      "reprotId": _vm.reprotId,
      "successCallback": _vm.reportList
    },
    on: {
      "on-close": _vm.onEvaluationSheetModalClose
    },
    model: {
      value: (_vm.showEvaluationSheetModal),
      callback: function($$v) {
        _vm.showEvaluationSheetModal = $$v
      },
      expression: "showEvaluationSheetModal"
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('UserTrackContentModal', {
    ref: "trackContentModal"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Form', {
    attrs: {
      "label-position": "right",
      "label-width": 100
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "user",
      "label": "课顾分组："
    }
  }, [_c('Select', {
    attrs: {
      "disabled": _vm.adviserGroupSelectDisable
    },
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.teamType),
      callback: function($$v) {
        _vm.teamType = $$v
      },
      expression: "teamType"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "password",
      "label": "课程顾问："
    }
  }, [_c('Select', {
    attrs: {
      "disabled": _vm.adviserSelectDisable
    },
    on: {
      "on-change": _vm.onAdviserIdChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不论")]), _vm._v(" "), _vm._l((_vm.adviserList), function(item) {
    return _c('Option', {
      key: item.adviserId,
      attrs: {
        "value": item.adviserId
      }
    }, [_vm._v(_vm._s(item.adviserName) + "\n            ")])
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    ref: "store",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": _vm.placeNum,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('Option', {
      key: item.num,
      attrs: {
        "value": item.num
      }
    }, [_vm._v("\n          " + _vm._s('+' + item.num + ' ' + item.name.cn) + "\n  ")])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加反馈",
      "width": 600
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.tempLessonParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "多个老师用英文逗号隔开"
    },
    model: {
      value: (_vm.tempLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "tchId", $$v)
      },
      expression: "tempLessonParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈类型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChangeFeedBackType
    },
    model: {
      value: (_vm.tempLessonParam.feedBackType),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "feedBackType", _vm._n($$v))
      },
      expression: "tempLessonParam.feedBackType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "加开固定时间"
    }
  }, [_vm._v("加开固定时间")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "加开短期固定时间"
    }
  }, [_vm._v("加开短期固定时间")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "加开临时时间"
    }
  }, [_vm._v("加开临时时间")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "开绑定权限"
    }
  }, [_vm._v("开绑定权限")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "开临时约课权限"
    }
  }, [_vm._v("开临时约课权限")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "其他"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '其他') ? _c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "留言内容"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入留言内容"
    },
    model: {
      value: (_vm.tempLessonParam.otherContent),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "otherContent", $$v)
      },
      expression: "tempLessonParam.otherContent"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '开绑定权限') ? _c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请理由"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入开绑定权限的理由"
    },
    model: {
      value: (_vm.tempLessonParam.otherContent),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "otherContent", $$v)
      },
      expression: "tempLessonParam.otherContent"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '开临时约课权限') ? _c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请理由"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入开临时约课权限的理由"
    },
    model: {
      value: (_vm.tempLessonParam.otherContent),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "otherContent", $$v)
      },
      expression: "tempLessonParam.otherContent"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '加开固定时间' || _vm.tempLessonParam.feedBackType === '加开短期固定时间') ? _c('Form', {
    ref: "timeForm1",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule1
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择买断时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '加开短期固定时间') ? _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "截止有效期",
      "clearable": false,
      "value": _vm.timeParam.endDateStr
    },
    on: {
      "on-change": _vm.onChangeEndDate
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime1
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '加开固定时间' || _vm.tempLessonParam.feedBackType === '加开短期固定时间') ? _c('Form', {
    ref: "timeListForm1",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule1
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "19"
      }
    }, [_c('label', [_c('b', [_vm._v("时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,    生效日期：" + _vm._s(item.useDateStr)), (_vm.tempLessonParam.feedBackType === '加开短期固定时间') ? _c('span', [_vm._v(" ,    截止有效期：" + _vm._s(item.endDateStr))]) : _vm._e()])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '加开临时时间') ? _c('Form', {
    ref: "timeForm2",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.timeParam,
      "rules": _vm.timeRule2
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择上课时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "day"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value": _vm.timeParam.dayStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 3
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime2
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType === '加开临时时间') ? _c('Form', {
    ref: "timeListForm2",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": {},
      "rules": _vm.timeListRule2
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "7"
      }
    }, [_c('label', [_c('b', [_vm._v(_vm._s(item.dayStr) + " " + _vm._s(item.startTimeStr) + "-" + _vm._s(item.endTimeStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempLessonParam.feedBackType !== '其他' && _vm.tempLessonParam.feedBackType !== '开绑定权限' && _vm.tempLessonParam.feedBackType !== '开临时约课权限') ? _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教留言"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 500,
      "placeholder": "选填，输入留言给外教，支持中文自动翻译"
    },
    model: {
      value: (_vm.tempLessonParam.feedRemark),
      callback: function($$v) {
        _vm.$set(_vm.tempLessonParam, "feedRemark", $$v)
      },
      expression: "tempLessonParam.feedRemark"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": false
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "/course/classinFolder"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.getFolderTop()
      }
    }
  }, [_vm._v("Classin文件目录")])]), _vm._v(" "), _vm._l((_vm.accountList), function(item, index) {
    return _c('Breadcrumb-item', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.queryAgentMember(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "folder"
  }, [_c('Form', {
    attrs: {
      "label-width": 60
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "md": 3
    }
  }, [(_vm.state) ? _c('div', {
    staticClass: "file",
    attrs: {
      "onLoading": _vm.onLoading
    },
    on: {
      "dblclick": _vm.onSearchTop
    }
  }, [_c('Icon', {
    attrs: {
      "type": "folder",
      "size": "100"
    }
  }), _vm._v(" "), _c('p', [_vm._v("classin目录")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    attrs: {
      "align": "center"
    }
  }, [_vm._l((_vm.folderList), function(item) {
    return _c('li', {
      staticClass: "file",
      on: {
        "dblclick": function($event) {
          return _vm.getFolderId(item.folderId, item.folderName)
        }
      }
    }, [_c('i-col', {
      attrs: {
        "span": 3
      }
    }, [_c('Icon', {
      attrs: {
        "type": "folder",
        "size": "70"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.folderId) + " -- " + _vm._s(item.folderName))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.fileList), function(item) {
    return (!_vm.state) ? _c('li', [_c('i-col', {
      attrs: {
        "span": 3
      }
    }, [_c('Icon', {
      attrs: {
        "type": "document-text",
        "size": "70"
      }
    }), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.id) + " --" + _vm._s(item.fileName))])], 1)], 1) : _vm._e()
  })], 2)], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "label": _vm.label,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.teacherList), function(teacher) {
    return _c('Option', {
      key: teacher.id,
      attrs: {
        "value": teacher.id
      }
    }, [_vm._v("\n    " + _vm._s(teacher.id) + " - " + _vm._s(teacher.firstName) + " " + _vm._s(teacher.lastName) + " -\n    " + _vm._s(teacher.email) + "\n  ")])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "查看上课情况",
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.activityList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.id + ' - ' + item.firstName + item.lastName))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-copy"
  }, [_c('p', [_vm._v("2017-2020 © QU BOPS")])])
}]}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑短期固定时间",
      "width": 650
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": _vm.timeParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 26
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择短期固定时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "week"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": ""
    },
    model: {
      value: (_vm.timeParam.week),
      callback: function($$v) {
        _vm.$set(_vm.timeParam, "week", $$v)
      },
      expression: "timeParam.week"
    }
  }, _vm._l((_vm.$constant.week), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 30],
      "value": _vm.timeParam.startTimeStr
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 30],
      "value": _vm.timeParam.endTimeStr
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "useDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "生效日期",
      "clearable": false,
      "value": _vm.timeParam.useDateStr
    },
    on: {
      "on-change": _vm.onChangeUseDate
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "截至有效期",
      "clearable": false,
      "value": _vm.timeParam.endDateStr
    },
    on: {
      "on-change": _vm.onChangeEndDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "disabled": _vm.timeParam.startTime >= _vm.timeParam.endTime
    },
    on: {
      "click": _vm.addOpenedTime
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "timeListForm",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "model": {},
      "rules": _vm.timeListRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: item.week
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "19"
      }
    }, [_c('label', [_c('b', [_vm._v("时间：" + _vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr) + " ,    生效日期：" + _vm._s(item.useDateStr) + " ,    截至有效期：" + _vm._s(item.endDateStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": false
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-报名失败记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _c('div', [_vm._v("报名失败原因：")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.teacherReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "teacherReason", $$v)
      },
      expression: "formValidate.teacherReason"
    }
  }, [_vm._v("老师原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.equipmentReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "equipmentReason", $$v)
      },
      expression: "formValidate.equipmentReason"
    }
  }, [_vm._v("设备原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.netReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "netReason", $$v)
      },
      expression: "formValidate.netReason"
    }
  }, [_vm._v("网络原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.highPrice),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "highPrice", $$v)
      },
      expression: "formValidate.highPrice"
    }
  }, [_vm._v("价格偏高")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.registerOtherAgencies),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "registerOtherAgencies", $$v)
      },
      expression: "formValidate.registerOtherAgencies"
    }
  }, [_vm._v("已报名其它机构")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.likeShortTermCourse),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "likeShortTermCourse", $$v)
      },
      expression: "formValidate.likeShortTermCourse"
    }
  }, [_vm._v("意向短期课程")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.contrastiveCompetition),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contrastiveCompetition", $$v)
      },
      expression: "formValidate.contrastiveCompetition"
    }
  }, [_vm._v("对比竞品")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.inThinking),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "inThinking", $$v)
      },
      expression: "formValidate.inThinking"
    }
  }, [_vm._v("考虑中")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.childNotCooperate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "childNotCooperate", $$v)
      },
      expression: "formValidate.childNotCooperate"
    }
  }, [_vm._v("孩子不配合")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.worryEffect),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "worryEffect", $$v)
      },
      expression: "formValidate.worryEffect"
    }
  }, [_vm._v("担心效果")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.lossOfUnion),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "lossOfUnion", $$v)
      },
      expression: "formValidate.lossOfUnion"
    }
  }, [_vm._v("学员失联")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "其它/备注"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.specialRemark),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "specialRemark", $$v)
      },
      expression: "formValidate.specialRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑作品信息"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          学生：" + _vm._s(_vm.userVideoParams.uid) + "-" + _vm._s(_vm.userVideoParams.nickname) + "\n        ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.title),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "title", $$v)
      },
      expression: "userVideoParams.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "ageGroup"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.userVideoParams.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "ageGroup", _vm._n($$v))
      },
      expression: "userVideoParams.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生作品",
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    ref: "videoUpload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoChange,
      "on-success": _vm.videoSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.videoExceed,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "disabled": !_vm.formReady,
      "accept": "video/*",
      "limit": 1,
      "file-list": _vm.videoFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.formReady
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品封面",
      "prop": "videoPicUrl"
    }
  }, [_c('el-upload', {
    ref: "videoPicUpload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoPicChange,
      "on-success": _vm.videoPicSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.videoPicExceed,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "disabled": !_vm.formReady,
      "accept": "image/*",
      "limit": 1,
      "file-list": _vm.videoPicFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.formReady
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抖音链接",
      "prop": "douyinUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "抖音分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.douyinUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "douyinUrl", $$v)
      },
      expression: "userVideoParams.douyinUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.douyinUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('douyin')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "小红书链接",
      "prop": "xhsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "小红书分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.xhsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "xhsUrl", $$v)
      },
      expression: "userVideoParams.xhsUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.xhsUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('xhs')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "视频号链接",
      "prop": "channelsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "视频号分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.channelsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "channelsUrl", $$v)
      },
      expression: "userVideoParams.channelsUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.channelsUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('channels')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.userVideoParams.svSyncStatus != null) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同步状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.syncStatusText))]), _vm._v(" "), (_vm.userVideoParams.svAuthor) ? _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("作者：" + _vm._s(_vm.userVideoParams.svAuthor))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("合计 赞" + _vm._s(_vm.userVideoParams.svLikeCount || 0) + " / 藏" + _vm._s(_vm.userVideoParams.svCollectCount || 0) + " / 评" + _vm._s(_vm.userVideoParams.svCommentCount || 0))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.svTasks.length) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "平台抓取"
    }
  }, _vm._l((_vm.svTasks), function(task) {
    return _c('div', {
      key: task.platform
    }, [_c('span', [_vm._v(_vm._s(_vm.platformText(task.platform)) + "：" + _vm._s(_vm.taskStatusText(task.status)))]), _vm._v(" "), (task.author) ? _c('span', {
      staticStyle: {
        "margin-left": "12px"
      }
    }, [_vm._v("作者：" + _vm._s(task.author))]) : _vm._e(), _vm._v(" "), (task.coverUrl) ? _c('viewer', {
      staticStyle: {
        "display": "inline-block",
        "margin-left": "12px",
        "vertical-align": "middle"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "28px",
        "height": "28px",
        "object-fit": "cover",
        "cursor": "pointer",
        "vertical-align": "middle"
      },
      attrs: {
        "src": _vm.mediaUrl(task.coverUrl),
        "alt": "封面"
      }
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "12px"
      }
    }, [_vm._v("赞" + _vm._s(task.likeCount || 0) + " / 藏" + _vm._s(task.collectCount || 0) + " / 评" + _vm._s(task.commentCount || 0))]), _vm._v(" "), (task.status === 'fail' && task.errorMsg) ? _c('span', {
      staticStyle: {
        "margin-left": "12px",
        "color": "#ed4014"
      }
    }, [_vm._v("失败原因：" + _vm._s(task.errorMsg))]) : _vm._e()], 1)
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning",
      "size": "large",
      "loading": _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo()
      }
    }
  }, [_vm._v("全部抓取")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditModal,
      "disabled": !_vm.formReady
    },
    on: {
      "click": _vm.editUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加上课时间",
      "width": "600"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "timeForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.timeParam,
      "rules": _vm.timeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择上课时间",
      "prop": "openedTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "day"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value": _vm.timeParam.dayStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeDate
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "开始时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.startTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeStratTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "结束时间",
      "clearable": false,
      "steps": [1, 5],
      "value": _vm.timeParam.endTimeStr,
      "onfocus": false
    },
    on: {
      "on-change": _vm.onChangeEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 3
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addOpenedTime
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "timeListForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": {},
      "rules": _vm.timeListRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择时间",
      "prop": "openedTimeList"
    }
  }, [_c('Row', _vm._l((_vm.openedTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "offset": "1",
        "span": "7"
      }
    }, [_c('label', [_c('b', [_vm._v(_vm._s(item.dayStr) + " " + _vm._s(item.startTimeStr) + "-" + _vm._s(item.endTimeStr))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeOpenedTime(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("添加")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("周数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周时间"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10"
    },
    model: {
      value: (_vm.queryParam.periodLabel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "periodLabel", $$v)
      },
      expression: "queryParam.periodLabel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [20, 50, 100]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师上课记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("上课异常列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 75
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lsnType", _vm._n($$v))
      },
      expression: "queryParam.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bc/listAbsentStudent",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('LessonMemberTimeModal', {
    attrs: {
      "openedId": _vm.openId
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售名单利用统计")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-position": "left",
      "label-width": 80
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "获得名单日期:",
      "label-width": 100
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value": _vm.defaultData,
      "placement": "bottom-start"
    },
    on: {
      "on-change": _vm.getTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "截止日期:"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value": _vm.expiration,
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.stopTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择销售:"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "查看方式:"
    }
  }, [_c('Radio-group', {
    model: {
      value: (_vm.queryParam.personage),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "personage", $$v)
      },
      expression: "queryParam.personage"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("按个人查看")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("按分组查看")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n                      ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n            ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.showSummaryData
    }
  }, [_vm._v("查看汇总结果\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.table,
      "listUrl": "/data/report/queryadviserdata",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload,
      "pageSize": "50"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "规则"
    },
    model: {
      value: (_vm.tableRulePrompt),
      callback: function($$v) {
        _vm.tableRulePrompt = $$v
      },
      expression: "tableRulePrompt"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.tableRulePromptContent) + "\n          "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.onLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "查看汇总结果"
    },
    model: {
      value: (_vm.showSummaryDataModal),
      callback: function($$v) {
        _vm.showSummaryDataModal = $$v
      },
      expression: "showSummaryDataModal"
    }
  }, [_c('div', [_vm._v("【注册名单数】 " + _vm._s(_vm.summaryData.totalNum))]), _vm._v(" "), _c('div', [_vm._v("【邀约数】" + _vm._s(_vm.summaryData.totalInviteNum))]), _vm._v(" "), _c('div', [_vm._v("【出席数】" + _vm._s(_vm.summaryData.totalAttendNum))]), _vm._v(" "), _c('div', [_vm._v("【成交数】" + _vm._s(_vm.summaryData.totalTransactionsNum))]), _vm._v(" "), _c('div', [_vm._v("【邀约率】" + _vm._s(_vm.summaryData.inviteRatio) + "%")]), _vm._v(" "), _c('div', [_vm._v("【出席率】" + _vm._s(_vm.summaryData.attendRatio) + "%")]), _vm._v(" "), _c('div', [_vm._v("【成交率】" + _vm._s(_vm.summaryData.transactionsRatio) + "%")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "学生课时",
      "width": "1100"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("新外教跟进")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    规则：新外教入职满 "), _c('b', [_vm._v(_vm._s(_vm.rules.reviewDays))]), _vm._v(" 天触发一次回访（节点日 = 入职日 + " + _vm._s(_vm.rules.reviewDays) + " 天）；节点前\n    "), _c('b', [_vm._v(_vm._s(_vm.rules.reviewAlertDays))]), _vm._v(" 天开始提示，逾期未登记持续提醒。入职早于 "), _c('b', [_vm._v(_vm._s(_vm.rules.reviewStartDate || '—'))]), _vm._v(" 的老师不进清单。\n    "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/hrWorkbench/settings')
      }
    }
  }, [_vm._v("调整规则")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', {
    staticClass: "seg"
  }, _vm._l((_vm.levelTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.level === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeLevel(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + " " + _vm._s(_vm.counts[item.value] || 0) + "\n      ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-total"
  }, [_vm._v("共 " + _vm._s(_vm.dataList.length) + " 人")]), _vm._v(" "), _c('Button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": "",
      "row-class-name": _vm.rowClassName,
      "no-data-text": "当前筛选下无回访对象"
    }
  })], 1), _vm._v(" "), _c('review-save-modal', {
    attrs: {
      "value": _vm.showReview,
      "row": _vm.currentRow
    },
    on: {
      "on-close": function($event) {
        _vm.showReview = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [_c('p', {
    staticClass: "schedule-desc"
  }, [_vm._v("可单选或同时勾选面试与试讲，分别选择日期时间。")]), _vm._v(" "), _c('div', {
    staticClass: "schedule-box"
  }, [_c('div', {
    staticClass: "schedule-row"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.useInterview),
      callback: function($$v) {
        _vm.useInterview = $$v
      },
      expression: "useInterview"
    }
  }, [_vm._v("面试")]), _vm._v(" "), (_vm.useInterview) ? _c('DatePicker', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value": _vm.interviewTime,
      "placeholder": "选择面试日期与时间",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.interviewTime = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "schedule-row"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.useDemo),
      callback: function($$v) {
        _vm.useDemo = $$v
      },
      expression: "useDemo"
    }
  }, [_vm._v("试讲")]), _vm._v(" "), (_vm.useDemo) ? _c('DatePicker', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value": _vm.demoTime,
      "placeholder": "选择试讲日期与时间",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.demoTime = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.useInterview && !_vm.useDemo) ? _c('p', {
    staticClass: "schedule-warn"
  }, [_vm._v("请至少勾选「面试」或「试讲」")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "disabled": !_vm.useInterview && !_vm.useDemo
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确认安排")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list disk-share-records"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("网盘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分享记录")])], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.list,
      "loading": _vm.loading,
      "no-data-text": "还没有分享记录"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "详细记录",
      "width": "720"
    },
    model: {
      value: (_vm.showLog),
      callback: function($$v) {
        _vm.showLog = $$v
      },
      expression: "showLog"
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.logColumns,
      "data": _vm.logList,
      "loading": _vm.logLoading,
      "no-data-text": "还没有预览或下载"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', _vm._l((_vm.columns), function(column) {
    return _c('td', [_c('timetable-cell', {
      attrs: {
        "column": column,
        "row": _vm.row,
        "activeId": _vm.activeId,
        "types": _vm.types
      },
      on: {
        "hover-active": _vm.onActive
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-credential-page"
  }, [_c('div', {
    ref: "printContent",
    staticClass: "credential-card"
  }, [_c('h1', {
    staticClass: "credential-title"
  }, [_vm._v("Hellokid 課程購買憑據")]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("課程方案資料")]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("訂單編號：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.orderNum))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("購買日期：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("學員ID：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.userId))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("學員姓名：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.nickName))])])])]), _vm._v(" "), _c('table', {
    staticClass: "detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("基礎方案")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.basePlanDetail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.amount) + " " + _vm._s(_vm.currencyLabel))])]), _vm._v(" "), (_vm.hasActivity) ? _c('tr', [_c('td', [_vm._v("活動明細")]), _vm._v(" "), _c('td', [_c('ul', {
    staticClass: "activity-list"
  }, [(_vm.discountNum > 0) ? _c('li', [_vm._v("• " + _vm._s(_vm.discountNum) + "節一對一外教課")]) : _vm._e(), _vm._v(" "), (_vm.discount > 0) ? _c('li', [_vm._v("• 現金優惠" + _vm._s(_vm.discount) + _vm._s(_vm.currencyLabel))]) : _vm._e()])]), _vm._v(" "), _c('td', [_vm._v("—")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', [_vm._v("合計")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalLessons))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payAmount) + " " + _vm._s(_vm.currencyLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("確認資料")]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-item signer-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("簽單人：")]), _vm._v(" "), _c('div', {
    staticClass: "signer-name-block"
  }, [_c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.createUser))]), _vm._v(" "), _c('img', {
    staticClass: "company-seal",
    attrs: {
      "src": "/static/bangder-seal.jpg",
      "alt": "公章"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credential-toolbar not-print"
  }, [_c('div', {
    staticClass: "toolbar_inbox"
  }, [_c('button', {
    staticClass: "toolbtn",
    on: {
      "click": _vm.printWeb
    }
  }, [_vm._v("打印本憑據")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-project"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "col-detail"
  }, [_vm._v("詳情")]), _vm._v(" "), _c('th', {
    staticClass: "col-total"
  }, [_vm._v("合計總金額")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("開票單位：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v("香港邦德爾科技有限公司")])])
}]}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师跟踪记录列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外管："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.adminName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminName", $$v)
      },
      expression: "queryParam.adminName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.trackType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "trackType", _vm._n($$v))
      },
      expression: "queryParam.trackType"
    }
  }, _vm._l((_vm.$constant.tchTrackRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "处理人："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.modifierName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "modifierName", $$v)
      },
      expression: "queryParam.modifierName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师名称："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师手机号："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchTrack/recordList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学情反馈")])], 1)], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.svcTab),
      callback: function($$v) {
        _vm.svcTab = $$v
      },
      expression: "svcTab"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "新生服务",
      "name": "new"
    }
  }), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "老生服务",
      "name": "old"
    }
  }), _vm._v(" "), (!_vm.isStudyAdviser) ? _c('TabPane', {
    attrs: {
      "label": "进度展示",
      "name": "progress"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.svcTab !== 'progress'),
      expression: "svcTab !== 'progress'"
    }],
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid",
      "placeholder": "精确学生ID"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser",
      "disabled": _vm.isStudyAdviser
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), (_vm.svcTab === 'old') ? _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "服务状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.served),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "served", $$v)
      },
      expression: "queryParam.served"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已服务")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("待服务")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.svcTab === 'old') ? _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "服务日期"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": "",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.changeServiceDate
    },
    model: {
      value: (_vm.serviceDateRange),
      callback: function($$v) {
        _vm.serviceDateRange = $$v
      },
      expression: "serviceDateRange"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.svcTab === 'old') ? _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课件"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "Level"
    },
    on: {
      "on-change": _vm.changeMaterialLevel
    },
    model: {
      value: (_vm.queryParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelId", _vm._n($$v))
      },
      expression: "queryParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: 'lv-' + item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "Lesson"
    },
    model: {
      value: (_vm.queryParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonId", _vm._n($$v))
      },
      expression: "queryParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: 'ls-' + item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.id) + "-" + _vm._s(item.title) + "\n                  ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "剩余课时"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "最低"
    },
    model: {
      value: (_vm.queryParam.leftHourMin),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "leftHourMin", $$v)
      },
      expression: "queryParam.leftHourMin"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "old-hour-split",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "最高"
    },
    model: {
      value: (_vm.queryParam.leftHourMax),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "leftHourMax", $$v)
      },
      expression: "queryParam.leftHourMax"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.svcTab === 'new'),
      expression: "svcTab === 'new'"
    }],
    staticClass: "new-svc-table"
  }, [_c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/user/new-student-service/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "pageSize": 20
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.svcTab === 'old'),
      expression: "svcTab === 'old'"
    }],
    staticClass: "old-svc-table"
  }, [(_vm.svcTab === 'old') ? _c('div', {
    staticClass: "statistics"
  }, [_vm._v("\n      服务进度："), _c('label', [_vm._v(_vm._s(_vm.servedCount) + "/" + _vm._s(_vm.studentTotal))])]) : _vm._e(), _vm._v(" "), (_vm.svcTab === 'old') ? _c('List', {
    ref: "oldDataList",
    attrs: {
      "tableColumns": _vm.oldTitle,
      "reload": _vm.oldReload,
      "reloadWithPage": _vm.oldReloadWithPage,
      "listUrl": "/user/new-student-service/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "pageSize": 20
    },
    on: {
      "on-sort-change": _vm.handleOldSortChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.svcTab === 'progress'),
      expression: "svcTab === 'progress'"
    }],
    staticClass: "progress-svc-table"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.progressTitle,
      "data": _vm.progressData,
      "loading": _vm.progressLoading
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.editTitle,
      "mask-closable": false,
      "transfer": ""
    },
    on: {
      "on-ok": _vm.confirmEdit,
      "on-cancel": _vm.closeEdit
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6,
      "placeholder": "请填写"
    },
    model: {
      value: (_vm.editValue),
      callback: function($$v) {
        _vm.editValue = $$v
      },
      expression: "editValue"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Menu', {
    ref: "sideMenu",
    staticClass: "left-menu",
    attrs: {
      "theme": _vm.theme,
      "activeName": _vm.currentMenu,
      "openNames": _vm.openNames,
      "width": "210px",
      "accordion": false
    },
    on: {
      "on-open-change": _vm.onOpenChange,
      "on-select": _vm.onSelect
    }
  }, [_vm._l((_vm.menuGroups), function(menuGroup) {
    return [(menuGroup.hasPermission) ? [(!menuGroup.url) ? _c('Submenu', {
      attrs: {
        "name": menuGroup.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(menuGroup.icon) ? _c('Icon', {
      attrs: {
        "type": menuGroup.icon
      }
    }) : _vm._e(), _vm._v("\n          " + _vm._s(menuGroup.name) + "\n        ")], 1), _vm._v(" "), _vm._l((menuGroup.menuItems), function(menuItem) {
      return [(menuItem.hasPermission && menuItem.subItems) ? _c('Submenu', {
        key: 'sub-' + menuItem.name,
        attrs: {
          "name": menuItem.name
        }
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _vm._l((menuItem.subItems), function(child) {
        return (child.hasPermission) ? _c('Menu-item', {
          key: child.name,
          attrs: {
            "name": child.name
          }
        }, [_vm._v("\n              " + _vm._s(child.name)), (_vm.hrBadgeCount(child)) ? _c('span', {
          staticClass: "hr-menu-badge"
        }, [_vm._v(_vm._s(_vm.hrBadgeCount(child)))]) : _vm._e()]) : _vm._e()
      })], 2) : (menuItem.hasPermission) ? _c('Menu-item', {
        key: menuItem.name,
        attrs: {
          "name": menuItem.name
        }
      }, [_vm._v("\n            " + _vm._s(menuItem.name)), (_vm.hrBadgeCount(menuItem)) ? _c('span', {
        staticClass: "hr-menu-badge"
      }, [_vm._v(_vm._s(_vm.hrBadgeCount(menuItem)))]) : _vm._e()]) : _vm._e()]
    })], 2) : _c('Menu-item', {
      attrs: {
        "name": menuGroup.name
      }
    }, [_vm._v("\n        " + _vm._s(menuGroup.name) + "\n      ")])] : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "header"
  }, [_c('tr', [_vm._l((_vm.columns), function(item) {
    return [(item.hour) ? _c('th', [_c('span', [_vm._v(_vm._s(item.hour) + ":00")]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, _vm._l((12), function(i) {
      return _c('i')
    }), 0)]) : _c('th', [_vm._v(_vm._s(item.title))])]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.column.hour) ? _c('div', {
    staticClass: "timetable-cell"
  }, [_vm._l((_vm.bookTchOpenedTimeList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        opended: true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "买断时间",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 买断时间")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.startTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.endTimeStr))]), _vm._v(" "), _c('li', [_vm._v("课时: " + _vm._s(item.duration))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.statusText))]), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), _c('i')])], 1)]
  }), _vm._v(" "), _vm._l((_vm.bookTchShortTermOpenedTimeList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        'short-term': true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "短期固定时间",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 短期固定时间")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.startTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.endTimeStr))]), _vm._v(" "), _c('li', [_vm._v("课时: " + _vm._s(item.duration))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.statusText))]), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), _c('i')])], 1)]
  }), _vm._v(" "), _vm._l((_vm.tchScheduleBookLessonOpenedDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        schedule: true,
        'student-leave': item.lsnSelStatus === 4,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "常规课",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 常规课")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.lsnBeginTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.lsnEndTimeStr))]), _vm._v(" "), _c('li', [_vm._v("学生: " + _vm._s(item.userNickname) + " - " + _vm._s(item.uId))]), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.lsnSelStatusText))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), (item.uid) ? _c('li', [_vm._v("学员id: " + _vm._s(item.uid))]) : _vm._e(), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), (item.lsnSelStatus === 4) ? _c('i', [_vm._v("(假)" + _vm._s(item.userNickname))]) : _vm._e(), _vm._v(" "), (item.isChange === 1) ? _c('i', [_vm._v("(替)" + _vm._s(item.userNickname))]) : _c('i', [_vm._v(_vm._s(item.userNickname))])])], 1)]
  }), _vm._v(" "), _vm._l((_vm.bookTchRandomPartnerTimeDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        partner: true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "陪练课",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 陪练课")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.lsnBeginTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.lsnEndTimeStr))]), _vm._v(" "), _c('li', [_vm._v("学生: " + _vm._s(item.userNickname) + " - " + _vm._s(item.uId))]), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.lsnSelStatusText))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), (item.uid) ? _c('li', [_vm._v("学员id: " + _vm._s(item.uid))]) : _vm._e(), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), (item.lsnSelStatus === 4) ? _c('i', [_vm._v("(假)" + _vm._s(item.userNickname))]) : _vm._e(), _vm._v(" "), (item.isChange === 1) ? _c('i', [_vm._v("(替)" + _vm._s(item.userNickname))]) : _c('i', [_vm._v(_vm._s(item.userNickname))])])], 1)]
  }), _vm._v(" "), _vm._l((_vm.tchScheduleBookLessonTestOpenedDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        test: true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "试听课",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 试听课")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.lsnBeginTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.lsnEndTimeStr))]), _vm._v(" "), _c('li', [_vm._v("学生: " + _vm._s(item.userNickname) + " - " + _vm._s(item.uId))]), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.statusText))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), _c('i', [_vm._v(_vm._s(item.userNickname))])])], 1)]
  }), _vm._v(" "), _vm._l((_vm.bookWorkLessonOpenedTimeDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        'book-work': true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "绑定课",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 绑定课")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.startTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.endTimeStr))]), _vm._v(" "), _c('li', [_vm._v("学生: " + _vm._s(item.nickname) + " - " + _vm._s(item.uid))]), _vm._v(" "), (item.studyAdviserNickName) ? _c('li', [_vm._v("学习顾问: " + _vm._s(item.studyAdviserNickName))]) : _vm._e(), _vm._v(" "), (item.adviserNickName) ? _c('li', [_vm._v("课程顾问: " + _vm._s(item.adviserNickName))]) : _vm._e(), _vm._v(" "), (item.tchStudyAdviserName) ? _c('li', [_vm._v("外管: " + _vm._s(item.tchStudyAdviserName))]) : _vm._e(), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), (item.isLeave === 'y') ? _c('i', [_vm._v("(假)" + _vm._s(item.nickname))]) : _c('i', [_vm._v(_vm._s(item.nickname))])])], 1)]
  }), _vm._v(" "), _vm._l((_vm.bookTchRandomOpenedTimeDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        'free': true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "空课",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 空课")]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.startTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.endTimeStr))]), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.statusText))]), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), _c('i')])], 1)]
  }), _vm._v(" "), _vm._l((_vm.bookTchLeaveTimeDtoList), function(item) {
    return [_c('div', {
      staticClass: "poptip",
      class: {
        'leave': true,
        active: item.id === _vm.activeId
      },
      style: ({
        left: item.startIndex / 12 * 100 + '%',
        width: item.colspan / 12 * 100 + '%'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(item)
        },
        "mouseout": _vm.onMouseOut
      }
    }, [_c('Poptip', {
      attrs: {
        "title": "老师请假",
        "placement": "top",
        "trigger": "hover",
        "delay": _vm.delay,
        "transfer": "",
        "append-to-body": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('li', [_vm._v("类型: 老师请假")]), _vm._v(" "), _c('li', [_vm._v("老师: " + _vm._s(item.tchFirstName) + " " + _vm._s(item.tchLastName))]), _vm._v(" "), _c('li', [_vm._v("开始时间: " + _vm._s(item.startTimeStr))]), _vm._v(" "), _c('li', [_vm._v("结束时间: " + _vm._s(item.endTimeStr))]), _vm._v(" "), _c('li', [_vm._v("时长: " + _vm._s(item.duration) + " 分钟")]), _vm._v(" "), _c('li', [_vm._v("状态: " + _vm._s(item.statusText))]), _vm._v(" "), (item.remark) ? _c('li', [_vm._v("备注: " + _vm._s(item.remark))]) : _vm._e()])]), _vm._v(" "), _c('i')])], 1)]
  })], 2) : (_vm.column.render) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('render-cell', {
    attrs: {
      "params": _vm.row,
      "render": _vm.column.render
    }
  })], 1) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.row[_vm.column.key]) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("数据中心")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学导跟进数据")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("\n      【外教课耗:】"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.details.totalRoutineNum))]), _vm._v("\n      【中教课耗:】"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.details.totalChineseNum))]), _vm._v("\n      【陪练课耗:】"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.details.totalPartnerNum))]), _vm._v("\n      【辅修课耗:】"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.details.totalMinorNum))]), _vm._v(" "), _vm._v("\n      【试听课数:】"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.details.totalAuditionNum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTimeStr),
      callback: function($$v) {
        _vm.startTimeStr = $$v
      },
      expression: "startTimeStr"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTimeStr),
      callback: function($$v) {
        _vm.endTimeStr = $$v
      },
      expression: "endTimeStr"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导："
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/adminUser/listStudyAdviserData",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生评价补充"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "feedback form",
    attrs: {
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "投诉补充"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.reason))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("官网活动")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生作品管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "userId"
    },
    model: {
      value: (_vm.queryParam.userId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userId", $$v)
      },
      expression: "queryParam.userId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号后六位"
    }
  }, [_c('Input', {
    attrs: {
      "name": "cardId"
    },
    model: {
      value: (_vm.queryParam.cardId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "cardId", $$v)
      },
      expression: "queryParam.cardId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "title"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属赛区"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.competitionArea),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "competitionArea", _vm._n($$v))
      },
      expression: "queryParam.competitionArea"
    }
  }, _vm._l((_vm.$constant.competitionAreaEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄分组"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageGroup", _vm._n($$v))
      },
      expression: "queryParam.ageGroup"
    }
  }, _vm._l((_vm.$constant.ageGroupEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "goNextPhase"
    },
    on: {
      "click": _vm.goNextPhase
    }
  }, [_vm._v("进入下一阶段")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/safenessUserVideo/pageList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('EditUserVideoModal', {
    attrs: {
      "value": _vm.showEditUserVideoModal,
      "itemId": _vm.itemId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEditUserVideoModal = false
      },
      "on-edit-clearid": _vm.clearid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("试听课预缺席记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": 10
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "缺席原因:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.absentReason
    },
    on: {
      "on-select-change": _vm.onAbsentReasonChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "其他/备注"
    },
    model: {
      value: (_vm.formData.otherReason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherReason", $$v)
      },
      expression: "formData.otherReason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.formData.nextTimeDate
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.$constant.handlerType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v(_vm._s(_vm.subText))])]), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), (_vm.chips && _vm.chips.length) ? _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("补课时记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('Col', [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminNickname"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adminMobile"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userMobile"
    },
    model: {
      value: (_vm.queryParam.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userMobile", $$v)
      },
      expression: "queryParam.userMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.$constant.bookCourseChangeStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠课类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeGivingType
    },
    model: {
      value: (_vm.queryParam.givingType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "givingType", _vm._n($$v))
      },
      expression: "queryParam.givingType"
    }
  }, _vm._l((_vm.$constant.givingType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.givingTypeChild),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "givingTypeChild", _vm._n($$v))
      },
      expression: "queryParam.givingTypeChild"
    }
  }, _vm._l((_vm.givingTypeChild), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2],
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", _vm._n($$v))
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "checkAdmin"
    },
    model: {
      value: (_vm.queryParam.checkAdmin),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "checkAdmin", $$v)
      },
      expression: "queryParam.checkAdmin"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.subType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "subType", _vm._n($$v))
      },
      expression: "queryParam.subType"
    }
  }, _vm._l((_vm.$constant.addSubType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "courseType", _vm._n($$v))
      },
      expression: "queryParam.courseType"
    }
  }, _vm._l((_vm.$constant.courseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请部门"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.applyDepartment),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "applyDepartment", _vm._n($$v))
      },
      expression: "queryParam.applyDepartment"
    }
  }, _vm._l((_vm.$constant.applyDepartment), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n          ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('280'),
      expression: "'280'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": ""
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n          ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.openUserClassHourModal
    }
  }, [_vm._v("加减课时")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.openBatchCourseChangeModal
    }
  }, [_vm._v("批量减课时,慎重操作")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookCourseChange/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "show-uid": true
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('BatchCourseChangeModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showBatchCourseChangeModal),
      callback: function($$v) {
        _vm.showBatchCourseChangeModal = $$v
      },
      expression: "showBatchCourseChangeModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拒绝原因",
      "prop": "memo"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "maxlength": 200,
      "placeholder": "请填写拒绝原因，将通知申请人"
    },
    model: {
      value: (_vm.rejectParam.memo),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "memo", $$v)
      },
      expression: "rejectParam.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.rejectLoading
    },
    on: {
      "click": _vm.submitReject
    }
  }, [_vm._v("拒绝")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加学生作品"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.title),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "title", $$v)
      },
      expression: "userVideoParams.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.uid),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "uid", _vm._n($$v))
      },
      expression: "userVideoParams.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "ageGroup"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.userVideoParams.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "ageGroup", _vm._n($$v))
      },
      expression: "userVideoParams.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生作品",
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoChange,
      "on-success": _vm.videoSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.videoFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品封面",
      "prop": "videoPicUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoPicChange,
      "on-success": _vm.videoPicSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.videoPicFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抖音链接",
      "prop": "douyinUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "抖音分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.douyinUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "douyinUrl", $$v)
      },
      expression: "userVideoParams.douyinUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "小红书链接",
      "prop": "xhsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "小红书分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.xhsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "xhsUrl", $$v)
      },
      expression: "userVideoParams.xhsUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "视频号链接",
      "prop": "channelsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "视频号分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.channelsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "channelsUrl", $$v)
      },
      expression: "userVideoParams.channelsUrl"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddModal
    },
    on: {
      "click": _vm.addUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "需代课请假",
      "width": "60%"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.leaveParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "leaveType", $$v)
      },
      expression: "leaveParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.onBookLessonOpened
    }
  }, [_vm._v("查看涉及课节")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "请假原因类别",
      "prop": "remarkType"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不知道就问主管"
    },
    model: {
      value: (_vm.leaveParam.remarkType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remarkType", $$v)
      },
      expression: "leaveParam.remarkType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("操作后记得点击“保存”按钮")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list reserved-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("储备老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "老师ID / 姓名 / 邮箱"
    },
    model: {
      value: (_vm.queryParam.keyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "keyword", $$v)
      },
      expression: "queryParam.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国籍"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "国籍"
    },
    model: {
      value: (_vm.queryParam.nationality),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nationality", $$v)
      },
      expression: "queryParam.nationality"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 20
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "stripe": "",
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": "",
      "show-elevator": "",
      "page-size-opts": [10, 20, 50, 100],
      "placement": "top"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.loadList,
      "recruit-flow-entry": "储备老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "RETIRE",
      "title": "退休管理",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加补升订单",
      "width": "700"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "channel"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.channel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "channel", _vm._n($$v))
      },
      expression: "formData.channel"
    }
  }, _vm._l((_vm.$constant.orderChannelRenew), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "on-blur": _vm.inputMobile
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formData.channel === 1) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "转介绍学生Id",
      "prop": "inviteId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inviteId", _vm._n($$v))
      },
      expression: "formData.inviteId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "转介绍凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 200,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "contractName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.contractName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractName", $$v)
      },
      expression: "formData.contractName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教课时",
      "prop": "num"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "input": _vm.calculateLeaveNum
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", _vm._n($$v))
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchChannel", $$v)
      },
      expression: "formData.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠送课时",
      "prop": "discountNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "赠送课时数"
    },
    on: {
      "input": _vm.calculateLeaveNum
    },
    model: {
      value: (_vm.formData.discountNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discountNum", _vm._n($$v))
      },
      expression: "formData.discountNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "应付金额",
      "prop": "payAmount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "payAmount", _vm._n($$v))
      },
      expression: "formData.payAmount"
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抵消课机会",
      "prop": "leaveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.leaveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveNum", _vm._n($$v))
      },
      expression: "formData.leaveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "24小时内取消课机会"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.makeupLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeupLessonNum", _vm._n($$v))
      },
      expression: "formData.makeupLessonNum"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "关联订单号：",
      "prop": "orgOrderId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.orgOrderId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "orgOrderId", $$v)
      },
      expression: "formData.orgOrderId"
    }
  }, _vm._l((_vm.orderList), function(item) {
    return _c('Option', {
      key: item.orderId,
      attrs: {
        "value": item.orderId
      }
    }, [_vm._v("订单号：" + _vm._s(item.orderId) + " | 课时：" + _vm._s(item.num))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "编辑合同",
      "prop": "contractVersionId"
    }
  }, [_c('Select', {
    attrs: {
      "placement": "top",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChangeSelectContractVersion
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showDealMonth) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "成交月份",
      "prop": "dealMonth"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择成交月份",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dealMonth),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dealMonth", $$v)
      },
      expression: "formData.dealMonth"
    }
  }, _vm._l((_vm.dealMonthOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("句子翻译")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "原句："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.sentence),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sentence", $$v)
      },
      expression: "queryParam.sentence"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/sentenceCard/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑句子' : '新增句子',
      "width": "640",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "原句",
      "prop": "sentence"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入原句"
    },
    model: {
      value: (_vm.formData.sentence),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sentence", $$v)
      },
      expression: "formData.sentence"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "中文翻译",
      "prop": "cnTranslate"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入中文翻译"
    },
    model: {
      value: (_vm.formData.cnTranslate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnTranslate", $$v)
      },
      expression: "formData.cnTranslate"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "音频",
      "prop": "audioUrl"
    }
  }, [_c('FileUpload', {
    attrs: {
      "defaultFileList": _vm.defaultFileList,
      "num": 1,
      "text": "点击或拖拽上传音频"
    },
    on: {
      "on-file-change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加题目模板"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createTemplateForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.Rules,
      "model": _vm.createTemplateParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.createTemplateParams.name),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "name", $$v)
      },
      expression: "createTemplateParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "题目大类",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createTemplateParams.type),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "type", $$v)
      },
      expression: "createTemplateParams.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "video"
    }
  }, [_vm._v("录音题")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "read"
    }
  }, [_vm._v("阅读理解")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("听力题")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板英文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板英文"
    },
    model: {
      value: (_vm.createTemplateParams.english),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "english", $$v)
      },
      expression: "createTemplateParams.english"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.createTemplate
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hr-workbench-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "section-adviser"
  }, [_c('span', {
    staticClass: "section-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange,
      "on-loaded": function($event) {
        _vm.advisers = $event
      }
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('article', {
      key: card.key,
      staticClass: "kpi-card is-clickable",
      class: 'is-' + card.level,
      on: {
        "click": function($event) {
          return _vm.goCard(card)
        }
      }
    }, [_c('div', {
      staticClass: "kpi-bar"
    }), _vm._v(" "), _c('div', {
      staticClass: "kpi-body"
    }, [_c('div', {
      staticClass: "kpi-title"
    }, [_c('i', {
      staticClass: "kpi-dot"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.title))])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(card.value))]), _vm._v(" "), _c('div', {
      staticClass: "kpi-period-row"
    }, [_c('span', {
      staticClass: "kpi-period"
    }, [_vm._v(_vm._s(card.period))]), _vm._v(" "), (card.compare) ? _c('span', {
      staticClass: "kpi-compare",
      class: 'is-' + card.compareTone
    }, [_vm._v(_vm._s(card.compare))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "kpi-foot"
    }, [_vm._v(_vm._s(card.foot))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section dash-two-col"
  }, [_c('div', {
    staticClass: "dash-block"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("今日待办")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "block-note"
  }, [_vm._v(_vm._s(_vm.todayStr) + " · 共 " + _vm._s(_vm.todos.length) + " 项" + _vm._s(_vm.todos.length > 16 ? '，显示前 16 项' : ''))])]), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("试用期、合同、昨日出勤待跟进、新外教回访、异动高危，按紧急 → 关注 → 预告排序。")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(!_vm.shownTodos.length) ? _c('div', {
    staticClass: "todo-empty"
  }, [_c('div', {
    staticClass: "todo-empty-big"
  }, [_vm._v("今日暂无待办")]), _vm._v(" "), _c('div', [_vm._v("所有提醒均已处理完毕")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shownTodos), function(t, idx) {
    return _c('div', {
      key: t.kind + '-' + t.tchId + '-' + idx,
      staticClass: "todo-row"
    }, [_c('span', {
      staticClass: "todo-bar",
      class: 'is-' + (t.severity || 'info')
    }), _vm._v(" "), _c('div', {
      staticClass: "todo-main"
    }, [_c('div', {
      staticClass: "todo-title"
    }, [_c('span', {
      staticClass: "tch-name-row"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(t.tchId)
        }
      }
    }, [_vm._v(_vm._s(t.title || _vm.tchText(t)))]), _vm._v(" "), (_vm.scoreText(t)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(t)))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "todo-kind",
      class: 'is-' + (t.severity || 'info')
    }, [_vm._v(_vm._s(_vm.kindText(t.kind)))])]), _vm._v(" "), _c('div', {
      staticClass: "todo-meta"
    }, [_vm._v(_vm._s(t.meta))]), _vm._v(" "), (t.action) ? _c('div', {
      staticClass: "todo-action"
    }, [_vm._v("建议：" + _vm._s(t.action))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "todo-btns"
    }, [_c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(t.tchId)
        }
      }
    }, [_vm._v("档案")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "loading": _vm.todoLoadingKey === _vm.todoKey(t)
      },
      on: {
        "click": function($event) {
          return _vm.handleTodo(t)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.kindButton(t.kind)) + "\n            ")])], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-block"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("每天请假 + 旷课（含失联）课节数，含今天。")]), _vm._v(" "), _c('div', {
    staticClass: "card trend-card"
  }, [_c('div', {
    staticClass: "trend"
  }, _vm._l((_vm.trendBars), function(d) {
    return _c('div', {
      key: d.date,
      staticClass: "trend-col"
    }, [_c('span', {
      staticClass: "trend-num"
    }, [_vm._v(_vm._s(d.count))]), _vm._v(" "), _c('div', {
      staticClass: "trend-bar",
      class: {
        'is-yesterday': d.isYesterday
      },
      style: ({
        height: d.height + 'px'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "trend-label"
    }, [_vm._v(_vm._s(d.label))])])
  }), 0)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.probationBars), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "dist-row"
    }, [_c('div', {
      staticClass: "dist-head"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.value) + " 人")])]), _vm._v(" "), _c('div', {
      staticClass: "dist-track"
    }, [_c('div', {
      staticClass: "dist-fill",
      class: 'is-' + item.tone,
      style: ({
        width: item.percent + '%'
      })
    })])])
  }), 0), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.contractBars), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "dist-row"
    }, [_c('div', {
      staticClass: "dist-head"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.value) + " 人")])]), _vm._v(" "), _c('div', {
      staticClass: "dist-track"
    }, [_c('div', {
      staticClass: "dist-fill",
      class: 'is-' + item.tone,
      style: ({
        width: item.percent + '%'
      })
    })])])
  }), 0)])]), _vm._v(" "), _c('probation-decide-modal', {
    attrs: {
      "value": _vm.modal.probation,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.probation = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('review-save-modal', {
    attrs: {
      "value": _vm.modal.review,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.review = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.modal.contract,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.contract = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外管工作台")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("Foreign Teacher HR Workbench / 试用期 / 新外教回访 / 合同续签 / 出勤跟进 / 异动高危")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 口径：在职外教（在职 + 外教），按服务器当日自然日计算 · 点击卡片进入对应页面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("紧急\n          / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("关注\n          / "), _c('i', {
    staticClass: "legend-dot is-info"
  }), _vm._v("预告\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("近 7 日异动趋势")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head block-gap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("试用期状态分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head block-gap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("合同状态分布")])])
}]}

/***/ }),
/* 1990 */,
/* 1991 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[911]);


// WEBPACK FOOTER //
// static/js/app.b51a99abb6d755990afb.js